(function () {
  'use strict';

  angular.module('app.core', [
    'app.core.api',
    'ngAnimate',
    'ngAria',
    'ngCookies',
    'ngMessages',
    'ngResource',
    'ngSanitize',
    'ngMaterial',
    'ngTagsInput',
    'angularMoment',
    'uiGmapgoogle-maps',
    'pascalprecht.translate',
    'ui.router',
    'ui.select',
    'ui.mask',
    'ui.utils.masks',
    'idf.br-filters',
    'datatables',
    'datatables.buttons',
    'nvd3',
    'angular-chartist',
    'chart.js',
    'ui-rangeSlider',
    'ngTimeSlider',
    'ngclipboard',
    'duScroll',
    'naif.base64',
    'moment-picker',
    'ngImgCrop',
    'monospaced.qrcode',
    'ui.sortable',
    'leaflet-directive',
    'ngMdBadge',
    'ngCpfCnpj',
    'ngFileUpload',
    'signature'
  ])
  .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('app/core');
    $translatePartialLoaderProvider.addPart('app/core/integrations');
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('OmieLoadDataService', OmieLoadDataService);

  function OmieLoadDataService() {
    return {
      returnLinkedOSProductsRegisteredInOmie: returnLinkedOSProductsRegisteredInOmie,
      returnLinkedOSServicesRegisteredInOmie: returnLinkedOSServicesRegisteredInOmie
    };

    function returnLinkedOSProductsRegisteredInOmie(omieProducts, osProducts) {
      var existentOmieProducts = [];
      omieProducts.forEach(function (omieProduct) {
        osProducts.forEach(function (osProduct) {
          if (omieProduct.integrationId === osProduct.id) {
            omieProduct.measure = osProduct.measure;
            omieProduct.quantity = osProduct.quantity;

            if (!omieProduct.value) {
              omieProduct.value = osProduct.value || 1;
            }

            existentOmieProducts.push(omieProduct);
          }
        });
      });
      return existentOmieProducts;
    }

    function returnLinkedOSServicesRegisteredInOmie(omieServices, osServices, useOSValue) {
      var existentOmieServices = [];
      omieServices.forEach(function (omieService) {
        osServices.forEach(function (osService) {
          if (omieService.integrationId === osService.id) {
            omieService.quantity = osService.quantity;

            var valueToUse = useOSValue ? osService.value : omieService.value;
            omieService.value = valueToUse > 0 ? valueToUse : 1;

            existentOmieServices.push(omieService);
          }
        });
      });
      return existentOmieServices;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('OmieLoadDataController', OmieLoadDataController);

  function OmieLoadDataController(
    $q, $translate, locals,
    omieApi, omieCustomerMapper, OmieErrorsDialog, OmieTaskExportDialog, FcModalService,
    ordersApi, OmieLoadDataService, _, $mdDialog, $rootScope, msUtils
  ) {
    var accounts = locals.accounts;
    var startingAppIdToLoad = accounts[0].value.appId;

    if (locals.selectedAccount) {
      startingAppIdToLoad = locals.selectedAccount.appId;
    }
    loadData().then(function (data) {
      if (!_isEssentialDataLoaded(data)) {
        return OmieErrorsDialog.open({ data: data, target: locals.target });
      }

      var inputs = {
        data: data,
        tasks: locals.tasks,
        configuration: locals.configuration,
        accounts: accounts,
        activatedAccount: locals.selectedAccount || accounts[0].value,
        target: locals.target
      };

      _validateDuplicateOs(inputs)
        .then(function (response) {
          var omieOs = response && response.omieOs;
          var method = response && response.method;

          if (method === 'cancel') {
            $rootScope.loadingProgress = false;
            $mdDialog.cancel();
            return;
          }

          inputs.duplicateOsMethod = method;
          inputs.omieOs = omieOs;

          _showQuantityWillNotBeChangedDialog(inputs, function () {
            OmieTaskExportDialog.open(inputs);
          });
        });

    }).catch(function (error) {
      OmieErrorsDialog.open({ error: error, target: locals.target });
    });

    function loadData() {
      var requests = {
        customers: _loadCustomers(),
        cities: _loadCity(),
        services: _loadServices(),
        productsLinkedToOrder: _loadLinkedToOrderProducts(),
        servicesLinkedToOrder: _loadLinkedToOrderServices(),
        bankAccounts: _loadBankAccounts(),
        categories: _loadCategories(),
        installments: _loadInstallments(),
        sellers: _loadSellers(),
        accounts: new Promise(function (resolve) {
          resolve([]);
        })
      };

      return $q.all(requests);
    }

    function _isEssentialDataLoaded(data) {
      var categories = data.categories && data.categories.length;
      var services = data.services && data.services.length;
      var installments = data.installments && data.installments.length;
      var sellers = data.sellers && data.sellers.length;
      var bankAccounts = data.bankAccounts && data.bankAccounts.length;
      var customers = data.customers;
      var cities = data.cities;

      return (
        categories &&
        services &&
        installments &&
        sellers &&
        bankAccounts &&
        customers &&
        cities
      );
    }

    function _loadCustomers() {
      var customer = locals.tasks[0].order.customer;
      var requests = {
        customersbyName: _loadCustomersByCustumerName(customer.name),
        customersbyFantasyName: _loadCustomersByCustumerFantasyName(customer.name)
      };
      return $q.all(requests).then(function (data) {
        var customers = data.customersbyName.concat(data.customersbyFantasyName);
        customers = _.uniq(customers, 'codigo_cliente_omie');
        if(customers.length == 1){
          return customers;
        }

        if(customers.length > 1){
          return _openDialogCustomerOmie(customers);
        }

        return null;
      });
    }

    function _loadLinkedToOrderProducts() {
      var orderId = locals && locals.tasks && locals.tasks[0] && locals.tasks[0].order && locals.tasks[0].order.id;
      return ordersApi.queryForAllOrderProducts(orderId).then(function (response) {
        var osProducts = response;
        var productsWithExternalId = _.filter(response, function (product) {
          return product.externalAppId && product.type === 'product';
        }).map(function (product) {
          return { codigo_produto_integracao: product.id };
        });
        var customParams = {
          produtosPorCodigo: productsWithExternalId
        };
        if (customParams.produtosPorCodigo.length === 0) {
          return Promise.resolve([]);
        }
        return omieApi.products.getAll(startingAppIdToLoad, customParams).then(function (response) {
          var omieProducts = response;
          return OmieLoadDataService.returnLinkedOSProductsRegisteredInOmie(omieProducts, osProducts);
        });
      });
    }

    function _loadServices() {
      return omieApi.services.search(startingAppIdToLoad);
    }

    function _loadLinkedToOrderServices() {
      var orderId = locals && locals.tasks && locals.tasks[0] && locals.tasks[0].order && locals.tasks[0].order.id;

      if (locals.configuration.integrationOmieServicesOSValue) {
        var input = {
          id: orderId,
          take: 1000
        };

        return ordersApi.queryForOrderServices(input).then(function (response) {
          var baseServices = response && response.services && response.services.items;
          var mappedOsServices = baseServices.map(function (service) {
            return {
              id: service.item.id,
              externalAppId: service.item.externalAppId,
              type: 'service',
              imageUrl: service.item.imageUrl,
              name: service.item.name,
              integration: service.item.integration,
              value: service.value,
              quantity: service.quantity,
              totalValue: service.totalValue,
            };
          });

          return omieApi.services.search(startingAppIdToLoad).then(function (response) {
            var omieServices = response;

            return OmieLoadDataService.returnLinkedOSServicesRegisteredInOmie(omieServices, mappedOsServices, true);
          });
        });
      }

      return ordersApi.queryForAllOrderProducts(orderId).then(function (response) {
        var osServices = response;
        return omieApi.services.search(startingAppIdToLoad).then(function (response) {
          var omieServices = response;
          return OmieLoadDataService.returnLinkedOSServicesRegisteredInOmie(omieServices, osServices, false);
        });
      });
    }

    function _loadCity() {
      var address = locals.tasks[0].order.customer.address;

      if (!address.city || !address.state) {
        return Promise.resolve(null);
      }

      var uf = address.state;
      if (uf.length !== 2) {
        uf = omieCustomerMapper.stateToUf(address.state);
      }
      var searchable = address.city + ' (' + uf + ')';
      return omieApi.cities.search(searchable, startingAppIdToLoad);
    }

    function _loadBankAccounts() {
      return omieApi.bankAccounts.search(startingAppIdToLoad);
    }

    function _loadCategories() {
      return omieApi.categories.search(startingAppIdToLoad);
    }

    function _loadInstallments() {
      return omieApi.payments.getAll(startingAppIdToLoad);
    }

    function _loadSellers() {
      var defaultSeller = {
        nome: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.DEFAULT_SELLER'),
        translate: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.DEFAULT_SELLER'),
        value: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.DEFAULT_SELLER'),
        codigo: null
      };

      return omieApi.sellers.search(startingAppIdToLoad).then(function (sellers) {
        sellers.unshift(defaultSeller);
        return sellers;
      });
    }

    function _showQuantityWillNotBeChangedDialog(inputs, callback) {
      if (!inputs.configuration) { return callback(); }
      if (!inputs.configuration.integrationsServiceQuantityAsDuration) { return callback(); }

      var haveSomeTasksWithStartAndCompletedAt = inputs.tasks.some(function (task) { return (task.startedAt && task.completedAt); });
      if (haveSomeTasksWithStartAndCompletedAt) { return callback(); }

      FcModalService.open('', {
        title: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.QUANTITY_WILL_NOT_BE_CHANGED_DIALOG.TITLE'),
        content: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.QUANTITY_WILL_NOT_BE_CHANGED_DIALOG.CONTENT'),
        rightButtonText: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.QUANTITY_WILL_NOT_BE_CHANGED_DIALOG.CONTINUE'),
        handleRightButton: callback
      });
    }

    function _loadCustomersByCustumerName(customerName) {
      return omieApi.customers.search({ 'razao_social': customerName }, startingAppIdToLoad).then(function (customers) {
        if(customers){
          return customers;
        }

        return [];
      });
    }

    function _loadCustomersByCustumerFantasyName(customerName) {
      return omieApi.customers.search({ 'nome_fantasia': customerName }, startingAppIdToLoad)
        .then(function (customers) {
          if(customers){
            return customers;
          }

          return [];
        });
    }

    function _openDialogCustomerOmie(customers){
      customers = customers.map(function (c) {
        return Object.assign({}, c, {
          displayName: c.razao_social + (c.nome_fantasia ? ' (' + c.nome_fantasia + ')' : '')
        });
      });

      var deferred = $q.defer();
      FcModalService.open('', {
        title: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.CUSTOMERS.TITLE'),
        content: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.CUSTOMERS.DESCRIPTION'),
        paddingSmall: true,
        hasOmieCustomerSelector: true,
        rightContinueButton: true,
        rightButtonText: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'),
        leftButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
        variables: {
          customers: customers,
          startingAppIdToLoad: startingAppIdToLoad
        },
        handleRightButton: function (customer) {
          deferred.resolve([customer]);
        },
        handleClose: function (){
          $rootScope.loadingProgress = false;
          $mdDialog.cancel();
        }
      });
      return deferred.promise;
    }

    function _validateDuplicateOs(inputs) {
      return new Promise(function (resolve) {
        var tasks = inputs.tasks;
        var order = tasks[0].order;
        var orderIdentifier = order && order.identifier;

        if (!orderIdentifier) {
          return resolve();
        }

        return omieApi.os.getByOsIdentifier(orderIdentifier, startingAppIdToLoad).then(function (response) {
          var omieOs = response && response.data;
          var cCodIntOS = omieOs && omieOs.Cabecalho && omieOs.Cabecalho.cCodIntOS;
          if(!cCodIntOS) {
            return resolve();
          }

          return _openOmieDuplicateOsDialog(orderIdentifier).then(function (response) {
            return resolve({ method: response, omieOs: omieOs });
          });
        });
      });
    }

    function _openOmieDuplicateOsDialog(orderIdentifier) {
      return new Promise(function (resolve) {
        document.dispatchEvent(new CustomEvent('openOmieDuplicateOsDialog', { detail: { identifier: orderIdentifier } }));

        document.addEventListener('omieDuplicateOsDialogClosed', function (event) {
          if (event.detail && event.detail.data && event.detail.data.method) {
            return resolve(event.detail.data.method);
          }

          return resolve('cancel');
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('OmieTasksExportDialogViewModel', OmieTasksExportDialogViewModelFactory);

  /** @ngInject */
  function OmieTasksExportDialogViewModelFactory(
    omieApi, msUtils, _,moment, omieCustomerMapper, omieProductMapper, omieServiceMapper,
    $translate, $locale, dateConverter, CurrencyService) {

      var currencySymbol = CurrencyService.currencySymbol;
      $locale.NUMBER_FORMATS.CURRENCY_SYM = currencySymbol;
      $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
      $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    var OmieTasksExportDialogViewModel = function (loadedData) {

      if (loadedData) {
        this.accounts = loadedData.accounts;
        this.activatedAccount = loadedData.activatedAccount;
        this.selectedAccount = this.activatedAccount;
        this.tasks = loadedData.tasks;
        this.configuration = loadedData.configuration;
        this.data = loadedData.data;
        this.disableCustomerInput = false;
        this.disableCityInput = false;
        this.customers = loadedData.data.customers;
        this.bankAccounts = loadedData.data.bankAccounts;
        this.productsLinkedToOrder = loadedData.data.productsLinkedToOrder;
        this.servicesLinkedToOrder = loadedData.data.servicesLinkedToOrder;
        this.cities = loadedData.data.cities;
        this.categories = loadedData.data.categories;
        this.services = loadedData.data.services;
        this.products = loadedData.data.products;
        this.installments = loadedData.data.installments.slice(0, 100);
        this.installmentsCopy = loadedData.data.installments;
        this.sellers = loadedData.data.sellers.slice(0, 100);
        this.sellersCopy = loadedData.data.sellers;
        this.loadedAllItems = false;
        this.loadedAllInstallments = false;
        this.loadedAllSellers = false;
        this.nPaginaServices = 1;
        this.searchProductTextArray = [];
        this.searchServiceTextArray = [];
        this.oneYearAgo = moment().subtract(1, 'year').toDate();
        this.form = {
          account: loadedData.activatedAccount,
          task: loadedData.tasks[0],
          bankAccount: null,
          city: null,
          customer: null,
          installment: null,
          seller: null,
          service: null,
          category: null,
          forecastDate: moment.utc(),
          services: [{
            description: '',
            qtd: 1,
            value: 0,
          }],
          products: [],
          duplicateOsMethod: loadedData.duplicateOsMethod,
          omieOs: loadedData.omieOs
        };
      }
    };

    OmieTasksExportDialogViewModel.prototype.setData = setData;
    OmieTasksExportDialogViewModel.prototype.setLinkedOSProducts = setLinkedOSProducts;
    OmieTasksExportDialogViewModel.prototype.setLinkedOSServices = setLinkedOSServices;
    OmieTasksExportDialogViewModel.prototype.setCity = setCity;
    OmieTasksExportDialogViewModel.prototype.setCategory = setCategory;
    OmieTasksExportDialogViewModel.prototype.setBankAccount = setBankAccount;
    OmieTasksExportDialogViewModel.prototype.setInstallmentToView = setInstallmentToView;
    OmieTasksExportDialogViewModel.prototype.setSellerToView = setSellerToView;
    OmieTasksExportDialogViewModel.prototype.searchCustomer = searchCustomer;
    OmieTasksExportDialogViewModel.prototype.searchCity = searchCity;
    OmieTasksExportDialogViewModel.prototype.setCustomer = setCustomer;
    OmieTasksExportDialogViewModel.prototype.setAccount = setAccount;
    OmieTasksExportDialogViewModel.prototype.serviceHasSelected = serviceHasSelected;
    OmieTasksExportDialogViewModel.prototype.sendTask = sendTask;
    OmieTasksExportDialogViewModel.prototype.loadInstallmentsPage = loadInstallmentsPage;
    OmieTasksExportDialogViewModel.prototype.loadInstallments = loadInstallments;
    OmieTasksExportDialogViewModel.prototype.loadSellersPage = loadSellersPage;
    OmieTasksExportDialogViewModel.prototype.loadSellers = loadSellers;
    OmieTasksExportDialogViewModel.prototype.setProbablyService = setProbablyService;
    OmieTasksExportDialogViewModel.prototype.addService = addService;
    OmieTasksExportDialogViewModel.prototype.addProduct = addProduct;
    OmieTasksExportDialogViewModel.prototype.setServiceManually = setServiceManually;
    OmieTasksExportDialogViewModel.prototype.removeService = removeService;
    OmieTasksExportDialogViewModel.prototype.removeProduct = removeProduct;
    OmieTasksExportDialogViewModel.prototype.searchService = searchService;
    OmieTasksExportDialogViewModel.prototype.searchProduct = searchProduct;
    OmieTasksExportDialogViewModel.prototype.searchInstallment = searchInstallment;
    OmieTasksExportDialogViewModel.prototype.searchSeller = searchSeller;
    OmieTasksExportDialogViewModel.prototype.productHasSelected = productHasSelected;
    OmieTasksExportDialogViewModel.prototype.setCustomer = setCustomer;
    OmieTasksExportDialogViewModel.prototype.setOneCustomer = setOneCustomer;
    OmieTasksExportDialogViewModel.prototype.setOneAccount = setOneAccount;
    OmieTasksExportDialogViewModel.prototype.setInstallment = setInstallment;
    OmieTasksExportDialogViewModel.prototype.setSeller = setSeller;
    OmieTasksExportDialogViewModel.prototype.setService = setService;
    OmieTasksExportDialogViewModel.prototype.setProduct = setProduct;
    OmieTasksExportDialogViewModel.prototype.setOneCity = setOneCity;
    OmieTasksExportDialogViewModel.prototype.setCustomerValue = setCustomerValue;
    OmieTasksExportDialogViewModel.prototype.getCopyInstallment = getCopyInstallment;
    OmieTasksExportDialogViewModel.prototype.getCopySeller = getCopySeller;

    function setData() {
      if (this.customers.length) {
        this.setOneCustomer(this.customers[0]);
      }
      if (this.cities.length) {
        this.setOneCity(this.cities[0]);
      }

      this.setLinkedOSProducts();
      this.setProbablyService();
      this.setLinkedOSServices();
      this.setBankAccount();
      this.setInstallmentToView();
      this.setSellerToView();
      this.setCategory();
      this.setCustomerValue();
    };

    function setOneCity(city) {
      this.form.city = city;
    };

    function setCity(cities) {
      this.cities = cities;
    };

    function setCategory() {
      this.form.category = _.find(this.categories, function (category) {
        return category.descricao === 'Clientes - Serviços Prestados';
      });
    };

    function setCustomerValue() {
      this.customers.forEach(function (customer){
        customer.value = customer.displayName || customer.razao_social;
      });
    }

    function setBankAccount() {
      this.form.bankAccount = this.bankAccounts[0].descricao;
    };

    function setInstallmentToView() {
      this.form.installment = this.installments[0].cDescricao;
    };

    function setSellerToView() {
      this.form.seller = this.sellers[0].nome;
    };

    function setLinkedOSServices() {
      var services = _.cloneDeep(this.form.services);
      if (this.servicesLinkedToOrder && this.servicesLinkedToOrder.length) {
        var services = [];

        this.servicesLinkedToOrder.forEach(function (linkedService) {
          var service = omieServiceMapper.generateServiceObject(linkedService);
          services.push(service);
        });
      }
      this.form.services = services;
    }

    function setLinkedOSProducts() {
      var products = _.cloneDeep(this.form.products);
      if (this.productsLinkedToOrder && this.productsLinkedToOrder.length) {
        this.productsLinkedToOrder.forEach(function (linkedProduct) {
          var product = omieProductMapper.generateProductObject(linkedProduct);
          products.push(product);
        });
      }
      this.form.products = products;
    }

    function setCustomer(customers) {
      this.customers = customers;
    }

    function setAccount(accounts) {
      this.accounts = accounts;
    }

    function setOneAccount(account) {
        this.form.account = account.value;
        this.selectedAccount = account.value;
    };

    function setOneCustomer(customer, dontDecode) {
      if (customer.codigo_cliente_omie || customer.codigo_cliente_integracao) {
        this.form.customer = customer;
        this.disableCustomerInput = true;
        this.customerData = omieCustomerMapper.toFieldControl(customer, dontDecode);
        this.selectedCustomer = customer.displayName || customer.razao_social;
      }
    };

    function setProbablyService() {
      var highSimilarity = 0.8;
      var self = this;

      var taskService = self.tasks && self.tasks[0] && self.tasks[0].order && self.tasks[0].order.service;
      var possibleServices = [];

      if (!taskService) { return possibleServices; }

      self.services.forEach(function (service) {
        var serviceName = service.cabecalho.cDescricao;
        var similarity = msUtils.similarity(taskService.description, serviceName);

        var similarityIsHigh = similarity > highSimilarity;
        if (similarityIsHigh) {
          service.similarity = similarity;
          service.qtd = _getServiceQuantity(self.tasks, self.configuration);
          service.value = service.value > 0 ? service.value : 1;
          possibleServices.push(service);
        }
      });

      if (possibleServices.length) {
        possibleServices = _.sortBy(possibleServices, 'similarity').reverse();
        self.setServiceManually(possibleServices[0]);
      }
    };

    function searchCustomer(searchText, callback) {
      var filter = (searchText && parseInt(searchText) > 0) ? { 'cnpj_cpf': searchText } : { 'razao_social': searchText.substr(0, 60) };

      omieApi.customers.search(filter, this.selectedAccount.appId).then(function (response) {
        callback(response);
      }).catch(function () { callback([]); });
    }

    function searchCity(searchText, callback) {
      omieApi.cities.search(searchText, this.selectedAccount.appId).then(function (response) {
        callback(response);
      }).catch(function () { callback([]); });
    }

    function serviceHasSelected(service) {
      if (service.obj && service.obj.cabecalho) {
        service.value = service.obj.cabecalho.nPrecoUnit > 0 ? parseFloat(service.obj.cabecalho.nPrecoUnit) : 0;
      }
    };

    function productHasSelected(product) {
      if (!product.obj) { return; }
      product.value = product.obj.value && product.obj.value > 0 ? parseFloat(product.obj.value) : 0;
      product.measure = product.obj.measure || '';
    };

    function sendTask(form) {
      var self = this;

      form.categoryToSave = _correctToSave(form.category.descricao, this.categories, 'descricao');
      form.bankAccountToSave = _correctToSave(form.bankAccount, this.bankAccounts, 'descricao');
      form.installmentToSave = _correctToSave(form.installment, this.installments, 'cDescricao');
      form.sellerToSave = _correctToSave(this.form.seller, this.sellers, 'nome');
      form.customer = _correctToSave(this.selectedCustomer, this.customers, this.customers[0].displayName ? 'displayName' : 'razao_social');

      return chooseSendProductsLinkedToOrderMethod(form).then(function (sendMethod) {
        if (sendMethod === 'cancel') {
          return;
        }

        if (sendMethod === 'salesOrder') {
          omieApi.salesOrders
            .create(form, self.selectedAccount.appId)
            .then(function (response) {
              return response;
            })
            .catch(function (error) {
              return error;
            });

          form.products = [];
        }

        return omieApi.os
          .createOrUpdate(form, self.selectedAccount.appId)
          .then(function (response) {
            return response;
          })
          .catch(function (error) {
            return error;
          });
      });
    }

    function chooseSendProductsLinkedToOrderMethod(form) {
      return new Promise(function (resolve) {
        var products = form.products || [];

        if (!products.length) {
          return resolve();
        }

        openDialogToChooseSendProductsMethod(form).then(function (sendMethod) {
          return resolve(sendMethod);
        });
      });
    }

    function openDialogToChooseSendProductsMethod(form) {
      return new Promise(function (resolve) {
        var orderIdentifier = form.task && form.task.order && form.task.order.identifier;
        document.dispatchEvent(new CustomEvent('openOmieChooseSendProductsMethod', { detail: { identifier: orderIdentifier } }));

        document.addEventListener('omieChooseSendProductsMethodClosed', function (event) {
          if (event.detail && event.detail.data && event.detail.data.sendMethod) {
            return resolve(event.detail.data.sendMethod);
          }

          return resolve('cancel');
        });
      });
    }

    function loadInstallmentsPage(page) {
      var self = this;

      return omieApi.payments.list({
        pagina: page,
      }, this.selectedAccount.appId).then(function (response) {
        if (response.status === 200 && response.data.cadastros.length) {
          response.data.cadastros.forEach(function (installment) {
            self.installments.push(installment);
          });
          if (response.data.pagina < response.data.total_de_paginas) {
            return self.loadInstallmentsPage(page + 1);
          } else {
            self.loadedAllInstallments = true;
            self.checkIfLoadAllItems();
          }
        }
      }).catch(function (error) {
        return { error: true, message: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.ERROR_LOADING_PAYMENTS') };
      });
    };

    function loadInstallments() {
      return this.loadInstallmentsPage(1);
    };

    function loadSellersPage(page) {
      var self = this;

      return omieApi.sellers.list({
        pagina: page,
      }, this.selectedAccount.appId).then(function (response) {
        if (response.status === 200 && response.data.cadastro.length) {
          response.data.cadastro.forEach(function (seller) {
            self.sellers.push(seller);
          });
          if (response.data.pagina < response.data.total_de_paginas) {
            return self.loadSellersPage(page + 1);
          } else {
            self.loadedAllSellers = true;
            self.checkIfLoadAllItems();
          }
        }
      }).catch(function (error) {
        return { error: true, message: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.ERROR_LOADING_PAYMENTS') };
      });
    };

    function loadSellers() {
      return this.loadSellersPage(1);
    };

    function addService() {
      this.form.services.push({
        description: '',
        qtd: 1,
        value: 0,
      });
    };

    function addProduct() {
      this.form.products.push({
        name: '',
        quantity: 1,
        value: 0,
        measure: ''
      });
    };

    function removeProduct(index) {
      this.searchProductTextArray.splice(index, 1);
      this.form.products.splice(index, 1);
    };

    function setServiceManually(service) {
      var isOnlyEmptyItem = this.form.services.length === 1 && !this.form.services[0].obj;
      if (isOnlyEmptyItem) {
        this.form.services[0].obj = service;
        this.form.services[0].qtd = service.qtd || 1;
        this.serviceHasSelected(this.form.services[0]);
      } else {
        var index = this.form.services.length ? this.form.services.length - 1 : 0;
        var lastItem = this.form.services[index];

        if (lastItem.obj && lastItem.obj.cabecalho && lastItem.obj.cabecalho.cDescricao) {
          this.addService();
          index++;
        }

        this.form.services[index].obj = service;
        this.form.services[index].qtd = service.qtd || 1;
        this.serviceHasSelected(this.form.services[index]);
      }
    };

    function removeService(index) {
      this.searchServiceTextArray.splice(index, 1);
      this.form.services.splice(index, 1);
    };

    function setService(services) {
      this.services = services;
    }

    function searchService(searchText, callback) {
      if (!searchText || searchText === '') { return callback([]); }
      var returnableItems = [];
      var _searchText = searchText.toLowerCase();
      omieApi.services.list(null, this.selectedAccount.appId).then(function (services) {
        callback(_searchPaginateServices(services, _searchText, returnableItems));
      }).catch(function () { callback([]); });
    };

    function setProduct(products) {
      this.products = products;
    }

    function searchProduct(searchText, callback) {
      omieApi.products.search(this.selectedAccount.appId, { filtrar_apenas_descricao: '%' + searchText + '%' }).then(function (products) {
        callback(_.sortBy(products, 'name'));
      });
    };

    function setInstallment(installments) {
      this.installments = installments;
    }

    function searchInstallment(searchText, callback) {
      omieApi.payments.list({
        pagina: 1,
      }, this.selectedAccount.appId).then(function (response) {
        searchText = searchText ? searchText.toLowerCase() : '';
        var returnableItems = response.data.cadastros.filter(function (installment) {
          return installment.cDescricao.toLowerCase().includes(searchText);
        });
        callback(returnableItems);
      }).catch(function () { callback([]); });
    }

    function setSeller(sellers) {
      this.sellers = sellers;
    }

    function searchSeller(searchText, callback) {
      omieApi.sellers.list({
        pagina: 1,
      }, this.selectedAccount.appId).then(function (response) {
        searchText = searchText ? searchText.toLowerCase() : '';
        var returnableItems = response.data.cadastro.filter(function (seller) {
          return seller.nome.toLowerCase().includes(searchText);
        });
        callback(returnableItems);
      }).catch(function () { callback([]); });
    }

    function _searchPaginateServices(response, searchText, returnableItems) {
      response.data.cadastros.forEach(function (service) {
        service.displayName = service.cabecalho.cCodigo + ' - ' + service.cabecalho.cDescricao;
        var name = service.cabecalho.cDescricao.trim().toLowerCase();
        if (name.includes(searchText)) { returnableItems.push(service); }
      });

      return _.sortBy(returnableItems, 'service.cabecalho.cDescricao');
    }

    function _correctToSave(selectedValue, allItems, field) {
      return allItems.find(function (item) {
        return item[field] === selectedValue;
      });
    }

    function _getServiceQuantity(tasks, configuration) {
      var defaultQuantity = 1;
      if (!configuration) { return defaultQuantity; }
      if (!configuration.integrationsServiceQuantityAsDuration) { return defaultQuantity; }

      var quantity = tasks.filter(function (task) {
        if (!task.startedAt) { return false; }
        if (!task.completedAt) { return false; }
        if (task.archived) { return false; }

        return true;
      }).reduce(function (quantity, task) {
        var startedAt = dateConverter.toDateAndTime(task.scheduling.date, task.startedAt);
        var completedAt = dateConverter.toDateAndTime(task.scheduling.date, task.completedAt);
        var duration = Number(moment.duration(completedAt.diff(startedAt)).asHours().toFixed(6));

        return quantity + duration;
      }, 0);

      return quantity > 0 ? quantity : defaultQuantity;
    }

    function getCopyInstallment() {
      return this.installmentsCopy;
    }

    function getCopySeller() {
      return this.sellersCopy;
    }

    return OmieTasksExportDialogViewModel;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('OmieTasksExportDialogController', OmieTasksExportDialogController);

  /** @ngInject */
  function OmieTasksExportDialogController(
    $scope,$mdDialog, locals, accountCache,
    OmieTasksExportDialogViewModel, $rootScope, $mdToast, $translate
  ) {
    var vm = this;

    vm.viewModel = new OmieTasksExportDialogViewModel(locals);
    vm.sendingTask = false;
    vm.duplicatedProduct = false;
    vm.sendTask = sendTask;
    vm.verifyProductsName = verifyProductsName;
    vm.closeDialog = closeDialog;
    vm.search = search;
    vm.searchInstallmentText = searchInstallmentText;
    vm.searchSellerText = searchSellerText;
    vm.duplicateOsMethod = locals.duplicateOsMethod;

    $rootScope.loadingProgress = false;

    vm.viewModel.setData();

    accountCache.loadAccount().then(function (account) {
      vm.hasStockModule =
        (account &&
          account.configuration &&
          account.configuration.moduleStorageControlEnabled);
    });

    function sendTask() {
      vm.sendingTask = true;
      $rootScope.loadingProgress = true;

      vm.viewModel.sendTask(vm.viewModel.form).then(function (response) {
        vm.sendingTask = false;
        $rootScope.loadingProgress = false;

        if (response.status === 200) {
          toast($translate.instant('INTEGRATIONS.TASKS.EXPORT.SUCCESS_MESSAGE', { app: 'Omie' }), 6000);
          closeDialog();
        } else {
          var message = response.data.message || response.data.faultstring;
          toast($translate.instant('INTEGRATIONS.TASKS.EXPORT.ERROR') + ': ' + message, 8000);
        }
      });
    }

    function verifyProductsName() {
      var productNames = vm.viewModel.form.products.map(function (product) {
        if (!product.obj) {
          return '';
        }
        return product.obj.name;
      });
      var repeatedProductsIndex = [];
      var uniqueProductsIndex = [];

      productNames.forEach(function (name, index) {
        var isUnique = productNames.indexOf(name) === index;
        var formKey = 'productsAutoComplete__' + index;

        if (isUnique) {
          uniqueProductsIndex.push(index);
          setValidityAndTouched(formKey, 'uniqueProduct', true);
        } else {
          repeatedProductsIndex.push(index);
          setValidityAndTouched(formKey, 'uniqueProduct', false);
        }
      });

      repeatedProductsIndex.forEach(function (repeatedIndex) {
        var formKey = 'productsAutoComplete__' + repeatedIndex;
        setValidityAndTouched(formKey, 'uniqueProduct', false);
      });

      vm.duplicatedProduct = repeatedProductsIndex.length > 0;

      function setValidityAndTouched(formKey, validityKey, isValid) {
        $scope.omieExportTaskForm[formKey].$setValidity(validityKey, isValid);
        $scope.omieExportTaskForm[formKey].$setTouched();
      }
    }

    function toast(message, delay) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .hideDelay(delay)
      );
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function search(searchText, searchType) {
      var searchFunction = 'search'.concat(searchType);
      var setFunction = 'set'.concat(searchType);

      vm.viewModel[searchFunction](searchText, function (response) {
        _.defer(function () {
					$scope.$apply(function () {
            vm.viewModel[setFunction](response);
					});
				});
      });
    }

    function searchInstallmentText() {
      var copy = vm.viewModel.getCopyInstallment();
      if (vm.viewModel.installments.length <= copy.length) {
        vm.viewModel.setInstallment(vm.viewModel.getCopyInstallment());
      }
    }

    function searchSellerText() {
      var copy = vm.viewModel.getCopySeller();
      if (vm.viewModel.sellers.length <= copy.length) {
        vm.viewModel.setSeller(vm.viewModel.getCopySeller());
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('OmieTaskExportDialog', OmieTaskExportDialog);

  function OmieTaskExportDialog($mdDialog, $document) {
    return {
      open: open,
      filterProductsByName: filterProductsByName
    };

    function open(locals) {
      $mdDialog.show({
        controller: 'OmieTasksExportDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/integrations/core/tasks/dialogs/export/omie/export/omie-tasks-export-dialog.html',
        parent: locals.target || angular.element($document.body),
        clickOutsideToClose: false,
        locals: locals
      });
    }

    function filterProductsByName(products, searchText) {
      if (!searchText) { return products; }
      return products.filter(function (product) {
        var name = product.name.trim().toLowerCase();
        return name.indexOf(searchText.toLowerCase()) !== -1;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('OmieErrorsDialog', OmieErrorsDialog);

  /** @ngInject */
  function OmieErrorsDialog($mdDialog, $document) {
    return {
      open: open
    };

    function open(locals) {
      $mdDialog.show({
        controller: 'OmieErrorsController',
        controllerAs: 'vm',
        templateUrl: 'app/core/integrations/core/tasks/dialogs/export/omie/errors/omie-errors-dialog.html',
        parent: locals.target || angular.element($document.body) ,
        clickOutsideToClose: false,
        locals: locals
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('OmieErrorsController', OmieErrorsController);

  function OmieErrorsController($mdDialog, $rootScope, $translate, locals) {
    var vm = this;

    $rootScope.loadingProgress = false;

    vm.data = locals.data;
    vm.error = locals.error;

    vm.getKeyTranslate = getKeyTranslate;
    vm.isKeyError = isKeyError;
    vm.closeDialog = closeDialog;

    function getKeyTranslate(key) {
      return $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.' + key.toUpperCase());
    }

    function isKeyError() {
      if (!locals || !locals.error || !locals.error.data || !locals.error.data.faultcode || !locals.error.data.faultstring) {
        return false;
      }
      var faultcode = locals.error.data.faultcode === 'SOAP-ENV:Server';
      var faultstring = locals.error.data.faultstring === 'A chave de acesso está inválida ou o aplicativo está suspenso.';

      return faultcode && faultstring;
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('OmieSendQuotationToOmieDialog', OmieSendQuotationToOmieDialog);

  function OmieSendQuotationToOmieDialog($mdDialog, $document) {
    return {
      openDialog: openDialog,
      closeDialog: closeDialog
    };

    function openDialog(locals) {
      return $mdDialog.show({
        controller: 'OmieSendQuotationToOmieController',
        controllerAs: 'vm',
        templateUrl:
          'app/core/integrations/core/quotations/dialogs/export/omie/sending-to-omie/sending-to-omie.html',
        parent: locals.target || angular.element($document.body) ,
        clickOutsideToClose: false,
        multiple: true,
        targetEvent: null,
        locals: locals,
      }).then(function (response) {
        return response;
      });
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').controller('OmieSendQuotationToOmieController', OmieSendQuotationToOmieController);

  function OmieSendQuotationToOmieController(locals, $mdDialog) {
    var vm = this;
    vm.callback = locals.callback;

    if (!locals || !locals.callback) {
      $mdDialog.hide();
      return;
    }

    vm.callback().then(function (response) {
      $mdDialog.hide(response);
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('OmieQuotationLoadDataService', OmieQuotationLoadDataService);

  function OmieQuotationLoadDataService(msUtils) {
    return {
      returnLinkedQuotationProductsRegisteredInOmie: returnLinkedQuotationProductsRegisteredInOmie,
      returnLinkedQuotationServicesRegisteredInOmie: returnLinkedQuotationServicesRegisteredInOmie
    };

    function returnLinkedQuotationProductsRegisteredInOmie(omieProducts, quotationProducts) {
      var existentOmieProducts = [];

      omieProducts.forEach(function (omieProduct) {
        quotationProducts.forEach(function (quotationProduct) {
          var similarity = msUtils.similarity(omieProduct.name, quotationProduct.productService.name);

          if (
            omieProduct.integrationId === quotationProduct.productService.id &&
            similarity > 0.5
          ) {
            omieProduct.measure = quotationProduct.productService.measure;
            omieProduct.quantity = quotationProduct.quantity;

            if (!omieProduct.value) {
              omieProduct.value = quotationProduct.value || 1;
            }

            existentOmieProducts.push(omieProduct);
          }
        });
      });

      return existentOmieProducts;
    }

    function returnLinkedQuotationServicesRegisteredInOmie(omieServices, quotationServices, quotation) {
      var existentOmieServices = [];

      omieServices.forEach(function (omieService) {
        quotationServices.forEach(function (quotationService) {
          if (omieService.integrationId === quotationService.productService.id) {
            omieService.quantity = quotationService.quantity;
            omieService.description = quotationService.description;
            omieService.value = quotationService.value || 0;

            existentOmieServices.push(omieService);
          }
        });
      });

      if (quotation && quotation.discount) {
        var discountType = quotation.discount.type || 'value';
        var discountValue = quotation.discount.value || 0;
        var discountTotal = quotation.discount.total || 0;

        if (typeof quotation.discount === 'number') {
           discountType = 'value';
           discountTotal = quotation.discount;
        }

        if (discountType === 'percentage') {
          existentOmieServices.forEach(function (service) {
            service.discount = {
              type: 'percentage',
              value: discountValue
            };
          });
        } else {
          var totalQuotationValue = quotation.subtotal || 0;

          if (!totalQuotationValue) {
             totalQuotationValue = existentOmieServices.reduce(function (total, service) {
               return total + service.value * service.quantity;
             }, 0);
          }

          existentOmieServices.forEach(function (service) {
            var serviceTotal = service.value * service.quantity;
            var proportion = totalQuotationValue > 0 ? serviceTotal / totalQuotationValue : 0;
            var distributedDiscount = discountTotal * proportion;

            service.discount = {
              type: 'value',
              value: distributedDiscount
            };
          });
        }
      }

      return existentOmieServices;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').controller('OmieQuotationLoadDataController', OmieQuotationLoadDataController);

  function OmieQuotationLoadDataController(
    $q,
    $translate,
    locals,
    omieApi,
    OmieQuotationErrorsDialog,
    OmieQuotationExportDialog,
    OmieQuotationLoadDataService,
    omieCustomerMapper,
    FcModalService,
    $mdDialog,
    $rootScope,
    _
  ) {
    var appId = locals.selectedAccount.appId;

    loadData()
      .then(function (data) {
        if (!_isEssentialDataLoaded(data)) {
          return OmieQuotationErrorsDialog.open({
            data: Object.assign({}, data, { quotaiton: locals.quotation }),
            target: locals.target
          });
        }

        var inputs = {
          data: data,
          quotation: locals.quotation,
          selectedAccount: locals.selectedAccount,
          target: locals.target,
        };

        OmieQuotationExportDialog.open(inputs);
      })
      .catch(function (error) {
        OmieQuotationErrorsDialog.open({ error: error, target: locals.target });
      });

    function loadData() {
      var requests = {
        customers: _loadCustomers(),
        cities: _loadCity(),
        productsLinkedToQuotation: _loadLinkedToQuotationProducts(),
        servicesLinkedToQuotation: _loadLinkedToQuotationServices(),
        bankAccounts: _loadBankAccounts(),
        categories: _loadCategories(),
        installments: _loadInstallments(),
        sellers: _loadSellers(),
      };

      return $q.all(requests);
    }

    function _isEssentialDataLoaded(data) {
      var categories = data.categories && data.categories.length;
      var installments = data.installments && data.installments.length;
      var sellers = data.sellers && data.sellers.length;
      var bankAccounts = data.bankAccounts && data.bankAccounts.length;
      var customers = data.customers;
      var cities = data.cities;
      var servicesLinkedToQuotation = data.servicesLinkedToQuotation && data.servicesLinkedToQuotation.length;
      var productsLinkedToQuotation = data.productsLinkedToQuotation && data.productsLinkedToQuotation.length;

      return (
        categories &&
        installments &&
        sellers &&
        bankAccounts &&
        customers &&
        cities &&
        (servicesLinkedToQuotation || productsLinkedToQuotation)
      );
    }

    function _loadCustomers() {
      var customer = locals.quotation.customer;

      var requests = {
        customersbyName: _loadCustomersByCustumerName(customer.name),
        customersbyFantasyName: _loadCustomersByCustumerFantasyName(customer.name),
      };

      return $q.all(requests).then(function (data) {
        var customers = data.customersbyName.concat(data.customersbyFantasyName);
        customers = _.uniq(customers, 'codigo_cliente_omie');

        if (customers.length == 1) {
          return customers;
        }

        if (customers.length > 1) {
          return _openDialogCustomerOmie(customers);
        }

        return null;
      });
    }

    function _loadLinkedToQuotationProducts() {
      var quotationProducts = _getQuotationItemsByType(locals.quotation, 'product');

      if (!quotationProducts || !quotationProducts.length) {
        return Promise.resolve([]);
      }

      var linkedQuotationProducts = _.map(quotationProducts, function (product) {
        return { codigo_produto_integracao: product.productService.id };
      });
      var customParams = {
        produtosPorCodigo: linkedQuotationProducts
      };
      if (customParams.produtosPorCodigo.length === 0) {
        return Promise.resolve([]);
      }

      return omieApi.products.getAll(appId, customParams).then(function (response) {
        var omieProducts = response;
        return OmieQuotationLoadDataService.returnLinkedQuotationProductsRegisteredInOmie(
          omieProducts,
          quotationProducts
        );
      });
    }

    function _loadLinkedToQuotationServices() {
      var quotationServices = _getQuotationItemsByType(locals.quotation, 'service');

      return omieApi.services.search(appId).then(function (response) {
        var omieServices = response;
        return OmieQuotationLoadDataService.returnLinkedQuotationServicesRegisteredInOmie(
          omieServices,
          quotationServices,
          locals.quotation
        );
      });
    }

    function _loadCity() {
      var address = locals.quotation.customer.address;
      if (!address.city || !address.state) {
        return Promise.resolve(null);
      }

      var uf = address.state;
      if (uf.length !== 2) {
        uf = omieCustomerMapper.stateToUf(address.state);
      }

      var searchable = address.city + ' (' + uf + ')';

      return omieApi.cities.search(searchable, appId);
    }

    function _loadBankAccounts() {
      return omieApi.bankAccounts.search(appId);
    }

    function _loadCategories() {
      return omieApi.categories.search(appId);
    }

    function _loadInstallments() {
      return omieApi.payments.getAll(appId);
    }

    function _loadSellers() {
      var defaultSeller = {
        nome: $translate.instant('INTEGRATIONS.QUOTATIONS.DEFAULT_SELLER'),
        translate: $translate.instant('INTEGRATIONS.QUOTATIONS.DEFAULT_SELLER'),
        value: $translate.instant('INTEGRATIONS.QUOTATIONS.DEFAULT_SELLER'),
        codigo: null,
      };

      return omieApi.sellers.search(appId).then(function (sellers) {
        sellers.unshift(defaultSeller);
        return sellers;
      });
    }

    function _loadCustomersByCustumerName(customerName) {
      return omieApi.customers.search({ razao_social: customerName }, appId).then(function (customers) {
        if (customers) {
          return customers;
        }

        return [];
      });
    }

    function _loadCustomersByCustumerFantasyName(customerName) {
      return omieApi.customers.search({ nome_fantasia: customerName }, appId).then(function (customers) {
        if (customers) {
          return customers;
        }

        return [];
      });
    }

    function _getQuotationItemsByType(quotation, type) {
      return quotation.items.filter(function (item) {
        return item.productService.type === type;
      });
    }

    function _openDialogCustomerOmie(customers){
      customers = customers.map(function (c) {
        return Object.assign({}, c, {
          displayName: c.razao_social + (c.nome_fantasia ? ' (' + c.nome_fantasia + ')' : '')
        });
      });

      var deferred = $q.defer();
      FcModalService.open('', {
        title: $translate.instant('INTEGRATIONS.QUOTATIONS.CUSTOMERS.TITLE'),
        content: $translate.instant('INTEGRATIONS.QUOTATIONS.CUSTOMERS.DESCRIPTION'),
        paddingSmall: true,
        hasOmieCustomerSelector: true,
        rightContinueButton: true,
        rightButtonText: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'),
        leftButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
        variables: {
          customers: customers,
          startingAppIdToLoad: appId
        },
        handleRightButton: function (customer) {
          deferred.resolve([customer]);
        },
        handleClose: function (){
          $rootScope.loadingProgress = false;
          $mdDialog.cancel();
        }
      });
      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('OmieQuotationsExportDialogViewModel', OmieQuotationsExportDialogViewModelFactory);

  /** @ngInject */
  function OmieQuotationsExportDialogViewModelFactory(
    omieApi,
    msUtils,
    _,
    moment,
    omieCustomerMapper,
    omieProductMapper,
    omieServiceMapper,
    $translate,
    $locale,
    dateConverter,
    CurrencyService,
    OmieSendQuotationToOmieDialog
  ) {
    var currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    var OmieQuotationsExportDialogViewModel = function (loadedData) {
      if (loadedData) {
        this.selectedAccount = loadedData.selectedAccount;
        this.quotation = loadedData.quotation;
        this.disableCustomerInput = false;
        this.disableCityInput = false;
        this.customers = loadedData.data.customers;
        this.bankAccounts = loadedData.data.bankAccounts;
        this.productsLinkedToQuotation = loadedData.data.productsLinkedToQuotation;
        this.servicesLinkedToQuotation = loadedData.data.servicesLinkedToQuotation;
        this.cities = loadedData.data.cities;
        this.categories = loadedData.data.categories;
        this.installments = loadedData.data.installments.slice(0, 100);
        this.installmentsCopy = loadedData.data.installments;
        this.sellers = loadedData.data.sellers.slice(0, 100);
        this.sellersCopy = loadedData.data.sellers;
        this.loadedAllItems = false;
        this.loadedAllInstallments = false;
        this.loadedAllSellers = false;
        this.nPaginaServices = 1;
        this.searchProductTextArray = [];
        this.searchServiceTextArray = [];
        this.oneYearAgo = moment().subtract(1, 'year').toDate();
        this.target = loadedData.target;
        this.form = {
          account: loadedData.activatedAccount,
          quotation: loadedData.quotation,
          city: null,
          bankAccount: null,
          customer: null,
          installment: null,
          seller: null,
          service: null,
          category: null,
          forecastDate: moment.utc(),
          services: [],
          products: [],
          task: { order: loadedData.quotation.order },
          duplicateOsMethod: 'duplicate',
        };
      }
    };

    OmieQuotationsExportDialogViewModel.prototype.setData = setData;
    OmieQuotationsExportDialogViewModel.prototype.setLinkedQuatationProducts = setLinkedQuatationProducts;
    OmieQuotationsExportDialogViewModel.prototype.setLinkedQuotationServices = setLinkedQuotationServices;
    OmieQuotationsExportDialogViewModel.prototype.setCity = setCity;
    OmieQuotationsExportDialogViewModel.prototype.setCategory = setCategory;
    OmieQuotationsExportDialogViewModel.prototype.setBankAccount = setBankAccount;
    OmieQuotationsExportDialogViewModel.prototype.setInstallmentToView = setInstallmentToView;
    OmieQuotationsExportDialogViewModel.prototype.setSellerToView = setSellerToView;
    OmieQuotationsExportDialogViewModel.prototype.searchCustomer = searchCustomer;
    OmieQuotationsExportDialogViewModel.prototype.searchCity = searchCity;
    OmieQuotationsExportDialogViewModel.prototype.setCustomer = setCustomer;
    OmieQuotationsExportDialogViewModel.prototype.setAccount = setAccount;
    OmieQuotationsExportDialogViewModel.prototype.serviceHasSelected = serviceHasSelected;
    OmieQuotationsExportDialogViewModel.prototype.sendQuotation = sendQuotation;
    OmieQuotationsExportDialogViewModel.prototype.loadInstallmentsPage = loadInstallmentsPage;
    OmieQuotationsExportDialogViewModel.prototype.loadInstallments = loadInstallments;
    OmieQuotationsExportDialogViewModel.prototype.loadSellersPage = loadSellersPage;
    OmieQuotationsExportDialogViewModel.prototype.loadSellers = loadSellers;
    OmieQuotationsExportDialogViewModel.prototype.addService = addService;
    OmieQuotationsExportDialogViewModel.prototype.addProduct = addProduct;
    OmieQuotationsExportDialogViewModel.prototype.setServiceManually = setServiceManually;
    OmieQuotationsExportDialogViewModel.prototype.removeService = removeService;
    OmieQuotationsExportDialogViewModel.prototype.removeProduct = removeProduct;
    OmieQuotationsExportDialogViewModel.prototype.searchService = searchService;
    OmieQuotationsExportDialogViewModel.prototype.searchProduct = searchProduct;
    OmieQuotationsExportDialogViewModel.prototype.searchInstallment = searchInstallment;
    OmieQuotationsExportDialogViewModel.prototype.searchSeller = searchSeller;
    OmieQuotationsExportDialogViewModel.prototype.productHasSelected = productHasSelected;
    OmieQuotationsExportDialogViewModel.prototype.setCustomer = setCustomer;
    OmieQuotationsExportDialogViewModel.prototype.setOneCustomer = setOneCustomer;
    OmieQuotationsExportDialogViewModel.prototype.setOneAccount = setOneAccount;
    OmieQuotationsExportDialogViewModel.prototype.setInstallment = setInstallment;
    OmieQuotationsExportDialogViewModel.prototype.setSeller = setSeller;
    OmieQuotationsExportDialogViewModel.prototype.setService = setService;
    OmieQuotationsExportDialogViewModel.prototype.setProduct = setProduct;
    OmieQuotationsExportDialogViewModel.prototype.setOneCity = setOneCity;
    OmieQuotationsExportDialogViewModel.prototype.setCustomerValue = setCustomerValue;
    OmieQuotationsExportDialogViewModel.prototype.getCopyInstallment = getCopyInstallment;
    OmieQuotationsExportDialogViewModel.prototype.getCopySeller = getCopySeller;

    function setData() {
      if (this.customers.length) {
        this.setOneCustomer(this.customers[0]);
      }
      if (this.cities.length) {
        this.setOneCity(this.cities[0]);
      }

      this.setLinkedQuatationProducts();
      this.setLinkedQuotationServices();
      this.setBankAccount();
      this.setInstallmentToView();
      this.setSellerToView();
      this.setCategory();
      this.setCustomerValue();
    }

    function setOneCity(city) {
      this.form.city = city;
    }

    function setCity(cities) {
      this.cities = cities;
    }

    function setCategory() {
      this.form.category = _.find(this.categories, function (category) {
        return category.descricao === 'Clientes - Serviços Prestados';
      });
    }

    function setCustomerValue() {
      this.customers.forEach(function (customer) {
        customer.value = customer.razao_social;
      });
    }

    function setBankAccount() {
      this.form.bankAccount = this.bankAccounts[0].descricao;
    }

    function setInstallmentToView() {
      this.form.installment = this.installments[0].cDescricao;
    }

    function setSellerToView() {
      this.form.seller = this.sellers[0].nome;
    }

    function setLinkedQuotationServices() {
      var services = _.cloneDeep(this.form.services);

      if (this.servicesLinkedToQuotation && this.servicesLinkedToQuotation.length) {
        this.servicesLinkedToQuotation.forEach(function (linkedService) {
          var service = omieServiceMapper.generateServiceObject(linkedService);
          if (linkedService.discount) {
            service.discount = linkedService.discount;
          } else {
            service.discount = {
              type: 'value',
              value: 0,
            };
          }

          services.push(service);
        });
      }

      this.form.services = services;
    }

    function setLinkedQuatationProducts() {
      var products = _.cloneDeep(this.form.products);

      if (this.productsLinkedToQuotation && this.productsLinkedToQuotation.length) {
        this.productsLinkedToQuotation.forEach(function (linkedProduct) {
          var product = omieProductMapper.generateProductObject(linkedProduct);
          product.discount = {
            type: 'value',
            value: 0,
          };

          products.push(product);
        });
      }

      this.form.products = products;
    }

    function setCustomer(customers) {
      this.customers = customers;
    }

    function setAccount(accounts) {
      this.accounts = accounts;
    }

    function setOneAccount(account) {
      this.form.account = account.value;
      this.selectedAccount = account.value;
    }

    function setOneCustomer(customer, dontDecode) {
      if (customer.codigo_cliente_omie || customer.codigo_cliente_integracao) {
        this.form.customer = customer;
        this.disableCustomerInput = true;
        this.customerData = omieCustomerMapper.toFieldControl(customer, dontDecode);
        this.selectedCustomer = customer.razao_social;
      }
    }

    function searchCustomer(searchText, callback) {
      var filter =
        searchText && parseInt(searchText) > 0 ? { cnpj_cpf: searchText } : { razao_social: searchText.substr(0, 60) };

      omieApi.customers
        .search(filter, this.selectedAccount.appId)
        .then(function (response) {
          callback(response);
        })
        .catch(function () {
          callback([]);
        });
    }

    function searchCity(searchText, callback) {
      omieApi.cities
        .search(searchText, this.selectedAccount.appId)
        .then(function (response) {
          callback(response);
        })
        .catch(function () {
          callback([]);
        });
    }

    function serviceHasSelected(service) {
      if (service.obj && service.obj.cabecalho) {
        service.value = service.obj.cabecalho.nPrecoUnit > 0 ? parseFloat(service.obj.cabecalho.nPrecoUnit) : 0;
      }
    }

    function productHasSelected(product) {
      if (!product.obj) {
        return;
      }
      product.value = product.obj.value && product.obj.value > 0 ? parseFloat(product.obj.value) : 0;
      product.measure = product.obj.measure || '';
    }

    function sendQuotation(form) {
      var self = this;

      form.categoryToSave = _correctToSave(form.category.descricao, this.categories, 'descricao');
      form.bankAccountToSave = _correctToSave(form.bankAccount, this.bankAccounts, 'descricao');
      form.installmentToSave = _correctToSave(form.installment, this.installments, 'cDescricao');
      form.sellerToSave = _correctToSave(this.form.seller, this.sellers, 'nome');
      form.customer = _correctToSave(this.selectedCustomer, this.customers, 'razao_social');

      return chooseSendQuotationProductsMethod(form).then(function (sendMethod) {
        if (sendMethod === 'cancel') {
          return;
        }

        return OmieSendQuotationToOmieDialog.openDialog({
          target: self.target,
          callback: function () {
            return createSalesOrder(form, sendMethod, self.selectedAccount.appId).then(function () {
              return createOS(form, self.selectedAccount.appId);
            });
          },
        });
      });
    }

    function chooseSendQuotationProductsMethod(form) {
      return new Promise(function (resolve) {
        var products = form.products || [];

        if (!products.length) {
          return resolve();
        }

        openOmieChooseSendQuotationMethod(form).then(function (sendMethod) {
          return resolve(sendMethod);
        });
      });
    }

    function openOmieChooseSendQuotationMethod(form) {
      return new Promise(function (resolve) {
        var quotationName = form.quotation && form.quotation.name;
        document.dispatchEvent(
          new CustomEvent('openOmieChooseSendQuotationMethod', { detail: { name: quotationName } })
        );

        document.addEventListener('omieChooseSendQuotationMethodClosed', function (event) {
          if (event.detail && event.detail.data && event.detail.data.sendMethod) {
            return resolve(event.detail.data.sendMethod);
          }

          return resolve('cancel');
        });
      });
    }

    function createSalesOrder(form, sendMethod, appId) {
      return new Promise(function (resolve) {
        if (!sendMethod) {
          return resolve(null);
        }

        var stageToSave = sendMethod === 'quotation' ? '00' : '10';
        form.stageToSave = stageToSave;

        omieApi.salesOrders
          .create(form, appId)
          .then(function (response) {
            form.products = [];

            return resolve(response);
          })
          .catch(function (error) {
            if (error && error.data && error.data.faultcode === 'SOAP-ENV:Client-1065') {
              openShowConfirmDialog({
                title: 'Erro ao enviar orçamento',
                text: 'Ocorreu um erro ao enviar o orçamento. Por favor, verifique se a configuração de orçamento está habilitada no Omie.',
                successText: 'Ok',
              }).then(function () {
                return resolve();
              });
            }
          });
      });
    }

    function createOS(form, appId) {
      return new Promise(function (resolve) {
        if (!form.services || !form.services.length) {
          return resolve({ status: 200 });
        }

        return omieApi.os.createOrUpdate(form, appId).then(function (response) {
          return resolve(response);
        });
      });
    }

    function loadInstallmentsPage(page) {
      var self = this;

      return omieApi.payments
        .list(
          {
            pagina: page,
          },
          this.selectedAccount.appId
        )
        .then(function (response) {
          if (response.status === 200 && response.data.cadastros.length) {
            response.data.cadastros.forEach(function (installment) {
              self.installments.push(installment);
            });
            if (response.data.pagina < response.data.total_de_paginas) {
              return self.loadInstallmentsPage(page + 1);
            } else {
              self.loadedAllInstallments = true;
              self.checkIfLoadAllItems();
            }
          }
        })
        .catch(function (error) {
          return { error: true, message: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.ERROR_LOADING_PAYMENTS') };
        });
    }

    function loadInstallments() {
      return this.loadInstallmentsPage(1);
    }

    function loadSellersPage(page) {
      var self = this;

      return omieApi.sellers
        .list(
          {
            pagina: page,
          },
          this.selectedAccount.appId
        )
        .then(function (response) {
          if (response.status === 200 && response.data.cadastro.length) {
            response.data.cadastro.forEach(function (seller) {
              self.sellers.push(seller);
            });
            if (response.data.pagina < response.data.total_de_paginas) {
              return self.loadSellersPage(page + 1);
            } else {
              self.loadedAllSellers = true;
              self.checkIfLoadAllItems();
            }
          }
        })
        .catch(function (error) {
          return { error: true, message: $translate.instant('INTEGRATIONS.TASKS.EXPORT.OMIE.ERROR_LOADING_PAYMENTS') };
        });
    }

    function loadSellers() {
      return this.loadSellersPage(1);
    }

    function addService() {
      this.form.services.push({
        description: '',
        qtd: 1,
        value: 0,
      });
    }

    function addProduct() {
      this.form.products.push({
        name: '',
        quantity: 1,
        value: 0,
        measure: '',
      });
    }

    function removeProduct(index) {
      this.searchProductTextArray.splice(index, 1);
      this.form.products.splice(index, 1);
    }

    function setServiceManually(service) {
      var index = this.form.services.length ? this.form.services.length - 1 : 0;
      var lastItem = this.form.services[index];
      if (lastItem.obj && lastItem.obj.cabecalho && lastItem.obj.cabecalho.cDescricao) {
        this.addService();
        index++;
      }
      this.form.services[index].obj = service;
      this.form.services[index].qtd = service.qtd;
      this.serviceHasSelected(this.form.services[index]);
    }

    function removeService(index) {
      this.searchServiceTextArray.splice(index, 1);
      this.form.services.splice(index, 1);
    }

    function setService(services) {
      this.services = services;
    }

    function searchService(searchText, callback) {
      if (!searchText || searchText === '') {
        return callback(this.services || []);
      }

      var self = this;
      omieApi.services
        .list(null, self.selectedAccount.appId)
        .then(function (services) {
          callback(_searchPaginateServices(services, _searchText, returnableItems));
        }).catch(function () {
          callback([]);
        });
    }

    function setProduct(products) {
      this.products = products;
    }

    function searchProduct(searchText, callback) {
      omieApi.products
        .search(this.selectedAccount.appId, { filtrar_apenas_descricao: '%' + searchText + '%' })
        .then(function (products) {
          callback(_.sortBy(products, 'name'));
        });
    }

    function setInstallment(installments) {
      this.installments = installments;
    }

    function searchInstallment(searchText, callback) {
      omieApi.payments
        .list(
          {
            pagina: 1,
          },
          this.selectedAccount.appId
        )
        .then(function (response) {
          searchText = searchText ? searchText.toLowerCase() : '';
          var returnableItems = response.data.cadastros.filter(function (installment) {
            return installment.cDescricao.toLowerCase().includes(searchText);
          });
          callback(returnableItems);
        })
        .catch(function () {
          callback([]);
        });
    }

    function setSeller(sellers) {
      this.sellers = sellers;
    }

    function searchSeller(searchText, callback) {
      omieApi.sellers
        .list(
          {
            pagina: 1,
          },
          this.selectedAccount.appId
        )
        .then(function (response) {
          searchText = searchText ? searchText.toLowerCase() : '';
          var returnableItems = response.data.cadastro.filter(function (seller) {
            return seller.nome.toLowerCase().includes(searchText);
          });
          callback(returnableItems);
        })
        .catch(function () {
          callback([]);
        });
    }

    function _searchPaginateServices(response, searchText, returnableItems) {
      response.data.cadastros.forEach(function (service) {
        service.displayName = service.cabecalho.cCodigo + ' - ' + service.cabecalho.cDescricao;
        var name = service.cabecalho.cDescricao.trim().toLowerCase();
        if (name.includes(searchText)) {
          returnableItems.push(service);
        }
      });

      return _.sortBy(returnableItems, 'service.cabecalho.cDescricao');
    }

    function _correctToSave(selectedValue, allItems, field) {
      return allItems.find(function (item) {
        return item[field] === selectedValue;
      });
    }

    function getCopyInstallment() {
      return this.installmentsCopy;
    }

    function getCopySeller() {
      return this.sellersCopy;
    }

    function openShowConfirmDialog(params) {
      return new Promise(function (resolve) {
        document.dispatchEvent(new CustomEvent('showConfirmDialog', { detail: params }));

        document.addEventListener('confirmDialogClosed', function () {
          return resolve();
        });
      });
    }

    return OmieQuotationsExportDialogViewModel;
  }
})();

(function () {
  'use strict';

  angular.module('app.core').controller('OmieQuotationsExportDialogController', OmieQuotationsExportDialogController);

  /** @ngInject */
  function OmieQuotationsExportDialogController(
    $scope,
    $mdDialog,
    locals,
    OmieQuotationsExportDialogViewModel,
    $rootScope,
    $mdToast,
    $translate,
    CurrencyService,
    $locale,
    $timeout
  ) {
    var currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    var vm = this;

    vm.viewModel = new OmieQuotationsExportDialogViewModel(locals);
    vm.sendingQuotation = false;
    vm.duplicatedProduct = false;
    vm.sendQuotation = sendQuotation;
    vm.verifyProductsName = verifyProductsName;
    vm.closeDialog = closeDialog;
    vm.search = search;
    vm.searchInstallmentText = searchInstallmentText;
    vm.searchSellerText = searchSellerText;
    vm.duplicateOsMethod = locals.duplicateOsMethod;
    vm.validateProductDiscountValue = validateProductDiscountValue;
    vm.validateServiceDiscountValue = validateServiceDiscountValue;
    this.discountTypes = [
      { value: 'percentage', translate: '%' },
      { value: 'value', translate: currencySymbol },
    ];

    $rootScope.loadingProgress = false;

    vm.viewModel.setData();

    function sendQuotation() {
      vm.sendingQuotation = true;
      $rootScope.loadingProgress = true;

      vm.viewModel.sendQuotation(vm.viewModel.form).then(function (response) {
        vm.sendingQuotation = false;
        $rootScope.loadingProgress = false;

        if (response && response.status === 200) {
          toast($translate.instant('INTEGRATIONS.QUOTATIONS.SUCCESS_MESSAGE'), 6000);
          closeDialog();
        } else {
          var message = response && (response.data.message || response.data.faultstring);
          toast($translate.instant('INTEGRATIONS.QUOTATIONS.ERROR_MESSAGE') + ': ' + message, 8000);
        }
      });
    }

    function verifyProductsName() {
      var productNames = vm.viewModel.form.products.map(function (product) {
        if (!product.obj) {
          return '';
        }
        return product.obj.name;
      });
      var repeatedProductsIndex = [];
      var uniqueProductsIndex = [];

      productNames.forEach(function (name, index) {
        var isUnique = productNames.indexOf(name) === index;
        var formKey = 'productsAutoComplete__' + index;

        if (isUnique) {
          uniqueProductsIndex.push(index);
          setValidityAndTouched(formKey, 'uniqueProduct', true);
        } else {
          repeatedProductsIndex.push(index);
          setValidityAndTouched(formKey, 'uniqueProduct', false);
        }
      });

      repeatedProductsIndex.forEach(function (repeatedIndex) {
        var formKey = 'productsAutoComplete__' + repeatedIndex;
        setValidityAndTouched(formKey, 'uniqueProduct', false);
      });

      vm.duplicatedProduct = repeatedProductsIndex.length > 0;

      function setValidityAndTouched(formKey, validityKey, isValid) {
        if (!$scope.omieExportQuotationForm || !$scope.omieExportQuotationForm[formKey]) {
          return;
        }

        $scope.omieExportQuotationForm[formKey].$setValidity(validityKey, isValid);
        $scope.omieExportQuotationForm[formKey].$setTouched();
      }
    }

    function toast(message, delay) {
      $mdToast.show($mdToast.simple().textContent(message).hideDelay(delay));
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function search(searchText, searchType) {
      var searchFunction = 'search'.concat(searchType);
      var setFunction = 'set'.concat(searchType);

      vm.viewModel[searchFunction](searchText, function (response) {
        _.defer(function () {
          $scope.$apply(function () {
            vm.viewModel[setFunction](response);
          });
        });
      });
    }

    function searchInstallmentText() {
      var copy = vm.viewModel.getCopyInstallment();
      if (vm.viewModel.installments.length <= copy.length) {
        vm.viewModel.setInstallment(vm.viewModel.getCopyInstallment());
      }
    }

    function searchSellerText() {
      var copy = vm.viewModel.getCopySeller();
      if (vm.viewModel.sellers.length <= copy.length) {
        vm.viewModel.setSeller(vm.viewModel.getCopySeller());
      }
    }

    function validateProductDiscountValue(index) {
      if (!vm.viewModel.form.products || !vm.viewModel.form.products[index]) {
        return;
      }

      $timeout(function () {
        var product = vm.viewModel.form.products[index];
        var productControl = $scope.omieExportQuotationForm['productDiscountValue__' + index];
        var value = parseFloat(product.discount.value || 0);

        if (product.discount.type === 'percentage') {
          productControl.$setValidity(
            'errorPercentageDiscount',
            value <= 100 && value >= 0 && /^[0-9.,]+$/.test(value) && !JSON.stringify(value).includes('-')
          );
        }

        var totalProductValue = (product.quantity || 1) * product.value;

        if (product.discount.type === 'value') {
          productControl.$setValidity('errorValueDiscount', value <= totalProductValue && value >= 0);
        }
      }, 0);
    }

    function validateServiceDiscountValue(index) {
      if (!vm.viewModel.form.services || !vm.viewModel.form.services[index]) {
        return;
      }

      $timeout(function () {
        var service = vm.viewModel.form.services[index];
        var serviceControl = $scope.omieExportQuotationForm['serviceDiscountValue__' + index];
        var value = parseFloat(service.discount.value || 0);

        if (service.discount.type === 'percentage') {
          serviceControl.$setValidity(
            'errorPercentageDiscount',
            value <= 100 && value >= 0 && /^[0-9.,]+$/.test(value) && !JSON.stringify(value).includes('-')
          );
        }

        var totalServiceValue = service.qtd * service.value;

        if (service.discount.type === 'value') {
          serviceControl.$setValidity('errorValueDiscount', value <= totalServiceValue && value >= 0);
        }
      }, 0);
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('OmieQuotationExportDialog', OmieQuotationExportDialog);

  function OmieQuotationExportDialog($mdDialog, $document) {
    return {
      open: open,
    };

    function open(locals) {
      $mdDialog.show({
        controller: 'OmieQuotationsExportDialogController',
        controllerAs: 'vm',
        templateUrl:
          'app/core/integrations/core/quotations/dialogs/export/omie/export/omie-quotations-export-dialog.html',
        parent: locals.target || angular.element($document.body),
        clickOutsideToClose: false,
        locals: locals,
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('OmieQuotationErrorsDialog', OmieQuotationErrorsDialog);

  /** @ngInject */
  function OmieQuotationErrorsDialog($mdDialog, $document) {
    return {
      open: open
    };

    function open(locals) {
      $mdDialog.show({
        controller: 'OmieQuotationErrorsController',
        controllerAs: 'vm',
        templateUrl: 'app/core/integrations/core/quotations/dialogs/export/omie/errors/omie-errors-dialog.html',
        parent: locals.target || angular.element($document.body) ,
        clickOutsideToClose: false,
        locals: locals
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').controller('OmieQuotationErrorsController', OmieQuotationErrorsController);

  function OmieQuotationErrorsController($mdDialog, $rootScope, $translate, locals) {
    var vm = this;

    $rootScope.loadingProgress = false;

    vm.data = locals.data;
    vm.error = locals.error;

    vm.isKeyError = isKeyError;
    vm.closeDialog = closeDialog;

    function isKeyError() {
      if (
        !locals ||
        !locals.error ||
        !locals.error.data ||
        !locals.error.data.faultcode ||
        !locals.error.data.faultstring
      ) {
        return false;
      }

      var faultcode = locals.error.data.faultcode === 'SOAP-ENV:Server';
      var faultstring =
        locals.error.data.faultstring === 'A chave de acesso está inválida ou o aplicativo está suspenso.';

      return faultcode && faultstring;
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('CustomersImportAutomaticConfirmDialogController', CustomersImportAutomaticConfirmDialogController);

    /** @ngInject */
    function CustomersImportAutomaticConfirmDialogController($mdDialog, locals, CustomersImportAutomaticDialog) {

        var vm = this;
        vm.appName = locals.appName;
        vm.totalCustomerToImport = locals.totalCustomerToImport;
        vm.appId = locals.appId;

        vm.closeDialog = closeDialog;
        vm.startImport = startImport;

        function startImport() {
            CustomersImportAutomaticDialog.openCustomerImportAutomaticDialog(vm.appName, vm.totalCustomerToImport, vm.appId);
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('ContaAzulTasksExportDialogViewModel', ContaAzulTasksExportDialogViewModelFactory);

  /** @ngInject */
  function ContaAzulTasksExportDialogViewModelFactory(contaAzulApi, $q, msUtils, _, moment, contaAzulCustomerMapper, ordersApi, $locale, CurrencyService) {

    // Workaround até descobrir como fazer com que o $locale identifique corretamente a localização
    // pacote do i18n possui os locales
    var currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    var ContaAzulTasksExportDialogViewModel = function (locals) {
      var self = this;
      if (locals && locals.tasks) {
        self.task = locals.tasks[0];
        self.loadedItems = [];
        self.disableCustomerInput = false;
        self.form = {
          customer: null,
          date: moment.utc(),
          status: 'COMMITTED',
          items: [{
            description: '',
            qtd: 1,
            value: 0,
            type: 'service'
          }],
          discount: {
            value: 0,
            type: '0'
          },
          subTotal: 0,
          total: 0,
          notes: ''
        };
        self.services = [];
        self.products = [];
        self.defaultItems = [];
        self.productService = [];
        self.availableCustomers = [];
        self.probableServices = [];
        self.probableProducts = [];
        self.checkServices = false;
        self.checkMaterials = false;
      }
    };

    ContaAzulTasksExportDialogViewModel.prototype.fillNotes = function () {
      var self = this;

      if (self.task.order) {
        if (self.task.order.identifier) {
          self.form.notes += 'Identificador: ' + self.task.order.identifier + '\n';
        }
        if (self.task.order.service && self.task.order.service.description) {
          self.form.notes += 'Tipo de OS: ' + self.task.order.service.description + '\n';
        }
        if (self.task.order.description) {
          self.form.notes += 'Descrição: ' + self.task.order.description;
        }
      }
    };

    ContaAzulTasksExportDialogViewModel.prototype.searchCustomer = function (searchText) {
      var self = this;
      return contaAzulApi.customers.list({
        'search': searchText
      }).then(function (response) {
        self.availableCustomers = response.length > 0 ? response : [];
        return self.availableCustomers;
      });
    };

    ContaAzulTasksExportDialogViewModel.prototype.loadItems = function () {
      var self = this;
      var task = self.task;

      ordersApi.queryForAllOrderProducts(task.order.id).then(function (productService) {
        self.productService = productService;

        return ordersApi.getMaterials(task.order.id);
      }).then(function (materials) {
        self.materials = materials || [];

        return self.matchItemsWithContaAzul();
      });
    };

    ContaAzulTasksExportDialogViewModel.prototype.matchItemsWithContaAzul = function () {
      var self = this;

      var servicePromise = $q.resolve();
      if (self.task.order && self.task.order.service) {
        servicePromise = contaAzulApi.services.list({ search: self.task.order.service.description })
          .then(function (services) {
            if (services.length) {
              var service = services[0];
              service.type = 'service';
              service.qtd = 1;
              self.setItemManually(service);
            }
          });
      }

      var orderProducts = self.productService.filter(function (p) { return p.type === 'product'; });

      return servicePromise.then(function () {
        return orderProducts.reduce(function (promise, product) {
          return promise.then(function () {
            return contaAzulApi.products.list({ search: product.name })
              .then(function (products) {
                if (products.length) {
                  var found = products.find(function (p) { return p.name === product.name; });
                  if (found) {
                    found.type = 'product';
                    found.qtd = product.quantity;
                    self.setItemManually(found);
                  }
                }
              });
          });
        }, $q.resolve());
      });
    };

    ContaAzulTasksExportDialogViewModel.prototype.setItemManually = function (item) {
      var type = item.type + 's';
      var index = this[type].length > 0 ? this[type].length - 1 : 0;
      var lastItem = this[type][index];

      if ((lastItem && lastItem.qtd)) {
        this.addItem(item.type);
        index++;
      } else {
        this.addItem(item.type);
      }

      this[type][index].obj = item;
      this[type][index].qtd = item.qtd;
      this.itemHasSelected(this[type][index]);
    };

    ContaAzulTasksExportDialogViewModel.prototype.setProbablyProducts = function () {
      var self = this;
      var task = self.task;
      if (task.order && task.order.id) {
        ordersApi.getMaterials(task.order.id).then(function (orderMaterials) {
          if (orderMaterials.length) {
            orderMaterials.forEach(function (orderMaterial) {
              var probablyProducts = [];
              var material = orderMaterial.material;
              self.loadedItems.forEach(function (item) {
                var similarity = msUtils.similarity(item.name, material.name);
                if (similarity === 1) {
                  item.similarity = similarity;
                  item.qtd = material.quantity;
                  probablyProducts.push(item);
                }
              });

              if (probablyProducts.length) {
                probablyProducts = _.sortBy(probablyProducts, 'similarity').reverse();
                self.setItemManually(probablyProducts[0]);
              }
            });
          }
        }).then(function () {
          if (self.services.length === 0 && self.products.length === 0) {
            self.checkMaterials = true;
          }
        });

        var orderProducts = _.filter(this.productService, function (item) {
          return item.type === 'product';
        });
        if (orderProducts.length) {
          orderProducts.forEach(function (orderProduct) {
            var probablyProducts = [];
            var product = orderProduct;

            self.loadedItems.forEach(function (item) {
              var similarity = msUtils.similarity(item.name, product.name);
              if (similarity === 1 && item.type === 'product') {
                item.similarity = similarity;
                item.qtd = product.quantity;
                probablyProducts.push(item);
              }
            });
            if (probablyProducts.length) {
              probablyProducts = _.sortBy(probablyProducts, 'similarity').reverse();
              self.setItemManually(probablyProducts[0]);
            }
          });
        }
        if (self.services.length === 0 && self.products.length === 0 && self.checkServices === true && self.checkMaterials === true) {
          self.addItem('service');
        }
      }
    };

    ContaAzulTasksExportDialogViewModel.prototype.setProbablyService = function () {
      var self = this;
      var task = self.task;

      if (task.order && task.order.service && task.order.service.description) {
        var service = task.order.service;
        var possibleServices = [];

        self.loadedItems.forEach(function (item) {
          var similarity = msUtils.similarity(service.description, item.name);
          if (similarity === 1 && item.type === 'service') {
            item.similarity = similarity;
            item.qtd = 1;
            possibleServices.push(item);
          }
        });

        if (possibleServices.length > 0) {
          possibleServices = _.sortBy(possibleServices, 'similarity').reverse();
          self.setItemManually(possibleServices[0]);
        }
      }

      var orderServices = _.filter(this.productService, function (item) {
        return item.type === 'service';
      });
      if (orderServices.length) {
        orderServices.forEach(function (orderService) {
          var probablyServices = [];
          var service = orderService;

          self.loadedItems.forEach(function (item) {
            var similarity = msUtils.similarity(item.name, service.name);
            if (similarity === 1 && item.type === 'service') {
              item.similarity = similarity;
              item.qtd = service.quantity;
              probablyServices.push(item);
            }
          });
          if (probablyServices.length) {
            probablyServices = _.sortBy(probablyServices, 'similarity').reverse();
            self.setItemManually(probablyServices[0]);
            }
        });
      };

      if (self.services.length === 0 && self.products.length === 0) {
        self.checkServices = true;
      }
    };

    ContaAzulTasksExportDialogViewModel.prototype.searchItem = function (searchText, type) {
      var self = this;

      if (!searchText || searchText.length < 2) {
        return [];
      }

      if (type === 'service') {
        return contaAzulApi.services.list({ search: searchText }).then(function (services) {
          self.probableServices = services.map(function (service) {
            service.type = 'service';
            return service;
          });
          return self.probableServices;
        });
      }

      if (type === 'product') {
        return contaAzulApi.products.list({ search: searchText }).then(function (products) {
          self.probableProducts = products.map(function (product) {
            product.type = 'product';
            return product;
          });
          return self.probableProducts;
        });
      }

      return [];
    };

    ContaAzulTasksExportDialogViewModel.prototype.sendTask = function (form) {
      return contaAzulApi.sales.create(form).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    };

    ContaAzulTasksExportDialogViewModel.prototype.loadProbablyCustomer = function () {
      var self = this;
      if (self.task && self.task.order && self.task.order.customer) {
        var customer = self.task.order.customer;
        if (customer.documentNumber) {
          return self.searchCustomer(customer.documentNumber).then(function (customers) {
            if (customers.length > 0) {
              self.setCustomer(customers[0]);
            }
          });
        } else if (customer.name) {
          return self.searchCustomer(customer.name).then(function (customers) {
            if (customers.length > 0) {
              self.setCustomer(customers[0]);
            }
          });
        }
      }
    };

    ContaAzulTasksExportDialogViewModel.prototype.setCustomer = function (customer) {
      if (customer.id) {
        this.form.customer = customer;
        this.customerData = contaAzulCustomerMapper.toFieldControl(customer, []);
      }
    };

    ContaAzulTasksExportDialogViewModel.prototype.customerTextHasChanged = function () {
      this.customerData = {};
    };

    ContaAzulTasksExportDialogViewModel.prototype.customerHasChanged = function () {
      if (this.form.customer !== null) {
        this.disableCustomerInput = true;
        this.customerData = contaAzulCustomerMapper.toFieldControl(this.form.customer, []);
      } else {
        this.disableCustomerInput = false;
        this.customerData = [];
      }
    };

    ContaAzulTasksExportDialogViewModel.prototype.removeItem = function (index, type) {
      this[type].splice(index, 1);

      this.form.items = [];
      this.form.items = this.form.items.concat(this['products']);
      this.form.items = this.form.items.concat(this['services']);

      this.itemHasChanged();
    };

    ContaAzulTasksExportDialogViewModel.prototype.addItem = function (type) {
      this[type + 's'].push({
        description: '',
        qtd: 1,
        value: 0,
        type: type
      });

      this.form.items = [];
      this.form.items = this.form.items.concat(this['products']);
      this.form.items = this.form.items.concat(this['services']);

      this.focusInLastItem();
    };

    ContaAzulTasksExportDialogViewModel.prototype.focusInLastItem = function () {
      setTimeout(function () {
        var elements = document.getElementsByClassName('md-autocomplete-input-item');
        var index = elements.length - 1;
        if (index >= 0 && elements.item(index)) {
          elements.item(index).focus();
        }
      }, 250);
    };

    ContaAzulTasksExportDialogViewModel.prototype.itemHasSelected = function (item) {
      if (item.obj && item.obj.type === 'product' && item.obj.value > 0) {
        item.value = parseFloat(item.obj.value);
      }
      else if (item.obj && item.obj.type === 'service' && item.obj.value > 0) {
        item.value = parseFloat(item.obj.value);
      } else {
        item.value = 0;
      }
      this.itemHasChanged();
    };

    ContaAzulTasksExportDialogViewModel.prototype.itemHasChanged = function () {
      var subTotal = 0;
      var total = 0;

      this.form.items = [];
      this.form.items = this.form.items.concat(this['products']);
      this.form.items = this.form.items.concat(this['services']);

      this.form.items.forEach(function (item) {
        if (parseFloat(item.qtd) > 0 && parseFloat(item.value) > 0) {
          subTotal += parseFloat(item.qtd) * parseFloat(item.value);
        }
      });

      this.form.subTotal = parseFloat(subTotal.toFixed(2));
      this.discount = 0;
      total = parseFloat(subTotal.toFixed(2));

      if (parseInt(this.form.discount.type) === 0) {
        this.discount = parseFloat(this.form.discount.value);
      } else {
        this.discount = total * (parseFloat(this.form.discount.value) / 100);
        var percentDiscount = document.getElementById('percentDiscount');
        percentDiscount.focus();
      }

      if (isNaN(this.discount)) {
        this.discount = 0;
      }

      total -= this.discount;

      if (total < 0) {
        total = 0;
      }

      this.form.total = total;
    };

    ContaAzulTasksExportDialogViewModel.prototype.clearSelectedCustomer = function () {
      this.disableCustomerInput = false;
      this.form.customer = null;
      this.searchCustomerText = "";
    };

    return ContaAzulTasksExportDialogViewModel;
  }
})();

(function () {
    'use strict';

    angular
      .module('app.core')
      .controller('ContaAzulTasksExportDialogController', ContaAzulTasksExportDialogController);

    /** @ngInject */
    function ContaAzulTasksExportDialogController($mdDialog, locals, ContaAzulTasksExportDialogViewModel, $rootScope, $mdToast, MessageDialog, $translate) {

      var vm = this;
      vm.viewModel = new ContaAzulTasksExportDialogViewModel(locals);
      vm.sendingTask = false;
      vm.sendTask = sendTask;
      vm.closeDialog = closeDialog;
      vm.colapseSection = colapseSection;
      vm.addItem = addItem;
      vm.verifyItemInclude = verifyItemInclude;
      vm.statusOptions = [{
        translate: 'Venda',
        value: 'APROVADO'
      },{
        translate: 'Revisão pendente',
        value: 'EM_ANDAMENTO'
      }];

      vm.typeOptions = [{
        translate: 'Em reais',
        value: '0'
      },{
        translate: 'Porcentagem',
        value: '1'
      }];

      vm.generalIsOpen = true;
      vm.servicesIsOpen = true;
      vm.productsIsOpen = true;

      $rootScope.loadingProgress = false;

      vm.viewModel.loadProbablyCustomer();
      vm.viewModel.loadItems();
      vm.viewModel.fillNotes();

      function addItem(type) {
        vm.viewModel.addItem(type);
        vm[type + 'sIsOpen'] = true;
      }

      function sendTask() {
        vm.sendingTask = true;
        $rootScope.loadingProgress = true;
        var errorsStatus = [400, 401, 422];

        vm.viewModel.sendTask(vm.viewModel.form).then(function (response) {
          vm.sendingTask = false;
          $rootScope.loadingProgress = false;

          if (response.status === 200) {
            toast('Atividade enviada com sucesso para o Conta Azul', 6000);
            closeDialog();
          } else if (errorsStatus.includes(response.status)) {
            var message = 'Um erro ocorreu.';

            switch (response.status) {
              case 400:
                message = $translate.instant('TASKS.INTEGRATIONS.CONTA_AZUL.ERROR.NOT_PROVIDED');
                break;
              case 401:
                message = $translate.instant('TASKS.INTEGRATIONS.CONTA_AZUL.ERROR.UNAUTHORIZED');
                break;
              case 422:
                message = $translate.instant('TASKS.INTEGRATIONS.CONTA_AZUL.ERROR.INVALID_FIELD');
                break;
            }

            MessageDialog.showToast({
              message:  message
            });
          } else {
            toast('ERRO: ' + response.data.message, 8000);
          }
        });
      }

      function toast(message, delay) {
        $mdToast.show(
          $mdToast.simple()
          .textContent(message)
          .hideDelay(delay)
        );
      }

      function colapseSection(section) {
        vm[section + 'IsOpen'] = !vm[section + 'IsOpen'];
      }

      function closeDialog() {
        $mdDialog.hide();
      }

      function verifyItemInclude(item){
        return vm.viewModel.defaultItems.includes(item);
      }
    }
  })();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('CustomersPromptUpdateController', CustomersPromptUpdateController);

  /** @ngInject */
  function CustomersPromptUpdateController($rootScope, fieldCustomer, fieldLocation, apiCustomerData, appId, CustomersPromptViewModel, contaAzulApi, omieApi,
    $mdDialog, $mdToast, $translate) {

    var vm = this;
    vm.viewModel = new CustomersPromptViewModel(fieldCustomer, fieldLocation);
    vm.appName = apiCustomerData.apiName;
    vm.closeDialog = closeDialog;
    vm.updateCustomer = updateCustomer;

    function closeDialog() {
      $mdDialog.hide();
    }

    function onSuccess() {
      var message = $translate.instant('CUSTOMERS.INTEGRATIONS.UPDATED_SUCCESSFULLY', {
        customer: fieldCustomer.name,
        appName: vm.appName
      });
      toastAndExit(message, 8000);
    }

    function onError() {
      var message = $translate.instant('CUSTOMERS.INTEGRATIONS.ERROR_SENDING_CUSTOMER');
      toastAndExit(message, 8000);
    }

    function updateCustomer() {
      $rootScope.loadingProgress = true;
      if(apiCustomerData.apiName === 'Conta Azul') {
        fieldCustomer.externalAppId = 'conta-azul';
        contaAzulApi.customers.update(apiCustomerData.apiCustomer.id, fieldCustomer, fieldLocation).then(function () {
          onSuccess();
        }).catch(function (err) {
          if (err && err.status) {
            integrationsShowError.showToast(err.status.toString(), {
              errors: {
                title: $translate.instant('CUSTOMERS.INTEGRATIONS.ERROR_SENDING_CUSTOMER'),
                '400': {
                  message: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTA_AZUL.ERROR.CUSTOMER_NOT_PROVIDED')
                },
                '401': {
                  message: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTA_AZUL.ERROR.UNAUTHORIZED')
                },
                '422': {
                  message: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTA_AZUL.ERROR.INVALID_FIELD')
                }
              }
            });
            closeDialog();
            $rootScope.loadingProgress = false;
          } else {
            onError();
          }
        });
      } else if(apiCustomerData.apiName === 'Omie') {
        if (_hasInvalidZipCode(fieldCustomer, fieldLocation)) {
          _confirmInvalidZipCode().then(function () {
            var sanitizedData = _sanitizeZipCode(fieldCustomer, fieldLocation);
            _updateOmieCustomerWithData(sanitizedData.customer, sanitizedData.location);
          }).catch(function () {
            $rootScope.loadingProgress = false;
          });
          return;
        }

        _updateOmieCustomerWithData(fieldCustomer, fieldLocation);
      }
    }

    function _updateOmieCustomerWithData(customerData, locationData) {
      omieApi.customers.update(apiCustomerData.apiCustomer.codigo_cliente_omie, customerData, locationData, appId).then(function (response) {
        if(response.status === 200) {
          onSuccess();
        } else {
          onError();
        }
      }).catch(function () {
        onError();
      });
    }

    function toastAndExit(message, delay) {
      $rootScope.loadingProgress = false;
      $mdToast.show($mdToast.simple().textContent(message).hideDelay(delay));
      closeDialog();
    }

    function _getAddress(customer, location) {
      if (location && location.address) {
        return location.address;
      }
      return customer ? customer.address : null;
    }

    function _hasInvalidZipCode(customer, location) {
      var address = _getAddress(customer, location);
      if (!address) { return false; }

      var zipCode = address.postalCode || address.zipCode;
      if (!zipCode) { return false; }

      var sanitizedZipCode = zipCode.toString().replace(/\D/g, '');
      return sanitizedZipCode && sanitizedZipCode.length < 8;
    }

    function _sanitizeZipCode(customer, location) {
      var sanitizedCustomer = angular.copy(customer);
      var sanitizedLocation = angular.copy(location);
      var address = _getAddress(sanitizedCustomer, sanitizedLocation);

      if (address) {
        address.postalCode = null;
        address.zipCode = null;
        address.formattedAddress = null;
      }

      return {
        customer: sanitizedCustomer,
        location: sanitizedLocation
      };
    }

    function _confirmInvalidZipCode() {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('CUSTOMERS.INTEGRATIONS.INVALID_ZIPCODE_CONFIRM_TITLE'))
        .textContent($translate.instant('CUSTOMERS.INTEGRATIONS.INVALID_ZIPCODE_CONFIRM_MESSAGE'))
        .ok($translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'))
        .cancel($translate.instant('CUSTOMERS.INTEGRATIONS.CANCEL'));

      return $mdDialog.show(confirm);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('CustomersPromptCreateController', CustomersPromptCreateController);

  /** @ngInject */
  function CustomersPromptCreateController($rootScope, fieldCustomer, fieldLocation, appName, appId, CustomersPromptViewModel, contaAzulApi, omieApi,
    $mdDialog, FcToastService, $translate, integrationsShowError) {

    var vm = this;
    vm.viewModel = new CustomersPromptViewModel(fieldCustomer, fieldLocation);
    vm.closeDialog = closeDialog;
    vm.createCustomer = createCustomer;
    vm.appName = appName;

    function closeDialog() {
      $mdDialog.hide();
    }

    function createContaAzulCustomer() {
      fieldCustomer.externalAppId = 'conta-azul';
      contaAzulApi.customers.create(fieldCustomer, fieldLocation).then(function () {
        var message = $translate.instant('CUSTOMERS.INTEGRATIONS.CREATED_SUCCESSFULLY', {
          customer: fieldCustomer.name,
          appName: appName
        });
        toastAndExit(message, 8000);
      }).catch(function (err) {
        if (err && err.status) {
          integrationsShowError.showToast(err.status.toString(), {
            errors: {
              title: $translate.instant('CUSTOMERS.INTEGRATIONS.ERROR_SENDING_CUSTOMER'),
              '400': {
                message: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTA_AZUL.ERROR.CUSTOMER_NOT_PROVIDED')
              },
              '401': {
                message: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTA_AZUL.ERROR.UNAUTHORIZED')
              },
              '422': {
                message: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTA_AZUL.ERROR.INVALID_FIELD')
              }
            }
          });
          closeDialog();
          $rootScope.loadingProgress = false;
        } else {
          var message = $translate.instant('CUSTOMERS.INTEGRATIONS.ERROR_SENDING_CUSTOMER');
          toastAndExit(message, 8000);
        }
      });
    }

    function createOmieCustomer() {
      if (_hasInvalidZipCode(fieldCustomer, fieldLocation)) {
        _confirmInvalidZipCode().then(function () {
          var sanitizedData = _sanitizeZipCode(fieldCustomer, fieldLocation);
          _createOmieCustomerWithData(sanitizedData.customer, sanitizedData.location);
        }).catch(function () {
          $rootScope.loadingProgress = false;
        });
        return;
      }

      _createOmieCustomerWithData(fieldCustomer, fieldLocation);
    }

    function _createOmieCustomerWithData(customerData, locationData) {
      omieApi.customers.create(customerData, locationData, appId).then(function (response) {
        if (response.status === 200) {
          var message = $translate.instant('CUSTOMERS.INTEGRATIONS.CREATED_SUCCESSFULLY', {
            customer: fieldCustomer.name,
            appName: appName
          });
          toastAndExit(message, 8000);
        }
      }).catch(function (err) {
        var message = $translate.instant('CUSTOMERS.INTEGRATIONS.ERROR_SENDING_CUSTOMER');
        toastAndExit(message, 8000);
      });
    }

    function createCustomer() {
      $rootScope.loadingProgress = true;
      if (appName === 'Conta Azul') {
        createContaAzulCustomer();
      } else if (appName === 'Omie') {
        createOmieCustomer();
      }
    }

    function toastAndExit(message, delay) {
      $rootScope.loadingProgress = false;

      FcToastService.addWarning({
        hideDelay: delay,
        position: 'BOTTOM LEFT',
        success: true,
        title: message,
        iconPath: message.includes('criado com sucesso') ? 'assets/icons/success-icon.svg' : null,
        noExit: true
      });
      closeDialog();
    }

    function _getAddress(customer, location) {
      if (location && location.address) {
        return location.address;
      }
      return customer ? customer.address : null;
    }

    function _hasInvalidZipCode(customer, location) {
      var address = _getAddress(customer, location);
      if (!address) { return false; }

      var zipCode = address.postalCode || address.zipCode;
      if (!zipCode) { return false; }

      var sanitizedZipCode = zipCode.toString().replace(/\D/g, '');
      return sanitizedZipCode && sanitizedZipCode.length < 8;
    }

    function _sanitizeZipCode(customer, location) {
      var sanitizedCustomer = angular.copy(customer);
      var sanitizedLocation = angular.copy(location);
      var address = _getAddress(sanitizedCustomer, sanitizedLocation);

      if (address) {
        address.postalCode = null;
        address.zipCode = null;
        address.formattedAddress = null;
      }

      return {
        customer: sanitizedCustomer,
        location: sanitizedLocation
      };
    }

    function _confirmInvalidZipCode() {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('CUSTOMERS.INTEGRATIONS.INVALID_ZIPCODE_CONFIRM_TITLE'))
        .textContent($translate.instant('CUSTOMERS.INTEGRATIONS.INVALID_ZIPCODE_CONFIRM_MESSAGE'))
        .ok($translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'))
        .cancel($translate.instant('CUSTOMERS.INTEGRATIONS.CANCEL'));

      return $mdDialog.show(confirm);
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('CustomersImportManualItemViewModel', CustomersImportManualItemViewModelFactory);

  /** @ngInject */
  function CustomersImportManualItemViewModelFactory(customersApi, contaAzulCustomerMapper, omieCustomerMapper, geoCoder, $translate) {
    var CustomersImportManualItemViewModel = function (apiCustomer, appName, extraData, appId) {
      this.isLoading = true;
      this.actionCompleted = false;
      this.apiCustomer = apiCustomer;
      this.extraData = extraData;
      this.appId = appId;

      if (appName === 'Conta Azul') {
        this.initContaAzulCustomer();
      }

      if (appName === 'Omie') {
        this.initOmieCustomer();
      }
    };

    CustomersImportManualItemViewModel.prototype.initOmieCustomer = function () {
      this.apiCustomer = omieCustomerMapper.toFieldControl(this.apiCustomer);
      this.checkIfExistsInFieldControl();
    };

    CustomersImportManualItemViewModel.prototype.initContaAzulCustomer = function () {
      this.apiCustomer = contaAzulCustomerMapper.toFieldControl(this.apiCustomer, this.extraData.contaAzulCustomerContacts);
      this.checkIfExistsInFieldControl();
    };

    CustomersImportManualItemViewModel.prototype.checkIfExistsInFieldControl = function () {
      var self = this;
      if (self.apiCustomer.documentNumber) {
        customersApi.search({
          where: {
            documentNumber: self.apiCustomer.documentNumber
          },
          take: 1
        }).then(function (result) {
          if (result.items.length) {
            self.currentFieldCustomer = result.items[0];
            self.archived = result.items[0].archived;
            self.actionName = $translate.instant('CUSTOMERS.INTEGRATIONS.UPDATE');
            self.actionButtonClass = 'md-primary';
          } else {
            self.actionName = $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORT');
            self.actionButtonClass = 'md-raised md-primary';
            self.archived = null;
          }
          self.isLoading = false;
        });
      } else {
        this.isLoading = false;
        this.actionName = $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORT');
        this.actionButtonClass = 'md-raised md-primary';
      }
    };

    CustomersImportManualItemViewModel.prototype.syncCustomer = function () {
      var self = this;
      var fieldCustomer = self.apiCustomer;
      this.isLoading = true;
      if (self.currentFieldCustomer) {
        fieldCustomer.id = self.currentFieldCustomer.id;
      }

      geoCoder.getByAddressObject(fieldCustomer.address).then(function (location) {
        var lat = location ? location.lat : null;
        var lng = location ? location.lng : null;

        fieldCustomer.address.coords.latitude = lat;
        fieldCustomer.address.coords.longitude = lng;
        fieldCustomer.externalAppId = self.appId;

        customersApi.save(fieldCustomer).then(function () {
          self.isLoading = false;
          self.actionCompleted = true;
        });
      });
    };

    return CustomersImportManualItemViewModel;
  }
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('CustomersImportManualDialog', CustomersImportManualDialog);

	/** @ngInject */
	function CustomersImportManualDialog($mdDialog, $document, $rootScope) {

		return {
			initCustomersImportManualDialog: initCustomersImportManualDialog,
		};

		function initCustomersImportManualDialog(event, appName) {
			$mdDialog.show({
				controller: 'CustomersImportManualDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/core/integrations/core/customers/dialogs/import/manual/customers-import-manual-dialog.html',
				parent: angular.element($document.body),
				targetEvent: event,
				clickOutsideToClose: false,
				locals: appName
			}).then(function () {
				$rootScope.$broadcast('customers:filter-updated');
			});
		}
	}

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('CustomersImportManualDialogController', CustomersImportManualDialogController);

  /** @ngInject */
  function CustomersImportManualDialogController(_, CustomersImportManualItemViewModel, appName, appId, $mdDialog, contaAzulApi, omieApi) {

    var vm = this;
    vm.searchText = '';
    vm.appId = appId;
    vm.searchCustomers = searchCustomers;
    vm.didMakeTheFirstSearch = false;
    vm.displayErrMessage = false;
    vm.displayKeyErrMessage = false;
    vm.closeDialog = closeDialog;
    vm.appName = appName;

    function closeDialog() {
      $mdDialog.hide();
    }

    function searchOmieCustomers() {
      var filter = {};
      if (vm.searchText[0] && parseInt(vm.searchText[0]) > 0 && vm.searchText[1] && parseInt(vm.searchText[1])) {
        filter = { cnpj_cpf: vm.searchText };
      } else {
        filter = { razao_social: vm.searchText };
      }

      return omieApi.customers.list({
        clientesFiltro: filter,
        pagina: 1,
        registros_por_pagina: 30,
        apenas_importado_api: 'N'
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.total_de_registros) {
          onSuccess();
          return response.data.clientes_cadastro.forEach(function (omieCustomer) {
            var extraData = {};
            vm.customersFound.push(new CustomersImportManualItemViewModel(omieCustomer, appName, extraData, vm.appId));
          });
        } else {
          return noResults();
        }
      }).catch(function (error) {
        if (error && error.data && error.data.faultstring) {
          var customersNotFound = error && error.data && error.data.faultstring.indexOf('ERROR: Não existem registros') !== -1;
          if (customersNotFound) {
            return noResults();
          } else if (_isKeyError(error)) {
            return _showOmieKeyError();
          }
        }
        return onError();
      });
    }

    function _isKeyError(error) {
      if (!error || !error.data || !error.data.faultcode || !error.data.faultstring) {
        return false;
      }
      var faultcode = error.data.faultcode === 'SOAP-ENV:Server';
      var faultstring = error.data.faultstring === 'A chave de acesso está inválida ou o aplicativo está suspenso.';

      return faultcode && faultstring;
    }

    function _showOmieKeyError() {
      vm.didMakeTheFirstSearch = true;
      vm.loadingCustomers = false;
      vm.displayErrMessage = false;
      vm.displayKeyErrMessage = true;
    }

    function noResults() {
      vm.didMakeTheFirstSearch = true;
      vm.loadingCustomers = false;
    }

    function searchContaAzulCustomers() {
      return contaAzulApi.customers.list({
        search: vm.searchText,
        size: 50
      }).then(function (contaAzulCustomers) {
        onSuccess();
        contaAzulCustomers.forEach(function (contaAzulCustomer) {
          return contaAzulApi.customers.contacts(contaAzulCustomer.id, {}).then(function (contaAzulCustomerContacts) {
            var extraData = { contaAzulCustomerContacts: contaAzulCustomerContacts };
            vm.customersFound.push(new CustomersImportManualItemViewModel(contaAzulCustomer, appName, extraData, vm.appId));
          }).catch(function () {
            var extraData = { contaAzulCustomerContacts: [] };
            vm.customersFound.push(new CustomersImportManualItemViewModel(contaAzulCustomer, appName, extraData, vm.appId));
          });
        });
      }).catch(function () {
        onError();
      });
    }

    function onSuccess() {
      vm.didMakeTheFirstSearch = true;
      vm.loadingCustomers = false;
      vm.displayErrMessage = false;
      vm.displayKeyErrMessage = false;
    }

    function onError() {
      vm.didMakeTheFirstSearch = true;
      vm.loadingCustomers = false;
      vm.displayErrMessage = true;
    }

    function searchCustomers() {
      vm.customersFound = [];
      if (vm.searchText.length === 0) {
        return null;
      }
      vm.loadingCustomers = true;

      if (appName === 'Conta Azul') {
        searchContaAzulCustomers();
      }

      if (appName === 'Omie') {
        searchOmieCustomers();
      }
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('CustomersImportAutomaticDialog', CustomersImportAutomaticDialog);

	/** @ngInject */
	function CustomersImportAutomaticDialog($mdDialog, $document, $rootScope, $mdToast, $translate, omieApi, FcModalService) {

		return {
			openConfirmDialog: openConfirmDialog,
			openCustomerImportAutomaticDialog: openCustomerImportAutomaticDialog
		};

		function openCustomerImportAutomaticDialog(appName, totalCustomersToImport, appId) {
			$mdDialog.show({
				controller: 'CustomersImportAutomaticDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/core/integrations/core/customers/dialogs/import/automatic/customers-import-automatic-dialog.html',
				parent: angular.element($document.body),
				clickOutsideToClose: false,
				locals: {
					appName: appName,
					totalCustomersToImport: totalCustomersToImport,
          appId: appId
				}
			}).then(function () {
				$rootScope.$broadcast('customers:filter-updated');
			});
		}

		function openConfirmDialog(event, appName) {
          FcModalService.open(event, {
            title: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.TITLE', { app: 'Omie' }),
            content: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.CONTENT', { quantity: 0 }),
            hasOmieAccountSelector: true,
            paddingSmall: true,
            leftButtonText: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.IMPORT_BUTTON'),
            rightButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
            handleLeftButton: function (omieAccount) {
              _getCustomersTotalsToImport(appName, omieAccount).then(function (totalCustomerToImport) {
                if (totalCustomerToImport && totalCustomerToImport > 0) {
                  openCustomerImportAutomaticDialog(appName, totalCustomerToImport, omieAccount.appId);
                } else {
                  _showErrorAndExit($translate.instant('CUSTOMERS.INTEGRATIONS.AUTOMATIC_IMPORT_ERROR_CANT_FIND_CUSTOMERS'));
                }
              }).catch(function (error) {
                _showErrorAndExit($translate.instant('CUSTOMERS.INTEGRATIONS.AUTOMATIC_IMPORT_ERROR_CANT_FIND_CUSTOMERS'));
              });
            }
        });
		}

		function _getOmieCustomerTotalsToImport(appId) {
			$rootScope.loadingProgress = true;
			return omieApi.customers.list({
				pagina: 1,
				registros_por_pagina: 1,
				apenas_importado_api: "N"
			}, appId).then(function (response) {
				$rootScope.loadingProgress = false;
				if (response.status === 200) {
					return response.data.total_de_registros;
				}
			});
		}

		function _getCustomersTotalsToImport(appName, account) {
			if (appName === 'Omie') {
				return _getOmieCustomerTotalsToImport(account.appId);
			}
		}

		function _showErrorAndExit(message, duration) {
			$rootScope.loadingProgress = false;
			if (!duration) {
				duration = 6000;
			}
			$mdToast.show(
				$mdToast.simple()
					.textContent(message)
					.hideDelay(duration)
			);
		}
	}

})();

(function () {
    'use strict';

    angular
      .module('app.core')
      .controller('CustomersImportAutomaticDialogController', CustomersImportAutomaticDialogController);

    /** @ngInject */
    function CustomersImportAutomaticDialogController($mdDialog, $rootScope, $timeout, $mdToast, $translate, locals, customersApi, omieApi, omieCustomerMapper, geoCoderApi) {

      var vm = this;
      vm.closeDialog = closeDialog;
      vm.appName = locals.appName;
      vm.totalCustomersToImport = locals.totalCustomersToImport;
      vm.appId = locals.appId;

      vm.totalCustomersImported = 0;
      vm.progressPercentage = 0;

      startImport();

      function startImport() {
        if (vm.appName === 'Omie') {
          startOmieImport();
        }
      }

      function startOmieImport() {
        $rootScope.loadingProgress = true;
        getOmieCustomers(1, vm.appId);
      }

      function getOmieCustomers(pagination, appId) {
        omieApi.customers.list({
          clientesFiltro: {},
          pagina: pagination,
          registros_por_pagina: 100,
          apenas_importado_api: "N"
        }, appId).then(function (response) {
          if(response.status !== 200) {
            toastAndExit($translate.instant('CUSTOMERS.INTEGRATIONS.AUTOMATIC_IMPORT_ERROR_IN_FINISH'), 8000);
            return;
          }
          if(response.data.total_de_registros > 10000) {
            toastAndExit($translate.instant('CUSTOMERS.INTEGRATIONS.AUTOMATIC_IMPORT_ERROR_LIMIT'), 8000);
            return;
          }
          var index = 0;
          response.data.clientes_cadastro.forEach(function (omieCustomer) {
            index++;

            var fieldCustomer = omieCustomerMapper.toFieldControl(omieCustomer);
            fieldCustomer.externalAppId = appId;
            saveCustomerInFieldControl(fieldCustomer);

            if (index === response.data.clientes_cadastro.length) {
              if (response.data.pagina < response.data.total_de_paginas) {
                getOmieCustomers(++pagination, vm.appId);
              }
            }
          });
        });
      }

      function saveCustomerInFieldControl(fieldCustomer) {
        getFieldControlCustomerByDocument(fieldCustomer.documentNumber).then(function (fieldCustomerId) {
          if (fieldCustomerId) {
            fieldCustomer.id = fieldCustomerId;
          }

          var address = fieldCustomer.address.formattedAddress + ', Brasil';
          return geoCoderApi.search({ 'q': address }).then(function (response) {
            if (response.status === 'OK' && response.results.length) {
              fieldCustomer.address.coords.latitude = response.results[0].geometry.location.lat;
              fieldCustomer.address.coords.longitude = response.results[0].geometry.location.lng;
            } else {
              fieldCustomer.address.coords.latitude = 0;
              fieldCustomer.address.coords.longitude = 0;
            }
            customersApi.save(fieldCustomer).then(function (customer) {
              if (customer.id) {
                customerHasImported();
              }
            });
          });
        });
      }

      function customerHasImported() {
        vm.totalCustomersImported++;
        vm.progressPercentage = (vm.totalCustomersImported * 100) / vm.totalCustomersToImport;

        if (vm.progressPercentage === 100) {
          $timeout(function () {
            toastAndExit(vm.totalCustomersImported + $translate.instant('CUSTOMERS.INTEGRATIONS.AUTOMATIC_IMPORT_SUCCESS_TOAST'), 8000);
          }, 500);
        }
      }

      function getFieldControlCustomerByDocument(document) {
        return customersApi.search({
          where: {
            documentNumber: document
          },
          take: 1
        }).then(function (result) {
          if (result && result.items && result.items.length) {
            return result.items[0].id;
          } else {
            return null;
          }
        });
      }

      function toastAndExit(message, duration) {
        closeDialog();
        $rootScope.loadingProgress = false;
        if (!duration) {
          duration = 6000;
        }
        $mdToast.show(
          $mdToast.simple()
            .textContent(message)
            .hideDelay(duration)
        );
      }

      function closeDialog() {
        $mdDialog.hide();
      }
    }
  })();

(function () {
  'use strict';

  angular
    .module('app.tasks', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {

    $stateProvider
      .state('app.tasks', {
        url: '/atividades',
        views: {
          'content@app': {
            templateUrl: 'app/main/tasks/tasks.html',
            controller: 'TasksController as vm'
          }
        },
        data: { titleTranslateKey: 'TASKS.PAGE_TITLE' },
        resolve: {
          employees: function (employeesApi) {
            return employeesApi.getAll();
          },
          services: function (servicesApi) {
            return servicesApi.getAll();
          },
          account: function (accountsApi) {
            return accountsApi.get();
          }
        }
      });

    $translatePartialLoaderProvider.addPart('app/main/tasks');
  }
})();
(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('ListFilterSidenavController', ListFilterSidenavController);

  /** @ngInject */
  function ListFilterSidenavController($rootScope, $translate, $scope, $mdDialog, $document, $mdToast, tasksApi, TasksFiltersService) {
    var vm = this;
    vm.customFilters = [];
    vm.defaultFilters = [
      {
        icon: 'icon-clipboard-alert',
        name: $translate.instant('TASKS.SIDENAV.CUSTOM_FILTERS.LIST.DEFAULT.FILTERS.OUT_OF_TIME'),
        searchValues: {
          activitiesDateToView: new Date(),
          activitiesDateFromView: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
          activitiesDateDeadlineFrom: null,
          activitiesDateDeadlineTo: new Date(),
          status: [
            "scheduled",
            "in-progress"
          ]
        }
      },
      {
        icon: 'icon-account-alert',
        name: $translate.instant('TASKS.SIDENAV.CUSTOM_FILTERS.LIST.DEFAULT.FILTERS.WITHOUT_EMPLOYEE'),
        searchValues: {
          employees: ['null']
        }
      },
      {
        icon: 'icon-calendar-remove',
        name: $translate.instant('TASKS.SIDENAV.CUSTOM_FILTERS.LIST.DEFAULT.FILTERS.UNFINISHED_FROM_PAST'),
        searchValues: {
          activitiesDateToView: new Date(),
          activitiesDateFromView: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
          status: [
            "scheduled",
            "in-progress"
          ]
        }
      }
    ];

    vm.selectFilter = selectFilter;
    vm.updateToArchived = updateToArchived;

    tasksApi.getFilters().then(function (result) {
      vm.customFilters = result.items;
    });

    $scope.$on('update-tasks-list', function (event, data) {
      if (data.method) {
        var filterToUpdate = _.find(vm.customFilters, function (filter) {
          return filter.id === data.filter.id;
        });

        filterToUpdate.name = data.filter.name;
        filterToUpdate.searchValues = data.filter.searchValues;
      } else {
        vm.customFilters.push(data.filter);
      }

      $rootScope.$broadcast('tasks-list:saved-filter-selected');
    });

    function selectFilter(filter) {
      var searchValues = filter.searchValues;
      for (var property in searchValues) {
        TasksFiltersService[property] = searchValues[property];
      }
      $rootScope.selectedCustomFilter = {};
      if (filter.id) { $rootScope.selectedCustomFilter = filter; }
      $rootScope.$broadcast('tasks-list:saved-filter-selected');
    }

    function updateToArchived(event, filter) {
      var confirm = $mdDialog.confirm({
        title: $translate.instant('TASKS.SIDENAV.CUSTOM_FILTERS.LIST.REMOVE_DIALOG.TITLE'),
        parent: $document.find('#default-list'),
        textContent: $translate.instant('TASKS.SIDENAV.CUSTOM_FILTERS.LIST.REMOVE_DIALOG.CONTENT', { filterName: filter.name }),
        ariaLabel: $translate.instant('TASKS.SIDENAV.CUSTOM_FILTERS.LIST.REMOVE_DIALOG.TITLE'),
        targetEvent: event,
        clickOutsideToClose: false,
        escapeToClose: false,
        ok: $translate.instant('TASKS.SIDENAV.CUSTOM_FILTERS.LIST.REMOVE_DIALOG.OK'),
        cancel: $translate.instant('TASKS.SIDENAV.CUSTOM_FILTERS.LIST.REMOVE_DIALOG.CANCEL')
      });

      $mdDialog.show(confirm).then(function () {
        tasksApi.updateToArchived(filter.id).then(function () {
          vm.customFilters = _.reject(vm.customFilters, function (customFilter) { return customFilter.id === filter.id; });
          TasksFiltersService.clear();
          $rootScope.selectedCustomFilter = {};

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('TASKS.TOASTS.FILTERS.CUSTOM_FILTER_DELETED', { filterName: filter.name }))
              .hideDelay(3000)
          );
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('CustomFilterSidenavController', CustomFilterSidenavController);

  /** @ngInject */
  function CustomFilterSidenavController($rootScope, $scope, $mdToast, $translate, tasksApi, TasksFiltersService) {
    var vm = this;

    vm.filter = {};
    vm.action = 'new';

    vm.saveFilter = saveFilter;
    vm.setFilterNames = setFilterNames;

    $scope.$on('returning-to-filter-main-page', function () {
      cleanFilterNames();
      vm.action = 'new';
    });

    function saveFilter(method) {
      if (method === 'edit') {
        vm.filter.id = $rootScope.selectedCustomFilter.id;
      }

      vm.filter.searchValues = JSON.stringify(angular.copy(TasksFiltersService));
      vm.filter.name = vm.filter.newName || vm.filter.editName;

      tasksApi.saveFilter(vm.filter).then(function (filter) {
        cleanFilterNames();
        vm.action = 'new';
        $rootScope.selectedCustomFilter = filter;
        $rootScope.$broadcast('update-tasks-list', {
          method: method,
          filter: filter
        });

        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('TASKS.TOASTS.FILTERS.CUSTOM_FILTER_SAVED', { filterName: filter.name }))
            .hideDelay(3000)
        );
      });
    }

    function cleanFilterNames() {
      vm.filter.newName = '';
      vm.filter.editName = '';
    }

    function setFilterNames() {
      cleanFilterNames();
      if (vm.action === 'edit') { vm.filter.editName = $rootScope.selectedCustomFilter.name; }
    }
  }
})();

(function ()
{
  'use strict';

  angular
  .module('app.modules', [])
  .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider)
  {
    $stateProvider.state('app.modules', {
      url    : '/modulos',
      params: {
        configurationKey: null
      },
      views  : {
        'content@app': {
          templateUrl: 'app/main/modules/modules.html',
          controller : 'ModulesController as vm'
        }
      },
      data: {titleTranslateKey: 'MODULES.PAGE_TITLE'},
      resolve: {
        Account: function (accountsApi) {
          return accountsApi.get();
        },
        FeatureFlags: function (accountFeatureFlagsApiGraphQL) {
          return accountFeatureFlagsApiGraphQL.accountFeatureFlags();
        }
      }
    });

    $translatePartialLoaderProvider.addPart('app/main/modules');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/customers-area');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/route-optimizer');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/equipments');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/image-resolution');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/materials');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/route-optimizer');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/tickets');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/videos');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/print-configuration');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/tasks-plans');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/vehicles');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/deadlines');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/storage-control');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/smart-rewrite');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/territories');
    $translatePartialLoaderProvider.addPart('app/main/modules/sidenavs/templates');
  }

})();

(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('OmieAppController', OmieAppController);

  /** @ngInject */
  function OmieAppController(
    $translate, $mdToast, $mdDialog, $window, FcToastService, $timeout,
    Account, Configuration, newIntegration, IntegrationsService, FcModalService,
    accountsApi, omieApi, _, $q, $scope, $rootScope
  ) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.configuration = Configuration;
    vm.isNewIntegration = newIntegration;

    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;

    vm.accounts = [{
      name: null,
      key: null,
      secret: null,
      new: true
    }];

    var deferred = $q.defer();

    omieApi.accounts.list()
      .then(function (res) {

        if (!res.data || !res.data.Items || !res.data.Items.length) {
          deferred.resolve([{
            name: null,
            key: null,
            secret: null,
            new: true
          }]);
          return;
        }

        var accounts = res.data.Items.map(function (item) {
          return {
            name: item.accountName,
            key: item.appId,
            secret: item.appSecret,
            new: false
          };
        });

        deferred.resolve(accounts);
      })
      .catch(function (error) {
        console.error('Error fetching accounts:', error);
        deferred.reject(error);
      });

    deferred.promise.then(function (accounts) {
      vm.accounts = accounts;
    });

    vm.save = save;
    vm.addAccount = addAccount;
    vm.removeAccount = removeAccount;
    vm.focusInLastItem = focusInLastItem;
    vm.enableIntegration = enableIntegration;
    vm.disableApp = disableApp;
    vm.closeDialog = closeDialog;

    vm.hasValidAppKeys = true;

    vm.changedAppKey = changedAppKey;
    vm.changedAppName = changedAppName;
    vm.validatedAppKeys = validatedAppKeys;

    function changedAppKey(index) {
      var existingKeys = _.map(vm.accounts.slice(0, index), 'key');

      if (_.includes(existingKeys, vm.accounts[index].key)) {
        $scope.omieForm['key' + index].$setValidity('duplicate', false);
      } else {
        $scope.omieForm['key' + index].$setValidity('duplicate', true);
      }

      validatedAppKeys();
    }

    function changedAppName(index) {
        var existingNames = _.map(vm.accounts.slice(0, index), 'name');

        if (_.includes(existingNames, vm.accounts[index].name)) {
          $scope.omieForm['name' + index].$setValidity('duplicate', false);
        } else {
          $scope.omieForm['name' + index].$setValidity('duplicate', true);
        }

        validatedAppKeys();
    }

    function validatedAppKeys() {
      _.forEach(vm.accounts, function (account) {

        if (!account.secret  || !account.key) {
          vm.hasValidAppKeys = false;
          return;
        }

        if (account.key.length >= 10 && account.secret.length >= 32) {
          vm.hasValidAppKeys = true;
        } else {
          vm.hasValidAppKeys = false;
        }
      });
    }

    function removeAccount(account, index) {
      FcModalService.open(null, {
        title: $translate.instant('APPS.OMIE.ACCOUNTS.DELETE.TITLE'),
        content: $translate.instant('APPS.OMIE.ACCOUNTS.DELETE.DESCRIPTION', {
          account: account.name || index + 1
        }),
        leftButtonText: $translate.instant('APPS.OMIE.ACCOUNTS.DELETE.YES'),
        rightButtonText: $translate.instant('APPS.OMIE.ACCOUNTS.DELETE.NO'),
        handleLeftButton: function () {
          omieApi.accounts.delete(account.key).then(function () {
            vm.accounts.splice(index, 1);
            FcToastService.addWarning({
              hideDelay: 2000,
              position: 'BOTTOM LEFT',
              success: true,
              title: $translate.instant('APPS.OMIE.ACCOUNTS.DELETE.TOAST', {
                account: account.name || index + 1
              }),
              iconPath: 'assets/icons/success-icon.svg',
              noExit: true
            });
          });
        }
      });
    };

    function addAccount() {
      vm.accounts.push({
        name: null,
        key: null,
        secret: null,
        new: true
      });

      vm.focusInLastItem();
    };

    function enableIntegration() {
      closeDialog();
      $rootScope.loadingProgress = true;

      _.forEach(vm.accounts, function (account) {
        var data = {
          accountName: account.name,
          appKey: account.key,
          appSecret: account.secret,
          appId: account.key
        };

        IntegrationsService.activate('omie', data).then(function () {
          $mdToast.show(
            $mdToast.simple().textContent(
              $translate.instant('CUSTOMERS.INTEGRATIONS.SUCCESS_WHEN_ACTIVATING',
                { app: 'Omie' })
            ).hideDelay(2000)
          );
          $timeout(function () {
              $window.location.reload(true);
          }, 1500);
        }).catch(function () {
          $mdToast.show(
            $mdToast.simple().textContent(
              $translate.instant('CUSTOMERS.INTEGRATIONS.ERROR_WHEN_ACTIVATING',
                { app: 'Omie' })
            ).hideDelay(2000)
          );
        });
      });
    }

    function focusInLastItem() {
      setTimeout(function () {
        var elements = document.getElementsByClassName('fc-input__input');
        var index = elements.length - 3;
        if (index >= 0 && elements.item(index)) {
          elements.item(index).focus();
        }
      }, 250);
    };

    function checkForDuplicates() {
      var hasDuplicates = false;

      _.forEach(vm.accounts, function (account, index) {
        var existingNames = _.map(vm.accounts.slice(0, index), 'name');
        var existingKeys = _.map(vm.accounts.slice(0, index), 'key');

        if (_.includes(existingNames, account.name)) {
          $scope.omieForm['name' + index].$setValidity('duplicate', false);
          hasDuplicates = true;
        }
        if (_.includes(existingKeys, account.key)) {
          $scope.omieForm['key' + index].$setValidity('duplicate', false);
          hasDuplicates = true;
        }
      });

      return hasDuplicates;
    }

    function save() {
      if (checkForDuplicates()) {
        return;
      }

      omieApi.accounts.saveAccounts(vm.accounts);

      accountsApi.saveConfigurations(vm.account.configuration).then(function () {
        FcToastService.addWarning({
          hideDelay: 2900,
          position: 'BOTTOM LEFT',
          success: true,
          title: $translate.instant('APPS.TOAST_SUCCESS'),
          iconPath: 'assets/icons/icon-success-circle-green.svg',
          noExit: true
        });

        closeDialog();

        $timeout(function () {
          $window.location.reload(true);
        }, 3000);
      }).catch(function () {
        var message = $translate.instant('APPS.ERROR_WHEN_SAVING', { app: 'Omie' });
        var toast = $mdToast.simple().textContent(message).hideDelay(3000);
        $mdToast.show(toast);
        vm.disableButton = false;
      });
    }

    function disableApp($event) {
      vm.disableButton = true;

      FcModalService.open($event, {
        title: $translate.instant('APPS.DISABLE_DIALOG.TITLE'),
        content: $translate.instant('APPS.DISABLE_DIALOG.TEXT'),
        leftButtonText: $translate.instant('APPS.DISABLE_DIALOG.NO'),
        rightButtonText: $translate.instant('APPS.DISABLE_DIALOG.YES'),
        handleRightButton: _disableOmie,
        handleLeftButton: function () {
          vm.disableButton = false;
        }
      });
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function _disableOmie() {
      IntegrationsService.deactivate('omie').then(function () {
        var message = $translate.instant('APPS.SUCCESS_WHEN_DISABLING', { app: 'Omie' });
        var toast = $mdToast.simple().textContent(message).hideDelay(3000);
        $mdToast.show(toast);

        $timeout(function () {
          $window.location.reload(true);
        }, 2000);
      }).catch(function () {
        var message = $translate.instant('APPS.ERROR_WHEN_DISABLING', { app: 'Omie' });
        var toast = $mdToast.simple().textContent(message).hideDelay(3000);
        $mdToast.show(toast);
        vm.disableButton = false;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('ContaAzulAppController', ContaAzulAppController);

  /** @ngInject */
  function ContaAzulAppController(
    $translate, $mdToast, $mdDialog, $window, $timeout,
    Account, Configuration, IntegrationsService, FcModalService
  ) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;

    vm.disableApp = disableApp;
    vm.closeDialog = closeDialog;

    function disableApp($event) {
      vm.disableButton = true;

      FcModalService.open($event, {
        title: $translate.instant('APPS.DISABLE_DIALOG.TITLE'),
        content: $translate.instant('APPS.DISABLE_DIALOG.TEXT'),
        leftButtonText: $translate.instant('APPS.DISABLE_DIALOG.NO'),
        rightButtonText: $translate.instant('APPS.DISABLE_DIALOG.YES'),
        handleRightButton: _disableContaAzul,
        handleLeftButton: function () {
          vm.disableButton = false;
        }
      });
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function _disableContaAzul() {
      IntegrationsService.deactivate('conta-azul').then(function () {
        var message = $translate.instant('APPS.SUCCESS_WHEN_DISABLING', { app: 'Conta Azul' });
        var toast = $mdToast.simple().textContent(message).hideDelay(3000);
        $mdToast.show(toast);

        $timeout(function () {
          $window.location.reload(true);
        }, 2000);
      }).catch(function () {
        var message = $translate.instant('APPS.ERROR_WHEN_DISABLING', { app: 'Conta Azul' });
        var toast = $mdToast.simple().textContent(message).hideDelay(3000);
        $mdToast.show(toast);
        vm.disableButton = false;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('SelectExpenseController', SelectExpenseController);

  /** @ngInject */
  function SelectExpenseController(
    $rootScope, $mdDialog, ExpensesApi
  ) {

    var vm = this;
    vm.closeDialog = closeDialog;
    vm.expenses = [];
    vm.expenseName = '';
    vm.searchExpenses = searchExpenses;
    vm.selectExpense = selectExpense;
    vm.selectedExpense = null;

    function closeDialog() {
      $mdDialog.hide();
    }

    function searchExpenses() {
      $rootScope.loadingProgress = true;
      ExpensesApi.search({ name: vm.expenseName })
        .then(function (response) {
          vm.expenses = response.items.map(function (item) {
            return {
              id: item.id,
              value: item,
            };
          });
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function selectExpense() {
      $mdDialog.hide(vm.selectedExpense);
    }

    searchExpenses();
  }
})();

(function () {
  'use strict';

  angular.module('app.modules')
      .factory('CustomersAreaCustomersModuleService', CustomersAreaCustomersModuleService);

  /** @ngInject */
  function CustomersAreaCustomersModuleService(customersApi, warg2OrganizationsApi, $rootScope, $mdToast, $translate) {

    return {
      loadCustomers: loadCustomers,
      activateCustomer: activateCustomer
    };

    function loadCustomers(name) {
      return customersApi.search({
        where: {
          nameContains: name || undefined,
          archived: false
        },
        take: 20
      });
    }

    function activateCustomer(customer) {
      $rootScope.loadingProgress = true;

      function _onSuccess(response) {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.ACTIVATE_CUSTOMER.SUCCESS"))
            .hideDelay(2000)
        );

        return warg2OrganizationsApi.getOrganization(response.id)
          .then(function (response) {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.ACTIVATE_CUSTOMER.SUCCESS"))
                .hideDelay(2000)
            );

            return response;
          })
          .catch(_onCatch);
      }

      function _onCatch() {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.ACTIVATE_CUSTOMER.ERROR"))
            .theme('error-toast')
            .hideDelay(2000)
        );

        return false;
      }

      function _onFinally() {
        $rootScope.loadingProgress = false;
      }

      return warg2OrganizationsApi.getOrganization(customer._id)
        .then(function (response) {
          if (_.isEmpty(response)) {
            return warg2OrganizationsApi.createOrganization(customer)
              .then(_onSuccess)
              .catch(_onCatch)
              .finally(_onFinally);
          } else {
            return warg2OrganizationsApi.updateOrganization(customer, true)
              .then(_onSuccess)
              .catch(_onCatch)
              .finally(_onFinally);
          }
        })
        .catch(_onCatch);
    }
  }
})();


(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('customersAreaCustomersTab', customersAreaCustomersTab);

  /** @ngInject */
  function customersAreaCustomersTab()
  {
    return {
      restrict: 'E',
      scope: {
        settings: '=',
        changeTab: '&'
      },
      templateUrl: 'app/main/modules/sidenavs/customers-area/tabs/customers/customers.html',
      controller: 'CustomersAreaCustomersTabController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('CustomersAreaCustomersTabController', CustomersAreaCustomersTabController);

  /** @ngInject */
  function CustomersAreaCustomersTabController($scope, CustomersAreaCustomersModuleService, CustomersAreaModuleService, $mdDialog, $translate) {
    var vm = this;
    vm.changeTab = $scope.changeTab;
    vm.customers = [];

    vm.searchCustomersInput = '';
    vm.customersLoading = false;

    vm.searchCustomers = searchCustomers;
    vm.activateCustomer = activateCustomer;

    _initialize();

    function _initialize() {
      vm.customersLoading = true;

      CustomersAreaCustomersModuleService.loadCustomers()
        .then(function (customersResponse) {
          vm.customers = customersResponse.items;
          vm.customersLoading = false;

          _checkActivatedCustomersArea();
        });
    }

    function _checkActivatedCustomersArea() {
      CustomersAreaModuleService.loadActiveOrganizations()
        .then(function (activeOrganizations) {
          var activeCustomers = activeOrganizations;

          if (activeCustomers.length) {
            vm.customers.forEach(function (customer) {
              customer.isAreaActivated = _.some(activeCustomers, function (activeCustomer) {
                return customer._id === activeCustomer.id;
              });
            });
          }
        });
    }

    function searchCustomers() {
      vm.customersLoading = true;

      CustomersAreaCustomersModuleService.loadCustomers(vm.searchCustomersInput)
        .then(function (customersResponse) {
          vm.customers = customersResponse.items;
          vm.customersLoading = false;

          _checkActivatedCustomersArea();
        });
    }

    function activateCustomer(customer) {
      var confirm = $mdDialog.confirm({ multiple: true })
          .title($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.ACTIVATE_CUSTOMER.TITLE"))
          .htmlContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.ACTIVATE_CUSTOMER.MESSAGE", {
              name: customer.name
          }))
          .ok($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.ACTIVATE_CUSTOMER.OK"))
          .cancel($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.ACTIVATE_CUSTOMER.CANCEL"));

      $mdDialog.show(confirm).then(function () {
        CustomersAreaCustomersModuleService.activateCustomer(customer)
          .then(function (response) {
            vm.changeTab({ tabIndex: 2, activeCustomer: response });
          });
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.modules')
      .factory('CustomersAreaCustomerModuleService', CustomersAreaCustomerModuleService);

  /** @ngInject */
  function CustomersAreaCustomerModuleService(servicesApi, warg2OrganizationsApi, warg2UsersApi, warg2ServicesApi, $rootScope, $mdToast, $translate) {

    return {
      getServices: getServices,
      loadUsers: loadUsers,
      getUser: getUser,
      deactivateCustomer: deactivateCustomer,
      deactivateUser: deactivateUser,
      activateUser: activateUser,
      sendUserInvitation: sendUserInvitation,
      syncServices: syncServices
    };

    function getServices() {
      return servicesApi.getAll().then(function (result) {
        return result.items.map(function (service) {
          return {
            id: service._id,
            name: service.description,
            archived: service.archived
          };
        });
      });
    }

    function loadUsers(customer) {
      return warg2UsersApi.getUsers({
        organizationId: customer.id
      }, 1000, 0);
    }

    function getUser(email) {
      return warg2UsersApi.getUser(email);
    }

    function deactivateCustomer(customer) {
      $rootScope.loadingProgress = true;

      return warg2OrganizationsApi.updateOrganization(customer, false)
        .then(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_CUSTOMER.SUCCESS"))
              .hideDelay(2000)
          );
        })
        .catch(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_CUSTOMER.ERROR"))
              .theme('error-toast')
              .hideDelay(2000)
          );
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function deactivateUser(user, organizationId) {
      $rootScope.loadingProgress = true;

      return warg2UsersApi.updateUser(user, organizationId, false)
        .then(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_USER.SUCCESS"))
              .hideDelay(2000)
          );
        })
        .catch(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_USER.ERROR"))
              .theme('error-toast')
              .hideDelay(2000)
          );
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function activateUser(user, organizationId) {
      $rootScope.loadingProgress = true;

      return warg2UsersApi.updateUser(user, organizationId, true)
        .then(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_USER.SUCCESS"))
              .hideDelay(2000)
          );
        })
        .catch(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_USER.ERROR"))
              .theme('error-toast')
              .hideDelay(2000)
          );
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function sendUserInvitation(user, customer) {
      $rootScope.loadingProgress = true;

      return warg2UsersApi.sendUserInvitation(user.name, user.email, customer.id)
        .catch(function (error) {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.ERRORS.INVITE"))
              .theme('error-toast')
              .hideDelay(2000)
          );

          return { isError: true, error: error };
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function syncServices(servicesToActivate, customerId) {
      $rootScope.loadingProgress = true;

      return warg2ServicesApi.syncServices(
        servicesToActivate,
        customerId
      ).then(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.SAVE_SUCCESS"))
            .hideDelay(2000)
        );
      })
      .catch(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.SAVE_ERROR"))
            .theme('error-toast')
            .hideDelay(2000)
        );
      })
      .finally(function () {
        $rootScope.loadingProgress = false;
      });
    }
  }
})();


(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('customersAreaCustomerTab', customersAreaCustomerTab);

  /** @ngInject */
  function customersAreaCustomerTab()
  {
    return {
      restrict   : 'E',
      scope      : {
        settings: '=',
        changeTab: '&',
        form: '=',
        saveCustomer: '='
      },
      templateUrl: 'app/main/modules/sidenavs/customers-area/tabs/customer/customer.html',
      controller: 'CustomersAreaCustomerTabController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('CustomersAreaCustomerTabController', CustomersAreaCustomerTabController);

  /** @ngInject */
  function CustomersAreaCustomerTabController($scope, CustomersAreaCustomerModuleService, $mdDialog, $mdToast, $translate) {
    var vm = this;
    vm.changeTab = $scope.changeTab;
    vm.customer = $scope.settings.customer;
    $scope.saveCustomer = saveCustomer;

    vm.services = [];
    vm.activeTab = 0;
    vm.usersLoading = false;
    vm.users = [];
    vm.archivedUsers = [];
    vm.disableUserButton = false;
    vm.noUserActive = false;
    vm.searchUsers = '';
    vm.searchArchivedUsers = '';

    vm.newUser = {
      email: ''
    };

    vm.deactivateCustomer = deactivateCustomer;
    vm.deactivateUser = deactivateUser;
    vm.activateUser = activateUser;
    vm.sendUserInvitation = sendUserInvitation;
    vm.resendUserInvitation = resendUserInvitation;
    vm.goBack = goBack;
    vm.reloadUsers = reloadUsers;
    vm.isActivated = isActivated;

    _initialize();

    function _initialize() {
      CustomersAreaCustomerModuleService.getServices().then(function (response) {
        vm.services = response;
      });
    }

    function deactivateCustomer() {
      var confirm = $mdDialog.confirm({ multiple: true })
          .title($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_CUSTOMER.TITLE"))
          .htmlContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_CUSTOMER.MESSAGE", {
              name: vm.customer.name
          }))
          .ok($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_CUSTOMER.OK"))
          .cancel($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_CUSTOMER.CANCEL"));

      $mdDialog.show(confirm).then(function () {
        CustomersAreaCustomerModuleService.deactivateCustomer(vm.customer).then(function () {
          vm.changeTab({ tabIndex: 0 });
        });
      });
    }

    function deactivateUser(user) {
      var confirm = $mdDialog.confirm({ multiple: true })
          .title($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_USER.TITLE"))
          .htmlContent($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_USER.MESSAGE", {
              name: user.name
          }))
          .ok($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_USER.OK"))
          .cancel($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.DEACTIVATE_USER.CANCEL"));

      $mdDialog.show(confirm).then(function () {
        CustomersAreaCustomerModuleService.deactivateUser(user, vm.customer.id).then(function () {
          _loadUsers();

          vm.searchUsers = '';
          vm.searchArchivedUsers = '';
        });
      });
    }

    function activateUser(user) {
      var confirm = $mdDialog.confirm({ multiple: true })
          .title($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE.TITLE"))
          .htmlContent($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE.MESSAGE", {
              name: vm.customer.name
          }))
          .ok($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE.OK"))
          .cancel($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE.CANCEL"));

      return $mdDialog.show(confirm).then(function () {
        CustomersAreaCustomerModuleService.activateUser(user, vm.customer.id).then(function () {
          _loadUsers();

          vm.searchUsers = '';
          vm.searchArchivedUsers = '';
        });
      });
    }

    function sendUserInvitation() {
      vm.disableUserButton = true;

      CustomersAreaCustomerModuleService.getUser(vm.newUser.email).then(function (response) {
        var onFinally = function () {
          vm.disableUserButton = false;
        };

        if (response && response.organizations && response.organizations.length) {
          var currentOrganization = _.find(response.organizations, { organization_id: vm.customer.id });

          if (currentOrganization && currentOrganization.id) {
            if (currentOrganization.active) {
              _userAlreadyActive().finally(onFinally);
            } else if (response.invites && response.invites.length) {
              var inviteFromCurrentOrganization = _.find(response.invites, { organizationId: currentOrganization.organization_id });

              if (inviteFromCurrentOrganization  && !inviteFromCurrentOrganization.activatedAt) {
                _userWaitingInvite().finally(onFinally);
              } else {
                _sendInviteToUser();
              }
            } else {
              _activateUserExistentSameOrganization(response).then(function () {
                vm.activeTab = 0;

                vm.newUser.email = '';

                $scope.newUserForm.$setPristine();
                $scope.newUserForm.$setUntouched();

                _loadUsers();
              }).finally(onFinally);
            }
          } else {
            _sendInviteToUser();
          }
        } else {
          _sendInviteToUser();
        }
      });
    }

    function resendUserInvitation(user) {
      var confirm = $mdDialog.confirm({ multiple: true })
          .title($translate.instant("CUSTOMERS_AREA_MODULE.USERS.RESEND_USER_INVITATION.TITLE"))
          .htmlContent($translate.instant("CUSTOMERS_AREA_MODULE.USERS.RESEND_USER_INVITATION.MESSAGE", {
            email: user.email
          }))
          .ok($translate.instant("CUSTOMERS_AREA_MODULE.USERS.RESEND_USER_INVITATION.OK"))
          .cancel($translate.instant("CUSTOMERS_AREA_MODULE.USERS.RESEND_USER_INVITATION.CANCEL"));

      return $mdDialog.show(confirm).then(function () {
        CustomersAreaCustomerModuleService.sendUserInvitation(user, vm.customer)
          .then(function (response) {
            if (!response.isError) {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($translate.instant("CUSTOMERS_AREA_MODULE.USERS.RESEND_USER_INVITATION.SUCCESS"))
                  .hideDelay(2000)
              );
            }
          });
      });
    }

    function goBack() {
      vm.activeTab = 0;
      vm.newUser.email = '';

      $scope.newUserForm.$setPristine();
      $scope.newUserForm.$setUntouched();
    }

    function saveCustomer() {
      $scope.$parent.vm.disableButton = true;

      CustomersAreaCustomerModuleService.syncServices(
        vm.customer.services,
        vm.customer.id
      ).then(function () {
        $scope.customerForm.$setPristine();
        $scope.customerForm.$setUntouched();
      })
      .finally(function () {
        $scope.$parent.vm.disableButton = false;
      });
    }

    function reloadUsers() {
      _loadUsers();
    }

    function _loadUsers() {
      vm.usersLoading = true;
      CustomersAreaCustomerModuleService.loadUsers(vm.customer).then(function (users) {
        users.forEach(function (user) {
          user.currentOrganization = user.organizations.find(function (organization) {
            if(organization.organization_id === vm.customer.id ){
              return true;
            };
          });
        });

        vm.users = users.filter(function (user) {
          if(user.currentOrganization && user.currentOrganization.active === true) {
            return user;
          }
        });

        vm.archivedUsers = users.filter(function (user) {
          if(user.currentOrganization && user.currentOrganization.active === false) {
            return user;
          }
        });

        if (!vm.users.length) {
          vm.noUserActive = true;
        } else {
          vm.noUserActive = false;
        }

        vm.usersLoading = false;
      });
    }

    function _activateUserExistentSameOrganization(user) {
      var confirm = $mdDialog.confirm({ multiple: true })
          .title($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_EXISTENT_SAME_ORGANIZATION.TITLE"))
          .htmlContent($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_EXISTENT_SAME_ORGANIZATION.MESSAGE", {
              name: vm.customer.name
          }))
          .ok($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_EXISTENT_SAME_ORGANIZATION.OK"))
          .cancel($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_EXISTENT_SAME_ORGANIZATION.CANCEL"));

      return $mdDialog.show(confirm).then(function () {
        CustomersAreaCustomerModuleService.activateUser(user).then(function () {
          _loadUsers();
        });
      });
    }

    function _sendInviteToUser() {
      CustomersAreaCustomerModuleService.sendUserInvitation(vm.newUser, vm.customer)
      .then(function () {
        vm.activeTab = 2;

        vm.newUser.email = '';

        $scope.newUserForm.$setPristine();
        $scope.newUserForm.$setUntouched();

        _loadUsers();
      }).finally(vm.disableUserButton = false);
    }

    function _userAlreadyActive() {
      return $mdDialog.show(
        $mdDialog.alert({ multiple: true })
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_ALREADY_ACTIVE.TITLE"))
            .textContent($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_ALREADY_ACTIVE.MESSAGE"))
            .ok($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_ALREADY_ACTIVE.OK"))
      );
    }

    function _userWaitingInvite() {
      var confirm = $mdDialog.confirm({ multiple: true })
          .title($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_WAITING_INVITE.TITLE"))
          .textContent($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_WAITING_INVITE.MESSAGE"))
          .ok($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_WAITING_INVITE.OK"))
          .cancel($translate.instant("CUSTOMERS_AREA_MODULE.USERS.ACTIVATE_WAITING_INVITE.CANCEL"));

      return $mdDialog.show(confirm).then(function () {
        CustomersAreaCustomerModuleService.sendUserInvitation(vm.newUser, vm.customer)
          .then(function () {
            vm.activeTab = 2;

            vm.newUser.email = '';

            $scope.newUserForm.$setPristine();
            $scope.newUserForm.$setUntouched();
          });
      });
    }

    function isActivated(user) {
      if (!user || !user.organizations || !user.organizations.length) {
        return;
      }

      return _.some(user.organizations, function (organization) {
        return organization.organization_id === vm.customer.id && organization.active;
      });
    }

    $scope.$watch('customerForm', function (customerForm) {
      $scope.form = customerForm;
    });

    $scope.$watch('settings', function () {
      vm.customer = $scope.settings.customer;

      if (!_.isEmpty(vm.customer)) {
        $scope.customerForm.$setPristine();
        $scope.customerForm.$setUntouched();

        _loadUsers();

        vm.searchUsers = '';
        vm.searchArchivedUsers = '';
      }
    });
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('customersAreaActiveCustomersTab', customersAreaActiveCustomersTab);

  /** @ngInject */
  function customersAreaActiveCustomersTab()
  {
    return {
      restrict   : 'E',
      scope      : {
        settings: '=',
        changeTab: '&',
        editCustomer: '&',
        syncCustomer: '&'
      },
      templateUrl: 'app/main/modules/sidenavs/customers-area/tabs/active-customers/active-customers.html',
      controller: 'CustomersAreaActiveCustomersTabController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('CustomersAreaActiveCustomersTabController', CustomersAreaActiveCustomersTabController);

  /** @ngInject */
  function CustomersAreaActiveCustomersTabController($scope) {
    var vm = this;
    vm.changeTab = $scope.changeTab;
    vm.editCustomer = $scope.editCustomer;
    vm.syncCustomer = $scope.syncCustomer;
    vm.activeCustomers = $scope.settings.activeCustomers;
    vm.activeCustomersLoading = $scope.settings.activeCustomersLoading;
    vm.noActiveCustomers = $scope.settings.noActiveCustomers;

    $scope.$watch('settings', function () {
      vm.activeCustomers = $scope.settings.activeCustomers;
      vm.activeCustomersLoading = $scope.settings.activeCustomersLoading;
      vm.noActiveCustomers = $scope.settings.noActiveCustomers;
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.control-panel', [
      'gantt',
      'gantt.sortable',
      'gantt.movable',
      'gantt.drawtask',
      'gantt.tooltips',
      'gantt.bounds',
      'gantt.progress',
      'gantt.table',
      'gantt.tree',
      'gantt.groups',
      'gantt.dependencies',
      'gantt.overlap',
      'ngAnimate',
      'gantt.resizeSensor'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
    $stateProvider

      .state('app.control-panel', {
        abstract: true,
        url: '/painel-de-controle',
        bodyClass: 'scrumboard',
        data: { titleTranslateKey: 'CONTROL_PANEL.PAGE_TITLE' },
        resolve: {
          Account: function (accountsApi) {
            return accountsApi.get();
          }
        }
      })

      .state('app.control-panel.main', {
        url: '/',
        views: {
          'content@app': {
            templateUrl: 'app/main/control-panel/views/main/main.html',
            controller: 'ControlPanelMainController as vm'
          }
        }
      })

      .state('app.control-panel.gantt', {
        url: '/linha-do-tempo',
        views: {
          'content@app': {
            templateUrl: 'app/main/control-panel/control-panel.html',
            controller: 'ControlPanelController as vm'
          },
          'controlPanelContent@app.control-panel.gantt': {
            templateUrl: 'app/main/control-panel/views/gantt/gantt.html',
            controller: 'ControlPanelGanttController as vm'
          }
        },
        data: { titleTranslateKey: 'CONTROL_PANEL.TIMELINE' }
      })

      .state('app.control-panel.list', {
        url: '/listagem',
        views: {
          'content@app': {
            templateUrl: 'app/main/control-panel/control-panel.html',
            controller: 'ControlPanelController as vm'
          },
          'controlPanelContent@app.control-panel.list': {
            templateUrl: 'app/main/control-panel/views/list/list.html',
            controller: 'ControlPanelListController as vm'
          }
        },
        data: { titleTranslateKey: 'CONTROL_PANEL.TASKS_OF_DAY' },
      })

      .state('app.control-panel.map', {
        url: '/mapa',
        views: {
          'content@app': {
            templateUrl: 'app/main/control-panel/control-panel.html',
            controller: 'ControlPanelController as vm'
          },
          'controlPanelContent@app.control-panel.map': {
            templateUrl: 'app/main/control-panel/views/map/map.html',
            controller: 'ControlPanelMapController as vm',
            resolve: {
              account: function (accountsApi) {
                return accountsApi.get();
              }
            }
          }
        },
        data: { titleTranslateKey: 'CONTROL_PANEL.MAP' }
      });

    $translatePartialLoaderProvider.addPart('app/main/control-panel');
    $translatePartialLoaderProvider.addPart('app/main/control-panel/views/map/services/mapHtmlTemplate');

    // Api
    msApiProvider.register('mail.folders', ['app/data/mail/folders.json']);
    msApiProvider.register('mail.labels', ['app/data/mail/labels.json']);
    msApiProvider.register('mail.label.notes', ['app/data/mail/labels/notes.json']);
    msApiProvider.register('mail.label.paypal', ['app/data/mail/labels/paypal.json']);
    msApiProvider.register('mail.label.invoices', ['app/data/mail/labels/invoices.json']);
    msApiProvider.register('mail.label.amazon', ['app/data/mail/labels/amazon.json']);
    msApiProvider.register('mail.folder.inbox', ['app/data/mail/folders/inbox.json']);
    msApiProvider.register('mail.folder.sent', ['app/data/mail/folders/sent.json']);
    msApiProvider.register('mail.folder.drafts', ['app/data/mail/folders/drafts.json']);
    msApiProvider.register('mail.folder.spam', ['app/data/mail/folders/spam.json']);
    msApiProvider.register('mail.folder.trash', ['app/data/mail/folders/trash.json']);
    msApiProvider.register('mail.folder.starred', ['app/data/mail/folders/starred.json']);
    msApiProvider.register('mail.folder.important', ['app/data/mail/folders/important.json']);
  }

})();

(function () {
    'use strict';

    angular.module('app.control-panel')
        .factory('mapHtmlTemplate', mapHtmlTemplate);

    /** @ngInject */
    function mapHtmlTemplate(moment, TasksStatusHelper, dateHandler, $translate, LocalDateConvert) {

        return {
            taskMarkerTemplate: taskMarkerTemplate,
            employeeMarkerTemplate: employeeMarkerTemplate
        };

        function taskMarkerTemplate(task) {

            var template = '';
            template += '<span data-cy="customer-name"><b>' + task.order.customer.name + '</b></span>';
            template += '<br/>';
            template += '<div style="margin-top: 5px;">';

            template += '<i class="icon icon-clipboard-text s15 icon"></i>';
            template += $translate.instant("MAP_HTML_TEMPLATE.IDENTIFIER") + ': <span><b>' + task.order.identifier + '</b></span>';
            template += '<br/>';

            template += '<i class="icon icon-tag s15 icon"></i>';
            template += $translate.instant("MAP_HTML_TEMPLATE.TYPE") + ': <span><b>' + task.order.service.description + '</b></span>';

            if (task.order && task.order.labels && task.order.labels.length > 0) {

                template += '<br/>';
                template += '<i class="icon icon-label s15"></i>';
                template += $translate.instant("MAP_HTML_TEMPLATE.LABELS") + ': <span class="fix-label">';

                task.order.labels.forEach(function (label) {
                    template += '<span style="font-size: 11px;" class="md-'+label.color+'-bg status-label">'+label.name+'</span>';
                });

                template += '</span>';
            }

            var status = TasksStatusHelper.getByName(task.status);
            template += '<br/>';
            template += '<i data-cy="status" class="icon-traffic-light s15 icon"></i>';
            template += $translate.instant("MAP_HTML_TEMPLATE.SITUATION") + ': <span style="color: '+status.color+'"><b>' + status.description + '</b></span>';

            if (task.status == 'scheduled' && task.scheduling.estimation && task.scheduling.estimation.startTask) {
                template += '<br/>';
                template += '<i class="icon-calendar-clock s15 icon"></i>';
                template += $translate.instant("MAP_HTML_TEMPLATE.ESTIMATED_START") + ': <span><b>' + dateHandler.formatDateTime(task.scheduling.estimation.startTask) + '</b></span>';
            }

            if (task.status == 'in-progress') {

                if (task.scheduling.estimation && task.scheduling.estimation.startTask) {
                    template += '<br/>';
                    template += '<i class="icon-calendar-clock s15 icon"></i>';
                    template += $translate.instant("MAP_HTML_TEMPLATE.STARTED_IN") + ': <span><b>' + dateHandler.formatDateTime(task.scheduling.estimation.startTask) + '</b></span>';
                }

                if (task.scheduling.estimation && task.scheduling.estimation.completeTask) {
                    template += '<br/>';
                    template += '<i class="icon-calendar-clock s15 icon"></i>';
                    template += $translate.instant("MAP_HTML_TEMPLATE.ESTIMATED_COMPLETION") + ': <span><b>' + dateHandler.formatDateTime(task.scheduling.estimation.completeTask) + '</b></span>';
                }
            }

            if (task.status == 'done' || task.status == 'canceled' || task.status == 'reported') {

                if (task.scheduling.estimation && task.scheduling.estimation.startTask) {
                    template += '<br/>';
                    template += '<i class="icon-calendar-clock s15 icon"></i>';
                    template += $translate.instant("MAP_HTML_TEMPLATE.STARTED_IN") + ': <span><b>' + dateHandler.formatDateTime(task.scheduling.estimation.startTask) + '</b></span>';
                }

                if (task.scheduling.estimation && task.scheduling.estimation.completeTask) {
                    template += '<br/>';
                    template += '<i class="icon-calendar-clock s15 icon"></i>';
                    template += $translate.instant("MAP_HTML_TEMPLATE.FINISHED_IN") + ': <span><b>' + dateHandler.formatDateTime(task.scheduling.estimation.completeTask) + '</b></span>';
                }

            }

            if (task.rating && task.rating.stars) {
                template += '<br/>';
                template += '<i class="icon icon-thumbs-up-down s15"></i>';
                template += $translate.instant("MAP_HTML_TEMPLATE.RATING") + ': <span>';

                var className = task.rating.stars >= 1 ? 'icon-star' : 'icon-star-outline';
                template += '<i style="color: #ffb508;" class="icon s15 '+className+'"></i>';

                className = task.rating.stars >= 2 ? 'icon-star' : 'icon-star-outline';
                template += '<i style="color: #ffb508;" class="icon s15 '+className+'"></i>';

                className = task.rating.stars >= 3 ? 'icon-star' : 'icon-star-outline';
                template += '<i style="color: #ffb508;" class="icon s15 '+className+'"></i>';

                className = task.rating.stars >= 4 ? 'icon-star' : 'icon-star-outline';
                template += '<i style="color: #ffb508;" class="icon s15 '+className+'"></i>';

                className = task.rating.stars >= 5 ? 'icon-star' : 'icon-star-outline';
                template += '<i style="color: #ffb508;" class="icon s15 '+className+'"></i>';

                template += '</span>';
            }

            if (task.employee && task.employee.id) {
                template += '<br/>';
                template += '<i class="icon icon-worker s15"></i>';
                template += $translate.instant("MAP_HTML_TEMPLATE.EMPLOYEE") + ': <span><b>' + task.employee.name + '</b></span>';
            }

            template += '<br/>';
            template += '<i class="icon-map-marker s15 icon"></i>';
            template += $translate.instant("MAP_HTML_TEMPLATE.LATITUDE_LONGITUDE") + ': (<b>' + String(task.coords.latitude).substring(0, 7) + ',' + String(task.coords.longitude).substring(0, 7) + '</b>)';
            template += '</div>';

            template += '<br/>';
            template += '<a data-cy="task-edit" style="cursor: pointer;" ng-click="editTask($event, \''+ task.order.id +'\');">' + $translate.instant("MAP_HTML_TEMPLATE.EDIT") + '</a>';

            return template;
        }

        function employeeMarkerTemplate(employeeLocation) {

            function getBatteryTemplate(batteryLevel) {

                var batteryPercentage = parseInt((batteryLevel * 100));

                batteryStyle = {
                    class: 'icon-battery-' + Math.ceil(batteryPercentage / 10) * 10,
                    percentage: batteryPercentage
                };

                if (batteryStyle.percentage >= 95) {
                    batteryStyle.class = 'icon-battery';
                    batteryStyle.color =  'green';
                } else if (batteryStyle.percentage <= 15) {
                    batteryStyle.class = 'icon-battery-alert';
                    batteryStyle.color =  'red';
                }

                if (!batteryStyle.color) {
                    if (batteryStyle.percentage > 50) {
                        batteryStyle.color =  'green';
                    } else {
                        batteryStyle.color =  'orange';
                    }
                }

                return batteryStyle;
            }

            var batteryStyle = getBatteryTemplate(employeeLocation.batteryLevel);

            var template = '';
            if (employeeLocation.employee) {
                template += '<span><b>' + employeeLocation.employee.name + '</b></span>';
                template += '<br/>';
            }
            template += '<div style="margin-top: 5px;">';
            template += '<i style="color: '+batteryStyle.color+';" class=" '+ batteryStyle.class +' s15 icon"></i>';
            template += $translate.instant("MAP_HTML_TEMPLATE.BATTERY") + ': <b>' + batteryStyle.percentage + '%</b>';

            template += '<br/>';
            template += '<i class="icon-map-marker s15 icon"></i>';
            template += $translate.instant("MAP_HTML_TEMPLATE.LATITUDE_LONGITUDE") + ': (<b>' + String(employeeLocation.latitude).substring(0, 7) + ',' + String(employeeLocation.longitude).substring(0, 7) + '</b>)';

            function toDateString(date) {
                var currentDate = moment(date).toDate();
                return LocalDateConvert.formatDate(currentDate, 'date-time');
            }

            if (employeeLocation.employee)  {
                var locationColorClass = employeeLocation.employee.isOnline ? 'green-fg' : 'red-fg';
                template += '<br/>';
                template += '<i class="icon-clock s15 icon '+locationColorClass+'"></i>';
                template += $translate.instant("MAP_HTML_TEMPLATE.LAST_UPDATE") + ': <b>' + toDateString(employeeLocation.timestamp) + '</b>';
            }

            template += '</div>';
            return template;
        }
    }
})();

(function () {
  'use strict';

  angular
     .module('app.control-panel')
     .controller('ModalInvalidGeoController', ModalInvalidGeoController);

  /** @ngInject */
  function ModalInvalidGeoController($mdDialog, $rootScope, $scope, invalidGeolocationOrders, $mdToast, $translate) {
    $scope.invalidGeolocationOrders = invalidGeolocationOrders;

    $scope.copyInvalidOrders = function () {
      var values = $scope.invalidGeolocationOrders.join('; ');
      var dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = values;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      $mdToast.show(
        $mdToast.simple()
          .textContent($translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.MODAL.COPY_IDENTIFIERS_GEOLOCATION_INVALID'))
          .hideDelay(3000)
      );
    };

    $scope.closeDialog = function () {
      $mdDialog.hide();
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('TasksExportDialog', TasksExportDialog);

  /** @ngInject */
  function TasksExportDialog($mdDialog, $document) {
    var appConfig = {
      'Conta Azul': {
        controller: 'ContaAzulTasksExportDialogController',
        templateUrl: 'app/core/integrations/core/tasks/dialogs/export/conta-azul/conta-azul-tasks-export-dialog.html'
      },
      'Omie': {
        controller: 'OmieLoadDataController',
        templateUrl: 'app/core/integrations/core/tasks/dialogs/export/omie/load-data/omie-load-data.html',
        escapeToClose: false
      }
    };

    return {
      openExportTaskDialog: openExportTaskDialog
    };

    function openExportTaskDialog(params) {
      var $event = params.$event;
      var tasks = params.tasks;
      var configuration = params.configuration;
      var appName = params.appName;
      var accounts = params.accounts;
      var selectedAccount = params.selectedAccount;
      var target = params.target;
      var multiple = params.multiple;
      var app = appConfig[appName];

      var dialog = {
        controller: app.controller,
        controllerAs: 'vm',
        templateUrl: app.templateUrl,
        clickOutsideToClose: true,
        multiple: multiple || false,
        escapeToClose: app.escapeToClose !== undefined ? app.escapeToClose : true,
        locals: {
          target: target,
          accounts: accounts,
          tasks: tasks,
          configuration: configuration,
          appName: appName,
          selectedAccount: selectedAccount
        }
      };

      if ($event) {
        dialog.parent = angular.element($document.body);
        dialog.targetEvent = $event;
      }

      if (target) {
        dialog.parent = target;
        dialog.targetEvent = null;
      }

      $mdDialog.show(dialog);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('QuotationsExportDialog', QuotationsExportDialog);

  /** @ngInject */
  function QuotationsExportDialog($mdDialog, $document) {
    var appConfig = {
      'Omie': {
        controller: 'OmieQuotationLoadDataController',
        templateUrl: 'app/core/integrations/core/quotations/dialogs/export/omie/load-data/omie-load-data.html',
        escapeToClose: false
      }
    };

    return {
      openExportQuotationDialog: openExportQuotationDialog
    };

    function openExportQuotationDialog(params) {
      var appName = params.appName;
      var selectedAccount = params.selectedAccount;
      var quotation = params.quotation;
      var $event = params.$event;

      var app = appConfig[appName];
      var target = params.target;

      var dialog = {
        controller: app.controller,
        controllerAs: 'vm',
        templateUrl: app.templateUrl,
        clickOutsideToClose: true,
        escapeToClose: app.escapeToClose !== undefined ? app.escapeToClose : true,
        parent: angular.element($document.body),
        locals: {
          target: target,
          selectedAccount: selectedAccount,
          quotation: quotation
        }
      };

      if ($event) {
        dialog.parent = angular.element($document.body);
        dialog.targetEvent = $event;
      }

      if (target) {
        dialog.parent = target;
        dialog.targetEvent = null;
      }

      $mdDialog.show(dialog);
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('CustomersPromptService', CustomersPromptService);

  /** @ngInject */
  function CustomersPromptService($mdDialog, $document) {

    return {
      openCreate: openCreate,
      openUpdate: openUpdate
    };

    function openCreate($event, fieldCustomer, fieldLocation, appName, appId) {
      $mdDialog.show({
        controller: 'CustomersPromptCreateController',
        controllerAs: 'vm',
        templateUrl: 'app/core/integrations/core/customers/dialogs/prompt/create/customers-prompt.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: false,
        locals: {
          fieldCustomer: fieldCustomer,
          fieldLocation: fieldLocation,
          appName: appName,
          appId: appId
        }
      });
    }

    function openUpdate($event, fieldCustomer, fieldLocation, apiCustomer, appId) {
      $mdDialog.show({
        controller: 'CustomersPromptUpdateController',
        controllerAs: 'vm',
        templateUrl: 'app/core/integrations/core/customers/dialogs/prompt/update/customers-prompt.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: false,
        locals: {
          apiCustomerData: apiCustomer,
          fieldCustomer: fieldCustomer,
          fieldLocation: fieldLocation,
          appId: appId
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('CustomersPromptViewModel', CustomersPromptViewModelFactory);

  /** @ngInject */
  function CustomersPromptViewModelFactory(msUtils) {

    var CustomersPromptViewModel = function (customer, location) {
      if (customer) {
        this.formattedAddress = msUtils.formatAddress(location.address);
        this.customerName = customer.name + ' ' + location.name;
        this.customerDocumentNumber = location.documentNumber || customer.documentNumber;
        this.customerContactPhone = getPhone(customer, location);
        this.customerEmailAddress = getEmail(customer, location);
        this.customerNotes = location.notes || customer.notes;
        this.location = location;

        if (customer.name === location.name) { this.customerName = customer.name; }
      }
    };

    function getPhone(customer, location) {
      var hasPhones = location.contacts && location.contacts.phones && location.contacts.phones.length;
      if (!hasPhones) { return customer.contact.phone; }

      var primaryPhoneIndex = location.contacts.phones.findIndex(function (phone) { return phone.primary; });
      if (primaryPhoneIndex !== -1) {
        return location.contacts.phones[primaryPhoneIndex].number;
      }

      return location.contacts.phones[0].number;
    }

    function getEmail(customer, location) {
      var hasEmails = location.contacts && location.contacts.emails && location.contacts.emails.length;
      if (!hasEmails) { return customer.contact.email; }

      var primaryEmailIndex = location.contacts.emails.findIndex(function (phone) { return phone.primary; });
      if (primaryEmailIndex !== -1) {
        return location.contacts.emails[primaryEmailIndex].address;
      }

      return location.contacts.emails[0].address;
    }

    return CustomersPromptViewModel;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('CustomersExportDialog', CustomersExportDialog);

  /** @ngInject */
  function CustomersExportDialog($mdDialog, $mdToast, $document, documents,
    CustomersPromptService, contaAzulApi, omieCustomerApiHelper, $q, _, $rootScope) {

    return {
      exportTo: exportTo
    };

    function exportTo($event, fieldCustomer, fieldLocation, apiName, appId) {
      $rootScope.loadingProgress = true;
      if(apiName === 'Conta Azul') {
        exportToContaAzul($event, fieldCustomer, fieldLocation, appId);
      } else if(apiName === 'Omie') {
        exportToOmie($event, fieldCustomer, fieldLocation, appId);
      }
    }

    function exportToOmie($event, fieldCustomer, fieldLocation, appId) {
      var apiPossibleCustomers = {
        apiName: 'Omie',
        customers: []
      };
      omieCustomerApiHelper.getPossibleCustomers(fieldCustomer, appId).then(function (possibleOmieCustomers) {
        possibleOmieCustomers = _.uniq(possibleOmieCustomers, 'codigo_cliente_omie');
        if (possibleOmieCustomers.length) {
          apiPossibleCustomers.customers = possibleOmieCustomers;
          openSelectCustomerDialog($event, {
            fieldCustomer: fieldCustomer,
            fieldLocation: fieldLocation,
            apiPossibleCustomers: apiPossibleCustomers,
            appName: 'Omie',
            appId: appId
          });
        } else {
          CustomersPromptService.openCreate($event, fieldCustomer, fieldLocation, 'Omie', appId);
        }
      });
    }

    function exportToContaAzul($event, fieldCustomer, fieldLocation, appId) {
      var requests = {
        byName: contaAzulApi.customers.list({
          search: fieldCustomer.name
        }),
      };

      var documentNumber = fieldLocation.documentNumber || fieldCustomer.documentNumber;
      if (documentNumber) {
        requests.byFormattedDocument = contaAzulApi.customers.list({
          search: documents.formatDocument(documentNumber)
        });
        requests.byUnformattedDocument = contaAzulApi.customers.list({
          search: documentNumber.replace(/\D/g, '')
        });
      }

      $q.all(requests).then(function (response) {
        $rootScope.loadingProgress = false;

        var possibleContaAzulCustomers = [];
        response.byName.forEach(function (contaAzulCustomer) {
          possibleContaAzulCustomers.push(contaAzulCustomer);
        });

        if (response.byFormattedDocument) {
          response.byFormattedDocument.forEach(function (contaAzulCustomer) {
            possibleContaAzulCustomers.push(contaAzulCustomer);
          });
        }

        if (response.byUnformattedDocument) {
          response.byUnformattedDocument.forEach(function (contaAzulCustomer) {
            possibleContaAzulCustomers.push(contaAzulCustomer);
          });
        }

        possibleContaAzulCustomers = _.uniq(possibleContaAzulCustomers, 'id');
        if (possibleContaAzulCustomers.length) {
          var apiPossibleCustomers = {
            apiName: 'Conta Azul',
            customers: possibleContaAzulCustomers
          };
          openSelectCustomerDialog($event, {
            fieldCustomer: fieldCustomer,
            fieldLocation: fieldLocation,
            appId: appId,
            apiPossibleCustomers: apiPossibleCustomers,
            appName: 'Conta Azul'
          });
        } else {
          CustomersPromptService.openCreate($event, fieldCustomer, fieldLocation, 'Conta Azul');
        }
      }).catch(function (error) {
        if (error.status !== 201) {
          toast('Não foi possível se conectar com o Conta Azul, verifique suas configurações de integração e tente novamente.', 6000);
        }
      });
    }

    function toast(message, delay) {
      $mdToast.show(
        $mdToast.simple()
        .textContent(message)
        .hideDelay(delay)
      );
      $rootScope.loadingProgress = false;
    }

    function openSelectCustomerDialog($event, locals) {
      $mdDialog.show({
        controller: 'CustomersExportDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/integrations/core/customers/dialogs/export/customers-export-dialog.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: false,
        locals: locals
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('CustomersExportDialogController', CustomersExportDialogController);

  /** @ngInject */
  function CustomersExportDialogController($mdDialog, CustomersPromptService, apiPossibleCustomers, appName, appId, fieldCustomer, fieldLocation, CustomersExportDialogViewModel) {

    var vm = this;
    vm.viewModel = new CustomersExportDialogViewModel();
    vm.apiPossibleCustomers = vm.viewModel.mapApiPossibleCustomers(apiPossibleCustomers);
    vm.selectedCustomer = null;
    vm.closeDialog = closeDialog;
    vm.selectCustomer = selectCustomer;
    vm.goToConfirmPrompt = goToConfirmPrompt;
    vm.appName = appName;
    vm.appId = appId;

    function closeDialog() {
      $mdDialog.hide();
    }

    function selectCustomer(customer) {
      vm.selectedCustomer = customer;
    }

    function goToConfirmPrompt($event) {
      if (vm.selectedCustomer) {
        CustomersPromptService.openUpdate($event, fieldCustomer, fieldLocation, vm.selectedCustomer, vm.appId);
      } else {
        CustomersPromptService.openCreate($event, fieldCustomer, fieldLocation, appName, vm.appId);
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('CustomersExportDialogViewModel', CustomersExportDialogViewModelFactory);

  /** @ngInject */
  function CustomersExportDialogViewModelFactory(contaAzulCustomerMapper, omieCustomerMapper) {

    var CustomersExportDialogViewModel = function () { };

    CustomersExportDialogViewModel.prototype.mapApiPossibleCustomers = function (apiPossibleCustomers) {
      if (apiPossibleCustomers.customers && apiPossibleCustomers.customers.length) {
        if (apiPossibleCustomers.apiName === 'Conta Azul') {
          apiPossibleCustomers.customers = _.map(apiPossibleCustomers.customers, function (contaAzulCustomer) {
            var customer = contaAzulCustomerMapper.toFieldControl(contaAzulCustomer);
            customer.apiName = 'Conta Azul';
            customer.apiCustomer = contaAzulCustomer;
            return customer;
          });
        } else if (apiPossibleCustomers.apiName === 'Omie') {
          apiPossibleCustomers.customers = _.map(apiPossibleCustomers.customers, function (omieCustomer) {
            var customer = omieCustomerMapper.toFieldControl(omieCustomer);
            customer.apiName = 'Omie';
            customer.apiCustomer = omieCustomer;
            return customer;
          });
        }
        return apiPossibleCustomers;
      }
      return [];
    };

    return CustomersExportDialogViewModel;
  }
})();

(function () {
  'use strict';

  angular
  .module('app.core.api', [])
  .constant('Api', Api)
  .constant('GraphQLApi', GraphQLApi);

  function Api($http, baseUrl, resourceName, qStringify, querify, $q) {

    var self = this;
    self.baseUrl = baseUrl;
    self.resourceName = resourceName;

    self.getUrl = function () {
      var url = self.baseUrl + (self.resourceName || '');
      if (!_.endsWith(url, '/')) { url += '/'; }
      return url;
    };

    self.delete = function (id) {
      return $http.delete(self.getUrl() + id).then(self.whenCompleted);
    };

    self.patchMany = function (resources) {
      return $http.patch(self.getUrl(), resources).then(self.whenCompleted);
    };

    self.getAll = function () {
      return $http.get(self.getUrl()).then(self.whenCompleted);
    };

    self.get = function (id) {
      return $http.get(self.getUrl() + id).then(self.whenCompleted);
    };

    self.put = function (resource) {
      if (resource.id) {
        return $http.put(self.getUrl() + resource.id, resource).then(self.whenCompleted);
      } else {
        return $http.put(self.getUrl(), resource).then(self.whenCompleted);
      }
    };

    self.save = function (resource) {
      if (resource.id) {
        return $http.put(self.getUrl() + resource.id, resource)
        .then(self.whenCompleted);
      } else {
        return $http.post(self.getUrl(), resource)
        .then(self.whenCompleted);
      }
    };

    self.update = function (resource) {
      return $http.put(self.getUrl() + resource.id, resource)
      .then(self.whenCompleted);
    };

    self.post = function (resource) {
      return $http.post(self.getUrl(), resource).then(self.whenCompleted);
    };

    self.getParams = function (parameters) {
      if (!qStringify) {
        console.warn('qStringify is not defined, check Api constructor :P');
      }
      var requestUrl = self.getUrl();
      requestUrl += '?' + qStringify(parameters);
      return $http.get(requestUrl).then(self.whenCompleted);
    };

    self.whenCompleted = function (result) {
      return result.data;
    };

    self.search = function (query, options) {
      var requestUrl = self.getUrl();
      requestUrl += querify(query, options);
      return $http.get(requestUrl).then(self.whenCompleted);
    };

    self.getSequence = function (queries, options) {
      var results = [];
      var promise = $q.when();
      queries.forEach(function (query) {
        promise = promise.then(function () {
          var searchOptions = options || {};

          if (!searchOptions.limit) {
            searchOptions.limit = 50;
          }

          return self.search(query, searchOptions).then(function (result) {
            result.items.forEach(function (item) {
              results.push(item);
            });
            return {
              items: results,
              totalItems: results.length
            };
          });
        });
      });
      return promise;
    };

  }

  function GraphQLApi($http, EnvironmentConfig, $q, url) {

    var self = this;
    self.baseUrl = url || EnvironmentConfig.eyeOfSauron2Url;

    self.query = function (queryString, queryParams, resource) {
      return $http.post(
        self.baseUrl,
        { query: queryString, variables: queryParams },
        { headers: { 'cache-control': 'no-cache' } }
      ).then(function (response) {
        return response.data['data'][resource];
      });
    };

    self.getSequence = function (queryString, queryParams, resource, queries) {
      var results = [];
      var promise = $q.when();
      queries.forEach(function (query) {
        promise = promise.then(function () {
          var params = queryParams || {};

          params.where = query || params.where;

          if (!params.take) {
            params.take = 1000;
          }

          return self.query(queryString, params, resource).then(function (result) {
            result.items.forEach(function (item) {
              results.push(item);
            });
            return {
              items: results,
              totalItems: results.length
            };
          });
        });
      });
      return promise;
    };

    self.mutation = function (queryString, queryParams, resource) {
      return $http.post(
        self.baseUrl,
        { query: queryString, variables: queryParams },
        { headers: { 'cache-control': 'no-cache' } }
      ).then(function (response) {
        if (response.data && response.data.errors) {
          return Promise.reject(response.data);
        }

        return response.data['data'][resource];
      });
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('KnowledgeBasesQuery', '\
    query KnowledgeBases($take: Int, $skip: Int, $orderBy: KnowledgeBasesOrderByEnum, $where: KnowledgeBasesWhereInput) { \
      knowledgeBases(take: $take, skip: $skip, orderBy: $orderBy, where: $where) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          name \
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('UsersSearchQuery', ' \
    query UsersQuery ( \
      $where: UsersWhereInput, \
      $orderBy: UsersOrderByEnum \
      $take: Int \
      $skip: Int \
    ) { \
      users ( \
        where: $where, \
        orderBy: $orderBy, \
        take: $take, \
        skip: $skip \
      ) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          _id \
          name \
          loginCount \
          email \
          emailValidatedAt \
          avatarUrl \
          lastLoginAt \
          hiredAt \
          workPosition \
          department \
          mfaActive \
          profile { \
            admin \
            owner \
          } \
          preferences \
          account { \
            id \
          } \
          metadata \
        } \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('UsersGetOneTerritoriesQuery', '\
    query UserQuery( \
      $id: String! \
    ) { \
      user(id: $id) { \
        id \
        territories { \
          id \
          name \
          parentTerritory { \
            id \
            name \
          } \
          radius \
          geometry { \
            type \
            coordinates { \
              lat \
              lng \
            } \
          } \
          type \
        }\
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('UsersGetOneQuery', '\
    query UserQuery( \
      $id: String! \
    ) { \
      user(id: $id) { \
        id \
        _id \
        name \
        loginCount \
        email \
        emailValidatedAt \
        avatarUrl \
        lastLoginAt \
        hiredAt \
        workPosition \
        department \
        mfaActive \
        profile { \
          admin \
          owner \
        } \
        preferences \
        account { \
          id \
        } \
        metadata \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('UsersGetOneWithGroupsQuery', '\
    query UserQuery( \
      $id: String! \
    ) { \
      user(id: $id) { \
        id \
        groups { \
          id \
          name \
        }\
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('TerritoriesSearchQuery', '\
    query TerritoriesQuery ( \
      $where: TerritoriesWhereInput \
      $orderBy: TerritoriesOrderByEnum \
      $take: Int \
      $skip: Int \
    ) { \
      territories (where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          name \
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('TerritoriesByCoordinatesQuery', ' \
  query TerritoriesByCoordinates ( \
    $latitude: Float!, \
    $longitude: Float! \
  ) { \
    territoriesByCoordinates ( \
      latitude: $latitude, \
      longitude: $longitude \
    ) { \
      id \
      name \
      parentTerritory { \
        id \
        name \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('TemplatesSearchQuery', ' \
    query TemplatesQuery($where: TemplatesWhereInput, $take: Int = 10, $skip: Int = 0) { \
      templates(where: $where, take: $take, skip: $skip) { \
        items { \
          id \
          name \
          type \
          active \
          archived \
          createdAt \
          createdBy { \
            name \
            avatarUrl \
          } \
        } \
        totalCount \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('TasksSearchQuery', ' \
  query TasksQuery ( \
    $where: TasksWhereInput, \
    $orderBy: TasksOrderByEnum \
    $take: Int \
    $skip: Int \
  ) { \
    tasks ( \
      where: $where, \
      orderBy: $orderBy, \
      take: $take, \
      skip: $skip \
    ) { \
      pageInfo { \
        hasNextPage \
        hasPreviousPage \
      } \
      totalCount \
      items { \
        id \
        _id \
        startedAt \
        completedAt \
        status \
        statusDescription \
        description \
        duration \
        archived \
        position \
        metadata \
        startedRouteAt \
        reportedReason \
        viewedAt \
        receivedAt \
        account { \
          id \
        } \
        order { \
          id \
          _id \
          identifier \
          description \
          deadlineAt \
          archived \
          updatedAt \
          locked \
          customer { \
            id \
            _id \
            name \
            notes \
            archived \
            createdAt \
            locked \
            metadata \
            documentNumber \
            avatarUrl \
            externalAppId \
            contact { \
              email \
              phone \
            } \
            address { \
              zipCode \
              street \
              number \
              complement \
              neighborhood \
              city \
              state \
              formattedAddress \
              coords { \
                latitude \
                longitude \
              } \
            } \
            statistics { \
              updatedAt \
              service { \
                firstAt \
                lastAt \
                total \
              } \
              rating { \
                lastStar \
                lastComment \
                averageStars \
              } \
            } \
            primaryLocation { \
              id \
            } \
          } \
          service { \
            id \
            description \
            duration \
            allowAllForms \
            configurations { \
              mobile { \
                startNCompleteTaskValidationRadiusOn \
                startNCompleteTaskValidationRadiusMeters \
              } \
              notifications { \
                sendEmailTaskRatingLinkWhenCompleted \
                sendEmailOrderReportLinkWhenCompleted \
                sendEmailEmployeeOrderReportWhenCompleted \
                sendEmailEmployeeRouteTrackingLinkWhenOnRoute \
              } \
            } \
            signatureRequired \
            quotationRequired \
            form { \
              id \
            } \
            ratingForm { \
              id \
            } \
          } \
          location { \
            id \
          } \
          territories { \
            id \
            name \
          } \
          subTerritories { \
            id \
            name \
          } \
          address { \
            zipCode \
            street \
            number \
            complement \
            neighborhood \
            city \
            state \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
          signature { \
            _id \
            path \
            signedAt \
            signedBy \
          } \
        } \
        secondaryEmployees { \
          id \
          name \
          avatarUrl \
          workSchedule { \
            start \
            end \
            break { \
              start \
              end \
            } \
          } \
        } \
        employee { \
          id \
          _id \
          name \
          notes \
          avatarUrl \
          email \
          emailValidatedAt \
          inactivatedAt \
          preferences { \
            language \
          } \
          address { \
            zipCode \
            street \
            number \
            city \
            state \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
          contract { \
            hiredAt \
            firedAt \
            active \
          } \
          device { \
            id \
            registration \
            appVersion \
            releaseVersion \
            platform \
          } \
          workSchedule { \
            start \
            end \
            break { \
              start \
              end \
            } \
            capacity \
          } \
        } \
        rating { \
          id \
        } \
        scheduling { \
          type \
          date \
          time \
        } \
        coords { \
          latitude \
          longitude \
        } \
        security { \
          startPasswordCode \
          completePasswordCode \
          metadata \
        } \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('TasksSearchForDataTableQuery', '\
    query TasksQuery( \
      $where: TasksWhereInput\
      $orderBy: TasksOrderByEnum\
      $take: Int \
      $skip: Int \
    ) { \
    tasks(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
      pageInfo { \
        hasNextPage \
        hasPreviousPage \
      } \
      totalCount \
      items { \
        id \
        description \
        startedAt \
        completedAt \
        startedRouteAt \
        metadata \
        status \
        archived \
        statusDescription \
        scheduling { \
          date \
          time \
        } \
        rating { \
          id \
          stars \
          comments \
        } \
        employee { \
          id \
          name \
          avatarUrl \
        } \
        order { \
          id \
          identifier \
          deadlineAt \
          description \
          locked \
          recurrence { \
            id \
          } \
          createdBy { \
            id \
            name \
          } \
          service { \
            id \
            description \
          } \
          labels { \
            id \
            name \
            color \
          } \
          location { \
            id \
            name \
          } \
          address { \
            formattedAddress \
          } \
          customer { \
            id \
            name \
          } \
          deadline { \
            id \
            responseStatus \
            solutionStatus \
          } \
        } \
      } \
    }\
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('TasksSearchForControlPanelQuery', '\
    query TasksQuery( \
      $where: TasksWhereInput\
      $orderBy: TasksOrderByEnum\
      $take: Int \
      $skip: Int \
    ) { \
    tasks(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
      pageInfo { \
        hasNextPage \
        hasPreviousPage \
      } \
      totalCount \
      items { \
        id \
        _id \
        description \
        startedAt \
        completedAt \
        startedRouteAt \
        metadata \
        status \
        archived \
        statusDescription \
        duration \
        position \
        receivedAt \
        reportedReason \
        viewedAt \
        account { \
          id \
        } \
        coords { \
          latitude \
          longitude \
        } \
        scheduling { \
          type \
          date \
          time \
        } \
        rating { \
          id \
          stars \
          comments \
        } \
        employee { \
          id \
        } \
        secondaryEmployees { \
          id \
        } \
        security { \
          completePasswordCode \
          metadata \
          startPasswordCode \
        } \
        order { \
          id \
          identifier \
          deadlineAt \
          description \
          locked \
          archived \
          updatedAt \
          _id \
          address { \
            zipCode \
            street \
            number \
            complement \
            neighborhood \
            city \
            state \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
          createdBy { \
            id \
            name \
          } \
          service { \
            id \
            description \
            allowAllForms \
            duration \
            form { \
              id \
            } \
            ratingForm { \
              id \
            } \
            signatureRequired \
            configurations { \
              notifications { \
                sendEmailEmployeeRouteTrackingLinkWhenOnRoute \
                sendEmailOrderReportLinkWhenCompleted \
                sendEmailTaskRatingLinkWhenCompleted \
              } \
            } \
          } \
          labels { \
            id \
            name \
            color \
          } \
          signature { \
            path \
            signedAt \
            signedBy \
            _id \
          } \
          customer { \
            id \
            _id \
            name \
            archived \
            avatarUrl \
            contact { \
              email \
              phone \
            } \
            createdAt \
            documentNumber \
            labels { \
              id \
            } \
            locked \
            metadata \
            notes \
            primaryLocation { \
              id \
            } \
            statistics { \
              rating { \
                averageStars \
                lastComment \
                lastStar \
              } \
              service { \
                firstAt \
                lastAt \
                total \
              } \
            } \
            address { \
              zipCode \
              street \
              number \
              complement \
              neighborhood \
              city \
              state \
              formattedAddress \
              coords { \
                latitude \
                longitude \
              } \
            } \
          } \
          location { \
            account { \
              id \
            } \
            archived \
            documentNumber \
            id \
            locked \
            name \
            notes \
            address { \
              postalCode \
              street \
              number \
              complement \
              neighborhood \
              city \
              state \
              formattedAddress \
              coords { \
                latitude \
                longitude \
              } \
            } \
          } \
          deadline { \
            id \
            responseStatus \
            solutionStatus \
          } \
        } \
      } \
    }\
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('TasksSearchForCalendarQuery', ' \
  query TasksQuery ( \
    $where: TasksWhereInput, \
    $take: Int, \
    $skip: Int, \
    $orderBy: TasksOrderByEnum \
  ) { \
    tasks( \
      where: $where, \
      take: $take, \
      skip: $skip, \
      orderBy: $orderBy \
      ) \
    { \
      pageInfo { \
        hasNextPage \
        hasPreviousPage \
      }, \
      totalCount, \
      items { \
        id \
        status \
        rating { \
          id \
        } \
        startedAt \
        duration \
        completedAt \
        employee { \
          id \
          name \
          avatarUrl \
        } \
        order { \
          id  \
          identifier \
          location { \
            name \
          } \
          labels { \
            id \
            name \
            color \
          } \
          customer { \
            name \
          } \
          service { \
            description \
          } \
        } \
        scheduling { \
          time \
          date \
        } \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('TasksSearchForCalendarV2Query', ' \
  query TasksToCalendarQuery ( \
    $where: TasksWhereInput, \
    $dateRange: DateRangeInput, \
    $orderBy: TasksOrderByEnum \
  ) { \
    tasksToCalendar( \
      where: $where, \
      dateRange: $dateRange, \
      orderBy: $orderBy \
      ) \
    { \
     daysTasks { \
      date \
      tasksCount \
      tasks { \
        id \
        status \
        rating { \
          id \
        } \
        startedAt \
        duration \
        completedAt \
        employee { \
          id \
          name \
          avatarUrl \
        } \
        order { \
          id  \
          identifier \
          location { \
            name \
          } \
          labels { \
            id \
            name \
            color \
          } \
          customer { \
            name \
          } \
          service { \
            description \
          } \
        } \
        scheduling { \
          time \
          date \
        } \
       } \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('TasksSearchEstimatedQuery', ' \
  query TasksEstimationQuery ( \
    $where: TasksWhereInput, \
    $orderBy: TasksOrderByEnum \
    $take: Int \
    $skip: Int \
  ) { \
    tasksEstimation ( \
      where: $where, \
      orderBy: $orderBy, \
      take: $take, \
      skip: $skip \
    ) { \
      id \
      _id \
      startedAt \
      completedAt \
      status \
      statusDescription \
      description \
      duration \
      archived \
      position \
      metadata \
      startedRouteAt \
      reportedReason \
      viewedAt \
      receivedAt \
      account { \
        id \
      } \
      order { \
        id \
        _id \
        identifier \
        description \
        deadlineAt \
        archived \
        updatedAt \
        locked \
        customer { \
          id \
          _id \
          name \
          notes \
          archived \
          createdAt \
          locked \
          metadata \
          documentNumber \
          avatarUrl \
          externalAppId \
          contact { \
            email \
            phone \
          } \
          address { \
            zipCode \
            street \
            number \
            complement \
            neighborhood \
            city \
            state \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
          statistics { \
            updatedAt \
            service { \
              firstAt \
              lastAt \
              total \
            } \
            rating { \
              lastStar \
              lastComment \
              averageStars \
            } \
          } \
          primaryLocation { \
            id \
          } \
          contacts { \
            emails { \
              id \
              address \
              type \
              primary \
              name \
            } \
            phones { \
              id \
              number \
              type \
              primary \
              name \
              countryCode \
            } \
          } \
        } \
        service { \
          id \
          description \
          duration \
          allowAllForms \
          configurations { \
            mobile { \
              startNCompleteTaskValidationRadiusOn \
              startNCompleteTaskValidationRadiusMeters \
            } \
            notifications { \
              sendEmailTaskRatingLinkWhenCompleted \
              sendEmailOrderReportLinkWhenCompleted \
              sendEmailEmployeeOrderReportWhenCompleted \
              sendEmailEmployeeRouteTrackingLinkWhenOnRoute \
            } \
          } \
          signatureRequired \
          quotationRequired \
          form  { \
           id \
          } \
          ratingForm  { \
           id \
          } \
        } \
        location { \
          id \
        } \
        address { \
          zipCode \
          street \
          number \
          complement \
          neighborhood \
          city \
          state \
          formattedAddress \
          coords { \
            latitude \
            longitude \
          } \
        } \
        signature { \
          _id \
          path \
          signedAt \
          signedBy \
        } \
      } \
      employee { \
        id \
        name \
        avatarUrl \
        address { \
          zipCode \
          street \
          number \
          city \
          state \
          coords { \
            latitude \
            longitude \
          } \
        } \
        workSchedule { \
          start \
          end \
          break { \
            start \
            end \
          } \
        } \
      } \
      rating { \
        id \
      } \
      scheduling { \
        type \
        date \
        time \
        estimation { \
          id \
          routeCost \
          startRoute \
          startTask \
          completeTask \
          priority \
        } \
      } \
      coords { \
        latitude \
        longitude \
      } \
      security { \
        startPasswordCode \
        completePasswordCode \
        metadata \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('TasksGetOneQuery', '\
  query TaskQuery( \
    $id: ID! \
  ) { \
    task(id: $id) { \
      id \
      _id \
      startedAt \
      completedAt \
      status \
      statusDescription \
      description \
      duration \
      archived \
      position \
      metadata \
      startedRouteAt \
      reportedReason \
      viewedAt \
      receivedAt \
      account { \
        id \
      }, \
      order { \
        id \
      }, \
      employee { \
        id \
      }, \
      rating { \
        id \
      } \
      scheduling { \
        type \
        date \
        time \
      }, \
      coords { \
        latitude \
        longitude \
      }, \
      security { \
        startPasswordCode \
        completePasswordCode \
        metadata \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .constant('TasksUpdateMutation', '\
      mutation UpdateTask($input: UpdateTaskInput!) { \
        updateTask(input: $input) { \
          id \
        } \
      }'
    );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('RecurrencesSearchQuery', ' \
  query RecurrencesQuery ( \
    $where: RecurrencesWhereInput, \
    $orderBy: RecurrencesOrderByEnum \
    $take: Int \
    $skip: Int \
  ) { \
    recurrences ( \
      where: $where, \
      orderBy: $orderBy, \
      take: $take, \
      skip: $skip \
    ) { \
      pageInfo { \
        hasNextPage \
        hasPreviousPage \
      } \
      totalCount \
      items { \
        id \
        notes \
        archived \
        customer { \
          id \
          name \
          notes \
          contact { \
            email \
            phone \
          }, \
          address { \
            zipCode \
            street \
            number \
            complement \
            neighborhood \
            city \
            state \
            coords { \
              latitude \
              longitude \
            } \
          } \
        } \
        location { \
          id \
          name \
          notes \
          archived \
          locked \
          createdAt \
          customer { \
            id \
          } \
          address { \
            postalCode \
            street \
            number \
            neighborhood \
            city \
            state \
            complement \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
        } \
        service { \
          id \
          description \
          duration \
          slaTimeLimit \
        } \
        employee { \
          id \
          name \
        } \
        options { \
          calculateDeadline \
        } \
        metadata \
        automatic { \
          enabled \
          before \
        } \
        repeat { \
          from \
          every \
          interval \
          weekday \
          dayOfMonth \
          skipWeekend \
          until \
          time \
        } \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('RecurrencesGetOneQuery', '\
  query RecurrenceQuery( \
    $id: ID! \
  ) { \
    recurrence(id: $id) { \
      id \
      notes \
      archived \
      customer { \
        id \
        name \
        notes \
        contact { \
          email \
          phone \
        }, \
        address { \
          zipCode \
          street \
          number \
          complement \
          neighborhood \
          city \
          state \
          coords { \
            latitude \
            longitude \
          } \
        } \
      } \
      location { \
        id \
        name \
        notes \
        archived \
        locked \
        createdAt \
        customer { \
          id \
        } \
        address { \
          postalCode \
          street \
          number \
          neighborhood \
          city \
          state \
          complement \
          formattedAddress \
          coords { \
            latitude \
            longitude \
          } \
        } \
      } \
      service { \
        id \
        description \
        duration \
        slaTimeLimit \
      } \
      employee { \
        id \
        name \
      } \
      options { \
        calculateDeadline \
      } \
      metadata \
      automatic { \
        enabled \
        before \
      } \
      repeat { \
        from \
        every \
        interval \
        weekday \
        dayOfMonth \
        skipWeekend \
        until \
        time \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('RecurrencesUpdateMutation', '\
    mutation UpdateRecurrenceMutation($input: UpdateRecurrenceInput!) { \
      updateRecurrence(input: $input) { \
        id \
        metadata \
        service { \
          description \
        } \
        location { \
          name \
        } \
        options { \
          calculateDeadline \
        } \
        employee { \
          name \
        } \
        customer { \
          name \
        } \
        notes \
        archived \
        createdAt \
        automatic { \
          before \
          enabled \
        } \
        repeat { \
          from \
          every \
          interval \
          weekday \
          dayOfMonth \
          skipWeekend \
          until \
          time \
        } \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('RecurrencesCreateMutation', '\
    mutation CreateRecurrenceMutation($input: CreateRecurrenceInput!) { \
      createRecurrence(input: $input) { \
        id \
        metadata \
        service { \
          description \
        } \
        location { \
          name \
        } \
        options { \
          calculateDeadline \
        } \
        employee { \
          name \
        } \
        customer { \
          name \
        } \
        notes \
        archived \
        createdAt \
        automatic { \
          before \
          enabled \
        } \
        repeat { \
          from \
          every \
          interval \
          weekday \
          dayOfMonth \
          skipWeekend \
          until \
          time \
        } \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('QuotationsSearchQuery', ' \
  query QuotationsQuery ( \
    $where: QuotationsWhereInput, \
    $orderBy: QuotationsOrderByEnum \
    $take: Int \
    $skip: Int \
  ) { \
    quotations ( \
      where: $where, \
      orderBy: $orderBy, \
      take: $take, \
      skip: $skip \
    ) { \
      pageInfo { \
        hasNextPage \
        hasPreviousPage \
      } \
      totalCount \
      items { \
        id \
        order { \
          id \
          identifier \
        } \
        identifier \
        name \
        description \
        archived \
        subtotal \
        total \
        createdAt \
        createdBy \
        customer { \
          id \
          name \
        } \
        discount { \
          type \
          value \
          total \
        } \
        status \
        expiredAt \
        refusedAt \
        approvedAt \
        approvedBy \
        approvedSignature \
        items { \
          id \
          productService { \
            id \
            name \
            value \
            type \
            archived \
          } \
          quotation { \
            id \
          } \
          position \
          quantity \
          total \
          description \
        } \
        labels { \
          id \
          name \
          color \
        } \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('QuotationsGetOneQuery', '\
  query QuotationQuery( \
    $id: UUID! \
  ) { \
    quotation(id: $id) { \
      id \
      identifier \
      name \
      description \
      additionalInformation \
      subtotal \
      total \
      status \
      refusedAt \
      expiredAt \
      approvedAt \
      approvedBy \
      createdAt \
      createdBy \
      approvedMessage \
      approvedSignature \
      archived \
      updatedAt \
      order { \
        id \
        _id \
        identifier \
        description \
        deadlineAt \
        archived \
        metadata \
        createdAt \
        locked \
        signature { \
          _id \
          path \
          signedAt \
          signedBy \
        } \
        customer { \
          id \
          metadata \
        } \
        location { \
          id \
        } \
        service { \
          id \
        }, \
        address { \
          zipCode \
          street \
          number \
          complement \
          neighborhood \
          city \
          state \
          formattedAddress \
          coords { \
            latitude \
            longitude \
          } \
        } \
        plan { id } \
        ticket { id } \
      } \
      discount { \
        type \
        value \
        total \
      } \
      customer { \
        id \
        _id \
        name \
        notes \
        archived \
        createdAt \
        locked \
        metadata \
        documentNumber \
        avatarUrl \
        externalAppId \
        contact { \
          email \
          phone \
        } \
        address { \
          zipCode \
          street \
          number \
          complement \
          neighborhood \
          city \
          state \
          formattedAddress \
          coords { \
            latitude \
            longitude \
          } \
        } \
        statistics { \
          updatedAt \
          service { \
            firstAt \
            lastAt \
            total \
          } \
          rating { \
            lastStar \
            lastComment \
            averageStars \
          } \
        } \
        primaryLocation { \
          id \
        } \
        contacts { \
          phones { \
            id \
            number \
            type \
            primary \
            name \
            countryCode \
          } \
          emails { \
            id \
            address \
            type \
            primary \
            name \
          } \
        } \
      } \
      metadata \
      items { \
        id \
        description \
        quantity \
        total \
        position \
        quotation { \
          id \
        } \
        productService { \
          id \
          value \
          name \
          imageUrl \
          metadata \
          measure \
          type \
          archived \
        } \
        metadata \
        value \
        equipment { \
          id \
          name \
          number \
          imageUrl \
          type { \
            id \
            name \
          } \
        } \
      } \
      quotationEquipments { \
        id \
        equipment { \
          id \
          name \
          number \
          imageUrl \
          location { \
            id \
            name \
          } \
          type { \
            id \
            name \
          } \
        } \
        quotation { \
          id \
        } \
        createdAt \
      } \
      expenses { \
        id \
        expense { \
          id \
          name \
          maxValue \
          archived \
          receiptRequired \
        } \
        quotation { \
          id \
        } \
        position \
        path \
        total \
        description \
      } \
      labels { \
        id \
        name \
        color \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('UpdateQuotationMutation', '\
    mutation UpdateQuotationMutation($input: UpdateQuotationInput!) { \
      updateQuotation(input: $input) { \
        id \
        name \
        description \
        additionalInformation \
        approvedMessage \
        approvedSignature \
        customer { \
          id \
        } \
        order { \
          id \
        } \
        discount { \
          type \
          value \
          total \
        } \
        items { \
          id \
          description \
          quantity \
          total \
          productService { \
            id \
            name \
            value \
            type \
          } \
          quotation { \
            id \
          } \
          equipment { \
            id \
            name \
            number \
          } \
          metadata \
        } \
        quotationEquipments { \
          id \
          quotation { \
            id \
          } \
          equipment { \
            id \
            name \
            number \
          } \
          createdAt \
        } \
        archived \
        identifier \
        approvedAt \
        approvedBy \
        refusedAt \
        expiredAt \
        status \
        subtotal \
        total \
        createdAt \
        updatedAt \
        metadata \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('updateQuotationExpenseMutation', '\
    mutation updateQuotationExpenseMutation ($input: UpdateQuotationExpenseInput!) { \
      updateQuotationExpense(input: $input) {  \
        expense { \
          id \
          name \
          maxValue \
        } \
        quotation { \
          id \
        } \
        position \
        total \
        description \
        path \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('UnarchiveQuotationMutation', '\
    mutation UnarchiveQuotationMutation($id: UUID!) { \
      unarchiveQuotation(id: $id) { \
        id \
        identifier \
        name \
        description \
        additionalInformation \
        approvedMessage \
        archived \
        subtotal \
        total \
        customer { \
          id \
          name \
        } \
        status \
        expiredAt \
        refusedAt \
        approvedAt \
        approvedBy \
        approvedSignature \
        createdAt \
        createdBy \
        updatedAt \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('RemoveQuotationExpenseMutation', '\
    mutation RemoveQuotationExpenseMutation ($id: ID!) { \
      removeQuotationExpense(id: $id) {  \
        id \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('CreateQuotationMutation', '\
    mutation CreateQuotationMutation($input: CreateQuotationInput!) { \
      createQuotation(input: $input) { \
        id \
        name \
        description \
        additionalInformation \
        approvedMessage \
        approvedSignature \
        customer { \
          id \
        } \
        order { \
          id \
        } \
        discount { \
          type \
          value \
          total \
        } \
        items { \
          id \
          description \
          quantity \
          total \
          productService { \
            id \
            name \
            value \
            type \
          } \
          quotation { \
            id \
          } \
          equipment { \
            id \
            name \
            number \
          } \
          metadata \
        } \
         expenses { \
          id \
          expense { \
            id \
            name \
            maxValue \
            archived \
            receiptRequired \
          } \
          quotation { \
            id \
          } \
          position \
          path \
          total \
          description \
        } \
        quotationEquipments { \
          id \
          quotation { \
            id \
          } \
          equipment { \
            id \
            name \
            number \
          } \
          createdAt \
        } \
        archived \
        identifier \
        approvedAt \
        approvedBy \
        refusedAt \
        expiredAt \
        status \
        subtotal \
        total \
        createdAt \
        updatedAt \
        metadata \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('CreateQuotationExpenseMutation', '\
    mutation CreateQuotationExpenseMutation ($input: CreateQuotationExpenseInput!) { \
      createQuotationExpense(input: $input) {  \
        id \
        expense { \
          id \
          name \
          maxValue \
        } \
        quotation { \
          id \
        } \
        position \
        total \
        description \
        path \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('ArchiveQuotationMutation', '\
    mutation ArchiveQuotationMutation($id: UUID!) { \
      archiveQuotation(id: $id) { \
        id \
        identifier \
        name \
        description \
        additionalInformation \
        approvedMessage \
        archived \
        subtotal \
        total \
        customer { \
          id \
          name \
        } \
        status \
        expiredAt \
        refusedAt \
        approvedAt \
        approvedBy \
        approvedSignature \
        createdAt \
        createdBy \
        updatedAt \
      } \
    }'
  );
})();

(function (){
  'use strict';

  angular
  .module('app.core.api')
  .constant('ProductsSearchQuery', '\
  query ProductsQuery ( \
    $where: ProductsWhereInput \
    $orderBy: ProductsOrderByEnum \
    $take: Int \
    $skip: Int \
  ) { \
    products( \
      where: $where, \
      orderBy: $orderBy, \
      take: $take, \
      skip: $skip \
    ) { \
      pageInfo { \
        hasNextPage \
        hasPreviousPage \
      } \
      totalCount \
      items { \
        archived \
        code \
        createdAt \
        description \
        externalAppId \
        id \
        imageUrl \
        integration \
        locked \
        measure \
        metadata \
        name \
        qrCode \
        type \
        value \
        productType { \
          archived \
          description \
          id \
          locked \
          metadata \
          name \
        } \
      } \
    } \
  }');
})();
(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('PlansSearchQuery', ' \
  query PlansQuery ( \
    $where: PlansWhereInput, \
    $orderBy: PlansOrderByEnum \
    $take: Int \
    $skip: Int \
  ) { \
    plans ( \
      where: $where, \
      orderBy: $orderBy, \
      take: $take, \
      skip: $skip \
    ) { \
      pageInfo { \
        hasNextPage \
        hasPreviousPage \
      } \
      totalCount \
      items { \
        id \
        name \
        description \
        status \
        archived \
        createdAt \
        spreadsheet { \
          path \
        } \
        planType { \
          id \
          name \
          description \
        } \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('PlansGetOneQuery', '\
  query PlanQuery( \
    $id: ID! \
  ) { \
    plan(id: $id) { \
      id \
      name \
      description \
      status \
      archived \
      createdAt \
      spreadsheet { \
        path \
      } \
      planType { \
        id \
        name \
        description \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('PlanTypesSearchQuery', ' \
    query planTypesQuery( \
      $where: PlanTypesWhereInput, \
      $orderBy: PlanTypesOrderByEnum, \
      $take: Int, \
      $skip: Int \
    ) { \
      planTypes(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          archived \
          createdAt \
          name \
          description \
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('OrdersSearchQuery', '\
    query OrdersSearchQuery( \
      $where: OrdersWhereInput \
      $orderBy: OrdersOrderByEnum \
      $take: Int \
      $skip: Int \
    ) { \
      orders(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          _id \
          identifier \
          description \
          deadlineAt \
          archived \
          metadata \
          locked \
          totalValue \
          productsTotalValue \
          servicesTotalValue \
          signature { \
            _id \
            path \
            signedAt \
            signedBy \
          } \
          customer { \
            id \
            _id \
            name \
            notes \
            archived \
            createdAt \
            locked \
            metadata \
            documentNumber \
            avatarUrl \
            externalAppId \
            contact { \
              email \
              phone \
            } \
            address { \
              zipCode \
              street \
              number \
              complement \
              neighborhood \
              city \
              state \
              formattedAddress \
              coords { \
                latitude \
                longitude \
              } \
            } \
            statistics { \
              updatedAt \
              service { \
                firstAt \
                lastAt \
                total \
              } \
              rating { \
                lastStar \
                lastComment \
                averageStars \
              } \
            } \
            primaryLocation { \
              id \
            } \
            contacts { \
              phones { \
                id \
                number \
                type \
                primary \
                name \
                countryCode \
              } \
              emails { \
                id \
                address \
                type \
                primary \
                name \
              } \
            } \
          } \
          location { \
            id \
            name \
            notes \
            archived \
            locked \
            createdAt \
            customer { \
              id \
            } \
            address { \
              postalCode \
              street \
              number \
              neighborhood \
              city \
              state \
              formattedAddress \
              coords { \
                latitude \
                longitude \
              } \
            } \
          } \
          service { \
            id \
            description \
            duration \
            allowAllForms \
            configurations { \
              notifications  { \
                sendEmailTaskRatingLinkWhenCompleted \
                sendEmailOrderReportLinkWhenCompleted \
                sendEmailEmployeeOrderReportWhenCompleted \
                sendEmailEmployeeRouteTrackingLinkWhenOnRoute \
              } \
              mobile { \
                startNCompleteTaskValidationRadiusOn \
                startNCompleteTaskValidationRadiusMeters \
              } \
            } \
            security { \
              startPasswordCodeRequired \
              completePasswordCodeRequired \
            } \
          } \
          address { \
            zipCode \
            street \
            number \
            complement \
            neighborhood \
            city \
            state \
            formattedAddress \
            coords { \
                latitude \
                longitude \
            } \
          } \
          createdBy { \
            id \
          } \
          plan { \
            id \
          } \
          ticket { \
            id \
          } \
          contractor { \
            id \
            name \
            logoUrl \
            metadata \
            createdAt \
            updatedAt \
          } \
          tasks { \
            id \
            _id \
            description \
            duration \
            archived \
            position \
            startedAt \
            completedAt \
            status \
            statusDescription \
            locked \
            viewedAt \
            receivedAt \
            reportedReason \
            order { \
              id \
            } \
            employee { \
              id \
              _id \
              name \
              avatarUrl \
            } \
            scheduling { \
              type \
              date \
              time \
            } \
            coords { \
              latitude \
              longitude \
            } \
            metadata \
          } \
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('OrdersSearchForPlansQuery', '\
    query OrdersSearchForPlansQuery( \
      $where: OrdersWhereInput \
      $orderBy: OrdersOrderByEnum \
      $take: Int \
      $skip: Int \
    ) { \
      orders(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          _id \
          identifier \
          description \
          deadlineAt \
          archived \
          metadata \
          locked \
          totalValue \
          productsTotalValue \
          servicesTotalValue \
          signature { \
            _id \
            path \
            signedAt \
            signedBy \
          } \
          customer { \
            id \
            _id \
            name \
            notes \
            archived \
            createdAt \
            locked \
            metadata \
            documentNumber \
            avatarUrl \
            externalAppId \
            contact { \
              email \
              phone \
            } \
            address { \
              zipCode \
              street \
              number \
              complement \
              neighborhood \
              city \
              state \
              formattedAddress \
              coords { \
                latitude \
                longitude \
              } \
            } \
            statistics { \
              updatedAt \
              service { \
                firstAt \
                lastAt \
                total \
              } \
              rating { \
                lastStar \
                lastComment \
                averageStars \
              } \
            } \
            primaryLocation { \
              id \
            } \
            contacts { \
              phones { \
                id \
                number \
                type \
                primary \
                name \
                countryCode \
              } \
              emails { \
                id \
                address \
                type \
                primary \
                name \
              } \
            } \
          } \
          location { \
            id \
            name \
            notes \
            archived \
            locked \
            createdAt \
            customer { \
              id \
            } \
            address { \
              postalCode \
              street \
              number \
              neighborhood \
              city \
              state \
              formattedAddress \
              coords { \
                latitude \
                longitude \
              } \
            } \
          } \
          service { \
            id \
            description \
            duration \
            allowAllForms \
            configurations { \
              notifications  { \
                sendEmailTaskRatingLinkWhenCompleted \
                sendEmailOrderReportLinkWhenCompleted \
                sendEmailEmployeeOrderReportWhenCompleted \
                sendEmailEmployeeRouteTrackingLinkWhenOnRoute \
              } \
              mobile { \
                startNCompleteTaskValidationRadiusOn \
                startNCompleteTaskValidationRadiusMeters \
              } \
            } \
            security { \
              startPasswordCodeRequired \
              completePasswordCodeRequired \
            } \
          } \
          equipments { \
            id \
            name \
            number \
            imageUrl \
            notes \
            qrCode \
            archived \
            createdAt \
            customer { id } \
            type { id } \
          } \
          address { \
            zipCode \
            street \
            number \
            complement \
            neighborhood \
            city \
            state \
            formattedAddress \
            coords { \
                latitude \
                longitude \
            } \
          } \
          createdBy { \
            id \
          } \
          plan { \
            id \
          } \
          ticket { \
            id \
          } \
          contractor { \
            id \
            name \
            logoUrl \
            metadata \
            createdAt \
            updatedAt \
          } \
          tasks { \
            id \
            _id \
            description \
            duration \
            archived \
            position \
            startedAt \
            completedAt \
            status \
            statusDescription \
            locked \
            viewedAt \
            receivedAt \
            reportedReason \
            order { \
              id \
            } \
            employee { \
              id \
              _id \
              name \
              avatarUrl \
            } \
            scheduling { \
              type \
              date \
              time \
            } \
            coords { \
              latitude \
              longitude \
            } \
            metadata \
          } \
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('OrdersGetOneQuery', '\
  query OrderQuery( \
    $id: ID! \
  ) { \
    order(id: $id) { \
      id \
      _id \
      identifier \
      description \
      deadlineAt \
      archived \
      metadata \
      locked \
      totalValue \
      productsTotalValue \
      servicesTotalValue \
      labels { \
        id \
        name \
      } \
      signature { \
        _id \
        path \
        signedAt \
        signedBy \
      } \
      customer { \
        id \
        _id \
        name \
        notes \
        archived \
        createdAt \
        locked \
        metadata \
        documentNumber \
        avatarUrl \
        externalAppId \
        contact { \
          email \
          phone \
        } \
        address { \
          zipCode \
          street \
          number \
          complement \
          neighborhood \
          city \
          state \
          formattedAddress \
          coords { \
            latitude \
            longitude \
          } \
        } \
        statistics { \
          updatedAt \
          service { \
            firstAt \
            lastAt \
            total \
          } \
          rating { \
            lastStar \
            lastComment \
            averageStars \
          } \
        } \
        primaryLocation { \
          id \
        } \
        contacts { \
          phones { \
            id \
            number \
            type \
            primary \
            name \
            countryCode \
          } \
          emails { \
            id \
            address \
            type \
            primary \
            name \
          } \
        } \
      } \
      location { \
        id \
        name \
        notes \
        archived \
        locked \
        createdAt \
        customer { \
          id \
        } \
        address { \
          postalCode \
          street \
          number \
          neighborhood \
          city \
          state \
          formattedAddress \
          coords { \
            latitude \
            longitude \
          } \
        } \
      } \
      service { \
        id \
      } \
      form { \
        id \
      } \
      address { \
        zipCode \
        street \
        number \
        complement \
        neighborhood \
        city \
        state \
        formattedAddress \
        coords { \
          latitude \
          longitude \
        } \
      } \
      createdBy { \
        id \
      } \
      plan { \
        id \
      } \
      ticket { \
        id \
      } \
      deadline { \
        id \
        responseAt \
        responseRiskAt \
        solutionAt \
        solutionRiskAt \
        contract { \
          id \
          name \
          locked \
          archived \
          metadata \
          createdAt \
          updatedAt \
          description \
          officeHours { \
            friday { \
              to \
              from \
            } \
            monday { \
              to \
              from \
            } \
            sunday { \
              to \
              from \
            } \
            tuesday { \
              to \
              from \
            } \
            saturday { \
              to \
              from \
            } \
            thursday { \
              to \
              from \
            } \
            wednesday { \
              to \
              from \
            } \
          } \
          hasOfficeHours \
          considerHoliday \
          responseDeadline \
          solutionDeadline \
          responseDeadlineRisk \
          solutionDeadlineRisk \
          responseDeadlineDisplayUnit \
          solutionDeadlineDisplayUnit \
          responseDeadlineRiskDisplayUnit \
          solutionDeadlineRiskDisplayUnit \
        } \
        updatedAt \
        createdAt \
        status \
        firstTaskStartedAt \
        lastTaskCompletedAt \
        responseViolationReason { \
          id \
          linkedBy \
        } \
        solutionViolationReason { \
          id \
          linkedBy \
        } \
      } \
      contractor { \
        id \
      } \
      tasks { \
        id \
        _id \
        description \
        duration \
        archived \
        position \
        startedAt \
        completedAt \
        status \
        statusDescription \
        locked \
        viewedAt \
        receivedAt \
        reportedReason \
        order { \
          id \
        } \
        employee { \
          id \
        } \
        scheduling { \
          type \
          date \
          time \
        } \
        coords { \
          latitude \
          longitude \
        } \
        metadata \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('LocationSearchQuery', '\
    query LocationsQuery( \
      $where: LocationsWhereInput \
      $orderBy: LocationsOrderByEnum \
      $take: Int \
      $skip: Int \
    ) { \
      locations(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          name \
          archived \
          locked \
          documentNumber \
          customer { \
            name \
            metadata\
          } \
          createdAt \
          address { \
            zipCode \
            street \
            number \
            complement \
            neighborhood \
            city \
            state \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
          contacts { \
            phones { \
              id \
              number \
              type \
              primary \
            } \
            emails { \
              id \
              address \
              type \
              primary \
            } \
          } \
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('LocationGetOneQuery', '\
    query LocationQuery( \
      $id: ID! \
    ) { \
      location(id: $id) { \
        id \
        name \
        archived \
        documentNumber \
        notes \
        locked \
        customer { \
          id \
          name \
          metadata\
          primaryLocation { \
            id \
          } \
        } \
        address { \
          street \
          number \
          complement \
          postalCode \
          neighborhood \
          city \
          state \
          formattedAddress \
          coords { \
            latitude \
            longitude \
          } \
        } \
        contacts { \
          emails { \
            id \
            name \
            address \
            type \
            primary \
          } \
          phones { \
            id \
            name \
            countryCode \
            number \
            type \
            primary \
          } \
        } \
      } \
    }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('GroupsSearchQuery', '\
    query GroupQuery( \
      $where: GroupsWhereInput, \
      $orderBy: GroupsOrderByEnum, \
      $take: Int = 10, \
      $skip: Int = 0 \
    ) { \
      groups(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          name \
        } \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('GroupsGetOneQuery', '\
    query GroupQuery($id: ID!) {\
      group(id: $id) {\
        id \
        name \
      }\
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('ExpensesSearchQuery', '\
    query ExpensesSearchQuery( \
      $where: ExpenseWhereInput, \
      $orderBy: ExpenseOrderByInput, \
      $take: Int = 10, \
      $skip: Int = 0 \
    ) { \
      expenses(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        items { \
          id \
          name \
          description \
          maxValue \
          receiptRequired \
          createdBy { \
            id \
            name \
            type \
            avatarUrl \
          } \
          updatedBy { \
            id \
            name \
            type \
            avatarUrl \
          } \
        } \
        totalCount \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('ExpensesGetOneQuery', '\
    query ExpensesGetOneQuery($id: ID!) { \
      expense(id: $id) { \
      id \
        name \
        description \
        maxValue \
        receiptRequired \
        createdBy { \
          id \
          name \
          type \
          avatarUrl \
        } \
        updatedBy { \
          id \
          name \
          type \
          avatarUrl \
        } \
      } \
    }'
  );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('EquipmentsSearchQuery', '\
    query EquipmentsQuery( \
      $where: EquipmentsWhereInput \
      $orderBy: EquipmentsOrderByEnum \
      $take: Int \
      $skip: Int \
    ) { \
      equipments(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          name \
          number \
          imageUrl \
          notes \
          locked \
          qrCode \
          archived \
          createdAt \
          purchasedAt \
          installedAt \
          labels { \
            id \
            name \
            color \
          } \
          customer { \
            id \
            _id \
            name \
            notes \
            archived \
            createdAt \
            locked \
            metadata \
            documentNumber \
            avatarUrl \
            externalAppId \
            contact { \
              email \
              phone \
            } \
            address { \
              zipCode \
              street \
              number \
              complement \
              neighborhood \
              city \
              state \
              formattedAddress \
              coords { \
                latitude \
                longitude \
              } \
            } \
            statistics { \
              updatedAt \
              service { \
                firstAt \
                lastAt \
                total \
              } \
              rating { \
                lastStar \
                lastComment \
                averageStars \
              } \
            } \
            primaryLocation { \
              id \
            } \
          } \
          location { \
            id \
            name \
          } \
          type { \
            id \
            name \
            createdAt \
            archived \
          } \
          warrantySummary { \
            id \
            startDate \
            endDate \
            status \
          } \
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('EquipmentsGetOneQuery', '\
  query EquipmentQuery( \
    $id: ID! \
  ) { \
    equipment(id: $id) { \
      id \
      name \
      number \
      imageUrl \
      notes \
      locked \
      qrCode \
      archived \
      createdAt \
      purchasedAt \
      installedAt \
      labels { \
        id \
        name \
        color \
      } \
      customer { \
        id \
        _id \
        name \
        notes \
        archived \
        createdAt \
        locked \
        metadata \
        documentNumber \
        avatarUrl \
        externalAppId \
        contact { \
          email \
          phone \
        } \
        address { \
          zipCode \
          street \
          number \
          complement \
          neighborhood \
          city \
          state \
          formattedAddress \
          coords { \
            latitude \
            longitude \
          } \
        } \
        statistics { \
          updatedAt \
          service { \
            firstAt \
            lastAt \
            total \
          } \
          rating { \
            lastStar \
            lastComment \
            averageStars \
          } \
        } \
        primaryLocation { \
          id \
        } \
      } \
      location { \
        id \
        name \
        documentNumber \
        notes \
        archived \
        locked \
        account { \
          id \
        } \
        customer { \
          id \
        }, \
        address { \
          postalCode \
          street \
          number \
          neighborhood \
          city \
          state \
          complement \
          formattedAddress \
          coords { \
            latitude \
            longitude \
          } \
        } \
      } \
      type { \
        id \
        name \
        createdAt \
        archived \
      } \
      locationSector { \
        id \
        name \
        archived \
        createdAt \
        description \
        location { \
          id \
        } \
      } \
      locationEnvironment { \
        id \
        name \
        archived \
        createdAt \
        description \
        qrCode \
        location { \
          id \
        } \
        sector { \
          id \
        } \
      } \
      labels { \
        id \
        name \
        color \
        type \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('EmployeesSearchQuery', '\
    query EmployeesQuery( \
      $where: EmployeesWhereInput \
      $orderBy: EmployeesOrderByEnum \
      $take: Int \
      $skip: Int \
    ) { \
      employees(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          _id \
          name \
          documentNumber \
          notes \
          avatarUrl \
          email \
          emailValidatedAt \
          inactivatedAt \
          isInactivatedOrFired \
          createdAt \
          passwordExpiredAt \
          hasCredential \
          preferences { \
            language \
          } \
          address { \
            zipCode \
            street \
            number \
            city \
            state \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
          contract { \
            hiredAt \
            firedAt \
            active \
          } \
          device { \
            id \
            registration \
            appVersion \
            releaseVersion \
            platform \
          } \
          workSchedule { \
            start \
            end \
            break { \
              start \
              end \
            } \
            capacity \
          } \
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('EmployeesSearchWithTerritoriesQuery', '\
    query EmployeesQuery( \
      $where: EmployeesWhereInput \
      $orderBy: EmployeesOrderByEnum \
      $take: Int \
      $skip: Int \
    ) { \
      employees(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          _id \
          territories { \
            id \
            name \
            parentTerritory { \
              id \
              name \
            } \
          }\
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .constant('EmployeesGetOneQuery', '\
  query EmployeeQuery( \
    $id: ID! \
  ) { \
    employee(id: $id) { \
      id \
      _id \
      name \
      documentNumber \
      notes \
      avatarUrl \
      email \
      emailValidatedAt \
      inactivatedAt \
      createdAt \
      passwordExpiredAt \
      hasCredential \
      preferences { \
        language \
      } \
      address { \
        zipCode \
        street \
        number \
        city \
        state \
        formattedAddress \
        coords { \
          latitude \
          longitude \
        } \
      } \
      contract { \
        hiredAt \
        firedAt \
        active \
      } \
      device { \
        id \
        registration \
        appVersion \
        releaseVersion \
        platform \
      } \
      workSchedule { \
        start \
        end \
        break { \
          start \
          end \
        } \
        capacity \
      } \
      groups { \
        id \
        name \
      } \
    } \
  }');
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .constant('EmployeesUpdateMutation', '\
    mutation UpdateEmployeeMutation($input: UpdateEmployeeInput!) { \
      updateEmployee(input: $input) { \
        id \
        name \
        documentNumber \
      } \
    }'
    );
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('CustomerSearchQuery', '\
    query CustomersQuery ( \
      $where: CustomersWhereInput \
      $orderBy: CustomersOrderByEnum \
      $take: Int \
      $skip: Int \
    ) { \
      customers (where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          _id \
          name \
          notes \
          archived \
          createdAt \
          locked \
          metadata \
          documentNumber \
          avatarUrl \
          externalAppId \
          contact { \
            email \
            phone \
          } \
          address { \
            zipCode \
            street \
            number \
            complement \
            neighborhood \
            city \
            state \
            formattedAddress \
            coords { \
                latitude \
                longitude \
            } \
          } \
          statistics { \
            updatedAt \
            service { \
              firstAt \
              lastAt \
              total \
            } \
            rating { \
              lastStar \
              lastComment \
              averageStars \
            } \
          } \
          primaryLocation { \
            id \
          } \
          labels { \
            color \
            id \
            name \
          } \
          contacts { \
            phones { \
              id \
              number \
              type \
              primary \
              name \
              countryCode \
            } \
            emails { \
              id \
              address \
              type \
              primary \
              name \
            } \
          } \
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('CustomerGetOneQuery', ' \
    query CustomerQuery ($id: ID!) { \
      customer (id: $id) { \
        id \
        _id \
        name \
        notes \
        archived \
        createdAt \
        locked \
        metadata \
        documentNumber \
        avatarUrl \
        externalAppId \
        contact { \
          email \
          phone \
        } \
        address { \
          zipCode \
          street \
          number \
          complement \
          neighborhood \
          city \
          state \
          formattedAddress \
          coords { \
              latitude \
              longitude \
          } \
        } \
        statistics { \
          updatedAt \
          service { \
            firstAt \
            lastAt \
            total \
          } \
          rating { \
            lastStar \
            lastComment \
            averageStars \
          } \
        } \
        primaryLocation { \
          id \
          name \
          notes \
          archived \
          locked \
          createdAt \
          customer { \
            id \
          } \
          address { \
            postalCode \
            street \
            number \
            neighborhood \
            city \
            state \
            complement \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
        } \
        labels { \
          id \
          name \
          color \
          type \
        } \
        contacts { \
          phones { \
            id \
            number \
            type \
            primary \
            name \
            countryCode \
          } \
          emails { \
            id \
            address \
            type \
            primary \
            name \
          } \
        } \
        orderReportTemplate { \
          id \
          name \
          type \
          active \
          archived \
          createdAt \
          createdBy { \
            name \
            avatarUrl \
          } \
        } \
      } \
    } \
  ');
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('AbsencesSearchQuery', ' \
    query AbsencesQuery ( \
      $where: AbsencesWhereInput \
      $orderBy: AbsencesOrderByEnum \
      $take: Int \
      $skip: Int \
    ) { \
      absences (where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
        pageInfo { \
          hasNextPage \
          hasPreviousPage \
        } \
        totalCount \
        items { \
          id \
          from \
          to \
          reason \
          createdAt \
          account { \
            id \
          } \
          employee { \
            id \
            name \
            avatarUrl \
          } \
        } \
      } \
    } \
  ');
})();
(function () {
  'use strict';

  angular
  .module('app.core.api')
  .constant('AbsencesGetOneQuery', ' \
    query AbsenceQuery ($id: ID!) { \
      absence (id: $id) { \
        id \
        from \
        to \
        reason \
        createdAt \
        account { \
          id \
        } \
        employee { \
          id \
          name \
          avatarUrl \
        } \
      } \
    } \
  ');
})();
(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('StoragesMovementsTabController', StoragesMovementsTabController);

  /** @ngInject */
  function StoragesMovementsTabController(storagesMovementsApiGraphQL, $mdDialog, $document, $translate, $mdToast, LocalDateConvert) {
    var self = this;

    self.order = {};

    self.storagesMovements = [];
    self.take = 5;
    self.skip = 0;
    self.currentPage = 1;
    self.orderBy = 'createdAt_desc';
    self.totalPages = 0;
    self.totalCount = 0;
    self.productOrStorageNameContains = '';
    self.currentShowedStoragesMovements = self.take;
    self.loadingList = false;
    self.productId = null;
    self.dateFormat = LocalDateConvert.pickFormat('date-time');

    self.setControllerData = setControllerData;
    self.navigateToPage = navigateToPage;
    self.searchStoragesMovements = searchStoragesMovements;
    self.getLastStoragesMovementsCount = getLastStoragesMovementsCount;
    self.openEditStorageMovementDialog = openEditStorageMovementDialog;

    function setControllerData(order, productId) {
      self.order = order;
      self.productId = productId;

      _initialize();
    }

    function navigateToPage(isNextPage) {
      self.currentPage = isNextPage ? self.currentPage + 1 : self.currentPage - 1;
      self.skip = isNextPage ? self.skip + 5 : self.skip - 5;
      self.currentShowedStoragesMovements = self.skip + 5;

      searchStoragesMovements();
    }

    function searchStoragesMovements() {
      self.loadingList = true;
      _fetchStoragesMovements().then(function (response) {
        _setStoragesMovements(response);
      }).finally(function () {
        self.loadingList = false;
      });
    }

    function _fetchStoragesMovements() {
      var input = {
        orderBy: self.orderBy,
        take: self.take,
        skip: self.skip,
        where: {
          productOrStorageNameContains: self.productOrStorageNameContains,
          orderId: self.order.id,
          productId: self.productId
        }
      };

      return storagesMovementsApiGraphQL.search(input).then(function (response) {
        return response;
      });
    }

    function _setStoragesMovements(response) {
      self.storagesMovements = response && response.items ? response.items : [];
      self.totalCount = response.totalCount;
      self.totalPages = Math.ceil(self.totalCount / self.take);
    }

    function _initialize() {
      self.loadingList = true;
      _fetchStoragesMovements().then(function (response) {
        _setStoragesMovements(response);
      }).finally(function () {
        self.loadingList = false;
      });
    }

    function getLastStoragesMovementsCount() {
      return self.currentPage >= self.totalPages ? self.totalCount : self.currentPage * self.take;
    }

    function openEditStorageMovementDialog(storageMovement) {
      $mdDialog.show({
        controller: 'StorageMovementsModalComponent',
        controllerAs: 'self',
        templateUrl: 'app/main/tasks/dialogs/storage-movements-dialog/storage-movements-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        targetEvent: null,
        escapeToClose: false,
        multiple: true,
        locals: {
          order: self.order,
          storageMovement: storageMovement
        }
      }).then(function (result) {
        if (!result) { return; }

        self.searchStoragesMovements();

        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.SUCCESSFULLY_EDITED'))
            .hideDelay(2000)
        );
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('ServicesTabController', ServicesTabController);

  /** @ngInject */
  function ServicesTabController($mdDialog, $document, ordersApi, UtilityFunctions, orderServicesService, $rootScope, $scope, $mdToast, $q, $translate, omieApi) {
    var self = this;

    self.order = {};
    self.selectedCustomer = {};
    self.selectedService = {};

    self.services = [];
    self.linkedServices = [];
    self.servicesTotal = {};

    self.maxServicesPerOrder = 150;
    self.limit = 5;
    self.offset = 0;
    self.currentPage = 1;
    self.orderBy = 'name_asc';
    self.totalPages = 0;
    self.totalCount = 0;
    self.nameContains = '';
    self.currentShowedServices = self.limit;
    self.loadingList = false;

    self.openLinkServiceDialog = openLinkServiceDialog;
    self.setControllerData = setControllerData;
    self.openConfirmDeleteServiceDialog = openConfirmDeleteServiceDialog;
    self.parseValueToPrice = parseValueToPrice;
    self.setService = setService;
    self.orderByName = orderByName;
    self.getLastServiceCount = getLastServiceCount;
    self.navigateToPage = navigateToPage;
    self.searchServices = searchServices;

    function setControllerData(order, selectedCustomer, selectedService) {
      self.order = order;
      self.selectedCustomer = selectedCustomer;
      self.selectedService = selectedService;
      _initialize(order);
    }

    function openLinkServiceDialog() {
      $mdDialog.show({
        controller: 'LinkServicesDialogController',
        controllerAs: 'self',
        templateUrl: 'app/main/tasks/dialogs/link-services-dialog/link-services-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        targetEvent: null,
        escapeToClose: false,
        multiple: true,
        locals: {
          order: self.order,
          selectedCustomer: self.selectedCustomer,
          selectedService: self.selectedService
        }
      }).then(function (result) {
        if (!result) { return; }
        var servicesToInsert = _getServicesToInsert(result);
        self.loadingList = true;

        _calculateTotalValue(result);

        ordersApi.saveOrderServices(servicesToInsert, self.order.id).then(function () {
          _fetchServices().then(function (response) {
            _setServices(response, self.order);
          }).finally(function () {
            var message = $translate.instant('TASKS.DIALOG.TABS.SERVICES.LINKED_SUCESS');
            self.loadingList = false;

            $mdToast.show(
              $mdToast.simple()
                .textContent(message)
                .hideDelay(2000)
            );
          });
        });

        $scope.orderForm.$setDirty();
      });
    }

    $rootScope.$on('quotations:linked-new-data', function () {
      if (!self.order || !self.order.id) {
        return;
      }

      self.searchServices();
    });

    function _calculateTotalValue(services) {
      var isRemoving = self.services.includes(services);
      if (isRemoving) {
        self.order.servicesTotalValue = parseFloat((self.order.servicesTotalValue - services.totalValue).toFixed(2));
        self.order.totalValue = parseFloat((self.order.totalValue - services.totalValue).toFixed(2));
        return;
      }

      var addedServicesValue = services.reduce(function (acc, service) {
        return acc + parseFloat(service.value);
      }, 0);

      self.order.servicesTotalValue = parseFloat((self.order.servicesTotalValue + addedServicesValue).toFixed(2));
      self.order.totalValue = parseFloat((self.order.totalValue + addedServicesValue).toFixed(2));
    }

    function _getServicesToInsert(services) {
      return services.map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity
        };
      });
    }

    function openConfirmDeleteServiceDialog(service) {
      $mdDialog.show({
        controller: 'ConfirmDeleteProductServiceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/tasks/dialogs/confirm-delete-product-service-dialog/confirm-delete-product-service-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        targetEvent: null,
        escapeToClose: false,
        multiple: true,
        locals: {
          service: service
        }
      }).then(function (result) {
        if (!result) { return; }
        self.loadingList = true;

        _calculateTotalValue(service);
        orderServicesService.removeServiceToUpdate(service);

        ordersApi.deleteOrderService(service.item.id, self.order.id).then(function () {
          var isLastServiceOnThePage = (self.services && self.services.length === 1) && self.currentPage > 1;
          if (isLastServiceOnThePage) {
            self.currentPage = self.currentPage - 1;
            self.offset = self.offset - 5;
            self.currentShowedServices = self.offset + 5;
          }

          _fetchServices().then(function (response) {
            _setServices(response, self.order);
          }).finally(function () {
            var message = $translate.instant('TASKS.DIALOG.TABS.SERVICES.CONFIRM_DELETE_DIALOG.SUCESS');
            self.loadingList = false;

            $mdToast.show(
              $mdToast.simple()
                .textContent(message)
                .hideDelay(2000)
            );
          });
        });
      });
    }

    function setService(service) {
      if (!service.quantity || !(service.value || service.value === 0)) {
        return;
      }
      var totalValue = (service.quantity || 0) * service.value;
      self.order.totalValue = self.order.totalValue - service.totalValue;
      self.order.servicesTotalValue = self.order.servicesTotalValue - service.totalValue;
      service.totalValue = totalValue;
      self.order.totalValue = self.order.totalValue + service.totalValue;
      self.order.servicesTotalValue = self.order.servicesTotalValue + service.totalValue;
      orderServicesService.setService(service);
    }

    function parseValueToPrice(value) {
      return UtilityFunctions.parseValueToPrice(value);
    }

    function navigateToPage(isNextPage) {
      self.loadingList = true;
      self.currentPage = isNextPage ? self.currentPage + 1 : self.currentPage - 1;
      self.offset = isNextPage ? self.offset + 5 : self.offset - 5;
      self.currentShowedServices = self.offset + 5;

      _fetchServices().then(function (response) {
        _setServices(response, self.order);
      }).finally(function () {
        self.loadingList = false;
      });
    }

    function searchServices() {
      self.loadingList = true;
      _fetchServices().then(function (response) {
        _setServices(response, self.order);
      }).finally(function () {
        self.loadingList = false;
      });
    }

    function _fetchServices() {
      var input = {
        id: self.order.id,
        orderBy: self.orderBy,
        take: self.limit,
        skip: self.offset,
        whereProductsServices: {
          nameContains: self.nameContains
        }
      };

      return ordersApi.queryForOrderServices(input).then(function (response) {
        return response;
      });
    }

    function _setServices(response, order) {
      var services = response && response.services && response.services.items ? response.services.items : [];
      self.totalCount = response.services.totalCount;
      self.totalPages = Math.ceil(self.totalCount / self.limit);
      self.servicesTotal = response;
      self.services = _setServicesValues(services, orderServicesService.getServicesToUpdate());
      self.linkedServices = response && response.services && response.services.items ? response.services.items : [];
      orderServicesService.resetServices(self.linkedServices, order.id);
    }

    function _setServicesValues(services, changedServices) {
      changedServices.forEach(function (updateItem) {
        var index = services.findIndex(function (item) { return item.item.id === updateItem.item.id; });

        if (index !== -1) {
          services[index].quantity = updateItem.quantity;
          services[index].totalValue = parseFloat(updateItem.totalValue);
        }
      });
      return services;
    }

    function _initialize(order) {
      self.loadingList = true;
      _fetchServices().then(function (response) {
        _setServices(response, order);
        var deferred = $q.defer();

        omieApi.accounts
          .list()
          .then(function (res) {
            if (!res.data || !res.data.Items || !res.data.Items.length) {
              deferred.resolve([
                {
                  value: {
                    name: null,
                    appId: null,
                  },
                },
              ]);
              return;
            }

            var accounts = res.data.Items.map(function (item) {
              return {
                value: {
                  name: item.accountName,
                  appId: item.appId,
                },
              };
            });

            deferred.resolve(accounts);
          })
          .catch(function (error) {
            deferred.reject(error);
          });

        deferred.promise.then(function (accounts) {
          self.omieAccounts = accounts;

          _.forEach(self.linkedServices, function (service) {
            var accountValues = _.map(self.omieAccounts, 'value');
            var account = _.find(accountValues, { appId: service.item.externalAppId });
            var omieCustomerAccoutName = account ? account.name : null;
            service.item.omieAccount = omieCustomerAccoutName;
          });
        });
      }).finally(function () {
        self.loadingList = false;
      });
    }

    function getLastServiceCount() {
      return self.currentPage >= self.totalPages ? self.totalCount : self.currentPage * self.limit;
    }

    function orderByName() {
      if (self.orderBy === 'name_asc') {
        self.orderBy = 'name_desc';
      } else {
        self.orderBy = 'name_asc';
      }

      _fetchServices().then(function (response) {
        _setServices(response, self.order);
      }).finally(function () {
        self.loadingList = false;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('RoutesTabController', RoutesTabController);

  /** @ngInject */
  function RoutesTabController(leafletData, $translate, orderRoutesService) {
    var self = this;
    self.order = {};
    self.route = {};
    self.setControllerData = setControllerData;

    function setControllerData(order) {
      self.order = order;
      _initializeMap();
    }

    function _initializeMap() {
      self.route = orderRoutesService.getRoutes() || {};

      _configureMap();
      _setBounds();
    }

    function _configureMap() {
      self.map = {
        center: {
          lat: self.route.addresses && self.route.addresses[0].latitude,
          lng: self.route.addresses && self.route.addresses[0].longitude,
          zoom: 16
        },
        controls: {
          fullscreen: {
            position: 'topleft'
          }
        },
        markers: _getMarkers(),
        layers: {
          baselayers: {
            mapbox_standard: {
              name: $translate.instant('TASKS.DIALOG.TABS.ROUTES.MAP.LAYERS.DEFAULT'),
              url: 'https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                'showOnSelector': true
              }
            },
            mapbox_satellite: {
              name: $translate.instant('TASKS.DIALOG.TABS.ROUTES.MAP.LAYERS.SATELLITE'),
              url: 'https://mt0.google.com/vt/lyrs=y&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                'showOnSelector': true
              }
            },
            mapbox_roadmap: {
              name: $translate.instant('TASKS.DIALOG.TABS.ROUTES.MAP.LAYERS.ROADS'),
              url: 'https://mt0.google.com/vt/lyrs=h&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                'showOnSelector': true
              }
            },
            mapbox_terrain: {
              name: $translate.instant('TASKS.DIALOG.TABS.ROUTES.MAP.LAYERS.GROUND'),
              url: 'https://mt0.google.com/vt/lyrs=p&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                'showOnSelector': true
              }
            }
          }
        }
      };
    }

    function _getMarkers() {
      if (!self.route.addresses) {
        return {};
      }

      var andressesToPlot = self.route.addresses;
      var markers = {};
      var customerAvatarUrl = self.order.customer && self.order.customer.avatarUrl;
      var customerName = self.order.customer && self.order.customer.name;
      var uiAvatarUrl = customerAvatarUrl ? customerAvatarUrl : 'https://ui-avatars.com/api/?name=' + customerName;
      var i = 0;
      for (i = 0; i < andressesToPlot.length; i++) {
        markers['location' + i] = {
          lat: parseFloat(andressesToPlot[i].latitude),
          lng: parseFloat(andressesToPlot[i].longitude),
          draggable: false,
          message: andressesToPlot[i].formattedAddress,
          icon: {
            type: 'div',
            html: '<div>' +
              '<img src="' + uiAvatarUrl + '" style="width: 32px; height: 32px; border: 4px solid #0055FF; box-shadow: 0 0 5px 0 #0055FF; border-radius: 50%;">' +
              '</div>',
            iconAnchor: [16, 16],
            popupAnchor: [0, -16]
          },
        };
      }
      return markers;
    }

    function _setBounds() {
      if (!self.route.waypoints) {
        return;
      }

      var waypoints = self.route.waypoints;
      var boundsItems = [];

      for (var i = 0; i < waypoints.length; i++) {
        boundsItems.push([waypoints[i].latitude, waypoints[i].longitude]);
      }

      var bounds = L.latLngBounds(boundsItems);
      leafletData.getMap('routeMap').then(function (map) {
        map.fitBounds(bounds);
      });

      var polyline = {
        type: 'polyline',
        latlngs: boundsItems,
        color: '#0055FF',
        weight: 3,
      };

      self.paths = {
        polyline: polyline
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('QuotationsTabController', QuotationsTabController);

  /** @ngInject */
  function QuotationsTabController(
      QuotationsDialog, ordersApi, quotationsApi, accountsApi, accountFeatureFlagsApiGraphQL, $q,
      LocalDateConvert, $rootScope, $translate, CheckEditPermission, CurrencyService, FcModalService
    ) {
    var self = this;

    self.order = null;
    self.quotations = [];
    self.searchedQuotations = [];
    self.maxQuotationsAllowed = 5;
    self.isLoading = true;
    self.currencySymbol = CurrencyService.currencySymbol;

    self.setControllerData = setControllerData;
    self.searchQuotations = searchQuotations;
    self.createQuotation = createQuotation;
    self.addQuotation = addQuotation;
    self.seeQuotation = seeQuotation;
    self.removeQuotation = removeQuotation;
    self.hasQuotationsEquipmentsFeatureFlag = false;
    self.isLinkToOrderQuotationItemsConfigActive = false;
    self.isStorageControlModuleActive = false;

    hasFeatureFlag('quotations-equipments-beta-flag').then(function (flag) {
      self.hasQuotationsEquipmentsFeatureFlag = flag;
    });

    function setControllerData(order) {
      self.order = order;

      _loadQuotations().finally(function () {
        self.isLoading = false;
      });
    }

    function searchQuotations(searchTerm) {
      if (!searchTerm) {
        self.searchedQuotations = [];
        return;
      }

      $rootScope.loadingProgress = true;

      quotationsApi.search({
        where: {
          customerId: self.order.customer.id,
          nameOrIdentifierContains: searchTerm,
          archived: false,
        },
        orderBy: 'createdAt_desc',
        take: 5,
        skip: 0
      }).then(function (result) {
        self.searchedQuotations = _normalizeSearchedQuotations(result.items);
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function createQuotation($event) {
      if (!CheckEditPermission.hasPermission()) {
        return;
      }
      QuotationsDialog.createQuotationFromOrder($event, self.order, null, function (_, quotation) {
        if (quotation && quotation.id) {
          if (!self.hasQuotationsEquipmentsFeatureFlag || !self.isLinkToOrderQuotationItemsConfigActive || self.isStorageControlModuleActive) {
            return _loadQuotations();
          }

          showQuotationImportItemsDialog(quotation);
        }
      });
    }

    function addQuotation(quotation) {
      if (!CheckEditPermission.hasPermission()) {
        return;
      }

      if (!quotation || !quotation.id) {
        return;
      }

      if (!self.hasQuotationsEquipmentsFeatureFlag || !self.isLinkToOrderQuotationItemsConfigActive || self.isStorageControlModuleActive) {
        $rootScope.loadingProgress = true;
        self.searchedQuotations = [];

        ordersApi.saveQuotation(self.order.id, quotation.id).then(function () {
          return _loadQuotations();
        }).finally(function () {
          $rootScope.loadingProgress = false;
        });

        return;
      }

      showQuotationImportItemsDialog(quotation);
    }

    function showQuotationImportItemsDialog(quotation) {
      var CONFIRM_DIALOG_TRANSLATION_PATH = 'TASKS.DIALOG.TABS.QUOTATIONS.LINK_CONFIRM_DIALOG';

      FcModalService.open(null, {
        title: $translate.instant(CONFIRM_DIALOG_TRANSLATION_PATH + '.TITLE'),
        content: $translate.instant(CONFIRM_DIALOG_TRANSLATION_PATH + '.DESCRIPTION'),
        rightButtonText: $translate.instant(CONFIRM_DIALOG_TRANSLATION_PATH + '.YES'),
        paddingSmall: true,
        leftButtonText: $translate.instant(CONFIRM_DIALOG_TRANSLATION_PATH + '.NO'),
        handleRightButton: function () {
          importItemsFromQuotation(quotation);
        },
        handleLeftButton: function () {
          $rootScope.loadingProgress = true;
          self.searchedQuotations = [];

          ordersApi.saveQuotation(self.order.id, quotation.id).then(function () {
            return _loadQuotations();
          }).finally(function () {
            $rootScope.loadingProgress = false;
          });
        },
      });
    }

    function importItemsFromQuotation(quotation) {
      self.searchedQuotations = [];
      $rootScope.loadingProgress = true;

      _getQuotation(quotation.id).then(function (fullQuotation) {
        ordersApi.queryForAllOrderProducts(self.order.id).then(function (orderProductsServices) {
          var productServicessOnOrder = orderProductsServices || [];

          var productServicesIdsOnOrder = productServicessOnOrder.map(function (productService) {
            return productService.id;
          });

          var servicesToInsert = [];
          var productsToInsert = [];

          if (fullQuotation && fullQuotation.items && fullQuotation.items.length) {
            _.forEach(fullQuotation.items, function (quotationItem) {
              var productService = quotationItem && quotationItem.productService;
              var quantity = quotationItem.quantity;

              if (!quotationItem || !productService || !productService.id || !productService.type) {
                return;
              }

              if (productService.type === 'product') {
                productsToInsert.push({
                  id: productService.id,
                  quantity: quantity
                });

                return;
              }

              servicesToInsert.push({
                id: productService.id,
                quantity: quantity
              });
            });
          }

          var requests = {};

          productsToInsert = _.filter(productsToInsert, function (productService) {
            return !((productServicesIdsOnOrder || []).includes(productService.id));
          });

          servicesToInsert = _.filter(servicesToInsert, function (productService) {
            return !((productServicesIdsOnOrder || []).includes(productService.id));
          });

          if (productsToInsert && productsToInsert.length) {
            requests.products = ordersApi.saveOrderProducts(productsToInsert, self.order.id);
          }

          if (servicesToInsert && servicesToInsert.length) {
            requests.services = ordersApi.saveOrderServices(servicesToInsert, self.order.id);
          }

          requests.order = ordersApi.saveQuotation(self.order.id, quotation.id);

          return $q.all(requests).finally(function () {
            return _loadQuotations();
          });
        }).finally(function () {
          $rootScope.$broadcast('quotations:linked-new-data');
          $rootScope.loadingProgress = false;
        });
      });
    }

    function hasFeatureFlag(name) {
      return accountsApi.getCachedAccount().then(function (account) {
        self.isLinkToOrderQuotationItemsConfigActive = account.configuration ? Boolean(account.configuration.quotationsLinkItemsToOrderOn) : false;
        self.isStorageControlModuleActive = account.configuration ? Boolean(account.configuration.moduleStorageControlEnabled) : false;

        return accountFeatureFlagsApiGraphQL.getCachedFlagByName(name).then(function (flag) {
          if (!flag) { return false; }

          return flag.active;
        });
      });
    }

    function seeQuotation($event, quotation) {
      QuotationsDialog.editQuotation($event, quotation.id, null, function (reload) {
        if (reload) {
          return _loadQuotations();
        }
      });
    }

    function removeQuotation(quotation) {
      if (!CheckEditPermission.hasPermission()) {
        return;
      }
      if (!quotation || !quotation.id) {
        return;
      }

      $rootScope.loadingProgress = true;
      self.searchedQuotations = [];

      ordersApi.deleteQuotation(self.order.id, quotation.id).then(function () {
        return _loadQuotations();
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function _getQuotation(id) {
      return quotationsApi.getOne(id);
    }

    function _loadQuotations() {
      return quotationsApi.search({
        where: {
          orderId: self.order.id,
        },
        orderBy: 'createdAt_desc',
        take: 5,
        skip: 0
      }).then(function (result) {
        self.quotations = _normalizeQuotations(result.items);
      });
    }

    function _normalizeQuotations(quotations) {
      return quotations.map(function (quotation) {
        quotation.statusName = $translate.instant('TASKS.DIALOG.TABS.QUOTATIONS.STATUS.' + quotation.status.toUpperCase());
        if (quotation.approvedAt) { quotation.approvedAt = LocalDateConvert.formatDate(quotation.approvedAt, 'date'); }
        if (quotation.refusedAt) { quotation.refusedAt = LocalDateConvert.formatDate(quotation.refusedAt, 'date'); }

        quotation.products = _getProductsServicesTotal(quotation, 'product');
        quotation.services = _getProductsServicesTotal(quotation, 'service');

        quotation.subtotal = _toCurrency(quotation.subtotal);
        quotation.discount.total = _toCurrency(quotation.discount.total);
        quotation.total = _toCurrency(quotation.total);

        return quotation;
      });
    }

    function _normalizeSearchedQuotations(quotations) {
      return quotations.filter(function (searchedQuotation) {
        return !self.quotations.find(function (quotation) {
          return searchedQuotation.id === quotation.id;
        });
      }).map(function (quotation) {
        return {
          id: quotation.id,
          text: quotation.identifier + (quotation.name ? ' - ' + quotation.name : '')
        };
      });
    }

    function _getProductsServicesTotal(quotation, type) {
      var productsServices = quotation.items.filter(function (item) {
        return item.productService.type === type;
      });

      var quantity = productsServices.reduce(function (previousValue, currentValue) {
        return (previousValue += currentValue.quantity);
      }, 0);

      var total = productsServices.reduce(function (previousValue, currentValue) {
        return (previousValue += currentValue.total);
      }, 0);

      return {
        quantity: quantity,
        total: _toCurrency(total)
      };
    }

    function _toCurrency(value) {
      return self.currencySymbol + ' ' + value.toFixed(2).replace('.', ',');
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.tasks').controller('ProductsTabController', ProductsTabController);

  /** @ngInject */
  function ProductsTabController(
    $mdDialog,
    $document,
    ordersApi,
    $q,
    UtilityFunctions,
    orderProductsService,
    $scope,
    $mdToast,
    $translate,
    omieApi,
    accountCache,
    ProductsDialog,
    $rootScope
    ) {
    var self = this;

    self.order = {};
    self.selectedCustomer = {};
    self.selectedService = {};
    self.products = [];
    self.linkedProducts = [];
    self.productsTotal = {};

    self.maxProductsPerOrder = 150;
    self.limit = 5;
    self.offset = 0;
    self.currentPage = 1;
    self.orderBy = 'name_asc';
    self.totalPages = 0;
    self.totalCount = 0;
    self.nameContains = '';
    self.currentShowedProducts = self.limit;
    self.loadingList = false;
    self.account = null;
    self.hasStockModule = false;

    self.openLinkProductDialog = openLinkProductDialog;
    self.setControllerData = setControllerData;
    self.openConfirmDeleteProductDialog = openConfirmDeleteProductDialog;
    self.parseValueToPrice = parseValueToPrice;
    self.setTotalValue = setTotalValue;
    self.orderByName = orderByName;
    self.getLastProductCount = getLastProductCount;
    self.navigateToPage = navigateToPage;
    self.searchProducts = searchProducts;
    self.openLinkStorageMovementDialog = openLinkStorageMovementDialog;
    self.openProductDialog = openProductDialog;
    self.loadProducts = loadProducts;
    self.openReturnStorageMovementDialog = openReturnStorageMovementDialog;
    self.goToMovementsTab = goToMovementsTab;

    function setControllerData(order, selectedCustomer, selectedService) {
      self.order = order;
      self.selectedCustomer = selectedCustomer;
      self.selectedService = selectedService;
      _initialize(order);
    }

    function openLinkProductDialog() {
      $mdDialog
        .show({
          controller: 'LinkProductsDialogController',
          controllerAs: 'self',
          templateUrl: 'app/main/tasks/dialogs/link-products-dialog/link-products-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: true,
          targetEvent: null,
          escapeToClose: false,
          multiple: true,
          locals: {
            order: self.order,
            selectedCustomer: self.selectedCustomer,
            selectedService: self.selectedService,
          },
        })
        .then(function (result) {
          if (!result) {
            return;
          }
          var productsToInsert = _getProductsToInsert(result);
          self.loadingList = true;

          _calculateTotalValue(result);

          ordersApi.saveOrderProducts(productsToInsert, self.order.id).then(function () {
            _fetchProducts()
              .then(function (response) {
                _setProducts(response, self.order);
              })
              .finally(function () {
                var message = $translate.instant('TASKS.DIALOG.TABS.PRODUCTS.LINKED_SUCESS');
                self.loadingList = false;

                $mdToast.show($mdToast.simple().textContent(message).hideDelay(2000));
              });
          });

          $scope.orderForm.$setDirty();
        });
    }

    function _calculateTotalValue(products) {
      var isRemoving = self.products.includes(products);
      if (isRemoving) {
        self.order.productsTotalValue = parseFloat((self.order.productsTotalValue - products.totalValue).toFixed(2));
        self.order.totalValue = parseFloat((self.order.totalValue - products.totalValue).toFixed(2));
        return;
      }

      var addedProductsValue = products.reduce(function (acc, product) {
        return acc + parseFloat(product.value);
      }, 0);

      self.order.productsTotalValue = parseFloat((self.order.productsTotalValue + addedProductsValue).toFixed(2));
      self.order.totalValue = parseFloat((self.order.totalValue + addedProductsValue).toFixed(2));
    }

    function _getProductsToInsert(products) {
      return products.map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity
        };
      });
    }

    function openConfirmDeleteProductDialog(product) {
      $mdDialog
        .show({
          controller: 'ConfirmDeleteProductServiceDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/tasks/dialogs/confirm-delete-product-service-dialog/confirm-delete-product-service-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: true,
          targetEvent: null,
          escapeToClose: false,
          multiple: true,
          locals: {
            product: product,
          },
        })
        .then(function (result) {
          if (!result) {
            return;
          }
          self.loadingList = true;

          _calculateTotalValue(product);
          orderProductsService.removeProductToUpdate(product);

          ordersApi.deleteOrderProduct(product.item.id, self.order.id).then(function () {
            var isLastProductOnThePage = self.products && self.products.length === 1 && self.currentPage > 1;
            if (isLastProductOnThePage) {
              self.currentPage = self.currentPage - 1;
              self.offset = self.offset - 5;
              self.currentShowedProducts = self.offset + 5;
            }

            _fetchProducts()
              .then(function (response) {
                _setProducts(response, self.order);
              })
              .finally(function () {
                var message = $translate.instant('TASKS.DIALOG.TABS.PRODUCTS.CONFIRM_DELETE_DIALOG.SUCESS');
                self.loadingList = false;

                $mdToast.show($mdToast.simple().textContent(message).hideDelay(2000));
              });
          });
        });
    }

    function setTotalValue(product) {
      if (!product.quantity || !(product.value || product.value === 0)) {
        return;
      }

      var totalValue = product.quantity * product.value;
      self.order.totalValue = self.order.totalValue - product.totalValue;
      self.order.productsTotalValue = self.order.productsTotalValue - product.totalValue;
      product.totalValue = totalValue;
      self.order.totalValue = self.order.totalValue + product.totalValue;
      self.order.productsTotalValue = self.order.productsTotalValue + product.totalValue;
      orderProductsService.setProduct(product);
    }

    function parseValueToPrice(value) {
      return UtilityFunctions.parseValueToPrice(value);
    }

    function navigateToPage(isNextPage) {
      self.loadingList = true;
      self.currentPage = isNextPage ? self.currentPage + 1 : self.currentPage - 1;
      self.offset = isNextPage ? self.offset + 5 : self.offset - 5;
      self.currentShowedProducts = self.offset + 5;

      _fetchProducts()
        .then(function (response) {
          _setProducts(response, self.order);
        })
        .finally(function () {
          self.loadingList = false;
        });
    }

    function searchProducts() {
      self.loadingList = true;
      _fetchProducts()
        .then(function (response) {
          _setProducts(response, self.order);
        })
        .finally(function () {
          self.loadingList = false;
        });
    }

    function _fetchProducts() {
      var input = {
        id: self.order.id,
        orderBy: self.orderBy,
        take: self.limit,
        skip: self.offset,
        whereProductsServices: {
          nameContains: self.nameContains,
        },
      };

      return ordersApi.queryForOrderProducts(input).then(function (response) {
        return response;
      });
    }

    function _setProducts(response, order) {
      var products = response && response.productsV2 && response.productsV2.items ? response.productsV2.items : [];
      self.totalCount = response.productsV2.totalCount;
      self.totalPages = Math.ceil(self.totalCount / self.limit);
      self.productsTotal = response;
      self.products = _setProductsValues(products, orderProductsService.getProductsToUpdate());
      self.linkedProducts =
      response && response.productsV2 && response.productsV2.items ? response.productsV2.items : [];
      orderProductsService.resetProducts(self.linkedProducts, order.id);
    }

    function _setProductsValues(products, changedProducts) {
      changedProducts.forEach(function (updateItem) {
        var index = products.findIndex(function (item) {
          return item.item.id === updateItem.item.id;
        });

        if (index !== -1) {
          products[index].quantity = updateItem.quantity;
          products[index].totalValue = parseFloat(updateItem.totalValue);
        }
      });
      return products;
    }

    function _initialize(order) {
      self.loadProducts(order);
    }

    $scope.$on('quotations:linked-new-data', function () {
      if (!self.order || !self.order.id) {
        return;
      }

      self.loadProducts(self.order);
    });

    function loadProducts(order) {
      self.loadingList = true;

      accountCache.loadAccount().then(function (account) {
        self.account = account;

        self.hasStockModule =
        (self.account &&
          self.account.configuration &&
          self.account.configuration.moduleStorageControlEnabled) ||
          (self.account &&
            self.account.configuration &&
            self.account.configuration.featureStorageControlEnabledByCMMS);
      });

      _fetchProducts(order.id)
        .then(function (response) {
          _setProducts(response, order);
          var deferred = $q.defer();

          omieApi.accounts
            .list()
            .then(function (res) {
              if (!res.data || !res.data.Items || !res.data.Items.length) {
                deferred.resolve([
                  {
                    value: {
                      name: null,
                      appId: null,
                    },
                  },
                ]);
                return;
              }

              var accounts = res.data.Items.map(function (item) {
                return {
                  value: {
                    name: item.accountName,
                    appId: item.appId,
                  },
                };
              });

              deferred.resolve(accounts);
            })
            .catch(function (error) {
              deferred.reject(error);
            });

          deferred.promise.then(function (accounts) {
            self.omieAccounts = accounts;

            _.forEach(self.linkedProducts, function (product) {
              var accountValues = _.map(self.omieAccounts, 'value');
              var account = _.find(accountValues, { appId: product.item.externalAppId });
              var omieCustomerAccoutName = account ? account.name : null;
              product.item.omieAccount = omieCustomerAccoutName;
            });
          });
        })
        .finally(function () {
          self.loadingList = false;
        });
    }

    function getLastProductCount() {
      return self.currentPage >= self.totalPages ? self.totalCount : self.currentPage * self.limit;
    }

    function orderByName() {
      if (self.orderBy === 'name_asc') {
        self.orderBy = 'name_desc';
      } else {
        self.orderBy = 'name_asc';
      }

      _fetchProducts()
        .then(function (response) {
          _setProducts(response, self.order);
        })
        .finally(function () {
          self.loadingList = false;
        });
    }

    function openLinkStorageMovementDialog() {
      $mdDialog.show({
        controller: 'StorageMovementsModalComponent',
        controllerAs: 'self',
        templateUrl: 'app/main/tasks/dialogs/storage-movements-dialog/storage-movements-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        targetEvent: null,
        escapeToClose: false,
        multiple: true,
        locals: {
          order: self.order
        }
      }).then(function (result) {
        if (!result) {
          return;
        }

        self.loadProducts(self.order);

        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.SUCCESSFULLY_CREATED'))
            .hideDelay(2000)
        );
      });
    }

    function openProductDialog(ev, id) {
      ProductsDialog.editProduct(ev, { id: id }, function (reload) {
        if (reload) {
          self.loadProducts(self.order);
        }
      });
    }

    function openReturnStorageMovementDialog(productId) {
      $mdDialog.show({
        controller: 'ReturnOrderProductsModalComponent',
        controllerAs: 'self',
        templateUrl: 'app/main/tasks/dialogs/return-order-products-dialog/return-order-products-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        targetEvent: null,
        escapeToClose: false,
        multiple: true,
        locals: {
          orderId: self.order.id,
          productId: productId
        }
      }).then(function (result) {
        if (!result) {
          return;
        }

        self.loadProducts(self.order);
      });
    }

    function goToMovementsTab(productId) {
      $rootScope.$broadcast('go-to-movements-tab', productId);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('PendenciesTabController', PendenciesTabController);

  /** @ngInject */
  function PendenciesTabController($scope, orderPendenciesService, authenticatedUser, accountCache, $mdDialog, $mdToast, $document,
      $translate, ordersPendenciesApiGraphQL, $rootScope, $timeout, $location, $window) {
    var self = this;

    self.account = {};
    self.permissions = {};
    self.order = null;
    self.cursor = null;
    self.totalCount = 0;
    self.pendencies = [];
    self.pageInfo = null;
    self.setControllerData = setControllerData;
    self.openCreatePendencyDialog = openCreatePendencyDialog;
    self.openUpdateAssigneeModal = openUpdateAssigneeModal;
    self.loadMorePendencies = loadMorePendencies;
    self.navigateToPendency = navigateToPendency;

    _getAccount().then(function (account) {
      self.account = account;
      _setPermissions();
    });

    $scope.$on('orderPendenciesUpdated', function () {
      setControllerData();
    });

    function _getAccount() {
      return accountCache.loadAccount().then(function (account) {
        return account;
      });
    }

    function _setPermissions() {
      self.permissions = {
        canCreate: authenticatedUser.hasPermission(self.account, 'pendencies_create'),
        canEdit: authenticatedUser.hasPermission(self.account, 'pendencies_edit')
      };
    }

    function setControllerData(order) {
      if (!self.order) { self.order = order; }

      var pendencies = orderPendenciesService.getPendencies();
      self.cursor = pendencies.pageInfo.cursor;
      self.totalCount = pendencies.totalCount;
      self.pendencies = pendencies.items;
      self.pageInfo = pendencies.pageInfo;
    }

    function openCreatePendencyDialog() {
      $mdDialog.show({
        controller: 'CreateOrEditPendencyDialogComponent',
        controllerAs: 'self',
        templateUrl: 'app/main/tasks/dialogs/create-or-edit-pendency-dialog/create-or-edit-pendency-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        targetEvent: null,
        escapeToClose: false,
        multiple: true,
        locals: {
          order: self.order
        }
      }).then(function (result) {
        if (!result.pendency) { return; }
        self.totalCount++;
        self.pendencies.unshift(result.pendency);

        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('TASKS.DIALOG.TABS.PENDENCIES.' + result.message))
            .hideDelay(2000)
        );
      });
    }

    function openUpdateAssigneeModal(pendency) {
      $mdDialog.show({
        controller: 'UpdateAssigneeModalController',
        controllerAs: 'self',
        templateUrl: 'app/main/tasks/dialogs/update-pendency-assignee-modal/update-pendency-assignee-modal.html',
        parent: angular.element($document.body),
        targetEvent: null,
        clickOutsideToClose: false,
        escapeToClose: false,
        multiple: true,
        locals: {
          assignee: pendency.assignee,
          pendency: pendency
        }
      }).then(function (result) {
        if (!result) { return; }

        _updatePendencyData(result.pendency);

        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('TASKS.DIALOG.TABS.PENDENCIES.UPDATE_PENDENCY_ASSIGNEE.' + result.message))
            .hideDelay(2000)
        );
      });
    }

    function loadMorePendencies() {
      if (self.totalCount <= self.pendencies.length) { return; }

      $rootScope.loadingProgress = true;
      $timeout(function () {
        _getPendencies();
      }, 500);
    }

    function navigateToPendency(pendency) {
      $window.open('/painel/#/pendencias/' + pendency.id);
    }

    function _getPendencies() {
      var cursor = self.pageInfo ? self.pageInfo.endCursor : null;
      ordersPendenciesApiGraphQL.getPendencies(self.order.id, cursor, 10).then(function (result) {
        orderPendenciesService.setPendencies(result);
        self.pendencies = orderPendenciesService.getPendencies().items;
        self.pageInfo = orderPendenciesService.getPendencies().pageInfo;
        self.totalCount = orderPendenciesService.getPendencies().totalCount;
        $rootScope.loadingProgress = false;
      });
    }

    function _updatePendencyData(updatedPendency) {
      var pendencyToUpdateIndex = self.pendencies.findIndex(function (pendency) {
        return pendency.id === updatedPendency.id;
      });
      if (pendencyToUpdateIndex !== -1) {
        var pendencyToUpdate = self.pendencies[pendencyToUpdateIndex];

        self.pendencies.splice(pendencyToUpdateIndex, 1);
        pendencyToUpdate.assignee = updatedPendency.assignee;
        self.pendencies.unshift(pendencyToUpdate);
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('MaterialsTabController', MaterialsTabController);

  /** @ngInject */
  function MaterialsTabController(ordersApi, materialsApi, MeasuresOptions, orderMaterialsService, _, $mdToast, $translate, $mdDialog, CheckEditPermission) {
    var self = this;

    self.order = null;
    self.showMaterialMigration = false;
    self.orderMaterials = [];
    self.materials = [];
    self.selectedMaterialText = null;
    self.selectedMaterial = null;

    self.setControllerData = setControllerData;
    self.selectedMaterialItemChange = selectedMaterialItemChange;
    self.searchMaterials = searchMaterials;
    self.measuresOptions = MeasuresOptions;
    self.removeMaterial = removeMaterial;
    self.closeDialog = closeDialog;

    function setControllerData(order, accountConfiguration) {
      self.order = order;

      _orderMaterials();
      _checkShowMaterialMigration(accountConfiguration);
    }

    function searchMaterials(text) {
      return materialsApi.search({
        'archived': 'no',
        'name~~*': '*' + text + '*'
      }, { limit: 100 }).then(function (response) {
        return response.items;
      });
    }

    function selectedMaterialItemChange(selectedMaterial) {
      if (selectedMaterial) {
        if (!CheckEditPermission.hasPermission()) {
          self.selectedMaterialText = null;
          self.selectedMaterial = null;
          return;
        }
        orderMaterialsService.setMaterial(selectedMaterial, self.order);

        self.selectedMaterialText = null;
        self.selectedMaterial = null;
        self.orderMaterials = orderMaterialsService.getMaterials();
      }
    }

    function _orderMaterials() {
      orderMaterialsService.resetMaterials();
      ordersApi.getMaterials(self.order.id).then(function (response) {
        if (response.length) {
          _.forEach(response, function (item) {
            item.material.isLinked = true;
            orderMaterialsService.setMaterial(item.material, self.order);
          });
        }

        self.orderMaterials = orderMaterialsService.getMaterials();
      });
    }

    function removeMaterial(material) {
      if (!CheckEditPermission.hasPermission()) {
        return;
      }
      var toast = $mdToast.simple()
        .textContent($translate.instant('TASKS.DIALOG.MATERIALS.UNLINKED_MATERIAL'))
        .hideDelay(1500);

      if (self.order && self.order.id && material.isLinked) {
        return ordersApi.deleteMaterial(self.order.id, material.id).then(function () {
          self.orderMaterials = orderMaterialsService.deleteMaterial(material);
          $mdToast.show(toast);
        });
      }
      $mdToast.show(toast);
      self.orderMaterials = orderMaterialsService.deleteMaterial(material);
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function _checkShowMaterialMigration(accountConfiguration) {
      return materialsApi.search({
        'archived': 'no'
      }, { limit: 1 }).then(function (response) {
        self.showMaterialMigration = (accountConfiguration && !accountConfiguration.disableMaterials) && (response.totalItems !== 0);
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.tasks').controller('LinksTabController', LinksTabController);

  /** @ngInject */
  function LinksTabController(orderLinksService, $document, $mdDialog, $timeout, $translate) {
    var self = this;

    self.order = null;

    self.setControllerData = setControllerData;

    $timeout(function () {
      var openLaunchVideoDialog = document.querySelector('.open-launch-video-dialog');

      openLaunchVideoDialog.addEventListener('click', function () {
        $mdDialog.show({
          controller: 'LaunchVideoController',
          controllerAs: 'vm',
          templateUrl: 'app/core/dialogs/launch-video/launch-video.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          multiple: true,
          locals: {
            title: $translate.instant('LOCATIONS.DIALOG.LAUNCH_VIDEO.TITLE'),
            message: $translate.instant('LOCATIONS.DIALOG.LAUNCH_VIDEO.MESSAGE'),
            videoUrl: 'https://www.youtube.com/embed/VQE_FyV8Gf0?si=5--LRK3YoF_FqVGJ'
          }
        });
      });
    }, 1000);

    function setControllerData(order) {
      self.order = order;

      setListeners();

      removeListeners();
    }

    var orderLinksTabFn = function (value) {
      setOrderLinks(value.detail);
    };

    var openEditEquipmentFn = function (value) {
      emitEditEquipment(value.detail);
    };

    var openAnswerEquipmentFormsFn = function (value) {
      emitToggleSearchEquipmentsForms(value.detail);
    };

    var openEquipmentFormsFn = function (value) {
      emitToggleEquipmentsForms(value.detail);
    };

    function setListeners() {
      document.addEventListener('orderLinksTab', orderLinksTabFn);

      document.addEventListener('openEquipmentForms', openEquipmentFormsFn);

      document.addEventListener('openAnswerEquipmentForms', openAnswerEquipmentFormsFn);

      document.addEventListener('openEditEquipment', openEditEquipmentFn);
    }

    function removeListeners() {
      document.addEventListener('order-dialog:close', function () {
        document.removeEventListener('orderLinksTab', orderLinksTabFn);

        document.removeEventListener('openEquipmentForms', openEquipmentFormsFn);

        document.removeEventListener('openAnswerEquipmentForms', openAnswerEquipmentFormsFn);

        document.removeEventListener('openEditEquipment', openEditEquipmentFn);
      });
    }

    function setOrderLinks(value) {
      orderLinksService.setOrderLinks(value);
    }

    function emitToggleEquipmentsForms(value) {
      var event = new CustomEvent('equipment:toggleEquipmentsForms', { detail: value });

      document.dispatchEvent(event);
    }

    function emitToggleSearchEquipmentsForms(value) {
      var event = new CustomEvent('equipment:toggleSearchEquipmentsForms', { detail: value });

      document.dispatchEvent(event);
    }

    function emitEditEquipment(value) {
      var event = new CustomEvent('equipment:editEquipment', { detail: value });

      document.dispatchEvent(event);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.tasks')
        .controller('HistoricTabController', HistoricTabController);

    /** @ngInject */
    function HistoricTabController(tasksApi, taskTimelineConverter, TasksStatusHelper, LocalDateConvert) {
        var self = this;

        self.selectedTask = 0;
        self.dateFormat = LocalDateConvert.pickFormat('date');
        self.setControllerData = setControllerData;
        self.getTimelineLabel = getTimelineLabel;
        self.loadTimeline = loadTimeline;

        function setControllerData(task, tasks, allEmployees, order) {
            self.task = task;
            self.tasks = tasks;
            self.allEmployees = allEmployees;
            self.order = order;

            if (self.task.id) { loadTimeline(task); }
        }

        function loadTimeline(task) {
            if (task) { self.task = task; }
            if (!self.task._timeline) {
                tasksApi.getLogs(self.task.id).then(function (logs) {
                    self.task._timeline = taskTimelineConverter.toTimeline(self.task, logs, self.allEmployees, self.order);
                    self.timeline = self.task._timeline;
                });
            } else {
                self.timeline = self.task._timeline;
            }
        }

        function getTimelineLabel(task) {
            var label = '';
            label += LocalDateConvert.formatDate(task.scheduling.date, 'date');
            label += ' • ';
            if (task.employee && task.employee.id !== null && task.employee.id !== 'null') {
                var taskEmployee = _.find(self.employees, function (e) {
                    return e.id === task.employee.id;
                });
                if (taskEmployee) {
                    label += taskEmployee.name;
                }
            } else {
                label += 'Sem colaborador';
            }
            var taskStatus = TasksStatusHelper.getByName(task.status);
            label += " - ";
            label += "<span class='" + taskStatus.colorClass + "'>" + taskStatus.description + '</span>';
            if (task.archived) {
                label += '&nbsp;<span class="status-label md-red-900-bg">Arquivada</span>';
            }
            return label;
        }

    }
})();

(function () {
  'use strict';

  angular.module('app.tasks').controller('FormsTabController', FormsTabController);

  /** @ngInject */
  function FormsTabController() {
    var self = this;

    self.setControllerData = setControllerData;

    function setControllerData(order) {
      self.order = JSON.stringify(order);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('DeadlinesTabController', DeadlinesTabController);

  /** @ngInject */
  function DeadlinesTabController($filter, ordersApi, deadlineStatus, $translate, deadlineViolationsReasonsApi, LocalDateConvert, deadlineViolationsReasonsApiGraphQL, _) {
    var self = this;
    self.setControllerData = setControllerData;
    self.disabledReasonViolationResponse = false;
    self.disabledReasonViolationSolution = false;
    self.violationsReasons = [];
    self.contractOfficeDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    self.notConsideredOfficeDays = [];
    self.queryOptions = {
      skip: 0,
      take: 20
    };

    self.dayOrder = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    self.isEnterpriseOrder = false;
    self.enterpriseAccountName = null;
    self.featureDisableAddDeadlineViolationReason = false;
    self.isResponseViolationReasonLinkedByEnterprise = false;
    self.isSolutionViolationReasonLinkedByEnterprise = false;
    self.showResponseViolationReasonInput = true;
    self.showSolutionViolationReasonInput = true;

    function loadDeadline() {
      return ordersApi.getDeadline(self.order.id)
        .then(function (response) {
          return response;
        });
    }

    function getViolationsReason(id) {
      return deadlineViolationsReasonsApi.getOne(id, {})
        .then(function (response) {
          return response;
        });
    }

    function loadViolationsReasons() {
      deadlineViolationsReasonsApiGraphQL.search(self.queryOptions)
        .then(function (response) {
          if (response && response.items.length > 0) {
            _.map(response.items, function (item) { self.violationsReasons.push( { value: item }); });
          }
          if (response && response.items.length >= self.queryOptions.take) {
            self.queryOptions.skip += self.queryOptions.take;
            loadViolationsReasons();
          }
        });
    }

    function setControllerData(order) {
      self.order = order;

      self.isEnterpriseOrder = Boolean(
        order.metadata &&
        order.metadata.callbacks &&
        order.metadata.sammathnaur &&
        order.metadata.sammathnaur.account &&
        order.metadata.callbacks.includes('sammathnaur')
      );

      if (self.isEnterpriseOrder) {
        self.enterpriseAccountName = order.metadata &&
          order.metadata.sammathnaur &&
          order.metadata.sammathnaur.account &&
          order.metadata.sammathnaur.account.name;

        self.featureDisableAddDeadlineViolationReason = Boolean(
          order.metadata &&
          order.metadata.featureDisableAddDeadlineViolationReason
        );

        self.isResponseViolationReasonLinkedByEnterprise = Boolean(
          order.deadline &&
          order.deadline.responseViolationReason &&
          order.deadline.responseViolationReason.linkedBy === 'enterprise'
        );

        self.isSolutionViolationReasonLinkedByEnterprise = Boolean(
          order.deadline &&
          order.deadline.solutionViolationReason &&
          order.deadline.solutionViolationReason.linkedBy === 'enterprise'
        );

        if (order.deadline && order.deadline.contract && order.deadline.contract.id) {
          self.queryOptions.where = {
            deadlineContractIds: [order.deadline.contract.id]
          };
        }
      }

      loadDeadline().then(function (response) {
        var deadline = {};
        if (response && response.deadline) {
          deadline = response.deadline;
          deadline.contract = angular.copy(order.deadline.contract);
          self.deadline = rewriteSla(deadline);
          showViolationsReasons(self.deadline);

          self.officeHoursDisplay = getSortedOfficeHours();
        }

        if (self.order.deadline) {
          var orderDeadline = self.order.deadline;

          if (orderDeadline.responseViolationReason && orderDeadline.responseViolationReason.id) {
            var responseViolationReasonId = orderDeadline.responseViolationReason.id;
            getViolationsReason(responseViolationReasonId).then(function (response) {
              orderDeadline.responseViolationReason = response;
            });
          }

          if (orderDeadline.solutionViolationReason && orderDeadline.solutionViolationReason.id) {
            var solutionViolationReasonId = orderDeadline.solutionViolationReason.id;
            getViolationsReason(solutionViolationReasonId).then(function (response) {
              orderDeadline.solutionViolationReason = response;
            });
          }

          if (self.isEnterpriseOrder) {
            self.showResponseViolationReasonInput = self.disabledReasonViolationResponse || (!self.isResponseViolationReasonLinkedByEnterprise && !self.featureDisableAddDeadlineViolationReason);
            self.showSolutionViolationReasonInput = self.disabledReasonViolationSolution || (!self.isSolutionViolationReasonLinkedByEnterprise && !self.featureDisableAddDeadlineViolationReason);
          }
         }
      });

      loadViolationsReasons();
    }

    function getSortedOfficeHours() {
      var orderedOfficeHours = [];

      _.forEach(self.dayOrder, function (day) {
        if (self.deadline.contract.officeHours[day]) {
          orderedOfficeHours.push({ key: day, value: self.deadline.contract.officeHours[day] });
        }
      });

      return orderedOfficeHours;
    };

    function rewriteSla(deadline) {
      if (!deadline) {
        return {};
      }

      if (deadline.contract) {
        deadline.contract.officeHoursType = deadline.contract.hasOfficeHours ?
          $translate.instant('TASKS.DIALOG.TABS.DEADLINES.MODEL.OFFICE_HOURS.CUSTOMIZED') :
          $translate.instant('TASKS.DIALOG.TABS.DEADLINES.MODEL.OFFICE_HOURS.NO_CUSTOMIZE');

        deadline.contract.considerHoliday = deadline.contract.considerHoliday ?
          $translate.instant('TASKS.DIALOG.TABS.DEADLINES.MODEL.CONSIDER_HOLIDAYS.CONSIDER') :
          $translate.instant('TASKS.DIALOG.TABS.DEADLINES.MODEL.CONSIDER_HOLIDAYS.NO_CONSIDER');

        if (deadline.contract.responseDeadline) {
          deadline.contract.responseDeadline = $filter('durationFormat')(deadline.contract.responseDeadline);
        }

        self.notConsideredOfficeDays = self.contractOfficeDays.filter(function (day) {
          return !Object.keys(deadline.contract.officeHours).includes(day);
        });

        self.notConsideredOfficeDays.forEach(function (day) {
          deadline.contract.officeHours[day] = 'Not considered';
        });

        if (deadline.contract.responseDeadlineRisk) {
          deadline.contract.responseDeadlineRisk = $filter('durationFormat')(deadline.contract.responseDeadlineRisk);
        }

        if (deadline.contract.solutionDeadline) {
          deadline.contract.solutionDeadline = $filter('durationFormat')(deadline.contract.solutionDeadline);
        }

        if (deadline.contract.solutionDeadlineRisk) {
          deadline.contract.solutionDeadlineRisk = $filter('durationFormat')(deadline.contract.solutionDeadlineRisk);
        }
      }

      if (deadline.responseAt) {
        deadline.responseAt = LocalDateConvert.formatDate(deadline.responseAt, 'date-time');
      }

      if (deadline.solutionAt) {
        deadline.solutionAt = LocalDateConvert.formatDate(deadline.solutionAt, 'date-time');
      }

      if (deadline.firstTaskStartedAt) {
        deadline.firstTaskStartedAt = LocalDateConvert.formatDate(deadline.firstTaskStartedAt, 'date-time');
      }

      if (deadline.lastTaskCompletedAt) {
        deadline.lastTaskCompletedAt = LocalDateConvert.formatDate(deadline.lastTaskCompletedAt, 'date-time');
      }

      deadline.responseStatus = deadlineStatus.getStatus(deadline.responseStatus);
      deadline.solutionStatus = deadlineStatus.getStatus(deadline.solutionStatus);

      return deadline;
    }

    function showViolationsReasons(deadline) {
      var responseOutOfschedule = deadline.responseStatus && (deadline.responseStatus.name === 'completedOutOfSchedule' || deadline.responseStatus.name === 'outOfSchedule');
      if (!responseOutOfschedule) { self.disabledReasonViolationResponse = true; }

      var solutionOutOfschedule = deadline.solutionStatus && (deadline.solutionStatus.name === 'completedOutOfSchedule' || deadline.solutionStatus.name === 'outOfSchedule');
      if (!solutionOutOfschedule) { self.disabledReasonViolationSolution = true; }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.tasks').controller('CommentsTabController', CommentsTabController);

  /** @ngInject */
  function CommentsTabController($rootScope, ordersApi, focus, attachmentsUtils, MessageDialog, $, $timeout, _, $translate, CheckEditPermission, LocalDateConvert) {
    var self = this;
    self.comments = [];
    self.notLoadedComments = [];
    self.limit = 10;
    self.loading = false;
    self.firstLoading = true;
    self.loadedAllComments = false;
    self.validateCommentType = validateCommentType;
    self.dateFormat = LocalDateConvert.pickAltFormat('date-time');
    self.setControllerData = setControllerData;
    self.addComment = addComment;
    self.isMyOwnComment = isMyOwnComment;
    self.deleteComment = deleteComment;
    self.keyDownEvent = keyDownEvent;
    self.companyNameMetadata = companyNameMetadata;
    self.isMetadataFromSammathnaur = isMetadataFromSammathnaur;
    self.loadMoreComments = loadMoreComments;

    function _initialize() {
      $rootScope.$on('new:notification', loadComments);
    }

    function setControllerData(order, user) {
      self.order = order;
      self.user = user;
      self.sendingComment = false;

      self.user.avatarUrl = attachmentsUtils.correctUrl(self.user.picture);

      self.comment = {
        user: {
          id: self.user.id,
        },
        order: {
          id: self.order.id,
        },
        message: '',
        type: 'team',
      };

      loadComments().then(function () {
        _scrollToEndOfComments();
        self.firstLoading = false;
      });
    }

    function loadComments() {
      self.loading = true;

      return ordersApi
        .searchComments({
          orderId: self.order.id,
          orderBy: 'createdAt_desc',
          take: self.limit,
          skip: 0,
        })
        .then(function (result) {
          var comments = result.items;

          comments.forEach(function (comment) {
            if (comment && comment.postedBy) {
              comment.postedBy.avatarUrl = attachmentsUtils.correctUrl(comment.postedBy.avatarUrl);
            }
          });

          self.comments = _.filter(comments, function (comment) {
            return comment && comment.id;
          });

          self.loading = false;
          self.loadedAllComments = self.comments.length === result.totalCount;
          self.notLoadedComments = [];
        });
    }

    function validateCommentType(comment) {
      var isMyMessage = isMyOwnComment(comment);
      var isCorporate = comment.postedBy.type === 'corporate';

      var commentTypes = {
        collaborator:
          isMyMessage || isCorporate
            ? 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_COLLABORATORS'
            : 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_CORPORATE',
        corporate: isMyMessage
          ? 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_CORPORATE'
          : 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_MANAGER',
        internal: 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_INTERNAL',
        company: isMyMessage
          ? 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_MANAGER'
          : 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_CORPORATE_BY_MANAGER',
        team: isMyMessage ? 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_COLLABORATORS' : 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_MANAGER',
        public: 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_PUBLIC',
        manager: isMyMessage
          ? 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_MANAGER'
          : 'TASKS.DIALOG.TABS.COMMENTS.COMMENT_TO_CORPORATE_BY_MANAGER',
      };

      var translationKey = commentTypes[comment.type];
      var message = $translate.instant(translationKey);

      if (comment.type === 'corporate' && isMyMessage) {
        message += ' ' + self.companyNameMetadata();
      } else if (comment.type === 'collaborator' && !isMyMessage && !isCorporate) {
        message += ' ' + self.companyNameMetadata();
      }

      return message;
    }

    function loadMoreComments() {
      self.limit = self.limit + self.notLoadedComments.length + 10;

      loadComments();
    }

    function companyNameMetadata() {
      if (
        self.order.metadata &&
        self.order.metadata.sammathnaur &&
        self.order.metadata.sammathnaur.account &&
        self.order.metadata.sammathnaur.account.name
      ) {
        return self.order.metadata.sammathnaur.account.name;
      }
      return $translate.instant('TASKS.DIALOG.TABS.COMMENTS.CLIENT');
    }

    function isMetadataFromSammathnaur() {
      return Boolean(self.order.metadata && self.order.metadata.sammathnaur && self.order.metadata.sammathnaur.account);
    }

    function isMyOwnComment(comment) {
      if (comment && comment.postedBy && comment.postedBy.id) {
        return comment.postedBy.id === self.user._id;
      }
      return false;
    }

    function deleteComment(comment) {
      if (!CheckEditPermission.hasPermission()) {
        return;
      }
      ordersApi.deleteComment(comment).then(function () {
        MessageDialog.showToast({
          hideDelay: 7000,
          message: $translate.instant('TASKS.DIALOG.TABS.COMMENTS.TOASTS.COMMENT_DELETED'),
        });

        comment.archived = true;
      });
    }

    function addComment() {
      if (!CheckEditPermission.hasPermission()) {
        return;
      }

      self.sendingComment = true;

      ordersApi
        .saveComment(self.comment)
        .then(function (comment) {
          comment.postedBy.avatarUrl = attachmentsUtils.correctUrl(comment.postedBy.avatarUrl);
          self.comment.message = '';
          self.comments.push(comment);
          self.notLoadedComments.push(comment);
        })
        .then(_scrollToEndOfComments)
        .finally(function () {
          self.sendingComment = false;
          focus('text-area-comment');
        });
    }

    function keyDownEvent($event) {
      if (self.comment.message) {
        if ($event.keyCode === 13 && !$event.shiftKey && !$event.ctrlKey) {
          self.addComment();
        }
      }
    }

    function _scrollToEndOfComments() {
      setTimeout(function () {
        var commentsElement = document.querySelector('.comments__body');
        if (commentsElement) {
          commentsElement.scrollTop = commentsElement.scrollHeight;
        }
      }, 0);
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('AttachmentsTabController', AttachmentsTabController);

  /** @ngInject */
  function AttachmentsTabController(ordersApi, tasksApi, attachmentsUtils, uploadApi, msUtils, focus, MessageDialog, $translate, $mdToast, $rootScope, FcModalService, $timeout, $window, _, LocalDateConvert, CheckEditPermission) {
    var self = this;
    self.setControllerData = setControllerData;
    self.loading = true;

    self.attachments = [];
    self.files = [];
    self.filesToUpload = [];
    self.uploadProgress = false;
    self.videoTypes = ['mp4'];
    self.imageTypes = ['jpg', 'jpeg', 'png', 'heic', 'webp'];
    self.viewOriginalAttachment = viewOriginalAttachment;
    self.editAttachmentTitle = editAttachmentTitle;
    self.cancelEditAttachment = cancelEditAttachment;
    self.saveAttachmentTitle = saveAttachmentTitle;
    self.saveAttachmentWhenEnterKey = saveAttachmentWhenEnterKey;
    self.removeAttachment = removeAttachment;
    self.cancelRemoveAttachment = cancelRemoveAttachment;
    self.confirmRemoveAttachment = confirmRemoveAttachment;
    self.archiveAttachment = archiveAttachment;
    self.unarchiveAttachment = unarchiveAttachment;
    self.cancelArchiveAttachment = cancelArchiveAttachment;
    self.confirmArchiveAttachment = confirmArchiveAttachment;
    self.reorderAttachments = reorderAttachments;
    self.uploadImages = uploadImages;
    self.removeUploadedAttachment = removeUploadedAttachment;
    self.validateImage = validateImage;
    self.isFileTypeImage = msUtils.isFileTypeImage;
    self.isFileTypeVideo = msUtils.isFileTypeVideo;
    self.getIconByFileType = msUtils.getIconByFileType;
    self.fakeEditAttachmentTitle = fakeEditAttachmentTitle;
    self.dateFormat = LocalDateConvert.pickFormat('date');
    self.timeFormat = LocalDateConvert.pickFormat('time-seconds');

    function setControllerData(order, tasks, accountConfiguration) {
      self.order = order;
      self.tasks = tasks;
      self.firstTaskId = tasks && tasks[0] && tasks[0].id;
      self.accountConfiguration = accountConfiguration;
      $timeout(function () {
        _getAttachmentsFromOrder();
      }, 500);
    }

    function removeUploadedAttachment(attachmentIndex) {
      self.files.splice(attachmentIndex, 1);
    }

    function uploadImages() {
      var fakeUpload = function () {
        var attachmentsWithPreviews = _createAttachmentsWithPreviews(self.files);
        attachmentsWithPreviews.forEach(function (attachmentWithPreview) {
          self.attachments.push(attachmentWithPreview);
        });
        self.files = [];
        $rootScope.$emit('order:attachments-changed', { filesToUpload: self.filesToUpload, attachments: self.attachments });
        return null;
      };

      var upload = function () {
        if (!(self.files && self.files.length)) { return null; }
        if (!self.order.id) { return fakeUpload(); }

        _saveAttachmentsOnTask(self.files);
      };

      return upload();
    }

    function _saveAttachmentsOnTask(filesToUpload) {
      if (!filesToUpload) { filesToUpload = self.filesToUpload; }
      self.uploadProgress = true;
      var _totalUploadsFilesCount = filesToUpload.length;
      var _currentUploadsFilesCount = 0;

      filesToUpload.forEach(function (file, index) {
        uploadApi.uploadWithPreSignedPost({
          file: file,
          filePath: "/orders/" + self.order.id + "/tasks/" + self.firstTaskId + "/" + file.name.replace(/%20| /g, ''),
          $mdToast: $mdToast,
          $translate: $translate
        }, function () { })
          .then(function (result) {
            _currentUploadsFilesCount++;
            var currentPosition = self.attachments.length + (index + 1);
            var attachment = {
              path: result.path,
              task: {
                id: self.firstTaskId
              },
              size: file.size,
              type: result.contentType,
              position: currentPosition,
            };

            tasksApi.postAttachment(attachment.task.id, attachment).then(function () {
              var uploadsCompleted = _currentUploadsFilesCount >= _totalUploadsFilesCount;
              if (uploadsCompleted) {
                self.files = [];
                filesToUpload = [];
                self.uploadProgress = false;
                MessageDialog.showToast({
                  hideDelay: 3000,
                  message: $translate.instant('TASKS.TOASTS.ATTACHMENTS.IMAGES_UPLOADED')
                });
                _getAttachmentsFromOrder();
              }
            });
          })
          .catch(function (err) {
            if (err.status === 422) {
              self.uploadProgress = false;
              self.files = [];
              filesToUpload = [];
              showErrorModal();
            }
          });
      });
    }

    function _createAttachmentsWithPreviews() {
      return self.files.map(function (file, index) {
        self.filesToUpload.push(file);
        return {
          title: file.title,
          type: file.type,
          position: ++index,
          archived: false,
          fullPath: URL.createObjectURL(file) || ''
        };
      });
    }

    function viewOriginalAttachment(path) {
      $timeout(function () {
        $window.open(path, '_blank');
      }, 250);
    }

    function archiveAttachment(attachment) {
      attachment.editing = false;
      attachment.archiving = true;
      attachment.title = attachment._previousTitle;
    }

    function confirmArchiveAttachment(attachment) {
      $rootScope.loadingProgress = true;
      attachment.index = _.indexOf(self.attachments, attachment);

      if (attachment.type !== 'signature') {
        tasksApi.archiveAttachment(attachment.task.id, attachment.id).then(function () {
          self.attachments[attachment.index].archived = true;
          self.attachments[attachment.index]['open-archive-' + attachment.index] = '';
          _orderAttachments();

          MessageDialog.showToast({
            hideDelay: 10000,
            message: $translate.instant('TASKS.TOASTS.ATTACHMENTS.SUCCESSFULLY_ARCHIVED')
          });
        });
      }

      $rootScope.loadingProgress = false;
    }

    function cancelArchiveAttachment(attachment) {
      attachment.archiving = false;
    }

    function unarchiveAttachment(attachment) {
      $rootScope.loadingProgress = true;
      attachment.index = _.indexOf(self.attachments, attachment);

      if (attachment.type !== 'signature') {
        tasksApi.unarchiveAttachment(attachment.task.id, attachment.id).then(function () {
          self.attachments[attachment.index].archived = false;
          _orderAttachments();

          MessageDialog.showToast({
            hideDelay: 10000,
            message: $translate.instant('TASKS.TOASTS.ATTACHMENTS.SUCCESSFULLY_UNARCHIVED')
          });
        });
      }

      $rootScope.loadingProgress = false;
    }

    function reorderAttachments(actualIndex, action) {
      $rootScope.loadingProgress = true;

      if (action === 'up') {
        self.attachments[actualIndex].position -= 1;
        self.attachments[actualIndex - 1].position += 1;
      } else if (action === 'down') {
        self.attachments[actualIndex].position += 1;
        self.attachments[actualIndex + 1].position -= 1;
      }

      var onlyAttachments = _.filter(self.attachments, function (attachment) {
        return attachment.type !== 'signature';
      });

      if (!self.order.id) { return null; }
      ordersApi.reorderAttachments(self.order.id, onlyAttachments).then(function () {
        $rootScope.loadingProgress = false;
        self.attachments = _.sortBy(self.attachments, function (attachment) { return attachment.position; });
      });
    }

    function editAttachmentTitle(attachment) {
      attachment.editing = true;
      attachment.removing = false;
      attachment._previousTitle = attachment.title;
      focus("attachment_" + attachment.id);
    }

    function cancelEditAttachment(attachment) {
      attachment.title = attachment._previousTitle;
      attachment.editing = false;
    }

    function fakeEditAttachmentTitle(attachment, $index){
      attachment.editing = false;
      attachment.removing = false;
      uploadImages();
    }

    function saveAttachmentTitle(attachment) {
      $rootScope.loadingProgress = true;

      if (attachment.type !== 'signature') {
        tasksApi.updateAttachment(attachment.task.id, attachment.id, { title: attachment.title }).then(function () {
          attachment.editing = false;
          attachment.removing = false;
          MessageDialog.showToast({
            hideDelay: 4000,
            message: $translate.instant('TASKS.TOASTS.ATTACHMENTS.TITLE_UPDATED')
          });
        }).finally(function () {
          $rootScope.loadingProgress = false;
        });
      } else {
        var payload = {
          id: attachment.id,
          name: attachment.title,
          path: attachment.path
        };
        if (!self.order.id) { return null; }
        ordersApi.updateSignature(self.order.id, payload).then(function () {
          attachment.editing = false;
          attachment.removing = false;
        }).finally(function () {
          $rootScope.loadingProgress = false;
        });
      }
    }

    function saveAttachmentWhenEnterKey(e, attachment) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if(!self.order.id){
          return fakeEditAttachmentTitle(attachment);
        }
        self.saveAttachmentTitle(attachment);

        return false;
      }
    }

    function removeAttachment(attachment) {
      attachment.editing = false;
      attachment.removing = true;
      attachment.title = attachment._previousTitle;
    }

    function confirmRemoveAttachment(attachment) {
      $rootScope.loadingProgress = true;
      attachment.index = _.indexOf(self.attachments, attachment);
      if (!self.order.id) {
        $rootScope.loadingProgress = false;
        self.attachments.splice(attachment.index, 1);
        return self.filesToUpload.splice(attachment.index, 1);
      }

      if (attachment.type !== 'signature') {
        tasksApi.removeAttachment(attachment.task.id, attachment.id).then(function () {
          self.attachments.splice(attachment.index, 1);
          _orderAttachments();

          MessageDialog.showToast({
            hideDelay: 10000,
            message: $translate.instant('TASKS.TOASTS.ATTACHMENTS.SUCCESSFULLY_REMOVED')
          });
        });
      } else if (attachment.type == 'signature') {
        ordersApi.deleteSignature(self.order.id, attachment.id).then(function () {
          self.order.signature.path = null;
          self.attachments.splice(attachment.index, 1);

          MessageDialog.showToast({
            hideDelay: 10000,
            message: $translate.instant('TASKS.TOASTS.ATTACHMENTS.SIGNATURE_REMOVED')
          });
        });
      }

      $rootScope.loadingProgress = false;
    }

    function cancelRemoveAttachment(attachment) {
      attachment.removing = false;
    }

    function _orderAttachments() {
      if (!self.order.id) { return null; }
      var index = 1;
      var onlyAttachments = _.filter(self.attachments, function (attachment) {
        return attachment.type !== 'signature';
      });

      onlyAttachments.map(function (attachment) {
        attachment.position = index;
        index++;
      });

      ordersApi.reorderAttachments(self.order.id, onlyAttachments).then(function () {
        $rootScope.loadingProgress = false;
        self.attachments = _.sortBy(self.attachments, function (attachment) { return attachment.position; });
      });
    }

    function _getSignaturesFromOrder() {
      return ordersApi.getSignatures(self.order.id).then(function (signatures) {
        var resultSignatures = [];
        if (signatures && signatures.length) {
          signatures.forEach(function (signature) {
            var item = {
              id: signature.id,
              type: 'signature',
              path: signature.path,
              fullPath: attachmentsUtils.correctUrl(signature.path),
              title: signature.name || '',
              position: 999,
              metadata: { createdAt: signature.metadata.createdAt }
            };
            resultSignatures.push(item);
          });
        }
        return resultSignatures;
      });
    }

    function _getAttachmentsFromOrder() {
      if (!self.order.id) {
        self.loading = false;
        return null;
      }

      _getSignaturesFromOrder().then(function (signatures) {
        ordersApi.getAttachments(self.order.id).then(function (attachments) {
          var resultAttachments = [];

          var editingAttachment = _.find(self.attachments, function (attachment) {
            return attachment.editing;
          });

          if (attachments && attachments.length) {
            attachments.forEach(function (attachment, index) {
              if (attachment.position === 99) {
                attachment.position = ++index;
              }

              attachment.fullPath = attachmentsUtils.correctUrl(attachment.path);

              if (editingAttachment && editingAttachment.id === attachment.id) {
                attachment.editing = true;
                attachment.removing = false;
                attachment._previousTitle = attachment.title;
                attachment.title = editingAttachment.title;
                focus("attachment_" + attachment.id);
              }

              resultAttachments.push(attachment);
            });
          }

          var sortedAttachments = _.sortBy(resultAttachments, function (attachment) {
            return attachment.position;
          });
          self.attachments = sortedAttachments.concat(signatures);
        }).finally(function () {
          self.loading = false;
          checkForProcessing();
        });
      });
    }

    function validateImage(file) {
      var minImageSize = 1;
      var maxImageSize = 10000000;
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
      var isVideoOrImageFile = self.videoTypes.includes(extension) || file.type.includes('video') || self.imageTypes.includes(extension) || file.type.includes('image');

      if (isVideoOrImageFile) {
        maxImageSize = 52428800;
      }

      if (file.size <= minImageSize) {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('TASKS.DIALOG.TABS.ATTACHMENTS.MIN_SIZE_FILES'))
            .hideDelay(2000)
        );
        return false;
      }

      if (file.size > maxImageSize) {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant(isVideoOrImageFile ? 'TASKS.DIALOG.TABS.ATTACHMENTS.MAX_SIZE_BIG_FILES' : 'TASKS.DIALOG.TABS.ATTACHMENTS.MAX_SIZE_FILES'))
            .hideDelay(2000)
        );
        return false;
      }

      var invalidCharsRegex = /[<>!{}="';\\]|(?:\.{2})/;
      if (invalidCharsRegex.test(file.name)) {
        showErrorModal();
        return false;
      }

      return true;
    }

    function showErrorModal() {
      FcModalService.open('', {
        title: $translate.instant('TASKS.MODAL.ERROR.TITLE'),
        content: $translate.instant('TASKS.MODAL.ERROR.CONTENT'),
        rightButtonText: $translate.instant('TASKS.MODAL.ERROR.OK'),
        handleRightButton: function (){
          FcModalService.close();
        },
      });
    }

    function checkForProcessing() {
      var processingAttachments = _.filter(self.attachments, function (attachment) {
        return attachment.status === 'processing';
      });

      if (!processingAttachments.length) { return null; }

      setTimeout(_getAttachmentsFromOrder, 4000);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {

    $stateProvider

      .state('app.settings', {
        url: '/configuracoes',
        views: {
          'content@app': {
            templateUrl: 'app/main/settings/settings.html',
            controller: 'SettingsController as vm'
          }
        },
        data: { titleTranslateKey: 'CONFIGURATIONS.PAGE_TITLE' },
        resolve: {
          Account: function (accountsApi) {
            return accountsApi.get();
          },
          Users: function (usersApi) {
            return usersApi.search({ take: 100 });
          },
          Labels: function (labelsApi) {
            return labelsApi.search({ type: 'orders,customers' }, { limit: 100 });
          }
        }
      })

      .state('app.settings.accountInfo', {
        url: '/dados-da-empresa',
        views: {
          'settingsPanelContent': {
            templateUrl: 'app/main/settings/contents/account-info/account-info.html',
            controller: 'AccountInfoController as vm'
          }
        },
        data: { titleTranslateKey: 'CONFIGURATIONS.ACCOUNT.PAGE_TITLE' },
      })

      .state('app.settings.labelsManager', {
        url: '/etiquetas',
        views: {
          'labelsManagerContent': {
            templateUrl: 'app/main/settings/contents/labels-manager/labels-manager.html',
            controller: 'LabelsManagerController as vm'
          }
        },
        data: { titleTranslateKey: 'CONFIGURATIONS.LABELS_MANAGER.PAGE_TITLE' },
      })

      .state('app.settings.devSettings', {
        url: '/configuracao-para-desenvolvedores',
        views: {
          'settingsPanelContent': {
            templateUrl: 'app/main/settings/contents/dev-settings.html',
            controller: 'SettingsController as vm'
          }
        },
        data: { titleTranslateKey: 'CONFIGURATIONS.DEV_SETTINGS.PAGE_TITLE' },
      })

      .state('app.settings.devWebhookCallbacks', {
        url: '/historico-eventos-de-integracao',
        views: {
          'settingsPanelContent': {
            templateUrl: 'app/main/settings/contents/dev-webhooks-callbacks.html',
            controller: 'SettingsController as vm'
          }
        },
        data: { titleTranslateKey: 'CONFIGURATIONS.WEBHOOKS_CALLBACKS.PAGE_TITLE' },
      })

      .state('app.settings.integrations', {
        url: '/integracoes',
        views: {
          'settingsPanelContent': {
            templateUrl: 'app/main/settings/contents/integrations/integrations.html',
            controller: 'IntegrationsController as vm'
          }
        },
        data: { titleTranslateKey: 'APPS.PAGE_TITLE' },
      })

      .state('app.settings.serviceOrder', {
        url: '/ordens-de-servico',
        views: {
          'settingsPanelContent': {
            templateUrl: 'app/main/settings/contents/service-order.html',
            controller: 'SettingsController as vm'
          }
        },
        data: { titleTranslateKey: 'CONFIGURATIONS.ORDERS.PAGE_TITLE' },
      })

      .state('app.settings.timeline', {
        url: '/linha-do-tempo',
        views: {
          'settingsPanelContent': {
            templateUrl: 'app/main/settings/contents/timeline.html',
            controller: 'SettingsController as vm'
          }
        },
        data: { titleTranslateKey: 'CONFIGURATIONS.GANTT.PAGE_TITLE' },
      })

      .state('app.settings.cellphone', {
        url: '/aplicativo-do-celular',
        views: {
          'settingsPanelContent': {
            templateUrl: 'app/main/settings/contents/mobile-app.html',
            controller: 'SettingsController as vm'
          }
        },
        data: { titleTranslateKey: 'CONFIGURATIONS.MOBILE.PAGE_TITLE' },
      })

      .state('app.settings.otherConfig', {
        url: '/outras',
        views: {
          'settingsPanelContent': {
            templateUrl: 'app/main/settings/contents/others-config.html',
            controller: 'SettingsController as vm'
          }
        },
        data: { titleTranslateKey: 'CONFIGURATIONS.OTHERS.PAGE_TITLE' },
      });

    $translatePartialLoaderProvider.addPart('app/main/settings');
    $translatePartialLoaderProvider.addPart('app/main/settings/contents/integrations');
  }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .factory('WebhookResponseDetailsDialog', WebhookResponseDetailsDialog);

    /** @ngInject */
    function WebhookResponseDetailsDialog($mdDialog, $document) {

        return {
            open: open
        };

        function open(ev, webhook) {
            $mdDialog.show({
                controller: 'WebhookResponseDetailsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/dialogs/webhooks/response-details/webhook-response-details-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    webhook: webhook
                },
                closeTo: {
                  top: 0,
                  left: window.innerWidth,
                  width: window.innerWidth,
                  height: window.innerHeight / 1.8
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular
    .module('app.settings')
    .controller('WebhookResponseDetailsDialogController', WebhookResponseDetailsDialogController);

    /** @ngInject */
    function WebhookResponseDetailsDialogController(webhook, $mdDialog, MessageDialog, $translate) {

        var vm = this;
        vm.webhookResponse = webhook;
        vm.closeDialog = closeDialog;
        vm.tryGetPayloadAsObject = tryGetPayloadAsObject;
        vm.onCopyClipboard = onCopyClipboard;

        function tryGetPayloadAsObject(payload) {
            try {
                return JSON.parse(payload);
            } catch (err) {
                return payload;
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function onCopyClipboard(success) {
          var message = success
            ? 'CONFIGURATIONS.DIALOGS.WEBHOOKS.COPY.SUCCESS'
            : 'CONFIGURATIONS.DIALOGS.WEBHOOKS.COPY.FAILURE';
          MessageDialog.showToast({
            hideDelay: 5000,
            message: $translate.instant(message)
          });
        }
    }

})();

(function () {
    'use strict';

    angular.module('app.settings')
        .factory('DeleteWebhookDialog', DeleteWebhookDialog);

    /** @ngInject */
    function DeleteWebhookDialog($mdDialog, $document) {

        return {
            open: open
        };

        function open(ev, webhook) {
            return $mdDialog.show({
                controller: 'DeleteWebhookDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/dialogs/webhooks/delete/delete-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    webhook: webhook
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('DeleteWebhookDialogController', DeleteWebhookDialogController);

    /** @ngInject */
    function DeleteWebhookDialogController($rootScope, webhook, $mdDialog, webhookApi) {

        var vm = this;
        vm.webhook = webhook;
        vm.closeDialog = closeDialog;
        vm.deleteWebhook = deleteWebhook;

        function deleteWebhook() {
            $rootScope.loadingProgress = true;
            webhookApi.delete(vm.webhook.id).finally(function () {
                closeDialog(true);
            }).finally(function (){
                $rootScope.loadingProgress = false;
            });
        }

        function closeDialog(reload) {
            $mdDialog.hide(reload);
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.settings')
        .factory('CreateWebhookDialog', CreateWebhookDialog);

    /** @ngInject */
    function CreateWebhookDialog($mdDialog, $document) {

        return {
            open: open
        };

        function open(ev) {
            return $mdDialog.show({
                controller: 'CreateWebhookDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/dialogs/webhooks/create/create-webhook-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {}
            });
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.settings')
    .controller('CreateWebhookDialogController', CreateWebhookDialogController);

  /** @ngInject */
  function CreateWebhookDialogController(_, $rootScope, $mdDialog, webhookApi, $translate) {
    var vm = this;
    vm.auth = {};
    vm.authenticationTypes = [
      {
        translate: $translate.instant('CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.AUTH.NONE'),
        value: 'none'
      },
      {
        translate: 'HTTP Basic Authentication',
        value: 'HTTP Basic Authentication'
      }
    ];
    var baseTranslate = 'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.TYPES.';

    vm.webhooks = [
      { value: 'order-form-created', translate: baseTranslate + 'ORDER_FORM_CREATED', description: baseTranslate + 'ORDER_FORM_CREATED_DESCRIPTION' },
      { value: 'order-form-updated', translate: baseTranslate + 'ORDER_FORM_UPDATED', description: baseTranslate + 'ORDER_FORM_UPDATED_DESCRIPTION' },
      { value: 'order-attachment-created', translate: baseTranslate + 'ORDER_ATTACHMENT_CREATED', description: baseTranslate + 'ORDER_ATTACHMENT_CREATED_DESCRIPTION' },
      { value: 'order-attachment-updated', translate: baseTranslate + 'ORDER_ATTACHMENT_UPDATED', description: baseTranslate + 'ORDER_ATTACHMENT_UPDATED_DESCRIPTION' },
      { value: 'order-created', translate: baseTranslate + 'ORDER_CREATED', description: baseTranslate + 'ORDER_CREATED_DESCRIPTION' },
      { value: 'order-updated', translate: baseTranslate + 'ORDER_UPDATED', description: baseTranslate + 'ORDER_UPDATED_DESCRIPTION' },
      { value: 'task-created', translate: baseTranslate + 'TASK_CREATED', description: baseTranslate + 'TASK_CREATED_DESCRIPTION' },
      { value: 'task-updated', translate: baseTranslate + 'TASK_UPDATED', description: baseTranslate + 'TASK_UPDATED_DESCRIPTION' },
      { value: 'task-started', translate: baseTranslate + 'TASK_STARTED', description: baseTranslate + 'TASK_STARTED_DESCRIPTION' },
      { value: 'task-reported', translate: baseTranslate + 'TASK_REPORTED', description: baseTranslate + 'TASK_REPORTED_DESCRIPTION' },
      { value: 'task-completed', translate: baseTranslate + 'TASK_COMPLETED', description: baseTranslate + 'TASK_COMPLETED_DESCRIPTION' },
      { value: 'task-rated', translate: baseTranslate + 'TASK_RATED', description: baseTranslate + 'TASK_RATED_DESCRIPTION' },
      { value: 'task-start-route', translate: baseTranslate + 'TASK_START_ROUTE', description: baseTranslate + 'TASK_START_ROUTE_DESCRIPTION' },
      { value: 'task-route-started', translate: baseTranslate + 'TASK_ROUTE_STARTED', description: baseTranslate + 'TASK_ROUTE_STARTED_DESCRIPTION' },
      { value: 'comment-created', translate: baseTranslate + 'COMMENT_CREATED', description: baseTranslate + 'COMMENT_CREATED_DESCRIPTION' },
      { value: 'employee-created', translate: baseTranslate + 'EMPLOYEE_CREATED', description: baseTranslate + 'EMPLOYEE_CREATED_DESCRIPTION' },
      { value: 'ticket-accepted', translate: baseTranslate + 'TICKET_ACCEPTED', description: baseTranslate + 'TICKET_ACCEPTED_DESCRIPTION' },
      { value: 'ticket-canceled', translate: baseTranslate + 'TICKET_CANCELED', description: baseTranslate + 'TICKET_CANCELED_DESCRIPTION' },
      { value: 'ticket-created', translate: baseTranslate + 'TICKET_CREATED', description: baseTranslate + 'TICKET_CREATED_DESCRIPTION' },
      { value: 'quotation-created', translate: baseTranslate + 'QUOTATION_CREATED', description: baseTranslate + 'QUOTATION_CREATED_DESCRIPTION' },
      { value: 'quotation-canceled', translate: baseTranslate + 'QUOTATION_CANCELED', description: baseTranslate + 'QUOTATION_CANCELED_DESCRIPTION' },
      { value: 'quotation-updated', translate: baseTranslate + 'QUOTATION_UPDATED', description: baseTranslate + 'QUOTATION_UPDATED_DESCRIPTION' },
      { value: 'quotation-approved', translate: baseTranslate + 'QUOTATION_APPROVED', description: baseTranslate + 'QUOTATION_APPROVED_DESCRIPTION' },
      { value: 'quotation-refused', translate: baseTranslate + 'QUOTATION_REFUSED', description: baseTranslate + 'QUOTATION_REFUSED_DESCRIPTION' },
      { value: 'vehicle-created', translate: baseTranslate + 'VEHICLE_CREATED', description: baseTranslate + 'VEHICLE_CREATED_DESCRIPTION' },
      { value: 'vehicle-updated', translate: baseTranslate + 'VEHICLE_UPDATED', description: baseTranslate + 'VEHICLE_UPDATED_DESCRIPTION' },
    ];
    vm.toggleAllWebhooks = true;
    vm.allOptions = false;
    vm.selectedAllOptions = 'selectedAllOptions';
    vm.selectedWebhooks = [];
    vm.showCurrentPassword = false;

    vm.closeDialog = closeDialog;
    vm.createWebhook = createWebhook;
    vm.isBasicHttpAuth = isBasicHttpAuth;
    vm.toggleWebhook = toggleWebhook;
    vm.changeToggleAllWebhooks = changeToggleAllWebhooks;
    vm.isSelectedWebhook = isSelectedWebhook;
    vm.toggleCurrentPassword = toggleCurrentPassword;

    function createWebhook() {
      if (vm.auth.type === 'HTTP Basic Authentication') {
        vm.auth.type = 'httpBasicAuthentication';
        vm.options = {
          username: vm.auth.username,
          password: vm.auth.password
        };
      }

      var types = vm.toggleAllWebhooks ? [] : _.map(vm.selectedWebhooks, 'value');

      var newWebhook = {
        url: vm.url,
        authentication: {
          type: vm.auth.type || 'none',
          options: vm.options || undefined
        },
        types: types
      };

      $rootScope.loadingProgress = true;

      webhookApi.create(newWebhook).then(function () {
        closeDialog(true);
      }).finally(function (){
        $rootScope.loadingProgress = false;
      });
    }

    function toggleCurrentPassword() {
      vm.showCurrentPassword = !vm.showCurrentPassword;
    }

    function changeToggleAllWebhooks(value) {
      vm.toggleAllWebhooks = value;

      if (vm.toggleAllWebhooks) {
        vm.selectedWebhooks = [];
      }
    }

    function toggleWebhook(selectedWebhook) {
      vm.toggleAllWebhooks = false;

      var webhook = _.find(vm.selectedWebhooks, { value: selectedWebhook.value });

      if (!webhook) {
        vm.selectedWebhooks.push(selectedWebhook);

        return;
      }

      _.remove(vm.selectedWebhooks, webhook);
    }

    function isSelectedWebhook(webhook) {
      return _.find(vm.selectedWebhooks, { value: webhook.value });
    }

    function isBasicHttpAuth() {
      return vm.auth.type === 'HTTP Basic Authentication';
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.settings')
        .factory('DeleteApiKeyDialog', DeleteApiKeyDialog);

    /** @ngInject */
    function DeleteApiKeyDialog($mdDialog, $document) {

        return {
            open: open
        };

        function open(ev, key) {
            return $mdDialog.show({
                controller: 'DeleteApiKeyDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/dialogs/apikeys/delete/delete-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    key: key
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('DeleteApiKeyDialogController', DeleteApiKeyDialogController);

    /** @ngInject */
    function DeleteApiKeyDialogController(key, $rootScope, $mdDialog, apiKeyIntegrationApi) {

        var vm = this;
        vm.key = key;
        vm.closeDialog = closeDialog;
        vm.deleteApiKey = deleteApiKey;

        function deleteApiKey() {
            $rootScope.loadingProgress = true;
            apiKeyIntegrationApi.delete(vm.key.id).then(function () {
                closeDialog(true);
            }).finally(function (){
                $rootScope.loadingProgress = false;
            });
        }

        function closeDialog(reload) {
            $mdDialog.hide(reload);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.settings')
        .factory('ApiKeyDialog', ApiKeyDialog);

    /** @ngInject */
    function ApiKeyDialog($mdDialog, $document) {

        return {
            open: open
        };

        function open(ev) {
            return $mdDialog.show({
                controller: 'CreateApiKeyDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/dialogs/apikeys/create/create-apikey-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('CreateApiKeyDialogController', CreateApiKeyDialogController);

    /** @ngInject */
    function CreateApiKeyDialogController($rootScope, $mdDialog, apiKeyIntegrationApi) {

        var vm = this;
        vm.closeDialog = closeDialog;
        vm.createApiKey = createApiKey;
        vm.createdApiKey = null;

        function createApiKey() {
            $rootScope.loadingProgress = true;
            apiKeyIntegrationApi.create({ name: vm.newName }).then(function (createdApiKey) {
                vm.createdApiKey = createdApiKey;
            }).finally(function (){
                $rootScope.loadingProgress = false;
            });
        }

        function closeDialog() {
            if (vm.createdApiKey) {
                $mdDialog.hide(true);
            } else {
                $mdDialog.hide(false);
            }
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.settings')
    .controller('ResizeLogoDialogController', ResizeLogoDialogController);

  /** @ngInject */
  function ResizeLogoDialogController($mdDialog, avatarImage, minImageResolution) {
    var vm = this;
    vm.avatarImage = avatarImage;
    vm.minImageResolution = minImageResolution;
    vm.avatarResultImage = null;

    vm.closeDialog = closeDialog;
    vm.resize = resize;

    function closeDialog(result) {
      $mdDialog.hide(result);
    }

    function resize() {
      closeDialog(vm.avatarResultImage);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.recurrences', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State

        $stateProvider
            .state('app.recurrences', {
                url: '/atividades-recorrentes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/recurrences/recurrences.html',
                        controller: 'RecurrencesController as vm'
                    }
                },
                resolve: {
                    Account: function (accountsApi) {
                        return accountsApi.get();
                    }
                },
                data: { titleTranslateKey: 'RECURRENCES.PAGE_TITLE' },
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/recurrences');
    }
})();

(function () {
  'use strict';

  angular.module('app.recurrences').controller('RecurrencesLinksTabController', RecurrencesLinksTabController);

  /** @ngInject */
  function RecurrencesLinksTabController(recurrencesLinksService, $document, $mdDialog, $timeout, $translate, _) {
    var self = this;

    self.recurrence = null;

    self.setControllerData = setControllerData;

    $timeout(function () {
      var openLaunchVideoDialog = document.querySelector('.open-launch-video-dialog');

      if (!openLaunchVideoDialog) {
        return;
      }

      openLaunchVideoDialog.addEventListener('click', function () {
        $mdDialog.show({
          controller: 'LaunchVideoController',
          controllerAs: 'vm',
          templateUrl: 'app/core/dialogs/launch-video/launch-video.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          multiple: true,
          locals: {
            title: $translate.instant('LOCATIONS.DIALOG.LAUNCH_VIDEO.TITLE'),
            message: $translate.instant('LOCATIONS.DIALOG.LAUNCH_VIDEO.MESSAGE'),
            videoUrl: 'https://www.youtube.com/embed/VQE_FyV8Gf0?si=5--LRK3YoF_FqVGJ',
          },
        });
      });
    }, 1000);

    function setControllerData(recurrence) {
      self.recurrence = recurrence;

      setListeners();

      removeListeners();
    }

    var recurrenceLinksTabFn = function (value) {
      $timeout(function () {

        var detail = {
          sectors: value.detail.sectors || [],
          environments: value.detail.environments || [],
          equipments: value.detail.equipments || [],
        };

        setRecurrenceLinks(detail);

        if (self.recurrence) {
          self.recurrence.sectors = detail.sectors;
          self.recurrence.environments = detail.environments;
          self.recurrence.equipments = detail.equipments;
        }
      });
    };

    function setListeners() {
      document.addEventListener('recurrenceLinksTab', recurrenceLinksTabFn);
    }

    function removeListeners() {
      document.addEventListener('recurrence-dialog:close', function () {
        document.removeEventListener('recurrenceLinksTab', recurrenceLinksTabFn);
      });
    }

    function setRecurrenceLinks(value) {
      recurrencesLinksService.setRecurrenceLinks(value);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('QuotationAttachmentsService', QuotationAttachmentsService);

  /** @ngInject */
  function QuotationAttachmentsService(msUtils, $translate) {
    return {
      createFakeAttachment: createFakeAttachment,
      reorderAttachments: reorderAttachments
    };

    function createFakeAttachment(attachmentWithPreview, attachmentsLength) {
      attachmentWithPreview.id = msUtils.uuidGenerator();
      attachmentWithPreview.position = attachmentsLength + 1 || 0;
      attachmentWithPreview.archived = false;
      attachmentWithPreview.title = $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.NO_TITLE');
      attachmentWithPreview.createdAt = moment().utc().format();
      attachmentWithPreview.path = attachmentWithPreview.fullPath;

      return attachmentWithPreview;
    }

    function reorderAttachments(direction, attachmentId, nextOrPreviousAttachmentId, attachments) {
      return attachments.map(function (attachment) {
        if (attachment.id === attachmentId) {
          attachment.position = direction === 'up' ? attachment.position - 1 : attachment.position + 1;
        }
        if (attachment.id === nextOrPreviousAttachmentId) {
          attachment.position = direction === 'up' ? attachment.position + 1 : attachment.position - 1;
        }
        return attachment;
      }).sort(function (a, b) { return a.position - b.position; });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.quotations', [])
    .config(config)
    .directive('ngUploadChange', ngUploadChange);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.quotations', {
      url: '/orcamentos',
      views: {
        'content@app': {
          templateUrl: 'app/main/quotations/quotations.html',
          controller: 'QuotationsController as vm'
        }
      },
      data: { titleTranslateKey: 'QUOTATIONS.PAGE_TITLE' },
      resolve: {
        account: function (accountsApi) {
          return accountsApi.get();
        }
      }
    });
    $translatePartialLoaderProvider.addPart('app/main/quotations');
  }

  function ngUploadChange() {
    return {
      scope: {
        ngUploadChange: '&',
      },
      link: function ($scope, $element) {
        $element.on('change', function (event) {
          $scope.$apply(function () {
            $scope.ngUploadChange({ $event: event });
          });
        });

        $scope.$on('$destroy', function () {
          $element.off();
        });
      },
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.quotations')
    .component('quotationItemsEquipments', {
      templateUrl: 'app/main/quotations/dialogs/components/quotation-items-equipments/quotation-items-equipments.component.html',
      controller: quotationItemsEquipmentsController,
      controllerAs: 'vm',
      bindings: {
        quotation: '=',
        isCopy: '=',
        quotationForm: '<'
      }
    });

  function quotationItemsEquipmentsController(
    QuotationProductService, $locale, $scope,
    $rootScope, $timeout, _, ProductsServicesDialog,
    ProductsMeasuresOptions, msUtils, $translate, FcModalService, CurrencyService
  ) {
    var vm = this;
    var quotationProductService = QuotationProductService;
    var productsServicesDialog = ProductsServicesDialog;
    vm.measuresSelectOptions = ProductsMeasuresOptions.measures;

    vm.createProductService = productsServicesDialog.createProductService;
    vm.createProductServiceWithEquipment = productsServicesDialog.createProductServiceWithEquipment;
    vm.createProductServiceSetup = createProductServiceSetup;
    vm.resetAllProductsServices = quotationProductService.resetAllProductsServices;
    vm.hideButton = quotationProductService.disabled;

    vm.updateTotal = updateTotal;
    vm.addQuotationItem = addQuotationItem;
    vm.addQuotationEquipment = addQuotationEquipment;
    vm.searchProductService = searchProductService;
    vm.searchEquipments = searchEquipments;
    vm.removeItem = removeItem;
    vm.removeEquipment = removeEquipment;
    vm.findMeasureSelected = findMeasureSelected;
    vm.editProductService = editProductService;
    vm.setProductServiceInputDisabled = setProductServiceInputDisabled;
    vm.toggleExpanded = toggleExpanded;

    vm.productsServices = [];
    vm.equipmentsToPick = [];
    vm.items = [];
    vm.productsWithoutEquipments = [];
    vm.servicesWithoutEquipments = [];
    vm.quotationEquipments = [];
    vm.equipments = [];

    vm.broadcastUpdateTotal = _.debounce(function () {
      $timeout(function () { $rootScope.$broadcast('quotation:update:items'); }, 50);
    }, 500);

    vm.currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = vm.currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    _initialize();

    function _initialize() {
      vm.items = _.map(vm.quotation.items, function (quotItem) {
        var item = angular.copy(quotItem);

        item.expanded = true;

        return item;
      });

      vm.quotationEquipments = vm.quotation.quotationEquipments;

      _setEquipmentItems(vm.quotationEquipments);

      vm.broadcastUpdateTotal();

      if (vm.isCopy) {
        vm.items = vm.items.map(function (item) {
          return quotationProductService.addQuotationItem(item, true);
        });

        vm.quotationEquipments = vm.equipments.map(function (equipment) {
          return quotationProductService.addQuotationEquipment(equipment, true);
        });
      }

      _setProdutsAndServicesWithoutEquipments(vm.items);

      $scope.$on('quotation:customer:changed', function () {
        vm.selectedCustomer = quotationProductService.selectedCustomer;
      });

      $scope.$on('quotation:service-order:changed', function () {
        vm.selectedServiceOrder = quotationProductService.selectedServiceOrder;
      });

      $scope.$on('quotation:copied', function () {
        vm.selectedCustomer = quotationProductService.selectedCustomer;
      });

      $scope.$on('product-services:created', function (event, quotationItem) {
        vm.addQuotationItem(quotationItem, true, quotationItem.equipment ? quotationItem.equipment.id : null);
        _setFormDirty();
      });

      $scope.$on('product-services:edited', function (event, quotationItem) {
        vm.addQuotationItem(quotationItem);
      });
    }

    function toggleExpanded(arrayToUpdate, item) {
      arrayToUpdate = arrayToUpdate.map(function (arrayItem) {
        if (arrayItem.id === item.id) {
          arrayItem.expanded = !arrayItem.expanded;
        }

        return arrayItem;
      });
    }

    function _setEquipmentItems(array) {
      vm.equipments = _.map(array, function (baseEquipment, index) {
        var equipment = angular.copy(baseEquipment.equipment ? baseEquipment.equipment : baseEquipment);

        equipment.products = _.filter(vm.items, function (item) {
          return item.equipment && item.equipment.id === equipment.id && item.productService.type === 'product';
        });

        equipment.services = _.filter(vm.items, function (item) {
          return item.equipment && item.equipment.id === equipment.id && item.productService.type === 'service';
        });

        equipment.expanded = equipment.expanded || (baseEquipment.equipment && index === 0);

        return equipment;
      });
    }

    function getInputType(item) {
      var saveInputType;
      if (item.productService.type === 'product') {
        saveInputType = $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.UPDATE_BUDGET_TYPE_PRODUCT');
      } else if (item.productService.type === 'service') {
        saveInputType = $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.UPDATE_BUDGET_TYPE_SERVICE');
      }
      _setFormDirty();
      return saveInputType;
    }

    function modalOptionQuotation(item, callback) {
      var saveInputType = getInputType(item);

      FcModalService.open('', {
        title: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.UPDATE_BUDGET_TITLE'),
        content: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.UPDATE_BUDGET_CONTENT') + saveInputType + $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.UPDATE_BUDGET_TYPE_CONFIRM'),
        leftButtonText: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.QUESTION_DATA_LOSS_NO'),
        rightButtonText: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.QUESTION_DATA_LOSS_YES'),
        handleRightButton: function () {
          callback(true);
        },
        handleLeftButton: function () {
          callback(false);
        }
      });

      _setFormDirty();
    }

    function editProductService(ev, quotationItem) {
      productsServicesDialog.editProductService(ev, quotationItem, function (_, productService) {
        var productServiceId = productService.id;

        vm.items.find(function (item, index) {
          if (item.productService.id === productServiceId) {
            item.productService.imageUrl = productService.imageUrl;
            item.productService.name = productService.name;

            _setFormDirty();

            if ((item.description != productService.description) || (item.productService.value != productService.value)) {
              modalOptionQuotation(item, function (response) {
                if (response) {
                  item.description = productService.description;
                  item.total = productService.value * item.quantity;
                  item.productService.value = productService.value;

                  item.total = parseFloat(quotationProductService.items[index].total);
                }

                updateTotal(item);
                return item;
              });
            }

            _setEquipmentItems(vm.equipments);

            _setProdutsAndServicesWithoutEquipments(vm.items);
            $rootScope.loadingProgress = false;
          }
        });
      });
    }

    function searchProductService(searchTerm, currentEquipmentId) {
      return quotationProductService.searchProductService(
        searchTerm, vm.selectedCustomer, vm.selectedServiceOrder
      ).then(function (productsServices) {
        if (vm.items && vm.items.length) {
          vm.items.forEach(function (item) {
            if (productsServices && productsServices.length) {
              productsServices = _.filter(productsServices, function (productService) {
                var isDifferentEquipment = item.equipment && item.equipment.id !== currentEquipmentId;

                return item.productService.id !== productService.id || isDifferentEquipment;
              });
            }
          });
        }

        vm.productsServices = productsServices;
      });
    }

    function searchEquipments(searchTerm) {
      return quotationProductService.searchEquipments(searchTerm, vm.selectedCustomer).then(function (equipments) {
        if (vm.equipments && vm.equipments.length) {
          vm.equipments.forEach(function (equipment) {
            if (equipments && equipments.length) {
              equipments = _.filter(equipments, function (equip) {
                return equipment.id !== equip.id;
              });
            }
          });
        }

        vm.equipmentsToPick = equipments;
      });
    }

    function removeItem(productServiceId, equipmentId) {
      vm.items = _.filter(vm.items, function (item) {
        return item.productService.id !== productServiceId || (item.equipment && item.equipment.id !== equipmentId);
      });

      _setProdutsAndServicesWithoutEquipments(vm.items);

      quotationProductService.items = vm.items.map(function (item) {
        return quotationProductService.addQuotationItem(item);
      });

      _setEquipmentItems(vm.equipments);

      vm.equipments.forEach(function (equipment) {
        if (!equipment.products.length && !equipment.services.length) {
          _validateProductService(false);
        }
      });

      vm.broadcastUpdateTotal();
      _setFormDirty();
    }

    function removeEquipment(equipmentId) {
      vm.equipments = _.filter(vm.equipments, function (equipment) {
        return equipment.id !== equipmentId;
      });

      quotationProductService.quotationEquipments = vm.equipments.map(function (equipment) {
        return quotationProductService.addQuotationEquipment(equipment);
      });

      var itemsToBeRemoved = vm.items.filter(function (item) {
        return item.equipment && item.equipment.id === equipmentId;
      });

      _.forEach(itemsToBeRemoved, function (item) {
        removeItem(item.productService.id, equipmentId);
      });

      _setFormDirty();
    }

    function updateTotal(item) {
      var isProduct = item.productService.type === 'product';

      if (!item.quantity) {
        item.quantity = isProduct ? 0 : 1;
      }

      item.quantity = isProduct ? parseFloat(item.quantity).toFixed(2) : parseInt(item.quantity);

      item.total = item.productService.value * item.quantity;

      quotationProductService.items = vm.items.map(function (item) {
        return quotationProductService.addQuotationItem(item);
      });

      _setEquipmentItems(vm.equipments);

      vm.broadcastUpdateTotal();
    }

    function createProductServiceSetup(ev, equipment) {
      var equipmentId = equipment ? equipment.id : 'none';

      vm.createProductServiceWithEquipment(ev, equipmentId);
    }

    function addQuotationItem(option, isNewProductService, equipmentId) {
      var item = {
        id: option.id,
        sessionId: msUtils.uuidGenerator(),
        quantity: 1,
        total: 1 * option.value,
        description: option.description,
        productService: {
          id: option.id,
          name: option.name,
          value: option.value,
          imageUrl: option.imageUrl,
          type: option.type,
          measure: option.measure,
          metadata: option.metadata
        },
        expanded: true,
        equipment: equipmentId ? { id: equipmentId } : null
      };

      item = quotationProductService.addQuotationItem(item, isNewProductService, equipmentId);
      vm.items = quotationProductService.items;

      _setProdutsAndServicesWithoutEquipments(vm.items);

      _setEquipmentItems(vm.equipments);

      vm.equipments.forEach(function (equipment) {
        if (!equipment.products.length && !equipment.services.length) {
          _validateProductService(false);
        } else {
          _validateProductService(true);
        }
      });

      vm.broadcastUpdateTotal();
    }

    function addQuotationEquipment(option, isNewProductService) {
      var item = {
        id: option.id,
        name: option.name,
        number: option.number,
        imageUrl: option.imageUrl,
        location: option.location,
        type: option.type,
      };

      item = quotationProductService.addQuotationEquipment(item, isNewProductService);
      var quotEquipments = quotationProductService.quotationEquipments;

      _setEquipmentItems(quotEquipments);

      _validateProductService(false);

      vm.broadcastUpdateTotal();
    }

    function _setFormDirty() {
      $timeout(function () {
        if ($scope && $scope.vm && $scope.vm.quotationForm) {
          $scope.vm.quotationForm.$setDirty();
        }
      }, 100);
    }

    function _validateProductService(productService) {
      if ($scope.vm.quotationForm) {
        $scope.vm.quotationForm.$setValidity('quotationForm', productService);
      }
    }

    function _isFromCorporateOrBradesco(data) {
      try {
        return data.metadata.integration === 'bradesco-pat' || data.metadata.integration === 'corporate';
      } catch (ignore) {
        return false;
      }
    }

    function _filterProductsWithoutEquipment(items) {
      var products = items.filter(function (item) {
        return item.productService.type === 'product' && !item.equipment;
      });

      return products;
    }

    function _filterServicesWithoutEquipment(items) {
      var services = items.filter(function (item) {
        return item.productService.type === 'service' && !item.equipment;
      });

      return services;
    }

    function _setProdutsAndServicesWithoutEquipments(items) {
      vm.productsWithoutEquipments = _filterProductsWithoutEquipment(items);
      vm.servicesWithoutEquipments = _filterServicesWithoutEquipment(items);
    }

    function setProductServiceInputDisabled(productService) {
      if (!productService.id || vm.hideButton) {
        return true;
      }

      var isCorporateOrBradesco = _isFromCorporateOrBradesco(quotationProductService.selectedCustomer);
      var featureQuotationChangeValueProductsDisabled = Boolean(
        quotationProductService.selectedCustomer &&
        quotationProductService.selectedCustomer.metadata &&
        quotationProductService.selectedCustomer.metadata.featureQuotationChangeValueProductsDisabled
      );

      var productServiceAllowEditValue = Boolean(
        productService.metadata &&
        productService.metadata.allowEditValue
      );

      if (isCorporateOrBradesco && productServiceAllowEditValue) {
        return false;
      }

      return featureQuotationChangeValueProductsDisabled;
    }

    function findMeasureSelected(measureValue) {
      if (!measureValue) { return ''; }

      var measure = vm.measuresSelectOptions.find(function (measure) {
        return measure.value === measureValue;
      });

      return measure;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.quotations')
    .component('quotationItems', {
      templateUrl: 'app/main/quotations/dialogs/components/quotation-items/quotation-items.component.html',
      controller: QuotationItemsController,
      controllerAs: 'vm',
      bindings: {
        quotation: '=',
        isCopy: '=',
        quotationForm: '<'
      }
    });

  function QuotationItemsController(
    QuotationProductService, $locale, $scope,
    $rootScope, $timeout, _, ProductsServicesDialog,
    ProductsMeasuresOptions, msUtils, $translate, FcModalService, CurrencyService
  ) {
    var vm = this;
    var quotationProductService = QuotationProductService;
    var productsServicesDialog = ProductsServicesDialog;
    vm.updateTotal = updateTotal;
    vm.addQuotationItem = addQuotationItem;
    vm.searchProductService = searchProductService;
    vm.removeItem = removeItem;
    vm.findMeasureSelected = findMeasureSelected;
    vm.createProductService = productsServicesDialog.createProductService;
    vm.editProductService = editProductService;
    vm.hideButton = quotationProductService.disabled;
    vm.resetAllProductsServices = quotationProductService.resetAllProductsServices;
    vm.productsServices = [];
    vm.items = [];
    vm.products = [];
    vm.services = [];
    vm.measuresSelectOptions = ProductsMeasuresOptions.measures;
    vm.setProductServiceInputDisabled = setProductServiceInputDisabled;

    vm.broadcastUpdateTotal = _.debounce(function () {
      $timeout(function () { $rootScope.$broadcast('quotation:update:items'); }, 50);
    }, 500);

    vm.currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = vm.currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    _initialize();

    function _initialize() {
      vm.items = vm.quotation.items;

      vm.broadcastUpdateTotal();

      if (vm.isCopy) {
        vm.items = vm.items.map(function (item) {
          return quotationProductService.addQuotationItem(item, true);
        });
      }
      _setProdutsAndServices(vm.items);

      $scope.$on('quotation:customer:changed', function () {
        vm.selectedCustomer = quotationProductService.selectedCustomer;
      });

      $scope.$on('quotation:service-order:changed', function () {
        vm.selectedServiceOrder = quotationProductService.selectedServiceOrder;
      });

      $scope.$on('quotation:copied', function () {
        vm.selectedCustomer = quotationProductService.selectedCustomer;
      });

      $scope.$on('product-services:created', function (event, quotationItem) {
        vm.addQuotationItem(quotationItem, true);
      });

      $scope.$on('product-services:edited', function (event, quotationItem) {
        vm.addQuotationItem(quotationItem);
      });
    }

    function _filterProducts(items) {
      var products = items.filter(function (item) {
        return item.productService.type === 'product';
      });
      return products;
    }

    function _filterServices(items) {
      var services = items.filter(function (item) {
        return item.productService.type === 'service';
      });
      return services;
    }

    function getInputType(item) {
      var saveInputType;
      if (item.productService.type === 'product') {
        saveInputType = $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.UPDATE_BUDGET_TYPE_PRODUCT');
      } else if (item.productService.type === 'service') {
        saveInputType = $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.UPDATE_BUDGET_TYPE_SERVICE');
      }
      _setFormDirty();
      return saveInputType;
    }

    function modalOptionQuotation(item, callback) {
      var saveInputType = getInputType(item);
      FcModalService.open('', {
        title: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.UPDATE_BUDGET_TITLE'),
        content: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.UPDATE_BUDGET_CONTENT') + saveInputType + $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.UPDATE_BUDGET_TYPE_CONFIRM'),
        leftButtonText: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.QUESTION_DATA_LOSS_NO'),
        rightButtonText: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.QUESTION_DATA_LOSS_YES'),
        handleRightButton: function () {
          callback(true);
        },
        handleLeftButton: function () {
          callback(false);
        }
      });
      _setFormDirty();
    }

    function editProductService(ev, quotationItem) {
      productsServicesDialog.editProductService(ev, quotationItem, function (_, productService) {
        var productServiceId = productService.id;

        vm.items.find(function (item, index) {
          if (item.productService.id === productServiceId) {
            item.productService.imageUrl = productService.imageUrl;
            item.productService.name = productService.name;

            _setFormDirty();
            if((item.description != productService.description) || (item.productService.value != productService.value)){
            modalOptionQuotation(item, function (response) {
            if (response) {
              item.description = productService.description;
              item.total = productService.value * item.quantity;
              item.productService.value = productService.value;

              item.total = parseFloat(quotationProductService.items[index].total);
            }

            updateTotal(item);
            return item;
            });
          }
          _setProdutsAndServices(vm.items);
          $rootScope.loadingProgress = false;
        }});
      });
    }

    function searchProductService(searchTerm) {
      return quotationProductService.searchProductService(
        searchTerm, vm.selectedCustomer, vm.selectedServiceOrder
      ).then(function (productsServices) {
        if (vm.items && vm.items.length) {
          vm.items.forEach(function (item) {
            if (productsServices && productsServices.length) {
              productsServices = _.filter(productsServices, function (productService) {
                return item.productService.id !== productService.id;
              });
            }
          });
        }

        vm.productsServices = productsServices;
      });
    }

    function removeItem(productServiceId) {
      vm.items = _.filter(vm.items, function (item) {
        return item.productService.id !== productServiceId;
      });

      vm.products = _filterProducts(vm.items);
      vm.services = _filterServices(vm.items);

      quotationProductService.items = vm.items.map(function (item) {
        return quotationProductService.addQuotationItem(item);
      });

      vm.broadcastUpdateTotal();
      _setFormDirty();
    }

    function updateTotal(item) {
      var isProduct = item.productService.type === 'product';
      if (!item.quantity) {
        item.quantity = isProduct ? 0 : 1;
      }

      item.quantity = isProduct ? parseFloat(item.quantity).toFixed(2) : parseInt(item.quantity);

      item.total = item.productService.value * item.quantity;

      quotationProductService.items = vm.items.map(function (item) {
        return quotationProductService.addQuotationItem(item);
      });

      vm.broadcastUpdateTotal();
    }

    function addQuotationItem(option, isNewProductService) {
      var item = {
        id: option.id,
        sessionId: msUtils.uuidGenerator(),
        quantity: 1,
        total: 1 * option.value,
        description: option.description,
        productService: {
          id: option.id,
          name: option.name,
          value: option.value,
          imageUrl: option.imageUrl,
          type: option.type,
          measure: option.measure,
          metadata: option.metadata
        },
      };
      item = quotationProductService.addQuotationItem(item, isNewProductService);
      vm.items = quotationProductService.items;

      vm.products = _filterProducts(vm.items);
      vm.services = _filterServices(vm.items);

      vm.broadcastUpdateTotal();
    }

    function _setFormDirty() {
      $timeout(function () {
        if ($scope && $scope.vm && $scope.vm.quotationForm) {
          $scope.vm.quotationForm.$setDirty();
        }
      }, 100);
    }

    function _isFromCorporateOrBradesco(data) {
      try {
        return data.metadata.integration === 'bradesco-pat' || data.metadata.integration === 'corporate';
      } catch (ignore) {
        return false;
      }
    }

    function setProductServiceInputDisabled(productService) {
        if (!productService.id || vm.hideButton) {
            return true;
        }

        var isCorporateOrBradesco = _isFromCorporateOrBradesco(quotationProductService.selectedCustomer);
        var featureQuotationChangeValueProductsDisabled = Boolean(
          quotationProductService.selectedCustomer &&
          quotationProductService.selectedCustomer.metadata &&
          quotationProductService.selectedCustomer.metadata.featureQuotationChangeValueProductsDisabled
        );

        var productServiceAllowEditValue = Boolean(
          productService.metadata &&
          productService.metadata.allowEditValue
        );

        if (isCorporateOrBradesco && productServiceAllowEditValue) {
          return false;
        }

        return featureQuotationChangeValueProductsDisabled;
    }

    function _setProdutsAndServices(items) {
      vm.products = _filterProducts(items);
      vm.services = _filterServices(items);
    }

    function findMeasureSelected(measureValue) {
      if (!measureValue) { return ''; }

      var measure = vm.measuresSelectOptions.find(function (measure) {
        return measure.value === measureValue;
      });
      return measure;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.quotations')
    .component('quotationExpenses', {
      templateUrl: 'app/main/quotations/dialogs/components/quotation-expenses/quotation-expenses.component.html',
      controller: QuotationExpensesController,
      controllerAs: 'vm',
      bindings: {
        quotation: '=',
        isCopy: '=',
        quotationForm: '<'
      }
    });

  function QuotationExpensesController(
    QuotationProductService, $locale, $scope, $mdDialog, $document,
    $rootScope, $timeout, _,
    $translate, CurrencyService, $mdToast,
    uploadApi, MessageDialog, attachmentsUtils, quotationsApi
  ) {
    var vm = this;
    var quotationProductService = QuotationProductService;
    vm.updateTotal = updateTotal;
    vm.removeItem = removeItem;
    vm.hideButton = quotationProductService.disabled;
    vm.handleFileChange = handleFileChange;
    vm.removeFile = removeFile;
    vm.selectExpense = selectExpense;
    vm.createQuotationExpense = createQuotationExpense;
    vm.items = [];

    vm.broadcastUpdateTotal = _.debounce(function () {
      $timeout(function () { $rootScope.$broadcast('quotation:update:items'); }, 50);
    }, 500);

    vm.currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = vm.currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    _initialize();

    function _initialize() {
      vm.items = vm.quotation.expenses ? vm.quotation.expenses.map(function (item) {
        item.fullPath = attachmentsUtils.correctUrl(item.path);
        return item;
      }) : [];

      vm.broadcastUpdateTotal();

      var updateQuotationExpense = _.debounce(function (item) {
        if (!item.id) return;

        quotationsApi.updateQuotationExpense({
          id: item.id,
          description: item.description,
          position: item.position,
          total: item.total,
          path: item.path
        });
      }, 500);

      if (vm.quotation.id) {
        $scope.$watch(
          function () {
            return vm.items.map(function (item) {
              var expense = item;
              expense.file = undefined;
              return expense;
            });
          },
          function (newVal, oldVal) {
            if (!angular.equals(newVal, oldVal)) {
              var changedItems = newVal.filter(function (item, index) {
                return !angular.equals(item, oldVal[index]);
              });

              changedItems.forEach(function (item) {
                updateQuotationExpense(item);
              });

              $scope.originalExpenses = angular.copy(newVal);
              updateTotal();
            }
          },
          true
        );

        $scope.$on('$destroy', function () {
          updateQuotationExpense.cancel();
        });
      }
    }


    function selectExpense($event) {
      $mdDialog.show({
        controller: 'SelectExpenseController',
        controllerAs: 'vm',
        templateUrl: 'app/main/quotations/dialogs/components/quotation-expenses/select-expense/select-expense.component.html',
        parent: angular.element($document.body),
        targetEvent: $event,
        clickOutsideToClose: true,
        multiple: true,
        onComplete: function (scope, element) {
          element[0].style.zIndex = 99999;
        }
      }).then(function (selectedExpense) {
        if (selectedExpense) {
          vm.items.push({
            description: '',
            expense: selectedExpense,
            path: null,
            position: vm.items.length + 1,
            quotation: { id: vm.quotation.id },
          });

          _setFormDirty();
        }
      });
    }

    function removeItem(item) {
      if (item.id) {
        quotationsApi.removeQuotationExpense(item.id);
      }

      vm.items = vm.items.filter(function (expenseItem) {
        return item.id ? expenseItem.id !== item.id : expenseItem.position !== item.position;
      });

      vm.items = vm.items.map(function (item, i) {
        item.position = i + 1;
        return item;
      });

      vm.updateTotal();
      _setFormDirty();
    }

    function updateTotal() {
      updateQuotationProductServiceExpenses();
      vm.broadcastUpdateTotal();
      _setFormDirty();
    }

    function updateQuotationProductServiceExpenses() {
      quotationProductService.expenses = vm.items
        .filter(function (item) {
          return vm.quotation.id ? item.id : true;
        })
        .map(function (item) {
          return quotationProductService.addQuotationExpense(item);
        });
    }

    function _setFormDirty() {
      $timeout(function () {
        if ($scope && $scope.vm && $scope.vm.quotationForm) {
          $scope.vm.quotationForm.$setDirty();
        }
      }, 100);
    }

    function handleFileChange(event, item) {
      var file = event.target.files[0];
      if (!file) return;


      if (!vm.quotation.id) {
        item.path = file.name.replace(/%20| /g, '');
        item.file = file;
        updateQuotationProductServiceExpenses();
        return;
      }

      item.uploading = true;
      $rootScope.loadingProgress = true;

      uploadApi.uploadWithPreSignedPost({
        file: file,
        filePath: '/quotations/' + vm.quotation.id + '/expenses/' + file.name.replace(/%20| /g, ''),
        randomize: false,
        $mdToast: $mdToast,
        $translate: $translate
      }, function () { })
        .then(function (result) {
          item.path = result.path;
          item.fullPath = attachmentsUtils.correctUrl(item.path);

          MessageDialog.showToast({
            hideDelay: 3000,
            message: $translate.instant('QUOTATIONS.DIALOG.EXPENSES.TOAST.UPDATED_SUCCESSFULLY')
          });
        })
        .catch(function (err) {
          MessageDialog.showToast({
            hideDelay: 3000,
            message: $translate.instant('QUOTATIONS.DIALOG.EXPENSES.TOAST.UPDATED_FAILED')
          });
        })
        .finally(function () {
          item.uploading = false;
          $rootScope.loadingProgress = false;
        });
    }


    function removeFile(item) {
      item.path = null;
    };

    function createQuotationExpense(item) {
      var control = $scope && $scope.vm && $scope.vm.quotationForm;
      var expenseTotalControl = control && control['expenseTotal__' + item.position];
      var fileInputControl = control && control['fileInput_' + item.position];

      expenseTotalControl.$setTouched();
      fileInputControl.$setTouched();
      if (expenseTotalControl && expenseTotalControl.$invalid) return;
      if (fileInputControl && fileInputControl.$invalid) return;

      quotationsApi.createQuotationExpense({
        description: item.description,
        position: item.position,
        expenseId: item.expense.id,
        quotationId: item.quotation.id,
        total: item.total,
        path: item.path
      }).then(function (response) {
        item.id = response.id;
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.control-panel')
        .factory('MapMarkerFilter', MapMarkerFilter);

    /** @ngInject */
    function MapMarkerFilter(ControlPanelFilters, _, msUtils) {

        return {
            filterEmployee: filterEmployee,
            filterTask: filterTask
        };

        function filterEmployee(marker) {

            if (ControlPanelFilters.isOff()) {
                return marker;
            }

            if (ControlPanelFilters.employees.length > 0) {

                var containFilteredEmployee = _.any(ControlPanelFilters.employees, function (employee) {
                    return marker.employeeId == employee;
                });

                if (!containFilteredEmployee) {
                    return null;
                }
            }

            return marker;
        }

        function filterTask(marker) {

            if (ControlPanelFilters.isOff()) {
                return marker;
            }

            if (ControlPanelFilters.status.length > 0) {

                var containFilteredStatus = _.any(ControlPanelFilters.status, function (status) {
                    return marker.statusValue == status;
                });

                if (!containFilteredStatus) {
                    return null;
                }
            }

            if (ControlPanelFilters.services.length > 0) {

                var containFilteredService = _.any(ControlPanelFilters.services, function (service) {
                    return marker.serviceId == service.id;
                });

                if (!containFilteredService) {
                    return null;
                }
            }


            if (ControlPanelFilters.employees.length > 0) {

                var containFilteredEmployee = _.any(ControlPanelFilters.employees, function (employee) {
                    return marker.employeeId == employee;
                });

                if (!containFilteredEmployee) {
                    return null;
                }
            }

            if (ControlPanelFilters.ratings.length > 0) {

                var containFilteredRating = _.any(ControlPanelFilters.ratings, function (stars) {

                    if (marker.ratingStars) {
                        return marker.ratingStars == stars;

                    } else {
                        return stars <= 0;
                    }
                });

                if (!containFilteredRating) {
                    return null;
                }
            }

            if (ControlPanelFilters.labels.length > 0) {

                var containFilteredLabel = _.any(ControlPanelFilters.labels, function (labelId) {

                    if (marker.labels && marker.labels.length > 0) {

                        var hasLabel = _.any(marker.labels, function (markerLabel) {
                            return markerLabel.id ==  labelId;
                        });

                        return hasLabel;

                    } else {

                        if (labelId == 'null') {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }

                });

                if (!containFilteredLabel) {
                    return null;
                }
            }

            if (ControlPanelFilters.customerLabels.length > 0) {
                var filteredLabels = _.pluck(ControlPanelFilters.customerLabels, 'id');
                var taskLabels = _.pluck(marker.customerLabels, 'id');
                if (_.intersection(filteredLabels, taskLabels).length === 0) {
                    return null;
                }
            }

            if (ControlPanelFilters.customerName) {
                var loweredTaskName = msUtils.toStringCompare(marker.customerName);
                var loweredCustomerName = msUtils.toStringCompare(ControlPanelFilters.customerName);
                if (loweredTaskName.indexOf(loweredCustomerName) === -1) {
                    return null;
                }
            }

            if (ControlPanelFilters.locationName) {
                var loweredTaskName = msUtils.toStringCompare(marker.locationName);
                var loweredLocationName = msUtils.toStringCompare(ControlPanelFilters.locationName);
                if (loweredTaskName.indexOf(loweredLocationName) === -1) {
                    return null;
                }
            }

            if (ControlPanelFilters.description) {
                if (!marker.orderDescription) {
                    return null;
                }
                var loweredTaskDescription = msUtils.toStringCompare(marker.orderDescription);
                var loweredSearchTaskDescription = msUtils.toStringCompare(ControlPanelFilters.description);
                if (loweredTaskDescription.indexOf(loweredSearchTaskDescription) === -1) {
                    return null;
                }
            }

            return marker;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.control-panel')
        .factory('ListTasksFilter', ListTasksFilter);

    /** @ngInject */
    function ListTasksFilter(ControlPanelFilters, _, msUtils, TasksStatusHelper) {

        return {
            filterTask: filterTask
        };

        function filterTask(task) {

            if (ControlPanelFilters.status.length > 0) {

                var statusTask = TasksStatusHelper.getByName(task.status);

                var containFilteredStatus = _.any(ControlPanelFilters.status, function (status) {
                    return statusTask.value == status;
                });

                if (!containFilteredStatus) {
                    return null;
                }
            }

            if (ControlPanelFilters.services.length > 0) {

                var containFilteredService = _.any(ControlPanelFilters.services, function (service) {
                    return task.order.service.id == service.id;
                });

                if (!containFilteredService) {
                    return null;
                }
            }

            if (ControlPanelFilters.labels.length > 0) {

                var containFilteredLabel = _.any(ControlPanelFilters.labels, function (labelId) {

                    if (task.order && task.order.labels && task.order.labels.length > 0) {

                        var hasLabel = _.any(task.order.labels, function (orderLabel) {
                           return orderLabel.id ==  labelId;
                        });

                        return hasLabel;

                    } else {

                        if (labelId == 'null') {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }

                });

                if (!containFilteredLabel) {
                    return null;
                }
            }

            if (ControlPanelFilters.employees.length > 0) {

                var containFilteredEmployee = _.any(ControlPanelFilters.employees, function (employee) {
                    if (task.employee && task.employee.id) {
                        return task.employee.id == employee;
                    }
                    else {
                        return employee == 'null';
                    }
                });

                if (!containFilteredEmployee) {
                    return null;
                }
            }

            if (ControlPanelFilters.ratings.length > 0) {

                var containFilteredRating = _.any(ControlPanelFilters.ratings, function (stars) {

                    if (task.rating && task.rating.id && task.rating.stars) {
                       return task.rating.stars == stars;

                    } else {
                        return stars <= 0;
                    }
                });

                if (!containFilteredRating) {
                    return null;
                }
            }

            var isArchivedFilter = ControlPanelFilters.archived === 'true' && !task.archived;
            var isUnarchivedFilter = ControlPanelFilters.archived === 'false' && task.archived;
            if (ControlPanelFilters.archived && isArchivedFilter || isUnarchivedFilter) {
              return null;
            }

            if (ControlPanelFilters.customerLabels.length > 0) {
                var filteredLabels = _.pluck(ControlPanelFilters.customerLabels, 'id');
                var taskLabels = _.pluck(task.order.customer.labels, 'id');
                if (_.intersection(filteredLabels, taskLabels).length === 0) {
                    return null;
                }
            }

            if (ControlPanelFilters.customerName !== '') {
                var loweredTaskName = msUtils.toStringCompare(task.order.customer.name);
                var loweredCustomerName = msUtils.toStringCompare(ControlPanelFilters.customerName);
                if (loweredTaskName.indexOf(loweredCustomerName) === -1) {
                    return null;
                }
            }

            if (ControlPanelFilters.locationName !== '') {
                var loweredTaskName = msUtils.toStringCompare(task.order.location.name);
                var loweredLocationName = msUtils.toStringCompare(ControlPanelFilters.locationName);
                if (loweredTaskName.indexOf(loweredLocationName) === -1) {
                    return null;
                }
            }

            if (ControlPanelFilters.description !== '') {
                if (!task.order.description) {
                    return null;
                }
                var loweredTaskDescription = msUtils.toStringCompare(task.order.description);
                var loweredSearchTaskDescription = msUtils.toStringCompare(ControlPanelFilters.description);
                if (loweredTaskDescription.indexOf(loweredSearchTaskDescription) === -1) {
                    return null;
                }
            }

            return task;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.control-panel')
        .factory('GanttTasksStatistics', GanttTasksStatistics);

    /** @ngInject */
    function GanttTasksStatistics() {

        return {
            calculateStatistics: calculateStatistics
        };

        function calculateStatistics(options) {

            var totalTaskCost = 0;
            var totalRouteCost = 0;
            var totalActivitiesDone = 0;
            var totalCapacity = 0;

            options.tasks.forEach(function (task) {
                if (task.archived === false && task.scheduling.estimation) {
                    totalTaskCost += task.duration;
                    totalRouteCost += task.scheduling.estimation.routeCost;
                    if (task.status === 'done') {
                        totalActivitiesDone++;
                    }
                }
            });

            options.employees.forEach(function (employee) {
                totalCapacity += employee.workSchedule.capacity;
            });

            var stats = {};
            stats.totalTaskCost = totalTaskCost;
            stats.totalRouteCost = totalRouteCost;
            stats.totalCost = totalTaskCost + totalRouteCost;
            stats.totalActivitiesDone = totalActivitiesDone;
            stats.totalCapacity = totalCapacity;
            stats.availableCapacity = (stats.totalCapacity - stats.totalCost);

            return stats;
        }


    }
})();
(function () {
    'use strict';

    angular.module('app.control-panel')
        .factory('ganttTaskLabelHtml', ganttTaskLabelHtml);

    /** @ngInject */
    function ganttTaskLabelHtml($, $compile) {

        return {
            insertLabelsHtmlOnTasks: insertLabelsHtmlOnTasks
        };

        function insertLabelsHtmlOnTasks(tasks, scope) {
            tasks = tasks || [];

            $('.list-card-labels').remove();

            tasks.forEach(function (task) {
                if (task && task.order && task.order.labels && task.order.labels.length > 0) {

                    var template = '<div class="list-card-labels" layout="row" layout-wrap>';

                    task.order.labels.forEach(function (label) {
                        template += '<span class="list-card-label md-'+label.color+'-bg">';
                        template += '<md-tooltip>';
                        template += label.name;
                        template += '</md-tooltip>';
                        template += '</span>';
                    });

                    template += '</div>';

                    var ganttTask = $('.task-id-' + task.id);
                    if (ganttTask) {
                        ganttTask.append($compile(template)(scope));
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.control-panel')
        .factory('GanttTasksFilter', GanttTasksFilter);

    /** @ngInject */
    function GanttTasksFilter(ControlPanelFilters, _, msUtils) {

        return {
            filterTask: filterTask,
            filterRow: filterRow
        };

        function filterRow(row) {

            if (ControlPanelFilters.isOff()) {
                return row;
            }

            if (ControlPanelFilters.employees.length > 0) {

                var containFilteredEmployee = _.any(ControlPanelFilters.employees, function (employee) {
                    return row.model.employeeId == employee;
                });

                if (!containFilteredEmployee) {
                    return null;
                }
            }

            return row;
        }

        function filterTask(task) {

            if (ControlPanelFilters.isOff()) {
                return task;
            }

            if (task.model.type !== 'task') {
                return null;
            }

            if (ControlPanelFilters.status.length > 0) {

                var containFilteredStatus = _.any(ControlPanelFilters.status, function (status) {
                   return task.model.status == status;
                });

                if (!containFilteredStatus) {
                    return null;
                }
            }

            if (ControlPanelFilters.services.length > 0) {

                var containFilteredService = _.any(ControlPanelFilters.services, function (service) {
                    return task.model.serviceId == service.id;
                });

                if (!containFilteredService) {
                    return null;
                }
            }

            if (ControlPanelFilters.employees.length > 0) {

                var containFilteredEmployee = _.any(ControlPanelFilters.employees, function (employee) {
                    return task.model.employeeId == employee;
                });

                if (!containFilteredEmployee) {
                    return null;
                }
            }

            if (ControlPanelFilters.ratings.length > 0) {

                var containFilteredRating = _.any(ControlPanelFilters.ratings, function (stars) {

                    if (task.model.ratingStars) {
                        return task.model.ratingStars == stars;

                    } else {
                        return stars <= 0;
                    }
                });

                if (!containFilteredRating) {
                    return null;
                }
            }

            if (ControlPanelFilters.labels.length > 0) {

                var containFilteredLabel = _.any(ControlPanelFilters.labels, function (labelId) {

                    if (task.model.labels && task.model.labels.length > 0) {

                        var hasLabel = _.any(task.model.labels, function (orderLabel) {
                            return orderLabel.id ==  labelId;
                        });

                        return hasLabel;

                    } else {

                        if (labelId == 'null') {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }

                });

                if (!containFilteredLabel) {
                    return null;
                }
            }

            if (ControlPanelFilters.customerLabels.length > 0) {
                var filteredLabels = _.pluck(ControlPanelFilters.customerLabels, 'id');
                var taskLabels = _.pluck(task.model.customerLabels, 'id');
                if (_.intersection(filteredLabels, taskLabels).length === 0) {
                    return null;
                }
            }

            if (ControlPanelFilters.customerName) {
                var loweredTaskName = msUtils.toStringCompare(task.model.name);
                var loweredCustomerName = msUtils.toStringCompare(ControlPanelFilters.customerName);
                if (loweredTaskName.indexOf(loweredCustomerName) === -1) {
                    return null;
                }
            }

            if (ControlPanelFilters.locationName) {
                var loweredTaskName = msUtils.toStringCompare(task.model.locationName);
                var loweredLocationName = msUtils.toStringCompare(ControlPanelFilters.locationName);
                if (loweredTaskName.indexOf(loweredLocationName) === -1) {
                    return null;
                }
            }

            if (ControlPanelFilters.description) {
                if (!task.model.orderDescription) {
                    return null;
                }
                var loweredTaskDescription = msUtils.toStringCompare(task.model.orderDescription);
                var loweredSearchTaskDescription = msUtils.toStringCompare(ControlPanelFilters.description);
                if (loweredTaskDescription.indexOf(loweredSearchTaskDescription) === -1) {
                    return null;
                }
              }

            return task;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.control-panel')
        .factory('ganttHtmlTemplate', ganttHtmlTemplate);

    /** @ngInject */
    function ganttHtmlTemplate(moment, msUtils, $translate, LocalDateConvert) {

        return {
            taskTemplate: taskTemplate,
            employeeTemplate: employeeTemplate
        };

        function toDateString(date) {
            var currentDate = moment(date).toDate();
            return LocalDateConvert.formatDate(currentDate, 'date-time');;
        }

        function employeeTemplate(currentDate, employeeLocation, employee, tasks) {

            var tooltipTemplate = '';
            var template = '';
            if (employee.avatarUrl) {
                var avatarUrl = employee.avatarUrl + '?id=' + msUtils.shortGuidGenerator();
                template += '<img src="./assets/images/avatars/profile.jpg" ' +
                              'ng-src="'+avatarUrl+'" class="avatar medium"/>';
            } else {
                template += '<img src="./assets/images/avatars/profile.jpg" class="avatar medium"/>';
            }

            var isCurrentDate = moment().isSame(currentDate, 'day');
            if (isCurrentDate) {

                var colorClass = 'none';
                var employeeLabelOnline = $translate.instant("CONTROL_PANEL.VIEWS.GANTT.EMPLOYEE_LABEL_ONLINE.NO_LOCATION");
                if (employeeLocation && employeeLocation.employee) {
                    colorClass = employeeLocation.employee.isOnline ? 'online' : 'offline';
                    if (employeeLocation.employee.isOnline) {
                        employeeLabelOnline = $translate.instant("CONTROL_PANEL.VIEWS.GANTT.EMPLOYEE_LABEL_ONLINE.LAST_RECEIVED_LOCATION");
                        if (employeeLocation.timestamp) {
                            employeeLabelOnline += $translate.instant("CONTROL_PANEL.VIEWS.GANTT.EMPLOYEE_LABEL_ONLINE.ON", {
                                timestamp: toDateString(employeeLocation.timestamp)
                            });
                        }
                    } else {
                        employeeLabelOnline = $translate.instant("CONTROL_PANEL.VIEWS.GANTT.EMPLOYEE_LABEL_ONLINE.OUTDATED_LOCATION");
                        if (employeeLocation.timestamp) {
                            employeeLabelOnline += $translate.instant("CONTROL_PANEL.VIEWS.GANTT.EMPLOYEE_LABEL_ONLINE.LAST_UPDATE_ON", {
                                timestamp: toDateString(employeeLocation.timestamp)
                            });
                        }
                    }

                }

                template += '&nbsp;' + '<div class="avatar-status-gantt '+colorClass+'">';
                template += '<md-tooltip md-direction="right">';
                template += employeeLabelOnline;
                template += '</md-tooltip>';
                template += '</div>';
            }
            template += '&nbsp;&nbsp;' +
                            '<span data-cy="employee-name" ng-click="scope.vm.editEmployee($event, row.model.employeeId)"> ' +
                            '{{row.model.name}}' + tooltipTemplate + '</span>';
            return template;
        }

        function taskTemplate() {

            var template = '';

            template += '<i data-cy="task" ng-show="task.model.type === \'task\'" ' +
                'ng-click="scope.vm.editTask($event, task.model.orderId)"' +
                'class="gantt-task-edit-button icon-open-in-new s15 icon" ' +
                'aria-label="' + $translate.instant("CONTROL_PANEL.VIEWS.GANTT.EMPLOYEE_LABEL_ONLINE.TASK_LOCATION") + '">' +
                '</i>';

            template += '<span class="gantt-task-name task-id-{{task.model._id}}">{{task.model.description}}';
            template += '</span>';
            return template;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.control-panel')
        .factory('ganttData', ganttData);

    /** @ngInject */
    function ganttData(moment, _, msUtils, activityColor, TasksStatusHelper, ganttHtmlTemplate, $translate) {

        return {
            toRows: toRows,
            configureDateRanges: configureDateRanges
        };

        function configureDateRanges(rows, options, selectedDate) {
            var dates = [];

            dates.push(moment(selectedDate).hour(8));
            dates.push(moment(selectedDate).hour(18));

            _.each(rows, function (employee) {
                _.each(employee.tasks, function (task) {
                    dates.push(moment(task.from));
                    dates.push(moment(task.to));
                });
            });

            var fromDate = _.min(dates, function (date) {
                return date;
            });
            var toDate = _.max(dates, function (date) {
                return date;
            });

            options.fromDate = fromDate;
            options.toDate = toDate;
        }

        function orderByPriority(tasks) {

            var orderedTasks = _.sortBy(tasks, function (task) {
                switch (task.type) {
                    case 'absence':
                        return -1;
                    case 'break':
                        return 1;
                    case 'route':
                        return 2;
                    case 'task':
                        return 3;
                    default:
                        return 0;
                }
            });

            var priority = 1;
            orderedTasks.forEach(function (task) {
                task.priority = priority;
                priority++;
            });

            return orderedTasks;
        }

        function toRows(activities, employees, locations, absences, account, currentDate) {
          var rows = [];

          var estimatedResult = _.map(activities, function (task) {
            if(!task.employee || !task.employee || (task.employee && !task.employee.id)) return false;

            var taskStatus = TasksStatusHelper.getByName(task.status);
                var estimatedResultModel = {
                    employeeId: task.employee && task.employee.id,
                    secondaryEmployeesId:task.secondaryEmployees && task.secondaryEmployees.map(function (employee) {
                        return employee.id;
                    }),
                    employeeName: task.employee.name,
                    routeCost: task.scheduling.routeCost,
                    startedAt: task.startedAt,
                    from: task.scheduling.estimation.startTask,
                    estimatedRouteStart: task.scheduling.estimation.startRoute,
                    to: task.scheduling.estimation.completeTask,
                    timeFixed: (task.scheduling.type === 'scheduled-date-and-time'),
                    id: msUtils.guidGenerator(),
                    _id: task.id,
                    orderId: task.order.id,
                    orderAddress: task.order.address.formattedAddress,
                    orderDescription: task.order.description,
                    serviceName: task.order.service.description,
                    labels: task.order.labels,
                    locationName: task.order.location ? task.order.location.name : undefined,
                    status: parseInt(taskStatus.value),
                    identifier: task.order.identifier,
                    latitude: task.coords.latitude,
                    longitude: task.coords.longitude,
                    customerName: task.order.customer.name,
                    customerLabels: task.order.customer.labels,
                    duration: task.duration,
                    serviceId: task.order.service.id,
                    ratingStars: null
                };

                if (task.rating && task.rating.stars) {
                    estimatedResultModel.ratingStars = task.rating.stars;
                }

                return estimatedResultModel;
            });

            var estimatedGroup = _.groupBy(estimatedResult, 'employeeId');

            estimatedResult.forEach(function (task) {
                if (!task.secondaryEmployeesId || !task.secondaryEmployeesId.length) {
                    return;
                }
                task.secondaryEmployeesId.forEach(function (employeeId) {
                    if (estimatedGroup.hasOwnProperty(employeeId)) {
                        estimatedGroup[employeeId].push(task);
                        return;
                    }
                    estimatedGroup[employeeId] = [];
                    estimatedGroup[employeeId].push(task);
                });
            });

            employees.forEach(function (employee) {

                var estimatedTasks = [];
                if (estimatedGroup.hasOwnProperty(employee.id)) {
                    estimatedTasks = estimatedGroup[employee.id];
                    var secundarysTaskGroup = getSecundarysTaskGroup(estimatedResult, employee.id);
                    estimatedTasks = angular.copy(estimatedTasks).map(function (task) {
                        task.employeeId = employee.id;

                        return task;
                    });
                    estimatedTasks = estimatedTasks.concat(secundarysTaskGroup);

                }

                var ganttEstimatedTasks = [];

                function createRouteTask(task) {

                    if (account.configuration.ganttDisplayTravelTimeOn) {
                        if (task.estimatedRouteStart !== task.from) {

                            var routeTask = {
                              identifier: $translate.instant("CONTROL_PANEL.VIEWS.GANTT.ROUTE_TASK_NAME"),
                              name: task.customerName,
                              id: msUtils.guidGenerator(),
                              _id: task.id,
                              type: 'route',
                              size: task.routeCost,
                              classes: [
                                  'md-blue-grey-100-bg',
                                  'route-or-break-task',
                                  'routechecker'
                              ],
                              startedAt: task.startedAt,
                              from: task.estimatedRouteStart,
                              to: task.from,
                              orderId: task.orderId,
                              orderAddress: task.orderAddress,
                              orderDescription: task.orderDescription,
                              serviceName: task.serviceName,
                              labels: task.labels,
                              locationName: task.locationName,
                              employeeId: task.employeeId,
                              serviceId: task.serviceId,
                              customerLabels: task.customerLabels,
                              description: task.customerName,
                              latitude: task.latitude,
                              longitude: task.longitude,
                              status: task.status,
                              est: task.from,
                              timeFixed: task.timeFixed,
                              lct: task.to,
                              progress: 100,
                              ratingStars: task.ratingStars,
                          };

                            ganttEstimatedTasks.push(routeTask);
                        }
                    }
                }

                function createTask(task) {
                    var ganttTask = {
                        employeeId: task.employeeId,
                        serviceId: task.serviceId,
                        name: task.customerName,
                        customerLabels: task.customerLabels,
                        startedAt: task.startedAt,
                        description: task.customerName,
                        identifier: task.identifier,
                        id: msUtils.guidGenerator(),
                        _id: task._id,
                        orderId: task.orderId,
                        orderAddress: task.orderAddress,
                        orderDescription: task.orderDescription,
                        serviceName: task.serviceName,
                        labels: task.labels,
                        locationName: task.locationName,
                        type: 'task',
                        classes: [
                            activityColor.classNameFromStatusCode(task.status),
                            'task-hover-increase'
                        ],
                        latitude: task.latitude,
                        longitude: task.longitude,
                        status: task.status,
                        from: task.from,
                        to: task.to,
                        est: task.from,
                        timeFixed: task.timeFixed,
                        lct: task.to,
                        progress: 100,
                        ratingStars: task.ratingStars,
                        secondaryEmployeesId: task.secondaryEmployeesId
                    };

                    ganttEstimatedTasks.push(ganttTask);
                }

                function createAbsenceTask() {
                    var absence = _.find(absences, function (absence) {
                        if (absence.employee) {
                            return absence.employee.id === employee.id;
                        } else {
                            return null;
                        }
                    });

                    if (absence) {

                        var timing = [];

                        var absenceCurrentDate = moment(currentDate).format('YYYY-MM-DD');
                        var employeeStartTime = moment(absenceCurrentDate + ' ' + employee.workSchedule.start);
                        var employeeEndTime = moment(absenceCurrentDate + ' ' + employee.workSchedule.end);
                        timing.push({
                            from: employeeStartTime.toDate(),
                            to: employeeEndTime.toDate()
                        });
                        ganttEstimatedTasks.forEach(function (ganttEstimatedTask) {
                            timing.push({
                                from: ganttEstimatedTask.from,
                                to: ganttEstimatedTask.to
                            });
                        });
                        var minimumFrom = _.min(timing, function (time) {
                            return time.from;
                        });
                        var minimumTo = _.min(timing, function (time) {
                            return time.to;
                        });

                        var absenceTask = {
                            name: $translate.instant("CONTROL_PANEL.VIEWS.GANTT.ABSENCE_TASK_NAME", {
                                reason: absence.reason
                            }),
                            id: msUtils.guidGenerator(),
                            type: 'absence',
                            color: 'transparent',
                            classes: ['absence-task'],
                            from: minimumFrom.from,
                            to: minimumTo.to
                        };

                        ganttEstimatedTasks.push(absenceTask);
                    }
                }

                function checkOverlaps() {
                  ganttEstimatedTasks.forEach(function (t1) {
                    ganttEstimatedTasks.forEach(function (t2) {
                            if (t1.id != t2.id) {
                                var previousTask = t1;
                                var nextTask = t2;

                                if (previousTask.from > nextTask.from) {
                                    nextTask = t1;
                                    previousTask = t2;
                                }

                                var t1From = moment(previousTask.from);
                                var t1To = moment(previousTask.to);
                                var range1 = moment.range(t1From, t1To);

                                var t2From = moment(nextTask.from).add(1, 'm');
                                var t2To = moment(nextTask.to);
                                var range2 = moment.range(t2From, t2To);

                                if (range1.overlaps(range2)) {
                                    t1.classes = t1.classes || [];
                                    t1.classes.push('gantt-task-overlaps');
                                    t2.classes = t2.classes || [];
                                    t2.classes.push('gantt-task-overlaps');
                                }
                            }
                        });
                    });
                }

                estimatedTasks.forEach(function (task) {
                    createRouteTask(task);
                    createTask(task);
                });

                createAbsenceTask();
                checkOverlaps();

                var employeeLocation = _.find(locations, function (location) {
                    if (location.employee) {
                        return location.employee && location.employee.id === employee.id;
                    } else {
                        return false;
                    }
                });

                rows.push({
                    name: employee.name,
                    employeeId: employee.id,
                    content: ganttHtmlTemplate.employeeTemplate(currentDate, employeeLocation, employee, estimatedTasks),
                    tasks: orderByPriority(ganttEstimatedTasks)
                });

            });

            if (account && account.configuration && account.configuration.ganttEmployeesPositions) {
                if (account.configuration.ganttEmployeesSortBy !== 'alphabetically') {
                    rows = _.sortBy(rows, function (row) {
                        var employeePosition = _.find(account.configuration.ganttEmployeesPositions, function (configPosition) {
                            return configPosition.id == row.employeeId;
                        });
                        if (employeePosition) {
                            return employeePosition.position;
                        }
                        else {
                            return 999;
                        }
                    });
                } else {
                    rows =  _.sortBy(rows, function (row) {
                        row.name.toLowerCase();
                        return (row.name = row.name.charAt(0).toUpperCase() + row.name.slice(1));
                    });
                }
            }

            return rows;
        }

        function getSecundarysTaskGroup(estimatedResult, employeeId) {
            var secundarysTaskGroup = [];
            estimatedResult.forEach(function (task) {
                if (!task.employees || !task.employees.length) {
                    return;
                }

                var activityBelongsToEmployee = _.find(task.employees, function (employee) {
                    return employee.id === employeeId;
                });

                if (activityBelongsToEmployee) {
                    secundarysTaskGroup.push(task);
                }
            });
            return secundarysTaskGroup;
        }

    }
})();

(function () {
    'use strict';

    angular.module('app.control-panel')
        .factory('ganttConfig', ganttConfig);

    /** @ngInject */
    function ganttConfig(ganttHtmlTemplate, moment, $translate, LocalDateConvert) {

        return {
            getOptions: getOptions
        };

        function getOptions() {


            return {
                viewScale               : 'hour',
                zoom                    : 1,
                sideMode                : 'table',
                maxHeight               : 1000,
                taskContent             : ganttHtmlTemplate.taskTemplate(),
                allowSideResizing       : false,
                labelsEnabled           : true,
                fromDate                : '',
                toDate                  : '',
                headers                 : ['month', 'day', 'hour'],
                columns                 : ['model.name'],
                columnsHeaders          : [$translate.instant("CONTROL_PANEL.VIEWS.GANTT.CONFIG_EMPLOYEE")],
                currentDate             : 'line',
                currentDateValue        : moment().format('YYYY-MM-DD HH:mm'),
                draw                    : false,
                headersFormats: {
                  day: LocalDateConvert.pickFormat('date'),
                }
            };
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieSaveProductsService', omieSaveProductsService);

  function omieSaveProductsService(_) {
    return {
      mapProductsToSave: mapProductsToSave
    };

    function mapProductsToSave(form) {
      var products = [];

      if (form.products && form.products.length) {
        products = form.products.reduce(function (mappedProducts, product) {
          var foundProduct = mappedProducts.find(function (mappedProduct) {
            return mappedProduct.nCodProdutoPU === product.obj.id;
          });

          if (foundProduct) {
            foundProduct.nQtdePU += product.quantity;
          } else {
            mappedProducts.push({
              nCodProdutoPU: product.obj.id,
              nQtdePU: product.quantity,
            });
          }

          return mappedProducts;
        }, []);
      }

      if (form.duplicateOsMethod === 'update') {
        var omieOsUsedProducts = _getUsedProducts(form);

        products = products.map(function (mappedProduct) {
          var usedProduct = omieOsUsedProducts.find(function (used) {
            return used.nCodProdutoPU === mappedProduct.nCodProdutoPU;
          });

          return _setProductAction(mappedProduct, usedProduct);
        });

        var removedProducts = _getRemovedProducts(omieOsUsedProducts, products);
        products = products.concat(removedProducts);
      }

      return products;
    };

    function _getUsedProducts(form) {
      return (
        form.omieOs &&
        form.omieOs.produtosUtilizados &&
        form.omieOs.produtosUtilizados.produtoUtilizado
      ) || [];
    }

    function _setProductAction(mappedProduct, usedProduct) {
      if (usedProduct) {
        mappedProduct.cAcaoItemPU = 'A'; // Alterar o item
        mappedProduct.nIdItemPU = usedProduct.nIdItemPU;

        return mappedProduct;
      }

      mappedProduct.cAcaoItemPU = 'I'; // Incluir o item
      return mappedProduct;
    }

    function _getRemovedProducts(omieOsUsedProducts, products) {
      var removedProducts = omieOsUsedProducts.filter(function (used) {
        return !products.some(function (mapped) {
          return mapped.nCodProdutoPU === used.nCodProdutoPU;
        });
      });

      return removedProducts.map(function (removed) {
        return {
          nCodProdutoPU: removed.nCodProdutoPU,
          cAcaoItemPU: 'E', // Excluir o item
          nIdItemPU: removed.nIdItemPU
        };
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieServiceMapper', omieServiceMapper);

  /** @ngInject */
  function omieServiceMapper() {
    return {
      generateServiceObject: generateServiceObject,
      toFieldControl: toFieldControl,
      toOmie: toOmie,
      getServicePropValueOrDefault: getServicePropValueOrDefault,
      groupEqualServicesToUpdateIntegrationCode: groupEqualServicesToUpdateIntegrationCode
    };

    function generateServiceObject(linkedService) {
      return {
        obj: {
          displayName: linkedService.displayName,
          value: linkedService.value,
          id: linkedService.id,
          qtd: linkedService.quantity,
          intListar: linkedService.intListar,
          displayDescription: linkedService.description
        },
        value: linkedService.value,
        qtd: linkedService.quantity
      };
    }

    function toFieldControl(omieService) {
      var serviceName = getServicePropValueOrDefault(omieService.cabecalho, 'cDescricao', '');
      var fieldControlService = {
        name: serviceName.slice(0, 150),
        value: getServicePropValueOrDefault(omieService.cabecalho, 'nPrecoUnit', 0),
        description: getServicePropValueOrDefault(omieService.descricao, 'cDescrCompleta', ''),
        type: 'service',
        archived: false,
        integrationId: getServicePropValueOrDefault(omieService.intListar, 'cCodIntServ', ''),
        omieId: getServicePropValueOrDefault(omieService.intListar, 'nCodServ', '')
      };
      return fieldControlService;
    }

    function toOmie(fieldControlService) {
      var omieService = {
        cCodIntServ: getServicePropValueOrDefault(fieldControlService, 'integrationId', ''),
        nCodServ: getServicePropValueOrDefault(fieldControlService, 'omieId', '')
      };
      return omieService;
    }

    function getServicePropValueOrDefault(service, prop, defaultValue) {
      if (!service || prop === null) { return defaultValue; }
      var propValue = service[prop] ? service[prop] : defaultValue;
      return propValue;
    }

    function groupEqualServicesToUpdateIntegrationCode(createdServices, servicesToSaveInfos) {
      var hasCreatedServices = createdServices && createdServices.length;
      var hasServicesInfos = servicesToSaveInfos && servicesToSaveInfos.length;
      if (!hasCreatedServices || !hasServicesInfos) { return null; }

      var servicesToUpdateIntegrationId = createdServices
        .map(function (createdService, serviceIndex) {
          var currentInfo = servicesToSaveInfos[serviceIndex];
          var service = currentInfo.service ? currentInfo.service : {};
          service.integrationId = createdService.id;
          return currentInfo.service;
        })
        .filter(function (service) { return service && service.integrationId && service.omieId; });

      return servicesToUpdateIntegrationId;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieProductMapper', omieProductMapper);

  /** @ngInject */
  function omieProductMapper() {
    return {
      generateProductObject: generateProductObject,
      toFieldControl: toFieldControl,
      toOmie: toOmie,
      getProductPropValueOrDefault: getProductPropValueOrDefault,
      groupEqualProductsToUpdateIntegrationCode: groupEqualProductsToUpdateIntegrationCode,
      getOmieMeasureToFieldControl: getOmieMeasureToFieldControl
    };

    function generateProductObject(linkedProduct) {
      return {
        obj: {
          name: linkedProduct.name,
          value: linkedProduct.value,
          id: linkedProduct.id,
          measure: getFieldMeasureToOmie(linkedProduct.measure)
        },
        value: linkedProduct.value,
        quantity: Number(linkedProduct.quantity),
        measure: getFieldMeasureToOmie(linkedProduct.measure),
      };
    }

    function toFieldControl(omieProduct) {
      var productImageUrl = omieProduct.imagens && omieProduct.imagens.length && omieProduct.imagens[0];
      var productName = getProductPropValueOrDefault(omieProduct, 'descricao', '');
      var fieldControlProduct = {
        name: productName.slice(0, 150),
        value: getProductPropValueOrDefault(omieProduct, 'valor_unitario', 1),
        measure: getOmieMeasureToFieldControl(omieProduct),
        description: getProductPropValueOrDefault(omieProduct, 'descr_detalhada', ''),
        type: 'product',
        imageUrl: productImageUrl ? productImageUrl.url_imagem : '',
        archived: false,
        integrationId: getProductPropValueOrDefault(omieProduct, 'codigo_produto_integracao', ''),
        omieId: getProductPropValueOrDefault(omieProduct, 'codigo_produto', ''),
        code: getProductPropValueOrDefault(omieProduct, 'codigo', '')
      };
      return fieldControlProduct;
    }

    function toOmie(fieldControlProduct) {
      var omieProduct = {
        codigo_produto_integracao: getProductPropValueOrDefault(fieldControlProduct, 'integrationId', ''),
        codigo_produto: getProductPropValueOrDefault(fieldControlProduct, 'omieId', '')
      };
      return omieProduct;
    }

    function getProductPropValueOrDefault(product, prop, defaultValue) {
      if (!product || prop === null) { return defaultValue; }
      var propValue = product[prop] ? product[prop] : defaultValue;
      return propValue;
    }

    function getFieldMeasureToOmie(fieldMeasure) {
      var FIELD_CONTROL_MEASURES = Object.freeze({
        UNITY: {
          ordinal: 0,
          enum: 'unity',
        },
        CENTIMETER: {
          ordinal: 1,
          enum: 'centimeter',
        },
        METER: {
          ordinal: 2,
          enum: 'meter',
        },
        LITER: {
          ordinal: 3,
          enum: 'liter',
        },
        MILLILITER: {
          ordinal: 4,
          enum: 'milliliter',
        },
        KILOGRAM: {
          ordinal: 5,
          enum: 'kilogram',
        },
        GRAM: {
          ordinal: 6,
          enum: 'gram',
        }
      });

      var OMIE_MEASURES = Object.freeze({
        "UNID": FIELD_CONTROL_MEASURES.UNITY.enum,
        "UNI": FIELD_CONTROL_MEASURES.UNITY.enum,
        "UND": FIELD_CONTROL_MEASURES.UNITY.enum,
        "UN1": FIELD_CONTROL_MEASURES.UNITY.enum,
        "UND1": FIELD_CONTROL_MEASURES.UNITY.enum,
        "PC": FIELD_CONTROL_MEASURES.UNITY.enum,
        "CM": FIELD_CONTROL_MEASURES.CENTIMETER.enum,
        "M": FIELD_CONTROL_MEASURES.METER.enum,
        "MTS": FIELD_CONTROL_MEASURES.METER.enum,
        "METRO": FIELD_CONTROL_MEASURES.METER.enum,
        "ML1": FIELD_CONTROL_MEASURES.METER.enum,
        "L": FIELD_CONTROL_MEASURES.LITER.enum,
        "LT": FIELD_CONTROL_MEASURES.LITER.enum,
        "LITRO": FIELD_CONTROL_MEASURES.LITER.enum,
        "LT2": FIELD_CONTROL_MEASURES.LITER.enum,
        "LI1": FIELD_CONTROL_MEASURES.LITER.enum,
        "ML": FIELD_CONTROL_MEASURES.MILLILITER.enum,
        "KG": FIELD_CONTROL_MEASURES.KILOGRAM.enum,
        "KG1": FIELD_CONTROL_MEASURES.KILOGRAM.enum,
        "G": FIELD_CONTROL_MEASURES.GRAM.enum,
        "GR": FIELD_CONTROL_MEASURES.GRAM.enum,
        "GRAMA": FIELD_CONTROL_MEASURES.GRAM.enum
      });

      for (var key in OMIE_MEASURES) {
        if (OMIE_MEASURES[key] === fieldMeasure) {
          return key;
        }
      }

      return fieldMeasure;
    }

    function getOmieMeasureToFieldControl(omieProduct) {
      var omieMeasure = getProductPropValueOrDefault(omieProduct, 'unidade', 'UND');
      var FIELD_CONTROL_MEASURES = Object.freeze({
        UNITY: {
          ordinal: 0,
          enum: 'unity',
        },
        CENTIMETER: {
          ordinal: 1,
          enum: 'centimeter',
        },
        METER: {
          ordinal: 2,
          enum: 'meter',
        },
        LITER: {
          ordinal: 3,
          enum: 'liter',
        },
        MILLILITER: {
          ordinal: 4,
          enum: 'milliliter',
        },
        KILOGRAM: {
          ordinal: 5,
          enum: 'kilogram',
        },
        GRAM: {
          ordinal: 6,
          enum: 'gram',
        }
      });
      var OMIE_MEASURES = Object.freeze({
        "UNID": FIELD_CONTROL_MEASURES.UNITY,
        "UNI": FIELD_CONTROL_MEASURES.UNITY,
        "UND": FIELD_CONTROL_MEASURES.UNITY,
        "UN1": FIELD_CONTROL_MEASURES.UNITY,
        "UND1": FIELD_CONTROL_MEASURES.UNITY,
        "PC": FIELD_CONTROL_MEASURES.UNITY,
        "CM": FIELD_CONTROL_MEASURES.CENTIMETER,
        "M": FIELD_CONTROL_MEASURES.METER,
        "MTS": FIELD_CONTROL_MEASURES.METER,
        "METRO": FIELD_CONTROL_MEASURES.METER,
        "ML1": FIELD_CONTROL_MEASURES.METER,
        "L": FIELD_CONTROL_MEASURES.LITER,
        "LT": FIELD_CONTROL_MEASURES.LITER,
        "LITRO": FIELD_CONTROL_MEASURES.LITER,
        "LT2": FIELD_CONTROL_MEASURES.LITER,
        "LI1": FIELD_CONTROL_MEASURES.LITER,
        "ML": FIELD_CONTROL_MEASURES.MILLILITER,
        "KG": FIELD_CONTROL_MEASURES.KILOGRAM,
        "KG1": FIELD_CONTROL_MEASURES.KILOGRAM,
        "G": FIELD_CONTROL_MEASURES.GRAM,
        "GR": FIELD_CONTROL_MEASURES.GRAM,
        "GRAMA": FIELD_CONTROL_MEASURES.GRAM
      });
      var measureUnit = OMIE_MEASURES[omieMeasure] || FIELD_CONTROL_MEASURES.UNITY;
      return measureUnit.enum;
    }

    function groupEqualProductsToUpdateIntegrationCode(createdProducts, productsToSaveInfos) {
      var hasCreatedProducts = createdProducts && createdProducts.length;
      var hasProductsInfos = productsToSaveInfos && productsToSaveInfos.length;
      if (!hasCreatedProducts || !hasProductsInfos) { return null; }

      var productsToUpdateIntegrationId = createdProducts
        .map(function (createdProduct, productIndex) {
          var currentInfo = productsToSaveInfos[productIndex];
          var product = currentInfo.product ? currentInfo.product : {};
          product.integrationId = createdProduct.id;
          return currentInfo.product;
        })
        .filter(function (product) { return product && product.integrationId && product.omieId; });

      return productsToUpdateIntegrationId;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieCustomerMapper', omieCustomerMapper);

  /** @ngInject */
  function omieCustomerMapper(msUtils, $filter, omieCityApi, _, accountCache) {

    accountCache.loadAccount();

    return {
      toFieldControl: toFieldControl,
      toFieldControlContacts: toFieldControlContacts,
      toOmie: toOmie,
      getOmieName: getOmieName,
      getOmieDocument: getOmieDocument,
      getOmieEmail: getOmieEmail,
      getOmiePhone: getOmiePhone,
      stateToUf: stateToUf,
      ufToState: ufToState,
      toOmieAddress: toOmieAddress,
      toOmieContacts: toOmieContacts,
      toOmieDocument: toOmieDocument,
      toOmieNames: toOmieNames,
      removeUfFromCity: removeUfFromCity
    };

    function toFieldControl(omieCustomer, dontDecode) {
      var fieldControlCustomer = {
        name: getOmieName(omieCustomer, dontDecode),
        documentNumber: getOmieDocument(omieCustomer),
        contact: {
          email: getOmieEmail(omieCustomer),
          phone: getOmiePhone(omieCustomer)
        },
        contacts: toFieldControlContacts(omieCustomer),
        address: toFieldControlAddress(omieCustomer)
      };

      if (!dontDecode) {
        fieldControlCustomer.name = _decodeString(fieldControlCustomer.name);
      }

      return fieldControlCustomer;
    }

    function toOmie(fieldControlCustomer, fieldControlLocation) {
      var omieCustomer = {};
      omieCustomer = Object.assign(omieCustomer, toOmieAddress(fieldControlCustomer, fieldControlLocation));
      omieCustomer = Object.assign(omieCustomer, toOmieContacts(fieldControlCustomer, fieldControlLocation));
      omieCustomer = Object.assign(omieCustomer, toOmieDocument(fieldControlCustomer, fieldControlLocation));
      omieCustomer = Object.assign(omieCustomer, toOmieNames(fieldControlCustomer, fieldControlLocation));
      return omieCustomer;
    }

    function toOmieAddress(fieldControlCustomer, fieldControlLocation) {
      var omieAddress = {
        bairro: null,
        cep: null,
        cidade: null,
        complemento: null,
        endereco: null,
        endereco_numero: null,
        estado: null,
      };

      if (!fieldControlCustomer.address) { return omieAddress; }

      var address = fieldControlLocation ? fieldControlLocation.address : fieldControlCustomer.address;
      var state = null;

      if (address.neighborhood && address.neighborhood.length > 2) {
        omieAddress.bairro = address.neighborhood;
      }

      var zipCode = address.postalCode || address.zipCode;
      if (zipCode && zipCode.length >= 8) {
        omieAddress.cep = zipCode;
      } else if (address.formattedAddress) {
        var cepFinder = /\d+/g;
        var searchAddress = address.formattedAddress;
        var searchResult = searchAddress.match(cepFinder);
        var foundNumber;
        var foundZipCode;

        if (searchResult && searchResult.length) {
          for (var index = 0; index < searchResult.length; index++) {
            zipCode = searchResult[index];
            if (!foundNumber && !searchAddress.substr(searchAddress.indexOf(zipCode) + zipCode.length, 1)) {
              foundNumber = zipCode;
            }

            if (zipCode.length >= 5 && searchAddress.substr(searchAddress.indexOf(zipCode) + zipCode.length, 1)) {
              foundZipCode = zipCode + searchResult[index + 1];
              continue;
            }
          }
        }
        omieAddress.cep = foundZipCode;
        omieAddress.endereco_numero = foundNumber;
      }
      if(address.complement && address.complement.length > 1) {
        omieAddress.complemento = address.complement;
      }

      if(address.street && address.street.length > 1) {
        omieAddress.endereco = address.street;
      }

      if(address.number && address.number.length > 1) {
        omieAddress.endereco_numero = address.number;
      }

      if(address.state && address.state.length > 1) {
        state = stateToUf(address.state);
        omieAddress.estado = state;
      }

      if(address.city && address.city.length > 1) {
        resolveOmieCity(omieAddress, state, address.city);
      }

      return omieAddress;
    }

    function toOmieContacts(fieldControlCustomer, fieldControlLocation) {
      var customerPhones = getFieldControlPhone(fieldControlCustomer, fieldControlLocation);
      var customerEmails = getFieldControlEmail(fieldControlCustomer, fieldControlLocation);

      var omieContacts = {
        email: customerEmails[0],
        telefone1_ddd: customerPhones[0] ? customerPhones[0].ddd : null,
        telefone1_numero: customerPhones[0] ? customerPhones[0].number : null,
        telefone2_ddd: customerPhones[1] ? customerPhones[1].ddd : null,
        telefone2_numero: customerPhones[1] ? customerPhones[1].number : null
      };

      return omieContacts;
    }

    function toOmieDocument(fieldControlCustomer, fieldControlLocation) {
      var documentNumber = fieldControlLocation.documentNumber || fieldControlCustomer.documentNumber;
      if (!documentNumber) { return { cnpj_cpf: null, pessoa_fisica: null }; }

      if(documentNumber.length === 14) {
        return {
          cnpj_cpf: $filter('cpfCnpjFilter')(documentNumber),
          pessoa_fisica: 'N'
        };
      }

      if(documentNumber.length === 11) {
        return {
          cnpj_cpf: $filter('cpfCnpjFilter')(documentNumber),
          pessoa_fisica: 'S'
        };
      }
    }

    function toOmieNames(fieldControlCustomer, fieldControlLocation, dontDecode) {
      if (!fieldControlCustomer.name && !fieldControlLocation.name) {
        return {
          nome_fantasia: null,
          razao_social: null
        };
      }

      var name = fieldControlCustomer.name + ' ' + fieldControlLocation.name;

      if (fieldControlCustomer.primaryLocation && fieldControlCustomer.primaryLocation.id === fieldControlLocation.id) {
        name = fieldControlCustomer.name;
      }

      if (!dontDecode) {
        name = _decodeString(name);
      }

      return { nome_fantasia: name.substring(0, 100), razao_social: name.substring(0, 60) };
    }

    function getOmieName(omieCustomer, dontDecode) {
      var account = accountCache.getAccount();
      var configuration = account && account.configuration;
      var name = omieCustomer.razao_social || null;

      if (omieCustomer.nome_fantasia && configuration) {
        var usesTradeName = configuration.integrationOmieCustomerCommercialName;
        name = usesTradeName ? omieCustomer.nome_fantasia : name;
      }

      if (!dontDecode) {
        name = _decodeString(name);
      }

      return name;
    }

    function getOmieDocument(omieCustomer) {
      return omieCustomer.cnpj_cpf ? omieCustomer.cnpj_cpf.replace(/[^\w\s]/gi, '') : null;
    }

    function getOmieEmail(omieCustomer) {
      return omieCustomer.email && omieCustomer.email.length > 2 ? omieCustomer.email : null;
    }

    function getOmiePhone(omieCustomer) {
      if (
        omieCustomer.telefone1_ddd &&
        omieCustomer.telefone1_ddd.length > 1 &&
        omieCustomer.telefone1_numero &&
        omieCustomer.telefone1_numero.length > 5
      ) {
        return omieCustomer.telefone1_ddd + omieCustomer.telefone1_numero;
      }

      if (
        omieCustomer.telefone2_ddd &&
        omieCustomer.telefone2_ddd.length > 1 &&
        omieCustomer.telefone2_numero &&
        omieCustomer.telefone2_numero.length > 5
      ) {
        return omieCustomer.telefone2_ddd + omieCustomer.telefone2_numero;
      }

      return null;
    }

    function toFieldControlContacts(omieCustomer) {
      var contacts = {
        emails: [],
        phones: []
      };
      if(omieCustomer.email) {
        contacts.emails = omieCustomer.email.split(',')
          .map(function (email, index) {
            return {
              address: email,
              type: "personal",
              primary: index === 0 ? true : false
            };
          });
      }
      if( omieCustomer.telefone1_ddd &&
          omieCustomer.telefone1_ddd.length > 1 &&
          omieCustomer.telefone1_numero &&
          omieCustomer.telefone1_numero.length > 5) {
        contacts.phones.push({
          countryCode: "55",
          number: omieCustomer.telefone1_ddd + omieCustomer.telefone1_numero,
          type: "home",
          primary: false
        });
      }
      if( omieCustomer.telefone2_ddd &&
          omieCustomer.telefone2_ddd.length > 1 &&
          omieCustomer.telefone2_numero &&
          omieCustomer.telefone2_numero.length > 5) {
        contacts.phones.push({
          countryCode: "55",
          number: omieCustomer.telefone2_ddd + omieCustomer.telefone2_numero,
          type: "home",
          primary: false
        });
      }
      if(contacts.phones[0] && contacts.phones[0].number) {
        contacts.phones[0].primary = true;
      }

      if(omieCustomer.contato && contacts.phones[0]) {
        contacts.phones[0].name = omieCustomer.contato;
      }
      return contacts;
    }

    function toFieldControlAddress(omieCustomer) {
      var fieldControlAddress = {
        zipCode: omieCustomer.cep ? omieCustomer.cep.replace(/\D/g, '') : '',
        street: omieCustomer.endereco,
        number: omieCustomer.endereco_numero,
        complement: omieCustomer.complemento,
        neighborhood: omieCustomer.bairro,
        city: removeUfFromCity(omieCustomer.cidade),
        state: omieCustomer.estado,
        coords: {
          latitude: null,
          longitude: null
        },
        formattedAddress: ''
      };

      fieldControlAddress.formattedAddress += omieCustomer.endereco ? omieCustomer.endereco + ', ' : '';
      fieldControlAddress.formattedAddress += omieCustomer.endereco_numero ? omieCustomer.endereco_numero + ' - ' : '';
      fieldControlAddress.formattedAddress += omieCustomer.bairro ? omieCustomer.bairro + ', ' : '';
      fieldControlAddress.formattedAddress += omieCustomer.cidade ? removeUfFromCity(omieCustomer.cidade) + ' - ' : '';
      fieldControlAddress.formattedAddress += omieCustomer.estado ? omieCustomer.estado + ', ' : '';
      fieldControlAddress.formattedAddress += omieCustomer.cep ? omieCustomer.cep : '';
      return fieldControlAddress;
    }

    function resolveOmieCity(omieAddress, ufState, cityName) {
      if(ufState) {
        var formattedOmieCity = addUfToCity(cityName, ufState);
        omieAddress.cidade = formattedOmieCity;
      } else {
        getOmieCityCodeByName(omieAddress, cityName);
      }
    }

    function getOmieCityCodeByName(omieAddress, city) {
      omieCityApi.search(city).then(function (resultCity) {
        if(resultCity || resultCity.length) {
          var formattedCityToOmie = resultCity[0].cCod;
          omieAddress.cidade = formattedCityToOmie;
        }
      });
    }

    function removeUfFromCity(city) {
      return city.split(' (')[0];
    }

    function addUfToCity(cityName, ufState) {
      var state = ' (' + ufState + ')';
      var formattedCity = cityName.concat(state);
      return formattedCity;
    }

    function stateToUf(stateName) {
      var ufs = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
      for (var i = 0; i < ufs.length; i++ ) {
      var uf = ufs[i];
        if (stateName === uf) {
         return uf;
        }
      }

      var states = [];
      stateName = stateName.toLowerCase();
      stateName = msUtils.removeAccents(stateName);
      states['acre'] = 'AC';
      states['alagoas'] = 'AL';
      states['amapa'] = 'AP';
      states['amazonas'] = 'AM';
      states['bahia'] = 'BA';
      states['ceara'] = 'CE';
      states['distrito federal'] = 'DF';
      states['espirito santo'] = 'ES';
      states['goias'] = 'GO';
      states['maranhao'] = 'MA';
      states['mato grosso'] = 'MT';
      states['mato grosso do sul'] = 'MS';
      states['minas gerais'] = 'MG';
      states['para'] = 'PA';
      states['paraiba'] = 'PB';
      states['parana'] = 'PR';
      states['pernambuco'] = 'PE';
      states['piaui'] = 'PI';
      states['rio de janeiro'] = 'RJ';
      states['rio grande do norte'] = 'RN';
      states['rio grande do sul'] = 'RS';
      states['rondonia'] = 'RO';
      states['roraima'] = 'RR';
      states['santa catarina'] = 'SC';
      states['sao paulo'] = 'SP';
      states['sergipe'] = 'SE';
      states['tocantins'] = 'TO';
      return states[stateName];
    }

    function ufToState(UF) {
      var states = [];
      states['AC'] = 'Acre';
      states['AL'] = 'Alagoas';
      states['AP'] = 'Amapá';
      states['AM'] = 'Amazonas';
      states['BA'] = 'Bahia';
      states['CE'] = 'Ceará';
      states['DF'] = 'Distrito Federal';
      states['ES'] = 'Espírito Santo';
      states['GO'] = 'Goiás';
      states['MA'] = 'Maranhão';
      states['MT'] = 'Mato Grosso';
      states['MS'] = 'Mato Grosso do Sul';
      states['MG'] = 'Minas Gerais';
      states['PA'] = 'Pará';
      states['PB'] = 'Paraíba';
      states['PR'] = 'Paraná';
      states['PE'] = 'Pernambuco';
      states['PI'] = 'Piauí';
      states['RJ'] = 'Rio de Janeiro';
      states['RN'] = 'Rio Grande do Norte';
      states['RS'] = 'Rio Grande do Sul';
      states['RO'] = 'Rondônia';
      states['RR'] = 'Roraima';
      states['SC'] = 'Santa Catarina';
      states['SP'] = 'São Paulo';
      states['SE'] = 'Sergipe';
      states['TO'] = 'Tocantins';
      return states[UF];
    }

    function getFieldControlPhone(fieldCustomer, fieldLocation) {
      var hasCustomerPhone = fieldCustomer.contacts && fieldCustomer.contacts.phones && fieldCustomer.contacts.phones.length;
      var hasLocationPhones = fieldLocation.contacts && fieldLocation.contacts.phones && fieldLocation.contacts.phones.length;
      var hasOldContact = fieldCustomer.contact && fieldCustomer.contact.phone;
      if (!hasCustomerPhone && !hasLocationPhones && !hasOldContact) { return [mapOmiePhone(null)]; }
      if (!hasCustomerPhone && !hasLocationPhones) { return [mapOmiePhone(fieldCustomer.contact.phone)]; }

      var phones = [];
      _.sortBy(fieldLocation.contacts.phones, 'primary').reverse().forEach(function (phone) {
        phones.push(mapOmiePhone(phone.number));
      });
      _.sortBy(fieldCustomer.contacts.phones, 'primary').reverse().forEach(function (phone) {
        phones.push(mapOmiePhone(phone.number));
      });

      return phones;
    }

    function getFieldControlEmail(fieldCustomer, fieldLocation) {
      var hasCustomerEmails = fieldCustomer.contacts && fieldCustomer.contacts.emails && fieldCustomer.contacts.emails.length;
      var hasLocationEmails = fieldLocation.contacts && fieldLocation.contacts.emails && fieldLocation.contacts.emails.length;
      var hasOldContact = fieldCustomer.contact && fieldCustomer.contact.email;
      if (!hasCustomerEmails && !hasLocationEmails && !hasOldContact) { return [null]; }
      if (!hasCustomerEmails && !hasLocationEmails) { return [fieldCustomer.contact.email]; }

      var emails = [];
      _.sortBy(fieldLocation.contacts.emails, 'primary').reverse().forEach(function (email) {
        emails.push(email.address);
      });
      _.sortBy(fieldCustomer.contacts.emails, 'primary').reverse().forEach(function (email) {
        emails.push(email.address);
      });

      return emails;
    }

    function mapOmiePhone(phone) {
      if (!phone) { return { ddd: null, number: null }; }

      return {
        ddd: phone.substr(0, 2),
        number: phone.substr(2, phone.length)
      };
    }

    function _decodeString(input) {
      var parser = new DOMParser();
      var decodedDoc = parser.parseFromString(input, 'text/html');
      return decodedDoc.body.textContent;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieServiceApi', omieServiceApi);

  function omieServiceApi(EnvironmentConfig, omieApiErrorHandler, $http) {

    var api = EnvironmentConfig.shelob + 'omie/servicos/servico';
    var responseForResourceNotFound = {
      status: 200,
      data: {
        nPagina: 1,
        nTotPaginas: 1,
        nRegistros: 0,
        nTotRegistros: 0,
        cadastro: []
      }
    };

    return {
      list: list,
      search: search,
      create: create,
      editIntegrationCode: editIntegrationCode
    };

    function _loadAllPages(appId, currentPage, allServices) {
      currentPage = currentPage || 1;
      allServices = allServices || [];

      return list({ nPagina: currentPage, nRegPorPagina: 500 }, appId)
        .then(function (response) {
          var servicesBatch = response.data.cadastros || response.data.resultResource.cadastro || [];
          allServices = allServices.concat(servicesBatch);
          var totalPages = response.data.nTotPaginas || 1;

          if (currentPage < totalPages) {
            return _loadAllPages(appId, currentPage + 1, allServices);
          }

          return allServices;
        });
    }

    function list(options, appId) {
      var params = {
        nPagina: 1,
        nRegPorPagina: 500
      };

      if (options) {
        if (options.nPagina) {
          params.nPagina = options.nPagina;
        }
        if (options.nRegPorPagina) {
          params.nRegPorPagina = options.nRegPorPagina;
        }
        if (options.cDescricao) {
          params.cDescricao = options.cDescricao;
        }
      }

      var payload = {
        call: 'ListarCadastroServico',
        appId: String(appId),
        param: [params]
      };

      return omieApiErrorHandler.responseForResourceNotFound(api, payload, responseForResourceNotFound);
    }

    function search(appId) {
      return _loadAllPages(appId)
      .then(function (services) {

        if (services && services.length) {
          return services.map(function (service) {
            service.displayName = service.cabecalho.cCodigo + ' - ' + service.cabecalho.cDescricao;
            service.integrationId = service.intListar.cCodIntServ;
            service.id = service.cabecalho.cCodigo;
            service.value = service.cabecalho.nPrecoUnit;

            return service;
          });
        }
        return services;
      });
    }

    function create(service, appId) {
      var randomId = parseInt(Math.random() * (1 - 10000) + 10000).toString();

      var service = {
          intIncluir: {
            cCodIntServ: service.id
          },
          descricao: {
            cDescrCompleta: service.name
          },
          cabecalho: {
            cDescricao: service.name,
            cCodigo: randomId,
            nPrecoUnit: service.price
          }
      };

      var payload = {
        call: 'IncluirCadastroServico',
        appId: String(appId),
        param: [service]
      };
      return $http.post(api, payload);
    };

    function editIntegrationCode(service, appId) {
      var payload = {
        call: 'AssociarCodIntServico',
        appId: String(appId),
        param: [service]
      };
      return $http.post(api, payload);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieServiceCachedApi', omieServiceCachedApi);

  function omieServiceCachedApi(omieServiceApi) {

    var cachedResponse = null;

    return {
      list: list,
      search: omieServiceApi.search,
      create: omieServiceApi.create
    };

    function list(options) {
      if (cachedResponse) {
        return Promise.resolve(cachedResponse);
      }
      return omieServiceApi.list(options).then(function (response) {
        cachedResponse = response;
        return response;
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('omieSalesOrderApi', omieSalesOrderApi);

  function omieSalesOrderApi(EnvironmentConfig, $http) {
    var api = EnvironmentConfig.shelob + 'omie/produtos/pedido';

    return {
      create: create,
    };

    function create(form, appId) {
      var randomId = parseInt(Math.random() * (1 - 10000) + 10000).toString();
      var forecastDate = moment(form.forecastDate).format('DD/MM/YYYY');

      var stage = form.stageToSave;
      var validStages = ['10', '20', '30', '40', '50', '70', '80'];

      if (!validStages.includes(stage)) {
        stage = '10';
      }

      var salesOrder = {
        cabecalho: {
          codigo_cliente: form.customer.codigo_cliente_omie,
          codigo_pedido_integracao: randomId,
          data_previsao: forecastDate,
          etapa: stage,
          quantidade_itens: form.products.length,
          codigo_parcela: form.installmentToSave.cCodigo,
          qtde_parcelas: parseInt(form.installmentToSave.nQtdeParc),
        },
        det: form.products.map(function (product) {
          var omieProduct = {
            ide: {
              codigo_item_integracao: randomId,
            },
            produto: {
              codigo_produto: product.obj.id,
              quantidade: product.quantity,
              unidade: product.obj.measure,
              valor_unitario: product.value,
            },
          };

          if (product.discount && product.discount.value) {
            var percentage = product.discount.type === 'percentage';
            omieProduct.produto.tipo_desconto = percentage ? 'P' : 'V';

            if (percentage) {
              omieProduct.produto.percentual_desconto = product.discount.value;
            } else {
              omieProduct.produto.valor_desconto = product.discount.value;
            }
          }

          return omieProduct;
        }),
        informacoes_adicionais: {
          codigo_categoria: form.categoryToSave.codigo,
          consumidor_final: 'S',
          enviar_email: 'N',
          codigo_conta_corrente: form.bankAccountToSave.nCodCC,
          codVend: parseInt(form.sellerToSave.codigo)
        }
      };

      var payload = {
        call: 'IncluirPedido',
        appId: appId,
        param: [salesOrder],
      };

      return $http.post(api, payload);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieProductApi', omieProductApi);

  function omieProductApi(EnvironmentConfig, omieApiErrorHandler, $http, msUtils) {

    var api = EnvironmentConfig.shelob + 'omie/geral/produtos';
    var responseForResourceNotFound = {
      status: 200,
      data: {
        nPagina: 1,
        nTotPaginas: 1,
        nRegistros: 0,
        nTotRegistros: 0,
        cadastro: []
      }
    };

    return {
      list: list,
      search: search,
      update: update,
      getAll: getAll
    };

    function list(customParams, appId) {
      var pagina = customParams && customParams.pagina;
      var registros_por_pagina = customParams && customParams.registros_por_pagina;
      var apenas_importado_api = customParams && customParams.apenas_importado_api;
      var filtrar_apenas_omiepdv = customParams && customParams.filtrar_apenas_omiepdv;
      var ordenar_por = customParams && customParams.ordenar_por;
      var filtrar_apenas_descricao = customParams && customParams.filtrar_apenas_descricao;
      var exibir_obs = customParams && customParams.exibir_obs;
      var produtosPorCodigo = customParams && customParams.produtosPorCodigo;
      var params = {
        "pagina": pagina || 1,
        "registros_por_pagina": registros_por_pagina || 1000,
        "apenas_importado_api": apenas_importado_api || "N",
        "filtrar_apenas_omiepdv": filtrar_apenas_omiepdv || "N",
        "ordenar_por": ordenar_por || "DATA_ALT",
        "filtrar_apenas_descricao": filtrar_apenas_descricao || '',
        "exibir_obs": exibir_obs || 'N',
        "produtosPorCodigo": produtosPorCodigo || []
      };

      var payload = {
        call: 'ListarProdutos',
        appId: String(appId),
        param: [params]
      };

      return omieApiErrorHandler.responseForResourceNotFound(api, payload, responseForResourceNotFound);
    }

    function search(appId, customParams) {
      return list(customParams, appId).then(function (response) {
        var products = response.data.produto_servico_cadastro || [];
          var mappedProducts = products.map(function (product) {
            return {
              id: product.codigo_produto,
              integrationId: product.codigo_produto_integracao,
              name: msUtils.textSanitizer(product.descricao || ''),
              value: product.valor_unitario,
              measure: product.unidade,
            };
          });
          return mappedProducts;
      });
    }

    function update(omieProduct, appId) {
      var payload = {
        call: 'AssociarCodIntProduto',
        appId: String(appId),
        param: [omieProduct]
      };
      return $http.post(api, payload);
    }

    function getAll(appId, customParams) {
      return _listAll(customParams, appId).then(function (products) {
        var mappedProducts = products.map(function (product) {
          return {
            id: product.codigo_produto,
            integrationId: product.codigo_produto_integracao,
            name: msUtils.textSanitizer(product.descricao || ''),
            value: product.valor_unitario,
            measure: product.unidade,
          };
        });
        return mappedProducts;
      });
    }

    function _listAll(options, appId, allResults) {
      if(!allResults){
        allResults = [];
      }

      if (options) {
        var pagina = options.pagina;
        var registros_por_pagina = options.registros_por_pagina;
        var apenas_importado_api = options.apenas_importado_api;
        var filtrar_apenas_omiepdv = options.filtrar_apenas_omiepdv;
        var ordenar_por = options.ordenar_por;
        var filtrar_apenas_descricao = options.filtrar_apenas_descricao;
        var exibir_obs = options.exibir_obs;
        var produtosPorCodigo = options.produtosPorCodigo;
      }
      var params = {
        "pagina": pagina || 1,
        "registros_por_pagina": registros_por_pagina || 100,
        "apenas_importado_api": apenas_importado_api || "N",
        "filtrar_apenas_omiepdv": filtrar_apenas_omiepdv || "N",
        "ordenar_por": ordenar_por || "DATA_ALT",
        "filtrar_apenas_descricao": filtrar_apenas_descricao || '',
        "exibir_obs": exibir_obs || 'N',
        "produtosPorCodigo": produtosPorCodigo || []
      };

      var payload = {
        call: 'ListarProdutos',
        appId: String(appId),
        param: [params]
      };

      return $http.post(api, payload).then(function (currentResults) {
        if (!currentResults.data.produto_servico_cadastro) {
          return allResults;
        }
        allResults = allResults.concat(currentResults.data.produto_servico_cadastro);
        if(currentResults.data.total_de_paginas > currentResults.data.pagina) {
          params.pagina = currentResults.data.pagina + 1;
          return _listAll(params, appId, allResults);
        }

        return allResults;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieServicoMunicipioApi', omieServicoMunicipioApi);

  function omieServicoMunicipioApi($http, EnvironmentConfig) {

    var api = EnvironmentConfig.shelob + 'omie/servicos/listaservico';

    return {
      list: list
    };

    function list(options, appId) {
      if(!options) {
        options = {
          pagina: 1,
          registros_por_pagina: 1000
        };
      }
      var payload = {
        call: 'ListarServMunic',
        appId: String(appId),
        param: [options]
      };
      return $http.post(api, payload);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieSellerApi', omieSellerApi);

  function omieSellerApi($http, EnvironmentConfig) {

    var api = EnvironmentConfig.shelob + 'omie/geral/vendedores';

    return {
      list: list,
      search: search
    };

    function list(options, appId) {
      var params = {
        pagina: 1,
        registros_por_pagina: 100
      };

      if (options) {
        if (options.pagina) {
          params.pagina = options.pagina;
        }
        if (options.registros_por_pagina) {
          params.registros_por_pagina = options.registros_por_pagina;
        }
      }

      var payload = {
        call: 'ListarVendedores',
        appId: String(appId),
        param: [params]
      };

      return $http.post(api, payload);
    }

    function search(appId) {
      return list(null, appId).then(function (response) {
        var sellers = response.data.cadastro || [];
        var mappedSellers = sellers.map(function (seller) {
          seller.translate = seller.nome;
          seller.value = seller.nome;
          return seller;
        });
        return mappedSellers;
      });
    }
  }
})();

(function () {
    'use strict';

    angular
      .module('app.core')
      .factory('omiePaymentApi', omiePaymentApi);

    function omiePaymentApi($http, EnvironmentConfig) {

      var api = EnvironmentConfig.shelob + 'omie/produtos/formaspagvendas';

      return {
        list: list,
        search: search,
        getAll: getAll
      };

      function list(options, appId) {
        var params = {
          pagina: 1,
          registros_por_pagina: 1000
        };

        if (options) {
          if (options.pagina) {
            params.pagina = options.pagina;
          }
          if (options.registros_por_pagina) {
            params.registros_por_pagina = options.registros_por_pagina;
          }
        }

        var payload = {
          call: 'ListarFormasPagVendas',
          appId: String(appId),
          param: [params]
        };

        return $http.post(api, payload);
      }

      function search(appId) {
        return list(null, appId).then(function (response) {
          var mappedInstallments = response.data.cadastros.map(function (installment) {
            installment.translate = installment.cDescricao;
            installment.value = installment.cDescricao;
            return installment;
          });
          return mappedInstallments;
        });
      }
      function getAll(appId) {
        return _listAll(null, appId).then(function (response) {
          var mappedInstallments = response.map(function (installment) {
            installment.translate = installment.cDescricao;
            installment.value = installment.cDescricao;
            return installment;
          });
          return mappedInstallments;
        });
      }

      function _listAll(options, appId, allResults) {
        if(!allResults){
          allResults = [];
        }
        var params = {
          pagina: 1,
          registros_por_pagina: 1000
        };

        if (options) {
          if (options.pagina) {
            params.pagina = options.pagina;
          }
          if (options.registros_por_pagina) {
            params.registros_por_pagina = options.registros_por_pagina;
          }
        }

        var payload = {
          call: 'ListarFormasPagVendas',
          appId: String(appId),
          param: [params]
        };

        return $http.post(api, payload).then(function (currentResults) {
          allResults = allResults.concat(currentResults.data.cadastros);
          if(currentResults.data.total_de_paginas > currentResults.data.pagina) {
            params.pagina = currentResults.data.pagina + 1;
            return _listAll(params, appId, allResults);
          }

          return allResults;
        });
      }
    }

  })();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omiePaymentCachedApi', omiePaymentCachedApi);

  function omiePaymentCachedApi(omiePaymentApi) {

    var cachedResponse = {};

    return {
      list: list,
      search: omiePaymentApi.search,
      getAll: omiePaymentApi.getAll
    };

    function list(options) {
      var responseIndex = (options && options.pagina) ? String(options.pagina) : '1';
      if (cachedResponse[responseIndex]) {
        return Promise.resolve(cachedResponse[responseIndex]);
      }
      return omiePaymentApi.list(options).then(function (response) {
        var mappedInstallments = response.map(function (installment) {
          installment.translate = installment.cDescricao;
          installment.value = installment.cDescricao;
          return installment;
        });
        cachedResponse[responseIndex] = mappedInstallments;
        return mappedInstallments;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieLc116Api', omieLc116Api);

  function omieLc116Api($http, EnvironmentConfig) {

    var api = EnvironmentConfig.shelob + 'omie/servicos/lc116';

    return {
      list: list
    };

    function list(options, appId) {
      if(!options) {
        options = {
          pagina: 1,
          registros_por_pagina: 1000
        };
      }
      var payload = {
        call: 'ListarLC116',
        appId: String(appId),
        param: [options]
      };
      return $http.post(api, payload);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieOsApi', omieOsApi);

  function omieOsApi($http, EnvironmentConfig, authenticatedUser, moment, omieSaveProductsService, omieApiErrorHandler) {
    var api = EnvironmentConfig.shelob + 'omie/servicos/os';
    var responseForResourceNotFound = {
      status: 200,
      data: {
        nPagina: 1,
        nTotPaginas: 1,
        nRegistros: 0,
        nTotRegistros: 0,
        cadastro: []
      }
    };

    return {
      createOrUpdate: createOrUpdate,
      getByOsIdentifier: getByOsIdentifier
    };

    function createOrUpdate(form, appId) {
      var services = [];

      var orderDescription = '\nAdicionado via Field Control';

      if (authenticatedUser && authenticatedUser.profile && authenticatedUser.profile.name) {
        orderDescription += '\nCriado por: ' + authenticatedUser.profile.name + ' (' + authenticatedUser.profile.email + ')';
      }

      var nowDate = moment().format('DD/MM/YYYY');
      var nowTime = moment().format('HH:mm:ss');
      orderDescription += '\nCriado em: ' + nowDate + ' às ' + nowTime;

      if (form && form.task && form.task.order) {
        if (form.task.order.identifier) {
          orderDescription += '\nOrdem de serviço: ' + form.task.order.identifier;
        }
      }

      if (form && form.task && form.task.order && form.task.order.description) {
        orderDescription += '\n\n' + 'Descrição:\n' + form.task.order.description;
      }

      if (form && form.quotation) {
        if (form.quotation.description) {
          if (orderDescription) {
            orderDescription += '\nDescrição: ';
          }
          orderDescription += form.quotation.description;
        }

        if (form.quotation.additionalInformation) {
          if (orderDescription) {
            orderDescription += '\nObservação: ';
          }
          orderDescription += form.quotation.additionalInformation;
        }
      }

      if (form.services.length) {
        form.services.forEach(function (service, index) {
          var description = service.obj.displayName;

          if (service.obj.displayDescription) {
            description += '\nDescrição do Serviço: ' + service.obj.displayDescription;
          }

          var omieService = {
            cDescServ: description,
            nCodServico: service.obj.intListar.nCodServ,
            nQtde: service.qtd,
            nValUnit: service.value,
            nSeqItem: index + 1,
          };

          if (service.discount && service.discount.value) {
            var percentage = service.discount.type === 'percentage';

            omieService.cTpDesconto = percentage ? 'P' : 'V';

            if (percentage) {
              omieService.nAliqDesconto = service.discount.value;
            } else {
              omieService.nValorDesconto = service.discount.value;
            }
          }

          services.push(omieService);
        });
      }
      var usedProducts = {};
      var products = omieSaveProductsService.mapProductsToSave(form);
      var duplicateOsMethod = form.duplicateOsMethod;

      if (products && products.length) {
        usedProducts.produtoUtilizado = products;
        usedProducts.cAcaoProdUtilizados = 'EST';
      }

      var forecastDate = moment(form.forecastDate).format('DD/MM/YYYY');


      var omieCall = 'IncluirOS';
      var cCodIntOS = 'FieldControl' + parseInt(Math.random() * (1 - 10000) + 10000).toString();

      if(form.task && form.task.order && form.task.order.identifier) {
        cCodIntOS = form.task.order.identifier;
      }

      if (duplicateOsMethod === 'update') {
        omieCall = 'AlterarOS';
      }

      if (duplicateOsMethod === 'duplicate') {
        var randomId = parseInt(Math.random() * (1 - 10000) + 10000).toString();
        cCodIntOS = cCodIntOS + '-' + randomId;
      }

      var os = {
        Cabecalho: {
          cCodIntOS: cCodIntOS,                                        // Código de Integração da OS
          cEtapa: "10",                                                // Código da etapa do processo, sendo: (10, 20, 30, 40, 50)
          dDtPrevisao: forecastDate,                                   // Previsão de Faturamento
          nCodCli: parseInt(form.customer.codigo_cliente_omie),        // Código do Cliente
          cCodParc: form.installmentToSave.cCodigo,                    // Código da Parcela
          nQtdeParc: parseInt(form.installmentToSave.nQtdeParc),       // Quantidade de Parcelas
          nCodVend: parseInt(form.sellerToSave.codigo)                 // Código do Vendedor
        },
        InformacoesAdicionais: {
          cCidPrestServ: form.city.cCod,                               // Cidade
          cCodCateg: form.categoryToSave.codigo,                       // Categoria
          nCodCC: parseInt(form.bankAccountToSave.nCodCC)              // Código da Conta Corrente
        },
        ServicosPrestados: services,
        produtosUtilizados: usedProducts,
        Observacoes: {
          cObsOS: orderDescription                                     // Observações da OS
        }
      };

      var payload = {
        call: omieCall,
        appId: String(appId),
        param: [os]
      };

      return $http.post(api, payload);
    };

    function getByOsIdentifier(identifier, appId) {
      var payload = {
        call: 'ConsultarOS',
        appId: String(appId),
        param: {
          cCodIntOS: identifier
        }
      };

      return omieApiErrorHandler.responseForResourceNotFound(api, payload, responseForResourceNotFound);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieCustomerApi', omieCustomerApi);

  function omieCustomerApi($http, EnvironmentConfig, omieCustomerMapper, omieApiErrorHandler) {

    var api = EnvironmentConfig.shelob + 'omie/geral/clientes';
    var responseForResourceNotFound = {
      status: 200,
      data: {
        pagina: 1,
        total_de_paginas: 1,
        registros: 0,
        total_de_registros: 0,
        clientes_cadastro: []
      }
    };

    return {
      list: list,
      update: update,
      create: create,
      search: search,
      hasCustomers: hasCustomers
    };

    function create(fieldControlCustomer, fieldControlLocation, appId) {
      var omieCustomer = omieCustomerMapper.toOmie(fieldControlCustomer, fieldControlLocation);
      var cod_omie = parseInt(Math.random() * (99999 - 10000) + 10000).toString();
      cod_omie += fieldControlCustomer.id.toString();
      cod_omie = parseInt(cod_omie);
      omieCustomer.codigo_cliente_omie = cod_omie;
      omieCustomer.codigo_cliente_integracao = cod_omie;
      var payload = {
        call: 'IncluirCliente',
        appId: String(appId),
        param: [omieCustomer]
      };
      return $http.post(api, payload);
    }

    function update(codigoClienteOmie, fieldControlCustomer, fieldControlLocation, appId) {
      var omieCustomer = omieCustomerMapper.toOmie(fieldControlCustomer, fieldControlLocation);
      omieCustomer.codigo_cliente_omie = codigoClienteOmie;
      var payload = {
        call: 'AlterarCliente',
        appId: String(appId),
        param: [omieCustomer]
      };
      return $http.post(api, payload);
    }

    function list(options, appId) {
      var params = {
        pagina: 1,
        registros_por_pagina: 1000,
        apenas_importado_api: 'N'
      };

      if (options) {
        if (options.pagina && options.pagina > 0) {

          params.pagina = options.pagina;
        }
        if (options.registros_por_pagina && options.registros_por_pagina > 0) {
          params.registros_por_pagina = options.registros_por_pagina;
        }
        if (options.apenas_importado_api) {
          params.apenas_importado_api = options.apenas_importado_api;
        }
        if (options.clientesFiltro) {
          params.clientesFiltro = options.clientesFiltro;
        }
      }

      var payload = {
        call: 'ListarClientes',
        appId: String(appId),
        param: [params]
      };

      return omieApiErrorHandler.responseForResourceNotFound(api, payload, responseForResourceNotFound);
    }

    function search(filter, appId) {
      return list({ clientesFiltro: filter }, appId)
        .then(function (response) {
          return response.data.clientes_cadastro;
        });
    }

    function hasCustomers(appId) {
      return list({ registros_por_pagina: 1 }, appId)
        .then(function (response) {
          return !!response.data.total_de_registros;
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieCustomerApiHelper', omieCustomerApiHelper);

  function omieCustomerApiHelper(omieApi) {
    return {
      getPossibleCustomers: getPossibleCustomers
    };

    function apiListCustomers(filters, qtd, appId) {
      return omieApi.customers.list({
        clientesFiltro: filters,
        pagina: 1,
        registros_por_pagina: qtd || 1000,
        apenas_importado_api: "N"
      }, appId).then(function (response) {
        return response;
      }).catch(function (error) {
        return error;
      });
    }

    function _searchCustomersByDocumentNumber(documentNumber, appId) {
      return apiListCustomers({ cnpj_cpf: documentNumber }, 1000, appId).then(function (response) {
        var hasCustomers = response.status === 200 && response.data.total_de_registros > 0;
        if(hasCustomers) {
          return response.data.clientes_cadastro;
        } return [];
      });
    }

    function _searchCustomersByName(name, appId) {
      return apiListCustomers({ razao_social: name }, 1000, appId)
        .then(function (response) {
          var hasCustomers = response.status === 200 && response.data.total_de_registros > 0;
          if(hasCustomers) {
            return response.data.clientes_cadastro;
          } return [];
        });
    }

    function getPossibleCustomers(fieldCustomer, appId) {
      return _searchCustomersByDocumentNumber(fieldCustomer.documentNumber, appId).then(function (customersByDocumentNumber) {
        if(!customersByDocumentNumber.length) {
          return _searchCustomersByName(fieldCustomer.name, appId).then(function (customersByName) {
            if(customersByName.length) {
              return customersByName;
            } return [];
          }).catch(function () { return []; });
        } return customersByDocumentNumber;
      }).catch(function () {
        return _searchCustomersByName(fieldCustomer.name, appId).then(function (customersByName) {
          if(customersByName.length) {
            return customersByName;
          } return [];
        }).catch(function () { return []; });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieCityApi', omieCityApi);

  function omieCityApi($http, EnvironmentConfig) {

    var api = EnvironmentConfig.shelob + 'omie/geral/cidades';

    return {
      list: list,
      search: search
    };

    function list(options, appId) {
      var params = {
        pagina: 1,
        registros_por_pagina: 1000
      };

      if (options) {
        if (options.pagina) {
          params.pagina = options.pagina;
        }
        if (options.registros_por_pagina) {
          params.registros_por_pagina = options.registros_por_pagina;
        }
        if (options.filtrar_cidade_contendo) {
          params.filtrar_cidade_contendo = options.filtrar_cidade_contendo;
        }
      }

      var payload = {
        call: 'PesquisarCidades',
        appId: String(appId),
        param: [params]
      };
      return $http.post(api, payload);
    }

    function search(city, appId) {
      return list({ filtrar_cidade_contendo: city }, appId).then(function (response) {
        return response.data.lista_cidades;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieCategoryApi', omieCategoryApi);

  function omieCategoryApi($http, EnvironmentConfig) {

    var api = EnvironmentConfig.shelob + 'omie/geral/categorias';

    return {
      list: list,
      search: search
    };

    function list(options, appId) {
      if(!options) {
        options = {
          pagina: 1,
          registros_por_pagina: 1000
        };
      }
      var payload = {
        call: 'ListarCategorias',
        appId: String(appId),
        param: [options]
      };
      return $http.post(api, payload);
    }

    function search(appId) {
      return list(null, appId).then(function (response) {
        var categories = response.data.categoria_cadastro;

        categories = _.filter(categories, function (category) {
          return category.transferencia !== 'S' &&
                  category.totalizadora !== 'S' &&
                  category.nao_exibir !== 'S' &&
                  category.conta_inativa !== 'S' &&
                  category.conta_receita === 'S';
        });
        categories = _.sortBy(categories, 'descricao');

        var mappedResponse = categories.map(function (category) {
          category.value = category.descricao;
          category.translate = category.descricao;
          return category;
        });
        return mappedResponse;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieCategoryCachedApi', omieCategoryCachedApi);

  function omieCategoryCachedApi(omieCategoryApi) {

    var cachedResponse = null;

    return {
      list: list,
      search: omieCategoryApi.search
    };

    function list(options) {
      if (cachedResponse) {
        return Promise.resolve(cachedResponse);
      }
      return omieCategoryApi.list(options).then(function (response) {
        var mappedResponse = response.map(function (category) {
          category.value = category.descricao;
          category.translate = category.descricao;
          return category;
        });
        cachedResponse = mappedResponse;
        return mappedResponse;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieBankAccountApi', omieBankAccountApi);

  function omieBankAccountApi($http, EnvironmentConfig) {

    var api = EnvironmentConfig.shelob + 'omie/geral/contacorrente';

    return {
      list: list,
      search: search
    };

    function list(options, appId) {
      var params = {
        pagina: 1,
        registros_por_pagina: 1000,
        apenas_importado_api: 'N'
      };

      if (options) {
        if (options.pagina) {
          params.pagina = options.pagina;
        }
        if (options.registros_por_pagina) {
          params.registros_por_pagina = options.registros_por_pagina;
        }
        if (options.apenas_importado_api) {
          params.apenas_importado_api = options.apenas_importado_api;
        }
      }

      var payload = {
        call: 'ListarContasCorrentes',
        appId: String(appId),
        param: [params]
      };

      return $http.post(api, payload);
    }

    function search(appId) {
      return list(null, appId).then(function (response) {
        var banks = response.data.ListarContasCorrentes;
        return banks.map(function (bank) {
          bank.translate = bank.descricao;
          bank.value = bank.descricao;
          return bank;
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieBankAccountCachedApi', omieBankAccountCachedApi);

  function omieBankAccountCachedApi(omieBankAccountApi) {
    var cachedResponse = null;

    return {
      list: list,
      search: omieBankAccountApi.search
    };

    function list() {
      if (cachedResponse) {
        return Promise.resolve(cachedResponse);
      }
      return omieBankAccountApi.list().then(function (response) {
        var mappedBanks = response.map(function (bank) {
          bank.translate = bank.descricao;
          bank.value = bank.descricao;
          return bank;
        });
        cachedResponse = mappedBanks;
        return mappedBanks;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieAccountApi', omieAccountApi);

  function omieAccountApi($http, EnvironmentConfig, _) {

    var api = EnvironmentConfig.shelob + 'configuration/';

    return {
      list: list,
      delete: deleteAccount,
      saveAccounts: saveAccounts
    };

    function list() {
      return $http.get(api + 'omie-accounts');
    }

    function deleteAccount(appId) {
      return $http.delete(api + 'omie-account/' + appId);
    }

    function saveAccounts(accounts) {
      _.forEach(accounts, function (account) {
        var payload = {
          apiName: 'omie',
          accountName: account.name,
          appId: account.key
        };

        if (account.new) {
          delete account.new;

          payload.action = 'insert';
          payload.appKey = account.key;
          payload.appSecret = account.secret;

          return $http.put(api, payload);
        } else {
          delete account.new;

          payload.action = 'update';

          return $http.put(api, payload);
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('contaAzulAddress', contaAzulAddress);

  /** @ngInject */
  function contaAzulAddress($filter) {
    return function (contaAzulAddress) {
      if (contaAzulAddress) {
        var formattedAddress = '';
        if (contaAzulAddress.street) formattedAddress += contaAzulAddress.street + ', ';
        if (contaAzulAddress.number) formattedAddress += contaAzulAddress.number + ' - ';
        if (contaAzulAddress.neighborhood) formattedAddress += contaAzulAddress.neighborhood + ', ';
        if (contaAzulAddress.city && contaAzulAddress.city.name) formattedAddress += contaAzulAddress.city.name + ' - ';
        if (contaAzulAddress.state && contaAzulAddress.state.name) formattedAddress += contaAzulAddress.state.name + ', ';
        if (contaAzulAddress.zip_code) formattedAddress += $filter('brCep')(contaAzulAddress.zip_code.replace(/\D/g, ''));
        formattedAddress = formattedAddress.trim();
        if (formattedAddress.charAt(formattedAddress.length - 1) === '-' || formattedAddress.charAt(formattedAddress.length - 1) === ',') {
          formattedAddress = formattedAddress.slice(0, formattedAddress.length - 1);
        }
        return formattedAddress;
      }
      return '';
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('contaAzulServiceApi', contaAzulServiceApi);

  function contaAzulServiceApi($http, EnvironmentConfig) {
    var api = EnvironmentConfig.shelob + 'conta-azul/';

    return {
      list: list,
    };

    function list(options) {
      var queryParams = [];
      if (options.search) {
        queryParams.push('busca_textual=' + encodeURIComponent(options.search));
      }
      if (options.size) {
        queryParams.push('tamanho_pagina=' + encodeURIComponent(options.size));
      }
      if (options.page) {
        queryParams.push('pagina=' + encodeURIComponent(options.page));
      }

      var url = api + 'servicos?' + queryParams.join('&');

      return $http.get(url).then(function handleFirst(res) {
        var payload = (res && res.data) || [];
        var envelope = Array.isArray(payload) ? (payload[0] || {}) : payload;
        var itensArray = Array.isArray(envelope.itens) ? envelope.itens: [];
        var totalPages = (envelope.paginacao && envelope.paginacao.total_paginas) ? envelope.paginacao.total_paginas : 1;
        var currentPage = 1;
        var allItems = [];

        allItems = allItems.concat(extractItems(itensArray));

        function loadNextPage() {
          currentPage++;

          if ((currentPage > totalPages) || options.page) {
            return allItems;
          }

          var nextUrl = url + "&pagina=" + currentPage;

          return $http.get(nextUrl).then(function (nextRes) {
            var nextPayload = (nextRes && nextRes.data) || [];
            var nextEnvelope = Array.isArray(nextPayload) ? (nextPayload[0] || {}) : nextPayload;
            var nextItensArray = Array.isArray(nextEnvelope.itens) ? nextEnvelope.itens : [];

            allItems = allItems.concat(extractItems(nextItensArray));
            return loadNextPage();
          });
        }

        return loadNextPage();
      });
    }

    function extractItems(itensArray) {
      return itensArray.map(function (service) {
        return {
          cost: service.custo,
          name: service.descricao,
          id: service.id,
          value: service.preco,
          type: service.tipo_servico,
          code: service.codigo
        };
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('contaAzulSaleApi', contaAzulSaleApi);

  function contaAzulSaleApi($http, EnvironmentConfig, moment) {
    var api = EnvironmentConfig.shelob + 'conta-azul/';

    return {
      create: create,
    };

    function create(form) {
      var itens = [];

      form.items.forEach(function (item) {
        itens.push({
          descricao: item.description,
          quantidade: item.qtd,
          id: item.obj.id,
          valor: parseFloat(item.value),
        });
      });

      var saleNumber = uniqueSaleNumber();

      var contaAzulSale = {
        data_venda: toDateOnly(form.date),
        situacao: form.status ? form.status : 'APROVADO',
        numero: saleNumber,
        id_cliente: form.customer.id,
        itens: itens,
        composicao_de_valor: {
          desconto: {
            tipo: form.discount.type === '0' ? 'VALOR' : 'PORCENTAGEM',
            valor: parseFloat(form.discount.value),
          },
        },
        condicao_pagamento: {
          tipo_pagamento: 'DINHEIRO',
          opcao_condicao_pagamento: 'À vista',
          parcelas: [
            {
              valor: parseFloat(form.total),
              data_vencimento: toDateOnly(form.date),
            },
          ],
        },
        observacoes: form.notes,
      };
      return $http.post(api + 'venda', contaAzulSale);
    }

    function toDateOnly(date) {
      if (!date) return undefined;
      var iso = new Date(date).toISOString();
      return iso.slice(0, 10);
    }

    function uniqueSaleNumber() {
      return Date.now();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('contaAzulProductApi', contaAzulProductApi);

  function contaAzulProductApi($http, EnvironmentConfig) {
    var api = EnvironmentConfig.shelob + 'conta-azul/';

    return {
      list: list,
    };

    function list(options) {
      options = options || {};

      var queryParams = [];
      var pageSize = options.size || 1000;

      if (options.search) {
        queryParams.push('busca=' + encodeURIComponent(options.search));
      }

      queryParams.push('tamanho_pagina=' + pageSize);

      var url = api + 'produtos?' + queryParams.join('&');
      var initialPage = options.page || 1;

      return $http.get(url + '&pagina=' + initialPage).then(function handleFirst(res) {
        var data = (res && res.data) || {};
        var itensArray = Array.isArray(data.items) ? data.items : [];
        var totalPages = Math.ceil(data.totalItems/pageSize);

        var currentPage = initialPage;
        var allItems = [];

        allItems = allItems.concat(extractItems(itensArray));

        function loadNextPage() {
          currentPage++;

          if (currentPage > totalPages || options.page) {
            return allItems;
          }

          var nextUrl = url + '&pagina=' + currentPage;

          return $http.get(nextUrl).then(function (nextRes) {
            var nextData = (nextRes && nextRes.data) || {};
            var nextItensArray = Array.isArray(nextData.itens)
              ? nextData.itens
              : [];

            allItems = allItems.concat(extractItems(nextItensArray));
            return loadNextPage();
          });
        }
        return loadNextPage();
      });
    }
    function extractItems(itensArray) {
      return itensArray.map(function (product) {
        return {
          id: product.id || product.id_legado,
          name: product.nome,
          value: product.valor_venda
        };
      });
    }
  }
})();
(function () {
  'use strict';

  angular.module('app.core').factory('contaAzulCustomerApi', contaAzulCustomerApi);

  function contaAzulCustomerApi($http, EnvironmentConfig, contaAzulCustomerMapper) {
    var api = EnvironmentConfig.shelob + 'conta-azul/';

    return {
      create: create,
      update: update,
      list: list,
      contacts: contacts,
    };

    function contacts(contaAzulCustomerId) {
      return $http
        .get(api + 'pessoas/' + contaAzulCustomerId)
        .catch(function (err) {
          if (err && (err.status === 404 || err.status === 400)) {
            return $http.get(api + 'pessoas/legado/' + contaAzulCustomerId);
          }
          throw err;
        })
        .then(function (res) {
          var data = (res && res.data) || {};

          return {
            id: data.id,
            name: data.nome,
            address: data.enderecos,
            documentNumber: data.documento
          };
      });
    }


    function create(fieldControlCustomer, fieldControlLocation) {
      var contaAzulCustomer = contaAzulCustomerMapper.toContaAzul(fieldControlCustomer, fieldControlLocation);
      var url = api + 'pessoas';
      return $http.post(url, contaAzulCustomer);
    }

    function update(contaAzulCustomerId, fieldControlCustomer, fieldControlLocation) {
      var fieldCustomer = contaAzulCustomerMapper.toContaAzul(fieldControlCustomer, fieldControlLocation);

      var url = api + 'pessoas/';

      var payload = {
        cnpj: fieldCustomer.cnpj || undefined,
        cpf: fieldCustomer.cpf || undefined,
        email: fieldCustomer.email || '',
        nome: fieldCustomer.nome,
        telefone_celular: fieldCustomer.telefone_celular,
        telefone_comercial: fieldCustomer.telefone_comercial,
        enderecos: fieldCustomer.enderecos
      };

      return $http.patch(url + contaAzulCustomerId, payload)
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function list(options) {
      var queryParams = [];
      if (options.search) {
        queryParams.push('busca=' + encodeURIComponent(options.search));
      }
      if (options.document) {
        queryParams.push('documentos=' + encodeURIComponent(options.document));
      }
      if (options.size) {
        queryParams.push('tamanho_pagina=' + encodeURIComponent(options.size));
      }

      queryParams.push('com_endereco=true');

      var url = api + 'pessoas?' + queryParams.join('&');

      return $http.get(url).then(function (res) {
        var data = (res && res.data) || {};
        var itensArray = Array.isArray(data.items) ? data.items : [];

        return itensArray.map(function (customer) {
          var endereco = customer.endereco || {};

          return {
            id: customer.id || customer.id_legado,
            name: customer.nome,
            email: customer.email,
            document: customer.documento,
            address: {
              street: endereco.logradouro || '',
              number: endereco.numero || '',
              neighborhood: endereco.bairro || '',
              zipCode: endereco.cep || '',
              city: endereco.cidade || '',
              state: endereco.estado || '',
              complement: endereco.complemento || ''
            },
            business_phone: customer.telefone,
            mobile_phone: customer.telefone
          };
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('knowledgeBasesApi', knowledgeBasesApi);

  function knowledgeBasesApi($http, EnvironmentConfig, GraphQLApi, KnowledgeBasesQuery) {
    var gandalf2Url = EnvironmentConfig.gandalf2;
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig, null, gandalf2Url);

    return {
      search: search
    };

    function search(queryParams) {
      return graphQLApi.query(KnowledgeBasesQuery, queryParams, 'knowledgeBases');
    }
  }
})();


(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('usersApi', usersApi);

    function usersApi(
        $http, EnvironmentConfig, Api, GraphQLApi,
        UsersGetOneQuery, UsersSearchQuery, UsersGetOneTerritoriesQuery,
        UsersGetOneWithGroupsQuery
    ) {

        var api = new Api($http, EnvironmentConfig.baseUrl, 'users');
        var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

        return {
            get: getOne,
            getWithGroups: getOneWithGroups,
            getTerritories: getTerritories,
            search: search,
            getPermissions: getPermissions,
            save: api.save,
            delete: api.delete,
            patch: patch,
            changePassword: changePassword,
            saveUserGroups: saveUserGroups
        };

        function getOne(id) {
            return graphQLApi.query(UsersGetOneQuery, { id: String(id) }, 'user');
        }

        function getOneWithGroups(id) {
            return graphQLApi.query(UsersGetOneWithGroupsQuery, { id: String(id ) }, 'user');
        }

        function getTerritories(id) {
            return graphQLApi.query(UsersGetOneTerritoriesQuery, { id: String(id) }, 'user').then(function (user) {
                return user.territories;
            });
        }

        function search(queryParams) {
            return graphQLApi.query(UsersSearchQuery, queryParams, 'users');
        }

        function patch(id, payload) {
            var requestUrl = api.getUrl() + id;
            return $http.patch(requestUrl, payload).then(api.whenCompleted);
        }

        function changePassword(id, currentPassword, newPassword) {
            var requestUrl = api.getUrl() + id + '/actions/change-password';
            var payload = {
                currentPassword: currentPassword,
                newPassword: newPassword
            };
            return $http.put(requestUrl, payload).then(api.whenCompleted);
        }

        function getPermissions(id) {
            var requestUrl = api.getUrl() + id + '/permissions';
            return $http.get(requestUrl).then(api.whenCompleted);
        }

        function saveUserGroups(id, groups) {
            var requestUrl = api.getUrl() + id + '/groups';
            var payload = groups;
            return $http.put(requestUrl, payload).then(api.whenCompleted);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('territoriesApi', territoriesApi);
  function territoriesApi(
    $http, EnvironmentConfig, GraphQLApi, TerritoriesByCoordinatesQuery, TerritoriesSearchQuery
  ) {
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      search: search,
      territoriesByCoordinates: territoriesByCoordinates
    };
    function search(queryParams) {
      return graphQLApi.query(TerritoriesSearchQuery, queryParams, 'territories');
    }


    function territoriesByCoordinates(queryParams) {
      return graphQLApi.query(TerritoriesByCoordinatesQuery, queryParams, 'territoriesByCoordinates');
    }
  }
})();


(function () {
  'use strict';

  angular
  .module('app.core.api')
  .factory('templatesApi', templatesApi);

  function templatesApi($http, EnvironmentConfig, GraphQLApi, TemplatesSearchQuery) {
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      search: search
    };

    function search(queryParams) {
      return graphQLApi.query(TemplatesSearchQuery, queryParams, 'templates');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('tasksApi', tasksApi);

  function tasksApi(
    $http, EnvironmentConfig, Api, GraphQLApi, querifyPost,
    TasksGetOneQuery, TasksSearchQuery, TasksSearchForDataTableQuery,
    TasksSearchForControlPanelQuery, TasksSearchForCalendarQuery,
    TasksSearchEstimatedQuery, TasksSearchForCalendarV2Query, TasksUpdateMutation
  ) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'tasks');
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      get: getOne,
      search: search,
      queryForDatatable: queryForDatatable,
      queryForControlPanel: queryForControlPanel,
      searchTasksForCalendar: searchTasksForCalendar,
      searchTasksForCalendarV2: searchTasksForCalendarV2,
      getEstimatedTasks: getEstimatedTasks,
      getAttachments: getAttachments,
      getLogs: getLogs,
      getFilters: getFilters,
      save: api.save,
      updateAttachment: updateAttachment,
      sendPrintLink: sendPrintLink,
      sendTrackingLink: sendTrackingLink,
      sendRatingLink: sendRatingLink,
      patchTasks: patchTasks,
      postAttachment: postAttachment,
      updateTask: updateTask,
      updateTasks: updateTasks,
      removeAttachment: removeAttachment,
      archiveAttachment: archiveAttachment,
      unarchiveAttachment: unarchiveAttachment,
      saveFilter: saveFilter,
      updateToArchived: updateToArchived,
      enqueueDataExport: enqueueDataExport,
      setNewScheduleSuggestion: setNewScheduleSuggestion,
      linkSecondaryEmployees: saveSecondaryEmployees,
      getSecondaryEmployees: getSecondaryEmployees
    };

    function getOne(id) {
      return graphQLApi.query(TasksGetOneQuery, { id: id }, 'task');
    }

    function search(queryParams) {
      return graphQLApi.query(TasksSearchQuery, queryParams, 'tasks');
    }

    function queryForDatatable(queryParams) {
      return graphQLApi.query(TasksSearchForDataTableQuery, queryParams, 'tasks');
    }

    function queryForControlPanel(queryParams) {
      return graphQLApi.query(TasksSearchForControlPanelQuery, queryParams, 'tasks');
    }

    function searchTasksForCalendar(queryParams) {
      return graphQLApi.query(TasksSearchForCalendarQuery, queryParams, 'tasks');
    }

    function searchTasksForCalendarV2(queryParams) {
      return graphQLApi.query(TasksSearchForCalendarV2Query, queryParams, 'tasksToCalendar');
    }

    function getEstimatedTasks(queryParams) {
      return graphQLApi.query(TasksSearchEstimatedQuery, queryParams, 'tasksEstimation');
    }

    function enqueueDataExport(queryString, userSettings) {
      var requestUrl = api.getUrl() + 'actions/export';
      return $http.post(requestUrl, {
        q: querifyPost(queryString),
        userSettings: userSettings
      }).then(api.whenCompleted);
    }

    function updateTask(queryParams) {
      return graphQLApi.mutation(TasksUpdateMutation, { input: queryParams }, 'updateTask');
    }

    function updateTasks(tasks) {
      return $http.put(api.getUrl(), tasks).then(api.whenCompleted);
    }

    function getLogs(id) {
      var requestUrl = api.getUrl() + id + '/logs/?include=rating';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function patchTasks(tasks) {
      return $http.patch(api.getUrl(), tasks).then(api.whenCompleted);
    }

    function getAttachments(id) {
      var requestUrl = api.getUrl() + id + '/attachments';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function postAttachment(taskId, attachment) {
      var requestUrl = api.getUrl() + taskId + '/attachments';
      return $http.post(requestUrl, attachment).then(api.whenCompleted);
    }

    function updateAttachment(id, attId, payload) {
      var requestUrl = api.getUrl() + id + '/attachments/' + attId;
      return $http.patch(requestUrl, payload).then(api.whenCompleted);
    }

    function sendPrintLink(id, payload) {
      var requestUrl = api.getUrl() + id + '/actions/send-print-link';
      return $http.post(requestUrl, payload).then(api.whenCompleted);
    }

    function sendRatingLink(id, payload) {
      var requestUrl = api.getUrl() + id + '/actions/send-rating-link';
      return $http.post(requestUrl, payload).then(api.whenCompleted);
    }

    function sendTrackingLink(id, payload) {
      var requestUrl = api.getUrl() + id + '/actions/send-tracking-link';
      return $http.post(requestUrl, payload).then(api.whenCompleted);
    }

    function removeAttachment(id, attId) {
      var requestUrl = api.getUrl() + id + '/attachments/' + attId;
      return $http.delete(requestUrl).then(api.whenCompleted);
    }

    function archiveAttachment(id, attId) {
      var requestUrl = api.getUrl() + id + '/attachments/' + attId;
      return $http.patch(requestUrl, { archived: true }).then(api.whenCompleted);
    }

    function unarchiveAttachment(id, attId) {
      var requestUrl = api.getUrl() + id + '/attachments/' + attId;
      return $http.patch(requestUrl, { archived: false }).then(api.whenCompleted);
    }

    function getFilters() {
      var requestUrl = api.getUrl() + 'filters';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function updateToArchived(filterId) {
      var requestUrl = api.getUrl() + 'filters/' + filterId;
      return $http.delete(requestUrl).then(api.whenCompleted);
    }

    function saveFilter(payload) {
      if (payload.id) {
        var requestUrl = api.getUrl() + 'filters/' + payload.id;
        return $http.put(requestUrl, payload).then(api.whenCompleted);
      } else {
        var requestUrl = api.getUrl() + 'filters';
        return $http.post(requestUrl, payload).then(api.whenCompleted);
      }
    }

    function setNewScheduleSuggestion(form, tickedId) {
      var mutation = 'mutation TicketMutation($id: ID!, $input: TicketSuggestSchedulingInput!) { \
          suggestTicketScheduling (id: $id, input: $input) { \
            id \
            name \
            status \
            subject \
            metadata \
          } \
        } \
      ';

      var input = {
        date: moment(form.date).format('YYYY-MM-DD'),
        time: form.time ? moment(form.time).format('HH:mm:ss') : null
      };

      return $http.post(EnvironmentConfig.eyeOfSauron2Url, {
        query: mutation,
        variables: {
          id: tickedId,
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['suggestTicketScheduling'];
        });
    }

    function saveSecondaryEmployees(input) {
      var mutation = 'mutation SaveSecondaryEmployeesMutation($input: SaveSecondaryEmployeesInput!) { \
          saveSecondaryEmployees (input: $input) { \
            id \
          } \
        } \
      ';
      return $http.post(EnvironmentConfig.eyeOfSauron2Url, {
        query: mutation,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } });
    }

    function getSecondaryEmployees(taskId) {
      var query = '\
        query TaskQuery( \
          $id: ID! \
        ){ \
          task(id: $id) { \
            secondaryEmployees {\
              id \
              name \
              avatarUrl \
            }\
          } \
        }';

      return $http.post(EnvironmentConfig.eyeOfSauron2Url, {
        query: query,
        variables: {
          id: taskId
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['task']['secondaryEmployees'];
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('recurrencesApi', recurrencesApi);

  function recurrencesApi(
    $http, EnvironmentConfig, Api, GraphQLApi, msUtils,
    RecurrencesGetOneQuery, RecurrencesSearchQuery, RecurrencesCreateMutation, RecurrencesUpdateMutation
  ) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'recurrences');
    var baseURL = new Api($http, EnvironmentConfig.eyeOfSauron2Url);
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      getOne: getOne,
      search: search,
      getOccurrence: getOccurrence,
      searchOccurrences: searchOccurrences,
      getEquipments: getEquipments,
      insertOccurrence: insertOccurrence,
      insertOccurrenceTask: insertOccurrenceTask,
      processOccurrences: processOccurrences,
      processOccurrencesTasks: processOccurrencesTasks,
      save: api.save,
      create: create,
      update: update,
      updateOccurrence: updateOccurrence,
    };

    function getOne(id) {
      return graphQLApi.query(RecurrencesGetOneQuery, { id: id }, 'recurrence');
    }

    function search(queryParams) {
      return graphQLApi.query(RecurrencesSearchQuery, queryParams, 'recurrences');
    }

    function create(recurrence) {
      return graphQLApi.mutation(RecurrencesCreateMutation, { input: recurrence }, 'createRecurrence');
    }

    function update(recurrence) {
      return graphQLApi.mutation(RecurrencesUpdateMutation, { input: recurrence }, 'updateRecurrence');
    }

    function processOccurrencesTasks(recurrence) {
      var requestUrl = api.getUrl() + recurrence.id + '/actions/process-recurrences-occurrences-tasks';
      return $http.post(requestUrl).then(api.whenCompleted);
    }

    function processOccurrences(recurrence) {
      var requestUrl = api.getUrl() + recurrence.id + '/actions/process-recurrences-occurrences';
      return $http.post(requestUrl).then(api.whenCompleted);
    }

    function insertOccurrence(recurrence, occurrence) {
      var requestUrl = api.getUrl() + recurrence.id + '/occurrences';
      return $http.post(requestUrl, occurrence).then(api.whenCompleted);
    }

    function updateOccurrence(recurrence, occurrence) {
      var requestUrl = api.getUrl() + recurrence.id + '/occurrences/' + occurrence.id;
      return $http.put(requestUrl, occurrence).then(api.whenCompleted);
    }

    function insertOccurrenceTask(recurrence, occurrence) {
      var requestUrl = api.getUrl() + recurrence.id + '/occurrences/' + occurrence.id + '/task';
      return $http.post(requestUrl, occurrence).then(api.whenCompleted);
    }
    function getOccurrence(recurrence, occurrence) {
      var requestUrl = api.getUrl() + recurrence.id + '/occurrences/' + occurrence.id;
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function searchOccurrences(recurrence, options) {
      var requestUrl = api.getUrl() + recurrence.id + '/occurrences';
      if (options) {
        requestUrl += '?' + msUtils.qStringify(options);
      }
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function getEquipments(where, orderBy, take, skip) {
      var query = '\
      query EquipmentsQuery( \
        $where: EquipmentsWhereInput \
        $orderBy: EquipmentsOrderByEnum \
        $take: Int \
        $skip: Int \
      ) { \
        equipments( \
          where: $where, \
          orderBy: $orderBy, \
          take: $take, \
          skip: $skip \
        ) { \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
          items { \
            id \
            name \
            number \
            locked \
            notes \
            imageUrl \
            qrCode \
            archived \
            location { \
              id \
            } \
            customer { \
              id \
            } \
            type { \
              id \
            } \
            attachments { \
              path \
            } \
            locationSector { \
              id \
              name \
            } \
            locationEnvironment { \
              id \
              name \
            } \
          } \
        } \
      }';

      return $http.post(baseURL.getUrl(), {
        query: query,
        variables: {
          where: where,
          orderBy: orderBy,
          take: take,
          skip: skip
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['equipments'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('quotationsApi', quotationsApi);

  function quotationsApi(
    $http, EnvironmentConfig, Api, GraphQLApi, CreateQuotationMutation, UpdateQuotationMutation, updateQuotationExpenseMutation, RemoveQuotationExpenseMutation, CreateQuotationExpenseMutation,
    QuotationsGetOneQuery, QuotationsSearchQuery, ArchiveQuotationMutation, UnarchiveQuotationMutation
  ) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'quotations');
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      getOne: getOne,
      search: search,
      sendLink: sendLink,
      save: api.save,
      create: create,
      update: update,
      archive: archive,
      unarchive: unarchive,
      setLabels: setLabels,
      generateIdentifier: generateIdentifier,
      getLastIdentifier: getLastIdentifier,
      setNewIdentifier: setNewIdentifier,
      updateQuotationExpense: updateQuotationExpense,
      createQuotationExpense: createQuotationExpense,
      removeQuotationExpense: removeQuotationExpense
    };

    function create(quotation) {
      return graphQLApi.mutation(CreateQuotationMutation, { input: quotation }, 'createQuotation');
    }

    function update(quotation) {
      return graphQLApi.mutation(UpdateQuotationMutation, { input: quotation }, 'updateQuotation');
    }

    function updateQuotationExpense(quotationExpense) {
      return graphQLApi.mutation(updateQuotationExpenseMutation, { input: quotationExpense }, 'updateQuotationExpense');
    }

    function createQuotationExpense(quotationExpense) {
      return graphQLApi.mutation(CreateQuotationExpenseMutation, { input: quotationExpense }, 'createQuotationExpense');
    }

    function removeQuotationExpense(id) {
      return graphQLApi.mutation(RemoveQuotationExpenseMutation, { id: id }, 'removeQuotationExpense');
    }

    function archive(id) {
      return graphQLApi.query(ArchiveQuotationMutation, { id: id }, 'archiveQuotation');
    }

    function unarchive(id) {
      return graphQLApi.query(UnarchiveQuotationMutation, { id: id }, 'unarchiveQuotation');
    }

    function getOne(id) {
      return graphQLApi.query(QuotationsGetOneQuery, { id: id }, 'quotation');
    }

    function search(queryParams) {
      return graphQLApi.query(QuotationsSearchQuery, queryParams, 'quotations');
    }

    function sendLink(id, emails) {
      var url = EnvironmentConfig.grondBaseUrl;
      var query = '\
      query QuotationLinkQuery($id: ID!, $emails: [String!]!) { \
        sendQuotationLink(id: $id, emails: $emails) { \
          emailSent \
        } \
      }';

      return $http.post(url, {
        query: query,
        variables: {
          id: id,
          emails: emails
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['sendQuotationLink'];
      });
    }

    function setLabels(id, labels) {
      var requestUrl = api.getUrl() + id + '/labels';
      return $http.put(requestUrl, { labels: labels }).then(api.whenCompleted);
    }

    function generateIdentifier() {
      var url = EnvironmentConfig.eyeOfSauron2Url;
      var query = '\
        mutation GenerateQuotationIdentifier { \
          generateQuotationIdentifier { \
            identifier \
          } \
        }';

      return $http.post(url, {
        query: query
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['generateQuotationIdentifier'];
      });
    }

    function getLastIdentifier() {
      var url = EnvironmentConfig.eyeOfSauron2Url;
      var query = 'query QuotationIdentifierQuery { \
        quotationIdentifier { \
          identifier \
        } \
      }';

      return $http.post(url, {
        query: query
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['quotationIdentifier'];
      });
    }

    function setNewIdentifier(identifier) {
      var url = EnvironmentConfig.eyeOfSauron2Url;
      var query = '\
      mutation configureInitialIdentifier($input: ConfigureInitialIdentifierInput) { \
        configureInitialIdentifier(input: $input) { \
          identifier \
        } \
      }';

      return $http.post(url, {
        query: query,
        variables: {
          input: {
            identifier: identifier
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['configureInitialIdentifier'];
      });
    }
  }
})();


(function (){
  'use strict';

  angular
  .module('app.core.api')
  .factory('productsServicesApiGraphQL', productsServicesApiGraphQL);

  function productsServicesApiGraphQL(
    $http, EnvironmentConfig, GraphQLApi , ProductsSearchQuery
  ){
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      searchProducts: searchProducts,
      searchProdutsServices: searchProdutsServices
    };

    function searchProducts(queryParams, queryOptions){
      queryParams['type'] = 'product';
      var variables = {
        where: queryParams,
        skip: queryOptions.skip,
        take: queryOptions.take,
        orderBy: queryOptions.orderBy
      };
      return graphQLApi.query(ProductsSearchQuery, variables , 'products');
    };

    function searchProdutsServices(queryParams, queryOptions){
      queryParams['type'] = 'productOrService';
      var variables = {
        where: queryParams,
        skip: queryOptions.skip,
        take: queryOptions.take,
        orderBy: queryOptions.orderBy
      };
      return graphQLApi.query(ProductsSearchQuery, variables , 'products');
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('plansApi', plansApi);

  function plansApi(
    $http, EnvironmentConfig, Api, GraphQLApi,
    PlansGetOneQuery, PlansSearchQuery
  ) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'plans');
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      getOne: getOne,
      search: search,
      save: api.save,
    };

    function getOne(id) {
      return graphQLApi.query(PlansGetOneQuery, { id: id }, 'plan');
    }

    function search(queryParams) {
      return graphQLApi.query(PlansSearchQuery, queryParams, 'plans');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('planTypesApiGraphQL', planTypesApiGraphQL);

  function planTypesApiGraphQL($http, EnvironmentConfig, GraphQLApi, PlanTypesSearchQuery) {
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      queryForDatatable: queryForDatatable
    };

    function queryForDatatable(queryParams) {
      return graphQLApi.query(PlanTypesSearchQuery, queryParams, 'planTypes');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('ordersApi', ordersApi);

  function ordersApi(
    $http, EnvironmentConfig, Api, GraphQLApi,
    OrdersGetOneQuery, OrdersSearchQuery, OrdersSearchForPlansQuery
  ) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'orders');
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      get: getOne,
      search: search,
      searchForPlans: searchForPlans,
      searchComments: searchComments,
      getAttachments: getAttachments,
      getEquipmentForms: getEquipmentForms,
      getEquipments: getEquipments,
      getForms: getForms,
      getMaterials: getMaterials,
      getSignatures: getSignatures,
      getDeadline: getDeadline,
      queryForAllOrderProducts: queryForAllOrderProducts,
      queryForOrderProducts: queryForOrderProducts,
      queryForOrderServices: queryForOrderServices,
      deleteComment: deleteComment,
      deleteEquipment: deleteEquipment,
      deleteForm: deleteForm,
      deleteMaterial: deleteMaterial,
      deleteSignature: deleteSignature,
      nextIdentifier: nextIdentifier,
      reorderAttachments: reorderAttachments,
      save: api.save,
      saveWithTasks: saveWithTasks,
      saveComment: saveComment,
      saveEquipment: saveEquipment,
      saveForm: saveForm,
      saveMaterial: saveMaterial,
      sendPrintLink: sendPrintLink,
      setLabels: setLabels,
      updateForm: updateForm,
      getCurrentIdentifier: getCurrentIdentifier,
      setNextIdentifier: setNextIdentifier,
      updateSignature: updateSignature,
      saveQuotation: saveQuotation,
      deleteQuotation: deleteQuotation,
      saveDeadline: saveDeadline,
      saveDeadlineViolationReason: saveDeadlineViolationReason,
      saveOrderProducts: saveOrderProducts,
      saveOrderServices: saveOrderServices,
      deleteOrderProduct: deleteOrderProduct,
      deleteOrderService: deleteOrderService,
      updateOrderProductQuantity: updateOrderProductQuantity,
      updateOrderServiceQuantity: updateOrderServiceQuantity,
      patch: patch
    };

    function saveWithTasks(order) {
      var withTasksUrl = api.getUrl().slice(0, -1) + '-with-tasks/';

      if (order.id) {
        return $http.put(api.getUrl() + order.id, order)
          .then(api.whenCompleted);
      } else {
        return $http.post(withTasksUrl, order)
          .then(api.whenCompleted);
      }
    }

    function getOne(id) {
      return graphQLApi.query(OrdersGetOneQuery, { id: id }, 'order');
    }

    function search(queryParams) {
      return graphQLApi.query(OrdersSearchQuery, queryParams, 'orders');
    }

    function searchForPlans(queryParams) {
      return graphQLApi.query(OrdersSearchForPlansQuery, queryParams, 'orders');
    }

    function getCurrentIdentifier() {
      var requestUrl = api.getUrl() + 'actions/get-current-identifier';
      return $http.get(requestUrl).then(function (response) {
        return response.data.identifier;
      });
    }

    function setNextIdentifier(next) {
      var requestUrl = api.getUrl() + 'actions/set-next-identifier';
      return $http.put(requestUrl, { next: next }).then(api.whenCompleted);
    }

    function deleteSignature(id, signatureId) {
      var requestUrl = api.getUrl() + id + '/signatures/' + signatureId;
      return $http.delete(requestUrl).then(api.whenCompleted);
    }

    function getAttachments(id) {
      var requestUrl = api.getUrl() + id + '/attachments';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function getSignatures(id) {
      var requestUrl = api.getUrl() + id + '/signatures';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function updateSignature(id, signature) {
      var requestUrl = api.getUrl() + id + '/signatures/' + signature.id;
      return $http.put(requestUrl, signature).then(api.whenCompleted);
    }

    function sendPrintLink(id, payload) {
      var requestUrl = api.getUrl() + id + '/actions/send-print-link';
      return $http.post(requestUrl, payload).then(api.whenCompleted);
    }

    function setLabels(id, labels) {
      var requestUrl = api.getUrl() + id + '/labels';
      return $http.put(requestUrl, { labels: labels }).then(api.whenCompleted);
    }

    function getForms(id) {
      var requestUrl = api.getUrl() + id + '/forms';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function saveForm(id, form) {
      var requestUrl = api.getUrl() + id + '/forms';
      return $http.post(requestUrl, form).then(api.whenCompleted);
    }

    function updateForm(id, form) {
      var requestUrl = api.getUrl() + id + '/forms/' + form.id;
      return $http.put(requestUrl, form).then(api.whenCompleted);
    }

    function deleteForm(id, form) {
      var requestUrl = api.getUrl() + id + '/forms/' + form.id;
      return $http.delete(requestUrl, form).then(api.whenCompleted);
    }

    function nextIdentifier(payload) {
      var requestUrl = api.getUrl();
      requestUrl += 'actions/generate-next-identifier';
      return $http.post(requestUrl, payload).then(api.whenCompleted);
    }

    function searchComments(input) {
      var query = '\
        query CommentsQuery( \
          $orderId: ID! \
          $orderBy: CommentsOrderByEnum \
          $take: Int \
          $skip: Int \
        ) { \
          comments( \
            orderId: $orderId \
            orderBy: $orderBy \
            take: $take \
            skip: $skip \
          ) { \
            pageInfo { \
              hasNextPage \
              hasPreviousPage \
            } \
            totalCount \
            items { \
              id \
              message \
              archived \
              order { \
                id \
              } \
              type \
              postedBy { \
                id \
                name \
                type \
                avatarUrl \
              } \
              employee { \
                id \
                avatarUrl \
                name \
              } \
              user { \
                id \
                avatarUrl \
                name \
              } \
              metadata \
            } \
          } \
        } \
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: {
          orderId: input.orderId,
          orderBy: input.orderBy,
          take: input.take,
          skip: input.skip
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['comments'];
      });
    }

    function saveComment(comment) {
      var requestUrl = api.getUrl() + comment.order.id + '/comments';
      return $http.post(requestUrl, comment).then(api.whenCompleted);
    }

    function deleteComment(comment) {
      var requestUrl = api.getUrl() + comment.order.id + '/comments/' + comment.id;
      return $http.delete(requestUrl, comment).then(api.whenCompleted);
    }

    function reorderAttachments(orderId, attachments) {
      var requestUrl = api.getUrl() + orderId + '/attachments/actions/reorder';
      return $http.patch(requestUrl, attachments).then(api.whenCompleted);
    }

    function patch(order) {
      var requestUrl = api.getUrl() + '/' + order.id;
      return $http.patch(requestUrl, order).then(api.whenCompleted);
    }

    function getEquipments(orderId) {
      var requestUrl = api.getUrl() + orderId + '/equipments';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function deleteEquipment(orderId, equipmentId) {
      var requestUrl = api.getUrl() + orderId + '/equipments/' + equipmentId;
      return $http.delete(requestUrl, {}).then(api.whenCompleted);
    }

    function saveEquipment(orderId, equipment) {
      var requestUrl = api.getUrl() + orderId + '/equipments';
      return $http.post(requestUrl, {
        equipment: {
          id: equipment.id
        }
      }).then(api.whenCompleted);
    }

    function getEquipmentForms(orderId, equipmentId) {
      var requestUrl = api.getUrl() + orderId + '/equipments/' + equipmentId + '/forms';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function getMaterials(orderId) {
      var requestUrl = api.getUrl() + orderId + '/materials';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function saveMaterial(orderId, item) {
      var requestUrl = api.getUrl() + orderId + '/materials';
      if (item.material.isLinked) {
        requestUrl += "/" + item.material.id;
        return $http.put(requestUrl, item).then(api.whenCompleted);
      } else {
        return $http.post(requestUrl, item).then(api.whenCompleted);
      }
    }

    function deleteMaterial(orderId, materialId) {
      var requestUrl = api.getUrl() + orderId + '/materials/' + materialId;
      return $http.delete(requestUrl, {}).then(api.whenCompleted);
    }

    function saveQuotation(orderId, quotationId) {
      var requestUrl = api.getUrl() + orderId + '/quotation/' + quotationId;
      return $http.post(requestUrl).then(api.whenCompleted);
    }

    function deleteQuotation(orderId, quotationId) {
      var requestUrl = api.getUrl() + orderId + '/quotation/' + quotationId;
      return $http.delete(requestUrl).then(api.whenCompleted);
    }

    function saveDeadline(orderId, deadlineContractId) {
      var requestUrl = api.getUrl() + orderId + '/deadline';
      return $http.put(requestUrl, { contract: { id: deadlineContractId } }).then(api.whenCompleted);
    }

    function getDeadline(orderId) {
      var query = '\
      query OrdersQuery( \
        $id: ID! \
      ) { \
        order(id: $id) { \
          id \
          deadline { \
            id \
            status \
            responseAt \
            responseRiskAt \
            responseStatus \
            solutionAt \
            solutionRiskAt \
            solutionStatus \
            firstTaskStartedAt \
            lastTaskCompletedAt \
          } \
        } \
      } \
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: {
          id: orderId,
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['order'];
      });
    }

    function saveDeadlineViolationReason(orderId, type, violationReasonId, deadlineId) {
      var requestUrl = api.getUrl() + orderId + '/deadline/violation-reason/' + type;
      return $http.put(
        requestUrl,
        {
          violationReason: {
            id: violationReasonId
          },
          deadline: {
            id: deadlineId
          }
        }
      ).then(api.whenCompleted);
    }

    function queryForAllOrderProducts(orderId) {
      var query = '\
        query OrdersQuery($id: ID!) { \
          order(id: $id) { \
            products { \
              id \
              name \
              measure \
              value \
              imageUrl \
              quantity \
              externalAppId \
              integration \
              type \
            } \
          } \
        } \
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: {
          id: orderId,
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data.data.order.products;
      });
    }

    function queryForOrderProducts(input) {
      var query = '\
        query OrderQuery( \
          $id: ID! \
          $whereProductsServices: OrderProductServiceWhereInput \
          $orderBy: OrderProductServiceDirectionInput \
          $take: Int = 5 \
          $skip: Int = 0 \
        ) { \
          order(id: $id) { \
            id \
            totalValue \
            servicesTotalValue \
            productsTotalValue \
            productsV2( \
              where: $whereProductsServices \
              orderBy: $orderBy \
              take: $take \
              skip: $skip \
            ) { \
              totalCount \
              pageInfo { \
                hasPreviousPage \
                hasNextPage \
              } \
              items { \
                value \
                quantity \
                totalValue \
                item { \
                  id \
                  name \
                  type \
                  value \
                  imageUrl \
                  measure \
                  externalAppId \
                  integration \
                } \
              } \
            } \
          } \
        } \
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: input
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data.data.order;
      });
    }

    function saveOrderProducts(products, orderId) {
      var query = '\
        mutation SaveOrderProductMutation($input: SaveOrderProductInput !) { \
          saveOrderProducts (input: $input) { \
            id \
          } \
        }\
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: {
          input: {
            products: products,
            orderId: orderId
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        if (!response.data.data) { return null; }
        return response.data.data.saveOrderProducts;
      });
    }

    function updateOrderProductQuantity(items) {
      var query = '\
        mutation UpdateOrderProductQuantity($input: UpdateOrderProductInput !) { \
          updateOrderProductQuantity (input: $input) { \
            id \
          } \
        }\
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: {
          input: {
            items: items
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        if (!response.data.data) { return null; }
        return response.data.data.UpdateOrderProductQuantity;
      });
    }

    function deleteOrderProduct(productId, orderId) {
      var query = '\
        mutation DeleteOrderProductMutation($input: DeleteOrderProductInput!) { \
          deleteOrderProduct (input: $input){ \
            id \
          } \
        } \
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: {
          input: {
            productId: productId,
            orderId: orderId
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data.data.deleteOrderProduct;
      });
    }

    function queryForOrderServices(input) {
      var query = '\
        query OrderQuery( \
          $id: ID! \
          $whereProductsServices: OrderProductServiceWhereInput \
          $orderBy: OrderProductServiceDirectionInput \
          $take: Int = 5 \
          $skip: Int = 0 \
        ) { \
          order(id: $id) { \
            id \
            totalValue \
            servicesTotalValue \
            productsTotalValue \
            services( \
              where: $whereProductsServices \
              orderBy: $orderBy \
              take: $take \
              skip: $skip \
            ) { \
              totalCount \
              pageInfo { \
                hasPreviousPage \
                hasNextPage \
              } \
              items { \
                value \
                quantity \
                totalValue \
                item { \
                  id \
                  name \
                  type \
                  value \
                  imageUrl \
                  externalAppId \
                  integration \
                } \
              } \
            } \
          } \
        } \
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: input
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data.data.order;
      });
    }

    function saveOrderServices(services, orderId) {
      var query = '\
        mutation SaveOrderServiceMutation($input: SaveOrderServiceInput!) { \
          saveOrderServices (input: $input) { \
            id \
            value \
            totalValue \
            quantity \
            item { \
              id \
              name \
              value \
            } \
          } \
        }\
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: {
          input: {
            services: services,
            orderId: orderId
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        if (!response.data.data) { return null; }
        return response.data.data.saveOrderServices;
      });
    }

    function updateOrderServiceQuantity(items) {
      var query = '\
        mutation UpdateOrderServiceQuantity($input: UpdateOrderServiceInput!) { \
          updateOrderServiceQuantity (input: $input) { \
            id \
            value \
            quantity \
            totalValue \
            item { \
              id \
              name \
              value \
            } \
          } \
        }\
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: {
          input: {
            items: items
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        if (!response.data.data) { return null; }
        return response.data.data.updateOrderServiceQuantity;
      });
    }

    function deleteOrderService(serviceId, orderId) {
      var query = '\
        mutation DeleteOrderServiceMutation($input: DeleteOrderServiceInput!) { \
          deleteOrderService (input: $input) { \
            id \
          } \
        } \
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: {
          input: {
            serviceId: serviceId,
            orderId: orderId
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data.data.deleteOrderService;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('customerLocationsApi', customerLocationsApi);

  function customerLocationsApi(
    $http, EnvironmentConfig, GraphQLApi, _,
    LocationGetOneQuery, LocationSearchQuery
  ) {
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      getOne: getOne,
      search: search
    };

    function getOne(id) {
      return graphQLApi.query(LocationGetOneQuery, { id: id }, 'location');
    }

    function search(queryParams) {
      return graphQLApi.query(LocationSearchQuery, queryParams, 'locations');
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core.api').factory('groupsApi', groupsApi);

  function groupsApi($http, EnvironmentConfig, GraphQLApi, GroupsGetOneQuery, GroupsSearchQuery) {
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      get: getOne,
      search: search
    };

    function getOne(id) {
      return graphQLApi.query(GroupsGetOneQuery, { id: id }, 'group');
    }

    function search(queryParams) {
      return graphQLApi.query(GroupsSearchQuery, queryParams, 'groups');
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core.api').factory('ExpensesApi', ExpensesApi);

  function ExpensesApi($http, EnvironmentConfig, GraphQLApi, ExpensesGetOneQuery, ExpensesSearchQuery) {
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      get: getOne,
      search: search
    };

    function getOne(id) {
      return graphQLApi.query(ExpensesGetOneQuery, { id: id }, 'expense');
    }

    function search(queryParams) {
      return graphQLApi.query(ExpensesSearchQuery, queryParams, 'expenses');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('equipmentsApi', equipmentsApi);

  function equipmentsApi(
    $http, EnvironmentConfig, Api, GraphQLApi, querify, querifyPost, $q,
    EquipmentsGetOneQuery, EquipmentsSearchQuery
  ) {

    var api = new Api($http, EnvironmentConfig.baseUrl, 'equipments', null, querify, $q);
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig, $q);
    var defaultOptions = { headers: { 'cache-control': 'no-cache' } };

    return {
      get: getOne,
      search: search,
      getManyByNumber: getManyByNumber,
      getAttachmentsFromEquipment: getAttachmentsFromEquipment,
      getCustomFieldAnswers: getCustomFieldAnswers,
      getEquipmentLogs: getEquipmentLogs,
      put: api.put,
      save: save,
      archive: archive,
      updateEquipments: updateEquipments,
      saveEquipmentAttachment: saveEquipmentAttachment,
      deleteEquipmentAttachment: deleteEquipmentAttachment,
      saveCustomFieldResponses: saveCustomFieldResponses,
      exportEquipments: exportEquipments,
      setLabels: setLabels
    };

    function getOne(id) {
      return graphQLApi.query(EquipmentsGetOneQuery, { id: id }, 'equipment');
    }

    function search(queryParams) {
      return graphQLApi.query(EquipmentsSearchQuery, queryParams, 'equipments');
    }

    function getManyByNumber(numbers) {
      var queries = [];
      _.chunk(numbers, 20).forEach(function (numbersChunk) {
        queries.push({ numbers: numbersChunk });
      });
      return graphQLApi.getSequence(EquipmentsSearchQuery, { take: 1000 }, 'equipments', queries);
    }

    function save(variables) {
      return variables.input.id ? update(variables) : create(variables);
    }

    function create(variables) {
      var mutation = 'mutation CreateEquipmentMutation($input: CreateEquipmentInput!) { \
        createEquipment (input: $input) { \
          id \
        } \
      }';

      var options = angular.copy(defaultOptions);
      options.headers['x-client-application-name'] = 'mordor';

      return $http.post(EnvironmentConfig.eyeOfSauron2Url, {
        query: mutation,
        variables: variables
      }, options)
        .then(function (response) {
          return response.data.data.createEquipment;
        });
    }

    function update(variables) {
      var mutation = 'mutation UpdateEquipmentMutation($input: UpdateEquipmentInput!) { \
        updateEquipment (input: $input) { \
          id \
        } \
      }';

      var options = angular.copy(defaultOptions);
      options.headers['x-client-application-name'] = 'mordor';

      return $http.post(EnvironmentConfig.eyeOfSauron2Url, {
        query: mutation,
        variables: variables
      }, options)
        .then(function (response) {
          return response.data.data.updateEquipment;
        });
    }

    function updateEquipments(equipments) {
      return $http.put(api.getUrl(), equipments).then(api.whenCompleted);
    }

    function getEquipmentLogs(variables) {
      var query = '\
        query EquipmentQuery($equipmentId: ID!, $equipmentLogQueryInput: EquipmentLogQueryInput!) { \
          equipment (id: $equipmentId) { \
            logs (input: $equipmentLogQueryInput) { \
              pageInfo { \
                endCursor \
              } \
              items { \
                id \
                type \
                changedBy { \
                  id \
                  name \
                  type \
                  source \
                } \
                createdAt \
                clientApplicationName \
                snapshot { \
                  name \
                  number \
                  qrCode \
                  notes \
                  imageUrl \
                  archived \
                  locationSector { \
                    id \
                    name \
                  } \
                  locationEnvironment { \
                    id \
                    name \
                  } \
                  customer { \
                    id \
                    name \
                  } \
                  type { \
                    id \
                    name \
                    customFields { \
                      name \
                      required \
                      position \
                    } \
                  } \
                  location { \
                    id \
                    name \
                  } \
                } \
                attachmentSnapshot { \
                  id \
                  path \
                } \
                customFieldsSnapshot { \
                  name \
                  value \
                  type \
                  position \
                } \
              } \
            } \
          } \
        } \
      ';

      return $http.post(EnvironmentConfig.eyeOfSauron2Url, {
        query: query,
        variables: variables
      }, defaultOptions)
        .then(function (response) {
          return response.data.data.equipment.logs;
        });
    }

    function setLabels(variables) {
      var mutation = 'mutation LinkLabelsMutation($input: LinkLabelsInput!) { \
          setLabels (input: $input) { \
            id \
            name \
            type \
            color \
          } \
        } \
      ';

      var options = angular.copy(defaultOptions);
      return $http.post(EnvironmentConfig.eyeOfSauron2Url, {
        query: mutation,
        variables: variables
      }, options)
        .then(function (response) {
          return response.data.data.setLabels;
        });
    }

    function archive(id) {
      var requestUrl = api.getUrl() + id;
      return $http.delete(requestUrl).then(api.whenCompleted);
    }

    function getAttachmentsFromEquipment(equipment) {
      var requestUrl = api.getUrl() + equipment.id + '/attachments' + querify({ archived: 'no' });
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function getCustomFieldAnswers(equipmentId) {
      var requestUrl = api.getUrl() + equipmentId + '/custom-fields';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function saveCustomFieldResponses(equipmentId, customFields) {
      var requestUrl = api.getUrl() + equipmentId + '/custom-fields';
      return $http.put(requestUrl, customFields).then(api.whenCompleted);
    }

    function saveEquipmentAttachment(equipmentId, attachment) {
      if (attachment.id) {
        var requestUrl = api.getUrl() + equipmentId + '/attachments/' + attachment.id;
        return $http.put(requestUrl, attachment).then(api.whenCompleted);
      } else {
        var requestUrl = api.getUrl() + equipmentId + '/attachments';
        return $http.post(requestUrl, attachment).then(api.whenCompleted);
      }
    }

    function exportEquipments(queryString, userSettings) {
      var requestUrl = api.getUrl() + 'actions/export';
      return $http.post(requestUrl, {
        q: querifyPost(queryString),
        userSettings: userSettings
      }).then(api.whenCompleted);
    }

    function deleteEquipmentAttachment(equipmentId, attachmentId) {
      var requestUrl = api.getUrl() + equipmentId + '/attachments/' + attachmentId;
      return $http.delete(requestUrl).then(api.whenCompleted);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('employeesApi', employeesApi);

    function employeesApi(
        $http, EnvironmentConfig, Api, GraphQLApi, querify,
        EmployeesGetOneQuery, EmployeesSearchQuery, EmployeesUpdateMutation, EmployeesSearchWithTerritoriesQuery
    ) {
        var api = new Api($http, EnvironmentConfig.baseUrl, 'employees');
        var blackgateApi = new Api($http, EnvironmentConfig.blackgateUrl, 'employees');
        var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

        return {
            get: getOne,
            search: search,
            searchWithTerritories: searchWithTerritories,
            getAll: getAll,
            getSkill: getSkill,
            getSkills: getSkills,
            save: api.save,
            delete: api.delete,
            clearSkills: clearSkills,
            addSkill: addSkill,
            addSkills: addSkills,
            patchEmployee: patchEmployee,
            activate: activate,
            inactivate: inactivate,
            update: update
        };

        function getOne(id) {
            return graphQLApi.query(EmployeesGetOneQuery, { id: id }, 'employee');
        }

        function search(queryParams) {
            return graphQLApi.query(EmployeesSearchQuery, queryParams, 'employees');
        }

        function searchWithTerritories(queryParams) {
          return graphQLApi.query(EmployeesSearchWithTerritoriesQuery, queryParams, 'employees');
        }

        function update(employee) {
          return graphQLApi.mutation(EmployeesUpdateMutation, { input: employee }, 'updateEmployee');
        }

        function getAll() {
            return search({ take: 10000, orderBy: 'name_asc' });
        }

        function getSkill(id, serviceId) {
            var requestUrl = api.getUrl()  + id + '/skills/' + serviceId;
            return $http.get(requestUrl).then(api.whenCompleted);
        }

        function getSkills(id) {
            var requestUrl = api.getUrl()  + id + '/skills/';
            return $http.get(requestUrl).then(api.whenCompleted);
        }

        function addSkill(id, serviceId) {
            var requestUrl = api.getUrl()  + id + '/skills/';
            return $http.post(requestUrl, { service: { id: serviceId } }).then(api.whenCompleted);
        }

        function addSkills(id, skills) {
            var requestUrl = api.getUrl()  + id + '/skills/';
            return $http.post(requestUrl, skills).then(api.whenCompleted);
        }

        function clearSkills(id) {
            var requestUrl = api.getUrl()  + id + '/skills/';
            return $http.delete(requestUrl).then(api.whenCompleted);
        }

        function patchEmployee(id, data) {
            var requestUrl = api.getUrl() + id;
            return $http.patch(requestUrl, data).then(api.whenCompleted);
        }

        function activate(id) {
          var requestUrl = blackgateApi.getUrl() + id + '/activate/' ;

          return $http.post(requestUrl).then(blackgateApi.whenCompleted);
        }

        function inactivate(id) {
          var requestUrl = blackgateApi.getUrl() + id + '/inactivate/';

          return $http.post(requestUrl).then(blackgateApi.whenCompleted);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('customersApi', customersApi);

  function customersApi(
    $http, EnvironmentConfig, Api, GraphQLApi, querify, querifyPost, $q, _,
    CustomerGetOneQuery, CustomerSearchQuery
  ) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'customers', null, querify, $q);
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig, $q);

    return {
      getOne: getOne,
      search: search,
      getManyByDocumentNumber: getManyByDocumentNumber,
      getContacts: getContacts,
      getAttachments: getAttachments,
      save: api.save,
      patchCustomers: patchCustomers,
      putCustomer: putCustomer,
      setLabels: setLabels,
      postAttachment: postAttachment,
      putAttachment: putAttachment,
      postLocation: postLocation,
      putLocation: putLocation,
      patchLocation: patchLocation,
      saveLocation: saveLocation,
      enqueueDataExport: enqueueDataExport,
      geoSearch: geoSearch
    };

    function getOne(id) {
      return graphQLApi.query(CustomerGetOneQuery, { id: id }, 'customer');
    }

    function search(queryParams) {
      return graphQLApi.query(CustomerSearchQuery, queryParams, 'customers');
    }

    function getManyByDocumentNumber(documentNumbers) {
      var queries = [];
      _.chunk(documentNumbers, 20).forEach(function (documentNumbersChunk) {
        queries.push({ documentNumbers: documentNumbersChunk });
      });
      return graphQLApi.getSequence(CustomerSearchQuery, { take: 1000 }, 'customers', queries);
    }

    function getContacts(id) {
      var requestUrl = api.getUrl() + id + '/contacts';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function setLabels(id, labels) {
      var requestUrl = api.getUrl() + id + '/labels';
      return $http.put(requestUrl, { labels: labels }).then(api.whenCompleted);
    }

    function geoSearch(query, options) {
      var requestUrl = api.getUrl() + 'actions/geo-search';
      requestUrl += querify(query, options);
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function patchCustomers(customers) {
      return $http.patch(api.getUrl(), customers).then(api.whenCompleted);
    }

    function putCustomer(customer) {
      var requestUrl = api.getUrl() + customer.id;
      return $http.put(requestUrl, customer).then(api.whenCompleted);
    }

    function getAttachments(id) {
      var requestUrl = api.getUrl() + id + '/attachments';
      return $http.get(requestUrl).then(api.whenCompleted)
      .then(function (attachments) {
        return _.sortBy(attachments, function (attachment){
          return attachment.metadata.createdAt;
        });
      });
    }

    function postAttachment(id, attachment) {
      var requestUrl = api.getUrl() + id + '/attachments';
      return $http.post(requestUrl, attachment).then(api.whenCompleted);
    }

    function putAttachment(id, attachment) {
      var requestUrl = api.getUrl() + id + '/attachments/' + attachment.id;
      return $http.put(requestUrl, attachment).then(api.whenCompleted);
    }

    function postLocation(id, location) {
      var requestUrl = api.getUrl() + id + '/locations';
      return $http.post(requestUrl, location).then(api.whenCompleted);
    }

    function putLocation(id, location) {
      var requestUrl = api.getUrl() + id + '/locations/' + location.id;
      return $http.put(requestUrl, location).then(api.whenCompleted);
    }

    function patchLocation(id, location) {
      var requestUrl = api.getUrl() + id + '/locations/' + location.id;
      return $http.patch(requestUrl, location).then(api.whenCompleted);
    }

    function saveLocation(id, location) {
      if (location.id) {
        var requestUrl = api.getUrl() + id + '/locations/' + location.id;
        return $http.put(requestUrl, location).then(api.whenCompleted);
      } else {
        var requestUrl = api.getUrl() + id + '/locations';
        return $http.post(requestUrl, location).then(api.whenCompleted);
      }
    }

    function enqueueDataExport(queryString, userSettings) {
      var requestUrl = api.getUrl() + 'actions/export';
      return $http.post(requestUrl, {
        q: querifyPost(queryString),
        userSettings: userSettings
      }).then(api.whenCompleted);
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .factory('absencesApi', absencesApi);

  function absencesApi(
    $http, EnvironmentConfig, Api, GraphQLApi,
    AbsencesGetOneQuery, AbsencesSearchQuery
  ) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'absences');
    var graphQLApi = new GraphQLApi($http, EnvironmentConfig);

    return {
      getByDate: getByDate,
      get: get,
      save: api.save,
      delete: api.delete,
      search: search
    };

    function get(id) {
      return graphQLApi.query(AbsencesGetOneQuery, { id: id }, 'absence');
    }

    function search(queryParams) {
      return graphQLApi.query(AbsencesSearchQuery, queryParams, 'absences');
    }

    function getByDate(date) {
      var absenceDate = moment(date).format('YYYY-MM-DD');
      var queryParams = {
        where: {
          fromLte: absenceDate,
          toGte: absenceDate
        },
        take: 100
      };

      return search(queryParams).then(function (result) {
        return result.items;
      });
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.work-services', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.work-services', {
      url: '/servicos',
      views: {
        'content@app': {
          templateUrl: 'app/main/work-services/work-services.html',
          controller: 'WorkServicesController as vm'
        }
      },
      data: { titleTranslateKey: 'WORK_SERVICES.PAGE_TITLE' },
      resolve: {
        account: function (accountsApi) {
          return accountsApi.get();
        }
      }
    });
    $translatePartialLoaderProvider.addPart('app/main/work-services');
  }

})();

(function () {
  'use strict';

  angular
    .module('app.work-services')
    .factory('WorkServicesFilters', WorkServicesFilters);

  /** @ngInject */
  function WorkServicesFilters($rootScope, $timeout) {

    var filters = {
      name: null,
      description: null,
      archived: '1',
      type: 'service',

      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.name = null;
      filters.description = null;
      filters.archived = '1';
      filters.type = 'service';

      $timeout(function () { $rootScope.$broadcast('work-services:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = filters.name === null;
      var noDescriptionFiltered = filters.description === null;
      var noArchivedFiltered = filters.archived === '1';

      return !(noNameFiltered && noDescriptionFiltered && noArchivedFiltered);
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.work-services')
    .controller('WorkServicesFiltersSideNavController', WorkServicesFiltersSideNavController);

  /** @ngInject */
  function WorkServicesFiltersSideNavController(WorkServicesFilters, _, $rootScope, $timeout, $translate) {

    var vm = this;
    vm.serviceFilters = WorkServicesFilters;


    vm.statusOptions = [
      {
        value: {
          label: $translate.instant('WORK_SERVICES.FILTERS.SITUATIONS.ALL'),
          value: '-1'
        }
      },
      {
        value: {
          label: $translate.instant('WORK_SERVICES.FILTERS.SITUATIONS.ACTIVE'),
          value: '1'
        }
      },
      {
        value: {
          label: $translate.instant('WORK_SERVICES.FILTERS.SITUATIONS.ARCHIVED'),
          value: '0'
        }
      }
    ];
    vm.statusFilterValue = vm.statusOptions[1].value;


    vm.broadcastFilterUpdated = _.debounce(function (changedFilterName) {
      if (changedFilterName === 'archived') {
        vm.serviceFilters.archived = vm.statusFilterValue.value;
      }

      if (changedFilterName && vm.serviceFilters[changedFilterName] === 'null') {
        vm.serviceFilters[changedFilterName] = null;
      }

      if (changedFilterName && vm.serviceFilters[changedFilterName] === 'false') {
        vm.serviceFilters[changedFilterName] = false;
      }

      if (changedFilterName && vm.serviceFilters[changedFilterName] === 'true') {
        vm.serviceFilters[changedFilterName] = true;
      }

      $timeout(function () { $rootScope.$broadcast('work-services:reload'); }, 50);
    }, 500);
  }
})();

(function () {
  'use strict';

  angular.module('app.work-services')
    .factory('WorkServicesDialog', WorkServicesDialog);

  /** @ngInject */
  function WorkServicesDialog($mdDialog, $rootScope, productsServicesApi, $document, $q) {

    return {
      createService: createService,
      editService: editService
    };

    function createService(ev, callback) {
      _openDialog(ev, {
        Service: null,
        From: null
      }, callback);
    }

    function editService(ev, params, callback) {
      $rootScope.loadingProgress = true;

      var requests = {
        productService: productsServicesApi.getOne(params.id, {})
      };

      $q.all(requests).then(function (result) {
        _openDialog(ev, {
          Service: result.productService,
          From: params.from ? params.from : null
        }, callback);

      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function _openDialog(ev, locals, callback) {
      $mdDialog.show({
        controller: 'WorkServicesDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/work-services/dialogs/work-services/services-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload, Service) {
        if (callback) {
          callback(reload, Service);
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.work-services')
    .controller('WorkServicesDialogController', WorkServicesDialogController);

  /** @ngInject */
  function WorkServicesDialogController(
    $translate, $rootScope, $mdDialog, omieApi,
    $mdToast, $locale, Service, From, $q,
    productsServicesApi, gandalfApi,
    msUtils, uploadApi, CurrencyService
  ) {
    var vm = this;
    vm.currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = vm.currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    vm.service = angular.copy(Service);
    vm.from = angular.copy(From) || null;
    vm.serviceResultImageFile = null;
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['product-service-description'];

    if (!vm.service) {
      vm.service = {
        name: '',
        type: 'service',
        value: '',
        archived: false,
        description: '',
        imageUrl: '',
        measure: null,
        code: null,
        qrCode: null,
        productType: {
          id: null,
          name: null
        }
      };
      vm.newService = true;
    }

    if (vm.service && vm.service.externalAppId) {
      var deferred = $q.defer();

      omieApi.accounts.list()
        .then(function (res) {

          if (!res.data || !res.data.Items || !res.data.Items.length) {
            deferred.resolve({
              name: null,
              appId: null
            });
            return;
          }


          var account = _.find(res.data.Items, { appId: vm.service.externalAppId });

          deferred.resolve(account);
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      deferred.promise.then(function (account) {
        vm.omieAccount = account ? account.accountName : null;
      });
    }

    vm.closeDialog = closeDialog;
    function closeDialog(reload) {
      $mdDialog.hide(reload, vm.service);
    }

    vm.saveService = saveService;
    function saveService() {
      if (vm.service && !vm.service.description) {
        vm.service.description = '';
      }

      $rootScope.loadingProgress = true;
      productsServicesApi.save(vm.service)
        .then(function (result) {
          vm.service = _.assign(vm.service, result);
          if (vm.serviceResultImageFile) {
            var filename = '/work-services/' + vm.service.id + '/' + msUtils.shortGuidGenerator() + '.png';

            var reader = new FileReader();
            reader.readAsDataURL(vm.serviceResultImageFile);
            reader.onloadend = function () {
              var base64data = reader.result;

              uploadApi.uploadWithPassthrough({
                imageBase64Encoded: base64data,
                filename: filename
              })
                .then(function (path) {
                  vm.service.imageUrl = path.data.key;

                  productsServicesApi
                    .put(vm.service.id, vm.service)
                    .then(function (result) {
                      vm.service.imageUrl = result.imageUrl;
                    }).finally(function () {
                      _reloadService();
                    });
                });
            };
          }

          for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
            var field = vm.smartRewriteFields[i];
            var params = {
              reference: vm.sessionId,
              referenceType: field,
              updatedReference: result.id
            };

            gandalfApi.updateRewriteInputHistory(params);
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('WORK_SERVICES.TOAST.SAVED', { service: vm.service.name }))
              .hideDelay(3000)
          );
        })
        .catch(function (result) {
          if (result.data.err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('WORK_SERVICES.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('WORK_SERVICES.DIALOG.ALERT.OK'))
                .textContent(result.data.message)
            );
          }
        })
        .finally(function () {
          $rootScope.$broadcast('work-services:reload');
          $rootScope.loadingProgress = false;

          if ((!vm.serviceResultImageFile && !vm.service.imageUrl) || !vm.serviceResultImageFile) {
            _reloadService();
          }

          vm.closeDialog();
        });
    }

    vm.selectImage = selectImage;
    function selectImage() {
      var imageSelector = document.querySelector('#image-insert-container');
      if (imageSelector) {
        imageSelector.click();
      }
    }

    function _reloadService() {
      if (vm.newService) {
        $rootScope.$broadcast('product-services:created', vm.service);
      } else {
        $rootScope.$broadcast('product-services:edited', vm.service);
      }
    }

    vm.unarchiveService = unarchiveService;
    function unarchiveService($event) {
      vm.service.archived = false;
      saveService();
    }

    vm.archiveService = archiveService;
    function archiveService($event) {
      vm.service.archived = true;
      saveService();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('OmieManualServicesImportDialogController', OmieManualServicesImportDialogController);

  /** @ngInject */
  function OmieManualServicesImportDialogController(
    _, UtilityFunctions, $mdDialog, $rootScope, $scope, FcToastService, locals,
    productsServicesApi, omieServiceMapper, omieApi, $translate, msUtils
  ) {
    var vm = this;

    vm.limitPerPage = 5;
    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.totalCount = 0;
    vm.allServices = [];
    vm.nameContains = '';

    vm.navigateToPage = navigateToPage;
    vm.onSearchChange = onSearchChange;
    vm.searchServices = searchServices;
    vm.parseValueToPrice = parseValueToPrice;
    vm.importService = importService;
    vm.updateService = updateService;
    vm.closeDialog = closeDialog;
    vm.isValidUUID = msUtils.isUuidV4;
    vm.appId = locals.appId;

    _initialize();

    function navigateToPage(isNextPage) {
      vm.currentPage = isNextPage ? vm.currentPage + 1 : vm.currentPage - 1;
      searchServices();
    }

    function onSearchChange() {
      vm.currentPage = 1;
      searchServices();
    }

    function searchServices() {
      $rootScope.isLoading = true;
      _getOmieServicesToImport()
        .then(function (response) {
          _.defer(function () {
            $scope.$apply(function () {
              vm.totalPages = response.nTotPaginas || 0;
              vm.totalCount = response.nTotRegistros || 0;
              var omieServices = response.cadastros;
              if (omieServices && omieServices.length) {
                vm.allServices = omieServices.map(function (omieService) {
                  var fieldControlService = omieServiceMapper.toFieldControl(omieService);
                  checkIfExistsInFieldControl(fieldControlService);
                  fieldControlService.updating = true;
                  return fieldControlService;
                });
              }
            });
          });
        })
        .catch(function () {
          FcToastService.addWarning({
            hideDelay: 5000,
            position: 'BOTTOM LEFT',
            title: $translate.instant('WORK_SERVICES.IMPORT.LOADING_ERROR'),
            customClass: 'import-error-toast',
            iconPath: 'assets/icons/icon-service-error.svg',
            errorType: 'import-error-toast',
            noExit: true
          });
        });
    }

    function checkIfExistsInFieldControl(apiService) {
      if (apiService.integrationId) {
        productsServicesApi.getOne(
          apiService.integrationId,
          { limit: 1 }
        ).then(function (result) {
          if (result.id) {
            apiService.archived = result.archived;
            apiService.updating = true;
          } else {
            apiService.updating = false;
            apiService.archived = null;
          }
          $rootScope.isLoading = false;
        }).catch(function () {
          apiService.updating = false;
          $rootScope.isLoading = false;
        });
      } else {
        $rootScope.isLoading = false;
        apiService.updating = false;
      }
    };

    function _getOmieServicesToImport() {
      $rootScope.loadingProgress = true;
      vm.isLoadingServices = true;
      return omieApi.services.list({
        nPagina: vm.currentPage,
        nRegPorPagina: vm.limitPerPage,
        cDescricao: vm.nameContains ? '%' + vm.nameContains + '%' : ''
      }, vm.appId)
        .then(function (response) {
          return response.data;
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
          vm.isLoadingServices = false;
        });
    }

    function importService(serviceToSave) {
      $rootScope.loadingProgress = true;
      serviceToSave.externalAppId = vm.appId;
      productsServicesApi.save(serviceToSave)
        .then(function (savedService) {
          serviceToSave.integrationId = savedService.id;
          _saveIntegrationCodeOnOmie(serviceToSave);
          serviceToSave.selected = true;
        })
        .catch(function () {
          return _throwDefaultWarningByType('error', 'create');
        });
    }

    function updateService(serviceToUpdate) {
      $rootScope.loadingProgress = true;
      serviceToUpdate.selected = true;
      serviceToUpdate.externalAppId = vm.appId;
      productsServicesApi.put(serviceToUpdate.integrationId, serviceToUpdate)
        .then(function () {
          return _throwDefaultWarningByType('success', 'update');
        })
        .catch(function () {
          return _throwDefaultWarningByType('error', 'update');
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function _saveIntegrationCodeOnOmie(fieldControlService) {
      var omieService = omieServiceMapper.toOmie(fieldControlService);
      return omieApi.services.editIntegrationCode(omieService, vm.appId)
        .then(function (updatedOmieService) {
          omieService = updatedOmieService;
          return _throwDefaultWarningByType('success', 'create');
        })
        .catch(function () {
          return _throwDefaultWarningByType('error', 'create');
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function parseValueToPrice(value) {
      return UtilityFunctions.parseValueToPrice(value);
    }

    function _throwDefaultWarningByType(warningType, actionType) {
      var actionTranslation = actionType === 'update' ? 'UPDATE_SUCCESS' : 'SUCCESS_MANUAL';
      if (warningType === 'error') {
        actionTranslation = actionType === 'update' ? 'UPDATE_ERROR' : 'CREATE_ERROR';
      }
      var warningKeys = {
        error: {
          title: 'WORK_SERVICES.IMPORT.' + actionTranslation,
          customClass: 'import-error-toast',
          iconPath: 'assets/icons/icon-service-error.svg',
          errorType: 'import-error-toast'
        },
        success: {
          title: 'WORK_SERVICES.IMPORT.' + actionTranslation,
          customClass: 'import-finished-toast',
          iconPath: 'assets/icons/icon-success-circle-green.svg',
          errorType: 'import-finished-toast'
        }
      };
      var currentWarning = warningKeys[warningType];
      FcToastService.addWarning({
        hideDelay: 5000,
        position: 'BOTTOM LEFT',
        title: $translate.instant(currentWarning.title),
        customClass: currentWarning.customClass,
        iconPath: currentWarning.iconPath,
        errorType: currentWarning.errorType,
        noExit: true
      });
    }

    function closeDialog() {
      $mdDialog.hide(true);
    }

    function _initialize() {
      searchServices(0);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicles-usage', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.vehicles-usage', {
      url: '/historico-de-uso',
      views: {
        'content@app': {
          templateUrl: 'app/main/vehicles-usage/vehicles-usage.html',
          controller: 'VehiclesUsageController as vm'
        }
      },
      data: { titleTranslateKey: 'VEHICLES_USAGE.TITLE' },
      resolve: {
        account: function (accountsApi) {
          return accountsApi.get();
        }
      }
    });

    $translatePartialLoaderProvider.addPart('app/main/vehicles-usage');
  }

})();
(function () {
  'use strict';

  angular
    .module('app.vehicles-usage')
    .factory('VehiclesUsageFilters', VehiclesUsageFilters);

  /** @ngInject */
  function VehiclesUsageFilters($rootScope, $timeout) {

    var filters = {
      name: null,
      licensePlateNumber: null,
      type: null,
      origin: null,
      employeeId: null,
      userId: null,
      pickupAtGte: null,
      pickupAtLte: null,
      returnedAtGte: null,
      returnedAtLte: null,
      archived: false,
      licensePlate: null,

      clear: clear,
      isOn: isOn,
      isOff: isOff,
      toSearchOptions: toSearchOptions
    };

    function clear() {
      filters.name = null;
      filters.type = null;
      filters.origin = null;
      filters.employeeId = null;
      filters.userId = null;
      filters.pickupAtLte = null;
      filters.pickupAtGte = null;
      filters.returnedAtLte = null;
      filters.returnedAtGte = null;
      filters.archived = false;
      filters.licensePlate = null;

      $timeout(function () { $rootScope.$broadcast('vehicles-usage:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = filters.name === null;
      var noTypeFiltered = filters.type === null;
      var noOriginFiltered = filters.origin === null;
      var noEmployeeIdFiltered = filters.employeeId === null;
      var noUserIdFiltered = filters.userId === null;
      var noPickupAtLteFiltered = filters.pickupAtLte === null;
      var noPickupAtGteFiltered = filters.pickupAtGte === null;
      var noReturnedAtLteFiltered = filters.returnedAtLte === null;
      var noReturnedAtGteFiltered = filters.returnedAtGte === null;
      var noArchivedFiltered = filters.archived === false;
      var noLicensePlateFiltered = filters.licensePlate === null;

      return !(
        noNameFiltered &&
        noTypeFiltered &&
        noOriginFiltered &&
        noEmployeeIdFiltered &&
        noUserIdFiltered &&
        noPickupAtLteFiltered &&
        noPickupAtGteFiltered &&
        noReturnedAtLteFiltered &&
        noReturnedAtGteFiltered &&
        noArchivedFiltered &&
        noLicensePlateFiltered
      );
    }

    function isOff() {
      return !isOn();
    }

    function toSearchOptions() {
      var searchOptions = {};

      if (filters.name) {
        searchOptions.vehicleNameContains = filters.name;
      }

      if (filters.type) {
        searchOptions.vehicleType = filters.type;
      }

      if (filters.origin) {
        searchOptions.vehicleOrigin = filters.origin;
      }

      if (filters.employeeId) {
        searchOptions.employeeId = filters.employeeId;
      }

      if (filters.userId) {
        searchOptions.userId = filters.userId;
      }

      if (filters.pickupAtLte) {
        searchOptions.pickupAtLte = filters.pickupAtLte;
      }

      if (filters.pickupAtGte) {
        searchOptions.pickupAtGte = filters.pickupAtGte;
      }

      if (filters.returnedAtLte) {
        searchOptions.returnedAtLte = filters.returnedAtLte;
      }

      if (filters.returnedAtGte) {
        searchOptions.returnedAtGte = filters.returnedAtGte;
      }

      if (filters.licensePlate) {
        searchOptions.vehicleLicensePlateContains = filters.licensePlate;
      }

      if (filters.archived !== null) {
        searchOptions.archived = filters.archived;
      }

      return searchOptions;
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicles-usage')
    .controller('VehiclesUsageFiltersSideNavController', VehiclesUsageFiltersSideNavController);

  /** @ngInject */
  function VehiclesUsageFiltersSideNavController(
    _, $rootScope, msUtils, employeesApi,
    usersApi, VehiclesUsageFilters, $timeout
  ) {

    var vm = this;

    vm.employees = [];
    _loadEmployees();

    vm.vehiclesUsageFilters = {
      name: null,
      type: null,
      origin: null,
      employeeId: null,
      userId: null,
      pickupAtGte: null,
      pickupAtLte: null,
      returnedAtGte: null,
      returnedAtLte: null,
      archived: false
    };
    vm.vehiclesUsageFilters = VehiclesUsageFilters;

    vm.clearFilters = VehiclesUsageFilters.clear;
    vm.filteringIsOn = VehiclesUsageFilters.isOn;
    vm.exists = msUtils.exists;
    vm.filterId = null;
    vm.toggleInArray = toggleInArray;
    vm.options = [];
    vm.broadcastFilterUpdated = _.debounce(function (changedFilterName) {

      $timeout(function () {
        if (changedFilterName) {
          var currentFilterValue = vm.vehiclesUsageFilters[changedFilterName];

          if (changedFilterName === 'userId') {
            vm.vehiclesUsageFilters.userId = vm.filterId.id;
          }

          if (changedFilterName === 'employeeId') {
            vm.vehiclesUsageFilters.employeeId = vm.filterId.id;
          }

          if ((changedFilterName.indexOf('pickupAtGte') > -1 && currentFilterValue) || (changedFilterName.indexOf('returnedAtGte') > -1 && currentFilterValue)) {
             vm.vehiclesUsageFilters[changedFilterName] = moment(currentFilterValue).startOf('day').toJSON();
          }
          if ((changedFilterName.indexOf('pickupAtLte') > -1 && currentFilterValue) || (changedFilterName.indexOf('returnedAtLte') > -1 && currentFilterValue)) {
             vm.vehiclesUsageFilters[changedFilterName] = moment(currentFilterValue).endOf('day').toJSON();
          }

          if (currentFilterValue === 'null') {
            vm.vehiclesUsageFilters[changedFilterName] = null;
          }

          if (currentFilterValue === 'false') {
            vm.vehiclesUsageFilters[changedFilterName] = false;
          }

          if (currentFilterValue === 'true') {
            vm.vehiclesUsageFilters[changedFilterName] = true;
          }

        }

        $rootScope.$broadcast('vehicles-usage:reload');
      }, 50);
    }, 500);

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }

    function _loadEmployees() {
      employeesApi.getAll()
        .then(function (result) {
          var activeEmployees = _.filter(result.items, function (employee) {
            return employee.contract.active && !employee.inactivatedAt;
          });
          _.forEach(activeEmployees, function (employee) {
            employee.isEmployee = true;
            vm.options.push(employee);
            vm.options = _.sortBy(vm.options, 'name');
          });
        });
    }

    usersApi.search({ take: 100 })
    .then(function (result) {
        var users = result.items;
        _.forEach(users, function (user) {
          user.isEmployee = false;
          vm.options.push(user);
          vm.options = _.sortBy(vm.options, 'name');
        });
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicles', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.vehicles', {
      url: '/veiculos',
      views: {
        'content@app': {
          templateUrl: 'app/main/vehicles/vehicles.html',
          controller: 'VehiclesController as vm'
        }
      },
      data: { titleTranslateKey: 'VEHICLES.TITLE' }
    });

    $translatePartialLoaderProvider.addPart('app/main/vehicles');
  }

})();
(function () {
  'use strict';

  angular
    .module('app.vehicles')
    .factory('VehiclesFilters', VehiclesFilters);

  /** @ngInject */
  function VehiclesFilters($rootScope, $timeout) {

    var filters = {
      name: null,
      licensePlate: null,
      status: null,
      type: null,
      origin: null,
      archived: false,

      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.name = null;
      filters.licensePlate = null;
      filters.status = null;
      filters.type = null;
      filters.origin = null;
      filters.archived = false;

      $timeout(function () { $rootScope.$broadcast('vehicles:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = filters.name === null;
      var nolicensePlateFiltered = filters.licensePlate === null;
      var noStatusFiltered = filters.status === null;
      var noTypeFiltered = filters.type === null;
      var noOriginFiltered = filters.origin === null;
      var noArchivedFiltered = filters.archived === false;

      return !(
        noNameFiltered &&
        nolicensePlateFiltered &&
        noStatusFiltered &&
        noTypeFiltered &&
        noOriginFiltered &&
        noArchivedFiltered
      );
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicles')
    .controller('VehiclesFiltersSideNavController', VehiclesFiltersSideNavController);

  /** @ngInject */
  function VehiclesFiltersSideNavController(
    _, $rootScope, msUtils,
    VehiclesFilters, $timeout,
    $location, QueryStringParser
  ) {

    var vm = this;

    vm.vehiclesFilters = VehiclesFilters;
    vm.clearFilters = VehiclesFilters.clear;
    vm.filteringIsOn = VehiclesFilters.isOn;
    vm.exists = msUtils.exists;
    vm.toggleInArray = toggleInArray;
    vm.broadcastFilterUpdated = _.debounce(function (changedFilterName) {
      $timeout(function () {
        if (changedFilterName && vm.vehiclesFilters[changedFilterName] === 'null') {
          vm.vehiclesFilters[changedFilterName] = null;
        }

        if (changedFilterName && vm.vehiclesFilters[changedFilterName] === 'false') {
          vm.vehiclesFilters[changedFilterName] = false;
        }

        if (changedFilterName && vm.vehiclesFilters[changedFilterName] === 'true') {
          vm.vehiclesFilters[changedFilterName] = true;
        }

        $rootScope.$broadcast('vehicles:reload');
      }, 50);
    }, 500);

    _loadPreDefinedFilters();

    function _loadPreDefinedFilters() {
      var uriQuery = $location.search().q;
      if (uriQuery) {
        var qOptions = {
          keywords: [
            'status',
            'archived'
          ]
        };

        var queryResult = QueryStringParser.parse(uriQuery, qOptions);
        if (queryResult) {
          vm.vehiclesFilters.status = queryResult.status ? queryResult.status : vm.vehiclesFilters.status;
          vm.vehiclesFilters.archived = queryResult.archived ? queryResult.archived : vm.vehiclesFilters.archived;
          $rootScope.$broadcast('vehicles:reload');
        }
      }
    }

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('TasksFiltersSidenavController', TasksFiltersSidenavController);

  /** @ngInject */
  function TasksFiltersSidenavController(
    $scope, $rootScope, TasksStatusHelper, servicesApi, employeesApi, TasksFiltersService,
    msUtils, _, labelsApi, customersApi, equipmentsApi, $translate, accountCache, deadlineStatus, usersApi, territoriesApi,
    accountFeatureFlagsApiGraphQL
  ) {

    var vm = this;
    vm.filtredEquipment = null;
    vm.activitiesFilters = TasksFiltersService;
    vm.revicedFilters  = TasksFiltersService;
    vm.hasCustomerSelectedInFilter = false;
    vm.selectedCustomerInFilter = null;
    vm.customersFilterable = [];
    vm.hasUserSelectedInFilter = false;
    vm.selectedUserInFilter = null;
    vm.usersFilterable = [];
    vm.equipmentsFilterList = [];
    vm.servicesSelectedFilter = [];
    vm.equipmentsSelectedFilter = [];
    vm.hasSelectedCustomerEquipments = false;
    vm.searchTerm = '';
    vm.selectedMenu = 'Filters';
    vm.employees = [];
    vm.inactiveMessage = $translate.instant('TASKS.SIDENAV.FILTERS.FIELDS.BY_EMPLOYEE.INACTIVE');
    vm.today = moment().startOf('day').toDate();
    vm.account = null;
    vm.ratings = [
      { stars: 'null', name: '' },
      { stars: 1, name: $translate.instant('TASKS.SIDENAV.FILTERS.FIELDS.BY_RATE.RATINGS.ONE_STAR') },
      { stars: 2, name: $translate.instant('TASKS.SIDENAV.FILTERS.FIELDS.BY_RATE.RATINGS.TWO_STARS') },
      { stars: 3, name: $translate.instant('TASKS.SIDENAV.FILTERS.FIELDS.BY_RATE.RATINGS.THREE_STARS') },
      { stars: 4, name: $translate.instant('TASKS.SIDENAV.FILTERS.FIELDS.BY_RATE.RATINGS.FOUR_STARS') },
      { stars: 5, name: $translate.instant('TASKS.SIDENAV.FILTERS.FIELDS.BY_RATE.RATINGS.FIVE_STARS') }
    ];
    vm.hasTerritoriesFlag = false;

    vm.clearFilters = clearFilters;
    vm.toggleInArray = toggleInArray;
    vm.broadcastFilterUpdated = broadcastFilterUpdated;
    vm.createdByFilterHasChange = createdByFilterHasChange;
    vm.selectUserInFilter = selectUserInFilter;
    vm.removeSelectedUserInFilter = removeSelectedUserInFilter;
    vm.loadCustomerLabels = loadCustomerLabels;
    vm.customerNameFilterHasChange = customerNameFilterHasChange;
    vm.selectCustomerInFilter = selectCustomerInFilter;
    vm.removeSelectedCustomerInFilter = removeSelectedCustomerInFilter;
    vm.backToFilterPage = backToFilterPage;
    vm.clearSearchTerm = clearSearchTerm;
    vm.activitiesStatus = [];
    vm.filteringIsOn = TasksFiltersService.isOn;
    vm.exists = msUtils.exists;
    vm.deadlineStatusFilterList = deadlineStatus.getAll();
    vm.territorySelected = territorySelected;

    function _initialize() {
      servicesApi.getAll().then(function (result) {
        var services = _.filter(result.items, function (service) { return !service.archived; });
        vm.servicesFilterList = loadList(services, 'description');
      });

      accountFeatureFlagsApiGraphQL.getCachedFlagByName('territories').then(function (flag) {
        vm.hasTerritoriesFlag = flag ? flag.active : false;
      });

      territoriesApi.search({ take: 100, where: { archived: false } }).then(function (result) {
        vm.territoriesFilterList = result.items;
      });

      employeesApi.getAll().then(function (result) {
        var employees = _.map(result.items, function (employee) {
          if ((employee.contract.firedAt && moment(employee.contract.firedAt).isBefore(vm.today)) || (employee.inactivatedAt && moment(employee.inactivatedAt).isBefore(vm.today))) {
            employee.name += vm.inactiveMessage;
          }

          return employee;
        });

        employees = _.sortBy(employees, function (employee) { return employee.name; });

        employees = employees.sort(function (a, b) {
          var isAInactivatedOrFired = (a.contract.firedAt && moment(a.contract.firedAt).isBefore(vm.today)) || (a.inactivatedAt && moment(a.inactivatedAt).isBefore(vm.today));
          var isBInactivatedOrFired = (b.contract.firedAt && moment(b.contract.firedAt).isBefore(vm.today)) || (b.inactivatedAt && moment(b.inactivatedAt).isBefore(vm.today));

          return isAInactivatedOrFired === isBInactivatedOrFired ? 0 : isAInactivatedOrFired ? 1 : -1;
        });

        vm.employees = employees;
      });

      labelsApi.search({ type: 'orders' }, { limit: 100 }).then(function (result) {
        vm.labels = result.items;
      });

      accountCache.loadAccount().then(function (account) {
        vm.account = account;
        vm.activitiesStatus = TasksStatusHelper.getAll().filter(function (status) {
          if (status.name === 'pending' && (!account || !account.configuration.taskEnablePendingStatus)) {
            return false;
          }

          return true;
        });
      });

      $scope.$on('tasks-list:filter-cleaned', function () {
        resetSelectedCustomerFilterMechanic();
        resetSelectedCustomerEquipmentsFilter();
        resetSelectedCreatedByFilterMechanic();
      });

      $scope.$on('tasks-list:saved-filter-selected', function () {
        vm.selectedMenu = 'Filters';
        broadcastFilterUpdated();
      });

      $scope.$on('tasks-list:set-equipment-filters', function () {
        setEquipmentFilters();
      });
    }

    function clearSearchTerm() {
      vm.searchTerm = '';
    };

    function clearFilters() {
      $rootScope.selectedCustomFilter = {};
      TasksFiltersService.clear();
    }

    function loadCustomerLabels(query) {
      return labelsApi.search({
        'type': 'customers',
        'name~~*': '*' + query + '*'
      }, { limit: 100 }).then(function (result) {
        return result.items;
      });
    }

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      broadcastFilterUpdated();
    }

    function broadcastFilterUpdated(select) {
      if (select && typeof select === 'object' && select.hasOwnProperty('search')) {
        select.search = '';
      }
      $rootScope.$broadcast('tasks-list:filter-updated');
    }

    function customerNameFilterHasChange() {
      try {
        var osEquipmentEnabled = vm.account && vm.account.configuration.moduleOrderEquipmentManagementEnabled;
        if (osEquipmentEnabled && vm.activitiesFilters.customersName.length > 0) {
          vm.customersFilterable = [];
          customersApi.search({
            where: {
              nameContains: vm.activitiesFilters.customersName,
              archived: false
            },
            take: 5
          }).then(function (response) {
            if (response.items.length > 0) {
              response.items.forEach(function (customer) {
                vm.customersFilterable.push(customer);
              });
            }
          });
        } else {
          resetSelectedCustomerFilterMechanic();
          resetSelectedCustomerEquipmentsFilter();
        }
      } catch (e) {
        console.log("error searching for customers");
      }
    }

    function selectCustomerInFilter() {
      vm.activitiesFilters.customersName = vm.selectedCustomerInFilter.name;
      vm.hasCustomerSelectedInFilter = true;
      loadSelectedCustomerEquipments();
      resetSelectedCustomerEquipmentsFilter();
      vm.broadcastFilterUpdated();
    }

    function loadSelectedCustomerEquipments() {
      if (vm.selectedCustomerInFilter !== null) {
        vm.equipmentsFilterList = [];
        equipmentsApi.search({
          where: {
            customerIds: [vm.selectedCustomerInFilter.id],
            archived: false,
          },
          take: 1000
        }).then(function (response) {
          if (response.items.length) {
            response.items.forEach(function (equipment) {
              if (!equipment) { return; }
              var name = equipment.name;
              var number = equipment.number;

              equipment.displayName = name ? name + ' - ' + number : number;
              vm.equipmentsFilterList.push(equipment);
            });
            vm.hasSelectedCustomerEquipments = true;

            if(vm.revicedFilters.equipments.length && vm.revicedFilters.equipments[0].id){
              var recivedFilter = vm.revicedFilters.equipments[0].id || null;
              $scope.vm.activitiesFilters.equipments = [];
              if(vm.revicedFilters){
                vm.filtredEquipment = _.find(vm.equipmentsFilterList, function (equipment) {
                  return equipment.id === recivedFilter;
                });
                if (vm.filtredEquipment) {
                  $scope.vm.activitiesFilters.equipments.push(vm.filtredEquipment);
                }
              }
            }

          } else { resetSelectedCustomerEquipmentsFilter(); }
        });
      } else { resetSelectedCustomerEquipmentsFilter(); }
    }

    function removeSelectedCustomerInFilter() {
      vm.broadcastFilterUpdated();
      resetSelectedCustomerFilterMechanic();
      resetSelectedCustomerEquipmentsFilter();
    }

    function resetSelectedCustomerFilterMechanic() {
      vm.hasCustomerSelectedInFilter = false;
      vm.selectedCustomerInFilter = null;
      vm.customersFilterable = [];
    }

    function resetSelectedCustomerEquipmentsFilter() {
      vm.equipmentsFilterList = [];
      vm.hasSelectedCustomerEquipments = false;
      vm.activitiesFilters.equipments = [];
    }

    function createdByFilterHasChange() {
      try {
        var isCreatedByNameFiltering = vm.activitiesFilters.createdBy.length > 0;
        if (isCreatedByNameFiltering) {
          vm.usersFilterable = [];
          usersApi.search({
            where: {
              nameContains: vm.activitiesFilters.createdBy
            },
            take: 5
          })
            .then(function (response) {
              if (response.items.length > 0) {
                response.items.forEach(function (user) {
                  vm.usersFilterable.push(user);
                });
              }
            });
        } else {
          resetSelectedCreatedByFilterMechanic();
        }
      } catch (e) {
        console.log("error searching for users");
      }
    }

    function selectUserInFilter() {
      vm.activitiesFilters.createdBy = vm.selectedUserInFilter.name;
      vm.activitiesFilters.createdByIds = [Number(vm.selectedUserInFilter.id)];
      vm.hasUserSelectedInFilter = true;
      vm.broadcastFilterUpdated();
    }

    function resetSelectedCreatedByFilterMechanic() {
      vm.hasUserSelectedInFilter = false;
      vm.selectedUserInFilter = null;
      vm.usersFilterable = [];
      vm.activitiesFilters.createdBy = '';
      vm.activitiesFilters.createdByIds = [];
    }

    function removeSelectedUserInFilter() {
      vm.broadcastFilterUpdated();
      resetSelectedCreatedByFilterMechanic();
    }

    function loadList(list, propertyName, customValue) {
      var items = [];

      if (customValue) {
        items.push(customValue);
      }

      list.forEach(function (item) {
        item.name = item[propertyName];
        items.push(item);
      });

      return items;
    }

    function backToFilterPage() {
      vm.selectedMenu = 'Filters';
      $rootScope.$broadcast('returning-to-filter-main-page');
    }

    function setEquipmentFilters() {
      if(vm.activitiesFilters.customersName === ''){ return; }
      customersApi.search({
        where: {
          documentNumberContains: vm.activitiesFilters.customersName,
          archived: false
        },
        take: 5
      }).then(function (response) {
        if (response.items.length > 0) {
          var currentCustomer = _.find(response.items, function (customer) {
            return customer.name === vm.activitiesFilters.customersName;
          });
          if(currentCustomer){
            vm.customersFilterable.push(currentCustomer);
            vm.selectedCustomerInFilter = currentCustomer;
            vm.hasCustomerSelectedInFilter = true;
          }
          loadSelectedCustomerEquipments();
        }
      });
    }

    function territorySelected() {
      var selectedTerritoryId = vm.activitiesFilters.territoryId;
      vm.activitiesFilters.subTerritoryIds = [];
      vm.broadcastFilterUpdated();

      if (!selectedTerritoryId) {
        vm.subTerritoriesFilterList = [];

        return;
      }

      territoriesApi.search({ take: 150, where: { parentId: selectedTerritoryId, archived: false } }).then(function (result) {
        vm.subTerritoriesFilterList = result.items;
      });
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
  .module('app.tasks')
  .controller('UpdateAssigneeModalController', UpdateAssigneeModalController);

  /** @ngInject */
  function UpdateAssigneeModalController(
    $mdDialog, locals, $q, $timeout, $rootScope
  ) {
  var self = this;
  self.pendency = undefined;
  self.assignee = undefined;

  _initialize();

  function _initialize() {
    self.assignee = locals.assignee;
    self.pendency = locals.pendency;

    $timeout(function () {
      var dialog = document.querySelector('#update-assignee-modal');
      var modal = dialog.parentNode;
      var modalWithBackdrop = modal.parentNode;
      modal.classList.add('overflow-visible');

      dialog.addEventListener('closeDialogEvent', function (value) {
        $mdDialog.hide(value && value.detail);
      });

      dialog.addEventListener('isLoadingEvent', function (value) {
        if (value && value.detail) {
          $rootScope.loadingProgress = true;
          return;
        }

        $rootScope.loadingProgress = false;
      });

      dialog.addEventListener('showDialogEvent', function () {
        modalWithBackdrop.style.display = 'flex';
      });

      dialog.addEventListener('hideDialogEvent', function () {
        modalWithBackdrop.style.display = 'none';
      });
    });
  }
}})();

(function () {
  'use strict';

  angular
  .module('app.tasks')
  .controller('StorageMovementsModalComponent', StorageMovementsModalComponent);

  /** @ngInject */
  function StorageMovementsModalComponent(
    $mdDialog, locals, $q, $timeout
  ) {
  var self = this;
  self.order = undefined;
  self.storageMovement = undefined;

  _initialize();

  function _initialize() {
    self.order = locals.order;
    self.storageMovement = locals.storageMovement;

    $timeout(function () {
      var dialog = document.querySelector('#storage-movement');

      dialog.addEventListener('storageMovementClose', function (value) {
        $mdDialog.hide(value && value.detail);
      });
    });
  }
}})();

(function () {
  'use strict';

  angular.module('app.tasks')
    .factory('validateEmployeeIsInMoreThanOneTaskAtTheSameTime', validateEmployeeIsInMoreThanOneTaskAtTheSameTime);

  function validateEmployeeIsInMoreThanOneTaskAtTheSameTime(_, moment, msUtils) {
    return {
      validate: validate,
    };

    function checkOverlaps(tasks, account, formErr) {
      tasks.forEach(function (t1, t1Index) {
        tasks.forEach(function (t2, t2Index) {
          if (t1Index !== t2Index && (!t1.archived && !t2.archived)) {
            var previousTask = t1;
            var nextTask = t2;

            if (previousTask.startedAt && nextTask.startedAt) {

              if (previousTask.startedAt > nextTask.startedAt) {
                previousTask = t2;
                nextTask = t1;
              }

              var previousTaskFromTime = previousTask.startedAt.split(':');
              var previousTaskFromDate = new Date(previousTask.scheduling.date);
              previousTaskFromDate.setHours(previousTaskFromTime[0]);
              previousTaskFromDate.setMinutes(previousTaskFromTime[1]);
              var previousTaskFrom = moment(previousTaskFromDate);

              var previousTaskTo = null;
              if (previousTask.completedAt) {
                var previousTaskToTime = previousTask.completedAt.split(':');
                var previousTaskToDate = new Date(previousTask.scheduling.date);
                previousTaskToDate.setHours(previousTaskToTime[0]);
                previousTaskToDate.setMinutes(previousTaskToTime[1]);
                previousTaskTo = moment(previousTaskToDate);
              }
              var range1 = moment.range(previousTaskFrom, previousTaskTo);

              var nextTaskFromTime = nextTask.startedAt.split(':');
              var nextTaskFromDate = new Date(nextTask.scheduling.date);
              nextTaskFromDate.setHours(nextTaskFromTime[0]);
              nextTaskFromDate.setMinutes(nextTaskFromTime[1]);
              var nextTaskFrom = moment(nextTaskFromDate);

              var nextTaskTo = null;
              if (nextTask.completedAt) {
                var nextTaskToTime = nextTask.completedAt.split(':');
                var nextTaskToDate = new Date(nextTask.scheduling.date);
                nextTaskToDate.setHours(nextTaskToTime[0]);
                nextTaskToDate.setMinutes(nextTaskToTime[1]);
                nextTaskTo = moment(nextTaskToDate);
              }
              var range2 = moment.range(nextTaskFrom, nextTaskTo);

              var error = 'employeeIsInMoreThanOneTaskAtTheSameTime';
              if (range1.overlaps(range2)) {
                previousTask.statusErrors = previousTask.statusErrors || [];
                previousTask.statusErrors.push(error);

                nextTask.statusErrors = previousTask.statusErrors || [];
                nextTask.statusErrors.push(error);

                previousTask.statusErrors = msUtils.removeArrayDuplicates(previousTask.statusErrors);
                nextTask.statusErrors = msUtils.removeArrayDuplicates(nextTask.statusErrors);

                formErr[error] = 'This employee is in more than one task at the same time';
              } else {
                delete formErr[error];
                if (previousTask.statusErrors && previousTask.statusErrors.length) {
                  previousTask.statusErrors.splice(previousTask.statusErrors.indexOf(error), 1);
                }
                if (nextTask.statusErrors && nextTask.statusErrors.length) {
                  nextTask.statusErrors.splice(nextTask.statusErrors.indexOf(error), 1);
                }
              }
            }
          }
        });
      });
    }

    function validate(tasks, account, formErr) {
      if (!account || !account.timezone) { account = { timezone: 'America/Sao_Paulo' }; }

      if (!formErr) { formErr = {}; }

      if (tasks && tasks.length > 1) {
        var tasksGroupedByEmployee = _.groupBy(tasks, 'employee.id');

        Object.keys(tasksGroupedByEmployee).forEach(function (taskGroupedByEmployee) {
          if (taskGroupedByEmployee || taskGroupedByEmployee !== 'null') {
            var tasksByEmployee = tasksGroupedByEmployee[taskGroupedByEmployee];
            checkOverlaps(tasksByEmployee, account, formErr);
          }
        });

      }
      return tasks;
    }
  }
})();
(function () {
  'use strict';

  angular.module('app.tasks')
    .factory('validateDateAndTimeService', validateDateAndTimeService);

  function validateDateAndTimeService(moment) {
    return {
      isDateOrTimeMissing: isDateOrTimeMissing,
      isStartedAtLessThanCreatedAt: isStartedAtLessThanCreatedAt,
      isStartedAtGreaterThanPresent: isStartedAtGreaterThanPresent,
      isCompletedAtLessThanStartedAt: isCompletedAtLessThanStartedAt,
      isCompletedAtGreaterThanPresent: isCompletedAtGreaterThanPresent,
      isGreaterThan12Hours: isGreaterThan12Hours,
      isMinorThan1Hour: isMinorThan1Hour
    };

    function isDateOrTimeMissing(date, time, entityToVerify) {
      if (date && time) {
        return false;
      }

      if (!date && !time) {
        return false;
      }

      if (entityToVerify === 'date') return !date;
      if (entityToVerify === 'time') return !time;

      return true;
    }

    function isStartedAtLessThanCreatedAt(inputs, timeFormat) {
      var task = inputs.task;
      var index = inputs.index;
      var orderForm = inputs.orderForm;
      var account = inputs.account;
      var featureCloseTaskWithPastDate = inputs.featureCloseTaskWithPastDate;
      var startedAtDate = orderForm['startedAtDate_' + index].$viewValue;
      var startedAtTime = orderForm['startedAtTime_' + index].$viewValue;

      if (isDateOrTimeMissing(startedAtDate, startedAtTime)) {
        return false;
      }

      if (!startedAtDate && !startedAtTime) {
        return false;
      }

      if (featureCloseTaskWithPastDate) {
        return false;
      }

      if (timeFormat === 'pm') {
        startedAtTime = String(parseInt(startedAtTime.split(':')[0]) + 12) + ':' + startedAtTime.split(':')[1];
      }

      var formattedStartedAt = moment(startedAtDate + 'T' + startedAtTime);
      var formattedCreatedAt = moment(task.metadata.createdAt);


      var startedAtLocal = moment(formattedStartedAt);
      var createdAtLocal = moment(formattedCreatedAt);
      return startedAtLocal.isBefore(createdAtLocal);
    }

    function isStartedAtGreaterThanPresent(inputs, timeFormat) {
      var index = inputs.index;
      var orderForm = inputs.orderForm;
      var account = inputs.account;
      var featureCloseTaskWithFutureDate = inputs.featureCloseTaskWithFutureDate;
      var startedAtDate = orderForm['startedAtDate_' + index].$viewValue;
      var startedAtTime = orderForm['startedAtTime_' + index].$viewValue;

      if (isDateOrTimeMissing(startedAtDate, startedAtTime)) {
        return false;
      }

      if (!startedAtDate && !startedAtTime) {
        return false;
      }

      if (featureCloseTaskWithFutureDate) {
        return false;
      }

      if (timeFormat === 'pm') {
        startedAtTime = String(parseInt(startedAtTime.split(':')[0]) + 12) + ':' + startedAtTime.split(':')[1];
      }

      var formattedStartedAt = moment(startedAtDate + 'T' + startedAtTime);
      var formattedNow = moment();

      var startedAtLocal = moment(formattedStartedAt);
      var nowLocal = moment(formattedNow);

      return startedAtLocal.isAfter(nowLocal);
    }

    function isCompletedAtLessThanStartedAt(inputs, startTimeFormat, completedTimeFormat) {
      var index = inputs.index;
      var orderForm = inputs.orderForm;
      var account = inputs.account;
      var startedAtDate = orderForm['startedAtDate_' + index].$viewValue;
      var startedAtTime = orderForm['startedAtTime_' + index].$viewValue;
      var completedAtDate = orderForm['completedAtDate_' + index].$viewValue;
      var completedAtTime = orderForm['completedAtTime_' + index].$viewValue;

      if (isDateOrTimeMissing(startedAtDate, startedAtTime) || isDateOrTimeMissing(completedAtDate, completedAtTime)) {
        return false;
      }

      if ((!startedAtDate && !startedAtTime) || (!completedAtDate && !completedAtTime)) {
        return false;
      }

      if (startTimeFormat === 'pm') {
        startedAtTime = String(parseInt(startedAtTime.split(':')[0]) + 12) + ':' + startedAtTime.split(':')[1];

        if (startedAtTime.split(':')[0] === '24') {
          startedAtTime = '12:' + startedAtTime.split(':')[1];
        }
      } else if (startTimeFormat === 'am') {
        if (startedAtTime.split(':')[0] === '12') {
          startedAtTime = '00:' + startedAtTime.split(':')[1];
        }
      }
      if (completedTimeFormat === 'pm') {
        completedAtTime = String(parseInt(completedAtTime.split(':')[0]) + 12) + ':' + completedAtTime.split(':')[1];

        if (completedAtTime.split(':')[0] === '24') {
          completedAtTime = '12:' + completedAtTime.split(':')[1];
        }
      } else if (completedTimeFormat === 'am') {
        if (completedAtTime.split(':')[0] === '12') {
          completedAtTime = '00:' + completedAtTime.split(':')[1];
        }
      }

      var formattedStartedAt = moment(startedAtDate + 'T' + startedAtTime);
      var formatCompletedAt = moment(completedAtDate + 'T' + completedAtTime);

      var startedAtLocal = moment(formattedStartedAt);
      var completedAtLocal = moment(formatCompletedAt);

      return completedAtLocal.isBefore(startedAtLocal);
    }

    function isCompletedAtGreaterThanPresent(inputs, timeFormat) {
      var index = inputs.index;
      var orderForm = inputs.orderForm;
      var account = inputs.account;
      var featureCloseTaskWithFutureDate = inputs.featureCloseTaskWithFutureDate;
      var completedAtDate = orderForm['completedAtDate_' + index].$viewValue;
      var completedAtTime = orderForm['completedAtTime_' + index].$viewValue;

      if (isDateOrTimeMissing(completedAtDate, completedAtTime)) {
        return false;
      }

      if (!completedAtDate && !completedAtTime) {
        return false;
      }

      if (featureCloseTaskWithFutureDate) {
        return false;
      }

      if (timeFormat === 'pm') {
        completedAtTime = String(parseInt(completedAtTime.split(':')[0]) + 12) + ':' + completedAtTime.split(':')[1];

        if (completedAtTime.split(':')[0] === '24') {
          completedAtTime = '12:' + completedAtTime.split(':')[1];
        }
      }

      var formattedCompletedAt = moment(completedAtDate + 'T' + completedAtTime);
      var formattedNow = moment();


      var completedAtLocal = moment(formattedCompletedAt);
      var nowLocal = moment(formattedNow);

      if (completedAtLocal.isAfter(nowLocal)) {
        return true;
      }

      return false;
    }

    function isGreaterThan12Hours(input, timeFormat) {
      if (!input) {
        return false;
      }

      input = input.split(':')[0];
      if (input > 12) {
        return true;
      }

    }

    function isMinorThan1Hour(input) {
      if (input) {
        input = input.split(':')[0];
        if (input < 1) {
          return true;
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.tasks')
    .factory('taskTimelineConverter', taskTimelineConverter);

  /** @ngInject */
  function taskTimelineConverter(_, moment, TasksStatusHelper,
    usersCacheService, msUtils,
    haversine, leafletBoundsHelpers, $translate, LocalDateConvert) {

    return {
      toTimeline: toTimeline
    };

    function toTimeline(task, logs, employees) {

      var users = usersCacheService.getUsers();

      var timeline = [];
      var ratedEvent = false;
      var previousEvent = null;
      var previousEmployee = null;

      function formatName(name) {
        if (name) {
          var atIndex = name.indexOf('@');
          if (atIndex !== -1) {
            name = name.substring(0, atIndex);
            name = name.toLocaleLowerCase();
            name = name.charAt(0).toUpperCase() + name.slice(1);
          }
          return name;
        }
        return '';
      }

      function createFirstEvent(args) {

        timeline.push({
          id: args.log.id,
          icon: args.currentStatus.icon,
          color: args.currentStatus.color,
          time: LocalDateConvert.formatDate(args.log.metadata.createdAt, 'date-time'),
          event: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.TASK_CREATED.EVENT', { name: formatName(args.currentSource.name) }),
          eventIcon: args.currentSource.eventIcon,
          eventIconTooltip: args.currentSource.eventIconTooltip,
          card: {
            "title": task.order.service.description,
            "subtitle": task.order.customer.name,
            "template": "app/core/directives/ms-card/templates/template-2/template-2.html",
            "text": args.task.order.description,
            "avatar": {
              "src": args.currentSource.avatarUrl,
              "alt": formatName(args.currentSource.name)
            }
          }
        });
      }

      function createArchivedOrUnarchivedEvent(args) {

        if (previousEvent) {

          var hasBeenArchived = previousEvent.archived === false && args.log.archived === true;
          if (hasBeenArchived) {

            timeline.push({
              id: args.log.id,
              card: {
                template: "app/core/directives/ms-card/templates/template-2/template-2.html",
                title: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.TASK_ARCHIVED.TITLE'),
                text: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.TASK_ARCHIVED.TEXT', { name: formatName(args.currentSource.name) }),
                "avatar": {
                  "src": args.currentSource.avatarUrl,
                  "alt": args.currentSource.name
                }
              },
              icon: 'icon-folder-download',
              color: '#607D8B',
              time: LocalDateConvert.formatDate(args.log.metadata.createdAt, 'date-time'),
              event: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.TASK_ARCHIVED.EVENT', { name: formatName(args.currentSource.name) }),
              eventIcon: args.currentSource.eventIcon,
              eventIconTooltip: args.currentSource.eventIconTooltip
            });

          }

          var hasBeenUnarchived = previousEvent.archived === true && args.log.archived === false;
          if (hasBeenUnarchived) {

            timeline.push({
              id: args.log.id,
              card: {
                template: "app/core/directives/ms-card/templates/template-2/template-2.html",
                title: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.TASK_UNARCHIVED.TITLE'),
                text: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.TASK_UNARCHIVED.TEXT', { name: formatName(args.currentSource.name) }),
                "avatar": {
                  "src": args.currentSource.avatarUrl,
                  "alt": args.currentSource.name
                }
              },
              icon: 'icon-folder-upload',
              color: '#01579B',
              time: LocalDateConvert.formatDate(args.log.metadata.createdAt, 'date-time'),
              event: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.TASK_UNARCHIVED.EVENT', { name: formatName(args.currentSource.name) }),
              eventIcon: args.currentSource.eventIcon,
              eventIconTooltip: args.currentSource.eventIconTooltip
            });

          }
        }
      }

      function createSchedulingChangedEvent(args) {

        if (previousEvent) {

          if (previousEvent.scheduling && args.log.scheduling) {

            var changedScheduledDate = previousEvent.scheduling.date !== args.log.scheduling.date;
            var changedScheduledTime = previousEvent.scheduling.time !== args.log.scheduling.time;

            if (changedScheduledDate || changedScheduledTime) {

              var fromDate = LocalDateConvert.formatDate(previousEvent.scheduling.date, 'date');
              if (previousEvent.scheduling.time) {
                fromDate += ' ' + previousEvent.scheduling.time;
              }

              var toDate = LocalDateConvert.formatDate(args.log.scheduling.date, 'date');
              if (args.log.scheduling.time) {
                toDate += ' ' + args.log.scheduling.time;
              }

              timeline.push({
                id: args.log.id,
                card: {
                  template: "app/core/directives/ms-card/templates/template-2/template-2.html",
                  title: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.SCHEDULE_CHANGED.TITLE'),
                  text: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.SCHEDULE_CHANGED.TEXT', {
                    name: formatName(args.currentSource.name),
                    fromDate: fromDate,
                    toDate: toDate
                  }),
                  "avatar": {
                    "src": args.currentSource.avatarUrl,
                    "alt": args.currentSource.name
                  }
                },
                icon: 'icon-calendar-select',
                color: 'rgb(3,155,229)',
                time: LocalDateConvert.formatDate(args.log.metadata.createdAt, 'date-time'),
                event: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.SCHEDULE_CHANGED.EVENT', { name: formatName(args.currentSource.name) }),
                eventIcon: args.currentSource.eventIcon,
                eventIconTooltip: args.currentSource.eventIconTooltip
              });

            }
          }
        }
      }

      function createEmployeeChangedEvent(args) {

        var employeeUnassigned = previousEmployee && (!args.log.employee || !args.log.employee.id);
        var employeeAssigned = !previousEmployee && (args.log.employee && args.log.employee.id);

        if (previousEmployee && (args.log.employee && args.log.employee.id)) {

          var employeeChanged = previousEmployee.id !== args.log.employee.id;

          if (employeeChanged) {

            timeline.push({
              id: args.log.id,
              card: {
                template: "app/core/directives/ms-card/templates/template-2/template-2.html",
                title: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.EMPLOYEE_CHANGED.TITLE'),
                //subtitle: args.activity.employee.name,
                text: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.EMPLOYEE_CHANGED.TEXT', {
                  name: formatName(args.currentSource.name),
                  previousEmployee: previousEmployee.name,
                  currentEmployee: args.currentEmployee.name
                }),
                "avatar": {
                  "src": args.currentSource.avatarUrl,
                  "alt": args.currentSource.name
                }
              },
              icon: 'icon-account-switch',
              color: 'rgb(3,155,229)',
              time: LocalDateConvert.formatDate(args.log.metadata.createdAt, 'date-time'),
              event: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.EMPLOYEE_CHANGED.EVENT', { name: formatName(args.currentSource.name) }),
              eventIcon: args.currentSource.eventIcon,
              eventIconTooltip: args.currentSource.eventIconTooltip
            });
          }

        } else if (employeeAssigned) {

          timeline.push({
            id: args.log.id,
            card: {
              template: "app/core/directives/ms-card/templates/template-2/template-2.html",
              title: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.EMPLOYEE_ASSIGNED.TITLE'),
              //subtitle: args.activity.employee.name,
              text: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.EMPLOYEE_ASSIGNED.TEXT', {
                name: formatName(args.currentSource.name),
                employeeName: args.currentEmployee.name
              }),
              "avatar": {
                "src": args.currentSource.avatarUrl,
                "alt": args.currentSource.name
              }
            },
            icon: 'icon-account-check',
            color: 'rgb(3,155,229)',
            time: LocalDateConvert.formatDate(args.log.metadata.createdAt, 'date-time'),
            event: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.EMPLOYEE_ASSIGNED.EVENT', { name: formatName(args.currentSource.name) }),
            eventIcon: args.currentSource.eventIcon,
            eventIconTooltip: args.currentSource.eventIconTooltip
          });
        }
        else if (employeeUnassigned) {

          timeline.push({
            id: args.log.id,
            card: {
              template: "app/core/directives/ms-card/templates/template-2/template-2.html",
              title: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.EMPLOYEE_UNASSIGNED.TITLE'),
              //subtitle: args.activity.employee.name,
              text: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.EMPLOYEE_UNASSIGNED.TEXT', {
                name: formatName(args.currentSource.name),
                employeeName: previousEmployee.name
              }),
              "avatar": {
                "src": args.currentSource.avatarUrl,
                "alt": args.currentSource.name
              }
            },
            icon: 'icon-account-remove',
            color: 'rgb(3,155,229)',
            time: LocalDateConvert.formatDate(args.log.metadata.createdAt, 'date-time'),
            event: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.EMPLOYEE_UNASSIGNED.EVENT', { name: formatName(args.currentSource.name) }),
            eventIcon: args.currentSource.eventIcon,
            eventIconTooltip: args.currentSource.eventIconTooltip
          });
        }
      }

      function createStatusChangedEvent(args) {

        var statusChanged = previousEvent.status !== args.log.status;
        if (statusChanged) {

          var text = args.log.statusDescription || $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.STATUS_CHANGED.TEXT');

          var timelineEvent = {
            id: args.log.id,
            card: {
              template: "app/core/directives/ms-card/templates/template-12/template-12.html",
              avatar: {
                src: args.currentSource.avatarUrl,
                alt: args.currentSource.name
              },
              title: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.STATUS_CHANGED.TITLE'),
              subtitle: args.currentStatus.description,
              subtitleColor: args.currentStatus.color,
              text: text
            },
            icon: args.currentStatus.icon,
            color: args.currentStatus.color,
            time: LocalDateConvert.formatDate(args.log.metadata.createdAt, 'date-time'),
            event: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.STATUS_CHANGED.EVENT', { name: formatName(args.currentSource.name) }),
            eventIcon: args.currentSource.eventIcon,
            eventIconTooltip: args.currentSource.eventIconTooltip
          };
          timelineEvent.card.map = {
            bounds: {},
            center: {},
            markers: {},
            paths: {},
            defaults: {
              dragging: false,
              scrollWheelZoom: false,
              zoomControl: true
            }
          };

          if (args.log.changedBy.coords && args.log.changedBy.coords.latitude && args.log.changedBy.coords.longitude) {

            timelineEvent.coords = args.log.changedBy.coords;

            var employeeLocation = {
              latitude: parseFloat(args.log.changedBy.coords.latitude),
              longitude: parseFloat(args.log.changedBy.coords.longitude)
            };

            var taskLocation = {
              latitude: parseFloat(task.coords.latitude),
              longitude: parseFloat(task.coords.longitude)
            };

            var metersDistance = haversine(employeeLocation, taskLocation, { unit: 'meter' });
            var kmDistance = haversine(employeeLocation, taskLocation, { unit: 'km' });

            var displayDistance = null;
            var displayDistanceName = null;

            if (metersDistance > 1000) {
              displayDistance = kmDistance.toFixed(0);
              displayDistanceName = 'Km';
            } else {
              displayDistance = metersDistance.toFixed(0);
              displayDistanceName = 'm';
            }

            timelineEvent.coords.distanceDescription = $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.STATUS_CHANGED.DISTANCE_DESCRIPTION', {
              displayDistance: displayDistance,
              displayDistanceName: displayDistanceName
            });

            var employeePin = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/null-avatar-marker-online.png';
            if (args.currentSource.source == 'mobile') {
              if (args.currentSource.source.avatarUrl) {
                employeePin = args.currentSource.source.avatarUrl.replace('/default.', '/marker-online.');
                employeePin += '?id=' + msUtils.shortGuidGenerator();
              }
            }

            timelineEvent.card.map = {
              id: 'events' + args.log.id + 'Map',
              bounds: leafletBoundsHelpers.createBoundsFromArray([
                [employeeLocation.latitude, employeeLocation.longitude],
                [taskLocation.latitude, taskLocation.longitude]
              ]),
              center: {
                autoDiscover: true
              },
              markers: {
                employee: {
                  lat: employeeLocation.latitude,
                  lng: employeeLocation.longitude,
                  icon: {
                    iconUrl: employeePin,
                    iconSize: [32, 32], // size of the icon
                    iconAnchor: [16, 16], // point of the icon which will correspond to marker's location
                    popupAnchor: [0, -16]  // point from which the popup should open relative to the iconAnchor
                  }
                },
                task: {
                  lat: taskLocation.latitude,
                  lng: taskLocation.longitude,
                  icon: {
                    type: 'div',
                    html: '<div>' +
                      '    <i style="color:' + args.currentStatus.color + ';" class="icon icon-city s38"></i>' +
                      '</div>',
                    iconAnchor: [16, 16], // point of the icon which will correspond to marker's location
                    popupAnchor: [0, -16]  // point from which the popup should open relative to the iconAnchor
                  }
                }
              },
              paths: {
                distance: {
                  color: args.currentStatus.color,
                  weight: 4,
                  latlngs: [
                    {
                      lat: taskLocation.latitude,
                      lng: taskLocation.longitude
                    },
                    {
                      lat: employeeLocation.latitude,
                      lng: employeeLocation.longitude
                    }
                  ]
                }
              },
              defaults: {
                dragging: false,
                scrollWheelZoom: false,
                zoomControl: true
              }
            };
          }

          timelineEvent.mobileOffline = args.log.changedBy.offline;
          if (timelineEvent.mobileOffline === true && args.log.changedBy.offlineClock) {
            timelineEvent.offlineClock = LocalDateConvert.formatDate(args.log.changedBy.offlineClock, 'date-time-seconds');
          }

          timeline.push(timelineEvent);
        }
      }

      function createStatusDescriptionChangedEvent(args) {
        var statusDescriptionChanged = previousEvent.statusDescription !== args.log.statusDescription && previousEvent.status === args.log.status;
        if (statusDescriptionChanged) {
          var text = args.log.statusDescription || $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.STATUS_CHANGED.TEXT');

          var timelineEvent = {
            id: args.log.id,
            card: {
              template: "app/core/directives/ms-card/templates/template-12/template-12.html",
              avatar: {
                src: args.currentSource.avatarUrl,
                alt: args.currentSource.name
              },
              title: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.STATUS_DECRIPTION_CHANGED.TITLE'),
              subtitle: args.currentStatus.description,
              subtitleColor: args.currentStatus.color,
              text: text
            },
            icon: args.currentStatus.icon,
            color: args.currentStatus.color,
            time: LocalDateConvert.formatDate(args.log.metadata.createdAt, 'date-time'),
            event: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.STATUS_DECRIPTION_CHANGED.EVENT', { name: formatName(args.currentSource.name) }),
            eventIcon: args.currentSource.eventIcon,
            eventIconTooltip: args.currentSource.eventIconTooltip
          };

          timeline.push(timelineEvent);
        }
      }

      function createRatingEvent(args) {

        if (args.log.rating && args.log.rating.id && ratedEvent === false) {

          ratedEvent = true;

          var colorsByStars = {
            1: '#F44336',
            2: '#F44336',
            3: '#FFC107',
            4: '#4CAF50',
            5: '#4CAF50'
          };

          var emotionsByStars = {
            1: 'icon-emoticon-sad',
            2: 'icon-emoticon-sad',
            3: 'icon-emoticon-neutral',
            4: 'icon-emoticon-happy',
            5: 'icon-emoticon'
          };

          var timelineEvent = {
            id: args.log.id,
            card: {
              template: "app/core/directives/ms-card/templates/template-13/template-13.html",
              emotion: emotionsByStars[args.log.rating.stars],
              title: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.TASK_RATING.TITLE'),
              stars: args.log.rating.stars,
              color: colorsByStars[args.log.rating.stars],
              text: args.log.rating.comments
            },
            color: colorsByStars[args.log.rating.stars],
            icon: "icon-thumbs-up-down",
            time: LocalDateConvert.formatDate(args.log.metadata.createdAt, 'date-time'),
            event: $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.TASK_RATING.EVENT', { customerName: task.order.customer.name }),
            eventIcon: args.currentSource.eventIcon,
            eventIconTooltip: args.currentSource.eventIconTooltip
          };

          timeline.push(timelineEvent);
        }
      }

      function getUserOrEmployee(changedBy) {
        var source = {
          name: changedBy.name,
          source: changedBy.source
        };

        if (changedBy.source == 'browser') {

          source.eventIcon = 'laptop-chromebook';
          source.eventIconTooltip = $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.SENT_BY.BROWSER');
          source.avatarUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg';

        } else if (changedBy.source == 'mobile') {

          source.eventIcon = 'cellphone-iphone';
          source.eventIconTooltip = $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.SENT_BY.CELLPHONE');
          source.avatarUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg';

        } else if (changedBy.source == 'vrp') {

          source.eventIcon = 'cog';
          source.eventIconTooltip = $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.SENT_BY.ROUTE_PLANNER');
          source.avatarUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/vrp.png';

        } else if (changedBy.source == 'sys') {

          source.eventIcon = 'cog';
          source.eventIconTooltip = $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.SENT_BY.FIELD_CONTROL');
          source.avatarUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/recurrence.png';

        } else if (changedBy.source === 'api') {

          source.eventIcon = 'code-not-equal-variant';
          source.eventIconTooltip = 'Atualizado pela API de Integração';
          source.avatarUrl = 'https://app.fieldcontrol.com.br/assets/images/api.png';

        } else if (changedBy.source == 'enterprise') {

          source.eventIcon = 'cog';
          source.eventIconTooltip = $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.SENT_BY.ENTERPRISE', { corporateAccount: task.order.metadata.sammathnaur.account.name });
          source.avatarUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/recurrence.png';

        } else if (changedBy.source == 'gandalf') {
          source.eventIcon = 'cog';
          source.eventIconTooltip = $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.SENT_BY.GANDALF');
          source.avatarUrl = 'https://app.fieldcontrol.com.br/assets/icons/modules/smart-rewrite.svg';
        }

        if (changedBy.type == 'users') {
          if (changedBy.source == 'browser') {
            source.eventIconTooltip += ' ' + $translate.instant('TASKS.DIALOG.TABS.HISTORY.TIMELINE.SENT_BY.CONTROL_PANEL');
          }
          var user = _.find(users, function (u) {
            return u.id == changedBy.id;
          });
          if (user) {
            if (user.avatarUrl) {
              source.avatarUrl = user.avatarUrl;
            }
          }

        } else if (changedBy.type == 'employees') {
          var employee = _.find(employees, function (e) {
            return e.id == changedBy.id;
          });
          if (employee) {
            source.name = employee.name;
            if (employee.avatarUrl) {
              source.avatarUrl = employee.avatarUrl;
            }
          }
        }

        return source;
      }

      function getEmployee(employee) {
        if (employee) {
          return _.find(employees, function (e) {
            return e.id == employee.id;
          });
        }
        return null;
      }

      logs = logs.items;
      logs = _.sortBy(logs, function (log) {
        return moment(log.metadata.createdAt).toDate().getTime();
      });

      logs.forEach(function (log) {

        var args = {
          log: log,
          task: task,
          currentStatus: TasksStatusHelper.getByName(log.status),
          currentSource: getUserOrEmployee(log.changedBy),
          currentEmployee: getEmployee(log.employee)
        };

        if (previousEvent === null) {
          createFirstEvent(args);
        }
        else {
          createEmployeeChangedEvent(args);
          createStatusChangedEvent(args);
          createStatusDescriptionChangedEvent(args);
          createSchedulingChangedEvent(args);
          createRatingEvent(args);
          createArchivedOrUnarchivedEvent(args);
        }

        previousEvent = log;
        var withEmployee = log.employee && log.employee.id;
        var withNoEmployee = !log.employee || !log.employee.id;
        if (withEmployee) {
          previousEmployee = args.currentEmployee;
        } else if (withNoEmployee && previousEmployee) {
          previousEmployee = null;
        }
      });

      return timeline.reverse();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .factory('recurrencesLinksService', recurrencesLinksService);

  /** @ngInject */
  function recurrencesLinksService(_) {
    var recurrenceLocationSectors = null;
    var recurrenceLocationEnvironments = null;
    var recurrenceEquipments = null;

    return {
      setRecurrenceLinks: setRecurrenceLinks,
      getRecurrenceLinks: getRecurrenceLinks,
      clearRecurrenceLinks: clearRecurrenceLinks
    };

    function setRecurrenceLinks(params) {
      if (!params) {
        return;
      }

      if (params.sectors) {
        recurrenceLocationSectors = params.sectors;
      }

      if (params.environments) {
        recurrenceLocationEnvironments = params.environments;
      }

      if (params.equipments) {
        recurrenceEquipments = params.equipments;
      }
    }

    function getRecurrenceLinks() {
      return {
        recurrenceLocationSectors: recurrenceLocationSectors,
        recurrenceLocationEnvironments: recurrenceLocationEnvironments,
        recurrenceEquipments: recurrenceEquipments,
      };
    }

    function clearRecurrenceLinks() {
      recurrenceLocationSectors = null;
      recurrenceLocationEnvironments = null;
      recurrenceEquipments = null;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.tasks')
    .factory('ordersFormsMapper', ordersFormsMapper);

  /** @ngInject */
  function ordersFormsMapper(_) {

    return {
      toView: toView,
      toEntity: toEntity,
      reloadedFormToView: reloadedFormToView
    };

    function toEntity(form) {
      if (form) {
        if (form.questions && form.questions.length) {
          form.questions = _.sortBy(form.questions, 'position');
          form.questions.forEach(function (question) {
            if (question.type === 'checkboxes') {
              question.answer = question.answer || null;
              question.options = question.options || [];
              var answers = [];
              question.options.forEach(function (qOption) {
                if (qOption.checked === true) {
                  answers.push(qOption.value);
                }
              });
              if (answers.length) {
                question.answer = answers.join('&');
              }
            }

            if (question.show === false) {
              question.answer = null;
            }

            if (question.type === 'multiple-picture') {
              question.answer = _.filter(question.answer, function (answer) { return !!answer; });
              question.answer = question.answer.join('&');
            }
          });
        }
      }
      return form;
    }

    function toView(forms) {
      var results = [];
      forms = forms || [];
      forms.forEach(function (form) {
        if (!form || !form.id) {
          return;
        }

        if (!form.questions || !form.questions.length) {
          return;
        }

        form.questions = _.sortBy(form.questions, 'position');
        form.questions.forEach(function (question) {
          if (!question.answer) {
            return;
          }

          if (question.type === 'checkboxes') {
            question.answer.split('&').forEach(function (optionValue) {
              var option = _.find(question.options, function (qOption) {
                return qOption.value === optionValue;
              });

              if (option) {
                option.checked = true;
              }
            });

            return;
          }

          if (question.type === 'multiple-picture') {
            if (_.isArray(question.answer)) {
              return;
            }

            question.answer = question.answer.split('&');
          }
        });

        form = _verifyConditional(form);
        results.push(form);
      });

      return results;
    }

    function reloadedFormToView(form, oldForm) {
      if (!form || !form.id) { return form; }
      if (!form.questions || !form.questions.length) { return form; }
      if (oldForm) {
        form.order = oldForm.order;
        form.metadata = oldForm.metadata;
        form.reference = oldForm.reference;
        form.equipment = oldForm.equipment;
      }
      form.questions = _.sortBy(form.questions, 'position');
      form.questions.forEach(function (question) {
        if (!question.answer) { return; }

        if (question.type === 'checkboxes') {
          question.answer.split('&').forEach(function (optionValue) {
            var option = _.find(question.options, function (qOption) {
              return qOption.value === optionValue;
            });
            if (option) { option.checked = true; }
          });

          return;
        }

        if (question.type === 'multiple-picture') {
          if (_.isArray(question.answer)) { return; }
          question.answer = question.answer.split('&');
        }
      });
      form = _verifyConditional(form);
      return form;
    }
  }

  function _verifyConditional(form) {
    form.questions.forEach(function (question) {

      var isConditional = question.conditions && question.conditions.length;

      if (!isConditional) {
        question.show = true;
        return;
      }

      var everyConditionsMatch = _.every(question.conditions, function (condition) {
        var matchQuestion = _.find(form.questions, function (item) {
          return item.title === condition.question.title;
        });

        if (condition.operator === 'not-equal') {
          return matchQuestion && matchQuestion.answer !== condition.value && matchQuestion.show;
        }

        return matchQuestion && matchQuestion.answer === condition.value && matchQuestion.show;
      });

      question.show = everyConditionsMatch;
    });

    return form;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .factory('orderServicesService', orderServicesService);

  /** @ngInject */
  function orderServicesService(_) {
    var orderServices = [];
    var servicesToUpdate = [];

    return {
      addService: addService,
      setService: setService,
      getServices: getServices,
      resetServices: resetServices,
      hasExistentService: hasExistentService,
      getServicesToUpdate: getServicesToUpdate,
      removeServiceToUpdate: removeServiceToUpdate,
      formatSelectedService: formatSelectedService,
      resetServicesToUpdate: resetServicesToUpdate
    };

    function hasExistentService(ordersWithServices, service) {
      var orderServiceIds = ordersWithServices.map(function (order) { return order.service.id; });
      var existentServiceIndex = orderServiceIds.indexOf(service.id);
      return existentServiceIndex !== -1;
    }

    function getServices() {
      return _formatOrderServices(orderServices);
    }

    function setService(service) {
      servicesToUpdate.push(service);
    }

    function removeServiceToUpdate(service) {
      servicesToUpdate = servicesToUpdate.filter(function (item) { return item.item.id !== service.item.id; });
    }

    function getServicesToUpdate() {
      return servicesToUpdate;
    }

    function addService(service, orderId) {
      var ServiceExists = hasExistentService(orderServices, service);
      if (!ServiceExists) {
        orderServices.push(formatSelectedService(service, orderId));
        return orderServices;
      }

      orderServices = orderServices.map(function (orderService) {
        var currentService = orderService.id === service.id ? service : orderService;
        return formatSelectedService(currentService, orderId);
      });
      return orderServices;
    }

    function resetServices(linkedServices, orderId) {
      if(!(linkedServices && linkedServices.length)) { linkedServices = []; }
      orderServices = linkedServices.map(function (linkedService) {
        return formatSelectedService(linkedService, orderId);
      });
    }

    function formatSelectedService(service, orderId) {
      var item = (service && service.service) || service;
      var selectedService = {
        order: {
          id: orderId
        },
        service: item
      };

      return selectedService;
    }

    function _formatOrderServices(orderServices) {
      return orderServices.map(function (orderService) {
        return orderService.service || orderService;
      });
    }

    function resetServicesToUpdate() {
      servicesToUpdate = [];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .factory('orderRoutesService', orderRoutesService);

  /** @ngInject */
  function orderRoutesService($rootScope) {
    var routes = {};

    return {
      getRoutes: getRoutes,
      setRoutes: setRoutes,
      resetRoutes: resetRoutes,
    };

    function getRoutes() {
      return routes;
    }

    function resetRoutes() {
      routes = {};
    }

    function setRoutes(newRoutes) {
      routes = angular.copy(newRoutes);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .factory('orderProductsService', orderProductsService);

  /** @ngInject */
  function orderProductsService(_) {
    var orderProducts = [];
    var productsToUpdate = [];

    return {
      addProduct: addProduct,
      setProduct: setProduct,
      getProducts: getProducts,
      resetProducts: resetProducts,
      hasExistentProduct: hasExistentProduct,
      getProductsToUpdate: getProductsToUpdate,
      removeProductToUpdate: removeProductToUpdate,
      formatSelectedProduct: formatSelectedProduct,
      resetUpdateProducts: resetUpdateProducts
    };

    function hasExistentProduct(ordersWithProducts, product) {
      var orderProductIds = ordersWithProducts.map(function (order) { return order.product.id; });
      var existentProductIndex = orderProductIds.indexOf(product.id);
      return existentProductIndex !== -1;
    }

    function getProducts() {
      return _formatOrderProducts(orderProducts);
    }

    function setProduct(product) {
      productsToUpdate.push(product);
    }

    function removeProductToUpdate(product) {
      productsToUpdate = productsToUpdate.filter(function (item) { return item.item.id !== product.item.id; });
    }

    function getProductsToUpdate() {
      return productsToUpdate;
    }

    function addProduct(product, orderId) {
      var productExists = hasExistentProduct(orderProducts, product);
      if (!productExists) {
        orderProducts.push(formatSelectedProduct(product, orderId));
        return orderProducts;
      }

      orderProducts = orderProducts.map(function (orderProduct) {
        var currentProduct = orderProduct.id === product.id ? product : orderProduct;
        return formatSelectedProduct(currentProduct, orderId);
      });
      return orderProducts;
    }

    function resetProducts(linkedProducts, orderId) {
      if(!(linkedProducts && linkedProducts.length)) { linkedProducts = []; }
      orderProducts = linkedProducts.map(function (linkedProduct) {
        return formatSelectedProduct(linkedProduct, orderId);
      });
    }

    function formatSelectedProduct(product, orderId) {
      var item = (product && product.product) || product;
      var selectedProduct = {
        order: {
          id: orderId
        },
        product: item
      };

      return selectedProduct;
    }

    function _formatOrderProducts(orderProducts) {
      return orderProducts.map(function (orderProduct) {
        return orderProduct.product || orderProduct;
      });
    }

    function resetUpdateProducts() {
      productsToUpdate = [];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .factory('orderPendenciesService', orderPendenciesService);

  /** @ngInject */
  function orderPendenciesService($rootScope) {
    var pendencies = {};

    return {
      getPendencies: getPendencies,
      setPendencies: setPendencies,
      resetPendencies: resetPendencies
    };

    function getPendencies() {
      return pendencies;
    }

    function resetPendencies() {
      pendencies = {};
    }

    function setPendencies(newPendencies) {
      pendencies.items = pendencies.items && pendencies.items.length
        ? pendencies.items.concat(newPendencies.items)
        : newPendencies.items;

      pendencies.pageInfo = newPendencies.pageInfo;
      pendencies.totalCount = newPendencies.totalCount;

      $rootScope.$broadcast('orderPendenciesUpdated');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .factory('orderMaterialsService', orderMaterialsService);

  /** @ngInject */
  function orderMaterialsService(_) {
    var orderMaterials = [];

    return {
      setMaterial: setMaterial,
      getMaterials: getMaterials,
      deleteMaterial: deleteMaterial,
      resetMaterials: resetMaterials
    };

    function getMaterials() {
      return orderMaterials;
    }

    function resetMaterials() {
      orderMaterials = [];
    }

    function setMaterial(material, order) {
      if (_isSelectedMaterial(material.id)) {
        return orderMaterials;
      }

      var selectedMaterial = {
        order: {
          id: order.id
        },
        material: null
      };

      selectedMaterial.material = material;

      if (!selectedMaterial.material.quantity) {
        selectedMaterial.material.quantity = null;
      }

      if (!selectedMaterial.material.isLinked) {
        selectedMaterial.material.isLinked = false;
      }

      orderMaterials.push(selectedMaterial);

      return orderMaterials;
    }

    function deleteMaterial(material) {
      var materialIndex = _.findIndex(orderMaterials, function (orderMaterial) {
        return orderMaterial.material.id === material.id;
      });

      orderMaterials.splice(materialIndex, 1);

      return orderMaterials;
    }

    function _isSelectedMaterial(materialId) {
      var selectedMaterial = _.find(orderMaterials, function (item) {
        return item.material.id === materialId;
      });

      return !!selectedMaterial;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .factory('orderLinksService', orderLinksService);

  /** @ngInject */
  function orderLinksService(_) {
    var orderLocationSectors = null;
    var orderLocationEnvironments = null;
    var orderEquipments = null;

    return {
      setOrderLinks: setOrderLinks,
      getOrderLinks: getOrderLinks,
      clearOrderLinks: clearOrderLinks
    };

    function setOrderLinks(params) {
      if (!params) {
        return;
      }

      if (params.sectors) {
        orderLocationSectors = params.sectors;
      }

      if (params.environments) {
        orderLocationEnvironments = params.environments;
      }

      if (params.equipments) {
        orderEquipments = params.equipments;
      }
    }

    function getOrderLinks() {
      return {
        orderLocationSectors: orderLocationSectors,
        orderLocationEnvironments: orderLocationEnvironments,
        orderEquipments: orderEquipments,
      };
    }

    function clearOrderLinks() {
      orderLocationSectors = null;
      orderLocationEnvironments = null;
      orderEquipments = null;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.tasks')
    .factory('normalizePrintConfigurations', normalizePrintConfigurations);

  function normalizePrintConfigurations(_) {
    return {
      normalize: normalize
    };

    function normalize(configurations) {
      if (!configurations || !configurations.length) return [];
      _.forEach(configurations, function (configuration) {
        var isBoolean = _.includes(['true', 'false'], configuration.value);
        if (isBoolean) {
          configuration.value = JSON.parse(configuration.value);
        }
        if (!isBoolean && !isNaN(configuration.value)) {
          configuration.value = +configuration.value;
        }
      });
      return configurations;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.tasks')
    .factory('formValidator', formValidator);

  function formValidator(_, ordersFormsMapper) {

    return {
      validate: validate
    };

    function validate(options) {
      var response = {
        isValid: false
      };
      if (options.status === 'done' || options.status === 'reported') {
        if (options.serviceForms.length > 0) {
          var requiredForms = _getRequiredForms(options.status, options.serviceForms);
          if (requiredForms.length > 0) {
            var requiredFormsNotAnswered = _getRequiredFormsNotAnswered(requiredForms, options.forms);
            if (requiredFormsNotAnswered.length) {
              response.errors = requiredFormsNotAnswered;
            } else {
              var requiredFormsAnswered = _getRequiredFormsAnswered(requiredForms, options.forms);
              var requiredFormsWithRequiredQuestionsNotAnswered = [];
              requiredFormsAnswered.forEach(function (requiredFormAnswered) {
                var requiredQuestionsAnswered = _validateAnswers(requiredFormAnswered);
                if (requiredQuestionsAnswered) {
                  if (!requiredFormsWithRequiredQuestionsNotAnswered.length) {
                    response.isValid = true;
                  } else {
                    response.isValid = false;
                  }
                } else {
                  response.isValid = false;
                  requiredFormsWithRequiredQuestionsNotAnswered.push({
                      description: 'Formulário ' + requiredFormAnswered.name + ' (perguntas obrigatórias estão sem resposta)'
                  });
                }
              });

              if (requiredFormsWithRequiredQuestionsNotAnswered.length) {
                response.errors = requiredFormsWithRequiredQuestionsNotAnswered;
              }
            }
          } else {
            response.isValid = true;
          }
          return response;
        } else {
          response.isValid = true;
          return response;
        }
      } else {
        response.isValid = true;
        return response;
      }
    }

    function _getRequiredForms(status, serviceForms) {
      return _.filter(serviceForms, function (serviceForm) {
        if (status === 'done') {
          return serviceForm.required.complete;
        } else if (status === 'reported') {
          return serviceForm.required.report;
        }
      });
    }

    function _getRequiredFormsNotAnswered(requiredForms, answeredForms) {
      var requiredFormsNotAnswered = [];
      requiredForms.forEach(function (requiredForm) {
        var answeredForm = _.filter(answeredForms, function (form) {
            return form.name === requiredForm.name;
        });
        if (!answeredForm.length) {
          requiredFormsNotAnswered.push({ description: 'Formulário ' + requiredForm.name + ' é obrigatório' });
        }
      });
      return requiredFormsNotAnswered;
    }

    function _getRequiredFormsAnswered(requiredForms, answeredForms) {
      var requiredFormsAnswered = [];
      answeredForms.forEach(function (answeredForm) {
        if (!answeredForm.archived) {
          var requiredFormAnswered = _.find(requiredForms, function (requiredForm) {
            return requiredForm.name === answeredForm.name;
          });

          if (requiredFormAnswered) {
            requiredFormsAnswered.push(answeredForm);
          }
        }
      });

      return requiredFormsAnswered;
    }

    function _validateAnswers(answeredForm) {
      var validQuestions = true;
      answeredForm = ordersFormsMapper.toEntity(answeredForm);
      var requiredAnswerAndNotAnswered = _.filter(answeredForm.questions, function (question) {
        if(question.show === undefined) question.show = true;
        return (question.required && question.show && !question.answer);
      });
      if (requiredAnswerAndNotAnswered && requiredAnswerAndNotAnswered.length) {
        validQuestions = false;
      }

      return validQuestions;
    }

  }
})();

(function () {
  'use strict';
  angular
  .module('app.tasks')
  .controller('SearchEquipmentsFormsController', SearchEquipmentsFormsController);

  /** @ngInject */
  function SearchEquipmentsFormsController(
    $mdDialog, $document, locals, equipmentTypesApi, _, formsApi
  ) {
    var vm = this;
    vm.searchForms = searchForms;
    vm.closeDialog = closeDialog;
    vm.navigateToPage = navigateToPage;
    vm.getLastFormsCount = getLastFormsCount;
    vm.answerForm = answerForm;

    vm.equipment = null;
    vm.order = null;
    vm.forms = [];
    vm.showingForms = [];
    vm.formsPage = 1;
    vm.formsPaginateBy = 6;
    vm.searchEquipmentFormText = '';

    _initialize();

    function _initialize() {
      vm.order = angular.copy(locals.order);
      vm.equipment = angular.copy(locals.equipment);
      vm.searchEquipments = locals.searchEquipments;
      vm.getEquipmentsFromOrder = locals.getEquipmentsFromOrder;
      vm.account = angular.copy(locals.account);
      vm.featureFlags = angular.copy(locals.featureFlags);
      vm.hasFeatureFlag = angular.copy(locals.hasFeatureFlag);
      vm.reloadEquipmentsForms = reloadEquipmentsForms;
      getFormsByEquipmentType(vm.equipment);
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function searchForms(searchTerm) {
      vm.filteredForms = _.filter(vm.forms, function (form) {
        return form.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
      });
    }

    function getFormsByEquipmentType(equipment) {
      var equipmentTypeId = equipment.type.id;

      equipmentTypesApi.getOneEquipmentType(equipmentTypeId, { include: 'forms' }).then(function (response) {
        var equipmentForms = response.forms;
        var unarchivedEquipmentForms = equipmentForms.filter(function (form) {
          return form.archived !== true;
        });

        filterAvailableFormsByService(vm.order.service, unarchivedEquipmentForms);
      });
    }

    function filterAvailableFormsByService(orderService, equipmentForms) {
      vm.forms = equipmentForms.filter(function (form) {
        if (form.service && form.service.id) {
          return form.service.id === orderService.id;
        } else {
          return !form.service;
        }
      });
      navigateToPage(1);
    }

    function answerForm(form) {
      formsApi.get(form.id, { include: 'questions,questions.options' }).then(function (formModel) {
        if (vm.hasFeatureFlag('forms')) {
          formModel.equipment = vm.equipment;

          var event = new CustomEvent('openOrderFormAnswerDialog', {
            detail: {
              formModel: formModel,
              order: vm.order
            }
          });

          document.dispatchEvent(event);

          document.addEventListener('orderFormAnswerDialogClosed', orderFormAnswerDialogClosed);
          return;
        }

        $mdDialog.show({
          controller: 'FormQuestionsController',
          controllerAs: 'vm',
          templateUrl: 'app/core/dialogs/form-questions/form-questions.html',
          parent: document.querySelector('.palantir-modal-container') || angular.element($document.body),
          targetEvent: null,
          clickOutsideToClose: true,
          multiple: true,
          locals: {
            form: form,
            order: vm.order,
            equipment: vm.equipment
          }
        })
        .then(function () {
          vm.searchEquipments();
          vm.getEquipmentsFromOrder();
        })
        .finally(function (){
          _initialize();
        });
      });
    }

    function orderFormAnswerDialogClosed(event) {
      document.removeEventListener('orderFormAnswerDialogClosed', orderFormAnswerDialogClosed);

      vm.searchEquipments();
      vm.getEquipmentsFromOrder();
      vm.reloadEquipmentsForms();

      getFormsByEquipmentType(vm.equipment);
    }

    function reloadEquipmentsForms() {
      var event = new CustomEvent('reloadOrderEquipments');

      document.dispatchEvent(event);
    }

    function navigateToPage(pageNumber) {
      vm.formsPage = pageNumber;
      vm.showingForms = vm.forms.slice(
        (vm.formsPage - 1) * vm.formsPaginateBy,
        vm.formsPage * vm.formsPaginateBy
      );
    }

    function getLastFormsCount() {
      return vm.formsPage * vm.formsPaginateBy;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('SearchAnsweredEquipmentsFormsController', SearchAnsweredEquipmentsFormsController);
  /** @ngInject */
  function SearchAnsweredEquipmentsFormsController($scope, $document, $mdDialog, locals, ordersApi, _, moment, CheckEditPermission, LocalDateConvert) {
    var vm = this;

    vm.initialForms = [];
    vm.equipment = null;
    vm.task = null;
    vm.account = null;
    vm.answeredFormIsCollapsed = [];
    vm.forms = [];
    vm.filteredForms = [];
    vm.formsNames = [];
    vm.moment = moment;
    vm.dateFormat = LocalDateConvert.pickFormat('date-time');
    vm.selectForm = selectForm;

    vm.closeDialog = closeDialog;
    vm.searchAnsweredForms = searchAnsweredForms;
    vm.goToForm = goToForm;
    vm.toggleCollapse = toggleCollapse;

    _initialize();

    function toggleCollapse(index) {
      vm.answeredFormIsCollapsed[index] = !vm.answeredFormIsCollapsed[index];
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function _initialize() {
      vm.equipment = angular.copy(locals.equipment);
      vm.order = angular.copy(locals.order);
      vm.account = angular.copy(locals.account);
      vm.featureFlags = angular.copy(locals.featureFlags);
      vm.hasFeatureFlag = angular.copy(locals.hasFeatureFlag);
      getAvailableFormsForEquipment(vm.equipment);
    }

    function searchAnsweredForms(searchTerm) {
      var keys = Object.keys(vm.forms);
      var filteredKey = _.filter(keys, function (key) {
        return key.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
      });

      vm.filteredForms = _.map(filteredKey, function (key) {
        return {
          text: key
        };
      });
    }

    function selectForm(form) {
      vm.forms = {};
      vm.forms[form.text] = vm.initialForms[form.text];
    }

    function getAvailableFormsForEquipment(equipment) {
      ordersApi.getEquipmentForms(vm.order.id, equipment.id).then(function (response) {
        if (response) {
          var groupedForms = _.groupBy(response, 'reference' && 'name');
          vm.forms = Object.values(groupedForms);
          _.defer(function () {
            $scope.$apply(function () {
              vm.forms = groupedForms;
              vm.initialForms = groupedForms;
            });
          });
        }
        vm.forms = [];
      });
    }

    function goToForm(form) {
      if (!CheckEditPermission.hasPermission()) {
        vm.closeDialog();
        return;
      }

      if (vm.hasFeatureFlag('forms')) {
        form.equipment = vm.equipment;

        var event = new CustomEvent('openOrderFormAnswerDialog', {
          detail: {
            formModel: form,
            order: vm.order
          }
        });

        document.dispatchEvent(event);

        document.addEventListener('orderFormAnswerDialogClosed', orderFormAnswerDialogClosed);

        return;
      }

      $mdDialog.show({
        controller: 'FormQuestionsController',
        controllerAs: 'vm',
        templateUrl: 'app/core/dialogs/form-questions/form-questions.html',
        parent: angular.element($document.body),
        targetEvent: null,
        clickOutsideToClose: true,
        multiple: true,
        locals: {
          form: form,
          order: vm.order,
          equipment: vm.equipment,
          editForm: true
        }
      }).finally(function () {
        _initialize();
      });
    }

    function orderFormAnswerDialogClosed(event) {
      console.log('executou');
      document.removeEventListener('orderFormAnswerDialogClosed', orderFormAnswerDialogClosed);

      getAvailableFormsForEquipment(vm.equipment);

      var event = new CustomEvent('reloadFormsEvent');
      document.dispatchEvent(event);
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('app.tasks')
  .controller('ReturnOrderProductsModalComponent', ReturnOrderProductsModalComponent);

  /** @ngInject */
  function ReturnOrderProductsModalComponent(
    $mdDialog, locals, $timeout
  ) {

  var self = this;
  self.orderId = undefined;
  self.productId = undefined;

  _initialize();

  function _initialize() {
    self.orderId = locals.orderId;
    self.productId = locals.productId;

    $timeout(function () {
      var dialog = document.querySelector('#return-order-products');

      dialog.addEventListener('ReturnOrderProductsClose', function (value) {
        $mdDialog.hide(value && value.detail);
      });
    });
  }
}})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('LinkServicesDialogController', LinkServicesDialogController);

  /** @ngInject */
  function LinkServicesDialogController(_, ordersApi, productsServicesApi, UtilityFunctions, locals, $mdDialog, orderServicesService, $q, omieApi, $rootScope, CurrencyService) {
    var self = this;

    self.maxLinkedServices = 150;
    self.limit = 5;
    self.offset = 0;
    self.currentPage = 1;
    self.totalPages = 0;
    self.totalCount = 0;

    self.allServices = [];
    self.linkedServices = [];
    self.currentlySelectedServices = [];

    self.orderId = locals.order.id;
    self.selectedCustomer = locals.selectedCustomer;
    self.selectedService = locals.selectedService;

    self.isLoading = false;
    self.nameContains = '';
    self.allServicesSelected = false;
    self.currentShowedServices = self.limit;

    self.navigateToPage = navigateToPage;
    self.selectService = selectService;
    self.deselectService = deselectService;
    self.searchServices = searchServices;
    self.selectOrDeselectAllServices = selectOrDeselectAllServices;
    self.parseValueToPrice = parseValueToPrice;
    self.saveSelectedServices = saveSelectedServices;
    self.closeDialog = closeDialog;
    self.getLastServiceCount = getLastServiceCount;

    _initialize();

    function navigateToPage(isNextPage) {
      self.currentPage = isNextPage ? self.currentPage + 1 : self.currentPage - 1;
      self.offset = isNextPage ? self.offset + 5 : self.offset - 5;
      self.currentShowedServices = self.offset + 5;

      searchServices(self.offset);
    }

    function searchServices(offset) {
      self.isLoading = true;
      var queryParams = {
        archived: 'no',
        type: 'service'
      };

      var queryOptions = {
        sort: '-createdAt',
        limit: self.limit,
        offset: offset
      };

      if (self.nameContains !== '') {
        queryParams['name~~*'] = '*' + self.nameContains + '*';
      }

      var customerIntegration = self.selectedCustomer && self.selectedCustomer.metadata && self.selectedCustomer.metadata.integration;
      if (customerIntegration === 'bradesco-diti') {
        queryOptions['include'] = 'customersProductsServices';
        queryParams['customersProductsServices.customer_id'] = self.selectedCustomer.id;
        queryParams['customersProductsServices.integration'] = customerIntegration;
      }

      if (customerIntegration === 'corporate') {
        queryParams['integration'] = 'corporate/' + self.selectedCustomer.metadata.sammathnaur.account.uuid;
      }

      if (customerIntegration === 'bradesco-pat') {
        queryOptions['include'] = 'customersProductsServices';
        queryParams['customersProductsServices.customer_id'] = self.selectedCustomer.id;
        queryParams['customersProductsServices.integration'] = 'bradesco-pat';
      }

      var serviceSource = self.selectedService && self.selectedService.metadata && self.selectedService.metadata.source;
      if (serviceSource === 'dolguldur-2') {
        queryParams['metadata.eyeofsauron.service.id'] = self.selectedService.id;
      }

      productsServicesApi.search(queryParams, queryOptions).then(function (response) {
        self.allServices = UtilityFunctions.unionBy(response.items, self.currentlySelectedServices, 'id');

        _.forEach(self.allServices, function (service) {
          var accountValues = _.map(self.omieAccounts, 'value');
          var account = _.find(accountValues, { 'appId': service.externalAppId });
          var omieCustomerAccoutName = account ? account.name : null;
          service.omieAccount = omieCustomerAccoutName;
        });

        self.totalCount = response.totalItems;
        self.totalPages = Math.ceil(self.totalCount / self.limit);
        var input = {
          id: self.orderId,
          orderBy: 'name_desc',
          take: null,
          skip: 0,
          whereProductsServices: {
            nameContains: self.nameContains
          }
        };

        ordersApi.queryForOrderServices(input).then(function (servicesLinked) {
          var linkedServices = servicesLinked && servicesLinked.services && servicesLinked.services.items ? servicesLinked.services.items : [];
          var linkedServicesItems = linkedServices.map(function (linkedService) { return linkedService.item; });

          self.allServices = UtilityFunctions.mergeLinkedWithAll(self.allServices, linkedServicesItems);
          self.linkedServices = linkedServicesItems;
        }).finally(function () {
          self.isLoading = false;
        });

        self.allServicesSelected = _allServicesAreSelected(self.allServices);
      });
    }

    function parseValueToPrice(value) {
      return UtilityFunctions.parseValueToPrice(value);
    }

    function selectOrDeselectAllServices() {
      self.allServices.forEach(function (service) {
        var selectedServicesLength = self.linkedServices.length + self.currentlySelectedServices.length;
        var limitReached = selectedServicesLength >= self.maxLinkedServices;
        deselectService(service);

        !limitReached && self.allServicesSelected && !service.linked ? selectService(service) : deselectService(service);
      });
    }

    function selectService(service) {
      if (self.currentlySelectedServices.length < self.maxLinkedServices) {
        service.selected = true;
        self.currentlySelectedServices.push(service);
      }
    }

    function deselectService(service) {
      service.selected = false;
      self.currentlySelectedServices = _.reject(self.currentlySelectedServices, function (selectedService) {
        return selectedService.id === service.id;
      });
    }

    function saveSelectedServices() {
      self.currentlySelectedServices.forEach(function (service) {
        service.quantity = 1;
        orderServicesService.addService(service, self.orderId);
      });
      closeDialog(self.currentlySelectedServices);
    }

    function closeDialog(selectedServices) {
      $mdDialog.hide(selectedServices);
    }

    function getLastServiceCount() {
      return self.currentPage >= self.totalPages ? self.totalCount : self.currentPage * self.limit;
    }

    function _allServicesAreSelected(services) {
      var count = _.countBy(services, function (service) {
        return service.selected ? 'value' : null;
      });
      return count.value === self.limit;
    }

    function _initialize() {
      var deferred = $q.defer();

      omieApi.accounts.list()
      .then(function (res) {

        if (!res.data || !res.data.Items || !res.data.Items.length) {
          deferred.resolve([{
            value: {
            name: null,
            appId: null
          }
        }]);
          return;
        }


        var accounts = res.data.Items.map(function (item) {
          return {
            value: {
              name: item.accountName,
              appId: item.appId
            }
          };
        });

        deferred.resolve(accounts);
      })
      .catch(function (error) {
        deferred.reject(error);
      });

      deferred.promise.then(function (accounts) {
        self.omieAccounts = accounts;
      });

      searchServices(0);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('LinkProductsDialogController', LinkProductsDialogController);

  /** @ngInject */
  function LinkProductsDialogController(_, ordersApi, productsServicesApi, $q, UtilityFunctions, locals, $mdDialog, omieApi, orderProductsService, $rootScope, CurrencyService, productsServicesApiGraphQL) {
    var self = this;

    self.maxLinkedProducts = 150;
    self.limit = 10;
    self.offset = 0;
    self.currentPage = 1;
    self.totalPages = 0;
    self.totalCount = 0;
    self.skip = 0;

    self.allProducts = [];
    self.linkedProducts = [];
    self.currentlySelectedProducts = [];

    self.orderId = locals.order.id;
    self.selectedCustomer = locals.selectedCustomer;
    self.selectedService = locals.selectedService;

    self.isLoading = false;
    self.nameContains = '';
    self.allProductsSelected = false;
    self.currentShowedProducts = self.limit;

    self.navigateToPage = navigateToPage;
    self.selectProduct = selectProduct;
    self.deselectProduct = deselectProduct;
    self.searchProducts = searchProducts;
    self.selectOrDeselectAllProducts = selectOrDeselectAllProducts;
    self.parseValueToPrice = parseValueToPrice;
    self.saveSelectedProducts = saveSelectedProducts;
    self.closeDialog = closeDialog;
    self.getLastProductCount = getLastProductCount;

    _initialize();

    function navigateToPage(isNextPage) {
      self.currentPage = isNextPage ? self.currentPage + 1 : self.currentPage - 1;
      self.skip = isNextPage ? self.skip + 10 : self.skip - 10;
      self.currentShowedProducts = self.skip + 10;

      searchProducts(self.skip);
    }

    function searchProducts(skip) {
      self.isLoading = true;
      var queryParams = {
        archived: false,
        type: 'product'
      };

      var queryOptions = {
        skip: skip,
        limit: self.limit,
        orderBy: 'createdAt_desc'
      };

      if (self.nameContains !== '') {
        queryParams['nameContains'] = self.nameContains;
      }

      var customerIntegration = self.selectedCustomer && self.selectedCustomer.metadata && self.selectedCustomer.metadata.integration;
      if (customerIntegration === 'bradesco-diti') {
        queryParams['customersProductsServicesIntegration'] = 'bradesco-diti';
        queryParams['customerId'] = self.selectedCustomer.id;
      }

      if (customerIntegration === 'corporate') {
        queryParams['integration'] = 'corporate/' + self.selectedCustomer.metadata.sammathnaur.account.uuid;
      }

      if (customerIntegration === 'bradesco-pat') {
        queryParams['customersProductsServicesIntegration'] = 'bradesco-pat';
        queryParams['customerId'] = self.selectedCustomer.id;
      }

      var serviceSource = self.selectedService && self.selectedService.metadata && self.selectedService.metadata.source;
      if (serviceSource === 'dolguldur-2') {
        queryParams['serviceId'] = self.selectedService.id;
      }

      productsServicesApiGraphQL.searchProducts(queryParams, queryOptions).then(function (response) {
        self.allProducts = UtilityFunctions.unionBy(response.items, self.currentlySelectedProducts, 'id');

        _.forEach(self.allProducts, function (product) {
          var accountValues = _.map(self.omieAccounts, 'value');
          var account = _.find(accountValues, { 'appId': product.externalAppId });
          var omieCustomerAccountName = account ? account.name : null;
          product.omieAccount = omieCustomerAccountName;
        });

        self.totalCount = response.totalCount;
        self.totalPages = Math.ceil(self.totalCount / self.limit);
        var input = {
          id: self.orderId,
          orderBy: 'name_desc',
          take: null,
          skip: 0,
          whereProductsServices: {
            nameContains: self.nameContains
          }
        };

        ordersApi.queryForOrderProducts(input).then(function (productsLinked) {
          var linkedProducts = productsLinked && productsLinked.productsV2 && productsLinked.productsV2.items ? productsLinked.productsV2.items : [];
          var linkedProductsItems = linkedProducts.map(function (linkedService) { return linkedService.item; });

          self.allProducts = UtilityFunctions.mergeLinkedWithAll(self.allProducts, linkedProductsItems);
          self.linkedProducts = linkedProductsItems;
        }).finally(function () {
          self.isLoading = false;
        });

        self.allProductsSelected = _allProductsAreSelected(self.allProducts);
      });
    }

    function parseValueToPrice(value) {
      return UtilityFunctions.parseValueToPrice(value);
    }

    function selectOrDeselectAllProducts() {
      self.allProducts.forEach(function (product) {
        var selectedProductsLength = self.linkedProducts.length + self.currentlySelectedProducts.length;
        var limitReached = selectedProductsLength >= self.maxLinkedProducts;
        deselectProduct(product);

        !limitReached && self.allProductsSelected && !product.linked ? selectProduct(product) : deselectProduct(product);
      });
    }

    function selectProduct(product) {
      if (self.currentlySelectedProducts.length < self.maxLinkedProducts) {
        product.selected = true;
        self.currentlySelectedProducts.push(product);
      }
    }

    function deselectProduct(product) {
      product.selected = false;
      self.currentlySelectedProducts = _.reject(self.currentlySelectedProducts, function (selectedProduct) {
        return selectedProduct.id === product.id;
      });
    }

    function saveSelectedProducts() {
      self.currentlySelectedProducts.forEach(function (product) {
        product.quantity = 1;
        orderProductsService.addProduct(product, self.orderId);
      });
      closeDialog(self.currentlySelectedProducts);
    }

    function closeDialog(selectedProducts) {
      $mdDialog.hide(selectedProducts);
    }

    function getLastProductCount() {
      return self.currentPage >= self.totalPages ? self.totalCount : self.currentPage * self.limit;
    }

    function _allProductsAreSelected(products) {
      var count = _.countBy(products, function (product) {
        return product.selected ? 'value' : null;
      });
      return count.value === self.limit;
    }

    function _initialize() {
      var deferred = $q.defer();

      omieApi.accounts.list()
        .then(function (res) {

          if (!res.data || !res.data.Items || !res.data.Items.length) {
            deferred.resolve([{
              value: {
                name: null,
                appId: null
              }
            }]);
            return;
          }


          var accounts = res.data.Items.map(function (item) {
            return {
              value: {
                name: item.accountName,
                appId: item.appId
              }
            };
          });

          deferred.resolve(accounts);
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      deferred.promise.then(function (accounts) {
        self.omieAccounts = accounts;
      });

      searchProducts(0);
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('app.tasks')
  .controller('CreateOrEditPendencyDialogComponent', CreateOrEditPendencyDialogComponent);

  /** @ngInject */
  function CreateOrEditPendencyDialogComponent(
    $mdDialog, locals, $q, $timeout, ordersPendenciesApiGraphQL
  ) {
  var self = this;
  self.order = undefined;

  _initialize();

  function _initialize() {
    self.order = locals.order;
    _getContractor();

    $timeout(function () {
      var dialog = document.querySelector('#create-or-edit-pendency');

      dialog.addEventListener('closeDialogEvent', function (value) {
        $mdDialog.hide(value && value.detail);
      });
    });
  }

  function _getContractor() {
    var contractorIdFromFSM = self.order && self.order.metadata && self.order.metadata.contractor && self.order.metadata.contractor.id;
    var contractorIdFromCMMS = self.order && self.order.metadata && self.order.metadata.sammathnaur && self.order.metadata.sammathnaur.contractor && self.order.metadata.sammathnaur.contractor.id;

    var contractorId = contractorIdFromFSM || contractorIdFromCMMS;

    ordersPendenciesApiGraphQL.getContractor(contractorId).then(function (contractor) {
      self.order.contractor = {
        id: contractor.id,
        name: contractor.name,
        avatarUrl: contractor.logoUrl
      };
    });
  }
}})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('ConfirmDeleteProductServiceDialogController', ConfirmDeleteProductServiceDialogController);

  /** @ngInject */
  function ConfirmDeleteProductServiceDialogController(_, locals, $mdDialog) {

    var vm = this;
    vm.closeDialog = closeDialog;
    vm.translationTag = locals.product ? 'PRODUCTS' : 'SERVICES';
    vm.productServiceName = locals.product ? locals.product.item.name : locals.service.item.name;

    function closeDialog(shouldRemove) {
      $mdDialog.hide(shouldRemove);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('AddEquipmentsDialogController', AddEquipmentsDialogController);

  /** @ngInject */
  function AddEquipmentsDialogController(
    locals, $mdDialog, _, equipmentsApiGraphQL, attachmentsUtils, OrderDialog
  ) {
    var vm = this;
    vm.selectedCustomer = locals.selectedCustomer;
    vm.selectedEquipments = locals.selectedEquipments;
    vm.currentlySelectedEquipments = [];
    vm.orderId = locals.order.id;
    vm.locationId = locals.locationId;
    vm.selectedEquipmentText = '';
    vm.equipmentOptions = [];
    vm.equipmentsPaginateBy = 10;
    vm.equipmentsPage = 1;
    vm.equipmentsSkip = 0;
    vm.totalCount = 0;
    vm.allEquipmentsSelected = false;
    vm.maxEquipmentPerTask = 150;
    vm.disableButton = false;

    vm.closeDialog = closeDialog;
    function closeDialog() {
      $mdDialog.hide();
    }

    vm.searchEquipments = _.debounce(searchEquipments, 800);
    function searchEquipments(setTotalCount) {
      var primaryLocation = locals.order.customer.primaryLocation;

      if (!primaryLocation) {
        primaryLocation = locals.selectedCustomer.primaryLocation;
      }

      var query = {
        where: {
          archived: false,
          customerIds: vm.selectedCustomer.id,
          locationIds: [vm.locationId || primaryLocation.id, null],
          nameOrNumberContains: vm.selectedEquipmentText
        },
        take: vm.equipmentsPaginateBy,
        skip: vm.equipmentsSkip
      };

      equipmentsApiGraphQL.search(query).then(function (result) {
        var equipments = _.map(result.items, function (equipment) {
          if (_.some(vm.selectedEquipments, function (item) { return item.id === equipment.id; })) {
            equipment.linked = true;
          } else {
            equipment.linked = false;
          }
          equipment.selected = false;
          equipment.thumbnail = attachmentsUtils.correctUrl(equipment.imageUrl);
          return equipment;
        });

        vm.currentlySelectedEquipments = _.union(
          vm.currentlySelectedEquipments,
          _.filter(vm.equipmentOptions, function (equipment) {
            return equipment.selected === true;
          })
        );

        vm.equipmentOptions = _.map(equipments, function (equipment) {
          return _.find(vm.currentlySelectedEquipments, function (selectedEquipment) {
            return selectedEquipment.id === equipment.id;
          }) || equipment;
        });

        if (setTotalCount) {
          setTotalCount(result.totalCount);
        }
      });
    }

    vm.saveEquipments = saveEquipments;
    function saveEquipments() {
      locals.order.equipments = _.map(vm.currentlySelectedEquipments, function (equipment) {
        delete equipment.selected;
        return equipment;
      });

      if (!vm.orderId) {
        return $mdDialog.hide();
      }

      vm.disableButton = true;

      return OrderDialog.linkEquipments(vm.currentlySelectedEquipments, vm.orderId).then(function () {
        $mdDialog.hide();
      }).finally(function () {
        var equipEvent = new CustomEvent('reloadFormsEquipmentsEvent');
        document.dispatchEvent(equipEvent);
        vm.disableButton = false;
      });
    }

    vm.selectEquipment = selectEquipment;
    function selectEquipment(equipment) {
      vm.currentlySelectedEquipments.push(equipment);
    }

    vm.deselectEquipment = deselectEquipment;
    function deselectEquipment(equipment) {
      vm.currentlySelectedEquipments = _.reject(vm.currentlySelectedEquipments, function (selectedEquipment) {
        return selectedEquipment.id === equipment.id;
      });
    }

    vm.navigateToPage = navigateToPage;
    function navigateToPage(pageNumber, setTotalCount) {
      vm.equipmentsPage = pageNumber;
      vm.equipmentsSkip = (vm.equipmentsPage - 1) * vm.equipmentsPaginateBy;
      searchEquipments(setTotalCount);
      vm.allEquipmentsSelected = false;
    }

    vm.selectAllEquipments = selectAllEquipments;
    function selectAllEquipments() {
      if (vm.allEquipmentsSelected) {
        _.forEach(vm.equipmentOptions, function (equipment) {
          if (!equipment.linked && equipment.selected === false) {
            selectEquipment(equipment);
            equipment.selected = true;
          }
        });
      } else {
        _.forEach(vm.equipmentOptions, function (equipment) {
          if (!equipment.linked && equipment.selected === true) {
            deselectEquipment(equipment);
            equipment.selected = false;
          }
        });
      }
    }

    vm.getLastEquipmentCount = getLastEquipmentCount;
    function getLastEquipmentCount() {
      return vm.equipmentsPage * vm.equipmentsPaginateBy;
    }

    function _initializeDialog() {
      navigateToPage(1, function (totalCount) {
        vm.totalCount = totalCount;
      });
    }

    _initializeDialog();

    return vm;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.subscription', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.subscription', {
      url: '/configuracoes/assinatura',
      views: {
        'content@app': {
          templateUrl: 'app/main/subscription/subscription.html',
          controller: 'SubscriptionController as vm'
        }
      },
      data: { titleTranslateKey: 'SUBSCRIPTION.PAGE_TITLE' },
      resolve: {
        Data: function ($q, ereborApi, accountsApi) {
          var requests = {
            account: accountsApi.get(),
            subscription: ereborApi.getCurrentSubscription(),
            pendingRenewal: ereborApi.getPendingSubscriptionRenewal(),
            subscriptionRenewalItems: ereborApi.getSubscriptionRenewalItems(),
          };

          return $q.all(requests);
        }
      }
    });

    $translatePartialLoaderProvider.addPart('app/main/subscription');
  }
})();

(function () {
  'use strict';

  angular
    .module('app.subscription')
    .directive('storageUpgradeSidenav', storageUpgradeSidenav);

  /** @ngInject */
  function storageUpgradeSidenav() {
    return {
      restrict: 'E',
      scope: {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/subscription/sidenavs/storage-upgrade/storage-upgrade.html',
      controller: 'StorageUpgradeSidenavController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.subscription')
    .controller('StorageUpgradeSidenavController', StorageUpgradeSidenavController);

  function StorageUpgradeSidenavController($mdSidenav, $mdToast, $translate) {
    var vm = this;

    vm.requestUpgrade = requestUpgrade;

    function requestUpgrade() {
      $mdSidenav('storage-upgrade-sidenav').close().then(function () {
        vm.requestDate = null;
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('ACCOUNT_PLAN.TOAST.SUCCESS'))
            .hideDelay(2000)
        );
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.subscription')
    .directive('renewalSidenav', renewalSidenav);

  /** @ngInject */
  function renewalSidenav() {
    return {
      restrict: 'E',
      scope: {
        subscription: '=',
        features: '=',
        renewal: '='
      },
      templateUrl: 'app/main/subscription/sidenavs/renewal/renewal.html',
      controller: 'RenewalSidenavController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.subscription')
    .controller('RenewalSidenavController', RenewalSidenavController);

  function RenewalSidenavController($scope, $window, $mdSidenav, $mdToast, $translate, SubscriptionService) {
    var vm = this;
    var subscriptionValidatorMapper = {
      hasSubscriptionRenewAt: $scope.subscription && $scope.subscription.renewAt,
      hasSubscriptionType: $scope.subscription && $scope.subscription.type,
      hasSubscriptionStatus: $scope.subscription && $scope.subscription.status
    };
      vm.subscription = {
        renewAt: subscriptionValidatorMapper.hasSubscriptionRenewAt ? moment($scope.subscription.renewAt).format('DD/MM/YYYY') : null,
        type: subscriptionValidatorMapper.hasSubscriptionType ? $scope.subscription.type : null,
        status: subscriptionValidatorMapper.status ? $scope.subscription.status : null,
        termsChecked: false,
      };
    vm.features = $scope.features;
    if ($scope.renewal && $scope.renewal.invoice) {
      vm.invoice = $scope.renewal.invoice;
    }
    vm.renewSubscription = renewSubscription;
    vm.numberToCurrency = SubscriptionService.numberToCurrency;
    vm.openInvoice = openInvoice;
    vm.close = close;

    function openInvoice() {
      if (!vm.invoice || !vm.invoice.url) { return; }
      $window.open(vm.invoice.url, '_blank');
    }

    function renewSubscription() {
      SubscriptionService.renewSubscription()
        .then(function (renewal) {
          if (!renewal) {
            return showErrorToast('SUBSCRIPTION.TOAST.FAIL');
          }

          vm.invoice = renewal.invoice;
          openInvoice();
        })
        .catch(function () {
          showErrorToast('SUBSCRIPTION.TOAST.FAIL');
        });
    }

    function close(callback) {
      $mdSidenav('renewal-sidenav').close().then(callback);
    }

    function showErrorToast(translationKey) {
      $mdToast.show(
        $mdToast.simple()
          .textContent($translate.instant(translationKey))
          .hideDelay(3000)
          .theme('error-toast')
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.subscription')
    .directive('employeesUpgradeSidenav', employeesUpgradeSidenav);

  /** @ngInject */
  function employeesUpgradeSidenav() {
    return {
      restrict: 'E',
      scope: {
        feature: '='
      },
      templateUrl: 'app/main/subscription/sidenavs/employees-upgrade/employees-upgrade.html',
      controller: 'EmployeesUpgradeSidenavController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.subscription')
    .controller('EmployeesUpgradeSidenavController', EmployeesUpgradeSidenavController);

  function EmployeesUpgradeSidenavController($scope, $mdSidenav, $mdDialog, $mdToast, $translate, SubscriptionService) {
    var vm = this;
    if ($scope.feature && $scope.feature.quantity) {
      vm.currentLicensesQuantity = $scope.feature.quantity;
    }
    vm.increaseNumber = 1;

    vm.requestUpgrade = requestUpgrade;

    function requestUpgrade() {
      var confirmRequestActivationDialog = $mdDialog.confirm()
        .title($translate.instant('SUBSCRIPTION.SIDENAVS.EMPLOYEES.DIALOG.TITLE'))
        .htmlContent($translate.instant('SUBSCRIPTION.SIDENAVS.EMPLOYEES.DIALOG.DESCRIPTION'))
        .ok($translate.instant('SUBSCRIPTION.SIDENAVS.EMPLOYEES.DIALOG.CONFIRM'))
        .cancel($translate.instant('SUBSCRIPTION.SIDENAVS.EMPLOYEES.DIALOG.CANCEL'))
        .clickOutsideToClose(true);

      if (confirmRequestActivationDialog) {
        $mdDialog.show(confirmRequestActivationDialog).then(function () {
          SubscriptionService.requestEmployeesUpgrade(vm.increaseNumber).then(function (ok) {
            _closeSidenav(function () {
              ok ? _showToast('SUBSCRIPTION.SIDENAVS.EMPLOYEES.TOAST.SUCCESS') :
                _showToast('SUBSCRIPTION.SIDENAVS.EMPLOYEES.TOAST.FAIL', { error: true });
            });
          }).catch(function () {
            _closeSidenav(function () {
              _showToast('SUBSCRIPTION.SIDENAVS.EMPLOYEES.TOAST.FAIL', { error: true });
            });
          });
        });
      }
    }

    function _closeSidenav(callback) {
      vm.increaseNumber = 1;
      $mdSidenav('employees-upgrade-sidenav').close().then(callback);
    }

    function _showToast(msg, options) {
      var toast = $mdToast.simple()
        .textContent($translate.instant(msg))
        .hideDelay(4000);

      if (options && options.error) {
        toast.theme('error-toast');
      }

      $mdToast.show(toast);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.subscription')
    .directive('dueDateSidenav', dueDateSidenav);

  /** @ngInject */
  function dueDateSidenav() {
    return {
      restrict: 'E',
      scope: {
        subscription: '=',
        renewal: '='
      },
      templateUrl: 'app/main/subscription/sidenavs/due-date/due-date.html',
      controller: 'DueDateSidenavController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.subscription')
    .controller('DueDateSidenavController', DueDateSidenavController);

  function DueDateSidenavController($scope, $mdSidenav, $mdToast, $translate, moment, _, SubscriptionService) {
    var vm = this;
    var primaryEmail = null;

    _initialize();

    vm.addEmail = _.debounce(addEmail, vm.formDebounceTime);
    vm.removeEmail = removeEmail;
    vm.updateEmails = updateEmails;
    vm.setPrimaryEmail = setPrimaryEmail;
    vm.handleKeyDown = handleKeyDown;
    vm.validateForm = validateForm;
    vm.updateChart = updateChart;

    function _initialize() {
      var subscriptionValidatorMapper = {
        hasSubscriptionId: $scope.subscription && $scope.subscription.id,
        hasSubscriptionEmails: $scope.subscription && $scope.subscription.emails,
        hasSubscriptionRenewAt: $scope.subscription && $scope.subscription.renewAt
      };

      vm.subscription = {
        id: subscriptionValidatorMapper.hasSubscriptionId ? $scope.subscription.id : null,
        emails: subscriptionValidatorMapper.hasSubscriptionEmails ? angular.copy($scope.subscription.emails) : null,
        renewAt: subscriptionValidatorMapper.hasSubscriptionRenewAt ? moment($scope.subscription.renewAt).format('DD/MM/YYYY') : null
      };

      vm.renewal = $scope.renewal;
      vm.email = '';
      vm.max = 5;
      vm.formDebounceTime = 500;
      if (vm.subscription && vm.subscription.emails) {
        primaryEmail = _.find(vm.subscription.emails, 'primary');
      }
    }

    function updateChart() {
      if (vm.subscription && vm.subscription.emails) {
        return (vm.subscription.emails.length / vm.max) * 100;
      }
    }

    function handleKeyDown(event, form) {
      if (event.keyCode === 13) {
        addEmail(form);
      }
    }

    function addEmail(form) {
      if (form.$invalid) { return; }

      vm.subscription.emails.push({
        address: vm.email,
        primary: false
      });
      vm.email = '';
      _sortEmails();
    }

    function validateForm(form) {
      if (form.email !== '' && vm.subscription.emails.length === vm.max) {
        form.email.$setValidity('maxItems', false);
      } else {
        form.email.$setValidity('maxItems', true);
      }

      var duplicated = _.find(vm.subscription.emails, function (email) {
        return vm.email === email.address;
      });

      if (duplicated) {
        form.email.$setValidity('duplicated', false);
      } else {
        form.email.$setValidity('duplicated', true);
      }

      if (form.email.$valid && form.$invalid) {
        form.email.$setValidity('item', false);
      } else {
        form.email.$setValidity('item', true);
      }
    }

    function removeEmail(form, index) {
      var removedEmail = vm.subscription.emails.splice(index, 1)[0];
      if (removedEmail.primary) {
        setPrimaryEmail(form, vm.subscription.emails[0]);
      }
      form.$setDirty();
    }

    function _sortEmails() {
      vm.subscription.emails = _.sortBy(vm.subscription.emails, 'address');
    }

    function setPrimaryEmail(form, email) {
      primaryEmail.primary = false;
      email.primary = true;
      primaryEmail = email;
      form.$setDirty();
    }

    function _showToast(msg, options) {
      var toast = $mdToast.simple()
        .textContent($translate.instant(msg))
        .hideDelay(4000);

      if (options && options.error) {
        toast.theme('error-toast');
      }

      $mdToast.show(toast);
    }

    function updateEmails() {
      SubscriptionService.updateEmails(vm.subscription)
        .then(function (subscription) {
          if (!subscription) {
            return _showToast('SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.TOAST.FAIL', { error: true });
          }
          _showToast('SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.TOAST.SUCCESS');
          $mdSidenav('due-date-sidenav').close();
        }).catch(function () {
          _showToast('SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.TOAST.FAIL', { error: true });
        });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .factory('LabelDialog', LabelDialog);

    /** @ngInject */
    function LabelDialog($mdDialog, $rootScope, absencesApi, $document) {

        return {
            removeLabel: removeLabel
        };

        function removeLabel(ev, label, callback) {
            _openLabelDialog(ev, { Label: label }, callback);
        }

        function _openLabelDialog(ev, locals, callback) {

            $mdDialog.show({
                controller: 'LabelDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/settings/dialogs/labels/label-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: locals
            }).then(callback);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('LabelDialogController', LabelDialogController);

    /** @ngInject */
    function LabelDialogController(Label, $rootScope, labelsApi, MessageDialog, $mdDialog, $translate) {

        var vm = this;
        vm.label = Label;
        vm.deleteLabel = deleteLabel;
        vm.closeDialog = closeDialog;
        function deleteLabel() {
            $rootScope.loadingProgress = true;

            labelsApi.delete(vm.label.id).then(function () {
                MessageDialog.showToast({
                    message: $translate.instant("CONFIGURATIONS.DIALOGS.LABELS.SUCCESSFULLY_DELETED", {
                        name: vm.label.name
                    })
                });
            }).catch(function () {
                MessageDialog.showToast({
                    message: $translate.instant("CONFIGURATIONS.DIALOGS.LABELS.COULD_NOT_DELETE", {
                        name: vm.label.name
                    })
                });
            }).finally(function () {
                $rootScope.loadingProgress = false;
                closeDialog(true);
            });
        }

        function closeDialog(reload) {
            $mdDialog.hide(reload);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.settings')
    .controller('LabelsManagerController', LabelsManagerController);

  /** @ngInject */
  function LabelsManagerController($scope, $translate, $rootScope, Labels, labelsApi, dataTableOptions,
    DTColumnBuilder, _, LabelDialog, $compile, $window, LocalDateConvert) {
    var vm = this;
    vm.labels = Labels.items;
    vm.reload = _.debounce(loadLabels, 1000);
    vm.confirmDeleteLabel = confirmDeleteLabel;
    vm.goToList = goToList;

    function initialize() {
      startDataTable();
    }

    function loadLabels(resetPaging) {
      if (!resetPaging) {
        resetPaging = false;
      }
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function goToList(type, labelId) {
      var map = {
        customers: 'clientes',
        orders: 'atividades',
        quotations: 'orcamentos',
        equipments: 'equipamentos'
      };

      var path = '#/' + map[type] + '?q=etiqueta:' + labelId;

      if (type === 'orders') {
        path += encodeURIComponent(' data_agendamento>:2017-01-01');
      }

      $window.open(path, '_blank');
    }


    function confirmDeleteLabel(ev, label) {
      LabelDialog.removeLabel(ev, label, function (reload) {
        if (reload) {
          loadLabels();
        }
      });
    }

    $scope.$on('labels:reload', function () {
      loadLabels();
    });

    function startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;
      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.columnDefs.push({
          targets: 2,
          filtered: false,
          sortable: false,
          width: 100
        });

        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var sort = 'name';

          if (aoData[2].value && aoData[2].value[0]) {
            var columnDir = aoData[2].value[0];
            if (columnDir.dir === 'desc') {
              sort = '-' + sort;
            }
          }

          var queryOptions = {
            offset: aoData[3].value,
            limit: aoData[4].value,
            sort: sort
          };

          labelsApi.search({ type: 'equipments,orders,customers,quotations' }, queryOptions).then(function (result) {
            vm.labels = result.items;
            fnCallback({
              'draw': aoData[0].value,
              'recordsTotal': result.totalItems,
              'recordsFiltered': result.totalItems,
              'data': result.items
            });

            $rootScope.loadingProgress = false;
          });
        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.pageLength = 25;
        config.buttons = [];
        config.order = [1, 'asc'];
      });

      vm.dtColumns = _getDtColumns();
      vm.dtInstanceCallback = function (_dtInstance) {
        _fixTableHeaders();
        vm.dtInstance = _dtInstance;
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
        });
      };
    }

    function _fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });
    }

    function _getDtColumns() {

      var colorColumn = DTColumnBuilder.newColumn(null, '')
        .renderWith(function (data) {
          return '<md-icon md-font-icon="icon-label" class="' + data.color + '-500-fg fs-16"></md-icon>';
        })
        .withOption('width', '5%')
        .notSortable();

      var nameColumn = DTColumnBuilder.newColumn(null, $translate.instant('CONFIGURATIONS.LABELS_MANAGER.NAME'))
        .renderWith(function (data) {
          return data.name;
        })
        .withOption('width', '30%');
      nameColumn.sortBy = 'name';

      var typeColumn = DTColumnBuilder.newColumn(null, $translate.instant('CONFIGURATIONS.LABELS_MANAGER.TYPE'))
        .renderWith(function (data) {
          return $translate.instant('CONFIGURATIONS.LABELS_MANAGER.' + data.type.toUpperCase());
        })
        .withOption('width', '25%')
        .notSortable();

      var gotoColumn = DTColumnBuilder.newColumn(null, '')
        .renderWith(function (data) {
          var templateHtml = '';
          templateHtml += '<span data-cy="go-to-list-button" class="link ng-binding" ng-click="vm.goToList(\'' + data.type + '\', \'' + data.id + '\')" role="button"><span class="ng-scope">';
          templateHtml += $translate.instant('CONFIGURATIONS.LABELS_MANAGER.LIST_OF') + ' ';
          templateHtml += $translate.instant('CONFIGURATIONS.LABELS_MANAGER.' + data.type.toUpperCase()).toLowerCase();
          templateHtml += '</span>';
          templateHtml += '</span>';
          return templateHtml;
        })
        .notSortable();

      var createdAtColumn = DTColumnBuilder.newColumn(null, $translate.instant('CONFIGURATIONS.LABELS_MANAGER.CREATED_AT'))
        .renderWith(function (data) {
          return data.createdAt ? LocalDateConvert.formatDate(data.createdAt,'date') : null;
        })
        .notSortable();

      var actionsColumn = DTColumnBuilder.newColumn(null, $translate.instant('CONFIGURATIONS.LABELS_MANAGER.ACTIONS'))
        .renderWith(function (data) {
          var templateHtml = '';
          templateHtml += '<md-button data-cy="delete-button" ng-click="vm.confirmDeleteLabel($event, { id: \'' + data.id + '\', name: \'' + data.name + '\' })" class="md-icon-button">';
          templateHtml += '<md-icon md-font-icon="icon-trash"></md-icon>';
          templateHtml += '<md-tooltip md-direction="left"><span>';
          templateHtml += $translate.instant('CONFIGURATIONS.LABELS_MANAGER.DELETE_LABEL');
          templateHtml += '</span></md-tooltip></md-button>';
          return templateHtml;
        })
        .notSortable();

      return [
        colorColumn,
        nameColumn,
        typeColumn,
        gotoColumn,
        createdAtColumn,
        actionsColumn,
      ];
    }

    initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings')
    .controller('IntegrationsController', IntegrationsController);

  /** @ngInject */
  function IntegrationsController(
    $scope, $mdToast, $window, $translate, $timeout, $document, $mdDialog, msUtils,
    Account, IntegrationsService, EnvironmentConfig, OmieConfigurationDialog, FcModalService
  ) {

    var vm = this;
    vm.account = angular.copy(Account);
    vm.integrations = {};

    var state = msUtils.uuidGenerator();
    var redirectUri = EnvironmentConfig.contaAzul.redirectUri;
    var clientId = EnvironmentConfig.contaAzul.clientId;
    vm.contaAzulUrl = 'https://auth.contaazul.com/oauth2/authorize?response_type=code&client_id=' + clientId + '&redirect_uri=' + redirectUri + '&state=' + state + '&scope=openid+profile+aws.cognito.signin.user.admin';
    vm.manageContaAzul = manageContaAzul;
    vm.manageOmie = manageOmie;

    IntegrationsService.initialize();
    $scope.$on('integrations:updated', function () {
      _initialize();
    });

    function _initialize() {
      var integrations = IntegrationsService.getAll();

      vm.integrations = {
        'omie': {
          controller: 'OmieAppController',
          templateUrl: 'app/main/settings/contents/integrations/apps/omie/omie.html',
          isEnable: integrations.omie,
          isPaid: true
        },
        'conta-azul': {
          controller: 'ContaAzulAppController',
          templateUrl: 'app/main/settings/contents/integrations/apps/conta-azul/conta-azul.html',
          isEnable: integrations.contaAzul,
          isPaid: true
        }
      };
    }

    function manageContaAzul($event) {
      if (!vm.integrations['conta-azul'] || !vm.integrations['conta-azul'].isEnable) {
        return openContaAzulConfirmDialog($event);;
      }

      _openDialog($event, vm.integrations['conta-azul']);
    }

    function manageOmie($event) {
      if (!vm.integrations['omie'] || !vm.integrations['omie'].isEnable) {
        _openDialog($event, vm.integrations['omie'], true);
        return;
      }

      _openDialog($event, vm.integrations['omie'], false);
    }

    function openContaAzulConfirmDialog($event) {
      FcModalService.open($event, {
        title: $translate.instant('APPS.CONTA_AZUL.CONFIRM_DIALOG.TITLE'),
        content: $translate.instant('APPS.CONTA_AZUL.CONFIRM_DIALOG.CONTENT'),
        paddingSmall: true,
        leftButtonText: $translate.instant('APPS.CONTA_AZUL.CONFIRM_DIALOG.NO'),
        rightButtonText: $translate.instant('APPS.CONTA_AZUL.CONFIRM_DIALOG.CONTINUE'),
        handleRightButton: function () {
          $window.open(vm.contaAzulUrl, '_parent');
        }
      });
    }

    function _openDialog(ev, integration, newIntegration) {
      $mdDialog.show({
        controller: integration.controller,
        controllerAs: 'vm',
        templateUrl: integration.templateUrl,
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Account: vm.account,
          Configuration: integration,
          newIntegration: newIntegration
        },
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8,
        },
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings')
    .controller('AccountInfoController', AccountInfoController);

  /** @ngInject */
  function AccountInfoController(
    _, Account, timeZone, focus, geoCoder, cepDbApi,
    autocompleteAddressService, uploadApi, accountsApi,
    $mdToast, $mdDialog, $timeout, $scope, $window, $document, $translate, $filter,
    msUtils, locationsService, CurrencyService, FcModalService
  ) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.countries = [];
    vm.countryCodes = [];
    vm.timezones = timeZone.items;
    vm.currencies = CurrencyService.items;
    vm.currencyCode = CurrencyService.pickCurrentCode();
    vm.openAlertModal = openAlertModal;
    vm.isSelectedCountryBrasil = false;
    vm.countrySearchTerm = '';
    vm.hasAccountAddress = true;
    vm.selectedAccountAddress = null;
    vm.selectedAccountAddressText = '';
    vm.addressService = autocompleteAddressService;
    vm.formErr = {};
    vm.geocodingAddress = false;
    vm.avatarResultImage = null;
    vm.currentUnixTime = new Date().getTime();
    vm.disableSaveButton = false;
    vm.minImageResolution = 512;
    vm.searchTerm = '';

    vm.handleTimezoneCountryFlagsAndAddress = handleTimezoneCountryFlagsAndAddress;
    vm.clearCountrySearchTerm = clearCountrySearchTerm;
    vm.clearSelectedAccountAddress = clearSelectedAccountAddress;
    vm.addressChanged = addressChanged;
    vm.cepDb = cepDb;
    vm.geoCoderAddress = _.debounce(geoCoderAddress, 500);
    vm.useLocalPicture = useLocalPicture;
    vm.saveAccount = saveAccount;
    vm.clearSearchTerm = clearSearchTerm;
    vm.isSearching = false;

    $scope.$watchCollection('vm.account.address', function (newValue, oldValue) {
      if (newValue !== oldValue) {
        vm.account.address.formattedAddress = msUtils.formatAddress(vm.account.address);
      }
    });

    _initialize();

    function _initialize() {
      vm.addressService.setModel(vm.account.address);
      _initFlags();
      _initTimezonesAndCountries();
      _initCountryCodes();
      _initFileUploadBehavior();

      $timeout(function () {
        if ($scope.companyForm && $scope.companyForm.$invalid) {
          _.forEach($scope.companyForm, function (field, key) {
            if (key[0] !== '$' && field && field.$setTouched && field.$setDirty) {
              field.$setTouched();
              field.$setDirty();
            }
          });
        }
      });
    }

    function _initFlags() {
      if (vm.account.address.countryCode === 'BRA') {
        vm.isSelectedCountryBrasil = true;
      }
    }

    function _initTimezonesAndCountries() {
      if (!vm.timezones[0].name.includes('GMT')) {
        vm.timezones.forEach(function (tz) {
          tz.gmt = moment.tz(tz.id)._offset / 60;
          tz.name = tz.name + ' (GMT' + tz.gmt + ')';
        });
      }

      if (!vm.countries.length) {
        vm.timezones.forEach(function (tz) {
          vm.countries.push({
            code: tz.countryCode,
            name: tz.countryName,
          });
        });

        vm.countries = _.uniq(vm.countries, function (country) {
          return country.code;
        });
      }

      if (vm.account.address.countryCode) {
        vm.countrySearchTerm = _.filter(vm.countries, function (country) {
          return vm.account.address.countryCode === country.code;
        });

        vm.timezones = _.filter(timeZone.items, function (timezone) {
          return timezone.countryCode === vm.account.address.countryCode;
        });

        vm.timezones = _.sortBy(vm.timezones, function (timezone) {
          return timezone.gmt;
        }).reverse();
      }
    }

    function _initCountryCodes(){
      if (!vm.countryCodes.length) {
        vm.countryCodes = locationsService.countryCodes;
      }
    }

    function _initFileUploadBehavior() {
      $timeout(function () {
        var fileInput = document.querySelector('#file-avatar-company-input');
        var fileInputElement = angular.element(fileInput);

        fileInputElement.on('click', function () {
          fileInputElement.val(null);
        });

        fileInputElement.on('change', function (evt) {
          var file = evt.currentTarget.files[0];
          var reader = new FileReader();

          reader.onloadend = function (evt) {
            var image = new Image();
            image.src = evt.target.result;

            image.onload = function () {
              if (image.width < vm.minImageResolution || image.height < vm.minImageResolution) {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent($translate.instant("CONFIGURATIONS.ACCOUNT.MIN_IMAGE_SIZE_REQUIRED", {
                      minImageResolution: vm.minImageResolution
                    }))
                    .hideDelay(3000)
                );

                return;
              }

              _openResizeImageDialog({
                avatarImage: evt.target.result,
                minImageResolution: vm.minImageResolution
              }, function (result) {
                if (result) {
                  vm.avatarResultImage = result;

                  if ($scope.companyForm) {
                    $scope.companyForm.$setDirty();
                  }
                }

                vm.disableSaveButton = false;
              });
            };
          };

          reader.readAsDataURL(file);
        });
      }, 1000);
    }

    function updateAccountAndSaveConfiguration() {
      if (!vm.account.contact.webSite) {
        vm.account.contact.webSite = null;
      }

      return accountsApi.patch(vm.account)
        .then(function () {
          vm.account.configuration.currencySymbol = CurrencyService.getCurrencySymbol(vm.currencyCode);
          return accountsApi.saveConfigurations(vm.account.configuration);
        })
        .then(function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent($translate.instant("CONFIGURATIONS.ACCOUNT_SETTINGS_SAVED"))
              .hideDelay(3000)
          );

          $timeout(function () {
            $window.location.reload(true);
          }, 2000);

          return true;
        })
        .catch(function (error) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent($translate.instant('CONFIGURATIONS.ERRORS.SAVE_ERROR'))
              .theme('error-toast')
              .hideDelay(2000)
          );

          vm.disableSaveButton = false;

          return false;
        });
    }

    function clearSearchTerm() {
      vm.searchTerm = '';
    };

    function _openResizeImageDialog(locals, callback) {
      $mdDialog.show({
        controller: 'ResizeLogoDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/settings/contents/account-info/dialogs/resize-logo-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: false,
        locals: locals
      }).then(callback);
    }

    function openAlertModal($event) {
      FcModalService.open($event, {
        title: $translate.instant('CONFIGURATIONS.ACCOUNT.CURRENCY.TITLE'),
        content: $translate.instant('CONFIGURATIONS.ACCOUNT.CURRENCY.DESCRIPTION'),
        rightButtonText: 'Ok',
        handleRightButton: function () {},
      });
    }

    function handleTimezoneCountryFlagsAndAddress() {
      vm.timezones = _.filter(timeZone.items, function (timezone) {
        return timezone.countryCode === vm.account.address.countryCode;
      });

      vm.timezones = _.sortBy(vm.timezones, function (timezone) {
        return timezone.gmt;
      }).reverse();

      if (vm.account.address.countryCode !== 'BRA') {
          vm.isSelectedCountryBrasil = false;

          vm.countrySearchTerm = _.filter(vm.countries, function (country) {
            return vm.account.address.countryCode === country.code;
          });

          vm.timezones.forEach(function (timezone) {
            if (timezone.default) {
              vm.account.timezone = timezone.id;
            }
          });
      } else {
        vm.account.timezone = 'America/Sao_Paulo';
        vm.isSelectedCountryBrasil = true;
        vm.countrySearchTerm = '';
      }

      clearSelectedAccountAddress();
    }

    function clearCountrySearchTerm() {
      vm.countrySearchTerm = '';
    }

    function clearSelectedAccountAddress() {
      vm.hasAccountAddress = false;
      vm.selectedAccountAddress = null;
      vm.selectedAccountAddressText = '';

      vm.account.address.zipCode = null;
      vm.account.address.street = null;
      vm.account.address.city = null;
      vm.account.address.state = null;
      vm.account.address.number = null;
      vm.account.address.coords.latitude = null;
      vm.account.address.coords.longitude = null;
      vm.account.address.formattedAddress = null;

      $timeout(function () {
        focus('auto-complete-address');
      }, 200);
    }

    function addressChanged() {
      vm.addressService.selectedAddressItemChange(vm.selectedAccountAddress, $scope.accountForm, vm.formErr);

      if (vm.selectedAccountAddress) {
        vm.hasAccountAddress = true;
      }
    }

    function cepDb() {
      vm.isSearching = true;
      if (!vm.account.address.zipCode) {
        vm.account.address.street = '';
        vm.account.address.city = '';
        vm.account.address.state = '';
        vm.account.address.number = '';
      } else {
        var cep = vm.account.address.zipCode.replace(/\D/g, '');

        cepDbApi.search({
          'zipCode': cep
        }).then(function (data) {
          vm.account.address.street = '';
          vm.account.address.city = '';
          vm.account.address.state = '';

          if (data) {
            vm.account.address.street = data.logradouro;
            vm.account.address.city = data.cidade;
            vm.account.address.state = data.estado;
          }
          geoCoderAddress();
        }).finally(function () {
          vm.isSearching = false;
        });
      }
    }

    function geoCoderAddress() {
      vm.geocodingAddress = true;

      geoCoder.getByAddressObject(vm.account.address).then(function (location) {
        if (location) {
          vm.account.address.coords.latitude = location.lat;
          vm.account.address.coords.longitude = location.lng;
        } else {
          vm.account.latitude = null;
          vm.account.longitude = null;
        }
      }).catch(function () {
        $mdToast.show(
            $mdToast.simple().textContent(
                $translate.instant("CONFIGURATIONS.ERRORS.ERROR_FETCHING_ADDRESS")
            ).hideDelay(3000)
        );
      }).finally(function () {
          vm.geocodingAddress = false;
      });
    }

    function useLocalPicture() {
      _.defer(function () {
        $scope.$apply(function () {
          document.getElementById('file-avatar-company-input').click();
        });
      });
    }

    function saveAccount() {
      vm.disableSaveButton = true;

      if (vm.avatarResultImage) {
        uploadApi.uploadWithPassthrough({
          filename: 'company-logo.png',
          imageBase64Encoded: vm.avatarResultImage
        }).then(function (uploadedFile) {
          vm.account.logoUrl = uploadedFile.data.key;
        }).catch(function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent($translate.instant("CONFIGURATIONS.ERRORS.SAVE_IMAGE")).hideDelay(2000)
          );
        }).finally(function () {
          updateAccountAndSaveConfiguration();
        });
      } else {
        updateAccountAndSaveConfiguration();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.customers', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {

    $stateProvider.state('app.customers', {
      url: '/clientes',
      views: {
        'content@app': {
          templateUrl: 'app/main/customers/customers.html',
          controller: 'CustomersController as vm'
        }
      },
      data: { titleTranslateKey: 'CUSTOMERS.PAGE_TITLE' },
      resolve: {
        account: function (accountsApi) {
          return accountsApi.get();
        }
      }
    });

    $translatePartialLoaderProvider.addPart('app/main/customers');
  }
})();

(function () {
  'use strict';

  angular
    .module('app.customers')
    .controller('ServicesFiltersSideNavController', ServicesFiltersSideNavController);

  /** @ngInject */
  function ServicesFiltersSideNavController(ServicesFilters, _, msUtils, $rootScope, $timeout) {

    var vm = this;
    vm.servicesFilters = ServicesFilters;
    vm.clearFilters = ServicesFilters.clear;
    vm.filteringIsOn = ServicesFilters.isOn;
    vm.exists = msUtils.exists;
    vm.toggleInArray = toggleInArray;

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }

    vm.broadcastFilterUpdated = _.debounce(function () {
      $timeout(function () { $rootScope.$broadcast('services:reload'); }, 50);
    }, 500);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.services', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.services', {
      url: '/tipos-de-os',
      views: {
        'content@app': {
          templateUrl: 'app/main/services/services.html',
          controller: 'ServicesController as vm'
        }
      },
      data: { titleTranslateKey: 'SERVICES.PAGE_TITLE' },
      resolve: {
        account: function (accountsApi) {
          return accountsApi.get();
        },
        FeatureFlags: function (accountFeatureFlagsApiGraphQL) {
          return accountFeatureFlagsApiGraphQL.accountFeatureFlags();
        }
      }
    });

    $translatePartialLoaderProvider.addPart('app/main/services');
  }

})();

(function () {
    'use strict';

    angular
        .module('app.services')
        .factory('ServicesFilters', ServicesFilters);

    /** @ngInject */
    function ServicesFilters($rootScope, $timeout) {

        var filters = {
            description: null,
            archived: '1',

            clear: clear,
            isOn: isOn,
            isOff: isOff
        };

        function clear() {
            filters.description = null;
            filters.archived = '1';

            $timeout(function () { $rootScope.$broadcast('services:reload'); }, 200);
        }

        function isOn() {
            var noDescriptionFiltered = filters.description === null;
            var noArchivedFiltered = filters.archived === '1';

            return !(noDescriptionFiltered && noArchivedFiltered);
        }

        function isOff() {
            return !isOn();
        }

        return filters;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.routes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider
            .state('app.routes', {
                url    : '/historico-de-rotas',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/routes/routes.html',
                        controller : 'RoutesController as vm'
                    }
                },
                data: {titleTranslateKey: 'ROUTES.PAGE_TITLE'},
                resolve: {
                    account: function (accountsApi) {
                        return accountsApi.get();
                    }
                },
                bodyClass: 'dashboard-project'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/routes');
    }
})();

(function () {
  'use strict';

  angular.module('app.routes')
    .controller('RoutesFiltersSidenavController', RoutesFiltersSidenavController);

  /** @ngInject */
  function RoutesFiltersSidenavController(employeesApi, RoutesFilters, $rootScope, $timeout, moment, $scope) {
    var vm = this;
    vm.employees = [];
    vm.selectEmployee = selectEmployee;
    vm.routesFilters = RoutesFilters;

    vm.clearFilters = function () {
        RoutesFilters.clear();
        vm.invalidDate = false;
    };

    vm.filteringIsOn = RoutesFilters.isOn;
    vm.selectedEmployee = {};
    vm.invalidDate = RoutesFilters.invalidDate;
    vm.validDateFormat = moment().subtract(40, "days").format('DD/MM/YYYY');
    vm.minDate = moment().subtract(40, "days").toDate();

    function selectEmployee(employee) {
      vm.employees.forEach(function (employee) {
        employee.selected = false;
      });

      employee.selected = true;
      vm.routesFilters.employeeId = employee.id;
      vm.selectedEmployee = employee;
      vm.broadcastFilterUpdated();
    }

    function loadEmployees() {
      if (vm.employees.length > 0) {
        return;
      }

      return employeesApi.getAll().then(function (employees) {
        employees = _.filter(employees.items, function (employee) {
          return (!employee.contract.firedAt || moment(employee.contract.firedAt).isAfter(moment())) && !employee.inactivatedAt;
        });

        vm.employees = _.sortBy(employees, 'name');
      });
    }

    vm.broadcastFilterUpdated = _.debounce(function () {
      if (vm.routesFilters.employeeId && vm.routesFilters.date){
        $timeout(function () {
          var filterDate = moment.utc(vm.routesFilters.date);
          var utcNow = moment.utc();
          var diffInDays = utcNow.diff(filterDate, 'days');
          vm.invalidDate = diffInDays <= 40 ? false : true;
          if(!vm.invalidDate) {
            $rootScope.$broadcast('routes:filter-updated', vm.selectedEmployee);
          }
        }, 50);
      }
    }, 500);

    loadEmployees();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.recurrences')
    .factory('RecurrencesFilters', RecurrencesFilters);

  /** @ngInject */
  function RecurrencesFilters($rootScope, $timeout) {
    var filters = {
      customer: null,
      startDate: null,
      endDate: null,
      notes: null,
      location: null,
      archived: '1',
      services: [],
      employees: [],
      recurrenceDateDeadlineFrom: null,
      recurrenceDateDeadlineTo: null,

      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.customer = null;
      filters.startDate = null;
      filters.endDate = null;
      filters.notes = null;
      filters.archived = '1';
      filters.services = [];
      filters.employees = [];
      filters.recurrenceDateDeadlineFrom = null;
      filters.recurrenceDateDeadlineTo = null;

      $timeout(function () { $rootScope.$broadcast('recurrences:filter-updated'); }, 200);
    }

    function isOn() {
      var noCustomerFiltered = filters.customer === null;
      var noStartDateFiltered = filters.startDate === null;
      var noEndDateFiltered = filters.endDate === null;
      var noRecurrenceDateDeadlineFrom = filters.recurrenceDateDeadlineFrom === null;
      var noRecurrenceDateDeadlineTo = filters.recurrenceDateDeadlineTo === null;
      var noNotesFiltered = filters.notes === null;
      var noArchivedFiltered = filters.archived === '1';
      var noServicesFiltered = filters.services.length === 0;
      var noEmployeesFiltered = filters.employees.length === 0;
      return !(noCustomerFiltered &&
        noStartDateFiltered &&
        noEndDateFiltered &&
        noRecurrenceDateDeadlineFrom &&
        noRecurrenceDateDeadlineTo &&
        noNotesFiltered &&
        noArchivedFiltered &&
        noServicesFiltered &&
        noEmployeesFiltered);
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
    'use strict';

    angular
        .module('app.recurrences')
        .controller('RecurrencesFiltersSideNavController', RecurrencesFiltersSideNavController);

    /** @ngInject */
    function RecurrencesFiltersSideNavController($rootScope, $timeout, msUtils,
                                                 RecurrencesFilters, servicesApi, _, employeesApi) {

        var vm = this;
        vm.services = [];
        vm.employees = [];
        vm.recurrencesFilters = RecurrencesFilters;
        vm.clearFilters = RecurrencesFilters.clear;
        vm.filteringIsOn = RecurrencesFilters.isOn;
        vm.exists = msUtils.exists;
        vm.toggleInArray = toggleInArray;

        function toggleInArray(value, array) {
            msUtils.toggleInArray(value, array);
            vm.broadcastFilterUpdated();
        }

        servicesApi.getAll().then(function (result) {
            vm.services = _.filter(result.items, function (service) {
                return !service.archived;
            });
            vm.services = loadList(vm.services, 'description');
        });

        employeesApi.getAll().then(function (result) {
            var employees = _.filter(result.items, function (employee) { return employee.contract.active && !employee.inactivatedAt; });
            employees = _.sortBy(employees, function (employee) { return employee.name; });
            vm.employees = employees;
        });

        function loadList(list, propertyName) {
            var items = [];
            list.forEach(function (item) {
                item.name = item[propertyName];
                items.push(item);
            });
            return items;
        }

        vm.broadcastFilterUpdated = _.debounce(function () {
            $timeout(function () { $rootScope.$broadcast('recurrences:filter-updated'); }, 50);
        }, 500);
    }
})();

(function () {
  'use strict';

  angular
    .module('app.quotations')
    .factory('QuotationsFilters', QuotationsFilters);

  /** @ngInject */
  function QuotationsFilters($rootScope, $timeout) {

    var filters = {
      name: '',
      identifier: '',
      customer: '',
      createdBy: '',
      status: [],
      archived: '1',
      labels: [],
      dateFrom: moment().subtract(6, 'months').startOf('day').toDate(),
      dateTo: moment().endOf('day').toDate(),
      dateType: 'creation',
      clear: clear,
      isOn: isOn,
      isOff: isOff,
      toSearchOptions: toSearchOptions
    };

    function clear() {
      filters.name = '';
      filters.identifier = '';
      filters.customer = '';
      filters.createdBy = '';
      filters.status = [];
      filters.archived = '1';
      filters.labels = [];
      filters.dateFrom = moment().subtract(6, 'months').startOf('day').toDate();
      filters.dateTo = moment().endOf('day').toDate();
      filters.dateType = 'creation';

      $timeout(function () { $rootScope.$broadcast('quotations:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = !filters.name;
      var noIdentifierFiltered = !filters.identifier;
      var noCustomerFiltered = !filters.customer;
      var noCreatedByFiltered = !filters.createdBy;
      var noStatusFiltered = !filters.status.length;
      var noArchivedFiltered = filters.archived === '1';
      var noLabelsFiltered = filters.labels.length === 0;
      var noDataFiltered = (moment(filters.dateFrom).isSame(moment().subtract(6, 'months').startOf('day'), 'day') && moment(filters.dateTo).isSame(moment().endOf('day'), 'day'));

      return !(noNameFiltered && noIdentifierFiltered && noArchivedFiltered && noCustomerFiltered && noStatusFiltered && noDataFiltered && noLabelsFiltered && noCreatedByFiltered);
    }

    function isOff() {
      return !isOn();
    }

    function toSearchOptions() {
      var kqQueryParams = {};
      var gqlParams = {};

      if (filters.name) {
        kqQueryParams['name~~*'] = '*' + filters.name + '*';
        gqlParams['nameContains'] = filters.name;
      }

      if (filters.archived === '1') {
        kqQueryParams['archived'] = 'no';
        gqlParams['archived'] = false;
      } else if (filters.archived === '0') {
        kqQueryParams['archived'] = 'yes';
        gqlParams['archived'] = true;
      }

      if (filters.identifier) {
        kqQueryParams['identifier~~*'] = '*' + filters.identifier + '*';
        gqlParams['identifierContains'] = filters.identifier;
      }

      if (filters.customer) {
        kqQueryParams['customer.name~~*'] = '*' + filters.customer + '*';
        gqlParams['customerNameContains'] = Array.isArray(filters.customer) ? filters.customer.join(", ") : filters.customer;
      }

      if (filters.createdBy) {
        kqQueryParams['createdBy~~*'] = '*' + filters.createdBy + '*';
        gqlParams['createdByContains'] = filters.createdBy;
      }

      if (filters.status.length) {
        kqQueryParams['status'] = filters.status;
        gqlParams['statusIn'] = filters.status;
      }

      if (filters.labels.length) {
        kqQueryParams['label_id'] = filters.labels;
        gqlParams['labelIds'] = filters.labels;
      }

      if (filters.dateType === 'creation') {
       if (filters.dateFrom) {
        kqQueryParams['createdAt>='] = moment(filters.dateFrom).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
        gqlParams['createdAtGte'] = moment(filters.dateFrom).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
       }
       if (filters.dateTo) {
        kqQueryParams['createdAt<='] = moment(filters.dateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
        gqlParams['createdAtLte'] = moment(filters.dateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
       }
      } else if (filters.dateType === 'negotiation') {
        if (filters.dateFrom) {
          kqQueryParams['approvedOrRefusedAt>='] = moment(filters.dateFrom).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
          gqlParams['approvedOrRefusedAtGte'] = moment(filters.dateFrom).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
         }
         if (filters.dateTo) {
          kqQueryParams['approvedOrRefusedAt<='] = moment(filters.dateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
          gqlParams['approvedOrRefusedAtLte'] = moment(filters.dateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
         }
      }

      return {
        kq: kqQueryParams,
        graphQL: gqlParams
      };
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.quotations')
    .controller('QuotationsFiltersSideNavController', QuotationsFiltersSideNavController);

  /** @ngInject */
  function QuotationsFiltersSideNavController(QuotationsFilters, _, msUtils, $rootScope, $timeout, $translate, labelsApi) {

    var vm = this;
    vm.quotationsFilters = QuotationsFilters;

    vm.toggleInArray = toggleInArray;
    vm.dateType = [
      {translate: $translate.instant('QUOTATIONS.FILTERS.DATE.CREATION'), value: 'creation'},
      {translate: $translate.instant('QUOTATIONS.FILTERS.DATE.NEGOTIATION'), value: 'negotiation'}
    ];
    vm.archived = [
      {translate: $translate.instant('QUOTATIONS.FILTERS.STATE.ALL'), value: '-1'},
      {translate: $translate.instant('QUOTATIONS.FILTERS.STATE.ACTIVE'), value: '1'},
      {translate: $translate.instant('QUOTATIONS.FILTERS.STATE.ARCHIVED'), value: '0'}
    ];
    vm.exists = msUtils.exists;
    vm.quotationsStatus = [
      { name: 'pending', description: $translate.instant('QUOTATIONS.STATUS.PENDING') },
      { name: 'approved', description: $translate.instant('QUOTATIONS.STATUS.APPROVED') },
      { name: 'refused', description: $translate.instant('QUOTATIONS.STATUS.REFUSED') },
      { name: 'expired', description: $translate.instant('QUOTATIONS.STATUS.EXPIRED') },
      { name: 'canceled', description: $translate.instant('QUOTATIONS.STATUS.CANCELED') }
    ];
    vm.archived = [
      { translate: $translate.instant('QUOTATIONS.FILTERS.STATE.ALL'), value: '-1' },
      { translate: $translate.instant('QUOTATIONS.FILTERS.STATE.ACTIVE'), value: '1' },
      { translate: $translate.instant('QUOTATIONS.FILTERS.STATE.ARCHIVED'), value: '0' }
    ];

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }

    labelsApi.search({ type: 'quotations' }, { limit: 100 }).then(function (result) {
      vm.labels = result.items;
    });

    vm.broadcastFilterUpdated = _.debounce(function () {
      $timeout(function () { $rootScope.$broadcast('quotations:reload'); }, 50);
    }, 500);
  }
})();

(function () {
  'use strict';

  angular
    .module('app.quotations')
    .factory('QuotationProductService', QuotationProductService);

  /** @ngInject */
  function QuotationProductService(productsServicesApi, equipmentsApi, $rootScope, productsServicesApiGraphQL) {

    var data = {
      items: [],
      expenses: [],
      quotationEquipments: [],
      disabled: false,
      selectedCustomer: null,
      searchProductService: searchProductService,
      searchEquipments: searchEquipments,
      saveProductService: saveProductService,
      resetNewProductService: resetNewProductService,
      resetAllProductsServices: resetAllProductsServices,
      addQuotationItem: addQuotationItem,
      addQuotationEquipment: addQuotationEquipment,
      addQuotationExpense: addQuotationExpense
    };

    function searchProductService(searchText, selectedCustomer, selectedServiceOrder) {
      var queryParams = {
        nameOrCodeContains: searchText,
        archived: false
      };

      var queryOptions = {
        take: 50,
        orderBy: 'name_asc'
      };

      if (!selectedCustomer) {
        selectedCustomer = data.selectedCustomer;
      }

      var customerIntegration = selectedCustomer && selectedCustomer.metadata && selectedCustomer.metadata.integration;
      if (customerIntegration === 'bradesco-diti') {
        queryParams['customersProductsServicesIntegration'] = 'bradesco-diti';
        queryParams['customerId'] = selectedCustomer.id;
      }

      if (customerIntegration === 'corporate') {
        queryParams['integration'] = 'corporate/' + selectedCustomer.metadata.sammathnaur.account.uuid;
      }

      if (customerIntegration === 'bradesco-pat') {
        queryParams['integration'] = 'bradesco-pat';
      }

      return productsServicesApiGraphQL.searchProdutsServices(queryParams, queryOptions).then(function (result) {
        return result.items;
      });
    }

    function searchEquipments(searchText) {
      var body = {
        where: {
          nameOrNumberContains: searchText,
          archived: false,
        },
        skip: 0,
        take: 20,
        orderBy: 'name_asc'
      };

      return equipmentsApi.search(body).then(function (result) {
        return result.items;
      });
    }

    function searchEquipments(searchText, selectedCustomer) {
      if (!selectedCustomer) {
        selectedCustomer = data.selectedCustomer;
      }

      var body = {
        where: {
          nameOrNumberContains: searchText,
          archived: false,
          customerIds: (selectedCustomer && selectedCustomer.id) ? [selectedCustomer.id] : []
        },
        skip: 0,
        take: 20,
        orderBy: 'name_asc'
      };

      return equipmentsApi.search(body).then(function (result) {
        return result.items;
      });
    }

    function saveProductService(item) {
      return productsServicesApi.save(item.newProductService).then(function (response) {
        return response;
      });
    }

    function addQuotationItem(item, isNewProductService, equipmentId) {
      var item = {
        id: item.id ? item.id : null,
        sessionId: item.sessionId,
        total: item.total,
        quantity: item.quantity,
        position: data.items.length + 1,
        productService: item.productService,
        description: item.description ? item.description : '',
        newProductService: resetNewProductService(),
        expanded: item.expanded,
        equipment: (equipmentId || item.equipment) ? {
          id: equipmentId ? equipmentId : (item.equipment ? item.equipment.id : null)
        } : null
      };

      if (isNewProductService) {
        data.items.push(item);
      }

      return item;
    }

    function addQuotationExpense(expense) {
      return {
        description: expense.description,
        position: expense.position,
        expenseId: expense.expense && expense.expense.id ? expense.expense.id : '',
        total: expense.total,
        file: expense.file
      };
    }

    function addQuotationEquipment(equipment, isNewEquipment) {
      var quotationEquipment = {
        equipment: {
          id: equipment.id,
          name: equipment.name,
          number: equipment.number,
          imageUrl: equipment.imageUrl,
          type: equipment.type,
          location: equipment.location,
        }
      };

      if (isNewEquipment) {
        data.quotationEquipments.push(quotationEquipment);
      }

      return quotationEquipment;
    }

    function resetAllProductsServices() {
      data.items = [];
    }

    function resetNewProductService() {
      return {
        show: false,
        name: '',
        type: 'product',
        value: 0,
        description: '',
        archived: false,
        expanded: false,
        equipment: null
      };
    }

    return data;
  }
})();

(function () {
  'use strict';

  angular.module('app.quotations')
    .factory('QuotationServiceOrder', QuotationServiceOrder);

  /** @ngInject */
  function QuotationServiceOrder(ordersApi) {

    return {
      searchServiceOrderByIdentifier: searchServiceOrderByIdentifier
    };

    function searchServiceOrderByIdentifier(searchServiceOrderIdentifierText, customer) {
      var queryParams = {
        where: {
          archived: false,
          locked: false,
          customerId: customer.id
        },
        sortBy: 'createdAt_desc',
        take: 10
      };

      if (searchServiceOrderIdentifierText) {
        queryParams.where['identifierContains'] = searchServiceOrderIdentifierText;
      }

      return ordersApi.search(queryParams).then(function (result) {
        return result.items;
      });
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.quotations')
    .factory('QuotationCustomer', QuotationCustomer);

  /** @ngInject */
  function QuotationCustomer(customersApi, $translate) {

    return {
      validateCustomer: validateCustomer,
      searchCustomerByName: searchCustomerByName
    };

    function validateCustomer(selectedCustomer, formErr) {
      var customerIsNotSelected = !selectedCustomer;

      if (customerIsNotSelected) {
        formErr['customerIsRequired'] = $translate.instant('QUOTATIONS.DIALOG.MODEL.CUSTOMER.ENTER_VALUE');
        return false;
      }

      delete formErr['customerIsRequired'];
      return true;
    }

    function searchCustomerByName(searchCustomerText) {
      return customersApi.search({
        where: {
          nameOrDocumentNumberContains: searchCustomerText,
          archived: false
        },
        take: 10
      }).then(function (result) {
        return result.items;
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('CurrencyFormat', CurrencyFormat);

  /** @ngInject */
  function CurrencyFormat(translateService) {
    return {
      format: format
    };

    function format(num) {
      num = Number.parseFloat(num);

      var localeConfigs = {
        style: 'currency',
        currency: 'BRL'
      };
      var arrayValues = num.toLocaleString('pt-br', localeConfigs);
      var formatedValue = '';

      arrayValues = arrayValues.split('$');
      formatedValue = arrayValues.join('$');

      return formatedValue;
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('app.products-services', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.products-services', {
      url: '/produtos-e-servicos',
      views: {
        'content@app': {
          templateUrl: 'app/main/products-services/products-services.html',
          controller: 'ProductsServicesController as vm'
        }
      },
      data: { titleTranslateKey: 'PRODUCTS_SERVICES.PAGE_TITLE' },
      resolve: {
        account: function (accountsApi) {
          return accountsApi.get();
        }
      }
    });
    $translatePartialLoaderProvider.addPart('app/main/products-services');
  }

})();

(function () {
  'use strict';

  angular
    .module('app.products-services')
    .factory('ProductsServicesFilters', ProductsServicesFilters);

  /** @ngInject */
  function ProductsServicesFilters($rootScope, $timeout) {

    var filters = {
      name: null,
      archived: '1',
      type: '-1',

      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.name = null;
      filters.archived = '1';
      filters.type = '-1';

      $timeout(function () { $rootScope.$broadcast('products-services:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = filters.name === null;
      var noArchivedFiltered = filters.archived === '1';
      var noTypeFiltered = filters.type === '-1';

      return !(noNameFiltered && noArchivedFiltered && noTypeFiltered);
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.products-services')
    .controller('ProductsServicesFiltersSideNavController', ProductsServicesFiltersSideNavController);

  /** @ngInject */
  function ProductsServicesFiltersSideNavController(ProductsServicesFilters, _, $rootScope, $timeout) {

    var vm = this;
    vm.productsServicesFilters = ProductsServicesFilters;

    vm.broadcastFilterUpdated = _.debounce(function () {
      $timeout(function () { $rootScope.$broadcast('products-services:reload'); }, 50);
    }, 500);
  }
})();

(function () {
  'use strict';

  angular.module('app.products-services')
    .factory('ProductsServicesDialog', ProductsServicesDialog);

  /** @ngInject */
  function ProductsServicesDialog($mdDialog, $rootScope, productsServicesApi, $document, $q) {

    return {
      createProductService: createProductService,
      createProductServiceWithEquipment: createProductServiceWithEquipment,
      editProductService: editProductService
    };

    function createProductService(ev, callback) {
      _openDialog(ev, {
        ProductService: null,
        From: null,
        EquipmentId: null
      }, callback);
    }

    function createProductServiceWithEquipment(ev, equipmentId) {
      _openDialog(ev, {
        ProductService: null,
        From: null,
        EquipmentId: equipmentId || null
      });
    }

    function editProductService(ev, params, callback) {
      $rootScope.loadingProgress = true;

      var requests = {
        productService: productsServicesApi.getOne(params.id, {})
      };

      $q.all(requests).then(function (result) {
        _openDialog(ev, {
          ProductService: result.productService,
          From: params.from ? params.from : null,
          EquipmentId: params.equipmentId ? params.equipmentId : null
        }, callback);

      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function _openDialog(ev, locals, callback) {
      $mdDialog.show({
        controller: 'ProductsServicesDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/products-services/dialogs/products-services/products-services-dialog.html',
        parent: document.querySelector('.palantir-modal-container') || angular.element($document.body),
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (productService) {
        $rootScope.loadingProgress = false;
        if (callback) {
          callback(_, productService);
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.products-services')
    .controller('ProductsServicesDialogController', ProductsServicesDialogController);

  /** @ngInject */
  function ProductsServicesDialogController(
    $translate, $rootScope, $mdDialog, EquipmentId,
    $mdToast, $locale, ProductService, From,
    productsServicesApi, CurrencyService,
    $scope, msUtils, uploadApi, ProductsMeasuresDialogOptions
  ) {
    var vm = this;
    vm.currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = vm.currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    vm.productService = angular.copy(ProductService);
    vm.from = angular.copy(From) || null;
    vm.productResultImageFile = null;
    vm.productsServicesSelectOptions = [
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.TYPE.PRODUCT'), value: 'product' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.TYPE.SERVICE'), value: 'service' }
    ];
    vm.measuresSelectOptions = ProductsMeasuresDialogOptions.measures;

    if (!vm.productService) {
      vm.productService = {
        name: '',
        type: 'product',
        value: '',
        archived: false,
        description: '',
        imageUrl: '',
        measure: ''
      };
      vm.newProductService = true;
    }

    vm.closeDialog = closeDialog;
    function closeDialog(reload) {
      $mdDialog.hide(vm.productService);
    }

    vm.changeProductsServicesOption = changeProductsServicesOption;
    function changeProductsServicesOption(productServiceType) {
      var isService = productServiceType === 'service';
      if (isService) { vm.productService.measure = null; }
    }

    vm.saveProductService = saveProductService;
    function saveProductService() {
      if (vm.productService && !vm.productService.description) {
        vm.productService.description = '';
      }
      $rootScope.loadingProgress = true;
      productsServicesApi.save(vm.productService)
        .then(function (result) {
          vm.productService = _.assign(vm.productService, result);

          if (!vm.productResultImageFile && EquipmentId && vm.newProductService) {
            _realoadProductService();
          }

          if (vm.productResultImageFile) {
            var filename = '/products-services/' + vm.productService.id + '/' + msUtils.shortGuidGenerator() + '.png';

            var reader = new FileReader();
            reader.readAsDataURL(vm.productResultImageFile);
            reader.onloadend = function () {
              var base64data = reader.result;

              uploadApi.uploadWithPassthrough({
                  imageBase64Encoded: base64data,
                  filename: filename
              })
              .then(function (path) {
                  vm.productService.imageUrl = path.data.key;
                  productsServicesApi
                  .put(vm.productService.id, vm.productService)
                  .then(function (result) {
                      vm.productService.imageUrl = result.imageUrl;
                      $mdToast.show(
                          $mdToast.simple()
                          .textContent($translate.instant('PRODUCTS_SERVICES.TOAST.SAVED', { productService: vm.productService.name }))
                          .hideDelay(3000)
                      );
                  }).finally(function () {
                      $rootScope.$broadcast('products-services:reload');
                      $rootScope.loadingProgress = false;
                      if ((!vm.productResultImageFile && !vm.productService.imageUrl) || !vm.productResultImageFile) {
                          _realoadProductService();
                      }
                      vm.closeDialog();
                  });
              });
            };
        } else { vm.closeDialog(); }
        })
        .catch(function (result) {
          $rootScope.$broadcast('products-services:reload');
          $rootScope.loadingProgress = false;
          if ((!vm.productResultImageFile && !vm.productService.imageUrl) || !vm.productResultImageFile) {
           _realoadProductService();
          }
          if (result.data.err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('PRODUCTS_SERVICES.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('PRODUCTS_SERVICES.DIALOG.ALERT.OK'))
                .textContent(result.data.message)
            );
          }
          vm.closeDialog();
        });
    }

    function _realoadProductService() {
      if (vm.newProductService) {
        if (EquipmentId) {
          vm.productService.equipment = (EquipmentId && EquipmentId !== 'none') ? { id: EquipmentId } : null;
        }

        $rootScope.$broadcast('product-services:created', vm.productService);
      } else {
        $rootScope.$broadcast('product-services:edited', vm.productService);
      }
    }

    vm.unarchiveProductService = unarchiveProductService;
    function unarchiveProductService($event) {
      vm.productService.archived = false;
      saveProductService();
    }

    vm.archiveProductService = archiveProductService;
    function archiveProductService($event) {
      vm.productService.archived = true;
      saveProductService();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('OmieManualImportDialogController', OmieManualImportDialogController);

  /** @ngInject */
  function OmieManualImportDialogController(
    _, UtilityFunctions, $mdDialog, $rootScope, $scope, FcToastService,
    productsServicesApi, omieProductMapper, omieApi, $translate, msUtils
  ) {
    var vm = this;

    vm.limitPerPage = 5;
    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.totalCount = 0;
    vm.allProducts = [];
    vm.nameContains = '';

    vm.navigateToPage = navigateToPage;
    vm.onSearchChange = onSearchChange;
    vm.searchProducts = searchProducts;
    vm.parseValueToPrice = parseValueToPrice;
    vm.importProduct = importProduct;
    vm.updateProduct = updateProduct;
    vm.closeDialog = closeDialog;
    vm.isValidUUID = msUtils.isUuidV4;

    _initialize();

    function navigateToPage(isNextPage) {
      vm.currentPage = isNextPage ? vm.currentPage + 1 : vm.currentPage - 1;
      searchProducts();
    }

    function onSearchChange() {
      vm.currentPage = 1;
      searchProducts();
    }

    function searchProducts() {
      $rootScope.isLoading = true;
      _getOmieProductsToImport()
        .then(function (response) {
          _.defer(function () {
            $scope.$apply(function () {
              vm.totalPages = response.total_de_paginas || 0;
              vm.totalCount = response.total_de_registros || 0;
              var omieProducts = response.produto_servico_cadastro;
              if (omieProducts && omieProducts.length) {
                vm.allProducts = omieProducts.map(function (omieProduct) {
                  var fieldControlProduct = omieProductMapper.toFieldControl(omieProduct);
                  return fieldControlProduct;
                });
              }
            });
          });
        })
        .catch(function () {
          FcToastService.addWarning({
            hideDelay: 5000,
            position: 'BOTTOM LEFT',
            title: $translate.instant('PRODUCTS_SERVICES.IMPORT.LOADING_ERROR'),
            customClass: 'import-error-toast',
            iconPath: 'assets/icons/icon-service-error.svg',
            errorType: 'import-error-toast',
            noExit: true
          });
        });
    }

    function _getOmieProductsToImport() {
      $rootScope.loadingProgress = true;
      vm.isLoadingProducts = true;
      return omieApi.products.list({
        pagina: vm.currentPage,
        registros_por_pagina: vm.limitPerPage,
        filtrar_apenas_descricao: vm.nameContains ? '%' + vm.nameContains + '%' : '',
        exibir_obs: 'S'
      })
        .then(function (response) {
          return response.data;
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
          vm.isLoadingProducts = false;
        });
    }

    function importProduct(productToSave) {
      var existingProduct = vm.allProducts.find(function (product) {
        return product.integrationId === productToSave.integrationId;
      });

      if (existingProduct) {
        return updateProduct(productToSave);
      }
      $rootScope.loadingProgress = true;
      productsServicesApi.save(productToSave)
          .then(function (savedProduct) {
            productToSave.integrationId = savedProduct.id;
            _saveIntegrationCodeOnOmie(productToSave);
            productToSave.selected = true;
            importedProducts.push(productToSave);
          })
          .catch(function () {
            return _throwDefaultWarningByType('error', 'create');
          });
    }

    function updateProduct(productToUpdate) {
      if (!productToUpdate.integrationId){
        return importProduct(productToUpdate);
      }
      $rootScope.loadingProgress = true;
      productToUpdate.selected = true;
      productsServicesApi.put(productToUpdate.integrationId, productToUpdate)
        .then(function () {
          return _throwDefaultWarningByType('success', 'update');
        })
        .catch(function () {
          return _throwDefaultWarningByType('error', 'update');
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function _saveIntegrationCodeOnOmie(fieldControlProduct) {
      var omieProduct = omieProductMapper.toOmie(fieldControlProduct);
      return omieApi.products.update(omieProduct)
        .then(function (updatedOmieProduct) {
          omieProduct = updatedOmieProduct;
          return _throwDefaultWarningByType('success', 'create');
        })
        .catch(function () {
          return _throwDefaultWarningByType('error', 'create');
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function parseValueToPrice(value) {
      return UtilityFunctions.parseValueToPrice(value);
    }

    function _throwDefaultWarningByType(warningType, actionType) {
      var actionTranslation = actionType === 'update' ? 'UPDATE_SUCCESS' : 'SUCCESS_MANUAL';
      if (warningType === 'error') {
        actionTranslation = actionType === 'update' ? 'UPDATE_ERROR' : 'CREATE_ERROR';
      }
      var warningKeys = {
        error: {
          title: 'PRODUCTS_SERVICES.IMPORT.' + actionTranslation,
          customClass: 'import-error-toast',
          iconPath: 'assets/icons/icon-service-error.svg',
          errorType: 'import-error-toast'
        },
        success: {
          title: 'PRODUCTS_SERVICES.IMPORT.' + actionTranslation,
          customClass: 'import-finished-toast',
          iconPath: 'assets/icons/icon-success-circle-green.svg',
          errorType: 'import-finished-toast'
        }
      };
      var currentWarning = warningKeys[warningType];
      FcToastService.addWarning({
        hideDelay: 5000,
        position: 'BOTTOM LEFT',
        title: $translate.instant(currentWarning.title),
        customClass: currentWarning.customClass,
        iconPath: currentWarning.iconPath,
        errorType: currentWarning.errorType,
        noExit: true
      });
    }

    function closeDialog() {
      $mdDialog.hide(true);
    }

    function _initialize() {
      searchProducts(0);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.products', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.products', {
      url: '/produtos',
      views: {
        'content@app': {
          templateUrl: 'app/main/products/products.html',
          controller: 'ProductsController as vm'
        }
      },
      data: { titleTranslateKey: 'PRODUCTS.PAGE_TITLE' },
      resolve: {
        account: function (accountsApi) {
          return accountsApi.get();
        }
      }
    });
    $translatePartialLoaderProvider.addPart('app/main/products');
  }

})();

(function () {
  'use strict';

  angular
    .module('app.products')
    .factory('ProductsFilters', ProductsFilters);

  /** @ngInject */
  function ProductsFilters($rootScope, $timeout) {

    var filters = {
      name: null,
      description: null,
      code: null,
      productType: '-1',
      measure: '-1',
      archived: '1',
      type: 'product',

      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.name = null;
      filters.description = null;
      filters.code = null;
      filters.productType = '-1';
      filters.measure = '-1';
      filters.archived = '1';
      filters.type = 'product';

      $timeout(function () { $rootScope.$broadcast('products:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = filters.name === null;
      var noDescriptionFiltered = filters.description === null;
      var noCodeFiltered = filters.code === null;
      var noProductTypeFiltered = filters.productType === '-1';
      var noMeasureFiltered = filters.measure === '-1';
      var noArchivedFiltered = filters.archived === '1';

      return !(noNameFiltered && noDescriptionFiltered && noCodeFiltered && noArchivedFiltered && noProductTypeFiltered && noMeasureFiltered);
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.products')
    .controller('ProductsFiltersSideNavController', ProductsFiltersSideNavController);

  /** @ngInject */
  function ProductsFiltersSideNavController(ProductsFilters, _, $rootScope, $timeout, $translate, productTypesApiGraphQL) {

    var vm = this;
    vm.productsFilters = ProductsFilters;

    vm.statusOptions = [
      {
        value: {
          label: $translate.instant('PRODUCTS.FILTERS.SITUATIONS.ALL'),
          value: '-1'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCTS.FILTERS.SITUATIONS.ACTIVE'),
          value: '1'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCTS.FILTERS.SITUATIONS.ARCHIVED'),
          value: '0'
        }
      }
    ];
    vm.statusFilterValue = vm.statusOptions[1].value;

    vm.measureOptions = [
      {
        value: {
          label: $translate.instant('PRODUCTS.MODEL.MEASURES.ALL'),
          value: '-1'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCTS.MODEL.MEASURES.UNITY'),
          value: 'unity'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCTS.MODEL.MEASURES.CENTIMETER'),
          value: 'centimeter'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCTS.MODEL.MEASURES.METER'),
          value: 'meter'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCTS.MODEL.MEASURES.LITER'),
          value: 'liter'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCTS.MODEL.MEASURES.MILLILITER'),
          value: 'milliliter'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCTS.MODEL.MEASURES.KILOGRAM'),
          value: 'kilogram'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCTS.MODEL.MEASURES.GRAM'),
          value: 'gram'
        }
      }
    ];
    vm.measureFilterValue = vm.measureOptions[0].value;

    vm.productTypeOptions = [
      {
        value: {
          label: $translate.instant('PRODUCTS.MODEL.TYPE.ALL'),
          value: '-1'
        }
      }
    ];
    vm.productTypeFilterValue = vm.productTypeOptions[0].value;

    productTypesApiGraphQL
    .queryForDatatable({
      where: {
        archived: false
      },
      orderBy: 'name_desc',
      take: 1000,
      skip: 0
    })
    .then(function (result) {

      if (result && result.items && result.items.length) {
        _.forEach(result.items, function (item) {
          var productType = {
            value: {
              label: item.name,
              value: item.id.toString()
            }
          };

          vm.productTypeOptions.push(productType);
        });
      }
    });


    vm.broadcastFilterUpdated = _.debounce(function (changedFilterName) {
      if (changedFilterName === 'archived') {
        vm.productsFilters.archived = vm.statusFilterValue.value;
      }

      if (changedFilterName === 'measure') {
        vm.productsFilters.measure = vm.measureFilterValue.value;
      }

      if (changedFilterName === 'productType' && vm.productTypeFilterValue.value) {
        vm.productsFilters.productType = vm.productTypeFilterValue.value;
      }

      if (changedFilterName && vm.productsFilters[changedFilterName] === 'null') {
        vm.productsFilters[changedFilterName] = null;
      }

      if (changedFilterName && vm.productsFilters[changedFilterName] === 'false') {
        vm.productsFilters[changedFilterName] = false;
      }

      if (changedFilterName && vm.productsFilters[changedFilterName] === 'true') {
        vm.productsFilters[changedFilterName] = true;
      }

      $timeout(function () { $rootScope.$broadcast('products:reload'); }, 50);
    }, 500);
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('OmieManualProductsImportDialogController', OmieManualProductsImportDialogController);

  /** @ngInject */
  function OmieManualProductsImportDialogController(
    _, UtilityFunctions, $mdDialog, $rootScope, $scope, FcToastService, locals,
    productsServicesApi, omieProductMapper, omieApi, $translate, msUtils,FcModalService
  ) {
    var vm = this;

    vm.limitPerPage = 5;
    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.totalCount = 0;
    vm.allProducts = [];
    vm.nameContains = '';

    vm.navigateToPage = navigateToPage;
    vm.onSearchChange = onSearchChange;
    vm.searchProducts = searchProducts;
    vm.parseValueToPrice = parseValueToPrice;
    vm.importProduct = importProduct;
    vm.updateProduct = updateProduct;
    vm.closeDialog = closeDialog;
    vm.isValidUUID = msUtils.isUuidV4;
    vm.textSanitizer = msUtils.textSanitizer;
    vm.appId = locals.appId;

    _initialize();

    function navigateToPage(isNextPage) {
      vm.currentPage = isNextPage ? vm.currentPage + 1 : vm.currentPage - 1;
      searchProducts();
    }

    function onSearchChange() {
      vm.currentPage = 1;
      searchProducts();
    }

    function searchProducts() {
      $rootScope.isLoading = true;
      _getOmieProductsToImport()
        .then(function (response) {
          _.defer(function () {
            $scope.$apply(function () {
              vm.totalPages = response.total_de_paginas || 0;
              vm.totalCount = response.total_de_registros || 0;
              var omieProducts = response.produto_servico_cadastro;
              if (omieProducts && omieProducts.length) {
                vm.allProducts = omieProducts.map(function (omieProduct) {
                  var fieldControlProduct = omieProductMapper.toFieldControl(omieProduct);
                  fieldControlProduct.name = vm.textSanitizer(fieldControlProduct.name);
                  checkIfExistsInFieldControl(fieldControlProduct);
                  fieldControlProduct.updating = true;
                  return fieldControlProduct;
                });
              }
            });
          });
        })
        .catch(function () {
          FcToastService.addWarning({
            hideDelay: 5000,
            position: 'BOTTOM LEFT',
            title: $translate.instant('PRODUCTS.IMPORT.LOADING_ERROR'),
            customClass: 'import-error-toast',
            iconPath: 'assets/icons/icon-service-error.svg',
            errorType: 'import-error-toast',
            noExit: true
          });
        });
    }

    function checkIfExistsInFieldControl(apiProduct) {
      if (apiProduct.integrationId) {
        productsServicesApi.getOne(
          apiProduct.integrationId,
          { limit: 1 }
        ).then(function (result) {
          if (result.id) {
            apiProduct.archived = result.archived;
            apiProduct.updating = true;
          } else {
            apiProduct.updating = false;
            apiProduct.archived = null;
          }
          $rootScope.isLoading = false;
        }).catch(function () {
          apiProduct.updating = false;
          $rootScope.isLoading = false;
        });
      } else {
        $rootScope.isLoading = false;
        apiProduct.updating = false;
      }
    };

    function _getOmieProductsToImport() {
      $rootScope.loadingProgress = true;
      vm.isLoadingProducts = true;
      return omieApi.products.list({
        pagina: vm.currentPage,
        registros_por_pagina: vm.limitPerPage,
        filtrar_apenas_descricao: vm.nameContains ? '%' + vm.nameContains + '%' : '',
        exibir_obs: 'S'
      }, vm.appId)
        .then(function (response) {
          return response.data;
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
          vm.isLoadingProducts = false;
        });
    }

    function _checkIfCodeExists(product) {
      return new Promise(function (resolve, reject) {
        var queryParams = {
          'code': product.code,
          type: 'product'
        };

        var queryOptions = {
          offset: 0,
          limit: 2,
          sort: '-createdAt'
        };

        productsServicesApi.search(queryParams, queryOptions).then(function (response) {
          var canUpdate = false;
          if (response && response.items && response.items.length > 0) {
            var productFound = response.items[0];
            if (productFound.code === product.code && productFound.id === product.integrationId) {
              canUpdate = true;
            }
          } else {
            canUpdate = true;
          }
          resolve({ canUpdate: canUpdate, productFound: productFound });
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function importProduct(productToSave) {
      $rootScope.loadingProgress = true;
      productToSave.externalAppId = vm.appId;
      _checkIfCodeExists(productToSave).then(function (response) {
        var canUpdate = response.canUpdate;
        var productFound = response.productFound;
        if (canUpdate) {
          productsServicesApi.save(productToSave)
          .then(function (savedProduct) {
              productToSave.integrationId = savedProduct.id;
              _saveIntegrationCodeOnOmie(productToSave);
              productToSave.selected = true;
            })
            .catch(function () {
              return _throwDefaultWarningByType('error', 'create');
            });
        } else {
          productToSave.failed = true;
          _throwDefaultWarningByType('error', 'create');
          _openDuplicatedCodeOmieManualImportDialog(productToSave, productFound);
        }
      });
    }

    function updateProduct(productToUpdate) {
      $rootScope.loadingProgress = true;
      productToUpdate.externalAppId = vm.appId;
      var finalProduct = {};
      _checkIfCodeExists(productToUpdate).then(function (response) {
        var canUpdate = response.canUpdate;
        var productFound = response.productFound;
        if (canUpdate) {
          finalProduct = productToUpdate;
          finalProduct.id = productToUpdate.integrationId;
          finalProduct.integrationId = finalProduct.id;
          finalProduct.omieId = productToUpdate.omieId;
          _saveIntegrationCodeOnOmie(finalProduct);
          productToUpdate.selected = true;

          productsServicesApi.put(finalProduct.id, productToUpdate)
          .then(function () {
            return _throwDefaultWarningByType('success', 'update');
          })
          .catch(function () {
            return _throwDefaultWarningByType('error', 'update');
          })
          .finally(function () {
            $rootScope.loadingProgress = false;
          });
        } else {
          productToUpdate.failed = true;
          _throwDefaultWarningByType('error', 'update');
          _openDuplicatedCodeOmieManualImportDialog(productToUpdate, productFound);
        }
      });
    }

    function _openDuplicatedCodeOmieManualImportDialog(productToUpdate, existingProduct) {
      FcModalService.open(null, {
        title: $translate.instant('PRODUCTS.OMIE_DIALOG.TITLE', {productToUpdate: productToUpdate.name}),
        content: $translate.instant('PRODUCTS.OMIE_DIALOG.CONTENT', {code: productToUpdate.code, existingProduct: existingProduct.name}),
        paddingSmall: true,
        rightContinueButton: true,
        rightButtonText: $translate.instant('PRODUCTS.OMIE_DIALOG.UPDATE'),
        leftButtonText: $translate.instant('PRODUCTS.OMIE_DIALOG.CANCEL'),
        handleRightButton: function () {
          productToUpdate.id = existingProduct.id;
          productToUpdate.integrationId = existingProduct.id;
          _updateFieldProduct(productToUpdate);
          var fieldControlProductToSaveIntegrationIdOnOmie = omieProductMapper.toOmie(productToUpdate);
          omieApi.products.update(fieldControlProductToSaveIntegrationIdOnOmie, vm.appId);
          productToUpdate.selected = true;
        }
      });
    }

    function _updateFieldProduct(fieldControlProduct) {
      fieldControlProduct.externalAppId = vm.appId;
      productsServicesApi.put(fieldControlProduct.integrationId, fieldControlProduct)
        .catch(function () {
          productsServicesApi.save(fieldControlProduct).then(function (createdProduct) {
            fieldControlProduct.integrationId = createdProduct.id;
            var fieldControlProductToSaveIntegrationIdOnOmie = omieProductMapper.toOmie(fieldControlProduct);

            omieApi.products.update(fieldControlProductToSaveIntegrationIdOnOmie, vm.appId);
            _throwDefaultWarningByType('success', 'create');
          });
        }).finally(function () {
          _throwDefaultWarningByType('success', 'update');
        });
    }

    function _saveIntegrationCodeOnOmie(fieldControlProduct) {
      var omieProduct = omieProductMapper.toOmie(fieldControlProduct);
      return omieApi.products.update(omieProduct, vm.appId)
        .then(function (updatedOmieProduct) {
          omieProduct = updatedOmieProduct;
          return _throwDefaultWarningByType('success', 'create');
        })
        .catch(function () {
          return _throwDefaultWarningByType('error', 'create');
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function parseValueToPrice(value) {
      return UtilityFunctions.parseValueToPrice(value);
    }

    function _throwDefaultWarningByType(warningType, actionType) {
      var actionTranslation = actionType === 'update' ? 'UPDATE_SUCCESS' : 'SUCCESS_MANUAL';
      if (warningType === 'error') {
        actionTranslation = actionType === 'update' ? 'UPDATE_ERROR' : 'CREATE_ERROR';
      }
      var warningKeys = {
        error: {
          title: 'PRODUCTS.IMPORT.' + actionTranslation,
          customClass: 'import-error-toast',
          iconPath: 'assets/icons/icon-service-error.svg',
          errorType: 'import-error-toast'
        },
        success: {
          title: 'PRODUCTS.IMPORT.' + actionTranslation,
          customClass: 'import-finished-toast',
          iconPath: 'assets/icons/icon-success-circle-green.svg',
          errorType: 'import-finished-toast'
        }
      };
      var currentWarning = warningKeys[warningType];
      FcToastService.addWarning({
        hideDelay: 5000,
        position: 'BOTTOM LEFT',
        title: $translate.instant(currentWarning.title),
        customClass: currentWarning.customClass,
        iconPath: currentWarning.iconPath,
        errorType: currentWarning.errorType,
        noExit: true
      });
    }

    function closeDialog() {
      $mdDialog.hide(true);
    }

    function _initialize() {
      searchProducts(0);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.product-types', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.product-types', {
      url: '/tipos-de-produto',
      views: {
        'content@app': {
          templateUrl: 'app/main/product-types/product-types.html',
          controller: 'ProductTypesController as vm'
        }
      },
      data: { titleTranslateKey: 'PRODUCT_TYPES.PAGE_TITLE' },
      resolve: {
        account: function (accountsApi) {
          return accountsApi.get();
        }
      }
    });
    $translatePartialLoaderProvider.addPart('app/main/product-types');
  }

})();

(function () {
  'use strict';

  angular
    .module('app.product-types')
    .factory('ProductTypesFilters', ProductTypesFilters);

  /** @ngInject */
  function ProductTypesFilters($rootScope, $timeout) {

    var filters = {
      name: null,
      description: null,
      archived: '1',

      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.name = null;
      filters.description = null;
      filters.archived = '1';

      $timeout(function () { $rootScope.$broadcast('product-types:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = filters.name === null;
      var noDescriptionFiltered = filters.description === null;
      var noArchivedFiltered = filters.archived === '1';

      return !(noNameFiltered && noDescriptionFiltered && noArchivedFiltered);
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.product-types')
    .controller('ProductTypesFiltersSideNavController', ProductTypesFiltersSideNavController);

  /** @ngInject */
  function ProductTypesFiltersSideNavController(ProductTypesFilters, _, $rootScope, $timeout, $translate) {

    var vm = this;
    vm.productTypesFilters = ProductTypesFilters;


    vm.statusOptions = [
      {
        value: {
          label: $translate.instant('PRODUCT_TYPES.FILTERS.SITUATIONS.ALL'),
          value: '-1'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCT_TYPES.FILTERS.SITUATIONS.ACTIVE'),
          value: '1'
        }
      },
      {
        value: {
          label: $translate.instant('PRODUCT_TYPES.FILTERS.SITUATIONS.ARCHIVED'),
          value: '0'
        }
      }
    ];
    vm.statusFilterValue = vm.statusOptions[1].value;


    vm.broadcastFilterUpdated = _.debounce(function (changedFilterName) {
      if (changedFilterName === 'archived') {
        vm.productTypesFilters.archived = vm.statusFilterValue.value;
      }

      if (changedFilterName && vm.productTypesFilters[changedFilterName] === 'null') {
        vm.productTypesFilters[changedFilterName] = null;
      }

      if (changedFilterName && vm.productTypesFilters[changedFilterName] === 'false') {
        vm.productTypesFilters[changedFilterName] = false;
      }

      if (changedFilterName && vm.productTypesFilters[changedFilterName] === 'true') {
        vm.productTypesFilters[changedFilterName] = true;
      }

      $timeout(function () { $rootScope.$broadcast('product-types:reload'); }, 50);
    }, 500);
  }
})();

(function () {
  'use strict';

  angular
    .module('app.product-types')
    .controller('ProductTypesDialogController', ProductTypesDialogController);

  /** @ngInject */
  function ProductTypesDialogController(
    $translate, $rootScope, $mdDialog, gandalfApi,
    $mdToast, $locale, ProductType,
    msUtils, productTypesApiGraphQL, CurrencyService
  ) {
    var vm = this;
    vm.currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = vm.currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    vm.productType = angular.copy(ProductType);
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['product-types-description'];

    vm.closeDialog = closeDialog;
    vm.saveProductType = saveProductType;
    vm.selectImage = selectImage;
    vm.unarchiveProductType = unarchiveProductType;
    vm.archiveProductType = archiveProductType;

    if (!vm.productType) {
      vm.productType = {
        id: '',
        name: '',
        description: '',
        archived: false,
      };
      vm.newProductType = true;
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload, vm.productType);
    }

    function saveProductType(actionName) {
      var actionName = actionName === 'create' ? 'createProductType' : 'updateProductType';

      if (vm.productType && !vm.productType.description) {
        vm.productType.description = '';
      }

      var productTypeToSve = angular.copy(vm.productType);

      $rootScope.loadingProgress = true;
      productTypesApiGraphQL[actionName](productTypeToSve)
        .then(function (result) {
          vm.productType = _.assign(vm.productType, result);

          if (actionName === 'createProductType') {
            for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
              var field = vm.smartRewriteFields[i];
              var params = {
                reference: vm.sessionId,
                referenceType: field,
                updatedReference: result.id
              };

              gandalfApi.updateRewriteInputHistory(params);
            }
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('PRODUCT_TYPES.TOAST.SAVED', { productType: vm.productType.name }))
              .hideDelay(3000)
          );
        })
        .catch(function (result) {
          if (result.data.err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('PRODUCT_TYPES.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('PRODUCT_TYPES.DIALOG.ALERT.OK'))
                .textContent(result.data.message)
            );
          }
        })
        .finally(function () {
          $rootScope.$broadcast('product-types:reload');
          $rootScope.loadingProgress = false;

            _reloadProductType();

          vm.closeDialog();
        });
    }


    function selectImage() {
      var imageSelector = document.querySelector('#image-insert-container');
      if (imageSelector) {
        imageSelector.click();
      }
    }

    function _reloadProductType() {
      if (vm.newProductType) {
        $rootScope.$broadcast('product-services:created', vm.productType);
      } else {
        $rootScope.$broadcast('product-services:edited', vm.productType);
      }
    }

    function unarchiveProductType($event) {
      vm.productType.archived = false;
      saveProductType();
    }

    function archiveProductType($event) {
      vm.productType.archived = true;
      saveProductType();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.product-types')
    .factory('ProductTypesDialog', ProductTypesDialog);

  /** @ngInject */
  function ProductTypesDialog($mdDialog, $rootScope, $document, $q, productTypesApiGraphQL) {

    return {
      createProductType: createProductType,
      editProductType: editProductType
    };

    function createProductType(ev, callback) {
      _openDialog(ev, {
        ProductType: null,
        From: null
      }, callback);
    }

    function editProductType(ev, params, callback) {
      $rootScope.loadingProgress = true;

      productTypesApiGraphQL
      .queryForDialog(params.id)
      .then(function (productType) {
        _openDialog(ev, {
          ProductType: productType,
          From: null
        }, callback);
      })
      .finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function _openDialog(ev, locals, callback) {
      $mdDialog.show({
        controller: 'ProductTypesDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/product-types/dialogs/product-types/product-types-dialog.html',
        parent: document.querySelector('.palantir-modal-container') || angular.element($document.body),
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload, productType) {
        if (callback) {
          callback(reload, productType);
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.plans-types', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.plans-types', {
      url: '/tipos-de-planos-de-atividades',
      views: {
        'content@app': {
          templateUrl: 'app/main/plans-types/plans-types.html',
          controller: 'PlansTypesController as vm'
        }
      },
      data: { titleTranslateKey: 'PLANSTYPES.PAGE_TITLE' }
    });

    $translatePartialLoaderProvider.addPart('app/main/plans-types');
  }
})();

(function () {
  'use strict';

  angular
    .module('app.plans-types')
    .controller('PlansTypesFiltersSideNavController', PlansTypesFiltersSideNavController);

  /** @ngInject */
  function PlansTypesFiltersSideNavController(PlansTypesFilters, _, msUtils, $rootScope, $timeout) {
    var vm = this;
    vm.plansTypesFilters = PlansTypesFilters;
    vm.clearFilters = PlansTypesFilters.clear;
    vm.filteringIsOn = PlansTypesFilters.isOn;
    vm.exists = msUtils.exists;
    vm.toggleInArray = toggleInArray;

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }

    vm.broadcastFilterUpdated = _.debounce(function () {
      $timeout(function () { $rootScope.$broadcast('plans-types:reload'); }, 50);
    }, 500);
  }
})();

(function () {
  'use strict';

  angular
    .module('app.plans-types')
    .factory('PlansTypesFilters', PlansTypesFilters);

  /** @ngInject */
  function PlansTypesFilters($rootScope, $timeout) {

    var filters = {
      name: null,
      description: null,
      archived: '1',

      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.name = null;
      filters.description = null;
      filters.archived = '1';

      $timeout(function () { $rootScope.$broadcast('plans-types:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = filters.name === null;
      var noDescriptionFiltered = filters.description === null;
      var noArchivedFiltered = filters.archived === '1';

      return !(noNameFiltered && noDescriptionFiltered && noArchivedFiltered);
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.plans', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.plans', {
      url: '/planos-de-atividades',
      views: {
        'content@app': {
          templateUrl: 'app/main/plans/plans.html',
          controller: 'PlansController as vm'
        }
      },
      data: { titleTranslateKey: 'PLANS.PAGE_TITLE' },
      resolve: {
        Account: function (accountsApi) {
          return accountsApi.get();
        }
      }
    });

    $translatePartialLoaderProvider.addPart('app/main/plans');
  }

})();

(function () {
  'use strict';

  angular
    .module('app.plans')
    .controller('PlansFiltersSideNavController', PlansFiltersSideNavController);

  /** @ngInject */
  function PlansFiltersSideNavController(PlansFilters, _, msUtils, $rootScope, $timeout) {

    var vm = this;
    vm.plansFilters = PlansFilters;
    vm.clearFilters = PlansFilters.clear;
    vm.filteringIsOn = PlansFilters.isOn;
    vm.exists = msUtils.exists;
    vm.toggleInArray = toggleInArray;

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }

    vm.broadcastFilterUpdated = _.debounce(function () {
      $timeout(function () { $rootScope.$broadcast('plans:reload'); }, 50);
    }, 500);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.plans')
    .factory('PlansFilters', PlansFilters);

  /** @ngInject */
  function PlansFilters($rootScope, $timeout) {

    var filters = {
      name: null,
      description: null,
      planType: null,
      archived: '1',

      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.name = null;
      filters.description = null;
      filters.planType = null;
      filters.archived = '1';

      $timeout(function () { $rootScope.$broadcast('plans:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = filters.name === null;
      var noDescriptionFiltered = filters.description === null;
      var noPlanTypeFiltered = filters.planType === null;
      var noArchivedFiltered = filters.archived === '1';

      return !(noNameFiltered && noDescriptionFiltered && noPlanTypeFiltered && noArchivedFiltered);
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular.module('app.plans')
    .factory('UnprocessableSpreadSheetPrompt', UnprocessableSpreadSheetPrompt);

  /** @ngInject */
  function UnprocessableSpreadSheetPrompt($mdDialog, $document, $rootScope) {

    return {
      show: show
    };

    function show(data) {
      $rootScope.loadingProgress = false;

      return $mdDialog.show({
        controller: 'UnprocessableSpreadSheetPromptController',
        controllerAs: 'vm',
        templateUrl: 'app/main/plans/dialogs/unprocessable-spreadsheet-prompt/unprocessable-spreadsheet-prompt.html',
        parent: angular.element($document.body),
        clickOutsideToClose: false,
        locals: {
          Data: data
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.plans')
    .controller('UnprocessableSpreadSheetPromptController', UnprocessableSpreadSheetPromptController);

  /** @ngInject */
  function UnprocessableSpreadSheetPromptController($mdDialog, Data, $translate) {
    var vm = this;
    vm.close = close;
    vm.data = Data;
    vm.formattedMessage = null;
    vm.itemsLimit = 1500;

    if (vm.data.error === 'invalid-columns'){
      vm.formattedMessage = $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.UNPROCESSABLE.COLUMNS_NOT_FOUND');
    } else if (vm.data.error === 'spreadsheet-with-more-than-1500-rows'){
      vm.formattedMessage = $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.UNPROCESSABLE.SPREADSHEET_TOO_BIG',{
        activitiesLimit: vm.itemsLimit
      });
    } else if (vm.data.error === 'spreadsheet-without-rows'){
      vm.formattedMessage = $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.UNPROCESSABLE.EMPTY_SPREADSHEET');
    }

    function close() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.plans').factory('PlansDialog', PlansDialog);

  /** @ngInject */
  function PlansDialog($mdDialog, $rootScope, plansApi, plansTypesApi, $document, $q, ordersApi, _, UnprocessableSpreadSheetPrompt) {

    return {
      createPlan: createPlan,
      editPlan: editPlan,
      orderPlansItems: orderPlansItems
    };

    function createPlan(ev, args, callback) {
      $rootScope.loadingProgress = true;

      var requests = {
        planTypes: plansTypesApi.search({ archived: false }, { limit: 500 })
      };

      var itemsLimit = 1500;

      $q.all(requests).then(function (result) {
        var totalItemsPlans = args.plans.totalItems || 0;
        var exceededItemsLimit = totalItemsPlans > itemsLimit;

        if (exceededItemsLimit) {
          UnprocessableSpreadSheetPrompt.show({
            error: 'spreadsheet-with-more-than-1500-rows'
          });
        } else {
          _openDialog(ev, {
            DialogData: {
              plans: args.plans,
              planTypes: result.planTypes.items,
              spreadsheetJson: args.spreadsheetJson,
              spreadsheetFile: args.excelFile
            }
          }, callback);
        }
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function editPlan(ev, id, callback) {
      $rootScope.loadingProgress = true;

      var requests = {
        plans: plansApi.getOne(id),
        planTypes: plansTypesApi.search({ archived: false }, { limit: 500 }),
        orders: ordersApi.searchForPlans({
          where: {
            planId: id
          },
          take: 1000000,
          sortBy: 'createdAt_asc'
        })
      };

      $q.all(requests).then(function (result) {
        result.plans.orders = result.orders.items;
        delete result.orders.items;
        _openDialog(ev, {
          DialogData: {
            plans: result.plans,
            planTypes: result.planTypes.items,
          }
        }, callback);
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function orderPlansItems(items) {
      var allTasks = angular.copy(items);
      allTasks = _.sortBy(allTasks, 'scheduledDate');
      var tasks = [];

      var tasksByScheduledDate = _.groupBy(allTasks, 'scheduledDate');
      var scheduledDates = Object.keys(tasksByScheduledDate);

      for (var index = 0; index < scheduledDates.length; index++) {
        var scheduledDate = scheduledDates[index];
        var tasksToOrder = tasksByScheduledDate[scheduledDate];

        tasksToOrder = _.sortBy(tasksToOrder, 'scheduledHour');

        _.forEach(tasksToOrder, function (task) {
          tasks.push(task);
        });
      }

      return tasks;
    }

    function _openDialog(ev, locals, callback) {

      $mdDialog.show({
        controller: 'PlansDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/plans/dialogs/plans/plans-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.plans')
    .controller('PlansDialogController', PlansDialogController);

    /** @ngInject */
    function PlansDialogController(
      _, $translate, $timeout, $rootScope, FcModalService, $mdDialog, $mdToast,
      DialogData, plansApi, uploadApi, msUtils, OrderDialog, moment, TasksStatusHelper,
      tasksApi, PlansDialog, gandalfApi
    ) {

      var vm = this;

      function _initialize() {
        vm.plans = angular.copy(DialogData.plans);
        vm.plansTypes = angular.copy(DialogData.planTypes);
        vm.totalItems = vm.plans.totalItems || 0;
        vm.newPlan = vm.totalItems > 0;
        vm.itemsLimit = 1500;
        vm.exceededItemsLimit = vm.totalItems > vm.itemsLimit;
        vm.editOrder = editOrder;
        vm.closeDialog = closeDialog;
        vm.createPlan = createPlan;
        vm.editPlan = editPlan;
        vm.tasks = [];
        vm.unarchivePlan = unarchivePlan;
        vm.archivePlan = archivePlan;
        vm.broadcastFilterUpdated = _.debounce(function () {
          $timeout(function () { $rootScope.$broadcast('plans:reload'); }, 50);
        }, 500);
        vm.pagination = {
          perPageCount: 10,
          currentPage: 1,
          firstPageIndex: 1,
          lastPageIndex: 10
        };
        vm.hasPlans = false;
        vm.hasPlansTasks = false;
        vm.sessionId = msUtils.uuidGenerator();
        vm.smartRewriteFields = ['plans-description'];

        if (!vm.newPlan) {
          getTasksFromOrders();
          loadPaginatedTasks(1);
          vm.loadPaginated = loadPaginatedTasks;
        } else {
          loadPaginatedPlans(1);
          vm.loadPaginated = loadPaginatedPlans;
        }

        goToTab(1);
      }

      function archivePlan() {
        vm.plans.archived = true;
        editPlan('PLANS.TOAST.ARCHIVED', 'PLANS.DIALOG.ALERT.ERROR_ARCHIVE').then(function () {
            var tasks = pluckTasksFromOrders(vm.plans.orders);
            var scheduledTasks = _.filter(tasks, function (task) {
            return task.status === 'scheduled';
            });
            if (scheduledTasks.length) {
              return archiveTasksFromOrder(scheduledTasks);
            }
        });
      }

      function archiveTasksFromOrder(scheduledTasks) {
        _.forEach(scheduledTasks, function (task) {
          task.archived = true;
        });

        FcModalService.open('', {
          title: $translate.instant('PLANS.DIALOG.CONFIRM_DIALOG.TITLE'),
          content: $translate.instant('PLANS.DIALOG.CONFIRM_DIALOG.CONTENT'),
          leftButtonText: $translate.instant('PLANS.DIALOG.CONFIRM_DIALOG.CANCEL'),
          rightButtonText: $translate.instant('PLANS.DIALOG.CONFIRM_DIALOG.OK'),
          handleRightButton: function () {
            patchTasks(scheduledTasks, true);
            FcModalService.close();
          }
        });
      }

      function unarchivePlan() {
        vm.plans.archived = false;
        editPlan('PLANS.TOAST.UNARCHIVED', 'PLANS.DIALOG.ALERT.ERROR_UNARCHIVE');

        var tasks = pluckTasksFromOrders(vm.plans.orders);
        var scheduledTasks = _.filter(tasks, function (task) {
          return task.status === 'scheduled';
        });

        if (scheduledTasks.length) {
          unarchiveTasksFromOrder(scheduledTasks);
        }
      }

      function unarchiveTasksFromOrder(scheduledTasks) {
        _.forEach(scheduledTasks, function (task) {
          task.archived = false;
        });

        patchTasks(scheduledTasks, false);
      }

      function pluckTasksFromOrders(orders) {
        var tasks = [];
        _.forEach(orders, function (order) {
          _.forEach(order.tasks, function (task) {
              tasks.push(task);
          });
        });

        return tasks;
      }

      function patchTasks(tasksFromOrder, isArchiving) {
        $rootScope.loadingProgress = true;

        tasksApi.patchTasks(tasksFromOrder)
        .then(function () {
          if(isArchiving) {
            editPlan('PLANS.TOAST.SCHEDULED_TASKS_ARCHIVED', 'PLANS.DIALOG.ALERT.ERROR_ARCHIVE');
          }
        });
      }

      function goToTab(index) {
        vm.selectedTabIndex = index;
      }

      function getTasksFromOrders() {
        vm.plans.orders.forEach(function (order) {
          if (!order.tasks) { return; };
          order.tasks.forEach(function (task) {
            var taskStatus = TasksStatusHelper.getByName(task.status);
            var mappedTask = {
              order: order,
              service: order.service,
              employee: task.employee,
              customer: order.customer,
              equipment: order.equipments,
              scheduling: task.scheduling,
              status: taskStatus
            };

            mappedTask.scheduling.formattedDate = _formateDateTime(task.scheduling);

            vm.tasks.push(mappedTask);
          });
        });
      }

      function _formateDateTime(scheduling) {
        if (!scheduling.date) {
          return '';
        }

        if (!scheduling.time) {
          return moment(scheduling.date).format('DD/MM/YYYY');
        }

        var formattedDate = scheduling.date + ' ' + scheduling.time;
        return moment(formattedDate).format('DD/MM/YYYY HH:mm');
      }

      function paginate(arr, perpage, page) {
        vm.pagination.currentPage = page;
        vm.pagination.firstPageIndex = perpage * (page - 1);
        vm.pagination.lastPageIndex = perpage * page;
        var plans = angular.copy(arr);
        plans.items = PlansDialog.orderPlansItems(plans.items);

        var pagedItems = plans.slice(vm.pagination.firstPageIndex, vm.pagination.lastPageIndex);
        var isEmpty = pagedItems.length === 0;
        if (isEmpty) {
          vm.pagination.firstPageIndex = 0;
        } else {
          vm.pagination.firstPageIndex++;
        }
        var isLastPageIndexGreaterThanTotalLength = vm.pagination.lastPageIndex >= arr.length;
        if (isLastPageIndexGreaterThanTotalLength) {
          vm.pagination.lastPageIndex = arr.length;
        }
        return pagedItems;
      }

      function loadPaginatedPlans(page) {
        $rootScope.loadingProgress = true;
        $timeout(function () {
          vm.currentPlans = paginate(vm.plans.items, vm.pagination.perPageCount, page);
          vm.hasPlans = !!vm.currentPlans.length;
          $rootScope.loadingProgress = false;
        }, 450);
      }

      function loadPaginatedTasks(page) {
        $rootScope.loadingProgress = true;
        $timeout(function () {
          vm.currentTasks = paginate(vm.tasks, vm.pagination.perPageCount, page);
          vm.hasPlansTasks = !!vm.currentTasks.length;
          $rootScope.loadingProgress = false;
        }, 450);
      }

      function editOrder(ev, orderId) {
        OrderDialog.editTask(ev, { id: orderId }, function () { });
      }

      function editPlan(textContent, alertTitle) {
        return new Promise(function (resolve, reject) {
          textContent = textContent || 'PLANS.TOAST.EDITED';
          $rootScope.loadingProgress = true;
          var payload = angular.copy(vm.plans);
          delete payload.orders;
          plansApi.save(payload).then(function (result) {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($translate.instant(textContent, { plan: vm.plans.name }))
                  .hideDelay(3000)
              );
              resolve();
          }).catch(function (result) {
            if (result.data.err) {
              $mdDialog.show(
                $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title($translate.instant('PLANS.DIALOG.ALERT.TITLE'))
                  .ok($translate.instant('PLANS.DIALOG.ALERT.OK'))
                  .textContent(result.data.message)
              );
              reject(result.data.message);
          }})
          .finally(function () {
            vm.broadcastFilterUpdated();
            $rootScope.loadingProgress = false;
            vm.closeDialog();
          });
        });
      }

      function createPlan() {
        $rootScope.loadingProgress = true;
        var filePath = '/plans/' + msUtils.uuidGenerator() + '.xlsx';
        uploadApi.uploadWithPreSignedPost({
          file: DialogData.spreadsheetFile,
          filePath: filePath
        }).then(function (result) {
          vm.plans = {
            name: vm.plans.name,
            description: vm.plans.description || '',
            spreadsheet: {
              path: result.path
            },
            planType: {
              id: vm.plans.planType.id
            }
          };

          plansApi.save(vm.plans).then(function (result) {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('PLANS.TOAST.SAVED', { plan: vm.plans.name }))
                .hideDelay(3000)
            );

            for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
              var field = vm.smartRewriteFields[i];
              var params = {
                reference: vm.sessionId,
                referenceType: field,
                updatedReference: result.id
              };

              gandalfApi.updateRewriteInputHistory(params);
            }
          }).catch(function (result) {
            if (result.data.err) {
              $mdDialog.show(
                $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title($translate.instant('PLANS.DIALOG.ALERT.TITLE'))
                  .ok($translate.instant('PLANS.DIALOG.ALERT.OK'))
                  .textContent(result.data.message)
              );
            }
          }).finally(function () {
            vm.broadcastFilterUpdated();
            $rootScope.loadingProgress = false;
            vm.closeDialog();
          });

        }).catch(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('PLANS.TOAST.ERROR_SAVED'))
              .hideDelay(3000)
          );
        }).finally(function () {
          question.uploadProgress = false;
        });
      }

      function closeDialog(reload) {
        $mdDialog.hide(reload);
      }

      _initialize();
    }
})();

(function () {
    'use strict';

    angular.module('app.plans').factory('ImportSpreadSheetPlansDialog', ImportSpreadSheetPlansDialog);

    /** @ngInject */
    function ImportSpreadSheetPlansDialog($mdDialog, $document) {

        return {
            import: importSpreadSheetPlans
        };

        function importSpreadSheetPlans(ev, callback) {
            _openDialog(ev, {}, callback);
        }

        function _openDialog(ev, locals, callback) {

            $mdDialog.show({
                controller: 'ImportSpreadSheetPlansDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/plans/dialogs/import-spreadsheet/import-spreadsheet-plans-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: locals,
                closeTo: {
                  top: 0,
                  left: window.innerWidth,
                  width: window.innerWidth,
                  height: window.innerHeight / 1.8
                }
            }).then(function (reload) {
                if (callback) {
                    callback(reload);
                }
            });
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.plans')
    .controller('ImportSpreadSheetPlansDialogController', ImportSpreadSheetPlansDialogController);

  /** @ngInject */
  function ImportSpreadSheetPlansDialogController($q, $rootScope, $scope, $mdDialog, $mdToast, _, $timeout, $translate,
    importsSpreadsheetService, ReadPlansSpreadSheet, servicesApi, employeesApi, PlansDialog, customersApi, equipmentsApi, UnprocessableSpreadSheetPrompt, locationsApiGraphQL,
    customersApiGraphQL
  ) {

    var vm = this;
    vm.closeDialog = closeDialog;
    vm.fileHasChange = fileHasChange;
    vm.openCreatePlanDialog = openCreatePlanDialog;
    vm.downloadSpreadsheetModel = downloadSpreadsheetModel;
    vm.dataToValidator = {};

    function downloadSpreadsheetModel() {
      window.open('assets/spreadsheets/modelo-importacao-planos-de-atividades.xlsx', '_blank');
    }

    function openCreatePlanDialog() {
      vm.disableCreateButton = true;
      $rootScope.loadingProgress = true;
      ReadPlansSpreadSheet.read(vm.file).then(function (file) {
        if (!file.values.length) {
          return UnprocessableSpreadSheetPrompt.show({
            error: 'spreadsheet-without-rows'
          });
        }
        var columns = file.columns || [];
        var validatedColumns = ReadPlansSpreadSheet.validateColumns(columns);
        if (!validatedColumns.valid) {
          return;
        }

        var searchQueryCustomersDocumentNumber = _getUniqCustomerDocumentNumber(file.values);
        var searchQueryCustomersName = _getUniqCustomerName(file.values);
        var searchQueryLocationsName = _getUniqLocationName(file.values);

        var searchQueryEquipments = _getUniqEquipmentNumbers(file.values);

        var customerDocument = customersApi.getManyByDocumentNumber(searchQueryCustomersDocumentNumber);
        var customerName = customersApiGraphQL.getCustomerSequence(searchQueryCustomersName);
        var locationName = locationsApiGraphQL.getLocationSequence(searchQueryLocationsName);
        var requests = {
          services: servicesApi.getAll(),
          employees: employeesApi.getAll(),
          customersDocuments: customerDocument,
          customersNames: customerName,
          equipments: equipmentsApi.getManyByNumber(searchQueryEquipments),
          locations: locationName
        };

        $rootScope.loadingProgress = true;
        $q.all(requests).then(function (dbItems) {
          $timeout(function () {
            var validatedRows = ReadPlansSpreadSheet.validateRows(vm.file, file.values, dbItems);
            PlansDialog.createPlan(null, validatedRows);
          }, 500);
        }).finally(function () {
            $rootScope.loadingProgress = false;
        });
      }).catch(function (err) {
        console.error(err);
        $mdToast.show($mdToast.simple().textContent($translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.COULD_NOT_READ')).hideDelay(3000));
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function fileHasChange() {
      var reader = new FileReader();
      reader.onload = function (evt) {
        vm.disableCreateButton = false;
        $scope.$apply(function ($scope) {
          if (vm.file.size > 10000000) {
            vm.fileHasError = true;
            vm.fileHasErrorMessage = $translate.instant("PLANS.DIALOG.IMPORT.ERROR.SIZE_NOT_ALLOWED");
            vm.inputFileClass = "";
          } else if (importsSpreadsheetService.isNotAllowedType(vm.file.type)) {
            vm.fileHasError = true;
            vm.fileHasErrorMessage = $translate.instant("PLANS.DIALOG.IMPORT.ERROR.TYPE_NOT_ALLOWED");
            vm.inputFileClass = "";
          } else {
            vm.fileHasError = false;
            vm.fileHasErrorMessage = "";
            vm.inputFileClass = "active";
          }
        });
      };
      if (vm.file) {
        reader.readAsDataURL(vm.file);
      }
    }

    function _getUniqCustomerDocumentNumber(values) {
      var uniqRow = _.uniq(values, function (value) { return value['DOCUMENTO DO CLIENTE']; });
      var documentsNumbers = [];
      uniqRow.forEach(function (row) {
        var documentNumber = row['DOCUMENTO DO CLIENTE'];
        if (documentNumber) {
          documentNumber = documentNumber.replace(/[^\w\s]/gi, '').replace(/\s/g,'');
          documentsNumbers.push(documentNumber);
        }
      });
      return documentsNumbers;
    }

    function _getUniqCustomerName(values) {
      var uniqRow = _.uniq(values, function (value) { return value['NOME DO CLIENTE']; });
      var names = [];
      uniqRow.forEach(function (row) {
        var name = row['NOME DO CLIENTE'];
        if (name) {
          names.push(name);
        }
      });
      return names;
    }

    function _getUniqEquipmentNumbers(values) {
      var uniqRow = _.uniq(values, function (value) { return value['NÚMERO DE SÉRIE – EQUIPAMENTO (OPCIONAL)']; });
      var serialNumbers = [];
      uniqRow.forEach(function (row) {
        var serialNumber = row['NÚMERO DE SÉRIE – EQUIPAMENTO (OPCIONAL)'];
        if (serialNumber) {
          serialNumber.trim();
          serialNumbers.push(serialNumber);
        }
      });
      return serialNumbers;
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }

    function _getUniqLocationName(values){
      var uniqRow = _.uniq(values, function (value) { return value['NOME DA LOCALIZAÇÃO (OPCIONAL)']; });
      var locationsName = [];
      uniqRow.forEach(function (row) {
        var locationName = row['NOME DA LOCALIZAÇÃO (OPCIONAL)'];
        if (locationName) {
          locationsName.push(locationName);
        }
      });
      return locationsName;
    }
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('videosSidenav', videosSidenav);

  /** @ngInject */
  function videosSidenav()
  {
    return {
      restrict   : 'E',
      scope      : {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/videos/videos.html',
      controller: 'VideosSidenavController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app.modules')
    .controller('VideosSidenavController', VideosSidenavController);

  /** @ngInject */
  function VideosSidenavController(Account, Configuration, ModulesService, $mdDialog, $window, EnvironmentConfig) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;

    vm.requestActivation = requestActivation;
    vm.closeDialog = closeDialog;

    function requestActivation() {
      vm.disableButton = true;

      $window.open(EnvironmentConfig.ereborClientUrl + 'assinaturas?module=video', '_self');
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('vehiclesSidenav', vehiclesSidenav);

  /** @ngInject */
  function vehiclesSidenav()
  {
    return {
      restrict   : 'E',
      scope      : {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/vehicles/vehicles.html',
      controller: 'VehiclesSidenavController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('VehiclesSidenavController', VehiclesSidenavController);

  /** @ngInject */
  function VehiclesSidenavController(Account, Configuration, ModulesService, $mdDialog, $window, EnvironmentConfig) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;

    vm.requestActivation = requestActivation;
    vm.closeDialog = closeDialog;

    function requestActivation() {
      vm.disableButton = true;

      $window.open(EnvironmentConfig.ereborClientUrl + 'assinaturas?module=vehiclesModule', '_self');
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.modules')
      .factory('TicketsModuleService', TicketsModuleService);

  /** @ngInject */
  function TicketsModuleService($rootScope, ticketsConfigurationsWargApi, EnvironmentConfig, authenticatedUser, msUtils, wargApi, servicesApi, $mdToast, $translate, attachmentsUtils, accountsApi) {

    return {
      getTicketsUrl: getTicketsUrl,
      getDefaultTicketsSettings: getDefaultTicketsSettings,
      getTicketsSettings: getTicketsSettings,
      getServices: getServices,
      verifySlugExistence: verifySlugExistence,
      saveTicketsSettings: saveTicketsSettings,
      disableTickets: disableTickets,
      getSettings: getSettings
    };

    function getSettings(account) {
      return ticketsConfigurationsWargApi.getTicketConfiguration(account)
        .then(function (response) {
          return response.configuration;
        });
    }

    function _onSucess() {
      $rootScope.loadingProgress = false;

      return true;
    }

    function _onError() {
      $rootScope.loadingProgress = false;

      $mdToast.show(
        $mdToast.simple()
          .textContent($translate.instant('MODULES.MODULES_ERROR'))
          .theme('error-toast')
          .hideDelay(2000)
      );

      return false;
    }

    function getTicketsUrl() {
      return EnvironmentConfig.wargBaseUrl + '/';
    }

    function getDefaultTicketsSettings(account) {
      return {
        active: account.active,
        accountId: account.id,
        company: account.name,
        services: [],
        logoUrl: account.logoUrl,
        slug: msUtils.slugify(account.name)
      };
    }

    function getTicketsSettings() {
      $rootScope.loadingProgress = true;

      return wargApi.getAccount(authenticatedUser.profile.accountId)
        .then(function (response) {
          $rootScope.loadingProgress = false;

          var ticketsSettings = {};
          if (response.data.account) {
              ticketsSettings = response.data.account;
          }
          return ticketsSettings;
        }).catch(function () {
          $rootScope.loadingProgress = false;

          return {};
        });
    }

    function getServices() {
      return servicesApi.getAll().then(function (result) {
        return _.filter(result.items, function (service) {
          return !service.archived;
        });
      });
    }

    function verifySlugExistence(slug, account) {
      return wargApi.getBySlug(slug).then(function (response) {
        return response.data && response.data.account && response.data.account.accountId !== account.id;
      });
    }

    function saveTicketsSettings(account, ticketsSettings) {
      $rootScope.loadingProgress = true;
      var settings = angular.copy(ticketsSettings);

      settings.logoUrl = attachmentsUtils.correctUrl(settings.logoUrl);
      settings.services = settings.services.map(function (service) {
        return service.description;
      }).filter(function (service) { return !service.archived; });

      return wargApi.getAccount(account.id).then(function (response) {
        var saveOrUpdate = response.data.message === 'Account not found' ? wargApi.saveAccount : wargApi.updateAccount;

        return saveOrUpdate(settings)
          .then(_onSucess)
          .catch(_onError);
      })
      .catch(_onError);
    }

    function disableTickets(account) {
      return wargApi.removeAccount(account.id)
        .then(_onSucess)
        .catch(_onError);
    }
  }

})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('ticketsSidenav', ticketsSidenav);

  /** @ngInject */
  function ticketsSidenav()
  {
    return {
      restrict   : 'E',
      scope      : {
        configuration: '=',
        account: '=',
        tickets: '='
      },
      templateUrl: 'app/main/modules/sidenavs/tickets/tickets.html',
      controller: 'TicketsSidenavController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('TicketsSidenavController', TicketsSidenavController);

  /** @ngInject */
  function TicketsSidenavController(
    $scope, Account, Configuration, TicketsModuleService,
    ModulesService, $mdDialog, $mdToast,
    $q, $translate, $rootScope, accountsApi
  ) {
    var vm = this;

    vm.currentUnixTimeVersion = '?v=' + new Date().getTime();
    vm.configuration = Configuration;
    vm.account = angular.copy(Account);
    vm.wargUrl = TicketsModuleService.getTicketsUrl();
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.forceConfiguration = false;
    vm.disableButton = false;
    vm.services = [];
    vm.searchServiceTypeTerm = '';
    vm.ticketsSettings = {};
    vm.ticketsLoading = true;

    vm.tickets = {
      featureShowAddressFields: false,
      featureMandatoryAddressFields: false,
    };

    _loadConfiguration();

    vm.enableModule = enableModule;
    vm.disableModule = disableModule;
    vm.separateNonCorporateServices = separateNonCorporateServices;
    vm.saveModuleSettings = saveModuleSettings;
    vm.finalizeModuleActivation = finalizeModuleActivation;
    vm.cancelModuleActivation = cancelModuleActivation;
    vm.verifyTicketsSlug = verifyTicketsSlug;
    vm.closeDialog = closeDialog;

    _initialize();

    function _initialize() {
      vm.ticketsLoading = true;

      var requests = {
        services: TicketsModuleService.getServices(),
        ticketSettings: TicketsModuleService.getTicketsSettings()
      };

      $q.all(requests).then(function (response) {
        vm.services = vm.separateNonCorporateServices(response);

        if(_.isEmpty(response.ticketSettings)) {
          vm.ticketsSettings = TicketsModuleService.getDefaultTicketsSettings(vm.account);
        } else {
          vm.ticketsSettings = response.ticketSettings;
        }

        vm.verifyTicketsSlug();

        vm.ticketsSettings.services = vm.ticketsSettings.services.map(function (serviceDescription) {
          return vm.services.find(function (service) {
            return service.description === serviceDescription;
          });
        }).filter(function (service) { return service; });

        vm.ticketsLoading = false;
      });
    }

    function _changeModule(condition) {
      accountsApi.get().then(function (account) {
        account.configuration[vm.configuration.configurationName] = condition;
        account.configuration.moduleWargSlug = condition ? vm.ticketsSettings.slug : null;

        ModulesService.saveConfiguration(account.configuration)
          .then(function (result) {
            if(!result) {
              _onError();
            }

            $rootScope.$broadcast('reload:account');
          });
      });
    }

    function _loadConfiguration() {
      TicketsModuleService.getSettings(vm.account).then(function (configuration) {

        Object.keys(configuration).forEach(function (name) {
          var isTrue = (configuration[name] === true);
          vm.tickets[name] = isTrue ? isTrue : configuration[name];
        });
      }).catch(function () {

        vm.tickets = {
          featureShowAddressFields: false,
          featureMandatoryAddressFields: false,
        };
      });
    }

    function _onError() {
      vm.disableButton = false;
    }

    function enableModule() {
      vm.disableButton = true;

      if (
        vm.ticketsSettings.services &&
        vm.ticketsSettings.slug &&
        vm.ticketsSettings.services.length &&
        vm.ticketsSettings.slug.length
      ) {
        _changeModule(true);
      } else {
        vm.forceConfiguration = true;
        vm.disableButton = false;
      }
    }

    function separateNonCorporateServices(responseData) {
      var nonCorporateServices = [];

      for (var service in responseData.services) {
        var currentService = responseData.services[service];

        if (currentService.metadata && currentService.metadata.sammathnaur) {
          continue;
        }
        nonCorporateServices.push(currentService);
      }

      return nonCorporateServices;
    }

    function disableModule(event) {
      var confirmDisable = $mdDialog.confirm()
        .title($translate.instant('MODULES.DISABLE_MODULE.TITLE'))
        .textContent($translate.instant('MODULES.DISABLE_MODULE.CONTENT'))
        .targetEvent(event)
        .ok($translate.instant('MODULES.DISABLE'))
        .cancel($translate.instant('MODULES.CANCEL'));

      $mdDialog.show(confirmDisable).then(function () {
        vm.disableButton = true;

        TicketsModuleService.disableTickets(vm.account)
        .then(function (result) {
          if (result) {
            _changeModule(false);
          } else {
            _onError();
          }
        });
      });
    }

    function saveModuleSettings() {
      vm.disableButton = true;

      if (!vm.tickets.featureShowAddressFields) {
        vm.tickets.featureMandatoryAddressFields = false;
      }

      vm.ticketsSettings['configuration'] = angular.copy(vm.tickets);

      TicketsModuleService.saveTicketsSettings(vm.account, vm.ticketsSettings)
        .then(function (result) {
          $rootScope.$broadcast('reload:account');

          _changeModule(true);

          if (result) {
            vm.disableButton = false;

            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant("MODULES.MODULES_SAVED"))
                .hideDelay(2000)
            );

            $scope.ticketsForm.$setPristine();
            vm.closeDialog();
          } else {
            _onError();
          }
        });
    }

    function finalizeModuleActivation() {
      vm.disableButton = true;

      TicketsModuleService.saveTicketsSettings(vm.account, vm.ticketsSettings)
        .then(function (result) {
          if (result) {
            _changeModule(true);
          } else {
            _onError();
          }
        });
    }

    function cancelModuleActivation() {
      vm.forceConfiguration = false;
      vm.ticketsSettings = TicketsModuleService.getDefaultTicketsSettings(vm.account);
    }

    function verifyTicketsSlug() {
      TicketsModuleService.verifySlugExistence(vm.ticketsSettings.slug, vm.account)
        .then(function (slugAlreadyExists) {
          if (slugAlreadyExists) {
            $scope.ticketsForm.slug.$setTouched();
            $scope.ticketsForm.slug.$setValidity('existent', false);
          } else {
            $scope.ticketsForm.slug.$setValidity('existent', true);
          }
        });
    }

    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.modules')
    .directive('territoriesSidenav', territoriesSidenav);

  /** @ngInject */
  function territoriesSidenav() {
    return {
      restrict: 'E',
      scope: {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/territories/territories.html',
      controller: 'TerritoriesControlSidenavController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.modules').controller('TerritoriesControlSidenavController', TerritoriesControlSidenavController);

  /** @ngInject */
  function TerritoriesControlSidenavController(
    Account,
    Configuration,
    $mdDialog,
    $window,
    accountFeatureFlagsApiGraphQL,
    $mdToast,
    $timeout,
    $rootScope,
    $translate
  ) {
    var vm = this;
    vm.accountConfiguration = angular.copy(Account.configuration);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;

    vm.changeModule = changeModule;
    vm.closeDialog = closeDialog;

    function changeModule(condition) {
      vm.disableButton = true;
      $rootScope.loadingProgress = true;

      return accountFeatureFlagsApiGraphQL.updateAccountFeatureFlag('territories',  condition)
        .then(function () {
          $rootScope.loadingProgress = false;
          vm.disableButton = false;

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("MODULES.MODULES_SAVED"))
              .hideDelay(2000)
          );

          $window.location.reload(true);

          return true;
        }).catch(function () {
          $rootScope.loadingProgress = false;
          vm.disableButton = false;

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('MODULES.MODULES_ERROR'))
              .theme('error-toast')
              .hideDelay(2000)
          );

          return false;
        });
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.modules')
    .directive('templatesSidenav', templatesSidenav);

  /** @ngInject */
  function templatesSidenav() {
    return {
      restrict: 'E',
      scope: {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/templates/templates.html',
      controller: 'TemplatesSidenavController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.modules').controller('TemplatesSidenavController', TemplatesSidenavController);

  /** @ngInject */
  function TemplatesSidenavController(
    Account,
    Configuration,
    ModulesService,
    $mdDialog,
    $window,
    EnvironmentConfig
  ) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.accountConfiguration = angular.copy(Account.configuration);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;
    vm.requestActivation = requestActivation;
    vm.closeDialog = closeDialog;
    vm.changeModule = changeModule;

    function changeModule(condition) {
      vm.disableButton = true;

      vm.accountConfiguration[vm.configuration.configurationName] = condition;

      ModulesService.saveConfiguration(vm.accountConfiguration).then(function (result) {
        if (!result) {
          vm.disableButton = false;
        }
      });
    }

    function requestActivation() {
      vm.disableButton = true;

      $window.open(EnvironmentConfig.ereborClientUrl + 'assinaturas?module=templatesModule', '_self');
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('tasksPlansSidenav', tasksPlansSidenav);

  /** @ngInject */
  function tasksPlansSidenav()
  {
    return {
      restrict   : 'E',
      scope      : {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/tasks-plans/tasks-plans.html',
      controller: 'TasksPlansSidenavController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('TasksPlansSidenavController', TasksPlansSidenavController);

  /** @ngInject */
  function TasksPlansSidenavController(Account, Configuration, ModulesService, $mdDialog) {
    var vm = this;
    vm.accountConfiguration = angular.copy(Account.configuration);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;

    vm.changeModule = changeModule;
    vm.closeDialog = closeDialog;

    function changeModule(condition) {
      vm.disableButton = true;

      vm.accountConfiguration[vm.configuration.configurationName] = condition;

      ModulesService.saveConfiguration(vm.accountConfiguration)
        .then(function (result) {
          if (!result) {
            vm.disableButton = false;
          }
        });
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.modules')
    .directive('storageControlSidenav', storageControlSidenav);

  /** @ngInject */
  function storageControlSidenav() {
    return {
      restrict: 'E',
      scope: {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/storage-control/storage-control.html',
      controller: 'StorageControlSidenavController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.modules').controller('StorageControlSidenavController', StorageControlSidenavController);

  /** @ngInject */
  function StorageControlSidenavController(
    Account,
    Configuration,
    ModulesService,
    $mdDialog,
    $window,
    EnvironmentConfig
  ) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.accountConfiguration = angular.copy(Account.configuration);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;
    vm.requestActivation = requestActivation;
    vm.closeDialog = closeDialog;
    vm.changeModule = changeModule;

    function changeModule(condition) {
      vm.disableButton = true;

      vm.accountConfiguration[vm.configuration.configurationName] = condition;

      ModulesService.saveConfiguration(vm.accountConfiguration).then(function (result) {
        if (!result) {
          vm.disableButton = false;
        }
      });
    }

    function requestActivation() {
      vm.disableButton = true;

      $window.open(EnvironmentConfig.ereborClientUrl + 'assinaturas?module=storageControlModule', '_self');
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.modules')
    .factory('SmartRewriteModuleService', SmartRewriteModuleService);

  /** @ngInject */
  function SmartRewriteModuleService(smartRewriteApi) {

    return {
      getAccountUsage: getAccountUsage,
      getAccountHistory: getAccountHistory
    };

    function getAccountUsage() {
      return smartRewriteApi.getAccountUsage()
        .then(function (response) {
          return response && response.data;
        });
    }

    function getAccountHistory(params) {
      return smartRewriteApi.getAccountHistory(params)
        .then(function (response) {
          return response && response.data;
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.modules')
    .directive('smartRewriteSidenav', smartRewriteSidenav);

  /** @ngInject */
  function smartRewriteSidenav() {
    return {
      restrict: 'E',
      scope: {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/smart-rewrite/smart-rewrite.html',
      controller: 'SmartRewriteSidenavController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.modules').controller('SmartRewriteSidenavController', SmartRewriteSidenavController);

  /** @ngInject */
  function SmartRewriteSidenavController(
    Account,
    Configuration,
    ModulesService,
    $mdDialog,
    $window,
    EnvironmentConfig,
    SmartRewriteModuleService,
    LocalDateConvert
  ) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.accountConfiguration = angular.copy(Account.configuration);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;
    vm.requestActivation = requestActivation;
    vm.closeDialog = closeDialog;
    vm.changeModule = changeModule;
    vm.loadMore = loadMore;
    vm.buyCredits = buyCredits;
    vm.openVideoModal = openVideoModal;
    vm.activeTab = 0;
    vm.canLoadMore = false;

    vm.lastEvaluatedKey = '';
    vm.items = [];

    vm.usedCredits = 0;
    vm.maxCredits = 2000;
    vm.extraCredits = 0;

    vm.olderItems = [];
    vm.yesterdayItems = [];
    vm.todayItems = [];

    function changeModule(condition) {
      vm.disableButton = true;

      vm.accountConfiguration[vm.configuration.configurationName] = condition;

      ModulesService.saveConfiguration(vm.accountConfiguration).then(function (result) {
        if (!result) {
          vm.disableButton = false;
        }
      });
    }

    function requestActivation() {
      vm.disableButton = true;

      $window.open(EnvironmentConfig.ereborClientUrl + 'assinaturas?module=smartRewriteModule', '_self');
    }

    function buyCredits() {
      vm.disableButton = true;

      $window.open(EnvironmentConfig.ereborClientUrl + 'assinaturas?module=smartRewriteModule&credits=true', '_self');
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function openVideoModal() {
      var event = new CustomEvent('openVideoInfo',  { detail: { type: 'smart-rewrite', link: 'https://www.youtube.com/embed/lT837apfqBk?si=m1tZnjch-S2rmIgE' } });

      document.dispatchEvent(event);
    }

    function _loadData() {
      SmartRewriteModuleService.getAccountUsage().then(function (usage) {
        vm.usedCredits = usage.creditsUsage;
        vm.maxCredits = usage.maxCredits;
        vm.extraCredits = usage.extraCredits;
      });

      SmartRewriteModuleService.getAccountHistory({}).then(function (history) {
        vm.items = history.items;
        vm.lastEvaluatedKey = history.lastEvaluatedKey;

        vm.olderItems = vm.items.filter(function (item) {
          item.displayDate = LocalDateConvert.formatDate(item.createdAt, 'date-time');
          return moment(item.createdAt).isBefore(moment().startOf('day').subtract(1, 'days').valueOf());
        });

        vm.yesterdayItems = vm.items.filter(function (item) {
          return moment(item.createdAt).isAfter(moment().startOf('day').subtract(1, 'days').valueOf()) && moment(item.createdAt).isBefore(moment().startOf('day').valueOf());
        });

        vm.todayItems = vm.items.filter(function (item) {
          return moment(item.createdAt).isAfter(moment().startOf('day').valueOf());
        });

        if (vm.items && vm.items.length === 10 && vm.lastEvaluatedKey) {
          vm.canLoadMore = true;
        }
      });
    }

    function loadMore() {
      SmartRewriteModuleService.getAccountHistory({ lastEvaluatedKey: vm.lastEvaluatedKey }).then(function (history) {
        vm.items = vm.items.concat(history.items);
        vm.lastEvaluatedKey = history.lastEvaluatedKey;

        vm.olderItems = vm.items.filter(function (item) {
          item.displayDate = LocalDateConvert.formatDate(item.createdAt, 'date-time');
          return moment(item.createdAt).isBefore(moment().startOf('day').subtract(1, 'days').valueOf());
        });

        vm.yesterdayItems = vm.items.filter(function (item) {
          return moment(item.createdAt).isAfter(moment().startOf('day').subtract(1, 'days').valueOf()) && moment(item.createdAt).isBefore(moment().startOf('day').valueOf());
        });

        vm.todayItems = vm.items.filter(function (item) {
          return moment(item.createdAt).isAfter(moment().startOf('day').valueOf());
        });

        if (history.items.length === 0 || !history.itemsOnPage || !history.lastEvaluatedKey) {
          this.canLoadMore = false;
        }
      });
    }

    _loadData();
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('routeOptimizerSidenav', routeOptimizerSidenav);

  /** @ngInject */
  function routeOptimizerSidenav()
  {
    return {
      restrict   : 'E',
      scope      : {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/route-optimizer/route-optimizer.html',
      controller: 'RouteOptmizerSidenavController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('RouteOptimizerSidenavController', RouteOptmizerSidenavController);

  /** @ngInject */
  function RouteOptmizerSidenavController(Account, Configuration, accountFeatureFlagsApiGraphQL, $mdDialog, $window, EnvironmentConfig, routerizationApi) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.isAdvancedModuleEnabled = vm.configuration.isAdvancedEnabled;
    vm.disableButton = false;
    vm.requestActivation = requestActivation;
    vm.openVideoModal = openVideoModal;
    vm.closeDialog = closeDialog;
    vm.credits = 0;
    vm.buyCredits = buyCredits;

    function requestActivation() {
      vm.disableButton = true;

      _openModuleInfoElement('advanced_route_optimization', false);
    };

    function _loadData() {
      getUsage();
    }

    function getUsage() {
      routerizationApi.getRequestUsage()
        .then(function (response) {
          var accountUsage = response.data;
          var routerModule =  vm.isAdvancedModuleEnabled ? "advancedRequestsQuota" : "requestsQuota";
          vm.credits = accountUsage[routerModule];
        });
    }

    function buyCredits() {
      vm.disableButton = true;
      $window.open(EnvironmentConfig.ereborClientUrl + "assinaturas?module=advancedRouteOptimizationModule", '_self');
    }

    function openVideoModal() {
      var event = new CustomEvent('openVideoInfo',  { detail: { type: 'advanced-route-optimization', link: 'https://www.youtube.com/embed/GlXDg3lO2fI?si=yeMqghQkBSsLU-Cl' } });

      document.dispatchEvent(event);

      vm.disableButton = false;
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function _openModuleInfoElement(module, isEnabled) {
      var event = new CustomEvent('openModuleInfo',  { detail: { type: module, hired: isEnabled } });

      document.dispatchEvent(event);
    }

    _loadData();
  }
})();

(function () {
  'use strict';

  angular.module('app.modules')
    .factory('PrintConfigurationModuleService', PrintConfigurationModuleService);

  /** @ngInject */
  function PrintConfigurationModuleService(printConfigurationApi, $mdToast, $translate, $rootScope, $mdDialog) {

    return {
      saveSettings: saveSettings,
      getSettings: getSettings
    };

    function getSettings() {
      return printConfigurationApi.getPrintConfiguration()
        .then(function (response) {
          var configurations = [];
          if (response && response.configurations) {
            response.configurations.forEach(function (item) {
              configurations[item.name] = item.value;
            });
          }

          return configurations;
        });
    }

    function saveSettings(configuration) {
      var payload = {
        configurations: []
      };
      Object.keys(configuration).forEach(function (name) {
        payload.configurations.push({
          name: name,
          value: String(configuration[name])
        });
      });

      $rootScope.loadingProgress = true;
      return printConfigurationApi.createPrintConfiguration(payload)
        .then(function () {
          $rootScope.loadingProgress = false;
          _showSuccessMessage();
        })
        .catch(function () {
          _showErrorMessage();
        });
    }

    function _showSuccessMessage(message) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message || $translate.instant("MODULES.MODULES_SAVED"))
          .hideDelay(2000)
      );
      $mdDialog.hide();
    }

    function _showErrorMessage(message) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message || $translate.instant('MODULES.MODULES_ERROR'))
          .theme('error-toast')
          .hideDelay(2000)
      );
    }
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('printConfigurationSidenav', printConfigurationSidenav);

  /** @ngInject */
  function printConfigurationSidenav()
  {
    return {
      restrict   : 'E',
      scope      : {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/print-configuration/print-configuration.html',
      controller: 'PrintConfigurationSidenavController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('PrintConfigurationSidenavController', PrintConfigurationSidenavController);

  /** @ngInject */
  function PrintConfigurationSidenavController($scope, Account, Configuration, $translate,
                                              PrintConfigurationModuleService, $mdDialog) {
    var vm = this;
    vm.disableButton = false;
    vm.account = Account;
    vm.accountConfiguration = angular.copy(Account.configuration);
    vm.configuration = Configuration;
    vm.saveConfiguration = saveConfiguration;
    vm.printConfigurationLoading = true;
    vm.printConfiguration = {
      complementaryInfos: null,
      showEquipmentsCustomFields: true,
      sortFormsBy: 'date',
      sortEquipmentsBy: 'linkage',
      showOrderCreationDate: true,
      showCustomerNotes: false,
      showTaskDuration: false,
      showEmployeeImage: true,
      showFormFillingData: true,
      showFormSelectedResponses: false,
      showFormTotalScore: true,
      hideQuestionsWithoutAnswers: false,
      showEquipmentsQrCode: false,
      hideProductValue: false,
      showStartAndCompleteTime: true,
      showOptionsDescriptions: false,
      attachmentsColumnsQuantity: '4',
      seeFormAnswersInOneColumn: false,
      showEmployeesCoordinates: false,
      autoPageBreak: false
    };
    vm.sortFormsByOptions = {
      date: $translate.instant('PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORMS_ORDINATION_OPTIONS.DATE'),
      name: $translate.instant('PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORMS_ORDINATION_OPTIONS.NAME')
    };
    vm.sortEquipmentsByOptions = {
      linkage: $translate.instant('PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.EQUIPMENTS_ORDINATION_OPTIONS.LINKAGE'),
      name: $translate.instant('PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.EQUIPMENTS_ORDINATION_OPTIONS.NAME')
    };

    vm.closeDialog = closeDialog;

    function saveConfiguration() {
      if ($scope.printConfigurationForm.$valid) {
        vm.disableButton = true;
        PrintConfigurationModuleService.saveSettings(vm.printConfiguration)
        .finally(function () {
          vm.disableButton = false;
          $scope.printConfigurationForm.$setPristine();
        });
      }
    }

    function _loadConfiguration() {
      vm.printConfigurationLoading = true;

      PrintConfigurationModuleService.getSettings().then(function (configuration) {
        Object.keys(configuration).forEach(function (name) {
          var isTrue = (configuration[name] === 'true');
          vm.printConfiguration[name] = isTrue ? isTrue : configuration[name];
        });

        vm.printConfigurationLoading = false;
      });
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    _loadConfiguration();

  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('materialsSidenav', materialsSidenav);

  /** @ngInject */
  function materialsSidenav()
  {
    return {
      restrict   : 'E',
      scope      : {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/materials/materials.html',
      controller: 'MaterialsSidenavController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('MaterialsSidenavController', MaterialsSidenavController);

  /** @ngInject */
  function MaterialsSidenavController(Account, Configuration, ModulesService, $mdDialog) {
    var vm = this;
    vm.accountConfiguration = angular.copy(Account.configuration);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;

    vm.changeModule = changeModule;
    vm.closeDialog = closeDialog;

    function changeModule(condition) {
      vm.disableButton = true;

      vm.accountConfiguration[vm.configuration.configurationName] = condition;

      ModulesService.saveConfiguration(vm.accountConfiguration)
        .then(function (result) {
          if (!result) {
            vm.disableButton = false;
          }
        });
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('imageResolutionSidenav', imageResolutionSidenav);

  /** @ngInject */
  function imageResolutionSidenav()
  {
    return {
      restrict   : 'E',
      scope      : {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/image-resolution/image-resolution.html',
      controller: 'ImageResolutionSidenavController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('ImageResolutionSidenavController', ImageResolutionSidenavController);

  /** @ngInject */
  function ImageResolutionSidenavController(Account, Configuration, ModulesService, $mdDialog, $window, EnvironmentConfig) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;

    vm.requestActivation = requestActivation;
    vm.closeDialog = closeDialog;

    function requestActivation() {
      vm.disableButton = true;

      $window.open(EnvironmentConfig.ereborClientUrl + 'assinaturas?module=highResolutionImages', '_self');
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('equipmentsSidenav', equipmentsSidenav);

  /** @ngInject */
  function equipmentsSidenav()
  {
    return {
      restrict   : 'E',
      scope      : {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/equipments/equipments.html',
      controller: 'EquipmentsSidenavController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('EquipmentsSidenavController', EquipmentsSidenavController);

  /** @ngInject */
  function EquipmentsSidenavController(Account, Configuration, ModulesService, $mdDialog, $window, EnvironmentConfig) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;

    vm.requestActivation = requestActivation;
    vm.saveModuleSettings = saveModuleSettings;
    vm.closeDialog = closeDialog;

    function requestActivation() {
      vm.disableButton = true;

      $window.open(EnvironmentConfig.ereborClientUrl + 'assinaturas?module=equipmentsModule', '_self');
    }

    function saveModuleSettings() {
      vm.disableButton = true;

      ModulesService.saveConfiguration(vm.account.configuration)
        .then(function (result) {
          if(!result) {
            vm.disableButton = false;
          }
        });
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.modules')
    .directive('deadlinesSidenav', deadlinesSidenav);

  /** @ngInject */
  function deadlinesSidenav() {
    return {
      restrict: 'E',
      scope: {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/deadlines/deadlines.html.html',
      controller: 'DeadlinesSidenavController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.modules')
    .controller('DeadlinesSidenavController', DeadlinesSidenavController);

  /** @ngInject */
  function DeadlinesSidenavController(Account, Configuration, ModulesService, $mdDialog, $window, EnvironmentConfig) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.accountConfiguration = angular.copy(Account.configuration);
    vm.configuration = Configuration;
    vm.showModuleSettings = vm.configuration.isEnable;
    vm.disableButton = false;
    vm.requestActivation = requestActivation;
    vm.closeDialog = closeDialog;
    vm.changeModule = changeModule;

    function changeModule(condition) {
      vm.disableButton = true;

      vm.accountConfiguration[vm.configuration.configurationName] = condition;

      ModulesService.saveConfiguration(vm.accountConfiguration)
        .then(function (result) {
          if (!result) {
            vm.disableButton = false;
          }
        });
    }


    function requestActivation() {
      vm.disableButton = true;

      $window.open(EnvironmentConfig.ereborClientUrl + 'assinaturas?module=deadlineModule', '_self');
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.modules')
      .factory('CustomersAreaModuleService', CustomersAreaModuleService);

  /** @ngInject */
  function CustomersAreaModuleService(warg2CompaniesApi, warg2OrganizationsApi, accountsApi, $mdToast, $translate) {

    return {
      getCompany: getCompany,
      verifySlugExistence: verifySlugExistence,
      getOrganization: getOrganization,
      loadActiveOrganizations: loadActiveOrganizations,
      enable: enable,
      disable: disable,
      saveSettings: saveSettings,
      syncCustomer: syncCustomer,
      syncCompany: syncCompany
    };

    function _showSuccessMessage(message) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message || $translate.instant("MODULES.MODULES_SAVED"))
          .hideDelay(2000)
      );
    }

    function _showErrorMessage(message) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(message || $translate.instant('MODULES.MODULES_ERROR'))
          .theme('error-toast')
          .hideDelay(2000)
      );
    }

    function getCompany() {
      return warg2CompaniesApi.getCompany();
    }

    function verifySlugExistence(slug) {
      return warg2CompaniesApi.companySlugExists(slug);
    }

    function getOrganization(id) {
      return warg2OrganizationsApi.getOrganization(id);
    }

    function loadActiveOrganizations() {
      return warg2OrganizationsApi.getOrganizations({
        active: true
      }, 1000, 0);
    }

    function _updateWarg2Slug(slug) {
      return accountsApi.get().then(function (account) {
        var configurations = account.configuration || {};
        configurations.moduleWarg2Slug = slug;
        return accountsApi.saveConfigurations(configurations);
      });
    }

    function enable(id, company) {
      function onThen() {
        _showSuccessMessage($translate.instant('CUSTOMERS_AREA_MODULE.ENABLE_SUCCESS'));
      }

      function onCatch() {
        _showErrorMessage();
      }

      var apiMethod = id ? warg2CompaniesApi.updateCompany : warg2CompaniesApi.createCompany;
      var params = id ? [id, company] : [company];

      return apiMethod.apply(null, params)
        .then(function (response) {
          return _updateWarg2Slug(company.slug).then(function () {
            return response;
          });
        })
        .then(onThen)
        .catch(onCatch);
    }

    function disable(id) {
      var company = {
        active: false
      };

      return warg2CompaniesApi.updateCompany(id, company)
        .then(function () {
          return _updateWarg2Slug(null);
        })
        .then(function () {
          _showSuccessMessage($translate.instant('CUSTOMERS_AREA_MODULE.DISABLE_SUCCESS'));
        })
        .catch(function () {
          _showErrorMessage();
        });
    }

    function saveSettings(id, company) {
      return warg2CompaniesApi.updateCompany(id, company)
        .then(function () {
          var configurations = company.configuration || {};
          configurations.moduleWarg2Slug = company.slug;
          accountsApi.saveConfigurations(configurations)
            .then(function () {
              _showSuccessMessage();
            })
            .catch(function () {
              _showErrorMessage();
            });
        })
        .catch(function () {
          _showErrorMessage();
        });
    }

    function syncCustomer(customer) {
      return warg2OrganizationsApi.updateOrganization(customer)
        .then(function () {
          _showSuccessMessage($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.SYNC_SUCCESS"));
        })
        .catch(function () {
          _showErrorMessage($translate.instant("CUSTOMERS_AREA_MODULE.CUSTOMERS.SYNC_ERROR"));
        });
    }

    function syncCompany(id, company) {
      return warg2CompaniesApi.updateCompany(id, company)
        .then(function () {
          _showSuccessMessage($translate.instant('CUSTOMERS_AREA_MODULE.SYNC_SUCCESS'));
        })
        .catch(function () {
          _showErrorMessage($translate.instant("CUSTOMERS_AREA_MODULE.SYNC_ERROR"));
        });
    }
  }

})();

(function ()
{
  'use strict';

  angular
    .module('app.modules')
    .directive('customersAreaSidenav', customersAreaSidenav);

  /** @ngInject */
  function customersAreaSidenav()
  {
    return {
      restrict   : 'E',
      scope      : {
        configuration: '=',
        account: '='
      },
      templateUrl: 'app/main/modules/sidenavs/customers-area/customers-area.html',
      controller: 'CustomersAreaSidenavController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
  .module('app.modules')
  .controller('CustomersAreaSidenavController', CustomersAreaSidenavController);

  /** @ngInject */
  function CustomersAreaSidenavController($scope, Account, Configuration, $rootScope, $mdDialog, CustomersAreaModuleService, ModulesService, msUtils, $translate, $window, EnvironmentConfig) {
    var vm = this;
    vm.configuration = Configuration;
    vm.account = angular.copy(Account);
    console.log('carreguei');
    vm.showModuleSettings = vm.configuration.isEnable;

    vm.disableButton = false;
    vm.activeTab = 0;

    vm.wargUrl = 'https://';
    vm.wargEndUrl = '.fieldcontrol.app/#/entrar';
    vm.slugPlaceholder = msUtils.slugify(vm.account.name);
    vm.customersAreaSettings = {};
    vm.activeCustomers = [];
    vm.activeCustomersLoading = true;
    vm.noActiveCustomers = false;
    vm.customersAreaChooseEmployeeOnTicketAccept = false;
    vm.activeCustomer = {};
    vm.customers = [];

    vm.changeTab = changeTab;
    vm.reload = reload;
    vm.verifyTicketsSlug = verifyTicketsSlug;
    vm.editCustomer = editCustomer;
    vm.syncCustomer = syncCustomer;
    vm.requestActivation = requestActivation;
    vm.enableModule = enableModule;
    vm.disableModule = disableModule;
    vm.saveSettings = saveSettings;
    vm.syncCompany = syncCompany;
    vm.closeDialog = closeDialog;

    _initialize();

    function _initialize() {
      vm.reload().then(function () {
        if (!vm.customersAreaSettings.active && vm.customersAreaSettings.slug && vm.customersAreaSettings.slug.length) {
          $scope.customersAreaForm.$setDirty();
          $scope.customersAreaForm.slug.$setTouched();
        }
      });
    }

    function _loadSettings() {
      vm.customersAreaChooseEmployeeOnTicketAccept = vm.account && vm.account.configuration && vm.account.configuration.customersAreaChooseEmployeeOnTicketAccept;

      return CustomersAreaModuleService.getCompany().then(function (company) {
        if (!_.isEmpty(company)) {
          vm.customersAreaSettings = company;
        }
      });
    }

    function _loadActiveCustomers() {
      vm.activeCustomersLoading = true;

      CustomersAreaModuleService.loadActiveOrganizations()
        .then(function (activeOrganizations) {
          vm.activeCustomers = activeOrganizations;

          if (!activeOrganizations.length) {
            vm.noActiveCustomers = true;
          } else {
            vm.noActiveCustomers = false;
          }

          vm.activeCustomersLoading = false;
        });
    }

    function changeTab(tabIndex, activeCustomer) {
      if (activeCustomer) {
        vm.activeCustomer = activeCustomer;
      } else {
        vm.activeCustomer = {};
      }

      vm.activeTab = tabIndex;

      var content = angular.element(document.getElementById('moduleSidenavContent'));
      content.scrollTop(0);

      if (tabIndex === 0) {
        vm.reload();
      }

      if (tabIndex === 1) {
        $scope.$broadcast('customersAreaSearchCustomersFocus');
      }
    }

    function reload() {
      return _loadSettings().then(function () {
        if (vm.customersAreaSettings.id) {
          _loadActiveCustomers();
        } else {
          vm.activeCustomersLoading = false;
        }
      });
    }

    function verifyTicketsSlug() {
      vm.disableButton = true;

      CustomersAreaModuleService.verifySlugExistence(vm.customersAreaSettings.slug)
        .then(function (slugAlreadyExists) {
          if (slugAlreadyExists) {
            $scope.customersAreaForm.slug.$setTouched();
            $scope.customersAreaForm.slug.$setValidity('existent', false);
          } else {
            $scope.customersAreaForm.slug.$setValidity('existent', true);
          }

          vm.disableButton = false;
        });
    }

    function editCustomer(customer) {
      $rootScope.loadingProgress = true;

      CustomersAreaModuleService.getOrganization(customer.id)
        .then(function (organization) {
          vm.changeTab(2, organization);

          $rootScope.loadingProgress = false;
        });
    }

    function syncCustomer(customer) {
      $rootScope.loadingProgress = true;

      CustomersAreaModuleService.syncCustomer(customer)
        .then(function () {
          $rootScope.loadingProgress = false;

          vm.reload();
        });
    }

    function requestActivation() {
      vm.disableButton = true;

      $window.open(EnvironmentConfig.ereborClientUrl + 'assinaturas?module=customerArea', '_self');
    }

    function enableModule() {
      $rootScope.loadingProgress = true;
      vm.disableButton = true;

      var company = {
        name: vm.account.name,
        slug: vm.customersAreaSettings.slug,
        logoUrl: vm.account.logoUrl,
        configuration: vm.account.configuration,
        active: true
      };

      CustomersAreaModuleService.enable(vm.customersAreaSettings.id, company)
        .then(function () {
          _loadSettings();

          $scope.customersAreaForm.$setPristine();
          $scope.customersAreaForm.$setUntouched();
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
          vm.disableButton = false;
          $rootScope.$broadcast('reload:account');
        });
    }

    function disableModule() {
      var confirm = $mdDialog.confirm({ multiple: true })
          .title($translate.instant("CUSTOMERS_AREA_MODULE.DISABLE_DIALOG.TITLE"))
          .htmlContent($translate.instant("CUSTOMERS_AREA_MODULE.DISABLE_DIALOG.MESSAGE"))
          .ok($translate.instant("CUSTOMERS_AREA_MODULE.DISABLE_DIALOG.OK"))
          .cancel($translate.instant("CUSTOMERS_AREA_MODULE.DISABLE_DIALOG.CANCEL"));

      $mdDialog.show(confirm).then(function () {
        $rootScope.loadingProgress = false;
        vm.disableButton = true;

        CustomersAreaModuleService.disable(
          vm.customersAreaSettings.id
        ).then(function () {
          _loadSettings();

          vm.changeTab(0);

          $scope.customersAreaForm.$setDirty();
          $scope.customersAreaForm.slug.$setTouched();

          $rootScope.loadingProgress = false;
          vm.disableButton = false;
        }).finally(function () {
          $rootScope.loadingProgress = false;
          vm.disableButton = false;
          $rootScope.$broadcast('reload:account');
        });
      });
    }

    function saveSettings() {
      $rootScope.loadingProgress = true;
      vm.disableButton = true;

      var company = {
        name: vm.account.name,
        slug: vm.customersAreaSettings.slug,
        logoUrl: vm.account.logoUrl,
        configuration: vm.account.configuration
      };

      company.configuration.customersAreaChooseEmployeeOnTicketAccept = vm.customersAreaChooseEmployeeOnTicketAccept;

      CustomersAreaModuleService.saveSettings(
        vm.customersAreaSettings.id,
        company
      ).then(function () {
        _loadSettings();

        $scope.customersAreaForm.$setPristine();
        $scope.customersAreaForm.slug.$setUntouched();

        $rootScope.loadingProgress = false;
        vm.disableButton = false;
      }).finally(function () {
        $rootScope.loadingProgress = false;
        vm.disableButton = false;
        $rootScope.$broadcast('reload:account');
      });
    }

    function syncCompany() {
      $rootScope.loadingProgress = true;
      vm.disableButton = true;

      var company = {
        name: vm.account.name,
        logoUrl: vm.account.logoUrl,
        configuration: vm.account.configuration
      };

      CustomersAreaModuleService.syncCompany(
        vm.customersAreaSettings.id,
        company
      ).then(function () {
        _loadSettings();

        $scope.customersAreaForm.$setPristine();
        $scope.customersAreaForm.slug.$setUntouched();

        $rootScope.loadingProgress = false;
        vm.disableButton = false;
      }).catch(function () {
        $rootScope.loadingProgress = false;
        vm.disableButton = false;
      });
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.materials', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.materials', {
      url: '/materiais',
      views: {
        'content@app': {
          templateUrl: 'app/main/materials/materials.html',
          controller: 'MaterialsController as vm'
        }
      },
      data: { titleTranslateKey: 'MATERIALS.PAGE_TITLE' },
      resolve: {
        account: function (accountsApi) {
          return accountsApi.get();
        },
        materials: function (materialsApi) {
          return materialsApi.search({}, { limit: 200, sort: '-createdAt' });
        }
      }
    });
    $translatePartialLoaderProvider.addPart('app/main/materials');
  }

})();
(function () {
  'use strict';

  angular
    .module('app.materials')
    .factory('MaterialsFilters', MaterialsFilters);

  /** @ngInject */
  function MaterialsFilters($timeout, $rootScope) {
    var filters = {
      name: '',
      archived: '1',
      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.name = '';
      filters.archived = '1';
      $timeout(function () { $rootScope.$broadcast('materials:reload'); }, 200);
    }

    function isOn() {
      var noArchivedFiltered = filters.archived === '1';
      var noNameFiltered = filters.name === '';
      return !(noArchivedFiltered && noNameFiltered);
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.materials')
    .controller('MaterialsFiltersSideNavController', MaterialsFiltersSideNavController);

  /** @ngInject */
  function MaterialsFiltersSideNavController($rootScope, msUtils, MaterialsFilters, _) {

    var vm = this;
    vm.materials = [];
    vm.materialsFilters = MaterialsFilters;
    vm.clearFilters = MaterialsFilters.clear;
    vm.filteringIsOn = MaterialsFilters.isOn;
    vm.exists = msUtils.exists;

    function broadcastFilterUpdated() {
      $rootScope.$broadcast('materials:reload');
    }

    function _initialize() {
      vm.broadcastFilterUpdated = broadcastFilterUpdated;
      vm.materialsFilters = MaterialsFilters;
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.locations', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {

    $stateProvider
      .state('app.locations', {
        url: '/localizacoes',
        views: {
          'content@app': {
            templateUrl: 'app/main/locations/locations.html',
            controller: 'LocationsController as vm'
          }
        },
        resolve: {
          account: function (accountsApi) {
            return accountsApi.get();
          }
        },
        data: { titleTranslateKey: 'LOCATIONS.PAGE_TITLE' }
      });

    $translatePartialLoaderProvider.addPart('app/main/locations');
  }
})();
(function () {
  'use strict';

  angular
    .module('app.locations')
    .factory('LocationsFilters', LocationsFilters);

  /** @ngInject */
  function LocationsFilters($rootScope, $timeout) {

    var filters = {
      locationName: null,
      locationNotes: null,
      customerName: null,
      documentNumber: null,
      street: null,
      city: null,
      state: null,
      archived: false,
      territoryId: '',
      subTerritoryIds: [],

      clear: clear,
      isOn: isOn,
      isOff: isOff,
      toSearchOptions: toSearchOptions
    };

    function clear() {
      filters.locationName = null;
      filters.locationNotes = null;
      filters.customerName = null;
      filters.documentNumber = null;
      filters.street = null;
      filters.city = null;
      filters.state = null;
      filters.archived = false;
      filters.territoryId = '';
      filters.subTerritoryIds = [];

      $timeout(function () { $rootScope.$broadcast('locations:reload'); }, 200);
    }

    function isOn() {
      var noLocationNameFiltered = filters.locationName === null;
      var noLocationNotesFiltered = filters.locationNotes === null;
      var noCustomerNameFiltered = filters.customerName === null;
      var noDocumentNumberFiltered = filters.documentNumber === null;
      var noStreetFiltered = filters.street === null;
      var noCityFiltered = filters.city === null;
      var noStateFiltered = filters.state === null;
      var noArchivedFiltered = filters.archived === false;
      var noTerritoryFiltered = !filters.territoryId;
      var noSubTerritoryFiltered = !filters.subTerritoryIds || !filters.subTerritoryIds.length;

      return !(
        noLocationNameFiltered &&
        noLocationNotesFiltered &&
        noCustomerNameFiltered &&
        noDocumentNumberFiltered &&
        noStreetFiltered &&
        noCityFiltered &&
        noStateFiltered &&
        noArchivedFiltered &&
        noTerritoryFiltered &&
        noSubTerritoryFiltered
      );
    }

    function isOff() {
      return !isOn();
    }

    function toSearchOptions() {
      var kqQueryParams = {};
      var gqlParams = {};

      if (filters.locationName) {
        kqQueryParams['locationName~~*'] = '*' + filters.locationName + '*';
        gqlParams['nameContains'] = filters.locationName;
      }

      if (filters.locationNotes) {
        kqQueryParams['locationNotes~~'] = '*' + filters.locationNotes + '*';
        gqlParams['notesContains'] = filters.locationNotes;
      }

      if (filters.customerName) {
        kqQueryParams['customerName~~*'] = '*' + filters.customerName + '*';
        gqlParams['customerNameContains'] = Array.isArray(filters.customerName) ? filters.customerName.join(", ") : filters.customerName;
      }

      if (filters.documentNumber) {
        kqQueryParams['documentNumber~~*'] = '*' + filters.documentNumber + '*';
        gqlParams['documentNumberContains'] = filters.documentNumber;
      }

      if (filters.street) {
        kqQueryParams['street~~*'] = '*' + filters.street + '*';
        gqlParams['streetContains'] = filters.street;
      }

      if (filters.city) {
        kqQueryParams['city~~*'] = '*' + filters.city + '*';
        gqlParams['cityContains'] = filters.city;
      }

      if (filters.state) {
        kqQueryParams['state~~*'] = '*' + filters.state + '*';
        gqlParams['stateContains'] = filters.state;
      }

      if (filters.archived !== null) {
        kqQueryParams['archived'] = filters.archived;
        gqlParams['archived'] = filters.archived;
      }

      if (filters.subTerritoryIds && filters.subTerritoryIds.length) {
        gqlParams['territoryIds'] = filters.subTerritoryIds;
      } else if (filters.territoryId) {
        gqlParams['territoryIds'] = [filters.territoryId];
      }

      return {
        kq: kqQueryParams,
        graphQL: gqlParams
      };
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.locations')
    .controller('LocationsFiltersSideNavController', LocationsFiltersSideNavController);

  /** @ngInject */
  function LocationsFiltersSideNavController(
    $rootScope, LocationsFilters,
    $timeout, $translate, _,
    territoriesApi, accountFeatureFlagsApiGraphQL
  ) {
    var vm = this;

    vm.statusOptions = [
      {
        value: {
          label: $translate.instant('LOCATIONS.FILTERS.STATUS.ALL'),
          value: null
        }
      },
      {
        value: {
          label: $translate.instant('LOCATIONS.FILTERS.STATUS.ARCHIVED'),
          value: true
        }
      },
      {
        value: {
          label: $translate.instant('LOCATIONS.FILTERS.STATUS.UNARCHIVED'),
          value: false
        }
      }
    ];
    vm.statusFilterValue = vm.statusOptions[2].value;
    vm.locationsFilters = LocationsFilters;
    vm.filteringIsOn = LocationsFilters.isOn;
    vm.clearFilters = clearFilters;
    vm.territorySelected = territorySelected;
    vm.broadcastFilterUpdated = _.debounce(function (changedFilterName) {
      $timeout(function () {
        if (changedFilterName === 'archived') {
          vm.locationsFilters.archived = vm.statusFilterValue.value;
        }

        if (changedFilterName && vm.locationsFilters[changedFilterName] === 'null') {
          vm.locationsFilters[changedFilterName] = null;
        }

        if (changedFilterName && vm.locationsFilters[changedFilterName] === 'false') {
          vm.locationsFilters[changedFilterName] = false;
        }

        if (changedFilterName && vm.locationsFilters[changedFilterName] === 'true') {
          vm.locationsFilters[changedFilterName] = true;
        }

        $rootScope.$broadcast('locations:reload');
      }, 50);
    }, 500);

    vm.hasTerritoriesFlag = false;

    accountFeatureFlagsApiGraphQL.getCachedFlagByName('territories').then(function (flag) {
      vm.hasTerritoriesFlag = flag ? flag.active : false;
    });

    territoriesApi.search({ take: 100, where: { archived: false } }).then(function (result) {
      vm.territoriesFilterList = result.items;
    });

    function clearFilters() {
      vm.statusFilterValue = vm.statusOptions[2].value;
      LocationsFilters.clear();
    }

    function territorySelected() {
      var selectedTerritoryId = vm.locationsFilters.territoryId;
      vm.locationsFilters.subTerritoryIds = [];
      vm.broadcastFilterUpdated('subTerritoryIds');

      if (!selectedTerritoryId) {
        vm.subTerritoriesFilterList = [];

        return;
      }

      territoriesApi.search({ take: 150, where: { parentId: selectedTerritoryId, archived: false } }).then(function (result) {
        vm.subTerritoriesFilterList = result.items;
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.customers')
    .factory('locationTasksTimelineConverter', locationTasksTimelineConverter);

  /** @ngInject */
  function locationTasksTimelineConverter(TasksStatusHelper, $translate, LocalDateConvert) {
    return {
      toTimeline: toTimeline
    };

    function toTimeline(tasks) {
      var timeline = [];

      tasks = tasks || [];
      tasks.forEach(function (task) {

        var currentStatus = TasksStatusHelper.getByName(task.status);
        var avatarUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg';
        if (task.employee && task.employee.avatarUrl) {
          avatarUrl = task.employee.avatarUrl;
        }

        var itemTime = task.scheduling.date ? LocalDateConvert.formatDate(task.scheduling.date, 'date') : null;
        if (task.scheduling.time) {
          itemTime += ' ' + task.scheduling.time;
        }

        var cardText = '';

        if (task.employee && task.employee.name) {
          cardText += '<br/>';
          cardText += '<span>Colaborador responsável: <b>' + task.employee.name + '</b></span>';
        } else {
          cardText += '<br/>';
          cardText += '<span>Sem colaborador</span>';
        }

        if (task.duration) {
          cardText += '<br/>';
          cardText += '<span>Duração da visita: <b>' + task.duration + 'minutos</b></span>';
        }

        if (task.scheduling && task.scheduling.date) {
          var schedulingDate = LocalDateConvert.formatDate(task.scheduling.date, 'date');
          var schedulingTime = task.scheduling.time ? task.scheduling.time.substring(0, 5) : '00:00';

          cardText += '<br/>';
          cardText += '<span>Data/hora de agendamento: <b>' + schedulingDate + ' ' + schedulingTime + '</b></span>';
        }

        if (task.startedAt) {
          cardText += '<br/>';
          cardText += '<span>Data/hora de início: <b>' + LocalDateConvert.formatDate(task.startedAt, 'date-time') + '</b></span>';
        }

        if (task.completedAt) {
          cardText += '<br/>';
          cardText += '<span>Data/hora de conclusão: <b>' + LocalDateConvert.formatDate(task.completedAt, 'date-time') + '</b></span>';
        }

        var timelineEvent = {
          id: task.id,
          card: {
            template: "app/core/directives/ms-card/templates/template-14/template-14.html",
            avatar: {
              src: avatarUrl,
              alt: task.employee ? task.employee.name : ''
            },
            title: task.order.service.id + ' - ' + task.order.service.description,
            createdAt: LocalDateConvert.formatDate(task.metadata.createdAt, 'date-time'),
            subtitle: currentStatus.description,
            subtitleColor: currentStatus.color,
            text: cardText,
            identifier: task.order.identifier
          },
          icon: currentStatus.icon,
          color: currentStatus.color,
          time: itemTime
        };

        timeline.push(timelineEvent);
      });

      return timeline;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.locations').controller('MapDialogController', MapDialogController);

  /** @ngInject */
  function MapDialogController(
    $mdDialog,
    $rootScope,
    $scope,
    leafletData,
    UpdateCoordsFunc,
    Address,
    $translate,
    UserTerritories
  ) {
    var vm = this;
    vm.marker = undefined;

    function closeDialog(reload) {
      $mdDialog.hide(reload);
      $rootScope.loadingProgress = false;
    }

    function _initialize() {
      vm.closeDialog = closeDialog;
      vm.address = angular.copy(Address);
      vm.updateCoordsFunc = angular.copy(UpdateCoordsFunc);
      vm.userTerritories = angular.copy(UserTerritories);
      vm.hasBeenChanged = false;

      _configureMap();
      _updateMapMarkersAndCenter();
      _drawTerritories();
    }

    function _configureMap() {
      var coords = vm.address.coords;
      vm.map = {
        center: {
          lat: parseFloat(coords.latitude) || -23.552753,
          lng: parseFloat(coords.longitude) || -46.632567,
          zoom: 16,
        },
        controls: {
          fullscreen: {
            position: 'topleft',
          },
        },
        layers: {
          baselayers: {
            mapbox_standard: {
              name: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.LAYERS.DEFAULT'),
              url: 'https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                showOnSelector: true,
              },
            },
            mapbox_satellite: {
              name: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.LAYERS.SATELLITE'),
              url: 'https://mt0.google.com/vt/lyrs=y&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                showOnSelector: true,
              },
            },
            mapbox_roadmap: {
              name: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.LAYERS.ROADS'),
              url: 'https://mt0.google.com/vt/lyrs=h&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                showOnSelector: true,
              },
            },
            mapbox_terrain: {
              name: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.LAYERS.GROUND'),
              url: 'https://mt0.google.com/vt/lyrs=p&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                showOnSelector: true,
              },
            },
          },
        },
      };

      leafletData.getMap('locationMap').then(function (map) {
        var icon = L.divIcon({
          html: '<div>' + '    <i style="color:#273238;" class="icon icon-city s38"></i>' + '</div>',
          iconSize: [38, 38],
          iconAnchor: [16, 16],
        });

        vm.marker = new L.marker([vm.map.center.lat, vm.map.center.lng], {
          draggable: true,
          message: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.CUSTOMER_LOCATION'),
          icon: icon,
        }).addTo(map);

        vm.marker.on('dragend', function (event) {
          vm.hasBeenChanged = true;
          var latLng = event.target.getLatLng();

          var args = {
            model: {
              lat: latLng.lat,
              lng: latLng.lng,
            },
          };

          vm.updateCoordsFunc(_, args).then(function (response) {
            if (!response) {
              _updateMapMarkersAndCenter();

              return;
            }

            vm.address.coords.latitude = args.model.lat;
            vm.address.coords.longitude = args.model.lng;
          });
        });
      });
    }

    function _updateMapMarkersAndCenter() {
      var latitude = parseFloat(vm.address.coords.latitude);
      var longitude = parseFloat(vm.address.coords.longitude);

      if (latitude && longitude) {
        var boundsItems = [];
        boundsItems.push([latitude, longitude]);

        var bounds = L.latLngBounds(boundsItems);
        leafletData.getMap('locationMap').then(function (map) {
          vm.marker.setLatLng([latitude, longitude]);

          map.fitBounds(bounds);
        });
      }
    }

    function _drawTerritories() {
      if (!vm.userTerritories || !vm.userTerritories.length) {
        return;
      }

      leafletData.getMap('locationMap').then(function (map) {
        for (var i = 0; i < vm.userTerritories.length; i++) {
          var territory = vm.userTerritories[i];
          var type = territory.type;
          var radius = territory.radius;

          if (type === 'circle') {
            var coordinates = territory.geometry.coordinates[0];
            var geometry = [coordinates.lat, coordinates.lng];

            L.circle(geometry, {
              fill: false,
              stroke: '#0055ff',
              radius: radius,
            }).addTo(map);

            continue;
          }

          var coordinates = territory.geometry.coordinates.map(function (coord) {
            return [coord.lat, coord.lng];
          });

          L.polygon([coordinates], {
            fill: false,
            stroke: '#0055ff',
          }).addTo(map);
        }
      });
    }

    _initialize();
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.exports', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.exports', {
            url    : '/exportacoes',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/exports/exports.html',
                    controller : 'ExportsController as vm'
                }
            },
            data: { titleTranslateKey: 'EXPORTS.PAGE_TITLE' },
            resolve: {
                account: function (accountsApi) {
                    return accountsApi.get();
                },
                exports: function (exportsApi) {
                    return exportsApi.search({}, {});
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/exports');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.exports')
        .factory('ExportsFilters', ExportsFilters);

    /** @ngInject */
    function ExportsFilters($timeout, $rootScope, _) {
        var filters = {
            id: '',
            number: '',
            employee: [],
            status: '',
            createdAtFrom: null,
            createdAtTo: null,
            completedAtFrom: null,
            completedAtTo: null,
            clear: clear,
            isOn: isOn,
            isOff: isOff
        };

        function clear() {
            filters.id = '';
            filters.number = '';
            filters.status = '';
            filters.employee = [];
            filters.createdAtFrom = null;
            filters.createdAtTo = null;
            filters.completedAtFrom = null;
            filters.completedAtTo = null;
            $timeout(function () { $rootScope.$broadcast('exports:reload'); }, 200);
        }

        function isOn() {
            var noIdFiltered = filters.id === '';
            var noNumberFiltered = filters.number === '';
            var noStatusFiltered = filters.status === '';
            var noEmployeeFiltered = _.isEmpty(filters.employee);
            var noCompletedAtFiltered = filters.completedAtFrom === null && filters.completedAtTo === null;
            var noCreatedAtFiltered = filters.createdAtFrom === null && filters.createdAtTo === null;
            return !(noNumberFiltered && noStatusFiltered && noEmployeeFiltered && noIdFiltered && noCreatedAtFiltered && noCompletedAtFiltered);
        }

        function isOff() {
            return !isOn();
        }

        return filters;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.exports')
        .controller('ExportsFiltersSideNavController', ExportsFiltersSideNavController);

    /** @ngInject */
    function ExportsFiltersSideNavController($rootScope, msUtils, ExportsFilters, _, employeesApi) {

        var vm = this;
        vm.exports = [];
        vm.exportsFilters = ExportsFilters;
        vm.clearFilters = ExportsFilters.clear;
        vm.filteringIsOn = ExportsFilters.isOn;
        vm.exists = msUtils.exists;
        vm.toggleInArray = toggleInArray;

        employeesApi.getAll().then(function (result) {
            var employees = _.filter(result.items, function (employee) { return employee.contract.active && !employee.inactivatedAt; });
            employees = _.sortBy(employees, function (employee) { return employee.name; });
            vm.employees = employees;
        });

        function toggleInArray(value, array) {
            msUtils.toggleInArray(value, array);
            broadcastFilterUpdated();
        }

        function broadcastFilterUpdated() {
            $rootScope.$broadcast('exports:reload');
        }

        function _initialize() {
            vm.broadcastFilterUpdated = broadcastFilterUpdated;
            vm.exportsFilters = ExportsFilters;
        }

        _initialize();
    }
})();

(function () {
  'use strict';

  angular
    .module('app.equipments', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.equipments', {
      url: '/equipamentos',
      views: {
        'content@app': {
          templateUrl: 'app/main/equipments/equipments.html',
          controller: 'EquipmentsController as vm'
        }
      },
      data: { titleTranslateKey: 'EQUIPMENTS.PAGE_TITLE' },
      resolve: {
        account: function (accountsApi) {
          return accountsApi.get();
        },
        equipments: function (equipmentsApi) {
          return equipmentsApi.search({ take: 200, orderBy: 'customerName_desc' });
        },
        equipmentsTypes: function (equipmentTypesApi) {
          return equipmentTypesApi.getEquipmentTypes();
        }
      }
    });
    $translatePartialLoaderProvider.addPart('app/main/equipments');
  }

})();

(function () {
  'use strict';

  angular
    .module('app.equipments')
    .factory('EquipmentsFilters', EquipmentsFilters);

  /** @ngInject */
  function EquipmentsFilters($timeout, $rootScope) {
    var filters = {
      id: '',
      name: '',
      number: '',
      customerId: '',
      customerName: '',
      locationId: '',
      archived: '1',
      equipmentTypeId: '',
      labelsIds: [],
      territoryId: '',
      subTerritoryIds: [],
      warrantyStartDateLte: null,
      warrantyEndDateGte: null,
      warrantyStatusIn: [],
      clear: clear,
      isOn: isOn,
      isOff: isOff,
      toSearchOptions: toSearchOptions
    };

    function clear() {
      filters.id = '';
      filters.number = '';
      filters.name = '';
      filters.archived = '1';
      filters.equipmentTypeId = '';
      filters.customerId = '';
      filters.customerName = '';
      filters.locationId = '';
      filters.labelsIds = [];
      filters.territoryId = '';
      filters.subTerritoryIds = [];
      filters.warrantyStartDateLte = null;
      filters.warrantyEndDateGte = null;
      filters.warrantyStatusIn = [];

      $timeout(function () { $rootScope.$broadcast('equipments:reload'); }, 200);
    }

    function isOn() {
      var noTerritoryFiltered = !filters.territoryId;
      var noSubTerritoryFiltered = !filters.subTerritoryIds || !filters.subTerritoryIds.length;

      return !(
        filters.id === '' &&
        filters.number === '' &&
        filters.name === '' &&
        filters.archived === '1' &&
        filters.equipmentTypeId === '' &&
        filters.customerId === '' &&
        filters.customerName === '' &&
        filters.locationId === '' &&
        filters.labelsIds.length === 0 &&
        noTerritoryFiltered &&
        noSubTerritoryFiltered &&
        filters.warrantyStartDateLte === null &&
        filters.warrantyEndDateGte === null &&
        filters.warrantyStatusIn.length === 0
      );
    }

    function isOff() {
      return !isOn();
    }

    function toSearchOptions() {
      var kqQueryParams = {};
      var gqlParams = {};

      if (filters.archived === '1') {
        kqQueryParams['archived'] = 'no';
        gqlParams['archived'] = false;
      } else if (filters.archived === '2') {
        kqQueryParams['archived'] = 'yes';
        gqlParams['archived'] = true;
      }

      if (filters.id) {
        kqQueryParams['id'] = filters.id;
        gqlParams['ids'] = [filters.id];
      }

      if (filters.name) {
        kqQueryParams['name~~*'] = '*' + filters.name + '*';
        gqlParams['nameContains'] = filters.name;
      }

      if (filters.number) {
        kqQueryParams['number~~*'] = '*' + filters.number + '*';
        gqlParams['numberContains'] = filters.number;
      }

      if (!filters.customerId && filters.customerName) {
        kqQueryParams['customer_name~~*'] = '*' + filters.customerName + '*';
        gqlParams['customerNameContains'] = filters.customerName;
      }

      if (filters.customerId) {
        kqQueryParams['customer_id'] = filters.customerId;
        gqlParams['customerIds'] = [filters.customerId];
      }

      if (filters.locationId) {
        kqQueryParams['location_id'] = filters.locationId;
        gqlParams['locationIds'] = [filters.locationId];
      }

      if (filters.equipmentTypeId) {
        kqQueryParams['equipment_type_id'] = filters.equipmentTypeId;
        gqlParams['equipmentTypeId'] = filters.equipmentTypeId;
      }

      if (filters.labelsIds.length) {
        gqlParams['labelsIds'] = filters.labelsIds;
      }

      if (filters.subTerritoryIds && filters.subTerritoryIds.length) {
        gqlParams['territoryIds'] = filters.subTerritoryIds;
      } else if (filters.territoryId) {
        gqlParams['territoryIds'] = [filters.territoryId];
      }

      if (filters.warrantyStartDateLte) {
        gqlParams['warrantyStartDateLte'] = filters.warrantyStartDateLte;
      }

      if (filters.warrantyEndDateGte) {
        gqlParams['warrantyEndDateGte'] = filters.warrantyEndDateGte;
      }

      if (filters.warrantyStatusIn.length) {
        var status = filters.warrantyStatusIn.map(function (status) {
          if (status === 'no_warranty') return null;
          return status;
        });

        gqlParams['warrantyStatusIn'] = status.length ? status : null;
      }

      return {
        kq: kqQueryParams,
        graphQL: gqlParams
      };
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.equipments')
    .controller('EquipmentsFiltersSideNavController', EquipmentsFiltersSideNavController);

  /** @ngInject */
  function EquipmentsFiltersSideNavController(
    $rootScope, msUtils, EquipmentsFilters, customersApi, equipmentTypesApi, labelsApi, customerLocationsApi,
    territoriesApi, accountFeatureFlagsApiGraphQL, authenticatedUser, accountCache
  ) {
    var vm = this;
    vm.customers = [];
    vm.selectedCustomerInFilter = null;
    vm.locationName = '';
    vm.locations = [];
    vm.selectedLocationInFilter = null;
    vm.territoriesFilterList = [];
    vm.subTerritoriesFilterList = [];
    vm.warrantyStatus = ['active', 'expired', 'extended', 'future', 'no_warranty'];
    vm.hasWarrantiesPermission = false;
    vm.hasTerritoriesFlag = false;

    vm.equipmentsFilters = EquipmentsFilters;
    vm.clearFilters = EquipmentsFilters.clear;
    vm.filteringIsOn = EquipmentsFilters.isOn;
    vm.exists = msUtils.exists;
    vm.toggleInArray = toggleInArray;
    vm.territorySelected = territorySelected;

    function _initialize() {
      accountCache.loadAccount().then(function () {
        vm.account = accountCache.getAccount();
        vm.broadcastFilterUpdated = broadcastFilterUpdated;
        vm.equipmentsFilters = EquipmentsFilters;
        equipmentTypesApi.getEquipmentTypes({ archived: "no" }).then(function (result) {
          vm.equipmentTypesFilterList = normalizeEquipmentTypes(result.items);
        });

        loadLabels().then(function (result) {
          vm.labels = result.items;
        });

        vm.hasWarrantiesPermission = authenticatedUser.hasPermission(vm.account, 'warranties_list');

        accountFeatureFlagsApiGraphQL.getCachedFlagByName('territories').then(function (flag) {
          vm.hasTerritoriesFlag = flag ? flag.active : false;
        });

        territoriesApi.search({ take: 100, where: { archived: false } }).then(function (result) {
          vm.territoriesFilterList = result.items;
        });
      });
    }

    function broadcastFilterUpdated() {
      $rootScope.$broadcast('equipments:reload');
    }

    // Customer
    vm.loadCustomers = loadCustomers;
    vm.selectCustomerInFilter = selectCustomerInFilter;
    vm.removeSelectedCustomerInFilter = removeSelectedCustomerInFilter;

    function loadCustomers() {
      if (vm.equipmentsFilters.customerName && vm.equipmentsFilters.customerName.length) {
        var searchCustomerText = vm.equipmentsFilters.customerName;
        vm.customers = [];
        var queryParams = {
          where: {
            nameOrDocumentNumberContains: searchCustomerText
          },
          skip: 0,
          take: 10,
          orderBy: 'archived_asc'
        };

        customersApi.search(queryParams).then(function (response) {
          if (response.items.length > 0) {
            response.items.forEach(function (customer) {
              vm.customers.push(customer);
            });
          }
        });

        broadcastFilterUpdated();
      } else {
        vm.customers = [];
        broadcastFilterUpdated();
      }
    }

    function selectCustomerInFilter() {
      if (vm.selectedCustomerInFilter) {
        vm.equipmentsFilters.customerId = vm.selectedCustomerInFilter.id;
        broadcastFilterUpdated();
      }
    }

    function removeSelectedCustomerInFilter() {
      vm.selectedCustomerInFilter = null;
      vm.equipmentsFilters.customerId = '';
      vm.equipmentsFilters.customerName = '';

      vm.locationName = '';
      vm.selectedLocationInFilter = null;
      vm.equipmentsFilters.locationId = '';

      broadcastFilterUpdated();
    }

    // Location
    vm.loadLocations = loadLocations;
    vm.selectLocationInFilter = selectLocationInFilter;
    vm.removeSelectedLocationInFilter = removeSelectedLocationInFilter;

    function loadLocations() {
      if (vm.locationName.length) {
        vm.locations = [];
        customerLocationsApi.search({
          where: {
            customerIds: [vm.equipmentsFilters.customerId],
            nameContains: vm.locationName,
            archived: false
          },
          take: 5
        }).then(function (response) {
          if (response.items.length > 0) {
            response.items.forEach(function (location) {
              vm.locations.push(location);
            });
          }
        });
      }
    }

    function selectLocationInFilter() {
      if (vm.selectedLocationInFilter) {
        vm.equipmentsFilters.locationId = vm.selectedLocationInFilter.id;
        broadcastFilterUpdated();
      }
    }

    function removeSelectedLocationInFilter() {
      vm.locationName = '';
      vm.selectedLocationInFilter = null;
      vm.equipmentsFilters.locationId = '';
      broadcastFilterUpdated();
    }

    function normalizeEquipmentTypes(list) {
      return _.sortBy(list, 'name');
    }

    // Labels
    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }

    function loadLabels() {
      return labelsApi.search({ type: 'equipments' }, { limit: 100 });
    }


    function territorySelected() {
      var selectedTerritoryId = vm.equipmentsFilters.territoryId;
      vm.equipmentsFilters.subTerritoryIds = [];
      vm.broadcastFilterUpdated();

      if (!selectedTerritoryId) {
        vm.subTerritoriesFilterList = [];

        return;
      }

      territoriesApi.search({ take: 150, where: { parentId: selectedTerritoryId, archived: false } }).then(function (result) {
        vm.subTerritoriesFilterList = result.items;
      });
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('EquipmentsTimelineService', EquipmentsTimelineService);

  /** @ngInject */
  function EquipmentsTimelineService(_, moment, $translate, attachmentsUtils, LocalDateConvert) {
    function toTimeline(equipmentLogs) {
      var formattedLogs = [];

      if (!equipmentLogs || !equipmentLogs.length) {
        return formattedLogs;
      }

      function _createFirstLog(log) {
        formattedLogs.push({
          title: $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.CREATED'),
          updatedBy: _toUpdatedBy(log, true),
          colorClass: 'created',
          icon: 'icon-plus',
          createdAt: LocalDateConvert.formatDateTimeSeconds(log.createdAt),
          formattedCreatedAt: LocalDateConvert.formatDate(log.createdAt),
          eventDescription: $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.CREATED_DESCRIPTION', {
            equipmentName: log.snapshot.name,
            equipmentNumber: log.snapshot.number
          }),
        });
      }

      function _createArchiveLog(log) {
        formattedLogs.push({
          title: $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.' + (log.snapshot.archived ? 'ARCHIVED' : 'UNARCHIVED')),
          updatedBy: _toUpdatedBy(log),
          colorClass: log.snapshot.archived ? 'archived' : 'unarchived',
          icon: log.snapshot.archived ? 'icon-archive-arrow-down' : 'icon-archive-arrow-up',
          createdAt: LocalDateConvert.formatDateTimeSeconds(log.createdAt),
          formattedCreatedAt: LocalDateConvert.formatDate(log.createdAt),
        });
      }

      function _createAttachmentLog(log) {
        var eventDescription = '';
        var correctAttachmentPath = attachmentsUtils.correctMumakilUrl(log.attachmentSnapshot.path);
        var attachment = '<img src="' + correctAttachmentPath.path + '" alt="'+ log.attachmentSnapshot.title + '">';

        var attachmentTypeToIcon = {
          csv: 'sheet-icon.png',
          xls: 'sheet-icon.png',
          xlsx: 'sheet-icon.png',
          docx: 'doc-icon.png',
          doc: 'doc-icon.png',
          txt: 'doc-icon.png',
          pdf: 'pdf-icon.png',
          ppt: 'pwp-icon.png',
          pptx: 'pwp-icon.png',
          kml: 'kml-icon.png'
        };

        var attachmentTypes = Object.keys(attachmentTypeToIcon);

        var fileType = attachmentTypes.find(function (key) {
          return _.includes(_.slice(correctAttachmentPath.path, -5).join(''), key);
        });

        if (fileType) {
          attachment = '<img src="./assets/images/' + attachmentTypeToIcon[fileType] + '" width="64px" height="64px" alt="' + log.attachmentSnapshot.title + '">';
        }


        if (log.type === 'createAttachment') {
          eventDescription += '<p>' + $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.ATTACHMENTS_ADDED_TITLE') + '</p>';
          eventDescription += '<div class="equipment-dialog__historic-tab__log__container__detail_description-pictures">' + attachment + '</div>';
        }

        if (log.type === 'archiveAttachment') {
          eventDescription += '<p>' + $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.ATTACHMENTS_DELETED_TITLE') + '</p>';
          eventDescription += '<div class="equipment-dialog__historic-tab__log__container__detail_description-pictures">' +  attachment + '</div>';
        }

        formattedLogs.push({
          title: $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.CHANGED'),
          updatedBy: _toUpdatedBy(log),
          colorClass: 'changed',
          icon: 'icon-list',
          createdAt: LocalDateConvert.formatDateTimeSeconds(log.createdAt),
          formattedCreatedAt: LocalDateConvert.formatDate(log.createdAt),
          eventDescription: eventDescription,
        });
      }

      function _createEditLog(previousEquipmentLog, previousCustomFieldsLog, currentLog) {
        var requiredChanges = [];
        var eventDescription = '';

        if (currentLog.type ==='updateEquipment' && previousEquipmentLog) {
          if (previousEquipmentLog.snapshot.name !== currentLog.snapshot.name) {
            requiredChanges.push($translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CHANGED_NAME', {
              previous: previousEquipmentLog.snapshot.name,
              current: currentLog.snapshot.name,
            }));
          }

          if (previousEquipmentLog.snapshot.number !== currentLog.snapshot.number) {
            requiredChanges.push($translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CHANGED_NUMBER', {
              previous: previousEquipmentLog.snapshot.number,
              current: currentLog.snapshot.number,
            }));
          }

          if (previousEquipmentLog.snapshot.type.id !== currentLog.snapshot.type.id) {
            requiredChanges.push($translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CHANGED_TYPE', {
              previous: previousEquipmentLog.snapshot.type.name,
              current: currentLog.snapshot.type.name,
            }));
          }

          if (previousEquipmentLog.snapshot.customer && currentLog.snapshot.customer && previousEquipmentLog.snapshot.customer.id !== currentLog.snapshot.customer.id) {
            requiredChanges.push($translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CHANGED_CUSTOMER', {
              previous: previousEquipmentLog.snapshot.customer.name,
              current: currentLog.snapshot.customer.name,
            }));
          }

          if (previousEquipmentLog.snapshot.location && currentLog.snapshot.location && previousEquipmentLog.snapshot.location.id !== currentLog.snapshot.location.id) {
            requiredChanges.push($translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CHANGED_LOCATION', {
              previous: previousEquipmentLog.snapshot.location.name,
              current: currentLog.snapshot.location.name,
            }));
          }

          if (previousEquipmentLog.snapshot.locationSector && currentLog.snapshot.locationSector && previousEquipmentLog.snapshot.locationSector.id !== currentLog.snapshot.locationSector.id) {
            requiredChanges.push($translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CHANGED_LOCATION_SECTOR', {
              previous: previousEquipmentLog.snapshot.locationSector.name,
              current: currentLog.snapshot.locationSector.name,
            }));
          }

          if (previousEquipmentLog.snapshot.locationEnvironment && currentLog.snapshot.locationEnvironment && previousEquipmentLog.snapshot.locationEnvironment.id !== currentLog.snapshot.locationEnvironment.id) {
            requiredChanges.push($translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CHANGED_LOCATION_ENVIRONMENT', {
              previous: previousEquipmentLog.snapshot.locationEnvironment.name,
              current: currentLog.snapshot.locationEnvironment.name,
            }));
          }

          if (previousEquipmentLog.snapshot.qrCode !== currentLog.snapshot.qrCode) {
            requiredChanges.push($translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CHANGED_QR_CODE'));
          }

          requiredChanges = requiredChanges.join('<br>');
          if (requiredChanges.length) {
            eventDescription += '<p>' + $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.REQUIRED_CHANGES_TITLE') +'</p>';
            eventDescription += '<div class="equipment-dialog__historic-tab__log__container__detail_description-category">' + requiredChanges +'</div>';
          }

          if (currentLog.snapshot.imageUrl && previousEquipmentLog.snapshot.imageUrl !== currentLog.snapshot.imageUrl) {
            eventDescription += '<p>' + $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.PICTURE_CHANGED_TITLE') +'</p>';
            eventDescription += '<img src="' + currentLog.snapshot.imageUrl + '" alt="picture">';
          }

          if (!currentLog.snapshot.imageUrl && previousEquipmentLog.snapshot.imageUrl !== currentLog.snapshot.imageUrl) {
            eventDescription += '<p>' + $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.PICTURE_REMOVED_TITLE') +'</p>';
          }

          if (previousEquipmentLog.snapshot.notes !== currentLog.snapshot.notes) {
            eventDescription += '<p>' + $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.NOTES_CHANGED_TITLE') +'</p>';
            eventDescription += '<div class="equipment-dialog__historic-tab__log__container__detail_description-category">' + (currentLog.snapshot.notes || $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.EMPTY_NOTES')) +'</div>';
          }
        }

        var lastLogWithCustomFields = _getLastLogWithCustomFieldsSnapshot(previousEquipmentLog, previousCustomFieldsLog);
        var customFieldsOfType = _getCustomFieldsOfType(currentLog, previousEquipmentLog);

        if (_.isArray(currentLog.customFieldsSnapshot)) {
          var addedCustomFields = _toAddedCustomFields(lastLogWithCustomFields, currentLog, customFieldsOfType);
          if (addedCustomFields) {
            eventDescription += '<p>' + $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CUSTOM_FIELDS_ADDED_TITLE') + '</p>';
            eventDescription += '<div class="equipment-dialog__historic-tab__log__container__detail_description-category">' + addedCustomFields + '</div>';
          }

          if (_.isObject(lastLogWithCustomFields)) {
            var updatedCustomFields = _toUpdatedCustomFields(lastLogWithCustomFields, currentLog, customFieldsOfType);
            if (updatedCustomFields) {
              eventDescription += '<p>' + $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CUSTOM_FIELDS_CHANGED_TITLE') + '</p>';
              eventDescription += '<div class="equipment-dialog__historic-tab__log__container__detail_description-category">' + updatedCustomFields + '</div>';
            }

            var deletedCustomFields = _toDeletedCustomFields(lastLogWithCustomFields, currentLog, customFieldsOfType);
            if (deletedCustomFields) {
              eventDescription += '<p>' + $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.CUSTOM_FIELDS_DELETED_TITLE') + '</p>';
              eventDescription += '<div class="equipment-dialog__historic-tab__log__container__detail_description-category">' + deletedCustomFields + '</div>';
            }
          }
        }

        if (eventDescription) {
          formattedLogs.push({
            title: $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.CHANGED'),
            updatedBy: _toUpdatedBy(currentLog),
            colorClass: 'changed',
            icon: 'icon-list',
            createdAt: LocalDateConvert.formatDateTimeSeconds(currentLog.createdAt),
            formattedCreatedAt: LocalDateConvert.formatDate(currentLog.createdAt),
            eventDescription: eventDescription,
          });
        }
      }

      angular.forEach(equipmentLogs, function (log) {
        if (!_.isString(log.type)) {
          return;
        }

        if (_.includes(log.type, 'Attachment')) {
          return _createAttachmentLog(log);
        }

        if (log.type === 'createEquipment') {
          return _createFirstLog(log);
        }

        var lastLogThatChangesEquipment = _.chain(equipmentLogs)
          .filter(function (equipmentLog) {
            return equipmentLog.id !== log.id &&
              _.includes(equipmentLog.type.toLowerCase(), 'equipment') &&
              moment(equipmentLog.createdAt).isBefore(moment(log.createdAt));
          })
          .sortByOrder(['createdAt'], ['desc'])
          .value()[0];

        var archivedColumnsHasChanged = _.includes(log.type.toLowerCase(), 'equipment') && lastLogThatChangesEquipment && lastLogThatChangesEquipment.snapshot.archived !== log.snapshot.archived;
        if(log.type === 'archiveEquipment' || archivedColumnsHasChanged) {
          return _createArchiveLog(log);
        }

        var lastLogThatChangesOnlyCustomFields = _.chain(equipmentLogs)
          .filter(function (equipmentLog) {
            return equipmentLog.id !== log.id &&
              (equipmentLog.type === 'updateCustomFields' || (equipmentLog.type === 'updateEquipment' && equipmentLog.clientApplicationName === 'mordor')) &&
              moment(equipmentLog.createdAt).isBefore(moment(log.createdAt));
          })
          .sortByOrder(['createdAt'], ['desc'])
          .value()[0];

          _createEditLog(lastLogThatChangesEquipment, lastLogThatChangesOnlyCustomFields, log);
      });

      return formattedLogs;
    }

    function _toUpdatedBy(log, isFirst) {
      var deviceOptions = {
        mobile: 'icon-cellphone',
        browser: 'icon-laptop',
        sys: 'icon-sync',
        vrp: 'icon-map-marker'
      };

      var changedByTypeTitle = isFirst ? 'CREATED_BY' : 'UPDATED_BY';
      var clientName = $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.CLIENT.SYSTEM');

      if (log.clientApplicationName) {
        clientName = $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.CLIENT.' + log.clientApplicationName.toUpperCase());
      } else {
        if (log.changedBy.source === 'mobile' && log.changedBy.type === 'employees') {
          clientName = $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.CLIENT.ORC-2');
        }

        if (log.changedBy.source === 'mobile' && log.changedBy.type === 'users') {
          clientName = $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.CLIENT.GOTHMOG-2');
        }

        if (log.changedByType === 'integrations') {
          clientName = $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.CLIENT.CARCHOST');
        }

        if (log.changedBy.source === 'browser') {
          clientName = $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.CLIENT.MORDOR');
        }
      }

      return {
        device: deviceOptions[log.changedBy.source],
        title: $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.' + changedByTypeTitle, {
          userName: log.changedBy.name,
          clientName: clientName,
        })
      };
    }

    function _toAddedCustomFields(lastLogWithCustomFields, currentLog, customFieldsOfType) {
      var previous = lastLogWithCustomFields
        ? _.map(lastLogWithCustomFields.customFieldsSnapshot, 'name')
        : [];

      return  _.chain(currentLog.customFieldsSnapshot)
        .filter(function (customField) {
          return !_.includes(previous, customField.name);
        })
        .sortByOrder(['position'], ['asc'])
        .map(function (customField) {
          var isRequiredField = _.find(customFieldsOfType, { name: customField.name, required: true });
          var content = '<p><b>' + customField.name + (isRequiredField ? '*' : '');
          var formattedValue = customField.type === 'date' && !!customField.value
            ? LocalDateConvert.formatDate(customField.value)
            : (customField.value || $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.EMPTY_CUSTOM_FIELD'));

          content += '</b></p><p>' +  formattedValue + '</p>';
          return content;
        })
        .value().join('');
    }

    function _toUpdatedCustomFields(lastLogWithCustomFields, currentLog, customFieldsOfType) {
      var previous = lastLogWithCustomFields.customFieldsSnapshot || [];

      return _.chain(currentLog.customFieldsSnapshot)
        .filter(function (customField) {
          var previousCustomField = _.find(previous, { name: customField.name });
          return previousCustomField && previousCustomField.value !== customField.value;
        })
        .sortByOrder(['position'], ['asc'])
        .map(function (customField) {
          var isRequiredField = _.find(customFieldsOfType, { name: customField.name, required: true });
          var content = '<p><b>' + customField.name + (isRequiredField ? '*' : '');
          var formattedValue = customField.type === 'date' && !!customField.value
            ? LocalDateConvert.formatDate(customField.value)
            : (customField.value || $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.EMPTY_CUSTOM_FIELD'));

          content += '</b></p><p>' +  formattedValue + '</p>';
          return content;
        })
        .value().join('');
    }

    function _toDeletedCustomFields(lastLogWithCustomFields, currentLog, customFieldsOfType) {
      var current = _.map(currentLog.customFieldsSnapshot, 'name');
      var previous = lastLogWithCustomFields.customFieldsSnapshot || [];

      return _.chain(previous)
        .filter(function (customField) {
          return !_.includes(current, customField.name);
        })
        .sortByOrder(['position'], ['asc'])
        .map(function (customField) {
          var isRequiredField = _.find(customFieldsOfType, { name: customField.name, required: true });
          var content = '<p><b>' + customField.name + (isRequiredField ? '*' : '');
          var formattedValue = customField.type === 'date' && !!customField.value
            ? LocalDateConvert.formatDate(customField.value)
            : (customField.value || $translate.instant('EQUIPMENTS.DIALOG.HISTORIC.LOGS.EVENT.EMPTY_CUSTOM_FIELD'));

          content += '</b></p><p>' +  formattedValue + '</p>';
          return content;
        })
        .value().join('');
    }

    function _getLastLogWithCustomFieldsSnapshot(equipmentLog, customFieldLog) {
      var equipmentCustomFieldSnapshot = (equipmentLog && equipmentLog.customFieldsSnapshot) || [];
      var updateCustomFieldSnapshot = (customFieldLog && customFieldLog.customFieldsSnapshot) || [];

      if (equipmentCustomFieldSnapshot.length && updateCustomFieldSnapshot.length) {
        var equipmentLogIsBefore = moment(equipmentLog.createdAt).isBefore(moment(customFieldLog.createdAt));
        return equipmentLogIsBefore ? customFieldLog : equipmentLog;
      }

      return updateCustomFieldSnapshot.length ? customFieldLog : equipmentLog;
    }

    function _getCustomFieldsOfType(currentLog, previousEquipmentLog) {
      if (currentLog.snapshot && currentLog.snapshot.type && currentLog.snapshot.type.customFields) {
        return currentLog.snapshot.type.customFields;
      }

      if (previousEquipmentLog && previousEquipmentLog.snapshot && previousEquipmentLog.snapshot.type && previousEquipmentLog.snapshot.type.customField) {
        return previousEquipmentLog.snapshot.type.customFields;
      }

      return [];
    }

    return { toTimeline: toTimeline };
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('equipmentsLabelsService', equipmentsLabelsService);

  /** @ngInject */
  function equipmentsLabelsService(_, MessageDialog, $translate, equipmentsApi, $rootScope, accountsApi,
    labelsApi) {

    function saveEquipmentLabels(equipment, isUpdate, callback) {
			if (!equipment.id) {
				return;
			}

			if (isUpdate) {
				$rootScope.loadingProgress = true;
			}

      var variables = {
        input: {
          type: 'equipments',
          id: equipment.id,
          labelsIds: _.map(equipment.labels, 'id'),
        }
      };

      return equipmentsApi.setLabels(variables)
				.then(function () {
					if (isUpdate) {
						MessageDialog.showToast({
							hideDelay: 3000,
							message: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.LABEL.UPDATED')
						});
					}
					if (callback) {
						callback();
					}
				})
				.finally(function () {
					if (isUpdate) {
						$rootScope.loadingProgress = false;
						$rootScope.$broadcast('equipments:reload');
					}
				});
    }

    function addLabel(label, callback) {
      var variables = {
        input: {
          color: label.color,
          name: label.name,
          type: 'equipments'
        }
      };

      labelsApi.create(variables).then(function (response) {
        callback(response);
			});
    }

    function loadEquipmentsLabels(equipment, callback) {
      return loadLabels(100, callback, equipment);
    }

    function loadLabels(limit, callback, equipment) {
      return labelsApi.search({ type: 'equipments' }, { limit: limit }).then(function (response) {
        if (!response.items && !response.items.length) {
          callback([]);
        }

        var labels = [];
        labels = _.map(response.items, function (label) {
          label.isLinked = labelIsLinkedOnEquipment(equipment, label);
          return label;
        });

        callback(labels);
      });
    }

    function labelIsLinkedOnEquipment(equipment, label) {
      var labelIsLinkedOnEquipment = _.findIndex(equipment.labels, function (equipmentLabel) {
        return equipmentLabel.id === label.id;
      });
      return labelIsLinkedOnEquipment >= 0;
    }

    function updateLabel(updatedLabel, callback) {
			updatedLabel.type = 'equipments ';
      labelsApi.save(updatedLabel).then(function () {
        if (callback) {
          callback();
        }
			});
		}

    function toggleLabel(changedLabel, equipment, labels, callback) {
      var existingEquipmentLabelIndex = _.findIndex(equipment.labels, { id: changedLabel.id });
      if (existingEquipmentLabelIndex >= 0) {
        equipment.labels.splice(existingEquipmentLabelIndex, 1);
      } else {
        equipment.labels.push(changedLabel);
      }

      var label = _.findWhere(labels, { id: changedLabel.id });
      label.isLinked = existingEquipmentLabelIndex < 0;

      if (callback) {
        callback(equipment);
      }

      return equipment;
    }

    return {
      saveEquipmentLabels: saveEquipmentLabels,
      addLabel: addLabel,
      loadEquipmentsLabels: loadEquipmentsLabels,
      updateLabel: updateLabel,
      toggleLabel: toggleLabel,
      labelIsLinkedOnEquipment: labelIsLinkedOnEquipment
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.equipment-types', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.equipment-types', {
            url    : '/tipos-de-equipamento',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/equipment-types/equipment-types.html',
                    controller : 'EquipmentTypesController as vm'
                }
            },
            data: { titleTranslateKey: 'EQUIPMENT_TYPES.PAGE_TITLE' },
            resolve: {
                equipmentTypes: function (equipmentTypesApi) {
                    return equipmentTypesApi.getEquipmentTypes();
                },
                account: function (accountsApi) {
                    return accountsApi.get();
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/equipment-types');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.equipment-types')
        .factory('EquipmentTypesFilters', EquipmentTypesFilters);

    /** @ngInject */
    function EquipmentTypesFilters($timeout, $rootScope) {
        var filters = {
            name: '',
            archived: '1',
            clear: clear,
            isOn: isOn,
            isOff: isOff
        };

        function clear() {
            filters.name = '';
            filters.archived = '1';
            $timeout(function () { $rootScope.$broadcast('equipment-types:reload'); }, 200);
        }

        function isOn() {
            var noNameFiltered = filters.name === '';
            var noArchivedFiltered = filters.archived === '1';
            return !(noNameFiltered  && noArchivedFiltered);
        }

        function isOff() {
            return !isOn();
        }

        return filters;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.equipment-types')
        .controller('EquipmentTypesFiltersSideNavController', EquipmentTypesFiltersSideNavController);

    /** @ngInject */
    function EquipmentTypesFiltersSideNavController($rootScope, msUtils, EquipmentTypesFilters, _) {

        var vm = this;
        vm.equipmentTypes = [];
        vm.equipmentTypesFilters = EquipmentTypesFilters;
        vm.clearFilters = EquipmentTypesFilters.clear;
        vm.filteringIsOn = EquipmentTypesFilters.isOn;
        vm.exists = msUtils.exists;

        function broadcastFilterUpdated() {
            $rootScope.$broadcast('equipment-types:reload');
        }

        function _initialize() {
            vm.broadcastFilterUpdated = broadcastFilterUpdated;
            vm.equipmentTypesFilters = EquipmentTypesFilters;
        }

        _initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employees', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.employees', {
            url: '/colaboradores',
            views: {
                'content@app': {
                    templateUrl: 'app/main/employees/employees.html',
                    controller: 'EmployeesController as vm'
                }
            },
            data: { titleTranslateKey: 'EMPLOYEES.PAGE_TITLE' },
            resolve: {
                account: function (accountsApi) {
                    return accountsApi.get();
                },
                employees: function (employeesApi) {
                    return employeesApi.getAll();
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/employees');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.employees')
        .factory('EmployeesFilters', EmployeesFilters);

    /** @ngInject */
    function EmployeesFilters($timeout, $rootScope) {
        var filters = {
            name: '',
            archived: 'active',
            clear: clear,
            isOn: isOn,
            isOff: isOff
        };

        function clear() {
            filters.name = '';
            filters.archived = 'active';
            $timeout(function () { $rootScope.$broadcast('employees:reload'); }, 200);
        }

        function isOn() {
            var noNameFiltered = filters.name === '';
            var noArchivedFiltered = filters.archived === 'active';
            return !(noNameFiltered && noArchivedFiltered);
        }

        function isOff() {
            return !isOn();
        }

        return filters;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('EmployeesFiltersSideNavController', EmployeesFiltersSideNavController);

    /** @ngInject */
    function EmployeesFiltersSideNavController($rootScope, msUtils, EmployeesFilters, _) {

        var vm = this;
        vm.employees = [];
        vm.employeesFilters = EmployeesFilters;
        vm.clearFilters = EmployeesFilters.clear;
        vm.filteringIsOn = EmployeesFilters.isOn;
        vm.exists = msUtils.exists;

        function broadcastFilterUpdated() {
            $rootScope.$broadcast('employees:reload');
        }

        function _initialize() {
            vm.broadcastFilterUpdated = broadcastFilterUpdated;
            vm.employeesFilters = EmployeesFilters;
        }

        _initialize();
    }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('validateTimeService', validateTimeService);

  function validateTimeService() {
    return {
      isGreaterThan12Hours: isGreaterThan12Hours,
      isMinorThan1Hour: isMinorThan1Hour
    };

    function isGreaterThan12Hours(input, timeFormat) {
      if (!input) {
        return false;
      }
      if (timeFormat) {
        input = input.split(':')[0];
        if (input > 12) {
          return true;
        }
      }
    }

    function isMinorThan1Hour(input, timeFormat) {
      if (timeFormat && input) {
        input = input.split(':')[0];
        if (input < 1) {
          return true;
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.employees')
    .factory('EmployeePasswordDialog', EmployeePasswordDialog);

  /** @ngInject */
  function EmployeePasswordDialog($mdDialog, $document) {

    return {
      open: open
    };

    function open(ev, locals, callback) {

      $mdDialog.show({
        controller: 'EmployeePasswordDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employees/dialogs/password/employee-password-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          EmployeeUsername: locals.employeeUsername,
          EmployeeName: locals.employeeName
        },
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular.module('app.employees')
    .controller('EmployeePasswordDialogController', EmployeePasswordDialogController);

  /** @ngInject */
  function EmployeePasswordDialogController($scope, $mdDialog, $mdToast, $rootScope, msUtils, authApi, EmployeeUsername, EmployeeName, $translate, focus) {
    var vm = this;

    vm.closeDialog = closeDialog;
    vm.employee = {
      username: EmployeeUsername,
      name: EmployeeName,
      password: '',
      passwordRepeat: ''
    };
    vm.toggleNewPassword = false;
    vm.showConfirmationNewPassword = false;
    vm.samplePassword = msUtils.generateRandomPassword();

    vm.saveButtonDisabled = saveButtonDisabled;
    vm.updatePassword = updatePassword;
    vm.toggleNewPassword = toggleNewPassword;
    vm.toggleConfirmationNewPassword = toggleConfirmationNewPassword;

    function closeDialog(reload) {
      $mdDialog.hide(reload);
      $rootScope.loadingProgress = false;
    }

    function saveButtonDisabled() {
      if ($scope.employeeForm) {
        var isDisabled = ($scope.employeeForm.$invalid || $scope.employeeForm.$pristine || $rootScope.loadingProgress === true);
        return isDisabled;
      }
      return true;
    }

    function updatePassword() {
      $rootScope.loadingProgress = true;

      authApi.adminUpdatePassword(vm.employee.username, vm.employee.password).then(function () {
        $mdToast.show(
          $mdToast.simple()
              .textContent($translate.instant('EMPLOYEES.TOAST.PASSWORD_CHANGED', { name: vm.employee.name }))
              .hideDelay(3000)
        );
      }).catch(function (err) {
        var currentError = err.data && err.data.err;
        var message = currentError == 'auth/already-used-password' ? 'EMPLOYEES.TOAST.ALREADY_USED_PASSWORD' : 'EMPLOYEES.TOAST.UNEXPECTED_ERROR';
        $mdToast.show(
          $mdToast.simple()
              .textContent($translate.instant(message))
              .hideDelay(3000)
              .theme("error-toast")
        );
      }).finally(function () {
        $rootScope.loadingProgress = false;
        closeDialog();
      });
    }

    function toggleNewPassword() {
      vm.showNewPassword = !vm.showNewPassword;
      var inputPassword = document.getElementById('password');
      vm.showNewPassword ? inputPassword.classList.add("show") : inputPassword.classList.remove("show");
      inputPassword.focus();
    }

    function toggleConfirmationNewPassword() {
      vm.showConfirmationNewPassword = !vm.showConfirmationNewPassword;
      var inputPasswordRepeat = document.querySelector('#passwordRepeat');
      vm.showConfirmationNewPassword ? inputPasswordRepeat.classList.add("show") : inputPasswordRepeat.classList.remove("show");
      inputPasswordRepeat.focus();
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('InactivateEmployeeDialogController', InactivateEmployeeDialogController);

    /** @ngInject */
    function InactivateEmployeeDialogController($scope, focus, Employee, employeesApi, $mdDialog, MessageDialog, $rootScope, $translate, FcToastService) {

        var vm = this;
        vm.formErr = {};

        vm.closeDialog = closeDialog;
        vm.employeeTabIndex = 0;
        vm.inactivateEmployee = inactivateEmployee;
        vm.employee = angular.copy(Employee);
        vm.employee.fistName = vm.employee.name.split(' ')[0];
        vm.verifyFistName = null;

        function inactivateEmployee() {
            $rootScope.loadingProgress = true;

            employeesApi.inactivate(vm.employee.id).then(function () {
                FcToastService.addWarning({
                  hideDelay: 2900,
                  position: 'BOTTOM LEFT',
                  success: true,
                  iconPath: 'assets/icons/icon-success-circle-green.svg',
                  title: $translate.instant('EMPLOYEES.TOAST.EMPLOYEE_SUCCESSFULLY_INACTIVATED'),
                  noExit: true
                });

                $rootScope.$broadcast('employees:reload');
                closeDialog(true);
            }).catch(function () {
                MessageDialog.showToast({
                    message: $translate.instant('EMPLOYEES.TOAST.INACTIVATE_EMPLOYEE_FAILED', { username: vm.employee.name })
                });
            }).finally(function () {
                $rootScope.loadingProgress = false;
            });
        }

        function closeDialog(reload) {
            $mdDialog.hide(reload);
        }

        focus('firstName');
    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.devices', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider)
  {
    $stateProvider.state('app.devices', {
      url    : '/dispositivos',
      views  : {
        'content@app': {
          templateUrl: 'app/main/devices/devices.html',
          controller : 'DevicesController as vm'
        }
      },
      data: { titleTranslateKey: 'DEVICES.PAGE_TITLE' },
    });
    $translatePartialLoaderProvider.addPart('app/main/devices');
  }

})();
(function () {
    'use strict';

    angular
        .module('app.devices')
        .controller('DeleteDevicesDialogController', DeleteDevicesDialogController);

    /** @ngInject */
    function DeleteDevicesDialogController(focus, Employee, devicesApiGraphQL, $mdDialog, MessageDialog, $rootScope, $translate, FcToastService) {
        var vm = this;
        vm.formErr = {};

        vm.closeDialog = closeDialog;
        vm.deleteDevices = deleteDevices;
        vm.employee = angular.copy(Employee);

        function deleteDevices() {
            $rootScope.loadingProgress = true;

            devicesApiGraphQL.deleteDevices(vm.employee._id).then(function () {
                FcToastService.addWarning({
                  hideDelay: 2900,
                  position: 'BOTTOM LEFT',
                  success: true,
                  iconPath: 'assets/icons/icon-success-circle-green.svg',
                  title: $translate.instant('EMPLOYEES.TOAST.DEVICES_DELETED'),
                  noExit: true
                });

                $rootScope.$broadcast('employees:reload');
                closeDialog(true);
            }).catch(function () {
                MessageDialog.showToast({
                    message: $translate.instant('EMPLOYEES.TOAST.DELETE_DEVICES_FAILED')
                });
            }).finally(function () {
                $rootScope.loadingProgress = false;
            });
        }

        function closeDialog(reload) {
            $mdDialog.hide(reload);
        }

        focus('firstName');
    }
})();

(function () {
  'use strict';

  angular.module('app.employees')
    .factory('EmployeeCredentialsDialog', EmployeeCredentialsDialog);

  /** @ngInject */
  function EmployeeCredentialsDialog($mdDialog, $document) {

    return {
      open: open
    };

    function open(ev, locals, callback) {

      $mdDialog.show({
        controller: 'EmployeeCredentialsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employees/dialogs/credentials/employee-credentials-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          EmployeeId: locals.employeeId,
          EmployeeName: locals.employeeName
        }
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular.module('app.employees')
    .controller('EmployeeCredentialsDialogController', EmployeeCredentialsDialogController);

  /** @ngInject */
  function EmployeeCredentialsDialogController($scope, $mdDialog, $mdToast, $rootScope, msUtils, authApi, employeesApi, EmployeeId, EmployeeName, $translate) {
    var vm = this;

    vm.formErr = {};
    vm.closeDialog = closeDialog;
    vm.employee = {
      name: EmployeeName,
      email: '',
      password: '',
      passwordRepeat: ''
    };
    vm.samplePassword = msUtils.generateRandomPassword();
    vm.saveButtonDisabled = saveButtonDisabled;
    vm.addCredentials = addCredentials;
    vm.checkEmailErr = checkEmailErr;
    vm.termsAccept = false;

    function closeDialog(reload) {
      $mdDialog.hide(reload);
      $rootScope.loadingProgress = false;
    }

    function saveButtonDisabled() {
      if ($scope.employeeForm) {
        var isDisabled = ($scope.employeeForm.$invalid || $scope.employeeForm.$pristine || $rootScope.loadingProgress === true || vm.termsAccept === false);
        return isDisabled;
      }
      return true;
    }

    function checkEmailErr() {
      if (vm.formErr['employee_email_already_taken_value'] !== vm.employee.email) {
        delete vm.formErr['email_already_taken'];
      }
    }

    function addCredentials() {
      $rootScope.loadingProgress = true;

      employeesApi.patchEmployee(EmployeeId, { email: vm.employee.email }).then(function () {
        authApi.adminUpdatePassword(vm.employee.email, vm.employee.password).then(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('EMPLOYEES.TOAST.CREDENTIALS_ADDED', { name: vm.employee.name }))
              .hideDelay(3000)
          );
        }).catch(function (err) {
          var currentError = err.data && err.data.err;
          var message = currentError === 'auth/already-used-password' ? 'EMPLOYEES.TOAST.ALREADY_USED_PASSWORD' : 'EMPLOYEES.TOAST.UNEXPECTED_ERROR';
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant(message))
              .hideDelay(3000)
              .theme("error-toast")
          );
        }).finally(function () {
          $rootScope.loadingProgress = false;
          closeDialog();
        });
      }).catch(function (result) {
        if (result.status === 422) {
          if(result.data.code === 'employee_email_already_taken') {
            vm.formErr['employee_email_already_taken_value'] = vm.employee.email;
            vm.formErr['email_already_taken'] = $translate.instant('EMPLOYEES.MODEL.ERRORS.EMAIL_ALREADY_TAKEN');
          }
        } else {
          $mdToast.show(
            $mdToast.simple()
            .textContent($translate.instant('EMPLOYEES.TOAST.UNEXPECTED_ERROR'))
            .hideDelay(3000)
            .theme("error-toast")
          );
          closeDialog();
        }

        $rootScope.loadingProgress = false;
      });
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('ActivateEmployeeDialogController', ActivateEmployeeDialogController);

    /** @ngInject */
    function ActivateEmployeeDialogController($scope, focus, Employee, employeesApi, $mdDialog, MessageDialog, $rootScope, $translate, FcToastService) {

        var vm = this;
        vm.formErr = {};

        vm.closeDialog = closeDialog;
        vm.employeeTabIndex = 0;
        vm.activateEmployee = activateEmployee;
        vm.employee = angular.copy(Employee);
        vm.employee.fistName = vm.employee.name.split(' ')[0];
        vm.verifyFistName = null;

        function activateEmployee() {
            $rootScope.loadingProgress = true;

            employeesApi.activate(vm.employee.id).then(function () {
                FcToastService.addWarning({
                  hideDelay: 2900,
                  position: 'BOTTOM LEFT',
                  success: true,
                  iconPath: 'assets/icons/icon-success-circle-green.svg',
                  title: $translate.instant('EMPLOYEES.TOAST.EMPLOYEE_SUCCESSFULLY_ACTIVATED'),
                  noExit: true
                });

                $rootScope.$broadcast('employees:reload');
                closeDialog(true);
            }).catch(function (err) {
              if (err && err.data && err.data.err === 'already-existing-employee/with-email') {
                return MessageDialog.showToast({
                  message: $translate.instant('EMPLOYEES.TOAST.ACTIVATE_EMPLOYEE_FAILED_EMAIL', { username: vm.employee.name })
                });
              }
              MessageDialog.showToast({
                  message: $translate.instant('EMPLOYEES.TOAST.ACTIVATE_EMPLOYEE_FAILED', { username: vm.employee.name })
              });
            }).finally(function () {
                $rootScope.loadingProgress = false;
            });
        }

        function closeDialog(reload) {
            $mdDialog.hide(reload);
        }

        focus('firstName');
    }
})();

(function () {
  'use strict';

  angular
    .module('app.devices')
    .factory('DevicesFilters', DevicesFilters);

  /** @ngInject */
  function DevicesFilters($timeout, $rootScope) {
    var filters = {
      uuid: '',
      manufacturer: '',
      platform_name: '',
      last_seen_with: null,
      type: null,
      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.uuid = '';
      filters.manufacturer = '';
      filters.platform_name = '';
      filters.last_seen_with = null;
      $timeout(function () { $rootScope.$broadcast('devices:reload'); }, 200);
    }

    function isOn() {
      var noUuidFiltered = filters.uuid === '';
      var noManufacturerFiltered = filters.manufacturer === '';
      var noPlatformNameFiltered = filters.platform_name === '';
      var noLastSeenWithFiltered = filters.last_seen_with === null;
      return !(
        noUuidFiltered &&
        noManufacturerFiltered &&
        noPlatformNameFiltered &&
        noLastSeenWithFiltered
      );
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular.module('app.devices').controller('DevicesFiltersSideNavController', DevicesFiltersSideNavController);

  /** @ngInject */
  function DevicesFiltersSideNavController($rootScope, msUtils, DevicesFilters, employeesApi, _) {
    var vm = this;
    vm.devices = [];
    vm.employees = [];
    vm.activeEmployees = [];
    vm.unactiveEmployees = [];
    vm.employeesTypes = ['All', 'Active', 'Unactive'];
    vm.currentType = '';
    vm.platforms = [
      { icon: 'icon-apple-ios', name: 'iOS' },
      { icon: 'icon-android', name: 'Android' },
      { icon: 'icon-monitor', name: 'Web' }
    ];
    vm.devicesFilters = DevicesFilters;
    vm.clearFilters = DevicesFilters.clear;
    vm.filteringIsOn = DevicesFilters.isOn;
    vm.exists = msUtils.exists;
    vm.typeUpdated = typeUpdated;

    function typeUpdated() {
      vm.currentType = vm.devicesFilters.type;
      if (vm.devicesFilters.last_seen_with !== null) {
        vm.devicesFilters.last_seen_with = null;
        broadcastFilterUpdated();
      }
    }

    function broadcastFilterUpdated() {
      $rootScope.$broadcast('devices:reload');
    }

    function filterPlatform(platformName) {
      vm.devicesFilters.platform_name = platformName;
    }

    function _initialize() {
      vm.broadcastFilterUpdated = broadcastFilterUpdated;
      vm.filterPlatform = filterPlatform;

      employeesApi.getAll().then(function (result) {
        var employees = result.items;
        employees = _.sortBy(employees, function (employee) {
          return employee.name;
        });

        var activeEmployees = _.filter(employees, function (employee) { return employee.contract.active && !employee.inactivatedAt; });
        var unactiveEmployees = _.filter(employees, function (employee) { return !employee.contract.active && !employee.inactivatedAt; });

        vm.employees = employees;
        vm.activeEmployees = activeEmployees;
        vm.unactiveEmployees = unactiveEmployees;
      });

      vm.devicesFilters = DevicesFilters;
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deadline-violations-reasons', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider
      .state('app.deadline-violations-reasons', {
        url: '/motivos-de-violacao-de-prazo',
        views: {
          'content@app': {
            templateUrl: 'app/main/deadline-violations-reasons/deadline-violations-reasons.html',
            controller: 'DeadlineViolationosReasonsController as vm'
          }
        }
      });

    $translatePartialLoaderProvider.addPart('app/main/deadline-violations-reasons');
  }

})();

(function () {
  'use strict';

  angular
    .module('app.deadline-violations-reasons')
    .factory('DeadlineViolationsReasonsFilters', DeadlineViolationsReasonsFilters);

  /** @ngInject */
  function DeadlineViolationsReasonsFilters($rootScope, $timeout) {

    var filters = {
      name: '',
      description: '',
      archived: '1',
      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.name = '';
      filters.description = '';
      filters.archived = '1';

      $timeout(function () { $rootScope.$broadcast('deadline-violations-reasons:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = !filters.name;
      var noDescriptionFiltereed = !filters.description;
      var noArchivedFiltered = filters.archived === '1';

      return !(noNameFiltered && noDescriptionFiltereed && noArchivedFiltered);
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deadline-violations-reasons')
    .controller('DeadlineViolationsReasonsSideNavController', DeadlineViolationsReasonsSideNavController);

  /** @ngInject */
  function DeadlineViolationsReasonsSideNavController(DeadlineViolationsReasonsFilters, _, msUtils, $rootScope, $timeout) {

    var vm = this;
    vm.deadlineViolationsReasonsFilters = DeadlineViolationsReasonsFilters;
    vm.toggleInArray = toggleInArray;
    vm.exists = msUtils.exists;

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }

    vm.broadcastFilterUpdated = _.debounce(function () {
      $timeout(function () {
        $rootScope.$broadcast('deadline-violations-reasons:reload');
      }, 50);
    }, 500);
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deadline-contracts', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider
      .state('app.deadline-contracts', {
        url: '/contratos-de-prazos',
        views: {
          'content@app': {
            templateUrl: 'app/main/deadline-contracts/deadline-contracts.html',
            controller: 'DeadlineContractsController as vm'
          }
        },
        resolve: {
          account: function (accountsApi) {
            return accountsApi.get();
          }
        }
      });

    $translatePartialLoaderProvider.addPart('app/main/deadline-contracts');
  }

})();

(function () {
  'use strict';

  angular
    .module('app.deadline-contracts')
    .factory('DeadlineContractsFilters', DeadlineContractsFilters);

  /** @ngInject */
  function DeadlineContractsFilters($rootScope, $timeout) {

    var filters = {
      name: '',
      description: '',
      archived: '0',
      clear: clear,
      isOn: isOn,
      isOff: isOff
    };

    function clear() {
      filters.name = '';
      filters.description = '';
      filters.archived = '0';

      $timeout(function () { $rootScope.$broadcast('deadline-contracts:reload'); }, 200);
    }

    function isOn() {
      var noNameFiltered = !filters.name;
      var noDescriptionFiltereed = !filters.description;
      var noArchivedFiltered = filters.archived === '0';

      return !(noNameFiltered && noDescriptionFiltereed && noArchivedFiltered);
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deadline-contracts')
    .controller('DeadlineContractsFiltersSideNavController', DeadlineContractsFiltersSideNavController);

  /** @ngInject */
  function DeadlineContractsFiltersSideNavController(DeadlineContractsFilters, _, msUtils, $rootScope, $timeout) {

    var vm = this;
    vm.deadlineContractsFilters = DeadlineContractsFilters;
    vm.toggleInArray = toggleInArray;
    vm.exists = msUtils.exists;

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }

    vm.broadcastFilterUpdated = _.debounce(function () {
      $timeout(function () {
        $rootScope.$broadcast('deadline-contracts:reload');
      }, 50);
    }, 500);
  }
})();

(function () {
  'use strict';

  angular.module('app.customers')
    .factory('customerTasksTimelineConverter', customerTasksTimelineConverter);

  /** @ngInject */
  function customerTasksTimelineConverter(TasksStatusHelper, $translate, LocalDateConvert) {
    return {
      toTimeline: toTimeline
    };

    function toTimeline(tasks) {
      var timeline = [];

      tasks = tasks || [];
      tasks.forEach(function (task) {
        var currentStatus = TasksStatusHelper.getByName(task.status);
        var avatarUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg';

        if (task.employee && task.employee.avatarUrl) {
          avatarUrl = task.employee.avatarUrl;
        }

        var itemTime = task.scheduling.date ? LocalDateConvert.formatDate(task.scheduling.date, 'date') : null;
        if (task.scheduling.time) {
          itemTime += ' ' + LocalDateConvert.formatDate(task.scheduling.time, 'time-seconds');
        }

        var cardText = '<b>' + task.order.service.description + '</b>';

        if (task.order.description) {
          cardText += '<br/>';
          cardText += '<br/>';
          cardText += task.order.description;
        }

        if (task.statusDescription) {
          cardText += '<br/>';
          cardText += '<br/>';
          cardText += '<span class="' + currentStatus.colorClass + '">' + task.statusDescription + '</span>';
        }

        var eventHtml = '';
        if (task.status == 'pending') {
          eventHtml += 'Atividade pendente, aguardando agendamento.';
        } else if (task.status == 'scheduled') {
          eventHtml += $translate.instant("CUSTOMERS.SERVICES.SCHEDULED_ACTIVITY");
        } else if (task.status == 'in-progress') {
          eventHtml += $translate.instant("CUSTOMERS.SERVICES.ACTIVITY_IN_PROGRESS") + ' ' + LocalDateConvert.formatDate(task.startedAt, 'time-seconds');
        } else if (task.status == 'on-route') {
          eventHtml += 'Atividade em deslocamento';
        } else if (task.status == 'canceled') {
          eventHtml += $translate.instant("CUSTOMERS.SERVICES.ACTIVITY_CANCELED");
        } else if (task.status == 'reported') {
          eventHtml += $translate.instant("CUSTOMERS.SERVICES.OPENING_HOURS") + ' <b />';
          eventHtml += LocalDateConvert.formatDate(task.startedAt, 'time-seconds') + '<b /> ' + $translate.instant("CUSTOMERS.SERVICES.UNTIL") + ' <b />' + LocalDateConvert.formatDate(task.completedAt, 'time-seconds') + '<b />';
          eventHtml += ' ' + $translate.instant("CUSTOMERS.SERVICES.TOTAL_DURATION_OF") + ' <b />' + moment(task.completedAt).diff(task.startedAt, 'minutes') + '<b /> ' + $translate.instant("CUSTOMERS.SERVICES.MINUTES");
        } else if (task.status == 'done') {
          eventHtml += $translate.instant("CUSTOMERS.SERVICES.OPENING_HOURS") + ' <b />';
          eventHtml += LocalDateConvert.formatDate(task.startedAt, 'time-seconds') + '<b /> ' + $translate.instant("CUSTOMERS.SERVICES.UNTIL") + ' <b />' + LocalDateConvert.formatDate(task.completedAt, 'time-seconds') + '<b />';
          eventHtml += ' ' + $translate.instant("CUSTOMERS.SERVICES.TOTAL_DURATION_OF") + ' <b />' + moment(task.completedAt).diff(task.startedAt, 'minutes') + '<b /> ' + $translate.instant("CUSTOMERS.SERVICES.MINUTES");
        }

        var timelineEvent = {
          id: task.id,
          card: {
            template: "app/core/directives/ms-card/templates/template-12/template-12.html",
            avatar: {
              src: avatarUrl,
              alt: task.employee ? task.employee.name : ''
            },
            title: task.employee ? task.employee.name : '',
            subtitle: currentStatus.description,
            subtitleColor: currentStatus.color,
            text: cardText
          },
          icon: currentStatus.icon,
          color: currentStatus.color,
          time: itemTime,
          eventHtml: eventHtml
        };

        timeline.push(timelineEvent);
      });

      return timeline;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('OmieCustomersManualImportDialogController', OmieCustomersManualImportDialogController);

  /** @ngInject */
  function OmieCustomersManualImportDialogController(
    _, customerLocationsApi, $mdDialog, $rootScope, $scope, FcToastService, locals,
    customersApi, omieCustomerMapper, omieApi, $translate, msUtils, geoCoder
  ) {
    var vm = this;

    vm.limitPerPage = 5;
    vm.currentPage = 1;
    vm.totalPages = 0;
    vm.totalCount = 0;
    vm.allCustomers = [];
    vm.nameContains = '';
    vm.filterTypes = [
      { value: { name: $translate.instant('CUSTOMERS.INTEGRATIONS.OMIE.FILTERS.CORPORATE_NAME'), code: 'razao_social' }},
      { value: { name: $translate.instant('CUSTOMERS.INTEGRATIONS.OMIE.FILTERS.TRADE_NAME'), code: 'nome_fantasia' }}
    ];
    vm.filterType = {name: $translate.instant('CUSTOMERS.INTEGRATIONS.OMIE.FILTERS.CORPORATE_NAME'), code: 'razao_social'};

    vm.navigateToPage = navigateToPage;
    vm.onSearchChange = onSearchChange;
    vm.searchCustomers = searchCustomers;
    vm.importCustomer = importCustomer;
    vm.updateCustomer = updateCustomer;
    vm.closeDialog = closeDialog;
    vm.isValidUUID = msUtils.isUuidV4;
    vm.appId = locals.appId;

    _initialize();

    function navigateToPage(isNextPage) {
      vm.currentPage = isNextPage ? vm.currentPage + 1 : vm.currentPage - 1;
      searchCustomers();
    }

    $scope.$watch(function () {
      return vm.filterType;
    }, function (newVal, oldVal) {
      if (newVal !== oldVal && vm.nameContains.length >= 3) {
        vm.searchCustomers();
      }
    });
    function onSearchChange() {
      vm.currentPage = 1;
      searchCustomers();
    }

    function searchCustomers() {
      $rootScope.isLoading = true;
      _getOmieCustomersToImport()
        .then(function (response) {
          _.defer(function () {
            $scope.$apply(function () {
              vm.totalPages = response.total_de_paginas || 0;
              vm.totalCount = response.total_de_registros || 0;
              var omieCustomers = response.clientes_cadastro;
              if (omieCustomers && omieCustomers.length) {
                vm.allCustomers = omieCustomers.map(function (omieCustomer) {
                  var fieldControlCustomer = omieCustomerMapper.toFieldControl(omieCustomer);
                  checkIfExistsInFieldControl(fieldControlCustomer);
                  return fieldControlCustomer;
                });
              }
            });
          });
        })
        .catch(function () {
          FcToastService.addWarning({
            hideDelay: 5000,
            position: 'BOTTOM LEFT',
            title: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.LOADING_ERROR'),
            customClass: 'import-error-toast',
            iconPath: 'assets/icons/icon-service-error.svg',
            errorType: 'import-error-toast',
            noExit: true
          });
        });
    }

    function _getOmieCustomersToImport() {
      $rootScope.loadingProgress = true;
      vm.isLoadingCustomers = true;
      var filter;

      if (vm.nameContains.length >= 3) {
        if (!isNaN(parseInt(vm.nameContains))) {
          filter = { cnpj_cpf: vm.nameContains };
        } else if (vm.filterType.code === 'nome_fantasia') {
          filter = { nome_fantasia: vm.nameContains };
        } else {
          filter = { razao_social: vm.nameContains };
        }
      }

      return omieApi.customers.list({
          clientesFiltro: filter,
          pagina: vm.currentPage,
          registros_por_pagina: vm.limitPerPage,
          apenas_importado_api: 'N'
        }, vm.appId).then(function (response) {
          return response.data;
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
          vm.isLoadingCustomers = false;
        });
    }

    function checkIfExistsInFieldControl(apiCustomer) {
      if (apiCustomer.documentNumber) {
        customersApi.search({ where: { documentNumber: apiCustomer.documentNumber }, take: 1 }).then(function (result) {
          if (result.items.length) {
            apiCustomer.currentFieldCustomer = result.items[0];
            apiCustomer.archived = result.items[0].archived;
            apiCustomer.actionName = $translate.instant('CUSTOMERS.INTEGRATIONS.UPDATE');
            apiCustomer.updating = true;
          } else {
            apiCustomer.actionName = $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORT');
            apiCustomer.archived = null;
          }
          $rootScope.isLoading = false;
        });
      } else {
        $rootScope.isLoading = false;
        apiCustomer.actionName = $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORT');
      }
    };

    function importCustomer(customerToSave) {
      $rootScope.loadingProgress = true;

      geoCoder.getByAddressObject(customerToSave.address).then(function (location) {
        var lat = location ? location.lat : null;
        var lng = location ? location.lng : null;

        customerToSave.address.coords.latitude = lat;
        customerToSave.address.coords.longitude = lng;
        customerToSave.externalAppId = vm.appId;

        customersApi.save(customerToSave)
        .then(function () {
          customerToSave.selected = true;
        })
        .catch(function () {
          return _throwDefaultWarningByType('error', 'create');
        }).finally(function () {
          $rootScope.loadingProgress = false;
        });
      });
    }

    function updateCustomer(customerToUpdate) {
      $rootScope.loadingProgress = true;

      geoCoder.getByAddressObject(customerToUpdate.address).then(function (location) {
        var lat = location ? location.lat : null;
        var lng = location ? location.lng : null;

        customerToUpdate.address.coords.latitude = lat;
        customerToUpdate.address.coords.longitude = lng;
        customerToUpdate.externalAppId = vm.appId;

        customerToUpdate.id = customerToUpdate.currentFieldCustomer.id;

        customersApi.putCustomer(customerToUpdate)
        .then(function (customerResult) {
          customerToUpdate.selected = true;
          var customer = customerResult && customerResult.length && customerResult[0];
          if(customer && customer.primaryLocation && customer.primaryLocation.id) {
            var locationId = customer.primaryLocation.id;

            return customerLocationsApi.getOne(locationId).then(function (locationResult) {
              customerToUpdate.address.postalCode = customerToUpdate.address.zipCode;
              locationResult.address = customerToUpdate.address;
              return customersApi.putLocation(customerToUpdate.id, locationResult).then(function (result) {
                return _throwDefaultWarningByType('success', 'update');
              });
            });
          }
        })
        .catch(function (err) {
          console.error('Error updating Omie Customer on Field: ' + err);

          if (err.status === 404 || !customerToUpdate.id) {
            customersApi.search({ where: { documentNumber: customerToUpdate.documentNumber }, take: 1 }).then(function (result) {
              if (!result.items.length) {
                delete customerToUpdate.id;
                return customersApi.save(customerToUpdate).finally(function () {
                  _throwUpdateCreationError();
                });
              }

              _throwDefaultWarningByType('error', 'update');
            });

            return;
          }

          return _throwDefaultWarningByType('error', 'update');
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
      });
    }

    function _throwDefaultWarningByType(warningType, actionType) {
      var actionTranslation = actionType === 'update' ? 'UPDATE_SUCCESS' : 'SUCCESS_MANUAL';
      if (warningType === 'error') {
        actionTranslation = actionType === 'update' ? 'UPDATE_ERROR' : 'CREATE_ERROR';
      }
      var warningKeys = {
        error: {
          title: 'CUSTOMERS.INTEGRATIONS.IMPORTS.' + actionTranslation,
          customClass: 'import-error-toast',
          iconPath: 'assets/icons/icon-service-error.svg',
          errorType: 'import-error-toast'
        },
        success: {
          title: 'CUSTOMERS.INTEGRATIONS.IMPORTS.' + actionTranslation,
          customClass: 'import-finished-toast',
          iconPath: 'assets/icons/icon-success-circle-green.svg',
          errorType: 'import-finished-toast'
        }
      };
      var currentWarning = warningKeys[warningType];
      FcToastService.addWarning({
        hideDelay: 5000,
        position: 'BOTTOM LEFT',
        title: $translate.instant(currentWarning.title),
        customClass: currentWarning.customClass,
        iconPath: currentWarning.iconPath,
        errorType: currentWarning.errorType,
        noExit: true
      });
    }

    function _throwUpdateCreationError() {
      var errorWarningKeys = {
        title: 'CUSTOMERS.INTEGRATIONS.IMPORTS.UPDATE_ERROR_CREATE',
        customClass: 'import-error-toast',
        iconPath: 'assets/icons/icon-service-error.svg',
        errorType: 'import-error-toast'
      };

      FcToastService.addWarning({
        hideDelay: 5000,
        position: 'BOTTOM LEFT',
        title: $translate.instant(errorWarningKeys.title),
        customClass: errorWarningKeys.customClass,
        iconPath: errorWarningKeys.iconPath,
        errorType: errorWarningKeys.errorType,
        noExit: true
      });
    }

    function closeDialog() {
      $mdDialog.hide(true);
    }

    function _initialize() {
      searchCustomers(0);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.control-panel')
    .controller('ControlPanelMapController', ControlPanelMapController);

  /** @ngInject */
  function ControlPanelMapController($scope, hasher, OrderDialog, leafletData, MessageDialog, $translate,
    ControlPanelData, $rootScope, MapMarkerFilter, $timeout,
    moment, mapHtmlTemplate, TasksStatusHelper, Account, attachmentsUtils, legendOptions) {

    var vm = this;
    vm.pooling = null;
    vm.poolingInterval = 120000;
    vm.mapControl = {};
    vm.map = {
      center: {
        zoom: 12
      },

      fit: true,
      options: {},
      controls: {
        fullscreen: {
          position: 'topleft'
        }
      },

      hashMarkers: null,
      markers: [],

      legend: legendOptions(Account.name),
      layers: {
        baselayers: {
          mapbox_standard: {
            name: $translate.instant("CONTROL_PANEL.VIEWS.MAP.LAYERS.DEFAULT"),
            url: 'https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
            type: 'xyz',
            layerOptions: {
              'showOnSelector': true
            }
          },
          mapbox_satellite: {
            name: $translate.instant("CONTROL_PANEL.VIEWS.MAP.LAYERS.SATELLITE"),
            url: 'https://mt0.google.com/vt/lyrs=y&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
            type: 'xyz',
            layerOptions: {
              'showOnSelector': true
            }
          },
          mapbox_roadmap: {
            name: $translate.instant("CONTROL_PANEL.VIEWS.MAP.LAYERS.ROADS"),
            url: 'https://mt0.google.com/vt/lyrs=h&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
            type: 'xyz',
            layerOptions: {
              'showOnSelector': true
            }
          },
          mapbox_terrain: {
            name: $translate.instant("CONTROL_PANEL.VIEWS.MAP.LAYERS.GROUND"),
            url: 'https://mt0.google.com/vt/lyrs=p&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
            type: 'xyz',
            layerOptions: {
              'showOnSelector': true
            }
          }
        }
      }
    };
    vm.mapFitOn = true;
    vm.clusterOn = false;
    vm.mapAutoUpdate = false;
    vm.changedClusterMode = changedClusterMode;
    vm.changeMapFit = changeMapFit;
    vm.mapAutoUpdateChanged = mapAutoUpdateChanged;

    window.TheMirrorAnalytics.trackPageView('Page', 'Mapa');

    function mapAutoUpdateChanged() {
      if (vm.mapAutoUpdate) {
        vm.polling = $timeout(autoUpdate, vm.poolingInterval);

        MessageDialog.showToast({
          message: $translate.instant('CONTROL_PANEL.AUTOUPDATE_ENABLE') || 'Auto refresh enabled, map will be updated every 2 minutes'
        });
      } else {
        $timeout.cancel(vm.polling);

        MessageDialog.showToast({
          message: $translate.instant('CONTROL_PANEL.AUTOUPDATE_DISABLE') || 'Auto refresh desabled'
        });
      }
    }

    $scope.$on("$destroy", function () {
      $timeout.cancel(vm.polling);
    });

    function autoUpdate() {
      ControlPanelData.loadData();
      vm.polling = $timeout(autoUpdate, vm.poolingInterval);
    }

    function changeMapFit() {
      centralizeMap();
    }

    function changedClusterMode() {
      reloadGMaps(true);
    }

    $scope.$on('control-panel:data-updated', function (event, data) {
      $rootScope.loadingProgress = true;
      vm.data = data;
      reloadGMaps(true);
      $rootScope.loadingProgress = false;
    });

    $scope.$on('control-panel:filter-updated', function () {
      $rootScope.loadingProgress = true;
      reloadGMaps(true);
      $rootScope.loadingProgress = false;
    });

    function reloadGMaps(withFilters) {

      var taskMarkers = [];
      var employeeMarkers = [];

      if (!vm.data) return;

      var notArchivedTasks = _.filter(vm.data.tasks, function (task) {
        return task.archived === false;
      });

      notArchivedTasks.forEach(function (task) {

        var templateTooltip = mapHtmlTemplate.taskMarkerTemplate(task);
        var taskStatus = TasksStatusHelper.getByName(task.status);

        var taskMarker = {
          id: task.id,
          orderId: task.order.id,
          orderDescription: task.order.description,
          isTask: true,
          isEmployee: false,
          status: task.status,
          statusValue: taskStatus.value,
          serviceId: task.order.service.id,
          customerName: task.order.customer.name,
          customerLabels: task.order.customer.labels,
          locationName: task.order.location ? task.order.location.name : undefined,
          latitude: task.coords.latitude,
          lat: task.coords.latitude,
          longitude: task.coords.longitude,
          lng: task.coords.longitude,
          ratingStars: 0,
          icon: {
            type: 'div',
            html: '<div>' +
              '    <i style="color:' + taskStatus.color + ';" class="icon icon-city s38" data-cy="task-map"></i>' +
              '</div>',
            iconAnchor: [16, 16], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -16]  // point from which the popup should open relative to the iconAnchor
          },
          getMessageScope: function () { return $scope; },
          message: templateTooltip,
          compileMessage: true
        };

        if (task.rating && task.rating.id && task.rating.stars) {
          taskMarker.ratingStars = task.rating.stars;
        }

        if (task.order && task.order.labels) {
          taskMarker.labels = task.order.labels;
        }

        if (task.employee && task.employee.id) {
          taskMarker.employeeId = task.employee.id;
        } else {
          taskMarker.employeeId = 'null';
        }

        if (vm.clusterOn) {
          taskMarker.group = 'tasks';
        }

        taskMarkers.push(taskMarker);
      });


      if (moment().isSame(ControlPanelData.getDate(), 'day')) {
        vm.data.locations.forEach(function (location) {

          if (location.employee) {

            var templateTooltip = mapHtmlTemplate.employeeMarkerTemplate(location);

            var employeePin = '../assets/images/null-avatar.jpg';
            var pinClass = location.employee.isOnline ? 'online-pin' : 'offline-pin';

            if (location.employee.avatarUrl) {
              employeePin = location.employee.avatarUrl;
            }

            employeeMarkers.push({
              id: location.id,
              isActivity: false,
              isEmployee: true,
              employeeId: location.employee && location.employee.id,
              latitude: location.latitude,
              lat: parseFloat(location.latitude),
              longitude: location.longitude,
              lng: parseFloat(location.longitude),
              icon: {
                type: 'div',
                html: '<div>' +
                  '    <img src="' + employeePin + '" class="marker-border-radius employee-marker">' +
                  '    <div class="marker-pin ' + pinClass + '"></div>' +
                  '</div>',
                iconAnchor: [20, 20], // point of the icon which will correspond to marker's location
                popupAnchor: [0, -20]  // point from which the popup should open relative to the iconAnchor
              },
              message: templateTooltip,
              compileMessage: true
            });
          }
        });
      }

      var markers = [];

      if (withFilters) {

        taskMarkers.forEach(function (activityMarker) {
          var marker = MapMarkerFilter.filterTask(activityMarker);
          if (marker) {
            markers.push(marker);
          }
        });

        employeeMarkers.forEach(function (employeeMarker) {
          var marker = MapMarkerFilter.filterEmployee(employeeMarker);
          if (marker) {
            markers.push(marker);
          }
        });

      } else {
        markers = taskMarkers.concat(employeeMarkers);
      }

      var hashMarkers = hasher.sha1(markers);
      if (hashMarkers !== vm.map.hashMarkers) {
        vm.map.hashMarkers = hashMarkers;

        vm.map.markers = {};
        vm.map._markers = markers;
        showCompanyLocation();
        $timeout(function () {
          markers.forEach(function (marker) {
            var id = String(marker.id);
            id = id.replace(/-/g, '');
            vm.map.markers[id] = marker;
          });
        }, 100);

        $timeout(function () { centralizeMap(); }, 300);

      } else {
        centralizeMap();
      }
    }

    function showCompanyLocation() {
      Account.logoUrl = attachmentsUtils.correctUrl(Account.logoUrl);
      if (Account.address && Account.address.coords) {
        var companyMarker = {
          id: Account.id,
          latitude: parseFloat(Account.address.coords.latitude),
          lat: parseFloat(Account.address.coords.latitude),
          longitude: parseFloat(Account.address.coords.longitude),
          lng: parseFloat(Account.address.coords.longitude),
          opacity: 0.9,
          icon: {
            type: 'div',
            html: '<div class="company-logo">' +
              '</div>',
            iconSize: [38, 38], // size of the icon
            iconAnchor: [8, 16], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -16]  // point from which the popup should open relative to the iconAnchor
          },
          message: Account.name
        };
        vm.map.markers[Account.id] = companyMarker;
      }
    }

    $scope.editTask = function (ev, id) {

      OrderDialog.editTask(ev, { id: id }, function (reload) {
        if (reload) {
          ControlPanelData.loadData();
        }
      });

    };

    function centralizeMap() {
      if (vm.mapFitOn) {

        var boundsItems = [];
        vm.map._markers.forEach(function (marker) {
          boundsItems.push([marker.latitude, marker.longitude]);
        });

        var bounds = L.latLngBounds(boundsItems);
        leafletData.getMap('controlPanelMap').then(function (map) {
          if (bounds._northEast && bounds._southWest) {
            map.fitBounds(bounds);
          }
        });
      }
    }

    $rootScope.controlPanel = $rootScope.controlPanel || {};
    $rootScope.controlPanel.activeView = 'map';
  }
})();

(function () {
    'use strict';

    angular
        .module('app.control-panel')
        .controller('ControlPanelMainController', ControlPanelMainController);

    /** @ngInject */
    function ControlPanelMainController() {
        var vm = this;
    }

})();
(function () {
    'use strict';

    angular
        .module('app.control-panel')
        .controller('ControlPanelListController', ControlPanelListController);

    /** @ngInject */
    function ControlPanelListController($scope, $rootScope, $mdDialog, $timeout, labelsApi, authenticatedUser, tasksApi, fuseGenerator,
                                        ListTasksFilter, $mdMedia, ControlPanelData, MessageDialog, fuseTheming, $window, msUtils,
                                        OrderDialog, TasksStatusHelper, _, moment, ordersApi, $q, ControlPanelFilters, $translate, Account, LocalDateConvert) {

        $scope.isListView = true;
        var showWarningBatchActionTaskCount = 3;
        var vm = this;
        vm.account = Account;
        vm.accountConfiguration = angular.copy(Account.configuration);
        vm.addPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_create');
        vm.editPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_edit');
        vm.hasLabelsPermission = authenticatedUser.hasPermission(vm.account, 'settings-registers_labels_menu');
        vm.filteringIsOn = ControlPanelFilters.isOn;
        vm.clearFilters = ControlPanelFilters.clear;
        vm.labels = [];
        vm.labelsLimit = vm.accountConfiguration.labelsLimit || 30;
        vm.reload = reload;
        vm.palettes = fuseTheming.getRegisteredPalettesLabels();
        vm.rgba = fuseGenerator.rgba;
        vm.loadingList = true;
        vm.newTaskDate = moment().toDate();
        vm.timeFormat = LocalDateConvert.pickFormat('time');
        vm.dateFormat = LocalDateConvert.pickAltFormat('date');
        vm.currentThread = null;
        vm.selectedTaskIds = [];
        $rootScope.selectedTaskIds = [];

        vm.views = {
            classic: 'app/main/control-panel/views/list/views/classic/classic-view.html',
            outlook: 'app/main/control-panel/views/list/views/outlook/outlook-view.html'
        };
        vm.defaultView = 'classic';
        vm.currentView = 'classic';
        vm.pagination = {
            perPageCount: 20,
            currentPage: 1,
            firstPageIndex: 1,
            lastPageIndex: 20
        };

        $scope.$watch(function () {
            return vm.selectedTaskIds;
        }, function (newVal) {
            $rootScope.selectedTaskIds = newVal;
        });

        $scope.$on('control-panel:data-updated', function (event, data) {
            vm.data = data;
            vm.employees = data.employees;
            vm.labels = data.labels;
            vm.selectedDate = data.options.selectedDate;
            loadTasks();
        });

        $scope.$on('control-panel:filter-updated', function () {
            loadTasks();
        });

        //Layout
        $scope.$watch(function () {
            return $mdMedia('xs');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }
            if (current) {
                vm.currentView = 'classic';
            }
        });

        $scope.$watch(function () {
            return $mdMedia('gt-xs');
        }, function (current, old) {
            if (angular.equals(current, old)) {
                return;
            }
            if (current) {
                if (vm.defaultView === 'outlook') {
                    vm.currentView = 'outlook';
                }
            }
        });

        function reload() {
            ControlPanelData.loadData(true);
        }

        //List actions
        vm.archiveSelectedTasks = archiveSelectedTasks;
        vm.showArchiveButton = showArchiveButton;
        vm.unarchiveSelectedTasks = unarchiveSelectedTasks;
        vm.showUnarchiveButton = showUnarchiveButton;
        vm.changeTaskDate = changeTaskDate;
        vm.toggleTaskLabel = toggleTaskLabel;
        vm.setTaskEmployee = setTaskEmployee;
        vm.sendRatingEmail = sendRatingEmail;
        vm.someSelectedTasksWithEmployee = someSelectedTasksWithEmployee;
        vm.allSelectedTasksWithEmployee = allSelectedTasksWithEmployee;
        vm.someSelectedTasksWithLabel = someSelectedTasksWithLabel;
        vm.allSelectedTasksWithLabel = allSelectedTasksWithLabel;
        vm.openMenuWithEditPermission = openMenuWithEditPermission;

        var saveUpdatedLabels = _.debounce(function () {

            if (vm.selectedTaskIds && vm.selectedTaskIds.length > 0) {
                $rootScope.loadingProgress = true;

                var requests = {};
                var index = 0;

                vm.selectedTaskIds.forEach(function (selectedTaskId) {
                    var task = _.find(vm.tasks, function (selectedTask) {
                        return selectedTask.id == selectedTaskId;
                    });
                    var labels = task.order.labels;
                    labels = _.map(labels, function (item){ return { id: item.id }; });
                    requests['setLabels_'+index] = ordersApi.setLabels(task.order.id, labels);
                });

                $q.all(requests).then(function () {
                    ControlPanelData.loadData();
                    MessageDialog.showToast({
                        message: $translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.SUCCESSFULLY_CHANGED")
                    });

                }).finally(function () {
                    $rootScope.loadingProgress = false;
                });
            }

        }, 1500);
        function archiveSelectedTasks() {
          if (!vm.editPermission) {
            return;
          }
          if (vm.selectedTaskIds && vm.selectedTaskIds.length > 0) {

              var archiveTasks = function () {
                  $rootScope.loadingProgress = true;
                  var patch = [];
                  vm.selectedTaskIds.forEach(function (selectedTaskId) {
                      patch.push({
                          id: selectedTaskId,
                          archived: true
                      });
                  });
                  tasksApi.patchTasks(patch).then(function () {

                      ControlPanelData.loadData();

                      MessageDialog.showToast({
                          message: $translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.SUCCESSFULLY_ARCHIVED")
                      });

                  }).finally(function () {
                      $rootScope.loadingProgress = false;
                  });
              };

              if (vm.selectedTaskIds.length > showWarningBatchActionTaskCount) {

                  var confirm = $mdDialog.confirm()
                      .title($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.TITLE", {
                          quantity: vm.selectedTaskIds.length
                      }))
                      .textContent($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.MESSAGE", {
                          quantity: vm.selectedTaskIds.length
                      }))
                      .ok($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.OK"))
                      .cancel($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.CANCEL"));

                  $mdDialog.show(confirm).then(function () {
                      archiveTasks();
                  });

              } else {
                  archiveTasks();
              }


          }
        }
        function unarchiveSelectedTasks() {
          if (!vm.editPermission) {
            return;
          }
          if (vm.selectedTaskIds && vm.selectedTaskIds.length > 0) {

              var unarchiveTasks = function () {
                  $rootScope.loadingProgress = true;
                  var patch = [];
                  vm.selectedTaskIds.forEach(function (selectedTaskId) {
                      patch.push({
                          id: selectedTaskId,
                          archived: false
                      });
                  });

                  tasksApi.patchTasks(patch).then(function () {

                      ControlPanelData.loadData();

                      MessageDialog.showToast({
                          message: $translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.SUCCESSFULLY_UNARCHIVED")
                      });

                  }).finally(function () {
                      $rootScope.loadingProgress = false;
                  });
              };

              if (vm.selectedTaskIds.length > showWarningBatchActionTaskCount) {

                  var confirm = $mdDialog.confirm()
                      .title($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.TITLE", {
                          quantity: vm.selectedTaskIds.length
                      }))
                      .textContent($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.MESSAGE", {
                          quantity: vm.selectedTaskIds.length
                      }))
                      .ok($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.OK"))
                      .cancel($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.CANCEL"));

                  $mdDialog.show(confirm).then(function () {
                      unarchiveTasks();
                  });

              } else {
                  unarchiveTasks();
              }
          }
        }
        function showArchiveButton() {
            return _.any(vm.selectedTaskIds, function (selectedTaskId) {
                var currentTask = _.find(vm.tasks, function (task) {
                    return task.id == selectedTaskId;
                });
                if (currentTask) {
                    return currentTask.archived === false;
                } else {
                    return false;
                }
            });
        }
        function showUnarchiveButton() {
            return _.any(vm.selectedTaskIds, function (selectedTaskId) {
                var currentTask = _.find(vm.tasks, function (task) {
                    return task.id == selectedTaskId;
                });
                if (currentTask) {
                    return currentTask.archived === true;
                } else {
                    return false;
                }
            });
        }
        function sendRatingEmail() {
            if (vm.selectedTaskIds && vm.selectedTaskIds.length > 0) {

                var sendRatingLink = function () {

                    $rootScope.loadingProgress = true;

                    var requests = {};
                    for (var i = 0; i < vm.selectedTaskIds.length; i++) {
                        var selectedTaskId = vm.selectedTaskIds[i];
                        requests[selectedTaskId] = tasksApi.sendRatingLink(selectedTaskId);
                    }

                    $q.all(requests).then(function () {

                        MessageDialog.showToast({
                            hideDelay: 10000,
                            message: $translate.instant("CONTROL_PANEL.VIEWS.LIST.RATING_EMAIL.RATING_LINK")
                        });

                    }).finally(function () {

                        $rootScope.loadingProgress = false;
                    });

                };

                if (vm.selectedTaskIds.length > showWarningBatchActionTaskCount) {

                    var confirm = $mdDialog.confirm()
                        .title($translate.instant("CONTROL_PANEL.VIEWS.LIST.RATING_EMAIL.TITLE", {
                            quantity: vm.selectedTaskIds.length
                        }))
                        .textContent($translate.instant("CONTROL_PANEL.VIEWS.LIST.RATING_EMAIL.MESSAGE", {
                            quantity: vm.selectedTaskIds.length
                        }))
                        .ok($translate.instant("CONTROL_PANEL.VIEWS.LIST.RATING_EMAIL.OK"))
                        .cancel($translate.instant("CONTROL_PANEL.VIEWS.LIST.RATING_EMAIL.CANCEL"));

                    $mdDialog.show(confirm).then(function () {
                        sendRatingLink();
                    });

                } else {
                    sendRatingLink();
                }
            }
        }

        function changeTaskDate() {
          if (!vm.editPermission) {
            MessageDialog.showToast({
              hideDelay: 2000,
              message: $translate.instant('TASKS.DIALOG.ACTIONS.ALERTS.CANT_EDIT')
            });
            return;
          }
          if (vm.selectedTaskIds && vm.selectedTaskIds.length > 0) {

              var allScheduledTasks = true;
              vm.selectedTaskIds.forEach(function (selectedTaskId) {
                  var task = _.find(vm.tasks, function (selectedTask) {
                      return selectedTask.id == selectedTaskId;
                  });
                  if (task.status !== 'scheduled') {
                      allScheduledTasks = false;
                  }
              });

              if (allScheduledTasks === false) {

                  $mdDialog.show(
                      $mdDialog.alert()
                          .parent(angular.element(document.body))
                          .clickOutsideToClose(true)
                          .title($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.CANNOT_MODIFY.TITLE"))
                          .ok($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.CANNOT_MODIFY.OK"))
                          .htmlContent($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.CANNOT_MODIFY.MESSAGE"))
                  );

              } else {

                  var setDateOnTasks = function () {
                      $rootScope.loadingProgress = true;
                      var patch = [];
                      vm.selectedTaskIds.forEach(function (selectedTaskId) {

                          var task = _.find(vm.tasks, function (selectedTask) {
                              return selectedTask.id == selectedTaskId;
                          });

                          patch.push({
                              id: selectedTaskId,
                              scheduling: {
                                  type: task.scheduling.type,
                                  time: task.scheduling.time || null,
                                  date: moment(vm.newTaskDate).format('YYYY-MM-DD')
                              }
                          });
                      });
                      tasksApi.patchTasks(patch).then(function () {

                          ControlPanelData.loadData();

                          MessageDialog.showToast({
                              message: $translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.SUCCESSFULLY_CHANGED")
                          });

                      }).finally(function () {
                          $rootScope.loadingProgress = false;
                      });
                  };

                  if (vm.selectedTaskIds.length > showWarningBatchActionTaskCount) {

                      var confirm = $mdDialog.confirm()
                          .title($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.TITLE", {
                              quantity: vm.selectedTaskIds.length
                          }))
                          .textContent($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.MESSAGE", {
                              quantity: vm.selectedTaskIds.length
                          }))
                          .ok($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.OK"))
                          .cancel($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.CANCEL"));

                      $mdDialog.show(confirm).then(function () {
                          setDateOnTasks();
                      });

                  } else {
                      setDateOnTasks();
                  }

              }
          }
        }
        function toggleTaskLabel(label) {
          if (!vm.editPermission) {
            return;
          }

          if (vm.selectedTaskIds && vm.selectedTaskIds.length > 0) {
                  vm.selectedTaskIds.forEach(function (selectedTaskId) {
                      var task = _.find(vm.tasks, function (selectedTask) {
                          return selectedTask.id == selectedTaskId;
                      });

                      var labels = task.order.labels || [];

                      labels.push(label);
                      labels = _.uniq(labels, function (item) { return item.id; });

                      if (vm.allSelectedTasksWithLabel(label) || someSelectedTasksWithLabel(label)) {
                        labels = _.filter(labels, function (item) { return item.id !== label.id; });
                      }

                      task.order.labels = labels;
                  });

                  saveUpdatedLabels();
          }
        }
        function allSelectedTasksWithEmployee(employee) {
            return _.all(vm.selectedTaskIds, function (selectedTaskId) {
                var currentTask = _.find(vm.currentTasks, function (task) {
                    return task.id == selectedTaskId;
                });
                if (currentTask) {
                    return currentTask.employee && currentTask.employee.id == employee.id;
                }
                else {
                    return false;
                }
            });
        }
        function someSelectedTasksWithEmployee(employee) {
            return _.any(vm.selectedTaskIds, function (selectedTaskId) {
                var currentTask = _.find(vm.currentTasks, function (task) {
                    return task.id == selectedTaskId;
                });
                if (currentTask) {
                    return currentTask.employee.id == employee.id;
                }
                else {
                    return false;
                }
            });
        }
        function allSelectedTasksWithLabel(label) {
            return _.all(vm.selectedTaskIds, function (selectedTaskId) {
                var currentTask = _.find(vm.currentTasks, function (task) {
                    return task.id == selectedTaskId;
                });
                if (currentTask) {
                    if (currentTask.order.labels) {
                        return _.any(currentTask.order.labels, function (orderLabel) {
                           return orderLabel.id == label.id;
                        });
                    }
                    else {
                        return false;
                    }

                }
                else {
                    return false;
                }
            });
        }
        function someSelectedTasksWithLabel(label) {
            return _.some(vm.selectedTaskIds, function (selectedTaskId) {
                var currentTask = _.find(vm.currentTasks, function (task) {
                    return task.id == selectedTaskId;
                });
                if (currentTask) {
                    if (currentTask.order.labels) {
                        return _.any(currentTask.order.labels, function (orderLabel) {
                            return orderLabel.id == label.id;
                        });
                    }
                    else {
                        return false;
                    }

                }
                else {
                    return false;
                }
            });
        }
        function setTaskEmployee(employee) {
          if (!vm.editPermission) {
            return;
          }
          if (vm.selectedTaskIds && vm.selectedTaskIds.length > 0) {

              var setEmployeeOnTasks = function () {
                  $rootScope.loadingProgress = true;
                  var patch = [];
                  vm.selectedTaskIds.forEach(function (selectedTaskId) {

                      var task = _.find(vm.tasks, function (selectedTask) {
                          return selectedTask.id == selectedTaskId;
                      });

                      if (task) {

                          //when updating employee, task should be at the last position
                          var position = task.position;
                          if (task.employee && task.employee.id !== employee.id) {
                              position = 100;
                          }

                          patch.push({
                              id: selectedTaskId,
                              employee: {
                                  id: employee.id
                              },
                              position: position
                          });
                      }
                  });

                  tasksApi.patchTasks(patch).then(function () {

                      ControlPanelData.loadData();

                      MessageDialog.showToast({
                          message: $translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.EMPLOYEE_SELECTED", {
                              name: employee.name
                          })
                      });

                  }).finally(function () {
                      $rootScope.loadingProgress = false;
                  });
              };

              if (vm.selectedTaskIds.length > showWarningBatchActionTaskCount) {

                  var confirm = $mdDialog.confirm()
                      .title($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.TITLE", {
                          quantity: vm.selectedTaskIds.length
                      }))
                      .textContent($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.MESSAGE", {
                          quantity: vm.selectedTaskIds.length
                      }))
                      .ok($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.OK"))
                      .cancel($translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.CHANGE_TASKS.CANCEL"));

                  $mdDialog.show(confirm).then(function () {
                      setEmployeeOnTasks();
                  });

              } else {
                  setEmployeeOnTasks();
              }

          }
        }
        function openMenuWithEditPermission($mdOpenMenu, $event) {
          if (!vm.editPermission) {
            MessageDialog.showToast({
              hideDelay: 2000,
              message: $translate.instant('TASKS.DIALOG.ACTIONS.ALERTS.CANT_EDIT')
            });
            return;
          }

          vm.labelTabIndex = 0;
          $mdOpenMenu($event);
        }

        //List
        vm.openTask = openTask;
        vm.getStatusTask = getStatusTask;
        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectAllTasks = selectAllTasks;
        vm.deselectAllTasks = deselectAllTasks;
        vm.toggleSelectTasks = toggleSelectTasks;
        vm.changeView = changeView;
        vm.loadPaginatedTasks = loadPaginatedTasks;
        vm.currentTasks = [];
        function openTask(task, ev) {

            $timeout(function () {
                OrderDialog.editTask(ev, { id: task.order.id }, function (reload) {
                    if (reload) {
                        ControlPanelData.loadData();
                    }
                });
            }, 200);

        }
        function getStatusTask(task) {
            var statusTask = TasksStatusHelper.getByName(task.status);
            if (task.archived === true) {
                return {
                    color: '#dfdfdf',
                    icon: statusTask.icon
                };
            } else {
                return statusTask;
            }
        }
        function isSelected(task) {
            return _.any(vm.selectedTaskIds, function (selectedTaskId) {
                return selectedTaskId == task.id;
            });
        }
        function toggleSelectThread(task, event) {

            if (event) {
                event.stopPropagation();
            }

            if (isSelected(task)) {
                vm.selectedTaskIds = _.filter(vm.selectedTaskIds, function (selectedTaskId) {
                    return selectedTaskId !== task.id;
                });
            }
            else {
                vm.selectedTaskIds.push(task.id);
            }
        }
        function selectAllTasks() {
            vm.selectedTaskIds = [];
            for (var i = 0; i < vm.currentTasks.length; i++) {
                vm.selectedTaskIds.push(vm.currentTasks[i].id);
            }
        }
        function deselectAllTasks() {
            vm.selectedTaskIds = [];
        }
        function toggleSelectTasks() {
            if (vm.selectedTaskIds.length > 0) {
                vm.deselectAllTasks();
            }
            else {
                vm.selectAllTasks();
            }
        }
        function changeView(view) {
            if (vm.views[view]) {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }
        function loadTasks() {

            vm.loadingList = true;

            var tasks = [];
            if (vm.data && vm.data.tasks) {
                vm.data.tasks.forEach(function (task) {
                    var task = ListTasksFilter.filterTask(task);
                    if (task) {
                        tasks.push(task);
                    }
                });
            }

            vm.tasks = _.sortBy(tasks, function (task) {
                if (task.scheduling.estimation) {
                    var startTask = moment.utc(task.scheduling.estimation.startTask);
                    return startTask.toDate().getTime();
                } else if (task.archived === false) {
                    return Number.MAX_VALUE - 1;
                } else {
                    return Number.MAX_VALUE;
                }
            });

            vm.newTaskDate = ControlPanelData.getDate();

            //Prevent non-filtered tasks to be selected
            if (vm.selectedTaskIds.length > 0) {
                var selectedTaskIds = [];
                vm.tasks.forEach(function (task) {
                    if (isSelected(task)) {
                        selectedTaskIds.push(task.id);
                    }
                });
                vm.selectedTaskIds = selectedTaskIds;
            }
            loadPaginatedTasks(1);
            vm.loadingList = false;
        }

        function paginate(arr, perpage, page) {
            vm.pagination.currentPage = page;
            vm.pagination.firstPageIndex = perpage * (page-1);
            vm.pagination.lastPageIndex = perpage * page;
            var pagedItems = angular.copy(arr).slice(vm.pagination.firstPageIndex, vm.pagination.lastPageIndex);
            var isEmpty = pagedItems.length === 0;
            if (isEmpty) {
                vm.pagination.firstPageIndex = 0;
            } else {
                vm.pagination.firstPageIndex++;
            }
            var isLastPageIndexGreaterThanTotalLength = vm.pagination.lastPageIndex >= vm.tasks.length;
            if (isLastPageIndexGreaterThanTotalLength) {
                vm.pagination.lastPageIndex = vm.tasks.length;
            }
            return pagedItems;
        }

        function loadPaginatedTasks(page) {
            $rootScope.loadingProgress = true;
            $timeout(function (){
                vm.currentTasks = paginate(vm.tasks, vm.pagination.perPageCount, page);
                $rootScope.loadingProgress = false;
            }, 450);
        }

        ///Labels
        vm.editLabel = editLabel;
        vm.archiveLabel = archiveLabel;
        vm.addNewLabel = addNewLabel;
        vm.loadLabels = loadLabels;
        vm.updateLabel = updateLabel;
        vm.labelQuerySearch = labelQuerySearch;
        vm.filterLabel = filterLabel;
        vm.getItemById = msUtils.getItemById;

        //TODO: Should be extract to somewhere else
        function labelQuerySearch(query) {
            return query ? vm.labels.filter(createFilterFor(query)) : [];
        }
        function filterLabel(label) {
            if (!vm.labelSearchText || vm.labelSearchText === '') {
                return true;
            }
            return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
        }
        //TODO: Should be extract to somewhere else
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
            };
        }
        function loadLabels() {
            labelsApi.search({ type: 'orders' }, { limit: 100 }).then(function (result) {
                ControlPanelData.setData('labels', result.items);
            });
        }
        function addNewLabel(newLabel) {
            newLabel.type = 'orders';
            labelsApi.save(newLabel).then(function () {
                vm.newLabelColor = null;
                vm.newLabelName = null;
                vm.labelTabIndex = 0;
                loadLabels();
            });
        }
        function updateLabel(label) {
            label.type = 'orders';
            labelsApi.save(label).then(function (savedLabel) {
                vm.editingLabel = null;
                vm.labelTabIndex = 0;
                loadLabels();

                vm.tasks.forEach(function (task) {
                    if (task.order && task.order.labels) {
                        var currentUpdatedLabel = _.find(task.order.labels, function (orderLabel) {
                            return orderLabel.id == savedLabel.id;
                        });
                        if (currentUpdatedLabel) {
                            currentUpdatedLabel.name = savedLabel.name;
                            currentUpdatedLabel.color = savedLabel.color;
                        }
                    }
                });

            });
        }
        function archiveLabel(label) {
            //request here..
            vm.labelTabIndex = 0;
        }
        function editLabel(label) {
            vm.editingLabel = label;
            vm.labelTabIndex = 2;
        }

        //Employees
        vm.employeeQuerySearch = employeeQuerySearch;
        vm.filterEmployee = filterEmployee;
        vm.getEmployeeAvatarUrl = getEmployeeAvatarUrl;

        function getEmployeeAvatarUrl(employee) {
            if (employee && employee.avatarUrl) {
                return employee.avatarUrl;
            } else {
                return 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg';
            }
        }

        function employeeQuerySearch(query) {
            return query ? vm.employees.filter(createFilterFor(query)) : [];
        }

        function filterEmployee(employee) {
            if (!vm.employeeSearchText || vm.employeeSearchText === '') {
                return true;
            }
            return angular.lowercase(employee.name).indexOf(angular.lowercase(vm.employeeSearchText)) >= 0;
        }

        //Task Item
        vm.printTask = printTask;
        vm.archiveTask = archiveTask;
        vm.unarchiveTask = unarchiveTask;
        function archiveTask(task) {
          if (!vm.editPermission) {
            return;
          }
          $rootScope.loadingProgress = true;
          tasksApi.patchTasks([{id: task.id, archived: true}]).then(function () {
              MessageDialog.showToast({
                  hideDelay: 7000,
                  message: $translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.SUCCESSFULLY_ARCHIVED_UNIQUE", {
                      customer_name: task.order.customer.name,
                      order_identifier: task.order.identifier
                  })
              });
              task.archived = true;
          }).finally(function () {
              $rootScope.loadingProgress = false;
          });
        }
        function unarchiveTask(task) {
          if (!vm.editPermission) {
            return;
          }
          $rootScope.loadingProgress = true;
          tasksApi.patchTasks([{id: task.id, archived: false}]).then(function () {
              MessageDialog.showToast({
                  hideDelay: 7000,
                  message: $translate.instant("CONTROL_PANEL.VIEWS.LIST.TASK.SUCCESSFULLY_UNARCHIVED_UNIQUE", {
                      customer_name: task.order.customer.name,
                      order_identifier: task.order.identifier
                  })
              });
              task.archived = false;
          }).finally(function () {
              $rootScope.loadingProgress = false;
          });
        }
        function printTask(task) {
            $timeout(function () {
                $window.open("https://app.fieldcontrol.com.br/relacionamento-cliente/#/relatorio/" + task.order.id, '_blank');
            }, 1000);
        }

        $scope.$on('tasks:reload', function () {
            vm.reload();
        });

        $rootScope.controlPanel = $rootScope.controlPanel || {};
        $rootScope.controlPanel.activeView = 'list';
    }
})();

(function () {
  'use strict';

  angular
    .module('app.control-panel')
    .controller('ControlPanelGanttController', ControlPanelGanttController);

  /** @ngInject */
  function ControlPanelGanttController(
    GanttTasksStatistics, authenticatedUser, EmployeeDialog, GanttTasksFilter,
    OrderDialog, tasksApi, $rootScope, ganttData, $mdDialog, $scope, $timeout,
    $interval, $translate, ganttConfig, hasher, MessageDialog, moment, employeesApi,
    $mdToast, ControlPanelData, $, _, msUtils, FcModalService, $window, ganttTaskLabelHtml,
    Account, LocalDateConvert
  ) {
      var vm = this;
      vm.forceReload = true;
      vm.stats = null;
      vm.account = Account;
      vm.accountConfiguration = Account.configuration;
      vm.absences = [];
      vm.employees = [];
      vm.ganttData = [];
      vm.activities = [];
      vm.addPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_create');
      vm.editPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_edit');
      vm.dateFormat = LocalDateConvert.pickFormat('date-time');

      vm.ganttApi = null;
      vm.ganttOptions = ganttConfig.getOptions();
      vm.ganttOptions.filterTask = GanttTasksFilter.filterTask;
      vm.ganttOptions.filterRow = GanttTasksFilter.filterRow;
      vm.ganttOptions.hashData = null;
      vm.ganttOptions.canDrag = true;
      vm.ganttOptions.dragAlterTime = localStorage.getItem('FIELD_CONTROL_GANTT_DRAG_ALTER_TIME') === 'true' || false;

      vm.ganttOptions.inAutoload = false;
      var autoLoadInterval = null;
      var poolingTime = 120000;

      window.TheMirrorAnalytics.trackPageView('Page', 'Linha do tempo');

      vm.toggleCanDrag = function () {
        if (!vm.ganttOptions.canDrag) {
          vm.ganttOptions.dragAlterTime = false;
          localStorage.setItem('FIELD_CONTROL_GANTT_DRAG_ALTER_TIME', false);
        }
      };

      vm.toggleAutoload = function () {
        if (vm.ganttOptions.inAutoload) {
          MessageDialog.showToast({
            message: $translate.instant('CONTROL_PANEL.AUTOUPDATE_ENABLE')
          });
          autoLoadInterval = $interval(function () {
            ControlPanelData.loadData();
          }, poolingTime);
        } else {
          $interval.cancel(autoLoadInterval);
          autoLoadInterval = undefined;
          MessageDialog.showToast({
            message:  $translate.instant('CONTROL_PANEL.AUTOUPDATE_DISABLE')
          });
        }
      };

      vm.toggleDragAlterTime = function () {
        localStorage.setItem('FIELD_CONTROL_GANTT_DRAG_ALTER_TIME', vm.ganttOptions.dragAlterTime);
        if (vm.ganttOptions.dragAlterTime) {
          MessageDialog.showToast({
            message: $translate.instant('CONTROL_PANEL.DRAG_ALTER_TIME_ENABLE')
          });
        } else {
          MessageDialog.showToast({
            message:  $translate.instant('CONTROL_PANEL.DRAG_ALTER_TIME_DISABLE')
          });
        }
      };

      $scope.$on("$destroy", function () {
        if (angular.isDefined(autoLoadInterval)) {
          $interval.cancel(autoLoadInterval);
          autoLoadInterval = undefined;
        }
      });

      var onMovedTaskOrRowChanged = _.debounce(function (content) {

          var setTasksOrder = function (tasks) {
              var orderedTasks = _.sortBy(tasks, function (task) {
                  return task.from;
              });
              var order = 1;
              orderedTasks.forEach(function (task) {
                  task.order = order;
                  order++;
              });
          };

          var model = content.model;
          if (model.type !== 'task') {
              vm.forceReload = true;
              ControlPanelData.loadData();
              return;
          }
          $rootScope.loadingProgress = true;

          var getEmployeeTasks = function (id) {
              var row = _.find(content.rowsManager.rows, function (row) {
                  return row.model.employeeId === id;
              });
              if (row) {
                  return _.filter(row.model.tasks, function (task) {
                      return task.type === 'task';
                  });
              } else {
                  return [];
              }
          };

          var taskId = content.model._id;
          var serviceId = content.model.serviceId;
          var employeeFrom = content.model.employeeId;
          var employeeTo = content.row.model.employeeId;

          var task = _.find(vm.data.tasks, function (task) {
            return task.id === taskId;
          });

          var isChangingOnlyTime = function () {
              return (employeeFrom === employeeTo && (task.scheduling.time || vm.ganttOptions.dragAlterTime)) || (!task.scheduling.time && !vm.ganttOptions.dragAlterTime);
          };

          var isChangingEmployee = employeeFrom !== employeeTo;
          var taskAlreadyHaveThisMainEmployee = task && task.employee && task.employee.id === employeeTo;
          var taskAlreadyHaveThisSecondaryEmployee = task && task.secondaryEmployees && task.secondaryEmployees.map(function (employee) {
              return employee.id;
          }).includes(employeeTo);

          if (isChangingEmployee && (taskAlreadyHaveThisMainEmployee || taskAlreadyHaveThisSecondaryEmployee)) {
              vm.forceReload = true;
              ControlPanelData.loadData();
              $mdDialog.show(
                  $mdDialog.alert()
                      .parent(angular.element(document.body))
                      .title($translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.ERROR_ALREADY_ALOCATED.TITLE'))
                      .ok('OK')
                      .htmlContent($translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.ERROR_ALREADY_ALOCATED.MESSAGE'))
                  );
              return;
          }

          var isMovingMainEmployee = task && task.employee && task.employee.id === employeeFrom;

          employeesApi.getSkill(employeeTo, serviceId).then(function () {
              var taskPatchPayload = [];
              if((task.scheduling.time || vm.ganttOptions.dragAlterTime) && isChangingOnlyTime()) {
                if(taskAlreadyHaveThisSecondaryEmployee) {
                  var currentSecondaryEmployees = angular.copy(task.secondaryEmployees || []);

                  tasksApi.linkSecondaryEmployees({
                    taskId: task.id,
                    secondaryEmployeesIds: currentSecondaryEmployees.map(function (employee) {
                      return Number(employee.id);
                    })
                    }).then(function () {
                      var taskPatchPayload = [{
                        id: taskId,
                        scheduling : {
                          type: 'scheduled-date-and-time',
                          time: model.from.format('HH:mm')
                        }
                      }];

                      return tasksApi.patchTasks(taskPatchPayload);
                    }).then(function () {
                      MessageDialog.showToast({
                        hideDelay: 4000,
                        message: $translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.SUCCESS', {
                          name: model.name,
                          identifier: model.identifier
                        })
                      });
                      vm.forceReload = true;
                      ControlPanelData.loadData();
                    });
                  return;
                }

                var taskPatchPayload = [{
                  id: taskId,
                  scheduling: {
                    type: 'scheduled-date-and-time',
                    time: model.from.format('HH:mm')
                  }
                }];

                tasksApi.patchTasks(taskPatchPayload).then(function () {
                  MessageDialog.showToast({
                    hideDelay: 4000,
                    message: $translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.SUCCESS', {
                      name: model.name,
                      identifier: model.identifier
                    })
                  });
                  vm.forceReload = true;
                  ControlPanelData.loadData();
                });
                return;
              }

              if(isChangingEmployee) {
                if (isMovingMainEmployee) {
                  var taskPatchPayload = [];
                  if (task.scheduling.time || vm.ganttOptions.dragAlterTime) {
                    taskPatchPayload.push({
                      id: taskId,
                      scheduling: {
                        type: 'scheduled-date-and-time',
                        time: model.from.format('HH:mm')
                      },
                      employee: {
                        id: employeeTo
                      }
                    });
                  } else {
                    taskPatchPayload.push({
                      id: taskId,
                      employee: {
                        id: employeeTo
                      }
                    });
                  }
                  tasksApi.patchTasks(taskPatchPayload).then(function () {
                    vm.forceReload = true;
                    ControlPanelData.loadData();
                    MessageDialog.showToast({
                      hideDelay: 4000,
                      message: $translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.SUCCESS', {
                        name: model.name,
                        identifier: model.identifier
                      })
                    });
                  });
                }

                if(!isMovingMainEmployee){
                  var taskPatchPayload = [];
                  var currentSecondaryEmployees = angular.copy(task.secondaryEmployees || []);
                  var newSecondaryEmployees = currentSecondaryEmployees.filter(function (employee) {
                    return employee.id != employeeFrom;
                  });

                  if(employeeTo != task.employee.id && !newSecondaryEmployees.some(function (employee) {
                    return employee.id == employeeTo;
                  })) {
                      newSecondaryEmployees.push({
                        id: employeeTo,
                      });
                    }

                  if (task.scheduling.time || vm.ganttOptions.dragAlterTime) {
                    taskPatchPayload.push({
                      id: taskId,
                      scheduling: {
                        type: 'scheduled-date-and-time',
                        time: model.from.format('HH:mm')
                      }
                    });
                    tasksApi.linkSecondaryEmployees({
                      taskId: task.id,
                      secondaryEmployeesIds: newSecondaryEmployees.map(function (employee) {
                        return Number(employee.id);
                      })
                    }).then(function (){
                      tasksApi.patchTasks(taskPatchPayload).then(function () {
                        vm.forceReload = true;
                        ControlPanelData.loadData();
                        MessageDialog.showToast({
                          hideDelay: 4000,
                          message: $translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.SUCCESS', {
                            name: model.name,
                            identifier: model.identifier
                          })
                        });
                      });
                    });
                  } else {
                    tasksApi.linkSecondaryEmployees({
                    taskId: task.id,
                    secondaryEmployeesIds: newSecondaryEmployees.map(function (employee) {
                      return Number(employee.id);
                    })
                    }).then(function (){
                      vm.forceReload = true;
                      ControlPanelData.loadData();

                      MessageDialog.showToast({
                        hideDelay: 4000,
                        message: $translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.SUCCESS', {
                          name: model.name,
                          identifier: model.identifier
                        })
                      });
                    });
                    return;
                  }
                }
                return;
              }

              if (model.timeFixed || vm.ganttOptions.dragAlterTime) {
                var taskPatchPayload = [];

                taskPatchPayload.push({
                  id: taskId,
                  scheduling: {
                    type: 'scheduled-date-and-time',
                    time: model.from.format('HH:mm')
                  },
                  employee: {
                    id: employeeTo
                  }
                });

                tasksApi.patchTasks(taskPatchPayload).then(function () {
                  vm.forceReload = true;
                  ControlPanelData.loadData();

                  MessageDialog.showToast({
                    hideDelay: 4000,
                    message: $translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.SUCCESS', {
                      name: model.name,
                      identifier: model.identifier
                    })
                  });
                });
              }
              else {

                  var tasksPayload = [];
                  if (employeeFrom === employeeTo) {

                      var tasks = getEmployeeTasks(employeeTo);
                      setTasksOrder(tasks);
                      tasks.forEach(function (task) {
                        var isSecondaryEmployee = task.secondaryEmployeesId && task.secondaryEmployeesId.some(function (employeeId) {
                              return employeeId === task.employeeId;
                          });
                          if (!isSecondaryEmployee) {
                              tasksPayload.push({
                                  id: task._id,
                                  position: task.order,
                                  employee: {
                                      id: task.employeeId
                                  }
                              });
                          }
                          });

                  } else {

                      var tasks1 = getEmployeeTasks(employeeTo);
                      setTasksOrder(tasks1);

                      var tasks2 = getEmployeeTasks(employeeFrom);
                      setTasksOrder(tasks2);

                      tasks1.forEach(function (task) {
                          tasksPayload.push({
                              id: task._id,
                              position: task.order,
                              employee: {
                                  id: employeeTo
                              }
                          });
                      });
                      tasks2.forEach(function (task) {
                          tasksPayload.push({
                              id: task._id,
                              position: task.order,
                              employee: {
                                  id: employeeFrom
                              }
                          });
                      });
                    }
                  tasksApi.patchTasks(tasksPayload).then(function () {

                      vm.forceReload = true;
                      ControlPanelData.loadData();

                      $mdToast.show(
                          $mdToast.simple()
                              .textContent($translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASKS_SUCCESS'))
                              .hideDelay(3000)
                      );
                  });
              }

          }).catch(function (err) {
              if (err.status === 404) {
                  vm.forceReload = true;
                  ControlPanelData.loadData();

                  $mdDialog.show(
                      $mdDialog.alert()
                          .parent(angular.element(document.body))
                          .clickOutsideToClose(true)
                          .title($translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.ERROR'))
                          .ok('OK')
                          .textContent($translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.NO_PERMISSION'))
                  );
              }
          });

      }, 400);

      var setLabelsOnTasks = _.debounce(function () {

          if (vm.tasksWithEmployeeNotArchived) {
              ganttTaskLabelHtml.insertLabelsHtmlOnTasks(vm.tasksWithEmployeeNotArchived, $scope);
          }

      }, 500);

      var afterChangedData = _.debounce(function () {

          setLabelsOnTasks();

          if ($rootScope.customData && $rootScope.customData.startTourAfterGanttLoaded === true) {
              delete $rootScope.customData.startTourAfterGanttLoaded;
              FcModalService.open(null, {
                  title: $translate.instant("CORE.WELCOME"),
                  templateUrl: 'app/core/tutorial/fc-tutorial-dialog.html',
                  closeButtonIconPath: 'assets/icons/icon-close.svg',
                  titleIconPath: 'assets/icons/rocket.svg',
                  rightButtonText: $translate.instant("CORE.WELCOME_CLOSE_DIALOG"),
                  handleClose: function () {
                      var element = document.querySelector('.fc-fixed-tooltip--hidden');
                      if (element) {
                        element.classList.remove('fc-fixed-tooltip--hidden');
                      }
                  },
                  large: true
              });
          }

      }, 500);

      var drawEndHandler = _.debounce(function (taskModel) {
        if (taskModel.model.trigger === 'draw') {
          vm.ganttOptions.draw = false;

          if (disableDrawTimeout) {
            $timeout.cancel(disableDrawTimeout);
            disableDrawTimeout = null;
          }

          var employeeId = taskModel.row.model.employeeId;
          var taskDuration = taskModel.model.to.diff(taskModel.model.from, 'minutes');

          var employeeTasks = _.filter(vm.tasksWithEmployeeNotArchived, function (task) {
            return task.employee && task.employee.id == employeeId;
          });

          var scheduledWithDateNTime = _.any(employeeTasks, function (employeeTask) {
            return employeeTask.scheduling.type == 'scheduled-date-and-time';
          });

          var employeeGanttModelTasks = _.filter(taskModel.row.tasks, function (ganttTask) {
            return ganttTask.model.type == 'task';
          });

          var sortedEmployeeTasks = _.sortBy(employeeGanttModelTasks, function (rowTaskModel) {
            return rowTaskModel.model.from;
          });

          var indexOf = _.findIndex(sortedEmployeeTasks, function (rowTaskModel) {
            return rowTaskModel.model.id == taskModel.model.id;
          });

          var taskPosition = (indexOf + 1);
          var position = 0;
          var tasksPayload = [];

          sortedEmployeeTasks.forEach(function (rowTaskModel) {
            position++;

            if (rowTaskModel.model.id !== taskModel.model.id) {
              tasksPayload.push({
                id: rowTaskModel.model.id,
                position: position
              });
            }
          });

          var createTaskScheduling = {
            date: ControlPanelData.getDateAsString(),
            time: (scheduledWithDateNTime || vm.ganttOptions.dragAlterTime) ?
              taskModel.model.from.format('HH:mm') : null,
          };

          if (vm.ganttOptions.dragAlterTime) {
            createTaskScheduling.type = 'scheduled-date-and-time';
          }

          createTask(null, {
            _hooks: {
              onSaved: function () {
                return tasksApi.patchTasks(tasksPayload);
              }
            },
            scheduling: createTaskScheduling,
            employee: {id: employeeId},
            duration: taskDuration,
            position: taskPosition
          }, true);
        }
      }, 500);

      vm.ganttOptions.api = function (api) {
          api.core.on.ready($scope, function () {

              vm.ganttApi = api;

              if (api.tasks.on.rowChange) {
                  api.tasks.on.rowChange($scope, onMovedTaskOrRowChanged);
              }

              if (api.tasks.on.moveEnd) {
                  api.tasks.on.moveEnd($scope, onMovedTaskOrRowChanged);
              }

              if (api.data.on.change) {
                  api.data.on.change($scope, afterChangedData);
              }

              if (api.tasks.on.filter) {
                  api.tasks.on.filter($scope, setLabelsOnTasks);
              }

              if (api.tasks.on.drawEnd) {
                  api.tasks.on.drawEnd($scope, drawEndHandler);
              }

              if (api.tasks.on.add && api.tasks.on.resize && api.tasks.on.resizeBegin && api.tasks.on.resizeEnd) {

                  api.tasks.on.add($scope, function (taskModel) {

                      if (taskModel.model.trigger == 'draw') {
                          drawEndHandlerTimeout = $timeout(function (){
                              drawEndHandler(taskModel);
                          }, 2000);
                      }

                  });

                  api.tasks.on.resize($scope, function (taskModel) {

                      if (taskModel.model.trigger == 'draw') {
                          if (drawEndHandlerTimeout) {
                              $timeout.cancel(drawEndHandlerTimeout);
                              drawEndHandlerTimeout = null;
                          }
                      }
                  });

                  api.tasks.on.resizeEnd($scope, drawEndHandler);
              }

          });
      };

      var drawEndHandlerTimeout = null;
      vm.ganttOptions.canDraw = function (event) {
          var isLeftMouseButton = event.button === 0 || event.button === 1;
          return vm.ganttOptions.draw && isLeftMouseButton;
      };

      vm.ganttOptions.drawTaskFactory = function () {
          return {
              id: msUtils.guidGenerator(),
              trigger: 'draw',
              name: $translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.NEW'),
              description: $translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.NEW'),
              type: 'task',
              classes: [
                  'md-blue-grey-200-bg',
                  'task-hover-increase'
              ]
          };
      };

      $scope.$on('control-panel:data-updated', function (event, data) {
          vm.data = data;

          if (data.options.isPastDate) {
              $('.gantt-current-date-line').hide();
          } else {
              $('.gantt-current-date-line').show();
          }

          _calculateActiveEmployees();
          calculateStatistics();
          reloadGantt();
      });

      function _calculateActiveEmployees() {
          var activeEmployees = _.filter(vm.data.employees, function (employee) {
              return employee.contract.active === true && !employee.inactivatedAt;
          });
          vm.countActiveEmployees = activeEmployees.length;
      }

      $scope.$on('control-panel:filter-updated', function () {
          vm.ganttApi.rows.refresh();
      });

      $scope.$on('update-gantt-header', function () {
        vm.ganttApi.columns.refresh();
        vm.ganttApi.rows.refresh();
      });

      vm.getColumnWidth = getColumnWidth;
      vm.increaseGanttZoom = increaseGanttZoom;
      vm.decreaseGanttZoom = decreaseGanttZoom;
      vm.editTask = editTask;
      vm.editEmployee = editEmployee;
      vm.createTask = createTask;
      vm.createEmployee = createEmployee;
      vm.enableDrawingTasks = enableDrawingTasks;
      var disableDrawTimeout = null;

      function editEmployee(ev, id) {
          if (authenticatedUser.profile.accountId === 84) {
              EmployeeDialog.editEmployee(ev, id, vm.countActiveEmployees, function (reload) {
                  if (reload) {
                      ControlPanelData.loadData();
                  }
              });
          }
      }

      function enableDrawingTasks() {

          vm.reloadGanttCallback = function () {

              vm.ganttOptions.draw = true;
              disableDrawTimeout = $timeout(function () {
                  vm.ganttOptions.draw = false;
              }, 10000);

              MessageDialog.showToast({
                  hideDelay: 5000,
                  message: $translate.instant('CONTROL_PANEL.VIEWS.GANTT.TASK.DRAG_AND_DROP')
              });
          };

          vm.forceReload = true;
          ControlPanelData.loadData();
      }

      function createTask(ev, data, reloadAnyway) {
          OrderDialog.createTask(ev, data, function (reload) {
              if (reload || reloadAnyway) {
                  vm.forceReload = true;
                  ControlPanelData.loadData();
              }
          }, vm.addPermission);
      }

      function increaseGanttZoom() {
          if (vm.ganttOptions.zoom < 20) {
              vm.ganttOptions.zoom = vm.ganttOptions.zoom + 1;
          }
      }

      function decreaseGanttZoom() {
          if (vm.ganttOptions.zoom > 1) {
              vm.ganttOptions.zoom = vm.ganttOptions.zoom - 1;
          }
      }

      function getColumnWidth(zoom) {
          if (zoom < 3) {
              return undefined;
          }

          return 40 * zoom;
      }

      function createEmployee(ev) {
          EmployeeDialog.createEmployee(ev, vm.countActiveEmployees, function (reload) {
              if (reload) {
                  $window.location.reload(true);
              }
          });
      }

      function editTask(ev, id) {
          OrderDialog.editTask(ev, { id: id }, function (reload) {
              if (reload) {
                  ControlPanelData.loadData();
              }
          });
      }

      function calculateStatistics() {
          vm.stats = GanttTasksStatistics.calculateStatistics({
              tasks: vm.data.tasks,
              employees: vm.data.employees
          });
      }

      function reloadGantt() {
          var tasksWithEmployeeNotArchived = _.filter(vm.data.tasks, function (task) {
              return task.employee && !task.archived;
          });
          tasksWithEmployeeNotArchived = _.filter(tasksWithEmployeeNotArchived, function (task) {
              var isTaskToday = task.startedAt && moment(task.startedAt).isSame(ControlPanelData.getDate(), 'day');
              return isTaskToday || !task.startedAt;
          });
          vm.tasksWithEmployeeNotArchived = tasksWithEmployeeNotArchived.map(function (task) {
              var completeDate = task.scheduling.estimation && task.scheduling.estimation.completeTask;
              if (completeDate) {
                  task.scheduling.estimation.completeTask = completeDate;
              }
              return task;
          });

          var rows = ganttData.toRows(vm.tasksWithEmployeeNotArchived,
              vm.data.employees,
              vm.data.locations,
              vm.data.absences,
              vm.data.account,
              ControlPanelData.getDate());

          ganttData.configureDateRanges(rows, vm.ganttOptions, ControlPanelData.getDate());

          var hashData = hasher.sha1({
              e: vm.data.employees,
              l: vm.data.locations,
              a0: vm.data.absences,
              a2: tasksWithEmployeeNotArchived,
              d: ControlPanelData.getDate()
          });

          if (hashData !== vm.ganttOptions.hashData || vm.forceReload == true) {
              vm.ganttOptions.hashData = hashData;
              vm.ganttData = rows;
              vm.forceReload = false;
          }

          if (vm.reloadGanttCallback) {
              vm.reloadGanttCallback();
              vm.reloadGanttCallback = null;
          }

          if (moment().isSame(ControlPanelData.getDate(), 'day')) {
              vm.ganttOptions.currentDateValue = moment().format('YYYY-MM-DD HH:mm');
          }
          else {
              vm.ganttOptions.currentDateValue = null;
          }

          vm.warningEmployee = (vm.data.employees.length <= 0);
          if (vm.warningEmployee) {
              $('#loader-gantt-tasks').remove();
              $('#gantt-tasks').remove();
              $('#zoom-control').remove();

              $timeout(function () {

                  $('#loader-gantt-tasks').remove();
                  $('#gantt-tasks').remove();
                  $('#zoom-control').remove();

              }, 1000);
          }
      }

      $rootScope.controlPanel = $rootScope.controlPanel || {};
      $rootScope.controlPanel.activeView = 'gantt';
  }
})();

(function () {
  'use strict';

  angular.module('app.control-panel').controller('FiltersSidenavController', FiltersSidenavController);

  /** @ngInject */
  function FiltersSidenavController($scope, $rootScope, $timeout, msUtils, accountCache,
    ControlPanelData, moment, ControlPanelFilters, $location,
    activityStatus, _, servicesApi, labelsApi, $translate) {

    accountCache.loadAccount();

    var vm = this;
    vm.employees = [];
    vm.customerLabels = [];
    vm.customerLabelSearchTerm = '';
    vm.employeeStatusEnabled = false;
    vm.activitiesStatus = angular.copy(activityStatus);
    vm.ratings = [
      { stars: 0, name: '' },
        { stars: 1, name: $translate.instant("CONTROL_PANEL.FILTERS.RATING.TERRIBLE") },
        { stars: 2, name: $translate.instant("CONTROL_PANEL.FILTERS.RATING.BAD") },
        { stars: 3, name: $translate.instant("CONTROL_PANEL.FILTERS.RATING.REGULAR") },
        { stars: 4, name: $translate.instant("CONTROL_PANEL.FILTERS.RATING.GOOD") },
        { stars: 5, name: $translate.instant("CONTROL_PANEL.FILTERS.RATING.GREAT") }
    ];

    vm.controlPanelFilters = ControlPanelFilters;
    vm.clearFilters = ControlPanelFilters.clear;
    vm.filteringIsOn = ControlPanelFilters.isOn;
    vm.getEmployeeStatusClass = getEmployeeStatusClass;
    vm.currentUrl = $location.url();

    servicesApi.getAll().then(function (result) {
        var services = _.filter(result.items, function (service) { return !service.archived; });
      vm.servicesFilterList = loadList(services, 'description');
    });

    labelsApi.search({ type: 'orders' }, { limit: 100 }).then(function (result) {
      vm.labels = result.items;
    });

    vm.searchLabels = _.debounce(function () {
        labelsApi.search({ 'name~~*': '*' + vm.customerLabelSearchTerm + '*', type: 'customers' }, { limit: 100 }).then(function (result) {
          var labels = _.filter(result.items, function (label) { return !label.archived; });
          vm.labelsFilterList = loadList(labels, 'name');
        });
    }, 50);

    vm.searchLabels();

    function loadList(list, propertyName, customValue) {
      var items = [];

      if (customValue) {
        items.push(customValue);
      }

      list.forEach(function (item) {
        item.name = item[propertyName];
        items.push(item);
      });

      return items;
    }

    var broadcastFilterUpdated = _.debounce(function () {
      $timeout(function () {
        $rootScope.$broadcast('control-panel:filter-updated');
      }, 50);
    }, 500);

    $scope.$on('control-panel:data-updated', function (event, data) {
      if (data) {
        vm.account = accountCache.getAccount();
        data.employees = _.filter(data.employees, function (employee) {
          return !employee.inactivatedAt;
        });
        vm.employees = sortEmployeesAsConfig(data.employees || []);
        vm.customerLabels = data.labels;
        vm.employeeStatusEnabled = moment().isSame(ControlPanelData.getDate(), 'day');
      }
    });

    $scope.$on('orders-labels:updated', function () {
      labelsApi.search({ type: 'customers' }, { limit: 100 }).then(function (result) {
        vm.customerLabels = result.items;
      });
    });

    vm.exists = msUtils.exists;
    vm.toggleInArray = toggleInArray;
    vm.broadcastFilterUpdated = broadcastFilterUpdated;

    function sortEmployeesAsConfig(employees) {
      if (vm.account) {
        return _.sortBy(employees, function (employee) {
          var employeePosition = _.find(vm.account.configuration.ganttEmployeesPositions, function (configPosition) {
            return configPosition.id == employee.id;
          });
            if (employeePosition) { return employeePosition.position; }
            else { return 99999; }
        });
      } else {
        return employees;
      }
    }

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      broadcastFilterUpdated();
    }

    function getEmployeeStatusClass(employee) {
      if (employee.location) {
        if (employee.isOnline) {
          return 'online';
        } else {
          return 'offline';
        }
      } else {
        return 'none';
      }
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.control-panel')
        .factory('RouteOptimizerDialog', RouteOptimizerDialog);

    /** @ngInject */
    function RouteOptimizerDialog($mdDialog, $rootScope, $document, routerizationApi) {

        return {
            startOptimizer: startOptimizer
        };

        function startOptimizer(ev, employees, callback) {
            $rootScope.loadingProgress = true;

            var locals = {
              Employees: employees,
              RoteirizationUsage: {
                requestCount: 0,
                requestsQuota: 500,
                loadedSuccess: true,
              },
            };

            routerizationApi.getRequestUsage()
              .then(function (response) {
                  locals.RoteirizationUsage.requestsQuota = response.data.requestsQuota;
                  locals.RoteirizationUsage.requestCount = response.data.requestCount;

                  _openRouteOptimizerDialog(ev, locals, callback);
              })
              .catch(function (err) {
                  locals.RoteirizationUsage.loadedSuccess = false;
                  _openRouteOptimizerDialog(ev, locals, callback);
              })
              .finally(function () {
                $rootScope.loadingProgress = false;
              });
        }

        function _openRouteOptimizerDialog(ev, locals, callback) {
            $mdDialog.show({
                controller: 'RouteOptimizerDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/control-panel/dialogs/route-optimizer/route-optimizer-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: locals,
                closeTo: {
                  top: 0,
                  left: window.innerWidth,
                  width: window.innerWidth,
                  height: window.innerHeight / 1.8
                }
            }).then(function (result) {
                if (callback) {
                    callback(result);
                }
            });
        }
    }
})();

(function () {
   'use strict';

   angular
      .module('app.control-panel')
      .controller('RouteOptimizerDialogController', RouteOptimizerDialogController);

   /** @ngInject */
   function RouteOptimizerDialogController($mdDialog, Employees, RoteirizationUsage, TasksStatusHelper, tasksApi, locationsApi, _, $rootScope, $localStorage,
      routerizationApi, accountCache, locals, moment, leafletData, ControlPanelData, $translate, $mdToast, geoCoderReverseApi, geoCoder, $scope, TasksDistribution,
      accountFeatureFlagsApiGraphQL) {

      var vm = this;

      vm.account = accountCache.getAccount();
      vm.isPreventAccount = [44408, 51999].includes(vm.account.id);

      vm.companyAddress = vm.account.address.street + ", " + vm.account.address.number + " - " + vm.account.address.state;
      vm.selectedEmployeeAddress = null;
      vm.selectedDateIsInFuture = false;

      vm.selectedEmployee = null;
      vm.employeeScheduledTasks = [];
      vm.employeeNotScheduledTasks = [];
      vm.employees = Employees;
      vm.employeeLastLocalizationAddress = "";

      vm.requestCount = RoteirizationUsage.requestCount;
      vm.requestsQuota = RoteirizationUsage.requestsQuota;
      vm.roteirizationLoaded = RoteirizationUsage.loadedSuccess;

      vm.considerTraffic = true;

      vm.loadingMap = false;
      vm.showMap = false;
      vm.mapAlreadyBuilded = false;

      vm.map = {};

      vm.currentStep = 1;
      vm.currentStepIndex = 0;

      vm.enableStep2 = false;
      vm.enableStep3 = false;
      vm.finishedOptimization = false;

      vm.optimizatedWaypoints = null;
      vm.totalMilageRoute = 0;

      vm.routerizationApiError = false;
      vm.routerizationApiErrorMessage = "";

      vm.searchCustomEndLocation = searchCustomEndLocation;
      vm.selectedCustomEndLocationChanged = selectedCustomEndLocationChanged;
      vm.selectedFinalDestinationChanged = selectedFinalDestinationChanged;
      vm.openModuleInfoElement = openModuleInfoElement;
      vm.openAdvancedRouteOptimizationHireDialog = openAdvancedRouteOptimizationHireDialog;
      vm.dontShowAgain = dontShowAgain;

      vm.selectedEndLocationText = "";
      vm.customEndLocation = null;
      vm.customEndLocationAddress = null;
      vm.locations = [];

      vm.selectedRouteType = "eco";
      vm.routeTypes = [
        {
          id: "eco",
          name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.BALANCED'),
          description: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.BALANCED_ROUTE_DESCRIPTION')
        },
        {
          id: "fastest",
          name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.FASTEST'),
          description: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.FASTEST_ROUTE_DESCRIPTION')
        },
        {
          id: "shortest",
          name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.SHORTEST'),
          description: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.SHORTEST_ROUTE_DESCRIPTION')
        }
      ];

      vm.selectedTravelMode = "car";
      vm.TravelModes = [
         {id: "car", name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.CAR')},
         {id: "motorcycle", name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.MOTORCYCLE')},
         {id: "truck", name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.TRUCK')},
         {id: "van", name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.VAN')},
         {id: "bicycle", name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.BICYCLE')},
         {id: "pedestrian", name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.PEDESTRIAN')}
      ];

      vm.initialDestinations = [
        {
          id: "company",
          name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.COMPANY'),
          description: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.COMPANY_DESCRIPTION')
        },
        {
          id: "home",
          name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.EMPLOYEE_HOME'),
          description: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.EMPLOYEE_HOME_DESCRIPTION')
        }
      ];

      vm.selectedFinalDestination = "home";
      vm.finalDestinations = [
         {
            id: "company",
            name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.COMPANY'),
            description: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.COMPANY_DESCRIPTION')
         },
         {
            id: "home",
            name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.EMPLOYEE_HOME'),
            description: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.EMPLOYEE_HOME_DESCRIPTION')
         },
         {
            id: "custom",
            name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.CUSTOM_FINAL_DESTINATION'),
            description: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.CUSTOM_FINAL_DESTINATION_DESCRIPTION')
         }
      ];

      vm.daysOfTheWeek = [
        { value: 0, viewText: $translate.instant("CONTROL_PANEL.DIALOGS.ROUTERIZATION.DAYS_OF_THE_WEEK.DAYS.SUNDAY"), checked: false },
        { value: 1, viewText: $translate.instant("CONTROL_PANEL.DIALOGS.ROUTERIZATION.DAYS_OF_THE_WEEK.DAYS.MONDAY"), checked: false },
        { value: 2, viewText: $translate.instant("CONTROL_PANEL.DIALOGS.ROUTERIZATION.DAYS_OF_THE_WEEK.DAYS.TUESDAY"), checked: false },
        { value: 3, viewText: $translate.instant("CONTROL_PANEL.DIALOGS.ROUTERIZATION.DAYS_OF_THE_WEEK.DAYS.WEDNESDAY"), checked: false },
        { value: 4, viewText: $translate.instant("CONTROL_PANEL.DIALOGS.ROUTERIZATION.DAYS_OF_THE_WEEK.DAYS.THURSDAY"), checked: false },
        { value: 5, viewText: $translate.instant("CONTROL_PANEL.DIALOGS.ROUTERIZATION.DAYS_OF_THE_WEEK.DAYS.FRIDAY"), checked: false },
        { value: 6, viewText: $translate.instant("CONTROL_PANEL.DIALOGS.ROUTERIZATION.DAYS_OF_THE_WEEK.DAYS.SATURDAY"), checked: false },
      ];

      vm.today = moment().toDate();
      vm.initialDate = vm.today;
      vm.tasksPerDay = 1;
      vm.selectedWeekDays = [];
      vm.taskGeolocationError = false;
      vm.showInvalidGeolocationModal = showInvalidGeolocationModal;
      vm.invalidGeolocationOrders = [];
      vm.nextStep = nextStep;
      vm.backStep = backStep;
      vm.goToStep = goToStep;
      vm.closeDialog = closeDialog;
      vm.confirmOptimization = confirmOptimization;
      vm.validateTasksPerDay = validateTasksPerDay;
      vm.changeSelectedWeekDays = changeSelectedWeekDays;
      vm.hideRouteOptimizationUpdate = 'true';

      _verifyHideHireUpdateModule();

      function showInvalidGeolocationModal() {
        $mdDialog.show({
           controller: 'ModalInvalidGeoController',
           templateUrl: 'app/main/control-panel/dialogs/route-optimizer/templates/fc-modal-invalid-geo/fc-modal-invalid-geo.html',
           parent: angular.element(document.body),
           clickOutsideToClose: true,
           locals: {
            invalidGeolocationOrders: vm.invalidGeolocationOrders
          }
        });
      };

      function openModuleInfoElement() {
        var event = new CustomEvent('openModuleInfo',  { detail: { type: 'advanced_route_optimization', hired: true } });

        document.dispatchEvent(event);
      }

      function openAdvancedRouteOptimizationHireDialog() {
        window.open('https://app.fieldcontrol.com.br/assinaturas/#/?module=advancedRouteOptimizationModule', '_blank');
      }

      function _verifyHideHireUpdateModule() {

        vm.hideRouteOptimizationUpdate = $localStorage.get("hideRouteOptimizationUpdate") || 'false';
      }

      function dontShowAgain() {
        vm.hideRouteOptimizationUpdate = 'true';
        $localStorage.set("hideRouteOptimizationUpdate", 'true');
      }

      function validateTasksPerDay() {
         var tasksPerDay = parseInt(vm.tasksPerDay || 0);
         var tasksPerDayInput = vm.wizardStep3 && vm.wizardStep3.tasksPerDay;

         if (tasksPerDayInput) {
            var isTaskPerDayValid = tasksPerDay > 0;
            vm.wizardStep3.tasksPerDay.$setValidity('min', isTaskPerDayValid);
         }
      }

      function changeSelectedWeekDays() {
        vm.selectedWeekDays = TasksDistribution.filterSelectedWeekDays(vm.daysOfTheWeek);
      }

      function confirmOptimization() {
         removeSecondaryEmployeesFromTasks();

         var taskPatchPayload = [];
         vm.optimizatedWaypoints.forEach(function (optimizatedTask) {
            taskPatchPayload.push(optimizatedTask);
         });

         var index = 0;
         vm.employeeNotScheduledTasks.forEach(function (notScheduledTask) {
            taskPatchPayload.push({
               id: notScheduledTask.id,
               position: --index
            });
         });

         var controlPanelPayload = { taskPatchPayload: taskPatchPayload };
         if (vm.isPreventAccount) {
            var initialDate = new Date(vm.initialDate).toISOString();
            controlPanelPayload.initialDate = initialDate;
            controlPanelPayload.selectedWeekDays = vm.selectedWeekDays;
            controlPanelPayload.tasksPerDay = vm.tasksPerDay;
         }

         document.dispatchEvent(new CustomEvent('closeRouterOptimizer', { detail: { reload: true } }));

         $mdDialog.hide(controlPanelPayload);
      }

      function removeSecondaryEmployeesFromTasks() {
         var tasksWithSecondaryEmployees = vm.employeeScheduledTasks.filter(function (task) {
            return task.secondaryEmployees && task.secondaryEmployees.length > 0;
         });

         tasksWithSecondaryEmployees.forEach(function (task) {
            tasksApi.updateTask({
               id: task.id,
               secondaryEmployeeIds: []
            });
         });
      }

      function goToStep(step, stepAction) {
         if (vm.currentStep != step && canGoToStep(step)) {
            initStep(step, stepAction);
         }
      }

      function initStep(step, stepAction) {
         if (step === 2) {
            vm.enableStep2 = true;
            vm.enableStep3 = false;
            vm.finishedOptimization = false;
            vm.routerizationApiError = false;

            var selectedDate = moment(ControlPanelData.getDate()).format('YYYY-MM-DD');
            var todayDate = moment().format('YYYY-MM-DD');
            vm.selectedDateIsInFuture = selectedDate > todayDate ? true : false;

            if (stepAction === "nextStep") {
               manageEmployeeLastLocalization();

               var scheduledDate = moment(ControlPanelData.getDate()).format('YYYY-MM-DD');

               var addressFieldsChecking = ['street', 'number', 'state'];
               if (!!vm.selectedEmployee.address && addressFieldsChecking.some(function (e) { return !!vm.selectedEmployee.address[e]; })) {
                  vm.selectedEmployeeAddress = vm.selectedEmployee.address.street + (vm.selectedEmployee.address.number ? ", " + vm.selectedEmployee.address.number : '') + " - " + vm.selectedEmployee.address.state;
               }

               tasksApi.search({
                  where: {
                     scheduledDateGte: scheduledDate,
                     scheduledDateLte: scheduledDate,
                     employeeIds: [vm.selectedEmployee.id],
                     archived: false
                  },
                  take: 100
               }).then(function (tasks) {
                  var hasInvalidTasks = false;
                  tasks.items.forEach(function (task) {
                  var isTaskValid = task.coords && (task.coords.latitude !== 0 && task.coords.latitude !== null && task.coords.longitude !== 0 && task.coords.longitude !== null);
                  if (!isTaskValid) {
                     vm.taskGeolocationError = true;
                     hasInvalidTasks = true;
                     vm.invalidGeolocationOrders.push(task.order.identifier);
                  }
                  if (task.status === 'scheduled') {
                     vm.employeeScheduledTasks.push(task);
                  } else {
                     vm.employeeNotScheduledTasks.push(task);
                  }
                  });
                  if (hasInvalidTasks) {
                  vm.showInvalidGeolocationModal();
                  }
               });
            }
         } else if (step === 3) {
            var hasSecondaryEmployees = checkForSecondaryEmployees();
            console.log("🚀 ~ initStep ~ hasSecondaryEmployees:", hasSecondaryEmployees);

            if (hasSecondaryEmployees) {
               handleSecondaryEmployeesAlert();
            } else {
               continueToStep3();
            }
         } else { // step 1
            vm.enableStep2 = false;
            vm.enableStep3 = false;
            vm.finishedOptimization = false;
            vm.routerizationApiError = false;
         }

         vm.currentStep = step;
         vm.currentStepIndex = step - 1;
      }

      function checkForSecondaryEmployees() {
         return vm.employeeScheduledTasks.some(function (task) {
            return task.secondaryEmployees && task.secondaryEmployees.length > 0;
         });
      }

      function handleSecondaryEmployeesAlert() {
         var event = new CustomEvent('openRouterOptimizerAlert');

         var handleAlertClosed = function (e) {
            document.removeEventListener('routerOptimizerAlertClosed', handleAlertClosed);

            if (e.detail.role === 'success') {
               continueToStep3();
               vm.currentStep = 3;
               vm.currentStepIndex = 2;
            }
         };

         document.addEventListener('routerOptimizerAlertClosed', handleAlertClosed);
         document.dispatchEvent(event);
      }

      function continueToStep3() {
         vm.enableStep2 = true;
         vm.enableStep3 = true;
         vm.finishedOptimization = false;
         vm.loadingMap = true;
         vm.routerizationApiError = false;
         getStartLocation().then(function (startLocation) {
            var endLocation = getEndLocation();
            var waypoints = getWaypoints();
            var options = getOptions();

            routerizationApi.getRouteOptimization(startLocation, endLocation, waypoints, options).then(
               function (response) {
                  var hasResponseDataRoutes = response && response.data && response.data.routes && response.data.routes.length;
                  var firstRoute = hasResponseDataRoutes && response.data.routes[0];
                  if (firstRoute && firstRoute.summary && firstRoute.legs) {
                     vm.optimizatedWaypoints = response.data.optimizedWaypoints;
                     vm.totalMilageRoute = _convertMetersToKm(response.data.routes[0].summary.lengthInMeters);
                     var points = legsToPoints(response.data.routes[0].legs);
                     buildMap();
                     renderMapRoute(points);
                     renderMapMarkers(startLocation, endLocation);
                     centralizeMap(points);
                  }
                  updateRoterizationUsage();
               },
               function (error) {
                  vm.routerizationApiError = true;
                  if (error.status === 500) {
                  vm.routerizationApiErrorMessage = $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.SERVER_ERROR');
                  } else if (error.data.message === 'Request failed with status code 400') {
                  vm.routerizationApiErrorMessage = $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.NO_POSSIBLE_ROUTE_FOUND');
                  } else if (error.data.code === "feature-not-enabled") {
                  vm.routerizationApiErrorMessage = $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.USER_NOT_AUTHORIZED');
                  } else if (error.data.code === "payment-required") {
                  vm.routerizationApiErrorMessage = $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.MAXIMUM_LIMIT');
                  } else {
                  vm.routerizationApiErrorMessage = $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.UNKNOWN_SERVER_ERROR');
                  }
                  updateRoterizationUsage();
               }
            );
         }, function (error) {
            $mdToast.show(
               $mdToast.simple()
                     .textContent(error.message)
                     .hideDelay(3000)
            );
            goToStep(2);
         });
      }

      function buildMap() {
         vm.loadingMap = false;
         vm.showMap = true;

         if(!vm.mapAlreadyBuilded) {
            vm.mapAlreadyBuilded = true;
            vm.map = {
               controls: {
                  fullscreen: { position: 'topleft' }
               },
               decorations: {
                  markers: {
                      coordinates: [],
                      patterns: [
                          { offset: 25, repeat: 50, symbol: L.Symbol.arrowHead({pixelSize: 15, pathOptions: {fillOpacity: 1, weight: 0, color: '#0e9ce4'}})}
                      ]
                  }
              },
               markers: {},
               layers: {
                  baselayers: {
                     mapbox_standard: {
                        name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.LAYERS.DEFAULT'),
                        url: 'https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                        type: 'xyz',
                        layerOptions: { 'showOnSelector': true }
                     },
                     mapbox_satellite: {
                        name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.LAYERS.SATELLITE'),
                        url: 'https://mt0.google.com/vt/lyrs=y&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                        type: 'xyz',
                        layerOptions: { 'showOnSelector': true }
                     },
                     mapbox_roadmap: {
                        name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.LAYERS.ROADS'),
                        url: 'https://mt0.google.com/vt/lyrs=h&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                        type: 'xyz',
                        layerOptions: { 'showOnSelector': true }
                     },
                     mapbox_terrain: {
                        name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.LAYERS.GROUND'),
                        url: 'https://mt0.google.com/vt/lyrs=p&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                        type: 'xyz',
                        layerOptions: { 'showOnSelector': true }
                     }
                  }
               }
            };
         }
      }

      function legsToPoints(legs) {
         var points = [];

         legs.forEach(function (leg) {
            leg.points.forEach(function (point) {
               points.push({
                  latitude: parseFloat(point.latitude),
                  longitude: parseFloat(point.longitude)
               });
            });
         });

         return points;
      }

      function renderMapRoute(points) {
         var path = {
             weight: 3,
             color: '#039BE5',
             latlngs: [],
             latLongDecorations: []
         };

         var latLong = [];
         points.forEach(function (point) {
            path.latlngs.push({
               lat: point.latitude,
               lng: point.longitude,
               draggable: false
            });
            path.latLongDecorations.push([point.latitude, point.longitude]);
            latLong.push([point.latitude, point.longitude]);
         });

         vm.map.paths = {};
         vm.map.paths.pathByGantt = path;

         vm.map.decorations.markers.coordinates = [];
         vm.map.decorations.markers.coordinates.push(path.latLongDecorations);

         vm.finishedOptimization = true;
      }

      function renderMapMarkers(startLocation, endLocation) {
         vm.map.markers = {};
         renderStartLocationMarker(startLocation);
         renderWaypointsMarker();
         renderNotScheduledTasksMarker();
         renderEndLocationMarker(endLocation);
      }

      function renderNotScheduledTasksMarker() {
         var i = 99999999;
         var decorations = [];

         vm.employeeNotScheduledTasks.forEach(function (task) { i++;

            var markerColor = "#aaaaaa";
            if(task.status === "done") { markerColor = "#4B9A50"; }
            else if(task.status === "in-progress") { markerColor = "#FAB042"; }
            else if(task.status === "reported") { markerColor = "#D74145"; }
            else if(task.status === "canceled") { markerColor = "#B35AC3"; }

            decorations.push([task.latitude, task.longitude]);
            var taskMarker = {
               lat: task.coords.latitude,
               lng: task.coords.longitude,
               icon: {
                  type: 'div',
                  html: '<div><i style="color:'+markerColor+';" class="icon icon-city s38"></i></div>',
                  iconAnchor:   [16, 16], // point of the icon which will correspond to marker's location
                  className: "none" // to now show empty white square in the icon
               },
               draggable: false,
               message: getTaskMarkerHtmlMessage(task)
            };
            vm.map.markers[i] = taskMarker;
         });
      }

      function renderStartLocationMarker(startLocation) {
         var employeePin = '../assets/images/null-avatar.jpg';

         if (vm.selectedEmployee.avatarUrl) {
            employeePin = vm.selectedEmployee.avatarUrl;
         }

         var startLocationMarker = {
            lat: startLocation.latitude,
            lng: startLocation.longitude,
            icon: {
                type: 'div',
                html: '<div style="height: 20px">' +
                  '    <img src="' + employeePin + '" class="marker-border-radius employee-marker" width="40" height="40">' +
                  '</div>',
                iconAnchor:   [16, 16],
                className: "none" // to now show empty white square in the icon
            },
            focus: true,
            draggable: false
        };
        vm.map.markers[0] = startLocationMarker;
      }

      function renderEndLocationMarker(endLocation) {
         var endLocationMarker = {
            lat: endLocation.latitude,
            lng: endLocation.longitude,
            icon: {
                type: 'div',
                html: vm.selectedFinalDestination !== 'custom' ? '<div class="endlocation-marker"></div>' : '<div><i style="color:#2957C3;" class="icon icon-flag s38"></i></div>',
                iconAnchor:   [16, 16],
                className: "none" // to now show empty white square in the icon
            },
            draggable: false
        };

        var endLocationPosition = Object.keys(vm.map.markers).length;
        vm.map.markers[endLocationPosition] = endLocationMarker;
      }

      function renderWaypointsMarker() {
         var i = 0;
         var decorations = [];
         var ordenedEmployeeScheduledTasks = [];

         for (var y = 0; y < vm.optimizatedWaypoints.length; y++) {
            for (var z = 0; z < vm.employeeScheduledTasks.length; z++) {
               if (vm.optimizatedWaypoints[y].id === vm.employeeScheduledTasks[z].id) {
                  ordenedEmployeeScheduledTasks[y] = vm.employeeScheduledTasks[z];
               }
            }
         }

         ordenedEmployeeScheduledTasks.forEach(function (task) { i++;

            decorations.push([task.coords.latitude, task.coords.longitude]);
            var taskMarker = {
               lat: task.coords.latitude,
               lng: task.coords.longitude,
               icon: {
                  type: 'div',
                  html: '<div><i style="color:#2957C3;" class="icon icon-city s38"><span class="indice">'+i+'</span></i></div>',
                  iconAnchor:   [16, 16], // point of the icon which will correspond to marker's location
                  className: "none" // to now show empty white square in the icon
               },
               draggable: false,
               message: getTaskMarkerHtmlMessage(task)
            };
            vm.map.markers[i] = taskMarker;
         });
      }

      function getTaskMarkerHtmlMessage(task) {
         var html = '<div class="leafvar-popup-content ng-scope" style="width: 210px;">';

         if(task.order.customer.name) {
            html += '<span><b>' + task.order.customer.name + '</b></span><br>';
         }

         html += '<div style="margin-top: 5px;">';

         if(task.order.service.description) {
            html += '<i class="icon icon-tag s15"></i>';
            html += $translate.instant("CONTROL_PANEL.DIALOGS.ROUTERIZATION.TASK_MARKER.OS_TYPE") + ': <span><b>'+task.order.service.description+'</b></span><br>';
         }

         if(task.status) {
            var status = TasksStatusHelper.getByName(task.status);
            html += '<i class="icon-traffic-light s15 icon"></i>';
            html += $translate.instant("CONTROL_PANEL.DIALOGS.ROUTERIZATION.TASK_MARKER.SITUATION") + ': <span style="color: '+status.color+'"><b>'+status.description+'</b></span><br>';
         }

         if(task.coords) {
            html += '<i class="icon-map-marker s15 icon"></i>';
            html += $translate.instant("CONTROL_PANEL.DIALOGS.ROUTERIZATION.TASK_MARKER.LATITUDE_LONGITUDE") + ': (<b>'+task.coords.latitude+','+task.coords.longitude+'</b>)';
         }

         html += '</div>';
         html += "</div>";

         return html;
      }

      function centralizeMap(points) {
         var boundsItems = [];

         points.forEach(function (point) {
            boundsItems.push([point.latitude, point.longitude]);
         });

         leafletData.getMap('routerOptizerMap').then(function (map) {
            var bounds = L.latLngBounds(boundsItems);
            map.fitBounds(bounds);
         });
      }

      function manageEmployeeLastLocalization() {
         vm.selectedInitialDestination = "company";

         vm.initialDestinations = vm.initialDestinations.filter(function (destination) {
            return destination.id !== "last_localization";
         });

         locationsApi.getLastedLocations().then(function (locations) {
            if(locations) {
               var lastLocalization = _.filter(locations, function (location) {
                  return location.employeeId === vm.selectedEmployee.id;
               });
               if(lastLocalization[0] && !vm.selectedDateIsInFuture) {

                  geoCoderReverseApi.search({
                     latitude: lastLocalization[0].latitude,
                     longitude: lastLocalization[0].longitude
                  }).then(function (response){
                     if(response.results.length) {
                        vm.employeeLastLocalizationAddress = response.results[0].formatted_address;
                     }
                  });

                  vm.initialDestinations.unshift({
                     id: "last_localization",
                     name: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.LAST_LOCALIZATION'),
                     description: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.LAST_LOCALIZATION_DESCRIPTION')
}
                  );
                  vm.selectedInitialDestination = "last_localization";
               }
            }
         });
      }

      function getStartLocation() {
         if (vm.selectedInitialDestination === "company") {
            return new Promise(function (resolve, reject) {
               resolve({
                  latitude: vm.account.address.coords.latitude,
                  longitude: vm.account.address.coords.longitude
               });
            });
         } else if (vm.selectedInitialDestination === "home") {
            return new Promise(function (resolve, reject) {
               resolve({
                  latitude: vm.selectedEmployee.address.coords.latitude,
                  longitude: vm.selectedEmployee.address.coords.longitude
               });
            });
         } else if (vm.selectedInitialDestination === "last_localization") {
            return locationsApi.getLastedLocations().then(function (locations) {
               if (locations) {
                  var lastLocalization = locations.filter(function (location) {
                     return location.employeeId === vm.selectedEmployee.id;
                  });
                  if (lastLocalization[0]) {
                     return {
                        latitude: parseFloat(lastLocalization[0].latitude),
                        longitude: parseFloat(lastLocalization[0].longitude)
                     };
                  }
               } return new Promise(function (resolve, reject) { reject({message: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.EMPLOYEE_LAST_LOCALIZATION_NOT_FOUND')}); });
            });
         } else {
            return new Promise(function (resolve, reject) { reject({message: $translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.INVALID_INITIAL_DESTINATION')}); });
         }
      }

      function getEndLocation() {
         var endLocations = {
            company: {
               latitude: vm.account.address.coords.latitude,
               longitude: vm.account.address.coords.longitude
            },
            home: {
               latitude: vm.selectedEmployee.address.coords.latitude,
               longitude: vm.selectedEmployee.address.coords.longitude
            },
            custom: {
               latitude: vm.customEndLocation ? vm.customEndLocation.lat : null,
               longitude: vm.customEndLocation ? vm.customEndLocation.lng : null
            }
         };

         if (endLocations[vm.selectedFinalDestination]) {
            return endLocations[vm.selectedFinalDestination];
         }

         $mdToast.show(
            $mdToast.simple()
               .textContent($translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.INVALID_END_LOCATION'))
               .hideDelay(3000)
         );
      }

      function getWaypoints() {
         var waypoints = [];

         vm.employeeScheduledTasks.forEach(function (task) {
            waypoints.push({
               id: task.id,
               latitude: task.coords.latitude,
               longitude: task.coords.longitude
            });
         });

         return waypoints.length ? waypoints : "";
      }

      function getOptions() {
         return {
            considerTraffic: vm.considerTraffic,
            routeType: vm.selectedRouteType,
            travelMode: vm.selectedTravelMode,
            departAt: moment().add(10, 'minutes').format()
         };
      }

      function searchCustomEndLocation() {
         vm.locations = [];
         if (vm.selectedEndLocationText !== '') {
            geoCoder.getByAddressString(vm.selectedEndLocationText).then(function (results) {
               var address = results[0].city ? results[0] : results[1];
               if (address) {
                  vm.locations.push(address);
               }
            });
          }
      }

      function selectedCustomEndLocationChanged() {
         vm.locations = [];
         if (vm.selectedFinalDestination === 'custom') {
            if (vm.customEndLocation) {
               vm.customEndLocationAddress = vm.customEndLocation.formattedAddress;
               return;
            }
         }

         vm.customEndLocation = null;
      }

      function selectedFinalDestinationChanged() {
         vm.locations = [];
         vm.customEndLocation = null;
         vm.customEndLocationAddress = null;
      }

      function canGoToStep(step) {
         if (step === 1) {
            return true;
         } else if (step === 2 && vm.selectedEmployee) {
            return true;
         } else if (step === 3 && vm.selectedRouteType && vm.selectedTravelMode && vm.selectedFinalDestination) {
            return true;
         } else {
            return false;
         }
      }

      function nextStep() {
         goToStep(vm.currentStep + 1, 'nextStep');
      }

      function backStep() {
         goToStep(vm.currentStep - 1, 'backStep');
      }

      function closeDialog() {
         $mdDialog.hide();
      }

      function updateRoterizationUsage() {
        routerizationApi.getRequestUsage()
          .then(function (response) {
            vm.requestsQuota = response.data.requestsQuota;
            vm.requestCount = response.data.requestCount;
          });
      }

      function _convertMetersToKm(meters) {
         if (meters) {
            var kilometers = meters / 1000;
            return kilometers.toLocaleString(undefined, {
               maximumFractionDigits: 3
             });
         }
      }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.calendar', ['ui.calendar'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.calendar', {
      url: '/calendario-de-atividades',
      views: {
        'content@app': {
          templateUrl: 'app/main/calendar/calendar.html',
          controller: 'CalendarController as vm'
        }
      },
      data: { titleTranslateKey: 'CALENDAR.PAGE_TITLE' },
      bodyClass: 'calendar',
      resolve: {
        Account: function (accountsApi) {
          return accountsApi.get();
        },
        FeatureFlags: function (accountFeatureFlagsApiGraphQL) {
          return accountFeatureFlagsApiGraphQL.accountFeatureFlags();
        }
      }
    });

    $translatePartialLoaderProvider.addPart('app/main/calendar');
  }
})();

(function () {
  'use strict';

  angular
    .module('app.calendar')
    .controller('CalendarFiltersSidenavController', CalendarFiltersSidenavController);

  /** @ngInject */
  function CalendarFiltersSidenavController(
    $rootScope, servicesApi, employeesApi, labelsApi, TasksStatusHelper, _, CalendarTasksFilter, msUtils
  ) {
    var vm = this;
    vm.calendarTasksFilter = CalendarTasksFilter;
    vm.clearFilters = CalendarTasksFilter.clear;
    vm.filteringIsOn = CalendarTasksFilter.isOn;
    vm.exists = msUtils.exists;

    vm.employees = [];

    servicesApi.getAll().then(function (result) {
      var services = _.filter(result.items, function (service) { return !service.archived; });
      vm.servicesFilterList = loadList(services, 'description');
    });

    employeesApi.getAll().then(function (result) {
      var activeEmployees = _.filter(result.items, function (employee) { return employee.contract.active && !employee.inactivatedAt; });
      var sortedEmployees = _.sortBy(activeEmployees, 'name');
      vm.employees = sortedEmployees;
    });

    labelsApi.search({ type:'orders' }, { limit: 100 }).then(function (result) {
      vm.labels = result.items;
    });

    vm.exists = msUtils.exists;
    vm.toggleInArray = toggleInArray;
    var activitiesStatusResult = TasksStatusHelper.getAll();
    vm.activitiesStatus = _.filter(activitiesStatusResult, function (item) { return item.name !== 'pending';});

    vm.broadcastFilterUpdated = _.debounce(broadcastFilterUpdated, 1000);

    function broadcastFilterUpdated() {
      $rootScope.$broadcast('calendar-tasks:filter-updated');
    }

    function loadList(list, propertyName, customValue) {
      var items = [];

      if (customValue) {
        items.push(customValue);
      }

      list.forEach(function (item) {
        item.name = item[propertyName];
        items.push(item);
      });

      return items;
    }

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.bootstrap', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider
            .state('app.bootstrap', {
                url: '/configuracoes-iniciais',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.bootstrap': {
                        templateUrl: 'app/main/bootstrap/bootstrap.html',
                        controller: 'BootstrapController as vm'
                    }
                },
                data: { titleTranslateKey: 'BOOTSTRAP.PAGE_TITLE' },
                resolve: {
                    services: function (servicesApi) {
                        return servicesApi.getAll();
                    },
                    employees: function (employeesApi) {
                        return employeesApi.getAll();
                    },
                    account: function (accountsApi) {
                        return accountsApi.get();
                    },
                    customers: function (customersApi) {
                        return customersApi.search({ take: 1 });
                    }
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/bootstrap');
    }
})();

(function () {
    'use strict';

    angular.module('app.bootstrap')
        .factory('HowRegisterEmployeeDialog', HowRegisterEmployeeDialog);

    /** @ngInject */
    function HowRegisterEmployeeDialog($mdDialog, $document) {

        return {
            open: open
        };

        function open(ev, callback) {

            $mdDialog.show({
                controller: 'HowRegisterEmployeeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/bootstrap/dialogs/how-to-register-employee/how-register-employee-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {}
            }).then(function (reload) {
                if (callback) {
                    callback(reload);
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('app.bootstrap')
        .controller('HowRegisterEmployeeDialogController', HowRegisterEmployeeDialogController);

    /** @ngInject */
    function HowRegisterEmployeeDialogController($mdDialog) {

        var vm = this;

        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.audit-logs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.audit-logs', {
            url    : '/logs-de-auditoria',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/audit-logs/audit-logs.html',
                    controller : 'AuditLogsController as vm'
                }
            },
            data: {titleTranslateKey: 'AUDIT_LOGS.PAGE_TITLE'}
        });

        $translatePartialLoaderProvider.addPart('app/main/audit-logs');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.audit-logs')
        .factory('AuditLogsFilters', AuditLogsFilters);

    /** @ngInject */
    function AuditLogsFilters($rootScope, $timeout) {

        var filters = {
            action: [],
            targetResource: null,
            userName: null,
            userIp: null,
            createdAt: [],

            clear: clear,
            isOn: isOn,
            isOff: isOff
        };

        function clear() {
            filters.action = [];
            filters.targetResource = null;
            filters.userName = null;
            filters.userIp = null;
            filters.createdAt = [];

            $timeout(function () { $rootScope.$broadcast('audit-logs:reload'); }, 200);
        }

        function isOn() {
            var noActionFiltered = filters.action.length === 0;
            var noTargetResourceFiltered = filters.targetResource === null;
            var noUserNameFiltered = filters.userName === null;
            var noUserIpFiltered = filters.userIp === null;
            var noCreatedAtFiltered = filters.createdAt.length === 0;

            return !(noActionFiltered && noTargetResourceFiltered && noUserNameFiltered && noUserIpFiltered && noCreatedAtFiltered);
        }

        function isOff() {
            return !isOn();
        }

        return filters;
    }
})();

(function () {
    'use strict';

    angular
      .module('app.audit-logs')
      .controller('AuditLogsFiltersSideNavController', AuditLogsFiltersSideNavController);

    /** @ngInject */
    function AuditLogsFiltersSideNavController(AuditLogsFilters, _, msUtils, $rootScope, $timeout) {

      var vm = this;
      vm.auditLogsFilters = AuditLogsFilters;
      vm.clearFilters = AuditLogsFilters.clear;
      vm.filteringIsOn = AuditLogsFilters.isOn;
      vm.exists = msUtils.exists;
      vm.toggleInArray = toggleInArray;

      function toggleInArray(value, array) {
        msUtils.toggleInArray(value, array);
        vm.broadcastFilterUpdated();
      }

      vm.broadcastFilterUpdated = _.debounce(function () {
        if (vm.auditLogsFilters.status === 'null') {
          vm.auditLogsFilters.status = null;
        }
        $timeout(function () { $rootScope.$broadcast('audit-logs:reload'); }, 50);
      }, 500);

    }
  })();

(function () {
    'use strict';

    angular.module('app.audit-logs')
    .factory('AuditLogDialogs', AuditLogDialogs);

    /** @ngInject */
    function AuditLogDialogs(auditLogsApi, $mdDialog, $rootScope, $document, _) {

        return {
            showEventDetails: showEventDetails
        };

        function showEventDetails(event, id, callback) {
            $rootScope.loadingProgress = true;

            auditLogsApi.get(id).then(function (result) {
                _openDialog(event, {
                    DialogData: {
                        log: result.data.event
                    }
                }, callback);
                $rootScope.loadingProgress = false;
            });
        }

        function _openDialog(event, locals, callback) {
            $mdDialog.show({
                controller: 'AuditLogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/audit-logs/dialogs/event-details/event-details-dialog.html',
                parent: angular.element($document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                locals: locals,
                closeTo: {
                  top: 0,
                  left: window.innerWidth,
                  width: window.innerWidth,
                  height: window.innerHeight / 1.8
                }
            }).then(function (reload) {
                if (callback) {
                    callback(reload);
                }
            });
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.audit-logs')
    .controller('AuditLogDialogController', AuditLogDialogController);

  /** @ngInject */
  function AuditLogDialogController(DialogData, $timeout, $rootScope, $mdDialog, $translate) {

    var vm = this;

    function _initialize() {
      vm.event = DialogData.log;
      vm.event.data = JSON.stringify(vm.event.data, null, 2);

      vm.closeDialog = closeDialog;
      vm.humanizeEvent = humanizeEvent;

      vm.broadcastFilterUpdated = _.debounce(function () {
        $timeout(function () { $rootScope.$broadcast('audit-logs:reload'); }, 50);
      }, 500);
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }

    function humanizeEvent() {
      var event = vm.event;
      var operation = $translate.instant('AUDIT_LOGS.DIALOGS.EVENT_DETAILS.HUMANIZE.ACTION.' + event.action.toUpperCase());
      var entity = $translate.instant('AUDIT_LOGS.DIALOGS.EVENT_DETAILS.HUMANIZE.RESOURCE_NAME.' + event.targetResource.toUpperCase());

      var theUser = $translate.instant('AUDIT_LOGS.DIALOGS.EVENT_DETAILS.HUMANIZE.THE_USER');
      var theEntity = $translate.instant('AUDIT_LOGS.DIALOGS.EVENT_DETAILS.HUMANIZE.THE_ENTITY');
      var whoseId = $translate.instant('AUDIT_LOGS.DIALOGS.EVENT_DETAILS.HUMANIZE.WHOSE_ID');
      var at = $translate.instant('AUDIT_LOGS.DIALOGS.EVENT_DETAILS.HUMANIZE.AT');
      var atTime = $translate.instant('AUDIT_LOGS.DIALOGS.EVENT_DETAILS.HUMANIZE.AT_TIME');

      return  theUser + '<b>' + event.userName + '</b>' + ' ' + '<u>' + operation + '</u>' +
        (event.action === 'AUTHENTICATED' ? '' : theEntity +
        '<b>' + entity + '</b>' + whoseId + '<u>' + event.targetResourceId + '</u>') +
        at + '<b>' + moment(event.createdAt).format('DD/MM/YYYY') + '</b>' + atTime +
        '<b>' + moment(event.createdAt).format('HH:mm') + '</b>.';
    }

    _initialize();
  }
})();

(function () {
    'use strict';

    angular
        .module('app.absences', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.absences', {
            url: '/ausencias',
            views: {
                'content@app': {
                    templateUrl: 'app/main/absences/absences.html',
                    controller: 'AbsencesController as vm'
                }
            },
            data: {titleTranslateKey: 'ABSENCES.PAGE_TITLE'},
            resolve: {
                absences: function (absencesApi) {
                    return absencesApi.search({
                        take: 1000,
                        orderBy: 'id_desc'
                    });
                }
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/absences');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.absences')
        .factory('AbsencesFilters', AbsencesFilters);

    /** @ngInject */
    function AbsencesFilters($rootScope, $timeout) {

        var filters = {
            reason: null,
            employees: [],
            startDateFrom: null,
            startDateTo: null,
            endDateFrom: null,
            endDateTo: null,

            clear: clear,
            isOn: isOn,
            isOff: isOff
        };

        function clear() {

            filters.reason = null;
            filters.employees = [];
            filters.startDateFrom = null;
            filters.startDateTo = null;
            filters.endDateFrom = null;
            filters.endDateTo = null;

            $timeout(function () { $rootScope.$broadcast('absences:filter-updated'); }, 200);
        }

        function isOn() {
            var noReasonFiltered = filters.reason === null;
            var noEmployeesFiltered = filters.employees.length === 0;
            var noStartDateFromFiltered = filters.startDateFrom === null;
            var noStartDateToFiltered = filters.startDateTo === null;
            var noEndDateFromFiltered = filters.endDateFrom === null;
            var noEndDateToFiltered = filters.endDateTo === null;

            return !(noReasonFiltered && noEmployeesFiltered  && noStartDateFromFiltered &&
                    noStartDateToFiltered && noEndDateFromFiltered && noEndDateToFiltered);
        }

        function isOff() {
            return !isOn();
        }

        return filters;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.absences')
        .controller('AbsencesFiltersSideNavController', AbsencesFiltersSideNavController);

    /** @ngInject */
    function AbsencesFiltersSideNavController(_, $rootScope, $timeout, msUtils,
        AbsencesFilters, employeesApi) {

        var vm = this;
        vm.employees = [];
        vm.absencesFilters = AbsencesFilters;
        vm.clearFilters = AbsencesFilters.clear;
        vm.filteringIsOn = AbsencesFilters.isOn;
        vm.exists = msUtils.exists;
        vm.toggleInArray = toggleInArray;

        function toggleInArray(value, array) {
            msUtils.toggleInArray(value, array);
            vm.broadcastFilterUpdated();
        }

        employeesApi.getAll().then(function (result) {
            var activeEmployees = _.filter(result.items, function (employee) { return employee.contract.active && !employee.inactivatedAt; });
            vm.employees = _.sortBy(activeEmployees, function (employee) { return employee.name; });
        });

        vm.broadcastFilterUpdated = _.debounce(function () {
            $timeout(function () { $rootScope.$broadcast('absences:filter-updated'); }, 50);
        }, 500);
    }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('UtilityFunctions', UtilityFunctions);

  /** @ngInject */
  function UtilityFunctions() {
    return {
      unionBy: unionBy,
      parseValueToPrice: parseValueToPrice,
      mergeLinkedWithAll: mergeLinkedWithAll,
      splitItemsByQuantity: splitItemsByQuantity
    };

    function mergeLinkedWithAll(allItems, linkedItems) {
      allItems.forEach(function (item) {
        linkedItems.forEach(function (linkedItem) {
          if (item.id === linkedItem.id) {
            item.linked = true;
          };
        });
      });

      return allItems;
    }

    function unionBy(items, priorityItems, property) {
      var allItems = _.cloneDeep(items);
      priorityItems.forEach(function (priorityItem) {
        items.forEach(function (item, itemIndex) {
          if (priorityItem[property] === item[property]) {
            allItems[itemIndex] = priorityItem;
          }
        });
      });
      return allItems;
    }

    function parseValueToPrice(value) {
      if (!value || value === '') { return '0,00'; }

      return parseFloat(value).toFixed(2).replace('.', ',');
    }

    function splitItemsByQuantity(items, quantity) {
      if (!(items && items.length) || !quantity) { return []; }
      var splittedItems = [];
      for (var index = 0; index < items.length; index += quantity) {
        var chunk = items.slice(index, index + quantity);
        splittedItems.push(chunk);
      }
      return splittedItems;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieApiErrorHandler', omieApiErrorHandler);

  function omieApiErrorHandler($http) {
    return {
      responseForResourceNotFound: responseForResourceNotFound
    };

    function responseForResourceNotFound(api, payload, response) {
      return new Promise(function (resolve, reject) {
        return $http.post(api, payload)
          .then(function (response) {
            var resultResource = response.data.resultResource;

            if(response.data && resultResource && isJSON(resultResource)){
              response.data.resultResource = JSON.parse(resultResource);
            };

            resolve(response);
          })
          .catch(function (error) {
            if (_isResourceNotFoundError(error)) {
              return resolve(response);
            }
            reject(error);
          });
      });
    }

    function _isResourceNotFoundError(error) {
      var isInternalServerError = error.status && error.status === 500;
      var faultCode = error.data && error.data.faultcode;
      var validFaultCodes = [
        'SOAP-ENV:Client-5113',  // Entidade não cadastrado na Omie
        'SOAP-ENV:Client-103'    // Serviço não está cadastrado na Omie
      ];

      var isResourceNotFoundError = faultCode && validFaultCodes.includes(faultCode);

      return isInternalServerError && isResourceNotFoundError;
    };

    function isJSON(str) {
      try {
          JSON.parse(str);
      } catch (e) {
          return false;
      }
      return true;
    };
  }
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('OmieConfigurationDialog', OmieConfigurationDialog);

	/** @ngInject */
	function OmieConfigurationDialog($mdDialog, $document) {

		return {
			openOmieConfigurationDialog: openOmieConfigurationDialog,
		};

		function openOmieConfigurationDialog(event) {
			$mdDialog.show({
				controller: 'OmieConfigurationDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/core/integrations/omie/configuration/omie-configuration-dialog.html',
				parent: angular.element($document.body),
				targetEvent: event,
				clickOutsideToClose: false,
			});
		}
	}

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('OmieConfigurationDialogController', OmieConfigurationDialogController);

  /** @ngInject */
  function OmieConfigurationDialogController($mdDialog, $mdToast, $timeout, $window, $rootScope, $translate, IntegrationsService) {
    var vm = this;
    vm.appKey = '';
    vm.appSecret = '';
    vm.hasValidAppKeys = false;

    vm.closeDialog = closeDialog;
    vm.enableIntegration = enableIntegration;
    vm.changedAppKey = changedAppKey;

    function changedAppKey() {
      validatedAppKeys();
    }

    function validatedAppKeys() {
      if (vm.appKey.length >= 10 && vm.appSecret.length >= 32) {
        vm.hasValidAppKeys = true;
      } else {
        vm.hasValidAppKeys = false;
      }
    }

    function enableIntegration(appKey, appSecret) {
      closeDialog();
      $rootScope.loadingProgress = true;

      var data = {
        appKey: appKey,
        appSecret: appSecret,
        appId: appKey
      };

      IntegrationsService.activate('omie', data).then(function () {
        $mdToast.show(
          $mdToast.simple().textContent(
            $translate.instant('CUSTOMERS.INTEGRATIONS.SUCCESS_WHEN_ACTIVATING',
              { app: 'Omie' })
          ).hideDelay(2000)
        );
        $timeout(function () {
            $window.location.reload(true);
        }, 1500);
      }).catch(function () {
        $mdToast.show(
          $mdToast.simple().textContent(
            $translate.instant('CUSTOMERS.INTEGRATIONS.ERROR_WHEN_ACTIVATING',
              { app: 'Omie' })
          ).hideDelay(2000)
        );
      });
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('omieApi', omieApi);

  function omieApi(
    omieCustomerApi,
    omieOsApi,
    omieBankAccountCachedApi,
    omieCityApi,
    omieCategoryCachedApi,
    omieServiceApi,
    omieProductApi,
    omieLc116Api,
    omiePaymentCachedApi,
    omieServicoMunicipioApi,
    omieAccountApi,
    omieSellerApi,
    omieSalesOrderApi
  ) {
    return {
      customers: omieCustomerApi,
      os: omieOsApi,
      bankAccounts: omieBankAccountCachedApi,
      cities: omieCityApi,
      categories: omieCategoryCachedApi,
      services: omieServiceApi,
      products: omieProductApi,
      lc116: omieLc116Api,
      payments: omiePaymentCachedApi,
      servicoMunicipios: omieServicoMunicipioApi,
      accounts: omieAccountApi,
      sellers: omieSellerApi,
      salesOrders: omieSalesOrderApi
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('contaAzulCustomerMapper', contaAzulCustomerMapper);

  /** @ngInject */
  function contaAzulCustomerMapper($filter, _) {

    return {
      toFieldControl: toFieldControl,
      toContaAzul: toContaAzul,
      toFieldControlContacts: toFieldControlContacts,
      getContaAzulPhone: getContaAzulPhone,
      getContaAzulEmail: getContaAzulEmail,
      getStateName: getStateName,
      getStateUF: getStateUF,
      getContaAzulPersonType: getContaAzulPersonType
    };

    function toFieldControl(contaAzulCustomer, contaAzulCustomerContacts) {
      var fieldControlCustomer = {
        name: contaAzulCustomer.name,
        notes: contaAzulCustomer.notes,
        documentNumber: contaAzulCustomer.document,
        contact: {
          email: getContaAzulEmail(contaAzulCustomer, contaAzulCustomerContacts),
          phone: getContaAzulPhone(contaAzulCustomer, contaAzulCustomerContacts)
        },
        contacts: toFieldControlContacts(contaAzulCustomer, contaAzulCustomerContacts),
        address: toFieldControlAddress(contaAzulCustomer.address)
      };
      return fieldControlCustomer;
    }

    function toContaAzul(fieldControlCustomer, fieldControlLocation) {
      var toContaAzulName = fieldControlCustomer.name + ' ' + fieldControlLocation.name;

      if(fieldControlCustomer.name === fieldControlLocation.name) { toContaAzulName = fieldControlCustomer.name; }

      var documentNumber = fieldControlCustomer.documentNumber || fieldControlLocation.documentNumber;

      var isCnpj = documentNumber && documentNumber.replace(/\D/g, '').length === 14;
      var isCpf = documentNumber && documentNumber.replace(/\D/g, '').length === 11;

      var customerCode = randomCodeID();

      return {
        nome: toContaAzulName,
        cnpj: isCnpj ? documentNumber : null,
        cpf: isCpf ? documentNumber : null,
        email: getFieldControlEmail(fieldControlCustomer, fieldControlLocation),
        telefone_comercial: getFieldControlPhone(fieldControlCustomer, fieldControlLocation),
        tipo_pessoa: getContaAzulPersonType(fieldControlCustomer.documentNumber),
        observacao: fieldControlLocation.notes || fieldControlCustomer.notes,
        enderecos: toContaAzulAddress(fieldControlLocation.address),
        codigo: customerCode,
        perfis: [
          {
            id: fieldControlCustomer.id,
            tipo_perfil: "Cliente"
          }
        ],
      };
    }

    function getContaAzulPersonType(document) {
      if (document && document.length > 4) {
        document = document.replace(/\D/g, '');
        return document.length <= 11 ? "Física" : "Jurídica";
      }
      return "Física";
    }

    function toFieldControlContacts(contaAzulCustomer, contaAzulCustomerContacts) {
      var contacts = {
        emails: [],
        phones: []
      };

      var mainEmail = getContaAzulEmail(contaAzulCustomer, contaAzulCustomerContacts);
      var mainPhone = getContaAzulPhone(contaAzulCustomer, contaAzulCustomerContacts);

      if(mainEmail && mainEmail !== null) {
        contacts.emails.push({
          address: mainEmail,
          type: "personal",
          primary: false
        });
      }

      if(mainPhone && mainPhone !== null) {
        contacts.phones.push({
          countryCode: "55",
          number: mainPhone,
          type: "home",
          primary: false
        });
      }

      if(contaAzulCustomerContacts && contaAzulCustomerContacts.length > 0) {
        contaAzulCustomerContacts.forEach(function (contact) {
          if(contact.email && contact.email.length > 2 && contact.email !== mainEmail) {
            contacts.emails.push({
              address: contact.email,
              type: "personal",
              primary: false,
              name: contact.name
            });
          }
          if(contact.business_phone && contact.business_phone.length > 2 && contact.business_phone !== mainPhone) {
            contacts.phones.push({
              countryCode: "55",
              number: contact.business_phone,
              type: "home",
              primary: false,
              name: contact.name
            });
          }
        });
      }

      if(contacts.emails && contacts.emails.length > 0) {
        contacts.emails[0].primary = true;
      }
      if(contacts.phones && contacts.phones.length > 0) {
        contacts.phones[0].primary = true;
      }
      return contacts;
    }

    function toFieldControlAddress(contaAzulAddress) {
      if(!contaAzulAddress) {
        return {};
      }

      var fieldControlAddress = {
        zipCode: (contaAzulAddress.zip_code || contaAzulAddress.zipCode || '').replace(/\D/g, ''),
        street: contaAzulAddress.street,
        number: contaAzulAddress.number,
        complement: contaAzulAddress.complement,
        neighborhood: contaAzulAddress.neighborhood,
        city: (contaAzulAddress.city && contaAzulAddress.city.name) ? contaAzulAddress.city.name : (contaAzulAddress.city || ''),
        state: (contaAzulAddress.state) ? getStateName(contaAzulAddress.state.name || contaAzulAddress.state) : '',
        coords: {
          latitude: null,
          longitude: null
        },
        formattedAddress: $filter('contaAzulAddress')(contaAzulAddress)
      };

      return fieldControlAddress;
    }

    function toContaAzulAddress(fieldControlAddress) {
      var zipCode = fieldControlAddress.postalCode || fieldControlAddress.zipCode;

      var contaAzulAddress = [{
        logradouro: fieldControlAddress.street,
        numero: fieldControlAddress.number,
        complemento: fieldControlAddress.complement,
        cep: zipCode ? $filter('brCep')(zipCode.replace(/\D/g, '')) : '',
        bairro: fieldControlAddress.neighborhood,
        cidade: fieldControlAddress.city,
        estado: getStateUF(fieldControlAddress.state),
        pais: "Brasil"
      }];

      return contaAzulAddress;
    }

    function getContaAzulEmail(contaAzulCustomer, contaAzulCustomerContacts) {
      var email = null;
      if(contaAzulCustomer.email && contaAzulCustomer.email.length > 2) {
        email = contaAzulCustomer.email;
      } else if(contaAzulCustomerContacts && contaAzulCustomerContacts.length > 0) {
        contaAzulCustomerContacts.forEach(function (contact) {
          if(contact.email && contact.email.length > 2) {
            email = contact.email;
          }
        });
      }
      return email;
    }

    function getContaAzulPhone(contaAzulCustomer, contaAzulCustomerContacts) {
      var phone = null;
      if (contaAzulCustomer.business_phone && contaAzulCustomer.business_phone.length > 4) {
        phone = contaAzulCustomer.business_phone.replace(/\D/g, '');
      } else if (contaAzulCustomer.mobile_phone && contaAzulCustomer.mobile_phone.length > 4) {
        phone = contaAzulCustomer.mobile_phone.replace(/\D/g, '');
      } else if (contaAzulCustomerContacts && contaAzulCustomerContacts.length > 0) {
        contaAzulCustomerContacts.forEach(function (contact) {
          if(contact.business_phone && contact.business_phone.length > 4) {
            phone = contact.business_phone.replace(/\D/g, '');
          }
        });
      }
      return phone;
    }

    function getStateUF(stateName) {
      var states = [];
      states['Acre'] = 'AC';
      states['Alagoas'] = 'AL';
      states['Amapá'] = 'AP';
      states['Amazonas'] = 'AM';
      states['Bahia'] = 'BA';
      states['Ceará'] = 'CE';
      states['Distrito Federal'] = 'DF';
      states['Espírito Santo'] = 'ES';
      states['Goiás'] = 'GO';
      states['Maranhão'] = 'MA';
      states['Mato Grosso'] = 'MT';
      states['Mato Grosso do Sul'] = 'MS';
      states['Minas Gerais'] = 'MG';
      states['Pará'] = 'PA';
      states['Paraíba'] = 'PB';
      states['Paraná'] = 'PR';
      states['Pernambuco'] = 'PE';
      states['Piauí'] = 'PI';
      states['Rio de Janeiro'] = 'RJ';
      states['Rio Grande do Norte'] = 'RN';
      states['Rio Grande do Sul'] = 'RS';
      states['Rondônia'] = 'RO';
      states['Roraima'] = 'RR';
      states['Santa Catarina'] = 'SC';
      states['São Paulo'] = 'SP';
      states['Sergipe'] = 'SE';
      states['Tocantins'] = 'TO';
      return states[stateName];
    }

    function getStateName(UF) {
      var states = [];
      states['AC'] = 'Acre';
      states['AL'] = 'Alagoas';
      states['AP'] = 'Amapá';
      states['AM'] = 'Amazonas';
      states['BA'] = 'Bahia';
      states['CE'] = 'Ceará';
      states['DF'] = 'Distrito Federal';
      states['ES'] = 'Espírito Santo';
      states['GO'] = 'Goiás';
      states['MA'] = 'Maranhão';
      states['MT'] = 'Mato Grosso';
      states['MS'] = 'Mato Grosso do Sul';
      states['MG'] = 'Minas Gerais';
      states['PA'] = 'Pará';
      states['PB'] = 'Paraíba';
      states['PR'] = 'Paraná';
      states['PE'] = 'Pernambuco';
      states['PI'] = 'Piauí';
      states['RJ'] = 'Rio de Janeiro';
      states['RN'] = 'Rio Grande do Norte';
      states['RS'] = 'Rio Grande do Sul';
      states['RO'] = 'Rondônia';
      states['RR'] = 'Roraima';
      states['SC'] = 'Santa Catarina';
      states['SP'] = 'São Paulo';
      states['SE'] = 'Sergipe';
      states['TO'] = 'Tocantins';
      return states[UF];
    }

    function getFieldControlPhone(fieldCustomer, fieldLocation) {
      var hasPhones = fieldLocation.contacts && fieldLocation.contacts.phones && fieldLocation.contacts.phones.length;
      if (!hasPhones) { return fieldCustomer.contact.phone; }

      var primaryPhoneIndex = _.findIndex(fieldLocation.contacts.phones, function (phone) { return phone.primary; });
      if (primaryPhoneIndex !== -1) {
        return fieldLocation.contacts.phones[primaryPhoneIndex].number;
      }

      return fieldLocation.contacts.phones[0].number;
    }

    function getFieldControlEmail(fieldCustomer, fieldLocation) {
      var hasEmails = fieldLocation.contacts && fieldLocation.contacts.emails && fieldLocation.contacts.emails.length;
      if (!hasEmails) { return fieldCustomer.contact.email; }

      var primaryEmailIndex = _.findIndex(fieldLocation.contacts.emails, function (phone) { return phone.primary; });
      if (primaryEmailIndex !== -1) {
        return fieldLocation.contacts.emails[primaryEmailIndex].address;
      }

      return fieldLocation.contacts.emails[0].address;
    }

    function randomCodeID() {
      return Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('contaAzulApi', contaAzulApi);

  function contaAzulApi(contaAzulCustomerApi, contaAzulSaleApi, contaAzulProductApi, contaAzulServiceApi) {
    return {
      customers: contaAzulCustomerApi,
      sales: contaAzulSaleApi,
      products: contaAzulProductApi,
      services: contaAzulServiceApi
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('warg2UsersApi', warg2UsersApi);

  function warg2UsersApi($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.warg2BaseUrl;

    return {
      getUsers: getUsers,
      getUser: getUser,
      updateUser: updateUser,
      sendUserInvitation: sendUserInvitation
    };

    function getUsers(where, take, skip) {
      var query = '\
      query UsersQuery ( \
        $where: UserWhereInput \
        $take: Int \
        $skip: Int \
      ) { \
        users ( \
          where: $where \
          take: $take \
          skip: $skip \
        ) { \
          items { \
            id \
            name \
            email \
            avatarUrl \
            organizations { \
              id \
              organization_id \
              user_id \
              role  \
              created_at \
              updated_at  \
              active \
              archived \
            } \
          } \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          where: where,
          take: take,
          skip: skip
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['users']['items'];
      });
    }

    function getUser(email) {
      var query = '\
      query UserQuery ( \
        $email: String! \
      ) { \
        user ( \
          email: $email \
        ) { \
          id \
          name \
          email \
          invites { \
            id \
            activatedAt \
            companyId \
            organizationId \
            userId \
            createdAt \
            expiredAt \
          } \
          organizations { \
            id \
            organization_id \
            user_id \
            role  \
            created_at \
            updated_at  \
            active \
            archived \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          email: email
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['user'];
      });
    }

    function updateUser(user, organizationId ,active) {
      var query = '\
      mutation UpdateUserMutation ($input: UpdateUserInput!) { \
        updateUser(input: $input) { \
          id \
        } \
      }';

      var input = {
        id: user.id,
        name: user.name,
        avatarUrl: user.avatarUrl,
        organizationId: organizationId
      };

      if (active !== undefined) {
        input.active = active;
      }

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['updateUser'];
      });
    }

    function sendUserInvitation(name, email, organizationId) {
      var query = '\
      mutation SendUserInvitationMutation ($input: SendUserInvitationInput!) { \
        sendUserInvitation(input: $input) { \
          id \
        } \
      }';

      var input = {
        email: email,
        organizationId: organizationId
      };

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        if (!response.data['data']) {
          return {
            error: true,
            message: response.data['errors'][0].message
          };
        }

        return response.data['data']['sendUserInvitation'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('warg2ServicesApi', warg2ServicesApi);

  function warg2ServicesApi($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.warg2BaseUrl;

    return {
      syncServices: syncServices,
    };

    function syncServices(servicesToActivate, customerId) {
      var query = '\
      mutation SyncServicesMutation ( \
        $input: SyncServicesInput! \
      ) { \
        syncServices ( \
          input: $input \
        ) { \
          companyId \
          organizationId \
          services { \
            id \
            name \
            active \
          }  \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: {
            servicesToActivate: servicesToActivate,
            organizationId: customerId
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['syncServices'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('warg2OrganizationsApi', warg2OrganizationsApi);

  function warg2OrganizationsApi($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.warg2BaseUrl;

    return {
      getOrganization: getOrganization,
      getOrganizations: getOrganizations,
      createOrganization: createOrganization,
      updateOrganization: updateOrganization,
      syncOrganizationAttachment: syncOrganizationAttachment,
      unsyncOrganizationAttachment: unsyncOrganizationAttachment
    };

    function getOrganization(id) {
      var query = '\
      query OrganizationQuery ( \
        $id: String! \
      ) { \
        organization ( \
          id: $id \
        ) { \
          id \
          name \
          description \
          logoUrl \
          services { \
            id \
            name \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          id: id
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['organization'];
      });
    }

    function getOrganizations(where, take, skip) {
      var query = '\
      query OrganizationsQuery ( \
        $where: OrganizationWhereInput \
        $take: Int \
        $skip: Int \
      ) { \
        organizations ( \
          where: $where \
          take: $take \
          skip: $skip \
        ) { \
          items { \
            id \
            name \
            description \
            logoUrl \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          where: where,
          take: take,
          skip: skip
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['organizations']['items'];
      });
    }

    function createOrganization(customer) {
      var query = '\
      mutation CreateOrganizationMutation ($input: CreateOrganizationInput!) { \
        createOrganization(input: $input) { \
          id \
        } \
      }';

      var input = {
        id: customer._id,
        name: customer.name,
        description: customer.notes,
        logoUrl: customer.avatarUrl
      };

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['createOrganization'];
      });
    }

    function updateOrganization(customer, active) {
      var query = '\
      mutation UpdateOrganizationMutation ($input: UpdateOrganizationInput!) { \
        updateOrganization(input: $input) { \
          id \
        } \
      }';

      var input = { id: customer._id || customer.id };

      if (active !== undefined) {
        input.active = active;
      }

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data'] ? response.data['data']['updateOrganization'] : response.data['data'];
      });
    }

    function syncOrganizationAttachment(attachmentId, customerId) {
      var query = '\
      mutation SyncOrganizationAttachmentMutation ($input: SyncOrganizationAttachmentInput!) { \
        syncOrganizationAttachment(input: $input) { \
          id \
        } \
      }';

      var input = {
        organizationId: customerId,
        attachmentId: attachmentId
      };

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['syncOrganizationAttachment'];
      });
    }

    function unsyncOrganizationAttachment(attachmentId, customerId) {
      var query = '\
      mutation UnSyncOrganizationAttachmentMutation ($input: UnsyncOrganizationAttachmentInput!) { \
        unsyncOrganizationAttachment(input: $input) { \
          id \
        } \
      }';

      var input = {
        organizationId: customerId,
        attachmentId: attachmentId
      };

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['unsyncOrganizationAttachment'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('warg2CompaniesApi', warg2CompaniesApi);

  function warg2CompaniesApi($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.warg2BaseUrl;

    return {
      createCompany: createCompany,
      updateCompany: updateCompany,
      getCompany: getCompany,
      companySlugExists: companySlugExists,
    };

    function createCompany(company) {
      var query = '\
      mutation CreateCompanyMutation ($input: CreateCompanyInput!) { \
        createCompany(input: $input) { \
          id \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: company
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['createCompany'];
      });
    }

    function updateCompany(id, company) {
      var query = '\
      mutation UpdateCompanyMutation ($id: ID!, $input: UpdateCompanyInput!) { \
        updateCompany(id: $id, input: $input) { \
          id \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          id: id,
          input: company
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['updateCompany'];
      });
    }

    function getCompany() {
      var query = '\
      query CompanyQuery { \
        company { \
          id \
          name \
          logoUrl \
          slug \
          active \
        } \
      }';

      return $http.post(baseUrl, {
        query: query
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['company'];
      });
    }

    function companySlugExists(slug) {
      if (!slug) {
        return true;
      }

      var query = '\
      query companySlugExistsQuery($slug: String!) { \
        companySlugExists( \
          slug: $slug \
        ) { \
          exists \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          slug: slug
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['companySlugExists']['exists'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('ticketsConfigurationsWargApi', ticketsConfigurationsWargApi);

  function ticketsConfigurationsWargApi(wargApi) {
    return {
      createTicketConfiguration: createTicketConfiguration,
      getTicketConfiguration: getTicketConfiguration
    };

    function createTicketConfiguration(account) {
      return wargApi.updateAccount(account.id).then(function (response) {
        return response.data['account'];
      });
    }

    function getTicketConfiguration(account) {
      return wargApi.getAccount(account.id).then(function (response) {
        return response.data['account'];
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('wargApi', wargApi);

    function wargApi($http, EnvironmentConfig, Api, querify, msUtils) {
        return {
            getAccount: getAccount,
            getBySlug: getBySlug,
            saveAccount: saveAccount,
            updateAccount: updateAccount,
            removeAccount: removeAccount
        };

        function getAccount(id) {
            var requestUrl = EnvironmentConfig.wargBaseUrl + '/accounts/' + id;
            return $http.get(requestUrl);
        }

        function getBySlug(slug) {
            var requestUrl = EnvironmentConfig.wargBaseUrl + '/accounts/slug/' + slug;
            return $http.get(requestUrl);
        }

        function saveAccount(payload) {
            var requestUrl = EnvironmentConfig.wargBaseUrl + '/accounts';
            return $http.post(requestUrl, payload);
        }

        function updateAccount(payload) {
            var requestUrl = EnvironmentConfig.wargBaseUrl + '/accounts';
            return $http.put(requestUrl, payload);
        }

        function removeAccount(id) {
            var requestUrl = EnvironmentConfig.wargBaseUrl + '/accounts/' + id;
            return $http.delete(requestUrl);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('auditLogsApi', auditLogsApi);

    function auditLogsApi($http, EnvironmentConfig, Api) {
        var api = new Api($http, EnvironmentConfig.thuringwethilUrl);

        return {
            get: get,
            search: search
        };

        function get(id) {
            var requestUrl = api.getUrl();
            var body = {
                query: 'query($id: ID!) { \
                    event(id: $id) { \
                        id \
                        targetResource \
                        targetResourceId \
                        action \
                        userId \
                        userName \
                        userIp \
                        data \
                        createdAt \
                    } \
                }',
                variables: { id: id }
            };
            return $http.post(requestUrl, body).then(api.whenCompleted);
        }

        function search(variables) {
            var requestUrl = api.getUrl();
            var body = {
                query: 'query($search: searchEventsInput!) { \
                    searchEvents(search: $search) { \
                      items { \
                        id \
                        targetResource \
                        action \
                        userName \
                        userIp \
                        createdAt \
                      } \
                      totalItems \
                    } \
                }',
                variables: variables
            };
            return $http.post(requestUrl, body).then(api.whenCompleted);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('shelobApi', shelobApi);

  function shelobApi($http, EnvironmentConfig, Api) {
    var api = new Api($http, EnvironmentConfig.shelob, 'configuration');
    var requestUrl = api.getUrl();

    return {
      activateIntegration: activateIntegration,
      getIntegrations: getIntegrations,
      deactivateIntegration: deactivateIntegration
    };

    function getIntegrations() {
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function activateIntegration(data) {
      return $http.put(requestUrl, data).then(api.whenCompleted);
    }

    function deactivateIntegration(apiName) {
      return $http.delete(requestUrl + apiName).then(api.whenCompleted);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('routerizationApi', routerizationApi);

    function routerizationApi($http, EnvironmentConfig) {
        var requestUrl = EnvironmentConfig.saruman;

        return {
            getRouteOptimization: getRouteOptimization,
            getRequestUsage: getRequestUsage
        };

        function getRouteOptimization(startLocation, endLocation, waypoints, options) {
            var body = {
                startLocation: startLocation,
                endLocation: endLocation,
                waypoints: waypoints,
                options: options
            };

            return $http.post(requestUrl + "vrp", body);
        }

        function getRequestUsage() {
            return $http.get(requestUrl + "usage");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('uploadApi', uploadApi);

    function uploadApi($http, EnvironmentConfig, Api, querify, Upload) {
        var signedApi = new Api($http, EnvironmentConfig.uploadsBaseUrl + 's3-pre-signed-post', '');
        var passthroughApi = new Api($http, EnvironmentConfig.uploadsBaseUrl + 's3-passthrough-upload', '');

        return {
            uploadWithPassthrough: uploadWithPassthrough,
            uploadWithPreSignedPost: uploadWithPreSignedPost
        };

        function uploadWithPassthrough(options) {
            return $http.post(passthroughApi.getUrl(), {
                filename: options.filename,
                imageBase64Encoded: options.imageBase64Encoded
            });
        }

        function uploadWithPreSignedPost(options, callbackProgress) {
            var $mdToast = options.$mdToast;
            var $translate = options.$translate;
            return $http.post(signedApi.getUrl(), {
                filename: options.filePath,
                randomize: options.randomize === false ? false : true
            }).then(function (result) {
                return _uploadToS3(result.data, options.file, callbackProgress);
            })
            .catch(function (err) {
                if ($mdToast && $translate) {
                    $mdToast.show(
                        $mdToast
                          .simple()
                          .textContent($translate.instant('TASKS.TOASTS.FORMS.INCOMPATIBLE_FILE'))
                          .hideDelay(4000)
                          .theme('error-toast')
                          .position('bottom right')
                      );
                }
                throw err;
            });
        }

        function _uploadToS3(s3Permission, file, callbackProgress) {

            return new Promise(function (resolve, reject) {

                var params = s3Permission.form;
                params.file = file;

                var upload = Upload.upload({
                    url: s3Permission.endpoint,
                    data: params
                });

                upload.then(function (resp) {
                    // TODO: Se enviar um accept json não será retornado em json?
                    resolve({
                        path: _extractValueFromXML(resp.data, "Key"),
                        contentType: resp.config.data['Content-Type']
                    });
                }, function (resp) {
                    reject(resp);
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);

                    if (callbackProgress) {
                        callbackProgress(progressPercentage);
                    }
                });

            });
        }

        function _extractValueFromXML(xml, key) {
            var xmlDoc = new DOMParser().parseFromString(xml,"text/xml");
            return xmlDoc.getElementsByTagName(key)[0].textContent;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('pushNotificationsApi', pushNotificationsApi);

  function pushNotificationsApi(Api, $http, EnvironmentConfig, $localStorage) {
    var api = new Api($http, EnvironmentConfig.mouthOfSauron3Url);

    return {
      subscribe: subscribe,
      unsubscribe: unsubscribe
    };

    function subscribe(subscriber, token) {
      var body = {
        query: 'mutation subscribeMutation( $input: SubscribeInput!) {subscribe(input: $input) { id} }',
        variables: { input: subscriber }
      };
      return $http.post(api.getUrl(), body, { headers: { 'Authorization': token } }).then(function (result) {
        if (result.data.data) {
          $localStorage.set("subscribeKey", result.data.data.subscribe.id);
        }
        return api.whenCompleted;
      });
    }

    function unsubscribe(token) {
      var body = {
        query: 'mutation unsubscribeMutation( $id: ID!) { unsubscribe(id: $id) { id }}',
        variables: { id: $localStorage.get("subscribeKey") }
      };
      return $http.post(api.getUrl(), body, { headers: { 'Authorization': token } }).then(function (result) {
        $localStorage.remove("subscribeKey");
        return api.whenCompleted;
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('notificationsApi', notificationsApi);


    function notificationsApi($http, EnvironmentConfig, Api, $localStorage) {
        var api = new Api($http, EnvironmentConfig.mouthOfSauron3Url);

        return {
            read: read,
            readAll: readAll,
            getAll: getAll,
            unreadCount: unreadCount,
        };

        function getAll(token) {
            var body = { query: '{notifications { id title type data createdAt readAt}}' };
            return $http.post(api.getUrl(), body, { headers: { 'Authorization': token } }).then(api.whenCompleted);
        }

        function unreadCount(token) {
            var body = { query: '{ notificationsUnreadCount { count } }' };
            return $http.post(api.getUrl(), body, { headers: { 'Authorization': token } }).then(api.whenCompleted);
        }

        function read(id, token) {
            var body = {
                query: "mutation NotificationRead ($id: ID!){ notificationRead(id: $id) {  title } }",
                variables: { 'id': id }
            };
            return $http.post(api.getUrl(), body, { headers: { 'Authorization': token } }).then(api.whenCompleted);
        }

        function readAll(token) {
            var body = { query: 'mutation NotificationReadAll{ notificationReadAll{ count } }' };
            return $http.post(api.getUrl(), body, { headers: { 'Authorization': token } }).then(api.whenCompleted);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('printConfigurationApi', printConfigurationApi);

  function printConfigurationApi($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.grondBaseUrl;

    return {
      createPrintConfiguration: createPrintConfiguration,
      getPrintConfiguration: getPrintConfiguration
    };

    function createPrintConfiguration(configurations) {
      var query = '\
      mutation printConfigurationMutation ($input: PrintConfigurationInput!) { \
        savePrintConfigurations(input: $input) { \
          configurations { \
            name \
            value \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: configurations
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['savePrintConfigurations'];
      });
    }

    function getPrintConfiguration() {
      var query = '\
      query printConfigurationQuery { \
        printConfigurations { \
          configurations { \
            name \
            value \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['printConfigurations'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('smartRewriteApi', smartRewriteApi);

  function smartRewriteApi($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.gandalfUrl;

    return {
      getAccountUsage: getAccountUsage,
      getAccountHistory: getAccountHistory
    };

    function getAccountUsage() {

      return $http.get(baseUrl + '/smart-rewrite-account-usage').then(function (response) {
        return response;
      });
    }

    function getAccountHistory(params) {
      return $http.get(baseUrl + '/smart-rewrite-account-history', { params: params }).then(function (response) {
        return response;
      });
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('gandalfApi', gandalfApi);

  function gandalfApi($http, EnvironmentConfig, Api) {
    var api = new Api($http, EnvironmentConfig.gandalf);

    return {
      getInputHistory: getInputHistory,
      updateRewriteInputHistory: updateRewriteInputHistory
    };

    function getInputHistory(reference) {
      var url = api.getUrl() + 'smart-rewrite-input-history?reference=' + encodeURIComponent(reference);

      return $http.get(url);
    }

    function updateRewriteInputHistory(params) {
      var url = api.getUrl() + 'smart-rewrite-history-update?';

      url += 'referenceType=' + params.referenceType + '&';
      url += 'reference=' + params.reference + '&';
      url += 'updatedReference=' + params.updatedReference;

      return $http.get(url);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('recurringApi', recurringApi);

  function recurringApi($http, Api, EnvironmentConfig, msUtils) {
    var api = new Api($http, EnvironmentConfig.fellbeast2, 'recurring', msUtils.qStringify);

    return {
      getOccurrencesDates: getOccurrencesDates
    };

    function getOccurrencesDates(config) {
      var requestUrl = api.getUrl();
      return $http.post(requestUrl, config).then(api.whenCompleted);
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('profitWellApi', profitWellApi);

    function profitWellApi($http, Api, EnvironmentConfig, msUtils) {
        var api = new Api($http, EnvironmentConfig.othersApiBaseUrl, 'profitwell', msUtils.qStringify);
        return {
            getMe: getMe
        };

        function getMe() {
            var requestUrl = api.getUrl() + 'me';
            return $http.get(requestUrl).then(api.whenCompleted);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('geoCoderApi', geoCoderApi);

    function geoCoderApi($http, Api, EnvironmentConfig, msUtils) {
        var api = new Api($http, EnvironmentConfig.othersApiBaseUrl, 'geocode', msUtils.qStringify);
        return {
            search: api.getParams
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('geoCoderReverseApi', geoCoderReverseApi);

    function geoCoderReverseApi($http, Api, EnvironmentConfig, msUtils) {
        var api = new Api($http, EnvironmentConfig.othersApiBaseUrl, 'reverseGeocode', msUtils.qStringify);
        return {
            search: api.getParams
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('crispApi', crispApi);

    function crispApi($http, Api, EnvironmentConfig, msUtils) {
        var api = new Api($http, EnvironmentConfig.othersApiBaseUrl, 'crisp', msUtils.qStringify);
        return {
            getMe: getMe
        };

        function getMe() {
            var requestUrl = api.getUrl() + 'me';
            return $http.get(requestUrl).then(api.whenCompleted);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('cepDbApi', cepDbApi);

    function cepDbApi($http, Api, EnvironmentConfig, msUtils) {
        var api = new Api($http, EnvironmentConfig.othersApiBaseUrl, 'lookup', msUtils.qStringify);
        return {
            search: api.getParams
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('blatoutApi', blatoutApi);

    function blatoutApi($http, Api, EnvironmentConfig, msUtils) {
        var api = new Api($http, EnvironmentConfig.othersApiBaseUrl, 'blatout', msUtils.qStringify);
        return {
            getUserHash: getUserHash
        };

        function getUserHash(userId) {
            var requestUrl = api.getUrl() + 'users/' + userId;
            return $http.get(requestUrl).then(api.whenCompleted);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('storagesApiGraphQL', storagesApiGraphQL);

  function storagesApiGraphQL($http, EnvironmentConfig, $q) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      search: search
    };

    function search(queryParams) {
      var queryString = '\
      query StoragesQuery ( \
        $where: StoragesWhereInput \
        $orderBy: StoragesOrderByEnum \
        $take: Int \
        $skip: Int \
      ) { \
        storages (where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
          items { \
            id \
            name \
            description \
            archived \
            employee { \
              id \
              name \
              avatarUrl \
            } \
            productSummary { \
              quantity \
              totalValue \
            } \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['storages'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('storagesMovementsApiGraphQL', storagesMovementsApiGraphQL);

  function storagesMovementsApiGraphQL($http, EnvironmentConfig, $q) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      search: search,
      create: create
    };

    function search(queryParams) {
      var queryString = '\
      query StorageMovementsQuery ( \
        $where: StorageMovementsWhereInput \
        $orderBy: StorageMovementsOrderByEnum \
        $take: Int \
        $skip: Int \
      ) { \
        storageMovements (where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
          items { \
            id \
            type \
            product { \
              id \
              name \
              measure \
              imageUrl \
              value \
              code \
            } \
            quantity \
            oldQuantity \
            description \
            totalValue \
            storage { \
              id \
              name \
            } \
            order { \
              id \
              identifier \
            } \
            createdAt \
            createdBy { \
              id \
              name \
              avatarUrl \
            } \
            updatedAt \
            updatedBy { \
              id \
              name \
              avatarUrl \
            } \
            storageMovementTransfer { \
              id \
              storageMovementEntry { \
                id \
                type \
                quantity \
                oldQuantity \
                description \
                totalValue \
                product { \
                  id \
                  name \
                  measure \
                  imageUrl \
                  value \
                  code \
                } \
                storage { \
                  id \
                  name \
                } \
              } \
              storageMovementRemoval { \
                id \
                type \
                quantity \
                oldQuantity \
                description \
                totalValue \
                product { \
                  id \
                  name \
                  measure \
                  imageUrl \
                  value \
                  code \
                } \
                storage { \
                  id \
                  name \
                } \
              } \
            } \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['storageMovements'];
        });
    }

    function create(queryParams) {
      var queryString = '\
      mutation CreateStorageMovement($input: CreateStorageMovementInput!) { \
        createStorageMovement (input: $input) { \
          id \
          type \
          product { \
            id \
            name \
            measure \
            imageUrl \
            value \
          } \
          quantity \
          totalValue \
          storage { \
            id \
          } \
          order { \
            id \
          } \
          createdBy { \
            id \
            name \
            avatarUrl \
          } \
        } \
      } \
    ';

    return $http.post(baseUrl, {
      query: queryString,
      variables: { input: queryParams }
    }, { headers: { 'cache-control': 'no-cache' } })
      .then(function (response) {
        return response.data['data']['createStorageMovement'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('storageProductsApiGraphQL', storageProductsApiGraphQL);

  function storageProductsApiGraphQL($http, EnvironmentConfig, $q) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      search: search,
      update: update
    };

    function search(queryParams) {
      var queryString = ' \
        query StorageProductsQuery ( \
          $where: StorageProductsWhereInput \
          $orderBy: StorageProductsOrderByEnum \
          $take: Int \
          $skip: Int \
        ) { \
          storageProducts (where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
            pageInfo { \
              hasNextPage \
              hasPreviousPage \
            } \
            totalCount \
            items { \
              id \
              quantity \
              totalValue \
              createdAt \
              product { \
                id \
                name \
                archived \
                locked \
                type \
                value \
                createdAt \
                description \
                measure \
                quantity \
                imageUrl \
              } \
              storage { \
                id \
                name \
                description \
                archived \
              } \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['storageProducts'];
        });
    }

    function update(queryParams) {
      var queryString = '\
        mutation UpdateStorageProduct($input: UpdateStorageProductInput!) { \
          updateStorageProduct (input: $input) { \
            id \
            minimalQuantity \
            minimalQuantityAtRisk \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: { input: queryParams }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['updateStorageProduct'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('ServicesApiGraphQL', ServicesApiGraphQL);

  function ServicesApiGraphQL($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      search: search,
      queryForDatatable: queryForDatatable
    };

    function search(queryParams) {
      var queryString = ' \
      query ServicesQuery( \
        $where: ServicesWhereInput \
        $orderBy: ServicesOrderByEnum \
        $take: Int \
        $skip: Int \
      ) { \
        services(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
          items { \
            id \
            _id \
            description \
            duration \
            archived \
            slaTimeLimit \
            allowAllForms \
            locked \
            signatureRequired \
            quotationRequired \
            metadata \
            configurations { \
              mobile { \
                startNCompleteTaskValidationRadiusOn \
                startNCompleteTaskValidationRadiusMeters \
                autoSmartRewriteEnabled \
                autoSmartRewriteFields \
              } \
              notifications { \
                sendEmailTaskRatingLinkWhenCompleted \
                sendEmailOrderReportLinkWhenCompleted \
                sendEmailEmployeeRouteTrackingLinkWhenOnRoute \
              } \
            } \
            createdAt \
            updatedAt \
            security { \
              startPasswordCodeRequired \
              completePasswordCodeRequired \
            } \
            forms { \
              id \
              name \
              required { \
                complete \
                report \
                start \
              } \
            } \
          } \
        } \
      } \
    ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['services'];
        });
    }

    function queryForDatatable(queryParams) {
      var queryString = '\
      query ServicesQuery( \
        $where: ServicesWhereInput, \
        $orderBy: ServicesOrderByEnum, \
        $take: Int, \
        $skip: Int \
      ) { \
        services(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
          items { \
            id \
            description \
            duration \
            archived \
            locked \
            employees { \
              id \
              name \
            } \
          configurations { \
            mobile { \
              startNCompleteTaskValidationRadiusOn \
              startNCompleteTaskValidationRadiusMeters \
              autoSmartRewriteEnabled \
              autoSmartRewriteFields \
            } \
            notifications { \
              sendEmailTaskRatingLinkWhenCompleted \
              sendEmailOrderReportLinkWhenCompleted \
              sendEmailEmployeeRouteTrackingLinkWhenOnRoute \
              sendEmailEmployeeOrderReportWhenCompleted \
            } \
          } \
          ratingFormId \
          allowAllForms \
          signatureRequired \
          quotationRequired \
          metadata \
          createdAt \
          updatedAt \
          security { \
            startPasswordCodeRequired \
            completePasswordCodeRequired \
          } \
          slaTimeLimit \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['services'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
      .module('app.core.api')
      .factory('quotationsAttachmentsApi', quotationsAttachmentsApi);

  function quotationsAttachmentsApi($http, EnvironmentConfig) {
    var api = {
      getQuotationsAttachments: getQuotationsAttachments,
      createQuotationAttachments: createQuotationAttachments,
      updateQuotationsAttachment: updateQuotationsAttachment,
      deleteQuotationsAttachment: deleteQuotationsAttachment,
      reorderAttachments: reorderAttachments
    };
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return api;

    function getQuotationsAttachments(quotationId) {
      var queryString = ' \
        query quotation( \
          $id: UUID! \
          $where: AttachmentsWhereInput \
        ) { \
          quotation(id: $id) { \
            attachments(where: $where) { \
              id \
              createdAt \
              path \
              type \
              archived \
              title \
              position \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          id: quotationId
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['quotation']['attachments'];
        });
    }

    function createQuotationAttachments(quotationId, attachments) {
      var mutationString = ' \
        mutation createMultipleQuotationAttachment($input: CreateMultipleQuotationAttachmentInput!) { \
          createMultipleQuotationAttachment(input: $input) { \
            id \
            createdAt \
            path \
            type \
            archived \
            title \
            position \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: mutationString,
        variables: {
          input: {
            quotationId: quotationId,
            attachments: attachments
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['createMultipleQuotationAttachment'];
        });
    }

    function reorderAttachments(quotationId, attachmentId, position, direction) {
      var mutationString = ' \
        mutation reorderQuotationAttachments($input: ReorderQuotationAttachmentsInput!) { \
          reorderQuotationAttachments(input: $input) { \
            id \
            title \
            position \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: mutationString,
        variables: {
          input: {
            quotationId: quotationId,
            attachmentId: attachmentId,
            position: position,
            direction: direction
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['reorderQuotationAttachments'];
        });
    }

    function updateQuotationsAttachment(quotationId, attachmentId, archived, title, position) {
      var mutationString = ' \
        mutation updateQuotationAttachment($input: UpdateQuotationAttachmentInput!) { \
          updateQuotationAttachment(input: $input) { \
            id \
            createdAt \
            path \
            type \
            archived \
            title \
            position \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: mutationString,
        variables: {
          input: {
            quotationId: quotationId,
            attachmentId: attachmentId,
            archived: archived,
            title: title,
            position: position
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['updateQuotationAttachment'];
        });
    }

    function deleteQuotationsAttachment(quotationId, attachmentId) {
      var mutationString = ' \
        mutation deleteQuotationAttachment($input: DeleteQuotationAttachmentInput!) { \
          deleteQuotationAttachment(input: $input) { \
            id \
            createdAt \
            path \
            type \
            archived \
            title \
            position \
          }\
        }\
      ';

    return $http.post(baseUrl, {
      query: mutationString,
      variables: {
        input: {
          quotationId: quotationId,
          attachmentId: attachmentId
        }
      }
    }, { headers: { 'cache-control': 'no-cache' } })
      .then(function (response) {
        return response.data['data']['deleteQuotationAttachment'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('productTypesApiGraphQL', productTypesApiGraphQL);

  function productTypesApiGraphQL($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      queryForDatatable: queryForDatatable,
      queryForDialog: queryForDialog,
      createProductType: createProductType,
      updateProductType: updateProductType
    };

    function queryForDatatable(queryParams) {
      var queryString = '\
      query ProductTypesQuery( \
        $where: ProductTypesWhereInput, \
        $orderBy: ProductTypesOrderByEnum, \
        $take: Int, \
        $skip: Int \
      ) { \
        productTypes(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
          totalCount \
          items { \
            id \
            name \
            description \
            archived \
            createdAt \
            metadata \
            locked \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['productTypes'];
        });
    }

    function queryForDialog(productTypeId) {
      var queryString = '\
      query ProductTypesQuery( \
        $id: UUID! \
      ) { \
        productType(id: $id) { \
          id \
          name \
          description \
          archived \
          metadata \
          locked \
        } \
      }';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          id: productTypeId
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data'] && response.data['data']['productType'];
        });
    }

    function createProductType(productType) {
      var queryString = '\
      mutation createProductTypeMutation($input: CreateProductTypeInput!) { \
        createProductType(input: $input) { \
          id \
          name \
          description \
          archived \
        } \
      }';

      var input = {
        name: productType.name,
        description: productType.description,
        archived: productType.archived
      };

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['createProductType'];
        });
    }

    function updateProductType(productType) {
      var queryString = '\
      mutation UpdateProductTypeMutation($input: UpdateProductTypeInput!) { \
        updateProductType(input: $input) { \
          id \
          name \
          description \
          archived \
        } \
      }';

      var input = {
        id: productType.id,
        name: productType.name,
        description: productType.description,
        archived: productType.archived
      };

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['updateProductType'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('productServicesApiGraphQL', productServicesApiGraphQL);

  function productServicesApiGraphQL($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      search: search,
    };

    function search(queryParams) {
      var queryString = ' \
      query ProductsQuery( \
        $where: ProductsWhereInput \
        $orderBy: ProductsOrderByEnum \
        $take: Int \
        $skip: Int \
      ) { \
        products(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
          items { \
            id \
            name \
            archived \
            locked \
            type \
            value \
            createdAt \
            description \
            measure \
            quantity \
            imageUrl \
            metadata \
            code \
            qrCode \
            productType { \
              id \
              name \
              description \
            } \
            storageSummary { \
              quantity \
              totalValue \
            } \
          } \
        } \
      } \
    ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['products'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
      .module('app.core.api')
      .factory('ordersRoutesApiGraphQL', ordersRoutesApiGraphQL);

  function ordersRoutesApiGraphQL($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;
    var api = {
      getRoute: getRoute,
    };

    function getRoute(orderId) {
      var queryString = ' \
        query OrderRoutesQuery( \
          $id: ID! \
        ) { \
          order(id: $id) { \
            route { \
              waypoints { \
                latitude \
                longitude \
              } \
              addresses { \
                id \
                position \
                postalCode \
                street \
                number \
                complement \
                neighborhood \
                city \
                state \
                formattedAddress \
                country \
                placeName \
                placePhone \
                latitude \
                longitude \
                createdAt \
              } \
              kmTotal \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          id: orderId,
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['order']['route'];
        });
    }

    return api;
  }
})();

(function () {
  'use strict';

  angular
      .module('app.core.api')
      .factory('ordersPendenciesApiGraphQL', ordersPendenciesApiGraphQL);

  function ordersPendenciesApiGraphQL($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;
    var api = {
      getPendencies: getPendencies,
      getContractor: getContractor,
    };

    function getPendencies(orderId, cursor, take) {
      var queryString = ' \
        query OrderQuery( \
          $id: ID! \
          $cursor: String \
          $take: Int \
        ) { \
          order(id: $id) { \
            pendencies(take: $take, cursor: $cursor) { \
              totalCount \
              pageInfo { \
                startCursor \
                endCursor \
              } \
              items { \
                id \
                title \
                identifier \
                status \
                treatmentStatus \
                pendencyType { \
                  name \
                } \
                assignee { \
                  id \
                  name \
                  avatarUrl \
                } \
                contractor { \
                  name \
                  logoUrl \
                } \
              } \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          id: orderId,
          cursor: cursor,
          take: take
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['order']['pendencies'];
        });
    }

    function getContractor(id) {
      var queryString = ' \
        query ContractorQuery( \
          $id: ID! \
        ) { \
          contractor(id: $id) { \
            id \
            name \
            logoUrl \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          id: id
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['contractor'];
        });
    }

    return api;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('offlineSyncRequestsApiGraphQL', offlineSyncRequestsApiGraphQL);

  function offlineSyncRequestsApiGraphQL($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      getOfflineSyncRequests: getOfflineSyncRequests
    };

    function getOfflineSyncRequests(orderId, take, skip) {
      var query = '\
      query OfflineSyncRequestsQuery(\
        $where: OfflineSyncRequestsWhereInput\
        $orderBy: OfflineSyncRequestsOrderByEnum\
        $take: Int\
        $skip: Int\
      ) {\
        offlineSyncRequests(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {\
          pageInfo {\
            hasNextPage\
            hasPreviousPage\
          }\
          totalCount\
          items {\
            id\
            name\
            status\
            retried\
            fileToUpload {\
              path\
              size\
              name\
            }\
            error\
            syncAt\
            createdAt\
          }\
        }\
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          where: {
            orderId: orderId
          },
          orderBy: 'createdAt_desc',
          take: take,
          skip: skip
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['offlineSyncRequests'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('locationsApiGraphQL', locationsApiGraphQL);

  function locationsApiGraphQL($http, EnvironmentConfig, $q) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      queryForDatatable: queryForDatatable,
      queryForDialog: queryForDialog,
      createLocation: createLocation,
      updateLocation: updateLocation,
      syncLocationContacts: syncLocationContacts,
      getLocationAttachments: getLocationAttachments,
      createLocationAttachments: createLocationAttachments,
      updateLocationAttachments: updateLocationAttachments,
      removeLocationAttachments: removeLocationAttachments,
      getCustomerLocationsContacts: getCustomerLocationsContacts,
      getLocationSequence: getLocationSequence,
      search: search
    };

    function queryForDatatable(queryParams) {
      var queryString = '\
      query LocationsQuery( \
        $where: LocationsWhereInput, \
        $orderBy: LocationsOrderByEnum, \
        $take: Int, \
        $skip: Int \
      ) { \
        locations(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
          totalCount \
          items { \
            id \
            name \
            archived \
            locked \
            documentNumber \
            customer { \
              name \
              metadata\
            } \
            address { \
              formattedAddress \
            } \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['locations'];
        });
    }

    function queryForDialog(locationId) {
      var queryString = '\
      query LocationQuery( \
        $id: ID! \
      ) { \
        location(id: $id) { \
          id \
          name \
          archived \
          documentNumber \
          notes \
          locked \
          customer { \
            id \
            name \
            metadata\
            primaryLocation { \
              id \
            } \
          } \
          territories { \
            id \
            name \
          } \
          subTerritories { \
            id \
            name \
          } \
          address { \
            street \
            number \
            complement \
            postalCode \
            neighborhood \
            city \
            state \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
          contacts { \
            emails { \
              id \
              name \
              address \
              type \
              primary \
            } \
            phones { \
              id \
              name \
              countryCode \
              number \
              type \
              primary \
            } \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          id: locationId
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['location'];
        });
    }

    function createLocation(location) {
      var queryString = '\
      mutation CreateLocationMutation($input: CreateLocationInput!) { \
        createLocation(input: $input) { \
          id \
          name \
          archived \
          address { \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
          customer { \
           name \
          } \
        } \
      }';

      var input = {
        name: location.name,
        documentNumber: location.documentNumber,
        customerId: location.customerId,
        archived: location.archived,
        locked: location.locked,
        address: location.address,
        notes: location.notes
      };

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['createLocation'];
        });
    }

    function updateLocation(location) {
      var queryString = '\
      mutation UpdateLocationMutation($input: UpdateLocationInput!) { \
        updateLocation(input: $input) { \
          id \
          name \
          archived \
          address { \
            formattedAddress \
            coords { \
              latitude \
              longitude \
            } \
          } \
          customer { \
           name \
          } \
        } \
      }';

      var input = {
        id: location.id,
        name: location.name,
        documentNumber: location.documentNumber,
        customerId: location.customerId,
        archived: location.archived,
        locked: location.locked,
        address: location.address,
        notes: location.notes
      };

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['updateLocation'];
        });
    }

    function syncLocationContacts(location) {
      var queryString = '\
      mutation SyncLocationContactsMutation($input: SyncLocationContactsInput!) { \
        syncLocationContacts(input: $input) { \
          emails { \
            name \
            address \
            type \
            primary \
          } \
          phones { \
            name \
            number \
            type \
            primary \
          } \
        } \
      }';

      var input = {
        locationId: location.id,
        emails: location.contacts && location.contacts.emails || [],
        phones: location.contacts && location.contacts.phones || []
      };

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['syncLocationContacts'];
        });
    }

    function getLocationAttachments(locationId) {
      if (!locationId) {
        return [];
      }

      var queryString = ' \
        query LocationAttachmentQuery( \
          $id: ID! \
        ) { \
          location(id: $id) { \
            attachments { \
              id \
              createdAt \
              path \
              type \
              archived \
              title \
              position \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          id: locationId
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['location']['attachments'];
        });
    }

    function createLocationAttachments(locationId, attachments) {
      var mutationString = ' \
        mutation createMultipleLocationAttachment($input: CreateMultipleLocationAttachmentInput!) { \
          createMultipleLocationAttachment(input: $input) { \
            id \
            createdAt \
            path \
            type \
            archived \
            title \
            position \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: mutationString,
        variables: {
          input: {
            locationId: locationId,
            attachments: attachments
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['createMultipleLocationAttachment'];
        });
    }

    function updateLocationAttachments(locationId, attachmentId, archived, title, position) {
      var mutationString = ' \
        mutation updateLocationAttachment($input: UpdateLocationAttachmentInput!) { \
          updateLocationAttachment(input: $input) { \
            id \
            createdAt \
            path \
            type \
            archived \
            title \
            position \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: mutationString,
        variables: {
          input: {
            locationId: locationId,
            attachmentId: attachmentId,
            archived: archived,
            title: title,
            position: position
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['updateLocationAttachment'];
        });
    }

    function removeLocationAttachments(locationId, attachmentId) {
      var mutationString = ' \
        mutation deleteLocationAttachment($input: DeleteLocationAttachmentInput!) { \
          deleteLocationAttachment(input: $input) { \
            id \
            createdAt \
            path \
            type \
            archived \
            title \
            position \
          }\
        }\
      ';

    return $http.post(baseUrl, {
      query: mutationString,
      variables: {
        input: {
          locationId: locationId,
          attachmentId: attachmentId
        }
      }
    }, { headers: { 'cache-control': 'no-cache' } })
      .then(function (response) {
        return response.data['data']['deleteLocationAttachment'];
      });
    }

    function getCustomerLocationsContacts(customerId, locationName, locationStreet) {
      var queryString = '\
      query Location( \
        $where: LocationsWhereInput \
      ) { \
        locations(where: $where) { \
          totalCount \
          items { \
            id \
            name \
            archived \
            locked \
            contacts { \
              emails { \
                id \
                name \
                address \
                type \
                primary \
              } \
              phones { \
                id \
                name \
                countryCode \
                number \
                type \
                primary \
              } \
            } \
          } \
        } \
      }';

      var where = {
        customerIds: customerId,
        nameContains: locationName,
        streetContains: locationStreet
      };

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          where: where
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          var emails = [];
          var phones = [];
          var locations = response.data['data']['locations']['items'];
          locations.map( function (location) {
            location.contacts.emails.map( function (email) { emails.push(email); });
            location.contacts.phones.map( function (phone) { phones.push(phone); });
          });


           return {
            emails: emails,
            phones: phones
          };
        });
    }

    function getLocationSequence(locationsName) {
      var queryString = '\
      query Location( \
        $where: LocationsWhereInput \
      ) { \
        locations(where: $where) { \
          totalCount \
          items { \
            id \
            name \
            archived \
            locked \
            customer {\
              id \
            } \
            contacts { \
              emails { \
                id \
                name \
                address \
                type \
                primary \
              } \
              phones { \
                id \
                name \
                countryCode \
                number \
                type \
                primary \
              } \
            } \
          } \
        } \
      }';

      var results = [];
      var promise = $q.when();
      locationsName.forEach(function (locationName) {
        var where = {
          nameContains: locationName,
          archived: false
        };
        promise = promise.then(function () {
          return $http.post(baseUrl, {
            query: queryString,
            variables: {
              where: where
            }
          }, { headers: { 'cache-control': 'no-cache' } })
            .then(function (response) {
              response.data['data']['locations']['items'].forEach(function (item) {
                results.push(item);
              });
              return {
                items: results,
                totalItems: results.length
              };
            });
        });
      });
      return promise;
    }

    function search(queryParams) {
      var queryString = '\
        query LocationsQuery( \
          $where: LocationsWhereInput \
          $orderBy: LocationsOrderByEnum \
          $take: Int \
          $skip: Int \
        ) { \
          locations(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
            pageInfo { \
              hasNextPage \
              hasPreviousPage \
            } \
            totalCount \
            items { \
              id \
              name \
              archived \
              locked \
              documentNumber \
              customer { \
                name \
                metadata\
              } \
              createdAt \
              address { \
                zipCode \
                street \
                number \
                complement \
                neighborhood \
                city \
                state \
                formattedAddress \
                coords { \
                  latitude \
                  longitude \
                } \
              } \
              contacts { \
                phones { \
                  id \
                  number \
                  type \
                  primary \
                } \
                emails { \
                  id \
                  address \
                  type \
                  primary \
                } \
              } \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['locations'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('formsApiGraphQL', formsApiGraphQL);

  function formsApiGraphQL($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      getFormsAnswer: getFormsAnswer,
      getForm: getForm,
      getForms: getForms
    };

    function getFormsAnswer(answerId) {
      var query = '\
        query FormAnswerQuery($id: UUID!) { \
          formAnswer(id: $id) { \
            id \
            name \
            status \
            archived \
            type \
            questions { \
              id \
              type \
              title \
              required \
              position \
              answeredAt \
              answer \
              options { \
                id \
                value \
                position \
                score \
              } \
              conditions { \
                value \
                operator \
                question { \
                  id \
                  title \
                } \
                condition \
              } \
            } \
            createdAt \
            completedAt \
            createdBy \
            questionsCount \
            answeredQuestionsCount \
          } \
        }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          id: answerId
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['formAnswer'];
      });
    }

    function getForm(formId) {
      var query = '\
        query FormQuery( \
          $id: UUID! \
        ){ \
          form(id: $id) { \
              id \
              name \
              archived \
              questionsCount \
              type \
              metadata \
              locked \
              questions { \
                id\
                type\
                title\
                required\
                position\
                options {\
                  id\
                  value\
                  position \
                  score \
                  description \
                }\
                conditions {\
                   \
                  value\
                  operator\
                  question { \
                    id \
                    title \
                  } \
                  condition \
                }\
              }\
              equipmentTypes{ \
                id \
                name \
                createdAt \
                archived \
              } \
              services { \
                id \
                description \
                archived \
              } \
              required { \
                complete \
                report \
              } \
              createdAt\
              updatedAt\
            } \
        }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          id: formId
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['form'];
      });
    }

    function getForms(queryParams) {
      var query = '\
        query FormQuery( \
          $where: FormsWhereInput, \
          $orderBy: FormsOrderByEnum, \
          $take: Int, \
          $skip: Int \
        ){ \
          forms(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
              items { \
                id \
                name \
                archived \
                questionsCount \
                type \
                metadata \
                locked \
                questions { \
                  id\
                  type\
                  title\
                  required\
                  position\
                  options {\
                    id\
                    value\
                    position \
                    score \
                    description \
                  }\
                  conditions {\
                    \
                    value\
                    operator\
                    question { \
                      id \
                      title \
                    } \
                    condition \
                  }\
                }\
                required { \
                  complete \
                  report \
                } \
                createdAt\
                updatedAt\
              } \
            } \
        }';

      return $http.post(baseUrl, {
        query: query,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['forms'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('equipmentsApiGraphQL', equipmentsApiGraphQL);

  function equipmentsApiGraphQL($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      getEquipmentTypesForms: getEquipmentTypesForms,
      search: search,
      getEquipamentsByOrderId: getEquipamentsByOrderId
    };

    function getEquipmentTypesForms(serviceId) {
      var query = '\
        query equipmentTypesQuery($where: EquipmentTypesWhereInput!, $take: Int, $skip: Int) { \
          equipmentTypes(where: $where, take: $take, skip: $skip) { \
            items {\
              name \
              forms { \
                name \
                service { \
                  id \
                  description \
                } \
              } \
            } \
          } \
        }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          where: {
            linkedToServiceIds: [serviceId],
          }
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['equipmentTypes'];
      });
    }

    function search(queryParams) {
      var url = EnvironmentConfig.eyeOfSauron2Url;
      var queryString = '\
      query EquipmentsQuery($where: EquipmentsWhereInput, $take: Int, $skip: Int) { \
        equipments(where: $where, take: $take, skip: $skip) { \
          totalCount \
          items { \
            archived \
            attachments { \
              id \
              title \
              path \
            } \
            customer { \
              id \
            } \
            id \
            imageUrl \
            location { \
              id \
              name \
            } \
            locked \
            name \
            notes \
            number \
            qrCode \
            type { \
              id \
            } \
          } \
        } \
      }';

      return $http.post(url, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['equipments'];
      });
    }

    function getEquipamentsByOrderId(orderId) {
      var queryString = '\
      query EquipmentsQuery( \
        $where: EquipmentsWhereInput \
        $orderBy: EquipmentsOrderByEnum \
        $take: Int \
        $skip: Int \
      ) {\
        equipments(where: $where,orderBy: $orderBy, take: $take, skip: $skip) { \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
          items { \
            id \
            name \
            number \
            imageUrl \
            location { \
              id \
              name \
            } \
            notes \
            qrCode \
            archived \
            createdAt \
            type { \
              id \
            } \
            attachments { \
              id \
              path \
              archived \
              createdAt \
              title \
              size \
            } \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          skip: 0,
          take: 10000,
          where: {
            linkedToOrderIds: [orderId],
          },
          orderBy: 'linkedAt_asc'
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['equipments']['items'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('employeesApiGraphQL', employeesApiGraphQL);

  function employeesApiGraphQL($http, EnvironmentConfig) {
    var api = {
      createEmployee: createEmployee,
      search: search,
      countActiveEmployees: countActiveEmployees
    };
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return api;

    function createEmployee(employee) {
      var queryString = '\
          mutation EmployeeMutation($input: CreateEmployeeInput!) { \
              createEmployee(input: $input) { \
                  id \
                  name \
                  documentNumber \
                  _id \
                  email \
                  notes \
                  emailValidatedAt \
                  address { \
                      zipCode \
                      street \
                      number \
                      city \
                      state \
                      coords { \
                          latitude \
                          longitude \
                      } \
                      formattedAddress \
                  } \
                  contract { \
                      hiredAt \
                      firedAt \
                      active \
                  } \
                  workSchedule { \
                      start \
                      end \
                      break { \
                          start \
                          end \
                      } \
                      capacity \
                  } \
                  device { \
                      id \
                      registration \
                      platform \
                      appVersion \
                      releaseVersion \
                  } \
                  avatarUrl \
                  preferences { \
                      language \
                  } \
              } \
          } \
      ';

      var input = {
        contract: employee.contract,
        address: employee.address,
        workSchedule: employee.workSchedule,
        name: employee.name,
        documentNumber: employee.documentNumber,
        notes: employee.notes,
        email: employee.email,
        avatarUrl: employee.avatarUrl,
        groupIds: employee.groupIds,
        serviceIds: employee.serviceIds,
      };

      return new Promise(function (resolve, reject) {
        return $http.post(baseUrl, {
          query: queryString,
          variables: {
            input: input
          }
        }, { headers: { 'cache-control': 'no-cache' } })
          .then(function (response) {
            if (!response.data['data']) {
              return reject(response.data);
            }

            return resolve(response.data['data']['createEmployee']);
          });
      });
    }

    function search(queryParams) {
      var queryString = '\
        query EmployeeQuery( \
          $where: EmployeesWhereInput \
          $orderBy: EmployeesOrderByEnum \
          $take: Int \
          $skip: Int \
        ) { \
          employees(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
            pageInfo { \
              hasNextPage \
              hasPreviousPage \
            } \
            totalCount \
            items { \
              id \
              name \
              inactivatedAt \
              email \
              avatarUrl \
              emailValidatedAt \
              geolocationEnabled \
              documentNumber \
              contract { \
                hiredAt \
                firedAt \
                active \
                } \
              workSchedule { \
                start \
                end \
                break { \
                  start \
                  end \
                } \
              } \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['employees'];
        });
    }

    function countActiveEmployees() {
      var queryString = '\
        query EmployeeQuery( \
          $where: EmployeesWhereInput \
        ) { \
          employees(where: $where) { \
            totalCount \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          where: {
            active: true,
            isInactivated: null,
            isInactivatedOrFired: null
          }
        }
      },
        { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['employees'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('app.core.api')
  .factory('devicesApiGraphQL', devicesApiGraphQL);

  function devicesApiGraphQL($http, EnvironmentConfig) {
    var api = {
      deleteDevices: deleteDevices
    };
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return api;

    function deleteDevices(employeeId) {
      var queryString = '\
        mutation DeleteDevicesMutation($employeeId: UUID!) { \
          deleteDevices(employeeId: $employeeId) \
        } \
      ';

      return new Promise(function (resolve, reject) {
        return $http.post(baseUrl, {
          query: queryString,
          variables: {
            employeeId: employeeId
          }
        }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          if (!response.data['data']) {
            return reject(response.data);
          }

          return resolve(response.data['data']['deleteDevices']);
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('deadlineViolationsReasonsApiGraphQL', deadlineViolationsReasonsApiGraphQL);

  function deadlineViolationsReasonsApiGraphQL($http, EnvironmentConfig, $q) {
    var api = {
      search: search,
    };

    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;
    return api;

    function search(queryParams) {
      var queryString = '\
        query DeadlineViolationsReasonsQuery( \
          $where: DeadlineViolationReasonsWhereInput \
          $orderBy: DeadlineViolationReasonsOrderByEnum \
          $take: Int \
          $skip: Int \
        ) { \
          deadlineViolationReasons(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
            pageInfo { \
              hasNextPage \
              hasPreviousPage \
            } \
            totalCount \
            items { \
              id \
              name \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['deadlineViolationReasons'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('customersApiGraphQL', customersApiGraphQL);

  function customersApiGraphQL($http, EnvironmentConfig, $q) {
    var api = {
      getCustomerAttachments: getCustomerAttachments,
      getCustomerSequence: getCustomerSequence,
      search: search,
      createCustomer: createCustomer,
    };
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return api;

    function getCustomerAttachments(customerId) {
      var queryString = ' \
        query customer( \
           $id: ID!\
        ) { \
          customer(id: $id) { \
            attachments { \
              id \
              path \
              title \
              type \
              archived \
              position \
              metadata \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          id: customerId
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['customer']['attachments'];
        });
    }

    function getCustomerSequence(customerNames) {
      var queryString = ' \
        query CustomersQuery( \
          $where: CustomersWhereInput\
        ) { \
          customers(where: $where) { \
            totalCount \
            items { \
              id \
              name \
              documentNumber \
              archived \
              metadata \
            } \
          } \
        } \
      ';

      var results = [];
      var promises = $q.when();

      customerNames.forEach(function (customerName) {
        var where = {
          nameContains: customerName
        };

        promises = promises.then(function () {
          return $http.post(baseUrl, {
            query: queryString,
            variables: {
              where: where
            }
          }, { headers: { 'cache-control': 'no-cache' } })
            .then(function (response) {
              response.data['data']['customers']['items'].forEach(function (item) {
                results.push(item);
              });
              return {
                items: results,
                totalItems: results.length
              };
            });
        });
      });
      return promises;
    }

    function search(queryParams) {
      var queryString = '\
        query CustomersQuery( \
          $where: CustomersWhereInput \
          $orderBy: CustomersOrderByEnum \
          $take: Int \
          $skip: Int \
        ) { \
          customers(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
            pageInfo { \
              hasNextPage \
              hasPreviousPage \
            } \
            totalCount \
            items { \
              id \
              _id \
              name \
              notes \
              archived \
              createdAt \
              locked \
              metadata \
              documentNumber \
              avatarUrl \
              address { \
                zipCode \
                street \
                number \
                complement \
                neighborhood \
                city \
                state \
                formattedAddress \
                coords { \
                  latitude \
                  longitude \
                } \
              } \
              statistics { \
                rating { \
                  averageStars \
                  lastComment \
                  lastStar \
                } \
                service { \
                  firstAt \
                  lastAt \
                  total \
                } \
                updatedAt \
              } \
              primaryLocation { \
                id \
              } \
              contact { \
                email \
                phone \
              } \
              contacts { \
                phones { \
                  id \
                  number \
                  type \
                  primary \
                  name \
                  countryCode \
                } \
                emails { \
                  id \
                  address \
                  type \
                  primary \
                  name \
                } \
              } \
              labels { \
                id \
                name \
                color \
              } \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: queryParams
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['customers'];
        });
    }

    function createCustomer(input) {
      var queryString = '\
        mutation CreateCustomerMutation( \
          $input: CreateCustomerInput! \
        ) { \
          createCustomer(input: $input) { \
            id \
            name \
            documentNumber \
            archived \
            metadata \
            primaryLocation { \
              id \
            } \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          input: input
        }
      }).then(function (response) {
        return response.data['data']['createCustomer'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('accountFeatureFlagsApiGraphQL', accountFeatureFlagsApiGraphQL);

  function accountFeatureFlagsApiGraphQL($http, EnvironmentConfig, $q) {
    var api = {
      accountFeatureFlags: accountFeatureFlags,
      accountFeatureFlag: accountFeatureFlag,
      updateAccountFeatureFlag: updateAccountFeatureFlag,
      getCachedFlagByName: getCachedFlagByName
    };
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;
    var _flags;

    return api;

    function accountFeatureFlags() {
      var queryString = ' \
        query AccountFeatureFlagsQuery { \
          accountFeatureFlags { \
            id \
            name \
            active \
            createdAt \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['accountFeatureFlags'];
        });
    }

    function accountFeatureFlag(name) {
      var queryString = ' \
        query AccountFeatureFlagQuery($name: String!) { \
          accountFeatureFlag(name: $name) { \
            id \
            name \
            active \
            createdAt \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          name: name
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['accountFeatureFlag'];
        });
    }

    function updateAccountFeatureFlag(name, active) {
      var queryString = ' \
        mutation UpdateAccountFeatureFlagMutation($name: String!, $active: Boolean!) { \
          updateAccountFeatureFlag(name: $name, active: $active) { \
            id \
            name \
            active \
            createdAt \
          } \
        } \
      ';

      return $http.post(baseUrl, {
        query: queryString,
        variables: {
          name: name,
          active: active
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['updateAccountFeatureFlag'];
        });
    }

    function getCachedFlagByName(name) {
      return new Promise(function (resolve, reject) {
        if (_flags) {
          return resolve(_flags.find(function (flagName) {
            return flagName.name === name;
          }));
        }

        return accountFeatureFlags().then(function (flags) {
          _flags = flags;

          return resolve(flags.find(function (flagName) {
            return flagName.name === name;
          }));
        }).catch(reject);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('vehiclesApi', vehiclesApi);

  function vehiclesApi($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      save: save,
      put: put,
      getOne: getOne,
      search: search,
      searchBrands: searchBrands,
      searchModels: searchModels
    };

    function search(where, orderBy, take, skip) {
      var query = '\
      query VehiclesQuery( \
        $where: VehiclesWhereInput \
        $orderBy: VehiclesOrderByEnum \
        $take: Int \
        $skip: Int \
      ) { \
        vehicles( \
          where: $where, \
          orderBy: $orderBy, \
          take: $take, \
          skip: $skip \
        ) { \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
          items { \
            id \
            name \
            register \
            licensePlate \
            brand { \
              name \
            } \
            model { \
              name \
            } \
            year \
            color \
            status \
            type \
            origin \
            archived \
            pickupForm { \
              id \
              required \
            } \
            returnForm { \
              id \
              required \
            } \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          where: where,
          orderBy: orderBy,
          take: take,
          skip: skip
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['vehicles'];
        });
    }

    function getOne(vehicleId) {
      var query = '\
      query Vehicle($id: ID!) { \
        vehicle(id: $id) { \
          id \
          imageUrl \
          name \
          register \
          licensePlate \
          brand { \
            id \
            name \
          } \
          model { \
            id \
            name \
          } \
          year \
          color \
          status \
          type \
          origin \
          originalTravelingDistance \
          description \
          qrCode \
          archived \
          pickupForm { \
            id \
            required \
          } \
          returnForm { \
            id \
            required \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          id: vehicleId
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['vehicle'];
        });
    }

    function put(vehicle) {
      var query = '\
      mutation UpdateVehicle($input: UpdateVehicleInput!) { \
        updateVehicle(input: $input) { \
          id \
          imageUrl \
          name \
          register \
          licensePlate \
          brand { \
            id \
            name \
          } \
          model { \
            id \
            name \
          } \
          year \
          color \
          status \
          type \
          origin \
          originalTravelingDistance \
          description \
          qrCode \
          archived \
          pickupForm { \
            id \
            required \
          } \
          returnForm { \
            id \
            required \
          } \
        } \
      }';

      var input = {
        id: vehicle.id,
        name: vehicle.name,
        imageUrl: vehicle.imageUrl,
        register: vehicle.register,
        licensePlate: vehicle.licensePlate,
        brandId: vehicle.brand.id,
        modelId: vehicle.model.id,
        year: vehicle.year,
        color: vehicle.color,
        type: vehicle.type,
        origin: vehicle.origin,
        originalTravelingDistance: vehicle.originalTravelingDistance,
        description: vehicle.description,
        qrCode: vehicle.qrCode,
        archived: vehicle.archived,
        pickupForm: vehicle.pickupForm,
        returnForm: vehicle.returnForm
      };

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['updateVehicle'];
        });
    }

    function save(vehicle) {
      var query = '\
        mutation CreateVehicle($input: CreateVehicleInput!) { \
          createVehicle(input: $input) { \
            id \
            imageUrl \
            name \
            register \
            licensePlate \
            brand { \
              id \
              name \
            } \
            model { \
              id \
              name \
            } \
            year \
            color \
            status \
            type \
            origin \
            originalTravelingDistance \
            description \
            qrCode \
            archived \
            pickupForm { \
              id \
              required \
            } \
            returnForm { \
              id \
              required \
            } \
          } \
        }';

      var input = {
        imageUrl: vehicle.imageUrl,
        name: vehicle.name,
        register: vehicle.register,
        licensePlate: vehicle.licensePlate,
        brandId: vehicle.brand.id,
        modelId: vehicle.model.id,
        year: vehicle.year,
        color: vehicle.color,
        type: vehicle.type,
        origin: vehicle.origin,
        originalTravelingDistance: vehicle.originalTravelingDistance,
        description: vehicle.description,
        qrCode: vehicle.qrCode,
        pickupForm: vehicle.pickupForm,
        returnForm: vehicle.returnForm
      };

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['createVehicle'];
        });
    }

    function searchBrands(where) {
      var query = '\
      query VehiclesBrandsQuery ( $where: VehiclesBrandsWhereInput ) { \
        vehiclesBrands (where: $where) { \
          id \
          name \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          where: where
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['vehiclesBrands'];
        });
    }

    function searchModels(where, take, skip) {
      var query = '\
      query VehiclesModelsQuery ( \
        $where: VehiclesModelsWhereInput \
        $skip: Int \
        $take: Int \
      ) { \
        vehiclesModels (where: $where, skip: $skip, take: $take) { \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
          items { \
            id \
            name \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          where: where,
          take: take,
          skip: skip
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['vehiclesModels'];
        });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('vehiclesUsageApi', vehiclesUsageApi);

  function vehiclesUsageApi($http, EnvironmentConfig) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      search: search,
      getOne: getOne,
      put: put,
      vehicleForm: vehicleForm,
      answerVehicleForm: answerVehicleForm
    };

    function search(where, orderBy, take, skip) {
      var query = '\
      query VehiclesUsage ( \
        $where: VehiclesUsageWhereInput \
        $orderBy: VehiclesUsageOrderByEnum \
        $take: Int \
        $skip: Int \
      ) { \
        vehiclesUsage ( \
          where: $where, \
          orderBy: $orderBy, \
          take: $take, \
          skip: $skip \
        ) { \
          pageInfo { \
            hasNextPage \
            hasPreviousPage \
          } \
          totalCount \
          items { \
            id \
            employee { \
              name \
            } \
            user { \
              name \
            } \
            vehicle { \
              name \
              licensePlate \
            } \
            pickupAt \
            pickupTravelingDistance \
            returnedAt \
            duration \
            travelingDistance \
            archived \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          where: where,
          orderBy: orderBy,
          take: take,
          skip: skip
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['vehiclesUsage'];
        });
    }

    function getOne(id) {
      var query = '\
      query VehicleUsage($id: ID!) { \
        vehicleUsage(id: $id) { \
          id \
          employee { \
            id \
            name \
            avatarUrl \
          } \
          user { \
            id \
            name \
            avatarUrl \
          } \
          vehicle { \
            id \
            name \
            pickupForm { \
              id \
              required \
            } \
            returnForm { \
              id \
              required \
            } \
          } \
          pickupAt \
          pickupTravelingDistance \
          pickupDescription \
          pickupImageUrl \
          returnedAt \
          returnedTravelingDistance \
          returnedDescription \
          returnedImageUrl \
          duration \
          travelingDistance \
          archived \
          pickupAnsweredForm { \
            id \
            name \
            questionsCount \
            createdBy \
            createdAt \
          } \
          returnAnsweredForm { \
            id \
            name \
            questionsCount \
            createdBy \
            createdAt \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          id: id
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['vehicleUsage'];
        });
    }

    function vehicleForm(formId, vehicleUsageId, formType) {
      var query = '\
      query VehicleFormAnswer($formId: UUID!, $vehicleUsageId: UUID!, $formType: VehicleFormTypeEnum!) {  \
        vehicleFormAnswer(formId: $formId, vehicleUsageId: $vehicleUsageId, formType: $formType) { \
          id \
          name \
          type \
          questionsCount \
          archived \
          createdAt \
          status \
          questions { \
            id \
            type \
            required \
            position \
            answer \
            title \
            options { \
              id \
              value \
              position \
            } \
            conditions { \
              value \
              operator \
              question { \
                id \
                title \
              } \
            } \
          } \
        } \
      }';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          formId: formId,
          vehicleUsageId: vehicleUsageId,
          formType: formType
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['vehicleFormAnswer'];
        });
    }

    function put(vehicleUsage) {
      var query = '\
      mutation UpdateVehicleUsage($input: UpdateVehicleUsageInput!) { \
        updateVehicleUsage(input: $input) { \
          id \
          employee { \
            id \
            name \
          } \
          vehicle { \
            id \
            name \
          } \
          pickupAt \
          pickupTravelingDistance \
          pickupDescription \
          pickupImageUrl \
          returnedAt \
          returnedTravelingDistance \
          returnedDescription \
          returnedImageUrl \
          duration \
          travelingDistance \
          archived \
          pickupAnsweredForm { \
            name \
            questionsCount \
            createdBy \
            createdAt \
          } \
          returnAnsweredForm { \
            name \
            questionsCount \
            createdBy \
            createdAt \
          } \
        } \
      }';

      var input = {
        id: vehicleUsage.id,
        employeeId: vehicleUsage.employee && vehicleUsage.employee.id,
        userId: vehicleUsage.user && vehicleUsage.user.id,
        vehicleId: vehicleUsage.vehicle.id,
        pickupAt: vehicleUsage.pickupAt,
        pickupTravelingDistance: vehicleUsage.pickupTravelingDistance,
        pickupDescription: vehicleUsage.pickupDescription,
        pickupImageUrl: vehicleUsage.pickupImageUrl,
        returnedAt: vehicleUsage.returnedAt,
        returnedTravelingDistance: vehicleUsage.returnedTravelingDistance,
        returnedDescription: vehicleUsage.returnedDescription,
        returnedImageUrl: vehicleUsage.returnedImageUrl,
        archived: vehicleUsage.archived
      };

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['updateVehicleUsage'];
        });
    }

    function answerVehicleForm(vehicleUsageId, form) {
      var query = '\
      mutation AnswerVehicleForm($input: AnswerVehicleFormInput!) { \
        answerVehicleForm(input: $input) { \
          id \
          name \
          createdAt \
          reference \
          archived \
          status \
          type \
          vehicleUsageId \
          questions { \
            id \
            title \
            answer \
            position \
            required \
            type \
            options { \
              id \
              value \
              position \
            } \
            conditions { \
              value \
              operator \
              question { \
                id \
                title \
              } \
            } \
          } \
        } \
      }';

      var input = {
        formId: form.formId,
        vehicleUsageId: vehicleUsageId,
        type: form.type,
        name: form.name,
        questions: form.questions
      };

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['answerVehicleForm'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('ticketsApi', ticketsApi);

  function ticketsApi($http, EnvironmentConfig, Api, querify) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'tickets');
    var defaultOptions = { headers: { 'cache-control': 'no-cache' } };

    return {
      search: search,
      del: api.delete,
      getAttachments: getAttachments,
      cancel: cancel,
      accept: accept,
      getOne: getOne,
      getCancelationReasons: getCancelationReasons,
      queryForDatatable: queryForDatatable,
      markTicketAsAccepted: markTicketAsAccepted
    };

    function search(query, options) {
      var requestUrl = api.getUrl();
      requestUrl += querify(query, options);
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function queryForDatatable(variables) {
      var query = '\
        query TicketsQuery( \
          $where: TicketsWhereInput \
          $orderBy: TicketsOrderByEnum \
          $take: Int \
          $skip: Int \
        ) { \
          tickets(where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
            pageInfo { \
              hasNextPage \
              hasPreviousPage \
            } \
            totalCount \
            items { \
              id \
              name \
              number \
              identifier \
              message \
              status \
              subject \
              archived \
              acceptedAt \
              canceledAt \
              createdAt \
              expiredAt \
              metadata \
              contact { \
                phone \
                email \
              } \
            } \
          } \
        } \
      ';

      return $http.post(EnvironmentConfig.eyeOfSauron2Url, { query: query, variables: variables }, defaultOptions)
        .then(function (response) {
          return response.data.data.tickets;
        });
    }

    function markTicketAsAccepted(id) {
      var query = '\
        mutation MarkTicketAsAccepted($id: ID!) { \
          markTicketAsAccepted(id: $id) { \
            ticket { \
              id \
              name \
              number \
              identifier \
              message \
              status \
              subject \
              archived \
              createdAt \
              updatedAt \
              acceptedAt \
              canceledAt \
              metadata \
              contact { \
                phone \
                email \
              } \
            } \
          } \
        } \
      ';

      var variables = {
        id: id
      };

      return $http.post(EnvironmentConfig.eyeOfSauron2Url, { query: query, variables: variables }, defaultOptions)
        .then(function (response) {
          return response.data.data.ticket;
        });
    }

    function getAttachments(id) {
      var requestUrl = api.getUrl() + id + '/attachments';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function cancel(id, cancelation) {
      var requestUrl = api.getUrl() + id + '/actions/cancel';
      return $http.put(requestUrl, cancelation).then(api.whenCompleted);
    }

    function accept(id) {
      var requestUrl = api.getUrl() + id + '/actions/accept';
      return $http.put(requestUrl).then(api.whenCompleted);
    }

    function getOne(id) {
      var requestUrl = api.getUrl() + id;
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function getCancelationReasons() {
      var requestUrl = api.getUrl() + 'cancelations/reasons';
      return $http.get(requestUrl).then(api.whenCompleted);
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('tagsApi', tagsApi);

    function tagsApi($http, EnvironmentConfig, Api) {
        var api = new Api($http, EnvironmentConfig.baseUrl, 'tags');
        return {
            searchCustomersTags: searchCustomersTags
        };

        function searchCustomersTags(tagName) {
            var requestUrl = EnvironmentConfig.baseUrl + 'tags/customers?name=' + tagName;
            return $http.get(requestUrl).then(api.whenCompleted);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('servicesApi', servicesApi);

  function servicesApi($http, EnvironmentConfig, Api, querify, msUtils) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'services');
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      getAll: api.getAll,
      get: api.get,
      getOne: getOne,
      save: api.save,
      getEmployees: getEmployees,
      clearEmployees: clearEmployees,
      addSkills: addSkills,
      search: search,
      setForms: setForms,
      updateService: updateService
    };

    function getOne(id, options) {
      var requestUrl = api.getUrl();
      requestUrl += id;
      if (options) {
        requestUrl += '?' + msUtils.qStringify(options);
      }
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function setForms(id, forms) {
      var requestUrl = api.getUrl() + id + '/forms';
      return $http.put(requestUrl, forms).then(api.whenCompleted);
    }

    function getEmployees(id) {
      var requestUrl = api.getUrl() + id + '/employees';
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function clearEmployees(id) {
      var requestUrl = api.getUrl() + id + '/employees';
      return $http.delete(requestUrl).then(api.whenCompleted);
    }

    function addSkills(id, skills) {
      var requestUrl = api.getUrl() + id + '/skills/';
      return $http.post(requestUrl, skills).then(api.whenCompleted);
    }

    function search(query, options) {
      var requestUrl = api.getUrl();
      requestUrl += querify(query, options);
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function updateService(input) {
      var query = '\
        mutation UpdateService($input:UpdateServiceInput!) {\
          updateService(input: $input) {\
            id\
          }\
        }\
      ';

      return $http.post(baseUrl, {
        query: query,
        variables: {
          input: input
        }
      }, { headers: { 'cache-control': 'no-cache' } })
        .then(function (response) {
          return response.data['data']['updateService'];
        });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('routeOptimizationApi', routeOptimizationApi);

    function routeOptimizationApi($http, EnvironmentConfig, Api, querify) {
        var api = new Api($http, EnvironmentConfig.baseUrl, 'route-optimization');
        return {
            create: api.post,
            search: search,
            patchMany: api.patchMany
        };
        function search(query, options) {
            var requestUrl = api.getUrl();
            requestUrl += querify(query, options);
            return $http.get(requestUrl).then(api.whenCompleted);
        }
    }

})();

/**
 * Created by ryuk on 22/03/17.
 */
(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('reportsApi', reportsApi);

    function reportsApi($http, EnvironmentConfig, Api, querify) {

        var api = new Api($http, EnvironmentConfig.baseUrl, 'reports');

        return {
            getReport: getReport
        };

        function getReport(query) {
            var requestUrl = api.getUrl();
            requestUrl += querify(query, {});
            return $http.get(requestUrl).then(api.whenCompleted);
        }
    }

})();
(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('productsServicesApi', productsServicesApi);

  function productsServicesApi($http, EnvironmentConfig, Api, querify, msUtils) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'products-services');

    return {
      search: search,
      getOne: getOne,
      save: api.save,
      put: put
    };

    function search(query, options) {
      var requestUrl = api.getUrl();
      requestUrl += querify(query, options);
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function getOne(id, options) {
      var requestUrl = api.getUrl();
      requestUrl += id;
      if (options) {
        requestUrl += '?' + msUtils.qStringify(options);
      }
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function put(id, productService) {
      var requestUrl = api.getUrl() + id;
      return $http.put(requestUrl, productService).then(api.whenCompleted);
    }
  }
})();


(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('plansTypesApi', plansTypesApi);

    function plansTypesApi($http, EnvironmentConfig, Api, querify, msUtils) {
        var api = new Api($http, EnvironmentConfig.baseUrl, 'plans-types');
        return {
            search: search,
            getOne: getOne,
            save: api.save,
        };

        function getOne(id, options) {
            var requestUrl = api.getUrl();
            requestUrl += id;
            if (options) {
                requestUrl += '?' + msUtils.qStringify(options);
            }
            return $http.get(requestUrl).then(api.whenCompleted);
        }

        function search(query, options) {
            var requestUrl = api.getUrl();
            requestUrl += querify(query, options);
            return $http.get(requestUrl).then(api.whenCompleted);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('permissionsApi', permissionsApi);

    function permissionsApi($http, EnvironmentConfig, Api) {
        var api = new Api($http, EnvironmentConfig.baseUrl, 'permissions');
        return {
            getAll: api.getAll
        };
    }
})();

(function () {
  'use strict';

  angular.module('app.core.api').factory('orderLocationSectorApi', orderLocationSectorApi);

  function orderLocationSectorApi($http, EnvironmentConfig, $q) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      save: save,
    };

    function save(queryParams) {
      var queryString =
        '\
      mutation saveOrderLocationSector($input: SaveOrderLocationSectorInput!) { \
        saveOrderLocationSector (input: $input) { \
          id \
          order { \
            id \
          } \
          locationSector { \
            id \
          } \
          createdAt \
        } \
      } \
    ';

      return $http
        .post(
          baseUrl,
          {
            query: queryString,
            variables: { input: queryParams },
          },
          { headers: { 'cache-control': 'no-cache' } }
        )
        .then(function (response) {
          return response.data['data']['saveOrderLocationSector'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core.api').factory('orderLocationEnvironmentApi', orderLocationEnvironmentApi);

  function orderLocationEnvironmentApi($http, EnvironmentConfig, $q) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      save: save,
    };

    function save(queryParams) {
      var queryString =
        '\
      mutation saveOrderLocationEnvironment($input: SaveOrderLocationEnvironmentInput!) { \
        saveOrderLocationEnvironment (input: $input) { \
          id \
          order { \
            id \
          } \
          locationEnvironment { \
            id \
          } \
          createdAt \
        } \
      } \
    ';

      return $http
        .post(
          baseUrl,
          {
            query: queryString,
            variables: { input: queryParams },
          },
          { headers: { 'cache-control': 'no-cache' } }
        )
        .then(function (response) {
          return response.data['data']['saveOrderLocationEnvironment'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core.api').factory('orderEquipmentApi', orderEquipmentApi);

  function orderEquipmentApi($http, EnvironmentConfig, $q) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      save: save,
    };

    function save(queryParams) {
      var queryString =
        '\
      mutation saveOrderEquipment($input: SaveOrderEquipmentInput!) { \
        saveOrderEquipment (input: $input) { \
          id \
          order { \
            id \
          } \
          equipment { \
            id \
          } \
          createdAt \
        } \
      } \
    ';

      return $http
        .post(
          baseUrl,
          {
            query: queryString,
            variables: { input: queryParams },
          },
          { headers: { 'cache-control': 'no-cache' } }
        )
        .then(function (response) {
          return response.data['data']['saveOrderEquipment'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('materialsApi', materialsApi);

  function materialsApi($http, EnvironmentConfig, Api, querify) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'materials');
    return {
      save: api.save,
      search: search,
      get: getOne,
      migrateMaterialsToProducts: migrateMaterialsToProducts
    };

    function search(query, options) {
      var requestUrl = api.getUrl();
      requestUrl += querify(query, options);
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function getOne(id, options) {
      var requestUrl = api.getUrl();
      requestUrl += id;

      if (options) {
        requestUrl += '?' + msUtils.qStringify(options);
      }
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function migrateMaterialsToProducts() {
      var query = ' \
      mutation MigrateMaterialsToProductsMutation { \
        migrateMaterialsToProducts { \
          messageId \
        } \
      }';

      return $http.post(EnvironmentConfig.eyeOfSauron2Url, { query: query });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core.api').factory('locationSectorsApiGraphQL', locationSectorsApiGraphQL);

  function locationSectorsApiGraphQL($http, EnvironmentConfig, $q) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      search: search,
    };

    function search(queryParams) {
      var queryString =
        ' \
        query LocationSectorsQuery ( \
          $where: LocationSectorsWhereInput \
          $orderBy: LocationSectorsOrderByEnum \
          $take: Int \
          $skip: Int \
        ) { \
          locationSectors (where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
            pageInfo { \
              hasNextPage \
              hasPreviousPage \
            } \
            totalCount \
            items { \
              id \
              name \
              description \
              archived \
              location { \
                id \
                name \
              } \
              locationEnvironments { \
                id \
                name \
              } \
              createdAt \
            } \
          } \
        } \
      ';

      return $http
        .post(
          baseUrl,
          {
            query: queryString,
            variables: queryParams,
          },
          { headers: { 'cache-control': 'no-cache' } }
        )
        .then(function (response) {
          return response.data['data']['locationSectors'];
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core.api').factory('locationEnvironmentsApiGraphQL', locationEnvironmentsApiGraphQL);

  function locationEnvironmentsApiGraphQL($http, EnvironmentConfig, $q) {
    var baseUrl = EnvironmentConfig.eyeOfSauron2Url;

    return {
      search: search,
    };

    function search(queryParams) {
      var queryString =
        ' \
        query LocationEnvironmentsQuery ( \
          $where: LocationEnvironmentsWhereInput \
          $orderBy: LocationEnvironmentsOrderByEnum \
          $take: Int \
          $skip: Int \
        ) { \
          locationEnvironments (where: $where, orderBy: $orderBy, take: $take, skip: $skip) { \
            pageInfo { \
              hasNextPage \
              hasPreviousPage \
            } \
            totalCount \
            items { \
              id \
              name \
              qrCode \
              description \
              location { \
                name \
              } \
              locationSector { \
                id \
                name \
              } \
              archived \
              createdAt \
            } \
          } \
        } \
      ';

      return $http
        .post(
          baseUrl,
          {
            query: queryString,
            variables: queryParams,
          },
          { headers: { 'cache-control': 'no-cache' } }
        )
        .then(function (response) {
          return response.data['data']['locationEnvironments'];
        });
    }
  }
})();

(function () {
  'use strict';

    angular
        .module('app.core.api')
        .factory('labelsApi', labelsApi);

        function labelsApi($http, EnvironmentConfig, Api, msUtils, querify) {

          var defaultOptions = { headers: { 'cache-control': 'no-cache' } };
          var api = new Api($http, EnvironmentConfig.baseUrl, 'labels');
        return {
            save: api.save,
            getAll: api.getAll,
            get: getOne,
            search: search,
            delete: api.delete,
            create: create
        };

        function getOne(id, options) {
            var requestUrl = api.getUrl();
            requestUrl += id;
            if (options) {
                requestUrl += '?' + msUtils.qStringify(options);
            }
            return $http.get(requestUrl).then(api.whenCompleted);
        }

        function search(query, options) {
            var requestUrl = api.getUrl();
            requestUrl += querify(query, options);
            return $http.get(requestUrl).then(api.whenCompleted);
        }

        function create(variables) {
          var mutation = 'mutation CreateLabelMutation($input: CreateLabelInput!) { \
              createLabel (input: $input) { \
                id \
                name \
                type \
                color \
              } \
            } \
          ';
          var options = angular.copy(defaultOptions);
          return $http.post(EnvironmentConfig.eyeOfSauron2Url, {
            query: mutation,
            variables: variables
          }, options)
            .then(function (response) {
              return response.data.data.setLabels;
            });
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('formsApi', formsApi);

  function formsApi($http, EnvironmentConfig, Api, msUtils, querify) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'forms');
    return {
      get: getOne,
      save: api.save,
      search: search,
      searchGraphql: searchGraphql
    };

    function getOne(id, options) {
      var requestUrl = api.getUrl();
      requestUrl += id;
      if (options) {
        requestUrl += '?' + msUtils.qStringify(options);
      }
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function getModels() {
      /**@todo criar API eyeofsauron */
      var formModels = '/app/data/forms/form-models.json';

      return $http.get(formModels).then(api.whenCompleted);
    }

    function delServices(id) {
      var requestUrl = api.getUrl();
      requestUrl += id + '/services';
      return $http.delete(requestUrl).then(api.whenCompleted);
    }

    function search(query, options) {
      var requestUrl = api.getUrl();
      requestUrl += querify(query, options);
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function searchGraphql(input) {
      var query = '\
        query FormsQuery( \
          $where: FormsWhereInput \
          $orderBy: FormsOrderByEnum \
          $take: Int \
          $skip: Int \
        ) { \
          forms( \
            where: $where \
            orderBy: $orderBy \
            take: $take \
            skip: $skip \
          ) { \
            pageInfo { \
              hasNextPage \
              hasPreviousPage \
            } \
            totalCount \
            items { \
              id \
              name \
              archived \
              questionsCount \
              type \
              metadata \
              questions { \
                id \
                type \
                title \
                required \
                position \
                options { \
                  id \
                  value \
                  position \
                  score \
                  description \
                } \
                conditions { \
                  value \
                  operator \
                  question { \
                    id \
                    title \
                  } \
                  condition \
                } \
              } \
              required { \
                complete \
                report \
              } \
              createdAt \
              updatedAt \
              locked \
            } \
          } \
        } \
      ';

      var url = EnvironmentConfig.eyeOfSauron2Url;

      return $http.post(url, {
        query: query,
        variables: {
          where: input.where,
          orderBy: input.orderBy,
          take: input.take,
          skip: input.skip
        }
      }, { headers: { 'cache-control': 'no-cache' } }).then(function (response) {
        return response.data['data']['forms'];
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('exportsApi', exportsApi);

  function exportsApi($http, EnvironmentConfig, Api, querify, $q) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'exports', null, querify, $q);
    var defaultOptions = { headers: { 'cache-control': 'no-cache' } };

    return {
      search: search,
      exportFeature: exportFeature,
      verifyPdfReportStatus: verifyPdfReportStatus
    };

    function search(query, options) {
      var requestUrl = api.getUrl();
      requestUrl += querify(query, options);
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function verifyPdfReportStatus(variables) {
      var query = '\
        query ExportsQuery ($id: ID!) { \
          export (id: $id) { \
            id \
            status \
            link \
          } \
        } \
      ';
      return $http.post(EnvironmentConfig.eyeOfSauron2Url, { query: query, variables: variables }, defaultOptions)
        .then(function (response) {
          var data = response.data && response.data.data;
          return data || null;
        });
    }

    function exportFeature(feature, searchOptions, userSettings) {
      var requestUrl = api.getUrl() + feature;

      return $http.post(requestUrl, {
        q: searchOptions.q,
        graphQL: searchOptions.graphQL,
        userSettings: userSettings
      }).then(api.whenCompleted);
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('equipmentTypesApi', equipmentsApi);

    function equipmentsApi($http, EnvironmentConfig, Api, msUtils, querify) {

        var api = new Api($http, EnvironmentConfig.baseUrl, 'equipment-types');

        return {
            getEquipmentTypes: getEquipmentTypes,
            getOneEquipmentType: getOneEquipmentType,
            saveEquipmentType: saveEquipmentType,
            getCustomFieldFromEquipmentType: getCustomFieldFromEquipmentType,
            saveCustomFieldQuestions: saveCustomFieldQuestions,
            setForms: setForms,
            search: search
        };

        function getEquipmentTypes(query, options) {
            var requestUrl = api.getUrl();
            query = query || {};
            options = options || {};
            options.limit = 1000;
            requestUrl += querify(query, options);
            return $http.get(requestUrl).then(api.whenCompleted);
        }

        function getOneEquipmentType(id, options) {
            var requestUrl = api.getUrl();
            requestUrl += id;
            if (options) {
                requestUrl += '?' + msUtils.qStringify(options);
            }
            return $http.get(requestUrl).then(api.whenCompleted);
        }

        function getCustomFieldFromEquipmentType(equipmentTypeId) {
            var requestUrl = api.getUrl() + equipmentTypeId + '/custom-fields?limit=1000';
            return $http.get(requestUrl).then(api.whenCompleted);
        }

        function saveCustomFieldQuestions(equipmentTypeId, customFieldQuestionArray) {
            var requestUrl = api.getUrl() + equipmentTypeId + '/custom-fields';
            return $http.put(requestUrl, customFieldQuestionArray).then(api.whenCompleted);
        }

        function saveEquipmentType(equipmentType) {
            if (equipmentType.id) {
                var requestUrl = api.getUrl() + '/' + equipmentType.id;
                return $http.put(requestUrl, equipmentType).then(api.whenCompleted);
            } else {
                var requestUrl = api.getUrl();
                return $http.post(requestUrl, equipmentType).then(api.whenCompleted);
            }
        }

        function setForms(id, forms) {
            var requestUrl = api.getUrl()  + id + '/forms';
            return $http.put(requestUrl, forms).then(api.whenCompleted);
        }

        function search(query, options) {
            var requestUrl = api.getUrl();
            requestUrl += querify(query, options);
            return $http.get(requestUrl).then(api.whenCompleted);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('deadlineViolationsReasonsApi', deadlineViolationsReasonsApi);

  function deadlineViolationsReasonsApi($http, EnvironmentConfig, Api, querify, msUtils) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'deadline-violations-reasons');

    function search(query, options) {
      var requestUrl = api.getUrl();
      requestUrl += querify(query, options);
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function getOne(id, options) {
      var requestUrl = api.getUrl();
      requestUrl += id;
      if (options) {
        requestUrl += '?' + msUtils.qStringify(options);
      }
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    return {
      search: search,
      getOne: getOne,
      save: api.save
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('deadlineContractsApi', deadlineContractsApi);

  function deadlineContractsApi($http, EnvironmentConfig, Api, querify, msUtils) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'deadline-contracts');

    function search(query, options) {
      var requestUrl = api.getUrl();
      requestUrl += querify(query, options);
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    function getOne(id, options) {
      var requestUrl = api.getUrl();
      requestUrl += id;
      if (options) {
        requestUrl += '?' + msUtils.qStringify(options);
      }
      return $http.get(requestUrl).then(api.whenCompleted);
    }

    return {
      search: search,
      getOne: getOne,
      save: api.save
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('accountsApi', accountsApi);

  function accountsApi($http, EnvironmentConfig, Api) {
    var api = new Api($http, EnvironmentConfig.baseUrl, 'accounts');
    var _account;

    return {
      create: api.save,
      patch: function (resource) {
        return $http.patch(api.getUrl(), resource).then(api.whenCompleted);
      },
      saveConfigurations: function (configuration) {
        return $http.post(api.getUrl() + 'actions/configure', configuration).then(api.whenCompleted);
      },
      get: function () {
        return $http.get(api.getUrl()).then(api.whenCompleted);
      },
      getCachedAccount: function () {
        return new Promise(function (resolve, reject) {
          if (_account) {
            return resolve(_account);
          }

          return $http.get(api.getUrl())
            .then(api.whenCompleted)
            .then(function (account) {
              _account = account;

              return resolve(account);
            })
            .catch(function (err) {
              return reject(err);
            });
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('ereborApi', ereborApi);

  function ereborApi($http, EnvironmentConfig, Api) {
    var api = new Api($http, EnvironmentConfig.ereborBaseUrl);
    var defaultOptions = { headers: { 'cache-control': 'no-cache' } };
    var testMode = EnvironmentConfig.environmentName !== 'production';

    return {
      getCurrentSubscription: getCurrentSubscription,
      getSubscriptionRenewalItems: getSubscriptionRenewalItems,
      isPendingSubscriptionRenewal: isPendingSubscriptionRenewal,
      getPendingSubscriptionRenewal: getPendingSubscriptionRenewal,
      getSubscriptionContracts: getSubscriptionContracts,
      updateCurrentSubscriptionEmails: updateCurrentSubscriptionEmails,
      createSubscriptionRenewalInvoice: createSubscriptionRenewalInvoice,
      getProRata: getProRata,
      getPaymentMethods: getPaymentMethods,
      savePaymentMethod: savePaymentMethod,
      chargeSubscription: chargeSubscription,
    };

    function updateCurrentSubscriptionEmails(id, emails) {
      var data = {
        query: '\
          mutation updateCurrentSubscriptionEmails($input: SubscriptionInput!) { \
            updateCurrentSubscriptionEmails(input: $input) { \
              emails \
            } \
          } \
        ',
        variables: {
          input: {
            id: id,
            emails: emails
          }
        }
      };

      return $http.post(api.getUrl(), data, defaultOptions)
        .then(function (response) {
          if (response.data.data) {
            return response.data.data.updateCurrentSubscriptionEmails;
          }
          return null;
        });
    }

    function getPendingSubscriptionRenewal() {
      var query = '\
        query PendingSubscriptionRenewal { \
          pendingSubscriptionRenewal { \
            invoice { \
              url \
            } \
          } \
        } \
      ';

      return $http.post(api.getUrl(), { query: query }, defaultOptions)
        .then(function (response) {
          if (response.data.data) {
            return response.data.data.pendingSubscriptionRenewal;
          }
          return null;
        });
    }

    function getCurrentSubscription() {
      var query = '\
        query CurrentSubscription { \
          currentSubscription { \
            id \
            type \
            renewAt \
            totalValue \
            emails \
            contracts { \
              isSignedContract \
            } \
            items { \
              feature \
              value \
              quantity \
              totalValue \
            } \
          } \
        } \
      ';

      return $http.post(api.getUrl(), { query: query }, defaultOptions)
        .then(function (response) {
          if (response.data.data) {
            return response.data.data.currentSubscription;
          }
          return null;
        });
    }

    function getSubscriptionRenewalItems() {
      var query = '\
        query CurrentSubscriptionRenewalItems { \
          currentSubscriptionRenewalItems { \
            feature \
            quantity \
            value \
            totalValue \
          } \
        } \
      ';

      return $http.post(api.getUrl(), { query: query }, defaultOptions)
        .then(function (response) {
          if (response.data.data) {
            return response.data.data.currentSubscriptionRenewalItems;
          }
          return null;
        });
    }

    function isPendingSubscriptionRenewal() {
      var query = '\
        query PendingSubscriptionRenewal { \
          pendingSubscriptionRenewal { \
            id \
          } \
        } \
      ';

      return $http.post(api.getUrl(), { query: query }, defaultOptions)
        .then(function (response) {
          if (response.data.data) {
            return !!response.data.data.pendingSubscriptionRenewal;
          }
          return null;
        });
    }

    function getSubscriptionContracts(where, orderBy) {
      var query = '\
        query SubscriptionContractsQuery($where: SubscriptionContractWhereInput, $orderBy: SubscriptionContractOrderByInput) { \
          subscriptionContracts(where: $where, orderBy: $orderBy) { \
            id \
            name \
            filePath \
            type \
            startDate \
            endDate \
            archived \
            createdAt \
            isSignedContract \
            contractId \
          } \
        } \
      ';

      return $http.post(api.getUrl(), {
        query: query,
        variables: {
          where: where,
          orderBy: orderBy
        }
      }, defaultOptions).then(function (response) {
        if (response.data.data) {
          return response.data.data.subscriptionContracts;
        }
        return null;
      });
    }

    function createSubscriptionRenewalInvoice() {
      var query = '\
        mutation CreateSubscriptionRenewalInvoice { \
          createSubscriptionRenewalInvoice { \
            status \
            invoice { \
              dueAt \
              paidAt \
              url \
              items \
              metadata \
              createdAt \
            } \
          } \
        } \
      ';

      return $http.post(api.getUrl(), { query: query }, defaultOptions)
        .then(function (response) {
          if (response.data.data) {
            return response.data.data.createSubscriptionRenewalInvoice;
          }
          return null;
        });
    }

    function getProRata(modules) {
      var query = '\
        query proRataQuery ($modules: [ModuleInput!]!) { \
          proRata (modules: $modules) { \
            daysLeft \
            totalValue \
            modules { \
              name \
              monthlyValue \
              dailyValue \
              quantity \
              totalValue \
            } \
            subscription { \
              id \
              type \
              renewAt \
              totalValue \
            } \
          } \
        } \
      ';

      return $http.post(api.getUrl(), {
        query: query,
        variables: {
          modules: modules
        }
      }, defaultOptions)
        .then(function (response) {
          if (response.data.data) {
            return response.data.data.proRata;
          }
          return null;
        });
    }

    function getPaymentMethods() {
      var query = '\
        query paymentMethodsQuery { \
          paymentMethods { \
            id \
            type \
            default \
            description\
            paymentMethodId \
            data \
          } \
        } \
      ';

      return $http.post(api.getUrl(), { query: query }, defaultOptions)
        .then(function (response) {
          if (response.data.data) {
            return response.data.data.paymentMethods;
          }
          return null;
        });
    }

    function savePaymentMethod(inputs) {
      var query = '\
        mutation savePaymentMethodMutation($input: SavePaymentMethodInput!) { \
          savePaymentMethod(input: $input) { \
            id \
            type \
            default \
            description \
            paymentMethodId \
            data \
            updatedAt \
            createdAt \
          } \
        } \
      ';

      return $http.post(api.getUrl(), {
        query: query,
        variables: {
          input: {
            token: inputs.token,
            default: inputs.default,
            saveRenewalAutomatic: inputs.saveRenewalAutomatic,
            test: testMode
          }
        }
      }, defaultOptions)
        .then(function (response) {
          if (response.data.data) {
            return response.data.data.savePaymentMethod;
          }
          return null;
        });
    }

    function chargeSubscription(paymentMethod, numberOfInstallments, modules) {
      var query = '\
        mutation chargeSubscriptionMutation($input: ChargeSubscriptionInput!) { \
          chargeSubscription(input: $input) { \
            id \
            invoices { \
              id \
              invoiceId \
              value \
              numberOfInstallments \
              items \
            } \
            status \
            user \
            description \
            link \
            type \
            totalValue \
            updatedAt \
            createdAt \
          } \
        } \
      ';

      return $http.post(api.getUrl(), {
        query: query,
        variables: {
          input: {
            paymentMethodId: paymentMethod.id,
            numberOfInstallments: numberOfInstallments || 1,
            modules: modules,
            test: testMode
          }
        }
      }, defaultOptions)
        .then(function (response) {
          if (response.data.data) {
            return response.data.data.chargeSubscription;
          }
          return null;
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('dolguldur2Api', dolguldur2Api);

  function dolguldur2Api($http, EnvironmentConfig) {

    return {
      accept: accept
    };

    function accept(id) {
      var requestUrl = EnvironmentConfig.dolguldur2Url + "tickets/actions/accept";
      return $http.post(requestUrl, { 'id': id }).then(function (response) {
        return response.data;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('dolguldurApi', dolguldurApi);

  function dolguldurApi($http, EnvironmentConfig) {

    return {
      accept: accept
    };

    function accept(identifier) {
      var requestUrl = EnvironmentConfig.dolguldurUrl + "service-requests/actions/accept";
      return $http.post(requestUrl, { 'identifier': identifier }).then(function (response) {
        return response.data;
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('webhookApi', webhookApi);

    function webhookApi($http, EnvironmentConfig, Api) {
        var api = new Api($http, EnvironmentConfig.integrationBaseUrl, 'webhooks');
        return {
            get: api.getAll,
            create: api.post,
            delete: api.delete,
            getResponses: getResponses
        };

        function getResponses(id, nextToken) {
            var requestUrl = api.getUrl() + id + '/responses';
            if (nextToken) {
                requestUrl += '?nextToken=' + nextToken;
            }
            return $http.get(requestUrl).then(api.whenCompleted);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('apiKeyIntegrationApi', apiKeyIntegrationApi);

    function apiKeyIntegrationApi($http, EnvironmentConfig, Api) {
        var api = new Api($http, EnvironmentConfig.integrationBaseUrl, 'api-keys');
        return {
            get: api.getAll,
            create: api.post,
            delete: api.delete
        };
    }
})();

(function () {
  'use strict';

  angular.module('app.core.api').factory('devicesApi', devicesApi);

  function devicesApi($http, EnvironmentConfig, Api, querify) {
    var api = new Api($http, EnvironmentConfig.blackgateUrl, 'devices');
    return {
      search: function (query, options) {
        var requestUrl = api.getUrl();
        requestUrl += querify(query || {}, options || {});
        return $http.get(requestUrl).then(api.whenCompleted);
      },

      delete: function (id) {
        var requestUrl = api.getUrl() + id;
        return $http.delete(requestUrl).then(api.whenCompleted);
      },

      deleteAll: function () {
        var requestUrl = api.getUrl();
        requestUrl = requestUrl.replace(/\/+$/, '');
        return $http.delete(requestUrl);
      },
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('authApi', authApi);

  function authApi($http, EnvironmentConfig, Api) {
    var api = new Api($http, EnvironmentConfig.blackgateUrl, 'auth');
    return {
      adminUpdatePassword: function (username, password) {
        var requestUrl = api.getUrl() + 'admin-update-password';
        return $http.put(requestUrl, { username: username, newPassword: password }).then(api.whenCompleted);
      },
      inviteUser: function (email) {
        var requestUrl = api.getUrl() + 'invite-user';
        return $http.post(requestUrl, { email: email }).then(api.whenCompleted);
      },
      generatePassword: function (email) {
        var requestUrl = api.getUrl() + 'generate-new-temp-password';
        return $http.put(requestUrl, { email: email }).then(api.whenCompleted);
      },
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core.api')
    .factory('siteApi', siteApi);

  function siteApi($http, Api, EnvironmentConfig) {
    return {
      scheduleDemo: scheduleDemo,
      requestModuleActivation: requestModuleActivation
    };

    function scheduleDemo(formOptions) {
      var api = new Api($http, EnvironmentConfig.baraddurUrl);

      var payload = {
        formId: '40',
        utm: {
          source: 'painel-do-gestor',
          medium: 'button',
          campaign: 'schedule-demo'
        },
        contact: {
          name: formOptions.name,
          email: formOptions.email,
          phone: formOptions.phone,
          customer_account: formOptions.accountName
        },
        language: formOptions.language,
        recaptcha: '39705978-eb22-493c-b06c-c18ee3150bac'
      };

      return $http.post(api.getUrl() + 'forms', payload).then(api.whenCompleted);
    }

    function requestModuleActivation(formOptions) {
      var api = new Api($http, EnvironmentConfig.baraddurUrl);

      var payload = {
        formId: '82',
        contact: {
          name: formOptions.name,
          email: formOptions.email,
          customer_account: formOptions.accountName
        },
        fieldOptions: [
          { option: '123', value: moduleMapper(formOptions.module) }
        ],
        language: formOptions.language,
        recaptcha: '39705978-eb22-493c-b06c-c18ee3150bac'
      };

      if (formOptions.quantity) {
        payload.fieldOptions.push({ option: '146', value: formOptions.quantity });
      }

      return $http.post(api.getUrl() + 'forms', payload).then(api.whenCompleted);
    }

    function moduleMapper(module) {
      switch (module) {
        case 'route-optimizer': return 'Roteirização';
        case 'equipments': return 'Controle de Equipamentos';
        case 'image-resolution': return 'Qualidade de Fotos';
        case 'video': return 'Video';
        case 'customer-area': return 'Area do cliente';
        case 'technician-app': return 'Licença';
        case 'vehicles': return 'Veículos';
        case 'deadlines': return 'Prazos';
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('trackingApi', trackingApi);

    function trackingApi($http, EnvironmentConfig, Api) {
        var api = new Api($http, EnvironmentConfig.locationsBaseUrl, 'tracking');
        return {
            createTracking: api.save
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core.api')
        .factory('locationsApi', locationsApi);

    function locationsApi($http, EnvironmentConfig, Api) {
        var api = new Api($http, EnvironmentConfig.locationsBaseUrl, 'locations');
        return {
            getLastedLocations: function () {
                var requestUrl = api.getUrl() + 'lasted';
                return $http.get(requestUrl, { timeout: 7000 }).then(api.whenCompleted);
            },
            getRouteHistory: function (employeeId, date) {
                var requestUrl = api.getUrl() + employeeId + '/route-history/' + date;
                return $http.get(requestUrl).then(api.whenCompleted);
            }
        };
    }
})();

(function () {
  'use strict';

  angular.module('app.vehicles-usage')
    .factory('vehiclesUsageService', vehiclesUsageService);

  /** @ngInject */
  function vehiclesUsageService(moment, uploadApi, $translate, $mdToast) {

    function separateDateAndTime(dateAndTime) {
      var date = new Date(dateAndTime);
      var time = moment(dateAndTime).format('HH:mm');

      return [date, time];
    }

    function groupDateAndTime(date, time) {
      var formattedDate = moment(date).format('YYYY-MM-DD');
      var correctFormat = moment(formattedDate + 'T' + time).toJSON();

      return correctFormat;
    }

    function compareHoursAndMinutes(hoursAndMinutes, timeToCompare, comparisonType) {
      comparisonType = comparisonType ? comparisonType : 'isAfter';
      var hoursAndMinutesToCompare = new Date('1/1/1999 ' + hoursAndMinutes + ':00');
      var timeToCompare = new Date('1/1/1999 ' + timeToCompare + ':00');
      var comparisonsMapper = {
        'isAfter': hoursAndMinutesToCompare > timeToCompare,
        'isAfterOrEqual': hoursAndMinutesToCompare >= timeToCompare
      };

      return comparisonsMapper[comparisonType];
    }

    function imageUpload(filename, image, callback) {
      uploadApi.uploadWithPreSignedPost({ file: image, filePath: filename }, null)
        .then(function (result) {
          callback(result);
        })
        .catch(_vehicleImageSaveError);
    }

    function _vehicleImageSaveError() {
      $mdToast.show(
        $mdToast.simple()
          .textContent($translate.instant('VEHICLES_USAGE.TOAST.ERRORS.IMAGE_UPLOAD'))
          .hideDelay(3000)
      );
    }

    return {
      separateDateAndTime: separateDateAndTime,
      groupDateAndTime: groupDateAndTime,
      imageUpload: imageUpload,
      compareHoursAndMinutes: compareHoursAndMinutes
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.vehicles-usage')
    .factory('VehiclesUsageDialog', VehiclesUsageDialog);

  /** @ngInject */
  function VehiclesUsageDialog($mdDialog, $rootScope, $document, vehiclesUsageApi) {

    return {
      editVehicleUsage: editVehicleUsage
    };

    function editVehicleUsage(ev, id, callback) {
      $rootScope.loadingProgress = true;

      vehiclesUsageApi.getOne(id)
        .then(function (vehicleUsage) {
          _openDialog(ev, {
            VehicleUsage: vehicleUsage
          }, callback);
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function _openDialog(ev, locals, callback) {
      $mdDialog
        .show({
          controller: 'VehiclesUsageDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/vehicles-usage/dialogs/vehicle-usage-dialog.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          locals: locals,
          closeTo: {
            top: 0,
            left: window.innerWidth,
            width: window.innerWidth,
            height: window.innerHeight / 1.8
          }
        })
        .then(function (reload) {
          if (callback) {
            callback(reload);
          }
        });
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.vehicles-usage')
    .controller('VehiclesUsageDialogController', VehiclesUsageDialogController);

  /** @ngInject */
  function VehiclesUsageDialogController(
    $rootScope, _, VehicleUsage, msUtils,
    $mdToast, $mdDialog, $translate, $locale,
    employeesApi, vehiclesUsageApi, vehiclesUsageService,
    usersApi, translateService, $document, $q, LocalDateConvert
  ) {

    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    var vm = this;

    vm.language = translateService.getLanguage() || 'pt';
    vm.vehicleUsage = null;
    vm.pickupImage = null;
    vm.returnImage = null;
    vm.pickupDate = null;
    vm.pickupTime = null;
    vm.returnDate = null;
    vm.returnTime = null;
    vm.timeFormatIsActive = vm.language === 'en';
    vm.pickupTimeFormat = '';
    vm.returnTimeFormat = '';
    vm.timeFormats = [{ translate: 'AM', value: 'am' }, { translate: 'PM', value: 'pm' }];
    vm.updatePickupTimeFormat = updatePickupTimeFormat;
    vm.updateReturnTimeFormat = updateReturnTimeFormat;

    vm.pickedBy = null;
    vm.today = moment().toDate();
    vm.employees = [];
    vm.avatarUrl = '';
    vm.defaultAvatarUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg';
    vm.employeesUsers = [];

    _initialize();

    vm.closeDialog = closeDialog;
    vm.checkTimes = checkTimes;
    vm.checkDates = checkDates;
    vm.checkTravelingDistance = checkTravelingDistance;
    vm.checkReturnTime = checkReturnTime;
    vm.saveVehicleUsage = saveVehicleUsage;
    vm.archiveVehicleUsage = archiveVehicleUsage;
    vm.unarchiveVehicleUsage = unarchiveVehicleUsage;
    vm.onChangePickedBy = onChangePickedBy;
    vm.editVehicleUsageFormAnswers = editVehicleUsageFormAnswers;
    vm.hasAllImages = hasAllImages;

    function _initialize() {
      loadEmployees();
      loadUsers();
      loadVehicleUsage();
    }

    function loadEmployees() {
      var params = {
        where: {
          active: true
        },
        take: 10000
      };

      employeesApi.search(params)
        .then(function (result) {
          var activeEmployees = _.filter(result.items, 'contract.active');
          vm.employees = _.map(activeEmployees, function (employee) {
            var employeeValues = { id: employee.id, name: employee.name, avatarUrl: employee.avatarUrl, isEmployee: true };
            return { translate: employee.name + $translate.instant('VEHICLES_USAGE.DIALOG.EMPLOYEE'), value: employeeValues };
          });
          _.forEach(vm.employees, function (employee) {
            vm.employeesUsers.push(employee);
          });

          vm.employeesUsers = _.sortBy(vm.employeesUsers, 'name');
        });

    }

    function loadUsers() {
      usersApi.search({ take: 100 })
        .then(function (result) {
          var users = result.items;
          users = _.map(users, function (user) {
            var userValues = { id: user.id, name: user.name, avatarUrl: user.avatarUrl, isEmployee: false };
            return { translate: user.name + $translate.instant('VEHICLES_USAGE.DIALOG.USER'), value: userValues };
          });
          _.forEach(users, function (user) {
            vm.employeesUsers.push(user);
          });

          vm.employeesUsers = _.sortBy(vm.employeesUsers, 'name');
        });

    }

    function loadVehicleUsage() {
      vm.vehicleUsage = angular.copy(VehicleUsage);

      if (vm.vehicleUsage) {
        var hasUser = !!vm.vehicleUsage.user;
        var currentPickedByValue = hasUser ? vm.vehicleUsage.user : vm.vehicleUsage.employee;
        currentPickedByValue.isEmployee = hasUser ? false : true;
        vm.pickedBy = currentPickedByValue;

        if (vm.vehicleUsage.duration) {
          var currentLanguage = translateService.getLanguage();
          if (!currentLanguage) {
            currentLanguage = 'pt-br';
          }

          vm.vehicleUsage.duration = moment.duration(vm.vehicleUsage.duration, 'milliseconds').locale(currentLanguage).humanize();
          vm.vehicleUsage.duration = ['segundos'].includes(vm.vehicleUsage.duration) ? '1 minuto' : vm.vehicleUsage.duration;
        }

        if (vm.vehicleUsage.pickupAt) {
          var pickupDateAndTime = vehiclesUsageService.separateDateAndTime(vm.vehicleUsage.pickupAt);
          vm.pickupDate = pickupDateAndTime[0];
          vm.pickupTime = pickupDateAndTime[1];

          if (vm.timeFormatIsActive) {
            vm.pickupTimeFormat = moment(vm.pickupTime, 'HH:mm').format('a');
            vm.pickupTime = LocalDateConvert.convertTimeToShow(vm.pickupTime);
          }
        }

        if (vm.vehicleUsage.returnedAt) {
          var returnDateAndTime = vehiclesUsageService.separateDateAndTime(vm.vehicleUsage.returnedAt);
          vm.returnDate = returnDateAndTime[0];
          vm.returnTime = returnDateAndTime[1];

          if (vm.timeFormatIsActive) {
            vm.returnTimeFormat = moment(vm.returnTime, 'HH:mm').format('a');
            vm.returnTime = LocalDateConvert.convertTimeToShow(vm.returnTime);
          }
        }

        if (vm.vehicleUsage.returnAnsweredForm && vm.vehicleUsage.returnAnsweredForm.createdAt) {
          vm.vehicleUsage.returnAnsweredForm.createdAt = LocalDateConvert.formatDate(vm.vehicleUsage.returnAnsweredForm.createdAt, 'date-time');
        }

        if (vm.vehicleUsage.pickupAnsweredForm && vm.vehicleUsage.pickupAnsweredForm.createdAt) {
          vm.vehicleUsage.pickupAnsweredForm.createdAt = LocalDateConvert.formatDate(vm.vehicleUsage.pickupAnsweredForm.createdAt, 'date-time');
        }

        if (vm.vehicleUsage.pickupImageUrl) {
          vm.pickupImage = vm.vehicleUsage.pickupImageUrl;
        }

        if (vm.vehicleUsage.returnedImageUrl) {
          vm.returnImage = vm.vehicleUsage.returnedImageUrl;
        }
      }
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function checkTimes() {
      var currentTime = moment().format('HH:mm');
      var todayMomentDateToCompare = moment().format('DD/MM/YYYY');

      var pickupDateToCompare = moment(vm.pickupDate).format('DD/MM/YYYY');
      var returnDateToCompare = moment(vm.returnDate).format('DD/MM/YYYY');

      var pickupTimeToCompare = vm.timeFormatIsActive ? LocalDateConvert.convertTimeToSave(vm.pickupTime, vm.pickupTimeFormat) : vm.pickupTime;
      var returnTimeToCompare = vm.timeFormatIsActive ? LocalDateConvert.convertTimeToSave(vm.returnTime, vm.returnTimeFormat) : vm.returnTime;

      var isSamePickupDateAndCurrentDate = todayMomentDateToCompare === pickupDateToCompare;
      var isSameReturnDateAndCurrentDate = todayMomentDateToCompare === returnDateToCompare;
      var isSamePickupAndReturnDate = pickupDateToCompare === returnDateToCompare;
      var isPickupTimeAfterOrEqualReturnTime = vehiclesUsageService.compareHoursAndMinutes(pickupTimeToCompare, returnTimeToCompare, 'isAfterOrEqual');

      if (vm.timeFormatIsActive) {
        var pickupHour = parseInt(vm.pickupTime.split(':')[0], 10);
        var returnHour = parseInt(vm.returnTime.split(':')[0], 10);

        switch (true) {
          case pickupHour > 12:
            _resetTimeControlValidity();
            return _setTimeControlValidity('pickupGreaterThan12', false);
          case returnHour > 12:
            _resetTimeControlValidity();
            return _setTimeControlValidity('returnGreaterThan12', false);
          case pickupHour === 0:
            _resetTimeControlValidity();
            return _setTimeControlValidity('pickupMinorThan00', false);
          case returnHour === 0:
            _resetTimeControlValidity();
            return _setTimeControlValidity('returnMinorThan00', false);
        }
      }

      if (isSamePickupAndReturnDate && isPickupTimeAfterOrEqualReturnTime) {
        return _setTimeControlValidity('invalidReturnTime', false);
      }
      else if (isSamePickupDateAndCurrentDate || isSameReturnDateAndCurrentDate) {
        var isPickupTimeAfterCurrentTime = vehiclesUsageService.compareHoursAndMinutes(pickupTimeToCompare, currentTime, 'isAfter');
        var isReturnTimeAfterCurrentTime = vehiclesUsageService.compareHoursAndMinutes(returnTimeToCompare, currentTime, 'isAfter');

        if (isSamePickupDateAndCurrentDate && isPickupTimeAfterCurrentTime) {
          return _setTimeControlValidity('invalidPickupTime', false);
        }

        if (isSameReturnDateAndCurrentDate && isReturnTimeAfterCurrentTime) {
          return _setTimeControlValidity('invalidReturnTime', false);
        }
      }

      _resetTimeControlValidity();
    }

    function _resetTimeControlValidity() {
      var controls = ['invalidPickupTime', 'invalidReturnTime', 'pickupGreaterThan12', 'returnGreaterThan12', 'pickupMinorThan00', 'returnMinorThan00'];
      controls.forEach(function (control) { _setTimeControlValidity(control, true); });
    }

    function checkDates() {
      if (vm.pickupDate && vm.returnDate && moment.utc(vm.pickupDate).isAfter(vm.returnDate)) {
        vm.returnDate = undefined;
      }
    }

    function checkTravelingDistance() {
      var hasReturnedTravelingDistance = vm.vehicleUsage.returnedTravelingDistance === 0 || (vm.vehicleUsage.returnedTravelingDistance && vm.vehicleUsage.returnedTravelingDistance !== 0);

      if (hasReturnedTravelingDistance && (vm.vehicleUsage.pickupTravelingDistance > vm.vehicleUsage.returnedTravelingDistance)) {
        vm.vehiclesUsageForm.returnedTravelingDistance.$setValidity('invalidTravelingDistance', false);
      } else {
        vm.vehiclesUsageForm.returnedTravelingDistance.$setValidity('invalidTravelingDistance', true);
      }
    }

    function checkReturnTime() {
      if (!vm.returnDate) {
        vm.returnTime = undefined;
      }

      checkTimes();
    }

    function saveVehicleUsage() {
      $rootScope.loadingProgress = true;

      if (vm.timeFormatIsActive) {
        vm.pickupTime = LocalDateConvert.convertTimeToSave(vm.pickupTime, vm.pickupTimeFormat);
        vm.returnTime = LocalDateConvert.convertTimeToSave(vm.returnTime, vm.returnTimeFormat);
      }

      vm.vehicleUsage.pickupAt = vehiclesUsageService.groupDateAndTime(vm.pickupDate, vm.pickupTime);
      vm.vehicleUsage.returnedAt = vehiclesUsageService.groupDateAndTime(vm.returnDate, vm.returnTime);

      var hasImagesMapper = {
        twoImages: vm.pickupImage && vm.returnImage,
        withoutImages: !vm.pickupImage && !vm.returnImage
      };

      if (hasImagesMapper.twoImages) {
        var imagesToUpload = [];

        if (vm.pickupImage != vm.vehicleUsage.pickupImageUrl) {
          var pickupFilename = '/vehicles-usage/' + vm.vehicleUsage.id + '/pickupImage/' + msUtils.shortGuidGenerator() + '.png';
          imagesToUpload.push(
            $q(function (resolve) {
              vehiclesUsageService.imageUpload(pickupFilename, vm.pickupImage, function (result) {
                vm.vehicleUsage.pickupImageUrl = result.path;
                resolve(result);
              });
            })
          );
        }

        if (vm.returnImage != vm.vehicleUsage.returnedImageUrl) {
          var returnFilename = '/vehicles-usage/' + vm.vehicleUsage.id + '/returnImage/' + msUtils.shortGuidGenerator() + '.png';
          imagesToUpload.push(
            $q(function (resolve) {
              vehiclesUsageService.imageUpload(returnFilename, vm.returnImage, function (result) {
                vm.vehicleUsage.returnedImageUrl = result.path;
                resolve(result);
              });
            })
          );
        }

        $q.all(imagesToUpload).then(function () {
          _updateVehicleUsage();
        });

      } else if (hasImagesMapper.withoutImages) {
        _updateVehicleUsage();
      }
      else {
        var imagesToUploadPossibilites = ['pickupImage', 'returnImage'];
        imagesToUploadPossibilites.forEach(function (currentImageName) {
          var currentImage = vm[currentImageName];
          if (currentImage) {
            var filename = '/vehicles-usage/' + vm.vehicleUsage.id + '/' + currentImageName + '/' + msUtils.shortGuidGenerator() + '.png';
            vehiclesUsageService.imageUpload(filename, currentImage, function (result) {
              vm.vehicleUsage.pickupImageUrl = currentImageName === 'pickupImage' ? result.path : vm.vehicleUsage.pickupImageUrl;
              vm.vehicleUsage.returnedImageUrl = currentImageName === 'returnImage' ? result.path : vm.vehicleUsage.returnedImageUrl;
              _updateVehicleUsage();
            });
          }
        });
      }
    }

    function archiveVehicleUsage() {
      vm.vehicleUsage.archived = true;
      _updateVehicleUsage();
    }

    function unarchiveVehicleUsage() {
      vm.vehicleUsage.archived = false;
      _updateVehicleUsage();
    }

    function onChangePickedBy(value) {
      if (value && value.isEmployee) {
        vm.vehicleUsage.employee = value;
        vm.vehicleUsage.user = null;
        var avatarUrl = vm.vehicleUsage.employee.avatarUrl;
        vm.avatarUrl = avatarUrl ? avatarUrl : vm.defaultAvatarUrl;
      }

      if (value && !value.isEmployee) {
        vm.vehicleUsage.user = value;
        vm.vehicleUsage.employee = null;
        var avatarUrl = vm.vehicleUsage.user.avatarUrl;
        vm.avatarUrl = avatarUrl ? avatarUrl : vm.defaultAvatarUrl;
      }
    }

    function updatePickupTimeFormat(value, inputControl) {
      if (!value) {
        return vm.pickupTimeFormat;
      }
      vm.pickupTimeFormat = value;

      if (inputControl) {
        inputControl.$setDirty();
        inputControl.$setTouched();
      }
    }

    function updateReturnTimeFormat(value, inputControl) {
      if (!value) {
        return vm.returnTimeFormat;
      }
      vm.returnTimeFormat = value;

      if (inputControl) {
        inputControl.$setDirty();
        inputControl.$setTouched();
      }
    }

    function editVehicleUsageFormAnswers(form, formType) {
      var currentFormId = vm.vehicleUsage.vehicle[formType] && vm.vehicleUsage.vehicle[formType].id;
      form.formId = currentFormId;
      form.type = formType === 'pickupForm' ? 'pickup' : 'return';

      $mdDialog.show({
        controller: 'FormQuestionsController',
        controllerAs: 'vm',
        templateUrl: 'app/core/dialogs/form-questions/form-questions.html',
        parent: angular.element($document.body),
        targetEvent: null,
        clickOutsideToClose: true,
        multiple: true,
        locals: {
          form: form,
          vehicleUsage: vm.vehicleUsage,
          editForm: true
        }
      })
        .finally(function () {
          _initialize();
        });
    }

    function _updateVehicleUsage() {
      vehiclesUsageApi.put(vm.vehicleUsage)
        .then(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('VEHICLES_USAGE.TOAST.VEHICLE_USAGE_SAVED', { name: vm.vehicleUsage.vehicle.name }))
              .hideDelay(3000)
          );
        })
        .catch(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('VEHICLES_USAGE.TOAST.ERRORS.SAVING'))
              .hideDelay(5000)
          );
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
          closeDialog(true);
          $rootScope.$broadcast('vehicles-usage:reload');
        });
    }

    function _setTimeControlValidity(timeControlName, isValid) {
      var formControls = {
        'invalidPickupTime': vm.vehiclesUsageForm.pickupTime,
        'invalidReturnTime': vm.vehiclesUsageForm.returnTime,
        'pickupGreaterThan12': vm.vehiclesUsageForm.pickupTime,
        'returnGreaterThan12': vm.vehiclesUsageForm.returnTime,
        'pickupMinorThan00': vm.vehiclesUsageForm.pickupTime,
        'returnMinorThan00': vm.vehiclesUsageForm.returnTime
      };

      if (formControls[timeControlName]) {
        formControls[timeControlName].$setValidity(timeControlName, isValid);
        formControls[timeControlName].$invalid = !isValid;
      }

    }

    function hasAllImages() {
      return (vm.pickupImage && vm.returnImage) ? true : false;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.vehicles')
    .factory('VehiclesDialog', VehiclesDialog);

  /** @ngInject */
  function VehiclesDialog($mdDialog, $rootScope, $document, vehiclesApi, $q, accountsApi) {

    return {
      createVehicle: createVehicle,
      editVehicle: editVehicle
    };

    function createVehicle(ev, callback) {
      $rootScope.loadingProgress = true;

      accountsApi.get().then(function (account) {
        _openDialog(ev, {
          Vehicle: null,
          Account: account
        }, callback);
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function editVehicle(ev, id, callback) {
      $rootScope.loadingProgress = true;

      var requests = {
        vehicle: vehiclesApi.getOne(id),
        account: accountsApi.get()
      };

      $q.all(requests)
        .then(function (result) {
          _openDialog(ev, {
            Vehicle: result.vehicle,
            Account: result.account
          }, callback);
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function _openDialog(ev, locals, callback) {
      $mdDialog
        .show({
          controller: 'VehiclesDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/vehicles/dialogs/vehicle-dialog.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          locals: locals,
          closeTo: {
            top: 0,
            left: window.innerWidth,
            width: window.innerWidth,
            height: window.innerHeight / 1.8
          }
        })
        .then(function (reload) {
          if (callback) {
            callback(reload);
          }
        });
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.vehicles')
    .controller('VehiclesDialogController', VehiclesDialogController);

  /** @ngInject */
  function VehiclesDialogController(
    $rootScope, _, Vehicle, msUtils,
    $mdToast, $mdDialog, $translate, FcModalService,
    vehiclesApi, uploadApi, $locale, $scope, formsApi, gandalfApi,
    accountFeatureFlagsApiGraphQL, Account
  ) {

    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    var vm = this;
    var initialYear = new Date().getFullYear() + 2;
    var minYear = 1970;

    vm.vehicleImage = null;
    vm.vehicle = angular.copy(Vehicle) || {
      name: "",
      imageUrl: "",
      licensePlate: "",
      register: "",
      brand: null,
      model: null,
      year: "",
      color: "",
      type: "",
      origin: "",
      originalTravelingDistance: null,
      description: "",
      qrCode: "",
      status: "",
      archived: false,
      pickupForm: {
        id: null,
        required: false
      },
      returnForm: {
        id: null,
        required: false
      }
    };

    vm.vehiclesTypeOptions = [
      { translate: $translate.instant('VEHICLES.MODEL.TYPES_OPTIONS.CAR'), value: 'car' },
      { translate: $translate.instant('VEHICLES.MODEL.TYPES_OPTIONS.MOTORCYCLE'), value: 'motorcycle' },
      { translate: $translate.instant('VEHICLES.MODEL.TYPES_OPTIONS.NAUTICAL'), value: 'nautical' },
      { translate: $translate.instant('VEHICLES.MODEL.TYPES_OPTIONS.TRUCK'), value: 'truck' },
      { translate: $translate.instant('VEHICLES.MODEL.TYPES_OPTIONS.SEMI_TRUCK'), value: 'semi_truck' }
    ];
    vm.vehiclesOriginsOptions = [
      { translate: $translate.instant('VEHICLES.MODEL.ORIGINS_OPTIONS.RENTED'), value: 'rented' },
      { translate: $translate.instant('VEHICLES.MODEL.ORIGINS_OPTIONS.COMPANY'), value: 'company' },
      { translate: $translate.instant('VEHICLES.MODEL.ORIGINS_OPTIONS.EMPLOYEE'), value: 'employee' },
    ];
    vm.vehiclesColorsOptions = [
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.YELLOW'), value: 'yellow' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.BLUE'), value: 'blue' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.BEIGE'), value: 'beige' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.WHITE'), value: 'white' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.BRONZE'), value: 'bronze' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.GRAY'), value: 'gray' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.GOLDEN'), value: 'golden' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.ORANGE'), value: 'orange' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.BROWN'), value: 'brown' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.SILVER'), value: 'silver' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.BLACK'), value: 'black' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.PINK'), value: 'pink' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.PURPLE'), value: 'purple' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.GREEN'), value: 'green' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.RED'), value: 'red' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.WINE'), value: 'wine' },
      { translate: $translate.instant('VEHICLES.MODEL.COLORS_OPTIONS.UNDEFINED'), value: 'undefined' }
    ];
    vm.vehiclesYearsOptions = Array.from({ length: initialYear - minYear }, function () {
      initialYear--;
      return { value: initialYear };
    });

    vm.formsOptions = [];
    vm.pickupSwitch = false;
    vm.returnSwitch = false;
    vm.currentSelectedPickupForm = [];
    vm.currentSelectedReturnForm = [];
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['vehicle-description'];
    vm.hasPublicQRCodeFeatureFlag = false;
    vm.accountConfiguration = Account.configuration;

    vm.closeDialog = closeDialog;
    vm.downloadQRCode = downloadQRCode;
    vm.goToQRCodeTab = goToQRCodeTab;
    vm.generateQRCode = generateQRCode;
    vm.viewQRCode = viewQRCode;
    vm.loadVehicleModels = loadVehicleModels;
    vm.searchBrandByName = searchBrandByName;
    vm.searchModelByName = searchModelByName;
    vm.archiveVehicle = archiveVehicle;
    vm.unarchiveVehicle = unarchiveVehicle;
    vm.saveVehicle = saveVehicle;
    vm.getAllAvailableForms = getAllAvailableForms;
    vm.changePickupVehicleForm = changePickupVehicleForm;
    vm.changeReturnVehicleForm = changeReturnVehicleForm;
    vm.getVehicleFormAndSetSwitch = getVehicleFormAndSetSwitch;
    vm.clearSelectedReturnForm = clearSelectedReturnForm;
    vm.clearSelectedPickupForm = clearSelectedPickupForm;
    vm.selectImage = selectImage;

    vm.vehiclesBrandsOptions = [];
    searchBrandByName('', function () {
      if (Vehicle && Vehicle.brand) {
        vm.vehicle.brand = Vehicle.brand;
      }
    });
    vm.validateVehicleName = function () {
      var newName = vm.vehicle.name;
      if (!newName) {
        vm.nameIsDuplicate = false;
        setNameDuplicateValidity(true);
        return;
      }

      vehiclesApi.search({ nameContains: newName.trim(), archived: false }, null, 1000, 0)
        .then(function (result) {
          var normalizedNewName = newName.trim().toLowerCase();
          var currentVehicleId = vm.vehicle.id;
          var hasExactDuplicate = (result.items || []).some(function (item) {
            return (currentVehicleId ? item.id !== currentVehicleId : true) &&
                  !item.archived &&
                  (item.name || '').trim().toLowerCase() === normalizedNewName;
          });

          vm.nameIsDuplicate = hasExactDuplicate;
          setNameDuplicateValidity(!hasExactDuplicate);
        });
    };

    function setNameDuplicateValidity(isValid) {
      if ($scope.vm.vehiclesForm && $scope.vm.vehiclesForm.name) {
        $scope.vm.vehiclesForm.name.$setValidity('duplicate', isValid);
      }
    }

    _initialize();

    function _initialize() {
      accountFeatureFlagsApiGraphQL.getCachedFlagByName('public-qrcode-beta-flag').then(function (flag) {
        vm.hasPublicQRCodeFeatureFlag = flag ? flag.active : false;
      });

      getAllAvailableForms().then(function () {
        getVehicleFormAndSetSwitch(vm.vehicle.pickupForm.id,  _setSelectedPickupForm);
        getVehicleFormAndSetSwitch(vm.vehicle.returnForm.id,  _setSelectedReturnForm);
      });
    }

    vm.vehiclesModelsOptions = [];
    if (vm.vehicle.brand && vm.vehicle.brand.id) {
      _searchModelByBrandId(vm.vehicle.brand.id, function () {
        vm.vehicle.model = Vehicle.model;
      });
    }

    function selectImage() {
      var imageSelector = document.querySelector('#image-insert-container');
      if (imageSelector) {
        imageSelector.click();
      }
    }

    function closeDialog(isReload) {
      $mdDialog.hide(isReload);
    }

    function downloadQRCode() {
      var download = document.getElementById('vehicleDownloadLink');
      var image = document.querySelector('#vehicle-qrcode-download canvas').toDataURL('image/png').replace('image/png', 'image/octet-stream');
      download.setAttribute("href", image);
    }

    function goToQRCodeTab() {
      vm.selectedTabIndex = 2;
    }

    function generateQRCode() {
      vm.vehicle.qrCode = msUtils.uuidGenerator();
      vm.existingEquipmentWithQRCode = (vm.vehicle && vm.vehicle.id && vm.vehicle.qrCode);
      var qrcodeGeneratorModalId = msUtils.uuidGenerator();
      vm.vehiclesForm.$setDirty();

      FcModalService.open(null, {
        title:  $translate.instant('VEHICLES.MODEL.QR_CODE.MODAL.GENERATE'),
        templateUrl: 'app/main/vehicles/dialogs/modal/qrcode-generator.html',
        modalId: qrcodeGeneratorModalId,
        eventNameToSubscribe: 'vehicles-qrcodes',
        closeButtonIconPath: 'assets/icons/icon-close.svg',
        variables: {
          title: $translate.instant('VEHICLES.MODEL.QR_CODE.MODAL.GENERATE'),
          vehicle: vm.vehicle,
          hasPublicQRCodeFeatureFlag: vm.hasPublicQRCodeFeatureFlag && vm.accountConfiguration.featurePublicQRCodeEnabled
        },
        buttonFlex: true,
        buttonWidth: 199,
        leftButtonText: $translate.instant('VEHICLES.MODEL.QR_CODE.MODAL.GENERATE_ANOTHER_CODE'),
        rightButtonText: $translate.instant('VEHICLES.MODEL.QR_CODE.MODAL.SAVE'),
        handleLeftButton: function () {
          vm.vehicle.qrCode = msUtils.uuidGenerator();
          vm.existingVehicleWithQRCode = (vm.vehicle && vm.vehicle.id && vm.vehicle.qrCode);
        },
        handleRightButton: function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('VEHICLES.MODEL.QR_CODE.MODAL.SAVED_SUCCESSFULLY'))
              .hideDelay(3000)
          );
        },
        dontCloseModalOnLeftButtonHandler: true
      }, null);
    }

    function viewQRCode() {
      var qrcodeGeneratorModalId = msUtils.uuidGenerator();

      FcModalService.open(null, {
        title:  $translate.instant('VEHICLES.MODEL.QR_CODE.MODAL.GENERATE'),
        templateUrl: 'app/main/vehicles/dialogs/modal/qrcode-generator.html',
        modalId: qrcodeGeneratorModalId,
        eventNameToSubscribe: 'vehicle-qrcodes',
        closeButtonIconPath: 'assets/icons/icon-close.svg',
        variables: {
          title: $translate.instant('VEHICLES.MODEL.QR_CODE.MODAL.GENERATE'),
          vehicle: vm.vehicle,
          hasPublicQRCodeFeatureFlag: vm.hasPublicQRCodeFeatureFlag && vm.accountConfiguration.featurePublicQRCodeEnabled
        },
        buttonFlex: true,
        rightButtonText: $translate.instant('VEHICLES.MODEL.QR_CODE.MODAL.DOWNLOAD'),
        handleRightButton: downloadQRCode,
        rightButtomFullSize: true,
        rightButtonIsDownloadLink: true,
        downloadLink: 'veiculo-' + vm.vehicle.qrCode + '.png',
        downloadHref: document.querySelector('#vehicle-qrcode-download canvas').toDataURL('image/png').replace('image/png', 'image/octet-stream'),
        dontCloseModalOnLeftButtonHandler: true
      }, null);
    }

    function loadVehicleModels(brand) {
      vm.vehicle.model = null;
      if(brand && brand.id) {
        _searchModelByBrandId(brand.id);
      }
      if (vm.vehicle && !vm.vehicle.id && !vm.vehicle.qrCode) {
        document.querySelector('md-tabs-canvas').classList.add('creating-vehicle');
      }
    }

    function getAllAvailableForms(searchTerm) {
      var increaseLimitWhenUserTypes = searchTerm ? 1000 : 10;
      var query = { nameContains: searchTerm, archived: 'no' };
      var options = { limit: increaseLimitWhenUserTypes, offset: 0 };

      return formsApi.search(query, options).then(function (forms) {
        vm.formsOptions = _.map(forms.items, function (form) {
          return {
            value: {
              id: form.id,
              name: form.name
            }
          };
        });
      });
    }

    function getVehicleFormAndSetSwitch(formId, callback) {
      vm.pickupSwitch = vm.vehicle.pickupForm ? vm.vehicle.pickupForm.required : false;
      vm.returnSwitch = vm.vehicle.returnForm ? vm.vehicle.returnForm.required : false;
      if (formId) {
        formsApi.get(formId, { limit: 1, offset: 0 }).then(function (form) {
          callback(form);
        });
      }
    }

    function _setSelectedPickupForm(form) {
      vm.currentSelectedPickupForm = form;
      _addFormOption(form);
    }

    function _setSelectedReturnForm(form) {
      vm.currentSelectedReturnForm = form;
      _addFormOption(form);
    }

    function changePickupVehicleForm(value) {
      if(typeof (value) === 'boolean') {
        vm.vehicle.pickupForm.required = vm.pickupSwitch;
      }

      if(value && value.id) {
        vm.vehicle.pickupForm.id = value.id;
      }

      if(!vm.vehicle.pickupForm.id) {
        $scope.vm.vehiclesForm.$setPristine();
      }
    }

    function changeReturnVehicleForm(value) {
      if(typeof (value) === 'boolean') {
        vm.vehicle.returnForm.required = vm.returnSwitch;
      }

      if(value && value.id) {
        vm.vehicle.returnForm.id = value.id;
      }

      if(!vm.vehicle.returnForm.id) {
        $scope.vm.vehiclesForm.$setPristine();
      }
    }

    function clearSelectedReturnForm() {
      if (vm.currentSelectedReturnForm) {
        vm.currentSelectedReturnForm = null;
        vm.returnSwitch = null;
        vm.vehicle.returnForm = { id: null, required: null };
        $scope.vm.vehiclesForm.$setDirty();
      }
    }

    function clearSelectedPickupForm() {
      if (vm.currentSelectedPickupForm) {
        vm.currentSelectedPickupForm = null;
        vm.pickupSwitch = null;
        vm.vehicle.pickupForm = { id: null, required: null };
        $scope.vm.vehiclesForm.$setDirty();
      }
    }

    function searchBrandByName(searchTerm, callback) {
      vehiclesApi.searchBrands({ nameContains: searchTerm })
        .then(function (brands) {
          vm.vehiclesBrandsOptions = _.map(brands, function (brand) {
            return { value: brand };
          });

          if (callback) { return callback(); }
        });
    }

    function searchModelByName(searchTerm) {
      var take = 10;
      if(!searchTerm) {
        take = 100;
      }
      if (vm.vehicle.brand && vm.vehicle.brand.id) {
        vehiclesApi.searchModels({ nameContains: searchTerm, brandId: vm.vehicle.brand.id }, take, 0)
          .then(function (result) {
            vm.vehiclesModelsOptions = _.map(result.items, function (model) {
              return { value: model };
            });
          });
      }
    }

    function archiveVehicle() {
      vm.vehicle.archived = true;
      saveVehicle();
    }

    function unarchiveVehicle() {
      var name = vm.vehicle.name;

      vehiclesApi.search({ nameContains: name, archived: false }, null, 1, 0)
        .then(function (result) {
          var hasConflict = result.items.some(function (item) {
            return item.name === name && item.id !== vm.vehicle.id;
          });

          if (hasConflict) {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('VEHICLES.TOAST.ERRORS.UNARCHIVE_DUPLICATE_NAME'))
                .hideDelay(4000)
            );
            return;
          }

          vm.vehicle.archived = false;
          saveVehicle();
        });
    }

  function saveVehicle() {
    $rootScope.loadingProgress = true;
      if (vm.vehicle.id) {
        if (vm.vehicleImage) {
          var filename = '/vehicles/' + vm.vehicle.id + '/' + msUtils.shortGuidGenerator() + '.png';
          uploadApi.uploadWithPreSignedPost({ file: vm.vehicleImage, filePath: filename }, null)
            .then(function (result) {
              vm.vehicle.imageUrl = result.path;
              _saveAction();
            })
            .catch(_vehicleImageSaveError);
        } else {
          _saveAction();
        }
      } else {
        _saveAction();
      }
    };

    function _saveAction() {
      var action = vm.vehicle.id ? 'put' : 'save';

      if (action === 'save') {
        delete vm.vehicle.pickupForm;
        delete vm.vehicle.returnForm;
      }

      vehiclesApi[action](vm.vehicle)
        .then(function (savedVehicle) {
          if (action === 'save' && vm.vehicleImage) {
            vm.vehicle.id = savedVehicle.id;

            var filename = '/vehicles/' + vm.vehicle.id + '/' + msUtils.shortGuidGenerator() + '.png';
            uploadApi.uploadWithPreSignedPost({ file: vm.vehicleImage, filePath: filename }, null)
              .then(function (result) {
                vm.vehicle.imageUrl = result.path;
                vehiclesApi.put(vm.vehicle).catch(_vehicleImageSaveError);
              })
              .catch(_vehicleImageSaveError);
          }

          for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
            var field = vm.smartRewriteFields[i];
            var params = {
              reference: vm.sessionId,
              referenceType: field,
              updatedReference: savedVehicle.id
            };

            gandalfApi.updateRewriteInputHistory(params);
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('VEHICLES.TOAST.SUCCESS.VEHICLE_SAVED', { name: vm.vehicle.name }))
              .hideDelay(3000)
          );
        })
        .catch(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('VEHICLES.TOAST.ERRORS.ERROR_TO_SAVE'))
              .hideDelay(5000)
          );
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
          closeDialog(true);
        });
    }

    function _vehicleImageSaveError() {
      $mdToast.show(
        $mdToast.simple()
          .textContent($translate.instant('VEHICLES.TOAST.ERRORS.IMAGE_UPLOAD'))
          .hideDelay(3000)
      );
    }

    function _searchModelByBrandId(branId, callback) {
      vehiclesApi.searchModels({ brandId: branId }, 1000, 0)
        .then(function (result) {
          vm.vehiclesModelsOptions = _.map(result.items, function (model) {
            return { value: model };
          });

          if (callback) { return callback(); }
        });
    }

    function _addFormOption(form) {
      var hasCurrentFormInFormOptions = _.find(vm.formsOptions, function (option) {
        return option.value.id === form.id;
      });
      if(!hasCurrentFormInFormOptions){
        vm.formsOptions.push({
          value: {
            id: form.id,
            name: form.name
          }
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .factory('TasksFiltersService', TasksFiltersService);

  /** @ngInject */
  function TasksFiltersService($rootScope, moment, TasksStatusHelper, accountCache) {
    var filters = {
      customersName: '',
      customerId: '',
      customersLabels: [],
      activitiesDateFrom: null,
      activitiesDateFromView: moment().startOf('day').toDate().toISOString(),
      activitiesDateTo: null,
      activitiesDateToView: moment().add(6, 'M').startOf('day').toDate().toISOString(),

      activitiesDateDeadlineFrom: null,
      activitiesDateDeadlineTo: null,

      zipCode: '',
      city: '',
      locationName: '',
      locationNotes: '',
      activitiesIdentifier: '',
      description: '',
      services: [],
      equipments: [],
      createdByIds: [],
      employees: [],
      archived: '1',
      ratings: [],
      status: [],
      labels: [],
      responseDeadlineStatus: [],
      solutionDeadlineStatus: [],
      territoryId: '',
      subTerritoryIds: [],

      clear: clear,
      isOn: isOn,
      isOff: isOff,
      toSearchOptions: toSearchOptions
    };

    function clear() {
      filters.customersName = '';
      filters.customerId = '';
      filters.customersLabels = [];

      filters.zipCode = '';
      filters.city = '';
      filters.locationName = '';
      filters.locationNotes = '';
      filters.equipmentNumber = '';

      filters.activitiesDateFrom = null;
      filters.activitiesDateFromView = moment().startOf('day').toDate().toISOString();
      filters.activitiesDateTo = null;
      filters.activitiesDateToView = moment().add(6, 'M').startOf('day').toDate().toISOString();

      filters.activitiesDateDeadlineFrom = null;
      filters.activitiesDateDeadlineTo = null;

      filters.activitiesIdentifier = '';
      filters.description = '';
      filters.archived = '1';

      filters.services = [];
      filters.equipments = [];
      filters.employees = [];
      filters.createdByIds = [];
      filters.status = [];
      filters.labels = [];
      filters.ratings = [];
      filters.responseDeadlineStatus = [];
      filters.solutionDeadlineStatus = [];
      filters.territoryId = '';
      filters.subTerritoryIds = [];

      $rootScope.$broadcast('tasks-list:filter-updated');
      $rootScope.$broadcast('tasks-list:filter-cleaned');
    }

    function isOn() {
      var emptyCustomerName = filters.customersName === '';
      var emptyCustomerId = filters.customerId === '';
      var noCustomersLabelsFiltered = !filters.customersLabels.length;

      var nullActivitiesDateDeadlineFrom = filters.activitiesDateDeadlineFrom === null;
      var nullActivitiesDateDeadlineTo = filters.activitiesDateDeadlineTo === null;
      var defaultActivitiesDateView = filters.activitiesDateFromView === moment().startOf('day').toDate().toISOString()
        && filters.activitiesDateToView === moment().add(6, 'M').startOf('day').toDate().toISOString();

      var emptyIdentifier = filters.activitiesIdentifier === '';
      var emptyDescription = filters.description === '';
      var emptyZipCode = filters.zipCode === '';
      var emptyCity = filters.city === '';
      var emptyLocationName = filters.locationName === '';
      var emptyLocationNotes = filters.locationNotes === '';
      var defaultArchived = filters.archived === '1';

      var noEmployeeFiltered = !filters.employees.length;
      var noCreatedByIdsFiltered = !filters.createdByIds.length;
      var noServiceFiltered = !filters.services.length;
      var noStatusFiltered = !filters.status.length;
      var noLabelsFiltered = !filters.labels.length;
      var noRatingFiltered = !filters.ratings.length;
      var noResponseDeadlineStatusFiltered = !filters.responseDeadlineStatus.length;
      var noSolutionDeadlineStatusFiltered = !filters.solutionDeadlineStatus.length;
      var noEquipmentFiltered = filters.equipments === null || !filters.equipments.length;
      var noTerritoryFiltered = !filters.territoryId;
      var noSubTerritoryFiltered = !filters.subTerritoryIds || !filters.subTerritoryIds.length;

      return !(
        nullActivitiesDateDeadlineTo &&
        nullActivitiesDateDeadlineFrom &&
        defaultActivitiesDateView &&
        emptyCustomerName &&
        emptyCustomerId &&
        emptyZipCode &&
        emptyCity &&
        emptyLocationName &&
        emptyLocationNotes &&
        noEquipmentFiltered &&
        defaultArchived &&
        noCustomersLabelsFiltered &&
        emptyIdentifier &&
        emptyDescription &&
        noEmployeeFiltered &&
        noCreatedByIdsFiltered &&
        noServiceFiltered &&
        noStatusFiltered &&
        noRatingFiltered &&
        noLabelsFiltered &&
        noResponseDeadlineStatusFiltered &&
        noSolutionDeadlineStatusFiltered &&
        noTerritoryFiltered &&
        noSubTerritoryFiltered
      );
    }

    function isOff() {
      return !isOn();
    }

    function toSearchOptions() {
      var orderEquipmentIds = [];
      if (filters.equipments && filters.equipments.length) {
        orderEquipmentIds = _.map(filters.equipments, function (equipment) { return equipment.id; });
      }

      if (!filters.activitiesDateFromView) {
        filters.activitiesDateFromView = moment().toDate().toISOString();
      }

      return accountCache.getCachedOrDefault().then(function (account) {
        var status = _getStatusFilter(account && account.configuration);

        var kqQueryParams = {
          'scheduled_date>=': moment(filters.activitiesDateFromView).format('YYYY-MM-DD'),
          'employee_id': filters.employees,
          'order_label_id': filters.labels,
          'rating_stars': filters.ratings,
          'status': status,
          'service_id': _.map(filters.services, function (service) { return service.id; }),
          'order_equipment_id': orderEquipmentIds,
          'customer_labels_id': _.map(filters.customersLabels, 'id')
        };

        var gqlParams = {
          scheduledDateGte: moment(filters.activitiesDateFromView).format('YYYY-MM-DD'),
          employeeIds: filters.employees,
          orderLabelIds: filters.labels,
          ratings: _.map(filters.ratings, function (rating) { return parseInt(rating); }),
          statusIn: status,
          serviceIds: _.map(filters.services, function (service) { return service.id; }),
          equipmentIds: orderEquipmentIds,
          createdByIds: filters.createdByIds,
          customerLabelIds: _.map(filters.customersLabels, 'id'),
        };

        if (filters.activitiesDateToView) {
          kqQueryParams['scheduled_date<='] = moment(filters.activitiesDateToView).format('YYYY-MM-DD');
          gqlParams['scheduledDateLte'] = moment(filters.activitiesDateToView).format('YYYY-MM-DD');
        }

        if (filters.customersName) {
          kqQueryParams['order.customer.name~~*'] = '*' + filters.customersName + '*';
          gqlParams['customerNameContains'] = filters.customersName;
        }

        if (filters.customerId) {
          kqQueryParams['customer_id'] = filters.customerId;
          gqlParams['customerIds'] = [parseInt(filters.customerId)];
        }

        if (filters.zipCode) {
          kqQueryParams['order.zip_code'] = filters.zipCode;
          gqlParams['zipCode'] = filters.zipCode;
        }

        if (filters.city) {
          kqQueryParams['order.city~~*'] = '*' + filters.city + '*';
          gqlParams['cityContains'] = filters.city;
        }

        if (filters.neighborhood) {
          kqQueryParams['order.neighborhood~~*'] = '*' + filters.neighborhood + '*';
          gqlParams['neighborhoodContains'] = filters.neighborhood;
        }

        if (filters.locationName) {
          kqQueryParams['order.location.name~~*'] = '*' + filters.locationName + '*';
          gqlParams['locationNameContains'] = filters.locationName;
        }

        if (filters.locationNotes) {
          kqQueryParams['order.location.notes~~*'] = '*' + filters.locationNotes + '*';
          gqlParams['locationNotesContains'] = filters.locationNotes;
        }

        if (filters.sectorId) {
          gqlParams['locationSectorIds'] = [filters.sectorId];
        }

        if (filters.environmentId) {
          gqlParams['locationEnvironmentIds'] = [filters.environmentId];
        }

        if (filters.equipments) {
          kqQueryParams['order.equipment_id'] = orderEquipmentIds;
          gqlParams['equipmentIds'] = orderEquipmentIds;
        }

        if (filters.activitiesIdentifier) {
          kqQueryParams['order.identifier~~*'] = '*' + filters.activitiesIdentifier + '*';
          gqlParams['identifierContains'] = filters.activitiesIdentifier;
        }

        if (filters.description) {
          kqQueryParams['description~~*'] = '*' + filters.description + '*';
          gqlParams['descriptionContains'] = filters.description;
        }

        if (filters.activitiesDateDeadlineFrom) {
          kqQueryParams['deadline_at>='] = moment(filters.activitiesDateDeadlineFrom).format('YYYY-MM-DD');
          gqlParams['deadlineAtGte'] = moment(filters.activitiesDateDeadlineFrom).format('YYYY-MM-DD');
        }

        if (filters.activitiesDateDeadlineTo) {
          kqQueryParams['deadline_at<='] = moment(filters.activitiesDateDeadlineTo).format('YYYY-MM-DD');
          gqlParams['deadlineAtLte'] = moment(filters.activitiesDateDeadlineTo).format('YYYY-MM-DD');
        }

        if (filters.responseDeadlineStatus.length >= 0) {
          gqlParams['deadlineResponseStatusIn'] = filters.responseDeadlineStatus;
        }

        if (filters.solutionDeadlineStatus.length >= 0) {
          gqlParams['deadlineSolutionStatusIn'] = filters.solutionDeadlineStatus;
        }

        if (filters.orderCreatedAtGte) {
          gqlParams['orderCreatedAtGte'] = _getSpecificPeriodOfDay(filters.orderCreatedAtGte.toISOString(), 'initial');
        }

        if (filters.orderCreatedAtLte) {
          gqlParams['orderCreatedAtLte'] = _getSpecificPeriodOfDay(filters.orderCreatedAtLte.toISOString(), 'final');
        }

        if (filters.subTerritoryIds && filters.subTerritoryIds.length) {
          gqlParams['territoryIds'] = filters.subTerritoryIds;
        } else if (filters.territoryId) {
          gqlParams['territoryIds'] = [filters.territoryId];
        }

        if (filters.isFilteringByCreatedAt) {
          delete gqlParams.scheduledDateLte;
          delete gqlParams.scheduledDateGte;
        }

        if (filters.archived === '1') {
          kqQueryParams['archived'] = 'no';
          gqlParams['archived'] = false;
        } else if (filters.archived === '0') {
          kqQueryParams['archived'] = 'yes';
          gqlParams['archived'] = true;
        }

        return {
          kq: kqQueryParams,
          graphQL: gqlParams
        };
      });
    }

    function _getStatusFilter(configuration) {
      var isPendingTasksEnabled = configuration && configuration.taskEnablePendingStatus;
      var isFilteringByStatus = filters.status && filters.status.length;
      var allStatus = TasksStatusHelper.getAll().map(function (status) { return status.name; });

      if (isPendingTasksEnabled && !isFilteringByStatus) {
        return allStatus;
      }

      if (!isPendingTasksEnabled && !isFilteringByStatus) {
        allStatus = _.filter(allStatus, function (statusName) { return statusName !== 'pending'; });

        return allStatus;
      }

      return filters.status;
    }

    function _getSpecificPeriodOfDay(dateString, period) {
      var date = dateString.split('T');
      var periodOfDayMapper = {
        initial: '03:00:00.000Z',
        final: '23:59:59.000Z'
      };

      return date[0]+'T'+periodOfDayMapper[period];
    }

    return filters;
  }
})();

(function () {
  'use strict';

  angular.module('app.tasks')
    .factory('OrderDialog', OrderDialog);

  /** @ngInject */
  function OrderDialog(
    $mdDialog, $rootScope, $document, $, ordersApi, $q, orderMaterialsService, MessageDialog,
    geoCoder, $mdToast, orderPendenciesService, accountFeatureFlagsApiGraphQL,
    servicesApi, servicesCache, employeesCache, employeesApi, accountsApi, labelsApi, deadlineContractsApi, $translate, msUtils
  ) {
    var isDialogOpen = false;
    return {
      createTask: createTask,
      editTask: editTask,
      linkEquipments: linkEquipments,
      sortTasks: sortTasks
    };

    function createTask(ev, data, callback, allowed) {
      if (isDialogOpen) return;
      isDialogOpen = true;

      if (!allowed) {
        MessageDialog.showToast({
          hideDelay: 2000,
          message: $translate.instant('TASKS.DIALOG.ACTIONS.ALERTS.CANT_CREATE')
        });
        isDialogOpen = false;
        return;
      }

      accountFeatureFlagsApiGraphQL.accountFeatureFlags().then(function (featureFlags) {
        if (hasNewOrderBetaFlag(featureFlags)) {
          return _openNewOrderDialog(data, callback).finally(function () {
            isDialogOpen = false;
          });
        }

        _loaderOn();

        data = data || {};

        var requests = {
          services: servicesApi.getAll(),
          employees: employeesApi.getAll(),
          account: accountsApi.get(),
          labels: labelsApi.search({ type: 'orders' }, { limit: 100 }),
          deadlineContracts: deadlineContractsApi.search({'archived': false}, { limit: 100 }),
        };

        if (data.isToUseTicketAddress && data.ticket && data.ticket.metadata && data.ticket.metadata.address) {
          requests['coords'] = geoCoder.getByAddressObject(data.ticket.metadata.address);
        }

        $q.all(requests).then(function (result) {

          if (result.coords) {
            data.ticket.metadata.address.coords = {
              latitude: result.coords.lat,
              longitude: result.coords.lng
            };
          }

          _openDialog(ev, {
            Order: null,
            Services: result.services.items,
            Employees: result.employees.items,
            Account: result.account,
            Labels: result.labels,
            Ticket: data.ticket || {},
            FeatureFlags: featureFlags,
            Forms: null,
            Data: data,
            event: ev,
            TabIndex: 0,
            DeadlineContracts: result.deadlineContracts.items,
            isToUseTicketAddress: data.isToUseTicketAddress || false,
            enableCreateCustomer: data.enableCreateCustomer
          }, callback);
        }).finally(function () {
          _loaderOff();
          isDialogOpen = false;
        });
      });
    }

    function editTask(ev, data, callback) {
      if (isDialogOpen) return;
      isDialogOpen = true;

      accountFeatureFlagsApiGraphQL.accountFeatureFlags().then(function (featureFlags) {
        if (hasNewOrderBetaFlag(featureFlags)) {
          return _openNewOrderDialog(data, callback).finally(function () {
            isDialogOpen = false;
          });
        }

        _loaderOn();

        var requests = {
          order: ordersApi.get(data.id),
          services: servicesCache.getCachedOrDefault(),
          employees: employeesCache.getCachedOrDefault(),
          account: accountsApi.get(),
          labels: labelsApi.search({ type: 'orders' }, { limit: 100 }),
          deadlineContracts: deadlineContractsApi.search({'archived': false}, {limit: 100}),
          featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags()
        };

        $q.all(requests).then(function (result) {
          _openDialog(ev, {
            Order: result.order,
            Services: result.services || [],
            Employees: result.employees || [],
            Account: result.account,
            Ticket: data.ticket || {},
            Forms: null,
            Labels: result.labels,
            FeatureFlags: featureFlags,
            Data: {},
            SelectedDate: null,
            event: ev,
            TabIndex: data.tabIndex,
            DeadlineContracts: result.deadlineContracts.items,
            isToUseTicketAddress: false,
            enableCreateCustomer: false
          }, callback);
        }).finally(function () {
          _loaderOff();
          isDialogOpen = false;
        });
      });
    }

    function _openDialog(ev, locals, callback) {
      return $mdDialog.show({
        controller: 'OrderDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/tasks/dialogs/order-dialog.html',
        parent: document.querySelector('.palantir-modal-container') || angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: locals,
        multiple: true,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload) {
        if (reload) {
          document.dispatchEvent(new CustomEvent('order-dialog:updated'));
        }

        if (callback) {
          var TIMEOUT_CALLBACK = 0;
          if (reload) {
            TIMEOUT_CALLBACK = 2000;
            $rootScope.loadingProgress = true;
          }

          setTimeout(function () {
            callback(reload);
          }, TIMEOUT_CALLBACK);
        }
        //FIXME: workaround for md-autocomplete bug :/
        $('.md-scroll-mask').remove();
      }).finally(function () {
        isDialogOpen = false;
        orderMaterialsService.resetMaterials();
        orderPendenciesService.resetPendencies();
        document.dispatchEvent(new CustomEvent('order-dialog:close'));
      });
    }

    function _loaderOn() {
      $rootScope.loadingProgress = true;
    }

    function _loaderOff() {
      $rootScope.loadingProgress = false;
    }

    function linkEquipments(equipments, orderId) {
      return new Promise(function (resolve, reject) {
        var toast = $mdToast.simple().textContent('Vinculando equipamentos... 0 / ' + equipments.length);
        $mdToast.show(toast);

        var linkEquipmentPromises = _.map(equipments, function (_, index) {
          return function (callback) { _linkEquipment(equipments, index, orderId, callback); };
        });

        async.waterfall(linkEquipmentPromises, function (error, result) {
          if (error) {
            return reject(error);
          }

          resolve(result);
        });
      });
    }

    function _linkEquipment(equipments, index, orderId, callback) {
      ordersApi.saveEquipment(orderId, equipments[index]).then(function (response) {
        callback(null);
        $mdToast.updateTextContent('Vinculando equipamentos... ' + (index + 1) + ' / ' + equipments.length);
      }).catch(function (error) {
        callback(error);
      });
    }

    function sortTasks(tasks) {
      return tasks.sort(function (a, b) {
        return (
          msUtils.sortCompare(a.archived, b.archived) ||
          msUtils.sortCompare(a.scheduling.date, b.scheduling.date) ||
          msUtils.sortCompare(a.scheduling.time, b.scheduling.time) ||
          msUtils.sortCompare(a.position, b.position) ||
          msUtils.sortCompare(a.metadata.createdAt, b.metadata.createdAt) ||
          msUtils.sortCompare(a.id, b.id)
        );
      });
    }

    function _openNewOrderDialog(data, callback) {
      return new Promise(function (resolve) {
        var mappedData = { };

        if (data) {
          mappedData.orderId = data.id;
          mappedData.scheduledDate = data.scheduling && data.scheduling.date ? moment(data.scheduling.date).format('YYYY-MM-DD') : null;
          mappedData.customerId = data.customer && data.customer.id ? data.customer.id : null;
          mappedData.tab = data.tabIndex ? mapTabIndexToTabName(data.tabIndex) : null;
          mappedData.description = data.description || null;
        }

        document.dispatchEvent(new CustomEvent('openNewOrderDialog', { detail: mappedData }));

        document.addEventListener('order-modal:closed', function (event) {
          var reload = event && event.detail && event.detail.reload;
          var order = event && event.detail && event.detail.order;
          isDialogOpen = false;

          if (callback) {
            callback(reload);
          }

          if (data && data._hooks && data._hooks.onSaved) {
            data._hooks.onSaved({ order: order });
          }

          orderMaterialsService.resetMaterials();
          orderPendenciesService.resetPendencies();
          document.dispatchEvent(new CustomEvent('order-dialog:close'));

          resolve(reload);
        });
      });
    }

    function hasNewOrderBetaFlag(featureFlags) {
      var hasFeature = featureFlags.find(function (featureFlag) {
        return featureFlag.name === 'new-order-beta-flag';
      });

      if (!hasFeature) { return false; }

      return hasFeature.active;
    }

    function mapTabIndexToTabName(index) {
      var tabAndexMap = {
        0: 'general',
        1: 'general', // old deadline tab
        2: 'general', // old location tab
        3: 'links',
        4: 'pendencies',
        5: 'quotations',
        6: 'general', // old materials tab
        7: 'products',
        8: 'services',
        9: 'movements',
        10: 'attachments',
        11: 'forms',
        12: 'comments',
        13: 'history',
        14: 'routes',
      };

      return tabAndexMap[index] || null;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('OrderDialogController', OrderDialogController);

  /** @ngInject */
  function OrderDialogController(
    $scope, Order, Services, Employees, Data, $mdDialog, $timeout, focus, $mdToast,
    $rootScope, customersApi, geoCoder, dateHandler, $, $document, haversine, $q,
    tasksApi, employeesApi, labelsApi, _, equipmentsApiGraphQL, ordersApi, formsApi, equipmentsApi, equipmentTypesApi,
    cepDbApi, MessageDialog, locationsApi, authenticatedUser, leafletData, Account,
    hasher, ordersFormsMapper, fuseTheming, moment, TasksStatusHelper, $window, addressService,
    documentDuplicatedValidationService, msUtils, fuseGenerator, attachmentsUtils,
    $locale, formValidator, documents, contaAzulApi, omieApi, $translate, Ticket,
    ticketsApi, TabIndex, uploadApi, Labels, orderMaterialsService, TasksExportDialog,
    contaAzulCustomerMapper, omieCustomerMapper, absencesApi, IntegrationsService, CheckEditPermission,
    validateEmployeeIsInMoreThanOneTaskAtTheSameTime, DeadlineContracts, FcModalService,
    deadlineContractsApi, locationsService, validateDateAndTimeService, formsApiGraphQL, $localStorage,
    printConfigurationApi, normalizePrintConfigurations, exportsApi, orderProductsService, orderServicesService,
    customerLocationsApi, isToUseTicketAddress, enableCreateCustomer, locationsApiGraphQL, OrderDialog,
    FeatureFlags, accountFeatureFlagsApiGraphQL, ordersPendenciesApiGraphQL, orderPendenciesService, customersApiGraphQL,
    orderLinksService, orderLocationSectorApi, orderLocationEnvironmentApi, orderEquipmentApi, EquipmentsDialog, gandalfApi,
    orderRoutesService, ordersRoutesApiGraphQL, LocalDateConvert, territoriesApi, usersApi, CurrencyService, translateService
  ) {
    var vm = this;

    vm.currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = vm.currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';
    vm.language = translateService.getLanguage() || 'pt';

    vm.filesToUpload = [];
    vm.user = authenticatedUser.profile;
    vm.addressModeSelection = Account.configuration.addressSearchMode || 'google';
    vm.selectedTabIndex = TabIndex || 0;
    vm.loadMorePendencies = loadMorePendencies;
    vm.lastTrackedTab = 'general';
    vm.initialized = false;
    vm.maxEquipmentPerTask = 150;
    vm.order = angular.copy(Order);
    vm.productToMovementTab = null;
    vm.timeFormatIsActive = this.language === 'en';
    vm.dateFormat = LocalDateConvert.pickFormat('date-time');
    vm.formsTabIndex = 11;

    vm.emptySchedulingState = {
      date: null,
      time: null
    };

    vm.employeesOptions = [];
    vm.setEmployeesOptions = setEmployeesOptions;

    vm.hasCreateOrderWithTasksFlag = false;
    accountFeatureFlagsApiGraphQL.getCachedFlagByName('create-order-with-tasks-beta-flag').then(function (flag) {
      vm.hasCreateOrderWithTasksFlag = flag ? flag.active : false;
    });

    vm.updateScheduledTimeFormat = function (timeFormat) {
      task.scheduledTimeFormat = timeFormat;
    };

    vm.updateStartedTimeFormat = function (timeFormat, task) {
      task.startedAtTimeFormat = timeFormat;
    };

    vm.updateCompletedTimeFormat = function (timeFormat, task) {
      task.completedAtTimeFormat = timeFormat;
    };

    vm.secondaryEmployeesMaxLengthValidator = function (task, secondaryEmployeeId) {
      if (!task.secondaryEmployees) {
        return false;
      }

      var filteredEmployees = task.secondaryEmployees.filter(function (employeeId) {
        var employee = vm.employees.find(function (e) {
          return e.id == employeeId;
        });

        return employee && employee.contract && employee.contract.active && !employee.inactivatedAt;
      });

      if (filteredEmployees && filteredEmployees.length < 10) {
        return false;
      }

      var employeeIsSelected = task.secondaryEmployees.find(function (employeeId) {
        return employeeId == secondaryEmployeeId.toString();
      });

      return !employeeIsSelected ? true : false;
    };

    vm.allEmployees = Employees;
    vm.loadedTabs = {
      products: false,
      pendencies: false,
      services: false,
      materials: false,
      attachments: false,
      comments: false,
      history: false,
      forms: false,
      quotations: false,
      deadlines: false,
      offline: false,
      storagesMovements: false,
      links: false,
      routes: false
    };

    vm.account = Account;
    vm.accountConfiguration = Account.configuration;

    vm.hasCustomerPermission = authenticatedUser.hasPermissionFromCategory(vm.account, 'customers');
    vm.addPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_create');
    vm.editPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_edit');
    vm.showRatingButton = (
      vm.order &&
      vm.order.tasks && vm.order.tasks.length &&
      vm.order.tasks[0].status === 'done'
    );

    vm.disablePrintOrder = false;
    vm.hasCorporateDeadlineContractPermission = false;
    vm.hasDeadlineContractsPermission = authenticatedUser.hasPermissionFromCategory(vm.account, 'tasks') && vm.accountConfiguration.moduleOrdersDeadlineEnabled;
    vm.labelsLimit = vm.accountConfiguration.labelsLimit || 30;
    vm.maxTasksPerOrder = vm.accountConfiguration.maxTasksPerOrder || 20;
    vm.checkQuestions = [];
    vm.configurations = {
      featureDisableEditDeadlineContract: false,
      featureCreateTaskWithPastDate: false,
      featureCloseTaskWithPastDate: true,
      featureCloseTaskWithFutureDate: true,
      featureCancelationDescriptionRequired: false
    };

    var cleanupEventAttachmentsChanged = $rootScope.$on('order:attachments-changed', function (event, result) {
      vm.filesToUpload = result.filesToUpload || [];
      vm.attachments = result.attachments || [];
    });

    $rootScope.$on('$destroy', function () {
      cleanupEventAttachmentsChanged();
    });

    $rootScope.$on('go-to-movements-tab', function (e, data) {
      vm.productToMovementTab = data;

      vm.goToTab(9);

      $timeout(function () {
        vm.productToMovementTab = null;
      }, 1000);
    });

    var commentTabIndex = 12;

    if (vm.selectedTabIndex === commentTabIndex) {
      vm.loadedTabs.comments = true;
    }

    vm.employees = _.filter(angular.copy(Employees), function (employee) {
      return employee.contract.active && !employee.inactivatedAt;
    });

    vm.setEmployeesOptions();

    vm.palettes = fuseTheming.getRegisteredPalettesLabels();
    vm.rgba = fuseGenerator.rgba;

    var updateOrdersLabelsDebounced = _.debounce(updateLabels, 1000);
    vm.toggleLabel = function (id, array) {
      msUtils.toggleInArray(id, array);

      updateOrdersLabelsDebounced(vm.order, {
        reload: true,
        showToast: true,
        showProgress: true
      });
    };

    vm.toggleInArray = function (id, array, skipFormValidation) {
      msUtils.toggleInArray(id, array);
      if (skipFormValidation) {
        return;
      }

      $timeout(function () {
        if ($scope.orderForm) {
          $scope.orderForm.$setDirty();
        }
      }, 1000);
    };

    vm.exists = msUtils.exists;
    vm.allServices = angular.copy(Services);

    vm.services = _.filter(angular.copy(Services), function (service) {
      var isServiceActive = service.archived === false;
      if (isServiceActive) {
        return true;
      }

      var preSelectedServiceId = Data.service && Data.service.id;
      if (preSelectedServiceId === service.id) {
        return true;
      }

      return false;
    });

    vm.link = {
      taskRatingLink: 'https://app.fieldcontrol.com.br/relacionamento-cliente/#/avaliacao-do-atendimento/',
      taskPrintLink: 'https://app.fieldcontrol.com.br/#/visualizar-relatorio-atividade?id=',
      orderPrintLink: 'https://app.fieldcontrol.com.br/#/visualizar-relatorio-os?id=',
      newOrderPrintLink: 'https://app.fieldcontrol.com.br/relacionamento-cliente/#/relatorio/'
    };

    vm.tasks = [];
    vm.locations = [];
    vm.pendencies = {};
    vm.routes = {};
    vm.formErr = {};
    vm.question = {};
    vm.isCreatingOrder = false;
    vm.hasQuestionAnswer = true;
    vm.selectedCustomer = null;
    vm.selectedService = null;
    vm.selectedAddress = null;
    vm.selectedCustomerEmails = [];
    vm.selectedCustomerEmailsPrintLink = [];
    vm.selectedCustomerEmailsRatingLink = [];
    vm.selectedCustomerEmailsTrackingLink = [];
    vm.selectedNewCustomerAddress = false;
    vm.taskStatus = TasksStatusHelper.getAll();
    vm.countAnsweredForms = countAnsweredForms;
    vm.validateIdentifier = validateIdentifier;
    vm.hideFeedbackForm = _getHideFeedBackForm();
    vm.tabClicked = tabClicked;
    vm.hideEquipmentFeedbackForm = _getEquipmentHideFeedBackForm();
    vm.closeFeedback = closeFeedback;
    vm.closeEquipmentFeedback = closeEquipmentFeedback;
    vm.taskReportedReasons = Account.configuration.taskReportedReasons;
    vm.taskEnableReportedReason = Account.configuration.taskEnableReportedReason;
    vm.enablePendenciesTab = Account.configuration.featurePendenciesEnabled && authenticatedUser.hasPermission(vm.account, 'pendencies_list');
    vm.featureFlags = FeatureFlags || [];
    vm.hasFeatureFlag = hasFeatureFlag;
    vm.hasNewOsLaunchFeatureFlag = hasFeatureFlag('new-order-launch-beta-flag');
    vm.isTestAccount = isTestAccount;

    vm.actions = {
      enableShareSingleTask: false,
      enableShareMultipleTask: false,
      allowMultipleTasks: false
    };

    vm.requiredFormsErr = {};
    vm.ticket = Ticket;
    vm.errorInvalidDateOrTime = false;
    vm.errorCloseTaskWithPastDate = false;
    vm.validateDateAndTime = validateDateAndTime;
    vm.equipmentTypes = [];
    vm.employeesWithoutSkill = [];
    vm.hideBorder = hideBorder;
    vm.showIntegrationButton = showIntegrationButton;
    vm.openIntegrationDialog = openIntegrationDialog;
    vm.openLaunchDialog = openLaunchDialog;
    vm.integrations = IntegrationsService.getAll();
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['order-description'];
    vm.taskSmartRewriteFields = ['task-description', 'task-status-description'];

    function _getAlreadySelectedEmployees() {
      var alreadySelectedEmployees = [];

      (vm.tasks || []).map(function (task) {
        if (task.employee && task.employee.id) {
          var employee = _.find(vm.employees, function (employee) {
            return employee.id == task.employee.id;
          });

          if (employee) {
            alreadySelectedEmployees.push(employee);
          }
        }
        if (task.secondaryEmployees && task.secondaryEmployees.length) {
          task.secondaryEmployees.forEach(function (employeeId) {
            var employee = _.find(vm.employees, function (employee) {
              return employee.id == employeeId;
            });

            if (employee) {
              alreadySelectedEmployees.push(employee);
            }
          });
        }
      });

      return alreadySelectedEmployees;
    }

    function _resetEmployeesOptions() {
      var alreadySelectedEmployees = _getAlreadySelectedEmployees();

      var sortedEmployees = _.sortBy(vm.employees, function (employee) {
        return employee.kmDistance;
      });

      var defaultEmployees = sortedEmployees.slice(0, 25);

      vm.employeesOptions = _.uniq(defaultEmployees.concat(alreadySelectedEmployees), function (item) {
        return item._id;
      });

      vm.employeesOptions.forEach(function (employee) {
        employee.priority = '0';
      });
    }

    function setEmployeesOptions() {

      if (!vm.employeeSearchTerm) return _resetEmployeesOptions();

      var employeesBySearchTerm = _.filter(vm.employees, function (employee) {
        return employee.name && employee.name.trim().toLowerCase().includes(vm.employeeSearchTerm.trim().toLowerCase());
      }).slice(0, 25);

      var alreadySelectedEmployees = _getAlreadySelectedEmployees();

      employeesBySearchTerm.forEach(function (employee) {
        employee.priority = '0';
      });

      alreadySelectedEmployees.forEach(function (employee) {
        employee.priority = '1';
      });

      vm.employeesOptions = _.uniq(employeesBySearchTerm.concat(alreadySelectedEmployees), function (item) {
        return item._id;
      });
    }

    function showIntegrationButton(appName) {
      if (appName === 'Conta Azul') {
        return vm.integrations.contaAzul;
      }
      if (appName === 'Omie') {
        return vm.integrations.omie;
      }
      return false;
    }

    function hideBorder() {
      return commentTabIndex === vm.selectedTabIndex;
    }

    function _getHideFeedBackForm() {
      return $localStorage.get("hideOrderFeedbackForm");
    }

    function closeFeedback() {
      vm.hideFeedbackForm = true;
      $localStorage.set("hideOrderFeedbackForm", 'true');
    }

    function _getEquipmentHideFeedBackForm() {
      return $localStorage.get("hideOrderEquipmentFeedbackForm");
    }

    function closeEquipmentFeedback() {
      vm.hideEquipmentFeedbackForm = true;
      $localStorage.set("hideOrderEquipmentFeedbackForm", 'true');
    }

    function hasFeatureFlag(name) {
      var hasFeature = vm.featureFlags.find(function (featureFlag) {
        return featureFlag.name === name;
      });

      if (!hasFeature) { return false; }

      return hasFeature.active;
    }

    function isTestAccount() {
      return vm.account && vm.account.plan && vm.account.plan.name && vm.account.plan.name === 'test';
    }

    function loadMorePendencies() {
      if (vm.lastTrackedTab != 'pendencies') { return; }
      if (vm.pendencies.totalCount <= vm.pendencies.items.length) { return; }

      _getPendencies();
    }

    vm.isAddingNewTask = false;
    vm.lockNewTaskCreationIfPreviousWasNotCompleted = false;
    vm.onlyAllowNewTaskIfPreviousWasCompleted = Account.configuration.featureOnlyAllowNewTaskIfPreviousWasCompleted;
    vm.isPendingTasksEnabled = isPendingTasksEnabled;

    var contractorIdFromFSM = vm.order && vm.order.metadata && vm.order.metadata.contractor && vm.order.metadata.contractor.id;
    var contractorIdFromCMMS = vm.order && vm.order.metadata && vm.order.metadata.sammathnaur && vm.order.metadata.sammathnaur.contractor && vm.order.metadata.sammathnaur.contractor.id;

    vm.contractorId = contractorIdFromFSM || contractorIdFromCMMS;

    if (vm.onlyAllowNewTaskIfPreviousWasCompleted) {
      if (!vm.order) {
        vm.lockNewTaskCreationIfPreviousWasNotCompleted = true;
      }
      if (vm.order && vm.order.tasks && vm.order.tasks.length) {
        vm.order.tasks.forEach(function (task) {
          var openedStatus = ["scheduled", "in-progress", "on-route"];
          if (_.includes(openedStatus, task.status)) {
            vm.lockNewTaskCreationIfPreviousWasNotCompleted = true;
          }
        });
      }
    }

    function openIntegrationDialog($event, tasks, appName) {
      if (!CheckEditPermission.hasPermission() && vm.order.id) {
        return;
      }

      if (appName === 'Conta Azul') {
        $rootScope.loadingProgress = true;
        return TasksExportDialog.openExportTaskDialog({
          $event: $event,
          tasks: tasks,
          configuration: vm.accountConfiguration,
          appName: appName
        });
      }

      FcModalService.open($event, {
        title: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.ACCOUNT'),
        content: $translate.instant('TASKS.DIALOG.ACTIONS.SELECT_THE_ACCOUNT'),
        paddingSmall: true,
        hasOmieAccountSelector: true,
        rightContinueButton: true,
        rightButtonText: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'),
        leftButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
        handleRightButton: function (account) {
          $rootScope.loadingProgress = true;
          TasksExportDialog.openExportTaskDialog({
            $event: $event,
            tasks: tasks,
            configuration: vm.accountConfiguration,
            appName: appName,
            accounts: vm.omieAccounts,
            selectedAccount: account
          });
        }
      });
    }

    function countAnsweredForms(order) {
      if (order.forms && order.forms.length) {
        var answeredForms = 0;

        order.forms.forEach(function (form) {
          if (!form.archived && form.status === 'done') {
            answeredForms++;
          }
        });

        return answeredForms;
      }
      return 0;
    }

    function _getForms() {
      ordersApi.getForms(vm.order.id).then(function (forms) {
        vm.order.forms = ordersFormsMapper.toView(forms);
        vm.order.untouchedForms = angular.copy(vm.order.forms);

        vm.order.forms.forEach(function (form) {
          form.untouchedFormHash = hasher.sha1ButIgnoreNGHashKey(form);
        });

        vm.order.forms = _.sortBy(vm.order.forms, function (form) {
          return form.archived;
        });

        vm.order.untouchedForms.forEach(function (untouchedForm) {
          untouchedForm.hash = hasher.sha1ButIgnoreNGHashKey(untouchedForm);
        });

        if (vm.order.forms.length) {
          vm.selectedFormIndex = 0;
          vm.order.form = vm.order.forms[vm.selectedFormIndex];
          vm.scoredQuestions = getScoredQuestions(vm.order.form);
          vm.order.form._createdAt = LocalDateConvert.formatDate(vm.order.form.metadata.createdAt, 'date-time-seconds');

          vm.order.tasks.forEach(function (task, index) {
            checkRequiredForms({
              status: task.status,
              taskIndex: index
            });
          });
        }
        _getEquipmentsForms();
      });
    }

    function _getPendencies() {
      $rootScope.loadingProgress = true;
      var cursor = vm.pendencies.pageInfo ? vm.pendencies.pageInfo.endCursor : null;
      ordersPendenciesApiGraphQL.getPendencies(vm.order.id, cursor, 10).then(function (result) {
        orderPendenciesService.setPendencies(result);
        vm.pendencies = orderPendenciesService.getPendencies();
        vm.loadedTabs.pendencies = true;
        $rootScope.loadingProgress = false;
      });
    }

    function _getOrderRoutes() {
      $rootScope.loadingProgress = true;
      ordersRoutesApiGraphQL.getRoute(vm.order.id).then(function (result) {
        orderRoutesService.setRoutes(result);
        vm.routes = orderRoutesService.getRoutes();
        vm.loadedTabs.routes = true;
        $rootScope.loadingProgress = false;
      });
    }

    function _initializeDialog() {
      _setupConfigurations();

      var deferred = $q.defer();

      omieApi.accounts.list()
        .then(function (res) {

          if (!res.data || !res.data.Items || !res.data.Items.length) {
            deferred.resolve([{
              value: {
                name: null,
                appId: null
              }
            }]);
            return;
          }


          var accounts = res.data.Items.map(function (item) {
            return {
              value: {
                name: item.accountName,
                appId: item.appId
              }
            };
          });

          deferred.resolve(accounts);
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      deferred.promise.then(function (accounts) {
        vm.omieAccounts = accounts;

        if (vm.order && vm.order.customer) {
          var accountValues = _.map(vm.omieAccounts, 'value');
          var account = _.find(accountValues, { 'appId': vm.order.customer.externalAppId });
          var omieCustomerAccoutName = account ? account.name : null;
          vm.selectedCustomer.omieAccount = omieCustomerAccoutName;
        }
      });

      if (vm.order) {
        vm.hasCorporateDeadlineContractPermission = Boolean(vm.order && vm.order.metadata && vm.order.metadata.deadlineContract);
        vm.configurations.featureDisableEditDeadlineContract = vm.order && vm.order.metadata && vm.order.metadata.featureDisableEditDeadlineContract;

        if (!vm.editPermission) {
          vm.order.locked = true;
        }

        vm.order.customer = vm.order.customer || {};
        vm.order.customer.contacts = vm.order.customer.contacts || {};

        vm.selectedCustomer = {
          id: vm.order.customer.id,
          name: vm.order.customer.name,
          contact: vm.order.customer.contact,
          contacts: vm.order.customer.contacts,
          notes: vm.order.customer.notes,
          address: vm.order.customer.address,
          statistics: vm.order.customer.statistics,
          avatarUrl: vm.order.customer.avatarUrl,
          metadata: vm.order.customer.metadata
        };

        if (vm.order.location) {
          vm.selectedCustomerLocation = {
            id: vm.order.location.id,
            name: vm.order.location.name,
            notes: vm.order.location.notes,
            address: vm.order.location.address
          };

          checkIfEmployeeIsInLocation(vm.order.location.id);
        }

        if (vm.selectedCustomer.contacts) {
          vm.selectedCustomer.primaries = {
            email: _.find(vm.selectedCustomer.contacts.emails, 'primary'),
            phone: _.find(vm.selectedCustomer.contacts.phones, 'primary'),
          };
        }

        //Forms handling
        _getForms();

        //Sla handling
        if (vm.order.deadlineAt) {
          vm.order._deadlineAt = moment(vm.order.deadlineAt).toDate();
        }

        //Labels handling
        vm.order.idLabels = [];

        if (vm.order.labels && vm.order.labels.length) {
          vm.order.idLabels = _.map(vm.order.labels, 'id');
        }

        //Service handling
        if (vm.order.service && vm.order.service.id) {
          var orderService = _.find(vm.allServices, function (service) {
            return service.id === parseInt(vm.order.service.id);
          });

          if (orderService && orderService.archived) {
            vm.services.push(orderService);
          }

          vm.order.service = angular.copy(orderService);

          if (vm.order.service.form && vm.order.service.form.id) {
            formsApi.get(vm.order.service.form.id).then(function (form) {
              vm.order.service.form = form;
            });
          }
        }

        vm.selectedService = {
          id: vm.order.service.id,
          description: vm.order.service.description,
          duration: vm.order.service.duration,
          metadata: vm.order.service.metadata
        };

        //Events handling
        var orderCopy = angular.copy(vm.order);

        vm.tasks = vm.order.tasks || [];
        vm.tasks = OrderDialog.sortTasks(vm.tasks);

        vm.order.untouchedTasks = angular.copy(vm.tasks);
        vm.order.untouchedTasks.forEach(function (untouchedTask) {
          untouchedTask.order = { id: untouchedTask.order.id };
          untouchedTask.hash = hasher.sha1ButIgnoreNGHashKey(untouchedTask);
        });

        if (vm.order.customer.id && vm.order.location) {
          locationsApiGraphQL.getCustomerLocationsContacts(vm.order.customer.id, vm.order.location.name, vm.order.address.street).then(function (result) {
            result.emails.forEach(function (email) {
              email.checked = false;
            });
            vm.order.customer.allLocationsContacts = result;
            vm.noHaveEmails = vm.order.customer.allLocationsContacts.emails.length == 0 && vm.order.customer.contacts.emails.length == 0 ? true : false;
          });
        }

        if (!vm.tasks.length) {
          addTask();
        }

        vm.tasks.forEach(function (task, index) {
          task.scheduling.date = task.scheduling.date && moment(task.scheduling.date).toDate();
          task.startedAtDate = task.startedAt ? moment(task.startedAt).toDate() : null;
          task.startedAtTime = task.startedAt ? dateHandler.dateUtcToLocalTimeString(task.startedAt).split(' ')[0] : null;
          task.startedAtTimeFormat = task.startedAt ? dateHandler.dateUtcToLocalTimeString(task.startedAt).split(' ')[1] : null;

          task.completedAtDate = task.completedAt ? moment(task.completedAt).toDate() : null;
          task.completedAtTime = task.completedAt ? dateHandler.dateUtcToLocalTimeString(task.completedAt).split(' ')[0] : null;
          task.completedAtTimeFormat = task.completedAt ? dateHandler.dateUtcToLocalTimeString(task.completedAt).split(' ')[1] : null;

          task.order = orderCopy;
          task.minDate = moment('2015-01-01').toDate();
          vm.employeesCheckAbsent(task);

          //Employee handling
          if (task.employee && task.employee.id && task.employee.id !== 'null') {
            var taskEmployee = _.find(vm.employees, function (employee) {
              return employee.id === task.employee.id;
            });

            if (!taskEmployee) {
              taskEmployee = _.find(vm.allEmployees, function (employee) {
                return employee.id === task.employee.id;
              });
              vm.employees.push(taskEmployee);
              task._currentEmployeeId = taskEmployee ? taskEmployee.id : null;
            } else {
              task._currentEmployeeId = taskEmployee.id;
            }
          }

          if (!vm.configurations.featureCreateTaskWithPastDate) {
            task.minDate = moment(task.metadata.createdAt).clone().startOf('day').subtract(1, 'ms').toDate();
          }

          if (task.scheduling.time) {
            if (vm.timeFormatIsActive) {
              if (task.scheduling.time.split(':')[0] >= 12) {
                task.scheduledTimeFormat = 'pm';
                task.scheduling.time = task.scheduling.time.split(':');

                if (task.scheduling.time[0] > 12) {
                  task.scheduling.time[0] = task.scheduling.time[0] - 12;
                }

                if (task.scheduling.time[0] < 10) {
                  task.scheduling.time[0] = '0' + task.scheduling.time[0];
                }

                task.scheduling.time = task.scheduling.time[0] + ':' + task.scheduling.time[1] + ' pm';
              } else {
                task.scheduledTimeFormat = 'am';
                task.scheduling.time = task.scheduling.time.split(':');

                if (task.scheduling.time[0] === '00') {
                  task.scheduling.time[0] = '12';
                }

                task.scheduling.time = task.scheduling.time[0] + ':' + task.scheduling.time[1] + ' am';
              }

              task.scheduling.time = task.scheduling.time.split(' ')[0];
            }
            task.scheduling.time = task.scheduling.time.split(':');
            task.scheduling.time = task.scheduling.time[0] + ':' + task.scheduling.time[1];
          }

          if (task.startedAtTime) {
            task.startedAtTime = task.startedAtTime.split(':');
            task.startedAtTime = task.startedAtTime[0] + ':' + task.startedAtTime[1];
          }

          if (task.completedAtTime) {
            task.completedAtTime = task.completedAtTime.split(':');
            task.completedAtTime = task.completedAtTime[0] + ':' + task.completedAtTime[1];
          }

          tasksApi.getSecondaryEmployees(task.id).then(function (secondaryEmployees) {
            task.secondaryEmployees = secondaryEmployees.map(function (employee) {
              return employee.id;
            });
          });
        });

        //Events handling
        if (vm.tasks.length === 1) {
          vm.tasks[0].sendRatingEmail = vm.tasks[0].status === 'done' ? true : false;

          if (vm.tasks[0].status !== 'pending') {
            vm.actions.enableShareSingleTask = true;
          }
        } else {
          vm.actions.enableShareMultipleTask = _.some(vm.tasks, function (task) {
            return task.status !== 'pending';
          });
        }

        _configureMap({
          location: vm.order.address.coords,
          draggable: true
        });

        //Equipments handling
        _getEquipmentsFromOrder();
        _getMobilePhones();
        _getPendencies();

        if (vm.accountConfiguration.partnerName === 'notro') {
          _getOrderRoutes();
        }

        vm.orderDeadlineContractId = null;
        if (vm.order.deadline && vm.order.deadline.contract && vm.order.deadline.contract.id) {
          vm.orderDeadlineContractId = vm.order.deadline.contract.id;
          vm.order.untouchedDeadline = hasher.sha1ButIgnoreNGHashKey(vm.orderDeadlineContractId);

          if (vm.order.deadline.responseViolationReason && vm.order.deadline.responseViolationReason.id) {
            vm.order.untouchedResponseDeadlineViolationReason = hasher.sha1ButIgnoreNGHashKey(vm.order.deadline.responseViolationReason.id);
          }

          if (vm.order.deadline.solutionViolationReason && vm.order.deadline.solutionViolationReason.id) {
            vm.order.untouchedSolutionDeadlineViolationReason = hasher.sha1ButIgnoreNGHashKey(vm.order.deadline.solutionViolationReason.id);
          }
        }
      } else {
        vm.configurations.featureDisableEditDeadlineContract = vm.ticket && vm.ticket.metadata && vm.ticket.metadata.featureDisableEditDeadlineContract;
        vm.hasCorporateDeadlineContractPermission = Boolean(vm.ticket && vm.ticket.metadata && vm.ticket.metadata.deadlineContract);

        if (vm.ticket && vm.ticket.metadata && vm.ticket.metadata.deadlineContract && vm.ticket.metadata.deadlineContract.id) {
          vm.orderDeadlineContractId = vm.ticket.metadata.deadlineContract.id;
        }

        vm.order = {
          address: {
            coords: {}
          },
          service: {
            id: null
          },
          idLabels: []
        };

        vm.isCreatingOrder = true;

        vm.tasks.push({
          sessionId: msUtils.uuidGenerator(),
          status: 'scheduled',
          employee: {
            id: null
          },
          scheduling: {
            date: moment().toDate(),
            time: null
          },
          coords: {},
          position: 0,
          archived: false,
          minDate: vm.configurations.featureCreateTaskWithPastDate ? moment('2015-01-01').toDate() : moment().toDate()
        });

        vm.employeesCheckAbsent(vm.tasks[0]);

        _configureMap({
          location: vm.order.address.coords,
          draggable: true
        });

        if (Data) {
          if (Data.scheduling && Data.scheduling.date) {
            vm.tasks[0].scheduling.date = moment(Data.scheduling.date).toDate();
          }

          if (Data.scheduling && Data.scheduling.time) {
            vm.tasks[0].scheduling.time = Data.scheduling.time;
          }

          if (Data.employee) {
            vm.tasks[0].employee = Data.employee;
            vm.tasks[0]._currentEmployeeId = Data.employee.id;
          }

          if (Data.duration) {
            vm.tasks[0].duration = Data.duration;
            vm.tasks[0]._duration = Data.duration;
          }

          if (Data.position) {
            vm.tasks[0].position = Data.position;
          }

          if (Data.ticket) {
            $timeout(function () {
              if ($scope.orderForm) {
                $scope.orderForm.$setDirty();
              }
            }, 1000);

            vm.order.ticket = {
              id: Data.ticket.id,
              metadata: Data.ticket.metadata
            };

            if (Data.ticket.metadata) {
              var hasScheduledDate = !!(vm.ticket && vm.ticket.metadata && vm.ticket.metadata.selectedScheduleSuggestion && vm.ticket.metadata.selectedScheduleSuggestion.date);
              if (Data.ticket.metadata.scheduling && !hasScheduledDate) {
                if (Data.ticket.metadata.scheduling.date) {
                  vm.tasks[0].scheduling.date = moment(Data.ticket.metadata.scheduling.date, 'YYYY-MM-DD').toDate();
                }

                if (Data.ticket.metadata.scheduling.time) {
                  vm.tasks[0].scheduling.time = Data.ticket.scheduling.time;
                }
              }
            }

            var description = $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.DESCRIPTION.DEFAULT_FROM_OS.NAME') + Data.ticket.name;

            if (Data.ticket.subject) {
              description += '\n' + $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.DESCRIPTION.DEFAULT_FROM_OS.SUBJECT') + Data.ticket.subject;
            }

            if (Data.ticket.contact) {
              if (Data.ticket.contact.email) {
                description += '\n' + $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.DESCRIPTION.DEFAULT_FROM_OS.EMAIL') + Data.ticket.contact.email;
              }
              if (Data.ticket.contact.phone) {
                description += '\n' + $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.DESCRIPTION.DEFAULT_FROM_OS.PHONE') + Data.ticket.contact.phone;
              }
            }

            if (Data.ticket.number) {
              description += '\n' + $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.DESCRIPTION.DEFAULT_FROM_OS.NUMBER') + Data.ticket.number;
            }

            if (Data.ticket.createdAt) {
              description += '\n' + $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.DESCRIPTION.DEFAULT_FROM_OS.DATE') + LocalDateConvert.formatDate(Data.ticket.createdAt, 'date-time');
            }

            vm.order.description = (description + '').trim();

            if (Data.description) {
              vm.order.description += '\n\n' + Data.description;
            }
          }

          if (Data.description && !Data.ticket) {
            vm.order.description = Data.description;
          }


          if (Data.identifier) {
            vm.order.identifier = Data.identifier;
          }

          if (Data.customer) {
            vm.selectedCustomer = Data.customer;

            var location = null;

            if (Data.location) {
              location = angular.copy(Data.location);

              if (Data.ticket && Data.ticket.metadata && Data.ticket.metadata.address) {
                location.address = Data.ticket.metadata.address;
              }

              vm.selectedCustomerLocation = location;
              selectedCustomerLocationChanged(location);
            }

            selectedCustomerChanged(location);
          }

          if (Data.service) {
            vm.order.service.id = Data.service.id;
            onSelectedService();
          }

          vm.disableByTicket = false;
          if (Data.origin === 'ticket' && vm.order.service && vm.order.service.id > 0) {
            vm.disableByTicket = true;
          }

          if (Data.equipments) {
            vm.selectedEquipments = Data.equipments;
            Data.equipments.forEach(function (equipment) {
              selectedEquipmentItemChange(equipment);
            });
            searchEquipments();
          }

          if (isToUseTicketAddress && Data.ticket && Data.ticket.metadata && Data.ticket.metadata.address) {
            var ticketAddress = Data.ticket.metadata.address;
            vm.order.address = {
              city: ticketAddress.city,
              complement: ticketAddress.complement,
              neighborhood: ticketAddress.neighborhood,
              number: ticketAddress.number,
              state: ticketAddress.state,
              street: ticketAddress.street,
              zipCode: ticketAddress.postalCode || ticketAddress.zipCode,
              formattedAddress: msUtils.formatAddress(ticketAddress)
            };

            if (ticketAddress.coords) {
              _setOrderCoords(ticketAddress.coords);
            }
          }

          if (Data.featureDisableEditCustomer) {
            vm.order.metadata = vm.order.metadata || {};
            vm.order.metadata.featureDisableEditCustomer = true;
          }
        }

        vm.tasks[0].scheduledDate = vm.tasks[0].scheduling.date;
      }

      locationsApi.getLastedLocations().then(function (locations) {
        vm.employees.forEach(function (employee) {
          employee.isOnline = null;
        });

        vm.locations = locations;

        vm.locations.forEach(function (location) {
          var employee = _.find(vm.employees, function (employee) {
            return employee.id === location.employeeId;
          });

          if (employee) {
            var locationTime = moment.utc(location.timestamp);
            var utcNow = moment.utc();
            var diffInMinutes = utcNow.diff(locationTime, 'minutes');

            employee.isOnline = (diffInMinutes < 20);
            employee.location = location;
          }
        });

        vm.calculateDistanceFromCoords();
      });

      vm.hasLabelsPermission = authenticatedUser.hasPermission(vm.account, 'settings-registers_labels_menu');
      vm.actions.allowMultipleTasks = Account.configuration.ordersWithMultipleTasksOn;
      vm.ordersIdentifierType = Account.configuration.activitiesIdentifierType;
      vm.disableIdentifierInput = (Account.configuration.activitiesIdentifierType !== 'none');
      vm.customerIsCorporate = !!msUtils.getCorporateAccountUuidFromCustomer(vm.selectedCustomer);

      updateIdentifierDisabledAndRequiredState();
      updateServiceValidationState();
      updateCustomerValidationState();

      if (vm.account.configuration.featureValidateEmployeeIsInMoreThanOneTaskAtTheSameTime) {
        $scope.$watch('vm.tasks', function () {
          vm.tasks = validateEmployeeIsInMoreThanOneTaskAtTheSameTime.validate(vm.tasks, vm.account, vm.formErr);
        });
      }

      if (vm.selectedCustomer && vm.selectedCustomer.contacts) {
        vm.selectedCustomer.contacts.hasEmail = _contactsWithEmail();
        vm.selectedCustomer.contacts.hasPhone = _contactsWithPhone();
      }

      if (vm.accountConfiguration && !vm.accountConfiguration.ordersUploadFilesLimit) {
        vm.accountConfiguration.ordersUploadFilesLimit = 20;
      }

      if ($rootScope.customData && $rootScope.customData.startTourAfterAddTask) {
        delete $rootScope.customData.startTourAfterAddTask;

        $timeout(function () {
          FcModalService.open(null, {
            title: $translate.instant("CORE.WELCOME"),
            templateUrl: 'app/core/tutorial/fc-tutorial-dialog.html',
            closeButtonIconPath: 'assets/icons/icon-close.svg',
            titleIconPath: 'assets/icons/rocket.svg',
            rightButtonText: $translate.instant("CORE.WELCOME_CLOSE_DIALOG"),
            handleClose: function () {
              var element = document.querySelector('.fc-fixed-tooltip--hidden');
              if (element) {
                element.classList.remove('fc-fixed-tooltip--hidden');
              }
            },
            large: true
          });
        }, 1000);

        if (vm.selectedCustomer && vm.selectedCustomer.contacts) {
          vm.selectedCustomer.contacts.hasEmail = _contactsWithEmail();
        }

        $timeout(function () {
          $scope.orderForm.$setDirty();
        }, 5000);
      }

      equipmentTypesApi.getEquipmentTypes().then(function (types) {
        vm.equipmentTypes = types.items || [];
      }).catch(function () {
        vm.equipmentTypes = [];
      });

      checkDisableInputs();

      vm.tasks.forEach(function (task) {
        task.oldStatus = task.status;
        task.oldCompletedAtDate = task.completedAtDate;
        task.oldCompletedAtTime = task.completedAtTime;
        task.oldStartedAtDate = task.startedAtDate;
        task.oldStartedAtTime = task.startedAtTime;
      });

      if (enableCreateCustomer) {
        prepareToCreateNewCustomerWithTicketMetadata(vm.ticket);
      }


      $timeout(function () {
        vm.tasks.forEach(function (_task, index) {
          var schedulingDateControl = $scope.orderForm['scheduling_date_' + index];
          if (schedulingDateControl && schedulingDateControl.$invalid) {
            schedulingDateControl.$setTouched();
          }
        });
      }, 1000);

      getUserTerritories();
    }

    function prepareToCreateNewCustomerWithTicketMetadata(ticket) {
      delete vm.formErr['customerIsRequired'];
      vm.isNewCustomer = true;

      vm.selectedCustomer = {
        name: ticket && ticket.name,
        address: null,
        contacts: {
          emails: [{
            address: ticket && ticket.email || '',
            type: 'personal',
            primary: true
          }],
          phones: [{
            number: ticket && ticket.contact && ticket.contact.phone || '',
            type: 'home',
            primary: true,
            countryCode: '55'
          }]
        }
      };

      if (ticket && ticket.metadata && ticket.metadata.address) {
        geoCoder.getByAddressObject(ticket.metadata.address).then(function (geolocation) {
          if (!geolocation) { return; }

          var address = Object.assign({}, ticket.metadata.address, geolocation, {
            formattedAddress: msUtils.formatAddress(ticket.metadata.address)
          });

          selectedAddressItemChange(address, true);
        });
      }

      vm.order.address = null;
      vm.order.customer = null;

      vm.tasks.forEach(function (task) {
        task.coords.latitude = null;
        task.coords.longitude = null;
      });
      vm.addOrEditCustomer = true;

      $timeout(function () {
        var canEnableSaveButton = $scope.orderForm && vm.selectedAddress && vm.selectedCustomer && vm.selectedCustomer.name;
        if (canEnableSaveButton) {
          $scope.orderForm.$dirty = true;
          $scope.orderForm.$pristine = false;
        }
      }, 1000);

      $timeout(function () {
        if ($scope.orderForm) {
          $scope.orderForm.$setValidity('customerAddress', true, window);
        }
        focus('customerName');
      }, 1000);
      vm.googleCustomerAddressErrors = [];
      vm.googleCustomerAddressWarnings = [];
    }

    function _setupConfigurations() {
      vm.configurations.featureCreateTaskWithPastDate = msUtils.getConfiguration('featureCreateTaskWithPastDate', [
        vm.order && vm.order.metadata,
        Account.configuration
      ]);

      if (vm.ticket && vm.ticket.metadata && vm.ticket.metadata.hasOwnProperty('featureCreateTaskWithPastDate')) {
        vm.configurations.featureCreateTaskWithPastDate = msUtils.getConfiguration('featureCreateTaskWithPastDate', [
          vm.ticket && vm.ticket.metadata
        ]);
      }

      vm.configurations.featureCloseTaskWithPastDate = msUtils.getConfiguration('featureCloseTaskWithPastDate', [
        vm.order && vm.order.metadata,
        Account.configuration
      ]);

      vm.configurations.featureCloseTaskWithFutureDate = msUtils.getConfiguration('featureCloseTaskWithFutureDate', [
        vm.order && vm.order.metadata,
        Account.configuration
      ]);

      vm.configurations.featureCancelationDescriptionRequired = msUtils.getConfiguration('featureCancelationDescriptionRequired', [
        vm.order && vm.order.metadata
      ]);
    }

    function validateIdentifier() {
      var errors = msUtils.checkOrderIdentifierHashErrors(vm.order.identifier);
      $scope.orderForm.identifier.$setValidity('identifierHashValid', errors.identifierHashValid);
    }

    function isPendingTasksEnabled() {
      var configuration = Account.configuration.taskEnablePendingStatus;
      if (!configuration) {
        return false;
      }

      var metadata = vm.selectedCustomer && vm.selectedCustomer.metadata;
      if (metadata && (metadata.integration === 'bradesco-pat')) {
        return false;
      }

      return true;
    }

    function checkDisableInputs() {
      checkDisableCustomerSelectInput();
      checkDisableServiceSelectInput();
      checkDisableLocationSelectInput();
      checkDisableTaskInput();
      checkDisableScheduleSuggestionInputOnCreateTaskDialog();
      checkDisableSheduleInputOnEditTaskDialog();
    }

    vm.featureDisableEditCustomer = false;

    function checkDisableCustomerSelectInput() {
      if (vm.order && vm.order.ticket && vm.order.ticket.metadata && vm.order.ticket.metadata.featureDisableEditCustomer) {
        vm.featureDisableEditCustomer = true;
      }
      if (vm.order.metadata && vm.order.metadata.featureDisableEditCustomer) {
        vm.featureDisableEditCustomer = true;
      }
    }

    vm.featureDisableEditService = false;

    function checkDisableServiceSelectInput() {
      var featureCreateTicketSelectServiceDisableOn = Account.configuration.featureCreateTicketOrderSelectServiceDisableOn;
      var hasOrder = !!vm.order;
      var hasSelectedService = vm.order.service && vm.order.service.id;
      var hasMetadataToDisableEditService = vm.order.ticket && vm.order.ticket.metadata && vm.order.ticket.metadata.featureDisableEditService;

      if (featureCreateTicketSelectServiceDisableOn && (vm.order.id || vm.disableByTicket)) {
        vm.featureDisableEditService = true;
      }
      if (hasOrder && hasSelectedService && hasMetadataToDisableEditService) {
        vm.featureDisableEditService = true;
      }
      if (vm.order.metadata && vm.order.metadata.featureDisableEditService) {
        vm.featureDisableEditService = true;
      }
    }

    vm.featureDisableEditLocation = false;

    function checkDisableLocationSelectInput() {
      if (vm.order && vm.order.ticket && vm.order.ticket.metadata && vm.order.ticket.metadata.featureDisableEditLocation) {
        vm.featureDisableEditLocation = true;
      }
      if (vm.order.metadata && vm.order.metadata.featureDisableEditLocation) {
        vm.featureDisableEditLocation = true;
      }
    }

    vm.featureDisableEditTaskStatus = false;
    vm.featureDisableEditTaskCompletedAt = false;
    vm.featureDisableEditTaskStatus = false;
    vm.featureDisableCancelTaskStatus = false;

    function checkDisableTaskInput() {
      if (vm.order.metadata) {
        if (vm.order.metadata.featureDisableEditTaskStartedAt !== undefined) {
          vm.featureDisableEditTaskStartedAt = vm.order.metadata.featureDisableEditTaskStartedAt;
        }
        if (vm.order.metadata.featureDisableEditTaskCompletedAt !== undefined) {
          vm.featureDisableEditTaskCompletedAt = vm.order.metadata.featureDisableEditTaskCompletedAt;
        }
        if (vm.order.metadata.featureDisableEditTaskStatus !== undefined) {
          vm.featureDisableEditTaskStatus = vm.order.metadata.featureDisableEditTaskStatus;
        }

        if (vm.order.metadata.featureDisableCancelTaskStatus !== undefined) {
          vm.featureDisableCancelTaskStatus = vm.order.metadata.featureDisableCancelTaskStatus;
        }
      }

    }

    function checkDisableScheduleSuggestionInputOnCreateTaskDialog() {
      var hasScheduledDate = !!(vm.ticket && vm.ticket.metadata && vm.ticket.metadata.selectedScheduleSuggestion && vm.ticket.metadata.selectedScheduleSuggestion.date);
      var hasScheduledTime = !!(vm.ticket && vm.ticket.metadata && vm.ticket.metadata.selectedScheduleSuggestion && vm.ticket.metadata.selectedScheduleSuggestion.time);

      if (hasScheduledDate) {
        var date = vm.ticket.metadata.selectedScheduleSuggestion.date;
        vm.tasks[0].disableScheduleSuggestionDateInput = hasScheduledDate;
        vm.tasks[0].scheduling.date = moment(date).format();
      };

      if (hasScheduledTime) {
        var time = vm.ticket.metadata.selectedScheduleSuggestion.time;
        vm.tasks[0].disableScheduleSuggestionTimeInput = hasScheduledTime;
        vm.tasks[0].scheduling.time = time;
      };
    }

    function checkDisableSheduleInputOnEditTaskDialog() {
      var scheduleSuggestions = (
        vm.order.metadata &&
        vm.order.metadata.scheduleSuggestions &&
        vm.order.metadata.scheduleSuggestions.suggestions
      );

      if (!scheduleSuggestions || !scheduleSuggestions.length) {
        return;
      }

      vm.tasks[0].disableScheduleSuggestionDateInput = !!(scheduleSuggestions && vm.tasks[0].scheduling.date);
      disableTimeInput(scheduleSuggestions);
    }

    function disableTimeInput(scheduleSuggestions) {
      scheduleSuggestions.forEach(function (suggestion) {
        if (!suggestion.time) {
          return;
        }

        var taskDate = moment(vm.tasks[0].scheduling.date).format('YYYY-MM-DD');
        if (suggestion.date === taskDate) {
          var hasTaskTime = !!(vm.tasks[0].scheduling.time);
          vm.tasks[0].disableScheduleSuggestionTimeInput = hasTaskTime;
        }
      });
    }

    function _contactsWithEmail() {
      if (vm.selectedCustomer && vm.selectedCustomer.contacts) {
        if (vm.selectedCustomer.contacts.emails && vm.selectedCustomer.contacts.emails.length) {
          for (var i = 0; i < vm.selectedCustomer.contacts.emails.length; i++) {
            if (vm.selectedCustomer.contacts.emails[i].address) {
              return true;
            }
          }
        }
      }
      return false;
    }

    function _contactsWithPhone() {
      if (vm.selectedCustomer && vm.selectedCustomer.contacts) {
        if (vm.selectedCustomer.contacts.phones && vm.selectedCustomer.contacts.phones.length) {
          for (var i = 0; i < vm.selectedCustomer.contacts.phones.length; i++) {
            if (vm.selectedCustomer.contacts.phones[i].number) {
              return true;
            }
          }
        }
      }
      return false;
    }

    function _getMobilePhones() {
      if (vm.selectedCustomer && vm.selectedCustomer.contacts) {
        vm.mobilePhones = _.filter(vm.selectedCustomer.contacts.phones, function (phone) {
          return phone.number.length === 11 && phone.number.charAt(2) === '9';
        });
      }
    }

    function _loadServiceForms() {
      if (vm.order && vm.order.service && vm.order.service.forms) {
        var queryParams = {
          where: {
            linkedToService: vm.order.service.id,
            archived: false,
          }
        };

        formsApiGraphQL.getForms(queryParams).then(function (forms) {
          vm.order.service.forms.forEach(function (serviceForm) {
            var form = _.find(forms.items, function (form) {
              return form.id === serviceForm.id;
            });

            if (form) {
              serviceForm.questions = form.questions;
              serviceForm.type = form.type;
              serviceForm.archived = form.archived;
            }
          });
        });
      }
    }

    function openLaunchDialog() {
      var embedVideoUrl = 'https://www.youtube.com/embed/XpvyKNd2Em0?si=xTc7zt6kS7xAJrmt';

      document.dispatchEvent(new CustomEvent('showLaunchDialog', {
        detail: {
          title: $translate.instant('TASKS.DIALOG.LAUNCH_DIALOG.TITLE'),
          description: $translate.instant('TASKS.DIALOG.LAUNCH_DIALOG.DESCRIPTION'),
          videoText: $translate.instant('TASKS.DIALOG.LAUNCH_DIALOG.VIDEO_TEXT'),
          videoUrl: embedVideoUrl,
          rightButton: {
            text: $translate.instant('TASKS.DIALOG.LAUNCH_DIALOG.RIGHT_BUTTON'),
            action: function () {
              accountFeatureFlagsApiGraphQL.updateAccountFeatureFlag('new-order-beta-flag', true).then(function () {
                window.location.reload();
              });
            },
          },
          leftButton: {
            text: $translate.instant('TASKS.DIALOG.LAUNCH_DIALOG.LEFT_BUTTON'),
          },
        }
      }));
    }

    /// Labels
    vm.editLabel = editLabel;
    vm.addNewLabel = addNewLabel;
    vm.updateLabel = updateLabel;
    vm.labelQuerySearch = labelQuerySearch; // <---- isso usa??
    vm.filterLabel = filterLabel;
    vm.getItemById = msUtils.getItemById;
    vm.labels = Labels.items;

    // TODO: Should be extract to somewhere else
    function labelQuerySearch(query) { // <---- isso usa??
      return query ? vm.labels.filter(createFilterFor(query)) : [];
    }

    function filterLabel(label) {
      if (!vm.labelSearchText || vm.labelSearchText === '') {
        return true;
      }
      return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
    }

    function createFilterFor(query) { // <---- isso usa??
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
      };
    }

    function _loadLabels() {
      labelsApi.search({ type: 'orders' }, { limit: 100 }).then(function (result) {
        vm.labels = result.items;
      });
    }

    function addNewLabel(newLabel) {
      newLabel.type = 'orders';

      labelsApi.save(newLabel).then(function () {
        vm.newLabelColor = null;
        vm.newLabelName = null;
        vm.labelTabIndex = 0;

        _loadLabels();

        $rootScope.$broadcast('orders-labels:updated');
        document.dispatchEvent(new CustomEvent('order-dialog:updated'));
      });
    }

    function updateLabel(label) {
      label.type = 'orders';
      labelsApi.save(label).then(function () {
        vm.editingLabel = null;
        vm.labelTabIndex = 0;

        _loadLabels();

        $rootScope.$broadcast('orders-labels:updated');
        document.dispatchEvent(new CustomEvent('order-dialog:updated'));
      });
    }

    function editLabel(label) {
      vm.editingLabel = label;
      vm.labelTabIndex = 2;
    }

    /// Customer Phones
    vm.addPhone = addPhone;
    vm.removePhone = removePhone;
    vm.setPhoneAsPrimary = setPhoneAsPrimary;
    vm.checkPhoneType = _.debounce(checkPhoneType, 500);
    vm.countryCodes = angular.copy(locationsService.countryCodes);
    vm.getMaxLengthByCountryCode = locationsService.getMaxLengthByCountryCode;
    vm.formatPhoneByCountryCode = locationsService.formatPhoneByCountryCode;

    function addPhone() {
      vm.selectedCustomer.contacts.phones = vm.selectedCustomer.contacts.phones || [];
      vm.selectedCustomer.contacts.phones.push({
        number: '',
        type: 'home',
        primary: false,
        countryCode: '55',
        checked: false
      });

      $timeout(function () {
        focus('customer_contacts_phone_number_' + (vm.selectedCustomer.contacts.phones.length - 1));
      }, 300);
    }

    function removePhone(index) {
      var primaryRemoved = false;

      vm.selectedCustomer.contacts.phones = vm.selectedCustomer.contacts.phones || [];
      if (vm.selectedCustomer.contacts.phones[index] && vm.selectedCustomer.contacts.phones[index].primary) {
        primaryRemoved = true;
      }

      vm.selectedCustomer.contacts.phones.splice(index, 1);
      if (primaryRemoved) {
        vm.selectedCustomer.contacts.phones[0].primary = true;
      }
    }

    function setPhoneAsPrimary(index) {
      if (vm.selectedCustomer.contacts.phones[index]) {
        vm.selectedCustomer.contacts.phones.forEach(function (phone) { phone.primary = false; });
        vm.selectedCustomer.contacts.phones[index].primary = true;
      }
    }

    function checkPhoneType(index) {
      if (vm.selectedCustomer.contacts.phones[index]) {
        if (vm.selectedCustomer.contacts.phones[index].countryCode !== '55') { return; }

        var completePhoneNumber = vm.selectedCustomer.contacts.phones[index].number;

        if (completePhoneNumber && completePhoneNumber.length > 10 && completePhoneNumber[2] === '9') {
          vm.selectedCustomer.contacts.phones[index].type = 'mobile';
        } else {
          vm.selectedCustomer.contacts.phones[index].type = 'work';
        }
      }
    }

    /// Customer E-mails
    vm.addEmail = addEmail;
    vm.removeEmail = removeEmail;
    vm.setEmailAsPrimary = setEmailAsPrimary;

    function setEmailAsPrimary(index) {
      if (vm.selectedCustomer.contacts.emails[index]) {
        vm.selectedCustomer.contacts.emails.forEach(function (email) { email.primary = false; });
        vm.selectedCustomer.contacts.emails[index].primary = true;
      }
    }

    function removeEmail(index) {
      var primaryRemoved = false;

      vm.selectedCustomer.contacts.emails = vm.selectedCustomer.contacts.emails || [];
      if (vm.selectedCustomer.contacts.emails[index] && vm.selectedCustomer.contacts.emails[index].primary) {
        primaryRemoved = true;
      }

      vm.selectedCustomer.contacts.emails.splice(index, 1);
      if (primaryRemoved) {
        vm.selectedCustomer.contacts.emails[0].primary = true;
      }
    }

    function addEmail() {
      vm.selectedCustomer.contacts.emails = vm.selectedCustomer.contacts.emails || [];
      vm.selectedCustomer.contacts.emails.push({
        address: '',
        type: 'personal',
        primary: false
      });

      $timeout(function () {
        focus('customer_contacts_email_address_' + (vm.selectedCustomer.contacts.emails.length - 1));
      }, 300);
    }

    /// Customer
    vm.showMoreCustomerInfo = false;
    vm.hasNoLocations = false;
    vm.customersLocations = [];
    vm.searchCustomer = searchCustomer;
    vm.selectedCustomerChanged = selectedCustomerChanged;
    vm.selectedCustomerLocationChanged = selectedCustomerLocationChanged;
    vm.clearSelectedCustomer = clearSelectedCustomer;
    vm.clearSelectedCustomerLocation = clearSelectedCustomerLocation;
    vm.createNewCustomer = createNewCustomer;
    vm.updateCustomerCoords = updateCustomerCoords;
    vm.validateCustomerAddress = validateCustomerAddress;
    vm.isAutoCompleteAddressRequired = isAutoCompleteAddressRequired;
    vm.validateCustomer = validateCustomer;
    vm.validateLocation = validateLocation;
    vm.searchZipCode = searchZipCode;
    vm.customerGeoCodeAddress = customerGeoCodeAddress;
    vm.duplicatedValidation = _.debounce(duplicatedValidation, 500);
    vm.searchCustomerLocation = searchCustomerLocation;
    vm.createFirstCustomerLocation = createFirstCustomerLocation;
    vm.isNewCustomer = false;
    vm.hasOrderLinks = hasOrderLinks;

    function duplicatedValidation(customer, input) {
      documentDuplicatedValidationService.validate(customer, input);
    }

    function customerGeoCodeAddress() {
      geoCoder.getByAddressObject(vm.selectedCustomer.address).then(function (location) {
        if (location) {
          vm.selectedCustomer = vm.selectedCustomer || {};
          vm.selectedCustomer.address = vm.selectedCustomer.address || {};
          vm.selectedCustomer.address.coords = vm.selectedCustomer.address.coords || {};
          vm.selectedCustomer.address.coords.latitude = parseFloat(location.lat);
          vm.selectedCustomer.address.coords.longitude = parseFloat(location.lng);

          vm.selectedCustomer.address.coords.latitude = normalizeCoord(
            vm.selectedCustomer.address.coords.latitude
          );

          vm.selectedCustomer.address.coords.longitude = normalizeCoord(
            vm.selectedCustomer.address.coords.longitude
          );

          var isValidLatitude = !isNaN(vm.selectedCustomer.address.coords.latitude) && vm.selectedCustomer.address.coords.latitude >= -90 && vm.selectedCustomer.address.coords.latitude <= 90;
          var isValidLongitude = !isNaN(vm.selectedCustomer.address.coords.longitude) && vm.selectedCustomer.address.coords.longitude >= -180 && vm.selectedCustomer.address.coords.longitude <= 180;

          if (!isValidLatitude) {
            vm.selectedCustomer.address.coords.latitude = null;
          }

          if (!isValidLongitude) {
            vm.selectedCustomer.address.coords.longitude = null;
          }

          _setOrderCoords({
            latitude: vm.selectedCustomer.address.coords.latitude,
            longitude: vm.selectedCustomer.address.coords.longitude
          });

          mapCentralizeAt();
        } else {
          vm.selectedCustomer = vm.selectedCustomer || {};
          vm.selectedCustomer.address = vm.selectedCustomer.address || {};
          vm.selectedCustomer.address.coords = vm.selectedCustomer.address.coords || {};
          vm.selectedCustomer.address.coords.latitude = null;
          vm.selectedCustomer.address.coords.longitude = null;

          _setOrderCoords(null);
        }
      });
    }

    function normalizeCoord(coord) {
      if (coord == null) return coord;

      var str = coord.toString();

      if (!str.includes('.')) {
        str = str.replace(/^(-?\d{2})/, '$1.');
      }

      return parseFloat(str);
    }

    function searchZipCode() {
      if (vm.selectedCustomer.address && vm.selectedCustomer.address.zipCode) {
        var cep = vm.selectedCustomer.address.zipCode.replace(/\D/g, '');

        cepDbApi.search({ 'zipCode': cep }).then(function (data) {
          if (data) {
            vm.selectedCustomer.address.street = data.logradouro;
            vm.selectedCustomer.address.city = data.cidade;
            vm.selectedCustomer.address.state = data.estado;
            vm.selectedCustomer.address.neighborhood = data.bairro;

            focus('number');
          }
          else {
            vm.selectedCustomer.address.street = '';
            vm.selectedCustomer.address.city = '';
            vm.selectedCustomer.address.state = '';
            vm.selectedCustomer.address.neighborhood = '';
          }
        });
      } else {
        vm.selectedCustomer.address = vm.selectedCustomer.address || {};
        vm.selectedCustomer.address.street = '';
        vm.selectedCustomer.address.city = '';
        vm.selectedCustomer.address.state = '';
        vm.selectedCustomer.address.number = '';
        vm.selectedCustomer.address.neighborhood = '';
      }
    }

    function isAutoCompleteAddressRequired() {
      if (vm.addressModeSelection === 'google' && vm.addOrEditCustomer) {
        return vm.selectedCustomerAddress === null || vm.selectedCustomerAddress === undefined;
      }

      return false;
    }

    function validateCustomerAddress() {
      var addingCustomer = vm.addOrEditCustomer;
      var customerAddressIsSelected = vm.selectedCustomer.address !== null;

      if (addingCustomer && !customerAddressIsSelected) {
        vm.formErr['customerAddressIsRequired'] = $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_ADDRESS.ENTER_VALUE');
        return false;
      } else {
        delete vm.formErr['customerAddressIsRequired'];
        return true;
      }
    }

    function validateCustomer() {
      var notAddingCustomer = !vm.addOrEditCustomer;
      var customerIsNotSelected = !vm.selectedCustomer;

      if (notAddingCustomer && customerIsNotSelected) {
        vm.formErr['customerIsRequired'] = $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.ENTER_VALUE');
        return false;
      } else {
        delete vm.formErr['customerIsRequired'];
        return true;
      }
    }

    function _sanitizeLocation(location) {
      var sanitizedLocation = angular.copy(location);
      if (!sanitizedLocation.address.postalCode) delete sanitizedLocation.address.postalCode;
      if (!sanitizedLocation.address.city) delete sanitizedLocation.address.city;
      if (!sanitizedLocation.address.state) delete sanitizedLocation.address.state;
      if (!sanitizedLocation.address.street) delete sanitizedLocation.address.street;
      if (!sanitizedLocation.address.neighborhood) delete sanitizedLocation.address.neighborhood;
      if (!sanitizedLocation.address.number) delete sanitizedLocation.address.number;
      if (!sanitizedLocation.address.complement) sanitizedLocation.address.complement = null;

      return sanitizedLocation;
    }

    function validateLocation() {
      return vm.selectedCustomerLocation;
    }

    function updateCustomerCoords(task, newCustomer) {
      if (newCustomer) {
        vm.selectedCustomer.address.coords = {
          latitude: task.coords.latitude,
          longitude: task.coords.longitude
        };

        vm.setNewCustomerLocation = false;
      }

      if (!newCustomer && vm.order.location) {
        $rootScope.loadingProgress = true;

        vm.order.location.coords = {
          latitude: task.coords.latitude,
          longitude: task.coords.longitude
        };

        vm.order.location.address.coords = {
          latitude: task.coords.latitude,
          longitude: task.coords.longitude
        };

        var locationPayload = _sanitizeLocation(vm.order.location);

        customersApi.saveLocation(vm.order.customer.id, locationPayload).then(function () {
          _setOrderCoords(task.coords);

          MessageDialog.showToast({
            hideDelay: 7000,
            message: $translate.instant('TASKS.TOASTS.LOCATION.CUSTOMER_GEOLOCATION_UPDATED', { customerName: vm.order.customer.name })
          });
        }).finally(function () {
          $rootScope.loadingProgress = false;
          vm.setNewCustomerLocation = false;
          vm.isNewCustomer = false;
        });
      }

      if (!newCustomer && !vm.order.location) {
        $rootScope.loadingProgress = true;

        var patchCustomers = {
          id: vm.order.customer.id,
          address: {
            coords: {
              latitude: task.coords.latitude,
              longitude: task.coords.longitude
            }
          }
        };

        customersApi.patchCustomers([patchCustomers]).then(function () {
          _setOrderCoords(task.coords);

          MessageDialog.showToast({
            hideDelay: 7000,
            message: $translate.instant('TASKS.TOASTS.LOCATION.CUSTOMER_GEOLOCATION_UPDATED', { customerName: vm.order.customer.name })
          });
        }).finally(function () {
          $rootScope.loadingProgress = false;
          vm.setNewCustomerLocation = false;
          vm.isNewCustomer = false;
        });
      }
    }

    function updateIdentifierDisabledAndRequiredState() {
      var customerHasCorporateAccountUuid = !!msUtils.getCorporateAccountUuidFromCustomer(vm.selectedCustomer);
      var identifierTypeIsNone = Account.configuration.activitiesIdentifierType === 'none';
      var isCreatingOrder = !vm.order.id;
      var isFromTicket = vm.order && vm.order.ticket && vm.order.ticket.id;

      vm.disableIdentifierInput = customerHasCorporateAccountUuid || !identifierTypeIsNone;
      vm.identifierIsRequired = !customerHasCorporateAccountUuid && identifierTypeIsNone;

      if (customerHasCorporateAccountUuid && isCreatingOrder && !isFromTicket) {
        vm.order.identifier = '';
      }

      if (vm.disableIdentifierInput) {
        if ($scope && $scope.orderForm && $scope.orderForm.identifier) {
          $scope.orderForm.identifier.$setValidity('required', true);
        }
      }
    }

    function updateServiceValidationState() {
      if (vm.services && vm.services.length) {
        _.forEach(vm.services, function (service) {
          service.show = shouldShowService(service, vm.selectedCustomer, vm.accountConfiguration, vm.addOrEditCustomer);
          if (vm.order.service && vm.order.service.id === service.id && !service.show) {
            vm.order.service = null;
          }
        });
      }
    }

    function shouldShowService(service, customer, accountConfiguration, addOrEditCustomer) {
      var corporateCustomerAccountUuid = msUtils.getCorporateAccountUuidFromCustomer(customer);
      var serviceCorporateAccountUuid = msUtils.getCorporateAccountUuidFromService(service);

      if (accountConfiguration.featureSendCustomerToCmmsAccount && addOrEditCustomer) {
        return serviceCorporateAccountUuid;
      }
      var isNotCorporateCustomer = !corporateCustomerAccountUuid;
      var isNotCorporateService = !serviceCorporateAccountUuid;

      var serviceId = service.id;
      var orderServiceId = vm.order && vm.order.service && vm.order.service.id;
      var isEditingOrder = !!vm.order.id;

      if (isEditingOrder && orderServiceId === serviceId) {
        return true;
      }

      if (isNotCorporateCustomer) {
        return isNotCorporateService;
      }

      var isFromTicket = vm.order && vm.order.ticket && vm.order.ticket.id;
      if (isEditingOrder || isFromTicket) {
        return true;
      }

      var isSameCorporateAccount = corporateCustomerAccountUuid === serviceCorporateAccountUuid;
      var allowCreateTaskEnabled = service.metadata && service.metadata.featureAllowCreateTask;
      return Boolean(isSameCorporateAccount && allowCreateTaskEnabled);
    }

    function updateCustomerValidationState() {
      $timeout(function () {
        var hasCustomerNameInput = $scope && $scope.orderForm && $scope.orderForm.customerName;
        var hasSelectedCustomer = !!vm.selectedCustomer;
        var isNewOrder = !vm.order.id;
        var isFromTicket = vm.order && vm.order.ticket && vm.order.ticket.id;

        if (hasCustomerNameInput && hasSelectedCustomer && isNewOrder && !isFromTicket) {
          var isCorporateCustomer = !!msUtils.getCorporateAccountUuidFromCustomer(vm.selectedCustomer);
          var allowCreateTaskEnabled = Boolean(vm.selectedCustomer.metadata && vm.selectedCustomer.metadata.featureAllowCreateTask);
          var validity = isCorporateCustomer ? allowCreateTaskEnabled : true;
          $scope.orderForm.customerName.$setValidity('customerAllowCreateTaskEnabled', validity);
        }
      }, 50);
    }

    function selectedCustomerChanged(preSelectedLocation) {
      vm.customerIsCorporate = !!msUtils.getCorporateAccountUuidFromCustomer(vm.selectedCustomer);

      if (!vm.selectedCustomer) { return; }

      orderLinksService.clearOrderLinks();

      updateIdentifierDisabledAndRequiredState();
      updateServiceValidationState();
      updateCustomerValidationState();
      _importCustomerFromIntegrationBeforeContinue(function (err) {
        if (err) {
          vm.selectedCustomer = null;
          return MessageDialog.showToast({
            hideDelay: 5000,
            message: err
          });
        }

        vm.comingTasksCount = null;
        vm.comingTasksScheduledDate = null;

        vm.order.customer = {
          id: vm.selectedCustomer.id,
          name: vm.selectedCustomer.name,
          contact: vm.selectedCustomer.contact,
          contacts: vm.selectedCustomer.contacts,
          notes: vm.selectedCustomer.notes,
          statistics: vm.selectedCustomer.statistics
        };

        if (vm.selectedCustomer.contacts) {
          vm.selectedCustomer.primaries = {
            email: _.find(vm.selectedCustomer.contacts.emails, function (email) { return email.primary; }),
            phone: _.find(vm.selectedCustomer.contacts.phones, function (phone) { return phone.primary; })
          };
        }

        vm.selectedCustomer.statistics = vm.order.customer.statistics;

        if (vm.selectedCustomer.contact && vm.selectedCustomer.contact.phone) {
          vm.order.customer.contact.phone = vm.selectedCustomer.contact.phone.replace(/\D/g, '');
        }

        var notAddingCustomer = !vm.addOrEditCustomer && vm.selectedCustomer.id;

        if (!vm.order.id && notAddingCustomer) {
          tasksApi.search({
            where: {
              customerIds: [vm.selectedCustomer.id],
              statusIn: ['scheduled'],
              archived: false,
              scheduledDateGte: moment().format('YYYY-MM-DD')
            },
            take: 1
          }).then(function (nextTasksSearchResult) {
            vm.comingTasksScheduledFromDateParam = moment().format('YYYY-MM-DD');
            vm.comingTasksCount = nextTasksSearchResult.totalCount;

            if (nextTasksSearchResult.totalCount === 1) {
              if (nextTasksSearchResult.items[0] && nextTasksSearchResult.items[0].scheduling) {
                vm.comingTasksScheduledDate = LocalDateConvert.formatDate(nextTasksSearchResult.items[0].scheduling.date, 'date');
              }
            }

          });
        }

        customersApi.getOne(vm.selectedCustomer.id).then(function (customer) {
          var accountValues = _.map(vm.omieAccounts, 'value');
          var account = _.find(accountValues, { 'appId': customer.externalAppId });
          var omieCustomerAccountName = account ? account.name : null;

          vm.selectedCustomer.omieAccount = omieCustomerAccountName;
          vm.selectedCustomer.labels = customer.labels;
          vm.selectedCustomer.primaryLocation = customer.primaryLocation;

          _getPrimaryLocation(vm.selectedCustomer, function (primaryLocation) {
            if (vm.selectedCustomerLocation) { return; }
            if (primaryLocation) {
              vm.hasNoLocations = false;
              vm.selectedCustomerLocation = primaryLocation;

              selectedCustomerLocationChanged(primaryLocation);
            } else {
              vm.hasNoLocations = true;

              if (!vm.order.id && isToUseTicketAddress) { return; }

              vm.order.address = vm.selectedCustomer.address;

              _setOrderCoords(vm.selectedCustomer.address.coords);
            }
          });
        });

        _verifyCustomerEquipments();

        delete vm.formErr['customerIsRequired'];

        if (preSelectedLocation) {
          return;
        }

        vm.hasNoLocations = false;

        vm.tasks = _.map(vm.tasks, function (task) {
          if (task.status === 'pending' && !vm.isPendingTasksEnabled()) {
            task.status = 'scheduled';
          }

          return task;
        });
      });

      $timeout(function () {
        if ($scope.orderForm && $scope.orderForm.customerName) {
          $scope.orderForm.customerName.$setDirty();
        }
      });
    }

    function _importCustomerFromIntegrationBeforeContinue(callback) {
      if (vm.selectedCustomer.type === 'ca') {
        return contaAzulApi.customers.contacts(vm.selectedCustomer.id, {}).then(function (contacts) {
          return customersApi.search({
            where: {
              nameContains: vm.selectedCustomer.name,
              archived: false
            },
            take: 1
          }).then(function (result) {
            if (result.items.length) {
              vm.selectedCustomer = result.items[0];
              selectedCustomerChanged();
              callback();
              return;
            }

            vm.addOrEditCustomer = true;

            if (vm.selectedCustomer.type === "ca") {
              vm.selectedCustomer = contaAzulCustomerMapper.toFieldControl(vm.selectedCustomer);
              vm.selectedCustomer.type = "ca";
              if (!vm.selectedCustomer.contacts.emails || !vm.selectedCustomer.contacts.emails.length) {
                vm.selectedCustomer.contacts.emails = [{
                  address: "",
                  type: "personal",
                  primary: true
                }];
              }

              if (!vm.selectedCustomer.contacts.phones || !vm.selectedCustomer.contacts.phones.length) {
                vm.selectedCustomer.contacts.phones = [{
                  number: "",
                  type: "home",
                  primary: true
                }];
              }
            } else {
              vm.selectedCustomer = {
                name: vm.selectedCustomer.name,
                contacts: contacts,
                address: vm.selectedCustomer.address,
                metadata: vm.selectedCustomer.metadata
              };
            }

            if (vm.addressModeSelection === 'google') {
              vm.selectedCustomerAddressText = msUtils.formatAddress(vm.selectedCustomer.address);
              if (vm.selectedCustomerAddressText !== '') {
                geoCoder.getByAddressString(vm.selectedCustomerAddressText).then(function (results) {
                  selectedAddressItemChange(results[0], true);
                });
              }
            } else if (vm.addressModeSelection === 'cepdb') {
              searchZipCode();
            }

            callback();
          });
        });
      }

      if (vm.selectedCustomer.type === 'om') {
        if (!vm.selectedCustomer.address.zipCode) {
          return callback('Cliente sem endereço, não foi possível importar');
        }

        if (!vm.selectedCustomer.contacts.emails || !vm.selectedCustomer.contacts.emails.length) {
          vm.selectedCustomer.contacts.emails = [];
        }

        if (!vm.selectedCustomer.contacts.phones || !vm.selectedCustomer.contacts.phones.length) {
          vm.selectedCustomer.contacts.phones = [];
        }

        return geoCoder.getByAddressObject(vm.selectedCustomer.address).then(function (location) {
          var lat = location ? location.lat : null;
          var lng = location ? location.lng : null;

          vm.selectedCustomer.address.coords.latitude = lat;
          vm.selectedCustomer.address.coords.longitude = lng;

          return customersApi.search({ where: { documentNumber: vm.selectedCustomer.documentNumber }, take: 1 }).then(function (result) {
            if (!result.items || !result.items.length || !result.items[0]) {
              return customersApi.save(vm.selectedCustomer).then(function (savedCustomer) {
                vm.selectedCustomer.id = savedCustomer.id;

                MessageDialog.showToast({
                  hideDelay: 5000,
                  message: $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.OMIE_TOAST_SUCCESS', { name: vm.selectedCustomer.name })
                });

                callback();
              }).catch(function (err) {
                console.error(err);
                MessageDialog.showToast({
                  hideDelay: 5000,
                  message: $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.OMIE_TOAST_FAIL')
                });
                callback();
              });
            }

            var customerToUpdate = angular.copy(vm.selectedCustomer);

            customerToUpdate.id = result.items[0].id;
            customerToUpdate._id = result.items[0]._id;

            if (customerToUpdate.id) {
              return customersApi.putCustomer(customerToUpdate).then(function () {
                vm.selectedCustomer.id = customerToUpdate.id;

                MessageDialog.showToast({
                  hideDelay: 5000,
                  message: $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.OMIE_UPDATE_SUCCESS', { ogName: result.items[0].name, newName: customerToUpdate.name })
                });

                callback();
              }).catch(function (err) {
                console.error(err);
                MessageDialog.showToast({
                  hideDelay: 5000,
                  message: $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.OMIE_TOAST_FAIL')
                });
                callback();
              });
            }
          });
        }).catch(function (err) {
          console.error(err);
          MessageDialog.showToast({
            hideDelay: 5000,
            message: $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.OMIE_TOAST_FAIL')
          });
          callback();
        });
      }

      callback();
    }

    function selectedCustomerLocationChanged(location) {
      checkIfEmployeeIsInLocation(location.id).then(function () {
        if (location) {
          vm.order.location = location;
        }

        if (!vm.order.id && isToUseTicketAddress) {
          _verifyCustomerEquipments();
          return;
        }

        if (location) {
          vm.order.address = {
            city: location.address.city,
            complement: location.address.complement,
            coords: location.address.coords,
            neighborhood: location.address.neighborhood,
            number: location.address.number,
            state: location.address.state,
            street: location.address.street,
            zipCode: location.address.postalCode || location.address.zipCode,
            formattedAddress: location.address.formattedAddress
          };

          _setOrderCoords(location.address.coords);
        }

        _verifyCustomerEquipments();

        orderLinksService.clearOrderLinks();
      });
    }

    function searchEmployeesByLocation(locationId) {
      return new Promise(function (resolve) {
        employeesApi.search({
          where: { linkedToLocationTerritoryId: locationId, active: true },
          take: 10000
        }).then(function (result) {
          vm.employees = result.items;
          vm.setEmployeesOptions();
          resolve();
        });
      });
    }

    function checkIfEmployeeIsInLocation(locationId) {
      return new Promise(function (resolve) {
        if (!vm.hasFeatureFlag('territories') || !locationId) {
          return resolve(true);
        }

        return searchEmployeesByLocation(locationId).then(function () {
          var tasksEmployees = vm.tasks
            .filter(function (task) {
              return task.employee && task.employee.id;
            })
            .map(function (task) {
              return Number(task.employee.id);
            });

          if (!tasksEmployees || !tasksEmployees.length) {
            return resolve(true);
          }

          var employeesIds = _.map(vm.employees, 'id');
          var employeesWithoutLocation = tasksEmployees.filter(function (employeeId) {
            return !employeesIds.includes(employeeId);
          });

          if (!employeesWithoutLocation || !employeesWithoutLocation.length) {
            return resolve(true);
          }

          showEmployeeWithoutLocationDialog().then(function () {
            for (var i = 0; i < vm.tasks.length; i++) {
              var task = vm.tasks[i];

              if (employeesWithoutLocation.includes(Number(task.employee.id))) {
                task.employee.id = null;
              }
            }

            $scope.orderForm.$setDirty();

            resolve(false);
          });

          return resolve(false);
        });
      });
    }

    function showEmployeeWithoutLocationDialog() {
      return new Promise(function (resolve) {
        FcModalService.open('', {
          title: $translate.instant('TASKS.DIALOG.EMPLOYEE_WARNING.TITLE'),
          content: $translate.instant('TASKS.DIALOG.EMPLOYEE_WARNING.CONTENT'),
          leftButtonText: $translate.instant('TASKS.DIALOG.EMPLOYEE_WARNING.BUTTON'),
          handleRightButton: resolve(false)
        });
      });
    }

    function searchCustomer(searchCustomerText) {
      if (vm.integrations.contaAzul) {
        if (documents.isValidDocument(searchCustomerText)) {
          return contaAzulApi.customers.list({ document: searchCustomerText }).then(function (result) {
            return _.map(result, function (customer) {
              customer.type = 'ca';
              return customer;
            });
          });
        }
      }
      var variables = {
        where: {
          archived: false
        },
        skip: 0,
        take: 100,
        orderBy: 'name_asc'
      };

      return Promise.all([
        customersApiGraphQL.search(_.merge({}, variables, { where: { nameOrDocumentNumberContains: searchCustomerText } })),
        customersApiGraphQL.search(_.merge({}, variables, { where: { contactEmailContains: searchCustomerText } })),
        customersApiGraphQL.search(_.merge({}, variables, { where: { contactPhoneContains: searchCustomerText } }))
      ]).then(function (result) {
        result.items = _.uniq(_.flatten(_.map(result, 'items')), 'id');

        return _insertIntegrationsCustomersIfEnabled(searchCustomerText, result).then(function (result) {
          result.items = result.items.filter(function (item) {
            return item.archived === false;
          });

          return result.items;
        });
      });
    }

    function _insertIntegrationsCustomersIfEnabled(searchCustomerText, result) {
      return new Promise(function (resolve) {
        if (!vm.integrations.omie || searchCustomerText.length < 3) {
          return resolve(result);
        }

        var customerNames = _.map(result.items, function (customer) { return customer.name; });
        var customerDocuments = _.map(result.items, function (customer) { return customer.documentNumber; });

        for (var i = 0; i < vm.omieAccounts.length; i++) {
          var appId = vm.omieAccounts[i].value.appId;

          omieApi.customers.list({
            clientesFiltro: { razao_social: searchCustomerText },
            pagina: 1,
            registros_por_pagina: 1000,
            apenas_importado_api: 'N'
          }, appId).then(function (response) {
            var invalid = false;

            if (response.status !== 200) { invalid = true; }
            if (!response.data) { invalid = true; }
            if (!response.data.total_de_registros) { invalid = true; }

            response.data.clientes_cadastro.forEach(function (omieCustomer) {
              var duplicated = false;

              if (customerNames.includes(omieCustomer.razao_social)) { duplicated = true; }
              if (customerNames.includes(omieCustomer.nome_fantasia)) { duplicated = true; }

              var omieCustomerDocument = omieCustomer.cnpj_cpf.replace(/\D/g, '');

              if (customerDocuments.includes(omieCustomerDocument)) { duplicated = true; }

              var omieCustomerMapped = omieCustomerMapper.toFieldControl(omieCustomer);
              omieCustomerMapped.type = 'om';
              omieCustomerMapped.archived = omieCustomer.inativo === 'N' ? false : true;

              result.items.map(function (item) {
                if (!invalid && item.name === omieCustomerMapped.name) {
                  duplicated = true;
                }

                if (!invalid && item.documentNumber === omieCustomerDocument) {
                  duplicated = true;
                }
              });

              if (!omieCustomerDocument || duplicated || invalid) {
                if (!invalid && !duplicated) {
                  omieCustomerMapped.externalAppId = appId;
                  result.items.push(omieCustomerMapped);
                }

                return;
              }

              return customersApi.search({ where: { documentNumber: omieCustomerDocument }, take: 1 }).then(function (customerResult) {
                if (customerResult.items && customerResult.items.length) {
                  duplicated = true;
                }

                if (!invalid && !duplicated) {
                  omieCustomerMapped.externalAppId = appId;
                  result.items.push(omieCustomerMapped);
                }
              });
            });
          }).catch(function () { });
        }
        resolve(result);
      });
    }

    function promptRemoveEquipmentToProceed() {
      FcModalService.open('', {
        title: $translate.instant('TASKS.DIALOG.WARNINGS.TITLE'),
        content: $translate.instant('TASKS.DIALOG.WARNINGS.CONTENT'),
        leftButtonText: $translate.instant('TASKS.DIALOG.WARNINGS.BUTTON'),
        handleRightButton: vm.closeDialog
      });
    }

    function promptRemoveLinksToProceed() {
      FcModalService.open('', {
        title: $translate.instant('TASKS.DIALOG.WARNINGS.TITLE'),
        content: $translate.instant('TASKS.DIALOG.WARNINGS.CONTENT'),
        leftButtonText: $translate.instant('TASKS.DIALOG.WARNINGS.BUTTON'),
        handleRightButton: vm.closeDialog
      });
    }

    function clearSelectedCustomer() {
      if (vm.selectedEquipments && vm.selectedEquipments.length && vm.order.id) {
        promptRemoveEquipmentToProceed();
        return;
      }

      var hasOrderLinks = vm.hasOrderLinks();

      if (hasOrderLinks) {
        promptRemoveLinksToProceed();
        return;
      }

      vm.selectedCustomer = null;
      vm.searchCustomerText = null;
      vm.order.address = null;
      vm.order.customer = null;
      vm.order.location = null;
      vm.showingEquipments = [];
      vm.selectedEquipments = [];
      vm.equipmentOptions = [];

      _setOrderCoords(null);

      vm.addOrEditCustomer = false;
      vm.selectedCustomerAddress = null;
      vm.selectedCustomerAddressText = '';
      vm.selectedNewCustomerAddress = false;

      updateIdentifierDisabledAndRequiredState();
      updateServiceValidationState();
      updateCustomerValidationState();

      $timeout(function () {
        if ($scope.orderForm) {
          $scope.orderForm.$setValidity('customerAddress', true, window);
        }
      });
      vm.googleCustomerAddressErrors = [];
      vm.googleCustomerAddressWarnings = [];

      delete vm.formErr['customerAddressIsRequired'];

      vm.selectedCustomerLocation = null;
      delete vm.formErr['customerLocationIsRequired'];

      $timeout(function () {
        focus('auto-complete-customer');
      }, 200);
    }

    function clearSelectedCustomerLocation() {
      if (vm.selectedEquipments && vm.selectedEquipments.length && vm.order.id) {
        promptRemoveEquipmentToProceed();
        return;
      }

      var hasOrderLinks = vm.hasOrderLinks();

      if (hasOrderLinks) {
        promptRemoveLinksToProceed();
        return;
      }

      vm.selectedCustomerLocation = null;
      delete vm.formErr['customerLocationIsRequired'];
      vm.order.location = null;

      if (vm.selectedCustomer && vm.selectedCustomer.address) {
        vm.order.address = vm.selectedCustomer.address;
        _setOrderCoords(vm.selectedCustomer.address.coords);
      }

      $timeout(function () {
        focus('auto-complete-customer-location');

        if (vm.initialized && $scope.orderForm) {
          $scope.orderForm.$setDirty();
        }
      }, 200);
    }

    function createNewCustomer() {
      delete vm.formErr['customerIsRequired'];
      vm.isNewCustomer = true;

      vm.selectedCustomer = {
        name: vm.searchCustomerText,
        address: null,
        contacts: {
          emails: [{
            address: '',
            type: 'personal',
            primary: true
          }],
          phones: [{
            number: '',
            type: 'home',
            primary: true,
            countryCode: '55'
          }]
        }
      };
      vm.selectedCustomerAddress = null;

      vm.order.address = null;
      vm.order.customer = null;

      vm.tasks.forEach(function (task) {
        task.coords.latitude = null;
        task.coords.longitude = null;
      });

      vm.addOrEditCustomer = true;
      updateServiceValidationState();

      $timeout(function () {
        if (vm.searchCustomerText) {
          if (vm.addressModeSelection === 'google') {
            document.querySelector('#auto-complete-address').focus();
          }

          if (vm.addressModeSelection === 'cepdb') {
            document.querySelector('#zipCode').focus();
          }
        }
        else {
          focus('customerName');
        }
      }, 200);

      $timeout(function () {
        if (vm.initialized) {
          if ($scope.orderForm) {
            $scope.orderForm.$dirty = true;
          }
        }
      }, 1000);

      $timeout(function () {
        if ($scope.orderForm) {
          $scope.orderForm.$setValidity('customerAddress', true, window);
        }
      });
      vm.googleCustomerAddressErrors = [];
      vm.googleCustomerAddressWarnings = [];
    }

    function createFirstCustomerLocation() {
      $rootScope.loadingProgress = true;

      customersApi.save({
        id: vm.selectedCustomer.id,
        name: vm.selectedCustomer.name,
        address: vm.selectedCustomer.address
      }).then(function (result) {
        customersApi.getOne(vm.selectedCustomer.id).then(function (customer) {
          vm.selectedCustomerLocation = customer.primaryLocation;
          selectedCustomerLocationChanged(customer.primaryLocation);
          vm.hasNoLocations = false;

          $rootScope.loadingProgress = false;
        });
      });
    }

    function searchCustomerLocation(selectedCustomer, searchCustomerLocationText) {
      var params = {
        where: {
          archived: false,
          customerIds: [selectedCustomer.id]
        },
        skip: 0,
        take: 100,
        orderBy: 'name_asc'
      };

      return Promise.allSettled([
        locationsApiGraphQL.search(_.merge({}, params, { where: { nameOrDocumentNumberContains: searchCustomerLocationText } })),
        locationsApiGraphQL.search(_.merge({}, params, { where: { contactEmailContains: searchCustomerLocationText } })),
        locationsApiGraphQL.search(_.merge({}, params, { where: { contactPhoneContains: searchCustomerLocationText } })),
      ]).then(function (result) {
        var results = [];
        result.forEach(function (result) {
          if (result.status === 'fulfilled') {
            results.push(result.value.items);
          }
        });

        vm.customersLocations = _.uniq(_.flatten(results), 'id');

        return vm.customersLocations;
      });
    }

    function _getPrimaryLocation(customer, callback) {
      if (customer && customer.id && customer.primaryLocation && customer.primaryLocation.id) {
        customerLocationsApi.getOne(customer.primaryLocation.id).then(function (result) {
          callback(result);
        });
      } else {
        callback();
      }
    }

    function hasOrderLinks() {
      var orderLinks = orderLinksService.getOrderLinks();

      var orderLocationEnvironments = orderLinks && orderLinks.orderLocationEnvironments && orderLinks.orderLocationEnvironments.length;
      var orderLocationSectors = orderLinks && orderLinks.orderLocationSectors && orderLinks.orderLocationSectors.length;
      var orderEquipments = orderLinks && orderLinks.orderEquipments && orderLinks.orderEquipments.length;

      return orderLocationEnvironments || orderLocationSectors || orderEquipments;
    }

    /// Services

    // Filter Services
    vm.serviceSearchTerm = "";
    vm.employeeSearchTerm = "";
    vm.formSearchTerm = "";
    vm.clearFormSearchTerm = clearFormSearchTerm;
    vm.clearSearchTerm = clearSearchTerm;
    vm.clearEmployeeSearchTerm = clearEmployeeSearchTerm;
    vm.onSelectedService = onSelectedService;
    vm.toggleServiceRequiredValidationWorkaround = toggleServiceRequiredValidationWorkaround;
    vm.shouldShowService = shouldShowService;

    function clearSearchTerm() {
      vm.serviceSearchTerm = '';
    }

    function clearEmployeeSearchTerm() {
      vm.employeeSearchTerm = '';
    }

    function clearFormSearchTerm() {
      vm.formSearchTerm = '';
    }

    function toggleServiceRequiredValidationWorkaround() {
      return !(vm.order && vm.order.service && vm.order.service.id);
    }

    function onSelectedService() {
      var service = _.find(vm.services, function (item) {
        return item.id === parseInt(vm.order.service.id);
      });

      vm.order.service = angular.copy(service);

      if (service.slaTimeLimit) {
        vm.order._deadlineAt = moment().add(service.slaTimeLimit, 'd').toDate();
      } else {
        vm.order._deadlineAt = null;
      }

      var taskIndex = 0;
      vm.tasks.forEach(function (task) {
        if (!task._duration) {
          task.duration = service.duration;
        }
        onSelectedEmployee(task, taskIndex);
        onSelectedSecondaryEmployees(task, taskIndex);
        taskIndex++;
      });

      if (vm.order.service.form && vm.order.service.form.id) {
        formsApi.get(vm.order.service.form.id).then(function (form) {
          vm.order.service.form = form;
        });
      }

      if (vm.order && vm.order.tasks && vm.order.tasks.length) {
        vm.order.tasks.forEach(function (task, index) {
          checkRequiredForms({
            status: task.status,
            taskIndex: index
          });
        });
      }
    }

    /// Employees
    vm.hasErrors = hasErrors;
    vm.onSelectedEmployee = onSelectedEmployee;
    vm.onSelectedSecondaryEmployees = onSelectedSecondaryEmployees;
    vm.addEmployeeSkill = addEmployeeSkill;
    vm.addSecondayEmployeeSkill = addSecondayEmployeeSkill;
    vm.isTaskScheduledToday = isTaskScheduledToday;
    vm.calculateDistanceFromCoords = _.debounce(calculateDistanceFromCoords, 1000);
    vm.employeesCheckAbsent = employeesCheckAbsent;
    vm.employeeIsAbsent = employeeIsAbsent;
    vm.checkForRequiredEmployeeError = checkForRequiredEmployeeError;
    vm.checkForRequiredEmployeesValidation = checkForRequiredEmployeesValidation;
    vm.checkTaskRequiredEmployeesError = checkTaskRequiredEmployeesError;
    vm.hasRequiredEmployeeError = false;
    vm.isEmployeeDropdownOpen = false;
    vm.isSecondaryEmployeesDropdownOpen = false;

    function calculateDistanceFromCoords() {
      var latitude = vm.tasks[0] && vm.tasks[0].coords && vm.tasks[0].coords.latitude;
      var longitude = vm.tasks[0] && vm.tasks[0].coords && vm.tasks[0].coords.longitude;

      if (!latitude || !longitude) {
        latitude = vm.order && vm.order.address && vm.order.address.latitude;
        longitude = vm.order && vm.order.address && vm.order.address.longitude;
      }

      if (latitude && longitude) {
        var end = {
          latitude: parseFloat(latitude),
          longitude: parseFloat(longitude)
        };

        vm.employees.forEach(function (employee) {
          if (employee.location && employee.isOnline) {
            var start = {
              latitude: parseFloat(employee.location.latitude),
              longitude: parseFloat(employee.location.longitude)
            };

            employee.kmDistance = haversine(start, end, 'km');
          }
        });
      }

      vm.employees = _.sortBy(vm.employees, function (employee) {
        if (employee.kmDistance) {
          return employee.kmDistance;
        }

        if (!employee.isOnline) {
          return 99998;
        }

        if (employee.isOnline == null) {
          return 99999;
        }
      });

      vm.setEmployeesOptions();
    }

    function isTaskScheduledToday(task) {
      if (!task.scheduling || !task.scheduling.date) {
        return false;
      }

      var taskScheduledDate = moment(task.scheduling.date).format('YYYY-MM-DD');
      return moment().format('YYYY-MM-DD') === taskScheduledDate;
    }

    function addEmployeeSkill(task, index, service) {
      if (service && service.id) {
        employeesApi.addSkill(task.employee.id, service.id).then(function () {
          onSelectedEmployee(task, index);

          var employee = _.find(vm.employees, function (employeeFromList) {
            return Number(employeeFromList.id) === Number(task.employee.id);
          });

          $mdToast.show(
            $mdToast.simple()
              .textContent(
                $translate.instant('TASKS.TOASTS.SERVICES_TYPE.CUSTOMER_SERVICE_ADDED', {
                  serviceDescription: service.description,
                  employeeName: employee.name
                }
                ))
              .hideDelay(5000)
          );
        });
      }
    }

    function addSecondayEmployeeSkill(task, index, service) {
      var i = 0;
      if (task.secondaryEmployees && task.secondaryEmployees.length) {
        task.secondaryEmployees.forEach(function (employeeId) {
          employeesApi.addSkill(employeeId, service.id).then(function () {
            i++;
            if (i === task.secondaryEmployees.length - 1) {
              onSelectedSecondaryEmployees(task, index);

              $mdToast.show(
                $mdToast.simple()
                  .textContent(
                    $translate.instant('TASKS.TOASTS.SERVICES_TYPE.CUSTOMER_SERVICE_ADDED_TO_SECONDARY_EMPLOYEES', {
                      serviceDescription: service.description
                    }
                    ))
                  .hideDelay(5000)
              );
            }
          });
        });
      }
    }

    function onSelectedEmployee(task, index) {
      vm.hasRequiredEmployeeError = vm.checkForRequiredEmployeeError(vm.order, task);

      if (vm.order.service && vm.order.service.id) {
        if (task.employee && task.employee.id && task.employee.id !== 'null') {
          employeesApi.getSkill(task.employee.id, vm.order.service.id).then(function () {
            delete vm.formErr['notSkilledEmployee_' + index];
          }).catch(function () {
            vm.formErr['notSkilledEmployee_' + index] = $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ERRORS.DOES_NOT_PERFORM', { serviceDescription: vm.order.service.description });
          });
        } else {
          delete vm.formErr['notSkilledEmployee_' + index];
        }
      } else {
        delete vm.formErr['notSkilledEmployee_' + index];
      }

      if (task.secondaryEmployees && task.secondaryEmployees.includes(task.employee && task.employee.id && Number(task.employee.id))) {
        task.secondaryEmployees = _.without(task.secondaryEmployees, Number(task.employee.id));
      }

      if (!task.employee || !task.employee.id || task.employee.id === 'null') {
        task.secondaryEmployees = [];
      }
    }

    function onSelectedSecondaryEmployees(task, index) {
      var filteredEmployees = task.secondaryEmployees.filter(function (employeeId) {
        var employee = vm.employees.find(function (e) {
          return e.id == employeeId;
        });

        return employee && employee.contract && employee.contract.active && !employee.inactivatedAt;
      });
      if( filteredEmployees && filteredEmployees.length > 10) {
        vm.formErr['secondaryEmployeesLimit_' + index] = $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ERRORS.SECONDARY_EMPLOYEES_LIMIT');
      } else {
        delete vm.formErr['secondaryEmployeesLimit_' + index];
      }

      if (vm.order.service && vm.order.service.id) {
        if (task.secondaryEmployees && task.secondaryEmployees.length) {
          var employeesWithoutSkill = [];
          delete vm.formErr['notSkilledSecondaryEmployees_' + index];
          task.secondaryEmployees.forEach(function (employeeId) {
            employeesApi.getSkill(employeeId, vm.order.service.id).then(function () {}).catch(function (err) {
              var employee = _.find(vm.employees, function (employeeFromList) {
                return Number(employeeFromList.id) === Number(employeeId);
              });

              if (!employee) {
                return;
              }

              employeesWithoutSkill.push(employee.name);

              if (employeesWithoutSkill.length) {
                vm.formErr['notSkilledSecondaryEmployees_' + index] = $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ERRORS.SECONDARY_EMPLOYEES_DOES_NOT_PERFORM', { serviceDescription: vm.order.service.description, notSkilledEmployees: employeesWithoutSkill.join(', ') });
              } else {
                delete vm.formErr['notSkilledSecondaryEmployees_' + index];
              }

            });
          });
        } else {
          delete vm.formErr['notSkilledSecondaryEmployees_' + index];
        }
      } else {
        delete vm.formErr['notSkilledSecondaryEmployees_' + index];
      }

      if (task.secondaryEmployees && task.secondaryEmployees.includes(task.employee.id)) {
        task.secondaryEmployees = _.without(task.secondaryEmployees, task.employee.id);
      }

      if (!task.employee || !task.employee.id || task.employee.id === 'null') {
        task.secondaryEmployees = [];
      }
    }

    function checkForRequiredEmployeeError(order, task) {
      var isEmployeeRequired = false;
      var hasEmployeeSelected = false;

      if (order && order.ticket && order.ticket.metadata && order.ticket.metadata.featureAssignedEmployeeRequired) {
        isEmployeeRequired = true;
      }

      if (task.employee && task.employee.id && task.employee.id !== 'null') {
        hasEmployeeSelected = true;
      }

      if (isEmployeeRequired && !hasEmployeeSelected) {
        return true;
      }

      return false;
    }

    function checkForRequiredEmployeesValidation() {
      var hasSomeTaskWithoutEmployee = false;
      var employeeRequired = (vm.order && vm.order.ticket && vm.order.ticket.metadata && vm.order.ticket.metadata.featureAssignedEmployeeRequired) ||
        (vm.order && vm.order.metadata && vm.order.metadata.featureAssignedEmployeeRequired);

      if (!employeeRequired) return false;

      vm.tasks.forEach(function (task) {
        if (!task.employee || (!task.employee || (task.employee && !task.employee.id) || (task.employee && task.employee.id === 'null'))) {
          hasSomeTaskWithoutEmployee = true;
        }
      });

      return hasSomeTaskWithoutEmployee;
    }

    function checkTaskRequiredEmployeesError(task) {
      var employeeRequired = (vm.order && vm.order.ticket && vm.order.ticket.metadata && vm.order.ticket.metadata.featureAssignedEmployeeRequired) ||
        (vm.order && vm.order.metadata && vm.order.metadata.featureAssignedEmployeeRequired);

      if (!employeeRequired) return false;

      if (!task.employee || (!task.employee || (task.employee && !task.employee.id) || (task.employee && task.employee.id === 'null'))) {
        return true;
      }
    }

    function employeesCheckAbsent(task) {
      if (!task.scheduling || !task.scheduling.date) {
        return;
      }

      absencesApi.getByDate(moment(task.scheduling.date).toDate()).then(function (absences) {
        if (!vm.employees || !vm.employees.length) {
          return;
        }

        task.absences = _.map(vm.employees, function (employee) {
          var absence = _.find(absences, function (absence) {
            return absence.employee.id === employee.id;
          });

          return {
            id: employee.id,
            absent: !!absence
          };
        });
      });
    }

    function employeeIsAbsent(task, employee) {
      if (!employee) {
        return false;
      }

      var absence = _.find(task.absences, function (employeeAbsence) {
        return employee.id === employeeAbsence.id;
      });

      return absence ? absence.absent : false;
    }

    function hasErrors() {
      return (Object.keys(vm.formErr).length > 0);
    }

    /// Tasks & Scheduling
    vm.changedTaskStatus = changedTaskStatus;
    vm.taskStartedAtIsRequired = taskStartedAtIsRequired;
    vm.isTaskScheduledDateRequired = isTaskScheduledDateRequired;
    vm.taskCompletedAtIsRequired = taskCompletedAtIsRequired;
    vm.clearScheduledTime = clearScheduledTime;
    vm.scheduledDateChanged = scheduledDateChanged;
    vm.addTask = addTask;
    vm.deleteTask = deleteTask;
    vm.archiveTask = archiveTask;
    vm.archiveSingleTask = archiveSingleTask;
    vm.unarchiveTask = unarchiveTask;
    vm.unarchiveSingleTask = unarchiveSingleTask;
    vm.printOrder = printOrder;
    vm.osLinkPrint = osLinkPrint;
    vm.openCustomersEmail = openCustomersEmail;
    vm.sendRatingEmail = sendRatingEmail;
    vm.sendPrintLink = sendPrintLink;
    vm.shareTaskLocation = shareTaskLocation;
    vm.hasTaskStatus = hasTaskStatus;
    vm.sendEvaluationByWhatsApp = sendEvaluationByWhatsApp;

    function hasTaskStatus(status) {
      var containsTaskStatus = false;
      vm.tasks.forEach(function (task) {
        if (task.status === status) {
          containsTaskStatus = true;
        }
      });

      return containsTaskStatus;
    }

    function openCustomersEmail(openMenu, event) {
      vm.selectedCustomerEmails = [];
      openMenu(event);
    }

    vm.showToastWhileCopyLink = showToastWhileCopyLink;
    function showToastWhileCopyLink(identifier, type) {
      MessageDialog.showToast({
        hideDelay: 10000,
        message: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.LINK_COPIED.MESSAGE', {
          type: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.LINK_COPIED.' + (type == 'report' ? "FROM_REPORT" : "TO_EVALUATION")),
          id: identifier
        })
      });
    }

    function sendRatingEmail(task, emailIds) {
      var payload = { emails: [] };

      emailIds.forEach(function (emailId) {
        payload.emails.push({ id: emailId });
      });

      $rootScope.loadingProgress = true;
      tasksApi.sendRatingLink(task.id, payload).then(function (resp) {
        MessageDialog.showToast({
          hideDelay: 10000,
          message: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.EVALUATION_LINK_SENDED', { customerName: task.order.customer.name })
        });
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function sendPrintLink(task, emailIds) {
      var payload = { emails: [] };

      emailIds.forEach(function (emailId) {
        payload.emails.push({ id: emailId });
      });

      $rootScope.loadingProgress = true;
      tasksApi.sendPrintLink(task.id, payload).then(function (resp) {
        MessageDialog.showToast({
          hideDelay: 10000,
          message: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.EVALUATION_LINK_SENDED', { customerName: task.order.customer.name })
        });
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function sendByWhatsApp(id, type, phoneNumber, taskId) {
      var message = _createWhatsAppMessage(id, type, taskId);
      var phone = phoneNumber ? '&phone=55' + phoneNumber : '';

      $timeout(function () {
        $window.open('https://web.whatsapp.com/send?text=' + message + phone, '_blank');
      }, 1000);
    }

    function sendEvaluationByWhatsApp(phoneNumber, taskId) {
      var message = _createWhatsAppRatingMessage(taskId);
      var phone = phoneNumber ? '&phone=55' + phoneNumber : '';

      $timeout(function () {
        $window.open('https://web.whatsapp.com/send?text=' + message + phone, '_blank');
      }, 1000);
    }

    function _createWhatsAppMessage(id, type, taskId) {
      var link = 'https://app.fieldcontrol.com.br/#/visualizar-relatorio-' + type + '?id=' + id;

      if (type === 'new-os') {
        link = vm.link.newOrderPrintLink + id;

        if (taskId) {
          link = link + '/atividade/' + taskId;
        }
      }

      var message = $translate.instant('TASKS.DIALOG.ACTIONS.WHATSAPP_MESSAGE', {
        link: link,
        customer: vm.order.customer.name,
        company: vm.account.name,
        identifier: vm.order.identifier,
        service: vm.order.service.description
      });

      return encodeURIComponent(message);
    }

    function _createWhatsAppRatingMessage(id) {
      var link = vm.link.taskRatingLink + id;

      var message = $translate.instant('TASKS.DIALOG.ACTIONS.WHATSAPP_EVALUATION_MESSAGE', {
        link: link,
        customer: vm.order.customer.name,
        company: vm.account.name,
        identifier: vm.order.identifier,
        service: vm.order.service.description
      });

      return encodeURIComponent(message);
    }

    function osLinkPrint(order) {
      $timeout(function () {
        $window.open("https://app.fieldcontrol.com.br/relacionamento-cliente/#/relatorio/" + order.id + '?print=true', '_blank');
      }, 1000);
    }

    function printOrder(order) {
      $rootScope.loadingProgress = true;
      vm.disablePrintOrder = true;
      printConfigurationApi.getPrintConfiguration()
        .then(function (printConfiguration) {
          var configurations;
          if (printConfiguration && printConfiguration.configurations) {
            configurations = normalizePrintConfigurations.normalize(printConfiguration.configurations);
          }
          var searchOptions = {
            graphQL: {
              orderId: order.id,
              printConfiguration: {
                configurations: configurations
              }
            }
          };
          exportsApi.exportFeature('order-pdf-report', searchOptions, { timezone: moment.tz.guess() })
            .then(function (response) {
              $rootScope.$emit('order:pdf-report-created', {
                response: response,
                order: order
              });
              vm.disablePrintOrder = false;
            });
        });
    }

    function shareTaskLocation(task, emailIds) {
      var payload = { emails: [] };

      if (emailIds) {
        emailIds.forEach(function (emailId) {
          payload.emails.push({ id: emailId });
        });

        $rootScope.loadingProgress = true;
        tasksApi.sendTrackingLink(task.id, payload).then(function () {
          MessageDialog.showToast({
            hideDelay: 10000,
            message: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.EMPLOYEE_LOCATION_SENDED', { customerName: task.order.customer.name })
          });
        }).finally(function () {
          $rootScope.loadingProgress = false;
        });
      }
    }

    function changedTaskStatus(task, index) {
      var taskCurrentStatus = TasksStatusHelper.getByName(task.status);
      if (taskCurrentStatus) {

        if (
          task.oldStatus === 'in-progress' &&
          task.status !== 'in-progress' &&
          task.employee &&
          task.employee.id &&
          task.employee.id !== 'null'
        ) {
          employeesApi.get(task.employee.id).then(function (employee) {
            if (!employee) { return; };

            FcModalService.open(null, {
              title: $translate.instant('CORE.ATTENTION'),
              variables: {
                employeeName: employee.name,
                alertFirstContent: $translate.instant('TASKS.CHANGE_TASK_STATUS.ALERT_FIRST_CONTENT'),
                alertSecondContent: $translate.instant('TASKS.CHANGE_TASK_STATUS.ALERT_SECOND_CONTENT'),
              },
              templateUrl: 'app/main/tasks/templates/change-task-status-alert.html',
              rightButtonText: $translate.instant('CORE.SUBSCRIPTION_DIALOG.YES'),
              leftButtonText: $translate.instant('CORE.SUBSCRIPTION_DIALOG.NO'),
              handleLeftButton: function () {
                task.status = 'in-progress';
                changedTaskStatus(task, index);
              }
            });

          });
        }

        task._lastValues = task._lastValues || {};

        if (task.scheduling && task.scheduling.date) {
          task._lastValues.scheduling = task._lastValues.scheduling || {};
          task._lastValues.scheduling.date = task.scheduling.date;
        }

        if (task.scheduling && task.scheduling.time) {
          task._lastValues.scheduling = task._lastValues.scheduling || {};
          task._lastValues.scheduling.time = task.scheduling.time;
        }

        if (task.startedAtDate) {
          task._lastValues.startedAtDate = task.startedAtDate;
        }

        if (task.startedAtTime) {
          task._lastValues.startedAtTime = task.startedAtTime;
        }

        if (task.completedAtDate) {
          task._lastValues.completedAtDate = task.completedAtDate;
        }

        if (task.completedAtTime) {
          task._lastValues.completedAtTime = task.completedAtTime;
        }

        if (!taskCurrentStatus.hasStartTime) {
          task.startedAtDate = null;
          task.startedAtTime = null;
          task.startedAt = null;
        } else {
          task.startedAtDate = task._lastValues.startedAtDate || (task.scheduling && task.scheduling.date);
          task.startedAtTime = task._lastValues.startedAtTime;
        }

        if (!taskCurrentStatus.hasCompletedTime) {
          task.completedAtDate = null;
          task.completedAtTime = null;
          task.completedAt = null;
        } else {
          task.completedAtDate = task._lastValues.completedAtDate || (task.scheduling && task.scheduling.date);
          task.completedAtTime = task._lastValues.completedAtTime;
        }

        if (taskCurrentStatus.name === 'pending') {
          task.scheduling = task.scheduling || {};
          task.scheduling.date = null;
          task.scheduling.time = null;
        } else {
          task.scheduling = task._lastValues.scheduling || angular.copy(vm.emptySchedulingState);
        }

        setTimeout(function () {
          validateDateAndTime(task, index);
        }, 10);

        checkRequiredForms({
          status: task.status,
          taskIndex: index
        });
      }
    }

    function taskCompletedAtIsRequired(task, $index) {
      var currentStatus = TasksStatusHelper.getByName(task.status);
      var isRequired = currentStatus.hasCompletedTime;

      if (isRequired && vm.initialized) {
        if ($scope.orderForm && $scope.orderForm['completedAtDate_' + $index] && $scope.orderForm['completedAtTime_' + $index]) {
          $scope.orderForm['completedAtDate_' + $index].$setTouched();
          $scope.orderForm['completedAtTime_' + $index].$setTouched();
        }
      }

      return isRequired;
    }

    function taskStartedAtIsRequired(task, $index) {
      var currentStatus = TasksStatusHelper.getByName(task.status);
      var isRequired = currentStatus.hasStartTime;

      if (isRequired && vm.initialized) {
        if (
          $scope.orderForm && (
            $scope.orderForm['startedAtDate_' + $index] ||
            $scope.orderForm['startedAtTime_' + $index]
          )
        ) {
          $scope.orderForm['startedAtDate_' + $index].$setTouched();
          $scope.orderForm['startedAtTime_' + $index].$setTouched();
        }
      }

      return isRequired;
    }

    function isTaskScheduledDateRequired(task, $index) {
      if (!vm.initialized) {
        return;
      }

      var currentStatus = TasksStatusHelper.getByName(task.status);
      var isNewTask = !task.id;
      var isPendingTaskEnabled = vm.isPendingTasksEnabled();
      var isRequired = true;

      if (isNewTask) {
        isRequired = !isPendingTaskEnabled;

        if (isRequired) { _setSchedulingDateTouched(); }
        return isRequired;
      }

      if (currentStatus.name === 'pending') {
        isRequired = !isPendingTaskEnabled;

        if (isRequired) { _setSchedulingDateTouched(); }
        return isRequired;
      }

      return true;
    }

    function _setSchedulingDateTouched($index) {
      if (
        $scope.orderForm && (
          $scope.orderForm['startedAtDate_' + $index] ||
          $scope.orderForm['startedAtTime_' + $index]
        )
      ) {
        $scope.orderForm['scheduling_date_' + $index].$setTouched();
      }
    }

    function validateDateAndTime(task, $index) {
      var inputs = {
        task: task,
        index: $index,
        orderForm: $scope.orderForm,
        account: vm.account,
        featureCloseTaskWithPastDate: vm.configurations.featureCloseTaskWithPastDate,
        featureCloseTaskWithFutureDate: vm.configurations.featureCloseTaskWithFutureDate
      };

      function getFormInputBySelector(selector) {
        var orderFormInput = $scope.orderForm[selector];
        return orderFormInput || null;
      }

      if (vm.order) {
        var isGreaterThan12Hours = validateDateAndTimeService.isGreaterThan12Hours;
        var isMinorThan1Hour = validateDateAndTimeService.isMinorThan1Hour;
        var scheduledAtTimeInput = getFormInputBySelector('timeableVisit_' + $index);
        var scheduledAtTime = scheduledAtTimeInput && scheduledAtTimeInput.$viewValue;

        if (vm.timeFormatIsActive) {
          var scheduledTimeFormatInput = getFormInputBySelector('scheduledTimeFormat_' + $index);
          var scheduledTimeFormatInput = scheduledTimeFormatInput && scheduledTimeFormatInput.$viewValue;

          $scope.orderForm['timeableVisit_' + $index].$setValidity('isGreaterThan12Hours', !isGreaterThan12Hours(scheduledAtTime));
          $scope.orderForm['timeableVisit_' + $index].$setValidity('isMinorThan1Hour', !isMinorThan1Hour(scheduledAtTime));

          $scope.orderForm['scheduledTimeFormat_' + $index].$setTouched();
        }
        $scope.orderForm['timeableVisit_' + $index].$setTouched();
      }

      if (vm.order && vm.order.id) {
        var startedAtDateInput = getFormInputBySelector('startedAtDate_' + $index);
        var startedAtTimeInput = getFormInputBySelector('startedAtTime_' + $index);
        var completedAtDateInput = getFormInputBySelector('completedAtDate_' + $index);
        var completedAtTimeInput = getFormInputBySelector('completedAtTime_' + $index);
        var startedTimeFormatInput = getFormInputBySelector('startedAtTimeFormat_' + $index);
        var completedTimeFormatInput = getFormInputBySelector('completedAtTimeFormat_' + $index);

        var startedAtTime = startedAtTimeInput && startedAtTimeInput.$viewValue;
        var completedAtDate = completedAtDateInput && completedAtDateInput.$viewValue;
        var completedAtTime = completedAtTimeInput && completedAtTimeInput.$viewValue;
        var startedAtTimeFormat = startedTimeFormatInput && startedTimeFormatInput.$viewValue;
        var completedAtTimeFormat = completedTimeFormatInput && completedTimeFormatInput.$viewValue;

        var isDateOrTimeMissing = validateDateAndTimeService.isDateOrTimeMissing;
        var isStartedAtLessThanCreatedAt = validateDateAndTimeService.isStartedAtLessThanCreatedAt;
        var isStartedAtGreaterThanPresent = validateDateAndTimeService.isStartedAtGreaterThanPresent;
        var isCompletedAtLessThanStartedAt = validateDateAndTimeService.isCompletedAtLessThanStartedAt;
        var isCompletedAtGreaterThanPresent = validateDateAndTimeService.isCompletedAtGreaterThanPresent;

        var startedAtDate = '';
        if (startedAtDateInput) {
          startedAtDate = startedAtDateInput.$viewValue;
          startedAtDateInput.$setValidity('isStartedAtDateMissing', !isDateOrTimeMissing(startedAtDate, startedAtTime, 'date'));
          startedAtDateInput.$setValidity('startedAtIsLessThanCreatedAt', !isStartedAtLessThanCreatedAt(inputs, startedAtTimeFormat));
          startedAtDateInput.$setValidity('startedAtIsGreaterThanPresent', !isStartedAtGreaterThanPresent(inputs, startedAtTimeFormat));

          startedAtDateInput.$setTouched();
        }

        $scope.orderForm['startedAtTime_' + $index].$setValidity('isStartedAtTimeMissing', !isDateOrTimeMissing(startedAtDate, startedAtTime, 'time'));
        $scope.orderForm['startedAtTime_' + $index].$setValidity('startedAtIsLessThanCreatedAt', !isStartedAtLessThanCreatedAt(inputs, startedAtTimeFormat));
        $scope.orderForm['startedAtTime_' + $index].$setValidity('startedAtIsGreaterThanPresent', !isStartedAtGreaterThanPresent(inputs, startedAtTimeFormat));

        $scope.orderForm['completedAtDate_' + $index].$setValidity('isStartedAtDateMissing', !isDateOrTimeMissing(completedAtDate, completedAtTime, 'date'));
        $scope.orderForm['completedAtTime_' + $index].$setValidity('isStartedAtTimeMissing', !isDateOrTimeMissing(completedAtDate, completedAtTime, 'time'));
        $scope.orderForm['completedAtDate_' + $index].$setValidity('completedAtIsLessThanStartedAt', !isCompletedAtLessThanStartedAt(inputs, startedAtTimeFormat, completedAtTimeFormat));
        $scope.orderForm['completedAtTime_' + $index].$setValidity('completedAtIsLessThanStartedAt', !isCompletedAtLessThanStartedAt(inputs, startedAtTimeFormat, completedAtTimeFormat));
        $scope.orderForm['completedAtDate_' + $index].$setValidity('completedAtIsGreaterThanPresent', !isCompletedAtGreaterThanPresent(inputs, completedAtTimeFormat));
        $scope.orderForm['completedAtTime_' + $index].$setValidity('completedAtIsGreaterThanPresent', !isCompletedAtGreaterThanPresent(inputs, completedAtTimeFormat));

        $scope.orderForm['startedAtTime_' + $index].$setTouched();
        $scope.orderForm['completedAtDate_' + $index].$setTouched();
        $scope.orderForm['completedAtTime_' + $index].$setTouched();

        if (vm.timeFormatIsActive) {

          $scope.orderForm['startedAtTime_' + $index].$setValidity('isGreaterThan12Hours', !isGreaterThan12Hours(startedAtTime));
          $scope.orderForm['startedAtTime_' + $index].$setValidity('isMinorThan1Hour', !isMinorThan1Hour(startedAtTime));
          $scope.orderForm['completedAtTime_' + $index].$setValidity('isGreaterThan12Hours', !isGreaterThan12Hours(completedAtTime));
          $scope.orderForm['completedAtTime_' + $index].$setValidity('isMinorThan1Hour', !isMinorThan1Hour(completedAtTime));

          $scope.orderForm['startedAtTimeFormat_' + $index].$setValidity('isStartedAtTimeMissing', !isDateOrTimeMissing(startedAtDate, startedAtTime, 'time'));
          $scope.orderForm['startedAtTimeFormat_' + $index].$setValidity('startedAtIsLessThanCreatedAt', !isStartedAtLessThanCreatedAt(inputs, startedAtTimeFormat));
          $scope.orderForm['startedAtTimeFormat_' + $index].$setValidity('startedAtIsGreaterThanPresent', !isStartedAtGreaterThanPresent(inputs, startedAtTimeFormat));
          $scope.orderForm['completedAtTimeFormat_' + $index].$setValidity('isStartedAtTimeMissing', !isDateOrTimeMissing(completedAtDate, completedAtTime, 'time'));
          $scope.orderForm['completedAtTimeFormat_' + $index].$setValidity('completedAtIsLessThanStartedAt', !isCompletedAtLessThanStartedAt(inputs, startedAtTimeFormat, completedAtTimeFormat));
          $scope.orderForm['completedAtTimeFormat_' + $index].$setValidity('completedAtIsGreaterThanPresent', !isCompletedAtGreaterThanPresent(inputs, completedAtTimeFormat));
          $scope.orderForm['startedAtTimeFormat_' + $index].$setTouched();
          $scope.orderForm['completedAtTimeFormat_' + $index].$setTouched();
        }

        if (vm.account.configuration.featureValidateEmployeeIsInMoreThanOneTaskAtTheSameTime) {
          vm.tasks = validateEmployeeIsInMoreThanOneTaskAtTheSameTime.validate(vm.tasks, vm.account, vm.formErr);
        }

        if (task && task.scheduling && task.scheduling.date) {
          var currentStatus = TasksStatusHelper.getByName(task.status);
          if (currentStatus.name === 'pending') {
            $scope.orderForm['scheduling_date_' + $index].$setValidity('mustBeNull', false);
          } else {
            $scope.orderForm['scheduling_date_' + $index].$setValidity('mustBeNull', true);
          }
        } else {
          $scope.orderForm['scheduling_date_' + $index].$setValidity('mustBeNull', true);
        }
      }
    }

    function clearScheduledTime(task) {
      task.scheduling.time = null;

      $timeout(function () {
        if (vm.initialized && $scope.orderForm) {
          $scope.orderForm.$setDirty();
        }
      }, 100);
    }

    function scheduledDateChanged(newValue) {
      if (newValue && vm.initialized) {
        $timeout(function () {
          if (vm.initialized && $scope.orderForm) {
            /* workaround for https://github.com/indrimuska/angular-moment-picker/issues/66 */
            var tmp = document.createElement("input");

            $scope.orderForm.$setDirty();
            document.body.appendChild(tmp);
            tmp.focus();
            document.body.removeChild(tmp);
          }
        }, 100);
      }
    }

    function addTask() {
      vm.isAddingNewTask = true;
      var task = {
        sessionId: msUtils.uuidGenerator(),
        status: 'scheduled',
        employee: {
          id: null
        },
        scheduling: {
          date: moment().toDate(),
          time: null
        },
        position: vm.tasks.length,
        archived: false,
        metadata: {
          createdAt: moment().toDate(),
        },
        minDate: vm.configurations.featureCreateTaskWithPastDate ? moment('2015-01-01').toDate() : moment().toDate()
      };

      if (vm.order.address) {
        if (vm.order.address.coords) {
          task.coords = vm.order.address.coords;
        }
      }

      var lastTask = vm.tasks[vm.tasks.length - 1];
      task.duration = lastTask && lastTask.duration;
      if (!task.duration) {
        var serviceId = vm.order.service && vm.order.service.id;
        if (serviceId) {
          var service = _.find(vm.services, function (item) {
            return item.id === parseInt(serviceId);
          });

          if (service) {
            task.duration = service.duration;
          }
        }
      }

      task.scheduledDate = task.scheduling.date;
      vm.tasks.push(task);

      $timeout(function () {
        var container = $('.dialog-content');

        if (container) {
          container.scrollTop(container.scrollTop() + 1000);
        }
      }, 200);

      $timeout(function () {
        if ($scope.orderForm) {
          $scope.orderForm['duration_' + (vm.tasks.length - 1)].$setTouched();
        }
      }, 2000);
    }

    function deleteTask(task) {
      var index = vm.tasks.indexOf(task);

      if (index > -1) {
        vm.tasks.splice(index, 1);
      }
    }

    function archiveTask(task) {
      if (!CheckEditPermission.hasPermission() && vm.order.id) {
        return;
      }
      task.archived = true;

      if ($scope.orderForm) {
        $scope.orderForm.$setDirty();
      }
    }

    function archiveSingleTask(task) {
      if (!CheckEditPermission.hasPermission() && vm.order.id) {
        return;
      }
      $rootScope.loadingProgress = true;

      tasksApi.patchTasks([{ id: task.id, archived: true, viewedAt: null, receivedAt: null }]).then(function () {
        MessageDialog.showToast({
          hideDelay: 7000,
          message: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.TASK_ARCHIVED', { customerName: vm.order.customer.name, id: vm.order.identifier })
        });
        closeDialog(true);
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function unarchiveTask(task) {
      if (!CheckEditPermission.hasPermission() && vm.order.id) {
        return;
      }
      task.archived = false;

      if ($scope.orderForm) {
        $scope.orderForm.$setDirty();
      }
    }

    function unarchiveSingleTask(task) {
      if (!CheckEditPermission.hasPermission() && vm.order.id) {
        return;
      }
      $rootScope.loadingProgress = true;

      tasksApi.patchTasks([{ id: task.id, archived: false, viewedAt: null, receivedAt: null }]).then(function () {
        MessageDialog.showToast({
          hideDelay: 7000,
          message: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.TASK_UNARCHIVED', { customerName: vm.order.customer.name, id: vm.order.identifier })
        });
        closeDialog(true);
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    /// Order
    vm.resetDuplicatedIdentifierFormErr = resetDuplicatedIdentifierFormErr;
    vm.identifierIsRequired = true;
    vm.saveOrder = saveOrder;
    vm.saveCustomer = saveCustomer;
    vm.closeDialog = closeDialog;
    vm.sendPrintTask = sendPrintTask;
    vm.sendPrintOrder = sendPrintOrder;
    vm.sendByWhatsApp = sendByWhatsApp;
    vm.hasRequiredFormsErr = hasRequiredFormsErr;
    vm.validateOrderForm = validateOrderForm;

    function sendPrintOrder(order, emailIds) {
      var payload = { emails: [] };

      emailIds.forEach(function (emailId) {
        payload.emails.push({ id: emailId });
      });

      $rootScope.loadingProgress = true;
      ordersApi.sendPrintLink(order.id, payload).then(function () {
        MessageDialog.showToast({
          hideDelay: 10000,
          message: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.REPORT_LINK_SENDED', { customerName: order.customer.name })
        });
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function sendPrintTask(order, emailIds, taskId) {
      var payload = { emails: [] };

      emailIds.forEach(function (emailId) {
        payload.emails.push({ id: emailId });
      });

      $rootScope.loadingProgress = true;
      tasksApi.sendPrintLink(taskId, payload).then(function () {
        MessageDialog.showToast({
          hideDelay: 10000,
          message: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.REPORT_LINK_SENDED', { customerName: order.customer.name })
        });
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function resetDuplicatedIdentifierFormErr() {
      if (vm.order.identifier !== vm.formErr['duplicatedIdentifier_value']) {
        delete vm.formErr['duplicatedIdentifier_value'];
        delete vm.formErr['duplicatedIdentifier'];
      }
    }

    function saveCustomer(callback) {
      if (vm.addOrEditCustomer || vm.selectedCustomer.type) {
        if (vm.selectedCustomer.type === "ca") {
          vm.selectedCustomer = fixSelectedCustomerEmailAndPhone(vm.selectedCustomer);
        } else {
          vm.selectedCustomer.contacts = msUtils.clearEmptyContacts(vm.selectedCustomer.contacts);
        }
        vm.selectedCustomer.contacts.phones = removeCheckedProperty(vm.selectedCustomer.contacts.phones);
        vm.selectedCustomer.address.coords = _setCoords(vm.selectedCustomer.address.coords);

        var customerToCreate = {
          name: vm.selectedCustomer.name,
          address: vm.selectedCustomer.address,
          contacts: vm.selectedCustomer.contacts,
          documentNumber: vm.selectedCustomer.documentNumber,
          notes: vm.selectedCustomer.notes
        };

        customersApiGraphQL.createCustomer(customerToCreate).then(function (savedCustomer) {
          vm.order.customer = savedCustomer;

          _getPrimaryLocation(savedCustomer, function (primaryLocation) {
            vm.selectedCustomerLocation = primaryLocation;
            selectedCustomerLocationChanged(primaryLocation);

            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('TASKS.TOASTS.GENERAL.CUSTOMER_REGISTERED', { customerName: savedCustomer.name }))
                .hideDelay(3000)
            );

            vm.addOrEditCustomer = false;
            callback();
          });
        }).catch(function () {
          $rootScope.loadingProgress = false;
        });
      } else {
        callback();
      }
    }

    function removeCheckedProperty(contacts) {
      return contacts.map(function (contact) {
        if (contact.hasOwnProperty('checked')) {
          delete contact.checked;
        }
        return contact;
      });
    }

    function _setCoords(coords) {
      return { latitude: parseFloat(coords.latitude) || 0 , longitude: parseFloat(coords.longitude) || 0 };
    }

    function generateIdentifier(callback) {

      if (vm.order.id || vm.order.identifier) {
        return callback();
      }

      var isBradescoPat = vm.order && vm.order.ticket && vm.order.ticket.metadata && vm.order.ticket.metadata.integration === 'bradesco-pat';

      if (isBradescoPat && ((vm.order && !vm.order.identifier) || (vm.ticket && !vm.ticket.identifier))) {
        MessageDialog.showToast({
          hideDelay: 2000,
          message: $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.IDENTIFIER.ERRORS.REQUIRED')
        });
        return callback();
      }

      var isBradescoDiti = vm.order && vm.order.ticket && vm.order.ticket.metadata && vm.order.ticket.metadata.type === 'bradesco-diti';

      if (isBradescoDiti && ((vm.order && !vm.order.identifier) || (vm.ticket && !vm.ticket.identifier))) {
        MessageDialog.showToast({
          hideDelay: 2000,
          message: $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.IDENTIFIER.ERRORS.REQUIRED')
        });
        return callback();
      }

      var isIdentifierTypeNone = vm.ordersIdentifierType === 'none';
      var corporateAccountUuid = msUtils.getCorporateAccountUuidFromService(vm.order.service);

      if (isIdentifierTypeNone && !corporateAccountUuid) {
        return callback();
      }

      var payload = {
        corporateAccountUuid: corporateAccountUuid
      };

      ordersApi.nextIdentifier(payload)
        .then(function (result) {
          vm.order.identifier = result.identifier;
          callback();
        });
    }

    function _isValidTicket(callback) {
      if (_.isEmpty(vm.ticket)) {
        return callback();
      }

      ticketsApi.getOne(vm.ticket.id).then(function (ticket) {
        var ticketIsPending = ticket && (!ticket.status || ticket.status === 'pending');
        var ticketIsScheduling = ticket && (!ticket.status || ticket.status === 'scheduling');
        var ticketIsExpired = (ticketIsPending || ticketIsScheduling) && ticket.expiredAt && moment().isAfter(moment(ticket.expiredAt));

        if (!ticketIsPending || !ticketIsScheduling || !ticketIsExpired) {
          return callback();
        }

        var messageTranslation = ticketIsExpired ? 'EXPIRED' : 'ACCEPT_FAILED';
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('TASKS.TOASTS.TICKETS.' + messageTranslation))
            .hideDelay(2000)
        );

        closeDialog(true);
      });
    }

    function updateLabels(order, options) {
      if (!order.id || !order.idLabels) {
        return;
      }

      if (options && options.showProgress) {
        $rootScope.loadingProgress = true;
      }

      var labels = _.map(order.idLabels, function (id) {
        return { id: id };
      });

      return ordersApi.setLabels(order.id, labels)
        .then(function () {
          if (options && options.showToast) {
            MessageDialog.showToast({
              hideDelay: 3000,
              message: $translate.instant('TASKS.DIALOG.LABELS.LABELS_UPDATED')
            });
          }
        })
        .finally(function () {
          if (options && options.showProgress) {
            $rootScope.loadingProgress = false;
          }

          if (options && options.reload) {
            document.dispatchEvent(new CustomEvent('order-dialog:updated'));
            $rootScope.$broadcast('tasks:reload');
          }
        });
    }

    function saveOrder() {
      if (vm.hasCreateOrderWithTasksFlag) {
        return saveOrderWithTasks();
      }

      return saveOrderLegacy();
    }

    function saveOrderWithTasks() {
      if (vm.order.id && !vm.editPermission) {
        MessageDialog.showToast({
          hideDelay: 2000,
          message: $translate.instant('TASKS.DIALOG.ACTIONS.ALERTS.CANT_EDIT')
        });
        return;
      }
      if (!vm.order.id && !vm.addPermission) {
        MessageDialog.showToast({
          hideDelay: 2000,
          message: $translate.instant('TASKS.DIALOG.ACTIONS.ALERTS.CANT_CREATE')
        });
        return;
      }
      $rootScope.loadingProgress = true;
      _isValidTicket(function () {
        saveCustomer(function () {
          generateIdentifier(function () {
            if (vm.order._deadlineAt) {
              vm.order.deadlineAt = moment(vm.order._deadlineAt).format('YYYY-MM-DD');
            } else {
              vm.order.deadlineAt = null;
            }

            if (vm.order.description) {
              vm.order.description = ('' + vm.order.description).trim();
            }

            if (vm.order.tasks && vm.order.tasks.length) {
              vm.order.tasks.forEach(function (task) {
                if (task.statusDescription) {
                  task.statusDescription = ('' + task.statusDescription).trim();
                }
              });
            }

            var orderPayload = angular.copy(vm.order);

            delete orderPayload.forms;
            delete orderPayload.form;
            delete orderPayload.untouchedForms;
            delete orderPayload.tasks;
            delete orderPayload.untouchedTasks;
            orderPayload.service = { id: vm.order.service.id };

            if (!orderPayload.location) {
              customersApi.getOne(orderPayload.customer.id).then(function (customer) {
                if (customer && customer.primaryLocation) {
                  orderPayload.location = customer.primaryLocation;
                  orderPayload.address = customer.primaryLocation.address;
                };
                _saveOrderWithTasks(orderPayload);
              });
            } else {
              _saveOrderWithTasks(orderPayload);
            }
          });
        });
      });
    }

    function _saveOrderWithTasks(orderPayload) {
      if (vm.isCreatingOrder) {
        var taskPayload = [];

        vm.tasks.forEach(function (task) {
          var _task = angular.copy(task);
          _task.order = { id: null };

          delete _task.attachments;

          if (!_task.scheduling) {
            _task.scheduling = angular.copy(vm.emptySchedulingState);
          }

          if (_task.scheduling.time) {
            _task.scheduling.time = vm.timeFormatIsActive ? LocalDateConvert.convertTimeToSave(_task.scheduling.time, task.scheduledTimeFormat) : _task.scheduling.time;
            _task.scheduling.type = 'scheduled-date-and-time';
          } else {
            _task.scheduling.type = 'scheduled-date';
          }

          if (_task.scheduling.date) {
            _task.scheduling.date = moment(_task.scheduling.date).format('YYYY-MM-DD');
          } else {
            _task.scheduling.date = null;
            _task.scheduling.type = 'non-scheduled';
            _task.status = 'pending';
          }

          if (_task.startedAtDate || _task.startedAtTime) {
            if (_task.startedAtTime.indexOf(':') === -1) {
              _task.startedAtTime = _task.startedAtTime.substring(0, 2) + ':' + _task.startedAtTime.substring(2, 4);
            }

            if (vm.timeFormatIsActive) {
              _task.startedAtTime = LocalDateConvert.convertTimeToSave(_task.startedAtTime, task.startedAtTimeFormat);
            }

            var startedAtDate = moment(_task.startedAtDate).format('YYYY-MM-DD');
            var startedAtLocal = moment(startedAtDate + 'T' + _task.startedAtTime);
            var startedAtUtc = moment.utc(startedAtLocal);
            _task.startedAt = startedAtUtc.format();
          }

          if (_task.completedAtDate || _task.completedAtTime) {
            if (_task.completedAtTime.indexOf(':') === -1) {
              _task.completedAtTime = _task.completedAtTime.substring(0, 2) + ':' + _task.completedAtTime.substring(2, 4);
            }

            if (vm.timeFormatIsActive) {
              _task.completedAtTime = LocalDateConvert.convertTimeToSave(_task.completedAtTime, task.completedAtTimeFormat);
            }

            var completedAtDate = moment(_task.completedAtDate).format('YYYY-MM-DD');
            var completedAtLocal = moment(completedAtDate + 'T' + _task.completedAtTime);
            var completedAtUtc = moment.utc(completedAtLocal);

            _task.completedAt = completedAtUtc.format();
          }

          if (!_task.employee || (_task.employee && _task.employee.id === 'null')) {
            _task.employee = { id: null };
          }

          if (_task.coords) {
            if (!_task.coords.latitude || !_task.coords.longitude) {
              if (vm.order.address && vm.order.address.coords) {
                _task.coords = vm.order.address.coords;
              }
            }
          } else {
            if (vm.order.address && vm.order.address.coords) {
              _task.coords = vm.order.address.coords;
            }
          }

          _task.duration = parseInt(_task.duration);

          taskPayload.push(_task);
        });

        orderPayload.tasks = taskPayload;
      }

      ordersApi.saveWithTasks(orderPayload).then(function (savedOrder) {

        vm.order.id = savedOrder.id;

        if(vm.isCreatingOrder) {
          updateLabels(vm.order);
        }

        var requests = {};

        if (vm.order.deletingForms && vm.order.deletingForms.length) {
          vm.order.deletingForms.forEach(function (deletingForm) {
            requests['delete_form_' + deletingForm.id] = ordersApi.deleteForm(vm.order.id, deletingForm);
          });
        }

        document.dispatchEvent(new CustomEvent('saveOrder', { detail: { order: savedOrder } }));

        if (!vm.isCreatingOrder) {
          var updatingTasks = [];
          var insertingTasks = [];

          vm.tasks.forEach(function (task) {
            var _task = angular.copy(task);
            _task.order = { id: vm.order.id };
            delete _task.attachments;

            if (!_task.scheduling) {
              _task.scheduling = angular.copy(vm.emptySchedulingState);
            }

            if (_task.scheduling.time) {
              _task.scheduling.time = vm.timeFormatIsActive ? LocalDateConvert.convertTimeToSave(_task.scheduling.time, task.scheduledTimeFormat) : _task.scheduling.time;
              _task.scheduling.type = 'scheduled-date-and-time';
            } else {
              _task.scheduling.type = 'scheduled-date';
            }

            if (_task.scheduling.date) {
              _task.scheduling.date = moment(_task.scheduling.date).format('YYYY-MM-DD');
            } else {
              _task.scheduling.date = null;
              _task.scheduling.type = 'non-scheduled';
              _task.status = 'pending';
            }

            if (_task.startedAtDate || _task.startedAtTime) {
              if (_task.startedAtTime.indexOf(':') === -1) {
                _task.startedAtTime = _task.startedAtTime.substring(0, 2) + ':' + _task.startedAtTime.substring(2, 4);
              }

              if (vm.timeFormatIsActive) {
                _task.startedAtTime = LocalDateConvert.convertTimeToSave(_task.startedAtTime, task.startedAtTimeFormat);
              }

              var startedAtDate = moment(_task.startedAtDate).format('YYYY-MM-DD');
              var startedAtLocal = moment(startedAtDate + 'T' + _task.startedAtTime);
              var startedAtUtc = moment.utc(startedAtLocal);
              _task.startedAt = startedAtUtc.format();
            }

            if (_task.completedAtDate || _task.completedAtTime) {
              if (_task.completedAtTime.indexOf(':') === -1) {
                _task.completedAtTime = _task.completedAtTime.substring(0, 2) + ':' + _task.completedAtTime.substring(2, 4);
              }

              if (vm.timeFormatIsActive) {
                _task.completedAtTime = LocalDateConvert.convertTimeToSave(_task.completedAtTime, task.completedAtTimeFormat);
              }

              var completedAtDate = moment(_task.completedAtDate).format('YYYY-MM-DD');
              var completedAtLocal = moment(completedAtDate + 'T' + _task.completedAtTime);
              var completedAtUtc = moment.utc(completedAtLocal);

              _task.completedAt = completedAtUtc.format();
            }

            if (!_task.employee || (_task.employee && _task.employee.id === 'null')) {
              _task.employee = { id: null };
            }

            if (_task.coords) {
              if (!_task.coords.latitude || !_task.coords.longitude) {
                if (vm.order.address && vm.order.address.coords) {
                  _task.coords = vm.order.address.coords;
                }
              }
            } else {
              if (vm.order.address && vm.order.address.coords) {
                _task.coords = vm.order.address.coords;
              }
            }

            _task.duration = parseInt(_task.duration);

            if (_task.id) {
              delete _task._timeline;
              delete _task._currentEmployeeId;

              _task.hash = hasher.sha1ButIgnoreNGHashKey(_task);

              var untouchedTask = _.find(vm.order.untouchedTasks, function (currentTask) {
                return _task.id === currentTask.id;
              });

              if (untouchedTask) {
                if (untouchedTask.hash !== _task.hash) {
                  if (checkToResetReceivedAtViewedAt(untouchedTask, _task)) {
                    _task.receivedAt = null;
                    _task.viewedAt = null;
                  }

                  updatingTasks.push(_task);
                }
              }
            } else {
              insertingTasks.push(_task);
            }
          });

          if (updatingTasks.length) {
            requests.updateTasks = tasksApi.updateTasks(updatingTasks);
          }

          requests['sync_tasks'] = new Promise(function (resolve, reject) {
            var linkTasksPromises = _.map(insertingTasks, function (insertingTask, index) {
              return function (callback) {
                return tasksApi.save(insertingTask).then(function (task) {

                  for (var i = 0; i < vm.taskSmartRewriteFields.length; i++) {
                    var field = vm.taskSmartRewriteFields[i];
                    var params = {
                      reference: insertingTask.sessionId,
                      referenceType: field,
                      updatedReference: task.id
                    };
                    gandalfApi.updateRewriteInputHistory(params);
                  }

                  var isFirstTask = index === 0;

                  if(!isFirstTask) {
                    return callback(null);
                  }

                  _saveAttachments(task.id, function () {
                    if (Data && Data._hooks && Data._hooks.onSaved) {
                      Data._hooks.onSaved(response).then(function () {
                        closeDialog(true);
                      });
                    } else {
                      closeDialog(true);
                    }
                  });

                  setTimeout(function () {
                    callback(null);
                  }, 500);
                }).catch(function (err) {
                  callback(err);
                });
              };
            });

            async.waterfall(linkTasksPromises, function (error, result) {
              if (error) {
                return reject(error);
              }
              resolve(result);
            });
          });
        }

        if (vm.isCreatingOrder && savedOrder.tasks && savedOrder.tasks.length) {
          requests['sync_tasks'] = new Promise(function (resolve, reject) {
            var linkTasksPromises = _.map(savedOrder.tasks, function (task, index) {
              return function (callback) {
                var currentTask = _.find(taskPayload, function (currentTask) {
                  return currentTask.sessionId === task.sessionId;
                });

                if (currentTask) {
                  for (var i = 0; i < vm.taskSmartRewriteFields.length; i++) {
                    var field = vm.taskSmartRewriteFields[i];
                    var params = {
                      reference: currentTask.sessionId,
                      referenceType: field,
                      updatedReference: task.id
                    };
                    gandalfApi.updateRewriteInputHistory(params);
                  }
                }

                var isFirstTask = index === 0;

                if (!isFirstTask) {
                  return callback(null);
                }

                _saveAttachments(task.id, function () {
                  if (Data && Data._hooks && Data._hooks.onSaved) {
                    Data._hooks.onSaved(response).then(function () {
                      closeDialog(true);
                    });
                  } else {
                    closeDialog(true);
                  }
                });

                setTimeout(function () {
                  callback(null);
                }, 500);
              };
            });

            async.waterfall(linkTasksPromises, function (error, result) {
              if (error) {
                return reject(error);
              }
              resolve(result);
            });
          });
        }

        // Materials
        orderMaterialsService.getMaterials().forEach(function (material, index) {
          requests['new_material_' + index] = ordersApi.saveMaterial(vm.order.id, material);
        });

        _saveOrderProducts();
        _saveOrderServices();

        if (vm.orderDeadlineContractId) {
          var hashDeadlineContract = hasher.sha1ButIgnoreNGHashKey(vm.orderDeadlineContractId);
          if (vm.order.untouchedDeadline !== hashDeadlineContract) {
            requests['deadline'] = ordersApi.saveDeadline(vm.order.id, vm.orderDeadlineContractId);
          }

          if (vm.order.deadline && vm.order.deadline.responseViolationReason && vm.order.deadline.responseViolationReason.id) {
            var hashResponseDeadlineViolationReason = hasher.sha1ButIgnoreNGHashKey(vm.order.deadline.responseViolationReason.id);
            if (vm.order.untouchedResponseDeadlineViolationReason !== hashResponseDeadlineViolationReason) {
              requests['responseDeadlineViolationReason'] = ordersApi.saveDeadlineViolationReason(vm.order.id, 'response', vm.order.deadline.responseViolationReason.id, vm.order.deadline.id);
            }
          }

          if (vm.order.deadline && vm.order.deadline.solutionViolationReason && vm.order.deadline.solutionViolationReason.id) {
            var hashSolutionDeadlineViolationReason = hasher.sha1ButIgnoreNGHashKey(vm.order.deadline.solutionViolationReason.id);
            if (vm.order.untouchedSolutionDeadlineViolationReason !== hashSolutionDeadlineViolationReason) {
              requests['solutionDeadlineViolationReason'] = ordersApi.saveDeadlineViolationReason(vm.order.id, 'solution', vm.order.deadline.solutionViolationReason.id, vm.order.deadline.id);
            }
          }
        }

        if (vm.ticket && vm.ticket.id) {
          requests['ticket'] = ticketsApi.accept(vm.ticket.id);
        }

        $q.all(requests).then(function (response) {
          MessageDialog.showToast({
            hideDelay: 7000,
            message: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.TASK_SAVED', { customerName: vm.order.customer.name, id: vm.order.identifier })
          });

          if (vm.isCreatingOrder) {
            OrderDialog.linkEquipments(vm.selectedEquipments, vm.order.id);
            _saveOrderLInks();
          }

          for (var i = 0; i < vm.smartRewriteFields.length; i++) {
            var field = vm.smartRewriteFields[i];
            var params = {
              reference: vm.sessionId,
              referenceType: field,
              updatedReference: savedOrder.id
            };

            gandalfApi.updateRewriteInputHistory(params);
          }
          closeDialog(true);
        });
      }).catch(function (err) {
        if (err.status === 422) {
          if (err.data && err.data.code && err.data.code === 'orders_duplicated_identifier_key') {
            vm.formErr['duplicatedIdentifier_value'] = vm.order.identifier;
            vm.formErr['duplicatedIdentifier'] = $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.IDENTIFIER.ERRORS.IN_USE');
            vm.disableIdentifierInput = false;
          }
          if (err.data && err.data.code && err.data.code === 'ticket_already_used') {
            closeDialog(true);
            $mdToast.show(
              $mdToast
                .simple()
                .textContent($translate.instant('TASKS.TOASTS.TICKETS.ACCEPT_FAILED_DUPLICATED'))
                .hideDelay(6000)
                .theme('error-toast')
            );
          }
        }

        $rootScope.loadingProgress = false;
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function saveOrderLegacy() {
      if (vm.order.id && !vm.editPermission) {
        MessageDialog.showToast({
          hideDelay: 2000,
          message: $translate.instant('TASKS.DIALOG.ACTIONS.ALERTS.CANT_EDIT')
        });
        return;
      }
      if (!vm.order.id && !vm.addPermission) {
        MessageDialog.showToast({
          hideDelay: 2000,
          message: $translate.instant('TASKS.DIALOG.ACTIONS.ALERTS.CANT_CREATE')
        });
        return;
      }
      $rootScope.loadingProgress = true;
      _isValidTicket(function () {
        saveCustomer(function () {
          generateIdentifier(function () {
            if (vm.order._deadlineAt) {
              vm.order.deadlineAt = moment(vm.order._deadlineAt).format('YYYY-MM-DD');
            } else {
              vm.order.deadlineAt = null;
            }

            if (vm.order.description) {
              vm.order.description = ('' + vm.order.description).trim();
            }

            if (vm.order.tasks && vm.order.tasks.length) {
              vm.order.tasks.forEach(function (task) {
                if (task.statusDescription) {
                  task.statusDescription = ('' + task.statusDescription).trim();
                }
              });
            }

            var orderPayload = angular.copy(vm.order);
            delete orderPayload.forms;
            delete orderPayload.form;
            delete orderPayload.untouchedForms;
            delete orderPayload.tasks;
            delete orderPayload.untouchedTasks;
            orderPayload.service = { id: vm.order.service.id };

            if (!orderPayload.location) {
              customersApi.getOne(orderPayload.customer.id).then(function (customer) {
                if (customer && customer.primaryLocation) {
                  orderPayload.location = customer.primaryLocation;
                  orderPayload.address = customer.primaryLocation.address;
                };
                _saveOrder(orderPayload);
              });
            } else {
              _saveOrder(orderPayload);
            }
          });
        });
      });
    }

    function _saveOrder(orderPayload) {
      ordersApi.save(orderPayload).then(function (savedOrder) {
        vm.order.id = savedOrder.id;

        if (vm.isCreatingOrder) {
          updateLabels(vm.order);
        }

        var requests = {};

        if (vm.order.deletingForms && vm.order.deletingForms.length) {
          vm.order.deletingForms.forEach(function (deletingForm) {
            requests['delete_form_' + deletingForm.id] = ordersApi.deleteForm(vm.order.id, deletingForm);
          });
        }

        document.dispatchEvent(new CustomEvent('saveOrder', { detail: { order: savedOrder } }));

        var updatingTasks = [];
        var insertingTasks = [];
        var linkSecondaryEmployeesRequests = [];
        requests['secondary_employees'] = [];

        vm.tasks.forEach(function (task) {
          var _task = angular.copy(task);
          _task.order = { id: vm.order.id };
          delete _task.attachments;

          if (!_task.scheduling) {
            _task.scheduling = angular.copy(vm.emptySchedulingState);
          }

          if (_task.scheduling.time) {
            _task.scheduling.time = vm.timeFormatIsActive ? LocalDateConvert.convertTimeToSave(_task.scheduling.time, task.scheduledTimeFormat) : _task.scheduling.time;
            _task.scheduling.type = 'scheduled-date-and-time';
          } else {
            _task.scheduling.type = 'scheduled-date';
          }

          if (_task.scheduling.date) {
            _task.scheduling.date = moment(_task.scheduling.date).format('YYYY-MM-DD');
          } else {
            _task.scheduling.date = null;
            _task.scheduling.type = 'non-scheduled';
            _task.status = 'pending';
          }

          if (_task.startedAtDate || _task.startedAtTime) {
            if (_task.startedAtTime.indexOf(':') === -1) {
              _task.startedAtTime = _task.startedAtTime.substring(0, 2) + ':' + _task.startedAtTime.substring(2, 4);
            }

            if (vm.timeFormatIsActive) {
              _task.startedAtTime = LocalDateConvert.convertTimeToSave(_task.startedAtTime, task.startedAtTimeFormat);
            }

            var startedAtDate = moment(_task.startedAtDate).format('YYYY-MM-DD');
            var startedAtLocal = moment(startedAtDate + 'T' + _task.startedAtTime);
            var startedAtUtc = moment.utc(startedAtLocal);
            _task.startedAt = startedAtUtc.format();
          }

          if (_task.completedAtDate || _task.completedAtTime) {
            if (_task.completedAtTime.indexOf(':') === -1) {
              _task.completedAtTime = _task.completedAtTime.substring(0, 2) + ':' + _task.completedAtTime.substring(2, 4);
            }

            if (vm.timeFormatIsActive) {
              _task.completedAtTime = LocalDateConvert.convertTimeToSave(_task.completedAtTime, task.completedAtTimeFormat);
            }

            var completedAtDate = moment(_task.completedAtDate).format('YYYY-MM-DD');
            var completedAtLocal = moment(completedAtDate + 'T' + _task.completedAtTime);
            var completedAtUtc = moment.utc(completedAtLocal);

            _task.completedAt = completedAtUtc.format();
          }

          if (!_task.employee || (_task.employee && _task.employee.id === 'null')) {
            _task.employee = { id: null };
          }

          if (_task.coords) {
            if (!_task.coords.latitude || !_task.coords.longitude) {
              if (vm.order.address && vm.order.address.coords) {
                _task.coords = vm.order.address.coords;
              }
            }
          } else {
            if (vm.order.address && vm.order.address.coords) {
              _task.coords = vm.order.address.coords;
            }
          }

          _task.duration = parseInt(_task.duration);

          if (_task.id) {
            delete _task._timeline;
            delete _task._currentEmployeeId;

            _task.hash = hasher.sha1ButIgnoreNGHashKey(_task);

            var untouchedTask = _.find(vm.order.untouchedTasks, function (currentTask) {
              return _task.id === currentTask.id;
            });

            if (untouchedTask) {
              if (untouchedTask.hash !== _task.hash) {
                if (checkToResetReceivedAtViewedAt(untouchedTask, _task)) {
                  _task.receivedAt = null;
                  _task.viewedAt = null;
                }

                updatingTasks.push(_task);
                linkSecondaryEmployeesRequests.push({
                  taskId: _task.id,
                  secondaryEmployeesIds: _task.secondaryEmployees.map(function (employee) {
                    return Number(employee);
                  })
                });
              }
            }
          } else {
            insertingTasks.push(_task);
          }
        });

        if (updatingTasks.length) {
          requests.updateTasks = tasksApi.updateTasks(updatingTasks);
        }

        requests['sync_tasks'] = new Promise(function (resolve, reject) {
          var linkTasksPromises = _.map(insertingTasks, function (insertingTask, index) {
            return function (callback) {
              return tasksApi.save(insertingTask).then(function (task) {

                for (var i = 0; i < vm.taskSmartRewriteFields.length; i++) {
                  var field = vm.taskSmartRewriteFields[i];
                  var params = {
                    reference: insertingTask.sessionId,
                    referenceType: field,
                    updatedReference: task.id
                  };
                  gandalfApi.updateRewriteInputHistory(params);
                }

                  if (insertingTask.secondaryEmployees && insertingTask.secondaryEmployees.length) {
                    var linkSecondaryEmployeesParams = {
                      taskId: task.id,
                      secondaryEmployeesIds: insertingTask.secondaryEmployees.map(function (employee) {
                        return Number(employee);
                      })
                    };
                    tasksApi.linkSecondaryEmployees(linkSecondaryEmployeesParams);
                  }

                var isFirstTask = index === 0;

                if (!isFirstTask) {
                  return callback(null);
                }

                _saveAttachments(task.id, function () {
                  if (Data && Data._hooks && Data._hooks.onSaved) {
                    Data._hooks.onSaved(task).then( function (){
                      callback(null);
                    });
                  }
                });

                setTimeout(function () {
                  callback(null);
                }, 500);
              }).catch(function (err) {
                callback(err);
              });
            };
          });

          async.waterfall(linkTasksPromises, function (error, result) {
            if (error) {
              return reject(error);
            }
            resolve(result);
          });
        });

        // Materials
        orderMaterialsService.getMaterials().forEach(function (material, index) {
          requests['new_material_' + index] = ordersApi.saveMaterial(vm.order.id, material);
        });

        _saveOrderProducts();
        _saveOrderServices();

        if (vm.orderDeadlineContractId) {
          var hashDeadlineContract = hasher.sha1ButIgnoreNGHashKey(vm.orderDeadlineContractId);
          if (vm.order.untouchedDeadline !== hashDeadlineContract) {
            requests['deadline'] = ordersApi.saveDeadline(vm.order.id, vm.orderDeadlineContractId);
          }

          if (vm.order.deadline && vm.order.deadline.responseViolationReason && vm.order.deadline.responseViolationReason.id) {
            var hashResponseDeadlineViolationReason = hasher.sha1ButIgnoreNGHashKey(vm.order.deadline.responseViolationReason.id);
            if (vm.order.untouchedResponseDeadlineViolationReason !== hashResponseDeadlineViolationReason) {
              requests['responseDeadlineViolationReason'] = ordersApi.saveDeadlineViolationReason(vm.order.id, 'response', vm.order.deadline.responseViolationReason.id, vm.order.deadline.id);
            }
          }

          if (vm.order.deadline && vm.order.deadline.solutionViolationReason && vm.order.deadline.solutionViolationReason.id) {
            var hashSolutionDeadlineViolationReason = hasher.sha1ButIgnoreNGHashKey(vm.order.deadline.solutionViolationReason.id);
            if (vm.order.untouchedSolutionDeadlineViolationReason !== hashSolutionDeadlineViolationReason) {
              requests['solutionDeadlineViolationReason'] = ordersApi.saveDeadlineViolationReason(vm.order.id, 'solution', vm.order.deadline.solutionViolationReason.id, vm.order.deadline.id);
            }
          }
        }

        if (vm.ticket && vm.ticket.id) {
          requests['ticket'] = ticketsApi.accept(vm.ticket.id);
        }

        linkSecondaryEmployeesRequests.forEach(function (linkSecondaryEmployeesRequest) {
          requests['secondary_employees'].push(tasksApi.linkSecondaryEmployees(linkSecondaryEmployeesRequest));
        });

        $q.all(requests).then(function (response) {
          MessageDialog.showToast({
            hideDelay: 7000,
            message: $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.TASK_SAVED', { customerName: vm.order.customer.name, id: vm.order.identifier })
          });

          if (vm.isCreatingOrder) {
            OrderDialog.linkEquipments(vm.selectedEquipments, vm.order.id);
            _saveOrderLinks();
          }

          for (var i = 0; i < vm.smartRewriteFields.length; i++) {
            var field = vm.smartRewriteFields[i];
            var params = {
              reference: vm.sessionId,
              referenceType: field,
              updatedReference: savedOrder.id
            };

            gandalfApi.updateRewriteInputHistory(params);
          }
          closeDialog(true);
        });
      }).catch(function (err) {
        if (err.status === 422) {
          if (err.data && err.data.code && err.data.code === 'orders_duplicated_identifier_key') {
            vm.formErr['duplicatedIdentifier_value'] = vm.order.identifier;
            vm.formErr['duplicatedIdentifier'] = $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.IDENTIFIER.ERRORS.IN_USE');
            vm.disableIdentifierInput = false;
          }
          if (err.data && err.data.code && err.data.code === 'ticket_already_used') {
            closeDialog(true);
            $mdToast.show(
              $mdToast
                .simple()
                .textContent($translate.instant('TASKS.TOASTS.TICKETS.ACCEPT_FAILED_DUPLICATED'))
                .hideDelay(6000)
                .theme('error-toast')
            );
          }
        }

        $rootScope.loadingProgress = false;
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function _saveAttachments(taskId, callback) {
      if (!taskId || !(vm.filesToUpload && vm.filesToUpload.length)) { return callback(); }
      var uploadFilesPromises = vm.filesToUpload.map(function (file) {
        return uploadApi.uploadWithPreSignedPost({
          file: file,
          filePath: "/orders/" + vm.order.id + "/tasks/" + taskId + "/" + file.name.replace(/%20| /g, '')
        }, function () { });
      });

      Promise.all(uploadFilesPromises)
        .then(function (uploadedFiles) {
          var saveTasksAttachmentsPromises = uploadedFiles.map(function (uploadedFile, index) {
            var uploadedFileInfos = vm.filesToUpload[index];
            var attachmentTitle = vm.attachments[index].title || null;
            var attachmentPosition = vm.attachments[index].position || null;
            var attachment = {
              path: uploadedFile.path,
              task: {
                id: taskId
              },
              title: attachmentTitle,
              size: uploadedFileInfos.size,
              type: uploadedFile.contentType,
              position: attachmentPosition
            };
            return tasksApi.postAttachment(attachment.task.id, attachment);
          });

          Promise.all(saveTasksAttachmentsPromises)
            .finally(function () {
              callback();
            });
        })
        .catch(function () {
          callback();
        });
    }

    function checkRequiredForms(options) {
      var featureValidateRequiredForms = msUtils.getConfiguration('featureValidateRequiredForms', [
        vm.order && vm.order.metadata,
        vm.accountConfiguration
      ]);

      if (featureValidateRequiredForms) {
        delete vm.requiredFormsErr['requiredForm' + options.taskIndex];

        if (options.status === 'done' || options.status === 'reported') {
          options.serviceForms = vm.order.service.forms;
          options.forms = vm.order.forms;

          var result = formValidator.validate(options);

          if (!result.isValid) {
            vm.requiredFormsErr['requiredForm' + options.taskIndex] = result.errors;
          }
        }
      }
    }

    function hasRequiredFormsErr() {
      return Object.keys(vm.requiredFormsErr).length;
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
      orderProductsService.resetProducts();
      orderProductsService.resetUpdateProducts();
      orderServicesService.resetServicesToUpdate();
    }

    function validateOrderForm() {
      return (
        $scope.orderForm.$invalid ||
        $scope.orderForm.$pristine ||
        !vm.validateCustomer() ||
        !vm.selectedCustomerLocation ||
        vm.hasErrors() ||
        $rootScope.loadingProgress ||
        vm.hasRequiredFormsErr() ||
        vm.uploadProgress ||
        vm.hasMultiplePictureInvalidQuestion
      );
    }

    /// Map
    vm.useEmployeeCoords = useEmployeeCoords;
    vm.useCustomerCoords = useCustomerCoords;
    vm.getEmployeesWithTask = getEmployeesWithTask;
    vm.selectedAddressItemChange = selectedAddressItemChange;
    vm.searchAddress = searchAddress;
    vm.clearSelectedCustomerAddress = clearSelectedCustomerAddress;
    vm.googleCustomerAddressErrors = [];
    vm.googleCustomerAddressWarnings = [];
    vm.userTerritories = [];
    vm.setNewCustomerLocation = false;

    function fixSelectedCustomerEmailAndPhone(customer) {
      if (customer.contacts) {
        if (customer.contacts.emails
          && customer.contacts.emails[0]
          && customer.contacts.emails[0].address.length < 1) {
          customer.contacts.emails = [];
        }

        if (customer.contacts.phones
          && customer.contacts.phones[0]
          && customer.contacts.phones[0].number.length < 1) {
          customer.contacts.phones = [];
        }
      }
      return customer;
    }

    function clearSelectedCustomerAddress() {
      vm.selectedNewCustomerAddress = false;
      vm.selectedCustomerAddress = null;
      vm.selectedCustomerAddressText = '';

      if (vm.marker) {
        vm.marker.setLatLng([1, 1]);
      }

      $timeout(function () {
        if ($scope.orderForm) {
          $scope.orderForm.$setValidity('customerAddress', false, window);
        }
      });
      vm.googleCustomerAddressErrors = [];
      vm.googleCustomerAddressWarnings = [];

      vm.selectedCustomer.address = null;

      $timeout(function () {
        focus('address');
      }, 200);
    }

    function selectedAddressItemChange(selectedAddress, setCustomerAddress) {
      if (selectedAddress) {
        _setOrderCoords({
          latitude: selectedAddress.lat,
          longitude: selectedAddress.lng
        });

        if ($scope.orderForm) {
          $scope.orderForm.$setDirty();
        }

        if (setCustomerAddress) {
          if (vm.selectedCustomer.type == "ca" && vm.selectedCustomer.address) {
            vm.selectedCustomer.address.coords = {
              latitude: selectedAddress.lat,
              longitude: selectedAddress.lng
            };
          } else {
            vm.selectedCustomer.address = {
              zipCode: selectedAddress.zipCode || null,
              city: selectedAddress.city || null,
              state: selectedAddress.state || null,
              neighborhood: selectedAddress.neighborhood || null,
              street: selectedAddress.street || null,
              number: selectedAddress.number || null,
              coords: {
                latitude: selectedAddress.lat,
                longitude: selectedAddress.lng
              },
              formattedAddress: selectedAddress.formattedAddress
            };
            vm.selectedCustomerLocation = {
              address: vm.selectedCustomer.address
            };
          }
        }

        if (vm.ticket && vm.ticket.metadata && vm.ticket.metadata && vm.ticket.metadata.address) {
          vm.selectedCustomer.address.complement = vm.ticket.metadata.address.complement;
        }

        var validation = addressService.validateAddress(selectedAddress);

        $timeout(function () {
          if ($scope.orderForm) {
            $scope.orderForm.$setValidity('customerAddress', validation.valid, window);
          }
        });
        vm.googleCustomerAddressErrors = validation.errors;
        vm.googleCustomerAddressWarnings = validation.warnings;

        vm.selectedNewCustomerAddress = true;
        delete vm.formErr['customerAddressIsRequired'];
      }
    }

    function searchAddress(addressAsString) {
      var start = {
        latitude: parseFloat(Account.address.coords.latitude),
        longitude: parseFloat(Account.address.coords.longitude)
      };

      return geoCoder.getByAddressString(addressAsString).then(function (results) {
        results.forEach(function (result) {
          var end = {
            latitude: parseFloat(result.lat),
            longitude: parseFloat(result.lng)
          };

          result.kmDistance = haversine(start, end, 'km');
        });

        return _.sortBy(results, 'kmDistance');
      });
    }

    function getEmployeesWithTask() {
      var employeesWithTask = [];

      vm.tasks.forEach(function (task) {
        if (task.employee && task.employee.id !== null && task.employee.id !== 'null') {
          var taskEmployee = _.find(vm.employees, function (employee) {
            if (!employee || !employee.id) {
              return false;
            }

            return parseInt(employee.id) === parseInt(task.employee.id);
          });

          if (taskEmployee) {
            var employeeWithTask = _.find(employeesWithTask, function (employee) {
              return employee.id === taskEmployee.id;
            });

            if (!employeeWithTask) {
              employeesWithTask.push(taskEmployee);
            }
          }
        }
      });

      return employeesWithTask;
    }

    function useCustomerCoords() {
      if (vm.selectedCustomerLocation) {
        _setOrderCoords(vm.selectedCustomerLocation.address.coords);
        return;
      }

      _setOrderCoords(vm.selectedCustomer.address.coords);
    }

    function useEmployeeCoords(employee) {
      if (employee.address.coords) {
        _setOrderCoords(employee.address.coords);
      }
    }

    function _configureMap(options) {
      var location = { latitude: -23.552753, longitude: -46.632567 };

      if (options.location) {
        if (options.location.latitude) {
          location.latitude = options.location.latitude;
        }

        if (options.location.longitude) {
          location.longitude = options.location.longitude;
        }
      }

      location.latitude = normalizeCoord(
        location.latitude
      );

      location.longitude = normalizeCoord(
        location.longitude
      );

      var isValidLatitude = !isNaN(location.latitude) && location.latitude >= -90 && location.latitude <= 90;
      var isValidLongitude = !isNaN(location.longitude) && location.longitude >= -180 && location.longitude <= 180;

      if (!isValidLatitude) {
        location.latitude = null;
      }

      if (!isValidLongitude) {
        location.longitude = null;
      }

      vm.map = {
        center: {
          lat: parseFloat(location.latitude),
          lng: parseFloat(location.longitude),
          zoom: 16
        },
        controls: {
          fullscreen: {
            position: 'topleft'
          }
        },
        layers: {
          baselayers: {
            mapbox_standard: {
              name: $translate.instant('TASKS.DIALOG.TABS.LOCATION.MAP.LAYERS.STANDARD'),
              url: 'https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                'showOnSelector': true
              }
            },
            mapbox_satellite: {
              name: $translate.instant('TASKS.DIALOG.TABS.LOCATION.MAP.LAYERS.SATELLITE'),
              url: 'https://mt0.google.com/vt/lyrs=y&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                'showOnSelector': true
              }
            },
            mapbox_roadmap: {
              name: $translate.instant('TASKS.DIALOG.TABS.LOCATION.MAP.LAYERS.ROADMAP'),
              url: 'https://mt0.google.com/vt/lyrs=h&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                'showOnSelector': true
              }
            },
            mapbox_terrain: {
              name: $translate.instant('TASKS.DIALOG.TABS.LOCATION.MAP.LAYERS.TERRAIN'),
              url: 'https://mt0.google.com/vt/lyrs=p&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
              type: 'xyz',
              layerOptions: {
                'showOnSelector': true
              }
            }
          }
        }
      };

      leafletData.getMap('taskLocationMap').then(function (map) {
        var icon = L.divIcon({
          html: '<div>' + '    <i style="color:#273238;" class="icon icon-city s38"></i>' + '</div>',
          iconSize: [38, 38],
          iconAnchor: [16, 16],
        });

        vm.marker = new L.marker([parseFloat(location.latitude), parseFloat(location.longitude)], {
          draggable: true,
          message: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.CUSTOMER_LOCATION'),
          icon: icon,
        }).addTo(map);

        vm.marker.on('dragend', function (event) {
          var latLng = event.target.getLatLng();

          latLng.lat = normalizeCoord(
            latLng.lat
          );

          latLng.lng = normalizeCoord(
            latLng.lng
          );

          var isValidLatitude = !isNaN(latLng.lat) && latLng.lat >= -90 && latLng.lat <= 90;
          var isValidLongitude = !isNaN(latLng.lng) && latLng.lng >= -180 && latLng.lng <= 180;

          if (!isValidLatitude) {
            latLng.lat = null;
          }

          if (!isValidLongitude) {
            latLng.lng = null;
          }

          var args = {
            model: {
              lat: latLng.lat,
              lng: latLng.lng
            },
          };

          _setOrderCoords({
            latitude: args.model.lat,
            longitude: args.model.lng
          }).then(function (response) {
            if (!response) {
              return;
            }

            vm.setNewCustomerLocation = true;

            if ($scope.orderForm) {
              $scope.orderForm.$setDirty();
            }
          });
        });
      });
    }

    function _drawTerritories() {
      if (!vm.userTerritories || !vm.userTerritories.length) {
        return;
      }

      leafletData.getMap('taskLocationMap').then(function (map) {
        for (var i = 0; i < vm.userTerritories.length; i++) {
          var territory = vm.userTerritories[i];
          var type = territory.type;
          var radius = territory.radius;

          if (type === 'circle') {
            var coordinates = territory.geometry.coordinates[0];
            var geometry = [coordinates.lat, coordinates.lng];

            L.circle(geometry, {
              fill: false,
              stroke: '#0055ff',
              radius: radius,
            }).addTo(map);

            continue;
          }

          var coordinates = territory.geometry.coordinates.map(function (coord) {
            return [coord.lat, coord.lng];
          });

          L.polygon([coordinates], {
            fill: false,
            stroke: '#0055ff',
          }).addTo(map);
        }
      });
    }

    function mapCentralizeAt() {
      var latitude = vm.order.address.coords.latitude;
      var longitude = vm.order.address.coords.longitude;

      if (latitude && longitude) {
        var boundsItems = [];

        boundsItems.push([latitude, longitude]);
        var bounds = L.latLngBounds(boundsItems);

        leafletData.getMap('taskLocationMap').then(function (map) {
          vm.marker.setLatLng([latitude, longitude]);

          map.fitBounds(bounds);
        });

        vm.calculateDistanceFromCoords();
      }
    }

    function _setOrderCoords(coords) {
      return new Promise(function (resolve) {
        if (!coords) {
          vm.tasks.forEach(function (task) {
            task.coords = task.coords || {};
            task.coords.latitude = null;
            task.coords.longitude = null;
          });

          vm.order.address = vm.order.address || {};
          vm.order.address.coords = vm.order.address.coords || {};
          vm.order.address.coords.latitude = null;
          vm.order.address.coords.longitude = null;

          return resolve(false);
        }

        coords.latitude = normalizeCoord(
          coords.latitude
        );

        coords.longitude = normalizeCoord(
          coords.longitude
        );

        var isValidLatitude = !isNaN(coords.latitude) && coords.latitude >= -90 && coords.latitude <= 90;
        var isValidLongitude = !isNaN(coords.longitude) && coords.longitude >= -180 && coords.longitude <= 180;

        if (!isValidLatitude) {
          coords.latitude = null;
        }

        if (!isValidLongitude) {
          coords.longitude = null;
        }

        fetchTerritoriesByCoordinates({
          latitude: coords.latitude,
          longitude: coords.longitude,
        }).then(function (response) {
          if (!response) {
            mapCentralizeAt();
            return resolve();
          }

          if (coords.latitude === null || coords.latitude === undefined) { return; }

          var latitude = parseFloat(coords.latitude);
          var longitude = parseFloat(coords.longitude);

          vm.order.address = vm.order.address || {};
          vm.order.address.coords = vm.order.address.coords || {};
          vm.order.address.coords.latitude = latitude;
          vm.order.address.coords.longitude = longitude;

          vm.marker.setLatLng([latitude, longitude]);

          mapCentralizeAt();

          vm.tasks.forEach(function (task) {
            task.coords = task.coords || {};
            task.coords.latitude = latitude;
            task.coords.longitude = longitude;
          });

          resolve(true);
        });
      });
    }

    function fetchTerritoriesByCoordinates(coords) {
      return new Promise(function (resolve) {
        if (!vm.hasFeatureFlag('territories')) {
          return resolve(true);
        }

        territoriesApi.territoriesByCoordinates(coords).then(function (territories) {
          _validateUserTerritory(territories).then(function (response) {
            if (!response) {
              return resolve(false);
            }

            return _verifyIfEmployeeBelongsToTerritory(territories).then(function () {
              resolve(true);
            });
          });
        });
      });
    }

    function _validateUserTerritory(territories) {
      return new Promise(function (resolve) {
        var territory = territories.find(function (territory) {
          return !territory.parentTerritory;
        });

        if (!vm.userTerritories || !vm.userTerritories.length) {
          return resolve(true);
        }

        var filteredUserTerritories = vm.userTerritories.filter(function (userTerritory) {
          return userTerritory.id === (territory && territory.id);
        });

        if (!filteredUserTerritories || !filteredUserTerritories.length) {
          showChangeAddressTerritoryModal().then(function (response) {
            resolve(response);
          });
        } else {
          resolve(true);
        }
      });
    }

    function showChangeAddressTerritoryModal() {
      return new Promise(function (resolve) {
        FcModalService.open(null, {
          title: 'Troca de endereço da localização',
          paddingSmall: true,
          content:
            'O novo endereço inserido nesta localização não está associado a nenhum território ao qual você pertença. Ao prosseguir, os grupos de usuários e colaboradores vinculados a este território perderão o acesso a esta localização. Se necessário, um administrador poderá vincular esta localização a um território novamente.<br><br>Tem certeza que deseja continuar?',
          leftButtonText: 'NÃO',
          rightButtonText: 'SIM',
          handleRightButton: function () {
            resolve(true);
          },
          handleLeftButton: function () {
            resolve(false);
          },
        });
      });
    }

    function getUserTerritories() {
      var userId = authenticatedUser.profile.id;

      usersApi.getTerritories(userId).then(function (territories) {
        vm.userTerritories = territories;

        _drawTerritories();
      });
    }

    function _verifyIfEmployeeBelongsToTerritory(territories) {
      return new Promise(function (resolve) {
        var tasksEmployeeIds = vm.tasks
          .filter(function (task) {
            return task.employee && task.employee.id;
          })
          .map(function (task) {
            return Number(task.employee.id);
          });

        if (!tasksEmployeeIds || !tasksEmployeeIds.length) {
          return resolve();
        }

        var territoryIds = _.map(territories, 'id');

        if (!territoryIds || !territoryIds.length) {
          employeesApi.searchWithTerritories({
            where: {
              ids: tasksEmployeeIds,
            },
            take: 10000
          }).then(function (result) {
            var employees = result.items;
            if (!employees || !employees.length) {
              return resolve();
            }

            var someEmployeeHasTerritory = employees.some(function (employee) {
              return employee.territories && employee.territories.length;
            });

            if (someEmployeeHasTerritory) {
              return handleEmployeesWithoutTerritory(tasksEmployeeIds).then(function () {
                resolve();
              });
            }

            return resolve();
          });

          return;
        }

        employeesApi.search({
          where: {
            territoryIds: territoryIds,
            ids: tasksEmployeeIds,
          },
          take: 10000
        }).then(function (result) {
          var employees = result.items;

          var employeesWithoutTerritory = tasksEmployeeIds.filter(function (employeeId) {
            return !employees.find(function (employee) {
              return employee.id === employeeId;
            });
          });

          return handleEmployeesWithoutTerritory(employeesWithoutTerritory).then(function () {
            resolve();
          });
        });
      });
    }

    function handleEmployeesWithoutTerritory(employeesWithoutTerritory) {
      return new Promise(function (resolve) {
        if (!employeesWithoutTerritory || !employeesWithoutTerritory.length) {
          return resolve();
        }

        showEmployeeWithoutLocationDialog().then(function () {
          for (var i = 0; i < vm.tasks.length; i++) {
            var task = vm.tasks[i];

            if (employeesWithoutTerritory.includes(Number(task.employee.id))) {
              task.employee.id = null;
            }
          }

          $scope.orderForm.$setDirty();
          return resolve();
        });
      });
    }

    /// Forms
    vm.selectedFormChanged = selectedFormChanged;
    vm.formEnqueueToBeDeleted = formEnqueueToBeDeleted;
    vm.filterForm = filterForm;
    vm.reloadFormAnswer = reloadFormAnswer;
    vm.answeredQuestion = answeredQuestion;
    vm.updateArchiveForm = updateArchiveForm;
    vm.showConfirmUpdateArchiveForm = false;
    vm.setMultipleFields = setMultipleFields;
    vm.goToTab = goToTab;

    window.addEventListener('formChanged', function (event) {
      if (event.detail && event.detail.error) {
        var field = event.detail.field;
        if (field) {
          vm.formErr[field] = event.detail.error;
        }
      } else {
        var field = event.detail.field;
        if (field && vm.formErr[field]) {
          delete vm.formErr[field];
        }
      }

      vm.isFormValid = Object.keys(vm.formErr).length === 0;
      $scope.$apply();
    });


    function updateArchiveForm(orderId, form) {
      if (!CheckEditPermission.hasPermission() && vm.order.id) {
        return;
      }
      $rootScope.loadingProgress = true;

      var formClone = angular.copy(form);
      formClone.archived = !form.archived;

      ordersApi.updateForm(orderId, formClone).then(function (updatedForm) {
        var message = $translate.instant('TASKS.TOASTS.FORMS.FORM_UPDATED.SUCCESS', {
          formName: updatedForm.name,
          action: $translate.instant('TASKS.TOASTS.FORMS.FORM_UPDATED.' + (updatedForm.archived ? 'ARCHIVED' : 'UNARCHIVED'))
        });

        $mdToast.show(
          $mdToast.simple()
            .textContent(message)
            .hideDelay(2000)
        );

        form.archived = !form.archived;
      }).catch(function () {
        MessageDialog.showToast({
          message: $translate.instant('TASKS.TOASTS.FORMS.FORM_UPDATED.FAILED', {
            action: $translate.instant('TASKS.TOASTS.FORMS.FORM_UPDATED.' + (form.archived ? 'UNARCHIVE' : 'ARCHIVE')),
            formName: form.name
          })
        });
      }).finally(function () {
        $rootScope.loadingProgress = false;
        vm.showConfirmUpdateArchiveForm = false;
      });
    }

    function selectedFormChanged(id) {
      if (!CheckEditPermission.hasPermission() && vm.order.id) {
        return;
      }
      if (vm.order.forms && vm.order.forms[vm.selectedFormIndex]) {
        vm.order.form = _.find(vm.order.forms, function (form) {
          return form.id === id;
        });
        vm.scoredQuestions = getScoredQuestions(vm.order.form);

        var hasOrderFormCreatedAt = vm.order.form && vm.order.form.metadata && vm.order.form.metadata.createdAt;
        if (!vm.order.forms[vm.selectedFormIndex].isNew && hasOrderFormCreatedAt) {
          vm.order.form._createdAt = LocalDateConvert.formatDate(vm.order.form.metadata.createdAt, 'date-time-seconds');
        }
      }
    }

    function formEnqueueToBeDeleted() {
      vm.order.deletingForms = vm.order.deletingForms || [];
      vm.order.deletingForms.push(angular.copy(vm.order.form));
      vm.order.forms = _.filter(vm.order.forms, function (currentForm) {
        return currentForm.id !== vm.order.form.id;
      });

      if (vm.order.forms.length) {
        vm.selectedFormIndex = 0;
        vm.order.form = vm.order.forms[vm.selectedFormIndex];
      } else {
        vm.selectedFormIndex = -1;
        vm.order.form = null;
      }

      if ($scope.orderForm) {
        $scope.orderForm.$setDirty();
      }

      vm.confirmBeforeDeleteForm = false;
    }

    function filterForm(form) {
      if (!vm.formSearchText || vm.formSearchText === '') {
        return true;
      }

      return angular.lowercase(form.name).indexOf(angular.lowercase(vm.formSearchText)) >= 0;
    }

    function reloadFormAnswer(formToReload) {
      if (!CheckEditPermission.hasPermission() && vm.order.id) {
        return;
      }
      $rootScope.loadingProgress = true;
      formsApiGraphQL.getFormsAnswer(formToReload.id)
        .then(function (response) {
          var formAnswer = response;
          vm.order.forms = vm.order.forms.map(function (form) {
            if (form.id === formToReload.id) {
              form = ordersFormsMapper.reloadedFormToView(formAnswer, form);
            }
            return form;
          });
          selectedFormChanged(formToReload.id);
        })
        .finally(function () { $rootScope.loadingProgress = false; });
    }

    function setMultipleFields() {
      var answers = [];

      vm.order.form.questions.forEach(function (question) {
        if (question.answer && question.type === "checkboxes") {
          question.answer = answers.join('&');
        }
      });

      answeredQuestion();
    }

    function goToTab(tabIndex) {
      vm.selectedTabIndex = tabIndex;
    }

    function answeredQuestion() {
      if (!CheckEditPermission.hasPermission() && vm.order.id) {
        return;
      }
      _verifyFormMultiplePictureQuestionValidity(null, null, true);
      if (vm.order && vm.order.forms) {
        vm.order.forms = ordersFormsMapper.toView(vm.order.forms);
        vm.scoredQuestions = getScoredQuestions(vm.order.form);
      }

      if (vm.order && vm.order.tasks && vm.order.tasks.length) {
        vm.order.tasks.forEach(function (task, index) {
          checkRequiredForms({
            status: task.status,
            taskIndex: index
          });
        });
      }
    }

    function getScoredQuestions(form) {
      if (form && form.questions.length) {
        var questions = form.questions.filter(function (question) {
          var isDropdownOrMultipleChoice = (question.type === 'dropdown' || question.type === 'multiple-choice');
          var allOptionsHaveScore = question.options.length && !_.every(question.options, function (option) { return option.score === null; });
          return isDropdownOrMultipleChoice && allOptionsHaveScore;
        });
        if (questions.length) {
          questions = questions
            .map(function (question) {
              var answeredOption = _.find(question.options, function (option) { return option.value === question.answer; });
              if (answeredOption) return { answer: question.answer, score: answeredOption.score };
            })
            .filter(function (question) { return question && question.answer && question.score !== undefined; });
          var scores = _.map(questions, 'score');
          return {
            list: questions,
            total: _.sum(scores)
          };
        }
      }
      return null;
    }

    vm.pictures = {};
    vm.picturesToUpload = { infos: [], uploadInfos: [] };
    vm.setPictureAnswer = setPictureAnswer;
    vm.multiplePictures = {};
    vm.hasMultiplePictureInvalidQuestion = false;
    vm.uploadPictureAndSetAsAnswer = uploadPictureAndSetAsAnswer;
    vm.deletePictureAnswer = deletePictureAnswer;
    vm.viewOriginalSize = viewOriginalSize;

    function viewOriginalSize(question) {
      $timeout(function () {
        $window.open(question.answer, '_blank');
      }, 500);
    }

    function deletePictureAnswer(question, questionIndex, isMultiplePicture, multiplePictureIndex) {
      var multiplePictureForm = vm.multiplePictures['form_' + vm.selectedFormIndex];
      var form = isMultiplePicture ? multiplePictureForm : vm.pictures['form_' + vm.selectedFormIndex];
      var formQuestion = form && form['question_' + questionIndex];

      if (isMultiplePicture) {
        if (multiplePictureForm && multiplePictureForm['question_' + questionIndex]) {
          multiplePictureForm['question_' + questionIndex] = {};
        }
        question.answer.splice(multiplePictureIndex, 1);
        var hasQuestionAnswer = _hasMutiplePictureQuestionAnswer(question);
        _deleteFormMultiplePictureQuestion(formQuestion, multiplePictureIndex);
        _verifyFormMultiplePictureQuestionValidity(question, hasQuestionAnswer, null);
        $scope.orderForm.$setDirty();
      } else {
        question['open-delete-' + questionIndex] = '';
        question.answer = null;

        if (formQuestion) {
          vm.pictures['form_' + vm.selectedFormIndex]['question_' + questionIndex] = null;
        }
      }
    }

    function setPictureAnswer(picture, question, questionIndex) {
      if (picture) {
        var imagePreview = Object.assign(picture, { preview: URL.createObjectURL(picture) });
        question.type = 'picture';
        question.answer = imagePreview.preview;

        var filePath = '/orders/' + vm.order.id + '/forms/' +
          vm.order.form.id + '/' + picture.name.replace(/%20| /g, '');
        var pictureToUpload = {
          infos: {
            question: question,
            selectedFormIndex: vm.selectedFormIndex,
            questionIndex: questionIndex
          },
          uploadInfos: { file: picture, filePath: filePath }
        };
        vm.picturesToUpload.infos.push(pictureToUpload.infos);
        vm.picturesToUpload.uploadInfos.push(pictureToUpload.uploadInfos);
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent($translate.instant('TASKS.TOASTS.FORMS.INCOMPATIBLE_FILE'))
            .hideDelay(3000)
            .theme('error-toast')
        );
      }
    }

    function uploadPictureAndSetAsAnswer(picture, question, questionIndex, isMultiplePicture, multiplePictureIndex) {
      if (picture) {
        $timeout(function () {
          vm.uploadProgress = true;
          question.uploadProgress = true;
        }, 200);

        var filePath = '/orders/' + vm.order.id + '/forms/' + vm.order.form.id + '/' + picture.name.replace(/%20| /g, '');
        uploadApi.uploadWithPreSignedPost({
          file: picture,
          filePath: filePath
        }).then(function (result) {
          var correctAttachmentPath = attachmentsUtils.correctUrl(result.path);

          if (isMultiplePicture) {
            question.type = 'multiple-picture';
            question.answer = question.answer && question.answer.length ? question.answer : [];
            _addMultiplePictureAnswer(multiplePictureIndex, question, correctAttachmentPath);
            var hasQuestionAnswer = _hasMutiplePictureQuestionAnswer(question);
            _verifyFormMultiplePictureQuestionValidity(question, hasQuestionAnswer, null);
          } else {
            question.type = 'picture';
            question.answer = correctAttachmentPath;
          }
        }).catch(function () {
          if (isMultiplePicture) {
            var form = vm.multiplePictures['form_' + vm.selectedFormIndex];
            var formQuestion = form && form['question_' + questionIndex];
            _deleteFormMultiplePictureQuestion(formQuestion, multiplePictureIndex);
          } else {
            vm.pictures['form_' + vm.selectedFormIndex]['question_' + questionIndex] = null;
          }
        }).finally(function () {
          _setPictureQuestionsLoading(false);
          vm.uploadProgress = false;
          $scope.orderForm.$setDirty();
        });
      }
    }

    function _setPictureQuestionsLoading(isLoading) {
      vm.picturesToUpload.infos.forEach(function (uploadInfo) {
        uploadInfo.question.uploadProgress = isLoading;
      });
    }

    function _addMultiplePictureAnswer(multiplePictureIndex, question, correctAttachmentPath) {
      question.answer[multiplePictureIndex] = correctAttachmentPath;
    }

    function checkToResetReceivedAtViewedAt(untouchedTask, task) {
      var reset = false;

      if (!untouchedTask.employee) {
        untouchedTask.employee = { id: null };
      }

      if (!task.employee) {
        task.employee = { id: null };
      }

      if (untouchedTask.employee.id !== task.employee.id) { reset = true; }
      if (untouchedTask.status !== task.status) { reset = true; }
      if (untouchedTask.scheduling.date !== task.scheduling.date) { reset = true; }
      if (untouchedTask.scheduling.time !== task.scheduling.time) { reset = true; }
      if (untouchedTask.description !== task.description) { reset = true; }

      return reset;
    }

    vm.saveQuestionSignature = saveQuestionSignature;
    function saveQuestionSignature(signature, question) {
      $timeout(function () {
        question.uploadProgress = true;
      }, 200);

      if (signature.dataUrl) {
        $scope.orderForm.$dirty = true;
        uploadApi.uploadWithPassthrough({
          filename: '/orders/' + vm.order.id + '/forms/' + vm.order.form.id + '/signature-' + msUtils.uuidGenerator() + '.png',
          imageBase64Encoded: signature.dataUrl
        }).then(function (response) {
          question.answer = attachmentsUtils.correctUrl(response.data.key);
        }).finally(function () {
          $timeout(function () {
            question.uploadProgress = false;
            question.showPad = false;
            $timeout(function () { if ($scope.orderForm) { $scope.orderForm.$setDirty(); } }, 1000);
          }, 200);
        });
      }
    }

    vm.clearQuestionSignature = clearQuestionSignature;
    function clearQuestionSignature(question, clearAnswer) {
      question.showPad = false;
      if (clearAnswer) {
        question.answer = null;
        $timeout(function () { if ($scope.orderForm) { $scope.orderForm.$setDirty(); } }, 1000);
      }
    }

    function _deleteFormMultiplePictureQuestion(formQuestion, multiplePictureIndex) {
      if (formQuestion && formQuestion[multiplePictureIndex]) {
        delete formQuestion[multiplePictureIndex];
      }
    }

    function _hasMutiplePictureQuestionAnswer(question) {
      return question.answer && question.answer.length;
    }

    function _verifyFormMultiplePictureQuestionValidity(question, hasQuestionAnswer, ariaChecker) {
      if (question) { vm.question = question; }
      if (hasQuestionAnswer) { vm.hasQuestionAnswer = hasQuestionAnswer; }

      ariaChecker = !ariaChecker;

      var isNotSelected = true;

      if (vm.order.forms.length) {
        var form = vm.order.forms.filter(function (form) {
          return form.questions.filter(function (qt) {
            return qt.id === vm.question.id;
          });
        });
        vm.checkQuestions = form[0].questions;
      }

      if (vm.question.conditions || vm.checkQuestions.length) {
        vm.question.conditions = vm.question.conditions || [];
        vm.question.conditions.forEach(function (condition) {
          if (condition) {
            var element = document.getElementById(condition.value);
            var ariaChecked = element ? element.ariaChecked : false;
            var checked = false;

            if (ariaChecked === 'true') {
              checked = true;
            } else {
              checked = false;
            }

            if (!condition.operator === 'equal') {
              checked = !checked;
            }

            if (ariaChecker) {
              checked = false;
            }

            isNotSelected = !checked;
          }
        });
      }

      var isMultiplePictureQuestionValid = (vm.question.required && vm.hasQuestionAnswer) || !vm.question.required;
      vm.hasMultiplePictureInvalidQuestion = isNotSelected ? !isNotSelected : !isMultiplePictureQuestionValid;
    }

    /**
     * EQUIPAMENTOS
     **/
    vm.searchEquipments = searchEquipments;
    vm.navigateToPage = navigateToPage;
    vm.toggleEquipmentsForms = toggleEquipmentsForms;
    vm.toggleSearchEquipmentsForms = toggleSearchEquipmentsForms;
    vm.editEquipment = editEquipment;
    vm.selectedEquipment = null;
    vm.searchEquipmentText = '';
    vm.selectedEquipments = [];
    vm.equipmentOptions = [];
    vm.showingEquipments = [];
    vm.equipmentsPaginateBy = 10;
    vm.equipmentsPage = 1;

    var toggleSearchEquipmentsFormsListenerFn = function (data) {
      vm.toggleSearchEquipmentsForms(data.detail);
    };

    var toggleEquipmentsFormsListenerFn = function (data) {
      vm.toggleEquipmentsForms(data.detail);
    };

    var editEquipmentListenerFn = function (data) {
      vm.editEquipment(null, data.detail);
    };


    var formUpdatedListenerFn = function (params) {
      vm.order.forms = _.cloneDeep(params.detail.forms);
      vm.order.tasks.forEach(function (task, index) {
        checkRequiredForms({
          status: task.status,
          taskIndex: index
        });
      });

      $scope.orderForm.$pristine = false;
      $scope.$apply();
    };

    var refreshAnsweredCountListenerFn = function () {
      if (vm.order && vm.order.forms && vm.order.forms.length) {
        vm.order.forms = [];
        vm.order.form = null;
      }

      _getForms();
      $scope.orderForm.$pristine = false;
      $scope.$apply();
    };

    document.addEventListener('forms-updated', formUpdatedListenerFn);
    document.addEventListener('refresh-answered-count', refreshAnsweredCountListenerFn);
    document.addEventListener('equipment:toggleSearchEquipmentsForms', toggleSearchEquipmentsFormsListenerFn);
    document.addEventListener('equipment:toggleEquipmentsForms', toggleEquipmentsFormsListenerFn);
    document.addEventListener('equipment:editEquipment', editEquipmentListenerFn);
    document.addEventListener('equipment:reload-equipment', searchEquipments.bind(this));

    document.addEventListener('order-dialog:close', function () {
      document.removeEventListener('equipment:toggleSearchEquipmentsForms', toggleSearchEquipmentsFormsListenerFn);
      document.removeEventListener('equipment:toggleEquipmentsForms', toggleEquipmentsFormsListenerFn);
      document.removeEventListener('equipment:editEquipment', editEquipmentListenerFn);
      document.removeEventListener('equipment:reload-equipment', searchEquipments.bind(this));
      document.removeEventListener('forms-updated', formUpdatedListenerFn);
      document.removeEventListener('refresh-answered-count', refreshAnsweredCountListenerFn);
    });

    $timeout(function () {
      var goToLinksClick = document.querySelector('.go-to-links');

      if (goToLinksClick) {
        goToLinksClick.addEventListener('click', function () {
          vm.goToTab(4);
          $scope.$apply();
        });
      }
    }, 1500);

    function editEquipment(ev, id) {
      EquipmentsDialog.editEquipments(ev, id, null, function (reload) {
        if (reload) {
          $timeout(function () {
            searchEquipments();

            document.dispatchEvent(new CustomEvent('reloadEquipmentsEvent'));
          }, 2000);
        }
      });
    }

    function searchEquipments() {
      vm.equipmentOptions = _.filter(vm.selectedEquipments, function (equipment) {
        return equipment.name.includes(vm.searchEquipmentText) ||
          equipment.number.includes(vm.searchEquipmentText);
      });

      navigateToPage(1);
    }

    function selectedEquipmentItemChange(selectedEquipment) {
      if (selectedEquipment) {
        if (selectedEquipment.attachments && selectedEquipment.attachments.length) {
          selectedEquipment.thumbnail = attachmentsUtils.correctUrl(selectedEquipment.imageUrl);
        }

        if (vm.selectedEquipments && vm.selectedEquipments.length) {
          var hasEquipmentAdded = _.find(vm.selectedEquipments, function (equip) {
            return equip.id === selectedEquipment.id;
          });

          if (hasEquipmentAdded) {
            vm.searchEquipmentText = '';
            return;
          }
        }

        vm.selectedEquipments.push(selectedEquipment);
        vm.searchEquipmentText = '';
        vm.selectedEquipment = null;

        if (vm.order.id) {
          _getEquipmentsForms();
        }
      }
    }

    function toggleEquipmentsForms(equipment) {
      $mdDialog.show({
        controller: 'SearchAnsweredEquipmentsFormsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/tasks/dialogs/search-answered-equipments-forms/search-answered-equipments-forms.html',
        parent: angular.element($document.body),
        targetEvent: null,
        clickOutsideToClose: true,
        multiple: true,
        locals: {
          equipment: equipment,
          order: vm.order,
          account: vm.account,
          featureFlags: vm.featureFlags,
          hasFeatureFlag: hasFeatureFlag
        }
      });
    }

    function toggleSearchEquipmentsForms(equipment) {
      if (!CheckEditPermission.hasPermission() && vm.order.id) {
        return;
      }
      $mdDialog.show({
        controller: 'SearchEquipmentsFormsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/tasks/dialogs/search-equipments-forms/search-equipments-forms.html',
        parent: angular.element($document.body),
        targetEvent: null,
        clickOutsideToClose: true,
        multiple: true,
        locals: {
          equipment: equipment,
          order: vm.order,
          account: vm.account,
          getEquipmentsFromOrder: _getEquipmentsFromOrder,
          searchEquipments: searchEquipments,
          featureFlags: vm.featureFlags,
          hasFeatureFlag: hasFeatureFlag
        }
      });
    }

    function navigateToPage(pageNumber) {
      vm.equipmentsPage = pageNumber;
      vm.showingEquipments = vm.equipmentOptions.slice(
        (vm.equipmentsPage - 1) * vm.equipmentsPaginateBy,
        vm.equipmentsPage * vm.equipmentsPaginateBy
      );
    }

    function _getEquipmentsFromOrder() {
      _verifyCustomerEquipments();

      equipmentsApiGraphQL.getEquipamentsByOrderId(vm.order.id)
        .then(function (equipments) {
          if (equipments.length) {
            vm.selectedEquipments = _.map(equipments, function (equip) {
              equip.isLinked = true;
              equip.thumbnail = attachmentsUtils.correctUrl(equip.imageUrl);
              return equip;
            });
            _getEquipmentsForms();
            searchEquipments();
          }
        });
    }

    function _getEquipmentsForms() {
      var equipments = angular.copy(vm.selectedEquipments);

      _.forEach(equipments, function (equip, index) {
        ordersApi.getEquipmentForms(vm.order.id, equip.id).then(function (forms) {
          vm.selectedEquipments[index].forms = ordersFormsMapper.toView(forms);

          var equipmentType = _.find(vm.equipmentTypes, function (type) {
            return type.id === equip.type.id;
          });

          if (equipmentType) {
            equip.type = {
              id: equipmentType.id,
              name: equipmentType.name
            };
          }

          if (vm.selectedEquipments[index].forms.length) {
            _.forEach(vm.selectedEquipments[index].forms, function (form) {
              form.equipment.name = equip.name + ' - ' + equip.number;
              form.equipment.type = equip.type;
              form.equipment.number = equip.number;
              form.untouchedFormHash = hasher.sha1ButIgnoreNGHashKey(form);


              _pushEquipmentsForms(form);
            });

            if (!vm.order.form) {
              vm.selectedFormIndex = 0;
              vm.order.form = vm.order.forms[vm.selectedFormIndex];
            }
          }
        });
      });
    }

    function _pushEquipmentsForms(selectedEquipmentForm) {
      var orderForms = vm.order.forms;

      var equipmentFormToShow = orderForms.findIndex(function (form) {
        return form.id === selectedEquipmentForm.id;
      });

      if (equipmentFormToShow < 0) {
        orderForms.push(selectedEquipmentForm);
      }
    }

    function _verifyCustomerEquipments() {
      vm.selectedCustomer.hasEquipment = false;

      equipmentsApi.search({
        where: {
          customerIds: vm.selectedCustomer && vm.selectedCustomer.id ? [vm.selectedCustomer.id] : null,
          locationIds: [vm.order.location ? vm.order.location.id : null]
        },
        take: 1
      }).then(function (response) {
        vm.selectedCustomer.hasEquipment = response.totalCount ? true : false;
      }).catch(function () {
        vm.selectedCustomer.hasEquipment = false;
      });
    }

    function reloadOrderLinksEvent() {
      var event = new CustomEvent('reloadOrderLinks');

      document.dispatchEvent(event);
    }

    vm.disableEditTaskStartedAt = disableEditTaskStartedAt;
    function disableEditTaskStartedAt(task, index) {
      var hasInvalidStatus = ['pending', 'scheduled', 'on-route'].includes(task.status);

      if (task.status === 'canceled' && (!task.oldStartedAtDate || !task.oldStartedAtTime) && taskStartedAtIsRequired(task, index)) {
        return false;
      }

      return vm.featureDisableEditTaskStartedAt || hasInvalidStatus;
    }

    vm.disableEditTaskCompletedAt = disableEditTaskCompletedAt;
    function disableEditTaskCompletedAt(task, index) {
      var hasInvalidStatus = ['pending', 'scheduled', 'in-progress', 'on-route'].includes(task.status);

      if (task.status === 'canceled' && (!task.oldCompletedAtDate || !task.oldCompletedAtTime) && taskCompletedAtIsRequired(task, index)) {
        return false;
      }

      return vm.featureDisableEditTaskCompletedAt || hasInvalidStatus;
    }

    vm.deadlineContracts = angular.copy(DeadlineContracts);
    vm.deadlineContractSearchTerm = '';
    vm.clearDeadlineContractSearchTerm = clearDeadlineContractSearchTerm;
    vm.searchDeadlineContracts = _.debounce(searchDeadlineContracts, 200);

    function searchDeadlineContracts() {
      var searchTerms = {
        'name~~*': '%' + vm.deadlineContractSearchTerm + '%',
        'archived': false
      };

      var requestOptions = {
        limit: 100
      };

      deadlineContractsApi.search(searchTerms, requestOptions)
        .then(function (deadlineContractsResponse) {
          vm.deadlineContracts = deadlineContractsResponse.items;
        });
    }

    function _saveOrderProducts() {
      var productsToUpdate = orderProductsService.getProductsToUpdate();

      if (productsToUpdate && productsToUpdate.length) {
        _updateOrderProducts(productsToUpdate);
      }
    }

    function _updateOrderProducts(products) {
      var items = [];
      products.forEach(function (product) {
        items.push({
          productId: product.item.id,
          orderId: vm.order.id,
          quantity: product.quantity,
          value: product.value
        });
      });
      ordersApi.updateOrderProductQuantity(items);
    }

    function _saveOrderServices() {
      var servicesToUpdate = orderServicesService.getServicesToUpdate();

      if (servicesToUpdate && servicesToUpdate.length) {
        _updateOrderServices(servicesToUpdate);
      }
    }

    function _updateOrderServices(services) {
      var items = [];
      services.forEach(function (service) {
        items.push({
          serviceId: service.item.id,
          orderId: vm.order.id,
          quantity: service.quantity,
          value: service.value
        });
      });
      ordersApi.updateOrderServiceQuantity(items);
    }

    function _saveOrderLinks() {
      var hasOrderLinks = vm.hasOrderLinks();

      var orderLinks = orderLinksService.getOrderLinks();

      if (!hasOrderLinks) {
        return;
      }

      _saveOrderLocationSectors(orderLinks.orderLocationSectors)
        .then(function () {
          _saveOrderLocationEnvironment(orderLinks.orderLocationEnvironments)
            .then(function () {
              _saveOrderEquipments(orderLinks.orderEquipments)
                .then(function () {
                  orderLinksService.clearOrderLinks();
                });
            });
        });
    }

    function _saveOrderLocationSectors(orderLocationSectors) {
      if (!orderLocationSectors || !orderLocationSectors.length) {
        return Promise.resolve();
      }

      var orderLocationSectorsRequests = orderLocationSectors.map(function (orderLocationSector) {
        return orderLocationSectorApi.save({
          locationSectorId: orderLocationSector.id,
          orderId: vm.order.id
        });
      });

      return Promise.all(orderLocationSectorsRequests);
    }

    function _saveOrderLocationEnvironment(orderLocationEnvironments) {
      if (!orderLocationEnvironments || !orderLocationEnvironments.length) {
        return Promise.resolve();
      }

      var orderLocationEnvironmentsRequests = orderLocationEnvironments.map(function (orderLocationEnvironment) {
        return orderLocationEnvironmentApi.save({
          locationEnvironmentId: orderLocationEnvironment.id,
          orderId: vm.order.id
        });
      });

      return Promise.all(orderLocationEnvironmentsRequests);
    }

    function _saveOrderEquipments(orderEquipments) {
      if (!orderEquipments || !orderEquipments.length) {
        return Promise.resolve();
      }

      var orderEquipmentsRequests = orderEquipments.map(function (orderEquipment) {
        return orderEquipmentApi.save({
          equipmentId: orderEquipment.id,
          orderId: vm.order.id
        });
      });

      return Promise.all(orderEquipmentsRequests);
    }

    function clearDeadlineContractSearchTerm() {
      vm.deadlineContractSearchTerm = '';
    }

    function tabClicked(tabName) {
      if (tabName == 'forms') {
        if (vm.order && vm.order.forms && vm.order.forms.length) {
          vm.order.forms = [];
          vm.order.form = null;
        }

        _getForms();
      }

      if (tabName == 'general') {
        vm.tasks.forEach(function (task, index) {
          vm.changedTaskStatus(task, index);
        });
      }

      vm.lastTrackedTab = tabName;
    }

    vm.handleOnChangeDeadlineContract = function (deadlineContractId) {
      vm.deadlineContractId = deadlineContractId;
    };

    vm.formatPhoneOrCellphone = function (phone) {
      var phoneClean = phone.replace(/\D/g, '');
      if (phoneClean.length === 11) {
        return phoneClean.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else if (phoneClean.length === 10) {
        return phoneClean.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      } else {
        return phone;
      }
    };

    vm.clearArray = function () {
      vm.order.customer.allLocationsContacts.emails.forEach(function (email) {
        email.checked = false;
      });
      vm.order.customer.contacts.emails.forEach(function (email) {
        email.checked = false;
      });
      vm.selectedCustomerEmails = [];
    };

    function reloadEquipmentsForms() {
      var event = new CustomEvent('reloadOrderEquipments');

      document.dispatchEvent(event);
    }

    _initializeDialog();

    $timeout(function () {
      vm.initialized = true;
    }, 1000);
  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings')
    .factory('autocompleteAddressService', autocompleteAddressService);

  /** @ngInject */
  function autocompleteAddressService(geoCoder, $timeout, $translate) {
    var model = null;
    var hasAccountAddressValue = false;

    function setModel(modelAddress) {
      model = modelAddress;
    }

    function hasAccountAddress() {
      return hasAccountAddressValue;
    }

    function setHasAccountAddress(bool) {
      hasAccountAddressValue = bool;
    }

    function validateAddress(formErr) {
      var accountAddressIsSelected = model.formattedAddress;

      if (!accountAddressIsSelected) {
        formErr['accountAddressIsRequired'] = $translate.instant("CONFIGURATIONS.SERVICES.ENTER_ADDRESS") + ' <i class="md-accent-fg icon icon-arrow-up-bold s14"></i>';
        return false;
      } else {
        delete formErr['accountAddressIsRequired'];
        return true;
      }
    }

    function selectedAddressItemChange(selectedAddress, form, formErr) {
      if (selectedAddress) {
        $timeout(function () {
          if (form) {
            form.$setDirty();
          }
        }, 1000);

        model['zipCode'] = selectedAddress.zipCode || null;
        model['city'] = selectedAddress.city || null;
        model['state'] = selectedAddress.state || null;
        model['neighborhood'] = selectedAddress.neighborhood || null;
        model['street'] = selectedAddress.street || null;
        model['number'] = selectedAddress.number || null;
        model['coords'] = {
          latitude: selectedAddress.lat,
          longitude: selectedAddress.lng
        };
        model['formattedAddress'] = selectedAddress.formattedAddress;

        delete formErr['accountAddressIsRequired'];
      }
    }

    function searchAddress(addressAsString, country) {
      return geoCoder.getByAddressString(addressAsString, country).then(function (results) {
        return results;
      });
    }

    return {
      setModel: setModel,
      hasAccountAddress: hasAccountAddress,
      searchAddress: searchAddress,
      selectedAddressItemChange: selectedAddressItemChange,
      setHasAccountAddress: setHasAccountAddress,
      validateAddress: validateAddress
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.services').factory('ServiceDialog', ServiceDialog);

  /** @ngInject */
  function ServiceDialog($mdDialog, $rootScope, servicesApi, $document, $q, accountFeatureFlagsApiGraphQL) {

    return {
      createService: createService,
      editService: editService
    };

    function createService(ev, callback) {
      _loaderOn();

      var requests = {
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags()
      };

      $q.all(requests).then(function (result) {
        _openDialog(ev, {
          Service: null,
          FeatureFlags: result.featureFlags,
        }, callback);
      }).finally(_loaderOff);
    }

    function editService(ev, id, callback) {
      _loaderOn();

      var requests = {
        service: servicesApi.getOne(id, { include: 'form,forms,orderReportTemplate' }),
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags()
      };

      $q.all(requests).then(function (result) {
        _openDialog(ev, {
          Service: result.service,
          FeatureFlags: result.featureFlags,
        }, callback);
      }).finally(_loaderOff);
    }

    function _openDialog(ev, locals, callback) {
      $mdDialog.show({
        controller: 'ServiceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/services/dialogs/service-dialog.html',
        parent: document.querySelector('.palantir-modal-container') || angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }

    function _loaderOn() {
      $rootScope.loadingProgress = true;
    }

    function _loaderOff() {
      $rootScope.loadingProgress = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .controller('ServiceDialogController', ServiceDialogController);

  /** @ngInject */
  function ServiceDialogController(
    $scope, $mdDialog, Service, $mdToast, focus, equipmentsApiGraphQL, $timeout,
    $rootScope, templatesApi, servicesApi, employeesApi, $q, $translate, _,
    formsApi, FeatureFlags
  ) {
    var vm = this;
    vm.service = angular.copy(Service);
    vm.allForms = [];
    vm.forms = [];
    vm.newService = false;
    vm.hasAutoSmartRewriteFeatureFlag = false;
    vm.hasSmartOrderSummaryFeatureFlag = false;
    vm.ratingForm = null;
    vm.templates = [];
    vm.featureFlags = FeatureFlags || [];
    $scope.employeeSkills = [];

    vm.closeDialog = closeDialog;
    vm.editService = editService;
    vm.updateService = updateService;
    vm.createService = createService;
    vm.archiveService = archiveService;
    vm.unarchiveService = unarchiveService;
    vm.toggleAllEmployees = toggleAllEmployees;
    vm.addForm = addForm;
    vm.searchForm = searchForm;
    vm.deleteForm = deleteForm;
    vm.validateDescription = validateDescription;
    vm.changeRatingForm = changeRatingForm;
    vm.changeShowRatingForm = changeShowRatingForm;
    vm.linkOrderReportTemplate = linkOrderReportTemplate;
    vm.unlinkOrderReportTemplate = unlinkOrderReportTemplate;
    vm.hasFeatureFlag = hasFeatureFlag;
    vm.toggleAutoSmartRewriteFields = toggleAutoSmartRewriteFields;
    vm.toggleSmartSummaryPostWorkFields = toggleSmartSummaryPostWorkFields;

    $scope.toggle = toggle;
    $scope.exists = exists;

    _initialize();

    function _initialize() {
      vm.hasAutoSmartRewriteFeatureFlag = vm.hasFeatureFlag('auto-smart-rewrite-beta-flag');
      vm.hasSmartOrderSummaryFeatureFlag = vm.hasFeatureFlag('smart-order-summary-beta-flag');

      if (!vm.service) {
        vm.service = {
          description: '',
          duration: 15,
          archived: false,
          forms: [],
          allowAllForms: false,
          signatureRequired: false,
          quotationRequired: false,
          configurations: {
            notifications: {
              sendEmailEmployeeRouteTrackingLinkWhenOnRoute: false,
              sendEmailEmployeeOrderReportWhenCompleted: false,
              sendEmailOrderReportLinkWhenCompleted: false,
              sendEmailTaskRatingLinkWhenCompleted: false,
            },
            mobile: {
              startNCompleteTaskValidationRadiusOn: false,
              startNCompleteTaskValidationRadiusMeters: 300,
              autoSmartRewriteEnabled: false,
              autoSmartRewriteFields: ['statusDescription', 'forms'],
            },
            smartSummary: {
              preWork: {
                enabled: false
              },
              postWork: {
                enabled: false,
                displayOn: []
              }
            }
          },
          ratingForm: {
            id: null
          }
        };

        vm.newService = true;
      } else {
        vm.service.showRatingForm = !!vm.service.ratingForm.id;
        if (vm.service.forms && vm.service.forms.length) {
          vm.service.forms = _.sortBy(vm.service.forms, 'name');
        }
      }

      _loadData();
      _updateFormSelect();
      focus('description');
    }

    function deleteForm(id) {
      vm.service.forms = _.filter(vm.service.forms, function (form) {
        return form.id !== id;
      });

      _updateFormSelect();

      if ($scope.serviceForm) {
        $scope.serviceForm.description.$setDirty();
      }
    }

    function addForm(id) {
      var currentForm = _.find(vm.forms, function (form) {
        return form.id === id;
      });

      if (currentForm) {
        currentForm.required = false;
        vm.service.forms = vm.service.forms || [];
        vm.service.forms.push(currentForm);
        vm.service.forms = _.uniq(vm.service.forms, 'id');
      }

      _updateFormSelect();

      if ($scope.serviceForm) {
        $scope.serviceForm.description.$setDirty();
      }
    }

    function searchForm() {
      var options = { limit: 1000, offset: 0 };
      var query = { archived: 'no' };
      if (vm.formSearchTerm) {
        query['name~~*'] = '*' + vm.formSearchTerm + '*';
      }

      formsApi.search(query, options)
        .then(function (forms) {
          var currentFormsIds = vm.service.forms.map(function (form) { return form.id; });
          var unarchivedForms = forms.items.filter(function (form) { return !form.archived; });
          var activatedForms = unarchivedForms.filter(function (form) { return !currentFormsIds.includes(form.id); });
          vm.forms = activatedForms;
          vm.allForms = activatedForms;

          vm.formSelectOptions = _.map(unarchivedForms, function (form) {
            return {
              value: {
                id: form.id,
                name: form.name
              }
            };
          });
        });
    }

    function toggleAllEmployees() {
      if (!vm.selectAll) {
        $scope.employeeSkills = _.map(vm.employees, 'id');
        vm.selectAll = true;
      } else {
        $scope.employeeSkills = [];
        vm.selectAll = false;
      }

      if ($scope.serviceForm) {
        $scope.serviceForm.description.$setDirty();
      }
    }

    function editService() {
      $rootScope.loadingProgress = true;

      var input = {
        id: vm.service.id,
        description: vm.service.description,
        duration: vm.service.duration,
        configurations: vm.service.configurations,
        employeeIds: $scope.employeeSkills,
        allowAllForms: vm.service.allowAllForms,
        archived: vm.service.archived,
        ratingFormId: vm.service.ratingForm.id,
        signatureRequired: vm.service.signatureRequired,
        quotationRequired: vm.service.quotationRequired,
        slaTimeLimit: parseInt(vm.service.slaTimeLimit),
        orderReportTemplateId: vm.service.orderReportTemplate ? vm.service.orderReportTemplate.id : null,
        forms: _.map(vm.service.forms, function (form) {
          return {
            formId: form.id,
            required: {
              complete: form.required && form.required.complete || false,
              report: form.required && form.required.report || false,
              start: form.required && form.required.start || false,
            }
          };
        })
      };

      if (!input.configurations.mobile.startNCompleteTaskValidationRadiusOn) {
        delete input.configurations.mobile.startNCompleteTaskValidationRadiusMeters;
      }

      if (vm.service.locked) {
        input = {
          id: vm.service.id,
          duration: vm.service.duration,
          employeeIds: $scope.employeeSkills,
          orderReportTemplateId: vm.service.orderReportTemplate ? vm.service.orderReportTemplate.id : null
        };
      }

      delete vm.service.configurations.showRatingForm;
      vm.service.slaTimeLimit = parseInt(vm.service.slaTimeLimit);

      vm.updateService(input);
      $rootScope.loadingProgress = false;
    }

    function updateService(input) {
      return servicesApi.updateService(input).then(function (response) {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('SERVICES.TOAST.SAVED', { service: vm.service.description }))
            .hideDelay(3000)
        );

        $rootScope.loadingProgress = false;
        closeDialog(true);

      }).catch(function (result) {
        if (result.data.err) {
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .title($translate.instant('SERVICES.DIALOG.ALERT.TITLE'))
              .ok($translate.instant('SERVICES.DIALOG.ALERT.OK'))
              .textContent(result.data.message)
          );
        }

      });
    }

    function createService() {
      servicesApi.save(vm.service).then(function (savedService) {
        servicesApi.clearEmployees(savedService.id).then(function () {
          var skills = _.map($scope.employeeSkills, function (employeeId) {
            return { employee: { id: employeeId } };
          });

          servicesApi.addSkills(savedService.id, skills).then(function () {
            var serviceForms = _.map(vm.service.forms, function (form) {
              return { id: form.id, required: form.required };
            });

            servicesApi.setForms(savedService.id, serviceForms).then(function () {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($translate.instant('SERVICES.TOAST.SAVED', { service: vm.service.description }))
                  .hideDelay(3000)
              );

              $rootScope.loadingProgress = false;
              closeDialog(true);
            });
          });

        });
      }).catch(function (result) {
        if (result.data.err) {
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .title($translate.instant('SERVICES.DIALOG.ALERT.TITLE'))
              .ok($translate.instant('SERVICES.DIALOG.ALERT.OK'))
              .textContent(result.data.message)
          );
        }

        $rootScope.loadingProgress = false;
      });
    }

    function unarchiveService() {
      vm.service.archived = false;

      updateService({
        id: vm.service.id,
        archived: false
      });
    }

    function archiveService(event) {
      vm.service.archived = true;
      var items = [];

      equipmentsApiGraphQL.getEquipmentTypesForms(vm.service.id).then(function (equipmentTypes) {
        equipmentTypes.items = _.filter(equipmentTypes.items, function (equipmentType) {
          if (!equipmentType.forms || !equipmentType.forms.length) {
            return false;
          }

          equipmentType.forms = _.filter(equipmentType.forms, function (form) {
            return form.service && form.service.id === vm.service.id;
          });

          return equipmentType.forms.length > 0;
        });

        if (equipmentTypes.items && equipmentTypes.items.length) {
          _.forEach(equipmentTypes.items, function (equipmentType) {
            _.forEach(equipmentType.forms, function (form) {
              items.push({
                'form': form.name,
                'equipmentType': equipmentType.name
              });
            });
          });
        }

        if (!items.length) {
          updateService({
            id: vm.service.id,
            archived: true
          });
          return;
        }

        $mdDialog.show({
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          targetEvent: event,
          templateUrl: 'app/main/services/dialogs/alert/archive-service-alert.html',
          controllerAs: 'vm',
          controller: function ($mdDialog) {
            return {
              cancel: $mdDialog.cancel,
              confirm: confirmArchive($mdDialog),
              items: items
            };
          }
        }).then(function () {
          return updateService({
            id: vm.service.id,
            archived: true
          });

        });
      });
    }

    function confirmArchive(mdDialog) {
      $timeout(function () { $rootScope.$broadcast('services:reload'); }, 500);
      return mdDialog.hide;
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }

    function toggle(item, list) {
      var index = list.indexOf(item);
      if (index > -1) {
        list.splice(index, 1);
      } else {
        list.push(item);
      }

      $scope.serviceForm.description.$setDirty();
      vm.selectAll = ($scope.employeeSkills.length === vm.employees.length);
    }

    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    function validateDescription() {
      if (!vm.service.description) { return; }

      if (vm.service.description.length > 150) {
        $scope.serviceForm.description.$setValidity('maxlength', false);
        return;
      }
      $scope.serviceForm.description.$setValidity('maxlength', true);
      servicesApi.search({
        description: vm.service.description,
        archived: false
      }, { limit: 1 }).then(function (result) {
        var unique = result.items.length === 0;
        if (unique) {
          $scope.serviceForm.description.$setValidity('duplicated', true);
          return;
        }

        if (!vm.service.id) {
          $scope.serviceForm.description.$setValidity('duplicated', false);
          return;
        }

        if (result.items[0].id !== vm.service.id) {
          $scope.serviceForm.description.$setValidity('duplicated', false);
          return;
        }

        $scope.serviceForm.description.$setValidity('duplicated', true);
      });
    }

    function changeRatingForm(form) {
      if (form) {
        vm.service.ratingForm.id = form.id;
      }
    }

    function changeShowRatingForm() {
      if (!vm.service.configurations.showRatingForm) {
        vm.service.ratingForm.id = null;
        vm.ratingForm = null;
      }
    }

    function linkOrderReportTemplate() {
      var openPalantirSelectItemDialogParams = {
        title: $translate.instant('SERVICES.DIALOG.TEMPLATE.SELECT.TITLE'),
        selectAllText: '',
        searchPlaceholderText: $translate.instant('SERVICES.DIALOG.TEMPLATE.SELECT.SEARCH'),
        cancelText: $translate.instant('SERVICES.DIALOG.TEMPLATE.SELECT.CANCEL'),
        successText: $translate.instant('SERVICES.DIALOG.TEMPLATE.SELECT.SUCCESS'),
        emptyText: $translate.instant('SERVICES.DIALOG.TEMPLATE.SELECT.EMPTY'),
        items: vm.templates,
        type: 'single',
        map: function (item) {
          return {
            id: item.id,
            avatar: {
              icon: 'template-outline'
            },
            title: item.name + ' (' + (item.active ? $translate.instant('SERVICES.DIALOG.TEMPLATE.ACTIVE') : $translate.instant('SERVICES.DIALOG.TEMPLATE.INACTIVE')) + ')',
            subtitle: $translate.instant('SERVICES.DIALOG.TEMPLATE.TYPE.ORDER')
          };
        },
        search: function (value) {
          if (!value) { return vm.templates; }

          return vm.templates.filter(function (template) {
            var lowerCaseValue = value.toLowerCase();

            return template.name.toLowerCase().includes(lowerCaseValue);
          });
        }
      };

      document.dispatchEvent(new CustomEvent('openPalantirSelectItemDialog', { detail: openPalantirSelectItemDialogParams }));

      document.addEventListener('palantirSelectItemDialogClosed', _linkOrderReportTemplate);
    }

    function unlinkOrderReportTemplate() {
      vm.service.orderReportTemplate = null;

      setTimeout(function () {
        $scope.$apply();

        if ($scope.serviceForm) {
          $scope.serviceForm.$setDirty();
        }
      });
    }

    function hasFeatureFlag(name) {
      var hasFeature = vm.featureFlags.find(function (featureFlag) {
        return featureFlag.name === name;
      });

      if (!hasFeature) { return false; }

      return hasFeature.active;
    }

    function toggleAutoSmartRewriteFields(field) {
      if (!vm.service.configurations.mobile.autoSmartRewriteFields) {
        vm.service.configurations.mobile.autoSmartRewriteFields = [];
      }

      var hasField = vm.service.configurations.mobile.autoSmartRewriteFields.includes(field);
      if (hasField) {
        vm.service.configurations.mobile.autoSmartRewriteFields = vm.service.configurations.mobile.autoSmartRewriteFields.filter(function (f) {
          return f !== field;
        });
      } else {
        vm.service.configurations.mobile.autoSmartRewriteFields.push(field);
      }

      var hasNoFields = vm.service.configurations.mobile.autoSmartRewriteFields.length === 0;
      var isAutoSmartRewriteEnabled = vm.service.configurations.mobile.autoSmartRewriteEnabled;

      $scope.serviceForm.autoSmartRewriteFields.$setValidity('required', !hasNoFields && isAutoSmartRewriteEnabled);

      if ($scope.serviceForm) {
        $scope.serviceForm.$setDirty();
      }
    }

    function toggleSmartSummaryPostWorkFields(field) {
      if (!vm.service.configurations.smartSummary.postWork.displayOn) {
        vm.service.configurations.smartSummary.postWork.displayOn = [];
      }

      var hasField = vm.service.configurations.smartSummary.postWork.displayOn.includes(field);
      if (hasField) {
        vm.service.configurations.smartSummary.postWork.displayOn = vm.service.configurations.smartSummary.postWork.displayOn.filter(function (f) {
          return f !== field;
        });
      } else {
        vm.service.configurations.smartSummary.postWork.displayOn.push(field);
      }

      var hasNoFields = vm.service.configurations.smartSummary.postWork.displayOn.length === 0;
      var isPostWorkEnabled = vm.service.configurations.smartSummary.postWork.enabled;

      $scope.serviceForm.smartSummaryPostWorkDisplayOn.$setValidity('required', !hasNoFields && isPostWorkEnabled);

      if ($scope.serviceForm) {
        $scope.serviceForm.$setDirty();
      }
    }

    function _linkOrderReportTemplate(event) {
      if (!event) { return; }
      if (!event.detail) { return; }
      if (event.detail.role !== 'success') { return; }

      var template = event.detail.data[0];

      vm.service.orderReportTemplate = template;

      $scope.$apply();

      if ($scope.serviceForm) {
        $scope.serviceForm.$setDirty();
      }

      document.removeEventListener('ticketFeatureFlagUpdated', _linkOrderReportTemplate);
    }

    function _loadData() {
      $q.all({
        employees: employeesApi.getAll(),
        forms: formsApi.search({}, { limit: 1000, offset: 0 }),
        templates: templatesApi.search({ take: 1000, skip: 0, where: { archived: false } })
      }).then(function (result) {
        vm.employees = _.filter(result.employees.items, function (employee) {
          return employee.contract.active;
        });
        vm.templates = result.templates.items;
        var activatedForms = result.forms.items.filter(function (form) { return form.archived === false; });
        vm.forms = activatedForms;
        vm.allForms = activatedForms;

        vm.ratingForm = _.find(activatedForms, function (form) {
          return form.id === vm.service.ratingForm.id;
        });

        if (!vm.service.id) {
          $scope.employeeSkills = _.map(vm.employees, 'id');
          vm.selectAll = ($scope.employeeSkills.length === vm.employees.length);
        } else {
          servicesApi.getEmployees(vm.service.id).then(function (employees) {
            $scope.employeeSkills = _.map(employees, 'id');
            vm.selectAll = ($scope.employeeSkills.length === vm.employees.length);
          });

          if (vm.service.ratingFormId) {
            vm.ratingForm = activatedForms.find(function (form) {
              return vm.service.ratingFormId === form.id;
            });
          }
        }
      });
    }

    function _updateFormSelect() {
      var availableForms = [];

      vm.allForms.forEach(function (form) {
        vm.service.forms = vm.service.forms || [];
        var selectedForm = _.find(vm.service.forms, function (f) {
          return f.id === form.id;
        });

        if (!selectedForm) {
          availableForms.push(form);
        }
      });

      if (!availableForms.length) {
        vm.formSearchTerm = '';
        vm.searchForm();
      }

      vm.forms = availableForms;
      vm.selectedFormId = null;

      _.defer(function () {
        $scope.$apply(function () {
          vm.selectedForm = null;
        });
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.routes')
        .factory('RoutesFilters', RoutesFilters);

    /** @ngInject */
    function RoutesFilters($rootScope, $timeout) {

        var filters = {
            date: null,
            employeeId: null,

            invalidDate: false,

            clear: clear,
            isOn: isOn,
            isOff: isOff
        };

        function clear() {

            filters.date = null;
            filters.employeeId = null;
            filters.invalidDate = false;

            $timeout(function () {
                $rootScope.$broadcast('routes:filter-updated');
            }, 200);
        }

        function isOn() {
            var noSelectedDate = filters.date == null;
            var noSelectedEmployee = filters.employeeId == null;
            return !(noSelectedDate && noSelectedEmployee);
        }

        function isOff() {
            return !isOn();
        }

        return filters;
    }
})();

(function () {
    'use strict';

    angular.module('app.routes')
        .factory('GanttHtmlTemplate', GanttHtmlTemplate);

    /** @ngInject */
    function GanttHtmlTemplate(moment, msUtils) {

        return {
            taskTemplate: taskTemplate,
            employeeTemplate: employeeTemplate
        };

        function employeeTemplate(currentDate, employee, tasks) {

            var template = '';
            if (employee.avatarUrl) {
                var avatarUrl = employee.avatarUrl + '?id=' + msUtils.shortGuidGenerator();
                template += '<img src="https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg" ' +
                              'ng-src="' + avatarUrl + '" class="avatar medium"/>';
            } else {
                template += '<img src="https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg" class="avatar medium"/>';
            }

            template += '&nbsp;&nbsp;' +
                '<span>{{row.model.name}}</span>';

            return template;
        }

        function taskTemplate() {
            var template = '';
            template += '<div ng-click="scope.vm.highlightPath(task.model, $event)" ng-mouseover="scope.vm.highlightPath(task.model, $event)" ng-mouseleave="scope.vm.unhighlightPath($event)"><span class="gantt-task-name task-id-{{task.model._id}}">{{task.model.description}}';
            template += '</span></div>';
            return template;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.routes')
        .factory('GanttData', GanttData);

    /** @ngInject */
    function GanttData(moment, _, msUtils, activityColor, TasksStatusHelper, GanttHtmlTemplate) {

        return {
            toRows: toRows
        };

        function orderByPriority(tasks) {
            var orderedTasks = _.sortBy(tasks, function (task) {
                switch (task.type) {
                    case 'absence':
                        return -1;
                    case 'break':
                        return 1;
                    case 'route':
                        return 2;
                    case 'task':
                        return 3;
                    default:
                        return 0;
                }
            });
            var priority = 1;
            orderedTasks.forEach(function (task) {
                task.priority = priority;
                priority++;
            });

            return orderedTasks;
        }

        function toRows(tasks, paths, employee, currentDate) {
            var rows = [];

            var estimatedResult = _.map(tasks, function (task) {

                var taskStatus = TasksStatusHelper.getByName(task.status);

                var estimatedResultModel = {
                    customerName: task.order.customer.name,
                    from: task.startedAt ? task.startedAt : task.scheduling.estimation.startTask,
                    to: task.completedAt ? task.completedAt : task.scheduling.estimation.completeTask,
                    timeFixed: (task.scheduling.type === 'scheduled-date-and-time'),
                    id: task.id,
                    serviceName: task.order.service.description,
                    status: parseInt(taskStatus.value),
                    identifier: task.order.identifier,
                    latitude: task.coords.latitude,
                    longitude: task.coords.longitude,
                    startedAt: task.startedAt,
                    completedAt: task.completedAt
                };

                return estimatedResultModel;
            });

            estimatedResult = _.sortBy(estimatedResult, function (task) {
                return moment(task.estimatedRouteStart);
            });

            var ganttEstimatedTasks = [];

            function createGanttData(tasks, paths) {
                if(tasks.length > 0) {
                    var ganttTasks =  createGanttTasksData(tasks);
                    ganttTasks.forEach(function (task) {
                        ganttEstimatedTasks.push(task);
                    });

                    var ganttRoutes = createGanttRoutesData(ganttTasks, paths);
                    ganttRoutes.forEach(function (route) {
                        ganttEstimatedTasks.push(route);
                    });
                } else if(paths.length > 0 && paths[0].length > 0) {
                    ganttEstimatedTasks = createGanttRoutesData(null, paths);
                }
            }

            function createGanttTasksData(tasks) {
                var tasksData = [];

                tasks.forEach(function (task) {
                    var ganttTask = {
                        description: task.customerName,
                        identifier: task.identifier,
                        id: task.id,
                        type: 'task',
                        classes: [
                            activityColor.classNameFromStatusCode(task.status),
                            'task-hover-increase'
                        ],
                        progress: 100,
                        status: task.status,
                        from: task.staterdAt ? task.startedAt : task.from,
                        to: task.completedAt ? task.completedAt : task.to,
                        startedAt: task.staterdAt ? task.startedAt : task.from,
                        completedAt: task.completedAt ? task.completedAt : task.to,
                        lat: task.latitude,
                        lng: task.longitude
                    };

                    tasksData.push(ganttTask);
                });

                return tasksData;
            }

            function createGanttRoutesData(tasks, paths) {
                var routesData = [];
                paths.forEach(function (path) {
                    var preRoutes = overlapRoutes(tasks, path);

                    preRoutes.forEach(function (route) {
                        routesData.push(route);
                    });
                });

                return routesData;
            }

            function splitRoutesTasks(routeTask) {
                var baseDate, firstDate, item, lastDate, output;

                output = [];
                firstDate = moment.utc(routeTask.from);
                lastDate = moment.utc(routeTask.to);
                if (lastDate.diff(firstDate, 'minutes') <= 60) {
                    return [routeTask];
                } else {
                    baseDate = moment.utc(routeTask.from);
                    while (true) {
                        item = {
                            name: 'Deslocamento',
                            id: msUtils.guidGenerator(),
                            description: '.',
                            type: 'route',
                            classes: [
                                'md-blue-grey-100-bg',
                                'route-or-break-task'
                            ]
                        };

                        item.from = baseDate.format();
                        baseDate.add(1, 'h');
                        item.to = baseDate.format();

                        if (moment(item.to).isAfter(lastDate)) {
                            item.to = lastDate.format();
                        }

                        if (lastDate.diff(moment(item.to), 'minutes') <= 25) {
                            item.to = lastDate.format();
                        }

                        output.push(item);
                        if (moment(item.to).isSameOrAfter(lastDate)) {
                            break;
                        }
                    }

                return output;
                }
            };

            function overlapRoutes(tasks, paths) {
                var afterRouteTask, afterTaskLocations, currentResult, i, item, items, j, lastTask, len, len1, result, result2;
                result = [];

                if(tasks != null && tasks.length > 0) {
                    tasks = _.sortBy(tasks, function (task) {
                        return task.startedAt;
                    });

                    tasks.forEach(function (task) {
                        var preRouteTask, preTaskLocations;

                        preTaskLocations = _.filter(paths, function (path) {
                            if (result[result.length - 1]) {
                                return path.timestamp <= task.startedAt && path.timestamp >= result[result.length - 1].to;
                            } else {
                                return path.timestamp <= task.startedAt;
                            }
                        });

                        preTaskLocations = _.sortBy(preTaskLocations, function (location) {
                            return location.timestamp;
                        });

                        if (preTaskLocations.length) {
                            preRouteTask = {
                                name: 'Deslocamento',
                                id: msUtils.guidGenerator(),
                                description: '.',
                                type: 'route',
                                classes: [
                                    'md-blue-grey-100-bg',
                                    'route-or-break-task'
                                ],
                                from: preTaskLocations[0].timestamp,
                                to: preTaskLocations[preTaskLocations.length - 1].timestamp
                            };

                            result.push(preRouteTask);
                        }

                        return result.push({
                            description: task.description,
                            identifier: task.identifier,
                            id: task.id,
                            type: 'task',
                            classes: [
                                activityColor.classNameFromStatusCode(task.status),
                                'task-hover-increase'
                            ],
                            status: task.status,
                            from: task.startedAt,
                            to: task.completedAt
                        });
                    });

                    if (tasks.length) {
                        lastTask = tasks[tasks.length - 1];
                        afterTaskLocations = _.filter(paths, function (path) {
                            return path.timestamp >= lastTask.completedAt;
                        });

                        if (afterTaskLocations.length) {
                            afterTaskLocations = _.sortBy(afterTaskLocations, function (location) {
                                return location.timestamp;
                            });

                            afterRouteTask = {
                                name: 'Deslocamento',
                                id: msUtils.guidGenerator(),
                                description: '.',
                                type: 'route',
                                classes: [
                                    'md-blue-grey-100-bg',
                                    'route-or-break-task'
                                ],
                                from: afterTaskLocations[0].timestamp,
                                to: afterTaskLocations[afterTaskLocations.length - 1].timestamp
                            };

                            result.push(afterRouteTask);
                        }
                    }
                } else {
                    paths = _.sortBy(paths, function (path) {
                        return path.timestamp;
                    });

                    result.push({
                        name: 'Deslocamento',
                        id: msUtils.guidGenerator(),
                        description: '.',
                        type: 'route',
                        classes: [
                            'md-blue-grey-100-bg',
                            'route-or-break-task'
                        ],
                        from: paths[0].timestamp,
                        to: paths[paths.length - 1].timestamp
                    });
                }
                result = _.filter(result, function (object) {
                    return object.type === 'route';
                });

                result2 = [];

                for (i = 0, len = result.length; i < len; i++) {
                    currentResult = result[i];
                    items = splitRoutesTasks(currentResult);

                    for (j = 0, len1 = items.length; j < len1; j++) {
                        item = items[j];
                        result2.push(item);
                    }
                }

                return result2;
            };

            createGanttData(estimatedResult, paths);

            rows.push({
                name: employee.name,
                employeeId: employee.id,
                content: GanttHtmlTemplate.employeeTemplate(currentDate, employee, estimatedResult),
                tasks: orderByPriority(ganttEstimatedTasks)
            });

            return rows;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.routes')
        .factory('GanttConfig', GanttConfig);

    /** @ngInject */
    function GanttConfig(GanttHtmlTemplate) {

        return {
            getOptions: getOptions
        };

        function getOptions() {

            return {
                viewScale               : 'hour',
                zoom                    : 1,
                sideMode                : 'table',
                maxHeight               : 1000,
                taskContent             : GanttHtmlTemplate.taskTemplate(),
                allowSideResizing       : false,
                labelsEnabled           : true,
                fromDate                : '',
                toDate                  : '',
                columns                 : ['model.name'],
                columnsHeaders          : ['Colaborador'],
                draw                    : false
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.recurrences')
        .factory('recurrenceRepeatHumanizer', recurrenceRepeatHumanizer);

    function recurrenceRepeatHumanizer(moment, $translate, LocalDateConvert) {

        function intervalToText(every, interval) {
            var key = every > 1 ? 'S' : '';

            switch (interval) {
                case 'daily':
                    return ' ' + $translate.instant('RECURRENCES.MODEL.TIME_UNITS.DAY' + key);
                case 'weekly':
                    return ' ' + $translate.instant('RECURRENCES.MODEL.TIME_UNITS.WEEK' + key);
                case 'monthly':
                    return ' ' + $translate.instant('RECURRENCES.MODEL.TIME_UNITS.MONTH' + key);
            }
        }

        var resources = {

            weekdayToText: {
                'sunday': $translate.instant('RECURRENCES.MODEL.EXPLANATION.ON_O') + ' ' + $translate.instant('RECURRENCES.MODEL.WEEK_DAYS.SUNDAY'),
                'monday': $translate.instant('RECURRENCES.MODEL.EXPLANATION.ON_A') + ' ' + $translate.instant('RECURRENCES.MODEL.WEEK_DAYS.MONDAY'),
                'tuesday': $translate.instant('RECURRENCES.MODEL.EXPLANATION.ON_A') + ' ' + $translate.instant('RECURRENCES.MODEL.WEEK_DAYS.TUESDAY'),
                'wednesday': $translate.instant('RECURRENCES.MODEL.EXPLANATION.ON_A') + ' ' + $translate.instant('RECURRENCES.MODEL.WEEK_DAYS.WEDNESDAY'),
                'thursday': $translate.instant('RECURRENCES.MODEL.EXPLANATION.ON_A') + ' ' + $translate.instant('RECURRENCES.MODEL.WEEK_DAYS.THURSDAY'),
                'friday': $translate.instant('RECURRENCES.MODEL.EXPLANATION.ON_A') + ' ' + $translate.instant('RECURRENCES.MODEL.WEEK_DAYS.FRIDAY'),
                'saturday': $translate.instant('RECURRENCES.MODEL.EXPLANATION.ON_O') + ' ' + $translate.instant('RECURRENCES.MODEL.WEEK_DAYS.SATURDAY')
            }
        };

        return {
            getExplanationText: getExplanationText,
            getShortExplanationText: getShortExplanationText
        };

        function getShortExplanationText(recurrence) {

            var explanationText = '';
            explanationText += $translate.instant('RECURRENCES.MODEL.EXPLANATION.SCHEDULED_EVERY', { everyInterval: (recurrence.repeat.every || 0) + intervalToText(recurrence.repeat.every, recurrence.repeat.interval) });

            if (recurrence.repeat.interval !== 'weekly') {
                if (recurrence.repeat.skipWeekend === true) {
                    explanationText += ' <u>' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.EXCEPT_WEEKENDS') + '</u>';
                }
            }

            if (recurrence.repeat.interval === 'weekly') {
                explanationText += ' <b>' + resources.weekdayToText[recurrence.repeat.weekday] + '</b>';
            } else if (recurrence.repeat.interval === 'monthly') {
                explanationText += ' ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.ON_DAY') + ' <b>' + (recurrence.repeat.dayOfMonth || 1) + '</b>';
            }

            if (recurrence.repeat.time) {
                explanationText += ' ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.AT') + ' ' + recurrence.repeat.time;
            }

            if (recurrence.automatic.enabled) {
                explanationText += ' ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.AUTOMATICALLY_CREATED');
            } else {
                explanationText += ' ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.MANUALLY_CREATED');
            }

            return explanationText;
        }

        function getExplanationText(recurrence) {

            var fromAsDate = recurrence.repeat.fromAsDate || recurrence.repeat.from;
            var untilAsDate = recurrence.repeat.untilAsDate || recurrence.repeat.until || null;

            var explanationText = $translate.instant('RECURRENCES.MODEL.EXPLANATION.STARTS_ON', { date: LocalDateConvert.formatDate(fromAsDate, 'date') });
            if (untilAsDate) {
                explanationText += ' ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.ENDS_ON', { date: moment(untilAsDate).format('DD/MM/YYYY') });
            } else {
                explanationText += ' ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.NO_END_DATE');
            }
            explanationText += '. ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.SCHEDULED_EVERY', { everyInterval: (recurrence.repeat.every || 0) + intervalToText(recurrence.repeat.every, recurrence.repeat.interval) });

            if (recurrence.repeat.interval !== 'weekly') {
                if (recurrence.repeat.skipWeekend === true) {
                    explanationText += ' <u>' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.EXCEPT_WEEKENDS') + '</u>';
                }
            }

            if (recurrence.repeat.interval === 'weekly') {
                explanationText += ' <b>' + resources.weekdayToText[recurrence.repeat.weekday] + '</b>';
            } else if (recurrence.repeat.interval === 'monthly') {
                explanationText += ' ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.ON_DAY') + ' <b>' + (recurrence.repeat.dayOfMonth || 1) + '</b>';
            }

            if (recurrence.repeat.time) {
                explanationText += ' ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.AT') + ' ' + recurrence.repeat.time;
            }

            if (recurrence.automatic.enabled) {
                explanationText += ' ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.AUTOMATICALLY_CREATED');
            } else {
                explanationText += ' ' + $translate.instant('RECURRENCES.MODEL.EXPLANATION.MANUALLY_CREATED');
            }

            return explanationText;

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.recurrences')
        .factory('recurrenceOccurrencesGenerator', recurrenceOccurrencesGenerator);

    function recurrenceOccurrencesGenerator(_, moment, recurringApi) {

        return {
            generate: generate
        };

        function generate(repeat) {

            var untilLimit = moment().add(90, 'd');
            var until = moment(repeat.until);

            if (!repeat.until || until.isAfter(untilLimit)) {
                repeat.until = untilLimit.format('YYYY-MM-DD');
            }

            var recurringOptions = {
                start: repeat.from,
                end: repeat.until,
                iterations: 100,
                every: repeat.every || 1,
                interval: repeat.interval,
                options: {
                    skipWeekend: repeat.skipWeekend
                }
            };

            switch(repeat.interval) {
                case 'weekly': recurringOptions.weekday = repeat.weekday; break;
                case 'monthly': recurringOptions.dayOfMonth = repeat.dayOfMonth || 1; break;
            }

            return recurringApi.getOccurrencesDates(recurringOptions);
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.recurrences')
    .factory('RecurrenceDialog', RecurrenceDialog);

  /** @ngInject */
  function RecurrenceDialog($mdDialog, $rootScope, $document, servicesApi, recurrencesApi, employeesApi, accountsApi, $q, _) {

    return {
      createRecurrence: createRecurrence,
      editRecurrence: editRecurrence,
      getAllOccurrences: getAllOccurrences
    };

    function getAllOccurrences(recurrence, callback) {
      _loaderOn();

      recurrencesApi.searchOccurrences({ id: recurrence.id }, { include: 'task', limit: 2000, offset: 0 })
        .then(function (result) {
          if (callback) {
            callback(result.items, null);
          }
        })
        .catch(function (err) {
          if (callback) {
            callback(null, err);
          }
        })
        .finally(_loaderOff);
    }

    function createRecurrence(ev, callback) {
      _loaderOn();

      var requests = {
        services: servicesApi.search({ archived: false }),
        employees: employeesApi.search({ take: 10000, orderBy: 'name_asc', where: { active: true } }),
        account: accountsApi.get()
      };

      $q.all(requests).then(function (result) {
        var activeEmployees = _.filter(result.employees.items, function (employee) {
          return (employee.contract.active && !employee.inactivatedAt);
        });

        _openRecurrenceDialog(ev, {
          Recurrence: null,
          Services: result.services.items,
          Employees: activeEmployees,
          Occurrences: null,
          Account: result.account
        }, callback);
      }).finally(_loaderOff);
    }

    function editRecurrence(ev, id, callback) {
      _loaderOn();

      var requests = {
        services: servicesApi.getAll(),
        recurrence: recurrencesApi.getOne(id),
        occurrences: recurrencesApi.searchOccurrences({ id: id }, { include: 'task', limit: 5, offset: 0, sort: 'iteration' }),
        employees: employeesApi.search({ take: 10000, orderBy: 'name_asc' }),
        account: accountsApi.get()
      };

      $q.all(requests).then(function (result) {
        var selectedEmployee = result.recurrence.employee;
        var activeEmployeesAndSelectedEmployee = _.filter(result.employees.items, function (employee) {
          return (employee.contract.active && !employee.inactivatedAt) || selectedEmployee && employee.id === selectedEmployee.id;
        });

        var selectedService = result.recurrence.service;
        var activeServicesAndSelectedService = _.filter(result.services.items, function (service) {
          return !service.archived || service.id === selectedService.id;
        });

        _openRecurrenceDialog(ev, {
          Recurrence: result.recurrence,
          Services: activeServicesAndSelectedService,
          Occurrences: result.occurrences,
          Employees: activeEmployeesAndSelectedEmployee,
          Account: result.account
        }, callback);

      }).finally(_loaderOff);
    }

    function _openRecurrenceDialog(ev, locals, callback) {
      $mdDialog.show({
        controller: 'RecurrencesDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/recurrences/dialog/recurrence-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      }).finally(function () {
        document.dispatchEvent(new CustomEvent('recurrence-dialog:close'));
      });
    }

    function _loaderOn() {
      $rootScope.loadingProgress = true;
    }

    function _loaderOff() {
      $rootScope.loadingProgress = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.recurrences')
    .constant('isRecurrenceCopy', false)
    .controller('RecurrencesDialogController', RecurrencesDialogController);

  RecurrencesDialogController.$inject = [
    'Recurrence',
    'Account',
    'customersApi',
    'employeesApi',
    '$timeout',
    'FcModalService',
    '_',
    'focus',
    'Services',
    'recurrencesApi',
    'RecurrenceDialog',
    'customerLocationsApi',
    'moment',
    '$mdToast',
    '$mdDialog',
    '$scope',
    '$rootScope',
    'Employees',
    '$document',
    'recurrenceRepeatHumanizer',
    'equipmentsApi',
    '$q',
    'msUtils',
    'gandalfApi',
    'accountsApi',
    'accountFeatureFlagsApiGraphQL',
    'recurrenceOccurrencesGenerator',
    'TasksStatusHelper',
    'recurrencesLinksService',
    'tasksApi',
    'absencesApi',
    'Occurrences',
    '$translate',
    'dateHandler',
    'attachmentsUtils',
    'authenticatedUser',
    'ordersApi',
    'locationSectorsApiGraphQL',
    'locationEnvironmentsApiGraphQL',
    'isRecurrenceCopy'
  ];

  /** @ngInject */
  function RecurrencesDialogController(
    Recurrence, Account, customersApi, employeesApi, $timeout, FcModalService, _, focus, Services, recurrencesApi, RecurrenceDialog, customerLocationsApi,
    moment, $mdToast, $mdDialog, $scope, $rootScope, Employees, $document, recurrenceRepeatHumanizer, equipmentsApi, $q, msUtils, gandalfApi, accountsApi, accountFeatureFlagsApiGraphQL,
    recurrenceOccurrencesGenerator, TasksStatusHelper, recurrencesLinksService, tasksApi, absencesApi, Occurrences, $translate, dateHandler, attachmentsUtils, authenticatedUser, ordersApi, locationSectorsApiGraphQL, locationEnvironmentsApiGraphQL, isRecurrenceCopy) {

    var vm = this;
    vm.employeeSearchTerm = "";
    vm.isRecurrenceCopy = isRecurrenceCopy;
    vm.isSimulatingOccurrences = false;
    vm.loadingOccurrences = false;
    vm.recurrence = Recurrence ? angular.copy(Recurrence) : null;
    vm.searchCustomerText = null;
    vm.services = angular.copy(Services);
    vm.minDateBegin = !Recurrence ? moment().toDate() : null;
    vm.minDateEnd = !Recurrence ? moment().add(1, 'd').toDate() : null;
    vm.selectedCustomer = null;
    vm.selectedCustomerLocation = null;
    vm.hasNoLocations = false;
    vm.customersLocations = [];
    vm.accountConfiguration = Account.configuration;
    vm.account = Account;
    vm.addPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_create');
    vm.editPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_edit');
    vm.formErr = {};
    vm.isToShowEmployeeChangeWarning = false;
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['recurrence-notes'];
    vm.locationSectors = [];
    vm.locationEnvironments = [];
    vm.equipments = [];

    // Methods
    vm.addTask = addTask;
    vm.archiveOrUnarchiveRecurrence = archiveOrUnarchiveRecurrence;
    vm.archiveTask = archiveTask;
    vm.broadcastUpdateFields = broadcastUpdateFields;
    vm.verifyEmployeeSkills = verifyEmployeeSkills;
    vm.addEmployeeSkill = addEmployeeSkill;
    vm.changeRecurrenceType = changeRecurrenceType;
    vm.clearEmployeeSearchTerm = clearEmployeeSearchTerm;
    vm.clearSelectedCustomer = clearSelectedCustomer;
    vm.closeDialog = closeDialog;
    vm.createRecurrenceCopy = createRecurrenceCopy;
    vm.deleteOccurrence = deleteOccurrence;
    vm.initializeOccurrences = initializeOccurrences;
    vm.onSelectedService = onSelectedService;
    vm.saveRecurrence = saveRecurrence;
    vm.saveRecurrenceByFlag = saveRecurrenceByFlag;
    vm.searchCustomerByName = searchCustomerByName;
    vm.searchOccurrencesByPage = searchOccurrencesByPage;
    vm.selectedCustomerChanged = selectedCustomerChanged;
    vm.simulateOccurrences = simulateOccurrences;
    vm.toggleServiceRequiredValidationWorkaround = toggleServiceRequiredValidationWorkaround;
    vm.unarchiveTask = unarchiveTask;
    vm.employeesCheckAbsent = employeesCheckAbsent;
    vm.employeeIsAbsent = employeeIsAbsent;
    vm.updateOccurrence = updateOccurrence;
    vm.updateOccurrenceScheduledTime = updateOccurrenceScheduledTime;
    vm.updateMinEndDate = updateMinEndDate;
    vm.selectedCustomerLocationChanged = selectedCustomerLocationChanged;
    vm.searchCustomerLocationByName = searchCustomerLocationByName;
    vm.createFirstCustomerLocation = createFirstCustomerLocation;
    vm.clearSelectedCustomerLocation = clearSelectedCustomerLocation;
    vm.editOccurrence = editOccurrence;
    vm.cofirmEditOccurrence = cofirmEditOccurrence;
    vm.dismissEditOccurrence = dismissEditOccurrence;
    vm.showEmployeeChangeWarning = showEmployeeChangeWarning;
    vm.hasRecurrenceLinks = hasRecurrenceLinks;
    vm.hasRecurrenceLinksWhileCopying = hasRecurrenceLinksWhileCopying;

    vm.loadedTabs = {
      links: false
    };

    if (!vm.recurrence || !vm.recurrence.id) {
      recurrencesLinksService.setRecurrenceLinks({
        sectors: vm.isCopyingRecurrence ? (vm.recurrence.sectors) : [],
        environments: vm.isCopyingRecurrence ? (vm.recurrence.environments) : [],
        equipments: vm.isCopyingRecurrence ? (vm.recurrence.equipments) : []
      });
    }

    canShowNewRecurrenceLinksPage().then(function (canShow) {
      vm.canShowNewRecurrenceLinks = canShow;

      _initialize();
    });

    function _initialize() {
      vm.employees = _.sortBy(angular.copy(Employees), 'employee.name');

      vm.services = _.sortBy(angular.copy(Services), 'service.description');
      vm.skipWeekendShowOption = true;
      vm.limitPerPage = 5;
      vm.pagination = {
        perPageCount: 5,
        currentPage: 1,
        firstPageIndex: 1,
        lastPageIndex: 5
      };

      if (vm.recurrence) {
        vm.pagination.totalItems = Occurrences.totalItems;
        loadPaginated(1);
        vm.loadPaginated = loadPaginated;
      }

      if (vm.recurrence && !vm.recurrence.id) {
        vm.minDateBegin = moment().startOf('day').toDate();
        if (vm.recurrence.repeat && vm.recurrence.repeat.fromAsDate) {
          vm.minDateEnd = moment(vm.recurrence.repeat.fromAsDate).add(1, 'd').toDate();
        }
      }

      if (!vm.recurrence) {
        vm.recurrence = {
          customer: {},
          location: {},
          service: null,
          employee: {
            id: null
          },
          automatic: {
            before: '1-day',
            enabled: true
          },
          repeat: {
            from: null,
            every: 1,
            interval: 'daily',
            skipWeekend: true,
            until: null
          },
          archived: false
        };

        vm.recurrence.repeat.fromAsDate = new Date();
        vm.recurrence.repeat.from = moment(vm.recurrence.repeat.fromAsDate).format('YYYY-MM-DD');
        vm.occurrences = [];
      } else {
        vm.recurrence.employee = vm.recurrence.employee || { id: 'null' };
        vm.selectedCustomer = {
          id: vm.recurrence.customer.id,
          name: vm.recurrence.customer.name,
          address: vm.recurrence.customer.address,
          contact: vm.recurrence.customer.contact,
          notes: vm.recurrence.customer.notes
        };

        if (vm.recurrence.location) {
          vm.selectedCustomerLocation = {
            id: vm.recurrence.location.id,
            name: vm.recurrence.location.name,
            address: vm.recurrence.location.address,
            notes: vm.recurrence.location.notes
          };
        }

        vm.recurrence.repeat.fromAsDate = moment(vm.recurrence.repeat.from).toDate();
        if (vm.recurrence.repeat.until) {
          vm.recurrence.repeat.untilAsDate = moment(vm.recurrence.repeat.until).toDate();
        }

        if (vm.recurrence.repeat.time) {
          vm.recurrence.repeat.time = dateHandler.formatTimeToShort(vm.recurrence.repeat.time);
        }

        vm.datatableOffset = 0;
        vm.disableNext = (vm.datatableOffset + 25) >= Occurrences.totalItems;
        vm.disablePrevious = (vm.datatableOffset - 25) < 0;
        vm.recurrence.occurrences = Occurrences.items;
        vm.initialNotes = vm.recurrence.notes;
      }

      vm.employeesCheckAbsent(vm.recurrence);

      $scope.$on('recurrences:update-fields', function () {
        if (vm.recurrence.repeat.fromAsDate) {
          vm.recurrence.repeat.from = null;
          vm.recurrence.repeat.until = null;
          vm.recurrence.repeat.from = moment(vm.recurrence.repeat.fromAsDate).format('YYYY-MM-DD');

          if (vm.recurrence.repeat.untilAsDate) {
            vm.recurrence.repeat.until = moment(vm.recurrence.repeat.untilAsDate).format('YYYY-MM-DD');
          }

          vm.recurrenceExplanationRepeatText = recurrenceRepeatHumanizer.getExplanationText(vm.recurrence);
        }

        if (!vm.recurrence.id) {
          vm.occurrences = [];
        }

        setFormDirty();
      });

      updateServiceValidationState();

      $rootScope.$broadcast('recurrences:update-fields');
    }

    function employeesCheckAbsent(recurrence) {
      absencesApi.getByDate(moment().toDate()).then(function (absences) {
        if (!vm.employees || !vm.employees.length) {
          return;
        }

        recurrence.absences = _.map(vm.employees, function (employee) {
          var absence = _.find(absences, function (absence) {
            return absence.employee.id === employee.id;
          });

          return {
            id: employee.id,
            absent: !!absence
          };
        });
      });
    }

    function employeeIsAbsent(recurrence, employee) {
      var absence = _.find(recurrence.absences, function (employeeAbsence) {
        return employee.id === employeeAbsence.id;
      });

      return absence ? absence.absent : false;
    }

    function initializeOccurrences() {
      vm.occurrences = vm.occurrences || [];
      if (vm.recurrence.id && !vm.occurrences.length) {
        vm.loadingOccurrences = true;
        vm.recurrence.occurrences.forEach(function (occurrence, index) {

          vm.occurrences.push(occurrence);

          if ((vm.recurrence.occurrences.length - 1) === index) {
            vm.loadingOccurrences = false;
            vm.occurrences.forEach(function (occurrence) {
              if (occurrence.task) {
                occurrence.task.status = TasksStatusHelper.getByName(occurrence.task.status);
                occurrence.scheduled.date = occurrence.task.scheduling.date;

                if (occurrence.task && occurrence.task.employee) {
                  occurrence.employee = { id: occurrence.task.employee && occurrence.task.employee.id };
                } else {
                  occurrence.employee = { id: null };
                }
              }

              occurrence.scheduled.date = moment(occurrence.scheduled.date).toDate();
              if (occurrence.scheduled.at) {
                occurrence.scheduled._at = moment(occurrence.scheduled.at).format('DD/MM/YYYY HH:mm:ss');
              }
            });

            vm.occurrences = _.sortBy(vm.occurrences, function (occurrence) {
              return occurrence.iteration;
            });

            if (!vm.recurrence.employee) {
              vm.recurrence.employee = {
                id: 'null'
              };
            }
            onSelectedService();
          }
        });
      }
    }

    function createRecurrenceCopy($event) {
      var recurrenceCopy = angular.copy(vm.recurrence);

      delete recurrenceCopy.id;
      delete recurrenceCopy.createdAt;
      delete recurrenceCopy.updatedAt;

      recurrenceCopy.locationSectorIds = [];
      recurrenceCopy.locationEnvironmentIds = [];
      recurrenceCopy.equipmentsIds = [];

      $q.all([loadRecurrenceEquipments(), loadLocationEnvironments(), loadLocationSectors(), _verifyCustomerEquipments(true)]).then(function () {
        $timeout(function () {
          recurrenceCopy.locationSectorIds = _.map(vm.locationSectors, 'id');
          recurrenceCopy.locationEnvironmentIds = _.map(vm.locationEnvironments, 'id');
          recurrenceCopy.sectors = angular.copy(vm.locationSectors);
          recurrenceCopy.environments = angular.copy(vm.locationEnvironments);
          recurrenceCopy.equipments = angular.copy(vm.selectedEquipments);

          recurrencesLinksService.clearRecurrenceLinks();

          $mdDialog.show({
            controller: 'RecurrencesDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/recurrences/dialog/recurrence-dialog.html',
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: true,
            locals: {
              Recurrence: recurrenceCopy,
              Account: vm.account,
              Services: vm.services,
              Employees: vm.employees,
              Occurrences: [],
              isCopyingRecurrence: true,
              isRecurrenceCopy: true
            },
          }).then(function (reload) {
            if (reload) {
              $rootScope.$broadcast('recurrences:filter-updated');
            }
          });
        });
      });
    }

    function paginate(arr, perpage, page) {
      vm.pagination.currentPage = page;
      vm.pagination.firstPageIndex = perpage * (page - 1);
      vm.pagination.lastPageIndex = perpage * page;

      var pagedItems = angular.copy(arr).slice(vm.pagination.firstPageIndex, vm.pagination.lastPageIndex);
      var isEmpty = pagedItems.length === 0;

      if (isEmpty) {
        vm.pagination.firstPageIndex = 0;
      } else {
        vm.pagination.firstPageIndex++;
      }

      var isLastPageIndexGreaterThanTotalLength = vm.pagination.lastPageIndex >= arr.length;
      if (isLastPageIndexGreaterThanTotalLength) {
        vm.pagination.lastPageIndex = arr.length;
      }

      return pagedItems;
    }

    function loadPaginated(page) {
      $rootScope.loadingProgress = true;
      var offset = (page - 1) * vm.limitPerPage;
      var sumOffSetLimitPerPage = offset + vm.limitPerPage;
      var lastIndex = sumOffSetLimitPerPage > vm.pagination.totalItems ? vm.pagination.totalItems : sumOffSetLimitPerPage;
      vm.pagination.currentPage = page;
      vm.pagination.firstPageIndex = offset + 1;
      vm.pagination.lastPageIndex = lastIndex;

      $timeout(function () {
        recurrencesApi.searchOccurrences({ id: vm.recurrence.id }, { include: 'task', limit: vm.limitPerPage, offset: offset, sort: 'iteration' })
          .then(function (response) {
            vm.currentOccurrences = response.items;
            _normalizeOccurrences();
            $rootScope.loadingProgress = false;
            vm.pagination.lastPageIndex = Math.min(vm.pagination.lastPageIndex, vm.pagination.totalItems);
            vm.pagination.totalPages = Math.ceil(response.totalItems / vm.limitPerPage);
          })
          .catch(function (error) {
            $rootScope.loadingProgress = false;
          });
      }, 450);
    }

    function loadPaginatedSimulate(page) {
      $rootScope.loadingProgress = true;
      $timeout(function () {
        vm.currentOccurrences = paginate(vm.occurrences, vm.limitPerPage, page);
        _normalizeOccurrences();
        $rootScope.loadingProgress = false;
      }, 450);
    }

    function toggleServiceRequiredValidationWorkaround() {
      return !(vm.recurrence && vm.recurrence.service && vm.recurrence.service.id);
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }

    function archiveOrUnarchiveRecurrence(recurrence, archive) {
      recurrence.archived = archive;

      saveRecurrenceByFlag(recurrence, { closeDialog: true }, function (recurrence) {
        if (recurrence.id) {
          var today = moment().format('YYYY-MM-DD');

          RecurrenceDialog.getAllOccurrences(recurrence, function (occurrences) {
            if (occurrences && occurrences.length) {
              var nextOccurrencesTasks = _.filter(occurrences, function (occurrence) {
                var task = occurrence.task;

                return task &&
                  task.id &&
                  task.archived === !archive &&
                  task.status === 'scheduled' &&
                  moment(task.scheduling.date).isSameOrAfter(today);
              });

              if (nextOccurrencesTasks.length) {
                var patchPayload = _.map(nextOccurrencesTasks, function (occurrence) {
                  return { id: occurrence.task.id, archived: archive };
                });

                if (archive) {
                  var confirm = $mdDialog.confirm()
                    .title($translate.instant('RECURRENCES.DIALOG.ALERT.TITLE'))
                    .textContent($translate.instant('RECURRENCES.DIALOG.ALERT.CONTENT'))
                    .ok($translate.instant('RECURRENCES.DIALOG.ALERT.OK'))
                    .cancel($translate.instant('RECURRENCES.DIALOG.ALERT.CANCEL'));

                  $mdDialog.show(confirm).then(function () {
                    tasksApi.patchTasks(patchPayload);
                  });
                } else {
                  tasksApi.patchTasks(patchPayload);
                }
              }
            }
          });
        }
      });
    }

    function saveRecurrenceByFlag(recurrence, options, afterCloseCallback) {
      if (vm.canShowNewRecurrenceLinks) {
        return saveRecurrenceWithLinks(recurrence, options, afterCloseCallback);
      }

      return saveRecurrence(recurrence, options, afterCloseCallback);
    }

    function saveRecurrenceWithLinks(recurrence, options, afterCloseCallback) {
      if (vm.initialNotes !== vm.recurrence.notes && vm.recurrence.id) {
        var confirm = $mdDialog.confirm()
          .title($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.TITLE'))
          .htmlContent($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.CONTENT'))
          .ok($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.ACCEPT'))
          .cancel($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.CANCEL'));

        setTimeout(function () {
          $mdDialog.show(confirm).then(function () {
            RecurrenceDialog.getAllOccurrences(recurrence, function (occurrences) {

              if (!occurrences || !occurrences.length) { return; }

              var nextOccurrencesTasks = _.filter(occurrences, function (occurrence) {
                var task = occurrence.task;
                return task && task.id && task.status === 'scheduled';
              });

              if (!nextOccurrencesTasks.length) { return; };

              var ordersId = [];

              nextOccurrencesTasks.map(function (occurrence) {
                var orderId = occurrence.task.order.id;
                if (!ordersId.includes(orderId)) {
                  ordersId.push(orderId);
                }
              });

              var uploadOrders = ordersId.map(function (orderId) {
                var order = {
                  id: orderId,
                  customer: {
                    id: vm.recurrence.customer.id
                  },
                  description: vm.recurrence.notes
                };

                return ordersApi.patch(order);
              });

              Promise.all(uploadOrders).then(function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.SUCESS'))
                    .hideDelay(3000)
                    .theme('success-toast')
                );
              }).catch(function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.ERROR'))
                    .hideDelay(3000)
                    .theme('error-toast')
                );
              });

            });
          });
        }, 500);

      }

      if (!vm.recurrence.id) {
        _saveRecurrenceLinks(recurrence);
      }

      $rootScope.loadingProgress = true;

      if (recurrence.employee && (recurrence.employee.id === null || recurrence.employee.id === 'null')) {
        recurrence.employee = null;
      }

      recurrence.automatic.enabled = true;
      recurrence.repeat.from = null;
      recurrence.repeat.until = null;
      recurrence.repeat.from = moment(recurrence.repeat.fromAsDate).format('YYYY-MM-DD');

      if (recurrence.repeat.untilAsDate) {
        recurrence.repeat.until = moment(recurrence.repeat.untilAsDate).format('YYYY-MM-DD');
      }

      if (recurrence.repeat.time == "") {
        delete recurrence.repeat.time;
      }

      if (!recurrence.location || !recurrence.location.id) {
        delete recurrence.location;
      }

      if (vm.selectedEquipments && vm.selectedEquipments.length) {
        recurrence.equipments = vm.selectedEquipments;
      }

      if(recurrence.absences) {
        delete recurrence.absences;
      }

      var saveRecurrence = recurrence.id ? recurrencesApi.update : recurrencesApi.create;

      var mappedRecurrence = angular.copy(recurrence);

      if (vm.selectedEquipments && vm.selectedEquipments.length) {
        mappedRecurrence.equipments = _.map(vm.selectedEquipments, 'id');
      }

      if (vm.locationSectors && vm.locationSectors.length) {
        mappedRecurrence.locationSectorIds = _.map(vm.locationSectors, 'id');
      }

      if (vm.locationEnvironments && vm.locationEnvironments.length) {
        mappedRecurrence.locationEnvironmentIds = _.map(vm.locationEnvironments, 'id');
      }

      mappedRecurrence.customerId = mappedRecurrence.customer && mappedRecurrence.customer.id;
      mappedRecurrence.locationId = mappedRecurrence.location && mappedRecurrence.location.id;
      mappedRecurrence.serviceId = mappedRecurrence.service && mappedRecurrence.service.id;
      mappedRecurrence.employeeId = mappedRecurrence.employee && mappedRecurrence.employee.id;

      delete mappedRecurrence.customer;
      delete mappedRecurrence.location;
      delete mappedRecurrence.service;
      delete mappedRecurrence.employee;
      delete mappedRecurrence.sectors;
      delete mappedRecurrence.environments;
      delete mappedRecurrence.equipmentsIds;

      if (mappedRecurrence.repeat) {
        delete mappedRecurrence.repeat.fromAsDate;
        delete mappedRecurrence.repeat.untilAsDate;
      }

      if(mappedRecurrence.occurrences) {
        delete mappedRecurrence.occurrences;
      }

      if (recurrence.id) {
        delete mappedRecurrence.automatic;
        delete mappedRecurrence.repeat;
        delete mappedRecurrence.customerId;
      }

      saveRecurrence(mappedRecurrence).then(function (savedRecurrence) {
        recurrencesApi.processOccurrences(savedRecurrence).then(function () {
          var message = $translate.instant('RECURRENCES.TOAST.RECURRENCE_SAVED', { customerName: vm.selectedCustomer.name });

          $mdToast.show(
            $mdToast.simple().textContent(message).hideDelay(3000)
          );

          $rootScope.loadingProgress = false;

          if (options.closeDialog) {
            closeDialog(true);

            if (afterCloseCallback) {
              afterCloseCallback(recurrence, vm.occurrences);
            }
          }
        });

        for (var i = 0; i < vm.smartRewriteFields.length; i++) {
          var field = vm.smartRewriteFields[i];
          var params = {
            reference: vm.sessionId,
            referenceType: field,
            updatedReference: savedRecurrence.id
          };

          gandalfApi.updateRewriteInputHistory(params);
        }
      }).catch(function () {
        var message = $translate.instant('RECURRENCES.TOAST.CONNECTION_ERROR');
        $mdToast.show(
          $mdToast.simple()
            .textContent(message)
            .hideDelay(3000)
            .theme('error-toast')
        );

        $rootScope.loadingProgress = false;
      });
    }

    function saveRecurrence(recurrence, options, afterCloseCallback) {
      if (vm.initialNotes !== vm.recurrence.notes && vm.recurrence.id) {
        var confirm = $mdDialog.confirm()
          .title($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.TITLE'))
          .htmlContent($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.CONTENT'))
          .ok($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.ACCEPT'))
          .cancel($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.CANCEL'));

        setTimeout(function () {
          $mdDialog.show(confirm).then(function () {
            RecurrenceDialog.getAllOccurrences(recurrence, function (occurrences) {

              if (!occurrences || !occurrences.length) { return; }

              var nextOccurrencesTasks = _.filter(occurrences, function (occurrence) {
                var task = occurrence.task;
                return task && task.id && task.status === 'scheduled';
              });

              if (!nextOccurrencesTasks.length) { return; };

              var ordersId = [];

              nextOccurrencesTasks.map(function (occurrence) {
                var orderId = occurrence.task.order.id;
                if (!ordersId.includes(orderId)) {
                  ordersId.push(orderId);
                }
              });

              var uploadOrders = ordersId.map(function (orderId) {
                var order = {
                  id: orderId,
                  customer: {
                    id: vm.recurrence.customer.id
                  },
                  description: vm.recurrence.notes
                };

                return ordersApi.patch(order);
              });

              Promise.all(uploadOrders).then(function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.SUCESS'))
                    .hideDelay(3000)
                    .theme('success-toast')
                );
              }).catch(function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent($translate.instant('RECURRENCES.DIALOG.OCCURRENCES.CHANGE_DESCRIPTION.ERROR'))
                    .hideDelay(3000)
                    .theme('error-toast')
                );
              });

            });
          });
        }, 500);
      }

      $rootScope.loadingProgress = true;

      if (recurrence.employee && (recurrence.employee.id === null || recurrence.employee.id === 'null')) {
        recurrence.employee = null;
      }

      recurrence.automatic.enabled = true;
      recurrence.repeat.from = null;
      recurrence.repeat.until = null;
      recurrence.repeat.from = moment(recurrence.repeat.fromAsDate).format('YYYY-MM-DD');

      if (recurrence.repeat.untilAsDate) {
        recurrence.repeat.until = moment(recurrence.repeat.untilAsDate).format('YYYY-MM-DD');
      }

      if (recurrence.repeat.time == "") {
        delete recurrence.repeat.time;
      }

      if (!recurrence.location || !recurrence.location.id) {
        delete recurrence.location;
      }

      if (vm.selectedEquipments.length) {
        recurrence.equipments = _.map(vm.selectedEquipments, function (equipment) {
          return equipment.id;
        });
      }

      recurrencesApi.save(recurrence).then(function (savedRecurrence) {
        recurrencesApi.processOccurrences(savedRecurrence).then(function () {
          var message = $translate.instant('RECURRENCES.TOAST.RECURRENCE_SAVED', { customerName: vm.selectedCustomer.name });

          $mdToast.show(
            $mdToast.simple().textContent(message).hideDelay(3000)
          );

          $rootScope.loadingProgress = false;

          if (options.closeDialog) {
            closeDialog(true);

            if (afterCloseCallback) {
              afterCloseCallback(recurrence, vm.occurrences);
            }
          }
        });

        for (var i = 0; i < vm.smartRewriteFields.length; i++) {
          var field = vm.smartRewriteFields[i];
          var params = {
            reference: vm.sessionId,
            referenceType: field,
            updatedReference: savedRecurrence.id
          };

          gandalfApi.updateRewriteInputHistory(params);
        }
      }).catch(function () {
        var message = $translate.instant('RECURRENCES.TOAST.CONNECTION_ERROR');
        $mdToast.show(
          $mdToast.simple()
            .textContent(message)
            .hideDelay(3000)
            .theme('error-toast')
        );

        $rootScope.loadingProgress = false;
      });
    }

    function changeRecurrenceType() {
      delete vm.recurrence.repeat.dayOfMonth;
      delete vm.recurrence.repeat.weekday;
      vm.skipWeekendShowOption = true;

      if (vm.recurrence.repeat.interval === 'weekly') {
        vm.recurrence.repeat.weekday = 'monday';
        vm.recurrence.repeat.skipWeekend = false;
        vm.skipWeekendShowOption = false;
      }

      if (vm.recurrence.repeat.interval == 'monthly') {
        vm.recurrence.repeat.dayOfMonth = 1;
      }
    }

    function verifyEmployeeSkills() {
      var isServiceSelected = vm.recurrence && vm.recurrence.service && vm.recurrence.service.id;
      var isEmployeeSelected = vm.recurrence.employee && vm.recurrence.employee.id && vm.recurrence.employee.id !== 'null';

      if (!isServiceSelected || !isEmployeeSelected) return;

      employeesApi.getSkill(vm.recurrence.employee.id, vm.recurrence.service.id).then(function () {
        delete vm.formErr['notSkilledEmployee_'];
      }).catch(function () {
        vm.formErr['notSkilledEmployee_'] = null;
        if (isEmployeeSelected) {
          vm.formErr['notSkilledEmployee_'] = $translate.instant('RECURRENCES.MODEL.ERRORS.DOES_NOT_PERFORM', { serviceDescription: vm.recurrence.service.description });
        }
      });
    }

    function showEmployeeChangeWarning() {
      vm.isToShowEmployeeChangeWarning = true;
    }

    function addEmployeeSkill(recurrence) {
      var isServiceSelected = recurrence && recurrence.service.id;
      var isEmployeeSelected = recurrence && recurrence.employee && recurrence.employee.id && recurrence.employee.id !== 'null';


      if (!isServiceSelected && !isEmployeeSelected) return;

      employeesApi.addSkill(recurrence.employee.id, recurrence.service.id).then(function () {
        verifyEmployeeSkills();

        var employee = _.find(vm.employees, function (employeeFromList) {
          return Number(employeeFromList.id) === Number(recurrence.employee.id);
        });

        $mdToast.show(
          $mdToast.simple()
            .textContent(
              $translate.instant('TASKS.TOASTS.SERVICES_TYPE.CUSTOMER_SERVICE_ADDED', {
                serviceDescription: recurrence.service.description,
                employeeName: employee.name
              }
              )
            )
            .hideDelay(5000)
        );
      });
    }

    function broadcastUpdateFields() {
      $rootScope.$broadcast('recurrences:update-fields');
      setFormDirty();
    }

    function updateMinEndDate(isStartDate) {
      if (isStartDate) {
        vm.minDateEnd = moment(vm.recurrence.repeat.fromAsDate.toString()).add(1, 'd').toDate();
        vm.recurrence.repeat.untilAsDate = null;
      }

      broadcastUpdateFields();
    }

    function _normalizeOccurrences() {
      vm.currentOccurrences = _.map(vm.currentOccurrences, function (occurrence) {
        if (occurrence.scheduled && occurrence.scheduled.date) {
          occurrence.scheduled.date = moment(occurrence.scheduled.date).toDate();
          if (occurrence.task && typeof occurrence.task.status === 'string') {
            occurrence.task.status = TasksStatusHelper.getByName(occurrence.task.status);
          }
          if (occurrence.scheduled.time) {
            occurrence.scheduled.time = moment(occurrence.scheduled.time, 'HH:mm:ss').format('HH:mm');
          }
        }

        return occurrence;
      });
    }

    // Customer auto-complete
    function selectedCustomerChanged() {
      updateServiceValidationState();

      if (!vm.selectedCustomer) return;
      vm.recurrence.customer = vm.selectedCustomer;

      if (vm.selectedCustomer.primaryLocation && vm.selectedCustomer.primaryLocation.id) {
        customerLocationsApi.getOne(vm.selectedCustomer.primaryLocation.id).then(function (location) {
          if (location) {
            vm.hasNoLocations = false;
            vm.selectedCustomerLocation = location;
            vm.recurrence.location = vm.selectedCustomerLocation;
          } else {
            vm.hasNoLocations = true;
          }
        });
      } else {
        vm.hasNoLocations = true;
      }

      _verifyCustomerEquipments();
    }

    function updateServiceValidationState() {
      if (vm.services && vm.services.length) {
        _.forEach(vm.services, function (service) {
          service.show = shouldShowService(service, vm.selectedCustomer);
          if (vm.recurrence.service && vm.recurrence.service.id === service.id && !service.show) {
            vm.recurrence.service = null;
          }
        });
      }
    }

    function shouldShowService(service, customer) {
      var corporateCustomerAccountUuid = msUtils.getCorporateAccountUuidFromCustomer(customer);
      var serviceCorporateAccountUuid = msUtils.getCorporateAccountUuidFromService(service);

      var isNotCorporateCustomer = !corporateCustomerAccountUuid;
      var isNotCorporateService = !serviceCorporateAccountUuid;

      var serviceId = service.id;
      var recurrenceServiceId = vm.recurrence && vm.recurrence.service && vm.recurrence.service.id;
      var isEditingRecurrence = !!vm.recurrence.id;

      if ((isEditingRecurrence || vm.isRecurrenceCopy) && recurrenceServiceId === serviceId) {
        return true;
      }

      if (isNotCorporateCustomer) {
        return isNotCorporateService;
      }

      var isSameCorporateAccount = corporateCustomerAccountUuid === serviceCorporateAccountUuid;
      var allowCreateTaskEnabled = service.metadata && service.metadata.featureAllowCreateTask;
      return Boolean(isSameCorporateAccount && allowCreateTaskEnabled);
    }

    function searchCustomerByName(searchCustomerText) {
      return customersApi.search({
        where: {
          nameOrDocumentNumberContains: searchCustomerText,
          archived: false
        },
        take: 5
      }).then(function (result) {
        return result.items;
      });
    }

    function clearSelectedCustomer(isCopyingRecurrence, confirmed) {
      var copyFlow = !!(isCopyingRecurrence || vm.isCopyingRecurrence);

      if (copyFlow) {
        var hasLinks = vm.hasRecurrenceLinksWhileCopying();

        if (hasLinks && !confirmed) {
          promptRemoveCustomerDialog();
          return;
        }

        recurrencesLinksService.clearRecurrenceLinks();
        vm.locationSectors = [];
        vm.locationEnvironments = [];
        vm.selectedEquipments = [];
        vm.equipmentOptions = [];
        vm.showingEquipments = [];

        if (vm.recurrence) {
          vm.recurrence.sectors = [];
          vm.recurrence.environments = [];
          vm.recurrence.equipments = [];
          vm.recurrence.locationSectorIds = [];
          vm.recurrence.locationEnvironmentIds = [];
          vm.recurrence.customer = null;
        }

        vm.selectedCustomer = null;
        vm.searchCustomerText = null;

        $timeout(function () {
          focus('auto-complete-customer');
        }, 200);

        return;
      }

      var hasRecurrenceLinks = vm.hasRecurrenceLinks();

      if (hasRecurrenceLinks) {
        promptRemoveLinksToProceed();
        return;
      }

      vm.selectedCustomer = null;
      vm.searchCustomerText = null;
      vm.recurrence.customer = null;

      $timeout(function () {
        focus('auto-complete-customer');
      }, 200);
    }

    // LOCATION
    function selectedCustomerLocationChanged(location) {
      if (location) {
        vm.recurrence.location = location;
      }

      recurrencesLinksService.clearRecurrenceLinks();
    }

    function canShowNewRecurrenceLinksPage() {
      return accountsApi.getCachedAccount().then(function (account) {
        return accountFeatureFlagsApiGraphQL.getCachedFlagByName('recurrence-links-beta-flag').then(function (flag) {
          return flag ? true : false;
        });
      });
    }

    function searchCustomerLocationByName(selectedCustomer, searchCustomerLocationText) {
      return customerLocationsApi.search({
        where: {
          customerIds: [selectedCustomer.id],
          nameContains: searchCustomerLocationText,
          archived: false
        },
        take: 10
      }).then(function (result) {
        vm.customersLocations = result.items;
        return vm.customersLocations;
      });
    }

    function createFirstCustomerLocation() {
      $rootScope.loadingProgress = true;

      customersApi.save({
        id: vm.selectedCustomer.id,
        name: vm.selectedCustomer.name,
        address: vm.selectedCustomer.address
      }).then(function (result) {
        customersApi.getOne(vm.selectedCustomer.id).then(function (customer) {
          vm.selectedCustomerLocation = customer.primaryLocation;
          vm.recurrence.location = customer.primaryLocation;
          vm.hasNoLocations = false;

          $rootScope.loadingProgress = false;
        });
      });
    }

    function clearSelectedCustomerLocation(isCopyingRecurrence, confirmed) {
      var copyFlow = !!(isCopyingRecurrence || vm.isCopyingRecurrence);

      if (copyFlow) {
        var hasLinks = vm.hasRecurrenceLinksWhileCopying();

        if (hasLinks && !confirmed) {
          promptRemoveCustomerDialog();
          return;
        }

        recurrencesLinksService.clearRecurrenceLinks();
        vm.locationSectors = [];
        vm.locationEnvironments = [];
        vm.selectedEquipments = [];
        vm.equipmentOptions = [];
        vm.showingEquipments = [];

        if (vm.recurrence) {
          vm.recurrence.sectors = [];
          vm.recurrence.environments = [];
          vm.recurrence.equipments = [];
          vm.recurrence.locationSectorIds = [];
          vm.recurrence.locationEnvironmentIds = [];
          vm.recurrence.location = null;
        }

        vm.selectedCustomerLocation = null;

        $timeout(function () {
          focus('auto-complete-customer-location');
        }, 200);

        return;
      }

      var hasRecurrenceLinks = vm.hasRecurrenceLinks();

      if (hasRecurrenceLinks) {
        promptRemoveLinksToProceed();
        return;
      }

      vm.recurrence.location = null;
      vm.selectedCustomerLocation = null;

      $timeout(function () {
        focus('auto-complete-customer-location');
      }, 200);
    }

    function promptRemoveLinksToProceed() {
      FcModalService.open('', {
        title: $translate.instant('TASKS.DIALOG.WARNINGS.TITLE'),
        content: $translate.instant('TASKS.DIALOG.WARNINGS.CONTENT'),
        leftButtonText: $translate.instant('TASKS.DIALOG.WARNINGS.BUTTON'),
        handleRightButton: vm.closeDialog
      });
    }

    function promptRemoveCustomerDialog() {
      FcModalService.open('', {
        title: $translate.instant('RECURRENCES.DIALOG.WARNINGS.REMOVE_CUSTOMER_TITLE'),
        content: $translate.instant('RECURRENCES.DIALOG.WARNINGS.REMOVE_CUSTOMER_CONTENT'),
        leftButtonText: $translate.instant('RECURRENCES.DIALOG.WARNINGS.CANCEL_BUTTON'),
        handleLeftButton: function () {},
        rightButtonText: $translate.instant('RECURRENCES.DIALOG.WARNINGS.REMOVE_BUTTON'),
        handleRightButton: function () {
          clearSelectedCustomer(true, true);
        }
      });
    }


    // SERVICE
    function onSelectedService() {
      var service = _.find(vm.services, function (item) {
        return item.id == parseInt(vm.recurrence.service.id);
      });
      vm.recurrence.service = angular.copy(service);
    }

    function deleteOccurrence(index) {
      if (index > -1) {
        vm.occurrences.splice(index, 1);
      }
      calculateIterationNumber();
    }

    function addTask(occurrence) {
      if (!vm.recurrence.archived) {
        $rootScope.loadingProgress = true;
        recurrencesApi.insertOccurrenceTask(vm.recurrence, occurrence).then(function (task) {
          recurrencesApi.getOccurrence(vm.recurrence, occurrence).then(function (occurrenceUpdated) {
            task.status = TasksStatusHelper.getByName(task.status);
            occurrence.task = task;
            occurrence.scheduled._at = moment(occurrenceUpdated.scheduled.at).format('DD/MM/YYYY HH:mm:ss');
            occurrence.scheduled.type = occurrenceUpdated.scheduled.type;

            $rootScope.loadingProgress = false;
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('RECURRENCES.TOAST.TASK_CREATED', {
                  occurrenceIteration: occurrence.iteration,
                  date: moment(occurrenceUpdated.scheduled.date).format('DD/MM/YYYY')
                }))
                .hideDelay(3000)
            );
          });
        }).catch(function (e) {
          if (e.status === 404 || e.status === 422) {
            setTimeout(function () {
              addTask(occurrence);
            }, 1000);
          }

          $rootScope.loadingProgress = false;
        });
      }
    }

    function hasRecurrenceLinks() {
      var recurrenceLinks = recurrencesLinksService.getRecurrenceLinks();

      var recurrenceLocationEnvironments = recurrenceLinks && recurrenceLinks.recurrenceLocationEnvironments && recurrenceLinks.recurrenceLocationEnvironments.length;
      var recurrenceLocationSectors = recurrenceLinks && recurrenceLinks.recurrenceLocationSectors && recurrenceLinks.recurrenceLocationSectors.length;
      var recurrenceEquipments = recurrenceLinks && recurrenceLinks.recurrenceEquipments && recurrenceLinks.recurrenceEquipments.length;

      return recurrenceLocationEnvironments || recurrenceLocationSectors || recurrenceEquipments;
    }

    function _saveRecurrenceLinks(recurrence) {
      var hasRecurrenceLinks = vm.hasRecurrenceLinks();
      var recurrenceLinks = recurrencesLinksService.getRecurrenceLinks() || {};

      var hasRecurrenceLinks = (recurrenceLinks.recurrenceLocationSectors && recurrenceLinks.recurrenceLocationSectors.length) ||
        (recurrenceLinks.recurrenceLocationEnvironments && recurrenceLinks.recurrenceLocationEnvironments.length) ||
        (recurrenceLinks.recurrenceEquipments && recurrenceLinks.recurrenceEquipments.length);

      if (!hasRecurrenceLinks) {
        recurrence.locationSectorIds = [];
        recurrence.locationEnvironmentIds = [];
        recurrence.equipments = (vm.selectedEquipments && vm.selectedEquipments.length) ? _.map(vm.selectedEquipments, 'id') : [];
        return;
      }

      recurrence.locationSectorIds = _.map(recurrenceLinks.recurrenceLocationSectors || [], 'id');
      recurrence.locationEnvironmentIds = _.map(recurrenceLinks.recurrenceLocationEnvironments || [], 'id');
      recurrence.equipments = _.map(recurrenceLinks.recurrenceEquipments || [], 'id');

      if (vm.selectedEquipments && vm.selectedEquipments.length) {
        recurrence.equipments = _.map(vm.selectedEquipments, 'id');
      }
    }

    function hasRecurrenceLinksWhileCopying() {
      var recurrence = vm.recurrence;

      var recurrenceLocationEnvironments = recurrence && recurrence.environments && recurrence.environments.length;
      var recurrenceLocationSectors = recurrence && recurrence.sectors && recurrence.sectors.length;
      var recurrenceEquipments = recurrence && recurrence.equipments && recurrence.equipments.length;

      return recurrenceLocationEnvironments || recurrenceLocationSectors || recurrenceEquipments;
    }

    function archiveTask(occurrence) {
      if (!vm.recurrence.archived) {
        $rootScope.loadingProgress = true;

        tasksApi.patchTasks([{ id: occurrence.task.id, archived: true }]).then(function (archivedTask) {
          occurrence.task = archivedTask[0];
          occurrence.task.status = TasksStatusHelper.getByName(occurrence.task.status);
          occurrence.editMode = false;
          occurrence.confirmMode = false;

          $rootScope.loadingProgress = false;
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("RECURRENCES.TOAST.TASK_ARCHIVED", {
                occurrenceIteration: occurrence.iteration,
                date: moment(occurrence.scheduled.date).format('DD/MM/YYYY')
              }))
              .hideDelay(3000)
          );
        });
      }
    }

    function unarchiveTask(occurrence) {
      if (!vm.recurrence.archived) {

        $rootScope.loadingProgress = true;
        tasksApi.patchTasks([{ id: occurrence.task.id, archived: false }]).then(function (archivedTask) {
          occurrence.task = archivedTask[0];
          occurrence.task.status = TasksStatusHelper.getByName(occurrence.task.status);
          occurrence.editMode = false;
          occurrence.confirmMode = false;

          $rootScope.loadingProgress = false;
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('RECURRENCES.TOAST.TASK_UNARCHIVED', {
                occurrenceIteration: occurrence.iteration,
                date: moment(occurrence.scheduled.date).format('DD/MM/YYYY')
              }))
              .hideDelay(3000)
          );
        });
      }
    }

    function calculateIterationNumber() {
      vm.occurrences = vm.occurrences || [];
      var iteration = 0;
      vm.occurrences.forEach(function (occurrence) {
        occurrence.iteration = ++iteration;
      });

      vm.occurrences = _.sortBy(vm.occurrences, function (occurrence) {
        return occurrence.iteration;
      });
    }

    function simulateOccurrences() {
      vm.isSimulatingOccurrences = true;
      vm.recurrence.repeat.from = moment(vm.recurrence.repeat.fromAsDate).format('YYYY-MM-DD');

      if (vm.recurrence.repeat.untilAsDate) {
        vm.recurrence.repeat.until = moment(vm.recurrence.repeat.untilAsDate).format('YYYY-MM-DD');
      }

      return recurrenceOccurrencesGenerator.generate(vm.recurrence.repeat).then(function (occurrencesDates) {
        var iteration = 0, occurrences = [];

        for (var i = 0; i < occurrencesDates.results.length; i++) {
          var occurrence = {
            iteration: ++iteration,
            scheduled: {
              date: moment(occurrencesDates.results[i]).toDate(),
              time: vm.recurrence.repeat.time,
              at: null,
              type: null
            },
            employee: null,
            task: null
          };

          if (vm.recurrence.employee) {
            occurrence.employee = { id: vm.recurrence.employee.id };
          } else {
            occurrence.employee = { id: null };
          }

          occurrences.push(occurrence);
        }

        vm.occurrences = occurrences;
        if (vm.occurrences) {
          loadPaginatedSimulate(1);
          vm.loadPaginated = loadPaginatedSimulate;
        }
      }).catch(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('RECURRENCES.DIALOG.ERRORS.SIMULATE_OCCURRENCES'))
            .hideDelay(3000)
            .theme("error-toast")
        );
      }).finally(function () {
        vm.isSimulatingOccurrences = false;
      });
    }

    function updateOccurrenceScheduledTime(occurrence) {
      if (occurrence === '' || occurrence.scheduled.time.length === 5) {
        updateOccurrence(occurrence);
      }
    }

    function updateOccurrence(occurrence) {
      if (occurrence.id) {
        $rootScope.loadingProgress = true;

        if (!occurrence.employee || occurrence.employee.id === 'null') {
          occurrence.employee = {
            id: null
          };
        }

        recurrencesApi.updateOccurrence(vm.recurrence, occurrence).then(function (occurrenceUpdated) {
          if (occurrence.task) {
            tasksApi.patchTasks([
              {
                id: occurrenceUpdated.task.id,
                scheduling: {
                  date: occurrenceUpdated.scheduled.date,
                  type: occurrenceUpdated.scheduled.time ? 'scheduled-date-and-time' : 'scheduled-date',
                  time: occurrenceUpdated.scheduled.time
                },
                employee: occurrenceUpdated.employee
              }
            ]);
          }

          $rootScope.loadingProgress = false;
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('RECURRENCES.TOAST.TASK_UPDATED', { occurrenceIteration: occurrence.iteration }))
              .hideDelay(3000)
          );
        });
      }
    }

    function setFormDirty() {
      if ($scope.recurrenceForm) {
        $timeout(function () { $scope.recurrenceForm.$setDirty(); }, 500);
      }
    }

    function clearEmployeeSearchTerm() {
      vm.employeeSearchTerm = '';
    }

    function searchOccurrencesByPage(offset) {
      vm.datatableOffset = vm.datatableOffset + offset;

      var searchParams = { id: vm.recurrence.id };
      var searchOptions = {
        include: 'task',
        limit: vm.limitPerPage,
        offset: vm.datatableOffset,
        sort: 'iteration'
      };

      recurrencesApi.searchOccurrences(searchParams, searchOptions).then(function (result) {
        vm.occurrences = result.items;

        vm.occurrences.forEach(function (occurrence) {
          if (occurrence.task) {
            occurrence.task.status = TasksStatusHelper.getByName(occurrence.task.status);
            occurrence.scheduled.date = occurrence.task.scheduling.date;

            if (occurrence.task.employee) {
              occurrence.employee.id = occurrence.task.employee.id;
            } else {
              occurrence.employee.id = null;
            }
          }

          if (occurrence.scheduled.at) {
            occurrence.scheduled._at = moment(occurrence.scheduled.at).format('DD/MM/YYYY HH:mm:ss');
          }
        });

        vm.disableNext = (vm.datatableOffset + searchOptions.limit) >= result.totalItems;
        vm.disablePrevious = (vm.datatableOffset - searchOptions.limit) < 0;
      }).finally(function () {
        _scrollTop('.dialog-form-content');
      });
    }

    function _scrollTop(elementSelector) {
      var element = angular.element(document).find(elementSelector);

      if (element) {
        element.addClass('scroll-smooth');
        element.scrollTop(0);
        element.removeClass('scroll-smooth');
      }
    }

    function editOccurrence(occurrence) {
      occurrence.editMode = true;
    }

    function cofirmEditOccurrence(occurrence) {
      occurrence.confirmMode = true;
    }

    function dismissEditOccurrence(ocurrence) {
      ocurrence.confirmMode = false;
    }

    /**
     * EQUIPAMENTOS
     **/
    vm.selectedEquipmentItemChange = selectedEquipmentItemChange;
    vm.confirmRemoveEquipment = confirmRemoveEquipment;
    vm.loadRecurrenceEquipments = loadRecurrenceEquipments;
    vm.navigateToPage = navigateToPage;
    vm.getLastEquipmentCount = getLastEquipmentCount;
    vm.toggleSearchEquipments = toggleSearchEquipments;
    vm.searchEquipments = searchEquipments;
    vm._getEquipmentsFromRecurrence = _getEquipmentsFromRecurrence;
    vm.paginationEquipments = { take: 1000, skip: 0 };
    vm.loadingRecurrenceEquipments = true;
    vm.selectedEquipment = null;
    vm.selectedEquipmentText = null;
    vm.maxEquipmentPerRecurrence = 150;
    vm.equipmentsPaginateBy = 10;
    vm.equipmentsPage = 1;
    vm.showingEquipments = [];
    vm.equipmentOptions = [];
    vm.selectedEquipments = [];

    function selectedEquipmentItemChange(selectedEquipment) {
      if (selectedEquipment) {
        if (selectedEquipment.attachments && selectedEquipment.attachments.length) {
          selectedEquipment.thumbnail = attachmentsUtils.correctUrl(selectedEquipment.attachments[0].path);
        }

        if (vm.selectedEquipments && vm.selectedEquipments.length) {
          var hasEquipmentAdded = _.find(vm.selectedEquipments, function (equip) {
            return equip.id === selectedEquipment.id;
          });

          if (hasEquipmentAdded) { return; }
        }

        vm.selectedEquipments.push(selectedEquipment);
        vm.equipmentOptions = vm.selectedEquipments;
        vm.selectedEquipmentText = null;
        vm.selectedEquipment = null;
        navigateToPage(1);
      }
    }

    function _getEquipmentsFromRecurrence() {

      recurrencesApi.getEquipments(vm.recurrence.id).then(function (equipments) {
        if (equipments.length) {
          vm.selectedEquipments = _.map(equipments, function (equip) {
            equip.isLinked = true;
            equip.thumbnail = attachmentsUtils.correctUrl(equip.imageUrl);
            return equip;
          }).sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            return 1;
          });
          vm.showingEquipments = vm.selectedEquipments;

          _getEquipmentsForms();
          loadRecurrenceEquipments();
        }
      });
    }

    function navigateToPage(pageNumber) {
      vm.equipmentsPage = pageNumber;

      vm.showingEquipments = vm.equipmentOptions.slice(
        (vm.equipmentsPage - 1) * vm.equipmentsPaginateBy,
        vm.equipmentsPage * vm.equipmentsPaginateBy
      );
    }

    function toggleSearchEquipments() {
      $mdDialog.show({
        controller: 'AddEquipmentsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/tasks/dialogs/add-equipments-dialog/add-equipments-dialog.html',
        parent: angular.element($document.body),
        targetEvent: null,
        clickOutsideToClose: true,
        multiple: true,
        locals: {
          selectedCustomer: vm.selectedCustomer,
          selectedEquipments: vm.selectedEquipments,
          order: vm.recurrence,
          locationId: vm.recurrence.location ? vm.recurrence.location.id : null
        }
      }).then(function () {
        vm.selectedEquipments = _.union(vm.selectedEquipments, vm.recurrence.equipments);
        vm.equipmentOptions = _.union(vm.equipmentOptions, vm.recurrence.equipments);
        delete vm.recurrence.equipments;
        navigateToPage(1);
        setFormDirty();
      });
    }

    function getLastEquipmentCount() {
      return vm.equipmentsPage * vm.equipmentsPaginateBy;
    }

    function searchEquipments() {
      vm.equipmentOptions = _.filter(vm.selectedEquipments, function (equipment) {
        return equipment.name.includes(vm.searchEquipmentText) ||
          equipment.number.includes(vm.searchEquipmentText);
      });

      navigateToPage(1);
    }

    function confirmRemoveEquipment(equipment) {
      var equipmentIndex = _.findIndex(vm.selectedEquipments, function (equip) {
        return equip.id === equipment.id;
      });

      vm.selectedEquipments.splice(equipmentIndex, 1);
      vm.showingEquipments = vm.selectedEquipments;
      vm.equipmentOptions = vm.selectedEquipments;
      navigateToPage(1);
    }

    function loadRecurrenceEquipments(take, skip) {
      if (vm.recurrence.id) {
        _verifyCustomerEquipments();
        take = vm.paginationEquipments.take;
        skip = vm.paginationEquipments.skip;
        return recurrencesApi.getEquipments({ recurrenceId: vm.recurrence.id }, 'name_asc', take, skip).then(function (result) {
            vm.paginationEquipments.pageInfo = result.pageInfo;
            _.forEach(result.items, function (equipment) {
                selectedEquipmentItemChange(equipment);
            });
            vm.loadingRecurrenceEquipments = false;
        });
      } else {
        vm.loadingRecurrenceEquipments = false;
        return $q.resolve();
      }
    }

    function loadLocationSectors() {
        if (!vm.recurrence || !vm.recurrence.id) {
            vm.locationSectors = [];
            return $q.resolve();
        }

        return locationSectorsApiGraphQL.search({
            where: {
                recurrenceId: vm.recurrence.id
            },
            skip: 0,
            take: 1000
        }).then(function (response) {
            if (response && response.items.length) {
                vm.locationSectors = response.items.map(function (item) {
                    return item;
                });
            }
        });
    }

    function loadLocationEnvironments() {
        if (!vm.recurrence || !vm.recurrence.id) {
            vm.locationEnvironments = [];
            return $q.resolve();
        }

        return locationEnvironmentsApiGraphQL.search({
            where: {
                recurrenceId: vm.recurrence.id
            },
            skip: 0,
            take: 1000
        }).then(function (response) {
            if (response && response.items.length) {
                vm.locationEnvironments = response.items.map(function (item) {
                    return item;
                });
            }
        });
      }

    function _verifyCustomerEquipments(isCopying) {
      vm.selectedCustomer.hasEquipment = false;

      if (!isCopying) {
        vm.selectedEquipments = [];
      }

      equipmentsApi.search({
        where: { customerIds: [vm.selectedCustomer.id] },
        take: 1
      }).then(function (response) {
        vm.selectedCustomer.hasEquipment = response.totalCount ? true : false;
      }).catch(function () {
        vm.selectedCustomer.hasEquipment = false;
      });
    }

  }
})();
(function () {
  'use strict';

  angular.module('app.quotations')
    .factory('QuotationsDialog', QuotationsDialog);

  /** @ngInject */
  function QuotationsDialog($mdDialog, $rootScope, quotationsApi, $document, $q, accountsApi) {

    return {
      createQuotation: createQuotation,
      createQuotationFromOrder: createQuotationFromOrder,
      createQuotationFromTicket: createQuotationFromTicket,
      editQuotation: editQuotation,
      copyQuotation: copyQuotation,
      refreshQuotation: refreshQuotation,
    };

    function createQuotation(ev, callback) {
      var requests = {
        account: accountsApi.get(),
      };

      $q.all(requests).then(function (result) {
        _openDialog(ev, {
          Quotation: null,
          Order: null,
          Ticket: null,
          Account: result.account,
        }, callback);
      });

    }

    function createQuotationFromOrder(ev, order, target, callback) {
      var requests = {
        account: accountsApi.get(),
      };

      $q.all(requests).then(function (result) {
        _openDialog(ev, {
          Quotation: null,
          Order: order,
          Ticket: null,
          Account: result.account,
        }, target, callback);
      });
    }

    function createQuotationFromTicket(ev, ticket, callback) {
      var requests = {
        account: accountsApi.get(),
      };

      $q.all(requests).then(function (result) {
        _openDialog(ev, {
          Quotation: null,
          Order: null,
          Ticket: ticket,
          Account: result.account
        }, callback);
      });
    }

    function copyQuotation(quotation, callback) {
      var requests = {
        account: accountsApi.get(),
      };

      var target = document.querySelector('.palantir-modal-container');

      $q.all(requests).then(function (result) {
        _openDialog(_closeDialog(quotation), {
          Quotation: quotation,
          Order: null,
          Ticket: null,
          Account: result.account,
        }, target, callback);
      });

    }

    function editQuotation(ev, id, target, callback) {
      $rootScope.loadingProgress = true;
      var requests = {
        quotation: quotationsApi.getOne(id),
        account: accountsApi.get(),
      };

      $q.all(requests).then(function (result) {
        _openDialog(ev, {
          Quotation: result.quotation,
          Order: null,
          Ticket: null,
          Account: result.account,
        }, target, callback);

      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function _openDialog(ev, locals, target, callback) {
      $mdDialog.show({
        controller: 'QuotationsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/quotations/dialogs/quotation-dialog.html',
        parent: target || angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        multiple: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (result) {
        if (callback) {
          callback(result.reload, result.quotation);
        }
      }).finally(function () {
        document.dispatchEvent(new CustomEvent('quotation-dialog:close'));
      });
    }

    function _closeDialog(quotation) {
      $mdDialog.hide({
        reload: true,
        quotation: quotation
      });
    }

    function refreshQuotation(quotation, account, callback) {
      _openDialog(_closeDialog(quotation), {
        Quotation: quotation,
        Order: null,
        Account: account,
      }, callback);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.quotations')
    .controller('QuotationsDialogController', QuotationsDialogController);

  /** @ngInject */
  function QuotationsDialogController(
    $translate, $scope, $rootScope, $timeout, $window,
    $mdDialog, Quotation, Order, Ticket, QuotationCustomer,
    QuotationServiceOrder, QuotationProductService, accountsApi,
    QuotationsDialog, moment, msUtils, quotationsApi, accountFeatureFlagsApiGraphQL,
    Account, labelsApi, ticketsApi, fuseTheming, fuseGenerator, CheckEditPermission,
    MessageDialog, CurrencyService, _, $locale, authenticatedUser, FcModalService,
    $mdToast, uploadApi, quotationsAttachmentsApi, QuotationAttachmentsService,
    OrderDialog, ordersApi, gandalfApi, attachmentsUtils, LocalDateConvert, IntegrationsService,
    QuotationsExportDialog
  ) {
    var vm = this;
    vm.currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = vm.currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    vm.formErr = {};
    vm.today = moment().toDate();
    vm.quotationProductService = QuotationProductService;
    vm.quotationProductService.items = [];
    vm.quotationProductService.expenses = [];
    vm.quotationProductService.quotationEquipments = [];
    vm.quotationProductService.disabled = false;
    vm.discountOptions = [{ value: { symbol: '%', label: 'percentage' } }, { value: { symbol: vm.currencySymbol, label: 'value' } }];
    vm.currentDiscountOption = { symbol: '%', label: 'percentage' };
    vm.validateCustomer = QuotationCustomer.validateCustomer;
    vm.quotationLink = 'https://app.fieldcontrol.com.br/relacionamento-cliente/#/orcamentos/';
    vm.awsAttachmentsPath = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/';
    vm.selectedCustomerEmails = [];
    vm.customers = [];
    vm.searchCustomerText = null;
    vm.selectedCustomer = null;
    vm.isSelectedServiceOrderRequired = false;
    vm.serviceOrders = [];
    vm.searchServiceOrderIdentifierText = null;
    vm.selectedServiceOrder = null;
    vm.createdFromQuotation = null;
    vm.isServiceOrderRequired = false;
    vm.order = angular.copy(Order);
    vm.ticket = angular.copy(Ticket);
    vm.isCreatingQuotationFromTicket = Boolean(vm.ticket && vm.ticket.id);
    vm.account = Account;
    vm.accountConfiguration = Account.configuration;
    vm.addPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_create');
    vm.hasLabelsPermission = authenticatedUser.hasPermission(vm.account, 'settings-registers_labels_menu');
    vm.palettes = fuseTheming.getRegisteredPalettesLabels();
    vm.rgba = fuseGenerator.rgba;
    vm.addNewLabel = addNewLabel;
    vm.editLabel = editLabel;
    vm.updateLabel = updateLabel;
    vm.filterLabel = filterLabel;
    vm.hasLabel = hasLabel;
    vm.toggleLabel = toggleLabel;
    vm.labels = [];
    vm.labelSearchText = '';
    vm.editingLabel = null;
    vm.labelTabIndex = 0;
    vm.newLabelColor = null;
    vm.newLabelName = null;
    vm.customerAccountName = customerAccountName;
    vm.isValidQuotationFormTabGeneral = false;
    vm.labelsLimit = vm.accountConfiguration.labelsLimit || 30;
    vm.updatedQuotation = null;
    vm.lastIdentifier = null;
    vm.identifierType = null;
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['quotation-description', 'quotation-additional-information'];
    vm.productServiceSmartRewriteFields = ['quotation-product-service-description'];

    vm.attachmentsLimit = 20;
    vm.uploadProgress = false;
    vm.loadingAttachments = false;
    vm.renameTitle = '';

    vm.attachments = [];
    vm.files = [];
    vm.filesToUpload = [];

    vm.quotation = angular.copy(Quotation) || {
      identifier: null,
      name: '',
      status: 'pending',
      description: '',
      additionalInformation: '',
      approvedMessage: '',
      subtotal: 0,
      total: 0,
      expiredAt: moment().add(7, 'd').toDate(),
      refusedAt: null,
      approvedAt: null,
      approvedBy: null,
      approvedSignature: null,
      items: vm.quotationProductService.items,
      expenses: vm.quotationProductService.expenses,
      quotationEquipments: vm.quotationProductService.quotationEquipments,
      discount: {
        type: 'percentage',
        value: 0,
        total: 0
      },
      archived: false,
      createdBy: authenticatedUser.profile.name,
      emailsToSendQuotation: [],
      labels: [],
    };
    vm.searchCustomerByName = searchCustomerByName;
    vm.changedCustomer = changedCustomer;
    vm.searchServiceOrderByIdentifier = searchServiceOrderByIdentifier;
    vm.changedServiceOrder = changedServiceOrder;
    vm.saveQuotation = saveQuotation;
    vm.isSendQuotationEmailDisabled = isSendQuotationEmailDisabled;
    vm.promptSendQuotationLink = promptSendQuotationLink;
    vm.closeDialog = closeDialog;
    vm.copyQuotation = copyQuotation;
    vm.updateTotal = updateTotal;
    vm.validateDiscountValue = validateDiscountValue;
    vm.changeDiscountType = changeDiscountType;
    vm.validateItems = validateItems;
    vm.printQuotation = printQuotation;
    vm.unarchiveQuotation = unarchiveQuotation;
    vm.archiveQuotation = archiveQuotation;
    vm.cancelQuotation = cancelQuotation;
    vm.clearSelectedServiceOrder = clearSelectedServiceOrder;
    vm.showToastWhileCopyLink = showToastWhileCopyLink;
    vm.sendSpecificEmail = sendSpecificEmail;
    vm.sendLink = sendLink;
    vm.addEmailToSendQuotation = addEmailToSendQuotation;
    vm.deleteEmailToSendQuotation = deleteEmailToSendQuotation;
    vm.validateQuotationFormGeneralTab = validateQuotationFormGeneralTab;
    vm.discardQuotation = discardQuotation;
    vm.createTaskWithSelectedQuotation = createTaskWithSelectedQuotation;
    vm.dateFormat = LocalDateConvert.pickFormat('date');
    vm.timeFormat = LocalDateConvert.pickFormat('time');

    vm.validateImageSize = attachmentsUtils.validateImage;
    vm.isFileTypeImage = msUtils.isFileTypeImage;
    vm.removeFile = removeFile;
    vm.uploadImages = uploadImages;
    vm.getQuotationsAttachments = getQuotationsAttachments;
    vm.deleteAttachment = deleteAttachment;
    vm.archiveAttachment = archiveAttachment;
    vm.renameAttachment = renameAttachment;
    vm.openOriginal = openOriginal;
    vm.moveAttachmentDown = moveAttachmentDown;
    vm.moveAttachmentUp = moveAttachmentUp;
    vm.getIconByFileType = msUtils.getIconByFileType;
    vm.canCloseQuotationDialog = false;
    vm.expensesTotalValue = 0;

    vm.showIntegrationButton = showIntegrationButton;
    vm.openIntegrationDialog = openIntegrationDialog;
    vm.integrations = IntegrationsService.getAll();

    vm.hasQuotationsEquipmentsFeatureFlag = false;
    vm.hasPaymentsBetaFlag = false;
    vm.isQuotationsWithEquipmentsConfigActive = false;

    vm.shouldShowNewQuotationItemsDesign = false;

    vm.loadedTabs = {
      productsServices: false,
      expenses: false
    };

    hasFeatureFlag('quotations-equipments-beta-flag').then(function (flag) {
      vm.hasQuotationsEquipmentsFeatureFlag = flag;
      checkIfShouldShowNewItemsDesign();
    });

    hasFeatureFlag('payments-beta-flag').then(function (flag) {
      vm.hasPaymentsBetaFlag = flag;
    });

    initialize();

    function initialize() {
      vm.identifierType = vm.account.configuration.quotationsIdentifierType;

      if (vm.quotation.id || vm.quotation.copy) {
        vm.quotationProductService.selectedCustomer = vm.quotation.customer;
        vm.selectedCustomer = vm.quotation.customer;
        vm.selectedServiceOrder = vm.quotation.order;
        vm.quotationCreatedAt = vm.quotation.metadata && vm.quotation.metadata.createdAt ? LocalDateConvert.formatDate(vm.quotation.metadata.createdAt, 'date') : null;

        if ((!vm.quotation.metadata || !vm.quotation.metadata.createdAt) && vm.quotation.createdAt) {
          vm.quotationCreatedAt = LocalDateConvert.formatDate(vm.quotation.createdAt, 'date');
        }

        if (vm.quotation.id) {
          vm.quotationProductService.items = vm.quotation.items.map(function (item) {
            item.referenceId = vm.quotation.id + '_' + item.productService.id;
            item.productService.value = item.value;

            return item;
          });

          vm.quotationProductService.quotationEquipments = vm.quotation.quotationEquipments;

          if (vm.quotation.status !== 'pending') {
            vm.quotationProductService.disabled = true;
          }
        }

        if (vm.selectedCustomer && vm.selectedCustomer.contacts && vm.selectedCustomer.contacts.emails) {
          vm.selectedCustomer.contacts.hasEmail = _hasEmails(vm.selectedCustomer.contacts.emails);
        }

        if (!vm.quotation.discount.type) {
          vm.quotation.discount.type = 'percentage';
        }

        if (vm.quotation.discount.type && vm.quotation.discount.value) {
          vm.quotation.discount.value = parseFloat(vm.quotation.discount.value);
          vm.quotation.discount.total = parseFloat(vm.quotation.discount.total);
        }

        if (vm.quotation.copy) {
          vm.serviceOrders = vm.quotation.order ? [vm.quotation.order] : [];
          setTimeout(function () {
            $scope.quotationForm.$setDirty();
            $rootScope.$broadcast('quotation:copied');
            vm.updateTotal();
          }, 100);

          MessageDialog.showToast({
            hideDelay: 10000,
            message: $translate.instant('QUOTATIONS.DIALOG.TOAST.COPIED_QUOTATION')
          });
        }
      }

      if (vm.order) {
        vm.selectedCustomer = vm.order.customer;
        vm.selectedServiceOrder = vm.order;
      }

      if (vm.ticket) {
        vm.selectedCustomer = vm.ticket.customer;
      }

      checkIfShouldShowNewItemsDesign();

      $scope.$on('quotation:update:items', function () {
        vm.updateTotal();
        vm.validateDiscountValue();
      });

      getQuotationsAttachments();
      loadLabels();
      $rootScope.loadingProgress = false;
    }

    function checkIfShouldShowNewItemsDesign() {
      var shouldShow = Boolean(
        vm.isQuotationsWithEquipmentsConfigActive &&
        vm.hasQuotationsEquipmentsFeatureFlag
      );

      vm.shouldShowNewQuotationItemsDesign = shouldShow;
    }

    var updateQuotationLabelsDebounced = _.debounce(updateLabels, 1000);

    function toggleLabel(label) {
      var existingLabelIndex = _.findIndex(vm.quotation.labels, { id: label.id });

      if (existingLabelIndex >= 0) {
        vm.quotation.labels.splice(existingLabelIndex, 1);
      } else {
        vm.quotation.labels.push(label);
      }

      updateQuotationLabelsDebounced(vm.quotation, {
        showToast: true,
        showProgress: true,
        reload: true
      });
    }

    function loadLabels() {
      labelsApi
        .search({ type: 'quotations' }, { limit: 100 })
        .then(function (result) {
          vm.labels = result.items;
        });
    }

    function hasLabel(label) {
      return _.findIndex(vm.quotation.labels, { id: label.id }) >= 0;
    }

    function addNewLabel(newLabel) {
      if (vm.labels.length >= vm.labelsLimit) {
        return $mdToast.show(
          $mdToast.simple()
            .textContent('QUOTATIONS.DIALOG.LABEL.LIMIT_EXCEEDED')
            .hideDelay(6000)
        );
      }

      newLabel.type = 'quotations';
      labelsApi.save(newLabel).then(function () {
        vm.newLabelColor = null;
        vm.newLabelName = null;
        vm.labelTabIndex = 0;
        loadLabels();
      });
    }

    function editLabel(label) {
      vm.editingLabel = label;
      vm.labelTabIndex = 2;
    }

    function updateLabel(label) {
      label.type = 'quotations';
      labelsApi.save(label).then(function () {
        vm.editingLabel = null;
        vm.labelTabIndex = 0;
        loadLabels();
      });
    }

    function filterLabel(label) {
      if (!vm.labelSearchText) {
        return true;
      }

      var labelName = angular.lowercase(label.name);
      var labelSearchText = angular.lowercase(vm.labelSearchText);

      return labelName.indexOf(labelSearchText) >= 0;
    }

    function searchCustomerByName() {
      QuotationCustomer.searchCustomerByName(vm.searchCustomerText)
        .then(function (customers) {
          vm.customers = customers;
        });
    }

    function changedCustomer(selectedCustomer) {
      vm.quotationProductService.selectedCustomer = selectedCustomer;
      var isDifferentCustomer = (selectedCustomer && selectedCustomer.id) !== (vm.selectedServiceOrder && vm.selectedServiceOrder.customer.id);
      if (isDifferentCustomer) {
        vm.selectedServiceOrder = null;
      }

      if (selectedCustomer && !vm.isSendQuotationEmailDisabled(selectedCustomer) && selectedCustomer.contacts && selectedCustomer.contacts.emails) {
        vm.quotation.emailsToSendQuotation = _.map(selectedCustomer.contacts.emails, function (email) {
          return { address: email.address };
        });
      }

      if (selectedCustomer) {
        vm.isServiceOrderRequired = selectedCustomer.metadata && selectedCustomer.metadata.featureQuotationServiceOrderRequired ? true : false;
        vm.isSelectedServiceOrderRequired = vm.isServiceOrderRequired;
      }

      validateQuotationFormGeneralTab();
      $rootScope.$broadcast('quotation:customer:changed');
      $rootScope.$broadcast('quotation:service-order:changed');
    }

    function searchServiceOrderByIdentifier() {
      if (vm.searchServiceOrderIdentifierText && vm.selectedCustomer) {
        QuotationServiceOrder.searchServiceOrderByIdentifier(vm.searchServiceOrderIdentifierText, vm.selectedCustomer)
          .then(function (serviceOrders) {
            vm.serviceOrders = _.map(serviceOrders, function (serviceOrder) {
              serviceOrder.label = serviceOrder && serviceOrder.description ? serviceOrder.identifier + ' - ' + serviceOrder.service.description : serviceOrder.identifier;
              return serviceOrder;
            });
          });
      }
    }

    function changedServiceOrder(selectedServiceOrder) {
      if (selectedServiceOrder) {
        vm.selectedServiceOrder = selectedServiceOrder;
      }
      if (!vm.selectedServiceOrder && vm.quotation.order && vm.quotation.order.id) {
        vm.quotationOrderIdToDelete = vm.quotation.order.id;
        setTimeout(function () {
          $scope.quotationForm.$setDirty();
        }, 100);
      }

      vm.quotationProductService.selectedServiceOrder = selectedServiceOrder || vm.selectedServiceOrder || vm.createdFromQuotation;
      $rootScope.$broadcast('quotation:service-order:changed');

      if (vm.isSelectedServiceOrderRequired && vm.quotationProductService.selectedServiceOrder) {
        vm.isSelectedServiceOrderRequired = false;
      }

      validateQuotationFormGeneralTab();
    }

    function updateLabels(quotation, options) {
      if (!quotation.id) {
        return;
      }

      if (options && options.showProgress) {
        $rootScope.loadingProgress = true;
      }

      var labels = _.map(vm.quotation.labels, function (label) {
        return { id: label.id };
      });

      return quotationsApi.setLabels(quotation.id, labels)
        .then(function () {
          if (options && options.showToast) {
            MessageDialog.showToast({
              hideDelay: 3000,
              message: $translate.instant('QUOTATIONS.DIALOG.TOAST.LABELS_UPDATED')
            });
          }
        })
        .finally(function () {
          if (options && options.showProgress) {
            $rootScope.loadingProgress = false;
          }

          if (options && options.reload) {
            $rootScope.$broadcast('quotations:reload');
          }

        });
    }

    function saveQuotation($event) {
      if (!CheckEditPermission.hasPermission()) {
        vm.closeDialog();
        return;
      }
      $rootScope.loadingProgress = true;
      vm.quotation.customer = vm.selectedCustomer;
      if (vm.selectedServiceOrder) {
        vm.quotation.order = {
          id: vm.selectedServiceOrder.id
        };
      } else {
        delete vm.quotation.order;
      }

      _setupDataToSaveQuotation($event);
    }

    function _setupDataToSaveQuotation($event) {
      vm.quotation.items = vm.quotationProductService.items.map(function (item) {
        return {
          total: String(item.total),
          quantity: item.quantity,
          position: item.position,
          description: item.description ? item.description : null,
          productService: {
            id: item.productService.id,
            name: item.productService.name,
            type: item.type || item.productService.type,
            value: item.productService.value
          },
          equipment: item.equipment ? {
            id: item.equipment.id,
            name: item.equipment.name,
            number: item.equipment.number
          } : null
        };
      });

      vm.quotation.expenses = vm.quotationProductService.expenses;

      vm.quotation.quotationEquipments = vm.quotationProductService.quotationEquipments;

      var hasDiscountValue = vm.quotation.discount.type && !vm.quotation.discount.value;
      vm.quotation.discount.value = hasDiscountValue ? 0 : vm.quotation.discount.value;

      var hasQuotationProductService = vm.quotation.items.length && vm.quotation.items[0].productService;

      if (!hasQuotationProductService && !vm.quotation.expenses.length) {
        return $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
            .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
            .textContent($translate.instant('QUOTATIONS.DIALOG.ALERT.WITHOUT_CONTENT'))
        );
      }

      _editOrSaveQuotation($event);
    }

    function _handleSaveQuotations(quotation) {
      quotation.items = quotation.items.map(function (item) {
        return {
          total: String(item.total),
          quantity: item.quantity,
          position: item.position,
          description: item.description ? item.description : null,
          productService: {
            id: item.productService.id,
            name: item.productService.name,
            type: item.type || item.productService.type,
            value: item.productService.value,
            imageUrl: item.productService.imageUrl
          }
        };
      });

      delete quotation.quotationEquipments;

      return quotationsApi.save(quotation)
        .then(function (createdQuotation) {
          createdQuotation.items = quotation.items;

          if (quotation && quotation.copy) {
            if (vm.attachments && vm.attachments.length >= 1) {
              _saveAttachments(vm.attachments, createdQuotation.id);
            }
          } else {
            if (vm.filesToUpload && vm.filesToUpload.length >= 1) {
              _saveAttachments(vm.filesToUpload, createdQuotation.id);
            }

            if (Quotation && Quotation.attachments && Quotation.attachments.length > 0) {
              vm.filesToUpload = Quotation.attachments;
              _saveAttachments(Quotation.attachments, createdQuotation.id);
            }
          }

          if (!quotation.id) {
            for (var i = 0; i < vm.smartRewriteFields.length; i++) {
              var field = vm.smartRewriteFields[i];
              var params = {
                reference: vm.sessionId,
                referenceType: field,
                updatedReference: createdQuotation.id
              };

              gandalfApi.updateRewriteInputHistory(params);
            }
          }

          for (var i = 0; i < vm.quotationProductService.items.length; i++) {
            var item = vm.quotationProductService.items[i];
            if (!item.sessionId) { continue; }

            for (var j = 0; j < vm.productServiceSmartRewriteFields.length; j++) {
              var field = vm.productServiceSmartRewriteFields[j];
              var params = {
                reference: item.sessionId,
                referenceType: field,
                updatedReference: createdQuotation.id + '_' + item.productService.id
              };

              gandalfApi.updateRewriteInputHistory(params);
            }
          }

          return updateLabels(createdQuotation).then(function () {
            return createdQuotation;
          });
        })
        .then(function (createdQuotation) {
          if (vm.isCreatingQuotationFromTicket) {
            return markTicketAsAccepted(vm.ticket).then(function () {
              return createdQuotation;
            });
          }

          return createdQuotation;
        })
        .then(function (createdQuotation) {
          if (vm.quotationOrderIdToDelete && !vm.selectedServiceOrder) {
            ordersApi.deleteQuotation(vm.quotationOrderIdToDelete, vm.quotation.id);
          }
          MessageDialog.showToast({
            message: $translate.instant('QUOTATIONS.DIALOG.TOAST.SAVED', { quotation: vm.quotation.identifier }),
            hideDelay: 3000
          });

          if (!vm.filesToUpload.length) {
            vm.closeDialog(true, createdQuotation);
            $rootScope.loadingProgress = false;
          }

          if (vm.quotation.emailsToSendQuotation && vm.quotation.emailsToSendQuotation.length && vm.selectedCustomer && !vm.isSendQuotationEmailDisabled(vm.selectedCustomer) && !quotation.id) {
            var emailsToSendQuotationJustString = _.map(vm.quotation.emailsToSendQuotation, function (email) {
              return email.address;
            });

            vm.sendLink(createdQuotation, emailsToSendQuotationJustString);
          }
        })
        .catch(function (result) {
          if (result.data && result.data.code === 'quotation_duplicated_identifier') {
            $scope.vm.selectedTabIndex = 0;
            $scope.quotationForm.identifier.$invalid = true;
            $scope.quotationForm.identifier.$error.identifierExists = true;
          }

          if (result.data && result.data.code === 'quotation_already_approved') {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
                .textContent($translate.instant('QUOTATIONS.DIALOG.ALERT.QUOTATION_ALREADY_APPROVED'))
            );

            vm.closeDialog(true, quotation);
            $rootScope.loadingProgress = false;
            return;
          }

          if (result.data && result.data.err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
                .textContent(result.data.message)
            );

            vm.closeDialog();
          } else {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
                .textContent($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
            );
          }
        })
        .finally(function () {
          if (vm.isCreatingQuotationFromTicket) {
            document.dispatchEvent(new CustomEvent('tickets:reload', { detail: { reload: true } }));
          }
          $rootScope.$broadcast('quotations:reload');
        });
    }

    function _handleSaveQuotationsGraphQL(quotation) {
      var quotationItems = quotation.items;
      var saveOperation = quotation.id ? quotationsApi.update : quotationsApi.create;

      var quotationToSend = angular.copy(quotation);

      quotationToSend.customer = {
        id: quotation.customer && quotation.customer.id
      };

      quotationToSend.order = quotation.order ? {
        id: quotation.order.id
      } : null;

      quotationToSend.ticket = quotation.ticket ? {
        id: quotation.ticket.id
      } : null;

      quotationToSend.equipments = (quotation.quotationEquipments || []).map(function (quotEquipment) {
        return {
          id: quotEquipment.equipment && quotEquipment.equipment.id,
          name: quotEquipment.equipment && quotEquipment.equipment.name,
          number: quotEquipment.equipment && quotEquipment.equipment.number
        };
      });

      quotationToSend.items = quotation.items.map(function (item) {
        var mappedItem = angular.copy(item);

        mappedItem.quantity = parseFloat(item.quantity);
        mappedItem.total = parseFloat(item.total);

        if (mappedItem.productService) {
          mappedItem.productService.value = parseFloat(item.productService.value);
        }

        delete mappedItem.expanded;
        delete mappedItem.productService.type;
        return mappedItem;
      });

      delete quotationToSend.emailsToSendQuotation;
      delete quotationToSend.quotationEquipments;
      delete quotationToSend.createdAt;
      delete quotationToSend.updatedAt;
      delete quotationToSend.attachments;
      delete quotationToSend.copy;
      delete quotationToSend.labels;
      delete quotationToSend.createdBy;

      quotationToSend.expenses = quotation.expenses.map(function (expenses) {
        var mappedExpense = angular.copy(expenses);
        delete mappedExpense.file;
        return mappedExpense;
      });

      if (quotationToSend.id) {
        delete quotationToSend.expenses;
      }

      return saveOperation(quotationToSend)
        .then(function (createdQuotation) {
          createdQuotation.items = quotationItems;

          if (vm.hasPaymentsBetaFlag && createdQuotation.expenses && createdQuotation.expenses.length) {
            createdQuotation.expenses.forEach(function (createdQuotationExpense, index) {
              var quotationExpense = quotation.expenses.find(function (expense) {
                return expense.position === createdQuotationExpense.position;
              });

              if (!quotationExpense || !quotationExpense.file) return;

              setTimeout(function () {
                uploadApi.uploadWithPreSignedPost({
                  file: quotationExpense.file,
                  filePath: '/quotations/' + createdQuotation.id + '/expenses/' + quotationExpense.file.name.replace(/%20| /g, ''),
                  randomize: false,
                  $mdToast: $mdToast,
                  $translate: $translate
                })
                  .then(function (result) {
                    quotationsApi.updateQuotationExpense({
                      id: createdQuotationExpense.id,
                      total: createdQuotationExpense.total,
                      path: result.path
                    });

                    MessageDialog.showToast({
                      hideDelay: 3000,
                      message: $translate.instant('QUOTATIONS.DIALOG.EXPENSES.TOAST.UPDATED_SUCCESSFULLY')
                    });
                  })
                  .catch(function () {
                    MessageDialog.showToast({
                      hideDelay: 3000,
                      message: $translate.instant('QUOTATIONS.DIALOG.EXPENSES.TOAST.UPDATED_FAILED')
                    });
                  })
                  .finally(function () {
                    $rootScope.loadingProgress = false;
                  });
              }, index * 500);
            });
          }

          if (quotation && quotation.copy) {
            if (vm.attachments && vm.attachments.length >= 1) {
              _saveAttachments(vm.attachments, createdQuotation.id);
            }
          } else {
            if (vm.filesToUpload && vm.filesToUpload.length >= 1) {
              _saveAttachments(vm.filesToUpload, createdQuotation.id);
            }

            if (Quotation && Quotation.attachments && Quotation.attachments.length > 0) {
              vm.filesToUpload = Quotation.attachments;
              _saveAttachments(Quotation.attachments, createdQuotation.id);
            }
          }

          if (!quotation.id) {
            for (var i = 0; i < vm.smartRewriteFields.length; i++) {
              var field = vm.smartRewriteFields[i];
              var params = {
                reference: vm.sessionId,
                referenceType: field,
                updatedReference: createdQuotation.id
              };

              gandalfApi.updateRewriteInputHistory(params);
            }
          }

          for (var i = 0; i < vm.quotationProductService.items.length; i++) {
            var item = vm.quotationProductService.items[i];
            if (!item.sessionId) { continue; }

            for (var j = 0; j < vm.productServiceSmartRewriteFields.length; j++) {
              var field = vm.productServiceSmartRewriteFields[j];
              var params = {
                reference: item.sessionId,
                referenceType: field,
                updatedReference: createdQuotation.id + '_' + item.productService.id
              };

              gandalfApi.updateRewriteInputHistory(params);
            }
          }

          return updateLabels(createdQuotation).then(function () {
            return createdQuotation;
          });
        })
        .then(function (createdQuotation) {
          if (vm.isCreatingQuotationFromTicket) {
            return markTicketAsAccepted(vm.ticket).then(function () {
              return createdQuotation;
            });
          }

          return createdQuotation;
        })
        .then(function (createdQuotation) {
          if (vm.quotationOrderIdToDelete && !vm.selectedServiceOrder) {
            ordersApi.deleteQuotation(vm.quotationOrderIdToDelete, vm.quotation.id);
          }

          MessageDialog.showToast({
            message: $translate.instant('QUOTATIONS.DIALOG.TOAST.SAVED', { quotation: vm.quotation.identifier }),
            hideDelay: 3000
          });

          if (!vm.filesToUpload.length) {
            vm.closeDialog(true, createdQuotation);
            $rootScope.loadingProgress = false;
          }

          if (vm.quotation.emailsToSendQuotation && vm.quotation.emailsToSendQuotation.length && vm.selectedCustomer && !vm.isSendQuotationEmailDisabled(vm.selectedCustomer) && !quotation.id) {
            var emailsToSendQuotationJustString = _.map(vm.quotation.emailsToSendQuotation, function (email) {
              return email.address;
            });

            vm.sendLink(createdQuotation, emailsToSendQuotationJustString);
          }
        })
        .catch(function (result) {
          if (result.errors && result.errors.length && result.errors[0] && result.errors[0].extensions && result.errors[0].extensions.code === 'QUOTATION_DUPLICATED_IDENTIFIER') {
            $scope.vm.selectedTabIndex = 0;
            $scope.quotationForm.identifier.$invalid = true;
            $scope.quotationForm.identifier.$error.identifierExists = true;
          }

          if (result.errors && result.errors.length && result.errors[0] && result.errors[0].extensions && result.errors[0].extensions.code === 'QUOTATION_ALREADY_APPROVED') {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
                .textContent($translate.instant('QUOTATIONS.DIALOG.ALERT.QUOTATION_ALREADY_APPROVED'))
            );

            vm.closeDialog(true, quotation);
            $rootScope.loadingProgress = false;
            return;
          }

          if (result.errors && result.errors.length && result.errors[0] && result.errors[0].extensions && result.errors[0].extensions.code) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
                .textContent($translate.instant('QUOTATIONS.DIALOG.ALERT.' + result.errors[0].extensions.code))
            );

            vm.closeDialog();
          } else {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
                .textContent($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
            );
          }
        })
        .finally(function () {
          if (vm.isCreatingQuotationFromTicket) {
            document.dispatchEvent(new CustomEvent('tickets:reload', { detail: { reload: true } }));
          }

          $rootScope.$broadcast('quotations:reload');
        });
    }

    function _editOrSaveQuotation($event) {
      if (vm.quotation.id) {
        quotationsApi.getOne(vm.quotation.id).then(function (quotation) {
          var originalQuotationUpdatedAt = moment(vm.quotation.updatedAt);
          var quotationUpdatedAt = quotation.updatedAt;
          var updatedAtDiff = originalQuotationUpdatedAt.diff(quotationUpdatedAt, 'seconds');

          var hasUpdatedAtDifferenceBetweenQuotations = updatedAtDiff < 0;
          if (hasUpdatedAtDifferenceBetweenQuotations) {
            vm.updatedQuotation = quotation;
            return FcModalService.open($event, {
              title: $translate.instant('QUOTATIONS.DIALOG.GENERAL.IMPORTANT'),
              content: $translate.instant('QUOTATIONS.DIALOG.GENERAL.THIS_QUOTATION_WAS_EDITED'),
              rightButtonText: $translate.instant('QUOTATIONS.DIALOG.GENERAL.LABEL.EDIT'),
              handleRightButton: function () {
                QuotationsDialog.refreshQuotation(vm.updatedQuotation, vm.account, function (reload) {
                  if (reload) {
                    vm.closeDialog();
                  }
                });
              }
            });
          }

          return _handleSaveQuotationsGraphQL(vm.quotation);
        });
      } else {
        if (vm.isCreatingQuotationFromTicket) {
          vm.quotation.ticket = { id: vm.ticket.id };
        }

        return _handleSaveQuotationsGraphQL(vm.quotation);
      }
    }

    function hasFeatureFlag(name) {
      return accountsApi.getCachedAccount().then(function (account) {
        vm.isQuotationsWithEquipmentsConfigActive = account.configuration ? Boolean(account.configuration.quotationsWithEquipmentsOn) : false;

        return accountFeatureFlagsApiGraphQL.getCachedFlagByName(name).then(function (flag) {
          if (!flag) { return false; }

          return flag.active;
        });
      });
    }

    function markTicketAsAccepted(ticket) {
      return ticketsApi.markTicketAsAccepted(ticket.id);
    }

    function customerAccountName(customer) {
      return customer.metadata &&
        customer.metadata.sammathnaur &&
        customer.metadata.sammathnaur.account &&
        customer.metadata.sammathnaur.account.name;
    }

    function isSendQuotationEmailDisabled(customer) {
      if (!customer) { return false; }
      if (!customer.metadata) { return false; }
      return (
        customer.metadata.featureQuotationAccessApprovalLinkDisabled ||
        (customer.metadata.featureApproveQuotationByLink === false)
      );
    }

    function printQuotation(quotation) {
      $timeout(function () {
        $window.open("https://app.fieldcontrol.com.br/relacionamento-cliente/#/orcamentos/" + quotation.id + '?print=true', '_blank');
      }, 1000);
    }

    function promptSendQuotationLink(createdQuotation) {
      var sendQuotationLinkConfirm = $mdDialog.confirm()
        .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
        .title($translate.instant('QUOTATIONS.DIALOG.CONFIRM.TITLE'))
        .textContent($translate.instant('QUOTATIONS.DIALOG.CONFIRM.MESSAGE'))
        .ok($translate.instant('QUOTATIONS.DIALOG.CONFIRM.OK'))
        .cancel($translate.instant('QUOTATIONS.DIALOG.CONFIRM.CANCEL'));

      $mdDialog.show(sendQuotationLinkConfirm)
        .then(function () {
          var allEmails = vm.selectedCustomer.contacts.emails.map(function (email) { return email.address; });
          if (allEmails.length > 0) {
            vm.sendLink(createdQuotation, allEmails);
          }
        });
    }

    function closeDialog(reload, quotation) {
      $mdDialog.hide({
        reload: reload,
        quotation: quotation
      });
    }

    function copyQuotation() {
      var quotationItems = angular.copy(vm.quotationProductService.items);
      var quotationEquipments = angular.copy(vm.quotationProductService.quotationEquipments);
      var quotationAttachments = angular.copy(vm.attachments);

      if (quotationItems.length) {
        var subtotalValues = _.map(quotationItems, function (item) {
          return item.total;
        }).reduce(function (total, num) { return total + num; });
      }

      var newQuotation = {
        customer: vm.quotation.customer,
        name: vm.quotation.name ? vm.quotation.name : '',
        description: vm.quotation.description,
        additionalInformation: vm.quotation.additionalInformation,
        expiredAt: moment().add(7, 'd').toDate(),
        subtotal: subtotalValues ? subtotalValues : 0,
        total: subtotalValues && vm.quotation.discount.total ? subtotalValues - vm.quotation.discount.total : 0,
        approvedBy: null,
        approvedAt: null,
        approvedSignature: null,
        refusedAt: null,
        items: _.map(quotationItems, function (item) {
          delete item.id;
          delete item.quotation;
          delete item.metadata;
          delete item.searchItemText;
          delete item.newProductService;
          return item;
        }),
        quotationEquipments: quotationEquipments || [],
        attachments: _.map(quotationAttachments, function (attachment) {
          Reflect.deleteProperty(attachment, 'id');
          Reflect.deleteProperty(attachment, 'createdAt');

          Reflect.defineProperty(attachment, 'id', { value: msUtils.uuidGenerator() });
          Reflect.defineProperty(attachment, 'createdAt', { value: moment().toISOString() });

          return attachment;
        }),
        labels: angular.copy(vm.quotation.labels || []),
        status: 'pending',
        archived: false,
        discount: vm.quotation.discount && vm.quotation.discount.type ? vm.quotation.discount : {
          type: 'percentage',
          value: 0,
          total: 0
        },
        emailsToSendQuotation: [],
        copy: true,
        order: vm.quotation.order ? vm.quotation.order : null
      };

      if (vm.selectedCustomer && !vm.isSendQuotationEmailDisabled(vm.selectedCustomer) && vm.selectedCustomer.contacts && vm.selectedCustomer.contacts.emails) {
        newQuotation.emailsToSendQuotation = _.map(vm.selectedCustomer.contacts.emails, function (email) {
          return { address: email.address };
        });
      }

      QuotationsDialog.copyQuotation(newQuotation, function (reload, quotation) {
        if (quotation) {
          document.dispatchEvent(new CustomEvent('QuotationCreated', { detail: { quotation: quotation } }));
        }
      });
    }

    function updateTotal() {
      var items = vm.quotationProductService.items || [];
      var expenses = vm.quotationProductService.expenses || [];
      vm.quotation.subtotal = 0;
      vm.expensesTotalValue = 0;
      vm.quotation.total = 0;

      var discountTypesMapper = {
        'percentage': function () {
          vm.quotation.discount.total = (getSubtotal() * parseFloat(discountValue) / 100);
        },
        'value': function () {
          vm.quotation.discount.total = parseFloat(discountValue);
        }
      };

      if (items.length) {
        for (var index = 0; index < items.length; index++) {
          if (items[index].total) {
            vm.quotation.subtotal += parseFloat(items[index].total);
          }
        }
      }

      if (vm.hasPaymentsBetaFlag && expenses.length) {
        for (var index = 0; index < expenses.length; index++) {
          if (expenses[index].total) {
            vm.expensesTotalValue += parseFloat(expenses[index].total);
          }
        }

        vm.quotation.total += vm.expensesTotalValue;
      }

      var discountValue = parseFloat(vm.quotation.discount.value || 0);
      if (vm.quotation.discount.type) {
        discountTypesMapper[vm.quotation.discount.type]();
      }

      vm.quotation.total = getSubtotal() - vm.quotation.discount.total;
    }

    function validateDiscountValue() {
      if (vm.quotation && vm.quotation.discount && vm.quotation.discount.value !== undefined && getSubtotal()) {
        var value = parseFloat(vm.quotation.discount.value || 0);

        if (vm.quotation.discount.type === 'percentage') {
          vm.formErr['errorValueDiscount'] = value > 100 || value < 0 || !(/^[0-9.,]+$/.test(value)) || JSON.stringify(value).includes('-');
        }

        if (vm.quotation.discount.type === 'value') {
          vm.formErr['errorValueDiscount'] = value > getSubtotal() || value < 0;
        }

        if (vm.quotation.subtotal || vm.expensesTotalValue) {
          vm.updateTotal();
        }
      }
    }

    function getSubtotal() {
      var subtotal = vm.quotation.subtotal;

      if (vm.hasPaymentsBetaFlag) {
        subtotal += vm.expensesTotalValue;
      }

      return subtotal;
    }

    function changeDiscountType(discountOption) {
      var hasDiscountLabel = discountOption && discountOption.label;
      vm.quotation.discount.type = hasDiscountLabel ? discountOption.label : vm.quotation.discount.type;

      vm.validateDiscountValue();
    }

    function validateItems() {
      vm.quotation.items = vm.quotationProductService.items;
      var itemWithoutId = _.find(vm.quotation.items, function (item) {
        return !item.productService || !item.productService.id;
      });
      return (itemWithoutId && !vm.quotationProductService.expenses.length) ? false : true;
    }

    function unarchiveQuotation() {
      vm.quotation.archived = false;
      _unarchiveQuotation();
    }

    function archiveQuotation() {
      vm.quotation.archived = true;
      _archiveQuotation();
    }

    function cancelQuotation() {
      var cancelQuotationConfirm = $mdDialog.confirm()
        .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
        .title($translate.instant('QUOTATIONS.DIALOG.CANCEL.TITLE'))
        .textContent($translate.instant('QUOTATIONS.DIALOG.CANCEL.MESSAGE'))
        .ok($translate.instant('QUOTATIONS.DIALOG.CANCEL.YES'))
        .cancel($translate.instant('QUOTATIONS.DIALOG.CANCEL.NO'));

      vm.quotation.refusedAt = moment().utc().format();
      vm.quotation.status = 'canceled';

      $mdDialog.show(cancelQuotationConfirm).then((!vm.hasQuotationsEquipmentsFeatureFlag || !vm.isQuotationsWithEquipmentsConfigActive) ? _updateQuotation : _updateQuotationGraphQL);
    }

    function clearSelectedServiceOrder() {
      vm.selectedServiceOrder = null;
    }

    function showToastWhileCopyLink(identifier) {
      MessageDialog.showToast({
        hideDelay: 10000,
        message: $translate.instant('QUOTATIONS.DIALOG.TOAST.LINK_COPIED_MESSAGE', {
          id: identifier
        })
      });
    }

    function sendSpecificEmail(quotation, myForm) {
      if (quotation && myForm) {
        vm.sendLink(quotation, [myForm.$viewValue], $translate.instant('QUOTATIONS.DIALOG.TOAST.SPECIFIC_LINK_SENDED', { customerEmail: myForm.$viewValue }));
        myForm.$setValidity('sended', false);
      }
    }

    function sendLink(quotation, emails, message) {
      if (!emails.length) { return; }
      quotationsApi.sendLink(quotation.id, emails)
        .then(function () {
          MessageDialog.showToast({
            hideDelay: 10000,
            message: message ? message : $translate.instant('QUOTATIONS.DIALOG.TOAST.LINK_SENDED', { customerName: quotation.customer.name })
          });
        });
    }

    function addEmailToSendQuotation() {
      vm.quotation.emailsToSendQuotation.push({ address: '' });
    }

    function deleteEmailToSendQuotation(emailFieldIndex) {
      vm.quotation.emailsToSendQuotation = _.filter(vm.quotation.emailsToSendQuotation, function (email, index) {
        return index !== emailFieldIndex;
      });
    }

    function _hasEmails(emails) {
      if (emails && emails.length) {
        for (var i = 0; i < emails.length; i++) {
          if (emails[i].address) {
            return true;
          }
        }
      }
      return false;
    }

    function _archiveQuotation() {
      quotationsApi.archive(vm.quotation.id)
        .then(function (updatedQuotation) {
          MessageDialog.showToast({
            message: $translate.instant('QUOTATIONS.DIALOG.TOAST.SAVED', { quotation: vm.quotation.identifier }),
            hideDelay: 3000
          });

          vm.closeDialog(true, updatedQuotation);
        })
        .catch(function (result) {
          if (result.data.err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
                .textContent(result.data.message)
            );

            vm.closeDialog();
          }
        })
        .finally(function () {
          $rootScope.$broadcast('quotations:reload');
          $rootScope.loadingProgress = false;
        });
    }

    function _unarchiveQuotation() {
      quotationsApi.unarchive(vm.quotation.id)
        .then(function (updatedQuotation) {
          MessageDialog.showToast({
            message: $translate.instant('QUOTATIONS.DIALOG.TOAST.SAVED', { quotation: vm.quotation.identifier }),
            hideDelay: 3000
          });

          vm.closeDialog(true, updatedQuotation);
        })
        .catch(function (result) {
          if (result.data.err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
                .textContent(result.data.message)
            );

            vm.closeDialog();
          }
        })
        .finally(function () {
          $rootScope.$broadcast('quotations:reload');
          $rootScope.loadingProgress = false;
        });
    }

    function _updateQuotation() {
      vm.quotation.items = vm.quotation.items.map(function (item) {
        delete item.searchItemText;
        delete item.newProductService;
        delete item.referenceId;
        delete item.sessionId;
        delete item.equipment;
        return item;
      });

      delete vm.quotation.discount;
      delete vm.quotation.order;
      delete vm.quotation.quotationEquipments;

      quotationsApi.save(vm.quotation)
        .then(function (updatedQuotation) {
          MessageDialog.showToast({
            message: $translate.instant('QUOTATIONS.DIALOG.TOAST.SAVED', { quotation: vm.quotation.identifier }),
            hideDelay: 3000
          });

          document.dispatchEvent(new CustomEvent('QuotationUpdated', { detail: { quotation: updatedQuotation } }));
          vm.closeDialog(true, updatedQuotation);
        })
        .catch(function (result) {
          if (result.data.err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
                .textContent(result.data.message)
            );

            vm.closeDialog();
          }
        })
        .finally(function () {
          $rootScope.$broadcast('quotations:reload');
          $rootScope.loadingProgress = false;
        });
    }

    function _updateQuotationGraphQL() {
      vm.quotation.items = vm.quotation.items.map(function (item) {
        delete item.searchItemText;
        delete item.newProductService;
        delete item.referenceId;
        delete item.sessionId;
        return item;
      });

      delete vm.quotation.discount;
      delete vm.quotation.order;

      var quotationToSend = angular.copy(vm.quotation);

      quotationToSend.customer = {
        id: vm.quotation.customer && vm.quotation.customer.id
      };

      quotationToSend.order = vm.quotation.order ? {
        id: vm.quotation.order.id
      } : null;

      quotationToSend.ticket = vm.quotation.ticket ? {
        id: vm.quotation.ticket.id
      } : null;

      quotationToSend.equipments = (vm.quotation.quotationEquipments || []).map(function (quotEquipment) {
        return {
          id: quotEquipment.equipment && quotEquipment.equipment.id,
          name: quotEquipment.equipment && quotEquipment.equipment.name,
          number: quotEquipment.equipment && quotEquipment.equipment.number
        };
      });

      quotationToSend.items = vm.quotation.items.map(function (item) {
        var mappedItem = angular.copy(item);

        mappedItem.quantity = parseFloat(item.quantity);
        mappedItem.total = parseFloat(item.total);

        if (mappedItem.productService) {
          mappedItem.productService.value = parseFloat(item.productService.value);
        }

        var mappedResponse = {
          id: mappedItem.id,
          quantity: mappedItem.quantity,
          position: mappedItem.position,
          equipment: mappedItem.equipment ? {
            id: mappedItem.equipment.id,
            name: mappedItem.equipment.name,
            number: mappedItem.equipment.number
          } : null,
          total: mappedItem.total,
          productService: {
            id: mappedItem.productService && mappedItem.productService.id,
            value: mappedItem.productService && mappedItem.productService.value,
            name: mappedItem.productService && mappedItem.productService.name
          }
        };

        if (mappedItem.equipment) {
          mappedResponse.equipment = {
            id: mappedItem.equipment.id,
            name: mappedItem.equipment.name,
            number: mappedItem.equipment.number
          };
        }

        return mappedResponse;
      });

      delete quotationToSend.emailsToSendQuotation;
      delete quotationToSend.quotationEquipments;
      delete quotationToSend.createdAt;
      delete quotationToSend.updatedAt;
      delete quotationToSend.attachments;
      delete quotationToSend.copy;
      delete quotationToSend.labels;
      delete quotationToSend.createdBy;
      delete quotationToSend.expenses;

      quotationsApi.update(quotationToSend)
        .then(function (updatedQuotation) {
          MessageDialog.showToast({
            message: $translate.instant('QUOTATIONS.DIALOG.TOAST.SAVED', { quotation: vm.quotation.identifier }),
            hideDelay: 3000
          });

          document.dispatchEvent(new CustomEvent('QuotationUpdated', { detail: { quotation: updatedQuotation } }));
          vm.closeDialog(true, updatedQuotation);
        })
        .catch(function (result) {
          if (result.errors && result.errors.length && result.errors[0] && result.errors[0].extensions && result.errors[0].extensions.code) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('QUOTATIONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('QUOTATIONS.DIALOG.ALERT.OK'))
                .textContent(result.errors[0].extensions.code)
            );

            vm.closeDialog();
          }
        })
        .finally(function () {
          $rootScope.$broadcast('quotations:reload');
          $rootScope.loadingProgress = false;
        });
    }

    function validateQuotationFormGeneralTab() {
      var fieldQuotationFormValidateMapper = [
        'customer',
        'identifier',
        'expiredAt',
        'quotationName'
      ];

      _.defer(function () {
        $scope.$apply(function () {
          var quotationFormTabGeneralInvalid = fieldQuotationFormValidateMapper.map(function (field) {
            return $scope.quotationForm[field].$valid;
          }).includes(false);

          vm.isValidQuotationFormTabGeneral = !quotationFormTabGeneralInvalid;
        });
      });
    }

    function discardQuotation(ev) {
      if ($scope.quotationForm.$dirty) {
        FcModalService.open(ev, {
          title: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.QUESTION_DATA_LOSS_TITLE'),
          content: $translate.instant(vm.hasPaymentsBetaFlag ? 'QUOTATIONS.DIALOG.ACTIONS.WARNINGS.QUESTION_DATA_LOSS_CONTENT_WITH_EXPENSES' : 'QUOTATIONS.DIALOG.ACTIONS.WARNINGS.QUESTION_DATA_LOSS_CONTENT'),
          leftButtonText: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.QUESTION_DATA_LOSS_NO'),
          rightButtonText: $translate.instant('QUOTATIONS.DIALOG.ACTIONS.WARNINGS.QUESTION_DATA_LOSS_YES'),
          handleRightButton: vm.closeDialog
        });
      } else {
        vm.closeDialog();
      }

    };

    function removeFile(index) {
      vm.files.splice(index, 1);
    }

    function fakeUpload() {
      if (vm.attachments.length + vm.files.length > vm.attachmentsLimit) {
        _showErrorToast('QUOTATIONS.DIALOG.ATTACHMENTS.ERROR_MESSAGE_MAX_FILES_REMOVE');
        return null;
      }
      var attachmentsWithPreviews = _createAttachmentsWithPreviews(vm.files);
      attachmentsWithPreviews.forEach(function (attachmentWithPreview) {
        var attachmentToCreate = QuotationAttachmentsService.createFakeAttachment(attachmentWithPreview, vm.attachments.length);
        vm.attachments.push(attachmentToCreate);
      });
      vm.files = [];
      return null;
    };

    function uploadImages() {
      var upload = function () {
        if (!(vm.files && vm.files.length)) { return null; }
        if (!vm.quotation.id) { return fakeUpload(); }

        var itWillExceedLimit = (vm.attachments.length + vm.files.length) > vm.attachmentsLimit;
        if (itWillExceedLimit) {
          _showErrorToast('QUOTATIONS.DIALOG.ATTACHMENTS.ERROR_MESSAGE_MAX_FILES_REMOVE');
          return;
        }

        _saveAttachments(vm.files, vm.quotation.id);
      };
      return upload();
    }

    function getQuotationsAttachments() {
      vm.loadingAttachments = false;
      if (Quotation && Quotation.attachments) {
        vm.attachments = Quotation.attachments;
        return;
      }

      if (!vm.quotation.id) {
        vm.attachments = [];
        return;
      }

      vm.loadingAttachments = true;
      quotationsAttachmentsApi.getQuotationsAttachments(vm.quotation.id).then(function (result) {
        vm.loadingAttachments = false;
        vm.attachments = result;
      }).finally(function () {
        vm.loadingAttachments = false;
      });
    }

    function deleteAttachment(attachmentId, position, ev) {
      FcModalService.open(ev, {
        title: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.DELETE_MODAL.TITLE'),
        content: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.DELETE_MODAL.CONTENT'),
        leftButtonText: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.YES'),
        rightButtonText: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.NO'),
        handleLeftButton: function () {
          vm.attachments = vm.attachments.filter(function (attachment) {
            return attachment.id !== attachmentId;
          });

          vm.attachments.forEach(function (attachment) {
            if (attachment.position > position) {
              attachment.position--;
            }
          });

          if (!vm.quotation.id) {
            _showSuccessToast('QUOTATIONS.DIALOG.ATTACHMENTS.DELETE_MODAL.SUCCESS_MESSAGE');
            return;
          }

          quotationsAttachmentsApi.deleteQuotationsAttachment(vm.quotation.id, attachmentId)
            .catch(function () {
              _showErrorToast('QUOTATIONS.DIALOG.ATTACHMENTS.ERROR_MESSAGE');
            })
            .finally(function () {
              _showSuccessToast('QUOTATIONS.DIALOG.ATTACHMENTS.DELETE_MODAL.SUCCESS_MESSAGE');
              document.dispatchEvent(new CustomEvent('AttachmentUpdated', { detail: { attachmentId: attachmentId } }));
            });
        }
      });
    }

    function archiveAttachment(attachmentId, archived, ev) {
      FcModalService.open(ev, {
        title: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.ARCHIVE_MODAL.'.concat(archived ? 'ARCHIVE_TITLE' : 'UNARCHIVE_TITLE')),
        content: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.ARCHIVE_MODAL.'.concat(archived ? 'ARCHIVE_CONTENT' : 'UNARCHIVE_CONTENT')),
        leftButtonText: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.YES'),
        rightButtonText: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.NO'),
        handleLeftButton: function () {
          var messageSuffix = archived ? 'SUCCESS_MESSAGE' : 'SUCCESS_UNARCHIVE_MESSAGE';
          vm.attachments = vm.attachments.map(function (attachment) {
            if (attachment.id === attachmentId) {
              attachment.archived = archived;
            }
            return attachment;
          });

          if (!vm.quotation.id) {
            _showSuccessToast('QUOTATIONS.DIALOG.ATTACHMENTS.ARCHIVE_MODAL.' + messageSuffix);
            return;
          }

          quotationsAttachmentsApi.updateQuotationsAttachment(vm.quotation.id, attachmentId, archived)
            .catch(function () {
              _showErrorToast('QUOTATIONS.DIALOG.ATTACHMENTS.ERROR_MESSAGE');
            })
            .finally(function () {
              _showSuccessToast('QUOTATIONS.DIALOG.ATTACHMENTS.ARCHIVE_MODAL.' + messageSuffix);
            });
        }
      });
    }

    function renameAttachment(attachmentId, title, ev) {
      vm.renameTitle = title || '';
      FcModalService.open(ev, {
        title: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.RENAME_MODAL.TITLE'),
        templateUrl: 'app/main/quotations/dialogs/tabs/attachments/template/rename-attachment-template.html',
        rightButtonText: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.SAVE'),
        leftButtonText: $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.CANCEL'),
        variables: {
          renameTitle: vm.renameTitle,
          handleTitleChange: function (title) {
            if (!title) {
              document.querySelector('.fc-modal__button--right-button').setAttribute('disabled', true);
              return;
            }
            document.querySelector('.fc-modal__button--right-button').removeAttribute('disabled');
            vm.renameTitle = title;
          }
        },
        handleRightButton: function () {
          if (!vm.renameTitle) {
            vm.renameTitle = $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.NO_TITLE');
          }

          if (vm.renameTitle.length > 100) {
            _showErrorToast('QUOTATIONS.DIALOG.ATTACHMENTS.RENAME_MODAL.ERROR_MESSAGE');
            vm.renameTitle = '';
            return;
          }

          vm.attachments = vm.attachments.map(function (attachment) {
            if (attachment.id === attachmentId) {
              attachment.title = vm.renameTitle;
            }
            return attachment;
          });

          if (!vm.quotation.id) {
            vm.renameTitle = '';
            _showSuccessToast('QUOTATIONS.DIALOG.ATTACHMENTS.RENAME_MODAL.SUCCESS_MESSAGE');
            return;
          }

          quotationsAttachmentsApi.updateQuotationsAttachment(vm.quotation.id, attachmentId, undefined, vm.renameTitle)
            .catch(function () {
              _showErrorToast('QUOTATIONS.DIALOG.ATTACHMENTS.ERROR_MESSAGE');
            })
            .finally(function () {
              vm.renameTitle = '';
              _showSuccessToast('QUOTATIONS.DIALOG.ATTACHMENTS.RENAME_MODAL.SUCCESS_MESSAGE');
            });
        }
      });
    }

    function openOriginal(attachmentPath) {
      $window.open(attachmentPath);
    }

    function moveAttachmentDown(attachmentId, position) {
      vm.loadingAttachments = true;
      var nextAttachment = _findNextAttachment(position);

      if (!attachmentId || !nextAttachment.id) {
        _showErrorToast('QUOTATIONS.DIALOG.ATTACHMENTS.ERROR_MESSAGE');
        vm.loadingAttachments = false;
        return;
      }

      vm.attachments = QuotationAttachmentsService.reorderAttachments('down', attachmentId, nextAttachment.id, vm.attachments);
      vm.loadingAttachments = false;

      if (!vm.quotation.id) { return; }

      quotationsAttachmentsApi.reorderAttachments(vm.quotation.id, attachmentId, position, 'down');
    }

    function moveAttachmentUp(attachmentId, position) {
      vm.loadingAttachments = true;
      var previousAttachment = _findPreviousAttachment(position);

      if (!attachmentId || !previousAttachment.id) {
        _showErrorToast('QUOTATIONS.DIALOG.ATTACHMENTS.ERROR_MESSAGE');
        vm.loadingAttachments = false;
        return;
      }

      vm.attachments = QuotationAttachmentsService.reorderAttachments('up', attachmentId, previousAttachment.id, vm.attachments);
      vm.loadingAttachments = false;

      if (!vm.quotation.id) { return; }

      quotationsAttachmentsApi.reorderAttachments(vm.quotation.id, attachmentId, position, 'up');
    }

    function _createAttachmentsWithPreviews(files) {
      return files.map(function (file, index) {
        vm.filesToUpload.push(file);
        return {
          type: file.type,
          position: ++index,
          archived: false,
          fullPath: URL.createObjectURL(file) || '',
          file: file
        };
      });
    }

    function _saveAttachments(filesToUpload, quotationId) {
      $rootScope.loadingProgress = true;

      var totalUploadsFilesCount = filesToUpload.length;
      var currentUploadsFilesCount = 0;
      var filesToCreate = [];

      var alreadyUploadedAttachments = filesToUpload.filter(function (attachment) {
        return attachment && attachment.path && attachment.path.includes(vm.awsAttachmentsPath);
      });

      if (alreadyUploadedAttachments.length) {
        quotationsAttachmentsApi.createQuotationAttachments(quotationId, alreadyUploadedAttachments).then(function (response) {
          vm.attachments = vm.attachments.concat(response);
        }).finally(function () {
          _resetUploadState(quotationId);
        });
      }

      filesToUpload = filesToUpload.filter(function (attachment) {
        return !(attachment && attachment.path && attachment.path.includes(vm.awsAttachmentsPath));
      }).map(function (attachment) {
        return attachment.file || attachment;
      });

      filesToUpload.forEach(function (attachment) {
        var attachmentName = attachment && attachment.name && attachment.name.replace(/%20| /g, '');
        uploadApi.uploadWithPreSignedPost({
          file: attachment,
          filePath: '/quotations/' + quotationId + '/attachments/' + attachmentName
        }).then(function (response) {
          currentUploadsFilesCount++;
          filesToCreate.push(_createFileToSave(response, attachment));

          if (currentUploadsFilesCount === totalUploadsFilesCount) {
            quotationsAttachmentsApi.createQuotationAttachments(quotationId, filesToCreate).then(function (response) {
              vm.attachments = vm.attachments.concat(response);
            }).finally(function () {
              _resetUploadState(quotationId);
            });
          }
        });
      });
    }

    function _resetUploadState(quotationId) {
      vm.filesToUpload = [];
      vm.files = [];
      vm.uploadProgress = false;
      $rootScope.loadingProgress = false;
      vm.closeDialog(true, {
        id: quotationId,
        identifier: vm.quotation.identifier,
        name: vm.quotation.name,
        status: vm.quotation.status,
        description: vm.quotation.description,
        additionalInformation: vm.quotation.additionalInformation,
        approvedMessage: vm.quotation.approvedMessage,
        attachments: vm.attachments,
        subtotal: vm.quotation.subtotal,
        total: vm.quotation.total,
        expiredAt: vm.quotation.expiredAt,
        refusedAt: vm.quotation.refusedAt,
        approvedAt: vm.quotation.approvedAt,
        approvedBy: vm.quotation.approvedBy,
        approvedSignature: vm.quotation.approvedSignature,
        items: vm.quotation.items,
        quotationEquipments: vm.quotation.quotationEquipments || [],
        discount: vm.quotation.discount,
        archived: vm.quotation.archived,
        createdBy: vm.quotation.createdBy,
        emailsToSendQuotation: vm.quotation.emailsToSendQuotation,
        labels: vm.quotation.labels,
      });
    }

    function _findNextAttachment(position) {
      return vm.attachments.find(function (attachment) {
        return attachment.position === position + 1;
      });
    }

    function _findPreviousAttachment(position) {
      return vm.attachments.find(function (attachment) {
        return attachment.position === position - 1;
      });
    }

    function _showSuccessToast(translationString) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent($translate.instant(translationString))
          .theme('success-toast')
          .hideDelay(5000)
      );
    }

    function _showErrorToast(translationString) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent($translate.instant(translationString))
          .theme('error-toast-v2')
          .hideDelay(5000)
      );
    }

    function _createFileToSave(response, attachment) {
      return {
        path: vm.awsAttachmentsPath + response.path,
        type: response.contentType,
        title: attachment.title || $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.NO_TITLE'),
        archived: attachment.archived || false,
      };
    }

    function createTaskWithSelectedQuotation(ev) {
      var selectedCustomer = vm.selectedCustomer;
      var data = {
        origin: 'quotation',
        customer: selectedCustomer,
        description: vm.quotation.description,
        items: vm.quotation.items,
        quotationEquipments: vm.quotation.quotationEquipments || [],
        contacts: selectedCustomer.contacts,
        _hooks: {
          onSaved: function (savedOrderResponse) {
            if (vm.quotation.id) {
              $scope.quotationForm.$setValidity();
              $scope.quotationForm.$setDirty();
            }

            if (!savedOrderResponse || !savedOrderResponse.order || !savedOrderResponse.order.id) {
              return;
            }

            var orderId = savedOrderResponse.order.id;
            return ordersApi.get(orderId).then(function (result) {
              changedServiceOrder(result);
            });
          }
        }
      };

      OrderDialog.createTask(ev, data, null, vm.addPermission);
    }

    function showIntegrationButton() {
      return vm.integrations.omie;
    }

    function openIntegrationDialog($event) {
      FcModalService.open($event, {
        title: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.ACCOUNT'),
        content: $translate.instant('TASKS.DIALOG.ACTIONS.SELECT_THE_ACCOUNT'),
        paddingSmall: true,
        hasOmieAccountSelector: true,
        rightContinueButton: true,
        rightButtonText: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'),
        leftButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
        handleRightButton: function (account) {
          QuotationsExportDialog.openExportQuotationDialog({
            selectedAccount: account,
            quotation: vm.quotation,
            appName: 'Omie',
            $event: $event,
            target: document.querySelector('.palantir-modal-container') || angular.element(document.body)
          });
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('ProductsMeasuresOptions', ProductsMeasuresOptions);

  /** @ngInject */
  function ProductsMeasuresOptions(_, $translate) {
    var measures = [
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.UNITY'), value: 'unity' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.CENTIMETER'), value: 'centimeter' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.METER'), value: 'meter' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.LITER'), value: 'liter' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.MILLILITER'), value: 'milliliter' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.KILOGRAM'), value: 'kilogram' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.GRAM'), value: 'gram' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.SQUARE_METERS'), value: 'square-meters' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.CUBIC_METERS'), value: 'cubic-meters' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.TONS_REFRIGERATION'), value: 'tons-refrigeration' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.DISLOCATION'), value: 'dislocation' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.CJT'), value: 'cjt' },
      { translate: $translate.instant('PRODUCTS_SERVICES.MODEL.MEASURES.OTHERS'), value: 'others' },
    ];

    return {
      measures: measures
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('ProductsMeasuresOptions', ProductsMeasuresOptions);

  /** @ngInject */
  function ProductsMeasuresOptions(_, $translate) {
    var measures = [
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.UNITY'), value: 'unity' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.CENTIMETER'), value: 'centimeter' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.METER'), value: 'meter' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.LITER'), value: 'liter' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.MILLILITER'), value: 'milliliter' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.KILOGRAM'), value: 'kilogram' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.GRAM'), value: 'gram' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.SQUARE_METERS'), value: 'square-meters' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.CUBIC_METERS'), value: 'cubic-meters' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.TONS_REFRIGERATION'), value: 'tons-refrigeration' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.DISLOCATION'), value: 'dislocation' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.CJT'), value: 'cjt' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.OTHERS'), value: 'others' }
    ];

    return {
      measures: measures
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.products')
    .factory('ProductsDialog', ProductsDialog);

  /** @ngInject */
  function ProductsDialog($mdDialog, $rootScope, productsServicesApi, $document, $q) {

    return {
      createService: createService,
      editProduct: editProduct
    };

    function createService(ev, callback) {
      _openDialog(ev, {
        ProductService: null,
        From: null
      }, callback);
    }

    function editProduct(ev, params, callback) {
      $rootScope.loadingProgress = true;

      var requests = {
        productService: productsServicesApi.getOne(params.id, {})
      };

      $q.all(requests).then(function (result) {
        _openDialog(ev, {
          ProductService: result.productService,
          From: params.from ? params.from : null
        }, callback);

      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function _openDialog(ev, locals, callback) {
      $mdDialog.show({
        controller: 'ProductsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/products/dialogs/products-dialog.html',
        parent: document.querySelector('.palantir-modal-container') || angular.element($document.body),
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload, productService) {
        if (callback) {
          callback(reload, productService);
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.products')
    .controller('ProductsDialogController', ProductsDialogController);

  /** @ngInject */
  function ProductsDialogController(
    $translate, $rootScope, $mdDialog, productTypesApiGraphQL,
    $mdToast, $locale, ProductService, From, omieApi, $q,
    productsServicesApi, gandalfApi, FcModalService,
    $scope, msUtils, uploadApi, ProductsMeasuresDialogOptions,
    $timeout, storageProductsApiGraphQL, accountCache,
    storagesMovementsApiGraphQL, CurrencyService
  ) {
    var vm = this;
    vm.currencySymbol = CurrencyService.currencySymbol;
    $locale.NUMBER_FORMATS.CURRENCY_SYM = vm.currencySymbol;
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
    $locale.NUMBER_FORMATS.GROUP_SEP = '.';

    vm.product = angular.copy(ProductService);
    vm.storageProducts = [];
    vm.from = angular.copy(From) || null;
    vm.hasStockModule = false;
    vm.isValidStorageProductForm = true;
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['product-description'];

    vm.closeDialog = closeDialog;
    vm.generateQRCode = generateQRCode;
    vm.viewQRCode = viewQRCode;
    vm.saveProduct = saveProduct;
    vm.selectImage = selectImage;
    vm.unarchiveProduct = unarchiveProduct;
    vm.archiveProduct = archiveProduct;
    vm.verifyDuplicatedProductCode = verifyDuplicatedProductCode;
    vm.validateProductForm = validateProductForm;

    function _initialize() {
      vm.measuresSelectOptions = ProductsMeasuresDialogOptions.measures;
      vm.productResultImageFile = null;
      vm.productTypesSelectOptions = [];

      accountCache.loadAccount().then(function (account) {
        vm.hasStockModule =
          (account &&
            account.configuration &&
            account.configuration.moduleStorageControlEnabled);
      });

      if (!vm.product) {
        vm.product = {
          name: '',
          type: 'product',
          value: '',
          archived: false,
          description: '',
          imageUrl: '',
          code: '',
          qrCode: '',
          measure: '',
          productType: {
            id: '',
            name: ''
          }
        };
        vm.newProduct = true;
      }

      if (vm.product && vm.product.externalAppId) {
        var deferred = $q.defer();

        omieApi.accounts.list()
          .then(function (res) {

            if (!res.data || !res.data.Items || !res.data.Items.length) {
              deferred.resolve({
                name: null,
                appId: null
              });
              return;
            }


            var account = _.find(res.data.Items, { appId: vm.product.externalAppId });

            deferred.resolve(account);
          })
          .catch(function (error) {
            deferred.reject(error);
          });

        deferred.promise.then(function (account) {
          vm.omieAccount = account ? account.accountName : null;
        });
      }

      productTypesApiGraphQL
      .queryForDatatable({
        where: {
          archived: false
        },
        orderBy: 'name_desc',
        take: 1000,
        skip: 0
      })
      .then(function (result) {

        if (result && result.items && result.items.length) {
          _.forEach(result.items, function (item) {
            var productType = {
              value: {
                name: item.name,
                id: item.id.toString()
              }
            };

            vm.productTypesSelectOptions.push(productType);
          });

          if (vm.product && vm.product.id) {
            var foundProductType = _.find(vm.productTypesSelectOptions, function (item) {
              if (vm.product.productType) {
                return item.value.id === vm.product.productType.id;
              }
            });

            vm.product.productType = foundProductType ? foundProductType.value : null;
          }
        }
      });

      _initializeStorageProducts();
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload, vm.product);
    }

    function downloadQRCode() {
      var download = document.getElementById('productDownloadLink');
      var image = document.querySelector('#product-qrcode-download canvas').toDataURL('image/png').replace('image/png', 'image/octet-stream');
      download.setAttribute("href", image);
    }

    function generateQRCode() {
      vm.product.qrCode = msUtils.uuidGenerator();
      vm.existingProductWithQRCode = (vm.product && vm.product.id && vm.product.qrCode);
      var qrcodeGeneratorModalId = msUtils.uuidGenerator();
      $scope.productForm.$setDirty();

      FcModalService.open(null, {
        title:  $translate.instant('PRODUCTS.MODEL.QR_CODE.MODAL.GENERATE'),
        templateUrl: 'app/main/products/dialogs/modal/qrcode-generator.html',
        modalId: qrcodeGeneratorModalId,
        eventNameToSubscribe: 'products-qrcodes',
        closeButtonIconPath: 'assets/icons/icon-close.svg',
        variables: {
          title: $translate.instant('PRODUCTS.MODEL.QR_CODE.MODAL.GENERATE'),
          product: vm.product,
        },
        buttonFlex: true,
        buttonWidth: 199,
        leftButtonText: $translate.instant('PRODUCTS.MODEL.QR_CODE.MODAL.GENERATE_ANOTHER_CODE'),
        rightButtonText: $translate.instant('PRODUCTS.MODEL.QR_CODE.MODAL.SAVE'),
        handleLeftButton: function () {
          vm.product.qrCode = msUtils.uuidGenerator();
          vm.existingProductWithQRCode = (vm.product && vm.product.id && vm.product.qrCode);
        },
        handleRightButton: function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('PRODUCTS.MODEL.QR_CODE.MODAL.SAVED_SUCCESSFULLY'))
              .hideDelay(3000)
          );
        },
        dontCloseModalOnLeftButtonHandler: true,
        clickOutsideToClose: true,
      }, null);
    }

    function viewQRCode() {
      var qrcodeGeneratorModalId = msUtils.uuidGenerator();

      FcModalService.open(null, {
        title:  $translate.instant('PRODUCTS.MODEL.QR_CODE.MODAL.GENERATE'),
        templateUrl: 'app/main/products/dialogs/modal/qrcode-generator.html',
        modalId: qrcodeGeneratorModalId,
        eventNameToSubscribe: 'products-qrcodes',
        closeButtonIconPath: 'assets/icons/icon-close.svg',
        variables: {
          title: $translate.instant('PRODUCTS.MODEL.QR_CODE.MODAL.GENERATE'),
          product: vm.product,
        },
        buttonFlex: true,
        rightButtonText: $translate.instant('PRODUCTS.MODEL.QR_CODE.MODAL.DOWNLOAD'),
        handleRightButton: downloadQRCode,
        rightButtomFullSize: true,
        rightButtonIsDownloadLink: true,
        downloadLink: 'produto-' + vm.product.qrCode + '.png',
        downloadHref: document.querySelector('#product-qrcode-download canvas').toDataURL('image/png').replace('image/png', 'image/octet-stream'),
        dontCloseModalOnLeftButtonHandler: true,
        clickOutsideToClose: true
      }, null);
    }

    function saveProduct() {
      if (vm.product && !vm.product.description) {
        vm.product.description = '';
      }

      $rootScope.loadingProgress = true;
      productsServicesApi.save(vm.product)
        .then(function (result) {
          vm.product = _.assign(vm.product, result);
          if (vm.productResultImageFile) {
            var filename = '/products/' + vm.product.id + '/' + msUtils.shortGuidGenerator() + '.png';

            var reader = new FileReader();
            reader.readAsDataURL(vm.productResultImageFile);
            reader.onloadend = function () {
              var base64data = reader.result;

              uploadApi.uploadWithPassthrough({
                imageBase64Encoded: base64data,
                filename: filename
              })
                .then(function (path) {
                  vm.product.imageUrl = path.data.key;

                  productsServicesApi
                    .put(vm.product.id, vm.product)
                    .then(function (result) {
                      vm.product.imageUrl = result.imageUrl;
                    }).finally(function () {
                      _realoadProductService();
                    });
                });

            };
          }

          if (vm.storageProducts && vm.storageProducts.length) {
            createAndUpdateStorageProduct();
          }

          vm.closeDialog(true);

          $rootScope.$broadcast('products:reload');

          for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
            var field = vm.smartRewriteFields[i];
            var params = {
              reference: vm.sessionId,
              referenceType: field,
              updatedReference: result.id
            };

            gandalfApi.updateRewriteInputHistory(params);
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('PRODUCTS.TOAST.SAVED', { product: vm.product.name }))
              .hideDelay(3000)
          );
        })
        .catch(function (result) {
          if (result.data.err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('PRODUCTS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('PRODUCTS.DIALOG.ALERT.OK'))
                .textContent(result.data.message)
            );
          }

          vm.closeDialog();
        })
        .finally(function () {
          $rootScope.loadingProgress = false;

          if ((!vm.productResultImageFile && !vm.product.imageUrl) || !vm.productResultImageFile) {
            _realoadProductService();
          }
        });
    }

    function selectImage() {
      var imageSelector = document.querySelector('#image-insert-container');
      if (imageSelector) {
        imageSelector.click();
      }
    }

    function _realoadProductService() {
      if (vm.newProduct) {
        $rootScope.$broadcast('product-services:created', vm.product);
      } else {
        $rootScope.$broadcast('product-services:edited', vm.product);
      }
    }

    function unarchiveProduct($event) {
      vm.product.archived = false;
      saveProduct();
    }

    function archiveProduct($event) {
      vm.product.archived = true;
      saveProduct();
    }

    function verifyDuplicatedProductCode() {
      if (!vm.product || !vm.product.code) {
        return;
      }

      productsServicesApi.search(
        { 'code': vm.product.code },
        { limit: 2 }
      ).then(function (response) {
        var hasResponseItems = response && response.items && response.items.length;
        if (!hasResponseItems) {
          $scope.productForm.code.$setValidity('duplicatedArchived', true);
          $scope.productForm.code.$setValidity('duplicated', true);
          $scope.productForm.code.$setTouched();
          return;
        }

        var sameProduct = _.find(response.items, function (product) {
          return product.id === vm.product.id;
        });
        if (response.items.length === 1 && sameProduct) {
          $scope.productForm.code.$setValidity('duplicatedArchived', true);
          $scope.productForm.code.$setValidity('duplicated', true);
          $scope.productForm.code.$setTouched();
          return;
        }

        var otherProduct = _.find(response.items, function (product) {
          return product.id !== vm.product.id;
        });

        if (otherProduct && otherProduct.archived) {
          $scope.productForm.code.$setValidity('duplicated', true);
          $scope.productForm.code.$setValidity('duplicatedArchived', false);
          $scope.productForm.code.$setTouched();
          return;
        }

        $scope.productForm.code.$setValidity('duplicated', false);
        $scope.productForm.code.$setValidity('duplicatedArchived', true);
        $scope.productForm.code.$setTouched();
      });
    }

    function validateProductForm() {
      return (
        $scope.productForm.$invalid ||
        $scope.productForm.$pristine ||
        vm.product.locked ||
        !vm.isValidStorageProductForm
      );
    }

    function _initializeStorageProducts() {
      $timeout(function () {
        var dialog = document.querySelector('product-tab-storage-provider');

        if (!dialog) {
          return;
        }

        dialog.addEventListener('productTabStorage', function (value) {
          vm.storageProducts = value.detail.storagesProducts;

          vm.isValidStorageProductForm = value.detail.status === "VALID" && !value.detail.pristine;

          $scope.productForm.$setDirty();

          $scope.$apply();
        });
      }, 1000);
    }

    function createAndUpdateStorageProduct() {
      _.forEach(vm.storageProducts, function (storageProduct) {
        if (storageProduct.id) {
          updateStorageProduct(storageProduct);

          return;
        }

        createStorageMovement(storageProduct).then(function (storageMovement) {
          searchStorageProduct(storageMovement).then(function (newStorageProduct) {
            storageProduct.id = newStorageProduct.items[0].id;

            updateStorageProduct(storageProduct);
          });
        });
      });
    }

    function searchStorageProduct(storageMovement) {
      var params = {
        where: {
          storageId: storageMovement.storage.id,
          productId: storageMovement.product.id
        }
      };

      return storageProductsApiGraphQL.search(params);
    }

    function updateStorageProduct(storageProduct) {
      var params = {
        id: storageProduct.id,
        minimalQuantity: storageProduct.minimalQuantity,
        minimalQuantityAtRisk: storageProduct.minimalQuantityAtRisk,
      };

      storageProductsApiGraphQL.update(params).then();
    }

    function createStorageMovement(storageProduct) {
      var storageMovement = {
        quantity: storageProduct.quantity,
        type: 'entry',
        storageId: storageProduct.storageId,
        productId: vm.product.id
      };

      return storagesMovementsApiGraphQL.create(storageMovement);
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.plans-types')
    .factory('PlansTypesDialog', PlansTypesDialog);

  /** @ngInject */
  function PlansTypesDialog($mdDialog, $rootScope, plansTypesApi, $document, $q) {

    return {
      createPlanType: createPlanType,
      editPlanType: editPlanType
    };

    function createPlanType(ev, callback) {
      _openDialog(ev, {
          PlanType: null
      }, callback);
    }

    function editPlanType(ev, id, callback) {
      _loaderOn();

      var requests = {
        planType: plansTypesApi.getOne(id, {})
      };

      $q.all(requests).then(function (result) {
        _openDialog(ev, {
            PlanType: result.planType
        }, callback);

      }).finally(_loaderOff);
    }

    function _openDialog(ev, locals, callback) {
      $mdDialog.show({
          controller: 'PlansTypesDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/plans-types/dialogs/plans-types-dialog.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          locals: locals,
          closeTo: {
            top: 0,
            left: window.innerWidth,
            width: window.innerWidth,
            height: window.innerHeight / 1.8
          }
      }).then(function (reload) {
          if (callback) {
              callback(reload);
          }
      });
    }

    function _loaderOn() {
      $rootScope.loadingProgress = true;
    }

    function _loaderOff() {
      $rootScope.loadingProgress = false;
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.plans-types')
    .controller('PlansTypesDialogController', PlansTypesDialogController);

  /** @ngInject */
  function PlansTypesDialogController(msUtils, $translate, gandalfApi, $rootScope, $mdDialog, $mdToast, PlanType, plansTypesApi) {

    var vm = this;
    vm.planType = angular.copy(PlanType);
    vm.newPlanType = false;
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['plan-type-description'];

    vm.closeDialog = closeDialog;
    vm.savePlanType = savePlanType;
    vm.archivePlanType = archivePlanType;
    vm.unarchivePlanType = unarchivePlanType;

    if (!vm.planType) {
      vm.planType = {
        name: '',
        description: '',
      };
      vm.newPlanType = true;
    }

    function savePlanType() {
      $rootScope.loadingProgress = true;
      plansTypesApi.save(vm.planType).then(function (planType) {
        for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
          var field = vm.smartRewriteFields[i];
          var params = {
            reference: vm.sessionId,
            referenceType: field,
            updatedReference: planType.id
          };

          gandalfApi.updateRewriteInputHistory(params);
        }

        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('PLANSTYPES.TOAST.SAVED', { planType: vm.planType.name }))
            .hideDelay(3000)
        );
      }).catch(function (result) {
        if (result.data.err) {
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .title($translate.instant('PLANSTYPES.DIALOG.ALERT.TITLE'))
              .ok($translate.instant('PLANSTYPES.DIALOG.ALERT.OK'))
              .textContent(result.data.message)
          );
        }
      }).finally(function () {
        $rootScope.$broadcast('plans-types:reload');
        $rootScope.loadingProgress = false;
        vm.closeDialog();
      });
    }

    function unarchivePlanType() {
      vm.planType.archived = false;
      savePlanType();
    }

    function archivePlanType() {
      vm.planType.archived = true;
      savePlanType();
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('ReadPlansSpreadSheet', ReadPlansSpreadSheet);

  /** @ngInject */
  function ReadPlansSpreadSheet(_, ExcelJS, $mdToast, $rootScope, objectMapperService, UnprocessableSpreadSheetPrompt, $translate, moment) {

    return {
      read: read,
      validateColumns: validateColumns,
      validateRows: validateRows
    };

    function read(excelFile) {
      $rootScope.loadingProgress = true;
      return ExcelJS
        .read(excelFile, { rowsLimit: 1000 })
        .then(function (excel) {
          return excel[0].data;
        }).catch(function (err) {
          $mdToast.show($mdToast.simple().textContent($translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.COULD_NOT_READ')).hideDelay(3000));
        }).finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function validateColumns(columns) {
      var columns = columns.map(function (column) {
        return column['field'];
      });

      var validColumns = [
        "TIPO DE OS",
        "DOCUMENTO DO CLIENTE",
        "NOME DO CLIENTE",
        "NOME DA LOCALIZAÇÃO (OPCIONAL)",
        "NÚMERO DE SÉRIE – EQUIPAMENTO (OPCIONAL)",
        "NOME DO COLABORADOR (OPCIONAL)",
        "DATA DE AGENDAMENTO (OPCIONAL)",
        "HORA DE AGENDAMENTO (OPCIONAL)",
        "DESCRIÇÃO (OPCIONAL)"
      ];

      if (_.contains(columns, "TIPO DE ATIVIDADE")) {
        columns[columns.indexOf("TIPO DE ATIVIDADE")] = "TIPO DE OS";
      }

      var differenceBetweenColumns = _.difference(validColumns, columns);
      var pluralize = differenceBetweenColumns.length > 1 ? 's' : '';

      if (differenceBetweenColumns && differenceBetweenColumns.length) {
        UnprocessableSpreadSheetPrompt.show({
          error: 'invalid-columns',
          pluralize: pluralize,
          differences: differenceBetweenColumns
        });

        return {
          valid: false,
          differenceBetweenColumns: differenceBetweenColumns
        };
      }

      return {
        valid: true,
        differenceBetweenColumns: differenceBetweenColumns
      };
    }

    function validateRows(excelFile, rows, dbItems) {
      var osRowKey = _.find(rows, function (row) { return row['TIPO DE OS']; }) ? 'TIPO DE OS' : 'TIPO DE ATIVIDADE';

      var plansSchema = {};
      plansSchema[osRowKey] = 'service.description';
      plansSchema['DOCUMENTO DO CLIENTE'] = 'customer.documentNumber';
      plansSchema['NOME DO CLIENTE'] = 'customer.name';
      plansSchema['NOME DA LOCALIZAÇÃO (OPCIONAL)'] = 'location.name';
      plansSchema['DATA DE AGENDAMENTO (OPCIONAL)'] = 'scheduledDate';
      plansSchema['HORA DE AGENDAMENTO (OPCIONAL)'] = 'scheduledHour';
      plansSchema['NOME DO COLABORADOR (OPCIONAL)'] = 'employee.name';
      plansSchema['NÚMERO DE SÉRIE – EQUIPAMENTO (OPCIONAL)'] = 'equipment.number';
      plansSchema['DESCRIÇÃO (OPCIONAL)'] = 'description';

      var plans = {
        items: [],
        totalItems: rows.length,
        totalInvalidItems: 0
      };
      for (var index = 0; index < rows.length; index++) {
        var planValues = rows[index];
        var mappedPlanRows = objectMapperService.reMap(plansSchema, planValues);
        var validate = _validateRow(mappedPlanRows, dbItems, plans.totalInvalidItems);
        plans.totalInvalidItems = validate.totalInvalidItems;
        plans.items.push(validate.plan);
      }

      if (excelFile && excelFile.target && excelFile.target.files && excelFile.target.files[0]) {
        excelFile = excelFile.target.files[0];
      }

      return {
        plans: plans,
        rows: rows,
        excelFile: excelFile
      };
    }

    function _validateRow(plan, dbItems, totalInvalidItems) {
      var errorDescriptions = [];
      var foundCustomer;
      var foundService;

      if (!plan.service || !plan.service.description) {
        errorDescriptions.push({
          property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.OS_TYPE'),
          error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.EMPTY')
        });
      } else {
        plan.service.description = plan.service.description.trim();

        foundService = _.find(dbItems.services.items, function (service) {
          return service.description === plan.service.description;
        });

        if (!foundService) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.OS_TYPE'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.DESCRIPTION_NOT_FOUND')
          });
        }

        if (foundService && foundService.archived) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.OS_TYPE'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.INACTIVE')
          });
        }

        plan.service = foundService;
      }

      if (!plan.customer.documentNumber && !plan.customer.name) {
        errorDescriptions.push({
          property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_DOCUMENT_NUMBER'),
          error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.EMPTY')
        });
      } else if (plan.customer.name && !plan.customer.documentNumber) {
        plan.customer.name = (plan.customer.name || '').trim();

        var customers = _.filter(dbItems.customersNames.items, function (customer) {
          return customer.name === plan.customer.name;
        });

        foundCustomer = _.filter(_.uniq(customers, 'id'), function (customer) {
          return customer.archived !== true;
        });

        if (customers.length <= 0) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_NAME'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.CUSTOMER_NOT_FOUND')
          });
        }

        if (foundCustomer.length > 1) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_NAME'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.DUPLICATE_CUSTOMER')
          });
        }

        if (foundCustomer.length <= 0 && customers.length > 0) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_NAME'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.CUSTOMER_ARCHIVED')
          });
        }

        plan.customer = foundCustomer[0] || customers[0] || plan.customer;
      } else {
        plan.customer.documentNumber = plan.customer.documentNumber.trim();
        var isValidCPFOrCNPJ = false;
        var regex = new RegExp(/(^\d{3}\.\d{3}\.\d{3}\-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$)/);
        var isCPFOrCNPJ = regex.test(plan.customer.documentNumber);
        if (!isCPFOrCNPJ) {
          if (plan.customer.documentNumber.length === 11 || plan.customer.documentNumber.length === 14 || plan.customer.documentNumber.length === 18) {
            isValidCPFOrCNPJ = true;
          }
        } else {
          isValidCPFOrCNPJ = true;
        }

        if (isValidCPFOrCNPJ) {
          plan.customer.documentNumber = plan.customer.documentNumber.replace(/[^\w\s]/gi, '');
          plan.customer.documentNumber = plan.customer.documentNumber.replace(/\s/g, '');
          foundCustomer = _.find(dbItems.customersDocuments.items, function (customer) {
            return customer.documentNumber === plan.customer.documentNumber;
          });

          if (foundCustomer && foundCustomer.archived) {
            errorDescriptions.push({
              property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_DOCUMENT_NUMBER'),
              error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.INACTIVE')
            });
          }

          if (!foundCustomer) {
            errorDescriptions.push({
              property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_DOCUMENT_NUMBER'),
              error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.DOCUMENT_NOT_FOUND')
            });
          }

          plan.customer = foundCustomer;
        } else {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_DOCUMENT_NUMBER'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.DOCUMENT_NONSTANDARD')
          });
        }
      }

      if (plan.location.name) {
        plan.location.name = plan.location.name.trim();

        var customerLocations = dbItems.locations && dbItems.locations.items ? dbItems.locations.items : [];
        var uniqueCustomerLocations = _.uniq(customerLocations, 'id');

        var foundLocations = _.filter(uniqueCustomerLocations, function (location) {
          return plan.customer && (location.name === plan.location.name && plan.customer.id === location.customer.id);
        });

        var foundLocation = foundLocations[0] || null;

        if (foundLocations.length > 1) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.LOCATION_NAME'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.DUPLICATE_LOCATION')
          });
        }

        if (foundLocation && foundLocation.archived) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.LOCATION_NAME'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.INACTIVE')
          });
        }

        if (!foundLocation) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.LOCATION_NAME'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.NOT_FOUND')
          });
        }

        plan.location = foundLocation;
      } else if (plan.customer) {
        var foundLocation;
        if (plan.customer.primaryLocation) {
          foundLocation = plan.customer.primaryLocation;
        }

        if (foundLocation) {
          plan.location = foundLocation;
        }
      }

      if (plan.equipment.number) {
        plan.equipment.number = plan.equipment.number.trim();
        var foundEquipment = _.find(dbItems.equipments.items, function (equipment) {
          return equipment.number === plan.equipment.number;
        });

        if (foundEquipment && foundEquipment.archived) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.EQUIPMENT_NUMBER'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.INACTIVE')
          });
        }

        if (!foundEquipment) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.EQUIPMENT_NUMBER'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.SERIAL_NUMBER_NOT_FOUND')
          });
        }

        plan.equipment = foundEquipment;
      }

      if (plan.employee.name) {
        plan.employee.name = plan.employee.name.trim();

        var foundEmployees = _.filter(dbItems.employees.items, function (employee) {
          return employee.name === plan.employee.name;
        });

        var foundActiveEmployee = _.find(foundEmployees, function (employee) {
          var isEmployeeActive = employee.contract && employee.contract.active && !employee.inactivatedAt;
          var firedAt = employee && employee.contract && employee.contract.firedAt;

          if (firedAt) {
            var today = moment().startOf('day');
            var firedAtMoment = moment(firedAt, 'YYYY-MM-DD').startOf('day');

            return isEmployeeActive && (firedAtMoment.isAfter(today) || firedAtMoment.isSame(today));
          }

          return isEmployeeActive;
        });

        if (foundEmployees && foundEmployees.length && !foundActiveEmployee) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.EMPLOYEE_NAME'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.INACTIVE_FIRED')
          });
        }

        if (!foundEmployees || !foundEmployees.length) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.EMPLOYEE_NAME'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.NOT_FOUND')
          });
        }

        plan.employee = foundActiveEmployee;
      }

      if (plan.scheduledDate) {
        var regex = new RegExp(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)(\d{2}|\d{4})$/g);
        var validDateFormat = regex.test(plan.scheduledDate);
        var today = moment().startOf('day');
        var scheduledDate = moment(plan.scheduledDate, 'DD/MM/YYYY');

        if (!validDateFormat) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.SCHEDULE_DATE'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.DATE_NONSTANDARD')
          });
        }

        if (!scheduledDate._isValid && validDateFormat) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.SCHEDULE_DATE'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.INVALID_DATE')
          });
        }

        if (scheduledDate.isBefore(today)) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.SCHEDULE_DATE'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.DATE_BEFORE_TODAY')
          });
        }
      }

      if (plan.scheduledHour) {
        var regex = new RegExp(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g);
        var validHour = regex.test(plan.scheduledHour);
        if (!validHour) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.SCHEDULE_HOUR'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.HOUR_NONSTANDARD')
          });
        }
      }

      if (plan.customer && plan.service) {
        var customerCorporateAccountUUID = _findCorporateAccountUUID(plan.customer.metadata);
        var serviceCorporateAccountUUID = _findCorporateAccountUUID(plan.service.metadata);
        var isCorporateServiceOrCorporateCustomer = Boolean(customerCorporateAccountUUID || serviceCorporateAccountUUID);
        var isCorporate = Boolean(customerCorporateAccountUUID && serviceCorporateAccountUUID);
        var isSameCorporateCustomer = customerCorporateAccountUUID === serviceCorporateAccountUUID;
        var corporateCustomerAllowCreateTask = plan.customer.metadata && plan.customer.metadata.featureAllowCreateTask;
        var corporateServiceAllowCreateTask = plan.service.metadata && plan.service.metadata.featureAllowCreateTask;
        var allowCreateTaskEnabled = corporateCustomerAllowCreateTask && corporateServiceAllowCreateTask;
        if (
          (isCorporateServiceOrCorporateCustomer && !isCorporate) ||
          (isCorporate && !isSameCorporateCustomer) ||
          (isCorporate && isSameCorporateCustomer && !allowCreateTaskEnabled)
        ) {
          errorDescriptions.push({
            property: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.OS_TYPE'),
            error: $translate.instant('PLANS.TABLE.INFO.NEW_PLAN.IMPORT_ERRORS.CORPORATE_SERVICE', {
              customerName: customerCorporateAccountUUID
                ? plan.customer.metadata.sammathnaur.account.name
                : plan.service.metadata.sammathnaur.account.name
            })
          });
        }
      }

      if (!_.isEmpty(errorDescriptions)) {
        plan.statusValidator = 'invalid';
        totalInvalidItems++;
        plan.statusValidatorDescriptions = errorDescriptions;
      } else {
        plan.statusValidator = 'valid';
        plan.statusValidatorDescriptions = [];
      }

      return {
        plan: plan,
        totalInvalidItems: totalInvalidItems
      };
    }

    function _findCorporateAccountUUID(metadata) {
      try {
        return metadata.sammathnaur.account.uuid;
      } catch (ignored) {
        return null;
      }
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.plans')
      .factory('importsSpreadsheetService', importsSpreadsheetService);

    /** @ngInject */
    function importsSpreadsheetService(_) {

      var allowedTypes = [
        'text/csv',
        'application/vnd.ms-excel',
        'application/vnd.ms-excel.sheet.macroEnabled.12',
        'application/vnd.ms-excel.template.macroEnabled.12',
        'application/vnd.ms-excel.addin.macroEnabled.12',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ];

      return {
        getAllowedTypes: getAllowedTypes,
        isAllowedType: isAllowedType,
        isNotAllowedType: isNotAllowedType
      };

      function isAllowedType(type) {
        return _.contains(allowedTypes, type);
      }

      function isNotAllowedType(type) {
        return !isAllowedType(type);
      }

      function getAllowedTypes() {
        return allowedTypes;
      }
    }
  })();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('MaterialsDialog', MaterialsDialog);

  /** @ngInject */
  function MaterialsDialog($mdDialog, $rootScope, $q, $document, accountsApi, materialsApi) {

    return {
      createMaterials: createMaterials,
      editMaterials: editMaterials
    };

    function createMaterials(ev, callback) {

      _loaderOn();

      var requests = {
        account: accountsApi.get()
      };

      $q.all(requests).then(function (result) {

        _openMaterialsDialog(ev, {
          Material: null,
          Account: result.account,
          event: ev
        }, callback);

      }).finally(_loaderOff);
    }

    function editMaterials(ev, id, callback) {

      _loaderOn();

      var requests = {
        materials: materialsApi.get(id),
        account: accountsApi.get()
      };

      $q.all(requests).then(function (result) {

        _openMaterialsDialog(ev, {
          Material: result.materials,
          Account: result.account,
          event: ev
        }, callback);

      }).finally(_loaderOff);
    }

    function _openMaterialsDialog(ev, locals, callback) {

      $mdDialog.show({
        controller: 'MaterialsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/materials/dialogs/materials-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }

    function _loaderOn() {
      $rootScope.loadingProgress = true;
    }

    function _loaderOff() {
      $rootScope.loadingProgress = false;
    }
  }
})();

(function () {
    'use strict';

    angular
    .module('app.materials')
    .controller('MaterialsDialogController', MaterialsDialogController);

    /** @ngInject */
    function MaterialsDialogController(Material, Account, MeasuresOptions, materialsApi,
                                       $mdDialog, $mdToast, $translate, $rootScope) {
        var vm = this;
        vm.material = Material;
        vm.account = Account;
        vm.measures = MeasuresOptions.measures;
        vm.closeDialog = closeDialog;
        vm.saveMaterial = saveMaterial;
        vm.updateMaterialStatus = updateMaterialStatus;
        vm.measuresOptions = translateMeasuresOption();


        function translateMeasuresOption(){
          return _.map(vm.measures, function (measure){
            return {translate: $translate.instant(measure.name), value: measure.value};
          });
        }

        function updateMaterialStatus() {
            if (vm.material.archived) {
                return _unarchiveMaterial();
            }
            return _archiveMaterial();
        }

        function closeDialog(reload) {
            $mdDialog.hide(reload);
        }

        function saveMaterial(material, options) {
            $rootScope.loadingProgress = true;

            materialsApi.save(material).then(function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($translate.instant(options.toastMessage || 'MATERIALS.SUCCESSFULLY_SAVED'))
                        .hideDelay(3000)
                );
            }).catch(function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($translate.instant('MATERIALS.ERROR_ON_SAVING'))
                        .hideDelay(3000)
                        .theme("error-toast")
                );
            }).finally(function () {
                $rootScope.loadingProgress = false;
                if (options.closeDialog) {
                    closeDialog(true);
                }
            });
        }

        function _archiveMaterial() {
            vm.material.archived = true;
            saveMaterial(vm.material, { closeDialog: true, toastMessage: 'MATERIALS.SUCCESSFULLY_ARCHIVED' });
        }

        function _unarchiveMaterial() {
            vm.material.archived = false;
            saveMaterial(vm.material, { closeDialog: true, toastMessage: 'MATERIALS.SUCCESSFULLY_UNARCHIVED' });
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.locations')
    .factory('LocationsDialog', LocationsDialog);

  /** @ngInject */
  function LocationsDialog(
    $mdDialog, $document,
    locationsApiGraphQL, authenticatedUser, accountsApi, $q,
    accountFeatureFlagsApiGraphQL
  ) {

    return {
      createLocation: createLocation,
      editLocation: editLocation,
      openMapDialog: openMapDialog
    };

    function createLocation(ev, params, callback) {
      _openDialog(ev, {
        Location: (params && params.location) || null,
        hasEquipmentsPermission: false,
        Customer: (params && params.customer) || null,
      }, callback);
    }

    function editLocation(ev, locationId, account, callback) {
      _loaderOn();

      var hasEquipmentsPermission = authenticatedUser.hasPermission(account, 'equipments_list_menu');
      var hasEquipmentsModule = account && account.configuration && account.configuration.moduleEquipmentManagementEnabled;

      locationsApiGraphQL
        .queryForDialog(locationId)
        .then(function (location) {
          _openDialog(ev, {
            Location: location,
            Customer: null,
            hasEquipmentsPermission: hasEquipmentsModule && hasEquipmentsPermission,
          }, callback);
        })
        .finally(function () {
          _loaderOff();
        });
    }


    function openMapDialog(ev, locals, callback) {
      var isOnTicket = $document.find('.ticket-details-dialog');
      $mdDialog.show({
        controller: 'MapDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/locations/dialogs/map/map-dialog.html',
        parent: isOnTicket ? document.querySelector('.palantir-modal-container') || $document.find('.ticket-details-dialog') : angular.element($document.body),
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }

    function _openDialog(ev, locals, callback) {
      var isOnTicket = document.querySelector('.ticket-details-dialog');
      locals.IsOnTicket = !!(isOnTicket);

      var requests = {
        account: accountsApi.get(),
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags()
      };

      $q.all(requests).then(function (result) {
        locals.Account = result.account;
        locals.FeatureFlags = result.featureFlags;

        $mdDialog
          .show({
            controller: 'LocationsDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/locations/dialogs/location-dialog.html',
            parent: isOnTicket ? document.querySelector('.ticket-details-dialog') : document.querySelector('.palantir-modal-container') || angular.element($document.body),
            targetEvent: ev,
            multiple: true,
            clickOutsideToClose: true,
            locals: locals,
            closeTo: {
              top: 0,
              left: window.innerWidth,
              width: window.innerWidth,
              height: window.innerHeight / 1.8
            }
          })
          .then(function (reload) {
            if (callback) {
              callback(reload);
            }
          });
      });
    }

    function _loaderOn() {
      document.dispatchEvent(new CustomEvent('showLoadingBar'));
    }

    function _loaderOff() {
      document.dispatchEvent(new CustomEvent('hideLoadingBar'));
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.locations').controller('LocationsDialogController', LocationsDialogController);

  /** @ngInject */
  function LocationsDialogController(
    $mdDialog,
    _,
    $rootScope,
    $scope,
    $translate,
    $document,
    EquipmentsDialog,
    Location,
    IsOnTicket,
    customersApi,
    cepDbApi,
    equipmentsApiGraphQL,
    hasEquipmentsPermission,
    geoCoder,
    haversine,
    addressService,
    attachmentsUtils,
    locationsApiGraphQL,
    $mdToast,
    $timeout,
    Customer,
    msUtils,
    LocationsDialog,
    locationsService,
    tasksApi,
    TasksStatusHelper,
    OrderDialog,
    uploadApi,
    $window,
    FcModalService,
    gandalfApi,
    Account,
    customerLocationsApi,
    LocalDateConvert,
    territoriesApi,
    usersApi,
    FeatureFlags,
    authenticatedUser
  ) {
    var vm = this;
    vm.account = angular.copy(Account);
    vm.isPrimaryLocation = false;
    vm.isTogglePrimaryLocationVisible = false;
    vm.customers = [];
    vm.masks = [];
    vm.customerSearchTerm = '';
    vm.isGoogleAddress = true;
    vm.invalidLocationGoogleAddress = null;
    vm.googleLocationAddressErrors = null;
    vm.googleLocationAddressWarnings = null;
    vm.isOnTicket = IsOnTicket;
    vm.searchEquipmentText = '';
    vm.searchedEquipments = [];
    vm.skipEquipments = 0;
    vm.takeEquipments = 5;
    vm.currentPage = 0;
    vm.showMap = false;
    vm.countryCodes = [];
    vm.timeline = [];
    vm.location = angular.copy(Location) || {
      name: '',
      documentNumber: '',
      archived: false,
      locked: false,
      address: {
        postalCode: '',
        street: '',
        number: '',
        neighborhood: '',
        city: '',
        state: '',
        complement: '',
        formattedAddress: '',
        coords: {
          latitude: 0,
          longitude: 0,
        },
      },
      territories: [],
      subTerritory: [],
      customer: Customer || null,
      notes: '',
      contacts: {
        phones: [],
        emails: [],
      },
      equipments: {
        items: [],
        totalCount: 0,
      },
    };
    vm.emailsTypes = [
      { translate: $translate.instant('LOCATIONS.DIALOG.CONTACT.CONTACT_TYPES.WORK'), value: 'work' },
      { translate: $translate.instant('LOCATIONS.DIALOG.CONTACT.CONTACT_TYPES.PERSONAL'), value: 'personal' },
    ];
    vm.phonesTypes = [
      { translate: $translate.instant('LOCATIONS.DIALOG.CONTACT.CONTACT_TYPES.WORK'), value: 'work' },
      { translate: $translate.instant('LOCATIONS.DIALOG.CONTACT.CONTACT_TYPES.HOME'), value: 'personal' },
      { translate: $translate.instant('LOCATIONS.DIALOG.CONTACT.CONTACT_TYPES.PHONE'), value: 'mobile' },
    ];

    vm.featureFlags = FeatureFlags || [];
    vm.hasTerritoriesFlag = hasTerritoryFeatureFlag();
    vm.userTerritories = [];
    vm.isInitializing = true;

    vm.attachments = [];
    vm.loadingAttachments = false;
    vm.maxAttachments = 10;
    vm.removeUploadedAttachment = removeUploadedAttachment;
    vm.viewOriginalAttachment = viewOriginalAttachment;
    vm.uploadImages = _.debounce(uploadImages, 1000);
    vm.uploadProgress = false;
    vm.totalUploadsFilesCount = 0;
    vm.currentUploadsFilesCount = 0;
    vm.files = [];
    vm.renameTitle = '';
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['location-complement', 'location-notes'];
    vm.locationLinksTab = null;

    vm.hasTerritoryFeatureFlag = hasTerritoryFeatureFlag;
    vm.hasEquipmentsPermission = hasEquipmentsPermission;
    vm.closeDialog = closeDialog;
    vm.handleSubmit = handleSubmit;
    vm.archiveUnarchiveLocation = archiveUnarchiveLocation;
    vm.verifyDuplicatedLocationNameToArchive = verifyDuplicatedLocationNameToArchive;
    vm.customerAccountName = customerAccountName;
    vm.validateCreateLocation = validateCreateLocation;
    vm.searchLocationByGoogle = searchLocationByGoogle;
    vm.openMapDialog = openMapDialog;
    vm.selectedGoogleAddressChange = selectedGoogleAddressChange;
    vm.searchCustomerByName = searchCustomerByName;
    vm.cepDb = cepDb;
    vm.geoCoderAddress = geoCoderAddress;
    vm.verifyDuplicatedNameLocation = _.debounce(verifyDuplicatedNameLocation, 500);
    vm.addContactFields = addContactFields;
    vm.deleteContactField = deleteContactField;
    vm.changePrimaryContact = changePrimaryContact;
    vm.createEquipment = createEquipment;
    vm.editEquipment = editEquipment;
    vm.attachments = [];
    vm.loadingAttachments = false;
    vm.maxAttachments = 10;
    vm.removeUploadedAttachment = removeUploadedAttachment;
    vm.viewOriginalAttachment = viewOriginalAttachment;
    vm.uploadImages = _.debounce(uploadImages, 1000);
    vm.uploadProgress = false;
    vm.totalUploadsFilesCount = 0;
    vm.currentUploadsFilesCount = 0;
    vm.files = [];
    vm.renameTitle = '';
    vm.isFileTypeImage = msUtils.isFileTypeImage;
    vm.getIconByFileType = msUtils.getIconByFileType;
    vm.isFileTypeVideo = msUtils.isFileTypeVideo;
    vm.filesToUpload = [];
    vm.getLocationAttachments = getLocationAttachments;
    vm.confirmRemoveAttachment = confirmRemoveAttachment;
    vm.editAttachmentTitle = editAttachmentTitle;
    vm.cancelEditAttachment = cancelEditAttachment;
    vm.archiveAttachment = archiveAttachment;
    vm.saveAttachmentWhenEnterKey = saveAttachmentWhenEnterKey;
    vm.saveAttachmentTitle = saveAttachmentTitle;
    vm.searchEquipments = searchEquipments;
    vm.navigateToPage = navigateToPage;
    vm.locationsService = locationsService;
    vm.openTask = openTask;
    vm.isLoading = false;
    vm.validateImage = attachmentsUtils.validateImage;
    vm.dateFormat = LocalDateConvert.pickFormat('date');
    vm.timeFormat = LocalDateConvert.pickFormat('time-seconds');

    $timeout(function () {
      vm.locationLinksTab = document.getElementById('location-links-tab');

      var goToLinksClick = document.querySelector('.go-to-links');

      if (goToLinksClick) {
        goToLinksClick.addEventListener('click', function () {
          vm.selectedTabIndex = 3;
          $scope.$apply();
        });
      }

      var openLaunchVideoDialog = document.querySelector('.open-launch-video-dialog');

      if (openLaunchVideoDialog) {
        openLaunchVideoDialog.addEventListener('click', function () {
          $mdDialog.show({
            controller: 'LaunchVideoController',
            controllerAs: 'vm',
            templateUrl: 'app/core/dialogs/launch-video/launch-video.html',
            parent: angular.element($document.body),
            clickOutsideToClose: false,
            multiple: true,
            locals: {
              title: $translate.instant('LOCATIONS.DIALOG.LAUNCH_VIDEO.TITLE'),
              message: $translate.instant('LOCATIONS.DIALOG.LAUNCH_VIDEO.MESSAGE'),
              videoUrl: 'https://www.youtube.com/embed/VQE_FyV8Gf0?si=5--LRK3YoF_FqVGJ',
            },
          });
        });
      }

      if (!vm.locationLinksTab) {
        return;
      }

      vm.locationLinksTab.addEventListener('openCreateEquipmentEvent', function (value) {
        vm.createEquipment(null, value.detail);
      });

      vm.locationLinksTab.addEventListener('openEditEquipmentEvent', function (value) {
        vm.editEquipment(null, value.detail);
      });
    }, 1500);

    function _initialize() {
      if (vm.isOnTicket && !vm.location.id) {
        _setFormattedGoogleAddress();
      }

      if (vm.location && vm.location.id) {
        var customer = vm.location.customer;
        var customerPrimaryLocationId = customer && customer.primaryLocation && customer.primaryLocation.id;
        vm.isPrimaryLocation = customerPrimaryLocationId === vm.location.id;
        vm.isTogglePrimaryLocationVisible = !vm.isPrimaryLocation;

        _setFormattedGoogleAddress();
        _loadLocationEquipments('');
        _checkIfCanShowMap();
        _loadTasks();
      }

      var phones = vm.location && vm.location.contacts && vm.location.contacts.phones;
      vm.countryCodes = _formatCountryCodesToSelect(angular.copy(locationsService.countryCodes));

      if (phones && phones.length) {
        vm.location.contacts.phones = phones.map(function (phone) {
          if (phone.countryCode) {
            phone.countryCode = locationsService.findCountryCodeByNumber(phone.countryCode);
          }
          return phone;
        });
      }

      getLocationAttachments();

      getUserTerritories();
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }

    function handleSubmit() {
      _showLoadingBar();
      vm.location.customerId = vm.location.customer.id;

      if (vm.location.id) {
        vm.location.customer.primaryLocation = vm.isPrimaryLocation ? { id: vm.location.id } : null;
        _createOrEditLocation('update');
      } else {
        _createOrEditLocation('create');
      }
    }

    function archiveUnarchiveLocation(shouldArchiveLocation) {
      Location.archived = shouldArchiveLocation;
      _showLoadingBar();

      locationsApiGraphQL
        .updateLocation(Location)
        .catch(function () {
          _showErrorToast($translate.instant('LOCATIONS.DIALOG.ERROR_SAVING'));
        })
        .finally(function () {
          _hideLoadingBar();
          vm.closeDialog({ reload: true });
        });
    }

    function verifyDuplicatedLocationNameToArchive(shouldArchiveLocation) {
      var hasCustomer = !!(vm.location.customer && vm.location.customer.id);
      var hasLocationName = !!(vm.location && vm.location.name && vm.location.name !== '');

      if (hasLocationName && hasCustomer) {
        var params = {
          where: {
            archived: false,
            name: vm.location.name,
            customerIds: [vm.location.customer.id],
          },
          take: 4
        };

        return customerLocationsApi
          .search(params)
          .then(function (locations) {
            var resultLocations = locations.items;
            var isValid = true;

            if (resultLocations.length) {
              isValid = false;

              if (resultLocations.length === 1 && resultLocations[0].id === vm.location.id) {
                isValid = true;
              }
            } else {
              isValid = true;
            }

            if (!isValid) {
              return _showErrorToast($translate.instant('LOCATIONS.DIALOG.ERROR_DUPLICATED'));
            }

            archiveUnarchiveLocation(shouldArchiveLocation);
          });
      }
    }

    function openMapDialog(event, address) {
      if (!vm.showMap) {
        return;
      }

      LocationsDialog.openMapDialog(event, {
        Address: address,
        UpdateCoordsFunc: _updateLocationCoords,
        UserTerritories: vm.userTerritories,
      });
      vm.locationsForm.$setDirty();
    }

    function searchLocationByGoogle(callback) {
      var start = {
        latitude: parseFloat(
          vm.location.address && vm.location.address.coords && vm.location.address.coords.latitude
            ? vm.location.address.coords.latitude
            : 0
        ),
        longitude: parseFloat(
          vm.location.address && vm.location.address.coords && vm.location.address.coords.longitude
            ? vm.location.address.coords.longitude
            : 0
        ),
      };

      geoCoder.getByAddressString(vm.locationByGoogleSearchTerm).then(function (results) {
        results.forEach(function (result) {
          var end = {
            latitude: parseFloat(result.lat),
            longitude: parseFloat(result.lng),
          };

          result.kmDistance = haversine(start, end, 'km');
        });

        vm.googleLocations = _.sortBy(results, 'kmDistance');
        if (callback) { callback(); }
      });
    }

    function _formatCountryCodesToSelect(countryCodes) {
      if (!countryCodes) return [];

      return _.map(countryCodes, function (item) {
        return { translate: '+' + item.countryCode, value: item };
      });
    }

    function searchCustomerByName() {
      _showLoadingBar();
      customersApi
        .search(
          {
          where: {
            nameContains: vm.customerSearchTerm,
            archived: false,
          },
            take: 5
          }
        )
        .then(function (result) {
          vm.customers = result.items;
        })
        .finally(function () {
          _hideLoadingBar();
        });
    }

    function cepDb() {
      if (!vm.location.address.postalCode) {
        vm.location.address.street = '';
        vm.location.address.city = '';
        vm.location.address.state = '';
        vm.location.address.number = '';
        vm.location.address.neighborhood = '';
      } else {
        var cep = vm.location.address.postalCode.replace(/\D/g, '');
        var initialAddress = angular.copy(vm.location.address);

        cepDbApi.search({ zipCode: cep }).then(function (data) {
          if (data) {
            vm.location.address.street = data.logradouro;
            vm.location.address.city = data.cidade;
            vm.location.address.state = data.estado;
            vm.location.address.neighborhood = data.bairro;
          } else {
            vm.location.address.street = '';
            vm.location.address.city = '';
            vm.location.address.state = '';
            vm.location.address.neighborhood = '';
          }
          vm.location.address.number = '';
          vm.geoCoderAddress(initialAddress);
        });
      }
    }

    function customerAccountName(customerMetadata) {
      return (
        customerMetadata &&
        customerMetadata.sammathnaur &&
        customerMetadata.sammathnaur.account &&
        customerMetadata.sammathnaur.account.name
      );
    }

    function validateCreateLocation() {
      var customerMetadata = vm.locationsForm.customer.$modelValue && vm.locationsForm.customer.$modelValue.metadata;

      if (customerMetadata) {
        var enableCreateLocation = msUtils.getConfiguration('featureDisableCreateLocation', [customerMetadata]);

        vm.locationsForm.customer.$setValidity('create-location-disabled-by-corporate', !enableCreateLocation);
      }
    }

    function geoCoderAddress(initialAddress) {
      var address = angular.copy(vm.location.address);
      address.zipCode = address.postalCode;
      delete address.zipCode;

      geoCoder.getByAddressObject(address).then(function (location) {
        if (location) {
          fetchTerritoriesByCoordinates({
            latitude: parseFloat(location.lat),
            longitude: parseFloat(location.lat),
          }).then(function (response) {
            if (!response) {
              vm.location.address = initialAddress;

              return;
            }

            vm.location.address = vm.location.address || {};
            vm.location.address.coords = vm.location.address.coords || {};
            vm.location.address.coords.latitude = parseFloat(location.lat);
            vm.location.address.coords.longitude = parseFloat(location.lng);
          });
        } else {
          vm.location.address = vm.location.address || {};
          vm.location.address.coords = vm.location.address.coords || {};
          vm.location.address.coords.latitude = null;
          vm.location.address.coords.longitude = null;
          vm.location.address.formattedAddress = null;
        }

        _checkIfCanShowMap();
      });
    }

    function verifyDuplicatedNameLocation() {
      var hasCustomer = !!(vm.location.customer && vm.location.customer.id);
      var hasLocationName = !!(vm.location && vm.location.name && vm.location.name !== '');
      vm.validateCreateLocation();

      if (hasLocationName && hasCustomer) {
        var params = {
          where: {
            archived: false,
            name: vm.location.name,
            customerIds: [vm.location.customer.id],
          },
          take: 4
        };

        return customerLocationsApi
          .search(params)
          .then(function (locations) {
          var resultLocations = locations.items;

          if (resultLocations.length) {
            vm.locationsForm.locationName.$setValidity('duplicatedName', false);
            vm.locationsForm.locationName.$setTouched();

            if (resultLocations.length === 1 && resultLocations[0].id === vm.location.id) {
              vm.locationsForm.locationName.$setValidity('duplicatedName', true);
            }
          } else {
            vm.locationsForm.locationName.$setValidity('duplicatedName', true);
          }
        });
      }
    }

    function addContactFields(contactType, currentContacts) {
      var defaultContact = { name: '', type: '', primary: false };
      var isContactTypePhone = contactType === 'phone';
      var customContactField = isContactTypePhone ? 'number' : 'address';
      defaultContact[customContactField] = '';

      if (!currentContacts.length) {
        defaultContact.primary = true;
      }

      if (isContactTypePhone) {
        defaultContact.countryCode = locationsService.findCountryCodeByNumber('55');
      }

      currentContacts.push(defaultContact);
    }

    function deleteContactField(contact, contactIndex, currentContacts, contactType) {
      vm.locationsForm.$setDirty();

      var newContacts = _.filter(currentContacts, function (contact, index) {
        return index !== contactIndex;
      });

      if (contact.primary && newContacts && newContacts.length) {
        newContacts[0].primary = true;
      }

      if (contact.primary && newContacts && newContacts.length) {
        newContacts[0].primary = true;
      }

      if (contactType === 'phone') {
        vm.location.contacts.phones = newContacts;
      } else {
        vm.location.contacts.emails = newContacts;
      }
    }

    function changePrimaryContact(contactIndex, currentContacts, contactType) {
      vm.locationsForm.$setDirty();

      var newContacts = _.map(currentContacts, function (contact, index) {
        contact.primary = index === contactIndex ? true : false;
        return contact;
      });

      if (contactType === 'phone') {
        vm.location.contacts.phones = newContacts;
      } else {
        vm.location.contacts.emails = newContacts;
      }
    }

    function createEquipment(event, data) {
      EquipmentsDialog.createEquipments(event, {
          location: vm.location,
          locationSector: data && data.locationSector ? data.locationSector : null,
          locationEnvironment: data && data.locationEnvironment ? data.locationEnvironment : null,
      }, function () {
          $timeout(function () {
            searchEquipments();

            document.dispatchEvent(new CustomEvent('reloadEquipmentsEvent'));
          }, 2000);
      });
    }

    function editEquipment(ev, id) {
      EquipmentsDialog.editEquipments(ev, id, null, function (reload) {
        if (reload) {
          searchEquipments();

          document.dispatchEvent(new CustomEvent('reloadEquipmentsEvent'));
        }
      });
    }

    function searchEquipments() {
      _loadLocationEquipments(vm.searchEquipmentText, 0);
    }

    function uploadImages() {
      var upload = function () {
        if (!(vm.files && vm.files.length)) {
          return null;
        }
        saveLocationAttachments(vm.files);
      };
      return upload();
    }

    function getLocationAttachments() {
      vm.attachments = [];

      if (vm.location.id) {
        locationsApiGraphQL.getLocationAttachments(vm.location.id).then(function (attachments) {
          vm.attachments = attachments;
        });
      }
    }

    function removeUploadedAttachment(attachmentIndex) {
      vm.files.splice(attachmentIndex, 1);
    }

    function viewOriginalAttachment(attachmentPath) {
      $window.open(attachmentPath);
    }

    function saveLocationAttachments(filesToUpload, locationId) {
      if (!filesToUpload) {
        filesToUpload = _.cloneDeep(vm.filesToUpload);
      }
      vm.uploadProgress = true;
      var totalUploadsFilesCount = filesToUpload.length;
      var currentUploadsFilesCount = 0;
      var currentPosition = vm.attachments.length - 1;
      var filesToSave = [];
      locationId = locationId || vm.location.id;
      if (!locationId) {
        filesToUpload = vm.attachments;
      }
      var AwsAttachmentPath = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/';

      filesToUpload.forEach(function (attachment) {
        var fileName =
          (attachment && attachment.file && attachment.file.name && attachment.file.name.replace(/%20| /g, '')) ||
          attachment.name.replace(/%20| /g, '') ||
          '';
        uploadApi
          .uploadWithPreSignedPost(
            {
              file: attachment.file || attachment,
              filePath: '/locations/' + locationId + '/attachments/' + fileName,
            },
            function () {}
          )
          .then(function (result) {
            currentUploadsFilesCount++;
            currentPosition++;

            filesToSave.push({
              path: AwsAttachmentPath + result.path,
              type: result.contentType,
              title: attachment.title || $translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.NO_TITLE'),
            });

            var uploadsCompleted = currentUploadsFilesCount >= totalUploadsFilesCount;
            if (uploadsCompleted) {
              locationsApiGraphQL
                .createLocationAttachments(locationId, filesToSave)
                .then(function (result) {
                  vm.attachments = vm.attachments.concat(result);
                })
                .finally(function () {
                  vm.filesToUpload = [];
                  vm.files = [];

                  vm.uploadProgress = false;
                });
            }
          });
      });
    }

    function confirmRemoveAttachment(attachment) {
      _showLoadingBar();
      attachment.archived = true;

      locationsApiGraphQL.removeLocationAttachments(vm.location.id, attachment.id).then(function () {
        vm.files = [];
        _hideLoadingBar();
        getLocationAttachments();
      });
    }

    function archiveAttachment(attachmentId, archived, ev) {
      FcModalService.open(ev, {
        title: $translate.instant(
          'LOCATIONS.DIALOG.ATTACHMENTS.ARCHIVE_MODAL.'.concat(archived ? 'ARCHIVE_TITLE' : 'UNARCHIVE_TITLE')
        ),
        content: $translate.instant(
          'LOCATIONS.DIALOG.ATTACHMENTS.ARCHIVE_MODAL.'.concat(archived ? 'ARCHIVE_CONTENT' : 'UNARCHIVE_CONTENT')
        ),
        leftButtonText: $translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.FILES.ALERTS.YES'),
        rightButtonText: $translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.FILES.ALERTS.NO'),
        handleLeftButton: function () {
          vm.loadingAttachments = true;

          vm.attachments = vm.attachments.map(function (attachment) {
            if (attachment.id === attachmentId) {
              attachment.archived = archived;
            }
            return attachment;
          });

          if (!vm.location.id) {
            _showSuccessToast(
              archived
                ?  $translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.ARCHIVE_MODAL.SUCCESS_MESSAGE')
                :  $translate.instant('QUOTATIONS.DIALOG.ATTACHMENTS.ARCHIVE_MODAL.SUCCESS_UNARCHIVE_MESSAGE')
            );
            vm.loadingAttachments = false;
            return;
          }

          locationsApiGraphQL
            .updateLocationAttachments(vm.location.id, attachmentId, archived)
            .catch(function () {
              _showErrorToast($translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.ERROR_MESSAGE'));
            })
            .finally(function () {
              vm.loadingAttachments = false;
              _showSuccessToast(
                archived
                  ?  $translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.ARCHIVE_MODAL.SUCCESS_MESSAGE')
                  :  $translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.ARCHIVE_MODAL.SUCCESS_UNARCHIVE_MESSAGE')
              );
            });
        },
      });
    }

    function editAttachmentTitle(attachmentId, ev) {
      FcModalService.open(ev, {
        title: $translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.RENAME_MODAL.TITLE'),
        templateUrl: 'app/main/locations/dialogs/tabs/attachments/template/rename-attachment-template.html',
        rightButtonText: $translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.FILES.SAVE_EDIT'),
        leftButtonText: $translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.FILES.CANCEL_EDIT'),
        variables: {
          renameTitle: vm.renameTitle,
          handleTitleChange: function (title) {
            vm.renameTitle = title;
          },
        },
        handleRightButton: function () {
          vm.loadingAttachments = true;

          vm.attachments = vm.attachments.map(function (attachment) {
            if (attachment.id === attachmentId) {
              attachment.title = vm.renameTitle;
            }
            return attachment;
          });

          if (!vm.location.id) {
            vm.loadingAttachments = false;
            vm.renameTitle = '';
            _showSuccessToast($translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.RENAME_MODAL.SUCCESS_MESSAGE'));
            return;
          }

          locationsApiGraphQL
            .updateLocationAttachments(vm.location.id, attachmentId, undefined, vm.renameTitle)
            .catch(function () {
              _showErrorToast($translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.ERROR_MESSAGE'));
            })
            .finally(function () {
              vm.loadingAttachments = false;
              vm.renameTitle = '';
              _showSuccessToast($translate.instant('LOCATIONS.DIALOG.ATTACHMENTS.RENAME_MODAL.SUCCESS_MESSAGE'));
            });
        },
      });
    }

    function cancelEditAttachment(attachment) {
      attachment.title = attachment._previousTitle;
      attachment.editing = false;
    }

    function saveAttachmentWhenEnterKey(e, attachment) {
      if (e.key === 'Enter') {
        e.preventDefault();
        saveAttachmentTitle(attachment);

        return false;
      }
    }

    function saveAttachmentTitle(attachment) {
      _showLoadingBar();

      locationsApiGraphQL
        .updateLocationAttachments(vm.location.id, attachment)
        .then(function () {
          attachment.editing = false;
          attachment.removing = false;
          MessageDialog.showToast({
            hideDelay: 4000,
            message: $translate.instant('LOCATIONS.DIALOGS.LOCATION.ATTACHMENTS.SAVE_TITLE_SUCCESS'),
          });
        })
        .finally(function () {
          _hideLoadingBar();
        });
    }

    function navigateToPage(pageNumber, reloadEquipments) {
      vm.skipEquipments = pageNumber * vm.takeEquipments;
      vm.currentPage = pageNumber;

      if (reloadEquipments) {
        _loadLocationEquipments();
      }
    }

    function _createOrEditLocation(actionName) {
      var actionName = actionName === 'create' ? 'createLocation' : 'updateLocation';
      var locationToSave = angular.copy(vm.location);

      if (locationToSave && locationToSave.address && !locationToSave.address.formattedAddress) {
        locationToSave.address.formattedAddress = msUtils.formatAddress(locationToSave.address);
      }

      var phones = locationToSave && locationToSave.contacts && locationToSave.contacts.phones;
      if (phones && phones.length) {
        locationToSave.contacts.phones = locationsService.mapPhoneCollectionToCountryCodeString(phones);
      }

      locationToSave.contacts = locationsService.mapLocationContacts(locationToSave.contacts);

      locationsApiGraphQL[actionName](locationToSave)
        .then(function (newLocation) {
          if (newLocation && newLocation.id) {
            locationToSave.id = newLocation.id;
            locationsApiGraphQL
              .syncLocationContacts(locationToSave)
              .catch(function () {
                _showErrorToast($translate.instant('LOCATIONS.DIALOG.ERROR_SAVING_CONTACTS'));
              })
              .finally(function () {
                locationToSave.customer.primaryLocation = vm.isPrimaryLocation ? { id: locationToSave.id } : null;
                locationToSave.customer.address = locationToSave.address;

                for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
                  var field = vm.smartRewriteFields[i];
                  var params = {
                    reference: vm.sessionId,
                    referenceType: field,
                    updatedReference: newLocation.id
                  };

                  gandalfApi.updateRewriteInputHistory(params);
                }

                if (vm.isOnTicket) {
                  _showSuccessToast($translate.instant('LOCATIONS.DIALOG.SAVED', { name: locationToSave.name }));
                  _hideLoadingBar();
                  vm.closeDialog({ reload: true, locationId: locationToSave.id });
                }

                if (locationToSave.customer.primaryLocation && locationToSave.customer.primaryLocation.id && !vm.isOnTicket) {
                  _updateCustomerPrimaryLocation(locationToSave.customer, function () {
                    _hideLoadingBar();
                    vm.closeDialog({ reload: true, primaryLocationId: locationToSave.customer.primaryLocation.id });
                  });
                } else if (!vm.isOnTicket) {
                  _showSuccessToast($translate.instant('LOCATIONS.DIALOG.SAVED', { name: locationToSave.name }));
                  _hideLoadingBar();
                  vm.closeDialog({ reload: true, locationId: locationToSave.id });
                }
              });
          }
        })
        .catch(function () {
          _showErrorToast($translate.instant('LOCATIONS.DIALOG.ERROR_SAVING'));
          _hideLoadingBar();
          vm.closeDialog({ reload: true });
        });
    }

    function _setFormattedGoogleAddress() {
      if (vm.location.address) {
        if (vm.location.address.formattedAddress && vm.isOnTicket) {
          getAddressCoords();
        }
        vm.selectedGoogleLocation = {
          lat: (vm.location.address.coords && vm.location.address.coords.latitude) || 0,
          lng: (vm.location.address.coords && vm.location.address.coords.longitude) || 0,
          formattedAddress: vm.location.address.formattedAddress || '',
          zipCode: vm.location.address.postalCode || '',
          state: vm.location.address.state || '',
          city: vm.location.address.city || '',
          neighborhood: vm.location.address.neighborhood || '',
          street: vm.location.address.street || '',
          number: vm.location.address.number || '',
          complement: vm.location.address.complement || '',
        };
      }
    }

    function getAddressCoords() {
      vm.locationByGoogleSearchTerm = vm.location.address.formattedAddress;
      searchLocationByGoogle(function () {
        vm.selectedGoogleLocation = Object.assign({}, vm.location.address, {
          lat: vm.googleLocations[0].lat,
          lng: vm.googleLocations[0].lng
        });
        selectedGoogleAddressChange();
      });
    }

    function _updateCustomerPrimaryLocation(customer, callback) {
      customersApi
        .patchCustomers([customer])
        .then(function () {
          _showSuccessToast($translate.instant('LOCATIONS.DIALOG.SAVED', { name: vm.location.name }));
        })
        .catch(function () {
          _showErrorToast($translate.instant('LOCATIONS.DIALOG.ERROR_SAVING_PRIMARY_LOCATION'));
        })
        .finally(function () {
          callback();
        });
    }

    function _updateLocationCoords(_, args) {
      return new Promise(function (resolve) {
        fetchTerritoriesByCoordinates({
          latitude: args.model.lat,
          longitude: args.model.lng,
        }).then(function (response) {
          if (!response) {
            return resolve();
          }

          vm.location.address = vm.location.address || {};
          vm.location.address.coords = vm.location.address.coords || {};
          vm.location.address.coords.latitude = args.model.lat;
          vm.location.address.coords.longitude = args.model.lng;
          vm.selectedGoogleLocation.lat = args.model.lat;
          vm.selectedGoogleLocation.lng = args.model.lng;

          resolve(true);
        });
      });
    }

    function _loadLocationEquipments(nameOrNumberContains, pageToNavigate) {
      _showLoadingBar();

      if (pageToNavigate || pageToNavigate === 0) {
        navigateToPage(pageToNavigate);
      }

      var query = {
        where: {
          archived: false,
          locationIds: [vm.location.id],
          nameOrNumberContains: nameOrNumberContains || '',
        },
        take: vm.takeEquipments,
        skip: vm.skipEquipments,
      };

      equipmentsApiGraphQL
        .search(query)
        .then(function (result) {
          result.items = _.map(result.items, function (equipment) {
            equipment.thumbnail = equipment.imageUrl ? attachmentsUtils.correctUrl(equipment.imageUrl) : null;

            return equipment;
          });

          _.defer(function () {
            $scope.$apply(function () {
              vm.location.equipments = result;
            });
          });
        })
        .finally(function () {
          _hideLoadingBar();
        });
    }

    function _checkIfCanShowMap() {
      vm.showMap =
        vm.location.address &&
        vm.location.address.coords &&
        vm.location.address.coords.latitude &&
        vm.location.address.coords.longitude;
    }

    function _loadTasks() {
      tasksApi.search({
          where: {
            locationId: vm.location.id,
          archived: false
          },
        orderBy: 'scheduledDate_desc'
        })
        .then(function (result) {
          vm.tasks = result.items;
          vm.timeline = toTimeline(result.items);

          if (vm.timeline.length) {
            var schedulingDates = vm.tasks.map(function (task) {
              if (task.scheduling.date) {
                return moment(task.scheduling.date);
              }
              return null;
            });
            schedulingDates = schedulingDates.filter(function (schedulingDate) {
              return Boolean(schedulingDate);
            });
            vm.lastTaskDate = moment.max(schedulingDates).format('YYYY-MM-DD');
            vm.firstTaskDate = moment('2015-01-01').format('YYYY-MM-DD');
          }
        });
    }

    function toTimeline(tasks) {
      var timeline = [];

      tasks = tasks || [];
      tasks.forEach(function (task) {
        var currentStatus = TasksStatusHelper.getByName(task.status);
        var avatarUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg';
        if (task.employee && task.employee.avatarUrl) {
          avatarUrl = task.employee.avatarUrl;
        }

        var itemTime = task.scheduling.date ? LocalDateConvert.formatDate(task.scheduling.date, 'date') : null;
        if (task.scheduling.time) {
          itemTime += ' ' + task.scheduling.time;
        }

        var cardText = '';

        if (task.employee && task.employee.name) {
          cardText += '<br/>';
          cardText += '<span>' + $translate.instant('LOCATIONS.DIALOG.VIEW.TABS.SERVICES.RESPONSIBLE_EMPLOYEE') + '<b>' + task.employee.name + '</b></span>';
        } else {
          cardText += '<br/>';
          cardText += '<span>'+ $translate.instant('LOCATIONS.DIALOG.VIEW.TABS.SERVICES.NO_EMPLOYEE') +'</span>';
        }

        if (
          task.duration &&
          currentStatus.description != 'Pendente' &&
          currentStatus.description != 'Cancelada' &&
          currentStatus.description != 'Em deslocamento' &&
          currentStatus.description != 'Em andamento'
        ) {
          cardText += '<br/>';
          cardText += '<span>' + $translate.instant('LOCATIONS.DIALOG.VIEW.TABS.SERVICES.VISIT_DURATION') +'<b>' + task.duration + $translate.instant('LOCATIONS.DIALOG.VIEW.TABS.SERVICES.MINUTES') +'</b></span>';
        }

        if (task.scheduling && task.scheduling.date) {
          var schedulingDate = LocalDateConvert.formatDate(task.scheduling.date, 'date');
          var schedulingTime = task.scheduling.time ? LocalDateConvert.formatDate(task.scheduling.time.substring(0, 5), 'time') : '';

          cardText += '<br/>';
          cardText += '<span>' + $translate.instant('LOCATIONS.DIALOG.VIEW.TABS.SERVICES.SCHEDULING_DATE_AND_TIME') + '<b>' + schedulingDate + ' ' + schedulingTime + '</b></span>';
        }

        if (task.startedAt && currentStatus.description != 'Cancelada') {
          cardText += '<br/>';
          cardText +=
            '<span>' + $translate.instant('LOCATIONS.DIALOG.VIEW.TABS.SERVICES.START_DATE_AND_TIME') + '<b>' + moment(task.startedAt).format('DD/MM/YYYY HH:mm') + '</b></span>';
        }

        if (task.completedAt && currentStatus.description != 'Cancelada') {
          cardText += '<br/>';
          cardText +=
            '<span>' + $translate.instant('LOCATIONS.DIALOG.VIEW.TABS.SERVICES.DATE_AND_TIME_OF_CONCLUSION') + '<b>' + moment(task.completedAt).format('DD/MM/YYYY HH:mm') + '</b></span>';
        }

        var timelineEvent = {
          id: task.id,
          task: task,
          orderId: task.order.id,
          avatar: {
            src: avatarUrl,
            alt: task.employee ? task.employee.name : '',
          },
          title: task.order.service.id + ' - ' + task.order.service.description,
          createdAt: $translate.instant('LOCATIONS.DIALOG.VIEW.TABS.SERVICES.CREATED_AT') + moment(task.metadata.createdAt).format('DD/MM/YYYY HH:mm'),
          subtitle: currentStatus.description,
          subtitleColor: currentStatus.color,
          text: cardText,
          identifier: task.order.identifier,
          icon: currentStatus.icon,
          color: currentStatus.color,
          time: itemTime,
        };

        timeline.push(timelineEvent);
      });

      return timeline;
    }

    function openTask(ev) {
      OrderDialog.editTask(ev, { id: ev.order.id });
    }

    function _showSuccessToast(message) {
      document.dispatchEvent(new CustomEvent('showSuccessAlert', { detail: { message: message } }));
    }

    function _showErrorToast(message) {
      document.dispatchEvent(new CustomEvent('showErrorAlert', { detail: { message: message } }));
    }

    function _showLoadingBar() {
      document.dispatchEvent(new CustomEvent('showLoadingBar'));
      vm.isLoading = true;
    }

    function _hideLoadingBar() {
      document.dispatchEvent(new CustomEvent('hideLoadingBar'));
      vm.isLoading = false;
    }

    function selectedGoogleAddressChange() {
      if (!vm.selectedGoogleLocation) {
        vm.invalidLocationGoogleAddress = null;
        vm.googleLocationAddressErrors = null;
        vm.googleLocationAddressWarnings = null;
        vm.locationsForm.googleLocation.$setValidity('validation', true);
        vm.isInitializing = false;

        return;
      }

      fetchTerritoriesByCoordinates({
        latitude: vm.selectedGoogleLocation.lat,
        longitude: vm.selectedGoogleLocation.lng,
      }).then(function (response) {
        handleGoogleLocationUpdate(response);
      });
    }

    function fetchTerritoriesByCoordinates(coords) {
      return new Promise(function (resolve) {
        if (!hasTerritoryFeatureFlag()) {
          return resolve(true);
        }

        territoriesApi.territoriesByCoordinates(coords).then(function (territories) {
          var territory = territories.find(function (territory) {
            return !territory.parentTerritory;
          });

          var subTerritory = territories.find(function (territory) {
            return territory.parentTerritory;
          });

          if (!vm.userTerritories || !vm.userTerritories.length) {
            updateLocationTerritories(territory, subTerritory);
            return resolve(true);
          }

          var filteredUserTerritories = vm.userTerritories.filter(function (userTerritory) {
            return userTerritory.id === (territory && territory.id);
          });

          if (!filteredUserTerritories || !filteredUserTerritories.length) {
            showChangeAddressTerritoryModal().then(function (response) {
              if (response) {
                updateLocationTerritories(territory, subTerritory);
                resolve(true);

                return;
              }

              resolve(false);
            });

            return;
          }

          updateLocationTerritories(territory, subTerritory);
          return resolve(true);
        });
      });
    }

    function handleGoogleLocationUpdate(response) {
      if (!response && !vm.isInitializing) {
        clearGoogleLocation();
        return;
      }

      var selectedAddress = vm.selectedGoogleLocation;
      vm.location.address = {
        postalCode: selectedAddress.zipCode || selectedAddress.postalCode || null,
        city: selectedAddress.city || null,
        state: selectedAddress.state || null,
        neighborhood: selectedAddress.neighborhood || null,
        street: selectedAddress.street || null,
        number: selectedAddress.number || null,
        complement: vm.location.address.complement,
        coords: {
          latitude: selectedAddress.lat,
          longitude: selectedAddress.lng,
        },
        formattedAddress: selectedAddress.formattedAddress,
      };

      validateGoogleLocationAddress(vm.location.address);

      _checkIfCanShowMap();
    }

    function updateLocationTerritories(territory, subTerritory) {
      vm.location.territory = territory;
      vm.location.subTerritory = subTerritory;
    }

    function clearGoogleLocation() {
      vm.selectedGoogleLocation = null;
      vm.locationByGoogleSearchTerm = '';
    }

    function showChangeAddressTerritoryModal() {
      return new Promise(function (resolve) {
        FcModalService.open(null, {
          title: 'Troca de endereço da localização',
          paddingSmall: true,
          content:
            'O novo endereço inserido nesta localização não está associado a nenhum território ao qual você pertença. Ao prosseguir, os grupos de usuários e colaboradores vinculados a este território perderão o acesso a esta localização. Se necessário, um administrador poderá vincular esta localização a um território novamente.<br><br>Tem certeza que deseja continuar?',
          leftButtonText: 'NÃO',
          rightButtonText: 'SIM',
          handleRightButton: function () {
            resolve(true);
          },
          handleLeftButton: function () {
            resolve(false);
          },
        });
      });
    }

    function hasTerritoryFeatureFlag() {
      return vm.featureFlags.find(function (featureFlag) {
        return featureFlag.name === 'territories' && featureFlag.active;
      });
    }

    function validateGoogleLocationAddress(address) {
      var validation = addressService.validateAddress(address);
      vm.invalidLocationGoogleAddress = !validation.valid;
      vm.googleLocationAddressErrors = validation.errors;
      vm.googleLocationAddressWarnings = validation.warnings;
      vm.isInitializing = false;
      vm.locationsForm.googleLocation.$setValidity('validation', !vm.invalidLocationGoogleAddress);
      vm.locationsForm.$setDirty();
    }

    function getUserTerritories() {
      var userId = authenticatedUser.profile.id;

      usersApi.getTerritories(userId).then(function (territories) {
        vm.userTerritories = territories;
      });
    }

    _initialize();
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.errors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.errors-404', {
            url: '/link-nao-encontrado',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.errors-404': {
                    templateUrl: 'app/main/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            data: { titleTranslateKey: 'ERROR404.PAGE_TITLE' },
            bodyClass: 'maintenance'
        });

        $stateProvider.state('app.errors-desktop-required', {
            url: '/necessario-computador-ou-notebook-ou-tablet',
            views: {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.errors-desktop-required': {
                    templateUrl: 'app/main/errors/desktop-required/desktop-required-error.html',
                    controller : 'DesktopRequiredErrorController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        $stateProvider.state('app.errors-download-app-required', {
            url: '/baixe-aplicativo-do-gestor',
            views: {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.errors-download-app-required': {
                    templateUrl: 'app/main/errors/download-app-required/download-app-required.html',
                    controller : 'DownloadAppRequiredController as vm'
                }
            },
            bodyClass: 'maintenance'
        });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/errors');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.errors')
        .controller('DownloadAppRequiredController', DownloadAppRequiredController);

    /** @ngInject */
    function DownloadAppRequiredController() {
        var vm = this;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.errors')
        .controller('DesktopRequiredErrorController', DesktopRequiredErrorController);

    /** @ngInject */
    function DesktopRequiredErrorController() {
        var vm = this;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.errors')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller(authenticatedUser, $state) {

        var vm = this;
        vm.hasToken = authenticatedUser.profile.token !== '';
    }
})();
(function () {
  'use strict';

  angular.module('app.core')
    .factory('EquipmentsDialog', EquipmentsDialog);

  /** @ngInject */
  function EquipmentsDialog(
    $mdDialog, $rootScope, $q, $document, equipmentsApi, equipmentTypesApi, accountsApi, $translate
  ) {
    return {
      createEquipments: createEquipments,
      editEquipments: editEquipments
    };

    function createEquipments(ev, params, callback) {
      _loaderOn();

      var requests = {
        equipmentsTypes: equipmentTypesApi.getEquipmentTypes({ archived: "no" }, null),
        account: accountsApi.get()
      };

      $q.all(requests).then(function (result) {
        _openEquipmentsDialog(ev, {
          Equipment: null,
          EquipmentsTypes: result.equipmentsTypes,
          Account: result.account,
          Location: (params && params.location) || null,
          event: ev,
          LocationSector: (params && params.locationSector) || null,
          LocationEnvironment: (params && params.locationEnvironment) || null
        }, callback);
      }).finally(_loaderOff);
    }

    function editEquipments(ev, id, selectedTab, callback) {
      _loaderOn();

      var requests = {
        equipments: equipmentsApi.get(id),
        equipmentsTypes: equipmentTypesApi.getEquipmentTypes({ archived: 'no' }, null),
        account: accountsApi.get()
      };

      $q.all(requests).then(function (result) {
        var equipment = angular.copy(result.equipments);

        if (equipment && equipment.locationSector && equipment.locationSector.archived) {
          equipment.locationSector.name = equipment.locationSector.name + $translate.instant('EQUIPMENTS.DIALOG.GENERAL.ARCHIVED');
        }

        if (equipment && equipment.locationEnvironment && equipment.locationEnvironment.archived) {
          equipment.locationEnvironment.name = equipment.locationEnvironment.name + $translate.instant('EQUIPMENTS.DIALOG.GENERAL.ARCHIVED');
        }

        _openEquipmentsDialog(ev, {
          Equipment: equipment,
          EquipmentsTypes: result.equipmentsTypes,
          Account: result.account,
          Location: null,
          LocationSector: null,
          LocationEnvironment: null,
          event: ev,
          selectedTab: selectedTab
        }, callback);
      }).finally(_loaderOff);
    }

    function _openEquipmentsDialog(ev, locals, callback) {
      var isOnTicket = $document.find('.ticket-details-dialog');

      $mdDialog.show({
        controller: 'EquipmentsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/equipments/dialogs/equipments-dialog.html',
        parent: isOnTicket ? document.querySelector('.palantir-modal-container') || $document.find('.ticket-details-dialog') : angular.element($document.body),
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }

    function _loaderOn() {
      document.dispatchEvent(new CustomEvent('showLoadingBar'));
    }

    function _loaderOff() {
      document.dispatchEvent(new CustomEvent('hideLoadingBar'));
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.equipments')
    .controller('EquipmentsDialogController', EquipmentsDialogController);

  /** @ngInject */
  function EquipmentsDialogController(
    $scope, $q, $mdDialog, Equipment, EquipmentsTypes, _, OrderDialog,
    customersApi, $window, msUtils, uploadApi, equipmentTypesApi, tasksApi,
    focus, equipmentsApi, moment, $timeout, customerLocationsApi, MessageDialog, TasksStatusHelper,
    attachmentsUtils, $translate, Account, Location, EquipmentsTimelineService,
    authenticatedUser, fuseTheming, fuseGenerator, equipmentsLabelsService, FcModalService,
    locationSectorsApiGraphQL, locationEnvironmentsApiGraphQL, LocationSector, LocationEnvironment,
    $document, gandalfApi, LocalDateConvert, accountFeatureFlagsApiGraphQL, locals
  ) {

    var vm = this;
    var _setEquipmentLabelsDebounced = _.debounce(equipmentsLabelsService.saveEquipmentLabels, 1000);
    vm.account = angular.copy(Account);
    vm.accountConfiguration = Account.configuration;
    vm.location = angular.copy(Location);
    vm.files = [];
    vm.formErr = {};
    vm.equipmentLogs = [];
    vm.loadingTimeline = true;
    vm.hasMoreTimeline = true;
    vm.lastEquipmentLogCursor = null;
    vm.today = moment().format(LocalDateConvert.pickFormat('date'));
    vm.yesterday = moment().subtract(1, 'days').format(LocalDateConvert.pickFormat('date'));
    vm.dateFormat = LocalDateConvert.pickFormat('date');
    vm.selectedTabIndex = 0;
    vm.labelTabIndex = 0;
    vm.labels = [];
    vm.labelSearchText = '';
    vm.newLabelColor = null;
    vm.newLabelName = null;
    vm.filterLabel = filterLabel;
    vm.palettes = fuseTheming.getRegisteredPalettesLabels();
    vm.rgba = fuseGenerator.rgba;
    vm.equipment = angular.copy(Equipment);
    vm.labelsLimit = vm.accountConfiguration.labelsLimit || 30;
    vm.editingLabel = null;
    vm.equipmentsTypes = EquipmentsTypes.items.map(function (item) {
      var corporate = item.metadata && item.metadata.sammathnaur && item.metadata.sammathnaur.account && item.metadata.sammathnaur.account.name;
      if (corporate) {
        item.name = item.name + ' (' + corporate + ')';
      }

      return { value: item};
    });
    vm.equipmentsTypesToShow = vm.equipmentsTypes;
    vm.equipmentImage = null;
    vm.equipmentAttachments = null;
    vm.hasNoLocations = false;
    vm.isQRCodeRequired = false;
    vm.uploadProgress = false;
    vm.customFieldEquipmentType = [];
    vm.existingEquipmentWithQRCode = (vm.equipment && vm.equipment.id && vm.equipment.qrCode);
    vm.generalIsInvalid = false;
    vm.customFieldIsInvalid = false;
    vm.equipmentHasLocation = false;
    vm.archivedEquipment = false;
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['equipment-notes'];
    vm.customFieldsSmartRewriteFields = ['equipment-custom-field-question'];
    vm.locationSectors = [];
    vm.locationEnvironments = [];
    vm.locationSector = angular.copy(LocationSector);
    vm.locationEnvironment = angular.copy(LocationEnvironment);
    vm.hasPublicQRCodeFeatureFlag = false;
    vm.hasWarrantiesPermission = authenticatedUser.hasPermission(vm.account, 'warranties_list');

    vm.isFileTypeImage = msUtils.isFileTypeImage;
    vm.isFileTypeVideo = msUtils.isFileTypeVideo;
    vm.getIconByFileType = msUtils.getIconByFileType;
    vm.hasLabelsPermission = authenticatedUser.hasPermission(vm.account, 'settings-registers_labels_menu');
    vm.closeDialog = closeDialog;
    vm.saveEquipment = saveEquipment;
    vm.archiveEquipment = archiveEquipment;
    vm.unarchiveEquipment = unarchiveEquipment;
    vm.uploadImages = _.debounce(uploadImages, 1000);
    vm.downloadQRCode = downloadQRCode;
    vm.goToQRCodeTab = goToQRCodeTab;
    vm.tabs = {
      'general': 0,
      'custom-fields': 1,
      'attachments': 2,
      'services': 3,
      'history': 4,
    };
    vm.validateImage = attachmentsUtils.validateImage;
    vm.loadTimeline = loadTimeline;
    vm.editLabel = editLabel;
    vm.updateLabel = updateLabel;
    vm.removeUploadedAttachment = removeUploadedAttachment;
    vm.customerAccountName = customerAccountName;
    vm.validateCreateEquipment = validateCreateEquipment;
    vm.verifyDuplicatedEquipmentNumber = verifyDuplicatedEquipmentNumber;
    vm.validateRequiredGeneralFields = validateRequiredGeneralFields;
    vm.toggleInArray = toggleInArray;
    vm.addNewLabel = addNewLabel;
    vm.selectImage = selectImage;
    vm.isLoading = false;

    $timeout(function () {
      var openLaunchVideoDialog = document.querySelector('.open-launch-video-dialog');

      if (openLaunchVideoDialog) {
        openLaunchVideoDialog.addEventListener('click', function () {
          $mdDialog.show({
            controller: 'LaunchVideoController',
            controllerAs: 'vm',
            templateUrl: 'app/core/dialogs/launch-video/launch-video.html',
            parent: angular.element($document.body),
            clickOutsideToClose: false,
            multiple: true,
            locals: {
              title: $translate.instant('LOCATIONS.DIALOG.LAUNCH_VIDEO.TITLE'),
              message: $translate.instant('LOCATIONS.DIALOG.LAUNCH_VIDEO.MESSAGE'),
              videoUrl: 'https://www.youtube.com/embed/VQE_FyV8Gf0?si=5--LRK3YoF_FqVGJ'
            }
          });
        });
      }
    }, 1000);

    function _initialize() {
        updateTabs();

        if(locals.selectedTab) {
          vm.selectedTabIndex = vm.tabs[locals.selectedTab];
        }

      accountFeatureFlagsApiGraphQL.getCachedFlagByName('public-qrcode-beta-flag').then(function (flag) {
        vm.hasPublicQRCodeFeatureFlag = flag ? flag.active : false;
      });

      _hideLoadingBar();
      if (!vm.equipment) {
        vm.equipment = {
          id: '',
          name: '',
          notes: '',
          number: '',
          qrCode: '',
          archived: false,
          customer: (vm.location && vm.location.customer) || null,
          type: null,
          location: vm.location || null,
          labels: [],
          locationSector: vm.locationSector || null,
          locationEnvironment: vm.locationEnvironment || null
        };
      } else {

        if (vm.equipment.type && vm.equipment.type.id) {
          var matchingType = vm.equipmentsTypes.find(function (item) {
            return item.value.id === vm.equipment.type.id;
          });

          if (matchingType) {
            vm.equipment.type = matchingType.value;
          } else {
            if (vm.equipment.type.archived) {
              vm.equipment.type.name = vm.equipment.type.name + ' (Arquivado)';
            }
            vm.equipmentsTypes.push({ value: vm.equipment.type });
          }
        }

        _updateAllAttachmentsFromEquipment();
        _updateAllCustomFieldsAnswersFromEquipment();
        _getAllCustomFieldFromEquipmentType(vm.equipment.type.id);

        vm.equipment.createdAt = moment(vm.equipment.createdAt).toDate();

        loadTasks();
      }
      _loadLabels();

      focus('number');
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }

    function _loadLabels() {
      equipmentsLabelsService.loadEquipmentsLabels(vm.equipment, function (labels) {
        vm.labels = labels;
      });
    }

    function selectImage() {
      var imageSelector = document.querySelector('#image-insert-container');
      if (imageSelector) {
        imageSelector.click();
      }
    }

    function equipmentImageSaveError() {
      _showErrorToast($translate.instant('EQUIPMENTS.TOAST.ERRORS.EQUIPMENT_IMAGE_UPLOAD'));
    }

    function saveEquipment(equipment, options) {
      _showLoadingBar();

      _saveEquipmentImage()
        .then(function () {
          var input = _toSaveEquipmentRow(equipment);

          equipmentsApi.save({ input: input })
          .then(function (response) {
            var createdEquipment = {
              id: response.id,
              labels: vm.equipment.labels
            };
            equipmentsLabelsService.saveEquipmentLabels(createdEquipment, true)
              .then(function () {
                _showSuccessToast($translate.instant('EQUIPMENTS.TOAST.EQUIPMENT_SAVED', { name: vm.equipment.name }));

                if (options.closeDialog) {
                  closeDialog(true);
                }

                for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
                  var field = vm.smartRewriteFields[i];
                  var params = {
                    reference: vm.sessionId,
                    referenceType: field,
                    updatedReference: response.id
                  };

                  gandalfApi.updateRewriteInputHistory(params);
                }

                for (var index = 0; index < vm.customFieldEquipmentType.length; index++) {
                  var customField = vm.customFieldEquipmentType[index];

                  for (var i = 0; i < vm.customFieldsSmartRewriteFields.length; i++ ) {
                    var field = vm.customFieldsSmartRewriteFields[i];
                    var params = {
                      reference: vm.sessionId + '_' + customField.id,
                      referenceType: field,
                      updatedReference: response.id  + '_' + customField.id
                    };

                    gandalfApi.updateRewriteInputHistory(params);
                  }
                }
              });

            })
            .catch(function (errResponse) {
              if (errResponse && errResponse.data) {
                if (errResponse.data.code === 'equipment_duplicated_serial_number') {
                  $scope.equipmentsForm.number.$setValidity('duplicated', false);
                  vm.formErr['equipment_duplicated_serial_number_value'] = vm.equipment.number;
                }
              }
            })
            .finally(function () {
              _hideLoadingBar();
            });
        })
        .catch(equipmentImageSaveError);
    }

    function _saveEquipmentImage() {
      return new Promise(function (resolve, reject) {
        if (vm.equipmentImage) {
          var filename = '/customer/' + vm.equipment.customer.id + '/equipment/' + msUtils.shortGuidGenerator() + '.png';
          uploadApi.uploadWithPreSignedPost({
            file: vm.equipmentImage,
            filePath: filename
          }, null)
            .then(function (result) {
              vm.equipment.imageUrl = result.path;
              resolve();
            });
        } else {
          resolve();
        }
      });
    }

    function _toSaveEquipmentRow(equipment) {
      var input = {
        imageUrl: equipment.imageUrl,
        name: equipment.name,
        number: equipment.number,
        qrCode: equipment.qrCode || null,
        notes: equipment.notes,
        archived: equipment.archived,
        locationId: equipment.location && equipment.location.id,
        customerId: equipment.customer && equipment.customer.id,
        equipmentTypeId: equipment.type && equipment.type.id,
        customFields: _toSaveCustomFields(),
        locationSectorId: equipment.locationSector && equipment.locationSector.id,
        locationEnvironmentId: equipment.locationEnvironment && equipment.locationEnvironment.id
      };

      if (equipment.id) {
        input.id = equipment.id;
      }

      return input;
    }

    function _toSaveCustomFields() {
      return _.chain(vm.customFieldEquipmentType)
        .map(function (customField, index) {
          if (customField.name && customField.answer) {
            return {
              value: customField.answer,
              name: customField.name,
              type: customField.type,
              position: vm.customFieldEquipmentType.length - index
            };
          }
        })
        .filter(function (customField) { return !!customField; })
        .value();
    }

    function archiveEquipment($event) {
      vm.equipment.archived = true;
      saveEquipment(vm.equipment, { closeDialog: true });
    }

    function unarchiveEquipment($event) {
      vm.equipment.archived = false;
      saveEquipment(vm.equipment, { closeDialog: true });
    }

    function uploadImages(files) {
      if (files && files.length) {
        vm.uploadProgress = true;
        vm.totalUploadsFilesCount = files.length;
        vm.currentUploadsFilesCount = 0;

        var filePath = "/customer/" + vm.equipment.customer.id + "/equipments/" + vm.equipment.id + "/";
        files.forEach(function (file) {
          var filename = filePath + file.name.replace(/%20| /g, '');
          var fileSize = file.size;

          uploadApi.uploadWithPreSignedPost({ file: file, filePath: filename }, null)
            .then(function (result) {
              vm.currentUploadsFilesCount++;

              var attachment = {
                path: result.path,
                size: fileSize,
                equipment: {
                  id: vm.equipment.id
                }
              };

              equipmentsApi.saveEquipmentAttachment(vm.equipment.id, attachment).then(function () {
                var uploadsCompleted = vm.currentUploadsFilesCount >= vm.totalUploadsFilesCount;
                if (uploadsCompleted) {
                  vm.files = [];
                  vm.uploadProgress = false;

                  _showSuccessToast($translate.instant('EQUIPMENTS.TOAST.IMAGES_SENDED'));
                  _updateAllAttachmentsFromEquipment();
                }
              });
            });
        });
      }
    }

    function downloadQRCode() {
      var download = document.getElementById('equipmentDownloadLink');
      var image = document.querySelector('#equipment-qrcode-download canvas').toDataURL('image/png').replace('image/png', 'image/octet-stream');
      download.setAttribute("href", image);
    }

    function goToQRCodeTab() {
      vm.selectedTabIndex = 3;
    }

    function verifyDuplicatedEquipmentNumber() {
      if (vm.equipment && vm.equipment.number) {
        equipmentsApi.search({
          where: {
            number: vm.equipment.number
          },
          skip: 0,
          take: 50
        }).then(function (response) {
          var hasResponseItems = response && response.items && response.items.length;
          if (hasResponseItems) {
            vm.archivedEquipment = response.items[0].archived;
            var isDuplicatedNumber = _.some(response.items, function (equipment) {
              return !(equipment.id !== vm.equipment.id && equipment.number === vm.equipment.number);
            });

            $scope.equipmentsForm.number.$setValidity('duplicated', isDuplicatedNumber);

            if(vm.archivedEquipment){
              $scope.equipmentsForm.number.$setValidity('duplicated', true);
              $scope.equipmentsForm.number.$setValidity('duplicatedArchived', !vm.archivedEquipment);
            }

            $scope.equipmentsForm.number.$setTouched();
            return;
          }
          $scope.equipmentsForm.number.$setValidity('duplicatedArchived', true);
          $scope.equipmentsForm.number.$setValidity('duplicated', true);
          $scope.equipmentsForm.number.$setTouched();
        });
      }
    }

    function _updateAllAttachmentsFromEquipment() {
      equipmentsApi.getAttachmentsFromEquipment(vm.equipment).then(function (data) {
        vm.equipmentAttachments = [];

        data.items.forEach(function (attachment) {
          var pathObject = attachmentsUtils.correctMumakilUrl(attachment.path);
          attachment.path = pathObject.path;
          attachment.thumbnailPath = pathObject.thumbnailPath;
          vm.equipmentAttachments.push(attachment);
        });
        vm.equipmentAttachments = data.items;
        vm.equipmentAttachments = _.sortBy(data.items, function (att) { return att.createdAt; }).reverse();
      });
    }

    function _updateAllCustomFieldsAnswersFromEquipment() {
      _getAllCustomFieldFromEquipmentType(vm.equipment.type.id).then(function () {
        equipmentsApi.getCustomFieldAnswers(vm.equipment.id)
          .then(function (result) {
            var answers = result.items;

            if (answers.length) {
              _.defer(function () {
                $scope.$apply(function () {
                  vm.customFieldEquipmentType.forEach(function (cf) {
                    var answer = _.find(answers, function (cfAnswer) { return cf.name === cfAnswer.name; });
                    if (answer) {
                      if (cf.type === 'date' && answer.value === '') {
                        answer.value = null;
                      }
                      cf.answer = answer.value;
                    }
                  });
                });
              });
            }
          });
      });
    }

    function validateCreateEquipment() {
      var errors = msUtils.checkCreateEquipmentErrors(vm.equipment.customer,vm.account);
      $scope.equipmentsForm.customer.$setValidity('equipment-management-module-required-valid', errors.equipmentManagementModuleRequiredValid);
      if (!vm.equipment.id) {
        $scope.equipmentsForm.customer.$setValidity('create-equipment-disabled-by-corporate-valid', errors.createEquipmentDisabledByCorporateValid);
      }
    }

    function customerAccountName(customerMetadata) {
      return customerMetadata && customerMetadata.sammathnaur && customerMetadata.sammathnaur.account && customerMetadata.sammathnaur.account.name;
    }

    function validateRequiredGeneralFields() {
      var generalRequiredFields = ['number', 'name', 'equipmentTypeId', 'customer', 'customerLocation'];

      var allFieldsValid = _.every(generalRequiredFields, function (field) {
          return $scope.equipmentsForm[field] && $scope.equipmentsForm[field].$valid;
      });

      if(allFieldsValid) {
        vm.generalIsInvalid = false;
      } else {
        vm.generalIsInvalid = true;
      }

      return vm.generalIsInvalid;
    }

    // Customer
    vm.customers = [];
    vm.searchCustomerText = null;
    vm.selectedCustomerChanged = selectedCustomerChanged;
    vm.searchCustomerByName = searchCustomerByName;

    vm.generateQRCode = generateQRCode;
    vm.viewQRCode = viewQRCode;

    function generateQRCode() {
      vm.equipment.qrCode = msUtils.uuidGenerator();
      vm.existingEquipmentWithQRCode = (vm.equipment && vm.equipment.id && vm.equipment.qrCode);
      var qrcodeGeneratorModalId = msUtils.uuidGenerator();
      $scope.equipmentsForm.$setDirty();

      FcModalService.open(null, {
        title:  $translate.instant('EQUIPMENTS.DIALOG.QRCODE.MODAL.GENERATE'),
        templateUrl: 'app/main/equipments/dialogs/modal/qrcode-generator.html',
        modalId: qrcodeGeneratorModalId,
        eventNameToSubscribe: 'equipments-qrcodes',
        closeButtonIconPath: 'assets/icons/icon-close.svg',
        variables: {
          title: $translate.instant('EQUIPMENTS.DIALOG.QRCODE.MODAL.GENERATE'),
          equipment: vm.equipment,
          hasPublicQRCodeFeatureFlag: vm.hasPublicQRCodeFeatureFlag && vm.accountConfiguration.featurePublicQRCodeEnabled
        },
        buttonFlex: true,
        buttonWidth: 199,
        leftButtonText: $translate.instant('EQUIPMENTS.DIALOG.QRCODE.MODAL.GENERATE_ANOTHER_CODE'),
        rightButtonText: $translate.instant('EQUIPMENTS.DIALOG.QRCODE.MODAL.SAVE'),
        handleLeftButton: function () {
          vm.equipment.qrCode = msUtils.uuidGenerator();
          vm.existingEquipmentWithQRCode = (vm.equipment && vm.equipment.id && vm.equipment.qrCode);
        },
        handleRightButton: function () {
          _showSuccessToast($translate.instant('EQUIPMENTS.DIALOG.QRCODE.MODAL.SAVED_SUCCESSFULLY'));
        },
        dontCloseModalOnLeftButtonHandler: true,
        clickOutsideToClose: true,
      }, null);
    }

    function viewQRCode() {
      var qrcodeGeneratorModalId = msUtils.uuidGenerator();

      FcModalService.open(null, {
        title:  $translate.instant('EQUIPMENTS.DIALOG.QRCODE.MODAL.GENERATE'),
        templateUrl: 'app/main/equipments/dialogs/modal/qrcode-generator.html',
        modalId: qrcodeGeneratorModalId,
        eventNameToSubscribe: 'equipments-qrcodes',
        closeButtonIconPath: 'assets/icons/icon-close.svg',
        variables: {
          title: $translate.instant('EQUIPMENTS.DIALOG.QRCODE.MODAL.GENERATE'),
          equipment: vm.equipment,
          hasPublicQRCodeFeatureFlag: vm.hasPublicQRCodeFeatureFlag && vm.accountConfiguration.featurePublicQRCodeEnabled
        },
        buttonFlex: true,
        rightButtonText: $translate.instant('EQUIPMENTS.DIALOG.QRCODE.MODAL.DOWNLOAD'),
        handleRightButton: downloadQRCode,
        rightButtomFullSize: true,
        rightButtonIsDownloadLink: true,
        downloadLink: 'equipamento-' + vm.equipment.qrCode + '.png',
        downloadHref: document.querySelector('#equipment-qrcode-download canvas').toDataURL('image/png').replace('image/png', 'image/octet-stream'),
        dontCloseModalOnLeftButtonHandler: true,
        clickOutsideToClose: true
      }, null);
    }

    function selectedCustomerChanged() {
      if (vm.location) {
        return;
      };

      vm.equipmentHasLocation = vm.equipment.id && vm.equipment.location && vm.equipment.location.id ? true : false;

      if (vm.equipment.customer) {
        vm.validateCreateEquipment();

        if (vm.equipment.customer.metadata && vm.equipment.customer.metadata.featureEquipmentQrCodeRequired) {
          vm.isQRCodeRequired = true;
        }
        if (vm.equipment.customer.primaryLocation && vm.equipment.customer.primaryLocation.id) {
          var id = vm.equipmentHasLocation ? vm.equipment.location.id : vm.equipment.customer.primaryLocation.id;
          customerLocationsApi.getOne(id).then(function (result) {
            if (result) {
              vm.equipment.location = result;

              vm.selectedCustomerLocationChanged();
            } else {
              vm.hasNoLocations = true;
            }
        });
        } else {
          vm.hasNoLocations = true;
        }

        var isCorporateCustomer = vm.equipment.customer.metadata && vm.equipment.customer.metadata.callbacks && vm.equipment.customer.metadata.callbacks.includes('sammathnaur');

        if (isCorporateCustomer) {
          vm.equipmentsTypesToShow = vm.equipmentsTypes.filter(function (item) {
            return item.value && item.value.metadata && item.value.metadata.callbacks && item.value.metadata.callbacks.includes('sammathnaur');
          });
        }
      } else {
        vm.equipmentsTypesToShow = vm.equipmentsTypes;
        vm.isQRCodeRequired = false;
        vm.equipment.location = null;
      }
    }

    function searchCustomerByName() {
      _showLoadingBar();
      customersApi.search({
        where: {
          nameContains: vm.searchCustomerText,
          archived: false
        },
        take: 30
      }).then(function (result) {
        vm.customers = result.items;
      }).finally(function () {
        _hideLoadingBar();
      });
    }

    // Tasks
    vm.tasks = [];
    vm.timeline = [];
    vm.tasksTotalCount = 0;
    vm.taskLimit = 10;
    vm.taskOffset = 0;
    vm.openTask = openTask;
    vm.loadTasks = loadTasks;
    vm.loadMoreTasks = loadMoreTasks;

    function loadTasks() {
      if (!vm.equipment || !vm.equipment.id) {
        return;
      }

			tasksApi.search({
				where: {
          equipmentIds: [vm.equipment.id],
          archived: false
        },
        orderBy: 'scheduledDate_desc',
        take: vm.taskLimit,
        skip: vm.taskOffset,
			}).then(function (result) {
        var timelineItems = _toTimeline(result.items);
				if (!timelineItems.length) {
					return;
				}

        _.forEach(result.items, function (item) {
          vm.tasks.push(item);
        });

        _.forEach(timelineItems, function (item) {
          vm.timeline.push(item);
        });

        vm.tasksTotalCount = result.totalCount;
        var schedulingDates = vm.tasks.map(function (task) {
          if(task.scheduling.date){
            return moment(task.scheduling.date);
          }
          return null;
        });
        schedulingDates = schedulingDates.filter(function (schedulingDate) {return Boolean(schedulingDate); });
        vm.lastTaskDate = moment.max(schedulingDates).format('YYYY-MM-DD');
				vm.firstTaskDate = moment('2015-01-01').format('YYYY-MM-DD');
			});
		}

    function loadMoreTasks() {
      vm.taskOffset += vm.taskLimit;
      loadTasks();
    }

    function _toTimeline(tasks) {
      var timeline = [];

      tasks = tasks || [];
      tasks.forEach(function (task) {
        var currentStatus = TasksStatusHelper.getByName(task.status);
        var avatarUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg';
        if (task.employee && task.employee.avatarUrl) {
          avatarUrl = task.employee.avatarUrl;
        }

        var itemTime = task.scheduling.date ? LocalDateConvert.formatDate(task.scheduling.date) : null;
        if (task.scheduling.time) {
          itemTime += ' ' + task.scheduling.time;
        }

        var cardText = '';

        if (task.employee && task.employee.name) {
          cardText += '<br/>';
          cardText += '<span>Colaborador responsável: <b>' + task.employee.name + '</b></span>';
        } else {
          cardText += '<br/>';
          cardText += '<span>Sem colaborador</span>';
        }

        if (task.duration && (currentStatus.description != "Pendente" && currentStatus.description != "Cancelada"
        && currentStatus.description != "Em deslocamento" && currentStatus.description != "Em andamento")) {
          cardText += '<br/>';
          cardText += '<span>Duração da visita: <b>' + task.duration + ' minutos</b></span>';
        }

        if (task.scheduling && task.scheduling.date) {
          var schedulingDate = LocalDateConvert.formatDate(task.scheduling.date);
          var schedulingTime = task.scheduling.time ? task.scheduling.time.substring(0, 5) : '';

          cardText += '<br/>';
          cardText += '<span>Data/hora de agendamento: <b>' + schedulingDate + ' ' + schedulingTime + '</b></span>';
        }

        if (task.startedAt && currentStatus.description != "Cancelada") {
          cardText += '<br/>';
          cardText += '<span>Data/hora de início: <b>' + LocalDateConvert.formatDateTime(task.startedAt) + '</b></span>';
        }

        if (task.completedAt && currentStatus.description != "Cancelada") {
          cardText += '<br/>';
          cardText += '<span>Data/hora de conclusão: <b>' + LocalDateConvert.formatDateTime(task.completedAt) + '</b></span>';
        }

        var timelineEvent = {
          id: task.id,
          task: task,
          orderId: task.order.id,
          avatar: {
            src: avatarUrl,
            alt: task.employee && task.employee.name
          },
          title: task.order.service.id + ' - ' + task.order.service.description,
          createdAt: "Criado em " + LocalDateConvert.formatDateTime(task.metadata.createdAt),
          subtitle: currentStatus.description,
          subtitleColor: currentStatus.color,
          text: cardText,
          identifier: task.order.identifier,
          icon: currentStatus.icon,
          color: currentStatus.color,
          time: itemTime
        };
        timeline.push(timelineEvent);
      });

      return timeline;
    }

    function openTask(ev) {
      OrderDialog.editTask(ev, { id: ev.order.id });
    }

    // Location
    vm.customerLocations = [];
    vm.searchCustomerLocationByName = searchCustomerLocationByName;
    vm.createFirstCustomerLocation = createFirstCustomerLocation;
    vm.clearSelectedCustomerLocation = clearSelectedCustomerLocation;
    vm.selectedCustomerLocationChanged = selectedCustomerLocationChanged;
    vm.selectedLocationSectorChanged = selectedLocationSectorChanged;

    function searchCustomerLocationByName() {
      if (!vm.equipment.customer || !vm.equipment.customer.id) {
        return;
      }

      customerLocationsApi.search({
        where: {
          customerIds: [vm.equipment.customer.id],
          nameContains: vm.searchCustomerLocationText,
          archived: false
        },
        take: 10
      }).then(function (result) {
        vm.customerLocations = result.items;
      });
    }

    function createFirstCustomerLocation() {
      _showLoadingBar();

      customersApi.save({
        id: vm.equipment.customer.id,
        name: vm.equipment.customer.name,
        address: vm.equipment.customer.address
      }).then(function (result) {
        customersApi.getOne(vm.equipment.customer.id)
          .then(function (customer) {
            vm.equipment.location = customer.primaryLocation;
            vm.hasNoLocations = false;
            vm.selectedCustomerLocationChanged();

            _hideLoadingBar();
          });
      });
    }

    function clearSelectedCustomerLocation() {
      vm.equipment.location = null;

      $timeout(function () {
        focus('auto-complete-customer-location');
      }, 200);
    }

    function selectedCustomerLocationChanged() {
      loadLocationSectors();

      loadLocationEnvironments();
    }

    function selectedLocationSectorChanged(newLocationSector) {
      $timeout(function () {
        var newLocationSectorId = newLocationSector && newLocationSector.id;
        var currentLocationSectorId = vm.equipment && vm.equipment.locationSector && vm.equipment.locationSector.id;

        if (newLocationSectorId === currentLocationSectorId) {
          return;
        }

        vm.equipment.locationEnvironment = null;

        loadLocationEnvironments();
      });
    }

    function loadLocationSectors() {
      if (!vm.equipment.location || !vm.equipment.location.id) {
        vm.equipment.locationSector = null;
        return;
      }

      locationSectorsApiGraphQL.search({
        where: {
          locationId: vm.equipment.location.id
        },
        skip: 0,
        take: 1000
      }).then(function (response) {
        if (response && response.items.length) {
          vm.locationSectors = response.items
            .filter(function (item) {
              return !item.archived || (vm.equipment.locationSector && vm.equipment.locationSector.id === item.id);
            })
            .map(function (item) {
              if (item.archived) {
                item.name = item.name + $translate.instant('EQUIPMENTS.DIALOG.GENERAL.ARCHIVED');
              }

              return {
                value: item
              };
            });
        }
      });
    }

    function loadLocationEnvironments() {
      if (!vm.equipment.locationSector || !vm.equipment.locationSector.id) {
        vm.equipment.locationEnvironment = null;

        return;
      }

      locationEnvironmentsApiGraphQL.search({
        where: {
          locationSectorId: vm.equipment.locationSector.id
        },
        skip: 0,
        take: 1000
      }).then(function (response) {
        if (response && response.items.length) {
          vm.locationEnvironments = response.items
            .filter(function (item) {
              return !item.archived || (vm.equipment.locationEnvironment && vm.equipment.locationEnvironment.id === item.id);
            })
            .map(function (item) {
              if (item.archived) {
                item.name = item.name + $translate.instant('EQUIPMENTS.DIALOG.GENERAL.ARCHIVED');
              }

              return {
                value: item
              };
            });
        } else {
          vm.locationEnvironments = [];
        }
      });
    }

    // Equipment Attachments
    vm.saveAttachmentWhenEnterKey = saveAttachmentWhenEnterKey;
    vm.editAttachmentTitle = editAttachmentTitle;
    vm.cancelEditAttachment = cancelEditAttachment;
    vm.saveAttachmentTitle = saveAttachmentTitle;
    vm.viewOriginalAttachment = viewOriginalAttachment;
    vm.removeAttachment = removeAttachment;
    vm.cancelRemoveAttachment = cancelRemoveAttachment;
    vm.confirmRemoveAttachment = confirmRemoveAttachment;

    function saveAttachmentWhenEnterKey(e, attachment) {
      if (e.key === 'Enter') {
        e.preventDefault();
        vm.saveAttachmentTitle(attachment);
        return false;
      }
    }

    function saveAttachmentTitle(attachment) {
      _showLoadingBar();

      equipmentsApi.saveEquipmentAttachment(vm.equipment.id, attachment).then(function () {
        attachment.editing = false;
        attachment.removing = false;
        MessageDialog.showToast({
          hideDelay: 4000,
          message: $translate.instant('EQUIPMENTS.TOAST.IMAGE_TITLE_CHANGED')
        });
      }).finally(function () {
        _hideLoadingBar();
      });
    }

    function editAttachmentTitle(attachment) {
      attachment.editing = true;
      attachment.removing = false;
      attachment._previousTitle = attachment.title;
      focus("attachment_" + attachment.id);
    }

    function cancelEditAttachment(attachment) {
      attachment.title = attachment._previousTitle;
      attachment.editing = false;
    }

    function removeAttachment(attachment) {
      attachment.editing = false;
      attachment.removing = true;
      attachment.title = attachment._previousTitle;
    }

    function confirmRemoveAttachment(attachment) {
      _showLoadingBar();
      attachment.index = _.indexOf(vm.equipmentAttachments, attachment);

      equipmentsApi.deleteEquipmentAttachment(vm.equipment.id, attachment.id).then(function () {
        vm.equipmentAttachments.splice(attachment.index, 1);
        MessageDialog.showToast({
          hideDelay: 10000,
          message: $translate.instant('EQUIPMENTS.TOAST.IMAGE_DELETED')
        });
      });

      _hideLoadingBar();
    }

    function cancelRemoveAttachment(attachment) {
      attachment.removing = false;
    }

    function viewOriginalAttachment(attachment) {
      $timeout(function () {
        $window.open(attachment.path, '_blank');
      }, 100);
    }

    // Equipments types select
    vm.onChangeEquipmentType = onChangeEquipmentType;
    vm.checkRequiredCustomFields = checkRequiredCustomFields;
    vm.setValidityToCustomFields = setValidityToCustomFields;
    vm.getRequiredCustomFields = getRequiredCustomFields;

    function onChangeEquipmentType(currentEquipmentType) {
      if (!currentEquipmentType && vm.equipment.type) {
        currentEquipmentType = vm.equipment.type;
      }

      if (currentEquipmentType && currentEquipmentType.id) {
        vm.checkRequiredCustomFields(currentEquipmentType);
        _getAllCustomFieldFromEquipmentType(currentEquipmentType.id);
        _updateAllCustomFieldsAnswersFromEquipment();
      } else {
        vm.customFieldEquipmentType = [];
      }
    }

    function _getAllCustomFieldFromEquipmentType(equipmentTypeId) {
      return equipmentTypesApi.getCustomFieldFromEquipmentType(equipmentTypeId)
        .then(function (result) {
          _.defer(function () {
            $scope.$apply(function () {
              vm.customFieldEquipmentType = orderCustomFieldsByPosition(result.items || []);
            });
          });
        });
    }

    function orderCustomFieldsByPosition(customFields) {
      var orderedCustomFields = _.map(customFields, function (customField) {
        if (customField.type === 'multiple-choice' && customField.options && customField.options.length) {
          customField.options = _.sortBy(customField.options, 'position');
        }

        return customField;
      });

      return _.sortBy(orderedCustomFields, 'position');
    }

    function checkRequiredCustomFields(currentEquipmentType) {
      var customFields = currentEquipmentType || vm.customFieldEquipmentType;

      if (customFields.length) {
        vm.getRequiredCustomFields(customFields);
      } else {
        vm.customFieldIsInvalid = false;
      }

      return vm.customFieldIsInvalid;
    }

    function getRequiredCustomFields(customFields) {
      var requiredQuestions = customFields.filter(function (question) {
        return question.required;
      });

      if (requiredQuestions.length > 0) {
        var allRequiredQuestionsAnswered = _.every(requiredQuestions, function (filteredQuestion) {
          return filteredQuestion.answer;
        });

        vm.setValidityToCustomFields(allRequiredQuestionsAnswered);
      } else {
        vm.customFieldIsInvalid = false;
      }
    }

    function setValidityToCustomFields(requiredQuestionsAnswered) {
      if(requiredQuestionsAnswered) {
        vm.customFieldIsInvalid = false;
      } else {
        vm.customFieldIsInvalid = true;
      }
    }

    function removeUploadedAttachment(attachmentIndex) {
      vm.files.splice(attachmentIndex, 1);
    }

    $scope.$on("$destroy", function () {
      var equipmentTab = document.getElementById('equipmentTab');
      if (equipmentTab) {
        equipmentTab.removeEventListener('scroll', _searchLogsAfterScrolledToTheBottom);
      }
    });

    function _searchLogsAfterScrolledToTheBottom(event) {
      var element = event && event.target;
      var hasScrolledToTheBottom = element && (element.scrollHeight - element.scrollTop === element.clientHeight);
      if (vm.equipment.id && !vm.loadingTimeline && hasScrolledToTheBottom && vm.selectedTabIndex === 4) {
        loadTimeline();
      }
    }

    function loadTimeline(isFirstLoad) {
      if (!vm.hasMoreTimeline) {
        return;
      }

      _showLoadingBar();
      vm.loadingTimeline = true;

      if (isFirstLoad) {
        vm.equipmentLogs = [];
        vm.lastEquipmentLogCursor = null;

        var equipmentTab = document.getElementById('equipmentTab');
        if (equipmentTab) {
          equipmentTab.addEventListener('scroll', _searchLogsAfterScrolledToTheBottom);
        }
      }

      var variables = {
        equipmentId: vm.equipment.id,
        equipmentLogQueryInput: {
          cursor: vm.lastEquipmentLogCursor,
          direction: 'desc',
          take: 10
        }
      };

      equipmentsApi
        .getEquipmentLogs(variables)
        .then(function (loadedLogs) {
          if (!loadedLogs.pageInfo.endCursor) {
            vm.hasMoreTimeline = false;
          }

          var formattedLogs = EquipmentsTimelineService.toTimeline(loadedLogs.items);
          vm.equipmentLogs = vm.equipmentLogs.concat(formattedLogs);
          vm.lastEquipmentLogCursor = loadedLogs.pageInfo.endCursor;
        })
        .finally(function () {
          _hideLoadingBar();
          vm.loadingTimeline = false;
        });
    }

    function filterLabel(label) {
			if (!vm.labelSearchText || vm.labelSearchText === '') {
				return true;
			}
			var labelName = angular.lowercase(label.name);
			var labelSearchText = angular.lowercase(vm.labelSearchText);

			return labelName.indexOf(labelSearchText) >= 0;
		}

    function toggleInArray(label) {
      equipmentsLabelsService.toggleLabel(label, vm.equipment, vm.labels, function (equipment) {
        _setEquipmentLabelsDebounced(equipment, true);
        vm.equipment.labels = equipment.labels;
      });
    }

    function addNewLabel(label) {
      equipmentsLabelsService.addLabel(label, function () {
        vm.newLabelColor = null;
        vm.newLabelName = null;
        vm.labelTabIndex = 0;
        _loadLabels();
      });
		}

    function editLabel(label) {
			vm.editingLabel = label;
			vm.labelTabIndex = 2;
		}

		function updateLabel(labelToUpdate) {
      equipmentsLabelsService.updateLabel(labelToUpdate, function () {
				vm.editingLabel = null;
				vm.labelTabIndex = 0;
        updateLabelNameBeforeSave(labelToUpdate);
				_loadLabels();
      });
		}

    function updateLabelNameBeforeSave(updatedLabel) {
      _.forEach(vm.equipment.labels, function (label) {
        if (updatedLabel.id === label.id) {
          label.name = updatedLabel.name;
          label.color = updatedLabel.color;
        }
      });
    }

    function _showSuccessToast(message) {
      document.dispatchEvent(new CustomEvent('showSuccessAlert', { detail: { message: message } }));
    }

    function _showErrorToast(message) {
      document.dispatchEvent(new CustomEvent('showErrorAlert', { detail: { message: message } }));
    }

    function _showLoadingBar() {
			document.dispatchEvent(new CustomEvent('showLoadingBar'));
      vm.isLoading = true;
		}

		function _hideLoadingBar() {
			document.dispatchEvent(new CustomEvent('hideLoadingBar'));
      vm.isLoading = false;
		}

    function updateTabs() {
      vm.tabs['warranties'] = 1;
      vm.tabs['custom-fields'] = 2;
      vm.tabs['attachments'] = 3;
      vm.tabs['services'] = 4;
      vm.tabs['history'] = 5;
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('EquipmentTypesDialog', EquipmentTypesDialog);

  /** @ngInject */
  function EquipmentTypesDialog(
    $mdDialog, $rootScope, $q, formsApi, $document, equipmentTypesApi, accountsApi, servicesApi,
    knowledgeBasesApi, accountFeatureFlagsApiGraphQL
  ) {

    return {
      createEquipmentTypes: createEquipmentTypes,
      editEquipmentTypes: editEquipmentTypes
    };

    function createEquipmentTypes(ev, callback) {
      _loaderOn();

      var requests = {
        equipmentTypes: equipmentTypesApi.getEquipmentTypes(),
        account: accountsApi.get(),
        services: servicesApi.getAll(),
        knowledgeBases: knowledgeBasesApi.search({ take: 100, where: { archived: false } }),
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags()
      };

      $q.all(requests).then(function (result) {
        var activatedServices = _getActiveServices(result.services.items);

        _openEquipmentTypesDialog(ev, {
          EquipmentType: null,
          EquipmentTypes: result.equipmentTypes,
          CustomFields: [],
          Account: result.account,
          Services: activatedServices,
          KnowledgeBases: result.knowledgeBases,
          FeatureFlags: result.featureFlags,
          event: ev
        }, callback);

      }).finally(_loaderOff);
    }

    function editEquipmentTypes(ev, id, callback) {
      _loaderOn();

      var requests = {
        equipmentType: equipmentTypesApi.getOneEquipmentType(id, { include: 'forms,knowledgeBase' }),
        equipmentTypes: equipmentTypesApi.getEquipmentTypes(),
        customFields: equipmentTypesApi.getCustomFieldFromEquipmentType(id),
        services: servicesApi.getAll(),
        account: accountsApi.get(),
        knowledgeBases: knowledgeBasesApi.search({ take: 100, where: { archived: false } }),
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags()
      };

      $q.all(requests).then(function (result) {
        var activatedServices = _getActiveServices(result.services.items);
        result.equipmentType.forms = result.equipmentType.forms.filter(function (form) { return !form.archived; });

        _openEquipmentTypesDialog(ev, {
          EquipmentType: result.equipmentType,
          EquipmentTypes: result.equipmentTypes,
          CustomFields: result.customFields,
          Account: result.account,
          Services: activatedServices,
          KnowledgeBases: result.knowledgeBases,
          FeatureFlags: result.featureFlags,
          event: ev
        }, callback);

      }).finally(_loaderOff);
    }

    function _openEquipmentTypesDialog(ev, locals, callback) {
      $mdDialog.show({
        controller: 'EquipmentTypesDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/equipment-types/dialogs/equipment-types-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }

    function _loaderOn() {
      $rootScope.loadingProgress = true;
    }

    function _loaderOff() {
      $rootScope.loadingProgress = false;
    }

    function _getActiveServices(services) {
      return _.filter(services, function (service) {
        return !service.archived;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.equipment-types')
    .controller('EquipmentTypesDialogController', EquipmentTypesDialogController);

  /** @ngInject */
  function EquipmentTypesDialogController(
    $scope, $mdDialog, EquipmentType, EquipmentTypes, ServicesApiGraphQL,
    Account, Services, $mdToast, _, focus, equipmentTypesApi, CustomFields,
    $timeout, $rootScope, $translate, msUtils, formsApi, gandalfApi, KnowledgeBases, FeatureFlags
  ) {
    $scope.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) list.splice(idx, 1);
      else list.push(item);
      $scope.equipmentsForm.name.$setDirty();
    };
    $scope.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    var vm = this;
    vm.formErr = {};
    $rootScope.loadingProgress = false;
    vm.equipmentType = angular.copy(EquipmentType);
    vm.equipmentTypes = angular.copy(EquipmentTypes.items);
    vm.knowledgeBases = angular.copy(KnowledgeBases.items);
    vm.featureFlags = angular.copy(FeatureFlags);

    vm.customFieldTypes = [
      { id: 0, value: 'question' },
      { id: 1, value: 'multiple-choice' },
      { id: 2, value: 'date' },
      { id: 3, value: 'number' }
    ];
    vm.wasCreated = true;
    vm.accountConfiguration = Account.configuration;
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['equipment-type-name'];
    vm.hasKnowledgeBaseFeatureFlag = hasFeatureFlag('knowledge-base-beta-flag');

    vm.knowledgeBasesOptions = vm.knowledgeBases.map(function (knowledgeBase) {
      return {
        value: { id: knowledgeBase.id, name: knowledgeBase.name }
      };
    });

    if (!vm.equipmentType) {
      vm.equipmentType = {
        id: '',
        name: '',
        archived: false,
        customFields: [],
        showKnowledgeBase: false,
        knowledgeBase: {
          id: null,
        },
      };
      // ADDING THE FIRST DEFAULT QUESTION 'PLACEHOLDER'
      addQuestion();
    } else {
      vm.equipmentType.showKnowledgeBase = Boolean(vm.equipmentType.knowledgeBase);
      vm.equipmentType.customFields = angular.copy(CustomFields.items);

      if (vm.equipmentType.archived) {
        vm.wasCreated = false;
      }

      vm.equipmentType.customFields = vm.equipmentType.customFields || [];
      vm.equipmentType.customFields = _.sortBy(vm.equipmentType.customFields, 'position');
      vm.equipmentType.customFields.forEach(function (question) {
        question.options = question.options || [];
        question.options = _.sortBy(question.options, 'position');
      });
    }

    vm.msScrollOptions = {
      suppressScrollX: true
    };

    vm.optionsSortableOptions = {
      handle: '> .handle-options',
      update: setFormDirty,
      disabled: vm.equipmentType.locked
    };

    vm.closeDialog = closeDialog;
    vm.saveEquipmentType = saveEquipmentType;
    vm.archiveEquipmentType = archiveEquipmentType;
    vm.unarchiveEquipmentType = unarchiveEquipmentType;
    vm.addQuestion = addQuestion;
    vm.removeQuestion = removeQuestion;
    vm.setItemFocus = setItemFocus;
    vm.setFormDirty = setFormDirty;
    vm.reorderQuestions = reorderQuestions;
    vm.addDefaultOption = addDefaultOption;
    vm.preventDefault = preventDefault;
    vm.removeOption = removeOption;
    vm.addOption = addOption;
    vm.changeShowKnowledgeBase = changeShowKnowledgeBase;
    vm.hasFeatureFlag = hasFeatureFlag;

    vm.allServices = angular.copy(Services);
    vm.services = angular.copy(Services);
    vm.searchServices = searchServices;
    vm.serviceSearchTerm = '';

    function addQuestion() {
      vm.equipmentType.customFields = vm.equipmentType.customFields || [];
      vm.equipmentType.customFields.push({
        name: $translate.instant('EQUIPMENT_TYPES.DIALOG.FORMS.QUESTION') + ' ' + (vm.equipmentType.customFields.length + 1),
        required: false,
        type: 'question',
        position: vm.equipmentType.customFields.length,
        options: []
      });
      focus('question_' + (vm.equipmentType.customFields.length - 1));
    }

    function removeOption(question, index) {
      question.options = question.options || [];
      question.options.splice(index, 1);
      setFormDirty();
    }

    function addOption(question) {
      var answers = _.filter(question.options, function (option) {
        return option.value;
      });

      if (answers.length === question.options.length) {
        question.options = question.options || [];
        question.options.push({
          value: $translate.instant('EQUIPMENT_TYPES.DIALOG.FORMS.OPTION') + ' ' + (question.options.length + 1)
        });

        setFormDirty();
      }
    }

    function addDefaultOption(question) {
      if ((question.type === 'multiple-choice') && question.options.length === 0) {
        question.options = question.options || [];
        question.options.push({
          value: $translate.instant('EQUIPMENT_TYPES.DIALOG.FORMS.OPTION') + ' 1'
        });
      }
    }

    function removeQuestion(index) {
      vm.equipmentType.customFields = vm.equipmentType.customFields || [];
      vm.equipmentType.customFields.splice(index, 1);
      setFormDirty();
    }

    function setItemFocus($index) {
      $('.form-question').removeClass('question-focus');
      $('.form-question-' + $index).addClass('question-focus');
    }

    function preventDefault(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    function reorderQuestions(index, direction) {
      if (direction === 'up') {
        vm.equipmentType.customFields[index].position = vm.equipmentType.customFields[index].position - 1;
        vm.equipmentType.customFields[index - 1].position = vm.equipmentType.customFields[index - 1].position + 1;
      } else {
        vm.equipmentType.customFields[index].position = vm.equipmentType.customFields[index].position + 1;
        vm.equipmentType.customFields[index + 1].position = vm.equipmentType.customFields[index + 1].position - 1;
      }
      vm.equipmentType.customFields = _.sortBy(vm.equipmentType.customFields, 'position');
      setFormDirty();
    }

    function setFormDirty() {
      $timeout(function () {
        if ($scope && $scope.equipmentsForm) {
          $scope.equipmentsForm.$setDirty();
        }
      }, 100);
    }

    function _buidOrderedCustomFieldArray(customFields) {
      var questionPosition = 1;
      customFields.forEach(function (question) {
        question.position = questionPosition++;

        if (question.id) { delete question.id; }
        if (question.options) {
          question.options = _.reject(question.options, function (option) {
            return option.value === '' || option.value === undefined;
          });

          question.options.forEach(function (option, index) {
            option.position = index;
          });
        }
      });
      return customFields;
    }

    function saveEquipmentType(equipmentType, options) {
      $rootScope.loadingProgress = true;
      var orderedCustomFieldArray = vm.equipmentType.customFields ? _buidOrderedCustomFieldArray(vm.equipmentType.customFields) : [];

      equipmentTypesApi.saveEquipmentType(equipmentType).then(function (savedEquipmentType) {
        if (!equipmentType.id) {
          for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
            var field = vm.smartRewriteFields[i];
            var params = {
              reference: vm.sessionId,
              referenceType: field,
              updatedReference: savedEquipmentType.id
            };

            gandalfApi.updateRewriteInputHistory(params);
          }
        }

        equipmentTypesApi.saveCustomFieldQuestions(savedEquipmentType.id, orderedCustomFieldArray).then(function () {
          var equipmentTypeForms = _.map(vm.equipmentType.forms, function (form) {
            if (form.service.id === "null") {
              form.service = null;
            }

            return { id: form.id, required: form.required, service: form.service };
          });

          equipmentTypesApi.setForms(savedEquipmentType.id, equipmentTypeForms).then(function () {
            $mdToast.show(
              $mdToast.simple().textContent($translate.instant(options.toastMessage || 'EQUIPMENT_TYPES.TOAST.SAVED')).hideDelay(3000)
            );

            $rootScope.loadingProgress = false;
            $rootScope.$broadcast('equipment-types:reload');
          });
        }).catch(function (err) {
          $mdToast.show(
            $mdToast.simple().textContent($translate.instant('EQUIPMENT_TYPES.TOAST.SAVE_FAILED')).hideDelay(3000)
          );
        }).finally(function () {
          $rootScope.loadingProgress = false;
          if (options.closeDialog) closeDialog(true);
        });
      });
    }

    function archiveEquipmentType($event) {
      vm.equipmentType.archived = true;
      saveEquipmentType(vm.equipmentType, { closeDialog: true, toastMessage: 'EQUIPMENT_TYPES.TOAST.ARCHIVED' });
    }

    function unarchiveEquipmentType($event) {
      vm.equipmentType.archived = false;
      saveEquipmentType(vm.equipmentType, { closeDialog: true, toastMessage: 'EQUIPMENT_TYPES.TOAST.UNARCHIVED' });
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }

    function changeShowKnowledgeBase() {
      if (!vm.equipmentType.showKnowledgeBase) {
        vm.equipmentType.knowledgeBase = { id: null };
      }
    }

    function hasFeatureFlag(name) {
      var hasFeature = vm.featureFlags.find(function (featureFlag) {
        return featureFlag.name === name;
      });

      if (!hasFeature) { return false; }

      return hasFeature.active;
    }

    function searchServices() {
      var params = {
        take: 100,
        where: {
          description: vm.serviceSearchTerm,
          archived: false
        }
      };

      ServicesApiGraphQL.search(params)
        .then(function (services) {
          var searchedServices = angular.copy(services.items || []);

          var currentServicesOnForms = _.filter(vm.equipmentType.forms, function (form) {
            return form.service && form.service.id !== 'null';
          });

          _.forEach(currentServicesOnForms, function (form) {
            var formService = _.find(searchedServices, function (service) {
              return service.id === form.service.id;
            });

            if (!formService) {
              var foundService = _.find(vm.allServices, function (service) {
                return Number(service.id) === Number(form.service.id);
              });

              if (foundService) {
                searchedServices.push(foundService);
              }
            }
          });

          vm.services = searchedServices;
        });
    }

    /**
     * FORMS
     */

    vm.allForms = [];
    vm.forms = [];
    vm.searchForm = searchForm;
    vm.addForm = addForm;
    vm.deleteForm = deleteForm;
    vm.validateServiceSelect = validateServiceSelect;

    function searchForm() {
      var options = { limit: 1000, offset: 0 };
      var query = { archived: 'no' };
      if (vm.formSearchTerm) {
        query['name~~*'] = '*' + vm.formSearchTerm + '*';
      }

      formsApi.search(query, options)
        .then(function (forms) {
          var currentFormsIds = vm.equipmentType.forms.map(function (form) { return form.id; });
          var activeForms = forms.items.filter(function (form) {
            return form.archived === false && !currentFormsIds.includes(form.id);
          });

          vm.forms = activeForms;
          vm.allForms = activeForms;
        });
    }

    _initializeForms();

    function deleteForm(form) {
      vm.equipmentType.forms = _.filter(vm.equipmentType.forms, function (item) {
        return item._id !== form._id;
      });

      validateServiceSelect(form);
      updateFormSelect();
      searchForm();
    }

    function addForm(id) {
      var currentForm = _.find(vm.forms, function (form) {
        return form.id === id;
      });

      if (currentForm) {
        var formToAdd = angular.copy(currentForm);
        formToAdd.hideOptionAllOfSelectService = true;
        formToAdd._id = msUtils.uuidGenerator();
        formToAdd.required = false;
        formToAdd.error = { allServices: false, sameService: false };
        formToAdd.service = { id: 'null' };

        vm.equipmentType.forms.push(formToAdd);
        validateServiceSelect(formToAdd);
      }

      updateFormSelect();
      setFormDirty();
    }

    function validateServiceSelect(form) {
      vm.serviceSearchTerm = '';

      var formsIds = vm.equipmentType.forms.map(function (item) { return item._id; });
      var sameForms = _.filter(vm.equipmentType.forms, function (sameForm) {
        return sameForm.id === form.id && form._id !== sameForm._id;
      });
      var sameFormsServices = sameForms.map(function (item) { return item.service.id.toString(); });

      $scope.equipmentsForm.$setValidity('same_service', true);
      $scope.equipmentsForm.$setValidity('all_service', true);

      if (!sameForms.length) {
        form.error = { sameService: false, allServices: false };

        updateFormSelect();
        setFormDirty();
        return;
      }

      for (var index = 0; index < sameForms.length; index++) {
        var item = sameForms[index];
        item.error = { sameService: false, allServices: false };

        if (item.service.id.toString() === form.service.id && formsIds.includes(form._id)) {
          item.error = { sameService: true, allServices: false };
          $scope.equipmentsForm.$setValidity('same_service', false);
          continue;
        }

        if (item.service.id.toString() === 'null' && sameForms.length > 1) {
          item.error = { sameService: false, allServices: true };
          $scope.equipmentsForm.$setValidity('all_service', false);
          continue;
        }

        for (var i = 0; i < sameForms.length; i++) {
          var othersForms = sameForms[i];
          if (item.service.id.toString() === othersForms.service.id.toString() && othersForms._id !== item._id) {
            item.error = { sameService: true, allServices: false };
            $scope.equipmentsForm.$setValidity('same_service', false);
            break;
          }
        }
      }

      if (formsIds.includes(form._id)) {
        var equalFormsId = vm.equipmentType.forms.map(function (item) {
          return item.service.id.toString();
        });

        if (equalFormsId.indexOf('null', form.service.id.toString()) > -1) {
          form.error = { sameService: false, allServices: true };
          return $scope.equipmentsForm.$setValidity('all_service', false);
        }

        if (sameFormsServices.includes(form.service.id)) {
          form.error = { sameService: true, allServices: false };
          return $scope.equipmentsForm.$setValidity('same_service', false);
        }

        form.error = { sameService: false, allServices: false };
      }

      updateFormSelect();
      setFormDirty();
    }

    function filterFormsAvailable(form){
      if(form){
        return !form.archived;
      }
    }

    function updateFormSelect() {
      var availableForms = [];

      vm.allForms.forEach(function (form) {
        vm.equipmentType.forms = vm.equipmentType.forms || [];
        var selectedForm = _.find(vm.equipmentType.forms, function (f) {
          return f.id === form.id;
        });

        if (!form.archived && (!selectedForm || (selectedForm && selectedForm.service.id !== 'null'))) {
          availableForms.push(form);
        }
      });

      vm.forms = availableForms;
      vm.selectedFormId = null;

      if (!availableForms.length) {
        vm.formSearchTerm = '';
        vm.searchForm();
      }
    }

    function _initializeForms() {
      vm.equipmentType.forms = vm.equipmentType.forms || [];

      if (vm.equipmentType.forms.length) {
        vm.equipmentType.forms.forEach(function (item) {
          item._id = msUtils.uuidGenerator();
          item.error = { allServices: false, sameService: false };

          if (!item.service) {
            item.service = { id: 'null' };
          }
        });
      }

      searchForm();
      updateFormSelect();
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
      .factory('EmployeeService', EmployeeService);

  /** @ngInject */
  function EmployeeService($rootScope, $mdDialog) {

      return {
          showMaxAllowedEmployeesMessage: showMaxAllowedEmployeesMessage
      };

      function showMaxAllowedEmployeesMessage(accountLimitEmployee) {
        $rootScope.loadingProgress = false;
        var alert = $mdDialog.alert({
            title: 'Número máximo de licenças',
            htmlContent: 'Você atingiu o número máximo de ' + accountLimitEmployee + ' colaboradores ativos. <br/>Para aumentar o número de licenças entre em contato com <strong>financeiro@fieldcontrol.com.br</strong>',
            ok: 'Ok'
        });
        $mdDialog.show(alert).then();
      }
  }

})();

(function () {
  'use strict';

  angular.module('app.core')
      .factory('EmployeeDialog', EmployeeDialog);

  /** @ngInject */
  function EmployeeDialog($mdDialog, $rootScope, $q, servicesApi, $document, employeesApi, accountsApi, groupsApi) {
    return {
      createEmployee: createEmployee,
      editEmployee: editEmployee,
      inactivateEmployee: inactivateEmployee,
      activateEmployee: activateEmployee,
      deleteDevices: deleteDevices
    };

    function createEmployee(ev, countActiveEmployees, callback) {
      _loaderOn();

      var requests = {
        services: servicesApi.getAll(),
        account: accountsApi.get(),
        groups: groupsApi.search({ take: 100, where: { archived: false, userType: 'employees' } })
      };

      $q.all(requests).then(function (result) {
        _openEmployeeDialog(ev, {
          Employee: null,
          Services: result.services.items,
          Account: result.account,
          Groups: result.groups.items,
          countActiveEmployees: countActiveEmployees,
          event: ev
        }, callback);
      }).finally(_loaderOff);
    }

    function editEmployee(ev, id, countActiveEmployees, callback) {
      _loaderOn();

      var requests = {
        employee: employeesApi.get(id),
        services: servicesApi.getAll(),
        account: accountsApi.get(),
        groups: groupsApi.search({ take: 100, where: { archived: false, userType: 'employees' } })
      };

      $q.all(requests).then(function (result) {
        _openEmployeeDialog(ev, {
          Employee: result.employee,
          Services: result.services.items,
          Account: result.account,
          Groups: result.groups.items,
          countActiveEmployees: countActiveEmployees,
          event: ev
        }, callback);
      }).finally(_loaderOff);
    }

    function _openEmployeeDialog(ev, locals, callback) {
      $mdDialog.show({
        controller: 'EmployeeDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employees/dialogs/employee-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }

    function inactivateEmployee(ev, id, callback) {
      if (!id || id === 'null') return;

      _loaderOn();

      employeesApi.get(id).then(function (employee) {

        $mdDialog.show({
          controller: 'InactivateEmployeeDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/employees/dialogs/inactivate/employee-dialog.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          multiple: true,
          locals: {
            Employee: employee
          }
        }).then(function (reload) {
          if (reload) {
            deleteDevices(ev, id, callback);
          } else {
            if (callback) {
              callback(reload);
            }
          }
        });

      }).finally(_loaderOff);
    }

    function deleteDevices(ev, id, callback) {
      if (!id || id === 'null') return;

      _loaderOn();

      employeesApi.get(id).then(function (employee) {
        $mdDialog.show({
          controller: 'DeleteDevicesDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/employees/dialogs/delete-devices/delete-devices-dialog.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          multiple: true,
          locals: {
            Employee: employee
          }
        }).then(function (reload) {
          if (callback) {
            callback(reload);
          }
        });
      });
    }

    function activateEmployee(ev, id, callback) {
      if (!id || id === 'null') return;

      _loaderOn();

      employeesApi.get(id).then(function (employee) {

        $mdDialog.show({
          controller: 'ActivateEmployeeDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/employees/dialogs/activate/employee-dialog.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          multiple: true,
          locals: {
            Employee: employee
          }
        }).then(function (reload) {
          if (callback) {
            callback(reload);
          }
        });

      }).finally(_loaderOff);
    }

    function _loaderOn() {
      $rootScope.loadingProgress = true;
    }

    function _loaderOff() {
      $rootScope.loadingProgress = false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.employees')
    .controller('EmployeeDialogController', EmployeeDialogController);

  /** @ngInject */
  function EmployeeDialogController(
    $scope, $mdDialog, Services, Employee, $mdToast, _, focus,
    employeesApi, geoCoder, moment, $timeout, EmployeeDialog, Groups,
    $rootScope, haversine, Account, countActiveEmployees, EmployeeService, gandalfApi,
    uploadApi, msUtils, authApi, $translate, dateHandler, addressService, devicesApi,
    accountFeatureFlagsApiGraphQL, employeesApiGraphQL, translateService, LocalDateConvert, validateTimeService,
    employeeDocumentDuplicatedValidationService
  ) {
    var vm = this;
    vm.language = translateService.getLanguage() || 'pt';
    vm.formErr = {};
    vm.employee = angular.copy(Employee);
    vm.initialEmployee = angular.copy(Employee);
    vm.allServices = Services;
    vm.location = {};
    vm.groups = Groups;
    vm.locationAddressErrors = null;
    vm.locationAddressWarnings = null;
    vm.invalidLocationAddress = null;

    vm.allowRemoveEmployeeFiredAt = false;
    vm.selectAll = false;
    vm.geoCoderOk = false;
    vm.newEmployee = false;
    vm.isHired = true;
    vm.avatarImage = null;
    vm.avatarResultImage = null;
    vm.samplePassword = '{$Assd10937';
    vm.hasEmail = false;
    vm.services = _.filter(vm.allServices, function (service) { return !service.archived; });
    vm.employeeSkills = [];
    vm.employeeDevices = [];
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['employee-notes'];
    vm.searchTerm = '';

    vm.hasMultipleEmployeeAccountsFlag = false;
    vm.hasTerritoriesFlag = false;

    vm.allowUpdateWithQrCode = vm.employee && vm.employee.id && !vm.employee.contract.firedAt;
    vm.countryCode = Account.address.countryCode;
    vm.duplicatedValidation = _.debounce(duplicatedValidation, 300);
    vm.closeDialog = closeDialog;
    vm.saveEmployee = saveEmployee;
    vm.checkEmailErr = checkEmailErr;
    vm.searchAddress = searchAddress;
    vm.selectedAddressItemChange = selectedAddressItemChange;
    vm.validateEmployeeAddress = validateEmployeeAddress;
    vm.clearSelectedEmployeeAddress = clearSelectedEmployeeAddress;
    vm.onChangeEmployeeFiredAt = onChangeEmployeeFiredAt;
    vm.fireEmployee = fireEmployee;
    vm.rehireEmployee = rehireEmployee;
    vm.toogleAllServices = toogleAllServices;
    vm.toggleService = toggleService;
    vm.serviceIsChecked = serviceIsChecked;
    vm.validateEmployeeAddressChange = validateEmployeeAddressChange;
    vm.inactivateEmployee = inactivateEmployee;
    vm.passwordExpiredAt = null;
    vm.hasCredential = false;
    vm.generateTempPassword = generateTempPassword;
    vm.generateCredential = generateCredential;
    vm.employeeCredentialDialogClosedEvent = employeeCredentialDialogClosedEvent;
    vm.activateEmployee = activateEmployee;
    vm.timeFormatIsActive = vm.language === 'en';
    vm.startTimeFormat = '';
    vm.endTimeFormat = '';
    vm.updateStartTimeFormat = updateStartTimeFormat;
    vm.updateEndTimeFormat = updateEndTimeFormat;
    vm.validateTime = validateTime;
    vm.isEmployeeFiredAndBeforeToday = isEmployeeFiredAndBeforeToday;

    function duplicatedValidation(employee, input) {
      employeeDocumentDuplicatedValidationService.validate(employee, input);
    }

    function _initialize() {
      _loadFeatureFlags();

      if (!vm.employee) {
        vm.employee = {
          contract: {
            hiredAt: moment().subtract(1, "days").toDate()
          },
          address: {
            coords: {}
          },
          workSchedule: {
            start: '08:00',
            end: '18:00',
            break: {
              start: '12:00',
              end: '13:00'
            }
          },
          device: {},
          groups: [],
          password: null,
          confirmPassword: null
        };

        vm.newEmployee = true;
        vm.services.forEach(function (service) {
          vm.employeeSkills.push(service.id);
        });

        vm.selectAll = (vm.employeeSkills.length === vm.services.length);
        vm.samplePassword = msUtils.generateRandomPassword();
      } else {
        vm.geoCoderOk = vm.employee.address.coords.latitude && vm.employee.address.coords.longitude;
        vm.employee.contract.hiredAt = moment(vm.employee.contract.hiredAt).toDate();

        if (vm.employee.contract.firedAt) {
          vm.employee.contract.firedAt = moment(vm.employee.contract.firedAt).toDate();
          vm.isHired = false;
        }

        if (vm.employee.workSchedule) {
          if (vm.employee.workSchedule.start) {
            vm.employee.workSchedule.start = dateHandler.formatTimeToShort(vm.employee.workSchedule.start);
            if (vm.timeFormatIsActive) {
              vm.startTimeFormat = moment(vm.employee.workSchedule.start, 'HH:mm').format('a');
              vm.employee.workSchedule.start = LocalDateConvert.convertTimeToShow(vm.employee.workSchedule.start);
            }
          }

          if (vm.employee.workSchedule.end) {
            vm.employee.workSchedule.end = dateHandler.formatTimeToShort(vm.employee.workSchedule.end);
            if (vm.timeFormatIsActive) {
              vm.endTimeFormat = moment(vm.employee.workSchedule.end, 'HH:mm').format('a');
              vm.employee.workSchedule.end = LocalDateConvert.convertTimeToShow(vm.employee.workSchedule.end);
            }
          }
        }

        employeesApi.getSkills(vm.employee.id).then(function (skills) {
          vm.employeeSkills = _.map(skills, 'id');
          vm.selectAll = (vm.employeeSkills.length === vm.services.length);
        });

        if (vm.employee.email) {
          vm.hasEmail = true;
        }

        vm.hasEmployeeAddress = true;
        vm.passwordExpiredAt = vm.employee.passwordExpiredAt;
        vm.hasCredential = vm.employee.hasCredential;
      }
      validateEmployeeAddress();
      getEmployeeDevices();

      vm.selectedEmployeeAddress = vm.employee.address.formattedAddress || '';
      vm.selectedEmployeeAddressText = vm.employee.address.formattedAddress || '';

      focus('name');
    }

    function isEmployeeFiredAndBeforeToday(firedAt) {
      if (!firedAt) {
        return false;
      }

      var firedAtMoment = moment(firedAt);

      return firedAtMoment.isBefore(moment());
    }

    function employeeCredentialDialogClosedEvent() {
      closeDialog(true);
      document.removeEventListener('employeeCredentialDialogClosed', employeeCredentialDialogClosedEvent);
    }

    function updateStartTimeFormat(value) {
      vm.startTimeFormat = value;
    }

    function updateEndTimeFormat(value) {
      vm.endTimeFormat = value;
    }

    function getEmployeeDevices() {
      var queryOptions = {
        limit: 100
      };
      var query = {
        last_seen_employee_id: vm.employee._id
      };
      devicesApi.search(query, queryOptions).then(function (devices) {
        vm.employeeDevices = devices.items;
      });
    }

    function checkEmailErr() {
      if (vm.formErr['employee_email_already_taken_value'] !== vm.employee.email) {
        delete vm.formErr['email_already_taken'];
        delete vm.formErr['EMAIL_ALREADY_IN_USE'];
      }
    }

    function searchAddress(addressAsString) {
      var start = {
        latitude: parseFloat(Account.address.coords.latitude),
        longitude: parseFloat(Account.address.coords.longitude)
      };

      return geoCoder.getByAddressString(addressAsString).then(function (results) {
        results.forEach(function (result) {
          var end = {
            latitude: parseFloat(result.lat),
            longitude: parseFloat(result.lng)
          };

          result.kmDistance = haversine(start, end, 'km');
        });

        return _.sortBy(results, 'kmDistance');
      });
    }

    function selectedAddressItemChange(selectedAddress) {
      if (selectedAddress) {
        $timeout(function () {
          if ($scope.employeeForm) {
            $scope.employeeForm.$setDirty();
          }
        }, 1000);

        vm.employee.address = {
          zipCode: selectedAddress.zipCode || null,
          city: selectedAddress.city || null,
          state: selectedAddress.state || null,
          neighborhood: selectedAddress.neighborhood || null,
          street: selectedAddress.street || null,
          number: selectedAddress.number || null,
          coords: {
            latitude: selectedAddress.lat,
            longitude: selectedAddress.lng
          },
          formattedAddress: selectedAddress.formattedAddress
        };

        vm.geoCoderOk = true;

        vm.hasEmployeeAddress = true;
        delete vm.formErr['employeeAddressIsRequired'];
      }
    }

    function validateEmployeeAddress() {
      var validation = addressService.validateAddress(vm.employee.address);
      validation.warnings = validation.warnings.filter(function (warning) {
        return warning !== 'NEIGHBORHOOD';
      });
      vm.locationAddressErrors = validation.errors;
      vm.locationAddressWarnings = validation.warnings;

    }

    function validateTime() {
      function getFormInputBySelector(selector) {
        var employeeFormInput = $scope.employeeForm[selector];
        return employeeFormInput || null;
      }
      var isGreaterThan12Hours = validateTimeService.isGreaterThan12Hours;
      var isMinorThan1Hour = validateTimeService.isMinorThan1Hour;
      var startTimeInput = getFormInputBySelector('startTime');
      var endTimeInput = getFormInputBySelector('endTime');
      var startTimeFormatInput = getFormInputBySelector('startTimeFormat');
      var endTimeFormatInput = getFormInputBySelector('endTimeFormat');
      var startTime = startTimeInput && startTimeInput.$viewValue;
      var endTime = endTimeInput && endTimeInput.$viewValue;
      var startTimeFormat = startTimeFormatInput && startTimeFormatInput.$viewValue;
      var endTimeFormat = endTimeFormatInput && endTimeFormatInput.$viewValue;


      if (vm.timeFormatIsActive) {
        $scope.employeeForm['startTime'].$setValidity('isGreaterThan12Hours', !isGreaterThan12Hours(startTime, startTimeFormat));
        $scope.employeeForm['startTime'].$setValidity('isMinorThan1Hour', !isMinorThan1Hour(startTime, startTimeFormat));

        $scope.employeeForm['endTime'].$setValidity('isGreaterThan12Hours', !isGreaterThan12Hours(endTime, endTimeFormat));
        $scope.employeeForm['endTime'].$setValidity('isMinorThan1Hour', !isMinorThan1Hour(endTime, endTimeFormat));
      }

      $scope.employeeForm['startTime'].$setTouched();
      $scope.employeeForm['endTime'].$setTouched();
    }

    function clearSelectedEmployeeAddress() {
      vm.hasEmployeeAddress = false;
      vm.selectedEmployeeAddress = '';
      vm.selectedEmployeeAddressText = '';
      vm.geoCoderOk = false;

      $timeout(function () {
        focus('auto-complete-address');
      }, 200);
    }

    function onChangeEmployeeFiredAt(currentEmployeeFiredAt) {
      var initialEmployeeContract = vm.initialEmployee && vm.initialEmployee.contract;
      var hadDateAndRemoved = initialEmployeeContract.firedAt && !currentEmployeeFiredAt;

      vm.allowRemoveEmployeeFiredAt = initialEmployeeContract.active && hadDateAndRemoved;
    }

    function activateEmployee(ev) {
      if (!_allowSaveEmployee()) {
        return EmployeeService.showMaxAllowedEmployeesMessage(Account.maxEmployeesAllowed);
      }
      EmployeeDialog.activateEmployee(ev, vm.employee.id, function (reload) {
        if (reload) {
          closeDialog(true);
        }
      });
    }

    function inactivateEmployee(ev) {
      EmployeeDialog.inactivateEmployee(ev, vm.employee.id, function (reload) {
        if (reload) {
          closeDialog(true);
        }
      });
    }

    function generateTempPassword() {
      $rootScope.loadingProgress = true;

      authApi.generatePassword(vm.employee.email).then(function (data) {
        var event = new CustomEvent('showEmployeeCredentialDialog', {
          detail: {
            type: 'reset-password',
            email: data.email,
            password: data.password,
          }
        });
        document.dispatchEvent(event);
      }).catch(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('EMPLOYEES.TOAST.GENERATE_PASSWORD_ERROR'))
            .theme('error-toast')
            .hideDelay(2000)
        );
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });

      document.addEventListener('employeeCredentialDialogClosed', employeeCredentialDialogClosedEvent);
    }

    function generateCredential() {
      $rootScope.loadingProgress = true;

      authApi.inviteUser(vm.employee.email).then(function (data) {
        if (data === 'credential-already-exists') {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Colaborador criado com sucesso')
              .theme('success-toast')
              .hideDelay(2000)
          );

          return closeDialog(true);
        }

        var event = new CustomEvent('showEmployeeCredentialDialog', {
          detail: {
            type: 'new-credential',
            email: data.email,
            password: data.password,
          }
        });
        document.dispatchEvent(event);

        vm.hasCredential = true;

      }).catch(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('EMPLOYEES.TOAST.GENERATE_CREDENTIAL_ERROR'))
            .theme('error-toast')
            .hideDelay(2000)
        );
      }).finally(function () {
        $rootScope.loadingProgress = false;
        document.addEventListener('employeeCredentialDialogClosed', employeeCredentialDialogClosedEvent);
      });
    }

    function saveEmployee($event) {
      if (!_allowSaveEmployee()) {
        return EmployeeService.showMaxAllowedEmployeesMessage(Account.maxEmployeesAllowed);
      }

      $rootScope.loadingProgress = true;

      if (vm.avatarImage && vm.avatarResultImage) {
        var filename = "/employees/" + vm.employee._id + "/" + msUtils.shortGuidGenerator() + ".png";
        uploadApi.uploadWithPassthrough({
          imageBase64Encoded: vm.avatarResultImage,
          filename: filename
        }).then(function (path) {
          vm.employee.avatarUrl = path.data.key;
          createOrUpdateEmployee();
        });

        return;
      }

      createOrUpdateEmployee();
    }

    function fireEmployee($event) {
      vm.employee.contract.firedAt = moment().subtract(1, 'days').format('YYYY-MM-DD');
      saveEmployee($event);
      EmployeeDialog.deleteDevices($event, vm.employee.id, function () {
        closeDialog(true);
        $rootScope.loadingProgress = false;
      });
    }

    function rehireEmployee($event) {
      vm.employee.contract.firedAt = null;
      saveEmployee($event);
      $rootScope.loadingProgress = false;
      closeDialog(true);
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
      $rootScope.loadingProgress = false;
    }

    function toogleAllServices() {
      if (!vm.selectAll) {
        vm.employeeSkills = _.map(vm.services, 'id');
        vm.selectAll = true;
      }
      else {
        vm.employeeSkills = [];
        vm.selectAll = false;
      }

      $scope.employeeForm.name.$setDirty();
    }

    function toggleService(item, list) {
      var index = list.indexOf(item);

      if (index > -1) {
        list.splice(index, 1);
      } else {
        list.push(item);
      }

      $scope.employeeForm.name.$setDirty();
      vm.selectAll = (vm.employeeSkills.length === vm.services.length);
    };

    function serviceIsChecked(item, list) {
      return list.indexOf(item) > -1;
    }

    function createOrUpdateEmployee() {
      if (vm.employee.id) {
        _updateEmployee();

        return;
      }

      _createEmployee();
    }

    function _createEmployee() {
      if (vm.timeFormatIsActive) {
        vm.employee.workSchedule.start = LocalDateConvert.convertTimeToSave(vm.employee.workSchedule.start, vm.startTimeFormat);
        vm.employee.workSchedule.end = LocalDateConvert.convertTimeToSave(vm.employee.workSchedule.end, vm.endTimeFormat);
      }

      vm.employee.serviceIds = vm.employeeSkills;
      vm.employee.groupIds = _.map(vm.employee.groups, 'id');

      employeesApiGraphQL.createEmployee(vm.employee).then(function (savedEmployee) {
        if (!vm.hasMultipleEmployeeAccountsFlag) {
          authApi.adminUpdatePassword(vm.employee.email, vm.employee.password);
        }

        if (!vm.employee.id && vm.hasMultipleEmployeeAccountsFlag) {
          generateCredential();
        }

        for (var i = 0; i < vm.smartRewriteFields.length; i++) {
          var field = vm.smartRewriteFields[i];
          var params = {
            reference: vm.sessionId,
            referenceType: field,
            updatedReference: savedEmployee.id
          };
          gandalfApi.updateRewriteInputHistory(params);
        }

        if (!vm.hasMultipleEmployeeAccountsFlag) {
          closeDialog(true);
        }
      }).catch(function (result) {
        showErrorMessage(result);
      });
    }

    function _updateEmployee() {
      if (vm.timeFormatIsActive) {
        vm.employee.workSchedule.start = LocalDateConvert.convertTimeToSave(vm.employee.workSchedule.start, vm.startTimeFormat);
        vm.employee.workSchedule.end = LocalDateConvert.convertTimeToSave(vm.employee.workSchedule.end, vm.endTimeFormat);
      }

      sanitizeEmployee();

      employeesApi.update(vm.employee).then(function (savedEmployee) {
        for (var i = 0; i < vm.smartRewriteFields.length; i++) {
          var field = vm.smartRewriteFields[i];
          var params = {
            reference: vm.sessionId,
            referenceType: field,
            updatedReference: savedEmployee.id
          };

          gandalfApi.updateRewriteInputHistory(params);

          closeDialog(true);
        }
      }).catch(function (result) {
        showErrorMessage(result);
      });
    }

    function showErrorMessage(result) {
      var errorMessages = {
        'device_id_already_taken': 'EMPLOYEES.MODEL.ERRORS.DEVICE_ALREADY_TAKEN',
        'employee_email_already_taken': 'EMPLOYEES.MODEL.ERRORS.EMAIL_ALREADY_TAKEN',
        'EMAIL_ALREADY_IN_USE': 'EMPLOYEES.MODEL.ERRORS.EMAIL_ALREADY_TAKEN',
        'employee_max_allowed_exceeded_err': 'EMPLOYEES.MODEL.ERRORS.MAX_ALLOWED_EXCEEDED',
        'already_used_password': 'EMPLOYEES.MODEL.ERRORS.ALREADY_USED_PASSWORD'
      };

      var errorAction = {
        'employee_email_already_taken': alreadyTakenValueError,
        'employee_max_allowed_exceeded_err': maxAllowedEmployeesExcededError
      };

      var isErrorStatus = result.status === 422 || result.status === 400 || (result.errors && result.errors.length);
      var currentCode = (result && result.data && result.data.code) || (result.errors && result.errors[0].extensions.code);

      if (isErrorStatus && errorMessages[currentCode]) {
        var code = currentCode;

        vm.formErr[code] = $translate.instant(errorMessages[code]);

        if (errorAction[code]) {
          errorAction[code]();
        }

        $rootScope.loadingProgress = false;
      }
    }

    function sanitizeEmployee() {
      vm.employee.serviceIds = vm.employeeSkills;
      vm.employee.groupIds = _.map(vm.employee.groups, 'id');

      delete vm.employee.groups;
      delete vm.employee.contract.active;
      delete vm.employee.workSchedule.capacity;
      delete vm.employee.workSchedule.break;
      delete vm.employee._id;
      delete vm.employee.emailValidatedAt;
      delete vm.employee.inactivatedAt;
      delete vm.employee.createdAt;
      delete vm.employee.preferences;
      delete vm.employee.device;
      delete vm.employee.passwordExpiredAt;
      delete vm.employee.hasCredential;

      if (vm.hasMultipleEmployeeAccountsFlag) {
        delete vm.employee.email;
      }
    }

    function _setFormDirty() {
      if ($scope.employeeForm) {
        _.defer(function () {
          $scope.$apply(function () {
            $scope.employeeForm.$setDirty();
          });
        });
      }
    }

    function validateEmployeeAddressChange() {
      var selectedAddress = vm.selectedEmployeeAddress;
      if (selectedAddress) {
        vm.location.address = {
          postalCode: selectedAddress.zipCode || null,
          city: selectedAddress.city || null,
          state: selectedAddress.state || null,
          neighborhood: selectedAddress.neighborhood || null,
          street: selectedAddress.street || null,
          number: selectedAddress.number || null,
          coords: {
            latitude: selectedAddress.lat,
            longitude: selectedAddress.lng
          },
          formattedAddress: selectedAddress.formattedAddress
        };

        var validation = addressService.validateAddress(vm.location.address);
        if (validation.warnings) {
          validation.warnings = validation.warnings.filter(function (warning) {
            return warning !== 'NEIGHBORHOOD';
          });
        }
        vm.invalidLocationAddress = !validation.valid;
        vm.locationAddressErrors = validation.errors;
        vm.locationAddressWarnings = validation.warnings;

        if (!vm.googleLocationAddressErrors && !vm.googleLocationAddressWarnings) {
          vm.completedEmployeeAddress = true;
        }

        _setFormDirty();
      } else {
        vm.invalidLocationAddress = null;
        vm.locationAddressErrors = null;
        vm.locationAddressWarnings = null;
      }
      var employeeAddressIsSelected = vm.employee.address.formattedAddress != null;

      if (selectedAddress && validation.valid) {
        vm.geoCoderOk = true;

        vm.hasEmployeeAddress = true;
        delete vm.formErr['employeeAddressIsRequired'];
      }
    }

    function maxAllowedEmployeesExcededError() {
      EmployeeService.showMaxAllowedEmployeesMessage(Account.maxEmployeesAllowed);
    }

    function alreadyTakenValueError() {
      vm.formErr['employee_email_already_taken_value'] = vm.employee.email;
      vm.formErr['email_already_taken'] = $translate.instant('EMPLOYEES.MODEL.ERRORS.EMAIL_ALREADY_TAKEN');
    }

    function _allowSaveEmployee() {
      if ((vm.employee.contract.firedAt || vm.isHired) && !vm.employee.inactivatedAt) {
        return true;
      }

      if (vm.employee.id) {
        if (!vm.employee.contract.firedAt || vm.employee.inactivatedAt) {
          if (countActiveEmployees >= Account.maxEmployeesAllowed && !vm.allowRemoveEmployeeFiredAt) {
            return false;
          }
        } else {
          if (countActiveEmployees > Account.maxEmployeesAllowed) {
            return false;
          }
        }
      } else {
        if (countActiveEmployees >= Account.maxEmployeesAllowed) {
          return false;
        }
      }

      return true;
    }

    function _loadFeatureFlags() {
      accountFeatureFlagsApiGraphQL.getCachedFlagByName('multiple-accounts-employees').then(function (hasFlag) {
        hasFlag = hasFlag && hasFlag.active;

        vm.hasMultipleEmployeeAccountsFlag = hasFlag;
      });

      accountFeatureFlagsApiGraphQL.getCachedFlagByName('territories').then(function (hasFlag) {
        vm.hasTerritoriesFlag = hasFlag && hasFlag.active;
      });
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deadline-violations-reasons')
    .factory('DeadlineViolationsReasonsDialog', DeadlineViolationsReasonsDialog);

  /** @ngInject */
  function DeadlineViolationsReasonsDialog($mdDialog, $rootScope, deadlineViolationsReasonsApi, $document, $q) {
    function openDialog(ev, id, callback) {
      if (id) {
        $rootScope.loadingProgress = true;

        var requests = {
          deadlineViolationReason: deadlineViolationsReasonsApi.getOne(id, {})
        };

        $q.all(requests).then(function (result) {
          _openDialog(ev, {
            DeadlineViolationReason: result.deadlineViolationReason
          }, callback);

        }).finally(function () {
          $rootScope.loadingProgress = false;
        });

      } else {
        _openDialog(ev, {
          DeadlineViolationReason: null
        }, callback);
      }
    }

    function _openDialog(ev, locals, callback) {
      $mdDialog.show({
        controller: 'DeadlineViolationsReasonsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/deadline-violations-reasons/dialogs/deadline-violations-reasons-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: locals
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }

    return {
      openDialog: openDialog
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deadline-violations-reasons')
    .controller('DeadlineViolationsReasonsDialogController', DeadlineViolationsReasonsDialogController);

  /** @ngInject */
  function DeadlineViolationsReasonsDialogController(
    deadlineViolationsReasonsApi, $rootScope, $translate, $mdDialog, MessageDialog, DeadlineViolationReason, msUtils, gandalfApi
  ) {
    var vm = this;
    vm.violationReason = DeadlineViolationReason;
    vm.saveDeadlineViolationsReasons = saveDeadlineViolationsReasons;
    vm.closeDialog = closeDialog;
    vm.archiveViolationReason = archiveViolationReason;

    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['deadline-contract-reason-description'];

    function archiveViolationReason() {
      vm.violationReason.archived = !vm.violationReason.archived;
      saveDeadlineViolationsReasons();
    }

    function saveDeadlineViolationsReasons() {
      $rootScope.loadingProgress = true;

      deadlineViolationsReasonsApi.save(vm.violationReason)
        .then(function (result) {
          for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
            var field = vm.smartRewriteFields[i];
            var params = {
              reference: vm.sessionId,
              referenceType: field,
              updatedReference: result.id
            };

            gandalfApi.updateRewriteInputHistory(params);
          }

          MessageDialog.showToast({
            message: $translate.instant('DEADLINE-VIOLATIONS-REASONS.DIALOG.TOAST.SAVED', { violationReason: vm.violationReason.name }),
            hideDelay: 3000
          });

          vm.closeDialog();
        })
        .catch(function (result) {
          if (result.data.err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('DEADLINE-VIOLATIONS-REASONS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('DEADLINE-VIOLATIONS-REASONS.DIALOG.ALERT.OK'))
                .textContent(result.data.message)
            );

            vm.closeDialog();
          }
        })
        .finally(function () {
          $rootScope.$broadcast('deadline-violations-reasons:reload');
          $rootScope.loadingProgress = false;
        });
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deadline-contracts')
    .factory('DeadlineContractsDialog', DeadlineContractsDialog);

  /** @ngInject */
  function DeadlineContractsDialog($mdDialog, $rootScope, deadlineContractsApi, $document, $q) {
    function openDialog(ev, id, target, callback) {
      if (id) {
        $rootScope.loadingProgress = true;

        var requests = {
          contract: deadlineContractsApi.getOne(id, {})
        };

        $q.all(requests).then(function (result) {
          _openDialog(ev, {
            Contract: result.contract
          }, target, callback);

        }).finally(function () {
          $rootScope.loadingProgress = false;
        });

      } else {
        _openDialog(ev, {
          Contract: null
        }, target, callback);
      }
    }
    function _openDialog(ev, locals, target, callback) {
      $mdDialog.show({
        controller: 'DeadlineContractsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/deadline-contracts/dialogs/deadline-contracts-dialog.html',
        parent: target || angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: locals
      }).then(function (reload) {
        if (callback) {
          callback(reload);
        }
      });
    }

    return {
      openDialog: openDialog
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deadline-contracts')
    .controller('DeadlineContractsDialogController', DeadlineContractsDialogController);

  /** @ngInject */
  function DeadlineContractsDialogController(
    deadlineContractsApi, $rootScope, $translate, $mdDialog, MessageDialog, Contract, $scope, _, msUtils, gandalfApi
  ) {
    var vm = this;
    vm.contract = Contract;

    vm.unitOptions =  [
      { translate: $translate.instant('DEADLINE-CONTRACTS.DIALOG.UNIT.MINUTES'), value: 'minutes' },
      { translate: $translate.instant('DEADLINE-CONTRACTS.DIALOG.UNIT.HOURS'), value: 'hours' },
      { translate: $translate.instant('DEADLINE-CONTRACTS.DIALOG.UNIT.DAYS'), value: 'days' },
    ];
    vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['deadline-contract-description'];

    vm.responseFocus = true;
    vm.solutionFocus = true;

    vm.selectedResponseDeadline = (vm.contract && vm.contract.responseDeadlineDisplayUnit) || vm.unitOptions[0].value;
    vm.selectedResponseDeadlineRisk = (vm.contract && vm.contract.responseDeadlineRiskDisplayUnit) || vm.unitOptions[0].value;
    vm.selectedSolutionDeadline = (vm.contract && vm.contract.solutionDeadlineDisplayUnit) || vm.unitOptions[0].value;
    vm.selectedSolutionDeadlineRisk = (vm.contract && vm.contract.solutionDeadlineRiskDisplayUnit) || vm.unitOptions[0].value;

    if (vm.contract) {
      vm.contract.responseDeadline = vm.contract.responseDeadlineDisplayUnit === 'minutes' ? vm.contract.responseDeadline : (vm.contract.responseDeadlineDisplayUnit === 'hours' ? convertToHours(vm.contract.responseDeadline, 'minutes') : convertToDays(vm.contract.responseDeadline, 'minutes'));
      vm.contract.responseDeadlineRisk = vm.contract.responseDeadlineRiskDisplayUnit === 'minutes' ? vm.contract.responseDeadlineRisk : (vm.contract.responseDeadlineRiskDisplayUnit === 'hours' ? convertToHours(vm.contract.responseDeadlineRisk, 'minutes') : convertToDays(vm.contract.responseDeadlineRisk, 'minutes'));
      vm.contract.solutionDeadline = vm.contract.solutionDeadlineDisplayUnit === 'minutes' ? vm.contract.solutionDeadline : (vm.contract.solutionDeadlineDisplayUnit === 'hours' ? convertToHours(vm.contract.solutionDeadline, 'minutes') : convertToDays(vm.contract.solutionDeadline, 'minutes'));
      vm.contract.solutionDeadlineRisk = vm.contract.solutionDeadlineRiskDisplayUnit === 'minutes' ? vm.contract.solutionDeadlineRisk : (vm.contract.solutionDeadlineRiskDisplayUnit === 'hours' ? convertToHours(vm.contract.solutionDeadlineRisk, 'minutes') : convertToDays(vm.contract.solutionDeadlineRisk, 'minutes'));
    }

    vm.saveContract = saveContract;
    vm.closeDialog = closeDialog;
    vm.handleChangeOfficeHours = handleChangeOfficeHours;
    vm.handleChangeDays = handleChangeDays;
    vm.toggleContractArchiving = toggleContractArchiving;
    vm.daysSelected = {};
    vm.validIfDaySelectedInOfficeHours = validIfDaySelectedInOfficeHours;
    vm.validateMaxInResponseRisk = validateMaxInResponseRisk;
    vm.validateMaxInSolutionRisk = validateMaxInSolutionRisk;
    vm.disableOfficeHours = disableOfficeHours;
    vm.hasDaysAsUnits = hasDaysAsUnits;

    function validateMaxInResponseRisk() {
      $scope.contractForm.responseDeadlineRisk.$setValidity('size', true);
      $scope.contractForm.responseDeadline.$setValidity('size', true);

      var responseDeadlineRisk = parseInt(convertDeadlineToMinutes(vm.contract.responseDeadlineRisk, vm.selectedResponseDeadlineRisk) || 0);

      if (responseDeadlineRisk > 525600) {
        $scope.contractForm.responseDeadlineRisk.$setValidity('size', false);
      }

      if (!vm.contract.responseDeadline) {
        return true;
      }

      var responseDeadline = parseInt(convertDeadlineToMinutes(vm.contract.responseDeadline, vm.selectedResponseDeadline) || 0);


      if (responseDeadline > 525600) {
        $scope.contractForm.responseDeadline.$setValidity('size', false);
      }


      if (responseDeadlineRisk > responseDeadline) {
        $scope.contractForm.responseDeadlineRisk.$setValidity('max', false);

        if (vm.responseFocus) {
          var responseRiskInput = document.getElementById('response-risk-input');
          responseRiskInput.focus();
          vm.responseFocus = false;
        }

        return false;
      } else {
        $scope.contractForm.responseDeadlineRisk.$setValidity('max', true);

        if (vm.selectedResponseDeadline !== vm.contract.responseDeadlineDisplayUnit || vm.selectedResponseDeadlineRisk !== vm.contract.responseDeadlineRiskDisplayUnit) {
          $scope.contractForm.$setDirty();
        }

        return true;
      }
    }

    function validateMaxInSolutionRisk() {
      $scope.contractForm.solutionDeadline.$setValidity('size', true);
      $scope.contractForm.solutionDeadlineRisk.$setValidity('size', true);

      var solutionDeadlineRisk = parseInt(convertDeadlineToMinutes(vm.contract.solutionDeadlineRisk, vm.selectedSolutionDeadlineRisk) || 0);

      if (solutionDeadlineRisk > 525600) {
        $scope.contractForm.solutionDeadlineRisk.$setValidity('size', false);
      }

      if (!vm.contract.solutionDeadline) {
        return true;
      }

      var solutionDeadline = parseInt(convertDeadlineToMinutes(vm.contract.solutionDeadline, vm.selectedSolutionDeadline) || 0);


      if (solutionDeadline > 525600) {
        $scope.contractForm.solutionDeadline.$setValidity('size', false);
      }


      if (solutionDeadlineRisk > solutionDeadline) {
        $scope.contractForm.solutionDeadlineRisk.$setValidity('max', false);

        if (vm.solutionFocus) {
          var responseRiskInput = document.getElementById('solution-risk-input');
          responseRiskInput.focus();
          vm.solutionFocus = false;
        }

        return false;
      } else {
        $scope.contractForm.solutionDeadlineRisk.$setValidity('max', true);

        if (vm.selectedSolutionDeadline !== vm.contract.solutionDeadlineDisplayUnit || vm.selectedSolutionDeadlineRisk !== vm.contract.solutionDeadlineRiskDisplayUnit) {
          $scope.contractForm.$setDirty();
        }

        return true;
      }
    }

    function handleChangeOfficeHours(hasOfficeHours) {
      if (!hasOfficeHours) {
        vm.contract.officeHours = {};
        vm.daysSelected = {};
      }
    }

    function handleChangeDays(day) {
      if (vm.contract.officeHours && vm.contract.officeHours[day]) {
        delete vm.contract.officeHours[day];
      } else {
        if (!vm.contract.officeHours) {
          vm.contract.officeHours = {};
        }

        if (!vm.contract.officeHours[day]) {
          vm.contract.officeHours[day] = {
            to: '23:59',
            from: '00:00'
          };
        }
      }
    }

    function toggleContractArchiving() {
      vm.contract.archived = !vm.contract.archived;
      saveContract();
    }

    function saveContract() {
      $rootScope.loadingProgress = true;

      formatTimeToSave();

      var unitTypes = [vm.contract.responseDeadlineDisplayUnit, vm.contract.responseDeadlineRiskDisplayUnit, vm.contract.solutionDeadlineDisplayUnit, vm.contract.solutionDeadlineRiskDisplayUnit];

      if (unitTypes.includes('days')) {
        _.forEach(Object.keys(vm.contract.officeHours), function (day) {
          vm.contract.officeHours[day] = {
            from: '00:00',
            to: '23:59'
          };
        });
      }

      deadlineContractsApi.save(vm.contract)
        .then(function (result) {
          for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
            var field = vm.smartRewriteFields[i];
            var params = {
              reference: vm.sessionId,
              referenceType: field,
              updatedReference: result.id
            };

            gandalfApi.updateRewriteInputHistory(params);
          }

          MessageDialog.showToast({
            message: $translate.instant('DEADLINE-CONTRACTS.DIALOG.TOAST.SAVED', { contract: vm.contract.name }),
            hideDelay: 3000
          });

          vm.closeDialog({ reload: true, deadlineContractId: result.id });
        })
        .catch(function (result) {
          if (result.data.err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('DEADLINE-CONTRACTS.DIALOG.ALERT.TITLE'))
                .ok($translate.instant('DEADLINE-CONTRACTS.DIALOG.ALERT.OK'))
                .textContent(result.data.message)
            );

            vm.closeDialog();
          }
        })
        .finally(function () {
          $rootScope.$broadcast('deadline-contracts:reload');
          $rootScope.loadingProgress = false;
        });
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }

    function checkSelectedDays() {
      if (!vm.contract) {
        return;
      }

      var officeDays = Object.keys(vm.contract.officeHours);
      var daysSelected = {};
      for (var index = 0; index < officeDays.length; index++) {
        var officeDay = officeDays[index];
        daysSelected[officeDay] = true;
      }

      vm.daysSelected = daysSelected;
    }

    function validIfDaySelectedInOfficeHours() {
      vm.disableOfficeHours();
      if (vm.contract.hasOfficeHours) {
        var daySelected = Object.keys(vm.contract.officeHours || {}).length === 0;
        return daySelected;
      }
      return false;
    }

    function _initialize() {
      checkSelectedDays();
    }

    function convertToMinutes(value, unit) {
      var conversionTable = {
        hours: value * 60,
        days: value * 1440,
      };
      return conversionTable[unit] || value;
    }

    function convertToHours(value, unit) {
      var conversionTable = {
        minutes: value / 60,
        days: value * 24,
      };
      return  Math.round(conversionTable[unit]) || value;
    }

    function convertToDays(value, unit) {
      var conversionTable = {
        minutes: value / 1440,
        hours: value / 24,
      };
      return  Math.round(conversionTable[unit]) || value;
    }

    function convertDeadlineToMinutes(deadline, selectedUnit) {
      if(selectedUnit !== 'minutes') {
        return convertToMinutes(deadline, selectedUnit);
      }
      return deadline;
    }

    function formatTimeToSave() {
      vm.contract.responseDeadlineDisplayUnit = vm.selectedResponseDeadline;
      vm.contract.responseDeadline = convertDeadlineToMinutes(vm.contract.responseDeadline, vm.selectedResponseDeadline);
      vm.contract.responseDeadlineRiskDisplayUnit = vm.selectedResponseDeadlineRisk;
      vm.contract.responseDeadlineRisk = convertDeadlineToMinutes(vm.contract.responseDeadlineRisk, vm.selectedResponseDeadlineRisk);
      vm.contract.solutionDeadlineDisplayUnit = vm.selectedSolutionDeadline;
      vm.contract.solutionDeadline = convertDeadlineToMinutes(vm.contract.solutionDeadline, vm.selectedSolutionDeadline);
      vm.contract.solutionDeadlineRiskDisplayUnit = vm.selectedSolutionDeadlineRisk;
      vm.contract.solutionDeadlineRisk = convertDeadlineToMinutes(vm.contract.solutionDeadlineRisk, vm.selectedSolutionDeadlineRisk);
    }

    function hasDaysAsUnits() {
      return vm.selectedResponseDeadline === 'days' || vm.selectedResponseDeadlineRisk === 'days' || vm.selectedSolutionDeadline === 'days' || vm.selectedSolutionDeadlineRisk === 'days';
    }

    function disableOfficeHours(check) {
      var hasDaysAsUnits = vm.hasDaysAsUnits();

      if (hasDaysAsUnits) {
        _.forEach(Object.keys(vm.contract.officeHours), function (day) {
          vm.contract.officeHours[day] = {
            from: '00:00',
            to: '23:59'
          };
        });
      }
      validateMaxInResponseRisk();
      validateMaxInSolutionRisk();
      return check || hasDaysAsUnits;
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.customers')
    .controller('CustomersFiltersSideNavController', CustomersFiltersSideNavController);

  /** @ngInject */
  function CustomersFiltersSideNavController(
    CustomersFilters, _, msUtils, labelsApi, $rootScope, $timeout, $translate, omieApi, $q,
    territoriesApi, accountFeatureFlagsApiGraphQL
  ) {

    var vm = this;
    vm.labels = [];
    vm.customersFilters = CustomersFilters;
    vm.clearFilters = CustomersFilters.clear;
    vm.filteringIsOn = CustomersFilters.isOn;
    vm.exists = msUtils.exists;
    vm.toggleInArray = toggleInArray;
    vm.territorySelected = territorySelected;

    vm.ratings = [
      { stars: 'null', name: '' },
      { stars: 1, name: $translate.instant("CUSTOMERS.FILTERS.RATINGS.TERRIBLE") },
      { stars: 2, name: $translate.instant("CUSTOMERS.FILTERS.RATINGS.BAD") },
      { stars: 3, name: $translate.instant("CUSTOMERS.FILTERS.RATINGS.REGULAR") },
      { stars: 4, name: $translate.instant("CUSTOMERS.FILTERS.RATINGS.GOOD") },
      { stars: 5, name: $translate.instant("CUSTOMERS.FILTERS.RATINGS.GREAT") }
    ];

    vm.areThereOmieAccounts = true;
    vm.externalAppIdOptions = [
      {
          label: $translate.instant('AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.RESOURCE_NAME.OPTIONS.ALL'),
          value: '0'
      }
    ];
    vm.externalAppIdValue = vm.externalAppIdOptions[0].value;
    vm.hasTerritoriesFlag = false;
    vm.territoriesFilterList = [];
    vm.subTerritoriesFilterList = [];

    accountFeatureFlagsApiGraphQL.getCachedFlagByName('territories').then(function (flag) {
      vm.hasTerritoriesFlag = flag ? flag.active : false;
    });

    var deferred = $q.defer();

    omieApi.accounts.list()
      .then(function (res) {

        if (!res.data || !res.data.Items || !res.data.Items.length) {
          vm.areThereOmieAccounts = false;
          vm.externalAppIdOptions = [];
          return;
        }


        var accounts = res.data.Items.map(function (item) {
          vm.areThereOmieAccounts = true;
          return vm.externalAppIdOptions.push({
            label: item.accountName,
            value: item.appId
          });
        });

        deferred.resolve(accounts);
      })
      .catch(function (error) {
        console.error('Error fetching accounts:', error);
        deferred.reject(error);
      });

    territoriesApi.search({ take: 100, where: { archived: false } }).then(function (result) {
      vm.territoriesFilterList = result.items;
    });

    function toggleInArray(value, array) {
      msUtils.toggleInArray(value, array);
      vm.broadcastFilterUpdated();
    }

    labelsApi.search({ type: 'customers' }, { limit: 100 }).then(function (result) {
      vm.labels = result.items;
    });

    vm.broadcastFilterUpdated = _.debounce(function () {
      $timeout(function () { $rootScope.$broadcast('customers:filter-updated'); }, 50);
    }, 500);

    function territorySelected() {
      var selectedTerritoryId = vm.customersFilters.territoryId;
      vm.customersFilters.subTerritoryIds = [];
      vm.broadcastFilterUpdated();

      if (!selectedTerritoryId) {
        vm.subTerritoriesFilterList = [];

        return;
      }

      territoriesApi.search({ take: 150, where: { parentId: selectedTerritoryId, archived: false } }).then(function (result) {
        vm.subTerritoriesFilterList = result.items;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.customers')
    .factory('CustomersFilters', CustomersFilters);

  /** @ngInject */
  function CustomersFilters($rootScope, $timeout) {

    var filters = {
      name: '',
      phone: '',
      documentNumber: null,
      email: '',
      street: '',
      city: '',
      state: '',
      archived: '1',
      externalAppId: '0',
      labels: [],
      firstServiceDateFrom: null,
      firstServiceDateTo: null,
      lastServiceDateFrom: null,
      lastServiceDateTo: null,
      averageRating: [],
      lastRating: [],
      territoryId: '',
      subTerritoryIds: [],
      clear: clear,
      isOn: isOn,
      isOff: isOff,
      toSearchOptions: toSearchOptions,
    };

    function clear() {
      filters.name = '';
      filters.phone = '';
      filters.documentNumber = null;
      filters.email = '';
      filters.street = '';
      filters.city = '';
      filters.state = '';
      filters.archived = '1';
      filters.externalAppId = '0';
      filters.labels = [];
      filters.firstServiceDateFrom = null;
      filters.firstServiceDateTo = null;
      filters.lastServiceDateFrom = null;
      filters.lastServiceDateTo = null;
      filters.averageRating = [];
      filters.lastRating = [];
      filters.territoryId = '';
      filters.subTerritoryIds = [];

      $timeout(function () { $rootScope.$broadcast('customers:filter-updated'); }, 200);
    }

    function isOn() {
      var noNameFiltered = filters.name === '';
      var noPhoneFiltered = filters.phone === '';
      var noDocumentNumberFiltered = filters.documentNumber === null;
      var noEmailFiltered = filters.email === '';
      var noStreetFiltered = filters.street === '';
      var noCityFiltered = filters.city === '';
      var noStateFiltered = filters.state === '';
      var noArchivedFiltered = filters.archived === '1';
      var noOmieAccountFiltered = filters.externalAppId === '0';
      var noLabelsFiltered = filters.labels.length === 0;
      var noFirstServiceDateFromFiltered = filters.firstServiceDateFrom === null;
      var noFirstServiceDateToFiltered = filters.firstServiceDateTo === null;
      var noLastServiceDateFromFiltered = filters.lastServiceDateFrom === null;
      var noLastServiceDateToFiltered = filters.lastServiceDateTo === null;
      var noAverageRatingFiltered = filters.averageRating.length === 0;
      var noLastRatingFiltered = filters.lastRating.length === 0;
      var noTerritoryFiltered = filters.territoryId === '';
      var noSubTerritoryFiltered = !filters.subTerritoryIds || filters.subTerritoryIds.length === 0;

      return !(
        noNameFiltered &&
        noPhoneFiltered &&
        noEmailFiltered &&
        noArchivedFiltered &&
        noOmieAccountFiltered &&
        noLabelsFiltered &&
        noFirstServiceDateFromFiltered &&
        noFirstServiceDateToFiltered &&
        noLastServiceDateFromFiltered &&
        noLastServiceDateToFiltered &&
        noAverageRatingFiltered &&
        noLastRatingFiltered &&
        noStreetFiltered &&
        noCityFiltered &&
        noStateFiltered &&
        noDocumentNumberFiltered &&
        noTerritoryFiltered &&
        noSubTerritoryFiltered
      );
    }

    function isOff() {
      return !isOn();
    }

    function toSearchOptions() {
      var kqQueryParams = {};
      var gqlParams = {};

      kqQueryParams['label_id'] = filters.labels;
      gqlParams['labelIds'] = filters.labels;

      if (filters.name) {
        kqQueryParams['name~~*'] = '*' + filters.name + '*';
        gqlParams['nameContains'] = filters.name;
      }
      if (filters.email) {
        kqQueryParams['email_address~~*'] = filters.email + '*';
        gqlParams['contactEmailContains'] = filters.email;
      }
      if (filters.phone) {
        kqQueryParams['phone_number~~*'] = '*' + filters.phone + '*';
        gqlParams['contactPhoneContains'] = filters.phone;
      }
      if (filters.documentNumber) {
        kqQueryParams['document_number~~*'] = '*' + filters.documentNumber + '*';
        gqlParams['documentNumberContains'] = filters.documentNumber;
      }
      if (filters.street) {
        kqQueryParams['street~~*'] = '*' + filters.street + '*';
        gqlParams['streetContains'] = filters.street;
      }
      if (filters.city) {
        kqQueryParams['city~~*'] = '*' + filters.city + '*';
        gqlParams['cityContains'] = filters.city;
      }
      if (filters.state) {
        kqQueryParams['state~~*'] = '*' + filters.state + '*';
        gqlParams['stateContains'] = filters.state;
      }
      if (filters.archived === '1') {
        kqQueryParams['archived'] = 'no';
        gqlParams['archived'] = false;
      } else if (filters.archived === '0') {
        kqQueryParams['archived'] = 'yes';
        gqlParams['archived'] = true;
      }
      if (filters.externalAppId !== '0') {
        kqQueryParams['omie_account_imported_app_id'] = filters.externalAppId;
        gqlParams['externalAppId'] = filters.externalAppId;
      }
      if (filters.firstServiceDateFrom) {
        var firstServiceDateFrom = moment(filters.firstServiceDateFrom).format('YYYY-MM-DD');
        kqQueryParams['first_service_at>='] = firstServiceDateFrom;
        gqlParams['firstServiceGte'] = firstServiceDateFrom;
      }
      if (filters.firstServiceDateTo) {
        var firstServiceDateTo = moment(filters.firstServiceDateTo).format('YYYY-MM-DD');
        kqQueryParams['first_service_at<='] = firstServiceDateTo;
        gqlParams['firstServiceLte'] = firstServiceDateTo;
      }
      if (filters.lastServiceDateFrom) {
        var lastServiceDateFrom = moment(filters.lastServiceDateFrom).format('YYYY-MM-DD');
        kqQueryParams['last_service_at>='] = lastServiceDateFrom;
        gqlParams['lastServiceGte'] = lastServiceDateFrom;
      }
      if (filters.lastServiceDateTo) {
        var lastServiceDateTo = moment(filters.lastServiceDateTo).format('YYYY-MM-DD');
        kqQueryParams['last_service_at<='] = lastServiceDateTo;
        gqlParams['lastServiceLte'] = lastServiceDateTo;
      }
      if (filters.averageRating.length) {
        kqQueryParams['average_stars'] = filters.averageRating.toString();
        gqlParams['averageRatingIn'] = _.map(filters.averageRating, function (rating) { return parseInt(rating); });
      }
      if (filters.lastRating.length) {
        kqQueryParams['last_star'] = filters.lastRating.toString();
        gqlParams['lastRatingIn'] = _.map(filters.lastRating, function (rating) { return parseInt(rating); });
      }

      if (filters.subTerritoryIds && filters.subTerritoryIds.length) {
        gqlParams['territoryIds'] = filters.subTerritoryIds;
      } else if (filters.territoryId) {
        gqlParams['territoryIds'] = [filters.territoryId];
      }

      return {
        kq: kqQueryParams,
        graphQL: gqlParams
      };
    }

    return filters;
  }
})();


(function () {
  'use strict';

  angular
    .module('app.customers')
    .factory('CustomersMap', CustomersMap);

  /** @ngInject */
  function CustomersMap(leafletData, $q, customersApi, $interval, $translate, $timeout, $rootScope, _) {
    var map = null;
    var mapAPI = null;
    var lastMarkersLatLng = [];
    var markersLatLng = [];
    var markerActions = [];
    var searchInBoundsMode = false;
    var requestLimit = 0;
    var pollingRequest = null;
    var pollingCount = 1;
    var pollingIndex = 0;
    var currentSearchedAreaCenter = null;
    var totalCustomersLoaded = 0;

    function getMap() {
      return map;
    }

    //polling
    function initialCustomerPolling(customersInitialLimit) {
      function cancelPollingRequest() {
        pollingIndex = 0;
        pollingCount = 1;
        if (pollingRequest) {
          $interval.cancel(pollingRequest);
        }
        pollingRequest = null;
      }
      return $q(function (resolve, reject) {
        function pollingCustomer() {
          customersApi.geoSearch({ 'archived': 'false' }, { offset: pollingIndex, limit: requestLimit })
          .then(function (result) {
              if (result.items.length && totalCustomersLoaded <= customersInitialLimit) {
                totalCustomersLoaded += result.items.length;
                pollingIndex = requestLimit * pollingCount;
                _updateMarkers(result.items);
                pollingRequest = $interval(pollingCustomer, 1000, 1);
                pollingCount++;
              } else {
                cancelPollingRequest();
                return totalCustomersLoaded > 0 ? resolve({ ok: true }) : reject({ ok: false });
              }
            }).catch(function (err) {
              cancelPollingRequest();
              return reject(err);
            });
        }
        pollingCustomer();
      });
    }
    var addMarkerAction = function (event, title, icon) {
      if (!markerActions.length) {
        markerActions.push({ event: event, title: title, icon: icon });
      }

      _.forEach(markerActions, function (markerAction) {
        if (markerAction.title !== title) {
          markerActions.push({ event: event, title: title, icon: icon });
        }
      });

      for (var key in map.markers) {
        if (map.markers.hasOwnProperty(key) && !(_.includes(map.markers[key].message, title))) {
          map.markers[key].message = _buildMarker(map.markers[key].data);
        }
      }
    };
    function centralize() {
      if (map.markers && markersLatLng.length) {
        var bounds = L.latLngBounds(markersLatLng);
        mapAPI.fitBounds(bounds);

        var center = bounds.getCenter();
        if (isValidCoordinates(center.lat, center.lng)) {
          mapAPI.setView(center, mapAPI.getZoom());
        } else {
          mapAPI.setView([0, 0], 4);
        }
      }
    }
    function build(htmlId, totalCustomers, customersInitialLimit) {
      return $q(function (resolve, reject) {
        if (totalCustomers >= customersInitialLimit) {
          searchInBoundsMode = true;
        }
        requestLimit = 500;
        map = {
          markers: {},
          center: {
            zoom: 4
          },
          layers: {
            baselayers: {
              mapbox_standard: {
                name: $translate.instant("CUSTOMERS.MAP.LAYERS.DEFAULT"),
                url: 'https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                type: 'xyz',
                layerOptions: {
                  'showOnSelector': true
                }
              },
              mapbox_satellite: {
                name: $translate.instant("CUSTOMERS.MAP.LAYERS.SATELLITE"),
                url: 'https://mt0.google.com/vt/lyrs=y&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                type: 'xyz',
                layerOptions: {
                  'showOnSelector': true
                }
              },
              mapbox_roadmap: {
                name: $translate.instant("CUSTOMERS.MAP.LAYERS.ROADS"),
                url: 'https://mt0.google.com/vt/lyrs=h&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                type: 'xyz',
                layerOptions: {
                  'showOnSelector': true
                }
              },
              mapbox_terrain: {
                name: $translate.instant("CUSTOMERS.MAP.LAYERS.GROUND"),
                url: 'https://mt0.google.com/vt/lyrs=p&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                type: 'xyz',
                layerOptions: {
                  'showOnSelector': true
                }
              }
            }
          },
          controls: {
            fullscreen: {
              position: 'topleft'
            },
            custom: []
          },
          addMarkerAction: addMarkerAction,
          centralize: centralize
        };
        var buttonClass = 'per-area-control';
        var buttonContent = '<div style="display: flex; align-items: center; padding: 5px; font-size: 1.5em;">' +
          '<svg class="svg-icon" viewBox="0 0 20 20" height="26" width="26">' +
          '<path d="M18.125,15.804l-4.038-4.037c0.675-1.079,1.012-2.308,1.01-3.534C15.089,4.62,12.199,1.75,8.584,1.75C4.815,1.75,1.982,4.726,2,8.286c0.021,3.577,2.908,6.549,6.578,6.549c1.241,0,2.417-0.347,3.44-0.985l4.032,4.026c0.167,0.166,0.43,0.166,0.596,0l1.479-1.478C18.292,16.234,18.292,15.968,18.125,15.804 M8.578,13.99c-3.198,0-5.716-2.593-5.733-5.71c-0.017-3.084,2.438-5.686,5.74-5.686c3.197,0,5.625,2.493,5.64,5.624C14.242,11.548,11.621,13.99,8.578,13.99 M16.349,16.981l-3.637-3.635c0.131-0.11,0.721-0.695,0.876-0.884l3.642,3.639L16.349,16.981z"></path>' +
          '</svg>' +
          '<span style="font-size: 16px;">' + $translate.instant('CUSTOMERS.MAP.IN_BOUNDS_SEARCH_BUTTON') + '</span></div>';

        var searchInBoundsButton = _createControlButton(buttonContent, 'bottomleft', function (e) {
          mapAPI.scrollWheelZoom.disable();
          map.markers = {};
          $rootScope.loadingProgress = true;

          $timeout(function () {
            var bounds = mapAPI.getBounds();
            customersApi.geoSearch({
              'latitude<=': bounds._northEast.lat,
              'latitude>=': bounds._southWest.lat,
              'longitude<=': bounds._northEast.lng,
              'longitude>=': bounds._southWest.lng,
              'archived': 'false'
            }, { limit: customersInitialLimit })
              .then(function (result) {
                $rootScope.loadingProgress = false;
                mapAPI.scrollWheelZoom.enable();
                _updateMarkers(result.items);
                _setSearchedCenter(L.latLngBounds(lastMarkersLatLng).getCenter());
                _toggleControlButton(buttonClass, false);
              })
              .catch(function (err) {
                return reject(err);
              });
          }, 1000);
        }, buttonClass);
        map.controls.custom.push(searchInBoundsButton);
        initialCustomerPolling(customersInitialLimit)
          .then(function () {
            resolve(map);
            return leafletData.getMap(htmlId);
          })
          .then(function (_map) {
            mapAPI = _map;
            if (searchInBoundsMode) {
              mapAPI.on('dragend', function () {
                _toggleControlButton(buttonClass, !_inSearchedCenter());
              });
              mapAPI.on('zoomend', function () {
                _toggleControlButton(buttonClass, !_inSearchedCenter());
              });
            }
            centralize();
          })
          .catch(function (err) {
            return reject(err);
          });
      });
    }
    function _updateMarkers(customers) {
      for (var c = 0; c < customers.length; c++) {
        for (var key in map.markers) {
          if (map.markers[key] && map.markers[key].data && customers[c]) {
            if (map.markers[key].data.id === customers[c].id) {
              customers.splice(c, 1);
            }
          }
        }
      }
      Object.assign(map.markers, _createMarkers(customers));
    }
    function isValidCoordinates(lat, lon) {
      return !isNaN(lat) && lat >= -90 && lat <= 90 && !isNaN(lon) && lon >= -180 && lon <= 180;
    }
    function _createMarkers(customers) {
      if (!customers.length) {
        return [];
      }
      lastMarkersLatLng = [];
      var markers = {};
      var icon = {
        type: 'div',
        html: '<div>' +
          '    <i style="color:#0957c3;" class="icon icon-city s38"></i>' +
          '</div>',
        iconAnchor: [16, 16], // point of the icon which will correspond to marker's location
        popupAnchor: [0, -16]  // point from which the popup should open relative to the iconAnchor
      };
      var index = map && map.markers && Object.keys(map.markers).length ? Object.keys(map.markers).length : 0;

      customers.forEach(function (customer) {
        var lat = customer && customer.coords && customer.coords.latitude;
        var lng = customer && customer.coords && customer.coords.longitude;
        if (isValidCoordinates(lat, lng)) {
          markers['customer' + index] = {
            lat: parseFloat(customer.coords.latitude),
            lng: parseFloat(customer.coords.longitude),
            message: _buildMarker(customer),
            focus: false,
            data: customer,
            draggable: false,
            icon: icon,
            group: 'customers'
          };
          lastMarkersLatLng.push([markers['customer' + index].lat, markers['customer' + index].lng]);
        }
        index++;
      });
      markersLatLng = markersLatLng.concat(lastMarkersLatLng);
      return markers;
    }
    function _inSearchedCenter() {
      if (currentSearchedAreaCenter === null) { return false; }
      return currentSearchedAreaCenter.getBounds().contains(mapAPI.getCenter());
    }
    function _buildMarker(customer) {
      var data = JSON.stringify(customer).replace(/"/g, "'");
      var template = '';
      template += '<span><b>' + customer.name + '</b></span>';
      template += '<br/>';
      template += '<div style="margin: 5px 0 5px 0;">';
      template += '<i class="icon-map-marker s15 icon"></i>';
      template += $translate.instant("CUSTOMERS.MAP.LATITUDE_LONGITUDE", {
        latitude: String(customer.coords.latitude).substring(0, 7),
        longitude: String(customer.coords.longitude).substring(0, 7)
      });
      template += '</div>';
      if (markerActions.length) {
        var actionsTemplate = '';
        markerActions.forEach(function (action) {
          actionsTemplate += '<a ng-click="$broadcast(\'' + 'customers-map:' + action.event + '\', $event, ' + data + ')" style="cursor: pointer;"> ' +
            action.title + '</a>';
        });
        template += '<br/><div style="display: flex; flex-direction: row; align-items: start;">' + actionsTemplate + '</div>';
      }
      return template;
    }
    function _setSearchedCenter(center) {
      var radius = (18 - map.center.zoom) === 0 ? 1 : (18 - map.center.zoom);
      if (currentSearchedAreaCenter === null) {
        currentSearchedAreaCenter = L.circle(center, { color: 'transparent', radius: radius * 1000 }).addTo(mapAPI);
      } else {
        currentSearchedAreaCenter.setLatLng(center);
        currentSearchedAreaCenter.setRadius(radius * 1000);
      }
    }
    function _createControlButton(content, position, buttonAction, customClass) {
      var controlButton = new L.control();
      controlButton.setPosition(position);
      controlButton.onAdd = function () {
        var container = L.DomUtil.create('div', ['leaflet-custom-control', 'leaflet-bar', customClass].join(' '));
        container.style.backgroundColor = 'white';
        container.style.cursor = 'pointer';
        angular.element(container).append(content);
        L.DomEvent.addListener(container, 'click', buttonAction);
        return container;
      };
      return controlButton;
    }
    function _toggleControlButton(buttonClass, state) {
      angular.element('.' + buttonClass).css('display', state ? 'block' : 'none');
    }
    return {
      build: build,
      getMap: getMap
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.customers')
    .factory('CustomerDialog', CustomerDialog);

  /** @ngInject */
  function CustomerDialog($mdDialog, $rootScope, customersApi, $document, $translate, FcModalService, accountsApi, $q, customersApiGraphQL, accountFeatureFlagsApiGraphQL) {
    return {
      createCustomer: createCustomer,
      editCustomer: editCustomer
    };

    function createCustomer(ev, callback) {
      _loaderOn();

      var requests = {
        accounts: accountsApi.get(),
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags()
      };

      $q.all(requests).then(function (result) {
        _openCustomerDialog(ev, {
          Customer: null,
          CustomerAttachments: [],
          Account: result.accounts,
          IsOnTicket: false,
          FeatureFlags: result.featureFlags
        }, callback);
      }).finally(_loaderOff);
    }

    function editCustomer(ev, id, callback) {
      _loaderOn();

      var requests = {
        customer: customersApi.getOne(id),
        account: accountsApi.get(),
        customerAttachments: customersApiGraphQL.getCustomerAttachments(id),
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags()
      };

      $q.all(requests).then(function (result) {
        var customerAttachments = result.customerAttachments.filter(function (attachment) {
          return !attachment.archived;
        });

        if (result.customer && !result.customer.primaryLocation) {
          return FcModalService.open('', {
            title: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.ERROR.TITLE'),
            content: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.ERROR.MESSAGE'),
            paddingSmall: true,
            rightButtonText: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.ERROR.CONTINUE'),
            handleRightButton: function () {
              _openCustomerDialog(ev, {
                Customer: result.customer,
                CustomerAttachments: customerAttachments,
                Account: result.account,
                FeatureFlags: result.featureFlags,
                IsOnTicket: false
              }, callback);
            },
            handleClose: function (){
              $rootScope.loadingProgress = false;
              $mdDialog.cancel();
            }
          });
        }

        _openCustomerDialog(ev, {
          Customer: result.customer,
          CustomerAttachments: customerAttachments,
          Account: result.account,
          FeatureFlags: result.featureFlags,
          IsOnTicket: false
        }, callback);
      }).finally(_loaderOff);
    }

    function _openCustomerDialog(ev, locals, callback) {
      $mdDialog.show({
        controller: 'CustomerDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/customers/dialogs/customer-dialog.html',
        parent: document.querySelector('.palantir-modal-container') || angular.element($document.body),
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: true,
        locals: locals,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8
        }
      }).then(function (result) {
        if (!callback) {
          return;
        }

        callback(result.reload, result.savedCustomer);
      });
    }

    function _loaderOn() {
      $rootScope.loadingProgress = true;
    }

    function _loaderOff() {
      $rootScope.loadingProgress = false;
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('app.customers')
		.controller('CustomerDialogController', CustomerDialogController);

	/** @ngInject */
	function CustomerDialogController($scope, $mdDialog, $timeout, Customer, fuseTheming, labelsApi, documentDuplicatedValidationService,
		$mdToast, hasher, focus, customersApi, moment, $rootScope, _, fuseGenerator, tasksApi, CustomersExportDialog, addressService,
		customerTasksTimelineConverter, MessageDialog, geoCoder, cepDbApi, msUtils, locationsApiGraphQL, IntegrationsService, $q, omieApi,
		authenticatedUser, Account, haversine, CustomerAttachments, uploadApi, attachmentsUtils, $window, $translate, LocationsDialog, locationsService,
    FcModalService, customersApiGraphQL, warg2OrganizationsApi, gandalfApi, IsOnTicket, customerLocationsApi, territoriesApi,
    usersApi, FeatureFlags, LocalDateConvert, templatesApi
  ) {

		var vm = this;
		vm.account = Account;
    vm.accountConfiguration = Account.configuration;
		vm.customer = angular.copy(Customer);
		vm.location = { address: {} };
		vm.newCustomer = IsOnTicket || false;
		vm.isOnTicket = IsOnTicket;
		vm.brandImage = null;
		vm.tasks = [];
		vm.timeline = [];
		vm.attachments = CustomerAttachments;
		vm.files = [];
		vm.maxAttachments = 20;
		vm.formErr = {};
		vm.integrations = IntegrationsService.getAll();
		vm.openCustomersExportDialog = openCustomersExportDialog;
		vm.showButtonSendToContaAzul = vm.integrations.contaAzul || false;
		vm.showButtonSendToOmie = vm.integrations.omie || false;
		vm.hasLabelsPermission = authenticatedUser.hasPermission(vm.account, 'settings-registers_labels_menu');
    vm.labelsLimit = vm.accountConfiguration.labelsLimit || 30;
		vm.selectedTabIndex = null;
		vm.alreadyContinued = false;
		vm.hasWhiteSpacesInName = false;
		vm.customerToArchive = angular.copy(Customer);
		vm.labels = [];
		vm.labelSearchText = '';
		vm.editingLabel = null;
		vm.labelTabIndex = 0;
		vm.newLabelColor = null;
		vm.newLabelName = null;
		vm.exists = msUtils.exists;
		vm.palettes = fuseTheming.getRegisteredPalettesLabels();
		vm.rgba = fuseGenerator.rgba;
		vm.emailTypes = [
			{ translate: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.EMAIL_TYPE.WORK'), value: 'work' },
			{ translate: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.EMAIL_TYPE.PERSONAL'), value: 'personal' }
		];
		vm.phoneTypes = [
			{ translate: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.PHONE_TYPE.WORK'), value: 'work' },
			{ translate: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.PHONE_TYPE.HOME'), value: 'home' },
			{ translate: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.PHONE_TYPE.CELL'), value: 'mobile' }
		];
		vm.uploadProgress = false;
		vm.totalUploadsFilesCount = 0;
		vm.currentUploadsFilesCount = 0;
		vm.isGoogleAddress = true;
		vm.invalidLocationGoogleAddress = null;
		vm.googleLocationAddressErrors = null;
		vm.googleLocationAddressWarnings = null;
		vm.locations = [];
		vm.templates = [];
		vm.primaryLocation = null;
		vm.locationsCurrentPage = 0;
		vm.locationPaginationQuantityStart = 0;
		vm.locationPaginationQuantityEnd = 0;
		vm.locationsTotalItems = 0;
		vm.disableLocationsPrevious = true;
		vm.disableLocationsNext = true;
		vm.locationsIsLoading = false;
		vm.locationsNotFound = false;
		vm.locationsFilters = {
			name: ''
		};
		vm.hasDuplicatedLocationsName = false;
		vm.allLocationsNames = [];
    vm.masks = [];
		vm.showMap = false;
    vm.customerHaveCustomerArea = false;
    vm.isToHideShareAttachmentMessageConfirmation = window.localStorage.getItem('isToHideShareAttachmentMessageConfirmation') === 'true' || false;

    vm.userTerritories = [];
    vm.featureFlags = FeatureFlags || [];
    vm.hasTerritoriesFlag = false;
    vm.isAtLeastOneContactFieldInvalid = false;

    var _setCustomerLabelsDebounced = _.debounce(_setLabels, 1000);

		vm.closeDialog = closeDialog;
		vm.continueToNextTab = continueToNextTab;
    vm.validateFields = validateFields;
		vm.duplicatedValidation = duplicatedValidation;
		vm.validateDuplicateWhiteSpacesInName = validateDuplicateWhiteSpacesInName;
		vm.archiveCustomer = archiveCustomer;
		vm.unarchiveCustomer = unarchiveCustomer;
		vm.saveCustomer = saveCustomer;
		vm.addNewLabel = addNewLabel;
		vm.editLabel = editLabel;
		vm.updateLabel = updateLabel;
		vm.labelQuerySearch = labelQuerySearch;
		vm.filterLabel = filterLabel;
		vm.getItemById = msUtils.getItemById;
		vm.toggleInArray = toggleInArray;
		vm.addContactFields = addContactFields;
		vm.deleteContactField = deleteContactField;
		vm.changePrimaryContact = changePrimaryContact;
		vm.checkPhoneType = _.debounce(checkPhoneType, 500);
		vm.removeUploadedAttachment = removeUploadedAttachment;
		vm.viewOriginalAttachment = viewOriginalAttachment;
		vm.uploadImages = _.debounce(uploadImages, 1000);
		vm.confirmRemoveAttachment = confirmRemoveAttachment;
		vm.editAttachmentTitle = editAttachmentTitle;
		vm.cancelEditAttachment = cancelEditAttachment;
		vm.saveAttachmentWhenEnterKey = saveAttachmentWhenEnterKey;
		vm.saveAttachmentTitle = saveAttachmentTitle;
		vm.isFileTypeImage = msUtils.isFileTypeImage;
		vm.getIconByFileType = msUtils.getIconByFileType;
		vm.searchLocationByGoogle = searchLocationByGoogle;
		vm.selectedGoogleAddressChange = selectedGoogleAddressChange;
		vm.cepDb = cepDb;
		vm.geoCoderAddress = geoCoderAddress;
		vm.verifyDuplicatedNameLocation = verifyDuplicatedNameLocation;
		vm.loadLocations = _.debounce(loadLocations, 500);
		vm.loadPrimaryLocation = _.debounce(loadPrimaryLocation, 500);
		vm.changeLocationsPagination = changeLocationsPagination;
		vm.archiveLocation = archiveLocation;
		vm.newLocation = newLocation;
		vm.editLocation = editLocation;
		vm.openMapDialog = openMapDialog;
    vm.locationsService = locationsService;
    vm.changeAttachmentShare = changeAttachmentShare;
		vm.sessionId = msUtils.uuidGenerator();
    vm.smartRewriteFields = ['customer-notes'];
		vm.locationSmartRewriteFields = ['location-complement'];
		vm.isLoading = false;
		vm.validateImage = attachmentsUtils.validateImage;
		vm.countryCode = vm.account.address.countryCode;
    vm.hasFeatureFlag = hasFeatureFlag;
		vm.linkOrderReportTemplate = linkOrderReportTemplate;
    vm.unlinkOrderReportTemplate = unlinkOrderReportTemplate;
		vm.dateFormat = LocalDateConvert.pickFormat('date');
		vm.timeFormat = LocalDateConvert.pickFormat('time');
		vm.goToTaskList = goToTaskList;
		vm.isValidating = false;

		function _initialize() {
      vm.hasTerritoriesFlag = vm.hasFeatureFlag('territories');

			_hideLoadingBar();
			_setCustomer(vm.customer);
			_loadLabels();
			_loadTemplates();
			_setFormattedGoogleAddress();
      getUserTerritories();

			var phones = vm.customer && vm.customer.contacts && vm.customer.contacts.phones;

			vm.countryCodes = _formatCountryCodesToSelect(angular.copy(locationsService.countryCodes));
			vm.customer.contacts.phones = phones.map(function (phone) {
				phone.countryCode = locationsService.findCountryCodeByNumber(phone.countryCode || '55');
				return phone;
			});

			if (!vm.newCustomer) {
				_setIdLabels();
				_loadTasks();
				loadLocations();
				loadPrimaryLocation();
			} else {
				focus('name');
			}

      if (vm.customer && vm.customer.externalAppId) {
        var deferred = $q.defer();

        omieApi.accounts.list()
          .then(function (res) {

            if (!res.data || !res.data.Items || !res.data.Items.length) {
              deferred.resolve({
                name: null,
                appId: null
              });
              return;
            }


            var account = _.find(res.data.Items, { appId: vm.customer.externalAppId });

            deferred.resolve(account);
          })
          .catch(function (error) {
            deferred.reject(error);
          });

        deferred.promise.then(function (account) {
          vm.omieAccount = account ? account.accountName : null;
        });
      }

      vm.customerHaveCustomerArea = vm.customer &&
        vm.customer.metadata &&
        vm.customer.metadata.callbacks &&
        vm.customer.metadata.callbacks[0] === 'warg';

			_checkIfCanShowMap();

			$scope.$watch('customerForm', function () {
				if ($scope.customerForm) {
					$scope.customerForm.$setDirty();
				}
			});
		}

		function closeDialog(reload, savedCustomer) {
			var dialogResult = {
				reload: reload,
				savedCustomer: savedCustomer
			};

			$mdDialog.hide(dialogResult);
			_hideLoadingBar();
		}

		function continueToNextTab() {
			vm.selectedTabIndex = 1;
			vm.alreadyContinued = true;
		}

		function duplicatedValidation(customer, input) {
			vm.isValidating = true;
			documentDuplicatedValidationService.validate(customer, input).finally(function () {
				vm.isValidating = false;
			});
		}

    $scope.$watch(function () {
      return $scope.customerForm.$valid;
    }, function (isValid) {
      if (!isValid) {
        validateFields();
      }

      vm.isAtLeastOneContactFieldInvalid = false;
    });

    function validateFields() {
      var contactFields = ['phone', 'type', 'email'];
      var isAtLeastOneContactFieldInvalid = false;

      $timeout(function () {
        if ($scope.customerForm && $scope.customerForm.$invalid) {
          _.forEach($scope.customerForm, function (field, key) {
            var isContactField = _.some(contactFields, function (phoneField) {
              return _.includes(key, phoneField);
            });

            if (key[0] !== '$' && field && field.$invalid && field.$setTouched && field.$setDirty && isContactField) {
              isAtLeastOneContactFieldInvalid = true;

              field.$setTouched();
              field.$setDirty();
            }
          });
        }

        vm.isAtLeastOneContactFieldInvalid = isAtLeastOneContactFieldInvalid;
      });
    }

		function archiveCustomer() {
			vm.customerToArchive.archived = true;
			_showLoadingBar();
			saveCustomer(vm.customerToArchive);
		}

		function unarchiveCustomer() {
			vm.customerToArchive.archived = false;
			_showLoadingBar();
			saveCustomer(vm.customerToArchive);
		}

		function saveCustomer(customerToSave) {
			var customer = customerToSave || vm.customer;
			_showLoadingBar();

			_uploadBrandImage(function () {
				_saveCustomer(customer, function (savedCustomer) {

					_setLabels(savedCustomer, false, function () {

						for (var i = 0; i < vm.smartRewriteFields.length; i++ ) {
							var field = vm.smartRewriteFields[i];
							var params = {
								reference: vm.sessionId,
								referenceType: field,
								updatedReference: savedCustomer.id
							};

							gandalfApi.updateRewriteInputHistory(params);
						}

						for (var i = 0; i < vm.locationSmartRewriteFields.length; i++ ) {
							var field = vm.locationSmartRewriteFields[i];
							var params = {
								reference: vm.sessionId,
								referenceType: field,
								updatedReference: savedCustomer.primaryLocation && savedCustomer.primaryLocation.id
							};

							gandalfApi.updateRewriteInputHistory(params);
						}

						_showAlertSuccess($translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.SAVED_CUSTOMER', {
							name: savedCustomer.name
						}));

						closeDialog(true, savedCustomer);
					});
				});
			});
		}

		function validateDuplicateWhiteSpacesInName() {
			if (vm.customer && vm.customer.name) {
				var isValid = /\s{2,}/gm.exec(vm.customer.name);

				if (isValid) {
					$scope.customerForm.name.$setValidity('hasWhiteSpacesInName', false);
					$scope.customerForm.name.$setTouched();
					vm.hasWhiteSpacesInName = false;
				} else {
					vm.hasWhiteSpacesInName = true;
					$scope.customerForm.name.$setValidity('hasWhiteSpacesInName', true);
				}
			}
		}

    function _formatCountryCodesToSelect(countryCodes) {
      if (!countryCodes) return [];

      return _.map(countryCodes, function (item) {
        return { translate: '+' + item.countryCode, value: item };
      });
    }

		function toggleInArray(id, array) {
			msUtils.toggleInArray(id, array);

			_setCustomerLabelsDebounced(vm.customer, true);
		};

		function addNewLabel(newLabel) {
			newLabel.type = 'customers';
			labelsApi.save(newLabel).then(function () {
				vm.newLabelColor = null;
				vm.newLabelName = null;
				vm.labelTabIndex = 0;
				_loadLabels();
			});
		}

		function editLabel(label) {
			vm.editingLabel = label;
			vm.labelTabIndex = 2;
		}

		function updateLabel(label) {
			label.type = 'customers';
			labelsApi.save(label).then(function () {
				vm.editingLabel = null;
				vm.labelTabIndex = 0;
				_loadLabels();
			});
		}

		function filterLabel(label) {
			if (!vm.labelSearchText || vm.labelSearchText === '') {
				return true;
			}
			var labelName = angular.lowercase(label.name);
			var labelSearchText = angular.lowercase(vm.labelSearchText);

			return labelName.indexOf(labelSearchText) >= 0;
		}

		function labelQuerySearch(query) {
			return query ? vm.labels.filter(_createFilterFor(query)) : [];
		}

		function addContactFields(contactType, currentContacts) {
      var isContactTypePhone = contactType === 'phone';
			var defaultContact = { name: '', type: isContactTypePhone ? 'home' : 'personal', primary: false };
			var customContactField = isContactTypePhone ? 'number' : 'address';
			defaultContact[customContactField] = '';

			if (!currentContacts.length) {
				defaultContact.primary = true;
			}

			if (isContactTypePhone) {
        defaultContact.countryCode = locationsService.findCountryCodeByNumber('55');
			}

			currentContacts.push(defaultContact);

			$timeout(function () {
				focus(contactType + '__' + (vm.customer.contacts.phones.length - 1));
        validateFields();
			}, 300);
		}

		function deleteContactField(contact, contactIndex, currentContacts, contactType) {
			_setFormDirty();

			var newContacts = _.filter(currentContacts, function (contact, index) {
				return index !== contactIndex;
			});

			if (contact.primary && newContacts && newContacts.length) {
				newContacts[0].primary = true;
			}

			if (contactType === 'phone') {
				vm.customer.contacts.phones = newContacts;
			} else {
				vm.customer.contacts.emails = newContacts;
			}
		}

		function changePrimaryContact(contactIndex, currentContacts, contactType) {
			_setFormDirty();

			var newContacts = _.map(currentContacts, function (contact, index) {
				contact.primary = index === contactIndex ? true : false;
				return contact;
			});

			if (contactType === 'phone') {
				vm.customer.contacts.phones = newContacts;
			} else {
				vm.customer.contacts.emails = newContacts;
			}
		}

		function checkPhoneType(index) {
			if (vm.customer.contacts.phones[index]) {
				var completePhoneNumber = vm.customer.contacts.phones[index].number;

				if (completePhoneNumber && completePhoneNumber.length > 10 && completePhoneNumber[2] === '9') {
					vm.customer.contacts.phones[index].type = 'mobile';
				} else {
					vm.customer.contacts.phones[index].type = 'work';
				}
			}
		}

		function removeUploadedAttachment(attachmentIndex) {
			vm.files.splice(attachmentIndex, 1);
		}

		function viewOriginalAttachment(attachment) {
			$timeout(function () {
				$window.open(attachment.path, '_blank');
			}, 250);
		}

		function uploadImages() {
			if (vm.files && vm.files.length) {
				vm.uploadProgress = true;
				vm.totalUploadsFilesCount = vm.files.length;
				vm.currentUploadsFilesCount = 0;

				for (var i = 0; i < vm.files.length; i++) {
					var filePath = '/customers/' + vm.customer.id + '/attachments/' + vm.files[i].name;

					uploadApi.uploadWithPreSignedPost({
						file: vm.files[i],
						filePath: filePath
					}, function () { }).then(function (result) {
						vm.currentUploadsFilesCount++;
						var attachment = {
							path: attachmentsUtils.correctUrl(result.path),
							type: result.contentType
						};

						customersApi.postAttachment(vm.customer.id, attachment).then(function () {
							var uploadsCompleted = vm.currentUploadsFilesCount >= vm.totalUploadsFilesCount;
							if (uploadsCompleted) {
								vm.files = [];
								vm.uploadProgress = false;

								_showAlertSuccess($translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.SEND_SUCCESS'));
								_getCustomerAttachments();
							}
						});
					}).catch(function (err) {
						vm.files = [];
						vm.uploadProgress = false;

						_showErrorAlert($translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.SEND_FAIL', {
							file_name: err.config.data.file.name
						}));

						_getCustomerAttachments();
					});
				}
			}
		}

		function confirmRemoveAttachment(attachment) {
			_showLoadingBar();
			attachment.archived = true;

			customersApi.putAttachment(vm.customer.id, attachment).then(function () {
				vm.files = [];
				_hideLoadingBar();
				_getCustomerAttachments();

        warg2OrganizationsApi.unsyncOrganizationAttachment(attachment.id, vm.customer._id).then(function (response) {
          if (!response) {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant(TRANSLATION_ROOT + '.TOASTS.ERROR'))
                .theme('error-toast')
                .hideDelay(3000)
            );
          }
        });
      });

		}

		function editAttachmentTitle(attachment) {
			attachment.editing = true;
			attachment.removing = false;
			attachment._previousTitle = attachment.title;
			focus("attachment_" + attachment.id);
		}

		function cancelEditAttachment(attachment) {
			attachment.title = attachment._previousTitle;
			attachment.editing = false;
		}

		function saveAttachmentWhenEnterKey(e, attachment) {
			if (e.key === 'Enter') {
				e.preventDefault();
				saveAttachmentTitle(attachment);

				return false;
			}
		}

		function saveAttachmentTitle(attachment) {
			_showLoadingBar();

			customersApi.putAttachment(vm.customer.id, attachment).then(function () {
				attachment.editing = false;
				attachment.removing = false;
				MessageDialog.showToast({
					hideDelay: 4000,
					message: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.SAVE_TITLE_SUCCESS')
				});

        warg2OrganizationsApi.syncOrganizationAttachment(attachment.id, vm.customer._id).then(function (response) {
          if (!response) {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant(TRANSLATION_ROOT + '.TOASTS.ERROR'))
                .theme('error-toast')
                .hideDelay(3000)
            );
          }
        });
			}).finally(function () {
				_hideLoadingBar();
			});
		}

		function openCustomersExportDialog($event, apiName) {
			if (vm.customer && vm.customer.notes && vm.customer.notes.length > 255 && apiName === 'Conta Azul') {
				$mdDialog.show(
					$mdDialog.alert()
						.parent(angular.element(document.body))
						.clickOutsideToClose(true)
						.title($translate.instant('CUSTOMERS.DIALOGS.ALERTS.CUSTOMER_DESCRIPTION.TITLE'))
						.ok('OK')
						.textContent($translate.instant('CUSTOMERS.DIALOGS.ALERTS.CUSTOMER_DESCRIPTION.MESSAGE'))
				);
				return;
			}

      if (apiName === 'Conta Azul') {
        return locationsApiGraphQL.queryForDialog(vm.customer.primaryLocation.id).then(function (location) {
          CustomersExportDialog.exportTo($event, vm.customer, location, 'Conta Azul', 'conta-azul');
        });
      }

      FcModalService.open($event, {
        title: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.ACCOUNT'),
        content: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.SELECT_THE_ACCOUNT', { customerName: vm.customer.name }),
        paddingSmall: true,
        hasOmieAccountSelector: true,
        rightContinueButton: true,
        rightButtonText: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'),
        leftButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
        handleRightButton: function (account) {
          locationsApiGraphQL.queryForDialog(vm.customer.primaryLocation.id).then(function (location) {
            CustomersExportDialog.exportTo($event, vm.customer, location,  apiName, account.appId);
          });
        }
      });
		}

		function searchLocationByGoogle(callback) {
			var start = {
				latitude: parseFloat(Account.address.coords.latitude),
				longitude: parseFloat(Account.address.coords.longitude)
			};

			geoCoder.getByAddressString(vm.locationByGoogleSearchTerm).then(function (results) {
				results.forEach(function (result) {
					var end = {
						latitude: parseFloat(result.lat),
						longitude: parseFloat(result.lng)
					};

					result.kmDistance = haversine(start, end, 'km');
				});

				vm.googleLocations = _.sortBy(results, 'kmDistance');
        if (callback) { callback(); }
			});
		}

		function cepDb() {
			if (!vm.location.address.postalCode) {
				vm.location.address.street = '';
				vm.location.address.city = '';
				vm.location.address.state = '';
				vm.location.address.number = '';
				vm.location.address.neighborhood = '';
				vm.location.address.coords = {
					latitude: 0,
					longitude: 0
				};
			} else {
				var cep = vm.location.address.postalCode.replace(/\D/g, '');
        var initialAddress = angular.copy(vm.location.address);

				cepDbApi.search({ 'zipCode': cep }).then(function (data) {
					if (data) {
						vm.location.address.street = data.logradouro;
						vm.location.address.city = data.cidade;
						vm.location.address.state = data.estado;
						vm.location.address.neighborhood = data.bairro;
						vm.location.address.coords = {
							latitude: 0,
							longitude: 0
						};
						focus('number');
					} else {
						vm.location.address.street = '';
						vm.location.address.city = '';
						vm.location.address.state = '';
						vm.location.address.neighborhood = '';
						vm.location.address.coords = {
							latitude: null,
							longitude: null
						};
					}
				});
			}
      vm.geoCoderAddress(initialAddress);

			_checkIfCanShowMap();
		}

		function geoCoderAddress(initialAddress) {
			if (vm.location.hashAddress !== _hashAddress()) {
				var address = angular.copy(vm.location.address);
				address.zipCode = address.postalCode;
				delete address.zipCode;

				geoCoder.getByAddressObject(address).then(function (location) {
					if (location) {
            fetchTerritoriesByCoordinates({
              latitude: parseFloat(location.lat),
              longitude: parseFloat(location.lat),
            }).then(function (response) {
              if (!response) {
                vm.location.address = initialAddress;

                return;
              }

              vm.location.address = vm.location.address || {};
              vm.location.address.coords = vm.location.address.coords || {};
              vm.location.address.coords.latitude = parseFloat(location.lat);
              vm.location.address.coords.longitude = parseFloat(location.lng);
            });
					} else {
						vm.location.address = vm.location.address || {};
						vm.location.address.coords = vm.location.address.coords || {};
						vm.location.address.coords.latitude = null;
						vm.location.address.coords.longitude = null;
						vm.location.address.formattedAddress = null;
					}

					vm.location.hashAddress = _hashAddress();
				});
			}

			_checkIfCanShowMap();
		}

		function verifyDuplicatedNameLocation(callback) {
			if (!vm.newCustomer) {
				if (vm.location && vm.location.name && vm.location.name !== '') {
					return customerLocationsApi.search({
						where: {
							customerIds: [vm.customer.id],
							name: vm.location.name,
							archived: false
						},
						take: 4
					}).then(function (locations) {
						var resultLocations = locations.items;

						if (resultLocations.length) {
							$scope.customerForm.locationName.$setValidity('duplicatedName', false);
							$scope.customerForm.locationName.$setTouched();
						} else {
							$scope.customerForm.locationName.$setValidity('duplicatedName', true);
						}

						if (callback) { callback(); }
					});
				}
			}
		}

		function changeLocationsPagination(pagesToChange) {
			pagesToChange < 0 ? vm.locationsCurrentPage -= 1 : vm.locationsCurrentPage += 1;

			if (vm.locationsCurrentPage < 0) {
				vm.locationsCurrentPage = 0;
			}

			loadLocations();
		}

    function loadLocations(callback) {
			if (!vm.newCustomer) {
				vm.locations = [];
				var limit = 4;
				vm.locationsCurrentPage = vm.locationsCurrentPage || 0;
				vm.locationsIsLoading = true;

				var searchQuery = {
					customerIds: [vm.customer.id],
					archived: vm.hasTerritoriesFlag ? null : false
				};

				if (vm.locationsFilters && vm.locationsFilters.name) {
					searchQuery['nameContains'] = vm.locationsFilters.name;
				}

				var searchOptions = {
					limit: limit,
					offset: limit * vm.locationsCurrentPage
				};

				return customerLocationsApi.search({
					where: searchQuery,
					take: limit,
					skip: limit * vm.locationsCurrentPage
				})
					.then(function (locations) {
						vm.locations = locations.items;

						vm.locationPaginationQuantityStart = searchOptions.offset + 1;
						vm.locationPaginationQuantityEnd = searchOptions.limit + searchOptions.offset;
						vm.locationsTotalItems = locations.totalCount;

						vm.disableLocationsPrevious = vm.locationsCurrentPage === 0;
						vm.disableLocationsNext = vm.locationPaginationQuantityEnd >= vm.locationsTotalItems;

						if (vm.disableLocationsNext) {
							vm.locationPaginationQuantityEnd = vm.locationsTotalItems;
						}

						if (vm.locations.length) {
							vm.locations.forEach(function (location) {
								var primaryLocation = vm.customer.primaryLocation;
								if (primaryLocation && primaryLocation.id === location.id) {
									location.primary = true;
								}

								if (vm.allLocationsNames.length < vm.locationsTotalItems) {
									vm.allLocationsNames.push(location.name);
								}
							});

							vm.locationsNotFound = false;
						} else {
							vm.locationsNotFound = true;
						}

            if ((!vm.customer || !vm.customer.primaryLocation) && vm.locations && vm.locations.length && vm.locations[0]) {
              vm.customer.primaryLocation = angular.copy(vm.locations[0]);
              vm.loadPrimaryLocation = _.debounce(loadPrimaryLocation, 500);
            }

						if (callback) { callback(); }
					})
					.finally(function () {
						vm.locationsIsLoading = false;
					});
			}
		}

		function archiveLocation(location) {
			_showLoadingBar();

			location.archived = true;
			var locationPayload = _sanitizeLocation(location);

			customersApi.putLocation(vm.customer.id, locationPayload).then(function (result) {
				$mdToast.show(
					$mdToast.simple()
						.textContent($translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.TOASTS.LOCATION_ARCHIVED', {
							locationName: location.name
						})).hideDelay(3000)
				);
			}).catch(function (error) {
				$mdToast.show(
					$mdToast.simple()
						.textContent($translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.TOASTS.SAVE_ERROR'))
						.hideDelay(3000)
				);
			}).finally(function () {
				if (vm.locationsCurrentPage > 0 && vm.locations.length === 1) {
					changeLocationsPagination(-1);
				} else {
					loadLocations();
				}

				_hideLoadingBar();
			});
		}

		function newLocation(event) {
			LocationsDialog.createLocation(event, { customer: vm.customer, isOnTicket: vm.isOnTicket }, function (locationResponse) {
				if (locationResponse.primaryLocationId) {
					vm.customer.primaryLocation.id = locationResponse.primaryLocationId;
				}

				if (locationResponse.reload) {
					$timeout(function () {
						loadLocations();
						loadPrimaryLocation();
					}, 300);
				}
			});
		}

		function editLocation(event, locationId) {
			LocationsDialog.editLocation(event, locationId, vm.account, function (locationResponse) {
				if (!locationResponse) {
					return;
				}

				if (locationResponse.primaryLocationId) {
					vm.customer.primaryLocation.id = locationResponse.primaryLocationId;
				}

				if (locationResponse.reload) {
					$timeout(function () {
						loadLocations();
						loadPrimaryLocation();
					}, 300);
				}
			});
		}

		function openMapDialog(event, address) {
			if (!vm.showMap) { return; }

			LocationsDialog.openMapDialog(event, {
				Address: address,
				UpdateCoordsFunc: _updateLocationCoords,
        UserTerritories: vm.userTerritories,
			});
			_setFormDirty();
		}

    function changeAttachmentShare(share, index) {
      if (share || vm.isToHideShareAttachmentMessageConfirmation) {
        _shareAttachment(index, share);
        return;
      }

      _showCustomerShareAttachmentConfirmationDialog(function () {
        _shareAttachment(index, share);
      });
    }

    function _shareAttachment(index, share) {
      if (!share) {
        warg2OrganizationsApi.syncOrganizationAttachment(vm.attachments[index].id, vm.customer._id).then(function (response) {
          var TRANSLATION_ROOT = 'CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.SHARE_ATTACHMENTS_WITH_CLIENT';

          if (!response) {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant(TRANSLATION_ROOT + '.TOASTS.ERROR'))
                .theme('error-toast')
                .hideDelay(3000)
            );
          }

          vm.attachments[index].metadata = vm.attachments[index].metadata || {};
          vm.attachments[index].metadata.callbacks = vm.attachments[index].metadata.callbacks || [];
          vm.attachments[index].metadata.callbacks.push('warg');

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant(TRANSLATION_ROOT + '.TOASTS.IS_SHARING'))
              .theme('success-toast')
              .hideDelay(3000)
          );
        });

        return;
      }

      warg2OrganizationsApi.unsyncOrganizationAttachment(vm.attachments[index].id, vm.customer._id).then(function (response) {
        var TRANSLATION_ROOT = 'CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.SHARE_ATTACHMENTS_WITH_CLIENT';

        if (!response) {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant(TRANSLATION_ROOT + '.TOASTS.ERROR'))
              .theme('error-toast')
              .hideDelay(3000)
          );
        }

        vm.attachments[index].metadata = vm.attachments[index].metadata || {};
        vm.attachments[index].metadata.callbacks = vm.attachments[index].metadata.callbacks || [];
        vm.attachments[index].metadata.callbacks = _.without(vm.attachments[index].metadata.callbacks, 'warg');

        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant(TRANSLATION_ROOT + '.TOASTS.IS_NOT_SHARING'))
            .theme('success-toast')
            .hideDelay(3000)
        );
      });
    }

    function _showCustomerShareAttachmentConfirmationDialog(callback) {
      var CONFIRM_DIALOG_TRANSLATION_PATH = 'CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.SHARE_ATTACHMENTS_WITH_CLIENT.CONFIRMATION_DIALOG';

      FcModalService.open(null, {
        title: $translate.instant(CONFIRM_DIALOG_TRANSLATION_PATH + '.TITLE'),
        content: $translate.instant(CONFIRM_DIALOG_TRANSLATION_PATH + '.DESCRIPTION', { customerName: vm.customer.name }),
        templateUrl: 'app/main/customers/dialogs/templates/share-attachment.template.html',
        rightButtonText: $translate.instant(CONFIRM_DIALOG_TRANSLATION_PATH + '.YES'),
        leftButtonText: $translate.instant(CONFIRM_DIALOG_TRANSLATION_PATH + '.NO'),
        variables: {
          isToHideShareAttachmentMessageConfirmation: vm.isToHideShareAttachmentMessageConfirmation,
          handleCheck: function (value) {
            vm.isToHideShareAttachmentMessageConfirmation = value;
          }
        },
        handleRightButton: function () {
          if (vm.isToHideShareAttachmentMessageConfirmation) {
            window.localStorage.setItem('hideShareAttachmentMessageConfirmation', true);
          }
          callback();
        }
      });
    }

		function _setCustomer(customer) {
			if (!customer) {
				vm.customer = {
					idLabels: [],
					address: {
						coords: {
							latitude: 0,
							longitude: 0
						}
					},
					contacts: {
						emails: [],
						phones: []
					}
				};

				vm.newCustomer = true;
			} else {
				vm.customer.address = customer.address || {};
				vm.customer.address.coords = customer.address.coords || {};

				vm.customer.contacts = customer.contacts || {};
				vm.customer.contacts.emails = customer.contacts.emails || [];
				vm.customer.contacts.phones = customer.contacts.phones || [];
				vm.hasWhiteSpacesInName = true;
			}
		}

		function _uploadBrandImage(callback) {
			if (!vm.brandImage) {
				return callback();
			}

			var filename = '/customers/' + vm.customer.id + '/brand/' + msUtils.shortGuidGenerator() + '.png';
			uploadApi.uploadWithPreSignedPost({ file: vm.brandImage, filePath: filename })
				.then(function (result) {
					vm.customer.avatarUrl = result.path;
					callback();
				});
		}

		function _mapLocationToCustomer(location) {
			return {
				zipCode: location.address.postalCode,
				city: location.address.city,
				state: location.address.state,
				neighborhood: location.address.neighborhood,
				street: location.address.street,
				number: location.address.number,
				coords: location.address.coords,
				complement: location.address.complement,
				formattedAddress: location.address.formattedAddress
			};
		}

		function _saveCustomer(customer, callback) {
			customer.contacts = msUtils.clearEmptyContacts(customer.contacts);
			delete customer.contact;

			customer.contacts.phones = locationsService.mapPhoneCollectionToCountryCodeString(vm.customer.contacts.phones);

			if (!customer.documentNumber) {
				customer.documentNumber = null;
			}

			if (vm.newCustomer) {
				customer.address = _mapLocationToCustomer(vm.location);
			}

			var isEditing = Boolean(customer.id);

			if (isEditing) {
				if(vm.locations && vm.locations.length > 0){
					customer.address = _mapLocationToCustomer(vm.primaryLocation);
				}

				var customerToUpdate = _.cloneDeep(customer);
				customerToUpdate.orderReportTemplate = vm.customer.orderReportTemplate ? vm.customer.orderReportTemplate : { id: null };

				return customersApi.save(customerToUpdate).then(function (savedCustomer) {
					callback(savedCustomer);
				});
			}
			var customerToCreate = _.cloneDeep(customer);
			delete customerToCreate.idLabels;
			delete customerToCreate.orderReportTemplate;
			customerToCreate.locationName = vm.location && vm.location.name || '';
			customerToCreate.orderReportTemplateId = vm.customer.orderReportTemplate ? vm.customer.orderReportTemplate.id : null;
			return customersApiGraphQL.createCustomer(customerToCreate).then(function (savedCustomer) {
				callback(savedCustomer);
			});
		}

		function _setLabels(customer, isUpdate, callback) {
			if ((!customer.id || !vm.customer.idLabels) && !vm.isOnTicket) {
				return;
			}

			if (isUpdate) {
				_showLoadingBar();
			}

			var labels = _.map(vm.customer.idLabels, function (id) {
				return { id: id };
			});

			return customersApi.setLabels(customer.id, labels)
				.then(function () {
					if (isUpdate) {
						MessageDialog.showToast({
							hideDelay: 3000,
							message: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.LABEL.UPDATED')
						});
					}

					if (callback) {
						callback();
					}
				})
				.finally(function () {
					if (isUpdate) {
						_hideLoadingBar();
						$rootScope.$broadcast('customers:filter-updated');
					}
				});
		}

		function _loadTasks() {
			tasksApi.search({
				where: {
					customerIds: [vm.customer.id],
					archived: false
				},
				orderBy: 'scheduledDate_desc'
			}).then(function (result) {
				vm.tasks = result.items;
				vm.timeline = customerTasksTimelineConverter.toTimeline(result.items);

				if (vm.timeline.length) {
					var schedulingDates = vm.tasks.map(function (task) {
						if(task.scheduling.date){
							return moment(task.scheduling.date);
						}
						return null;
					});
					schedulingDates = schedulingDates.filter(function (schedulingDate) {return Boolean(schedulingDate); });
					vm.lastTaskDate = moment.max(schedulingDates).format('YYYY-MM-DD');
					vm.firstTaskDate = moment('2015-01-01').format('YYYY-MM-DD');
				}
			});
		}

		function _setFormDirty() {
			if ($scope.customerForm) {
				_.defer(function () {
					$scope.$apply(function () {
						$scope.customerForm.$setDirty();
					});
				});
			}
		}

		function _loadLabels() {
			labelsApi.search({
				type: 'customers'
			}, { limit: 100 }).then(function (result) {
				vm.labels = result.items;
			});
		}

		function _loadTemplates() {
			templatesApi.search({ take: 1000, skip: 0, where: { archived: false } }).then(function (result) {
				vm.templates = result.items;
			});
		}

		function _setIdLabels() {
			vm.customer.idLabels = [];
			if (vm.customer.labels && vm.customer.labels.length) {
				vm.customer.idLabels = _.map(vm.customer.labels, 'id');
			}
		}

		function _createFilterFor(query) {
			return function filterFn(item) {
				var itemName = angular.lowercase(item.name);
				var queryText = angular.lowercase(query);
				return itemName.indexOf(queryText) >= 0;
			};
		}

		function _getCustomerAttachments() {
			customersApiGraphQL.getCustomerAttachments(vm.customer.id).then(function (attachments) {
				vm.attachments = attachments.filter(function (attachment) {
          return !attachment.archived;
        });
			});
		}

		function _sanitizeLocation(location) {
			var sanitizedLocation = angular.copy(location);
			if (!sanitizedLocation.address.postalCode) delete sanitizedLocation.address.postalCode;
			if (!sanitizedLocation.address.city) delete sanitizedLocation.address.city;
			if (!sanitizedLocation.address.state) delete sanitizedLocation.address.state;
			if (!sanitizedLocation.address.street) delete sanitizedLocation.address.street;
			if (!sanitizedLocation.address.neighborhood) delete sanitizedLocation.address.neighborhood;
			if (!sanitizedLocation.address.number) delete sanitizedLocation.address.number;
			if (!sanitizedLocation.address.complement) sanitizedLocation.address.complement = null;

			return sanitizedLocation;
		}

		function _updateLocationCoords(_, args) {
      return new Promise(function (resolve) {
        fetchTerritoriesByCoordinates({
          latitude: args.model.lat,
          longitude: args.model.lng,
        }).then(function (response) {
          if (!response) {
            return resolve();
          }

          vm.location.address = vm.location.address || {};
          vm.location.address.coords = vm.location.address.coords || {};
          vm.location.address.coords.latitude = args.model.lat;
          vm.location.address.coords.longitude = args.model.lng;
          vm.selectedGoogleLocation.lat = args.model.lat;
          vm.selectedGoogleLocation.lng = args.model.lng;

          if (vm.newCustomer) {
            _setFormDirty();
          }

          resolve(true);
        });
      });
		}

		function _hashAddress() {
			return hasher.sha1({
				postalCode: vm.location.address.postalCode,
				street: vm.location.address.street,
				city: vm.location.address.city,
				neighborhood: vm.location.address.neighborhood,
				state: vm.location.address.state,
				number: vm.location.address.number
			});
		}

		function _setFormattedGoogleAddress() {
			var hasAddres = !!(vm.customer.address && vm.customer.address.formattedAddress);
			if (hasAddres && vm.isOnTicket) {
        getAddressCoords();
			}
    }

		function _checkIfCanShowMap() {
			vm.showMap = vm.location.address && vm.location.address.coords && vm.location.address.coords.latitude && vm.location.address.coords.longitude;
		}

		function _showLoadingBar() {
			document.dispatchEvent(new CustomEvent('showLoadingBar'));
			vm.isLoading = true;
		}

		function _hideLoadingBar() {
			document.dispatchEvent(new CustomEvent('hideLoadingBar'));
			vm.isLoading = false;
		}

		function _showAlertSuccess(message) {
			document.dispatchEvent(new CustomEvent('showSuccessAlert', { detail: { message: message } }));
		}

		function _showErrorAlert(message) {
			document.dispatchEvent(new CustomEvent('showErrorAlert', { detail: { message: message } }));
		}

    function getAddressCoords() {
      vm.locationByGoogleSearchTerm = vm.customer.address.formattedAddress;
      searchLocationByGoogle(function () {
        vm.selectedGoogleLocation = vm.googleLocations[0];
        selectedGoogleAddressChange();
      });
    }

		function loadPrimaryLocation() {
      if (!vm.customer || !vm.customer.primaryLocation) {
        return {};
      }

			return customerLocationsApi.getOne(vm.customer.primaryLocation.id)
			.then(function (location) {
				vm.primaryLocation = location;
			})
			.finally(function () {
				vm.locationsIsLoading = false;
			});
		}

    function getUserTerritories() {
      var userId = authenticatedUser.profile.id;

      usersApi.getTerritories(userId).then(function (territories) {
        vm.userTerritories = territories;
      });
    }

    function selectedGoogleAddressChange() {
      if (!vm.selectedGoogleLocation) {
        vm.invalidLocationGoogleAddress = null;
        vm.googleLocationAddressErrors = null;
        vm.googleLocationAddressWarnings = null;
				$scope.customerForm.googleLocation.$setValidity('validation', true);

        return;
      }

      fetchTerritoriesByCoordinates({
        latitude: vm.selectedGoogleLocation.lat,
        longitude: vm.selectedGoogleLocation.lng,
      }).then(function (response) {
        handleGoogleLocationUpdate(response);
        _checkIfCanShowMap();
      });
		}

    function fetchTerritoriesByCoordinates(coords) {
      return new Promise(function (resolve) {
        if (!vm.userTerritories || !vm.userTerritories.length) {
          return resolve(true);
        }

        territoriesApi.territoriesByCoordinates(coords).then(function (territories) {
          var territory = territories.find(function (territory) {
            return !territory.parentTerritory;
          });

          var filteredUserTerritories = vm.userTerritories.filter(function (userTerritory) {
            return userTerritory.id === (territory && territory.id);
          });

          if (filteredUserTerritories && filteredUserTerritories.length) {
            return resolve(true);
          }

          showChangeAddressTerritoryModal().then(function (response) {
            if (response) {
              resolve(true);

              return;
            }

            resolve(false);
          });
        });
      });
    }

    function showChangeAddressTerritoryModal() {
      return new Promise(function (resolve) {
        FcModalService.open(null, {
          title: 'Troca de endereço da localização',
          paddingSmall: true,
          content:
            'O novo endereço inserido nesta localização não está associado a nenhum território ao qual você pertença. Ao prosseguir, os grupos de usuários e colaboradores vinculados a este território perderão o acesso a esta localização. Se necessário, um administrador poderá vincular esta localização a um território novamente.<br><br>Tem certeza que deseja continuar?',
          leftButtonText: 'NÃO',
          rightButtonText: 'SIM',
          handleRightButton: function () {
            resolve(true);
          },
          handleLeftButton: function () {
            resolve(false);
          },
        });
      });
    }

    function handleGoogleLocationUpdate(response) {
      if (!response) {
        vm.selectedGoogleLocation = null;
        vm.locationByGoogleSearchTerm = '';

        return;
      }

      var selectedAddress = vm.selectedGoogleLocation;

      vm.location.address = {
        postalCode: selectedAddress.zipCode || null,
        city: selectedAddress.city || null,
        state: selectedAddress.state || null,
        neighborhood: selectedAddress.neighborhood || null,
        street: selectedAddress.street || null,
        number: selectedAddress.number || null,
        complement: vm.location.address.complement,
        coords: {
          latitude: selectedAddress.lat,
          longitude: selectedAddress.lng,
        },
        formattedAddress: selectedAddress.formattedAddress,
      };

      validateGoogleLocationAddress(vm.location.address);

      _checkIfCanShowMap();
    }

    function validateGoogleLocationAddress(address) {
      var validation = addressService.validateAddress(address);
      vm.invalidLocationGoogleAddress = !validation.valid;
      vm.googleLocationAddressErrors = validation.errors;
      vm.googleLocationAddressWarnings = validation.warnings;
      vm.isInitializing = false;
      $scope.customerForm.googleLocation.$setValidity('validation', !vm.invalidLocationGoogleAddress);
      _setFormDirty();
    }

    function hasFeatureFlag(name) {
      var hasFeature = vm.featureFlags.find(function (featureFlag) {
        return featureFlag.name === name;
      });

      if (!hasFeature) { return false; }

      return hasFeature.active;
    }

		function linkOrderReportTemplate() {
      var openPalantirSelectItemDialogParams = {
        title: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.SELECT.TITLE'),
        selectAllText: '',
        searchPlaceholderText: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.SELECT.SEARCH'),
        cancelText: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.SELECT.CANCEL'),
        successText: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.SELECT.SUCCESS'),
        emptyText: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.SELECT.EMPTY'),
        items: vm.templates,
        type: 'single',
        map: function (item) {
          return {
            id: item.id,
            avatar: {
              icon: 'template-outline'
            },
            title: item.name + ' (' + (item.active ? $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.ACTIVE') : $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.INACTIVE')) + ')',
            subtitle: $translate.instant('CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.TYPE.ORDER')
          };
        },
        search: function (value) {
          if (!value) { return vm.templates; }

          return vm.templates.filter(function (template) {
            var lowerCaseValue = value.toLowerCase();

            return template.name.toLowerCase().includes(lowerCaseValue);
          });
        }
      };

      document.dispatchEvent(new CustomEvent('openPalantirSelectItemDialog', { detail: openPalantirSelectItemDialogParams }));

      document.addEventListener('palantirSelectItemDialogClosed', _linkOrderReportTemplate);
    }

    function unlinkOrderReportTemplate() {
      vm.customer.orderReportTemplate = null;

      setTimeout(function () {
        $scope.$apply();

        if ($scope.customerForm) {
					$scope.customerForm.$setDirty();
				}
      });
    }

		function _linkOrderReportTemplate(event) {
      if (!event) { return; }
      if (!event.detail) { return; }
      if (event.detail.role !== 'success') { return; }

      var template = event.detail.data[0];

      setTimeout(function () {
				vm.customer.orderReportTemplate = template;

				$scope.$apply();

				if ($scope.customerForm) {
					$scope.customerForm.$setDirty();
				}
			});

      document.removeEventListener('ticketFeatureFlagUpdated', _linkOrderReportTemplate);
    }

		function goToTaskList() {
			var url = '#/atividades?q=id_cliente:\'' + encodeURIComponent(vm.customer.id) +
				'\'+data_agendamento<=:' + vm.lastTaskDate +
				'+data_agendamento>=:' + vm.firstTaskDate;

			vm.closeDialog();
			setTimeout(function () {
				window.location.href = url;
				window.location.reload();
			}, 300);
		}

		_initialize();
	}
})();

(function () {
  'use strict';

  angular
    .module('app.control-panel')
    .factory('TasksDistribution', TasksDistribution);

  /** @ngInject */
  function TasksDistribution(moment, _) {

    function splitByAmountPerDay(tasks, amountPerDay) {
      var tasksArray = angular.copy(tasks);
      var separedItems = [];
      var initialIndex = 0;

      do {
        separedItems.push(
          tasksArray.splice(initialIndex === 0 ? initialIndex : initialIndex - 1, amountPerDay)
        );
      } while (tasksArray.length > 0);
      return separedItems;
    }

    function updateTasks(tasks, selectedWeekDays, initialDate) {
      if (!tasks || !tasks.length || !selectedWeekDays || !selectedWeekDays.length) {
        return [];
      }

      var currentDate = moment(initialDate);
      var weekDaysCount = 0;
      var positionToUpdateTasks = 0;

      while (weekDaysCount < selectedWeekDays.length && positionToUpdateTasks !== tasks.length) {
        var currentWeekDay = selectedWeekDays[weekDaysCount];
        var isCurrentWeekDayEqual = currentWeekDay.value === currentDate.weekday();
        if (isCurrentWeekDayEqual) {
          tasks[positionToUpdateTasks].forEach(function (task) {
            task.scheduling.date = currentDate.format('YYYY-MM-DD');
          });
          positionToUpdateTasks++;
        }

        ++weekDaysCount;
        var isLastSelectedWeekDay = weekDaysCount === selectedWeekDays.length;
        if (isLastSelectedWeekDay) {
          weekDaysCount = 0;
          currentDate.add(1, 'day');
        }
      }
      return tasks;
    }

    function extractTasks(updatedTasks) {
      var allTasks = [];

      updatedTasks.forEach(function (tasks) {
        allTasks = allTasks.concat(tasks);
      });

      return allTasks;
    }

    function filterSelectedWeekDays(daysOfTheWeek) {
      return _.filter(daysOfTheWeek, function (weekDay) {
        return weekDay.checked;
      });
    }

    return {
      splitByAmountPerDay: splitByAmountPerDay,
      updateTasks: updateTasks,
      extractTasks: extractTasks,
      filterSelectedWeekDays: filterSelectedWeekDays
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.control-panel').factory('ControlPanelFilters', ControlPanelFilters);

  /** @ngInject */
  function ControlPanelFilters($rootScope, $timeout) {
    var filters = {
      customerName: '',
      locationName: '',
      description: '',
      archived: 'false',
      customerLabels: [],
      employees: [],
      services: [],
      status: [],
      labels: [],
      ratings: [],
      clear: clear,
      isOn: isOn,
      isOff: isOff,
    };

    function clear() {
      filters.customerName = '';
      filters.locationName = '';
      filters.description = '';
      filters.archived = 'false';
      filters.customerLabels = [];
      filters.employees = [];
      filters.services = [];
      filters.status = [];
      filters.labels = [];
      filters.ratings = [];

      $timeout(function () {
        $rootScope.$broadcast('control-panel:filter-updated');
      }, 200);
    }

    function isOn() {
      var emptyCustomerName = filters.customerName === '';
      var emptyLocationName = filters.locationName === '';
      var emptyDescription = filters.description === '';
      var noArchivedFiltered = filters.archived === 'false';
      var emptyCustomerLabels = filters.customerLabels.length === 0;
      var noEmployeeFiltered = filters.employees.length === 0;
      var noServiceFiltered = filters.services.length === 0;
      var noStatusFiltered = filters.status.length === 0;
      var noLabelsFiltered = filters.labels.length === 0;
      var noRatingFiltered = filters.ratings.length === 0;

      return !(
        emptyCustomerName &&
        emptyCustomerLabels &&
        emptyLocationName &&
        emptyDescription &&
        noArchivedFiltered &&
        noRatingFiltered &&
        noEmployeeFiltered &&
        noServiceFiltered &&
        noStatusFiltered &&
        noLabelsFiltered
      );
    }

    function isOff() {
      return !isOn();
    }

    return filters;
  }
})();

(function () {
    'use strict';

    angular
        .module('app.control-panel')
        .factory('ControlPanelData', ControlPanelData);

    /** @ngInject */
    function ControlPanelData($q, $rootScope, moment, tasksApi, employeesApi,
        accountsApi, labelsApi, locationsApi, absencesApi, routerizationApi,
        TasksEstimation) {

        var _data = null;
        var _currentDate = moment().toDate();
        var _selectedDate = null;
        var _selectedDateAsString = null;
        var _isPastDate = null;
        var _isPastOrTodayDate = null;

        setDate(_currentDate);

        return {

            reset: reset,

            getData: function () {
                return _data;
            },

            getDate: function () {
                return _selectedDate;
            },

            getDateAsString: function () {
                return _selectedDateAsString;
            },

            setDate: setDate,
            loadData: loadData,

            setData: setData,
        };

        function setData(key, value) {
          _data = _data || {};
          _data[key] = value;
          $rootScope.$broadcast('control-panel:data-updated', _data);
        }

        function setDate(selectedDate) {
            _currentDate = moment().toDate();
            _selectedDate = selectedDate;
            _selectedDateAsString = moment(_selectedDate).format('YYYY-MM-DD');
            _isPastDate = isPastDate();
            _isPastOrTodayDate = isPastOrTodayDate();
        }

        function reset() {
            setDate(moment().toDate());
            _data = null;
        }

        function isPastDate() {
            var currentDate = moment(_currentDate).startOf('day').toDate();
            var selectedDate = moment(_selectedDate).startOf('day').toDate();
            return selectedDate.getTime() < currentDate.getTime();
        }

        function isPastOrTodayDate() {
            var currentDate = moment(_currentDate).startOf('day').toDate();
            var selectedDate = moment(_selectedDate).startOf('day').toDate();
            return selectedDate.getTime() <= currentDate.getTime();
        }

        function loadTasks(where) {
          return new Promise(function (resolve) {
              var tasks = [];
              var skip = 0;
              var params = { where: angular.copy(where) };
              var page = 500;

              var mergeResult = function () {
                params.take = page;
                params.skip = skip;

                tasksApi.queryForControlPanel(params).then(function (result) {
                    for (var index = 0; index < result.items.length; index++) {
                        var task = result.items[index];
                        tasks.push(task);
                    }

                    if (tasks.length < result.totalCount) {
                        skip += page;
                        mergeResult();
                    } else {
                        resolve(tasks);
                    }
                });
              };
              mergeResult();
          });
        }


        function getTasks(where) {
          var deferred = $q.defer();
          var take = 500;

          tasksApi.queryForControlPanel({
            where: where,
            take: 1,
            skip: 0
          })
          .then(function (res) {
            var totalCount = res.totalCount;
            var pageCount = Math.ceil(totalCount / take);

            var promises = [];
            for (var i = 0; i < pageCount; i++) {
              promises.push(
                tasksApi.queryForControlPanel({
                  where: where,
                  take: take,
                  skip: i * take
                })
              );
            }

            $q.all(promises)
              .then(function (results) {
                var all = [];

                for (var j = 0; j < results.length; j++) {
                  all = all.concat(results[j].items);
                }

                deferred.resolve(all);
              })
              .catch(function (err) {
                deferred.reject(err);
              });
          })
          .catch(function (err) {
            deferred.reject(err);
          });

          return deferred.promise;
        }

        function loadLocations() {
          return locationsApi
            .getLastedLocations()
            .catch(function () {
              return [];
            });
        }

        function loadData(forceReload) {
          $rootScope.$broadcast('control-panel:data-updating');
          $rootScope.loadingProgress = true;

          var selectedDate = moment(_selectedDateAsString);

          var requests = {};
          requests.employees = employeesApi.getAll();
          requests.tasks = getTasks({ scheduledOrStartedOrCompletedAtDate: _selectedDateAsString });
          requests.absences = absencesApi.getByDate(_selectedDateAsString);
          requests.locations = loadLocations();

          if (_data == null || !_data.account) {
              requests.account = accountsApi.get();
          }

          if (_data == null || !_data.labels) {
              requests.labels = labelsApi.search({ type: 'orders' }, { limit: 100 });
          }

          return $q.all(requests).then(function (result) {
              _data = _data || {};
              _data.tasks = result.tasks;
              _data.tasks.forEach(function (task) {
                  var taskEmployee = _.find(result.employees.items, function (item) {
                      return task.employee && task.employee.id === item.id;
                  });
                  if (taskEmployee) {
                      task.employee = taskEmployee;
                  } else {
                      task.employee = { id: null };
                  }
              });
              _data.employees = _.filter(result.employees.items, function (employee) {
                  if (employee.contract.firedAt == null) {
                      return true;
                  } else {
                      var selectedDate = moment(_selectedDate);
                      var firedAt = moment.utc(employee.contract.firedAt);
                      return selectedDate.toDate().getTime() <= firedAt.toDate().getTime();
                  }
              });

              _data.absences = result.absences;
              _data.locations = result.locations || [];

              if (result.account) { _data.account = result.account; }
              if (result.labels) { _data.labels = result.labels.items; }

              var tasksEstimationOption = {
                  timezone: _data.account.timezone,
                  realTimeMonitoring: _data.account.configuration.ganttRealTimeMonitoringOn,
              };

              var filteredTasks = removeTasksCompletedAtLessThenSelectedDate(_data.tasks, selectedDate);
              filteredTasks = removeTasksStartedAtGreaterThanSelectedDate(filteredTasks, selectedDate);
              TasksEstimation.estimateTasks(filteredTasks, tasksEstimationOption);
              _data.locations.forEach(function (location) {
                  var employee = _.find(_data.employees, function (employee) {
                      return employee.id === location.employeeId;
                  });

                  if (employee) {
                      var isAbsent = _.any(_data.absences, function (absence) {
                          return absence.employee.id == employee.id;
                      });

                      if (!isAbsent) {
                          var locationTime = moment.utc(location.timestamp);
                          var utcNow = moment.utc();
                          var diffInMinutes = utcNow.diff(locationTime, 'minutes');
                          employee.isOnline = (diffInMinutes < 20);
                          location.employee = angular.copy(employee);
                          employee.location = angular.copy(location);
                      }
                  }
              });

              _data.options = {
                  selectedDate: _selectedDate,
                  selectedDateAsString: _selectedDateAsString,
                  isPastDate: _isPastDate,
                  isPastOrTodayDate: _isPastOrTodayDate,
                  forceReload: (forceReload === true)
              };

              $rootScope.$broadcast('control-panel:data-updated', _data);
          })
          .finally(function () {
              $rootScope.loadingProgress = false;
          });
        }

        function removeTasksCompletedAtLessThenSelectedDate(tasks, selectedDate) {
          var filteredTasks = _.filter(tasks, function (task) {
            var completedAtLessThenSelectedDate = false;
            var startedAtLessThenSelectedDate = false;
            if(task.completedAt && task.startedAt) {
              completedAtLessThenSelectedDate = moment(task.completedAt).diff(moment(selectedDate), 'hours') < 0;
              startedAtLessThenSelectedDate = moment(task.startedAt).diff(moment(selectedDate), 'hours') < 0;
            }
            return !completedAtLessThenSelectedDate || !startedAtLessThenSelectedDate;
          });
          return filteredTasks;
        }

        function removeTasksStartedAtGreaterThanSelectedDate(tasks, selectedDate) {
          var filteredTasks = _.filter(tasks, function (task) {
            var startedAtGreaterThanSelectedDate = false;
            if(task.startedAt) {
              startedAtGreaterThanSelectedDate = moment(task.startedAt).diff(moment(selectedDate), 'days') > 0;
            }
            return !startedAtGreaterThanSelectedDate;
          });
          return filteredTasks;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.calendar')
        .factory('calendarTooltip', calendarTooltip);

    function calendarTooltip() {

        return {
            tooltipTemplate : tooltipTemplate
        };

        function tooltipTemplate(task) {
            var isMoreTasksIndicator = task && task.className && task.className.includes('more-tasks-indicator');
            if (isMoreTasksIndicator) {
              return '<md-tooltip md-direction="top" class="tooltip more-tasks-indicator">Clique para ver as atividades</md-tooltip>';
            }

            var template = '<md-tooltip md-direction="top" class="tooltip ' + task.status.name + '">';
            template += '<i class="icon icon-city s15 grey-A100-fg"></i> '  + task.title;
            template += '<br/><i class="icon icon-clipboard-text s15 grey-A100-fg"></i> '  + task.orderIdentifier;
            template += '<br/><i class="icon icon-tag s15 grey-A100-fg"></i> '  + task.serviceName;

            if (task.labels && task.labels.length) {
                template += '<br/><i class="icon icon-label s15 grey-A100-fg"></i> ';
                task.labels.forEach(function (label) {
                    template += '<span style="font-size: 11px;" class="md-'+label.color+'-bg status-label">'+label.name+'</span>&nbsp;';
                });
            }

            template += '<br/><i class="icon-traffic-light s15 icon grey-A100-fg"></i> ' + task.status.description;
            if (task.startTime) {
                template += '<br/><i class="icon-calendar-clock s15 icon grey-A100-fg"></i> ' + task.startTime;

                if (task.status.name !== 'scheduled' && task.endTime) {
                    template += ' - ' + task.endTime;
                }
            }

            if (task.rating && task.rating.stars) {
                template += '<br/><i class="icon icon-thumbs-up-down s15 grey-A100-fg"></i> ';

                var className = task.rating.stars >= 1 ? 'icon-star' : 'icon-star-outline';
                template += '<i style="color: #ffb508;" class="icon s15 '+className+'"></i>';

                className = task.rating.stars >= 2 ? 'icon-star' : 'icon-star-outline';
                template += '<i style="color: #ffb508;" class="icon s15 '+className+'"></i>';

                className = task.rating.stars >= 3 ? 'icon-star' : 'icon-star-outline';
                template += '<i style="color: #ffb508;" class="icon s15 '+className+'"></i>';

                className = task.rating.stars >= 4 ? 'icon-star' : 'icon-star-outline';
                template += '<i style="color: #ffb508;" class="icon s15 '+className+'"></i>';

                className = task.rating.stars >= 5 ? 'icon-star' : 'icon-star-outline';
                template += '<i style="color: #ffb508;" class="icon s15 '+className+'"></i>';
            }

            if (task.employeeName) {
                template += '<br/><i class="icon icon-worker s15 grey-A100-fg"></i> ' + task.employeeName;
            }

            if(task.locationName){
                template += '<br/><i class="icon icon-map-marker s15 grey-A100-fg"></i> ' + task.locationName;
            }

            template += '</md-tooltip>';

            return template;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.calendar')
        .factory('CalendarTasksFilter', CalendarTasksFilter);

    function CalendarTasksFilter($timeout, $rootScope) {
        var filters = {
            customersName: '',
            activitiesIdentifier: '',
            services: [],
            labels:[],
            status: [],
            employees: [],

            clear: clear,
            isOn: isOn,
            isOff: isOff
        };

        function clear() {
            filters.customersName = '';
            filters.activitiesIdentifier = '';
            filters.services = [];
            filters.labels = [];
            filters.status = [];
            filters.employees = [];

            $timeout(function () { $rootScope.$broadcast('calendar-tasks:filter-updated'); }, 200);
        }

        function isOn() {
            var noCustomersFiltered = filters.customersName === '';
            var noActivitiesFiltered = filters.activitiesIdentifier === '';
            var noServicesFiltered = filters.services.length === 0;
            var noLabelsFiltered = filters.labels.length === 0;
            var noStatusFiltered = filters.status.length === 0;
            var noEmployeesFiltered = filters.employees.length === 0;

            return !(
              noCustomersFiltered &&
              noActivitiesFiltered &&
              noServicesFiltered &&
              noLabelsFiltered &&
              noStatusFiltered &&
              noEmployeesFiltered
            );
        }

        function isOff() {
            return !isOn();
        }

        return filters;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.bootstrap')
        .factory('autocompleteAddressService', autocompleteAddressService);

    /** @ngInject */
    function autocompleteAddressService(geoCoder, $timeout, $translate) {
        var model = null;
        var hasAccountAddressValue = false;

        function setModel(modelAddress) {
            model = modelAddress;
        }

        function hasAccountAddress() {
            return hasAccountAddressValue;
        }

        function setHasAccountAddress(bool) {
            hasAccountAddressValue = bool;
        }

        function validateAddress(formErr) {
            var accountAddressIsSelected = model.formattedAddress;

            if (!accountAddressIsSelected) {
                var enterAddressTranslation = $translate.instant('BOOTSTRAP.FORM.ADDRESS.ENTER_ADDRESS') || 'Enter the address in the field above';
                formErr['accountAddressIsRequired'] = enterAddressTranslation + ' <i class="md-accent-fg icon icon-arrow-up-bold s14"></i>';
                return false;
            } else {
                delete formErr['accountAddressIsRequired'];
                return true;
            }
        }

        function selectedAddressItemChange(selectedAddress, form, formErr) {
            if (selectedAddress) {
                $timeout(function () {
                    if (form) {
                        form.$setDirty();
                    }
                }, 1000);

                model['zipCode'] = selectedAddress.zipCode || null;
                model['city'] = selectedAddress.city || null;
                model['state'] = selectedAddress.state || null;
                model['neighborhood'] = selectedAddress.neighborhood || null;
                model['street'] = selectedAddress.street || null;
                model['number'] = selectedAddress.number || null;
                model['coords'] = {
                    latitude: selectedAddress.lat,
                    longitude: selectedAddress.lng
                };
                model['formattedAddress'] = selectedAddress.formattedAddress;

                delete formErr['accountAddressIsRequired'];
            }
        }

        function searchAddress(addressAsString, options) {
            return geoCoder.getByAddressString(addressAsString, options).then(function (results) {
                return results;
            });
        }

        return {
            setModel: setModel,
            hasAccountAddress: hasAccountAddress,
            searchAddress: searchAddress,
            selectedAddressItemChange: selectedAddressItemChange,
            setHasAccountAddress: setHasAccountAddress,
            validateAddress: validateAddress
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth-reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.auth-reset-password', {
            url      : '/redefinir-senha/:id',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-reset-password': {
                    templateUrl: 'app/main/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            data: {titleTranslateKey: 'RESET_PASSWORD.PAGE_TITLE'},
            bodyClass: 'forgot-password'
        });

        $translatePartialLoaderProvider.addPart('app/main/auth/reset-password');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth-reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController(
      $stateParams, $scope, $state, msInfoBarService, $window,
      auth, $timeout, $rootScope, MessageDialog, msUtils, $translate, EnvironmentConfig
    ) {

        msInfoBarService.remove();

        var vm = this;
        vm.form = {
            sent: false,
            error: false
        };
        vm.samplePassword = msUtils.generateRandomPassword();
        vm.submit = submit;
        vm.toggleNewPassword = toggleNewPassword;

        function submit() {

            $rootScope.loadingProgress = true;

            vm.form.sent = false;
            vm.form.error = false;
            vm.errorMessage = null;

            auth.resetPassword($stateParams.id, vm.form.password).then(function () {

                $timeout(function () {

                    vm.form.sent = true;
                    vm.form.error = false;

                    $timeout(function () {

                        MessageDialog.showToast({
                            hideDelay: 7000,
                            message: $translate.instant('RESET_PASSWORD.TOAST.SUCCESSFULLY_RESETED')
                        });

                        $window.location.href = EnvironmentConfig.blackgateClientUrl + 'login';
                    }, 3000);

                }, 1000);

            }).catch(function (err) {

                vm.form.sent = true;
                vm.form.error = true;

                var expired = err.data.code === 'reset_password_expired';
                var used = err.data.code === 'reset_password_already_used';
                var notFound = err.status == 404;

                if (expired || used || notFound) {
                    vm.errorMessage = $translate.instant('RESET_PASSWORD.ERRORS.INVALID_LINK');
                }

                if (err.data.code === 'reset_password_saving_err' || err.data.code === 'reset_password_hash_err') {
                    vm.errorMessage = $translate.instant('RESET_PASSWORD.ERRORS.RESET_FAILED');
                }

            }).finally(function () {

                $timeout(function () {
                    $rootScope.loadingProgress = false;
                }, 5000);

            });

        }

        function toggleNewPassword() {
          vm.showNewPassword = !vm.showNewPassword;
          var inputPassword = document.getElementById('password');
          vm.showNewPassword ? inputPassword.classList.add("show") : inputPassword.classList.remove("show");
          inputPassword.focus();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth-forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.auth-forgot-password', {
            url      : '/esqueci-minha-senha',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-forgot-password': {
                    templateUrl: 'app/main/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            data: {titleTranslateKey: 'FORGOT_PASSWORD.PAGE_TITLE'},
            bodyClass: 'forgot-password'
        });

        $translatePartialLoaderProvider.addPart('app/main/auth/forgot-password');
    }

})();
(function () {
  'use strict';

  angular
    .module('app.auth-forgot-password')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController(auth, $rootScope, $timeout, msInfoBarService) {
    msInfoBarService.remove();

    var vm = this;
    vm.form = {
      sent: false
    };
    vm.submit = submit;

    function submit() {
      $rootScope.loadingProgress = true;
      auth.forgotPassword(vm.form.email).then(function () {
        vm.form.sent = true;
      }).finally(function () {
        $timeout(function () {
          $rootScope.loadingProgress = false;
        }, 3000);
      });
    }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth-confirm-email', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.auth-confirm-email', {
            url      : '/confirmar-email',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-confirm-email': {
                    templateUrl: 'app/main/auth/confirm-email/confirm-email.html',
                    controller : 'ConfirmEmailController as vm'
                }
            },
            resolve  : {
                User: function (usersApi, authenticatedUser) {
                    return usersApi.get(authenticatedUser.profile.id);
                },
                Services:  function (servicesApi) {
                    return servicesApi.getAll().then(function (response) {
                        return response.items;
                    });
                },
                Employees:  function (employeesApi) {
                    return employeesApi.getAll().then(function (response) {
                        return response.items;
                    });
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/confirm-email');
    }

})();
(function () {
  'use strict';

  angular
    .module('app.auth-confirm-email')
    .controller('ConfirmEmailController', ConfirmEmailController);

  /** @ngInject */
  function ConfirmEmailController(
    User, Services, Employees, usersApi, auth, authenticatedUser,
    $timeout, $interval, $state, $rootScope, $scope
  ) {
    var vm = this;
    vm.user = angular.copy(User);
    vm.interval = null;
    vm.emailSent = false;
    vm.loading = false;

    vm.sendConfirmationEmail = sendConfirmationEmail;

    _initialize();

    function _initialize() {
      if (vm.user.emailValidatedAt) {
        redirect();
      } else {
        vm.interval = $interval(verifyEmailConfirmation, 10000);
      }
    }

    function verifyEmailConfirmation() {
      usersApi.get(authenticatedUser.profile.id)
        .then(function (user) {
          if (user.emailValidatedAt) {
            $interval.cancel(vm.interval);
            redirect();
          }
        });
    }

    function redirect() {
      if (Services.length <= 0 || Employees.length <= 0) {
        $timeout(function () {
          $state.go('app.bootstrap');
        }, 1000);
      } else {
        $timeout(function () {
          $state.go('app.tasks');
        }, 1000);
      }
    }

    function sendConfirmationEmail() {
      $rootScope.loadingProgress = true;
      vm.loading = true;

      auth.sendConfirmationEmail()
        .then(function () {
          vm.emailSent = true;
        }).finally(function () {
          vm.loading = false;
          $rootScope.loadingProgress = false;
        });
    }

    $scope.$on("$destroy", function (){
      $interval.cancel(vm.interval);
    });
  }
}).call(this);
(function () {
  'use strict';

  angular.module('app.services').controller('AbsenceDialogController', AbsenceDialogController);

  /** @ngInject */
  function AbsenceDialogController($mdDialog, Absence, $mdToast, _, $rootScope, MessageDialog, focus,
    absencesApi, employeesApi, dateConverter, $translate, $scope) {

    var vm = this;
    vm.employees = [];
    vm.absence = angular.copy(Absence);
    vm.newAbsence = false;

    if (!vm.absence) {
      vm.absence = {
        employee: {
          id: null,
        },
        reason: '',
      };
      vm.absence.to = new Date();
      vm.absence.from = new Date();
      vm.newAbsence = true;
    } else {
      vm.absence.to = dateConverter.toDateTimeStringIgnoreUtc(vm.absence.to);
      vm.absence.from = dateConverter.toDateTimeStringIgnoreUtc(vm.absence.from);
    }

    loadEmployees();

    vm.dateAbsenceValidation = dateAbsenceValidation;
    vm.closeDialog = closeDialog;
    vm.saveAbsence = saveAbsence;
    vm.loadEmployees = loadEmployees;
    vm.toggleRequiredValidationWorkaround = toggleRequiredValidationWorkaround;
    vm.deleteAbsence = deleteAbsence;

    function deleteAbsence() {
      var absenceEmployee = _.find(vm.employees, function (employee) {
        if (vm.absence.employee) {
          return employee.id == vm.absence.employee.id;
        } else {
          return null;
        }
      });

      if (absenceEmployee) {
        var confirm = $mdDialog
          .confirm()
          .title($translate.instant('ABSENCES.DIALOG.DELETE_ALERT.TITLE'))
          .textContent($translate.instant('ABSENCES.DIALOG.DELETE_ALERT.TEXT_CONTENT'))
          .ok($translate.instant('ABSENCES.DIALOG.DELETE_ALERT.OK'))
          .cancel($translate.instant('ABSENCES.DIALOG.DELETE_ALERT.CANCEL'));

        $mdDialog.show(confirm).then(function () {
          $rootScope.loadingProgress = true;

          absencesApi
            .delete(vm.absence.id)
            .then(function () {
              MessageDialog.showToast({
                message: $translate.instant('ABSENCES.TOAST.SUCCESSFULLY_REMOVED', {
                  employeeName: absenceEmployee.name,
                }),
              });

              $rootScope.$broadcast('absences:deleted');
            })
            .catch(function () {
              MessageDialog.showToast({
                message: $translate.instant('ABSENCES.TOAST.REMOVE_FAILED', { employeeName: absenceEmployee.name }),
              });
            })
            .finally(function () {
              $rootScope.loadingProgress = false;
            });
        });
      }
    }

    function dateAbsenceValidation() {
      if (moment(vm.absence.to).isBefore(vm.absence.from)) {
        $scope.absenceForm.to.$setValidity('invalid', false);
      } else {
        $scope.absenceForm.to.$setValidity('invalid', true);
      }
    }

    function toggleRequiredValidationWorkaround() {
      return !(vm.absence && vm.absence.employee && vm.absence.employee.id);
    }

    function loadEmployees() {
      if (vm.employees.length > 0) {
        return;
      }
      return employeesApi.getAll().then(function (employees) {
        if (vm.newAbsence) {
          vm.employees = _.filter(employees.items, function (employee) {
            if(employee.contract.active && !employee.inactivatedAt){
              employee.translate = employee.name;
              employee.value = employee.id;
              return employee;
            }
          });
        } else {
          vm.employees = _.filter(employees.items, function (employee) {
            if ((employee.contract.active && !employee.inactivatedAt) || employee.id === vm.absence.employee.id) {
              employee.translate = employee.name;
              employee.value = employee.id;
              return employee;
            }
          });
        }
      });
    }

    function saveAbsence() {
      absencesApi.save(vm.absence).then(function () {
        var absenceEmployee = _.find(vm.employees, function (employee) {
          return employee.id == vm.absence.employee.id;
        });

        $mdToast.show(
          $mdToast
            .simple()
            .textContent($translate.instant('ABSENCES.TOAST.SAVE_SUCCESSFULLY', { employeeName: absenceEmployee.name }))
            .hideDelay(3000)
        );

        closeDialog(true);
      });
    }

    function closeDialog(reload) {
      $mdDialog.hide(reload);
    }

    focus('reason');
  }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('querifyPost', querifyPost);

        function querifyPost() {

            return function (query) {

                var q = '';
                for (var property in query) {
                    if (query.hasOwnProperty(property)) {
                        var value = query[property];
                        if (_.isArray(value)) {
                            if (value.length > 0) {
                                q += (property + ':' + value.join(',') + ' ');
                            }
                        } else if (value) {
                            q += (property + ':"' + value + '" ');
                        }
                    }
                }
                return q.trim();
            };

        }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('querify', querify);

        function querify(msUtils) {

            return function (query, options) {

                var q = '';
                for (var property in query) {
                    if (query.hasOwnProperty(property)) {
                        var value = query[property];
                        if (_.isArray(value)) {
                            if (value.length > 0) {
                                q += encodeURIComponent(property + ':' + value.join(',') + ' ');
                            }
                        } else if (value || value === false || value === 0) {
                            q += encodeURIComponent(property + ':"' + value + '" ');
                        }
                    }
                }
                var queryString = '?q=' + q.trim();
                if(options) {
                    queryString += '&' + msUtils.qStringify(options);
                }
                return queryString;
            };
        }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('OpenNotificationService', OpenNotificationService);

  /** @ngInject */
  function OpenNotificationService(OrderDialog, QuotationsDialog) {
    return {
      openDialog: openDialog,
      openQuotationDialog: openQuotationDialog
    };

    function openDialog(location) {
      var notificationParamId = location.search().id;
      var notificationType = location.search().type;
      var mapTabIndex = {
        'commentCreated': 12,
        'taskReported': 0,
        'taskRated': 13,
        'deadlineAtRisk': 1,
        'deadlineOutOfSchedule': 1,
        'locationLinks': 3
      };

      if (notificationParamId && notificationType) {
        if (notificationType === 'ticketCreated' || notificationType === 'ticketOnNegotiation') {
          location.path('/chamados-e-oportunidades/' + notificationParamId);
          return;
        } else if (notificationType.includes('quotation')) {
          location.path('/orcamentos');
          QuotationsDialog.editQuotation(null, notificationParamId);
          return;
        }
        OrderDialog.editTask(null, { id: notificationParamId, tabIndex: mapTabIndex[notificationType] || 0 });
      }
    }

    function openQuotationDialog(location) {
      var notificationParamId = location.search().id;
      var notificationType = location.search().type;

      if (notificationParamId && notificationType && notificationType.includes('quotation')) {
        QuotationsDialog.editQuotation(null, notificationParamId);
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('documents', documents);

  function documents($filter) {

    return {
      isValidDocument: isValidDocument,
      formatDocument: formatDocument
    };

    function formatDocument(cpfOrCnpj) {
      return cpfOrCnpj && cpfOrCnpj.length > 4 ? $filter('cpfCnpjFilter')(cpfOrCnpj) : '';
    }

    function _checkDocumentType(value) {
      value = value.toString();
      value = value.replace(/[^0-9]/g, '');

      if (value.length === 11) {
        return 'CPF';
      } else if (value.length === 14) {
        return 'CNPJ';
      } else {
        return false;
      }
    }

    function _calcDigitsPosition(digits, positions, sumDigits) {
      positions = positions || 10;
      sumDigits = sumDigits || 0;
      digits = digits.toString();

      for (var i = 0; i < digits.length; i++) {
        sumDigits = sumDigits + (digits[i] * positions);
        positions--;

        if (positions < 2) { positions = 9; }
      }


      sumDigits = sumDigits % 11;
      sumDigits = sumDigits < 2 ? 0 : 11 - sumDigits;

      return digits + sumDigits;
    }

    function _isValidCpf(cpf) {
      var cpfDigits = cpf.substr(0, 9);
      var cpfCalc = _calcDigitsPosition(cpfDigits);
      cpfCalc = _calcDigitsPosition(cpfCalc, 11);
      return cpfCalc === cpf ? true : false;
    }

    function _isValidCnpj(cnpj) {
      var cnpjCopy = cnpj;
      var firstNumbersCnpj = cnpj.substr(0, 12);
      var firstCalc = _calcDigitsPosition(firstNumbersCnpj, 5);
      var secondCalc = _calcDigitsPosition(firstCalc, 6);
      cnpj = secondCalc;
      return cnpj === cnpjCopy ? true : false;
    }

    function isValidDocument(document) {

      var documentType = _checkDocumentType(document);
      document = document.toString();
      document = document.replace(/[^0-9]/g, '');

      if (documentType === 'CPF') {
        return _isValidCpf(document);
      } else if (documentType === 'CNPJ') {
        return _isValidCnpj(document);
      } else {
        return false;
      }

    }
  }
})();
(function () {
  'use strict';

  angular.module('app.core').factory('DateDiffer', DateDiffer);

  /** @ngInject */
  function DateDiffer(_, moment) {
    return {
      getTimeParts: getTimeParts,
      isToday: isToday,
      createDate: createDate,
      timeStringToSeconds: timeStringToSeconds,
      diffInMinutes: diffInMinutes
    };

    function getTimeParts(timeAsString) {
      var timeParts = timeAsString.split(':');
      return {
        hours: timeParts[0],
        minutes: timeParts[1]
      };
    }

    function isToday(dateA, dateB) {
      dateA = moment.utc(dateA);
      dateB = moment.utc(dateB);
      return dateA.format('YYYY-MM-DD') === dateB.format('YYYY-MM-DD');
    }

    function createDate(baseDate, timeAsString, timezone) {
      timezone = timezone || 'America/Sao_Paulo';
      baseDate = baseDate || '2016-01-01';
      timeAsString = timeAsString || '00:00:00';

      var stringDate = baseDate + ' 00:00';
      var date = moment.tz(stringDate, timezone);
      var timeParts = this.getTimeParts(timeAsString);

      date.add(timeParts.hours, 'h');
      date.add(timeParts.minutes, 'm');

      return date;
    }

    function timeStringToSeconds(timeAsString) {
      var timeParts = timeAsString.split(':');
      var totalSeconds = (parseInt(timeParts[0]) * 60 * 60);
      totalSeconds += (parseInt(timeParts[1]) * 60);
      if (timeParts[2]) { totalSeconds += parseInt(timeParts[2]); }
      return parseInt(totalSeconds);
    }

    function diffInMinutes(startTimeAsString, endTimeAsString) {
      var startAt = createDate(null, startTimeAsString);
      var endAt = createDate(null, endTimeAsString);
      return endAt.diff(startAt, 'minutes');
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.core').factory('DateConversionHandler', DateConversionHandler);

    /** @ngInject */
    function DateConversionHandler(_, moment) {
        return {
            toUtcDateString: toUtcDateString,
            toUtcDateTimeString: toUtcDateTimeString,
            toUtcWithCompleteDateTimeString: toUtcWithCompleteDateTimeString,
            toUtc: toUtc
        };

        function toUtcDateString(date) {
            if (!date) { return null; }
            var parsedDate = moment(date);
            return parsedDate.format('YYYY-MM-DD');
        }

        function toUtcDateTimeString(date) {
            if (!date) { return null; }
            var parsedDate = moment(date);
            return parsedDate.format('YYYY-MM-DD') + 'T' + parsedDate.format('HH:mm:ss') + 'Z';
        }

        function toUtcWithCompleteDateTimeString(date) {
            if (!date) { return null; }
            var parsedDate = moment(date);
            return parsedDate.format('YYYY-MM-DD') + 'T' + parsedDate.format('HH:mm:ss.SSS') + 'Z';
        }

        function toUtc(tzDate) { return moment(tzDate).utc(); }
    }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('attachmentsUtils', attachmentsUtils);

    /** @ngInject */
    function attachmentsUtils(EnvironmentConfig, $translate) {

        var prefixUrlImageResizer = EnvironmentConfig.uploadsBaseUrl + 's3-image-resizer';
        var prefixBucketUrl = EnvironmentConfig.uploadsStaticBaseUrl;

        return {
            correctUrl: correctUrl,
            correctMumakilUrl: correctMumakilUrl,
            validateImage: validateImage
        };

        function correctUrl(path) {

            if (path) {

                var hasHttp = (path.indexOf('http://') !== -1);
                var hasHttps = (path.indexOf('https://') !== -1);
                if (hasHttp || hasHttps) {
                    return path;
                } else {
                    return prefixBucketUrl + path;
                }

            } else {
                return null;
            }

        }

        function correctMumakilUrl(path) {

            var defaultUrl = 'http://via.placeholder.com/300x300';

            if (path) {

                var hasHttp = (path.indexOf('http://') !== -1);
                var hasHttps = (path.indexOf('https://') !== -1);
                if (hasHttp || hasHttps) {
                    return {
                        path: path,
                        thumbnailPath: path,
                    };
                } else {
                    return {
                        path: prefixBucketUrl + path,
                        thumbnailPath: prefixUrlImageResizer + '?type=jpeg&width=200&height=200&quality=100&filename=' + path,
                    };
                }

            } else {
                return {
                    path: defaultUrl,
                    thumbnailPath: defaultUrl
                };
            }

        }
        function validateImage(file) {
            if (file.size > 10485760) {
                _showErrorToast($translate.instant('EQUIPMENTS.DIALOG.ATTACHMENTS.MAX_SIZE_FILES'));
                return false;
            } else {
                return true;
            }
        }

        function _showErrorToast(message) {
            document.dispatchEvent(new CustomEvent('showErrorAlert', { detail: { message: message } }));
        }
    }

})();

(function () {
    'use strict';

    angular.module('app.core').factory('AirDistance', AirDistance);

    /** @ngInject */
    function AirDistance() {
        return {
            getAverageKmSpeed: getAverageKmSpeed,
            calculateMinutes: calculateMinutes,
            getDistanceRanges: getDistanceRanges
        };

        function _roundUp(value) {
            return Math.ceil(value);
        }

        function getAverageKmSpeed(kmDistance) {
            if (kmDistance < 9) { return 15; }
            if ((kmDistance > 9) && (kmDistance < 30)) { return 35; }
            return 60;
        }

        function getDistanceRanges(kmDistance) {
            var ranges = [];

            if (kmDistance <= 9) {
                ranges.push({ distance: kmDistance, averageKmSpeed: 15 });
                return ranges;
            }

            if ((kmDistance > 9) && (kmDistance <= 30)) {
                ranges.push({ distance: 9, averageKmSpeed: 15 });
                kmDistance = kmDistance - 9;
                ranges.push({ distance: kmDistance, averageKmSpeed: 35 });
                return ranges;
            }

            if (kmDistance > 30) {
                ranges.push({ distance: 9, averageKmSpeed: 15 });
                kmDistance = kmDistance - 9;
                ranges.push({ distance: 21, averageKmSpeed: 35 });
                kmDistance = kmDistance - 21;
                ranges.push({ distance: kmDistance, averageKmSpeed: 60 });
                return ranges;
            }

            return ranges;
        }

        function haversine(start, end, options) {
            options = options || {};

            var toRad = function (num) {
                return ((num * Math.PI) / 180);
            };

            var radii = {
                km: 6371,
                mile: 3960,
                meter: 6371000
            };

            var R = radii.km;
            if (options.unit && radii[options.unit]) { R = radii[options.unit]; }

            var dLat = toRad(end.latitude - start.latitude);
            var dLon = toRad(end.longitude - start.longitude);
            var lat1 = toRad(start.latitude);
            var lat2 = toRad(end.latitude);

            var a = (Math.sin(dLat / 2) * Math.sin(dLat / 2)) + (Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2));
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            if (options.threshold) { return options.threshold > (R * c); }
            return R * c;
        }

        function calculateMinutes(route) {
            var kmDistance = haversine(route.from, route.to, { unit: 'km' });
            var distanceRanges = getDistanceRanges(kmDistance);
            var distanceInMinutes = 0;
            distanceRanges.forEach(function (range) {
                var rangeDistanceInMinutes = (range.distance * 60) / range.averageKmSpeed;
                distanceInMinutes += rangeDistanceInMinutes;
            });
            return _roundUp(distanceInMinutes);
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('LocalDateConvert', LocalDateConvert);

  /** @ngInject */
  function LocalDateConvert(_, moment, translateService) {
    var language = translateService.getLanguage() || 'pt';
    moment.locale(language);

    var dateFormats = {
      pt: {
        date: 'DD/MM/YYYY',
        'date-time': 'DD/MM/YYYY HH:mm',
        'date-time-seconds': 'DD/MM/YYYY HH:mm:ss',
        time: 'HH:mm',
        'time-seconds': 'HH:mm:ss',
      },
      en: {
        date: 'MM/DD/YYYY',
        'date-time': 'MM/DD/YYYY hh:mm a',
        'date-time-seconds': 'MM/DD/YYYY hh:mm:ss a',
        time: 'hh:mm a',
        'time-seconds': 'hh:mm:ss a',
      },
      es: {
        date: 'DD/MM/YYYY',
        'date-time': 'DD/MM/YYYY HH:mm',
        'date-time-seconds': 'DD/MM/YYYY HH:mm:ss',
        time: 'HH:mm',
        'time-seconds': 'HH:mm:ss',
      },
    };

    var altFormats = {
      pt: {
        date: 'dd/MM/yyyy',
        'date-time': 'dd/MM/yyyy HH:mm',
        'date-time-seconds': 'dd/MM/yyyy HH:mm:ss',
        time: 'HH:mm',
      },
      en: {
        date: 'MM/dd/yyyy',
        'date-time': 'MM/dd/yyyy hh:mm a',
        'date-time-seconds': 'MM/dd/yyyy hh:mm:ss',
        time: 'hh:mm a',
      },
      es: {
        date: 'dd/MM/yyyy',
        'date-time': 'dd/MM/yyyy HH:mm',
        'date-time-seconds': 'dd/MM/yyyy HH:mm:ss',
        time: 'HH:mm',
      },
    };

    function formatDate(date, format, timezone) {
      if (!date) return null;

      if (!format) {
        format = 'date';
      }

      var dateFormat = dateFormats[language][format] || dateFormats[language]['date'];
      var parsedDate = moment(date);

      var isTimeOnly = /^\d{2}:\d{2}(:\d{2})?$/.test(date);

      if (isTimeOnly && (format === 'time' || format === 'time-seconds')) {
          parsedDate = moment.utc(date, format === 'time' ? 'HH:mm' : 'HH:mm:ss');
      }

      return timezone ? parsedDate.tz(timezone).format(dateFormat) : parsedDate.format(dateFormat);
    }

    function formatDateTime(date) {
      if (!date) return null;

      var format = 'date-time';
      return formatDate(date, format);
    }

    function formatDateTimeSeconds(date) {
      if (!date) return null;

      var format = 'date-time-seconds';
      return formatDate(date, format);
    }

    function pickFormat(format) {
      return dateFormats[language][format] || dateFormats[language]['date'];
    }

    function pickAltFormat(format) {
      return altFormats[language][format] || altFormats[language]['date'];
    }

    function formatTime(hours, minutes, addZero) {
      if (addZero) {
        hours = '0' + hours;
      }

      return hours + ':' + minutes;
    }

    function convertTimeToShow(time) {
      if (!time) return null;

      var hours = splitTime(time).hours;
      var minutes = splitTime(time).minutes;

      if (parseInt(hours) > 12) {
        hours = String(parseInt(hours) - 12);
      }

      time = formatTime(hours, minutes, hours < 10);

      if (parseInt(hours) === 0) {
        time = '12:' + minutes;
      }

      return time;
    }

    function convertTimeToSave(time, timeFormat) {
      if (!time) return null;

      var hours = splitTime(time).hours;
      var minutes = splitTime(time).minutes;
      timeFormat = timeFormat.toLowerCase();

      if (timeFormat === 'pm') {
        if (parseInt(hours) !== 12) {
          hours = String(parseInt(hours) + 12);
        }
      } else if (parseInt(hours) === 12) {
        hours = '00';
        return formatTime(hours, minutes, false);
      }
      time = parseInt(time[0]) === 12 ? '00:' + time[1] : time[0] + ':' + time[1];

      return formatTime(hours, minutes, hours < 10);
    }

    function splitTime(time) {
      var parts = time.split(':');
      return {
        hours: parseInt(parts[0]),
        minutes: parts[1],
      };
    }

    return {
      formatDate: formatDate,
      formatDateTime: formatDateTime,
      pickFormat: pickFormat,
      pickAltFormat: pickAltFormat,
      convertTimeToSave: convertTimeToSave,
      convertTimeToShow: convertTimeToShow,
      formatDateTimeSeconds: formatDateTimeSeconds,
      splitTime: splitTime
    };
  }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('TasksStatusHelper', TasksStatusHelper);

    /** @ngInject */
    function TasksStatusHelper(_, $translate) {

        var items = [
            {
                description: $translate.instant("CORE.TASKS_STATUS.PENDING"),
                propertyDescription: 'description',
                name: 'pending',
                value: '-1',
                icon: 'icon-calendar-clock',
                color: '#3D99E9',
                colorClass: 'activity-scheduled-color',
                hasStartTime: false,
                hasCompletedTime: false
            },
            {
                description: $translate.instant("CORE.TASKS_STATUS.SCHEDULED"),
                propertyDescription: 'description',
                name: 'scheduled',
                value: '0',
                icon: 'icon-clock',
                color: '#105BFB',
                colorClass: 'activity-scheduled-color',
                hasStartTime: false,
                hasCompletedTime: false
            },
            {
                description: $translate.instant("CORE.TASKS_STATUS.ON_ROUTE"),
                propertyDescription: 'onRoute',
                icon: 'icon-truck',
                name: 'on-route',
                value: '5',
                color: '#617D8A',
                colorClass: 'activity-onroute-color',
                hasStartTime: false,
                hasCompletedTime: false
            },
            {
                description: $translate.instant("CORE.TASKS_STATUS.IN_PROGRESS"),
                name: 'in-progress',
                value: '1',
                icon: 'icon-map-marker',
                color: '#E4771F',
                colorClass: 'activity-inprogress-color',
                hasStartTime: true,
                hasCompletedTime: false
            },
            {
                description: $translate.instant("CORE.TASKS_STATUS.COMPLETED"),
                propertyDescription: 'doneDescription',
                icon: 'icon-check',
                name: 'done',
                value: '2',
                color: '#24B787',
                colorClass: 'activity-done-color',
                hasStartTime: true,
                hasCompletedTime: true
            },
            {
                description: $translate.instant("CORE.TASKS_STATUS.CANCELED"),
                propertyDescription: 'canceledDescription',
                icon: 'icon-close',
                name: 'canceled',
                value: '3',
                color: '#C25AB5',
                colorClass: 'activity-canceled-color',
                hasStartTime: true,
                hasCompletedTime: true
            },
            {
                description: $translate.instant("CORE.TASKS_STATUS.PREVENTED"),
                propertyDescription: 'problemDescription',
                icon: 'icon-alert',
                name: 'reported',
                value: '4',
                color: '#F85457',
                colorClass: 'activity-problem-color',
                hasStartTime: true,
                hasCompletedTime: true
            }
        ];

        return {
            getByName: function (name) {
                var item = _.find(items, function (item) {
                    return item.name == String(('' + name)).trim();
                });
                return item;
            },
            getByIndex: function (index) {
                var item = _.find(items, function (item) {
                    return item.value == index;
                });
                return item;
            },
            getAll: function () {
                return angular.copy(items);
            }
        };
    }

})();


(function () {
    'use strict';

    angular
      .module('app.core')
      .factory('taskService', taskService);

    /** @ngInject */
    function taskService(_) {
        return {
            sortTasksByScheduling: sortTasksByScheduling
        };

        function sortTasksByScheduling(tasks) {
            tasks = _(tasks).chain().sortBy(function (task) {
                return task.scheduling.time;
            }).sortBy(function (task) {
                return task.scheduling.date;
            }).sortBy(function (task) {
                return task.archived;
            }).value();

            return tasks;
        }
    }
  })();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('TasksEstimation', TasksEstimation);

  /** @ngInject */
  function TasksEstimation(_, moment, DateDiffer, DateConversionHandler, AirDistance) {
    return {
      estimateTasks: estimateTasks
    };

    function estimateTasks(employeeTasks, options) {
      var estimations = [];
      var tasksGroupedByScheduledDate = _.groupBy(employeeTasks, 'employee.id');

      for (var date in tasksGroupedByScheduledDate) {
        if (!date) { continue; }
        if (!tasksGroupedByScheduledDate.hasOwnProperty(date)) { continue; }

        var tasksFromDate = tasksGroupedByScheduledDate[date];

        var tasksWithEmployee = _.filter(tasksFromDate, function (task) {
          return task.employee && task.employee.id;
        });

        var tasksGroupedByEmployeeId = _.groupBy(tasksWithEmployee, 'employee.id');

        for (var employeeId in tasksGroupedByEmployeeId) {
          if (!tasksGroupedByEmployeeId.hasOwnProperty(employeeId)) { continue; }

          var employeeTasks = tasksGroupedByEmployeeId[employeeId];

          if (!employeeTasks || !employeeTasks.length) { continue; }

          var unarchivedEmployeeTasks = _.filter(employeeTasks, function (employeeTask) {
            return !employeeTask.archived;
          });

          if (!unarchivedEmployeeTasks || !unarchivedEmployeeTasks.length) { continue; }

          var sortedTasks = _sortTasks(unarchivedEmployeeTasks);
          _estimateEmployeeTasks(sortedTasks, {
            timezone: options.timezone,
            realTimeMonitoring: options.realTimeMonitoring,
            includeScheduledTime: true
          });

          sortedTasks.forEach(function (employeeTask) {
            estimations.push(employeeTask.scheduling.estimation);
          });
        }
      }

      return estimations;
    }

    function _sortTasks(tasks) {
      var startedTasks = [];
      var notStartedTasks = [];

      for (var i = 0; i < tasks.length; i++) {
        if (tasks[i].startedAt) {
          startedTasks.push(tasks[i]);
        } else {
          notStartedTasks.push(tasks[i]);
        }
      }

      var sortedStartedTasks = _sortStartedTasks(startedTasks);
      var sortedNotStartedTasks = _sortNotStartedTasks(notStartedTasks);

      return sortedStartedTasks.concat(sortedNotStartedTasks);
    }

    function _sortStartedTasks(tasks) {
      return tasks.sort(function (a, b) {
        var aStartedAtTime = new Date(a.startedAt).getTime();
        var bStartedAtTime = new Date(b.startedAt).getTime();

        return aStartedAtTime - bStartedAtTime;
      });
    }

    function _sortNotStartedTasks(tasks) {
      return tasks.sort(
        firstBy(function (a, b) { return a.position - b.position; })
          .thenBy(function (a, b) {
            var aCretedAtTime = new Date(a.metadata.createdAt).getTime();
            var bCretedAtTime = new Date(b.metadata.createdAt).getTime();

            return aCretedAtTime - bCretedAtTime;
          })
      );
    }

    function _calculateAirDistanceRouteCost(tasks, index, employee) {
      var routeCost;
      if (index === 0) {
        routeCost = AirDistance.calculateMinutes({ from: employee.address.coords, to: tasks[index].coords });
        return routeCost;
      } else {
        var previousTask = tasks[index - 1];
        routeCost = AirDistance.calculateMinutes({ from: previousTask.coords, to: tasks[index].coords });
        return routeCost;
      }
    }

    function _estimateEmployeeTasks(employeeTasks, options) {
      var employeeEstimations = [];
      var employee = employeeTasks[0].employee;
      var scheduledDate = employeeTasks[0].scheduling.date;

      var startedDateAndTime = employeeTasks[0].startedAt;
      var dateToEstimateStartWorking = scheduledDate;
      if (startedDateAndTime) {
        var startedDate = startedDateAndTime.split('T')[0];
        dateToEstimateStartWorking = startedDate;
      }
      var startWorkingAt = DateDiffer.createDate(dateToEstimateStartWorking, employee.workSchedule.start, options.timezone);
      var refDate = DateConversionHandler.toUtc(startWorkingAt);
      var utcNow = moment.utc();

      var realTimeMonitoringOn = options.realTimeMonitoring && DateDiffer.isToday(scheduledDate, utcNow);

      for (var index = 0; index < employeeTasks.length; index++) {
        var minutesCorrection;
        var task = employeeTasks[index];
        var employeeTaskEstimation = {
          id: task.id
        };

        var routeCost = _calculateAirDistanceRouteCost(employeeTasks, index, employee);

        employeeTaskEstimation.routeCost = routeCost;
        employeeTaskEstimation.startRoute = refDate.format();

        refDate.add(routeCost, 'm');

        if (task.startedAt) {
          minutesCorrection = moment(task.startedAt).diff(refDate, 'minutes');
          refDate.add(minutesCorrection, 'm');
        } else if (options.includeScheduledTime && task.scheduling.type === 'scheduled-date-and-time') {
          var routeRefCorrection;
          var scheduledAt = DateDiffer.createDate(task.scheduling.date, task.scheduling.time, options.timezone);

          scheduledAt = DateConversionHandler.toUtc(scheduledAt);

          if (utcNow.isAfter(scheduledAt) && realTimeMonitoringOn) {
            minutesCorrection = utcNow.diff(refDate, 'minutes');
            refDate.add(minutesCorrection, 'm');
            routeRefCorrection = refDate.clone();
            routeRefCorrection.add((routeCost * -1), 'm');
            employeeTaskEstimation.startRoute = routeRefCorrection.format();
          } else {
            minutesCorrection = scheduledAt.diff(refDate, 'minutes');
            refDate.add(minutesCorrection, 'm');
            routeRefCorrection = refDate.clone();
            routeRefCorrection.add((routeCost * -1), 'm');
            employeeTaskEstimation.startRoute = routeRefCorrection.format();
          }
        } else if (utcNow.isAfter(refDate) && realTimeMonitoringOn) {
          minutesCorrection = utcNow.diff(refDate, 'minutes');
          refDate.add(minutesCorrection, 'm');
        }

        employeeTaskEstimation.startTask = refDate.format();
        refDate.add(task.duration, 'm');

        if (task.completedAt) {
          employeeTaskEstimation.completeTask = task.startedAt;
          minutesCorrection = moment(task.completedAt).diff(refDate, 'minutes');
          refDate.add(minutesCorrection, 'm');
        } else if (realTimeMonitoringOn && utcNow.isAfter(refDate)) {
          minutesCorrection = utcNow.diff(refDate, 'minutes');
          refDate.add(minutesCorrection, 'm');
        }

        employeeTaskEstimation.completeTask = refDate.format();

        // TODO: rever essa lógica
        var breakCost = task.scheduling.estimation != null ? task.scheduling.estimation.breakCost : undefined;
        if (breakCost) {
          employeeTaskEstimation.startBreak = refDate.format();
          refDate.add(breakCost, 'm');
          employeeTaskEstimation.completeBreak = refDate.format();
        }

        employeeTaskEstimation.priority = employeeEstimations.length;
        task.scheduling.estimation = employeeTaskEstimation;
        employeeEstimations.push(employeeTaskEstimation);
      }

      return employeeEstimations;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('StartUsingField', StartUsingField);

  /** @ngInject */
  function StartUsingField($localStorage, usersApi, authenticatedUser, FcModalService, $translate, usersCacheService, _) {

    return {
      start: start,
    };

    function start() {
      var usersCached = usersCacheService.getUsers();
      var startVideoConfig = _getStartVideoConfig();
      if (!usersCached) {
        usersApi.get(authenticatedUser.profile.id).then(function (user) {
          _shouldDisplayTheVideo(user, startVideoConfig);
        });
        return;
      }
      var user = _findUserById(usersCached, authenticatedUser);
      _shouldDisplayTheVideo(user, startVideoConfig);
    }

    function _shouldDisplayTheVideo(user, startVideoConfig) {
      var loginCount = user.loginCount;
      if (loginCount < 2 && !startVideoConfig) {
        _openVideoTutorial();
        _setStartVideoConfig(false);
      }
    }

    function _getStartVideoConfig() {
      return $localStorage.get("startVideoTutorial");
    }

    function _setStartVideoConfig(shouldDisplay) {
      $localStorage.set("startVideoTutorial", shouldDisplay);
    }

    function _openVideoTutorial() {
      FcModalService.open(null, {
        title: $translate.instant("CORE.WELCOME"),
        templateUrl: 'app/core/tutorial/fc-tutorial-dialog.html',
        closeButtonIconPath: 'assets/icons/icon-close.svg',
        titleIconPath: 'assets/icons/rocket.svg',
        rightButtonText: $translate.instant("CORE.WELCOME_CLOSE_DIALOG"),
        handleClose: function () {
          var element = document.querySelector('.fc-fixed-tooltip--hidden');
          if (element) {
            element.classList.remove('fc-fixed-tooltip--hidden');
          }
        },
        large: true
      });
    }

    function _findUserById(users, authenticatedUser) {
      var user = _.find(users, function (user) {
        return String(user.id) === String(authenticatedUser.profile.id);
      });
      return user;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('ShortcutsService', ShortcutsService);

  function ShortcutsService($localStorage, $log, _, shortcutsData, $translate) {

    var localStorageKey = 'shortcuts';

    var possibleShortcuts = shortcutsData;

    return {
      possibleShortcuts: possibleShortcuts,
      getShortcuts: getShortcuts,
      setShortcuts: setShortcuts,
      validateShortcuts: validateShortcuts,
      getDefaultShortcuts: getDefaultShortcuts
    };

    function getShortcuts() {

      var shortcuts = $localStorage.getObject(localStorageKey);

      if (validateShortcuts(shortcuts)) {
        return fixShortcuts(shortcuts);
      } else {
        return null;
      }
    }

    function setShortcuts(shortcuts) {
      if(validateShortcuts(shortcuts)) {
        $localStorage.setObject(localStorageKey, fixShortcuts(shortcuts));
      } else {
        $log.error('shortcuts.service error: trying to set a invalid array of shortcuts');
      }
    }

    function validateShortcuts(shortcutsToValidate) {

      var isValid = true;

      if (_.isArray(shortcutsToValidate)) {
        if(shortcutsToValidate.length) {

          for(var index = 0; index < shortcutsToValidate.length; index++) {

            var shortcut = shortcutsToValidate[index];

            if (
              (_.isString(shortcut.title) && shortcut.title.length) &&
              (_.isString(shortcut.id) && shortcut.id.length) &&
              (_.isString(shortcut.icon) && shortcut.icon.length) &&
              (_.isString(shortcut.url) && shortcut.url.length)
            ) {

              var shorcutExists = false;

              var possibleShortcutsArray = Object.keys(possibleShortcuts).map(function (key) {
                return possibleShortcuts[key];
              });

              possibleShortcutsArray.forEach(function (possibleShortcut) {
                if(shortcut.id === possibleShortcut.id) {
                  shorcutExists = true;
                }
              });

              if(!shorcutExists) {
                isValid = false;
              }

            } else {
              isValid = false;
            }
          }

        }
      } else {
        isValid = false;
      }

      return isValid;
    }

    function getDefaultShortcuts() {
      return fixShortcuts([
        possibleShortcuts.shortcutDashboard,
        possibleShortcuts.shortcutTimeline,
        possibleShortcuts.shortcutMap,
        possibleShortcuts.shortcutList
      ]);
    }

    function fixShortcuts(shortcuts) {

      var fixedShortcuts = shortcuts.map(function (shortcut) {
        shortcut.title = $translate.instant('CORE.SHORTCUTS.' + shortcut.id);
        shortcut.icon = iconMapper(shortcut.id);
        if(shortcut.$$hashKey) shortcut.$$hashKey = undefined;
        return shortcut;
      });

      return fixedShortcuts;
    }

    function iconMapper(shortcutId) {
      switch (shortcutId) {
        case 'TASKS': return 'icon-clipboard-text';
        case 'DAY_TASKS': return 'icon-view-list';
        case 'TASKS_TYPES': return 'icon-clipboard-outline';
        case 'TIMELINE': return 'icon-playlist-minus';
        case 'MAP': return 'icon-map';
        case 'CALENDAR': return 'icon-calendar-today';
        case 'RECURRENCES': return 'icon-alarm-multiple';
        case 'CUSTOMERS': return 'icon-city';
        case 'EMPLOYEES': return 'icon-account-outline';
        case 'ABSENCES': return 'icon-account-remove';
        case 'ROUTE_HISTORY': return 'icon-routes';
        case 'FORMS': return 'icon-file-document';
        case 'DASHBOARD': return 'icon-chart-bar';
        case 'RATING': return 'icon-star';
        case 'EMPLOYEE_REPORT': return 'icon-account-multiple';
        case 'FORMS_REPORT': return 'icon-file-multiple';
        case 'TASKS_REPORT': return 'icon-chart-arc';
        case 'HEAT_MAP': return 'icon-weather-sunny';
        case 'TICKETS': return 'icon-email-open';
        case 'EQUIPMENT': return 'icon-server';
        case 'EQUIPMENT_TYPES': return 'icon-server-plus';
        case 'MATERIALS': return 'icon-wallet-membership';
      }
    }

  }
})();
(function () {
  'use strict';

  angular.module('app.core')
    .factory('shortcutsData', shortcutsData);

  /** @ngInject */
  function shortcutsData(EnvironmentConfig, $translate) {
    return {
      shortcutActivities: {
        title: $translate.instant("CORE.SHORTCUTS.TASKS"),
        id: 'TASKS',
        icon: 'icon-clipboard-text',
        url: EnvironmentConfig.mordorUrl + 'atividades'
      },
      shortcutList: {
        title: $translate.instant("CORE.SHORTCUTS.DAY_TASKS"),
        id: 'DAY_TASKS',
        icon: 'icon-view-list',
        url: EnvironmentConfig.mordorUrl + 'painel-de-controle/listagem'
      },
      shortcutTaskTypes: {
        title: $translate.instant("CORE.SHORTCUTS.TASKS_TYPES"),
        id: 'TASKS_TYPES',
        icon: 'icon-clipboard-outline',
        url: EnvironmentConfig.mordorUrl + 'tipos-de-os'
      },
      shortcutTimeline: {
        title: $translate.instant("CORE.SHORTCUTS.TIMELINE"),
        id: 'TIMELINE',
        icon: 'icon-playlist-minus',
        url: EnvironmentConfig.mordorUrl + 'painel-de-controle/linha-do-tempo'
      },
      shortcutMap: {
        title: $translate.instant("CORE.SHORTCUTS.MAP"),
        id: 'MAP',
        icon: 'icon-map',
        url: EnvironmentConfig.mordorUrl + 'painel-de-controle/mapa'
      },
      shortcutCalendar: {
        title: $translate.instant("CORE.SHORTCUTS.CALENDAR"),
        id: 'CALENDAR',
        icon: 'icon-calendar-today',
        url: EnvironmentConfig.mordorUrl + 'calendario-de-atividades'
      },
      shortcutRecurrences: {
        title: $translate.instant("CORE.SHORTCUTS.RECURRENCES"),
        id: 'RECURRENCES',
        icon: 'icon-alarm-multiple',
        url: EnvironmentConfig.mordorUrl + 'atividades-recorrentes'
      },
      shortcutCustomers: {
        title: $translate.instant("CORE.SHORTCUTS.CUSTOMERS"),
        id: 'CUSTOMERS',
        icon: 'icon-city',
        url: EnvironmentConfig.mordorUrl + 'clientes'
      },
      shortcutEmployees: {
        title: $translate.instant("CORE.SHORTCUTS.EMPLOYEES"),
        id: 'EMPLOYEES',
        icon: 'icon-account-outline',
        url: EnvironmentConfig.mordorUrl + 'colaboradores'
      },
      shortcutAbsences: {
        title: $translate.instant("CORE.SHORTCUTS.ABSENCES"),
        id: 'ABSENCES',
        icon: 'icon-account-remove',
        url: EnvironmentConfig.mordorUrl + 'ausencias'
      },
      shortcutRouteHistory: {
        title: $translate.instant("CORE.SHORTCUTS.ROUTE_HISTORY"),
        id: 'ROUTE_HISTORY',
        icon: 'icon-routes',
        url: EnvironmentConfig.mordorUrl + 'historico-de-rotas'
      },
      shortcutDashboard:  {
        title: $translate.instant("CORE.SHORTCUTS.DASHBOARD"),
        id: 'DASHBOARD',
        icon: 'icon-chart-bar',
        url: EnvironmentConfig.dashboardUrl + 'dashboard'
      },
      shortcutRating: {
        title: $translate.instant("CORE.SHORTCUTS.RATING"),
        id: 'RATING',
        icon: 'icon-star',
        url: EnvironmentConfig.dashboardUrl + 'avaliacoes'
      },
      shortcutEmployeesReport: {
        title: $translate.instant("CORE.SHORTCUTS.EMPLOYEE_REPORT"),
        id: 'EMPLOYEE_REPORT',
        icon: 'icon-account-multiple',
        url: EnvironmentConfig.dashboardUrl + 'colaboradores'
      },
      shortcutFormsReport: {
        title: $translate.instant("CORE.SHORTCUTS.FORMS_REPORT"),
        id: 'FORMS_REPORT',
        icon: 'icon-file-multiple',
        url: EnvironmentConfig.dashboardUrl + 'formularios'
      },
      shortcutTasksReport: {
        title: $translate.instant("CORE.SHORTCUTS.TASKS_REPORT"),
        id: 'TASKS_REPORT',
        icon: 'icon-chart-arc',
        url: EnvironmentConfig.dashboardUrl + 'servicos'
      },
      shortcutHeatMap: {
        title: $translate.instant("CORE.SHORTCUTS.HEAT_MAP"),
        id: 'HEAT_MAP',
        icon: 'icon-weather-sunny',
        url: EnvironmentConfig.dashboardUrl + 'mapa-calor'
      },
      shortcutTickets: {
        title: $translate.instant("CORE.SHORTCUTS.TICKETS"),
        id: 'TICKETS',
        icon: 'icon-email-open',
        url: EnvironmentConfig.mordorUrl + 'chamados-e-oportunidades'
      },
      shortcutEquipments: {
        title: $translate.instant("CORE.SHORTCUTS.EQUIPMENT"),
        id: 'EQUIPMENT',
        icon: 'icon-server',
        url: EnvironmentConfig.mordorUrl + 'equipamentos'
      },
      shortcutEquipmentsType: {
        title: $translate.instant("CORE.SHORTCUTS.EQUIPMENT_TYPES"),
        id: 'EQUIPMENT_TYPES',
        icon: 'icon-server-plus',
        url: EnvironmentConfig.mordorUrl + 'tipos-de-equipamento'
      },
      shortcutExports: {
        title: $translate.instant("CORE.SHORTCUTS.EXPORTS"),
        id: 'EXPORTS',
        icon: 'icon-export',
        url: EnvironmentConfig.mordorUrl + 'exportacoes'
      },
      shortcutMaterials: {
        title: $translate.instant("CORE.SHORTCUTS.MATERIALS"),
        id: 'MATERIALS',
        icon: 'icon-wallet-membership',
        url: EnvironmentConfig.mordorUrl + 'materiais'
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('ProductsMeasuresDialogOptions', ProductsMeasuresOptions);

  /** @ngInject */
  function ProductsMeasuresOptions(_, $translate) {
    var measures = [
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.UNITY'), value: 'unity' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.CENTIMETER'), value: 'centimeter' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.METER'), value: 'meter' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.LITER'), value: 'liter' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.MILLILITER'), value: 'milliliter' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.KILOGRAM'), value: 'kilogram' },
      { translate: $translate.instant('PRODUCTS.MODEL.MEASURES.GRAM'), value: 'gram' }
    ];

    return {
      measures: measures
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('permissionsService', permissionsService);

  function permissionsService($localStorage) {
    return {
      hasPermission: hasPermission,
      hasPermissionFromCategory: hasPermissionFromCategory,
      hasAccountPermission: hasAccountPermission
    };

    function hasPermission(account, profile, permissionName) {
      var hasPermission = _.chain(profile.permissions).map('name').includes(permissionName).value();
      var hasPermissionFromAccount = hasAccountPermission(account, permissionName);

      return hasPermission && hasPermissionFromAccount;
    }

    function hasPermissionFromCategory(account, profile, category) {
      return _.chain(profile.permissions)
        .filter(function (permission) {
          return permission.category === category;
        })
        .some(function (permission) {
          return hasAccountPermission(account, permission.name);
        }).value();
    }

    function hasAccountPermission(account, permissionName) {
      var configuration = account.configuration;
      var accountPlan = account.plan.name;

      var accountPermissions = {
        'tasks_plans_menu': !!(configuration.moduleTasksPlansEnabled),
        'tickets_list_menu': !!(
          configuration.toolbarTicketsMenuItemVisible ||
          configuration.moduleCustomersAreaEnabled
        ),
        'equipments_list_menu': !!(configuration.moduleEquipmentManagementEnabled || configuration.isCorporateCompany),
        'settings-account_company_menu': !!(configuration.toolbarConfigurationMenuItemVisible),
        'settings-account_signature_menu': !!(
          configuration.toolbarConfigurationMenuItemVisible &&
          (accountPlan === 'pro' || accountPlan === 'test')
        ),
        'settings-account_devices_menu': !!(configuration.toolbarConfigurationMenuItemVisible),
        'settings-registers_equipments-type_menu': !!(configuration.moduleEquipmentManagementEnabled),
        'settings-registers_materials_menu': !!(configuration.moduleMaterialManagementEnabled),
        'settings-system': !!(configuration.toolbarConfigurationMenuItemVisible),
        'settings-system_modules_menu': !!(accountPlan !== 'trial'),
        'settings-resources_equipments-qrcode-generator': !!(accountPlan === 'pro' || accountPlan === 'test' || accountPlan === 'corporate'),
        'settings-integrations_imports_menu': !!(
          configuration.toolbarConfigurationMenuItemVisible &&
          (accountPlan === 'pro' || accountPlan === 'test')
        ),
        'settings-integrations-dev_api_menu': !!(
          configuration.toolbarConfigurationMenuItemVisible &&
          (accountPlan === 'pro' || accountPlan === 'test' || accountPlan === 'corporate')
        ),
        'settings-integrations-dev_webhooks_menu': !!(
          configuration.toolbarConfigurationMenuItemVisible &&
          (accountPlan === 'pro' || accountPlan === 'test' || accountPlan === 'corporate')
        ),
        'vehicles_usage_list_menu': !!(
          ((!configuration.moduleVehiclesEnabled && $localStorage.get('hideVehiclesFakeDoor') !== 'true') || configuration.moduleVehiclesEnabled) &&
          (accountPlan === 'pro' || accountPlan === 'test' || accountPlan === 'corporate' || accountPlan === 'bradesco' || accountPlan === 'trial')
        ),
        'settings-registers_vehicles': !!(
          configuration.moduleVehiclesEnabled &&
          (accountPlan === 'pro' || accountPlan === 'test' || accountPlan === 'corporate' || accountPlan === 'bradesco' || accountPlan === 'trial')
        ),
        'settings-registers-plans-types': !!(configuration.moduleTasksPlansEnabled),
        'settings-registers_deadlines_menu': !!(configuration.moduleOrdersDeadlineEnabled || configuration.isCorporateCompany),
        'storages_list_menu': !!configuration.moduleStorageControlEnabled,
        'storages-movements_list_menu': !!configuration.moduleStorageControlEnabled,
        'stock_list_menu': !!configuration.moduleStorageControlEnabled,
      };

      if (accountPermissions[permissionName] !== undefined) {
        return accountPermissions[permissionName];
      }

      return true;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('locationsService', locationsService);

  function locationsService(_, $filter) {
    var countryCodes = [
      {
        countryCode: '55',
        maxLength: 11,
        format: function (phone) {
          return $filter('brPhoneNumber')(phone);
        }
      },
      {
        countryCode: '351',
        maxLength: 9,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{2})(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '244',
        maxLength: 9,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{3})(\d{3}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '52',
        maxLength: 10,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{2})(\d{4})(\d{4}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '1',
        maxLength: 11,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4})(\d{4}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '57',
        maxLength: 12,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '54',
        maxLength: 13,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{2})(\d{4})(\d{4}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '51',
        maxLength: 9,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{3})(\d{3}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '58',
        maxLength: 10,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '56',
        maxLength: 10,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4})(\d{3}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '593',
        maxLength: 8,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{1})(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '53',
        maxLength: 10,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4})(\d{3}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '591',
        maxLength: 8,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{1})(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '1-809',
        maxLength: 10,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '1-829',
        maxLength: 10,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '1-849',
        maxLength: 10,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '504',
        maxLength: 8,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '595',
        maxLength: 9,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{6}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '505',
        maxLength: 8,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{4})(\d{4}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '503',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '506',
        maxLength: 8,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{4})(\d{4}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '1-787',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{4})(\d{3}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '1-939',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{4})(\d{3}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '507',
        maxLength: 8,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4})(\d{1}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '598',
        maxLength: 10,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4})(\d{3}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '502',
        maxLength: 10,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4})(\d{3}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '1-876',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2') : '';
         }
      },
      {
        countryCode: '1-868',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '501',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '1-242',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '1-246',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '1-758',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '1-784',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '1-473',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '1-268',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
        }
      },
      {
        countryCode: '1-767',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
         }
      },
      {
        countryCode: '1-869',
        maxLength: 7,
        format: function (phone) {
          return phone ? phone.replace(/^(\d{3})(\d{4}).*/, '$1 $2 $3') : '';
         }
      }
    ];

    function findCountryCodeByNumber(countryCode) {
      var requiredCountryCode = _.find(countryCodes, function (item) {
        return item.countryCode === countryCode;
      });

      return requiredCountryCode || null;
    }

    function mapPhoneCollectionToCountryCodeString(phones) {
      var phonesWithCountryCodeString = phones.map(function (phone) {
        var phoneCountryCode = phone.countryCode && phone.countryCode.countryCode;
        if (phoneCountryCode) {
          phone.countryCode = phoneCountryCode;
        }
        return phone;
      });

      return phonesWithCountryCodeString;
    }

    function formatPhoneByCountryCode(countryCode, phone) {
      if (!countryCode || !phone) {
        return null;
      }

      var requiredCountryCode = _.find(countryCodes, function (item) {
        return item.countryCode === countryCode;
      });

      if (!requiredCountryCode) {
        return null;
      }

      return requiredCountryCode.format(phone);
    }

    function getMaxLengthByCountryCode(countryCode) {
      if (!countryCode) {
        return null;
      }

      var requiredCountryCode = _.find(countryCodes, function (item) {
        return item.countryCode === countryCode;
      });

      if (!requiredCountryCode) {
        return null;
      }

      return requiredCountryCode.maxLength;
    }

    function mapLocationContacts(contacts) {
      var phones = (contacts && contacts.phones) || [];
      var emails = (contacts && contacts.emails) || [];

      var mappedPhones = phones.map(function (phone) {
        return {
          id: phone.id,
          countryCode: phone.countryCode,
          number: phone.number,
          name: phone.name,
          primary: phone.primary,
          type: phone.type
        };
      });

      var mappedEmails = emails.map(function (email) {
        return {
          id: email.id,
          address: email.address,
          name: email.name,
          primary: email.primary,
          type: email.type
        };
      });

      return {
        phones: mappedPhones,
        emails: mappedEmails
      };
    }

    return {
      countryCodes: countryCodes,
      findCountryCodeByNumber: findCountryCodeByNumber,
      mapPhoneCollectionToCountryCodeString: mapPhoneCollectionToCountryCodeString,
      formatPhoneByCountryCode: formatPhoneByCountryCode,
      getMaxLengthByCountryCode: getMaxLengthByCountryCode,
      mapLocationContacts: mapLocationContacts
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('formsService', formsService);

  /** @ngInject */
  function formsService(_) {
    return {
      getScoredOptions: getScoredOptions
    };

    function getScoredOptions(form) {
      var questions = form.questions.filter(function (question) {
        var isDropdownOrMultipleChoice = (question.type === 'dropdown' || question.type === 'multiple-choice');
        var allQuestionsHaveScore = question.options.length && !_.every(question.options, function (option) { return option.score === null; });
        return isDropdownOrMultipleChoice && allQuestionsHaveScore;
      });
      if (questions.length) {
        questions = questions
          .map(function (question) {
            var answeredOption = _.find(question.options, function (option) { return option.value === question.answer; });
            if (answeredOption) return { title: question.title, answer: question.answer, score: answeredOption.score };
          })
          .filter(function (question) { return question && question.answer && question.score !== undefined; });
        var scores = _.map(questions, 'score');
        form.score = {
          list: questions,
          total: _.sum(scores)
        };
      } else {
        form.score = null;
      }
      return form;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('fieldControlGlobalEventsService', fieldControlGlobalEventsService);

  /** @ngInject */
  function fieldControlGlobalEventsService(
    OrderDialog,
    QuotationsDialog,
    LocationsDialog,
    ProductsDialog,
    ProductsServicesDialog,
    customersApi,
    customersApiGraphQL,
    accountFeatureFlagsApiGraphQL,
    accountsApi,
    ordersApi,
    $rootScope,
    $mdDialog,
    $document,
    $q,
    accountCache,
    authenticatedUser,
    DeadlineContractsDialog,
    CheckEditPermission,
    TasksExportDialog,
    FcModalService,
    $translate,
    EquipmentsDialog,
    RouteOptimizerDialog,
    tasksApi
  ) {
    return {
      openCreateCustomerDialog: openCreateCustomerDialog,
      openEditCustomerDialog: openEditCustomerDialog,
      openCreateLocationDialog: openCreateLocationDialog,
      openLocationDialog: openLocationDialog,
      openEditOrderDialog: openEditOrderDialog,
      openCreateQuotationFromOrderDialog: openCreateQuotationFromOrderDialog,
      openEditQuotationDialog: openEditQuotationDialog,
      openCreateQuotationDialogFromTicket: openCreateQuotationDialogFromTicket,
      openDeadlineContractDialog: openDeadlineContractDialog,
      openReturnOrderProductsDialog: openReturnOrderProductsDialog,
      openLinkStorageMovementDialog: openLinkStorageMovementDialog,
      openEditProductModal: openEditProductModal,
      openEditServiceModal: openEditServiceModal,
      openIntegrationDialog: openIntegrationDialog,
      openAnswerEquipmentForm: openAnswerEquipmentForm,
      openEquipmentDialog: openEquipmentDialog,
      openLegacyRouteOptimizer: openLegacyRouteOptimizer
    };

    function openCreateCustomerDialog(customer) {
      createCustomerWithPredefinedData(customer, function (reload, savedCustomer) {
        if (reload && savedCustomer) {
          document.dispatchEvent(
            new CustomEvent('CustomerCreated', {
              detail: {
                customer: savedCustomer,
                locationId: customer.primaryLocation ? customer.primaryLocation.id : null,
              },
            })
          );
        }
      });
    }

    function openEditCustomerDialog(data) {
      _loaderOn();

      var requests = {
        customer: customersApi.getOne(data.customerId, { include: 'labels,contacts' }),
        account: accountsApi.get(),
        customerAttachments: customersApiGraphQL.getCustomerAttachments(data.customerId),
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags(),
      };

      $q.all(requests)
        .then(function (result) {
          var customerAttachments = result.customerAttachments.filter(function (attachment) {
            return !attachment.archived;
          });

          _openCustomerDetailDialog(data, {
            Customer: result.customer,
            CustomerAttachments: customerAttachments,
            Account: result.account,
            FeatureFlags: result.featureFlags,
            IsOnTicket: false,
          });
        })
        .finally(_loaderOff);
    }

    function openCreateLocationDialog(params) {
      LocationsDialog.createLocation(null, params, function (reload) {
        if (reload && reload.locationId && params.customer) {
          document.dispatchEvent(
            new CustomEvent('LocationCreated', {
              detail: {
                customer: params.customer,
                locationId: reload.locationId,
              },
            })
          );
        }
      });
    }

    function openLocationDialog(data) {
      _loaderOn();

      var account = accountCache.getAccount();
      var hasEquipmentsPermission = authenticatedUser.hasPermission(account, 'equipments_list_menu');
      var hasEquipmentsModule =
        account && account.configuration && account.configuration.moduleEquipmentManagementEnabled;

      var requests = {
        account: accountsApi.get(),
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags(),
      };

      $q.all(requests)
        .then(function (result) {
          var locals = {
            Account: result.account,
            Location: data.location || null,
            Customer: data.customer || null,
            hasEquipmentsPermission: hasEquipmentsModule && hasEquipmentsPermission,
            IsOnTicket: false,
            FeatureFlags: result.featureFlags,
          };

          $mdDialog
            .show({
              controller: 'LocationsDialogController',
              controllerAs: 'vm',
              templateUrl: 'app/main/locations/dialogs/location-dialog.html',
              parent: data.target,
              targetEvent: null,
              multiple: true,
              clickOutsideToClose: true,
              locals: locals,
              closeTo: {
                top: 0,
                left: window.innerWidth,
                width: window.innerWidth,
                height: window.innerHeight / 1.8,
              },
            })
            .then(function (reload) {
              var locationId = (reload && reload.locationId) || (reload && reload.primaryLocationId);
              if (!locationId || !reload) {
                return;
              }

              document.dispatchEvent(
                new CustomEvent('LocationUpdated', {
                  detail: {
                    locationId: locationId,
                  },
                })
              );
            });
        })
        .finally(_loaderOff);
    }

    function openEditOrderDialog(orderId) {
      OrderDialog.editTask(null, { id: orderId });
    }

    function openCreateQuotationFromOrderDialog(data) {
      QuotationsDialog.createQuotationFromOrder(null, data.order, data.target, function (reload, quotation) {
        if (quotation && quotation.id) {
          document.dispatchEvent(new CustomEvent('QuotationCreated', { detail: { quotation: quotation } }));
        }
      });
    }

    function openEditQuotationDialog(data) {
      QuotationsDialog.editQuotation(null, data.quotationId, data.target, function (_, quotation) {
        if (quotation && quotation.id) {
          document.dispatchEvent(new CustomEvent('QuotationUpdated', { detail: { quotation: quotation } }));
        }
      });
    }

    function openCreateQuotationDialogFromTicket(ticket) {
      QuotationsDialog.createQuotationFromTicket(null, ticket);
    }

    function createCustomerWithPredefinedData(data, callback) {
      _loaderOn();

      var requests = {
        accounts: accountsApi.get(),
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags(),
      };

      $q.all(requests)
        .then(function (result) {
          _openCustomerDialog(
            data,
            {
              Customer: data.customerId || data.customer,
              CustomerAttachments: [],
              Account: result.accounts,
              FeatureFlags: result.featureFlags,
              IsOnTicket: true,
            },
            callback
          );
        })
        .finally(_loaderOff);
    }

    function openDeadlineContractDialog(data) {
      var deadlineContractId = data && data.deadlineContractId;
      var target = data && data.target;

      DeadlineContractsDialog.openDialog(null, deadlineContractId, target, function (result) {
        if (result) {
          document.dispatchEvent(
            new CustomEvent('DeadlineContractUpdated', {
              detail: {
                deadlineContractId: result.deadlineContractId,
              },
            })
          );
        }
      });
    }

    function openReturnOrderProductsDialog(data) {
      $mdDialog
        .show({
          controller: 'ReturnOrderProductsModalComponent',
          controllerAs: 'self',
          templateUrl: 'app/main/tasks/dialogs/return-order-products-dialog/return-order-products-dialog.html',
          parent: data.target,
          clickOutsideToClose: true,
          targetEvent: null,
          multiple: true,
          locals: {
            orderId: data.orderId,
            productId: data.productId,
          },
          closeTo: {
            top: 0,
            left: window.innerWidth,
            width: window.innerWidth,
            height: window.innerHeight / 1.8,
          },
        })
        .then(function (result) {
          if (!result) {
            return;
          }

          document.dispatchEvent(new CustomEvent('ReturnOrderProductsClose', { detail: result }));
        });
    }

    function openLinkStorageMovementDialog(data) {
      $mdDialog
        .show({
          controller: 'StorageMovementsModalComponent',
          controllerAs: 'self',
          templateUrl: 'app/main/tasks/dialogs/storage-movements-dialog/storage-movements-dialog.html',
          parent: data.target,
          clickOutsideToClose: true,
          targetEvent: null,
          multiple: true,
          locals: {
            order: data.order,
          },
          closeTo: {
            top: 0,
            left: window.innerWidth,
            width: window.innerWidth,
            height: window.innerHeight / 1.8,
          },
        })
        .then(function (result) {
          if (!result) {
            return;
          }

          document.dispatchEvent(new CustomEvent('LinkStorageMovementClose', { detail: result }));
        });
    }

    function openEditProductModal(data) {
      ProductsDialog.editProduct(data.target, { id: data.id }, function (reload, productService) {
        if (reload) {
          document.dispatchEvent(new CustomEvent('ProductUpdated'));
        }
      });
    }

    function openEditServiceModal(data) {
      ProductsServicesDialog.editProductService(data.target, { id: data.id }, function (reload, productService) {
        if (reload) {
          document.dispatchEvent(new CustomEvent('ServiceUpdated'));
        }
      });
    }

    function openIntegrationDialog(data) {
      if (!CheckEditPermission.hasPermission() && data.order && data.order.id) {
        return;
      }

      if (data.appName === 'Conta Azul') {
        $rootScope.loadingProgress = true;
        return TasksExportDialog.openExportTaskDialog(data);
      }

      FcModalService.open(data.$event, {
        title: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.ACCOUNT'),
        content: $translate.instant('TASKS.DIALOG.ACTIONS.SELECT_THE_ACCOUNT'),
        paddingSmall: true,
        hasOmieAccountSelector: true,
        rightContinueButton: true,
        rightButtonText: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'),
        leftButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
        handleRightButton: function (account) {
          $rootScope.loadingProgress = true;
          data.selectedAccount = account;
          TasksExportDialog.openExportTaskDialog(data);
        }
      });
    }

    function openAnswerEquipmentForm(data) {
      var requests = {
        account: accountsApi.get(),
        featureFlags: accountFeatureFlagsApiGraphQL.accountFeatureFlags(),
        order: ordersApi.get(data.orderId),
      };

      $q.all(requests)
        .then(function (result) {
          $mdDialog
            .show({
              controller: 'SearchEquipmentsFormsController',
              controllerAs: 'vm',
              templateUrl: 'app/main/tasks/dialogs/search-equipments-forms/search-equipments-forms.html',
              parent: data.target,
              targetEvent: null,
              multiple: true,
              clickOutsideToClose: true,
              closeTo: {
                top: 0,
                left: window.innerWidth,
                width: window.innerWidth,
                height: window.innerHeight / 1.8,
              },
              locals: {
                equipment: data.equipment,
                order: result.order,
                account: result.account,
                getEquipmentsFromOrder: function ()  {},
                searchEquipments: function () {},
                featureFlags: result.featureFlags,
                hasFeatureFlag: function _hasFeatureFlag(name) {
                  var hasFeature = result.featureFlags.find(function (featureFlag) {
                    return featureFlag.name === name;
                  });

                  if (!hasFeature) { return false; }

                  return hasFeature.active;
                }
              }
            }).then(function () {
              document.dispatchEvent(new CustomEvent('AnswerEquipmentFormsClose'));
            });
      });
    }

    function openEquipmentDialog(data) {
      EquipmentsDialog.editEquipments(data.target, data.equipmentId, data.selectedTab, function (reload) {
        if (reload) {
          document.dispatchEvent(new CustomEvent('EquipmentUpdated', { detail: { equipmentId: data.equipmentId } }));
        }
      });
    }

    function openLegacyRouteOptimizer(data) {
      var employees = angular.copy(data.employees);
      employees.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      RouteOptimizerDialog.startOptimizer(data.target, employees, function (optimizationResult) {
        if (optimizationResult) {
          optimizationResult.taskPatchPayload.forEach(function (task) {
            task.scheduling = {
              type: 'scheduled-date',
              time: null
            };
          });

          var currentPayload = optimizationResult.taskPatchPayload;
          if (vm.isPreventAccount) {
            var tasks = angular.copy(optimizationResult.taskPatchPayload);
            var initialDate = optimizationResult.initialDate;
            var selectedWeekDays = optimizationResult.selectedWeekDays;
            var splitByAmountPerDay = TasksDistribution.splitByAmountPerDay(tasks, optimizationResult.tasksPerDay);
            var updatedTasks = TasksDistribution.updateTasks(splitByAmountPerDay, selectedWeekDays, initialDate);
            var formattedTasks = TasksDistribution.extractTasks(updatedTasks);
            currentPayload = formattedTasks;
          }

          tasksApi.patchTasks(currentPayload).then(function () {
            ControlPanelData.loadData();
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.SUCCESS_MESSAGE'))
                .hideDelay(3000)
            );
          });
        }
      });
    }

    function _openCustomerDialog(data, locals, callback) {
      $mdDialog
        .show({
          controller: 'CustomerDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/customers/dialogs/customer-dialog.html',
          parent: data.target,
          targetEvent: null,
          multiple: true,
          clickOutsideToClose: true,
          locals: locals,
          closeTo: {
            top: 0,
            left: window.innerWidth,
            width: window.innerWidth,
            height: window.innerHeight / 1.8,
          },
        })
        .then(function (result) {
          if (!callback) {
            return;
          }

          callback(result.reload, result.savedCustomer);
        });
    }

    function _openCustomerDetailDialog(data, locals) {
      $mdDialog
        .show({
          controller: 'CustomerDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/customers/dialogs/customer-dialog.html',
          parent: data.target,
          targetEvent: null,
          multiple: true,
          clickOutsideToClose: true,
          locals: locals,
          closeTo: {
            top: 0,
            left: window.innerWidth,
            width: window.innerWidth,
            height: window.innerHeight / 1.8,
          },
        })
        .then(function (result) {
          if (!result.reload || !result.savedCustomer) {
            return;
          }

          document.dispatchEvent(
            new CustomEvent('CustomerUpdated', {
              detail: {
                customer: result.savedCustomer,
              },
            })
          );
        });
    }

    function _loaderOn() {
      document.dispatchEvent(new CustomEvent('showLoadingBar'));
    }

    function _loaderOff() {
      document.dispatchEvent(new CustomEvent('hideLoadingBar'));
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fieldcontrolGlobalEvents', fieldcontrolGlobalEvents);

  /** @ngInject */
  function fieldcontrolGlobalEvents() {
    return {
      restrict: 'E',
      templateUrl: 'app/core/services/fieldcontrol-global-events/fieldcontrol-global-events.html',
      controller: 'FieldControlGlobalEventsController as vm'
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('FieldControlGlobalEventsController', FieldControlGlobalEventsController);

  /** @ngInject */
  function FieldControlGlobalEventsController($scope, fieldControlGlobalEventsService) {
    var vm = this;

    vm.events = [
      { name: 'openCreateCustomerDialog', action: function (data) { fieldControlGlobalEventsService.openCreateCustomerDialog(data.detail); } },
      { name: 'openEditCustomerDialog', action: function (data) { fieldControlGlobalEventsService.openEditCustomerDialog(data.detail); } },
      { name: 'openCreateLocationDialog', action: function (data) { fieldControlGlobalEventsService.openCreateLocationDialog(data.detail); } },
      { name: 'openLocationDialog', action: function (data) { fieldControlGlobalEventsService.openLocationDialog(data.detail); } },
      { name: 'openOrderDialog', action: function () { fieldControlGlobalEventsService.openOrderDialog(); } },
      { name: 'openEditOrderDialog', action: function (data) { fieldControlGlobalEventsService.openEditOrderDialog(data.detail); } },
      { name: 'openCreateQuotationFromOrderDialog', action: function (data) { fieldControlGlobalEventsService.openCreateQuotationFromOrderDialog(data.detail); } },
      { name: 'openEditQuotationDialog', action: function (data) { fieldControlGlobalEventsService.openEditQuotationDialog(data.detail); } },
      { name: 'openCreateQuotationDialogFromTicket', action: function (data) { fieldControlGlobalEventsService.openCreateQuotationDialogFromTicket(data.detail); } },
      { name: 'openDeadlineContractDialog', action: function (data) { fieldControlGlobalEventsService.openDeadlineContractDialog(data.detail); } },
      { name: 'openReturnOrderProductsDialog', action: function (data) { fieldControlGlobalEventsService.openReturnOrderProductsDialog(data.detail); } },
      { name: 'openLinkStorageMovementDialog', action: function (data) { fieldControlGlobalEventsService.openLinkStorageMovementDialog(data.detail); } },
      { name: 'openEditProductModal', action: function (data) { fieldControlGlobalEventsService.openEditProductModal(data.detail); } },
      { name: 'openEditServiceModal', action: function (data) { fieldControlGlobalEventsService.openEditServiceModal(data.detail); } },
      { name: 'openIntegrationDialog', action: function (data) { fieldControlGlobalEventsService.openIntegrationDialog(data.detail); } },
      { name: 'openAnswerEquipmentForm', action: function (data) { fieldControlGlobalEventsService.openAnswerEquipmentForm(data.detail); } },
      { name: 'openEquipmentDialog', action: function (data) { fieldControlGlobalEventsService.openEquipmentDialog(data.detail); } },
      { name: 'openLegacyRouteOptimizer', action: function (data) { fieldControlGlobalEventsService.openLegacyRouteOptimizer(data.detail); } },
    ];

    _initialize();

    function _initialize() {
      vm.events.forEach(function (event) {
        event.action = event.action.bind(vm);
        document.addEventListener(event.name, event.action);
      });

      $scope.$on('$destroy', function () {
        vm.events.forEach(function (event) {
          document.removeEventListener(event.name, event.action);
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('employeeDocumentDuplicatedValidationService', employeeDocumentDuplicatedValidationService);

  /** @ngInject */
  function employeeDocumentDuplicatedValidationService(employeesApiGraphQL) {
    return {
      validate: validate
    };

    function validate(employee, input) {
      var hasDocumentNumber = employee.documentNumber && employee.documentNumber.trim();

      if (hasDocumentNumber) {
        return employeesApiGraphQL.search({
          where: {
            documentNumber: employee.documentNumber
          },
          take: 2
        }).then(function (res) {
          if (input.$error && input.$error.duplicated) {
            input.$setValidity('duplicated', true);
          }

          var items = res.items || res;

          if (!employee.id && items.length > 0) {
            return input.$setValidity('duplicated', false);
          }

          var isDuplicated = items.some(function (employeeResult) {
            return employeeResult.id !== employee.id;
          });

          if (isDuplicated) {
            input.$setValidity('duplicated', false);
          }
        });
      } else {
        if (input.$error && input.$error.duplicated) {
          input.$setValidity('duplicated', true);
        }
      }
      return Promise.resolve();
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('AbsenceDialog', AbsenceDialog);

    /** @ngInject */
    function AbsenceDialog($mdDialog, $rootScope, absencesApi, $document) {

        return {
            createAbsence: createAbsence,
            editAbsence: editAbsence
        };

        function createAbsence(ev, callback) {
            _openAbsenceDialog(ev, { Absence: null }, callback);
        }

        function editAbsence(ev, id, callback) {

            _loaderOn();

            absencesApi.get(id).then(function (absence){
                _openAbsenceDialog(ev, { Absence: absence }, callback);
            }).finally(_loaderOff);
        }

        function _openAbsenceDialog(ev, locals, callback) {

            $mdDialog.show({
                controller: 'AbsenceDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/absences/dialogs/absence-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: locals,
                closeTo: {
                  top: 0,
                  left: window.innerWidth,
                  width: window.innerWidth,
                  height: window.innerHeight / 1.8
                }
            }).then(function (reload) {
                if (callback) {
                    callback(reload);
                }
            });
        }

        function _loaderOn() {
            $rootScope.loadingProgress = true;
        }

        function _loaderOff() {
            $rootScope.loadingProgress = false;
        }
    }

})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('dateHandler', dateHandler);

  /** @ngInject */
  function dateHandler(moment, LocalDateConvert) {

    return {
      dateUtcToLocalDateTime: dateUtcToLocalDateTime,
      dateUtcToLocalDateString: dateUtcToLocalDateString,
      dateUtcToLocalTimeString: dateUtcToLocalTimeString,
      formatDateTime: formatDateTime,
      formatTimeToShort: formatTimeToShort
    };

    function dateUtcToLocalDateTime(utcDate) {
      if (utcDate) {
        return moment(utcDate);
      }
      else {
        return null;
      }
    }

    function dateUtcToLocalDateString(utcDate) {
      if (utcDate) {
        var datetime = dateUtcToLocalDateTime(utcDate);
        return LocalDateConvert.formatDate(datetime, 'date');
      } else {
        return null;
      }
    }

    function dateUtcToLocalTimeString(utcDate) {
      if (utcDate) {
        var datetime = dateUtcToLocalDateTime(utcDate);
        return LocalDateConvert.formatDate(datetime, 'time');
      } else {
        return null;
      }
    }

    function formatDateTime(date) {
      return LocalDateConvert.formatDate(date, 'date-time');
    }

    /**
     * Format complete time to short.
     * @param {string} time - Complete time (HH:mm:ss).
     */
    function formatTimeToShort(time) {
      var splittedTime = time.split(':');

      if (splittedTime.length < 2) {
        return null;
      } else if (splittedTime[0].length !== 2 || splittedTime[1].length !== 2) {
        return null;
      } else if (isNaN(splittedTime[0]) || isNaN(splittedTime[1])) {
        return null;
      }

      return splittedTime[0] + ':' + splittedTime[1];
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .service('dataTableHelperService', dataTableHelperService);

  function dataTableHelperService() {

    var ODER_BY_INDEX = 2;
    var OFFSET_INDEX = 3;
    var LIMIT_INDEX = 4;

    function toOrderBy(args) {
      var orderClauses = args.aoData[ODER_BY_INDEX];
      var firstOrderClause = orderClauses && orderClauses.value && orderClauses.value[0];

      if (!firstOrderClause) {
        console.warn('No order clause found');
        return null;
      }

      var columnIndex = firstOrderClause.column;
      var column = args.columns[columnIndex];

      if (!column || !column.sortBy) {
        console.warn('No sortBy found for column', columnIndex);
        return null;
      }

      if(args.where) {
        return column.sortBy + '_' + firstOrderClause.dir;
      }

      return firstOrderClause.dir === 'desc' ? '-' + column.sortBy : column.sortBy;
    }

    function toGraphqlVariables(args) {
      var aoData = args.aoData || [];
      var columns = args.columns || [];
      var where = args.where || {};

      var limit = aoData[LIMIT_INDEX];
      var offset = aoData[OFFSET_INDEX];

      var orderBy = toOrderBy({
        aoData: aoData,
        columns: columns,
        where: where
      });

      return {
        skip: offset ? offset.value : null,
        take: limit ? limit.value : null,
        orderBy: orderBy,
        where: where
      };

    }

    return {
      toGraphqlVariables: toGraphqlVariables,
      toOrderBy: toOrderBy
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('documentDuplicatedValidationService', documentDuplicatedValidationService);

    /** @ngInject */
    function documentDuplicatedValidationService(customersApi) {
        return {
            validate: validate
        };

        function validate(customer, input) {
            var hasDocumentNumber = customer.documentNumber && customer.documentNumber.trim();
            if (hasDocumentNumber) {
               return customersApi.search({
                    where: {
                        documentNumber: customer.documentNumber
                    },
                    take: 2
                }).then(function (res) {
                    if (input.$error && input.$error.duplicated) {
                        input.$setValidity('duplicated', true);
                    }

                    res.items.forEach(function (customerResult) {
                        if (customerResult.id !== customer.id) {
                            return input.$setValidity('duplicated', false);
                        }
                    });
                });
            } else {
                if (input.$error && input.$error.duplicated) {
                    input.$setValidity('duplicated', true);
                }
            }
            return Promise.resolve();
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.core')
  .factory('addressService', addressService);

  /** @ngInject */
  function addressService($translate) {
    return {
      validateAddress: validateAddress,
      getCountries: getCountries
    };

    function validateAddress(address) {
      var errors = [];
      var warnings = [];

      if (address) {
        if (!address.state) {
          errors.push('STATE');
        }

        if (!address.city) {
          errors.push('CITY');
        }

        if (!address.postalCode && !address.zipCode) {
          warnings.push('POSTAL_CODE');
        }

        if (!address.street) {
          warnings.push('STREET');
        }

        if (!address.neighborhood) {
          warnings.push('NEIGHBORHOOD');
        }

        if (!address.number) {
          warnings.push('NUMBER');
        }
      } else {
        errors.push('REQUIRED');
      }

      return {
        valid: !errors.length,
        errors: errors.length ? errors : null,
        warnings: warnings.length ? warnings : null
      };
    }

    function getCountries() {
      return [{
        name: $translate.instant("CORE.ADDRESS_SERVICE.COUNTRIES.NO_RESTRICTIONS"),
        code: '',
        number: '000'
      }, {
        name: 'Argentina',
        code: 'AR',
        number: '032'
      }, {
        name: 'Bolívia',
        code: 'BO',
        number: '068'
      }, {
        name: 'Brasil',
        code: 'BR',
        number: '076'
      }, {
        name: 'Chile',
        code: 'CL',
        number: '152'
      }, {
        name: 'Colômbia',
        code: 'CO',
        number: '170'
      }, {
        name: 'Equador',
        code: 'EC',
        number: '218'
      }, {
        name: 'Uruguai',
        code: 'UY',
        number: '858'
      }, {
        name: 'Paraguai',
        code: 'PY',
        number: '600'
      }, {
        name: 'México',
        code: 'MX',
        number: '484'
      }, {
        name: 'Peru',
        code: 'PE',
        number: '604'
      }];
    }
  }
})();
(function () {
  'use strict';

  angular
  .module('app.core')
  .factory('licenseService', licenseService);

  /** @ngInject */
  function licenseService() {
    return {
      isDelayed: isDelayed,
      limit: limit
    };

    function isDelayed(account) {
      return account.plan.paymentStatus === 'delayed';
    }

    function limit(activeEmployees, account) {
      var percentage = (activeEmployees * 100 / account.plan.licenses);

      return {
        isExceeded: percentage > 100,
        percentage: percentage.toFixed(0)
      };
    }
  }
})();

(function (){
    'use strict';

    angular
        .module('app.core')
        .directive('timezonedDate', timezonedDate);

    function timezonedDate(moment) {

        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, ngModel) {

                var toView = function (val) {
                    var offset = moment(val).utcOffset();
                    var date = new Date(moment(val).subtract(offset, 'm'));
                    var newOffset = moment.tz.zone(attrs.timezone).offset(date);
                    return new Date(moment(date).subtract(newOffset, 'm').unix() * 1000);
                };

                var toModel = function (val) {
                    var offset = moment(val).utcOffset();
                    var date = new Date(moment(val).add(offset, 'm'));
                    var newOffset = moment.tz.zone(attrs.timezone).offset(date);
                    return moment(date).add(newOffset, 'm').unix() * 1000;
                };

                ngModel.$formatters.unshift(toView);
                ngModel.$parsers.unshift(toModel);
            }
        };
    }


}).call(this);

(function (){
    'use strict';

    angular
        .module('app.core')
        .directive('stringToNumber', stringToNumber);

    function stringToNumber() {

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (value) {
                    return '' + value;
                });
                ngModel.$formatters.push(function (value) {
                    return parseFloat(value);
                });
            }
        };
    };
})();
(function () {
  'use strict';

  angular
  .module('app.core')
  .directive('numericOnly', numericOnly);

  /** @ngInject */
  function numericOnly() {
    return {
      require: 'ngModel',
      link: link
    };

    function link(_, __, ___, modelCtrl) {
      modelCtrl.$parsers.push(function (inputValue) {
        var transformedInput = inputValue ? inputValue.replace(/[^\d.-]/g,'') : null;

        if (transformedInput !== inputValue) {
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }

        return transformedInput;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('ngImageLoad', ['$parse', ngImageLoad]);

  /** @ngInject */
  function ngImageLoad($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var fn = $parse(attrs.ngImageLoad);
        element.on('load', function (event) {
          scope.$apply(function () {
            fn(scope, { $event: event });
          });
        });
      }
    };
  }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element) {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip() {
            if (!isFlippable()) {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable() {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective() {
        return {
            restrict: 'E',
            scope: {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
                    // Custom transclusion
                    transcludeFn(function (clone) {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective() {
        return {
            restrict: 'E',
            require: '^msWidget',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
                    // Custom transclusion
                    transcludeFn(function (clone) {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective() {
        return {
            restrict: 'E',
            require: '^msWidget',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
                    // Custom transclusion
                    transcludeFn(function (clone) {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement, attr)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if(attr.msTimelineScroll) {
                            if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                            {
                                // Show the loader
                                loadMoreEl.addClass('show');

                                // Unregister scroll event to prevent triggering the function over and over again
                                unregisterOnScroll();

                                // Trigger load more event
                                scope.loadMore().then(
                                    // Success
                                    function ()
                                    {
                                        // Hide the loader
                                        loadMoreEl.removeClass('show');

                                        // Register the onScroll event again
                                        registerOnScroll();
                                    },

                                    // Error
                                    function ()
                                    {
                                        // Remove the loader completely
                                        loadMoreEl.remove();
                                    }
                                );
                            }
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $document, $timeout, $window, ShortcutsService, $mdToast, accountsApi, _, $translate, authenticatedUser) {

        var vm = this;

        // Data
        vm.searchInput = '';
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.shortcutsLimit = 5;
        vm.possibleShortcuts = [];
        vm.listedShortcuts = [];
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;
        vm.openMenu = openMenu;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.goTo = goTo;

        init();

        function init() {
            vm.shortcuts = ShortcutsService.getShortcuts();

            if(!vm.shortcuts) {
                vm.shortcuts = ShortcutsService.getDefaultShortcuts();

                saveShortcuts();
            }

            vm.possibleShortcuts = Object.keys(ShortcutsService.possibleShortcuts).map(function (shortcutName) {
                return ShortcutsService.possibleShortcuts[shortcutName];
            });

            accountsApi.get().then(function (account) {

                function removeShortcutFromList(item) {
                    vm.removeShortcut(item);

                    for ( var x = 0; x < vm.possibleShortcuts.length; x++ ) {
                        if ( vm.possibleShortcuts[x].id === item.id ) {
                            vm.possibleShortcuts.splice(x, 1);
                        }
                    }
                }

                // Tickets
                if (!account.configuration.toolbarTicketsMenuItemVisible) {
                    removeShortcutFromList(ShortcutsService.possibleShortcuts.shortcutTickets);
                }

                // Equipments
                if (!account.configuration.moduleEquipmentManagementEnabled && !account.configuration.isCorporateCompany) {
                    removeShortcutFromList(ShortcutsService.possibleShortcuts.shortcutEquipments);
                    removeShortcutFromList(ShortcutsService.possibleShortcuts.shortcutEquipmentsType);
                }

                // Materials
                if (!account.configuration.moduleMaterialManagementEnabled) {
                    removeShortcutFromList(ShortcutsService.possibleShortcuts.shortcutMaterials);
                }

                for(var shortcut in ShortcutsService.possibleShortcuts) {
                    var formatedShortcut = shortcut.replace('shortcut', '').toLowerCase();
                    if(!authenticatedUser.hasPermission(account, shortcutMapper(formatedShortcut))) {
                        removeShortcutFromList(ShortcutsService.possibleShortcuts[shortcut]);
                    }
                }
            });

            vm.shortcuts.forEach(function (shortcut) {
                for(var index = 0; index < vm.possibleShortcuts.length; index++) {
                    if(shortcut.id === vm.possibleShortcuts[index].id) {
                        vm.possibleShortcuts[index].inUse = true;
                    }
                }
            });

            vm.listedShortcuts = vm.possibleShortcuts;

            $scope.$watch('MsShortcuts.searchInput', handleSearch);
        }

        function goTo(url) {
            $window.location.href = url;
        }

        function openMenu($mdOpenMenu, $event) {
            vm.query = '';
            $mdOpenMenu($event);
        }

        function handleSearch(current, old) {
            if (angular.isUndefined(current)) {
                return;
            }

            if (angular.equals(current, old)) {
                return;
            }

            vm.populateResults();
        }

        function populateResults() {
            var results = [];

            if (vm.searchInput) {
                vm.possibleShortcuts.forEach(function (shortcut) {
                    if (angular.lowercase(shortcut.title).search(angular.lowercase(vm.searchInput)) > -1 ) {
                        results.push(shortcut);
                    }
                });
            } else {
                results = vm.possibleShortcuts;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            vm.listedShortcuts = results;
        }

        function handleResultClick(item) {
            // Add or remove the shortcut
            if ( item.inUse ) {
                vm.removeShortcut(item);
            } else {
                if(vm.shortcuts.length < vm.shortcutsLimit) {
                    vm.addShortcut(item);
                } else {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent($translate.instant("CORE.SHORTCUTS.MAX_SHORTCUTS", {
                            shortcutsLimit: vm.shortcutsLimit
                        }))
                        .hideDelay(2000)
                    );
                }
            }
        }

        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 ) {
                event.preventDefault();
            }

            switch ( keyCode ) {
                // Enter
                case 13:
                    // Trigger result click
                    vm.handleResultClick(vm.listedShortcuts[vm.selectedResultIndex]);
                    break;

                // Up Arrow
                case 38:
                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 ) {
                        // Decrease the selected index
                        vm.selectedResultIndex--;
                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }
                    break;

                // Down Arrow
                case 40:
                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.listedShortcuts.length ) {
                        // Increase the selected index
                        vm.selectedResultIndex++;
                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }
                    break;

                default:
                    break;
            }
        }

        function saveShortcuts() {
            ShortcutsService.setShortcuts(vm.shortcuts);
        }

        function addShortcut(item) {
            // Update the inUse status
            for(var index = 0; index < vm.possibleShortcuts.length; index++) {
                if(item.id === vm.possibleShortcuts[index].id) {
                    vm.possibleShortcuts[index].inUse = true;
                }
            }

            // Add as a shortcut
            vm.shortcuts.push(item);

            vm.saveShortcuts();
        }

        function removeShortcut(item) {
            // Update the inUse status
            for(var index = 0; index < vm.possibleShortcuts.length; index++) {
                if(item.id === vm.possibleShortcuts[index].id) {
                    vm.possibleShortcuts[index].inUse = false;
                }
            }

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ ) {
                if ( vm.shortcuts[x].id === item.id ) {
                    vm.shortcuts.splice(x, 1);

                    if ( x >= vm.shortcuts.length ) {
                        vm.selectedResultIndex = vm.shortcuts.length - 1;
                    }
                }
            }

            vm.saveShortcuts();
        }

        function absorbEvent(event) {
            event.preventDefault();
        }

        function handleMouseenter(index) {

            if ( vm.ignoreMouseEvents ) {
                return;
            }

            vm.selectedResultIndex = index;
        }

        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function () {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl ) {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top ) {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) ) {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement) {
                tElement.addClass('ms-shortcuts');
            }
        };
    }

    function shortcutMapper(shortcut) {
        switch (shortcut) {
          case 'activities': return 'tasks_list_menu';
          case 'list': return 'tasks_daily-tasks_menu';
          case 'tasktypes': return 'settings-registers_tasks-type_menu';
          case 'timeline': return 'tasks_timeline_menu';
          case 'map': return 'tasks_map_menu';
          case 'calendar': return 'tasks_calendar_menu';
          case 'recurrences': return 'tasks_recurrences_menu';
          case 'customers': return 'customers_list_menu';
          case 'employees': return 'settings-account_employees_menu';
          case 'absences': return 'settings-registers_absences_menu';
          case 'routehistory': return 'settings-log_routes-history_menu';
          case 'dashboard': return 'reports_dashboard_menu';
          case 'rating': return 'reports_ratings_menu';
          case 'employeesreport': return 'reports_employees_menu';
          case 'formsreport': return 'reports_forms_menu';
          case 'tasksreport': return 'settings-registers_tasks-type_menu';
          case 'heatmap': return 'reports_heat-map_menu';
          case 'tickets': return 'tickets_list_menu';
          case 'equipments': return 'equipments_list_menu';
          case 'equipmentstype': return 'settings-registers_equipments-type_menu';
          case 'materials': return 'settings-registers_materials_menu';
        }
      }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            if (item.externalUrl) {
                uisref = item.state;
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService, $transitions)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            $transitions.onSuccess({}, function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            $transitions.onSuccess({}, function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, $transitions, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $transitions.onSuccess({}, function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function () {
  'use strict';

  angular.module('app.core')
    .factory('msInfoBarService', msInfoBarService);

  /** @ngInject */
  function msInfoBarService($rootScope) {
    var infoBarArray = [];
    var currentInfoBar = {};
    var messageButton = '';

    return {
      add: add,
      get: get,
      getAll: getAll,
      load: load,
      setCurrentInfoBar: setCurrentInfoBar,
      close: close,
      remove: remove,
      canRemove: canRemove
    };

    function add(infoBar) {
      if(
        infoBar.priority &&
        infoBar.condition &&
        infoBar.displayMessage
        ) {
          infoBarArray.push(infoBar);
        }
      }

      function get() {
        return currentInfoBar;
      }

      function getAll() {
        return infoBarArray;
      }

      function load() {
        if (angular.element('#index-info-bar') && infoBarArray.length) {
          infoBarArray = _.sortBy(infoBarArray, 'priority');

          var infoBar = infoBarArray.shift();

          if (infoBar.condition) {
            currentInfoBar = infoBar;

            $rootScope.indexMsInfoBar = {
              displayMessage: infoBar.displayMessage,
              displayLinkMessage: infoBar.displayLinkMessage || null,
              buttonLinkMessage: infoBar.buttonLinkMessage || null,
              function: infoBar.function || null,
              ngClass: infoBar.ngClass && infoBar.ngClass.length ? infoBar.ngClass : ['md-accent-bg']
            };

            messageButton = $rootScope.indexMsInfoBar.buttonLinkMessage;
          } else {
            currentInfoBar = null;

            load();
          }
        } else {
          currentInfoBar = null;
        }
      }

      function setCurrentInfoBar(infoBar) {
        if(currentInfoBar) {
          $rootScope.indexMsInfoBar = {
            displayMessage: infoBar.displayMessage,
            displayLinkMessage: infoBar.displayLinkMessage || null,
            buttonLinkMessage: infoBar.buttonLinkMessage || null,
            function: infoBar.function || null,
            ngClass: infoBar.ngClass && infoBar.ngClass.length ? infoBar.ngClass : ['md-accent-bg']
          };
        }
      }

      function close() {
        if (canRemove()) {
          remove();
        } else {
          load();
        }
      }

      function remove() {
        currentInfoBar = null;

        try {
          var body = angular.element('body');
          if (body) {
            body.removeClass('ms-info-bar-active');
          }
          var infoBar = angular.element('#index-info-bar');
          if (infoBar) {
            infoBar.remove();
          }
        } catch (err) { }
      }

      function canRemove() {
        return infoBarArray.length === 0;
      }
    }
  })();

(function ()
{
  'use strict';

  angular
    .module('app.core')
    .directive('msInfoBar', msInfoBarDirective);

  /** @ngInject */
  function msInfoBarDirective($document, msInfoBarService)
  {
    return {
      restrict   : 'E',
      scope      : {},
      transclude : true,
      templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
      link       : function (scope, iElement)
      {
        var body = $document.find('body');
        var bodyClass = 'ms-info-bar-active';
        body.addClass(bodyClass);

        scope.removeInfoBar = msInfoBarService.close;
      }
    };
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix)
        .config(mdDateLocaleConfig);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$scope.$watch(function () { return ngModel.minDate; }, function () {
                    if (ngModel.dateUtil.isValidDate(ngModel.date)) {
                        ngModel.updateErrorState.call(ngModel);
                    }
                });

                ngModel.$scope.$watch(function () { return ngModel.date; }, function (newVal, oldVal) {
                    ngModel.updateErrorState.call(ngModel);
                });

                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }

    function mdDateLocaleConfig($mdDateLocaleProvider) {
        var language = localStorage.getItem('language') || 'pt-br';
        moment.locale(language);
        $mdDateLocaleProvider.formatDate = function (date) {
            if (date) {
                var format;
                if (language === 'en') {
                    format = 'MM/DD/YYYY';
                } else {
                    format = 'DD/MM/YYYY';
                }

                return moment(date).format(format);
            }

            return null;
        };
        $mdDateLocaleProvider.parseDate = function (date) {
          if (date) {
            var format;
            if (language === 'en') {
                format = 'MM/DD/YYYY';
            } else {
                format = 'DD/MM/YYYY';
            }
            var m = moment(date, format, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          }

          return null;
        };

        $mdDateLocaleProvider.firstDayOfWeek = 0;

        var language = localStorage.getItem('language') || 'pt';

        if (language === 'pt' || language === 'pt-BR') {
          $mdDateLocaleProvider.daysMin = ["D", "S", "T", "Q", "Q", "S", "S", "D"];
          $mdDateLocaleProvider.shortDays = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];
          $mdDateLocaleProvider.days = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];
          $mdDateLocaleProvider.monthsMin = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
          $mdDateLocaleProvider.shortMonths = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
          $mdDateLocaleProvider.months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
        } else if (language === 'en' || language === 'en-US') {
          $mdDateLocaleProvider.daysMin = ["S", "M", "T", "W", "T", "F", "S"];
          $mdDateLocaleProvider.shortDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          $mdDateLocaleProvider.days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          $mdDateLocaleProvider.monthsMin = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
          $mdDateLocaleProvider.shortMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          $mdDateLocaleProvider.months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        } else if (language === 'es' || language === 'es-ES') {
          $mdDateLocaleProvider.daysMin = ["D", "L", "M", "X", "J", "V", "S"];
          $mdDateLocaleProvider.shortDays = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
          $mdDateLocaleProvider.days = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
          $mdDateLocaleProvider.monthsMin = ["E", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
          $mdDateLocaleProvider.shortMonths = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
          $mdDateLocaleProvider.months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    /* How to Use
    *  <toggle-feature feature-name="test1">
    *      <span>Field Control with directive TAG</span>
    *  </toggle-feature>
    *  OR
    *  <any toggle-feature feature-name="test2">
    *      <span>Field Control with any HTML TAG</span>
    *  </any>
    */

    angular
        .module('app.core')
        .factory('toggleFeatureProvider', toggleFeatureProvider)
        .directive('toggleFeature', toggleFeature);

    /** @ngInject */
    function toggleFeatureProvider(authenticatedUser) {
        var user = authenticatedUser.profile;
        var features = user.permissions;

        function getFeatureStatus(featureName) {
            if (!featureName) { return null; }
            return _.chain(features).map('name').includes(featureName).value();
        }

        function getFeatures() {
            return features;
        }

        function setFeatures(newFeatures) {
            features = {};
            if (newFeatures) {
                features = newFeatures;
            }
            return features;
        }

        return {
            getFeatures: getFeatures,
            setFeatures: setFeatures,
            getFeatureStatus: getFeatureStatus
        };
    }

    /** @ngInject */
    function toggleFeature(toggleFeatureProvider) {
        return {
            restrict: 'AE',
            transclude: true,
            link: function ($scope, element, attrs, ctrl, $transclude) {
                if (toggleFeatureProvider.getFeatureStatus(attrs.featureName)) {
                    $transclude(function (featureEl) {
                        element.after(featureEl).remove();
                    });
                } else {
                    $transclude(function (featureEl) {
                        featureEl.after(element).remove();
                    });
                }
            }
        };
    }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('FcToastService', FcToastService);

  /*
  options: {
    title: string,
    content: string,
    iconPath: string,
    iconFontName: string,
    position: ( TOP | BOTTOM ) && ( LEFT | RIGHT ) || CENTER,
    hideDelay: number in milliseconds,
    customClass: string,
    errorType: string
  }
  */
  /** @ngInject */
  function FcToastService(_) {

    var observerCallbacks = [];
    var toastService = {};
    toastService.errorsQueue = [];

    function notifyObservers() {
      // remove repeated errors
      toastService.errorsQueue = _.uniq(toastService.errorsQueue, function (error) {
        return error.errorType;
      });
      var isErrorsQueueEmpty = toastService.errorsQueue.length === 0;

      angular.forEach(observerCallbacks, function (callback) {
        callback(isErrorsQueueEmpty);
      });
    };

    toastService.registerObserverCallback = function (callback) {
      observerCallbacks.push(callback);
    };

    toastService.removeErrorByIndex = function (index) {
      toastService.errorsQueue.splice(index, 1);
      notifyObservers();
    };

    toastService.addWarning = function (options) {
      toastService.errorsQueue.push(options);

      notifyObservers();
    };


    return toastService;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcToast', fcToast);

  /*
    title: string,
    content: string,
    iconPath: string, md-svg-src="iconPath"
    iconFontName: string, md-font-icon="iconFontName"
    position: string,
    hideDelay: string,
    customClass: string,
    noExit: boolean
  */
  /** @ngInject */
  function fcToast() {
    var controller = function ($scope, $timeout, _, FcToastService) {
      var vm = this;

      vm.errorsQueue = [];

      var updateErrorsQueue = function (isErrorsQueueEmpty) {
        if (isErrorsQueueEmpty) {
          vm.errorsQueue = [];
        }
        else if (FcToastService.errorsQueue.length && FcToastService.errorsQueue[0] && FcToastService.errorsQueue[0].hideDelay) {
          _.defer(function () {
            $scope.$apply(function () {
              vm.errorsQueue = FcToastService.errorsQueue;
            });

            if (vm.errorsQueue.length === 1) {
              toggleCurrentError();
            }
          });
        }
      };

      FcToastService.registerObserverCallback(updateErrorsQueue);

      vm.hideError = hideError;
      function hideError() {
        var myToast = document.querySelector('.fc-toast');

        if (vm.errorsQueue.length && myToast) {
          myToast.classList.add('HIDDEN');

          waitHideAnimation(function () {
            FcToastService.removeErrorByIndex(0);

            if (vm.errorsQueue.length) {
              toggleCurrentError();
            }
          });
        }
      }

      function toggleCurrentError() {
        var myToast = document.querySelector('.fc-toast');

        waitHideAnimation(function () {
          if (myToast) {
            myToast.classList.remove('HIDDEN');
          }
        });

        if (vm.errorsQueue.length && vm.errorsQueue[0].hideDelay) {
          $timeout(function () {
            vm.hideError();
          }, vm.errorsQueue[0].hideDelay);
        }
      }

      function waitHideAnimation(callback) {
        $timeout(callback, 300);
      }
    };

    return {
      restrict: 'E',
      scope: {
        title: '@',
        content: '@',
        iconPath: '@',
        iconFontName: '@',
        position: '@',
        hideDelay: '@',
        customClass: '@'
      },
      templateUrl: 'app/core/directives/fc-toast/template/fc-toast.html',
      controller: controller,
      controllerAs: 'vm'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcTimeInput', fcTimeInput);

  /** @ngInject */
  function fcTimeInput() {
    return {
      restrict: 'E',
      scope: {
        required: '=',
        timemodel: '=',
        datemodel: '='
      },
      templateUrl: 'app/core/directives/fc-time-input/fc-time-input.html',
      controller: 'FcTimeInputController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('FcTimeInputController', FcTimeInputController);

  function FcTimeInputController(moment, $scope) {
    var vm = this;
    $scope.timemodel = $scope.timemodel ? $scope.timemodel : '';
    vm.timeTextInput = document.querySelector('.fc-time-input__input');
    vm.placeholderIsOnCenter = $scope.timemodel.length === 0 ? true : false;
    vm.movePlaceholderToTop = movePlaceholderToTop;
    vm.movePlaceholderToCenter = movePlaceholderToCenter;
    vm.validateTime = validateTime;
    vm.errors = [];

    _initialize();

    function _initialize() {
      if (!vm.timeTextInput) {
        return;
      };

      vm.timeTextInput.addEventListener('input', function () {
        validateTime();
        if (vm.errors.length) {
          $scope.timemodel.$invalid = true;
        } else {
          delete $scope.timemodel.$invalid;
        }
      });
    }

    function validateTime() {
      vm.timeTextInput.value = vm.timeTextInput.value.replace(/[^0-9:]/g, '');
      vm.errors = [];

      $scope.timemodel = moment(vm.timeTextInput.value, "h:mm");
      var incompleteTime = vm.timeTextInput.value.length < 5;

      if (!vm.timeTextInput.value && !$scope.required) {
        return;
      }

      if (!vm.timeTextInput.value && $scope.required) {
        vm.errors.push('empty');
        return;
      }

      if (!$scope.timemodel.isValid() || incompleteTime) {
        vm.errors.push('invalid');
      }
    };

    function movePlaceholderToTop() {
      vm.placeholderIsOnCenter = false;
    };

    function movePlaceholderToCenter() {
      if (vm.timeTextInput.value.length === 0) {
        vm.placeholderIsOnCenter = true;
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcTextarea', fcTextarea);

  /*
    ngModel: string,
    errorsToWatch: [{ name: string, translate: string, translateValues: { } }],
    inputControl: {},
    inputName: string,
    label: string,
    isDisabled: boolean,
    isRequired: boolean,
    ngChange: function,
    maxLength: number,
    minLength: number,
  */
  /** @ngInject */
  function fcTextarea() {
    var controller = function ($scope, $element) {
      var vm = this;
      vm.disableOnlyText = $scope.disableOnlyText === 'true';
      vm.maxLength = $scope.maxLength ? Number.parseInt($scope.maxLength) : Number.MAX_SAFE_INTEGER;
      vm.minLength = $scope.minLength ? Number.parseInt($scope.minLength) : 0;

      function _initialize() {
        $scope.$watch('ngModel', function () {
          $scope.ngChange();
        });

        var element = $element.find('textarea')[0];
        element.parentNode.dataset.replicatedValue = $scope.ngModel;
      }

      _initialize();
    };

    return {
      restrict: 'E',
      require: ['ngModel', 'ngChange'],
      scope: {
        ngModel: '=',
        errorsToWatch: '=',
        inputControl: '=',
        isDisabled: '=',
        isRequired: '=',
        ngChange:  '&',
        inputName: '@',
        label: '@',
        maxLength: '@',
        minLength: '@'
      },
      templateUrl: 'app/core/directives/fc-textarea/template/fc-textarea.html',
      controller: controller,
      controllerAs: 'vm'
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.core').directive('fcSubscriptionModule', fcSubscriptionModule);

  function controller($state, $scope) {
    var vm = this;
    vm.goToModule = goToModule;
    vm.configurationName = $scope.configurationName;

    function goToModule() {
      $state.go('app.modules', { configurationKey: vm.configurationName });
    }
  }

  function fcSubscriptionModule() {
    return {
      restrict: 'E',
      scope: {
        moduleTitle: '=',
        moduleDescription: '=',
        previewUrl: '@',
        activedModule: '=',
        configurationName: '@',
      },
      controller: controller,
      controllerAs: 'vm',
      templateUrl: 'app/core/directives/fc-subscription-module/template/fc-subscription-module.html',
    };
  }
})();

(function () {
    'use strict';

    angular
      .module('app.core')
      .directive('fcSpreadsheetResult', fcSpreadsheetResult);

    function fcSpreadsheetResult() {
      var controller = function ($scope, _) {
        var vm = this;
        vm.loading = false;
        vm.spreadsheet = $scope.spreadsheet;
        vm.inspectedRows = [];
        vm.invalidRowsCount = 0;
        vm.invalidRowsPercentage = 0;

        vm.columnHasError = _columnHasError;

        if ($scope.checkRows) {
          vm.loading = true;
          $scope.checkRows()
            .then(function (inspectedRows) {
              vm.invalidRowsCount = _.filter(inspectedRows, { valid: false }).length;
              vm.invalidRowsPercentage = (vm.invalidRowsCount / vm.spreadsheet.rows.length) * 100;
              $scope.valid = vm.invalidRowsPercentage === 0;
              vm.inspectedRows = inspectedRows.map(function (row){
                row.error = _.chain(row.error)
                  .filter({ reason: 'custom' })
                  .sortBy('code')
                  .value();
                return row;
              });
              vm.inspectedRows = inspectedRows;
            }).finally(function () {
              vm.loading = false;
            });
        }

        function _columnHasError(row, column) {
          return _.find(row.error, { code: column });
        }
      };

      return {
        restrict: 'E',
        require: ['ngModel'],
        scope: {
          spreadsheet: '=',
          checkRows: '=',
          valid: '='
        },
        templateUrl: 'app/core/directives/fc-spreadsheet-result/template/spreadsheet-result.html',
        controller: controller,
        controllerAs: 'vm'
      };
    }

  }).call(this);
(function () {
    'use strict';

    angular
      .module('app.core')
      .directive('fcSpreadsheetReader', fcSpreadsheetReader);

    function fcSpreadsheetReader() {
      var controller = function ($scope, ExcelJS, $mdToast, $translate) {
        var vm = this;

        $scope.options.allowedTypes = $scope.options.allowedTypes || [
          'text/csv',
          'application/vnd.ms-excel',
          'application/vnd.ms-excel.sheet.macroEnabled.12',
          'application/vnd.ms-excel.template.macroEnabled.12',
          'application/vnd.ms-excel.addin.macroEnabled.12',
          'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];

        vm.loadSpreadsheet = loadSpreadsheet;

        function loadSpreadsheet(file) {
          if (!file) {
            $scope.result(null);
            return;
          }
          vm.loading = true;
          ExcelJS.read(file, { rowsLimit: 1000 })
            .then(function (result) {
              var spreadsheet = {
                columns: result[0].data.columns.map(_getColumnLabel),
                rows: result[0].data.values,
                file: file
              };
              $scope.result(spreadsheet);
            })
            .catch(function (error) {
              $scope.result(null);
              console.error(error);
              $mdToast.show(
                $mdToast.simple()
                .textContent($translate.instant('CORE.FC_SPREADSHEET_READER.TOASTS.FILE.OPEN_ERROR'))
                .hideDelay(3000)
              );
            })
            .finally(function () {
              vm.loading = false;
              $scope.$apply();
            });
        }

        function _getColumnLabel(column) {
          return column['field'];
        }
      };

      return {
        restrict: 'E',
        require: ['ngModel'],
        scope: {
          name: '@',
          ngModel: '=',
          ngChange: '&',
          required: '@',
          disabled: '=',
          options: '=',
          result: '='
        },
        templateUrl: 'app/core/directives/fc-spreadsheet-reader/template/spreadsheet-reader.html',
        controller: controller,
        controllerAs: 'vm'
      };
    }

  }).call(this);
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcSmartRewrite', fcSmartRewrite);

  /** @ngInject */
  function fcSmartRewrite(gandalfApi) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        referenceId: '=',
        disabled: '=',
        referenceType: '@',
      },
      templateUrl: 'app/core/directives/fc-smart-rewrite/fc-smart-rewrite.directive.html',
      link: link
    };

    function link($scope, element, attrs, ctrl, transclude) {
      $scope.input = null;
      $scope.observer = new MutationObserver(getInputElement);
      $scope.container = element.get(0);

      $scope.mouseEnter = mouseEnter;
      $scope.mouseLeave = mouseLeave;
      $scope.onInput = onInput;
      $scope.openDialog = openDialog;
      $scope.openInputHistory = openInputHistory;
      $scope.smartRewriteClosed = smartRewriteClosed;
      $scope.smartRewriteHistoryClosed = smartRewriteHistoryClosed;

      $scope.hasHistory = false;
      $scope.hasHover = false;
      $scope.hasValue = false;

      function _initialize() {
        $scope.observer.observe($scope.container, { childList: true, subtree: true });
        getInputElement();

        var reference = $scope.referenceType + '#' + $scope.referenceId;
        gandalfApi.getInputHistory(reference).then(function (inputHistory) {
          $scope.hasHistory = inputHistory.data && inputHistory.data.items && inputHistory.data.items.length;
        });
      }

      function getInputElement() {
        $scope.input = $scope.container.querySelectorAll('input, textarea')[0];
        if (!$scope.input) { return; }

        $scope.observer.disconnect();
        applyEventListeners($scope.input);
      }

      function applyEventListeners(input) {
        if (!input) { return; }

        input.addEventListener('input', $scope.onInput);
      }

      function openDialog() {
        if (!$scope.input) { return; }

        var data = {
          message: $scope.input.value,
          referenceId: $scope.referenceId,
          referenceType: $scope.referenceType
        };

        document.dispatchEvent(new CustomEvent('openSmartRewrite', { detail: data }));

        document.addEventListener('smartRewriteClosed', $scope.smartRewriteClosed);
      }

      function openInputHistory() {
        if (!$scope.input) { return; }

        var data = {
          message: $scope.input.value,
          referenceId: $scope.referenceId,
          referenceType: $scope.referenceType
        };

        document.dispatchEvent(new CustomEvent('openSmartRewriteInputHistory', { detail: data }));

        document.addEventListener('smartRewriteInputHistoryClosed', $scope.smartRewriteHistoryClosed);
      }

      function smartRewriteClosed(event) {
        var result = event.detail;
        document.removeEventListener('smartRewriteClosed', $scope.smartRewriteClosed);
        if (!$scope.input) { return; }
        if (!result) { return; }

        $scope.input.value = result;
        $scope.input.dispatchEvent(new Event('input', { bubbles: true }));
        $scope.input.dispatchEvent(new Event('change', { bubbles: true }));

        $scope.hasHistory = true;
      };

      function smartRewriteHistoryClosed(event) {
        var result = event.detail;
        document.removeEventListener('smartRewriteInputHistoryClosed', $scope.smartRewriteHistoryClosed);
        if (!$scope.input) { return; }
        if (!result) { return; }

        $scope.input.value = result;
        $scope.input.dispatchEvent(new Event('input', { bubbles: true }));
        $scope.input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      function mouseEnter() {
        $scope.hasHover = true;
        onInput();
      };

      function mouseLeave() {
        $scope.hasHover = false;
      };

      function onInput() {
        if (!$scope.input) {
          $scope.hasValue = false;
          return;
        }

        var value = $scope.input.value;

        if (!value || (value && value.length <= 3)) {
          $scope.hasValue = false;
          return;
        }

        if (value.length > 5000) {
          $scope.hasValue = false;
          return;
        }

        $scope.hasValue = true;
      };

      _initialize();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcSelect', fcSelect);

  /*
    ngModel: any,
    options: [ { translate: string, value: ngModelValue } ]
    errorsToWatch: [{ name: string, translate: string, translateValues: { } }],
    inputControl: {}
    isDisabled: boolean
    isRequired: boolean
    hasArrow: boolean
    inputName: string
    label: string
    trackBy: string (ngModel object key) *required when ngModel = object*
    withSearch: boolean
    withoutDivider: boolean
    searchPhrase: string
    prefixSrc: string
    ngChange: function
    searchFunction: function (callback) => {}
    limit: number
    skipSearch: boolean
  */
  /** @ngInject */
  function fcSelect($compile) {
    var controller = function ($scope, _) {
      var vm = this;

      vm.withSearch = $scope.withSearch === 'true';
      vm.skipSearch = $scope.skipSearch === 'true';
      vm.withoutDivider = $scope.withoutDivider === 'true';
      vm.hasArrow = $scope['hasArrow'];
      vm.showOptions = false;
      vm.selectedOption = getCurrentSelectedOption();
      vm.viewValue = getViewValue(vm.selectedOption);

      if($scope.searchFunction) {
        $scope.searchFunction = _.debounce($scope.searchFunction, 600);
      }

      vm.hideOptionsClickOutside = function (event) {
        var elements = angular.element('div.fc-select').filter(function () {
          return angular.element(this).find('ul[aria-hidden="false"]').length > 0;
        }).last()[0];

        var element = angular.element('div.fc-select').has(event.target)[0];

        if (vm.showOptions && (elements != element || !element.$$hashKey || elements.$$hashKey !== element.$$hashKey)) {
          vm.showOptions = false;
          $scope.$apply();
          $scope.$on('$destroy', function () {
            angular.element(document).off('click', vm.hideOptionsClickOutside);
          });
        }
      };

      function _initialize() {
        $scope.options = _.sortBy($scope.options, 'value.name');

        angular.element(document).on('click', vm.hideOptionsClickOutside);
      }

      _initialize();

      if (vm.withSearch && !vm.skipSearch) {
        $scope.$watch('vm.searchTerm', function () {
          var currentFilter = null;
          var isWithTranslate = $scope.options && $scope.options.length > 1 ? !!$scope.options[1].translate : false;

          if (isWithTranslate) {
            currentFilter = { translate: vm.searchTerm || '' };
          }

          if ($scope.trackBy && !isWithTranslate) {
            currentFilter = { value: {} };
            currentFilter.value[$scope.trackBy] = vm.searchTerm || '';
          }

          if (!$scope.trackBy && !isWithTranslate) {
            currentFilter = vm.searchTerm || '';
          }


          if(_.isEmpty(currentFilter.translate) && $scope.limit){
            $scope.options = $scope.options.slice(0, $scope.limit);
          }
          vm.currentFilter = currentFilter;
        });
      }

      $scope.$watch('ngModel', function () {
        vm.selectedOption = getCurrentSelectedOption();
        vm.viewValue = getViewValue(vm.selectedOption);
      });

      $scope.$watch('options', function () {
        vm.selectedOption = getCurrentSelectedOption();
        vm.viewValue = getViewValue(vm.selectedOption);
        $scope.ngChange();
      });

      $scope.$watch('vm.showOptions', function (newVal) {
        if (newVal) {
          var currentActiveIndex = 0;
          var dropdown = document.querySelector('.fc-select__dropdown');

          var dropdownItems = Array.from(document.querySelectorAll('.fc-select__dropdown__item'));
          document.body.addEventListener('keydown', function (event) {
            // arrow down
            if (event.keyCode === 40) {
              var nextIndex = currentActiveIndex + 1;
              if (nextIndex <= dropdownItems.length - 1) {
                currentActiveIndex++;
              } else {
                currentActiveIndex = dropdownItems.length - 1;
              }

              vm.changeActiveOption(dropdownItems, currentActiveIndex);
              dropdown.scroll(0, currentActiveIndex * 43);
            }

            // arrow up
            if (event.keyCode === 38) {
              var nextIndex = currentActiveIndex - 1;
              if (nextIndex >= 0) {
                currentActiveIndex--;
              } else {
                currentActiveIndex = 0;
              }

              vm.changeActiveOption(dropdownItems, currentActiveIndex);
              dropdown.scroll(0, currentActiveIndex * 43);
            }

            // enter
            if (event.keyCode === 13) {
              var currentOption = $scope.options[currentActiveIndex];
              $scope.$apply(function () {
                vm.selectedItemChange(null, currentOption);
              });
            }
          });
        } else {
          document.body.removeEventListener('keydown', function () { });
        }
      }, true);

      if (!$scope.isRequired) {
        $scope.options.unshift({ translate: $scope.label, value: null });
      }

      vm.selectedItemChange = selectedItemChange;
      vm.toggleShowOptions = toggleShowOptions;
      vm.changeActiveOption = changeActiveOption;

      function selectedItemChange($event, selectedValue) {
        if ($scope.inputControl) {
          $scope.inputControl.$setDirty();
        }
        vm.showOptions = false;
        $scope.ngModel = selectedValue.value;
        $scope.ngChange({ value: selectedValue.value });
      };

      function toggleShowOptions() {
        if (!$scope.isDisabled) {
          vm.showOptions = !vm.showOptions;

          if ($scope.inputControl) {
            $scope.inputControl.$setTouched();
          }
        }
      };

      function changeActiveOption(dropdownItems, currentActiveIndex) {
        var currentActivated = document.querySelector('.activated');
        if (currentActivated) {
          currentActivated.classList.remove('activated');
        }

        dropdownItems[currentActiveIndex].classList.add('activated');
      };

      function getCurrentSelectedOption() {
        var currentSelectedOption = null;

        if ($scope.ngModel) {
          currentSelectedOption = _.find($scope.options, function (option) {
            if (!option.value) {
              return null;
            }

            return $scope.trackBy ?
              option.value[$scope.trackBy] === $scope.ngModel[$scope.trackBy]
              : option.value === $scope.ngModel;
          });
        }


        return currentSelectedOption;
      };

      function getViewValue(selectedItem) {
        var viewValue = selectedItem ? selectedItem.translate || selectedItem.value : null;
        if (selectedItem && $scope.trackBy) {
          viewValue = selectedItem.translate || selectedItem.value[$scope.trackBy];
        }

        return viewValue;
      };
    };

    return {
      restrict: 'E',
      require: ['ngModel', 'ngChange'],
      scope: {
        options: '=',
        ngModel: '=',
        errorsToWatch: '=',
        inputControl: '=',
        isDisabled: '=',
        isRequired: '=',
        hasArrow: '=',
        inputName: '@',
        label: '@',
        trackBy: '@',
        withSearch: '@',
        withoutDivider: '@',
        searchPhrase: '@',
        ngChange: '&',
        searchFunction: '&',
        prefixSrc: '@',
        limit: '@',
        skipSearch: '@'
      },
      templateUrl: 'app/core/directives/fc-select/template/fc-select.html',
      controller: controller,
      controllerAs: 'vm'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcSearch', fcSearch);

  /*
   options: [{ text: string }]
   label: string
   hint: string
   isDisabled: boolean
   trackBy: string
   searchFunction: (string) => {}
   selectFunction: (option) => {}
  */
  /** @ngInject */
  function fcSearch() {
    var controller = function ($scope, _) {
      var vm = this;

      vm.showOptions = true;
      vm.searchTerm = '';

      vm.selectedItemChange = selectedItemChange;
      vm.onChange = onChange;

      function selectedItemChange(option) {
        vm.showOptions = false;
        vm.searchTerm = '';
        $scope.selectFunction({ option: option });
      };

      function onChange() {
        $scope.searchFunction({ searchTerm: vm.searchTerm });
      }
    };

    return {
      restrict: 'E',
      require: ['ngModel'],
      scope: {
        options: '=',
        label: '@',
        hint: '@',
        trackBy: '@',
        isDisabled: '=',
        searchFunction: '&',
        selectFunction: '&'
      },
      templateUrl: 'app/core/directives/fc-search/template/fc-search.html',
      controller: controller,
      controllerAs: 'vm'
    };
  }
})();
(function () {
  'use strict';

  angular.module('app.core')
    .factory('FcModalService', FcModalService);

  /*
  {
    component: 'componentName',
    resolve: {
      handleRightButton: () => {},
      rightButtonText: string,
      leftButtonText: string,
      leftButtonColor: string,
      title: string,
      content: string,
      templateUrl: string,
      variables: object,
      large: boolean,
      buttonFlex: boolean,
      padding: boolean,
      dontCloseModalOnLeftButtonHandler: boolean,
      rightButtomFullSize: boolean,
      rightButtonIsDownloadLink: boolean,
      clickOutsideToClose: boolean,
      hasOmieAccountSelector: boolean,
      buttonHeight: integer,
      buttonWidth: integer,
      rightContinueButton: boolean,
      contentTextSpacing: string,
      colorBold: string,
      downloadLink: string,
      downloadHref: string,
      closeButtonIconPath: string, md-svg-src="iconPath"
      iconPath: string, md-svg-src="iconPath"
      titleIconPath: string, md-svg-src="iconPath"
      hasOmieCustomerSelector: boolean
    }
  }
  */
  /** @ngInject */
  function FcModalService($mdDialog, $document, $rootScope) {
    return {
      open: open,
      close: close
    };

    function close(modalId) {
      $rootScope.$broadcast('close-modal-service-' + modalId);
    }

    function open(ev, options, callback) {
      _openDialog(ev, {
        Title: options.title,
        Content: options.content,
        ScrollableContent: options.scrollableContent,
        TemplateUrl: options.templateUrl,
        PaddingSmall: options.paddingSmall,
        Variables: options.variables,
        CloseButtonIconPath: options.closeButtonIconPath,
        RightButtonText: options.rightButtonText,
        LeftButtonText: options.leftButtonText,
        LeftButtonColor: options.leftButtonColor,
        HandleRightButton: options.handleRightButton,
        HandleLeftButton: options.handleLeftButton,
        DontCloseModalOnLeftButtonHandler: options.dontCloseModalOnLeftButtonHandler,
        RightButtomFullSize: options.rightButtomFullSize,
        HasOmieAccountSelector: options.hasOmieAccountSelector,
        RightContinueButton: options.rightContinueButton,
        RightButtonIsDownloadLink: options.rightButtonIsDownloadLink,
        ClickOutsideToClose: options.clickOutsideToClose,
        DownloadLink: options.downloadLink,
        DownloadHref: options.downloadHref,
        HandleClose: options.handleClose,
        IconPath: options.iconPath,
        TitleIconPath: options.titleIconPath,
        Large: options.large,
        ButtonSeparation: options.buttonFlex,
        ContentTextSpacing: options.contentTextSpacing,
        EventNameToSubscribe: options.eventNameToSubscribe,
        ModalId: options.modalId,
        ModalClass: options.modalClass,
        ColorBold: options.colorBold,
        ButtonWidth: options.buttonWidth,
        ButtonHeight: options.buttonHeight,
        HasOmieCustomerSelector: options.hasOmieCustomerSelector
      }, callback);
    }

    function _openDialog(ev, locals, callback) {
      var isOnTicket = $document.find('.ticket-details-dialog');
      $mdDialog.show({
        controller: 'FcModalController',
        controllerAs: 'vm',
        templateUrl: 'app/core/directives/fc-modal/fc-modal.html',
        parent: isOnTicket ? document.querySelector('.palantir-modal-container') || $document.find('.ticket-details-dialog') : angular.element($document.body) || document.querySelector('.palantir-modal-container'),
        targetEvent: ev || null,
        clickOutsideToClose: locals.ClickOutsideToClose || false,
        escapeToClose: false,
        multiple: true,
        locals: locals
      }).then(function (result) {
        if (callback) {
          callback(result);
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('FcModalController', FcModalController);

  /** @ngInject */
  function FcModalController(
    Title,
    Content,
    ScrollableContent,
    TemplateUrl,
    Variables,
    RightButtonText,
    LeftButtonText,
    LeftButtonColor,
    CloseButtonIconPath,
    PaddingSmall,
    ButtonSeparation,
    ContentTextSpacing,
    HandleClose,
    HandleRightButton,
    HandleLeftButton,
    DontCloseModalOnLeftButtonHandler,
    ColorBold,
    HasOmieAccountSelector,
    RightButtomFullSize,
    RightButtonIsDownloadLink,
    DownloadLink,
    DownloadHref,
    IconPath,
    TitleIconPath,
    Large,
    EventNameToSubscribe,
    ModalId,
    ModalClass,
    ButtonHeight,
    ButtonWidth,
    RightContinueButton,
    $mdDialog,
    $rootScope,
    $scope,
    _,
    omieApi,
    $q,
    HasOmieCustomerSelector
  ) {

    if (EventNameToSubscribe) {
      $rootScope.$on(EventNameToSubscribe, function (ev, args) {
        var argsKeys = args && Object.keys(args);
        if (Array.isArray(argsKeys) && argsKeys.length) {
          argsKeys.forEach(function (key) {
            if (vm.variables.hasOwnProperty(key)) {
              _.defer(function () {
                $rootScope.$apply(function () {
                  vm.variables[key] = args[key] || '';
                });
              });
            }
          });
        }
      });
    }

    if (ModalId) {
      $rootScope.$on('close-modal-service-' + ModalId, function () {
        closeDialog();
      });
    }

    if (HasOmieAccountSelector) {
      var deferred = $q.defer();

      omieApi.accounts.list()
        .then(function (res) {

          if (!res.data || !res.data.Items || !res.data.Items.length) {
            deferred.resolve([{
              value: {
              name: null,
              appId: null
            }
          }]);
            return;
          }


          var accounts = res.data.Items.map(function (item) {
            return {
              value: {
                name: item.accountName,
                appId: item.appId
              }
            };
          });

          deferred.resolve(accounts);
        })
        .catch(function (error) {
          console.error('Error fetching accounts:', error);
          deferred.reject(error);
        });

      deferred.promise.then(function (accounts) {
        vm.omieAccounts = accounts;

        if (vm.omieAccounts && vm.omieAccounts.length && vm.omieAccounts.length === 1) {
          vm.selectedAccount = vm.omieAccounts[0] ? vm.omieAccounts[0].value : null;
        }
      });
    }

    var vm = this;
    vm.title = Title;
    vm.content = Content;
    vm.templateUrl = TemplateUrl;
    vm.variables = Variables;
    vm.rightButtonText = RightButtonText;
    vm.leftButtonText = LeftButtonText;
    vm.leftButtonColor = LeftButtonColor;
    vm.closeButtonIconPath = CloseButtonIconPath;
    vm.paddingSmall = PaddingSmall;
    vm.rightContinueButton = RightContinueButton;
    vm.buttonSeparation = ButtonSeparation;
    vm.hasOmieAccountSelector = HasOmieAccountSelector;
    vm.contentTextSpacing = ContentTextSpacing;
    vm.rightButtomFullSize = RightButtomFullSize;
    vm.rightButtonIsDownloadLink = RightButtonIsDownloadLink;
    vm.downloadLink = DownloadLink;
    vm.downloadHref = DownloadHref;
    vm.buttonHeight = ButtonHeight;
    vm.buttonWidth = ButtonWidth;
    vm.colorBold = ColorBold;
    vm.modalClass = ModalClass;
    vm.scrollableContent = ScrollableContent;
    vm.updateFunction = null;
    vm.hasOmieCustomerSelector = HasOmieCustomerSelector;
    vm.searchCustomerByName = searchCustomerByName;

    function searchCustomerByName(searchTerm) {
      if (!searchTerm || searchTerm.length < 3) {
        return $q.resolve([]);
      }

      var startingAppIdToLoad = Variables.startingAppIdToLoad;
      var requests = {
        customersbyName: _loadCustomersByCustumerName(searchTerm, startingAppIdToLoad),
        customersbyFantasyName: _loadCustomersByCustumerFantasyName(searchTerm, startingAppIdToLoad)
      };
      $q.all(requests).then(function (data) {
        var customers = data.customersbyName.concat(data.customersbyFantasyName);
        customers = _.uniq(customers, 'codigo_cliente_omie');
        vm.omieCustomers = customers.map(function (omieCustomer) {
          var displayName = omieCustomer.razao_social + (omieCustomer.nome_fantasia ? ' (' + omieCustomer.nome_fantasia + ')' : '');
          return Object.assign({}, omieCustomer, {
            displayName: displayName,
            translate: displayName,
            value: Object.assign({}, omieCustomer, { displayName: displayName }),
          });
        });

        setTimeout(function () {
          $scope.$apply();
        }, 100);
      });
      return vm.omieCustomers;
    }

    function _loadCustomersByCustumerName(customerName, startingAppIdToLoad) {
      return omieApi.customers.search({ 'razao_social': customerName }, startingAppIdToLoad).then(function (customers) {
        if(customers){
          return customers;
        }

        return [];
      });
    }

    function _loadCustomersByCustumerFantasyName(customerName, startingAppIdToLoad) {
      return omieApi.customers.search({ 'nome_fantasia': customerName }, startingAppIdToLoad)
        .then(function (customers) {
          if(customers){
            return customers;
          }

          return [];
        });
    }

    if(HasOmieCustomerSelector){
      vm.omieCustomers = Variables.customers.map(function (customer) {
        return {value: customer};
      });
    }

    if (vm.variables && vm.variables.updateFunction) {
      vm.updateFunction = updateFunction;
    }

    vm.handleRightButton = handleRightButton;
    vm.handleLeftButton = handleLeftButton;
    vm.closeDialog = closeDialog;

    vm.iconPath = IconPath;
    vm.titleIconPath = TitleIconPath;
    vm.large = Large;

    function updateFunction() {
      if (vm.variables) {
        var isDisabled = vm.variables.updateFunction(vm.variables.option.description);
        return !isDisabled;
      }
    }

    function closeDialog() {
      if (HandleClose) {
        HandleClose();
      }

      $mdDialog.hide();
    }

    function handleRightButton() {
      closeDialog();

      if (HandleRightButton) {
        if (HasOmieAccountSelector) {
          return HandleRightButton(vm.selectedAccount);
        }

        if(HasOmieCustomerSelector) {
          return HandleRightButton(vm.selectedCustomer);
        }

        HandleRightButton();
      }
    }

    function handleLeftButton() {
      if (!DontCloseModalOnLeftButtonHandler) {
        closeDialog();
      }

      if (HandleLeftButton) {
        if (HasOmieAccountSelector) {
          return HandleLeftButton(vm.selectedAccount);
        }

        HandleLeftButton();
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('fcLabelActivity', fcLabelActivity);

    function fcLabelActivity() {
        return {
            restrict: 'E',
            template: '<span class="ml-16 text-boxed {{colorBg}}-bg white-fg ng-binding">{{label}}</span>',
            scope: {
                status: '=',
                label: '='
            },
            link: function (scope, element, attrs) {
                var colorBg;

                if (scope.status == '0') {
                    colorBg = 'fa-envelope';
                }

                scope.colorBg = 'red';
            }
        };
    }

}).call(this);


(function () {
    'use strict';

    angular
    .module('app.core')
    .directive('infiniteScroll', ['$parse', infiniteScroll]);

    /** @ngInject */
    function infiniteScroll($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var fn = $parse(attrs.infiniteScroll);
                var el = element[0];

                element.on('scroll', function (event) {
                    if (el.scrollTop + el.offsetHeight >= el.scrollHeight) {
                        scope.$apply(function () {
                            fn(scope, { $event: event });
                        });
                    }
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('fcImportJsonButton', fcImportJsonButton);

    function fcImportJsonButton() {
        return {
            restrict     : 'E',
            templateUrl  : 'app/core/directives/fc-import-template-button/templates/button.html',
        };
    }

}).call(this);


(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcImageInput', fcImageInput);

  /*
    name: string
    ngModel: string (image url)
    imageFile: File (output file)
    inputControl: form control
    withoutRemove: boolean
    ngfAccept: string
    width: string
    height: string
    imgCustomClass: string
    isDisabled: boolean
    maxSize: string
    isDisabled: boolean
    onChange: function
    onRemoveImage: function
  */
  /** @ngInject */
  function fcImageInput() {
    var controller = function ($scope, $timeout, $window, $mdToast, $translate) {
      var vm = this;

      vm.imageFile = null;
      vm.ngfAccept = $scope.ngfAccept ? $scope.ngfAccept : 'image/*';
      vm.maxSize = $scope.maxSize ? $scope.maxSize : '2MB';
      vm.isDisabled = $scope.isDisabled;
      vm.withoutRemove = $scope.withoutRemove;
      vm.validateImage = validateImage;

      function validateImage(file) {
        $timeout(function () {
          if (file.$error === 'maxSize') {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('CORE.FC_IMAGE_INPUT'))
            );
            return false;
          }
          vm.imageFile = file;
        }, 500);
      }

      $scope.$watch('imageFile', function () {
        vm.imageFile = $scope.imageFile;
      });

      vm.fileChanged = fileChanged;
      vm.viewOriginalImage = viewOriginalImage;
      vm.isChanged = false;

      function fileChanged() {
        $scope.imageFile = vm.imageFile;
        vm.isChanged = true;
        $scope.onChange({ value: vm.imageFile });
      };

      function viewOriginalImage(attachment) {
        $window.open(attachment, '_blank');
      }

      vm.removeImage = removeImage;
      function removeImage() {
        if (vm.isDisabled) { return; }
        vm.imageFile = null;
        $scope.imageFile = null;
        $scope.ngModel = null;

        if ($scope.inputControl) {
          $scope.inputControl.$setDirty();
        }
        $scope.onRemoveImage();
      }
    };

    return {
      restrict: 'E',
      require: ['ngModel'],
      scope: {
        name: '@',
        disabled: '=',
        imageFile: '=',
        inputControl: '=',
        withoutRemove: '=',
        ngModel: '=',
        isDisabled: '=',
        width: '@',
        height: '@',
        ngfAccept: '@',
        imgCustomClass: '@',
        maxSize: '@',
        onChange: '&',
        onRemoveImage: '&'
      },
      templateUrl: 'app/core/directives/fc-image-input/template/fc-image-input.html',
      controller: controller,
      controllerAs: 'vm'
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('fcExportPrintButton', fcExportPrintButton);

    function fcExportPrintButton() {
        return {
            restrict     : 'E',
            templateUrl  : 'app/core/directives/fc-export-print-button/templates/button.html'
        };
    }

}).call(this);


(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('fcExportExcelButton', fcExportExcelButton);

    function fcExportExcelButton() {
        return {
            restrict     : 'E',
            templateUrl  : 'app/core/directives/fc-export-excel-button/templates/button.html',
        };
    }

}).call(this);


(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('fcExportCsvButton', fcExportCsvButton);

    function fcExportCsvButton() {
        return {
            restrict     : 'E',
            templateUrl  : 'app/core/directives/fc-export-csv-button/templates/button.html',
        };
    }

}).call(this);


(function () {
  'use strict';

  angular
  .module('app.core')
  .factory('fcExportAlertService', fcExportAlertService);

  /** @ngInject */
  function fcExportAlertService($mdDialog, $mdToast, $translate, $localStorage) {
    var neverShowExportAlertKey = 'NEVER_SHOW_EXPORT_ALERT';

    return {
      show: show,
      setToNeverShowAnyMore: setToNeverShowAnyMore,
      canShowExportAlert: canShowExportAlert
    };

    function show(options, alertType) {
      if (!canShowExportAlert()) {
        return $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('CUSTOMERS.TABLE.SPREADSHEET_SENT', {
              email: options.email
            }))
            .hideDelay(5000)
        );
      }
      var alertTemplates = {
        migration: 'migration-alert.html',
        export: 'export-alert.html'
      };
      var alertTemplate = alertTemplates[alertType] || alertTemplates.export;
      return $mdDialog.show({
				controller: 'FcExportAlertController',
				controllerAs: 'vm',
				templateUrl: 'app/core/directives/fc-export-alert/templates/' + alertTemplate,
				clickOutsideToClose: true,
        hasBackdrop: false,
        escapeToClose: false,
        autoWrap: false,
        disableParentScroll: false,
				locals: {
					email: options.email,
          title: options.title,
          hasSendedToEmail: options.hasSendedToEmail,
          isToShowButtons: options.isToShowButtons
				}
			});
    }

    function setToNeverShowAnyMore() {
      $localStorage.setObject(neverShowExportAlertKey, 'true');
    }

    function canShowExportAlert() {
      var response = $localStorage.getObject(neverShowExportAlertKey);
      return response === 'true' ? false : true;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.customers')
    .controller('FcExportAlertController', FcExportAlertController);

  /** @ngInject */
  function FcExportAlertController($mdDialog, EnvironmentConfig, fcExportAlertService, email, title, hasSendedToEmail, isToShowButtons) {
    var vm = this;
    vm.email = email;
    vm.title = title;
    vm.hasSendedToEmail = hasSendedToEmail;
    vm.isToShowButtons = isToShowButtons;

    vm.goToExportPage = goToExportPage;
    vm.dontSeeAnymore = dontSeeAnymore;
    vm.close = close;

    function goToExportPage() {
      window.open(EnvironmentConfig.mordor2Url + 'exportacoes');
      vm.close();
    }

    function dontSeeAnymore() {
      fcExportAlertService.setToNeverShowAnyMore();
      vm.close();
    }

    function close() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcError', fcError);

  /*
    inputErrors: formName.inputName.$error
    errorsToWatch: [{
      name: string,
      translate: string,
      translateValues: string (optional),
      custom: any (optional)
    }]
    ngShow: boolean
    customClass: string
  */
  /** @ngInject */
  function fcError() {
    var controller = function ($scope, _) {
      var vm = this;
    };

    return {
      restrict: 'E',
      require: ['ngModel'],
      scope: {
        inputErrors: '=',
        ngShow: '=',
        errorsToWatch: '=',
        customClass: '@'
      },
      templateUrl: 'app/core/directives/fc-error/template/fc-error.html',
      controller: controller
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcDialogError', fcDialogError);

  /*
    text: string
  */
  /** @ngInject */
  function fcDialogError() {
    var controller = function ($scope, _) {
      var vm = this;

      vm.closeError = function () {
        $scope.isVisible = false;
      };
    };

    return {
      restrict: 'E',
      require: ['ngModel'],
      scope: {
        text: '@',
        isVisible: '='
      },
      templateUrl: 'app/core/directives/fc-dialog-error/template/fc-dialog-error.html',
      controller: controller,
      controllerAs: 'vm'
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcDateInput', fcDateInput);

  /** @ngInject */
  function fcDateInput() {
    return {
      restrict: 'E',
      scope: {
        datemodel: '=',
        required: '='
      },
      templateUrl: 'app/core/directives/fc-date-input/fc-date-input.html',
      controller: 'FcDateInputController as vm'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('FcDateInputController', FcDateInputController);

  function FcDateInputController(moment, $scope) {
    var vm = this;
    vm.today = moment().startOf('day').toDate();
    vm.dateModel = $scope.datemodel ? $scope.datemodel : vm.today;
    vm.dateTextInput = document.querySelector('.md-datepicker-input-container input');
    vm.placeholderIsOnCenter = vm.dateModel.length === 0 ? true : false;
    vm.movePlaceholderToTop = movePlaceholderToTop;
    vm.movePlaceholderToCenter = movePlaceholderToCenter;
    vm.validateDate = validateDate;
    vm.maskDate = maskDate;
    vm.setValidTime = setValidTime;
    vm.errors = [];

    _initialize();

    function _initialize() {
      if (!vm.dateTextInput) {
        return;
      };

      vm.dateTextInput.addEventListener('input', function (event) {
        maskDate(event);
        validateDate();
        if (vm.errors.length) {
          $scope.datemodel.$invalid = true;
        } else {
          setValidTime();
        }
      });
    }

    function _addZeroBeforeEnteredValue(cursorPosition) {
      vm.dateTextInput.value = vm.dateTextInput.value.slice(0, cursorPosition - 1) + "0" + vm.dateTextInput.value.slice(cursorPosition - 1);
    };

    function _addSlashToDateValue() {
      vm.dateTextInput.value = vm.dateTextInput.value.replace(/\D/g, '').replace(/(\d{2})(\d)/, '$1/$2').replace(/(\d{2})(\d)/, '$1/$2');
    };

    function maskDate(event) {
      if (event.inputType === 'deleteContentBackward') {
        return;
      }

      var cursorPosition = vm.dateTextInput.selectionStart;
      var nextCharacter = vm.dateTextInput.value.charAt(cursorPosition);
      var isNextCharacterSlash = nextCharacter === '/';
      var dateStringArray = vm.dateTextInput.value.split('/');
      var isMissingDayOrMouth = dateStringArray[0].length === 3;

      if (isNextCharacterSlash && vm.dateTextInput.value.length === 9) {
        return;
      }

      if (dateStringArray.length === 2 && isMissingDayOrMouth) {
        _addZeroBeforeEnteredValue(cursorPosition);
      }

      _addSlashToDateValue();

      if (vm.dateTextInput.value.length > 10) {
        vm.dateTextInput.value = vm.dateTextInput.value.slice(0, 10);
      }
    };

    function setValidTime() {
      delete $scope.datemodel.$invalid;
      if (!vm.dateTextInput.value && !$scope.required) {
        $scope.datemodel = null;
        return;
      }
      $scope.datemodel = vm.dateModel;
    };

    function validateDate(dateHasSelectedByTheDatepicker) {
      var date = moment(vm.dateTextInput.value, "DD/MM/YYYY");
      var incompleteDate = vm.dateTextInput.value.length < 10;
      vm.errors = [];

      if (dateHasSelectedByTheDatepicker && vm.dateModel) {
        $scope.datemodel = moment(vm.dateModel, "DD/MM/YYYY");
        return;
      }

      if (!vm.dateTextInput.value && !$scope.required) {
        return;
      }

      if (!vm.dateTextInput.value && $scope.required) {
        vm.errors.push('empty');
        return;
      }

      if (!date.isValid() || incompleteDate) {
        vm.errors.push('invalid');
        return;
      }

      if (date.isBefore(vm.today)) {
        vm.errors.push('retroactive');
      }

      vm.dateModel = date;
    };

    function movePlaceholderToTop() {
      vm.placeholderIsOnCenter = false;
    };

    function movePlaceholderToCenter() {
      if (vm.dateTextInput.value.length === 0) {
        vm.placeholderIsOnCenter = true;
      }
    };
  }
})();

(function () {
    'use strict';

    angular
      .module('app.core')
      .directive('fcColorPicker', fcColorPicker);

    function fcColorPicker() {
      var controller = function ($scope, $mdColorPalette) {
        var vm = this;

        vm.mainVariantColor = '500';
        vm.selectedColor = null;
        vm.colors = $mdColorPalette;
        vm.selectColor = selectColor;

        function selectColor(color, variant) {
          $scope.ngChange();

          if (!$scope.disabled) {
            if (variant === vm.mainVariantColor) {
              color.$$expanded = !color.$$expanded;
            }
            $scope.ngModel = color[variant].hex;
          }
        }
      };

      return {
        restrict: 'E',
        require: ['ngModel'],
        scope: {
          name: '@',
          ngModel: '=',
          ngChange: '&',
          required: '@',
          disabled: '='
        },
        templateUrl: 'app/core/directives/fc-color-picker/template/color-picker.html',
        controller: controller,
        controllerAs: 'vm'
      };
    }

  }).call(this);
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcCard', fcCard);

  /** @ngInject */
  function fcCard()
  {
    return {
      restrict   : 'E',
      scope      : {
        icon: '@',
        title: '@',
        description: '@',
        configuration: '=',
        openFunction: '&',
        new: '@?'
      },
      templateUrl: 'app/core/directives/fc-card/fc-card.html'
    };
  }
})();

(function () {
  'use strict';

  angular
      .module('app.core')
      .directive('fcCallToActionCreateNew', fcCallToActionCreateNew);

  function fcCallToActionCreateNew() {
      return {
          restrict: 'E',
          scope: {
            message: '@',
            link: '@',
            action: '&'
          },
          templateUrl  : 'app/core/directives/fc-call-to-action-create-new/templates/index.html',
      };
  }

}).call(this);


(function () {
  'use strict';

  angular.module('app.core').directive('fcBox', fcBox);

  function controller($scope) {
    var vm = this;
    vm.currentWidth = 0;

    $scope.$watch('progressUsing', function () {
      setProgressPercentage();
    });

    function setProgressPercentage() {
      if (!$scope.progressUsing || !$scope.progressLimit) {
        return;
      }
      var currentWidth = (Number($scope.progressUsing) / Number($scope.progressLimit)) * 100;
      vm.currentWidth = currentWidth + '%';
    }
  }

  function fcBox() {
    return {
      restrict: 'E',
      scope: {
        headerTitle: '=',
        buttonText: '=',
        buttonClick: '&',
        progressUsing: '=',
        progressLimit: '=',
        isRenewal: '=',
        type: '@',
      },
      controller: controller,
      templateUrl: 'app/core/directives/fc-box/template/fc-box.html',
      controllerAs: 'vm',
      transclude: true,
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('fcAutocomplete', fcAutocomplete);

  /*
   focusId: string
   options: [any]
   inputControl: {},
   ngChange: function,
   ngModel: any
   searchTerm: string
   errorsToWatch: [{ name: string, translate: string, translateValues: { } }],
   label: string
   inputName: string
   isRequired: boolean
   isDisabled: boolean
   searchFunction: (string) => {}
   trackBy: string
   debounce: number
   no-animation: boolean
  */
  /** @ngInject */
  function fcAutocomplete() {
    var controller = function (focus, $rootScope, $scope, _) {
      var vm = this;

      $scope.searchFunction = _.debounce($scope.searchFunction, parseInt($scope.debounce) || 600);

      vm.loading = null;
      vm.showOptions = true;
      vm.isInputDisabled = $scope.ngModel ? true : false;

      vm.clearList = clearList;
      vm.selectedItemChange = selectedItemChange;
      vm.setInputTouched = setInputTouched;
      vm.focusIfWanted = focusIfWanted;
      vm.deselect = deselect;

      $rootScope.$watch('loadingProgress', function (newValue) {
        vm.loading = newValue;
      });

      $scope.$watch('ngModel', function () {
        if (!$scope.ngModel) {
          vm.clearList();
          vm.isInputDisabled = false;
        } else {
          vm.isInputDisabled = true;
          vm.selectedItemChange(null, $scope.ngModel);
        }
        $scope.ngChange();
      });

      if ($scope.ngModel) {
        $scope.searchTerm = $scope.trackBy ? $scope.ngModel[$scope.trackBy] : $scope.ngModel;
        $scope.isInputDisabled = true;
      }

      function deselect() {
        var isToDeselect = $scope.clickToRemove && $scope.ngModel && $scope.isInputDisabled;
        if (!isToDeselect) { return; }
        clearList();
      }

      function clearList() {
        $scope.ngModel = null;
        vm.showOptions = true;
      };

      function selectedItemChange($event, option) {
        $scope.isInputDisabled = true;
        $scope.searchTerm = $scope.trackBy ? option[$scope.trackBy] : option;
        $scope.ngModel = option;
      };

      function setInputTouched() {
        if ($scope.inputControl) {
          $scope.inputControl.$setTouched();
        }
      };

      function focusIfWanted() {
        if ($scope.focusId) {
          focus($scope.focusId);
        }
      }
    };

    return {
      restrict: 'E',
      require: ['ngModel', 'ngChange'],
      scope: {
        focusId: '@',
        options: '=',
        inputControl: '=',
        ngModel: '=',
        searchTerm: '=',
        errorsToWatch: '=',
        isDisabled: '=',
        label: '@',
        inputName: '@',
        isRequired: '=',
        trackBy: '@',
        debounce: '@',
        translate: '@',
        noAnimation: '=',
        ngChange: '&',
        searchFunction: '&',
        clickToRemove: '='
      },
      templateUrl: 'app/core/directives/fc-autocomplete/template/fc-autocomplete.html',
      controller: controller,
      controllerAs: 'vm'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('corporateCustomerRecurrenceValidator', corporateCustomerRecurrenceValidator);

  function corporateCustomerRecurrenceValidator() {
    return {
      require: 'ngModel',
      scope: {
        selectedCustomer: '='
      },
      link: function (scope, elm, attrs, ctrl) {
        ctrl.$setTouched();
        ctrl.$setDirty();
        ctrl.$validators.corporateCustomerRecurrenceValidator = function () {
          var isCorporateCustomer = scope.selectedCustomer && scope.selectedCustomer.metadata && scope.selectedCustomer.metadata.callbacks && scope.selectedCustomer.metadata.callbacks.includes('sammathnaur');
          if (!isCorporateCustomer) {
            return true;
          }

          var featureAllowCompanyCreateRecurrence = scope.selectedCustomer && scope.selectedCustomer.metadata && scope.selectedCustomer.metadata.featureAllowCompanyCreateRecurrence;
          if (featureAllowCompanyCreateRecurrence) {
            return true;
          }

          return false;
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('corporateCustomerDisclaimer', corporateCustomerDisclaimer);

  /** @ngInject */
  function corporateCustomerDisclaimer() {
    return {
      restrict: 'E',
      scope: {
        customerName: '=',
        customClass: '@'
      },
      templateUrl: 'app/core/directives/corporate-customer-disclaimer/corporate-customer-disclaimer.html'
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('app.tasks')
  .controller('VideoTutorialController', VideoTutorialController);

  /** @ngInject */
  function VideoTutorialController($mdDialog, $sce, videoUrl) {
    var vm = this;
    vm.videoUrl = $sce.trustAsResourceUrl(videoUrl);
    vm.closeDialog = closeDialog;

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('app.tasks')
  .controller('LaunchVideoController', LaunchVideoController);

  /** @ngInject */
  function LaunchVideoController($mdDialog, $sce, videoUrl, title, message) {
    var vm = this;

    vm.title = title;
    vm.message = message;
    vm.videoUrl = $sce.trustAsResourceUrl(videoUrl);
    vm.closeDialog = closeDialog;

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .controller('FormQuestionsController', FormQuestionsController);

  /** @ngInject */
  function FormQuestionsController(
    $mdDialog, $mdToast, $translate, authenticatedUser, locals, moment, uploadApi,
    attachmentsUtils, ordersApi, $timeout, msUtils, $q, _, formsApi, $scope, $rootScope,
    FcModalService, vehiclesUsageApi, formsApiGraphQL
  ) {

    var vm = this;
    vm.form = null;
    vm.equipment = null;
    vm.order = null;
    vm.vehicleUsage = null;
    vm.pictures = {};
    vm.formQuestionsForm = {};
    vm.initialFilePath = '';
    vm.signatures = [];
    vm.picturesToUpload = { questions: [], uploadInfos: [] };
    vm.multiplePicturesToUpload = { questions: [], uploadInfos: [], multiplePictureIndexes: [] };
    vm.multiplePictures = {};
    vm.hasMultiplePictureInvalidQuestion = false;
    vm.checkQuestions = [];

    vm.saveForm = saveForm;
    vm.closeDialog = closeDialog;
    vm.reloadFormAnswer = reloadFormAnswer;
    vm.setPictureAnswerPreview = setPictureAnswerPreview;
    vm.setMultiplePicturesAnswerPreview = setMultiplePicturesAnswerPreview;
    vm.deletePictureAnswer = deletePictureAnswer;
    vm.deleteMultiplePictureAnswer = deleteMultiplePictureAnswer;
    vm.clearQuestionSignature = clearQuestionSignature;
    vm.satisfyQuestionCondition = satisfyQuestionCondition;
    vm.archiveEquipmentForm = archiveEquipmentForm;
    vm.unarchiveEquipmentForm = unarchiveEquipmentForm;
    vm.closeAndSaveDialog = closeAndSaveDialog;
    vm.confirmSignatures = confirmSignatures;
    vm.answeredCheckboxes = answeredCheckboxes;
    vm.formatTime = /^([01]\d|2[0-3]):([0-5]\d)$/;

    _initialize();

    function _initialize() {
      vm.form = angular.copy(locals.form);
      vm.formRowId = vm.form.formId;
      vm.order = locals.order ? angular.copy(locals.order) : null;
      vm.vehicleUsage = locals.vehicleUsage ? angular.copy(locals.vehicleUsage) : null;
      vm.equipment = locals.equipment ? angular.copy(locals.equipment) : null;
      vm.isEditing = locals.editForm;
      vm.initialFilePath = vm.order ? '/orders/' + vm.order.id + '/forms/' + vm.form.id + '/' : '';

      if (!locals.editForm) {
        resetFormAnswers();
        _getFormById(vm.form.id).then(function (formResponse) {
          vm.form = formResponse;
          _.forEach(vm.form.questions, function (question) {
            _formatQuestions(question);
            if (question.type === "multiple-picture") {
              _verifyFormMultiplePictureQuestionValidity(question, null);
            }
          });
        });
      }

      if (locals.editForm) {
        var hasFormQuestions = vm.form.questions && vm.form.questions.length;
        if (!hasFormQuestions) {
          _getFormById(vm.form.id).then(function (formResponse) {
            vm.form = formResponse;
            _.forEach(vm.form.questions, function (question) {
              _formatQuestions(question);
              _setDateValue(question);
            });
          });
        } else {
          _.forEach(vm.form.questions, function (question) {
            _formatQuestions(question);
            _setDateValue(question);
            if (question.type === "multiple-picture") {
              _verifyFormMultiplePictureQuestionValidity(question, null);
            }
          });
        }
      }
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function reloadFormAnswer() {
      $rootScope.loadingProgress = true;
      formsApiGraphQL.getFormsAnswer(vm.form.id)
        .then(function (response) {
          var formAnswer = response;
          formAnswer.metadata = vm.form.metadata;
          formAnswer.equipment = vm.form.equipment;
          formAnswer.order = vm.form.order;
          formAnswer.reference = vm.form.reference;
          vm.form = formAnswer;
          _.forEach(vm.form.questions, function (question) {
            _formatQuestions(question);
            _setDateValue(question);
          });
        })
        .finally(function () { $rootScope.loadingProgress = false; });
    }

    function saveForm(initialForm) {
      $rootScope.loadingProgress = true;
      var isArchiving = initialForm ? true : false;
      var form = initialForm || vm.form;

      if (locals.editForm) {
        return uploadSignatures()
          .then(function (signaturesResponse) {
            _setSignaturesAnswers(form.questions, signaturesResponse);

            _uploadPicturesAndUpdateAnswers(function () {
              _uploadMultiplePicturesAndUpdateAnswers(function () {
                form.updatedBy = authenticatedUser.profile.name;
                form.updatedAt = new Date().toISOString();
                form.questions = _.forEach(form.questions, function (question) {
                  question = formatQuestionWithOptions(question);
                  _formatQuestionAnswers(question);
                });

                _saveOrEditForm(form, true, function (response) {
                  vm.formQuestionsForm.$setPristine();
                  if (isArchiving) {
                    var message = form.archived ? $translate.instant('TASKS.TOASTS.FORMS.FORM_UPDATED.ARCHIVED') : $translate.instant('TASKS.TOASTS.FORMS.FORM_UPDATED.UNARCHIVED');
                  } else {
                    var message = $translate.instant('TASKS.TOASTS.FORMS.FORM_UPDATED.SUCCESS', {
                      formName: response.name,
                      action: $translate.instant('TASKS.TOASTS.FORMS.FORM_UPDATED.SAVE')
                    });
                  }

                  $mdToast.show(
                    $mdToast.simple()
                      .textContent(message)
                      .hideDelay(2000)
                  );

                  var event = new CustomEvent('reloadFormsEvent');
                  document.dispatchEvent(event);

                  vm.closeDialog();
                });

                $rootScope.loadingProgress = false;
              });
            });
          });
      }

      form.status = 'done';
      form.reference = form.id;
      form.completedAt = moment().utc().format();
      form.id = msUtils.uuidGenerator();

      if (!form.createdBy) {
        form.createdBy = authenticatedUser.profile.name;
      }

      _setAnswers();

      var equipmentId = vm.equipment && vm.equipment.id;
      if (equipmentId) {
        form.equipment = {
          id: equipmentId
        };
      }

      uploadSignatures()
        .then(function (signaturesResponse) {
          _setSignaturesAnswers(vm.form.questions, signaturesResponse);

          _uploadPicturesAndUpdateAnswers(function () {
            _uploadMultiplePicturesAndUpdateAnswers(function () {
              _.forEach(form.questions, function (question) {
                question = formatQuestionWithOptions(question);
                _formatQuestionAnswers(question);
              });

              _saveOrEditForm(form, false, function (response) {
                vm.formQuestionsForm.$setPristine();
                var message = $translate.instant('TASKS.TOASTS.FORMS.FORM_CREATED.CREATED', {
                  formName: response.name,
                });

                $mdToast.show(
                  $mdToast.simple()
                    .textContent(message)
                    .hideDelay(2000)
                );

                var event = new CustomEvent('reloadFormsEvent');
                document.dispatchEvent(event);

                $rootScope.loadingProgress = false;
                vm.closeDialog();
              });
            });
          });
        });
      }

    function _getFormById(formId) {
      if (!formId) { return; }
      if (vm.order && vm.order.id) { return formsApi.get(formId, { include: 'questions,questions.options' }); }
      if (vm.vehicleUsage && vm.vehicleUsage.id) { return vehiclesUsageApi.vehicleForm(vm.form.formId, vm.vehicleUsage.id, vm.form.type); }
    }

    function _saveOrEditForm(form, isEditing, callback) {
      if (form) {
        _.forEach(form.questions, function (question) {
          if (question.hasOwnProperty('showQuestion')) {
            delete question.showQuestion;
          }
        });
      }

      var isOrderForm = !!(vm.order && vm.order.id);
      if (isOrderForm) {
        _saveOrEditOrderForm(form, isEditing, callback);
      } else {
        _saveOrEditVehicleUsageForm(form, callback);
      }
    }

    function _saveOrEditOrderForm(form, isEditing, callback) {
      if (isEditing) {
        ordersApi.updateForm(vm.order.id, form).then(function (response) {
          callback(response);
        })
          .catch(function () {
            $rootScope.loadingProgress = false;
            vm.closeDialog();
          });
      } else {
        ordersApi.saveForm(vm.order.id, form).then(function (response) {
          callback(response);
        })
          .catch(function () {
            $rootScope.loadingProgress = false;
            vm.closeDialog();
          });
      }
    }

    function _saveOrEditVehicleUsageForm(form, callback) {
      form.formId = vm.formRowId;
      vehiclesUsageApi.answerVehicleForm(vm.vehicleUsage.id, form).then(function (response) {
        callback(response);
      })
        .catch(function (err) {
          $rootScope.loadingProgress = false;
          vm.closeDialog();
        });
    }

    function _formatQuestions(question) {
      if (question.type === 'checkboxes' && question.answer) {
        var values = question.answer.split('&');
        _setCheckboxesValues(values, question);
      }

      if (question.type === 'signature') {
        question.showPad = false;
      }

      if (question.type === 'unique-checkbox') {
        _setUniqueCheckboxesValues(question);
      }

      if (question.type === 'multiple-picture') {
        _setMultiplePictures(question);
      }
    }

    function _formatQuestionAnswers(question) {
      if (question.type === 'signature') {
        delete question.showPad;
      }

      if (question.type === 'checkboxes') {
        question.answer = _formatCheckboxesAnswer(question);
      }

      if (question.type === 'date' && question.answer) {
        question.answer = new Date(question.answer).toISOString();
      }

      if (question.type === 'multiple-picture' && question.answer) {
        question.answer = _removeEmptyMultiplePictureAnswer(angular.copy(question.answer)).join('&') || '';
      }
    }

    function _setAnswers() {
      for (var index = 0; index < vm.form.questions.length; index++) {
        var question = vm.form.questions[index];
        if (question.type === 'hour' && question.answer) {
          _setHourAnswer(question);
        }
        if (question.type === 'numeric' && question.answer) {
          _setNumericAnswer(question);
        }
      }
    }

    function _setHourAnswer(question) {
      var hourRegex = /^([0-1][0-9]|[2][0-3]):([0-5][0-9])$/;
      var answerHour = question.answer;
      question.answer = null;
      if (hourRegex.test(answerHour)) {
        question.answer = answerHour;
      }
    }

    function _setNumericAnswer(question) {
      if (question.answer) {
        question.answer = question.answer.toString();
      }
    }

    function _setUniqueCheckboxesValues(question) {
      if (question.answer) {
        question.answer = !!question.answer;
      }
    }

    function _setMultiplePictures(question) {
      if (question.answer) {
        question.answer = question.answer.split('&');
        return;
      }
      question.answer = [];
    }

    function _setCheckboxesValues(values, question) {
      _.forEach(values, function (value) {
        _.forEach(question.options, function (option) {
          if (option.value === value) {
            option.answer = true;
          }
        });
      });
    }

    function _setDateValue(question) {
      if (question.type === 'date' && question.answer) {
        question.answer = new Date(question.answer);
      }
    }

    function _formatCheckboxesAnswer(question) {
      var answers = [];
      _.forEach(question.options, function (option) {
        if (option.answer) {
          answers.push(option.value);
        }
      });
      return answers.join('&');
    }

    function _setSignaturesAnswers(questions, signatureResult) {
      if(!signatureResult) { return; }
      _.forEach(questions, function (question) {
        if (question.type === 'signature' && signatureResult[question.position] && signatureResult[question.position].data) {
          question.answer = attachmentsUtils.correctUrl(signatureResult[question.position].data.key);
        }
      });
    }

    function _setPictureAnswer(question, value) {
      question.answer = value;
    }

    function _hasMutiplePictureQuestionAnswer(question) {
      return question.answer && question.answer.length;
    }

    function _verifyFormMultiplePictureQuestionValidity(question, ariaChecker) {
      if (question) { vm.question = question; }
      var hasQuestionAnswer = _hasMutiplePictureQuestionAnswer(question);
      if (hasQuestionAnswer && typeof question.answer === 'string') {
        question.answer = question.answer.split('&');
      }

      var isNotSelected = question ? question['showQuestion'] : true;

      if (vm.form && vm.form.questions.length) {
        var form = angular.copy(vm.form);
        form.questions = form.questions.filter(function (qt) {
            return qt.id === vm.question.id;
          });

        vm.checkQuestions = form.questions;
      }

      if (vm.question.conditions || vm.checkQuestions.length) {
        vm.question.conditions = vm.question.conditions || [];
        vm.question.conditions.forEach(function (condition) {
          if (condition) {
            var element = document.getElementById(condition.value);
            var ariaChecked = element ? element.ariaChecked : false;
            var checked = false;



            if (ariaChecked === 'true') {
              checked = true;
            }

            if (!condition.operator === 'equal') {
              checked = !checked;
            }

            if (!ariaChecker) {
              checked = false;
            }

            isNotSelected = !checked;
          }
        });
      }

      var isMultiplePictureQuestionValid = vm.hasQuestionAnswer || !vm.question.required;
      vm.hasMultiplePictureInvalidQuestion = isNotSelected ? !isNotSelected : !isMultiplePictureQuestionValid;
    }

    function satisfyQuestionCondition(question) {
      var showQuestion = false;

      if (question && !question.conditions.length) {
        question['showQuestion'] = true;
        showQuestion = true;
        return true;
      }

      var response;

      _.forEach(question.conditions, function (condition) {
        var conditionQuestion = condition.question;
        _.forEach(vm.form.questions, function (formQuestion) {
          if ((formQuestion.title === conditionQuestion.title) && !!formQuestion.answer) {
            showQuestion = _questionAnswerSatisfyOperator(condition.operator, formQuestion, condition);
            formQuestion['showQuestion'] = showQuestion;
            var returningshowQuestion = _questionAnswerSatisfyOperator(condition.operator, formQuestion, condition);

            formQuestion['showQuestion'] = returningshowQuestion;
            response = returningshowQuestion;
            return response;
          }
        });
        return response;
      });


      showQuestion = response;
      return showQuestion;
    }

    function _questionAnswerSatisfyOperator(operator, question, condition) {
      var isOperatorSatisfied = false;

      if (operator === 'equal' && question.answer === condition.value) {
        return question.answer === condition.value;
      }

      if (operator === 'not-equal' && question.answer !== condition.value) {
        return item.answer !== condition.value;
      }

      return isOperatorSatisfied;
    }

    function resetFormAnswers() {
      _.forEach(vm.form.questions, function (question) {
        question.answer = null;

        if (question.options) {
          _.forEach(question.options, function (option) {
            option.answer = null;
          });
        }
      });
    }

    function uploadSignatures() {
      if (!vm.signatures.length) { return $q.resolve(null); }

      vm.signaturesUploadRequests = {};
      vm.signatures.forEach(function (signature, index) {
        if (signature && signature.dataUrl && signature.dataUrl.includes('data:')) {
          vm.signaturesUploadRequests[index] = uploadApi.uploadWithPassthrough({
            filename: vm.initialFilePath + 'signature-' + msUtils.uuidGenerator() + '.png',
            imageBase64Encoded: vm.signatures[index].dataUrl
          });
        }
      });

      var hasSignaturesToUpload = Object.keys(vm.signaturesUploadRequests).length;
      return hasSignaturesToUpload ? $q.all(vm.signaturesUploadRequests) : $q.resolve(null);
    }

    function deletePictureAnswer(question) {
      question.answer = null;
    }

    function setPictureAnswerPreview(picture, question) {
      if (picture) {
        var imagePreview = Object.assign(picture, { preview: URL.createObjectURL(picture) });
        _setPictureAnswer(question, imagePreview.preview);

        var filePath = vm.initialFilePath + picture.name.replace(/%20| /g, '');
        vm.picturesToUpload.questions.push(question);
        vm.picturesToUpload.uploadInfos.push({ file: picture, filePath: filePath });
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent($translate.instant('TASKS.TOASTS.FORMS.INCOMPATIBLE_FILE'))
            .hideDelay(3000)
            .theme('error-toast')
        );
      }
    }

    function deleteMultiplePictureAnswer(question, questionIndex, multiplePictureIndex) {
      var multiplePictureFormQuestion = vm.multiplePictures && vm.multiplePictures['question_' + questionIndex];
      var multiplePictureQuestion = multiplePictureFormQuestion && multiplePictureFormQuestion[multiplePictureIndex];

      if (multiplePictureQuestion) {
        multiplePictureQuestion = {};
      }

      vm.multiplePicturesToUpload.questions
        .forEach(function (currentQuestion, currentIndex) {
          var currMultiplePictureIndex = vm.multiplePicturesToUpload.multiplePictureIndexes && vm.multiplePicturesToUpload.multiplePictureIndexes[currentIndex];
          var isSameQuestionId = question && question.id === currentQuestion.id;
          var isSameMultiplePictureIndex = currMultiplePictureIndex === multiplePictureIndex;

          if (isSameQuestionId && isSameMultiplePictureIndex) {
            vm.multiplePicturesToUpload.multiplePictureIndexes.splice(currentIndex, 1);
            vm.multiplePicturesToUpload.uploadInfos.splice(currentIndex, 1);
            vm.multiplePicturesToUpload.questions.splice(currentIndex, 1);
          }
        });

      question.answer.splice(multiplePictureIndex, 1);
      _verifyFormMultiplePictureQuestionValidity(question, null);
      vm.formQuestionsForm.$setDirty();
    }

    function setMultiplePicturesAnswerPreview(picture, question, multiplePictureIndex) {
      if (picture) {
        var imagePreview = Object.assign(picture, { preview: URL.createObjectURL(picture) });
        _setMultiplePictureAnswer(multiplePictureIndex, question, imagePreview.preview);

        var filePath = vm.initialFilePath + picture.name.replace(/%20| /g, '');
        vm.multiplePicturesToUpload.multiplePictureIndexes.push(multiplePictureIndex);
        vm.multiplePicturesToUpload.questions.push(question);
        vm.multiplePicturesToUpload.uploadInfos.push({ file: picture, filePath: filePath });
        _verifyFormMultiplePictureQuestionValidity(question, null);
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent($translate.instant('TASKS.TOASTS.FORMS.INCOMPATIBLE_FILE'))
            .hideDelay(3000)
            .theme('error-toast')
        );
      }
    }

    function _uploadPicturesAndUpdateAnswers(callback) {
      var uploadPicturesRequests = vm.picturesToUpload.uploadInfos
        .map(function (infos) {
          return uploadApi.uploadWithPreSignedPost(infos);
        });

      var hasRequests = uploadPicturesRequests && uploadPicturesRequests.length;
      if (hasRequests) {
        $q.all(uploadPicturesRequests)
          .then(function (response) {
            response.forEach(function (uploadedPicture, index) {
              var hasPictureToUpload = vm.picturesToUpload.questions && vm.picturesToUpload.questions.length;
              if (hasPictureToUpload) {
                var currentQuestion = vm.picturesToUpload.questions[index];
                _setPictureAnswer(currentQuestion, attachmentsUtils.correctUrl(uploadedPicture.path));
              }
            });
          })
          .finally(function () {
            callback();
          });
      } else {
        callback();
      }
    }

    function _uploadMultiplePicturesAndUpdateAnswers(callback) {
      var uploadMultiplePicturesRequests = vm.multiplePicturesToUpload.uploadInfos
        .map(function (infos) {
          return uploadApi.uploadWithPreSignedPost(infos);
        });

      var hasRequests = uploadMultiplePicturesRequests && uploadMultiplePicturesRequests.length;
      if (hasRequests) {
        $q.all(uploadMultiplePicturesRequests)
          .then(function (response) {
            response.forEach(function (uploadedPicture, index) {
              var hasPictureToUpload = vm.multiplePicturesToUpload.questions && vm.multiplePicturesToUpload.questions.length;
              if (hasPictureToUpload) {
                var currentQuestion = vm.multiplePicturesToUpload.questions[index];
                var currentQuestionIndex = vm.multiplePicturesToUpload.multiplePictureIndexes[index];
                _setMultiplePictureAnswer(currentQuestionIndex, currentQuestion, attachmentsUtils.correctUrl(uploadedPicture.path));
              }
            });
          })
          .finally(function () {
            callback();
          });
      } else {
        callback();
      }
    }

    function _setMultiplePictureAnswer(multiplePictureIndex, question, correctAttachmentPath) {
      question.answer[multiplePictureIndex] = correctAttachmentPath;
    }

    function clearQuestionSignature(question, clearAnswer) {
      question.showPad = false;
      if (clearAnswer) {
        vm.signatures[question.position] = null;
        question.answer = null;
        $timeout(function () {
          if (vm.formQuestionsForm) {
            vm.formQuestionsForm.$invalid = true;
          }
        }, 1000);
      }
    }

    function _removeEmptyMultiplePictureAnswer(answers) {
      if (answers && answers.length) {
        return _.filter(answers, function (answer) {
          return !!answer;
        });
      }
      return [];
    }

    vm.initialForm = angular.copy(vm.form);
    function archiveEquipmentForm(ev) {
      vm.initialForm.archived = true;

      FcModalService.open(ev, {
        title: $translate.instant('TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.ARCHIVED.TITLE'),
        content: $translate.instant('TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.ARCHIVED.ARE_YOU_SURE', {
          formName: '"' + vm.initialForm.name + '"'
        }),
        leftButtonText: $translate.instant('TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.ARCHIVED.NO'),
        rightButtonText: $translate.instant('TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.ARCHIVED.YES'),
        handleRightButton: vm.closeAndSaveDialog
      });
    }

    function closeAndSaveDialog() {
      vm.saveForm(vm.initialForm);
    }

    function unarchiveEquipmentForm() {
      vm.initialForm.archived = false;
      vm.saveForm(vm.initialForm);
    }

    function formatQuestionWithOptions(question) {
      question.options = _.reject(question.options, function (option) {
        return option.value === null;
      });
      return question;
    }

    function confirmSignatures(question){
       question.answer = vm.signatures[question.position].dataUrl;
    }

    function answeredCheckboxes(question){
      var answered = _.filter(question.options, function (option) {
        return option.answer;
      });

      question.answer = !!answered.length;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.work-services')
    .controller('WorkServicesController', WorkServicesController);

  /** @ngInject */
  function WorkServicesController(
    account, WorkServicesFilters, productsServicesApi, WorkServicesDialog, $translate, $compile, $document, UtilityFunctions,
    $mdSidenav, $scope, $rootScope, _, dataTableOptions, DTColumnBuilder, CurrencyService, omieServiceMapper, msUtils, $timeout,
    FcModalService, $mdDialog, authenticatedUser, exportsApi, $mdToast, $filter, IntegrationsService, omieApi, FcToastService, LocalDateConvert
  ) {
    var vm = this;

    vm.currentPage = 1;
    vm.totalPages = 1;
    vm.limitPerPage = 100;
    vm.appId = '';
    vm.totalServicesToImport = 0;
    vm.totalServicesImported = 0;
    vm.importedServicesProgress = 0;
    vm.exportProductsServices = exportProductsServices;
    vm.showIntegrationButton = showIntegrationButton;
    vm.openImportOmieDialog = openImportOmieDialog;
    vm.integrations = IntegrationsService.getAll();
    vm.addService = addService;
    vm.editService = editService;

    $scope.$on('work-services:reload', function () {
      vm.reload();
    });

    vm.addService = addService;
    function addService($event) {
      WorkServicesDialog.createService($event, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    }

    vm.editService = editService;
    function editService(ev, id) {
      WorkServicesDialog.editService(ev, { id: id }, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    }


    function _getOmieServicesToImport(appId) {
      return omieApi.services.list({
        nPagina: vm.currentPage,
        nRegPorPagina: vm.limitPerPage
      }, appId)
        .then(function (response) {
          if (!(response && response.data)) { return; }
          var formattedResponse = {
            totalItems: response.data.nTotRegistros,
            services: response.data.cadastros,
            totalPages: response.data.nTotPaginas
          };
          return formattedResponse;
        })
        .catch(function () {
          FcToastService.addWarning({
            hideDelay: 5000,
            position: 'BOTTOM LEFT',
            title: $translate.instant('WORK_SERVICES.IMPORT.LOADING_ERROR'),
            customClass: 'import-error-toast',
            iconPath: 'assets/icons/icon-service-error.svg',
            errorType: 'import-error-toast',
            noExit: true
          });
        });
    }

    function openImportOmieDialog($event, exportType) {
      if (exportType === 'manual') {
        _openOmieManualImportDialog();
      } else {
        $rootScope.loadingProgress = true;
        FcModalService.open($event, {
          title: $translate.instant('WORK_SERVICES.IMPORT.TITLE', { app: 'Omie' }),
          content: $translate.instant('WORK_SERVICES.IMPORT.CONTENT', { quantity: vm.totalServicesToImport }),
          paddingSmall: true,
          hasOmieAccountSelector: true,
          leftButtonText: $translate.instant('WORK_SERVICES.IMPORT.IMPORT_BUTTON'),
          rightButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
          handleLeftButton: function (account) {
            vm.appId = account.appId;
            _getOmieServicesToImport(account.appId)
            .then(function (response) {
              if (!(response && response.totalItems)) { return _throwDefaultWarning(true); }
              vm.totalPages = response.totalPages;
              vm.totalServicesToImport = response.totalItems;
              $rootScope.loadingProgress = false;
              _openOmieAutomaticImportLoadingModal($event);

              _importAllServices(response.services);
            });
          },
          handleRightButton: function () {
            $rootScope.loadingProgress = false;
          }
        });
      }
    }

    function _importAllServices(currentServicesToImport) {
      if (currentServicesToImport && currentServicesToImport.length) {
        return _importServices(currentServicesToImport);
      }

      _getOmieServicesToImport(vm.appId)
        .then(function (response) {
          var currentServicesToImport = response.services;
          vm.totalPages = response.totalPages;
          _importServices(currentServicesToImport);
        })
        .catch(function () {
          $rootScope.loadingProgress = false;
        });
    }


    function _importServices(currentServicesToImport) {
      _updateAndGetServicesToSaveIntegrationCode(currentServicesToImport).then(function (servicesToSaveInfos) {
        if (!(servicesToSaveInfos && servicesToSaveInfos.length)) {
          return _repeatImportProccessIfNecessary();
        }

        var savingServicePromises = servicesToSaveInfos.map(function (info) {
          return info.promise;
        });

        _updateAllServicesIntegrationCodes(savingServicePromises, servicesToSaveInfos)
          .finally(function () {
            _repeatImportProccessIfNecessary();
          });
      });
    }

    function throttleConcurrent(fn, limit, interval) {
      var queue = [];
      var activeCount = 0;
      var lastRequestTime = Date.now();

      function next() {
        if (queue.length === 0 || activeCount >= limit) {
          return;
        }

        var now = Date.now();
        var timeSinceLastRequest = now - lastRequestTime;

        if (timeSinceLastRequest < interval) {
          setTimeout(next, interval - timeSinceLastRequest);
          return;
        }

        activeCount++;
        lastRequestTime = Date.now();
        var item = queue.shift();
        var resolve = item.resolve;
        var reject = item.reject;
        var args = item.args;
        Promise.resolve(fn.apply(null, args))
          .then(resolve)
          .catch(function (err) {
            if (err && err.status === 504) {
              setTimeout(function () {
                queue.push({ resolve: resolve, reject: reject, args: args });
                next();
              }, 10000);
            } else {
              reject(err);
            }
          })
          .finally(function () {
            activeCount--;
            next();
          });
      }

      return function () {
        var args = Array.prototype.slice.call(arguments);
        return new Promise(function (resolve, reject) {
          queue.push({ resolve: resolve, reject: reject, args: args });
          next();
        });
      };
    }

    var _sendUpdateToOmie = throttleConcurrent(omieApi.services.editIntegrationCode, 3, 60000 / 240);

    function _updateOmieIntegrationCode(servicesGroups, groupIndex) {
      groupIndex = groupIndex || 0;
      var lastArrayIndex = servicesGroups.length - 1;
      $timeout(function () {
        var groupToUpdate = servicesGroups[groupIndex];
        var promises = groupToUpdate.map(function (fieldService) {
          var omieService = omieServiceMapper.toOmie(fieldService);
          return _sendUpdateToOmie(omieService, vm.appId)
            .finally(function () {
              _serviceHasImported();
            });
        });

        Promise.allSettled(promises).then(function () {
          if (groupIndex < lastArrayIndex) {
            groupIndex++;
            _updateOmieIntegrationCode(servicesGroups, groupIndex);
          } else {
            groupIndex = 0;
          }
        });
      }, 1000);
    }

    function _updateAndGetServicesToSaveIntegrationCode(currentServices) {
      return new Promise(function (resolve) {
        var servicesToSaveInfos = [];

        vm.currentServices = currentServices;

        currentServices.forEach(function (service) {
          var fieldControlService = omieServiceMapper.toFieldControl(service);
          fieldControlService.externalAppId = vm.appId;
          if (fieldControlService.integrationId && msUtils.isUuidV4(fieldControlService.integrationId)) {
            _updateFieldService(fieldControlService);
          } else {
            servicesToSaveInfos.push({ promise: productsServicesApi.save(fieldControlService), service: fieldControlService });
          }
        });
        resolve(servicesToSaveInfos);
      });
    }

    function _updateFieldService(fieldControlService) {
      fieldControlService.externalAppId = vm.appId;
      productsServicesApi.put(fieldControlService.integrationId, fieldControlService)
        .catch(function () {
          return _throwDefaultWarning(true);
        })
        .finally(function () {
          _serviceHasImported();
        });
    }

    function _updateAllServicesIntegrationCodes(savingServicesPromises, servicesToSaveInfos) {
      return Promise.all(savingServicesPromises)
        .then(function (createdServices) {
          var servicesToUpdateIntegrationId = omieServiceMapper.groupEqualServicesToUpdateIntegrationCode(createdServices, servicesToSaveInfos);
          var servicesGroupsToUpdateOnOmie = UtilityFunctions.splitItemsByQuantity(servicesToUpdateIntegrationId, 3);
          if (servicesGroupsToUpdateOnOmie && servicesGroupsToUpdateOnOmie.length) {
            _updateOmieIntegrationCode(servicesGroupsToUpdateOnOmie);
          }
        })
        .catch(function (err) {
          _throwDefaultWarning(true);
        });
    }

    function _repeatImportProccessIfNecessary() {
      if (vm.currentPage >= vm.totalPages) {
        _throwDefaultWarning(false);
        $rootScope.loadingProgress = false;
        vm.currentPage = 1;
      } else {
        vm.currentPage++;
        _importAllServices();
      }
    }

    function _openOmieAutomaticImportLoadingModal($event) {
      vm.loadingImportModalId = msUtils.uuidGenerator();
      FcModalService.open($event, {
        title: $translate.instant('WORK_SERVICES.IMPORT.IMPORT_LOADING_TITLE'),
        templateUrl: 'app/main/work-services/sidenavs/import-modal/import-products-services-modal.html',
        modalId: vm.loadingImportModalId,
        eventNameToSubscribe: 'update-imported-services-progress',
        variables: {
          title: $translate.instant('WORK_SERVICES.IMPORT.WAIT_LOADING'),
          progressPercentage: vm.importedServicesProgress,
          totalServicesImported: vm.totalServicesImported,
          totalServicesToImport: vm.totalServicesToImport
        },
        leftButtonText: $translate.instant('WORK_SERVICES.IMPORT.CLOSE')
      }, null);
    }

    function _openOmieManualImportDialog() {
      FcModalService.open(null, {
        title: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.ACCOUNT'),
        content: $translate.instant('WORK_SERVICES.IMPORT.SELECT_THE_ACCOUNT_MANUAL'),
        hasOmieAccountSelector: true,
        paddingSmall: true,
        rightContinueButton: true,
        rightButtonText: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'),
        leftButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
        handleRightButton: function (account) {
          vm.appId = account.appId;
          $mdDialog.show({
            controller: 'OmieManualServicesImportDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/work-services/dialogs/omie-manual-import/omie-manual-import-dialog.html',
            parent: angular.element($document.body),
            clickOutsideToClose: true,
            targetEvent: null,
            escapeToClose: false,
            multiple: true,
            locals: {
              appId: account.appId
            }
          }).then(function () {
            vm.reload();
          });
        }
      });
    }

    function _serviceHasImported() {
      vm.totalServicesImported++;
      vm.importedServicesProgress = (vm.totalServicesImported * 100) / vm.totalServicesToImport;
      $rootScope.$broadcast('update-imported-services-progress', {
        totalServicesImported: vm.totalServicesImported,
        progressPercentage: vm.importedServicesProgress
      });

      if (vm.importedServicesProgress >= 100) {
        $rootScope.loadingProgress = false;
        FcModalService.close(vm.loadingImportModalId);
        vm.reload();
        vm.importedServicesProgress = 0;
        vm.totalServicesImported = 0;
        vm.totalServicesToImport = 0;
        return _throwDefaultWarning(false);
      }
    }

    function _throwDefaultWarning(isError) {
      var toastTitleTranslateKey = isError ? 'UPDATE_ERROR' : 'SUCCESS_AUTOMATIC';
      var toastCustomClass = isError ? 'import-error-toast' : 'import-finished-toast';
      var toastIconPath = isError ? 'assets/icons/icon-service-error.svg' : 'assets/icons/icon-success-circle-green.svg';
      return FcToastService.addWarning({
        hideDelay: 5000,
        position: 'BOTTOM LEFT',
        title: $translate.instant('WORK_SERVICES.IMPORT.' + toastTitleTranslateKey),
        customClass: toastCustomClass,
        iconPath: toastIconPath,
        errorType: toastCustomClass,
        noExit: true
      });
    }

    function exportProductsServices($event) {
      FcModalService.open($event, {
        title: $translate.instant('WORK_SERVICES.EXPORT.TITLE'),
        templateUrl: 'app/main/work-services/templates/export-products-services.html',
        content: $translate.instant('WORK_SERVICES.EXPORT.CONTENT', { email: authenticatedUser.profile.email }),
        variables: {
          confirmActionContent: $translate.instant('WORK_SERVICES.EXPORT.CONFIRM_ACTION_CONTENT')
        },
        rightButtonText: $translate.instant('WORK_SERVICES.EXPORT.YES'),
        leftButtonText: $translate.instant('WORK_SERVICES.EXPORT.NO'),
        handleRightButton: function () {
          var queryOptions = _formatQueryOptions();
          exportsApi.exportFeature('services', {
            graphQL: queryOptions
           }, {
            timezone: moment.tz.guess()
          }).then(function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('WORK_SERVICES.EXPORT.SPREADSHEET_SENT', {
                  email: authenticatedUser.profile.email
                }))
                .hideDelay(5000)
            );
          }).catch(function (err) {
            $mdDialog.hide();
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('WORK_SERVICES.EXPORT.SPREADSHEET_ERROR'))
                .hideDelay(5000)
            );
          });
        },
        handleLeftButton: function () {}
      });
    }

    function showIntegrationButton(appName) {
      if (appName === 'Omie') {
        return vm.integrations.omie;
      }
      return false;
    }

    function _formatQueryOptions() {
      var filterOptions = {
        nameContains: vm.serviceFilters.name || '',
        description: vm.serviceFilters.description || '',
      };

      if (vm.serviceFilters.type !== '-1') {
        filterOptions.type = vm.serviceFilters.type;
      }

      if (vm.serviceFilters.archived !== '-1') {
        filterOptions.archived = !(Number(vm.serviceFilters.archived));
      }

      return filterOptions;
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [];
        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var sort = '';
          if (aoData[2].value && aoData[2].value[0]) {
            var columnOrder = aoData[2].value[0];
            if (columnOrder.dir === 'desc') { sort += '-'; }

            switch (columnOrder.column) {
              case 1:
                sort += 'name';
                break;
              case 4:
                sort += 'value';
                break;
              case 5:
                sort += 'createdAt';
                break;
              default:
                sort = null;
                break;
            }
          }

          var queryOptions = {
            offset: aoData[3].value,
            limit: aoData[4].value,
            sort: '-createdAt'
          };

          if (sort) { queryOptions.sort = sort; }
          var queryParams = {};
          if (vm.serviceFilters) {
            if (vm.serviceFilters.archived === '1') {
              queryParams['archived'] = 'no';
            } else if (vm.serviceFilters.archived === '0') {
              queryParams['archived'] = 'yes';
            }
            if (vm.serviceFilters.name) {
              queryParams['name~~*'] = '*' + vm.serviceFilters.name + '*';
            }
            if (vm.serviceFilters.description) {
              queryParams['description~~*'] = '*' + vm.serviceFilters.description + '*';
            }
            if (vm.serviceFilters.type !== '-1') {
              queryParams['type'] = vm.serviceFilters.type;
            }
          }

          productsServicesApi.search(queryParams, queryOptions).then(function (result) {
            vm.services = result.items;
            vm.totalServices = result.totalItems;
          }).finally(function () {
            fnCallback({
              'draw': aoData[0].value,
              'recordsTotal': vm.totalServices,
              'recordsFiltered': vm.totalServices,
              'data': vm.services
            });
            $rootScope.loadingProgress = false;
          });

        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });
      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        _addCallToActionButton();
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          _addCallToActionButton();
          fixTableHeaders();
        });
      };
    }

    function _addCallToActionButton() {
      $('.call-to-action').remove();

      if (!vm.account.configuration.featureDisableAddProductService) {
        var ctanewService = $compile('<div class="call-to-action">' +
          '<span translate="WORK_SERVICES.TABLE.CREATE_SERVICES_CTA">You can create a new service</span> ' +
          '<a class="cursor-pointer" translate="WORK_SERVICES.TABLE.CREATE_SERVICES_LINK" ng-click="vm.addService($event)">clicking here</a>.' +
          '</div>')(($scope));

        $('.dataTables_empty').append($(ctanewService));
      }
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (isColumnVisible(index)) { visibleColumnsCount++; }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function _getDtColumns() {
      return [
        DTColumnBuilder.newColumn('id', 'id').notVisible(),
        DTColumnBuilder.newColumn(null, $translate.instant('WORK_SERVICES.TABLE.NAME')).renderWith(function (data) {
          var corporateCustomerName = (
            data.metadata &&
            data.metadata.sammathnaur &&
            data.metadata.sammathnaur.account &&
            data.metadata.sammathnaur.account.name
          );

          var corporateCustomerNameFormatted = corporateCustomerName ?
            '<em class="text-light-gray">(' + corporateCustomerName + ')</em>' : '<em>' + '</em>';

          var archivedClass = data.archived ? 'md-red-500-bg' : 'md-green-600-bg',
            archivedText = $translate.instant(data.archived ? 'WORK_SERVICES.TABLE.INACTIVE' : 'WORK_SERVICES.TABLE.ACTIVE'),
            templateHTML = '<div layout="row" layout-align="start center">' +
              '<div class="quantity-indicator ' + archivedClass + '">' +
              '<md-tooltip>' + archivedText + '</md-tooltip>' +
              '</div>' +
              '<span>' + $filter('maxLength')(data.name, 30) + ' ' + corporateCustomerNameFormatted + '</span>' +
              '</div>';
          return templateHTML;
        }).withOption('width', '17%'),
        DTColumnBuilder.newColumn(null, $translate.instant('WORK_SERVICES.TABLE.DESCRIPTION')).renderWith(function (data) {
          var description = data.description;

          if (description) {
            return '<span title="' + data.description + '">' + $filter('maxLength')(data.description, 95) + '</span>';
          }

          return '';
        }).withOption('width', '50%').notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('WORK_SERVICES.TABLE.TYPE')).renderWith(function () {
          return $translate.instant('WORK_SERVICES.MODEL.TYPE.SERVICE');
        }).notSortable().notVisible(),
        DTColumnBuilder.newColumn(null, $translate.instant('WORK_SERVICES.TABLE.VALUE', { currency: CurrencyService.currencySymbol })).renderWith(function (data) {
          var formattedTotal = $filter('currencyFormat')(data.value);
          return formattedTotal;
        }).withOption('width', '10%'),
        DTColumnBuilder.newColumn(null, $translate.instant('WORK_SERVICES.TABLE.CREATED_AT')).renderWith(function (data) {
          var createdAt = (data.metadata && data.metadata.createdAt) || data.createdAt;
          if (!createdAt) { return ''; }

          return LocalDateConvert.formatDate(createdAt, 'date-time');
        }).withOption('width', '10%'),
        DTColumnBuilder.newColumn(null, $translate.instant('WORK_SERVICES.TABLE.ACTIONS')).renderWith(function (data) {
          var eventClick = 'ng-click="vm.editService($event,\'' + data.id + '\')"';
          var isCorporateCustomer = data.metadata && data.metadata.sammathnaur;
          var templateHTML = '';

          if (data.locked && !isCorporateCustomer) {
            templateHTML = '<md-button class="md-icon-button md-button-disabled-css">' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="WORK_SERVICES.TABLE.SERVICE_EDIT_NOT_ALLOWED">Edit</span></md-tooltip>' +
              '</md-button>';
          } else if (isCorporateCustomer) {
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="WORK_SERVICES.TABLE.VIEW">Edit</span></md-tooltip>' +
              '</md-button>';
          } else {
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="WORK_SERVICES.TABLE.EDIT">Edit</span></md-tooltip>' +
              '</md-button>';
          }
          return templateHTML;
        }).notSortable()
        .withOption('width', '5%')
        .withOption('responsivePriority', 1)
      ];
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _initialize() {
      vm.account = account;
      vm.serviceFilters = WorkServicesFilters;
      vm.clearFilters = vm.serviceFilters.clear;
      vm.filteringIsOn = vm.serviceFilters.isOn;
      vm.toggleSidenav = toggleSidenav;
      vm.reload = _.debounce(_reloadDatatable, 1000);
      _startDataTable();
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicles-usage')
    .controller('VehiclesUsageController', VehiclesUsageController);

  /** @ngInject */
  function VehiclesUsageController(
    $translate, DTColumnBuilder, dataTableOptions,
    $compile, $scope, VehiclesUsageDialog,
    vehiclesUsageApi, $mdSidenav, msUtils,
    moment, $rootScope, VehiclesUsageFilters,
    translateService, $mdDialog, exportsApi,
    authenticatedUser, MessageDialog, account, $state,
    $window, EnvironmentConfig, $document,LocalDateConvert
  ) {
    if (!account.configuration.moduleVehiclesEnabled) {
      $window.open(EnvironmentConfig.ereborClientUrl + 'como-funciona/historico-de-uso', '_self');
    }

    $scope.$on('vehicles-usage:reload', function () {
      vm.reload();
    });

    var vm = this;
    var currentLanguage = translateService.getLanguage();
    if (!currentLanguage) {
      currentLanguage = 'pt-br';
    }
    vm.openVideoTutorial = openVideoTutorial;

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [
          {
            isExportButton: true,
            extend: 'csvHtml5',
            className: 'hidden-button',
            filename: msUtils.shortGuidGenerator(),
            text: '.',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
          }
        ];

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var sort = '';
          var sortableColumnsMapper = {
            '5': 'pickupAt',
            '6': 'pickupTravelingDistance',
            '7': 'travelingDistance',
            '8': 'returnedAt',
            '9': 'duration'
          };
          if (aoData[2].value && aoData[2].value[0]) {
            var columnOrder = aoData[2].value[0];

            if (columnOrder && columnOrder.dir && columnOrder.column) {
              var columnOrderName = sortableColumnsMapper[columnOrder.column];
              sort = columnOrderName + '_' + columnOrder.dir;
            }
          }

          var queryOptions = {
            skip: aoData[3].value,
            limit: aoData[4].value,
            sort: sort ? sort : 'createdAt_desc'
          };

          vehiclesUsageApi.search(vm.vehiclesUsageFilters.toSearchOptions(), queryOptions.sort, queryOptions.limit, queryOptions.skip)
            .then(function (result) {
              vm.vehiclesUsage = result.items;
              vm.totalVehiclesUsages = result.totalCount;

              $rootScope.loadingProgress = false;
            })
            .finally(function () {
              fnCallback({
                draw: aoData[0].value,
                recordsTotal: vm.totalVehiclesUsages,
                recordsFiltered: vm.totalVehiclesUsages,
                data: vm.vehiclesUsage
              });

              $rootScope.loadingProgress = false;
            });
        }, 1000);

        config.createdRow = function (row, data) {
          if (data && data.archived) {
            $(row).addClass('disabled-row');
          }

          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });
      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          $('.call-to-action').remove();
          _fixTableHeaders();
        });
      };

      function _fixTableHeaders() {
        $('.dataTables_scrollHeadInner table thead th').each(function () {
          var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
          $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
        });

        var visibleColumnsCount = 1;
        for (var index = 0; index < vm.dtColumns.length; index++) {
          if (_isColumnVisible(index)) { visibleColumnsCount++; }
        }
        $('.dataTables_empty').attr('colspan', visibleColumnsCount);
      }

      function _isColumnVisible(index) {
        if (vm.dtInstance) {
          return vm.dtInstance.DataTable.column(index).visible();
        }
      }

      function _getDtColumns() {
        var columns = [
          DTColumnBuilder.newColumn('id', 'id').notVisible(),
          DTColumnBuilder.newColumn('archived', 'archived').notVisible(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES_USAGE.TABLE.COLUMNS.NAME')).renderWith(function (data) {
            return data.vehicle.name;
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES_USAGE.TABLE.COLUMNS.LICENSE_PLATE')).renderWith(function (data) {
            return data.vehicle.licensePlate;
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES_USAGE.TABLE.COLUMNS.PICKED_UP_BY')).renderWith(function (data) {
            if (data.user) {
              return data.user.name + '<span style="color: #757575" translate="VEHICLES_USAGE.DIALOG.USER"> (Usuário)</span>';
            }
            return data.employee.name + '<span style="color: #757575" translate="VEHICLES_USAGE.DIALOG.EMPLOYEE"> (Colaborador)</span>';
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES_USAGE.TABLE.COLUMNS.PICKED_UP_AT')).renderWith(function (data) {
            return data.pickupAt ? LocalDateConvert.formatDate(data.pickupAt, 'date-time') : '';
          }),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES_USAGE.TABLE.COLUMNS.INITIAL_KM')).renderWith(function (data) {
            var pickupTravelingDistance = 0;
            if (data.pickupTravelingDistance) {
              pickupTravelingDistance = Number.parseInt(data.pickupTravelingDistance);
              pickupTravelingDistance = new Intl.NumberFormat(currentLanguage).format(pickupTravelingDistance);
            }

            return pickupTravelingDistance !== null ? pickupTravelingDistance + " km" : '';
          }),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES_USAGE.TABLE.COLUMNS.TRAVELED_KM')).renderWith(function (data) {
            var travelingDistance = 0;
            if (data.travelingDistance) {
              travelingDistance = Number.parseInt(data.travelingDistance);
              travelingDistance = new Intl.NumberFormat(currentLanguage).format(travelingDistance);
            }

            return travelingDistance !== null? travelingDistance + " km" : '';
          }),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES_USAGE.TABLE.COLUMNS.RETURNED_AT')).renderWith(function (data) {
            return data.returnedAt ? LocalDateConvert.formatDate(data.returnedAt, 'date-time') : '';
          }),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES_USAGE.TABLE.COLUMNS.USAGE_TIME')).renderWith(function (data) {
            if (data.duration) {
              var duration = moment.duration(data.duration, 'milliseconds').locale(currentLanguage).humanize();
              duration = ['segundos'].includes(duration) ? '1 minuto' : duration;
            }

            return duration ? duration : '';
          }),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES_USAGE.TABLE.COLUMNS.ACTIONS')).renderWith(function (data) {
            var eventClick = 'ng-click="vm.openEditVehicleUsageDialog($event,\'' + data.id + '\')"';
            var templateHTML = '<md-button data-cy="historic-edit-button" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left">' +
              '<span translate="VEHICLES_USAGE.EDIT">View</span>' +
              '</md-tooltip>' +
              '</md-button>';
            return templateHTML;
          }).notSortable()
          .withOption('responsivePriority', 1)
        ];

        return columns;
      }
    };

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function openEditVehicleUsageDialog($event, id) {
      VehiclesUsageDialog.editVehicleUsage($event, id, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    };

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function exportData() {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('VEHICLES_USAGE.ALERT.TITLE'))
        .htmlContent($translate.instant('VEHICLES_USAGE.ALERT.CONTENT', { email: authenticatedUser.profile.email }))
        .ok($translate.instant('VEHICLES_USAGE.ALERT.OK'))
        .cancel($translate.instant('VEHICLES_USAGE.ALERT.CANCEL'));

      $mdDialog.show(confirm).then(function () {
        exportsApi.exportFeature('vehicles-usage', {
          graphQL: vm.vehiclesUsageFilters.toSearchOptions()
        }, {
          timezone: moment.tz.guess()
        }).then(function (result) {
          $mdDialog.hide();

          MessageDialog.showToast({
            message: $translate.instant('VEHICLES_USAGE.TOAST.EXPORTED', { email: authenticatedUser.profile.email })
          });

          return result;
        }, function () {
          MessageDialog.showToast({
            message: $translate.instant('VEHICLES_USAGE.TOAST.WAIT')
          });
        });
      });
    }

    function openVideoTutorial() {
      $mdDialog.show({
        controller: 'VideoTutorialController',
        controllerAs: 'vm',
        templateUrl: 'app/core/dialogs/video-tutorial/video-tutorial.html',
        parent: angular.element($document.body),
        clickOutsideToClose: false,
        locals: {
          videoUrl: 'https://www.youtube.com/embed/H8RIaxk4J4Y?modestbranding=1&rel=0'
        }
      });
    }

    function _initialize() {
      vm.vehiclesUsageFilters = VehiclesUsageFilters;

      vm.reload = _.debounce(_reloadDatatable, 1000);
      vm.openEditVehicleUsageDialog = openEditVehicleUsageDialog;
      vm.toggleSidenav = toggleSidenav;
      vm.exportData = exportData;
      vm.clearFilters = vm.vehiclesUsageFilters.clear;
      vm.filteringIsOn = vm.vehiclesUsageFilters.isOn;

      _startDataTable();
    };

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicles')
    .controller('VehiclesController', VehiclesController);

  /** @ngInject */
  function VehiclesController(
    $translate, DTColumnBuilder, dataTableOptions,
    $compile, $scope, VehiclesDialog,
    $mdSidenav, VehiclesFilters, vehiclesApi,
    $rootScope, $mdDialog, $document, accountFeatureFlagsApiGraphQL
  ) {
    var vm = this;
    vm.openVideoTutorial = openVideoTutorial;
    vm.openQrCodeGenerator = openQrCodeGenerator;

    $scope.$on('vehicles:reload', function () {
      vm.reload();
    });

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [];

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var sort = '';
          if (aoData[2].value && aoData[2].value[0]) {
            var columnOrder = aoData[2].value[0];

            if (columnOrder && columnOrder.dir && columnOrder.column) {
              if (columnOrder.column === 6) {
                sort = 'year_' + columnOrder.dir;
              }
            }
          }

          var queryOptions = {
            skip: aoData[3].value,
            limit: aoData[4].value,
            sort: sort ? sort : 'createdAt_desc'
          };

          var vehiclesWhereInput = {};
          if (vm.vehiclesFilters) {
            vehiclesWhereInput = {
              'nameContains': vm.vehiclesFilters.name ? vm.vehiclesFilters.name : null,
              'licensePlateContains': vm.vehiclesFilters.licensePlate ? vm.vehiclesFilters.licensePlate : null,
              'status': vm.vehiclesFilters.status ? vm.vehiclesFilters.status : null,
              'type': vm.vehiclesFilters.type ? vm.vehiclesFilters.type : null,
              'origin': vm.vehiclesFilters.origin ? vm.vehiclesFilters.origin : null,
              'archived': vm.vehiclesFilters.archived ? true : false
            };

            if (vm.vehiclesFilters.archived === null) {
              delete vehiclesWhereInput.archived;
            }
          }

          vehiclesApi.search(vehiclesWhereInput, queryOptions.sort, queryOptions.limit, queryOptions.skip)
            .then(function (result) {
              vm.vehicles = result.items;
              vm.totalVehicles = result.totalCount;
            })
            .finally(function () {
              fnCallback({
                draw: aoData[0].value,
                recordsTotal: vm.totalVehicles,
                recordsFiltered: vm.totalVehicles,
                data: vm.vehicles
              });

              $rootScope.loadingProgress = false;
            });
        }, 1000);

        config.createdRow = function (row, data) {
          if (data && data.archived) {
            $(row).addClass('disabled-row');
          }

          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });
      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        _addCallToActionButton();
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          _addCallToActionButton();
          _fixTableHeaders();
        });
      };

      function _addCallToActionButton() {
        $('.call-to-action').remove();

        var ctaNewVehicle = $compile('<div class="call-to-action">' +
          '<span translate="VEHICLES.TABLE.CREATE_VEHICLE_CTA">You can create a new vehicle</span> ' +
          '<a class="cursor-pointer" translate="VEHICLES.TABLE.CREATE_VEHICLE_LINK" ng-click="vm.openAddVehicleDialog($event)">clicking here</a>.' +
          '</div>')(($scope));

        $('.dataTables_empty').append($(ctaNewVehicle));
      }

      function _fixTableHeaders() {
        $('.dataTables_scrollHeadInner table thead th').each(function () {
          var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
          $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
        });

        var visibleColumnsCount = 1;
        for (var index = 0; index < vm.dtColumns.length; index++) {
          if (_isColumnVisible(index)) { visibleColumnsCount++; }
        }
        $('.dataTables_empty').attr('colspan', visibleColumnsCount);
      }

      function _isColumnVisible(index) {
        if (vm.dtInstance) {
          return vm.dtInstance.DataTable.column(index).visible();
        }
      }

      function _getDtColumns() {
        var columns = [
          DTColumnBuilder.newColumn('id', 'id').notVisible(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES.TABLE.COLUMNS.NAME')).renderWith(function (data) {
            var name = data.name.length > 16 ? data.name.slice(0, 16) + '...' : data.name;
            return name;
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES.TABLE.COLUMNS.LICENSE_PLATE_NUMBER')).renderWith(function (data) {
            return data.licensePlate;
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES.TABLE.COLUMNS.REGISTER')).renderWith(function (data) {
            return data.register;
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES.TABLE.COLUMNS.MODEL')).renderWith(function (data) {
            return data.model.name;
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES.TABLE.COLUMNS.BRAND')).renderWith(function (data) {
            return data.brand.name;
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES.TABLE.COLUMNS.YEAR')).renderWith(function (data) {
            return data.year;
          }),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES.TABLE.COLUMNS.CATEGORY')).renderWith(function (data) {
            return $translate.instant('VEHICLES.MODEL.TYPES_OPTIONS.' + data.type.toUpperCase());
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES.TABLE.COLUMNS.ORIGIN')).renderWith(function (data) {
            return $translate.instant('VEHICLES.MODEL.ORIGINS_OPTIONS.' + data.origin.toUpperCase());
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES.TABLE.COLUMNS.DISPONIBILITY')).renderWith(function (data) {
            return $translate.instant('VEHICLES.MODEL.STATUS_OPTIONS.' + data.status.toUpperCase());
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('VEHICLES.TABLE.COLUMNS.ACTIONS')).renderWith(function (data) {
            var eventClick = 'ng-click="vm.openEditVehicleDialog($event,\'' + data.id + '\')"';
              var templateHTML = '<md-button class="md-icon-button"' + eventClick + '>' +
                '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
                '<md-tooltip md-direction="left">' +
                '<span translate="VEHICLES.EDIT">View</span>' +
                '</md-tooltip>' +
                '</md-button>';
            return templateHTML;
          })
          .withOption('width', '10%')
          .notSortable()
          .withOption('responsivePriority', 1)
        ];

        return columns;
      }
    };

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _openAddVehicleDialog($event) {
      VehiclesDialog.createVehicle($event, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    };

    function _openEditVehicleDialog($event, id) {
      VehiclesDialog.editVehicle($event, id, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    };

    function openVideoTutorial() {
      $mdDialog.show({
        controller: 'VideoTutorialController',
        controllerAs: 'vm',
        templateUrl: 'app/core/dialogs/video-tutorial/video-tutorial.html',
        parent: angular.element($document.body),
        clickOutsideToClose: false,
        locals: {
          videoUrl: 'https://www.youtube.com/embed/Oo2aDHK-uOY?modestbranding=1&rel=0'
        }
      });
    }

    function openQrCodeGenerator() {
       window.dispatchEvent(
        new CustomEvent('crebain-qr-code:open', {
          detail: { mode: 'vehicles' }
        })
      );
    }

    function _toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function _initialize() {
      vm.vehiclesFilters = VehiclesFilters;

      vm.reload = _.debounce(_reloadDatatable, 1000);
      vm.openAddVehicleDialog = _openAddVehicleDialog;
      vm.openEditVehicleDialog = _openEditVehicleDialog;
      vm.toggleSidenav = _toggleSidenav;
      vm.clearFilters = vm.vehiclesFilters.clear;
      vm.filteringIsOn = vm.vehiclesFilters.isOn;

      accountFeatureFlagsApiGraphQL
        .getCachedFlagByName('public-qrcode-beta-flag')
        .then(function (flag) {
          vm.showQrCodeButton = flag && flag.active;
        });

      _startDataTable();
    };

    _initialize();
  }
})();

(function () {
    'use strict';

    angular
        .module('app.tickets', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.tickets', {
                url: '/chamados-e-oportunidades',
                resolve: {
                    account: function (accountsApi) {
                        return accountsApi.get();
                    },
                    cancelationReasons: function (ticketsApi) {
                        return ticketsApi.getCancelationReasons().then(function (result) { return result.items; });
                    }
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/tickets/tickets.html',
                        controller: 'TicketController as vm'
                    }
                },
                data: {titleTranslateKey: 'TICKETS.PAGE_TITLE'},
                params: {
                    type: {
                        value: null,
                        squash: true
                    }
                },
                bodyClass: 'mail'
            })
            .state('app.tickets.thread', {
                url: '/:threadId',
                bodyClass: 'mail'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/tickets');
    }
})();
(function () {
  'use strict';

  angular
    .module('app.tickets')
    .controller('TicketController', TicketController);

  /** @ngInject */
  function TicketController() {}
})();

(function () {
  'use strict';

  angular
    .module('app.tasks')
    .factory('TaskListColumnTemplate', TaskListColumnTemplate)
    .controller('TasksController', TasksController);

  /** @ngInject */
  function TaskListColumnTemplate(TasksStatusHelper, LocalDateConvert, dateHandler, moment, msUtils, $translate, deadlineStatus, $filter) {
    var editPermission = false;
    var employees = [];
    var services = [];

    return {
      setData: setData,
      renderActionsColumn: renderActionsColumn,
      renderEmployeeColumn: renderEmployeeColumn,
      renderServiceColumn: renderServiceColumn,
      renderStatusColumn: renderStatusColumn,
      renderStartedAtDateColumn: renderStartedAtDateColumn,
      renderStartedAtColumn: renderStartedAtColumn,
      renderStartRouteAtDateColumn: renderStartRouteAtDateColumn,
      renderStartRouteAtTimeColumn: renderStartRouteAtTimeColumn,
      renderCompletedAtDateColumn: renderCompletedAtDateColumn,
      renderCompletedAtColumn: renderCompletedAtColumn,
      renderTotalTimeColumn: renderTotalTimeColumn,
      renderTotalRouteTimeColumn: renderTotalRouteTimeColumn,
      renderScheduledToColumn: renderScheduledToColumn,
      renderScheduledTimeToColumn: renderScheduledTimeToColumn,
      renderDeadlineAtColumn: renderDeadlineAtColumn,
      renderIdentifierColumn: renderIdentifierColumn,
      renderRatingColumn: renderRatingColumn,
      renderAddressColumn: renderAddressColumn,
      renderObservationVisit: renderObservationVisit,
      renderDescriptionColumn: renderDescriptionColumn,
      renderTagAtColumn: renderTagAtColumn,
      renderCreatedAtColumn: renderCreatedAtColumn,
      renderCommentColumn: renderCommentColumn,
      renderResponseDeadlineStatusColumn: renderResponseDeadlineStatusColumn,
      renderSolutionDeadlineStatusColumn: renderSolutionDeadlineStatusColumn,
      renderOrderCreatedByColumn: renderOrderCreatedByColumn,
      renderCustomerColumn: renderCustomerColumn,
      renderLocationColumn: renderLocationColumn
    };

    function setData(data) {
      editPermission = data.editPermission;
      employees = data.employees;
      services = data.services;
    }

    function renderIdentifierColumn(data) {
      var templateColumnHtml = '<div title="' + data.order.identifier + '" > ' + $filter('maxLength')(data.order.identifier , 15) + '</div>';

      if (data.order && data.order.labels && data.order.labels.length > 0) {
        templateColumnHtml += '<div class="order-labels">';

        data.order.labels.forEach(function (label) {
          templateColumnHtml += '<i class="icon-label s12 icon ' + label.color + '-fg">';
          templateColumnHtml += '<md-tooltip>&nbsp;' + label.name + '</md-tooltip>';
          templateColumnHtml += '</i>';
        });

        templateColumnHtml += '</div>';
      }
      return templateColumnHtml;

    }

    function renderTagAtColumn(data) {
      var templateColumnHtml = '<div layout="row" layout-align="start center">';

      if (data.order && data.order.labels && data.order.labels.length > 0) {
        data.order.labels.forEach(function (label, i) {
          templateColumnHtml += '<i class="icon-label s12 icon ' + label.color + '-fg">';
          templateColumnHtml += '<md-tooltip>';
          templateColumnHtml += label.name;
          templateColumnHtml += (i < data.order.labels.length - 1 ? '&nbsp;|&nbsp;' : '');
          templateColumnHtml += '</md-tooltip>';
          templateColumnHtml += '</i>';
        });
      }

      templateColumnHtml += '</div>';
      return templateColumnHtml;
    }

    function renderAddressColumn(data) {
      return '<span title="' + data.order.address.formattedAddress + '">' + $filter('maxLength')(data.order.address.formattedAddress, 35) + '</span>';
    }

    function renderObservationVisit(data) {
      if (data && data.description) {
        return '<span title="' + data.description + '">' + $filter('maxLength')(data.description, 60) + '</span>';
      }
      return '';
    }

    function renderScheduledToColumn(data) {
      if (data && data.scheduling && data.scheduling.date) {
        return LocalDateConvert.formatDate(data.scheduling.date, 'date');
      }
      return null;
    }

    function renderScheduledTimeToColumn(data) {
      if (data && data.scheduling && data.scheduling.time) {
        return ('' + data.scheduling.time).substring(0, 5);
      }
      return null;
    }

    function renderDeadlineAtColumn(data) {
      if (data && data.order && data.order.deadlineAt) {
        var templateHtml = '';
        var today = moment();
        var deadlineAt = moment(data.order.deadlineAt);

        if (today.isSameOrAfter(deadlineAt)) {
          templateHtml = '<span style="color:darkred;">' + LocalDateConvert.formatDate(deadlineAt, 'date') + '</span>';
        } else {
          templateHtml = '<span>' + LocalDateConvert.formatDate(deadlineAt, 'date') + '</span>';
        }

        return templateHtml;
      }

      return null;
    }

    function renderCompletedAtDateColumn(data) {
      if (data) {
        return dateHandler.dateUtcToLocalDateString(data);
      }
    }

    function renderStartRouteAtDateColumn(data) {
      if (data) {
        return dateHandler.dateUtcToLocalDateString(data);
      }
    }

    function renderStartRouteAtTimeColumn(data) {
      if (data) {
        return dateHandler.dateUtcToLocalTimeString(data);
      }
    }

    function renderCompletedAtColumn(data) {
      if (data) {
        return dateHandler.dateUtcToLocalTimeString(data);
      }
    }

    function renderStartedAtDateColumn(data) {
      if (data) {
        return dateHandler.dateUtcToLocalDateString(data);
      }
    }

    function renderStartedAtColumn(data) {
      if (data) {
        return dateHandler.dateUtcToLocalTimeString(data);
      }
    }

    function renderRatingColumn(data) {

      if (data) {

        if (data.rating && data.rating.id) {

          var templateHtml = '<div>';

          var className = data.rating.stars >= 1 ? 'icon-star' : 'icon-star-outline';
          templateHtml += '<i style="color: #ffb508;" class="icon s16 ' + className + '"></i>';

          className = data.rating.stars >= 2 ? 'icon-star' : 'icon-star-outline';
          templateHtml += '<i style="color: #ffb508;" class="icon s16 ' + className + '"></i>';

          className = data.rating.stars >= 3 ? 'icon-star' : 'icon-star-outline';
          templateHtml += '<i style="color: #ffb508;" class="icon s16 ' + className + '"></i>';

          className = data.rating.stars >= 4 ? 'icon-star' : 'icon-star-outline';
          templateHtml += '<i style="color: #ffb508;" class="icon s16 ' + className + '"></i>';

          className = data.rating.stars >= 5 ? 'icon-star' : 'icon-star-outline';
          templateHtml += '<i style="color: #ffb508;" class="icon s16 ' + className + '"></i>';

          templateHtml += '</div>';

          if (data.rating.comments) {
            templateHtml += data.rating.comments;
          }

          return templateHtml;
        }

      }
      return '<span style="color:#939393;">' + $translate.instant('TASKS.TABLE.MARKINGS.NO_RATE') + '</span>';
    }

    function renderCommentColumn(data) {
      if (data && data.rating && data.rating.comments) {
        return '<span title="' + data.rating.comments + '">' + $filter('maxLength')(data.rating.comments, 50) + '</span>';
      }
      return '';
    }

    function renderStatusColumn(data) {
      if (data) {
        var currentStatus = TasksStatusHelper.getByName(data.status);
        var templateHtml = '<span class="' + currentStatus.name + '-fg">' + currentStatus.description + '</span>';
        if (data.archived) {
          templateHtml += '<span class="text-boxed red-bg white-fg small-label">&nbsp;' + $translate.instant('TASKS.TABLE.MARKINGS.ARCHIVED') + '</span>';
        }
        return templateHtml;
      }
      return '';
    }

    function renderTotalRouteTimeColumn(data) {
      if (data && data.startedRouteAt && typeof data.startedAt !== 'undefined' && data.startedAt && moment(data.startedAt).isAfter(data.startedRouteAt)) {
        var formattedDate = '';
        var dateSeconds = moment(data.startedAt).diff(data.startedRouteAt, 'seconds');

        var units = {
          "week": 24 * 7 * 60 * 60,
          "day": 24 * 60 * 60,
          "hour": 60 * 60,
          "minute": 1 * 60,
          "second": 1
        };

        for (var name in units) {
          var p = Math.floor(dateSeconds / units[name]);
          dateSeconds %= units[name];
          units[name] = p;
        }

        if (units.day > 0) {
          formattedDate += units.day + ' ' + (units.day > 1 ? $translate.instant('TASKS.TABLE.MARKINGS.DAY.PLURAL') : $translate.instant('TASKS.TABLE.MARKINGS.DAY.SINGULAR')) + ' - ';
        }

        formattedDate += msUtils.leftPad(units.hour, 2) + ':' + msUtils.leftPad(units.minute, 2) + ':' + msUtils.leftPad(units.second, 2);
        return formattedDate;
      }

      return '';
    }

    function renderTotalTimeColumn(data) {
      if (data && data.startedAt && typeof data.completedAt !== 'undefined' && data.completedAt) {
        var formattedDate = '';
        var dateSeconds = moment(data.completedAt).diff(data.startedAt, 'seconds');
        var units = {
          "week": 24 * 7 * 60 * 60,
          "day": 24 * 60 * 60,
          "hour": 60 * 60,
          "minute": 1 * 60,
          "second": 1
        };

        for (var name in units) {
          var p = Math.floor(dateSeconds / units[name]);
          dateSeconds %= units[name];
          units[name] = p;
        }
        if (units.day > 0) {
          formattedDate += units.day + ' ' + (units.day > 1 ? $translate.instant('TASKS.TABLE.MARKINGS.DAY.PLURAL') : $translate.instant('TASKS.TABLE.MARKINGS.DAY.SINGULAR')) + ' - ';
        }
        formattedDate += msUtils.leftPad(units.hour, 2) + ':' + msUtils.leftPad(units.minute, 2) + ':' + msUtils.leftPad(units.second, 2);
        return formattedDate;
      }
      return '';
    }

    function renderServiceColumn(data) {
      if (data) {
        var service = _.find(services, function (c) {
          return c.id == data.order.service.id;
        });

        if (service) {
          return '<span>' + service.description + '</span>';
        }

        return '';
      }
    }

    function renderEmployeeColumn(data) {
      if (data && data.employee && data.employee.id) {
        var employee = data.employee;

        if (employee) {
          return '<div>' +
            '<img class="avatar small" alt="' + employee.name + '" ng-src="' + (employee.avatarUrl ? employee.avatarUrl : "./assets/images/avatars/profile.jpg") + '" src="./assets/images/avatars/profile.jpg">' +
            '<span title="' + employee.name + '">' + $filter('maxLength')(employee.name, 30) + '</span>' +
            '</div>';
        }
      }
      return $translate.instant('TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.NO_EMPLOYEE');
    }


    function renderActionsColumn(data) {
      var icon = data.order.locked || editPermission === false ? '<md-icon md-font-icon="icon-eye"></md-icon>' : '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">';
      var label = data.order.locked || editPermission === false ? $translate.instant('TASKS.TABLE.ROWS.ACTION.VIEW') : $translate.instant('TASKS.TABLE.ROWS.ACTION.EDIT');
      return (
        '<md-button class="md-icon-button" ng-click="vm.editTask($event, \'' + data.order.id + '\')" aria-label="more" data-cy="edit-task-icon">' +
          icon +
          '<md-tooltip md-direction="right">' + label + '</md-tooltip>' +
        '</md-button>'
      );
    }

    function renderCreatedAtColumn(data) {

      if (data && data.metadata && data.metadata.createdAt) {
        return LocalDateConvert.formatDate(data.metadata.createdAt, 'date-time');
      }
      return '';
    }

    function renderDescriptionColumn(data) {
      if (data && data.order && data.order.description) {
        return '<span title="' + data.order.description + '">' + $filter('maxLength')(data.order.description, 70) + '</span>';
      }
      return '';
    }

    function renderResponseDeadlineStatusColumn(data) {
      if (data && data.order) {
        var statusName = data.order.deadline && data.order.deadline.responseStatus ? data.order.deadline.responseStatus : null;
        var status = deadlineStatus.getStatus(statusName);
        var templateHTML = '<div layout="row" layout-align="start center">' +
          '<div class="quantity-indicator ' + status.classBgColor + '">' +
          '</div>' +
          '<span title="' + status.description + '">'+ $filter('maxLength')(status.description, 70) + '</span>' +
          '</div>';
        return templateHTML;
      }
      return '';
    }

    function renderSolutionDeadlineStatusColumn(data) {
      if (data && data.order && data.order) {
        var statusName = data.order.deadline && data.order.deadline.solutionStatus ? data.order.deadline.solutionStatus : null;
        var status = deadlineStatus.getStatus(statusName);
        var templateHTML = '<div layout="row" layout-align="start center">' +
          '<div class="quantity-indicator ' + status.classBgColor + '">' +
          '</div>' +
          '<span title="' + status.description + '">' + $filter('maxLength')(status.description, 60) + '</span>' +
          '</div>';

        return templateHTML;
      }
      return '';
    }

    function renderOrderCreatedByColumn(data) {
      var createdByName = data.order && data.order.createdBy && data.order.createdBy.name;
      if (!createdByName) {
        createdByName = (data.order && data.order.recurrence && data.order.recurrence.id) ? 'Recorrência' : '';
      }

      return createdByName || '';
    }

    function renderCustomerColumn(data) {
      var customer = data.order && data.order.customer && data.order.customer.name;

      if (customer) {
        return '<span title="' + data.order.customer.name + '">' + $filter('maxLength')(data.order.customer.name, 50) + '</span>';
      }

      return '';
    }

    function renderLocationColumn(data) {
      var location = data.order && data.order.location && data.order.location.name;

      if (location) {
        return '<span title="' + data.order.location.name + '">' + $filter('maxLength')(data.order.location.name, 40) + '</span>';
      }

      return '';
    }
  }

  /** @ngInject */
  function TasksController(
    $scope, $compile, TasksFiltersService, employees, services, $mdSidenav,
    $rootScope, dataTableOptions, TaskListColumnTemplate, _, $mdToast, $translate,
    msUtils, $timeout, DTColumnBuilder, tasksApi, $, authenticatedUser, exportsApi,
    $mdDialog, OrderDialog, $location, QueryStringParser, account, $localStorage, MessageDialog,
    dataTableHelperService, FcModalService, fcExportAlertService, servicesCache, employeesCache,
    printConfigurationApi, normalizePrintConfigurations, StartUsingField, OpenNotificationService, $document, IntegrationsService,
    accountsApi, accountFeatureFlagsApiGraphQL, RouteOptimizerDialog, $window, EnvironmentConfig
  ) {
    var vm = this;
    vm.isLoading = true;

    vm.viewPermission = authenticatedUser.hasPermission(account, 'tasks_list_menu');
    if (!vm.viewPermission) {
      $window.location.href = EnvironmentConfig.blackgateClientUrl + 'perfil';
      return;
    }

    vm.addPermission = authenticatedUser.hasPermission(account, 'tasks_allow_create');
    vm.editPermission = authenticatedUser.hasPermission(account, 'tasks_allow_edit');
    vm.getCurrentScroll = getCurrentScroll;

    canShowNewTaskListPage().then(function (canShow) {
      vm.canShowNewTaskList = canShow;

      servicesCache.resetCache();
      servicesCache.getCachedOrDefault();

      employeesCache.resetCache();
      employeesCache.getCachedOrDefault();

      IntegrationsService.initialize();

      if (!vm.canShowNewTaskList) {
        initialize();
      }

      startTaskListeners();
      vm.isLoading = false;
    });

    function initialize() {
      vm.hasEmptyTaskMessage = false;
      vm.exportTables = {
        products: true,
        materials: true,
        equipments: true,
        services: true,
        links: false,
        forms: false
      };

      vm.totalRows = 0;
      vm.totalCount = 0;
      vm.queryParams = '';
      vm.filteringIsOn = TasksFiltersService.isOn;
      vm.accountConfiguration = account.configuration;
      vm.profileId = authenticatedUser.profile.id;
      vm.currentOrdersIds = [];

      vm.clearFilters = clearFilters;
      vm.reload = reload;
      vm.hideFeedbackForm = _getHideFeedBackForm();
      vm.closeFeedback = closeFeedback;

      vm.openVideoTutorial = openVideoTutorial;

      vm.dtLocalStorageStatus = dtLocalStorageStatus;

      TaskListColumnTemplate.setData({ employees: employees.items, services: services.items, editPermission: vm.editPermission});
      TasksFiltersService.clear();

      vm.dtInstance = {};
      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = false;
        config.serverSide = true;
        config.searchDelay = 1000;
        config.paging = true;
        config.order = [27, 'desc'];

        config.buttons = [{
          isExportButton: true,
          extend: 'print',
          className: 'hidden-button',
          filename: msUtils.shortGuidGenerator(),
          text: '.',
          autoPrint: true,
          exportOptions: {
            columns: ':visible'
          },
          customize: function (printWindow) {
            printWindow.document.getElementsByTagName("body")[0].style = 'overflow: visible !important;';
            printWindow.document.getElementsByTagName("html")[0].style = 'overflow: visible !important;';
            printWindow.document.getElementsByTagName("table")[0].style = 'font-size: 10px !important;';

            var ths = printWindow.document.querySelectorAll('th');
            if (ths.length > 0) {
              ths[ths.length - 1].remove();
            }
            var trs = printWindow.document.querySelectorAll('tr');
            for (var i = 0; i < trs.length; i++) {
              var tds = trs[i].getElementsByTagName("td");
              if (tds.length > 0) {
                tds[tds.length - 1].remove();
                if (tds[0].innerHTML.indexOf("&nbsp;") != -1) {
                  tds[0].innerHTML = tds[0].innerHTML.substr(0, tds[0].innerHTML.indexOf("&nbsp;"));
                }
              }
            }
          }
        }];

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          TasksFiltersService.toSearchOptions().then(function (queryParams) {
            vm.queryParams = queryParams;

            var variables = dataTableHelperService.toGraphqlVariables({
              aoData: aoData,
              columns: vm.dtColumns,
              where: vm.queryParams.graphQL
            });

            tasksApi.queryForDatatable(variables)
              .then(function (result) {
                vm.totalRows = result.totalItems;
                vm.totalCount = result.totalCount;
                fnCallback({
                  draw: aoData[0].value,
                  recordsTotal: result.totalCount,
                  recordsFiltered: result.totalCount,
                  data: result.items
                });

                if (Array.isArray(result.items) && result.items.length) {
                  vm.currentOrdersIds = result.items.map(function (task) {
                    var orderId = task.order && task.order.id;
                    return orderId;
                  });
                  vm.currentOrdersIds = _removeRepeatedIds(vm.currentOrdersIds);
                }

                $rootScope.loadingProgress = false;

                $timeout(function () {
                  setLastedScrollTop();
                }, 200);
              });
          });
        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs.push({
          targets: 15,
          responsivePriority: 1,
          filterable: false,
          sortable: false
        });
      });

      var columnId = DTColumnBuilder.newColumn('id', 'Id').notVisible();

      var columnIdentifier = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.ID'))
        .renderWith(TaskListColumnTemplate.renderIdentifierColumn)
        .withClass('column-title');
      columnIdentifier.sortBy = 'identifier';

      var columnLabel = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.LABELS'))
        .renderWith(TaskListColumnTemplate.renderTagAtColumn)
        .notVisible()
        .notSortable();

      var columnScheduledDate = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.DATE'))
        .renderWith(TaskListColumnTemplate.renderScheduledToColumn);
      columnScheduledDate.sortBy = 'scheduledDate';

      var columnScheduledTime = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.HOUR'))
        .renderWith(TaskListColumnTemplate.renderScheduledTimeToColumn)
        .notVisible()
        .notSortable();

      var columnDeadlineAt = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.DEADLINE'))
        .renderWith(TaskListColumnTemplate.renderDeadlineAtColumn)
        .notVisible();
      columnDeadlineAt.sortBy = 'deadlineAt';

      var columnCustomerName = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.CUSTOMER'))
        .renderWith(TaskListColumnTemplate.renderCustomerColumn);
      columnCustomerName.sortBy = 'customerName';

      var columnCustomerLocation = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.CUSTOMER_LOCATION'))
        .renderWith(TaskListColumnTemplate.renderLocationColumn)
        .notSortable();

      var columnAddress = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.ADDRESS'))
        .renderWith(TaskListColumnTemplate.renderAddressColumn)
        .notSortable()
        .notVisible();

      var columnOrderDescription = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.DESCRIPTION'))
        .renderWith(TaskListColumnTemplate.renderDescriptionColumn)
        .notVisible()
        .notSortable();

      var columnObservationVisit = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.VISIT_OBSERVATION'))
        .renderWith(TaskListColumnTemplate.renderObservationVisit)
        .notSortable()
        .notVisible();

      var columnStatusColumn = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.SITUATION'))
        .renderWith(TaskListColumnTemplate.renderStatusColumn);
      columnStatusColumn.sortBy = 'status';

      var columnStartedAtDate = DTColumnBuilder.newColumn('startedAt', $translate.instant('TASKS.TABLE.COLUMNS.START_DATE'))
        .renderWith(TaskListColumnTemplate.renderStartedAtDateColumn)
        .withOption('defaultContent', '')
        .notVisible();
      columnStartedAtDate.sortBy = 'startedAt';

      var columnStartedAt = DTColumnBuilder.newColumn('startedAt', $translate.instant('TASKS.TABLE.COLUMNS.START_HOUR'))
        .renderWith(TaskListColumnTemplate.renderStartedAtColumn)
        .withOption('defaultContent', '')
        .notSortable();

      var columnStartRouteAtDate = DTColumnBuilder.newColumn('startedRouteAt', $translate.instant('TASKS.TABLE.COLUMNS.ROUTE_DATE'))
        .renderWith(TaskListColumnTemplate.renderStartRouteAtDateColumn)
        .withOption('defaultContent', '')
        .notVisible();
      columnStartRouteAtDate.sortBy = 'startedRouteAt';

      var columnStartRouteAtTime = DTColumnBuilder.newColumn('startedRouteAt', $translate.instant('TASKS.TABLE.COLUMNS.ROUTE_HOUR'))
        .renderWith(TaskListColumnTemplate.renderStartRouteAtTimeColumn)
        .withOption('defaultContent', '')
        .notVisible()
        .notSortable();

      var columnCompletedAtDate = DTColumnBuilder.newColumn('completedAt', $translate.instant('TASKS.TABLE.COLUMNS.END_DATE'))
        .renderWith(TaskListColumnTemplate.renderCompletedAtDateColumn)
        .withOption('defaultContent', '')
        .notVisible();
      columnCompletedAtDate.sortBy = 'completedAt';

      var columnCompletedAt = DTColumnBuilder.newColumn('completedAt', $translate.instant('TASKS.TABLE.COLUMNS.END_HOUR'))
        .renderWith(TaskListColumnTemplate.renderCompletedAtColumn)
        .withOption('defaultContent', '')
        .notSortable();

      var columnTotalTime = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.VISIT_DURATION'))
        .renderWith(TaskListColumnTemplate.renderTotalTimeColumn)
        .withOption('defaultContent', '')
        .notVisible()
        .notSortable();

      var columnTotalRouteTime = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.ROUTE_DURATION'))
        .renderWith(TaskListColumnTemplate.renderTotalRouteTimeColumn)
        .withOption('defaultContent', '')
        .notVisible()
        .notSortable();

      var columnStatusDescription = DTColumnBuilder.newColumn('statusDescription', $translate.instant('TASKS.TABLE.COLUMNS.DESCRIPTION_CLOSURE'))
        .notVisible()
        .notSortable();

      var columnRating = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.RATE'))
        .renderWith(TaskListColumnTemplate.renderRatingColumn);
      columnRating.sortBy = 'ratingStars';

      var columnComment = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.COMMENT'))
        .renderWith(TaskListColumnTemplate.renderCommentColumn)
        .withClass('no-display')
        .notSortable();

      var columnService = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.TYPE'))
        .renderWith(TaskListColumnTemplate.renderServiceColumn)
        .notSortable();

      var columnEmployee = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.EMPLOYEE'))
        .renderWith(TaskListColumnTemplate.renderEmployeeColumn)
        .notSortable();

      var columnResonseDeadlineStatus = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.RESPONSE_DEADLINE_STATUS'))
        .renderWith(TaskListColumnTemplate.renderResponseDeadlineStatusColumn)
        .withOption('defaultContent', '')
        .notVisible()
        .notSortable();

      var columnSolutionDeadlineStatus = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.SOLUTION_DEADLINE_STATUS'))
        .renderWith(TaskListColumnTemplate.renderSolutionDeadlineStatusColumn)
        .withOption('defaultContent', '')
        .notVisible()
        .notSortable();

      var columnOrderCreatedBy = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.ORDER_CREATED_BY'))
        .renderWith(TaskListColumnTemplate.renderOrderCreatedByColumn)
        .withOption('defaultContent', '')
        .notVisible()
        .notSortable();

      var columnCreatedAt = DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.CREATED_AT'))
        .renderWith(TaskListColumnTemplate.renderCreatedAtColumn);
      columnCreatedAt.sortBy = 'createdAt';

      vm.dtColumns = [
        columnId,
        columnIdentifier,
        columnLabel,
        columnScheduledDate,
        columnScheduledTime,
        columnDeadlineAt,
        columnCustomerName,
        columnCustomerLocation,
        columnAddress,
        columnOrderDescription,
        columnObservationVisit,
        columnStatusColumn,
        columnStartRouteAtDate,
        columnStartRouteAtTime,
        columnStartedAtDate,
        columnStartedAt,
        columnCompletedAtDate,
        columnCompletedAt,
        columnTotalTime,
        columnTotalRouteTime,
        columnStatusDescription,
        columnRating,
        columnComment,
        columnService,
        columnEmployee,
        columnResonseDeadlineStatus,
        columnSolutionDeadlineStatus,
        columnOrderCreatedBy,
        columnCreatedAt,

        DTColumnBuilder.newColumn(null, $translate.instant('TASKS.TABLE.COLUMNS.ACTIONS'))
          .renderWith(TaskListColumnTemplate.renderActionsColumn)
          .withClass('no-margin-important no-padding-important')
          .notSortable()
          .withOption('responsivePriority', 1)
      ];

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;

        vm.dtInstance.DataTable.on('draw', function () {
          document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop = 0;
        });

        if (vm.dtInstance) {
          if ($localStorage.getObject('dtColumnsVisibility-' + vm.profileId).length !== vm.dtColumns.length) {
            dtLocalStorageRemove();
          } else if ($localStorage.getObject('dtColumnsVisibility-' + vm.profileId).length) {
            for (var index = 0; index < vm.dtColumns.length; index++) {
              vm.dtInstance.DataTable.column(index).visible($localStorage.getObject('dtColumnsVisibility-' + vm.profileId)[index]);
            }
          }
          fixTableHeaders();
          loadPreDefinedFilters();
        }
      };

      vm.dtLocalStorageRemove = dtLocalStorageRemove;

      vm.createTask = createTask;
      vm.editTask = _.debounce(editTask, 500);
      vm.toggleSidenav = toggleSidenav;
      vm.exportData = exportData;
      vm.toggleColumnVisibility = toggleColumnVisibility;
      vm.isColumnVisible = isColumnVisible;

      $scope.$on('tasks:reload', function () {
        vm.reload();
      });

      $scope.$on('tasks-list:filter-updated', function () {
        resetCurrentScroll();
        loadActivities(true);

        var indexOf = window.location.href.indexOf('?');
        if (indexOf > -1 && history && history.pushState) {
          history.pushState('', document.title, (window.location.href + '').substring(0, indexOf));
        }
      });
    }

    function canShowNewTaskListPage() {
      return accountsApi.getCachedAccount().then(function (account) {
        return accountFeatureFlagsApiGraphQL.getCachedFlagByName('task-list').then(function (flag) {
          return flag ? flag.active : false;
        });
      });
    }

    OpenNotificationService.openDialog($location);

    function dtLocalStorageStatus() {
      if ($localStorage.getObject('dtColumnsVisibility-' + vm.profileId).length) {
        return true;
      }
      return false;
    }

    function clearFilters() {
      $rootScope.selectedCustomFilter = {};
      TasksFiltersService.clear();
    }

    function reload() {
      resetCurrentScroll();
      loadActivities();
    }

    function dtLocalStorageRemove() {
      $localStorage.remove('dtColumnsVisibility-' + vm.profileId);
      for (var index = 0; index < vm.dtColumns.length; index++) {
        vm.dtInstance.DataTable.column(index).visible((vm.dtColumns[index].bVisible === false) ? false : true);
      }
      fixTableHeaders();
    }

    function loadPreDefinedFilters() {

      if ($rootScope.searchTasksFilters) {

        if ($rootScope.searchTasksFilters.status && $rootScope.searchTasksFilters.status.length > 0) {
          TasksFiltersService.status = $rootScope.searchTasksFilters.status;
        }

        if ($rootScope.searchTasksFilters.employees && $rootScope.searchTasksFilters.employees.length > 0) {
          TasksFiltersService.employees = $rootScope.searchTasksFilters.employees;
        }

        if ($rootScope.searchTasksFilters.customerName) {
          TasksFiltersService.customersName = $rootScope.searchTasksFilters.customerName;
        }

        if ($rootScope.searchTasksFilters.customerId) {
          TasksFiltersService.customerId = $rootScope.searchTasksFilters.customerId;
        }

        TasksFiltersService.activitiesDateFromView = $rootScope.searchTasksFilters.activitiesDateFromView;
        TasksFiltersService.activitiesDateToView = $rootScope.searchTasksFilters.activitiesDateToView;

        delete $rootScope.searchTasksFilters;

      } else {

        var uriQuery = $location.search().q;
        if (uriQuery) {

          var qOptions = {
            keywords: [
              'numero',
              'data_agendamento>',
              'data_agendamento>=',
              'data_agendamento<=',
              'servicos',
              'nome_cliente',
              'situacao',
              'colaborador',
              'colaboradores',
              'avaliacao',
              'etiqueta',
              'id_cliente',
              'prazo_resposta',
              'prazo_solucao',
              'nome_localizacao',
              'descricao_localizacao',
              'equipment_id',
              'data_criacao_ordem_servico>=',
              'data_criacao_ordem_servico<=',
              'id_setor',
              'id_ambiente'
            ]
          };

          var queryResult = QueryStringParser.parse(uriQuery, qOptions);

          if (queryResult) {

            if (queryResult['numero']) {
              TasksFiltersService.activitiesIdentifier = queryResult['numero'];
            }

            if (queryResult['data_agendamento>']) {
              TasksFiltersService.activitiesDateFromView = moment(queryResult['data_agendamento>']).startOf('day').toDate();
            }

            if (queryResult['data_agendamento>=']) {
              TasksFiltersService.activitiesDateFromView = moment(queryResult['data_agendamento>=']).startOf('day').toDate();
            }

            if (queryResult['data_agendamento<=']) {
              TasksFiltersService.activitiesDateToView = moment(queryResult['data_agendamento<=']).startOf('day').toDate();
            }

            if (queryResult['data_criacao_ordem_servico>=']) {
              TasksFiltersService.isFilteringByCreatedAt = true;
              TasksFiltersService.orderCreatedAtGte = moment(queryResult['data_criacao_ordem_servico>=']).startOf('day').toDate();
            }
            if (queryResult['data_criacao_ordem_servico<=']) {
              TasksFiltersService.isFilteringByCreatedAt = true;
              TasksFiltersService.orderCreatedAtLte = moment(queryResult['data_criacao_ordem_servico<=']).startOf('day').toDate();
            }

            if (queryResult['nome_cliente']) {
              var customerName = queryResult['nome_cliente'];
              if (Array.isArray(customerName)) {
                customerName = customerName.join(',');
              }

              TasksFiltersService.customersName = customerName;
            }

            if (queryResult['nome_localizacao']) {
              TasksFiltersService.locationName = queryResult['nome_localizacao'];
            }

            if (queryResult['descricao_localizacao']) {
              TasksFiltersService.locationNotes = queryResult['descricao_localizacao'];
            }

            if (queryResult['id_setor']) {
              TasksFiltersService.sectorId = queryResult['id_setor'];
            }

            if (queryResult['id_ambiente']) {
              TasksFiltersService.environmentId = queryResult['id_ambiente'];
            }

            if(queryResult['id_cliente']) {
              TasksFiltersService.customerId = queryResult['id_cliente'];
            }

            if (queryResult['avaliacao']) {
              TasksFiltersService.ratings.push(parseInt(queryResult['avaliacao']));
            }

            if (queryResult['situacao']) {
              var translateStatus = {
                'agendada': 'scheduled',
                'concluida': 'done',
                'em_andamento': 'in-progress',
                'problema': 'reported'
              };

              TasksFiltersService.status.push(translateStatus[queryResult.situacao]);
            }

            if (queryResult['colaborador']) {
              if (queryResult['colaborador'] == 'sem_colaborador') {
                TasksFiltersService.employees.push('null');
              }
              // fixme: deveria setar o id do colaborador nesse else ?
            }

            if (queryResult['colaboradores']) {
              TasksFiltersService.employees = (queryResult['colaboradores'] || '')
                .toString()
                .split(',')
                .map(function (value) {
                  return value.trim();
                })
                .filter(Boolean)
                .map(Number);
            }

            if (queryResult['etiqueta']) {
              TasksFiltersService.labels.push(queryResult['etiqueta']);
            }

            if (queryResult['servicos']) {
              TasksFiltersService.services = (queryResult['servicos'] || '')
                .toString()
                .split(',')
                .map(function (value) { return value.trim(); })
                .filter(Boolean)
                .map(function (id) { return { id: Number(id) }; });
            }

            if (queryResult['prazo_resposta']) {
              var translateDeadlineResponseStatus = {
                'dentro_do_prazo' : 'onSchedule',
                'em_risco' : 'atRisk',
                'fora_do_prazo' : 'outOfSchedule',
                'concluido_fora_do_prazo' : 'completedOutOfSchedule',
                'concluido_dentro_do_prazo' : 'completedOnSchedule',
                'nao_aplicavel' : 'notApplicable'
              };
              TasksFiltersService.responseDeadlineStatus = (queryResult['prazo_resposta'] || '').toString().split(',').map(function (value) { return translateDeadlineResponseStatus[value]; });
            }

            if (queryResult['prazo_solucao']) {
              var translateDeadlineResponseStatus = {
                'dentro_do_prazo' : 'onSchedule',
                'em_risco' : 'atRisk',
                'fora_do_prazo' : 'outOfSchedule',
                'concluido_fora_do_prazo' : 'completedOutOfSchedule',
                'concluido_dentro_do_prazo' : 'completedOnSchedule',
                'nao_aplicavel' : 'notApplicable'
              };
              TasksFiltersService.solutionDeadlineStatus = (queryResult['prazo_solucao'] || '').toString().split(',').map(function (value) { return translateDeadlineResponseStatus[value]; });
            }

            if (queryResult['equipment_id']) {
              var equipment = {id: queryResult['equipment_id']};
              TasksFiltersService.equipments = [equipment];
            }
          }
        }
      }

      $timeout(function () { loadActivities(); }, 1000);
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (isColumnVisible(index)) {
          visibleColumnsCount++;
        }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function isColumnVisible(index) {
      if (vm.dtInstance && vm.dtInstance.DataTable) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function toggleColumnVisibility(index) {
      var visibility = !vm.dtInstance.DataTable.column(index).visible();
      var visibleCount = 0;
      for (var i = 0; i < vm.dtColumns.length; i++) {
        if (vm.dtInstance.DataTable.column(i).visible()) {
          visibleCount++;
        }
      }
      if (visibility === false && visibleCount <= 3) {
        return;
      }
      vm.dtInstance.DataTable.column(index).visible(visibility);
      var columnsVisible = [];
      for (var index = 0; index < vm.dtColumns.length; index++) {
        columnsVisible.push(vm.dtInstance.DataTable.column(index).visible());
      }
      $localStorage.setObject('dtColumnsVisibility-' + vm.profileId, columnsVisible);
      fixTableHeaders();
    }

    function enqueueDataExport(type) {
      exportsApi.exportFeature(type, vm.queryParams, {
        timezone: moment.tz.guess(),
        tables: vm.exportTables
      }).then(function (result) {
        var isTasksExport = type === 'tasks';
        fcExportAlertService.show({
          email: authenticatedUser.profile.email,
          title: isTasksExport ? $translate.instant('TASKS.TOASTS.EXPORT.EXCEL_TITLE') : $translate.instant('TASKS.TOASTS.EXPORT.TITLE'),
          hasSendedToEmail: true
        });
        return result;
      }).catch(function () {
        var message = $translate.instant('TASKS.TOASTS.DIALOG_ACTIONS.EXPORT_ERROR');
        $mdToast.show(
          $mdToast.simple()
            .textContent(message)
            .hideDelay(5000)
        );
      });
    };

    function exportData($event, actionName, clickClassNameCallback) {
      _resetExportTables();
      vm.exportingClickClassNameCallback = clickClassNameCallback;

      if (actionName === 'impressão') {
        vm.exportingDataLoading = true;
        $rootScope.loadingProgress = true;

        $timeout(function () {
          vm.exportingDataLoading = false;
          $rootScope.loadingProgress = false;

          if (vm.exportingClickClassNameCallback) {
            document.getElementsByClassName(vm.exportingClickClassNameCallback)[0].click();
          }
        }, 2000);

        return null;
      }

      if (actionName === 'pdf') {
        if(vm.totalCount > 1000) {
          return FcModalService.open($event, {
            title: $translate.instant('TASKS.EXPORT_MODAL.TITLE_LIMIT_EXCEEDED'),
            templateUrl: 'app/main/tasks/templates/export-limit-exceeded.html',
            variables: {
              alertFirstContent: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.ALERT_LIMIT_EXCEEDED_FIRST_CONTENT'),
              alertSecondContent: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.ALERT_LIMIT_EXCEEDED_SECOND_CONTENT'),
              pdfExportMaxLength: 1000,
              pdfExportRecivedLength:  vm.totalCount
            },
            leftButtonText: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.OK')
          });
        }
        return FcModalService.open($event, {
          title: $translate.instant('TASKS.EXPORT_MODAL.TITLE_PDF'),
          templateUrl: 'app/main/tasks/templates/export-pdf-button-content.html',
          variables: {
            email: authenticatedUser.profile.email,
            alertFirstContent: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.ALERT_FIRST_CONTENT'),
            alertSecondContent: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.ALERT_SECOND_CONTENT')
          },
          closeButtonIconPath: 'assets/icons/icon-close.svg',
          leftButtonText: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.NO'),
          rightButtonText: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.YES'),
          handleRightButton: function () {
            vm.queryParams.graphQL.ordersId = vm.currentOrdersIds;
            printConfigurationApi.getPrintConfiguration()
              .then(function (printConfigurations) {
                if (printConfigurations && printConfigurations.configurations) {
                  var configurations = normalizePrintConfigurations.normalize(printConfigurations.configurations);
                  vm.queryParams.graphQL.printConfiguration = {
                    configurations: configurations
                  };
                }
                enqueueDataExport('orders-pdfs-reports');
              })
              .catch(function () {
                MessageDialog.showToast({
                  hideDelay: 2000,
                  message: $translate.instant('TASKS.DIALOG.ACTIONS.ALERTS.EXPORT_DATA.CANT_EXPORT')
                });
              });
          }
        });
      }

      var materialNgModel = true;
      var productNgModel = true;
      var equipmentNgModel = true;
      var formsNgModel = false;
      var linksNgModel = false;
      var servicesNgModel = true;

      FcModalService.open($event, {
        title: $translate.instant('TASKS.EXPORT_MODAL.TITLE'),
        templateUrl: 'app/main/tasks/templates/export-excel-button-content.html',
        variables: {
          title: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.TITLE'),
          productCheckboxTitle: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.PRODUCTS'),
          materialCheckboxTitle: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.MATERIALS'),
          equipmentCheckboxTitle: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.EQUIPMENTS'),
          formsCheckboxTitle: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.FORMS'),
          linksCheckboxTitle: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.LINKS'),
          servicesCheckboxTitle: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.SERVICES'),
          email: authenticatedUser.profile.email,
          alertFirstContent: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.ALERT_FIRST_CONTENT'),
          alertSecondContent: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.ALERT_SECOND_CONTENT'),
          confirmActionContent: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.CONFIRM_ACTION_CONTENT'),
          changeCheckbox: changeCheckbox,
          materialNgModel: materialNgModel,
          productNgModel: productNgModel,
          equipmentNgModel: equipmentNgModel,
          formsNgModel: formsNgModel,
          linksNgModel: linksNgModel,
          servicesNgModel: servicesNgModel
        },
        closeButtonIconPath: 'assets/icons/icon-close.svg',
        leftButtonText: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.NO'),
        rightButtonText: $translate.instant('TASKS.EXPORT_MODAL.TEMPLATE.YES'),
        handleRightButton: function () {
          enqueueDataExport('tasks');
        }
      });
    }

    function changeCheckbox(title) {
      vm.exportTables[title] = !(vm.exportTables[title]);
    }

    function _resetExportTables() {
      vm.exportTables = {
        materials: true,
        products: true,
        equipments: true,
        forms: false,
        links: false,
        services: true
      };
    }

    function _removeRepeatedIds(items) {
      var withoutRepeatedIds = items.filter(function (value, index) {
        return items.indexOf(value) === index;
      });
      return withoutRepeatedIds;
    }

    var isDialogOpen = false;

    function createTask(ev) {
      if (isDialogOpen) {
        return;
      }

      isDialogOpen = true;

      OrderDialog.createTask(ev, null, function (reload) {
        if (reload) {
          if (vm.canShowNewTaskList) {
            document.dispatchEvent(new CustomEvent('order-dialog:saved'));
            $rootScope.loadingProgress = false;

            return;
          }

          vm.getCurrentScroll();
          loadActivities();
        }
      }, vm.addPermission);

      document.addEventListener('order-dialog:close', function () {
        isDialogOpen = false;
      }, { once: true });
    }

    function editTask(ev, id) {
      if (isDialogOpen) {
        return;
      }

      isDialogOpen = true;

      OrderDialog.editTask(ev, { id: id }, function (reload) {
        if (reload) {
          if (vm.canShowNewTaskList) {
            document.dispatchEvent(new CustomEvent('order-dialog:saved'));
            $rootScope.loadingProgress = false;

            return;
          }

          vm.getCurrentScroll();
          loadActivities();
        }
      });

      document.addEventListener('order-dialog:close', function () {
        isDialogOpen = false;
      }, { once: true });
    }

    function loadActivities(resetPaging) {
      if (!resetPaging) {
        resetPaging = false;
      }

      vm.dtInstance.DataTable.ajax.reload(function () {
        $('.call-to-action').remove();
        $('md-tooltip').hide();

        if (!vm.accountConfiguration.featureDisableAddTask && !vm.hasEmptyTaskMessage) {
          var createNewLabel = $translate.instant('TASKS.TABLE.ROWS.EMPTY.CTA');
          var clickHereLabel = $translate.instant('TASKS.TABLE.ROWS.EMPTY.LINK');

          var ctaNewTask = $compile('<fc-call-to-action-create-new message="' + createNewLabel + '" link="' + clickHereLabel + '" action="vm.createTask($event)"></fc-call-to-action-create-new>')(($scope));
          $('.dataTables_empty').append($(ctaNewTask));
          vm.hasEmptyTaskMessage = true;
        }
      }, resetPaging);

      vm.hasEmptyTaskMessage = false;
    }

    vm.currentScrollTop = 0;
    function getCurrentScroll() {
      var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
      if (scrollContent) {
        vm.currentScrollTop = scrollContent.scrollTop;
      }
    }

    function resetCurrentScroll() {
      vm.currentScrollTop = 0;
    }

    function setLastedScrollTop() {
      if (vm.currentScrollTop > 0) {
        var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
        if (scrollContent) {
          scrollContent.scrollTop = vm.currentScrollTop;
        }
      }
    }

    function openVideoTutorial() {
      $mdDialog.show({
        controller: 'VideoTutorialController',
        controllerAs: 'vm',
        templateUrl: 'app/core/dialogs/video-tutorial/video-tutorial.html',
        parent: angular.element($document.body),
        clickOutsideToClose: false,
        locals: {
          videoUrl: 'https://www.youtube.com/embed/7RF3GjdPJh8?modestbranding=1&rel=0'
        }
      });
    }

    function _getHideFeedBackForm() {
      return $localStorage.get("hideTasksFeedbackForm_a4fa0092-c494-4b38-809f-ce1e3d5714fc");
    }

    function closeFeedback() {
      vm.hideFeedbackForm = true;
      $localStorage.set("hideTasksFeedbackForm_a4fa0092-c494-4b38-809f-ce1e3d5714fc", 'true');
    }

    function openRouteOptimizer($event) {
      if (!account.configuration.moduleRouteOptimizationEnabled && !account.configuration.moduleAdvancedRouteOptimizationEnabled) {
        return _openModuleInfoElement('advanced_route_optimization', false);
      }

      if (account.configuration.moduleAdvancedRouteOptimizationEnabled) {
        openAdvancedRouteOptimizer($event);
        return;
      }

      openLegacyRouteOptimizer($event);
    }

    function openAdvancedRouteOptimizer($event) {
      if ((!account.configuration.moduleAdvancedRouteOptimizationEnabled) && vm.accountPlan !== 'test') {
        return _openModuleInfoElement('advanced_route_optimization', false);
      }

      var taskIds = $rootScope.selectedTaskIds || $event.detail.selectedTaskIds;
      var selectedDate = vm.selectedDate || $event.detail.selectedDate;

      var data = { selectedTaskIds: taskIds, selectedDate: selectedDate };
      var event = new CustomEvent('openRouterOptimizer', { detail: data });

      document.dispatchEvent(event);
    }

    function openLegacyRouteOptimizer($event) {
      if ((!account.configuration.moduleRouteOptimizationEnabled) && vm.accountPlan !== 'test') {
        return _openModuleInfoElement('advanced_route_optimization', false);
      }

      var employeesItems = employees && employees.items;

      RouteOptimizerDialog.startOptimizer($event, employeesItems, function (optimizationResult) {
        if (optimizationResult) {
          optimizationResult.taskPatchPayload.forEach(function (task) {
            task.scheduling = {
              type: 'scheduled-date',
              time: null
            };
          });

          var currentPayload = optimizationResult.taskPatchPayload;
          if (vm.isPreventAccount) {
            var tasks = angular.copy(optimizationResult.taskPatchPayload);
            var initialDate = optimizationResult.initialDate;
            var selectedWeekDays = optimizationResult.selectedWeekDays;
            var splitByAmountPerDay = TasksDistribution.splitByAmountPerDay(tasks, optimizationResult.tasksPerDay);
            var updatedTasks = TasksDistribution.updateTasks(splitByAmountPerDay, selectedWeekDays, initialDate);
            var formattedTasks = TasksDistribution.extractTasks(updatedTasks);
            currentPayload = formattedTasks;
          }

          tasksApi.patchTasks(currentPayload).then(function () {
            ControlPanelData.loadData();
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.SUCCESS_MESSAGE'))
                .hideDelay(3000)
            );
          });
        }
      });
    }

    function _openModuleInfoElement(module, isEnabled) {
      var event = new CustomEvent('openModuleInfo', { detail: { type: module, hired: isEnabled } });

      document.dispatchEvent(event);
    }

    var openRouteOptimizerListenerFn = function ($event) {
      openRouteOptimizer($event);
    };

    var createOrderListenerFn = function () {
      createTask(null);
    };

    var editOrderListenerFn = function (data) {
      editTask(null, data.detail);
    };

    function startTaskListeners() {
      document.addEventListener('create-order', createOrderListenerFn);

      document.addEventListener('edit-order', editOrderListenerFn);

      document.addEventListener('open-route-optimizer', openRouteOptimizerListenerFn);
    }

    $scope.$on('$destroy', function () {
      document.removeEventListener('create-order', createOrderListenerFn);
      document.removeEventListener('edit-order', editOrderListenerFn);
      document.removeEventListener('open-route-optimizer', openRouteOptimizerListenerFn);
    });

    StartUsingField.start();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.subscription')
    .factory('SubscriptionViewModel', SubscriptionViewModelFactory);

  /** @ngInject */
  function SubscriptionViewModelFactory(employeesApi, _) {

    var SubscriptionViewModel = function (Data) {
      this.account = angular.copy(Data.account);
      this.isAccountPro = _isAccountPro(this.account);

      if (this.isAccountPro) {
        this.subscription = angular.copy(Data.subscription);
        this.pendingRenewal = angular.copy(Data.pendingRenewal);
        this.renewalFeatures = _getMappedFeatures(Data.subscriptionRenewalItems);
        this.features = _getMappedFeatures(this.subscription.items);
        this.defaultChartOptions = _getDeafultChartOptions();
      }
    };

    SubscriptionViewModel.prototype.getPendingRenewal = function () {
      return angular.copy(this.pendingRenewal);
    };

    SubscriptionViewModel.prototype.getEmployeeChartConfig = function () {
      var self = this;

      return _numberOfEmployeesLicensesInUse().then(function (number) {
        var using = number;
        var options = angular.copy(self.defaultChartOptions);
        options.high = self.features.technicianApp.quantity;

        return {
          using: using,
          limit: self.features.technicianApp.quantity,
          data: {
            series: [
              [using],
              [self.features.technicianApp.quantity]
            ]
          },
          options: options
        };
      });
    };

    SubscriptionViewModel.prototype.getStorageChartConfig = function () {
      var options = angular.copy(this.defaultChartOptions);
      options.high = 50;

      return {
        using: 25,
        limit: 50,
        unity: 'GB',
        data: {
          series: [
            [20],
            [5],
            [50]
          ]
        },
        options: options
      };
    };

    SubscriptionViewModel.prototype.getChartEvents = function () {
      return {
        draw: function drawHandler(obj) {
          obj.element.attr({ style: 'stroke-width: 5px' });
        }
      };
    };

    SubscriptionViewModel.prototype.getCurrentSubscription = function () {
      var emails = this.subscription.emails.map(function (email, index) {
        return {
          address: email,
          primary: index === 0
        };
      });

      return {
        id: this.subscription.id,
        type: this.subscription.type,
        locked: this.subscription.locked,
        renewAt: this.subscription.renewAt,
        payment: {
          email: emails[0].address || this.account.contact.email
        },
        emails: emails
      };
    };

    SubscriptionViewModel.prototype.getFeatures = function () {
      return angular.copy(this.features);
    };

    SubscriptionViewModel.prototype.getRenewalFeatures = function () {
      return angular.copy(this.renewalFeatures);
    };

    function _numberOfEmployeesLicensesInUse() {
      return employeesApi.getAll().then(function (employees) {
        return _.filter(employees.items, 'contract.active').length;
      });
    }

    function _getMappedFeatures(featuresItems) {
      var features = {
        totalValue: 0,
        installmentValue: 0,
        technicianApp: null,
        managerApp: null,
        equipmentsModule: null,
        highResolutionImages: null,
        video: null,
        routeOptimization: null
      };

      if (!featuresItems || !featuresItems.length) {
        return features;
      }

      featuresItems.forEach(function (featureItem) {
        features[featureItem.feature] = featureItem;
        features.totalValue += featureItem.totalValue * 12;
      });
      features.installmentValue = features.totalValue / 12;

      return features;
    }

    function _getDeafultChartOptions() {
      return {
        stackBars: true,
        horizontalBars: true,
        axisY: {
          offset: 0,
          showLabel: false,
          showGrid: false
        },
        axisX: {
          showLabel: false,
          showGrid: false
        },
        chartPadding: {
          top: 30,
          right: 0,
          bottom: 0,
          left: 0
        },
        height: '40px'
      };
    }

    function _isAccountPro(account) {
      return account.plan.name !== 'test' && account.plan.name !== 'trial';
    }

    return SubscriptionViewModel;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.subscription')
    .factory('SubscriptionService', SubscriptionService);

  function SubscriptionService($rootScope, siteApi, authenticatedUser, accountsApi, ereborApi) {
    return {
      updateEmails: updateEmails,
      numberToCurrency: numberToCurrency,
      renewSubscription: renewSubscription,
      requestEmployeesUpgrade: requestEmployeesUpgrade
    };

    function updateEmails(subscription) {
      $rootScope.loadingProgress = true;

      var emails = [];
      subscription.emails.map(function (email) {
        if (email.primary) {
          return emails.splice(0, 0, email.address);
        }
        emails.push(email.address);
      });

      return ereborApi.updateCurrentSubscriptionEmails(
        subscription.id,
        emails
      ).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function renewSubscription() {
      $rootScope.loadingProgress = true;

      return ereborApi.createSubscriptionRenewalInvoice()
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function requestEmployeesUpgrade(increaseNumber) {
      $rootScope.loadingProgress = true;

      return accountsApi.get().then(function (account) {
        var formOptions = {
          name: authenticatedUser.profile.name,
          email: account.contact.email,
          accountName: account.contact.name,
          module: 'technician-app',
          quantity: increaseNumber,
          language: account.language
        };

        return siteApi.requestModuleActivation(formOptions)
          .then(function () { return true; })
          .catch(function () { return false; })
          .finally(function () { $rootScope.loadingProgress = false; });

      }).catch(function () {
        $rootScope.loadingProgress = false;
        return false;
      });
    }

    function numberToCurrency(number, options) {
      var value = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(number);

      if (options) {
        if (options.removeSpaces) {
          value = value.replace('\xa0', '');
        }
        if (options.removeCurrency) {
          value = value.slice(3);
        }
      }

      return value;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.subscription').controller('SubscriptionController', SubscriptionController);

  function SubscriptionController($state, $mdSidenav,SubscriptionViewModel, authenticatedUser, SubscriptionService, Data, siteApi, $rootScope, $mdToast, $translate, _, ModulesService) {
    var vm = this;

    vm.viewModel = new SubscriptionViewModel(Data);
    vm.account = vm.viewModel.account;
    vm.isAccountPro = vm.viewModel.isAccountPro;

    if (vm.isAccountPro) {
      vm.showRenewalAlert = !!Data.pendingRenewal;
      vm.subscription = vm.viewModel.getCurrentSubscription();
      vm.configuration = ModulesService.configuration(vm.account);
      vm.modulesSubscription = getModulesSubscription(vm.configuration);

      vm.renewAtFormatted = moment(vm.subscription.renewAt).format('DD/MM/YYYY');
      vm.charts = {
        storage: vm.viewModel.getStorageChartConfig(),
        events: vm.viewModel.getChartEvents(),
      };
      vm.viewModel.getEmployeeChartConfig().then(function (config) {
        vm.charts.employee = config;
      });
      vm.features = vm.viewModel.getFeatures();
      vm.renewalFeatures = vm.viewModel.getRenewalFeatures();

      vm.numberToCurrency = numberToCurrency;
      vm.toggleSidenav = toggleSidenav;
      vm.goToModules = goToModules;
    }
    vm.scheduleDemo = scheduleDemo;

    initialize();

    function initialize() {
      $rootScope.disabledButton = false;
    }

    function numberToCurrency(number) {
      return SubscriptionService.numberToCurrency(number, {
        removeSpaces: true,
      });
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function goToModules() {
      $state.go('app.modules');
    }

    function scheduleDemo() {
      $rootScope.disabledButton = true;
      var formOptions = {
        name: authenticatedUser.profile.name,
        email: authenticatedUser.profile.email,
        accountName: vm.account.name,
        phone: vm.account.contact.phone,
        language: navigator.language || navigator.userLanguage,
      };
      siteApi.scheduleDemo(formOptions).then(function () {
        $rootScope.loadingProgress = false;
        $mdToast.show($mdToast.simple().textContent($translate.instant('TOOLBAR.SCHEDULE_DEMO.SUCCESS')).hideDelay(2000));
      }).catch(function () {
        $rootScope.loadingProgress = false;
        $mdToast.show(
          $mdToast.simple().textContent($translate.instant('TOOLBAR.SCHEDULE_DEMO.ERROR')).theme('error-toast').hideDelay(2000)
        );
      });
    }

    function getModulesSubscription(modulesSubscription) {
      var featuresActived = {};
      var featuresKeys = _.keys(modulesSubscription);

      _.each(featuresKeys, function (key) {
        if (!_.isEmpty(modulesSubscription[key])) {
          featuresActived[key] = modulesSubscription[key].isEnable;
        }
      });

      return featuresActived;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController($scope, $state, $transitions, $element, Account, Users, msUtils, $mdDialog,
    $rootScope, employeesApi, accountsApi, apiKeyIntegrationApi, webhookApi, $mdToast,
    addressService, $timeout, $window, attachmentsUtils, accountCache, accountFeatureFlagsApiGraphQL,
    ordersApi, $q, _, ApiKeyDialog, CreateWebhookDialog, $translate, quotationsApi,
    DeleteApiKeyDialog, DeleteWebhookDialog, WebhookResponseDetailsDialog, FcModalService, LocalDateConvert) {

    var vm = this;
    vm.taskRatingNotificationEmails = [];
    vm.users = Users.items;
    vm.usersList = msUtils.loadListIds(angular.copy(Users.items));
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.apiKey = null;
    vm.webhookConfiguration = null;
    vm.canShowOrcTicketsConfig = false;
    vm.hasOrcOrdersBetaFlag = false;
    vm.hasQuotationsEquipmentsFeatureFlag = false;
    vm.hasPublicQRCodeFeatureFlag = false;
    vm.webhookResponses = [];
    vm.webhookResponsesNexToken = null;
    vm.disableApiKeyNewButton = true;
    vm.disableWebhookNewButton = true;
    vm.employees = [];
    vm.employeesOrderBy = Account.configuration.ganttEmployeesSortBy;
    vm.employeesSortableOptions = { handle: '> .handle-options' };
    vm.preventDefault = preventDefault;
    vm.notifyRatingChanged = notifyRatingChanged;
    vm.notifyMobileShowPendingTasksChanged = notifyMobileShowPendingTasksChanged;
    vm.notifyGeolocationDisabledChanged = notifyGeolocationDisabledChanged;
    vm.mobileAllowCreateOrdersChanged = mobileAllowCreateOrdersChanged;
    vm.saveAccountConfiguration = saveAccountConfiguration;
    vm.addressCountries = addressService.getCountries();
    Account.logoUrl = attachmentsUtils.correctUrl(Account.logoUrl);
    vm.account = angular.copy(Account);
    vm.isLoading = true;
    vm.dateFormat = LocalDateConvert.pickAltFormat('date-time');
    vm.hasFeatureFlag = hasFeatureFlag;

    vm.languages = [
      { code: 'pt-br', name: $translate.instant('CONFIGURATIONS.OTHERS.LANGUAGE.PORTUGUESE') },
      { code: 'es-mx', name: $translate.instant('CONFIGURATIONS.OTHERS.LANGUAGE.SPANISH') },
      { code: 'en-us', name: $translate.instant('CONFIGURATIONS.OTHERS.LANGUAGE.ENGLISH') }
    ];

    vm.confirmIdentifierChange = confirmIdentifierChange;
    vm.cancelIdentifierChange = cancelIdentifierChange;
    vm.cancelQuotationIdentifierChange = cancelQuotationIdentifierChange;

    vm.dtInstance = {};
    vm.currentScroll = vm.currentScroll || 0;
    vm.toggleInput = false;
    vm.retryGetCurrentIdentifier = _.debounce(getCurrentIdentifier, 500);

    vm.playSound = playSound;
    vm.notificationSounds = [
      {
        code: 'default',
        name: $translate.instant('CONFIGURATIONS.MOBILE.SOUND_NOTIFICATION.DEFAULT')
      },
      {
        code: 'smooth',
        name: $translate.instant('CONFIGURATIONS.MOBILE.SOUND_NOTIFICATION.SMOOTH'),
        soundPath: 'assets/audio/smooth.mp3'
      },
      {
        code: 'moderate',
        name: $translate.instant('CONFIGURATIONS.MOBILE.SOUND_NOTIFICATION.MODERATE'),
        soundPath: 'assets/audio/moderate.mp3'
      },
      {
        code: 'high',
        name: $translate.instant('CONFIGURATIONS.MOBILE.SOUND_NOTIFICATION.HIGH'),
        soundPath: 'assets/audio/high.mp3'
      },
      {
        code: 'high-extended',
        name: $translate.instant('CONFIGURATIONS.MOBILE.SOUND_NOTIFICATION.HIGH_EXTENDED'),
        soundPath: 'assets/audio/highextended.mp3'
      }
    ];

    vm.screen = {
      accountInfo: true,
      devSettings: false,
      devWebhookCallbacks: false,
      integrations: false,
      serviceOrder: false,
      timeline: false,
      cellphone: false,
      otherConfig: false,
      equipments: false,
      title: $translate.instant('CONFIGURATIONS.SIDENAV.COMPANY_DATA')
    };

    hasFeatureFlag('orc-tickets-beta-flag').then(function (canShow) {
      vm.canShowOrcTicketsConfig = canShow;
    });

    hasFeatureFlag('orc-orders-beta-flag').then(function (canShow) {
      vm.hasOrcOrdersBetaFlag = canShow;
    });

    hasFeatureFlag('quotations-equipments-beta-flag').then(function (flag) {
      vm.hasQuotationsEquipmentsFeatureFlag = flag;
    });

    hasFeatureFlag('public-qrcode-beta-flag').then(function (flag) {
      vm.hasPublicQRCodeFeatureFlag = flag;
    });

    loadEmployees();
    loadConfig();
    loadApiKeys();
    loadWebhooks();
    getCurrentIdentifier();

    _selectConfigMenu($state.current);

    function confirmIdentifierChange() {
      vm.setNewNextIdentifier = true;
      vm.toggleInput = !vm.toggleInput;
    }

    function cancelIdentifierChange() {
      vm.nextIdentifier = vm.currentIdentifier + 1;
      vm.setNewNextIdentifier = false;
      vm.toggleInput = !vm.toggleInput;
    }

    function preventDefault(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    function loadEmployees() {
      employeesApi.getAll().then(function (result) {
        var activeEmployees = _.filter(result.items, function (employee) {
          return employee.contract.active && !employee.inactivatedAt;
        });
        var isConfigurationDefined = Account && Account.configuration;
        var isEmployeeSortingConfigured = Account.configuration.ganttEmployeesPositions && Account.configuration.ganttEmployeesPositions.length;
        if (isConfigurationDefined && isEmployeeSortingConfigured) {
          vm.employees = _.sortBy(activeEmployees, function (employee) {
            var employeePosition = _.find(Account.configuration.ganttEmployeesPositions, function (configPosition) {
              return configPosition.id === employee.id;
            });
            if (employeePosition) {
              return employeePosition.position;
            } else {
              return 99999;
            }
          });
        } else {
          vm.employees = activeEmployees;
        }
      });
    }

    function setEmployeesPositions() {
      if (vm.configuration.ganttEmployeesSortBy === 'custom') {
        var index = 0;
        vm.configuration.ganttEmployeesPositions = [];
        vm.employees.forEach(function (employee) {
          vm.configuration.ganttEmployeesPositions.push({
            id: employee.id,
            name: employee.name,
            position: ++index
          });
        });
      } else {
        vm.configuration.ganttEmployeesPositions = [];
      }
    }

    function _selectConfigMenu(state) {
      var title = state.data.titleTranslateKey;
      var screen = state.name.split('.')[2];

      vm.configuration.taskRatingNotificationEmails = _.map(vm.taskRatingNotificationEmails, function (userId) {
        return {
          id: userId
        };
      });

      clearSelectedScreen();
      vm.screen.title = $translate.instant(title) || '';
      vm.screen[screen] = true;
    }

    function clearSelectedScreen() {
      vm.screen.accountInfo = false;
      vm.screen.devSettings = false;
      vm.screen.devWebhookCallbacks = false;
      vm.screen.integrations = false;
      vm.screen.serviceOrder = false;
      vm.screen.timeline = false;
      vm.screen.cellphone = false;
      vm.screen.otherConfig = false;
      vm.screen.equipments = false;
      vm.screen.labelsManager = false;
    }

    function loadConfig() {
      vm.disableSaveButton = false;
      vm.configuration = angular.copy(Account.configuration);
      vm.configuration.mobileTicketsOnEmployeeIds = vm.configuration.mobileTicketsOnEmployeeIds || [];
      vm.configuration.mobileAllowCreateOrdersEmployeeIds = vm.configuration.mobileAllowCreateOrdersEmployeeIds || [];
      vm.configuration.mobileBrowseBackAndForwardActivitiesListAllowedDays = vm.configuration.mobileBrowseBackAndForwardActivitiesListAllowedDays || [];
      vm.configuration.mobileCreateOrdersToOtherEmployeesIds = vm.configuration.mobileCreateOrdersToOtherEmployeesIds || [];
      vm.taskRatingNotificationEmails = _.map(vm.configuration.taskRatingNotificationEmails, function (user) {
        return user.id;
      });
    }

    function cancelQuotationIdentifierChange() {
      vm.nextIdentifier = vm.currentIdentifier;
      vm.setNewNextIdentifier = false;
      vm.toggleInput = !vm.toggleInput;
    }

    function getCurrentIdentifier() {
      setTimeout(function () {
        var location = window.location.href;
        if (location.includes('configuracoes/outras')) {
          quotationsApi.getLastIdentifier().then(function (response) {
            vm.currentIdentifier = parseInt(response.identifier);
            vm.nextIdentifier = vm.currentIdentifier;
          });
          return;
        }

        ordersApi.getCurrentIdentifier().then(function (currentIdentifier) {
          vm.currentIdentifier = currentIdentifier;
          vm.nextIdentifier = vm.currentIdentifier + 1;
        }).catch(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.GET_FAIL'))
              .hideDelay(3000)
              .theme('error-toast')
          );
        });
      }, 100);
    }

    var onSuccess = $transitions.onSuccess({}, function (transition, teste, teste2) {
      _selectConfigMenu(transition.to());
    });

    var onBefore = $transitions.onBefore({}, function (transition) {
      var toState = transition.to();
      if (vm.account && vm.account.configuration && !(_.isEqual(vm.account, Account) && _.isEqual(vm.configuration, Account.configuration))) {
        var promise = new Promise(function (resolve, reject) {
          function openDiscardConfirmationModal() {
            FcModalService.open(null, {
              title: $translate.instant('CONFIGURATIONS.DISCARD_CHANGES.TITLE'),
              content: $translate.instant('CONFIGURATIONS.DISCARD_CHANGES.CONTENT'),
              eventNameToSubscribe: 'discard-settings-changes',
              buttonFlex: true,
              leftButtonText: $translate.instant('CONFIGURATIONS.DISCARD_CHANGES.OK'),
              rightButtonText: $translate.instant('CONFIGURATIONS.DISCARD_CHANGES.DISCARD'),
              handleLeftButton: function () {
                if (!(_.isEqual(vm.account, Account))) {
                  saveAccount();
                } else if (!(_.isEqual(vm.configuration, Account.configuration))) {
                  saveAccountConfiguration();
                  $timeout(function () {
                    $window.location.reload(false);
                  }, 2000);
                }
                resolve();
              },
              handleRightButton: function () {
                reject();
              },
              dontCloseModalOnLeftButtonHandler: false
            }, null);
          }
          openDiscardConfirmationModal(toState);
        });
        return promise.then(function () {
          transition.to();
        });
      }
    });

    $scope.$on('$destroy', function () {
      onSuccess();
      onBefore();
    });

    $element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

    function notifyRatingChanged() {
      if (!vm.configuration.taskRatingNotificationOn) {
        vm.configuration.taskRatingNotificationEmails = [];
      }
    }

    function notifyGeolocationDisabledChanged() {
      if (!vm.configuration.mobileNotifyGeolocationDisabledOn) {
        vm.configuration.mobileNotifyGeolocationDisabledUserIds = [];
      }
    }

    function notifyMobileShowPendingTasksChanged() {
      if (!vm.configuration.mobileShowPendingTasksOn) {
        vm.configuration.mobileShowPendingTasksEmployeeIds = [];
      }
    }

    function mobileAllowCreateOrdersChanged() {
      if (!vm.configuration.mobileAllowCreateOrders) {
        vm.configuration.mobileAllowCreateOrdersEmployeeIds = [];
        vm.configuration.mobileCreateOrdersToOtherEmployees = false;
        vm.configuration.mobileCreateOrdersToOtherEmployeesIds = [];
      }
    }

    function hasFeatureFlag(name) {
      return accountsApi.getCachedAccount().then(function () {
        return accountFeatureFlagsApiGraphQL.getCachedFlagByName(name).then(function (flag) {
          if (!flag) { return false; }

          return flag.active;
        });
      });
    }

    function saveAccountConfiguration(type) {
      setEmployeesPositions();

      vm.disableSaveButton = true;
      vm.configuration.taskRatingNotificationEmails = _.map(vm.taskRatingNotificationEmails, function (userId) {
        return {
          id: userId
        };
      });

      var requests = {
        accountConfig: accountsApi.saveConfigurations(vm.configuration)
      };

      if (vm.setNewNextIdentifier && !type) {
        requests.identifier = ordersApi.setNextIdentifier(vm.nextIdentifier - 1);
      }

      if (vm.setNewNextIdentifier && type === 'quotation') {
        requests.identifier = quotationsApi.setNewIdentifier(vm.nextIdentifier - 1);
      }

      if (!vm.configuration.mobileCustomTaskCardEnabled) {
        vm.configuration.mobileCustomTaskCardConfig = [];
      }

      accountsApi.patch(vm.account).then(function () {
        $q.all(requests).then(function () {
          accountCache.invalidate();

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("CONFIGURATIONS.ACCOUNT_SETTINGS_SAVED"))
              .hideDelay(2000)
          );
          $timeout(function () {
            $window.location.reload(true);
          }, 2000);
        }).catch(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.FAIL'))
              .hideDelay(2000)
              .theme('error-toast')
          );
          vm.disableSaveButton = false;
          cancelIdentifierChange();
        });
      }).catch(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant('CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.FAIL'))
            .hideDelay(2000)
            .theme('error-toast')
        );
        vm.disableSaveButton = false;
        cancelIdentifierChange();
      });
    }

    // ApiKey
    vm.createApiKey = createApiKey;
    vm.confirmDeleteApiKey = confirmDeleteApiKey;

    function loadApiKeys() {
      $rootScope.loadingProgress = true;
      vm.apiKey = null;
      apiKeyIntegrationApi.get().then(function (apiKeys) {
        if (apiKeys && apiKeys.length) {
          vm.apiKey = apiKeys[0];
        }
      }).finally(function () {
        $rootScope.loadingProgress = false;
      });
    }

    function createApiKey(ev) {
      ApiKeyDialog.open(ev).then(function (reload) {
        if (reload) {
          loadApiKeys();
        }
      });
    }

    function confirmDeleteApiKey(ev, key) {
      DeleteApiKeyDialog.open(ev, key).then(function (deleted) {
        if (deleted) {
          vm.apiKey = null;
        }
      });
    }

    // Webhook
    vm.createWebhookConfiguration = createWebhookConfiguration;
    vm.confirmDeleteWebhook = confirmDeleteWebhook;
    vm.openWebhookResponseDetails = openWebhookResponseDetails;
    vm.loadWebhookResponsesHistory = loadWebhookResponsesHistory;

    function openWebhookResponseDetails(ev, webhookResponse) {
      WebhookResponseDetailsDialog.open(ev, webhookResponse);
    }

    function createWebhookConfiguration(ev) {
      CreateWebhookDialog.open(ev).then(function (reload) {
        if (reload) {
          loadWebhooks();
        }
      });
    }

    function loadWebhooks() {
      webhookApi.get().then(function (webhooks) {
        if (webhooks && webhooks.length) {
          vm.webhookConfiguration = webhooks[0];
          loadWebhookResponsesHistory(vm.webhookConfiguration.id);
        } else {
          vm.webhookResponses = [];
          vm.isLoading = false;
        }
      });
    }

    function loadWebhookResponsesHistory(id, nextToken) {
      webhookApi.getResponses(id, nextToken).then(function (responses) {
        responses.items.forEach(function (webhookResponses) {
          if (!webhookResponses.response.statusCode && webhookResponses.response.body === 'Request timed out') {
            webhookResponses.response.statusCode = 408;
          }
          vm.webhookResponses.push(webhookResponses);
        });
        vm.webhookResponsesNexToken = responses.nextToken;
        vm.isLoading = false;
      });
    }

    function confirmDeleteWebhook(ev, webhook) {
      DeleteWebhookDialog.open(ev, webhook).then(function (deleted) {
        if (deleted) {
          vm.webhookConfiguration = null;
          vm.webhookResponses = [];
          vm.webhookResponsesNexToken = null;
        }
      });
    }

    vm.timeZoneSearchTerm = "";
    vm.clearTimeZoneSearchTerm = clearTimeZoneSearchTerm;

    function clearTimeZoneSearchTerm() {
      vm.timeZoneSearchTerm = '';
    };

    vm.addressCountriesSearchTerm = "";
    vm.clearAddressCountriesSearchTerm = clearAddressCountriesSearchTerm;

    function clearAddressCountriesSearchTerm() {
      vm.addressCountriesSearchTerm = '';
    };

    function playSound(soundPath) {
      new Audio(soundPath).play();
    }

    vm.isCustomTaskCardChecked = isCustomTaskCardChecked;
    vm.isConfigEditTaskAfterCompletedChecked = isConfigEditTaskAfterCompletedChecked;
    vm.toggleCustomTaskCard = toggleCustomTaskCard;
    vm.includeConfigsAtEditTaskAfterCompleted = includeConfigsAtEditTaskAfterCompleted;
    vm.showMaxCustomTaskCardConfigError = false;

    function isCustomTaskCardChecked(config) {
      var defaultCustomTaskCardConfig = ['order-service', 'location-name'];

      if (!vm.configuration.mobileCustomTaskCardConfig.length) {
        vm.configuration.mobileCustomTaskCardConfig = defaultCustomTaskCardConfig;
      }

      return Boolean(vm.configuration.mobileCustomTaskCardConfig.find(function (customTaskConfig) {
        return customTaskConfig === config;
      }));
    }

    function isConfigEditTaskAfterCompletedChecked(config) {
      var mobileUpdateTaskAfterCompletedStatus = [];

      if (!vm.configuration.mobileUpdateTaskAfterCompletedStatus) {
        vm.configuration.mobileUpdateTaskAfterCompletedStatus = mobileUpdateTaskAfterCompletedStatus;
      }

      return Boolean(vm.configuration.mobileUpdateTaskAfterCompletedStatus.find(function (item) {
        return item === config;
      }));
    }

    function toggleCustomTaskCard(config) {
      var mobileCustomTaskCardConfig = vm.configuration.mobileCustomTaskCardConfig;

      if (vm.isCustomTaskCardChecked(config)) {
        vm.showMaxCustomTaskCardConfigError = false;

        if (mobileCustomTaskCardConfig.length <= 1) {
          return;
        }

        vm.configuration.mobileCustomTaskCardConfig = mobileCustomTaskCardConfig.filter(function (customTaskConfig) {
          return customTaskConfig !== config;
        });

        return;
      }

      vm.showMaxCustomTaskCardConfigError = mobileCustomTaskCardConfig.length >= 2;

      if (vm.showMaxCustomTaskCardConfigError) {
        return;
      }

      vm.configuration.mobileCustomTaskCardConfig = mobileCustomTaskCardConfig.concat(config);
    }

    function includeConfigsAtEditTaskAfterCompleted(config) {
      var mobileUpdateTaskAfterCompleted = vm.configuration.mobileUpdateTaskAfterCompleted;
      var mobileUpdateTaskAfterCompletedStatus = vm.configuration.mobileUpdateTaskAfterCompletedStatus;

      if (!mobileUpdateTaskAfterCompleted) {
        return;
      }

      if (mobileUpdateTaskAfterCompletedStatus.includes(config)) {
        var index = mobileUpdateTaskAfterCompletedStatus.indexOf(config);
        if (index !== -1) {
          mobileUpdateTaskAfterCompletedStatus.splice(index, 1);
          return;
        }

        return;
      }

      mobileUpdateTaskAfterCompletedStatus.push(config);

      vm.configuration.mobileUpdateTaskAfterCompletedStatus = mobileUpdateTaskAfterCompletedStatus;
    }

    vm.isCustomPublicQRCodeChecked = isCustomPublicQRCodeChecked;
    vm.toggleCustomPublicQRCode = toggleCustomPublicQRCode;

    function isCustomPublicQRCodeChecked(config) {
      var defaultCustomPublicQRCodeConfig = ['open-ticket', 'tasks'];

      if (!vm.configuration.featurePublicQRCodeCustomization) {
        vm.configuration.featurePublicQRCodeCustomization = defaultCustomPublicQRCodeConfig;
      }

      return Boolean(vm.configuration.featurePublicQRCodeCustomization.find(function (customPublicQRCodeConfig) {
        return customPublicQRCodeConfig === config;
      }));
    }

    function toggleCustomPublicQRCode(config) {
      var featurePublicQRCodeCustomization = vm.configuration.featurePublicQRCodeCustomization;

      if (vm.isCustomPublicQRCodeChecked(config)) {
        vm.configuration.featurePublicQRCodeCustomization = featurePublicQRCodeCustomization.filter(function (customPublicQRCodeConfig) {
          return customPublicQRCodeConfig !== config;
        });

        return;
      }

      vm.configuration.featurePublicQRCodeCustomization = featurePublicQRCodeCustomization.concat(config);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .controller('ServicesController', ServicesController);

  /** @ngInject */
  function ServicesController(
    $rootScope, ServiceDialog, dataTableOptions, ServicesApiGraphQL, $translate, $filter, DTColumnBuilder, msUtils,
    $compile, $scope, $mdSidenav, ServicesFilters, account, $mdDialog, $document, LocalDateConvert, FeatureFlags, accountFeatureFlagsApiGraphQL,
    EnvironmentConfig
  ) {

    var vm = this;
    vm.accountConfiguration = account.configuration;
    vm.dateFormat = LocalDateConvert.pickAltFormat('date');
    vm.currentPage = 1;
    vm.totalPages = 1;
    vm.limitPerPage = 25;
    vm.featureFlags = FeatureFlags;
    vm.hasTaskTypesLaunchBetaFlag = false;

    vm.addService = addService;
    vm.editService = editService;
    vm.toggleSidenav = toggleSidenav;
    vm.openVideoTutorial = openVideoTutorial;
    vm.hasFeatureFlag = hasFeatureFlag;
    vm.openLaunchDialog = openLaunchDialog;

    $scope.$on('services:reload', function () {
      vm.reload();
    });

    function _addCallToActionButton() {
      $('.call-to-action').remove();

      if (!vm.accountConfiguration.featureDisableAddService) {
        var ctaNewService = $compile(
          '<div class="call-to-action">' +
          '<span translate="SERVICES.TABLE.CREATE_OS_TYPE_CTA">You can create a new type of service</span> ' +
          '<a class="cursor-pointer" translate="SERVICES.TABLE.CREATE_OS_TYPE_LINK" ng-click="vm.addService($event)">clicking here</a>.' +
          '</div>')(($scope)
          );

        $('.dataTables_empty').append($(ctaNewService));
      }

    }

    function addService(ev) {
      ServiceDialog.createService(ev, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function editService(ev, id) {
      ServiceDialog.editService(ev, id, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    }

    function openVideoTutorial() {
      $mdDialog.show({
        controller: 'VideoTutorialController',
        controllerAs: 'vm',
        templateUrl: 'app/core/dialogs/video-tutorial/video-tutorial.html',
        parent: angular.element($document.body),
        clickOutsideToClose: false,
        locals: {
          videoUrl: 'https://www.youtube.com/embed/8LkEkCiHnSs?modestbranding=1&rel=0'
        }
      });
    }

    function hasFeatureFlag(name) {
      var hasFeature = vm.featureFlags.find(function (featureFlag) {
        return featureFlag.name === name;
      });

      if (!hasFeature) { return false; }

      return hasFeature.active;
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;

        config.buttons = [
          {
            isExportButton: true,
            extend: 'csvHtml5',
            className: 'hidden-button',
            filename: msUtils.shortGuidGenerator(),
            text: '.',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
        },
        {
            isExportButton: true,
            extend: 'excelHtml5',
            className: 'hidden-button',
            filename: msUtils.shortGuidGenerator(),
            text: '.',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
          }
        ];

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
            $rootScope.loadingProgress = true;

            var sortBy = 'createdAt_desc';

            var mapSortBy = {
              1: 'description_',
              2: 'duration_',
              3: 'createdAt_',
              4: 'updatedAt_',
              5: 'slaTimeLimit_'
            };

            if (aoData && aoData[2] && aoData[2].value[0].column && aoData[2].value[0].dir && (aoData[2].value[0].column === 1 || aoData[2].value[0].column === 2 || aoData[2].value[0].column === 3 || aoData[2].value[0].column === 4 || aoData[2].value[0].column === 5)) {
              var sortBy = (mapSortBy[aoData[2].value[0].column] + aoData[2].value[0].dir) || 'createdAt_desc';
            }

            var queryOptions = {
              skip: aoData[3].value,
              limit: aoData[4].value,
              sort: sortBy
            };

            var servicesWhereInput = {};
            if (vm.servicesFilters) {
              servicesWhereInput = {
                'description': vm.servicesFilters.description ? vm.servicesFilters.description : null,
                'archived': vm.servicesFilters.archived === '1' ? false : true
              };

              if (vm.servicesFilters.archived === '-1') {
                delete servicesWhereInput.archived;
              }
            }

            ServicesApiGraphQL
              .queryForDatatable({
                where: servicesWhereInput,
                orderBy: queryOptions.sort,
                take: queryOptions.limit,
                skip: queryOptions.skip
              })
              .then(function (result) {
                vm.services = result.items;
                vm.totalServices = result.totalCount;
              })
              .finally(function () {
                fnCallback({
                  draw: aoData[0].value,
                  recordsTotal: vm.totalServices,
                  recordsFiltered: vm.totalServices,
                  data: vm.services
                });

                $rootScope.loadingProgress = false;
              });
        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });

      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        _addCallToActionButton();
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          _addCallToActionButton();
          fixTableHeaders();
        });
      };
    }

    function openLaunchDialog() {
      document.dispatchEvent(new CustomEvent('showLaunchDialog', {
        detail: {
          title: $translate.instant('SERVICES.LAUNCH_DIALOG.TITLE'),
          size: 'small',
          description: $translate.instant('SERVICES.LAUNCH_DIALOG.DESCRIPTION'),
          imageUrl: 'https://app.fieldcontrol.com.br/assets/icons/rocket-color.svg',
          rightButton: {
            text: $translate.instant('SERVICES.LAUNCH_DIALOG.RIGHT_BUTTON'),
            action: function () {
              accountFeatureFlagsApiGraphQL.updateAccountFeatureFlag('task-types-beta-flag', true).then(function () {
                window.location.href = EnvironmentConfig.mordor2Url + 'tipos-de-os';
              });
            },
          },
          leftButton: {
            text: $translate.instant('SERVICES.LAUNCH_DIALOG.LEFT_BUTTON'),
          },
        }
      }));
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (isColumnVisible(index)) { visibleColumnsCount++; }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function _getDtColumns() {
      var columnID = DTColumnBuilder.newColumn('id', 'id').notVisible();
      var columnDescription = DTColumnBuilder.newColumn(null, $translate.instant('SERVICES.MODEL.DESCRIPTION')).renderWith(function (data) {
        var corporateCustomerName = (
          data.metadata &&
          data.metadata.sammathnaur &&
          data.metadata.sammathnaur.account &&
          data.metadata.sammathnaur.account.name
        );

        var corporateCustomerNameFormatted = corporateCustomerName ?
          '<em class="text-light-gray">(' + corporateCustomerName + ')</em>' : '<em>' + '</em>';

        var archivedClass = data.archived ? 'md-red-500-bg' : 'md-green-600-bg',
          archivedText = $translate.instant(data.archived ? 'SERVICES.TABLE.INACTIVE' : 'SERVICES.TABLE.ACTIVE'),
          templateHTML = '<div layout="row" layout-align="start center">' +
            '<div class="quantity-indicator ' + archivedClass + '">' +
            '<md-tooltip>' + archivedText + '</md-tooltip>' +
            '</div>' +
            '<span title="' + data.description + '">' + $filter('maxLength')(data.description, 110) + ' ' + corporateCustomerNameFormatted + '</span>' +
            '</div>';
        return templateHTML;
      }).withOption('width', '45%');

      columnDescription.sortBy = 'description';

      var columnDuration =  DTColumnBuilder.newColumn(null, $translate.instant('SERVICES.MODEL.DURATION')).renderWith(function (data) {
        var duration = data.duration;
        if (!duration) { return ''; }

        return duration;
      }).withOption('width', '17%');

      columnDuration.sortBy = 'duration';

      var columnCreatedAt =  DTColumnBuilder.newColumn(null, $translate.instant('SERVICES.MODEL.CREATEDAT')).renderWith(function (data) {
          var createdAt = (data.metadata && data.metadata.createdAt) || data.createdAt;
          if (!createdAt) { return ''; }

          return LocalDateConvert.formatDate(createdAt, 'date-time');
      }).withOption('width', '13%');

      columnCreatedAt.sortBy = 'createdAt';

      var columnUpdatedAt =  DTColumnBuilder.newColumn(null, $translate.instant('SERVICES.MODEL.UPDATEDAT')).renderWith(function (data) {
        var updatedAt = data.updatedAt;
        if (!updatedAt) { return ''; }

        return LocalDateConvert.formatDate(updatedAt, 'date-time');
      }).withOption('width', '13%');

      columnUpdatedAt.sortBy = 'updatedAt';

      var columnSlaTimeLimit =  DTColumnBuilder.newColumn(null, $translate.instant('SERVICES.MODEL.DEADLINE')).renderWith(function (data) {
        var slaTimeLimit = data.slaTimeLimit;
        if (!slaTimeLimit) { return ''; }

        return slaTimeLimit;
      }).withOption('width', '15%');

      columnSlaTimeLimit.sortBy = 'slaTimeLimit';

      var columnActions = DTColumnBuilder.newColumn(null, $translate.instant('SERVICES.TABLE.ACTIONS')).renderWith(function (data) {
          var eventClick = 'ng-click="vm.editService($event,\'' + data.id + '\')"';
          var isCorporateCustomer = data.metadata && data.metadata.sammathnaur;
          var templateHTML = '';

          if (data.locked && !isCorporateCustomer) {
            templateHTML = '<md-button class="md-icon-button md-button-disabled-css">' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="SERVICES.TABLE.EDIT_LOCKED">Edit</span></md-tooltip>' +
              '</md-button>';
          } else if (isCorporateCustomer) {
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="SERVICES.TABLE.VIEW">Edit</span></md-tooltip>' +
              '</md-button>';
          } else {
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="SERVICES.TABLE.EDIT">Edit</span></md-tooltip>' +
              '</md-button>';
          }
          return templateHTML;
      }).notSortable()
      .withOption('responsivePriority', 1)
      .withOption('width', '15%');

      return [
        columnID,
        columnDescription,
        columnDuration,
        columnCreatedAt,
        columnUpdatedAt,
        columnSlaTimeLimit,
        columnActions
      ];
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _initialize() {
      vm.account = account;
      vm.servicesFilters = ServicesFilters;
      vm.clearFilters = vm.servicesFilters.clear;
      vm.filteringIsOn = vm.servicesFilters.isOn;
      vm.toggleSidenav = toggleSidenav;
      vm.reload = _.debounce(_reloadDatatable, 1000);
      vm.hasTaskTypesLaunchBetaFlag = vm.hasFeatureFlag('task-types-launch-beta-flag');

      _startDataTable();
    }

    _initialize();
  }
})();

(function () {
    'use strict';

    angular
        .module('app.routes')
        .controller('RoutesController', RoutesController);

    /** @ngInject */
    function RoutesController($scope, $rootScope, $mdSidenav, leafletData, account, mapHtmlTemplate,
                              moment, RoutesFilters, tasksApi, _, msUtils, locationsApi, TasksStatusHelper,
                              OrderDialog, GanttData, GanttConfig, $q, attachmentsUtils, $translate, legendOptions) {

        var vm = this;
        vm.clearFilters = RoutesFilters.clear;
        RoutesFilters.clear();
        vm.filteringIsOn = RoutesFilters.isOn;

        vm.ganttOptions = GanttConfig.getOptions();
        vm.highlightPath = highlightPath;
        vm.unhighlightPath = unhighlightPath;
        vm.clicked = false;
        vm.mapFitOn = true;
        vm.changedMapFit = changedMapFit;
        vm.showConnectionPaths = true;
        vm.switchShowConnectionPaths = switchShowConnectionPaths;
        vm.changedClusterOption = changedClusterOption;
        vm.task = {};

        vm.map = {
            center:  {
                lat: parseFloat(account.address.coords.latitude),
                lng: parseFloat(account.address.coords.longitude),
                zoom: 12
            },
            markers: {},
            _markers: [],
            paths: {},
            decorations: {
                markers: {
                    coordinates: [],
                    patterns: [
                        { offset: 25, repeat: 50, symbol: L.Symbol.arrowHead({pixelSize: 15, pathOptions: {fillOpacity: 1, weight: 0, color: '#0e9ce4'}})}
                    ]
                }
            },
            locations: [],
            legend: legendOptions(account.name, 'bottomleft', 'routes'),
            controls: {
                fullscreen: {
                    position: 'topleft'
                }
            },
            layers: {
                baselayers: {
                    mapbox_standard: {
                        name: $translate.instant("ROUTES.MAP.LAYERS.DEFAULT"),
                        url: 'https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                        type: 'xyz',
                        layerOptions: {
                            'showOnSelector': true
                        }
                    },
                    mapbox_satellite: {
                        name: $translate.instant("ROUTES.MAP.LAYERS.SATELLITE"),
                        url: 'https://mt0.google.com/vt/lyrs=y&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                        type: 'xyz',
                        layerOptions: {
                            'showOnSelector': true
                        }
                    },
                    mapbox_roadmap: {
                        name: $translate.instant("ROUTES.MAP.LAYERS.ROADS"),
                        url: 'https://mt0.google.com/vt/lyrs=h&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                        type: 'xyz',
                        layerOptions: {
                            'showOnSelector': true
                        }
                    },
                    mapbox_terrain: {
                        name: $translate.instant("ROUTES.MAP.LAYERS.LAND"),
                        url: 'https://mt0.google.com/vt/lyrs=p&hl=pt&x={x}&y={y}&z={z}&s=Ga7',
                        type: 'xyz',
                        layerOptions: {
                            'showOnSelector': true
                        }
                    }
                }
            }
        };

        vm.toggleSidenav = toggleSidenav;
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        $scope.$on('routes:filter-updated', function (event, data) {
            vm.selectedEmployee = data;
            loadRoute();
        });

        function loadRoute() {
            clearData();
            if (RoutesFilters.isOn()) {
                $rootScope.loadingProgress = true;

                vm.map.markers = {};
                vm.map._markers = [];
                var selectedDate = moment(RoutesFilters.date).format('YYYY-MM-DD');


                $q.all({
                   pathResult: locationsApi.getRouteHistory(RoutesFilters.employeeId, selectedDate),
                   taskResult: tasksApi.getEstimatedTasks({
                        where: {
                            scheduledDateGte: selectedDate,
                            scheduledDateLte: selectedDate,
                            employeeIds: [RoutesFilters.employeeId],
                            archived: false
                        },
                        take: 1000,
                        skip: 0
                    })
                }).then(function (result) {

                    transformTaskResult(result.taskResult);
                    transformPathResult(result.pathResult);

                    if(moment(RoutesFilters.date).format('DD-MM-YYYY') === moment().format('DD-MM-YYYY')) {
                       loadEmployeeLocation();
                    }

                });
            }

            loadCompanyLocation();
        }

        function changedClusterOption() {
            loadRoute();
        }

        function loadCompanyLocation() {
            account.logoUrl = attachmentsUtils.correctUrl(account.logoUrl);
            if(account.address && account.address.coords) {
                var companyMarker = {
                    id: account.id,
                    latitude: parseFloat(account.address.coords.latitude),
                    lat: parseFloat(account.address.coords.latitude),
                    longitude: parseFloat(account.address.coords.longitude),
                    lng: parseFloat(account.address.coords.longitude),
                    opacity: 0.9,
                    icon: {
                        type: 'div',
                        html: '<div class="company-logo">' +
                              '</div>',
                        iconSize:     [38, 38], // size of the icon
                        iconAnchor:   [8, 16], // point of the icon which will correspond to marker's location
                        popupAnchor:  [0, -16]  // point from which the popup should open relative to the iconAnchor
                    },
                    message: account.name
                };
                vm.map.markers[account.id] = companyMarker;
            }
        }

        function changedMapFit() {
            centralizeMap(vm.map.locations, vm.map._markers);
        }

        function switchShowConnectionPaths() {
          loadRoute();
        }

        function clearData() {
            vm.map.markers = {};
            vm.map._markers = [];
            vm.map.locations = [];
            vm.map.paths = {};
            vm.map.decorations.markers.coordinates = [];
            vm.ganttData = [];
            vm.clicked = false;
            centralizeMap(vm.map.locations, vm.map._markers);
        }

        function transformTaskResult(tasks) {

            vm.tasks = tasks;

            tasks = _.filter(tasks, function (task) {
                return task.archived === false;
            });

            tasks.forEach(function (task) {

                var id = String(task.id);
                id = id.replace(/-/g, '');

                var templateTooltip = mapHtmlTemplate.taskMarkerTemplate(task);
                var taskStatus = TasksStatusHelper.getByName(task.status);

                var marker = {
                    id: msUtils.guidGenerator(),
                    latitude: task.coords.latitude,
                    lat: task.coords.latitude,
                    longitude: task.coords.longitude,
                    lng: task.coords.longitude,
                    status: task.status,
                    statusValue: taskStatus.value,
                    opacity: 0.9,
                    icon: {
                        type: 'div',
                        html: '<div>' +
                              '    <i style="color:' + taskStatus.color + ';" class="icon icon-city s38"></i>' +
                              '</div>',
                        iconAnchor:   [16, 16], // point of the icon which will correspond to marker's location
                        popupAnchor:  [0, -16]  // point from which the popup should open relative to the iconAnchor
                    },
                    getMessageScope: function () { return $scope; },
                    message: templateTooltip,
                    compileMessage: true
                };

                vm.map.markers[id] = marker;
                vm.map._markers.push(marker);
            });

        }

        $scope.editTask = function (ev, id) {
            OrderDialog.editTask(ev, { id: id });
        };

        function oldTransformPathResult(paths) {
            vm.locations = paths;

            vm.paths = [];

            vm.map.paths = {};
            vm.map.locations = [];

            var path = {
                weight: 3,
                color: '#039BE5',
                latlngs: [],
                latLongDecorations: []
            };

            paths.forEach(function (locations) {

                locations = _.sortBy(locations, function (location) {
                    return moment(location.timestamp).toDate().getTime();
                });

                locations.forEach(function (location) {

                    //manter a conversao de GMT para UTC só até ajustar na api
                    var d = moment.tz(location.timestamp, "America/Sao_Paulo");
                    location.timestamp = d.utc().format();

                    vm.paths.push(location);

                    path.latlngs.push({
                        lat: parseFloat(location.latitude),
                        lng: parseFloat(location.longitude),
                        draggable: false
                    });

                    path.latLongDecorations.push([parseFloat(location.latitude), parseFloat(location.longitude)]);

                    vm.map.locations.push(location);
                });

                loadGanttData();
            });

            vm.map.paths['p0'] = path;
            vm.fullPaths = vm.map.paths;

            vm.map.decorations.markers.coordinates.push(path.latLongDecorations);
            vm.fullDecorationPaths = vm.map.decorations.markers.coordinates;

            centralizeMap(vm.map.locations, vm.map._markers);
            showWarningIfLowAccuracy();
            $rootScope.loadingProgress = false;
        }

        function transformPathResult(paths) {
            vm.locations = paths;

            vm.paths = [];

            vm.map.paths = {};
            vm.map.locations = [];

            paths.forEach(function (locations, index) {

              var path = {
                weight: 3,
                color: '#039BE5',
                latlngs: [],
                latLongDecorations: []
              };

              var connectionPath = {
                weight: 3,
                color: '#d9c302',
                latlngs: [],
                latLongDecorations: []
              };

                locations = _.sortBy(locations, function (location) {
                    return moment(location.timestamp).toDate().getTime();
                });

                locations.forEach(function (location, idx) {

                    //manter a conversao de GMT para UTC só até ajustar na api
                    var d = moment.tz(location.timestamp, "America/Sao_Paulo");
                    location.timestamp = d.utc().format();

                    vm.paths.push(location);

                      path.latlngs.push({
                          lat: parseFloat(location.latitude),
                          lng: parseFloat(location.longitude),
                          draggable: false
                      });

                      // na ultima e primera location adicionar no 2 ao invez do 1
                      // adicionar hover deslocamento e ponto de ligacao

                      path.latLongDecorations.push([parseFloat(location.latitude), parseFloat(location.longitude)]);

                    vm.map.locations.push(location);
                });

                if (vm.showConnectionPaths && !(index === paths.length - 1) && path.latlngs && path.latlngs.length > 0 && paths[index + 1] && paths[index + 1].length > 0) {
                  connectionPath.latlngs.push({
                      lat: parseFloat(path.latlngs[path.latlngs.length - 1].lat),
                      lng: parseFloat(path.latlngs[path.latlngs.length - 1].lng),
                      draggable: false
                  });

                  connectionPath.latLongDecorations.push([parseFloat(path.latlngs[path.latlngs.length - 1].lat), parseFloat(path.latlngs[path.latlngs.length - 1].lng)]);

                  connectionPath.latlngs.push({
                      lat: parseFloat(paths[index + 1][0].latitude),
                      lng: parseFloat(paths[index + 1][0].longitude),
                      draggable: false
                  });

                  connectionPath.latLongDecorations.push([parseFloat(paths[index + 1][0].latitude), parseFloat(paths[index + 1][0].longitude)]);
                }


                vm.map.paths['p' + index] = path;
                vm.map.paths['c' + index] = connectionPath;
                vm.map.decorations.markers.coordinates.push(path.latLongDecorations);

                loadGanttData();
            });

            vm.fullPaths = vm.map.paths;

            vm.fullDecorationPaths = vm.map.decorations.markers.coordinates;

            centralizeMap(vm.map.locations, vm.map._markers);
            showWarningIfLowAccuracy();
            $rootScope.loadingProgress = false;
        }

        function centralizeMap(locations, markers) {
            if (vm.mapFitOn) {

                var boundsItems = [];

                locations.forEach(function (loc) {
                    if (loc && loc.lat && loc.lng) {
                        boundsItems.push([loc.lat, loc.lng]);
                    }
                });

                markers.forEach(function (loc) {
                    if (loc && loc.lat && loc.lng) {
                        boundsItems.push([loc.lat, loc.lng]);
                    }
                });

                var bounds = L.latLngBounds(boundsItems);
                leafletData.getMap('routesMap').then(function (map) {
                    try {
                        map.fitBounds(bounds);
                    } catch(ex) {

                    }
                });
            }
        }

        function showWarningIfLowAccuracy() {

            if (vm.map.locations && vm.map.locations.length > 0) {

                var locationsWithLowAccuracyCount = _.filter(vm.map.locations, function (location){
                    return location.accuracy > 30;
                }).length;

                var percentageLowAccuracy = (locationsWithLowAccuracyCount * 100) / vm.map.locations.length;
                percentageLowAccuracy = parseInt(percentageLowAccuracy);

                vm.showWarningLowAccuracy = percentageLowAccuracy > 15;

            } else {
                vm.showWarningLowAccuracy = false;
            }
        }


        function loadGanttData() {
            vm.ganttData = GanttData.toRows(vm.tasks, vm.locations, vm.selectedEmployee, RoutesFilters.date);
        }

        function findGanttRoute(task, callback) {

            var locations = _.sortBy(vm.paths, function (location) {
                return moment(location.timestamp).toDate().getTime();
            });

            var locationsFiltered = _.filter(locations, function (location) {
                var pathTimestamp = moment(location.timestamp);
                return pathTimestamp >= task.from && pathTimestamp <= task.to;
            });

            if(locationsFiltered.length === 0 && task.type !== 'task') {

                var indexTask = _.indexOf(vm.ganttData[0].tasks, task);
                while(locationsFiltered.length === 0 && indexTask > -1) {
                    task = vm.ganttData[0].tasks[indexTask];

                    locationsFiltered = _.filter(locations, function (location) {
                        var pathTimestamp = moment(location.timestamp);
                        return pathTimestamp >= task.from && pathTimestamp <= task.to;
                    });

                    indexTask--;
                }

                callback(locationsFiltered);
            } else {
                callback(locationsFiltered);
            }
        }

        function renderGanttFilterPath(locations) {
            var path = {
                weight: 3,
                color: '#039BE5',
                latlngs: []
            };

            var latLong = [];

            locations.forEach(function (location) {
                path.latlngs.push({
                    lat: parseFloat(location.latitude),
                    lng: parseFloat(location.longitude),
                    draggable: false
                });

                latLong.push([parseFloat(location.latitude), parseFloat(location.longitude)]);
            });

            vm.map.paths = {};
            vm.map.decorations.markers.coordinates = [];

            vm.map.paths.pathByGantt = path;
            vm.map.decorations.markers.coordinates = latLong;
        }

        function highlightPath(task, event) {
            if(!(vm.clicked && event.type === 'mouseover')) {

                findGanttRoute(task, function (locations) {
                    renderGanttFilterPath(locations);

                    if(event.type === 'click') {
                        if(task === vm.task) {
                            vm.clicked = false;
                            unhighlightPath(event);
                        } else {
                            clearActiveTaskGantt();
                            task.classes.push('active');

                            var latLngToCentralize = [];

                            if(vm.map.paths.pathByGantt.latlngs.length === 0) {
                                latLngToCentralize.push({ lat: task.lat, lng: task.lng });
                            } else {
                                latLngToCentralize = vm.map.paths.pathByGantt.latlngs;
                            }
                            centralizeMap(latLngToCentralize, []);
                            vm.selectedPaths = vm.map.paths;
                            vm.selectedDecorationsPath = vm.map.decorations.markers.coordinates;
                            vm.clicked = true;
                            vm.task = task;
                        }
                    }
                });
            }
        }

        function unhighlightPath(event) {
            if(event.type === 'click') {
                vm.clicked = false;
            }

            if(!vm.clicked) {
                clearActiveTaskGantt();
                vm.map.decorations.markers.coordinates = vm.fullDecorationPaths;
                vm.map.paths = vm.fullPaths;
                centralizeMap(vm.map.locations, vm.map._markers);
                delete vm.map.paths.pathByGantt;
                vm.task = null;
            }
        }

        function clearActiveTaskGantt() {
            vm.ganttData[0].tasks.forEach(function (task) {
                var active = task.classes.indexOf("active");
                if(active != -1) {
                    task.classes.splice(active, 1);
                }
            });
        }

        function loadEmployeeLocation() {
            var employee = vm.selectedEmployee;
            locationsApi.getLastedLocations().then(function (locations) {
                employee.location = _.find(locations, function (location) {
                    return RoutesFilters.employeeId === location.employeeId;
                });

                if (employee.location) {
                    var locationTime = moment.utc(employee.location.timestamp);
                    var utcNow = moment.utc();
                    var diffInMinutes = utcNow.diff(locationTime, 'minutes');
                    employee.location.isOnline = (diffInMinutes < 20);

                    if(employee.location.isOnline) {

                        var employeePin = '../assets/images/null-avatar.jpg';

                        if (employee.avatarUrl) {
                            employeePin = employee.avatarUrl;
                        }

                        vm.map.markers.employee = {
                            latitude: parseFloat(employee.location.latitude),
                            lat: parseFloat(employee.location.latitude),
                            longitude: parseFloat(employee.location.longitude),
                            lng: parseFloat(employee.location.longitude),
                            icon: {
                                type: 'div',
                                html: '<div>' +
                                      '    <img src="' + employeePin + '" class="marker-border-radius employee-marker">' +
                                      '</div>',
                                iconAnchor:   [20, 20], // point of the icon which will correspond to marker's location
                                popupAnchor:  [0, -20]  // point from which the popup should open relative to the iconAnchor
                            },
                            compileMessage: true
                        };
                    }
                }

                $rootScope.loadingProgress = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.recurrences')
        .controller('RecurrencesController', RecurrencesController);

    /** @ngInject */
    function RecurrencesController($rootScope, $scope, $timeout, $compile, $mdSidenav, Account,
                                   msUtils, DTColumnBuilder, moment, dataTableOptions, recurrenceRepeatHumanizer,
                                   RecurrencesFilters, recurrencesApi, RecurrenceDialog, _, dateHandler, $translate, $filter, authenticatedUser, LocalDateConvert) {

        var vm = this;
        vm.account = angular.copy(Account);
        vm.isColumnVisible = isColumnVisible;
        vm.toggleSidenav = toggleSidenav;
        vm.exportData = exportData;
        vm.addRecurrence = addRecurrence;
        vm.filteringIsOn = RecurrencesFilters.isOn;
        vm.clearFilters = RecurrencesFilters.clear;
        vm.reload = reload;
        vm.editRecurrence = _.debounce(editRecurrence, 750);
        vm.dtInstance = {};
        vm.limit = 200;
        vm.totalItems = 0;
        vm.isRecurrencesOverLimit = false;
        vm.addPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_create');
        vm.editPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_edit');

        function removeUnnecessarySentences(textContent, unnecessarySentencesArray) {
          unnecessarySentencesArray.forEach(function (sentence) {
            if (textContent.indexOf(sentence) > -1 ) {
              textContent = textContent.replaceAll(sentence, '');
            }
          });

          return textContent;
        }

        vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
            config.sAjaxDataProp = "data";
            config.processing = true;
            config.serverSide = true;
            config.searchDelay = 2000;
            config.paging = true;
            config.order = [6, 'desc'];

            config.buttons = [
              {
                isExportButton: true,
                extend: 'csvHtml5',
                className: 'hidden-button',
                filename: msUtils.shortGuidGenerator(),
                text: '.',
                exportOptions: {
                  columns: 'th:not(:last-child)'
                },
                customize: function (textContent) {
                  var unnecessarySentences = ['Inactive recurring activity', 'Active recurring activity'];

                  if (textContent) {
                    textContent = removeUnnecessarySentences(textContent, unnecessarySentences);
                  }

                  return textContent;
                }
              },
              {
                isExportButton: true,
                extend: 'excelHtml5',
                className: 'hidden-button',
                filename: msUtils.shortGuidGenerator(),
                text: '.',
                exportOptions: {
                  columns: 'th:not(:last-child)',
                   format: {
                          body: function (textContent) {
                            var unnecessarySentences = ['Inactive recurring activity', 'Active recurring activity'];
                            if(textContent) {
                              textContent = removeUnnecessarySentences(textContent, unnecessarySentences).replace(/(&nbsp;|<([^>]+)>)/ig, "");
                            }

                          return textContent;
                        },
                      }
                }
              },
              {
                isExportButton: true,
                extend: 'print',
                className: 'hidden-button',
                filename: msUtils.shortGuidGenerator(),
                text: '.',
                autoPrint: true,
                exportOptions: {
                  columns: ':visible'
                },
                customize: function (printWindow) {
                  printWindow.document.getElementsByTagName("body")[0].style = 'overflow: visible !important;';
                  printWindow.document.getElementsByTagName("html")[0].style = 'overflow: visible !important;';
                  printWindow.document.getElementsByTagName("table")[0].style = 'font-size: 10px !important;';

                  var ths = printWindow.document.querySelectorAll('th');

                  if (ths.length > 0) {
                    ths[ths.length - 1].remove();
                  }

                  var trs = printWindow.document.querySelectorAll('tr');
                  for (var i = 0; i < trs.length; i++) {
                    var tds = trs[i].getElementsByTagName("td");

                    if (tds.length > 0) {
                      tds[tds.length - 1].remove();
                    }
                  }

                  printWindow.document.body.querySelectorAll('td').forEach(function (td) {
                    if (td && td.textContent) {
                      var unnecessarySentences = ['Inactive recurring activity', 'Active recurring activity'];

                      td.textContent = removeUnnecessarySentences(td.textContent, unnecessarySentences);
                    }
                  });
                }
              }
            ];

            config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
              $rootScope.loadingProgress = true;

              var queryParams = {
                where: {},
                take: aoData[4].value,
                skip: aoData[3].value
              };

              queryParams.where['serviceIds'] = RecurrencesFilters.services.map(function (e) { return e.id; });

              if (RecurrencesFilters.customer) {
                queryParams.where['customerNameContains'] = RecurrencesFilters.customer;
              }

              if (RecurrencesFilters.startDate) {
                queryParams.where['repeatFromGte'] = moment(RecurrencesFilters.startDate).format('YYYY-MM-DD');
              }

              if (RecurrencesFilters.endDate) {
                queryParams.where['repeatFromLte'] = moment(RecurrencesFilters.endDate).format('YYYY-MM-DD');
              }

              if (RecurrencesFilters.recurrenceDateDeadlineFrom) {
              queryParams.where['repeatUntilGte'] = moment(RecurrencesFilters.recurrenceDateDeadlineFrom).format('YYYY-MM-DD');
              }
              if (RecurrencesFilters.recurrenceDateDeadlineTo) {
              queryParams.where['repeatUntilLte'] = moment(RecurrencesFilters.recurrenceDateDeadlineTo).format('YYYY-MM-DD');
              }

              if (RecurrencesFilters.notes) {
                queryParams.where['noteContains'] = RecurrencesFilters.notes;
              }

              if (RecurrencesFilters.location) {
                queryParams.where['locationNameContains'] = RecurrencesFilters.location;
              }

              if (RecurrencesFilters.archived === '1') {
                queryParams.where['archived'] = false;
              } else if (RecurrencesFilters.archived === '0') {
                queryParams.where['archived'] = true;
              }

              if (RecurrencesFilters.employees.length > 0) {
                queryParams.where['employeeIds'] = RecurrencesFilters.employees;
              }

              var sort = '';
              if (aoData[2].value && aoData[2].value[0]) {
                var columnOrder = aoData[2].value[0];
                var columnIndex = columnOrder.column;
                if (vm.dtColumns[(columnIndex)].sortBy) {
                  if(vm.dtColumns[columnIndex].sortBy.includes('_')) {
                    var sortArray = vm.dtColumns[columnIndex].sortBy.split('_');
                    sort += sortArray[0] + sortArray[1].charAt(0).toUpperCase() + sortArray[1].slice(1);
                  } else {
                    sort += vm.dtColumns[columnIndex].sortBy;
                  }
                  sort += '_' + columnOrder.dir;
                } else {
                  sort = null;
                }
              }

              if (sort) {
                queryParams.orderBy = sort;
              }

              if (!sort) {
                queryParams.orderBy = 'createdAt_desc';
              }

              recurrencesApi.search(queryParams).then(function (result) {
                result.items.forEach(function (recurrence) {
                  if (!recurrence.employee) {
                    recurrence.employee = { name: '' };
                  }
                });

                vm.limit = vm.account.configuration.featureRecurrencesLimit;
                vm.totalItems = result.totalCount;

                vm.isRecurrencesOverLimit = vm.totalItems >= vm.limit;

                fnCallback({
                  'draw': aoData[0].value,
                  'recordsTotal': vm.totalItems,
                  'recordsFiltered': vm.totalItems,
                  'data': result.items
                });

                $rootScope.loadingProgress = false;
              });
            }, 1000);

            config.createdRow = function (row) {
              $compile(angular.element(row).contents())($scope);
            };

            config.columnDefs = [{ "width": "40%", "targets": 3 }];
        });


        var customerColumn = DTColumnBuilder.newColumn(null, $translate.instant('RECURRENCES.MODEL.CUSTOMER')).renderWith(function (data) {
            var templateHtml = '<div layout="row" layout-align="start center">';
            if (data.archived) {
                templateHtml += '<div class="quantity-indicator md-red-500-bg">';
                templateHtml += '<md-tooltip><span translate="RECURRENCES.TABLE.INACTIVE">Inactive recurring activity</span></md-tooltip>';
                templateHtml += '</div>';
            } else {
                templateHtml += '<div class="quantity-indicator md-green-600-bg">';
                templateHtml += '<md-tooltip><span translate="RECURRENCES.TABLE.ACTIVE">Active recurring activity</span></md-tooltip>';
                templateHtml += '</div>';
            }

            templateHtml += '<div>'+ data.customer.name +'</div>';
            templateHtml += '</div>';
            return templateHtml;
        });
        customerColumn.sortBy = 'customer_name';

        var employeeColumn = DTColumnBuilder.newColumn(null, $translate.instant('RECURRENCES.MODEL.EMPLOYEE')).renderWith(function (data) {
            if (data && data.employee && data.employee.name) {
                return data.employee.name;
            }
            return $translate.instant('RECURRENCES.MODEL.NO_EMPLOYEE');
        });
        employeeColumn.sortBy = 'employee_name';

        var serviceColumn = DTColumnBuilder.newColumn('service.description', $translate.instant('RECURRENCES.MODEL.SERVICE'));
        serviceColumn.sortBy = 'service_name';

        var createdAtColumn = DTColumnBuilder.newColumn(null, $translate.instant('RECURRENCES.TABLE.CREATED_AT')).renderWith(function (data) {
            return LocalDateConvert.formatDateTime(data.metadata.createdAt);
        });
        createdAtColumn.sortBy = 'created_at';

        var startAtColumn = DTColumnBuilder.newColumn(null, $translate.instant('RECURRENCES.TABLE.START_AT')).renderWith(function (data) {
            return LocalDateConvert.formatDate(data.repeat.from);
        })
        .notSortable();

        var endAtColumn = DTColumnBuilder.newColumn(null, $translate.instant('RECURRENCES.TABLE.END_AT')).renderWith(function (data) {
            return LocalDateConvert.formatDate(data.repeat.until);
        })
        .notSortable();

        var locationColumn = DTColumnBuilder.newColumn(null, $translate.instant('RECURRENCES.MODEL.LOCATION')).renderWith(function (data) {
            if (data && data.location) {
                return data.location.name;
            }
            return $translate.instant('RECURRENCES.MODEL.ERRORS.NO_LOCATIONS.TEXT');
        });
        locationColumn.sortBy = 'location_name';

        vm.dtColumns = [

            customerColumn,
            employeeColumn,
            serviceColumn,

            DTColumnBuilder.newColumn(null, $translate.instant('RECURRENCES.TABLE.RECURRENCE'))
                .renderWith(function (data) {
                    return recurrenceRepeatHumanizer.getShortExplanationText(data);
                })
                .notSortable(),

            locationColumn,

            DTColumnBuilder.newColumn(null, $translate.instant('RECURRENCES.TABLE.OBSERVATIONS'))
                .renderWith(function (data) {
                  if(data && data.notes){
                    return '<div class="task-description-column recurrence-description">' +
                    '<span title="' + data.notes + '">' + $filter('maxLength')(data.notes, 70) + '</span>' +
                    '</div>';
                  }
                  return '';
                })
                .notSortable(),

            DTColumnBuilder.newColumn('archived', $translate.instant('RECURRENCES.MODEL.ARCHIVED'))
                .notVisible()
                .notSortable(),

            createdAtColumn,
            startAtColumn,
            endAtColumn,

            DTColumnBuilder.newColumn(null, $translate.instant('RECURRENCES.TABLE.ACTIONS'))
                .renderWith(function (data) {
                  var label = vm.editPermission === true ? $translate.instant('TASKS.TABLE.ROWS.ACTION.EDIT') : $translate.instant('TASKS.TABLE.ROWS.ACTION.VIEW') ;
                  var icon = vm.editPermission === true ? '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' : '<md-icon md-font-icon="icon-eye" alt="Edit"></md-icon>';
                    return '<md-button data-cy="edit-recurrence-button" class="md-icon-button" ' +
                           'ng-click="vm.editRecurrence($event, \'' + data.id + '\')" aria-label="more"> ' +
                           icon +
                                '<md-tooltip md-direction="right">' +
                                  label +
                                '</md-tooltip>' +
                           '</md-button>';
                })
                .withClass('no-margin-important no-padding-important')
                .notSortable()
                .withOption('responsivePriority', 1)
        ];

        vm.dtInstanceCallback = function (_dtInstance) {
            vm.dtInstance = _dtInstance;
            vm.dtInstance.DataTable.on('draw', function () {
                $('.call-to-action').remove();
                document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop = 0;
                var message = vm.addPermission === true ? '<span translate="RECURRENCES.TABLE.CREATE_RECURRENCE_CTA">You can create a new recurrence</span> ' +
                '<a class="cursor-pointer" translate="RECURRENCES.TABLE.CREATE_RECURRENCE_LINK" ng-click="vm.addRecurrence($event)">clicking here</a>.' :
                '';
                var ctaNewRecurrence = $compile('<div class="call-to-action">' +
                        message +
                    '</div>')(($scope));
                $('.dataTables_empty').append($(ctaNewRecurrence));
            });
            if (vm.dtInstance) {
                fixTableHeaders();
            }
        };

        function fixTableHeaders() {

            $('.dataTables_scrollHeadInner table thead th').each(function () {
                var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
                $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
            });
            var visibleColumnsCount = 1;
            for (var index = 0; index < vm.dtColumns.length; index++) {
                if (isColumnVisible(index)) {
                    visibleColumnsCount++;
                }
            }
            $('.dataTables_empty').attr('colspan', visibleColumnsCount);
        }

        function isColumnVisible(index) {
            if (vm.dtInstance) {
                return vm.dtInstance.DataTable.column(index).visible();
            }
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function exportData(actionName, clickClassNameCallback) {
            if (actionName) {
                $timeout(function () {
                    if (clickClassNameCallback) {
                        document.getElementsByClassName(clickClassNameCallback)[0].click();
                    }
                }, 1000);
            }
        }

        $scope.$on('recurrences:filter-updated', function () {
            loadRecurrences(true);
        });

        function loadRecurrences(resetPaging) {
            if (!resetPaging) {
                resetPaging = false;
            }
            vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
        }

        function reload() {
            loadRecurrences();
        }

        function addRecurrence($event) {
            RecurrenceDialog.createRecurrence($event, function (reload) {
                if (reload) {
                    loadRecurrences();
                }
            });
        }

        function editRecurrence(ev, id) {
            RecurrenceDialog.editRecurrence(ev, id, function (reload) {
                if (reload) {
                    loadRecurrences();
                }
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.quotations')
    .controller('QuotationsController', QuotationsController);

  /** @ngInject */
  function QuotationsController(
    account, $location, quotationsApi, QuotationsFilters, QuotationsDialog, exportsApi,
    $translate, $compile, $scope, $mdSidenav, $rootScope, _, $mdDialog, MessageDialog,
    dataTableOptions, DTColumnBuilder, CurrencyService, QueryStringParser, authenticatedUser,
    dataTableHelperService, $localStorage, LocalDateConvert, $filter, OpenNotificationService
  ) {
    var vm = this;

    vm.account = account;
    vm.profileId = authenticatedUser.profile.id;
    vm.quotationsFilters = QuotationsFilters;
    vm.clearFilters = vm.quotationsFilters.clear;
    vm.filteringIsOn = vm.quotationsFilters.isOn;
    vm.queryParams = {};
    vm.totalRows = 0;
    vm.exportingDataLoading = false;
    vm.currencySymbol = CurrencyService.currencySymbol;

    vm.reload = _.debounce(_reloadDatatable, 1000);
    vm.toggleSidenav = toggleSidenav;
    vm.addQuotation = addQuotation;
    vm.editQuotation = editQuotation;
    vm.redirectToTasksPage = redirectToTasksPage;
    vm.exportData = exportData;
    vm.toggleColumnVisibility = toggleColumnVisibility;
    vm.isColumnVisible = _isColumnVisible;
    vm.dtLocalStorageStatus = dtLocalStorageStatus;
    vm.dtLocalStorageRemove = dtLocalStorageRemove;

    function _initialize() {
      _startDataTable();
      _loadPreDefinedFilters();

      $scope.$on('quotations:reload', function () {
        vm.reload();
      });
    }

    OpenNotificationService.openQuotationDialog($location);

    function addQuotation($event) {
      QuotationsDialog.createQuotation($event, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    }

    function editQuotation(ev, id) {
      QuotationsDialog.editQuotation(ev, id, null, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    }

    function redirectToTasksPage(id) {
      $location.path('/atividades').search({ orderId: id });
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function toggleColumnVisibility(index) {
      var visibility = !vm.dtInstance.DataTable.column(index).visible();
      vm.dtInstance.DataTable.column(index).visible(visibility);
      var columnsVisible = [];

      for (var index = 0; index < vm.dtColumns.length; index++) {
        columnsVisible.push(vm.dtInstance.DataTable.column(index).visible());
      }

      $localStorage.setObject('dtQuotationsColumnsVisibility-' + vm.profileId, columnsVisible);
      fixTableHeaders();
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (_isColumnVisible(index)) {
          visibleColumnsCount++;
        }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function dtLocalStorageRemove() {
      $localStorage.remove('dtQuotationsColumnsVisibility-' + vm.profileId);
      for (var index = 0; index < vm.dtColumns.length; index++) {
        vm.dtInstance.DataTable.column(index).visible((vm.dtColumns[index].bVisible === false) ? false : true);
      }
      fixTableHeaders();
    }

    function dtLocalStorageStatus() {
      if ($localStorage.getObject('dtQuotationsColumnsVisibility-' + vm.profileId).length) {
        return true;
      }
      return false;
    }

    function exportData() {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('QUOTATIONS.EXPORT.TITLE'))
        .htmlContent($translate.instant('QUOTATIONS.EXPORT.CONTENT', { email: authenticatedUser.profile.email }))
        .ok($translate.instant('QUOTATIONS.EXPORT.OK'))
        .cancel($translate.instant('QUOTATIONS.EXPORT.CANCEL'));

      vm.exportingDataLoading = true;

      $mdDialog.show(confirm).then(function () {
        exportsApi.exportFeature('quotations', vm.queryParams, {
          timezone: moment.tz.guess()
        }).then(function (result) {
          $mdDialog.hide();

          MessageDialog.showToast({
            message: $translate.instant('QUOTATIONS.TOAST.EXPORTED', { email: authenticatedUser.profile.email })
          });

          return result;
        }).finally(function () {
          vm.exportingDataLoading = false;
        });
      }).catch(function () {
        vm.exportingDataLoading = false;
      });
    }

    function _fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (_isColumnVisible(index)) { visibleColumnsCount++; }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function _isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function _loadPreDefinedFilters() {
      var search = $location.search();
      if (search && search.q) {
        var queryOptions = {
          keywords: ['identifier', 'name', 'customerName', 'status', 'state', 'etiqueta']
        };

        var queryResult = QueryStringParser.parse(search.q, queryOptions);
        if (queryResult) {
          var archivedStates = ['-1', '0', '1'];
          var quotationsStatus = ['pending', 'approved', 'refused', 'expired', 'canceled'];

          if (queryResult['identifier']) {
            QuotationsFilters.identifier = queryResult['identifier'];
          }

          if (queryResult['name']) {
            QuotationsFilters.name = queryResult['name'];
          }

          if (queryResult['customerName']) {
            QuotationsFilters.customer = queryResult['customerName'];
          }

          if (queryResult['status'] && quotationsStatus.includes(queryResult['status'])) {
            QuotationsFilters.status.push(queryResult['status']);
          }

          if (queryResult['state'] && archivedStates.includes(queryResult['state'])) {
            QuotationsFilters.archived = queryResult['state'];
          }

          if(queryResult['etiqueta']) {
            QuotationsFilters.labels.push(queryResult['etiqueta']);
          }
        }
      }
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 1000;
        config.paging = true;
        config.buttons = [];
        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          vm.queryParams = vm.quotationsFilters.toSearchOptions();
          var queryParams = dataTableHelperService.toGraphqlVariables({
            aoData: aoData,
            columns: vm.dtColumns,
            where: vm.queryParams.graphQL
          });

          quotationsApi.search(queryParams)
            .then(function (result) {
              vm.totalRows = result.totalItems;

              fnCallback({
                draw: aoData[0].value,
                recordsTotal: result.totalCount,
                recordsFiltered: result.totalCount,
                data: _.filter(result.items, function (item) { return Boolean(item); })
              });
            }).finally(function () {
              $rootScope.loadingProgress = false;
            });
        }, 500);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });
      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        _addCallToActionButton();
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          _addCallToActionButton();
          _fixTableHeaders();
        });

        if (vm.dtInstance) {
          if ($localStorage.getObject('dtQuotationsColumnsVisibility-' + vm.profileId).length !== vm.dtColumns.length) {
            dtLocalStorageRemove();
          } else if ($localStorage.getObject('dtQuotationsColumnsVisibility-' + vm.profileId).length) {
            for (var index = 0; index < vm.dtColumns.length; index++) {
              vm.dtInstance.DataTable.column(index).visible($localStorage.getObject('dtQuotationsColumnsVisibility-' + vm.profileId)[index]);
            }
          }
          fixTableHeaders();
        }
      };
    }

    function _addCallToActionButton() {
      $('.call-to-action').remove();

      var ctaNewProductService = $compile('<div class="call-to-action">' +
        '<span translate="QUOTATIONS.TABLE.CREATE_QUOTATIONS_CTA">You can create a new product or service</span> ' +
        '<a class="cursor-pointer" translate="QUOTATIONS.TABLE.CREATE_QUOTATIONS_LINK" ng-click="vm.addQuotation($event)">clicking here</a>.' +
      '</div>')(($scope));

      $('.dataTables_empty').append($(ctaNewProductService));
    }

    function _getDtColumns() {
      var idColumn = DTColumnBuilder.newColumn('id', 'id')
        .notVisible();

      var identifierColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.IDENTIFIER'))
        .renderWith(function (data) {
          var templateHtml = '<div>' + data.identifier + '</div>';
          if (data && data.labels && data.labels.length) {
            templateHtml += '<div class="column-order-identifier ww-break-word">';
            data.labels.forEach(function (label) {
              templateHtml += '<i class="icon-label s12 icon ' + label.color + '-fg">';
              templateHtml += '<md-tooltip>&nbsp;' + label.name + '</md-tooltip>';
              templateHtml += '</i>';
            });
            templateHtml += '</div>';
          }
          return templateHtml;
        })
        .notSortable();
        var customerNameColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.CUSTOMER'))
          .renderWith(function (data) {
            return '<span class="table-text">' + data.customer.name + '</span>';
          }).withOption('width', '20%');
      customerNameColumn.sortBy = 'customerName';

      var nameColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.NAME'))
        .renderWith(function (data) {
          return data.name;
        }).notSortable();

      var descriptionColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.DESCRIPTION'))
        .renderWith(function (data) {
          return '<div class="quotation-description-column">' +
          '<span title="'+data.description+'">' + data.description + '</span>' +
          '</div>';
        })
        .notVisible()
        .notSortable();

      var expiredAtColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.EXPIRED_AT'))
        .renderWith(function (data) {
          return data.expiredAt ? LocalDateConvert.formatDate(data.expiredAt, 'date') : '';
        });
      expiredAtColumn.sortBy = 'expiredAt';

      var totalColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.TOTAL', { currency: vm.currencySymbol }))
        .renderWith(function (data) {
          return $filter('currencyFormat')(data.total);
        });
      totalColumn.sortBy = 'total';

      var orderIdentifierColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.OS_IDENTIFIER'))
        .renderWith(function (data) {
          if (data.order) {
            return '<div layout="row" layout-align="start center" class="link cursor-pointer" ng-click="vm.redirectToTasksPage(\'' + data.order.id + '\')">' +
                '<a class="link-text">' + data.order.identifier + '</a>' +
                '<md-icon md-font-icon="icon-open-in-new" class="link-icon"></md-icon>' +
              '</div>';
          }
          return '';
        });

      var statusColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.STATUS'))
        .renderWith(function (data) {
          var status = $translate.instant('QUOTATIONS.STATUS.' + data.status.toUpperCase());
          return '<span class="quotation-status-' + data.status + '-fg">'+ status +'</span>';
        });
      statusColumn.sortBy = 'status';

      var createdAtColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.CREATED_AT'))
        .renderWith(function (data) {
          return data.createdAt ? LocalDateConvert.formatDate(data.createdAt, 'date-time'): '';
        });
      createdAtColumn.sortBy = 'createdAt';

      var createdByColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.CREATED_BY'))
      .renderWith(function (data) {
        return data.createdBy;
      });

      var actionsColumn = DTColumnBuilder.newColumn(null, $translate.instant('QUOTATIONS.TABLE.ACTIONS'))
        .renderWith(function (data) {
          var eventClick = 'ng-click="vm.editQuotation($event,\'' + data.id + '\')"';
          return (
            '<md-button aria-label="more" data-cy="quotation-edit-button" class="md-icon-button"' + eventClick + '>' +
            '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
            '<md-tooltip md-direction="left"><span translate="QUOTATIONS.TABLE.VIEW">View</span></md-tooltip>' +
            '</md-button>'
          );
        })
        .notSortable()
        .withOption('responsivePriority', 1);

      return [
        idColumn,
        identifierColumn,
        customerNameColumn,
        nameColumn,
        orderIdentifierColumn,
        descriptionColumn,
        expiredAtColumn,
        totalColumn,
        statusColumn,
        createdAtColumn,
        createdByColumn,
        actionsColumn
      ];
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(function () {
        $('md-tooltip').hide();
      }, resetPaging);
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.products-services')
    .controller('ProductsServicesController', ProductsServicesController);

  /** @ngInject */
  function ProductsServicesController(
    account, ProductsServicesFilters, productsServicesApi, ProductsServicesDialog, $translate, $compile,
    $mdSidenav, $scope, $rootScope, _, dataTableOptions, DTColumnBuilder, CurrencyFormat, ProductsMeasuresOptions,
    IntegrationsService, FcModalService, omieApi, msUtils, omieProductMapper, FcToastService, $document,
    $mdDialog, $timeout, UtilityFunctions, authenticatedUser, exportsApi, $mdToast, LocalDateConvert
  ) {
    var vm = this;

    vm.currentPage = 1;
    vm.totalPages = 1;
    vm.limitPerPage = 100;
    vm.totalProductsToImport = 0;
    vm.totalProductsImported = 0;
    vm.importedProductsProgress = 0;
    vm.measuresSelectOptions = ProductsMeasuresOptions.measures;
    vm.integrations = IntegrationsService.getAll();
    vm.showIntegrationButton = showIntegrationButton;
    vm.openImportOmieDialog = openImportOmieDialog;
    vm.exportProductsServices = exportProductsServices;

    $scope.$on('products-services:reload', function () {
      vm.reload();
    });

    vm.addProductService = addProductService;
    function addProductService($event) {
      ProductsServicesDialog.createProductService($event, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    }

    vm.editProductService = editProductService;
    function editProductService(ev, id) {
      ProductsServicesDialog.editProductService(ev, { id: id }, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    }

    function showIntegrationButton(appName) {
      if (appName === 'Omie') {
        return vm.integrations.omie;
      }
      return false;
    }

    function _getOmieProductsToImport() {
      return omieApi.products.list({
        pagina: vm.currentPage,
        registros_por_pagina: vm.limitPerPage,
        exibir_obs: 'S'
      })
        .then(function (response) {
          if (!(response && response.data)) { return; }
          var formattedResponse = {
            totalItems: response.data.total_de_registros,
            products: response.data.produto_servico_cadastro,
            totalPages: response.data.total_de_paginas,
          };
          return formattedResponse;
        })
        .catch(function () {
          FcToastService.addWarning({
            hideDelay: 5000,
            position: 'BOTTOM LEFT',
            title: $translate.instant('PRODUCTS_SERVICES.IMPORT.LOADING_ERROR'),
            customClass: 'import-error-toast',
            iconPath: 'assets/icons/icon-service-error.svg',
            errorType: 'import-error-toast',
            noExit: true
          });
        });
    }

    function exportProductsServices($event) {
      FcModalService.open($event, {
        title: $translate.instant('PRODUCTS_SERVICES.EXPORT.TITLE'),
        templateUrl: 'app/main/products-services/templates/export-products-services.html',
        content: $translate.instant('PRODUCTS_SERVICES.EXPORT.CONTENT', { email: authenticatedUser.profile.email }),
        variables: {
          confirmActionContent: $translate.instant('PRODUCTS_SERVICES.EXPORT.CONFIRM_ACTION_CONTENT')
        },
        rightButtonText: $translate.instant('PRODUCTS_SERVICES.EXPORT.YES'),
        leftButtonText: $translate.instant('PRODUCTS_SERVICES.EXPORT.NO'),
        handleRightButton: function () {
          var queryOptions = _formatQueryOptions();
          exportsApi.exportFeature('products-services', {
            graphQL: queryOptions
           }, {
            timezone: moment.tz.guess()
          }).then(function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('PRODUCTS_SERVICES.EXPORT.SPREADSHEET_SENT', {
                  email: authenticatedUser.profile.email
                }))
                .hideDelay(5000)
            );
          }).catch(function (err) {
            $mdDialog.hide();
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('PRODUCTS_SERVICES.EXPORT.SPREADSHEET_ERROR'))
                .hideDelay(5000)
            );
          });
        },
        handleLeftButton: function () {}
      });
    }

    function _formatQueryOptions() {
      var filterOptions = {
        nameContains: vm.productsServicesFilters.name || '',
      };

      if (vm.productsServicesFilters.type !== '-1') {
        filterOptions.type = vm.productsServicesFilters.type;
      }

      if (vm.productsServicesFilters.archived !== '-1') {
        filterOptions.archived = !(Number(vm.productsServicesFilters.archived));
      }

      return filterOptions;
    }

    function openImportOmieDialog($event, exportType) {
      if (exportType === 'manual') {
        _openOmieManualImportDialog();
      } else {
        $rootScope.loadingProgress = true;
        _getOmieProductsToImport()
          .then(function (response) {
            if (!(response && response.totalItems)) { return _throwDefaultWarning(true); }
            if (response.totalItems > 5000) {
              return FcToastService.addWarning({
                hideDelay: 5000,
                position: 'BOTTOM LEFT',
                title: $translate.instant('CUSTOMERS.INTEGRATIONS.AUTOMATIC_IMPORT_ERROR_LIMIT'),
                customClass: 'import-error-toast',
                iconPath: 'assets/icons/icon-service-error.svg',
                errorType: 'import-error-toast'
              });
            }
            vm.totalPages = response.totalPages;
            vm.totalProductsToImport = response.totalItems;
            FcModalService.open($event, {
              title: $translate.instant('PRODUCTS_SERVICES.IMPORT.TITLE', { app: 'Omie' }),
              content: $translate.instant('PRODUCTS_SERVICES.IMPORT.CONTENT', { quantity: vm.totalProductsToImport }),
              leftButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.IMPORT'),
              rightButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
              handleLeftButton: function () {
                $rootScope.loadingProgress = true;
                _openOmieAutomaticImportLoadingModal($event);
                _importAllProducts(response.products);
              }
            });
          })
          .finally(function () {
            $rootScope.loadingProgress = false;
          });
      }
    }

    function _importAllProducts(currentProductsToImport) {
      if (currentProductsToImport && currentProductsToImport.length) {
        return _importProducts(currentProductsToImport);
      }

      _getOmieProductsToImport()
        .then(function (response) {
          var currentProductsToImport = response.products;
          vm.totalPages = response.totalPages;
          _importProducts(currentProductsToImport);
        })
        .catch(function () {
          $rootScope.loadingProgress = false;
        });
    }


    function _importProducts(currentProductsToImport) {
      var productsToSaveInfos = _updateAndGetProductsToSaveIntegrationCode(currentProductsToImport);
      if (!(productsToSaveInfos && productsToSaveInfos.length)) {
        return _repeatImportProccessIfNecessary();
      }
      var savingProductsPromises = productsToSaveInfos.map(function (info) {
        return info.promise;
      });
      _updateAllProductsIntegrationCodes(savingProductsPromises, productsToSaveInfos)
        .finally(function () {
          _repeatImportProccessIfNecessary();
        });
    }

    function _saveIntegrationCodeOnOmie(fieldControlProduct) {
      var omieProduct = omieProductMapper.toOmie(fieldControlProduct);
      return omieApi.products.update(omieProduct)
        .then(function (updatedOmieProduct) {
          omieProduct = updatedOmieProduct;
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function _updateOmieIntegrationCode(productsGroups) {
      var currentUpdateGroupIndex = 0;
      var lastArrayIndex = productsGroups.length - 1;
      $timeout(function () {
        var groupToUpdate = productsGroups[currentUpdateGroupIndex];
        groupToUpdate.forEach(function (fieldProduct) {
          var omieProduct = omieProductMapper.toOmie(fieldProduct);
          return omieApi.products.update(omieProduct)
            .finally(function () {
              _productHasImported();
            });
        });

        if (currentUpdateGroupIndex < lastArrayIndex) {
          currentUpdateGroupIndex++;
          _updateOmieIntegrationCode(productsGroups);
        } else {
          currentUpdateGroupIndex = 0;
        }
      }, 1000);
    }

    function _updateAndGetProductsToSaveIntegrationCode(currentProducts) {
      var productsToSaveInfos = [];
      currentProducts.forEach(function (product) {
        var fieldControlProduct = omieProductMapper.toFieldControl(product);
        if (fieldControlProduct.integrationId && msUtils.isUuidV4(fieldControlProduct.integrationId)) {
          _updateFieldProduct(fieldControlProduct);
        } else {
          productsToSaveInfos.push({ promise: productsServicesApi.save(fieldControlProduct), product: fieldControlProduct });
        }
      });
      return productsToSaveInfos;
    }

    function _createFieldProduct(productToCreate) {
      $rootScope.loadingProgress = true;
      productsServicesApi.save(productToCreate)
        .then(function (savedProduct) {
          productToCreate.integrationId = savedProduct.id;
          _saveIntegrationCodeOnOmie(productToCreate);
          productToCreate.selected = true;
        });
    }

    function _updateFieldProduct(fieldControlProduct) {
      productsServicesApi.put(fieldControlProduct.integrationId, fieldControlProduct)
      .catch(function (response) {
        if (response.status === 404) {
          _createFieldProduct(response.config.data);
        }
      })
      .finally(function () {
          _productHasImported();
        });
    }

    function _updateAllProductsIntegrationCodes(savingProductsPromises, productsToSaveInfos) {
      return Promise.all(savingProductsPromises)
        .then(function (createdProducts) {
          var productsToUpdateIntegrationId = omieProductMapper.groupEqualProductsToUpdateIntegrationCode(createdProducts, productsToSaveInfos);
          var productsGroupsToUpdateOnOmie = UtilityFunctions.splitItemsByQuantity(productsToUpdateIntegrationId, 3);
          if (productsGroupsToUpdateOnOmie && productsGroupsToUpdateOnOmie.length) {
            _updateOmieIntegrationCode(productsGroupsToUpdateOnOmie);
          }
        })
        .catch(function () {
          _throwDefaultWarning(true);
        });
    }

    function _repeatImportProccessIfNecessary() {
      if (vm.currentPage >= vm.totalPages) {
        _throwDefaultWarning(false);
        $rootScope.loadingProgress = false;
        vm.currentPage = 1;
      } else {
        vm.currentPage++;
        _importAllProducts();
      }
    }

    function _openOmieAutomaticImportLoadingModal($event) {
      vm.loadingImportModalId = msUtils.uuidGenerator();
      FcModalService.open($event, {
        title: $translate.instant('PRODUCTS_SERVICES.IMPORT.IMPORT_LOADING_TITLE'),
        templateUrl: 'app/main/products-services/sidenavs/import-modal/import-products-services-modal.html',
        modalId: vm.loadingImportModalId,
        eventNameToSubscribe: 'update-imported-products-progress',
        variables: {
          title: $translate.instant('PRODUCTS_SERVICES.IMPORT.WAIT_LOADING'),
          progressPercentage: vm.importedProductsProgress,
          totalProductsImported: vm.totalProductsImported,
          totalProductsToImport: vm.totalProductsToImport
        },
        leftButtonText: $translate.instant('PRODUCTS_SERVICES.IMPORT.CLOSE')
      }, null);
    }

    function _openOmieManualImportDialog() {
      $mdDialog.show({
        controller: 'OmieManualImportDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/products-services/dialogs/omie-manual-import/omie-manual-import-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        targetEvent: null,
        escapeToClose: false,
        multiple: true,
        locals: null
      }).then(function () {
        vm.reload();
      });
    }

    function _productHasImported() {
      vm.totalProductsImported++;
      vm.importedProductsProgress = (vm.totalProductsImported * 100) / vm.totalProductsToImport;
      $rootScope.$broadcast('update-imported-products-progress', {
        totalProductsImported: vm.totalProductsImported,
        progressPercentage: vm.importedProductsProgress
      });

      if (vm.importedProductsProgress >= 100) {
        $rootScope.loadingProgress = false;
        FcModalService.close(vm.loadingImportModalId);
        vm.reload();
        vm.importedProductsProgress = 0;
        vm.totalProductsImported = 0;
        vm.totalProductsToImport = 0;
        return _throwDefaultWarning(false);
      }
    }

    function _throwDefaultWarning(isError) {
      var toastTitleTranslateKey = isError ? 'UPDATE_ERROR' : 'SUCCESS_AUTOMATIC';
      var toastCustomClass = isError ? 'import-error-toast' : 'import-finished-toast';
      var toastIconPath = isError ? 'assets/icons/icon-service-error.svg' : 'assets/icons/icon-success-circle-green.svg';
      return FcToastService.addWarning({
        hideDelay: 5000,
        position: 'BOTTOM LEFT',
        title: $translate.instant('PRODUCTS_SERVICES.IMPORT.' + toastTitleTranslateKey),
        customClass: toastCustomClass,
        iconPath: toastIconPath,
        errorType: toastCustomClass,
        noExit: true
      });
    }

    function findMeasureSelected(measureValue) {
      if (!measureValue) { return ''; }

      var measure = vm.measuresSelectOptions.find(function (measure) {
        return measure.value === measureValue;
      });
      return measure;
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [];
        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var sort = '';
          if (aoData[2].value && aoData[2].value[0]) {
            var columnOrder = aoData[2].value[0];
            if (columnOrder.dir === 'desc') { sort += '-'; }

            switch (columnOrder.column) {
              case 1:
                sort += 'name';
                break;
              case 2:
                sort += 'value';
                break;
              case 3:
                sort += 'type';
                break;
              case 4:
                sort += 'createdAt';
                break;
              default:
                sort = null;
                break;
            }
          }

          var queryOptions = {
            offset: aoData[3].value,
            limit: aoData[4].value,
            sort: '-createdAt'
          };

          if (sort) { queryOptions.sort = sort; }
          var queryParams = {};
          if (vm.productsServicesFilters) {
            if (vm.productsServicesFilters.archived === '1') {
              queryParams['archived'] = 'no';
            } else if (vm.productsServicesFilters.archived === '0') {
              queryParams['archived'] = 'yes';
            }
            if (vm.productsServicesFilters.name) {
              queryParams['name~~*'] = '*' + vm.productsServicesFilters.name + '*';
            }
            if (vm.productsServicesFilters.type !== '-1') {
              queryParams['type'] = vm.productsServicesFilters.type;
            }
          }

          productsServicesApi.search(queryParams, queryOptions).then(function (result) {
            vm.productsServices = result.items;
            vm.totalProductsServices = result.totalItems;
          }).finally(function () {
            fnCallback({
              'draw': aoData[0].value,
              'recordsTotal': vm.totalProductsServices,
              'recordsFiltered': vm.totalProductsServices,
              'data': vm.productsServices
            });
            $rootScope.loadingProgress = false;
          });

        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });
      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        _addCallToActionButton();
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          _addCallToActionButton();
          fixTableHeaders();
        });
      };
    }

    function _addCallToActionButton() {
      $('.call-to-action').remove();

      if (!vm.account.configuration.featureDisableAddProductService) {
        var ctaNewProductService = $compile('<div class="call-to-action">' +
          '<span translate="PRODUCTS_SERVICES.TABLE.CREATE_PRODUCTS_SERVICES_CTA">You can create a new product or service</span> ' +
          '<a class="cursor-pointer" translate="PRODUCTS_SERVICES.TABLE.CREATE_PRODUCTS_SERVICES_LINK" ng-click="vm.addProductService($event)">clicking here</a>.' +
          '</div>')(($scope));

        $('.dataTables_empty').append($(ctaNewProductService));
      }
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (isColumnVisible(index)) { visibleColumnsCount++; }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function _getDtColumns() {
      return [
        DTColumnBuilder.newColumn('id', 'id').notVisible(),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS_SERVICES.TABLE.NAME')).renderWith(function (data) {
          var corporateCustomerName = (
            data.metadata &&
            data.metadata.sammathnaur &&
            data.metadata.sammathnaur.account &&
            data.metadata.sammathnaur.account.name
          );

          var corporateCustomerNameFormatted = corporateCustomerName ?
            '<em class="text-light-gray">(' + corporateCustomerName + ')</em>' : '<em>' + '</em>';

          var archivedClass = data.archived ? 'md-red-500-bg' : 'md-green-600-bg',
            archivedText = $translate.instant(data.archived ? 'PRODUCTS_SERVICES.TABLE.INACTIVE' : 'PRODUCTS_SERVICES.TABLE.ACTIVE'),
            templateHTML = '<div layout="row" layout-align="start center">' +
              '<div class="quantity-indicator ' + archivedClass + '">' +
              '<md-tooltip>' + archivedText + '</md-tooltip>' +
              '</div>' +
              '<span>' + data.name + ' ' + corporateCustomerNameFormatted + '</span>' +
              '</div>';
          return templateHTML;
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS_SERVICES.TABLE.TYPE')).renderWith(function (data) {
          if (data.type === 'product') {
            return $translate.instant('PRODUCTS_SERVICES.MODEL.TYPE.PRODUCT');
          }

          return $translate.instant('PRODUCTS_SERVICES.MODEL.TYPE.SERVICE');
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS_SERVICES.TABLE.MEASURE')).renderWith(function (data) {
          if (data.type === 'product' && data.measure) {
            return $translate.instant(findMeasureSelected(data.measure).translate);
          }

          return '-';
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS_SERVICES.TABLE.VALUE')).renderWith(function (data) {
          var formattedTotal = CurrencyFormat.format(data.value);
          return formattedTotal;
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS_SERVICES.TABLE.CREATED_AT')).renderWith(function (data) {
          var createdAt = (data.metadata && data.metadata.createdAt) || data.createdAt;
          if (!createdAt) { return ''; }

          return LocalDateConvert.formatDate(createdAt, 'date-time');
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS_SERVICES.TABLE.ACTIONS')).renderWith(function (data) {
          var eventClick = 'ng-click="vm.editProductService($event,\'' + data.id + '\')"';
          var isCorporateCustomer = data.metadata && data.metadata.sammathnaur;
          var templateHTML = '';

          if (data.locked && !isCorporateCustomer) {
            templateHTML = '<md-button class="md-icon-button md-button-disabled-css">' +
              '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="PRODUCTS_SERVICES.TABLE.PRODUCT_SERVICE_EDIT_NOT_ALLOWED">Edit</span></md-tooltip>' +
              '</md-button>';
          } else if (isCorporateCustomer) {
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="PRODUCTS_SERVICES.TABLE.VIEW">Edit</span></md-tooltip>' +
              '</md-button>';
          } else {
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="PRODUCTS_SERVICES.TABLE.EDIT">Edit</span></md-tooltip>' +
              '</md-button>';
          }
          return templateHTML;
        }).notSortable()
        .withOption('responsivePriority', 1)
      ];
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _initialize() {
      vm.account = account;
      vm.productsServicesFilters = ProductsServicesFilters;
      vm.clearFilters = vm.productsServicesFilters.clear;
      vm.filteringIsOn = vm.productsServicesFilters.isOn;
      vm.toggleSidenav = toggleSidenav;
      vm.reload = _.debounce(_reloadDatatable, 1000);
      _startDataTable();
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.products')
    .controller('ProductsController', ProductsController);

  /** @ngInject */
  function ProductsController(
    account, ProductsFilters, productsServicesApi, ProductsDialog, $translate, $compile, $filter,
    $mdSidenav, $scope, $rootScope, _, dataTableOptions, DTColumnBuilder, CurrencyService, ProductsMeasuresOptions,
    IntegrationsService, FcModalService, omieApi, msUtils, omieProductMapper, FcToastService, $document,
    $mdDialog, $timeout, UtilityFunctions, authenticatedUser, exportsApi, $mdToast, productTypesApiGraphQL, LocalDateConvert, productsServicesApiGraphQL
  ) {
    var vm = this;

    vm.currentPage = 1;
    vm.totalPages = 1;
    vm.limitPerPage = 100;
    vm.appId = '';
    vm.totalProductsToImport = 0;
    vm.totalProductsImported = 0;
    vm.importedProductsProgress = 0;
    vm.measuresSelectOptions = ProductsMeasuresOptions.measures;
    vm.integrations = IntegrationsService.getAll();
    vm.showIntegrationButton = showIntegrationButton;
    vm.openImportOmieDialog = openImportOmieDialog;
    vm.exportProductsServices = exportProductsServices;
    vm.addProduct = addProduct;
    vm.editProduct = editProduct;
    vm.textSanitizer = msUtils.textSanitizer;
    vm.duplicatedProducts = [];
    vm.alreadyShownDuplicateDialog = false;
    vm.currentProducts = [];

    function addProduct($event) {
      ProductsDialog.createService($event, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    }

    function editProduct(ev, id) {
      ProductsDialog.editProduct(ev, { id: id }, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    }

    function showIntegrationButton(appName) {
      if (appName === 'Omie') {
        return vm.integrations.omie;
      }
      return false;
    }

    function _getOmieProductsToImport(appId) {
      return omieApi.products.list({
        pagina: vm.currentPage,
        registros_por_pagina: vm.limitPerPage,
        exibir_obs: 'S'
      }, appId)
        .then(function (response) {
          if (!(response && response.data)) { return; }
          var products = response.data.produto_servico_cadastro;
          if (products && products.length) {
            products = products.map(function (product) {
              product.descricao = vm.textSanitizer(product.descricao);
              return product;
            });
          }
          var formattedResponse = {
            totalItems: response.data.total_de_registros,
            products: products,
            totalPages: response.data.total_de_paginas,
          };
          return formattedResponse;
        })
        .catch(function () {
          FcToastService.addWarning({
            hideDelay: 5000,
            position: 'BOTTOM LEFT',
            title: $translate.instant('PRODUCTS.IMPORT.LOADING_ERROR'),
            customClass: 'import-error-toast',
            iconPath: 'assets/icons/icon-service-error.svg',
            errorType: 'import-error-toast',
            noExit: true
          });
        });
    }

    function exportProductsServices($event) {
      FcModalService.open($event, {
        title: $translate.instant('PRODUCTS.EXPORT.TITLE'),
        templateUrl: 'app/main/products/templates/export-products-services.html',
        content: $translate.instant('PRODUCTS.EXPORT.CONTENT', { email: authenticatedUser.profile.email }),
        variables: {
          confirmActionContent: $translate.instant('PRODUCTS.EXPORT.CONFIRM_ACTION_CONTENT')
        },
        rightButtonText: $translate.instant('PRODUCTS.EXPORT.YES'),
        leftButtonText: $translate.instant('PRODUCTS.EXPORT.NO'),
        handleRightButton: function () {
          var queryOptions = _formatQueryOptions();
          exportsApi.exportFeature('products', {
            graphQL: queryOptions
           }, {
            timezone: moment.tz.guess()
          }).then(function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('PRODUCTS.EXPORT.SPREADSHEET_SENT', {
                  email: authenticatedUser.profile.email
                }))
                .hideDelay(5000)
            );
          }).catch(function (err) {
            $mdDialog.hide();
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('PRODUCTS.EXPORT.SPREADSHEET_ERROR'))
                .hideDelay(5000)
            );
          });
        },
        handleLeftButton: function () {}
      });
    }

    function _formatQueryOptions() {
      var filterOptions = {
        nameContains: vm.productsFilters.name || '',
      };

      if (vm.productsFilters.type !== '-1') {
        filterOptions.type = vm.productsFilters.type;
      }

      if (vm.productsFilters.archived !== '-1') {
        filterOptions.archived = !(Number(vm.productsFilters.archived));
      }

      if (vm.productsFilters.description) {
        filterOptions.description = vm.productsFilters.description;
      }

      if (vm.productsFilters.code) {
        filterOptions.code = vm.productsFilters.code;
      }

      if (vm.productsFilters.productType !== '-1') {
        filterOptions.productType = vm.productsFilters.productType;
      }

      if (vm.productsFilters.measure !== '-1') {
        filterOptions.measure = vm.productsFilters.measure;
      }

      return filterOptions;
    }

    function openImportOmieDialog($event, exportType) {
      if (exportType === 'manual') {
        _openOmieManualImportDialog();
      } else {
        $rootScope.loadingProgress = true;
        vm.duplicatedProducts = [];
        vm.alreadyShownDuplicateDialog = false;

        FcModalService.open($event, {
          title: $translate.instant('PRODUCTS.IMPORT.TITLE', { app: 'Omie' }),
          content: $translate.instant('PRODUCTS.IMPORT.CONTENT', { quantity: vm.totalProductsToImport }),
          paddingSmall: true,
          hasOmieAccountSelector: true,
          leftButtonText: $translate.instant('PRODUCTS.IMPORT.IMPORT_BUTTON'),
          rightButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
          handleLeftButton: function (account) {
            vm.appId = account.appId;
            _getOmieProductsToImport(account.appId)
            .then(function (response) {
              if (!(response && response.totalItems)) { return _throwDefaultWarning(true); }
              vm.totalPages = response.totalPages;
              vm.totalProductsToImport = response.totalItems;
              $rootScope.loadingProgress = false;
              _openOmieAutomaticImportLoadingModal($event);
              _importAllProducts(response.products);
            });
          },
          handleRightButton: function () {
            $rootScope.loadingProgress = false;
          }
        });
      }
    }

    function _importAllProducts(currentProductsToImport) {
      if (currentProductsToImport && currentProductsToImport.length) {
        return _importProducts(currentProductsToImport);
      }

      _getOmieProductsToImport(vm.appId)
        .then(function (response) {
          var currentProductsToImport = response.products;
          vm.totalPages = response.totalPages;
          _importProducts(currentProductsToImport);
        })
        .catch(function () {
          $rootScope.loadingProgress = false;
        });
    }


    function _importProducts(currentProductsToImport) {
      _updateAndGetProductsToSaveIntegrationCode(currentProductsToImport).then(function (productsToSaveInfos) {
        if (!(productsToSaveInfos && productsToSaveInfos.length)) {
          return _repeatImportProccessIfNecessary();
        }

        var savingProductsPromises = productsToSaveInfos.map(function (info) {
          return info.promise;
        });

        _updateAllProductsIntegrationCodes(savingProductsPromises, productsToSaveInfos)
          .finally(function () {
            _repeatImportProccessIfNecessary();
          });
      });
    }

    function throttleConcurrent(fn, limit, interval) {
      var queue = [];
      var activeCount = 0;
      var lastRequestTime = Date.now();

      function next() {
        if (queue.length === 0 || activeCount >= limit) {
          return;
        }

        var now = Date.now();
        var timeSinceLastRequest = now - lastRequestTime;

        if (timeSinceLastRequest < interval) {
          setTimeout(next, interval - timeSinceLastRequest);
          return;
        }

        activeCount++;
        lastRequestTime = Date.now();
        var item = queue.shift();
        var resolve = item.resolve;
        var reject = item.reject;
        var args = item.args;
        Promise.resolve(fn.apply(null, args))
          .then(resolve)
          .catch(reject)
          .finally(function () {
            activeCount--;
            next();
          });
      }

      return function () {
        var args = Array.prototype.slice.call(arguments);
        return new Promise(function (resolve, reject) {
          queue.push({ resolve: resolve, reject: reject, args: args });
          next();
        });
      };
    }

    var _sendUpdateToOmie = throttleConcurrent(omieApi.products.update, 4, 60000 / 240);

    var currentUpdateGroupIndex = 0;
    function _updateOmieIntegrationCode(productsGroups) {
      var lastArrayIndex = productsGroups.length - 1;
      $timeout(function () {
        var groupToUpdate = productsGroups[currentUpdateGroupIndex];
        var promises = groupToUpdate.map(function (fieldProduct) {
          var omieProduct = omieProductMapper.toOmie(fieldProduct);
          return _sendUpdateToOmie(omieProduct, vm.appId)
            .finally(function () {
              _productHasImported();
            });
        });

        Promise.all(promises).then(function () {
          if (currentUpdateGroupIndex < lastArrayIndex) {
            currentUpdateGroupIndex++;
            _updateOmieIntegrationCode(productsGroups);
          } else {
            currentUpdateGroupIndex = 0;
          }
        });
      }, 1000);
    }

    function _updateAndGetProductsToSaveIntegrationCode(currentProducts) {
      return new Promise(function (resolve, reject) {
        var productsToSaveInfos = [];

        vm.currentProducts = currentProducts;

        currentProducts.forEach(function (product) {
          var fieldControlProduct = omieProductMapper.toFieldControl(product);

          _checkIfCodeExists(fieldControlProduct).then(function (response) {
            var canUpdate = response.canUpdate;
            var productFound = response.productFound;
            fieldControlProduct.externalAppId = vm.appId;

            if (canUpdate) {
              if (fieldControlProduct.integrationId && msUtils.isUuidV4(fieldControlProduct.integrationId)) {
                _updateFieldProduct(fieldControlProduct);
              } else {
                productsToSaveInfos.push({ promise: productsServicesApi.save(fieldControlProduct), product: fieldControlProduct });
              }
            } else {
              _addToDuplicatedListOfProducts(fieldControlProduct, productFound);
            }

            resolve(productsToSaveInfos);
            }).catch(function (error) {
              reject(error);
            });
        });
      });
    }

    function _checkIfCodeExists(product) {
      return new Promise(function (resolve, reject) {
        var queryParams = {
          'code': product.code,
          type: 'product'
        };

        var queryOptions = {
          offset: 0,
          limit: 2,
          sort: '-createdAt'
        };

        productsServicesApi.search(queryParams, queryOptions).then(function (response) {
          var canUpdate = false;
          if (response && response.items && response.items.length > 0) {
            var productFound = response.items[0];
            if (productFound.code === product.code && productFound.id === product.integrationId) {
              canUpdate = true;
            }
          } else {
            canUpdate = true;
          }
          resolve({ canUpdate: canUpdate, productFound: productFound });
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function _openDuplicatedCodeOmieManualImportDialog() {
      if (!vm.duplicatedProducts.length || vm.alreadyShownDuplicateDialog) {
        return;
      }

      var names = '';
      var codes = '';
      var existingProducts = '';

      _.forEach(vm.duplicatedProducts, function (prod, index) {
        if (!prod || !prod.productToUpdate || !prod.existingProduct) {
          return;
        }

        var productToUpdate = prod.productToUpdate;
        var existingProduct = prod.existingProduct;

        if (index < 3) {
          names += '<br> - <b> ' + productToUpdate.name + '</b>;';
          codes += '<br> - <b> ' + productToUpdate.code + '</b>;';
          existingProducts += '<br> - <b> ' + existingProduct.name + '</b>;';
        } else if (index === 3) {
          names += '<br> ...';
          codes += '<br> ...';
          existingProducts += '<br> ...';
        }
      });

      FcModalService.open(null, {
        title: $translate.instant('PRODUCTS.OMIE_DIALOG.TITLE_ALL'),
        content: $translate.instant('PRODUCTS.OMIE_DIALOG.CONTENT_ALL1') + names + $translate.instant('PRODUCTS.OMIE_DIALOG.CONTENT_ALL2') + codes + $translate.instant('PRODUCTS.OMIE_DIALOG.CONTENT_ALL3') + existingProducts + $translate.instant('PRODUCTS.OMIE_DIALOG.CONTENT_ALL4'),
        paddingSmall: true,
        rightContinueButton: true,
        modalId: 'duplicated-products-dialog',
        rightButtonText: $translate.instant('PRODUCTS.OMIE_DIALOG.UPDATE'),
        leftButtonText: $translate.instant('PRODUCTS.OMIE_DIALOG.CANCEL'),
        modalClass: 'overflow-x-hidden',
        handleRightButton: function () {
          vm.totalProductsToImport = vm.duplicatedProducts.length;
          _openOmieAutomaticImportLoadingModal();

          _.forEach(vm.duplicatedProducts, function (prod) {
            if (!prod || !prod.productToUpdate || !prod.existingProduct) {
              return;
            }

            var productToUpdate = prod.productToUpdate;
            var existingProduct = prod.existingProduct;

            productToUpdate.id = existingProduct.id;
            productToUpdate.integrationId = existingProduct.id;
            _updateDuplicatedFieldProduct(productToUpdate);
          });

          vm.duplicatedProducts = [];
          vm.alreadyShownDuplicateDialog = false;
        },
        handleLeftButton: function () {
          vm.duplicatedProducts = [];
          vm.alreadyShownDuplicateDialog = false;
          finishImportProccess();

          vm.reload();
        }
      });

      vm.alreadyShownDuplicateDialog = true;
    }

    function _addToDuplicatedListOfProducts(productToUpdate, existingProduct) {
      vm.duplicatedProducts.push({
        productToUpdate: productToUpdate,
        existingProduct: existingProduct
      });

      _productHasImported();
    }

    function _updateDuplicatedFieldProduct(fieldControlProduct) {
      fieldControlProduct.externalAppId = vm.appId;
      productsServicesApi.put(fieldControlProduct.integrationId, fieldControlProduct)
        .then(function () {
          var fieldControlProductToSaveIntegrationIdOnOmie = omieProductMapper.toOmie(fieldControlProduct);
          return _updateIntegrationCodeOnOmie(fieldControlProductToSaveIntegrationIdOnOmie);
        })
        .then(function () {
          _productHasImported();
        })
        .catch(function () {
          _productHasImported();
          return _throwDefaultWarning(true);
        });
    }

    function _updateIntegrationCodeOnOmie(fieldControlProduct) {
      var alreadyHasProductWithSameCode = vm.currentProducts.find(function (product) {
        return product.codigo_produto_integracao === fieldControlProduct.codigo_produto_integracao && product.codigo_produto === fieldControlProduct.codigo_produto;
      });

      if (alreadyHasProductWithSameCode) {
        return Promise.resolve();
      }
      return _sendUpdateToOmie(fieldControlProduct, vm.appId);
    }

    function _updateFieldProduct(fieldControlProduct) {
      fieldControlProduct.externalAppId = vm.appId;
      productsServicesApi.put(fieldControlProduct.integrationId, fieldControlProduct)
        .then(function () {
          var fieldControlProductToSaveIntegrationIdOnOmie = omieProductMapper.toOmie(fieldControlProduct);
          return _updateIntegrationCodeOnOmie(fieldControlProductToSaveIntegrationIdOnOmie);
        })
        .catch(function () {
          return _throwDefaultWarning(true);
        })
        .finally(function () {
          _productHasImported();
        });
    }

    function _updateAllProductsIntegrationCodes(savingProductsPromises, productsToSaveInfos) {
      return Promise.all(savingProductsPromises)
        .then(function (createdProducts) {
          var productsToUpdateIntegrationId = omieProductMapper.groupEqualProductsToUpdateIntegrationCode(createdProducts, productsToSaveInfos);
          var productsGroupsToUpdateOnOmie = UtilityFunctions.splitItemsByQuantity(productsToUpdateIntegrationId, 3);
          if (productsGroupsToUpdateOnOmie && productsGroupsToUpdateOnOmie.length) {
            _updateOmieIntegrationCode(productsGroupsToUpdateOnOmie);
          }
        })
        .catch(function () {
          _throwDefaultWarning(true);
        });
    }

    function _repeatImportProccessIfNecessary() {
      if (vm.currentPage >= vm.totalPages) {
        _throwDefaultWarning(false);
        $rootScope.loadingProgress = false;
        vm.currentPage = 1;
      } else {
        vm.currentPage++;
        _importAllProducts();
      }
    }

    function _openOmieAutomaticImportLoadingModal($event) {
      vm.loadingImportModalId = msUtils.uuidGenerator();
      FcModalService.open($event, {
        title: $translate.instant('PRODUCTS.IMPORT.IMPORT_LOADING_TITLE'),
        templateUrl: 'app/main/products/sidenavs/import-modal/import-products-services-modal.html',
        modalId: vm.loadingImportModalId,
        eventNameToSubscribe: 'update-imported-products-progress',
        variables: {
          title: $translate.instant('PRODUCTS.IMPORT.WAIT_LOADING'),
          progressPercentage: vm.importedProductsProgress,
          totalProductsImported: vm.totalProductsImported,
          totalProductsToImport: vm.totalProductsToImport
        },
        leftButtonText: $translate.instant('PRODUCTS.IMPORT.CLOSE')
      }, null);
    }

    function _openOmieManualImportDialog() {
      FcModalService.open(null, {
        title: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.ACCOUNT'),
        content: $translate.instant('PRODUCTS.IMPORT.SELECT_THE_ACCOUNT_MANUAL'),
        hasOmieAccountSelector: true,
        paddingSmall: true,
        rightContinueButton: true,
        rightButtonText: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'),
        leftButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
        handleRightButton: function (account) {
          vm.appId = account.appId;
          $mdDialog.show({
            controller: 'OmieManualProductsImportDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/products/dialogs/omie-manual-import/omie-manual-import-dialog.html',
            parent: angular.element($document.body),
            clickOutsideToClose: true,
            targetEvent: null,
            escapeToClose: false,
            multiple: true,
            locals: {
              appId: account.appId
            }
          }).then(function () {
            vm.reload();
          });
        }
      });
    }

    function _productHasImported() {
      vm.totalProductsImported++;
      vm.importedProductsProgress = (vm.totalProductsImported * 100) / vm.totalProductsToImport;
      $rootScope.$broadcast('update-imported-products-progress', {
        totalProductsImported: vm.totalProductsImported,
        progressPercentage: vm.importedProductsProgress
      });

      if (vm.importedProductsProgress >= 100) {
        return finishImportProccess();
      }
    }

    function finishImportProccess() {
      $rootScope.loadingProgress = false;
      FcModalService.close(vm.loadingImportModalId);
      vm.reload();
      vm.importedProductsProgress = 0;
      vm.totalProductsImported = 0;
      vm.totalProductsToImport = 0;
      if (vm.duplicatedProducts.length > 0 && !vm.alreadyShownDuplicateDialog) {
        _openDuplicatedCodeOmieManualImportDialog();
      }

      return _throwDefaultWarning(false);
    }

    function _throwDefaultWarning(isError) {
      var toastTitleTranslateKey = isError ? 'UPDATE_ERROR' : 'SUCCESS_AUTOMATIC';
      var toastCustomClass = isError ? 'import-error-toast' : 'import-finished-toast';
      var toastIconPath = isError ? 'assets/icons/icon-service-error.svg' : 'assets/icons/icon-success-circle-green.svg';
      return FcToastService.addWarning({
        hideDelay: 5000,
        position: 'BOTTOM LEFT',
        title: $translate.instant('PRODUCTS.IMPORT.' + toastTitleTranslateKey),
        customClass: toastCustomClass,
        iconPath: toastIconPath,
        errorType: toastCustomClass,
        noExit: true
      });
    }

    function findMeasureSelected(measureValue) {
      if (!measureValue) { return ''; }

      var measure = vm.measuresSelectOptions.find(function (measure) {
        return measure.value === measureValue;
      });
      return measure;
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [];
        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var orderBy = '';
          if (aoData[2].value && aoData[2].value[0]) {
            var columnOrder = aoData[2].value[0];

            switch (columnOrder.column) {
              case 1:
                orderBy = 'code';
                break;
              case 2:
                orderBy = 'name';
                break;
              case 8:
                orderBy = 'value';
                break;
              case 9:
                orderBy = 'createdAt';
                break;
              default:
                orderBy = null;
                break;
            }

            if(orderBy) {
              orderBy += columnOrder.dir === 'asc' ? '_asc' : '_desc';
            } else {
              orderBy = 'createdAt_desc';
            }
          }

          var queryOptions = {
            skip: aoData[3].value,
            take: aoData[4].value,
            orderBy: 'createdAt_desc'
          };

          if (orderBy) { queryOptions.orderBy = orderBy; }
          var queryParams = {};
          if (vm.productsFilters) {
            if (vm.productsFilters.archived === '1') {
              queryParams['archived'] = false;
            } else if (vm.productsFilters.archived === '0') {
              queryParams['archived'] = true;
            }
            if (vm.productsFilters.name) {
              queryParams['nameContains'] = vm.productsFilters.name;
            }
            if (vm.productsFilters.description) {
              queryParams['descriptionContains'] = vm.productsFilters.description;
            }
            if (vm.productsFilters.code) {
              queryParams['codeContains'] = vm.productsFilters.code;
            }
            if (vm.productsFilters.productType !== '-1') {
              queryParams['linkedToProductTypeIds'] = [vm.productsFilters.productType];
            }
            if (vm.productsFilters.measure !== '-1') {
              queryParams['measure'] = vm.productsFilters.measure;
            }
            if (vm.productsFilters.type !== '-1') {
              queryParams['type'] = vm.productsFilters.type;
            }
          }

          productsServicesApiGraphQL.searchProducts(queryParams, queryOptions).then(function (result) {
            var promises = [];

            _.forEach(result.items, function (prod) {
              if (prod && prod.productType && prod.productType.id) {
                var promise = productTypesApiGraphQL.queryForDialog(prod.productType.id)
                  .then(function (productType) {
                    prod.productType = productType;
                  });

                promises.push(promise);
              }
            });

            Promise.all(promises)
              .then(function () {
                vm.products = result.items;
                vm.totalProducts = result.totalCount;

                fnCallback({
                  'draw': aoData[0].value,
                  'recordsTotal': vm.totalProducts,
                  'recordsFiltered': vm.totalProducts,
                  'data': vm.products
                });

                $rootScope.loadingProgress = false;
              })
              .catch(function (error) {
                console.log(error);
              });
          });

        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });
      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        _addCallToActionButton();
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          _addCallToActionButton();
          fixTableHeaders();
        });
      };
    }

    function _addCallToActionButton() {
      $('.call-to-action').remove();

      if (!vm.account.configuration.featureDisableAddProductService) {
        var ctaNewProduct = $compile('<div class="call-to-action">' +
          '<span translate="PRODUCTS.TABLE.CREATE_PRODUCTS_CTA">You can create a new product</span> ' +
          '<a class="cursor-pointer" translate="PRODUCTS.TABLE.CREATE_PRODUCTS_LINK" ng-click="vm.addProduct($event)">clicking here</a>.' +
          '</div>')(($scope));

        $('.dataTables_empty').append($(ctaNewProduct));
      }
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (isColumnVisible(index)) { visibleColumnsCount++; }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function _getDtColumns() {
      return [
        DTColumnBuilder.newColumn('id', 'id').notVisible(),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS.TABLE.CODE')).renderWith(function (data) {
          return data.code || '';
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS.TABLE.NAME')).renderWith(function (data) {
          var corporateCustomerName = (
            data.metadata &&
            data.metadata.sammathnaur &&
            data.metadata.sammathnaur.account &&
            data.metadata.sammathnaur.account.name
          );

          var corporateCustomerNameFormatted = corporateCustomerName ?
            '<em class="text-light-gray">(' + corporateCustomerName + ')</em>' : '<em>' + '</em>';

          var archivedClass = data.archived ? 'md-red-500-bg' : 'md-green-600-bg',
            archivedText = $translate.instant(data.archived ? 'PRODUCTS.TABLE.INACTIVE' : 'PRODUCTS.TABLE.ACTIVE'),
            templateHTML = '<div layout="row" layout-align="start center">' +
              '<div class="quantity-indicator ' + archivedClass + '">' +
              '<md-tooltip>' + archivedText + '</md-tooltip>' +
              '</div>' +
              '<span>' + data.name + ' ' + corporateCustomerNameFormatted + '</span>' +
              '</div>';
          return templateHTML;
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS.TABLE.DESCRIPTION')).renderWith(function (data) {
          var description = data.description;

          if (description) {
            return '<span title="' + data.description + '">' + $filter('maxLength')(data.description, 40) + '</span>';
          }

          return '';
        }).notSortable().notVisible(),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS.TABLE.TYPE')).renderWith(function (data) {

            return $translate.instant('PRODUCTS.MODEL.TYPE.PRODUCT');
        }).notSortable().notVisible(),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS.TABLE.MEASURE')).renderWith(function (data) {
          if (data.type === 'product' && data.measure) {
            return $translate.instant(findMeasureSelected(data.measure).translate);
          }

          return '-';
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS.TABLE.QRCODE')).renderWith(function (data) {

          return '<div style="layout-align="start center"; width: 100%;">' + '<qrcode id="product-qrcode-download" version="6" error-correction-level="M" size="45" data="' + (data.qrCode || null) + '">' +
           '</qrcode> ' + '</div>';
        }).notSortable().notVisible(),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS.TABLE.PRODUCT_TYPE')).renderWith(function (data) {
          if (data && data.productType && data.productType.name) {
            return data.productType.name || '';
          }

          return '';
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS.TABLE.VALUE', { currency: CurrencyService.currencySymbol })).renderWith(function (data) {
          var formattedTotal = $filter('currencyFormat')(data.value);
          return formattedTotal;
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS.TABLE.CREATED_AT')).renderWith(function (data) {
          var createdAt = (data.metadata && data.metadata.createdAt) || data.createdAt;
          if (!createdAt) { return ''; }

          return LocalDateConvert.formatDate(parseFloat(createdAt), 'date-time');
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('PRODUCTS.TABLE.ACTIONS')).renderWith(function (data) {
          var eventClick = 'ng-click="vm.editProduct($event,\'' + data.id + '\')"';
          var isCorporateCustomer = data.metadata && data.metadata.sammathnaur;
          var templateHTML = '';

          if (data.locked && !isCorporateCustomer) {
            templateHTML = '<md-button class="md-icon-button md-button-disabled-css">' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="PRODUCTS.TABLE.PRODUCT_EDIT_NOT_ALLOWED">Edit</span></md-tooltip>' +
              '</md-button>';
          } else if (isCorporateCustomer) {
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="PRODUCTS.TABLE.VIEW">Edit</span></md-tooltip>' +
              '</md-button>';
          } else {
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="PRODUCTS.TABLE.EDIT">Edit</span></md-tooltip>' +
              '</md-button>';
          }
          return templateHTML;
        }).notSortable()
        .withOption('responsivePriority', 1)
      ];
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _initialize() {
      vm.account = account;
      vm.productsFilters = ProductsFilters;
      vm.clearFilters = vm.productsFilters.clear;
      vm.filteringIsOn = vm.productsFilters.isOn;
      vm.toggleSidenav = toggleSidenav;
      vm.reload = _.debounce(_reloadDatatable, 1000);

      $scope.$on('products:reload', function () {
        vm.reload();
      });

      _startDataTable();
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.product-types')
    .controller('ProductTypesController', ProductTypesController);

  /** @ngInject */
  function ProductTypesController(
    account, ProductTypesFilters, ProductTypesDialog, $translate, $compile,
    $mdSidenav, $scope, $rootScope, _, dataTableOptions, DTColumnBuilder,
    productTypesApiGraphQL, $filter, LocalDateConvert
  ) {
    var vm = this;

    vm.currentPage = 1;
    vm.totalPages = 1;
    vm.limitPerPage = 100;

    $scope.$on('product-types:reload', function () {
      vm.reload();
    });

    vm.addProductType = addProductType;
    function addProductType($event) {
      ProductTypesDialog.createProductType($event, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    }

    vm.editProductType = editProductType;
    function editProductType(ev, id) {
      ProductTypesDialog.editProductType(ev, { id: id }, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [];

          config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
            $rootScope.loadingProgress = true;

            var sortBy = 'createdAt_desc';

            var mapSortBy = {
              1: 'name_',
              3: 'createdAt_'
            };

            if (aoData && aoData[2] && aoData[2].value[0].column && aoData[2].value[0].dir && (aoData[2].value[0].column === 1 || aoData[2].value[0].column === 3)) {
              var sortBy = (mapSortBy[aoData[2].value[0].column] + aoData[2].value[0].dir) || 'createdAt_desc';
            }

            var queryOptions = {
              skip: aoData[3].value,
              limit: aoData[4].value,
              sort: sortBy
            };

            var ProductTypesWhereInput = {};
            if (vm.productTypesFilters) {
              ProductTypesWhereInput = {
                'nameContains': vm.productTypesFilters.name ? vm.productTypesFilters.name : null,
                'descriptionContains': vm.productTypesFilters.description ? vm.productTypesFilters.description : null,
                'archived': vm.productTypesFilters.archived === '1' ? false : true
              };

              if (vm.productTypesFilters.archived === '-1') {
                delete ProductTypesWhereInput.archived;
              }

            }

            productTypesApiGraphQL
              .queryForDatatable({
                where: ProductTypesWhereInput,
                orderBy: queryOptions.sort,
                take: queryOptions.limit,
                skip: queryOptions.skip
              })
              .then(function (result) {
                vm.productTypes = result.items;
                vm.totalproductTypes = result.totalCount;
              })
              .finally(function () {
                fnCallback({
                  draw: aoData[0].value,
                  recordsTotal: vm.totalproductTypes,
                  recordsFiltered: vm.totalproductTypes,
                  data: vm.productTypes
                });

                $rootScope.loadingProgress = false;
              });
        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });
      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        _addCallToActionButton();
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          _addCallToActionButton();
          fixTableHeaders();
        });
      };
    }

    function _addCallToActionButton() {
      $('.call-to-action').remove();

      if (!vm.account.configuration.featureDisableAddProductService) {
        var ctaNewProductType = $compile('<div class="call-to-action">' +
          '<span translate="PRODUCT_TYPES.TABLE.CREATE_PRODUCT_TYPES_CTA">You can create a new product type</span> ' +
          '<a class="cursor-pointer" translate="PRODUCT_TYPES.TABLE.CREATE_PRODUCT_TYPES_LINK" ng-click="vm.addProductType($event)">clicking here</a>.' +
          '</div>')(($scope));

        $('.dataTables_empty').append($(ctaNewProductType));
      }
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (isColumnVisible(index)) { visibleColumnsCount++; }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function _getDtColumns() {
      var columnID = DTColumnBuilder.newColumn('id', 'id').notVisible();
      var columnName = DTColumnBuilder.newColumn(null, $translate.instant('PRODUCT_TYPES.TABLE.NAME')).renderWith(function (data) {
        var corporateCustomerName = (
          data.metadata &&
          data.metadata.sammathnaur &&
          data.metadata.sammathnaur.account &&
          data.metadata.sammathnaur.account.name
        );

        var corporateCustomerNameFormatted = corporateCustomerName ?
          '<em class="text-light-gray">(' + corporateCustomerName + ')</em>' : '<em>' + '</em>';

        var archivedClass = data.archived ? 'md-red-500-bg' : 'md-green-600-bg',
          archivedText = $translate.instant(data.archived ? 'PRODUCT_TYPES.TABLE.INACTIVE' : 'PRODUCT_TYPES.TABLE.ACTIVE'),
          templateHTML = '<div layout="row" layout-align="start center">' +
            '<div class="quantity-indicator ' + archivedClass + '">' +
            '<md-tooltip>' + archivedText + '</md-tooltip>' +
            '</div>' +
            '<span>' + $filter('maxLength')(data.name, 35) + ' ' + corporateCustomerNameFormatted + '</span>' +
            '</div>';
        return templateHTML;
      }).withOption('width', '20%');

      columnName.sortBy = 'name';

      var columnDescription = DTColumnBuilder.newColumn(null, $translate.instant('PRODUCT_TYPES.TABLE.DESCRIPTION')).renderWith(function (data) {
        var description = data.description;

        if (description) {
          return '<span title="' + data.description + '">' + $filter('maxLength')(data.description, 110) + '</span>';
        }

        return '';
      }).withOption('width', '57%').notSortable();

      var columnCreatedAt =  DTColumnBuilder.newColumn(null, $translate.instant('PRODUCT_TYPES.TABLE.CREATED_AT')).renderWith(function (data) {
          var createdAt = (data.metadata && data.metadata.createdAt) || data.createdAt;
          if (!createdAt) { return ''; }

          return LocalDateConvert.formatDate(createdAt, 'date-time');
      });

      columnCreatedAt.sortBy = 'createdAt';

      var columnActions = DTColumnBuilder.newColumn(null, $translate.instant('PRODUCT_TYPES.TABLE.ACTIONS')).renderWith(function (data) {
          var eventClick = 'ng-click="vm.editProductType($event,\'' + data.id + '\')"';
          var isCorporateCustomer = data.metadata && data.metadata.sammathnaur;
          var templateHTML = '';

          if (data.locked && !isCorporateCustomer) {
            templateHTML = '<md-button class="md-icon-button md-button-disabled-css">' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="PRODUCT_TYPES.TABLE.PRODUCT_TYPE_EDIT_NOT_ALLOWED">Edit</span></md-tooltip>' +
              '</md-button>';
          } else if (isCorporateCustomer) {
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="PRODUCT_TYPES.TABLE.VIEW">Edit</span></md-tooltip>' +
              '</md-button>';
          } else {
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="/assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="PRODUCT_TYPES.TABLE.EDIT">Edit</span></md-tooltip>' +
              '</md-button>';
          }
          return templateHTML;
      }).notSortable()
      .withOption('responsivePriority', 1)
      .withOption('width', '5%');


      return [
        columnID,
        columnName,
        columnDescription,
        columnCreatedAt,
        columnActions
      ];
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _initialize() {
      vm.account = account;
      vm.productTypesFilters = ProductTypesFilters;
      vm.clearFilters = vm.productTypesFilters.clear;
      vm.filteringIsOn = vm.productTypesFilters.isOn;
      vm.toggleSidenav = toggleSidenav;
      vm.reload = _.debounce(_reloadDatatable, 1000);
      _startDataTable();
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.plans-types')
    .controller('PlansTypesController', PlansTypesController);

  /** @ngInject */
  function PlansTypesController($rootScope, plansTypesApi, PlansTypesDialog, dataTableOptions, $translate, moment,
    authenticatedUser, $compile, $scope, $mdSidenav, PlansTypesFilters, DTColumnBuilder, LocalDateConvert, planTypesApiGraphQL) {

    var vm = this;

    $scope.$on('plans-types:reload', function () {
      vm.reload();
    });

    function _initialize() {
      vm.plansTypes = null;
      vm.currentPage = 1;
      vm.totalPages = 1;
      vm.limitPerPage = 25;
      vm.reload = _.debounce(_reloadDatatable, 1000);
      vm.toggleSidenav = toggleSidenav;
      vm.plansTypesFilters = PlansTypesFilters;
      vm.clearFilters = vm.plansTypesFilters.clear;
      vm.filteringIsOn = vm.plansTypesFilters.isOn;
      vm.addPlanType = addPlanType;
      vm.editPlanType = editPlanType;
      _startDataTable();
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function addPlanType(ev) {
      PlansTypesDialog.createPlanType(ev, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    }

    function editPlanType(ev, id) {
      PlansTypesDialog.editPlanType(ev, id, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [];

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var sortBy = 'createdAt_desc';

          var mapSortBy = {
            1: 'name_',
            3: 'createdAt_'
          };

          if (aoData && aoData[2] && aoData[2].value[0].column && aoData[2].value[0].dir && (aoData[2].value[0].column === 1 || aoData[2].value[0].column === 2 || aoData[2].value[0].column === 3 || aoData[2].value[0].column === 4 || aoData[2].value[0].column === 5)) {
            sortBy = (mapSortBy[aoData[2].value[0].column] + aoData[2].value[0].dir) || 'createdAt_desc';
          }

          var queryOptions = {
            skip: aoData[3].value,
            limit: aoData[4].value,
            sort: sortBy
          };

          var planTypesWhereInput = {};
          if (vm.plansTypesFilters) {
            planTypesWhereInput = {
              'nameContains': vm.plansTypesFilters.name ? vm.plansTypesFilters.name : null,
              'descriptionContains': vm.plansTypesFilters.description ? vm.plansTypesFilters.description : null,
              'archived': vm.plansTypesFilters.archived === '1' ? false : true
            };

            if (vm.plansTypesFilters.archived === '-1') {
              delete planTypesWhereInput.archived;
            }
          }

          planTypesApiGraphQL
            .queryForDatatable({
              where: planTypesWhereInput,
              orderBy: queryOptions.sort,
              take: queryOptions.limit,
              skip: queryOptions.skip
            })
            .then(function (result) {
              vm.plansTypes = result.items;
              vm.totalPlanTypes = result.totalCount;
            })
            .finally(function () {
              fnCallback({
                draw: aoData[0].value,
                recordsTotal: vm.totalPlanTypes || 0,
                recordsFiltered: vm.totalPlanTypes || 0,
                data: vm.plansTypes
              });

              $rootScope.loadingProgress = false;
            });
        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });

      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        _addCallToActionButton();
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');

          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;

          _addCallToActionButton();
          fixTableHeaders();
        });
      };
    }

    function _addCallToActionButton() {

      $('.call-to-action').remove();

      var ctaNewPlanType = $compile('<div class="call-to-action">' +
        '<span translate="PLANSTYPES.TABLE.CREATE_PLANS_TYPE_CTA">You can create a new plans OS types</span> ' +
        '<a class="cursor-pointer" translate="PLANSTYPES.TABLE.CREATE_PLANS_TYPE_LINK" ng-click="vm.addPlanType($event)">clicking here</a>.' +
        '</div>')(($scope));

      $('.dataTables_empty').append($(ctaNewPlanType));
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;

      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (isColumnVisible(index)) { visibleColumnsCount++; }
      }

      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function _getDtColumns() {
      return [
        DTColumnBuilder.newColumn('id', 'id').notVisible(),

        DTColumnBuilder.newColumn(null, $translate.instant('PLANSTYPES.MODEL.NAME')).renderWith(function (data) {
          var archivedClass = data.archived ? 'md-red-500-bg' : 'md-green-600-bg',
            archivedText = $translate.instant(data.archived ? 'PLANSTYPES.TABLE.INACTIVE' : 'PLANSTYPES.TABLE.ACTIVE'),
            templateHTML = '<div layout="row" layout-align="start center">' +
              '<div class="quantity-indicator ' + archivedClass + '">' +
              '<md-tooltip>' + archivedText + '</md-tooltip>' +
              '</div>' +
              '<span>' + data.name + '</span>' +
              '</div>';
          return templateHTML;
        }),

        DTColumnBuilder.newColumn(null, $translate.instant('PLANSTYPES.MODEL.DESCRIPTION')).renderWith(function (data) {
          return data.description;
        })
        .withOption('width', '30%')
        .notSortable(),

        DTColumnBuilder.newColumn(null, $translate.instant('PLANSTYPES.MODEL.CREATED_AT')).renderWith(function (data) {
          if (!data.createdAt) {
            return '';
          }
          return LocalDateConvert.formatDate(data.createdAt, 'date-time');
        }),

        DTColumnBuilder.newColumn(null, $translate.instant('PLANSTYPES.TABLE.ACTIONS')).renderWith(function (data) {
          var eventClick = 'ng-click="vm.editPlanType($event,\'' + data.id + '\')"',
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left"><span translate="PLANSTYPES.TABLE.EDIT">Edit</span></md-tooltip>' +
              '</md-button>';
          return templateHTML;
        })
        .withOption('width', '10%')
        .notSortable()
        .withOption('responsivePriority', 1)
      ];
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.plans')
    .controller('PlansController', PlansController);

  /** @ngInject */
  function PlansController($rootScope, authenticatedUser, plansApi, PlansDialog, ImportSpreadSheetPlansDialog, dataTableOptions, dataTableHelperService, $translate, $filter, moment, $compile, $scope, $mdSidenav, PlansFilters, DTColumnBuilder, Account, LocalDateConvert) {
    var vm = this;
    vm.account = Account;
    vm.downloadSpreadsheetModel = downloadSpreadsheetModel;
    vm.editPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_edit');
    vm.addPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_create');

    $scope.$on('plans:reload', function () {
      vm.reload();
    });

    function _initialize() {
      vm.plansArray = null;
      vm.totalPlans = 0;
      vm.reload = _.debounce(_reloadDatatable, 1000);
      vm.toggleSidenav = toggleSidenav;
      vm.plansFilters = PlansFilters;
      vm.clearFilters = vm.plansFilters.clear;
      vm.filteringIsOn = vm.plansFilters.isOn;
      vm.addPlan = addPlan;
      vm.editPlan = editPlan;
      _startDataTable();
    }

    function downloadSpreadsheetModel() {
      window.open('assets/spreadsheets/modelo-importacao-planos-de-atividades.xlsx', '_blank');
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function addPlan(ev) {
      ImportSpreadSheetPlansDialog.import(ev, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    }

    function editPlan(ev, id) {
      PlansDialog.editPlan(ev, id, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [];

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var queryParams = {
            where: {},
            aoData: aoData,
            columns: vm.dtColumns,
          };

          if (vm.plansFilters) {
            if (vm.plansFilters.archived === '1') {
              queryParams.where['archived'] = false;
            } else if (vm.plansFilters.archived === '0') {
              queryParams.where['archived'] = true;
            }
            if (vm.plansFilters.name) {
              queryParams.where['nameContains'] = vm.plansFilters.name;
            }

            if (vm.plansFilters.planType) {
              queryParams.where['planTypeNameContains'] = vm.plansFilters.planType;
            }

            if (vm.plansFilters.description) {
              queryParams.where['descriptionContains'] = vm.plansFilters.description;
            }
          }

          var params = dataTableHelperService.toGraphqlVariables(queryParams);

          params.orderBy = params.orderBy || 'createdAt_desc';

          plansApi.search(params).then(function (result) {
            vm.totalPlans = result.totalCount;
            vm.plansArray = result.items;
          }).finally(function () {
            fnCallback({
              'draw': aoData[0].value,
              'recordsTotal': vm.totalPlans || 0,
              'recordsFiltered': vm.totalPlans || 0,
              'data': vm.plansArray
            });

            $rootScope.loadingProgress = false;
          });
        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });

      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;

        _addCallToActionButton();

        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');

          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;

          _addCallToActionButton();
          fixTableHeaders();
        });
      };
    }

    function _addCallToActionButton() {
      $('.call-to-action').remove();

      var ctaNewPlanType = $compile('<div class="call-to-action">' +
        '<span translate="PLANS.TABLE.CREATE_PLANS_TYPE_CTA">You can create a new plans OS types</span> ' +
        '<a class="cursor-pointer" translate="PLANS.TABLE.CREATE_PLANS_TYPE_LINK" ng-click="vm.addPlan($event)">clicking here</a>.' +
        '</div>')(($scope));

      $('.dataTables_empty').append($(ctaNewPlanType));
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (isColumnVisible(index)) { visibleColumnsCount++; }
      }

      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function _getDtColumns() {
        var idColumn = DTColumnBuilder.newColumn('id', 'id').notVisible();

        var nameColumn = DTColumnBuilder.newColumn(null, $translate.instant('PLANS.MODEL.NAME')).renderWith(function (data) {
          var archivedClass = data.archived ? 'md-red-500-bg' : 'md-green-600-bg',
            archivedText = $translate.instant(data.archived ? 'PLANS.TABLE.INACTIVE' : 'PLANS.TABLE.ACTIVE'),
            templateHTML = '<div layout="row" layout-align="start center">' +
              '<div class="quantity-indicator ' + archivedClass + '">' +
              '<md-tooltip>' + archivedText + '</md-tooltip>' +
              '</div>' +
              '<span>' + data.name + '</span>' +
              '</div>';

          return templateHTML;
        });
        nameColumn.sortBy = 'name';

        var descriptionColumn = DTColumnBuilder.newColumn(null, $translate.instant('PLANS.MODEL.DESCRIPTION')).renderWith(function (data) {
          if (!data.description){
            return '<span title="' + data.description + '">' + $translate.instant('PLANS.MODEL.NO_DESCRIPTION') + '</span>';
          } else {
            return '<span title="' + data.description + '">' + $filter('maxLength')(data.description, 70) + '</span>';
          }
        }).notSortable();

        var planTypeColumn = DTColumnBuilder.newColumn(null, $translate.instant('PLANS.MODEL.PLANTYPE')).renderWith(function (data) {
          if (!data.planType.name) {
            return '';
          }

          return data.planType.name;
        }).notSortable();

        var createdAtColumn = DTColumnBuilder.newColumn(null, $translate.instant('PLANS.MODEL.CREATED_AT')).renderWith(function (data) {
          if (!data.createdAt) {
            return '';
          }

          return LocalDateConvert.formatDateTime(data.createdAt);
        });

        createdAtColumn.sortBy = 'createdAt';

        var actionsColumn = DTColumnBuilder.newColumn(null, $translate.instant('PLANS.TABLE.ACTIONS')).renderWith(function (data) {
          var label = vm.editPermission === true ? $translate.instant('TASKS.TABLE.ROWS.ACTION.EDIT') : $translate.instant('TASKS.TABLE.ROWS.ACTION.VIEW') ;
          var icon = vm.editPermission === true ? '<img ng-src="assets/icons/icon-edit.svg" data-cy="plan-edit-button" alt="Edit">' : '<md-icon md-font-icon="icon-eye" alt="Edit"></md-icon>';

          var eventClick = 'ng-click="vm.editPlan($event,\'' + data.id + '\')"',
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              icon +
              '<md-tooltip md-direction="left">'+ label +'</md-tooltip>' +
              '</md-button>';

          return templateHTML;
        })
          .withOption('width', '10%')
          .notSortable()
          .withOption('responsivePriority', 1);

        return [
            idColumn,
            nameColumn,
            descriptionColumn,
            planTypeColumn,
            createdAtColumn,
            actionsColumn
          ];
      }

    _initialize();
  }
})();

(function () {
    'use strict';

    angular
        .module('app.notifications', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/notifications');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.notifications')
        .controller('NotificationsController', NotificationsController);

    /** @ngInject */
    function NotificationsController($rootScope, $timeout,
        notificationsApi, $location, $scope, OrderDialog, QuotationsDialog, favicoNotification, authenticatedUser,
        EnvironmentConfig, $window) {

        var vm = this;
        vm.notifications = [];
        vm.readAll = readAll;
        vm.readOne = readOne;
        vm.loadNotifications = loadNotifications;
        vm.token = authenticatedUser.profile.token;
        vm.goToNotification = goToNotification;
        vm.unreadNotificationsCount = 0;

        $scope.$on('new:notification', function () {
            vm.canLoadMoreNotifications = 1;
            loadNotifications();
        });

        function loadNotifications() {
          $rootScope.loadingProgress = true;
          notificationsApi.getAll(vm.token).then(function (result) {
            $rootScope.loadingProgress = false;
            vm.notifications = result.data.notifications;
            unreadNotifications();
          });
        }

        function readOne(notificationId) {
            $rootScope.loadingProgress = true;
            $timeout(function () {
                notificationsApi.read(notificationId, vm.token).then(function () {
                    $rootScope.$broadcast('new:notification');
                });
            }, 300);
        }

        function readAll() {
            $timeout(function () {
                notificationsApi.readAll(vm.token).then(function () {
                    favicoNotification.reset();
                    $rootScope.$broadcast('new:notification');
                });
            }, 400);
        }

        function goToNotification(ev, notification) {
            $rootScope.loadingProgress = true;
            $timeout(function () {
                notificationsApi.read(notification.id, vm.token).then(function () {
                    $rootScope.loadingProgress = false;
                    if (notification.type === 'ticketCreated') {
                      $location.path('/chamados-e-oportunidades/' + notification.data.id);
                    } else if (notification.type === 'commentCreated') {
                        OrderDialog.editTask(ev, { id: notification.data.id, tabIndex: 11 });
                    } else if (notification.type === 'taskReported') {
                      OrderDialog.editTask(ev, { id: notification.data.id });
                    } else if (notification.type === 'taskRated') {
                        OrderDialog.editTask(ev, { id: notification.data.id, tabIndex: 12 });
                    } else if (notification.type === 'quotationApproved') {
                      QuotationsDialog.editQuotation(ev, notification.data.id);
                    } else if (notification.type === 'quotationRefused') {
                      QuotationsDialog.editQuotation(ev, notification.data.id);
                    } else if (notification.type === 'quotationCanceled') {
                      QuotationsDialog.editQuotation(ev, notification.data.id);
                    } else if (notification.type === 'deadlineAtRisk') {
                      OrderDialog.editTask(ev, { id: notification.data.orderId, tabIndex: 1 });
                    } else if (notification.type === 'deadlineOutOfSchedule') {
                      OrderDialog.editTask(ev, { id: notification.data.orderId, tabIndex: 1 });
                    } else if (notification.type === 'ticketOnNegotiation') {
                      $location.path('/chamados-e-oportunidades/' + notification.data.id);
                    } else if (notification.type.includes('pendency')) {
                      window.open(EnvironmentConfig.mordor2Url + 'pendencias/' + notification.data.pendency.id);
                    }
                });
            }, 500);
        }

        function unreadNotifications() {
            notificationsApi.unreadCount(vm.token).then(function (result) {
                vm.unreadNotificationsCount = result.data.notificationsUnreadCount.count;
            });
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.modules')
      .factory('ModulesService', ModulesService);

  /** @ngInject */
  function ModulesService($rootScope, authenticatedUser, accountsApi, siteApi, $timeout, $window, $mdToast, $mdDialog, $translate) {

    return {
      configuration: configuration,
      saveConfiguration: saveConfiguration,
      requestActivation: requestActivation
    };

    function configuration(account, featureFlags) {
      return {
        'route-optimizer': {
          controller: 'RouteOptimizerSidenavController',
          templateUrl: 'app/main/modules/sidenavs/route-optimizer/route-optimizer.html',
          configurationName: 'moduleRouteOptimizationEnabled',
          isEnable: account.configuration.moduleRouteOptimizationEnabled || Boolean(account.configuration.moduleAdvancedRouteOptimizationEnabled),
          isAdvancedEnabled: Boolean(account.configuration.moduleAdvancedRouteOptimizationEnabled),
          isPaid: true
        },
        'equipments': {
          controller: 'EquipmentsSidenavController',
          templateUrl: 'app/main/modules/sidenavs/equipments/equipments.html',
          configurationName: 'moduleEquipmentManagementEnabled; moduleOrderEquipmentManagementEnabled',
          isEnable: account.configuration.moduleEquipmentManagementEnabled && account.configuration.moduleOrderEquipmentManagementEnabled,
          isPaid: true
        },
        'materials': {
          controller: 'MaterialsSidenavController',
          templateUrl: 'app/main/modules/sidenavs/materials/materials.html',
          configurationName: 'moduleMaterialManagementEnabled',
          isEnable: account.configuration.moduleMaterialManagementEnabled,
          isPaid: false
        },
        'image-resolution': {
          controller: 'ImageResolutionSidenavController',
          templateUrl: 'app/main/modules/sidenavs/image-resolution/image-resolution.html',
          configurationName: 'moduleHighResolutionImagesEnabled',
          isEnable: account.configuration.moduleHighResolutionImagesEnabled,
          isPaid: true
        },
        'tickets': {
          controller: 'TicketsSidenavController',
          templateUrl: 'app/main/modules/sidenavs/tickets/tickets.html',
          configurationName: 'toolbarTicketsMenuItemVisible',
          isEnable: account.configuration.toolbarTicketsMenuItemVisible,
          isPaid: false
        },
        'videos': {
          controller: 'VideosSidenavController',
          templateUrl: 'app/main/modules/sidenavs/videos/videos.html',
          configurationName: 'moduleVideosEnabled',
          isEnable: account.configuration.moduleVideosEnabled,
          isPaid: true
        },
        'customers-area': {
          controller: 'CustomersAreaSidenavController',
          templateUrl: 'app/main/modules/sidenavs/customers-area/customers-area.html',
          configurationName: 'moduleCustomersAreaEnabled',
          isEnable: account.configuration.moduleCustomersAreaEnabled,
          isPaid: true
        },
        'print-configuration': {
          controller: 'PrintConfigurationSidenavController',
          templateUrl: 'app/main/modules/sidenavs/print-configuration/print-configuration.html',
          configurationName: 'fakeModulePrintConfiguration', // Não existe uma configuração para este módulo.
          isEnable: true,
          isPaid: false
        },
        'tasks-plans': {
          controller: 'TasksPlansSidenavController',
          templateUrl: 'app/main/modules/sidenavs/tasks-plans/tasks-plans.html',
          configurationName: 'moduleTasksPlansEnabled',
          isEnable: account.configuration.moduleTasksPlansEnabled,
          isPaid: false
        },
        'vehicles': {
          controller: 'VehiclesSidenavController',
          templateUrl: 'app/main/modules/sidenavs/vehicles/vehicles.html',
          configurationName: 'moduleVehiclesEnabled',
          isEnable: account.configuration.moduleVehiclesEnabled,
          isPaid: true
        },
        'deadlines': {
          controller: 'DeadlinesSidenavController',
          templateUrl: 'app/main/modules/sidenavs/deadlines/deadlines.html',
          configurationName: 'moduleOrdersDeadlineEnabled',
          isEnable: account.configuration.moduleOrdersDeadlineEnabled,
          isPaid: true
        },
        'storage-control': {
          controller: 'StorageControlSidenavController',
          templateUrl: 'app/main/modules/sidenavs/storage-control/storage-control.html',
          configurationName: 'moduleStorageControlEnabled',
          isEnable: account.configuration.moduleStorageControlEnabled,
          isPaid: true
        },
        'templates': {
          controller: 'TemplatesSidenavController',
          templateUrl: 'app/main/modules/sidenavs/templates/templates.html',
          configurationName: 'moduleTemplatesEnabled',
          isEnable: account.configuration.moduleTemplatesEnabled,
          isPaid: true
        },
        'smart-rewrite': {
          controller: 'SmartRewriteSidenavController',
          templateUrl: 'app/main/modules/sidenavs/smart-rewrite/smart-rewrite.html',
          configurationName: 'moduleSmartRewriteEnabled',
          isEnable: account.configuration.moduleSmartRewriteEnabled,
          isPaid: true
        },
        'territories': {
          controller: 'TerritoriesControlSidenavController',
          templateUrl: 'app/main/modules/sidenavs/territories/territories.html',
          configurationName: 'territories',
          isEnable: hasFeatureFlag(featureFlags, 'territories'),
          isPaid: false
        },
      };
    }

    function hasFeatureFlag(featureFlags, name) {
      var hasFeature = featureFlags.find(function (featureFlag) {
        return featureFlag.name == name;
      });

      return hasFeature && hasFeature.active;
    }

    function saveConfiguration(accountConfiguration) {
      $rootScope.loadingProgress = true;

      return accountsApi.saveConfigurations(accountConfiguration)
        .then(function () {
          $rootScope.loadingProgress = false;

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("MODULES.MODULES_SAVED"))
              .hideDelay(2000)
          );

          $timeout(function () {
            $window.location.reload(true);
          }, 2000);

          return true;
        }).catch(function () {
          $rootScope.loadingProgress = false;

          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('MODULES.MODULES_ERROR'))
              .theme('error-toast')
              .hideDelay(2000)
          );

          return false;
        });
    }

    function requestActivation(account, module) {
      if (account.plan.name !== 'trial') {
        var confirmRequestActivationDialog = $mdDialog.confirm()
          .title($translate.instant("MODULES.REQUEST_ACTIVATION.DIALOG.TITLE"))
          .htmlContent($translate.instant("MODULES.REQUEST_ACTIVATION.DIALOG.DESCRIPTION"))
          .ok($translate.instant("MODULES.REQUEST_ACTIVATION.DIALOG.OK"))
          .cancel($translate.instant("MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL"))
          .clickOutsideToClose(true);

        return $mdDialog.show(confirmRequestActivationDialog).then(function () {
          $rootScope.loadingProgress = true;
          var formOptions = {
            name: authenticatedUser.profile.name,
            email: account.contact.email,
            accountName: account.contact.name,
            module: module,
            language: account.language
          };

          return siteApi.requestModuleActivation(formOptions)
            .then(function () {
              $rootScope.loadingProgress = false;
              $mdToast.show(
                $mdToast.simple()
                  .textContent($translate.instant("MODULES.REQUEST_ACTIVATION.SUCCESS"))
                  .hideDelay(2000)
              );

              return true;
            }).catch(function () {
              $rootScope.loadingProgress = false;
              $mdToast.show(
                $mdToast.simple()
                  .textContent($translate.instant('MODULES.REQUEST_ACTIVATION.ERROR'))
                  .theme('error-toast')
                  .hideDelay(2000)
              );

              return false;
            });
        }, function () {
          return false;
        });
      } else {
        var trialRequestActivationDialog = $mdDialog.alert()
          .title($translate.instant("MODULES.REQUEST_ACTIVATION.TRIAL_DIALOG.TITLE"))
          .htmlContent($translate.instant("MODULES.REQUEST_ACTIVATION.TRIAL_DIALOG.DESCRIPTION"))
          .ok($translate.instant("MODULES.REQUEST_ACTIVATION.TRIAL_DIALOG.OK"))
          .clickOutsideToClose(true);

          return $mdDialog.show(trialRequestActivationDialog)
            .then(function () {
              return false;
            });
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.modules').controller('ModulesController', ModulesController);

  /** @ngInject */
  function ModulesController(
    Account,
    $mdDialog,
    ModulesService,
    $document,
    $rootScope,
    $location,
    FeatureFlags,
    accountsApi
  ) {
    var vm = this;
    vm.locationParams = $location.search();

    vm.account = angular.copy(Account);
    vm.accountFeatureFlags = angular.copy(FeatureFlags);
    vm.configuration = ModulesService.configuration(vm.account, vm.accountFeatureFlags);
    vm.styledModules = ['smart-rewrite'];
    vm.toggleSidenav = toggleSidenav;
    vm.hasFeatureFlag = hasFeatureFlag;

    _initialize();

    if (vm.locationParams) {
      toggleSidenav(null, vm.locationParams.module);
    }

    function toggleSidenav(ev, moduleName) {
      var module = vm.configuration[moduleName];
      if (!module) { return; }

      _openDialog(ev, module);
    }

    function hasFeatureFlag(name) {
      var hasFeature = vm.accountFeatureFlags.find(function (featureFlag) {
        return featureFlag.name == name;
      });

      return hasFeature && hasFeature.active;
    }

    function _openDialog(ev, module) {
      _loaderOn();

      $mdDialog.show({
        controller: module.controller,
        controllerAs: 'vm',
        templateUrl: module.templateUrl,
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Account: vm.account,
          Configuration: module,
        },
        onComplete: _loaderOff,
        closeTo: {
          top: 0,
          left: window.innerWidth,
          width: window.innerWidth,
          height: window.innerHeight / 1.8,
        },
      });
    }

    function _loaderOn() {
      $rootScope.loadingProgress = true;
    }

    function _loaderOff() {
      $rootScope.loadingProgress = false;
    }

    function _initialize() {
      $rootScope.$on('reload:account', function () {
        accountsApi.get().then(function (account) {
          vm.account = account;
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('MeasuresOptions', MeasuresOptions);

  /** @ngInject */
  function MeasuresOptions(_) {
    var measures = [
      {
        value: 'unity',
        name: 'MATERIALS.MEASURES.UNITY'
      },
      {
        value: 'centimeter',
        name: 'MATERIALS.MEASURES.CENTIMETER'
      },
      {
        value: 'meter',
        name: 'MATERIALS.MEASURES.METER'
      },
      {
        value: 'liter',
        name: 'MATERIALS.MEASURES.LITER'
      },
      {
        value: 'milliliter',
        name: 'MATERIALS.MEASURES.MILLILITER'
      },
      {
        value: 'kilogram',
        name: 'MATERIALS.MEASURES.KILOGRAM'
      }
    ];

    function selected(item) {
      if (typeof item !== 'undefined') {
        var selected = _.find(measures, function (measure) { return measure.value === item; });
        if (selected && selected.name) {
          return selected.name;
        }
      }

      return '';
    }

    return {
      measures: measures,
      selected: selected
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.materials')
        .controller('MaterialsController', MaterialsController);

    /** @ngInject */
    function MaterialsController(
        materials, account, materialsApi, MaterialsFilters, MaterialsDialog,
        MeasuresOptions, dataTableOptions, DTColumnBuilder,
        $translate, $rootScope, $compile, $scope, $mdSidenav, $mdToast,
        FcModalService , fcExportAlertService, accountsApi, LocalDateConvert
    ) {

        var vm = this;
        vm.materials = materials.items;
        vm.account = account;
        vm.isMinimized = false;
        vm.employeesWithOutdatedApp = [];

        vm.loadMaterials = loadMaterials;
        vm.clearFilters = MaterialsFilters.clear;
        vm.filteringIsOn = MaterialsFilters.isOn;
        vm.toggleSidenav = toggleSidenav;
        vm.editMaterials = editMaterials;
        vm.addMaterials = addMaterials;
        vm.minimize = minimize;
        vm.expand = expand;
        vm.openMigrationConfirmModal = openMigrationConfirmModal;
        vm.configuration = vm.account.configuration;

        function toggleSidenav() {
            $mdSidenav('materials-filters-sidenav').toggle();
        }

        $scope.$on('materials:reload', function () {
            loadMaterials();
        });

        function loadMaterials(resetPaging) {
            if (!resetPaging) {
                resetPaging = false;
            }
            vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
        }

        function editMaterials(ev, id) {
            MaterialsDialog.editMaterials(ev, id, function (reload) {
                if (reload) {
                    vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
                    loadMaterials();
                }
            });
        }

        function addMaterials($event) {
            MaterialsDialog.createMaterials($event, function (reload) {
                if (reload) {
                    loadMaterials();
                }
            });
        }

        function openMigrationConfirmModal(ev) {
          FcModalService.open(ev, {
            title: $translate.instant('MATERIALS.MIGRATION.MIGRATE'),
            content: $translate.instant('MATERIALS.MIGRATION.DESCRIPTION'),
            leftButtonText: $translate.instant('MATERIALS.MIGRATION.NO'),
            rightButtonText: $translate.instant('MATERIALS.MIGRATION.YES'),
            handleRightButton: _migrateProducts,
            contentTextSpacing: '0.6px'
          });
        }

        function minimize() {
          vm.isMinimized = true;
          var migrationCard = document.getElementById('content-to-minimize-and-expand');
          var migrationCardEnd = document.getElementById('end-content-to-minimize-and-expand');
          migrationCard.style.height = '12vh';
          migrationCardEnd.style.paddingBottom = '28px';
        }

        function expand() {
          vm.isMinimized = false;
          var migrationCard = document.getElementById('content-to-minimize-and-expand');
          var migrationCardEnd = document.getElementById('end-content-to-minimize-and-expand');

          migrationCard.style.height = '60vh';
          migrationCardEnd.style.paddingBottom = '0px';
        }

        function _migrateProducts(ev) {
          materialsApi.migrateMaterialsToProducts().then(function (response) {
            var error = response.data && response.data.errors && response.data.errors[0];

            if (error && error.extensions && error.extensions.code === 'EMPLOYEES_WITH_OUTDATED_APP') {
              vm.employeesWithOutdatedApp = _.cloneDeep(error.extensions.employees);
            }

            if (vm.employeesWithOutdatedApp && vm.employeesWithOutdatedApp.length) {
              return _showEmployeesWithOutdatedAppModal(vm.employeesWithOutdatedApp, ev);
            }

            vm.configuration.disableMaterials = false;
            accountsApi.saveConfigurations(vm.configuration);
            fcExportAlertService.show({
              title: $translate.instant('MATERIALS.MIGRATION.IN_PROGRESS'),
              isToShowButtons: false
            }, 'migration');
          });

        }

        function _showEmployeesWithOutdatedAppModal(employeesWithOutdatedApp, ev) {
          FcModalService.open(ev, {
            title: $translate.instant('MATERIALS.MIGRATION.APP_OUTDATED_IN_DEVICES', { devicesNumber: employeesWithOutdatedApp.length }),
            content: $translate.instant('MATERIALS.MIGRATION.DESCRIPTION_DEVICES', { devicesNumber: employeesWithOutdatedApp.length }),
            scrollableContent: employeesWithOutdatedApp,
            buttonFlex: true,
            buttonWidth: 199,
            colorBold: 'blue',
            leftButtonText: $translate.instant('MATERIALS.MIGRATION.CANCEL'),
            rightButtonText: $translate.instant('MATERIALS.MIGRATION.TRY_AGAIN'),
            handleRightButton: _migrateProducts
          });
        }

        function _startDataTable() {
            vm.dtInstance = {};
            vm.currentScroll = vm.currentScroll || 0;

            vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
                config.sAjaxDataProp = "data";
                config.processing = true;
                config.serverSide = true;
                config.searchDelay = 2000;
                config.paging = true;

                config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
                    $rootScope.loadingProgress = true;

                    var queryParams = {};
                    var sort = '';

                    if (MaterialsFilters.archived === '1') {
                        queryParams['archived'] = 'no';
                    } else if (MaterialsFilters.archived === '2') {
                        queryParams['archived'] = 'yes';
                    }

                    if (MaterialsFilters.name) {
                        queryParams['name~~*'] = '*' + MaterialsFilters.name + '*';
                    }

                    if (aoData[2].value && aoData[2].value[0]) {
                        var columnOrder = aoData[2].value[0];
                        if (columnOrder.dir === 'desc') {
                            sort += '-';
                        }
                        var columnIndex = columnOrder.column;
                        if (columnIndex === 2) {
                            sort += 'created_at';
                        } else if (columnIndex === 0) {
                            sort += 'name';
                        } else {
                            sort = null;
                        }
                    }

                    var queryOptions = {
                        offset: aoData[3].value,
                        limit: aoData[4].value,
                    };

                    if (sort) { queryOptions.sort = sort; }

                    var materials = {
                        totalItems: 0,
                        items: []
                    };

                    materialsApi.search(queryParams, queryOptions).then(function (result) {
                        materials = result;
                    }).catch(function (err) {
                      $mdToast.show(
                        $mdToast.simple()
                          .textContent($translate.instant('MATERIALS.ERROR_ON_SEARCH'))
                          .hideDelay(3000)
                          .theme("error-toast")
                      );
                    }).finally(function () {
                        $rootScope.loadingProgress = false;
                        fnCallback({
                            'draw': aoData[0].value,
                            'recordsTotal': materials.totalItems,
                            'recordsFiltered': materials.totalItems,
                            'data': materials.items
                        });
                    });
                }, 1000);

                config.createdRow = function (row) {
                    $compile(angular.element(row).contents())($scope);
                };

                config.columnDefs = [];
                config.lengthMenu = [25, 50, 100, 150, 200, 500];
                config.pageLength = 25;
                config.order = [2, 'desc'];
            });

            vm.dtColumns = _getDtColumns();
            vm.dtInstanceCallback = function (_dtInstance) {
                _fixTableHeaders();
                vm.dtInstance = _dtInstance;
                vm.dtInstance.DataTable.on('draw', function () {
                    var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
                    scrollContent.scrollTop = vm.currentScroll;
                    vm.currentScroll = 0;
                    $('.call-to-action').remove();
                });
            };
        }

        function _fixTableHeaders() {
            $('.dataTables_scrollHeadInner table thead th').each(function () {
                var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
                $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
            });
        }

        function _getDtColumns() {
            var columns = [
                DTColumnBuilder.newColumn(null, $translate.instant('MATERIALS.DATATABLE.NAME')).renderWith(function (data) {
                    var archivedClass = data.archived ? 'md-red-500-bg' : 'md-green-600-bg',
                    archivedText = data.archived ? $translate.instant('MATERIALS.ARCHIVED') : $translate.instant('MATERIALS.UNARCHIVED'),
                    templateHTML = '<div layout="row" layout-align="start center">' +
                    '<div class="quantity-indicator ' + archivedClass + '">' +
                    '<md-tooltip>' + archivedText + '</md-tooltip>' +
                    '</div>' +
                    '<span class="material-name">' + data.name + '</span>' +
                    '</div>';

                    return templateHTML;
                }),

                DTColumnBuilder.newColumn(null, $translate.instant('MATERIALS.DATATABLE.MEASURE')).renderWith(function (data) {
                    var measure =  $translate.instant(MeasuresOptions.selected(data.measure));
                    return measure;
                }).notSortable(),

                DTColumnBuilder.newColumn(null, $translate.instant('MATERIALS.DATATABLE.CREATED_AT')).renderWith(function (data) {
                    return LocalDateConvert.formatDate(data.createdAt, 'date-time');
                }),

                DTColumnBuilder.newColumn(null, $translate.instant('MATERIALS.DATATABLE.ACTIONS')).renderWith(function (data) {
                    var tooltip = data.locked ? $translate.instant('MATERIALS.DATATABLE.EDIT_LOCKED') : $translate.instant('MATERIALS.DATATABLE.EDIT'),
                    eventClick = data.locked ? '' : 'ng-click="vm.editMaterials($event,\'' + data.id + '\')"',
                    disabledClass = data.locked ? ' md-button-disabled-css' : '',
                    templateHTML = '<md-button ng-disabled="vm.configuration.disableMaterials" aria-label="more" class="md-icon-button' + disabledClass + '"' + eventClick + '>' +
                    '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
                    '<md-tooltip md-direction="left">' + tooltip + '</md-tooltip>' +
                    '</md-button>';
                    return templateHTML;
                })
                .withOption('width', '10%')
                .notSortable()
                .withOption('responsivePriority', 1)
            ];

            return columns;
        }

        function _initialize() {
            _startDataTable();
        }

        _initialize();
    }
})();

(function () {
  'use strict';

  angular
    .module('app.locations')
    .controller('LocationsController', LocationsController);

  /** @ngInject */
  function LocationsController(
    DTColumnBuilder, dataTableOptions, $translate,
    LocationsDialog, $compile, $scope,
    $mdSidenav, LocationsFilters, $rootScope,
    locationsApiGraphQL, account, authenticatedUser, FcModalService,
    exportsApi, $mdToast, $mdDialog, accountFeatureFlagsApiGraphQL, $window
  ) {

    var vm = this;
    vm.exportLocations = exportLocations;

    $scope.$on('locations:reload', function () {
      vm.reload();
    });

    function _initialize() {
      vm.account = angular.copy(account);
      vm.locationFilters = LocationsFilters;
      vm.clearFilters = vm.locationFilters.clear;
      vm.filteringIsOn = vm.locationFilters.isOn;

      vm.reload = _.debounce(_reloadDatatable, 1000);
      vm.openAddLocationDialog = openAddLocationDialog;
      vm.openEditLocationDialog = openEditLocationDialog;
      vm.toggleSidenav = toggleSidenav;
      vm.userPermissionCreateLocations = authenticatedUser.hasPermission(vm.account, 'locations_create_menu');

      vm.openQrCodeGenerator = openQrCodeGenerator;
      accountFeatureFlagsApiGraphQL
        .getCachedFlagByName('public-qrcode-beta-flag')
        .then(function (flag) {
          vm.showQrCodeButton = flag && flag.active;
        });

      _startDataTable();
    };

    function openAddLocationDialog($event) {
      LocationsDialog.createLocation($event, null, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    };

    function openEditLocationDialog($event, id) {
      LocationsDialog.editLocation($event, id, account, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          vm.reload();
        }
      });
    };

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function _startDataTable() {
      vm.dtInstance = {};

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [];

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var queryOptions = {
            skip: aoData[3].value,
            limit: aoData[4].value,
            sort: 'createdAt_desc'
          };

          var locationsWhereInput = {};
          if (vm.locationFilters) {
            var territoryId = vm.locationFilters.territoryId;
            var subTerritoryIds = vm.locationFilters.subTerritoryIds || [];

            var territoriesToSearch = [];

            if (subTerritoryIds.length) {
              territoriesToSearch = subTerritoryIds;
            } else if (territoryId) {
              territoriesToSearch = [territoryId];
            }

            locationsWhereInput = {
              'nameContains': vm.locationFilters.locationName ? vm.locationFilters.locationName : null,
              'notesContains': vm.locationFilters.locationNotes ? vm.locationFilters.locationNotes : null,
              'customerNameContains': vm.locationFilters.customerName ? vm.locationFilters.customerName : null,
              'documentNumberContains': vm.locationFilters.documentNumber ? vm.locationFilters.documentNumber : null,
              'streetContains': vm.locationFilters.street ? vm.locationFilters.street : null,
              'cityContains': vm.locationFilters.city ? vm.locationFilters.city : null,
              'stateContains': vm.locationFilters.state ? vm.locationFilters.state : null,
              'archived': vm.locationFilters.archived ? true : false,
              'territoryIds': territoriesToSearch.length ? territoriesToSearch : null
            };

            if (vm.locationFilters.archived === null) {
              delete locationsWhereInput.archived;
            }

            if (locationsWhereInput && Array.isArray(locationsWhereInput.customerNameContains)) {
              locationsWhereInput.customerNameContains = locationsWhereInput.customerNameContains.join(", ");
            }
          }

          locationsApiGraphQL
            .queryForDatatable({
              where: locationsWhereInput,
              orderBy: queryOptions.sort,
              take: queryOptions.limit,
              skip: queryOptions.skip
            })
            .then(function (result) {
              vm.locations = result.items;
              vm.totalLocations = result.totalCount;
            })
            .finally(function () {
              fnCallback({
                draw: aoData[0].value,
                recordsTotal: vm.totalLocations,
                recordsFiltered: vm.totalLocations,
                data: vm.locations
              });

              $rootScope.loadingProgress = false;
            });
        }, 1000);

        config.createdRow = function (row, data) {
          if (data && data.archived) {
            $(row).addClass('disabled-row');
          }

          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });
      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        _fixTableHeaders();
        vm.dtInstance = _dtInstance;
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          $('.call-to-action').remove();
        });
      };

      function _fixTableHeaders() {
        $('.dataTables_scrollHeadInner table thead th').each(function () {
          var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
          $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
        });
      }

      function _getDtColumns() {
        var columns = [
          DTColumnBuilder.newColumn('id', 'id').notVisible(),
          DTColumnBuilder.newColumn(null, $translate.instant('LOCATIONS.TABLE.COLUMNS.NAME')).renderWith(function (data) {
            var corporateCustomerName = (
              data.customer.metadata &&
              data.customer.metadata.sammathnaur &&
              data.customer.metadata.sammathnaur.account &&
              data.customer.metadata.sammathnaur.account.name
            );

            var corporateCustomerNameFormatted = corporateCustomerName ?
                    '<em class="text-light-gray">(' + corporateCustomerName + ')</em>' : '<em>' + '</em>';

            return  '<span>' + data.name + ' ' + corporateCustomerNameFormatted + '</span>';
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('LOCATIONS.TABLE.COLUMNS.CUSTOMER')).renderWith(function (data) {
            var customerName = data.customer && data.customer.name;
            return customerName ? customerName : '';
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('LOCATIONS.TABLE.COLUMNS.ADDRESS')).renderWith(function (data) {
            var formattedAddress = data.address && data.address.formattedAddress;
            return formattedAddress ? formattedAddress : '';
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('LOCATIONS.TABLE.COLUMNS.DOCUMENT_NUMBER')).renderWith(function (data) {
            var isDocumentNumberCPF = data.documentNumber && data.documentNumber.length <= 11;
            var formattedDocumentNumber = _formatDocumentNumber(isDocumentNumberCPF, data.documentNumber);

            return formattedDocumentNumber;
          }).notSortable(),
          DTColumnBuilder.newColumn(null, $translate.instant('LOCATIONS.TABLE.COLUMNS.ACTIONS')).renderWith(function (data) {
            var eventClick = 'ng-click="vm.openEditLocationDialog($event,\'' + data.id + '\')"';
                var isCorporateCustomer = data.customer.metadata && data.customer.metadata.sammathnaur;
                var templateHTML = '';

                if (data.locked && !isCorporateCustomer) {
                  templateHTML = '<md-button class="md-icon-button md-button-disabled-css" data-cy="edit-location-icon">' +
                  '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
                  '<md-tooltip md-direction="left"><span translate="LOCATIONS.PRODUCT_SERVICE_EDIT_NOT_ALLOWED">Edit</span></md-tooltip>' +
                  '</md-button>';
                } else if (isCorporateCustomer) {
                  templateHTML = '<md-button aria-label="more" data-cy="edit-location-icon" class="md-icon-button"' + eventClick + '>' +
                    '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
                    '<md-tooltip md-direction="left"><span translate="LOCATIONS.VIEW">Edit</span></md-tooltip>' +
                    '</md-button>';
                } else {
                  templateHTML = '<md-button aria-label="more" data-cy="edit-location-icon" class="md-icon-button"' + eventClick + '>' +
                    '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
                    '<md-tooltip md-direction="left"><span translate="LOCATIONS.EDIT">Edit</span></md-tooltip>' +
                    '</md-button>';
                }
                return templateHTML;
          }).notSortable()
          .withOption('responsivePriority', 1)
        ];

        return columns;
      }
    };

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _formatDocumentNumber(isCpf, documentNumber) {
      var formattedDocumentNumber = '';

      if (documentNumber) {
        if (isCpf) {
          formattedDocumentNumber = documentNumber.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        } else {
          formattedDocumentNumber = documentNumber.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        }
      }
      return formattedDocumentNumber;
    }

    function exportLocations($event) {
      FcModalService.open($event, {
        title: $translate.instant('LOCATIONS.EXPORT.TITLE'),
        templateUrl: 'app/main/locations/templates/export-locations.html',
        content: $translate.instant('LOCATIONS.EXPORT.CONTENT', { email: authenticatedUser.profile.email }),
        variables: {
          confirmActionContent: $translate.instant('LOCATIONS.EXPORT.CONFIRM_ACTION_CONTENT')
        },
        rightButtonText: $translate.instant('LOCATIONS.EXPORT.YES'),
        leftButtonText: $translate.instant('LOCATIONS.EXPORT.NO'),
        handleRightButton: function () {
          var queryParams = LocationsFilters.toSearchOptions();
          exportsApi.exportFeature('locations', queryParams, {
            timezone: moment.tz.guess()
          }).then(function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('PRODUCTS_SERVICES.EXPORT.SPREADSHEET_SENT', {
                  email: authenticatedUser.profile.email
                }))
                .hideDelay(5000)
            );
          }).catch(function (err) {
            $mdDialog.hide();
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant('PRODUCTS_SERVICES.EXPORT.SPREADSHEET_ERROR'))
                .hideDelay(5000)
            );
          });
        },
        handleLeftButton: function () {}
      });
    }

    function openQrCodeGenerator() {
      $window.dispatchEvent(
        new CustomEvent('crebain-qr-code:open', {
          detail: { mode: 'locations-environments' }
        })
      );
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.exports')
    .controller('ExportsController', ExportsController);

  /** @ngInject */
  function ExportsController(
    exports, exportsApi, account, dataTableOptions, $rootScope, _,
    $compile, $location, QueryStringParser, ExportsFilters,
    moment, DTColumnBuilder, $mdSidenav, $scope, $translate
  ) {
    var vm = this;
    vm.exports = exports.items;
    vm.account = account;
    vm.toggleSidenav = toggleSidenav;
    vm.clearFilters = ExportsFilters.clear;
    vm.filteringIsOn = ExportsFilters.isOn;
    vm.loadExports = _.debounce(loadExports, 1000);
    var _queryParams = {};

    function _initialize() {
      _startDataTable();
      _loadPreDefinedFilters();

      $scope.$on('exports:reload', function () {
        loadExports();
      });
    }

    function loadExports(resetPaging) {
      if (!resetPaging) {
        resetPaging = false;
      }
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _loadPreDefinedFilters() {
      if ($location.search().q) {
        var uriQuery = $location.search().q;

        if (uriQuery) {
          var qOptions = {
            keywords: [
              'id'
            ]
          };

          var queryResult = QueryStringParser.parse(uriQuery, qOptions);
          if (queryResult) {
            if (queryResult['id']) {
              ExportsFilters.id = queryResult['id'];
            }
          }
        }
      }
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * STARTS PRIVATE FUNCTIONS.
     */
    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {

        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;
          _queryParams = {};

          if (ExportsFilters.status) {
            _queryParams['status'] = ExportsFilters.status;
          }

          if (ExportsFilters.employee) {
            _queryParams['user_id'] = ExportsFilters.employee.toString();
          }

          if (ExportsFilters.createdAtFrom) {
            _queryParams['created_at>='] = moment(ExportsFilters.createdAtFrom).format('YYYY-MM-DD');;
          }

          if (ExportsFilters.createdAtTo) {
            _queryParams['created_at<='] = moment(ExportsFilters.createdAtTo).format('YYYY-MM-DD');;
          }

          if (ExportsFilters.completedAtFrom) {
            _queryParams['completed_at>='] = moment(ExportsFilters.completedAtFrom).format('YYYY-MM-DD');;
          }

          if (ExportsFilters.completedAtTo) {
            _queryParams['completed_at<='] = moment(ExportsFilters.completedAtTo).format('YYYY-MM-DD');;
          }

          var sort = '';

          if (aoData[2].value && aoData[2].value[0]) {
            var columnOrder = aoData[2].value[0];
            if (columnOrder.dir === 'desc') {
              sort += '-';
            }
            var columnIndex = columnOrder.column;
            if (columnIndex === 0) {
              sort += 'status';
            } else if (columnIndex === 1) {
              sort += 'type';
            } else if (columnIndex === 2) {
              sort += 'user.name';
            } else if (columnIndex === 3) {
              sort += 'created_at';
            } else if (columnIndex === 4) {
              sort += 'completed_at';
            } else {
              sort = null;
            }
          }

          var queryOptions = {
            offset: aoData[3].value,
            limit: aoData[4].value,
            include: 'user'
          };

          if (sort) { queryOptions.sort = sort; }

          exportsApi.search(_queryParams, queryOptions).then(function (result) {
            vm.exports = result.items;
            fnCallback({
              'draw': aoData[0].value,
              'recordsTotal': result.totalItems,
              'recordsFiltered': result.totalItems,
              'data': result.items
            });

            $rootScope.loadingProgress = false;
          });

        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [200];
        config.pageLength = 200;
        config.order = [3, 'desc'];
      });

      vm.dtColumns = _getDtColumns();
      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          $('.call-to-action').remove();
          _fixTableHeaders();
        });
      };
    }

    function _fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span>' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
          if (isColumnVisible(index)) { visibleColumnsCount++; }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function isColumnVisible(index) {
      if (vm.dtInstance) {
          return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function _getDtColumns() {

      var columns = [
        DTColumnBuilder.newColumn('id', 'id').notVisible(),

        DTColumnBuilder.newColumn(null, $translate.instant('EXPORTS.MODEL.STATUS.TITLE')).renderWith(function (data) {
          var templateVars = {
            className: 'md-grey-600-bg',
            text: $translate.instant('EXPORTS.MODEL.STATUS.PENDING')
          };

          if (data.status === 'completed') {
            templateVars.className = 'md-green-600-bg';
            templateVars.text = $translate.instant('EXPORTS.MODEL.STATUS.COMPLETED');
          } else if (data.status === 'error') {
            templateVars.className = 'md-red-500-bg';
            templateVars.text = $translate.instant('EXPORTS.MODEL.STATUS.ERROR');
          } else if (data.status === 'in-progress') {
            templateVars.className = 'md-yellow-500-bg';
            templateVars.text = $translate.instant('EXPORTS.MODEL.STATUS.IN_PROGRESS');
          }

          var templateColumnHtml = '';
          templateColumnHtml += '<div layout="row" layout-align="center">';
          templateColumnHtml += '<div class="quantity-indicator ' + templateVars.className + '">';
          templateColumnHtml += '<md-tooltip>' + templateVars.text + '</md-tooltip>';
          templateColumnHtml += '</div>';
          templateColumnHtml += '</div>';
          return templateColumnHtml;
        }).withClass('td-status').notSortable(),

        DTColumnBuilder.newColumn(null, $translate.instant('EXPORTS.MODEL.TYPE')).renderWith(function (data) {
          var exportTypes = {
            'tasks': $translate.instant('EXPORTS.MODEL.TYPES.TASKS'),
            'order-pdf-report': $translate.instant('EXPORTS.MODEL.TYPES.ORDER_PDF'),
            'orders-pdfs-reports': $translate.instant('EXPORTS.MODEL.TYPES.ORDER_PDF_MULTIPLE'),
            'customers': $translate.instant('EXPORTS.MODEL.TYPES.CUSTOMERS'),
            'forms-answers': $translate.instant('EXPORTS.MODEL.TYPES.FORMS_ANSWERS'),
            'equipments': $translate.instant('EXPORTS.MODEL.TYPES.EQUIPMENTS'),
            'quotations': $translate.instant('EXPORTS.MODEL.TYPES.QUOTATIONS'),
            'vehicles-usage': $translate.instant('EXPORTS.MODEL.TYPES.VEHICLES_USAGE'),
            'products-services': $translate.instant('EXPORTS.MODEL.TYPES.PRODUCTS_SERVICES'),
            'locations': $translate.instant('EXPORTS.MODEL.TYPES.LOCATIONS')
          };

          return exportTypes[data.type];
        }).notSortable(),

        DTColumnBuilder.newColumn(null, $translate.instant('EXPORTS.MODEL.EMPLOYEE')).renderWith(function (data) {
          return data.user.name;
        }),

        DTColumnBuilder.newColumn(null, $translate.instant('EXPORTS.MODEL.CREATED_AT')).renderWith(function (data) {
          return moment(data.createdAt).format('DD/MM/YYYY HH:mm');
        }),

        DTColumnBuilder.newColumn(null, $translate.instant('EXPORTS.MODEL.COMPLETED_AT')).renderWith(function (data) {
          return data.completedAt ? moment(data.completedAt).format('DD/MM/YYYY HH:mm') : '';
        }),

        DTColumnBuilder.newColumn(null, $translate.instant('EXPORTS.MODEL.EXPORT_LINK')).renderWith(function (data) {
          var isExpired = !moment(data.createdAt).add(2, 'd').isAfter(moment());

          if (data.link && !isExpired) {
            var href = '<a class="export-link" href="' + data.link + '"' ;
            if (data.type.includes('pdf')) {
              href += 'target="_blank"';
            }
            href += '>' + $translate.instant('EXPORTS.MODEL.ACCESS_FILE') + '</a>';
            return href;
          }

          if (isExpired) {
            return '<a class="link-expired">' + $translate.instant('EXPORTS.EXPIRED') + '</a>';
          }

          return '';
        })
      ];

      return columns;
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.equipments')
    .controller('EquipmentsController', EquipmentsController);

  /** @ngInject */
  function EquipmentsController(
    equipments, account, equipmentsApi, exportsApi, dataTableOptions, equipmentsTypes, MessageDialog,
    EquipmentsDialog, $rootScope, _, authenticatedUser, msUtils, $compile, $location, QueryStringParser,
    EquipmentsFilters, moment, DTColumnBuilder, FcModalService, $mdSidenav, $scope, $mdDialog, $translate,
    dataTableHelperService, $window, $document, $localStorage, LocalDateConvert, accountFeatureFlagsApiGraphQL
  ) {
    var vm = this;
    vm.equipmentsTypes = equipmentsTypes.items;
    vm.account = account;
    vm.toggleSidenav = toggleSidenav;
    vm.addEquipments = addEquipments;
    vm.editEquipments = editEquipments;
    vm.clearFilters = EquipmentsFilters.clear;
    vm.filteringIsOn = EquipmentsFilters.isOn;
    vm.exportData = exportData;
    vm.loadEquipments = _.debounce(loadEquipments, 1000);
    vm.totalRows = 0;
    vm.customFieldSelect = $translate.instant('EQUIPMENTS.ALERT.WITH_CUSTOM_FIELD');
    vm.openVideoTutorial = openVideoTutorial;
    vm.openQrCodeGenerator = openQrCodeGenerator;
    vm.hideFeedbackForm = _getHideFeedBackForm();
    vm.closeFeedback = closeFeedback;
    vm.hasWarrantiesPermission = authenticatedUser.hasPermission(vm.account, 'warranties_list');
    vm.getTextColor = getTextColor;
    vm.getBackgroundColor = getBackgroundColor;


    function _initialize() {
      accountFeatureFlagsApiGraphQL
        .getCachedFlagByName('public-qrcode-beta-flag')
        .then(function (flag) {
          vm.showQrCodeButton = flag && flag.active;
        });

      _startDataTable();
      _loadPreDefinedFilters();
    }

    function loadEquipments(resetPaging) {
      if (!resetPaging) {
        resetPaging = false;
      }

      if (vm.dtInstance && vm.dtInstance.DataTable) {
        vm.dtInstance.DataTable.ajax.reload(null, true);
      }
    }

    var exportTables = {
      withCustomField: true
    };

    function _loadPreDefinedFilters() {
      var search = $location.search();
      if (!search.q) {
        return;
      }

      var queryOptions = { keywords: ['id', 'etiqueta'] };
      var result = QueryStringParser.parse(search.q, queryOptions);

      if (result && result['id']) {
        EquipmentsFilters.id = result['id'];
      }

      if (result && result['etiqueta']) {
        EquipmentsFilters.labelsIds = [];
        EquipmentsFilters.labelsIds.push(result['etiqueta']);
      }
    }

    function _resetExportTables() {
      exportTables = {
        withCustomField: true

      };
    }


    function enqueueDataExport(type) {
      exportsApi.exportFeature(type, vm.queryParams, {
        timezone: moment.tz.guess(),
        tables: exportTables
      }).then(function (result) {
        MessageDialog.showToast({
          message: $translate.instant('EQUIPMENTS.TOAST.EXPORTED', { email: authenticatedUser.profile.email })
        });

        return result;
      }, function (err) {
        MessageDialog.showToast({
          message: $translate.instant('EQUIPMENTS.TOAST.WAIT_PLANNING')
        });
      });
    };

    function exportData($event, clickClassNameCallback) {
      _resetExportTables();
      vm.exportingClickClassNameCallback = clickClassNameCallback;

      var withCustomFieldNgModel = false;
      var withoutCustomFieldNgModel = false;
      FcModalService.open($event, {
        title: $translate.instant('EQUIPMENTS.ALERT.TITLE'),
        templateUrl: 'app/main/equipments/templates/export-excel-content.html',
        variables: {
          title: $translate.instant('EQUIPMENTS.ALERT.SUBTITLE'),
          withCustomFieldTitle: $translate.instant('EQUIPMENTS.ALERT.WITH_CUSTOM_FIELD'),
          withoutCustomFieldTitle: $translate.instant('EQUIPMENTS.ALERT.WITHOUT_CUSTOM_FIELD'),
          alertFirstContent: $translate.instant('EQUIPMENTS.ALERT.FIRST_CONTENT'),
          email: authenticatedUser.profile.email,
          alertSecondContent: $translate.instant('EQUIPMENTS.ALERT.SECOND_CONTENT'),
          confirmActionContent: $translate.instant('EQUIPMENTS.ALERT.EXPORT_CONFIRMATION'),
          radioSelection: radioSelection,
          customFieldSelect: vm.customFieldSelect,
          withCustomFieldNgModel: withCustomFieldNgModel,
          withoutCustomFieldNgModel: withoutCustomFieldNgModel
        },
        closeButtonIconPath: 'assets/icons/icon-close.svg',
        leftButtonText: $translate.instant('EQUIPMENTS.ALERT.CANCEL'),
        rightButtonText: $translate.instant('EQUIPMENTS.ALERT.OK'),
        handleRightButton: function () {
          MessageDialog.showToast({
            message: $translate.instant('EQUIPMENTS.TOAST.EXPORTED', { email: authenticatedUser.profile.email })
          });
          enqueueDataExport('equipments');
        },
      });
    }
    function radioSelection(value) {
      exportTables.withCustomField = value;
    };

    function addEquipments($event) {
      EquipmentsDialog.createEquipments($event, null, function (reload) {
        if (reload) {
          loadEquipments();
        }
      });
    }

    function editEquipments(ev, id) {
      EquipmentsDialog.editEquipments(ev, id, null, function (reload) {
        if (reload) {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          if (scrollContent) {
            vm.currentScroll = scrollContent.scrollTop;
          }
          loadEquipments();
        }
      });
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    $scope.$on('equipments:reload', function () {
      loadEquipments();
    });

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;
      vm.dtColumns = _getDtColumns();
      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {

        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;
          vm.queryParams = EquipmentsFilters.toSearchOptions();
          var queryParams = dataTableHelperService.toGraphqlVariables({
            aoData: aoData,
            where: vm.queryParams.graphQL,
            columns: vm.dtColumns
          });

          equipmentsApi.search(queryParams).then(function (result) {
            vm.totalRows = result.totalCount;

            fnCallback({
              draw: aoData[0].value,
              recordsTotal: result.totalCount,
              recordsFiltered: result.totalCount,
              data: result.items
            });

            $rootScope.loadingProgress = false;
          });

        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [200];
        config.pageLength = 200;
        config.order = [4, 'desc'];
      });

      vm.dtInstanceCallback = function (_dtInstance) {
        _fixTableHeaders();
        vm.dtInstance = _dtInstance;
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          if (scrollContent) {
            scrollContent.scrollTop = vm.currentScroll;
          }
          vm.currentScroll = 0;
          $('.call-to-action').remove();
        });
      };
    }


    function _fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });
    }

    function _getDtColumns() {
      var columnNumber = DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENTS.MODEL.NUMBER'))
        .renderWith(function (data) {
          var archivedClass = !data.archived ? 'md-green-600-bg' : 'md-red-500-bg',
            archivedText = $translate.instant(!data.archived ? 'EQUIPMENTS.MODEL.ACTIVE' : 'EQUIPMENTS.MODEL.ARCHIVED'),
            templateHTML = '<div layout="row" layout-align="start center">' +
              '<div class="quantity-indicator ' + archivedClass + '">' +
              '<md-tooltip>' + archivedText + '</md-tooltip>' +
              '</div>' +
              '<span class="table-text">' + data.number + '</span>' +
              '</div>';

              if (data.labels && data.labels.length) {
                templateHTML += '<div layout="row">';
                data.labels.forEach(function (label) {
                  templateHTML += '<i class="icon-label s12 icon ' + label.color + '-fg">';
                  templateHTML += '<md-tooltip><span style="display: none;">label_name#</span>' + label.name + '</md-tooltip>';
                  templateHTML += '</i>';
                });
                templateHTML += '</div>';
              }
          return templateHTML;
        }).withOption('width', '15%');
      columnNumber.sortBy = 'number';

      var columnName = DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENTS.MODEL.NAME'))
        .renderWith(function (data) {
          return '<span class="table-text">' + data.name + '</span>';
        })
        .withOption('width', '15%');
      columnName.sortBy = 'name';


      var columnTypeName = DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENTS.MODEL.EQUIPMENT_TYPE'))
        .renderWith(function (data) {
          return data.type.name;
        });
      columnTypeName.sortBy = 'typeName';

      var columnCustomerName = DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENTS.MODEL.CUSTOMER'))
        .renderWith(function (data) {
          return '<span class="table-text">' + data.customer.name + '</span>';
        }).withOption('width', '15%');
      columnCustomerName.sortBy = 'customerName';

      var columnCreatedAt = DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENTS.MODEL.CREATED_AT'))
        .renderWith(function (data) {
          return LocalDateConvert.formatDateTime(data.createdAt);
        })
        .withOption('width', '15%');
      columnCreatedAt.sortBy = 'createdAt';

      var columnWarrantyStartDate = DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENTS.MODEL.WARRANTY_START_DATE'))
        .renderWith(function (data) {
          return data.warrantySummary && data.warrantySummary.startDate ? LocalDateConvert.formatDateTime(data.warrantySummary.startDate) : $translate.instant('EQUIPMENTS.MODEL.EMPTY');
        })
        .withOption('width', '15%');
        columnWarrantyStartDate.sortBy = 'warrantyStartDate';

      var columnWarrantyEndDate = DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENTS.MODEL.WARRANTY_END_DATE'))
        .renderWith(function (data) {
          return data.warrantySummary && data.warrantySummary.endDate ? LocalDateConvert.formatDateTime(data.warrantySummary.endDate) : $translate.instant('EQUIPMENTS.MODEL.EMPTY');
        })
        .withOption('width', '15%');
        columnWarrantyEndDate.sortBy = 'warrantyEndDate';

      var columnWarrantyStatus = DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENTS.MODEL.WARRANTY_STATUS.TITLE'))
      .renderWith(function (data) {
        if (data.warrantySummary) {
          var backgroundColor = vm.getBackgroundColor(data.warrantySummary.status);
          var textColor = vm.getTextColor(data.warrantySummary.status);
          var text = $translate.instant('EQUIPMENTS.MODEL.WARRANTY_STATUS.' + data.warrantySummary.status.toUpperCase());
          return '<div class="status-badge" style="background-color:' + backgroundColor + '; color:' + textColor + ';">' +
            '<span class="status-badge__dot">●</span>' +
            '<span class="status-badge__text">' + text + '</span>' +
            '</div>';
        } else {
          return $translate.instant('EQUIPMENTS.MODEL.WARRANTY_STATUS.NO_WARRANTY');
        }
      })
      .withOption('width', '15%');
    columnWarrantyStatus.sortBy = 'warrantyStatus';


      var columnActions = DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENTS.TABLE.ACTIONS'))
        .renderWith(function (data) {
          var tooltip = data.locked ? $translate.instant('EQUIPMENTS.TABLE.EDIT_LOCKED') : $translate.instant('EQUIPMENTS.TABLE.EDIT'),
            eventClick = data.locked ? '' : 'ng-click="vm.editEquipments($event,\'' + data.id + '\')"',
            disabledClass = data.locked ? ' md-button-disabled-css' : '',
            templateHTML = '<md-button aria-label="more" data-cy="equipments-edit-button" class="md-icon-button' + disabledClass + '"' + eventClick + '>' +
              '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left">' + tooltip + '</md-tooltip>' +
              '</md-button>';
          return templateHTML;
        })
        .withOption('width', '10%')
        .notSortable()
        .withOption('responsivePriority', 1);

      var columns = [
        columnNumber,
        columnName,
        columnTypeName,
        columnCustomerName
      ];

      if(vm.hasWarrantiesPermission) {
        columns.push(columnWarrantyStartDate);
        columns.push(columnWarrantyEndDate);
        columns.push(columnWarrantyStatus);
      }

      columns.push(columnCreatedAt);
      columns.push(columnActions);

      return columns;
    }

    function openVideoTutorial() {
      $mdDialog.show({
        controller: 'VideoTutorialController',
        controllerAs: 'vm',
        templateUrl: 'app/core/dialogs/video-tutorial/video-tutorial.html',
        parent: angular.element($document.body),
        clickOutsideToClose: false,
        locals: {
          videoUrl: 'https://www.youtube.com/embed/efhfk3D9PJE?modestbranding=1&rel=0'
        }
      });
    }


    function _getHideFeedBackForm() {
      return $localStorage.get("hideEquipmentsFeedbackForm_c6220fe7-7eea-4d13-ac2c-d7d377e08b11");
    }

    function closeFeedback() {
      vm.hideFeedbackForm = true;
      $localStorage.set("hideEquipmentsFeedbackForm_c6220fe7-7eea-4d13-ac2c-d7d377e08b11", 'true');
    }


    function getTextColor(status) {
      switch (status.toLowerCase()) {
        case 'active':
          return '#29A37A';
        case 'expired':
          return '#FF0000';
        case 'extended':
          return '#FFAA00';
        case 'future':
          return '#00AAFF';
        default:
          return null;
      }
    }

    function getBackgroundColor(status) {
      switch (status.toLowerCase()) {
        case 'active':
          return '#2fb6881a';
        case 'expired':
          return '#ff00001a';
        case 'extended':
          return '#ffaa001a';
        case 'future':
          return '#00aaff1a';
        default:
          return null;
      }
    }

    function openQrCodeGenerator() {
      $window.dispatchEvent(
        new CustomEvent('crebain-qr-code:open', {
          detail: { mode: 'equipments' }
        })
      );
    }

    angular.element(document).ready(function () {
      _initialize();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.equipment-types')
        .controller('EquipmentTypesController', EquipmentTypesController);

    /** @ngInject */
    function EquipmentTypesController(equipmentTypesApi, dataTableOptions, EquipmentPermissionService,
                                 EquipmentTypesDialog, $rootScope, _, authenticatedUser, $compile, account,
                                 EquipmentTypesFilters, moment, DTColumnBuilder, $mdSidenav, $scope, $mdDialog,
                                 $document, $translate, LocalDateConvert) {

        var vm = this;
        vm.account = angular.copy(account);

        EquipmentPermissionService.accountHasEquipmentPermission(vm.account.configuration);

        vm.toggleSidenav = toggleSidenav;
        vm.addEquipmentTypes = addEquipmentTypes;
        vm.editEquipmentTypes = editEquipmentTypes;
        vm.clearFilters = EquipmentTypesFilters.clear;
        vm.filteringIsOn = EquipmentTypesFilters.isOn;
        vm.loadEquipmentTypes = _.debounce(loadEquipmentTypes, 1000);
        vm.formSearchTerm = "";
        vm.openVideoTutorial = openVideoTutorial;
        vm.dateTimeFormat = LocalDateConvert.pickFormat('date-time');

        function _initiliaze() {
            _startDataTable();
        }

        function loadEquipmentTypes(resetPaging) {
            if (!resetPaging) {
                resetPaging = false;
            }

            vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
        }

        function addEquipmentTypes(event) {
            EquipmentTypesDialog.createEquipmentTypes(event, function (reload) {
                if (reload) {
                    loadEquipmentTypes();
                }
            });
        }

        function editEquipmentTypes(event, id) {
            EquipmentTypesDialog.editEquipmentTypes(event, id, function (reload) {
                if (reload) {
                    vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
                    loadEquipmentTypes();
                }
            });
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        $scope.$on('equipment-types:reload', function () {
            loadEquipmentTypes(true);
        });

        function _startDataTable() {
            vm.dtInstance = {};
            vm.currentScroll = vm.currentScroll || 0;

            vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
                config.sAjaxDataProp = 'data';
                config.processing = true;
                config.serverSide = true;
                config.searchDelay = 2000;
                config.paging = true;
                config.columnDefs = [];
                config.lengthMenu = [25, 50, 100, 200, 250];
                config.pageLength = 25;

                config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
                    $rootScope.loadingProgress = true;

                    var queryParams = {};

                    if (EquipmentTypesFilters.archived === '1') {
                        queryParams['archived'] = 'false';
                    } else if (EquipmentTypesFilters.archived === '2') {
                        queryParams['archived'] = 'true';
                    }

                    if (EquipmentTypesFilters.name) {
                        queryParams['name~~*'] = '*' + EquipmentTypesFilters.name + '*';
                    }

                    var sort = '';

                    if (aoData[2].value && aoData[2].value[0]) {
                        var columnOrder = aoData[2].value[0];
                        if (columnOrder.dir === 'desc') {
                        sort += '-';
                        }
                        var columnIndex = columnOrder.column;
                        if (columnIndex === 0) {
                        sort += 'name';
                        } else {
                        sort = null;
                        }
                    }

                    var queryOptions = {
                        limit: aoData[4].value,
                        offset: aoData[3].value,
                        sort: '-created_at'
                    };

                    if (sort) { queryOptions.sort = sort; }

                    equipmentTypesApi.search(queryParams, queryOptions).then(function (result) {
                        fnCallback({
                            'draw': aoData[0].value,
                            'recordsTotal': result.totalItems,
                            'recordsFiltered': result.totalItems,
                            'data': result.items
                        });
                        $rootScope.loadingProgress = false;
                    });

                }, 1000);

                config.createdRow = function (row) {
                    $compile(angular.element(row).contents())($scope);
                };
            });

            vm.dtColumns = _getDtColumns();
            vm.dtInstanceCallback = function (_dtInstance) {
                vm.dtInstance = _dtInstance;
                vm.dtInstance.DataTable.on('draw', function () {
                    var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
                    scrollContent.scrollTop = vm.currentScroll;
                    vm.currentScroll = 0;
                });

                _fixTableHeaders();
            };
        }

        function _getDtColumns() {
            return [
                DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENT_TYPES.MODEL.NAME')).renderWith(function (data) {

                    var corporateCustomerName = data.metadata && data.metadata.sammathnaur
                        && data.metadata.sammathnaur.account && data.metadata.sammathnaur.account.name,
                    corporateCustomerNameFormatted = corporateCustomerName ?
                            '<em class="text-light-gray">(' + corporateCustomerName + ')</em>' : '<em>' + '</em>';

                    var archivedClass = !data.archived ? 'md-green-600-bg' : 'md-red-500-bg',
                    archivedText = $translate.instant(!data.archived ? 'EQUIPMENT_TYPES.MODEL.ACTIVED' : 'EQUIPMENT_TYPES.MODEL.ARCHIVED'),
                    templateHTML = '<div layout="row" layout-align="start center">' +
                                      '<div class="quantity-indicator ' + archivedClass + '">' +
                                        '<md-tooltip>' + archivedText + '</md-tooltip>' +
                                      '</div>' +
                                      '<span>' + data.name + ' ' + corporateCustomerNameFormatted + '</span>' +
                                    '</div>';
                    return templateHTML;
                })
                .withOption('width', '70%'),

                DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENT_TYPES.MODEL.CREATED_AT')).renderWith(function (data) {
                    return moment(data.createdAt).format(vm.dateTimeFormat);
                })
                .withOption('width', '20%')
                .notSortable(),

                DTColumnBuilder.newColumn(null, $translate.instant('EQUIPMENT_TYPES.TABLE.ACTIONS')).renderWith(function (data) {
                    var tooltip = $translate.instant(data.locked ? 'EQUIPMENT_TYPES.TABLE.VIEW' : 'EQUIPMENT_TYPES.TABLE.EDIT'),
                    eventClick = 'ng-click="vm.editEquipmentTypes($event,\'' + data.id + '\')"',
                    templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
                                        '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
                                        '<md-tooltip md-direction="left">' + tooltip + '</md-tooltip>' +
                                    '</md-button>';
                    return templateHTML;
                })
                .withOption('width', '10%')
                .notSortable()
            ];
        }

        function _fixTableHeaders() {
            $('.dataTables_scrollHeadInner table thead th').each(function () {
                var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
                $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
            });

            var visibleColumnsCount = 1;
            for (var index = 0; index < vm.dtColumns.length; index++) {
                if (_isColumnVisible(index)) { visibleColumnsCount++; }
            }
            $('.dataTables_empty').attr('colspan', visibleColumnsCount);
        }

        function _isColumnVisible(index) {
            if (vm.dtInstance) {
                return vm.dtInstance.DataTable.column(index).visible();
            }
        }

        function openVideoTutorial() {
          $mdDialog.show({
            controller: 'VideoTutorialController',
            controllerAs: 'vm',
            templateUrl: 'app/core/dialogs/video-tutorial/video-tutorial.html',
            parent: angular.element($document.body),
            clickOutsideToClose: false,
            locals: {
              videoUrl: 'https://www.youtube.com/embed/nfOiUNjFfds?modestbranding=1&rel=0'
            }
          });
        }

        _initiliaze();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.employees')
        .controller('EmployeesController', EmployeesController);

    /** @ngInject */
    function EmployeesController(employees, account, employeesApi, dataTableOptions,
        EmployeePasswordDialog, EmployeeCredentialsDialog, EmployeeDialog, $rootScope, $mdToast, LocalDateConvert,
        _, accountFeatureFlagsApiGraphQL, msUtils, $compile, EmployeesFilters, DTColumnBuilder,
        $mdSidenav, $scope, EmployeeService, $translate, licenseService , $mdDialog, $document, employeesApiGraphQL, exportsApi, fcExportAlertService, authenticatedUser, moment, $filter) {

        var vm = this;
        vm.account = account;
        vm.countryCode = account.address.countryCode;
        vm.clearFilters = EmployeesFilters.clear;
        vm.employees = employees.items;
        vm.filteringIsOn = EmployeesFilters.isOn;
        vm.hasMultipleEmployeeAccountsFlag = false;
        vm.sortByName = 'name_asc';

        // Methods
        vm.addCredentialsEmployee = addCredentialsEmployee;
        vm.addEmployee = addEmployee;
        vm.editEmployee = editEmployee;
        vm.editPasswordEmployee = editPasswordEmployee;
        vm.getEmployeeAtavarUrl = getEmployeeAtavarUrl;
        vm.reloadDatatable = _.debounce(reloadDatatable, 1000);
        vm.toggleSidenav = toggleSidenav;
        vm.openVideoTutorial = openVideoTutorial;
        vm.getHasMultipleEmployeeAccountsFlag = getHasMultipleEmployeeAccountsFlag;
        vm.exportData = exportData;

        _initialize();

        function _initialize() {
            _loadFeatureFlags();
            _startDataTable();
            _calculateLicenseLimit();

            $scope.$on('employees:reload', function () {
                reloadDatatable();
            });
        }

        function loadEmployees() {
            employeesApi.getAll().then(function (result) {
                vm.employees = result.items;
                _calculateLicenseLimit();
                reloadDatatable(true);
            });
        }

        function getEmployeeAtavarUrl(employee) {
            if (employee.avatarUrl) {
                return employee.avatarUrl + '?id=' + msUtils.shortGuidGenerator();
            } else {
                return 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br/defaults/avatar.jpg';
            }
        }

        function addEmployee(ev) {
          vm.account.maxEmployeesAllowed = vm.account.maxEmployeesAllowed * (vm.account.configuration.maxEmployeesAllowedMultiplier || 1);
            if (vm.account.countActiveEmployees < vm.account.maxEmployeesAllowed) {
                EmployeeDialog.createEmployee(ev, vm.account.countActiveEmployees, function (reload) {
                    if (reload) {
                        loadEmployees();
                    }
                });
            } else {
                EmployeeService.showMaxAllowedEmployeesMessage(vm.account.maxEmployeesAllowed);
            }
        }

        function editEmployee(ev, id) {
            EmployeeDialog.editEmployee(ev, id, vm.account.countActiveEmployees, function (reload) {
                if (reload) {
                    vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
                    loadEmployees();
                }
            });
        }

        function _calculateLicenseLimit() {
            employeesApiGraphQL.countActiveEmployees().then(function (result) {
                var activeEmployees = result.totalCount;

                var limit = licenseService.limit(activeEmployees, vm.account);

                vm.account.countActiveEmployees = activeEmployees;
                vm.account.isLimitExeeded = limit.isExceeded;
                vm.account.countActiveEmployeesPercentage = limit.percentage;
            });
        }

        function reloadDatatable(resetPaging) {
            vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }


        function isEmployeeFiredAndBeforeToday(firedAt) {
          if (!firedAt) {
            return false;
          }

          var firedAtMoment = moment(firedAt);

          return firedAtMoment.isBefore(moment());
        }

        function _startDataTable() {
          vm.dtInstance = {};
          vm.currentScroll = vm.currentScroll || 0;

          vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
            config.sAjaxDataProp = "data";
            config.serverSide = true;
            config.searchDelay = 2000;
            config.paging = true;

            config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
              $rootScope.loadingProgress = true;

              var sort = '';
              if (aoData[2].value && aoData[2].value[0]) {
                var columnOrder = aoData[2].value[0];
                vm.sortByName = 'name_' + columnOrder.dir;
                if (columnOrder.dir === 'desc') { sort += '-'; }
                var columnIndex = columnOrder.column;
                if (columnIndex === 0) {
                  sort += 'name_' + columnOrder.dir;
                } else {
                  sort = null;
                }
              }

              var queryOptions = {
                where: {
                  active: true,
                  isInactivated: null,
                  isInactivatedOrFired: null
                },
                orderBy: vm.sortByName,
                take: aoData[4].value,
                skip: aoData[3].value
              };

              if (sort) { queryOptions.sort = sort; }

              if (EmployeesFilters.name) {
                queryOptions.where.nameContains = EmployeesFilters.name;
              }

              var isActive = EmployeesFilters.archived === 'active';
              var isInactive = EmployeesFilters.archived === 'inactive';

              if (isActive) {
                queryOptions.where.active = true;
                queryOptions.where.isInactivated = false;
              } else if (isInactive) {
                queryOptions.where.active = null;
                queryOptions.where.isInactivatedOrFired = true;
              } else {
                queryOptions.where.active = null;
                queryOptions.where.isInactivated = null;
              }

              employeesApiGraphQL.search(queryOptions).then(function (result) {
                vm.employees = result.items;
                vm.totalItems = result.totalCount;
                if (isActive) {
                  vm.employees = _.filter(result.items, function (employee) {
                    return employee.contract.active === true && !employee.inactivatedAt;
                  });
                }
                if (isInactive) {
                  vm.employees = _.filter(result.items, function (employee) {
                    return employee.contract.active === false || employee.inactivatedAt || isEmployeeFiredAndBeforeToday(employee.contract.firedAt);
                  });
                }
                fnCallback({
                  'draw': aoData[0].value,
                  'recordsTotal': vm.totalItems,
                  'recordsFiltered': vm.totalItems,
                  'data': vm.employees
                });
              })
              .catch(function () {
                $mdToast.show(
                  $mdToast.simple()
                    .textContent($translate.instant('EMPLOYEES.MODEL.ERRORS.RELOAD'))
                    .hideDelay(3000)
                    .theme('error-toast')
                );
              }).finally(function () {
                $rootScope.loadingProgress = false;
              });
            }, 1000);

            config.createdRow = function (row) {
              $compile(angular.element(row).contents())($scope);
            };

            config.columnDefs = [];
            config.lengthMenu = [25, 50, 100, 200];
            config.pageLength = 25;
          });

          vm.dtColumns = _getDtColumns();
					vm.dtInstanceCallback = function (_dtInstance) {
							vm.dtInstance = _dtInstance;
							vm.dtInstance.DataTable.on('draw', function () {
								var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
								scrollContent.scrollTop = vm.currentScroll;
								vm.currentScroll = 0;
								$('.call-to-action').remove();
								var ctaNewEmployee = $compile('<div class="call-to-action">' +
									'<span translate="EMPLOYEES.TABLE.CREATE_EMPLOYEE_CTA">You can create a new employee</span> ' +
									'<a class="cursor-pointer" translate="EMPLOYEES.TABLE.CREATE_EMPLOYEE_LINK" ng-click="vm.addEmployee($event)">clicking here</a>.' +
									'</div>')(($scope));
								$('.dataTables_empty').append($(ctaNewEmployee));
							});
						fixTableHeaders();
					};
        }

        function _getDtColumns() {
            var columns = [
                DTColumnBuilder.newColumn(null, $translate.instant('EMPLOYEES.MODEL.NAME')).renderWith(function (data) {
                    var archivedClass = data.contract.active ? 'md-green-600-bg' : 'md-red-500-bg',
                        archivedText = $translate.instant(data.contract.active ? 'EMPLOYEES.TABLE.ACTIVATED' : 'EMPLOYEES.TABLE.DEACTIVATED'),
                        templateHTML = '<div layout="row" layout-align="start center">' +
                            '<div class="quantity-indicator ' + archivedClass + '">' +
                            '<md-tooltip>' + archivedText + '</md-tooltip>' +
                            '</div>' +
                            '<div class="avatar-wrapper">' +
                            '<img md-menu-align-target="" class="avatar-employees" alt="' + data.name + '" ng-src="' + (data.avatarUrl ? data.avatarUrl : "./assets/images/avatars/profile.jpg") + '" src="./assets/images/avatars/profile.jpg">' +
                            '</div>' +
                            '<span>' + data.name + '</span>' +
                            '</div>';
                    return templateHTML;
                }),

                DTColumnBuilder.newColumn('documentNumber', $translate.instant('EMPLOYEES.TABLE.DOCUMENT_NUMBER'))
                    .renderWith(function (data) {
                        return vm.countryCode === 'BRA' ? $filter('brCpfCnpj')(data) : data;
                    })
                    .withClass('td-document-number')
                    .notSortable(),

                DTColumnBuilder.newColumn(null, $translate.instant('EMPLOYEES.MODEL.EMAIL')).renderWith(function (data) {
                  var templateHTML = '';

                  if (data.emailValidatedAt) {
                    templateHTML += '<md-icon class="employee-email employee-email--valid" md-font-icon="icon-checkbox-marked-circle">' +
                      '<md-tooltip>' +
                        '<span translate="EMPLOYEES.TABLE.ROWS.EMAIL.VERIFIED"' +
                          'translate-values="{ validatedAt: \'' + LocalDateConvert.formatDate(data.emailValidatedAt, 'date') + '\' }">' +
                            'Verified at: ' + LocalDateConvert.formatDate(data.emailValidatedAt, 'date') +
                        '</span>' +
                      '</md-tooltip>' +
                    '</md-icon>';
                  } else {
                    templateHTML += '<md-icon class="employee-email employee-email--invalid" md-font-icon="icon-close-circle">' +
                      '<md-tooltip>' +
                        '<span translate="EMPLOYEES.TABLE.ROWS.EMAIL.UNVERIFIED">' +
                          'Unverified email' +
                        '</span>' +
                      '</md-tooltip>' +
                    '</md-icon>';
                  }

                  templateHTML += (data.email || $translate.instant('EMPLOYEES.MODEL.NO_EMAIL'));

                  return templateHTML;
                }).withClass('td-email').notSortable(),

                DTColumnBuilder.newColumn(null, $translate.instant('EMPLOYEES.MODEL.GEOLOCATION')).renderWith(function (data) {
                    var enabled = data.geolocationEnabled;
                    var statusClass = enabled ? 'geolocation-badge geolocation-badge--enabled' : 'geolocation-badge geolocation-badge--disabled';
                    var statusText = $translate.instant(enabled ? 'EMPLOYEES.MODEL.GEOLOCATION_ENABLED' : 'EMPLOYEES.MODEL.GEOLOCATION_DISABLED');

                    var templateHTML =
                      '<div class="' + statusClass + '">' +
                        '<div class="geolocation-badge__dot-container"><span class="geolocation-badge__dot"></span></div>' +
                        '<span>' + statusText + '</span>' +
                      '</div>';

                    return templateHTML;
                }).notSortable(),

                DTColumnBuilder.newColumn(null, $translate.instant('EMPLOYEES.MODEL.START_DATE')).renderWith(function (data) {
                    return LocalDateConvert.formatDate(data.contract.hiredAt, 'date');
                }).notSortable(),

                DTColumnBuilder.newColumn(null, $translate.instant('EMPLOYEES.MODEL.END_DATE')).renderWith(function (data) {
                    if (data.contract.firedAt) {
                        return LocalDateConvert.formatDate(data.contract.firedAt, 'date');
                    }
                    return '';
                }).notSortable(),

                DTColumnBuilder.newColumn(null, $translate.instant('EMPLOYEES.MODEL.START_TIME')).renderWith(function (data) {
                    return LocalDateConvert.formatDate(data.workSchedule.start, 'time-seconds');
                }).notSortable(),

                DTColumnBuilder.newColumn(null, $translate.instant('EMPLOYEES.MODEL.END_TIME')).renderWith(function (data) {
                    return LocalDateConvert.formatDate(data.workSchedule.end, 'time-seconds');
                }).notSortable(),

                DTColumnBuilder.newColumn(null, $translate.instant('EMPLOYEES.TABLE.ACTIONS')).renderWith(function (data) {
                    var tooltip = $translate.instant('EMPLOYEES.TABLE.EDIT'),
                        eventClick = data.locked ? '' : 'ng-click="vm.editEmployee($event,\'' + data.id + '\')"',
                        disabledClass = data.locked ? ' md-button-disabled-css' : '',
                        templateHTML = '<div style="width: 170px"><md-button aria-label="more" data-cy="edit-employee-button" class="md-icon-button' + disabledClass + '"' + eventClick + '>' +
                            '<img ng-src="assets/icons/icon-edit.svg" alt="Edit" class="ng-scope">' +
                            '<md-tooltip md-direction="right">' + tooltip + '</md-tooltip>' +
                            '</md-button>';

                    templateHTML += data.email ? editPasswordEmployeeButton(data) : addCredentialsEmployeeButton(data);

                    templateHTML += '</div>';

                    return templateHTML;
                })
                .notSortable()
                .withOption('responsivePriority', 1)
            ];

            return columns;
        }

        function fixTableHeaders() {
            $('.dataTables_scrollHeadInner table thead th').each(function () {
                var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
                $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
            });
        }

        function editPasswordEmployeeButton(data) {
            var tooltip = $translate.instant('EMPLOYEES.TABLE.CHANGE_PASSWORD'),
                disabledClass = data.locked ? ' md-button-disabled-css' : '',
                templateHTML = '<md-button ng-if="!vm.getHasMultipleEmployeeAccountsFlag()" aria-label="more" ng-click="vm.editPasswordEmployee($event,' + data.id + ')" class="md-icon-button' + disabledClass + '">' +
                    '<md-icon class="access-icon" md-font-icon="icon-key-variant"></md-icon>' +
                    '<md-tooltip md-direction="left">' + tooltip + '</md-tooltip>' +
                    '</md-button>';

            return templateHTML;
        }

        function addCredentialsEmployeeButton(data) {
            var tooltip = $translate.instant('EMPLOYEES.TABLE.ADD_CREDENTIALS'),
                disabledClass = data.locked ? ' md-button-disabled-css' : '',
                templateHTML = '<md-button ng-if="!vm.getHasMultipleEmployeeAccountsFlag()" aria-label="more" ng-click="vm.addCredentialsEmployee($event,' + data.id + ')" class="md-icon-button' + disabledClass + '">' +
                    '<md-icon md-font-icon="icon-alert" class="icon-red"></md-icon>' +
                    '<md-tooltip md-direction="left">' + tooltip + '</md-tooltip>' +
                    '</md-button>';

            return templateHTML;
        }

        function editPasswordEmployee(ev, employeeId) {
            var employee = _.find(vm.employees, function (emp) {
                return emp.id === employeeId;
            });

            EmployeePasswordDialog.open(ev, {
                employeeUsername: employee.email,
                employeeName: employee.name
            }, function () {
                loadEmployees();
            });
        }

        function addCredentialsEmployee(ev, employeeId) {
            var employee = _.find(vm.employees, function (emp) {
                return emp.id === employeeId;
            });

            EmployeeCredentialsDialog.open(ev, {
                employeeId: employee.id,
                employeeName: employee.name
            }, function () {
                loadEmployees();
            });
        }

        function openVideoTutorial() {
          $mdDialog.show({
            controller: 'VideoTutorialController',
            controllerAs: 'vm',
            templateUrl: 'app/core/dialogs/video-tutorial/video-tutorial.html',
            parent: angular.element($document.body),
            clickOutsideToClose: false,
            locals: {
              videoUrl: 'https://www.youtube.com/embed/LcvgRLLjs9Q?modestbranding=1&rel=0'
            }
          });
        }

        function getHasMultipleEmployeeAccountsFlag() {
            return vm.hasMultipleEmployeeAccountsFlag;
        }

        function _loadFeatureFlags() {
            accountFeatureFlagsApiGraphQL.getCachedFlagByName('multiple-accounts-employees').then(function (hasFlag) {
                hasFlag = hasFlag && hasFlag.active;

                $scope.$apply(function () {
                    vm.hasMultipleEmployeeAccountsFlag = hasFlag;
                });
            });
        }

        function enqueueDataExport(type) {
          var filters = employeesExportFilter();
          exportsApi.exportFeature(type, filters, {
            timezone: moment.tz.guess(),
          }).then(function (result) {
            fcExportAlertService.show({
              email: authenticatedUser.profile.email,
              title: $translate.instant('EMPLOYEES.EXPORT.TITLE'),
              hasSendedToEmail: true
            });
            return result;
          }).catch(function () {
            var message = $translate.instant('EMPLOYEES.EXPORT.ERROR');
            $mdToast.show(
              $mdToast.simple()
                .textContent(message)
                .hideDelay(5000)
            );
          });
        };

        function employeesExportFilter() {
          var queryOptions = {
            graphQL: {},
          };

          if (EmployeesFilters.name) {
            queryOptions.graphQL.name = EmployeesFilters.name;
          }

          var isActive = EmployeesFilters.archived === 'active';
          var isInactive = EmployeesFilters.archived === 'inactive';

          if (isActive) {
            queryOptions.graphQL.active = true;
            queryOptions.graphQL.isInactivated = false;
          } else if (isInactive) {
            queryOptions.graphQL.isInactivatedOrFired = true;
          }

          return queryOptions;
        }

        function exportData() {
          enqueueDataExport('employees');
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.devices')
    .controller('DevicesController', DevicesController);

  /** @ngInject */
  function DevicesController($scope, $rootScope, $compile, $mdDialog, $mdSidenav, $mdToast, _, DTColumnBuilder, dataTableOptions, moment, devicesApi, DevicesFilters, $translate, LocalDateConvert, $filter) {
    var vm = this;

    vm.dtColumns = _getDtColumns();
    vm.devices = [];

    function deleteDevice(ev, id) {
      $rootScope.loadingProgress = true;

      var confirm = $mdDialog.confirm()
        .title($translate.instant("DEVICES.DELETE_ALERT.TITLE"))
        .textContent($translate.instant("DEVICES.DELETE_ALERT.BODY"))
        .ok($translate.instant("DEVICES.DELETE_ALERT.OK"))
        .cancel($translate.instant("DEVICES.DELETE_ALERT.CANCEL"));

      $mdDialog.show(confirm)
        .then(function () {
          devicesApi.delete(id).then(function () {
            _reloadDatatable();

            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant("DEVICES.TOAST.DELETE_SUCCESS"))
                .hideDelay(3000)
            );
          }).catch(function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant("DEVICES.TOAST.DELETE_ERROR"))
                .hideDelay(3000)
                .theme("error-toast")
            );
          });
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function deleteAllDevices(ev) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant("DEVICES.DELETE_ALL_ALERT.TITLE"))
        .textContent($translate.instant("DEVICES.DELETE_ALL_ALERT.BODY"))
        .ok($translate.instant("DEVICES.DELETE_ALL_ALERT.OK"))
        .cancel($translate.instant("DEVICES.DELETE_ALL_ALERT.CANCEL"));

      $mdDialog.show(confirm).then(
        function onConfirm() {
          $rootScope.loadingProgress = true;

          return devicesApi.deleteAll()
            .then(function () {
              _reloadDatatable();
              $mdToast.show(
                $mdToast.simple()
                  .textContent($translate.instant("DEVICES.DELETE_ALL_ALERT.SUCCESS"))
                  .hideDelay(3000)
              );
            })
            .catch(function () {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($translate.instant("DEVICES.DELETE_ALL_ALERT.ERROR"))
                  .hideDelay(3000)
                  .theme("error-toast")
              );
            })
            .finally(function () {
              $rootScope.loadingProgress = false;
            });
        },
        function onCancel() {
        }
      );
    }

    $scope.$on('devices:reload', function () {
      _reloadDatatable();
    });

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
    * STARTS PRIVATE FUNCTIONS.
    */

    function _initialize() {
      vm.reload = _.debounce(_reloadDatatable, 1000);
      vm.deleteDevice = deleteDevice;
      vm.deleteAllDevices = deleteAllDevices;
      vm.toggleSidenav = toggleSidenav;
      vm.devicesFilters = DevicesFilters;

      _startDataTable();
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {

        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;

        config.buttons = [];

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var sort = '';
          if (aoData[2].value && aoData[2].value[0]) {
            var columnOrder = aoData[2].value[0];
            var columnIndex = columnOrder.column;
            if (columnIndex === 7) {
              sort = (columnOrder.dir === 'desc' ? '-' : '') + 'last_seen_with';
            } else {
              sort = null;
            }
          }

          var filteredDevices = 0;
          var filteredDevicesArray = [];
          var queryOptions = {
            offset: aoData[3].value,
            limit: aoData[4].value,
            sort: sort
          };
          var query = {
            uuid: DevicesFilters.uuid,
            manufacturer: DevicesFilters.manufacturer,
            platform_name: angular.lowercase(DevicesFilters.platform_name),
            last_seen_with: DevicesFilters.last_seen_with
          };

          devicesApi.search(query, queryOptions).then(function (devices) {
            filteredDevices = devices.totalItems;
            filteredDevicesArray = devices.items;
          }).finally(function () {
            fnCallback({
              'draw': aoData[0].value,
              'recordsTotal': filteredDevices,
              'recordsFiltered': filteredDevices,
              'data': filteredDevicesArray
            });
            $rootScope.loadingProgress = false;
          });

        }, 1000);

        config.createdRow = function (row) {
          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [10, 50, 100, 200];
        config.pageLength = 10;
      });

      vm.dtColumns = _getDtColumns();
      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          $('.call-to-action').remove();
          var ctaNewDevice = $compile('<div class="call-to-action"><span translate="DEVICES.TABLE.NO_RESULTS">No devices added so far.</span></div>')(($scope));
          $('.dataTables_empty').append($(ctaNewDevice));
          $('.dataTables_empty').attr('colspan', _countTableColumns(_dtInstance));
        });
        fixTableHeaders();
      };
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });
    }

    function _countTableColumns(_dtInstance) {
      return _dtInstance.DataTable.columns().header().length;
    }

    function _getDtColumns() {
      return [
        DTColumnBuilder.newColumn('id', 'id').notVisible(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEVICES.MODEL.IDENTIFIER')).renderWith(function (data) {
          return data.uuid;
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEVICES.MODEL.MANUFACTURER')).renderWith(function (data) {
          return data.manufacturer;
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEVICES.MODEL.MODEL')).renderWith(function (data) {
          return data.model;
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEVICES.MODEL.PLATFORM')).renderWith(function (data) {
          return data.platform.name;
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEVICES.MODEL.VERSION')).renderWith(function (data) {
          return data.platform.version;
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEVICES.MODEL.LAST_ACCESS')).renderWith(function (data) {
          return LocalDateConvert.formatDate(data.lastSeenAt, 'date-time');
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEVICES.MODEL.LAST_USER_TO_USE_IT')).renderWith(function (data) {
          return data.lastSeenWith;
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('DEVICES.MODEL.DEVICE_APP_VERSION'))
        .renderWith(function (data) {
          return $filter('versionAppFilter')(data.appVersion);
        }),
        DTColumnBuilder.newColumn(null, $translate.instant('DEVICES.TABLE.ACTIONS')).renderWith(function (data) {
          var eventClick = 'ng-click="vm.deleteDevice($event,\'' + data.id + '\')"',
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<md-icon md-font-icon="icon-delete"></md-icon>' +
              '<md-tooltip md-direction="left"><span translate="DEVICES.TABLE.REMOVE">Remove</span></md-tooltip>' +
              '</md-button>';
          return templateHTML;
        }).notSortable()
      ];
    }
    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deadline-violations-reasons')
    .controller('DeadlineViolationosReasonsController', DeadlineViolationosReasonsController);

  /** @ngInject */
  function DeadlineViolationosReasonsController(
    $translate, $compile, $scope, $rootScope, _, dataTableOptions,
    DTColumnBuilder, deadlineViolationsReasonsApi, DeadlineViolationsReasonsFilters, $mdSidenav, DeadlineViolationsReasonsDialog, LocalDateConvert
  ) {
    var vm = this;
    vm.openDialogDeadlineViolationsReasons = openDialogDeadlineViolationsReasons;

    function _addCallToActionButton() {
      $('.call-to-action').remove();

      var ctaNewProductService = $compile('')(($scope));

      $('.dataTables_empty').append($(ctaNewProductService));
    }

    function _fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (_isColumnVisible(index)) { visibleColumnsCount++; }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function _isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _getDtColumns() {
      return [
        DTColumnBuilder.newColumn('id', 'id').notVisible(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-VIOLATIONS-REASONS.TABLE.COLOR')).renderWith(function (data) {
          var color = data.color;
          var templateHTML = '<div style="width: 17.55px; height: 17.55px; border-radius: 50px; background-color:'+ color + '; margin-left: 8px;"></div>';
          return templateHTML;
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-VIOLATIONS-REASONS.TABLE.NAME')).renderWith(function (data) {
          if (!data.name) {
            return '';
          }

          var enterpriseCustomerName = data.metadata && data.metadata.sammathnaur && data.metadata.sammathnaur.account && data.metadata.sammathnaur.account.name;
          if (enterpriseCustomerName) {
            return data.name + ' <em class="text-light-gray">(' + enterpriseCustomerName + ')</em>';
          }

          return data.name;
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-VIOLATIONS-REASONS.TABLE.DESCRIPTION')).renderWith(function (data) {
          if (!data.description) {
            return '';
          }
          return data.description;
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-VIOLATIONS-REASONS.TABLE.CREATED_AT')).renderWith(function (data) {
          if (!data.createdAt) {
            return '';
          }
          return LocalDateConvert.formatDate(data.createdAt, 'date-time');
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-VIOLATIONS-REASONS.TABLE.ACTIONS')).renderWith(function (data) {
          var eventClick = 'ng-click="vm.openDialogDeadlineViolationsReasons($event,\'' + data.id + '\')"',
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left">' +
              '<span translate="DEADLINE-VIOLATIONS-REASONS.TABLE.' +
              (data.locked ? 'VIEW' : 'ACTIONS') +
              '">View</span>' +
              '</md-tooltip>' +
              '</md-button>';
          return templateHTML;
        }).notSortable()
        .withOption('responsivePriority', 1)
      ];
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [];

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var sort = '';
          if (aoData[2].value && aoData[2].value[0]) {
            var columnOrder = aoData[2].value[0];
            if (columnOrder.dir === 'desc') { sort += '-'; }
          }

          var queryParams = {};

          if (vm.deadlineViolationsReasonsFilters) {
            if (vm.deadlineViolationsReasonsFilters.name) {
              queryParams['name~~*'] = '*' + vm.deadlineViolationsReasonsFilters.name + '*';
            }

            if (vm.deadlineViolationsReasonsFilters.description) {
              queryParams['description~~*'] = '*' + vm.deadlineViolationsReasonsFilters.description + '*';
            }

            if (vm.deadlineViolationsReasonsFilters.archived === '1') {
              queryParams['archived'] = false;
            } else if (vm.deadlineViolationsReasonsFilters.archived === '0') {
              queryParams['archived'] = true;
            }
          }

          var queryOptions = {
            offset: aoData[3].value,
            limit: aoData[4].value,
            include: '',
            sort: '-createdAt'
          };

          if (sort) { queryOptions.sort = sort; }
          deadlineViolationsReasonsApi.search(queryParams, queryOptions)
            .then(function (result) {
              vm.deadlineViolationReasons = result.items;
              vm.totalDeadlineViolationReasons = result.totalItems;
            })
            .finally(function () {
              fnCallback({
                'draw': aoData[0].value,
                'recordsTotal': vm.totalDeadlineViolationReasons,
                'recordsFiltered': vm.totalDeadlineViolationReasons,
                'data': vm.deadlineViolationReasons
              });
              $rootScope.loadingProgress = false;
            });
        }, 1000);

        config.createdRow = function (row, data) {
          if (data && data.archived) {
            $(row).addClass('disabled-row');
          }

          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });
      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        _addCallToActionButton();
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          _addCallToActionButton();
          _fixTableHeaders();
        });
      };
    }

    function openDialogDeadlineViolationsReasons($event, id) {
      DeadlineViolationsReasonsDialog.openDialog($event, id, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    }

    $scope.$on('deadline-violations-reasons:reload', function () {
      vm.reload();
    });

    function _initialize() {
      vm.reload = _.debounce(_reloadDatatable, 1000);
      vm.deadlineViolationsReasonsFilters = DeadlineViolationsReasonsFilters;
      vm.clearFilters = vm.deadlineViolationsReasonsFilters.clear;
      vm.filteringIsOn = vm.deadlineViolationsReasonsFilters.isOn;
      vm.toggleSidenav = toggleSidenav;

      _startDataTable();
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deadline-contracts')
    .controller('DeadlineContractsController', DeadlineContractsController);

  /** @ngInject */
  function DeadlineContractsController(
    $translate, $compile, $scope, $rootScope, _, dataTableOptions, account,
    DTColumnBuilder, deadlineContractsApi, DeadlineContractsFilters, $mdSidenav, DeadlineContractsDialog, $filter, LocalDateConvert
  ) {
    var vm = this;
    vm.account = account;
    vm.openDialogContract = openDialogContract;

    function _addCallToActionButton() {
      $('.call-to-action').remove();

      var ctaNewProductService = $compile('')(($scope));

      $('.dataTables_empty').append($(ctaNewProductService));
    }

    function _fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (_isColumnVisible(index)) { visibleColumnsCount++; }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function _isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function _reloadDatatable(resetPaging) {
      resetPaging = resetPaging ? resetPaging : true;
      vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
    }

    function _getDtColumns() {
      return [
        DTColumnBuilder.newColumn('id', 'id').notVisible(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-CONTRACTS.TABLE.NAME')).renderWith(function (data) {
          if (!data.name) {
            return '';
          }

          var enterpriseCustomerName = data.metadata && data.metadata.sammathnaur && data.metadata.sammathnaur.account && data.metadata.sammathnaur.account.name;
          if (enterpriseCustomerName) {
            return data.name + ' <em class="text-light-gray">(' + enterpriseCustomerName + ')</em>';
          }

          return data.name;
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-CONTRACTS.TABLE.RESPONSE_DEADLINE_RISK')).renderWith(function (data) {
          if (!data.responseDeadlineRisk) {
            return '';
          }
          return $filter('durationFormat')(data.responseDeadlineRisk);
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-CONTRACTS.TABLE.RESPONSE_DEADLINE')).renderWith(function (data) {
          if (!data.responseDeadline) {
            return '';
          }
          return $filter('durationFormat')(data.responseDeadline);
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-CONTRACTS.TABLE.SOLUTION_DEADLINE_RISK')).renderWith(function (data) {
          if (!data.solutionDeadlineRisk) {
            return '';
          }
          return $filter('durationFormat')(data.solutionDeadlineRisk);
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-CONTRACTS.TABLE.SOLUTION_DEADLINE')).renderWith(function (data) {
          if (!data.solutionDeadline) {
            return '';
          }
          return $filter('durationFormat')(data.solutionDeadline);
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-CONTRACTS.TABLE.CREATED_AT')).renderWith(function (data) {
          if (!data.createdAt) {
            return '';
          }
          return LocalDateConvert.formatDate(data.createdAt, 'date-time');
        }).notSortable(),
        DTColumnBuilder.newColumn(null, $translate.instant('DEADLINE-CONTRACTS.TABLE.ACTIONS')).renderWith(function (data) {
          var eventClick = 'ng-click="vm.openDialogContract($event,\'' + data.id + '\')"',
            templateHTML = '<md-button aria-label="more" class="md-icon-button"' + eventClick + '>' +
              '<img ng-src="assets/icons/icon-edit.svg" alt="Edit">' +
              '<md-tooltip md-direction="left">'+
              '<span translate="DEADLINE-CONTRACTS.TABLE.' +
              (data.locked ? 'VIEW' : 'ACTIONS') +
              '">View</span>' +
              '</md-tooltip>' +
              '</md-button>';
          return templateHTML;
        }).notSortable()
        .withOption('responsivePriority', 1)
      ];
    }

    function _startDataTable() {
      vm.dtInstance = {};
      vm.currentScroll = vm.currentScroll || 0;

      vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
        config.sAjaxDataProp = "data";
        config.processing = true;
        config.serverSide = true;
        config.searchDelay = 2000;
        config.paging = true;
        config.buttons = [];

        config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
          $rootScope.loadingProgress = true;

          var sort = '';
          if (aoData[2].value && aoData[2].value[0]) {
            var columnOrder = aoData[2].value[0];
            if (columnOrder.dir === 'desc') { sort += '-'; }
          }

          var queryParams = {};

          if (vm.deadlineContractsFilters) {
            if (vm.deadlineContractsFilters.name) {
              queryParams['name~~*'] = '*' + vm.deadlineContractsFilters.name + '*';
            }

            if (vm.deadlineContractsFilters.description) {
              queryParams['description~~*'] = '*' + vm.deadlineContractsFilters.description + '*';
            }

            if (vm.deadlineContractsFilters.archived === '0') {
              queryParams['archived'] = false;
            } else if (vm.deadlineContractsFilters.archived === '1') {
              queryParams['archived'] = true;
            }
          }

          var queryOptions = {
            offset: aoData[3].value,
            limit: aoData[4].value,
            include: '',
            sort: '-createdAt'
          };

          if (sort) { queryOptions.sort = sort; }
          deadlineContractsApi.search(queryParams, queryOptions)
            .then(function (result) {
              vm.productsServices = result.items;
              vm.totalProductsServices = result.totalItems;
            })
            .finally(function () {
              fnCallback({
                'draw': aoData[0].value,
                'recordsTotal': vm.totalProductsServices,
                'recordsFiltered': vm.totalProductsServices,
                'data': vm.productsServices
              });
              $rootScope.loadingProgress = false;
            });
        }, 1000);

        config.createdRow = function (row, data) {
          if (data && data.archived) {
            $(row).addClass('disabled-row');
          }

          $compile(angular.element(row).contents())($scope);
        };

        config.columnDefs = [];
        config.lengthMenu = [25, 50, 100, 200];
        config.pageLength = 25;
      });
      vm.dtColumns = _getDtColumns();

      vm.dtInstanceCallback = function (_dtInstance) {
        vm.dtInstance = _dtInstance;
        _addCallToActionButton();
        vm.dtInstance.DataTable.on('draw', function () {
          var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
          scrollContent.scrollTop = vm.currentScroll;
          vm.currentScroll = 0;
          _addCallToActionButton();
          _fixTableHeaders();
        });
      };
    }

    function openDialogContract($event, id) {
      DeadlineContractsDialog.openDialog($event, id, null, function (reload) {
        if (reload) {
          vm.reload();
        }
      });
    }

    $scope.$on('deadline-contracts:reload', function () {
      vm.reload();
    });

    function _initialize() {
      vm.reload = _.debounce(_reloadDatatable, 1000);
      vm.deadlineContractsFilters = DeadlineContractsFilters;
      vm.clearFilters = vm.deadlineContractsFilters.clear;
      vm.filteringIsOn = vm.deadlineContractsFilters.isOn;
      vm.toggleSidenav = toggleSidenav;

      _startDataTable();
    }

    _initialize();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.customers')
    .controller('CustomersController', CustomersController);

  /** @ngInject */
  function CustomersController($scope, $rootScope, CustomerDialog, msUtils, $timeout, $compile, $mdToast,
    $filter, DTColumnBuilder, CustomersFilters, customersApi, dataTableOptions, ControlPanelData,
    $mdSidenav, account, dateHandler, moment, authenticatedUser, OrderDialog, _, exportsApi,
    $localStorage, QueryStringParser, $location, $mdDialog, CustomersMap, $translate, FcModalService,
    CustomersImportManualDialog, CustomersImportAutomaticDialog, IntegrationsService,
    dataTableHelperService, leafletMarkersHelpers, $document, LocalDateConvert, usersApi
  ) {

    var vm = this;
    var mapCustomersLimit = 1800;

    vm.dtInstance = {};
    vm.currentScroll = vm.currentScroll || 0;
    vm.customersFilters = CustomersFilters;
    vm.clearFilters = CustomersFilters.clear;
    vm.filteringIsOn = CustomersFilters.isOn;
    vm.accountConfiguration = account.configuration;
    vm.authenticatedUser = authenticatedUser;
    vm.addPermission = false;
    vm.totalRows = 0;
    vm.map = null;
    vm.showMap = false;
    vm.toggleMapView = toggleMapView;
    vm.openCustomersImportManualDialog = openCustomersImportManualDialog;
    vm.openCustomersImportAutomaticDialog = openCustomersImportAutomaticDialog;
    vm.loadingMap = false;
    vm.integrations = IntegrationsService.getAll();
    vm.showIntegrationButton = showIntegrationButton;
    vm.openVideoTutorial = openVideoTutorial;
		vm.countryCode = account.address.countryCode;
    vm.hasEmptyCustomerMessage = false;

    function initialize() {
      if (authenticatedUser.profile.accountId !== 14003) {
        vm.addPermission = true;
        return;
      }

      var willBlockAddPermissionForProSecurity = function (user) {
        if (!user.groups) { return false; }
        if (!user.groups.length) { return false; }
        if (user.groups.length > 1) { return false; }
        if (!user.groups[0]) { return false; }

        return user.groups[0].id === 'f457de76-eddd-4557-a477-6916b9595b70';
      };

      usersApi.getWithGroups(authenticatedUser.profile.id).then(function (user) {
        var blockAddPermissionForProSecurity = willBlockAddPermissionForProSecurity(user);

        if (blockAddPermissionForProSecurity) {
          vm.addPermission = false;
          return;
        }

        vm.addPermission = true;
      }).catch(function (error) {
        vm.addPermission = true;
      });
    }

    $scope.$on('customers:filter-updated', function () {
      loadCustomers(true);
    });

    $scope.$on('$destroy', function () {
      leafletMarkersHelpers.resetMarkerGroups();
    });

    function showIntegrationButton(appName) {
      if (appName === 'Conta Azul') {
        return vm.integrations.contaAzul;
      }
      if (appName === 'Omie') {
        return vm.integrations.omie;
      }
      return false;
    }

    function openCustomersImportAutomaticDialog($event, appName) {
      CustomersImportAutomaticDialog.openConfirmDialog($event, appName);
    }

    function openCustomersImportManualDialog($event, appName) {
      if (appName === 'Conta Azul') {
        return CustomersImportManualDialog.initCustomersImportManualDialog($event, { customer: vm.customer, appName: appName, appId: 'conta-azul' });
      }

      return _openOmieManualImportDialog();
    }

    function _openOmieManualImportDialog() {
      FcModalService.open(null, {
        title: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.ACCOUNT'),
        content: $translate.instant('CUSTOMERS.INTEGRATIONS.IMPORTS.SELECT_THE_ACCOUNT_MANUAL'),
        hasOmieAccountSelector: true,
        rightContinueButton: true,
        paddingSmall: true,
        rightButtonText: $translate.instant('CUSTOMERS.INTEGRATIONS.CONTINUE'),
        leftButtonText: $translate.instant('MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL'),
        handleRightButton: function (account) {
          $mdDialog.show({
            controller: 'OmieCustomersManualImportDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/customers/dialogs/omie-manual-import/omie-manual-import-dialog.html',
            parent: angular.element($document.body),
            clickOutsideToClose: true,
            targetEvent: null,
            escapeToClose: false,
            multiple: true,
            locals: {
              appId: account.appId
            }
          }).then(function () {
            vm.reload();
          });
        }
      });
    }

    function toggleMapView() {
      vm.showMap = !vm.showMap;
      if (vm.showMap && vm.map === null) {
        vm.loadingMap = true;
        CustomersMap.build('customersMap', vm.totalRows, mapCustomersLimit)
        .then(function (map) {
            vm.map = map;
            vm.map.addMarkerAction('new-task', $translate.instant('CUSTOMERS.MAP.NEW_TASK_BUTTON'), 'icon-plus');
            $scope.$on('customers-map:new-task', function (event, ev, customer) {
              createTask(ev, customer);
            });
            if (vm.totalRows > mapCustomersLimit) {
              $mdDialog.show(
                $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title($translate.instant('CUSTOMERS.MAP.MAX_CUSTOMER_WARNING_TITLE'))
                  .ok('OK')
                  .htmlContent('<p>' + $translate.instant('CUSTOMERS.MAP.MAX_CUSTOMER_WARNING_MESSAGE') + '</p>' +
                    '<img src="./assets/images/others/customers-map-search-area-button-explained.png" class="customers-map-button" alt="' + $translate.instant('CUSTOMERS.MAP.MAX_CUSTOMER_WARNING_IMG_ALT') + '">')
              );
            }
            vm.loadingMap = false;
          })
          .catch(function (err) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title($translate.instant('CUSTOMERS.MAP.ERROR_WARNING_TITLE'))
                .ok($translate.instant('CUSTOMERS.MAP.OK'))
                .htmlContent('<p>' + $translate.instant('CUSTOMERS.MAP.ERROR_WARNING_MESSAGE') + '</p>')
            );
          });
      }
    }

    function removeUnnecessarySentences(textContent, unnecessarySentencesArray) {
      unnecessarySentencesArray.forEach(function (sentence) {
        if (textContent.indexOf(sentence) > -1) {
          textContent = textContent.replaceAll(sentence, '');
        }
      });

      return textContent;
    }

    vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {

      config.sAjaxDataProp = "data";
      config.processing = true;
      config.serverSide = true;
      config.searchDelay = 2000;
      config.paging = true;

      config.buttons = [{
        isExportButton: true,
        extend: 'print',
        className: 'hidden-button',
        filename: msUtils.shortGuidGenerator(),
        text: '.',
        autoPrint: true,
        exportOptions: {
          columns: ':visible'
        },
        customize: function (printWindow) {
          printWindow.document.getElementsByTagName("body")[0].style = 'overflow: visible !important;';
          printWindow.document.getElementsByTagName("html")[0].style = 'overflow: visible !important;';
          printWindow.document.getElementsByTagName("table")[0].style = 'font-size: 10px !important;';
          printWindow.document.body.querySelectorAll('td').forEach(function (td) {
            if (td && td.textContent) {
              var unnecessarySentences = ['Ativo', 'Arquivado'];

              td.textContent = removeUnnecessarySentences(td.textContent, unnecessarySentences);
            }
          });

          var tableHeads = printWindow.document.querySelectorAll('th');
          if (tableHeads.length > 0) {
            tableHeads[tableHeads.length - 1].remove();
          }
          var tableRows = printWindow.document.querySelectorAll('tr');
          for (var i = 0; i < tableRows.length; i++) {
            var tableCells = tableRows[i].getElementsByTagName("td");
            if (tableCells.length > 0) {
              tableCells[tableCells.length - 1].remove();
            }

            for (var j = 0; j < tableCells.length; j++) {
              if (tableCells[j]) {
                var avatarLetterSelector = 'avatar_letter#';
                var labelNameSelector = 'label_name#';
                var content = tableCells[j].textContent;

                if (content.includes(avatarLetterSelector)) {
                  content = content.substring(avatarLetterSelector.length + 1, content.length);
                }

                if (content.includes(labelNameSelector)) {
                  content = content.replace(/label_name#/g, ' ');
                }

                tableCells[j].innerHTML = content;
              }
            }
          }
        }
      }];

      config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
        $rootScope.loadingProgress = true;
        vm.queryParams = vm.customersFilters.toSearchOptions();
        var variables = dataTableHelperService.toGraphqlVariables({
          aoData: aoData,
          columns: vm.dtColumns,
          where: vm.queryParams.graphQL
        });
        customersApi.search(variables)
          .then(function (result) {
            fnCallback({
              draw: aoData[0].value,
              recordsTotal: result.totalCount,
              recordsFiltered: result.totalCount,
              data: result.items
            });
            $rootScope.loadingProgress = false;
          });
      }, 1000);

      config.createdRow = function (row) {
        $compile(angular.element(row).contents())($scope);
      };

      config.columnDefs = [{
        targets: 15,
        responsivePriority: 1,
        filterable: false,
        sortable: false
      }];
    });

    var columnId = DTColumnBuilder.newColumn('id', 'id').notVisible();

    var columnName = DTColumnBuilder.newColumn(null, $translate.instant('CUSTOMERS.TABLE.NAME'))
      .renderWith(function (data) {
        var templateVars = {
          className: 'md-green-600-bg',
          text: $translate.instant('CUSTOMERS.TABLE.STATUS.ACTIVE')
        };

        if (data.archived) {
          templateVars.className = 'md-red-500-bg';
          templateVars.text = $translate.instant('CUSTOMERS.TABLE.STATUS.ARCHIVED');
        }

        var templateColumnHtml = '';
        templateColumnHtml += '<div layout="column">';
        templateColumnHtml += '<div layout="row" layout-align="start center">';
        templateColumnHtml += '<div class="quantity-indicator ' + templateVars.className + '">';
        templateColumnHtml += '<md-tooltip>' + templateVars.text + '</md-tooltip>';
        templateColumnHtml += '</div>';
        templateColumnHtml += '<div class="avatar-wrapper">';

        if (data.avatarUrl) {
          templateColumnHtml += '<img md-menu-align-target="" class="avatar-customer" alt="' + data.name + '" ng-src="' + data.avatarUrl + '" src="./assets/images/image-placeholder.jpg">';
        } else {
          templateColumnHtml += '<div class="avatar-letter" ms-random-class="[\'grey-500-bg\']"><span style="display: none;">avatar_letter#</span>' + (data.name[0] ? data.name[0].toUpperCase() : data.name.toUpperCase().slice(0, 1)) + '</div>';
        }
        templateColumnHtml += '</div>';
        templateColumnHtml += '<div layout="column" layout-align="start start">';
        templateColumnHtml += '<div layout="row">';

        var corporateCustomerName = data.metadata && data.metadata.sammathnaur && data.metadata.sammathnaur.account && data.metadata.sammathnaur.account.name;
        if (corporateCustomerName) {
          templateColumnHtml += '<div>' + data.name + ' <em class="text-light-gray">(' + corporateCustomerName + ')</em>' + '</div>';
        } else {
          templateColumnHtml += '<div>' + data.name + '</div>';
        }

        templateColumnHtml += '</div>';
        if (data.labels && data.labels.length) {
          templateColumnHtml += '<div layout="row">';
          data.labels.forEach(function (label) {
            templateColumnHtml += '<i class="icon-label s12 icon ' + label.color + '-fg">';
            templateColumnHtml += '<md-tooltip><span style="display: none;">label_name#</span>' + label.name + '</md-tooltip>';
            templateColumnHtml += '</i>';
          });
          templateColumnHtml += '</div>';
        }
        templateColumnHtml += '</div>';
        templateColumnHtml += '</div>';
        templateColumnHtml += '</div>';
        return templateColumnHtml;
      });
    columnName.sortBy = 'name';

    var columnLabels = DTColumnBuilder.newColumn(null, $translate.instant('CUSTOMERS.TABLE.LABELS'))
      .renderWith(function (data) {
        var templateColumnHtml = '<div class="ml-10n" layout="row" layout-align="start center">';

        if (data.labels && data.labels.length > 0) {
          templateColumnHtml += '<div class="noExport ml-5">';
          data.labels.forEach(function (label) {
            templateColumnHtml += '<i class="icon-label s12 icon ' + label.color + '-fg">';
            templateColumnHtml += '<md-tooltip>';
            templateColumnHtml += label.name;
            templateColumnHtml += '</md-tooltip>';
            templateColumnHtml += '</i>';
            if (data.labels.length > 1 && data.labels[data.labels.length - 1].id !== label.id) {
              templateColumnHtml += '<p class="o-display">&nbsp;|&nbsp;<p>';
            }
          });
          templateColumnHtml += '</div>';
        }

        templateColumnHtml += '</div>';
        return templateColumnHtml;
      })
      .notSortable()
      .notVisible();

    var columnDocumentNumber = DTColumnBuilder.newColumn('documentNumber', $translate.instant('CUSTOMERS.TABLE.DOCUMENT_NUMBER'))
      .renderWith(function (data) {
        return vm.countryCode === 'BRA' ? $filter('brCpfCnpj')(data) : data;
      })
      .notSortable();

    var columnEmail = DTColumnBuilder.newColumn(null, $translate.instant('CUSTOMERS.TABLE.EMAIL'))
      .renderWith(function (data) {
        var emails = data && data.contacts && data.contacts.emails;
        if (!emails) {
          return null;
        }

        var email = _.findWhere(emails, {
          primary: true
        });

        if (!email) {
          return null;
        }

        return email.address;
      })
      .notSortable()
      .notVisible();

    var columnPhone = DTColumnBuilder.newColumn(null, $translate.instant('CUSTOMERS.TABLE.PHONE'))
      .renderWith(function (data) {
        var phones = data && data.contacts && data.contacts.phones;
        if (!phones) {
          return null;
        }

        var phone = _.findWhere(phones, {
          primary: true
        });

        if (!phone) {
          return null;
        }
        return $filter('brPhoneNumber')(phone.number);
      }).notSortable().notVisible();

    var columnAddress = DTColumnBuilder.newColumn(null, $translate.instant('CUSTOMERS.TABLE.ADDRESS'))
      .renderWith(function (data) {
        return data && data.address && data.address.formattedAddress;
      })
      .notSortable()
      .notVisible();

    var columnNotes = DTColumnBuilder.newColumn('notes', $translate.instant('CUSTOMERS.TABLE.OBSERVATIONS'))
      .notSortable()
      .notVisible();



    var columnFirstServiceAt = DTColumnBuilder.newColumn(null, $translate.instant('CUSTOMERS.TABLE.FIRST_VISIT_IN'))
      .renderWith(function (data) {
        if (data && data.statistics && data.statistics.service && data.statistics.service.firstAt) {
          return LocalDateConvert.formatDate(data.statistics.service.firstAt, 'date');
        }
        return null;
      });
    columnFirstServiceAt.sortBy = 'firstServiceAt';

    var columnLastServiceAt = DTColumnBuilder.newColumn(null, $translate.instant('CUSTOMERS.TABLE.LAST_VISIT_IN'))
      .renderWith(function (data) {
        if (data && data.statistics && data.statistics.service && data.statistics.service.lastAt) {
          return LocalDateConvert.formatDate(data.statistics.service.lastAt, 'date');
        }
        return null;
      });

    columnLastServiceAt.sortBy = 'lastServiceAt';



    var columnVisitCount = DTColumnBuilder.newColumn(null, $translate.instant('CUSTOMERS.TABLE.TOTAL_VISITS'))
      .renderWith(function (data) {
        if (data && data.statistics && data.statistics.service && data.statistics.service.total) {
          return data.statistics.service.total;
        }
        return 0;
      });
    columnVisitCount.sortBy = 'serviceCount';



    var columnAverageStars = DTColumnBuilder.newColumn('statistics.rating', $translate.instant('CUSTOMERS.TABLE.AVERAGE_RATING'))
      .renderWith(function (data) {
        if (data && data.averageStars) {
          var templateColumnHtml = '<div>';
          templateColumnHtml += '<p class="no-display">' + data.averageStars + '</p>';
          for (var index = 0; index < 5; index++) {
            if (index < data.averageStars) {
              templateColumnHtml += ' <i class="star-style icon-star"></i>';
            } else {
              templateColumnHtml += ' <i class="star-style icon-star-outline"></i>';
            }
          }
          templateColumnHtml += '</div>';

          return templateColumnHtml;
        }

        return '<span style="color:#939393;">' + $translate.instant('CUSTOMERS.TABLE.NOT_RATED') + '</span>';
      });
    columnAverageStars.sortBy = 'averageStars';

    var columnLastStar = DTColumnBuilder.newColumn('statistics.rating', $translate.instant('CUSTOMERS.TABLE.LAST_REVIEW'))
      .renderWith(function (data) {
        if (data && data.lastStar) {
          var templateColumnHtml = '<div>';
          templateColumnHtml += '<p class="no-display">' + data.lastStar + '</p>';
          for (var i = 0; i < 5; i++) {
            if (i < data.lastStar) {
              templateColumnHtml += ' <i class="star-style icon-star"></i>';
            } else {
              templateColumnHtml += ' <i class="star-style icon-star-outline"></i>';
            }
          }
          templateColumnHtml += '</div>';

          return templateColumnHtml;
        }
        return '<span style="color:#939393;">' + $translate.instant('CUSTOMERS.TABLE.NOT_RATED') + '</span>';
      })
      .notVisible();
    columnLastStar.sortBy = 'lastStar';

    var columnLastComment = DTColumnBuilder.newColumn('statistics.rating', $translate.instant('CUSTOMERS.TABLE.LAST_COMMENT'))
      .renderWith(function (data) {
        if (data && data.lastComment) {
          return '<p class="m-0">' + data.lastComment + '</p>';
        }
        return null;
      })
      .notSortable()
      .notVisible();

    var columnCreatedAt = DTColumnBuilder.newColumn('createdAt', $translate.instant('CUSTOMERS.TABLE.CREATED_ON'))
      .renderWith(function (data) {
        if (data) {
          return LocalDateConvert.formatDate(data, 'date');
        }
        return null;
      });
    columnCreatedAt.sortBy = 'createdAt';

    var columnActions = DTColumnBuilder.newColumn(null, $translate.instant('CUSTOMERS.TABLE.ACTIONS'))
      .renderWith(function (data) {
        var templateHtml = '';
        var isCorporateCustomer = data.metadata && data.metadata.sammathnaur;
        if (data.locked && !isCorporateCustomer) {
          templateHtml = '<md-button class="md-icon-button md-button-disabled-css" data-cy="edit-customer-icon" aria-label="' +
            $translate.instant('CUSTOMERS.TABLE.CUSTOMER_EDIT_NOT_ALLOWED') + '"> ' +
            '<img ng-src="assets/icons/icon-edit.svg">' +
            '<md-tooltip md-direction="left">' +
            $translate.instant('CUSTOMERS.TABLE.CUSTOMER_EDIT_NOT_ALLOWED') +
            '</md-tooltip> ' +
            '</md-button>';
        } else if (isCorporateCustomer) {
          templateHtml = '<md-button class="md-icon-button" ng-click="vm.editCustomer($event, ' + data.id + ')" data-cy="edit-customer-icon" aria-label="' +
            $translate.instant('CUSTOMERS.TABLE.VIEW') + '"> ' +
            '<img ng-src="assets/icons/icon-edit.svg">' +
            '<md-tooltip md-direction="left">' +
            $translate.instant('CUSTOMERS.TABLE.VIEW') +
            '</md-tooltip> ' +
            '</md-button>';
          } else {
            templateHtml = '<md-button class="md-icon-button" data-cy="edit-customer-icon" ng-click="vm.editCustomer($event, ' + data.id + ')" aria-label="' +
            $translate.instant('CUSTOMERS.TABLE.EDIT') + '"> ' +
            '<img ng-src="assets/icons/icon-edit.svg">' +
            '<md-tooltip md-direction="left">' +
            $translate.instant('CUSTOMERS.TABLE.EDIT') +
            '</md-tooltip> ' +
            '</md-button>';
        }


        return templateHtml;

      })
      .withClass('no-margin-important no-padding-important')
      .notSortable();

    vm.dtColumns = [
      columnId,
      columnName,
      columnLabels,
      columnDocumentNumber,
      columnEmail,
      columnPhone,
      columnAddress,
      columnNotes,
      columnFirstServiceAt,
      columnLastServiceAt,
      columnVisitCount,
      columnAverageStars,
      columnLastStar,
      columnLastComment,
      columnCreatedAt,
      columnActions
    ];

    vm.dtInstanceCallback = function (_dtInstance) {
      vm.dtInstance = _dtInstance;

      vm.dtInstance.DataTable.on('draw', function () {
        document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop = vm.currentScroll;
        vm.currentScroll = 0;
      });

      if (vm.dtInstance) {
        if ($localStorage.getObject('customerDatatableColumns-' + vm.authenticatedUser.profile.id).length !== vm.dtColumns.length) {
          dtLocalStorageRemove();
        } else if ($localStorage.getObject('customerDatatableColumns-' + vm.authenticatedUser.profile.id).length) {
          for (var index = 0; index < vm.dtColumns.length; index++) {
            vm.dtInstance.DataTable.column(index).visible($localStorage.getObject('customerDatatableColumns-' + vm.authenticatedUser.profile.id)[index]);
          }
        }
        loadCustomers();
        fixTableHeaders();
        loadPredefinedFilters();
      }
    };

    vm.dtLocalStorageStatus = dtLocalStorageStatus;
    function dtLocalStorageStatus() {
      if ($localStorage.getObject('customerDatatableColumns-' + vm.authenticatedUser.profile.id).length) {
        return true;
      }
      return false;
    }

    vm.dtLocalStorageRemove = dtLocalStorageRemove;
    function dtLocalStorageRemove() {
      $localStorage.remove('customerDatatableColumns-' + vm.authenticatedUser.profile.id);
      for (var index = 0; index < vm.dtColumns.length; index++) {
        vm.dtInstance.DataTable.column(index).visible((vm.dtColumns[index].bVisible === false) ? false : true);
      }
      fixTableHeaders();
    }

    function fixTableHeaders() {
      $('.dataTables_scrollHeadInner table thead th').each(function () {
        var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
        $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
      });

      var visibleColumnsCount = 1;
      for (var index = 0; index < vm.dtColumns.length; index++) {
        if (isColumnVisible(index)) { visibleColumnsCount++; }
      }
      $('.dataTables_empty').attr('colspan', visibleColumnsCount);
    }

    function loadPredefinedFilters() {
      var search = $location.search();
      if (!search.q) {
        return;
      }

      var result = QueryStringParser.parse(search.q, {
        keywords: [
          'etiqueta'
        ]
      });

      if (result && result['etiqueta']) {
        CustomersFilters.labels = [];
        CustomersFilters.labels.push(result['etiqueta']);
      }
    }

    vm.addCustomer = addCustomer;
    vm.editCustomer = editCustomer;
    vm.reload = reload;
    vm.toggleSidenav = toggleSidenav;
    vm.exportData = exportData;
    vm.isColumnVisible = isColumnVisible;
    vm.toggleColumnVisibility = toggleColumnVisibility;

    function isColumnVisible(index) {
      if (vm.dtInstance) {
        return vm.dtInstance.DataTable.column(index).visible();
      }
    }

    function toggleColumnVisibility(index) {
      var visibility = !vm.dtInstance.DataTable.column(index).visible();
      var visibleCount = 0;
      for (var i = 0; i < vm.dtColumns.length; i++) {
        if (vm.dtInstance.DataTable.column(i).visible()) {
          visibleCount++;
        }
      }
      if (visibility === false && visibleCount <= 3) {
        return;
      }
      vm.dtInstance.DataTable.column(index).visible(visibility);
      var columnsVisible = [];
      for (var index = 0; index < vm.dtColumns.length; index++) {
        columnsVisible.push(vm.dtInstance.DataTable.column(index).visible());
      }
      $localStorage.setObject('customerDatatableColumns-' + vm.authenticatedUser.profile.id, columnsVisible);
      fixTableHeaders();
    }

    function exportData(actionName, clickClassNameCallback) {
      vm.exportingClickClassNameCallback = clickClassNameCallback;

      if (actionName === 'print') {
        vm.exportingDataLoading = true;
        $rootScope.loadingProgress = true;
        $timeout(function () {
          vm.exportingDataLoading = false;
          $rootScope.loadingProgress = false;
          if (vm.exportingClickClassNameCallback) {
            document.getElementsByClassName(vm.exportingClickClassNameCallback)[0].click();
          }
        }, 2000);
        return null;
      }

      $mdDialog.show({
        controllerAs: 'dialog',
        clickOutsideToClose: true,
        bindToController: true,
        controller: function ($mdDialog) {
          this.enqueueDataExport = function () {
            exportsApi.exportFeature('customers', vm.queryParams, {
              timezone: moment.tz.guess()
            }).then(function (result) {
              $mdDialog.hide();
              $mdToast.show(
                $mdToast.simple()
                  .textContent($translate.instant('CUSTOMERS.TABLE.SPREADSHEET_SENT', {
                    email: authenticatedUser.profile.email
                  }))
                  .hideDelay(5000)
              );
              return result;
            }, function () {
              $mdDialog.hide();
              $mdToast.show(
                $mdToast.simple()
                  .textContent($translate.instant('CUSTOMERS.TABLE.SPREADSHEET_ERROR'))
                  .hideDelay(5000)
              );
            });
          };
          this.exportScreen = function () {
            $mdDialog.hide();
            document.getElementsByClassName(vm.exportingClickClassNameCallback)[0].click();
          };
          this.hide = function () {
            $mdDialog.hide();
          };
        },
        autoWrap: false,
        template: '<md-dialog>' +
          '<md-content class="task-dialog-data-export">' +
          '<h2><b translate="CUSTOMERS.EXPORT_MODAL.TITLE">Customers exports</b></h2>' +
          '<br/>' +
          '<span translate="CUSTOMERS.EXPORT_MODAL.WARNING_BODY" translate-value-email="' + authenticatedUser.profile.email + '">If you want all customers, will be send a file to mail: <b>' + authenticatedUser.profile.email + '</b>.</span>' +
          '<br/><br/><span translate="CUSTOMERS.EXPORT_MODAL.SLOW_PROCESS"> The process is slow, ok?</span>' +
          '<br/><br/>' +
          '<div align="center">' +
          '<md-button ng-click="dialog.enqueueDataExport();" translate="CUSTOMERS.EXPORT_MODAL.EXPORT_TO_EMAIL">Export and send by mail</md-button>' +
          '<md-button ng-click="dialog.hide();" translate="CUSTOMERS.EXPORT_MODAL.CANCEL">Cancel</md-button>' +
          '</div>' +
          '</md-content>' +
          '</md-dialog>'
      });
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function reload() {
      loadCustomers();
    }

    function createTask(ev, customer) {
      customersApi.getOne(customer.id)
        .then(function (result) {
          OrderDialog.createTask(ev, {
            customer: result
          }, function (reload) {
            if (reload) {
              ControlPanelData.loadData();
            }
          }, vm.addPermission);
        })
        .catch(function (err) {
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .title($translate.instant('CUSTOMERS.MAP.ERROR_WARNING_TITLE'))
              .ok($translate.instant('CUSTOMERS.MAP.OK'))
              .htmlContent('<p>' + $translate.instant('CUSTOMERS.MAP.ERROR_WARNING_MESSAGE') + '</p>')
          );
        });
    }

    function openVideoTutorial() {
      $mdDialog.show({
        controller: 'VideoTutorialController',
        controllerAs: 'vm',
        templateUrl: 'app/core/dialogs/video-tutorial/video-tutorial.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          videoUrl: 'https://www.youtube.com/embed/9r5P49siDRM?modestbranding=1&rel=0'
        }
      });
    }

    function addCustomer(ev) {
      CustomerDialog.createCustomer(ev, function (reload) {
        if (reload) {
          loadCustomers();
        }
      });
    }

    function editCustomer(ev, id) {
      CustomerDialog.editCustomer(ev, id, function (reload) {
        if (reload) {
          vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
          loadCustomers();
        }
      });
    }

    function loadCustomers(resetPaging) {
      if (!resetPaging) {
        resetPaging = false;
      }

      vm.dtInstance.DataTable.ajax.reload(function () {
        $('.call-to-action').remove();
        $('md-tooltip').hide();

        if (!vm.accountConfiguration.featureDisableAddCustomer && !vm.hasEmptyCustomerMessage) {
          var createNewLabel = $translate.instant('CUSTOMERS.MAP.CREATE_CUSTOMER');
          var clickHereLabel = $translate.instant('CUSTOMERS.MAP.CLICKING_HERE');

          var ctaNewCustomer = $compile('<fc-call-to-action-create-new message="' + createNewLabel + '" link="' + clickHereLabel + '" action="vm.addCustomer($event)"></fc-call-to-action-create-new>')(($scope));
          $('.dataTables_empty').append($(ctaNewCustomer));
          vm.hasEmptyCustomerMessage = true;
        }
      }, resetPaging);

      vm.hasEmptyCustomerMessage = false;
    }

    initialize();
  }
})();

(function () {
    'use strict';

    angular
        .module('app.control-panel')
        .controller('ControlPanelController', ControlPanelController);

    /** @ngInject */
    function ControlPanelController(OrderDialog, $scope, $mdToast, tasksApi, $timeout, RouteOptimizerDialog,
        $rootScope, $state, ControlPanelData, $mdSidenav, ControlPanelFilters, _,
        $q, Account, customersApi, employeesApi, servicesApi, $translate, TasksDistribution,
        authenticatedUser, $mdDialog, $document, StartUsingField, accountsApi, accountFeatureFlagsApiGraphQL
    ) {

        var vm = this;
        vm.pooling = null;
        vm.isLoading = true;

        vm.openRouteOptimizer = openRouteOptimizer;
        vm.openLegacyRouteOptimizer = openLegacyRouteOptimizer;
        vm.openAdvancedRouteOptimizer = openAdvancedRouteOptimizer;

        vm.selectedDate = ControlPanelData.getDate();
        vm.clearFilters = ControlPanelFilters.clear;
        vm.filteringIsOn = ControlPanelFilters.isOn;

        vm.createTask = createTask;
        vm.toggleSidenav = toggleSidenav;
        vm.selectedDateChanged = selectedDateChanged;
        vm.loadData = loadData;

        vm.accountConfiguration = Account.configuration;
        vm.accountPlan = Account.plan && Account.plan.name;
        vm.isPreventAccount = [44408, 51999].includes(Account.id);
        vm.openVideoTutorial = openVideoTutorial;
        vm.account = Account;
        vm.addPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_create');
        vm.editPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_edit');
        vm.openLaunchDialog = openLaunchDialog;

        canShowNewTodayTaskListPage().then(function (canShow) {
          vm.canShowNewTodayTaskList = canShow;

          if (!(vm.canShowNewTodayTaskList && $state.current.name == 'app.control-panel.list')) {
            $timeout(function () {
              _initialize();
            }, 2000);
          };

          startControlPanelListeners();
          vm.isLoading = false;
        });

        canShowNewTodayTaskButton().then(function (canShow) {
          vm.canShowNewTodayTaskButton = canShow;

          if (!(vm.canShowNewTodayTaskButton && $state.current.name == 'app.control-panel.list')) {
            $timeout(function () {
              _initialize();
            }, 2000);
          };

          startControlPanelListeners();
          vm.isLoading = false;
        });

        function openLaunchDialog() {
          document.dispatchEvent(new CustomEvent('showLaunchDialog', {
            detail: {
              title: $translate.instant('CONTROL_PANEL.VIEWS.LIST.LAUNCH_DIALOG.TITLE'),
              description: $translate.instant('CONTROL_PANEL.VIEWS.LIST.LAUNCH_DIALOG.DESCRIPTION'),
              image: {
                url: 'assets/images/today-task-list.png',
                position: 'bottom'
              },
              rightButton: {
                text: $translate.instant('CONTROL_PANEL.VIEWS.LIST.LAUNCH_DIALOG.RIGHT_BUTTON'),
                action: function () {
                  accountFeatureFlagsApiGraphQL.updateAccountFeatureFlag('today-task-list-beta-flag', true).then(function () {
                    window.location.reload();
                  });
                },
              },
              leftButton: {
                text: $translate.instant('CONTROL_PANEL.VIEWS.LIST.LAUNCH_DIALOG.LEFT_BUTTON'),
              },
            }
          }));
        }

        StartUsingField.start();

        function _initialize() {
          loadData();
          startControlPanelListeners();
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function canShowNewTodayTaskListPage() {
          return accountsApi.getCachedAccount().then(function (account) {
            return accountFeatureFlagsApiGraphQL.getCachedFlagByName('today-task-list-beta-flag').then(function (flag) {
              return flag ? flag.active : false;
            });
          });
        }

        function canShowNewTodayTaskButton() {
          return accountsApi.getCachedAccount().then(function (account) {
            return accountFeatureFlagsApiGraphQL.getCachedFlagByName('today-task-list-launch-beta-flag').then(function (flag) {
              return flag ? flag.active : false;
            });
          });
        }

        function createSampleTask(ev) {
          if (isDialogOpen) {
            return;
          }

          isDialogOpen = true;
          var requests = {
            service: servicesApi.search({ archived: false }, { limit: 1 }),
            customer: customersApi.search({ where: { archived: false }, take: 1 }),
            employee: employeesApi.search({ where: { archived: false }, take: 1 }),
          };

          $q.all(requests).then(function (result) {
            OrderDialog.createTask(ev, {
                scheduling: {
                  date: vm.selectedDate
                },
                service: result.service.items[0],
                customer: result.customer.items[0],
                employee: result.employee.items[0]
            }, function (reload) {
                if (reload) {
                  if ((vm.canShowNewTodayTaskList && $state.current.name == 'app.control-panel.list')) {
                    document.dispatchEvent(new CustomEvent('order-dialog:saved'));
                    $rootScope.loadingProgress = false;

                    return;
                  }

                  ControlPanelData.loadData();
                }
            }, vm.addPermission);

            document.addEventListener('order-dialog:close', function () {
              isDialogOpen = false;
            }, { once: true });
          });
        }

        var isDialogOpen = false;

        function createTask(ev) {
          if (isDialogOpen) {
            return;
          }

          isDialogOpen = true;
          if ($rootScope.customData && $rootScope.customData.startTourAfterAddTask) {
            createSampleTask(ev);
            return;
          }

          OrderDialog.createTask(ev, {
              scheduling: {
                date: ev.detail.selectedDate || vm.selectedDate
              }
          }, function (reload) {
              if (reload) {
                if ((vm.canShowNewTodayTaskList && $state.current.name == 'app.control-panel.list')) {
                  document.dispatchEvent(new CustomEvent('order-dialog:saved'));
                  $rootScope.loadingProgress = false;

                  return;
                }

                ControlPanelData.loadData();
              }
          }, vm.addPermission);

          document.addEventListener('order-dialog:close', function () {
            isDialogOpen = false;
          }, { once: true });
        }

        function editTask(ev, id) {
          if (isDialogOpen) {
            return;
          }

          isDialogOpen = true;

          OrderDialog.editTask(ev, { id: id }, function (reload) {
            if (reload) {
              if ((vm.canShowNewTodayTaskList && $state.current.name == 'app.control-panel.list')) {
                document.dispatchEvent(new CustomEvent('order-dialog:saved'));
                $rootScope.loadingProgress = false;

                return;
              }

              ControlPanelData.loadData();
            }
          });

          document.addEventListener('order-dialog:close', function () {
            isDialogOpen = false;
          }, { once: true });
        }

        function startControlPanelListeners() {
          document.addEventListener('create-order', createOrderListenerFn);

          document.addEventListener('edit-order', editOrderListenerFn);
        }

        function createOrderListenerFn(event) {
          createTask(event);
        };

        var editOrderListenerFn = function (data) {
          editTask(null, data.detail);
        };

        function loadData(forceReload) {
            ControlPanelData.loadData(forceReload);
        }

        function selectedDateChanged() {
            ControlPanelData.setDate(vm.selectedDate);
            ControlPanelData.loadData();
            $scope.$broadcast('update-gantt-header');
        }

        function openVideoTutorial() {
          $mdDialog.show({
            controller: 'VideoTutorialController',
            controllerAs: 'vm',
            templateUrl: 'app/core/dialogs/video-tutorial/video-tutorial.html',
            parent: angular.element($document.body),
            clickOutsideToClose: false,
            locals: {
              videoUrl: 'https://www.youtube.com/embed/r738JnfPYpk?modestbranding=1&rel=0'
            }
          });
        }

        $scope.$on('control-panel:data-updated', function (event, data) {
            vm.data = data;
            if (data) {
              vm.data.employees = _.filter(data.employees, function (employee) {
                return !employee.inactivatedAt;
              });
            }
            vm.data.tasks = vm.data.tasks || [];
            vm.data.notAchivedTasks = _.filter(vm.data.tasks, function (task) {
              return task.archived === false;
          });
            vm.selectedDate = ControlPanelData.getDate();
        });

        window.addEventListener('control-panel:reload-data', reloadData);

        $scope.$on('$destroy', function () {
          if ($state.current.name.indexOf('app.control-panel') == -1) {
            ControlPanelData.reset();
          }

          document.removeEventListener('create-order', createOrderListenerFn);
          window.removeEventListener('control-panel:reload-data', reloadData);
        });

        function openRouteOptimizer($event) {
          if (!vm.data.account.configuration.moduleRouteOptimizationEnabled && !vm.data.account.configuration.moduleAdvancedRouteOptimizationEnabled) {
            return _openModuleInfoElement('advanced_route_optimization', false);
          }

          if (vm.data.account.configuration.moduleAdvancedRouteOptimizationEnabled) {
            openAdvancedRouteOptimizer($event);
            return;
          }

          openLegacyRouteOptimizer($event);
        }

        function openAdvancedRouteOptimizer($event) {
          if ((!vm.data.account.configuration.moduleAdvancedRouteOptimizationEnabled) && vm.accountPlan !== 'test') {
            return _openModuleInfoElement('advanced_route_optimization', false);
          }

          var data = { selectedTaskIds: $rootScope.selectedTaskIds, selectedDate: vm.selectedDate };
          var event = new CustomEvent('openRouterOptimizer', { detail: data });

          document.dispatchEvent(event);
        }

        function openLegacyRouteOptimizer($event) {
          if ((!vm.data.account.configuration.moduleRouteOptimizationEnabled) && vm.accountPlan !== 'test') {
            return _openModuleInfoElement('advanced_route_optimization', false);
          }

          var employees = vm.data && vm.data.employees;

          RouteOptimizerDialog.startOptimizer($event, employees, function (optimizationResult) {
            if (optimizationResult) {
              optimizationResult.taskPatchPayload.forEach(function (task) {
                task.scheduling = {
                  type: 'scheduled-date',
                  time: null
                };
              });

              var currentPayload = optimizationResult.taskPatchPayload;
              if (vm.isPreventAccount) {
                var tasks = angular.copy(optimizationResult.taskPatchPayload);
                var initialDate = optimizationResult.initialDate;
                var selectedWeekDays = optimizationResult.selectedWeekDays;
                var splitByAmountPerDay = TasksDistribution.splitByAmountPerDay(tasks, optimizationResult.tasksPerDay);
                var updatedTasks = TasksDistribution.updateTasks(splitByAmountPerDay, selectedWeekDays, initialDate);
                var formattedTasks = TasksDistribution.extractTasks(updatedTasks);
                currentPayload = formattedTasks;
              }

              tasksApi.patchTasks(currentPayload).then(function () {
                ControlPanelData.loadData();
                $mdToast.show(
                  $mdToast.simple()
                    .textContent($translate.instant('CONTROL_PANEL.DIALOGS.ROUTERIZATION.SUCCESS_MESSAGE'))
                    .hideDelay(3000)
                );
              });
            }
          });
        }

        function _openModuleInfoElement(module, isEnabled) {
          var event = new CustomEvent('openModuleInfo',  { detail: { type: module, hired: isEnabled } });

          document.dispatchEvent(event);
        }

        function reloadData() {
          ControlPanelData.loadData(true);
        }

        vm.clearFilters();
    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.core')
    .directive('calendarTooltipMenu', calendarTooltipMenu);

  /** @ngInject */
  function calendarTooltipMenu(calendarTooltip, $compile, $timeout)
  {
    return {
      restrict : 'A',
      scope    : {
        task: '=calendarTooltipMenu'
      },
      link: function (scope, el) {
        $timeout(function () {
          var tooltipTemplate = angular.element(calendarTooltip.tooltipTemplate(scope.task) );

          el.append(tooltipTemplate);

          $compile(tooltipTemplate)(scope);
        }, 250);
      }
    };
  }
})();

/* eslint-disable no-unreachable */
(function () {
  'use strict';

  angular
    .module('app.calendar')
    .controller('CalendarController', CalendarController);

  /** @ngInject */
  function CalendarController($scope, $rootScope, $timeout, $compile, OrderDialog, moment,
    $mdDialog, $mdSidenav, $, $mdToast, _, tasksApi, TasksStatusHelper, MessageDialog,
    calendarTooltip, CalendarTasksFilter, Account, $translate, accountFeatureFlagsApiGraphQL,
    authenticatedUser, $interval, $localStorage, LocalDateConvert, translateService, FeatureFlags
  ) {

    var vm = this;
    vm.canShowNewCalendar = canShowNewCalendarPage(FeatureFlags);
    vm.canShowNewCalendarButton = canShowNewCalendarButton(FeatureFlags);
    vm.openLaunchDialog = openLaunchDialog;
    vm.account = Account;
    vm.addPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_create');
    vm.editPermission = authenticatedUser.hasPermission(vm.account, 'tasks_allow_edit');
    vm.isLoading = false;
    vm.accountConfiguration = Account.configuration;
    vm.dateFormat = LocalDateConvert.pickAltFormat('date-time');
    vm.calendarTasksFilter = CalendarTasksFilter;
    vm.next = next;
    vm.prev = prev;
    vm.loadEvents = _.debounce(loadEvents, 250);
    vm.cleanQueryParams = cleanQueryParams;
    vm.hideFeedbackForm = _getHideFeedBackForm();
    vm.closeFeedback = closeFeedback;
    vm.createTask = createTask;
    vm.reload = reload;
    vm.openOrderDialog = openOrderDialog;

    vm.loadMoreTasks = loadMoreTasks;
    vm.moreTasks = [];
    vm.moreTasksSkip = 0;
    vm.moreTasksDate = null;
    vm.moreTaskTotalCount = 0;
    vm.loadingMore = false;

    vm.timeFormat = translateService.getLanguage() !== 'en' ? '(H:mm)' : '(hh:mm a)';

    vm.toggleSidenav = toggleSidenav;
    CalendarTasksFilter.clear();
    startControlPanelListeners();

    if (vm.canShowNewCalendar) return;

    $scope.tasks = [];
    $scope.eventSources = [];
    $scope.calendarUiConfig = {
      calendar: {
        lang: $translate.use(),
        height: 800,
        editable: true,
        eventLimit: true,
        dragScroll: false,
        header: '',
        handleWindowResize: false,
        aspectRatio: 1,
        allDayText: $translate.instant('CALENDAR.ALL_DAY'),
        monthNames: [
          $translate.instant('CALENDAR.MONTHS.JANUARY'),
          $translate.instant('CALENDAR.MONTHS.FEBRUARY'),
          $translate.instant('CALENDAR.MONTHS.MARCH'),
          $translate.instant('CALENDAR.MONTHS.APRIL'),
          $translate.instant('CALENDAR.MONTHS.MAY'),
          $translate.instant('CALENDAR.MONTHS.JUNE'),
          $translate.instant('CALENDAR.MONTHS.JULY'),
          $translate.instant('CALENDAR.MONTHS.AUGUST'),
          $translate.instant('CALENDAR.MONTHS.SEPTEMBER'),
          $translate.instant('CALENDAR.MONTHS.OCTOBER'),
          $translate.instant('CALENDAR.MONTHS.NOVEMBER'),
          $translate.instant('CALENDAR.MONTHS.DECEMBER')
        ],
        monthNamesShort: [
          $translate.instant('CALENDAR.SHORT_MONTHS.JANUARY'),
          $translate.instant('CALENDAR.SHORT_MONTHS.FEBRUARY'),
          $translate.instant('CALENDAR.SHORT_MONTHS.MARCH'),
          $translate.instant('CALENDAR.SHORT_MONTHS.APRIL'),
          $translate.instant('CALENDAR.SHORT_MONTHS.MAY'),
          $translate.instant('CALENDAR.SHORT_MONTHS.JUNE'),
          $translate.instant('CALENDAR.SHORT_MONTHS.JULY'),
          $translate.instant('CALENDAR.SHORT_MONTHS.AUGUST'),
          $translate.instant('CALENDAR.SHORT_MONTHS.SEPTEMBER'),
          $translate.instant('CALENDAR.SHORT_MONTHS.OCTOBER'),
          $translate.instant('CALENDAR.SHORT_MONTHS.NOVEMBER'),
          $translate.instant('CALENDAR.SHORT_MONTHS.DECEMBER')
        ],
        dayNames: [
          $translate.instant('CALENDAR.WEEK_DAY.SUNDAY'),
          $translate.instant('CALENDAR.WEEK_DAY.MONDAY'),
          $translate.instant('CALENDAR.WEEK_DAY.TUESDAY'),
          $translate.instant('CALENDAR.WEEK_DAY.WEDNESDAY'),
          $translate.instant('CALENDAR.WEEK_DAY.THURSDAY'),
          $translate.instant('CALENDAR.WEEK_DAY.FRIDAY'),
          $translate.instant('CALENDAR.WEEK_DAY.SATURDAY'),
        ],
        dayNamesShort: [
          $translate.instant('CALENDAR.SHORT_WEEK_DAY.SUNDAY'),
          $translate.instant('CALENDAR.SHORT_WEEK_DAY.MONDAY'),
          $translate.instant('CALENDAR.SHORT_WEEK_DAY.TUESDAY'),
          $translate.instant('CALENDAR.SHORT_WEEK_DAY.WEDNESDAY'),
          $translate.instant('CALENDAR.SHORT_WEEK_DAY.THURSDAY'),
          $translate.instant('CALENDAR.SHORT_WEEK_DAY.FRIDAY'),
          $translate.instant('CALENDAR.SHORT_WEEK_DAY.SATURDAY'),
        ],
        timeFormat: vm.timeFormat,
        viewRender: function (view) {
          vm.calendarView = view;
          vm.calendar = vm.calendarView.calendar;
          vm.currentMonthShort = vm.calendar.getDate().format('MMM');
          vm.loadEvents();
        },
        columnFormat: {
          month: 'ddd',
          week: 'ddd D',
          day: 'ddd M'
        },
        eventClick: eventDetail,
        eventDrop: eventChangeDate,
        eventRender: function (event, element) {
          if (event.className && event.className.includes('more-tasks-indicator')) {
            element.find('.fc-time').remove();
          }

          if (vm.accountConfiguration.featureCalendarAvatarDisabled) {
            return;
          }

          var compiled = false;
          if (event.employeeName) {
            element.prepend('<img data-cy="task" src="' + event.employeeAvatar + '" class="avatar-icon" alt="' + event.employeeName + '"/>');
          }

          createTooltip(event, element, compiled);
        },
        eventDurationEditable: false,
        eventResourceEditable: false,
        eventOrder: 'start'
      }
    };

    function createTooltip(event, element) {
      var showPromise;
      var compiled = false;

      function onMouseEnter() {
        showPromise = $timeout(function () {
          if (compiled) return;
          compiled = true;

          var template = calendarTooltip.tooltipTemplate(event);
          element.append(template);
          $compile(element.contents())($scope);

          element.triggerHandler('mouseenter');
        }, 200);
      }

      function onMouseLeave() {
        if (showPromise) {
          $timeout.cancel(showPromise);
          showPromise = null;
        }
      }

      element.on('mouseenter', onMouseEnter);
      element.on('mouseleave', onMouseLeave);
    }

    function createOrderListenerFn() {
      createTask(null);
    };

    function editOrderListenerFn(data) {
      editTask(null, data.detail);
    };

    function startControlPanelListeners() {
      document.addEventListener('create-order', createOrderListenerFn);
      document.addEventListener('edit-order', editOrderListenerFn);
    }

    $scope.$watch('vm.calendar.view.type', function (newValue, oldValue) {
      $rootScope.loadingProgress = true;
      var middlePage = $('#calendar').innerHeight() / 2.4;
      if (newValue === 'agendaWeek' || newValue === 'agendaDay') {
        $('#content').scrollTop(middlePage);
      }
    });


    $scope.$on("$destroy", function () {
      $interval.cancel(vm.verifyPdfReportStatusInterval);
      document.removeEventListener('create-order', createOrderListenerFn);
      $rootScope.loadingProgress = false;
    });

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function reload() {
      vm.loadEvents();
    }

    function loadEvents() {
      $timeout(function () {
        $rootScope.loadingProgress = true;
        $scope.tasks = [];

        var queryParams = getQueryParams(vm.calendar.view.type);

        if (CalendarTasksFilter.customersName) {
          queryParams['customerNameContains'] = CalendarTasksFilter.customersName;
        }

        if (CalendarTasksFilter.activitiesIdentifier) {
          queryParams['identifierContains'] = CalendarTasksFilter.activitiesIdentifier;
        }

        loadTasks(queryParams);
      }, 0);
    }

    function getQueryParams(viewType) {
      var start = vm.calendarView.calendar.getView('calendar').start;
      var end = vm.calendarView.calendar.getView('calendar').end;

      var startedAt = start.format('YYYY-MM-DD');
      var completedAt = end.format('YYYY-MM-DD');

      if (viewType === 'agendaDay') {
        completedAt = startedAt;
      }

      var queryParams = {
        scheduledDateOrStartedAtBetween: {
          startedAtGte: moment(startedAt).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
          startedAtLte: moment(completedAt).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
          scheduledDateGte: startedAt,
          scheduledDateLte: completedAt,
        },
        employeeIds: CalendarTasksFilter.employees,
        orderLabelIds: CalendarTasksFilter.labels,
        statusIn: CalendarTasksFilter.status,
        serviceIds: CalendarTasksFilter.services.map(function (e) {
          return e.id;
        }),
        archived: false,
      };

      return queryParams;
    }

    function cleanQueryParams(queryParams) {
      for (var key in queryParams) {
        if (!queryParams[key] || queryParams[key].length < 1) {
          delete queryParams[key];
        }
      }
      return queryParams;
    }

    function _getHideFeedBackForm() {
      return $localStorage.get("hideCalendarFeedbackForm");
    }

    function closeFeedback() {
      vm.hideFeedbackForm = true;
      $localStorage.set("hideCalendarFeedbackForm", 'true');
    }

    function next() {
      $rootScope.loadingProgress = true;
      vm.calendarView.calendar.next();
      vm.loadEvents();
    }

    function prev() {
      $rootScope.loadingProgress = true;
      vm.calendarView.calendar.prev();
      vm.loadEvents();
    }

    function eventChangeDate(event, delta) {
      if (event.status.name === 'scheduled') {

        if (delta._days !== 0) {

          $timeout(function () {

            $rootScope.loadingProgress = true;

            tasksApi.get(event.id).then(function (task) {

              task.scheduling.date = event.start.format('YYYY-MM-DD');

              if (!task.employee) {
                task.employee = { id: null };
              }

              tasksApi.save(task).then(function () {

                $mdToast.show(
                  $mdToast.simple()
                    .textContent($translate.instant('CALENDAR.TOAST.TASK_DATE_CHANGED', { eventTitle: event.title }))
                    .hideDelay(3000)
                );

                $rootScope.loadingProgress = false;
              });
            });
          }, 0);
        } else {
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .title($translate.instant('CALENDAR.ALERTS.TASK_CHANGE_TIME_FAILED.TITLE'))
              .htmlContent($translate.instant('CALENDAR.ALERTS.TASK_CHANGE_TIME_FAILED.CONTENT'))
              .ok($translate.instant('CALENDAR.ALERTS.TASK_CHANGE_TIME_FAILED.OK'))
          );

          vm.loadEvents();
        }
      } else {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title($translate.instant('CALENDAR.ALERTS.ONLY_SCHEDULED_TASKS.TITLE'))
            .htmlContent($translate.instant('CALENDAR.ALERTS.ONLY_SCHEDULED_TASKS.CONTENT'))
            .ok($translate.instant('CALENDAR.ALERTS.ONLY_SCHEDULED_TASKS.OK'))
        );

        vm.loadEvents();
      }
    }

    function editTask(ev, id) {
      OrderDialog.editTask(ev, { id: id });
    }

    function eventDetail(event, ev) {
      var isMoreTasksIndicator = event && event.className && event.className.includes('more-tasks-indicator');
      if (isMoreTasksIndicator) {
        openMoreTasksMenu(event, ev);

        return;
      }

      openOrderDialog(event, ev);
    }

    function openOrderDialog(event, ev) {
      OrderDialog.editTask(ev, { id: event.orderId }, function (reload) {
        if (reload) {
          vm.loadEvents();
        }
        $('.md-scroll-mask').remove();
      });
    }

    function createTask(ev) {

      OrderDialog.createTask(ev, null, function (reload) {
        if (reload) {
          vm.loadEvents();
        }
        $('.md-scroll-mask').remove();
      }, vm.addPermission);
    }


    $scope.$on('calendar-tasks:filter-updated', function () {
      vm.loadEvents();
    });

    $scope.$on('tasks:reload', function () {
      vm.reload();
    });

    function loadTasks(queryParams) {
      hasCalendarOtimizationBetaFlag().then(function (hasFlag) {
        var params = cleanQueryParams(queryParams);
        params.archived = false;

        var isMonthView = vm.calendarView.calendar.getView('calendar').type === 'month';
        if (hasFlag && isMonthView) {
          return loadTasksV2(params);
        }

        loadTasksV1(params);
      });
    }

    function hasCalendarOtimizationBetaFlag() {
      return accountFeatureFlagsApiGraphQL.getCachedFlagByName('calendar-otimization-beta-flag').then(function (flag) {
        return flag ? flag.active : false;
      });
    }

    function loadTasksV1(queryParams) {
      getTasks(queryParams)
        .then(function (result) {
          $scope.tasks = [];
          var tasks = [];
          for (var i = 0; i < result.length; i++) {
            tasks = tasks.concat(result[i]);
          }
          tasks = tasks.filter(function (obj, index, self) {
            return index === self.findIndex(function (t) {
              return t.id === obj.id;
            });
          });
          tasks.forEach(function (task) {
            var task = processTask(task);
            $scope.tasks.push(task);
          });

          deferLoadTasks();
        })
        .catch(function (err) {
          console.error(err);
          $rootScope.loadingProgress = false;
        });
    }

    function loadTasksV2(queryParams) {
      getTasksV2(queryParams)
        .then(function (result) {
          $scope.tasks = [];

          result.forEach(function (dayTasks) {
            var tasks = dayTasks.tasks;
            var totalCount = dayTasks.tasksCount;
            var displayed = tasks && tasks.length;

            tasks.forEach(function (task) {
              var task = processTask(task);
              $scope.tasks.push(task);
            });

            if (totalCount > displayed) {
              insertDayMoreTasksItem(dayTasks, totalCount, displayed);
            }
          });

          deferLoadTasks();
        })
        .catch(function (err) {
          console.error(err);
          $rootScope.loadingProgress = false;
        });
    }

    function insertDayMoreTasksItem(dayTasks, totalCount, displayed) {
      var endOfDay = moment(dayTasks.date).endOf('day');

      $scope.tasks.push({
        id: 'more-' + dayTasks.date,
        title: '+' + (totalCount - displayed) + ' ver mais',
        start: endOfDay,
        allDay: false,
        className: 'more-tasks-indicator',
        _dayTasks: dayTasks,
        _totalCount: totalCount,
        _displayed: displayed
      });
    }

    function getTasks(where) {
      return tasksApi
        .searchTasksForCalendar({
          where: where,
          take: 1,
          skip: 0,
        })
        .then(function (res) {
          var totalCount = res.totalCount;
          var pageSize = 500;
          var pageCount = Math.ceil(totalCount / pageSize);
          var calls = [];

          for (var i = 0; i < pageCount; i++) {
            calls.push(
              tasksApi.searchTasksForCalendar({
                where: where,
                take: pageSize,
                skip: i * pageSize,
              })
            );
          }

          return Promise.all(calls).then(function (results) {
            var all = [];
            for (var j = 0; j < results.length; j++) {
              all = all.concat(results[j].items);
            }
            return all;
          });
        });
    }

    function getTasksV2(where) {
      var start = vm.calendarView.calendar.getView('calendar').start;
      var end = vm.calendarView.calendar.getView('calendar').end;

      return tasksApi
        .searchTasksForCalendarV2({
          dateRange: {
            startDate: start.format('YYYY-MM-DD'),
            endDate: end.format('YYYY-MM-DD'),
            limitPerDay: 2,
          },
          where: where,
          orderBy: 'scheduledDateTimeStartedCompletedAt_asc',
        })
        .then(function (res) {
          return res.daysTasks;
        });
    }

    function processTask(task) {
      var taskStatus = TasksStatusHelper.getByName(task.status);
      var event = {
        id: task.id,
        orderIdentifier: task.order.identifier,
        orderId: task.order.id,
        title: task.order.customer.name,
        color: taskStatus.color,
        status: taskStatus,
        rating: task.rating,
      };

      if (task.order && task.order.labels) {
        event.labels = task.order.labels;
      }

      if (task.startedAt) {
        event.start = moment(task.startedAt);
        event.startTime = LocalDateConvert.formatDate(event.start, 'time');
      } else if (task.scheduling && task.scheduling.time) {
        event.start = moment(task.scheduling.date + 'T' + task.scheduling.time);
        event.startTime = LocalDateConvert.formatDate(event.start, 'time');
      } else {
        event.start = moment(task.scheduling.date);
      }

      if (task.completedAt) {
        event.end = moment(task.completedAt);
        event.endTime = LocalDateConvert.formatDate(event.end, 'time');
      } else {
        event.end = moment(event.start).add(task.duration, 'minutes');
        event.endTime = LocalDateConvert.formatDate(event.end, 'time');
      }

      if (task.employee) {
        event.employeeName = task.employee.name;
        event.employeeAvatar = (task.employee.avatarUrl ? task.employee.avatarUrl: './assets/images/avatars/profile.jpg');
      }

      event.serviceName = task.order.service.description;

      if (task.order && task.order.location) {
        event.locationName = task.order.location.name;
      }

      return event;
    }

    function deferLoadTasks() {
      _.defer(function () {
        $scope.$apply(function () {
          $rootScope.loadingProgress = false;
          $scope.eventSources.splice(0, 1);
          $scope.eventSources.push($scope.tasks);
        });
      });
    }

    function openMoreTasksMenu(event, ev) {
      vm.moreTasksDate = event._dayTasks.date;
      vm.moreTasks = [];
      vm.moreTasksSkip = 0;
      vm.moreTaskTotalCount = event._totalCount;
      vm.loadMoreTasks();

      var btn = angular.element(document.getElementById('calendarMoreMenuBtn'));
      var menuEl   = angular.element(document.getElementById('calendarMoreMenu'));
      var menuCtrl = menuEl.controller('mdMenu');

      btn.css({
        top:  ev.clientY + 'px',
        left: ev.clientX + 'px',
        display: 'block'
      });

      menuCtrl.open(ev);

      $timeout(function () {
        var container = document.querySelector('.md-open-menu-container');
        if (container) {
          container.style.top  = ev.clientY + 'px';
          container.style.left = ev.clientX + 'px';
        }
      });

      var moreTasksContainer = document.querySelector('.more-tasks-menu');
      moreTasksContainer.addEventListener('scroll', function () {
        var scrollTop = moreTasksContainer.scrollTop;
        var scrollHeight = moreTasksContainer.scrollHeight;
        var clientHeight = moreTasksContainer.clientHeight;

        var canScroll = scrollTop + clientHeight >= scrollHeight;

        if (canScroll) {
          loadMoreTasks();
        }
      });
    }

    function loadMoreTasks() {
      var take = 50;

      var hasMoreTasks = vm.moreTasksSkip * take < vm.moreTaskTotalCount;
      if (vm.loadingMore || !hasMoreTasks) {
        return;
      }

      vm.loadingMore = true;

      var where = {
        scheduledDateOrStartedAtBetween: {
          scheduledDateGte: vm.moreTasksDate,
          scheduledDateLte: vm.moreTasksDate,
          startedAtGte: vm.moreTasksDate,
          startedAtLte: vm.moreTasksDate,
        },
        archived: false,
      };


      tasksApi.searchTasksForCalendar({
        where: where,
        take: take,
        skip: vm.moreTasksSkip * take,
        orderBy: 'scheduledDateTimeStartedCompletedAt_asc'
      })
        .then(function (res) {
          var totalCount = res.totalCount;
          var items = res.items || res;
          var processedItems = items.map(function (task) {
            return processTask(task);
          });

          vm.moreTasks = vm.moreTasks.concat(processedItems);
          vm.moreTasksSkip++;
          vm.moreTaskTotalCount = totalCount;
        })
        .finally(function () {
          vm.loadingMore = false;
        });
    }

    function canShowNewCalendarPage(FeatureFlags) {
      var calendarPageFeatureFlag = FeatureFlags.find(function (flag) {
        return flag.name === 'calendar-page-beta-flag';
      });
      return calendarPageFeatureFlag && calendarPageFeatureFlag.active;
    }

    function canShowNewCalendarButton(FeatureFlags) {
      var calendarPageLaunchFeatureFlag = FeatureFlags.find(function (flag) {
        return flag.name === 'calendar-page-launch-beta-flag';
      });
      return calendarPageLaunchFeatureFlag && calendarPageLaunchFeatureFlag.active;
    }

    function openLaunchDialog() {
      document.dispatchEvent(new CustomEvent('showLaunchDialog', {
        detail: {
          title: $translate.instant('CALENDAR.LAUNCH_DIALOG.TITLE'),
          size: 'small',
          description: $translate.instant('CALENDAR.LAUNCH_DIALOG.DESCRIPTION'),
          image: {
            url: 'https://app.fieldcontrol.com.br/assets/icons/rocket-color.svg',
            position: 'top'
          },
          rightButton: {
            text: $translate.instant('CALENDAR.LAUNCH_DIALOG.RIGHT_BUTTON'),
            action: function () {
              accountFeatureFlagsApiGraphQL.updateAccountFeatureFlag('calendar-page-beta-flag', true).then(function () {
                window.location.reload();
              });
            },
          },
          leftButton: {
            text: $translate.instant('CALENDAR.LAUNCH_DIALOG.LEFT_BUTTON'),
          },
        }
      }));
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.bootstrap')
        .controller('BootstrapController', BootstrapController);

    /** @ngInject */
    function BootstrapController($rootScope, $state, services, account, employees, customers, $mdToast, timeZone, $scope, msUtils,
                                 $q, $timeout, geoCoder, cepDbApi, focus, $interval, HowRegisterEmployeeDialog, _, accountsApi,
                                 servicesApi, employeesApi, customersApi, autocompleteAddressService, $translate) {

        var employeesInterval;
        var refreshApiKeyInterval;
        $rootScope.$broadcast('toolbar:hide-toolbar-options');

        var vm = this;
        vm.cepDb = cepDb;
        vm.geoCoderAddress = _.debounce(geoCoderAddress, 500);
        vm.openVideoHowToRegisterEmployee = openVideoHowToRegisterEmployee;
        vm.nextStep = nextStep;
        vm.startUsingFieldControl = startUsingFieldControl;
        vm.employeesCount = employees.items.length;

        vm.timezones = timeZone.items;
        vm.countries = [];
        vm.countrySearchTerm = '';
        vm.formErr = {};
        vm.clearCountrySearchTerm = clearCountrySearchTerm;
        vm.addressService = autocompleteAddressService;
        vm.clearSelectedAccountAddress = clearSelectedAccountAddress;
        vm.handleTimezoneCountryFlagsAndAddress = handleTimezoneCountryFlagsAndAddress;
        vm.addressChanged = addressChanged;

        _initialize();

        function _initialize() {
            vm.form.account = account;
            vm.form.account.contact = {
                name: account.contact.name,
                phone: ('' + account.contact.phone).replace(/[^0-9]/g, ''),
                email: account.contact.email
            };
            vm.form.account.address = vm.form.account.address || {};
            vm.form.account.address.coords = vm.form.account.address.coords || {};

            if (vm.form.account.address) {
                vm.hasAccountAddress = true;
            }

            if (vm.form.account.address.countryCode === 'BRA') {
                vm.isSelectedCountryBrasil = true;
            }
            vm.addressService.setModel(vm.form.account.address);

            if (angular.isDefined(refreshApiKeyInterval)) {
                $interval.cancel(refreshApiKeyInterval);
                refreshApiKeyInterval = undefined;
            }

            if (angular.isDefined(employeesInterval)) {
                $interval.cancel(employeesInterval);
                employeesInterval = undefined;
            }

            focus('zipCode');

            var md = new MobileDetect(window.navigator.userAgent);
            if (md.phone()) {
                $state.go('app.errors-desktop-required');
            }

            if (!vm.timezones[0].name.includes('GMT')) {
                vm.timezones.forEach(function (tz) {
                    tz.gmt = moment.tz(tz.id)._offset / 60;
                    tz.name = tz.name + ' (GMT' + tz.gmt + ')';
                });
            }

            if (!vm.countries.length) {
                vm.timezones.forEach(function (tz) {
                    vm.countries.push({ code: tz.countryCode, name: tz.countryName });
                });
                vm.countries = _.uniq(vm.countries, function (country) {
                    return country.code;
                });

                if (vm.form.account.address.countryCode) {
                    vm.countrySearchTerm = _.filter(vm.countries, function (country) {
                        return vm.form.account.address.countryCode === country.code;
                    });
                }
            }

            _fixPhoneNumber();
            _updateTimezoneFlexValue();
        }

        function _fixPhoneNumber() {
            var phone = vm.form.account.contact.phone,
                extra = phone.length - 11;

            if (extra) {
                vm.form.account.contact.phone = phone.substring(extra);
            }
        }

        function clearCountrySearchTerm() {
            vm.countrySearchTerm = '';
        }

        function clearSelectedAccountAddress() {
            vm.hasAccountAddress = false;
            vm.selectedAccountAddress = null;
            vm.selectedAccountAddressText = '';

            vm.form.account.address = vm.form.account.address || {};
            vm.form.account.address.coords = vm.form.account.address.coords || {};
            vm.form.account.address.zipCode = null;
            vm.form.account.address.street = null;
            vm.form.account.address.city = null;
            vm.form.account.address.state = null;
            vm.form.account.address.number = null;
            vm.form.account.address.coords.latitude = null;
            vm.form.account.address.coords.longitude = null;
            vm.form.account.address.formatAddress = null;

            $timeout(function () {
                focus('auto-complete-address');
            }, 200);
        }

        function _updateTimezoneFlexValue() {
            if (!vm.isSelectedCountryBrasil) {
                vm.timezoneFlexValue = 30;
            } else {
                vm.timezoneFlexValue = 15;
            }
        }

        function handleTimezoneCountryFlagsAndAddress() {
            vm.timezones = _.filter(timeZone.items, function (timezone) {
                return timezone.countryCode === vm.form.account.address.countryCode;
            });

            vm.timezones = _.sortBy(vm.timezones, function (timezone) {
                return timezone.gmt;
            }).reverse();

            if (vm.form.account.address.countryCode !== 'BRA') {
                vm.timezoneFlexValue = 30;
                vm.isSelectedCountryBrasil = false;

                vm.countrySearchTerm = _.filter(vm.countries, function (country) {
                    return vm.form.account.address.countryCode === country.code;
                });

                vm.timezones.forEach(function (timezone) {
                    if (timezone.default) {
                        vm.form.account.timezone = timezone.id;
                    }
                });
            } else {
                vm.timezoneFlexValue = 15;
                vm.form.account.timezone = 'America/Sao_Paulo';
                vm.isSelectedCountryBrasil = true;
                vm.countrySearchTerm = '';
            }

            clearSelectedAccountAddress();
        }

        function addressChanged() {
            vm.addressService.selectedAddressItemChange(vm.selectedAccountAddress, $scope.accountForm, vm.formErr);
            if (vm.selectedAccountAddress) {
                vm.hasAccountAddress = true;
            }
        }

        function geoCoderAddress() {
            vm.geocodingAddress = true;
            geoCoder.getByAddressObject(vm.form.account.address).then(function (location) {

                if (location) {
                    vm.form.account.address.coords.latitude = location.lat;
                    vm.form.account.address.coords.longitude = location.lng;
                    vm.isInvalidAddress = false;
                }
                else {
                    vm.form.account.latitude = null;
                    vm.form.account.longitude = null;
                    vm.isInvalidAddress = true;
                }

                vm.geocodingAddress = false;
            });
        }

        function cepDb() {
            if (!vm.form.account.address.zipCode) {
                vm.form.account.address.street = '';
                vm.form.account.address.city = '';
                vm.form.account.address.state = '';
                vm.form.account.address.number = '';
            } else {
                var cep = vm.form.account.address.zipCode.replace(/\D/g, '');
                cepDbApi.search({ 'zipCode': cep }).then(function (data) {
                    if (data) {
                        vm.form.account.address.street = data.logradouro;
                        vm.form.account.address.city = data.cidade;
                        vm.form.account.address.state = data.estado;
                        focus('number');
                    }
                    else {
                        vm.form.account.address.street = '';
                        vm.form.account.address.city = '';
                        vm.form.account.address.state = '';
                    }
                });
            }
        }

        function openVideoHowToRegisterEmployee(event) {
            HowRegisterEmployeeDialog.open(event);
        }

        function cancelIntervals(){
            if (angular.isDefined(employeesInterval)) {
                $interval.cancel(employeesInterval);
                employeesInterval = undefined;
            }

            if (angular.isDefined(refreshApiKeyInterval)) {
                $interval.cancel(refreshApiKeyInterval);
                refreshApiKeyInterval = undefined;
            }
        }

        function startUsingFieldControl() {
            cancelIntervals();
            $state.go('app.control-panel.gantt');

            $timeout(function (){
                $rootScope.$broadcast('toolbar:show-toolbar-options');
            }, 2000);

            $rootScope.customData = $rootScope.customData || {};
            $rootScope.customData.startTourAfterGanttLoaded = true;
            $rootScope.customData.startTourAfterAddTask = true;
        }

        function updateCountEmployees() {
            employeesApi.getAll().then(function (employees) {
                vm.employeesCount = employees.items.length;
                if (vm.employeesCount > 0) {
                    cancelIntervals();
                    $timeout(function (){
                        startUsingFieldControl();
                    }, 5000);
                }
            });
        }

        function nextStep(msWizard) {
            $rootScope.loadingProgress = true;

            if (vm.isSelectedCountryBrasil) {
                vm.form.account.address.formattedAddress = msUtils.formatAddress(vm.form.account.address);
            }

            var requests = {
                accountUpdate: accountsApi.patch({
                    name: vm.form.account.name,
                    timezone: vm.form.account.timezone,
                    contact: {
                        name: vm.form.account.contact.name,
                        phone: vm.form.account.contact.phone,
                        email: vm.form.account.contact.email
                    },
                    address: vm.form.account.address
                })
            };

            if (services.items.length === 0) {
                requests.servicesCreateA = servicesApi.save({ description: 'Manutenção', duration: 40 });
                requests.servicesCreateB = servicesApi.save({ description: 'Instalação', duration: 60 });
            }

            if (customers.items.length === 0) {
                requests.customersCreate = customersApi.save({
                    name: vm.form.account.contact.name,
                    address: vm.form.account.address,
                    contacts: {
                        "emails": [{
                            address: vm.form.account.contact.email,
                            type: "personal",
                            primary: true
                        }],
                        phones: []
                    }
                });
            }

            $q.all(requests).then(function () {
                $rootScope.loadingProgress = false;

                var fiveMinutes = 60000 * 5;
                var fiveSeconds = 5000;
                vm.refreshApiKey();
                refreshApiKeyInterval = $interval(function () {
                    vm.refreshApiKey();
                }, fiveMinutes);

                employeesInterval = $interval(function () {
                    updateCountEmployees();
                }, fiveSeconds);

                msWizard.nextStep();
            }).catch(function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($translate.instant("BOOTSTRAP.ERROR"))
                        .hideDelay(3000)
                );
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.audit-logs')
        .controller('AuditLogsController', AuditLogsController);

    /** @ngInject */
    function AuditLogsController(auditLogsApi, AuditLogsFilters, AuditLogDialogs,
        dataTableOptions, DTColumnBuilder, $rootScope, $translate, moment, $compile, $scope, $mdSidenav) {

        var vm = this;

        $scope.$on('audit-logs:reload', function () {
            vm.reload();
        });

        function _initialize() {
            vm.events = null;
            vm.reload = _.debounce(_reloadDatatable, 1000);
            vm.toggleSidenav = toggleSidenav;
            vm.auditLogsFilters = AuditLogsFilters;
            vm.clearFilters = vm.auditLogsFilters.clear;
            vm.filteringIsOn = vm.auditLogsFilters.isOn;

            vm.showEventDetails = showEventDetails;

            _startDataTable();
        }

        function showEventDetails(ev, id) {
            AuditLogDialogs.showEventDetails(ev, id);
        }


        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function _reloadDatatable(resetPaging) {
            resetPaging = resetPaging ? resetPaging : true;
            vm.dtInstance.DataTable.ajax.reload(null, resetPaging);
        }

        function _startDataTable() {
            vm.dtInstance = {};
            vm.currentScroll = vm.currentScroll || 0;

            vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
                config.sAjaxDataProp = "data";
                config.processing = true;
                config.serverSide = true;
                config.searchDelay = 2000;
                config.paging = true;
                config.buttons = [];
                config.order = [5, 'desc'];

                config.fnServerData = _.debounce(function (sSource, aoData, fnCallback) {
                    $rootScope.loadingProgress = true;

                    if (aoData[2].value && aoData[2].value[0]) {
                        var columnOrder = aoData[2].value[0];

                        var order = {
                            asc: (columnOrder.dir === 'asc'),
                            field: [
                                'id',
                                'targetResource',
                                'action',
                                'userName',
                                'userIp',
                                'createdAt'
                            ][columnOrder.column] || null
                        };
                    }

                    var pageInfo = {
                        take: aoData[3].value,
                        skip: aoData[4].value
                    };

                    var filters = {
                        action: { in: vm.auditLogsFilters.action },
                        targetResource: { ilike: vm.auditLogsFilters.targetResource ? '%' + vm.auditLogsFilters.targetResource  + '%' : null },
                        userName: { ilike: vm.auditLogsFilters.userName ? '%' + vm.auditLogsFilters.userName  + '%' : null },
                        userIp: { ilike: vm.auditLogsFilters.userIp ? '%' + vm.auditLogsFilters.userIp  + '%' : null },
                        createdAt: { between: vm.auditLogsFilters.createdAt }
                    };

                    var variables;
                    if (vm.auditLogsFilters) {
                        variables = {
                            search: {
                                filters: filters,
                                pageInfo: pageInfo,
                                orderBy: order
                            }
                        };
                    }

                    auditLogsApi.search(variables)
                        .then(function (result) {
                            vm.events = result.data.searchEvents.items;
                        })
                        .finally(function () {
                            fnCallback({
                                draw: aoData[0].value,
                                recordsTotal: vm.events.length,
                                recordsFiltered: vm.events.length,
                                data: vm.events
                            });
                            $rootScope.loadingProgress = false;
                        });

                }, 1000);

                config.createdRow = function (row) {
                    $compile(angular.element(row).contents())($scope);
                };

                config.columnDefs = [];
                config.lengthMenu = [25, 50, 100, 200];
                config.pageLength = 25;
            });
            vm.dtColumns = _getDtColumns();

            vm.dtInstanceCallback = function (_dtInstance) {
                vm.dtInstance = _dtInstance;
                vm.dtInstance.DataTable.on('draw', function () {
                    var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
                    scrollContent.scrollTop = vm.currentScroll;
                    vm.currentScroll = 0;
                });
                fixTableHeaders();
            };
        }

        function fixTableHeaders() {
            $('.dataTables_scrollHeadInner table thead th').each(function () {
                var title = $('.dataTables_scrollHeadInner table thead th').eq($(this).index()).text();
                $(this).html('<div class="table-header"><span class="column-title">' + title + '</span></div>');
            });

            var visibleColumnsCount = 1;
            for (var index = 0; index < vm.dtColumns.length; index++) {
                if (isColumnVisible(index)) { visibleColumnsCount++; }
            }
            $('.dataTables_empty').attr('colspan', visibleColumnsCount);
        }

        function isColumnVisible(index) {
            if (vm.dtInstance) {
                return vm.dtInstance.DataTable.column(index).visible();
            }
        }

        function _getDtColumns() {
            return [
                DTColumnBuilder.newColumn('id', 'id').notVisible(),
                DTColumnBuilder.newColumn(null, $translate.instant('AUDIT_LOGS.TABLE.COLUMNS.RESOURCE_NAME')).renderWith(function (data) {
                    return $translate.instant('AUDIT_LOGS.TABLE.ROWS.RESOURCE_NAME.' + data.targetResource.toUpperCase());
                }),
                DTColumnBuilder.newColumn(null, $translate.instant('AUDIT_LOGS.TABLE.COLUMNS.ACTION')).renderWith(function (data) {
                    return $translate.instant('AUDIT_LOGS.TABLE.ROWS.ACTIONS.' + data.action);
                }),
                DTColumnBuilder.newColumn(null, $translate.instant('AUDIT_LOGS.TABLE.COLUMNS.USERNAME')).renderWith(function (data) {
                    return data.userName;
                }),
                DTColumnBuilder.newColumn(null, $translate.instant('AUDIT_LOGS.TABLE.COLUMNS.USER_IP')).renderWith(function (data) {
                    return data.userIp;
                }).notSortable(),
                DTColumnBuilder.newColumn(null, $translate.instant('AUDIT_LOGS.TABLE.COLUMNS.CREATED_AT')).renderWith(function (data) {
                    return moment(data.createdAt).format('DD/MM/YYYY HH:mm');
                }),
                DTColumnBuilder.newColumn(null, $translate.instant('AUDIT_LOGS.TABLE.COLUMNS.ACTIONS')).renderWith(function (data) {
                    var eventClick = 'ng-click="vm.showEventDetails($event,\'' + data.id + '\')"',
                        templateHTML = '<md-button class="md-icon-button"' + eventClick + '>' +
                                '<img ng-src="assets/icons/icon-edit.svg" alt="Show">' +
                                '<md-tooltip md-direction="left">' +
                                    '<span translate="AUDIT_LOGS.TABLE.ACTIONS.VIEW">Show event</span>' +
                                '</md-tooltip>' +
                            '</md-button>';
                    return templateHTML;
                }).notSortable()
                .withOption('responsivePriority', 1)
            ];
        }

        _initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.absences')
        .controller('AbsencesController', AbsencesController);

    /** @ngInject */
    function AbsencesController($scope, absences, dataTableOptions, AbsenceDialog, msUtils,
                                AbsencesFilters, absencesApi, $rootScope, dateConverter, $compile, $mdSidenav, LocalDateConvert) {

        var vm = this;
        vm.toggleSidenav = toggleSidenav;
        vm.absences = absences.items;
        vm.currentScroll = vm.currentScroll || 0;
        handleUtcDates(vm.absences);
        vm.dtInstance = {};

        vm.dtOptions = dataTableOptions.getOptionsDefault(function (config) {
            config.columnDefs.push({
                targets: 2,
                filterable: true,
                sortable: true,
                type: 'date-pt'
            });

            config.columnDefs.push({
                targets: 3,
                filterable: true,
                sortable: true,
                type: 'date-pt'
            });

            config.columnDefs.push({
              targets: 4,
              filterable: false,
              sortable: true,
              type: 'date-pt',
            });

            config.columnDefs.push({
                targets: 5,
                responsivePriority: 1,
                filterable: false,
                sortable: false
            });

            config.buttons = [
              {
                isExportButton: true,
                extend: 'csvHtml5',
                className: 'hidden-button',
                filename: msUtils.shortGuidGenerator(),
                text: '.',
                exportOptions: {
                    columns: 'th:not(:last-child)'
                }
              },
              {
                isExportButton: true,
                extend: 'excelHtml5',
                className: 'hidden-button',
                filename: msUtils.shortGuidGenerator(),
                text: '.',
                exportOptions: {
                    columns: 'th:not(:last-child)'
                }
              }
            ];
        });

        $scope.$on('absences:filter-updated', function () {
            loadAbsences();
        });

        $scope.$on('absences:deleted', function () {
            loadAbsences();
        });

        vm.addAbsence = addAbsence;
        vm.editAbsence = editAbsence;
        vm.filteringIsOn = AbsencesFilters.isOn;
        vm.clearFilters = AbsencesFilters.clear;
        vm.reload = _.debounce(reload, 1000);

        vm.dtInstanceCallback = function (_dtInstance) {
            vm.dtInstance = _dtInstance;
            _addCallToActionButton();
            vm.dtInstance.DataTable.on('draw', function () {
                var scrollContent = document.querySelector('#table-list_wrapper .dataTables_scrollBody');
                scrollContent.scrollTop = vm.currentScroll;
                vm.currentScroll = 0;
                _addCallToActionButton();
            });
        };

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function _addCallToActionButton() {
            $('.call-to-action').remove();
            var ctaNewAbsence = $compile('<div class="call-to-action"><span><span translate="ABSENCES.TABLE.CREATE_NEW_CTA"></span> <a class="cursor-pointer" translate="ABSENCES.TABLE.CREATE_NEW_LINK" ng-click="vm.addAbsence($event)"></a>.</span></div>')(($scope));
            $('.dataTables_empty').append($(ctaNewAbsence)).attr('colspan', 6);
        }

        function reload() {
            loadAbsences();
        }

        function addAbsence(ev) {
            AbsenceDialog.createAbsence(ev, function (reload) {
                if (reload) {
                    loadAbsences();
                }
            });
        }

        function editAbsence(ev, id) {
            AbsenceDialog.editAbsence(ev, id, function (reload) {
                if (reload) {
                    vm.currentScroll = document.querySelector('#table-list_wrapper .dataTables_scrollBody').scrollTop;
                    loadAbsences();
                }
            });
        }

        function handleUtcDates(absences) {
            absences.forEach(function (absence) {
                absence.toView = LocalDateConvert.formatDate(absence.to, 'date');
                absence.fromView = LocalDateConvert.formatDate(absence.from, 'date');
                absence.createdAtView = absence.createdAt ? LocalDateConvert.formatDate(absence.createdAt, 'date-time') : '';
            });

        }

        function loadAbsences() {
            $rootScope.loadingProgress = true;
            var whereParams = {};

            if (AbsencesFilters.reason) {
                whereParams['reasonContains'] = AbsencesFilters.reason;
            }

            if (AbsencesFilters.employees.length) {
                whereParams['employeeIds'] = AbsencesFilters.employees;
            }

            if (AbsencesFilters.startDateFrom) {
                whereParams['fromGte'] = moment(AbsencesFilters.startDateFrom).format('YYYY-MM-DD');
            }

            if (AbsencesFilters.startDateTo) {
                whereParams['fromLte'] = moment(AbsencesFilters.startDateTo).format('YYYY-MM-DD');
            }

            if (AbsencesFilters.endDateFrom) {
                whereParams['toGte'] = moment(AbsencesFilters.endDateFrom).format('YYYY-MM-DD');
            }

            if (AbsencesFilters.endDateTo) {
                whereParams['toLte'] = moment(AbsencesFilters.endDateTo).format('YYYY-MM-DD');
            }

            var queryParams = {
                where: whereParams,
                skip: 0,
                take: 50,
                orderBy: 'createdAt_desc'
            };

            absencesApi.search(queryParams).then(function (absences) {
                vm.absences = absences.items;
                handleUtcDates(vm.absences);
                dataTableOptions.preRerenderBugFix(vm.dtInstance);
                vm.dtInstance.rerender();
            }).finally(function () {
                $rootScope.loadingProgress = false;
            });

        }
    }
})();

(function () {
  'use strict';
  angular.module('app.core')
      .factory('translateService', translateService);

  /** @ngInject */
  function translateService($localStorage, $translate, languageMap) {

      var languageKey = 'language';

      return {
        getLanguage: getLanguage,
        setLanguage: setLanguage,
        removeLanguage: removeLanguage,
        refreshLanguage: refreshLanguage
      };

      function getLanguage() {
        var language = $localStorage.get(languageKey);
        var lowercaseLanguage = language ? language.toLowerCase() : null;

        return lowercaseLanguage ? languageMap[lowercaseLanguage] : 'pt';
      }

      function setLanguage(language) {
        $localStorage.set(languageKey, languageMap[language]);
      }

      function removeLanguage() {
        $localStorage.remove(languageKey);
      }

      function refreshLanguage() {
        var language = getLanguage();

        if (language) {
            $translate.use(language);
        } else {
          var deviceLanguage = navigator.language || navigator.userLanguage;
          deviceLanguage = deviceLanguage.toLowerCase();
          language = languageMap[deviceLanguage] ? languageMap[deviceLanguage] : 'pt';
          setLanguage(language);
          $translate.use(language);
        }
      }
  }
})();

(function () {
  'use strict';

  angular
      .module('app.core')
      .provider('translate', translateProvider);

  /** @ngInject */
  function translateProvider(languageMap) {
      this.$get = function () {
        return {
          getTranslateLanguageCode: getTranslateLanguageCode
        };
      };

    function getTranslateLanguageCode() {
      var deviceLanguage = navigator.language || navigator.userLanguage;
      deviceLanguage = deviceLanguage.toLowerCase();
      return languageMap[deviceLanguage] ? languageMap[deviceLanguage] : 'pt';
    }
  }

}());
(function () {
  'use strict';

  angular
      .module('app.core')
      .constant('languageMap', {
          // PORTUGUESE
          'pt': 'pt',
          'pt-br': 'pt',
          // ENGLISH
          'en': 'en',
          'en-au': 'en',
          'en-bz': 'en',
          'en-ca': 'en',
          'en-ie': 'en',
          'en-jm': 'en',
          'en-nz': 'en',
          'en-za': 'en',
          'en-tt': 'en',
          'en-gb': 'en',
          'en-us': 'en',
          // SPANISH
          'es': 'es',
          'es-es': 'es',
          'es-ar': 'es',
          'es-bo': 'es',
          'es-cl': 'es',
          'es-co': 'es',
          'es-cr': 'es',
          'es-do': 'es',
          'es-ec': 'es',
          'es-sv': 'es',
          'es-gt': 'es',
          'es-hn': 'es',
          'es-mx': 'es',
          'es-ni': 'es',
          'es-pa': 'es',
          'es-py': 'es',
          'es-pe': 'es',
          'es-pr': 'es',
          'es-uy': 'es',
          'es-ve': 'es'
      });
})();

(function () {
    angular.module('app.core')
        .constant('googleMapsStyle', [{
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#444444"
            }]
        }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{
                "color": "#f2f2f2"
            }]
        }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{
                "saturation": -100
            }, {
                "lightness": 45
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{
                "visibility": "simplified"
            }]
        }, {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{
                "color": "#BBDEFB"
            }, {
                "visibility": "on"
            }]
        }]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredPalettesLabels: getRegisteredPalettesLabels,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            function getRegisteredPalettesLabels() {

                if (registeredPalettes) {
                    var registeredPalettesLabels = angular.copy(registeredPalettes);
                    delete registeredPalettesLabels['fuse-blue'];
                    delete registeredPalettesLabels['fuse-pale-blue'];
                    return registeredPalettesLabels;
                }
            }

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function () {
  'use strict';

  var fuseThemes = {
    'default': {
      primary: {
        name: 'field-pale',
        hues: {
          'default': '800',
        }
      },
      accent: {
        name: 'field-pale',
        hues: {
          'default': '700',
        }
      },
      warn: { name: 'red' },
      background: {
        name: 'grey',
        hues: {
          'default': 'A100',
          'hue-1': '100',
          'hue-2': '50',
          'hue-3': '300'
        }
      }
    }
  };

  angular
    .module('app.core')
    .constant('fuseThemes', fuseThemes);
})();
(function () {
  'use strict';

  var fusePalettes = [{
    name: 'fuse-blue',
    options: {
      '50': '#ebf1fa',
      '100': '#c2d4ef',
      '200': '#9ab8e5',
      '300': '#78a0dc',
      '400': '#5688d3',
      '500': '#3470ca',
      '600': '#2e62b1',
      '700': '#275498',
      '800': '#21467e',
      '900': '#1a3865',
      'A100': '#c2d4ef',
      'A200': '#9ab8e5',
      'A400': '#5688d3',
      'A700': '#275498',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': '50 100 200 A100',
      'contrastStrongLightColors': '300 400'
    }
  },
  {
    name: 'fuse-pale-blue',
    options: {
      '50': '#ececee',
      '100': '#c5c6cb',
      '200': '#9ea1a9',
      '300': '#7d818c',
      '400': '#5c616f',
      '500': '#3c4252',
      '600': '#353a48',
      '700': '#2d323e',
      '800': '#262933',
      '900': '#1e2129',
      'A100': '#c5c6cb',
      'A200': '#9ea1a9',
      'A400': '#5c616f',
      'A700': '#2d323e',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': '50 100 200 A100',
      'contrastStrongLightColors': '300 400'
    }
  },
  {
    name: 'field-pale',
    options: {
      '50': '#d3ddf2',
      '100': '#c5c6cb',
      '200': '#9ea1a9',
      '300': '#7d818c',
      '400': '#5c616f',
      '500': '#3c4252',
      '600': '#353a48',
      '700': '#0957C3',
      '800': '#00194a',
      '900': '#1e2129',
      'A100': '#c5c6cb',
      'A200': '#9ea1a9',
      'A400': '#5c616f',
      'A700': '#0957C3',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': '50 100 200 A100',
      'contrastStrongLightColors': '300 400'
    }
  }
  ];

  angular
    .module('app.core')
    .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            //var selectedTheme = $cookies.get('selectedTheme');
            //
            //if ( selectedTheme )
            //{
            //    fuseTheming.setActiveTheme(selectedTheme);
            //}
            //else
            //{
            //    fuseTheming.setActiveTheme('default');
            //}

            fuseTheming.setActiveTheme('default');
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function () {
    'use strict';

    angular.module('app.core')
        .factory('customerIcons', customerIcons);

    /** @ngInject */
    function customerIcons() {

        return {
            iconNameFromStatusCode: iconNameFromStatusCode
        };

        function iconNameFromStatusCode(statusCode) {

            switch (statusCode) {
                case 0:
                    return 'scheduled'; // scheduled - azul
                case 1:
                    return 'inprogress'; // in progress - laranja
                case 2:
                    return 'done'; // done - verde
                case 3:
                    return 'canceled'; // canceled - purple
                case 4:
                    return "reported"; // reported - red
                default:
                    return 'default';
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('activityColor', activityColor);

    /** @ngInject */
    function activityColor() {

        return {
            classNameFromStatusCode: classNameFromStatusCode
        };

        function classNameFromStatusCode(statusCode) {

            switch (statusCode) {
                case 0:
                    return 'scheduled-bg'; // scheduled - azul
                case 1:
                    return 'in-progress-bg'; // in progress - laranja
                case 2:
                    return 'done-bg'; // done - verde
                case 3:
                    return 'canceled-bg'; // canceled - purple
                case 4:
                    return "reported-bg"; // reported - red
                case 5:
                    return "on-route-bg"; // on-route - grey
                default:
                    return 'md-blue-grey-200-bg';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('timeZone', timeZone);

    /** @ngInject */
    function timeZone(_, moment) {
        var items = [
            {
                id: 'Pacific/Honolulu',
                name: 'Honolulu',
                countryCode: 'USA',
                countryName: 'Estados Unidos',
                default: false
            },
            {
                id: 'America/Anchorage',
                name: 'Anchorage',
                countryCode: 'USA',
                countryName: 'Estados Unidos',
                default: false
            },
            {
                id: 'America/Los_Angeles',
                name: 'Los Angeles',
                countryCode: 'USA',
                countryName: 'Estados Unidos',
                default: true
            },
            {
                id: 'America/Phoenix',
                name: 'Phoenix',
                countryCode: 'USA',
                countryName: 'Estados Unidos',
                default: false
            },
            {
                id: 'America/Salt_Lake_City',
                name: 'Salt Lake City',
                countryCode: 'USA',
                countryName: 'Estados Unidos',
                default: false
            },
            {
                id: 'America/Chicago',
                name: 'Chicago',
                countryCode: 'USA',
                countryName: 'Estados Unidos',
                default: false
            },
            {
                id: 'America/New_York',
                name: 'New York',
                countryCode: 'USA',
                countryName: 'Estados Unidos',
                default: false
            },
            {
                id: 'America/Tijuana',
                name: 'Tijuana',
                countryCode: 'MEX',
                countryName: 'México',
                default: false
            },
            {
                id: 'America/Hermosillo',
                name: 'Hermosillo',
                countryCode: 'MEX',
                countryName: 'México',
                default: false
            },
            {
                id: 'America/Mazatlan',
                name: 'Mazatlan',
                countryCode: 'MEX',
                countryName: 'México',
                default: false
            },
            {
                id: 'America/Mexico_City',
                name: 'Ciudad de México',
                countryCode: 'MEX',
                countryName: 'México',
                default: true
            },
            {
                id: 'America/Cancun',
                name: 'Cancún',
                countryCode: 'MEX',
                countryName: 'México',
                default: false
            },
            {
                id: 'America/Port_of_Spain',
                name: 'Port of Spain',
                countryCode: 'TTO',
                countryName: 'Trinidade e Tobago',
                default: true
            },
            {
                id: 'America/Costa_Rica',
                name: 'Costa Rica',
                countryCode: 'CRI',
                countryName: 'Costa Rica',
                default: true
            },
            {
                id: 'America/Havana',
                name: 'Havana',
                countryCode: 'CUB',
                countryName: 'Cuba',
                default: true
            },
            {
                id: 'America/Santo_Domingo',
                name: 'Santo Domingo',
                countryCode: 'DOM',
                countryName: 'República Dominicana',
                default: true
            },
            {
                id: 'America/Jamaica',
                name: 'Jamaica',
                countryCode: 'JAM',
                countryName: 'Jamaica',
                default: true
            },
            {
                id: 'America/Guatemala',
                name: 'Guatemala',
                countryCode: 'GTM',
                countryName: 'Guatemala',
                default: true
            },
            {
                id: 'America/Belize',
                name: 'Belize',
                countryCode: 'BLZ',
                countryName: 'Belize',
                default: true
            },
            {
                id: 'America/El_Salvador',
                name: 'El Salvador',
                countryCode: 'SLV',
                countryName: 'El Salvador',
                default: true
            },
            {
                id: 'America/Tegucigalpa',
                name: 'Tegucigalpa',
                countryCode: 'HND',
                countryName: 'Honduras',
                default: true
            },
            {
                id: 'America/Managua',
                name: 'Managua',
                countryCode: 'NIC',
                countryName: 'Nicarágua',
                default: true
            },
            {
                id: 'America/Panama',
                name: 'Panamá',
                countryCode: 'PAN',
                countryName: 'Panamá',
                default: true
            },
            {
                id: 'America/Puerto_Rico',
                name: 'Puerto Rico',
                countryCode: 'PRI',
                countryName: 'Porto Rico',
                default: true
            },
            {
                id: 'America/Nassau',
                name: 'Nassau',
                countryCode: 'BHS',
                countryName: 'Bahamas',
                default: true
            },
            {
                id: 'America/Rio_Branco',
                name: 'Rio Branco',
                countryCode: 'BRA',
                countryName: 'Brasil',
                default: false
            },
            {
                id: 'America/Manaus',
                name: 'Manaus',
                countryCode: 'BRA',
                countryName: 'Brasil',
                default: false
            },
            {
                id: 'America/Belem',
                name: 'Belém',
                countryCode: 'BRA',
                countryName: 'Brasil',
                default: false
            },
            {
                id: 'America/Sao_Paulo',
                name: 'São Paulo',
                countryCode: 'BRA',
                countryName: 'Brasil',
                default: true
            },
            {
                id: 'America/Fortaleza',
                name: 'Fortaleza',
                countryCode: 'BRA',
                countryName: 'Brasil',
                default: false
            },
            {
                id: 'America/Noronha',
                name: 'Noronha',
                countryCode: 'BRA',
                countryName: 'Brasil',
                default: false
            },
            {
                id: 'America/La_Paz',
                name: 'La Paz',
                countryCode: 'BOL',
                countryName: 'Bolívia',
                default: true
            },
            {
                id: 'Pacific/Easter',
                name: 'Easter',
                countryCode: 'CHL',
                countryName: 'Chile',
                default: false
            },
            {
                id: 'America/Santiago',
                name: 'Santiago',
                countryCode: 'CHL',
                countryName: 'Chile',
                default: true
            },
            {
                id: 'Pacific/Galapagos',
                name: 'Galápagos',
                countryCode: 'ECU',
                countryName: 'Equador',
                default: false
            },
            {
                id: 'America/Quito',
                name: 'Quito',
                countryCode: 'ECU',
                countryName: 'Equador',
                default: true
            },
            {
                id: 'America/Cayenne',
                name: 'Cayenne',
                countryCode: 'GUF',
                countryName: 'Guiana Francesa',
                default: true
            },
            {
                id: 'America/Georgetown',
                name: 'Georgetown',
                countryCode: 'GUY',
                countryName: 'Guiana',
                default: true
            },
            {
                id: 'America/Asuncion',
                name: 'Asunción',
                countryCode: 'PRY',
                countryName: 'Paraguai',
                default: true
            },
            {
                id: 'America/Lima',
                name: 'Lima',
                countryCode: 'PER',
                countryName: 'Peru',
                default: true
            },
            {
                id: 'America/Paramaribo',
                name: 'Paramaribo',
                countryCode: 'SUR',
                countryName: 'Suriname',
                default: true
            },
            {
                id: 'America/Montevideo',
                name: 'Montevideo',
                countryCode: 'URY',
                countryName: 'Uruguai',
                default: true
            },
            {
                id: 'America/Caracas',
                name: 'Caracas',
                countryCode: 'VEN',
                countryName: 'Venezuela',
                default: true
            },
            {
                id: 'America/Argentina/Buenos_Aires',
                name: 'Buenos Aires',
                countryCode: 'ARG',
                countryName: 'Argentina',
                default: true
            },
            {
                id: 'America/Bogota',
                name: 'Bogotá',
                countryCode: 'COL',
                countryName: 'Colômbia',
                default: true
            },
            {
                id: 'Europe/Lisbon',
                name: 'Lisbon',
                countryCode: 'PRT',
                countryName: 'Portugal',
                default: true
            },
            {
                id: 'Africa/Luanda',
                name: 'Angola',
                countryCode: 'AGO',
                countryName: 'Angola',
                default: true
            }
        ];

        var filteredItems = _.filter(items, function (item) {
            return moment.tz.names().includes(item.id);
        });

        return {
            items: filteredItems
        };
    }
})();

(function () {
  'use strict';

  angular.module('app.core')
      .factory('CheckEditPermission', CheckEditPermission);

  /** @ngInject */
  function CheckEditPermission(accountCache, authenticatedUser, MessageDialog, $translate) {

      return {
          hasPermission: hasPermission
      };

      function hasPermission() {
        var account = accountCache.getAccount();
        var editPermission = authenticatedUser.hasPermission(account, 'tasks_allow_edit');

        if (!editPermission) {
          MessageDialog.showToast({
            hideDelay: 2000,
            message: $translate.instant('TASKS.DIALOG.ACTIONS.ALERTS.CANT_EDIT')
          });
          return false;
        }
        return true;
      }
  }

})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('realtimeNotifications', realtimeNotifications);

  /** @ngInject */
  function realtimeNotifications($rootScope, EnvironmentConfig, authenticatedUser) {

    var socket = null;

    return {
      connectAndSetup: connectAndSetup,
      disconnectAndReset: disconnectAndReset
    };

    function disconnectAndReset() {
      if (socket !== null && socket.connected) {
        socket.disconnect();
      }
    }

    function connectAndSetup() {

      if (socket !== null && socket.connected && authenticatedUser.isAuthenticated()) {
        return;
      }

      socket = io(EnvironmentConfig.realtimeUrl, {
        query: {
          token: authenticatedUser.profile.token
        }
      });

      socket.on('reconnect_attempt', function () {
        socket.io.opts.query = {
          token: authenticatedUser.profile.token
        };
      });

      socket.on('disconnect', function (reason) {
        if (reason === 'io server disconnect') {
          socket.connect();
        }
      });

      socket.on('play:sound', function (data) {
        if (data) {
          if (data && data.src) {
            var audio = new Audio(data.src);
            var promiseAudio = audio.play();
            if (promiseAudio !== undefined) {
              promiseAudio.then(function () {

              }).catch(function (error) {
                console.warn('Could not play sound :(', error);
              });
            }
          }
        }
      });

      socket.on('new:notification', function (data) {
        $rootScope.$broadcast('new:notification', data);
      });

      socket.on('auth:logout', function (data) {
        $rootScope.$broadcast('auth:logout', data);
      });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('QueryStringParser', QueryStringParser);

    /** @ngInject */
    function QueryStringParser() {

        return {
            parse: parse
        };

        function parse(string, options) {

            // Set an empty options object when none provided
            if (!options) {
                options = {};
            }

            if (!string) {
                string = '';
            }

            // When a simple string, return it
            if (string.indexOf(':') === -1) {
                return string;
            }
            // When no keywords or ranges set, treat as a simple string
            else if (!options.keywords && !options.ranges){
                return string;
            }
            // Otherwise parse the advanced query syntax
            else {
                // Our object to store the query object
                var query = {text: [], offsets: []};
                var exclusion = {};
                var terms = [];
                // Get a list of search terms respecting single and double quotes
                var regex = /(\S+:'(?:[^'\\]|\\.)*')|(\S+:"(?:[^"\\]|\\.)*")|\S+|\S+:\S+/g;
                var match;
                while ((match = regex.exec(string)) !== null) {
                    var term = match[0];
                    var sepIndex = term.indexOf(':');
                    if (sepIndex !== -1) {
                        var split = term.split(':'),
                            key = term.slice(0, sepIndex),
                            val = term.slice(sepIndex + 1);
                        // Strip surrounding quotes
                        val = val.replace(/^\"|\"$|^\'|\'$/g, '');
                        // Strip backslashes respecting escapes
                        val = (val + '').replace(/\\(.?)/g, function (s, n1) {
                            switch (n1) {
                                case '\\':
                                    return '\\';
                                case '0':
                                    return '\u0000';
                                case '':
                                    return '';
                                default:
                                    return n1;
                            }
                        });
                        terms.push({
                            keyword: key,
                            value: val,
                            offsetStart: match.index,
                            offsetEnd: match.index + term.length
                        });
                    } else {
                        terms.push({
                            text: term,
                            offsetStart: match.index,
                            offsetEnd: match.index + term.length
                        });
                    }
                }
                // Reverse to ensure proper order when pop()'ing.
                terms.reverse();
                // For each search term
                var term;
                // eslint-disable-next-line no-cond-assign
                while (term = terms.pop()) {
                    // When just a simple term
                    if (term.text) {
                        // We add it as pure text
                        query.text.push(term.text);
                        query.offsets.push(term);
                    }
                    // We got an advanced search syntax
                    else {
                        var key = term.keyword;
                        // Check if the key is a registered keyword
                        options.keywords = options.keywords || [];
                        var isKeyword = false;
                        var isExclusion = false;
                        if (!/^-/.test(key)) {
                            isKeyword = !(options.keywords.indexOf(key) === -1);
                        } else  if (key[0] === '-') {
                            var _key = key.slice(1);
                            isKeyword = !(options.keywords.indexOf(_key) === -1);
                            if (isKeyword) {
                                key = _key;
                                isExclusion = true;
                            }
                        }

                        // Check if the key is a registered range
                        options.ranges = options.ranges || [];
                        var isRange = !(options.ranges.indexOf(key) === -1);
                        // When the key matches a keyword
                        if (isKeyword) {
                            query.offsets.push({
                                keyword: key,
                                value: term.value,
                                offsetStart: isExclusion ? term.offsetStart + 1 : term.offsetStart,
                                offsetEnd: term.offsetEnd
                            });

                            var value = term.value;
                            // When value is a thing
                            if (value.length) {
                                // Get an array of values when several are there
                                var values = value.split(',');
                                if (isExclusion) {
                                    if (exclusion[key]) {
                                        // ...many times...
                                        if (exclusion[key] instanceof Array) {
                                            // ...and got several values this time...
                                            if (values.length > 1) {
                                                // ... concatenate both arrays.
                                                exclusion[key] = exclusion[key].concat(values);
                                            }
                                            else {
                                                // ... append the current single value.
                                                exclusion[key].push(value);
                                            }
                                        }
                                        // We saw that keyword only once before
                                        else {
                                            // Put both the current value and the new
                                            // value in an array
                                            exclusion[key] = [exclusion[key]];
                                            exclusion[key].push(value);
                                        }
                                    }
                                    // First time we see that keyword
                                    else {
                                        // ...and got several values this time...
                                        if (values.length > 1) {
                                            // ...add all values seen.
                                            exclusion[key] = values;
                                        }
                                        // Got only a single value this time
                                        else {
                                            // Record its value as a string
                                            exclusion[key] = value;
                                        }
                                    }
                                } else {
                                    // If we already have seen that keyword...
                                    if (query[key]) {
                                        // ...many times...
                                        if (query[key] instanceof Array) {
                                            // ...and got several values this time...
                                            if (values.length > 1) {
                                                // ... concatenate both arrays.
                                                query[key] = query[key].concat(values);
                                            }
                                            else {
                                                // ... append the current single value.
                                                query[key].push(value);
                                            }
                                        }
                                        // We saw that keyword only once before
                                        else {
                                            // Put both the current value and the new
                                            // value in an array
                                            query[key] = [query[key]];
                                            query[key].push(value);
                                        }
                                    }
                                    // First time we see that keyword
                                    else {
                                        // ...and got several values this time...
                                        if (values.length > 1) {
                                            // ...add all values seen.
                                            query[key] = values;
                                        }
                                        // Got only a single value this time
                                        else {
                                            // Record its value as a string
                                            query[key] = value;
                                        }
                                    }
                                }
                            }
                        }
                        // The key allows a range
                        else if (isRange) {
                            query.offsets.push(term);

                            var value = term.value;
                            // Range are separated with a dash
                            var rangeValues = value.split('-');
                            // When both end of the range are specified
                            // keyword:XXXX-YYYY
                            query[key] = {};
                            if (rangeValues.length === 2) {
                                query[key].from = rangeValues[0];
                                query[key].to = rangeValues[1];
                            }
                            // When pairs of ranges are specified
                            // keyword:XXXX-YYYY,AAAA-BBBB
                            else if (!rangeValues.length % 2) {
                            }
                            // When only getting a single value,
                            // or an odd number of values
                            else {
                                query[key].from = value;
                            }
                        }
                        else {
                            // We add it as pure text
                            var text = term.keyword + ':' + term.value;
                            query.text.push(text);

                            query.offsets.push({
                                text: text,
                                offsetStart: term.offsetStart,
                                offsetEnd: term.offsetEnd
                            });
                        }
                    }
                }

                // Concatenate all text terms if any
                if (query.text.length) {
                    query.text = query.text.join(' ').trim();
                }
                // Just remove the attribute text when it's empty
                else {
                    delete query.text;
                }

                // Return forged query object
                query.exclude = exclusion;
                return query;
            }

        }


    }

})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('PushNotifications', PushNotifications);

  /** @ngInject */
  function PushNotifications(
    EnvironmentConfig, pushNotificationsApi, $timeout, $mdDialog, $translate,
    authenticatedUser, FcModalService, $localStorage
  ) {
    return {
      registerServiceWorker: registerServiceWorker,
      subscribeUser: subscribeUser,
      unsubscribeUser: unsubscribeUser,
      askActiveBrowserNotifications: askActiveBrowserNotifications
    };

    function registerServiceWorker() {
      navigator.serviceWorker.register('/service-worker.js').then(function () {
        if (!('PushManager' in window)) {
          console.warn('PushManager is not supported.');
        }
      }).catch(function (err) {
        console.error('err', err);
      });
    }

    function subscribeUser() {

      return navigator.serviceWorker.ready.then(function (serviceWorkerRegistration) {
        if (!serviceWorkerRegistration.active) {
          return;
        }
        return serviceWorkerRegistration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: _base64UrlToUint8Array(EnvironmentConfig.publicVapidKey)
        });
      }).then(function (subscription) {
        var subscriptionData = { data: subscription.toJSON() };
        subscriptionData.type = 'browser';
        subscriptionData.app = 'mordor';
        var token = authenticatedUser.profile.token;
        pushNotificationsApi.subscribe(subscriptionData, token);
      });
    }

    function unsubscribeUser() {
      return navigator.serviceWorker.ready.then(function (serviceWorkerRegistration) {
        if (!serviceWorkerRegistration.active) {
          return;
        }
        if(serviceWorkerRegistration.pushManager.getSubscription() == undefined){
          return;
        };
        return serviceWorkerRegistration.pushManager.getSubscription();
      }).then(function (subscription) {
        if (subscription) {
          var token = authenticatedUser.profile.token;
          pushNotificationsApi.unsubscribe(token).then(function () {
            return subscription.unsubscribe();
          });
        }
      });
    }

    function askActiveBrowserNotifications() {
      if (!authenticatedUser.isAuthenticated()) { return; }
      if (!('Notification' in window)) { return; }
      var lastBrowserNotificationDate = moment().format("YYYY-MM-DD");
      if (lastBrowserNotificationDate === $localStorage.get("LAST_BROWSER_NOTIFICATION_DATE")){
        return;
      }

      if (Notification.permission === 'granted') {
        subscribeUser();
        return;
      }

      if (Notification.permission === 'default') {
        $timeout(function () {
          FcModalService.open('', {
            title: $translate.instant('CORE.PUSH_NOTIFICATIONS.TITLE'),
            content: $translate.instant('CORE.PUSH_NOTIFICATIONS.MESSAGE'),
            leftButtonText: $translate.instant('CORE.PUSH_NOTIFICATIONS.OK'),
            rightButtonText: $translate.instant('CORE.PUSH_NOTIFICATIONS.CANCEL'),
            handleRightButton: function (){
              $localStorage.set("LAST_BROWSER_NOTIFICATION_DATE", lastBrowserNotificationDate);
              $mdDialog.hide();
            },
            handleLeftButton: function () {
              if ('PushManager' in window) {
                Notification.requestPermission(function (result) {
                  if (result === 'granted') {
                    subscribeUser();
                  }
                });
              }
            }
          });
        }, 1500);
      }
    }

    function _base64UrlToUint8Array(base64UrlData) {
      var padding = '='.repeat((4 - base64UrlData.length % 4) % 4);
      var base64 = (base64UrlData + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

      var rawData = window.atob(base64);
      var buffer = new Uint8Array(rawData.length);

      for (var i = 0; i < rawData.length; ++i) {
        buffer[i] = rawData.charCodeAt(i);
      }
      return buffer;
    }
  }

})();

(function () {
  angular
    .module('app.core')

    .filter('passwordCount', [
      function () {
        return function (value, peak) {
          value = angular.isString(value) ? value : '';
          peak = isFinite(peak) ? peak : 7;
          return value && (value.length > peak ? peak + '+' : value.length);
        };
      },
    ])

    .factory('zxcvbn', [
      function () {
        return {
          score: function () {
            var compute = zxcvbn.apply(null, arguments);
            return compute && compute.score;
          },
        };
      },
    ])

    .directive('okPassword', [
      'zxcvbn',
      function (zxcvbn) {
        return {
          scope: 'true',
          restrict: 'AC',
          require: 'ngModel',

          link: function ($scope, $element, $attrs, ngModelCtrl) {
            $element.on('blur change keydown', function (evt) {
              $scope.$evalAsync(function ($scope) {
                var pwd = ($scope.password = $element.val());
                var passwordStrength = 4;

                var lengthOk = pwd.length >= 8;

                var containsLowercase = /[a-z]/.test(pwd);
                var containsUppercase = /[A-Z]/.test(pwd);
                if (!(containsLowercase && containsUppercase)) {
                  passwordStrength = passwordStrength - 2;
                }

                var containsNumber = /\d/.test(pwd);
                if (!containsNumber) {
                  passwordStrength = passwordStrength - 2;
                }

                var containsSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd);
                if (!containsSpecialChar) {
                  passwordStrength = passwordStrength - 1;
                }

                $scope.passwordStrength = passwordStrength;
                $scope.lengthOk = lengthOk;
                $scope.containsLowercase = containsLowercase;
                $scope.containsUppercase = containsUppercase;
                $scope.containsNumber = containsNumber;
                $scope.containsSpecialChar = containsSpecialChar;

                var isValid =
                  lengthOk && containsLowercase && containsUppercase && containsNumber && containsSpecialChar;
                ngModelCtrl.$setValidity('okPassword', isValid);
              });
            });
          },
        };
      },
    ]);
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('objectMapperService', objectMapperService);

  /** @ngInject */
  function objectMapperService(_) {

    return {
      reMap: reMap
    };

    function reMap(custom_schema, data) {
      if (_.isEmpty(custom_schema)) {
        return custom_schema;
      } else if (_.isEmpty(data)) {
        return data;
      } else if (!_.isArray(data)) {
        return _createObject(custom_schema, data);
      } else {
        return _reMapAll(custom_schema, data);
      }
    };

    function _reMapAll(custom_schema, source) {
      var newArray = [];

      source.forEach(function (data) {
        newArray.push(_createObject(custom_schema, data));
      });

      return newArray;
    }

    function _stringToObject(path, val, obj) {
      var fields = path.split('.');
      var result = obj;

      for (var index = 0; index < fields.length && result !== undefined; index++) {
        var field = fields[index];

        if (index === fields.length - 1) {
          result[field] = val;
        } else {
          if (_.isEmpty(result[field]) || !_.isObject(result[field])) {
            result[field] = {};
          }

          result = result[field];
        }
      }
    }

    function _createObject(custom_schema, data) {
      var newObj = {};

      Object.keys(custom_schema).forEach(function (key) {
        var schemaKey = custom_schema[key];
        _stringToObject(schemaKey, data[key], newObj);
      });

      return newObj;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('msUtils', msUtils);

  /** @ngInject */
  function msUtils($window, moment, $filter, _) {

    // Private variables
    var mobileDetect = new MobileDetect($window.navigator.userAgent);
    var browserInfo = null;

    var service = {
      getItemById: getItemById,
      exists: exists,
      detectBrowser: detectBrowser,
      uuidGenerator: uuidGenerator,
      isUuidV4: isUuidV4,
      guidGenerator: guidGenerator,
      shortGuidGenerator: shortGuidGenerator,
      isMobile: isMobile,
      toggleInArray: toggleInArray,
      qStringify: qStringify,
      toStringCompare: toStringCompare,
      secondsSinceEpoch: secondsSinceEpoch,
      formatAddress: formatAddress,
      clearEmptyContacts: clearEmptyContacts,
      loadListIds: loadListIds,
      sortCompare: sortCompare,
      slugify: slugify,
      generateRandomPassword: generateRandomPassword,
      leftPad: leftPad,
      isFileTypeImage: isFileTypeImage,
      isFileTypeVideo: isFileTypeVideo,
      getIconByFileType: getIconByFileType,
      similarity: similarity,
      removeAccents: removeAccents,
      removeArrayDuplicates: removeArrayDuplicates,
      pagination: pagination,
      getConfiguration: getConfiguration,
      checkCreateEquipmentErrors: checkCreateEquipmentErrors,
      checkOrderIdentifierHashErrors: checkOrderIdentifierHashErrors,
      textSanitizer: textSanitizer,
      getCorporateAccountUuidFromCustomer: getCorporateAccountUuidFromCustomer,
      getCorporateAccountUuidFromService: getCorporateAccountUuidFromService,
    };

    return service;

    function getItemById(array, value) {
      return array.filter(function (item) {
        return item.id == value;
      })[0];
    }

    function checkCreateEquipmentErrors(customer, account) {

      var featureDisableCreateEquipment = getConfiguration('featureDisableCreateEquipment', [
        customer && customer.metadata,
      ]);

      var moduleEquipmentManagementEnabled = getConfiguration('moduleEquipmentManagementEnabled', [
        account && account.configuration
      ]);

      var isCorporateCustomer = !!(customer && customer.metadata && customer.metadata.integration === 'corporate');

      if (isCorporateCustomer) {
        return {
          equipmentManagementModuleRequiredValid: true,
          createEquipmentDisabledByCorporateValid: !featureDisableCreateEquipment
        };
      }

      return {
        equipmentManagementModuleRequiredValid: !!moduleEquipmentManagementEnabled,
        createEquipmentDisabledByCorporateValid: true
      };
    }

    function checkOrderIdentifierHashErrors(identifier) {
      var hashesAtStart = /^#+/;
      var hashesAtEnd = /#+$/;

      var containsHashAtMiddle = String(identifier || '')
        .trim()
        .replace(hashesAtStart, '')
        .replace(hashesAtEnd, '')
        .indexOf('#') >= 0;

      return {
        identifierHashValid: !containsHashAtMiddle
      };
    }

    function sortCompare(a, b) {
      if (a === null && b !== null) { return +1; }
      if (a !== null && b === null) { return -1; }
      if (a > b) { return +1; }
      if (a < b) { return -1; }
      return 0;
    }

    function slugify(string) {
      if (!string) return "";
      var slug = string.toLowerCase().trim(); // make lower case and trim
      slug = slug.replace(/[^a-z0-9\s-]/g, ' ');  // replace invalid chars with spaces
      slug = slug.replace(/[\s-]+/g, '-'); // replace multiple spaces or hyphens with a single hyphen
      return slug;
    }

    function leftPad(value, totalWidth, paddingChar) {
      var length = totalWidth - value.toString().length + 1;
      return Array(length).join(paddingChar || '0') + value;
    }

    function loadListIds(list, propertyName, customValue) {

      var items = [];

      if (customValue) {
        items.push(customValue);
      }

      list.forEach(function (item) {
        item.name = item[propertyName];
        items.push(item);
      });

      return items;
    }

    function clearEmptyContacts(contacts) {
      if (!_.isEmpty(contacts)) {
        if (contacts.emails && contacts.emails.length) {
          contacts.emails.forEach(function (email) {
            if (!email.address) {
              contacts.emails.splice(_.indexOf(contacts.emails, email), 1);
            }
          });
        } else {
          contacts.emails = [];
        }

        if (contacts.phones && contacts.phones.length) {
          contacts.phones.forEach(function (phone) {
            if (!phone.number) {
              contacts.phones.splice(_.indexOf(contacts.phones, phone), 1);
            }
          });
        } else {
          contacts.phones = [];
        }

        return contacts;
      } else {
        return {
          phones: [],
          emails: []
        };
      }
    }

    function formatAddress(address) {
      if (address) {
        var addressValue = '';
        if (address.street) addressValue += address.street + ', ';
        if (address.number) addressValue += address.number + ' - ';
        if (address.complement) addressValue += address.complement + ' - ';
        if (address.neighborhood) addressValue += address.neighborhood + ', ';
        if (address.city) addressValue += address.city + ' - ';
        if (address.state) addressValue += address.state + ', ';
        if (address.zipCode) addressValue += $filter('brCep')(address.zipCode);
        if (address.postalCode) addressValue += $filter('brCep')(address.postalCode);
        addressValue = addressValue.trim();
        if (addressValue.charAt(addressValue.length - 1) === '-' || addressValue.charAt(addressValue.length - 1) === ',') {
          addressValue = addressValue.slice(0, addressValue.length - 1);
        }
        return addressValue;
      }
      return '';
    }

    function secondsSinceEpoch(date) {
      if (date) {
        var ticks = moment(date).toDate().getTime();
        return Math.floor(ticks / 1000);
      }
      return null;
    }

    function qStringify(obj) {

      return obj ? Object.keys(obj).sort().map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return '';
        }

        if (val === '') {
          return '';
        }

        if (val === null) {
          return encodeURIComponent(key);
        }

        if (Array.isArray(val)) {
          var result = [];

          val.slice().forEach(function (val2) {
            if (val2 !== null && val2 !== undefined) {
              result.push(encodeURIComponent(val2));
            }
          });

          if (result.length > 0) { return encodeURIComponent(key) + '=' + result.join(','); }
          else { return ''; }
        }

        return encodeURIComponent(key) + '=' + encodeURIComponent(val);

      }).filter(function (x) {
        return x.length > 0;
      }).join('&') : '';
    }

    function toStringCompare(str) {

      var defaultDiacriticsRemovalMap = [
        {
          'base': 'A',
          'letters': '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        { 'base': 'AA', 'letters': '\uA732' },
        { 'base': 'AE', 'letters': '\u00C6\u01FC\u01E2' },
        { 'base': 'AO', 'letters': '\uA734' },
        { 'base': 'AU', 'letters': '\uA736' },
        { 'base': 'AV', 'letters': '\uA738\uA73A' },
        { 'base': 'AY', 'letters': '\uA73C' },
        { 'base': 'B', 'letters': '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' },
        { 'base': 'C', 'letters': '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E' },
        {
          'base': 'D',
          'letters': '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        { 'base': 'DZ', 'letters': '\u01F1\u01C4' },
        { 'base': 'Dz', 'letters': '\u01F2\u01C5' },
        {
          'base': 'E',
          'letters': '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        { 'base': 'F', 'letters': '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B' },
        {
          'base': 'G',
          'letters': '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
          'base': 'H',
          'letters': '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
          'base': 'I',
          'letters': '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        { 'base': 'J', 'letters': '\u004A\u24BF\uFF2A\u0134\u0248' },
        {
          'base': 'K',
          'letters': '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
          'base': 'L',
          'letters': '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        { 'base': 'LJ', 'letters': '\u01C7' },
        { 'base': 'Lj', 'letters': '\u01C8' },
        { 'base': 'M', 'letters': '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' },
        {
          'base': 'N',
          'letters': '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        { 'base': 'NJ', 'letters': '\u01CA' },
        { 'base': 'Nj', 'letters': '\u01CB' },
        {
          'base': 'O',
          'letters': '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        { 'base': 'OI', 'letters': '\u01A2' },
        { 'base': 'OO', 'letters': '\uA74E' },
        { 'base': 'OU', 'letters': '\u0222' },
        { 'base': 'OE', 'letters': '\u008C\u0152' },
        { 'base': 'oe', 'letters': '\u009C\u0153' },
        { 'base': 'P', 'letters': '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' },
        { 'base': 'Q', 'letters': '\u0051\u24C6\uFF31\uA756\uA758\u024A' },
        {
          'base': 'R',
          'letters': '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
          'base': 'S',
          'letters': '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
          'base': 'T',
          'letters': '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        { 'base': 'TZ', 'letters': '\uA728' },
        {
          'base': 'U',
          'letters': '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        { 'base': 'V', 'letters': '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' },
        { 'base': 'VY', 'letters': '\uA760' },
        { 'base': 'W', 'letters': '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' },
        { 'base': 'X', 'letters': '\u0058\u24CD\uFF38\u1E8A\u1E8C' },
        {
          'base': 'Y',
          'letters': '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
          'base': 'Z',
          'letters': '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
          'base': 'a',
          'letters': '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        { 'base': 'aa', 'letters': '\uA733' },
        { 'base': 'ae', 'letters': '\u00E6\u01FD\u01E3' },
        { 'base': 'ao', 'letters': '\uA735' },
        { 'base': 'au', 'letters': '\uA737' },
        { 'base': 'av', 'letters': '\uA739\uA73B' },
        { 'base': 'ay', 'letters': '\uA73D' },
        { 'base': 'b', 'letters': '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' },
        {
          'base': 'c',
          'letters': '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
          'base': 'd',
          'letters': '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        { 'base': 'dz', 'letters': '\u01F3\u01C6' },
        {
          'base': 'e',
          'letters': '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        { 'base': 'f', 'letters': '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C' },
        {
          'base': 'g',
          'letters': '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
          'base': 'h',
          'letters': '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        { 'base': 'hv', 'letters': '\u0195' },
        {
          'base': 'i',
          'letters': '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        { 'base': 'j', 'letters': '\u006A\u24D9\uFF4A\u0135\u01F0\u0249' },
        {
          'base': 'k',
          'letters': '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
          'base': 'l',
          'letters': '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        { 'base': 'lj', 'letters': '\u01C9' },
        { 'base': 'm', 'letters': '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' },
        {
          'base': 'n',
          'letters': '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        { 'base': 'nj', 'letters': '\u01CC' },
        {
          'base': 'o',
          'letters': '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        { 'base': 'oi', 'letters': '\u01A3' },
        { 'base': 'ou', 'letters': '\u0223' },
        { 'base': 'oo', 'letters': '\uA74F' },
        { 'base': 'p', 'letters': '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' },
        { 'base': 'q', 'letters': '\u0071\u24E0\uFF51\u024B\uA757\uA759' },
        {
          'base': 'r',
          'letters': '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
          'base': 's',
          'letters': '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
          'base': 't',
          'letters': '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        { 'base': 'tz', 'letters': '\uA729' },
        {
          'base': 'u',
          'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        { 'base': 'v', 'letters': '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' },
        { 'base': 'vy', 'letters': '\uA761' },
        { 'base': 'w', 'letters': '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' },
        { 'base': 'x', 'letters': '\u0078\u24E7\uFF58\u1E8B\u1E8D' },
        {
          'base': 'y',
          'letters': '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
          'base': 'z',
          'letters': '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
      ];

      var diacriticsMap = {};
      for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
        var letters = defaultDiacriticsRemovalMap[i].letters;
        for (var j = 0; j < letters.length; j++) {
          diacriticsMap[letters[j]] = defaultDiacriticsRemovalMap[i].base;
        }
      }

      // "what?" version ... http://jsperf.com/diacritics/12
      function removeDiacritics(str) {
        return str.replace(/[^\u0000-\u007E]/g, function (a) {
          return diacriticsMap[a] || a;
        });
      }

      str = removeDiacritics(str);
      str = str.toLowerCase();
      return str;
    }

    /**
     * Check if item exists in a list
     *
     * @param item
     * @param list
     * @returns {boolean}
     */
    function exists(item, list) {
      if (list) {
        return list.indexOf(item) > -1;
      } else {
        return false;
      }
    }

    /**
     * Returns browser information
     * from user agent data
     *
     * Found at http://www.quirksmode.org/js/detect.html
     * but modified and updated to fit for our needs
     */
    function detectBrowser() {
      // If we already tested, do not test again
      if (browserInfo) {
        return browserInfo;
      }

      var browserData = [
        {
          string: $window.navigator.userAgent,
          subString: 'Edge',
          versionSearch: 'Edge',
          identity: 'Edge'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Chrome',
          identity: 'Chrome'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'OmniWeb',
          versionSearch: 'OmniWeb/',
          identity: 'OmniWeb'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Apple',
          versionSearch: 'Version',
          identity: 'Safari'
        },
        {
          prop: $window.opera,
          identity: 'Opera'
        },
        {
          string: $window.navigator.vendor,
          subString: 'iCab',
          identity: 'iCab'
        },
        {
          string: $window.navigator.vendor,
          subString: 'KDE',
          identity: 'Konqueror'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Firefox',
          identity: 'Firefox'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Camino',
          identity: 'Camino'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Netscape',
          identity: 'Netscape'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'MSIE',
          identity: 'Explorer',
          versionSearch: 'MSIE'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Trident/7',
          identity: 'Explorer',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Gecko',
          identity: 'Mozilla',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Mozilla',
          identity: 'Netscape',
          versionSearch: 'Mozilla'
        }
      ];

      var osData = [
        {
          string: $window.navigator.platform,
          subString: 'Win',
          identity: 'Windows'
        },
        {
          string: $window.navigator.platform,
          subString: 'Mac',
          identity: 'Mac'
        },
        {
          string: $window.navigator.platform,
          subString: 'Linux',
          identity: 'Linux'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPhone',
          identity: 'iPhone'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPod',
          identity: 'iPod'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPad',
          identity: 'iPad'
        },
        {
          string: $window.navigator.platform,
          subString: 'Android',
          identity: 'Android'
        }
      ];

      var versionSearchString = '';

      function searchString(data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;

          versionSearchString = data[i].versionSearch || data[i].identity;

          if (dataString) {
            if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;

            }
          }
          else if (dataProp) {
            return data[i].identity;
          }
        }
      }

      function searchVersion(dataString) {
        var index = dataString.indexOf(versionSearchString);

        if (index === -1) {
          return;
        }

        return parseInt(dataString.substring(index + versionSearchString.length + 1));
      }

      var browser = searchString(browserData) || 'unknown-browser';
      var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
      var os = searchString(osData) || 'unknown-os';

      // Prepare and store the object
      browser = browser.toLowerCase();
      version = browser + '-' + version;
      os = os.toLowerCase();

      browserInfo = {
        browser: browser,
        version: version,
        os: os
      };

      return browserInfo;
    }

    function uuidGenerator() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    function isUuidV4(uuid) {
      if (!uuid) { return false; }
      var uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return uuidPattern.test(uuid);
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function guidGenerator() {
      var S4 = function () {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
      };
      return (S4() + S4() + S4() + S4() + S4() + S4());
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function shortGuidGenerator() {
      var S4 = function () {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
      };
      return (S4());
    }

    /**
     * Return if current device is a
     * mobile device or not
     */
    function isMobile() {
      return mobileDetect.mobile();
    }

    /**
     * Toggle in array (push or splice)
     *
     * @param item
     * @param array
     */
    function toggleInArray(item, array) {
      if (array.indexOf(item) === -1) {
        array.push(item);
      }
      else {
        array.splice(array.indexOf(item), 1);
      }
    }

    function generateRandomPassword() {
      var password = '';
      var letters = "abcdefghijklmnopqrstuvwxyz";
      var numbers = "0123456789";
      var specialChars = "!@#_%&][{}";

      password += letters.charAt(Math.floor(Math.random() * letters.length));
      password += letters.charAt(Math.floor(Math.random() * letters.length));
      password += letters.charAt(Math.floor(Math.random() * letters.length));
      password += letters.charAt(Math.floor(Math.random() * letters.length)).toUpperCase();
      password += letters.charAt(Math.floor(Math.random() * letters.length)).toUpperCase();
      password += numbers.charAt(Math.floor(Math.random() * numbers.length));
      password += numbers.charAt(Math.floor(Math.random() * numbers.length));
      password += specialChars.charAt(Math.floor(Math.random() * specialChars.length));

      return password.split('').sort(function () {
        return 0.5 - Math.random();
      }).join('');
    }

    function isFileTypeImage(file) {
      if (file.type.indexOf('image/') >= 0 || file.type.indexOf('signature') >= 0) {
        return true;
      }
      return false;
    }

    function isFileTypeVideo(file) {
      if (file.type.indexOf('video/') >= 0) {
        return true;
      }
      return false;
    }

    function getIconByFileType(fileType) {

      if (fileType === 'application/pdf') {
        return 'icon-file-pdf';
      }

      if (fileType === 'application/msword') {
        return 'icon-file-word';
      }

      if (fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        return 'icon-file-word';
      }

      if (fileType === 'application/vnd.ms-excel') {
        return 'icon-file-excel';
      }

      if (fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        return 'icon-file-excel';
      }

      if (fileType === 'application/vnd.ms-powerpoint') {
        return 'icon-file-powerpoint';
      }

      if (fileType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
        return 'icon-file-powerpoint';
      }

      if (fileType === 'text/plain') {
        return 'icon-file-document';
      }

      if (fileType === 'text/csv') {
        return 'icon-file-delimited';
      }

      if (fileType === 'application/vnd.google-earth.kml+xml') {
        return 'icon-google-maps';
      }

      if (fileType.includes('video')) {
        return 'icon-file-video';
      }

      return 'icon-file';
    }

    function similarityEditDistance(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();

      var costs = [];
      for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
          if (i == 0) { costs[j] = j; }
          else {
            if (j > 0) {
              var newValue = costs[j - 1];
              if (s1.charAt(i - 1) != s2.charAt(j - 1)) {
                newValue = Math.min(Math.min(newValue, lastValue),
                  costs[j]) + 1;
              }
              costs[j - 1] = lastValue;
              lastValue = newValue;
            }
          }
        }
        if (i > 0) { costs[s2.length] = lastValue; }
      }
      return costs[s2.length];
    }

    function similarity(s1, s2) {
      var longer = s1;
      var shorter = s2;
      if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
      }
      var longerLength = longer.length;
      if (longerLength == 0) {
        return 1.0;
      }
      return (longerLength - similarityEditDistance(longer, shorter)) / parseFloat(longerLength);
    }

    function removeAccents(string) {
      var mapAccents = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g
      };

      for (var letter in mapAccents) {
        var regularExpression = mapAccents[letter];
        string = string.replace(regularExpression, letter);
      }
      return string;
    }

    function removeArrayDuplicates(array) {
      var newArray = array.filter(function (value, index) {
        return array.indexOf(value) === index;
      });
      return newArray;
    }

    function pagination(config) {
      var totalPages = Math.ceil(config.totalItems / config.perPage);
      return {
        index: config.index >= 0 ? config.index : 0,
        perPage: config.perPage || 10,
        totalPages: totalPages || 1,
        totalItems: config.totalItems
      };
    }

    function getConfiguration(propertyName, entities) {
      var i = 0;

      for (i = 0; i < entities.length; i++) {
        var entity = entities[i];

        if (entity && entity[propertyName] !== undefined) {
          return entity[propertyName];
        }
      }

      return undefined;
    }

    function textSanitizer(text) {
      return text.replace(/&quot;?/g, '"')
        .replace(/&apos;?/g, "'")
        .replace(/&amp;?/g, '&')
        .replace(/&lt;?/g, '<')
        .replace(/&gt;?/g, '>');
    }

    function getCorporateAccountUuidFromCustomer(customer) {
      try {
        return customer.metadata.sammathnaur.account.uuid;
      } catch (ignored) {
        return null;
      }
    }

    function getCorporateAccountUuidFromService(service) {
      try {
        return service.metadata.sammathnaur.account.uuid;
      } catch (ignored) {
        return null;
      }
    }
  }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.core')
        .factory('MessageDialog', MessageDialog);

    /** @ngInject */
    function MessageDialog($mdDialog, $mdToast, $document) {

        return {
            showAlert: showAlert,
            showToast: showToast,
            showModal: showModal
        };

        function showAlert(options) {

            options.okText = options.okText || 'OK';

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(document.querySelector('.palantir-modal-container') || angular.element(document.body))
                    .clickOutsideToClose(true)
                    .title(options.title)
                    .ok(options.okText)
                    .textContent(options.message)
            );
        }

        function showToast(options) {

            options.hideDelay = options.hideDelay || 3000;

            $mdToast.show(
                $mdToast.simple()
                    .textContent(options.message)
                    .hideDelay(options.hideDelay)
            );
        }

        function showModal(ev, options, callback) {
            $mdDialog.show({
                controller: options.controller,
                controllerAs: 'vm',
                templateUrl: options.templateUrl,
                parent: document.querySelector('.palantir-modal-container') || angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: options.locals
            }).then(function (reload) {
                if (callback) {
                    callback(reload);
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('$localStorage', function ($window) {
            return {
                set: set,
                get: get,
                setObject: setObject,
                getObject: getObject,
                remove: remove
            };

            function set(key, value) {
                $window.localStorage[key] = value;
            }

            function get(key, defaultValue) {
                return $window.localStorage[key] || defaultValue;
            }

            function setObject(key, value) {
                $window.localStorage[key] = JSON.stringify(value);
            }

            function getObject(key) {
                return JSON.parse($window.localStorage[key] || '{}');
            }

            function remove(key) {
                $window.localStorage.removeItem(key);
            }
        });
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('legendOptions', legendOptions);

    /** @ngInject */
    function legendOptions($translate) {
        return function (accountName, position) {
            var labels = [
              $translate.instant("CONTROL_PANEL.VIEWS.MAP.TASK.SCHEDULED"),
              $translate.instant("CONTROL_PANEL.VIEWS.MAP.TASK.ON_ROUTE"),
              $translate.instant("CONTROL_PANEL.VIEWS.MAP.TASK.PROGRESS"),
              $translate.instant("CONTROL_PANEL.VIEWS.MAP.TASK.COMPLETED"),
              $translate.instant("CONTROL_PANEL.VIEWS.MAP.TASK.CANCELED"),
              $translate.instant("CONTROL_PANEL.VIEWS.MAP.TASK.DISABLED"),
              accountName,
              $translate.instant("CONTROL_PANEL.VIEWS.MAP.TASK.CONNECTION_PATH"),
            ];

            var colors = ['#42A5F5', '#607d8b', '#FFA726', '#388E3C', '#AB47BC', '#D32F2F', '#1E8EE8', '#d9c302'];

            return {
                position: position || 'bottomleft',
                colors: colors,
                labels: labels
            };
        };
    }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('integrationsShowError', integrationsShowError);

  /** @ngInject */
  function integrationsShowError(FcToastService) {

    return {
      showToast: showToast
    };

    /**
     * @param {string} errCode
     * @param {Object} errMessages
     */
    function showToast(errCode, errMessages) {
      FcToastService.addWarning({
        hideDelay: 6000,
        position: 'BOTTOM LEFT',
        title: errMessages.errors.title,
        content: errMessages.errors[errCode] ? errMessages.errors[errCode].message : errMessages.errors.message,
        customClass: 'connection-error-toast',
        iconPath: 'assets/icons/icon-yellow-alert.svg',
        errorType: 'integrationErrors'
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('IntegrationsService', IntegrationsService);

  /** @ngInject */
  function IntegrationsService($rootScope, $localStorage, shelobApi, EnvironmentConfig, _) {
    var key = 'integrations';
    var defaultData = {
      omie: false,
      contaAzul: false
    };

    return {
      get: get,
      reset: reset,
      getAll: getAll,
      activate: activate,
      initialize: initialize,
      deactivate: deactivate
    };

    function initialize() {
      var isProduction = EnvironmentConfig.environmentName === 'production';
      var isPreview = EnvironmentConfig.environmentName === 'preview';
      var isHomolog = EnvironmentConfig.environmentName === 'homolog';

      if (!isProduction && !isPreview && !isHomolog) {
        return Promise.resolve();
      }

      return shelobApi.getIntegrations().then(function (integrations) {
        if (integrations && !_.isEmpty(integrations)) {
          integrations.contaAzul = integrations['conta-azul'];
          delete integrations['conta-azul'];
          return $localStorage.setObject(key, integrations);
        }
        $localStorage.setObject(key, defaultData);
      }).catch(function () {
        $localStorage.setObject(key, defaultData);
      }).finally(function () {
        $rootScope.$broadcast('integrations:updated');
      });
    }

    function get(name) {
      var integrations = $localStorage.getObject(key);

      if (!integrations || _.isEmpty(integrations)) {
        integrations = angular.copy(defaultData);
        $localStorage.setObject(key, integrations);
      }

      if (name === 'conta-azul') { name = 'contaAzul'; }
      return integrations[name];
    }

    function getAll() {
      var integrations = $localStorage.getObject(key);

      if (!integrations || _.isEmpty(integrations)) {
        integrations = angular.copy(defaultData);
        $localStorage.setObject(key, integrations);
      }

      return integrations;
    }

    function activate(name, data) {
      data.apiName = name;

      return shelobApi.activateIntegration(data).then(function () {
        var integrations = $localStorage.getObject(key);

        if (!integrations || _.isEmpty(integrations)) {
          integrations = angular.copy(defaultData);
        }

        if (name === 'conta-azul') { name = 'contaAzul'; }
        integrations[name] = true;
        $localStorage.setObject(key, integrations);
      });
    }

    function deactivate(name) {
      return shelobApi.deactivateIntegration(name).then(function () {
        var integrations = $localStorage.getObject(key);

        if (!integrations || _.isEmpty(integrations)) {
          integrations = angular.copy(defaultData);
        }

        if (name === 'conta-azul') { name = 'contaAzul'; }
        integrations[name] = false;
        $localStorage.setObject(key, integrations);
      });
    }

    function reset() {
      $localStorage.remove(key);
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('haversine', function () {

            var toRad = function (num) {
                return num * Math.PI / 180;
            };

            return function (start, end, options) {
                options   = options || {};

                var radii = {
                    km:    6371,
                    mile:  3960,
                    meter: 6371000
                };

                var R = radii.km;
                if (options.unit && radii[options.unit]) {
                    R = radii[options.unit];
                }

                var dLat = toRad(end.latitude - start.latitude);
                var dLon = toRad(end.longitude - start.longitude);
                var lat1 = toRad(start.latitude);
                var lat2 = toRad(end.latitude);

                var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                    Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

                if (options.threshold) {
                    return options.threshold > (R * c);
                }

                return R * c;
            };

        });

})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('hasher', hasher);

    function hasher(flattenObject) {

        return {
            sha1: sha1,
            sha1ButIgnoreNGHashKey: sha1ButIgnoreNGHashKey
        };

        function sha1ButIgnoreNGHashKey(obj) {
            var flattedObject = flattenObject.flatten(obj);
            Object.keys(flattedObject).forEach(function (key) {
                if (key.indexOf('$$hashKey') > -1) {
                    delete flattedObject[key];
                }
            });
            return sha1(flattedObject);
        }

        function sha1(obj) {
            var objectJson = JSON.stringify(obj);
            var sha1 = binToHex(coreFunction(fillString(objectJson)));
            return sha1;
        }

        function fillString(str) {
            var blockAmount = ((str.length + 8) >> 6) + 1,
                blocks = [],
                i;

            for (i = 0; i < blockAmount * 16; i++) {
                blocks[i] = 0;
            }
            for (i = 0; i < str.length; i++) {
                blocks[i >> 2] |= str.charCodeAt(i) << (24 - (i & 3) * 8);
            }
            blocks[i >> 2] |= 0x80 << (24 - (i & 3) * 8);
            blocks[blockAmount * 16 - 1] = str.length * 8;

            return blocks;
        }

        function binToHex(binArray) {
            var hexString = "0123456789abcdef",
                str = "",
                i;

            for (i = 0; i < binArray.length * 4; i++) {
                str += hexString.charAt((binArray[i >> 2] >> ((3 - i % 4) * 8 + 4)) & 0xF) +
                    hexString.charAt((binArray[i >> 2] >> ((3 - i % 4) * 8  )) & 0xF);
            }

            return str;
        }

        function coreFunction(blockArray) {
            var w = [],
                a = 0x67452301,
                b = 0xEFCDAB89,
                c = 0x98BADCFE,
                d = 0x10325476,
                e = 0xC3D2E1F0,
                olda,
                oldb,
                oldc,
                oldd,
                olde,
                t,
                i,
                j;

            for (i = 0; i < blockArray.length; i += 16) {  //每次处理512位 16*32
                olda = a;
                oldb = b;
                oldc = c;
                oldd = d;
                olde = e;

                for (j = 0; j < 80; j++) {  //对每个512位进行80步操作
                    if (j < 16) {
                        w[j] = blockArray[i + j];
                    } else {
                        w[j] = cyclicShift(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
                    }
                    t = modPlus(modPlus(cyclicShift(a, 5), ft(j, b, c, d)), modPlus(modPlus(e, w[j]), kt(j)));
                    e = d;
                    d = c;
                    c = cyclicShift(b, 30);
                    b = a;
                    a = t;
                }

                a = modPlus(a, olda);
                b = modPlus(b, oldb);
                c = modPlus(c, oldc);
                d = modPlus(d, oldd);
                e = modPlus(e, olde);
            }

            return [a, b, c, d, e];
        }

        function ft(t, b, c, d) {
            if (t < 20) {
                return (b & c) | ((~b) & d);
            } else if (t < 40) {
                return b ^ c ^ d;
            } else if (t < 60) {
                return (b & c) | (b & d) | (c & d);
            } else {
                return b ^ c ^ d;
            }
        }

        function kt(t) {
            return (t < 20) ? 0x5A827999 :
                (t < 40) ? 0x6ED9EBA1 :
                    (t < 60) ? 0x8F1BBCDC : 0xCA62C1D6;
        }

        function modPlus(x, y) {
            var low = (x & 0xFFFF) + (y & 0xFFFF),
                high = (x >> 16) + (y >> 16) + (low >> 16);

            return (high << 16) | (low & 0xFFFF);
        }

        function cyclicShift(num, k) {
            return (num << k) | (num >>> (32 - k));
        }
    }

}).call(this);
(function () {
    'use strict';

    angular.module('app.core')
        .factory('geoCoder', geoCoder);

    /** @ngInject */
    function geoCoder(_, geoCoderApi, accountCache) {

        return {
            getByAddressString: getByAddressString,
            getByAddressObject: getByAddressObject
        };

        function getByAddressObject(addressObject) {
            var address = addressObject.street;
            address += ', ' + addressObject.number;
            if (addressObject.neighborhood) {
                address += ' - ' + addressObject.neighborhood;
            }
            if (addressObject.city) {
                address += ', ' + addressObject.city;
            }
            address += ' - ' + addressObject.state;
            address += ', ' + (addressObject.cep || addressObject.zipCode || addressObject.postalCode);

            return geoCoderApi.search({ 'q': address }).then(function (result) {

                if (result.status === 'OK' && result.results.length) {

                    var location = _.first(result.results).geometry.location;
                    var locationResult = { lat: null, lng: null };
                    locationResult.lat = location.lat.toFixed(6);
                    locationResult.lng = location.lng.toFixed(6);

                    return locationResult;

                } else {

                    var address2 = addressObject.street;
                    address2 += ', ' + addressObject.number;
                    if (addressObject.city) {
                        address2 += ', ' + addressObject.city;
                    }
                    address2 += ' - ' + addressObject.state;
                    address2 += ', ' + (addressObject.cep || addressObject.zipCode || addressObject.postalCode);

                    return geoCoderApi.search({ 'q': address2 }).then(function (result) {

                        if (result.status === 'OK' && result.results.length) {
                            var location = _.first(result.results).geometry.location;
                            var locationResult = { lat: null, lng: null };
                            locationResult.lat = location.lat.toFixed(6);
                            locationResult.lng = location.lng.toFixed(6);
                            return locationResult;

                        } else {

                            var address3 = (addressObject.cep || addressObject.zipCode || addressObject.postalCode);
                            address3 += ' - ' + addressObject.street;
                            address3 += ', ' + addressObject.number;
                            if (addressObject.city) {
                                address3 += ', ' + addressObject.city;
                            }

                            return geoCoderApi.search({ 'q': address3 }).then(function (result) {

                                if (result.status === 'OK' && result.results.length) {
                                    var location = _.first(result.results).geometry.location;
                                    var locationResult = { lat: null, lng: null };
                                    locationResult.lat = location.lat.toFixed(6);
                                    locationResult.lng = location.lng.toFixed(6);
                                    return locationResult;

                                } else {

                                    var address4 = (addressObject.cep || addressObject.zipCode || addressObject.postalCode);
                                    address4 += ' - ' + addressObject.street;
                                    address3 += ', ' + addressObject.number;

                                    return geoCoderApi.search({ 'q': address4 }).then(function (result) {

                                        if (result.status === 'OK' && result.results.length) {
                                            var location = _.first(result.results).geometry.location;
                                            var locationResult = { lat: null, lng: null };
                                            locationResult.lat = location.lat.toFixed(6);
                                            locationResult.lng = location.lng.toFixed(6);
                                            return locationResult;
                                        } else {

                                            var address5 = 'CEP:' + (addressObject.cep || addressObject.zipCode || addressObject.postalCode) + ', Brasil';

                                            return geoCoderApi.search({ 'q': address5 }).then(function (result) {

                                                if (result.status === 'OK' && result.results.length) {
                                                    var location = _.first(result.results).geometry.location;
                                                    var locationResult = { lat: null, lng: null };
                                                    locationResult.lat = location.lat.toFixed(6);
                                                    locationResult.lng = location.lng.toFixed(6);
                                                    return locationResult;
                                                }

                                                return null;
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }

        function getByAddressString(address, options) {
            var searchParams = { 'q': address };
            var global = (options && options.global) || false;

            var account = accountCache.getAccount();
            if (account && account.configuration) {
                if (account.configuration.addressSearchRestrictionCountry && !global) {
                    searchParams.components = "country:" + account.configuration.addressSearchRestrictionCountry;
                }
            }

            return geoCoderApi.search(searchParams).then(function (result) {
                var results = [];

                if (result.status === 'OK')  {
                    _.each(result.results, function (result) {
                        if (result.geometry && result.geometry.location) {
                            var currentLocation = result.geometry.location;
                            var currentLocationResult = {
                                lat: parseFloat(currentLocation.lat.toFixed(6)),
                                lng: parseFloat(currentLocation.lng.toFixed(6)),
                                formattedAddress: result['formatted_address']
                            };

                            currentLocationResult.zipCode = getAddressComponent(result.address_components, 'postal_code');
                            currentLocationResult.zipCode = currentLocationResult.zipCode ? currentLocationResult.zipCode.replace('-', '') : currentLocationResult.zipCode;
                            currentLocationResult.state = getAddressComponent(result.address_components, 'administrative_area_level_1');

                            try {
                                var country = getAddressComponent(result.address_components, 'country');
                                var isUSPostalCode = country === 'United States' || country === 'Estados Unidos';
                                if (isUSPostalCode) {
                                    currentLocationResult.city = getAddressComponent(result.address_components, 'locality');
                                } else {
                                    currentLocationResult.city = getAddressComponent(result.address_components, 'administrative_area_level_2', 'administrative_area_level_1');
                                }
                            } catch (err) {
                                console.log('geoCoderApi.search', err, result);
                            }

                            currentLocationResult.neighborhood = getAddressComponent(result.address_components, 'sublocality_level_1');
                            currentLocationResult.street = getAddressComponent(result.address_components, 'route', 'administrative_area_level_3');
                            currentLocationResult.number = getAddressComponent(result.address_components, 'street_number');
                            currentLocationResult.complement = getAddressComponent(result.address_components, '');
                            results.push(currentLocationResult);
                        }
                    });
                }

                return results;

            });

        }

        function getAddressComponent(components, type1, type2) {
            var matchedComponent = components.find(function (component) {
                return _.includes(component.types, type1);
            });

            if(!matchedComponent && type2) {
                matchedComponent = components.find(function (component) {
                    return _.includes(component.types, type2);
                });
            }

            if(matchedComponent) {
                return matchedComponent.long_name;
            } else {
                return null;
            }
        }
    }
})();
(function () {
  'use strict';

  angular.module('app.core')
    .factory('focus', focus);

  /** @ngInject */
  function focus($timeout, $window) {
    return function (id) {
      $timeout(function () {
        var element = $window.document.getElementById(id);
        if(element) {
          element.focus();
        }
      });
    };
  }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('flattenObject', flattenObject);

    function flattenObject() {

        return {
            flatten: flatten
        };

        function flatten(ob) {

            return Object.keys(ob).reduce(function (toReturn, k) {

                if (Object.prototype.toString.call(ob[k]) === '[object Date]') {
                    toReturn[k] = ob[k].toString();
                }
                else if ((typeof ob[k]) === 'object' && ob[k]) {
                    var flatObject = flatten(ob[k]);
                    Object.keys(flatObject).forEach(function (k2) {
                        toReturn[k + '.' + k2] = flatObject[k2];
                    });
                }
                else {
                    toReturn[k] = ob[k];
                }

                return toReturn;
            }, {});
        }
    }

}).call(this);
(function () {
    'use strict';

    angular.module('app.core')
        .factory('favicoNotification', favicoNotification);

    function favicoNotification() {
        var count = { current: 0, max: 9 };
        var favicons = _.map($('link[rel*="icon"]'), function (favicon) {
            return new Favico({
                animation: 'none',
                element: favicon
            });
        });

        return {
            badge: badge,
            increment: increment,
            decrement: decrement,
            reset: reset
        };

        function badge(total) {
            count.current = total;
            _.forEach(favicons, function (favicon) {
                favicon.badge(count.current > count.max ? count.max + '+' : count.current);
            });
        };

         function increment() {
            ++count.current;
            _.forEach(favicons, function (favicon) {
                favicon.badge(count.current > count.max ? count.max + '+' : count.current);
            });
        };

        function reset() {
            count.current = 0;
            _.forEach(favicons, function (favicon) {
                favicon.reset();
            });
        };

        function decrement() {
            _.forEach(favicons, function (favicon) {
                count.current > 0 ? favicon.badge(--count.current) : favicon.reset();
            });
        };
    }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('ExcelJS', ExcelJS);

    /** @ngInject */
    function ExcelJS(_, XLSX) {

        return {
            read: read,
            create: create,
            toBase64: toBase64
        };

        function create(dataJson, fileName, sheetName) {
            sheetName = sheetName || 'Página 1';
            return new Promise(function (resolve, reject) {
                var workSheet = XLSX.utils.json_to_sheet(dataJson);
                if (!workSheet) { reject(new Error("WorkSheet Not Created!")); }
                var workBook = XLSX.utils.book_new();
                if (!workBook) { reject(new Error("WorkBook Not Created!")); }
                XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
                var blobFile = XLSX.writeFile(workBook, fileName);
                resolve(blobFile);
            });
        }

        function toBase64(excelFile, callback) {
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.readAsDataURL(excelFile);

                reader.onload = function () {
                    callback(true, reader.result);
                    resolve();
                };

                reader.onerror = function (error) {
                    callback(false, error);
                    reject(error);
                };
            });
        }

        function readFile() {
            return (function () {
                var binaryString = arguments[0];
                var fileExtension = arguments[1];
                var options = arguments[2];

                var excelData = [];
                var workBook;
                if (fileExtension === "csv") {
                    workBook = XLSX.read(binaryString, { type: "string" });
                } else {
                    workBook = XLSX.read(binaryString, {
                        type: "binary",
                        raw: false
                    });
                }

                for (var indexSheet = 0; indexSheet < workBook.SheetNames.length; indexSheet++) {
                    var sheetName = workBook.SheetNames[indexSheet];
                    var workSheet = workBook.Sheets[workBook.SheetNames[indexSheet]];
                    var sheetValuesPerArrayLine = XLSX.utils.sheet_to_json(workSheet, {
                        header: 1,
                        raw: false,
                        blankrows: false,
                        defval: null,
                        range: "A1:AZ" + (parseInt((options && options.rowsLimit) || 500) + 1)
                    });

                    if (sheetValuesPerArrayLine && sheetValuesPerArrayLine[0] && sheetValuesPerArrayLine[0].length) {
                        var columns = [];
                        for (var indexColumns = 0; indexColumns < sheetValuesPerArrayLine[0].length; indexColumns++) {
                            if (sheetValuesPerArrayLine[0][indexColumns]) {
                                columns[indexColumns] = { field: sheetValuesPerArrayLine[0][indexColumns] };
                            }
                        }

                        var values = [];
                        for (var indexLine = 1; indexLine < sheetValuesPerArrayLine.length; indexLine++) {
                            values[indexLine - 1] = {};
                            for (var indexValue = 0; indexValue < sheetValuesPerArrayLine[indexLine].length; indexValue++) {
                                if (sheetValuesPerArrayLine[indexLine][indexValue] == null) {
                                    continue;
                                }
                                values[indexLine - 1][sheetValuesPerArrayLine[0][indexValue]] = sheetValuesPerArrayLine[indexLine][indexValue];
                            }
                        }

                        excelData.push({
                            sheet: sheetName,
                            data: {
                                columns: columns,
                                values: values
                            },
                            json: sheetValuesPerArrayLine
                        });
                    }
                }

                return excelData;
            })(arguments[0], arguments[1], arguments[2]);
        }

        function read(excelFile, options) {
            var fileExtension = null;
            if (excelFile.name) {
              fileExtension = excelFile.name.split('.').pop().toLowerCase();
            }
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onabort = function () {
                    reject(new Error("File read cancelled"));
                };

                reader.onerror = function (event) {
                    switch (event.target.error.code) {
                        case event.target.error.NOT_FOUND_ERR:
                            reject(new Error("File Not Found!"));
                            break;
                        case event.target.error.NOT_READABLE_ERR:
                            reject(new Error("File is not readable"));
                            break;
                        case event.target.error.ABORT_ERR:
                            break;
                        default:
                            reject(new Error("An error occurred reading this file"));
                    }
                };

                function loadInlineWorker() {
                    var self = this;
                    self.importScripts('https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.16.0/xlsx.full.min.js');
                    self.onmessage = function (event) {
                        var data = JSON.parse(event.data);
                        var result = new Function(data.function)(data.value, data.fileExtension);
                        self.postMessage(result);
                    };
                }

                function getFunctionBody(functionString) {
                    return functionString.slice(functionString.indexOf("{") + 1, functionString.lastIndexOf("}"));
                }

                reader.onload = function (event) {
                    var binaryString = event.target.result;
                    var excelData = [];

                    if (window.Worker && window.Blob && fileExtension) {
                        var functionBody = loadInlineWorker.toString();

                        functionBody = getFunctionBody(functionBody);

                        var blobURL = URL.createObjectURL(new window.Blob([functionBody], {
                            type: 'application/javascript'
                        }));

                        var worker = new window.Worker(blobURL);

                        if (!worker) {
                          return;
                        }

                        worker.postMessage(JSON.stringify({
                            value: binaryString,
                            fileExtension: fileExtension,
                            function: getFunctionBody(readFile.toString())
                        }));

                        worker.addEventListener("message", function (event) {
                            resolve(event.data);
                            worker.terminate();
                        });

                        worker.addEventListener("error", function (error) {
                            excelData = readFile(binaryString, fileExtension, options);
                            resolve(excelData);
                            worker.terminate();
                        });
                    } else {
                        excelData = readFile(binaryString, fileExtension, options);
                        resolve(excelData);
                    }
                };

                if (excelFile && excelFile.target && excelFile.target.files && excelFile.target.files[0]) {
                    excelFile = excelFile.target.files[0];
                }
                if (fileExtension === "csv") {
                    reader.readAsText(excelFile, { encoding: 'utf8' });
                } else {
                    reader.readAsBinaryString(excelFile);
                }
            });
        }
    }

})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('EquipmentPermissionService', EquipmentPermissionService);

  /** @ngInject */
  function EquipmentPermissionService($state, MessageDialog, $translate) {

    return {
      accountHasEquipmentPermission: accountHasEquipmentPermission
    };

    function accountHasEquipmentPermission(configuration) {
      if (!configuration.moduleEquipmentManagementEnabled && !configuration.isCorporateCompany) {
        MessageDialog.showAlert({
          title: $translate.instant("CORE.EQUIPAMENT_PERMISSION.TITLE"),
          message: $translate.instant("CORE.EQUIPAMENT_PERMISSION.MESSAGE")
        });
        $state.go('app.control-panel.gantt');
      }
    }
  }

})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('deadlineStatus', deadlineStatus);

  /** @ngInject */
  function deadlineStatus($translate, _) {
    var allStatus = [{
      name: 'onSchedule',
      description: $translate.instant("CORE.TASKS_DEADLINE_STATUS.ON_SCHEDULE"),
      color: '#135AC0',
      classBgColor: 'deadline-status-on-schedule--background-color',
      classFgColor: 'deadline-status-on-schedule--color'
    },
    {
      name: 'atRisk',
      description: $translate.instant("CORE.TASKS_DEADLINE_STATUS.AT_RISK"),
      color: '#E4771F',
      classBgColor: 'deadline-status-at-risk--background-color',
      classFgColor: 'deadline-status-at-risk--color'
    },
    {
      name: 'outOfSchedule',
      description: $translate.instant("CORE.TASKS_DEADLINE_STATUS.OUT_OF_SCHEDULE"),
      color: '#F85457',
      classBgColor: 'deadline-status-out-of-schedule--background-color',
      classFgColor: 'deadline-status-out-of-schedule--color'
    },
    {
      name: 'completedOutOfSchedule',
      description: $translate.instant("CORE.TASKS_DEADLINE_STATUS.COMPLETED_OUT_OF_SCHEDULE"),
      color: '#F85457',
      classBgColor: 'deadline-status-completed-out-of-schedule--background-color',
      classFgColor: 'deadline-status-completed-out-of-schedule--color'
    },
    {
      name: 'completedOnSchedule',
      description: $translate.instant("CORE.TASKS_DEADLINE_STATUS.COMPLETED_ON_SCHEDULE"),
      color: '#2BB98B',
      classBgColor: 'deadline-status-completed-on-schedule--background-color',
      classFgColor: 'deadline-status-completed-on-schedule--color'
    }, {
      name: 'notApplicable',
      description: $translate.instant("CORE.TASKS_DEADLINE_STATUS.NO_APPLICABLE"),
      color: '#c0c9c6',
      classBgColor: 'deadline-status-not-applicable--background-color',
      classFgColor: 'deadline-status-not-applicable--color'
    }];

    function getAll() {
      return allStatus;
    }

    function getStatus(value) {
      if (!value) {
        return {
          name: 'notApplicable',
          description: $translate.instant("CORE.TASKS_DEADLINE_STATUS.NO_APPLICABLE"),
          color: '#c0c9c6',
          classBgColor: 'deadline-status-not-applicable--background-color',
          classFgColor: 'deadline-status-not-applicable--color'
        };
      }
      var currentStatus = _.filter(allStatus, function (status) {
        return status.name === value;
      });

      return currentStatus.length >= 0 ? currentStatus[0] : {};
    }

    return {
      getAll: getAll,
      getStatus: getStatus
    };

  }

})();


(function () {
  'use strict';

  angular.module('app.core')
  .factory('dateConverter', dateConverter);

  /** @ngInject */
  function dateConverter(moment) {

    //TODO: This has to be replaced :P

    return {
      toTimeValues: toTimeValues,
      toDateTimeStringIgnoreUtc: toDateTimeStringIgnoreUtc,
      toTimeStringIgnoreUtc: toTimeStringIgnoreUtc,
      toDateIgnoreUtc: toDateIgnoreUtc,
      toDateFromDateTime: toDateFromDateTime,
      toStringDateFromDateAndTimeAsString: toStringDateFromDateAndTimeAsString,
      toFormatIgnoreUtc: toFormatIgnoreUtc,
      toDateAndTime: toDateAndTime
    };

    function toStringDateFromDateAndTimeAsString(dateTime, timeAsString) {
      var date = toDateFromDateTime(dateTime);
      var timeValues = toTimeValues(timeAsString);
      date.add(timeValues);
      return moment(date).format();
    }

    function toDateFromDateTime(dateTime) {
      return angular.copy(moment(dateTime).startOf('day'));
    }

    function toDateIgnoreUtc(date) {
      if (date && date.indexOf('Z') !== -1) {
        date = date.replace('Z', '');
      }
      return date;
    }

    function toFormatIgnoreUtc(date, format) {
      return moment(toDateIgnoreUtc(date)).format(format);
    }

    function toTimeStringIgnoreUtc(date) {
      return moment(toDateIgnoreUtc(date)).format('HH:mm');
    }

    function toDateTimeStringIgnoreUtc(date) {
      return moment(toDateIgnoreUtc(date)).toDate();
    }

    function toTimeValues(timeAsString) {

      if (timeAsString.indexOf(':') > -1) {
        return {
          hours: timeAsString.split(':')[0],
          minutes: timeAsString.split(':')[1]
        };
      } else {
        return {
          hours: timeAsString.substring(0, 2),
          minutes: timeAsString.substring(4, 2)
        };
      }
    }

    function toDateAndTime(date, time) {
      var time = toTimeValues(time);
      return moment(date).set({ hour: time.hours, minute: time.minutes });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('CurrencyService', CurrencyService);

  /** @ngInject */
  function CurrencyService(accountCache) {
    var account = accountCache.getAccount();
    var accountConfig = account ? account.configuration : {};
    var currencySymbol = accountConfig.currencySymbol || 'R$';

    var items = [
      { code: 'USD', symbol: '$' },
      { code: 'BRL', symbol: 'R$' },
      { code: 'EUR', symbol: '€' },
      { code: 'CLP', symbol: 'CLP$' },
      { code: 'GTQ', symbol: 'Q' },
      { code: 'MXN', symbol: 'MX$' },
      { code: 'HNL', symbol: 'L' },
      { code: 'PAB', symbol: 'B/.' },
      { code: 'BOB', symbol: 'Bs' },
      { code: 'PYG', symbol: 'Gs' },
      { code: 'PEN', symbol: 'S/' },
      { code: 'DOP', symbol: 'RD$' },
      { code: 'COP', symbol: 'COP$' },
      { code: 'SVC', symbol: 'C$' },
      { code: 'USD', symbol: 'USD$' }
    ];

    function pickCurrentCode() {
      var currentCode = items.filter(function (item) {
        return item.symbol === currencySymbol;
      });

      return currentCode[0].code || 'BRL';
    }

    function getCurrencySymbol(code) {
      var currency = items.filter(function (item) {
        return item.code === code;
      });

      return currency[0].symbol || 'R$';
    }

    return {
      items: items,
      currencySymbol: currencySymbol,
      pickCurrentCode: pickCurrentCode,
      getCurrencySymbol: getCurrencySymbol
    };
  }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('copyProperties', copyProperties);

    /** @ngInject */
    function copyProperties() {
        return function (object, properties, params) {
            return properties.forEach(function (property) {
                if (params[property]) {
                    object[property] = params[property];
                }
            });
        };
    }

})();

(function () {

    angular.module('app.core').directive('compareWith', function () {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=compareWith"
            },
            link: function (scope, element, attributes, ngModel) {

                ngModel.$validators.compareWith = function (modelValue) {
                    return modelValue == scope.otherModelValue;
                };

                scope.$watch("otherModelValue", function () {
                    ngModel.$validate();
                });
            }
        };
    });


})();

(function () {
	'use strict';

	angular.module('app.core')
		.factory('CheckoutService', CheckoutService);

	/** @ngInject */
	function CheckoutService($timeout) {

		return {
			redirectCheckout: redirectCheckout
		};

    function redirectCheckout() {
			$timeout(function () {
				window.location = "https://app.fieldcontrol.com.br/contratacao/";
			}, 3000);
    }
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    //TODO: Usages should be replaced by activity status service

    angular.module('app.core')
        .factory('activityStatusColor', activityStatusColor);

    /** @ngInject */
    function activityStatusColor() {

        var colors = [];
        colors.push('#0054ff');
        colors.push('#e67700');
        colors.push('#12b886');
        colors.push('#b197fc');
        colors.push('#fa5252');

        return function (status) {
            return colors[status];
        };
    }

    //TODO: Should be deleted

})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('activityStatus', activityStatus);

    /** @ngInject */
    function activityStatus($translate) {
        var items = [];
        items.push({
            description: $translate.instant("CORE.TASKS_STATUS.SCHEDULED"),
            propertyDescription: 'description',
            value: '0',
            name: 'scheduled',
            icon: 'icon-clock',
            color: '#105BFB',
            colorClass: 'activity-scheduled-color',
            hasStartTime: false,
            hasCompletedTime: false
        });
        items.push({
            description: 'Em deslocamento',
            propertyDescription: 'onRoute',
            icon: 'icon-truck',
            name: 'on-route',
            value: '5',
            color: '#617D8A',
            colorClass: 'activity-onroute-color',
            hasStartTime: false,
            hasCompletedTime: false
        });
        items.push({
            description: $translate.instant("CORE.TASKS_STATUS.IN_PROGRESS"),
            value: '1',
            name: 'in-progress',
            icon: 'icon-map-marker',
            color: '#E4771F',
            colorClass: 'activity-inprogress-color',
            hasStartTime: true,
            hasCompletedTime: false
        });
        items.push({
            description: $translate.instant("CORE.TASKS_STATUS.COMPLETED"),
            propertyDescription: 'doneDescription',
            icon: 'icon-check',
            name: 'done',
            value: '2',
            color: '#24B787',
            colorClass: 'activity-done-color',
            hasStartTime: true,
            hasCompletedTime: true
        });
        items.push({
            description: $translate.instant("CORE.TASKS_STATUS.CANCELED"),
            propertyDescription: 'canceledDescription',
            icon: 'icon-close',
            name: 'canceled',
            value: '3',
            color: '#C25AB5',
            colorClass: 'activity-canceled-color',
            hasStartTime: true,
            hasCompletedTime: true
        });
        items.push({
            description: $translate.instant("CORE.TASKS_STATUS.PREVENTED"),
            propertyDescription: 'problemDescription',
            icon: 'icon-alert',
            name: 'reported',
            value: '4',
            color: '#F84547',
            colorClass: 'activity-problem-color',
            hasStartTime: true,
            hasCompletedTime: true
        });
        return items;
    }

})();


(function () {
    'use strict';

    angular.module('app.core').factory('ProfitWell', ProfitWell);

    /** @ngInject */
    function ProfitWell(authenticatedUser, profitWellApi, accountsApi, $timeout) {

        var init = false;
        var lock = false;

        return {
            initialize: initialize
        };

        function initialize() {
            if (init || lock) {
                return null;
            }
            lock = true;
            if (authenticatedUser.isAuthenticated() && !authenticatedUser.profile.impersonated) {
                accountsApi.get().then(function (account) {
                    $timeout(function () {
                        try {
                            if (account && account.plan && account.plan.name === 'pro') {
                                profitWellApi.getMe().then(function (profitWellUser) {
                                    if (profitWellUser && profitWellUser.profitWellId) {
                                        profitwell('start', { 'user_id': profitWellUser.profitWellId });
                                        init = true;
                                    }
                                });
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    }, 1000);
                }).finally(function () {
                    lock = false;
                });
            }
        }
    }
})();
(function () {
    'use strict';
    angular.module('app.core')
        .factory('dataTableOptions', dataTableOptions);

    /** @ngInject */
    function dataTableOptions(msUtils, $, moment, DTDefaultOptions, $translate) {

        var sortingPtBrDateExtended = null;

        DTDefaultOptions.setLoadingTemplate('' +
            '<div style="width: 100%; margin-top:30px;">' +
                '<h3 class="text-center">'+
                $translate.instant("CORE.DATA_TABLE.LOADING") +
                '</h3>' +
            '</div>'
        );
        return {
            getOptions: getOptions, //TODO: Will be removed soon :P
            getOptionsDefault: getOptionsDefault,
            getLanguageOptions: getLanguageOptions,
            preRerenderBugFix: preRerenderBugFix,
            configureDateTimeSortingPtBr: configureDateTimeSortingPtBr
        };

        function getLanguageOptions() {

            return {
                "sEmptyTable": $translate.instant("CORE.DATA_TABLE.EMPTY_TABLE"),
                "sInfo": $translate.instant("CORE.DATA_TABLE.INFO"),
                "sInfoEmpty": $translate.instant("CORE.DATA_TABLE.INFO_EMPTY"),
                "sInfoFiltered": $translate.instant("CORE.DATA_TABLE.INFO_FILTERED"),
                "sInfoPostFix": "",
                "sInfoThousands": ".",
                "sLengthMenu": $translate.instant("CORE.DATA_TABLE.LENGTH_MENU"),
                "sLoadingRecords": $translate.instant("CORE.DATA_TABLE.LOADING"),
                "sProcessing": $translate.instant("CORE.DATA_TABLE.PROCESSING"),
                "sZeroRecords": $translate.instant("CORE.DATA_TABLE.EMPTY_TABLE") + " :(",
                "sSearch": $translate.instant("CORE.DATA_TABLE.SEARCH"),
                "oPaginate": {
                    "sNext": $translate.instant("CORE.DATA_TABLE.PAGINATE.NEXT"),
                    "sPrevious": $translate.instant("CORE.DATA_TABLE.PAGINATE.PREVIOUS"),
                    "sFirst": $translate.instant("CORE.DATA_TABLE.PAGINATE.FIRST"),
                    "sLast": $translate.instant("CORE.DATA_TABLE.PAGINATE.LAST")
                },
                "oAria": {
                    "sSortAscending": ": " + $translate.instant("CORE.DATA_TABLE.ARIA.SORT_ASCENDING"),
                    "sSortDescending": ": " + $translate.instant("CORE.DATA_TABLE.ARIA.SORT_DESCENDING")
                }
            };
        }

        function configureDateTimeSortingPtBr() {
            if (!sortingPtBrDateExtended) {
                $.extend($.fn.dataTableExt.oSort, {
                    "date-pt-pre": function (a) {
                        return parseInt(moment(a, "DD/MM/YYYY").format("X"), 10);
                    },
                    "date-pt-asc": function (a, b) {
                        return a - b;
                    },
                    "date-pt-desc": function (a, b) {
                        return b - a;
                    },
                    "time-pt-asc": function (a, b) {
                        if (a == '')
                            return 1;
                        else if (b == '')
                            return -1;
                        else
                        {
                            var ia = parseInt(moment(a, "HH:mm").format("X"), 10);
                            var ib = parseInt(moment(b, "HH:mm").format("X"), 10);
                            return (ia<ib) ? -1 : ((ia > ib) ? 1 : 0);
                        }
                    },
                    "time-pt-desc": function (a, b) {
                        if (a == '')
                            return 1;
                        else if (b == '')
                            return -1;
                        else
                        {
                            var ia = parseInt(moment(a, "HH:mm").format("X"), 10);
                            var ib = parseInt(moment(b, "HH:mm").format("X"), 10);
                            return (ia>ib) ? -1 : ((ia < ib) ? 1 : 0);
                        }
                    }
                });
                sortingPtBrDateExtended = true;
            }
        }

        function preRerenderBugFix(instance) {

            if (instance) {
                var buttons = [];
                if (instance.DataTable.buttons()[0]) {
                    $.each(instance.DataTable.buttons()[0].inst.s.buttons,
                        function () {
                            buttons.push(this);
                        });
                    $.each(buttons, function (index) {
                        buttons[index].node[0].remove();
                    });
                }
            }

            /*
             FIXME: temporary workaround, :bug: fix will be release @ bower soon
             see on https://datatables.net/forums/discussion/35261/cannot-read-property-node-of-undefined-js-error-when-destroying-buttons
             */
        }

        function getOptions(options) {

            configureDateTimeSortingPtBr();

            var dataTableOptions = {
                dom: '<"top"fB>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                buttons: [
                    {
                        isExportButton: true,
                        extend: 'csvHtml5',
                        className: 'hidden-button',
                        filename: msUtils.shortGuidGenerator(),
                        text: '.'
                    },
                    {
                        isExportButton: true,
                        extend: 'excelHtml5',
                        className: 'hidden-button',
                        filename: msUtils.shortGuidGenerator(),
                        text: '.'
                    },
                    {
                        isExportButton: true,
                        extend: 'print',
                        className: 'hidden-button',
                        filename: msUtils.shortGuidGenerator(),
                        text: '.',
                        autoPrint: true,
                        customize: function (printWindow) {
                            printWindow.document.getElementsByTagName("body")[0].style = 'overflow: visible !important;';
                            printWindow.document.getElementsByTagName("html")[0].style = 'overflow: visible !important;';
                            printWindow.document.getElementsByTagName("table")[0].style = 'font-size: 10px !important;';
                        }
                    }
                ],
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                stateSave: true,
                lengthMenu: [25, 50, 100, 200, 250],
                iDisplayLength: 25,
                language: getLanguageOptions()
            };

            options = options || {};
            options.buttons = options.buttons || {};

            if (options.buttons.columnVisibilityEnabled) {
                dataTableOptions.buttons.push({
                    isExportButton: false,
                    extend: 'colvis',
                    text: $translate.instant("CORE.DATA_TABLE.CHANGE_COLUMNS")
                });
            }

            if (options.buttons.columns) {
                for (var i = 0; i < dataTableOptions.buttons.length; i++) {
                    if (dataTableOptions.buttons[i].extend && dataTableOptions.buttons[i].isExportButton) {
                        dataTableOptions.buttons[i].exportOptions = dataTableOptions.buttons[i].exportOptions || {};
                        dataTableOptions.buttons[i].exportOptions.columns = options.buttons.columns;
                    }
                }
            }

            return dataTableOptions;
        }

        function getOptionsDefault(customConfiguration) {

            configureDateTimeSortingPtBr();

            var optionsDefault = {
                dom: 'rt<"bottom"<"left"<"length"lB>><"right"<"info"i><"pagination"p>>>',
                buttons: [
                    {
                        isExportButton: true,
                        extend: 'csvHtml5',
                        className: 'hidden-button',
                        filename: msUtils.shortGuidGenerator(),
                        text: '.'
                    },
                    {
                        isExportButton: true,
                        extend: 'excelHtml5',
                        className: 'hidden-button',
                        filename: msUtils.shortGuidGenerator(),
                        text: '.'
                    },
                    {
                        isExportButton: true,
                        extend: 'print',
                        className: 'hidden-button',
                        filename: msUtils.shortGuidGenerator(),
                        text: '.',
                        autoPrint: true,
                        customize: function (printWindow) {
                            printWindow.document.getElementsByTagName("body")[0].style = 'overflow: visible !important;';
                            printWindow.document.getElementsByTagName("html")[0].style = 'overflow: visible !important;';
                            printWindow.document.getElementsByTagName("table")[0].style = 'font-size: 10px !important;';
                        }
                    }
                ],
                columnDefs: [],
                initComplete: function () {
                    var api = this.api();
                    var searchBox = angular.element('body').find('#default-list-search-input');
                    angular.element('body').find('#table-list_wrapper .dataTables_scrollHeadInner')[0].classList.add('w-100-percent');
                    angular.element('body').find('#table-list_wrapper .dataTables_scrollHeadInner table')[0].classList.add('w-100-percent');
                    if (searchBox.length > 0) {
                        searchBox.on('keyup', function (event) {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType: 'simple',
                lengthMenu: [25, 50, 100, 200, 250],
                pageLength: 25,
                scrollY: 'auto',
                responsive: true,
                saveState: true,
                language: getLanguageOptions()
            };

            if (customConfiguration) {
                customConfiguration(optionsDefault);
            }

            return optionsDefault;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('versionAppFilter', versionAppFilter);

  /** @ngInject */
  function versionAppFilter() {
    return function (value) {
      if (value) {
        value = value.toString();

        var formatted = '';
        for (var i = 0; i < value.length; i += 2) {
          formatted += value.substr(i, 2) + '.';
        }

        formatted = formatted.slice(0, -1);

        return formatted;
      }

      return null;
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('toDateLiteralFormat', toDateLiteralFormat);

  /** @ngInject */
  function toDateLiteralFormat() {
    return function (value) {
      if (value) {
        var seconds = value * 60;
        var hours = Math.floor(seconds / 3600);
        seconds -= hours * 3600;
        var minutes = Math.floor(seconds / 60) % 60;

        var text = '';
        if (hours) {
          text += hours + 'h';
        }

        if (minutes ){
          text += minutes + 'min';
        }

        return text;
      }

      return null;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('thousandSeparator', thousandSeparator);

  /** @ngInject */
  function thousandSeparator() {
    return function (value, noDecimals) {
      if (typeof value !== 'string') {
        value = value.toFixed(2).toString();
      }

      var parts = value.split(".");
      var integerPart = parts[0];
      var decimalPart = parts[1] || '00';

      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      if (noDecimals) {
        return integerPart;
      }

      return integerPart + ',' + decimalPart;
    };
  }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('taskSearch', taskSearch);

    /** @ngInject */
    function taskSearch() {
        return function (items, taskName) {
            if (items.length === 0 || !taskName) {
                return items;
            }
            var filtered = [];
            items.forEach(function (task){
                var name = task.order.service.description + ' - ' + task.order.customer.name;
                var search = name.toUpperCase().search(taskName.toUpperCase());
                if(search >= 0){
                    filtered.push(task);
                }
            });
            return filtered;
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('taskDeadlineStatusToDescription', taskDeadlineStatusToDescription);

  /** @ngInject */
  function taskDeadlineStatusToDescription($translate) {
    return function (status) {
      var allStatus = {
        'notApplicable': $translate.instant("CORE.TASKS_DEADLINE_STATUS.NO_APPLICABLE"),
        'onSchedule': $translate.instant("CORE.TASKS_DEADLINE_STATUS.ON_SCHEDULE"),
        'atRisk': $translate.instant("CORE.TASKS_DEADLINE_STATUS.AT_RISK"),
        'outOfSchedule': $translate.instant("CORE.TASKS_DEADLINE_STATUS.OUT_OF_SCHEDULE"),
        'completedOutOfSchedule': $translate.instant("CORE.TASKS_DEADLINE_STATUS.COMPLETED_OUT_OF_SCHEDULE"),
        'completedOnSchedule': $translate.instant("CORE.TASKS_DEADLINE_STATUS.COMPLETED_ON_SCHEDULE"),
      };

      return allStatus[status] || '';
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;

                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('removeComma', removeComma);

    /** @ngInject */
    function removeComma() {
        return function (value) {
            value = value.replace(/,/g, '');
            return value.replace('.', ',');
        };
    }

})();



  (function () {
    'use strict';

    angular
    .module('app.core')
    .filter('optionDescription', getDescriptionFromSelectedOption);

        /** @ngInject */
        function getDescriptionFromSelectedOption($translate) {
          return function (options, answer) {
            var selectedOption = options.find(function (option) {
              return option.value === answer;
            });

            if (selectedOption && selectedOption.description) {
              return '<div>' +
                '<h3>' + $translate.instant('FORMS.DIALOG.MODAL.TITLE') + '</h3>' +
                '<p>' + selectedOption.description + '</p>' +
                '</div>';
            }

            return '';
          };
      }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('encodedUriComponent', encodedUriComponent);

    /** @ngInject */
    function encodedUriComponent() {
        return function (value) {
            return encodeURIComponent(value);
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('durationFormat', durationFormat);

  /** @ngInject */
  function durationFormat(translateService, $translate) {
    return function (minutes) {
      var locale = translateService.getLanguage() || 'pt';
      var durationFormats = {};
      durationFormats[locale] = {
        day: $translate.instant('CORE.DATA_TABLE.DAY'),
        hour: $translate.instant('CORE.DATA_TABLE.HOUR'),
        minute: $translate.instant('CORE.DATA_TABLE.MINUTE'),
        days: $translate.instant('CORE.DATA_TABLE.DAYS'),
        hours: $translate.instant('CORE.DATA_TABLE.HOURS'),
        minutes: $translate.instant('CORE.DATA_TABLE.MINUTES'),
        and: $translate.instant('CORE.DATA_TABLE.AND'),
      };
      var duration = moment.duration(minutes, 'minutes');
      var days = Math.floor(duration.asDays());
      var hours = duration.hours();
      var mins = duration.minutes();

      var formattedDuration = "";

      if (days > 0) {
        formattedDuration += days + " " + (days > 1 ? durationFormats[locale].days : durationFormats[locale].day);
        if (hours > 0 || mins > 0) {
          formattedDuration += ", ";
        }
      }

      if (hours > 0) {
        formattedDuration += hours + " " + (hours > 1 ? durationFormats[locale].hours : durationFormats[locale].hour);
        if (mins > 0) {
          formattedDuration += " " + durationFormats[locale].and + " ";
        }
      }

      if (mins > 0) {
        formattedDuration += mins + " " + (mins > 1 ? durationFormats[locale].minutes : durationFormats[locale].minute);
      }

      return formattedDuration;
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('currencyFormat', currencyFormat);

  /** @ngInject */
  function currencyFormat(CurrencyService, translateService) {
    return function (value) {
      var locale = translateService.getLanguage() || 'pt-BR';
      var currencySymbol = CurrencyService.currencySymbol;
      var currencyCode = CurrencyService.pickCurrentCode();

      var formattedNumber = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode
      }).format(value);

      formattedNumber = formattedNumber.replace(/[^\d.,\s]+/g, '');

      var value = currencySymbol + formattedNumber;

      return value;
    };
  }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('cpfCnpjFilter', cpfCnpjFilter);

    /** @ngInject */
    function cpfCnpjFilter() {
        return function (value) {
            if (value) {
                if (value.length <= 11) {
                    value = value.replace(/\D/g, "");
                    value = value.replace(/(\d{3})(\d)/, "$1.$2");
                    value = value.replace(/(\d{3})(\d)/, "$1.$2");
                    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else if (value.length <= 14) {
                    value = value.replace(/\D/g, "");
                    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
                    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                    value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
                    value = value.replace(/(\d{4})(\d)/, "$1-$2");
                }
                return value;
            }

            return null;
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('toTrusted', toTrustedFilter)
    .filter('htmlToPlaintext', htmlToPlainTextFilter)
    .filter('nospace', nospaceFilter)
    .filter('formatDateTimeComments', formatDateTimeComments)
    .filter('humanizeDoc', humanizeDocFilter)
    .filter('propsFilter', propsFilter)
    .filter('firstName', firstName)
    .filter('brlCurrencyFilter', brlCurrencyFilter)
    .filter('unique', unique)
    .filter('maxLength', maxLength)
    .filter('mumakil', mumakil);

  /** @ngInject */
  function unique() {
    return function (array, field) {
      if(!array){
        return array;
      }

      var keysUsed = {};
      var uniques = [];
      array.forEach(function (item){
        var key = item[field];

        var isKeyUsed = keysUsed[key];
        if(isKeyUsed){
          return;
        }
        keysUsed[key] = true;

        uniques.push(item);
      });

      return uniques;
    };
  }

  /** @ngInject */
  function propsFilter() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }
      return out;
    };
  }

  /** @ngInject */
  function formatDateTimeComments(moment) {

    return function (dateUTC) {
      return moment(dateUTC).fromNow();
    };
  }

  /** @ngInject */
  function toTrustedFilter($sce) {
    return function (value) {
      return $sce.trustAsHtml(value);
    };
  }

  /** @ngInject */
  function htmlToPlainTextFilter() {
    return function (text) {
      return String(text).replace(/<[^>]+>/gm, '');
    };
  }

  function firstName() {
    return function (name) {
      if (name) {
        var parts = name.split(/\s+/);
        return parts[0];
      }
      return '';
    };
  }

  /** @ngInject */
  function nospaceFilter() {
    return function (value) {
      return (!value) ? '' : value.replace(/ /g, '');
    };
  }

  /** @ngInject */
  function humanizeDocFilter() {
    return function (doc) {
      if (!doc) {
        return;
      }
      if (doc.type === 'directive') {
        return doc.name.replace(/([A-Z])/g, function ($1) {
          return '-' + $1.toLowerCase();
        });
      }
      return doc.label || doc.name;
    };
  }

  /** @ngInject */
  function brlCurrencyFilter($filter) {
    return function (amount, symbol, precision) {
      if (!amount) return;
      var symbol = symbol ? [symbol, ''].join(' ') : '',
        precision = precision ? precision : 2,
        amount = $filter('currency')(amount, symbol, precision);

      return amount
        .replace(/\./g, 'DECIMAL')
        .replace(/,/g, '.')
        .replace(/DECIMAL/g, ',');
    };
  }

  /** @ngInject */
  function maxLength() {
    return function (text, max, endWith) {
      if (!text) return;
      text = text.toString();
      if (text.length <= max) return text;
      endWith = endWith || '...';
      return text.slice(0, max - text.length) + endWith;
    };
  }

   /** @ngInject */
  function mumakil() {
    var defaultUrl = 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br';

    return function (link) {
      if (!link) {
        return;
      }

      if (link.startsWith('https://') || link.startsWith('http://')) {
        return link;
      }

      return defaultUrl + '/' + link.replace(/^\//, '');
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('licensePlateMask', licensePlateDirective);

  /** @ngInject */
  function licensePlateDirective() {
    return {
      link: link,
      require: 'ngModel'
    };

    function link(scope, element, attrs, ngModelController) {
      attrs.$set('maxlength', 8);
      scope.$watch(attrs['ngModel'], applyMask);

      function applyMask(event) {
        if (element.val()) {
          var value = element.val().replace(/-/g, "").toUpperCase();

          value = value.replace(/^([A-Z]{3})(\d{1})/, "$1-$2");
          value = value.replace(/^([A-Z]{3})-([0-9][A-Z|\d]\d{2})$/, "$1-$2");

          if (value.length <= 3) {
            value = value.replace(/\d/g, "");
          }

          if (value.length > 3) {
            value.match(/^([A-Z]{4})/g) ?
              ngModelController.$setValidity('isValidLicensePlate', false) :
              ngModelController.$setValidity('isValidLicensePlate', true);
          }

          if (value.length <= 8) {
            ngModelController.$setValidity('isValidLicensePlate', false);
          }

          if (value.length >= 8) {
            value.match(/^([A-Z]{3})-([0-9][A-Z|\d]\d{2})$/) ?
              ngModelController.$setValidity('isValidLicensePlate', true) :
              ngModelController.$setValidity('isValidLicensePlate', false);
          }

          element.val(value);
          ngModelController.$setViewValue(value);
        } else {
          ngModelController.$setViewValue('');
        }
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();

(function () {
  'use strict';

  angular
      .module('app.core')
      .directive('focusOn', focusOn);

  function focusOn($timeout) {
    return function (scope, elem, attr) {
      scope.$on(attr.focusOn, function (e) {
        $timeout(function () {
          elem[0].focus();
        }, 500);
      });
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('emailValidation', emailValidation);

    function emailValidation() {
        var pattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9]+([_-][a-zA-Z0-9]+)*(\.[a-zA-Z0-9_-]{2,64})+$/;

        return {
            link: validate,
            restrict: 'A',
            require: 'ngModel'
        };

        function validate(scope, element, attrs, ctrl) {
            ctrl.$validators.pattern = function (modelValue, viewValue) {
                if (ctrl.$isEmpty(modelValue)) {
                    return true;
                }

                if (pattern.test(viewValue)) {
                    return true;
                }
                return false;
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ngInsert', NgInsert);

        function NgInsert() {
            return {
                restrict: 'A',

                require: 'ngModel',

                link: function (scope, element, attr, ctrl) {

                function customValidator(ngModelValue) {

                    if (ngModelValue != 'EXCLUIR') {
                        ctrl.$setValidity('validationError', false);
                    } else {
                        ctrl.$setValidity('validationError', true);
                    }
                    return ngModelValue;
                    }

                    ctrl.$parsers.push(customValidator);

                }
            };
        }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('cpfCnpjMask', cpfCnpjDirective);

    /** @ngInject */
    function cpfCnpjDirective() {
        return {
            link: link,
            require: 'ngModel'
        };

        function link(scope, element, attrs, ngModelController) {
            attrs.$set('maxlength', 18);
            scope.$watch(attrs['ngModel'], applyMask);

            function applyMask(event) {
                if (element.val()) {
                    var value = element.val().replace(/\D/g, "");

                    if (value.length <= 11) {
                        value = value.replace(/(\d{3})(\d)/, "$1.$2");
                        value = value.replace(/(\d{3})(\d)/, "$1.$2");
                        value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                    } else {
                        value = value.replace(/^(\d{2})(\d)/, "$1.$2");
                        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                        value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
                        value = value.replace(/(\d{4})(\d)/, "$1-$2");
                    }

                    element.val(value);
                    ngModelController.$setViewValue(value.replace(/\D/g, "").toString());
                } else {
                    ngModelController.$setViewValue(null);
                }
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('app.core')
        .factory('usersCacheService', usersCacheService);

    /** @ngInject */
    function usersCacheService(usersApi, moment) {

        var _users = null;
        var _fetchAt = null;

        loadUsers();

        return {
            getUsers: getUsers
        };

        function loadUsers() {
            return usersApi.search({ take: 100 })
                .then(function (result) {
                    _users = result.items;
                    _fetchAt = moment.utc();
                });
        }

        function getUsers() {
            var rightNow = moment.utc();
            var minutesDiff = rightNow.diff(_fetchAt, 'minutes');
            if (minutesDiff > 10) {
                loadUsers();
            }
            return _users;
        }
    }

})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('servicesCache', servicesCache);

  /** @ngInject */
  function servicesCache(ServicesApiGraphQL, moment, $q) {
    var _services = null;
    var _fetchAt = null;

    return {
      getCachedOrDefault: getCachedOrDefault,
      resetCache: resetCache
    };

    function resetCache() {
      _fetchAt = null;
    }

    function getCachedOrDefault() {
      if (_isExpired()) {
        return loadServices();
      }

      return $q.resolve(_services);
    }

    function _isExpired() {
      if (!_fetchAt) {
        return true;
      }

      var rightNow = moment.utc();

      var minutesDiff = rightNow.diff(_fetchAt, 'minutes');
      return minutesDiff > 10;
    }

    function loadServices() {
      return ServicesApiGraphQL.search({ take: 10000 }).then(function (result) {
        _services = result.items;
        _fetchAt = moment.utc();
        return _services;
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('employeesCache', employeesCache);

  /** @ngInject */
  function employeesCache(employeesApi, moment, $q) {
    var _employees = null;
    var _fetchAt = null;

    return {
      getCachedOrDefault: getCachedOrDefault,
      resetCache: resetCache
    };

    function resetCache() {
      _fetchAt = null;
    }

    function getCachedOrDefault() {
      if (_isExpired()) {
        return loadEmployees();
      }

      return $q.resolve(_employees);
    }

    function _isExpired() {
      if (!_fetchAt) {
        return true;
      }

      var rightNow = moment.utc();

      var minutesDiff = rightNow.diff(_fetchAt, 'minutes');
      return minutesDiff > 10;
    }

    function loadEmployees() {
      return employeesApi.getAll().then(function (result) {
        _employees = result.items;
        _fetchAt = moment.utc();
        return _employees;
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('accountCache', accountCache);

  /** @ngInject */
  function accountCache(accountsApi, moment, $q) {
    loadAccount();

    var _account = null;
    var _fetchAt = null;
    var _invalid = false;

    return {
      loadAccount: loadAccount,
      getAccount: getAccount,
      getCachedOrDefault: getCachedOrDefault,
      invalidate: invalidate
    };

    function loadAccount() {
      return accountsApi.get().then(function (account) {
        _account = account;
        _fetchAt = moment.utc();
        return account;
      });
    }

    function getAccount() {
      var rightNow = moment.utc();
      if (_fetchAt) {
        var minutesDiff = rightNow.diff(_fetchAt, 'minutes');
        if (minutesDiff > 10) {
          loadAccount();
        }
      } else {
        loadAccount();
      }
      return _account;
    }

    function invalidate() {
      _invalid = true;
    }

    function getCachedOrDefault() {
      if (!_isExpired() && !_invalid) {
        return $q.resolve(_account);
      }

      return accountsApi.get().then(function (account) {
        _fetchAt = moment.utc();
        _account = account;
        _invalid = false;
        return _account;
      });
    }

    function _isExpired() {
      var rightNow = moment.utc();
      var minutesDiff = rightNow.diff(_fetchAt, 'minutes');
      return minutesDiff > 10;
    }
  }
})();
(function () {
    'use strict';

    angular.module('app.core').factory('Blatout', Blatout);

    /** @ngInject */
    function Blatout(authenticatedUser, usersApi, $timeout, blatoutApi, $translate) {

        var init = false;
        var lock = false;

        return {
            initialize: initialize,
            refresh: refresh
        };

        function refresh() {
            if (!init) {
                initialize();
            }

            window.BlatOut.refresh();
        }

        function initialize() {

            if (init || lock) {
                return;
            }
            lock = true;

            if (authenticatedUser.isAuthenticated() && !authenticatedUser.profile.impersonated) {

                usersApi.get(authenticatedUser.profile.id).then(function (loggedUser) {

                    blatoutApi.getUserHash(loggedUser._id).then(function (blatoutResult) {

                        $timeout(function tryLoadBlatout() {
                            var toolbarElement = document.querySelector('fieldcontrol-toolbar');
                            if (!toolbarElement) {
                                $timeout(tryLoadBlatout, 500);
                                return;
                            }
                            var shadowRoot = toolbarElement.shadowRoot;

                            window.BlatOut.load({
                                app: {
                                    id: '13e23135-904f-48b9-9785-eff19088b5cc',
                                    title: $translate.instant("CORE.BLATOUT.TITLE")
                                },
                                user: {
                                    id: loggedUser._id,
                                    hash: blatoutResult.blatoutHash,
                                    email: loggedUser.email,
                                    name: loggedUser.name
                                },
                                widgets: {
                                    sidebar: {
                                        selectors: ['.open-blatout-sidebar-widget']
                                    },
                                    badge: {
                                        type: 'counter',
                                        selector: '.blatout-badge-counter'
                                    }
                                }
                            }, shadowRoot);
                            init = true;
                        }, 500);
                    });
                });
            }

            lock = false;
        }
    }
})();
(function () {
  'use strict';

  angular.module('app.core')
    .factory('loginRedirect', loginRedirect)
    .config(configureLoginRedirect);

  /** @ngInject */
  function loginRedirect($q, $injector, $window, $location, $rootScope, EnvironmentConfig) {

    return {
      responseError: responseError
    };

    function responseError(response) {
      if (response.status === 401 || response.status === 403 && !isWhiteListUrl(response)) {
        $rootScope.toUrl = $location.url();
        $rootScope.loadingProgress = false;

        $window.location.href = EnvironmentConfig.blackgateClientUrl + 'login';
        return $q.reject(response);
      }
      return $q.reject(response);
    }

    function isWhiteListUrl(response)  {
      var whiteListUrls = [EnvironmentConfig.shelob];
      return response && response.config && whiteListUrls.some(function (url) { return response.config.url.startsWith(url); });
    }
  }


  /** @ngInject */
  function configureLoginRedirect($httpProvider) {
    $httpProvider.interceptors.push('loginRedirect');
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('authenticatedUser', authenticatedUser);

  /** @ngInject */
  function authenticatedUser(permissionsService, $localStorage, $injector, $translate) {

    var profileKey = 'k';
    var profile = getProfile();

    return {
      logout: logout,
      profile: profile,
      setProfile: setProfile,
      storageKey: storageKey,
      isAuthenticated: isAuthenticated,
      trialHasExpired: trialHasExpired,
      isPro: isPro,
      isTest: isTest,
      hasPermission: hasPermission,
      hasPermissionFromCategory: hasPermissionFromCategory
    };

    function isAuthenticated() {
      return profile && profile.id && profile.token && _isAuthTokenValid(profile.token);
    }

    function trialHasExpired() {
      return profile && profile.id && profile.token && profile.accountPlan === 'trial-expired';
    }

    function isPro() {
      return profile && profile.id && profile.token && profile.accountPlan === 'pro';
    }

    function isTest() {
      return profile && profile.id && profile.token && profile.accountPlan === 'test';
    }

    function _isAuthTokenValid(token) {
      try {
        var jwtData = token.split('.')[1];
        var decodedJwtJsonData = window.atob(base64urlToBase64(jwtData));
        var decodedJwtData = JSON.parse(decodedJwtJsonData);

        return (decodedJwtData.exp > (Date.now() / 1000));
      } catch (error) {
        $localStorage.remove('k');

        return false;
      }
    }

    function storageKey(keyName) {
      return profile.id + '_' + keyName;
    }

    function logout() {
      profile.id = '';
      profile._id = '';
      profile.accountId = null;
      profile.name = '';
      profile.picture = '';
      profile.email = '';
      profile.token = '';
      profile.admin = false;
      profile.owner = false;
      profile.impersonated = false;
      profile.accountPlan = null;
      profile.permissions = [];
      profile.emailValidatedAt = null;

      $localStorage.remove(profileKey);
    }

    function setProfile(userProfile) {
      profile.id = userProfile.id;
      profile._id = userProfile._id;
      profile.accountId = userProfile.accountId;
      profile.name = userProfile.name;
      profile.picture = userProfile.picture;
      profile.email = userProfile.email;
      profile.token = userProfile.token;
      profile.admin = userProfile.admin;
      profile.owner = userProfile.owner;
      profile.impersonated = userProfile.impersonated;
      profile.accountPlan = userProfile.accountPlan;
      profile.permissions = userProfile.permissions;
      profile.emailValidatedAt = userProfile.emailValidatedAt;

      $localStorage.setObject(profileKey, profile);
    }

    function getProfile() {
      profile = {
        id: '',
        _id: '',
        accountId: null,
        name: '',
        email: '',
        token: '',
        admin: false,
        owner: false,
        impersonated: false,
        accountPlan: null,
        permissions: [],
        emailValidatedAt: null
      };
      var savedProfile = $localStorage.getObject(profileKey);
      if (savedProfile) {
        profile.id = savedProfile.id;
        profile._id = savedProfile._id;
        profile.accountId = savedProfile.accountId;
        profile.name = savedProfile.name;
        profile.picture = savedProfile.picture;
        profile.email = savedProfile.email;
        profile.token = savedProfile.token;
        profile.admin = savedProfile.admin;
        profile.owner = savedProfile.owner;
        profile.impersonated = savedProfile.impersonated;
        profile.accountPlan = savedProfile.accountPlan;
        profile.permissions = savedProfile.permissions;
        profile.emailValidatedAt = savedProfile.emailValidatedAt;
      }
      return profile;
    }

    function hasPermission(account, permission) {
      return permissionsService.hasPermission(account, profile, permission);
    }

    function hasPermissionFromCategory(account, category) {
      return permissionsService.hasPermissionFromCategory(account, profile, category);
    }

    function base64urlToBase64(base64url) {
      var base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');

      while (base64.length % 4) {
          base64 += '=';
      }

      return base64;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.core').factory('auth', auth);

  function auth($http, EnvironmentConfig, authenticatedUser, usersApi) {

    var authenticationUrl = EnvironmentConfig.baseUrl + 'authenticate';
    var forgotPasswordUrl = EnvironmentConfig.blackgateUrl + 'auth/send-password-reset-email';
    var resetPasswordUrl = EnvironmentConfig.baseUrl + 'authentication/actions/reset-password';
    var validateTokenUrl = EnvironmentConfig.baseUrl + 'authentication/actions/validate';
    var confirmationEmailUrl = EnvironmentConfig.blackgateUrl + 'auth/send-email-confirmation';
    var googleDataUrl = 'https://www.googleapis.com/oauth2/v1/userinfo/?alt=json&access_token=';
    var userLookupUrl = EnvironmentConfig.blackgateUrl + 'auth/lookup-user';
    var authWithMicrosoftUrl = EnvironmentConfig.blackgateUrl + 'auth/sign-in';

    return {
      userLookup: userLookup,
      getGoogleData: getGoogleData,
      forgotPassword: forgotPassword,
      resetPassword: resetPassword,
      validateToken: validateToken,
      sendConfirmationEmail: sendConfirmationEmail,
      setAuthenticatedProfile: setAuthenticatedProfile,
      authenticateWithMicrosoft: authenticateWithMicrosoft,
      authenticateWithGoogle: authenticateWithGoogle,
      authenticateWithAccount: authenticateWithAccount,
    };

    function userLookup(payload) {
      return $http.post(userLookupUrl, payload).then(function (response) {
        return response.data;
      });
    }

    function validateToken(token) {
      return $http.post(validateTokenUrl, { token: token }).then(function (response) {
        return response.data;
      });
    }

    function getGoogleData(token) {
      return $http.get(googleDataUrl + token).then(function (response) {
        return response.data;
      });
    }

    function resetPassword(id, password) {
      return $http.put(resetPasswordUrl, { id: id, password: password }).then(function (response) {
        return response.data;
      });
    }

    function sendConfirmationEmail() {
      return $http.post(confirmationEmailUrl).then(function (response) {
        return response.data;
      });
    }

    function forgotPassword(email) {
      return $http.post(forgotPasswordUrl, { username: email, userType: 'users' }).then(function (response) {
        return response.data;
      });
    }

    function authenticateWithMicrosoft(token) {
      return $http.post(authWithMicrosoftUrl, {
        token: token,
        provider: 'active-directory',
        app: EnvironmentConfig.appName
      }).then(function (response) { return setAuthenticatedProfile(response.data); });
    }

    function authenticateWithGoogle(googleAccessToken) {
      return $http.post(authenticationUrl, {
        token: googleAccessToken,
        provider: 'google',
        app: EnvironmentConfig.appName
      }).then(function (response) { return setAuthenticatedProfile(response.data); });
    }

    function authenticateWithAccount(username, password) {
      return $http.post(authenticationUrl, {
        email: username,
        password: password,
        provider: 'username-password',
        app: EnvironmentConfig.appName
      }).then(function (response) { return setAuthenticatedProfile(response.data); });
    }

    function setAuthenticatedProfile(profile, callback) {
      authenticatedUser.setProfile(profile);
      return usersApi.getPermissions(profile.id)
        .then(function (permissions) {
          profile.permissions = permissions;
          authenticatedUser.setProfile(profile);

          if (callback) {
            callback();
          }
        })
        .then(function () {
          return profile;
        });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.core')
        .factory('addToken', addToken)
        .config(configureAddToken);

    /** @ngInject */
    function addToken(authenticatedUser, $q) {

        return {
            request: request
        };

        function request(config) {
            if (userAuthenticationIsValid()) {
                config.headers['x-access-token'] = authenticatedUser.profile.token;
            }
            return $q.when(config);
        }

        function userAuthenticationIsValid() {
            return authenticatedUser.profile.token;
        }
    }

    function configureAddToken($httpProvider) {
        $httpProvider.interceptors.push('addToken');
    }
})();

(function () {
  'use strict';

  angular.module('app.core.api')
    .factory('handleConnectionError', handleConnectionError)
    .config(configureHandleConnectionError);

  /** @ngInject */
  function handleConnectionError($q, $rootScope) {

    function onResponseError(error) {
      var isNetworkError = (
        !error.message || (
          error.message.includes('Network Error') ||
          error.message.includes('Failed to fetch') ||
          error.code === 'ECONNABORTED'
        )
      );

      var isNotTimeoutOrCanceled = (
        (!error.config || !error.config.timeout) &&
        !error.response &&
        (!error.request || !error.config.aborted)
      );

      if (error.status === -1 && !error.statusText && isNetworkError && isNotTimeoutOrCanceled) {
        console.error('CONNECTION ERROR', error);
        $rootScope.$broadcast('new:connectionError');
      }

      return $q.reject(error);
    }

    return {
      responseError: onResponseError
    };
  }

  function configureHandleConnectionError($httpProvider) {
    $httpProvider.interceptors.push('handleConnectionError');
  }
})();

(function () {
    'use strict';

    angular.module('app.core.api')
        .factory('addAcceptVersion', addAcceptVersion)
        .config(configureAddAcceptVersion);

    /** @ngInject */
    function addAcceptVersion($q) {

        return {
            request: request
        };

        function request(config) {
            if (!config.headers['accept-version']) {
                config.headers['accept-version'] = '~1';
            }
            return $q.when(config);
        }

    }

    function configureAddAcceptVersion($httpProvider) {
        $httpProvider.interceptors.push('addAcceptVersion');
    }
})();

(function () {
    'use strict';
    angular.module('app.core').directive('draggable', function () {
        return {
            // A = attribute, E = Element, C = Class and M = HTML Comment
            restrict: 'A',
            //The link function is responsible for registering DOM listeners as well as updating the DOM.
            link: function (scope, element, attrs) {
                element.draggable({
                    handle: ".draggable-toolbar",
                    opacity: 0.85,
                    stop: function (event) {
                        event.stopPropagation();
                    }
                });
            }
        };
    });
})();


(function () {
    'use strict';

    angular.module('fuse', [
        'app.core',
        'app.auth-forgot-password',
        'app.auth-reset-password',
        'app.auth-confirm-email',
        'app.locations',
        'app.customers',
        'app.employees',
        'app.absences',
        'app.services',
        'app.routes',
        'app.tasks',
        'app.tickets',
        'app.calendar',
        'app.settings',
        'app.errors',
        'app.control-panel',
        'app.bootstrap',
        'app.errors',
        'app.recurrences',
        'app.notifications',
        'app.equipments',
        'app.equipment-types',
        'app.exports',
        'app.plans',
        'app.plans-types',
        'app.devices',
        'app.materials',
        'app.modules',
        'app.subscription',
        'app.product-types',
        'app.products',
        'app.work-services',
        'app.products-services',
        'app.quotations',
        'app.audit-logs',
        'app.vehicles',
        'app.vehicles-usage',
        'app.deadline-contracts',
        'app.deadline-violations-reasons'
    ]);
})();

(function () {
  'use strict';

  angular.module('fuse').controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $rootScope, FcToastService, $translate) {
    $scope.$on('$viewContentAnimationEnded', function (event) {
      if (event.targetScope.$id === $scope.$id) {
        $rootScope.$broadcast('msSplashScreen::remove');
      }
    });

    $rootScope.$on('new:connectionError', function () {
      showConnectionErrorToast();
    });

    function showConnectionErrorToast() {
      FcToastService.addWarning({
        hideDelay: 4000,
        position: 'BOTTOM LEFT',
        title: $translate.instant('CORE.ERRORS.CONNECTION_ERROR.TITLE'),
        content: $translate.instant('CORE.ERRORS.CONNECTION_ERROR.CONTENT'),
        customClass: 'connection-error-toast',
        iconPath: 'assets/icons/icon-yellow-alert.svg',
        errorType: 'connectionError'
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .run(runBlock);

  /** @ngInject */
  function runBlock(msUtils, fuseGenerator, fuseConfig) {
    /**
     * Generate extra classes based on registered themes so we
     * can use same colors with non-angular-material elements
     */
    fuseGenerator.generate();

    /**
     * Disable md-ink-ripple effects on mobile
     * if 'disableMdInkRippleOnMobile' config enabled
     */
    if (fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile()) {
      var bodyEl = angular.element('body');
      bodyEl.attr('md-no-ink', true);
    }

    /**
     * Put isMobile() to the html as a class
     */
    if (msUtils.isMobile()) {
      angular.element('html').addClass('is-mobile');
    }

    /**
     * Put browser information to the html as a class
     */
    var browserInfo = msUtils.detectBrowser();
    if (browserInfo) {
      var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
      angular.element('html').addClass(htmlClass);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .constant('_', window._)
        .constant('$', window.$)
        .constant('XLSX', XLSX)
        .constant('moment', window.moment)
        .constant('SchemaInspector', window.SchemaInspector);
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider, translateProvider) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });

        $translateProvider.registerAvailableLanguageKeys(['pt', 'en', 'es'], {
            'pt-*': 'pt',
            'en-*': 'en',
            'es-*': 'es',
            'pt-BR': 'pt',
            'pt-br': 'pt'
        });

        var translateProvider = translateProvider.$get();
        var language = translateProvider.getTranslateLanguageCode();

        $translateProvider.preferredLanguage(language);

        $translateProvider.determinePreferredLanguage();

        $translateProvider.useSanitizeValueStrategy('escaped');

        $translateProvider.useLoaderCache('$translationCache');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /* eslint-enable */
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, PushNotifications, $translate, translateService, $transitions, fcExportAlertService, authenticatedUser, $interval, exportsApi, $window) {
        var stateChangeStartEvent = $transitions.onStart({}, function () {
            $rootScope.loadingProgress = true;
        });

        var stateChangeSuccessEvent = $transitions.onSuccess({}, function () {
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });

            var defaultTitle = 'Field Control';
            var defaultViewPort = 'width=device-width, initial-scale=1, maximum-scale=1';
            if ($state.current.data) {
                if ($state.current.data.titleTranslateKey) {
                    $rootScope.title = $translate.instant($state.current.data.titleTranslateKey) + ' - Field Control';
                } else if ($state.$current.data.titleTranslateKey) {
                    $rootScope.title = $translate.instant($state.$current.data.titleTranslateKey) + ' - Field Control';
                } else if ($state.current.data.title) {
                    $rootScope.title = $state.current.data.title + ' - Field Control';
                } else {
                    $rootScope.title = defaultTitle;
                }

                if ($state.current.data.metaViewPort) {
                    $rootScope.metaViewPort = $state.current.data.metaViewPort;
                } else {
                    $rootScope.metaViewPort = defaultViewPort;
                }
            } else {
                $rootScope.title = defaultTitle;
                $rootScope.metaViewPort = defaultViewPort;
            }
            if(!$rootScope.title){
                $rootScope.title = defaultTitle;
            }
        });

        $rootScope.state = $state;

        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        if ('serviceWorker' in navigator) {
            PushNotifications.registerServiceWorker();
        }

        PushNotifications.askActiveBrowserNotifications();

        translateService.refreshLanguage();

        var lastExportedId = null;
        var verifyPdfReportStatusInterval = null;

        $rootScope.$on('order:pdf-report-created', function (event, result) {
            fcExportAlertService.show({
                email: authenticatedUser.profile.email,
                title: $translate.instant('TASKS.TOASTS.EXPORT.TITLE'),
                hasSendedToEmail: false
            });

            var exportId = result && result.response && result.response.id;
            if (exportId && exportId !== lastExportedId) {
                lastExportedId = exportId;
                _verifyPdfReportStatus(exportId);
            }
        });

        $rootScope.$on('$destroy', function () {
            if (verifyPdfReportStatusInterval) {
                $interval.cancel(verifyPdfReportStatusInterval);
            }
        });

        function _verifyPdfReportStatus(exportId) {
            var FIVE_SECONDS_IN_MILLISECONDS = 5000;
            var REQUESTS_LIMIT = 10;
            lastExportedId = exportId;

            verifyPdfReportStatusInterval = $interval(function () {
                exportsApi.verifyPdfReportStatus({ id: exportId })
                .then(function (reportStatus) {
                    var exportedPdf = reportStatus && reportStatus.export;
                    if (exportedPdf.link) {
                    $window.open(exportedPdf.link, '_blank');
                    $interval.cancel(verifyPdfReportStatusInterval);
                    lastExportedId = null;
                    $rootScope.loadingProgress = false;
                    }

                    if (exportedPdf.status === 'error') {
                    $interval.cancel(verifyPdfReportStatusInterval);
                    lastExportedId = null;
                    $rootScope.loadingProgress = false;
                    }
                });
            }, FIVE_SECONDS_IN_MILLISECONDS);

            $timeout(function () {
                $interval.cancel(verifyPdfReportStatusInterval);
                lastExportedId = null;
                $rootScope.loadingProgress = false;
            }, FIVE_SECONDS_IN_MILLISECONDS * REQUESTS_LIMIT);
        }
    }

    var user = JSON.parse(localStorage.getItem('k'));
    if (user && user.token) {
        window.TheMirrorAnalytics.install('mordor', 'prod', user.token);
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode(false);
        $urlRouterProvider.otherwise('/atividades');

        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/vertical-navigation.html',
                        controller: 'MainController as vm'
                    }
                },
                data: { title: '' }
            });
    }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(
    fuseTheming, realtimeNotifications, CheckoutService,
    Blatout, ProfitWell, $rootScope, authenticatedUser, EnvironmentConfig
  ) {
    var vm = this;
    vm.themes = fuseTheming.themes;
    vm.redirectCheckout = redirectCheckout;

    if (authenticatedUser.isAuthenticated()) {
      $rootScope.authenticatedUser = authenticatedUser;
    }

    $rootScope.$on('$locationChangeSuccess', function () {
      if (!authenticatedUser.isAuthenticated()) return;

      realtimeNotifications.connectAndSetup();

      var isProduction = EnvironmentConfig.environmentName === 'production';
      if (!isProduction) return;

      Blatout.refresh();
      ProfitWell.initialize();
    });

    function redirectCheckout() {
      CheckoutService.redirectCheckout();
    }
  }
})();

(function () {
    'use strict';

    angular.module('fuse');
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config(uiGmapGoogleMapApiProvider, $logProvider) {
        $logProvider.debugEnabled(false);

        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyDghlvC09iJTVCWajxcLVdchyKB0eR1Ocs',
            v: '3.25',
            libraries: 'weather,geometry,visualization'
        });

        document.documentElement.lang = 'pt_BR';
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService() {
        var api = {};
        api.baseUrl = 'app/data/';
        return api;
    }
})();

(function () { 
 return angular.module("app.core")
.constant("EnvironmentConfig", {"appName":"mordor","environmentName":"production","baseUrl":"https://eyeofsauron.fieldcontrol.com.br/","eyeOfSauron2Url":"https://eyeofsauron-2-ebs.fieldcontrol.com.br/graphql","locationsBaseUrl":"https://azog.fieldcontrol.com.br/","integrationBaseUrl":"https://carchost-admin.fieldcontrol.com.br/","othersApiBaseUrl":"https://fellbeast.fieldcontrol.com.br/","fellbeast2":"https://fellbeast-2.fieldcontrol.com.br/","pushNotificationsUrl":"https://mouthofsauron-pn.fieldcontrol.com.br/","realtimeUrl":"https://mouthofsauron-3-rt.fieldcontrol.com.br/notifications","wargBaseUrl":"https://atendimento.fieldcontrol.com.br","warg2BaseUrl":"https://warg-2-admin.fieldcontrol.com.br/graphql","ereborBaseUrl":"https://erebor-2.fieldcontrol.com.br/graphql","dashboardUrl":"https://app.fieldcontrol.com.br/relatorios/#/","crebainUrl":"https://app.fieldcontrol.com.br/equipamentos/gerador-qrcodes/","mordorUrl":"https://app.fieldcontrol.com.br/#/","blackgateUrl":"https://blackgate.fieldcontrol.com.br/","baraddurUrl":"https://baraddur.fieldcontrol.com.br","saruman":"https://saruman.fieldcontrol.com.br/","shelob":"https://shelob.fieldcontrol.com.br/","dolguldurUrl":"https://europ-assistance.fieldcontrol.com.br/","dolguldur2Url":"https://ijifdlegvl.execute-api.sa-east-1.amazonaws.com/prod/","thuringwethilUrl":"https://tt53k4q502.execute-api.sa-east-1.amazonaws.com/prod/graphql","contaAzul":{"clientId":"1drubvqot7a2v18ob07mlo66gp","redirectUri":"https://app.fieldcontrol.com.br/conta-azul.html"},"gandalfUrl":"https://9nj042oc0k.execute-api.sa-east-1.amazonaws.com/prod","gandalfSmartRewriteUrl":"https://mz2lqxkkvxajfrrwkf5dgld4uq0jfdqj.lambda-url.sa-east-1.on.aws/","uploadsBaseUrl":"https://mumakil.fieldcontrol.com.br/","uploadsStaticBaseUrl":"https://s3.amazonaws.com/attachments.fieldcontrol.com.br/","publicVapidKey":"BBJyyr3U87iMM6bCaJPOSmHGzT1U4gJoe5pFB9Imr06RNaWF0VAxaVO7PIMAJ7RPNG-ItgMWu18XwF2gc6oTT2c","billingUrl":"https://moria.fieldcontrol.com.br/","mouthOfSauron3Url":"https://mouthofsauron-3.fieldcontrol.com.br/graphql","grondBaseUrl":"https://grond-2.fieldcontrol.com.br/graphql","ereborClientUrl":"https://app.fieldcontrol.com.br/assinaturas/#/","blackgateClientUrl":"https://app.fieldcontrol.com.br/autenticador/#/","mordor2Url":"https://app.fieldcontrol.com.br/painel/#/","morgulblade":"https://app.fieldcontrol.com.br/gerador-pmoc/#/","gandalf":"https://9nj042oc0k.execute-api.sa-east-1.amazonaws.com/prod","gandalf2":"https://bz2ikjhat7zhy3giezca4aepb40hfqgq.lambda-url.sa-east-1.on.aws/"});

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<field-control-main-layout-provider project=\"mordor\"><router-outlet ms-scroll ui-view=\"content\" \nclass=\"animate-slide-up fieldcontrol__content\"></router-outlet></field-control-main-layout-provider>");
$templateCache.put("app/core/tutorial/fc-tutorial-dialog.html","<div class=\"fc-tutorial-dialog\"><span class=\"fc-tutorial-dialog_description\">\n{{ \'CORE.WELCOME_DESCRIPTION\' | translate }}</span><section class=\"fc-tutorial-dialog__content\"><iframe width=\"100%\" \nheight=\"365px\" src=\"https://www.youtube.com/embed/xIkeK6lHJYc\" title=\"YouTube video player\" frameborder=\"0\" \nallow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen>\n</iframe></section></div>");
$templateCache.put("app/main/absences/absences.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div data-cy=\"title\" class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"ABSENCES.TITLE\">Absences</span></div></div><div class=\"fieldcontrol__search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \ndata-cy=\"search-input\" id=\"default-list-search-input\" class=\"search-input\" type=\"text\" translate \ntranslate-attr-placeholder=\"ABSENCES.SEARCH\" flex><fc-export-csv-button data-cy=\"export-csv-button\" class=\"mleft-15\">\n</fc-export-csv-button><fc-export-excel-button data-cy=\"export-excel-button\"></fc-export-excel-button><md-button \ndata-cy=\"add-button\" ng-click=\"vm.addAbsence($event)\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate-attr-aria-label=\"ABSENCES.NEW\" \naria-label=\"Add absence\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><span translate=\"ABSENCES.NEW\">\nNew absence</span></md-tooltip></md-button><md-button data-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"ABSENCES.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"ABSENCES.RELOAD\">Reload</span></md-tooltip></md-button><md-button data-cy=\"clear-filters-button\" \nng-if=\"vm.filteringIsOn()\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate translate-attr-aria-label=\"ABSENCES.FILTERS.CLEAR\">\n<md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"ABSENCES.FILTERS.CLEAR\">Clear filters\n</span></md-tooltip></md-button><md-button data-cy=\"filters-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'absences-filters-sidenav\')\" aria-label=\"Filter Absences\" translate \ntranslate-attr-aria-label=\"ABSENCES.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"ABSENCES.FILTER\">Filter Absences</span></md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table data-cy=\"absences-table\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstanceCallback\" dt-options=\"vm.dtOptions\" \nid=\"table-list\"><thead><tr><th class=\"secondary-text\"><div data-cy=\"employee-column\" class=\"table-header\"><span \nclass=\"column-title\" translate=\"ABSENCES.TABLE.EMPLOYEE\">Employee</span></div></th><th class=\"secondary-text\"><div \ndata-cy=\"reason-column\" class=\"table-header\"><span class=\"column-title\" translate=\"ABSENCES.TABLE.REASON\">Reason</span>\n</div></th><th class=\"secondary-text\"><div data-cy=\"start-date-column\" class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ABSENCES.TABLE.START_DATE\">Start date</span></div></th><th class=\"secondary-text\"><div \ndata-cy=\"end-date-column\" class=\"table-header\"><span class=\"column-title\" translate=\"ABSENCES.TABLE.END_DATE\">End date\n</span></div></th><th class=\"secondary-text\"><div data-cy=\"created-at-column\" class=\"table-header\"><span \nclass=\"column-title\" translate=\"ABSENCES.TABLE.CREATED_AT\">Created at</span></div></th><th class=\"secondary-text\"><div \ndata-cy=\"actions-column\" class=\"table-header\"><span class=\"column-title\" translate=\"ABSENCES.TABLE.ACTIONS\">Actions\n</span></div></th></tr></thead><tbody><tr data-cy=\"datatable-item\" ng-repeat=\"absence in ::vm.absences\"><td \nclass=\"absence-name-employee\"><img class=\"avatar small\" alt=\"{{absence.employee.name}}\" \nng-src=\"{{absence.employee.avatarUrl ? absence.employee.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"> <span>{{ absence.employee.name }}</span></td><td>{{ absence.reason }}</td>\n<td>{{ absence.fromView }}</td><td>{{ absence.toView }}</td><td>{{ absence.createdAtView }}</td><td \nclass=\"no-margin-important no-padding-important\"><md-button data-cy=\"edit-button\" class=\"md-icon-button\" \nng-click=\"vm.editAbsence($event, absence.id)\" aria-label=\"more\"><img ng-src=\"assets/icons/icon-edit.svg\" alt=\"Edit\">\n<md-tooltip md-direction=\"right\"><span translate=\"ABSENCES.TABLE.EDIT\">Edit</span></md-tooltip></md-button></td></tr>\n</tbody></table></div></div></div><md-sidenav class=\"filters-sidenav md-sidenav-right\" \nmd-component-id=\"absences-filters-sidenav\" ng-include=\"\'app/main/absences/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"AbsencesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/audit-logs/audit-logs.html","<div id=\"audit-logs\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"AUDIT_LOGS.TITLE\">\nAudit logs</span></div></div><div class=\"fieldcontrol__search\" layout=\"row\" layout-align=\"end center\" flex><md-button \nng-if=\"vm.filteringIsOn()\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate \ntranslate-attr-aria-label=\"AUDIT_LOGS.SIDENAVS.FILTERS.CLEAR\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon>\n<md-tooltip><span translate=\"AUDIT_LOGS.SIDENAVS.FILTERS.CLEAR\">Clear filters</span></md-tooltip></md-button><md-button\n class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'audit-logs-filters-sidenav\')\" aria-label=\"Filter Groups\" translate \ntranslate-attr-aria-label=\"AUDIT_LOGS.ACTIONS.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"AUDIT_LOGS.ACTIONS.FILTER\">Filter groups</span></md-tooltip></md-button><md-button data-cy=\"reload-button\" \nng-click=\"vm.reload()\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"AUDIT_LOGS.ACTIONS.RELOAD\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip><span translate=\"AUDIT_LOGS.ACTIONS.RELOAD\">Reload</span></md-tooltip>\n</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"padding-0\" layout=\"column\" flex>\n<table id=\"table-list\" datatable=\"\" class=\"dataTable row-border hover datatable-customers\" \ndt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div>\n</div></div><md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"audit-logs-filters-sidenav\" \nng-include=\"\'app/main/audit-logs/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"AuditLogsFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/bootstrap/bootstrap.html","<div id=\"default-list\" class=\"page-layout carded fullwidth header-default with-filters-sidenav\" layout=\"row\"><div \nclass=\"top-bg md-field-control-800-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-play-circle\"></md-icon><span \ntranslate=\"BOOTSTRAP.TITLE\">Account Bootstrap</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"BOOTSTRAP.WELCOME\">Welcome to <b>Field Control</b>! We are happy to have you here with us.</span><br><span \ntranslate=\"BOOTSTRAP.CONFIG\">\nBefore you have super powers with your outside team, let\'s set up a few things first. It\'s very fast, let\'s go!</span>\n</div></div><div layout=\"row\" layout-align=\"end center\" flex></div></div><div class=\"content-card\" layout=\"column\" \nflex><ms-form-wizard id=\"config-wizard\" flex><md-tabs md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\">\n<md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"accountForm.$invalid\">1 </span><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"accountForm.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\" translate=\"BOOTSTRAP.FORM.NAME\">Company\n</span></span></md-tab-label><md-tab-body><form name=\"accountForm\" class=\"md-inline-form\" ms-form-wizard-form \nnovalidate><div class=\"explanation\"><div layout=\"column\" layout-gt-xs=\"row\" flex><span class=\"md-title\" \ntranslate=\"BOOTSTRAP.FORM.INFO\">Informations about your company</span></div><div layout=\"column\" layout-gt-xs=\"row\" \nflex><span class=\"md-subhead\" translate=\"BOOTSTRAP.FORM.LOCATION\">We have to know where you company is located.</span>\n</div></div><div layout-xs=\"column\" layout=\"row\"><div flex=\"20\"><md-input-container class=\"md-block\"><input \nname=\"name\" ng-model=\"vm.form.account.name\" placeholder=\"{{ \'BOOTSTRAP.FORM.COMPANY.LABEL\' | translate }}\" required>\n<div ng-messages=\"accountForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BOOTSTRAP.FORM.COMPANY.REQUIRED\">Account name field is required</span></div></div></md-input-container>\n</div><div flex=\"20\"><md-input-container class=\"md-block\"><input name=\"contactName\" \nng-model=\"vm.form.account.contact.name\" placeholder=\"{{ \'BOOTSTRAP.FORM.MANAGER.LABEL\' | translate }}\" required><div \nng-messages=\"accountForm.contactName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BOOTSTRAP.FORM.MANAGER.REQUIRED\">Contact name field is required</span></div></div></md-input-container>\n</div><div flex=\"20\"><md-input-container class=\"md-block\"><input type=\"email\" name=\"email\" \nng-model=\"vm.form.account.contact.email\" placeholder=\"{{ \'BOOTSTRAP.FORM.EMAIL.LABEL\' | translate }}\" email-validation \nrequired><div ng-messages=\"accountForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"BOOTSTRAP.FORM.EMAIL.REQUIRED\">E-mail field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"BOOTSTRAP.FORM.EMAIL.VALID\">Must be a valid e-mail address</span></div></div></md-input-container></div><div\n flex=\"15\"><md-input-container class=\"md-block\"><input name=\"phoneNumber\" ui-br-phone-number \nng-model=\"vm.form.account.contact.phone\" placeholder=\"{{ \'BOOTSTRAP.FORM.PHONE.LABEL\' | translate }}\" required><div \nng-messages=\"accountForm.phoneNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BOOTSTRAP.FORM.PHONE.REQUIRED\">Phone number field is required</span></div></div></md-input-container></div>\n<div flex><md-input-container class=\"md-block\"><label translate=\"BOOTSTRAP.FORM.COUNTRY.LABEL\">Country</label>\n<md-select placeholder=\"Select a country\" translate translate-attr-placeholder=\"BOOTSTRAP.FORM.COUNTRY.PLACEHOLDER\" \nng-model=\"vm.form.account.address.countryCode\" ng-change=\"vm.handleTimezoneCountryFlagsAndAddress();\" required>\n<md-option ng-value=\"country.code\" ng-repeat=\"country in vm.countries\">{{ ::country.name }}</md-option></md-select>\n</md-input-container></div></div><div layout-xs=\"column\" layout=\"row\"><div flex=\"{{ vm.timezoneFlexValue }}\">\n<md-input-container class=\"md-block\"><label translate=\"BOOTSTRAP.FORM.TIMEZONE.LABEL\">Time zone</label><md-select \nplaceholder=\"Select a time zone\" name=\"timezone\" ng-model=\"vm.form.account.timezone\" translate \ntranslate-attr-placeholder=\"BOOTSTRAP.FORM.TIMEZONE.PLACEHOLDER\"><md-option ng-value=\"timezone.id\" \nng-repeat=\"timezone in vm.timezones\">{{ timezone.name }}</md-option></md-select></md-input-container></div><div flex \nlayout-xs=\"column\" layout=\"row\" ng-if=\"!vm.isSelectedCountryBrasil\"><div flex ng-if=\"!vm.hasAccountAddress\">\n<md-autocomplete flex ng-required=\"!vm.isSelectedCountryBrasil\" \nng-blur=\"vm.addressService.validateAddress(vm.formErr);\" md-input-id=\"auto-complete-address\" \nmd-input-name=\"auto-complete-address\" md-input-minlength=\"2\" md-input-maxlength=\"150\" md-no-cache=\"false\" \nmd-selected-item-change=\"vm.addressChanged()\" md-selected-item=\"vm.selectedAccountAddress\" \nmd-search-text=\"vm.selectedAccountAddressText\" \nmd-items=\"item in vm.addressService.searchAddress(vm.selectedAccountAddressText, { global: true })\" \nmd-autoselect=\"true\" md-delay=\"1500\" md-item-text=\"item.formattedAddress\" \nmd-floating-label=\"{{ \'BOOTSTRAP.FORM.ADDRESS.LABEL\' | translate }}\" md-menu-class=\"autocomplete-custom-template\">\n<md-item-template><span class=\"item-title\"><md-icon class=\"s18\" md-font-icon=\"icon-map-marker\"></md-icon><span>\n{{ item.formattedAddress }}</span></span></md-item-template><md-not-found><span class=\"item-title\"><md-icon \nclass=\"s18\" md-font-icon=\"icon-map-marker-off\"></md-icon><span translate=\"BOOTSTRAP.FORM.ADDRESS.NOT_FOUND\">\nAddress can\'t be found, change your search and try again.</span></span></md-not-found><div class=\"hint\" \nng-if=\"!vm.formErr[\'accountAddressIsRequired\'] && !accountForm[\'auto-complete-address\'].$error\"><span \ntranslate=\"BOOTSTRAP.FORM.ADDRESS.SEARCH_EXAMPLE\">Search an address, e.g.: 3501 S La Cienega Blvd, Los Angeles</span>\n</div><div class=\"hint\" ng-if=\"vm.formErr[\'accountAddressIsRequired\'] && vm.selectedAccountAddressText.length\"><span \nng-bind-html=\"vm.formErr[\'accountAddressIsRequired\']\"></span></div><div \nng-messages=\"accountForm[\'auto-complete-address\'].$error\" ng-if=\"accountForm[\'auto-complete-address\'].$touched\"><div \nng-message=\"required\"><span translate=\"BOOTSTRAP.FORM.ADDRESS.REQUIRED\">Address field is required</span></div></div>\n</md-autocomplete></div><div flex ng-if=\"vm.hasAccountAddress\"><md-input-container class=\"md-block\"><label \ntranslate=\"BOOTSTRAP.FORM.ADDRESS.LABEL_ACCOUNT\">Account Address</label><input id=\"formattedAddress\" \nname=\"formattedAddress\" ng-model=\"vm.form.account.address.formattedAddress\" disabled=\"disabled\"><div class=\"hint\" \nng-if=\"!vm.form.account.address.number\"><md-icon md-font-icon=\"icon-alert\" class=\"red-fg fs-16\"></md-icon><span \nclass=\"ml-7n\" translate=\"BOOTSTRAP.FORM.ADDRESS.NUMBER_NOT_SPECIFIED\">Number address not specified.</span></div>\n</md-input-container></div><div flex=\"5\" ng-if=\"vm.hasAccountAddress\"><md-button id=\"clear-account-address\" \nng-click=\"vm.clearSelectedAccountAddress($event);\" class=\"md-icon-button md-accent md-block clear-address\" \naria-label=\"{{ \'BOOTSTRAP.FORM.ADDRESS.CLEAR\' | translate }}\"><md-icon md-font-icon=\"icon icon-close-circle-outline\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"BOOTSTRAP.FORM.ADDRESS.CLEAR\">Clear address</span>\n</md-tooltip></md-button></div></div><div flex=\"85\" layout-xs=\"column\" layout=\"row\" ng-if=\"vm.isSelectedCountryBrasil\">\n<div flex=\"15\"><md-input-container class=\"md-block\"><label translate=\"BOOTSTRAP.FORM.ZIPCODE.LABEL\">Zip Code</label>\n<input ui-mask=\"99999-999\" ng-blur=\"vm.cepDb();\" id=\"zipCode\" name=\"zipCode\" \nng-model=\"vm.form.account.address.zipCode\" required><div ng-messages=\"accountForm.zipCode.$error\" \nng-show=\"accountForm.zipCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BOOTSTRAP.FORM.ZIPCODE.REQUIRED\">Zip code field is required</span></div></div></md-input-container></div>\n<div flex=\"25\"><md-input-container class=\"md-block\"><label translate=\"BOOTSTRAP.FORM.CITY.LABEL\">City</label><input \nname=\"city\" ng-model=\"vm.form.account.address.city\" required><div ng-messages=\"accountForm.city.$error\" \nng-show=\"accountForm.city.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BOOTSTRAP.FORM.CITY.REQUIRED\">City field is required</span></div></div></md-input-container></div><div \nflex=\"15\"><md-input-container class=\"md-block\"><label translate=\"BOOTSTRAP.FORM.STATE.LABEL\">State</label><input \nname=\"state\" ng-model=\"vm.form.account.address.state\" required><div ng-messages=\"accountForm.state.$error\" \nng-show=\"accountForm.state.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BOOTSTRAP.FORM.STATE.REQUIRED\"></span>State field is required</div></div></md-input-container></div><div \nflex=\"30\"><md-input-container class=\"md-block\"><label translate=\"BOOTSTRAP.FORM.STREET.LABEL\">Address</label><input \nname=\"street\" ng-model=\"vm.form.account.address.street\" required><div ng-messages=\"accountForm.street.$error\" \nng-show=\"accountForm.street.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BOOTSTRAP.FORM.STREET.REQUIRED\">Address field is required</span></div></div></md-input-container></div><div \nflex=\"10\"><md-input-container class=\"md-block\"><label translate=\"BOOTSTRAP.FORM.NUMBER.LABEL\">Number</label><input \nid=\"number\" name=\"number\" ng-blur=\"vm.geoCoderAddress();\" ng-keyup=\"vm.geoCoderAddress();\" \nng-model=\"vm.form.account.address.number\" required><div ng-messages=\"accountForm.number.$error\" \nng-show=\"accountForm.number.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BOOTSTRAP.FORM.NUMBER.REQUIRED\">Number field is required</span></div></div></md-input-container></div><div \nflex=\"5\" ng-if=\"vm.geocodingAddress == true\" style=\"margin-top:17px\"><md-progress-circular id=\"geocoder-progress\" \nclass=\"md-accent mleft-10\" md-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular></div><div flex=\"5\" \nclass=\"mtop-10\" layout-align=\"center center\" \nng-if=\"vm.geocodingAddress == false || vm.form.account.address.coords.latitude && vm.form.account.address.coords.longitude\">\n<a style=\"text-decoration: none\" target=\"_blank\" aria-label=\"Local\" \nhref=\"https://maps.google.com/?q={{vm.form.account.address.coords.latitude}},{{vm.form.account.address.coords.longitude}}\">\n<md-tooltip md-direction=\"bottom\" md-delay=\"1\">\n{{ \'BOOTSTRAP.FORM.ADDRESS.LATITUDE\' | translate }}: {{vm.form.account.address.coords.latitude}}, {{ \'BOOTSTRAP.FORM.ADDRESS.LONGITUDE\' | translate }}: {{vm.form.account.address.coords.longitude}}\n</md-tooltip><i style=\"color: rgb(33,150,243)\" class=\"icon icon-map-marker s40\"></i></a></div></div></div><div \nlayout-xs=\"column\" layout=\"row\"><input type=\"hidden\" id=\"latitude\" name=\"latitude\" \nng-model=\"vm.form.account.address.coords.latitude\" required> <input type=\"hidden\" id=\"longitude\" name=\"longitude\" \nng-model=\"vm.form.account.address.coords.longitude\" required></div></form><div \nclass=\"fc-warning-container fc-warning-container--large fc-warning-container--red\" ng-if=\"vm.isInvalidAddress\"><md-icon\n class=\"warning-icon\" md-svg-src=\"assets/icons/icon-warning-alert.svg\"></md-icon><span \ntranslate=\"BOOTSTRAP.WARNING.TEXT\"></span></div></md-tab-body></md-tab><md-tab \nng-disabled=\"accountForm.$invalid || msWizard.selectedIndex < 1\"><md-tab-label><span class=\"ms-form-wizard-step-label\">\n<span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"appForm.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"appForm.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\" translate=\"BOOTSTRAP.APP.NAME\">App</span></span></md-tab-label><md-tab-body><form \nname=\"appForm\" ms-form-wizard-form novalidate><div class=\"explanation\" layout=\"column\" layout-gt-md=\"row\" \nlayout-align=\"center center\"><div class=\"content app-download-container\" flex layout=\"column\" \nlayout-align=\"start center\"><span class=\"md-text\" translate=\"BOOTSTRAP.APP.DOWNLOAD\">\nDownload the app for your smartphone operating system </span><a \nhref=\"https://itunes.apple.com/br/app/field-control/id1224737324?mt=8\" target=\"_blanc\" \nclass=\"content-box app-download-link\"><div><img src=\"assets/images/logos/apple.png\" alt=\"iOS\"> <span \ntranslate=\"BOOTSTRAP.APP.APP_STORE\">download at app store</span></div></a><a \nhref=\"https://play.google.com/store/apps/details?id=com.fieldcontrol.orc\" target=\"_blanc\" \nclass=\"content-box app-download-link\"><div><img src=\"assets/images/logos/android-blue.png\" alt=\"Android\"> <span \ntranslate=\"BOOTSTRAP.APP.GOOGLE_PLAY\">download at google play</span></div></a></div></div></form></md-tab-body>\n</md-tab></md-tabs><div class=\"navigation-container\" layout=\"column\" layout-gt-xs=\"row\" flex><div \nclass=\"navigation controls-wizard\" flex layout=\"row\" layout-align=\"center\"><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.previousStep();\" ng-disabled=\"msWizard.isFirstStep()\" translate=\"BOOTSTRAP.PREVIOUS\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{ \'selected md-accent-bg\':msWizard.selectedIndex === $index }\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.nextStep(msWizard);\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid() || vm.isInvalidAddress\" translate=\"BOOTSTRAP.NEXT\">Next</md-button>\n<md-button class=\"md-raised md-default\" ng-click=\"vm.startUsingFieldControl()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || vm.employeesCount === 0\" translate=\"BOOTSTRAP.FINISH\">Finish</md-button>\n</div></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/main/calendar/calendar.html","<div id=\"calendar\" ng-if=\"!vm.canShowNewCalendar && !vm.isLoading\" \nclass=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\" translate=\"CALENDAR.TITLE\">Calendar</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-button data-cy=\"tasks-add-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.createTask($event)\" \naria-label=\"Add task\" ng-if=\"!vm.accountConfiguration.featureDisableAddTask && vm.addPermission\" translate \ntranslate-attr-aria-label=\"CALENDAR.TASKS.ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.TASKS.ADD\">Add task</span></md-tooltip></md-button><md-button id=\"create-task-button-disabled\" \nng-if=\"!vm.accountConfiguration.featureDisableAddTask && !vm.addPermission\" \nclass=\"md-icon-button md-accent md-mini button-white-bg md-button-disabled-css no-padding-important\" \naria-label=\"You are not allowed to create tasks\" translate \ntranslate-attr-aria-label=\"CONTROL_PANEL.TOOLBAR.CREATE_TASK.NO_PERMISSION\"><md-icon md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip><span translate=\"CONTROL_PANEL.TOOLBAR.CREATE_TASK.NO_PERMISSION\">\nYou are not allowed to create tasks</span></md-tooltip></md-button><md-button id=\"create-task-button-disabled-account\" \nng-if=\"vm.accountConfiguration.featureDisableAddTask === true\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important md-button-disabled-css\" \naria-label=\"Add task\" translate translate-attr-aria-label=\"CALENDAR.TASKS.ADD\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip><span translate=\"CALENDAR.TASKS.NO_PERMISSION\">Cannot create tasks</span></md-tooltip>\n</md-button><md-button ng-if=\"vm.calendarTasksFilter.isOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.calendarTasksFilter.clear()\" aria-label=\"Clear Filters\" translate \ntranslate-attr-aria-label=\"CALENDAR.FILTERS.CLEAR\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip>\n<span translate=\"CALENDAR.FILTERS.CLEAR\">Clear Filters</span></md-tooltip></md-button><md-button \nng-click=\"vm.toggleSidenav(\'calendar-filters-sidenav\')\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Filter Routes\" translate \ntranslate-attr-aria-label=\"CALENDAR.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.FILTER\">Filter</span></md-tooltip></md-button><md-button data-cy=\"reload-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.reload()\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"CALENDAR.RELOAD\"><md-icon md-font-icon=\"icon-reload\">\n</md-icon><md-tooltip><span translate=\"CALENDAR.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nng-if=\"(!vm.hideFeedbackForm || vm.hideFeedbackForm === \'false\') && !vm.canShowNewCalendarButton\" \nclass=\"fc-warning-container fc-warning-container--inside-tab calendar-feedback\"><div \nstyle=\"display: flex; flex-direction: row; gap: 12px\"><md-icon \nstyle=\"color: blue; height: 20px !important; min-height: 20px !important\" md-svg-src=\"assets/icons/feedback.svg\">\n</md-icon><div class=\"calendar-feedback-div\"><span translate=\"CALENDAR.FEEDBACK_FORM\">Feedback form</span></div></div>\n<md-button style=\"padding-top: 6px !important\" class=\"md-icon-button\" ng-click=\"vm.closeFeedback();\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon style=\"color: #135AC0\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div ng-if=\"vm.canShowNewCalendarButton\" \nclass=\"fc-warning-container fc-warning-container--inside-tab launch-banner\"><div \nstyle=\"display: flex; flex-direction: row; gap: 12px\"><md-icon \nstyle=\"color: #E51A80 !important; height: 20px !important; min-height: 20px !important\" \nmd-svg-src=\"assets/icons/rocket.svg\"></md-icon><div class=\"calendar-feedback-div\"><span \ntranslate=\"CALENDAR.LAUNCH_DIALOG.BANNER_TEXT\"></span></div></div><span ng-click=\"vm.openLaunchDialog();\" \nclass=\"call-to-action\" translate=\"CALENDAR.LAUNCH_DIALOG.RIGHT_BUTTON\"></span></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"calendar-header\"><div ng-if=\"!loadingProgress\" \nclass=\"calendar-header__period-navigation\"><md-button class=\"md-icon-button arrow\" ng-disabled=\"$root.loadingProgress\" \nng-click=\"vm.prev()\" aria-label=\"Previous\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{ vm.calendarView.title }}</div><md-button \nclass=\"md-icon-button arrow\" ng-disabled=\"$root.loadingProgress\" ng-click=\"vm.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div \nng-if=\"!loadingProgress\" class=\"calendar-header__view-mode\"><md-button ng-click=\"vm.calendar.changeView(\'agendaDay\')\" \nclass=\"md-accent md-raised md-button\"><span translate=\"CALENDAR.DAY\">Day</span></md-button><md-button \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" class=\"md-accent md-raised md-button\"><span translate=\"CALENDAR.WEEK\">\nWeek</span></md-button><md-button ng-click=\"vm.calendar.changeView(\'month\')\" class=\"md-accent md-raised md-button\">\n<span translate=\"CALENDAR.MONTH\">Month</span></md-button></div></div><div class=\"calendar-wrapper\"><div \nid=\"loader-calendar-tasks\" class=\"calendar-wrapper__loading-calendar-task\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"loadingProgress\"><div \nclass=\"calendar-wrapper__loading-calendar-task__progress-circular\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div translate=\"CALENDAR.CONTENT.LOADING\">\nLoading tasks...</div></div></div><div id=\"calendarView\" ui-calendar=\"calendarUiConfig.calendar\" \nng-model=\"eventSources\" calendar=\"main\"></div></div></div></div><md-sidenav class=\"filters-sidenav md-sidenav-right\" \nmd-component-id=\"calendar-filters-sidenav\" ng-include=\"\'app/main/calendar/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"CalendarFiltersSidenavController as vm\" ms-sidenav-helper></md-sidenav><md-menu id=\"calendarMoreMenu\" \nmd-position-mode=\"target target\" ng-if=\"true\"><md-button id=\"calendarMoreMenuBtn\" md-menu-origin \nstyle=\"position:fixed; display:none\"></md-button><md-menu-content width=\"4\" class=\"more-tasks-menu\"><md-menu-item \nng-repeat=\"task in vm.moreTasks\" ng-click=\"$event.stopPropagation(); vm.openOrderDialog(task, $event)\" \nclass=\"fc-day-grid-event fc-event more-tasks-menu--item\" \nng-style=\"{\'background-color\': task.color, \'border-color\': task.color}\"><div class=\"fc-content\" \ncalendar-tooltip-menu=\"task\"><div class=\"fc-content--inner\"><span class=\"fc-title\">{{ task.title }}</span><div \nclass=\"fc-time\" ng-if=\"task.startTime\">{{ task.startTime }}</div></div><img ng-if=\"task.employeeAvatar\" \nng-src=\"{{task.employeeAvatar}}\" class=\"calendar-avatar-icon\" alt=\"{{task.employeeName}}\"></div></md-menu-item>\n<md-menu-item ng-if=\"vm.loadingMore\" class=\"loading-more\" ng-repeat=\"i in [].constructor(3) track by $index\"><div \nclass=\"fc-skeleton\"></div></md-menu-item></md-menu-content></md-menu></div><calendar-page \nng-show=\"vm.canShowNewCalendar && !vm.isLoading\"></calendar-page>");
$templateCache.put("app/main/control-panel/control-panel.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav control-panel\" layout=\"row\" \nng-if=\"!vm.isLoading && !(vm.canShowNewTodayTaskList && state.current.name == \'app.control-panel.list\')\"><div \nclass=\"center down-margin\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \nng-if=\"$root.controlPanel.activeView == \'gantt\'\" translate=\"CONTROL_PANEL.TIMELINE\">Timeline</span> <span \nng-if=\"$root.controlPanel.activeView == \'map\'\" translate=\"CONTROL_PANEL.MAP\">Map</span> <span \nng-if=\"state.current.name == \'app.control-panel.list\'\" translate=\"CONTROL_PANEL.TASKS_OF_DAY\">Tasks of day</span></div>\n<div><md-button class=\"md-accent md-mini button-white-bg tutorial-video\" aria-label=\"Play\" \nng-click=\"vm.openVideoTutorial()\" ng-if=\"$root.controlPanel.activeView == \'gantt\'\"><md-icon \nmd-font-icon=\"icon-play-circle\"></md-icon><span translate=\"CONTROL_PANEL.TUTORIAL_VIDEO.TITLE\"></span><md-tooltip><span\n translate=\"CONTROL_PANEL.TUTORIAL_VIDEO.TOOLTIP\">Assistir vídeo explicativo.</span></md-tooltip></md-button></div>\n</div><div layout=\"row\" layout-align=\"end center\" flex><form name=\"mapDate\" class=\"form__control-panel\"><md-datepicker \nclass=\"margin-right-0\" ng-model=\"vm.selectedDate\" required data-cy=\"controlPanelDatePicker\" name=\"dateControlPanel\" \nng-change=\"vm.selectedDateChanged();\" md-placeholder=\"{{ \'CONTROL_PANEL.TOOLBAR.DATE.PLACEHOLDER\' | translate }}\">\n</md-datepicker><div layout=\"row\" role=\"alert\" class=\"fs-15 date-error\" ng-messages=\"mapDate.dateControlPanel.$error\" \nng-show=\"mapDate.dateControlPanel.$invalid\"><div layout=\"row\" ng-messages=\"mapDate.dateControlPanel.$required\" \nrole=\"alert\" class=\"fs-15\"><small data-cy=\"controlPanelEmptyDateError\"><span class=\"red-text\" \ntranslate=\"CONTROL_PANEL.ERROR.DATE_REQUIRED\">Scheduled date is invalid</span></small></div></div></form><md-button \nng-click=\"vm.createTask($event);\" \nng-disabled=\"vm.data.options.isPastDate || vm.accountConfiguration.featureDisableAddTask\" id=\"create-task-button\" \nng-if=\"vm.addPermission\" data-cy=\"tasks-add-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Create new task\" translate \ntranslate-attr-aria-label=\"CONTROL_PANEL.TOOLBAR.CREATE_TASK.TOOLTIP\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip><span translate=\"CONTROL_PANEL.TOOLBAR.CREATE_TASK.TOOLTIP\">Create new task</span></md-tooltip></md-button>\n<md-button id=\"create-task-button-disabled\" ng-if=\"!vm.addPermission\" \nclass=\"md-icon-button md-accent md-mini button-white-bg md-button-disabled-css no-padding-important\" \naria-label=\"You are not allowed to create tasks\" translate \ntranslate-attr-aria-label=\"CONTROL_PANEL.TOOLBAR.CREATE_TASK.NO_PERMISSION\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip><span translate=\"CONTROL_PANEL.TOOLBAR.CREATE_TASK.NO_PERMISSION\">\nYou are not allowed to create tasks</span></md-tooltip></md-button><md-button ng-if=\"vm.accountPlan !== \'test\'\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate \ntranslate-attr-aria-label=\"CONTROL_PANEL.TOOLBAR.OPTIMIZE_ROUTES.TOOLTIP\" ng-click=\"vm.openRouteOptimizer($event)\" \nng-disabled=\"vm.data.options.isPastDate\"><md-icon md-font-icon=\"icon-directions\"></md-icon><md-tooltip><span \ntranslate=\"CONTROL_PANEL.TOOLBAR.OPTIMIZE_ROUTES.TOOLTIP\">Optimize routes</span></md-tooltip></md-button><md-button \nng-if=\"vm.accountPlan === \'test\'\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate translate-attr-aria-label=\"CONTROL_PANEL.TOOLBAR.OPTIMIZE_ROUTES.TOOLTIP\" \nng-click=\"vm.openLegacyRouteOptimizer($event)\" ng-disabled=\"vm.data.options.isPastDate\"><md-icon \nmd-font-icon=\"icon-directions\"></md-icon><md-tooltip><span translate=\"CONTROL_PANEL.TOOLBAR.OPTIMIZE_ROUTES.TOOLTIP\">\nOptimize routes</span></md-tooltip></md-button><md-button ng-if=\"vm.accountPlan === \'test\'\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate \ntranslate-attr-aria-label=\"CONTROL_PANEL.TOOLBAR.OPTIMIZE_ROUTES.TOOLTIP\" \nng-click=\"vm.openAdvancedRouteOptimizer($event)\" ng-disabled=\"vm.data.options.isPastDate\"><md-icon \nmd-font-icon=\"icon-directions\"></md-icon><md-tooltip><span translate=\"CONTROL_PANEL.TOOLBAR.OPTIMIZE_ROUTES.TOOLTIP\">\nOptimize routes</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"CONTROL_PANEL.TOOLBAR.FILTERS.CLEAR\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"CONTROL_PANEL.TOOLBAR.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button><md-button data-cy=\"filter-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter tasks\" translate \ntranslate-attr-aria-label=\"CONTROL_PANEL.TOOLBAR.FILTERS.TOOLTIP\"><md-icon md-font-icon=\"icon-filter\"></md-icon>\n<md-tooltip><span translate=\"CONTROL_PANEL.TOOLBAR.FILTERS.TOOLTIP\">Filter tasks</span></md-tooltip></md-button>\n<md-button data-cy=\"reload-button\" id=\"reload-tasks-button\" ng-click=\"vm.loadData(true);\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"CONTROL_PANEL.TOOLBAR.RELOAD.TOOLTIP\"><md-icon md-font-icon=\"icon-reload\"></md-icon>\n<md-tooltip><span translate=\"CONTROL_PANEL.TOOLBAR.RELOAD.TOOLTIP\">Reload</span></md-tooltip></md-button></div></div>\n<div ng-if=\"vm.canShowNewTodayTaskButton && state.current.name == \'app.control-panel.list\'\" \nclass=\"fc-warning-container fc-warning-container--inside-tab launch-banner\"><div \nstyle=\"display: flex; flex-direction: row; gap: 12px\"><md-icon \nstyle=\"color: #E51A80 !important; height: 20px !important; min-height: 20px !important\" \nmd-svg-src=\"assets/icons/rocket.svg\"></md-icon><div><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.LAUNCH_DIALOG.BANNER_TEXT\"></span></div></div><span \nng-click=\"vm.openLaunchDialog();\" class=\"open-launch-dialog\" \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.LAUNCH_DIALOG.RIGHT_BUTTON\"></span></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content\" layout=\"column\" flex><md-content flex layout=\"column\" \nng-style=\"{\'position\': isListView ? \'inherit\' : \'relative\'}\" ui-view=\"controlPanelContent\"></md-content></div></div>\n</div><md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"filters-sidenav\" \nng-include=\"\'app/main/control-panel/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"FiltersSidenavController as vm\" ms-sidenav-helper></md-sidenav></div><today-task-list-page \nng-if=\"!vm.isLoading && (vm.canShowNewTodayTaskList && state.current.name == \'app.control-panel.list\')\">\n</today-task-list-page>");
$templateCache.put("app/main/customers/customers.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"CUSTOMERS.TITLE\">\nCustomers</span><div layout=\"row\"><md-button class=\"md-accent md-mini button-white-bg tutorial-video\" \naria-label=\"Play\" ng-click=\"vm.openVideoTutorial()\"><md-icon md-font-icon=\"icon-play-circle\"></md-icon><span \ntranslate=\"CUSTOMERS.TUTORIAL_VIDEO.TITLE\"></span><md-tooltip><span translate=\"CUSTOMERS.TUTORIAL_VIDEO.TOOLTIP\">\nAssistir vídeo explicativo.</span></md-tooltip></md-button></div></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"end center\" flex><md-menu md-position-mode=\"left bottom\" ng-if=\"vm.showIntegrationButton(\'Omie\');\" \nng-hide=\"vm.showMap\"><md-button class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"$mdOpenMenu();\"><md-icon md-svg-src=\"assets/icons/icon-omie-active.svg\" class=\"icon-customer-import\">\n</md-icon><md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.IMPORT_FROM\" translate-value-app=\"Omie\">\nImport customers from Omie</span></md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.openCustomersImportManualDialog($event, \'Omie\')\"><span translate=\"CUSTOMERS.TOOLBAR.MANUAL_IMPORT\">\nManual import</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.openCustomersImportAutomaticDialog($event, \'Omie\')\"><span translate=\"CUSTOMERS.TOOLBAR.AUTOMATIC_IMPORT\">\nAutomatic import</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-click=\"vm.openCustomersImportManualDialog($event, \'Conta Azul\')\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" \nng-if=\"vm.showIntegrationButton(\'Conta Azul\');\"><md-icon md-svg-src=\"assets/icons/icon-conta-azul-active.svg\" \nclass=\"icon-customer-import\"></md-icon><md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.IMPORT_FROM\" \ntranslate-value-app=\"Conta Azul\">Import customers from Conta Azul</span></md-tooltip></md-button><md-button \nng-click=\"vm.toggleMapView()\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-disabled=\"vm.loadingMap\" aria-label=\"{{vm.showMap ? \'Table visualization\' : \'Map visualization\'}}\" translate \ntranslate-attr-aria-label=\"{{vm.showMap ? \'CUSTOMERS.TOOLBAR.TABLE_VIEW\' : \'CUSTOMERS.TOOLBAR.MAP_VIEW\'}}\"><md-icon \nmd-font-icon=\"{{vm.showMap ? \'icon-table\' : \'icon-map\'}}\"></md-icon><md-tooltip><span \ntranslate=\"{{vm.showMap ? \'CUSTOMERS.TOOLBAR.TABLE_VIEW\' : \'CUSTOMERS.TOOLBAR.MAP_VIEW\'}}\">\n{{vm.showMap ? \'Table visualization\' : \'Map visualization\'}}</span></md-tooltip></md-button><md-button \nng-click=\"vm.exportData(\'print\', \'buttons-print\');\" ng-disabled=\"vm.exportingDataLoading\" ng-hide=\"vm.showMap\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Print\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.TOOLBAR.PRINT\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip><span \ntranslate=\"CUSTOMERS.TOOLBAR.PRINT\">Print</span></md-tooltip></md-button><md-button \nng-click=\"vm.exportData(\'export\', \'buttons-excel\');\" ng-hide=\"vm.showMap\" ng-disabled=\"vm.exportingDataLoading\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Export to Excel\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.TOOLBAR.EXPORT_TO_EXCEL\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>\n<md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.EXPORT_TO_EXCEL\">Export to Excel</span></md-tooltip></md-button>\n<md-button ng-if=\"vm.dtLocalStorageStatus();\" ng-click=\"vm.dtLocalStorageRemove();\" ng-hide=\"vm.showMap\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Restore columns\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.TOOLBAR.RESTORE_COLUMNS\"><md-icon md-font-icon=\"icon-table\"></md-icon><md-tooltip>\n<span translate=\"CUSTOMERS.TOOLBAR.RESTORE_COLUMNS\">Restore columns</span></md-tooltip></md-button><md-menu \nmd-position-mode=\"left bottom\"><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"$mdOpenMenu();\" \nng-hide=\"vm.showMap\" aria-label=\"Switch columns\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.TOOLBAR.SWITCH_COLUMNS\"><md-icon md-font-icon=\"icon-table-edit\"></md-icon>\n<md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.SWITCH_COLUMNS\">Switch columns</span></md-tooltip></md-button>\n<md-menu-content width=\"3\"><md-menu-item \nng-if=\"(vm.dtColumns.length - 1) > $index && $index > 0 && column.sTitle !== (\'CUSTOMERS.TABLE.LABELS\' | translate)\" \nng-repeat=\"column in vm.dtColumns track by $index\"><md-button ng-click=\"vm.toggleColumnVisibility($index);\" \nmd-prevent-menu-close=\"md-prevent-menu-close\"><span ng-class=\"{ \'line-thru\': !vm.isColumnVisible($index) }\">\n{{column.sTitle}}</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \ndata-cy=\"customers-add-button\" ng-click=\"vm.addCustomer($event)\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-disabled=\"vm.loadingMap || vm.accountConfiguration.featureDisableAddCustomer || !vm.addPermission\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.ADD\">Add customer</span></md-tooltip>\n</md-button><md-button data-cy=\"customers-clear-filters-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" \nng-if=\"vm.filteringIsOn()\" ng-click=\"vm.clearFilters()\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon>\n<md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.CLEAR_FILTERS\">Clear filters</span></md-tooltip></md-button><md-button \ndata-cy=\"customers-filter-button\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-hide=\"vm.showMap\" ng-click=\"vm.toggleSidenav(\'customers-filters-sidenav\')\"><md-icon md-font-icon=\"icon-filter\">\n</md-icon><md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.FILTER_CUSTOMERS\">Filter customers</span></md-tooltip>\n</md-button><md-button data-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" aria-label=\"Reload\" \ntranslate translate-attr-aria-label=\"CUSTOMERS.TOOLBAR.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon>\n<md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nclass=\"content-card customer-map-down-margin\" layout=\"column\" ng-class=\"{\'loader-map\': !vm.map && vm.showMap}\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" ng-show=\"!vm.showMap\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-customers\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div><leaflet id=\"customersMap\" ng-if=\"vm.map\" ng-show=\"vm.showMap\" \nmarkers=\"vm.map.markers\" lf-center=\"vm.map.center\" controls=\"vm.map.controls\" layers=\"vm.map.layers\" height=\"100%\" \nwidth=\"100%\"></leaflet><div ng-show=\"!vm.map && vm.showMap\" class=\"map-loader\"><h3 translate=\"CUSTOMERS.MAP.LOADER\">\nLoading customer map ...</h3><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear></div></div></div>\n<md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"customers-filters-sidenav\" \nng-include=\"\'app/main/customers/sidenavs/filters-sidenav.html\'\" \nng-controller=\"CustomersFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/deadline-contracts/deadline-contracts.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"DEADLINE-CONTRACTS.TITLE\">Contracts</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"end center\" flex><md-button data-cy=\"add-button\" ng-click=\"vm.openDialogContract($event)\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"DEADLINE-CONTRACTS.NEW\" ng-disabled=\"!vm.account.configuration.moduleOrdersDeadlineEnabled\" \naria-label=\"New contracts\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><span \ntranslate=\"DEADLINE-CONTRACTS.NEW\">New contracts</span></md-tooltip></md-button><md-button \ndata-cy=\"clear-filters-button\" ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"DEADLINE-CONTRACTS.FILTERS.CLEAR\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"DEADLINE-CONTRACTS.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button><md-button data-cy=\"filters-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'sla-contracts-filters-sidenav\')\" aria-label=\"Filter contracts\" translate \ntranslate-attr-aria-label=\"DEADLINE-CONTRACTS.FILTERS.TITLE\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip>\n<span translate=\"DEADLINE-CONTRACTS.FILTERS.TITLE\">Filter contracts</span></md-tooltip></md-button><md-button \ndata-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"DEADLINE-CONTRACTS.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"DEADLINE-CONTRACTS.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-contracts\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"sla-contracts-filters-sidenav\" \nng-include=\"\'app/main/deadline-contracts/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"DeadlineContractsFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/deadline-violations-reasons/deadline-violations-reasons.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.TITLE\">Violation Reasonn</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"end center\" flex><md-button data-cy=\"add-button\" \nng-click=\"vm.openDialogDeadlineViolationsReasons($event)\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"DEADLINE-VIOLATIONS-REASONS.NEW\" aria-label=\"New grounds violation\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip><span translate=\"DEADLINE-VIOLATIONS-REASONS.NEW\">New violation reason\n</span></md-tooltip></md-button><md-button data-cy=\"clear-filters-button\" ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.CLEAR\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button><md-button data-cy=\"filters-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'deadline-violations-reasons-filters-sidenav\')\" aria-label=\"Filter violation reason\" \ntranslate translate-attr-aria-label=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.TITLE\"><md-icon md-font-icon=\"icon-filter\">\n</md-icon><md-tooltip><span translate=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.TITLE\">Filter violation reason</span>\n</md-tooltip></md-button><md-button data-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"DEADLINE-VIOLATIONS-REASONS.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon>\n<md-tooltip><span translate=\"DEADLINE-VIOLATIONS-REASONS.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div\n class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"table-list\" datatable=\"\" class=\"dataTable row-border hover datatable-deadline-violation-reason\" \ndt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div>\n</div></div><md-sidenav class=\"filters-sidenav md-sidenav-right\" \nmd-component-id=\"deadline-violations-reasons-filters-sidenav\" \nng-include=\"\'app/main/deadline-violations-reasons/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"DeadlineViolationsReasonsSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/devices/devices.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"DEVICES.TITLE\">\nDevices</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-button \nng-click=\"vm.deleteAllDevices($event)\" class=\"md-icon-button md-warn md-mini button-white-bg no-padding-important\" \naria-label=\"Delete all\" translate translate-attr-aria-label=\"DEVICES.DELETE_ALL_ALERT.BUTTON\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"DEVICES.DELETE_ALL_ALERT.BUTTON\">Delete all</span>\n</md-tooltip></md-button><md-button ng-if=\"vm.devicesFilters.isOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.devicesFilters.clear()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"DEVICES.FILTERS.CLEAR\" data-cy=\"devices-filter-button\">\n<md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"DEVICES.FILTERS.CLEAR\">Clear Filters\n</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Filter devices\" translate \nng-click=\"vm.toggleSidenav(\'devices-filters-sidenav\')\" translate-attr-aria-label=\"DEVICES.FILTER\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip><span translate=\"DEVICES.FILTER\">Filter devices</span></md-tooltip>\n</md-button><md-button ng-click=\"vm.reload(true);\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"DEVICES.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"DEVICES.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-customers\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"devices-filters-sidenav\" \nng-include=\"\'app/main/devices/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"DevicesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/employees/employees.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"EMPLOYEES.TITLE\">\nEmployees</span></div><div class=\"product-count secondary-text\" ng-if=\"vm.account.plan.name === \'pro\'\"><b \ntranslate=\"EMPLOYEES.PRO.ACTIVE_COUNT\" \ntranslate-values=\"{ countActiveEmployees: vm.account.countActiveEmployees, planLicenses: vm.account.plan.licenses }\">\n{{ vm.account.countActiveEmployees }} out of {{ vm.account.plan.licenses }} qualified employees</b><br \nng-if=\"vm.account.isLimitExeeded\"><small class=\"md-red-900-bg banner\" ng-if=\"vm.account.isLimitExeeded\" \ntranslate=\"EMPLOYEES.PRO.ACTIVE_PERCENTAGE\" \ntranslate-values=\"{ activeEmployeesPercentage: vm.account.countActiveEmployeesPercentage }\">You are using <strong>\n{{ vm.account.countActiveEmployeesPercentage }}%</strong> of the contracted license limit.</small></div></div><div>\n<md-button class=\"md-accent md-mini button-white-bg tutorial-video\" aria-label=\"Play\" \nng-click=\"vm.openVideoTutorial()\"><md-icon md-font-icon=\"icon-play-circle\"></md-icon><span \ntranslate=\"EQUIPMENT_TYPES.TUTORIAL_VIDEO.TITLE\"></span><md-tooltip><span \ntranslate=\"EQUIPMENT_TYPES.TUTORIAL_VIDEO.TOOLTIP\">Assistir vídeo explicativo.</span></md-tooltip></md-button></div>\n<div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-button ng-click=\"vm.exportData();\" \nng-hide=\"vm.showMap\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"Export to Excel\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon><md-tooltip><span \ntranslate=\"EMPLOYEES.TOOLTIP.EXPORT_TO_EXCEL\">Export to Excel</span></md-tooltip></md-button><md-button \nng-click=\"vm.addEmployee($event)\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"EMPLOYEES.NEW.TITLE\" aria-label=\"Add employee\" data-cy=\"employees-create-button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip><span translate=\"EMPLOYEES.NEW\">New employee</span></md-tooltip>\n</md-button><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \ndata-cy=\"employees-clear-filters-button\" aria-label=\"Clear Filters\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.FILTERS.CLEAR\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip>\n<span translate=\"EMPLOYEES.FILTERS.CLEAR\">Clear Filters</span></md-tooltip></md-button><md-button \ndata-cy=\"employees-filter-button\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'employees-filters-sidenav\')\" aria-label=\"Filter Employees\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"EMPLOYEES.FILTER\">Filter Employees</span></md-tooltip></md-button><md-button \nng-click=\"vm.reloadDatatable();\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"EMPLOYEES.RELOAD\"><md-icon md-font-icon=\"icon-reload\">\n</md-icon><md-tooltip><span translate=\"EMPLOYEES.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"table-list\" datatable=\"\" class=\"dataTable row-border hover datatable-customers\" \ndt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div>\n</div></div><md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"employees-filters-sidenav\" \nng-include=\"\'app/main/employees/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"EmployeesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/equipment-types/equipment-types.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"EQUIPMENT_TYPES.TITLE\">Equipment Types</span></div></div><div><md-button \nclass=\"md-accent md-mini button-white-bg tutorial-video\" aria-label=\"Play\" ng-click=\"vm.openVideoTutorial()\"><md-icon \nmd-font-icon=\"icon-play-circle\"></md-icon><span translate=\"EQUIPMENT_TYPES.TUTORIAL_VIDEO.TITLE\"></span><md-tooltip>\n<span translate=\"EQUIPMENT_TYPES.TUTORIAL_VIDEO.TOOLTIP\">Assistir vídeo explicativo.</span></md-tooltip></md-button>\n</div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-button \nng-click=\"vm.addEquipmentTypes($event)\" data-cy=\"add-equipment-type-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-disabled=\"vm.account.configuration.featureDisableAddEquipmentType\" translate-attr-aria-label=\"EQUIPMENT_TYPES.NEW\" \naria-label=\"Add a equipment type\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><span \ntranslate=\"EQUIPMENT_TYPES.NEW\">New equipment type</span></md-tooltip></md-button><md-button \ndata-cy=\"clear-filters-button\" ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"EQUIPMENT_TYPES.CLEAR_FILTERS\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"EQUIPMENT_TYPES.FILTERS.CLEAR\">Clear filters\n</span></md-tooltip></md-button><md-button data-cy=\"filter-equipments-type-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'equipment-types-filters-sidenav\')\" aria-label=\"Filter Equipments\" translate \ntranslate-attr-aria-label=\"EQUIPMENT_TYPES.FILTER_EQUIPMENTS\"><md-icon md-font-icon=\"icon-filter\"></md-icon>\n<md-tooltip><span translate=\"EQUIPMENT_TYPES.FILTER\">Filter equipment types</span></md-tooltip></md-button><md-button \ndata-cy=\"reload-button\" ng-click=\"vm.loadEquipmentTypes();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"EQUIPMENT_TYPES.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"EQUIPMENT_TYPES.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-customers\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"equipment-types-filters-sidenav\" \nng-include=\"\'app/main/equipment-types/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"EquipmentTypesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/equipments/equipments.html","<div id=\"default-list\" class=\"page-layout carded fullwidth equipments-page with-filters-sidenav\" layout=\"row\"><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"EQUIPMENTS.TITLE\">Equipments</span></div></div><div><md-button \nclass=\"md-accent md-mini button-white-bg tutorial-video\" aria-label=\"Play\" ng-click=\"vm.openVideoTutorial()\"><md-icon \nmd-font-icon=\"icon-play-circle\"></md-icon><span translate=\"TASKS.TUTORIAL_VIDEO.TITLE\"></span><md-tooltip><span \ntranslate=\"TASKS.TUTORIAL_VIDEO.TOOLTIP\">Assistir vídeo explicativo.</span></md-tooltip></md-button></div><div \nclass=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-button ng-click=\"vm.addEquipments($event)\" \nng-disabled=\"vm.account.configuration.featureDisableAddEquipment\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"EQUIPMENTS.NEW\" aria-label=\"New equipment\" data-cy=\"equipments-add-button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip><span translate=\"EQUIPMENTS.NEW\">New equipment</span></md-tooltip>\n</md-button><md-button ng-if=\"vm.showQrCodeButton\" ng-click=\"vm.openQrCodeGenerator()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate \ntranslate-attr-aria-label=\"EQUIPMENTS.GENERATE_QR_CODE\" aria-label=\"Generate QR Code\"><md-icon \nmd-font-icon=\"icon-qrcode\"></md-icon><md-tooltip><span translate=\"EQUIPMENTS.GENERATE_QR_CODE\">Generate QR Code</span>\n</md-tooltip></md-button><md-button ng-click=\"vm.exportData();\" ng-disabled=\"!vm.totalRows\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Export to Excel\"><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon><md-tooltip><span translate=\"EQUIPMENTS.EXPORT_EXCEL\">Export to Excel</span>\n</md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear filters\" translate translate-attr-aria-label=\"EQUIPMENTS.FILTERS.CLEAR\" \ndata-cy=\"equipments-clear-filters-button\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span \ntranslate=\"EQUIPMENTS.FILTERS.CLEAR\">Clear filters</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'equipments-filters-sidenav\')\" aria-label=\"Filter equipments\" translate \ntranslate-attr-aria-label=\"EQUIPMENTS.FILTER\" data-cy=\"equipments-filter-button\"><md-icon md-font-icon=\"icon-filter\">\n</md-icon><md-tooltip><span translate=\"EQUIPMENTS.FILTER\">Filter equipments</span></md-tooltip></md-button><md-button \nng-click=\"vm.loadEquipments();\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"EQUIPMENTS.RELOAD\"><md-icon md-font-icon=\"icon-reload\">\n</md-icon><md-tooltip><span translate=\"EQUIPMENTS.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nng-if=\"!vm.hideFeedbackForm || vm.hideFeedbackForm === \'false\'\" \nclass=\"fc-warning-container fc-warning-container--inside-tab equipments-feedback\"><div \nstyle=\"display: flex; flex-direction: row; gap: 12px\"><md-icon \nstyle=\"color: blue; height: 20px !important; min-height: 20px !important\" md-svg-src=\"assets/icons/feedback.svg\">\n</md-icon><div class=\"equipments-feedback-div\"><span translate=\"EQUIPMENTS.FEEDBACK_FORM\">Feedback form</span> <a \nhref=\"https://forms.gle/YVi4a9f9ndhRaPa96\" target=\"_blank\" translate=\"CORE.CLICK_HERE\">Click here</a></div></div>\n<md-button style=\"padding-top: 6px !important\" class=\"md-icon-button\" ng-click=\"vm.closeFeedback();\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon style=\"color: #135AC0\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-customers\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"equipments-filters-sidenav\" \nng-include=\"\'app/main/equipments/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"EquipmentsFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/exports/exports.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div id=\"exports\" \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"EXPORTS.TITLE\">Exports</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex>\n<md-button ng-if=\"vm.filteringIsOn()\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear filters\" translate translate-attr-aria-label=\"EXPORTS.FILTERS.CLEAR\">\n<md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"EXPORTS.FILTERS.CLEAR\">Clear filters\n</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'exports-filters-sidenav\')\" aria-label=\"Filter exports\" translate \ntranslate-attr-aria-label=\"EXPORTS.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"EXPORTS.FILTER\">Filter exports</span></md-tooltip></md-button><md-button ng-click=\"vm.loadExports();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"EXPORTS.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"EXPORTS.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-customers\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"exports-filters-sidenav\" \nng-include=\"\'app/main/exports/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"ExportsFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/locations/locations.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"LOCATIONS.TITLE\">\nLocations</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-button \ndata-cy=\"locations-add-button\" ng-if=\"vm.userPermissionCreateLocations\" ng-click=\"vm.openAddLocationDialog($event)\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate \ntranslate-attr-aria-label=\"LOCATIONS.TOOLBAR.ADD\" aria-label=\"Add location\" \nng-disabled=\"vm.loadingMap || vm.account.configuration.featureDisableAddLocation\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip><span translate=\"LOCATIONS.TOOLBAR.ADD\">Add location</span></md-tooltip></md-button><md-button \nng-if=\"vm.showQrCodeButton\" ng-click=\"vm.openQrCodeGenerator()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate \ntranslate-attr-aria-label=\"LOCATIONS.GENERATE_QR_CODE\" aria-label=\"Generate QR Code\"><md-icon \nmd-font-icon=\"icon-qrcode\"></md-icon><md-tooltip><span translate=\"LOCATIONS.GENERATE_QR_CODE\">Generate QR Code</span>\n</md-tooltip></md-button><md-button ng-click=\"vm.exportLocations($event);\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Export to Excel\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.TOOLBAR.EXPORT_TO_EXCEL\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>\n<md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.EXPORT_TO_EXCEL\">Export to Excel</span></md-tooltip></md-button>\n<md-button ng-if=\"vm.filteringIsOn()\" data-cy=\"locations-filters-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate translate-attr-aria-label=\"LOCATIONS.FILTERS.CLEAR\">\n<md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"LOCATIONS.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" \nng-click=\"vm.toggleSidenav(\'locations-filters-sidenav\')\" aria-label=\"Filter Locations\" translate \ntranslate-attr-aria-label=\"LOCATIONS.TOOLBAR.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"LOCATIONS.TOOLBAR.FILTER\">Filter locations</span></md-tooltip></md-button><md-button \ndata-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" aria-label=\"Reload\" \ntranslate translate-attr-aria-label=\"LOCATIONS.TOOLBAR.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon>\n<md-tooltip><span translate=\"LOCATIONS.TOOLBAR.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" ng-class=\"{\'loader-map\': !vm.map && vm.showMap}\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-customers\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"locations-filters-sidenav\" \nng-include=\"\'app/main/locations/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"LocationsFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/materials/materials.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"MATERIALS.TITLE\">\nMaterials</span> <span ng-if=\"vm.configuration.disableMaterials\" class=\"discontinued\">\n{{ \'MATERIALS.MIGRATION.OUTDATED\' | translate}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"end center\" flex><md-button ng-click=\"vm.addMaterials($event)\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important {{ vm.configuration.disableMaterials && \'disabled-checker\' }}\" \ntranslate-attr-aria-label=\"MATERIALS.ADD\" ng-disabled=\"vm.account.configuration.featureDisableAddMaterial\" \naria-label=\"Add material\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><span translate=\"MATERIALS.ADD\">\nAdd new material</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important {{ vm.configuration.disableMaterials && \'disabled-checker\' }}\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate translate-attr-aria-label=\"MATERIALS.CLEAR_FILTERS\">\n<md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"MATERIALS.FILTERS.CLEAR\">\nClear Filters</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important {{ vm.configuration.disableMaterials && \'disabled-checker\' }}\" \nng-click=\"vm.toggleSidenav()\" aria-label=\"Filter materials\" translate \ntranslate-attr-aria-label=\"MATERIALS.FILTERS.TITLE\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"MATERIALS.FILTERS.TITLE\">Filter materials</span></md-tooltip></md-button><md-button \nng-click=\"vm.loadMaterials();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important {{ vm.configuration.disableMaterials && \'disabled-checker\' }}\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"MATERIALS.RELOAD\"><md-icon md-font-icon=\"icon-reload\">\n</md-icon><md-tooltip><span translate=\"MATERIALS.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nid=\"migration\" class=\"migration-container\" ng-if=\"!vm.configuration.disableMaterials\"><div \nclass=\"migration-container__warning\"><div class=\"migration-container__warning__paragraph\" ms-scroll \nid=\"content-to-minimize-and-expand\"><img src=\"assets/icons/news-icon.svg\"> <span>\n{{\'MATERIALS.MIGRATION.NEWS_FOR_YOU\' | translate}}</span><p>{{\'MATERIALS.MIGRATION.NOW_IS_POSSIBLE\' | translate}}</p>\n<p>{{\'MATERIALS.MIGRATION.WE_WILL_UNIFY\' | translate}}</p><p>{{\'MATERIALS.MIGRATION.FIRST_STEP\' | translate}}</p><p>\n{{\'MATERIALS.MIGRATION.ITS_YOU\' | translate}}</p><p>\n{{\'MATERIALS.MIGRATION.MATERIALS_WILL_BECOME_PRODUCTS\' | translate}}</p><p>\n{{\'MATERIALS.MIGRATION.MATERIALS_OS\' | translate}}</p><p>{{\'MATERIALS.MIGRATION.BUTTON_CREATE_MATERIALS\' | translate}}\n</p><p>{{\'MATERIALS.MIGRATION.IMPORTANT\' | translate}}</p><p>{{\'MATERIALS.MIGRATION.DEFINED_VALUE\' | translate}}</p><p \nid=\"end-content-to-minimize-and-expand\">{{\'MATERIALS.MIGRATION.CONTACT_SUPPORT\' | translate}}</p></div><div \nid=\"buttons\" class=\"migration-container__warning__buttons\"><button ng-if=\"!vm.isMinimized\" ng-click=\"vm.minimize()\" \nclass=\"migration-container__warning__buttons__minimize\">{{\'MATERIALS.MIGRATION.MINIMIZE\' | translate}}</button> <button\n ng-if=\"vm.isMinimized\" ng-click=\"vm.expand()\" class=\"migration-container__warning__buttons__expand\">\n{{\'MATERIALS.MIGRATION.EXPAND\' | translate}}</button> <button ng-click=\"vm.openMigrationConfirmModal($event)\" \nclass=\"migration-container__warning__buttons__migrate\">{{\'MATERIALS.MIGRATION.MIGRATE\' | translate}}</button></div><div\n ng-if=\"vm.isMinimized\" class=\"gradient\"></div></div></div><div id=\"migration\" class=\"migration-container\" \nng-if=\"vm.configuration.disableMaterials\"><div class=\"migration-container__warning\"><div \nclass=\"migration-container__warning__paragraph migration-container__warning__paragraph__done\" \nid=\"content-to-minimize-and-expand\"><img src=\"assets/icons/news-icon.svg\"> <span>\n{{\'MATERIALS.MIGRATION.MIGRATION_DONE\' | translate}}</span><p>\n{{\'MATERIALS.MIGRATION.DONE_EXPLANATION.MIGRATION_DONE\' | translate}}</p><p>\n{{\'MATERIALS.MIGRATION.DONE_EXPLANATION.MATERIALS\' | translate}}</p><p>\n{{\'MATERIALS.MIGRATION.DONE_EXPLANATION.BUTTONS\' | translate}}</p><p>\n{{\'MATERIALS.MIGRATION.DONE_EXPLANATION.DOUBTS\' | translate}}</p></div><div id=\"buttons\" \nclass=\"migration-container__warning__button-go-to-products\"><a ng-if=\"!vm.isMinimized\" href=\"#/produtos-e-servicos\">\n{{\'MATERIALS.MIGRATION.GO_TO_PRODUCTS\' | translate}}</a></div></div></div><div id=\"content-card\" class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-customers\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"materials-filters-sidenav\" \nng-include=\"\'app/main/materials/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"MaterialsFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/modules/modules.html","<div class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex>\n<div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start start\">\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"MODULES.TITLE\">Modules</span></div></div>\n</div><div class=\"content-card\" layout=\"column\" flex><md-content class=\"pt-20 pl-20 pb-20\" layout=\"row\" layout-wrap \nms-scroll><fc-card data-cy=\"route-optimizer-card\" icon=\"route-optimizer\" \ntitle=\"{{ \'ROUTE_OPTIMIZER_MODULE.TITLE\' | translate }}\" \ndescription=\"{{ \'ROUTE_OPTIMIZER_MODULE.DESCRIPTION\' | translate }}\" \nconfiguration=\"vm.configuration[\'route-optimizer\']\" open-function=\"vm.toggleSidenav($event, \'route-optimizer\')\">\n</fc-card><fc-card data-cy=\"equipments-card\" icon=\"equipments\" title=\"{{ \'EQUIPMENTS_MODULE.TITLE\' | translate }}\" \ndescription=\"{{ \'EQUIPMENTS_MODULE.DESCRIPTION\' | translate }}\" configuration=\"vm.configuration[\'equipments\']\" \nopen-function=\"vm.toggleSidenav($event, \'equipments\')\"></fc-card><fc-card data-cy=\"materials-card\" icon=\"materials\" \ntitle=\"{{ \'MATERIALS_MODULE.TITLE\' | translate }}\" description=\"{{ \'MATERIALS_MODULE.DESCRIPTION\' | translate }}\" \nconfiguration=\"vm.configuration[\'materials\']\" open-function=\"vm.toggleSidenav($event, \'materials\')\"></fc-card><fc-card \ndata-cy=\"tickets-card\" icon=\"tickets\" title=\"{{ \'TICKETS_MODULE.TITLE\' | translate }}\" \ndescription=\"{{ \'TICKETS_MODULE.DESCRIPTION\' | translate }}\" configuration=\"vm.configuration[\'tickets\']\" \nopen-function=\"vm.toggleSidenav($event, \'tickets\')\"></fc-card><fc-card data-cy=\"image-resolution-card\" \nicon=\"image-resolution\" title=\"{{ \'IMAGE_RESOLUTION_MODULE.TITLE\' | translate }}\" \ndescription=\"{{ \'IMAGE_RESOLUTION_MODULE.DESCRIPTION\' | translate }}\" \nconfiguration=\"vm.configuration[\'image-resolution\']\" open-function=\"vm.toggleSidenav($event, \'image-resolution\')\">\n</fc-card><fc-card data-cy=\"videos-card\" icon=\"video\" title=\"{{ \'VIDEOS_MODULE.TITLE\' | translate }}\" \ndescription=\"{{ \'VIDEOS_MODULE.DESCRIPTION\' | translate }}\" configuration=\"vm.configuration[\'videos\']\" \nopen-function=\"vm.toggleSidenav($event, \'videos\')\" new=\"true\"></fc-card><fc-card data-cy=\"customers-area-card\" \nicon=\"customers-area\" title=\"{{ \'CUSTOMERS_AREA_MODULE.TITLE\' | translate }}\" \ndescription=\"{{ \'CUSTOMERS_AREA_MODULE.DESCRIPTION\' | translate }}\" configuration=\"vm.configuration[\'customers-area\']\" \nopen-function=\"vm.toggleSidenav($event, \'customers-area\')\" new=\"true\"></fc-card><fc-card \ndata-cy=\"print-configuration-card\" icon=\"print-configuration\" \ntitle=\"{{ \'PRINT_CONFIGURATION_MODULE.TITLE\' | translate }}\" \ndescription=\"{{ \'PRINT_CONFIGURATION_MODULE.DESCRIPTION\' | translate }}\" \nconfiguration=\"vm.configuration[\'print-configuration\']\" \nopen-function=\"vm.toggleSidenav($event, \'print-configuration\')\" new=\"true\"></fc-card><fc-card \ndata-cy=\"tasks-plans-card\" icon=\"tasks-plans\" title=\"{{ \'TASKS_PLANS_MODULE.TITLE\' | translate }}\" \ndescription=\"{{ \'TASKS_PLANS_MODULE.DESCRIPTION\' | translate }}\" configuration=\"vm.configuration[\'tasks-plans\']\" \nopen-function=\"vm.toggleSidenav($event, \'tasks-plans\')\" new=\"true\"></fc-card><fc-card data-cy=\"vehicles-card\" \nicon=\"vehicles\" title=\"{{ \'VEHICLES.TITLE\' | translate }}\" description=\"{{ \'VEHICLES.DESCRIPTION\' | translate }}\" \nconfiguration=\"vm.configuration[\'vehicles\']\" open-function=\"vm.toggleSidenav($event, \'vehicles\')\" new=\"true\"></fc-card>\n<fc-card data-cy=\"deadlines-card\" icon=\"deadlines\" title=\"{{ \'DEADLINES_MODULES.TITLE\' | translate }}\" \ndescription=\"{{ \'DEADLINES_MODULES.DESCRIPTION\' | translate }}\" configuration=\"vm.configuration[\'deadlines\']\" \nopen-function=\"vm.toggleSidenav($event, \'deadlines\')\"></fc-card><fc-card data-cy=\"storage-control-card\" \nicon=\"storage-control\" title=\"{{ \'STORAGE_CONTROL_MODULES.TITLE\' | translate }}\" \ndescription=\"{{ \'STORAGE_CONTROL_MODULES.DESCRIPTION\' | translate }}\" \nconfiguration=\"vm.configuration[\'storage-control\']\" open-function=\"vm.toggleSidenav($event, \'storage-control\')\">\n</fc-card><fc-card data-cy=\"smart-rewrite-card\" icon=\"smart-rewrite\" \ntitle=\"{{ \'SMART_REWRITE_MODULES.TITLE\' | translate }}\" \ndescription=\"{{ \'SMART_REWRITE_MODULES.DESCRIPTION\' | translate }}\" configuration=\"vm.configuration[\'smart-rewrite\']\" \nopen-function=\"vm.toggleSidenav($event, \'smart-rewrite\')\"></fc-card><fc-card \nng-if=\"vm.hasFeatureFlag(\'territories-module-beta-flag\')\" data-cy=\"territories-card\" icon=\"territories\" \ntitle=\"{{ \'TERRITORIES_MODULE.TITLE\' | translate }}\" description=\"{{ \'TERRITORIES_MODULE.DESCRIPTION\' | translate }}\" \nconfiguration=\"vm.configuration[\'territories\']\" open-function=\"vm.toggleSidenav($event, \'territories\')\"></fc-card>\n<fc-card data-cy=\"templates-card\" icon=\"templates\" title=\"{{ \'TEMPLATES_MODULE.TITLE\' | translate }}\" \ndescription=\"{{ \'TEMPLATES_MODULE.DESCRIPTION\' | translate }}\" configuration=\"vm.configuration[\'templates\']\" \nopen-function=\"vm.toggleSidenav($event, \'templates\')\"></fc-card></md-content></div></div></div>");
$templateCache.put("app/main/plans/plans.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"PLANS.TITLE\">\nActivity Plans</span></div></div><div class=\"fieldcontrol__search\" layout=\"row\" layout-align=\"end center\" flex>\n<md-button class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.downloadSpreadsheetModel()\" translate-attr-aria-label=\"PLANS.DOWNLOAD_SPREADSHEET_MODEL\" \naria-label=\"Download spreadsheet model\"><md-icon md-font-icon=\"icon-box-download\"></md-icon><md-tooltip><span \ntranslate=\"PLANS.DOWNLOAD_SPREADSHEET_MODEL\">Download spreadsheet model</span></md-tooltip></md-button><md-button \ndata-cy=\"create-plan-button\" ng-if=\"vm.addPermission\" ng-click=\"vm.addPlan($event)\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate-attr-aria-label=\"PLANS.NEW\" \naria-label=\"New plan\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><span translate=\"PLANS.NEW\">New plan\n</span></md-tooltip></md-button><md-button ng-if=\"!vm.addPermission\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important no-action-permission\" \ntranslate-attr-aria-label=\"PLANS.NEW\" aria-label=\"New plan\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip>\n<span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.NO_PERMISSION_WARN_CREATE_PLAN\">New plan\n</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"PLANS.FILTERS.CLEAR\" data-cy=\"clear-filters-button\">\n<md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"PLANS.FILTERS.CLEAR\">Clear filters\n</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'plans-filters-sidenav\')\" aria-label=\"Filter Tickets\" translate \ntranslate-attr-aria-label=\"PLANS.FILTER\" data-cy=\"plans-filter-button\"><md-icon md-font-icon=\"icon-filter\"></md-icon>\n<md-tooltip><span translate=\"PLANS.FILTER\">Filter plans</span></md-tooltip></md-button><md-button \ndata-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"PLANS.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"PLANS.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-customers\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"plans-filters-sidenav\" \nng-include=\"\'app/main/plans/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"PlansFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/plans-types/plans-types.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"PLANSTYPES.TITLE\">\nPlans Types Activity</span></div></div><div class=\"fieldcontrol__search\" layout=\"row\" layout-align=\"end center\" flex>\n<md-button ng-click=\"vm.addPlanType($event)\" data-cy=\"plans-types-add-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"PLANSTYPES.NEW\" aria-label=\"New plan type\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip><span translate=\"PLANSTYPES.NEW\">New plan type</span></md-tooltip></md-button><md-button \nng-if=\"vm.filteringIsOn()\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.clearFilters()\" data-cy=\"plans-types-clear-filters-button\" aria-label=\"Clear Filters\" translate \ntranslate-attr-aria-label=\"PLANSTYPES.FILTERS.CLEAR\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip>\n<span translate=\"PLANSTYPES.FILTERS.CLEAR\">Clear filters</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'plans-types-filters-sidenav\')\" data-cy=\"plans-types-filter-button\" \naria-label=\"Filter Tickets\" translate translate-attr-aria-label=\"PLANSTYPES.FILTER\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip><span translate=\"PLANSTYPES.FILTER\">Filter plans types</span>\n</md-tooltip></md-button><md-button data-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"PLANSTYPES.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"PLANSTYPES.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-customers\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"plans-types-filters-sidenav\" \nng-include=\"\'app/main/plans-types/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"PlansTypesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/product-types/product-types.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"PRODUCT_TYPES.TITLE\">Product Type</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"end center\" flex><md-button data-cy=\"create-button\" \nng-disabled=\"vm.account.configuration.featureDisableAddProductService\" ng-click=\"vm.addProductType($event)\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"PRODUCT_TYPES.NEW\" aria-label=\"New plan type\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip><span translate=\"PRODUCT_TYPES.NEW\">New product type</span></md-tooltip></md-button><md-button \ndata-cy=\"clear-filters-button\" ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"PRODUCT_TYPES.FILTERS.CLEAR\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"PRODUCT_TYPES.FILTERS.CLEAR\">Clear filters\n</span></md-tooltip></md-button><md-button data-cy=\"filters-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'product-types-filters-sidenav\')\" aria-label=\"Filter and product types\" translate \ntranslate-attr-aria-label=\"PRODUCT_TYPES.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"PRODUCT_TYPES.FILTER\">Filter product types</span></md-tooltip></md-button><md-button \ndata-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"PRODUCT_TYPES.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"PRODUCT_TYPES.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-products-services\" dt-instance=\"vm.dtInstanceCallback\" \ndt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"product-types-filters-sidenav\" \nng-include=\"\'app/main/product-types/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"ProductTypesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/products/products.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"PRODUCTS.TITLE\">\nProducts</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-menu \nmd-position-mode=\"left bottom\" ng-if=\"vm.showIntegrationButton(\'Omie\');\" ng-hide=\"vm.showMap\"><md-button \ndata-cy=\"import-omie-button\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"$mdOpenMenu();\"><md-icon md-svg-src=\"/assets/icons/icon-omie-active.svg\" class=\"icon-customer-import\">\n</md-icon><md-tooltip><span translate=\"PRODUCTS.IMPORT.TITLE\" translate-value-app=\"Omie\">Import products from Omie\n</span></md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item><md-button data-cy=\"manual-import-button\" \nng-click=\"vm.openImportOmieDialog($event, \'manual\')\"><span translate=\"PRODUCTS.IMPORT.MANUAL\">Manual import</span>\n</md-button></md-menu-item><md-menu-item><md-button data-cy=\"automatic-import-button\" \nng-click=\"vm.openImportOmieDialog($event, \'automatic\')\"><span translate=\"PRODUCTS.IMPORT.AUTOMATIC\">Automatic import\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-button data-cy=\"export-excel-button\" \nng-click=\"vm.exportProductsServices($event);\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Export to Excel\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.TOOLBAR.EXPORT_TO_EXCEL\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>\n<md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.EXPORT_TO_EXCEL\">Export to Excel</span></md-tooltip></md-button>\n<md-button data-cy=\"add-product-button\" ng-disabled=\"vm.account.configuration.featureDisableAddProductService\" \nng-click=\"vm.addProduct($event)\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"PRODUCTS.NEW\" aria-label=\"New plan type\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip><span translate=\"PRODUCTS.NEW\">New product</span></md-tooltip></md-button><md-button \ndata-cy=\"clear-filters-button\" ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"PRODUCTS.FILTERS.CLEAR\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"PRODUCTS.FILTERS.CLEAR\">Clear filters</span>\n</md-tooltip></md-button><md-button data-cy=\"filter-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'products-filters-sidenav\')\" aria-label=\"Filter Products\" translate \ntranslate-attr-aria-label=\"PRODUCTS.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"PRODUCTS.FILTER\">Filter products</span></md-tooltip></md-button><md-button data-cy=\"reload-button\" \nng-click=\"vm.reload();\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"PRODUCTS.RELOAD\"><md-icon md-font-icon=\"icon-reload\">\n</md-icon><md-tooltip><span translate=\"PRODUCTS.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"table-list\" datatable=\"\" class=\"dataTable row-border hover datatable-products-services\" \ndt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div>\n</div></div><md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"products-filters-sidenav\" \nng-include=\"\'app/main/products/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"ProductsFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/products-services/products-services.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"PRODUCTS_SERVICES.TITLE\">Products and services</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"end center\" flex><md-menu md-position-mode=\"left bottom\" ng-if=\"vm.showIntegrationButton(\'Omie\');\" \nng-hide=\"vm.showMap\"><md-button class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"$mdOpenMenu();\"><md-icon md-svg-src=\"assets/icons/icon-omie-active.svg\" class=\"icon-customer-import\">\n</md-icon><md-tooltip><span translate=\"PRODUCTS_SERVICES.IMPORT.TITLE\" translate-value-app=\"Omie\">\nImport products from Omie</span></md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.openImportOmieDialog($event, \'manual\')\"><span translate=\"PRODUCTS_SERVICES.IMPORT.MANUAL\">Manual import\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.openImportOmieDialog($event, \'automatic\')\">\n<span translate=\"PRODUCTS_SERVICES.IMPORT.AUTOMATIC\">Automatic import</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-button ng-click=\"vm.exportProductsServices($event);\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Export to Excel\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.TOOLBAR.EXPORT_TO_EXCEL\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>\n<md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.EXPORT_TO_EXCEL\">Export to Excel</span></md-tooltip></md-button>\n<md-button ng-disabled=\"vm.account.configuration.featureDisableAddProductService\" \nng-click=\"vm.addProductService($event)\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"PRODUCTS_SERVICES.NEW\" aria-label=\"New plan type\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip><span translate=\"PRODUCTS_SERVICES.NEW\">New product service</span></md-tooltip></md-button>\n<md-button ng-if=\"vm.filteringIsOn()\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate \ntranslate-attr-aria-label=\"PRODUCTS_SERVICES.FILTERS.CLEAR\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon>\n<md-tooltip><span translate=\"PRODUCTS_SERVICES.FILTERS.CLEAR\">Clear filters</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'products-services-filters-sidenav\')\" aria-label=\"Filter Products and services\" translate \ntranslate-attr-aria-label=\"PRODUCTS_SERVICES.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"PRODUCTS_SERVICES.FILTER\">Filter products services</span></md-tooltip></md-button><md-button \ndata-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"PRODUCTS_SERVICES.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"PRODUCTS_SERVICES.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-products-services\" dt-instance=\"vm.dtInstanceCallback\" \ndt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"products-services-filters-sidenav\" \nng-include=\"\'app/main/products-services/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"ProductsServicesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/quotations/quotations.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"QUOTATIONS.TITLE\">\nQuotations</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-button \nng-click=\"vm.exportData();\" ng-disabled=\"vm.exportingDataLoading || vm.totalRows === 0\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"QUOTATIONS.EXPORT_EXCEL\" aria-label=\"Export Excel\"><md-icon md-font-icon=\"icon-file-excel\">\n</md-icon><md-tooltip><span translate=\"QUOTATIONS.EXPORT_EXCEL\">Export Excel</span></md-tooltip></md-button><md-button \nng-if=\"vm.dtLocalStorageStatus()\" ng-click=\"vm.dtLocalStorageRemove()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Restore columns\" translate \ntranslate-attr-aria-label=\"TASKS.ACTION_BUTTONS.RESTORE_COLUMNS\"><md-icon md-font-icon=\"icon-table\"></md-icon>\n<md-tooltip><span translate=\"TASKS.ACTION_BUTTONS.RESTORE_COLUMNS\">Restore columns</span></md-tooltip></md-button>\n<md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Toggle columns\" translate data-cy=\"quotations-toggle-columns-button\" \ntranslate-attr-aria-label=\"TASKS.TOGGLE_COLUMNS\"><md-icon md-font-icon=\"icon-table-edit\"></md-icon><md-tooltip><span \ntranslate=\"TASKS.ACTION_BUTTONS.TOGGLE_COLUMNS\">Toggle columns</span></md-tooltip></md-button><md-menu-content \nwidth=\"3\"><md-menu-item ng-if=\"(vm.dtColumns.length - 1) > $index && $index > 0\" \nng-repeat=\"column in vm.dtColumns track by $index\"><md-button ng-click=\"vm.toggleColumnVisibility($index)\" \nmd-prevent-menu-close=\"md-prevent-menu-close\"><span ng-class=\"{ \'line-thru\': (vm.isColumnVisible($index) === false) }\">\n{{column.sTitle}}</span></md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-click=\"vm.addQuotation($event)\" data-cy=\"quotation-add-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"QUOTATIONS.NEW\" aria-label=\"New quotation\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip><span translate=\"QUOTATIONS.NEW\">New quotation</span></md-tooltip></md-button><md-button \nng-if=\"vm.filteringIsOn()\" ng-click=\"vm.clearFilters()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.FILTERS.CLEAR\" aria-label=\"Clear Filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"QUOTATIONS.FILTERS.CLEAR\">Clear filters</span>\n</md-tooltip></md-button><md-button ng-click=\"vm.toggleSidenav(\'quotations-filters-sidenav\')\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.FILTERS.TITLE\" aria-label=\"Filter quotation\"><md-icon md-font-icon=\"icon-filter\">\n</md-icon><md-tooltip><span translate=\"QUOTATIONS.FILTERS.TITLE\">Filter quotation</span></md-tooltip></md-button>\n<md-button data-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.RELOAD\" aria-label=\"Reload\"><md-icon md-font-icon=\"icon-reload\"></md-icon>\n<md-tooltip><span translate=\"QUOTATIONS.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"table-list\" datatable=\"\" class=\"dataTable row-border hover datatable-quotations\" \ndt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div>\n</div></div><md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"quotations-filters-sidenav\" \nms-sidenav-helper ng-include=\"\'app/main/quotations/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"QuotationsFiltersSideNavController as vm\"></md-sidenav></div>");
$templateCache.put("app/main/recurrences/recurrences.html","<div id=\"default-list\" class=\"page-layout carded recurrences fullwidth with-filters-sidenav\" layout=\"row\"><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"RECURRENCES.TITLE\">Recurrences</span> <span data-cy=\"limit-recurrences-span\" class=\"limit-badge ml-8\">\n{{vm.totalItems}} / {{vm.limit}}</span></div><div ng-if=\"vm.isRecurrencesOverLimit\" class=\"limit-badge-text\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><span translate=\"RECURRENCES.REACHED_THE_MAXIMUM\">\nReached the maximum</span> &nbsp; <button translate=\"RECURRENCES.CONTACT_SUPPORT\">Contact support to know more</button>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-button \nng-click=\"vm.exportData(\'impressão\', \'buttons-print\');\" ng-disabled=\"vm.exportingDataLoading\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Imprimir\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip><span translate=\"RECURRENCES.PRINT\">Print</span></md-tooltip>\n</md-button><md-button ng-click=\"vm.exportData(\'exportação\', \'buttons-csv\');\" ng-disabled=\"vm.exportingDataLoading\" \nclass=\"md-icon-button md-accent md-mini button-white-bg\" aria-label=\"Export to CSV\" translate \ntranslate-attr-aria-label=\"RECURRENCES.EXPORT_CSV\"><md-icon md-font-icon=\"icon-file-delimited\"></md-icon><md-tooltip>\n<span translate=\"RECURRENCES.EXPORT_CSV\">Export to CSV</span></md-tooltip></md-button><md-button \nng-click=\"vm.exportData(\'exportação\', \'buttons-excel\');\" ng-disabled=\"vm.exportingDataLoading\" \nclass=\"md-icon-button md-accent md-mini button-white-bg\" aria-label=\"Export to Excel\" translate \ntranslate-attr-aria-label=\"RECURRENCES.EXPORT_EXCEL\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon><md-tooltip>\n<span translate=\"RECURRENCES.EXPORT_EXCEL\">Export to Excel</span></md-tooltip></md-button><md-button \nng-click=\"vm.addRecurrence($event)\" data-cy=\"add-recurrence-button\" ng-if=\"vm.addPermission\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"RECURRENCES.NEW\" ng-disabled=\"vm.isRecurrencesOverLimit\" aria-label=\"Add recurrence\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><span translate=\"RECURRENCES.NEW\">New recurrence</span>\n</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important no-action-permission\" \nng-if=\"!vm.addPermission\" translate-attr-aria-label=\"RECURRENCES.NEW\" aria-label=\"Add recurrence\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.NO_PERMISSION_WARN_CREATE_RECURRENCE\">\nNew recurrence</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"RECURRENCES.FILTERS.CLEAR\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"RECURRENCES.FILTERS.CLEAR\">Clear filters\n</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'recurrences-filters-sidenav\')\" aria-label=\"Filter Recurrences\" translate \ntranslate-attr-aria-label=\"RECURRENCES.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"RECURRENCES.FILTER\">Filter Recurrences</span></md-tooltip></md-button><md-button data-cy=\"reload-button\" \nng-click=\"vm.reload();\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"RECURRENCES.RELOAD\"><md-icon md-font-icon=\"icon-reload\">\n</md-icon><md-tooltip><span translate=\"RECURRENCES.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"table-list\" datatable=\"\" class=\"dataTable row-border hover\" dt-instance=\"vm.dtInstanceCallback\" \ndt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"recurrences-filters-sidenav\" \nng-include=\"\'app/main/recurrences/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"RecurrencesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/routes/routes.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div \nclass=\"center down-margin\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"ROUTES.TITLE\">Route History</span></div></div><div id=\"route-options\" layout=\"row\" \nlayout-align=\"end center\" flex><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear filters\" translate translate-attr-aria-label=\"ROUTES.FILTERS.CLEAR\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"ROUTES.FILTERS.CLEAR\">Clear filters</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'routes-filters-sidenav\')\" aria-label=\"Filter activities\" translate \ntranslate-attr-aria-label=\"ROUTES.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"ROUTES.FILTER\">Filter activities</span></md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable content-routes\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-switch \nstyle=\"margin-left:10px\" md-no-ink ng-model=\"vm.mapFitOn\" ng-change=\"vm.changedMapFit();\" \naria-label=\"{{ \'ROUTES.TOOLBAR.CENTRALIZE\' | translate }}\"><span class=\"md-subhead fs-14\" \ntranslate=\"ROUTES.TOOLBAR.CENTRALIZE\">Centralize</span></md-switch><md-switch ng-if=\"vm.filteringIsOn()\" \nstyle=\"margin-left:10px\" md-no-ink ng-model=\"vm.showConnectionPaths\" ng-change=\"vm.switchShowConnectionPaths();\" \naria-label=\"{{ \'ROUTES.TOOLBAR.SHOW_CONNECTION_PATHS\' | translate }}\"><span class=\"md-subhead fs-14\" \ntranslate=\"ROUTES.TOOLBAR.SHOW_CONNECTION_PATHS\">Show connection paths</span></md-switch><div class=\"divider-vertical\" \nng-if=\"vm.clicked;\"></div><md-button class=\"md-icon-button\" aria-label=\"Clear activity selection\" ng-if=\"vm.clicked;\" \nng-click=\"vm.unhighlightPath($event);\" translate translate-attr-aria-label=\"ROUTES.CLEAR_ACTIVITY_SELECTION\"><md-icon \nmd-font-icon=\"icon-layers-off\"></md-icon><md-tooltip><span translate=\"ROUTES.TOOLBAR.CLEAR_ACTIVITY_SELECTION\">\nClear activity selection</span></md-tooltip></md-button></div><div layout=\"row\" class=\"inset\" \nlayout-align=\"start center\"><md-progress-circular ng-if=\"$root.loadingProgress\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div></div><div id=\"gantt-chart\" \nclass=\"carded fullwidth gantt-route\" layout=\"row\" ng-if=\"vm.ganttData.length > 0\"><div class=\"content-card\" \nlayout=\"column\" flex><div flex layout-fill gantt id=\"gantt-tasks\" data=\"vm.ganttData\" options=\"vm.ganttOptions\" \nfrom-date=\"vm.ganttOptions.fromDate\" to-date=\"vm.ganttOptions.toDate\"><gantt-table headers=\"\'\'\" \ncolumns=\"vm.ganttOptions.columns\"></gantt-table><gantt-bounds></gantt-bounds><gantt-progress></gantt-progress>\n<gantt-resize-sensor></gantt-resize-sensor></div></div></div><md-content class=\"content\" \nstyle=\"border-bottom: 1px solid #ccc\" flex layout=\"column\"><div style=\"position: relative; height: 100%; width: 100%\">\n<leaflet id=\"routesMap\" legend=\"vm.map.legend\" lf-center=\"vm.map.center\" markers=\"vm.map.markers\" paths=\"vm.map.paths\" \ndecorations=\"vm.map.decorations\" controls=\"vm.map.controls\" layers=\"vm.map.layers\" height=\"100%\" width=\"100%\">\n</leaflet></div></md-content></div></div></div></div><md-sidenav class=\"filters-sidenav md-sidenav-right\" \nmd-component-id=\"routes-filters-sidenav\" ng-include=\"\'app/main/routes/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"RoutesFiltersSidenavController as vm\" ms-sidenav-helper></md-sidenav>");
$templateCache.put("app/main/services/services.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav services-dialog\" layout=\"row\"><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"SERVICES.TITLE\">Services</span><div><md-button class=\"md-accent md-mini button-white-bg tutorial-video\" \naria-label=\"Play\" ng-click=\"vm.openVideoTutorial()\"><md-icon md-font-icon=\"icon-play-circle\"></md-icon><span \ntranslate=\"EQUIPMENT_TYPES.TUTORIAL_VIDEO.TITLE\"></span><md-tooltip><span \ntranslate=\"EQUIPMENT_TYPES.TUTORIAL_VIDEO.TOOLTIP\">Assistir vídeo explicativo.</span></md-tooltip></md-button></div>\n</div></div><div class=\"fieldcontrol__search\" layout=\"row\" layout-align=\"end center\" flex><fc-export-csv-button \nclass=\"mleft-15\"></fc-export-csv-button><fc-export-excel-button></fc-export-excel-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" data-cy=\"create-new-service\" \nng-click=\"vm.addService($event)\" translate-attr-aria-label=\"SERVICES.NEW\" aria-label=\"New service\" \nng-disabled=\"vm.accountConfiguration.featureDisableAddService\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip>\n<span translate=\"SERVICES.NEW\">New service</span></md-tooltip></md-button><md-button data-cy=\"clearFilterService\" \nng-if=\"vm.filteringIsOn()\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate translate-attr-aria-label=\"SERVICES.FILTERS.CLEAR\">\n<md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"SERVICES.FILTERS.CLEAR\">Clear filters\n</span></md-tooltip></md-button><md-button data-cy=\"filter-services\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'services-filters-sidenav\')\" aria-label=\"Filter Tickets\" translate \ntranslate-attr-aria-label=\"SERVICES.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"SERVICES.FILTER\">Filter services</span></md-tooltip></md-button><md-button data-cy=\"reload-button\" \nng-click=\"vm.reload();\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"SERVICES.RELOAD\"><md-icon md-font-icon=\"icon-reload\">\n</md-icon><md-tooltip><span translate=\"SERVICES.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nng-if=\"vm.hasTaskTypesLaunchBetaFlag\" class=\"fc-warning-container fc-warning-container--inside-tab launch-banner\"><div \nstyle=\"display: flex; flex-direction: row; gap: 12px\"><md-icon \nstyle=\"color: #E51A80 !important; height: 20px !important; min-height: 20px !important\" \nmd-svg-src=\"assets/icons/rocket.svg\"></md-icon><div><span translate=\"SERVICES.LAUNCH_DIALOG.BANNER_TEXT\"></span></div>\n</div><span ng-click=\"vm.openLaunchDialog();\" class=\"open-launch-dialog\" \ntranslate=\"SERVICES.LAUNCH_DIALOG.RIGHT_BUTTON\"></span></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover datatable-services\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"services-filters-sidenav\" \nng-include=\"\'app/main/services/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"ServicesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/settings/settings.html","<div id=\"settings-page\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div\n class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span>{{ vm.screen.title }}</span></div><div \nclass=\"secondary-text\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.screen.cellphone\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\" class=\"grey-900-fg secondary-text__icon\"></md-icon><b \nclass=\"secondary-text__text\" translate=\"CONFIGURATIONS.MOBILE.WARNING\">\nThe settings referring to the employee\'s application will only be reflected after the logout is performed.</b></div>\n</div></div><div class=\"content-card\" layout=\"column\" flex><md-content ng-if=\"!vm.screen.labelsManager\" \nclass=\"content fullpage-datatable\" layout=\"column\" flex ms-scroll ui-view=\"settingsPanelContent\"></md-content>\n<md-content ng-if=\"vm.screen.labelsManager\" class=\"content fullpage-datatable padding-0\" layout=\"column\" flex \nms-scroll ui-view=\"labelsManagerContent\"></md-content></div></div></div>");
$templateCache.put("app/main/subscription/subscription.html","<div id=\"plan\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"SUBSCRIPTION.PAGE_TITLE\"></span></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nng-if=\"!vm.isAccountPro\" class=\"content-card__warning\"><div layout=\"column\"><span class=\"content-card__warning__title\">\n{{ \'SUBSCRIPTION.PLAN_WARNING.DOES_NOT_HAVE\' | translate }}</span><p class=\"content-card__warning__subtitle\">\n{{ \'SUBSCRIPTION.PLAN_WARNING.SUBTITLE\' | translate }}</p></div><div layout=\"row\"><button \nclass=\"fc-button content-card__warning__button\" data-cy=\"request-demo-button\" ng-click=\"vm.scheduleDemo()\" \nng-disabled=\"$root.disabledButton\" ng-class=\"{button__disabled: $root.disabledButton}\" \naria-label=\"Solicitar demonstração\" translate=\"SUBSCRIPTION.PLAN_WARNING.BUTTON\" \ntranslate-attr-aria-label=\"SUBSCRIPTION.PLAN_WARNING.BUTTON\">Request demo</button></div></div><md-content \nng-if=\"vm.isAccountPro\" class=\"content mb-30\" layout=\"column\" flex ms-scroll><div class=\"subscription__overview\"><h3 \nclass=\"header-title\" translate=\"SUBSCRIPTION.SECTIONS.OVERVIEW.TITLE\">Visão Geral</h3><div \nclass=\"subscription__overview__boxs\"><fc-box header-title=\"\'SUBSCRIPTION.NEXT_DUE_DATE\' | translate\" \nbutton-text=\"\'SUBSCRIPTION.SIDENAVS.RENEWAL.RENEW_SUBSCRIPTION\' | translate\" type=\"renewal\" \nis-renewal=\"vm.showRenewalAlert\" button-click=\"vm.toggleSidenav(\'renewal-sidenav\')\"><span>{{vm.renewAtFormatted}}\n</span></fc-box><fc-box header-title=\"\'SUBSCRIPTION.PAYMENT\' | translate\" \nbutton-text=\"\'SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.TITLE\' | translate\" \nbutton-click=\"vm.toggleSidenav(\'due-date-sidenav\')\"><span>{{ vm.subscription.payment.email }}</span></fc-box><fc-box \nheader-title=\"\'SUBSCRIPTION.LICENSE\' | translate\" button-text=\"\'SUBSCRIPTION.MANAGE_LICENSES\' | translate\" \nbutton-click=\"vm.toggleSidenav(\'employees-upgrade-sidenav\')\" progress-using=\"vm.charts.employee.using\" \nprogress-limit=\"vm.charts.employee.limit\"><div class=\"fc-box__content__text\"><span>{{ ::vm.charts.employee.using }}\n</span> <span translate=\"SUBSCRIPTION.OF\">of</span> <span>{{ ::vm.charts.employee.limit }}</span> <span \ntranslate=\"SUBSCRIPTION.USING\">using</span></div></fc-box></div></div><div class=\"subscription__modules\"><header \nclass=\"subscription__modules__header\"><h3 class=\"header-title\" translate=\"SUBSCRIPTION.SECTIONS.MODULES.TITLE\">\nTurbine sua assinatura com módulos</h3><span class=\"header-description\" \ntranslate=\"SUBSCRIPTION.SECTIONS.MODULES.DESCRIPTION\">\nEscolha entre os módulos disponíveis o que melhor se adequa ao cenário da sua empresa.</span></header><div \nclass=\"subscription__modules__items\"><fc-subscription-module \npreview-url=\"assets/images/modules/subscriptions/routes.png\" \nmodule-title=\"\'SUBSCRIPTION.SECTIONS.MODULES.ROUTES.TITLE\' | translate\" \nmodule-description=\"\'SUBSCRIPTION.SECTIONS.MODULES.ROUTES.DESCRIPTION\' | translate\" \nactived-module=\"vm.modulesSubscription[\'route-optimizer\']\" configuration-name=\"route-optimizer\">\n</fc-subscription-module><fc-subscription-module preview-url=\"assets/images/modules/subscriptions/equipments.png\" \nmodule-title=\"\'SUBSCRIPTION.SECTIONS.MODULES.EQUIPMENTS.TITLE\' | translate\" \nmodule-description=\"\'SUBSCRIPTION.SECTIONS.MODULES.EQUIPMENTS.DESCRIPTION\' | translate\" \nactived-module=\"vm.modulesSubscription[\'equipments\']\" configuration-name=\"equipments\"></fc-subscription-module>\n<fc-subscription-module preview-url=\"assets/images/modules/subscriptions/vehicles.png\" \nmodule-title=\"\'SUBSCRIPTION.SECTIONS.MODULES.VEHICLES.TITLE\' | translate\" \nmodule-description=\"\'SUBSCRIPTION.SECTIONS.MODULES.VEHICLES.DESCRIPTION\' | translate\" \nactived-module=\"vm.modulesSubscription[\'vehicles\']\" configuration-name=\"vehicles\"></fc-subscription-module>\n<fc-subscription-module preview-url=\"assets/images/modules/subscriptions/customers-area.png\" \nmodule-title=\"\'SUBSCRIPTION.SECTIONS.MODULES.CUSTOMERS_AREA.TITLE\' | translate\" \nmodule-description=\"\'SUBSCRIPTION.SECTIONS.MODULES.CUSTOMERS_AREA.DESCRIPTION\' | translate\" \nactived-module=\"vm.modulesSubscription[\'customers-area\']\" configuration-name=\"customers-area\"></fc-subscription-module>\n<fc-subscription-module preview-url=\"assets/images/modules/subscriptions/image-render.png\" \nmodule-title=\"\'SUBSCRIPTION.SECTIONS.MODULES.IMAGE_RENDER.TITLE\' | translate\" \nmodule-description=\"\'SUBSCRIPTION.SECTIONS.MODULES.IMAGE_RENDER.DESCRIPTION\' | translate\" \nactived-module=\"vm.modulesSubscription[\'image-resolution\']\" configuration-name=\"image-resolution\">\n</fc-subscription-module><fc-subscription-module preview-url=\"assets/images/modules/subscriptions/video.png\" \nmodule-title=\"\'SUBSCRIPTION.SECTIONS.MODULES.VIDEO.TITLE\' | translate\" \nmodule-description=\"\'SUBSCRIPTION.SECTIONS.MODULES.VIDEO.DESCRIPTION\' | translate\" \nactived-module=\"vm.modulesSubscription[\'videos\']\" configuration-name=\"videos\"></fc-subscription-module>\n<fc-subscription-module preview-url=\"assets/images/modules/subscriptions/deadline.png\" \nmodule-title=\"\'SUBSCRIPTION.SECTIONS.MODULES.DEADLINE.TITLE\' | translate\" \nmodule-description=\"\'SUBSCRIPTION.SECTIONS.MODULES.DEADLINE.DESCRIPTION\' | translate\" \nactived-module=\"vm.modulesSubscription[\'deadlines\']\" configuration-name=\"deadlines\"></fc-subscription-module></div>\n</div><div class=\"subscription__cancel-account\"><h3 class=\"header-title\" \ntranslate=\"SUBSCRIPTION.SECTIONS.CANCEL_ACCOUNT.TITLE\">Deseja cancelar sua conta?</h3><span class=\"header-description\" \ntranslate=\"SUBSCRIPTION.SECTIONS.CANCEL_ACCOUNT.DESCRIPTION\">Entre em contato com <a class=\"header-description--link\" \nhref=\"mailto: suporte@fieldcontrol.com.br\">suporte@fieldcontrol.com.br </a>\nou fale com seu gerente de conta para cancelar sua assinatura.</span></div><div id=\"storage\" class=\"box mb-20\" \nlayout=\"column\" ng-if=\"false\"><div class=\"box__header\"><span class=\"title\" translate=\"SUBSCRIPTION.STORAGE\">Storage\n</span></div><div class=\"box__content\" layout=\"row\"><div class=\"chart\"><chartist class=\"ct-chart\" \nchartist-chart-type=\"Bar\" chartist-data=\"vm.charts.storage.data\" chartist-chart-options=\"vm.charts.storage.options\" \nchartist-events=\"vm.charts.events\"></chartist><div layout=\"row\" layout-align=\"space-between start\"><div class=\"legend\" \nlayout=\"row\"><div class=\"mr-10\" layout=\"row\"><div class=\"circle images\"></div><span translate=\"SUBSCRIPTION.IMAGES\">\nImages</span></div><div class=\"mr-10\" layout=\"row\"><div class=\"circle videos\"></div><span \ntranslate=\"SUBSCRIPTION.VIDEOS\">Videos</span></div></div><div class=\"text-right f16\"><span class=\"fw-500 black\">\n{{ ::vm.charts.storage.using }}{{ vm.charts.storage.unity }}</span> <span translate=\"SUBSCRIPTION.OF\">of</span> <span \nclass=\"fw-500 black\">{{ ::vm.charts.storage.limit }}{{ vm.charts.storage.unity }}</span> <span \ntranslate=\"SUBSCRIPTION.USING\">using</span></div></div></div><div class=\"description\" layout=\"column\"><div><div \nclass=\"f16\" layout=\"row\"><span class=\"black\">{{ ::vm.storage.price }}</span> <span class=\"gray\">\n{{ ::vm.subscription.period }}</span></div><span class=\"upgrade-description\" \ntranslate=\"SUBSCRIPTION.REQUEST_STORAGE_UPGRADE\">Need more storage? Request an upgrade</span></div></div><div \nclass=\"upgrade-button-container\" layout=\"column\" layout-align=\"start end\"><md-button \nclass=\"md-accent md-raised fc-button\" ng-click=\"vm.toggleSidenav(\'storage-upgrade-sidenav\')\"><span \ntranslate=\"SUBSCRIPTION.UPGRADE_BUTTON\">Upgrade</span></md-button></div></div></div></md-content></div></div>\n<due-date-sidenav subscription=\"vm.subscription\" renewal=\"vm.viewModel.pendingRenewal\"></due-date-sidenav>\n<employees-upgrade-sidenav feature=\"vm.features.technicianApp\"></employees-upgrade-sidenav><renewal-sidenav \nsubscription=\"vm.subscription\" renewal=\"vm.viewModel.pendingRenewal\" features=\"vm.renewalFeatures\"></renewal-sidenav>\n</div>");
$templateCache.put("app/main/tasks/tasks.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav tasks-page\" layout=\"row\" \nng-if=\"!vm.canShowNewTaskList && !vm.isLoading\"><div class=\"center\" layout=\"column\" flex><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><span translate=\"TASKS.TITLE\">Orders</span></div></div><div><md-button \ndata-cy=\"instructions-button\" class=\"md-accent md-mini button-white-bg tutorial-video\" aria-label=\"Play\" \nng-click=\"vm.openVideoTutorial()\"><md-icon md-font-icon=\"icon-play-circle\"></md-icon><span \ntranslate=\"TASKS.TUTORIAL_VIDEO.TITLE\"></span><md-tooltip><span translate=\"TASKS.TUTORIAL_VIDEO.TOOLTIP\">\nAssistir vídeo explicativo.</span></md-tooltip></md-button></div><div class=\"search\" layout=\"row\" \nlayout-align=\"end center\" flex><md-button data-cy=\"print-button\" \nng-click=\"vm.exportData($event, \'impressão\', \'buttons-print\');\" \nng-disabled=\"vm.exportingDataLoading || vm.totalRows === 0\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Imprimir\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip><span translate=\"TASKS.ACTION_BUTTONS.PRINT\">Print</span>\n</md-tooltip></md-button><md-button data-cy=\"export-pdf-button\" \nng-click=\"vm.exportData($event, \'pdf\', \'buttons-pdf\');\" ng-disabled=\"vm.exportingDataLoading || vm.totalRows === 0\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Imprimir\"><md-icon \nmd-svg-src=\"assets/icons/icon-pdf.svg\"></md-icon><md-tooltip><span translate=\"TASKS.EXPORT_MODAL.TITLE_PDF\">Print\n</span></md-tooltip></md-button><md-button data-cy=\"export-excel-button\" \nng-click=\"vm.exportData($event, \'exportação\', \'buttons-excel\');\" \nng-disabled=\"vm.exportingDataLoading || vm.totalRows === 0\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Export Excel\"><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon><md-tooltip><span translate=\"TASKS.ACTION_BUTTONS.EXPORT_EXCEL\">Export Excel\n</span></md-tooltip></md-button><md-button data-cy=\"restore-columns-button\" ng-if=\"vm.dtLocalStorageStatus();\" \nng-click=\"vm.dtLocalStorageRemove();\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"Restore columns\" translate translate-attr-aria-label=\"TASKS.ACTION_BUTTONS.RESTORE_COLUMNS\"><md-icon \nmd-font-icon=\"icon-table\"></md-icon><md-tooltip><span translate=\"TASKS.ACTION_BUTTONS.RESTORE_COLUMNS\">Restore columns\n</span></md-tooltip></md-button><md-menu data-cy=\"columns\" md-position-mode=\"left bottom\"><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" data-cy=\"tasks-toggle-columns-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Toggle columns\" translate translate-attr-aria-label=\"TASKS.TOGGLE_COLUMNS\">\n<md-icon md-font-icon=\"icon-table-edit\"></md-icon><md-tooltip><span translate=\"TASKS.ACTION_BUTTONS.TOGGLE_COLUMNS\">\nToggle columns</span></md-tooltip></md-button><md-menu-content data-cy=\"tasks-toggle-columns-menu\" width=\"3\">\n<md-menu-item \nng-if=\"(vm.dtColumns.length - 1) > $index && $index > 0 && column.sTitle !== \'Etiquetas\' && column.sTitle !== \'Comentário\'\" \nng-repeat=\"column in vm.dtColumns track by $index\"><md-button data-cy=\"tasks-toggle-columns-menu-item\" \nng-click=\"vm.toggleColumnVisibility($index);\" md-prevent-menu-close=\"md-prevent-menu-close\"><span \nng-class=\"{ \'line-thru\': (vm.isColumnVisible($index) === false) }\">{{column.sTitle}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-button data-cy=\"tasks-clear-filters-button\" ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"TASKS.ACTION_BUTTONS.CLEAR_FILTERS\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"TASKS.ACTION_BUTTONS.CLEAR_FILTERS\">\nClear filters</span></md-tooltip></md-button><md-button data-cy=\"tasks-filter-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'tasks-filters-sidenav\')\" aria-label=\"Filter tasks\" translate \ntranslate-attr-aria-label=\"TASKS.ACTION_BUTTONS.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span\n translate=\"TASKS.ACTION_BUTTONS.FILTER\">Filter tasks</span></md-tooltip></md-button><md-button \ndata-cy=\"tasks-add-button\" ng-click=\"vm.createTask($event)\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"TASKS.ACTION_BUTTONS.NEW\" \nng-if=\"vm.addPermission && !vm.accountConfiguration.featureDisableAddTask\" aria-label=\"New task\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip><span translate=\"TASKS.ACTION_BUTTONS.NEW\">New task</span></md-tooltip>\n</md-button><md-button id=\"create-task-button-disabled\" ng-if=\"!vm.addPermission \" \nclass=\"md-icon-button md-accent md-mini button-white-bg md-button-disabled-css no-padding-important\" \naria-label=\"You are not allowed to create tasks\" translate \ntranslate-attr-aria-label=\"CONTROL_PANEL.TOOLBAR.CREATE_TASK.NO_PERMISSION\"><md-icon md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip><span translate=\"CONTROL_PANEL.TOOLBAR.CREATE_TASK.NO_PERMISSION\">\nYou are not allowed to create tasks</span></md-tooltip></md-button><md-button data-cy=\"reload-button\" \nng-click=\"vm.reload()\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"TASKS.ACTION_BUTTONS.RELOAD\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip><span translate=\"TASKS.ACTION_BUTTONS.RELOAD\">Reload</span>\n</md-tooltip></md-button></div></div><div ng-if=\"!vm.hideFeedbackForm || vm.hideFeedbackForm === \'false\'\" \nclass=\"fc-warning-container fc-warning-container--inside-tab tasks-feedback\"><div \nstyle=\"display: flex; flex-direction: row; gap: 12px\"><md-icon \nstyle=\"color: blue; height: 20px !important; min-height: 20px !important\" md-svg-src=\"assets/icons/feedback.svg\">\n</md-icon><div class=\"tasks-feedback-div\"><span translate=\"TASKS.FEEDBACK_FORM\">Feedback form</span> <a \nhref=\"https://bit.ly/Conviteexclusivofield\" target=\"_blank\" translate=\"CORE.CLICK_HERE\">Click here</a></div></div>\n<md-button style=\"padding-top: 6px !important\" class=\"md-icon-button\" ng-click=\"vm.closeFeedback();\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon style=\"color: #135AC0\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"table-list\" datatable=\"\" \nclass=\"dataTable row-border hover\" dt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"><tbody data-cy=\"task-list\"></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"tasks-filters-sidenav\" \nng-include=\"\'app/main/tasks/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"TasksFiltersSidenavController as vm\" ms-sidenav-helper></md-sidenav></div><task-list-page \nng-show=\"vm.canShowNewTaskList && !vm.isLoading\"></task-list-page>");
$templateCache.put("app/main/tickets/tickets.html","<tickets-page class=\"fade\"></tickets-page>");
$templateCache.put("app/main/vehicles/vehicles.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"VEHICLES.TITLE\">\nVehicles</span><div layout=\"row\"><md-button class=\"md-accent md-mini button-white-bg tutorial-video\" aria-label=\"Play\" \nng-click=\"vm.openVideoTutorial()\"><md-icon md-font-icon=\"icon-play-circle\"></md-icon><span \ntranslate=\"VEHICLES.TUTORIAL_VIDEO.TITLE\"></span><md-tooltip><span translate=\"VEHICLES.TUTORIAL_VIDEO.TOOLTIP\">\nAssistir vídeo explicativo.</span></md-tooltip></md-button></div></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"end center\" flex><md-button data-cy=\"add-vehicle-button\" ng-click=\"vm.openAddVehicleDialog($event)\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate \ntranslate-attr-aria-label=\"VEHICLES.TOOLBAR.ADD\" aria-label=\"Add vehicle\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip><span translate=\"VEHICLES.TOOLBAR.ADD\">Add vehicle</span></md-tooltip></md-button><md-button \nng-if=\"vm.showQrCodeButton\" ng-click=\"vm.openQrCodeGenerator()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" translate \ntranslate-attr-aria-label=\"VEHICLES.TOOLBAR.GENERATE_QR_CODE\" aria-label=\"Generate QR Code\"><md-icon \nmd-font-icon=\"icon-qrcode\"></md-icon><md-tooltip><span translate=\"VEHICLES.TOOLBAR.GENERATE_QR_CODE\">Generate QR Code\n</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate \ntranslate-attr-aria-label=\"VEHICLES.TOOLBAR.CLEAR_FILTERS\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon>\n<md-tooltip><span translate=\"VEHICLES.TOOLBAR.CLEAR_FILTERS\">Clear filters</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" \nng-click=\"vm.toggleSidenav(\'vehicles-filters-sidenav\')\" aria-label=\"Filter vehicles\" translate \ntranslate-attr-aria-label=\"VEHICLES.TOOLBAR.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"VEHICLES.TOOLBAR.FILTER\">Filter vehicles</span></md-tooltip></md-button><md-button data-cy=\"reload-button\" \nng-click=\"vm.reload();\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-hide=\"vm.showMap\" aria-label=\"Reload\" translate translate-attr-aria-label=\"VEHICLES.TOOLBAR.RELOAD\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip><span translate=\"VEHICLES.TOOLBAR.RELOAD\">Reload</span></md-tooltip>\n</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table id=\"table-list\" datatable=\"\" class=\"dataTable row-border hover\" \ndt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div>\n</div></div><md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"vehicles-filters-sidenav\" \nng-include=\"\'app/main/vehicles/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"VehiclesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/vehicles-usage/vehicles-usage.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"VEHICLES_USAGE.TITLE\">Vehicles</span><md-button class=\"md-accent md-mini button-white-bg tutorial-video\" \naria-label=\"Play\" ng-click=\"vm.openVideoTutorial()\"><md-icon md-font-icon=\"icon-play-circle\"></md-icon><span \ntranslate=\"VEHICLES_USAGE.TUTORIAL_VIDEO.TITLE\"></span><md-tooltip><span \ntranslate=\"VEHICLES_USAGE.TUTORIAL_VIDEO.TOOLTIP\">Assistir vídeo explicativo.</span></md-tooltip></md-button></div>\n<div></div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" flex><md-button \nng-click=\"vm.exportData();\" ng-disabled=\"!vm.vehiclesUsage.length\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Export to Excel\"><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon><md-tooltip><span translate=\"VEHICLES_USAGE.TOOLBAR.EXPORT_EXCEL\">\nExport to Excel</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate \ntranslate-attr-aria-label=\"VEHICLES_USAGE.TOOLBAR.CLEAR_FILTERS\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon>\n<md-tooltip><span translate=\"VEHICLES_USAGE.TOOLBAR.CLEAR_FILTERS\">Clear filters</span></md-tooltip></md-button>\n<md-button class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" \nng-click=\"vm.toggleSidenav(\'vehicles-usage-filters-sidenav\')\" aria-label=\"Filter vehicles\" \ntranslate-attr-aria-label=\"VEHICLES_USAGE.TOOLBAR.FILTER\" data-cy=\"vehicle-usage-filter-button\" translate><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip><span translate=\"VEHICLES_USAGE.TOOLBAR.FILTER\">Filter vehicles</span>\n</md-tooltip></md-button><md-button data-cy=\"reload-button\" ng-click=\"vm.reload();\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-hide=\"vm.showMap\" aria-label=\"Reload\" \ntranslate translate-attr-aria-label=\"VEHICLES_USAGE.TOOLBAR.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon>\n<md-tooltip><span translate=\"VEHICLES_USAGE.TOOLBAR.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"table-list\" datatable=\"\" class=\"dataTable row-border hover\" dt-instance=\"vm.dtInstanceCallback\" \ndt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div></div></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"vehicles-usage-filters-sidenav\" \nng-include=\"\'app/main/vehicles-usage/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"VehiclesUsageFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/work-services/work-services.html","<div id=\"default-list\" class=\"page-layout carded fullwidth with-filters-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"WORK_SERVICES.TITLE\">Services</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"end center\" \nflex><md-menu md-position-mode=\"left bottom\" ng-if=\"vm.showIntegrationButton(\'Omie\');\" ng-hide=\"vm.showMap\"><md-button \ndata-cy=\"import-omie-button\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"$mdOpenMenu();\"><md-icon md-svg-src=\"/assets/icons/icon-omie-active.svg\" class=\"icon-customer-import\">\n</md-icon><md-tooltip><span translate=\"WORK_SERVICES.IMPORT.TITLE\" translate-value-app=\"Omie\">Import services from Omie\n</span></md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item><md-button data-cy=\"manual-import-button\" \nng-click=\"vm.openImportOmieDialog($event, \'manual\')\"><span translate=\"WORK_SERVICES.IMPORT.MANUAL\">Manual import</span>\n</md-button></md-menu-item><md-menu-item><md-button data-cy=\"automatic-import-button\" \nng-click=\"vm.openImportOmieDialog($event, \'automatic\')\"><span translate=\"WORK_SERVICES.IMPORT.AUTOMATIC\">\nAutomatic import</span></md-button></md-menu-item></md-menu-content></md-menu><md-button data-cy=\"export-excel-button\" \nng-click=\"vm.exportProductsServices($event);\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" aria-label=\"Export to Excel\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.TOOLBAR.EXPORT_TO_EXCEL\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>\n<md-tooltip><span translate=\"CUSTOMERS.TOOLBAR.EXPORT_TO_EXCEL\">Export to Excel</span></md-tooltip></md-button>\n<md-button data-cy=\"add-service-button\" ng-disabled=\"vm.account.configuration.featureDisableAddProductService\" \nng-click=\"vm.addService($event)\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \ntranslate-attr-aria-label=\"WORK_SERVICES.NEW\" aria-label=\"New plan type\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip><span translate=\"WORK_SERVICES.NEW\">New service</span></md-tooltip></md-button><md-button \ndata-cy=\"clear-filters-button\" ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" ng-click=\"vm.clearFilters()\" \naria-label=\"Clear Filters\" translate translate-attr-aria-label=\"WORK_SERVICES.FILTERS.CLEAR\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"WORK_SERVICES.FILTERS.CLEAR\">Clear filters\n</span></md-tooltip></md-button><md-button data-cy=\"filters-button\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \nng-click=\"vm.toggleSidenav(\'work-services-filters-sidenav\')\" aria-label=\"Filter and services\" translate \ntranslate-attr-aria-label=\"WORK_SERVICES.FILTER\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip><span \ntranslate=\"WORK_SERVICES.FILTER\">Filter services</span></md-tooltip></md-button><md-button data-cy=\"reload-button\" \nng-click=\"vm.reload();\" class=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"WORK_SERVICES.RELOAD\"><md-icon md-font-icon=\"icon-reload\">\n</md-icon><md-tooltip><span translate=\"WORK_SERVICES.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"table-list\" datatable=\"\" class=\"dataTable row-border hover datatable-products-services\" \ndt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div>\n</div></div><md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"work-services-filters-sidenav\" \nng-include=\"\'app/main/work-services/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"WorkServicesFiltersSideNavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/core/dialogs/form-questions/form-questions.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large equipments-forms-dialogs task-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\">\n{{ \'TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.REPLY\' | translate }} \"{{vm.form.name}}\"</span>\n</div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><form name=\"vm.formQuestionsForm\" novalidate><md-dialog-content class=\"pt-0\" \nlayout=\"column\" ms-scroll><div class=\"fc-warning-flexbox\"><div ng-if=\"vm.form.archived\" \nclass=\"fc-warning-container fc-warning-container--inside-tab\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.ARCHIVED.FORMS_IS_ARCHIVED\"></span></div></div><div \nclass=\"equipment-form-header\" ng-if=\"vm.form && vm.form.status && !(vm.vehicleUsage && vm.vehicleUsage.id)\"><span \nng-if=\"vm.form.status === \'in-progress\'\" class=\"form--in-progress\">\n{{\'TASKS.DIALOG.TABS.FORMS.IN_PROGRESS\' | translate}} </span><span ng-if=\"vm.form.status === \'done\'\" \nclass=\"form--done\">{{\'TASKS.DIALOG.TABS.FORMS.DONE\' | translate}}</span><md-button \nng-disabled=\"!vm.form || vm.form.status !== \'in-progress\' || $root.loadingProgress\" \nclass=\"md-icon-button md-accent reload-form-icon equipment-form-header__reload\" ng-click=\"vm.reloadFormAnswer()\" \nng-if=\"vm.form && vm.form.status === \'in-progress\'\"><md-icon md-menu-origin md-svg-src=\"assets/icons/reload-icon.svg\">\n</md-icon><span translate=\"TASKS.DIALOG.TABS.FORMS.RELOAD\"></span></md-button></div><div ng-if=\"$root.loadingProgress\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div><div \nng-if=\"!$root.loadingProgress\" class=\"question\" \nng-repeat=\"question in vm.form.questions | orderBy: \'position\' track by $index\"><div class=\"question__item\" \nng-if=\"question.type === \'short-answer\' && vm.satisfyQuestionCondition(question)\"><label>{{ question.title }}<span \nclass=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><fc-textarea no-animation=\"true\" label=\" \" \nis-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" ng-model=\"question.answer\" \ninput-name=\"shortAnswer__{{$index}}\" input-control=\"vm.formQuestionsForm[\'shortAnswer__\' + $index]\" max-length=\"100\" \nerrors-to-watch=\"[\n              {\n                name: \'maxlength\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.MAX_LENGTH\',\n                translateValues: { expectedLength: 100, receivedLength: vm.formQuestionsForm[\'shortAnswer__\' + $index].$viewValue.length }\n              }\n            ]\">\n</div><div class=\"question__item\" ng-if=\"question.type === \'email\' && vm.satisfyQuestionCondition(question)\"><label>\n{{ question.title }}<span class=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><input \nno-animation=\"true\" class=\"equipment_text_input\" label=\" \" \nis-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" ng-model=\"question.answer\" \ninput-name=\"email__{{$index}}\" input-control=\"vm.formQuestionsForm[\'email__\' + $index]\" max-length=\"80\"></div><div \nflex=\"100\" layout=\"column\" class=\"question__item\" \nng-if=\"question.type === \'currency\' && vm.satisfyQuestionCondition(question)\"><label>{{ question.title }}<span \nclass=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><input no-animation=\"true\" \nclass=\"equipment_text_input\" label=\" \" type=\"text\" \nis-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" ng-model=\"question.answer\" \ninput-name=\"currency__{{$index}}\" input-control=\"vm.formQuestionsForm[\'currency__\' + $index]\" max-length=\"80\" \nmin=\"0.00\" ui-money-mask></div><div flex=\"100\" layout=\"column\" class=\"question__item\" \nng-if=\"question.type === \'phone\' && vm.satisfyQuestionCondition(question)\"><label>{{ question.title }}<span \nclass=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><input no-animation=\"true\" \nclass=\"equipment_text_input\" ui-mask=\"+55 (99) 99999-9999\" label=\" \" type=\"text\" \nis-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" ng-model=\"question.answer\" \ninput-name=\"phone__{{$index}}\" input-control=\"vm.formQuestionsForm[\'phone__\' + $index]\" max-length=\"80\"></div><div \nflex=\"100\" layout=\"column\" class=\"question__item\" \nng-if=\"question.type === \'document\' && vm.satisfyQuestionCondition(question)\"><label>{{ question.title }}<span \nclass=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><input no-animation=\"true\" \nclass=\"equipment_text_input\" label=\" \" type=\"text\" \nis-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" ng-model=\"question.answer\" \ninput-name=\"document__{{$index}}\" input-control=\"vm.formQuestionsForm[\'document__\' + $index]\" max-length=\"80\" \nui-br-cpfcnpj-mask></div><div flex=\"100\" class=\"question__item\" \nng-if=\"question.type === \'paragraph\' && vm.satisfyQuestionCondition(question)\"><label>{{ question.title }}<span \nclass=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><fc-textarea ng-model=\"question.answer\" \nis-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" input-name=\"paragraph__{{$index}}\" \ninput-control=\"vm.formQuestionsForm[\'paragraph__\' + $index]\" max-length=\"5000\" \nerrors-to-watch=\"[\n              {\n                name: \'maxlength\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.MAX_LENGTH\',\n                translateValues: { expectedLength: 5000, receivedLength: vm.formQuestionsForm[\'paragraph__\' + $index].$viewValue.length }\n              }\n            ]\">\n</div><div flex=\"100\" class=\"question__item\" \nng-if=\"question.type === \'dropdown\' && vm.satisfyQuestionCondition(question)\"><label>{{ question.title }}<span \nclass=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><fc-select options=\"question.options\" \nng-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" input-name=\"option__{{$index}}\" \ninput-control=\"vm.formQuestionsForm[\'option__\' + $index]\" ng-model=\"question.answer\"></fc-select></div><div flex=\"100\" \nlayout=\"column\" class=\"question__item\" ng-if=\"question.type === \'hour\' && vm.satisfyQuestionCondition(question)\">\n<label>{{ question.title }}<span class=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><input \nclass=\"equipment__input\" type=\"text\" ng-pattern=\"formatTime\" ui-time-mask=\"short\" id=\"hour__{{$index}}\" \nname=\"hour__{{$index}}\" ng-model=\"question.answer\" \nng-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\"><div \nng-if=\"vm.formQuestionsForm[\'hour__\' + $index].$error.time\" role=\"alert\" class=\"fs-15\"><small><span class=\"red-text\" s \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.TIMEABLE_VISIT.ERRORS.INVALID\">Invalid time</span></small></div></div><div \nflex=\"100\" layout=\"column\" class=\"question__item\" \nng-if=\"question.type === \'numeric\' && vm.satisfyQuestionCondition(question)\"><label>{{ question.title }}<span \nclass=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><input class=\"equipment__input\" type=\"number\" \nng-maxlength=\"15\" string-to-number id=\"numeric__{{$index}}\" name=\"numeric__{{$index}}\" ng-model=\"question.answer\" \nng-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\"></div><div flex=\"100\" class=\"question__item\" \nng-if=\"question.type === \'date\' && vm.satisfyQuestionCondition(question)\"><div flex=\"100\"><label \nstyle=\"margin-bottom: 6px !important\">{{ question.title }}<span class=\"text-darkred\" ng-if=\"question.required\">&nbsp;*\n</span></label><div \nclass=\"fc-datepicker fc-datepicker--without-after-border fc-datepicker--change-border-color datepicker__container\"><div\n class=\"date-container\"><md-datepicker class=\"p-0 form-answers-datepicker\" flex name=\"date__{{$index}}\" \nng-model=\"question.answer\" ng-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" \nmd-hide-icons=\"calendar\"></md-datepicker></div></div><div layout=\"row\" \nng-messages=\"vm.formQuestionsForm[\'date__\' + $index].$error\" role=\"alert\" class=\"fs-15\"><div ng-message=\"valid\"><small>\n<span class=\"red-text\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SCHEDULED_DATE.ERRORS.INVALID\">\nScheduled date is invalid</span></small></div><div ng-message=\"required\"><small><span class=\"red-text\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SCHEDULED_DATE.ERRORS.REQUIRED\">Scheduled date field is required</span>\n</small></div></div></div></div><div flex=\"100\" layout=\"column\" class=\"question__item\" \nng-if=\"question.type === \'checkboxes\' && vm.satisfyQuestionCondition(question)\"><label style=\"margin-bottom: 6px\">\n{{ question.title }}<span class=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><md-checkbox \nng-repeat=\"option in question.options | orderBy: \'position\'\" ng-model=\"option.answer\" name=\"checkboxes__{{$index}}\" \nng-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" ng-change=\"vm.answeredCheckboxes(question)\">\n<span>{{option.value}}</span></md-checkbox></div><div flex=\"100\" layout=\"row\" layout-align=\"start center\" \nclass=\"question__item\" ng-if=\"question.type === \'unique-checkbox\' && vm.satisfyQuestionCondition(question)\"><input \ntype=\"checkbox\" ng-model=\"question.answer\" ng-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" \nng-true-value=\"true\" ng-false-value=\"null\"><label class=\"no-margin\">{{ question.title }}<span class=\"text-darkred\" \nng-if=\"question.required\">&nbsp;*</span></label></div><div flex=\"100\" class=\"question__item\" \nng-if=\"question.type === \'signature\' && vm.satisfyQuestionCondition(question)\"><label>{{ question.title }}<span \nclass=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><input type=\"hidden\" ng-model=\"question.answer\" \nng-model-options=\"{ debounce: 1000 }\" name=\"signature__{{$index}}\"><div ng-if=\"question.showPad\" \nstyle=\"position: relative\"><div><signature-pad clear=\"clear\" dataurl=\"vm.signatures[question.position].dataUrl\" \naccept=\"accept\" height=\"220\" width=\"1000\" disabled=\"vm.form.status === \'in-progress\'\" class=\"pad-signature\">\n</signature-pad></div></div><div ng-if=\"!question.showPad\"><div class=\"container-picture-signature\" \nstyle=\"width: 100%;position: relative\"><img ng-src=\"{{ question.answer }}\" ng-if=\"question.answer\"> <span \nstyle=\"font-size: 14px; color: #9E9E9E\" class=\"no-signature\" ng-if=\"!question.answer\" \ntranslate=\"TASKS.DIALOG.TABS.FORMS.SIGNATURE.NO\">No signature</span></div></div><md-button \nclass=\"md-red-bg padding-horizontal-20 margin-top-20\" ng-click=\"vm.clearQuestionSignature(question, true);\" \nng-if=\"vm.signatures[question.position].dataUrl\"><md-icon md-font-icon=\"icon-delete\" class=\"white-500-fg\"></md-icon>\n<span translate=\"TASKS.DIALOG.TABS.FORMS.SIGNATURE.REMOVE\">Remove signature</span></md-button><md-button \nng-if=\"vm.signatures[question.position].dataUrl\" class=\"md-accent md-raised padding-horizontal-20 margin-top-20\" \nng-click=\"vm.confirmSignatures(question)\"><span translate=\"TASKS.DIALOG.TABS.FORMS.SIGNATURE.CONFIRM\">Confirm signature\n</span></md-button><md-button ng-if=\"!vm.signatures[question.position].dataUrl && !question.showPad\" \nclass=\"md-accent md-raised padding-horizontal-20 margin-top-20\" ng-click=\"question.showPad = true\"><span \ntranslate=\"TASKS.DIALOG.TABS.FORMS.SIGNATURE.ADD\">Add signature</span></md-button></div><div flex=\"100\" \nclass=\"question__item\" ng-if=\"question.type === \'picture\' && vm.satisfyQuestionCondition(question)\"><label>\n{{ question.title }}<span class=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><div \nclass=\"picture__container\"><div flex=\"100\" layout=\"row\" layout-align=\"center center\"><div ng-if=\"question.answer\" \nclass=\"picture__container__image\"><img ng-src=\"{{question.answer}}\"><div ng-click=\"vm.deletePictureAnswer(question)\" \nclass=\"picture__container__image-remove-icon\"><md-icon md-svg-src=\"assets/icons/close-image.svg\"></md-icon></div></div>\n</div><div flex=\"100\" layout=\"row\" layout-align=\"end center\"><button class=\"picture__container__attachment\" \nngf-select=\"vm.setPictureAnswerPreview($file, question)\" ngf-multiple=\"false\" \nngf-pattern=\"\'.jpg,.jpeg,.JPG,.JPEG,.png,.PNG\'\" ngf-accept=\"\'.jpg,.jpeg,.JPG,.JPEG,.png,.PNG\'\" ngf-max-files=\"1\" \nngf-allow-dir=\"false\" ngf-max-size=\"2MB\" ng-disabled=\"vm.form.status === \'in-progress\'\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.INSERT_ATTACHMENTS\">Inserir anexos</button>\n</div></div></div><div class=\"pb-question mb-20\" \nng-if=\"question.type === \'multiple-picture\' && vm.satisfyQuestionCondition(question)\"><label>{{ question.title }}<span \nclass=\"text-darkred\" ng-if=\"question.required\">&nbsp;*</span></label><div class=\"multiple-picture__pictures mt-10\">\n<fc-image-input height=\"125px\" ng-model=\"question.answer[0]\" ngf-accept=\"\'.jpg,.jpeg,.JPG,.JPEG,.png,.PNG\'\" \nimage-file=\"vm.multiplePictures[\'question_\' + $index][0]\" is-disabled=\"vm.form.status === \'in-progress\'\" \ndata-cy=\"multiple-picture-attachment\" on-change=\"vm.setMultiplePicturesAnswerPreview(value, question, 0)\" \non-remove-image=\"vm.deleteMultiplePictureAnswer(question, $index, 0)\"></fc-image-input><fc-image-input height=\"125px\" \nng-model=\"question.answer[1]\" ngf-accept=\"\'.jpg,.jpeg,.JPG,.JPEG,.png,.PNG\'\" \nimage-file=\"vm.multiplePictures[\'question_\' + $index][1]\" is-disabled=\"vm.form.status === \'in-progress\'\" \ndata-cy=\"multiple-picture-attachment\" on-change=\"vm.setMultiplePicturesAnswerPreview(value, question, 1)\" \non-remove-image=\"vm.deleteMultiplePictureAnswer(question, $index, 1)\"></fc-image-input><fc-image-input height=\"125px\" \nng-model=\"question.answer[2]\" ngf-accept=\"\'.jpg,.jpeg,.JPG,.JPEG,.png,.PNG\'\" \nimage-file=\"vm.multiplePictures[\'question_\' + $index][2]\" is-disabled=\"vm.form.status === \'in-progress\'\" \ndata-cy=\"multiple-picture-attachment\" on-change=\"vm.setMultiplePicturesAnswerPreview(value, question, 2)\" \non-remove-image=\"vm.deleteMultiplePictureAnswer(question, $index, 2)\"></fc-image-input><fc-image-input height=\"125px\" \nng-model=\"question.answer[3]\" ngf-accept=\"\'.jpg,.jpeg,.JPG,.JPEG,.png,.PNG\'\" \nimage-file=\"vm.multiplePictures[\'question_\' + $index][3]\" is-disabled=\"vm.form.status === \'in-progress\'\" \ndata-cy=\"multiple-picture-attachment\" on-change=\"vm.setMultiplePicturesAnswerPreview(value, question, 3)\" \non-remove-image=\"vm.deleteMultiplePictureAnswer(question, $index, 3)\"></fc-image-input><fc-image-input height=\"125px\" \nng-model=\"question.answer[4]\" ngf-accept=\"\'.jpg,.jpeg,.JPG,.JPEG,.png,.PNG\'\" \nimage-file=\"vm.multiplePictures[\'question_\' + $index][4]\" is-disabled=\"vm.form.status === \'in-progress\'\" \ndata-cy=\"multiple-picture-attachment\" on-change=\"vm.setMultiplePicturesAnswerPreview(value, question, 4)\" \non-remove-image=\"vm.deleteMultiplePictureAnswer(question, $index, 4)\"></fc-image-input></div><p \nclass=\"multiple-picture__alert\"><md-icon md-svg-src=\"assets/icons/icon-warning.svg\" class=\"icon-warning\"></md-icon>\n{{ \'TASKS.DIALOG.TABS.FORMS.MULTIPLE_PICTURES.WARNING\' | translate}}</p></div><div class=\"question__item\" \nng-if=\"question.type === \'multiple-choice\' && vm.satisfyQuestionCondition(question)\"><label>{{ question.title }}<span \nng-if=\"question.required\" class=\"text-darkred\">&nbsp;*</span></label><md-radio-group \nname=\"multiple-choices__{{$index}}\" ng-model=\"question.answer\"><md-radio-button value=\"{{ option.value }}\" \nid=\"{{ option.value }}\" ng-disabled=\"$root.loadingProgress || vm.form.status === \'in-progress\'\" \nng-repeat=\"option in question.options | orderBy: \'position\'\" class=\"md-primary display-block\">{{ option.value }}\n</md-radio-button></md-radio-group></div></div></md-dialog-content></form><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><button type=\"button\" \nng-click=\"vm.saveForm()\" aria-label=\"Save\" translate \nng-disabled=\"vm.formQuestionsForm.$invalid || $root.loadingProgress || vm.formQuestionsForm.$pristine\" \nclass=\"fc-button fc-button--actions\" \nng-class=\"{\'disabled\': vm.formQuestionsForm.$invalid || $root.loadingProgress || vm.formQuestionsForm.$pristine}\">\n{{ \'TASKS.DIALOG.ACTIONS.SAVE\' | translate }}</button></div><div layout=\"row\" \nng-if=\"vm.isEditing && vm.order && vm.order.id\"><md-button class=\"md-icon-button\" \nng-click=\"vm.archiveEquipmentForm($event);\" ng-if=\"vm.form && vm.form.id && !vm.form.archived\" \nng-disabled=\"vm.form.locked\" aria-label=\"Archive form\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"FORMS.DIALOG.ACTIONS.ARCHIVE_FORM\">Archive form</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.unarchiveEquipmentForm();\" ng-if=\"vm.form.archived\" \nng-disabled=\"vm.form.locked\" aria-label=\"Unarchive form\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"FORMS.DIALOG.ACTIONS.UNARCHIVE_FORM\">Unarchive form</span></md-tooltip>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/dialogs/launch-video/launch-video.html","<md-dialog class=\"launch-video\"><div class=\"launch-video__header\"><span class=\"launch-video__header__title\">\n{{ vm.title }}</span><md-button ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div><div class=\"launch-video__message\">{{ vm.message }}</div><div class=\"launch-video__video\"><iframe width=\"600\" \nheight=\"337\" ng-src=\"{{vm.videoUrl}}\" title=\"YouTube video player\" frameborder=\"0\" \nallow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\" \nallowfullscreen></iframe></div></md-dialog>");
$templateCache.put("app/core/dialogs/video-tutorial/video-tutorial.html","<md-dialog id=\"video-tutorial\"><div><md-button data-cy=\"close-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div data-cy=\"video-tutorial-container\" class=\"video-container\">\n<iframe data-cy=\"video-tutorial-iframe\" width=\"640\" height=\"360\" ng-src=\"{{vm.videoUrl}}\" title=\"YouTube video player\" \nframeborder=\"0\" \nallow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\" \nallowfullscreen></iframe></div></md-dialog>");
$templateCache.put("app/core/directives/corporate-customer-disclaimer/corporate-customer-disclaimer.html","<div data-cy=\"corporate-disclaimer\" class=\"fc-warning-container {{customClass || \'\'}}\" layout=\"row\" role=\"alert\">\n<md-icon class=\"warning-icon\" md-svg-src=\"assets/icons/icon-padlock.svg\"></md-icon><span \ntranslate=\"CORE.CORPORATE_CUSTOMER_DISCLAIMER\" translate-values=\"{ customerName: customerName }\">\nThe information about this page is defined by your customer <b>{{ customerName }}</b> and therefore can\'t be updated.\n</span></div>");
$templateCache.put("app/core/directives/fc-card/fc-card.html","<div class=\"fc-card\" ng-class=\"{ enabled: configuration.isEnable }\"><div class=\"fc-card__badges\" layout=\"row\" \nlayout-align=\"end center\"><span ng-if=\"configuration.isEnable\" class=\"badge enabled\" \ntranslate=\"MODULES.MODULE_CARD.ENABLED\">enabled</span> <span ng-if=\"new && !configuration.isEnable\" class=\"badge new\" \ntranslate=\"MODULES.MODULE_CARD.NEW\">new!</span></div><div class=\"fc-card__content\" layout=\"column\" \nlayout-align=\"space-between center\"><div layout=\"column\"><div \nclass=\"layout-align-center-center layout-row fc-card__content__icon\" ng-class=\"{ enabled: configuration.isEnable }\" \nng-include=\"\'assets/icons/modules/\' + icon + \'.svg\'\"></div><p class=\"fc-card__content__title\">{{ title }}</p><p \nclass=\"fc-card__content__description\">{{ description }}</p></div><md-button \nclass=\"md-raised fc-card__content__button enabled\" translate=\"MODULES.MODULE_CARD.MANAGE\" \nng-if=\"configuration.isEnable && !configuration.isIntegration\" ng-click=\"openFunction()\">MANAGE</md-button><md-button \nclass=\"md-raised fc-card__content__button enabled\" translate=\"CONFIGURATIONS.INTEGRATIONS.DISABLE_BUTTON\" \nng-if=\"configuration.isEnable && configuration.isIntegration\" ng-click=\"openFunction()\">DISABLED</md-button><md-button \nclass=\"md-raised fc-card__content__button disabled\" translate=\"MODULES.ENABLE\" ng-if=\"!configuration.isEnable\" \nng-click=\"openFunction()\">ENABLE</md-button></div></div>");
$templateCache.put("app/core/directives/fc-date-input/fc-date-input.html","<div class=\"fc-date-input\" ng-class=\"{\'invalid-date\': vm.errors.length}\"><div class=\"fc-date-input__title\" \nng-class=\"{\'center-date-value\': vm.placeholderIsOnCenter}\"><span translate=\"CORE.FC_DATE_INPUT.PLACEHOLDER\">Date</span>\n<span ng-if=\"required\">*</span></div><md-datepicker flex ng-required=\"required\" name=\"suggestion-date\" \nclass=\"md-datepicker\" ng-change=\"vm.validateDate(true)\" ng-blur=\"vm.movePlaceholderToCenter()\" \nng-focus=\"vm.movePlaceholderToTop()\" ng-model=\"vm.dateModel\" md-min-date=\"vm.today\"></md-datepicker><div role=\"alert\" \nclass=\"fc-input__input-error\"><div class=\"red-text\"><small><span class=\"fc-datepicker__error\" \nng-if=\"vm.errors.includes(\'empty\')\" translate=\"CORE.FC_DATE_INPUT.ERRORS.EMPTY\">Empty date </span><span \nclass=\"fc-datepicker__error\" ng-if=\"vm.errors.includes(\'invalid\')\" translate=\"CORE.FC_DATE_INPUT.ERRORS.INVALID\">\nInvalid date </span><span class=\"fc-datepicker__error\" ng-if=\"vm.errors.includes(\'retroactive\')\" \ntranslate=\"CORE.FC_DATE_INPUT.ERRORS.RETROACTIVE\">Retroactive date</span></small></div></div></div>");
$templateCache.put("app/core/directives/fc-modal/fc-modal.html","<div data-cy=\"export-fc-modal\" \nclass=\"fc-modal {{ vm.modalClass }} {{ vm.paddingSmall && \'fc-modal__padding-small\' }} {{vm.large ? \'fc-modal__large\' : \'fc-modal__small\'}}\">\n<section class=\"fc-modal__items\"><md-icon class=\"fc-modal__icon\" ng-if=\"vm.iconPath\" md-svg-src=\"{{vm.iconPath}}\">\n</md-icon><h3 ng-if=\"!vm.closeButtonIconPath\" class=\"fc-modal__title\">{{ vm.title }}</h3><div \nng-if=\"vm.closeButtonIconPath\" class=\"fc-modal__header\"><div layout=\"row\"><md-icon class=\"title-icon\" \nng-if=\"vm.titleIconPath\" md-svg-src=\"{{vm.titleIconPath}}\"></md-icon><h3 class=\"fc-modal__title\">{{ vm.title }}</h3>\n</div><md-icon ng-if=\"vm.closeButtonIconPath\" md-svg-src=\"{{vm.closeButtonIconPath}}\" ng-click=\"vm.closeDialog()\">\n</md-icon></div><p ng-if=\"vm.content\" \nclass=\"fc-modal__content {{(vm.colorBold && vm.colorBold === \'blue\') && \'fc-modal__content__blue_bold\'}}\" \nng-style=\"{ \'letter-spacing\': vm.contentTextSpacing && vm.contentTextSpacing }\" ng-bind-html=\"vm.content\"></p><div \nng-if=\"vm.scrollableContent && vm.scrollableContent.length\"><div class=\"fc-modal__scrollable-content\"><div \nng-repeat=\"element in vm.scrollableContent\"><div class=\"fc-modal__scrollable-content__name\">{{element.name}}</div>\n</div></div></div><div ng-if=\"!!vm.templateUrl\" ng-include=\"vm.templateUrl\"></div></section><form name=\"fcModalForm\" \nclass=\"md-inline-form\" novalidate><div ng-if=\"!!vm.hasOmieAccountSelector\" class=\"fc-input omie-account-select\">\n<fc-select class=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.ACCOUNT.SELECT\' | translate)}}\" options=\"vm.omieAccounts\" \nng-model=\"vm.selectedAccount\" input-name=\"account\" track-by=\"name\" input-control=\"fcModalForm.account\" \nis-required=\"true\"></fc-select><fc-error input-errors=\"fcModalForm.account.$error\" \nng-show=\"fcModalForm.account.$touched\" \nerrors-to-watch=\"[\n          {\n            name: \'required\',\n            translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n          }\n        ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div ng-if=\"vm.hasOmieCustomerSelector\" \nclass=\"fc-input omie-account-select\"><fc-select \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.CUSTOMERS.SELECT\' | translate)}}\" options=\"vm.omieCustomers\" \nng-model=\"vm.selectedCustomer\" input-name=\"customer\" track-by=\"displayName\" input-control=\"fcModalForm.customer\" \nis-required=\"true\" search-function=\"vm.searchCustomerByName(searchTerm)\" \nsearch-phrase=\"{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.CUSTOMERS.SEARCH\' | translate)}}\" with-search=\"true\" \nskip-search=\"true\"></fc-select><fc-error input-errors=\"fcModalForm.account.$error\" \nng-show=\"fcModalForm.account.$touched\" \nerrors-to-watch=\"[\n          {\n            name: \'required\',\n            translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n          }\n        ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><section \nclass=\"{{vm.buttonSeparation ? \'fc-modal__buttons-container-flex\' : \'fc-modal__buttons-container\'}}\"><button \nng-if=\"vm.leftButtonText\" ng-click=\"vm.handleLeftButton()\" data-cy=\"fc-modal-left-button\" type=\"button\" \nclass=\"fc-button fc-modal__button fc-modal__button--left-button\" \nng-disabled=\"(vm && vm.updateFunction && vm.leftButtonColor) ? vm.updateFunction() : (vm.rightContinueButton ? false : fcModalForm.$invalid)\" \nng-class=\"{\'red-left-button\': vm.leftButtonColor}\" \nng-style=\"{ \'margin-right\': vm.rightButtonText ? \'12px\' : 0, \'width\': vm.buttonWidth && vm.buttonWidth }\">\n{{ vm.leftButtonText }}</button> <a ng-if=\"vm.rightButtonIsDownloadLink\" href=\"{{vm.downloadHref}}\" \ndownload=\"{{vm.downloadLink}}\" class=\"{{vm.rightButtomFullSize && \'full-size-button\' }}\"><button \nng-if=\"vm.rightButtonText\" ng-click=\"vm.handleRightButton()\" data-cy=\"fc-modal-right-button\" type=\"button\" \nclass=\"fc-button fc-modal__button fc-modal__button--right-button {{vm.rightButtomFullSize && \'full-size-button\' }}\">\n{{ vm.rightButtonText }}</button> </a><button ng-if=\"!vm.rightButtonIsDownloadLink && vm.rightButtonText\" \nng-click=\"vm.handleRightButton()\" data-cy=\"fc-modal-right-button\" type=\"button\" \nng-disabled=\"(vm && vm.updateFunction) ? vm.updateFunction() : (vm.rightContinueButton ? fcModalForm.$invalid : false)\" \nng-style=\"{ \'width\': vm.buttonWidth && vm.buttonWidth }\" \nclass=\"fc-button fc-modal__button fc-modal__button--right-button {{vm.rightButtomFullSize && \'full-size-button\' }}\">\n{{ vm.rightButtonText }}</button></section></form></div>");
$templateCache.put("app/core/directives/fc-smart-rewrite/fc-smart-rewrite.directive.html","<div class=\"fc-smart-rewrite\" ng-mouseenter=\"mouseEnter()\" ng-mouseleave=\"mouseLeave()\" \nng-class=\"{ \'fc-smart-rewrite--active\': hasValue && hasHover && !disabled }\"><div ng-transclude></div><div \nclass=\"fc-smart-rewrite__buttons\"><button data-cy=\"hasHistory-button\" ng-if=\"hasHistory\" type=\"button\" \nclass=\"fc-smart-rewrite__button fc-smart-rewrite__button--secondary\" ng-click=\"openInputHistory()\"><img \nsrc=\"assets/icons/smart-rewrite-history.svg\" alt=\"Smart Rewrite History\"> <span>Ver histórico de alterações</span>\n</button> <button data-cy=\"rewrite-button\" type=\"button\" class=\"fc-smart-rewrite__button\" ng-click=\"openDialog()\"><img \nsrc=\"assets/icons/smart-rewrite.svg\" alt=\"Smart Rewrite\"> <span translate=\"CORE.FC_SMART_REWRITE.REWRITE_TEXT\"></span>\n</button></div></div>");
$templateCache.put("app/core/directives/fc-time-input/fc-time-input.html","<div class=\"fc-time-input\" ng-class=\"{\'invalid-time\': vm.errors.length}\"><div class=\"fc-time-input__title\" \nng-class=\"{\'center-time-value\': vm.placeholderIsOnCenter}\"><span translate=\"CORE.FC_TIME_INPUT.PLACEHOLDER\">time</span>\n<span ng-if=\"required\">*</span></div><input type=\"text\" ng-required=\"required\" ng-model=\"vm.time\" ui-time-mask=\"short\" \nclass=\"fc-time-input__input\" ng-blur=\"vm.movePlaceholderToCenter()\" ng-focus=\"vm.movePlaceholderToTop()\"><md-icon \nclass=\"fc-time-input__icon\" md-svg-src=\"assets/icons/schedule.svg\"></md-icon><div role=\"alert\" \nclass=\"fc-input__input-error\"><div class=\"red-text\"><small><span class=\"fc-datepicker__error\" \nng-if=\"vm.errors.includes(\'empty\')\" translate=\"CORE.FC_TIME_INPUT.ERRORS.EMPTY\">Empty time </span><span \nclass=\"fc-datepicker__error\" ng-if=\"vm.errors.includes(\'invalid\')\" translate=\"CORE.FC_TIME_INPUT.ERRORS.INVALID\">\nInvalid time </span><span class=\"fc-datepicker__error\" ng-if=\"vm.errors.includes(\'retroactive\')\" \ntranslate=\"CORE.FC_TIME_INPUT.ERRORS.RETROACTIVE\">Retroactive time</span></small></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\" translate \ntranslate-attr-aria-label=\"CORE.MS_INFO_BAR.CLOSE\"><md-icon md-font-icon=\"icon-close s24\" class=\"md-background-fg\">\n</md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\" \ntranslate=\"CORE.MS_MATERIAL_COLOR_PICKER.SELECT_COLOR\">Select Color</span></md-button><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header ng-class=\"selectedColor.class || \'md-accent-bg\'\" \nclass=\"md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\"><md-button md-prevent-menu-close \nng-click=\"activateHueSelection(false,false)\" class=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" \naria-label=\"Palette\" translate translate-attr-aria-label=\"CORE.MS_MATERIAL_COLOR_PICKER.PALETTE\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\" \ntranslate=\"CORE.MS_MATERIAL_COLOR_PICKER.SELECT_COLOR\">Select Color</span><md-button \nclass=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\" translate \ntranslate-attr-aria-label=\"CORE.MS_MATERIAL_COLOR_PICKER.REMOVE_COLOR\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\">\n</md-icon></md-button></header><div class=\"colors\" ms-scroll><div ng-if=\"!selectedPalette\" layout=\"row\" layout-wrap>\n<div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" ng-repeat=\"(palette, hues) in palettes\" \nng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" layout-align=\"start end\" md-prevent-menu-close \nmd-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div ng-if=\"selectedPalette\" layout=\"row\" layout-wrap>\n<div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in selectedHues\" \nng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span class=\"label\">\n{{hue}} </span><i ng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\">\n</i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"CORE.MS_SEARCH_BAR.SEARCH\" flex></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ng-click=\"MsShortcuts.goTo(shortcut.url)\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\">\n{{shortcut.title}}</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\">\n<md-button class=\"md-icon-button add-shortcut-button\" aria-label=\"{{\'CORE.SHORTCUTS.ADD_OR_REMOVE\' | translate}}\" \nng-click=\"MsShortcuts.openMenu($mdOpenMenu, $event);\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CORE.SHORTCUTS.ADD_OR_REMOVE\">Add or remove shortcut</span></md-tooltip></md-button><md-menu-content><div \nid=\"ms-shortcut-add-menu\"><div class=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-icon\" layout=\"row\" layout-align=\"center center\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><input type=\"text\" placeholder=\"Search shortcut\" flex \nng-model=\"MsShortcuts.searchInput\" ng-keydown=\"MsShortcuts.handleKeydown($event)\" translate \ntranslate-attr-placeholder=\"CORE.SHORTCUTS.SEARCH\"></div><div class=\"results\" ms-scroll><div class=\"no-results\" \nng-if=\"MsShortcuts.listedShortcuts.length === 0\" translate=\"CORE.SHORTCUTS.NOT_FOUND\">No shortcuts found</div><div \nclass=\"result\" ng-repeat=\"result in MsShortcuts.listedShortcuts\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i></div><div><div class=\"title\">{{result.title}}</div></div></div><md-icon \nmd-font-icon=\"icon-pin\" class=\"icon s18\" ng-class=\"{\'fade-text\': !result.inUse}\"></md-icon></div></div></div></div>\n</md-menu-content></md-menu></div></div>");
$templateCache.put("app/core/services/fieldcontrol-global-events/fieldcontrol-global-events.html","");
$templateCache.put("app/main/absences/dialogs/absence-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large\" aria-label=\"Ausências\"><form name=\"absenceForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__title\"><span data-cy=\"new-title\" ng-show=\"vm.newAbsence\" class=\"title\" \ntranslate=\"ABSENCES.DIALOG.TITLE_NEW\">New absence</span> <span data-cy=\"edit-title\" ng-show=\"!vm.newAbsence\" \nclass=\"title\" translate=\"ABSENCES.DIALOG.TITLE_EDIT\">Edit absence</span></div><div \nclass=\"sidebar-dialog__header__actions\"><md-button data-cy=\"close-button\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"fc-input\"><input data-cy=\"reason-input\" type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" ng-disabled=\"false\" id=\"reason\" name=\"reason\" \nng-model=\"vm.absence.reason\" ng-maxlength=\"50\" \nng-class=\"{\n              invalid: absenceForm.reason.$touched && absenceForm.reason.$invalid\n            }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'ABSENCES.MODEL.REASON\' | translate)}}</label><fc-error \nng-show=\"absenceForm.reason.$touched\" input-errors=\"absenceForm.reason.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'ABSENCES.MODEL.ERRORS.REASON_REQUIRED\'\n                },\n                {\n                  name: \'maxlength\',\n                  translate: \'ABSENCES.MODEL.ERRORS.REASON_MAX\',\n                  translateValues: { expectedLength: 50, receivedLength: absenceForm.reason.$viewValue.length }\n                },\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div class=\"mt-30\"><div layout-xs=\"column\" layout=\"flex\" \nclass=\"mt-0 products-services-input-container\"><div flex=\"60\"><fc-select data-cy=\"employee-select\" \nlabel=\"{{(\'ABSENCES.MODEL.EMPLOYEE\' | translate)}}\" options=\"vm.employees\" is-required=\"true\" input-name=\"employeeId\" \ninput-control=\"absenceForm.employeeId\" ng-model=\"vm.absence.employee.id\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'ABSENCES.MODEL.ERRORS.EMPLOYEE_REQUIRED\'\n                  }\n                ]\">\n</fc-select></div><div style=\"width: 20%\" class=\"fc-datepicker\"><label class=\"fc-datepicker__label\">\n{{ \'ABSENCES.MODEL.FROM\' | translate }}</label><div data-cy=\"from-date-picker\" class=\"date-container\"><md-datepicker \nclass=\"p-0\" flex required name=\"from\" ng-model=\"vm.absence.from\" ng-change=\"vm.dateAbsenceValidation()\" \nmd-hide-icons=\"calendar\" md-placeholder=\"{{ \'ABSENCES.MODEL.FROM\' | translate }}\"></md-datepicker></div><fc-error \nng-show=\"absenceForm.from.$touched\" input-errors=\"absenceForm.from.$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'ABSENCES.MODEL.ERRORS.DATE_REQUIRED\',\n                    translateValues: { fieldName: (\'VEHICLES_USAGE.MODEL.PICK_UP_DATE\' | translate) }\n                  },\n                  {\n                    name: \'invalid\',\n                    translate: \'ABSENCES.MODEL.ERRORS.DATE_VALID\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div style=\"width: 20%\" class=\"fc-datepicker\"><label \nclass=\"fc-datepicker__label\">{{ \'ABSENCES.MODEL.TO\' | translate }}</label><div data-cy=\"to-date-picker\" \nclass=\"date-container\"><md-datepicker class=\"p-0\" flex required name=\"to\" ng-model=\"vm.absence.to\" \nng-change=\"vm.dateAbsenceValidation()\" md-hide-icons=\"calendar\" md-placeholder=\"{{ \'ABSENCES.MODEL.TO\' | translate }}\">\n</md-datepicker></div><fc-error ng-show=\"absenceForm.to.$touched\" input-errors=\"absenceForm.to.$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'ABSENCES.MODEL.ERRORS.DATE_REQUIRED\',\n                    translateValues: { fieldName: (\'VEHICLES_USAGE.MODEL.PICK_UP_DATE\' | translate) }\n                  },\n                  {\n                    name: \'invalid\',\n                    translate: \'ABSENCES.MODEL.ERRORS.DATE_VALID\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button data-cy=\"save-button\" \ntype=\"submit\" ng-if=\"!vm.newAbsence\" ng-click=\"vm.saveAbsence()\" class=\"fc-button fc-button--actions\" \nng-disabled=\"absenceForm.$invalid || absenceForm.$pristine\" aria-label=\"Save\" translate=\"ABSENCES.DIALOG.SAVE\" \ntranslate-attr-aria-label=\"ABSENCES.DIALOG.SAVE\">SAVE</md-button><md-button data-cy=\"create-button\" type=\"submit\" \nng-if=\"vm.newAbsence\" ng-click=\"vm.saveAbsence()\" class=\"fc-button fc-button--actions\" \nng-disabled=\"absenceForm.$invalid || absenceForm.$pristine\" aria-label=\"Add Absence\" \ntranslate=\"ABSENCES.DIALOG.CREATE\" translate-attr-aria-label=\"ABSENCES.DIALOG.CREATE\">ADD ABSENCE</md-button></div><div\n layout=\"row\"><md-button data-cy=\"delete-button\" ng-if=\"vm.absence.id\" class=\"md-icon-button\" \nng-click=\"vm.deleteAbsence($event)\" aria-label=\"Delete\" translate translate-attr-aria-label=\"ABSENCES.DIALOG.DELETE\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"ABSENCES.DIALOG.DELETE\">\nDelete</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/auth/confirm-email/confirm-email.html","<div class=\"redirect-screen\"><div class=\"redirect-screen__content\"><img class=\"redirect-screen__content__logo\" \nsrc=\"assets/images/logos/field_logo_azul.png\" alt=\"Field Control\"><h1 class=\"redirect-screen__content__title\" \ntranslate=\"CONFIRM_EMAIL.TITLE\">Confirm your email!</h1><p class=\"redirect-screen__content__description\" \nng-if=\"!vm.emailSent\" translate=\"CONFIRM_EMAIL.DESCRIPTION.PART_1\" translate-values=\"{ email: vm.user.email }\">\nYou need to confirm email to continue, click on the button below to send a email to {{ vm.user.email }}</p><p \nclass=\"redirect-screen__content__description\" ng-if=\"vm.emailSent\" translate=\"CONFIRM_EMAIL.DESCRIPTION.PART_2\">\nEmail sent successfully! Continue the process in there</p><md-button class=\"md-raised md-accent\" ng-if=\"!vm.emailSent\" \nng-disabled=\"vm.loading\" ng-click=\"vm.sendConfirmationEmail()\" translate=\"CONFIRM_EMAIL.SEND_BUTTON\">Send email\n</md-button></div></div>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div class=\"authentication\" layout=\"row\" layout-align=\"start\"><div class=\"authentication-intro\" flex hide show-gt-sm>\n<div class=\"darkned\"><div class=\"logo\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"61\" \nviewBox=\"0 0 120 61\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path \nd=\"M35.115 39.56V12.402h6.609V39.56h-6.61zm39.596-12h-22.15c.386 2.08 1.4 3.726 3.038 4.942 1.64 1.216 3.675 1.824 6.107 1.824 3.101 0 5.657-1.021 7.665-3.067l3.543 4.071c-1.27 1.516-2.874 2.661-4.81 3.436-1.94.776-4.125 1.164-6.557 1.164-3.101 0-5.833-.616-8.195-1.85-2.36-1.234-4.185-2.951-5.47-5.154-1.288-2.204-1.93-4.697-1.93-7.481 0-2.75.624-5.226 1.876-7.428a13.313 13.313 0 0 1 5.208-5.155c2.22-1.233 4.723-1.85 7.507-1.85 2.748 0 5.207.607 7.375 1.825 2.168 1.214 3.858 2.925 5.074 5.126 1.216 2.204 1.824 4.751 1.824 7.64 0 .46-.034 1.11-.105 1.956zm-19.535-9.385c-1.462 1.251-2.352 2.918-2.669 4.996h16.019c-.283-2.044-1.147-3.7-2.59-4.969-1.446-1.27-3.244-1.903-5.393-1.903-2.115 0-3.904.626-5.367 1.876zm23.87 21.384V.333h6.609v39.226h-6.61zm30.186-6.37c1.27-.722 2.273-1.751 3.013-3.091.74-1.34 1.11-2.89 1.11-4.653 0-1.762-.37-3.312-1.11-4.652-.74-1.34-1.744-2.37-3.013-3.094-1.27-.721-2.696-1.082-4.283-1.082-1.585 0-3.013.36-4.281 1.082-1.27.724-2.274 1.755-3.015 3.094-.74 1.34-1.11 2.89-1.11 4.652s.37 3.313 1.11 4.653c.741 1.34 1.745 2.37 3.015 3.092 1.268.723 2.696 1.083 4.281 1.083 1.587 0 3.013-.36 4.283-1.083zM119.858.334v39.226h-6.345v-3.646a10.207 10.207 0 0 1-4.044 3.013c-1.604.67-3.375 1.005-5.313 1.005-2.714 0-5.154-.6-7.322-1.798s-3.868-2.9-5.1-5.102c-1.236-2.202-1.852-4.732-1.852-7.586 0-2.855.616-5.374 1.851-7.56 1.233-2.184 2.933-3.876 5.101-5.075 2.168-1.199 4.608-1.797 7.322-1.797 1.868 0 3.577.317 5.13.952a10.29 10.29 0 0 1 3.963 2.854V.333h6.61zM0 23.251v-6.61h23.141v6.61H0zm0-16.27V.334h29.692V6.98H0zm0 32.578v-6.608h13.1v6.608H0zM35.144 6.98h6.55V.335h-6.55zM2.454 60.164a4.619 4.619 0 0 1-1.802-1.73C.217 57.7 0 56.87 0 55.948c0-.923.22-1.754.658-2.488a4.66 4.66 0 0 1 1.81-1.728c.766-.418 1.625-.626 2.574-.626.772 0 1.475.135 2.112.404a4.296 4.296 0 0 1 1.614 1.17l-1.13 1.062c-.68-.734-1.518-1.104-2.514-1.104-.646 0-1.224.143-1.735.426a3.05 3.05 0 0 0-1.197 1.176c-.287.502-.43 1.07-.43 1.708 0 .636.143 1.205.43 1.706.288.503.685.895 1.197 1.178.51.282 1.09.422 1.735.422.996 0 1.833-.37 2.514-1.116l1.13 1.076c-.439.512-.98.902-1.62 1.171a5.42 5.42 0 0 1-2.119.404c-.95 0-1.808-.21-2.575-.625zm22.464-1.332a3.071 3.071 0 0 0 1.184-1.184c.287-.507.43-1.072.43-1.7 0-.628-.143-1.196-.43-1.702a3.059 3.059 0 0 0-1.184-1.182 3.392 3.392 0 0 0-1.695-.426c-.626 0-1.192.143-1.694.426a3.055 3.055 0 0 0-1.183 1.182 3.389 3.389 0 0 0-.43 1.702c0 .628.143 1.193.43 1.7.287.506.681.901 1.183 1.184a3.397 3.397 0 0 0 1.694.422 3.39 3.39 0 0 0 1.695-.422zm-4.29 1.332a4.643 4.643 0 0 1-1.815-1.736c-.439-.739-.659-1.567-.659-2.48 0-.916.22-1.743.659-2.482a4.63 4.63 0 0 1 1.816-1.734c.77-.418 1.636-.626 2.594-.626.96 0 1.826.208 2.596.626.771.416 1.376.993 1.816 1.728.439.734.659 1.565.659 2.488 0 .922-.22 1.752-.659 2.486a4.655 4.655 0 0 1-1.816 1.73c-.77.417-1.636.625-2.596.625-.958 0-1.824-.208-2.594-.625zm26.465-8.923v9.414h-1.439l-5.19-6.376v6.376h-1.735v-9.414h1.439l5.19 6.373v-6.373h1.735zm13.018 1.479h-3.12V51.24h7.988v1.479h-3.12v7.934H60.11V52.72zm20.292.484c-.395-.323-.973-.484-1.735-.484h-2.044v3.752h2.044c.762 0 1.34-.164 1.735-.49.395-.329.592-.793.592-1.393s-.197-1.062-.592-1.385zm.632 7.45l-1.923-2.757a3.942 3.942 0 0 1-.364.014h-2.124v2.744h-1.748V51.24h3.872c.816 0 1.527.135 2.132.404.606.27 1.07.655 1.392 1.156.323.503.484 1.099.484 1.79 0 .707-.173 1.317-.518 1.827-.344.512-.84.894-1.486 1.144l2.166 3.094h-1.883zm18.342-1.822a3.08 3.08 0 0 0 1.184-1.184c.287-.507.43-1.072.43-1.7 0-.628-.143-1.196-.43-1.702a3.068 3.068 0 0 0-1.184-1.182 3.392 3.392 0 0 0-1.695-.426c-.626 0-1.192.143-1.694.426a3.055 3.055 0 0 0-1.183 1.182 3.389 3.389 0 0 0-.43 1.702c0 .628.143 1.193.43 1.7.287.506.681.901 1.183 1.184a3.397 3.397 0 0 0 1.694.422 3.39 3.39 0 0 0 1.695-.422zm-4.29 1.332a4.634 4.634 0 0 1-1.815-1.736c-.44-.739-.66-1.567-.66-2.48 0-.916.22-1.743.66-2.482a4.621 4.621 0 0 1 1.816-1.734c.77-.418 1.636-.626 2.594-.626.96 0 1.826.208 2.596.626.77.416 1.376.993 1.816 1.728.439.734.659 1.565.659 2.488 0 .922-.22 1.752-.659 2.486a4.655 4.655 0 0 1-1.816 1.73c-.77.417-1.636.625-2.596.625-.958 0-1.824-.208-2.594-.625zm18.101-8.923h1.748v7.933h4.921v1.481h-6.669v-9.414z\"/>\n</g></svg></div></div></div><div class=\"authentication-form-wrapper flex-scrollable\"><div \nclass=\"authentication-form-wrapper-form\"><div class=\"logo\" hide-gt-sm><div><svg xmlns=\"http://www.w3.org/2000/svg\" \nwidth=\"120\" height=\"61\" viewBox=\"0 0 120 61\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#0054FF\" \nd=\"M35.115 39.56V12.402h6.609V39.56h-6.61zm39.596-12h-22.15c.386 2.08 1.4 3.726 3.038 4.942 1.64 1.216 3.675 1.824 6.107 1.824 3.101 0 5.657-1.021 7.665-3.067l3.543 4.071c-1.27 1.516-2.874 2.661-4.81 3.436-1.94.776-4.125 1.164-6.557 1.164-3.101 0-5.833-.616-8.195-1.85-2.36-1.234-4.185-2.951-5.47-5.154-1.288-2.204-1.93-4.697-1.93-7.481 0-2.75.624-5.226 1.876-7.428a13.313 13.313 0 0 1 5.208-5.155c2.22-1.233 4.723-1.85 7.507-1.85 2.748 0 5.207.607 7.375 1.825 2.168 1.214 3.858 2.925 5.074 5.126 1.216 2.204 1.824 4.751 1.824 7.64 0 .46-.034 1.11-.105 1.956zm-19.535-9.385c-1.462 1.251-2.352 2.918-2.669 4.996h16.019c-.283-2.044-1.147-3.7-2.59-4.969-1.446-1.27-3.244-1.903-5.393-1.903-2.115 0-3.904.626-5.367 1.876zm23.87 21.384V.333h6.609v39.226h-6.61zm30.186-6.37c1.27-.722 2.273-1.751 3.013-3.091.74-1.34 1.11-2.89 1.11-4.653 0-1.762-.37-3.312-1.11-4.652-.74-1.34-1.744-2.37-3.013-3.094-1.27-.721-2.696-1.082-4.283-1.082-1.585 0-3.013.36-4.281 1.082-1.27.724-2.274 1.755-3.015 3.094-.74 1.34-1.11 2.89-1.11 4.652s.37 3.313 1.11 4.653c.741 1.34 1.745 2.37 3.015 3.092 1.268.723 2.696 1.083 4.281 1.083 1.587 0 3.013-.36 4.283-1.083zM119.858.334v39.226h-6.345v-3.646a10.207 10.207 0 0 1-4.044 3.013c-1.604.67-3.375 1.005-5.313 1.005-2.714 0-5.154-.6-7.322-1.798s-3.868-2.9-5.1-5.102c-1.236-2.202-1.852-4.732-1.852-7.586 0-2.855.616-5.374 1.851-7.56 1.233-2.184 2.933-3.876 5.101-5.075 2.168-1.199 4.608-1.797 7.322-1.797 1.868 0 3.577.317 5.13.952a10.29 10.29 0 0 1 3.963 2.854V.333h6.61z\"/>\n<path fill=\"#05F\" d=\"M0 23.251v-6.61h23.141v6.61H0zm0-16.27V.334h29.692V6.98H0zm0 32.578v-6.608h13.1v6.608H0z\"/><path \nfill=\"#9E9E9E\" \nd=\"M35.144 6.98h6.55V.335h-6.55zM2.454 60.164a4.619 4.619 0 0 1-1.802-1.73C.217 57.7 0 56.87 0 55.948c0-.923.22-1.754.658-2.488a4.66 4.66 0 0 1 1.81-1.728c.766-.418 1.625-.626 2.574-.626.772 0 1.475.135 2.112.404a4.296 4.296 0 0 1 1.614 1.17l-1.13 1.062c-.68-.734-1.518-1.104-2.514-1.104-.646 0-1.224.143-1.735.426a3.05 3.05 0 0 0-1.197 1.176c-.287.502-.43 1.07-.43 1.708 0 .636.143 1.205.43 1.706.288.503.685.895 1.197 1.178.51.282 1.09.422 1.735.422.996 0 1.833-.37 2.514-1.116l1.13 1.076c-.439.512-.98.902-1.62 1.171a5.42 5.42 0 0 1-2.119.404c-.95 0-1.808-.21-2.575-.625zm22.464-1.332a3.071 3.071 0 0 0 1.184-1.184c.287-.507.43-1.072.43-1.7 0-.628-.143-1.196-.43-1.702a3.059 3.059 0 0 0-1.184-1.182 3.392 3.392 0 0 0-1.695-.426c-.626 0-1.192.143-1.694.426a3.055 3.055 0 0 0-1.183 1.182 3.389 3.389 0 0 0-.43 1.702c0 .628.143 1.193.43 1.7.287.506.681.901 1.183 1.184a3.397 3.397 0 0 0 1.694.422 3.39 3.39 0 0 0 1.695-.422zm-4.29 1.332a4.643 4.643 0 0 1-1.815-1.736c-.439-.739-.659-1.567-.659-2.48 0-.916.22-1.743.659-2.482a4.63 4.63 0 0 1 1.816-1.734c.77-.418 1.636-.626 2.594-.626.96 0 1.826.208 2.596.626.771.416 1.376.993 1.816 1.728.439.734.659 1.565.659 2.488 0 .922-.22 1.752-.659 2.486a4.655 4.655 0 0 1-1.816 1.73c-.77.417-1.636.625-2.596.625-.958 0-1.824-.208-2.594-.625zm26.465-8.923v9.414h-1.439l-5.19-6.376v6.376h-1.735v-9.414h1.439l5.19 6.373v-6.373h1.735zm13.018 1.479h-3.12V51.24h7.988v1.479h-3.12v7.934H60.11V52.72zm20.292.484c-.395-.323-.973-.484-1.735-.484h-2.044v3.752h2.044c.762 0 1.34-.164 1.735-.49.395-.329.592-.793.592-1.393s-.197-1.062-.592-1.385zm.632 7.45l-1.923-2.757a3.942 3.942 0 0 1-.364.014h-2.124v2.744h-1.748V51.24h3.872c.816 0 1.527.135 2.132.404.606.27 1.07.655 1.392 1.156.323.503.484 1.099.484 1.79 0 .707-.173 1.317-.518 1.827-.344.512-.84.894-1.486 1.144l2.166 3.094h-1.883zm18.342-1.822a3.08 3.08 0 0 0 1.184-1.184c.287-.507.43-1.072.43-1.7 0-.628-.143-1.196-.43-1.702a3.068 3.068 0 0 0-1.184-1.182 3.392 3.392 0 0 0-1.695-.426c-.626 0-1.192.143-1.694.426a3.055 3.055 0 0 0-1.183 1.182 3.389 3.389 0 0 0-.43 1.702c0 .628.143 1.193.43 1.7.287.506.681.901 1.183 1.184a3.397 3.397 0 0 0 1.694.422 3.39 3.39 0 0 0 1.695-.422zm-4.29 1.332a4.634 4.634 0 0 1-1.815-1.736c-.44-.739-.66-1.567-.66-2.48 0-.916.22-1.743.66-2.482a4.621 4.621 0 0 1 1.816-1.734c.77-.418 1.636-.626 2.594-.626.96 0 1.826.208 2.596.626.77.416 1.376.993 1.816 1.728.439.734.659 1.565.659 2.488 0 .922-.22 1.752-.659 2.486a4.655 4.655 0 0 1-1.816 1.73c-.77.417-1.636.625-2.596.625-.958 0-1.824-.208-2.594-.625zm18.101-8.923h1.748v7.933h4.921v1.481h-6.669v-9.414z\"/>\n</g></svg></div></div><form name=\"forgotPasswordForm\" novalidate ng-if=\"vm.form.sent === false\"><span class=\"title\" \ntranslate=\"FORGOT_PASSWORD.TITLE\">Recover your password</span><br><br><span class=\"description\" \ntranslate=\"FORGOT_PASSWORD.DESCRIPTION\">\nTo recover your password, please enter the registered email to receive the password change link.</span>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Write your email address here\" translate translate-attr-placeholder=\"FORGOT_PASSWORD.EMAIL_ADDRESS\" \nemail-validation required><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"FORGOT_PASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"FORGOT_PASSWORD.ERRORS.EMAIL_MUST_VALID\">Must be a valid email address</span>\n</div></div></md-input-container><md-button type=\"button\" class=\"md-raised md-accent submit-button submit-login\" \naria-label=\"RESET MY PASSWORD\" ng-click=\"vm.submit();\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine || $root.loadingProgress\" \ntranslate=\"FORGOT_PASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOT_PASSWORD.SEND_RESET_LINK\">Send reset link\n</md-button></form><div class=\"subtitle-info\" ng-if=\"vm.form.sent === true\"><span \ntranslate=\"FORGOT_PASSWORD.EMAIL_SENT\">\nReady! Within minutes you will receive an email with instructions for resetting your password.</span></div><div \nclass=\"separator\" ng-if=\"vm.form.sent !== true\"><span class=\"text text-uppercase\" translate=\"FORGOT_PASSWORD.OR\">Or\n</span></div><div class=\"login\" layout=\"row\" layout-align=\"center center\" ng-class=\"{\'mt-15\': vm.form.sent}\"><a \nclass=\"link\" ui-sref=\"app.auth-login\" translate=\"FORGOT_PASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/auth/reset-password/reset-password.html","<div class=\"authentication\" layout=\"row\" layout-align=\"start\"><div class=\"authentication-intro\" flex hide show-gt-sm>\n<div class=\"darkned\"><div class=\"logo\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"61\" \nviewBox=\"0 0 120 61\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path \nd=\"M35.115 39.56V12.402h6.609V39.56h-6.61zm39.596-12h-22.15c.386 2.08 1.4 3.726 3.038 4.942 1.64 1.216 3.675 1.824 6.107 1.824 3.101 0 5.657-1.021 7.665-3.067l3.543 4.071c-1.27 1.516-2.874 2.661-4.81 3.436-1.94.776-4.125 1.164-6.557 1.164-3.101 0-5.833-.616-8.195-1.85-2.36-1.234-4.185-2.951-5.47-5.154-1.288-2.204-1.93-4.697-1.93-7.481 0-2.75.624-5.226 1.876-7.428a13.313 13.313 0 0 1 5.208-5.155c2.22-1.233 4.723-1.85 7.507-1.85 2.748 0 5.207.607 7.375 1.825 2.168 1.214 3.858 2.925 5.074 5.126 1.216 2.204 1.824 4.751 1.824 7.64 0 .46-.034 1.11-.105 1.956zm-19.535-9.385c-1.462 1.251-2.352 2.918-2.669 4.996h16.019c-.283-2.044-1.147-3.7-2.59-4.969-1.446-1.27-3.244-1.903-5.393-1.903-2.115 0-3.904.626-5.367 1.876zm23.87 21.384V.333h6.609v39.226h-6.61zm30.186-6.37c1.27-.722 2.273-1.751 3.013-3.091.74-1.34 1.11-2.89 1.11-4.653 0-1.762-.37-3.312-1.11-4.652-.74-1.34-1.744-2.37-3.013-3.094-1.27-.721-2.696-1.082-4.283-1.082-1.585 0-3.013.36-4.281 1.082-1.27.724-2.274 1.755-3.015 3.094-.74 1.34-1.11 2.89-1.11 4.652s.37 3.313 1.11 4.653c.741 1.34 1.745 2.37 3.015 3.092 1.268.723 2.696 1.083 4.281 1.083 1.587 0 3.013-.36 4.283-1.083zM119.858.334v39.226h-6.345v-3.646a10.207 10.207 0 0 1-4.044 3.013c-1.604.67-3.375 1.005-5.313 1.005-2.714 0-5.154-.6-7.322-1.798s-3.868-2.9-5.1-5.102c-1.236-2.202-1.852-4.732-1.852-7.586 0-2.855.616-5.374 1.851-7.56 1.233-2.184 2.933-3.876 5.101-5.075 2.168-1.199 4.608-1.797 7.322-1.797 1.868 0 3.577.317 5.13.952a10.29 10.29 0 0 1 3.963 2.854V.333h6.61zM0 23.251v-6.61h23.141v6.61H0zm0-16.27V.334h29.692V6.98H0zm0 32.578v-6.608h13.1v6.608H0zM35.144 6.98h6.55V.335h-6.55zM2.454 60.164a4.619 4.619 0 0 1-1.802-1.73C.217 57.7 0 56.87 0 55.948c0-.923.22-1.754.658-2.488a4.66 4.66 0 0 1 1.81-1.728c.766-.418 1.625-.626 2.574-.626.772 0 1.475.135 2.112.404a4.296 4.296 0 0 1 1.614 1.17l-1.13 1.062c-.68-.734-1.518-1.104-2.514-1.104-.646 0-1.224.143-1.735.426a3.05 3.05 0 0 0-1.197 1.176c-.287.502-.43 1.07-.43 1.708 0 .636.143 1.205.43 1.706.288.503.685.895 1.197 1.178.51.282 1.09.422 1.735.422.996 0 1.833-.37 2.514-1.116l1.13 1.076c-.439.512-.98.902-1.62 1.171a5.42 5.42 0 0 1-2.119.404c-.95 0-1.808-.21-2.575-.625zm22.464-1.332a3.071 3.071 0 0 0 1.184-1.184c.287-.507.43-1.072.43-1.7 0-.628-.143-1.196-.43-1.702a3.059 3.059 0 0 0-1.184-1.182 3.392 3.392 0 0 0-1.695-.426c-.626 0-1.192.143-1.694.426a3.055 3.055 0 0 0-1.183 1.182 3.389 3.389 0 0 0-.43 1.702c0 .628.143 1.193.43 1.7.287.506.681.901 1.183 1.184a3.397 3.397 0 0 0 1.694.422 3.39 3.39 0 0 0 1.695-.422zm-4.29 1.332a4.643 4.643 0 0 1-1.815-1.736c-.439-.739-.659-1.567-.659-2.48 0-.916.22-1.743.659-2.482a4.63 4.63 0 0 1 1.816-1.734c.77-.418 1.636-.626 2.594-.626.96 0 1.826.208 2.596.626.771.416 1.376.993 1.816 1.728.439.734.659 1.565.659 2.488 0 .922-.22 1.752-.659 2.486a4.655 4.655 0 0 1-1.816 1.73c-.77.417-1.636.625-2.596.625-.958 0-1.824-.208-2.594-.625zm26.465-8.923v9.414h-1.439l-5.19-6.376v6.376h-1.735v-9.414h1.439l5.19 6.373v-6.373h1.735zm13.018 1.479h-3.12V51.24h7.988v1.479h-3.12v7.934H60.11V52.72zm20.292.484c-.395-.323-.973-.484-1.735-.484h-2.044v3.752h2.044c.762 0 1.34-.164 1.735-.49.395-.329.592-.793.592-1.393s-.197-1.062-.592-1.385zm.632 7.45l-1.923-2.757a3.942 3.942 0 0 1-.364.014h-2.124v2.744h-1.748V51.24h3.872c.816 0 1.527.135 2.132.404.606.27 1.07.655 1.392 1.156.323.503.484 1.099.484 1.79 0 .707-.173 1.317-.518 1.827-.344.512-.84.894-1.486 1.144l2.166 3.094h-1.883zm18.342-1.822a3.08 3.08 0 0 0 1.184-1.184c.287-.507.43-1.072.43-1.7 0-.628-.143-1.196-.43-1.702a3.068 3.068 0 0 0-1.184-1.182 3.392 3.392 0 0 0-1.695-.426c-.626 0-1.192.143-1.694.426a3.055 3.055 0 0 0-1.183 1.182 3.389 3.389 0 0 0-.43 1.702c0 .628.143 1.193.43 1.7.287.506.681.901 1.183 1.184a3.397 3.397 0 0 0 1.694.422 3.39 3.39 0 0 0 1.695-.422zm-4.29 1.332a4.634 4.634 0 0 1-1.815-1.736c-.44-.739-.66-1.567-.66-2.48 0-.916.22-1.743.66-2.482a4.621 4.621 0 0 1 1.816-1.734c.77-.418 1.636-.626 2.594-.626.96 0 1.826.208 2.596.626.77.416 1.376.993 1.816 1.728.439.734.659 1.565.659 2.488 0 .922-.22 1.752-.659 2.486a4.655 4.655 0 0 1-1.816 1.73c-.77.417-1.636.625-2.596.625-.958 0-1.824-.208-2.594-.625zm18.101-8.923h1.748v7.933h4.921v1.481h-6.669v-9.414z\"/>\n</g></svg></div></div></div><div class=\"authentication-form-wrapper flex-scrollable\"><div \nclass=\"authentication-form-wrapper-form\"><div class=\"logo\" hide-gt-sm><div><svg xmlns=\"http://www.w3.org/2000/svg\" \nwidth=\"120\" height=\"61\" viewBox=\"0 0 120 61\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#0054FF\" \nd=\"M35.115 39.56V12.402h6.609V39.56h-6.61zm39.596-12h-22.15c.386 2.08 1.4 3.726 3.038 4.942 1.64 1.216 3.675 1.824 6.107 1.824 3.101 0 5.657-1.021 7.665-3.067l3.543 4.071c-1.27 1.516-2.874 2.661-4.81 3.436-1.94.776-4.125 1.164-6.557 1.164-3.101 0-5.833-.616-8.195-1.85-2.36-1.234-4.185-2.951-5.47-5.154-1.288-2.204-1.93-4.697-1.93-7.481 0-2.75.624-5.226 1.876-7.428a13.313 13.313 0 0 1 5.208-5.155c2.22-1.233 4.723-1.85 7.507-1.85 2.748 0 5.207.607 7.375 1.825 2.168 1.214 3.858 2.925 5.074 5.126 1.216 2.204 1.824 4.751 1.824 7.64 0 .46-.034 1.11-.105 1.956zm-19.535-9.385c-1.462 1.251-2.352 2.918-2.669 4.996h16.019c-.283-2.044-1.147-3.7-2.59-4.969-1.446-1.27-3.244-1.903-5.393-1.903-2.115 0-3.904.626-5.367 1.876zm23.87 21.384V.333h6.609v39.226h-6.61zm30.186-6.37c1.27-.722 2.273-1.751 3.013-3.091.74-1.34 1.11-2.89 1.11-4.653 0-1.762-.37-3.312-1.11-4.652-.74-1.34-1.744-2.37-3.013-3.094-1.27-.721-2.696-1.082-4.283-1.082-1.585 0-3.013.36-4.281 1.082-1.27.724-2.274 1.755-3.015 3.094-.74 1.34-1.11 2.89-1.11 4.652s.37 3.313 1.11 4.653c.741 1.34 1.745 2.37 3.015 3.092 1.268.723 2.696 1.083 4.281 1.083 1.587 0 3.013-.36 4.283-1.083zM119.858.334v39.226h-6.345v-3.646a10.207 10.207 0 0 1-4.044 3.013c-1.604.67-3.375 1.005-5.313 1.005-2.714 0-5.154-.6-7.322-1.798s-3.868-2.9-5.1-5.102c-1.236-2.202-1.852-4.732-1.852-7.586 0-2.855.616-5.374 1.851-7.56 1.233-2.184 2.933-3.876 5.101-5.075 2.168-1.199 4.608-1.797 7.322-1.797 1.868 0 3.577.317 5.13.952a10.29 10.29 0 0 1 3.963 2.854V.333h6.61z\"/>\n<path fill=\"#05F\" d=\"M0 23.251v-6.61h23.141v6.61H0zm0-16.27V.334h29.692V6.98H0zm0 32.578v-6.608h13.1v6.608H0z\"/><path \nfill=\"#9E9E9E\" \nd=\"M35.144 6.98h6.55V.335h-6.55zM2.454 60.164a4.619 4.619 0 0 1-1.802-1.73C.217 57.7 0 56.87 0 55.948c0-.923.22-1.754.658-2.488a4.66 4.66 0 0 1 1.81-1.728c.766-.418 1.625-.626 2.574-.626.772 0 1.475.135 2.112.404a4.296 4.296 0 0 1 1.614 1.17l-1.13 1.062c-.68-.734-1.518-1.104-2.514-1.104-.646 0-1.224.143-1.735.426a3.05 3.05 0 0 0-1.197 1.176c-.287.502-.43 1.07-.43 1.708 0 .636.143 1.205.43 1.706.288.503.685.895 1.197 1.178.51.282 1.09.422 1.735.422.996 0 1.833-.37 2.514-1.116l1.13 1.076c-.439.512-.98.902-1.62 1.171a5.42 5.42 0 0 1-2.119.404c-.95 0-1.808-.21-2.575-.625zm22.464-1.332a3.071 3.071 0 0 0 1.184-1.184c.287-.507.43-1.072.43-1.7 0-.628-.143-1.196-.43-1.702a3.059 3.059 0 0 0-1.184-1.182 3.392 3.392 0 0 0-1.695-.426c-.626 0-1.192.143-1.694.426a3.055 3.055 0 0 0-1.183 1.182 3.389 3.389 0 0 0-.43 1.702c0 .628.143 1.193.43 1.7.287.506.681.901 1.183 1.184a3.397 3.397 0 0 0 1.694.422 3.39 3.39 0 0 0 1.695-.422zm-4.29 1.332a4.643 4.643 0 0 1-1.815-1.736c-.439-.739-.659-1.567-.659-2.48 0-.916.22-1.743.659-2.482a4.63 4.63 0 0 1 1.816-1.734c.77-.418 1.636-.626 2.594-.626.96 0 1.826.208 2.596.626.771.416 1.376.993 1.816 1.728.439.734.659 1.565.659 2.488 0 .922-.22 1.752-.659 2.486a4.655 4.655 0 0 1-1.816 1.73c-.77.417-1.636.625-2.596.625-.958 0-1.824-.208-2.594-.625zm26.465-8.923v9.414h-1.439l-5.19-6.376v6.376h-1.735v-9.414h1.439l5.19 6.373v-6.373h1.735zm13.018 1.479h-3.12V51.24h7.988v1.479h-3.12v7.934H60.11V52.72zm20.292.484c-.395-.323-.973-.484-1.735-.484h-2.044v3.752h2.044c.762 0 1.34-.164 1.735-.49.395-.329.592-.793.592-1.393s-.197-1.062-.592-1.385zm.632 7.45l-1.923-2.757a3.942 3.942 0 0 1-.364.014h-2.124v2.744h-1.748V51.24h3.872c.816 0 1.527.135 2.132.404.606.27 1.07.655 1.392 1.156.323.503.484 1.099.484 1.79 0 .707-.173 1.317-.518 1.827-.344.512-.84.894-1.486 1.144l2.166 3.094h-1.883zm18.342-1.822a3.08 3.08 0 0 0 1.184-1.184c.287-.507.43-1.072.43-1.7 0-.628-.143-1.196-.43-1.702a3.068 3.068 0 0 0-1.184-1.182 3.392 3.392 0 0 0-1.695-.426c-.626 0-1.192.143-1.694.426a3.055 3.055 0 0 0-1.183 1.182 3.389 3.389 0 0 0-.43 1.702c0 .628.143 1.193.43 1.7.287.506.681.901 1.183 1.184a3.397 3.397 0 0 0 1.694.422 3.39 3.39 0 0 0 1.695-.422zm-4.29 1.332a4.634 4.634 0 0 1-1.815-1.736c-.44-.739-.66-1.567-.66-2.48 0-.916.22-1.743.66-2.482a4.621 4.621 0 0 1 1.816-1.734c.77-.418 1.636-.626 2.594-.626.96 0 1.826.208 2.596.626.77.416 1.376.993 1.816 1.728.439.734.659 1.565.659 2.488 0 .922-.22 1.752-.659 2.486a4.655 4.655 0 0 1-1.816 1.73c-.77.417-1.636.625-2.596.625-.958 0-1.824-.208-2.594-.625zm18.101-8.923h1.748v7.933h4.921v1.481h-6.669v-9.414z\"/>\n</g></svg></div></div><form name=\"resetPasswordForm\" novalidate ng-if=\"vm.form.sent === false\"><span class=\"title\" \ntranslate=\"RESET_PASSWORD.TITLE\">Reset your password</span><br><br><span class=\"description\" \ntranslate=\"RESET_PASSWORD.DESCRIPTION\">\nEnter your new password next to it, it must be at least 8 characters long and must include letters, numbers and symbols.\n</span><md-input-container class=\"md-block new-password-fields\" md-no-float><input id=\"password\" type=\"text\" \nname=\"password\" autocomplete=\"off\" ng-model=\"vm.form.password\" placeholder=\"New password\" ok-password translate \nclass=\"newpassword\" translate-attr-placeholder=\"RESET_PASSWORD.NEW_PASSWORD\" required><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleNewPassword()\"><md-icon \nmd-font-icon=\"{{ vm.showNewPassword ? \'icon-eye\' : \'icon-eye-off\' }}\"></md-icon></md-button><div \nng-messages=\"resetPasswordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESET_PASSWORD.ERRORS.NEW_PASSWORD_REQUIRED\">New Password field is required</span></div></div><div \nclass=\"hint\"><span translate=\"RESET_PASSWORD.PASSWORD_EXAMPLE\">\nYou need to use a strong enough password. The password must contain at least 8 characters and include letters, numbers and symbols. For example: \n</span><b>{{vm.samplePassword}}</b></div><div class=\"strength-meter\"><div class=\"strength-meter-fill\" \ndata-strength=\"{{passwordStrength}}\"></div></div></md-input-container><md-button type=\"button\" ng-click=\"vm.submit();\" \nclass=\"md-raised md-accent submit-button submit-login\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine || $root.loadingProgress\" \ntranslate=\"RESET_PASSWORD.SUBMIT_LABEL\" translate-attr-aria-label=\"RESET_PASSWORD.SUBMIT_LABEL\">Reset password\n</md-button></form><div class=\"subtitle-info\" ng-if=\"vm.form.sent === true && vm.form.error === false\"><span \ntranslate=\"RESET_PASSWORD.SUCCESSFULLY_RESETED\">\nReady! Your password has been changed successfully. In a moment you will be redirected to login.</span></div><div \nclass=\"subtitle-info red-text\" ng-if=\"vm.form.sent === true && vm.form.error === true\">{{vm.errorMessage}}</div><div \nclass=\"separator\" ng-if=\"vm.form.sent !== true && vm.form.error === false\"><span class=\"text text-uppercase\" \ntranslate=\"RESET_PASSWORD.OR\">Or</span></div><div class=\"login\" layout=\"row\" layout-align=\"center center\" \nng-class=\"{\'mt-15\': vm.form.sent}\"><a class=\"link\" ui-sref=\"app.auth-login\" translate=\"RESET_PASSWORD.GO_BACK\">\nGo back to login</a></div></div></div></div>");
$templateCache.put("app/main/customers/dialogs/customer-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large customer-dialog\" aria-label=\"Clientes\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><md-menu class=\"labels\"><md-button \nclass=\"md-icon-button\" aria-label=\"Label\" ng-click=\"vm.labelTabIndex = 0; $mdMenu.open($event)\" translate \ndata-cy=\"open-customer-labels\" translate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.TITLE\"><md-icon \nmd-menu-origin md-font-icon=\"icon-label-outline\"><md-tooltip md-direction=\"bottom\" ng-if=\"vm.labels.length\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.MANAGE\">Manage labels</span></md-tooltip><md-tooltip md-direction=\"bottom\" \nng-if=\"!vm.labels.length && !vm.hasLabelsPermission\"><span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.NO_REGISTERED\">\nNo registered labels, only administrators can register labels.</span></md-tooltip></md-icon></md-button>\n<md-menu-content class=\"labels-menu-content\" width=\"4\" ms-scroll ng-show=\"vm.labels.length || vm.hasLabelsPermission\">\n<md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height><md-tab><md-tab-body><md-menu-item ng-if=\"vm.labels.length\">\n<md-input-container class=\"no-errors-spacer\" md-no-float><input type=\"text\" placeholder=\"Search tags ..\" \nng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate \ntranslate-attr-placeholder=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.PLACEHOLDER\"></md-input-container></md-menu-item>\n<md-menu-item ng-if=\"vm.labels.length\" class=\"label\" ng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button\n class=\"label-toggle-button\" md-prevent-menu-close ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.id, vm.customer.idLabels)\" aria-label=\"Toggle Label\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.TOGGLE\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{ label.name }}</span> <i \nng-if=\"vm.exists(label.id, vm.customer.idLabels)\" class=\"icon-check s16\"></i></div></md-button><md-button \nng-if=\"vm.hasLabelsPermission\" class=\"md-icon-button label-edit-button\" md-prevent-menu-close \nng-click=\"vm.editLabel(label);\" aria-label=\"Edit Label\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.EDIT\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\">\n</md-icon></md-button></md-menu-item><small class=\"counter-labels\" \ntranslate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.LIMIT_COUNT\" \ntranslate-values=\"{ length: vm.labels.length, limit: vm.labelsLimit }\" data-cy=\"quotations-label-counter\">\n{{ vm.labels.length }} of {{ vm.labelsLimit }} labels</small><md-menu-divider \nng-if=\"vm.labels.length && vm.hasLabelsPermission\"></md-menu-divider><md-menu-item ng-if=\"vm.hasLabelsPermission\">\n<md-button class=\"add-label-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 1\" \nng-disabled=\"vm.labels.length >= vm.labelsLimit\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.ADD\"><md-tooltip md-direction=\"right\" \nng-show=\"vm.labels.length >= vm.labelsLimit\"><span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.LIMIT_EXCEEDED\">\nMaximum tag limit has been exceeded.</span></md-tooltip>Create new label</span></md-button></md-menu-item>\n</md-tab-body></md-tab><md-tab><md-tab-body><div class=\"add-label-tab-content\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close \nng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span \nflex translate=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.ADD\">Create Label</span></div><div class=\"content\" layout=\"column\" \nlayout-align=\"start stretch\"><form name=\"addLabelForm\" novalidate layout=\"column\"><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.newLabelName\" \nmaxlength=\"20\" required translate translate-attr-placeholder=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.NAME\">\n</md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap><label class=\"color\" \nng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{ \'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1) }\" \nlayout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" \nng-value=\"palette\" aria-label=\"{{ palette }}\"> <i class=\"icon-check s18\" ng-if=\"vm.newLabelColor === palette\"></i>\n</label></div><md-button class=\"create-button md-accent md-raised\" md-prevent-menu-close \nng-click=\"vm.addNewLabel({ color:vm.newLabelColor, name: vm.newLabelName });\" \nng-disabled=\"!vm.newLabelColor || !vm.newLabelName\" aria-label=\"Create\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.CREATE_BUTTON\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.CREATE_BUTTON\">Create</span></md-button></form></div></div></md-tab-body>\n</md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close \nng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span \nflex translate=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.EDIT_LABEL\">Edit Label</span></div><div class=\"content\" \nlayout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float><input \nplaceholder=\"Label Name\" type=\"text\" ng-model=\"vm.editingLabel.name\" translate \ntranslate-attr-placeholder=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.NAME\"></md-input-container><div \nclass=\"label-color-picker\" layout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{ \'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1) }\" \nlayout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.editingLabel.color\" \nng-value=\"palette\" aria-label=\"{{ palette }}\"> <i ng-if=\"vm.editingLabel.color === palette\" class=\"icon-check s18\"></i>\n</label></div><md-button class=\"create-button md-accent md-raised\" md-prevent-menu-close aria-label=\"Update\" translate \nng-click=\"vm.updateLabel(vm.editingLabel);\" ng-disabled=\"!vm.editingLabel.name || !vm.editingLabel.color\" \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.EDIT\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LABEL.EDIT\">Update</span></md-button><div layout=\"row\" layout-align=\"end center\" \nflex></div></div></div></md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><span \nstyle=\"margin-top: 10px !important\" ng-show=\"!vm.customer.id\" class=\"title\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.TITLE_NEW\">New customer </span><span style=\"margin-top: 10px !important\" \nng-show=\"vm.customer.id\" class=\"title\" translate=\"CUSTOMERS.DIALOGS.CUSTOMER.TITLE_EDIT\">Edit customer </span><span \nflex></span> <span flex></span></div><div class=\"sidebar-dialog__actions\"><md-button data-cy=\"close-dialog-buton\" \nclass=\"md-icon-button\" aria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><form name=\"customerForm\" class=\"md-inline-form\" novalidate><md-dialog-content \nms-scroll class=\"pt-0 pr-0\"><md-tabs md-selected=\"vm.selectedTabIndex\" md-dynamic-height class=\"ml-24n mr-24n\"><md-tab>\n<md-tab-label><span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.TITLE\">General</span></md-tab-label><md-tab-body><div\n ng-include=\"\'app/main/customers/dialogs/tabs/general/general-tab.html\'\"></div></md-tab-body></md-tab><md-tab \ndata-cy=\"locations-tab\" \nng-disabled=\"!vm.customer.name && !vm.customer.id || !vm.hasWhiteSpacesInName && !vm.customer.id\"><md-tab-label><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.LABEL_CREATE\" ng-if=\"vm.newCustomer\">Location </span><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.LABEL\" ng-if=\"!vm.newCustomer\">Locations</span><md-icon \nng-if=\"vm.hasDuplicatedLocationsName\" class=\"tab-with-icon__warning\" md-svg-src=\"assets/icons/icon-alert-circlce.svg\">\n</md-icon></md-tab-label><md-tab-body><div ng-if=\"vm.newCustomer\" \nng-include=\"\'app/main/customers/dialogs/tabs/locations/new/locations-tab.html\'\"></div><div ng-if=\"!vm.newCustomer\" \nng-include=\"\'app/main/customers/dialogs/tabs/locations/edit/locations-tab.html\'\"></div></md-tab-body></md-tab><md-tab \nng-disabled=\"!vm.customer.name && !vm.customer.id || !vm.hasWhiteSpacesInName && !vm.customer.id\" \nng-click=\"vm.validateFields()\"><md-tab-label><span data-cy=\"contacts-tab\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.CONTACTS.TITLE\">Contacts</span><md-icon \nng-if=\"vm.isAtLeastOneContactFieldInvalid\" class=\"tab-with-icon__warning\" \nmd-svg-src=\"assets/icons/icon-alert-circlce.svg\"></md-icon></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/customers/dialogs/tabs/contacts/contacts-tab.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"!vm.newCustomer\"><md-tab-label><span data-cy=\"attachments-tab\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.LABEL\">Attachments</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/customers/dialogs/tabs/attachments/attachments-tab.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"!vm.newCustomer\"><md-tab-label><span data-cy=\"services-tab\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.SERVICES.TITLE\">Services</span></md-tab-label><md-tab-body><div \nng-if=\"vm.timeline.length <= 0\"><p class=\"text-center\"><i class=\"icon-history s40\"></i><br><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.SERVICES.NO_HISTORY\">This customer has no service history.</span></p></div><div \nng-if=\"vm.timeline.length > 0\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.goToTaskList();\" aria-label=\"ir para listagem de atividades\"><md-icon md-font-icon=\"icon-arrow-right\">\n</md-icon><md-tooltip md-direction=\"left\"><span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.SERVICES.GO_TO_TASKS_LIST\">\nGo to tasks list</span></md-tooltip></md-button></div><div id=\"timeline\" class=\"timeline-left fs-13\" \nng-if=\"vm.timeline.length > 0\" ms-timeline><div ms-timeline-item layout=\"column\" layout-align=\"center center\" \nlayout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" \nng-model=\"timelineItem.card\"></ms-card></div><div ng-style=\"{\'background-color\': timelineItem.color}\" \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{ timelineItem.time }}</div><div class=\"event\" \nng-bind-html=\"timelineItem.eventHtml\"></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ndata-cy=\"template-tab\" translate=\"CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.TITLE\">Models</span></md-tab-label><md-tab-body>\n<div ng-include=\"\'app/main/customers/dialogs/tabs/order-report-template/order-report-template-tab.html\'\"></div>\n</md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><button \nclass=\"fc-button fc-button--actions\" type=\"submit\" ng-if=\"!vm.newCustomer\" \nng-class=\"{disabled: customerForm.$invalid || vm.isValidating || customerForm.$pristine || $root.loadingProgress === true || (vm.customer.locked && vm.customer.metadata.sammathnaur) || vm.isLoading}\" \nng-click=\"vm.saveCustomer()\" data-cy=\"customer-save-button\" \nng-disabled=\"customerForm.$invalid || vm.isValidating || customerForm.$pristine || $root.loadingProgress === true || (vm.customer.locked && vm.customer.metadata.sammathnaur) || vm.isLoading\" \naria-label=\"Save\" translate=\"CUSTOMERS.DIALOGS.CUSTOMER.SAVE\" \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.SAVE\">Save</button> <button type=\"submit\" \nclass=\"fc-button fc-button--actions\" \nng-style=\"{display: vm.newCustomer && (vm.alreadyContinued || vm.selectedTabIndex > 0) ? \'block\' : \'none\'}\" \nng-class=\"{disabled: customerForm.$invalid || vm.isValidating || customerForm.$pristine || $root.loadingProgress === true || (vm.customer.locked && vm.customer.metadata.sammathnaur) || vm.isLoading}\" \nng-click=\"vm.saveCustomer()\" data-cy=\"customer-create-button\" \nng-disabled=\"customerForm.$invalid || vm.isValidating || customerForm.$pristine || $root.loadingProgress === true || (vm.customer.locked && vm.customer.metadata.sammathnaur) || vm.isLoading\" \naria-label=\"Create\" translate=\"CUSTOMERS.DIALOGS.CUSTOMER.CREATE\" \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.CREATE\">Create</button> <button \nclass=\"fc-button fc-button--actions__continue\" type=\"submit\" data-cy=\"customer-continue-button\" \nng-class=\"{disabled: !vm.customer.name || !vm.hasWhiteSpacesInName}\" \nng-style=\"{display: vm.newCustomer && vm.selectedTabIndex === 0 && !vm.alreadyContinued ? \'block\' : \'none\'}\" \nng-click=\"vm.continueToNextTab();\" ng-disabled=\"!vm.customer.name || !vm.hasWhiteSpacesInName\" aria-label=\"Continue\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.CONTINUE\" translate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.CONTINUE\">\nContinue</button></div><div layout=\"row\"><span><md-button \nng-disabled=\"!vm.customer.documentNumber || vm.customer.documentNumber.length < 11\" \nng-if=\"!vm.customer.archived && vm.customer.id && vm.showButtonSendToOmie && !vm.customer.metadata.sammathnaur\" \nng-click=\"vm.openCustomersExportDialog($event, \'Omie\')\" class=\"md-icon-button\" aria-label=\"Send to\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.SEND_TO\"><md-icon md-svg-src=\"assets/icons/icon-omie.svg\" \nclass=\"icon-customer-export\"></md-icon></md-button><md-tooltip \nng-if=\"vm.customer.documentNumber && vm.customer.documentNumber.length >= 11\" md-direction=\"top\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.SEND_TO\">Send to</span>&nbsp;Omie</md-tooltip><md-tooltip \nng-if=\"!vm.customer.documentNumber || vm.customer.documentNumber.length < 11\" md-direction=\"top\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.CANT_SEND_WITHOUT_DOCUMENT\">Can\'t send customers without CPF/CNPJ</span>\n</md-tooltip></span><md-button \nng-if=\"(!vm.customer.archived && vm.customer.id) && vm.showButtonSendToContaAzul && !vm.customer.metadata.sammathnaur\" \nng-click=\"vm.openCustomersExportDialog($event, \'Conta Azul\')\" class=\"md-icon-button\" aria-label=\"Send To\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.SEND_TO\"><md-icon md-svg-src=\"assets/icons/icon-conta-azul.svg\" \nclass=\"icon-customer-export\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.SEND_TO\">Send to</span>&nbsp;Conta Azul</md-tooltip></md-button><md-button \ndata-cy=\"customer-archive-button\" ng-show=\"(!vm.customer.archived && vm.customer.id)\" \nng-disabled=\"vm.customer.locked && vm.customer.metadata.sammathnaur\" class=\"md-icon-button\" aria-label=\"Archive\" \nng-click=\"vm.archiveCustomer($event)\" translate translate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.ARCHIVE\"><md-icon\n md-font-icon=\"icon-folder-download\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button \nng-show=\"(vm.customer.archived && vm.customer.id)\" \nng-disabled=\"vm.customer.locked && vm.customer.metadata.sammathnaur\" class=\"md-icon-button\" aria-label=\"Unarchive\" \nng-click=\"vm.unarchiveCustomer($event)\" translate translate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.UNARCHIVE\">\n<md-icon md-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.UNARCHIVE\">Unarchive</span></md-tooltip></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/customers/sidenavs/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"CUSTOMERS.FILTERS.TITLE\">Filter customers</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"CUSTOMERS.FILTERS.CLEAR\">\nClear</span></md-tooltip></md-button></div></md-toolbar><md-content class=\"animate-slide-right filter-customers\" \nms-scroll><md-list><div class=\"filter-property-name\" translate=\"CUSTOMERS.FILTERS.FIRST_VISIT_FILTERS\">\nFirst visit filters</div><md-list-item><label translate=\"CUSTOMERS.FILTERS.OF\">Of:</label>&nbsp;<md-datepicker \ndata-cy=\"customers-filters.firstServiceDateFrom\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.customersFilters.firstServiceDateFrom\" \nmd-placeholder=\"{{\'CUSTOMERS.FILTERS.DATE.PLACEHOLDER\' | translate}}\"></md-datepicker></md-list-item><md-list-item>\n<label translate=\"CUSTOMERS.FILTERS.UNTIL\">Until:</label><md-datepicker data-cy=\"customers-filters.firstServiceDateTo\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.customersFilters.firstServiceDateTo\" \nmd-placeholder=\"{{\'CUSTOMERS.FILTERS.DATE.PLACEHOLDER\' | translate}}\"></md-datepicker></md-list-item><md-divider>\n</md-divider><div class=\"filter-property-name\" translate=\"CUSTOMERS.FILTERS.FILTERS_BY_LAST_VISIT\">\nFilters by last visit</div><md-list-item><label translate=\"CUSTOMERS.FILTERS.OF\">Of:</label>&nbsp;<md-datepicker \ndata-cy=\"customers-filters.lastServiceDateFrom\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.customersFilters.lastServiceDateFrom\" \nmd-placeholder=\"{{\'CUSTOMERS.FILTERS.DATE.PLACEHOLDER\' | translate}}\"></md-datepicker></md-list-item><md-list-item>\n<label translate=\"CUSTOMERS.FILTERS.UNTIL\">Until:</label><md-datepicker data-cy=\"customers-filters.lastServiceDateTo\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.customersFilters.lastServiceDateTo\" \nmd-placeholder=\"{{\'CUSTOMERS.FILTERS.DATE.PLACEHOLDER\' | translate}}\"></md-datepicker></md-list-item><md-divider>\n</md-divider><div ng-if=\"vm.hasTerritoriesFlag\"><div class=\"filter-property-name\"><span \ntranslate=\"CUSTOMERS.FILTERS.BY_TERRITORY.LABEL\">Filter by territory</span></div><md-list-item><md-input-container>\n<label ng-show=\"!vm.customersFilters.territoryId\">{{ \'CUSTOMERS.FILTERS.BY_TERRITORY.SEARCH_LABEL\' | translate }}\n</label><md-select ng-model=\"vm.customersFilters.territoryId\" ng-model-options=\"{trackBy: \'$value\', debounce: 100}\" \nmd-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" \nng-change=\"vm.broadcastFilterUpdated(); vm.territorySelected();\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'CUSTOMERS.FILTERS.BY_TERRITORY.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"territory.id\" \nng-repeat=\"territory in vm.territoriesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">{{ territory.name }}\n</md-option></md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider><div \nng-if=\"vm.customersFilters.territoryId\"><div class=\"filter-property-name\"><span \ntranslate=\"CUSTOMERS.FILTERS.BY_SUBTERRITORY.LABEL\">Filter by subTerritory</span></div><md-list-item>\n<md-input-container><label ng-show=\"vm.customersFilters.subTerritoryIds.length == 0\">\n{{ \'CUSTOMERS.FILTERS.BY_SUBTERRITORY.SEARCH_LABEL\' | translate }}</label><md-select \nng-model=\"vm.customersFilters.subTerritoryIds\" ng-model-options=\"{trackBy: \'$value\', debounce: 100}\" \nmd-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" ng-change=\"vm.broadcastFilterUpdated();\" \nmultiple=\"multiple\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'CUSTOMERS.FILTERS.BY_SUBTERRITORY.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"territory.id\" \nng-repeat=\"territory in vm.subTerritoriesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">{{ territory.name }}\n</md-option></md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider></div></div>\n<md-list-item><input data-cy=\"customers-filters.name\" flex class=\"search-input\" \nplaceholder=\"{{\'CUSTOMERS.FILTERS.NAME.PLACEHOLDER\' | translate}}\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.customersFilters.name\"></md-list-item><md-list-item><input \ndata-cy=\"customers-filters.phone\" flex class=\"search-input\" \nplaceholder=\"{{\'CUSTOMERS.FILTERS.PHONE.PLACEHOLDER\' | translate}}\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.customersFilters.phone\"></md-list-item><md-list-item><input \ndata-cy=\"customers-filters.documentNumber\" flex class=\"search-input\" \nplaceholder=\"{{\'CUSTOMERS.FILTERS.DOCUMENT_NUMBER.PLACEHOLDER\' | translate}}\" type=\"text\" cpf-cnpj-mask \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.customersFilters.documentNumber\"></md-list-item><md-list-item><input data-cy=\"customers-filters.email\" \nflex class=\"search-input\" placeholder=\"{{\'CUSTOMERS.FILTERS.EMAIL.PLACEHOLDER\' | translate}}\" type=\"text\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.customersFilters.email\">\n</md-list-item><md-list-item><input data-cy=\"customers-filters.street\" flex class=\"search-input\" \nplaceholder=\"{{\'CUSTOMERS.FILTERS.STREET.PLACEHOLDER\' | translate}}\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.customersFilters.street\"></md-list-item><md-list-item><input \ndata-cy=\"customers-filters.city\" flex class=\"search-input\" \nplaceholder=\"{{\'CUSTOMERS.FILTERS.CITY.PLACEHOLDER\' | translate}}\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.customersFilters.city\"></md-list-item><md-list-item><input \ndata-cy=\"customers-filters.state\" flex class=\"search-input\" \nplaceholder=\"{{\'CUSTOMERS.FILTERS.STATE.PLACEHOLDER\' | translate}}\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.customersFilters.state\"></md-list-item><md-divider></md-divider>\n<div class=\"filter-subtitle\" ng-if=\"vm.areThereOmieAccounts\" translate=\"CUSTOMERS.FILTERS.FILTER_BY_OMIE\">\nFilter by omie account</div><md-list-item ng-if=\"vm.areThereOmieAccounts\"><md-select \ndata-cy=\"customers-filters.externalAppId\" class=\"mt-0 w-100-percent\" name=\"externalAppId\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.customersFilters.externalAppId\"><md-option \nng-repeat=\"option in vm.externalAppIdOptions\" value=\"option.value\" ng-value=\"option.value\">{{ option.label }}\n</md-option></md-select></md-list-item><div class=\"filter-subtitle\" translate=\"CUSTOMERS.FILTERS.FILTER_BY_SITUATION\">\nFilter by situation</div><md-list-item><md-select data-cy=\"customers-filters.archived\" class=\"mt-0 w-100-percent\" \nname=\"archived\" ng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.customersFilters.archived\"><md-option value=\"-1\">\n<span translate=\"CUSTOMERS.FILTERS.STATUS.ALL\">All</span></md-option><md-option value=\"1\"><span \ntranslate=\"CUSTOMERS.FILTERS.STATUS.ACTIVE\">Active</span></md-option><md-option value=\"0\"><span \ntranslate=\"CUSTOMERS.FILTERS.STATUS.ARCHIVED\">Archived</span></md-option></md-select></md-list-item><md-divider>\n</md-divider><div class=\"filter-property-name\" translate=\"CUSTOMERS.FILTERS.FILTER_BY_RATING_AVERAGE\">\nFilter by rating average</div><md-list-item data-cy=\"customers-filters.ratings-{{ $index }}\" class=\"label\" \nng-repeat=\"rating in vm.ratings\" ng-click=\"vm.toggleInArray(rating.stars, vm.customersFilters.averageRating)\"><p \nng-if=\"rating.stars === \'null\'\" translate=\"CUSTOMERS.FILTERS.NOT_RATED\">Not rated</p><p ng-if=\"rating.stars > 0\"><i \nng-class=\"rating.stars >= 1 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 2 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 3 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 4 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 5 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i></p><p>\n{{ rating.name }}</p><p></p><i class=\"icon-check s16\" \nng-if=\"vm.exists(rating.stars, vm.customersFilters.averageRating)\"></i></md-list-item><md-divider></md-divider><div \nclass=\"filter-property-name\" translate=\"CUSTOMERS.FILTERS.FILTER_BY_LAST_REVIEW\">Filter by last review</div>\n<md-list-item data-cy=\"customers-filters.lastRatings-{{ $index }}\" class=\"label\" ng-repeat=\"rating in vm.ratings\" \nng-click=\"vm.toggleInArray(rating.stars, vm.customersFilters.lastRating)\"><p ng-if=\"rating.stars === \'null\'\" \ntranslate=\"CUSTOMERS.FILTERS.NOT_RATED\">Not rated</p><p ng-if=\"rating.stars > 0\"><i \nng-class=\"rating.stars >= 1 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 2 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 3 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 4 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 5 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i></p><p>\n{{ rating.name }}</p><p></p><i class=\"icon-check s16\" ng-if=\"vm.exists(rating.stars, vm.customersFilters.lastRating)\">\n</i></md-list-item><md-divider ng-if=\"vm.labels && vm.labels.length > 0\"></md-divider><div \nng-if=\"vm.labels && vm.labels.length > 0\" class=\"filter-subtitle\" translate=\"CUSTOMERS.FILTERS.FILTER_BY_LABEL.LABEL\">\nFilter by tags</div><md-list-item data-cy=\"customers-filters.labels-no-label\" class=\"label\" \nng-click=\"vm.toggleInArray(null, vm.customersFilters.labels)\"><md-icon md-font-icon=\"icon-label-outline\" \nclass=\"label-icon\"></md-icon><p translate=\"CUSTOMERS.FILTERS.FILTER_BY_LABEL.NO_LABEL\">No tag</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(null, vm.customersFilters.labels)\"></i></md-list-item><md-list-item \ndata-cy=\"customers-filters.labels-{{ $index }}\" class=\"label\" ng-repeat=\"label in vm.labels\" \nng-click=\"vm.toggleInArray(label.id, vm.customersFilters.labels)\"><md-icon md-font-icon=\"icon-label\" \nng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(label.id, vm.customersFilters.labels)\"></i></md-list-item></md-list></md-content>");
$templateCache.put("app/main/deadline-contracts/dialogs/deadline-contracts-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large deadline-contracts-dialog\" aria-label=\"Dialog SLA Contracts\">\n<md-toolbar class=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span ng-show=\"!vm.contract.id\" \nclass=\"title\" translate=\"DEADLINE-CONTRACTS.DIALOG.NEW.TITLE\">New Contract </span><span \nng-show=\"vm.contract.id && !vm.contract.locked\" class=\"title\" translate=\"DEADLINE-CONTRACTS.DIALOG.VIEW.TITLE\">\nEdit Contract </span><span ng-show=\"vm.contract.id && vm.contract.locked\" class=\"title\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.VIEW.READONLY_TITLE\">View Contract</span></div><div \nclass=\"sidebar-dialog__actions\"><md-button data-cy=\"close-dialog-button\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><form name=\"contractForm\" class=\"md-inline-form\" novalidate><md-dialog-content class=\"p-0\" ms-scroll>\n<md-tabs md-selected=\"vm.selectedTabIndex\" md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.GENERAL.TITLE\">General</span></md-tab-label><md-tab-body><div \nng-if=\"!vm.contract.locked && !(vm.contract.metadata && vm.contract.metadata.sammathnaur)\" \nclass=\"fc-warning-container\" layout=\"row\"><div layout-align=\"center center\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"assets/icons/icon-warning-alert.svg\"></md-icon><span \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.GENERAL.WARNING_SENTENCE\"></span> <a \nhref=\"https://docs.fieldcontrol.com.br/docs/perguntas-frequentes/como-criar-um-contrato-de-prazos/\" target=\"_blank\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.GENERAL.LEARN_MORE\"></a></div></div><corporate-customer-disclaimer \nng-if=\"vm.contract.locked && vm.contract.metadata && vm.contract.metadata.sammathnaur\" \ncustomer-name=\"vm.contract.metadata && vm.contract.metadata.sammathnaur && vm.contract.metadata.sammathnaur.account.name\">\n</corporate-customer-disclaimer><fieldset class=\"content\"><span class=\"subtitle\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.GENERAL.CONTRACT_INFORMATION\">Contract Information</span><div layout=\"row\" \nlayout-xs=\"column\" flex=\"100\" layout-wrap><div flex=\"100\" class=\"fc-input mb-30\"><input data-cy=\"name-input\" \nclass=\"fc-input__input\" name=\"name\" ng-model=\"vm.contract.name\" ng-disabled=\"vm.contract.locked\" required \nplaceholder=\" \"><label class=\"fc-input__label\" translate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.NAME.LABEL\">Name</label>\n<fc-error ng-show=\"contractForm.name.$touched\" input-errors=\"contractForm.name.$error\" \nerrors-to-watch=\"[{\n                      name: \'required\',\n                      translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.NAME.ERRORS.REQUIRED\'\n                    }]\">\n</fc-error></div><div flex=\"100\" class=\"fc-input mb-25 h-flex\"><fc-smart-rewrite \nreference-id=\"vm.contract.id || vm.sessionId\" reference-type=\"deadline-contract-description\" \ndisabled=\"vm.contract.locked\"><fc-textarea data-cy=\"description-textarea\" \nlabel=\"{{ \'DEADLINE-CONTRACTS.DIALOG.MODEL.DESCRIPTION.LABEL\' | translate }}\" ng-model=\"vm.contract.description\" \ninput-name=\"description\" input-control=\"contractForm.description\" is-disabled=\"vm.contract.locked\" max-length=\"300\" \nerrors-to-watch=\"[\n                        {\n                        name: \'required\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.DESCRIPTION.ERRORS.REQUIRED\'\n                        },\n                        {\n                        name: \'maxlength\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.DESCRIPTION.ERRORS.MAX_LENGTH\',\n                        translateValues: { expectedLength: 300, receivedLength: contractForm.description.$viewValue.length }\n                        }\n                      ]\">\n</fc-smart-rewrite></div></div><div layout=\"column\" layout-xs=\"column\" flex=\"100\" class=\"deadline-times\"><div \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" class=\"deadline-top-row\"><div flex=\"25\" class=\"fc-input pr-10\"><input \ndata-cy=\"response-time-input\" id=\"response-risk-input\" class=\"fc-input__input\" name=\"responseDeadlineRisk\" \nng-disabled=\"vm.contract.locked\" ng-model=\"vm.contract.responseDeadlineRisk\" required type=\"text\" placeholder=\" \" \nng-pattern=\"\'\\\\d+\'\" ng-change=\"vm.validateMaxInResponseRisk()\"><label class=\"fc-input__label\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE_RISK.LABEL\">Risk Time in Respose Time</label><fc-error \nng-show=\"contractForm.responseDeadlineRisk.$touched\" input-errors=\"contractForm.responseDeadlineRisk.$error\" \nerrors-to-watch=\"[{\n                        name: \'required\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE_RISK.ERRORS.REQUIRED\'\n                      },{\n                        name: \'max\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE_RISK.ERRORS.MAX\'\n                      },{\n                        name: \'size\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE_RISK.ERRORS.SIZE_\' + vm.selectedResponseDeadlineRisk\n                      },{\n                        name: \'pattern\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE_RISK.ERRORS.PATTERN\'\n                      }]\">\n</fc-error></div><fc-select data-cy=\"response-time-select\" class=\"pr-10\" flex=\"25\" \nng-model=\"vm.selectedResponseDeadlineRisk\" options=\"vm.unitOptions\" is-disabled=\"vm.contract.locked\"></fc-select><div \nflex=\"25\" class=\"fc-input pr-10\"><input data-cy=\"response-deadline-input\" class=\"fc-input__input\" \nname=\"responseDeadline\" ng-disabled=\"vm.contract.locked\" ng-model=\"vm.contract.responseDeadline\" required type=\"text\" \nplaceholder=\" \" ng-pattern=\"\'\\\\d+\'\" ng-change=\"vm.validateMaxInResponseRisk()\"><label class=\"fc-input__label\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE.LABEL\">Response Time</label><fc-error \nng-show=\"contractForm.responseDeadline.$touched\" input-errors=\"contractForm.responseDeadline.$error\" \nerrors-to-watch=\"[{\n                        name: \'required\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE.ERRORS.REQUIRED\'\n                      },{\n                        name: \'type\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.DESCRIPTION.ERRORS.REQUIRED\'\n                      },{\n                        name: \'size\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE.ERRORS.SIZE_\' + vm.selectedResponseDeadline\n                      },{\n                        name: \'pattern\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE.ERRORS.PATTERN\'\n                      }]\">\n</fc-error></div><fc-select data-cy=\"response-deadline-select\" flex=\"25\" ng-model=\"vm.selectedResponseDeadline\" \nis-disabled=\"vm.contract.locked\" options=\"vm.unitOptions\"></fc-select></div><div layout=\"row\" layout-xs=\"column\" \nflex=\"100\" class=\"mt-24\"><div flex=\"25\" class=\"fc-input pr-10\"><input data-cy=\"solution-risk-input\" \nid=\"solution-risk-input\" class=\"fc-input__input\" name=\"solutionDeadlineRisk\" ng-disabled=\"vm.contract.locked\" \nng-model=\"vm.contract.solutionDeadlineRisk\" required type=\"text\" placeholder=\" \" ng-pattern=\"\'\\\\d+\'\" \nng-change=\"vm.validateMaxInSolutionRisk()\"><label class=\"fc-input__label\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.SOLUTION_DEADLINE_RISK.LABEL\">Risk Solution Deadline</label><fc-error \nng-show=\"contractForm.solutionDeadlineRisk.$touched\" input-errors=\"contractForm.solutionDeadlineRisk.$error\" \nerrors-to-watch=\"[{\n                        name: \'required\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.SOLUTION_DEADLINE_RISK.ERRORS.REQUIRED\'\n                      },{\n                        name: \'max\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.SOLUTION_DEADLINE_RISK.ERRORS.MAX\'\n                      },{\n                        name: \'size\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.SOLUTION_DEADLINE.ERRORS.SIZE_\' + vm.selectedSolutionDeadlineRisk\n                      },{\n                        name: \'pattern\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE.ERRORS.PATTERN\'\n                      }]\">\n</fc-error></div><fc-select data-cy=\"solution-risk-select\" class=\"pr-10\" flex=\"25\" \nng-model=\"vm.selectedSolutionDeadlineRisk\" is-disabled=\"vm.contract.locked\" options=\"vm.unitOptions\"></fc-select><div \nflex=\"25\" class=\"fc-input pr-10\"><input data-cy=\"solution-deadline-input\" class=\"fc-input__input\" \nname=\"solutionDeadline\" ng-disabled=\"vm.contract.locked\" ng-model=\"vm.contract.solutionDeadline\" required type=\"text\" \nplaceholder=\" \" ng-pattern=\"\'\\\\d+\'\" ng-change=\"vm.validateMaxInSolutionRisk()\"><label class=\"fc-input__label\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.SOLUTION_DEADLINE.LABEL\">Solution Deadline</label><fc-error \nng-show=\"contractForm.solutionDeadline.$touched\" input-errors=\"contractForm.solutionDeadline.$error\" \nerrors-to-watch=\"[{\n                        name: \'required\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.SOLUTION_DEADLINE.ERRORS.REQUIRED\'\n                      },{\n                        name: \'size\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.SOLUTION_DEADLINE.ERRORS.SIZE_\' + vm.selectedSolutionDeadline\n                      },{\n                        name: \'pattern\',\n                        translate: \'DEADLINE-CONTRACTS.DIALOG.MODEL.RESPONSE_DEADLINE.ERRORS.PATTERN\'\n                      }]\">\n</fc-error></div><fc-select data-cy=\"solution-deadline-select\" flex=\"25\" ng-model=\"vm.selectedSolutionDeadline\" \nis-disabled=\"vm.contract.locked\" options=\"vm.unitOptions\"></fc-select></div></div></fieldset><fieldset class=\"content\">\n<span class=\"subtitle\" translate=\"DEADLINE-CONTRACTS.DIALOG.GENERAL.OFFICE_HOURS\">Office hours</span><fieldset \nclass=\"consider-holiday\"><md-switch data-cy=\"consider-holiday-switch\" ng-model=\"vm.contract.considerHoliday\" \nng-disabled=\"vm.contract.locked\"><small ng-if=\"!vm.contract.considerHoliday\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.CONSIDER_HOLIDAY.LABEL_NOT_REQUIRED\">\nDo not consider national and state holidays in calculating the deadline. </small><small \nng-if=\"vm.contract.considerHoliday\" translate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.CONSIDER_HOLIDAY.LABEL_REQUIRED\">\nConsider national and state holidays when calculating the SLA.</small></md-switch></fieldset><fieldset \nclass=\"office-hours\" ng-class=\"{ \'office-hours-activated\': vm.contract.hasOfficeHours }\"><md-switch \ndata-cy=\"has-office-hours-switch\" ng-model=\"vm.contract.hasOfficeHours\" \nng-change=\"vm.handleChangeOfficeHours(vm.contract.hasOfficeHours)\" ng-disabled=\"vm.contract.locked\" class=\"h-20\"><small\n ng-class=\"{ \'hidden\': vm.contract.hasOfficeHours }\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.HAS_OFFICE_HOURS.LABEL_NOT_REQUIRED\" ng-class=\"hidden\">\nConsider the time elapsed based on 24 hours, 7 days a week. </small><small \nng-class=\"{ \'hidden\': !vm.contract.hasOfficeHours }\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.HAS_OFFICE_HOURS.LABEL_REQUIRED\">\nConsider the time elapsed based on custom schedules.</small></md-switch><p class=\"hours-message\" \nng-if=\"vm.hasDaysAsUnits() && !vm.contract.locked\" \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.HAS_OFFICE_HOURS.NOT_ALLOWED\"></p><div class=\"mt-30\" flex=\"100\" \nlayout=\"row\" layout-align=\"start center\"><div flex=\"15\" layout=\"column\" class=\"times__input--group mr-10\"><div \nclass=\"checkbox-days\"><input data-cy=\"sunday-checkbox\" type=\"checkbox\" ng-model=\"vm.daysSelected.sunday\" \nng-disabled=\"vm.contract.locked\" ng-change=\"vm.handleChangeDays(\'sunday\')\"> <span \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.OFFICE_HOURS.SUNDAY.LABEL\">Sunday</span></div><div flex=\"100\" \nlayout=\"column\"><div class=\"fc-input\"><input data-cy=\"sunday-00-input\" class=\"fc-input__input mb-5\" \nng-model=\"vm.contract.officeHours.sunday.from\" \nng-disabled=\"!vm.daysSelected.sunday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.sunday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"00:00\" \nid=\"sundayFromInput\" name=\"sundayFromInput\" ng-class=\"{ disabled: !vm.daysSelected.sunday }\"></div><div \nclass=\"fc-input\"><input data-cy=\"sunday-23-input\" class=\"fc-input__input\" ng-model=\"vm.contract.officeHours.sunday.to\" \nng-disabled=\"!vm.daysSelected.sunday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.sunday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"23:59\" \nid=\"sundayToInput\" name=\"sundayToInput\" ng-class=\"{ disabled: !vm.daysSelected.sunday }\"></div></div></div><div \nflex=\"15\" layout=\"column\" class=\"times__input--group mr-10\"><div class=\"checkbox-days\"><input \ndata-cy=\"monday-checkbox\" type=\"checkbox\" ng-model=\"vm.daysSelected.monday\" ng-disabled=\"vm.contract.locked\" \nng-change=\"vm.handleChangeDays(\'monday\')\"> <span translate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.OFFICE_HOURS.MONDAY.LABEL\">\nMonday</span></div><div flex=\"100\" layout=\"column\"><div class=\"fc-input\"><input data-cy=\"monday-00-input\" \nclass=\"fc-input__input mb-5\" ng-model=\"vm.contract.officeHours.monday.from\" \nng-disabled=\"!vm.daysSelected.monday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.monday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"00:00\" \nid=\"mondayFromInput\" name=\"mondayFromInput\" ng-class=\"{ disabled: !vm.daysSelected.monday }\"></div><div \nclass=\"fc-input\"><input data-cy=\"monday-23-input\" class=\"fc-input__input\" ng-model=\"vm.contract.officeHours.monday.to\" \nng-disabled=\"!vm.daysSelected.monday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.monday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"23:59\" \nid=\"mondayToInput\" name=\"mondayToInput\" ng-class=\"{ disabled: !vm.daysSelected.monday }\"></div></div></div><div \nflex=\"15\" layout=\"column\" class=\"times__input--group mr-10\"><div class=\"checkbox-days\"><input \ndata-cy=\"tuesday-checkbox\" type=\"checkbox\" ng-model=\"vm.daysSelected.tuesday\" ng-disabled=\"vm.contract.locked\" \nng-change=\"vm.handleChangeDays(\'tuesday\')\"> <span \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.OFFICE_HOURS.TUESDAY.LABEL\">Tuesday</span></div><div flex=\"100\" \nlayout=\"column\"><div class=\"fc-input\"><input data-cy=\"tuesday-00-input\" class=\"fc-input__input mb-5\" \nng-model=\"vm.contract.officeHours.tuesday.from\" \nng-disabled=\"!vm.daysSelected.tuesday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.tuesday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"00:00\" \nid=\"tuesdayFromInput\" name=\"tuesdayFromInput\" ng-class=\"{ disabled: !vm.daysSelected.tuesday }\"></div><div \nclass=\"fc-input\"><input data-cy=\"tuesday-23-input\" class=\"fc-input__input\" \nng-model=\"vm.contract.officeHours.tuesday.to\" \nng-disabled=\"!vm.daysSelected.tuesday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.tuesday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"23:59\" \nid=\"tuesdayToInput\" name=\"tuesdayToInput\" ng-class=\"{ disabled: !vm.daysSelected.tuesday }\"></div></div></div><div \nflex=\"15\" layout=\"column\" class=\"times__input--group mr-10\"><div class=\"checkbox-days\"><input \ndata-cy=\"wednesday-checkbox\" type=\"checkbox\" ng-model=\"vm.daysSelected.wednesday\" ng-disabled=\"vm.contract.locked\" \nng-change=\"vm.handleChangeDays(\'wednesday\')\"> <span \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.OFFICE_HOURS.WEDNESDAY.LABEL\">Wednesday</span></div><div flex=\"100\" \nlayout=\"column\"><div class=\"fc-input\"><input data-cy=\"wednesday-00-input\" class=\"fc-input__input mb-5\" \nng-model=\"vm.contract.officeHours.wednesday.from\" \nng-disabled=\"!vm.daysSelected.wednesday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.wednesday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"00:00\" \nid=\"wednesdayFromInput\" name=\"wednesdayFromInput\" ng-class=\"{ disabled: !vm.daysSelected.wednesday }\"></div><div \nclass=\"fc-input\"><input data-cy=\"wednesday-23-input\" class=\"fc-input__input\" \nng-model=\"vm.contract.officeHours.wednesday.to\" \nng-disabled=\"!vm.daysSelected.wednesday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.wednesday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"23:59\" \nid=\"wednesdayToInput\" name=\"wednesdayToInput\" ng-class=\"{ disabled: !vm.daysSelected.wednesday }\"></div></div></div>\n<div flex=\"15\" layout=\"column\" class=\"times__input--group mr-10\"><div class=\"checkbox-days\"><input \ndata-cy=\"thursday-checkbox\" type=\"checkbox\" ng-model=\"vm.daysSelected.thursday\" ng-disabled=\"vm.contract.locked\" \nng-change=\"vm.handleChangeDays(\'thursday\')\"> <span \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.OFFICE_HOURS.THURSDAY.LABEL\">Thursday</span></div><div flex=\"100\" \nlayout=\"column\"><div class=\"fc-input\"><input data-cy=\"thursday-00-input\" class=\"fc-input__input mb-5\" \nng-model=\"vm.contract.officeHours.thursday.from\" \nng-disabled=\"!vm.daysSelected.thursday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.thursday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"00:00\" \nid=\"thursdayFromInput\" name=\"thursdayFromInput\" ng-class=\"{ disabled: !vm.daysSelected.thursday }\"></div><div \nclass=\"fc-input\"><input data-cy=\"thursday-23-input\" class=\"fc-input__input\" \nng-model=\"vm.contract.officeHours.thursday.to\" \nng-disabled=\"!vm.daysSelected.thursday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.thursday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"23:59\" \nid=\"thursdayToInput\" name=\"thursdayToInput\" ng-class=\"{ disabled: !vm.daysSelected.thursday }\"></div></div></div><div \nflex=\"15\" layout=\"column\" class=\"times__input--group mr-10\"><div class=\"checkbox-days\"><input \ndata-cy=\"friday-checkbox\" type=\"checkbox\" ng-model=\"vm.daysSelected.friday\" ng-disabled=\"vm.contract.locked\" \nng-change=\"vm.handleChangeDays(\'friday\')\"> <span translate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.OFFICE_HOURS.FRIDAY.LABEL\">\nFriday</span></div><div flex=\"100\" layout=\"column\"><div class=\"fc-input\"><input data-cy=\"friday-00-input\" \nclass=\"fc-input__input mb-5\" ng-model=\"vm.contract.officeHours.friday.from\" \nng-disabled=\"!vm.daysSelected.friday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.friday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"00:00\" \nid=\"fridayFromInput\" name=\"fridayFromInput\" ng-class=\"{ disabled: !vm.daysSelected.friday }\"></div><div \nclass=\"fc-input\"><input data-cy=\"friday-23-input\" class=\"fc-input__input\" ng-model=\"vm.contract.officeHours.friday.to\" \nng-disabled=\"!vm.daysSelected.friday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.friday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"23:59\" \nid=\"fridayToInput\" name=\"fridayToInput\" ng-class=\"{ disabled: !vm.daysSelected.friday }\"></div></div></div><div \nflex=\"15\" layout=\"column\" class=\"times__input--group\"><div class=\"checkbox-days\"><input data-cy=\"saturday-checkbox\" \ntype=\"checkbox\" ng-model=\"vm.daysSelected.saturday\" ng-disabled=\"vm.contract.locked\" \nng-change=\"vm.handleChangeDays(\'saturday\')\"> <span \ntranslate=\"DEADLINE-CONTRACTS.DIALOG.MODEL.OFFICE_HOURS.SATURDAY.LABEL\">Saturday</span></div><div flex=\"100\" \nlayout=\"column\"><div class=\"fc-input\"><input data-cy=\"saturday-00-input\" class=\"fc-input__input mb-5\" \nng-model=\"vm.contract.officeHours.saturday.from\" \nng-disabled=\"!vm.daysSelected.saturday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.saturday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"00:00\" \nid=\"saturdayFromInput\" name=\"saturdayFromInput\" ng-class=\"{ disabled: !vm.daysSelected.saturday }\"></div><div \nclass=\"fc-input\"><input data-cy=\"saturday-23-input\" class=\"fc-input__input\" \nng-model=\"vm.contract.officeHours.saturday.to\" \nng-disabled=\"!vm.daysSelected.saturday || vm.disableOfficeHours() || vm.contract.locked\" \nng-required=\"vm.daysSelected.saturday && !vm.disableOfficeHours()\" ui-time-mask=\"short\" placeholder=\"23:59\" \nid=\"saturdayToInput\" name=\"saturdayToInput\" ng-class=\"{ disabled: !vm.daysSelected.saturday }\"></div></div></div></div>\n</fieldset></fieldset></md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-cy=\"close-contract-button\" ng-if=\"vm.contract.locked\" type=\"button\" ng-click=\"vm.closeDialog()\" \nclass=\"fc-button fc-button--actions\" aria-label=\"close contract\">\n{{ \'DEADLINE-CONTRACTS.DIALOG.ACTIONS.CLOSE\' | translate }}</md-button><md-button \nng-attr-data-cy=\"{{vm.contract.id ? \'save-button\' : \'create-button\'}}\" ng-if=\"!vm.contract.locked\" type=\"submit\" \nng-click=\"vm.saveContract()\" class=\"fc-button fc-button--actions\" \nng-disabled=\"contractForm.$invalid || contractForm.$pristine || $root.loadingProgress === true || vm.validIfDaySelectedInOfficeHours() || !vm.disableOfficeHours(true) || !vm.validateMaxInResponseRisk() || !vm.validateMaxInSolutionRisk()\" \naria-label=\"Save contracts\">\n{{ vm.contract.id ? (\'DEADLINE-CONTRACTS.DIALOG.ACTIONS.SAVE\' | translate ) : (\'DEADLINE-CONTRACTS.DIALOG.ACTIONS.CREATE\' | translate) }}\n</md-button></div><md-button data-cy=\"archive-button\" ng-if=\"vm.contract.id && !vm.contract.locked\" \nng-show=\"!vm.contract.archived\" class=\"md-icon-button\" ng-click=\"vm.toggleContractArchiving($event)\" \naria-label=\"Archive\" translate translate-attr-aria-label=\"DEADLINE-CONTRACTS.DIALOG.ACTIONS.ARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-download\"></md-icon><md-tooltip><span translate=\"DEADLINE-CONTRACTS.DIALOG.ACTIONS.ARCHIVE\">\nArchive</span></md-tooltip></md-button><md-button ng-if=\"vm.contract.id && !vm.contract.locked\" \nng-show=\"vm.contract.archived\" class=\"md-icon-button\" ng-click=\"vm.toggleContractArchiving($event)\" \naria-label=\"Unarchive\" translate translate-attr-aria-label=\"DEADLINE-CONTRACTS.DIALOG.ACTIONS.UNARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip><span translate=\"DEADLINE-CONTRACTS.DIALOG.ACTIONS.UNARCHIVE\">\nUnarchive</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/deadline-violations-reasons/dialogs/deadline-violations-reasons-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large deadline-violations-reasons-dialog\" \naria-label=\"Dialog Deadline Violation Reason\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__title\"><span ng-show=\"!vm.violationReason.id\" class=\"title\" \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.NEW.TITLE\">New Violation Reason </span><span \nng-show=\"vm.violationReason.id && !vm.violationReason.locked\" class=\"title\" \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.VIEW.TITLE\">Edit Violation Reason </span><span \nng-show=\"vm.violationReason.id && vm.violationReason.locked\" class=\"title\" \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.VIEW.READONLY_TITLE\">View Violation Reason</span></div><div \nclass=\"sidebar-dialog__actions\"><md-button data-cy=\"close-dialog-button\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><form name=\"violationReasonForm\" class=\"md-inline-form\" novalidate><div class=\"fc-warning-container\" \nlayout=\"row\" layout-align=\"space-between center\" \nng-if=\"!vm.violationReason.locked && !(vm.violationReason.metadata && vm.violationReason.metadata.sammathnaur)\"><div \nlayout-align=\"center center\"><md-icon class=\"warning-icon md-default-blue\" \nmd-svg-src=\"assets/icons/icon-warning-alert.svg\"></md-icon><span \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.WARNING\"></span></div></div><corporate-customer-disclaimer \nng-if=\"vm.violationReason.locked && vm.violationReason.metadata && vm.violationReason.metadata.sammathnaur\" \ncustomer-name=\"vm.violationReason.metadata && vm.violationReason.metadata.sammathnaur && vm.violationReason.metadata.sammathnaur.account.name\">\n</corporate-customer-disclaimer><md-dialog-content ms-scroll><div class=\"sidebar-dialog__input-group\" layout=\"column\">\n<div class=\"sidebar-dialog__input-group\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div flex=\"10\" \nclass=\"fc-input input-color\" layout=\"row\" layout-align=\"center end\"><input data-cy=\"color-input\" \nclass=\"fc-input__input button-container p-15\" name=\"color\" ng-model=\"vm.violationReason.color\" required type=\"color\" \nng-disabled=\"vm.violationReason.locked\"><label class=\"fc-input__label input-color-label\" \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.MODEL.COLOR.LABEL\">Cor*</label><div class=\"selected-color\" \nng-style=\"{\'background-color\': vm.violationReason.color}\"></div><fc-error ng-show=\"violationReasonForm.color.$touched\" \ninput-errors=\"violationReasonForm.color.$error\" \nerrors-to-watch=\"[ {\n                name: \'maxlength\',\n                translate: \'EQUIPMENTS.MODEL.ERRORS.NOTES_MAX_LENGTH\',\n                translateValues: { expectedLength: 300, receivedLength: equipmentsForm.notes.$viewValue.length }\n              }]\">\n</fc-error></div><div flex=\"90\" class=\"fc-input\"><input data-cy=\"name-input\" class=\"fc-input__input\" name=\"name\" \nng-model=\"vm.violationReason.name\" required ng-disabled=\"vm.violationReason.locked\"><label class=\"fc-input__label\" \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.MODEL.NAME.LABEL\">Name</label><fc-error \nng-show=\"violationReasonForm.name.$touched\" input-errors=\"violationReasonForm.name.$error\" \nerrors-to-watch=\"[{\n              name: \'required\',\n              translate: \'DEADLINE-VIOLATIONS-REASONS.DIALOG.MODEL.NAME.ERRORS.REQUIRED\'\n            }]\">\n</fc-error></div></div><div class=\"sidebar-dialog__input-group\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div \nflex=\"100\" class=\"fc-input\"><fc-smart-rewrite reference-id=\"vm.violationReason.id || vm.sessionId\" \nreference-type=\"deadline-contract-reason-description\" disabled=\"vm.violationReason.locked\"><fc-textarea \ndata-cy=\"description-textarea\" label=\"{{(\'DEADLINE-VIOLATIONS-REASONS.DIALOG.MODEL.DESCRIPTION.LABEL\' | translate)}}\" \nng-model=\"vm.violationReason.description\" input-name=\"description\" input-control=\"violationReasonForm.description\" \nmax-length=\"300\" is-disabled=\"vm.violationReason.locked\" \nerrors-to-watch=\"[\n                {\n                  name: \'maxlength\',\n                  translate: \'DEADLINE-VIOLATIONS-REASONS.DIALOG.MODEL.DESCRIPTION.ERRORS.MAX_LENGTH\',\n                  translateValues: { expectedLength: 300, receivedLength: violationReasonForm.description.$viewValue.length }\n                },\n              ]\">\n</fc-textarea></fc-smart-rewrite></div></div></div></md-dialog-content><md-dialog-actions \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button data-cy=\"save-button\" \nng-if=\"!vm.violationReason.locked\" type=\"submit\" ng-click=\"vm.saveDeadlineViolationsReasons()\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"violationReasonForm.$invalid || violationReasonForm.$pristine || $root.loadingProgress === true\" \naria-label=\"Save grounds violation\" translate=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.ACTIONS.CREATE\">Save grounds violation</md-button>\n<md-button data-cy=\"close-button\" ng-if=\"vm.violationReason.locked\" type=\"button\" ng-click=\"vm.closeDialog()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"close dialog\" \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.ACTIONS.CLOSE\" \ntranslate-attr-aria-label=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.ACTIONS.CLOSE\">Close</md-button></div><md-button \ndata-cy=\"archive-button\" ng-show=\"!vm.violationReason.archived && vm.violationReason.id && !vm.violationReason.locked\" \nclass=\"md-icon-button\" ng-click=\"vm.archiveViolationReason($event)\" aria-label=\"Archive\" translate \ntranslate-attr-aria-label=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.ACTIONS.ARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-download\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button \nng-show=\"vm.violationReason.archived && vm.violationReason.id && !vm.violationReason.locked\" class=\"md-icon-button\" \nng-click=\"vm.archiveViolationReason($event)\" aria-label=\"Unarchive\" translate \ntranslate-attr-aria-label=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.ACTIONS.UNARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/employee-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--small form-dialog\" aria-label=\"Colaboradores\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span ng-show=\"vm.newEmployee\" class=\"title\" \ntranslate=\"EMPLOYEES.DIALOG.NEW.TITLE\">New employee</span> <span ng-show=\"!vm.newEmployee\" class=\"title\" \ntranslate=\"EMPLOYEES.DIALOG.EDIT.TITLE\">Edit employee</span></div><div class=\"sidebar-dialog__actions\"><md-button \ndata-cy=\"close-dialog-button\" class=\"md-icon-button\" ng-click=\"vm.closeDialog();\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" translate translate-attr-aria-label=\"EMPLOYEES.DIALOG.CLOSE\"></md-icon></md-button></div>\n</md-toolbar><form name=\"employeeForm\" class=\"md-inline-form\" novalidate><md-dialog-content class=\"dialog-content p-0\" \nms-scroll><md-tabs md-selected=\"vm.selectedTabIndex\" md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"EMPLOYEES.DIALOG.GENERAL.TITLE\">General</span></md-tab-label><md-tab-body><div class=\"mt-20n\"><div \nlayout=\"row\" layout-align=\"space-between\"><h4 class=\"font-size-16 font-weight-500\" \ntranslate=\"EMPLOYEES.DIALOG.GENERAL.EMPLOYEE_DATA\">Employee data</h4><h4 ng-if=\"vm.employee.id\" \nclass=\"font-size-16 font-weight-500\"><span class=\"text-green-600\" \nng-if=\"!vm.employee.inactivatedAt && !vm.isEmployeeFiredAndBeforeToday(vm.employee.contract.firedAt)\" \ntranslate=\"EMPLOYEES.DIALOG.GENERAL.ACTIVE\">Active</span> <span class=\"text-red-500\" \nng-if=\"vm.employee.inactivatedAt || vm.isEmployeeFiredAndBeforeToday(vm.employee.contract.firedAt)\" \ntranslate=\"EMPLOYEES.DIALOG.GENERAL.INACTIVE\">Inactive</span> <span translate=\"EMPLOYEES.DIALOG.GENERAL.AND\">and</span>\n <span class=\"text-green-600\" ng-if=\"!vm.isEmployeeFiredAndBeforeToday(vm.employee.contract.firedAt)\" \ntranslate=\"EMPLOYEES.TABLE.ACTIVATED\">Within the hiring period</span> <span class=\"text-red-500\" \nng-if=\"vm.isEmployeeFiredAndBeforeToday(vm.employee.contract.firedAt)\" translate=\"EMPLOYEES.TABLE.DEACTIVATED\">\nOutside the hiring period</span></h4></div><div layout=\"row\"><div flex=\"10\"><div ng-click=\"vm.selectedTabIndex = 2\" \nclass=\"avatar-wrapper\"><img data-cy=\"avatar-employee\" class=\"avatar-employee\" ng-if=\"vm.avatarImage == null\" \nalt=\"{{ vm.employee.name }}\" ng-src=\"{{ vm.employee.avatarUrl }}\" src=\"./assets/images/avatars/profile.jpg\"> <img \nclass=\"avatar-employee\" ng-if=\"vm.avatarImage != null\" alt=\"{{ vm.employee.name }}\" \nng-src=\"{{ vm.avatarResultImage }}\" src=\"./assets/images/avatars/profile.jpg\"> <a ng-if=\"!vm.employee.id\" \nclass=\"md-subheader\" translate=\"EMPLOYEES.DIALOG.ACTIONS.UPLOAD_AVATAR\">Upload Avatar</a></div></div><div flex=\"90\">\n<div layout=\"column\"><div flex=\"100\" layout-xs=\"column\" layout=\"row\" layout-align=\"space-between\"><div flex=\"55\">\n<md-input-container class=\"md-block\"><label translate=\"EMPLOYEES.MODEL.NAME\">Name</label><input data-cy=\"name-input\" \nid=\"name\" name=\"name\" ng-model=\"vm.employee.name\" ng-maxlength=\"70\" required><div \nng-messages=\"employeeForm.name.$error\" ng-show=\"employeeForm.name.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"EMPLOYEES.MODEL.ERRORS.NAME_REQUIRED\">Name is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"EMPLOYEES.MODEL.ERRORS.NAME_VALID_LENGTH\" translate-values=\"{ length: 70 }\">Name size is invalid</span>\n</div></div></md-input-container></div><div flex=\"45\" ng-if=\"vm.countryCode === \'BRA\'\"><md-input-container \nclass=\"md-block\"><label translate=\"EMPLOYEES.MODEL.DOCUMENT.LABEL\">Document</label><input \ndata-cy=\"document-number-input\" id=\"documentNumber\" name=\"documentNumber\" ng-model=\"vm.employee.documentNumber\" \nng-change=\"vm.duplicatedValidation(vm.employee, employeeForm.documentNumber)\" ui-br-cpfcnpj-mask><div \nng-messages=\"employeeForm.documentNumber.$error\" ng-show=\"employeeForm.documentNumber.$touched\" role=\"alert\"><div \nng-message=\"cpf\"><span translate=\"EMPLOYEES.MODEL.DOCUMENT.INVALID_CPF\">Invalid CPF</span></div><div ng-message=\"cnpj\">\n<span translate=\"EMPLOYEES.MODEL.DOCUMENT.INVALID_CNPJ\">Invalid CNPJ</span></div><div ng-message=\"duplicated\"><span \ntranslate=\"EMPLOYEES.MODEL.DOCUMENT.EXISTS\">Document already exists</span></div></div></md-input-container></div><div \nflex=\"45\" ng-if=\"vm.countryCode !== \'BRA\'\"><md-input-container class=\"md-block\"><label \ntranslate=\"EMPLOYEES.MODEL.DOCUMENT.LABEL\">Document</label><input data-cy=\"document-number-input\" id=\"documentNumber\" \nname=\"documentNumber\" ng-model=\"vm.employee.documentNumber\" \nng-change=\"vm.duplicatedValidation(vm.employee, employeeForm.documentNumber)\" ng-maxlength=\"30\"><div \nng-messages=\"employeeForm.documentNumber.$error\" ng-show=\"employeeForm.documentNumber.$touched\" role=\"alert\"><div \nng-message=\"maxlength\"><span translate=\"EMPLOYEES.MODEL.ERRORS.DOCUMENT_NUMBER_VALID_LENGTH\" \ntranslate-values=\"{ length: 70 }\">Document size is invalid</span></div><div ng-message=\"duplicated\"><span \ntranslate=\"EMPLOYEES.MODEL.DOCUMENT.EXISTS\">Document already exists</span></div></div></md-input-container></div></div>\n</div></div></div><div layout-xs=\"column\" layout=\"row\"><div flex \nng-if=\"!vm.employee.address || vm.locationAddressErrors.length || vm.locationAddressWarnings.length || !vm.selectedEmployeeAddress\">\n<md-autocomplete flex required ng-blur=\"vm.completedEmployeeAddress\" data-cy=\"auto-complete-address\" \nmd-input-id=\"auto-complete-address\" md-input-name=\"auto-complete-address\" md-input-minlength=\"2\" \nmd-input-maxlength=\"150\" md-no-cache=\"false\" \nmd-selected-item-change=\"vm.validateEmployeeAddressChange(); vm.selectedAddressItemChange(vm.selectedEmployeeAddress)\" \nmd-selected-item=\"vm.selectedEmployeeAddress\" md-search-text=\"vm.selectedEmployeeAddressText\" \nmd-items=\"item in vm.searchAddress(vm.selectedEmployeeAddressText)\" md-autoselect=\"true\" md-delay=\"1500\" \nmd-item-text=\"item.formattedAddress\" md-floating-label=\"{{ \'EMPLOYEES.MODEL.EMPLOYEE_ADDRESS\' | translate }}\" \nmd-menu-class=\"autocomplete-custom-template\"><md-item-template><span data-cy=\"auto-complete-item\" class=\"item-title\">\n<md-icon class=\"s18\" md-font-icon=\"icon-map-marker\"></md-icon><span>{{ item.formattedAddress }} </span></span><span \nclass=\"item-metadata fs-13\"><md-icon class=\"s18\" md-font-icon=\"icon-road\"></md-icon>\n{{ item.kmDistance | number:1 | removeComma }} <span translate=\"EMPLOYEES.MODEL.DISTANCE_AWAY\">km away</span></span>\n</md-item-template><md-not-found><span class=\"item-title\"><md-icon class=\"s18\" md-font-icon=\"icon-map-marker-off\">\n</md-icon><span translate=\"EMPLOYEES.MODEL.ERRORS.ADDRESS_NOT_FOUND\">\nWe could not find the address, please change your search and try again.</span></span></md-not-found><div class=\"hint\" \nng-if=\"!vm.selectedEmployeeAddress && !vm.selectedEmployeeAddressText\"><span \ntranslate=\"EMPLOYEES.DIALOG.GENERAL.ENTER_ADDRESS\">Look for an address, example: Rua dos Pinheiros, 383 - São Paulo \n</span><i class=\"md-accent-fg icon icon-arrow-up-bold s14\"></i></div><div class=\"hint\" \nng-if=\"vm.selectedEmployeeAddressText && !vm.selectedEmployeeAddress\"><span \ntranslate=\"EMPLOYEES.DIALOG.GENERAL.ADDRESS_EXAMPLE\">Look for an address, example: Rua dos Pinheiros, 383 - São Paulo\n</span></div><div ng-messages=\"employeeForm[\'auto-complete-address\'].$error\" \nng-if=\"employeeForm[\'auto-complete-address\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"EMPLOYEES.MODEL.ERRORS.EMPLOYEE_ADDRESS_REQUIRED\">Employee address is required</span></div></div><div \nng-if=\"vm.formErr[\'employeeAddressIsRequired\'] && vm.selectedEmployeeAddressText.length > 0\"><div \nclass=\"grey-text fs-14\"><small ng-bind-html=\"vm.formErr[\'employeeAddressIsRequired\']\"></small></div></div><div \nng-if=\"vm.selectedEmployeeAddress\" \nclass=\"hint customers-dialog__locations-tab-new__main-container__input-groups__hint\"><div \nng-repeat=\"error in vm.locationAddressErrors\"><md-icon md-font-icon=\"icon-alert\" class=\"red-fg fs-14\"></md-icon><span>\n{{ \'CORE.ADDRESS_SERVICE.VALIDATION.\' + error | translate }}</span></div><div \nng-repeat=\"warning in vm.locationAddressWarnings\"><md-icon md-font-icon=\"icon-alert\" class=\"orange-fg fs-14\"></md-icon>\n<span>{{ \'CORE.ADDRESS_SERVICE.VALIDATION.\' + warning | translate }}</span></div></div></md-autocomplete></div><div \nflex \nng-if=\"vm.hasEmployeeAddress && vm.employee.address.number && !vm.locationAddressWarnings.length && !vm.locationAddressErrors.length\">\n<md-input-container class=\"md-block\"><label translate=\"EMPLOYEES.MODEL.EMPLOYEE_ADDRESS\">Employee Address</label><input\n data-cy=\"address-input\" id=\"formattedAddress\" name=\"formattedAddress\" ng-model=\"vm.employee.address.formattedAddress\" \ndisabled=\"disabled\"></md-input-container></div><div flex=\"5\" ng-if=\"vm.hasEmployeeAddress\"><md-button \nid=\"clear-employee-address\" ng-click=\"vm.clearSelectedEmployeeAddress($event);\" \nclass=\"md-icon-button md-accent mt-13 ml-5n\" aria-label=\"Limpar endereço do cliente\"><md-icon \nmd-font-icon=\"icon icon-close-circle-outline\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"EMPLOYEES.DIALOG.GENERAL.CLEAR_ADDRESS\">Clear employee address</span></md-tooltip></md-button></div></div>\n<div layout-xs=\"column\" layout=\"row\" ng-if=\"vm.hasTerritoriesFlag\"><md-input-container class=\"md-block\"><label \ntranslate=\"EMPLOYEES.MODEL.GROUPS\">Groups</label><md-select ng-model=\"vm.employee.groups\" \nng-model-options=\"{trackBy: \'$value.id\', debounce: 100}\" md-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" \nng-change=\"vm.broadcastFilterUpdated();\" multiple=\"multiple\" required><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'EMPLOYEES.MODEL.GROUPS\' | translate }}\" class=\"header-searchbox md-text\"></md-select-header>\n<md-optgroup><md-option ng-value=\"group\" ng-repeat=\"group in vm.groups | filter:vm.searchTerm | orderBy: \'name\'\">\n{{ group.name }}</md-option></md-optgroup></md-select><div ng-messages=\"employeeForm.groups.$error\" \nng-show=\"employeeForm.groups.$touched\"><div ng-message=\"required\"><span \ntranslate=\"EMPLOYEES.MODEL.ERRORS.GROUP_REQUIRED\">Group is required</span></div></div></md-input-container></div><div \nlayout-xs=\"column\" layout=\"row\"><div flex=\"25\"><md-input-container class=\"md-block\"><label \ntranslate=\"EMPLOYEES.MODEL.START_TIME\">Arrival time</label><input data-cy=\"start-time-input\" name=\"startTime\" \nui-time-mask=\"short\" ng-model=\"vm.employee.workSchedule.start\" \nng-change=\"vm.updateStartTimeFormat(vm.startTimeFormat); vm.validateTime()\" required><div \nng-messages=\"employeeForm[\'startTime\'].$error\" ng-if=\"employeeForm[\'startTime\'].$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"EMPLOYEES.MODEL.ERRORS.START_TIME_REQUIRED\">Arrival time is required</span>\n</div><div ng-message=\"time\"><span translate=\"EMPLOYEES.MODEL.ERRORS.START_TIME_INVALID\">Invalid time</span></div><div \nng-message=\"isGreaterThan12Hours\"><span>{{ \'EMPLOYEES.MODEL.ERRORS.START_TIME_IS_GREATER_THAN_12_HOURS\' | translate }}\n</span></div><div ng-message=\"isMinorThan1Hour\"><span>\n{{ \'EMPLOYEES.MODEL.ERRORS.START_TIME_IS_MINOR_THAN_1_HOUR\' | translate }}</span></div></div></md-input-container>\n</div><div flex=\"25\" ng-if=\"vm.timeFormatIsActive\"><md-input-container class=\"md-block\"><label>AM/PM</label><md-select \nrequired ng-model=\"vm.startTimeFormat\" name=\"startTimeFormat\" \nng-change=\"vm.updateStartTimeFormat(vm.startTimeFormat); vm.validateTime()\"><md-option value=\"am\">AM</md-option>\n<md-option value=\"pm\">PM</md-option></md-select><div ng-messages=\"employeeForm[\'startTimeFormat\'].$error\" \nng-if=\"employeeForm[\'startTimeFormat\'].$touched\" role=\"alert\"><div ng-message=\"required\">\n{{ \"EMPLOYEES.MODEL.ERRORS.TIME_FORMAT_REQUIRED\" | translate }}</div></div></md-input-container></div><div flex=\"25\" \nlayout-margin=\"20\"><md-input-container class=\"md-block\"><label translate=\"EMPLOYEES.MODEL.END_TIME\">Departure time\n</label><input name=\"endTime\" ui-time-mask=\"short\" ng-model=\"vm.employee.workSchedule.end\" \nng-change=\"vm.validateTime()\" required><div ng-messages=\"employeeForm[\'endTime\'].$error\" \nng-show=\"employeeForm[\'endTime\'].$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"EMPLOYEES.MODEL.ERRORS.END_TIME_REQUIRED\">Departure time is required</span></div><div ng-message=\"time\">\n<span translate=\"EMPLOYEES.MODEL.ERRORS.END_TIME_INVALID\">Invalid time</span></div><div \nng-message=\"isGreaterThan12Hours\"><span>{{ \'EMPLOYEES.MODEL.ERRORS.END_TIME_IS_GREATER_THAN_12_HOURS\' | translate }}\n</span></div><div ng-message=\"isMinorThan1Hour\"><span>\n{{ \'EMPLOYEES.MODEL.ERRORS.END_TIME_IS_MINOR_THAN_1_HOUR\' | translate }}</span></div><div \nng-message=\"endTimeIsMinorThanStartTime\"><span>\n{{ \"EMPLOYEES.MODEL.ERRORS.DEPARTURE_TIME_IS_LESS_THAN_ARRIVAL_TIME\" | translate }}</span></div></div>\n</md-input-container></div><div flex=\"25\" ng-if=\"vm.timeFormatIsActive\"><md-input-container class=\"md-block\"><label>\nAM/PM</label><md-select required ng-model=\"vm.endTimeFormat\" name=\"endTimeFormat\" \nng-change=\"vm.updateEndTimeFormat(vm.endTimeFormat); vm.validateTime()\"><md-option value=\"am\">AM</md-option><md-option \nvalue=\"pm\">PM</md-option></md-select><div ng-messages=\"employeeForm[\'endTimeFormat\'].$error\" \nng-if=\"employeeForm[\'endTimeFormat\'].$touched\" role=\"alert\"><div ng-message=\"required\">\n{{ \"EMPLOYEES.MODEL.ERRORS.TIME_FORMAT_REQUIRED\" | translate }}</div></div></md-input-container></div><div flex=\"25\" \nlayout-margin=\"20\"><md-input-container class=\"md-block\"><label translate=\"EMPLOYEES.MODEL.START_DATE\" \nclass=\"date-label\">Admission date</label><md-datepicker flex required class=\"icon-hide\" name=\"startDate\" \nng-model=\"vm.employee.contract.hiredAt\" md-placeholder=\"{{ \'EMPLOYEES.DIALOG.GENERAL.SELECT_DATE\' | translate }}\">\n</md-datepicker><div ng-messages=\"employeeForm.startDate.$error\" ng-show=\"employeeForm.startDate.$touched\" \nrole=\"alert\"><div ng-message=\"required\" class=\"red-text\"><small><span \ntranslate=\"EMPLOYEES.MODEL.ERRORS.START_DATE_REQUIRED\">Admission date is required</span></small></div></div>\n</md-input-container></div><div flex=\"25\" ng-if=\"vm.employee.id\" class=\"ml-42\"><md-input-container class=\"md-block\">\n<label translate=\"EMPLOYEES.MODEL.END_DATE\" class=\"date-label\">Dismissal date</label><md-datepicker flex \nname=\"endDate\" class=\"icon-hide\" md-min-date=\"vm.employee.contract.hiredAt\" ng-model=\"vm.employee.contract.firedAt\" \nmd-placeholder=\"{{ \'EMPLOYEES.DIALOG.GENERAL.SELECT_DATE\' | translate }}\" \nng-change=\"vm.onChangeEmployeeFiredAt(vm.employee.contract.firedAt)\"></md-datepicker></md-input-container></div></div>\n<div flex=\"100\" layout-xs=\"row\" layout=\"row\" layout-align=\"space-between\"><div flex=\"100\"><fc-smart-rewrite \nreference-id=\"vm.employee.id || vm.sessionId\" reference-type=\"employee-notes\"><fc-textarea data-cy=\"notes-input\" \nlabel=\"{{(\'EMPLOYEES.MODEL.NOTES\' | translate)}}\" ng-model=\"vm.employee.notes\" input-name=\"notes\" \ninput-control=\"employeeForm.notes\" max-length=\"2000\" \nerrors-to-watch=\"[\n                                            {\n                                                name: \'maxlength\',\n                                                translate: \'EMPLOYEES.MODEL.ERRORS.NOTE_VALID_LENGTH\',\n                                                translateValues: { expectedLength: 2000, receivedLength: employeeForm.notes.$viewValue.length }\n                                            },\n                                        ]\">\n</fc-textarea></fc-smart-rewrite></div></div><div layou-xs=\"column\" layout=\"column\"><h4 \nclass=\"font-size-16 font-weight-500 mt-0\" translate=\"EMPLOYEES.DIALOG.GENERAL.ACCESS_DATA\">Access data</h4><div \nflex=\"100\" layout=\"row\"><div flex=\"100\"><md-input-container><label translate=\"EMPLOYEES.MODEL.EMAIL\">Email</label>\n<input type=\"text\" name=\"email\" data-cy=\"email-input\" \nng-disabled=\"vm.employee.id && vm.hasMultipleEmployeeAccountsFlag || vm.employee.inactivatedAt\" \nng-model=\"vm.employee.email\" ng-change=\"vm.checkEmailErr()\" email-validation required><div \nng-if=\"employeeForm.email.$error.pattern && vm.employee.id\" class=\"red-text fs-14\"><span \ndata-cy=\"employees-email.invaldFormat\" translate=\"EMPLOYEES.MODEL.ERRORS.EMAIL_PATTERN_AFTER_CREATED\">\nInvalid email format contact your account manager</span></div><div ng-messages=\"employeeForm.email.$error\" \nng-show=\"employeeForm.email.$touched\"><div ng-message=\"required\"><span \ntranslate=\"EMPLOYEES.MODEL.ERRORS.EMAIL_REQUIRED\">Email is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"EMPLOYEES.MODEL.ERRORS.EMAIL_PATTERN\">Must be a valid email address</span></div><div \nng-if=\"vm.formErr[\'email_already_taken\']\"><div class=\"red-text fs-14\"><small \nng-bind-html=\"vm.formErr[\'email_already_taken\']\"></small></div></div><div ng-if=\"vm.formErr[\'EMAIL_ALREADY_IN_USE\']\">\n<div class=\"red-text fs-14\"><small ng-bind-html=\"vm.formErr[\'EMAIL_ALREADY_IN_USE\']\"></small></div></div></div><div \nng-if=\"vm.employee && vm.passwordExpiredAt && vm.hasMultipleEmployeeAccountsFlag\"><div class=\"red-text fs-14\"><small>\n{{ \'EMPLOYEES.DIALOG.ERRORS.TEMP_PASSWORD\' | translate }}</small></div></div></md-input-container></div><div>\n<md-input-container><md-button ng-click=\"vm.generateTempPassword()\" \nng-if=\"vm.employee && vm.passwordExpiredAt && vm.hasMultipleEmployeeAccountsFlag && !vm.employee.inactivatedAt\" \nng-disabled=\"$root.loadingProgress\" class=\"credential-button\" aria-label=\"Renew password\" \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIONS.CHANGE_TEMP_PASSWORD\" \ntranslate=\"EMPLOYEES.DIALOG.ACTIONS.CHANGE_TEMP_PASSWORD\">Renew password</md-button></md-input-container></div><div>\n<md-input-container><md-button ng-click=\"vm.generateCredential()\" \nng-if=\"vm.employee.id && !vm.hasCredential && !vm.employee.inactivatedAt\" ng-disabled=\"$root.loadingProgress\" \nclass=\"credential-button\" aria-label=\"Create credential\" \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIONS.CREATE_CREDENTIALS\" \ntranslate=\"EMPLOYEES.DIALOG.ACTIONS.CREATE_CREDENTIALS\">Create credential</md-button></md-input-container></div></div>\n<div flex=\"100\" layout-xs=\"column\" layout=\"row\" ng-if=\"vm.newEmployee && !vm.hasMultipleEmployeeAccountsFlag\"><div \nflex=\"50\"><md-input-container class=\"md-block mt-0 mb-0\"><label translate=\"EMPLOYEES.MODEL.PASSWORD\">Password</label>\n<input data-cy=\"password-input\" type=\"password\" name=\"password\" class=\"mb-10\" ok-password \nng-model=\"vm.employee.password\" ng-maxlength=\"40\" autocomplete=\"new-password\" required><div \nng-messages=\"employeeForm.password.$error\" ng-show=\"employeeForm.password.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"EMPLOYEES.MODEL.ERRORS.PASSWORD_REQUIRED\">Password is required</span></div><div \nng-message=\"maxlength\"><span translate=\"EMPLOYEES.MODEL.ERRORS.PASSWORD_MAX_LENGTH\">\nPassword must be up to 40 characters</span></div></div><div class=\"hint mt-10\"><span translate=\"EMPLOYEES.DIALOG.HINT\">\nYou must use a strong enough password. The password must contain at least 8 characters and include letters, numbers and symbols\n</span> <span translate=\"EMPLOYEES.DIALOG.FOR_EXAMPLE\">For example:</span> <b>{{ vm.samplePassword }}</b></div>\n</md-input-container><div class=\"strength-meter\"><div class=\"strength-meter-fill\" \ndata-strength=\"{{ passwordStrength }}\"></div></div></div><div flex=\"50\"><md-input-container class=\"md-block mt-0 mb-0\">\n<label translate=\"EMPLOYEES.MODEL.CONFIRM_PASSWORD\">Confirm password</label><input data-cy=\"confirm-password-input\" \nng-model=\"vm.employee.passwordRepeat\" name=\"passwordRepeat\" compare-with=\"vm.employee.password\" type=\"password\" \nrequired><div ng-messages=\"employeeForm.passwordRepeat.$error\" ng-show=\"employeeForm.passwordRepeat.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"EMPLOYEES.MODEL.ERRORS.PASSWORD_REQUIRED\">Password is required\n</span></div><div ng-message=\"compareWith\"><span translate=\"EMPLOYEES.MODEL.ERRORS.PASSWORDS_DIDNT_MATCH\">\nPassword didn\'t match</span></div></div></md-input-container></div></div></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"EMPLOYEES.DIALOG.SKILLS.TITLE\">Skills</span></md-tab-label><md-tab-body><div \nclass=\"plr-24\"><div class=\"section-header mb-10\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"section-title\" translate=\"EMPLOYEES.DIALOG.SKILLS.RESPONSIBILITIES\">Services types carried out</span>\n &nbsp;&nbsp;&nbsp;&nbsp;<md-checkbox class=\"md-primary\" ng-checked=\"vm.selectAll\" ng-click=\"vm.toogleAllServices();\">\n<small translate=\"EMPLOYEES.DIALOG.SKILLS.SELECT_ALL\">Select all</small></md-checkbox></div><div flex=\"100\" \nflex-gt-sm=\"100\" layout=\"column\" class=\"mt-25n\"><div class=\"checkbox-list\"><div layout=\"row\" layout-wrap flex><div \nflex=\"50\" ng-repeat=\"service in vm.services\"><md-checkbox class=\"md-primary\" \nng-checked=\"vm.serviceIsChecked(service.id, vm.employeeSkills)\" \nng-click=\"vm.toggleService(service.id, vm.employeeSkills)\">{{ service.description }}</md-checkbox></div></div></div>\n</div></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"EMPLOYEES.DIALOG.IMAGE.TITLE\">Avatar</span>\n</md-tab-label><md-tab-body><div class=\"plr-24\"><div ngf-drop ngf-select ng-model=\"vm.avatarImage\" \nngf-pattern=\"image/*\" class=\"mt-10 drop-box\"><div><md-icon md-font-icon=\"icon-upload\"></md-icon><br><small><span \ndata-cy=\"image-select-upload\" translate=\"EMPLOYEES.DIALOG.IMAGE.SELECT_OR_DRAG_PHOTO\">\nClick or drag your image to upload</span></small></div></div><div ng-if=\"vm.avatarImage\" \nstyle=\"padding-top: 5px; padding-bottom: 5px\"><small data-cy=\"crop-image-message\"><span \ntranslate=\"EMPLOYEES.DIALOG.IMAGE.CROP_IMAGE\">To crop this image, drag the region below and click the button:</span>\n</small></div><img-crop ng-if=\"vm.avatarImage\" class=\"crop-area-employee\" image=\"vm.avatarImage | ngfDataUrl\" \nresult-image=\"vm.avatarResultImage\"></img-crop></div></md-tab-body></md-tab></md-tabs></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"!vm.newEmployee\" ng-click=\"vm.saveEmployee($event)\" data-cy=\"submit-employee\" \nclass=\"fc-button fc-button--actions\" \nng-disabled=\"employeeForm.$invalid || employeeForm.$pristine || !vm.geoCoderOk || $root.loadingProgress || vm.locationAddressErrors || vm.formErr[\'email_already_taken\'] || vm.formErr[\'EMAIL_ALREADY_IN_USE\']\" \naria-label=\"Save\" translate=\"EMPLOYEES.DIALOG.ACTIONS.SAVE\" translate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIONS.SAVE\">\nSave</md-button><md-button type=\"submit\" ng-if=\"vm.newEmployee\" ng-click=\"vm.saveEmployee($event)\" . \ndata-cy=\"create-employee-button\" class=\"fc-button fc-button--actions\" data-cy=\"submit-employee\" \nng-disabled=\"employeeForm.$invalid || employeeForm.$pristine || !vm.geoCoderOk || $root.loadingProgress || vm.locationAddressErrors\" \naria-label=\"Add Employee\" translate=\"EMPLOYEES.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIONS.CREATE\">Create</md-button></div><div layout=\"row\"><md-button \nng-click=\"vm.selectedTabIndex = 2\" class=\"md-icon-button\" aria-label=\"Upload avatar\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIONS.UPLOAD_AVATAR\"><md-icon md-font-icon=\"icon-picture\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"EMPLOYEES.DIALOG.ACTIONS.UPLOAD_AVATAR\">Upload Avatar</span>\n</md-tooltip></md-button><md-button data-cy=\"inactivate-employee\" \nng-if=\"vm.employee.id && !vm.employee.inactivatedAt && !vm.employee.contract.firedAt\" class=\"md-icon-button\" \nng-click=\"vm.inactivateEmployee($event);\" aria-label=\"Inactivate\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.INACTIVATE.SUBMIT\"><md-icon \nmd-svg-src=\"assets/icons/icon-red-inactivate.svg\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"EMPLOYEES.DIALOG.INACTIVATE.TOOLTIP\">Inactivate</span></md-tooltip></md-button><md-button \ndata-cy=\"activate-employee\" ng-if=\"vm.employee.id && !!vm.employee.inactivatedAt\" class=\"md-icon-button\" \nng-click=\"vm.activateEmployee($event);\" aria-label=\"Activate\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIVATE.SUBMIT\"><md-icon \nmd-svg-src=\"/assets/icons/icon-blue-activate.svg\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"EMPLOYEES.DIALOG.ACTIVATE.TOOLTIP\">activate</span></md-tooltip></md-button><md-button \nng-click=\"vm.fireEmployee($event);\" ng-if=\"vm.employee.id && !vm.employee.contract.firedAt\" \nng-disabled=\"employeeForm.$invalid\" class=\"md-icon-button\" aria-label=\"Fire Employee\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIONS.FIRE_EMPLOYEE\" data-cy=\"fire-employee\"><md-icon \nmd-font-icon=\"icon-account-remove\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"EMPLOYEES.DIALOG.ACTIONS.FIRE_EMPLOYEE\">Fire Employee</span></md-tooltip></md-button><md-button \nng-click=\"vm.rehireEmployee($event);\" ng-if=\"vm.employee.id && vm.employee.contract.firedAt\" \nng-disabled=\"employeeForm.$invalid\" class=\"md-icon-button\" aria-label=\"Rehire Employee\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIONS.REHIRE_EMPLOYEE\" data-cy=\"rehire-employee\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"EMPLOYEES.DIALOG.ACTIONS.REHIRE_EMPLOYEE\">Rehire Employee</span></md-tooltip></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/equipment-types/dialogs/equipment-types-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large form-dialog equipment-type-dialog-content\" \naria-label=\"Equipamentos\"><md-toolbar class=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\" \nlayout=\"row\" layout-align=\"space-between\"><span ng-show=\"!vm.equipmentType.id\" class=\"title__equipment\" \ntranslate=\"EQUIPMENT_TYPES.DIALOG.NEW.TITLE\">New equipment type </span><span ng-show=\"vm.equipmentType.id\" \nclass=\"title__equipment\" translate=\"EQUIPMENT_TYPES.DIALOG.EDIT.TITLE\" \ntranslate-values=\"{ equipmentType: vm.equipmentType.name }\">Edit {{ vm.equipmentType.name }}</span></div><div \nclass=\"sidebar-dialog__header__actions\"><md-button data-cy=\"close-dialog-button\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\"></md-icon>\n</md-button></div></md-toolbar><form name=\"equipmentsForm\" class=\"dialog-form-content p-0\" novalidate>\n<md-dialog-content ms-scroll class=\"pt-0\"><md-tabs md-selected=\"vm.selectedTabIndex\" md-dynamic-height class=\"ml-24n\">\n<md-tab><md-tab-label><span translate=\"EQUIPMENT_TYPES.DIALOG.GENERAL.TITLE\">General</span></md-tab-label><md-tab-body>\n<corporate-customer-disclaimer ng-if=\"vm.equipmentType.metadata && vm.equipmentType.metadata.sammathnaur\" \ncustomer-name=\"vm.equipmentType.metadata.sammathnaur.account.name\"></corporate-customer-disclaimer><div><div \nng-include=\"\'app/main/equipment-types/tabs/general-tab.html\'\"></div></div></md-tab-body></md-tab><md-tab><md-tab-label>\n<span data-cy=\"custon-field-tab\" translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.TITLE\">Custom Fields</span>\n</md-tab-label><md-tab-body><corporate-customer-disclaimer \nng-if=\"vm.equipmentType.metadata && vm.equipmentType.metadata.sammathnaur\" \ncustomer-name=\"vm.equipmentType.metadata.sammathnaur.account.name\"></corporate-customer-disclaimer><div \nng-include=\"\'app/main/equipment-types/tabs/custom-fields-tab.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.accountConfiguration.moduleOrderEquipmentManagementEnabled\"><md-tab-label><span data-cy=\"forms-tab\" \ntranslate=\"EQUIPMENT_TYPES.DIALOG.FORMS.TITLE\">Forms</span></md-tab-label><md-tab-body><corporate-customer-disclaimer \nng-if=\"vm.equipmentType.metadata && vm.equipmentType.metadata.sammathnaur\" \ncustomer-name=\"vm.equipmentType.metadata.sammathnaur.account.name\"></corporate-customer-disclaimer><div \nng-include=\"\'app/main/equipment-types/tabs/forms-tab.html\'\"></div></md-tab-body></md-tab></md-tabs></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button data-cy=\"save-button\" type=\"submit\" ng-if=\"vm.equipmentType.id && !vm.equipmentType.locked\" \nng-click=\"vm.saveEquipmentType(vm.equipmentType, { closeDialog: true })\" class=\"fc-button fc-button--actions\" \nng-disabled=\"equipmentsForm.$invalid || equipmentsForm.$pristine || $root.loadingProgress || customFieldForm.$pristine || vm.equipmentType.locked\" \naria-label=\"Save\" translate=\"EQUIPMENT_TYPES.DIALOG.ACTIONS.SAVE\" \ntranslate-attr-aria-label=\"EQUIPMENT_TYPES.DIALOG.ACTIONS.SAVE\">Save</md-button><md-button data-cy=\"close-button\" \ntype=\"button\" ng-if=\"vm.equipmentType.id && vm.equipmentType.locked\" ng-click=\"vm.closeDialog()\" \nclass=\"fc-button fc-button--actions\" aria-label=\"Save\" translate=\"EQUIPMENT_TYPES.DIALOG.ACTIONS.CLOSE\" \ntranslate-attr-aria-label=\"EQUIPMENT_TYPES.DIALOG.ACTIONS.CLOSE\">Close</md-button><md-button data-cy=\"create-button\" \ntype=\"submit\" ng-if=\"!vm.equipmentType.id\" ng-click=\"vm.saveEquipmentType(vm.equipmentType, { closeDialog: true })\" \nclass=\"fc-button fc-button--actions\" \nng-disabled=\"equipmentsForm.$invalid || equipmentsForm.$pristine || vm.equipmentType.name.length === 0 || $root.loadingProgress\" \naria-label=\"Add equipment type\" translate=\"EQUIPMENT_TYPES.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"EQUIPMENT_TYPES.DIALOG.ACTIONS.CREATE\">Create</md-button></div><div layout=\"row\"><md-button \ndata-cy=\"archive-button\" ng-click=\"vm.archiveEquipmentType($event);\" \nng-if=\"vm.equipmentType.id && !vm.equipmentType.archived\" \nng-disabled=\"equipmentsForm.$invalid || vm.equipmentType.locked\" class=\"md-icon-button\" \naria-label=\"Archive equipment type\" translate translate-attr-aria-label=\"EQUIPMENT_TYPES.DIALOG.ACTIONS.ARCHIVE\">\n<md-icon md-font-icon=\"icon-folder-download\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"EQUIPMENT_TYPES.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button \nng-show=\"vm.equipmentType.id && vm.equipmentType.archived\" class=\"md-icon-button\" \nng-disabled=\"equipmentsForm.$invalid || vm.equipmentType.locked\" ng-click=\"vm.unarchiveEquipmentType($event)\" \naria-label=\"Unarchive Equipment\" translate translate-attr-aria-label=\"EQUIPMENT_TYPES.DIALOG.ACTIONS.UNARCHIVE\">\n<md-icon md-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"EQUIPMENT_TYPES.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/equipment-types/tabs/custom-fields-tab.html","<div class=\"tab-equipment-types\"><div class=\"fc-warning-container fc-warning-container--inside-tab\" \nng-if=\"vm.equipmentType.id && !vm.equipmentType.locked\"><span translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.INFO\">\nBy changing the question or type of response, we will unlink the assigned response from this custom field and all related locations.\n</span></div><div id=\"questions\" class=\"content\" layout=\"row\" flex><md-content class=\"form-question-list-pane\" flex \nms-scroll=\"vm.msScrollOptions\"><div class=\"form-questions sortable\" ng-model=\"vm.equipmentType.customFields\"><div \nclass=\"form-question form-question-{{$index}}\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"question in vm.equipmentType.customFields track by $index\" ng-click=\"vm.setItemFocus($index);\"><div \nclass=\"arrows-orders\" style=\"display: flex; flex-direction: column\"><md-icon md-font-icon=\"icon-arrow-up\" \nclass=\"icon s-20\" ng-if=\"$index >= 1\" ng-class=\"{\'cursor-block\': vm.equipmentType.locked }\" \nng-click=\"vm.equipmentType.locked || vm.reorderQuestions($index, \'up\');\"><md-tooltip md-direction=\"top\" \nng-hide=\"vm.equipmentType.locked\"><div translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.ARROW.UP\">Move up</div>\n</md-tooltip></md-icon><md-icon md-font-icon=\"icon-arrow-down\" class=\"icon mt-15 s-20\" \nng-class=\"{\'cursor-block\': vm.equipmentType.locked }\" ng-if=\"$index < vm.equipmentType.customFields.length - 1\" \nng-click=\"vm.equipmentType.locked || vm.reorderQuestions($index, \'down\');\"><md-tooltip md-direction=\"bottom\" \nng-hide=\"vm.equipmentType.locked\"><div translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.ARROW.DOWN\">Come down</div>\n</md-tooltip></md-icon></div><div layout=\"row\" layout-align=\"start center\" flex><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex><div layout-xs=\"column\" layout=\"row\" class=\"mt-15\"><div \nflex=\"70\"><md-input-container class=\"md-block\"><label translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.FIELD\">Field\n</label><input required maxlength=\"400\" id=\"question__{{$index}}\" name=\"question_{{$index}}\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() :\'\';\" autocomplete=\"off\" class=\"fz-14\" \nng-model=\"question.name\" ng-disabled=\"vm.equipmentType.locked\"><div \nng-messages=\"equipmentsForm[\'question_\'+$index].$error\" ng-show=\"equipmentsForm[\'question_\'+$index].$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"EQUIPMENT_TYPES.MODEL.ERRORS.FIELD_REQUIRED\">Field is required\n</span></div><div ng-message=\"maxlength\"><span translate=\"EQUIPMENT_TYPES.MODEL.ERRORS.NAME_VALID_LENGTH\" \ntranslate-values=\"{ length: 400 }\">Name size is invalid</span></div></div></md-input-container></div><div flex=\"40\">\n<md-input-container class=\"full-width\"><label translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.FIELD_TYPES.TITLE\">\nField type</label><md-select ng-model=\"question.type\" ng-change=\"vm.addDefaultOption(question)\" \nng-disabled=\"vm.equipmentType.locked\"><md-option value=\"question\"><md-icon md-font-icon=\"icon-comment-text\" \nclass=\"s20\"></md-icon><small translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.FIELD_TYPES.LONG_ANSWER\">Long answer\n</small></md-option><md-option value=\"date\"><md-icon md-font-icon=\"icon-calendar\" class=\"s20\"></md-icon><small \ntranslate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.FIELD_TYPES.DATE\">Date</small></md-option><md-option \nvalue=\"multiple-choice\"><md-icon md-font-icon=\"icon-radiobox-marked\" class=\"s20\"></md-icon><small \ntranslate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.FIELD_TYPES.MULTIPLE_CHOICE\">Multiple choice</small></md-option>\n<md-option value=\"number\"><md-icon md-font-icon=\"icon-numeric\" class=\"s20\"></md-icon><small \ntranslate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.FIELD_TYPES.NUMBER\">Numeric</small></md-option></md-select>\n</md-input-container></div><div flex=\"5\"><md-icon ng-class=\"{\'clickable\': !vm.equipmentType.locked }\" \nng-click=\"vm.equipmentType.locked || vm.removeQuestion($index);\" md-font-icon=\"icon-delete\"><md-tooltip \nng-hide=\"vm.equipmentType.locked\"><span translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.FIELD_TYPES.REMOVE\">\nRemove field</span></md-tooltip></md-icon></div></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"grey-800-fg fs-13 mt-27n\"><md-switch ng-disabled=\"vm.equipmentType.locked\" ng-model=\"question.required\" \nclass=\"fs-13 mt-2 mb-7\"><span translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.REQUIRED_ANSWER\" \nng-if=\"question.required\">Required answer</span> <span \ntranslate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.OPTIONAL_ANSWER\" ng-if=\"!question.required\">Answer not required</span>\n</md-switch></div><div class=\"title\" \nng-if=\"(question.type === \'multiple-choice\') && (!question.options || question.options.length <= 0)\"><p \nclass=\"text-center\"><small class=\"red-text\" translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.ALTERNATIVE_NEEDED\">\nAt least one alternative answer is required</small></p></div><div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"question.type === \'multiple-choice\'\" flex><div class=\"form-questions sortable full-width\" \nui-sortable=\"vm.optionsSortableOptions\" ng-model=\"question.options\"><div class=\"form-question-option\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"option in question.options track by $index\"><div \nng-class=\"{\'cursor-block\': vm.equipmentType.locked }\" class=\"handle-options\" \nng-click=\"vm.equipmentType.locked || vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" \nclass=\"icon\"><md-tooltip hide=\"vm.equipmentType.locked\"><span \ntranslate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.CHANGE_ORDER\">Drag to change the order of the alternative</span>\n</md-tooltip></md-icon></div><div layout=\"row\" layout-align=\"start start\" flex><div class=\"info\" \nlayout-align=\"start start\" flex><div class=\"title\" layout=\"row\" flex><md-radio-group><md-radio-button \nclass=\"radio-button-fix\" disabled=\"disabled\"></md-radio-button></md-radio-group><input type=\"text\" maxlength=\"200\" \nplaceholder=\"Alternative answer text...\" translate \ntranslate-attr-placeholder=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.ALTERNATIVE_TEXT\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() : \'\'\" ng-disabled=\"vm.equipmentType.locked\" \nng-model=\"option.value\" autocomplete=\"off\" ng-model-option=\"{ debounce: 1000 }\" class=\"option-value\"></div></div></div>\n<div class=\"buttons\" layout=\"row\" layout-align=\"start center\" ng-if=\"question.options.length > 1\"><md-icon \nng-class=\"{\'clickable\': !vm.equipmentType.locked }\" \nng-click=\"vm.equipmentType.locked || vm.removeOption(question, $index);\" md-font-icon=\"icon-close\"><md-tooltip \nng-hide=\"vm.equipmentType.locked\"><span translate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.REMOVE_ALTERNATIVE\">\nRemove alternative answer</span></md-tooltip></md-icon></div></div><div class=\"form-question add-option-row\" \nng-hide=\"vm.equipmentType.locked\" ng-class=\"{\'link-disabled\': vm.equipmentType.locked }\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex><div \nclass=\"title\"><md-radio-group class=\"add-option-fake-input\"><md-radio-button class=\"radio-button-fix\" \ndisabled=\"disabled\"></md-radio-button></md-radio-group><span class=\"add-option\" \ntranslate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.ADD_QUESTION\" \nng-click=\"vm.equipmentType.locked || vm.addOption(question, $parent.$index, question.options);\">Add new answer option\n</span></div></div></div></div></div></div></div></div></div></div></div><div class=\"form-question bb-none\" \nlayout=\"row\" layout-align=\"start center\" ng-hide=\"vm.equipmentType.locked\"><div layout=\"row\" \nlayout-align=\"center center\" flex><span class=\"add-question\" \ntranslate=\"EQUIPMENT_TYPES.DIALOG.CUSTOM_FIELDS.FIELD_TYPES.ADD\" \nng-click=\"vm.equipmentType.locked || vm.addQuestion() || vm.setFormDirty();\">Add more one field</span></div></div>\n</div></md-content></div></div>");
$templateCache.put("app/main/equipment-types/tabs/forms-tab.html","<div class=\"tab-equipment-types-forms tab-equipment-types\"><div layout-xs=\"column\" layout=\"row\" class=\"fs-14 mt-10n\">\n<md-input-container class=\"md-block\" ng-hide=\"vm.equipmentType.locked\"><span class=\"text-gray small\" \ntranslate=\"EQUIPMENT_TYPES.DIALOG.FORMS.ADD\">Add form</span><label translate=\"EQUIPMENT_TYPES.DIALOG.FORMS.SEARCH\">\nSearch form ...</label><md-select ng-disabled=\"vm.forms.length === 0\" ng-model=\"vm.selectedFormId\" class=\"text-gray\" \nng-change=\"vm.addForm(vm.selectedFormId);\"><md-select-header class=\"header-services\"><input size=\"50\" type=\"text\" \nautocomplete=\"off\" translate translate-attr-placeholder=\"EQUIPMENT_TYPES.DIALOG.FORMS.SEARCH\" \nonkeydown=\"event.stopPropagation()\" ng-model=\"vm.formSearchTerm\" ng-model-options=\"{ debounce: 1000 }\" \nng-change=\"vm.searchForm()\"></md-select-header><md-option ng-repeat=\"form in vm.forms \" value=\"{{form.id}}\">\n{{form.name}}</md-option><md-option ng-if=\"vm.forms.length === 0\" value=\"-1\"><span \ntranslate=\"EQUIPMENT_TYPES.DIALOG.FORMS.ALL_FORMS_ADDED\">All forms are already added</span></md-option></md-select>\n</md-input-container></div><p class=\"fs-14 color-grey\" ng-if=\"!vm.equipmentType.forms.length\"><span \ntranslate=\"EQUIPMENT_TYPES.DIALOG.FORMS.EMPTY\">No forms added for equipment type</span></p><div \nclass=\"container-teste\"><div layout=\"column\" layout-gt-xs=\"row\"><md-list flex=\"100\"><md-list-item \nclass=\"form-list__row\" layout=\"row\"><p flex=\"100\" class=\"text-gray\" translate=\"SERVICES.DIALOG.FORMS.LINKED_FORMS\">\nLinked forms</p><div class=\"icons-header\" flex=\"25\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"s22 color-green\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"EQUIPMENT_TYPES.DIALOG.FORMS.REQUIRED_TO_COMPLETE\">Required to complete visit</span></md-tooltip></md-icon>\n<md-icon md-font-icon=\"icon-alert\" class=\"s22 color-red\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"EQUIPMENT_TYPES.DIALOG.FORMS.REQUIRED_TO_IMPEDIMENT\">Required to record impediment</span></md-tooltip>\n</md-icon></div></md-list-item><md-list-item ng-repeat=\"form in vm.equipmentType.forms track by $index\" \nclass=\"form-list__row\" layout=\"row\"><div flex=\"100\" style=\"display: flex\"><md-button \nng-disabled=\"vm.equipmentType.locked\" class=\"md-icon-button\" ng-click=\"vm.deleteForm(form)\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s22\"></md-icon><md-tooltip md-direction=\"bottom\" ng-hide=\"vm.equipmentType.locked\">\n<span translate=\"EQUIPMENT_TYPES.DIALOG.FORMS.REMOVE\">Remove form</span></md-tooltip></md-button><div \nclass=\"form-name\" title=\"{{ form.name }}\">{{ form.name }}</div><small class=\"questions-count fs-12\" \nng-if=\"!vm.equipmentType.id\" translate=\"EQUIPMENT_TYPES.DIALOG.FORMS.QUESTIONS_QTY\" \ntranslate-values=\"{ questionsQty: form && form.questionsCount ? form.questionsCount : 0 }\">\n({{ form && form.questionsCount ? form.questionsCount : 0 }} questions) </small><small \nng-if=\"vm.equipmentType.id && form.questionsCount\" class=\"questions-count fs-12\" \ntranslate=\"EQUIPMENT_TYPES.DIALOG.FORMS.QUESTIONS_QTY\" translate-values=\"{ questionsQty: form.questionsCount }\">\n({{form.questionsCount}} questions)</small></div><div layout=\"row\" layout-align=\"center\" flex=\"20\"><md-input-container \nng-class=\"{\'service-error\': form.error.allServices || form.error.sameService}\" class=\"container-service-type\"><label \ntranslate=\"EQUIPMENT_TYPES.DIALOG.FORMS.SERVICE.LABEL\">OS type</label><md-icon \nng-if=\"form.error.allServices || form.error.sameService\" md-svg-src=\"assets/icons/icon-service-error.svg\"><md-tooltip \nmd-direction=\"bottom\"><span ng-if=\"form.error.sameService\" \ntranslate=\"EQUIPMENT_TYPES.DIALOG.FORMS.SERVICE.ERROR.SAME_SERVICE\">\nYou cannot select the same type of activity for two identical forms.</span> <span ng-if=\"form.error.allServices\" \ntranslate=\"EQUIPMENT_TYPES.DIALOG.FORMS.SERVICE.ERROR.ALL_SERVICES\">\nIt is not possible to select all OS types for the same form.</span></md-tooltip></md-icon><md-select \nng-disabled=\"vm.equipmentType.locked\" class=\"select-service\" ng-model=\"form.service.id\" \nng-change=\"vm.validateServiceSelect(form)\" \nplaceholder=\"{{ \'EQUIPMENT_TYPES.DIALOG.FORMS.SERVICE.PLACEHOLDER\' | translate }}\"><md-select-header \nclass=\"header-services\"><input size=\"50\" type=\"text\" autocomplete=\"off\" translate \ntranslate-attr-placeholder=\"EQUIPMENT_TYPES.DIALOG.FORMS.SERVICE.SEARCH\" onkeydown=\"event.stopPropagation()\" \nng-model=\"vm.serviceSearchTerm\" ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.searchServices()\">\n</md-select-header><md-option value=\"null\" translate=\"EQUIPMENT_TYPES.DIALOG.FORMS.SERVICE.ALL\">All</md-option>\n<md-option ng-repeat=\"service in vm.services\" value=\"{{ service.id }}\">\n{{ (service.description && service.description.length) > 64 ? service.description.substring(0, 64) + \'...\' : service.description }}\n</md-option></md-select></md-input-container></div><div flex=\"2\" layout=\"row\" class=\"switches\"><md-switch \nng-disabled=\"vm.equipmentType.locked\" ng-model=\"form.required.complete\"></md-switch><md-switch \nng-disabled=\"vm.equipmentType.locked\" ng-model=\"form.required.report\"></md-switch></div></md-list-item></md-list></div>\n</div></div>");
$templateCache.put("app/main/equipment-types/tabs/general-tab.html","<div class=\"tab-equipment-types\"><div layout-xs=\"column\" layout=\"row\" class=\"mb-25n\"><div flex=\"100\"><div \nclass=\"flex-100 input-name\"><fc-smart-rewrite reference-id=\"vm.equipmentType.id || vm.sessionId\" \nreference-type=\"equipment-type-name\" class=\"flex-100\" disabled=\"vm.equipmentType.locked\"><fc-textarea \nis-disabled=\"vm.equipmentType.locked\" data-cy=\"equipment-type-name-textarea\" \nlabel=\"{{ \'EQUIPMENT_TYPES.MODEL.NAME\' | translate }}\" ng-model=\"vm.equipmentType.name\" \ndata-cy=\"tasks-description-textarea\" max-length=\"150\" input-name=\"name\" input-control=\"equipmentsForm.name\" \nerrors-to-watch=\"[\n              {\n                name: \'maxlength\',\n                translate: \'EQUIPMENT_TYPES.MODEL.ERRORS.NAME_VALID_LENGTH\',\n                translateValues: { expectedLength: 150, receivedLength: equipmentsForm.name.$viewValue.length }\n              },\n            ]\">\n</fc-smart-rewrite><span ng-show=\"equipmentsForm.name.$touched\" ng-if=\"vm.equipmentType.name.length === 0\" \nclass=\"input-name__required-message\" translate=\"EQUIPMENT_TYPES.MODEL.ERRORS.NAME_REQUIRED\">Name is required</span>\n</div></div></div><div ng-if=\"vm.hasKnowledgeBaseFeatureFlag\"><div><span \nclass=\"tab-equipment-types__configurations-title\" translate=\"EQUIPMENT_TYPES.MODEL.CONFIGURATIONS\"></span><md-switch \nng-model=\"vm.equipmentType.showKnowledgeBase\" ng-change=\"vm.changeShowKnowledgeBase()\"><span \ntranslate=\"EQUIPMENT_TYPES.MODEL.SHOW_KNOWLEDGE_BASE\" class=\"tab-equipment-types__knowledge-base-switch-label\">\nif enabled, the knowledge base related to this activity will be displayed.</span></md-switch></div><div \nng-if=\"vm.equipmentType.showKnowledgeBase\" flex=\"100\" class=\"fc-input\"><fc-select \nlabel=\"{{(\'EQUIPMENT_TYPES.MODEL.KNOWLEDGE_BASE\' | translate)}}\" ng-model=\"vm.equipmentType.knowledgeBase\" \noptions=\"vm.knowledgeBasesOptions\" track-by=\"name\" with-search=\"true\" \nsearch-phrase=\"{{(\'EQUIPMENT_TYPES.MODEL.SEARCH\' | translate)}}\" is-required=\"true\"></fc-select></div></div></div>");
$templateCache.put("app/main/equipments/dialogs/equipments-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large equipment-dialog fixed-position\" aria-label=\"Equipamentos\">\n<md-toolbar class=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><md-menu \nclass=\"equipment-dialog__labels\"><md-button class=\"md-icon-button\" aria-label=\"Label\" \nng-click=\"vm.labelTabIndex = 0; $mdMenu.open($event)\" translate \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.TITLE\"><md-icon md-menu-origin \nmd-font-icon=\"icon-label-outline\"><md-tooltip md-direction=\"bottom\" ng-if=\"vm.labels.length\"><span \ntranslate=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.MANAGE\">Manage labels</span></md-tooltip><md-tooltip \nmd-direction=\"bottom\" ng-if=\"!vm.labels.length && !vm.hasLabelsPermission\"><span \ntranslate=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.NO_REGISTERED\">\nNo registered labels, only administrators can register labels.</span></md-tooltip></md-icon></md-button>\n<md-menu-content class=\"labels-menu-content\" width=\"4\" ms-scroll ng-show=\"vm.labels.length || vm.hasLabelsPermission\">\n<md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height><md-tab><md-tab-body><md-menu-item ng-if=\"vm.labels.length\">\n<md-input-container class=\"no-errors-spacer\" md-no-float><input type=\"text\" placeholder=\"Search tags ..\" \nng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate \ntranslate-attr-placeholder=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.PLACEHOLDER\"></md-input-container></md-menu-item>\n<md-menu-item ng-if=\"vm.labels.length\" class=\"label\" ng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button\n class=\"label-toggle-button\" md-prevent-menu-close ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label)\" aria-label=\"Toggle Label\" translate \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.TOGGLE\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{ label.name }}</span> <i ng-if=\"label.isLinked\" \nclass=\"icon-check s16\"></i></div></md-button><md-button ng-if=\"vm.hasLabelsPermission\" \nclass=\"md-icon-button label-edit-button\" md-prevent-menu-close ng-click=\"vm.editLabel(label);\" aria-label=\"Edit Label\" \ntranslate translate-attr-aria-label=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.EDIT\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16\"></md-icon></md-button></md-menu-item><small class=\"counter-labels\" \ntranslate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.LIMIT_COUNT\" \ntranslate-values=\"{ length: vm.labels.length, limit: vm.labelsLimit }\" data-cy=\"quotations-label-counter\">\n{{ vm.labels.length }} of {{ vm.labelsLimit }} labels</small><md-menu-divider \nng-if=\"vm.labels.length && vm.hasLabelsPermission\"></md-menu-divider><md-menu-item ng-if=\"vm.hasLabelsPermission\">\n<md-button class=\"add-label-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 1\" \nng-disabled=\"vm.labels.length >= vm.labelsLimit\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span \ntranslate=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.ADD\"><md-tooltip md-direction=\"right\" \nng-show=\"vm.labels.length >= vm.labelsLimit\"><span translate=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.LIMIT_EXCEEDED\">\nMaximum tag limit has been exceeded.</span></md-tooltip>Create new label</span></md-button></md-menu-item>\n</md-tab-body></md-tab><md-tab><md-tab-body><div class=\"add-label-tab-content\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close \nng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span\n flex translate=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.ADD\">Create Label</span></div><div class=\"content\" layout=\"column\" \nlayout-align=\"start stretch\"><form name=\"addLabelForm\" novalidate layout=\"column\"><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.newLabelName\" \nmaxlength=\"20\" required translate translate-attr-placeholder=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.NAME\">\n</md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap><label class=\"color\" \nng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{ \'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1) }\" \nlayout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" \nng-value=\"palette\" aria-label=\"{{ palette }}\"> <i class=\"icon-check s18\" ng-if=\"vm.newLabelColor === palette\"></i>\n</label></div><md-button class=\"create-button md-accent md-raised\" md-prevent-menu-close \nng-click=\"vm.addNewLabel({ color:vm.newLabelColor, name: vm.newLabelName });\" \nng-disabled=\"!vm.newLabelColor || !vm.newLabelName\" aria-label=\"Create\" translate \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.CREATE_BUTTON\"><span \ntranslate=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.CREATE_BUTTON\">Create</span></md-button></form></div></div></md-tab-body>\n</md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close \nng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span\n flex translate=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.EDIT_LABEL\">Edit Label</span></div><div class=\"content\" \nlayout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float><input \nplaceholder=\"Label Name\" type=\"text\" ng-model=\"vm.editingLabel.name\" translate \ntranslate-attr-placeholder=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.NAME\"></md-input-container><div \nclass=\"label-color-picker\" layout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{ \'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1) }\" \nlayout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.editingLabel.color\" \nng-value=\"palette\" aria-label=\"{{ palette }}\"> <i ng-if=\"vm.editingLabel.color === palette\" class=\"icon-check s18\"></i>\n</label></div><md-button class=\"create-button md-accent md-raised\" md-prevent-menu-close aria-label=\"Update\" translate \nng-click=\"vm.updateLabel(vm.editingLabel);\" ng-disabled=\"!vm.editingLabel.name || !vm.editingLabel.color\" \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.EDIT\"><span \ntranslate=\"EQUIPMENTS.DIALOG.EQUIPMENT.LABEL.EDIT\">Update</span></md-button><div layout=\"row\" \nlayout-align=\"end center\" flex></div></div></div></md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><span \nng-show=\"!vm.equipment.id\" class=\"title\" translate=\"EQUIPMENTS.DIALOG.NEW.TITLE\">New equipment</span> <span \nng-show=\"vm.equipment.id\" class=\"title\" translate=\"EQUIPMENTS.DIALOG.EDIT.TITLE\">Edit equipments</span></div><div \nclass=\"sidebar-dialog__actions\"><md-button data-cy=\"close-dialog-button\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><form name=\"equipmentsForm\" class=\"md-inline-form\" novalidate><md-dialog-content class=\"pt-0\" \nstyle=\"padding: 0 !important\" ms-scroll><md-tabs md-selected=\"vm.selectedTabIndex\" md-dynamic-height id=\"equipmentTab\">\n<md-tab md-on-select=\"vm.checkRequiredCustomFields()\"><md-tab-label><span translate=\"EQUIPMENTS.DIALOG.GENERAL.TITLE\">\nGeneral</span><md-icon ng-if=\"vm.selectedTabIndex !== 0 && vm.generalIsInvalid\" class=\"invalid-form-badge\" \nmd-svg-src=\"assets/icons/icon-warning-alert.svg\"></md-icon></md-tab-label><md-tab-body><ng-container \nclass=\"equipments-dialog__general-tab\"><banner-component-provider icon=\"creation\" badge=\"Novo\" \ntext=\"{{ \'EQUIPMENTS.DIALOG.GENERAL.HINT\' | translate }}\"></banner-component-provider><info-component-provider \ntext=\"{{ \'EQUIPMENTS.DIALOG.GENERAL.INFO\' | translate }}\"></info-component-provider><main \nclass=\"equipments-dialog__general-tab__main-container\"><div class=\"sidebar-dialog__input-group\" layout=\"column\"><div \nclass=\"image-container\"><div><fc-image-input height=\"120px\" width=\"120px\" class=\"image-input\" id=\"image-input\" \nname=\"image\" ngf-accept=\"\'.jpg,.png,.jpeg\'\" ng-model=\"vm.equipment.imageUrl\" image-file=\"vm.equipmentImage\" \nname=\"image\" input-control=\"equipmentsForm.image\"></fc-image-input></div><div class=\"insert-picture\"><md-button \ndata-cy=\"insert-picture-button\" class=\"insert-picture-button\" ng-disabled=\"vm.equipmentImage || vm.equipment.imageUrl\" \nng-click=\"vm.selectImage()\" translate=\"EQUIPMENTS.DIALOG.GENERAL.SELECT_IMAGES\">Selecionar imagens</md-button><p \nclass=\"customer-dialog__general-tab__avatar-description ml-20\">\n{{(\'EQUIPMENTS.DIALOG.GENERAL.PHOTO_RULES\' | translate)}}</p></div></div><fc-autocomplete name=\"customer\" \nis-required=\"true\" label=\"{{ \'EQUIPMENTS.MODEL.CUSTOMER\' | translate }}\" options=\"vm.customers\" \nng-model=\"vm.equipment.customer\" ng-change=\"vm.selectedCustomerChanged()\" input-name=\"customer\" \nng-class=\"{\n                      invalid: inputControl.$touched && inputControl.$invalid\n                    }\" \ninput-control=\"equipmentsForm.customer\" search-function=\"vm.searchCustomerByName()\" \nsearch-term=\"vm.searchCustomerText\" track-by=\"name\" debounce=\"600\" \nerrors-to-watch=\"[{\n                      name: \'required\',\n                      translate: \'EQUIPMENTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                    }, {\n                      name: \'create-equipment-disabled-by-corporate-valid\',\n                      translate: \'EQUIPMENTS.MODEL.ERRORS.DISABLED_CREATE_EQUIPMENT_CORPORATE\',\n                      translateValues: { customerAccountName: vm.customerAccountName(equipmentsForm.customer.$modelValue.metadata) }\n                    }, {\n                      name: \'equipment-management-module-required-valid\',\n                      translate: \'EQUIPMENTS.MODEL.ERRORS.DISABLED_CREATE_EQUIPMENT\'\n                    }]\">\n</fc-autocomplete><fc-autocomplete is-required=\"true\" label=\"{{ \'EQUIPMENTS.MODEL.LOCATION\' | translate }}\" \noptions=\"vm.customerLocations\" ng-model=\"vm.equipment.location\" input-name=\"customerLocation\" \ninput-control=\"equipmentsForm.customerLocation\" search-term=\"vm.searchCustomerLocationText\" track-by=\"name\" \ndebounce=\"800\" search-function=\"vm.searchCustomerLocationByName()\" ng-change=\"vm.selectedCustomerLocationChanged()\" \ntrack-by=\"name\" \nerrors-to-watch=\"[{\n                      name: \'required\',\n                      translate: \'EQUIPMENTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                    }]\" \ndata-cy=\"equipment-location\"></fc-autocomplete><small ng-if=\"vm.hasNoLocations\" role=\"alert\"><span \ntranslate=\"EQUIPMENTS.MODEL.ERRORS.NO_LOCATIONS.TEXT\">This customer don\'t have locations yet. </span><a \nng-click=\"vm.createFirstCustomerLocation()\" translate=\"EQUIPMENTS.MODEL.ERRORS.NO_LOCATIONS.LINK\">\nClick here to create a location on:</a><br><span>{{ vm.equipment.address.formattedAddress }}</span></small><div \nclass=\"sidebar-dialog__input-group\" layout=\"column\" flex=\"85\"><div class=\"sidebar-dialog__input-group\" layout=\"row\" \nlayout-xs=\"column\" flex=\"50\"><div flex=\"100\" class=\"fc-input\"><fc-select \nis-disabled=\"!vm.equipment.location || vm.locationSector\" label=\"{{ \'EQUIPMENTS.MODEL.SECTOR\' | translate }}\" \nng-model=\"vm.equipment.locationSector\" options=\"vm.locationSectors\" input-name=\"locationSectorId\" has-arrow=\"true\" \ninput-control=\"equipmentsForm.locationSectorId\" track-by=\"name\" with-search=\"true\" \nsearch-phrase=\"{{(\'EQUIPMENTS.MODEL.SEARCH_BY_SECTOR\' | translate)}}\" \nng-change=\"vm.selectedLocationSectorChanged(vm.equipment.locationSector)\"></fc-select></div><div flex=\"100\" \nclass=\"fc-input\"><fc-select is-disabled=\"!vm.equipment.locationSector || vm.locationEnvironment\" \nlabel=\"{{ \'EQUIPMENTS.MODEL.ENVIRONMENT\' | translate }}\" ng-model=\"vm.equipment.locationEnvironment\" \noptions=\"vm.locationEnvironments\" input-name=\"locationEnvironmentId\" has-arrow=\"true\" \ninput-control=\"equipmentsForm.locationEnvironmentId\" track-by=\"name\" with-search=\"true\" \nsearch-phrase=\"{{(\'EQUIPMENTS.MODEL.SEARCH_BY_ENVIRONMENT\' | translate)}}\"></fc-select></div></div><div \nclass=\"sidebar-dialog__input-group\" layout=\"row\" layout-xs=\"column\" flex=\"50\"><div flex=\"100\" class=\"fc-input\"><input \nrequired class=\"fc-input__input\" placeholder=\" \" name=\"number\" placeholder=\" \" ng-maxlength=\"100\" autocomplete=\"off\" \nng-model=\"vm.equipment.number\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.verifyDuplicatedEquipmentNumber()\" \nng-class=\"{\n                            invalid: equipmentsForm.number.$touched && equipmentsForm.number.$invalid\n                          }\" \ndata-cy=\"equipment-number\"><label class=\"fc-input__label\" translate=\"EQUIPMENTS.MODEL.NUMBER\">Number</label><fc-error \ndata-cy=\"equipments-number-required\" ng-show=\"equipmentsForm.number.$touched || equipmentsForm.number.length\" \ninput-errors=\"equipmentsForm.number.$error\" \nerrors-to-watch=\"[{\n                            name: \'duplicated\',\n                            translate: \'EQUIPMENTS.MODEL.ERRORS.DUPLICATED_NUMBER\'\n                          },\n                          {\n                            name: \'required\',\n                            translate: \'EQUIPMENTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                          },\n                          {\n                            name: \'maxlength\',\n                            translate: \'EQUIPMENTS.MODEL.ERRORS.MAX_LENGTH_NUMBER\'\n                          },\n                          {\n                            name: \'duplicatedArchived\',\n                            translate: \'EQUIPMENTS.MODEL.ERRORS.DUPLICATED_NUMBER_ARCHIVED\'\n                          }]\">\n</fc-error></div><div flex=\"100\" class=\"fc-input\"><fc-select is-required=\"true\" \nlabel=\"{{ \'EQUIPMENTS.MODEL.EQUIPMENT_TYPE\' | translate }}\" ng-model=\"vm.equipment.type\" \noptions=\"vm.equipmentsTypesToShow\" input-name=\"equipmentTypeId\" has-arrow=\"true\" \ninput-control=\"equipmentsForm.equipmentTypeId\" ng-change=\"vm.onChangeEquipmentType(value)\" track-by=\"name\" \nwith-search=\"true\" search-phrase=\"{{(\'EQUIPMENTS.MODEL.EQUIPMENT_TYPE\' | translate)}}\" data-cy=\"equipment-type\">\n</fc-select><fc-error class=\"type-error\" data-cy=\"equipments-type-required\" \nng-show=\"equipmentsForm.equipmentTypeId.$touched && !vm.equipment.type\" \ninput-errors=\"equipmentsForm.equipmentTypeId.$error\" \nerrors-to-watch=\"[{\n                            name: \'required\',\n                            translate: \'EQUIPMENTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                          }]\">\n</fc-error></div></div><div class=\"sidebar-dialog__input-group\" layout=\"row\" layout-xs=\"column\" flex=\"50\"><div \nflex=\"100\" class=\"fc-input\"><input class=\"fc-input__input\" id=\"name\" name=\"name\" placeholder=\" \" autocomplete=\"off\" \nrequired ng-model=\"vm.equipment.name\" ng-maxlength=\"70\" \nerrors-to-watch=\"{\n                            name: \'required\',\n                            translate: \'EQUIPMENTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                          }\" \nng-class=\"{\n                            invalid: equipmentsForm.name.$touched && equipmentsForm.name.$invalid\n                          }\" \ndata-cy=\"equipment-name\"><label class=\"fc-input__label\" translate=\"EQUIPMENTS.MODEL.NAME\">Name</label><fc-error \ndata-cy=\"equiments-name-required\" ng-show=\"equipmentsForm.name.$touched\" input-control=\"equipmentsForm.name\" \ninput-errors=\"equipmentsForm.name.$error\" max-length=\"70\" \nerrors-to-watch=\"[{\n                            name: \'maxlength\',\n                            translate: \'EQUIPMENTS.MODEL.ERRORS.NAME_INVALID_LENGTH\',\n                            translateValues: { expectedLength: 70, receivedLength: equipmentsForm.name.$viewValue.length }\n                          },\n                          {\n                          name: \'required\',\n                          translate: \'EQUIPMENTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                          }]\">\n</fc-error></div><div flex=\"100\" class=\"fc-input\"><md-button class=\"fc-input__input qrcode-container\" id=\"qrCode\" \nname=\"qrCode\" ng-model=\"vm.equipment.qrCode\" ng-click=\"!vm.equipment.qrCode ? vm.generateQRCode() : vm.viewQRCode()\" \nng-required=\"vm.isQRCodeRequired\"><div class=\"\"><md-button ng-show=\"!vm.equipment.qrCode\" \nclass=\"md-icon-button md-accent qrcode__button-center\" aria-label=\"Generate QR code\" \ntranslate-attr-aria-label=\"EQUIPMENTS.MODEL.QR_CODE.GENERATE\" data-cy=\"equipment-qr-code-button\"><md-icon \nmd-font-icon=\"icon-qrcode\" class=\"fs-18\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"EQUIPMENTS.MODEL.QR_CODE.GENERATE\">Generate QR code</span></md-tooltip></md-button><md-button \nng-show=\"vm.equipment.qrCode\" class=\"md-icon-button md-accent qrcode__button-center\" aria-label=\"Show QR code\" \ntranslate-attr-aria-label=\"EQUIPMENTS.MODEL.QR_CODE.DOWNLOAD_LINK_MESSAGE\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"fs-18\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"EQUIPMENTS.MODEL.QR_CODE.DOWNLOAD_LINK_MESSAGE\">Show QR code</span></md-tooltip></md-button></div><span \ntranslate=\"{{ !vm.equipment.qrCode ? (vm.isQRCodeRequired || vm.account.configuration.equipmentsQRCodeRequired ? \'EQUIPMENTS.DIALOG.QRCODE.GENERATE_QRCODE_MANDATORY\' : \'EQUIPMENTS.DIALOG.QRCODE.GENERATE_QRCODE\') : \'EQUIPMENTS.DIALOG.QRCODE.VIEW_QRCODE\' }}\">\n</span> <a id=\"equipmentDownloadLink\" class=\"download-link\" ng-click=\"vm.downloadQRCode();\" \ndownload=\"equipamento-{{ vm.equipment.qrCode }}.png\">Download</a><qrcode ng-if=\"!vm.hasPublicQRCodeFeatureFlag\" \nid=\"equipment-qrcode-download\" class=\"download-link\" version=\"6\" error-correction-level=\"M\" ] size=\"250\" \ndata=\"{{ vm.equipment.qrCode }}\"></qrcode><qrcode ng-if=\"vm.hasPublicQRCodeFeatureFlag\" id=\"equipment-qrcode-download\" \nclass=\"download-link\" version=\"6\" error-correction-level=\"M\" size=\"250\" \ndata=\"{{ \'https://app.fieldcontrol.com.br/qrcode-publico/#/\' + vm.equipment.qrCode }}\"></qrcode></md-button></div>\n</div></div><fc-smart-rewrite reference-id=\"vm.equipment.id || vm.sessionId\" reference-type=\"equipment-notes\" \nclass=\"flex-100\"><fc-textarea no-animation=\"true\" label=\"{{ \'EQUIPMENTS.DIALOG.GENERAL.NOTES\' | translate }}\" \nng-model=\"vm.equipment.notes\" input-name=\"notes\" input-control=\"equipmentsForm.notes\" max-length=\"500\" \nerrors-to-watch=\"[\n                      {\n                        name: \'maxlength\',\n                        translate: \'EQUIPMENTS.MODEL.ERRORS.NOTES_MAX_LENGTH\',\n                        translateValues: { expectedLength: 500, receivedLength: equipmentsForm.notes.$viewValue.length }\n                      }\n                    ]\" \ndata-cy=\"equipment-notes\"></fc-smart-rewrite></div><div><span ng-repeat=\"label in vm.equipment.labels\"><span \nclass=\"status-label equipment-dialog__labels__label-span\" ng-class=\"\'md-\' + label.color +\'-bg\'\">{{ label.name }}\n<md-icon class=\"equipment-dialog__labels__remove-label-icon\" ng-if=\"vm.hasLabelsPermission\" md-font-icon=\"icon-close\" \nng-click=\"vm.toggleInArray(label)\"></md-icon></span></span></div></main></ng-container></md-tab-body></md-tab><md-tab \nng-if=\"vm.accountConfiguration.featureWarrantiesTemplatesEnabledByCMMS\" \nmd-on-select=\"vm.validateRequiredGeneralFields()\"><md-tab-label><span data-cy=\"warranties-tab\" \ntranslate=\"EQUIPMENTS.DIALOG.WARRANTIES.TITLE\">Warranties</span><md-icon \nng-if=\"vm.selectedTabIndex !== 1 && vm.customFieldIsInvalid\" class=\"invalid-form-badge\" \nmd-svg-src=\"assets/icons/icon-warning-alert.svg\"></md-icon></md-tab-label><md-tab-body>\n<equipments-warranties-tab-provider ng-attr-equipment=\"{{ vm.equipment }}\"></equipments-warranties-tab-provider>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.validateRequiredGeneralFields()\" class=\"custom-fields-tab\">\n<md-tab-label><span data-cy=\"custom-fields-tab\" translate=\"EQUIPMENTS.DIALOG.CUSTOM_FIELDS.TITLE\">Custom Fields</span>\n<md-icon ng-if=\"vm.selectedTabIndex !== 1 && vm.customFieldIsInvalid\" class=\"invalid-form-badge\" \nmd-svg-src=\"assets/icons/icon-warning-alert.svg\"></md-icon></md-tab-label><md-tab-body><div \nclass=\"sidebar-dialog__hint\"><div class=\"equipment-hint\"><md-icon md-font-icon=\"icon-alert-circle\"></md-icon><span \ntranslate=\"EQUIPMENTS.DIALOG.CUSTOM_FIELDS.HINT\">The <strong>custom</strong>\n fields are configured in the type of equipment and serve to standardize the registration of information.</span></div>\n</div><div class=\"custom-field\" layout=\"row\" layout-xs=\"column\" \nng-repeat=\"customField in vm.customFieldEquipmentType | orderBy: \'position\' track by $index\"><div class=\"fc-input\" \nflex=\"100\" ng-if=\"customField.type === \'multiple-choice\'\"><p>{{customField.name}}</p><fc-select \nis-required=\"customField.required\" id=\"{{ customField.id }}\" input-name=\"option_{{ $index }}\" \ninput-control=\"equipmentsForm[\'option_\' + $index]\" \nlabel=\"{{ \'EQUIPMENTS.DIALOG.CUSTOM_FIELDS.LABEL_SELECT\' | translate }}\" ng-model=\"customField.answer\" \nng-change=\"vm.checkRequiredCustomFields()\" placeholder=\"{{ customField.name }}\" options=\"customField.options\" \ndata-cy=\"equipment-custom-field-option\" \nerrors-to-watch=\"[\n                    {\n                      name: \'required\',\n                      translate: \'EQUIPMENTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                    }\n                  ]\">\n</fc-select></div><div layout-xs=\"column\" layout=\"row\" ng-if=\"customField.type === \'question\'\"><div flex=\"100\"><p>\n{{customField.name}}</p><fc-smart-rewrite reference-id=\"(vm.equipment.id || vm.sessionId) + \'_\' + customField.id\" \nreference-type=\"equipment-custom-field-question\" class=\"flex-100\"><fc-textarea id=\"{{ customField.id }}\" \ndata-cy=\"equipment-custom-field-text\" is-required=\"customField.required\" \nlabel=\"{{ \'EQUIPMENTS.DIALOG.CUSTOM_FIELDS.LABEL_TEXT_AREA\' | translate }}\" ng-model=\"customField.answer\" \nng-change=\"vm.checkRequiredCustomFields()\" input-name=\"question_{{ $index }}\" \ninput-control=\"equipmentsForm[\'question_\' + $index]\" max-length=\"500\" \nerrors-to-watch=\"[\n                        {\n                          name: \'maxlength\',\n                          translate: \'EQUIPMENTS.MODEL.ERRORS.NOTES_MAX_LENGTH\',\n                          translateValues: { expectedLength: 500, receivedLength: equipmentsForm[\'question_\' + $index].$viewValue.length }\n                        },\n                        {\n                          name: \'required\',\n                          translate: \'EQUIPMENTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                        }\n                      ]\">\n</fc-textarea></fc-smart-rewrite></div></div><div layout-xs=\"column\" layout=\"row\" \nng-if=\"customField.type === \'number\'\"><div flex=\"100\"><p>{{customField.name}}</p><div class=\"fc-input numeric-input\">\n<input type=\"number\" id=\"{{ customField.id }}\" class=\"fc-input__input\" data-cy=\"equipment-custom-field-text\" \nplaceholder=\" \" label=\"{{ \'EQUIPMENTS.DIALOG.CUSTOM_FIELDS.LABEL_NUMBER\' | translate }}\" ng-model=\"customField.answer\" \nng-change=\"vm.checkRequiredCustomFields()\" input-name=\"question_{{ $index }}\" \ninput-control=\"equipmentsForm[\'question_\' + $index]\" max-length=\"500\" autocomplete=\"off\" string-to-number \nng-required=\"customField.required\" \nng-class=\"{\n                        invalid: equipmentsForm[\'question_\' + $index].$touched && equipmentsForm[\'question_\' + $index].$invalid\n                      }\">\n<label class=\"fc-input__label\">{{(\"EQUIPMENTS.DIALOG.CUSTOM_FIELDS.LABEL_NUMBER\" | translate)}}</label><fc-error \nng-show=\"equipmentsForm[\'question_\' + $index].$touched\" input-errors=\"equipmentsForm[\'question_\' + $index].$error\" \nerrors-to-watch=\"[\n                        {\n                          name: \'required\',\n                          translate: \'EQUIPMENTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                        }\n                      ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div ng-if=\"customField.type === \'date\'\"><p>\n{{customField.name}}</p><div style=\"width: 35%\" class=\"fc-datepicker\" \nng-class=\"{\n                    invalid: equipmentsForm[\'datePicker_\' + $index].$touched && equipmentsForm[\'datePicker_\' + $index].$invalid\n                  }\">\n<div class=\"date-container p-10\"><md-datepicker id=\"customField.id\" name=\"datePicker_{{ $index }}\" \nng-required=\"customField.required\" ng-model=\"customField.answer\" ng-change=\"vm.checkRequiredCustomFields()\" \nng-disabled=\"$root.loadingProgress\" md-hide-icons=\"calendar\" \nmd-placeholder=\"{{ \'EQUIPMENTS.DIALOG.CUSTOM_FIELDS.LABEL_DATE_PICKER\' | translate }}\" \ndata-cy=\"equipment-custom-field-date\" flex></md-datepicker></div><fc-error \nng-show=\"equipmentsForm[\'datePicker_\' + $index].$touched\" input-errors=\"equipmentsForm[\'datePicker_\' + $index].$error\" \nerrors-to-watch=\"[\n                      {\n                        name: \'required\',\n                        translate: \'EQUIPMENTS.MODEL.ERRORS.FIELD_REQUIRED\',\n                      }\n                    ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div class=\"custom-field\" layout=\"column\" \nng-if=\"!vm.customFieldEquipmentType.length\"><div class=\"text-center\"><i class=\"icon-clipboard-text s40\"></i><br><span \nng-if=\"vm.equipment.type\" translate=\"EQUIPMENTS.DIALOG.CUSTOM_FIELDS.INVALID\">This equipment type has no custom fields.\n</span> <span ng-if=\"!vm.equipment.type\" translate=\"EQUIPMENTS.DIALOG.CUSTOM_FIELDS.EMPTY\">\nSelect an equipment type to have custom fields displayed here.</span></div></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.equipment.id\"><md-tab-label><span data-cy=\"attachments-tab\" translate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.TITLE\">\nAttachments</span></md-tab-label><md-tab-body><div layout=\"row\" layout-align=\"center center\" class=\"warning\"><md-icon \nmd-svg-src=\"assets/icons/icon-question-circle.svg\"></md-icon><span \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.ATTACHMENT_WARNING\">\nLimit 20 attachments per Manager Panel. Maximum size of each file is 10MB.</span></div><span class=\"err\" \nng-show=\"errorMsg\">{{ errorMsg }}</span><div class=\"drop-box\" ng-class=\"{\'has-images\': vm.files.length > 0 }\" \nlayout=\"row\" layout-align=\"center\" ng-model=\"vm.files\" name=\"files\" ngf-allow-dir=\"true\" ngf-multiple=\"true\" ngf-drop \nngf-max-files=\"{{20 - vm.equipmentAttachments.length}}\" \nngf-accept=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nngf-pattern=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nngf-validate-fn=\"vm.validateImage($file)\"><div layout=\"column\" layout-align=\"center\" class=\"upload-warn\"><div \nlayout=\"column\" class=\"upload-warn__sentence-container\" layout-align=\"center center\"><div layout=\"column\" \nlayout-align=\"center center\" ng-if=\"20 - vm.equipmentAttachments.length <= 0\"><md-icon \nmd-svg-src=\"assets/icons/icon-service-error.svg\"></md-icon><span style=\"margin-top: 14px\" \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.ATTACHMENTS_LIMIT_REACHED\">\nAttachments limit reached to add more attachments you need to remove some first.</span></div><div \nng-if=\"vm.files.length < 1 && 20 - vm.equipmentAttachments.length > 0\"><md-icon \nmd-svg-src=\"assets/icons/icon-upload.svg\"></md-icon><span class=\"upload-warn__sentence-container__phrase\" \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.DROP_HERE\" layout-align=\"center center\" layout=\"column\">\nDrag your files to upload</span></div><div class=\"upload-warn__sentence-container__actions-buttons-container\" \nng-if=\"vm.equipmentAttachments.length < 20\"><div><span \nclass=\"upload-warn__sentence-container__actions-buttons-container__phrase\" ng-if=\"vm.files.length\" \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.INSERT_FILES_ALTERNATIVE\">Drag your files to upload or</span><md-button \nclass=\"insert-attachments\" ngf-select ng-model=\"vm.files\" ngf-multiple=\"true\" \nngf-pattern=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nngf-max-files=\"{{20 - vm.equipmentAttachments.length}}\" ngf-allow-dir=\"true\" ngf-validate-fn=\"vm.validateImage($file)\" \nngf-accept=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nng-disabled=\"vm.files.length > 0\"><md-icon md-svg-src=\"assets/icons/insert-attachments.svg\"></md-icon><span \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.INSERT_FILES\">Insert files</span></md-button></div><md-button \nclass=\"send-attachments\" ng-click=\"vm.uploadImages(vm.files)\" aria-label=\"menu\" \nng-disabled=\"vm.uploadProgress || !vm.files || 21 - (vm.equipmentAttachments.length + vm.files.length) <= 0\" \nng-if=\"vm.files && vm.files.length && vm.equipmentAttachments && vm.equipmentAttachments.length < 20 && !vm.uploadProgress\">\n<span translate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.SEND_FILES\">Save files</span></md-button></div></div></div>\n<md-progress-circular id=\"upload-progress\" ng-if=\"vm.uploadProgress\" class=\"md-accent mleft-10\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"equipments__wrapper-images-upload\" \nstyle=\"display: flex\" layout-align=\"center\" ng-if=\"!vm.uploadProgress\"><div ng-repeat=\"f in vm.files\"><md-icon \nclass=\"remove-attachment-icon\" md-svg-src=\"assets/icons/icon-remove.svg\" \nng-click=\"vm.removeUploadedAttachment($index)\"></md-icon><img ng-if=\"vm.isFileTypeImage(f)\" ngf-thumbnail=\"f\" \nngf-size=\"{width: 100, height: 100, quality: 0.9}\"><div ng-if=\"!vm.isFileTypeImage(f)\" layout=\"row\" \nlayout-align=\"center center\" class=\"attachment-icon\"><md-icon md-font-icon=\"{{vm.getIconByFileType(f.type)}}\" \nclass=\"file-image-thumbnail\" ng-class=\"vm.getIconByFileType(f.type)\"></md-icon></div><br><span class=\"name-file-text\">\n{{f.$error}} {{f.$errorParam}}</span></div></div></div><div ngf-no-file-drop \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.NOT_SUPPORTED_FILE_DRAG\">File Drag/Drop is not supported for this browser\n</div><md-divider class=\"equipment-divider\"></md-divider><span class=\"attachments-limit\" \nng-class=\"{ \'red-text\': vm.equipmentAttachments.length >= 20 }\"><span translate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.TITLE\">\nAttachments</span> ({{ vm.equipmentAttachments.length }} / 20)</span><div \nng-if=\"!vm.equipmentAttachments || !vm.equipmentAttachments.length\"><p class=\"text-center\"><i \nclass=\"icon-attachment s40\"></i><br><span translate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.EMPTY_STATE\">\nNo attachments have been added for this equipment.</span></p></div><div ng-if=\"vm.equipmentAttachments.length\" \nclass=\"sections\"><div class=\"section\"><div class=\"attachments\"><div class=\"section-content\"><div class=\"attachment\" \nng-repeat=\"attachment in vm.equipmentAttachments\"><div layout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" \nstyle=\"background-size: cover\" ng-if=\"vm.isFileTypeImage(attachment)\" \nng-style=\"{ \'background-image\': \'url(\\\'{{ attachment.path }}\\\')\' }\"></div><div \nclass=\"attachment-preview attachment-video md-whiteframe-2dp\" ng-if=\"vm.isFileTypeVideo(attachment)\" \nng-click=\"vm.viewOriginalAttachment(attachment.fullPath);\" \nng-style=\"{\'background-image\': \'url(\' + attachment.fullPath.replace(\'.mp4\', \'.jpg\') + \')\', \'background-size\': \'cover\'}\">\n</div><div class=\"attachment-preview md-whiteframe-2dp attachment-icon\" \nng-if=\"!vm.isFileTypeImage(attachment) && !vm.isFileTypeVideo(attachment)\"><md-icon class=\"file-image\" \nng-class=\"vm.getIconByFileType(attachment.type)\" md-font-icon=\"{{vm.getIconByFileType(attachment.type)}}\"></md-icon>\n</div><div class=\"attachment-content\" layout=\"column\" flex=\"100\"><div layout=\"row\"><div layout=\"column\" flex=\"100\"><div\n class=\"attachment-name\" ng-if=\"attachment.editing\"><div class=\"attachment-content-edit\" layout-align=\"space-between\">\n<input id=\"attachment_{{ attachment.id }}\" name=\"attachment_{{ attachment.id }}\" ng-model=\"attachment.title\" \nmaxlength=\"80\" ng-keydown=\"vm.saveAttachmentWhenEnterKey($event, attachment);\" type=\"text\"><div><md-icon \nclass=\"s20 clickable attachment-content__icon-check\" ng-click=\"vm.saveAttachmentTitle(attachment);\" \nmd-font-icon=\"icon-check\"><md-tooltip md-direction=\"top\"><span translate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.SAVE\">\nSave title</span></md-tooltip></md-icon><md-icon class=\"s20 clickable attachment-content__icon-close\" \nng-click=\"vm.cancelEditAttachment(attachment);\" md-font-icon=\"icon-close\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.CANCEL\">Cancel</span></md-tooltip></md-icon></div></div></div><div \nclass=\"attachment-name\" ng-if=\"!attachment.editing\"><span>{{ attachment.title || \'Sem título\' }}</span></div></div>\n</div><div layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"60\"><span ng-if=\"attachment.createdAt\" \nclass=\"attachment-time attachment-content-metadata\" translate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.CREATED_AT\" \ntranslate-value-date=\"{{ attachment.createdAt | amDateFormat: vm.dateFormat }}\" \ntranslate-value-time=\"{{ attachment.createdAt | amDateFormat: \'HH:mm:ss\' }}\">\nAdded in {{attachment.createdAt | amDateFormat: vm.dateFormat}} at {{attachment.createdAt | amDateFormat: \'HH:mm:ss\'}} \n</span><span class=\"attachment-rename\" ng-click=\"vm.editAttachmentTitle(attachment);\">Renomear</span></div><div \nlayout=\"column\"><div layout=\"row\" class=\"remove-equipment-attachment mt-22\"><md-button \nclass=\"remove-or-archive-attachment__action-button\" ng-click=\"vm.viewOriginalAttachment(attachment);\"><md-icon \nmd-svg-src=\"assets/icons/icon-eye-view.svg\"></md-icon><md-tooltip><span \nstyle=\"display: block; white-space: pre-wrap; text-align: center\" \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.VIEW_ORIGINAL\">View original</span></md-tooltip></md-button><md-button \nclass=\"remove-or-archive-attachment__action-button\" ng-click=\"attachment[\'open-delete-\' + $index] = \'visible\'\"><md-icon\n class=\"dark-red\" md-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.REMOVE\">Delete image</span></md-tooltip></md-button></div></div></div><div \nclass=\"attachment-delete-dialog\" ng-class=\"attachment[\'open-delete-\' + $index]\" layout=\"column\" flex=\"100\"><div \nlayout=\"column\" layout-align=\"space-between center\" layout-padding flex=\"100\"><div layout=\"row\"><span \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.ALERT.CONTENT\">Are you sure you want to delete the image?</span></div><div \nlayout=\"row\"><md-button type=\"button\" ng-click=\"vm.confirmRemoveAttachment(attachment)\" \nclass=\"md-accent md-raised md-red-800-bg\" aria-label=\"Delete attachment yes\" \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.ALERT.YES\" \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.ATTACHMENTS.ALERT.YES\">Yes</md-button><md-button type=\"button\" \nng-click=\"attachment[\'open-delete-\' + $index] = \'\'\" class=\"md-grey-300-bg md-raised\" aria-label=\"Delete attachment no\" \ntranslate=\"EQUIPMENTS.DIALOG.ATTACHMENTS.ALERT.NO\" translate-attr-aria-label=\"EQUIPMENTS.DIALOG.ATTACHMENTS.ALERT.NO\">\nNo</md-button></div></div></div></div></div></div></div></div></div></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.equipment.id\"><md-tab-label><span data-cy=\"services-tab\" translate=\"EQUIPMENTS.DIALOG.SERVICES.TITLE\">\nServices</span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/equipments/dialogs/tabs/tasks/tasks-tab.html\'\">\n</div></md-tab-body></md-tab><md-tab ng-if=\"vm.equipment.id\" md-on-select=\"vm.loadTimeline(true)\"><md-tab-label><span \ndata-cy=\"historic-tab\" translate=\"EQUIPMENTS.DIALOG.HISTORIC.TITLE\">Historic</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/equipments/dialogs/tabs/historic/historic-tab.html\'\"></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><button type=\"submit\" ng-if=\"vm.equipment.id\" \nng-click=\"vm.saveEquipment(vm.equipment, { closeDialog: true })\" \nng-disabled=\"equipmentsForm.$invalid || equipmentsForm.$pristine || $root.loadingProgress || vm.equipment.locked\" \nclass=\"fc-button fc-button--transition-none fc-button--actions\" \nng-class=\"{disabled: equipmentsForm.$invalid || equipmentsForm.$pristine || $root.loadingProgress || vm.equipment.locked}\" \naria-label=\"Save\" translate=\"EQUIPMENTS.DIALOG.ACTIONS.SAVE\" \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.ACTIONS.SAVE\" data-cy=\"button-save-equipment\">Save</button> <button \ntype=\"submit\" ng-if=\"!vm.equipment.id\" ng-click=\"vm.saveEquipment(vm.equipment, { closeDialog: true })\" \nng-disabled=\"equipmentsForm.$invalid || equipmentsForm.$pristine || $root.loadingProgress || vm.equipment.locked\" \nclass=\"fc-button fc-button--transition-none fc-button--actions\" \nng-class=\"{disabled: equipmentsForm.$invalid || equipmentsForm.$pristine || $root.loadingProgress || vm.equipment.locked}\" \naria-label=\"Create\" translate=\"EQUIPMENTS.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.ACTIONS.CREATE\" data-cy=\"button-create-equipment\">Create</button></div>\n<div layout=\"row\"><md-button ng-click=\"vm.archiveEquipment($event);\" ng-if=\"vm.equipment.id && !vm.equipment.archived\" \nng-disabled=\"equipmentsForm.$invalid\" data-cy=\"archived-equipment-button\" class=\"md-icon-button\" \nng-disabled=\"vm.equipment.locked\" aria-label=\"Archive\" translate \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.ACTIONS.ARCHIVE\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"EQUIPMENTS.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip>\n</md-button><md-button ng-show=\"vm.equipment.id && vm.equipment.archived\" class=\"md-icon-button\" \nng-disabled=\"vm.equipment.locked\" ng-click=\"vm.unarchiveEquipment($event)\" aria-label=\"Unarchive\" translate \ntranslate-attr-aria-label=\"EQUIPMENTS.DIALOG.ACTIONS.UNARCHIVE\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"EQUIPMENTS.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/equipments/templates/export-excel-content.html","<div><form><p class=\"fc-modal__content\">{{vm.variables.title}}</p><md-radio-group name=\"customFieldExport\" \nng-model=\"vm.variables.customFieldSelect\"><md-radio-button value=\"{{vm.variables.withCustomFieldTitle}}\" \nng-model=\"vm.variables.withCustomFieldNgModel\" ng-click=\"vm.variables.radioSelection(true)\" [checked]=\"true\">\n{{vm.variables.withCustomFieldTitle}}</md-radio-button><md-radio-button \nvalue=\"{{vm.variables.withoutCustomFieldTitle}}\" ng-model=\"vm.variables.withoutCustomFieldNgModel\" \nng-click=\"vm.variables.radioSelection(false)\">{{vm.variables.withoutCustomFieldTitle}}</md-radio-button>\n</md-radio-group></form><div><p class=\"fc-modal__content\">{{vm.variables.alertFirstContent}} <b>\n{{vm.variables.email}}. </b>{{vm.variables.alertSecondContent}}</p><p class=\"fc-modal__content\">\n{{vm.variables.confirmActionContent}}</p></div></div>");
$templateCache.put("app/main/errors/404/error-404.html","<div class=\"maintenance flex-scrollable\" layout=\"column\" ms-scroll><div class=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><svg xmlns:dc=\"http://purl.org/dc/elements/1.1/\" xmlns:cc=\"http://creativecommons.org/ns#\" \nxmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\" xmlns:svg=\"http://www.w3.org/2000/svg\" \nxmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"33.866669mm\" height=\"33.866669mm\" \nviewBox=\"0 0 33.866668 33.866668\" version=\"1.1\" id=\"svg8\"><g id=\"layer1\" transform=\"translate(0.57568723,-42.217589)\">\n<g id=\"layer1-5\" transform=\"matrix(0.16,0,0,0.16,-0.57568682,35.444256)\"><image width=\"211.66667\" height=\"211.66667\" \npreserveAspectRatio=\"none\" style=\"image-rendering:optimizeQuality\" \nxlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAMgCAYAAADbcAZoAAARB0lEQVR4nO3aIW5VQRiG4TnkLIQl dAesoeJiuwB20io8gtqqqjqSNsEhUCSIJtimDlM73cV7TzLPs4T/U29mtnGacwAAAAQ+ODIAAFAR IAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABk BAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAA GQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAA QEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgA AJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQEC AABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaA AAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJAR IAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABk BAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAA GQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAA QEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgA AJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQEC AABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaA AAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJAR IAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABk BAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAA GQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAA QEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgA AJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQEC AABkBAgAAJARIAAAQGZ3aljLvDM4cBzbZ2PAaryAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQEC AABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaA AAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJAR IAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABk BAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAA GQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAA QEaAAAAAGQECAABkBAgAAJDZnRrW8vXB4ADA+WzjNKf7AwAABV+wAACAjAABAAAyAgQAAMgIEAAA ICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQA AMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAAB AAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNA AACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgI EAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAy AgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACA jAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAA ICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQA AMgIEAAAILM7Nazl+xeDw1F8+zHGz7/mANYiQGAxV58sDkfx+EeAAOvxBQsAAMgIEAAAICNAAACA jAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAA ICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQA AMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAAB AAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNA AACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgI EAAAICNAAACAjAABAAAyAgQAAMgIEAAAILM7Nazl9sngcBTPL6YA1rON05x2BwAACr5gAQAAGQEC AABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaA AAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJAR IAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABk BAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAA GQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAA QEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgA AJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQEC AABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaA AAAAGQECAABkBAgAAJARIAAAQGZ3aljLxUeDr+7f6xj/31a/AgDnIkBgMb+vLb66y5sx7n+tfgUA zsUXLAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAAB AAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNA AACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgI EAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAy AgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACA jAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAyAgQAAMgIEAAAICNAAACAjAABAAAy2zjN6dwAAEDB CwgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAA GQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAA QEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgA AJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQEC AABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaA AAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJAR IAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABk BAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAA GQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAA QEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgA AJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQEC AABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaA AAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJAR IAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABk BAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAA GQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAA QEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgA AJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQEC AABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaAAAAAGQECAABkBAgAAJARIAAAQEaA AAAAjTHGO3IcJYMjEZEiAAAAAElFTkSuQmCC \" \nid=\"image90\" x=\"-2.5431316e-06\" y=\"42.333332\"/><path style=\"fill:#0155ff;stroke:none;stroke-width:0.264583\" \nd=\"M -2.5431316e-6,42.333332 V 254 H 211.66667 V 42.333332 H -2.5431316e-6 M 144.4625,98.160416 V 115.35833 H 66.939582 V 98.160416 H 144.4625 M 127.26458,139.96458 V 157.1625 H 66.939582 v -17.19792 h 60.324998 m -26.19375,42.06875 v 16.93334 H 66.939582 v -16.93334 z\" \nid=\"path94\"/></g></g></svg></div><div class=\"title\" translate=\"ERROR404.CODE\">404 - Page not found</div><div \nclass=\"subtitle\" translate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for<br>\nPlease check back later.</div><a class=\"cursor-pointer\" ui-sref=\"app.gantt\" ng-if=\"vm.hasToken\" \ntranslate=\"ERROR404.GO_BACK_LOGGED\">Back to dashboard</a></div></div></div>");
$templateCache.put("app/main/errors/desktop-required/desktop-required-error.html","<div class=\"maintenance flex-scrollable\" layout=\"column\" ms-scroll><div class=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><img src=\"assets/images/logos/field_logo_azul.png\"></div><div class=\"title\" \ntranslate=\"DESKTOP_REQUIRED_ERROR.CODE\">We noticed that you\'re on your cell phone.</div><div class=\"subtitle\" \ntranslate=\"DESKTOP_REQUIRED_ERROR.MESSAGE\">Account creation is performed by the <b>management panel</b>\n accessed via the desktop. Use your <b>notebook</b> or <b>computer</b> to perform this action. It\'s quick and simple.\n<br><br>If in doubt, use the chat to talk with us.<br><br></div></div></div></div>");
$templateCache.put("app/main/errors/download-app-required/download-app-required.html","<div class=\"maintenance flex-scrollable\" layout=\"column\" ms-scroll><div class=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><img src=\"assets/images/logos/field_logo_azul.png\"></div><div class=\"title\" \ntranslate=\"APP_DOWNLOAD_REQUIRED_ERROR.CODE\">We noticed that you\'re on your cell phone.</div><div \nclass=\"app-download-container\" flex layout=\"column\" layout-align=\"center center\"><span class=\"subtitle\" \ntranslate=\"APP_DOWNLOAD_REQUIRED_ERROR.DOWNLOAD\">Download the app for your smartphone operating system </span><a \nhref=\"https://apps.apple.com/br/app/gestor-field-control/id1445764147\" target=\"_blanc\" \nclass=\"content-box app-download-link\"><div><img src=\"assets/images/logos/apple.png\" alt=\"iOS\"> <span \ntranslate=\"APP_DOWNLOAD_REQUIRED_ERROR.APP_STORE\">download at app store</span></div></a><a \nhref=\"https://play.google.com/store/apps/details?id=com.fieldcontrol.gothmog\" target=\"_blanc\" \nclass=\"content-box app-download-link\"><div><img src=\"assets/images/logos/android-blue.png\" alt=\"Android\"> <span \ntranslate=\"APP_DOWNLOAD_REQUIRED_ERROR.GOOGLE_PLAY\">download at google play</span></div></a></div></div></div></div>");
$templateCache.put("app/main/locations/dialogs/location-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large location-dialog\" aria-label=\"Dialog Location\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\">\n{{vm.location.id ? ( \'LOCATIONS.DIALOG.VIEW.TITLE\' | translate ):(\'LOCATIONS.DIALOG.NEW.TITLE\' | translate)}}</span>\n</div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form \nname=\"vm.locationsForm\" novalidate><md-dialog-content class=\"pt-0\" style=\"padding: 0 !important\" ms-scroll><md-tabs \nmd-selected=\"vm.selectedTabIndex\" md-dynamic-height><md-tab><md-tab-label><span data-cy=\"general-tab\" \ntranslate=\"LOCATIONS.DIALOG.VIEW.TABS.GENERAL\">GENERAL</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/locations/dialogs/tabs/general/general-tab.html\'\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span data-cy=\"contacts-tab\" translate=\"LOCATIONS.DIALOG.VIEW.TABS.CONTACTS\">CONTACTS</span>\n</md-tab-label><md-tab-body><div ng-include=\"\'app/main/locations/dialogs/tabs/contacts/contacts-tab.html\'\"></div>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.location.id && vm.hasEquipmentsPermission\"><md-tab-label><span \ndata-cy=\"equipments-tab\" translate=\"LOCATIONS.DIALOG.VIEW.TABS.EQUIPMENTS\">EQUIPMENTS</span></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/locations/dialogs/tabs/equipments/equipments-tab.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.location.id\"><md-tab-label><div class=\"tab-label-with-badge\"><span data-cy=\"links-tab\" \ntranslate=\"LOCATIONS.DIALOG.VIEW.TABS.LOCATION_LINKS\">LINKS</span><div class=\"title-badge\"></div></div></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/locations/dialogs/tabs/location-links/location-links-tab.html\'\"></div>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.location.id\"><md-tab-label><span data-cy=\"services-tab\" \ntranslate=\"LOCATIONS.DIALOG.VIEW.TABS.SERVICES.TITLE\">Services</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/locations/dialogs/tabs/tasks/tasks-tab.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.location.id\"><md-tab-label><span data-cy=\"attachments-tab\" \ntranslate=\"LOCATIONS.DIALOG.VIEW.TABS.ATTACHMENTS\">ATTACHMENTS</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/locations/dialogs/tabs/attachments/attachments-tab.html\'\"></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content></form><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><button \nng-class=\"{disabled: vm.locationsForm.$invalid || vm.locationsForm.$pristine || (vm.location.id && vm.location.locked) || vm.isLoading }\" \nclass=\"fc-button fc-button--actions\" ng-click=\"vm.handleSubmit()\" \nng-disabled=\"vm.locationsForm.$invalid || vm.locationsForm.$pristine || (vm.location.id && vm.location.locked) || !(vm.location.customer && vm.location.customer.id) || vm.locationsForm.locationName.$invalid || vm.isLoading\">\n{{ vm.location.id ? (\'LOCATIONS.DIALOG.VIEW.SAVE\' | translate) : (\'LOCATIONS.DIALOG.NEW.CREATE_NEW_LOCATION\' | translate) }}\n</button></div><div layout=\"row\"><md-button \nng-if=\"vm.location.id && !vm.isPrimaryLocation && !vm.location.archived && !vm.location.locked\" class=\"md-icon-button\" \naria-label=\"Archive\" ng-click=\"vm.archiveUnarchiveLocation(true)\" translate \ntranslate-attr-aria-label=\"LOCATIONS.DIALOG.ARCHIVE\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon><md-tooltip\n md-direction=\"top\"><span translate=\"LOCATIONS.DIALOG.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button \nng-if=\"vm.location.archived && !vm.location.locked\" class=\"md-icon-button\" aria-label=\"Archive\" \nng-click=\"vm.verifyDuplicatedLocationNameToArchive(false)\" \nng-disabled=\"vm.locationsForm.$invalid || vm.locationsForm.$pristine || (vm.location.id && vm.location.locked) || !(vm.location.customer && vm.location.customer.id) || vm.locationsForm.locationName.$invalid || vm.isLoading\" \ntranslate translate-attr-aria-label=\"LOCATIONS.DIALOG.UNARCHIVE\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"LOCATIONS.DIALOG.UNARCHIVE\">Unarchive</span></md-tooltip></md-button>\n</div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/locations/templates/export-locations.html","<div><p class=\"fc-modal__content\">{{vm.variables.confirmActionContent}}</p></div>");
$templateCache.put("app/main/materials/dialogs/materials-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__title\"><span ng-show=\"!vm.material.id\" translate=\"MATERIALS.DIALOG.TITLE_NEW\">\nNew material</span> <span ng-show=\"vm.material.id\" translate=\"MATERIALS.DIALOG.TITLE_EDIT\">Edit material</span></div>\n<div class=\"sidebar-dialog__header__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog();\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form \nname=\"materialsForm\" class=\"md-inline-form\" novalidate><div class=\"fc-warning-container warning-custom-height\"><md-icon\n class=\"warning-icon\" md-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span \ntranslate=\"MATERIALS.DIALOG.QUOTATION_ALERT\"></span></div><md-dialog-content ms-scroll><div><strong>\n{{(\'MATERIALS.DIALOG.QUOTATION_INFO\' | translate)}}</strong></div><div layout-xs=\"column\" layout=\"row\" \nclass=\"materials-input-container mt-20\"><div flex=\"75\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input\" name=\"name\" ng-model=\"vm.material.name\" ng-disabled=\"false\" \nng-maxlength=\"150\" \nng-class=\"{\n                invalid: materialsForm.name.$touched && materialsForm.name.$invalid\n              }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'MATERIALS.MODEL.NAME\' | translate)}}</label><fc-error \nng-show=\"materialsForm.name.$touched\" input-errors=\"materialsForm.name.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'MATERIALS.MODEL.ERRORS.NAME_REQUIRED\'\n                },\n                {\n                  name: \'maxlength\',\n                  translate: \'MATERIALS.MODEL.ERRORS.MAX_LENGTH\',\n                  translateValues: { expectedLength: 150, receivedLength: materialsForm.name.$viewValue.length }\n                },\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"25\"><fc-select \nlabel=\"{{(\'MATERIALS.MODEL.MEASURE\' | translate)}}\" ng-model=\"vm.material.measure\" options=\"vm.measuresOptions\" \nis-required=\"true\" input-name=\"measure\" input-control=\"materialsForm.measure\" \nerrors-to-watch=\"[\n            {\n              name: \'required\',\n              translate: \'MATERIALS.MODEL.ERRORS.MEASURE_REQUIRED\'\n            }\n          ]\">\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"vm.saveMaterial(vm.material, { closeDialog: true })\" \nng-disabled=\"materialsForm.$invalid || materialsForm.$pristine || $root.loadingProgress\" type=\"submit\" \nclass=\"fc-button fc-button--actions\" aria-label=\"Save material\"><span translate=\"MATERIALS.DIALOG.SAVE\" \ntranslate-attr-aria-label=\"MATERIALS.DIALOG.SAVE\" ng-if=\"vm.material.id\">SAVE</span> <span \ntranslate=\"MATERIALS.DIALOG.CREATE\" translate-attr-aria-label=\"MATERIALS.DIALOG.CREATE\" ng-if=\"!vm.material.id\">\nADD MATERIAL</span></md-button></div><div layout=\"row\"><md-button ng-click=\"vm.updateMaterialStatus();\" \nng-disabled=\"materialsForm.$invalid\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-folder-download\" \nng-if=\"!vm.material.archived\"></md-icon><md-icon md-font-icon=\"icon-folder-upload\" ng-if=\"vm.material.archived\">\n</md-icon><md-tooltip md-direction=\"top\"><span translate=\"MATERIALS.DIALOG.ARCHIVE_MATERIAL\" \nng-if=\"vm.material.id && !vm.material.archived\">Archive material</span> <span \ntranslate=\"MATERIALS.DIALOG.UNARCHIVE_MATERIAL\" ng-if=\"vm.material.id && vm.material.archived\">Unarchive material\n</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/notifications/sidenavs/main-sidenav.html","<div ms-scroll class=\"scrollable p-0\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"NOTIFICATIONS.FILTERS.TITLE\">Filters</span></md-subheader><md-list-item \nng-class=\"{ \'selected\': vm.filtersType === \'all\' }\" ng-click=\"vm.changeFilterType(\'all\');\"><p class=\"pl-8\" \ntranslate=\"NOTIFICATIONS.FILTERS.ALL\">All</p></md-list-item><md-list-item \nng-class=\"{ \'selected\': vm.filtersType === \'ticket-created\' }\" ng-click=\"vm.changeFilterType(\'ticket-created\');\"><p \nclass=\"pl-8\" translate=\"NOTIFICATIONS.FILTERS.TICKETS\">Tickets</p></md-list-item><md-list-item \nng-class=\"{ \'selected\': vm.filtersType === \'comment-created\' }\" ng-click=\"vm.changeFilterType(\'comment-created\');\"><p \nclass=\"pl-8\" translate=\"NOTIFICATIONS.FILTERS.COMMENTS\">Comments</p></md-list-item><md-list-item \nng-class=\"{ \'selected\': vm.filtersType === \'task-rated\' }\" ng-click=\"vm.changeFilterType(\'task-rated\');\"><p \nclass=\"pl-8\" translate=\"NOTIFICATIONS.FILTERS.RATINGS\">Ratings</p></md-list-item><md-list-item \nng-class=\"{ \'selected\': vm.filtersType === \'task-reported\' }\" ng-click=\"vm.changeFilterType(\'task-reported\');\"><p \nclass=\"pl-8\" translate=\"NOTIFICATIONS.FILTERS.IMPEDIMENTS\">Impediments</p></md-list-item></md-list></div>");
$templateCache.put("app/main/plans-types/dialogs/plans-types-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large plan-type-dialog\" aria-label=\"Tipo de OS\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title ml-10i\" layout=\"row\" \nlayout-align=\"space-between\"><span ng-show=\"!vm.planType.id\" class=\"title\" translate=\"PLANSTYPES.DIALOG.NEW.TITLE\">\nNew plan type</span> <span ng-show=\"vm.planType.id\" class=\"title\" translate=\"PLANSTYPES.DIALOG.EDIT.TITLE\">\nEdit plan type</span></div><div class=\"sidebar-dialog__actions\"><md-button data-cy=\"close-dialog-button\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog();\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"PLANSTYPES.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"planTypeForm\" class=\"md-inline-form\" novalidate><md-dialog-content ms-scroll class=\"pt-0\"><div\n layout-xs=\"column\" layout=\"row\" class=\"mt-20 mb-40n\"><div flex=\"100\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"PLANSTYPES.MODEL.NAME\">Name</label><input id=\"name\" name=\"name\" data-cy=\"name-input\" \nng-model=\"vm.planType.name\" maxlength=\"50\" required><div ng-messages=\"planTypeForm.name.$error\" \nng-show=\"planTypeForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PLANSTYPES.MODEL.ERRORS.NAME_REQUIRED\">Name is required</span></div></div></md-input-container></div></div>\n<div layout-xs=\"column\" layout=\"row\" class=\"mt-10 mb-40n\"><div flex=\"100\"><fc-smart-rewrite \nreference-id=\"vm.planType.id || vm.sessionId\" reference-type=\"plan-type-description\"><fc-textarea \ndata-cy=\"description-textarea\" label=\"{{(\'PLANSTYPES.MODEL.DESCRIPTION\' | translate)}}\" \nng-model=\"vm.planType.description\" input-name=\"description\" input-control=\"planTypeForm.description\" max-length=\"2000\">\n</fc-textarea></fc-smart-rewrite></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button data-cy=\"save-button\" \ntype=\"submit\" ng-if=\"!vm.newPlanType\" ng-click=\"vm.savePlanType()\" class=\"fc-button fc-button--actions\" \nng-disabled=\"planTypeForm.$invalid || planTypeForm.$pristine || $root.loadingProgress === true\" aria-label=\"Save\" \ntranslate=\"PLANSTYPES.DIALOG.ACTIONS.SAVE\" translate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.SAVE\">Save</md-button>\n<md-button data-cy=\"create-button\" type=\"submit\" ng-if=\"vm.newPlanType\" ng-click=\"vm.savePlanType()\" \nclass=\"fc-button fc-button--actions\" \nng-disabled=\"planTypeForm.$invalid || planTypeForm.$pristine || $root.loadingProgress === true\" \naria-label=\"Add Plan Type\" translate=\"PLANSTYPES.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.CREATE\">Add Plan Type</md-button></div><div layout=\"row\">\n<md-button data-cy=\"archive-button\" ng-show=\"(!vm.planType.archived && vm.planType.id)\" class=\"md-icon-button\" \nng-click=\"vm.archivePlanType($event)\" aria-label=\"Archive\" translate \ntranslate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip>\n</md-button><md-button ng-show=\"(vm.planType.archived && vm.planType.id)\" class=\"md-icon-button\" \nng-click=\"vm.unarchivePlanType($event)\" aria-label=\"Unarchive\" translate \ntranslate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/products/dialogs/products-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large products-dialog\" id=\"products-dialog\" \naria-label=\"Products dialog\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__title ml-10i\" layout=\"row\" layout-align=\"space-between\"><span ng-show=\"!vm.product.id\" \nclass=\"title\" translate=\"PRODUCTS.DIALOG.NEW.TITLE\">New product</span> <span ng-show=\"vm.product.id\" class=\"title\" \ntranslate=\"PRODUCTS.DIALOG.EDIT.TITLE\">Edit product</span></div><div class=\"sidebar-dialog__actions\"><md-button \ndata-cy=\"close-button\" class=\"md-icon-button\" ng-click=\"vm.closeDialog();\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"PRODUCTS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"productForm\" novalidate><md-dialog-content class=\"p-0\" style=\"padding: 0 !important\" \nms-scroll><md-dialog-content ms-scroll class=\"p-0\"><md-tabs md-selected=\"vm.selectedTabIndex\" md-dynamic-height>\n<md-tab><md-tab-label><span translate=\"PRODUCTS.DIALOG.TABS.GENERAL\">General</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/products/dialogs/tabs/general/general-tab.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.hasStockModule\"><md-tab-label><span translate=\"PRODUCTS.DIALOG.TABS.STORAGE\">Storage</span></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/products/dialogs/tabs/storage/storage-tab.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></md-dialog-content></md-dialog-content></form><md-dialog-actions layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><button data-cy=\"save-button\" class=\"fc-button fc-button--actions\" \ntype=\"submit\" ng-if=\"!vm.newProduct\" \nng-class=\"{disabled: productForm.$invalid || productForm.$pristine || $root.loadingProgress === true}\" \nng-click=\"vm.saveProduct()\" ng-disabled=\"vm.validateProductForm() || $root.loadingProgress === true\" aria-label=\"Save\" \ntranslate=\"PRODUCTS.DIALOG.ACTIONS.SAVE\" translate-attr-aria-label=\"PRODUCTS.DIALOG.ACTIONS.SAVE\">Save</button> <button\n data-cy=\"create-button\" class=\"fc-button fc-button--actions\" type=\"submit\" ng-if=\"vm.newProduct\" \nng-class=\"{disabled: productForm.$invalid || productForm.$pristine || $root.loadingProgress === true}\" \nng-click=\"vm.saveProduct()\" ng-disabled=\"vm.validateProductForm() || $root.loadingProgress === true\" \naria-label=\"Add Plan Type\" translate=\"PRODUCTS.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"PRODUCTS.DIALOG.ACTIONS.CREATE\">Create</button></div><div layout=\"row\" \nng-if=\"vm.product.id && vm.from !== \'quotations\'\"><md-button data-cy=\"archive-button\" ng-show=\"!vm.product.archived\" \nclass=\"md-icon-button\" ng-click=\"vm.archiveProduct($event)\" aria-label=\"Archive\" translate \nng-disabled=\"vm.product.locked\" translate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-download\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button \ndata-cy=\"unarchive-button\" ng-show=\"vm.product.archived\" class=\"md-icon-button\" ng-click=\"vm.unarchiveProduct($event)\" \naria-label=\"Unarchive\" translate ng-disabled=\"vm.product.locked\" \ntranslate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/products/templates/export-products-services.html","<div><p class=\"fc-modal__content\">{{vm.variables.confirmActionContent}}</p></div>");
$templateCache.put("app/main/products-services/templates/export-products-services.html","<div><p class=\"fc-modal__content\">{{vm.variables.confirmActionContent}}</p></div>");
$templateCache.put("app/main/quotations/dialogs/quotation-dialog.html","<div class=\"fc-backdrop fc-backdrop--invisible\" ng-click=\"vm.discardQuotation($event)\"></div><md-dialog \nid=\"quotation-dialog\" data-cy=\"quotation-dialog\" class=\"sidebar-dialog sidebar-dialog--large quotation-dialog\" \naria-label=\"Dialog Quotation\"><md-toolbar class=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\">\n<md-menu class=\"labels\"><md-button class=\"md-icon-button\" aria-label=\"Label\" \nng-click=\"vm.labelTabIndex = 0; $mdMenu.open($event)\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.GENERAL.LABEL.TITLE\" data-cy=\"quotations-label-manage\"><md-icon \nmd-menu-origin md-font-icon=\"icon-label-outline\"><md-tooltip md-direction=\"bottom\" ng-if=\"vm.labels.length\"><span \ntranslate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.MANAGE\">Manage labels</span></md-tooltip><md-tooltip md-direction=\"bottom\" \nng-if=\"!vm.labels.length && !vm.hasLabelsPermission\"><span translate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.NO_REGISTERED\">\nNo registered labels, only administrators can register labels.</span></md-tooltip></md-icon></md-button>\n<md-menu-content class=\"labels-menu-content\" width=\"4\" ms-scroll ng-show=\"vm.labels.length || vm.hasLabelsPermission\">\n<md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height><md-tab><md-tab-body><md-menu-item ng-if=\"vm.labels.length\">\n<md-input-container class=\"no-errors-spacer\" md-no-float><input type=\"text\" placeholder=\"Search tags ..\" \nng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate \ntranslate-attr-placeholder=\"QUOTATIONS.DIALOG.GENERAL.LABEL.PLACEHOLDER\"></md-input-container></md-menu-item>\n<md-menu-item ng-if=\"vm.labels.length\" class=\"label\" ng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button\n class=\"label-toggle-button\" md-prevent-menu-close ng-class=\"\'md-\'+label.color+\'-bg\'\" ng-click=\"vm.toggleLabel(label)\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"QUOTATIONS.DIALOG.GENERAL.LABEL.TOGGLE\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex><span>{{ label.name }}</span> <i ng-if=\"vm.hasLabel(label)\" \nclass=\"icon-check s16\"></i></div></md-button><md-button ng-if=\"vm.hasLabelsPermission\" \nclass=\"md-icon-button label-edit-button\" md-prevent-menu-close ng-click=\"vm.editLabel(label);\" aria-label=\"Edit Label\" \ntranslate translate-attr-aria-label=\"QUOTATIONS.DIALOG.GENERAL.LABEL.EDIT\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16\"></md-icon></md-button></md-menu-item><small class=\"counter-labels\" \ntranslate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.LIMIT_COUNT\" \ntranslate-values=\"{ length: vm.labels.length, limit: vm.labelsLimit }\" data-cy=\"quotations-label-counter\">\n{{ vm.labels.length }} of {{ vm.labelsLimit }} labels</small><md-menu-divider \nng-if=\"vm.labels.length && vm.hasLabelsPermission\"></md-menu-divider><md-menu-item ng-if=\"vm.hasLabelsPermission\">\n<md-button class=\"add-label-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 1\" \nng-disabled=\"vm.labels.length >= vm.labelsLimit\" data-cy=\"quotations-label-add\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span translate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.ADD\"><md-tooltip \nmd-direction=\"right\" ng-show=\"vm.labels.length >= vm.labelsLimit\"><span \ntranslate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.LIMIT_EXCEEDED\">Maximum tag limit has been exceeded.</span></md-tooltip>\nCreate new label</span></md-button></md-menu-item></md-tab-body></md-tab><md-tab><md-tab-body><div \nclass=\"add-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-icon-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.GENERAL.LABEL.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span \nflex translate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.ADD\">Create Label</span></div><div class=\"content\" layout=\"column\" \nlayout-align=\"start stretch\"><form name=\"addLabelForm\" novalidate layout=\"column\"><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.newLabelName\" \nmaxlength=\"20\" required translate translate-attr-placeholder=\"QUOTATIONS.DIALOG.GENERAL.LABEL.NAME\" \ndata-cy=\"quotations-label-create-name\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap>\n<label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{ \'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1) }\" \nlayout=\"column\" layout-align=\"center center\" data-cy=\"quotations-label-create-color\"><input class=\"ng-hide\" \ntype=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" aria-label=\"{{ palette }}\"> <i class=\"icon-check s18\" \nng-if=\"vm.newLabelColor === palette\"></i></label></div><md-button class=\"create-button md-accent md-raised\" \nmd-prevent-menu-close ng-click=\"vm.addNewLabel({ color:vm.newLabelColor, name: vm.newLabelName });\" \nng-disabled=\"!vm.newLabelColor || !vm.newLabelName\" aria-label=\"Create\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.GENERAL.LABEL.CREATE_BUTTON\" data-cy=\"quotations-label-create\"><span \ntranslate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.CREATE_BUTTON\">Create</span></md-button></form></div></div></md-tab-body>\n</md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close \nng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.GENERAL.LABEL.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span \nflex translate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.EDIT_LABEL\">Edit Label</span></div><div class=\"content\" \nlayout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float><input \nplaceholder=\"Label Name\" type=\"text\" ng-model=\"vm.editingLabel.name\" translate \ntranslate-attr-placeholder=\"QUOTATIONS.DIALOG.GENERAL.LABEL.NAME\"></md-input-container><div class=\"label-color-picker\" \nlayout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{ \'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1) }\" \nlayout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.editingLabel.color\" \nng-value=\"palette\" aria-label=\"{{ palette }}\"> <i ng-if=\"vm.editingLabel.color === palette\" class=\"icon-check s18\"></i>\n</label></div><md-button class=\"create-button md-accent md-raised\" md-prevent-menu-close aria-label=\"Update\" translate \nng-click=\"vm.updateLabel(vm.editingLabel);\" ng-disabled=\"!vm.editingLabel.name || !vm.editingLabel.color\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.GENERAL.LABEL.EDIT\"><span \ntranslate=\"QUOTATIONS.DIALOG.GENERAL.LABEL.EDIT\">Update</span></md-button><div layout=\"row\" layout-align=\"end center\" \nflex></div></div></div></md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><span ng-show=\"!vm.quotation.id\" \nclass=\"title\" translate=\"QUOTATIONS.DIALOG.NEW.TITLE\">New Quotation</span> <span ng-show=\"vm.quotation.id\" \nclass=\"title\" translate=\"QUOTATIONS.DIALOG.VIEW.TITLE\">View Quotation</span></div><div class=\"sidebar-dialog__actions\">\n<md-button class=\"md-icon-button\" data-cy=\"quotation-dialog-close-button\" ng-click=\"vm.closeDialog();\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form \nname=\"quotationForm\" class=\"md-inline-form\" novalidate><md-dialog-content style=\"padding: 0\" ms-scroll><md-tabs \nclass=\"quotation-dialog__tabs\" md-selected=\"vm.selectedTabIndex\" md-dynamic-height><md-tab id=\"quotation-general-tab\">\n<md-tab-label><span translate=\"QUOTATIONS.DIALOG.GENERAL.TITLE\">General</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/quotations/dialogs/tabs/general/general-tab.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nid=\"quotation-products-services-tab\" md-on-select=\"vm.loadedTabs.productsServices = true;\" \nng-disabled=\"!vm.selectedCustomer || vm.isSelectedServiceOrderRequired && !vm.quotation.id || !vm.quotation.id && !vm.isValidQuotationFormTabGeneral\">\n<md-tab-label><span data-cy=\"products-services-tab\" translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.TITLE\">\nProducts and services</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/quotations/dialogs/tabs/products-services/products-services-tab.html\'\"></ng-include></md-tab-body>\n</md-tab><md-tab id=\"quotation-expenses-tab\" ng-if=\"vm.hasPaymentsBetaFlag\" \nmd-on-select=\"vm.loadedTabs.expenses = true;\" \nng-disabled=\"!vm.selectedCustomer || vm.isSelectedServiceOrderRequired && !vm.quotation.id || !vm.quotation.id && !vm.isValidQuotationFormTabGeneral\">\n<md-tab-label><span data-cy=\"expenses-tab\" translate=\"QUOTATIONS.DIALOG.EXPENSES.TITLE\">Expenses</span></md-tab-label>\n<md-tab-body><ng-include src=\"\'app/main/quotations/dialogs/tabs/expenses/expenses-tab.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab id=\"attachments-tab\" \nng-disabled=\"!vm.selectedCustomer || vm.isSelectedServiceOrderRequired && !vm.quotation.id || !vm.quotation.id && !vm.isValidQuotationFormTabGeneral\">\n<md-tab-label><span data-cy=\"fc-attachments-tab\" translate=\"QUOTATIONS.DIALOG.ATTACHMENTS.TITLE\">Attachments</span>\n</md-tab-label><md-tab-body><ng-include src=\"\'app/main/quotations/dialogs/tabs/attachments/attachments-tab.html\'\">\n</ng-include></md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><button \nclass=\"fc-button fc-button--transition-none fc-button--actions\" data-cy=\"fc-button-submit-form-quotation\" \ntype=\"submit\" ng-if=\"!vm.quotation.id && vm.selectedTabIndex !== 0 || !vm.quotation.id && vm.quotation.items.length\" \nng-class=\"{disabled: quotationForm.$invalid || quotationForm.$pristine || $root.loadingProgress === true || !vm.selectedCustomer || (!vm.quotationProductService.items.length && !vm.quotationProductService.expenses.length) || !vm.validateItems() || vm.formErr[\'errorValueDiscount\']}\" \nng-click=\"vm.saveQuotation($event)\" \nng-disabled=\"quotationForm.$invalid || quotationForm.$pristine || $root.loadingProgress === true || !vm.selectedCustomer || (!vm.quotationProductService.items.length && !vm.quotationProductService.expenses.length) || !vm.validateItems() || vm.formErr[\'errorValueDiscount\']\" \naria-label=\"Add quotation\" translate=\"QUOTATIONS.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.CREATE\">Add quotation</button> <button \nclass=\"fc-button fc-button--transition-none fc-button--actions save-button\" data-cy=\"fc-button-submit-form-quotation\" \ntype=\"submit\" ng-if=\"vm.quotation.id && (vm.quotation.status === \'pending\' || vm.quotation.status === \'approved\' )\" \nng-class=\"{disabled: quotationForm.$invalid || quotationForm.$pristine || $root.loadingProgress === true || !vm.selectedCustomer || (!vm.quotationProductService.items.length && !vm.quotationProductService.expenses.length) || !vm.validateItems() || vm.formErr[\'errorValueDiscount\']}\" \nng-click=\"vm.saveQuotation($event)\" \nng-disabled=\"quotationForm.$invalid || quotationForm.$pristine || $root.loadingProgress === true || !vm.selectedCustomer || (!vm.quotationProductService.items.length && !vm.quotationProductService.expenses.length) || !vm.validateItems() || vm.formErr[\'errorValueDiscount\']\" \naria-label=\"Add quotation\" translate=\"QUOTATIONS.DIALOG.ACTIONS.SAVE\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.SAVE\">Save quotation</button> <button \nclass=\"fc-button fc-button--transition-none fc-button--actions__continue\" data-cy=\"continue-button\" \nng-if=\"!vm.quotation.id && !vm.quotation.items.length && vm.selectedTabIndex === 0\" \nng-disabled=\"quotationForm.$invalid || quotationForm.$pristine || $root.loadingProgress === true || !vm.selectedCustomer || vm.isSelectedServiceOrderRequired && !vm.quotation.id\" \nng-class=\"{disabled: quotationForm.$invalid || quotationForm.$pristine || $root.loadingProgress === true || !vm.selectedCustomer || vm.isSelectedServiceOrderRequired && !vm.quotation.id}\" \nng-click=\"vm.selectedTabIndex = 1\" aria-label=\"Continue\" translate=\"QUOTATIONS.DIALOG.ACTIONS.CONTINUE\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.CONTINUE\">Continue</button> <button \nclass=\"fc-button cancel-button-quotations\" type=\"submit\" data-cy=\"fc-button-cancel-quotation\" \nng-if=\"vm.quotation.id && vm.quotation.status === \'pending\'\" ng-click=\"vm.cancelQuotation()\" \naria-label=\"Cancel quotation\" translate=\"QUOTATIONS.DIALOG.ACTIONS.CANCEL\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.CANCEL\">Cancel quotation</button></div><div layout=\"row\" \nng-if=\"vm.quotation.id\"><md-button ng-if=\"vm.showIntegrationButton() && vm.quotation.status === \'approved\'\" \nng-click=\"vm.openIntegrationDialog($event, \'Omie\');\" class=\"md-icon-button\" aria-label=\"Send to Omie\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.SEND_TO_OMIE\"><md-icon md-svg-src=\"assets/icons/icon-omie.svg\" \nclass=\"icon-task-export\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"QUOTATIONS.DIALOG.ACTIONS.SEND_TO_OMIE\">Send to Omie</span></md-tooltip></md-button><md-button \nng-click=\"vm.printQuotation(vm.quotation);\" ng-if=\"vm.quotation.id\" class=\"md-icon-button\" aria-label=\"Print\" \ntranslate translate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.PRINT\"><md-icon md-font-icon=\"icon-printer\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"QUOTATIONS.DIALOG.ACTIONS.PRINT\">Print</span></md-tooltip></md-button>\n<md-button data-cy=\"archive-quotation-button\" ng-show=\"!vm.quotation.archived\" class=\"md-icon-button\" \nng-click=\"vm.archiveQuotation($event)\" aria-label=\"Archive\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.ARCHIVE\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"QUOTATIONS.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip>\n</md-button><md-button ng-show=\"vm.quotation.archived\" class=\"md-icon-button\" ng-click=\"vm.unarchiveQuotation($event)\" \naria-label=\"Unarchive\" translate translate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.UNARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"QUOTATIONS.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.copyQuotation()\" data-cy=\"quotation-copy-button\" aria-label=\"Copy\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.COPY\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"QUOTATIONS.DIALOG.ACTIONS.COPY\">Copy</span></md-tooltip></md-button>\n<md-menu md-offset=\"0 48\" ng-if=\"!vm.selectedCustomer.metadata.featureQuotationAccessApprovalLinkDisabled\"><md-button \nclass=\"md-icon-button\" aria-label=\"submit activity report link\" ng-click=\"$mdOpenMenu($event)\" translate \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.SEND_LINK\"><md-icon md-menu-origin md-font-icon=\"icon-reply\" \nclass=\"icon-forward\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"QUOTATIONS.DIALOG.ACTIONS.SEND_LINK\">\nSubmit quotation link</span></md-tooltip></md-button><md-menu-content><ng-template><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"option\"><md-button ngclipboard data-clipboard-text=\"{{ vm.quotationLink + vm.quotation.id }}\" \nngclipboard-success=\"vm.showToastWhileCopyLink(vm.quotation.identifier)\" class=\"add-label-button\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon><p class=\"option-label option-label-fs-13\" \ntranslate=\"QUOTATIONS.DIALOG.ACTIONS.COPY_LINK\">Copy link from quotation</p></md-button></md-menu-item><md-menu-item \nclass=\"option option-link\"><md-button ng-attr-target=\"_blank\" ng-href=\"{{ vm.quotationLink + vm.quotation.id }}\" \nclass=\"add-label-button\"><md-icon md-font-icon=\"icon-open-in-new\"></md-icon><p class=\"option-label option-label-fs-13\" \ntranslate=\"QUOTATIONS.DIALOG.ACTIONS.OPEN_LINK\">Open quotation link</p></md-button></md-menu-item></ng-template>\n</md-menu-content></md-menu></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/recurrences/dialog/recurrence-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog w-1200 recurrence-dialog\" \nng-class=\"vm.isCopyingRecurrence ? \'center-dialog\' : \'\'\" aria-label=\"Recurrences\" translate \ntranslate-aria-label=\"RECURRENCES.TITLE\"><md-toolbar class=\"sidebar-dialog__header\" ng-if=\"!vm.isCopyingRecurrence\">\n<div class=\"sidebar-dialog__header__title\"><span ng-show=\"!vm.recurrence.id\" class=\"title\" \ntranslate=\"RECURRENCES.DIALOG.NEW.TITLE\">New recurrence </span><span ng-show=\"vm.recurrence.id\" class=\"title\" \ntranslate=\"RECURRENCES.DIALOG.EDIT.TITLE\">Edit recurrence </span><span flex></span> <span flex></span></div><div \nclass=\"sidebar-dialog__actions\"><md-button data-cy=\"close-dialog-button\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\" aria-label=\"Close\" translate translate-attr-aria-label=\"RECURRENCES.DIALOG.CLOSE\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"recurrenceForm\" class=\"md-inline-form\" \nnovalidate><md-dialog-content class=\"no-padding-important\" ms-scroll><div class=\"copying-warning\" \nng-if=\"vm.isCopyingRecurrence\"><span class=\"h2\" translate=\"RECURRENCES.DIALOG.COPYING.TITLE\">Copying recurrence</span>\n<md-progress-circular class=\"md-accent mleft-15\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div>\n<md-tabs md-selected=\"vm.selectedTabIndex\" ng-if=\"!vm.isCopyingRecurrence\" md-dynamic-height><md-tab><md-tab-label>\n<span translate=\"RECURRENCES.DIALOG.GENERAL.TITLE\">General</span></md-tab-label><md-tab-body><div layout=\"row\" \nlayout-xs=\"column\" class=\"mt-17n\"><div flex ng-if=\"!vm.selectedCustomer\"><md-autocomplete flex required \nmd-input-id=\"auto-complete-customer\" md-input-name=\"customer\" md-input-minlength=\"2\" md-input-maxlength=\"100\" \nmd-no-cache=\"false\" md-selected-item-change=\"vm.selectedCustomerChanged()\" md-selected-item=\"vm.selectedCustomer\" \nmd-search-text=\"vm.searchCustomerText\" md-items=\"item in vm.searchCustomerByName(vm.searchCustomerText)\" \nmd-autoselect=\"true\" md-delay=\"800\" md-item-text=\"item.name\" data-cy=\"select-custumer-input\" \nmd-floating-label=\"{{ \'RECURRENCES.MODEL.CUSTOMER\' | translate }}\" ng-disabled=\"vm.recurrence.id\" \nmd-require-match=\"true\"><md-item-template><span md-highlight-text=\"vm.searchCustomerText\">{{ item.name }}</span>\n</md-item-template><md-not-found onclick=\"window.open(\'./#/clientes\', \'_blank\')\"><span class=\"employee-not-found\" \ntranslate=\"RECURRENCES.MODEL.ERRORS.CUSTOMER_NOT_FOUND\">Customer not found</span></md-not-found><div \nng-messages=\"recurrenceForm.customer.$error\" ng-if=\"recurrenceForm.customer.$touched\"><div ng-message=\"required\"><span \ntranslate=\"RECURRENCES.MODEL.ERRORS.CUSTOMER_REQUIRED\">Customer is required</span></div></div><div \nng-if=\"vm.formErr[\'customerIsRequired\'] && vm.searchCustomerText.length > 0\"><div class=\"grey-text fs-14\"><small \nng-bind-html=\"vm.formErr[\'customerIsRequired\']\"></small></div></div></md-autocomplete></div><div flex \nng-if=\"vm.selectedCustomer\"><md-input-container class=\"md-block mb-0\"><label translate=\"RECURRENCES.MODEL.CUSTOMER\">\nCustomer</label><input id=\"customerName\" name=\"customerName\" ng-model=\"vm.selectedCustomer.name\" \nselected-customer=\"vm.selectedCustomer\" corporate-customer-recurrence-validator required disabled=\"disabled\"><div \nrole=\"alert\"><div ng-messages=\"recurrenceForm.customerName.$error\" ng-if=\"recurrenceForm.customerName.$touched\"><span \nng-message=\"required\" translate=\"RECURRENCES.MODEL.ERRORS.CUSTOMER_REQUIRED\">Customer is required </span><span \nng-message=\"corporateCustomerRecurrenceValidator\" translate=\"RECURRENCES.MODEL.ERRORS.CORPORATE_CUSTOMER\" \ntranslate-values=\"{ customerName: vm.selectedCustomer.name }\">You cannot post recurrences to a <b>\n{{ vm.selectedCustomer.name }}</b> location.</span></div></div><div role=\"alert\"><div class=\"fs-12 pb-10\"><span \nng-if=\"vm.selectedCustomer.contact.phone.$valid || vm.selectedCustomer.contact.phone\"><i \nclass=\"md-accent-fg icon icon-phone s15\"></i> {{ vm.selectedCustomer.contact.phone | brPhoneNumber }} </span><span \nng-if=\"(orderForm.email.$valid && orderForm.email.length > 0) || vm.selectedCustomer.contact.email\"><i \nclass=\"md-accent-fg icon icon-email s15\"></i> {{ vm.selectedCustomer.contact.email }} </span><span \nng-if=\"vm.selectedCustomer.notes\"><i class=\"md-accent-fg icon icon-comment s15\"></i> {{ vm.selectedCustomer.notes }}\n</span></div></div></md-input-container></div><div flex=\"5\" ng-if=\"vm.selectedCustomer\"><md-button id=\"clear-customer\" \nng-click=\"vm.clearSelectedCustomer($event);\" class=\"md-icon-button md-accent mt-13 ml-5n\" aria-label=\"Clear customer\" \nng-disabled=\"vm.recurrence.id\"><md-icon md-font-icon=\"icon icon-close-circle-outline\"></md-icon><md-tooltip \nmd-direction=\"left\"><span translate=\"RECURRENCES.DIALOG.GENERAL.CLEAR_CUSTOMER\">Clear customer</span></md-tooltip>\n</md-button></div></div><div layout-xs=\"column\" class=\"customer-space\" layout=\"row\" class=\"mt-17n mb-15n\" \nng-if=\"vm.selectedCustomer\"><div flex=\"95\" ng-if=\"!vm.selectedCustomerLocation\"><md-autocomplete flex \nmd-input-id=\"auto-complete-customer-location\" md-input-name=\"customerLocation\" md-input-minlength=\"2\" \nmd-input-maxlength=\"150\" md-no-cache=\"false\" md-search-text=\"vm.searchCustomerLocationText\" \nmd-selected-item=\"vm.selectedCustomerLocation\" \nmd-selected-item-change=\"vm.selectedCustomerLocationChanged(vm.selectedCustomerLocation)\" \nmd-items=\"customerLocation in vm.searchCustomerLocationByName(vm.selectedCustomer, vm.searchCustomerLocationText)\" \nmd-autoselect=\"true\" md-delay=\"800\" md-item-text=\"customerLocation.name\" \nmd-floating-label=\"{{ \'RECURRENCES.MODEL.LOCATION\' | translate }}\" ng-disabled=\"vm.selectedCustomerLocation\">\n<md-item-template>{{ customerLocation.name }}&nbsp; <i class=\"md-accent-fg icon icon-map-marker s15\" \nng-if=\"customerLocation.address.formattedAddress\"></i> <span class=\"additional-customer-info\" \nng-if=\"customerLocation.address.formattedAddress\">{{ customerLocation.address.formattedAddress }}</span>\n</md-item-template><md-not-found><span class=\"employee-not-found\" \ntranslate=\"RECURRENCES.MODEL.ERRORS.LOCATION_NOT_FOUND\">Location not found</span></md-not-found><small \nng-if=\"vm.hasNoLocations\" role=\"alert\"><span translate=\"RECURRENCES.MODEL.ERRORS.NO_LOCATIONS.TEXT\">\nThis customer don\'t have locations yet. </span><a class=\"cursor-pointer\" ng-click=\"vm.createFirstCustomerLocation()\" \ntranslate=\"RECURRENCES.MODEL.ERRORS.NO_LOCATIONS.LINK\">Click here to create a location on:</a><br><span>\n{{ vm.selectedCustomer.address.formattedAddress }}</span></small></md-autocomplete></div><div flex=\"95\" \nng-if=\"vm.selectedCustomerLocation\"><md-input-container id=\"customer-name-input\" class=\"md-block\"><label \ntranslate=\"RECURRENCES.MODEL.LOCATION\">Location</label><input id=\"customerLocationName\" name=\"customerLocationName\" \nng-model=\"vm.selectedCustomerLocation.name\" disabled=\"disabled\"><div role=\"alert\"><div class=\"fs-12\"><span \nng-if=\"vm.selectedCustomerLocation.address && vm.selectedCustomerLocation.address.formattedAddress\"><i \nclass=\"md-accent-fg icon icon-map-marker s15 clickable\"></i> </span><span \nng-if=\"vm.selectedCustomerLocation.address && vm.selectedCustomerLocation.address.formattedAddress\">\n{{ vm.selectedCustomerLocation.address.formattedAddress }}</span></div></div></md-input-container></div><div flex=\"5\" \nng-if=\"vm.selectedCustomerLocation\"><md-button id=\"clear-customer-location\" \nng-click=\"vm.clearSelectedCustomerLocation($event);\" class=\"md-icon-button md-accent mt-13 ml-5n\" \naria-label=\"Clear customer\" translate translate-attr-aria-label=\"RECURRENCES.DIALOG.GENERAL.CLEAR_LOCATION\" \nng-disabled=\"vm.recurrence.id\"><md-icon md-font-icon=\"icon icon-close-circle-outline\"></md-icon><md-tooltip \nmd-direction=\"left\"><span translate=\"RECURRENCES.DIALOG.GENERAL.CLEAR_LOCATION\">Clear customer location</span>\n</md-tooltip></md-button></div></div><div layout=\"row\" layout-xs=\"column\" class=\"mt-17n\"><div flex=\"60\">\n<md-input-container class=\"md-block mb-0\"><label translate=\"RECURRENCES.MODEL.SERVICE\">OS type</label><md-select \nid=\"select-service\" placeholder=\"{{ \'RECURRENCES.DIALOG.GENERAL.SELECT_SERVICE\' | translate }}\" name=\"serviceId\" \nng-required=\"vm.toggleServiceRequiredValidationWorkaround();\" ng-model=\"vm.recurrence.service.id\" \nng-change=\"vm.onSelectedService(); vm.verifyEmployeeSkills()\" ng-disabled=\"!vm.editPermission\"><md-option \nclass=\"service-select-options\" ng-class=\"{ \'inactive-archived-item\': service.archived }\" \nng-repeat=\"service in vm.services | orderBy: \'description\'\" ng-if=\"service.show\" value=\"{{ service.id }}\" \ntitle=\"{{ service.description }}\"><span \nng-class=\"{\n                          \'inactive\': service.archived,\n                          \'marquee-hover\': (service.description && service.description.length > 60)\n                        }\">\n<span>{{ service.description }}</span> </span><small class=\"gray\" ng-if=\"service.metadata.sammathnaur.account.name\">\n- ({{::service.metadata.sammathnaur.account.name}}) </small><span class=\"duration\" \ntranslate=\"RECURRENCES.DIALOG.GENERAL.SERVICE_DURATION\" translate-value-duration=\"{{ ::service.duration }}\">\n- {{ ::service.duration }} minutes </span><span class=\"caption\" ng-if=\"service.archived\" \ntranslate=\"RECURRENCES.MODEL.ARCHIVED_SERVICE\">Archived</span></md-option></md-select><div \nng-messages=\"recurrenceForm.serviceId.$error\" ng-show=\"recurrenceForm.serviceId.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECURRENCES.MODEL.ERRORS.SERVICE_REQUIRED\">Service is required</span></div>\n</div></md-input-container><md-switch ng-model=\"vm.recurrence.options.calculateDeadline\" class=\"fs-13 switch-button\" \nng-if=\"vm.recurrence.service.slaTimeLimit\"><span ng-if=\"!vm.recurrence.options.calculateDeadline\" \ntranslate=\"RECURRENCES.DIALOG.GENERAL.DONT_CALCULATE_DEADLINE\"><b>Don\'t calculate</b> deadline for the service order. \n</span><span ng-if=\"vm.recurrence.options.calculateDeadline\" translate=\"RECURRENCES.DIALOG.GENERAL.CALCULATE_DEADLINE\" \ntranslate-values=\"{ deadline: vm.recurrence.service.slaTimeLimit }\"><b>Calculate</b> the term of <b>\n{{vm.recurrence.service.slaTimeLimit}} days</b> when creating work order.</span><md-icon \nmd-font-icon=\"icon-question-mark-circle\" class=\"text-icon\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"RECURRENCES.DIALOG.GENERAL.PRECONFIG_DEADLINE\">Deadline preconfigured by the type of activity selected\n</span></md-tooltip></md-icon></md-switch></div><div flex=\"40\"><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"RECURRENCES.MODEL.EMPLOYEE\">Employee</label><md-select \nplaceholder=\"{{ \'RECURRENCES.DIALOG.GENERAL.SELECT_EMPLOYEE\' | translate }}\" id=\"select-employee\" name=\"employeeId\" \nng-required=\"vm.selectedCustomer.metadata.featureRecurrenceAssignedEmployeeRequired\" \nng-change=\"vm.broadcastUpdateFields(); vm.verifyEmployeeSkills(); vm.showEmployeeChangeWarning()\" \nng-model=\"vm.recurrence.employee.id\" ng-disabled=\"!vm.editPermission\" close=\"vm.clearEmployeeSearchTerm()\">\n<md-select-header class=\"header-services\"><input size=\"30\" ng-model=\"vm.employeeSearchTerm\" class=\"input-services\" \ntype=\"search\" onkeydown=\"event.stopPropagation()\" placeholder=\"Search employee...\" translate \ntranslate-attr-placeholder=\"RECURRENCES.DIALOG.GENERAL.SEARCH_EMPLOYEE\"></md-select-header><md-option \nclass=\"service-select-options\" value=\"null\"><span translate=\"RECURRENCES.MODEL.NO_EMPLOYEE\">No employee</span>\n</md-option><md-option class=\"service-select-options\" \nng-repeat=\"employee in vm.employees | filter: vm.employeeSearchTerm\" ng-value=\"{{ employee.id }}\" \nng-class=\"{ \'inactive-archived-item\': !employee.contract.active }\"><img ng-if=\"employee.avatarUrl\" \nalt=\"{{ ::employee.name }}\" ng-src=\"{{ ::employee.avatarUrl }}\" class=\"avatar-select\"> <img \nng-if=\"!employee.avatarUrl\" alt=\"{{ ::employee.name }}\" src=\"assets/images/avatars/profile.jpg\" class=\"avatar-select\"> \n<span ng-class=\"{ \'inactive\': !employee.contract.active }\">\n{{ (employee.name && employee.name.length) > 30 ? employee.name.substring(0, 30) + \'...\' : employee.name }} </span>\n<span class=\"caption\" ng-if=\"!employee.contract.active\" translate=\"RECURRENCES.MODEL.INACTIVE_EMPLOYEE\">Inactive \n</span><span class=\"caption\" ng-if=\"vm.employeeIsAbsent(vm.recurrence, employee)\" \ntranslate=\"RECURRENCES.MODEL.ABSENT_EMPLOYEE\">Absent</span></md-option></md-select><div \nng-show=\"vm.formErr[\'notSkilledEmployee_\']\"><div class=\"red-text fs-15\"><small \nng-bind-html=\"vm.formErr[\'notSkilledEmployee_\']\"></small></div><div class=\"fs-15\"><small><span \ntranslate=\"RECURRENCES.DIALOG.GENERAL.EMPLOYEE.ADD_TASK.MESSAGE\" \ntranslate-values=\"{ description: vm.order.service.description }\">\nAdd {{ vm.order.service.description }} as the OS type performed?</span><md-button type=\"button\" \nclass=\"fc-button fc-button--actions\" ng-click=\"vm.addEmployeeSkill(vm.recurrence)\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ADD_TASK.CONFIRM\">Yes</md-button></small></div></div><div \nclass=\"grey-text fs-15\" ng-if=\"vm.isToShowEmployeeChangeWarning\"><small><span \ntranslate=\"RECURRENCES.DIALOG.GENERAL.WARNING_MESSAGE\">\nThe contributor will only change for activities that have not yet been created.</span></small></div>\n</md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" class=\"mt-10 mb-10\"><div flex=\"100\"><div \nclass=\"flex-100\"><fc-smart-rewrite reference-id=\"vm.recurrence.id || vm.sessionId\" reference-type=\"recurrence-notes\" \nclass=\"flex-100\"><fc-textarea ng-model=\"vm.recurrence.notes\" \nlabel=\"{{ \'RECURRENCES.DIALOG.GENERAL.ORDER_DESCRIPTION.LABEL\' | translate }}\" max-length=\"2000\" \ninput-name=\"order_description\" input-control=\"recurrenceForm.order_description\" \nerrors-to-watch=\"[\n                          {\n                            name: \'maxlength\',\n                            translate: \'RECURRENCES.DIALOG.GENERAL.ORDER_DESCRIPTION.ERRORS.MAX_LENGTH\',\n                            translateValues: { expectedLength: 2000, receivedLength: recurrenceForm.order_description.$viewValue.length }\n                          }\n                        ]\">\n</fc-smart-rewrite></div></div></div><div layout=\"row\" layout-xs=\"column\" class=\"mt-10\"><div flex=\"20\"><label \nclass=\"fake-floating-label\" translate=\"RECURRENCES.MODEL.START_AT\">Starts on</label><div layout=\"row\" flex>\n<md-datepicker class=\"icon-hide\" required name=\"startDate\" ng-model=\"vm.recurrence.repeat.fromAsDate\" \nmd-min-date=\"vm.minDateBegin\" ng-change=\"vm.updateMinEndDate(true);\" \nmd-placeholder=\"{{ \'RECURRENCES.DIALOG.GENERAL.SELECT_DATE\' | translate }}\" ng-disabled=\"vm.recurrence.id\">\n</md-datepicker></div><div layout=\"row\" ng-messages=\"recurrenceForm[\'startDate\'].$error\" \nng-show=\"recurrenceForm[\'startDate\'].$touched\" role=\"alert\" class=\"fs-15\"><div ng-message=\"required\"><small><span \nclass=\"red-text\" translate=\"RECURRENCES.MODEL.ERRORS.START_AT_REQUIRED\">From date is required</span></small></div><div \nng-message=\"valid\"><small><span class=\"red-text\" translate=\"RECURRENCES.MODEL.ERRORS.INVALID_DATE\">\nThe entered value is not a date!</span></small></div></div></div><div flex=\"20\"><label class=\"fake-floating-label\" \ntranslate=\"RECURRENCES.MODEL.END_AT\">Ends on</label><div layout=\"row\" flex><md-datepicker class=\"icon-hide\" \nname=\"endDate\" ng-model=\"vm.recurrence.repeat.untilAsDate\" md-min-date=\"vm.minDateEnd\" \nng-change=\"vm.updateMinEndDate();\" md-placeholder=\"{{ \'RECURRENCES.DIALOG.GENERAL.SELECT_DATE\' | translate }}\" \nng-disabled=\"vm.recurrence.id\"></md-datepicker></div><div layout=\"row\" ng-messages=\"recurrenceForm[\'endDate\'].$error\" \nng-show=\"recurrenceForm[\'endDate\'].$touched\" role=\"alert\" class=\"fs-15\"><div ng-message=\"valid\"><small><span \nclass=\"red-text\" translate=\"RECURRENCES.MODEL.ERRORS.INVALID_DATE\">The entered value is not a date!</span></small>\n</div></div></div><div flex=\"20\"><md-input-container class=\"md-block\"><label translate=\"RECURRENCES.MODEL.INTERVAL\">\nInterval</label><md-select placeholder=\"{{ \'RECURRENCES.MODEL.INTERVAL\' | translate }}\" name=\"interval\" \nng-model=\"vm.recurrence.repeat.interval\" ng-change=\"vm.changeRecurrenceType();vm.broadcastUpdateFields();\" \nng-disabled=\"vm.recurrence.id\"><md-option class=\"service-select-options\" value=\"daily\"><span class=\"fs-13\" \ntranslate=\"RECURRENCES.MODEL.INTERVALS.DAILY\">Daily</span></md-option><md-option class=\"service-select-options\" \nvalue=\"weekly\"><span class=\"fs-13\" translate=\"RECURRENCES.MODEL.INTERVALS.WEEKLY\">Weekly</span></md-option><md-option \nclass=\"service-select-options\" value=\"monthly\"><span class=\"fs-13\" translate=\"RECURRENCES.MODEL.INTERVALS.MONTHLY\">\nMonthly</span></md-option></md-select></md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block\">\n<label translate=\"RECURRENCES.MODEL.EVERY\">Every</label><input required type=\"number\" step=\"any\" class=\"fs-13\" \nname=\"every\" ng-model=\"vm.recurrence.repeat.every\" min=\"1\" max=\"45\" ng-change=\"vm.broadcastUpdateFields();\" \nng-disabled=\"vm.recurrence.id\"><div layout=\"row\" ng-messages=\"recurrenceForm[\'every\'].$error\" \nng-if=\"recurrenceForm.every.$touched\" role=\"alert\" class=\"fs-15\"><div ng-message=\"required\"><small><span \nclass=\"red-text\" translate=\"RECURRENCES.MODEL.ERRORS.EVERY_REQUIRED\">Every is required</span></small></div></div><div \nlayout=\"row\" ng-messages=\"recurrenceForm[\'every\'].$error\" ng-if=\"recurrenceForm.every.$touched\" role=\"alert\" \nclass=\"fs-15\"><div ng-message=\"max\"><small ng-if=\"vm.recurrence.repeat.interval === \'daily\'\"><span class=\"red-text\" \ntranslate=\"RECURRENCES.MODEL.ERRORS.EVERY_MAX_DAYS\">Maximum of 45 days </span></small><small \nng-if=\"vm.recurrence.repeat.interval === \'weekly\'\"><span class=\"red-text\" \ntranslate=\"RECURRENCES.MODEL.ERRORS.EVERY_MAX_WEEKENDS\">Maximum of 45 weekends </span></small><small \nng-if=\"vm.recurrence.repeat.interval === \'monthly\'\"><span class=\"red-text\" \ntranslate=\"RECURRENCES.MODEL.ERRORS.EVERY_MAX_MOUTHS\">Maximum of 45 months</span></small></div><div ng-message=\"min\">\n<small ng-if=\"vm.recurrence.repeat.interval === \'daily\'\"><span class=\"red-text\" \ntranslate=\"RECURRENCES.MODEL.ERRORS.EVERY_MIN_DAYS\">Minimum of 1 day </span></small><small \nng-if=\"vm.recurrence.repeat.interval === \'weekly\'\"><span class=\"red-text\" \ntranslate=\"RECURRENCES.MODEL.ERRORS.EVERY_MIN_WEEKENDS\">Minimum of 1 week </span></small><small \nng-if=\"vm.recurrence.repeat.interval === \'monthly\'\"><span class=\"red-text\" \ntranslate=\"RECURRENCES.MODEL.ERRORS.EVERY_MIN_MOUTHS\">Minimum of 1 mouth</span></small></div></div>\n</md-input-container></div><div flex=\"10\"><div flex=\"10\" class=\"fs-13 mt-27\" \nng-if=\"vm.recurrence.repeat.interval === \'daily\'\"><span translate=\"RECURRENCES.MODEL.TIME_UNITS.DAY\" \nng-if=\"vm.recurrence.repeat.every === 1\">day</span> <span translate=\"RECURRENCES.MODEL.TIME_UNITS.DAYS\" \nng-if=\"vm.recurrence.repeat.every > 1\">days</span></div><div flex=\"15\" class=\"fs-13 mt-27\" \nng-if=\"vm.recurrence.repeat.interval === \'weekly\'\"><span translate=\"RECURRENCES.MODEL.TIME_UNITS.WEEK\" \nng-if=\"vm.recurrence.repeat.every === 1\">week</span> <span translate=\"RECURRENCES.MODEL.TIME_UNITS.WEEKS\" \nng-if=\"vm.recurrence.repeat.every > 1\">weeks</span></div><div flex=\"10\" class=\"fs-13 mt-27\" \nng-if=\"vm.recurrence.repeat.interval === \'monthly\'\"><span translate=\"RECURRENCES.MODEL.TIME_UNITS.MONTH\" \nng-if=\"vm.recurrence.repeat.every === 1\">month</span> <span translate=\"RECURRENCES.MODEL.TIME_UNITS.MONTHS\" \nng-if=\"vm.recurrence.repeat.every > 1\">months</span></div></div><div flex=\"20\" class=\"ml-18\" \nng-if=\"vm.recurrence.repeat.interval === \'monthly\'\"><md-input-container class=\"md-block\"><label><span \ntranslate=\"RECURRENCES.MODEL.DAY_OF_MONTH\">Day of month</span></label><input required type=\"number\" step=\"any\" \nname=\"dayOfMonth\" class=\"fs-13\" ng-model=\"vm.recurrence.repeat.dayOfMonth\" min=\"1\" max=\"30\" \nng-change=\"vm.broadcastUpdateFields();\" ng-disabled=\"vm.recurrence.id\"><div layout=\"row\" \nng-messages=\"recurrenceForm[\'dayOfMonth\'].$error\" role=\"alert\" class=\"fs-15\"><div ng-message=\"required\"><small><span \nclass=\"red-text\" translate=\"RECURRENCES.MODEL.ERRORS.DAY_OF_MONTH_REQUIRED\">Day of month is required</span></small>\n</div></div></md-input-container></div><div flex=\"20\" class=\"ml-21\" ng-if=\"vm.recurrence.repeat.interval === \'weekly\'\">\n<md-input-container class=\"md-block\"><label><span translate=\"RECURRENCES.MODEL.DAY_OF_WEEK\">Day of the week</span>\n</label><md-select name=\"weekday\" ng-model=\"vm.recurrence.repeat.weekday\" \nplaceholder=\"{{ \'RECURRENCES.MODEL.DAY_OF_WEEK\' | translate }}\" ng-change=\"vm.broadcastUpdateFields();\" \nng-disabled=\"vm.recurrence.id\"><md-option class=\"service-select-options\" value=\"monday\"><span class=\"fs-13\" \ntranslate=\"RECURRENCES.MODEL.WEEK_DAYS.MONDAY\">Monday</span></md-option><md-option class=\"service-select-options\" \nvalue=\"tuesday\"><span class=\"fs-13\" translate=\"RECURRENCES.MODEL.WEEK_DAYS.TUESDAY\">Tuesday</span></md-option>\n<md-option class=\"service-select-options\" value=\"wednesday\"><span class=\"fs-13\" \ntranslate=\"RECURRENCES.MODEL.WEEK_DAYS.WEDNESDAY\">Wednesday</span></md-option><md-option \nclass=\"service-select-options\" value=\"thursday\"><span class=\"fs-13\" translate=\"RECURRENCES.MODEL.WEEK_DAYS.THURSDAY\">\nThursday</span></md-option><md-option class=\"service-select-options\" value=\"friday\"><span class=\"fs-13\" \ntranslate=\"RECURRENCES.MODEL.WEEK_DAYS.FRIDAY\">Friday</span></md-option><md-option class=\"service-select-options\" \nvalue=\"saturday\"><span class=\"fs-13\" translate=\"RECURRENCES.MODEL.WEEK_DAYS.SATURDAY\">Saturday</span></md-option>\n<md-option class=\"service-select-options\" value=\"sunday\"><span class=\"fs-13\" \ntranslate=\"RECURRENCES.MODEL.WEEK_DAYS.SUNDAY\">Sunday</span></md-option></md-select></md-input-container></div><div \nflex=\"10\"><md-input-container class=\"md-block\"><label><span translate=\"RECURRENCES.MODEL.SCHEDULE\">Schedule</span>\n</label><input ng-if=\"!vm.recurrence.id\" type=\"text\" ui-time-mask=\"short\" name=\"recurrenceTime\" class=\"fs-13\" \nng-change=\"vm.broadcastUpdateFields();\" ng-model=\"vm.recurrence.repeat.time\"> <input ng-if=\"vm.recurrence.id\" \ntype=\"text\" name=\"recurrenceTime\" class=\"fs-13\" ng-change=\"vm.broadcastUpdateFields();\" \nng-model=\"vm.recurrence.repeat.time\" ng-disabled=\"true\"><div ng-messages=\"recurrenceForm[\'recurrenceTime\'].$error\"><div\n ng-message=\"time\"><span translate=\"RECURRENCES.MODEL.ERRORS.INVALID_TIME\">Invalid time</span></div></div>\n</md-input-container></div></div><div layout=\"row\" layout-xs=\"column\" class=\"mtop-m15\" \nng-if=\"vm.skipWeekendShowOption\"><md-switch ng-model=\"vm.recurrence.repeat.skipWeekend\" class=\"fs-13 switch-button\" \nng-change=\"vm.broadcastUpdateFields();\" ng-disabled=\"vm.recurrence.id\"><span ng-if=\"vm.recurrence.repeat.skipWeekend\" \ntranslate=\"RECURRENCES.DIALOG.GENERAL.SKIP_WEEKEND\"><b>Don\'t consider</b> scheduling on weekends </span><span \nng-if=\"!vm.recurrence.repeat.skipWeekend\" translate=\"RECURRENCES.DIALOG.GENERAL.NO_SKIP_WEEKEND\"><b>Consider</b>\n scheduling on weekends</span></md-switch></div><div layout=\"row\" layout-xs=\"column\"><span class=\"hint\" \nng-bind-html=\"vm.recurrenceExplanationRepeatText\"></span></div></md-tab-body></md-tab><md-tab \ndata-cy=\"recurrenceEquipments\" \nng-if=\"vm.recurrence.id || vm.selectedCustomer.hasEquipment && !vm.canShowNewRecurrenceLinks\" \nmd-on-select=\"vm.loadRecurrenceEquipments()\" \nng-disabled=\"\n          !vm.accountConfiguration.moduleEquipmentManagementEnabled &&\n          !vm.accountConfiguration.moduleOrderEquipmentManagementEnabled &&\n          !vm.accountConfiguration.isCorporateCompany\n        \">\n<md-tab-label><span translate=\"RECURRENCES.DIALOG.EQUIPMENTS.TITLE\">Equipments</span></md-tab-label><md-tab-body \nms-scroll><div class=\"mt-20\" layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.selectedCustomer.hasEquipment\" \ntranslate=\"RECURRENCES.DIALOG.EQUIPMENTS.SEARCH.NOT_FOUND\">This customer does not have registered equipment.</div><div \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.selectedCustomer.hasEquipment\"><div class=\"search-bar\" \nlayout=\"row\" flex=\"(!vm.recurrence.id ? 100 : 80)\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" ng-model=\"vm.searchEquipmentText\" \nng-change=\"vm.searchEquipments()\" ng-disabled=\"false\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.LABEL\">Search for an equipment</label><small \nclass=\"search-bar__hint\" translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.SEARCH.HINT\">\nSearch by the equipment\'s model name or serial number.</small></div><button class=\"fc-input__button border brad-4\" \nng-click=\"vm.searchEquipments()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></button></div><button flex=\"20\" \nclass=\"new-equipment-button fc-button fc-blue full-height\" data-cy=\"link-equipment-button\" ng-if=\"!vm.recurrence.id\" \nng-click=\"vm.toggleSearchEquipments()\" translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.LINK_NEW\">\nLink equipment</button></div><div id=\"order-equipments\" class=\"pt-20\" ng-if=\"vm.selectedCustomer.hasEquipment\"><div \nlayout=\"column\" class=\"orders-equipments\"><h4 class=\"fs-16 fw-500 mv-20\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.TITLE\">Linked equipments</span>\n ({{ vm.selectedEquipments.length }} / {{ vm.maxEquipmentPerRecurrence }})</h4><div layout-xs=\"column\" layout=\"row\" \nflex=\"100\" ng-if=\"vm.selectedEquipments.length\" class=\"b brad-4 mb-10 orders-equipments__item\" \nlayout-align=\"space-between center\" ng-repeat=\"equip in vm.showingEquipments track by $index\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"h-60 w-60 brad-4 ml-20\" ng-if=\"equip.thumbnail\"><img ngf-src=\"equip.thumbnail\" \nalt=\"{{ equip.name }}\" class=\"orders-equipments__image\"></div><div layout=\"row\" class=\"border h-60 w-60 brad-4 ml-20\" \nlayout-align=\"center center\" ng-if=\"!equip.thumbnail\"><svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" \nxmlns=\"http://www.w3.org/2000/svg\"><path \nd=\"M0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0H2C0.9 0 0 0.9 0 2ZM16 16H2V2H16V16ZM11.14 8.86L8.14 12.72L6 10.14L3 14H15L11.14 8.86Z\" \nfill=\"#D4DEF1\"/></svg></div><div flex=\"80\" layout=\"column\" class=\"ph-24\"><strong class=\"fs-14 mb-5\">{{ equip.name }}\n</strong> <span class=\"fs-14 pt-6\">{{ equip.number }}</span></div></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"!vm.recurrence.id\"><md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" \nng-click=\"vm.confirmRemoveEquipment(equip)\"><md-icon style=\"color: red\" md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip>{{ \'RECURRENCES.DIALOG.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.UNLINK_EQUIPMENT\' | translate }}\n</md-tooltip></md-button></div></div><div ng-if=\"vm.showingEquipments.length\" class=\"table-navigation\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"table-navigation__info\" id=\"table-list_info\" aria-live=\"polite\"><span \ntranslate=\"RECURRENCES.DIALOG.EQUIPMENTS.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((vm.equipmentsPage - 1) * vm.equipmentsPaginateBy) + 1 }} <span \ntranslate=\"RECURRENCES.DIALOG.EQUIPMENTS.NAVIGATION.TO\">to</span>\n {{ vm.getLastEquipmentCount() > vm.equipmentOptions.length ? vm.equipmentOptions.length : vm.getLastEquipmentCount() }} \n<span translate=\"RECURRENCES.DIALOG.EQUIPMENTS.NAVIGATION.OF\">of</span> {{ vm.equipmentOptions.length }} <span \ntranslate=\"RECURRENCES.DIALOG.EQUIPMENTS.NAVIGATION.RECORDS\">records</span></div><button \nclass=\"table-navigation__button\" aria-label=\"Previous\" ng-click=\"vm.navigateToPage(vm.equipmentsPage - 1)\" \nng-disabled=\"vm.equipmentsPage === 1\"><span translate=\"RECURRENCES.DIALOG.EQUIPMENTS.NAVIGATION.PREVIOUS\">Previous\n</span></button> <button class=\"table-navigation__button\" aria-label=\"Next\" \nng-click=\"vm.navigateToPage(vm.equipmentsPage + 1)\" \nng-disabled=\"vm.equipmentsPage * vm.equipmentsPaginateBy >= vm.equipmentOptions.length\"><span \ntranslate=\"RECURRENCES.DIALOG.EQUIPMENTS.NAVIGATION.NEXT\">Next</span></button></div></div></div></md-tab-body></md-tab>\n<md-tab md-on-select=\"vm.loadedTabs.links = true;\" \nng-if=\"(vm.recurrence.id || vm.selectedCustomerLocation) && vm.canShowNewRecurrenceLinks\"><md-tab-label><div \nclass=\"tab-label-with-badge\"><span translate=\"RECURRENCES.DIALOG.LINKS.TITLE\">LINKS</span><div class=\"title-badge\">\n</div></div></md-tab-label><md-tab-body><div id=\"recurrence-dialog-link-tab\" class=\"container-tab-content\"><ng-include \nng-if=\"vm.loadedTabs.links\" src=\"\'app/main/recurrences/dialog/tabs/links/links-tab.html\'\" \nng-controller=\"RecurrencesLinksTabController as self\" onload=\"self.setControllerData(vm.recurrence)\"></ng-include>\n</div></md-tab-body></md-tab><md-tab md-on-select=\"vm.initializeOccurrences()\"><md-tab-label><span \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.TITLE\">Occurrences</span></md-tab-label><md-tab-body><div \nng-if=\"vm.loadingOccurrences\" class=\"occurrences-table-loader\"><md-progress-circular md-diameter=\"60\">\n</md-progress-circular></div><div class=\"pl-5\"><div id=\"confirm-before-save\" ng-if=\"!vm.recurrence.id\"><span \nclass=\"hint\" ng-bind-html=\"vm.recurrenceExplanationRepeatText\"></span><br><p class=\"hint text-center\" \nng-if=\"!vm.occurrences.length\"><span ng-if=\"!vm.isSimulatingOccurrences\"><span class=\"link-action\" \nng-click=\"vm.simulateOccurrences();\" translate=\"RECURRENCES.DIALOG.OCCURRENCES.SIMULATION_LINK\">Click here </span>\n&nbsp; <span translate=\"RECURRENCES.DIALOG.OCCURRENCES.SIMULATION_CTA\">\nto simulate the occurrences (dates) of the recurring activity. </span></span><span class=\"flex-center\" \nng-if=\"vm.isSimulatingOccurrences\"><span translate=\"RECURRENCES.DIALOG.OCCURRENCES.LOADING\">Loading occurrences...\n</span><md-progress-circular class=\"md-accent mleft-10\" md-mode=\"indeterminate\" md-diameter=\"14\">\n</md-progress-circular></span></p></div><div id=\"occurrences-table\" class=\"simple-table-container fs-13 mr-3 mt-10\" \nng-if=\"vm.occurrences.length\"><table class=\"simple plans-table\" ms-responsive-table><thead class=\"fs-13\"><tr><th \nclass=\"mw-50\"></th><th translate=\"RECURRENCES.DIALOG.OCCURRENCES.DATE\" \ntranslate-attr-aria-label=\"RECURRENCES.DIALOG.OCCURRENCES.DATE\">Date</th><th \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.HOUR\" translate-attr-aria-label=\"RECURRENCES.DIALOG.OCCURRENCES.HOUR\">Hour\n</th><th translate=\"RECURRENCES.DIALOG.OCCURRENCES.EMPLOYEE\" \ntranslate-attr-aria-label=\"RECURRENCES.DIALOG.OCCURRENCES.EMPLOYEE\">Employee</th><th \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.SITUATION\" \ntranslate-attr-aria-label=\"RECURRENCES.DIALOG.OCCURRENCES.SITUATION\">Situation</th><th \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.TYPE\" translate-attr-aria-label=\"RECURRENCES.DIALOG.OCCURRENCES.TYPE\">Status\n</th><th translate=\"RECURRENCES.DIALOG.OCCURRENCES.ACTIONS\" \ntranslate-attr-aria-label=\"RECURRENCES.DIALOG.OCCURRENCES.ACTIONS\">Actions</th></tr></thead><tbody class=\"fs-13\"><tr \nng-repeat=\"occurrence in vm.currentOccurrences; track by $index\"><td class=\"cursor-default\">{{ occurrence.iteration }}.\n</td><td><md-datepicker class=\"icon-hide\" name=\"scheduling_date_{{ occurrence.iteration }}\" \nng-change=\"vm.updateOccurrence(occurrence);\" ng-model=\"occurrence.scheduled.date\" \nmd-placeholder=\"{{ \'RECURRENCES.DIALOG.OCCURRENCES.DATE\' | translate }}\" ng-disabled=\"!occurrence.editMode\" required>\n</md-datepicker><div layout=\"row\" ng-messages=\"recurrenceForm[\'scheduling_date_\' + occurrence.iteration].$error\" \nng-show=\"recurrenceForm[\'scheduling_date_\' + occurrence.iteration].$touched\" role=\"alert\" class=\"fs-15\"><div \nng-message=\"required\"><small><span class=\"red-text\" translate=\"RECURRENCES.MODEL.ERRORS.SCHEDULING_DATE_REQUIRED\">\nFrom date is required</span></small></div><div ng-message=\"valid\"><small><span class=\"red-text\" \ntranslate=\"RECURRENCES.MODEL.ERRORS.INVALID_DATE\">The entered value is not a date</span></small></div></div></td><td \nclass=\"occurrences-time-row\"><div><md-input-container><input class=\"fs-13\" type=\"text\" \nname=\"scheduling_time_{{ occurrence.iteration }}\" ui-time-mask=\"short\" ng-model=\"occurrence.scheduled.time\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.updateOccurrenceScheduledTime(occurrence);\" \nng-disabled=\"!occurrence.editMode\"><div ng-messages=\"recurrenceForm[\'scheduling_time_\' + occurrence.iteration].$error\" \nng-show=\"recurrenceForm[\'scheduling_time_\' + occurrence.iteration].$touched\"><div ng-message=\"time\"><small><span \nclass=\"red-text\" translate=\"RECURRENCES.MODEL.ERRORS.INVALID_TIME\">Invalid time</span></small></div></div>\n</md-input-container></div></td><td><md-select class=\"w-250 employee-input-margin\" \nname=\"employee_{{ occurrence.iteration }}\" ng-model=\"occurrence.employee.id\" \nng-change=\"vm.updateOccurrence(occurrence);\" ng-disabled=\"!occurrence.editMode\" \nng-required=\"vm.selectedCustomer.metadata.featureRecurrenceAssignedEmployeeRequired\" \nplaceholder=\"{{ \'RECURRENCES.MODEL.EMPLOYEE\' | translate }}\"><md-option class=\"service-select-options\" value=\"null\" \nng-if=\"occurrence.task\"><span translate=\"RECURRENCES.MODEL.NO_EMPLOYEE\">No employee</span></md-option><md-option \nclass=\"service-select-options\" value=\"{{ employee.id }}\" ng-repeat=\"employee in vm.employees\" \nng-class=\"vm.setInactiveOrArchivedClass(employee)\"><img ng-if=\"employee.avatarUrl\" alt=\"{{ ::employee.name }}\" \nng-src=\"{{ ::employee.avatarUrl }}\" class=\"avatar-select-mini\"> <img ng-if=\"!employee.avatarUrl\" \nalt=\"{{ ::employee.name }}\" src=\"assets/images/avatars/profile.jpg\" class=\"avatar-select-mini\"> <span>\n{{ ::employee.name }}</span> <span class=\"caption inactive-label\" translate=\"RECURRENCES.MODEL.INACTIVE_EMPLOYEE\" \nng-if=\"employee.isInactivatedOrFired\">Inactive</span></md-option></md-select></td><td class=\"cursor-default\"><span \nclass=\"color-grey\" ng-if=\"!occurrence.task\" translate=\"RECURRENCES.DIALOG.OCCURRENCES.WAITING\">Waiting... </span><span \nng-if=\"occurrence.task && occurrence.task.id && !occurrence.task.archived\" \nclass=\"{{ occurrence.task.status.colorClass }}\">{{occurrence.task.status.description }} </span><span \nng-if=\"occurrence.task && occurrence.task.id && occurrence.task.archived\" class=\"grey-400-fg\" \ntranslate=\"RECURRENCES.MODEL.ARCHIVED\">Archived</span></td><td><div ng-if=\"!occurrence.scheduled.type\"><span>-</span>\n</div><div ng-if=\"occurrence.scheduled.type\"><span class=\"cursor-default\" \nng-if=\"occurrence.scheduled.type === \'automatic\'\" translate=\"RECURRENCES.DIALOG.OCCURRENCES.SCHEDULED.AUTOMATIC\">\nAutomatic </span><span class=\"cursor-default\" ng-if=\"occurrence.scheduled.type === \'manual\'\" \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.SCHEDULED.MANUAL\">Manual</span><md-icon class=\"cursor-pointer fs-18 pb-28\" \nmd-font-icon=\"icon-information-outline\"><md-tooltip><span translate=\"RECURRENCES.TABLE.CREATED_AT\">Created on</span>\n {{ occurrence.scheduled._at }}</md-tooltip></md-icon></div></td><td class=\"actions-column cursor-pointer\"><md-menu \nmd-position-mode=\"target-right target\"><span ng-click=\"$mdOpenMenu($event)\"><md-icon ng-if=\"!occurrence.confirmMode\" \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></span><md-menu-content><md-menu-item \nng-if=\"!occurrence.editMode && occurrence.id\"><md-button class=\"link-action\" ng-click=\"vm.editOccurrence(occurrence)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><span translate=\"RECURRENCES.DIALOG.OCCURRENCES.EDIT\">Edit</span>\n</md-button></md-menu-item><md-menu-item ng-if=\"!occurrence.id\"><md-button class=\"link-action\" \nng-click=\"vm.deleteOccurrence($index);\"><md-icon md-font-icon=\"icon-close\"></md-icon><span \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.REMOVE\">Remove</span></md-button></md-menu-item><md-menu-item \nng-if=\"occurrence.id && !occurrence.task.id\"><md-button class=\"link-action\" ng-click=\"vm.addTask(occurrence);\" \nng-disabled=\"vm.recurrence.archived\"><md-icon class=\"create-task\" md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.ADD\">Add</span> <span \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.ARCHIVED_RECURRENCE\" ng-if=\"vm.recurrence.archived\">\nArchived recurrence, you can\'t add it</span></md-button></md-menu-item><md-menu-item \nng-if=\"occurrence.id && occurrence.task.id && !occurrence.task.archived\"><md-button class=\"link-action\" \nng-click=\"vm.cofirmEditOccurrence(occurrence);\" ng-disabled=\"vm.recurrence.archived\"><md-icon \nmd-svg-src=\"assets/icons/icon-archive-arrow-down.svg\"></md-icon><span \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.ARCHIVE_TASK\">Archive task</span></md-button></md-menu-item><md-menu-item \nng-if=\"occurrence.id && occurrence.task.id && occurrence.task.archived\"><md-button class=\"link-action\" \nng-click=\"vm.cofirmEditOccurrence(occurrence);\" ng-disabled=\"vm.recurrence.archived\"><md-icon \nmd-svg-src=\"assets/icons/icon-archive-arrow-up.svg\"></md-icon><span \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.UNARCHIVE_TASK\">Unarchive task</span></md-button></md-menu-item>\n</md-menu-content></md-menu><span class=\"link-action\" \nng-if=\"occurrence.confirmMode && occurrence.id && occurrence.task.id && !occurrence.task.archived\" \nng-click=\"vm.archiveTask(occurrence);\" ng-disabled=\"vm.recurrence.archived\"><md-icon class=\"blue-500-fg\" \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip><span translate=\"RECURRENCES.DIALOG.OCCURRENCES.CONFIRM\">Confirm</span>\n</md-tooltip></span><span class=\"link-action\" \nng-if=\"occurrence.confirmMode && occurrence.id && occurrence.task.id && occurrence.task.archived\" \nng-click=\"vm.unarchiveTask(occurrence);\" ng-disabled=\"vm.recurrence.archived\"><md-icon class=\"blue-500-fg\" \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip><span translate=\"RECURRENCES.DIALOG.OCCURRENCES.CONFIRM\">Confirm</span>\n</md-tooltip></span><span class=\"link-action\" ng-if=\"occurrence.confirmMode && occurrence.id && occurrence.task.id\" \nng-click=\"vm.dismissEditOccurrence(occurrence);\" ng-disabled=\"vm.recurrence.archived\"><md-icon class=\"red-500-fg\" \nmd-font-icon=\"icon-close\"></md-icon><md-tooltip><span translate=\"RECURRENCES.DIALOG.OCCURRENCES.CANCEL\">Cancel</span>\n</md-tooltip></span></td></tr></tbody></table><div layout=\"row\"><div class=\"table-navigation-dialog\"><div \nclass=\"table-navigation-dialog__info\" id=\"table-list_info\" aria-live=\"polite\"><span \ntranslate=\"RECURRENCES.DIALOG.NAVIGATION.SHOWING_FROM\">Showing from</span> {{ vm.pagination.firstPageIndex }} <span \ntranslate=\"RECURRENCES.DIALOG.NAVIGATION.TO\">to</span> {{ vm.pagination.lastPageIndex }} <span \ntranslate=\"RECURRENCES.DIALOG.NAVIGATION.OF\">of</span> {{ vm.pagination.totalItems }} <span \ntranslate=\"RECURRENCES.DIALOG.NAVIGATION.RECORDS\">records</span></div><button class=\"table-navigation-dialog__button\" \nng-disabled=\"vm.pagination.currentPage === 1\" ng-click=\"vm.loadPaginated(vm.pagination.currentPage - 1)\"><span \ntranslate=\"RECURRENCES.DIALOG.NAVIGATION.PREVIOUS\">Previous</span></button> <button \nclass=\"table-navigation-dialog__button\" aria-label=\"Next\" \nng-disabled=\"vm.pagination.currentPage === vm.pagination.totalPages\" \nng-click=\"vm.loadPaginated(vm.pagination.currentPage + 1)\"><span translate=\"RECURRENCES.DIALOG.NAVIGATION.NEXT\">Next\n</span></button></div></div></div></div><div class=\"hint-warning\" if=\"vm.occurrences.length\"><p class=\"hint\"><span \ntranslate=\"RECURRENCES.DIALOG.OCCURRENCES.HINT\">The occurrences are simulated for the <b><u>next 90 days</u></b>.<br>\nThe activities will be created automatically by Field Control <b><u>30 days before the scheduling date</u></b>\n of the occurrence.</span></p></div></md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.isCopyingRecurrence\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"vm.recurrence.id && vm.editPermission\" \nng-click=\"vm.saveRecurrenceByFlag(vm.recurrence, { closeDialog: true });\" class=\"send-button md-accent md-raised\" \ndata-cy=\"save-recurrence-button\" \nng-disabled=\"recurrenceForm.$invalid ||recurrenceForm.$pristine || !vm.recurrence.customer.id || $root.loadingProgress || vm.formErr[\'notSkilledEmployee_\']\" \naria-label=\"Save\" translate=\"RECURRENCES.DIALOG.ACTIONS.SAVE\" \ntranslate-attr-aria-label=\"RECURRENCES.DIALOG.ACTIONS.SAVE\">Save</md-button><md-button \ndata-cy=\"create-recurrence-button\" type=\"submit\" ng-if=\"!vm.recurrence.id && vm.addPermission\" \nng-click=\"vm.saveRecurrenceByFlag(vm.recurrence, { closeDialog: true });\" class=\"send-button md-accent md-raised\" \nng-disabled=\"recurrenceForm.$invalid || recurrenceForm.$pristine || !vm.recurrence.customer.id || $root.loadingProgress || vm.formErr[\'notSkilledEmployee_\']\" \naria-label=\"Create\" translate=\"RECURRENCES.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"RECURRENCES.DIALOG.ACTIONS.CREATE\">Create</md-button><div \nng-if=\"vm.recurrence.id && !vm.editPermission\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"warning-task-locked ng-scope\" translate=\"TASKS.DIALOG.ACTIONS.ALERTS.CANT_EDIT\">\nYou do not have permission to edit activities</span></div><div ng-if=\"!vm.recurrence.id && !vm.addPermission\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"warning-task-locked ng-scope\" \ntranslate=\"TASKS.DIALOG.ACTIONS.ALERTS.CANT_CREATE\">You do not have permission to create activities</span></div></div>\n<div layout=\"row\"><md-button ng-click=\"vm.createRecurrenceCopy($event)\" ng-if=\"vm.recurrence.id\" \nclass=\"md-icon-button\" aria-label=\"Create a copy\" translate \ntranslate-attr-aria-label=\"RECURRENCES.DIALOG.ACTIONS.CREATE_COPY\" ng-disabled=\"!vm.editPermission\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"RECURRENCES.DIALOG.ACTIONS.CREATE_COPY\">Create a copy</span></md-tooltip></md-button><md-button \ndata-cy=\"archive-recurrence-button\" ng-show=\"!vm.recurrence.archived && vm.recurrence.id\" class=\"md-icon-button\" \nng-disabled=\"!vm.editPermission\" ng-click=\"vm.archiveOrUnarchiveRecurrence(vm.recurrence, true)\" aria-label=\"Archive\" \ntranslate translate-attr-aria-label=\"RECURRENCES.DIALOG.ACTIONS.ARCHIVE\"><md-icon md-font-icon=\"icon-folder-download\">\n</md-icon><md-tooltip md-direction=\"top\"><span translate=\"RECURRENCES.DIALOG.ACTIONS.ARCHIVE\">Archive</span>\n</md-tooltip></md-button><md-button ng-show=\"vm.recurrence.archived && vm.recurrence.id\" class=\"md-icon-button\" \nng-disabled=\"!vm.editPermission\" ng-click=\"vm.archiveOrUnarchiveRecurrence(vm.recurrence, false)\" \naria-label=\"Unarchive\" translate translate-attr-aria-label=\"RECURRENCES.DIALOG.ACTIONS.UNARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"RECURRENCES.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/services/dialogs/service-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large service-dialog service-dialog-content\" aria-label=\"Tipo de OS\">\n<md-toolbar class=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span ng-show=\"!vm.service.id\" \nclass=\"title\" translate=\"SERVICES.DIALOG.NEW.TITLE\">New service</span> <span ng-show=\"vm.service.id\" class=\"title\" \ntranslate=\"SERVICES.DIALOG.EDIT.TITLE\">Edit service</span></div><div class=\"sidebar-dialog__header__actions\"><md-button\n data-cy=\"close-dialog-button\" class=\"md-icon-button\" ng-click=\"vm.closeDialog();\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"SERVICES.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"serviceForm\" data-cy=\"serviceForm\" class=\"md-inline-form\" novalidate><md-dialog-content \nms-scroll class=\"pt-0 pr-0\"><md-tabs class=\"ml-24n mr-24n\" md-selected=\"vm.selectedTabIndex\" md-dynamic-height><md-tab>\n<md-tab-label><span translate=\"SERVICES.DIALOG.GENERAL.TITLE\">General</span></md-tab-label><md-tab-body>\n<corporate-customer-disclaimer ng-if=\"vm.service.metadata && vm.service.metadata.sammathnaur\" \ncustomer-name=\"vm.service.metadata.sammathnaur.account.name\"></corporate-customer-disclaimer><div \nng-include=\"\'app/main/services/dialogs/tabs/general-tab.html\'\"></div></md-tab-body></md-tab><md-tab><md-tab-label><span\n data-cy=\"forms-tab\" translate=\"SERVICES.DIALOG.FORMS.TITLE\">Forms</span></md-tab-label><md-tab-body>\n<corporate-customer-disclaimer ng-if=\"vm.service.metadata && vm.service.metadata.sammathnaur\" \ncustomer-name=\"vm.service.metadata.sammathnaur.account.name\"></corporate-customer-disclaimer><div \nng-include=\"\'app/main/services/dialogs/tabs/forms-tab.html\'\"></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ndata-cy=\"employees-tab\" translate=\"SERVICES.DIALOG.EMPLOYEES.TITLE\">Employees</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/services/dialogs/tabs/employees-tab.html\'\"></div></md-tab-body></md-tab><md-tab><md-tab-label>\n<span data-cy=\"template-tab\" translate=\"SERVICES.DIALOG.TEMPLATE.TITLE\">Models</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/services/dialogs/tabs/order-report-template-tab.html\'\"></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button data-cy=\"save-button\" type=\"submit\" ng-if=\"!vm.newService\" \nng-click=\"vm.editService()\" class=\"fc-button fc-button--actions\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine || $root.loadingProgress === true\" aria-label=\"Save\" \ntranslate=\"SERVICES.DIALOG.ACTIONS.SAVE\" translate-attr-aria-label=\"SERVICES.DIALOG.ACTIONS.SAVE\">Save</md-button>\n<md-button data-cy=\"create-button\" type=\"submit\" ng-if=\"vm.newService\" ng-click=\"vm.createService()\" \nclass=\"fc-button fc-button--actions\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine || $root.loadingProgress === true\" aria-label=\"Add Service\" \ntranslate=\"SERVICES.DIALOG.ACTIONS.CREATE\" translate-attr-aria-label=\"SERVICES.DIALOG.ACTIONS.CREATE\">Add service\n</md-button></div><div layout=\"row\"><md-button data-cy=\"archive-button\" \nng-show=\"(!vm.service.archived && vm.service.id)\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" class=\"md-icon-button\" \nng-click=\"vm.archiveService($event)\" data-cy=\"archive-service-button\" aria-label=\"Archive\" translate \ntranslate-attr-aria-label=\"SERVICES.DIALOG.ACTIONS.ARCHIVE\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"SERVICES.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip>\n</md-button><md-button data-cy=\"unarchive-button\" ng-show=\"(vm.service.archived && vm.service.id)\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" class=\"md-icon-button\" \nng-click=\"vm.unarchiveService($event)\" aria-label=\"Unarchive\" translate \ntranslate-attr-aria-label=\"SERVICES.DIALOG.ACTIONS.UNARCHIVE\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"SERVICES.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/contents/dev-settings.html","<div class=\"simple-table-container\"><div class=\"table-title\"><span \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_KEY.TITLE\">Integration key</span><div><span \nclass=\"fs-13 secondary-text\" translate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_KEY.DESCRIPTION\">\nIntegration keys are used to programmatically access Field Control data</span></div></div><table class=\"simple\" \nms-responsive-table><thead><tr><th translate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_KEY.NAME\">Key name integration\n</th><th translate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_KEY.PREFIX\">Prefix</th><th \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_KEY.CREATED_ON\">Created on</th><th \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_KEY.CREATED_BY\">Created by</th><th \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_KEY.ACTIONS\">Actions</th></tr></thead><tfoot><tr><td \nng-if=\"!vm.apiKey\" colspan=\"5\"><div layout=\"row\" layout-align=\"center center\" class=\"mt-15\"><span \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_KEY.NOT_HAVE_INTEGRATION_KEY\">\nYour account does not yet have an integration key, create one </span>&nbsp; <a class=\"clickable\" \nng-click=\"vm.createApiKey($event)\"><span translate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_KEY.CLICKING_HERE\">\nclicking here </span></a>.</div></td></tr></tfoot><tbody><tr ng-if=\"vm.apiKey\"><td>{{ vm.apiKey.name }}</td><td>\n{{ vm.apiKey.prefix }}</td><td>{{ vm.apiKey.createdAt | date: vm.dateFormat}}</td><td>{{ vm.apiKey.createdBy }}</td><td\n class=\"no-margin-important no-padding-important w-100\"><md-button \nng-click=\"vm.confirmDeleteApiKey($event, vm.apiKey)\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_KEY.DELETE_INTEGRATION_KEY\">Delete integration key</span>\n</md-tooltip></md-button></td></tr></tbody></table></div><div class=\"simple-table-container\"><div class=\"table-title\">\n<span translate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.TITLE\">Integration webhooks</span><div><span \nclass=\"fs-13 secondary-text\" translate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.DESCRIPTION\">\nWebhooks are notifications that will be sent to your system when modifications occur in Field Control</span></div>\n</div><table class=\"simple\" ms-responsive-table><thead><tr><th \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.INTEGRATION_URL\">Integration URL</th><th \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.AUTHENTICATION\">Authentication</th><th \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.CREATED_ON\">Created on</th><th \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.CREATED_BY\">Created by</th><th \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.ACTIONS\">Actions</th></tr></thead><tfoot><tr><td \nng-if=\"!vm.webhookConfiguration\" colspan=\"5\"><div layout=\"row\" layout-align=\"center center\" class=\"mt-15\"><span \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.NOT_HAVE_INTEGRATION_WEBHOOK\">\nYour account does not yet have an integration webhook, create one </span>&nbsp; <a class=\"clickable\" \nng-click=\"vm.createWebhookConfiguration($event);\"><span \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.CLICKING_HERE\">clicking here </span></a>.</div></td></tr>\n</tfoot><tbody><tr ng-if=\"vm.webhookConfiguration\"><td class=\"w-500 integration-url\">{{ vm.webhookConfiguration.url }}\n</td><td><span ng-if=\"vm.webhookConfiguration.authentication.type === \'none\'\" \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.NONE\">None </span><span \nng-if=\"vm.webhookConfiguration.authentication.type === \'httpBasicAuthentication\'\"><span \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.BASIC_AUTH\">Basic authentication </span>(BasicAuth)</span>\n</td><td>{{ vm.webhookConfiguration.createdAt | date: vm.dateFormat}}</td><td>{{ vm.webhookConfiguration.createdBy }}\n</td><td class=\"no-margin-important no-padding-important w-100\"><md-button \nng-click=\"vm.confirmDeleteWebhook($event, vm.webhookConfiguration)\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.INTEGRATION_WEBHOOKS.DELETE_INTEGRATION_WEBHOOK\">Delete integration webhook\n</span></md-tooltip></md-button></td></tr></tbody></table></div><div class=\"documentation-link-box-container\"><div \nclass=\"documentation-link-box full\"><h4 class=\"documentation-link-title\" \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.DOCUMENTATION.TITLE\">Documentation</h4><p \nclass=\"documentation-link-description\" translate=\"CONFIGURATIONS.DEV_SETTINGS.DOCUMENTATION.DESCRIPTION\">\nClick on the link below to access the documentation and have more details on how to integrate</p><md-button \nclass=\"md-accent md-raised\" ng-href=\"https://developers.fieldcontrol.com.br/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-document\" class=\"documentation-button-icon\"></md-icon><span \ntranslate=\"CONFIGURATIONS.DEV_SETTINGS.DOCUMENTATION.BUTTON\">Access documentation</span></md-button></div></div>");
$templateCache.put("app/main/settings/contents/dev-webhooks-callbacks.html","<div class=\"simple-table-container\"><div class=\"table-title\"><span translate=\"CONFIGURATIONS.WEBHOOKS_CALLBACKS.TITLE\">\nWebhooks requests</span><div><span class=\"fs-13 secondary-text\"><span \ntranslate=\"CONFIGURATIONS.WEBHOOKS_CALLBACKS.DESCRIPTION\">\nIn this section, all requests for the integration webhook will be displayed</span></span></div></div><table \nms-responsive-table class=\"simple\"><thead><tr><th width=\"40%\" \ntranslate=\"CONFIGURATIONS.WEBHOOKS_CALLBACKS.REQUEST_IDENTIFIER\">Request identifier</th><th width=\"25%\" \ntranslate=\"CONFIGURATIONS.WEBHOOKS_CALLBACKS.EVENT\">Event</th><th width=\"25%\" \ntranslate=\"CONFIGURATIONS.WEBHOOKS_CALLBACKS.SENT_IN\">Sent in</th><th width=\"10%\" align=\"right\" \ntranslate=\"CONFIGURATIONS.WEBHOOKS_CALLBACKS.SEE_DETAILS\">See details</th></tr></thead><tfoot><tr><td colspan=\"5\"><div \nlayout=\"row\" layout-align=\"center center\" class=\"secondary-text mt-15\" \nng-if=\"!vm.webhookResponses.length && !vm.isLoading\"><span \ntranslate=\"CONFIGURATIONS.WEBHOOKS_CALLBACKS.NO_INTEGRATION_EVENTS\">There are no integration events for your account\n</span></div><div id=\"loader-gantt-tasks\" class=\"loading-gantt-tasks\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.isLoading\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular><div translate=\"CONTROL_PANEL.VIEWS.GANTT.CONTENT.LOADING\">Loading tasks...</div></div></td>\n</tr><tr><td ng-if=\"vm.webhookResponses.length > 9 && vm.webhookResponsesNexToken\" colspan=\"5\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"secondary-text mt-15\"><a class=\"clickable\" \nng-click=\"vm.loadWebhookResponsesHistory(vm.webhookConfiguration.id, vm.webhookResponsesNexToken);\" \ntranslate=\"CONFIGURATIONS.WEBHOOKS_CALLBACKS.LOAD_MORE\">Load more</a></div></td></tr></tfoot><tbody \nng-if=\"vm.webhookResponses.length\"><tr ng-repeat=\"webhookResponse in vm.webhookResponses\"><td><div layout=\"row\" \nlayout-align=\"start center\"><div><span class=\"badge md-red-A700-bg\" \nng-if=\"!(webhookResponse.response.statusCode >= 200 && webhookResponse.response.statusCode < 300)\">\n{{ webhookResponse.response.statusCode }} </span><span class=\"badge md-green-900-bg\" \nng-if=\"(webhookResponse.response.statusCode >= 200 && webhookResponse.response.statusCode < 300)\">\n{{ webhookResponse.response.statusCode }}</span></div><span class=\"ml-5\">{{ webhookResponse.id }}</span></div></td><td>\n{{ webhookResponse.eventName }}</td><td>{{ webhookResponse.createdAt | date: vm.dateFormat }}</td><td align=\"center\">\n<md-button ng-click=\"vm.openWebhookResponseDetails($event, webhookResponse)\" class=\"md-icon-button\"><img \nng-src=\"assets/icons/icon-edit.svg\" alt=\"Edit\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CONFIGURATIONS.WEBHOOKS_CALLBACKS.DETAILS\">Details</span></md-tooltip></md-button></td></tr></tbody></table>\n</div>");
$templateCache.put("app/main/settings/contents/integrations.html","<div layout=\"row\" layout-wrap ms-scroll><fc-card icon=\"conta-azul\" title=\"Conta Azul\" \ndescription=\"{{ \'CONFIGURATIONS.INTEGRATIONS.CONTA_AZUL.DESCRIPTION\' | translate }}\" \nconfiguration=\"{isEnable: vm.integrations.contaAzul, isIntegration: true}\" \nopen-function=\"!vm.integrations.contaAzul ? vm.contaAzulOAuth() : vm.contaAzulDisconnect()\"></fc-card><fc-card \nicon=\"omie\" title=\"Omie\" description=\"{{ \'CONFIGURATIONS.INTEGRATIONS.OMIE.DESCRIPTION\' | translate }}\" \nconfiguration=\"{isEnable: vm.integrations.omie, isIntegration: true}\" \nopen-function=\"vm.manageIntegrationOmie($event);\"></fc-card></div>");
$templateCache.put("app/main/settings/contents/mobile-app.html","<div layout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.CUSTOM_TASK_CARD.TITLE\">Enable track</h3>\n<md-switch data-cy=\"custom-task-card-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileCustomTaskCardEnabled\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.CUSTOM_TASK_CARD.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"mt-15n end-session\"><span class=\"hint\" translate=\"CONFIGURATIONS.MOBILE.CUSTOM_TASK_CARD.HINT\">\nThis option enables employee location and route history.</span><div \nng-if=\"vm.configuration.mobileCustomTaskCardEnabled\" class=\"custom-task-card\"><div class=\"custom-task-card__header\"><h3\n translate=\"CONFIGURATIONS.MOBILE.CUSTOM_TASK_CARD.SELECT\"></h3>&nbsp;<p \ntranslate=\"CONFIGURATIONS.MOBILE.CUSTOM_TASK_CARD.MAX_SELECTED\"></p></div><div class=\"custom-task-card__content\">\n<md-checkbox data-cy=\"custom-task-card-order-service-checkbox\" class=\"md-primary\" \nng-checked=\"vm.isCustomTaskCardChecked(\'order-service\')\" ng-click=\"vm.toggleCustomTaskCard(\'order-service\')\">\n{{ \'CONFIGURATIONS.MOBILE.CUSTOM_TASK_CARD.ORDER_SERVICE\' | translate }}</md-checkbox><md-checkbox \ndata-cy=\"custom-task-card-equipment-number-checkbox\" class=\"md-primary\" \nng-checked=\"vm.isCustomTaskCardChecked(\'equipment-number\')\" ng-click=\"vm.toggleCustomTaskCard(\'equipment-number\')\">\n{{ \'CONFIGURATIONS.MOBILE.CUSTOM_TASK_CARD.EQUIPMENT_NUMBER\' | translate }}</md-checkbox><md-checkbox \ndata-cy=\"custom-task-card-order-identifier-checkbox\" class=\"md-primary\" \nng-checked=\"vm.isCustomTaskCardChecked(\'order-identifier\')\" ng-click=\"vm.toggleCustomTaskCard(\'order-identifier\')\">\n{{ \'CONFIGURATIONS.MOBILE.CUSTOM_TASK_CARD.ORDER_IDENTIFIER\' | translate }}</md-checkbox><md-checkbox \ndata-cy=\"custom-task-card-location-name-checkbox\" class=\"md-primary\" \nng-checked=\"vm.isCustomTaskCardChecked(\'location-name\')\" ng-click=\"vm.toggleCustomTaskCard(\'location-name\')\">\n{{ \'CONFIGURATIONS.MOBILE.CUSTOM_TASK_CARD.LOCATION_NAME\' | translate }}</md-checkbox></div><div \nng-if=\"vm.showMaxCustomTaskCardConfigError\" class=\"custom-task-card__error\"><md-icon class=\"red-500-fg\" \nmd-font-icon=\"icon-alert\"></md-icon><span>{{ \'CONFIGURATIONS.MOBILE.CUSTOM_TASK_CARD.ERROR\' | translate }}</span></div>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.ENABLE_TRACKING.TITLE\">\nEnable track</h3><md-switch data-cy=\"geolocation-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileGeolocationOn\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.ENABLE_TRACKING.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.ENABLE_TRACKING.HINT\">\nThis option enables employee location and route history.</div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.UPLOAD_GALLERY_ON.TITLE\">Enable uploading of images through the gallery</h3><md-switch\n data-cy=\"upload-gallery-switch\" class=\"md-secondary ml-10 mt-10\" ng-model=\"vm.configuration.mobileUploadGalleryOn\" \naria-label=\"Enable uploading of images through the gallery\" translate \ntranslate-attr-aria-label=\"CONFIGURATIONS.MOBILE.UPLOAD_GALLERY_ON.TITLE\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.UPLOAD_GALLERY_ON.HINT\">\nThis option allows employees to upload images through the photo gallery.</div><div ng-if=\"vm.canShowOrcTicketsConfig\">\n<div layout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.ENABLE_TICKETS.TITLE\"></h3><md-switch \ndata-cy=\"show-mobile-tickets-switch\" class=\"md-secondary ml-10 mt-10\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.ENABLE_TICKETS.TITLE\' | translate}}\" ng-model=\"vm.configuration.mobileTicketsOn\">\n</md-switch></div><div class=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.ENABLE_TICKETS.HINT\">\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.configuration.mobileTicketsOn\"><md-list class=\"pt-5\">\n<md-list-item class=\"mb-40n\"><md-input-container class=\"md-block fs-16\"><label \ntranslate=\"CONFIGURATIONS.MOBILE.ENABLE_TICKETS.SEARCH_EMPLOYEES\"></label><input \nng-model=\"vm.allowTicketsEmployeeSearch\" ng-model-options=\"{ debounce: 100 }\"></md-input-container></md-list-item>\n<md-list-item class=\"member\" ng-repeat=\"employee in vm.employees | filter: { name: vm.allowTicketsEmployeeSearch }\" \nng-click=\"vm.toggleInArray(employee._id, vm.configuration.mobileTicketsOnEmployeeIds)\"><div class=\"avatar grey-bg\"><img\n alt=\"{{employee.name}}\" class=\"avatar\" \nng-src=\"{{employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ employee.name }}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(employee._id, vm.configuration.mobileTicketsOnEmployeeIds)\"></i></md-list-item>\n</md-list></div></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.configuration.mobileGeolocationOn\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.GPS_ACCURACY.TITLE\">GPS accuracy</h3><md-select data-cy=\"geolocation-accuracy-select\" \nclass=\"w-100 ml-20 mt-10 fs-14\" aria-label=\"{{\'CONFIGURATIONS.MOBILE.GPS_ACCURACY.TITLE\' | translate}}\" \nng-model=\"vm.configuration.mobileGeolocationDesiredAccuracy\"><md-optgroup class=\"remove-label\"><md-option \ndata-cy=\"high-option\" value=\"-1\"><span translate=\"CONFIGURATIONS.MOBILE.GPS_ACCURACY.HIGH\">High</span></md-option>\n<md-option data-cy=\"average-option\" value=\"0\"><span translate=\"CONFIGURATIONS.MOBILE.GPS_ACCURACY.AVERAGE\">Average\n</span></md-option><md-option data-cy=\"low-option\" value=\"10\"><span translate=\"CONFIGURATIONS.MOBILE.GPS_ACCURACY.LOW\">\nLow</span></md-option></md-optgroup></md-select></div><div class=\"hint fs-12 mt-15n end-session\" \ntranslate=\"CONFIGURATIONS.MOBILE.GPS_ACCURACY.HINT\" ng-if=\"vm.configuration.mobileGeolocationOn\">\nHigher GPS accuracy means higher battery consumption.</div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.ALLOW_CREATE_NEW_TASKS.TITLE\">Allow creating new activities from prohibited services\n</h3><md-switch data-cy=\"allow-create-new-tasks-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileAllowCreateNewTasks\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.ALLOW_CREATE_NEW_TASKS.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.ALLOW_CREATE_NEW_TASKS.HINT\">\nFor companies where the external employee has the autonomy to add new activities in prohibited services</div><div \nlayout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.START_PENDING_TASKS.TITLE\">\nAllow access to pending activities</h3><md-switch data-cy=\"show-pending-tasks-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileShowPendingTasksOn\" ng-change=\"vm.notifyMobileShowPendingTasksChanged();\"></md-switch>\n</div><div class=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.START_PENDING_TASKS.HINT\">\nThe employee will be able to choose which activities to carry out from the list of pending activities, in addition to having automatic access to the configuration of reordering activities.\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.configuration.mobileShowPendingTasksOn\"><md-list class=\"pt-5\">\n<md-list-item class=\"mb-40n\"><md-input-container class=\"md-block fs-16\"><label \ntranslate=\"CONFIGURATIONS.MOBILE.START_PENDING_TASKS.SEARCH_EMPLOYEES\">Look for employee</label><input \nng-model=\"vm.employeeSearch\" ng-model-options=\"{ debounce: 100 }\"></md-input-container></md-list-item><md-list-item \nclass=\"member\" ng-repeat=\"employee in vm.employees | filter: { name: vm.employeeSearch }\" \nng-click=\"vm.toggleInArray(employee.id, vm.configuration.mobileShowPendingTasksEmployeeIds)\"><div \nclass=\"avatar grey-bg\"><img alt=\"{{employee.name}}\" class=\"avatar\" \nng-src=\"{{employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ employee.name }}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(employee.id, vm.configuration.mobileShowPendingTasksEmployeeIds)\"></i>\n</md-list-item></md-list></div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.ALLOW_REORDER_TASKS.TITLE\">Allow reorder tasks</h3><md-switch \ndata-cy=\"reorder-tasks-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileReorderActivitiesListOn\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.ALLOW_REORDER_TASKS.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.ALLOW_REORDER_TASKS.HINT\">\nFor companies where the external employee has the autonomy to organize activities.</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.LIST_TASKS.TITLE\">List tasks for the next few days</h3>\n<md-switch data-cy=\"list-tasks-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileBrowseBackAndForwardActivitiesListOn\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.LIST_TASKS.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.LIST_TASKS.HINT\">\nBesides being able to see the visits of the day he can see the visits that have already been made and those that are scheduled for the next few days.\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.configuration.mobileBrowseBackAndForwardActivitiesListOn\">\n<md-list class=\"pt-5\"><h3 translate=\"CONFIGURATIONS.MOBILE.LIST_TASKS_ALLOWED_DAYS.TITLE\">\nDays available to list past and future tasks</h3><div class=\"hint fs-12 pt-5 mt-15n\" \nng-if=\"vm.configuration.mobileBrowseBackAndForwardActivitiesListOn\" \ntranslate=\"CONFIGURATIONS.MOBILE.LIST_TASKS_ALLOWED_DAYS.HINT\">Defines which days the employee can view the tasks.\n</div><md-list-item class=\"label\" \nng-click=\"vm.toggleInArray(\'yesterday\', vm.configuration.mobileBrowseBackAndForwardActivitiesListAllowedDays)\"><p \ntranslate=\"CONFIGURATIONS.MOBILE.LIST_TASKS_ALLOWED_DAYS.YESTERDAY\">Yesterday</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'yesterday\', vm.configuration.mobileBrowseBackAndForwardActivitiesListAllowedDays)\"></i>\n</md-list-item><md-list-item class=\"label\" \nng-click=\"vm.toggleInArray(\'tomorrow\', vm.configuration.mobileBrowseBackAndForwardActivitiesListAllowedDays)\"><p \ntranslate=\"CONFIGURATIONS.MOBILE.LIST_TASKS_ALLOWED_DAYS.TOMORROW\">Tomorrow</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'tomorrow\', vm.configuration.mobileBrowseBackAndForwardActivitiesListAllowedDays)\"></i></md-list-item>\n<md-list-item class=\"label\" \nng-click=\"vm.toggleInArray(\'nextWeek\', vm.configuration.mobileBrowseBackAndForwardActivitiesListAllowedDays)\"><p \ntranslate=\"CONFIGURATIONS.MOBILE.LIST_TASKS_ALLOWED_DAYS.NEXT_WEEK\">Next week</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'nextWeek\', vm.configuration.mobileBrowseBackAndForwardActivitiesListAllowedDays)\"></i></md-list-item>\n</md-list></div><div class=\"fs-12 pt-5 mt-15n end-session\"></div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.START_TASKS_OUT_OF_ORDER.TITLE\">Start tasks out of order</h3><md-switch \ndata-cy=\"start-tasks-out-of-order-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileStartTaskOutOfOrderOn\" \naria-label=\"{{ \'CONFIGURATIONS.MOBILE.START_TASKS_OUT_OF_ORDER.TITLE\' | translate }}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\"><span translate=\"CONFIGURATIONS.MOBILE.START_TASKS_OUT_OF_ORDER.HINT\">\nIt allows the employee to start tasks out of order. </span><br><br><md-icon md-font-icon=\"icon-alert\" \nclass=\"red-fg fs-16\"></md-icon><span class=\"ml-7n\" translate=\"CONFIGURATIONS.WARNINGS.TIMELINE_NOT_WORK_PROPERLY\">\nEnabling this setting causes the timeline to malfunction.</span></div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.START_TASKS_SIMULTANEOUSLY.TITLE\">Start tasks simultaneously</h3><md-switch \ndata-cy=\"start-tasks-simultaneously-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileStartTaskSimultaneouslyOn\" \naria-label=\"{{ \'CONFIGURATIONS.MOBILE.START_TASKS_SIMULTANEOUSLY.TITLE\' | translate }}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\"><span translate=\"CONFIGURATIONS.MOBILE.START_TASKS_SIMULTANEOUSLY.HINT\">\nIt allows the employee to start more than one task at the same time. </span><br><br><md-icon md-font-icon=\"icon-alert\" \nclass=\"red-fg fs-16\"></md-icon><span class=\"ml-7n\" translate=\"CONFIGURATIONS.WARNINGS.TIMELINE_NOT_WORK_PROPERLY\">\nEnabling this setting causes the timeline to malfunction. </span><br><md-icon md-font-icon=\"icon-alert\" \nclass=\"red-fg fs-16\"></md-icon><span class=\"ml-7n\" translate=\"CONFIGURATIONS.WARNINGS.AFFECTS_TASK_OUT_OF_ORDER\">\nEnabling the setting may affect the setting of (start activities out of order)</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.SEND_TASK_REPORT_LINK.TITLE\">Allow to send task report link\n</h3><md-switch data-cy=\"send-task-report-link-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileSendTaskPrintLink\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.SEND_TASK_REPORT_LINK.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.SEND_TASK_REPORT_LINK.HINT\">\nAfter closing the visit the employee will be able to send a report to the client by email.</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.SEND_TASK_RATING_LINK.TITLE\">\nAllow to send activity evaluation link</h3><md-switch data-cy=\"send-task-rating-link-switch\" \nclass=\"md-secondary ml-10 mt-10\" ng-model=\"vm.configuration.mobileSendTaskRatingLink\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.SEND_TASK_RATING_LINK.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.SEND_TASK_RATING_LINK.HINT\">\nAfter ending the visit, the employee can send the evaluation of the service to the customer\'s email.</div><div \nlayout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.SEND_TASK_SIGNATURE_LINK.TITLE\">\nAllow to send activity signature link</h3><md-switch data-cy=\"send-task-signature-link-switch\" \nclass=\"md-secondary ml-10 mt-10\" ng-model=\"vm.configuration.mobileSendTaskSignatureLink\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.SEND_TASK_SIGNATURE_LINK.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.SEND_TASK_SIGNATURE_LINK.HINT\">\nDuring the visit, the employee can share a signature link with the custumer through email.</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.ALLOW_EDIT_TASK_LABELS.TITLE\">Allow to edit the activity labels\n</h3><md-switch data-cy=\"edit-task-labels-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileEditTaskLabels\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.ALLOW_EDIT_TASK_LABELS.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.ALLOW_EDIT_TASK_LABELS.HINT\">\nThe employee can add or remove activity tags</div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.CREATE_EDIT_QUOTATIONS.TITLE\">Allows you to create quotes</h3><md-switch \ndata-cy=\"create-edit-quotations-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileShowQuotations\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.CREATE_EDIT_QUOTATIONS.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.CREATE_EDIT_QUOTATIONS.HINT\">\nIf enabled, the contributor will be able to view, create and share quotes through the app</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.HIDE_PRODUCT_VALUE.TITLE\">Hide the product value</h3><md-switch\n data-cy=\"hide-the-product-value-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileHideProductValue\"></md-switch></div><div class=\"hint fs-12 mt-15n end-session\" \ntranslate=\"CONFIGURATIONS.MOBILE.HIDE_PRODUCT_VALUE.DESCRIPTION\">\nIf enabled, the value of the products used in the activities will be hidden from the employee</div><div \nlayout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.EDIT_PRODUCT_SERVICE_VALUE.TITLE\">\nAllow to edit the value of the products and services</h3><md-switch data-cy=\"allow-edit-value-products-switch\" \nclass=\"md-secondary ml-10 mt-10\" ng-model=\"vm.configuration.mobileEditProductServiceValue\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.EDIT_PRODUCT_SERVICE_VALUE.DESCRIPTION\">\nIf enabled, the employee will be able to edit the value of the products and services added to the work orders</div><div\n layout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.SEND_LOCATION_OF_IMPEDIMENT.TITLE\">\nSend location when starting, completing, and registering impediment to visit</h3><md-switch \ndata-cy=\"tasks-actions-with-current-geo-position-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileTasksActionsWithCurrentGeoPositionOn\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.SEND_LOCATION_OF_IMPEDIMENT.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.SEND_LOCATION_OF_IMPEDIMENT.HINT\">\nWhen starting, completing or registering an activity as an impediment, the geolocation information will be stored.\n</div><div layout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.UPDATE_CUSTOMERS_COORDINATES.TITLE\">\nAllow the employee, with his location, to update the customer\'s coordinates</h3><md-switch \ndata-cy=\"update-customer-coords-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileUpdateCustomerCoordsOn\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.UPDATE_CUSTOMERS_COORDINATES.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.UPDATE_CUSTOMERS_COORDINATES.HINT\">\nThe employee can use his current location to update the customer\'s coordinates, if they are out of date.</div><div \nlayout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.VIEW_CUSTOMER_CONTACT_INFO.TITLE\">\nView customer contact information</h3><md-switch data-cy=\"view-customer-contacts-switch\" \nclass=\"md-secondary ml-10 mt-10\" ng-model=\"vm.configuration.mobileShowCustomerContacts\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.VIEW_CUSTOMER_CONTACT_INFO.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.VIEW_CUSTOMER_CONTACT_INFO.HINT\">\nAllows the employee access the customer\'s contact information only.</div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.UPDATE_CUSTOMER_CONTACT_INFO.TITLE\">Update customer\'s contact information</h3>\n<md-switch data-cy=\"update-customer-contacts-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileUpdateCustomerContacts\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.UPDATE_CUSTOMER_CONTACT_INFO.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.UPDATE_CUSTOMER_CONTACT_INFO.HINT\">\nAllows the employee to update the customer\'s contact information.</div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.LIST_CUSTOMERS.TITLE\">List customers</h3><md-switch data-cy=\"list-customers-switch\" \nclass=\"md-secondary ml-10 mt-10\" ng-model=\"vm.configuration.mobileListCustomersOn\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.LIST_CUSTOMERS.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.LIST_CUSTOMERS.HINT\">\nAllows the employee access to customer\'s information.</div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.ENABLE_CHANGES_VISIT.TITLE\">Enable changes to the visit once completed or prevented\n</h3><md-switch data-cy=\"update-task-after-completed-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileUpdateTaskAfterCompleted\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.ENABLE_CHANGES_VISIT.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n\" ng-class=\"{ \'end-session\': !vm.configuration.mobileUpdateTaskAfterCompleted }\" \ntranslate=\"CONFIGURATIONS.MOBILE.ENABLE_CHANGES_VISIT.HINT\">\nAllows the employee access the customer\'s contact information only.</div><div \nng-if=\"vm.configuration.mobileUpdateTaskAfterCompleted\" class=\"custom-task-card end-session\"><div \nclass=\"custom-task-card__header\"><h3 translate=\"CONFIGURATIONS.MOBILE.CUSTOM_EDIT_TASK_COMPLETE.SELECT\"></h3></div><div\n class=\"custom-task-card__content\"><md-checkbox data-cy=\"update-task-after-completed-done\" class=\"md-primary\" \nng-checked=\"vm.isConfigEditTaskAfterCompletedChecked(\'done\')\" \nng-click=\"vm.includeConfigsAtEditTaskAfterCompleted(\'done\')\">\n{{ \'CONFIGURATIONS.MOBILE.CUSTOM_EDIT_TASK_COMPLETE.COMPLETED\' | translate }}</md-checkbox><md-checkbox \ndata-cy=\"update-task-after-completed-reported\" class=\"md-primary\" \nng-checked=\"vm.isConfigEditTaskAfterCompletedChecked(\'reported\')\" \nng-click=\"vm.includeConfigsAtEditTaskAfterCompleted(\'reported\')\">\n{{ \'CONFIGURATIONS.MOBILE.CUSTOM_EDIT_TASK_COMPLETE.REPORTED\' | translate }}</md-checkbox><md-checkbox \ndata-cy=\"update-task-after-completed-canceled\" class=\"md-primary\" \nng-checked=\"vm.isConfigEditTaskAfterCompletedChecked(\'canceled\')\" \nng-click=\"vm.includeConfigsAtEditTaskAfterCompleted(\'canceled\')\">\n{{ \'CONFIGURATIONS.MOBILE.CUSTOM_EDIT_TASK_COMPLETE.CANCELED\' | translate }}</md-checkbox></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.MOBILE.TASK_DESCRIPTION_REQUIRED.TITLE\">\nConclusion field required</h3><md-switch data-cy=\"task-description-required-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileTaskDescriptionRequired\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.TASK_DESCRIPTION_REQUIRED.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.TASK_DESCRIPTION_REQUIRED.HINT\">\nConclusion field required to conclude employee\'s task</div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.TASK_REPORT_DESCRIPTION_REQUIRED.TITLE\">Report field required</h3><md-switch \ndata-cy=\"task-report-description-required-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileTaskReportDescriptionRequired\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.TASK_REPORT_DESCRIPTION_REQUIRED.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.TASK_REPORT_DESCRIPTION_REQUIRED.HINT\">\nReport field required to prevent employee\'s task</div><div layout=\"column\" layout-gt-sm=\"row\"><h3><span \ntranslate=\"CONFIGURATIONS.MOBILE.HIDE_EMPLOYEE_WORK_HOURS.TITLE\">\nHide information of hours worked in the employee\'s profile</span></h3><md-switch \ndata-cy=\"hide-employee-work-hours-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileHideEmployeeWorkHours\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.HIDE_EMPLOYEE_WORK_HOURS.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.HIDE_EMPLOYEE_WORK_HOURS.HINT\">\nThis setting hides the report of hours worked within the employee\'s profile within the technician\'s application</div>\n<div layout=\"column\" layout-gt-sm=\"row\"><h3><span translate=\"CONFIGURATIONS.MOBILE.FORMS_STEP_BY_STEP.TITLE\">\nStep-by-step forms</span></h3><md-switch data-cy=\"forms-step-by-step-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileFormStepByStepEnabled\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.FORMS_STEP_BY_STEP.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.FORMS_STEP_BY_STEP.HINT\">\nAllows the employee to answer the form in stages, one question at a time</div><div layout=\"column\" layout-gt-sm=\"row\">\n<h3><span translate=\"CONFIGURATIONS.MOBILE.SAVE_IMAGE_TO_GALLERY.TITLE\">Enable image rescue in the gallery</span></h3>\n<md-switch data-cy=\"save-image-to-gallery-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileSaveImageToGallery\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.SAVE_IMAGE_TO_GALLERY.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.SAVE_IMAGE_TO_GALLERY.HINT\">\nThis option allows employees to save the image taken by the camera in the photo gallery</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><h3><span translate=\"CONFIGURATIONS.MOBILE.SHOW_TASK_ON_ROUTE_ALERT.TITLE\">\nDisplay alert for activities scheduled for the next hour</span></h3><md-switch class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileShowTaskOnRouteAlert\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.SHOW_TASK_ON_ROUTE_ALERT.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.SHOW_TASK_ON_ROUTE_ALERT.HINT\">\nDisplays an alert to the employee about activities scheduled for the next hour</div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"vm.configuration.mobileShowTaskOnRouteAlert\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.TASK_ON_ROUTE_ALERT_INTERVAL.TITLE\">Alert display interval</h3><md-select \nclass=\"w-100 ml-20 mt-10 fs-14\" aria-label=\"{{\'CONFIGURATIONS.MOBILE.TASK_ON_ROUTE_ALERT_INTERVAL.HINT\' | translate}}\" \nng-model=\"vm.configuration.mobileTaskOnRouteAlertIntervalMinutes\"><md-optgroup class=\"remove-label\"><md-option \nvalue=\"5\"><span>5</span></md-option><md-option value=\"10\"><span>10</span></md-option><md-option value=\"15\"><span>15\n</span></md-option><md-option value=\"30\"><span>30</span></md-option><md-option value=\"60\"><span>60</span></md-option>\n</md-optgroup></md-select><h3 translate=\"CONFIGURATIONS.MOBILE.TASK_ON_ROUTE_ALERT_INTERVAL.MINUTES\">minutes</h3></div>\n<div class=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.TASK_ON_ROUTE_ALERT_INTERVAL.HINT\" \nng-if=\"vm.configuration.mobileShowTaskOnRouteAlert && vm.configuration.mobileTaskOnRouteAlertIntervalMinutes\">\nTime interval for displaying the alert for activities scheduled for the next hour</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><h3 class=\"mr-15 mt-25\" translate=\"CONFIGURATIONS.MOBILE.SOUND_NOTIFICATION.TITLE\">\nSelect the app notification sound</h3><md-select data-cy=\"notification-sound-select\" \nplaceholder=\"{{ \'CONFIGURATIONS.MOBILE.SOUND_NOTIFICATION.SELECT\' | translate }}\" \nng-model=\"vm.configuration.mobileNotificationSound\" required><div class=\"sound-select-option\" layout=\"row\" \nng-repeat=\"notificationSound in vm.notificationSounds\"><md-option flex ng-value=\"notificationSound.code\">\n{{ ::notificationSound.name }}</md-option><div layout=\"row\" layout-align=\"center center\" flex=\"20\" \nng-if=\"notificationSound.soundPath\"><md-button ng-click=\"vm.playSound(notificationSound.soundPath)\" \nclass=\"md-icon-button\" aria-label=\"Escutar som\"><md-icon md-font-icon=\"icon-play\"></md-icon></md-button></div></div>\n</md-select></div><div class=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.SOUND_NOTIFICATION.HINT\">\nSelect the sound that will play in the application</div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.hasOrcOrdersBetaFlag\"><h3 translate=\"CONFIGURATIONS.MOBILE.ALLOW_CREATE_ORDERS.TITLE\"></h3><md-switch \ndata-cy=\"show-allow-create-orders-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileAllowCreateOrders\" ng-change=\"vm.mobileAllowCreateOrdersChanged();\"></md-switch></div>\n<div ng-if=\"vm.hasOrcOrdersBetaFlag\" class=\"hint fs-12 mt-15n end-session\" \ntranslate=\"CONFIGURATIONS.MOBILE.ALLOW_CREATE_ORDERS.HINT\"></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.configuration.mobileAllowCreateOrders && vm.hasOrcOrdersBetaFlag\"><md-list class=\"pt-5\"><md-list-item \nclass=\"mb-40n\"><md-input-container class=\"md-block fs-16\"><label \ntranslate=\"CONFIGURATIONS.MOBILE.ALLOW_CREATE_ORDERS.SEARCH_EMPLOYEES\"></label><input \nng-model=\"vm.allowOrderEmployeeSearch\" ng-model-options=\"{ debounce: 100 }\"></md-input-container></md-list-item>\n<md-list-item class=\"member\" ng-repeat=\"employee in vm.employees | filter: { name: vm.allowOrderEmployeeSearch }\" \nng-click=\"vm.toggleInArray(employee.id, vm.configuration.mobileAllowCreateOrdersEmployeeIds)\"><div \nclass=\"avatar grey-bg\"><img alt=\"{{employee.name}}\" class=\"avatar\" \nng-src=\"{{employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ employee.name }}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(employee.id, vm.configuration.mobileAllowCreateOrdersEmployeeIds)\"></i>\n</md-list-item></md-list></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.hasOrcOrdersBetaFlag && vm.configuration.mobileAllowCreateOrders\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.CREATE_ORDERS_TO_OTHER_EMPLOYEES.TITLE\"></h3><md-switch \ndata-cy=\"show-create-orders-to-other-employees-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileCreateOrdersToOtherEmployees\"></md-switch></div><div \nng-if=\"vm.hasOrcOrdersBetaFlag && vm.configuration.mobileAllowCreateOrders\" class=\"hint fs-12 mt-15n end-session\" \ntranslate=\"CONFIGURATIONS.MOBILE.CREATE_ORDERS_TO_OTHER_EMPLOYEES.HINT\"></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.configuration.mobileCreateOrdersToOtherEmployees && vm.configuration.mobileAllowCreateOrders && vm.hasOrcOrdersBetaFlag\">\n<md-list class=\"pt-5\"><md-list-item class=\"mb-40n\"><md-input-container class=\"md-block fs-16\"><label \ntranslate=\"CONFIGURATIONS.MOBILE.CREATE_ORDERS_TO_OTHER_EMPLOYEES.SEARCH_EMPLOYEES\"></label><input \nng-model=\"vm.createOrderToEmployees\" ng-model-options=\"{ debounce: 100 }\"></md-input-container></md-list-item>\n<md-list-item class=\"member\" ng-repeat=\"employee in vm.employees | filter: { name: vm.createOrderToEmployees }\" \nng-if=\"vm.configuration.mobileAllowCreateOrdersEmployeeIds.includes(employee.id)\" \nng-click=\"vm.toggleInArray(employee.id, vm.configuration.mobileCreateOrdersToOtherEmployeesIds)\"><div \nclass=\"avatar grey-bg\"><img alt=\"{{employee.name}}\" class=\"avatar\" \nng-src=\"{{employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ employee.name }}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(employee.id, vm.configuration.mobileCreateOrdersToOtherEmployeesIds)\"></i>\n</md-list-item></md-list></div><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.MOBILE.NOTIFY_GEOLOCATION_DISABLED.TITLE\">Notify when the employee disables geolocation</h3>\n<md-switch data-cy=\"send-email-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.mobileNotifyGeolocationDisabledOn\" ng-change=\"vm.notifyGeolocationDisabledChanged();\" \naria-label=\"{{\'CONFIGURATIONS.MOBILE.NOTIFY_GEOLOCATION_DISABLED.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.MOBILE.NOTIFY_GEOLOCATION_DISABLED.HINT\">\nThe selected users will be notified via dashboard when an employee disables geolocation.</div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"vm.configuration.mobileNotifyGeolocationDisabledOn\"><md-list class=\"pt-5\"><md-list-item \nclass=\"mb-40n\"><md-input-container class=\"md-block fs-16\"><label \ntranslate=\"CONFIGURATIONS.MOBILE.NOTIFY_GEOLOCATION_DISABLED.SEARCH_USER\">Search user</label><input \nng-model=\"vm.userSearch\" ng-model-options=\"{ debounce: 100 }\"></md-input-container></md-list-item><md-list-item \nclass=\"member\" ng-repeat=\"user in vm.users | filter: { name: vm.userSearch }\" \nng-click=\"vm.toggleInArray(user._id, vm.configuration.mobileNotifyGeolocationDisabledUserIds)\"><div \nclass=\"avatar grey-bg\"><img alt=\"{{user.name}}\" class=\"avatar\" \nng-src=\"{{user.avatarUrl ? user.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ user.name }}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(user._id, vm.configuration.mobileNotifyGeolocationDisabledUserIds)\"></i></md-list-item></md-list>\n</div><md-button data-cy=\"save-button\" type=\"submit\" ng-click=\"vm.saveAccountConfiguration();\" \nng-disabled=\"vm.disableSaveButton\" class=\"send-button md-accent md-raised save-fixed-button\" \naria-label=\"Save configuration\" translate=\"CONFIGURATIONS.BUTTON_SAVE\" \ntranslate-attr-aria-label=\"CONFIGURATIONS.BUTTON_SAVE\">Save configuration</md-button>");
$templateCache.put("app/main/settings/contents/others-config.html","<div layout=\"column\" layout-gt-sm=\"row\"><h3 class=\"mt-25 mr-20\" translate=\"CONFIGURATIONS.OTHERS.LANGUAGE.TITLE\">\nAccount language</h3><md-select data-cy=\"language-select\" placeholder=\"Select language\" translate \ntranslate-attr-placeholder=\"CONFIGURATIONS.OTHERS.LANGUAGE.PLACEHOLDER\" ng-model=\"vm.account.language\" required>\n<md-option ng-value=\"language.code\" ng-repeat=\"language in vm.languages\">{{ ::language.name }}</md-option></md-select>\n</div><div class=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.OTHERS.LANGUAGE.HINT\">\nThis setting will affect the language of transactional emails and other account-related features</div><div \nlayout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.OTHERS.EMAIL.NOTICE_TASK_RATING.TITLE\">\nSend notice by email when receiving an task rating</h3><md-switch data-cy=\"send-email-switch\" \nclass=\"md-secondary ml-10 mt-10\" ng-model=\"vm.configuration.taskRatingNotificationOn\" \nng-change=\"vm.notifyRatingChanged();\" \naria-label=\"{{\'CONFIGURATIONS.OTHERS.EMAIL.NOTICE_TASK_RATING.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.OTHERS.EMAIL.NOTICE_TASK_RATING.HINT\">\nUpon receiving an rating of an task, selected managers will receive a notification email.</div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"vm.configuration.taskRatingNotificationOn\"><md-list class=\"pt-5\"><md-list-item \nclass=\"mb-40n\"><md-input-container class=\"md-block fs-16\"><label translate=\"CONFIGURATIONS.OTHERS.SEARCH_USER\">\nSearch user</label><input ng-model=\"vm.userSearch\" ng-model-options=\"{ debounce: 100 }\"></md-input-container>\n</md-list-item><md-list-item class=\"member\" ng-repeat=\"user in vm.users | filter: { name: vm.userSearch }\" \nng-click=\"vm.toggleInArray(user.id, vm.taskRatingNotificationEmails)\" \naria-label=\"{{\'CONFIGURATIONS.OTHERS.SWITCH_USER\' | translate}}\"><div class=\"avatar grey-bg\"><img alt=\"{{user.name}}\" \nclass=\"avatar\" ng-src=\"{{user.avatarUrl ? user.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ user.name }}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(user.id, vm.taskRatingNotificationEmails)\"></i></md-list-item></md-list></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.OTHERS.FORMS.SCORED_OPTIONS.TITLE\">\nUse scoring scheme in question options on forms</h3><md-switch data-cy=\"forms-scored-options-switch\" \nclass=\"md-secondary ml-10 mt-10\" ng-model=\"vm.configuration.featureFormsWithScoredOptions\" \naria-label=\"{{\'CONFIGURATIONS.OTHERS.FORMS.SCORED_OPTIONS.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.OTHERS.FORMS.SCORED_OPTIONS.HINT\">\nThis enables you to enter a score for a list or multiple choice option on forms.</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.OTHERS.NOTIFICATIONS.PENDING_NOTIFICATIONS.TITLE\">\nEnable notification for pending activities</h3><md-switch data-cy=\"pending-notifications-switch\" \nclass=\"md-secondary ml-10 mt-10\" ng-model=\"vm.configuration.taskPendingNotificationOn\" \naria-label=\"{{\'CONFIGURATIONS.OTHERS.NOTIFICATIONS.PENDING_NOTIFICATIONS.TITLE\' || translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.OTHERS.NOTIFICATIONS.PENDING_NOTIFICATIONS.HINT\">\nWhen enabled, new activities with pending status are gonna send notifications to all contributors via application</div>\n<form name=\"quotationIdentifierForm\" class=\"md-inline-form sequential-form\"><div layout=\"column\" layout-gt-sm=\"row\"><h3\n translate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.IDENTIFIER_TYPE.TITLE\">Identifier type</h3><md-select \ndata-cy=\"type-identifier-select\" class=\"ml-20 mt-10 fs-14\" \naria-label=\"{{ \'CONFIGURATIONS.OTHERS.QUOTATIONS.IDENTIFIER_TYPE.TITLE\' | translate }}\" \nng-model=\"vm.configuration.quotationsIdentifierType\" data-cy=\"quotation-identifier-select\"><md-optgroup \nclass=\"remove-label\"><md-option value=\"none\" data-cy=\"quotation-identifier-not-generate\"><span \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.IDENTIFIER_TYPE.TYPES.DO_NOT_GENERATE\">Do not generate</span></md-option>\n<md-option value=\"sequence\"><span translate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.IDENTIFIER_TYPE.TYPES.SEQUENCE\">\nSequential</span></md-option><md-option value=\"random\"><span \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.IDENTIFIER_TYPE.TYPES.RANDOM\">Random</span></md-option></md-optgroup>\n</md-select></div><div layout=\"column\" ng-if=\"vm.configuration.quotationsIdentifierType === \'sequence\'\"><div \nclass=\"documentation-link-box-container\"><div class=\"documentation-link-box\" \nstyle=\"margin-top: 0; margin-bottom: 36px\" layout=\"column\"><div layout=\"row\" ng-if=\"vm.currentIdentifier >= 0\"><h4 \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.SEQUENCE.TITLE\">Next quotation will have the identifier number</h4><h4 \nclass=\"ml-7\" ng-if=\"!vm.toggleInput\"><strong>{{ vm.nextIdentifier }}</strong></h4><md-input-container \nclass=\"ml-5 mt-10 fs-14 w-100\" ng-if=\"vm.toggleInput\"><input type=\"number\" name=\"nextIdentifier\" \nmin=\"{{ vm.currentIdentifier + 1 }}\" ng-model=\"vm.nextIdentifier\" ng-model-options=\"{ debounce: 500 }\"><div \nng-messages=\"quotationIdentifierForm.nextIdentifier.$error\"><div ng-message=\"min\"><span \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.SEQUENCE.ERRORS.MIN_ERROR\" \ntranslate-values=\"{ lastNextIdentifier: vm.currentIdentifier }\">Must be greater than {{ vm.currentIdentifier }}</span>\n</div></div></md-input-container></div><div \nng-if=\"vm.currentIdentifier === null || vm.currentIdentifier === undefined\"><h4 \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.SEQUENCE.ERRORS.SEARCH_FAILED\">\nThe current identifier could not be fetched. Check your connection and retry.</h4></div><div layout=\"row\" \nlayout-align=\"end\" ng-if=\"!vm.toggleInput\"><md-button class=\"md-accent md-raised mt-18\" \nng-if=\"vm.currentIdentifier >= 0\" ng-click=\"vm.toggleInput = !vm.toggleInput\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span class=\"ml-5 mr-5\" \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.SEQUENCE.CUSTOMIZE\">Customize</span></md-button><md-button \nclass=\"md-accent md-raised mt-18\" ng-if=\"vm.currentIdentifier === null || vm.currentIdentifier === undefined\" \nng-click=\"vm.retryGetCurrentIdentifier(\'quotation\')\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><span \nclass=\"ml-5 mr-5\" translate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.RETRY\">Retry</span></md-button></div><div \nclass=\"customize-actions\" ng-if=\"vm.toggleInput\" layout=\"row\" layout-align=\"end\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.confirmIdentifierChange()\" \nng-disabled=\"quotationIdentifierForm.$invalid || vm.nextIdentifier < vm.currentIdentifier + 1\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span class=\"ml-5 mr-5\" \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.SEQUENCE.CONFIRM\">Confirm</span></md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.cancelQuotationIdentifierChange()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><span class=\"ml-5 mr-5\" translate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.SEQUENCE.CANCEL\">Cancel</span>\n</md-button></div></div></div></div><div class=\"hint fs-12 mt-15n end-session\"><span \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.IDENTIFIER_TYPE.DESCRIPTIONS.DO_NOT_GENERATE\"><strong>Don\'t generate: \n</strong>\nthe quotation identification codes will not be created automatically, so it is necessary to be informed by the manager when the quotation is created.\n</span><br><span translate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.IDENTIFIER_TYPE.DESCRIPTIONS.SEQUENCE\"><strong>\nSequential: </strong>the identification codes will be generated in ascending order.</span><br><span \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.IDENTIFIER_TYPE.DESCRIPTIONS.RANDOM\"><strong>Random: </strong>\nthe identification codes will be generator randomly.</span></div></form><div \nng-if=\"vm.hasQuotationsEquipmentsFeatureFlag\"><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.EQUIPMENTS_ON.TITLE\">Enable notification for pending activities</h3>\n<md-switch data-cy=\"quotations-equipments-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.quotationsWithEquipmentsOn\" \naria-label=\"{{\'CONFIGURATIONS.OTHERS.QUOTATIONS.EQUIPMENTS_ON.TITLE\' || translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.EQUIPMENTS_ON.HINT\">\nWhen enabled, activates quotations with equipments for the account</div></div><div \nng-if=\"vm.hasQuotationsEquipmentsFeatureFlag\"><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.LINK_ITEMS.TITLE\">Enable notification for pending activities</h3><md-switch\n data-cy=\"quotations-link-items-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.quotationsLinkItemsToOrderOn\" \naria-label=\"{{\'CONFIGURATIONS.OTHERS.QUOTATIONS.LINK_ITEMS.TITLE\' || translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.OTHERS.QUOTATIONS.LINK_ITEMS.HINT\">\nWhen enabled, new tasks will be created with the quotation links</div></div><div ng-if=\"vm.hasPublicQRCodeFeatureFlag\">\n<div layout=\"column\" layout-gt-sm=\"row\"><h3>{{ \'CONFIGURATIONS.OTHERS.PUBLIC_QRCODE.ENABLE.TITLE\' | translate }}</h3>\n<md-switch data-cy=\"feature-public-qrcode-enabled-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.featurePublicQRCodeEnabled\"></md-switch></div><div class=\"hint fs-12 mt-15n end-session\">\n{{ \'CONFIGURATIONS.OTHERS.PUBLIC_QRCODE.ENABLE.DESCRIPTION\' | translate }}</div></div><div \nng-if=\"vm.hasPublicQRCodeFeatureFlag && vm.configuration.featurePublicQRCodeEnabled\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><h3>{{ \'CONFIGURATIONS.OTHERS.PUBLIC_QRCODE.CUSTOMIZATION.TITLE\' | translate }}</h3><md-switch \ndata-cy=\"feature-public-qrcode-customization-on-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.featurePublicQRCodeCustomizationOn\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\">{{ \'CONFIGURATIONS.OTHERS.PUBLIC_QRCODE.CUSTOMIZATION.DESCRIPTION\' | translate }}\n</div></div><div class=\"mt-15 end-session\" \nng-if=\"vm.hasPublicQRCodeFeatureFlag && vm.configuration.featurePublicQRCodeEnabled && vm.configuration.featurePublicQRCodeCustomizationOn\">\n<div class=\"custom-task-card\"><div class=\"custom-task-card__header\"><h3 \ntranslate=\"CONFIGURATIONS.OTHERS.PUBLIC_QRCODE.CUSTOMIZATION.CHOOSE_TITLE\"></h3></div><div \nclass=\"custom-task-card__content\"><md-checkbox data-cy=\"feature-public-qrcode-customization-detail-checkbox\" \nclass=\"md-primary\" ng-checked=\"true\" ng-disabled=\"true\">\n{{ \'CONFIGURATIONS.OTHERS.PUBLIC_QRCODE.CUSTOMIZATION.DETAIL\' | translate }}</md-checkbox><md-checkbox \ndata-cy=\"feature-public-qrcode-customization-open-ticket-checkbox\" class=\"md-primary\" \nng-checked=\"vm.isCustomPublicQRCodeChecked(\'open-ticket\')\" ng-click=\"vm.toggleCustomPublicQRCode(\'open-ticket\')\">\n{{ \'CONFIGURATIONS.OTHERS.PUBLIC_QRCODE.CUSTOMIZATION.OPEN_TICKET\' | translate }}</md-checkbox><md-checkbox \ndata-cy=\"feature-public-qrcode-customization-tasks-checkbox\" class=\"md-primary\" \nng-checked=\"vm.isCustomPublicQRCodeChecked(\'tasks\')\" ng-click=\"vm.toggleCustomPublicQRCode(\'tasks\')\">\n{{ \'CONFIGURATIONS.OTHERS.PUBLIC_QRCODE.CUSTOMIZATION.TASKS\' | translate }}</md-checkbox></div></div></div><md-button \ndata-cy=\"save-button\" type=\"submit\" ng-click=\"vm.saveAccountConfiguration(\'quotation\');\" \nng-disabled=\"vm.disableSaveButton\" class=\"send-button md-accent md-raised save-fixed-button\" \naria-label=\"Save settings\" translate=\"CONFIGURATIONS.BUTTON_SAVE\" \ntranslate-attr-aria-label=\"CONFIGURATIONS.BUTTON_SAVE\">Save settings</md-button>");
$templateCache.put("app/main/settings/contents/service-order.html","<form name=\"sequentialForm\" class=\"md-inline-form sequential-form\"><div layout=\"column\" layout-gt-sm=\"row\"><h3 \ntranslate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.TITLE\">Identifier type</h3><md-select class=\"ml-20 mt-10 fs-14\" \naria-label=\"{{ \'CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.TITLE\' | translate }}\" \nng-model=\"vm.configuration.activitiesIdentifierType\" data-cy=\"orders-identifier-select\"><md-optgroup \nclass=\"remove-label\"><md-option value=\"none\" data-cy=\"none\"><span \ntranslate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.DO_NOT_GENERATE\">Do not generate</span></md-option><md-option \nvalue=\"sequence\" data-cy=\"sequence\"><span translate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.SEQUENTIAL\">Sequential\n</span></md-option><md-option value=\"random\" data-cy=\"random\"><span \ntranslate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.RANDOM\">Random</span></md-option></md-optgroup></md-select></div>\n<div layout=\"column\" ng-if=\"vm.configuration.activitiesIdentifierType === \'sequence\'\"><div \nclass=\"documentation-link-box-container\"><div class=\"documentation-link-box\" layout=\"column\"><div layout=\"row\" \nng-if=\"vm.currentIdentifier >= 0\"><h4 translate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.NEXT_IDENTIFIER\">\nNext service order will have the identifier number</h4><h4 class=\"ml-7\" ng-if=\"!vm.toggleInput\"><strong>\n{{ vm.nextIdentifier }}</strong></h4><md-input-container class=\"ml-5 mt-10 fs-14 w-100\" ng-if=\"vm.toggleInput\"><input \ntype=\"number\" name=\"nextIdentifier\" min=\"{{ vm.currentIdentifier + 1 }}\" ng-model=\"vm.nextIdentifier\" \nng-model-options=\"{ debounce: 500 }\"><div ng-messages=\"sequentialForm.nextIdentifier.$error\"><div ng-message=\"min\">\n<span translate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.MIN_ERROR\" \ntranslate-values=\"{ lastNextIdentifier: vm.currentIdentifier }\">Must be greater than {{ vm.currentIdentifier }}</span>\n</div></div></md-input-container></div><div \nng-if=\"vm.currentIdentifier === null || vm.currentIdentifier === undefined\"><h4 \ntranslate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.GET_FAIL\">\nThe current identifier could not be fetched. Check your connection and retry.</h4></div><div layout=\"row\" \nlayout-align=\"end\" ng-if=\"!vm.toggleInput\"><md-button class=\"md-accent md-raised mt-18\" \nng-if=\"vm.currentIdentifier >= 0\" ng-click=\"vm.toggleInput = !vm.toggleInput\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><span class=\"ml-5 mr-5\" \ntranslate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.CUSTOMIZE\">Customize</span></md-button><md-button \nclass=\"md-accent md-raised mt-18\" ng-if=\"vm.currentIdentifier === null || vm.currentIdentifier === undefined\" \nng-click=\"vm.retryGetCurrentIdentifier()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><span class=\"ml-5 mr-5\" \ntranslate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.RETRY\">Retry</span></md-button></div><div \nclass=\"customize-actions\" ng-if=\"vm.toggleInput\" layout=\"row\" layout-align=\"end\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.confirmIdentifierChange()\" \nng-disabled=\"sequentialForm.$invalid || vm.nextIdentifier <= vm.currentIdentifier + 1\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><span class=\"ml-5 mr-5\" \ntranslate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.CONFIRM\">Confirm</span></md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.cancelIdentifierChange()\"><md-icon md-font-icon=\"icon-close\"></md-icon><span \nclass=\"ml-5 mr-5\" translate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.CANCEL\">Cancel</span></md-button></div></div>\n</div></div><div class=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.ORDERS.TASK_IDENTIFIER_TYPE.HINT\">\n<span><strong>Don\'t generate: </strong>\nthe service order identification codes will not be created automatically, so it is necessary to be informed by the manager when the service order is created.\n</span><br><span><strong>Sequential: </strong>the identification codes will be generated in ascending order.</span><br>\n<span><strong>Random: </strong>the identification codes will be generator randomly.</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start center\"><h3 translate=\"CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\">\nAllow multiple tasks</h3><md-switch class=\"md-secondary ml-10 mt-10\" data-cy=\"orders-allow-multiple-tasks\" \nng-model=\"vm.configuration.ordersWithMultipleTasksOn\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.HINT\">\nIt allows the manager to create more than one visit for the same work order.</div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start center\"><h3 translate=\"CONFIGURATIONS.ORDERS.ALLOW_PENDING_TASKS.TITLE\">\nAllow pending tasks</h3><md-switch data-cy=\"orders-allow-pending-tasks\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.taskEnablePendingStatus\"></md-switch></div><div class=\"hint fs-12 mt-15n end-session\" \ntranslate=\"CONFIGURATIONS.ORDERS.ALLOW_PENDING_TASKS.HINT\">\nAllows the manager to create, edit and view activities without a scheduled date.</div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start center\"><h3 \ntranslate=\"CONFIGURATIONS.ORDERS.CREATED_AT_IS_AFTER_STARTED_AT.TITLE\">\nAllows to close maintenance before the order creation date</h3><md-switch class=\"md-secondary ml-10 mt-10\" \ndata-cy=\"orders-close-task-with-past-date\" ng-model=\"vm.configuration.featureCloseTaskWithPastDate\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.CREATED_AT_IS_AFTER_STARTED_AT.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.ORDERS.CREATED_AT_IS_AFTER_STARTED_AT.HINT\">\nIt allows the manager to close maintenance before the order creation date.</div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start center\"><h3 \ntranslate=\"CONFIGURATIONS.ORDERS.EMPLOYEE_IS_MORE_THAN_ONE_TASK_SAME_TIME.TITLE\">\nDo not allow even collaborators in more than one activity</h3><md-switch class=\"md-secondary ml-10 mt-10\" \ndata-cy=\"orders-employee-in-more-than-one-task-same-time\" \nng-model=\"vm.configuration.featureValidateEmployeeIsInMoreThanOneTaskAtTheSameTime\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.EMPLOYEE_IS_MORE_THAN_ONE_TASK_SAME_TIME.TITLE\' | translate}}\"></md-switch></div>\n<div class=\"hint fs-12 mt-15n end-session\" \ntranslate=\"CONFIGURATIONS.ORDERS.EMPLOYEE_IS_MORE_THAN_ONE_TASK_SAME_TIME.HINT\">\nIf enabled, it does not allow the same employee to be working on more than one activity at the same time</div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\"><h3 \ntranslate=\"CONFIGURATIONS.ORDERS.ALLOW_NEW_TASK_IF_PREVIOUS_COMPLETED.TITLE\">\nBlock new visit if previous one is not completed</h3><md-switch class=\"md-secondary ml-10 mt-10\" \ndata-cy=\"orders-allow-new-task-if-previous-completed\" \nng-model=\"vm.configuration.featureOnlyAllowNewTaskIfPreviousWasCompleted\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_NEW_TASK_IF_PREVIOUS_COMPLETED.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.ORDERS.ALLOW_NEW_TASK_IF_PREVIOUS_COMPLETED.HINT\">\nIf enabled, the manager will only be able to create a new visit if the previous visits have the status of \'Prevented\', \'Canceled\' or \'Completed\'\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\"><h3 \ntranslate=\"CONFIGURATIONS.ORDERS.ADDRESS_SEARCH_MODE.TITLE\">Address search mode</h3><md-select \nclass=\"w-100 ml-20 mt-10 fs-14\" data-cy=\"orders-address-search-mode\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ADDRESS_SEARCH_MODE.TITLE\' | translate}}\" \nng-model=\"vm.configuration.addressSearchMode\"><md-optgroup class=\"remove-label\"><md-option value=\"google\"><span \ntranslate=\"CONFIGURATIONS.ORDERS.ADDRESS_SEARCH_MODE.GOOGLE\">Google</span></md-option><md-option value=\"cepdb\"><span \ntranslate=\"CONFIGURATIONS.ORDERS.ADDRESS_SEARCH_MODE.ZIP_CODE\">Zip code</span></md-option></md-optgroup></md-select>\n</div><div class=\"hint fs-12 mt-15n\" ng-class=\"{ \'end-session\': vm.configuration.addressSearchMode === \'google\' }\" \ntranslate=\"CONFIGURATIONS.ORDERS.ADDRESS_SEARCH_MODE.HINT\"><span><strong>Google: </strong>\nto find and save an address in the system just enter the address in the field.<br><strong>Zip code: </strong>\nwhen you need to enter an address you will need to enter zip code, street, number, neighborhood, city and state.</span>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.configuration.addressSearchMode === \'google\'\"><h3 \ntranslate=\"CONFIGURATIONS.ORDERS.SEARCHES_RESTRICTED_COUNTRY.TITLE\">\nAddress searches should be restricted to the country only:</h3><md-select class=\"w-150 ml-20 mt-10 fs-14\" \ndata-cy=\"orders-address-search-restricted-country\" close=\"vm.clearAddressCountriesSearchTerm()\" \nng-model=\"vm.configuration.addressSearchRestrictionCountry\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.SEARCHES_RESTRICTED_COUNTRY.TITLE\' | translate}}\"><md-select-header \nclass=\"header-services\"><input size=\"30\" ng-model=\"vm.addressCountriesSearchTerm\" class=\"input-services\" type=\"search\" \nplaceholder=\"Search by continent ...\" onkeydown=\"event.stopPropagation()\" translate \ntranslate-attr-placeholder=\"CONFIGURATIONS.ORDERS.SEARCHES_RESTRICTED_COUNTRY.SEARCH\"></md-select-header><md-optgroup \nclass=\"remove-label\" \nng-repeat=\"addressCountry in vm.addressCountries | orderBy: [\'code\',\'name\'] | filter: vm.addressCountriesSearchTerm\">\n<md-option value=\"{{addressCountry.code}}\">{{addressCountry.name}}</md-option></md-optgroup></md-select></div><div \nclass=\"hint fs-12\" ng-if=\"vm.configuration.addressSearchMode === \'google\'\" \ntranslate=\"CONFIGURATIONS.ORDERS.SEARCHES_RESTRICTED_COUNTRY.HINT\">\nIt will be possible to search for addresses only for the selected country.</div><md-button type=\"submit\" \nng-click=\"vm.saveAccountConfiguration();\" ng-disabled=\"vm.disableSaveButton || sequentialForm.$invalid\" \ndata-cy=\"orders-save-changes\" class=\"send-button md-accent md-raised save-fixed-button\" aria-label=\"Save settings\" \ntranslate=\"CONFIGURATIONS.BUTTON_SAVE\" translate-attr-aria-label=\"CONFIGURATIONS.BUTTON_SAVE\">Save settings</md-button>\n</form>");
$templateCache.put("app/main/settings/contents/timeline.html","<div layout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.GANTT.VIEW_DISPLACEMENT.TITLE\">View displacement\n</h3><md-switch data-cy=\"view-displacement-switch\" class=\"md-secondary ml-10 mt-10\" \nng-model=\"vm.configuration.ganttDisplayTravelTimeOn\" \naria-label=\"{{\'CONFIGURATIONS.GANTT.VIEW_DISPLACEMENT.TITLE\' | translate}}\"></md-switch></div><div \nclass=\"hint fs-12 mt-15n end-session\" translate=\"CONFIGURATIONS.GANTT.VIEW_DISPLACEMENT.HINT\">\nA \"gray bar\" will appear on the timeline, which is an estimate of displacement calculated by the air distance between activities\n</div><div layout=\"column\" layout-gt-sm=\"row\"><h3 translate=\"CONFIGURATIONS.GANTT.SORT_EMPLOYEES.TITLE\">\nOrdering employees in the timeline in order</h3><md-select data-cy=\"ordination-select\" class=\"w-120 ml-20 mt-10 fs-14\" \naria-label=\"{{\'CONFIGURATIONS.GANTT.SORT_EMPLOYEES.TITLE\' | translate}}\" \nng-model=\"vm.configuration.ganttEmployeesSortBy\" ng-change=\"vm.setEmployeesPositions()\"><md-optgroup \nclass=\"remove-label\"><md-option data-cy=\"alphabetically-option\" value=\"alphabetically\" \ntranslate=\"CONFIGURATIONS.GANTT.SORT_EMPLOYEES.ALPHABETICALLY\">Alphabetical</md-option><md-option \ndata-cy=\"custom-option\" value=\"custom\" translate=\"CONFIGURATIONS.GANTT.SORT_EMPLOYEES.CUSTOM\">Custom</md-option>\n</md-optgroup></md-select></div><div class=\"hint fs-12 mt-15n\"><span \ntranslate=\"CONFIGURATIONS.GANTT.SORT_EMPLOYEES.HINT\"><strong>Alphabetical: </strong>\nto sort employees alphabetically in the timeline.<br><strong>Customized: </strong>\norder the employees in the way they think best for viewing on the timeline. </span><a \nhref=\"https://docs.fieldcontrol.com.br/docs/organizacao/como-ordenar-os-colaboradores-na-linha-do-tempo/\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-question-mark-circle\" class=\"text-icon\"></md-icon></a><div><div \nng-if=\"vm.configuration.ganttEmployeesSortBy === \'custom\'\" class=\"employees-sortable-list sortable\" \nui-sortable=\"vm.employeesSortableOptions\" ng-model=\"vm.employees\"><div class=\"employee-sortable-item\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"employee in vm.employees track by $index\"><div class=\"handle-options\" \nng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><div \nlayout=\"row\" layout-align=\"start center\" flex><img class=\"avatar medium mt-10 mb-10\" alt=\"{{employee.name}}\" \nng-src=\"{{employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"><h4>{{ employee.name }}</h4></div></div></div><md-button type=\"submit\" \ndata-cy=\"save-button\" ng-click=\"vm.saveAccountConfiguration();\" ng-disabled=\"vm.disableSaveButton\" \nclass=\"send-button md-accent md-raised save-fixed-button\" aria-label=\"Save settings\" \ntranslate=\"CONFIGURATIONS.BUTTON_SAVE\" translate-attr-aria-label=\"CONFIGURATIONS.BUTTON_SAVE\">Save settings</md-button>\n</div></div>");
$templateCache.put("app/main/settings/sidenavs/sidenav-carded.html","<div class=\"carded-sidenav\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"CONFIGURATIONS.SIDENAV.ACCOUNT\">Account</span></md-subheader><div class=\"list-items\"><md-list-item \nui-sref=\"app.settings.accountInfo\" ng-class=\"{ active: vm.screen.accountInfo }\"><p \ntranslate=\"CONFIGURATIONS.SIDENAV.COMPANY_DATA\">Company data</p></md-list-item><md-divider></md-divider><md-list-item \nui-sref=\"app.settings.labelsManager\" ng-class=\"{ active: vm.screen.labelsManager }\"><p \ntranslate=\"CONFIGURATIONS.SIDENAV.MANAGE_LABELS\">Manage labels</p></md-list-item><md-divider></md-divider><md-list-item\n ui-sref=\"app.settings.integrations\" ng-class=\"{ active: vm.screen.integrations }\"><p \ntranslate=\"CONFIGURATIONS.SIDENAV.INTEGRATIONS\">Integrations</p></md-list-item><md-divider></md-divider></div>\n<md-subheader class=\"md-no-sticky\"><span translate=\"CONFIGURATIONS.SIDENAV.SYSTEM\">System</span></md-subheader><div \nclass=\"list-items\"><md-list-item ui-sref=\"app.settings.serviceOrder\" ng-class=\"{ active: vm.screen.serviceOrder }\"><p \ntranslate=\"CONFIGURATIONS.SIDENAV.SERVICE_ORDERS\">Service orders</p></md-list-item><md-divider></md-divider>\n<md-list-item ui-sref=\"app.settings.timeline\" ng-class=\"{ active: vm.screen.timeline }\"><p \ntranslate=\"CONFIGURATIONS.SIDENAV.TIMELINE\">Timeline</p></md-list-item><md-divider></md-divider><md-list-item \nui-sref=\"app.settings.cellphone\" ng-class=\"{ active: vm.screen.cellphone }\"><p \ntranslate=\"CONFIGURATIONS.SIDENAV.MOBILE_APP\">Mobile app</p></md-list-item><md-divider></md-divider><md-list-item \nui-sref=\"app.settings.otherConfig\" ng-class=\"{ active: vm.screen.otherConfig }\"><p \ntranslate=\"CONFIGURATIONS.SIDENAV.OTHER_SETTINGS\">Other settings</p></md-list-item><md-divider></md-divider></div>\n<md-subheader class=\"md-no-sticky\" ng-if=\"vm.account.plan.name === \'pro\' || vm.account.plan.name === \'test\'\"><span \ntranslate=\"CONFIGURATIONS.SIDENAV.DEVELOPER\">Developer</span></md-subheader><div class=\"list-items\" \nng-if=\"vm.account.plan.name === \'pro\' || vm.account.plan.name === \'test\'\"><md-list-item \nui-sref=\"app.settings.devSettings\" ng-class=\"{ active: vm.screen.devSettings }\"><p \ntranslate=\"CONFIGURATIONS.SIDENAV.INTEGRATION_API\">Integration API</p></md-list-item><md-divider></md-divider>\n<md-list-item ui-sref=\"app.settings.devWebhookCallbacks\" ng-class=\"{ active: vm.screen.devWebhookCallbacks }\"><p \ntranslate=\"CONFIGURATIONS.SIDENAV.INTEGRATION_EVENT_HISTORY\">Integration event history</p></md-list-item></div>\n</md-list></div>");
$templateCache.put("app/main/tasks/dialogs/order-dialog.html","<div class=\"fc-backdrop fc-backdrop--invisible\" ng-click=\"vm.closeDialog(reload)\"></div><md-dialog draggable \nclass=\"sidebar-dialog sidebar-dialog--large task-dialog\" aria-label=\"Ordem de serviço\" \nng-class=\"{\'sidebar-dialog--no-padding\': vm.selectedTabIndex === vm.formsTabIndex }\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><md-menu md-offset=\"0 48\" class=\"labels\">\n<md-button data-cy=\"manage-labels-button\" ng-disabled=\"!vm.editPermission\" class=\"md-icon-button\" aria-label=\"Label\" \ndata-cy=\"open-order-labels\" translate translate-attr-aria-label=\"TASKS.DIALOG.LABELS.TITLE\" \nng-click=\"vm.labelTabIndex = 0; $mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-label-outline\">\n<md-tooltip ng-if=\"vm.editPermission\" md-direction=\"bottom\" ng-if=\"vm.labels.length > 0\"><span \ntranslate=\"TASKS.DIALOG.LABELS.MANAGE\">Manage labels</span></md-tooltip><md-tooltip md-direction=\"bottom\" \nng-if=\"vm.labels.length == 0 && !vm.hasLabelsPermission\"><span translate=\"TASKS.DIALOG.LABELS.EMPTY\">\nNo tags registered, only administrators can register tags.</span></md-tooltip><md-tooltip ng-if=\"!vm.editPermission\" \nmd-direction=\"bottom\" ng-if=\"vm.labels.length > 0\"><span translate=\"NO_PERMISSION_WARN\">Manage labels</span>\n</md-tooltip></md-icon></md-button><md-menu-content ng-show=\"vm.labels.length > 0 || vm.hasLabelsPermission\" \nclass=\"labels-menu-content\" width=\"4\" ms-scroll><md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height><md-tab>\n<md-tab-body><md-menu-item ng-if=\"vm.labels.length > 0\"><md-input-container class=\"no-errors-spacer\" md-no-float><input\n data-cy=\"search-labels-input\" placeholder=\"Search labels...\" type=\"text\" ng-model=\"vm.labelSearchText\" \nautocomplete=\"off\" translate translate-attr-placeholder=\"TASKS.DIALOG.LABELS.SEARCH\"></md-input-container>\n</md-menu-item><md-menu-item ng-if=\"vm.labels.length > 0\" class=\"label\" \nng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button data-cy=\"label-toggle-button\" \nclass=\"label-toggle-button\" md-prevent-menu-close ng-class=\"\'md-\' + label.color + \'-bg\'\" \nng-click=\"vm.toggleLabel(label.id, vm.order.idLabels)\" aria-label=\"{{ label.name }}\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{ label.name }}</span> <i \nng-if=\"vm.exists(label.id, vm.order.idLabels)\" class=\"icon-check s16\"></i></div></md-button><md-button \ndata-cy=\"label-edit-button\" ng-if=\"vm.hasLabelsPermission\" class=\"md-icon-button label-edit-button\" \nmd-prevent-menu-close ng-click=\"vm.editLabel(label);\" aria-label=\"Edit Label\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.LABELS.EDIT_BUTTON\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></md-menu-item><small class=\"counter-labels\" translate=\"TASKS.DIALOG.LABELS.LIMIT_COUNT\" \ntranslate-values=\"{ length: vm.labels.length, limit: vm.labelsLimit }\">\n{{ vm.labels.length }} of {{ vm.labelsLimit }} labels</small><md-menu-divider \nng-if=\"vm.labels.length > 0 && vm.hasLabelsPermission\"></md-menu-divider><md-menu-item ng-if=\"vm.hasLabelsPermission\">\n<md-button data-cy=\"add-label-button\" class=\"add-label-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 1\" \nng-disabled=\"vm.labels.length >= vm.labelsLimit\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span \ntranslate=\"TASKS.DIALOG.LABELS.NEW\" style=\"pointer-events: auto\"><md-tooltip md-direction=\"right\" \nng-show=\"vm.labels.length >= vm.labelsLimit\"><span translate=\"TASKS.DIALOG.LABELS.LIMIT_EXCEEDED\" \ntranslate-values=\"{ length: vm.labels.length, limit: vm.labelsLimit }\">\nMaximum tag limit has been exceeded ({{ vm.labels.length }} of {{ vm.labelsLimit }}).</span></md-tooltip></span>\n</md-button></md-menu-item></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"add-label-tab-content\"><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button data-cy=\"add-label-button\" \nclass=\"md-icon-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.LABELS.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex \ntranslate=\"TASKS.DIALOG.LABELS.NEW\">Create Label</span></div><div class=\"content\" layout=\"column\" \nlayout-align=\"start stretch\"><form name=\"addLabelForm\" novalidate layout=\"column\"><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input data-cy=\"label-name-input\" placeholder=\"Label Name\" type=\"text\" \nng-model=\"vm.newLabelName\" maxlength=\"20\" required translate translate-attr-placeholder=\"TASKS.DIALOG.LABELS.NAME\">\n</md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap><label \ndata-cy=\"label-color-item-{{palette}}\" class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" \naria-label=\"{{palette}}\"> <i class=\"icon-check s18\" ng-if=\"vm.newLabelColor === palette\"></i></label></div><md-button \nmd-prevent-menu-close data-cy=\"create-label-button\" \nng-click=\"vm.addNewLabel({color:vm.newLabelColor, name: vm.newLabelName});\" class=\"create-button md-accent md-raised\" \nng-disabled=\"!vm.newLabelColor || !vm.newLabelName\" aria-label=\"Create\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.LABELS.CREATE\"><span translate=\"TASKS.DIALOG.LABELS.CREATE\">Create</span>\n</md-button></form></div></div></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button data-cy=\"edit-label-button\" \nclass=\"md-icon-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.LABELS.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex \ntranslate=\"TASKS.DIALOG.LABELS.EDIT\">Edit Label</span></div><div class=\"content\" layout=\"column\" \nlayout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float><input \ndata-cy=\"label-name-input\" placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.editingLabel.name\" maxlength=\"20\" \ntranslate translate-attr-placeholder=\"TASKS.DIALOG.LABELS.NAME\"></md-input-container><div class=\"label-color-picker\" \nlayout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input data-cy=\"edit-color-input\" class=\"ng-hide\" type=\"radio\" \nng-model=\"vm.editingLabel.color\" ng-value=\"palette\" aria-label=\"{{ palette }}\"> <i \nng-if=\"vm.editingLabel.color === palette\" class=\"icon-check s18\"></i></label></div><md-button \ndata-cy=\"update-label-button\" md-prevent-menu-close class=\"create-button md-accent md-raised\" aria-label=\"Update\" \ntranslate ng-click=\"vm.updateLabel(vm.editingLabel);\" ng-disabled=\"!vm.editingLabel.name || !vm.editingLabel.color\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.LABELS.UPDATE\"><span translate=\"TASKS.DIALOG.LABELS.UPDATE\">Update</span>\n</md-button><div layout=\"row\" layout-align=\"end center\" flex></div></div></div></md-tab-body></md-tab></md-tabs>\n</md-menu-content></md-menu><span style=\"margin-top: 10px !important\" class=\"title\"><span ng-if=\"!vm.order.id\" \ntranslate=\"TASKS.DIALOG.TITLES.NEW\">New task</span> <span ng-if=\"vm.order.id && !vm.order.locked\" \ntranslate=\"TASKS.DIALOG.TITLES.EDIT\">Edit task</span> <span ng-if=\"vm.order.id && vm.order.locked\" \ntranslate=\"TASKS.DIALOG.TITLES.VIEW\">View task</span> <span data-cy=\"identifier-task-span\" ng-if=\"vm.order.id\">\n&nbsp;#{{ vm.order.identifier | maxLength:55 }}<md-tooltip md-direction=\"right\"><span translate=\"TASKS.DIALOG.OS_ID\">\nService order identifier</span></md-tooltip></span></span><span flex></span> <span flex></span></div><div \nclass=\"order-modal-actions\" ng-if=\"vm.hasNewOsLaunchFeatureFlag\"><button class=\"order-modal-actions__launch-button\" \nng-click=\"vm.openLaunchDialog()\" aria-label=\"Launch\"><img src=\"assets/icons/star-magic-filled.svg\"> <span \ntranslate=\"TASKS.DIALOG.TEST_NEW_LAYOUT\">test new layout</span></button><div class=\"sidebar-dialog__actions\"><md-button\n data-cy=\"close-dialog-button\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n</md-toolbar><form name=\"orderForm\" class=\"md-inline-form\" novalidate><md-dialog-content class=\"dialog-content p-0\" \nms-scroll><div class=\"fc-warning-container cant-edit\" ng-if=\"vm.order && !vm.editPermission && vm.order.id\"><div \ndata-cy=\"corporate-disclaimer\"><md-icon class=\"warning-icon\" md-svg-src=\"assets/icons/icon-padlock.svg\"></md-icon><span\n translate=\"TASKS.DIALOG.WARNINGS.CANT_EDIT\">You do not have permission to edit activities</span></div></div><md-tabs \nid=\"order-dialog-tabs\" md-selected=\"vm.selectedTabIndex\" md-dynamic-height class=\"fix-textarea-scroll\"><md-tab \nng-click=\"vm.tabClicked(\'general\')\" id=\"order-general-tab\"><md-tab-label><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.TITLE\">General</span></md-tab-label><md-tab-body><div \nng-if=\"!vm.hideFeedbackForm || vm.hideFeedbackForm === \'false\'\" \nclass=\"fc-warning-container fc-warning-container--inside-tab mb-20\"><div class=\"feedback-div\"><md-icon \nstyle=\"color: blue; height: 20px !important; min-height: 20px !important\" md-svg-src=\"assets/icons/feedback.svg\">\n</md-icon><span translate=\"TASKS.DIALOG.FEEDBACK_FORM\">Feedback form</span></div><md-button \ndata-cy=\"close-dialog-button\" style=\"margin-left: 220px; padding-top: 6px !important\" class=\"md-icon-button\" \nng-click=\"vm.closeFeedback();\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\">\n<md-icon style=\"color: #135AC0\" md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nng-class=\"{\'no-edit-permission\' : !vm.editPermission && vm.order.id }\"><div layout-xs=\"column\" layout=\"row\"><div \nflex=\"100\" class=\"container-os\"><div layout-xs=\"column\" class=\"identifier-content\" layout=\"row\"><div flex=\"30\">\n<md-input-container class=\"md-block\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.IDENTIFIER.LABEL\">Identifier\n</label><input ng-disabled=\"vm.disableIdentifierInput || vm.order.id\" data-cy=\"identifier-input\" \nng-change=\"vm.validateIdentifier();\" ng-required=\"vm.identifierIsRequired\" name=\"identifier\" \nng-blur=\"vm.resetDuplicatedIdentifierFormErr();\" title=\"{{vm.order.identifier}}\" ng-model=\"vm.order.identifier\" \nrequired><div ng-show=\"vm.formErr[\'duplicatedIdentifier\']\"><div class=\"red-text\"><span>\n{{vm.formErr[\'duplicatedIdentifier\']}}</span></div></div><div data-cy=\"identifier-hash-error-message\" \nng-show=\"orderForm.identifier.$error.identifierHashValid\"><div class=\"red-text\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.IDENTIFIER.ERRORS.CHARACTER_INVALID\"></span></div></div><div \nng-messages=\"orderForm.identifier.$error\" ng-show=\"orderForm.identifier.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.IDENTIFIER.ERRORS.REQUIRED\">\nIdentifier field is required</span></div></div></md-input-container></div><div flex=\"60\" id=\"service-container\">\n<md-input-container class=\"md-block\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SERVICE.LABEL\">Service</label>\n<md-select ng-disabled=\"vm.featureDisableEditService\" data-cy=\"service-select\" \nplaceholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.SERVICE.SELECT\' | translate }}\" id=\"select-service\" name=\"serviceId\" \nmd-on-close=\"vm.clearSearchTerm();\" ng-required=\"vm.toggleServiceRequiredValidationWorkaround();\" \nng-model=\"vm.order.service.id\" ng-change=\"vm.onSelectedService();\"><md-select-header class=\"header-services\"><input \ndata-cy=\"services-search-input\" size=\"30\" ng-model=\"vm.serviceSearchTerm\" class=\"input-services\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" placeholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.SERVICE.SEARCH\' | translate }}\">\n</md-select-header><md-option class=\"service-select-options\" data-cy=\"service-select-option\" \nng-class=\"{ \'inactive-archived-item\': service.archived }\" ng-if=\"service.show\" \nng-repeat=\"service in vm.services | orderBy: \'description\' | filter: vm.serviceSearchTerm\" value=\"{{ service.id }}\">\n<span ng-class=\"{ \'inactive\': service.archived }\">{{ ::service.description | maxLength:55}}</span> <small class=\"gray\" \nng-if=\"service.metadata.sammathnaur.account.name\">- ({{::service.metadata.sammathnaur.account.name}}) </small><span \nclass=\"gray\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SERVICE.DURATION\" \ntranslate-value-duration=\"{{ service.duration }}\">- {{ ::service.duration }} minutes </span><span class=\"caption\" \nng-if=\"service.archived\" translate=\"RECURRENCES.MODEL.ARCHIVED_SERVICE\">Archived</span></md-option></md-select><small>\n<span ng-if=\"vm.order.service.form.id\"><i class=\"md-accent-fg icon icon-format-list-numbers s15\"></i>\n {{ vm.order.service.form.name }}</span></small><div ng-messages=\"orderForm.serviceId.$error\" \nng-show=\"orderForm.serviceId.$touched\" role=\"alert\"><div data-cy=\"service-required-err\" ng-message=\"required\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SERVICE.ERRORS.REQUIRED\">Service field is required</span></div></div>\n</md-input-container></div><div flex=\"15\"><label class=\"fake-floating-label\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DEADLINE.LABEL\">Deadline</label><div layout=\"row\"><md-datepicker \ndata-cy=\"service-dutarion-input\" class=\"icon-hide\" name=\"deadlineAt\" ng-model=\"vm.order._deadlineAt\" \nmd-placeholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.DEADLINE.LABEL\' | translate }}\"></md-datepicker></div><div \nlayout=\"row\" ng-messages=\"orderForm[\'deadlineAt\'].$error\" ng-show=\"orderForm[\'deadlineAt\'].$touched\" role=\"alert\" \nclass=\"fs-15\"><div ng-message=\"valid\"><small><span class=\"red-text\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DEADLINE.ERRORS.INVALID\">Scheduled date is invalid</span></small></div>\n</div></div></div><div layout-xs=\"column\" class=\"labels-content\" layout=\"row\"><span \nng-repeat=\"idLabel in vm.order.idLabels\"><span ng-class=\"\'md-\' + vm.getItemById(vm.labels, idLabel).color + \'-bg\'\" \nclass=\"status-label\">{{ vm.getItemById(vm.labels, idLabel).name }}</span>&nbsp;</span></div><div layout-xs=\"column\" \nflex=\"100\"><div layout-xs=\"column\" class=\"customer-space\" layout=\"row\" class=\"mt-17n mb-15n\"><div \nng-attr-flex=\"{{ vm.hasCustomerPermission ? 95 : 100 }}\" ng-if=\"!vm.selectedCustomer\"><md-autocomplete flex required \nng-blur=\"vm.validateCustomer();\" md-input-id=\"auto-complete-customer\" md-input-name=\"customer\" md-input-minlength=\"2\" \nmd-input-maxlength=\"150\" md-no-cache=\"false\" md-selected-item-change=\"vm.selectedCustomerChanged()\" \nmd-selected-item=\"vm.selectedCustomer\" md-search-text=\"vm.searchCustomerText\" \nmd-items=\"item in vm.searchCustomer(vm.searchCustomerText)\" md-autoselect=\"true\" md-delay=\"800\" \nmd-item-text=\"item.name\" md-floating-label=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.LABEL\' | translate }}\">\n<md-item-template><md-icon class=\"s-18\" md-svg-src=\"assets/icons/conta-azul.svg\" \nng-if=\"item.type === \'ca\' && !item.type === \'om\'\"></md-icon><md-icon class=\"s-18\" \nmd-svg-src=\"assets/icons/modules/omie.svg\" class=\"omie-icon\" ng-if=\"item.type === \'om\'\"></md-icon>\n{{ item.name }}&nbsp; <i class=\"md-accent-fg icon icon-document s15\" ng-if=\"item.documentNumber\"></i> <span \nclass=\"additional-customer-info\" ng-if=\"item.documentNumber\">{{ item.documentNumber | cpfCnpjFilter }}</span>&nbsp; <i \nclass=\"md-accent-fg icon icon-map-marker s15\" ng-if=\"item.address.formattedAddress\"></i> <span \nclass=\"additional-customer-info\" ng-if=\"item.address.formattedAddress\">{{ item.address.formattedAddress }}</span>\n</md-item-template><md-not-found><span class=\"employee-not-found\" \nng-if=\"vm.accountConfiguration.featureDisableAddCustomer\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.NOT_FOUND\">Customer not found </span><span \nclass=\"employee-not-found\" onclick=\"document.getElementById(\'add-customer\').click()\" \nng-if=\"!vm.accountConfiguration.featureDisableAddCustomer\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.ADD\">\nNo customers found, add a new customer?</span></md-not-found><div ng-messages=\"orderForm.customer.$error\" \nng-if=\"orderForm.customer.$touched\"><div ng-message=\"required\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.ERRORS.REQUIRED\">Customer field is required</span></div></div><div\n ng-if=\"vm.formErr[\'customerIsRequired\'] && vm.searchCustomerText.length > 0\"><div class=\"grey-text fs-14\"><small \nng-bind-html=\"vm.formErr[\'customerIsRequired\']\"></small></div></div></md-autocomplete></div><div flex=\"5\" \nng-if=\"!vm.selectedCustomer && vm.hasCustomerPermission\"><md-button id=\"add-customer\" data-cy=\"add-customer-button\" \nng-hide=\"vm.accountConfiguration.featureDisableAddCustomer === true\" ng-click=\"vm.createNewCustomer($event);\" \nclass=\"md-icon-button md-accent mt-13 ml-5n\" aria-label=\"Register new customer\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.REGISTER\"><md-icon \nmd-font-icon=\"icon icon-account-plus\"></md-icon><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.REGISTER\">Register new customer</span></md-tooltip></md-button>\n</div><div flex=\"95\" ng-if=\"vm.selectedCustomer || vm.addOrEditCustomer\"><md-input-container id=\"customer-name-input\" \nclass=\"md-block\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.LABEL\">Customer</label><input \nid=\"customerName\" name=\"customerName\" data-cy=\"customer-name-input\" ng-required=\"vm.addOrEditCustomer\" \nng-disabled=\"!vm.addOrEditCustomer\" ng-model=\"vm.selectedCustomer.name\"><div \nng-messages=\"orderForm.customerName.$error\"><div ng-message=\"required\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.ERRORS.REQUIRED\">Customer field is required</span></div><div \ndata-cy=\"customer-allow-create-task-err\" ng-message=\"customerAllowCreateTaskEnabled\" class=\"mt-5n op-100\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER.ERRORS.ADD_TASK_DISABLED_FOR_CORPORATE_CUSTOMER\" \ntranslate-values=\"{ customerName: vm.selectedCustomer.metadata.sammathnaur.account.name }\">\n> Cannot post task to a customer location <b>{{ vm.selectedCustomer.metadata.sammathnaur.account.name }}</b>.</span>\n</div></div><div role=\"alert\" ng-if=\"!vm.addOrEditCustomer\"><div class=\"fs-12\" ng-if=\"vm.selectedCustomer.statistics\">\n<span ng-if=\"vm.selectedCustomer.statistics.service.total\"><i class=\"md-accent-fg icon icon-home-variant s15\"></i> \n<span translate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.TOTAL_VIEWS\">Total visits</span>\n: {{ vm.selectedCustomer.statistics.service.total }} </span><span \nng-if=\"vm.selectedCustomer.statistics.rating.averageStars\"><i class=\"md-accent-fg icon icon-star s15\"></i> <span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.AVERAGE_RATING\">Average rating</span>\n: {{ vm.selectedCustomer.statistics.rating.averageStars }} </span><span ng-if=\"vm.selectedCustomer.omieAccount\">\n<md-icon md-svg-src=\"assets/icons/icon-omie-active.svg\" class=\"omie-tiny-icon\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.OMIE_ACCOUNT\">Omie Account</span>: <b>\n{{ vm.selectedCustomer.omieAccount }}</b> </span><span ng-if=\"vm.selectedCustomer.statistics.rating.lastStar\"><i \nclass=\"md-accent-fg icon icon-thumb-up s15\" ng-if=\"vm.selectedCustomer.statistics.rating.lastStar > 3\"></i> <i \nclass=\"md-accent-fg icon icon-thumb-down s15\" ng-if=\"vm.selectedCustomer.statistics.rating.lastStar <= 3\"></i> <span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.LAST_REVIEW\">Last review</span>\n: {{ vm.selectedCustomer.statistics.rating.lastStar }} <span class=\"customer-rating-comments\" \nng-if=\"vm.selectedCustomer.statistics.rating.lastComment\">- {{ vm.selectedCustomer.statistics.rating.lastComment }}\n</span></span></div><div class=\"fs-12\" ng-if=\"!vm.showMoreCustomerInfo\"><span \nng-if=\"vm.selectedCustomer.primaries.phone.number\"><i class=\"md-accent-fg icon icon-phone s15\"></i>\n {{ \'+\' + vm.selectedCustomer.primaries.phone.countryCode }} {{ vm.formatPhoneByCountryCode(vm.selectedCustomer.primaries.phone.countryCode, vm.selectedCustomer.primaries.phone.number) }} \n</span><span ng-if=\"vm.selectedCustomer.primaries.email.address\"><i class=\"md-accent-fg icon icon-email s15\"></i>\n {{ vm.selectedCustomer.primaries.email.address }} </span><span ng-if=\"vm.selectedCustomer.notes\"><i \nclass=\"md-accent-fg icon icon-comment s15\"></i> {{ vm.selectedCustomer.notes }} </span><span \nng-if=\"vm.selectedCustomer.contacts.emails.length >= 2 || vm.selectedCustomer.contacts.phones.length >= 2\" \nclass=\"display-inline\"><span class=\"text-bold cursor-pointer\" \nng-click=\"vm.showMoreCustomerInfo = !vm.showMoreCustomerInfo\"><i class=\"md-accent-fg icon icon-plus s15\"></i> <span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.SHOW_MORE\">Show more</span></span></span></div><div class=\"fs-12\" \nng-if=\"vm.showMoreCustomerInfo\"><div ng-if=\"vm.selectedCustomer.contacts.phones.length\"><span><i \nclass=\"md-accent-fg icon icon-phone s15\"></i> <span translate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.PHONES\">Phones</span>\n:</span><ul class=\"margin-top-0 margin-bottom-0\"><li \nng-repeat=\"phone in vm.selectedCustomer.contacts.phones | orderBy:\'primary\':true\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.MOBILE\" ng-if=\"phone.type === \'mobile\'\">Mobile</span> <span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.WORK\" ng-if=\"phone.type === \'work\'\">Work</span> <span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.HOME\" ng-if=\"phone.type === \'home\'\">Home</span> <span>\n{{ phone.type ? \':\' : \'\' }} {{\'+\' + phone.countryCode}} {{ vm.formatPhoneByCountryCode(phone.countryCode, phone.number) }} {{ phone.primary ? \'-\' : \'\' }} \n</span><span ng-if=\"phone.primary\" translate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.PRIMARY\">Primary</span></li>\n</ul></div><div ng-if=\"vm.selectedCustomer.contacts.emails.length\"><span><i class=\"md-accent-fg icon icon-email s15\">\n</i> <span translate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.EMAILS\"></span>:</span><ul \nclass=\"margin-top-0 margin-bottom-0\"><li \nng-repeat=\"email in vm.selectedCustomer.contacts.emails | orderBy:\'primary\':true\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.WORK\" ng-if=\"email.type === \'work\'\">Work</span> <span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.PERSONAL\" ng-if=\"email.type === \'personal\'\">Personal</span> \n<span>{{ email.type ? \':\' : \'\' }} {{ email.address }} {{ email.primary ? \'-\' : \'\' }}</span> <span \nng-if=\"email.primary\" translate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.PRIMARY\">Primary</span></li></ul></div>\n<div ng-if=\"vm.selectedCustomer.notes\"><i class=\"md-accent-fg icon icon-comment s15\"></i>\n {{ vm.selectedCustomer.notes }}</div><div \nng-if=\"vm.selectedCustomer.contacts.emails.length >= 2 || vm.selectedCustomer.contacts.phones.length >= 2\"><span \nclass=\"text-bold cursor-pointer\" ng-click=\"vm.showMoreCustomerInfo = !vm.showMoreCustomerInfo\"><i \nclass=\"md-accent-fg icon icon-plus s15\" ng-if=\"!vm.showMoreCustomerInfo\"></i> <i \nclass=\"md-accent-fg icon icon-minus s15\" ng-if=\"vm.showMoreCustomerInfo\"></i> <span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.SHOW_LESS\">Show less</span></span></div></div><div class=\"fs-12\" \nng-if=\"vm.comingTasksCount && !vm.order.id && (vm.addOrEditCustomer == undefined || vm.addOrEditCustomer == false)\"><i \nclass=\"md-accent-fg icon icon-calendar-check-multiple s15\"></i> <a \nng-href=\'#/atividades?q=data_agendamento<=:2030-01-01+data_agendamento>=:{{vm.comingTasksScheduledFromDateParam}}+nome_cliente:\"{{vm.selectedCustomer.name | encodedUriComponent}}\"+status:\"scheduled\"\' \nclass=\"fc-black\" target=\"_blank\" ng-if=\"vm.comingTasksCount > 1\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.SCHEDULED_TASKS\" translate-value-count=\"{{ vm.comingTasksCount }}\">\nThere are <b>{{ vm.comingTasksCount }} tasks scheduled</b> for the customer in the coming days </span></a><a \nng-href=\'#/atividades?q=data_agendamento<=:2030-01-01+data_agendamento>=:{{vm.comingTasksScheduledFromDateParam}}+nome_cliente:\"{{vm.selectedCustomer.name | encodedUriComponent}}\"+status:\"scheduled\"\' \nclass=\"fc-black\" target=\"_blank\" ng-if=\"vm.comingTasksCount == 1\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.SCHEDULED_TASK\" \ntranslate-values=\"{ count: vm.comingTasksCount, date: vm.comingTasksScheduledDate }\">There is <b>\n{{ vm.comingTasksCount }} scheduled activity</b> for the customer at {{ vm.comingTasksScheduledDate }}</span></a></div>\n<div ng-if=\"vm.selectedCustomer.labels\" class=\"fs-12\"><span ng-repeat=\"label in vm.selectedCustomer.labels\" \nclass=\"task-customer-label {{ label.color }}-bg\">{{ label.name }}</span></div></div></md-input-container></div><div \nflex=\"5\" ng-if=\"(vm.selectedCustomer || vm.addOrEditCustomer) && !vm.featureDisableEditCustomer\"><md-button \nid=\"clear-customer\" data-cy=\"clear-customer-button\" ng-click=\"vm.clearSelectedCustomer($event);\" \nclass=\"md-icon-button md-accent mt-13 ml-5n\" aria-label=\"Clear customer\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.CLEAR\"><md-icon \nmd-font-icon=\"icon icon-close-circle-outline\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.CUSTOMER.CLEAR\">Clear customer</span></md-tooltip></md-button></div></div><div \nlayout-xs=\"column\" class=\"customer-space\" layout=\"row\" \nng-class=\"{\'no-edit-permission\' : !vm.editPermission && vm.order.id} \" class=\"mt-17n mb-15n\" \nng-if=\"vm.selectedCustomer && !vm.addOrEditCustomer\"><div flex=\"95\" ng-if=\"!vm.selectedCustomerLocation\">\n<md-autocomplete flex required md-input-id=\"auto-complete-customer-location\" md-input-name=\"customerLocation\" \nmd-input-minlength=\"2\" md-input-maxlength=\"150\" md-no-cache=\"false\" md-search-text=\"vm.searchCustomerLocationText\" \nmd-selected-item=\"vm.selectedCustomerLocation\" \nmd-selected-item-change=\"vm.selectedCustomerLocationChanged(vm.selectedCustomerLocation)\" \nmd-items=\"customerLocation in vm.searchCustomerLocation(vm.selectedCustomer, vm.searchCustomerLocationText)\" \nmd-autoselect=\"true\" md-delay=\"800\" md-item-text=\"customerLocation.name\" \nmd-floating-label=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_LOCATION.LABEL\' | translate }}\" \nng-disabled=\"vm.selectedCustomerLocation\"><md-item-template>{{ customerLocation.name }}&nbsp; <i \nclass=\"md-accent-fg icon icon-map-marker s15\" ng-if=\"customerLocation.address.formattedAddress\"></i> <span \nclass=\"additional-customer-info\" ng-if=\"customerLocation.address.formattedAddress\">\n{{ customerLocation.address.formattedAddress }}</span></md-item-template><md-not-found><span \nclass=\"employee-not-found\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_LOCATION.NOT_FOUND\">Location not found\n</span></md-not-found><div ng-messages=\"orderForm.customerLocation.$error\" ng-if=\"orderForm.customerLocation.$touched\">\n<div ng-message=\"required\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_LOCATION.ERRORS.REQUIRED\">\nCustomer location is required</span></div></div><small ng-if=\"vm.hasNoLocations\" role=\"alert\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_LOCATION.NO_LOCATIONS.TEXT\">\nThis customer don\'t have locations yet. </span><a class=\"cursor-pointer\" ng-click=\"vm.createFirstCustomerLocation()\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_LOCATION.NO_LOCATIONS.LINK\">Click here to create a location on:\n</a><br><span>{{ vm.selectedCustomer.address.formattedAddress }}</span></small></md-autocomplete></div><div flex=\"95\" \nng-if=\"vm.selectedCustomerLocation\"><md-input-container id=\"customer-name-input\" class=\"md-block\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_LOCATION.LABEL\">Location</label><input id=\"customerLocationName\" \nname=\"customerLocationName\" ng-required=\"vm.addOrEditCustomer\" ng-disabled=\"!vm.addOrEditCustomer\" \nng-model=\"vm.selectedCustomerLocation.name\"><div ng-messages=\"orderForm.customerLocationName.$error\"><div \nng-message=\"required\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_LOCATION.ERRORS.REQUIRED\">\nCustomer location is required</span></div></div></md-input-container></div><div flex=\"5\" \nng-if=\"vm.selectedCustomerLocation && !vm.featureDisableEditLocation\"><md-button id=\"clear-customer-location\" \nng-click=\"vm.clearSelectedCustomerLocation($event);\" class=\"md-icon-button md-accent mt-13 ml-5n\" \naria-label=\"Clear customer\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_LOCATION.CLEAR\"><md-icon \nmd-font-icon=\"icon icon-close-circle-outline\"></md-icon><md-tooltip md-direction=\"bottom\"><span \nng-if=\"vm.editPermission\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_LOCATION.CLEAR\">Clear customer location\n</span></md-tooltip></md-button></div></div><div layout-xs=\"column\" layout=\"row\" \nng-if=\"vm.addOrEditCustomer && vm.addressModeSelection === \'google\'\" class=\"mb-15n\"><div \nng-if=\"!vm.selectedNewCustomerAddress\" flex><md-autocomplete flex ng-required=\"vm.isAutoCompleteAddressRequired();\" \nng-blur=\"vm.validateCustomerAddress();\" md-input-id=\"auto-complete-address\" md-input-name=\"auto-complete-address\" \nmd-input-minlength=\"2\" md-input-maxlength=\"150\" md-no-cache=\"false\" \nmd-selected-item-change=\"vm.selectedAddressItemChange(vm.selectedCustomerAddress, true)\" \nmd-selected-item=\"vm.selectedCustomerAddress\" md-search-text=\"vm.selectedCustomerAddressText\" \nmd-items=\"item in vm.searchAddress(vm.selectedCustomerAddressText)\" md-autoselect=\"true\" md-delay=\"1500\" \nmd-item-text=\"item.formattedAddress\" \nmd-floating-label=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_ADDRESS.LABEL\' | translate }}\" \nmd-menu-class=\"autocomplete-custom-template\"><md-item-template><span class=\"item-title\"><md-icon class=\"s18\" \nmd-font-icon=\"icon-map-marker\"></md-icon><span>{{ item.formattedAddress }} </span></span><span \nclass=\"item-metadata fs-13\"><md-icon class=\"s18\" md-font-icon=\"icon-road\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_ADDRESS.DISTANCE\" \ntranslate-value-distance=\"{{ item.kmDistance | number:1 | removeComma }}\">\n{{ item.kmDistance | number:1 | removeComma }} km de away</span></span></md-item-template><md-not-found><span \nclass=\"item-title\"><md-icon class=\"s18\" md-font-icon=\"icon-map-marker-off\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_ADDRESS.ERRORS.ADDRESS_NOT_FOUND\">\nWe could not find the address, change your search and try again.</span></span></md-not-found><div class=\"hint\" \nng-if=\"!vm.formErr[\'customerAddressIsRequired\']\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_ADDRESS.HINT\">\nLook for an address, example: Rua dos Pinheiros, 383 - São Paulo</span></div><div \nng-messages=\"orderForm[\'auto-complete-address\'].$error\" ng-if=\"orderForm[\'auto-complete-address\'].$touched\"><div \nng-message=\"required\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_ADDRESS.ERRORS.REQUIRED\">\nCustomer address field is required</span></div></div><div \nng-if=\"vm.formErr[\'customerAddressIsRequired\'] && vm.selectedCustomerAddressText.length > 0\"><div \nclass=\"grey-text fs-14\"><small ng-bind-html=\"vm.formErr[\'customerAddressIsRequired\']\"></small></div></div>\n</md-autocomplete></div><div flex=\"95\" ng-if=\"vm.selectedNewCustomerAddress\"><md-input-container class=\"md-block\">\n<label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_ADDRESS.LABEL\">Customer Address</label><input \nid=\"formattedAddress\" name=\"formattedAddress\" ng-model=\"vm.selectedCustomer.address.formattedAddress\" \ndisabled=\"disabled\" required><div class=\"hint\"><div ng-repeat=\"error in vm.googleCustomerAddressErrors\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"red-fg fs-16\"></md-icon><span class=\"ml-7n\">\n{{ \'CORE.ADDRESS_SERVICE.VALIDATION.\' + error | translate }}</span></div><div \nng-repeat=\"warning in vm.googleCustomerAddressWarnings\"><md-icon md-font-icon=\"icon-alert\" class=\"orange-fg fs-16\">\n</md-icon><span class=\"ml-7n\">{{ \'CORE.ADDRESS_SERVICE.VALIDATION.\' + warning | translate }}</span></div></div>\n</md-input-container></div><div flex=\"5\" ng-if=\"vm.selectedNewCustomerAddress\"><md-button id=\"clear-customer-address\" \nng-click=\"vm.clearSelectedCustomerAddress($event);\" class=\"md-icon-button md-accent mt-13 ml-5n\" \naria-label=\"Clear customer address\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_ADDRESS.CLEAR\"><md-icon \nmd-font-icon=\"icon icon-close-circle-outline\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_ADDRESS.CLEAR\">Clear customer address</span></md-tooltip>\n</md-button></div></div><div layout-xs=\"column\" layout=\"row\" \nng-if=\"vm.addOrEditCustomer && vm.addressModeSelection === \'google\'\" class=\"mb-15n\"><div flex=\"65\"><md-input-container \nclass=\"md-block\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLEMENT.LABEL\">Address complement</label><input \nname=\"complement\" ng-model=\"vm.selectedCustomer.address.complement\" ng-maxlength=\"50\"><div \nng-messages=\"orderForm.complement.$error\" ng-show=\"orderForm.complement.$touched\" role=\"alert\"><div \nng-message=\"maxlength\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLEMENT.ERRORS.VALID\">\nComplement must not contain more than 50 characters</span></div></div></md-input-container></div><div flex=\"35\">\n<md-input-container class=\"md-block\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DOCUMENT.LABEL\">CPF/CNPJ\n</label><input name=\"documentNumber\" ng-model=\"vm.selectedCustomer.documentNumber\" \nng-change=\"vm.duplicatedValidation(vm.selectedCustomer, orderForm.documentNumber)\" ui-br-cpfcnpj-mask><div \nng-messages=\"orderForm.documentNumber.$error\" ng-show=\"orderForm.documentNumber.$touched\" role=\"alert\"><div \nng-message=\"cpf\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DOCUMENT.ERRORS.INVALID_CPF\">Invalid CPF</span>\n</div><div ng-message=\"cnpj\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DOCUMENT.ERRORS.INVALID_CNPJ\">\nInvalid CNPJ</span></div><div ng-message=\"duplicated\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DOCUMENT.ERRORS.NUMBER_DUPLICATED\">Document number duplicated</span></div>\n</div></md-input-container></div></div><div layout-xs=\"column\" layout=\"row\" \nng-if=\"vm.addOrEditCustomer && vm.addressModeSelection === \'cepdb\'\"><div flex=\"15\"><md-input-container \nclass=\"md-block margin-fix\"><label id=\"cep\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.ZIPCODE.LABEL\">Zip Code</label>\n<input ui-mask=\"99999-999\" id=\"zipCode\" required ng-blur=\"vm.searchZipCode();\" name=\"zipCode\" \nng-model=\"vm.selectedCustomer.address.zipCode\"><div ng-messages=\"orderForm.zipCode.$error\" \nng-show=\"orderForm.zipCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.ZIPCODE.ERRORS.REQUIRED\">Zip code field is required</span></div></div>\n</md-input-container></div><div flex=\"40\"><md-input-container class=\"md-block margin-fix\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CITY.LABEL\">City</label><input name=\"city\" \nng-model=\"vm.selectedCustomer.address.city\" required><div ng-messages=\"orderForm.city.$error\" \nng-show=\"orderForm.city.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CITY.ERRORS.REQUIRED\">City field is required</span></div></div>\n</md-input-container></div><div flex=\"20\"><md-input-container class=\"md-block margin-fix\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STATE.LABEL\">State</label><input name=\"state\" \nng-model=\"vm.selectedCustomer.address.state\" required><div ng-messages=\"orderForm.state.$error\" \nng-show=\"orderForm.state.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STATE.ERRORS.REQUIRED\">State field is required</span></div></div>\n</md-input-container></div><div flex=\"25\"><md-input-container class=\"md-block margin-fix\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.NEIGHBORHOOD.LABEL\">Neighborhood</label><input name=\"neighborhood\" \nmaxlength=\"50\" ng-model=\"vm.selectedCustomer.address.neighborhood\"></md-input-container></div></div><div \nlayout-xs=\"column\" layout=\"row\" ng-if=\"vm.addOrEditCustomer && vm.addressModeSelection === \'cepdb\'\"><div flex=\"50\">\n<md-input-container class=\"md-block margin-fix\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STREET.LABEL\">\nAddress</label><input name=\"street\" ng-model=\"vm.selectedCustomer.address.street\"><div \nng-messages=\"orderForm.street.$error\" ng-show=\"orderForm.street.$touched\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STREET.ERRORS.REQUIRED\">Address field is required</span></div></div>\n</md-input-container></div><div flex=\"15\"><md-input-container class=\"md-block margin-fix\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.NUMBER.LABEL\">Number</label><input id=\"number\" name=\"number\" \nng-blur=\"vm.customerGeoCodeAddress()\" ng-model=\"vm.selectedCustomer.address.number\"><div \nng-messages=\"orderForm.number.$error\" ng-show=\"orderForm.number.$touched\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.NUMBER.ERRORS.REQUIRED\">Number field is required</span></div></div>\n</md-input-container></div><div flex=\"30\"><md-input-container class=\"md-block margin-fix\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLEMENT.LABEL\">Complement</label><input name=\"complement\" \nng-model=\"vm.selectedCustomer.address.complement\" g-maxlength=\"50\"><div ng-messages=\"orderForm.complement.$error\" \nng-show=\"orderForm.complement.$touched\" role=\"alert\"><div ng-message=\"maxlength\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLEMENT.ERRORS.VALID\">\nComplement must not contain more than 50 characters</span></div></div></md-input-container></div><div flex=\"5\" \nclass=\"mtop-10\" layout-align=\"center center\" \nng-if=\"vm.order.address.coords.latitude && vm.order.address.coords.longitude\"><a \nclass=\"align-icon-form-s40 no-text-decoration\" \nhref=\"https://maps.google.com/?q={{vm.order.address.coords.latitude }},{{vm.order.address.coords.longitude}}\" \ntarget=\"_blank\" aria-label=\"Local\"><i class=\"md-accent-fg icon icon-map-marker s40\"></i><md-tooltip md-direction=\"top\" \nmd-delay=\"1\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.LOCAL.LAT_LONG\" \ntranslate-values=\"{ lat: vm.order.address.coords.latitude, long: vm.order.address.coords.longitude }\">\nlatitude: {{ vm.order.address.coords.latitude }}, longitude: {{ vm.order.address.coords.longitude }}</span>\n</md-tooltip></a></div><div flex=\"35\"><md-input-container class=\"md-block\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DOCUMENT.LABEL\">CPF/CNPJ</label><input name=\"documentNumber\" \nng-model=\"vm.selectedCustomer.documentNumber\" \nng-change=\"vm.duplicatedValidation(vm.selectedCustomer, orderForm.documentNumber)\" ui-br-cpfcnpj-mask><div \nng-messages=\"orderForm.documentNumber.$error\" ng-show=\"orderForm.documentNumber.$touched\" role=\"alert\"><div \nng-message=\"cpf\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DOCUMENT.ERRORS.INVALID_CPF\">Invalid CPF</span>\n</div><div ng-message=\"cnpj\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DOCUMENT.ERRORS.INVALID_CNPJ\">\nInvalid CNPJ</span></div><div ng-message=\"duplicated\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DOCUMENT.ERRORS.NUMBER_DUPLICATED\">Document number duplicated</span></div>\n</div></md-input-container></div></div><div layout-xs=\"column\" class=\"email-space\" layout=\"row\" \nng-if=\"vm.addOrEditCustomer\" ng-repeat=\"email in vm.selectedCustomer.contacts.emails track by $index\"><div flex=\"60\">\n<md-input-container class=\"md-block\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMAIL.LABEL\">Email</label>\n<input id=\"customer_contacts_email_address_{{$index}}\" name=\"customer_contacts_email_address_{{$index}}\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() :\'\';\" ng-model=\"email.address\" email-validation><div \nng-messages=\"orderForm[\'customer_contacts_email_address_\' + $index].$error\" \nng-if=\"orderForm[\'customer_contacts_email_address_\' + $index].$touched\" role=\"alert\"><div ng-message=\"pattern\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMAIL.ERRORS.PATTERN\">Must be a valid email address</span></div></div><div \nclass=\"hint\"><md-checkbox class=\"contact-checkbox-primary\" ng-model=\"email.primary\" \nng-change=\"vm.setEmailAsPrimary($index);\" aria-label=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.EMAIL.HINT\' | translate }}\">\n<span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMAIL.HINT\">Main email</span></md-checkbox></div>\n</md-input-container></div><div flex><md-input-container class=\"md-block\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMAIL.SELECT_TYPE\">Email type</label><md-select \nname=\"customer_contacts_email_contacttype_{{$index}}\" \nplaceholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.EMAIL.SELECT_TYPE\' | translate }}\" ng-model=\"email.type\"><md-option \nvalue=\"personal\"><md-icon md-font-icon=\"icon-account\" class=\"s20\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.PERSONAL\">Personal</span></md-option><md-option value=\"work\">\n<md-icon md-font-icon=\"icon-briefcase\" class=\"s18\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.WORK\">Work</span></md-option></md-select></md-input-container>\n</div><div flex=\"5\" ng-if=\"vm.selectedCustomer.contacts.emails.length > 1\"><md-button class=\"md-icon-button mtop-15\" \nng-click=\"vm.removeEmail($index);\" style=\"margin-left: -3px\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n<md-tooltip><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMAIL.REMOVE\">Remove email</span></md-tooltip>\n</md-button></div><div flex=\"5\" \nng-if=\"($index === (vm.selectedCustomer.contacts.emails.length - 1)) && vm.selectedCustomer.contacts.emails.length < 3 && email.address !== \'\' && orderForm[\'customer_contacts_email_address_\' + $index].$valid\">\n<md-button class=\"md-icon-button mtop-15\" ng-click=\"vm.addEmail();\" style=\"margin-left: -3px\"><md-icon \nclass=\"md-accent\" md-font-icon=\"icon-plus-circle\"></md-icon><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMAIL.ADD\">Add one more email</span></md-tooltip></md-button></div></div>\n<div layout-xs=\"column\" layout=\"row\" class=\"phone-space\" ng-if=\"vm.addOrEditCustomer\" class=\"mb-15n\" \nng-repeat=\"phone in vm.selectedCustomer.contacts.phones track by $index\"><div flex=\"20\"><md-input-container \nclass=\"md-block\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.CODE\">Code</label><md-select \nplaceholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.CODE\' | translate }}\" \nname=\"customer_contacts_phone_countryCode_{{$index}}\" ng-model=\"phone.countryCode\"><md-option \nng-repeat=\"countryCodeObject in vm.countryCodes\" value=\"{{countryCodeObject.countryCode}}\"><md-icon \nmd-font-icon=\"icon-cellphone-iphone\" class=\"s18\"></md-icon><span>{{ \'+\' + countryCodeObject.countryCode }}</span>\n</md-option></md-select><div class=\"hint\"><md-checkbox class=\"contact-checkbox-primary\" ng-model=\"phone.primary\" \nng-change=\"vm.setPhoneAsPrimary($index);\" aria-label=\"Telefone principal\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.HINT\">Main phone</span></md-checkbox></div></md-input-container>\n</div><div flex=\"40\"><md-input-container ng-if=\"phone.countryCode === \'55\'\" class=\"md-block\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.LABEL\">Phone</label><input \nid=\"customer_contacts_phone_number_{{$index}}\" name=\"customer_contacts_phone_number_{{$index}}\" \nng-model=\"phone.number\" ng-change=\"vm.checkPhoneType($index);\" ui-br-phone-number><div \nng-messages=\"orderForm[\'customer_contacts_phone_number_\' + $index].$error\" \nng-if=\"orderForm[\'customer_contacts_phone_number_\' + $index].$touched\" role=\"alert\"><div ng-message=\"brPhoneNumber\">\n<span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.ERRORS.NUMBER_INVALID\">Invalid phone format</span></div></div>\n</md-input-container><md-input-container ng-if=\"phone.countryCode !== \'55\'\" class=\"md-block\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.LABEL\">Phone</label><input \nid=\"customer_contacts_phone_number_{{$index}}\" name=\"customer_contacts_phone_number_{{$index}}\" \nng-model=\"phone.number\" ng-change=\"vm.checkPhoneType($index);\" ng-pattern=\"/^[0-9]/\" \nng-maxlength=\"vm.getMaxLengthByCountryCode(phone.countryCode)\"><div \nng-messages=\"orderForm[\'customer_contacts_phone_number_\' + $index].$error\" \nng-if=\"orderForm[\'customer_contacts_phone_number_\' + $index].$touched\" role=\"alert\"><div ng-message=\"pattern\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.ERRORS.NUMBER_INVALID\">Invalid phone format</span></div><div \nng-message=\"maxlength\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.ERRORS.NUMBER_INVALID\">\nInvalid phone format</span></div></div></md-input-container></div><div flex><md-input-container class=\"md-block\"><label\n translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.SELECT_TYPE\">Phone type</label><md-select \nplaceholder=\"Tipo do telefone\" name=\"customer_contacts_phone_contacttype_{{$index}}\" ng-model=\"phone.type\"><md-option \nvalue=\"mobile\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"s18\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.MOBILE\">Celular</span></md-option><md-option value=\"home\">\n<md-icon md-font-icon=\"icon-home-variant\" class=\"s18\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.HOME\">Casa</span></md-option><md-option value=\"work\"><md-icon \nmd-font-icon=\"icon-briefcase\" class=\"s18\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.MODEL.CONTACT_TYPE.WORK\">Trabalho</span></md-option></md-select>\n</md-input-container></div><div flex=\"5\" ng-if=\"vm.selectedCustomer.contacts.phones.length > 1\"><md-button \nclass=\"md-icon-button mtop-15\" ng-click=\"vm.removePhone($index);\" style=\"margin-left: -3px\"><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon><md-tooltip><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.REMOVE\">\nRemove phone</span></md-tooltip></md-button></div><div flex=\"5\" \nng-if=\"($index === (vm.selectedCustomer.contacts.phones.length - 1)) && vm.selectedCustomer.contacts.phones.length < 3 && phone.number !== \'\' && orderForm[\'customer_contacts_phone_number_\' + $index].$valid\">\n<md-button class=\"md-icon-button mtop-15\" ng-click=\"vm.addPhone();\" style=\"margin-left: -3px\"><md-icon \nclass=\"md-accent\" md-font-icon=\"icon-plus-circle\"></md-icon><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.PHONE.ADD\">Add one more phone</span></md-tooltip></md-button></div></div>\n<div layout-xs=\"column\" layout=\"row\" ng-if=\"vm.addOrEditCustomer\" class=\"mb-15n\"><div flex><md-input-container \nclass=\"md-block\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.CUSTOMER_NOTES.LABEL\">Notes</label><textarea \nng-model=\"vm.selectedCustomer.notes\" style=\"min-height: 50px !important\" md-maxlength=\"300\" md-select-on-focus>\n                                                    </textarea></md-input-container></div></div></div><div \nclass=\"order-info\" ng-if=\"vm.order && vm.order.address && vm.order.address.formattedAddress\"><label \nclass=\"order-info__label\" translate=\"TASKS.DIALOG.TABS.GENERAL.ORDER_ADDRESS\">Order address</label><i \nng-click=\"vm.selectedTabIndex=1;\" class=\"md-accent-fg icon icon-map-marker s15 clickable\"></i> <span \nclass=\"order-info__text\">{{ vm.order.address.formattedAddress }}</span></div><div layout-xs=\"column\" class=\"mt-20\" \nlayout=\"row\" ng-if=\"vm.hasDeadlineContractsPermission || vm.hasCorporateDeadlineContractPermission\"><div flex=\"100\">\n<md-input-container class=\"md-block select-employee\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DEADLINE_CONTRACT.LABEL\">Service Contract</label><md-select \nplaceholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.DEADLINE_CONTRACT.SELECT\' | translate }}\" name=\"deadline_contract\" \nng-disabled=\"vm.configurations.featureDisableEditDeadlineContract || vm.customerIsCorporate\" \nmd-on-close=\"vm.clearDeadlineContractSearchTerm();\" ng-model=\"vm.orderDeadlineContractId\"><md-select-header \nclass=\"header-services\"><input size=\"30\" ng-model=\"vm.deadlineContractSearchTerm\" class=\"input-services\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" autocomplete=\"off\" ng-change=\"vm.searchDeadlineContracts()\" ng-disabled=\"false\" \nplaceholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.DEADLINE_CONTRACT.SEARCH\' | translate }}\"></md-select-header>\n<md-option ng-disabled=\"vm.deadlineContracts.length === 0\" ng-if=\"vm.deadlineContracts.length === 0\">\n{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.DEADLINE_CONTRACT.NO_SLA_CONTRACT\' | translate }}</md-option><md-option \nng-repeat=\"deadlineContract in vm.deadlineContracts | orderBy: \'name\'\" value=\"{{deadlineContract.id}}\" \nng-selected=\"{{deadlineContract.id === vm.orderDeadlineContractId}}\"><span>{{deadlineContract.name}}</span></md-option>\n</md-select></md-input-container></div></div><div layout-xs=\"column\" layout=\"row\" class=\"mt-4n\"><div flex=\"100\"><div \nclass=\"flex-100 mb-10\" data-cy=\"dialog-order-description-textarea\" id=\"order-description-textarea\"><fc-smart-rewrite \nreference-id=\"vm.order.id || vm.sessionId\" reference-type=\"order-description\" class=\"flex-100\"><fc-textarea \nlabel=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.DESCRIPTION.LABEL\' | translate }}\" ng-model=\"vm.order.description\" \ndata-cy=\"tasks-description-textarea\" max-length=\"5000\" input-name=\"description\" name=\"description\" \ninput-control=\"orderForm.description\" \nerrors-to-watch=\"[\n                                                            {\n                                                                name: \'maxlength\',\n                                                                translate: \'TASKS.DIALOG.TABS.GENERAL.FIELDS.DESCRIPTION.ERRORS.MAX_LENGTH\',\n                                                                translateValues: { expectedLength: 5000, receivedLength: orderForm.description.$viewValue.length }\n                                                            }\n                                                        ]\">\n</fc-smart-rewrite></div></div></div></div></div><div class=\"sections\"><div class=\"section mt-10n\" \nng-repeat=\"task in vm.tasks track by $index\"><div><div ng-if=\"vm.tasks.length > 1\" class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-clipboard-text s18\"></i> <span flex class=\"section-title\"><span \nng-class=\"{ \'archived-task\': task.archived }\" translate=\"TASKS.DIALOG.TABS.GENERAL.VISIT.TITLE\" \ntranslate-value-index=\"{{ $index + 1 }}\">Visit #{{ $index + 1 }} </span></span><span ng-if=\"task.archived\" \nclass=\"status-label md-red-900-bg\" translate=\"TASKS.DIALOG.TABS.GENERAL.VISIT.ARCHIVED\">Archived</span><md-button \ndata-cy=\"archive-task-button\" class=\"sections__archived-button\" ng-disabled=\"!task.id || vm.order.locked\" \nng-click=\"vm.archiveTask(task);\" aria-label=\"Archive task\" translate translate ng-if=\"task.archived == false\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.ARCHIVE_TASK\"><md-icon md-font-icon=\"icon-archive\"></md-icon>\n</md-button><md-button class=\"sections__archived-button\" ng-disabled=\"!task.id || vm.order.locked\" \nng-click=\"vm.unarchiveTask(task);\" aria-label=\"Unarchive task\" translate ng-if=\"task.archived == true\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.UNARCHIVE_TASK\"><md-icon md-font-icon=\"icon-archive\"></md-icon>\n</md-button><md-button class=\"sections__archived-button\" ng-click=\"vm.deleteTask(task);\" aria-label=\"Unarchive task\" \ntranslate ng-if=\"!task.id\" ng-disabled=\"vm.order.locked\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.UNARCHIVE_TASK\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button><md-menu data-cy=\"tasks-visit-options-button\" ng-if=\"task.id && (task.status !== \'pending\')\"><md-button \nclass=\"md-icon-button pointer-events\" \nng-click=\"$mdMenu.open();vm.selectedCustomerEmailsPrintLink = [];vm.selectedCustomerEmailsRatingLink = [];vm.selectedCustomerEmailsTrackingLink = [];\">\n<md-icon class=\"icon-forward\" md-menu-origin md-font-icon=\"icon-reply\"></md-icon></md-button><md-menu-content \nclass=\"dialog-menu-customer-space\" ng-show=\"task.archived == false\"><div class=\"menu-content-title\" \nlayout-align=\"space-between center\" flex><span translate=\"TASKS.DIALOG.ACTIONS.VISIT_REPORT_LINK\" \nng-if=\"task.id && (task.status !== \'pending\')\">Visit report link</span></div><md-menu-item \nng-if=\"task.id && (task.status !== \'pending\')\" diabled><md-menu md-offset=\"0 0\" md-delay=\"500\" \nng-mouseenter=\"vm.clearArray()\"><md-button class=\"menu-item-inner\" ng-click=\"$mdMenu.open()\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon><span translate=\"TASKS.DIALOG.ACTIONS.SHARE_BY_EMAIL\">Share by e-mail</span>\n</md-button><md-menu-content class=\"options-menu-content\" width=\"4\" ms-scroll><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.LOCATION_EMAILS\">Location emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.allLocationsContacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_NO_HAVE_EMAILS\">This location does not have emails.</span><md-menu-item \nng-if=\"vm.order.customer.allLocationsContacts.emails\" class=\"option\" \nng-repeat=\"email in vm.order.customer.allLocationsContacts.emails\"><md-button \nng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" translate \nmd-prevent-menu-close><div layout=\"row\" ng-click=\"email.checked = !email.checked\" md-prevent-menu-close><div flex=\"10\" \nclass=\"option__icon\"><md-icon md-font-icon=\"icon-email\"></md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\">\n<p class=\"option__label\">{{ (email.name || \'Sem nome\') }}</p><p ng-if=\"email.primary == true\" \ntranslate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p class=\"option__sub-label\">\n{{ email.address }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" layout-align=\"end\"><md-checkbox \nclass=\"contact-checkbox-primary\" ng-model=\"email.checked\" ng-click=\"email.checked = !email.checked\" \nmd-prevent-menu-close></md-checkbox></div></div></md-button></md-menu-item><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_EMAILS\">Customer Emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.contacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_NO_HAVE_EMAILS\">This customer does not have emails.</span><md-menu-item \nng-if=\"vm.selectedCustomer.contacts.hasEmail\" class=\"option\" ng-repeat=\"email in vm.order.customer.contacts.emails\">\n<md-button ng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" \nmd-prevent-menu-close aria-label=\"toggle e-mail\" translate><div layout=\"row\" ng-click=\"email.checked = !email.checked\" \nmd-prevent-menu-close><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-email\"></md-icon></div><div \nlayout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">{{ (email.name || \'Sem nome\') }}</p><p \nng-if=\"email.primary == true\" translate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p \nclass=\"option__sub-label\">{{ email.address }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" \nlayout-align=\"end\"><md-checkbox class=\"contact-checkbox-primary\" ng-model=\"email.checked\" \nng-click=\"email.checked = !email.checked\" md-prevent-menu-close></md-checkbox></div></div></md-button></md-menu-item>\n<md-menu-item class=\"option\" flex layout-align=\"center\" ng-if=\"!vm.noHaveEmails\"><md-button \nng-disabled=\"vm.selectedCustomerEmails.length === 0 \" ng-click=\"vm.sendPrintLink(task, vm.selectedCustomerEmails);\" \nclass=\"option__send-link-button\"><md-icon class=\"md-accent\" md-font-icon=\"icon-telegram\"></md-icon><span \nclass=\"option__buttom-label\" ng-if=\"!vm.noHaveEmails\" translate=\"TASKS.DIALOG.ACTIONS.SEND_REPORT_LINK\">\nSend report link </span><span class=\"option__buttom-label-count\">{{\' (\' + vm.selectedCustomerEmails.length + \') \' }}\n</span> <span class=\"option__buttom-label\" ng-if=\"vm.noHaveEmails\" \ntranslate=\"TASKS.DIALOG.ACTIONS.WARNINGS.CUSTOMER_NOT_HAVE_EMAIL\">The customer does not have an email</span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item \nng-if=\"task.id && (task.status !== \'pending\')\"><md-menu md-offset=\"0 0\" md-delay=\"500\"><md-button \nclass=\"menu-item-inner\" ng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-whatsapp\"></md-icon><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SHARE_BY_WHATSAPP\">Share by WhatsApp</span></md-button><md-menu-content \nclass=\"options-menu-content\" width=\"4\" ms-scroll><strong class=\"options-menu-content__subtitle\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CONTACTS_BY_LOCATION\" ng-if=\"vm.selectedCustomer.contacts.phones\">Contacts by location \n</strong><span class=\"options-menu-content__no-content-text\" \nng-if=\"vm.order.customer.allLocationsContacts.phones.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_NO_HAVE_CONTACTS\">This location does not have contacts.</span><md-menu-item \nng-if=\"vm.selectedCustomer.contacts.phones\" class=\"option\" \nng-repeat=\"phone in vm.order.customer.allLocationsContacts.phones\"><md-button \nng-click=\"phone.number ? vm.sendEvaluationByWhatsApp(vm.order.id, \'new-os\', phone.number) : null\" translate \nmd-prevent-menu-close><div layout=\"row\"><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">\n{{ (phone.name || \'Sem nome\') | limitTo: 20 }}</p><p ng-if=\"phone.primary == true\" \ntranslate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p class=\"option__sub-label\">\n{{ vm.formatPhoneOrCellphone(phone.number) }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" \nlayout-align=\"end\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div></md-button></md-menu-item><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_CONTACTS\" \nng-if=\"vm.selectedCustomer.contacts.phones\">Customer contacts </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.selectedCustomer.contacts.phones.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_NO_HAVE_CONTACTS\">This customer does not have contacts.</span><md-menu-item \nng-if=\"vm.selectedCustomer.contacts.phones\" class=\"option\" ng-repeat=\"phone in vm.selectedCustomer.contacts.phones\">\n<md-button ng-click=\"phone.number ? vm.sendEvaluationByWhatsApp(vm.order.id, \'new-os\', phone.number) : null\" translate \nmd-prevent-menu-close><div layout=\"row\"><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">\n{{ (phone.name || \'Sem nome\') | limitTo: 20 }}</p><p ng-if=\"phone.primary == true\" \ntranslate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p class=\"option__sub-label\">\n{{ vm.formatPhoneOrCellphone(phone.number) }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" \nlayout-align=\"end\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div></md-button></md-menu-item>\n<md-menu-item flex layout-align=\"center\" class=\"option\" \nng-if=\"vm.selectedCustomer.contacts.phones && vm.order.customer.allLocationsContacts.phones\"><md-button \nng-click=\"vm.sendEvaluationByWhatsApp(vm.order.id, \'new-os\')\" class=\"option__send-whats-button\"><md-icon \nmd-font-icon=\"icon-whatsapp\"></md-icon><span class=\"option__buttom-label\" \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_TO_ANOTHER_CONTACT\">Send to another contact</span></md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-item ng-if=\"task.id && (task.status !== \'pending\')\"><md-button \nngclipboard data-clipboard-text=\"{{vm.link.newOrderPrintLink + vm.order.id + \'/atividade/\' + task.id}}\" \nngclipboard-success=\"vm.showToastWhileCopyLink(vm.order.identifier, \'report\')\" class=\"add-label-button\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon><span class=\"option-label fs13 default-option-color\" \ntranslate=\"TASKS.DIALOG.ACTIONS.COPY_VISIT_REPORT_LINK\">Copy report link</span></md-button></md-menu-item><md-menu-item\n ng-if=\"task.id && (task.status !== \'pending\')\"><md-button class=\"add-label-button\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.OPEN_REPORT\" ng-attr-target=\"_blank\" \nng-href=\"{{vm.link.newOrderPrintLink + vm.order.id + \'/atividade/\' + task.id}}\"><md-icon md-font-icon=\"icon-eye\">\n</md-icon><p class=\"option-label fs13 default-option-color\" translate=\"TASKS.DIALOG.ACTIONS.OPEN_REPORT\">Open report\n</p></md-button></md-menu-item><md-menu-divider ng-if=\"task.id && task.employee.id && task.status === \'scheduled\'\">\n</md-menu-divider><md-menu-item ng-if=\"task.id && task.employee.id && task.status === \'scheduled\'\"><md-menu \nmd-offset=\"0 0\" md-delay=\"500\"><md-button class=\"menu-item-inner\" ng-click=\"$mdMenu.open()\"><md-icon \nmd-font-icon=\"icon-map\"></md-icon><span translate=\"TASKS.DIALOG.ACTIONS.SEND_EMPLOYEE_LOCATION_LINK\">\nSend employee location link</span></md-button><md-menu-content class=\"options-menu-content\" width=\"4\" ms-scroll><strong\n class=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_EMAILS\">Customer Emails </strong><span\n class=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.contacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_NO_HAVE_EMAILS\">This customer does not have emails.</span><md-menu-item \nng-if=\"vm.selectedCustomer.contacts.hasEmail\" class=\"option\" ng-repeat=\"email in vm.order.customer.contacts.emails\">\n<md-button ng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmailsTrackingLink, true) : null\" \nmd-prevent-menu-close aria-label=\"toggle e-mail\" translate><div layout=\"row\" layout-align=\"space-between center\" flex>\n<div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\"></md-icon><p class=\"option-label\">\n{{ email.address }}</p></div><i class=\"icon-check s16\" \nng-if=\"vm.exists(email.id, vm.selectedCustomerEmailsTrackingLink)\"></i></div></md-button></md-menu-item><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.LOCATION_EMAILS\">Location emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.allLocationsContacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_NO_HAVE_EMAILS\">This location does not have emails.</span><md-menu-item \nclass=\"option\" ng-if=\"vm.selectedCustomer.allLocationsContacts.emails.length != 0\" \nng-repeat=\"email in vm.order.customer.allLocationsContacts.emails\"><md-button \nng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" md-prevent-menu-close \naria-label=\"toggle e-mail\" translate><div layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-email\"></md-icon><p class=\"option-label option-label-fs-13\">\n{{ email.address }}</p></div><i class=\"icon-check s16\" ng-if=\"vm.exists(email.id, vm.selectedCustomerEmails)\"></i>\n</div></md-button></md-menu-item><md-menu-divider ng-if=\"!vm.noHaveEmails\"></md-menu-divider><md-menu-item \nclass=\"option\"><md-button ng-disabled=\"vm.selectedCustomerEmailsTrackingLink.length === 0\" \nng-click=\"vm.shareTaskLocation(task, vm.selectedCustomerEmailsTrackingLink);\" class=\"add-label-button\"><md-icon \nclass=\"md-accent\" md-font-icon=\"icon-telegram\"></md-icon><p ng-if=\"!vm.noHaveEmails\" class=\"option-label\" \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_EMPLOYEE_LOCATION_LINK\">Send employee location link</p><p ng-if=\"vm.noHaveEmails\" \nclass=\"option-label\" translate=\"TASKS.DIALOG.ACTIONS.WARNINGS.CUSTOMER_NOT_HAVE_EMAIL\">\nThe customer does not have an email</p></md-button></md-menu-item></md-menu-content></md-menu></md-menu-item>\n<md-menu-divider ng-if=\"task.id && (task.status == \'done\')\"></md-menu-divider><div class=\"menu-content-title\" \nlayout-align=\"space-between center\" flex ng-if=\"task.id && (task.status == \'done\')\"><span \ntranslate=\"TASKS.DIALOG.ACTIONS.VISIT_REVIEW_LINK\">Visit review link</span></div><md-menu-item \nng-if=\"task.id && (task.status == \'done\')\"><md-menu md-offset=\"0 0\" md-delay=\"500\" ng-mouseenter=\"vm.clearArray()\">\n<md-button class=\"menu-item-inner\" ng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-email\"></md-icon><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SHARE_BY_EMAIL\">Share by e-mail</span></md-button><md-menu-content \nclass=\"options-menu-content\" width=\"4\" ms-scroll><strong class=\"options-menu-content__subtitle\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_EMAILS\">Location emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.allLocationsContacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_NO_HAVE_EMAILS\">This location does not have emails.</span><md-menu-item \nng-if=\"vm.order.customer.allLocationsContacts.emails\" class=\"option\" \nng-repeat=\"email in vm.order.customer.allLocationsContacts.emails\"><md-button \nng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" translate \nmd-prevent-menu-close><div layout=\"row\" ng-click=\"email.checked = !email.checked\" md-prevent-menu-close><div flex=\"10\" \nclass=\"option__icon\"><md-icon md-font-icon=\"icon-email\"></md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\">\n<p class=\"option__label\">{{ (email.name || \'Sem nome\') }}</p><p ng-if=\"email.primary == true\" \ntranslate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p class=\"option__sub-label\">\n{{ email.address }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" layout-align=\"end\"><md-checkbox \nclass=\"contact-checkbox-primary\" ng-model=\"email.checked\" ng-click=\"email.checked = !email.checked\" \nmd-prevent-menu-close></md-checkbox></div></div></md-button></md-menu-item><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_EMAILS\">Customer Emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.contacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_NO_HAVE_EMAILS\">This customer does not have emails.</span><md-menu-item \nng-if=\"vm.selectedCustomer.contacts.hasEmail\" class=\"option\" ng-repeat=\"email in vm.order.customer.contacts.emails\">\n<md-button ng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" \nmd-prevent-menu-close aria-label=\"toggle e-mail\" translate><div layout=\"row\" ng-click=\"email.checked = !email.checked\" \nmd-prevent-menu-close><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-email\"></md-icon></div><div \nlayout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">{{ (email.name || \'Sem nome\') }}</p><p \nng-if=\"email.primary == true\" translate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p \nclass=\"option__sub-label\">{{ email.address }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" \nlayout-align=\"end\"><md-checkbox class=\"contact-checkbox-primary\" ng-model=\"email.checked\" \nng-click=\"email.checked = !email.checked\" md-prevent-menu-close></md-checkbox></div></div></md-button></md-menu-item>\n<md-menu-item class=\"option\" flex layout-align=\"center\" ng-if=\"!vm.noHaveEmails\"><md-button \nng-disabled=\"vm.selectedCustomerEmails.length === 0 \" ng-click=\"vm.sendRatingEmail(task, vm.selectedCustomerEmails);\" \nclass=\"option__send-link-button\"><md-icon class=\"md-accent\" md-font-icon=\"icon-telegram\"></md-icon><span \nclass=\"option__buttom-label\" ng-if=\"!vm.noHaveEmails\" translate=\"TASKS.DIALOG.ACTIONS.SEND_REPORT_LINK\">\nSend report link </span><span class=\"option__buttom-label-count\">{{\' (\' + vm.selectedCustomerEmails.length + \') \' }}\n</span> <span class=\"option__buttom-label\" ng-if=\"vm.noHaveEmails\" \ntranslate=\"TASKS.DIALOG.ACTIONS.WARNINGS.CUSTOMER_NOT_HAVE_EMAIL\">The customer does not have an email</span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item \nng-if=\"task.id && (task.status == \'done\')\"><md-menu md-offset=\"0 0\" md-delay=\"500\"><md-button class=\"menu-item-inner\" \nng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-whatsapp\"></md-icon><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SHARE_BY_WHATSAPP\">Share by WhatsApp</span></md-button><md-menu-content \nclass=\"options-menu-content\" width=\"4\" ms-scroll><strong class=\"options-menu-content__subtitle\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CONTACTS_BY_LOCATION\">Contacts by location </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.allLocationsContacts.phones.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_NO_HAVE_CONTACTS\">This location does not have contacts.</span><md-menu-item \nng-if=\"vm.order.customer.allLocationsContacts.phones\" class=\"option\" \nng-repeat=\"phone in vm.order.customer.allLocationsContacts.phones\"><md-button \nng-click=\"phone.number ? vm.sendEvaluationByWhatsApp(vm.order.id, \'new-os\', phone.number) : null\" translate \nmd-prevent-menu-close><div layout=\"row\"><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">\n{{ (phone.name || \'Sem nome\') | limitTo: 20 }}</p><p ng-if=\"phone.primary == true\" \ntranslate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p class=\"option__sub-label\">\n{{ vm.formatPhoneOrCellphone(phone.number) }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" \nlayout-align=\"end\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div></md-button></md-menu-item><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_CONTACTS\">Customer contacts </strong>\n<span class=\"options-menu-content__no-content-text\" ng-if=\"vm.selectedCustomer.contacts.phones.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_NO_HAVE_CONTACTS\">This customer does not have contacts.</span><md-menu-item \nng-if=\"vm.selectedCustomer.contacts.phones\" class=\"option\" ng-repeat=\"phone in vm.selectedCustomer.contacts.phones\">\n<md-button ng-click=\"phone.number ? vm.sendEvaluationByWhatsApp(vm.order.id, \'new-os\', phone.number) : null\" translate \nmd-prevent-menu-close><div layout=\"row\"><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">\n{{ (phone.name || \'Sem nome\') | limitTo: 20 }}</p><p ng-if=\"phone.primary == true\" \ntranslate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p class=\"option__sub-label\">\n{{ vm.formatPhoneOrCellphone(phone.number) }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" \nlayout-align=\"end\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div></md-button></md-menu-item>\n<md-menu-item flex layout-align=\"center\" class=\"option\" \nng-if=\"vm.selectedCustomer.contacts.phones && vm.order.customer.allLocationsContacts.phones\"><md-button \nng-click=\"vm.sendEvaluationByWhatsApp(vm.order.id, \'new-os\')\" class=\"option__send-whats-button\"><md-icon \nmd-font-icon=\"icon-whatsapp\"></md-icon><span class=\"option__buttom-label\" \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_TO_ANOTHER_CONTACT\">Send to another contact</span></md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-item ng-if=\"task.id && (task.status == \'done\')\"><md-button \nngclipboard data-clipboard-text=\"{{vm.link.taskRatingLink + task.id}}\" \nngclipboard-success=\"vm.showToastWhileCopyLink(task.order.identifier, \'rating\')\" class=\"add-label-button\" \nng-disabled=\"!task._currentEmployeeId\" data-cy=\"tasks-copy-evaluation-link\" \nng-attr-title=\"{{ task._currentEmployeeId ? \'\' : \'TASKS.DIALOG.ACTIONS.WARNINGS.RATE_TASK_WITHOUT_EMPLOYEE\' | translate }}\">\n<md-icon md-font-icon=\"icon-content-copy\"></md-icon><p class=\"option-label fs13\" \ntranslate=\"TASKS.DIALOG.ACTIONS.COPY_LINK\">Copy link</p></md-button></md-menu-item><md-menu-item \nng-if=\"task.id && (task.status == \'done\')\"><md-button class=\"add-label-button\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.OPEN_REPORT\" ng-disabled=\"!task._currentEmployeeId\" \ndata-cy=\"tasks-open-evaluation-link\" ng-attr-target=\"_blank\" ng-href=\"{{vm.link.taskRatingLink + task.id}}\" \nng-attr-title=\"{{ task._currentEmployeeId ? \'\' : \'TASKS.DIALOG.ACTIONS.WARNINGS.RATE_TASK_WITHOUT_EMPLOYEE\' | translate }}\">\n<md-icon md-font-icon=\"icon-eye\"></md-icon><p class=\"option-label fs13 black-text\" \ntranslate=\"TASKS.DIALOG.ACTIONS.OPEN_REPORT\">Open report</p></md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"section-content\"><div layout-xs=\"column\" class=\"mt-17n section-content__content\" layout=\"row\"><div \nflex=\"33\"><md-input-container id=\"duration-input\" class=\"md-block\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DURATION.LABEL\">Duration</label><input \nng-class=\"{ \'archived-task\': task.archived }\" type=\"number\" name=\"duration_{{$index}}\" ng-model=\"task.duration\" \nng-pattern=\"/^[0-9]/\" min=\"1\" max=\"999\" required data-cy=\"task-duration-input\"><div \nng-messages=\"orderForm[\'duration_\' + $index].$error\" ng-if=\"orderForm[\'duration_\' + $index].$touched\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DURATION.ERRORS.REQUIRED\">\nDuration field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DURATION.ERRORS.PATTERN\">Should be a number</span></div><div \nng-message=\"min\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DURATION.ERRORS.MIM\">Minimum duration 1 minute\n</span></div><div ng-message=\"max\"><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.DURATION.ERRORS.MAX\">\nMaximum duration 999 minutes</span></div></div></md-input-container></div><div class=\"datepicker-container\" flex=\"33\">\n<md-input-container class=\"md-block datepicker-container__md-input-container\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SCHEDULED_DATE.LABEL\">Visit date</label><md-datepicker \nng-required=\"vm.isTaskScheduledDateRequired(task, $index)\" data-cy=\"tasks-visit-date-input\" class=\"icon-hide\" \nname=\"scheduling_date_{{$index}}\" ng-model=\"task.scheduling.date\" \nng-disabled=\"task.status === \'pending\' || task.disableScheduleSuggestionDateInput\" md-min-date=\"task.minDate\" \nng-change=\"vm.clearTaskTimesIfConfigured(task); vm.validateDateAndTime(task, $index); vm.employeesCheckAbsent(task)\">\n</md-datepicker><md-icon class=\"icon-info datepicker-container__md-input-container__icon\" \nng-if=\"task.disableScheduleSuggestionDateInput\" md-svg-src=\"assets/icons/icon-info.svg\"><md-tooltip \nmd-direction=\"bottom\"><span translate=\"TASKS.DIALOG.TABS.FORMS.LOCK_DATE_AND_TIME_CHANGE\">\nIt is not allowed to change the date/time of an accepted appointment suggestion.</span></md-tooltip></md-icon><div \nlayout=\"row\" ng-messages=\"orderForm[\'scheduling_date_\' + $index].$error\" role=\"alert\" class=\"fs-15\"><div \nng-message=\"mindate\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SCHEDULED_DATE.ERRORS.MIN\">Scheduled date is too old\n</div><div ng-message=\"valid\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SCHEDULED_DATE.ERRORS.INVALID\">\nScheduled date is invalid</div><div ng-message=\"required\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SCHEDULED_DATE.ERRORS.REQUIRED\">Scheduled date field is required</div><div \nng-message=\"mustBeNull\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SCHEDULED_DATE.ERRORS.MUST_BE_NULL\">\nThere cannot be an scheduling date</div></div></md-input-container></div><div class=\"time-input-container\" flex=\"33\">\n<md-input-container class=\"md-block time-input-container__md-input-container\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.TIMEABLE_VISIT.LABEL\">Timeable Visit</label><input \ndata-cy=\"timeable-visit-input\" ng-class=\"{ \'archived-task\': task.archived }\" \nng-change=\"vm.validateDateAndTime(task, $index);\" type=\"text\" ng-model=\"task.scheduling.time\" ui-time-mask=\"short\" \nname=\"timeableVisit_{{$index}}\" ng-disabled=\"task.status === \'pending\' || task.disableScheduleSuggestionTimeInput\" \nclass=\"hour-input\"><md-icon class=\"icon-info time-input-container__md-input-container__icon\" \nng-if=\"task.disableScheduleSuggestionTimeInput\" md-svg-src=\"assets/icons/icon-info.svg\"><md-tooltip \nmd-direction=\"bottom\"><span translate=\"TASKS.DIALOG.TABS.FORMS.LOCK_DATE_AND_TIME_CHANGE\">\nIt is not allowed to change the date/time of an accepted appointment suggestion.</span></md-tooltip></md-icon><div \nng-messages=\"orderForm[\'timeableVisit_\'+$index].$error\" ng-show=\"orderForm[\'timeableVisit_\'+$index].$error\" \nrole=\"alert\"><div ng-message=\"time\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.TIMEABLE_VISIT.ERRORS.INVALID\">\nInvalid time</div><div ng-message=\"isGreaterThan12Hours\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.TIMEABLE_VISIT.ERRORS.GREATER_12_HOURS\">Greater than 12 hours</div><div \nng-message=\"isMinorThan1Hour\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.TIMEABLE_VISIT.ERRORS.MINOR_1_HOUR\">\nMinor than 1 hour</div></div></md-input-container></div><div flex=\"60\" ng-if=\"vm.timeFormatIsActive\">\n<md-input-container class=\"md-block\"><label>AM/PM</label><md-select ng-required=\"!!task.scheduling.time\" \nng-disabled=\"task.status === \'pending\' || task.disableScheduleSuggestionTimeInput\" \nng-class=\"{ \'archived-task\': task.archived }\" ng-model=\"task.scheduledTimeFormat\" \nname=\"scheduledTimeFormat_{{$index}}\" \nng-change=\"vm.updateScheduledTimeFormat(vm.scheduledTimeFormat); vm.validateDateAndTime(task, $index)\"><md-option \nvalue=\"am\">AM</md-option><md-option value=\"pm\">PM</md-option></md-select><div \nng-messages=\"orderForm[\'scheduledTimeFormat_\'+$index].$error\" \nng-show=\"orderForm[\'scheduledTimeFormat_\'+$index].$error\" role=\"alert\"><div ng-message=\"required\">\n{{ \"TASKS.DIALOG.TABS.GENERAL.FIELDS.SCHEDULED_TIME_FORMAT.ERRORS.REQUIRED\" | translate }}</div></div>\n</md-input-container></div></div><div layout-xs=\"column\" class=\"mt-17n mb-25 section-content__content\" layout=\"row\">\n<div flex=\"50\" ng-if=\"true\" class=\"employee-container\"><md-input-container data-cy=\"select-employee-input\" \nclass=\"md-block select-employee\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.LABEL\" \nng-class=\"{ \'employee-asterisk\': vm.order.ticket.metadata.featureAssignedEmployeeRequired,\n                                                                                \'employee-label-error\': vm.order.ticket.metadata.featureAssignedEmployeeRequired && orderForm.employeeId_{{$index}}.$touched\n                                                                                && vm.hasRequiredEmployeeError\n                                                                                }\">\nEmployee</label><md-select placeholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.SELECT\' | translate }}\" \nname=\"employeeId_{{$index}}\" ng-change=\"vm.onSelectedEmployee(task, $index);\" \nmd-on-close=\"vm.clearEmployeeSearchTerm();  vm.setEmployeesOptions(); vm.isEmployeeDropdownOpen = false\" \nng-model=\"task.employee.id\" ng-click=\"vm.isEmployeeDropdownOpen = true\"><md-select-header class=\"header-services\">\n<input size=\"30\" ng-model=\"vm.employeeSearchTerm\" class=\"input-services\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" \nmd-on-close=\"vm.clearEmployeeSearchTerm();  vm.setEmployeesOptions(); vm.isEmployeeDropdownOpen = false\" \nng-change=\"vm.setEmployeesOptions()\" autocomplete=\"off\" \nplaceholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.SEARCH\' | translate }}\"></md-select-header><md-option \nvalue=\"null\"><span \nng-class=\"{ \'archived-task\': task.archived,\n                                                                                          \'display-as-error\': vm.order.ticket.metadata.featureAssignedEmployeeRequired\n                                                                                          && orderForm.employeeId_{{$index}}.$touched\n                                                                                          && vm.hasRequiredEmployeeError && !vm.isEmployeeDropdownOpen}\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.NO_EMPLOYEE\">No employee</span></md-option><md-option \nclass=\"employee-select-options\" \nng-repeat=\"employee in vm.employeesOptions | orderBy: [\'priority\', \'kmDistance\', \'name\']\" value=\"{{ employee.id }}\" \nng-class=\"{ \'inactive-archived-item\': !employee.contract.active }\"><md-icon ng-if=\"employee.isOnline === null\" \nmd-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon><md-icon ng-if=\"employee.isOnline === false\" \nmd-font-icon=\"icon-map-marker\" class=\"red-fg s16\"></md-icon><md-icon ng-if=\"employee.isOnline\" \nmd-font-icon=\"icon-map-marker\" class=\"green-fg s16\"></md-icon><span data-cy=\"employee\" \nng-class=\"{ \'archived-task\': task.archived, \'inactive\': !employee.contract.active }\" \nng-if=\"employee.contract.active && !vm.employeeIsAbsent(task, employee)\">{{ employee.name }} </span><span \nng-class=\"{ \'archived-task\': task.archived, \'inactive\': !employee.contract.active }\" \nng-if=\"!employee.contract.active || vm.employeeIsAbsent(task, employee)\">\n{{ employee.name | maxLength: vm.isEmployeeDropdownOpen ? 58 : 12}} </span><span class=\"fs-11\" \nng-if=\"employee.isOnline && employee.kmDistance && vm.isTaskScheduledToday(task);\"><span \nng-if=\"employee.kmDistance < 1\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.LESS_THAN_1KM\" \ntranslate-values=\"{ distance: employee.kmDistance.toFixed(3).slice(2) }\">\n- {{ employee.kmDistance.toString().slice(2) }}m away </span><span ng-if=\"employee.kmDistance >= 1\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.GREATER_THAN_EQUAL_1KM\" \ntranslate-values=\"{ distance: employee.kmDistance.toFixed() }\">- {{ employee.kmDistance.toFixed() }}km away </span>\n</span><span class=\"caption\" ng-if=\"!employee.contract.active\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.INACTIVE\">Inactive </span><span class=\"caption\" \nng-if=\"vm.employeeIsAbsent(task, employee)\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ABSENT\">Absent</span>\n</md-option></md-select><span \nng-show=\"vm.order.ticket.metadata.featureAssignedEmployeeRequired\n                                                                                && orderForm.employeeId_{{$index}}.$touched\n                                                                                && vm.hasRequiredEmployeeError\" \nclass=\"required-forms-error\" role=\"alert\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ERRORS.REQUIRED\">\nEmployee is required.</span><div ng-show=\"vm.formErr[\'notSkilledEmployee_\' + $index]\"><div data-cy=\"emplyee-error\" \nclass=\"red-text fs-15\"><small ng-bind-html=\"vm.formErr[\'notSkilledEmployee_\' + $index]\"></small></div><div \nclass=\"fs-15\"><small><span translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ADD_TASK.MESSAGE\" \ntranslate-values=\"{ description: vm.order.service.description }\">\nAdd {{ vm.order.service.description }} as the OS type performed?</span><md-button type=\"button\" \nclass=\"fc-button fc-button--actions\" ng-click=\"vm.addEmployeeSkill(task, $index, vm.order.service)\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ADD_TASK.CONFIRM\">Yes</md-button></small></div></div>\n</md-input-container></div><div flex=\"50\" class=\"employee-container\"><md-input-container \ndata-cy=\"select-employee-input\" class=\"md-block select-employee\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SECONDARY_EMPLOYEES.LABEL\" \nng-class=\"{ \'employee-asterisk\': vm.order.ticket.metadata.featureAssignedEmployeeRequired,\n                                                                                \'employee-label-error\': vm.order.ticket.metadata.featureAssignedEmployeeRequired && orderForm.employeeId_{{$index}}.$touched\n                                                                                && vm.hasRequiredEmployeeError\n                                                                                }\">\nSecondary Employees</label><md-select ng-disabled=\"!task.employee || !task.employee.id || task.employee.id === \'null\'\" \nmultiple=\"multiple\" placeholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.SECONDARY_EMPLOYEES.SELECT\' | translate }}\" \nname=\"employeeId_{{$index}}\" ng-change=\"vm.onSelectedSecondaryEmployees(task, $index);\" \nmd-on-close=\"vm.clearEmployeeSearchTerm();  vm.setEmployeesOptions(); vm.isEmployeeDropdownOpen = false\" \nng-model=\"task.secondaryEmployees\" ng-click=\"vm.isSecondaryEmployeesDropdownOpen = true\"><md-select-header \nclass=\"header-services\"><input size=\"20\" ng-model=\"vm.employeeSearchTerm\" class=\"input-services\" type=\"search\" \nonkeydown=\"event.stopPropagation()\" autocomplete=\"off\" ng-change=\"vm.setEmployeesOptions()\" \nplaceholder=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.SECONDARY_EMPLOYEES.SEARCH\' | translate }}\"></md-select-header>\n<md-option ng-style=\"{ \'positon\': vm.isEmployeeDropdownOpen }\" \nng-disabled=\"employee.id == task.employee.id || vm.secondaryEmployeesMaxLengthValidator(task, employee.id)\" \nclass=\"employee-select-options\" \nng-repeat=\"employee in vm.employeesOptions | orderBy: [\'priority\', \'kmDistance\', \'name\']\" value=\"{{ employee.id }}\" \nng-class=\"{ \'inactive-archived-item\': !employee.contract.active }\"><md-icon ng-if=\"employee.isOnline === null\" \nmd-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon><md-icon ng-if=\"employee.isOnline === false\" \nmd-font-icon=\"icon-map-marker\" class=\"red-fg s16\"></md-icon><md-icon ng-if=\"employee.isOnline\" \nmd-font-icon=\"icon-map-marker\" class=\"green-fg s16\"></md-icon><span data-cy=\"employee\" \nng-class=\"{ \'archived-task\': task.archived, \'inactive\': !employee.contract.active }\" \nng-if=\"employee.contract.active && !vm.employeeIsAbsent(task, employee)\">{{ employee.name }} </span><span \nng-class=\"{ \'archived-task\': task.archived, \'inactive\': !employee.contract.active }\" \nng-if=\"!employee.contract.active || vm.employeeIsAbsent(task, employee)\">\n{{ employee.name | maxLength: vm.isEmployeeDropdownOpen ? 58 : 12}} </span><span class=\"fs-11\" \nng-if=\"employee.isOnline && employee.kmDistance && vm.isTaskScheduledToday(task);\"><span \nng-if=\"employee.kmDistance < 1\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.LESS_THAN_1KM\" \ntranslate-values=\"{ distance: employee.kmDistance.toFixed(3).slice(2) }\">\n- {{ employee.kmDistance.toString().slice(2) }}m away </span><span ng-if=\"employee.kmDistance >= 1\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.GREATER_THAN_EQUAL_1KM\" \ntranslate-values=\"{ distance: employee.kmDistance.toFixed() }\">- {{ employee.kmDistance.toFixed() }}km away </span>\n</span><span class=\"caption\" ng-style=\"!vm.isSecondaryEmployeesDropdownOpen ? {\'position\': \'relative\'} : {}\" \nng-if=\"!employee.contract.active\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.INACTIVE\">Inactive </span><span \nclass=\"caption\" ng-style=\"!vm.isSecondaryEmployeesDropdownOpen ? {\'position\': \'relative\'} : {}\" \nng-if=\"vm.employeeIsAbsent(task, employee)\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ABSENT\">Absent</span>\n</md-option></md-select><span ng-show=\"vm.formErr[\'secondaryEmployeesLimit_\' + $index]\" class=\"required-forms-error\" \nrole=\"alert\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SECONDARY_EMPLOYEES.ERRORS.SECONDARY_EMPLOYEES_LIMIT\">\nSecondary employees max length</span><div ng-show=\"vm.formErr[\'notSkilledSecondaryEmployees_\' + $index]\"><div \ndata-cy=\"emplyee-error\" class=\"red-text fs-15\"><small \nng-bind-html=\"vm.formErr[\'notSkilledSecondaryEmployees_\' + $index]\"></small></div><div class=\"fs-15\"><small><span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ADD_TASK.MESSAGE\" \ntranslate-values=\"{ description: vm.order.service.description }\">\nAdd {{ vm.order.service.description }} as the OS type performed?</span><md-button type=\"button\" \nclass=\"fc-button fc-button--actions\" ng-click=\"vm.addSecondayEmployeeSkill(task, $index, vm.order.service)\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ADD_TASK.CONFIRM\">Yes</md-button></small></div></div>\n</md-input-container></div></div><div layout=\"row\" class=\"mt-17n mb-25\"><fc-smart-rewrite \nreference-id=\"task.id || task.sessionId\" reference-type=\"task-description\" class=\"flex-100\"><fc-textarea \nng-model=\"task.description\" data-cy=\"task-description-textarea\" \nlabel=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.TASK_DESCRIPTION.LABEL\' | translate }}\" max-length=\"5000\" \ninput-name=\"task_description\" input-control=\"orderForm.task_description\" name=\"observation_{{$index}}\" \nerrors-to-watch=\"[\n                                                            {\n                                                                name: \'maxlength\',\n                                                                translate: \'TASKS.DIALOG.TABS.GENERAL.FIELDS.TASK_DESCRIPTION.ERRORS.MAX_LENGTH\',\n                                                                translateValues: { expectedLength: 5000, receivedLength: orderForm.task_description.$viewValue.length }\n                                                            }\n                                                        ]\">\n</fc-smart-rewrite></div><div layout-xs=\"column\" layout=\"row\" class=\"mt-17n\" ng-if=\"task.id\"><div flex=\"25\">\n<md-input-container class=\"md-block\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.SITUATION.LABEL\">Situation\n</label><md-select name=\"situation_{{$index}}\" \nng-disabled=\"vm.featureDisableEditTaskStatus && vm.featureDisableCancelTaskStatus\" ng-model=\"task.status\" \ndata-cy=\"task-status-select\" ng-class=\"vm.requiredFormsErr[\'requiredForm\'+$index] ? \'red-border-bottom\': \'\'\" \nng-change=\"vm.changedTaskStatus(task, $index);\"><md-option data-cy=\"task-status-option-{{ status.name }}\" \nng-if=\"\n                                                                    !vm.featureDisableEditTaskStatus ||\n                                                                    (status.name === task.oldStatus) ||\n                                                                    (!vm.featureDisableCancelTaskStatus && status.name === \'canceled\')\n                                                                \" \nng-repeat=\"status in vm.taskStatus\" value=\"{{status.name}}\" \nng-hide=\"status.name === \'on-route\' ||\n                                                                    (!vm.isPendingTasksEnabled() && status.name === \'pending\') ||\n                                                                    (task.disableScheduleSuggestionDateInput && status.name === \'pending\')\">\n<md-icon md-font-icon=\"{{status.icon}}\" class=\"s16\" ng-class=\"status.name + \'-fg\'\"></md-icon><span \ndata-cy=\"status-task\" ng-class=\"{ \'archived-task\': task.archived }\" class=\"{{status.name}}-fg\">{{ status.description}}\n</span></md-option></md-select></md-input-container><div ng-if=\"task.statusErrors\" class=\"required-forms-error\"><span \nng-repeat=\"error in task.statusErrors\" class=\"remove-margin\"><span \nng-if=\"error === \'employeeIsInMoreThanOneTaskAtTheSameTime\'\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.EMPLOYEE.ERRORS.ALREADY_IN_ACTIVITY\">\nThis employee is in more than one task at the same time</span></span></div><div \nng-if=\"vm.requiredFormsErr[\'requiredForm\'+$index]\" class=\"required-forms-error\"><span \nng-repeat=\"error in vm.requiredFormsErr[\'requiredForm\'+$index]\" class=\"remove-margin\">\n{{ error.description }}&nbsp;&nbsp;</span></div></div><div class=\"datepicker-container\" flex=\"20\"><md-input-container \nclass=\"md-block\"><label translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.LABEL_DATE\">Started at date</label>\n<md-datepicker data-cy=\"tasks-started-at-date-input\" class=\"icon-hide\" \nng-required=\"vm.taskStartedAtIsRequired(task, $index);\" ng-disabled=\"vm.disableEditTaskStartedAt(task, $index)\" \nng-class=\"{ \'archived-task\': task.archived }\" ng-model=\"task.startedAtDate\" name=\"startedAtDate_{{$index}}\" \nng-change=\"vm.validateDateAndTime(task, $index);\"></md-datepicker><div layout=\"row\" \nng-messages=\"orderForm[\'startedAtDate_\' + $index].$error\" role=\"alert\" class=\"fs-15\"><div ng-message=\"required\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.ERRORS.REQUIRED_DATE\">Started at field is required</div><div \nng-message=\"valid\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.ERRORS.INVALID_DATE\">\nScheduled date is invalid</div><div ng-message=\"startedAtIsLessThanCreatedAt\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.ERRORS.LESS_THAN\">Date is less than the created at</div><div \nng-message=\"startedAtIsGreaterThanPresent\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.ERRORS.TIME_IN_FUTURE\">Time cannot be greater than current time\n</div><div ng-message=\"isStartedAtDateMissing\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.ERRORS.DATE_MUST_HAVE_TIME\">Time must have date</div></div>\n</md-input-container></div><div flex=\"20\"><md-input-container class=\"md-block\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.LABEL_TIME\">Started at time</label><input \nng-disabled=\"vm.disableEditTaskStartedAt(task, $index)\" data-cy=\"tasks-started-at-time-input\" \nng-required=\"vm.taskStartedAtIsRequired(task, $index);\" class=\"hour-input\" \nng-class=\"{ \'archived-task\': task.archived }\" ng-model=\"task.startedAtTime\" name=\"startedAtTime_{{$index}}\" \nui-time-mask=\"short\" ng-change=\"vm.validateDateAndTime(task, $index);\"><div layout=\"row\" \nng-messages=\"orderForm[\'startedAtTime_\' + $index].$error\" role=\"alert\" class=\"fs-15\"><div ng-message=\"required\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.ERRORS.REQUIRED_TIME\">Started at field is required</div><div \nng-message=\"time\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.ERRORS.INVALID_TIME\">Invalid time</div><div \nng-message=\"isStartedAtTimeMissing\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.ERRORS.TIME_MUST_HAVE_DATE\">\nDate must have time</div><div ng-message=\"isGreaterThan12Hours\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.ERRORS.GREATER_12_HOURS\">Greater than 12 hours</div><div \nng-message=\"isMinorThan1Hour\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.STARTED_AT.ERRORS.MINOR_1_HOUR\">\nMinor than 1 hour</div></div></md-input-container></div><div flex=\"60\" ng-if=\"vm.timeFormatIsActive\">\n<md-input-container class=\"md-block\"><label>AM/PM</label><md-select \nng-disabled=\"vm.disableEditTaskStartedAt(task, $index)\" ng-required=\"!!task.startedAtTime\" \nng-class=\"{ \'archived-task\': task.archived }\" ng-model=\"task.startedAtTimeFormat\" \nname=\"startedAtTimeFormat_{{$index}}\" \nng-change=\"vm.updateStartedTimeFormat(task.startedAtTimeFormat, task); vm.validateDateAndTime(task, $index)\"><md-option\n value=\"am\">AM</md-option><md-option value=\"pm\">PM</md-option></md-select><div \nng-messages=\"orderForm[\'startedAtTimeFormat_\'+$index].$error\" \nng-show=\"orderForm[\'startedAtTimeFormat_\'+$index].$error\" role=\"alert\"><div ng-message=\"required\">\n{{ \"TASKS.DIALOG.TABS.GENERAL.FIELDS.START_TIME_FORMAT.ERRORS.REQUIRED\" | translate }}</div></div></md-input-container>\n</div><div class=\"datepicker-container\" flex=\"20\"><md-input-container class=\"md-block\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.LABEL_DATE\">Completed at date</label><md-datepicker \ndata-cy=\"tasks-started-at-date-input\" class=\"icon-hide\" ng-required=\"vm.taskCompletedAtIsRequired(task, $index);\" \nng-disabled=\"vm.disableEditTaskCompletedAt(task, $index)\" ng-class=\"{ \'archived-task\': task.archived }\" \nng-model=\"task.completedAtDate\" name=\"completedAtDate_{{$index}}\" ng-change=\"vm.validateDateAndTime(task, $index);\">\n</md-datepicker><div layout=\"row\" ng-messages=\"orderForm[\'completedAtDate_\' + $index].$error\" role=\"alert\" \nclass=\"fs-15\"><div ng-message=\"required\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.REQUIRED_DATE\">Started at field is required</div><div \nng-message=\"valid\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.INVALID_DATE\">\nScheduled date is invalid</div><div ng-message=\"completedAtIsLessThanStartedAt\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.MUST_BE_GREATER\">\nEnd time must be greater than start time</div><div ng-message=\"completedAtIsGreaterThanPresent\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.TIME_IN_FUTURE\">\nTime cannot be greater than current time</div><div ng-message=\"isStartedAtDateMissing\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.DATE_MUST_HAVE_TIME\">Time must have date</div><div \nng-message=\"isGreaterThan12Hours\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.GREATER_12_HOURS\">\nGreater than 12 hours</div><div ng-message=\"isMinorThan1Hour\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.MINOR_1_HOUR\">Minor than 1 hour</div></div>\n</md-input-container></div><div flex=\"20\"><md-input-container class=\"md-block\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.LABEL_TIME\">Completed at time</label><input \nng-disabled=\"vm.disableEditTaskCompletedAt(task, $index)\" data-cy=\"tasks-completed-at-input\" \nng-required=\"vm.taskCompletedAtIsRequired(task, $index);\" class=\"hour-input\" \nng-class=\"{ \'archived-task\': task.archived }\" ng-model=\"task.completedAtTime\" name=\"completedAtTime_{{$index}}\" \nui-time-mask=\"short\" ng-change=\"vm.validateDateAndTime(task, $index);\"><div \nng-messages=\"orderForm[\'completedAtTime_\'+$index].$error\" ng-show=\"orderForm[\'completedAtTime_\'+$index].$touched\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.REQUIRED_TIME\">\nCompleted at field is required</div><div ng-message=\"time\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.INVALID_TIME\">Invalid time</div><div \nng-message=\"isStartedAtTimeMissing\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.TIME_MUST_HAVE_DATE\">Date must have time</div><div><div\n ng-message=\"isGreaterThan12Hours\" translate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.GREATER_12_HOURS\">\nGreater than 12 hours</div></div><div ng-message=\"isMinorThan1Hour\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.COMPLETED_AT.ERRORS.MINOR_1_HOUR\">Minor than 1 hour</div></div>\n</md-input-container></div><div flex=\"60\" ng-if=\"vm.timeFormatIsActive\"><md-input-container class=\"md-block\"><label>\nAM/PM</label><md-select ng-disabled=\"vm.disableEditTaskCompletedAt(task, $index)\" ng-required=\"!!task.completedAtTime\" \nng-class=\"{ \'archived-task\': task.archived }\" ng-model=\"task.completedAtTimeFormat\" \nname=\"completedAtTimeFormat_{{$index}}\" \nng-change=\"vm.updateCompletedTimeFormat(task.completedAtTimeFormat, task); vm.validateDateAndTime(task, $index)\">\n<md-option value=\"am\">AM</md-option><md-option value=\"pm\">PM</md-option></md-select><div \nng-messages=\"orderForm[\'completedAtTimeFormat_\'+$index].$error\" \nng-show=\"orderForm[\'completedAtTimeFormat_\'+$index].$error\" role=\"alert\"><div ng-message=\"required\">\n{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.START_TIME_FORMAT.ERRORS.REQUIRED\' | translate }}</div></div></md-input-container>\n</div></div><md-input-container class=\"md-block mt-5n mb-46\" \nng-if=\"task.id && vm.taskEnableReportedReason && task.status === \'reported\'\"><label \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.REPORTED_REASON.LABEL\">Reported reason</label><md-select translate \ntranslate-attr-placeholder=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.REPORTED_REASON.PLACEHOLDER\" \nname=\"reportedReason_{{$index}}\" ng-model=\"task.reportedReason\" required><md-option ng-value=\"reportedReason\" \nng-repeat=\"reportedReason in vm.taskReportedReasons\">{{ reportedReason }}</md-option></md-select><div \nng-messages=\"orderForm[\'reportedReason_\'+$index].$error\" role=\"alert\" \nng-show=\"orderForm[\'reportedReason_\'+$index].$touched\"><div ng-message=\"required\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.FIELDS.REPORTED_REASON.ERRORS.REQUIRED\">Reported reason is required</div></div>\n</md-input-container><div layout=\"row\" class=\"mt-17n mb-25\" ng-if=\"task.status === \'done\'\"><fc-smart-rewrite \nreference-id=\"task.id || task.sessionId\" reference-type=\"task-status-description\" class=\"flex-100\"><fc-textarea \nng-model=\"task.statusDescription\" label=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.DONE_DESCRIPTION.LABEL\' | translate }}\" \nmax-length=\"5000\" input-name=\"task_status_description\" input-control=\"orderForm.task_status_description\" \nname=\"conclusionDescription\" \nerrors-to-watch=\"[\n                                                            {\n                                                                name: \'maxlength\',\n                                                                translate: \'TASKS.DIALOG.TABS.GENERAL.FIELDS.TASK_DESCRIPTION.ERRORS.MAX_LENGTH\',\n                                                                translateValues: { expectedLength: 5000, receivedLength: orderForm.task_status_description.$viewValue.length }\n                                                            }\n                                                        ]\">\n</fc-smart-rewrite></div><div layout=\"row\" class=\"mt-17n mb-25\" ng-if=\"task.status === \'canceled\'\"><fc-smart-rewrite \nreference-id=\"task.id || task.sessionId\" reference-type=\"task-status-description\" class=\"flex-100\"><fc-textarea \nng-model=\"task.statusDescription\" \nlabel=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.CANCELED_DESCRIPTION.LABEL\' | translate }}\" max-length=\"2000\" \ninput-name=\"task_status_description\" input-control=\"orderForm.task_status_description\" \nname=\"task_status_description_{{$index}}\" is-required=\"vm.configurations.featureCancelationDescriptionRequired\" \nerrors-to-watch=\"[\n                                                            {\n                                                                name: \'maxlength\',\n                                                                translate: \'TASKS.DIALOG.TABS.GENERAL.FIELDS.TASK_DESCRIPTION.ERRORS.MAX_LENGTH\',\n                                                                translateValues: { expectedLength: 2000, receivedLength: orderForm.task_status_description.$viewValue.length }\n                                                            }\n                                                        ]\">\n</fc-smart-rewrite></div><div layout=\"row\" class=\"mt-17n mb-25\" ng-if=\"task.status === \'reported\'\"><fc-smart-rewrite \nreference-id=\"task.id || task.sessionId\" reference-type=\"task-status-description\" class=\"flex-100\"><fc-textarea \nng-model=\"task.statusDescription\" \nlabel=\"{{ \'TASKS.DIALOG.TABS.GENERAL.FIELDS.IMPEDIMENT_DESCRIPTION.PLACEHOLDER\' | translate }}\" max-length=\"2000\" \ninput-name=\"task_status_description\" input-control=\"orderForm.task_status_description\" \nname=\"task_status_description_{{$index}}\" \nerrors-to-watch=\"[\n                                                            {\n                                                                name: \'maxlength\',\n                                                                translate: \'TASKS.DIALOG.TABS.GENERAL.FIELDS.TASK_DESCRIPTION.ERRORS.MAX_LENGTH\',\n                                                                translateValues: { expectedLength: 2000, receivedLength: orderForm.task_status_description.$viewValue.length }\n                                                            }\n                                                        ]\">\n</fc-smart-rewrite></div></div><div class=\"received-viwed-at-container\" ng-if=\"task.receivedAt\"><small \nng-if=\"task.receivedAt && !task.viewedAt\"><md-icon md-font-icon=\"icon-check\"></md-icon>&nbsp;<span \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.VISIT.RECEIVED_AT\" \ntranslate-value-date=\"{{ task.receivedAt| amDateFormat: vm.dateFormat }}\">\n received at {{ task.receivedAt | amDateFormat: vm.dateFormat }} </span></small><small \nng-if=\"task.receivedAt && task.viewedAt\"><md-icon md-font-icon=\"icon-check-all\" class=\"blue-A700-fg\"></md-icon>&nbsp;\n<span translate=\"TASKS.DIALOG.TABS.GENERAL.VISIT.VIEWED_AT\" \ntranslate-value-date=\"{{ task.viewedAt | amDateFormat: vm.dateFormat }}\">\n viewed at {{ task.viewedAt | amDateFormat: vm.dateFormat }}</span></small></div></div></div><div \nng-if=\"vm.tasks.length < vm.maxTasksPerOrder && vm.actions.allowMultipleTasks === true && !vm.order.locked\" \nlayout=\"row\" layout-align=\"center center\"><a data-cy=\"tasks-add-task-button\" class=\"add-task fc-btn-outline-primary\" \nng-click=\"vm.addTask();\" \nng-hide=\"vm.lockNewTaskCreationIfPreviousWasNotCompleted || (vm.isAddingNewTask && vm.onlyAllowNewTaskIfPreviousWasCompleted)\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.VISIT.CTA\">add one more task </a><span class=\"warning-new-visit\" \nng-if=\"vm.lockNewTaskCreationIfPreviousWasNotCompleted\" \ntranslate=\"TASKS.DIALOG.TABS.GENERAL.VISIT.ERRORS.MUST_BE_FINISHED\">\nTo add a new task, as the previous ones need to be completed, canceled or reported</span></div></div></div>\n</md-tab-body></md-tab><md-tab ng-click=\"vm.tabClicked(\'deadlines\')\" md-on-select=\"vm.loadedTabs.deadlines = true;\" \nng-if=\"vm.order.id\" \nng-disabled=\"!vm.accountConfiguration.moduleOrdersDeadlineEnabled && !vm.hasCorporateDeadlineContractPermission\">\n<md-tab-label><span translate=\"TASKS.DIALOG.TABS.DEADLINES.TITLE\">Deadlines</span></md-tab-label><md-tab-body \nng-class=\"{\'no-edit-permission\' : !vm.editPermission && vm.order.id}\"><div id=\"order-dialog-deadlines-tab\" \nclass=\"container-deadlines\"><ng-include ng-if=\"vm.loadedTabs.deadlines\" \nsrc=\"\'app/main/tasks/dialogs/tabs/deadlines/deadlines-tab.html\'\" ng-controller=\"DeadlinesTabController as self\" \nonload=\"self.setControllerData(vm.order)\"></ng-include></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.tabClicked(\'locations\')\" id=\"order-locations-tab\"><md-tab-label><span data-cy=\"location-tab\" \ntranslate=\"TASKS.DIALOG.TABS.LOCATION.TITLE\">Location</span></md-tab-label><md-tab-body><div \nng-class=\"{\'no-edit-permission\' : !vm.editPermission && vm.order.id}\"><div layout-xs=\"column\" layout=\"row\"><div \nflex=\"95\"><md-autocomplete flex md-input-id=\"auto-complete-locations\" data-cy=\"address-input\" \nmd-input-name=\"locations\" md-input-minlength=\"2\" md-input-maxlength=\"150\" md-no-cache=\"false\" \nmd-selected-item-change=\"vm.selectedAddressItemChange(vm.selectedAddress)\" md-selected-item=\"vm.selectedAddress\" \nmd-search-text=\"vm.selectedAddressText\" md-items=\"item in vm.searchAddress(vm.selectedAddressText)\" \nmd-autoselect=\"true\" md-delay=\"1500\" md-item-text=\"item.formattedAddress\" \nmd-floating-label=\"{{ \'TASKS.DIALOG.TABS.LOCATION.SEARCH_ADDRESS.LABEL\' | translate }}\"><md-item-template><span \nmd-highlight-text=\"vm.selectedAddressText\">{{ item.formattedAddress }}</span></md-item-template><md-not-found><span \ntranslate=\"TASKS.DIALOG.TABS.LOCATION.SEARCH_ADDRESS.NO_ADDRESS_FOUND\">No address found.</span></md-not-found><div \nclass=\"hint\"><span translate=\"TASKS.DIALOG.TABS.LOCATION.SEARCH_ADDRESS.ADDRESS_EXAMPLE\">\nTo update the location, look for an address, example: Rua dos Pinheiros, 383 - São Paulo</span></div></md-autocomplete>\n</div><div flex=\"5\" layout=\"row\" layout-align=\"end center\"><md-menu \nng-if=\"(vm.order.address.coords.latitude && vm.order.address.coords.longitude) || vm.getEmployeesWithTask().length\" \nmd-position-mode=\"target-right target\" class=\"options\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"options\"><md-icon md-menu-origin md-font-icon=\"icon-dots-horizontal\">\n</md-icon></md-button><md-menu-content class=\"options-menu-content\"><md-menu-item ng-if=\"vm.selectedCustomer\">\n<md-button class=\"fs-13\" ng-click=\"vm.useCustomerCoords();\" aria-label=\"Consider customer location\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.TABS.LOCATION.SET_TO_CUSTOMER\"><md-icon md-font-icon=\"icon-map-marker\">\n</md-icon><span translate=\"TASKS.DIALOG.TABS.LOCATION.SET_TO_CUSTOMER\">Consider customer location</span> <span>\n{{ vm.order.customer.name }}</span></md-button></md-menu-item><md-menu-item \nng-repeat=\"employee in vm.getEmployeesWithTask()\"><md-button class=\"fs-13\" ng-click=\"vm.useEmployeeCoords(employee);\" \naria-label=\"Consider employee location\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.TABS.LOCATION.SET_TO_EMPLOYEE\"><md-icon md-font-icon=\"icon-map-marker\">\n</md-icon><span translate=\"TASKS.DIALOG.TABS.LOCATION.SET_TO_EMPLOYEE\">Consider employee location</span> <span>\n{{ employee.name }}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div flex=\"100\"><div><p \nclass=\"fs-14\" ng-if=\"vm.setNewCustomerLocation && !vm.customerIsCorporate\"><span \ntranslate=\"TASKS.DIALOG.TABS.LOCATION.CHANGE_CUSTOMER_ADDRESS.MESSAGE\" \ntranslate-values=\"{ customerName: vm.selectedCustomer.name }\">\nThe geolocation information (latitude and longitude) for this service order has been changed. Do you want to permanently change this information for customer \n<b>{{ vm.selectedCustomer.name }}</b>? </span><span class=\"confirm-button\" \nng-click=\"vm.updateCustomerCoords(vm.tasks[0], vm.isNewCustomer);\" \ntranslate=\"TASKS.DIALOG.TABS.LOCATION.CHANGE_CUSTOMER_ADDRESS.OK\">Yes</span></p></div><leaflet id=\"taskLocationMap\" \nlf-center=\"vm.map.center\" markers=\"vm.map.markers\" controls=\"vm.map.controls\" layers=\"vm.map.layers\" height=\"210px\" \nwidth=\"100%\"></leaflet></div></div></md-tab-body></md-tab><md-tab md-on-select=\"vm.loadedTabs.links = true;\" \nng-click=\"vm.tabClicked(\'links\')\" ng-if=\"vm.order.id || vm.selectedCustomerLocation\"><md-tab-label><div \nclass=\"tab-label-with-badge\"><span translate=\"TASKS.DIALOG.TABS.LINKS.TITLE\">LINKS</span><div class=\"title-badge\">\n</div></div></md-tab-label><md-tab-body><div ng-class=\"{\'no-edit-permission\' : !vm.editPermission && vm.order.id}\" \nid=\"order-dialog-link-tab\" class=\"container-tab-content\"><ng-include ng-if=\"vm.loadedTabs.links\" \nsrc=\"\'app/main/tasks/dialogs/tabs/links/links-tab.html\'\" ng-controller=\"LinksTabController as self\" \nonload=\"self.setControllerData(vm.order)\"></ng-include></div></md-tab-body></md-tab><md-tab \nng-disabled=\"!vm.contractorId || !vm.enablePendenciesTab\" ng-click=\"vm.tabClicked(\'pendencies\')\" ng-if=\"vm.order.id\" \nid=\"order-pendencies-tab\"><md-tab-label><span translate=\"TASKS.DIALOG.TABS.PENDENCIES.TITLE\">Pendencies </span><span \nng-if=\"vm.pendencies.totalCount\" class=\"badge-counter\">{{ vm.pendencies.totalCount }}</span></md-tab-label>\n<md-tab-body><div ng-class=\"{\'no-edit-permission\' : !vm.editPermission}\" class=\"container-tab-content\"><ng-include \nng-if=\"vm.loadedTabs.pendencies\" src=\"\'app/main/tasks/dialogs/tabs/pendencies/pendencies-tab.html\'\" \nng-controller=\"PendenciesTabController as self\" onload=\"self.setControllerData(vm.order)\"></ng-include></div>\n</md-tab-body></md-tab><md-tab ng-click=\"vm.tabClicked(\'quotations\')\" ng-if=\"vm.order.id && vm.selectedCustomer\" \nmd-on-select=\"vm.loadedTabs.quotations = true;\"><md-tab-label><span data-cy=\"quotation-tab\" \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.TITLE\">Quotations</span></md-tab-label><md-tab-body><div \nng-class=\"{\'no-edit-permission\' : !vm.editPermission && vm.order.id}\" id=\"order-dialog-quotation-tab\" \nclass=\"container-tab-content\"><ng-include ng-if=\"vm.loadedTabs.quotations\" \nsrc=\"\'app/main/tasks/dialogs/tabs/quotations/quotations-tab.html\'\" ng-controller=\"QuotationsTabController as self\" \nonload=\"self.setControllerData(vm.order)\"></ng-include></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.tabClicked(\'materials\')\" id=\"order-materials-tab\" ng-if=\"vm.order.id\" \nng-disabled=\"!vm.accountConfiguration.moduleMaterialManagementEnabled\" md-on-select=\"vm.loadedTabs.materials = true;\">\n<md-tab-label><span translate=\"TASKS.DIALOG.TABS.MATERIALS.TITLE\">Materials</span></md-tab-label><md-tab-body>\n<info-component-provider text=\"{{ \'TASKS.DIALOG.TABS.MATERIALS.HINT\' | translate }}\"></info-component-provider><div \nng-class=\"{\'no-edit-permission\' : !vm.editPermission && vm.order.id}\" class=\"container-tab-content\"><ng-include \nng-if=\"vm.loadedTabs.materials\" src=\"\'app/main/tasks/dialogs/tabs/materials/materials-tab.html\'\" \nng-controller=\"MaterialsTabController as self\" onload=\"self.setControllerData(vm.order, vm.accountConfiguration)\">\n</ng-include></div></md-tab-body></md-tab><md-tab ng-click=\"vm.tabClicked(\'products\')\" \nng-if=\"vm.order.id && (!vm.selectedCustomer.metadata || (vm.selectedCustomer.metadata && !vm.selectedCustomer.metadata.featureHideTabTaskProducts))\" \nmd-on-select=\"vm.loadedTabs.products = true; vm.loadedTabs.storagesMovements = false\"><md-tab-label><span \ndata-cy=\"products\" translate=\"TASKS.DIALOG.TABS.PRODUCTS.TITLE\">Products</span></md-tab-label><md-tab-body><div \nng-class=\"{\'no-edit-permission\' : !vm.editPermission}\" class=\"container-tab-content\"><ng-include \nng-if=\"vm.loadedTabs.products\" src=\"\'app/main/tasks/dialogs/tabs/products/products-tab.html\'\" \nng-controller=\"ProductsTabController as self\" \nonload=\"self.setControllerData(vm.order, vm.selectedCustomer, vm.selectedService)\"></ng-include></div></md-tab-body>\n</md-tab><md-tab ng-click=\"vm.tabClicked(\'services\')\" \nng-if=\"vm.order.id && (!vm.selectedCustomer.metadata || (vm.selectedCustomer.metadata && !vm.selectedCustomer.metadata.featureHideTabTaskServices))\" \nmd-on-select=\"vm.loadedTabs.services = true;\"><md-tab-label><span data-cy=\"services\" \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.TITLE\">Services</span></md-tab-label><md-tab-body><div \nng-class=\"{\'no-edit-permission\' : !vm.editPermission}\" class=\"container-tab-content\"><ng-include \nng-if=\"vm.loadedTabs.services\" src=\"\'app/main/tasks/dialogs/tabs/services/services-tab.html\'\" \nng-controller=\"ServicesTabController as self\" \nonload=\"self.setControllerData(vm.order, vm.selectedCustomer, vm.selectedService)\"></ng-include></div></md-tab-body>\n</md-tab><md-tab ng-click=\"vm.tabClicked(\'storagesMovements\')\" ng-if=\"vm.order.id\" \nng-disabled=\"!vm.accountConfiguration.moduleStorageControlEnabled\" \nmd-on-select=\"vm.loadedTabs.storagesMovements = true\"><md-tab-label><span \ntranslate=\"TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.TITLE\">Movements</span></md-tab-label><md-tab-body><div \nng-class=\"{\'no-edit-permission\' : !vm.editPermission}\" class=\"container-tab-content\"><ng-include \nng-if=\"vm.loadedTabs.storagesMovements\" \nsrc=\"\'app/main/tasks/dialogs/tabs/storages-movements/storages-movements-tab.html\'\" \nng-controller=\"StoragesMovementsTabController as self\" \nonload=\"self.setControllerData(vm.order, vm.productToMovementTab)\"></ng-include></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.tabClicked(\'attachments\')\" id=\"order-anexos-tab\" md-on-select=\"vm.loadedTabs.attachments = true;\">\n<md-tab-label><span data-cy=\"attachments\" translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.TITLE\">Attachments</span>\n</md-tab-label><md-tab-body><div ng-class=\"{\'no-edit-permission\' : !vm.editPermission && vm.order.id}\" \nclass=\"container-attachments\"><ng-include ng-if=\"vm.loadedTabs.attachments\" \nsrc=\"\'app/main/tasks/dialogs/tabs/attachments/attachments-tab.html\'\" ng-controller=\"AttachmentsTabController as self\" \nonload=\"self.setControllerData(vm.order, vm.tasks, vm.accountConfiguration)\"></ng-include></div></md-tab-body></md-tab>\n<md-tab ng-click=\"vm.tabClicked(\'forms\')\" id=\"order-forms-tab\" ng-if=\"vm.order.id\" \nmd-on-select=\"vm.loadedTabs.forms = true;\"><md-tab-label><span data-cy=\"forms\" \ntranslate=\"TASKS.DIALOG.TABS.FORMS.TITLE\">Forms</span> <span class=\"badge-counter\">\n{{ vm.countAnsweredForms(vm.order) }}</span></md-tab-label><md-tab-body><div \nng-class=\"{\'no-edit-permission\' : !vm.editPermission && vm.order.id}\" class=\"tab-form\"><ng-include \nng-if=\"vm.loadedTabs.forms\" src=\"\'app/main/tasks/dialogs/tabs/forms/forms-tab.html\'\" \nng-controller=\"FormsTabController as self\" onload=\"self.setControllerData(vm.order)\"></ng-include></div></md-tab-body>\n</md-tab><md-tab ng-click=\"vm.tabClicked(\'comments\')\" id=\"order-comments-tab\" ng-if=\"vm.order.id\" \nmd-on-select=\"vm.loadedTabs.comments = true;\"><md-tab-label><span data-cy=\"comments\" \ntranslate=\"TASKS.DIALOG.TABS.COMMENTS.TITLE\">Comments</span></md-tab-label><md-tab-body><div \nng-class=\"{\'no-edit-permission\' : !vm.editPermission && vm.order.id }\" class=\"comment-tab\"><ng-include \nng-if=\"vm.loadedTabs.comments\" src=\"\'app/main/tasks/dialogs/tabs/comments/comments-tab.html\'\" \nng-controller=\"CommentsTabController as self\" onload=\"self.setControllerData(vm.order, vm.user)\"></ng-include></div>\n</md-tab-body></md-tab><md-tab ng-click=\"vm.tabClicked(\'history\')\" id=\"order-history-tab\" ng-if=\"vm.order.id\" \nmd-on-select=\"vm.loadedTabs.history = true;\"><md-tab-label><span translate=\"TASKS.DIALOG.TABS.HISTORY.TITLE\">History\n</span></md-tab-label><md-tab-body><div ng-class=\"{\'no-edit-permission\' : vm.editPermission !== true}\" \nclass=\"container-tab-content\"><ng-include ng-if=\"vm.loadedTabs.history\" \nsrc=\"\'app/main/tasks/dialogs/tabs/historic/historic-tab.html\'\" ng-controller=\"HistoricTabController as self\" \nonload=\"self.setControllerData(vm.tasks[0], vm.tasks, vm.allEmployees, vm.order)\"></ng-include></div></md-tab-body>\n</md-tab><md-tab ng-click=\"vm.trackMixpanelTabClicked(\'routes\')\" id=\"order-routes-tab\" \nng-if=\"vm.order.id && vm.accountConfiguration.partnerName === \'notro\'\" md-on-select=\"vm.loadedTabs.routes = true;\">\n<md-tab-label><span translate=\"TASKS.DIALOG.TABS.ROUTES.TITLE\">Routes</span></md-tab-label><md-tab-body><div \nclass=\"container-tab-content\"><ng-include ng-if=\"vm.loadedTabs.routes\" \nsrc=\"\'app/main/tasks/dialogs/tabs/routes/routes-tab.html\'\" ng-controller=\"RoutesTabController as self\" \nonload=\"self.setControllerData(vm.order)\"></ng-include></div></md-tab-body></md-tab></md-tabs></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-class=\"{\'no-border\': vm.hideBorder() }\"><div \nng-if=\"vm.order.locked && vm.editPermission\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"warning-task-locked\" translate=\"TASKS.DIALOG.LABELS.TASK_LOCKED\">This task is blocked and cannot be changed.\n</span></div><div ng-if=\"vm.order.locked && !vm.editPermission\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"warning-task-locked\" translate=\"TASKS.DIALOG.WARNINGS.CANT_EDIT\">You do not have permission to edit activities\n</span></div><div ng-if=\"!vm.order.locked\" layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"vm.order.id\" id=\"dialog-update-task-button\" ng-click=\"vm.saveOrder()\" class=\"fc-button fc-button--actions\" \nng-disabled=\"vm.validateOrderForm() || vm.checkForRequiredEmployeesValidation() || vm.isCreatingOrder\" \ndata-cy=\"tasks-save-button\" aria-label=\"Save\" translate=\"TASKS.DIALOG.ACTIONS.SAVE\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.SAVE\">Save</md-button><md-icon md-menu-origin \nmd-font-icon=\"icon-information\" class=\"red-700-fg s22\" ng-if=\"vm.hasRequiredFormsErr()\"><md-tooltip md-direction=\"top\" \nstyle=\"display: table\"><span ng-repeat=\"(formErrKey, formErrValue) in vm.requiredFormsErr\"><span \nng-repeat=\"(requiredFormErrKey, requiredFormErrValue) in vm.requiredFormsErr[formErrKey]\">\n{{ requiredFormErrValue.description }}<br></span></span></md-tooltip></md-icon><md-button \ndata-cy=\"dialog-create-task-button\" id=\"dialog-create-task-button\" type=\"submit\" ng-if=\"!vm.order.id\" \nng-click=\"vm.saveOrder(vm.addPermission)\" class=\"fc-button fc-button--actions\" \nng-disabled=\"orderForm.$invalid || orderForm.$pristine || !(vm.validateCustomer()) || vm.hasErrors() || $root.loadingProgress || vm.checkForRequiredEmployeesValidation()\" \naria-label=\"Add\" translate=\"TASKS.DIALOG.ACTIONS.CREATE\" translate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.CREATE\">\nAdd task</md-button></div><div layout=\"row\" ng-if=\"vm.tasks[0].id && vm.tasks.length === 1\"><md-button \nclass=\"md-icon-button\" ng-if=\"vm.showIntegrationButton(\'Omie\') && vm.editPermission === true\" \nng-click=\"vm.openIntegrationDialog($event, vm.tasks, \'Omie\');\"><md-icon md-svg-src=\"assets/icons/icon-omie.svg\" \nclass=\"icon-task-export\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TASKS.DIALOG.ACTIONS.SEND_TO_OMIE\">\nSend to Omie</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-if=\"vm.showIntegrationButton(\'Omie\') && !vm.editPermission\"><md-icon md-svg-src=\"assets/icons/icon-omie.svg\" \nclass=\"no-action-permission\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.NO_PERMISSION_WARN\">Send to Omie</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-if=\"vm.showIntegrationButton(\'Conta Azul\') && vm.editPermission\" \nng-click=\"vm.openIntegrationDialog($event, vm.tasks, \'Conta Azul\');\"><md-icon \nmd-svg-src=\"assets/icons/icon-conta-azul.svg\" class=\"icon-task-export\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_TO_CONTA_AZUL\">Send to Conta Azul</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"vm.showIntegrationButton(\'Conta Azul\') && !vm.editPermission\"><md-icon \nmd-svg-src=\"assets/icons/icon-conta-azul.svg\" class=\"no-action-permission\"></md-icon><md-tooltip md-direction=\"top\">\n<span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.NO_PERMISSION_WARN\">Send to Conta Azul\n</span></md-tooltip></md-button><md-menu md-offset=\"0 48\" ng-if=\"vm.showRatingButton\"><div><md-button \nclass=\"md-icon-button\" aria-label=\"Members\" ng-click=\"vm.openCustomersEmail($mdOpenMenu, $event);\" \nng-disabled=\"!vm.order.tasks[0]._currentEmployeeId\" data-cy=\"tasks-rate-button\"><md-icon md-menu-origin \nmd-font-icon=\"icon-thumbs-up-down\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_RATING_LINK\">Submit activity evaluation link</span></md-tooltip></md-button>\n<md-tooltip ng-if=\"!vm.order.tasks[0]._currentEmployeeId\" md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.ACTIONS.WARNINGS.RATE_TASK_WITHOUT_EMPLOYEE\">\nYou cannot avaliate activities without a collaborator</span></md-tooltip></div><md-menu-content \nclass=\"options-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-menu md-offset=\"0 0\" md-delay=\"500\" \nng-mouseenter=\"vm.clearArray()\"><md-button class=\"menu-item-inner\" ng-click=\"$mdMenu.open()\"><md-icon \nmd-font-icon=\"icon-telegram\"></md-icon><span translate=\"TASKS.DIALOG.ACTIONS.SEND_RATING_LINK\">Send rating link</span>\n</md-button><md-menu-content class=\"options-menu-content\" width=\"4\" ms-scroll><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.SHARE_BY_EMAIL\">Share by e-mail</strong>\n<md-menu-item class=\"option\" ng-if=\"vm.selectedCustomer.contacts.hasEmail\" \nng-repeat=\"email in vm.order.customer.contacts.emails\"><md-button \nng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" md-prevent-menu-close \naria-label=\"toggle e-mail\" translate><div layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-email\"></md-icon><p class=\"option-label\">{{ email.address }}\n</p></div><i class=\"icon-check s16\" ng-if=\"vm.exists(email.id, vm.selectedCustomerEmails)\"></i></div></md-button>\n</md-menu-item><md-menu-item class=\"option\" ng-if=\"!vm.noHaveEmails\"><md-button \nng-disabled=\"vm.selectedCustomerEmails.length === 0\" \nng-click=\"vm.sendRatingEmail(vm.tasks[0], vm.selectedCustomerEmails);\" class=\"add-label-button\"><md-icon \nclass=\"md-accent\" md-font-icon=\"icon-telegram\"></md-icon><p ng-if=\"!vm.noHaveEmails\" class=\"option-label\" \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_REPORT_LINK\">Submit activity evaluation link</p><p ng-if=\"vm.noHaveEmails\" \nclass=\"option-label\" translate=\"TASKS.DIALOG.ACTIONS.WARNINGS.CUSTOMER_NOT_HAVE_EMAIL\">\nThe customer does not have an email</p></md-button></md-menu-item><md-menu-divider></md-menu-divider><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.SHARE_BY_WHATSAPP\">Share by WhatsApp</strong>\n<md-menu-item ng-if=\"vm.selectedCustomer.contacts.hasPhone\" class=\"option\" \nng-repeat=\"phone in vm.order.customer.contacts.phones\"><md-button \nng-click=\"phone.number ? vm.sendEvaluationByWhatsApp(phone.number, vm.order.tasks[0].id) : null\" md-prevent-menu-close \naria-label=\"toggle e-mail\" translate><div layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-whatsapp\"></md-icon><p class=\"option-label\">\n{{ vm.formatPhoneOrCellphone(phone.number) }}</p></div></div></md-button></md-menu-item><md-menu-item class=\"option\">\n<md-button ng-click=\"vm.sendEvaluationByWhatsApp(phone.number, vm.order.tasks[0].id);\" class=\"add-label-button\">\n<md-icon md-font-icon=\"icon-whatsapp\"></md-icon><p class=\"sub-menu-option-label\" \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_TO_ANOTHER_CONTACT\">Send to another contact</p></md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-item class=\"option\"><md-button ngclipboard \ndata-clipboard-text=\"{{vm.link.taskRatingLink + vm.order.tasks[0].id}}\" \nngclipboard-success=\"vm.showToastWhileCopyLink(vm.order.identifier, \'rating\')\" class=\"add-label-button\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><p class=\"option-label fs13 default-option-color\" \ntranslate=\"TASKS.DIALOG.ACTIONS.COPY_LINK\">Copy link</p></md-button></md-menu-item><md-menu-item class=\"option\">\n<md-button class=\"add-label-button\" translate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.OPEN_REPORT\" \nng-attr-target=\"_blank\" ng-href=\"{{vm.link.taskRatingLink + vm.order.tasks[0].id}}\" \nng-disabled=\"!vm.order.tasks[0].employee.id\"><md-icon md-font-icon=\"icon-eye\"></md-icon><p \nclass=\"option-label fs13 black-text\" translate=\"TASKS.DIALOG.ACTIONS.OPEN_REPORT\">Open report</p></md-button>\n</md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 48\" \nng-if=\"vm.tasks[0].id && vm.tasks[0].employee.id && vm.tasks[0].status == \'scheduled\' || vm.tasks[0].status == \'on-route\' \">\n<md-button class=\"md-icon-button\" aria-label=\"Members\" ng-click=\"vm.openCustomersEmail($mdOpenMenu, $event);\"><md-icon \nmd-menu-origin md-font-icon=\"icon-map\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_EMPLOYEE_LOCATION_LINK\">Send employee location link</span></md-tooltip>\n</md-button><md-menu-content class=\"options-menu-content\" width=\"4\" ms-scroll><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_EMAILS\">Customer Emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.contacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_NO_HAVE_EMAILS\">This customer does not have emails.</span><md-menu-item \nclass=\"option\" ng-if=\"vm.selectedCustomer.contacts.hasEmail\" ng-repeat=\"email in vm.order.customer.contacts.emails\">\n<md-button ng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" \nmd-prevent-menu-close aria-label=\"toggle e-mail\" translate><div layout=\"row\" layout-align=\"space-between center\" flex>\n<div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\"></md-icon><p \nclass=\"option-label option-label-fs-13\">{{ email.address }}</p></div><i class=\"icon-check s16\" \nng-if=\"vm.exists(email.id, vm.selectedCustomerEmails)\"></i></div></md-button></md-menu-item><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.LOCATION_EMAILS\">Location emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.allLocationsContacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_NO_HAVE_EMAILS\">This location does not have emails.</span><md-menu-item \nclass=\"option\" ng-if=\"vm.selectedCustomer.allLocationsContacts.emails.length != 0\" \nng-repeat=\"email in vm.order.customer.allLocationsContacts.emails\"><md-button \nng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" md-prevent-menu-close \naria-label=\"toggle e-mail\" translate><div layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-email\"></md-icon><p class=\"option-label option-label-fs-13\">\n{{ email.address }}</p></div><i class=\"icon-check s16\" ng-if=\"vm.exists(email.id, vm.selectedCustomerEmails)\"></i>\n</div></md-button></md-menu-item><md-menu-divider ng-if=\"!vm.noHaveEmails\"></md-menu-divider><md-menu-item \nclass=\"option\"><md-button ng-disabled=\"!vm.selectedCustomerEmails.length\" \nng-click=\"vm.shareTaskLocation(vm.tasks[0], vm.selectedCustomerEmails);\" class=\"add-label-button\"><md-icon \nclass=\"md-accent\" md-font-icon=\"icon-telegram\"></md-icon><p ng-if=\"!vm.noHaveEmails\" \nclass=\"option-label option-label-fs-13\" translate=\"TASKS.DIALOG.ACTIONS.SEND_EMPLOYEE_LOCATION_LINK\">\nSend employee location link</p><p ng-if=\"vm.noHaveEmails\" class=\"option-label option-label-fs-13\" \ntranslate=\"TASKS.DIALOG.ACTIONS.WARNINGS.CUSTOMER_NOT_HAVE_EMAIL\">The customer does not have an email</p></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button ng-click=\"vm.osLinkPrint(vm.order);\" \nng-if=\"vm.actions.enableShareSingleTask\" class=\"md-icon-button\" aria-label=\"Print Task\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.PRINT\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip \nmd-direction=\"top\"><span translate=\"TASKS.DIALOG.ACTIONS.PRINT\">Print Task</span></md-tooltip></md-button><md-button \nng-click=\"vm.printOrder(vm.order);\" ng-if=\"vm.order.id\" class=\"md-icon-button\" aria-label=\"Print Task\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.EXPORT_PDF\"><md-icon md-svg-src=\"assets/icons/icon-pdf-grey.svg\">\n</md-icon><md-tooltip md-direction=\"top\"><span translate=\"TASKS.DIALOG.ACTIONS.EXPORT_PDF\">Export PDF</span>\n</md-tooltip></md-button><md-button data-cy=\"archive-task-button\" ng-if=\"vm.editPermission\" \nng-show=\"(!vm.tasks[0].archived && vm.tasks[0].id)\" class=\"md-icon-button\" \nng-click=\"vm.archiveSingleTask(vm.tasks[0])\" aria-label=\"Archive\" ng-disabled=\"vm.order.locked\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.ARCHIVE_TASK\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon>\n<md-tooltip md-direction=\"top\"><span \ntranslate=\"{{ vm.order.locked ? \'TASKS.DIALOG.ACTIONS.CANT_ARCHIVE_LOCKED\' : \'TASKS.DIALOG.ACTIONS.ARCHIVE_TASK\' }}\">\nARCHIVE</span></md-tooltip></md-button><md-button data-cy=\"archive-task-button\" ng-if=\"!vm.editPermission\" \nng-show=\"(!vm.tasks[0].archived && vm.tasks[0].id)\" class=\"md-icon-button\" aria-label=\"Archive\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.ARCHIVE_TASK\"><md-icon class=\"no-action-permission\" \nmd-font-icon=\"icon-folder-download\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.NO_PERMISSION_WARN\">ARCHIVE</span></md-tooltip>\n</md-button><md-button ng-if=\"vm.editPermission\" ng-show=\"(vm.tasks[0].archived && vm.tasks[0].id)\" \nclass=\"md-icon-button\" ng-click=\"vm.unarchiveSingleTask(vm.tasks[0])\" aria-label=\"Unarchive\" \nng-disabled=\"vm.order.locked\" translate translate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.UNARCHIVE_TASK\"><md-icon \nmd-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"{{ vm.order.locked ? \'TASKS.DIALOG.ACTIONS.CANT_ARCHIVE_LOCKED\' : \'TASKS.DIALOG.ACTIONS.UNARCHIVE_TASK\' }}\">\nUNARCHIVE</span></md-tooltip></md-button><md-menu md-offset=\"0 48\" ng-if=\"vm.actions.enableShareSingleTask\"><md-button \nclass=\"md-icon-button\" aria-label=\"submit activity report link\" ng-click=\"$mdOpenMenu($event);\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.SEND_NEW_REPORTS_LINK\"><md-icon md-menu-origin \nmd-font-icon=\"icon-reply\" class=\"icon-forward\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_NEW_REPORTS_LINK\">Submit new activity report link</span></md-tooltip></md-button>\n<md-menu-content class=\"dialog-menu-customer-space\"><div class=\"menu-content-title\" \nlayout-align=\"space-between center\" flex><span translate=\"TASKS.DIALOG.ACTIONS.ACTIVITY_REPORT_LINK\">\nActivity report link</span></div><md-menu-item><md-menu md-offset=\"0 0\" md-delay=\"500\" ng-mouseenter=\"vm.clearArray()\">\n<md-button class=\"menu-item-inner\" ng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-email\"></md-icon><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SHARE_BY_EMAIL\">Share by e-mail</span></md-button><md-menu-content \nclass=\"options-menu-content\" width=\"4\" ms-scroll><strong class=\"options-menu-content__subtitle\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_EMAILS\">Location emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.allLocationsContacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_NO_HAVE_EMAILS\">This location does not have emails.</span><md-menu-item \nng-if=\"vm.order.customer.allLocationsContacts.emails\" class=\"option\" \nng-repeat=\"email in vm.order.customer.allLocationsContacts.emails\"><md-button \nng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" translate \nmd-prevent-menu-close><div layout=\"row\" ng-click=\"email.checked = !email.checked\" md-prevent-menu-close><div flex=\"10\" \nclass=\"option__icon\"><md-icon md-font-icon=\"icon-email\"></md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\">\n<p class=\"option__label\">{{ (email.name || \'Sem nome\') | limitTo: 20 }}</p><p ng-if=\"email.primary == true\" \ntranslate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p class=\"option__sub-label\">\n{{ email.address }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" layout-align=\"end\"><md-checkbox \nclass=\"contact-checkbox-primary\" ng-model=\"email.checked\" ng-click=\"email.checked = !email.checked\" \nmd-prevent-menu-close></md-checkbox></div></div></md-button></md-menu-item><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_EMAILS\">Customer Emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.contacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_NO_HAVE_EMAILS\">This customer does not have emails.</span><md-menu-item \nng-if=\"vm.selectedCustomer.contacts.hasEmail\" class=\"option\" ng-repeat=\"email in vm.order.customer.contacts.emails\">\n<md-button ng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" \nmd-prevent-menu-close aria-label=\"toggle e-mail\" translate><div layout=\"row\" ng-click=\"email.checked = !email.checked\" \nmd-prevent-menu-close><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-email\"></md-icon></div><div \nlayout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">{{ (email.name || \'Sem nome\') | limitTo: 20 }}</p><p \nng-if=\"email.primary == true\" translate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p \nclass=\"option__sub-label\">{{ email.address }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" \nlayout-align=\"end\"><md-checkbox class=\"contact-checkbox-primary\" ng-model=\"email.checked\" \nng-click=\"email.checked = !email.checked\" md-prevent-menu-close></md-checkbox></div></div></md-button></md-menu-item>\n<md-menu-item class=\"option\" flex layout-align=\"center\" ng-if=\"!vm.noHaveEmails\"><md-button \nng-disabled=\"vm.selectedCustomerEmails.length === 0 \" \nng-click=\"vm.sendPrintOrder(vm.order, vm.selectedCustomerEmails, task.id);\" class=\"option__send-link-button\"><md-icon \nclass=\"md-accent\" md-font-icon=\"icon-telegram\"></md-icon><span class=\"option__buttom-label\" ng-if=\"!vm.noHaveEmails\" \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_REPORT_LINK\">Send report link </span><span class=\"option__buttom-label-count\">\n{{\' (\' + vm.selectedCustomerEmails.length + \') \' }}</span> <span class=\"option__buttom-label\" ng-if=\"vm.noHaveEmails\" \ntranslate=\"TASKS.DIALOG.ACTIONS.WARNINGS.CUSTOMER_NOT_HAVE_EMAIL\">The customer does not have an email</span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-menu md-offset=\"0 0\" \nmd-delay=\"500\"><md-button class=\"menu-item-inner\" ng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon><span translate=\"TASKS.DIALOG.ACTIONS.SHARE_BY_WHATSAPP\">Share by WhatsApp</span></md-button><md-menu-content\n class=\"options-menu-content\" width=\"4\" ms-scroll><strong class=\"options-menu-content__subtitle\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CONTACTS_BY_LOCATION\">Contacts by location </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.allLocationsContacts.phones.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_NO_HAVE_CONTACTS\">This location does not have contacts.</span><md-menu-item \nng-if=\"vm.order.customer.allLocationsContacts.phones\" class=\"option\" \nng-repeat=\"phone in vm.order.customer.allLocationsContacts.phones\"><md-button \nng-click=\"phone.number ? vm.sendByWhatsApp(vm.order.id, \'new-os\', phone.number) : null\" translate \nmd-prevent-menu-close><div layout=\"row\"><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">\n{{ (phone.name || \'Sem nome\') | limitTo: 20 }}</p><p ng-if=\"phone.primary == true\" \ntranslate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p class=\"option__sub-label\">\n{{ vm.formatPhoneOrCellphone(phone.number) }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" \nlayout-align=\"end\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div></md-button></md-menu-item><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_CONTACTS\">Customer contacts </strong>\n<span class=\"options-menu-content__no-content-text\" ng-if=\"vm.selectedCustomer.contacts.phones.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_NO_HAVE_CONTACTS\">This customer does not have contacts.</span><md-menu-item \nng-if=\"vm.selectedCustomer.contacts.phones\" class=\"option\" ng-repeat=\"phone in vm.selectedCustomer.contacts.phones\">\n<md-button ng-click=\"phone.number ? vm.sendByWhatsApp(vm.order.id, \'new-os\', phone.number) : null\" translate \nmd-prevent-menu-close><div layout=\"row\"><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">\n{{ (phone.name || \'Sem nome\') | limitTo: 20 }}</p><p ng-if=\"phone.primary == true\" \ntranslate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p class=\"option__sub-label\">\n{{ vm.formatPhoneOrCellphone(phone.number) }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" \nlayout-align=\"end\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div></md-button></md-menu-item>\n<md-menu-item flex layout-align=\"center\" class=\"option option__shared-wpp\" \nng-if=\"vm.selectedCustomer.contacts.phones && vm.order.customer.allLocationsContacts.phones\"><md-button \nng-click=\"vm.sendByWhatsApp(vm.order.id, \'new-os\')\" \nclass=\"option__send-whats-button option__send-whats-button__remove-margin\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon><span class=\"option__buttom-label\" translate=\"TASKS.DIALOG.ACTIONS.SEND_TO_ANOTHER_CONTACT\">\nSend to another contact</span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item \nclass=\"option\"><md-button ngclipboard data-clipboard-text=\"{{vm.link.newOrderPrintLink + vm.order.id}}\" \nngclipboard-success=\"vm.showToastWhileCopyLink(vm.order.identifier, \'report\')\" class=\"add-label-button\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon><p class=\"option-label option-label-fs-13\" \ntranslate=\"TASKS.DIALOG.ACTIONS.COPY_LINK\">Copy link</p></md-button></md-menu-item><md-menu-item class=\"option-link\">\n<md-button ng-attr-target=\"_blank\" ng-href=\"{{vm.link.newOrderPrintLink + vm.order.id}}\" class=\"add-label-button\">\n<md-icon md-font-icon=\"icon-eye\"></md-icon><p class=\"option-label option-label-fs-13\" \ntranslate=\"TASKS.DIALOG.ACTIONS.OPEN_REPORTS\">Open report</p></md-button></md-menu-item></md-menu-content></md-menu>\n</div><div layout=\"row\" ng-if=\"vm.tasks[0].id && vm.tasks.length > 1\"><md-button class=\"md-icon-button\" \nng-if=\"vm.showIntegrationButton(\'Omie\') && vm.editPermission\" \nng-click=\"vm.openIntegrationDialog($event, vm.tasks, \'Omie\');\"><md-icon md-svg-src=\"assets/icons/icon-omie.svg\" \nclass=\"icon-task-export\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TASKS.DIALOG.ACTIONS.SEND_TO_OMIE\">\nSend to Omie</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-show=\"vm.showIntegrationButton(\'Omie\') && !vm.editPermission\"><md-icon md-svg-src=\"assets/icons/icon-omie.svg\" \nclass=\"icon-task-export\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.NO_PERMISSION_WARN\">Send to Omie</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-if=\"vm.showIntegrationButton(\'Conta Azul\') && vm.editPermission\" \nng-click=\"vm.openIntegrationDialog($event, vm.tasks, \'Conta Azul\');\"><md-icon \nmd-svg-src=\"assets/icons/icon-conta-azul.svg\" class=\"icon-task-export\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_TO_CONTA_AZUL\">Send to Conta Azul</span></md-tooltip></md-button><md-button \nng-click=\"vm.osLinkPrint(vm.order);\" ng-if=\"vm.order.id\" class=\"md-icon-button\" aria-label=\"Print Order\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.PRINT\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip \nmd-direction=\"top\"><span translate=\"TASKS.DIALOG.ACTIONS.PRINT\">Print Order</span></md-tooltip></md-button><md-button \nng-click=\"vm.printOrder(vm.order);\" ng-if=\"vm.order.id\" class=\"md-icon-button\" aria-label=\"Print Task\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.EXPORT_PDF\"><md-icon md-svg-src=\"assets/icons/icon-pdf-grey.svg\">\n</md-icon><md-tooltip md-direction=\"top\"><span translate=\"TASKS.DIALOG.ACTIONS.EXPORT_PDF\">Export PDF</span>\n</md-tooltip></md-button><md-menu md-offset=\"0 48\"><md-button class=\"md-icon-button\" \naria-label=\"submit activity report link\" ng-click=\"$mdOpenMenu($event)\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.ACTIONS.SEND_NEW_REPORTS_LINK\"><md-icon md-menu-origin \nmd-font-icon=\"icon-reply\" class=\"icon-forward\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_NEW_REPORTS_LINK\">Submit new activity report link</span></md-tooltip></md-button>\n<md-menu-content class=\"dialog-menu-customer-space\"><div class=\"menu-content-title\" \nlayout-align=\"space-between center\" flex><span translate=\"TASKS.DIALOG.ACTIONS.ACTIVITY_REPORT_LINK\">\nActivity report link</span></div><md-menu-item><md-menu md-offset=\"0 0\" md-delay=\"500\" ng-mouseenter=\"vm.clearArray()\">\n<md-button class=\"menu-item-inner\" ng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-email\"></md-icon><span \ntranslate=\"TASKS.DIALOG.ACTIONS.SHARE_BY_EMAIL\">Share by e-mail</span></md-button><md-menu-content \nclass=\"options-menu-content\" width=\"4\" ms-scroll><strong class=\"options-menu-content__subtitle\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_EMAILS\">Location emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.allLocationsContacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_NO_HAVE_EMAILS\">This location does not have emails.</span><md-menu-item \nng-if=\"vm.order.customer.allLocationsContacts.emails\" class=\"option\" \nng-repeat=\"email in vm.order.customer.allLocationsContacts.emails\"><md-button \nng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" translate \nmd-prevent-menu-close><div layout=\"row\" ng-click=\"email.checked = !email.checked\" md-prevent-menu-close><div flex=\"10\" \nclass=\"option__icon\"><md-icon md-font-icon=\"icon-email\"></md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\">\n<p class=\"option__label\">{{ email.name | limitTo: 20 }}</p><p ng-if=\"email.primary == true\" \ntranslate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p class=\"option__sub-label\">\n{{ email.address }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" layout-align=\"end\"><md-checkbox \nclass=\"contact-checkbox-primary\" ng-model=\"email.checked\" ng-click=\"email.checked = !email.checked\" \nmd-prevent-menu-close></md-checkbox></div></div></md-button></md-menu-item><strong \nclass=\"options-menu-content__subtitle\" translate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_EMAILS\">Customer Emails </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.contacts.emails.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_NO_HAVE_EMAILS\">This customer does not have emails.</span><md-menu-item \nng-if=\"vm.selectedCustomer.contacts.hasEmail\" class=\"option\" ng-repeat=\"email in vm.order.customer.contacts.emails\">\n<md-button ng-click=\"email.address ? vm.toggleInArray(email.id, vm.selectedCustomerEmails, true) : null\" \nmd-prevent-menu-close aria-label=\"toggle e-mail\" translate><div layout=\"row\" ng-click=\"email.checked = !email.checked\" \nmd-prevent-menu-close><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-email\"></md-icon></div><div \nlayout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">{{ email.name | limitTo: 20 }}</p><p \nng-if=\"email.primary == true\" translate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p \nclass=\"option__sub-label\">{{ email.address }}</p></div></div><div flex=\"10\" class=\"option__end-icon\" \nlayout-align=\"end\"><md-checkbox class=\"contact-checkbox-primary\" ng-model=\"email.checked\" \nng-click=\"email.checked = !email.checked\" md-prevent-menu-close></md-checkbox></div></div></md-button></md-menu-item>\n<md-menu-item class=\"option\" flex layout-align=\"center\" ng-if=\"!vm.noHaveEmails\"><md-button \nng-disabled=\"vm.selectedCustomerEmails.length === 0 \" \nng-click=\"vm.sendPrintOrder(vm.order, vm.selectedCustomerEmails, task.id);\" class=\"option__send-link-button\"><md-icon \nclass=\"md-accent\" md-font-icon=\"icon-telegram\"></md-icon><span class=\"option__buttom-label\" ng-if=\"!vm.noHaveEmails\" \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_REPORT_LINK\">Send report link </span><span class=\"option__buttom-label-count\">\n{{\' (\' + vm.selectedCustomerEmails.length + \') \' }}</span> <span class=\"option__buttom-label\" ng-if=\"vm.noHaveEmails\" \ntranslate=\"TASKS.DIALOG.ACTIONS.WARNINGS.CUSTOMER_NOT_HAVE_EMAIL\">The customer does not have an email</span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item><md-menu md-offset=\"0 0\" \nmd-delay=\"500\"><md-button class=\"menu-item-inner\" ng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon><span translate=\"TASKS.DIALOG.ACTIONS.SHARE_BY_WHATSAPP\">Share by WhatsApp</span></md-button><md-menu-content\n class=\"options-menu-content\" width=\"4\" ms-scroll><strong class=\"options-menu-content__subtitle\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CONTACTS_BY_LOCATION\">Contacts by location </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.order.customer.allLocationsContacts.phones.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.LOCATION_NO_HAVE_CONTACTS\">This location does not have contacts.</span><md-menu-item \nng-if=\"vm.order.customer.allLocationsContacts.phones\" class=\"option\" \nng-repeat=\"phone in vm.order.customer.allLocationsContacts.phones\"><md-button \nng-click=\"phone.number ? vm.sendByWhatsApp(vm.order.id, \'new-os\', phone.number) : null\" translate \nmd-prevent-menu-close><div layout=\"row\"><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">{{ phone.name | limitTo: 20 }}\n</p><p ng-if=\"phone.primary == true\" translate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p \nclass=\"option__sub-label\">{{ vm.formatPhoneOrCellphone(phone.number) }}</p></div></div><div flex=\"10\" \nclass=\"option__end-icon\" layout-align=\"end\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div>\n</md-button></md-menu-item><strong class=\"options-menu-content__subtitle\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_CONTACTS\">Customer contacts </strong><span \nclass=\"options-menu-content__no-content-text\" ng-if=\"vm.selectedCustomer.contacts.phones.length === 0\" \ntranslate=\"TASKS.DIALOG.ACTIONS.CUSTOMER_NO_HAVE_CONTACTS\">This customer does not have contacts.</span><md-menu-item \nng-if=\"vm.selectedCustomer.contacts.phones\" class=\"option\" ng-repeat=\"phone in vm.selectedCustomer.contacts.phones\">\n<md-button ng-click=\"phone.number ? vm.sendByWhatsApp(vm.order.id, \'new-os\', phone.number) : null\" translate \nmd-prevent-menu-close><div layout=\"row\"><div flex=\"10\" class=\"option__icon\"><md-icon md-font-icon=\"icon-whatsapp\">\n</md-icon></div><div layout=\"column\" flex=\"80\"><div flex=\"30\"><p class=\"option__label\">{{ phone.name | limitTo: 20 }}\n</p><p ng-if=\"phone.primary == true\" translate=\"TASKS.DIALOG.ACTIONS.PRIMARY\">- Primary</p></div><div flex=\"40 \"><p \nclass=\"option__sub-label\">{{ vm.formatPhoneOrCellphone(phone.number) }}</p></div></div><div flex=\"10\" \nclass=\"option__end-icon\" layout-align=\"end\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div>\n</md-button></md-menu-item><md-menu-item flex layout-align=\"center\" class=\"option\" \nng-if=\"vm.selectedCustomer.contacts.phones && vm.order.customer.allLocationsContacts.phones\"><md-button \nng-click=\"vm.sendByWhatsApp(vm.order.id, \'new-os\')\" class=\"option__send-whats-button\"><md-icon \nmd-font-icon=\"icon-whatsapp\"></md-icon><span class=\"option__buttom-label\" \ntranslate=\"TASKS.DIALOG.ACTIONS.SEND_TO_ANOTHER_CONTACT\">Send to another contact</span></md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-item class=\"option\"><md-button ngclipboard \ndata-clipboard-text=\"{{vm.link.newOrderPrintLink + vm.order.id}}\" \nngclipboard-success=\"vm.showToastWhileCopyLink(vm.order.identifier, \'report\')\" class=\"add-label-button\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon><p class=\"option-label-fs-13\" translate=\"TASKS.DIALOG.ACTIONS.COPY_LINK\">\nCopy link</p></md-button></md-menu-item><md-menu-item class=\"option option-link\"><md-button ng-attr-target=\"_blank\" \nng-href=\"{{vm.link.newOrderPrintLink + vm.order.id}}\" class=\"add-label-button\"><md-icon md-font-icon=\"icon-eye\">\n</md-icon><p class=\"option-label-fs-13\" translate=\"TASKS.DIALOG.ACTIONS.OPEN_REPORT\">Open report</p></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/tasks/templates/change-task-status-alert.html","<div><div><p class=\"fc-modal__content\">{{vm.variables.alertFirstContent}} <b>{{vm.variables.employeeName}}</b>\n {{vm.variables.alertSecondContent}}</p></div></div>");
$templateCache.put("app/main/tasks/templates/export-excel-button-content.html","<div><p class=\"fc-modal__content\">{{vm.variables.title}}</p><md-checkbox class=\"md-primary checkbox-margin\" \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.variables.materialNgModel\" \nng-change=\"vm.variables.changeCheckbox(\'materials\')\">{{vm.variables.materialCheckboxTitle}}</md-checkbox><md-checkbox \nclass=\"md-primary checkbox-margin\" layout=\"row\" layout-align=\"start center\" ng-model=\"vm.variables.productNgModel\" \nng-change=\"vm.variables.changeCheckbox(\'products\')\">{{vm.variables.productCheckboxTitle}}</md-checkbox><md-checkbox \nclass=\"md-primary checkbox-margin\" layout=\"row\" layout-align=\"start center\" ng-model=\"vm.variables.servicesNgModel\" \nng-change=\"vm.variables.changeCheckbox(\'services\')\">{{vm.variables.servicesCheckboxTitle}}</md-checkbox><md-checkbox \nclass=\"md-primary checkbox-margin\" layout=\"row\" layout-align=\"start center\" ng-model=\"vm.variables.equipmentNgModel\" \nng-change=\"vm.variables.changeCheckbox(\'equipments\')\">{{vm.variables.equipmentCheckboxTitle}}</md-checkbox><md-checkbox\n class=\"md-primary checkbox-margin\" layout=\"row\" layout-align=\"start center\" ng-model=\"vm.variables.formsNgModel\" \nng-change=\"vm.variables.changeCheckbox(\'forms\')\">{{vm.variables.formsCheckboxTitle}}</md-checkbox><md-checkbox \nclass=\"md-primary checkbox-margin\" layout=\"row\" layout-align=\"start center\" ng-model=\"vm.variables.linksNgModel\" \nng-change=\"vm.variables.changeCheckbox(\'links\')\">{{vm.variables.linksCheckboxTitle}}</md-checkbox><div><p \nclass=\"fc-modal__content\">{{vm.variables.alertFirstContent}} <b>{{vm.variables.email}}. </b>\n{{vm.variables.alertSecondContent}}</p><p class=\"fc-modal__content\">{{vm.variables.confirmActionContent}}</p></div>\n</div>");
$templateCache.put("app/main/tasks/templates/export-limit-exceeded.html","<div><p class=\"fc-modal__content\">{{vm.variables.title}}</p><div><p class=\"fc-modal__content\">\n{{vm.variables.alertFirstContent}} <b>{{vm.variables.pdfExportMaxLength}}</b> {{vm.variables.alertSecondContent}}</p>\n</div></div>");
$templateCache.put("app/main/tasks/templates/export-pdf-button-content.html","<div><p class=\"fc-modal__content\">{{vm.variables.title}}</p><div><p class=\"fc-modal__content\">\n{{vm.variables.alertFirstContent}} <b>{{vm.variables.email}}. </b>{{vm.variables.alertSecondContent}}</p><p \nclass=\"fc-modal__content\">{{vm.variables.confirmActionContent}}</p></div></div>");
$templateCache.put("app/main/vehicles/dialogs/vehicle-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large vehicle-dialog\" aria-label=\"Dialog vehicle\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\">\n{{vm.vehicle.id ? ( \'VEHICLES.DIALOG.EDIT.TITLE\' | translate ):(\'VEHICLES.DIALOG.NEW.TITLE\' | translate)}}</span></div>\n<div class=\"sidebar-dialog__actions\"><md-button data-cy=\"close-dialog-button\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><form name=\"vm.vehiclesForm\" novalidate><md-dialog-content class=\"pt-0\" style=\"padding: 0 !important\" \nms-scroll><md-dialog-content ms-scroll class=\"pt-0\"><md-tabs md-selected=\"vm.selectedTabIndex\" md-dynamic-height \nclass=\"ml-24n\"><md-tab><md-tab-label class=\"creating-vehicle\"><span translate=\"VEHICLES.DIALOG.TABS.GENERAL\">General\n</span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/vehicles/dialogs/tabs/general/general-tab.html\'\"></div>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.vehicle && vm.vehicle.id\"><md-tab-label><span \ntranslate=\"VEHICLES.DIALOG.TABS.FORMS\">VEHICLE FORMS</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/vehicles/dialogs/tabs/forms/vehicle-forms-tab.html\'\"></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content></md-dialog-content></form><md-dialog-actions class=\"vehicle-dialog__footer\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><button \nng-attr-data-cy=\"{{vm.vehicle.id ? \'save-button\' : \'create-button\'}}\" \nng-class=\"{ disabled: vm.vehiclesForm.$invalid || vm.vehiclesForm.$pristine || $root.loadingProgress }\" \nclass=\"fc-button fc-button--actions\" ng-click=\"vm.saveVehicle()\" \nng-disabled=\"vm.vehiclesForm.$invalid || vm.vehiclesForm.$pristine || $root.loadingProgress\">\n{{vm.vehicle.id ? (\'VEHICLES.DIALOG.EDIT.SAVE\' | translate ) : (\'VEHICLES.DIALOG.NEW.CREATE\' | translate) }}</button>\n</div><div layout=\"row\" ng-if=\"vm.vehicle.id\"><md-button data-cy=\"archive-button\" ng-show=\"!vm.vehicle.archived\" \nclass=\"md-icon-button\" ng-click=\"vm.archiveVehicle($event)\" aria-label=\"Archive\" translate \ntranslate-attr-aria-label=\"VEHICLES.DIALOG.ACTIONS.ARCHIVE\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"VEHICLES.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip>\n</md-button><md-button data-cy=\"unarchive-button\" ng-show=\"vm.vehicle.archived\" class=\"md-icon-button\" \nng-click=\"vm.unarchiveVehicle($event)\" aria-label=\"Unarchive\" translate \ntranslate-attr-aria-label=\"VEHICLES.DIALOG.ACTIONS.UNARCHIVE\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"VEHICLES.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/vehicles-usage/dialogs/vehicle-usage-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large vehicles-usage-dialog\" aria-label=\"Dialog vehicles usage\">\n<md-toolbar class=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\" \ntranslate=\"VEHICLES_USAGE.DIALOG.TITLE\" translate-values=\"{ vehicleName: vm.vehicleUsage.vehicle.name }\"></span></div>\n<div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"pt-0\" style=\"padding: 0 !important\" ms-scroll><md-tabs md-dynamic-height class=\"ml-24n\"><md-tab><md-tab-label>\n<span translate=\"VEHICLES_USAGE.DIALOG.TABS.GENERAL\">GENERAL</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/vehicles-usage/dialogs/tabs/general/general-tab.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.vehicleUsage && vm.vehicleUsage.id\"><md-tab-label><span translate=\"VEHICLES_USAGE.DIALOG.TABS.FORMS\">FORMS\n</span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/vehicles-usage/dialogs/tabs/forms/forms-tab.html\'\"></div>\n</md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions class=\"vehicles-usage-dialog__footer\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><button \nclass=\"fc-button fc-button--actions\" ng-click=\"vm.saveVehicleUsage()\" \nng-disabled=\"vm.vehiclesUsageForm.$invalid || vm.vehiclesUsageForm.$pristine || $root.loadingProgress || !vm.hasAllImages()\" \nng-class=\"{disabled: vm.vehiclesUsageForm.$invalid || vm.vehiclesUsageForm.$pristine || $root.loadingProgress}\" \ntranslate=\"VEHICLES_USAGE.DIALOG.SAVE\"></button></div><div layout=\"row\" ng-if=\"vm.vehicleUsage.id\"><md-button \ndata-cy=\"archive-vehicle-usage-button\" ng-show=\"!vm.vehicleUsage.archived\" class=\"md-icon-button\" \nng-click=\"vm.archiveVehicleUsage($event)\" aria-label=\"Archive\" translate \ntranslate-attr-aria-label=\"VEHICLES_USAGE.DIALOG.ACTIONS.ARCHIVE\"><md-icon md-font-icon=\"icon-folder-download\">\n</md-icon><md-tooltip md-direction=\"top\"><span translate=\"VEHICLES_USAGE.DIALOG.ACTIONS.ARCHIVE\">Archive</span>\n</md-tooltip></md-button><md-button ng-show=\"vm.vehicleUsage.archived\" class=\"md-icon-button\" \nng-click=\"vm.unarchiveVehicleUsage($event)\" aria-label=\"Unarchive\" translate \ntranslate-attr-aria-label=\"VEHICLES_USAGE.DIALOG.ACTIONS.UNARCHIVE\"><md-icon md-font-icon=\"icon-folder-upload\">\n</md-icon><md-tooltip md-direction=\"top\"><span translate=\"VEHICLES_USAGE.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span>\n</md-tooltip></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-services/templates/export-products-services.html","<div><p class=\"fc-modal__content\">{{vm.variables.confirmActionContent}}</p></div>");
$templateCache.put("app/core/directives/fc-autocomplete/template/fc-autocomplete.html","<div class=\"fc-autocomplete\"><div class=\"fc-autocomplete__autocomplete\" \nng-class=\"{ disabled: vm.isInputDisabled || isDisabled }\" ng-click=\"vm.showOptions = true\"><div class=\"fc-input\" \nng-click=\"vm.deselect()\"><md-icon md-svg-src=\"assets/icons/icon-search.svg\" \nclass=\"fc-autocomplete__autocomplete__search-icon\"></md-icon><input hidden type=\"text\" name=\"{{inputName}}\" \nng-model=\"ngModel\" ng-required=\"isRequired\"> <input type=\"text\" id=\"{{ focusId }}\" \nclass=\"fc-input__input fc-input__input--with-prefix\" placeholder=\" \" ng-model=\"searchTerm\" ng-required=\"isRequired\" \nng-change=\"searchFunction()\" data-cy=\"fc-autocomplete-{{inputName}}\" ng-disabled=\"vm.isInputDisabled || isDisabled\" \nng-class=\"{\n          disabled: vm.isInputDisabled || isDisabled,\n          invalid: inputControl.$touched && inputControl.$invalid\n        }\" \nng-blur=\"vm.setInputTouched()\"><label class=\"fc-input__label fc-input__input--with-prefix__label\" \nng-class=\"{\n         \'fc-input__label--no-animation\': noAnimation\n        }\">{{label}}</label><fc-error \nng-show=\"inputControl.$touched\" input-errors=\"inputControl.$error\" errors-to-watch=\"errorsToWatch\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div class=\"fc-autocomplete__autocomplete__clear-button\" \nng-show=\"ngModel && !isDisabled\" ng-click=\"vm.clearList(); vm.focusIfWanted()\"></div></div><ul \nclass=\"fc-autocomplete__dropdown\" ng-show=\"!ngModel && searchTerm && vm.showOptions && !isDisabled\" ms-scroll><li \nclass=\"fc-autocomplete__dropdown__item\" ng-if=\"vm.loading === false && !options.length\">\n{{ \'CORE.FC_AUTOCOMPLETE.NO_RESULTS\' | translate }}</li><li class=\"fc-autocomplete__dropdown__item cursor-pointer\" \ndata-cy=\"fc-autocomplete-item-{{inputName}}\" \nng-class=\"{ \'activated\': option === (trackBy ? ngModel[trackBy] : ngModel) }\" ng-repeat=\"option in options\" \nng-click=\"vm.selectedItemChange($event, option)\">{{ option.translate || option[trackBy] || option }}</li></ul></div>\n<div class=\"overlay\" ng-show=\"!ngModel && searchTerm && vm.showOptions\" ng-click=\"vm.showOptions = false\"></div>");
$templateCache.put("app/core/directives/fc-box/template/fc-box.html","<div class=\"fc-box\"><header class=\"fc-box__header\"><span>{{headerTitle}}</span></header><div class=\"fc-box__body\"><div \nclass=\"fc-box__content\" ng-class=\"{\'fc-box__content--state-renewal\': type === \'renewal\'}\"><div ng-transclude></div><div\n ng-if=\"progressUsing && progressLimit\" class=\"fc-box__content__display-count\"><div \nclass=\"fc-box__content__display-count__progress fc-box__content__display-count__progress--empty\"></div><div \nid=\"progress-bar\" ng-style=\"{width: vm.currentWidth}\" \nclass=\"fc-box__content__display-count__progress fc-box__content__display-count__progress--current\"></div></div></div>\n<button ng-if=\"isRenewal\" ng-click=\"buttonClick()\" type=\"button\" class=\"fc-box__button\" \nng-class=\"{\'fc-box__button--state-renewal\': isRenewal}\" ng-disabled=\"type === \'renewal\' && !isRenewal\"><span>\n{{ buttonText }}</span></button> <button ng-if=\"!isRenewal\" ng-click=\"buttonClick()\" type=\"button\" \nclass=\"fc-box__button\" ng-disabled=\"type === \'renewal\' && !isRenewal\"><span>{{ buttonText }}</span></button></div>\n</div>");
$templateCache.put("app/core/directives/fc-call-to-action-create-new/templates/index.html","<div class=\"call-to-action\"><span>{{ message }} <a ng-click=\"action()\" class=\"cursor-pointer\">{{ link }}</a>.</span>\n</div>");
$templateCache.put("app/core/directives/fc-color-picker/template/color-picker.html","<div id=\"fc-color-picker\"><div flex class=\"color-value\" layout=\"row\"><input flex=\"90\" name=\"{{ name }}\" type=\"text\" \nautocomplete=\"off\" ng-model=\"ngModel\" ng-disabled=\"{{ disabled }}\" ng-pattern=\"/^#[0-9A-F]{6}$/i\" \nplaceholder=\"{{ \'CORE.FC_COLOR_PICKER.COLOR_INPUT.PLACEHOLDER\' | translate }}\" required=\"{{ required }}\"><span \nclass=\"color-selected\" ng-if=\"ngModel\" ng-style=\"{ \'background-color\': ngModel }\"></span></div><div \nng-show=\"{{ !disabled }}\" class=\"colors\"><div class=\"color\" ng-repeat=\"(colorClass, color) in vm.colors\"><button \nmd-colors=\"{ background: \'{{ colorClass }}-{{ vm.mainVariantColor }}\' }\" \nng-click=\"vm.selectColor(color, vm.mainVariantColor)\" aria-label=\"{{ colorClass }}\"></button><div flex \nclass=\"colors-variants\" ng-if=\"color.$$expanded\"><button md-colors=\"{ background: \'{{ colorClass }}-400\' }\" \nng-click=\"vm.selectColor(color, \'400\')\" aria-label=\"400\"></button> <button \nmd-colors=\"{ background: \'{{ colorClass }}-300\' }\" ng-click=\"vm.selectColor(color, \'300\')\" aria-label=\"300\"></button> \n<button md-colors=\"{ background: \'{{ colorClass }}-200\' }\" ng-click=\"vm.selectColor(color, \'200\')\" aria-label=\"200\">\n</button> <button md-colors=\"{ background: \'{{ colorClass }}-100\' }\" ng-click=\"vm.selectColor(color, \'100\')\" \naria-label=\"100\"></button></div></div></div></div>");
$templateCache.put("app/core/directives/fc-dialog-error/template/fc-dialog-error.html","<div ng-if=\"isVisible\" class=\"dialog-error-alert\"><md-icon class=\"dialog-error-alert__alert-icon\" \nmd-svg-src=\"assets/icons/icon-alert-bullet.svg\"></md-icon><p class=\"dialog-error-alert__text\">{{text}}</p><md-icon \nclass=\"dialog-error-alert__close-icon\" md-font-icon=\"icon-close\" ng-click=\"vm.closeError()\"></md-icon></div>");
$templateCache.put("app/core/directives/fc-error/template/fc-error.html","<div layout=\"row\"><div class=\"fc-error {{ customClass ? customClass : \'\' }}\" ng-messages=\"inputErrors\" role=\"alert\" \nng-show=\"ngShow\"><span class=\"fc-error__item\" ng-repeat=\"error in errorsToWatch\" ng-message=\"{{ error.name }}\" \ntranslate=\"{{ error.translate }}\" translate-values=\"{{ error.translateValues }}\" \ndata-cy=\"fc-error__item-{{error.name}}\">{{ error.translateValues | translate }}</span></div></div>");
$templateCache.put("app/core/directives/fc-export-alert/templates/export-alert.html","<md-dialog data-cy=\"export-dialog\" class=\"fc-export-alert\"><h3 class=\"fc-export-alert__header\">{{ vm.title }}</h3><div \nclass=\"fc-export-alert__body\"><p><span ng-if=\"vm.hasSendedToEmail\" translate=\"CORE.FC_EXPORT_ALERT.TEXT_SEND\">\nExport has been sent to email </span><span ng-if=\"vm.hasSendedToEmail\">{{ vm.email }}</span></p><p \nng-if=\"!vm.hasSendedToEmail\" translate=\"CORE.FC_EXPORT_ALERT.GENERATING\">\nYour export is being generated, wait for the download.</p><p translate=\"CORE.FC_EXPORT_ALERT.TEXT_VIEW\">\nYou can also view it by clicking the button below.</p></div><a data-cy=\"view-export-button\" \nclass=\"fc-export-alert__export-button\" translate=\"CORE.FC_EXPORT_ALERT.BUTTON_VIEW\" ng-click=\"vm.goToExportPage()\">\nview exports </a><a class=\"fc-export-alert__dont-see-anymore\" translate=\"CORE.FC_EXPORT_ALERT.BUTTON_DONT_SEE\" \nng-click=\"vm.dontSeeAnymore()\">I don\'t want to see this message anymore</a><md-button \nclass=\"fc-export-alert__close md-icon-button md-accent md-mini\" ng-click=\"vm.close()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button><img class=\"fc-export-alert__alert\" \nsrc=\"assets/icons/icon-alert-circlce-blue.svg\" alt=\"Alerta\"></md-dialog>");
$templateCache.put("app/core/directives/fc-export-alert/templates/migration-alert.html","<md-dialog class=\"fc-export-alert\"><h3 class=\"fc-export-alert__header\">{{ vm.title }}</h3><div \nng-if=\"vm.isToShowButtons\" class=\"fc-export-alert__body\"><p><span ng-if=\"vm.hasSendedToEmail\" \ntranslate=\"CORE.FC_EXPORT_ALERT.TEXT_SEND\">Export has been sent to email </span><span ng-if=\"vm.hasSendedToEmail\">\n{{ vm.email }}</span></p><p ng-if=\"!vm.hasSendedToEmail\" translate=\"CORE.FC_EXPORT_ALERT.GENERATING\">\nYour export is being generated, wait for the download.</p><p translate=\"CORE.FC_EXPORT_ALERT.TEXT_VIEW\">\nYou can also view it by clicking the button below.</p></div><div ng-if=\"!vm.isToShowButtons\" \nclass=\"fc-export-alert__body\">{{ \'MATERIALS.MIGRATION.ALERT_DESCRIPTION\' | translate }}</div><span \nng-if=\"vm.isToShowButtons\"><a class=\"fc-export-alert__export-button\" translate=\"CORE.FC_EXPORT_ALERT.BUTTON_VIEW\" \nng-click=\"vm.goToExportPage()\">view exports </a><a class=\"fc-export-alert__dont-see-anymore\" \ntranslate=\"CORE.FC_EXPORT_ALERT.BUTTON_DONT_SEE\" ng-click=\"vm.dontSeeAnymore()\">\nI don\'t want to see this message anymore</a></span><md-button \nclass=\"fc-export-alert__close md-icon-button md-accent md-mini\" ng-click=\"vm.close()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button><img class=\"fc-export-alert__alert\" \nsrc=\"assets/icons/icon-alert-circlce-blue.svg\" alt=\"Alerta\"></md-dialog>");
$templateCache.put("app/core/directives/fc-export-csv-button/templates/button.html","<md-button onclick=\"document.getElementsByClassName(\'buttons-csv\')[0].click()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"{{\'CORE.FC_EXPORT_CSV_BUTTON.TEXT\' | translate}}\"><md-icon md-font-icon=\"icon-file-delimited\"></md-icon>\n<md-tooltip><span translate=\"CORE.FC_EXPORT_CSV_BUTTON.TEXT\">Export to CSV</span></md-tooltip></md-button>");
$templateCache.put("app/core/directives/fc-export-excel-button/templates/button.html","<md-button onclick=\"document.getElementsByClassName(\'buttons-excel\')[0].click()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"{{\'CORE.FC_EXPORT_EXCEL_BUTTON.TEXT\' | translate}}\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>\n<md-tooltip><span translate=\"CORE.FC_EXPORT_EXCEL_BUTTON.TEXT\">Export to Excel</span></md-tooltip></md-button>");
$templateCache.put("app/core/directives/fc-export-print-button/templates/button.html","<md-button onclick=\"document.getElementsByClassName(\'buttons-print\')[0].click()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"{{\'CORE.FC_EXPORT_PRINT_BUTTON.TEXT\' | translate}}\"><md-icon md-font-icon=\"icon-printer\"></md-icon>\n<md-tooltip><span translate=\"CORE.FC_EXPORT_PRINT_BUTTON.TEXT\">Print</span></md-tooltip></md-button>");
$templateCache.put("app/core/directives/fc-image-input/template/fc-image-input.html","<div class=\"fc-image-input\"><md-icon ng-if=\"!vm.withoutRemove && vm.imageFile || ngModel\" \nclass=\"fc-image-input__remove-icon\" md-svg-src=\"/assets/icons/icon-remove.svg\" ng-click=\"vm.removeImage()\"></md-icon>\n<div class=\"fc-image-input__image-container\" ng-class=\"{ \'fc-image-input--disabled\': vm.isDisabled }\" \nng-style=\"{ \'width\': width, \'height\': height }\"><div ngf-drop ngf-select id=\"image-insert-container\" \nng-model=\"vm.imageFile\" data-cy=\"fc-image-input\" ngf-max-size=\"{{vm.maxSize}}\" ngf-validate=\"vm.validateImage($file)\" \nng-change=\"vm.fileChanged($file)\" ngf-accept=\"vm.ngfAccept\" ngf-multiple=\"false\" \nclass=\"fc-image-input__image-container__options\" ng-disabled=\"vm.isDisabled\" \nng-class=\"{ \'fc-image-input__image-container--disabled__options\': vm.isDisabled }\" name=\"{{ name }}\" \nngf-allow-dir=\"false\"><div class=\"fc-image-input__image-container__options__input\" \nng-click=\"vm.viewOriginalImage((ngModel | mumakil))\" ng-if=\"ngModel\"><div \nclass=\"fc-image-input__image-container__options__input__icons\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip \nmd-direction=\"top\"><span translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.VIEW_ORIGINAL\">See original attachment</span>\n</md-tooltip></div></div></div><md-icon ng-if=\"!(vm.imageFile || ngModel)\" \nmd-svg-src=\"assets/icons/icon-image-google.svg\"></md-icon><img class=\"fc-image-input__image-container__image\" \nng-if=\"vm.imageFile || ngModel\" ngf-src=\"vm.imageFile || (ngModel | mumakil)\"></div></div>");
$templateCache.put("app/core/directives/fc-import-template-button/templates/button.html","<md-button onclick=\"document.getElementsByClassName(\'button-import\')[0].click()\" \nclass=\"md-icon-button md-accent md-mini button-white-bg no-padding-important\" \naria-label=\"{{\'CORE.FC_IMPORT_TEMPLATE_BUTTON.TEXT\' | translate}}\"><md-icon md-font-icon=\"icon-cloud-download\">\n</md-icon><md-tooltip><span translate=\"CORE.FC_IMPORT_TEMPLATE_BUTTON.TEXT\">Import template</span></md-tooltip>\n</md-button>");
$templateCache.put("app/core/directives/fc-search/template/fc-search.html","<div class=\"fc-search\"><div class=\"fc-search__search\" ng-class=\"{ disabled: isDisabled }\" \nng-click=\"vm.showOptions = true\"><div class=\"fc-input\"><md-icon md-svg-src=\"assets/icons/icon-search.svg\" \nclass=\"fc-search__search__search-icon\"></md-icon><input type=\"text\" \nclass=\"fc-input__input fc-input__input--with-prefix fc-input__input--with-prefix__fc-search\" placeholder=\" \" \nng-model=\"vm.searchTerm\" ng-change=\"vm.onChange()\" ng-model-options=\"{ debounce: 500 }\" ng-disabled=\"isDisabled\" \nng-class=\"{ disabled: isDisabled }\"><label \nclass=\"fc-input__label fc-input__input--with-prefix__label fc-input__input--with-prefix__label__fc-search\">{{label}}\n</label><span ng-if=\"hint\" class=\"fc-input__input-hint\">{{ hint }}</span></div></div><ul class=\"fc-search__dropdown\" \nng-show=\"vm.searchTerm && vm.showOptions && !isDisabled\" ms-scroll><li class=\"fc-autocomplete__dropdown__item\" \nng-if=\"vm.searchTerm && !options.length && !isDisabled\">{{ \'CORE.FC_AUTOCOMPLETE.NO_RESULTS\' | translate }}</li><li \nng-if=\"options.length\" class=\"fc-search__dropdown__item\" ng-repeat=\"option in options\" \nng-click=\"vm.selectedItemChange(option)\">{{trackBy ? option[trackBy] : option}}</li></ul></div><div class=\"overlay\" \nng-show=\"vm.searchTerm && vm.showOptions\" ng-click=\"vm.showOptions = false\"></div>");
$templateCache.put("app/core/directives/fc-select/template/fc-select.html","<div class=\"fc-select\"><div class=\"fc-select__select\" ng-click=\"vm.toggleShowOptions()\" \nng-class=\"{\n      disabled: isDisabled,\n      invalid: inputControl.$touched && inputControl.$invalid,\n      \'with-divider\': !vm.withSearch && !vm.withoutDivider && !vm.hasArrow\n    }\">\n<div class=\"fc-input\" ng-class=\"{\n        \'fc-input--with-prefix\': prefixSrc\n      }\"><img ng-if=\"prefixSrc\" \nclass=\"fc-input__prefix\" src=\"{{prefixSrc}}\"> <input name=\"{{inputName}}\" type=\"text\" class=\"fc-input__input\" \nplaceholder=\" \" ng-model=\"vm.viewValue\" ng-readonly=\"true\" \nng-class=\"{\n          disabled: isDisabled,\n          invalid: inputControl.$touched && inputControl.$invalid,\n          arrow: hasArrow\n        }\" \nng-disabled=\"isDisabled\" ng-required=\"isRequired\"><label class=\"fc-input__label\">{{label}}</label><i \nng-if=\"vm.hasArrow\" ng-class=\"{ disabled: isDisabled }\" class=\"icon-chevron-down 18 arrow icon-arrow\"></i><fc-error \nng-show=\"inputControl.$touched\" input-errors=\"inputControl.$error\" errors-to-watch=\"errorsToWatch\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><ul class=\"fc-select__dropdown fc-select--position\" \nng-show=\"vm.showOptions && !clickOutside\" ms-scroll><input class=\"fc-select__dropdown__searcher\" ng-if=\"vm.withSearch\" \ntype=\"text\" ng-model=\"vm.searchTerm\" ng-change=\"searchFunction({searchTerm: vm.searchTerm});\" \nng-model-options=\"{ debounce: 500 }\" placeholder=\"{{searchPhrase}}\"><li class=\"fc-select__dropdown__item\" \nng-if=\"(options | filter: vm.currentFilter || \'\').length\" \nng-class=\"{ \'activated\': option.value === vm.selectedOption.value }\" \nng-repeat=\"option in options | filter: vm.currentFilter || \'\' track by $index\" \nng-click=\"vm.selectedItemChange($event, option)\" data-cy=\"fc-select__dropdown__item\">\n{{ option.translate ? option.translate : (trackBy ? option.value[trackBy] : option.value) }}</li><li \nclass=\"fc-select__dropdown__item\" ng-if=\"(options | filter: vm.currentFilter || \'\').length < 1\" \nng-class=\"{\'activated\': option.value === vm.selectedOption.value}\" \ntranslate=\"CORE.FC_SELECT.WITH_SEARCH.NO_RESULTS_FOUND\">No results found</li></ul></div><div class=\"overlay\" \nng-show=\"vm.showOptions\" ng-click=\"vm.toggleShowOptions()\"></div>");
$templateCache.put("app/core/directives/fc-spreadsheet-reader/template/spreadsheet-reader.html","<div id=\"fc-spreadsheet-reader\"><md-input-container class=\"md-block\"><div ngf-drop ngf-select class=\"drop-box\" \nname=\"{{ name }}\" ng-model=\"vm.spreadsheet\" accept=\"{{ options.allowedTypes }}\" \nngf-change=\"vm.loadSpreadsheet(vm.spreadsheet)\" ngf-max-size=\"{{ options.maxSize }}\" ngf-multiple=\"false\" \nngf-allow-dir=\"false\" ng-disabled=\"vm.loading || disabled\"><div class=\"select-spreadsheet-flex\"><div flex \nlayout=\"column\" layout-align=\"center center\" class=\"description\" ng-show=\"!vm.spreadsheet\"><md-icon \nmd-font-icon=\"icon-upload mb-5\"></md-icon><span translate=\"CORE.FC_SPREADSHEET_READER.FILE.UPLOAD_MESSAGE\">\nClick or drag the template sheet to upload</span><div class=\"hint\"><span \ntranslate=\"CORE.FC_SPREADSHEET_READER.FILE.MAX_SIZE\" translate-values=\"{ maxSize: options.maxSize }\">\nThe maximum file size is {{ options.maxSize }}</span></div></div><div flex layout=\"column\" \nlayout-align=\"center center\" class=\"description\" ng-show=\"vm.spreadsheet && !vm.loading\"><md-icon \nmd-font-icon=\"icon-file-excel mb-5\"></md-icon><small>{{ vm.spreadsheet.name }}</small></div><div flex layout=\"column\" \nlayout-align=\"center center\" class=\"description\" ng-show=\"vm.spreadsheet && vm.loading\"><md-progress-circular \nclass=\"md-accent mb-5\" md-diameter=\"15\"></md-progress-circular><small class=\"font-size-12\" \ntranslate=\"CORE.FC_SPREADSHEET_READER.LOADING\" translate-attr-aria-label=\"CORE.FC_SPREADSHEET_READER.LOADING\">\nLoading...</small></div></div><div ng-messages=\"errorFile\"><span ng-message=\"size\" \ntranslate=\"CORE.FC_SPREADSHEET_READER.FILE.ERRORS.MAX_SIZE\">Size too large. </span><span ng-message=\"pattern\" \ntranslate=\"CORE.FC_SPREADSHEET_READER.FILE.ERRORS.PATTERN\">File type not allowed.</span></div></div>\n</md-input-container></div>");
$templateCache.put("app/core/directives/fc-spreadsheet-result/template/spreadsheet-result.html","<div id=\"fc-spreadsheet-result\" class=\"simple-table-container\" ms-scroll><md-progress-linear class=\"md-accent\" \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\"></md-progress-linear><div flex class=\"spreadsheet-review\" layout=\"row\" \nlayout-align=\"center center\"><div flex=\"80\" layout=\"row\" flex-layout=\"center center\"><div \nclass=\"spreadsheet-review__status\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-close\" \nng-if=\"!vm.loading && vm.invalidRowsPercentage > 0\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.REVIEW.STATUS.INVALID\">Invalid</span></md-tooltip></md-icon><md-icon \nclass=\"green-800-fg\" md-font-icon=\"icon-check\" ng-if=\"!vm.loading && vm.invalidRowsPercentage === 0\"><md-tooltip \nmd-direction=\"down\"><span translate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.REVIEW.STATUS.VALID\">Valid</span></md-tooltip>\n</md-icon></div><span class=\"spreadsheet-name\">{{ spreadsheet.file.name }}</span></div><div flex=\"20\" \nclass=\"spreadsheet-review__progress\" layout=\"row\" layout-align=\"center end\"><div flex><span \nclass=\"spreadsheet-review__progress__counter\" ng-if=\"vm.invalidRowsPercentage > 0\">{{ vm.invalidRowsCount }}<strong>\n/{{ vm.spreadsheet.rows.length }}</strong></span><md-tooltip ng-if=\"vm.invalidRowsPercentage > 0\"><span \ntranslate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.REVIEW.INVALID_ROWS_PERCENTAGE\" \ntranslate-values=\"{ invalidPercentage: (vm.invalidRowsPercentage | number: 2) }\">\n{{ vm.invalidRowsPercentage | number: 2 }}% of lines are inconsistent</span></md-tooltip><md-tooltip \nng-if=\"vm.invalidRowsPercentage === 0\"><span translate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.REVIEW.WITHOUT_INCONSISTENCY\">\nThere are no inconsistent rows in this spreadsheet</span></md-tooltip><md-progress-linear \nclass=\"valid-rows-percentage\" md-mode=\"determinate\" value=\"{{ vm.invalidRowsPercentage }}\"></md-progress-linear></div>\n</div></div><table ng-if=\"vm.invalidRowsPercentage > 0\" class=\"simple spreadsheet-rows-table\" ms-responsive-table>\n<thead class=\"fs-13\"><tr><th width=\"5%\"></th><th width=\"5%\" \ntranslate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.COLUMNS.VALIDATION\" \ntranslate-attr-aria-label=\"CORE.FC_SPREADSHEET_RESULT.TABLE.COLUMNS.VALIDATION\">Validation</th><th width=\"50%\" \ntranslate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.COLUMNS.ROW\" \ntranslate-attr-aria-label=\"CORE.FC_SPREADSHEET_RESULT.TABLE.COLUMNS.ROW\">Row</th><th width=\"40%\" \ntranslate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.COLUMNS.ERRORS_COUNT\" \ntranslate-attr-aria-label=\"CORE.FC_SPREADSHEET_RESULT.TABLE.COLUMNS.ERRORS_COUNT\">Errors</th></tr></thead><tbody \nclass=\"fs-13\"><tr class=\"cursor-pointer\" ng-repeat-start=\"row in vm.inspectedRows\" ng-if=\"!row.valid\" \nng-click=\"row.$expanded = !row.$expanded\"><td><md-icon class=\"grey-800-fg\" md-font-icon=\"icon-chevron-down\" \nng-if=\"!row.$expanded\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.ROWS.DETAILS.MORE\">Show more details</span></md-tooltip></md-icon><md-icon \nclass=\"grey-800-fg\" md-font-icon=\"icon-chevron-up\" ng-if=\"row.$expanded\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.ROWS.DETAILS.LESS\">Show less details</span></md-tooltip></md-icon></td><td>\n<md-icon class=\"red-500-fg\" md-font-icon=\"icon-close\" ng-if=\"!row.valid\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.ROWS.SPREADSHEET_STATUS.INVALID\">Invalid</span></md-tooltip></md-icon>\n<md-icon class=\"green-800-fg\" md-font-icon=\"icon-check\" ng-if=\"row.valid\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.ROWS.SPREADSHEET_STATUS.INVALID\">Valid</span></md-tooltip></md-icon></td>\n<td><span translate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.ROWS.DETAILS.ROW\" translate-values=\"{ rowNumber: $index + 2 }\">\nRow {{ $index + 2 }}</span></td><td>{{ row.error.length }}</td></tr><tr ng-if=\"row.$expanded\" ng-repeat-end><td \ncolspan=\"11\"><div class=\"pb-15\" ng-if=\"!row.valid\"><h3 class=\"text-bold pl-10\" \ntranslate=\"CORE.FC_SPREADSHEET_RESULT.TABLE.ROWS.DETAILS.INCONSISTENCIES\">Inconsistencies:</h3><ul><li \nng-repeat=\"error in row.error\"><b>{{ error.code }}:</b> <span>{{ error.message }}</span></li></ul></div><table \nclass=\"simple spreadsheet-rows-erros-table\" if=\"row.error.length\" ms-responsive-table><tbody class=\"fs-13\"><tr \nng-repeat=\"column in spreadsheet.columns\" ng-if=\"vm.columnHasError(row, column)\" class=\"invalid-column\"><td \nclass=\"font-weight-600\">{{ column }}</td><td width=\"90%\">{{ row.values[column].join(\', \') || row.values[column] }}</td>\n</tr></tbody></table></td></tr></tbody></table></div>");
$templateCache.put("app/core/directives/fc-subscription-module/template/fc-subscription-module.html","<div class=\"fc-subscription-module\"><div class=\"fc-subscription-module__preview\"><img src=\"{{previewUrl}}\" \nalt=\"{{moduleTitle}}\"></div><div class=\"fc-subscription-module__content\"><div \nclass=\"fc-subscription-module__content--text\"><h3 class=\"fc-subscription-module__content--text-title\">{{moduleTitle}}\n</h3><span class=\"fc-subscription-module__content--text-description\">{{moduleDescription}}</span></div><button \nng-if=\"!activedModule\" type=\"button\" \nclass=\"fc-subscription-module__content__button fc-subscription-module__content__button--state-new\" \ntranslate=\"FC_SUBSCRIPTION_MODULE.ACTIONS.CONTRACT_MODULE\" ng-click=\"vm.goToModule()\">Contratar módulo</button><div \nclass=\"fc-subscription-module__hired\" ng-if=\"activedModule\"><span \ntranslate=\"FC_SUBSCRIPTION_MODULE.ACTIONS.MANAGER_MODULE.TITLE\">Módulo já contratado</span> <button type=\"button\" \nclass=\"fc-subscription-module__content__button fc-subscription-module__content--button--state-signed\" \ntranslate=\"FC_SUBSCRIPTION_MODULE.ACTIONS.MANAGER_MODULE.BUTTON_TITLE\" ng-click=\"vm.goToModule()\">Gerenciar módulo\n</button></div></div></div>");
$templateCache.put("app/core/directives/fc-textarea/template/fc-textarea.html","<div class=\"fc-textarea\"><textarea class=\"fc-textarea__textarea {{vm.maxLength < 300 ? \'without-resize\' : \'\'}}\" \nname=\"{{inputName}}\" placeholder=\" \" autocomplete=\"off\" ng-model=\"ngModel\" ng-disabled=\"isDisabled\" \nng-class=\"{\n      disabled: isDisabled,\n      invalid: inputControl.$touched && inputControl.$invalid,\n    }\" \nng-required=\"isRequired\" ng-maxlength=\"vm.maxLength\" ng-minlength=\"vm.minLength\" ms-scroll \noninput=\"this.parentNode.dataset.replicatedValue = this.value\">\n  </textarea><label class=\"fc-textarea__label\">\n{{label}}</label><span class=\"fc-textarea__limit\">\n({{inputControl.$viewValue.length ? inputControl.$viewValue.length : 0}} / {{vm.maxLength}})</span><fc-error \nng-show=\"inputControl.$touched\" input-errors=\"inputControl.$error\" errors-to-watch=\"errorsToWatch\"></fc-error></div>");
$templateCache.put("app/core/directives/fc-toast/template/fc-toast.html","<div ng-repeat=\"error in vm.errorsQueue track by $index\" \nclass=\"fc-toast {{error.position ? error.position : \'BOTTOM LEFT\'}} {{error.customClass ? error.customClass : \'\'}} {{error.success ? \'success\' : \'\'}}\">\n<div class=\"fc-toast__icon-generic\"><md-icon \nmd-svg-src=\"{{ error.iconPath ? error.iconPath : \'assets/icons/warning-icon.svg\' }}\" \nng-class=\"{ centralized: !error.content }\"></md-icon></div><div class=\"fc-toast__title-container\"><h3 \nng-if=\"error.title\" class=\"fc-toast__title-container__title\" ng-class=\"{ centralized: !error.content }\">{{error.title}}\n</h3><p ng-if=\"error.content\" class=\"fc-toast__content\">{{error.content}}</p></div><div ng-if=\"!error.noExit\" \nclass=\"fc-toast__icon-close\"><md-icon md-font-icon=\"icon-close\" ng-click=\"vm.hideError()\"></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\" translate \ntranslate-attr-aria-label=\"CORE.MS_NAVIGATION.TOGGLE_MOBILE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\"></md-icon>\n</md-button></div><ul class=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n        <div class=\"ms-navigation-button\" ng-class=\"node.css\" ng-if=\"!node.uisref && node.title && !externalUrl\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <i class=\"icon s16 full-icon {{node.fullIcon}}\" ng-if=\"node.fullIcon\">\n                <img ng-src=\"assets/icons/navigation/{{ node.fullIcon }}.svg\" alt=\"\" srcset=\"\">\n            </i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title && !node.externalUrl\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <i class=\"icon s16 full-icon {{node.fullIcon}}\" ng-if=\"node.fullIcon\">\n                <img ng-src=\"assets/icons/navigation/{{ node.fullIcon }}.svg\" alt=\"\" srcset=\"\">\n            </i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n        <a class=\"ms-navigation-button\" href=\"{{node.uisref}}\" target=\"{{ node.newTab ? \'_blank\' : \'_self\' }}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.externalUrl && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <i class=\"icon s16 full-icon {{node.fullIcon}}\" ng-if=\"node.fullIcon\">\n                <img ng-src=\"assets/icons/navigation/{{ node.fullIcon }}.svg\" alt=\"\" srcset=\"\">\n            </i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/integrations/omie/configuration/omie-configuration-dialog.html","<md-dialog class=\"omie-configuration-dialog\" aria-label=\"Integration\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools align-vertical align-vertical-middle\"><span class=\"fs-18\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.CONFIGURATION_TITLE\" translate-value-app=\"Omie\">Omie Integration</span> <span flex>\n</span> <span flex></span><md-button class=\"md-icon-button margin-top-0\" ng-click=\"vm.closeDialog();\" \naria-label=\"Close Dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><h2 translate=\"CUSTOMERS.INTEGRATIONS.ENABLE_INTEGRATION\">Enable Integration</h2><p class=\"fs-16\">\n<span translate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL\" \ntranslate-values=\"{ appKey: \'App Key\', appSecret: \'App Secret\' }\"></span></p><ul class=\"ul-steps\"><li><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_1\">Click</span> <a \nhref=\"https://developer.omie.com.br/my-apps/\" target=\"_blank\"><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_2\">here</span></a>, <span \ntranslate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_3\">e faça login com sua conta Omie</span></li><li>\n<span translate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_4\">\nClick on the option with the name of your company/application</span></li><li><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_5\">\nCopy the information from App Key and App Secret and paste in the fields below</span></li><li><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_6\">Click Enable Integration and you\'re done :)\n</span></li></ul><div layout=\"row\"><md-input-container flex=\"40\"><label class=\"label\">App Key</label><input \nclass=\"input\" ng-change=\"vm.changedAppKey();\" ng-model=\"vm.appKey\" placeholder=\"Cole sua App Key aqui..\">\n</md-input-container><md-input-container flex=\"60\"><label class=\"label\">App Secret</label><input class=\"input\" \nng-change=\"vm.changedAppKey();\" ng-model=\"vm.appSecret\" placeholder=\"Cole sua App Secret aqui..\"></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.enableIntegration(vm.appKey, vm.appSecret);\" class=\"send-button md-accent md-raised\" \nng-disabled=\"!vm.hasValidAppKeys\" translate=\"CUSTOMERS.INTEGRATIONS.ACTIVATE_INTEGRATION\">Activate integration\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/absences/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"ABSENCES.FILTERS.TITLE\">Filter Absences</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"ABSENCES.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-absences\" ms-scroll><md-list><div class=\"filter-subtitle\"><span \ntranslate=\"ABSENCES.FILTERS.DATE.START\">Filter by start date</span></div><md-list-item><label \ntranslate=\"ABSENCES.FILTERS.DATE.FROM\">From:</label><md-datepicker ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.absencesFilters.startDateFrom\" md-placeholder=\"{{ \'ABSENCES.FILTERS.DATE.SELECT\' | translate }}\">\n</md-datepicker></md-list-item><md-list-item><label translate=\"ABSENCES.FILTERS.DATE.TO\">To:</label><md-datepicker \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.absencesFilters.startDateTo\" \nmd-placeholder=\"{{ \'ABSENCES.FILTERS.DATE.SELECT\' | translate }}\"></md-datepicker></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\"><span translate=\"ABSENCES.FILTERS.DATE.END\">Filter by end date</span></div>\n<md-list-item><label translate=\"ABSENCES.FILTERS.DATE.FROM\">From:</label><md-datepicker \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.absencesFilters.endDateFrom\" \nmd-placeholder=\"{{ \'ABSENCES.FILTERS.DATE.SELECT\' | translate }}\"></md-datepicker></md-list-item><md-list-item><label \ntranslate=\"ABSENCES.FILTERS.DATE.TO\">To:</label><md-datepicker ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.absencesFilters.endDateTo\" md-placeholder=\"{{ \'ABSENCES.FILTERS.DATE.SELECT\' | translate }}\">\n</md-datepicker></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"ABSENCES.FILTERS.REASON\">Search by reason</span></div><md-list-item><input flex \nplaceholder=\"Search by reason\" translate translate-attr-placeholder=\"ABSENCES.FILTERS.REASON\" type=\"text\" \nclass=\"pl-10 h-35 search-input\" ng-model=\"vm.absencesFilters.reason\" ng-change=\"vm.broadcastFilterUpdated();\">\n</md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span translate=\"ABSENCES.FILTERS.EMPLOYEE\">\nSearch by employee</span></div><md-list-item><input flex placeholder=\"Search by employee\" translate \ntranslate-attr-placeholder=\"ABSENCES.FILTERS.EMPLOYEE\" type=\"text\" class=\"pl-10 h-35 search-input\" \nng-model-options=\"{ debounce: 100 }\" ng-model=\"vm.employeeFilter\"></md-list-item><md-list-item class=\"member\" \nng-repeat=\"employee in vm.employees | filter: { name: vm.employeeFilter }\" \nng-click=\"vm.toggleInArray(employee.id, vm.absencesFilters.employees)\" aria-label=\"Toggle Member\"><div \nclass=\"avatar bg-grey\"><img alt=\"{{ employee.name }}\" class=\"avatar\" \nng-src=\"{{ employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\' }}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ employee.name }}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(employee.id, vm.absencesFilters.employees)\"></i></md-list-item></md-list>\n</md-content>");
$templateCache.put("app/main/audit-logs/dialogs/event-details/event-details-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium audit-logs-dialog\" aria-label=\"Audit log dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\" layout=\"row\" layout-align=\"space-between\">\n<span class=\"title\" translate=\"AUDIT_LOGS.DIALOGS.EVENT_DETAILS.TITLE\">Event details</span></div><div \nclass=\"sidebar-dialog__header__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"AUDIT_LOGS.DIALOGS.CLOSE\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><form name=\"auditLogForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><div class=\"tab-general\"><div flex layout=\"column\"><div flex class=\"event-data\" layout=\"column\"><fieldset \nclass=\"event-data__description\"><legend translate=\"AUDIT_LOGS.DIALOGS.EVENT_DETAILS.DESCRIPTION\">Description</legend><p\n ng-bind-html=\"vm.humanizeEvent()\"></p></fieldset><div flex=\"100\" layout=\"row\"><md-input-container \nng-if=\"vm.event.targetResource\" class=\"md-block\"><label \ntranslate=\"AUDIT_LOGS.DIALOGS.EVENT_DETAILS.FIELDS.RESOURCE_NAME.LABEL\">Resource</label><md-select ng-model=\"null\" \ndisabled=\"disabled\"><md-option value=\"null\"><span>\n{{ \'AUDIT_LOGS.DIALOGS.EVENT_DETAILS.FIELDS.RESOURCE_NAME.OPTIONS.\' + vm.event.targetResource | uppercase | translate }}\n</span></md-option></md-select></md-input-container><md-input-container ng-if=\"vm.event.targetResourceId\" \nclass=\"md-block hide-validation-error\"><label translate=\"AUDIT_LOGS.DIALOGS.EVENT_DETAILS.FIELDS.RESOURCE_ID.LABEL\">\nResource ID</label><input type=\"text\" ng-model=\"vm.event.targetResourceId\" disabled=\"disabled\"></md-input-container>\n<md-input-container ng-if=\"vm.event.action\" class=\"md-block\"><label \ntranslate=\"AUDIT_LOGS.DIALOGS.EVENT_DETAILS.FIELDS.ACTION.LABEL\">Operation</label><md-select ng-model=\"null\" \ndisabled=\"disabled\"><md-option value=\"null\"><span>\n{{ \'AUDIT_LOGS.DIALOGS.EVENT_DETAILS.FIELDS.ACTION.OPTIONS.\' + vm.event.action | translate }}</span></md-option>\n</md-select></md-input-container></div><div flex=\"100\" layout=\"row\"><md-input-container ng-if=\"vm.event.userName\" \nclass=\"md-block hide-validation-error\"><label translate=\"AUDIT_LOGS.DIALOGS.EVENT_DETAILS.FIELDS.USERNAME.LABEL\">\nTriggered by</label><input type=\"text\" ng-model=\"vm.event.userName\" disabled=\"disabled\"></md-input-container>\n<md-input-container ng-if=\"vm.event.userId\" class=\"md-block hide-validation-error\"><label \ntranslate=\"AUDIT_LOGS.DIALOGS.EVENT_DETAILS.FIELDS.USER_ID.LABEL\">User ID</label><input type=\"text\" \nng-model=\"vm.event.userId\" disabled=\"disabled\"></md-input-container><md-input-container ng-if=\"vm.event.userIp\" \nclass=\"md-block hide-validation-error\"><label translate=\"AUDIT_LOGS.DIALOGS.EVENT_DETAILS.FIELDS.USER_IP.LABEL\">User IP\n</label><input type=\"text\" ng-model=\"vm.event.userIp\" disabled=\"disabled\"></md-input-container></div><div flex=\"100\" \nlayout=\"row\"><md-input-container ng-if=\"vm.event.createdAt\" class=\"md-block\"><label \ntranslate=\"AUDIT_LOGS.DIALOGS.EVENT_DETAILS.FIELDS.CREATED_AT.LABEL\">Created at</label><md-datepicker \nng-model=\"vm.event.createdAt\" disabled=\"disabled\"></md-datepicker></md-input-container></div><div flex=\"100\"><code \nclass=\"event-data__code\">{{ vm.event.data }}</code></div></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/audit-logs/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.TITLE\">Filter Events</span><md-button ng-if=\"vm.auditLogsFilters.isOn()\" \nng-click=\"vm.auditLogsFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.CLEAR\">Clear</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"filter-events animate-slide-right\" ms-scroll><div class=\"filter-property-name mt-10\"><span \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.CREATED_AT\">Filter by date</span></div><md-list-item><label \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.FROM\">From:</label><md-datepicker \nng-change=\"vm.broadcastFilterUpdated()\" ng-model=\"vm.auditLogsFilters.createdAt[0]\" \nmd-placeholder=\"{{ \'AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item>\n<md-list-item><label translate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.TO\">To:</label><md-datepicker \nng-change=\"vm.broadcastFilterUpdated()\" ng-model=\"vm.auditLogsFilters.createdAt[1]\" \nmd-placeholder=\"{{ \'AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item>\n<md-divider></md-divider><div class=\"filter-property-name mt-10\"><span \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.USERNAME.LABEL\">Filter by user name</span></div><md-list-item><input \nflex class=\"search-input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by username\" translate \ntranslate-attr-placeholder=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.USERNAME.SEARCH\" \nng-model=\"vm.auditLogsFilters.userName\" ng-change=\"vm.broadcastFilterUpdated()\"></md-list-item><md-divider>\n</md-divider><div class=\"filter-property-name mt-10\"><span \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.USER_IP.LABEL\">Filter by user ip</span></div><md-list-item><input flex \nclass=\"search-input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by username\" translate \ntranslate-attr-placeholder=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.USER_IP.SEARCH\" ng-model=\"vm.auditLogsFilters.userIp\" \nng-change=\"vm.broadcastFilterUpdated()\"></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.RESOURCE_NAME.LABEL\">Filter by resource</span></div><md-list-item>\n<md-select class=\"w-100-percent mt-0 mb-0\" name=\"status\" ng-change=\"vm.broadcastFilterUpdated()\" \nng-model=\"vm.auditLogsFilters.targetResource\"><md-option value=\"null\"><span \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.RESOURCE_NAME.OPTIONS.ALL\">All</span></md-option><md-option \nvalue=\"users\"><span translate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.RESOURCE_NAME.OPTIONS.USERS\">Users</span></md-option>\n<md-option value=\"employees\"><span translate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.RESOURCE_NAME.OPTIONS.EMPLOYEES\">\nEmployees</span></md-option><md-option value=\"imports\"><span \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.RESOURCE_NAME.OPTIONS.IMPORTS\">Imports</span></md-option><md-option \nvalue=\"exports\"><span translate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.RESOURCE_NAME.OPTIONS.EXPORTS\">Exports</span>\n</md-option></md-select></md-list-item><md-divider></md-divider><div class=\"filter-property-name\"><span \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.ACTION.LABEL\">Filter by action</span></div><md-list-item class=\"label\" \nng-click=\"vm.toggleInArray(\'CREATED\', vm.auditLogsFilters.action)\"><p \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.ACTION.OPTIONS.CREATED\">Created</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'CREATED\', vm.auditLogsFilters.action)\"></i></md-list-item><md-list-item class=\"label\" \nng-click=\"vm.toggleInArray(\'UPDATED\', vm.auditLogsFilters.action)\"><p \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.ACTION.OPTIONS.UPDATED\">Updated</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'UPDATED\', vm.auditLogsFilters.action)\"></i></md-list-item><md-list-item class=\"label\" \nng-click=\"vm.toggleInArray(\'PASSWORD_CHANGED\', vm.auditLogsFilters.action)\"><p \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.ACTION.OPTIONS.PASSWORD_CHANGED\">Password changed</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(\'PASSWORD_CHANGED\', vm.auditLogsFilters.action)\"></i></md-list-item>\n<md-list-item class=\"label\" ng-click=\"vm.toggleInArray(\'ARCHIVED\', vm.auditLogsFilters.action)\"><p \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.ACTION.OPTIONS.ARCHIVED\">Archived</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'ARCHIVED\', vm.auditLogsFilters.action)\"></i></md-list-item><md-list-item class=\"label\" \nng-click=\"vm.toggleInArray(\'UNARCHIVED\', vm.auditLogsFilters.action)\"><p \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.ACTION.OPTIONS.UNARCHIVED\">Unarchived</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'UNARCHIVED\', vm.auditLogsFilters.action)\"></i></md-list-item><md-list-item class=\"label\" \nng-click=\"vm.toggleInArray(\'AUTHORIZATION_CHANGED\', vm.auditLogsFilters.action)\"><p \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.ACTION.OPTIONS.AUTHORIZATION_CHANGED\">Authorization changed</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(\'AUTHORIZATION_CHANGED\', vm.auditLogsFilters.action)\"></i></md-list-item>\n<md-list-item class=\"label\" ng-click=\"vm.toggleInArray(\'AUTHENTICATED\', vm.auditLogsFilters.action)\"><p \ntranslate=\"AUDIT_LOGS.SIDENAVS.FILTERS.FIELDS.ACTION.OPTIONS.AUTHENTICATED\">Authenticated</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'AUTHENTICATED\', vm.auditLogsFilters.action)\"></i></md-list-item></md-content>");
$templateCache.put("app/main/bootstrap/dialogs/how-to-register-employee/how-register-employee-dialog.html","<md-dialog class=\"form-dialog\" aria-label=\"{{\'BOOTSTRAP.DIALOG.HOW_INSTALL.TITLE\' | translate}}\" \nstyle=\"width: 299px;max-height: 700px\"><form name=\"noForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span class=\"title\" \ntranslate=\"BOOTSTRAP.DIALOG.HOW_INSTALL.TITLE\">Register employees</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding: 0px 0px 0px 0px !important\"><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"center center\" style=\"margin-top:-15px\"><iframe width=\"299\" height=\"533\" \nsrc=\"https://www.youtube.com/embed/KNjWptOcEco?rel=0&hl=pt-br&cc_load_policy=1&autoplay=1\" frameborder=\"0\" \nallowfullscreen></iframe></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/calendar/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"CALENDAR.FILTERS.TITLE\">Filter Tasks</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"Clear filters\" translate \ntranslaste-attr-aria-label=\"CALENDAR.FILTERS.CLEAR\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip \nmd-direction=\"left\"><span translate=\"CALENDAR.FILTERS.CLEAR\">Clear filters</span></md-tooltip></md-button></div>\n</md-toolbar><md-content class=\"animate-slide-right filter-calendar\" ms-scroll><md-list><md-list-item><input flex \nclass=\"search-input\" placeholder=\"Search by customer\" translate translate-attr-placeholder=\"CALENDAR.FILTERS.CUSTOMER\" \ntype=\"text\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.calendarTasksFilter.customersName\"></md-list-item><md-list-item><input flex class=\"search-input\" \nplaceholder=\"Search by number\" translate translate-attr-placeholder=\"CALENDAR.FILTERS.NUMBER\" type=\"text\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.calendarTasksFilter.activitiesIdentifier\"></md-list-item><md-divider></md-divider><div \nclass=\"filter-subtitle\"><span translate=\"CALENDAR.FILTERS.OS_TYPE.TITLE\">Filter OS type</span></div><md-list-item>\n<md-input-container><label ng-show=\"vm.calendarTasksFilter.length == 0\">\n{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_TYPE.SEARCH_LABEL\' | translate }}</label><md-select \nng-model=\"vm.calendarTasksFilter.services\" ng-model-options=\"{trackBy: \'$value.id\', debounce: 100}\" \nmd-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" ng-change=\"vm.broadcastFilterUpdated();\" \nmultiple=\"multiple\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_TYPE.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"service\" \nng-repeat=\"service in vm.servicesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">\n{{(service.name && service.name.length) > 40 ? service.name.substring(0,40) + \'...\' : service.name }}</md-option>\n</md-optgroup></md-select></md-input-container></md-list-item><md-divider ng-if=\"vm.labels && vm.labels.length > 0\">\n</md-divider><div ng-if=\"vm.labels && vm.labels.length > 0\" class=\"filter-subtitle\"><span \ntranslate=\"CALENDAR.FILTERS.LABELS\">Filter by labels</span></div><md-list-item class=\"label\" \nng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleInArray(label.id, vm.calendarTasksFilter.labels)\"><md-icon \nmd-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(label.id, vm.calendarTasksFilter.labels)\"></i></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\"><span translate=\"CALENDAR.FILTERS.SITUATIONS\">Filter by situation</span>\n</div><md-list-item class=\"label\" ng-repeat=\"activityStatus in vm.activitiesStatus\" \nng-click=\"vm.toggleInArray(activityStatus.name, vm.calendarTasksFilter.status)\"><md-icon \nmd-font-icon=\"{{activityStatus.icon}}\" ng-class=\"activityStatus.name + \'-fg\'\" class=\"label-icon\"></md-icon><p \nng-class=\"activityStatus.name + \'-fg\'\">{{activityStatus.description}}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(activityStatus.name, vm.calendarTasksFilter.status)\"></i></md-list-item><md-divider></md-divider><div \nclass=\"filter-subtitle\"><span translate=\"CALENDAR.FILTERS.EMPLOYEE.TITLE\">Filter by employee</span></div><md-list-item>\n<input flex class=\"search-input\" placeholder=\"Search by employee\" translate \ntranslate-attr-placeholder=\"CALENDAR.FILTERS.EMPLOYEE.SEARCH\" type=\"text\" ng-model-options=\"{ debounce: 100 }\" \nng-model=\"vm.employeeFilter\"></md-list-item><md-list-item class=\"member\" \nng-click=\"vm.toggleInArray(\'null\', vm.calendarTasksFilter.employees)\" aria-label=\"Toggle Member\"><div \nclass=\"avatar bg-grey\"><div class=\"mt-3\"><i class=\"icon icon-account-remove s25 c-white\"></i></div></div><p \nclass=\"member-name\" translate=\"CALENDAR.FILTERS.EMPLOYEE.EMPTY\">No employee</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'null\', vm.calendarTasksFilter.employees)\"></i></md-list-item><md-list-item class=\"member\" \nng-repeat=\"employee in vm.employees | filter: { name: vm.employeeFilter }\" \nng-click=\"vm.toggleInArray(employee.id, vm.calendarTasksFilter.employees)\" aria-label=\"Toggle Member\"><div \nclass=\"avatar bg-grey\"><img alt=\"{{employee.name}}\" class=\"avatar\" \nng-src=\"{{employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ employee.name }}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(employee.id, vm.calendarTasksFilter.employees)\"></i></md-list-item><md-divider>\n</md-divider></md-list></md-content>");
$templateCache.put("app/main/control-panel/dialogs/route-optimizer/route-optimizer-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large\" id=\"optimizer\" \naria-label=\"{{ \'CONTROL_PANEL.DIALOGS.ROUTERIZATION.TITLE\' | translate }}\"><md-toolbar class=\"sidebar-dialog__header\">\n<div class=\"sidebar-dialog__header__title\"><span ng-show=\"!vm.service.id\" class=\"fs-17\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.TITLE\">Employee Routing</span> <span ng-if=\"vm.roteirizationLoaded\" \nclass=\"limit-badge limit-badge__inverse ml-8\">{{vm.requestCount}} / {{vm.requestsQuota}}</span></div><div \nclass=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button margin-top-0\" ng-click=\"vm.closeDialog();\" \naria-label=\"Close Dialog\" translate translate-attr-aria-label=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.CLOSE_BUTTON\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><ms-form-wizard flex><md-tabs \nmd-selected=\"vm.currentStepIndex\" md-center-tabs=\"true\"><md-tab md-on-select=\"vm.goToStep(1)\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"!vm.enableStep2\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"vm.enableStep2\">1</span> <span \nclass=\"ms-form-wizard-step-text\" translate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.STEPS.EMPLOYEE\" \nng-class=\"{ \'step-blue-color\': vm.currentStepIndex >= 0 }\">Employee</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form wizard-step height-100p\" novalidate><div class=\"height-100p\" \nng-include=\"\'app/main/control-panel/dialogs/route-optimizer/templates/employees-selection.html\'\"></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"!vm.enableStep2\" md-on-select=\"vm.goToStep(2)\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"!vm.enableStep3\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"vm.enableStep3\">2</span> <span \nclass=\"ms-form-wizard-step-text\" translate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.STEPS.SETTINGS\" \nng-class=\"{ \'step-blue-color\': vm.currentStepIndex >= 1 }\">Settings</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" class=\"wizard-step height-100p\" novalidate><div class=\"height-100p\" \nng-include=\"\'app/main/control-panel/dialogs/route-optimizer/templates/configuration.html\'\"></div></form></md-tab-body>\n</md-tab><md-tab ng-disabled=\"!vm.enableStep3\" md-on-select=\"vm.goToStep(3)\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"!vm.finishedOptimization\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"vm.finishedOptimization\">3</span> <span class=\"ms-form-wizard-step-text\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.STEPS.ROUTING\" \nng-class=\"{ \'step-blue-color\': vm.currentStepIndex >= 2 }\">Routing</span></span></md-tab-label><md-tab-body \nclass=\"tab-step-3\"><form ng-if=\"!vm.isPreventAccount\" name=\"vm.wizardStep3\" class=\"wizard-step height-100p p-24\" \nnovalidate><div style=\"height: 75%\" ng-include=\"\'app/main/control-panel/dialogs/route-optimizer/templates/map.html\'\">\n</div></form><form ng-if=\"vm.isPreventAccount\" name=\"vm.wizardStep3\" class=\"wizard-step height-100p p-24\" novalidate>\n<div style=\"height: 50%\" ng-include=\"\'app/main/control-panel/dialogs/route-optimizer/templates/map.html\'\"></div><div \nclass=\"router-filters\"><div class=\"router-filters__filter mt-25\"><p \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.TASK_DISTRIBUTION\">Distribution of activities/p></p><div flex \nlayout=\"row\" class=\"router-filters__filter__content\"><div \nclass=\"fc-datepicker fc-datepicker--without-after-border fc-datepicker--change-border-color datepicker__container\"><div\n class=\"date-container\"><md-datepicker class=\"p-0\" flex name=\"initialDate\" md-min-date=\"vm.today\" \nng-model=\"vm.initialDate\" md-placeholder=\"{{ \'CONTROL_PANEL.DIALOGS.ROUTERIZATION.INITIAL_DATE\' | translate }}\" \nng-disabled=\"$root.loadingProgress\" md-hide-icons=\"calendar\" required></md-datepicker></div><fc-error \nng-show=\"vm.wizardStep3.initialDate.$touched\" input-errors=\"vm.wizardStep3.initialDate.$error\" \nerrors-to-watch=\"[\n                                    {\n                                        name: \'required\',\n                                        translate: \'CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.INITIAL_DATE_REQUIRED\'\n                                    }\n                                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div class=\"router-filters__filter__content__field\"><div \nclass=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" ng-pattern=\"\'\\\\d+\'\" \nng-change=\"vm.validateTasksPerDay()\" name=\"tasksPerDay\" ng-model=\"vm.tasksPerDay\" ng-disabled=\"$root.loadingProgress\" \nng-required=\"true\"><label class=\"fc-input__label\">\n{{ \'CONTROL_PANEL.DIALOGS.ROUTERIZATION.AMOUNT_OF_ACTIVITIES_PER_DAY\' | translate }}</label><fc-error \nng-show=\"vm.wizardStep3.tasksPerDay.$touched\" input-errors=\"vm.wizardStep3.tasksPerDay.$error\" \nerrors-to-watch=\"[\n                                    {\n                                        name: \'required\',\n                                        translate: \'CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.AMOUNT_OF_ACTIVITIES_PER_DAY_REQUIRED\'\n                                    },\n                                    {\n                                        name: \'pattern\',\n                                        translate: \'CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.AMOUNT_OF_ACTIVITIES_PER_DAY_PATTERN\'\n                                    },\n                                    {\n                                        name: \'min\',\n                                        translate: \'CONTROL_PANEL.DIALOGS.ROUTERIZATION.ERROR.AMOUNT_OF_ACTIVITIES_PER_DAY_MIN\'\n                                    }\n                                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div></div><div class=\"router-filters__filter mt-25\"><p \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.DAYS_OF_THE_WEEK.TITLE\">Days of the week</p><div \nclass=\"router-filters__filter__content\"><div class=\"router-filters__filter__content--grid\"><div \nclass=\"router-filters__filter__content__field--date\" layout=\"row\" layout-align=\"center center\" \nng-repeat=\"option in vm.daysOfTheWeek\"><md-checkbox class=\"md-primary checkbox-margin\" layout=\"row\" \nlayout-align=\"start center\" ng-model=\"option.checked\" ng-change=\"vm.changeSelectedWeekDays()\">{{ option.viewText }}\n</md-checkbox></div></div></div></div></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"fc-button fc-button--actions fc-button--back\" \nng-click=\"msWizard.previousStep(); vm.backStep()\" ng-disabled=\"vm.currentStep == 1\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.PREVIOUS_BUTTON\">Return</md-button><div class=\"steps\"><span \nng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':vm.currentStepIndex === $index}\"></span></div>\n<md-button class=\"fc-button fc-button--actions\" ng-click=\"vm.nextStep()\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.NEXT_BUTTON\" ng-show=\"!vm.finishedOptimization || vm.currentStep < 3\" \nng-disabled=\"\n                    vm.routerizationApiError ||\n                    !vm.selectedEmployee ||\n                    (vm.currentStep == 2 &&\n                    (vm.employeeScheduledTasks.length <= 2 || vm.taskGeolocationError || !vm.selectedRouteType || !vm.selectedTravelMode || !vm.selectedInitialDestination || !vm.selectedFinalDestination || vm.selectedFinalDestination === \'custom\' && !vm.customEndLocation)) ||\n                    (vm.loadingMap && vm.currentStep === 3)\">\nNext</md-button><md-button class=\"fc-button fc-button--actions confirm-button\" ng-click=\"vm.confirmOptimization();\" \nng-show=\"vm.finishedOptimization && vm.currentStep == 3\" \nng-disabled=\"msWizard.formsIncomplete() || !vm.showMap || vm.routerizationApiError || vm.currentStep < 3 || (vm.isPreventAccount && (vm.wizardStep3.$invalid || vm.wizardStep3.$pristine || !(vm.selectedWeekDays && vm.selectedWeekDays.length)))\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIRM_BUTTON\">Confirmar</md-button></div></ms-form-wizard></md-dialog>");
$templateCache.put("app/main/control-panel/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title\" \ntranslate=\"CONTROL_PANEL.FILTERS.TITLE\">Filter tasks</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"Clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"CONTROL_PANEL.FILTERS.CLEAR\">Clear</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"filter-control-panel\" ms-scroll><md-list><div class=\"filter-subtitle\" \ntranslate=\"CONTROL_PANEL.FILTERS.NAME.LABEL\">Filter by customer</div><md-list-item><input flex class=\"search-input\" \nplaceholder=\"Search by client\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.controlPanelFilters.customerName\" translate \ntranslate-attr-placeholder=\"CONTROL_PANEL.FILTERS.NAME.PLACEHOLDER\"></md-list-item><md-divider></md-divider><div \nclass=\"filter-subtitle\" translate=\"CONTROL_PANEL.FILTERS.LOCATION.LABEL\">Filter by location name</div><md-list-item>\n<input flex class=\"search-input\" placeholder=\"Search by Location\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.controlPanelFilters.locationName\" translate \ntranslate-attr-placeholder=\"CONTROL_PANEL.FILTERS.LOCATION.SEARCH\"></md-list-item><md-divider></md-divider><div \nclass=\"filter-subtitle\" translate=\"CONTROL_PANEL.FILTERS.CUSTOMER_LABEL.LABEL\">Filter by customer label</div>\n<md-list-item><md-select multiple=\"multiple\" class=\"w-100-percent mt-0 mb-0\" \nplaceholder=\"{{ \'CONTROL_PANEL.FILTERS.CUSTOMER_LABEL.SEARCH\' | translate }}\" type=\"text\" close-on-select=\"false\" \nng-model=\"vm.controlPanelFilters.customerLabels\" ng-change=\"vm.broadcastFilterUpdated();\" \nmd-on-close=\"vm.broadcastFilterUpdated()\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.customerLabelSearchTerm\" ng-keydown=\"$event.stopPropagation(); vm.searchLabels()\" type=\"search\" \nplaceholder=\"{{ \'CONTROL_PANEL.FILTERS.CUSTOMER_LABEL.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-repeat=\"label in vm.labelsFilterList\" ng-value=\"label\">{{ label.name }}\n</md-option></md-optgroup></md-select></md-list-item><div ng-if=\"vm.currentUrl === \'/painel-de-controle/listagem\'\">\n<md-divider></md-divider><div class=\"filter-subtitle\" translate=\"CONTROL_PANEL.FILTERS.ARCHIVED.LABEL\">Filter by status\n</div><md-list-item><md-select name=\"archived\" class=\"w-100-percent mt-0 mb-0\" ng-change=\"vm.broadcastFilterUpdated()\" \nng-model=\"vm.controlPanelFilters.archived\"><md-option value=\"null\"><span translate=\"VEHICLES.MODEL.ALL\">All</span>\n</md-option><md-option value=\"true\"><span translate=\"VEHICLES.MODEL.ARCHIVED_OPTIONS.ARCHIVED\">Unactive</span>\n</md-option><md-option value=\"false\"><span translate=\"VEHICLES.MODEL.ARCHIVED_OPTIONS.UNARCHIVED\">Active</span>\n</md-option></md-select></md-list-item></div><md-divider></md-divider><div class=\"filter-subtitle\" \ntranslate=\"CONTROL_PANEL.FILTERS.TASK.LABEL\">Filter by OS type</div><md-list-item><md-input-container><label \nng-show=\"vm.controlPanelFilters.length == 0\">{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_TYPE.SEARCH_LABEL\' | translate }}\n</label><md-select ng-model=\"vm.controlPanelFilters.services\" ng-model-options=\"{trackBy: \'$value.id\', debounce: 100}\" \nmd-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" ng-change=\"vm.broadcastFilterUpdated();\" \nmultiple=\"multiple\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_TYPE.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"service\" \nng-repeat=\"service in vm.servicesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">\n{{(service.name && service.name.length) > 40 ? service.name.substring(0, 40) + \'...\' : service.name}}</md-option>\n</md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\" \ntranslate=\"CONTROL_PANEL.FILTERS.DESCRIPTION.LABEL\">Filter by description</div><md-list-item><input flex \nclass=\"search-input\" placeholder=\"Search by description\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.controlPanelFilters.description\" translate \ntranslate-attr-placeholder=\"CONTROL_PANEL.FILTERS.DESCRIPTION.PLACEHOLDER\"></md-list-item><md-divider></md-divider><div\n class=\"filter-subtitle\" translate=\"CONTROL_PANEL.FILTERS.SITUATION.LABEL\">Filter by situation</div><md-list-item \nclass=\"label\" ng-repeat=\"activityStatus in vm.activitiesStatus\" \nng-click=\"vm.toggleInArray(activityStatus.value, vm.controlPanelFilters.status)\"><md-icon \nmd-font-icon=\"{{activityStatus.icon}}\" ng-class=\"activityStatus.name + \'-fg\'\" class=\"label-icon\"></md-icon><p \nng-class=\"activityStatus.name + \'-fg\'\">{{activityStatus.description}}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(activityStatus.value, vm.controlPanelFilters.status)\"></i></md-list-item><md-divider></md-divider><div\n class=\"filter-subtitle\" translate=\"CONTROL_PANEL.FILTERS.EMPLOYEE.LABEL\">Filter by employee</div><md-list-item \nclass=\"member\" ng-click=\"vm.toggleInArray(\'null\', vm.controlPanelFilters.employees)\" \naria-label=\"{{ \'CONTROL_PANEL.FILTERS.EMPLOYEE.TOGGLE\' | translate }}\"><div class=\"avatar bg-grey\"><div class=\"mt-3\"><i\n class=\"icon icon-account-remove s25 c-white\"></i></div></div><p class=\"member-name\" \ntranslate=\"CONTROL_PANEL.FILTERS.EMPLOYEE.NO_EMPLOYEE\">No employee</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'null\', vm.controlPanelFilters.employees)\"></i></md-list-item><md-list-item class=\"member\" \nng-repeat=\"employee in vm.employees | filter: { name: vm.employeeFilter } | orderBy: (vm.account.configuration.ganttEmployeesSortBy === \'alphabetically\' ? \'name\' : \'position\')\" \nng-click=\"vm.toggleInArray(employee.id, vm.controlPanelFilters.employees)\" \naria-label=\"{{ \'CONTROL_PANEL.FILTERS.EMPLOYEE.TOGGLE\' | translate }}\"><div class=\"avatar bg-grey\"><img class=\"avatar\" \nng-src=\"{{employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"><div ng-if=\"vm.employeeStatusEnabled\" \nng-class=\"vm.getEmployeeStatusClass(employee);\" class=\"avatar-status\"></div></div><p class=\"member-name\">\n{{ employee.name }}</p><i class=\"icon-check s16\" ng-if=\"vm.exists(employee.id, vm.controlPanelFilters.employees)\"></i>\n</md-list-item><md-divider ng-if=\"vm.labels && vm.labels.length > 0\"></md-divider><div \nng-if=\"vm.labels && vm.labels.length > 0\" class=\"filter-subtitle\" translate=\"CONTROL_PANEL.FILTERS.LABELS.LABEL\">\nFilter by labels</div><md-list-item ng-if=\"vm.labels && vm.labels.length > 0\" class=\"label\" \nng-click=\"vm.toggleInArray(\'null\', vm.controlPanelFilters.labels)\"><md-icon md-font-icon=\"icon-label-outline\" \nclass=\"label-icon\"></md-icon><p translate=\"CONTROL_PANEL.FILTERS.LABELS.NO_LABELS\">Without label</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(\'null\', vm.controlPanelFilters.labels)\"></i></md-list-item><md-list-item \nclass=\"label\" ng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleInArray(label.id, vm.controlPanelFilters.labels)\">\n<md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(label.id, vm.controlPanelFilters.labels)\"></i></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\" translate=\"CONTROL_PANEL.FILTERS.RATING.LABEL\">Filter by rating</div>\n<md-list-item class=\"label\" ng-repeat=\"rating in vm.ratings\" \nng-click=\"vm.toggleInArray(rating.stars, vm.controlPanelFilters.ratings)\"><p ng-if=\"rating.stars === 0\" \ntranslate=\"CONTROL_PANEL.FILTERS.RATING.NO_RATING\">No rating</p><p ng-if=\"rating.stars > 0\" class=\"stars-row\"><i \nng-class=\"rating.stars >= 1 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 2 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 3 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 4 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i> <i \nng-class=\"rating.stars >= 5 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20 star-color\"></i></p><p \nclass=\"rating-name\">{{ rating.name }}</p><p></p><i class=\"icon-check s16\" \nng-if=\"vm.exists(rating.stars, vm.controlPanelFilters.ratings)\"></i></md-list-item></md-list></md-content>");
$templateCache.put("app/main/control-panel/views/gantt/gantt.html","<div id=\"gantt-chart\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div id=\"zoom-control\" style=\"padding: 9px 9px\" class=\"zoom\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"label\"><md-icon md-font-icon=\"icon-magnify\"><md-tooltip md-direction=\"bottom\">\n<span translate=\"CONTROL_PANEL.VIEWS.GANTT.ZOOM_CONTROL.TOOLTIP\">Zoom Control</span></md-tooltip></md-icon></span><div \nclass=\"input-wrapper\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.GANTT.ZOOM_CONTROL.ZOOM_OUT\' | translate }}\" ng-click=\"vm.decreaseGanttZoom();\">\n<md-icon md-font-icon=\"icon-minus\"></md-icon></md-button><input style=\"width: 50px; text-align: center\" \ndisabled=\"disabled\" ng-model=\"vm.ganttOptions.zoom\"><md-button class=\"md-icon-button\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.GANTT.ZOOM_CONTROL.ZOOM_IN\' | translate }}\" ng-click=\"vm.increaseGanttZoom();\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div class=\"divider-vertical\"></div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.GANTT.DRAW\' | translate }}\"><md-icon md-font-icon=\"icon icon-dots-horizontal\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.enableDrawingTasks();\" \nng-disabled=\"vm.accountConfiguration.featureDisableAddTask\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon><span translate=\"CONTROL_PANEL.VIEWS.GANTT.CREATE_TASK_TIMELINE\">\nCreate task through the timeline </span>&nbsp; <small style=\"color:grey\" \ntranslate=\"CONTROL_PANEL.VIEWS.GANTT.DRAG_AND_DROP\">(drag and drop)</small></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"divider-vertical\"></div><md-checkbox class=\"m-5 ml-10i\" \nng-model=\"vm.ganttOptions.canDrag\" ng-change=\"vm.toggleCanDrag()\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.GANTT.ALLOW_DRAGGING_TASKS\' | translate }}\"><span \ntranslate=\"CONTROL_PANEL.VIEWS.GANTT.ALLOW_DRAGGING_TASKS\">Allow dragging tasks</span></md-checkbox><div \nclass=\"divider-vertical\"></div><md-switch ng-model=\"vm.ganttOptions.inAutoload\" ng-change=\"vm.toggleAutoload()\" \naria-label=\"{{ \'CONTROL_PANEL.AUTOUPDATE\' | translate }}\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CONTROL_PANEL.AUTOUPDATE_TOOLTIP\">Update the timeline every 2 minutes</span></md-tooltip><span \ntranslate=\"CONTROL_PANEL.AUTOUPDATE\">Update periodically</span></md-switch><md-switch \nng-if=\"vm.ganttOptions.canDrag && vm.editPermission\" ng-model=\"vm.ganttOptions.dragAlterTime\" \nng-change=\"vm.toggleDragAlterTime()\" aria-label=\"{{ \'CONTROL_PANEL.DRAG_ALTER_TIME\' | translate }}\"><md-tooltip \nmd-direction=\"bottom\"><span translate=\"CONTROL_PANEL.DRAG_ALTER_TIME_TOOLTIP\">\nChange the scheduling time of unscheduled activities when dragging, instead of just moving their position</span>\n</md-tooltip><span translate=\"CONTROL_PANEL.DRAG_ALTER_TIME\">\nChange scheduling time for unscheduled activities when dragging</span></md-switch></div><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"space-between stretch\"><div class=\"p-16\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.stats && !vm.data.options.isPastOrTodayDate && false\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"pr-20\"><md-icon md-font-icon=\"icon-home-variant\" class=\"icon mr-8 s20\"><md-tooltip \nmd-direction=\"bottom\"><span translate=\"CONTROL_PANEL.VIEWS.GANTT.TOTAL_TIME_TASKS.TOOLTIP\">\nTotal time spent on tasks is the sum of minutes spent on tasks.</span></md-tooltip></md-icon><span \ntranslate=\"CONTROL_PANEL.VIEWS.GANTT.TOTAL_TIME_TASKS.LABEL\">Total time in tasks: </span><span \nclass=\"secondary-text ml-5\"><b>{{vm.stats.totalTaskCost}}</b></span></div><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-right: 20px\"><md-icon md-font-icon=\"icon-car\" class=\"icon mr-8 s20\">\n<md-tooltip md-direction=\"bottom\"><span translate=\"CONTROL_PANEL.VIEWS.GANTT.TOTAL_TIME_TRAVEL.TOOLTIP\">\nTotal travel time is the sum of the minutes spent traveling.</span></md-tooltip></md-icon><span \ntranslate=\"CONTROL_PANEL.VIEWS.GANTT.TOTAL_TIME_TRAVEL.LABEL\">Total travel time: </span><span \nclass=\"secondary-text ml-5\"><b>{{vm.stats.totalRouteCost}}</b></span></div><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-right: 20px\"><md-icon md-font-icon=\"icon-timer-sand\" class=\"icon mr-8 s20\">\n<md-tooltip md-direction=\"bottom\"><span translate=\"CONTROL_PANEL.VIEWS.GANTT.AVAILABLE_TIME.TOOLTIP\">\nTime available results from subtracting total time less time in tasks less time in commuting.</span></md-tooltip>\n</md-icon><span translate=\"CONTROL_PANEL.VIEWS.GANTT.AVAILABLE_TIME.LABEL\">Available time: </span><span \nclass=\"secondary-text ml-5\"><b>{{vm.stats.availableCapacity}}</b></span></div><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-right: 20px\"><md-icon md-font-icon=\"icon-clock\" class=\"icon mr-8 s20\">\n<md-tooltip md-direction=\"bottom\"><span translate=\"CONTROL_PANEL.VIEWS.GANTT.TOTAL_TIME_SUM.TOOLTIP\">\nTotal time is the sum of available time per day for each employee.</span></md-tooltip></md-icon><span \ntranslate=\"CONTROL_PANEL.VIEWS.GANTT.TOTAL_TIME_SUM.LABEL\">Total time: </span><span class=\"secondary-text ml-5\"><b>\n{{vm.stats.totalCapacity}}</b></span></div></div></div></div></div><md-content id=\"chart-container\" class=\"content\" \nflex layout=\"column\" ms-scroll><div id=\"loader-gantt-tasks\" class=\"loading-gantt-tasks\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.ganttData.length == 0\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \ntranslate=\"CONTROL_PANEL.VIEWS.GANTT.CONTENT.LOADING\">Loading tasks...</div></div><div layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.warningEmployee === true\"><div flex layout-fill class=\"text-center f16\"><p \ntranslate=\"CONTROL_PANEL.VIEWS.GANTT.CONTENT.NO_EMPLOYEE_ADDED\">\nNo employee has yet been added to your external team or there are no assets on that date.</p><p><span \ntranslate=\"CONTROL_PANEL.VIEWS.GANTT.CONTENT.ADD_FIRST_EMPLOYEE.TEXT\">Add the first employee in the top right <b>\nEmployees </b>menu or click </span>&nbsp; <span class=\"clickable\" ng-click=\"vm.createEmployee($event);\"><b \ntranslate=\"CONTROL_PANEL.VIEWS.GANTT.CONTENT.ADD_FIRST_EMPLOYEE.HERE\">here </b>.</span></p></div></div><div flex \nlayout-fill gantt id=\"gantt-tasks\" data=\"vm.ganttData\" filter-task=\"vm.ganttOptions.filterTask\" \nfilter-row=\"vm.ganttOptions.filterRow\" options=\"vm.ganttOptions\" \ncolumn-width=\"vm.getColumnWidth(vm.ganttOptions.zoom)\" current-date-value=\"vm.ganttOptions.currentDateValue\" \nfrom-date=\"vm.ganttOptions.fromDate\" to-date=\"vm.ganttOptions.toDate\"><gantt-table headers=\"\'\'\" \ncolumns=\"vm.ganttOptions.columns\"></gantt-table><gantt-bounds></gantt-bounds><gantt-progress></gantt-progress>\n<gantt-tooltips enabled=\"true\" date-format=\"vm.dateFormat\" \ntemplate-url=\"app/main/control-panel/views/gantt/override/tooltip.tmpl.html\"></gantt-tooltips><gantt-movable \nenabled=\"vm.ganttOptions.canDrag && vm.editPermission\" allow-moving=\"true\" allow-resizing=\"false\" \nallow-row-switching=\"true\"></gantt-movable><gantt-draw-task enabled=\"vm.ganttOptions.canDraw\" \ntask-factory=\"vm.ganttOptions.drawTaskFactory\"></gantt-draw-task><gantt-resize-sensor></gantt-resize-sensor></div>\n</md-content></div>");
$templateCache.put("app/main/control-panel/views/list/list.html","<div id=\"mail\" layout=\"row\"><div ng-class=\"vm.currentView\" class=\"content-tasks-of-day\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\"></div></div>");
$templateCache.put("app/main/control-panel/views/main/main.html","<div id=\"boards\" class=\"md-field-control-800-bg\" layout=\"column\" flex><div id=\"board-selector\" layout=\"column\" \nlayout-align=\"start center\" flex><h1 translate=\"CONTROL_PANEL.VIEWS.MAIN.TITLE\">Control panel</h1><div \nclass=\"board-list\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"board-list-item md-white-bg\" \nlayout=\"column\" layout-align=\"center center\" ui-sref=\"app.control-panel.gantt\"><md-icon \nmd-font-icon=\"icon-playlist-minus\" class=\"icon s64 md-accent-fg\"></md-icon><div class=\"board-name\" \ntranslate=\"CONTROL_PANEL.VIEWS.MAIN.TIMELINE\">Timeline</div></div><div class=\"board-list-item md-white-bg\" \nlayout=\"column\" layout-align=\"center center\" ui-sref=\"app.control-panel.map\"><md-icon md-font-icon=\"icon-map\" \nclass=\"icon s64 md-accent-fg\"></md-icon><div class=\"board-name\" translate=\"CONTROL_PANEL.VIEWS.MAIN.MAP\">Map</div>\n</div><div class=\"board-list-item md-white-bg\" layout=\"column\" layout-align=\"center center\" \nui-sref=\"app.control-panel.list\"><md-icon md-font-icon=\"icon-view-list\" class=\"icon s64 md-accent-fg\"></md-icon><div \nclass=\"board-name\" translate=\"CONTROL_PANEL.VIEWS.MAIN.LIST\">Listing</div></div></div></div></div>");
$templateCache.put("app/main/control-panel/views/map/map.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-switch style=\"margin-left:10px\" md-no-ink ng-model=\"vm.mapFitOn\" ng-change=\"vm.changeMapFit();\" \naria-label=\"{{\'CONTROL_PANEL.VIEWS.MAP.CENTRALIZE\' | translate}}\"><span class=\"md-subhead fs-13\" \ntranslate=\"CONTROL_PANEL.VIEWS.MAP.CENTRALIZE\">Centralize</span></md-switch><div class=\"divider-vertical\"></div>\n<md-switch style=\"margin-left:10px\" md-no-ink ng-model=\"vm.clusterOn\" ng-change=\"vm.changedClusterMode();\" \naria-label=\"{{\'CONTROL_PANEL.VIEWS.MAP.GROUP_VISITS\' | translate}}\"><span class=\"md-subhead fs-13\" \ntranslate=\"CONTROL_PANEL.VIEWS.MAP.GROUP_VISITS\">Group visits</span></md-switch><div class=\"divider-vertical\"></div>\n<md-switch ng-model=\"vm.mapAutoUpdate\" ng-change=\"vm.mapAutoUpdateChanged()\" style=\"margin-left:10px\" \naria-label=\"{{ \'CONTROL_PANEL.AUTOUPDATE\' | translate }}\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CONTROL_PANEL.MAP_AUTOUPDATE_TOOLTIP\">Update the map every 2 minutes</span></md-tooltip><span \ntranslate=\"CONTROL_PANEL.AUTOUPDATE\">Update periodically</span></md-switch></div><div layout=\"row\" class=\"inset\" \nlayout-align=\"start center\"></div></div><md-content data-cy=\"mapa-body\" class=\"content control-panel-map\" \nstyle=\"border-bottom: 1px solid #ccc\" flex layout=\"column\"><div style=\"position: relative; height: 100%; width: 100%\">\n<leaflet id=\"controlPanelMap\" markers=\"vm.map.markers\" lf-center=\"vm.map.center\" legend=\"vm.map.legend\" \ncontrols=\"vm.map.controls\" layers=\"vm.map.layers\" height=\"100%\" width=\"100%\"></leaflet></div></md-content>");
$templateCache.put("app/main/customers/dialogs/omie-manual-import/omie-manual-import-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large task-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.IMPORTS.TITLE\" translate-value-app=\"Omie\">Import customers from Omie</span></div><div\n class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"import-customers\" ms-scroll><info-component-provider\n text=\"{{ \'CUSTOMERS.INTEGRATIONS.OMIE.FILTERS.INFO\' | translate }}\"></info-component-provider><div layout=\"row\"><div \nlayout=\"column\" class=\"import-customers__search-bar\"><div class=\"search-bar\" layout=\"row\" flex=\"100\"><div \nclass=\"fc-input\" flex=\"100\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--search\" ng-model=\"vm.nameContains\" ng-change=\"vm.onSearchChange()\" \nng-model-options=\"{ debounce: 500 }\" ng-disabled=\"false\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.SEARCH_CUSTOMER\">Search for an customer</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div></div><small class=\"search-bar__hint mt-5\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.OMIE.FILTERS.SEARCH_BY\"></small></div><fc-select \nclass=\"fc-select__select--change-border-color import-customers__select\" \nlabel=\"{{(\'CUSTOMERS.INTEGRATIONS.OMIE.FILTERS.FILTER_BY\' | translate)}}\" options=\"vm.filterTypes\" \nng-model=\"vm.filterType\" input-name=\"filterType\" track-by=\"name\" is-required=\"true\"></fc-select></div><div \nlayout=\"column\"><div layout=\"row\" flex=\"100\" layout-align=\"space-between center\" class=\"import-customers__header\"><div>\n<span class=\"import-customers__header__title\" flex=\"20\">\n{{ \'CUSTOMERS.INTEGRATIONS.IMPORTS.FOUND_CUSTOMERS\' | translate }} ({{vm.totalCount}})</span></div></div><div \nng-if=\"$root.loadingProgress && vm.isLoadingCustomers\" class=\"loading-gantt-tasks\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div><div ng-repeat=\"customer in vm.allCustomers\" layout-xs=\"column\" layout=\"row\" flex=\"100\" \nng-if=\"vm.totalCount && !vm.isLoadingCustomers\" class=\"b brad-4 mb-10 import-customers__item\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h-70 w-70 brad-4 ml-20\" \nng-if=\"customer.imageUrl\"><img ng-src=\"{{ customer.imageUrl | mumakil }}\" alt=\"{{ customer.name }}\" \nclass=\"import-customers__image\"></div><div layout=\"row\" class=\"border h-70 w-70 brad-4 ml-20\" \nlayout-align=\"center center\" ng-if=\"!customer.imageUrl\"><img src=\"assets/icons/no-image_gray.svg\"></div><div flex=\"80\" \nclass=\"ph-24 import-customers__customer\"><span class=\"import-customers__customer__title\">{{ customer.name }}</span> \n<span ng-if=\"customer.documentNumber\">{{ customer.documentNumber }}</span></div></div><div \nclass=\"import-customers__import ph-10\"><md-icon ng-if=\"customer.selected\" \nmd-svg-src=\"/assets/icons/icon-imported-success.svg\"></md-icon><md-button class=\"import-customers__import__action\" \nng-if=\"!customer.selected && customer.updating\" ng-click=\"vm.updateCustomer(customer)\">\n{{ \'CORE.SUBSCRIPTION_DIALOG.UPDATE\' | translate }}</md-button><md-button class=\"import-customers__import__action\" \nng-if=\"!customer.selected && !customer.updating\" ng-click=\"vm.importCustomer(customer)\">\n{{ \'CUSTOMERS.INTEGRATIONS.IMPORTS.IMPORT_BUTTON\' | translate }}</md-button></div></div></div><div \nclass=\"import-customers__table-navigation\" layout=\"row\" layout-align=\"end center\" ng-if=\"vm.nameContains.length < 3\">\n<div class=\"import-customers__table-navigation__info\" id=\"table-list_info\" aria-live=\"polite\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((vm.currentPage - 1) * vm.limitPerPage) + 1 }} <span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.TO\">to\n</span> {{ vm.currentPage * vm.limitPerPage > vm.totalCount ? vm.totalCount : vm.currentPage * vm.limitPerPage }} <span\n translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.OF\">of</span> {{ vm.totalCount }} <span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.RECORDS\">records</span></div><button \nclass=\"import-customers__table-navigation__button-previous\" ng-click=\"vm.navigateToPage(false)\" \nng-disabled=\"vm.currentPage === 1 || ($root.loadingProgress || vm.isLoadingCustomers)\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.PREVIOUS\">Previous</span></button> <button \nclass=\"import-customers__table-navigation__button-next\" ng-click=\"vm.navigateToPage(true)\" \nng-disabled=\"vm.currentPage * vm.limitPerPage >= vm.totalCount || ($root.loadingProgress || vm.isLoadingCustomers)\">\n<span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.NEXT\">Next</span></button></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/customers/dialogs/templates/share-attachment.template.html","<md-checkbox ng-model=\"vm.variables.isToHideShareAttachmentMessageConfirmation\" \nng-change=\"vm.variables.handleCheck(vm.variables.isToHideShareAttachmentMessageConfirmation)\"><md-checkbox-label \nstyle=\"font-size: 14px;color: #757575;margin-top: 3px;display: block\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.SHARE_ATTACHMENTS_WITH_CLIENT.CONFIRMATION_DIALOG.NOT_SHOW_AGAIN\">\nNot show again</md-checkbox-label></md-checkbox>");
$templateCache.put("app/main/deadline-contracts/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"DEADLINE-CONTRACTS.FILTERS.TITLE\">Filter Contracts</span><md-button \nng-if=\"vm.deadlineContractsFilters.isOn()\" ng-click=\"vm.deadlineContractsFilters.clear()\" class=\"md-icon-button\" \naria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"DEADLINE-CONTRACTS.FILTERS.CLEAR\">Clear</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-quotations\" ms-scroll><md-list-item><input flex class=\"search-input\" type=\"text\" \nng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by name\" translate \ntranslate-attr-placeholder=\"DEADLINE-CONTRACTS.FILTERS.NAME\" ng-model=\"vm.deadlineContractsFilters.name\" \nng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider><md-list-item><input flex \nclass=\"search-input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by name\" translate \ntranslate-attr-placeholder=\"DEADLINE-CONTRACTS.FILTERS.DESCRIPTION\" ng-model=\"vm.deadlineContractsFilters.description\" \nng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"DEADLINE-CONTRACTS.FILTERS.STATE.TITLE\">Filter by state</span></div><md-list-item><md-select \nclass=\"w-100-percent mt-0 mb-0\" name=\"archived\" ng-change=\"vm.broadcastFilterUpdated()\" \nng-model=\"vm.deadlineContractsFilters.archived\"><md-option translate=\"DEADLINE-CONTRACTS.FILTERS.STATE.ALL\" value=\"-1\">\nAll</md-option><md-option translate=\"DEADLINE-CONTRACTS.FILTERS.STATE.ACTIVE\" value=\"0\">Active</md-option><md-option \ntranslate=\"DEADLINE-CONTRACTS.FILTERS.STATE.ARCHIVED\" value=\"1\">Archived</md-option></md-select></md-list-item>\n</md-content>");
$templateCache.put("app/main/deadline-violations-reasons/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.TITLE\">Filter violation reason</span><md-button \nng-if=\"vm.deadlineViolationsReasonsFilters.isOn()\" ng-click=\"vm.deadlineViolationsReasonsFilters.clear()\" \nclass=\"md-icon-button\" aria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip \nmd-direction=\"left\"><span translate=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.CLEAR\">Clear</span></md-tooltip></md-button>\n</div></md-toolbar><md-content class=\"animate-slide-right filter-grounds-violation\" ms-scroll><md-list-item><input \nflex class=\"search-input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by name\" translate \ntranslate-attr-placeholder=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.NAME\" \nng-model=\"vm.deadlineViolationsReasonsFilters.name\" ng-change=\"vm.broadcastFilterUpdated();\"></md-list-item>\n<md-divider></md-divider><md-list-item><input flex class=\"search-input\" type=\"text\" \nng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by name\" translate \ntranslate-attr-placeholder=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.DESCRIPTION\" \nng-model=\"vm.deadlineViolationsReasonsFilters.description\" ng-change=\"vm.broadcastFilterUpdated();\"></md-list-item>\n<md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.STATE.TITLE\">Filter by state</span></div><md-list-item><md-select \nclass=\"w-100-percent mt-0 mb-0\" name=\"archived\" ng-change=\"vm.broadcastFilterUpdated()\" \nng-model=\"vm.deadlineViolationsReasonsFilters.archived\"><md-option \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.STATE.ALL\" value=\"-1\">All</md-option><md-option \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.STATE.ACTIVE\" value=\"1\">Active</md-option><md-option \ntranslate=\"DEADLINE-VIOLATIONS-REASONS.FILTERS.STATE.ARCHIVED\" value=\"0\">Archived</md-option></md-select>\n</md-list-item></md-content>");
$templateCache.put("app/main/devices/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"DEVICES.FILTER\">Filter devices</span><md-button ng-if=\"vm.devicesFilters.isOn()\" \nng-click=\"vm.devicesFilters.clear()\" class=\"md-icon-button\" aria-label=\"Clear filters\" translate \ntranslate-attr-aria-label=\"Clear filters\" data-cy=\"devices-clear-filters-button\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"DEVICES.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-employees\" ms-scroll><div class=\"filter-subtitle\" \ntranslate=\"DEVICES.FILTERS.IDENTIFIER\">Filter identifier</div><md-list-item><input flex class=\"search-input\" \ntype=\"text\" translate translate-attr-placeholder=\"DEVICES.FILTERS.IDENTIFIER\" ng-model-options=\"{ debounce: 500 }\" \nng-model=\"vm.devicesFilters.uuid\" ng-change=\"vm.broadcastFilterUpdated();\" data-cy=\"devices-filters.identifier\">\n</md-list-item><md-divider></md-divider><div class=\"filter-subtitle\" translate=\"DEVICES.FILTERS.MANUFACTURER\">\nFilter manufacturer</div><md-list-item><input flex class=\"search-input\" type=\"text\" translate \ntranslate-attr-placeholder=\"DEVICES.FILTERS.MANUFACTURER\" ng-model-options=\"{ debounce: 500 }\" \nng-model=\"vm.devicesFilters.manufacturer\" data-cy=\"devices-filters.manufacturer\" \nng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\" \ntranslate=\"DEVICES.FILTERS.EMPLOYEE.LABEL\">Filter by employee</div><md-list-item><md-select class=\"mt-0 w-100-percent\" \nng-change=\"vm.typeUpdated()\" ng-model=\"vm.devicesFilters.type\" data-cy=\"devices-filters.employeesTypes\"><md-option \nng-value=\"null\">{{ \'DEVICES.FILTERS.EMPLOYEE.TYPES\' | translate }}</md-option><md-option \nng-repeat=\"type in vm.employeesTypes\" ng-value=\"type\" data-cy=\"devices-filters.employeeTypes\">\n{{ \'DEVICES.FILTERS.EMPLOYEE.\' + type + \'_OPTION\' | uppercase | translate }}</md-option></md-select></md-list-item>\n<md-list-item ng-if=\"vm.currentType === \'All\'\"><md-select class=\"mt-0 w-100-percent\" name=\"lastSeenWith\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.devicesFilters.last_seen_with\" \ndata-cy=\"devices-filters.employees\"><md-option ng-value=\"null\">{{ \'DEVICES.FILTERS.EMPLOYEE.ALL_OPTION\' | translate }}\n</md-option><md-option ng-repeat=\"employee in vm.employees\" ng-value=\"employee.name\" \ndata-cy=\"devices-filters.employee\">{{ employee.name }}</md-option></md-select></md-list-item><md-list-item \nng-if=\"vm.currentType === \'Active\'\"><md-select class=\"mt-0 w-100-percent\" name=\"lastSeenWithActive\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.devicesFilters.last_seen_with\" \ndata-cy=\"devices-filters.employees\"><md-option ng-value=\"null\">\n{{ \'DEVICES.FILTERS.EMPLOYEE.ACTIVE_OPTION\' | translate }}</md-option><md-option \nng-repeat=\"employee in vm.activeEmployees\" ng-value=\"employee.name\" data-cy=\"devices-filters.employee\">\n{{ employee.name }}</md-option></md-select></md-list-item><md-list-item ng-if=\"vm.currentType === \'Unactive\'\">\n<md-select class=\"mt-0 w-100-percent\" name=\"lastSeenWithUnactive\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.devicesFilters.last_seen_with\" data-cy=\"devices-filters.employees\"><md-option ng-value=\"null\">\n{{ \'DEVICES.FILTERS.EMPLOYEE.UNACTIVE_OPTION\' | translate }}</md-option><md-option \nng-repeat=\"employee in vm.unactiveEmployees\" ng-value=\"employee.name\" data-cy=\"devices-filters.employee\">\n{{ employee.name }}</md-option></md-select></md-list-item><div class=\"filter-subtitle\" \ntranslate=\"DEVICES.FILTERS.PLATFORM.LABEL\">Filter platform</div><md-list-item class=\"label\" \ndata-cy=\"devices-filters.platforms\" ng-repeat=\"platform in vm.platforms\" \nng-click=\"vm.filterPlatform(platform.name); vm.broadcastFilterUpdated();\"><md-icon class=\"label-icon\" \nmd-font-icon=\"{{platform.icon}}\" ng-class=\"{{platform.value + \'-fg\'}}\"></md-icon><p \nng-class=\"{{platform.value + \'-fg\'}}\">{{platform.name}}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(platform.name, vm.devicesFilters.platform_name)\"></i></md-list-item></md-content>");
$templateCache.put("app/main/employees/dialogs/activate/employee-dialog.html","<md-dialog class=\"archive-modal\" style=\"max-height: 95% !important; width: 430px\" aria-label=\"Activate user\">\n<md-dialog-content class=\"archive-modal__container\"><div class=\"archive-modal__container__content\"><span \nclass=\"font-size-15 archive-modal__container__content__title\" translate=\"EMPLOYEES.DIALOG.ACTIVATE.TITLE\">Activate user\n</span><div class=\"archive-modal__container__content__warning\"><p translate=\"EMPLOYEES.DIALOG.ACTIVATE.WARNING\" \ntranslate-values=\"{ username: vm.user.name }\">Are you sure you want to activate this user?</p></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"archive-modal__container\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"archive-modal__container__buttons\"><md-button data-cy=\"yes-button\" \nrequired type=\"button\" ng-click=\"vm.activateEmployee();\" class=\"archive-modal__container__buttons__left-button\" \naria-label=\"ACTIVATE\" translate=\"EMPLOYEES.DIALOG.ACTIVATE.SUBMIT\" \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIVATE.SUBMIT\">Yes</md-button></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"archive-modal__container__buttons\"><md-button data-cy=\"no-button\" type=\"button\" \nng-click=\"vm.closeDialog(false);\" class=\"archive-modal__container__buttons__right-button\" aria-label=\"CANCEL\" \ntranslate=\"EMPLOYEES.DIALOG.ACTIVATE.CANCEL\" translate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIVATE.CANCEL\">No\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/dialogs/credentials/employee-credentials-dialog.html","<md-dialog class=\"form-dialog form-auth-employee\" aria-label=\"Dados de acesso do colaborador\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title credentials-title\" translate=\"EMPLOYEES.DIALOG.CREDENTIALS.TITLE\" \ntranslate-values=\"{ name: vm.employee.name }\">Add email and password for collaborator <strong>{{ vm.employee.name }}\n</strong></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog();\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"employeeForm\" class=\"md-inline-form\" \nnovalidate autocomplete=\"off\"><md-dialog-content ms-scroll><div layout=\"column\"><div flex=\"100\" layout-xs=\"column\" \nlayout=\"column\"><div flex=\"100\"><md-input-container class=\"md-block\"><label>Email</label><input type=\"email\" \nname=\"email\" ng-model=\"vm.employee.email\" email-validation ng-disabled=\"vm.hasEmail\" ng-blur=\"vm.checkEmailErr();\" \nrequired><div ng-messages=\"employeeForm.email.$error\" ng-show=\"employeeForm.email.$touched\"><div ng-message=\"required\">\n<span translate=\"EMPLOYEES.MODEL.ERRORS.EMAIL_REQUIRED\">Email is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"EMPLOYEES.MODEL.ERRORS.EMAIL_PATTERN\">Must be a valid email address</span></div><div \nng-if=\"vm.formErr[\'email_already_taken\']\"><div class=\"red-text fs-14\"><small \nng-bind-html=\"vm.formErr[\'email_already_taken\']\"></small></div></div></div></md-input-container></div><div flex=\"100\">\n<md-input-container class=\"md-block mt-0 mb-0\"><label translate=\"EMPLOYEES.MODEL.PASSWORD\">Password</label><input \ntype=\"password\" name=\"password\" class=\"mb-10\" ok-password ng-model=\"vm.employee.password\" required \nautocomplete=\"new-password\"><div ng-messages=\"employeeForm.password.$error\" ng-show=\"employeeForm.password.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"EMPLOYEES.MODEL.ERRORS.PASSWORD_REQUIRED\">Password is required\n</span></div></div><div class=\"hint\"><span translate=\"EMPLOYEES.DIALOG.HINT\">\nYou must use a strong enough password. The password must contain at least 8 characters and include letters, numbers and symbols\n</span> <span translate=\"EMPLOYEES.DIALOG.FOR_EXAMPLE\">For example:</span><b> {{ vm.samplePassword }}</b></div><div \nclass=\"strength-meter\"><div class=\"strength-meter-fill\" data-strength=\"{{ passwordStrength }}\"></div></div>\n</md-input-container></div><div flex=\"100\"><md-input-container class=\"md-block mt-0 mb-0\"><label \ntranslate=\"EMPLOYEES.MODEL.CONFIRM_PASSWORD\">Confirm password</label><input ng-model=\"vm.employee.passwordRepeat\" \nname=\"passwordRepeat\" compare-with=\"vm.employee.password\" type=\"password\" required><div \nng-messages=\"employeeForm.passwordRepeat.$error\" ng-show=\"employeeForm.passwordRepeat.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"EMPLOYEES.MODEL.ERRORS.PASSWORD_REQUIRED\">Password is required</span></div><div \nng-message=\"compareWith\"><span translate=\"EMPLOYEES.MODEL.ERRORS.PASSWORDS_DIDNT_MATCH\">Password didn\'t match</span>\n</div></div></md-input-container></div><div flex=\"100\"><md-checkbox class=\"terms\" aria-label=\"Remember Me\" \nng-model=\"vm.termsAccept\"><span translate=\"EMPLOYEES.DIALOG.CREDENTIALS.AGREE_TERMS\" \ntranslate-values=\"{ name: vm.employee.name }\">I agree that after registering these data, they will be required for \n<strong>{{vm.employee.name}}</strong> to access the application.</span></md-checkbox></div></div></div>\n</md-dialog-content><md-dialog-actions><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.addCredentials()\" class=\"send-button md-accent md-raised\" ng-disabled=\"vm.saveButtonDisabled()\" \naria-label=\"Save\" translate=\"EMPLOYEES.DIALOG.ACTIONS.SAVE\" translate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIONS.SAVE\">\nSave</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/dialogs/delete-devices/delete-devices-dialog.html","<md-dialog data-cy=\"delete-devices-modal\" class=\"archive-modal\" style=\"max-height: 95% !important; width: 430px\" \naria-label=\"Delete devices\"><md-dialog-content class=\"archive-modal__container\"><div \nclass=\"archive-modal__container__content\"><span class=\"font-size-15 archive-modal__container__content__title\" \ntranslate=\"EMPLOYEES.DIALOG.DELETE_DEVICES.TITLE\">Delete devices</span><div data-cy=\"warning-message\" \nclass=\"archive-modal__container__content__warning\"><p translate=\"EMPLOYEES.DIALOG.DELETE_DEVICES.WARNING\" \ntranslate-values=\"{ username: vm.user.name }\">Are you sure you want to delete all devices linked to this user?</p>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" \nclass=\"archive-modal__container\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"archive-modal__container__buttons\"><md-button data-cy=\"yes-button\" required type=\"button\" \nng-click=\"vm.deleteDevices();\" class=\"archive-modal__container__buttons__left-button\" aria-label=\"DELETE\" \ntranslate=\"EMPLOYEES.DIALOG.DELETE_DEVICES.SUBMIT\" translate-attr-aria-label=\"EMPLOYEES.DIALOG.DELETE_DEVICES.SUBMIT\">\nYes</md-button></div><div layout=\"row\" layout-align=\"end center\" class=\"archive-modal__container__buttons\"><md-button \ndata-cy=\"no-button\" type=\"button\" ng-click=\"vm.closeDialog(false);\" \nclass=\"archive-modal__container__buttons__right-button\" aria-label=\"CANCEL\" \ntranslate=\"EMPLOYEES.DIALOG.DELETE_DEVICES.CANCEL\" translate-attr-aria-label=\"EMPLOYEES.DIALOG.DELETE_DEVICES.CANCEL\">\nNo</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/dialogs/inactivate/employee-dialog.html","<md-dialog data-cy=\"archive-modal\" class=\"archive-modal\" style=\"max-height: 95% !important; width: 430px\" \naria-label=\"Inactivate user\"><md-dialog-content class=\"archive-modal__container\"><div \nclass=\"archive-modal__container__content\"><span class=\"font-size-15 archive-modal__container__content__title\" \ntranslate=\"EMPLOYEES.DIALOG.INACTIVATE.TITLE\">Inctivate user</span><div data-cy=\"warning-message\" \nclass=\"archive-modal__container__content__warning\"><p translate=\"EMPLOYEES.DIALOG.INACTIVATE.WARNING\" \ntranslate-values=\"{ username: vm.user.name }\">Are you sure you want to activate this user?</p></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"archive-modal__container\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"archive-modal__container__buttons\"><md-button data-cy=\"yes-button\" \nrequired type=\"button\" ng-click=\"vm.inactivateEmployee();\" class=\"archive-modal__container__buttons__left-button\" \naria-label=\"INACTIVATE\" translate=\"EMPLOYEES.DIALOG.INACTIVATE.SUBMIT\" \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.INACTIVATE.SUBMIT\">Yes</md-button></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"archive-modal__container__buttons\"><md-button data-cy=\"no-button\" type=\"button\" \nng-click=\"vm.closeDialog(false);\" class=\"archive-modal__container__buttons__right-button\" aria-label=\"CANCEL\" \ntranslate=\"EMPLOYEES.DIALOG.INACTIVATE.CANCEL\" translate-attr-aria-label=\"EMPLOYEES.DIALOG.INACTIVATE.CANCEL\">No\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/employees/dialogs/password/employee-password-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--small form-auth-employee\" aria-label=\"Dados de acesso do colaborador\">\n<md-toolbar class=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\" \ntranslate=\"EMPLOYEES.DIALOG.PASSWORD.TITLE\">Change password</span></div><div class=\"sidebar-dialog__actions\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeDialog();\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"EMPLOYEES.DIALOG.CLOSE\"></md-icon></md-button></div></md-toolbar><form name=\"employeeForm\" \nclass=\"md-inline-form\" autocomplete=\"off\" novalidate><md-dialog-content ms-scroll><div layout=\"column\"><div flex=\"100\" \nlayout-xs=\"column\" layout=\"column\"><md-input-container class=\"md-block mt-0 mb-0\"><label \ntranslate=\"EMPLOYEES.MODEL.PASSWORD\">Password</label><input id=\"password\" class=\"input-password-employee mb-10\" \ntype=\"text\" name=\"password\" ok-password ng-model=\"vm.employee.password\" ng-maxlength=\"40\" required><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleNewPassword()\"><md-icon \nmd-font-icon=\"{{ vm.showNewPassword ? \'icon-eye\' : \'icon-eye-off\' }}\"></md-icon></md-button><div \nng-messages=\"employeeForm.password.$error\" ng-show=\"employeeForm.password.$touched\" role=\"alert\" \nclass=\"password-message\"><div ng-message=\"required\"><span translate=\"EMPLOYEES.MODEL.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"EMPLOYEES.MODEL.ERRORS.PASSWORD_MAX_LENGTH\">Password must be up to 40 characters</span></div></div><div \nclass=\"hint\"><span translate=\"EMPLOYEES.DIALOG.HINT\">\nYou must use a strong enough password. The password must contain at least 8 characters and include letters, numbers and symbols\n</span> <span translate=\"EMPLOYEES.DIALOG.FOR_EXAMPLE\">For example:</span><b> {{ vm.samplePassword }}</b></div><div \nclass=\"strength-meter\"><div class=\"strength-meter-fill\" data-strength=\"{{ passwordStrength }}\"></div></div>\n</md-input-container><md-input-container class=\"md-block mt-0 mb-0\"><label \ntranslate=\"EMPLOYEES.MODEL.CONFIRM_PASSWORD\">Confirm password</label><input id=\"passwordRepeat\" \nclass=\"input-password-employee\" type=\"text\" name=\"passwordRepeat\" ng-model=\"vm.employee.passwordRepeat\" \ncompare-with=\"vm.employee.password\" ng-maxlength=\"40\" required><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleConfirmationNewPassword()\"><md-icon \nmd-font-icon=\"{{ vm.showConfirmationNewPassword ? \'icon-eye\' : \'icon-eye-off\' }}\"></md-icon></md-button><div \nng-messages=\"employeeForm.passwordRepeat.$error\" ng-show=\"employeeForm.passwordRepeat.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"EMPLOYEES.MODEL.ERRORS.PASSWORD_REQUIRED\">Password is required</span></div><div \nng-message=\"compareWith\"><span translate=\"EMPLOYEES.MODEL.ERRORS.PASSWORDS_DIDNT_MATCH\">Password didn\'t match</span>\n</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.updatePassword()\" \nclass=\"fc-button fc-button--actions\" ng-disabled=\"vm.saveButtonDisabled()\" aria-label=\"Save\" \ntranslate=\"EMPLOYEES.DIALOG.ACTIONS.SAVE\" translate-attr-aria-label=\"EMPLOYEES.DIALOG.ACTIONS.SAVE\">Save</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/employees/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"EMPLOYEES.FILTERS.TITLE\">Filter Employees</span><md-button ng-if=\"vm.employeesFilters.isOn()\" \nng-click=\"vm.employeesFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"EMPLOYEES.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-employees\" ms-scroll><md-list-item><input flex class=\"search-input\" type=\"text\" \ndata-cy=\"employees-filters.byName\" placeholder=\"Search by name\" translate \ntranslate-attr-placeholder=\"EMPLOYEES.FILTERS.NAME\" ng-model-options=\"{ debounce: 500 }\" \nng-model=\"vm.employeesFilters.name\" ng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider>\n<div class=\"filter-subtitle\"><span translate=\"EMPLOYEES.FILTERS.SITUATIONS.TITLE\">Filter by situation</span></div>\n<md-list-item><md-select class=\"w-100-percent mt-0 mb-0\" data-cy=\"employees-filters.bySituation\" \nplaceholder=\"Pesquisar por situação\" name=\"archived\" id=\"select-situation-employee\" \nng-change=\"vm.broadcastFilterUpdated()\" ng-model=\"vm.employeesFilters.archived\"><md-option data-cy=\"active-option\" \nvalue=\"active\"><span translate=\"EMPLOYEES.FILTERS.SITUATIONS.ACTIVE\">Active</span></md-option><md-option \ndata-cy=\"inactive-option\" value=\"inactive\"><span translate=\"EMPLOYEES.FILTERS.SITUATIONS.INACTIVE\">Inactive</span>\n</md-option><md-option data-cy=\"all-option\" value=\"all\"><span translate=\"EMPLOYEES.FILTERS.SITUATIONS.ALL\">All</span>\n</md-option></md-select></md-list-item></md-content>");
$templateCache.put("app/main/equipment-types/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"EQUIPMENT_TYPES.FILTERS.TITLE\">Filter Equipment Types</span><md-button \nng-if=\"vm.equipmentTypesFilters.isOn()\" ng-click=\"vm.equipmentTypesFilters.clear()\" class=\"md-icon-button\" \naria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"EQUIPMENTS.FILTERS.CLEAR\">Clear filters</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-equipments\" ms-scroll><md-list-item><input flex class=\"search-input\" type=\"text\" \ntranslate translate-attr-placeholder=\"EQUIPMENT_TYPES.FILTERS.NAME\" ng-model-options=\"{ debounce: 500 }\" \nng-model=\"vm.equipmentTypesFilters.name\" ng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\"><span translate=\"EQUIPMENT_TYPES.FILTERS.SITUATIONS.TITLE\">\nFilter by situation</span></div><md-list-item><md-select class=\"w-100-percent mt-0 mb-0\" \nplaceholder=\"Pesquisar por situação\" name=\"archived\" id=\"select-situation-equipments\" \nng-change=\"vm.broadcastFilterUpdated()\" ng-model=\"vm.equipmentTypesFilters.archived\"><md-option value=\"1\"><span \ntranslate=\"EQUIPMENT_TYPES.FILTERS.SITUATIONS.ACTIVE\">Active</span></md-option><md-option value=\"2\"><span \ntranslate=\"EQUIPMENT_TYPES.FILTERS.SITUATIONS.ARCHIVED\">Archived</span></md-option><md-option value=\"0\"><span \ntranslate=\"EQUIPMENT_TYPES.FILTERS.SITUATIONS.ALL\">All</span></md-option></md-select></md-list-item></md-content>");
$templateCache.put("app/main/equipments/dialogs/modal/qrcode-generator.html","<div class=\"qrcode-modal-container\"><qrcode ng-if=\"!vm.variables.hasPublicQRCodeFeatureFlag\" \nid=\"equipment-qrcode-download\" ng-model=\"vm.variables.equipment.qrCode\" version=\"6\" error-correction-level=\"M\" \nsize=\"250\" data=\"{{ vm.variables.equipment.qrCode }}\"></qrcode><qrcode ng-if=\"vm.variables.hasPublicQRCodeFeatureFlag\" \nid=\"equipment-qrcode-download\" ng-model=\"vm.variables.equipment.qrCode\" version=\"6\" error-correction-level=\"M\" \nsize=\"250\" data=\"{{ \'https://app.fieldcontrol.com.br/qrcode-publico/#/\' + vm.variables.equipment.qrCode }}\"></qrcode><p\n ng-model=\"vm.variables.equipment.qrCode\">{{vm.variables.equipment.qrCode}}</p></div>");
$templateCache.put("app/main/equipments/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"EQUIPMENTS.FILTERS.TITLE\">Filter Equipments</span><md-button ng-if=\"vm.equipmentsFilters.isOn()\" \nng-click=\"vm.equipmentsFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"EQUIPMENTS.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-equipments\" ms-scroll><md-list-item><input flex class=\"search-input\" type=\"text\" \nplaceholder=\"Search by model name\" translate translate-attr-placeholder=\"EQUIPMENTS.FILTERS.MODEL_NAME\" \nng-model-options=\"{ debounce: 500 }\" ng-model=\"vm.equipmentsFilters.name\" ng-change=\"vm.broadcastFilterUpdated();\" \ndata-cy=\"equipments-filters.modelName\"></md-list-item><md-divider></md-divider><md-list-item><input flex \nclass=\"search-input\" type=\"text\" placeholder=\"Search by number\" translate \ntranslate-attr-placeholder=\"EQUIPMENTS.FILTERS.NUMBER\" ng-model-options=\"{ debounce: 500 }\" \nng-model=\"vm.equipmentsFilters.number\" ng-change=\"vm.broadcastFilterUpdated();\" data-cy=\"equipments-filters.number\">\n</md-list-item><div ng-if=\"vm.hasWarrantiesPermission\"><md-divider></md-divider><md-list-item><label \ntranslate=\"EQUIPMENTS.FILTERS.WARRANTY.WARRANTY_FROM\">From:</label><md-datepicker \ndata-cy=\"equipments-filter.warrantyStartDateLte\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.equipmentsFilters.warrantyStartDateLte\" \nmd-placeholder=\"{{ \'EQUIPMENTS.FILTERS.WARRANTY.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item>\n<md-list-item><label translate=\"EQUIPMENTS.FILTERS.WARRANTY.WARRANTY_UNTIL\">Until:</label><md-datepicker \ndata-cy=\"equipments-filter.warrantyEndDateGte\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.equipmentsFilters.warrantyEndDateGte\" \nmd-placeholder=\"{{ \'EQUIPMENTS.FILTERS.WARRANTY.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item>\n<md-divider></md-divider><div class=\"filter-subtitle\" translate=\"CONTROL_PANEL.FILTERS.SITUATION.LABEL\">\nFilter by situation</div><md-list-item class=\"label\" ng-repeat=\"status in vm.warrantyStatus\" \nng-click=\"vm.toggleInArray(status, vm.equipmentsFilters.warrantyStatusIn)\"><md-icon md-font-icon=\"material-icons\" \nng-class=\"status + \'-fg\'\" class=\"warranty-icon\">lens</md-icon><p ng-class=\"status + \'-fg\'\">\n{{ \'EQUIPMENTS.FILTERS.WARRANTY.\' + status.toUpperCase() | translate }}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(status, vm.equipmentsFilters.warrantyStatusIn)\"></i></md-list-item></div><md-divider></md-divider><div\n class=\"filter-subtitle\" translate=\"EQUIPMENTS.FILTERS.CUSTOMER.TITLE\">Filter by customer</div><md-list-item \nclass=\"fx-wrap\"><input flex class=\"search-input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nplaceholder=\"Search by customer\" translate translate-attr-placeholder=\"EQUIPMENTS.FILTERS.CUSTOMER.SEARCH\" \nng-change=\"vm.loadCustomers();\" ng-model=\"vm.equipmentsFilters.customerName\" \nng-show=\"!vm.equipmentsFilters.customerId\" data-cy=\"equipments-filters.customer\"><md-icon \nclass=\"icon s18 remove-selected-option\" md-menu-origin md-font-icon=\"icon-close\" \nng-click=\"vm.removeSelectedCustomerInFilter();\" ng-show=\"vm.equipmentsFilters.customerId\"></md-icon><md-select \nplaceholder=\"{{ \'EQUIPMENTS.FILTERS.CUSTOMER.SELECT\' | translate }}\" ng-model=\"vm.selectedCustomerInFilter\" \nclass=\"minimal-md-select md-no-underline ml-22 wd-100-22\" ng-show=\"vm.customers.length > 0\" \nng-change=\"vm.selectCustomerInFilter();\"><md-option ng-value=\"customer\" ng-repeat=\"customer in vm.customers\"><div \nclass=\"container-client-name\"><div ng-class=\"{\'is-archived\': customer.archived }\">{{customer.name}}</div><div \nng-if=\"customer.archived\" translate=\"EQUIPMENTS.FILTERS.CUSTOMER.INACTIVE\" class=\"is-archived-text\">Archived</div>\n</div></md-option></md-select></md-list-item><div class=\"filter-subtitle mt-5\" \nng-show=\"vm.equipmentsFilters.customerId\" translate=\"EQUIPMENTS.FILTERS.LOCATION.TITLE\">Filter by location</div>\n<md-list-item class=\"fx-wrap\" ng-show=\"vm.equipmentsFilters.customerId\"><input flex class=\"search-input\" type=\"text\" \nng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by location\" translate \ntranslate-attr-placeholder=\"EQUIPMENTS.FILTERS.LOCATION.SEARCH\" ng-change=\"vm.loadLocations();\" \nng-model=\"vm.locationName\" ng-show=\"!vm.equipmentsFilters.locationId\"><md-icon class=\"icon s18 remove-selected-option\" \nmd-menu-origin md-font-icon=\"icon-close\" ng-click=\"vm.removeSelectedLocationInFilter();\" \nng-show=\"vm.equipmentsFilters.locationId\"></md-icon><md-select \nplaceholder=\"{{ \'EQUIPMENTS.FILTERS.LOCATION.SELECT\' | translate }}\" ng-model=\"vm.selectedLocationInFilter\" \nclass=\"minimal-md-select md-no-underline ml-22 wd-100-22\" ng-show=\"vm.locations.length > 0\" \nng-change=\"vm.selectLocationInFilter();\"><md-option ng-value=\"location\" ng-repeat=\"location in vm.locations\">\n{{location.name}}</md-option></md-select></md-list-item><md-divider></md-divider><div ng-if=\"vm.hasTerritoriesFlag\">\n<div class=\"filter-property-name\" style=\"padding-left: 10px\"><span translate=\"EQUIPMENTS.FILTERS.BY_TERRITORY.LABEL\">\nFilter by territory</span></div><md-list-item><md-input-container><label ng-show=\"!vm.equipmentsFilters.territoryId\">\n{{ \'EQUIPMENTS.FILTERS.BY_TERRITORY.SEARCH_LABEL\' | translate }}</label><md-select \nng-model=\"vm.equipmentsFilters.territoryId\" ng-model-options=\"{trackBy: \'$value\', debounce: 100}\" \nmd-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" \nng-change=\"vm.broadcastFilterUpdated(\'territoryId\'); vm.territorySelected();\"><md-select-header class=\"select-header\">\n<input ng-model=\"vm.searchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'EQUIPMENTS.FILTERS.BY_TERRITORY.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"territory.id\" \nng-repeat=\"territory in vm.territoriesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">{{ territory.name }}\n</md-option></md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider><div \nng-if=\"vm.equipmentsFilters.territoryId\"><div class=\"filter-property-name\" style=\"padding-left: 10px\"><span \ntranslate=\"EQUIPMENTS.FILTERS.BY_SUBTERRITORY.LABEL\">Filter by subTerritory</span></div><md-list-item>\n<md-input-container><label ng-show=\"vm.equipmentsFilters.subTerritoryIds.length == 0\">\n{{ \'EQUIPMENTS.FILTERS.BY_SUBTERRITORY.SEARCH_LABEL\' | translate }}</label><md-select \nng-model=\"vm.equipmentsFilters.subTerritoryIds\" ng-model-options=\"{trackBy: \'$value\', debounce: 100}\" \nmd-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" ng-change=\"vm.broadcastFilterUpdated(\'territoryIds\');\" \nmultiple=\"multiple\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'EQUIPMENTS.FILTERS.BY_SUBTERRITORY.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"territory.id\" \nng-repeat=\"territory in vm.subTerritoriesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">{{ territory.name }}\n</md-option></md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider></div></div><div \nclass=\"filter-subtitle\" translate=\"EQUIPMENTS.FILTERS.SITUATIONS.TITLE\">Filter by situation</div><md-list-item>\n<md-select class=\"w-100-percent mt-0 mb-0\" name=\"archived\" id=\"select-situation-equipments\" \nplaceholder=\"{{ \'EQUIPMENTS.FILTERS.SITUATIONS.TITLE\' | translate }}\" ng-change=\"vm.broadcastFilterUpdated()\" \nng-model=\"vm.equipmentsFilters.archived\" data-cy=\"equipments-filters.situation\"><md-option value=\"1\"><span \ntranslate=\"EQUIPMENTS.FILTERS.SITUATIONS.ACTIVE\">Active</span></md-option><md-option value=\"2\"><span \ntranslate=\"EQUIPMENTS.FILTERS.SITUATIONS.ARCHIVED\">Archived</span></md-option><md-option value=\"0\"><span \ntranslate=\"EQUIPMENTS.FILTERS.SITUATIONS.ALL\">All</span></md-option></md-select></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\" translate=\"EQUIPMENTS.FILTERS.TYPE.TITLE\">Filter by equipment type</div>\n<md-list-item><md-select class=\"w-100-percent mt-0 mb-0\" id=\"select-type-equipments\" \nplaceholder=\"{{ \'EQUIPMENTS.FILTERS.TYPE.TITLE\' | translate }}\" ng-change=\"vm.broadcastFilterUpdated()\" \nng-model=\"vm.equipmentsFilters.equipmentTypeId\" data-cy=\"equipments-filters.equipmentType\"><md-option value=\"\" \ntranslate=\"EQUIPMENTS.FILTERS.TYPE.ALL\">All</md-option><md-option \nng-repeat=\"equipmentType in vm.equipmentTypesFilterList\" value=\"{{equipmentType.id}}\">{{equipmentType.name}}\n</md-option></md-select></md-list-item><md-divider ng-if=\"vm.labels && vm.labels.length > 0\"></md-divider><div \nng-if=\"vm.labels && vm.labels.length > 0\" class=\"filter-subtitle\" translate=\"EQUIPMENTS.FILTERS.FILTER_BY_LABEL.LABEL\">\nFilter by tags</div><md-list-item class=\"label\" ng-click=\"vm.toggleInArray(null, vm.equipmentsFilters.labelsIds)\">\n<md-icon md-font-icon=\"icon-label-outline\" class=\"label-icon\"></md-icon><p \ntranslate=\"EQUIPMENTS.FILTERS.FILTER_BY_LABEL.NO_LABEL\">No tag</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(null, vm.equipmentsFilters.labelsIds)\"></i></md-list-item><md-list-item class=\"label\" \nng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleInArray(label.id, vm.equipmentsFilters.labelsIds)\"><md-icon \nmd-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(label.id, vm.equipmentsFilters.labelsIds)\"></i></md-list-item></md-content>");
$templateCache.put("app/main/exports/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"EXPORTS.FILTERS.TITLE\">Filter Exports</span><md-button ng-if=\"vm.exportsFilters.isOn()\" \nng-click=\"vm.exportsFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"EXPORTS.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button></div></md-toolbar><md-content class=\"animate-slide-right filter-exports\" \nms-scroll><div class=\"filter-subtitle\" translate=\"EXPORTS.FILTERS.CREATION_DATE\">Search by creation date</div>\n<md-list-item><label translate=\"EXPORTS.FILTERS.FROM\">From:</label><md-datepicker \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.exportsFilters.createdAtFrom\" \nmd-placeholder=\"{{ \'EXPORTS.FILTERS.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item><md-list-item><label \ntranslate=\"EXPORTS.FILTERS.TO\">To:</label><md-datepicker ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.exportsFilters.createdAtTo\" md-placeholder=\"{{ \'EXPORTS.FILTERS.SELECT_DATE\' | translate }}\">\n</md-datepicker></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\" \ntranslate=\"EXPORTS.FILTERS.COMPLETION_DATE\">Search by completion date</div><md-list-item><label \ntranslate=\"EXPORTS.FILTERS.FROM\">From:</label><md-datepicker ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.exportsFilters.completedAtFrom\" ng-required=\"false\" \nmd-placeholder=\"{{ \'EXPORTS.FILTERS.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item><md-list-item><label \ntranslate=\"EXPORTS.FILTERS.TO\">To:</label><md-datepicker ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.exportsFilters.completedAtTo\" ng-required=\"false\" \nmd-placeholder=\"{{ \'EXPORTS.FILTERS.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\" translate=\"EXPORTS.FILTERS.STATUS\">Search by status</div><md-list-item>\n<md-select class=\"w-100-percent mt-0 mb-0\" name=\"status\" id=\"select-situation-exports\" \nplaceholder=\"{{ \'EXPORTS.MODEL.STATUS.TITLE\' | translate }}\" ng-change=\"vm.broadcastFilterUpdated()\" \nng-model=\"vm.exportsFilters.status\"><md-option value=\"completed\"><span translate=\"EXPORTS.MODEL.STATUS.COMPLETED\">\nCompleted</span></md-option><md-option value=\"pending\"><span translate=\"EXPORTS.MODEL.STATUS.PENDING\">Pending</span>\n</md-option><md-option value=\"in-progress\"><span translate=\"EXPORTS.MODEL.STATUS.IN_PROGRESS\">In progress</span>\n</md-option><md-option value=\"error\"><span translate=\"EXPORTS.MODEL.STATUS.ERROR\">Error</span></md-option></md-select>\n</md-list-item><md-divider></md-divider></md-content>");
$templateCache.put("app/main/locations/dialogs/map/map-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large location-dialog\" aria-label=\"Dialog Location\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\">\n{{ \'LOCATIONS.MAP.TITLE\' | translate}}</span></div><div class=\"sidebar-dialog__actions\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><form name=\"vm.mapForm\" novalidate><md-dialog-content class=\"pt-0 map-dialog\" \nstyle=\"padding: 0 !important\" ms-scroll><div class=\"fc-warning-container\"><span data-cy=\"map-alert\">\n{{ \'LOCATIONS.MAP.ALERT\' | translate }}</span></div><div ng-if=\"vm.map\" class=\"map-dialog__map\"><leaflet \nid=\"locationMap\" lf-center=\"vm.map.center\" markers=\"vm.map.markers\" controls=\"vm.map.controls\" layers=\"vm.map.layers\" \nheight=\"100%\" width=\"100%\"></leaflet></div><div class=\"hint mt-5 map-dialog__coordinates\" layout=\"row\" \nlayout-align=\"start center\" \nng-if=\"vm.address && vm.address.coords && vm.address.coords.latitude && vm.address.coords.longitude\"><span \ndata-cy=\"map-coordinates\" translate=\"CUSTOMERS.MAP.LATITUDE_LONGITUDE\" \ntranslate-values=\"{ latitude: vm.address.coords.latitude, longitude: vm.address.coords.longitude }\">\nCoordinates: {{ vm.address.coords.latitude }}, {{ vm.address.coords.longitude }}</span></div></md-dialog-content>\n</form><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><button class=\"fc-button\" ng-class=\"{ disabled: !vm.hasBeenChanged }\" \nng-disabled=\"!vm.hasBeenChanged\" ng-click=\"vm.closeDialog();\">{{ \'LOCATIONS.MAP.UPDATE\' | translate }}</button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/locations/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"LOCATIONS.TOOLBAR.FILTER\">Filter locations</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"LOCATIONS.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-locations\" ms-scroll><md-list><div class=\"fc-input margin-0-auto mt-10\" flex=\"90\">\n<input data-cy=\"locations-filters.name\" type=\"text\" placeholder=\" \" class=\"fc-input__input\" autocomplete=\"off\" \nng-model=\"vm.locationsFilters.locationName\" ng-change=\"vm.broadcastFilterUpdated();\"><label class=\"fc-input__label\">\n{{(\'LOCATIONS.FILTERS.LABELS.LOCATION_NAME\' | translate)}}</label></div><md-divider></md-divider><div \nclass=\"fc-input margin-0-auto mt-10\" flex=\"90\"><input data-cy=\"locations-filters.notes\" type=\"text\" placeholder=\" \" \nclass=\"fc-input__input\" autocomplete=\"off\" ng-model=\"vm.locationsFilters.locationNotes\" \nng-change=\"vm.broadcastFilterUpdated();\"><label class=\"fc-input__label\">\n{{(\'LOCATIONS.FILTERS.LABELS.LOCATION_DESCRIPTION\' | translate)}}</label></div><md-divider></md-divider><div \nclass=\"fc-input margin-0-auto mt-10\" flex=\"90\"><input type=\"text\" placeholder=\" \" class=\"fc-input__input\" \nautocomplete=\"off\" ng-model=\"vm.locationsFilters.customerName\" ng-change=\"vm.broadcastFilterUpdated();\"><label \nclass=\"fc-input__label\">{{(\'LOCATIONS.FILTERS.LABELS.CUSTOMER_NAME\' | translate)}}</label></div><md-divider>\n</md-divider><div class=\"fc-input margin-0-auto\" flex=\"90\"><input type=\"text\" placeholder=\" \" class=\"fc-input__input\" \nautocomplete=\"off\" ng-model=\"vm.locationsFilters.documentNumber\" ng-change=\"vm.broadcastFilterUpdated();\" \nui-br-cpfcnpj-mask><label class=\"fc-input__label\">{{(\'LOCATIONS.FILTERS.LABELS.DOCUMENT_NUMBER\' | translate)}}</label>\n</div><md-divider></md-divider><div class=\"fc-input margin-0-auto\" flex=\"90\"><input type=\"text\" placeholder=\" \" \nclass=\"fc-input__input\" autocomplete=\"off\" ng-model=\"vm.locationsFilters.street\" \nng-change=\"vm.broadcastFilterUpdated();\"><label class=\"fc-input__label\">\n{{(\'LOCATIONS.FILTERS.LABELS.STREET\' | translate)}}</label></div><md-divider></md-divider><div \nclass=\"fc-input margin-0-auto\" flex=\"90\"><input type=\"text\" placeholder=\" \" class=\"fc-input__input\" autocomplete=\"off\" \nng-model=\"vm.locationsFilters.city\" ng-change=\"vm.broadcastFilterUpdated();\"><label class=\"fc-input__label\">\n{{(\'LOCATIONS.FILTERS.LABELS.CITY\' | translate)}}</label></div><md-divider></md-divider><div \nclass=\"fc-input margin-0-auto\" flex=\"90\"><input type=\"text\" placeholder=\" \" class=\"fc-input__input\" autocomplete=\"off\" \nng-model=\"vm.locationsFilters.state\" ng-change=\"vm.broadcastFilterUpdated();\"><label class=\"fc-input__label\">\n{{(\'LOCATIONS.FILTERS.LABELS.STATE\' | translate)}}</label></div><md-divider></md-divider><div \nclass=\"fc-input margin-0-auto\" flex=\"90\"><fc-select label=\"{{(\'LOCATIONS.FILTERS.LABELS.STATUS\' | translate)}}\" \noptions=\"vm.statusOptions\" ng-model=\"vm.statusFilterValue\" track-by=\"label\" \nng-change=\"vm.broadcastFilterUpdated(\'archived\');\" is-required=\"true\"></fc-select></div><md-divider></md-divider><div \nng-if=\"vm.hasTerritoriesFlag\"><div class=\"filter-property-name\" style=\"padding-left: 10px\"><span \ntranslate=\"LOCATIONS.FILTERS.BY_TERRITORY.LABEL\">Filter by territory</span></div><md-list-item><md-input-container>\n<label ng-show=\"!vm.locationsFilters.territoryId\">{{ \'LOCATIONS.FILTERS.BY_TERRITORY.SEARCH_LABEL\' | translate }}\n</label><md-select ng-model=\"vm.locationsFilters.territoryId\" ng-model-options=\"{trackBy: \'$value\', debounce: 100}\" \nmd-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" \nng-change=\"vm.broadcastFilterUpdated(\'territoryId\'); vm.territorySelected()\"><md-select-header class=\"select-header\">\n<input ng-model=\"vm.searchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'LOCATIONS.FILTERS.BY_TERRITORY.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"territory.id\" \nng-repeat=\"territory in vm.territoriesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">{{ territory.name }}\n</md-option></md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider><div \nng-if=\"vm.locationsFilters.territoryId\"><div class=\"filter-property-name\" style=\"padding-left: 10px\"><span \ntranslate=\"LOCATIONS.FILTERS.BY_SUBTERRITORY.LABEL\">Filter by subTerritory</span></div><md-list-item>\n<md-input-container><label ng-show=\"vm.locationsFilters.subTerritoryIds.length == 0\">\n{{ \'LOCATIONS.FILTERS.BY_SUBTERRITORY.SEARCH_LABEL\' | translate }}</label><md-select \nng-model=\"vm.locationsFilters.subTerritoryIds\" ng-model-options=\"{trackBy: \'$value\', debounce: 100}\" \nmd-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" ng-change=\"vm.broadcastFilterUpdated(\'subTerritoryIds\');\" \nmultiple=\"multiple\"><md-select-header class=\"select-header\"><input ng-model=\"vm.searchTerm\" \nng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'LOCATIONS.FILTERS.BY_SUBTERRITORY.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"territory.id\" \nng-repeat=\"territory in vm.subTerritoriesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">{{ territory.name }}\n</md-option></md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider></div></div>\n</md-list></md-content>");
$templateCache.put("app/main/materials/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"MATERIALS.FILTERS.TITLE\">Filter material</span><md-button ng-if=\"vm.materialsFilters.isOn()\" \nng-click=\"vm.materialsFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"MATERIALS.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-materials\" ms-scroll><md-list-item><input flex class=\"search-input\" type=\"text\" \ntranslate translate-attr-placeholder=\"MATERIALS.FILTERS.NAME\" ng-model-options=\"{ debounce: 500 }\" \nng-model=\"vm.materialsFilters.name\" ng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider>\n<div class=\"filter-subtitle\" translate=\"MATERIALS.FILTERS.STATUS\">Filter by situation</div><md-list-item><md-select \nclass=\"w-100-percent mt-0 mb-0\" translate-attr-placeholder=\"MATERIALS.FILTERS.STATUS\" name=\"archived\" \nid=\"select-situation-materials\" ng-change=\"vm.broadcastFilterUpdated()\" ng-model=\"vm.materialsFilters.archived\">\n<md-option value=\"1\" translate=\"MATERIALS.FILTERS.ACTIVE\">Active</md-option><md-option value=\"2\" \ntranslate=\"MATERIALS.FILTERS.INACTIVE\">Inactive</md-option><md-option value=\"0\" translate=\"MATERIALS.FILTERS.ALL\">All\n</md-option></md-select></md-list-item></md-content>");
$templateCache.put("app/main/modules/sidenavs/customers-area/customers-area.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium customers-area-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"CUSTOMERS_AREA_MODULE.TITLE\">\nCustomers Area</span></div></div><div class=\"sidebar-dialog__actions\"><md-button data-cy=\"reload-button\" \nng-if=\"vm.showModuleSettings && vm.activeTab === 0\" ng-click=\"vm.reload();\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"CUSTOMERS_AREA_MODULE.RELOAD\">\nReload</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Close Dialog\" \nng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list id=\"moduleSidenavContent\" \nclass=\"module-sidenav__content no-padding-important\" ms-scroll \nng-show=\"vm.configuration.isEnable && vm.showModuleSettings && !vm.activeCustomersLoading\"><md-tabs class=\"main-tabs\" \nmd-dynamic-height md-selected=\"vm.activeTab\"><md-tab label=\"0\"><md-tabs><md-tab><md-tab-label><span \ndata-cy=\"general-tab\">{{ \'CUSTOMERS_AREA_MODULE.GENERAL\' | translate }}</span></md-tab-label><md-tab-body><form \nname=\"customersAreaForm\" novalidate><label class=\"module-sidenav__content__label\" \ntranslate=\"CUSTOMERS_AREA_MODULE.SLUG.TITLE\">Complete your online address (link):</label><md-list-item><div \nclass=\"slug-container\" layout=\"row\" flex><div class=\"slug-container__start-url\" layout=\"row\" \nlayout-align=\"start start\">{{vm.wargUrl}}</div><md-input-container class=\"slug-container__input\" flex md-no-float=\"\">\n<input name=\"slug\" type=\"text\" minlength=\"2\" maxlength=\"50\" placeholder=\"{{ vm.slugPlaceholder }}\" required \nng-model=\"vm.customersAreaSettings.slug\" ng-model-options=\"{ debounce: 1000 }\" \nng-pattern=\"/^[a-z0-9]+(?:-[a-z0-9]+)*$/\" ng-change=\"vm.verifyTicketsSlug()\"> <span class=\"slug-container__end-url\">\n{{ vm.wargEndUrl }}</span><md-button class=\"md-icon-button\" ngclipboard \ndata-clipboard-text=\"{{ vm.wargUrl + vm.customersAreaSettings.slug + vm.wargEndUrl }}\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"md-accent-fg\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.SLUG.COPY_LINK\">Copy link</span></md-tooltip></md-button><md-icon class=\"grey-400-fg\" \nmd-font-icon=\"icon-question-mark-circle\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.SLUG.HINT\">\nThis will be your online address (link) for requesting services from your customers</span></md-tooltip></md-icon><div \nng-messages=\"customersAreaForm.slug.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.SLUG.REQUIRED\">URL complement is required</span></div><div ng-message=\"existent\"><span\n translate=\"CUSTOMERS_AREA_MODULE.SLUG.IN_USE\">The URL complement is already in use</span></div><div \nng-message=\"pattern\"><span translate=\"CUSTOMERS_AREA_MODULE.SLUG.INVALID\">The URL complement is in invalid format\n</span></div><div ng-message=\"minlength\"><span translate=\"CUSTOMERS_AREA_MODULE.SLUG.MIN\">\nThe URL add-in must be at least 2 characters</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.SLUG.MAX\">The URL add-on must be a maximum of 50 characters</span></div></div>\n</md-input-container></div></md-list-item></form><customers-area-active-customers-tab \nng-if=\"vm.customersAreaSettings.active\" \nsettings=\"{\n                    activeCustomers: vm.activeCustomers,\n                    activeCustomersLoading: vm.activeCustomersLoading,\n                    noActiveCustomers: vm.noActiveCustomers,\n                  }\" \nchange-tab=\"vm.changeTab(tabIndex)\" edit-customer=\"vm.editCustomer(customer)\" \nsync-customer=\"vm.syncCustomer(customer)\"></customers-area-active-customers-tab></md-tab-body></md-tab><md-tab \nng-if=\"vm.customersAreaSettings.active\"><md-tab-label><span data-cy=\"settings-tab\">\n{{ \'CUSTOMERS_AREA_MODULE.CONFIGURATIONS.TITLE\' | translate }}</span></md-tab-label><md-tab-body><div class=\"p-4\"><div \nlayout=\"row\" layout-align=\"space-between\"><h3 \ntranslate=\"CUSTOMERS_AREA_MODULE.CONFIGURATIONS.CUSTOMERS_AREA_CHOOSE_EMPLOYEE_ON_TICKET_ACCEPT.TITLE\">\nChoose employee on ticket accept</h3><md-switch class=\"md-secondary ml-10 mt-10\" \ndata-cy=\"customers-area-choose-employee-on-ticket-accept-switch\" \nng-model=\"vm.customersAreaChooseEmployeeOnTicketAccept\" ng-change=\"customersAreaForm.$setDirty()\"></md-switch></div>\n<div class=\"hint fs-12 mt-15n end-session\" \ntranslate=\"CUSTOMERS_AREA_MODULE.CONFIGURATIONS.CUSTOMERS_AREA_CHOOSE_EMPLOYEE_ON_TICKET_ACCEPT.HINT\">\nMakes the employee selection mandatory when accepting a ticket.</div></div></md-tab-body></md-tab></md-tabs></md-tab>\n<md-tab label=\"1\"><customers-area-customers-tab change-tab=\"vm.changeTab(tabIndex, activeCustomer)\">\n</customers-area-customers-tab></md-tab><md-tab label=\"2\"><customers-area-customer-tab \nsettings=\"{ customer: vm.activeCustomer }\" change-tab=\"vm.changeTab(tabIndex)\" form=\"customerForm\" \nsave-customer=\"saveCustomer\"></customers-area-customer-tab></md-tab></md-tabs></md-list><div \nclass=\"customers__loading\" ng-show=\"vm.activeCustomersLoading\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div class=\"module-sidenav__description\" ms-scroll \nng-show=\"!vm.showModuleSettings\"><div class=\"module-sidenav__description__title\" layout=\"row\" \nlayout-align=\"space-between center\"><span ng-if=\"!vm.configuration.isPaid\" class=\"badge free\" \ntranslate=\"MODULES.FREE_MODULE\">free module</span> <span ng-if=\"vm.configuration.isPaid\" class=\"badge paid\" \ntranslate=\"MODULES.PAID_MODULE\">paid module</span></div><p translate=\"CUSTOMERS_AREA_MODULE.TEXT\">\nReceive requests from your customers through a single panel and reduce the waiting time for customer service.</p><ul>\n<li ng-repeat=\"item in (\'CUSTOMERS_AREA_MODULE.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"module-sidenav__button-container__container\" layout=\"row\"><md-button \nng-if=\"!vm.configuration.isEnable && !vm.showModuleSettings\" class=\"md-raised md-accent\" \nng-click=\"vm.requestActivation()\" ng-disabled=\"vm.disableButton\" translate=\"MODULES.REQUEST_ACTIVATION.BUTTON\">\nREQUEST ACTIVATION</md-button><md-button \nng-if=\"vm.configuration.isEnable && vm.showModuleSettings && vm.customersAreaSettings.active && vm.activeTab === 0\" \nclass=\"md-raised md-accent\" ng-click=\"vm.saveSettings()\" \nng-disabled=\"customersAreaForm.$invalid || customersAreaForm.$pristine || vm.disableButton\" \ntranslate=\"MODULES.SAVE_SETTINGS\">SAVE SETTINGS</md-button><md-button \nng-if=\"vm.configuration.isEnable && vm.showModuleSettings && vm.customersAreaSettings.active && vm.activeTab === 2\" \nclass=\"md-raised md-accent\" ng-click=\"saveCustomer()\" \nng-disabled=\"customerForm.$invalid || customerForm.$pristine || vm.disableButton\" translate=\"MODULES.SAVE_SETTINGS\">\nSAVE SETTINGS</md-button><md-button ng-if=\"vm.activeTab !== 0 && vm.showModuleSettings\" class=\"md-raised md-accent\" \nng-click=\"vm.changeTab(0)\" ng-disabled=\"vm.disableButton\" translate=\"CUSTOMERS_AREA_MODULE.GO_BACK\">GO BACK</md-button>\n<md-button ng-if=\"vm.configuration.isEnable && !vm.customersAreaSettings.active\" class=\"md-raised md-accent\" \nng-click=\"vm.enableModule()\" \nng-disabled=\"customersAreaForm.$invalid || customersAreaForm.$pristine || vm.disableButton\" translate=\"MODULES.ENABLE\">\nENABLE</md-button><md-button \nng-if=\"vm.configuration.isEnable && vm.customersAreaSettings.active && vm.activeTab === 0\" \nclass=\"md-raised disable-button\" ng-click=\"vm.disableModule()\" ng-disabled=\"vm.disableButton\" \ntranslate=\"MODULES.DISABLE\">DISABLE</md-button></div><div class=\"module-sidenav__button-container__container\">\n<md-button \nng-if=\"vm.configuration.isEnable && vm.showModuleSettings && vm.customersAreaSettings.active && vm.activeTab === 0\" \nng-disabled=\"vm.disableButton\" class=\"md-icon-button\" ng-click=\"vm.syncCompany()\"><md-icon md-font-icon=\"icon-refresh\">\n</md-icon><md-tooltip md-direction=\"top\"><span translate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.SYNC\">Sync</span>\n</md-tooltip></md-button></div></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/deadlines/deadlines.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"DEADLINES_MODULES.TITLE\">\nMaterials</span></div></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" \naria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list class=\"module-sidenav__content\" \nms-scroll ng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><p class=\"no-config\" \ntranslate=\"MODULES.NO_CONFIG\">There is no configuration available for this module</p></md-list><div \nclass=\"module-sidenav__description\" ms-scroll ng-show=\"!vm.showModuleSettings\"><div \nclass=\"module-sidenav__description__title\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"!vm.configuration.isPaid\" class=\"badge free\" translate=\"MODULES.FREE_MODULE\">free module</span> <span \nng-if=\"vm.configuration.isPaid\" class=\"badge paid\" translate=\"MODULES.PAID_MODULE\">paid module</span></div><p \ntranslate=\"DEADLINES_MODULES.TEXT\">\nRegister all the materials used by your employees in daily visits to have greater control of your company\'s stock.</p>\n<ul><li ng-repeat=\"item in (\'DEADLINES_MODULES.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.configuration.isEnable\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.requestActivation()\" ng-disabled=\"vm.disableButton\" \ntranslate=\"MODULES.HIRING\">HIRING</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/equipments/equipments.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"EQUIPMENTS_MODULE.TITLE\">\nEquipments</span></div></div><div class=\"sidebar-dialog__actions\"><md-button data-cy=\"close-dialog-button\" \nclass=\"md-icon-button\" aria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate \ntranslate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-list class=\"module-sidenav__content\" ms-scroll \nng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><form name=\"equipmentsForm\" novalidate><div \nclass=\"module-sidenav__content__switch\" layout=\"row\"><md-switch data-cy=\"link-equipments-switch\" class=\"md-secondary\" \nflex ng-model=\"vm.account.configuration.mobileUpdateOrderEquipments\" \naria-label=\"{{\'EQUIPMENTS_MODULE.LINK_EQUIPMENT_SERVICE_ORDER.TITLE\' | translate}}\"><span \ntranslate=\"EQUIPMENTS_MODULE.LINK_EQUIPMENT_SERVICE_ORDER.TITLE\">\nLink equipment to the service order to the employee application</span></md-switch><md-icon class=\"grey-400-fg\" \nmd-font-icon=\"icon-question-mark-circle\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"EQUIPMENTS_MODULE.LINK_EQUIPMENT_SERVICE_ORDER.HINT\">\nOnly the OS types selected will be displayed when requesting a service.</span></md-tooltip></md-icon></div><div \nclass=\"module-sidenav__content__switch\" layout=\"row\"><md-switch data-cy=\"required-qrcode-switch\" class=\"md-secondary\" \nflex ng-model=\"vm.account.configuration.equipmentsQRCodeRequired\" \naria-label=\"{{\'EQUIPMENTS_MODULE.REQUIRED_QRCODE.TITLE\' | translate}}\"><span \ntranslate=\"EQUIPMENTS_MODULE.REQUIRED_QRCODE.TITLE\">Require QRCode</span></md-switch><md-icon class=\"grey-400-fg\" \nmd-font-icon=\"icon-question-mark-circle\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"EQUIPMENTS_MODULE.REQUIRED_QRCODE.HINT\">\nEquipment can only be registered via an application with a valid QRCode.</span></md-tooltip></md-icon></div><div \nclass=\"module-sidenav__content__switch\" layout=\"row\"><md-switch data-cy=\"create-equipments-switch\" \nclass=\"md-secondary\" flex ng-model=\"vm.account.configuration.mobileCreateEquipments\" \naria-label=\"{{\'EQUIPMENTS_MODULE.CREATE_ORDER_EQUIPMENTS.TITLE\' | translate}}\"><span \ntranslate=\"EQUIPMENTS_MODULE.CREATE_ORDER_EQUIPMENTS.TITLE\">Create and edit equipments trough the employee\'s app</span>\n</md-switch><md-icon class=\"grey-400-fg\" md-font-icon=\"icon-question-mark-circle\"><md-tooltip md-direction=\"bottom\">\n<span translate=\"EQUIPMENTS_MODULE.CREATE_ORDER_EQUIPMENTS.HINT\">\nAllow the employee to create and edit equipments trough the employee\'s app.</span></md-tooltip></md-icon></div><div \nclass=\"module-sidenav__content__switch\" layout=\"row\"><md-switch data-cy=\"equipments-service-history-switch\" \nclass=\"md-secondary\" flex ng-model=\"vm.account.configuration.mobileEquipmentServiceHistory\" \naria-label=\"{{\'EQUIPMENTS_MODULE.EQUIPMENTS_SERVICE_HISTORY.TITLE\' | translate}}\"><span \ntranslate=\"EQUIPMENTS_MODULE.EQUIPMENTS_SERVICE_HISTORY.TITLE\">Access to equipment service history</span></md-switch>\n<md-icon class=\"grey-400-fg\" md-font-icon=\"icon-question-mark-circle\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"EQUIPMENTS_MODULE.EQUIPMENTS_SERVICE_HISTORY.HINT\">\nAllows the employee to have access to the service history of the equipment through the application.</span></md-tooltip>\n</md-icon></div></form></md-list><div class=\"module-sidenav__description\" ms-scroll ng-show=\"!vm.showModuleSettings\">\n<div class=\"module-sidenav__description__title\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"!vm.configuration.isPaid\" class=\"badge free\" translate=\"MODULES.FREE_MODULE\">free module</span> <span \nng-if=\"vm.configuration.isPaid\" class=\"badge paid\" translate=\"MODULES.PAID_MODULE\">paid module</span></div><div \nclass=\"module-video__container\"><img class=\"module-video__container__background\" \nsrc=\"assets/images/modules/equipments-video.jpg\" alt=\"{{ \'EQUIPMENTS_MODULE.TITLE\' | translate }}\"><div \nclass=\"module-video__container__filter\"></div><a class=\"module-video__container__play-button\" \nhref=\"https://www.youtube.com/watch?v=2eEOL8I0r2w\" target=\"_blank\"><img src=\"assets/images/modules/play-button.svg\" \nalt=\"{{ \'MODULES.MODULE_VIDEO.PLAY_BUTTON\' | translate }}\"></a></div><p translate=\"EQUIPMENTS_MODULE.TEXT\">\nRegister the equipment of your customers and have total control with forms dedicated to each type of equipment and facilitate the identification of registration via QR Code.\n</p><ul><li ng-repeat=\"item in (\'EQUIPMENTS_MODULE.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.configuration.isEnable && vm.showModuleSettings\"><md-button data-cy=\"save-module-settings-button\" \nclass=\"md-raised md-accent\" ng-click=\"vm.saveModuleSettings()\" \nng-disabled=\"equipmentsForm.$invalid || equipmentsForm.$pristine || vm.disableButton\" \ntranslate=\"MODULES.SAVE_SETTINGS\">SAVE SETTINGS</md-button></div><div class=\"module-sidenav__button-container\" \nlayout=\"row\" layout-align=\"start center\" ng-if=\"!vm.configuration.isEnable\"><md-button \ndata-cy=\"request-activation-button\" class=\"md-raised md-accent\" ng-click=\"vm.requestActivation()\" \nng-disabled=\"vm.disableButton\" translate=\"MODULES.HIRING\">HIRING</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/image-resolution/image-resolution.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" \ntranslate=\"IMAGE_RESOLUTION_MODULE.TITLE\">Image resolution</span></div></div><div class=\"sidebar-dialog__actions\">\n<md-button class=\"md-icon-button\" aria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate \ntranslate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-list class=\"module-sidenav__content\" ms-scroll \nng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><p class=\"no-config\" translate=\"MODULES.NO_CONFIG\">\nThere is no configuration available for this module</p></md-list><div class=\"module-sidenav__description\" ms-scroll \nng-show=\"!vm.showModuleSettings\"><div class=\"module-sidenav__description__title\" layout=\"row\" \nlayout-align=\"space-between center\"><span ng-if=\"!vm.configuration.isPaid\" class=\"badge free\" \ntranslate=\"MODULES.FREE_MODULE\">free module</span> <span ng-if=\"vm.configuration.isPaid\" class=\"badge paid\" \ntranslate=\"MODULES.PAID_MODULE\">paid module</span></div><p translate=\"IMAGE_RESOLUTION_MODULE.TEXT\">\nHave more quality in the images of your calls to give even more clarity in your calls with more detailed images about the service that was performed on your customers.\n</p><ul><li ng-repeat=\"item in (\'IMAGE_RESOLUTION_MODULE.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.configuration.isEnable\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.requestActivation()\" ng-disabled=\"vm.disableButton\" \ntranslate=\"MODULES.HIRING\">HIRING</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/materials/materials.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"MATERIALS_MODULE.TITLE\">\nMaterials</span></div></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" \naria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list class=\"module-sidenav__content\" \nms-scroll ng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><p class=\"no-config\" \ntranslate=\"MODULES.NO_CONFIG\">There is no configuration available for this module</p></md-list><div \nclass=\"module-sidenav__description\" ms-scroll ng-show=\"!vm.showModuleSettings\"><div \nclass=\"module-sidenav__description__title\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"!vm.configuration.isPaid\" class=\"badge free\" translate=\"MODULES.FREE_MODULE\">free module</span> <span \nng-if=\"vm.configuration.isPaid\" class=\"badge paid\" translate=\"MODULES.PAID_MODULE\">paid module</span></div><div \nclass=\"module-video__container\"><img class=\"module-video__container__background\" \nsrc=\"assets/images/modules/materials-video.jpg\" alt=\"{{ \'MATERIALS_MODULE.TITLE\' | translate }}\"><div \nclass=\"module-video__container__filter\"></div><a class=\"module-video__container__play-button\" \nhref=\"https://www.youtube.com/watch?v=zfnPTZ4u9Es\" target=\"_blank\"><img src=\"assets/images/modules/play-button.svg\" \nalt=\"{{ \'MODULES.MODULE_VIDEO.PLAY_BUTTON\' | translate }}\"></a></div><p translate=\"MATERIALS_MODULE.TEXT\">\nRegister all the materials used by your employees in daily visits to have greater control of your company\'s stock.</p>\n<ul><li ng-repeat=\"item in (\'MATERIALS_MODULE.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"!vm.configuration.isEnable\" class=\"md-raised md-accent\" ng-click=\"vm.changeModule(true)\" \nng-disabled=\"vm.disableButton\" translate=\"MODULES.ENABLE\">ENABLE</md-button><md-button \nng-if=\"vm.configuration.isEnable\" class=\"md-raised disable-button\" ng-click=\"vm.changeModule(false)\" \nng-disabled=\"vm.disableButton\" translate=\"MODULES.DISABLE\">DISABLE</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/print-configuration/print-configuration.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium print-configuration-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" \ntranslate=\"PRINT_CONFIGURATION_MODULE.TITLE\">Print configuration</span></div><div class=\"sidebar-dialog__actions\">\n<md-button class=\"md-icon-button\" aria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate \ntranslate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-list class=\"module-sidenav__content\" ms-scroll ng-show=\"!vm.printConfigurationLoading\"><form \nname=\"printConfigurationForm\" novalidate><h3 class=\"print-configuration-sidenav__title\" \ntranslate=\"PRINT_CONFIGURATION_MODULE.SUBTITLES.GENERAL\">General</h3><div class=\"print-configuration-sidenav__block\">\n<label translate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.COMPLEMENTARY_INFO\">Complementary information</label><small\n translate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.COMPLEMENTARY_INFO_DESCRIPTION\">\nThe information written here will be displayed on all service orders.</small><div class=\"mt-5\" flex=\"100\">\n<fc-smart-rewrite reference-id=\"vm.account.id\" reference-type=\"print-configuration-complementary-info\"><fc-textarea \nng-model=\"vm.printConfiguration.complementaryInfos\" input-name=\"complementaryInfos\" \ninput-control=\"printConfigurationForm.complementaryInfos\" max-length=\"2000\"></fc-textarea></fc-smart-rewrite></div>\n</div><div class=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.CUSTOMER_NOTES\">Customer notes</label><md-switch \ndata-cy=\"custumer-notes-switch\" class=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.showCustomerNotes\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.CUSTOMER_NOTES_DESCRIPTION\">Show customer notes.</small></div><div\n class=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.SHOW_START_AND_COMPLETE_TIME\">Show Date and Time</label><md-switch\n data-cy=\"custumer-notes-switch\" class=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.showStartAndCompleteTime\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.SHOW_START_AND_COMPLETE_TIME_DESCRIPTION\">\nShow the start and completion date and time of tasks in the report.</small></div><div \nclass=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.TASK_DURATION\">Task duration</label><md-switch \ndata-cy=\"custumer-notes-switch\" class=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.showTaskDuration\" \naria-label=\"{{\'PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.TASK_DURATION\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.TASK_DURATION_DESCRIPTION\">Show task duraation.</small></div><div \nclass=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.ORDER_CREATED_AT\">Creation date of the service order</label>\n<md-switch data-cy=\"order-creation-date-switch\" class=\"ml-10 mt-0\" \nng-model=\"vm.printConfiguration.showOrderCreationDate\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.ORDER_CREATED_AT_DESCRIPTION\">\nShow creation order in service orders.</small></div><div class=\"print-configuration-sidenav__block\"><div layout=\"row\" \nlayout-align=\"space-between\" class=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.EMPLOYEE_IMAGE\">Employee image</label><md-switch \ndata-cy=\"employee-image-switch\" class=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.showEmployeeImage\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.EMPLOYEE_IMAGE.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.EMPLOYEE_IMAGE_DESCRIPTION\">\nShow an image of the employee responsible for the activity.</small></div><div \nclass=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.AUTO_PAGE_BREAK\">Page break</label><md-switch \ndata-cy=\"auto-page-break-switch\" class=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.autoPageBreak\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.AUTO_PAGE_BREAK_DESCRIPTION\">\nStart sections of the report on new pages.</small></div><div class=\"print-configuration-sidenav__block\"><div \nlayout=\"row\" layout-align=\"space-between\" class=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.EMPLOYEE_COORDINATES\">Employee coordinates</label><md-switch \ndata-cy=\"employees-coordinates-switch\" class=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.showEmployeesCoordinates\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.EMPLOYEE_COORDINATES.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.EMPLOYEE_COORDINATES_DESCRIPTION\">\nShow employee\'s coordinates at the start and end of the activity.</small></div><md-divider></md-divider><h3 \nclass=\"print-configuration-sidenav__title\" translate=\"PRINT_CONFIGURATION_MODULE.SUBTITLES.FORMS\">Forms</h3><div \nclass=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_FILLING_DATA\">View form filling data</label><md-switch \ndata-cy=\"form-filling-data-switch\" class=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.showFormFillingData\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_FILLING_DATA_DESCRIPTION\">\nDisplays the date of completion with the form.</small></div><div class=\"print-configuration-sidenav__block\"><div \nlayout=\"row\" layout-align=\"space-between\" class=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_SELECTED_RESPONSES\">Display only selected responses</label>\n<md-switch data-cy=\"form-selected-responses-switch\" class=\"ml-10 mt-0\" \nng-model=\"vm.printConfiguration.showFormSelectedResponses\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_SELECTED_RESPONSES_DESCRIPTION\">\nFor multiple choice or checklist questions, only the selected alternatives will be displayed.</small></div><div \nclass=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_TOTAL_SCORE\">Display form total score</label><md-switch \ndata-cy=\"form-total-score-switch\" class=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.showFormTotalScore\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_TOTAL_SCORE_DESCRIPTION\">\nDisplays the total score next to the form title.</small></div><div class=\"print-configuration-sidenav__block\"><div \nlayout=\"row\" layout-align=\"space-between\" class=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_HIDE_QUESTIONS_WITHOUT_ANSWERS\">\nShow only questions with answers.</label><md-switch data-cy=\"hide-questions-without-answers-switch\" class=\"ml-10 mt-0\" \nng-model=\"vm.printConfiguration.hideQuestionsWithoutAnswers\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_HIDE_QUESTIONS_WITHOUT_ANSWERS_DESCRIPTION\">\nQuestions of any kind will not be displayed if unanswered.</small></div><div \nclass=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_DISPLAY_RESPONSES_IN_A_SINGLE_COLUMN\">\nDisplay form responses in a single column</label><md-switch data-cy=\"see-form-answers-in-one-column-switch\" \nclass=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.seeFormAnswersInOneColumn\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_DISPLAY_RESPONSES_IN_A_SINGLE_COLUMN_DESCRIPTION\">\nQuestions of any kind will not be displayed if unanswered.</small></div><div \nclass=\"print-configuration-sidenav__block\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORMS_ORDINATION\">Forms ordination</label><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORMS_ORDINATION_DESCRIPTION\">\nShow the order of forms according to the chosen option.</small><md-select data-cy=\"sort-forms-by-select\" \nng-model=\"vm.printConfiguration.sortFormsBy\" placeholder=\"Sort Forms By\"><md-option \nng-repeat=\"(key, value) in vm.sortFormsByOptions\" ng-value=\"key\" \nng-selected=\"vm.printConfiguration.sortFormsBy == key\" ng-bind=\"value\"></md-option></md-select></div><div \nclass=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_QUESTIONS_DESCRIPTION\">View form questions description\n</label><md-switch data-cy=\"show-options-descriptions-switch\" class=\"ml-10 mt-0\" \nng-model=\"vm.printConfiguration.showOptionsDescriptions\" \naria-label=\"{{\'PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_QUESTIONS_DESCRIPTION\' | translate}}\"></md-switch></div>\n<small translate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.FORM_QUESTIONS_DESCRIPTION_DESCRIPTION\">\nDisplays the description with the form questions.</small></div><md-divider></md-divider><h3 \nclass=\"print-configuration-sidenav__title\" translate=\"PRINT_CONFIGURATION_MODULE.SUBTITLES.EQUIPMENTS\">Equipments</h3>\n<div class=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.EQUIPMENTS_QR_CODE\">Display QR code of equipment</label><md-switch\n data-cy=\"show-equipments-qrcode-switch\" class=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.showEquipmentsQrCode\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.EQUIPMENTS_QR_CODE_DESCRIPTION\">\nDisplays the QR code of the equipment next to the equipment information.</small></div><div \nclass=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.CUSTOM_FIELDS_EQUIPMENTS\">Custom Fields Equipments</label>\n<md-switch data-cy=\"show-equipments-custom-fields-switch\" class=\"ml-10 mt-0\" \nng-model=\"vm.printConfiguration.showEquipmentsCustomFields\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.CUSTOM_FIELDS_EQUIPMENTS_DESCRIPTION\">\nShow custom fields for linked equipment in service orders.</small></div><div \nclass=\"print-configuration-sidenav__block\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.EQUIPMENTS_ORDINATION\">Equipments ordination</label><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.EQUIPMENTS_ORDINATION_DESCRIPTION\">\nShow the order of equipments according to the chosen option.</small><md-select data-cy=\"sort-equipments-by-select\" \nng-model=\"vm.printConfiguration.sortEquipmentsBy\" placeholder=\"Sort Equipments By\"><md-option \nng-repeat=\"(key, value) in vm.sortEquipmentsByOptions\" ng-value=\"key\" \nng-selected=\"vm.printConfiguration.sortEquipmentsBy == key\" ng-bind=\"value\"></md-option></md-select></div><md-divider>\n</md-divider><h3 class=\"print-configuration-sidenav__title\" translate=\"PRINT_CONFIGURATION_MODULE.SUBTITLES.PRODUCTS\">\nProducts</h3><div class=\"print-configuration-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"print-configuration-sidenav__block__item\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.HIDE_PRODUCT_VALUE\">Hide the product value</label><md-switch \ndata-cy=\"hide-product-value-switch\" class=\"ml-10 mt-0\" ng-model=\"vm.printConfiguration.hideProductValue\"></md-switch>\n</div><small translate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.HIDE_PRODUCT_VALUE_DESCRIPTION\">\nIf enabled, the value of the products used in the activities will be hidden from the employee.</small></div>\n<md-divider></md-divider><h3 class=\"print-configuration-sidenav__title\" \ntranslate=\"PRINT_CONFIGURATION_MODULE.SUBTITLES.ATTACHMENTS\">Attachments</h3><div \nclass=\"print-configuration-sidenav__block\"><div layout=\"row\"><label \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.ATTACHMENTS_PER_ROW\">Number of attachments per row:</label>\n<md-select data-cy=\"attachments-columns-quantity-select\" \nplaceholder=\"{{ \'PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.ATTACHMENTS_PER_ROW_PLACEHOLDER \' | translate }}\" \nng-model=\"vm.printConfiguration.attachmentsColumnsQuantity\"><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option></md-select></div><small \ntranslate=\"PRINT_CONFIGURATION_MODULE.CONFIGURATIONS.ATTACHMENTS_PER_ROW_DESCRIPTION\">\nThe quantity selected here will be the number of attachments per line in the service order.</small></div></form>\n</md-list><div class=\"print-configuration-dialog__loading\" ng-show=\"vm.printConfigurationLoading\"><md-progress-circular\n md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div class=\"module-sidenav__button-container\" \nlayout=\"row\" layout-align=\"start center\"><md-button data-cy=\"save-configuration-button\" class=\"md-raised md-accent\" \nng-click=\"vm.saveConfiguration()\" \nng-disabled=\"printConfigurationForm.$invalid || printConfigurationForm.$pristine || vm.disableButton\" \ntranslate=\"PRINT_CONFIGURATION_MODULE.SAVE_CONFIGURATION\">SAVE CONFIGURATION</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/route-optimizer/route-optimizer.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"ROUTE_OPTIMIZER_MODULE.TITLE\">\nRoute optmizer</span></div></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" \naria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list class=\"module-sidenav__content\" \nms-scroll ng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><div class=\"general-body\"><div \nclass=\"data-container info-div\"><span><md-icon class=\"primary-coloring\" md-svg-src=\"assets/icons/icon-insights.svg\">\n</md-icon></span><div class=\"info-data\"><span translate=\"ROUTE_OPTIMIZER_MODULE.INFO\">\nO módulo de reescrita inteligente é uma ferramenta essencial para manter uma comunicação sem ruídos com seus clientes, evitando que eles percam a confiança em sua empresa devido à erros de digitação da sua equipe.\n</span></div></div><div class=\"container-reinformation data-container\"><div layout=\"column\"><span class=\"graying-text\" \ntranslate=\"ROUTE_OPTIMIZER_MODULE.AVULSE_CREDITS\">Créditos avulsos</span> <span class=\"bolding-text\">\n{{ vm.credits | thousandSeparator:true }} <span translate=\"ROUTE_OPTIMIZER_MODULE.ROUTE_CREDITS\">créditos de reescrita\n</span></span></div><div ng-if=\"vm.isAdvancedModuleEnabled\" ng-click=\"vm.buyCredits()\" class=\"hire-button\"><span \nclass=\"hire-text\" translate=\"ROUTE_OPTIMIZER_MODULE.HIRE_MORE\"></span></div></div><div \nng-if=\"!vm.isAdvancedModuleEnabled\" class=\"config-container data-container\" layout=\"row\" layout-align=\"center\"><span \nclass=\"config-text\" translate=\"MODULES.NO_CONFIG\">\nO módulo está ativo, mas não há nenhuma configuração adicional disponível.</span></div></div></md-list><div \nclass=\"module-sidenav__description\" ms-scroll ng-show=\"!vm.showModuleSettings\"><div \nclass=\"module-sidenav__description__title\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"!vm.configuration.isPaid\" class=\"badge free\" translate=\"MODULES.FREE_MODULE\">free module</span> <span \nng-if=\"vm.configuration.isPaid\" class=\"badge paid\" translate=\"MODULES.PAID_MODULE\">paid module</span></div><p \ntranslate=\"ROUTE_OPTIMIZER_MODULE.TEXT\">\nAutomate the routes of all employees through artificial intelligence that identifies the best possible routes to save time and gas.\n</p><ul><li ng-repeat=\"item in (\'ROUTE_OPTIMIZER_MODULE.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nng-if=\"vm.showModuleSettings\" class=\"module-sidenav__button-container footer-data\" layout=\"column\" \nlayout-align=\"center\"><span><b translate=\"SMART_REWRITE_MODULES.MANAGE_SUBSCRIPTION\">Would you like to manage</b>\n</span> <span class=\"footer-info\"><span translate=\"SMART_REWRITE_MODULES.CONTACT\">Entre em contato com </span><a \nhref=\"mailto:suporte@fieldcontrol.com.br\">suporte@fieldcontrol.com.br </a><span \ntranslate=\"SMART_REWRITE_MODULES.CONTACT_END\">ou fale com seu gerente de conta.</span></span></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.configuration.isEnable\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.requestActivation()\" ng-disabled=\"vm.disableButton\" \ntranslate=\"MODULES.HIRING\">HIRING</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/smart-rewrite/smart-rewrite.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium smart-rewrite-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"SMART_REWRITE_MODULES.TITLE\">\nSmart rewrite</span></div></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" \naria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list \nclass=\"module-sidenav__content no-padding-smart-rewrite smart-rewrite-tabs\" \nng-class=\"{ \'tablist-full-height\': vm.activeTab === 1 }\" ms-scroll \nng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><md-tabs md-dynamic-height md-selected=\"vm.activeTab\">\n<md-tab label=\"0\"><md-tab-label><span translate=\"SMART_REWRITE_MODULES.GENERAL\">General</span></md-tab-label>\n<md-tab-body><div class=\"general-body\"><div class=\"data-container info-div\"><span><md-icon class=\"primary-coloring\" \nmd-svg-src=\"assets/icons/icon-insights.svg\"></md-icon></span><div class=\"info-data\"><span \ntranslate=\"SMART_REWRITE_MODULES.INFO\">\nO módulo de reescrita inteligente é uma ferramenta essencial para manter uma comunicação sem ruídos com seus clientes, evitando que eles percam a confiança em sua empresa devido à erros de digitação da sua equipe. \n</span><a ng-click=\"vm.openVideoModal()\">{{ \'SMART_REWRITE_MODULES.CLICK_HERE\' | translate }}</a> <span>\n{{ \'SMART_REWRITE_MODULES.INFO_END\' | translate }}</span></div></div><div class=\"container-information data-container\">\n<div layout=\"column\"><span class=\"graying-text\" translate=\"SMART_REWRITE_MODULES.MONTHLY_PLAN\">Plano mensal</span> \n<span class=\"bolding-text\">{{ vm.maxCredits | thousandSeparator:true }} <span \ntranslate=\"SMART_REWRITE_MODULES.REWRITE_CREDITS\">créditos de reescrita</span></span></div><div class=\"bullet-pointer\" \nng-class=\"{\n                        \'blue-pointer-bg\': vm.maxCredits - 100 > vm.usedCredits,\n                        \'yellow-pointer-bg\':  vm.usedCredits >= vm.maxCredits - 100 && vm.maxCredits > vm.usedCredits,\n                        \'danger-pointer-bg\': vm.usedCredits >= vm.maxCredits\n                      }\">\n<span><span>{{ (vm.usedCredits >= vm.maxCredits ? vm.maxCredits : vm.usedCredits) }}/{{ vm.maxCredits }}</span> <span \ntranslate=\"SMART_REWRITE_MODULES.USED_CREDITS\">créditos utilizados</span></span></div></div><div \nclass=\"config-container data-container\" layout=\"row\" layout-align=\"center\"><span class=\"config-text\" \ntranslate=\"MODULES.NO_CONFIG\">O módulo está ativo, mas não há nenhuma configuração adicional disponível.</span></div>\n</div></md-tab-body></md-tab><md-tab label=\"1\"><md-tab-label><span translate=\"SMART_REWRITE_MODULES.HISTORY\">History\n</span></md-tab-label><md-tab-body><div class=\"no-history-body\" ng-if=\"vm.items && !vm.items.length\"><div \nclass=\"no-history-info\"><p class=\"no-history-text\" translate=\"SMART_REWRITE_MODULES.NO_CREDIT\">No credits used</p>\n</div></div><div class=\"history-body\" ng-if=\"vm.olderItems || vm.yesterdayItems || vm.todayItems || vm.items\"><div \nclass=\"history-partition\"><p class=\"title-text\" ng-if=\"vm.todayItems && vm.todayItems.length > 0\" \ntranslate=\"SMART_REWRITE_MODULES.TODAY\"></p><div class=\"history-repeater\"><div ng-repeat=\"item in vm.todayItems\" \nclass=\"history-container\"><div class=\"history-div\"><div class=\"history-icon\"><md-icon \nclass=\"primary-coloring icon-sizing\" md-svg-src=\"assets/icons/icon-clock-dotted.svg\"></md-icon></div><div \nclass=\"history-bar\"></div></div><div class=\"history-data\"><div class=\"history-item-info\"><p \nclass=\"no-margin-paragraph\">\n{{ \'SMART_REWRITE_MODULES.HISTORY_TYPES.\' + (item.rewriteType || \'\').toUpperCase() | translate }}</p><p \nclass=\"no-margin-paragraph history-created-at\">{{ item.displayDate }}</p></div><div class=\"history-item-creator\">\n<md-icon class=\"history-creator-icon s18\" \nmd-svg-src=\"assets/icons/icon-{{item.createdByApp === \'orc\' || item.createdByApp === \'orc-pwa\' ? \'phone\' : \'computer\'}}.svg\">\n</md-icon><p class=\"no-margin-paragraph creator-text\">\n{{ \'SMART_REWRITE_MODULES.ALTERED_BY\' | translate : { name: item.createdByName, platform: (\'SMART_REWRITE_MODULES.PLATFORMS.\' + (item.createdByApp || \'\').toUpperCase() | translate) } }}\n</p></div><div class=\"history-item-value\"><span class=\"no-margin-paragraph bolded-text\">\n{{ \'SMART_REWRITE_MODULES.TOTAL_VALUE\' | translate }} </span><span class=\"no-margin-paragraph\">\n{{ \'SMART_REWRITE_MODULES.CREDITS\' | translate:{ value: (( (vm.maxCredits - item.newCreditsUsageTotal) | thousandSeparator:true ))} }}\n</span></div></div></div></div></div><div class=\"history-partition\"><p class=\"title-text\" \nng-if=\"vm.yesterdayItems && vm.yesterdayItems.length > 0\" translate=\"SMART_REWRITE_MODULES.YESTERDAY\"></p><div \nclass=\"history-repeater\"><div ng-repeat=\"item in vm.yesterdayItems\" class=\"history-container\"><div class=\"history-div\">\n<div class=\"history-icon\"><md-icon class=\"primary-coloring icon-sizing\" \nmd-svg-src=\"assets/icons/icon-clock-dotted.svg\"></md-icon></div><div class=\"history-bar\"></div></div><div \nclass=\"history-data\"><div class=\"history-item-info\"><p class=\"no-margin-paragraph\">\n{{ \'SMART_REWRITE_MODULES.HISTORY_TYPES.\' + (item.rewriteType || \'\').toUpperCase() | translate }}</p><p \nclass=\"no-margin-paragraph history-created-at\">{{ item.displayDate }}</p></div><div class=\"history-item-creator\">\n<md-icon class=\"history-creator-icon s18\" \nmd-svg-src=\"assets/icons/icon-{{item.createdByApp === \'orc\' || item.createdByApp === \'orc-pwa\' ? \'phone\' : \'computer\'}}.svg\">\n</md-icon><p class=\"no-margin-paragraph creator-text\">\n{{ \'SMART_REWRITE_MODULES.ALTERED_BY\' | translate : { name: item.createdByName, platform: (\'SMART_REWRITE_MODULES.PLATFORMS.\' + (item.createdByApp || \'\').toUpperCase() | translate) } }}\n</p></div><div class=\"history-item-value\"><span class=\"no-margin-paragraph bolded-text\">\n{{ \'SMART_REWRITE_MODULES.TOTAL_VALUE\' | translate }} </span><span class=\"no-margin-paragraph\">\n{{ \'SMART_REWRITE_MODULES.CREDITS\' | translate:{ value: (( (vm.maxCredits - item.newCreditsUsageTotal) | thousandSeparator:true ))} }}\n</span></div></div></div></div></div><div class=\"history-partition\"><p class=\"title-text\" \nng-if=\"vm.olderItems && vm.olderItems.length > 0\" translate=\"SMART_REWRITE_MODULES.ANTERIOR\"></p><div \nclass=\"history-repeater\"><div ng-repeat=\"item in vm.olderItems\" class=\"history-container\"><div class=\"history-div\"><div\n class=\"history-icon\"><md-icon class=\"primary-coloring icon-sizing\" md-svg-src=\"assets/icons/icon-clock-dotted.svg\">\n</md-icon></div><div class=\"history-bar\"></div></div><div class=\"history-data\"><div class=\"history-item-info\"><p \nclass=\"no-margin-paragraph\">\n{{ \'SMART_REWRITE_MODULES.HISTORY_TYPES.\' + (item.rewriteType || \'\').toUpperCase() | translate }}</p><p \nclass=\"no-margin-paragraph history-created-at\">{{ item.displayDate }}</p></div><div class=\"history-item-creator\">\n<md-icon class=\"history-creator-icon s18\" \nmd-svg-src=\"assets/icons/icon-{{item.createdByApp === \'orc\' || item.createdByApp === \'orc-pwa\' ? \'phone\' : \'computer\'}}.svg\">\n</md-icon><p class=\"no-margin-paragraph creator-text\">\n{{ \'SMART_REWRITE_MODULES.ALTERED_BY\' | translate : { name: item.createdByName, platform: (\'SMART_REWRITE_MODULES.PLATFORMS.\' + (item.createdByApp || \'\').toUpperCase() | translate) } }}\n</p></div><div class=\"history-item-value\"><span class=\"no-margin-paragraph bolded-text\">\n{{ \'SMART_REWRITE_MODULES.TOTAL_VALUE\' | translate }} </span><span class=\"no-margin-paragraph\">\n{{ \'SMART_REWRITE_MODULES.CREDITS\' | translate:{ value: (( (vm.maxCredits - item.newCreditsUsageTotal) | thousandSeparator:true ))} }}\n</span></div></div></div></div></div><div class=\"button-divider\" ng-if=\"vm.canLoadMore\"><div ng-click=\"vm.loadMore()\" \nclass=\"load-more-button\"><span class=\"hire-text\" translate=\"SMART_REWRITE_MODULES.LOAD_MORE\"></span></div></div></div>\n</md-tab-body></md-tab></md-tabs></md-list><div class=\"module-sidenav__description\" ms-scroll \nng-show=\"!vm.showModuleSettings\"><div class=\"module-sidenav__description__title\" layout=\"row\" \nlayout-align=\"space-between center\"><span ng-if=\"!vm.configuration.isPaid\" class=\"badge free\" \ntranslate=\"MODULES.FREE_MODULE\">free module</span> <span ng-if=\"vm.configuration.isPaid\" class=\"badge paid\" \ntranslate=\"MODULES.PAID_MODULE\">paid module</span></div><p translate=\"SMART_REWRITE_MODULES.TEXT\">\nRewrite all your texts with an insane ai assistant.</p><ul><li \nng-repeat=\"item in (\'SMART_REWRITE_MODULES.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nng-if=\"vm.showModuleSettings\" class=\"module-sidenav__button-container footer-data\" layout=\"column\" \nlayout-align=\"center\"><span><b translate=\"SMART_REWRITE_MODULES.MANAGE_SUBSCRIPTION\">Would you like to manage</b>\n</span> <span class=\"footer-info\"><span translate=\"SMART_REWRITE_MODULES.CONTACT\">Entre em contato com </span><a \nhref=\"mailto:suporte@fieldcontrol.com.br\">suporte@fieldcontrol.com.br </a><span \ntranslate=\"SMART_REWRITE_MODULES.CONTACT_END\">ou fale com seu gerente de conta.</span></span></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.configuration.isEnable\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.requestActivation()\" ng-disabled=\"vm.disableButton\" \ntranslate=\"MODULES.HIRING\">HIRING</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/storage-control/storage-control.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" \ntranslate=\"STORAGE_CONTROL_MODULES.TITLE\">Storage</span></div></div><div class=\"sidebar-dialog__actions\"><md-button \nclass=\"md-icon-button\" aria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate \ntranslate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-list class=\"module-sidenav__content\" ms-scroll \nng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><p class=\"no-config\" translate=\"MODULES.NO_CONFIG\">\nThere is no configuration available for this module</p></md-list><div class=\"module-sidenav__description\" ms-scroll \nng-show=\"!vm.showModuleSettings\"><div class=\"module-sidenav__description__title\" layout=\"row\" \nlayout-align=\"space-between center\"><span ng-if=\"!vm.configuration.isPaid\" class=\"badge free\" \ntranslate=\"MODULES.FREE_MODULE\">free module</span> <span ng-if=\"vm.configuration.isPaid\" class=\"badge paid\" \ntranslate=\"MODULES.PAID_MODULE\">paid module</span></div><p translate=\"STORAGE_CONTROL_MODULES.TEXT\">\nRegister all the materials used by your employees in daily visits to have greater control of your company\'s storage.\n</p><ul><li ng-repeat=\"item in (\'STORAGE_CONTROL_MODULES.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.configuration.isEnable\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.requestActivation()\" ng-disabled=\"vm.disableButton\" \ntranslate=\"MODULES.HIRING\">HIRING</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/tasks-plans/tasks-plans.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"TASKS_PLANS_MODULE.TITLE\">\nTasks Plans</span></div></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" \naria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-list class=\"module-sidenav__content\" ms-scroll \nng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><p class=\"no-config\" translate=\"MODULES.NO_CONFIG\">\nThere is no configuration available for this module</p></md-list><div class=\"module-sidenav__description\" ms-scroll \nng-show=\"!vm.showModuleSettings\"><div class=\"module-sidenav__description__title\" layout=\"row\" \nlayout-align=\"space-between center\"><span ng-if=\"!vm.configuration.isPaid\" class=\"badge free\" \ntranslate=\"MODULES.FREE_MODULE\">free module</span> <span ng-if=\"vm.configuration.isPaid\" class=\"badge paid\" \ntranslate=\"MODULES.PAID_MODULE\">paid module</span></div><p translate=\"TASKS_PLANS_MODULE.TEXT\">\nRegister all the materials used by your employees in daily visits to have greater control of your company\'s stock.</p>\n<ul><li ng-repeat=\"item in (\'TASKS_PLANS_MODULE.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"!vm.configuration.isEnable\" class=\"md-raised md-accent\" ng-click=\"vm.changeModule(true)\" \nng-disabled=\"vm.disableButton\" translate=\"MODULES.ENABLE\">ENABLE</md-button><md-button \nng-if=\"vm.configuration.isEnable\" class=\"md-raised disable-button\" ng-click=\"vm.changeModule(false)\" \nng-disabled=\"vm.disableButton\" translate=\"MODULES.DISABLE\">DISABLE</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/templates/templates.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"TEMPLATES_MODULE.TITLE\">\nTemplates</span></div></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" \naria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list class=\"module-sidenav__content\" \nms-scroll ng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><p class=\"no-config\" \ntranslate=\"MODULES.NO_CONFIG\">There is no configuration available for this module</p></md-list><div \nclass=\"module-sidenav__description\" ms-scroll ng-show=\"!vm.showModuleSettings\"><div \nclass=\"module-sidenav__description__title\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"!vm.configuration.isPaid\" class=\"badge free\" translate=\"MODULES.FREE_MODULE\">free module</span> <span \nng-if=\"vm.configuration.isPaid\" class=\"badge paid\" translate=\"MODULES.PAID_MODULE\">paid module</span></div><p \ntranslate=\"TEMPLATES_MODULE.TEXT\">\nRegister all the materials used by your employees in daily visits to have greater control of your company\'s storage.\n</p><ul><li ng-repeat=\"item in (\'TEMPLATES_MODULE.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.configuration.isEnable\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.requestActivation()\" ng-disabled=\"vm.disableButton\" \ntranslate=\"MODULES.HIRING\">HIRING</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/territories/territories.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"TERRITORIES_MODULE.TITLE\">\nStorage</span></div></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" \naria-label=\"Close Dialog\" ng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list class=\"module-sidenav__content\" \nms-scroll ng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><p class=\"no-config\" \ntranslate=\"MODULES.NO_CONFIG\">There is no configuration available for this module</p></md-list><div \nclass=\"module-sidenav__description\" ms-scroll ng-show=\"!vm.showModuleSettings\"><div \nclass=\"module-sidenav__description__title\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"!vm.configuration.isPaid\" class=\"badge free\" translate=\"MODULES.FREE_MODULE\">free module</span> <span \nng-if=\"vm.configuration.isPaid\" class=\"badge paid\" translate=\"MODULES.PAID_MODULE\">paid module</span></div><p \ntranslate=\"TERRITORIES_MODULE.TEXT\">\nRegister all the materials used by your employees in daily visits to have greater control of your company\'s storage.\n</p><ul><li ng-repeat=\"item in (\'TERRITORIES_MODULE.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"!vm.configuration.isEnable\" class=\"md-raised md-accent\" ng-click=\"vm.changeModule(true)\" \nng-disabled=\"vm.disableButton\" translate=\"MODULES.ENABLE\">ENABLE</md-button><md-button \nng-if=\"vm.configuration.isEnable\" class=\"md-raised disable-button\" ng-click=\"vm.changeModule(false)\" \nng-disabled=\"vm.disableButton\" translate=\"MODULES.DISABLE\">DISABLE</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/tickets/tickets.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium tickets-dialog\"><md-toolbar class=\"sidebar-dialog__header\"><div\n class=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"TICKETS_MODULE.TITLE\">Tickets\n</span></div></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" aria-label=\"Close Dialog\" \nng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list class=\"module-sidenav__content\" ms-scroll \nng-show=\"((vm.configuration.isEnable && vm.showModuleSettings) || vm.forceConfiguration) && !vm.ticketsLoading\"><form \nname=\"ticketsForm\" novalidate><md-list-item><md-input-container><label translate=\"TICKETS_MODULE.TASKS.TITLE\">\nOS types available:</label><md-select data-md-container-class=\"module-sidenav__content__select\" multiple=\"true\" \nname=\"serviceType\" required ng-model=\"vm.ticketsSettings.services\" ng-model-options=\"{trackBy: \'$value.description\'}\" \nmd-on-close=\"vm.searchServiceTypeTerm = \'\'\"><md-select-header><input type=\"search\" ng-model=\"vm.searchServiceTypeTerm\" \nonkeydown=\"event.stopPropagation()\" translate translate-attr-placeholder=\"TICKETS_MODULE.TASKS.SEARCH\" \nplaceholder=\"Search for a type service...\"></md-select-header><md-optgroup><md-option ng-value=\"service\" \nng-repeat=\"service in vm.services | filter:vm.searchServiceTypeTerm\">\n{{(service.description && service.description.length) > 60 ? service.description.substring(0,60) + \'...\' : service.description }}\n</md-option></md-optgroup><md-select-footer ng-if=\"!(vm.services | filter:vm.searchServiceTypeTerm).length\"><span \ntranslate=\"MODULES.NO_OPTION_FOUND\">No options found</span></md-select-footer></md-select><md-icon class=\"grey-400-fg\" \nmd-font-icon=\"icon-question-mark-circle\"><md-tooltip md-direction=\"bottom\"><span translate=\"TICKETS_MODULE.TASKS.HINT\">\nOnly the OS types selected will be displayed when requesting a service.</span></md-tooltip></md-icon><div \nng-messages=\"ticketsForm.serviceType.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TICKETS_MODULE.TASKS.REQUIRED\">Required at least 1 OS types for call opening</span></div></div>\n</md-input-container></md-list-item><label class=\"module-sidenav__content__label\" \ntranslate=\"TICKETS_MODULE.SLUG.TITLE\">Complete your online address (link):</label><md-list-item><div \nclass=\"slug-container\" layout=\"row\"><div class=\"slug-container__start-url\" layout=\"row\" layout-align=\"end start\">\n{{vm.wargUrl}}</div><md-input-container class=\"md-button-right\" flex><input name=\"slug\" type=\"text\" minlength=\"2\" \nmaxlength=\"50\" required ng-model=\"vm.ticketsSettings.slug\" ng-model-options=\"{ debounce: 1000 }\" \nng-pattern=\"/^[a-z0-9]+(?:-[a-z0-9]+)*$/\" ng-change=\"vm.verifyTicketsSlug()\"><md-button class=\"md-icon-button\" \nngclipboard data-clipboard-text=\"{{ vm.wargUrl + vm.ticketsSettings.slug + vm.currentUnixTimeVersion }}\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"md-accent-fg\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"TICKETS_MODULE.SLUG.COPY_LINK\">Copy link</span></md-tooltip></md-button><md-icon class=\"grey-400-fg\" \nmd-font-icon=\"icon-question-mark-circle\"><md-tooltip md-direction=\"bottom\"><span translate=\"TICKETS_MODULE.SLUG.HINT\">\nThis will be your online address (link) for requesting services from your customers</span></md-tooltip></md-icon><div \nng-messages=\"ticketsForm.slug.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TICKETS_MODULE.SLUG.REQUIRED\">URL complement is required</span></div><div ng-message=\"existent\"><span \ntranslate=\"TICKETS_MODULE.SLUG.IN_USE\">The URL complement is already in use</span></div><div ng-message=\"pattern\"><span\n translate=\"TICKETS_MODULE.SLUG.INVALID\">The URL complement is in invalid format</span></div><div \nng-message=\"minlength\"><span translate=\"TICKETS_MODULE.SLUG.MIN\">The URL add-in must be at least 2 characters</span>\n</div><div ng-message=\"maxlength\"><span translate=\"TICKETS_MODULE.SLUG.MAX\">\nThe URL add-on must be a maximum of 50 characters</span></div></div></md-input-container></div></md-list-item><div \nclass=\"tickets-sidenav__block\"><div layout=\"row\" layout-align=\"space-between\" class=\"tickets-sidenav__block__item\">\n<label translate=\"TICKETS_MODULE.CONFIGURATIONS.SHOW_ADDRESS_FIELDS\">Show adress fields</label><md-switch \nclass=\"ml-10 mt-0\" ng-model=\"vm.tickets.featureShowAddressFields\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"TICKETS_MODULE.CONFIGURATIONS.SHOW_ADDRESS_FIELDS_DESCRIPTION\">Show address fields.</small></div><div \nclass=\"tickets-sidenav__block\" ng-if=\"vm.tickets.featureShowAddressFields\"><div layout=\"row\" \nlayout-align=\"space-between\" class=\"tickets-sidenav__block__item\"><label \ntranslate=\"TICKETS_MODULE.CONFIGURATIONS.MANDATORY_ADDRESS_FIELDS\">Mandatory address fields</label><md-switch \nclass=\"ml-10 mt-0\" ng-model=\"vm.tickets.featureMandatoryAddressFields\" \naria-label=\"{{\'CONFIGURATIONS.ORDERS.ALLOW_MULTIPLE_TASKS.TITLE\' | translate}}\"></md-switch></div><small \ntranslate=\"TICKETS_MODULE.CONFIGURATIONS.MANDATORY_ADDRESS_FIELDS_DESCRIPTION\">Mandatory address fields.</small></div>\n</form></md-list><div class=\"tickets-dialog__loading\" ng-show=\"vm.ticketsLoading\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div class=\"module-sidenav__description\" \nms-scroll ng-show=\"!vm.showModuleSettings && !vm.forceConfiguration\"><div class=\"module-sidenav__description__title\" \nlayout=\"row\" layout-align=\"space-between center\"><span ng-if=\"!vm.configuration.isPaid\" class=\"badge free\" \ntranslate=\"MODULES.FREE_MODULE\">free module</span> <span ng-if=\"vm.configuration.isPaid\" class=\"badge paid\" \ntranslate=\"MODULES.PAID_MODULE\">paid module</span></div><div class=\"module-video__container\"><img \nclass=\"module-video__container__background\" src=\"assets/images/modules/tickets-video.jpg\" \nalt=\"{{ \'TICKETS_MODULE.TITLE\' | translate }}\"><div class=\"module-video__container__filter\"></div><a \nclass=\"module-video__container__play-button\" href=\"https://www.youtube.com/watch?v=kaPwgZ6FLKY\" target=\"_blank\"><img \nsrc=\"assets/images/modules/play-button.svg\" alt=\"{{ \'MODULES.MODULE_VIDEO.PLAY_BUTTON\' | translate }}\"></a></div><p \ntranslate=\"TICKETS_MODULE.TEXT\">\nReceive requests from your customers through a single panel and reduce the waiting time for customer service.</p><ul>\n<li ng-repeat=\"item in (\'TICKETS_MODULE.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"vm.configuration.isEnable && vm.showModuleSettings\" class=\"md-raised md-accent\" \nng-click=\"vm.saveModuleSettings()\" ng-disabled=\"ticketsForm.$invalid || ticketsForm.$pristine || vm.disableButton\" \ntranslate=\"MODULES.SAVE_SETTINGS\">SAVE SETTINGS</md-button><md-button \nng-if=\"!vm.configuration.isEnable && !vm.forceConfiguration\" class=\"md-raised md-accent\" ng-click=\"vm.enableModule()\" \nng-disabled=\"vm.disableButton\" translate=\"MODULES.ENABLE\">ENABLE</md-button><md-button \nng-if=\"vm.configuration.isEnable && !vm.forceConfiguration\" class=\"md-raised disable-button\" \nng-click=\"vm.disableModule()\" ng-disabled=\"vm.disableButton\" translate=\"MODULES.DISABLE\">DISABLE</md-button><md-button \nng-if=\"!vm.configuration.isEnable && vm.forceConfiguration\" class=\"md-raised md-accent\" \nng-click=\"vm.finalizeModuleActivation()\" \nng-disabled=\"ticketsForm.$invalid || ticketsForm.$pristine || vm.disableButton\" translate=\"MODULES.END_ACTIVATION\">\nEND ACTIVATION</md-button><md-button ng-if=\"!vm.configuration.isEnable && vm.forceConfiguration\" \nclass=\"md-raised disable-button\" ng-click=\"vm.cancelModuleActivation()\" ng-disabled=\"vm.disableButton\" \ntranslate=\"MODULES.CANCEL\">CANCEL</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/vehicles/vehicles.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"VEHICLES.TITLE\">Vehicles\n</span></div></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" aria-label=\"Close Dialog\" \nng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list class=\"module-sidenav__content\" ms-scroll \nng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><p class=\"no-config\" translate=\"MODULES.NO_CONFIG\">\nThere is no configuration available for this module</p></md-list><div class=\"module-sidenav__description\" ms-scroll \nng-show=\"!vm.showModuleSettings\"><div class=\"module-sidenav__description__title\" layout=\"row\" \nlayout-align=\"space-between center\"><span ng-if=\"!vm.configuration.isPaid\" class=\"badge free\" \ntranslate=\"MODULES.FREE_MODULE\">free module</span> <span ng-if=\"vm.configuration.isPaid\" class=\"badge paid\" \ntranslate=\"MODULES.PAID_MODULE\">paid module</span></div><p translate=\"VEHICLES.TEXT\">\nRegister all the materials used by your employees in daily visits to have greater control of your company\'s stock.</p>\n<ul><li ng-repeat=\"item in (\'VEHICLES.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.configuration.isEnable\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.requestActivation()\" ng-disabled=\"vm.disableButton\" \ntranslate=\"MODULES.HIRING\">HIRING</md-button></div></md-dialog>");
$templateCache.put("app/main/modules/sidenavs/videos/videos.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><md-button ng-if=\"vm.showModuleSettings\" \nng-click=\"vm.showModuleSettings = false;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-information\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MODULES.SEE_DESCRIPTION\">See description</span></md-tooltip>\n</md-button><md-button ng-if=\"!vm.showModuleSettings && vm.configuration.isEnable\" \nng-click=\"vm.showModuleSettings = true;\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MODULES.SEE_SETTINGS\">See settings</span></md-tooltip></md-button><div \nclass=\"sidebar-dialog__header__title\"><span flex class=\"menu-title text-left\" translate=\"VIDEOS_MODULE.TITLE\">Video\n</span></div></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" aria-label=\"Close Dialog\" \nng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list class=\"module-sidenav__content\" ms-scroll \nng-show=\"vm.configuration.isEnable && vm.showModuleSettings\"><p class=\"no-config\" translate=\"MODULES.NO_CONFIG\">\nThere is no configuration available for this module</p></md-list><div class=\"module-sidenav__description\" ms-scroll \nng-show=\"!vm.showModuleSettings\"><div class=\"module-sidenav__description__title\" layout=\"row\" \nlayout-align=\"space-between center\"><span ng-if=\"!vm.configuration.isPaid\" class=\"badge free\" \ntranslate=\"MODULES.FREE_MODULE\">free module</span> <span ng-if=\"vm.configuration.isPaid\" class=\"badge paid\" \ntranslate=\"MODULES.PAID_MODULE\">paid module</span></div><p translate=\"VIDEOS_MODULE.TEXT\">\nHave more field service details with video uploads bringing greater clarity and are easy to identify issues with quality image and sound.\n</p><ul><li ng-repeat=\"item in (\'VIDEOS_MODULE.LIST\' | translate).split(\';\')\">{{ item }}</li></ul></div><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.configuration.isEnable\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.requestActivation()\" ng-disabled=\"vm.disableButton\" \ntranslate=\"MODULES.HIRING\">HIRING</md-button></div></md-dialog>");
$templateCache.put("app/main/notifications/sidenavs/notifications-sidenav/notifications-sidenav.html","<div class=\"notifications-sidenav\"><md-toolbar class=\"notifications-sidenav-header md-accent\"><div \nclass=\"md-toolbar-tools\"><span class=\"menu-title\" translate=\"NOTIFICATIONS.PAGE_TITLE\">Notifications</span><md-menu \nmd-position-mode=\"left bottom\" layout=\"row\" layout-align=\"end center\" flex><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-button ng-disabled=\"!vm.unreadNotificationsCount\" ng-click=\"vm.readAll()\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon><span translate=\"NOTIFICATIONS.READ_ALL\">Mark all as read</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-toolbar><div class=\"notifications-sidenav-body\"><md-content \nclass=\"notifications\" ng-if=\"vm.notifications.length\" layout=\"column\"><md-list><md-subheader class=\"md-no-sticky\"><span\n translate=\"NOTIFICATIONS.ALL_NOTIFICATIONS\">All notifications</span></md-subheader><md-list-item \nclass=\"contact-item md-white-bg md-3-line\" ng-class=\"{ unread: !notification.readAt }\" \nng-repeat=\"notification in vm.notifications track by $index\" ng-click=\"vm.goToNotification($event, notification)\"><div \nclass=\"avatar-wrapper\"><img class=\"md-avatar avatar\" ng-if=\"!notification.user.avatarUrl\" \nsrc=\"assets/images/null-avatar.jpg\" alt=\"{{ notification.user.name }}\"> <img class=\"md-avatar avatar\" \nng-if=\"notification.user.avatarUrl\" src=\"assets/images/null-avatar.jpg\" ng-src=\"{{ notification.user.avatarUrl }}\" \nalt=\"{{ notification.user.name }}\"><md-icon class=\"icon s12 ticket-created\" \nng-if=\"notification.type === \'ticketCreated\'\" md-font-icon=\"icon-email-open\"></md-icon><md-icon \nclass=\"icon s12 commented\" ng-if=\"notification.type === \'commentCreated\'\" md-font-icon=\"icon-comment\"></md-icon>\n<md-icon class=\"icon s12 task-rated\" ng-if=\"notification.type === \'taskRated\'\" md-font-icon=\"icon-star\"></md-icon>\n<md-icon class=\"icon s12 task-reported\" ng-if=\"notification.type === \'taskReported\'\" md-font-icon=\"icon-alert\">\n</md-icon><md-icon class=\"icon s12 quotation-approved\" ng-if=\"notification.type === \'quotationApproved\'\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon class=\"icon s12 quotation-refused\" \nng-if=\"notification.type === \'quotationRefused\'\" md-font-icon=\"icon-close\"></md-icon><md-icon \nclass=\"icon s12 deadline-at-risk\" ng-if=\"notification.type === \'deadlineAtRisk\'\" md-svg-src=\"assets/icons/clock.svg\">\n</md-icon><md-icon class=\"icon s12 deadline-out-of-schedule\" ng-if=\"notification.type === \'deadlineOutOfSchedule\'\" \nmd-svg-src=\"assets/icons/clock.svg\"></md-icon><md-icon class=\"icon s12 ticket-on-negotiation\" \nng-if=\"notification.type === \'ticketOnNegotiation\'\" md-svg-src=\"assets/icons/drafts.svg\"></md-icon><md-icon \nclass=\"icon icon__pendency icon__pendency--created\" ng-if=\"notification.type === \'pendencyCreated\'\" \nmd-svg-src=\"assets/icons/pendency.svg\"></md-icon><md-icon class=\"icon icon__pendency icon__pendency--replied\" \nng-if=\"notification.type === \'pendencyReplied\'\" md-svg-src=\"assets/icons/pendency.svg\"></md-icon><md-icon \nclass=\"icon icon__pendency icon__pendency--completed\" ng-if=\"notification.type === \'pendencyCompleted\'\" \nmd-svg-src=\"assets/icons/pendency.svg\"></md-icon><md-icon class=\"icon icon__pendency icon__pendency--transferred\" \nng-if=\"notification.type === \'pendencyTransferred\'\" md-svg-src=\"assets/icons/pendency.svg\"></md-icon></div><div \nclass=\"md-list-item-text\"><h4>{{ notification.title }}</h4><p class=\"last-message\">\n{{ notification.createdAt | formatDateTimeComments }}</p></div><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.readOne(notification.id)\" ng-if=\"!notification.readAt\"><md-icon md-font-icon=\"icon-check\" \nclass=\"green-fg\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"NOTIFICATIONS.READ\">Mark as read</span>\n</md-tooltip></md-button></md-list-item></md-list></md-content><md-content class=\"no-notifications\" \nng-if=\"!vm.notifications.length\" layout=\"column\" layout-align=\"center center\" flex><span layout-align=\"center\"><md-icon\n md-font-icon=\"icon-bell-off\"></md-icon><h5 translate=\"NOTIFICATIONS.NO_RESULTS\">No notifications yet</h5></span>\n</md-content></div><div class=\"notifications-sidenav-footer\" layout=\"column\" layout-align=\"center center\" flex><a \nclass=\"go-to-notifications-center\" href=\"https://app.fieldcontrol.com.br/relatorios/#/notificacoes\"><span \ntranslate=\"NOTIFICATIONS.GO_TO_NOTIFICATION_CENTER\" flex>Go to notifications center</span></a></div></div>");
$templateCache.put("app/main/plans/dialogs/import-spreadsheet/import-spreadsheet-plans-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--small import-spreadsheet-dialog\" \naria-label=\"Importar plano de atividade\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__title\"><span class=\"title\" translate=\"PLANS.DIALOG.IMPORT.TITLE\">Import plan</span>\n</div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog();\" \naria-label=\"Close\" translate translate-attr-aria-label=\"PLANS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><form name=\"planForm\" class=\"md-inline-form\" novalidate><md-dialog-content \nms-scroll class=\"pt-0\"><div layout-xs=\"column\" layout=\"row\" class=\"mb-40n\"><div flex=\"100\"><md-input-container \nclass=\"md-block md-input-container-file\"><span translate=\"PLANS.DIALOG.IMPORT.MESSAGE\">\nDownload below our template spreadsheet and fill in the basic data to create your new activity plan:]</span>\n</md-input-container><md-input-container class=\"md-block md-input-container-file center-download-button\"><md-button \ndata-cy=\"download-spreadsheet-model-button\" type=\"button\" \nclass=\"send-button md-accent md-raised width-download-button\" ng-click=\"vm.downloadSpreadsheetModel()\" \ntranslate=\"PLANS.DIALOG.ACTIONS.DOWNLOAD\" translate-attr-aria-label=\"PLANS.DIALOG.ACTIONS.DOWNLOAD\" \naria-label=\"DOWNLOAD\">DOWNLOAD MODEL SHEET</md-button></md-input-container><md-input-container \nclass=\"md-block md-input-container-file mb-50\"><div class=\"select-file-button drop-box {{ vm.inputFileClass }}\" \nngf-drop ngf-select ng-model=\"vm.file\" name=\"file\" ng-change=\"vm.fileHasChange();\" ngf-multiple=\"false\" \nngf-max-files=\"1\" ngf-allow-dir=\"false\"><div class=\"select-spreadsheet-flex\"><md-icon md-font-icon=\"icon-upload\">\n</md-icon><div data-cy=\"upload-sheet-button\" class=\"description\" ng-if=\"!vm.file\" \ntranslate=\"PLANS.DIALOG.IMPORT.UPLOAD_MESSAGE\">Click or drag the template sheet to upload</div><div \nclass=\"description\" ng-if=\"vm.file\" translate=\"PLANS.DIALOG.IMPORT.SELECTED_SPREADSHEET\">Spreadsheet selected</div><div\n class=\"hint\" translate=\"PLANS.DIALOG.IMPORT.MAX_SIZE\">The maximum file size is 10 MB</div></div><div \nng-if=\"vm.fileHasError\"><div class=\"md-input-message-animation ng-scope input-file-error\"><span>\n{{ vm.fileHasErrorMessage }}</span></div></div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button data-cy=\"load-sheet-button\" type=\"button\" ng-click=\"vm.openCreatePlanDialog();\" \nclass=\"fc-button fc-button--actions\" translate=\"PLANS.DIALOG.ACTIONS.LOAD\" \ntranslate-attr-aria-label=\"PLANS.DIALOG.ACTIONS.LOAD\" \nng-disabled=\"!vm.file || vm.disableCreateButton || $root.loadingProgress || vm.fileHasError\" aria-label=\"LOAD\">LOAD\n</md-button><md-progress-circular ng-if=\"$root.loadingProgress\" class=\"md-accent display-initial mr-25\" \nmd-mode=\"indeterminate\" md-diameter=\"15\"></md-progress-circular><span ng-if=\"$root.loadingProgress\" \nclass=\"font-size-12\" translate=\"PLANS.DIALOG.ACTIONS.LOADING\" translate-attr-aria-label=\"PLANS.DIALOG.ACTIONS.LOADING\">\nWait, loading file...</span></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/plans/dialogs/plans/plans-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--small plan-dialog\" aria-label=\"Tipo de OS\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span ng-show=\"!vm.plans.id\" class=\"title\" \ntranslate=\"PLANS.DIALOG.NEW.TITLE\">New plan</span> <span ng-show=\"vm.plans.id\" class=\"title\" \ntranslate=\"PLANS.DIALOG.EDIT.TITLE\">Edit plan</span></div><div class=\"sidebar-dialog__actions\"><md-button \ndata-cy=\"close-dialog-button\" class=\"md-icon-button\" ng-click=\"vm.closeDialog();\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"PLANS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"planForm\" class=\"md-inline-form\" novalidate><md-dialog-content ms-scroll class=\"pt-0\"><md-tabs\n class=\"ml-24n\" md-selected=\"vm.selectedTabIndex\" md-dynamic-height flex><md-tab><md-tab-label><span \ndata-cy=\"general-tab\" translate=\"PLANS.DIALOG.GENERAL.TITLE\">General</span></md-tab-label><md-tab-body><div \nclass=\"tab-general\"><div layout-xs=\"column\" layout=\"row\" class=\"mb-40n\"><div flex=\"60\"><md-input-container \nclass=\"md-block\" flex><label translate=\"PLANS.MODEL.NAME\">Name</label><input data-cy=\"name-input\" id=\"name\" \nname=\"name\" ng-model=\"vm.plans.name\" maxlength=\"50\" required><div ng-messages=\"planForm.name.$error\" \nng-show=\"planForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PLANS.MODEL.ERRORS.NAME_REQUIRED\">Name is required</span></div></div></md-input-container></div><div \nflex=\"40\"><md-input-container class=\"md-block\" flex><label translate=\"PLANS.MODEL.PLANTYPE\">Plan Type</label><md-select\n data-cy=\"type-plan-select\" id=\"planType\" name=\"planType\" ng-model=\"vm.plans.planType.id\" translate \ntranslate-attr-placeholder=\"PLANS.MODEL.PLANTYPE\" required><md-option ng-value=\"planType.id\" \nng-repeat=\"planType in vm.plansTypes\">{{ ::planType.name }}</md-option></md-select><div \nng-messages=\"planForm.planType.$error\" ng-show=\"planForm.planType.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"PLANS.MODEL.ERRORS.PLANTYPE_REQUIRED\">Plan Type is required</span></div></div></md-input-container>\n</div></div><div layout-xs=\"column\" layout=\"row\" class=\"mt-20\"><div flex=\"100\"><fc-smart-rewrite \nreference-id=\"vm.plans.id || vm.sessionId\" reference-type=\"plans-description\" class=\"flex-100\"><fc-textarea \nng-model=\"vm.plans.description\" label=\"{{ \'PLANS.MODEL.DESCRIPTION\' | translate }}\" max-length=\"100\" \ninput-name=\"description\" input-control=\"planForm.description\" \nerrors-to-watch=\"[\n                        {\n                          name: \'maxlength\',\n                          translate: \'PLANS.MODEL.ERRORS.DESCRIPTION_MAXLENGTH\',\n                          translateValues: { expectedLength: 100, receivedLength: planForm.description.$viewValue.length }\n                        }\n                      ]\">\n</fc-smart-rewrite></div></div></div></md-tab-body></md-tab><md-tab flex><md-tab-label><span \ncy-data=\"activities-plans-tab\" translate=\"PLANS.DIALOG.ACTIVITIES.TITLE\">Activities</span></md-tab-label><md-tab-body>\n<div class=\"table-navigation max-h-73vh\"><div class=\"tab-general\" ng-if=\"vm.newPlan\" \nng-include=\"\'app/main/plans/dialogs/plans/plans-info/new-plan.html\'\" ms-scroll flex></div><div class=\"tab-general\" \nng-if=\"!vm.newPlan\" ng-include=\"\'app/main/plans/dialogs/plans/plans-info/actual-plan.html\'\" ms-scroll flex></div><div \nclass=\"table-navigation__pagination\" ng-show=\"(vm.selectedTabIndex === 1 && (vm.hasPlansTasks || vm.hasPlans))\"><div \nclass=\"table-navigation__info\" id=\"table-list_info\" aria-live=\"polite\"><span \ntranslate=\"PLANS.DIALOG.NAVIGATION.SHOWING_FROM\">Showing from</span> {{ vm.pagination.firstPageIndex }} <span \ntranslate=\"PLANS.DIALOG.NAVIGATION.TO\">to</span> {{ vm.pagination.lastPageIndex }} <span \ntranslate=\"PLANS.DIALOG.NAVIGATION.OF\">of</span> {{ vm.tasks.length || vm.plans.items.length }} <span \ntranslate=\"PLANS.DIALOG.NAVIGATION.RECORDS\">records</span></div><button class=\"table-navigation__button\" \naria-label=\"Previous\" ng-disabled=\"vm.pagination.currentPage === 1\" \nng-click=\"vm.loadPaginated(vm.pagination.currentPage - 1)\"><span translate=\"PLANS.DIALOG.NAVIGATION.PREVIOUS\">Previous\n</span></button> <button class=\"table-navigation__button\" aria-label=\"Next\" \nng-disabled=\"vm.pagination.lastPageIndex >= (vm.tasks.length || vm.plans.items.length)\" \nng-click=\"vm.loadPaginated(vm.pagination.currentPage + 1)\"><span translate=\"PLANS.DIALOG.NAVIGATION.NEXT\">Next</span>\n</button></div></div></md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ndata-cy=\"save-plan-button\" ng-if=\"!vm.exceededItemsLimit\" type=\"submit\" \nng-click=\"vm.newPlan ? vm.createPlan() : vm.editPlan()\" class=\"fc-button fc-button--actions\" \nng-disabled=\"vm.plans.totalInvalidItems > 0 || planForm.$invalid || planForm.$pristine || $root.loadingProgress === true || vm.exceededItemsLimit\" \naria-label=\"Save\" translate=\"PLANS.DIALOG.ACTIONS.SAVE\" translate-attr-aria-label=\"PLANS.DIALOG.ACTIONS.SAVE\">Save\n</md-button><span ng-if=\"vm.exceededItemsLimit\" class=\"red-text font-size-12\" \ntranslate=\"PLANS.DIALOG.ACTIONS.EXCEED_LIMIT\" translate-values=\"{ activitiesLimit: vm.itemsLimit }\" \ntranslate-attr-aria-label=\"PLANS.DIALOG.ACTIONS.EXCEED_LIMIT\">\nIt is not possible to import a spreadsheet with more than 1500 activities. Review the spreadsheet.</span></div><div \nlayout=\"row\"><md-button ng-show=\"(!vm.plans.archived && vm.plans.id)\" class=\"md-icon-button\" \nng-click=\"vm.archivePlan($event)\" aria-label=\"Archive\" translate data-cy=\"archive-plan-button\" \ntranslate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\"><md-icon md-font-icon=\"icon-folder-download\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip>\n</md-button><md-button ng-show=\"(vm.plans.archived && vm.plans.id)\" class=\"md-icon-button\" \nng-click=\"vm.unarchivePlan($event)\" aria-label=\"Unarchive\" translate data-cy=\"unarchive-plan-button\" \ntranslate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/plans/dialogs/unprocessable-spreadsheet-prompt/unprocessable-spreadsheet-prompt.html","<md-dialog><md-content class=\"dialogExport p-20 unprocessable-dialog-width\"><h2 class=\"text-align-h2 text-bold\" \ntranslate=\"PLANS.DIALOG.UNPROCESSABLE.TITLE\" translate-attr-aria-label=\"PLANS.DIALOG.UNPROCESSABLE.TITLE\"><b>\nOops, the spreadsheet could not be processed ...</b></h2><br><div><h4>{{ vm.formattedMessage }}</h4><ul \nng-if=\"vm.data.differences\"><li ng-repeat=\"differenceColumnName in vm.data.differences\">{{ differenceColumnName }}</li>\n</ul></div><br><br><div align=\"center\"><md-button ng-click=\"vm.close()\" translate=\"PLANS.DIALOG.UNPROCESSABLE.BUTTON\" \ntranslate-attr-aria-label=\"PLANS.DIALOG.UNPROCESSABLE.BUTTON\">Ok, got it</md-button></div></md-content></md-dialog>");
$templateCache.put("app/main/plans/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"PLANS.FILTERS.TITLE\">Filter Plans types</span><md-button ng-if=\"vm.plansFilters.isOn()\" \nng-click=\"vm.plansFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"PLANS.FILTERS.CLEAR\">Clear\n</span></md-tooltip></md-button></div></md-toolbar><md-content class=\"animate-slide-right filter-equipments\" ms-scroll>\n<md-list-item><input flex class=\"search-input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nplaceholder=\"Search by name\" translate translate-attr-placeholder=\"PLANS.FILTERS.NAME\" ng-model=\"vm.plansFilters.name\" \nng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider><md-list-item><input flex \nclass=\"search-input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by description\" translate \ntranslate-attr-placeholder=\"PLANS.FILTERS.DESCRIPTION\" ng-model=\"vm.plansFilters.description\" \nng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider><md-list-item><input flex \nclass=\"search-input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by plan type\" translate \ntranslate-attr-placeholder=\"PLANS.FILTERS.PLANTYPE\" ng-model=\"vm.plansFilters.planType\" \nng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"PLANS.FILTERS.SITUATIONS.TITLE\">Filter by situation</span></div><md-list-item><md-select \ndata-cy=\"plans-filters\" class=\"w-100-percent mt-0 mb-0\" name=\"archived\" id=\"select-situation-equipments\" \nng-change=\"vm.broadcastFilterUpdated()\" ng-model=\"vm.plansFilters.archived\"><md-option \ntranslate=\"PLANS.FILTERS.SITUATIONS.ALL\" value=\"-1\">All</md-option><md-option \ntranslate=\"PLANS.FILTERS.SITUATIONS.ACTIVE\" value=\"1\">Active</md-option><md-option \ntranslate=\"PLANS.FILTERS.SITUATIONS.ARCHIVED\" value=\"0\">Archived</md-option></md-select></md-list-item></md-content>");
$templateCache.put("app/main/plans-types/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"PLANSTYPES.FILTERS.TITLE\">Filter Plans types</span><md-button ng-if=\"vm.plansTypesFilters.isOn()\" \nng-click=\"vm.plansTypesFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"PLANSTYPES.FILTERS.CLEAR\">\nClear</span></md-tooltip></md-button></div></md-toolbar><md-content class=\"animate-slide-right filter-equipments\" \nms-scroll><md-list-item><input flex class=\"search-input\" data-cy=\"plans-types-filters.name\" type=\"text\" \nng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by name\" translate \ntranslate-attr-placeholder=\"PLANSTYPES.FILTERS.NAME\" ng-model=\"vm.plansTypesFilters.name\" \nng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider><md-list-item><input flex \nclass=\"search-input\" data-cy=\"plans-types-filters.description\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nplaceholder=\"Search by description\" translate translate-attr-placeholder=\"PLANSTYPES.FILTERS.DESCRIPTION\" \nng-model=\"vm.plansTypesFilters.description\" ng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\"><span translate=\"PLANSTYPES.FILTERS.SITUATIONS.TITLE\">Filter by situation\n</span></div><md-list-item><md-select class=\"w-100-percent mt-0 mb-0\" name=\"archived\" id=\"select-situation-equipments\" \ndata-cy=\"plans-types-filters.archived\" ng-change=\"vm.broadcastFilterUpdated()\" \nng-model=\"vm.plansTypesFilters.archived\"><md-option translate=\"PLANSTYPES.FILTERS.SITUATIONS.ALL\" value=\"-1\">All\n</md-option><md-option translate=\"PLANSTYPES.FILTERS.SITUATIONS.ACTIVE\" value=\"1\">Active</md-option><md-option \ntranslate=\"PLANSTYPES.FILTERS.SITUATIONS.ARCHIVED\" value=\"0\">Archived</md-option></md-select></md-list-item>\n</md-content>");
$templateCache.put("app/main/product-types/dialogs/product-types/product-types-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large product-types-dialog\" id=\"product-type-dialog\" \naria-label=\"Product types dialog\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__title ml-10i\" layout=\"row\" layout-align=\"space-between\"><span \nng-show=\"!vm.productType.id\" class=\"title\" translate=\"PRODUCT_TYPES.DIALOG.NEW.TITLE\">New product type</span> <span \nng-show=\"vm.productType.id\" class=\"title\" translate=\"PRODUCT_TYPES.DIALOG.EDIT.TITLE\">Edit product type</span></div>\n<div class=\"sidebar-dialog__actions\"><md-button data-cy=\"close-dialog-button\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\" aria-label=\"Close\" translate translate-attr-aria-label=\"PRODUCT_TYPES.DIALOG.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"productTypeForm\" \nclass=\"md-inline-form\" novalidate><corporate-customer-disclaimer \nng-if=\"vm.productType.metadata && vm.productType.metadata.sammathnaur\" \ncustomer-name=\"vm.productType.metadata.sammathnaur.account.name\"></corporate-customer-disclaimer><div \nng-hide=\"vm.productType.locked\" class=\"fc-warning-container\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"/assets/icons/icon-alert.svg\"></md-icon><span translate=\"PRODUCT_TYPES.DIALOG.PRODUCT_TYPE_ALERT\"></span>\n</div><md-dialog-content ms-scroll class=\"pt-20\"><div class=\"inputs-container\"><div flex=\"100\"><div class=\"fc-input\">\n<input data-cy=\"name-input\" type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"name\" \nng-model=\"vm.productType.name\" ng-disabled=\"vm.productType.locked\" ng-maxlength=\"150\" \nng-class=\"{\n                invalid: productTypeForm.name.$touched && productTypeForm.name.$invalid,\n                \'input-product-type-locked\': vm.productType.locked\n              }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'PRODUCT_TYPES.MODEL.NAME\' | translate)}}</label><fc-error \nng-show=\"productTypeForm.name.$touched\" input-errors=\"productTypeForm.name.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'PRODUCT_TYPES.MODEL.ERRORS.FIELD_REQUIRED\'\n                },\n                {\n                  name: \'maxlength\',\n                  translate: \'PRODUCT_TYPES.MODEL.ERRORS.MAX_LENGTH\',\n                  translateValues: { expectedLength: 150, receivedLength: productTypeForm.name.$viewValue.length }\n                },\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div layout-xs=\"column\" layout=\"row\" class=\"mt-30\">\n<div flex=\"100\"><fc-smart-rewrite reference-id=\"vm.productType.id || vm.sessionId\" \nreference-type=\"product-types-description\" disabled=\"vm.productType.locked\"><fc-textarea \ndata-cy=\"description-textarea\" class=\"fc-textarea__textarea--change-border-color\" is-disabled=\"vm.productType.locked\" \nlabel=\"{{(\'PRODUCT_TYPES.MODEL.DESCRIPTION\' | translate)}}\" ng-model=\"vm.productType.description\" \ninput-name=\"description\" input-control=\"productTypeForm.description\" \nng-class=\"{\n                \'input-product-type-locked\': vm.productType.locked\n              }\" max-length=\"2000\" \nerrors-to-watch=\"[\n                {\n                  name: \'maxlength\',\n                  translate: \'PRODUCT_TYPES.MODEL.ERRORS.MAX_LENGTH\',\n                  translateValues: { expectedLength: 2000, receivedLength: productTypeForm.description.$viewValue.length }\n                },\n              ]\">\n</fc-textarea></fc-smart-rewrite></div></div></md-dialog-content><md-dialog-actions \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><button data-cy=\"save-button\" \nclass=\"fc-button fc-button--actions\" type=\"submit\" ng-if=\"!vm.newProductType\" \nng-class=\"{disabled: productTypeForm.$invalid || productTypeForm.$pristine || $root.loadingProgress === true}\" \nng-click=\"vm.saveProductType(\'edit\')\" \nng-disabled=\"productTypeForm.$invalid || productTypeForm.$pristine || $root.loadingProgress === true || vm.productType.locked\" \naria-label=\"Save\" translate=\"PRODUCT_TYPES.DIALOG.ACTIONS.SAVE\" \ntranslate-attr-aria-label=\"PRODUCT_TYPES.DIALOG.ACTIONS.SAVE\">Save</button> <button data-cy=\"create-button\" \nclass=\"fc-button fc-button--actions\" type=\"submit\" ng-if=\"vm.newProductType\" \nng-class=\"{disabled: productTypeForm.$invalid || productTypeForm.$pristine || $root.loadingProgress === true}\" \nng-click=\"vm.saveProductType(\'create\')\" \nng-disabled=\"productTypeForm.$invalid || productTypeForm.$pristine || $root.loadingProgress === true || vm.productType.locked\" \naria-label=\"Add Plan Type\" translate=\"PRODUCT_TYPES.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"PRODUCT_TYPES.DIALOG.ACTIONS.CREATE\">Create</button></div><div layout=\"row\" \nng-if=\"vm.productType.id\"><md-button data-cy=\"archive-button\" ng-show=\"!vm.productType.archived\" \nclass=\"md-icon-button\" ng-click=\"vm.archiveProductType($event)\" aria-label=\"Archive\" translate \nng-disabled=\"vm.productType.locked\" translate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-download\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button \nng-show=\"vm.productType.archived\" class=\"md-icon-button\" ng-click=\"vm.unarchiveProductType($event)\" \naria-label=\"Unarchive\" translate ng-disabled=\"vm.productType.locked\" \ntranslate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/product-types/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"PRODUCT_TYPES.FILTERS.TITLE\">Filter Product types</span><md-button ng-if=\"vm.productTypesFilters.isOn()\" \nng-click=\"vm.productTypesFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"PRODUCT_TYPES.FILTERS.CLEAR\">Clear</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-equipments\" ms-scroll><div class=\"fc-input margin-0-auto mt-10 divider-margin\" \nflex=\"90\"><input data-cy=\"locations-filters.name\" type=\"text\" placeholder=\" \" class=\"fc-input__input\" \nautocomplete=\"off\" ng-model=\"vm.productTypesFilters.name\" ng-change=\"vm.broadcastFilterUpdated();\"><label \nclass=\"fc-input__label\">{{(\'PRODUCT_TYPES.FILTERS.NAME\' | translate)}}</label></div><div \nclass=\"fc-input margin-0-auto mt-10 divider-margin\" flex=\"90\"><input data-cy=\"locations-filters.name\" type=\"text\" \nplaceholder=\" \" class=\"fc-input__input\" autocomplete=\"off\" ng-model=\"vm.productTypesFilters.description\" \nng-change=\"vm.broadcastFilterUpdated();\"><label class=\"fc-input__label\">\n{{(\'PRODUCT_TYPES.FILTERS.DESCRIPTION\' | translate)}}</label></div><div class=\"margin-0-auto divider-margin\" flex=\"90\" \nstyle=\"margin-bottom: 60px\"><fc-select label=\"{{(\'PRODUCT_TYPES.FILTERS.SITUATIONS.TITLE\' | translate)}}\" \noptions=\"vm.statusOptions\" ng-model=\"vm.statusFilterValue\" track-by=\"label\" \nng-change=\"vm.broadcastFilterUpdated(\'archived\');\" is-required=\"true\"></fc-select></div></md-content>");
$templateCache.put("app/main/products/dialogs/modal/qrcode-generator.html","<div class=\"qrcode-modal-container\"><qrcode ng-model=\"vm.variables.product.qrCode\" id=\"product-qrcode-download\" \nversion=\"6\" error-correction-level=\"M\" size=\"250\" data=\"{{ vm.variables.product.qrCode }}\"></qrcode><p \nng-model=\"vm.variables.product.qrCode\">{{vm.variables.product.qrCode}}</p></div>");
$templateCache.put("app/main/products/dialogs/omie-manual-import/omie-manual-import-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large task-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\" \ntranslate=\"PRODUCTS.IMPORT.TITLE\" translate-value-app=\"Omie\">Import products from Omie</span></div><div \nclass=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"import-products\" ms-scroll><div layout=\"column\" \nclass=\"import-products__search-bar\"><div class=\"search-bar\" layout=\"row\" flex=\"100\"><div class=\"fc-input\" flex=\"100\">\n<input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" \nng-model=\"vm.nameContains\" ng-change=\"vm.onSearchChange()\" ng-model-options=\"{ debounce: 500 }\" ng-disabled=\"false\">\n<label class=\"fc-input__label\" translate=\"TASKS.DIALOG.TABS.PRODUCTS.SEARCH_PRODUCT\">Search for an product</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></div></div><small class=\"search-bar__hint mt-5\" \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.SEARCH_BY_NAME\">Search by name</small></div><div layout=\"column\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"space-between center\" class=\"import-products__header\"><div><span \nclass=\"import-products__header__title\" flex=\"20\">{{ \'PRODUCTS.IMPORT.FOUND_PRODUCTS\' | translate }} ({{vm.totalCount}})\n</span></div></div><div ng-if=\"$root.loadingProgress && vm.isLoadingProducts\" class=\"loading-gantt-tasks\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div ng-repeat=\"product in vm.allProducts\" layout-xs=\"column\" \nlayout=\"row\" flex=\"100\" ng-if=\"vm.totalCount && !vm.isLoadingProducts\" class=\"b brad-4 mb-10 import-products__item\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h-70 w-70 brad-4 ml-20\" \nng-if=\"product.imageUrl\"><img ng-src=\"{{ product.imageUrl | mumakil }}\" alt=\"{{ product.name }}\" \nclass=\"import-products__image\"></div><div layout=\"row\" class=\"border h-70 w-70 brad-4 ml-20\" \nlayout-align=\"center center\" ng-if=\"!product.imageUrl\"><img src=\"assets/icons/no-image_gray.svg\"></div><div flex=\"80\" \nclass=\"ph-24 import-products__product\"><span class=\"import-products__product__title\">{{ product.name }}</span> <span \nng-if=\"product.measure\">{{ \'TASKS.DIALOG.TABS.PRODUCTS.MEASURE.\' + product.measure | translate }} </span><span>\nR${{ vm.parseValueToPrice(product.value) }}</span></div></div><div class=\"import-products__import ph-10\"><md-icon \nng-if=\"product.selected\" md-svg-src=\"/assets/icons/icon-imported-success.svg\"></md-icon><md-icon \nng-if=\"product.failed && !product.selected\" md-svg-src=\"/assets/icons/icon-imported-fail.svg\"></md-icon><md-button \nclass=\"import-products__import__action\" \nng-if=\"!product.selected && product.integrationId && product.updating && !product.failed\" \nng-click=\"vm.updateProduct(product)\">{{ \'CORE.SUBSCRIPTION_DIALOG.UPDATE\' | translate }}</md-button><md-button \nclass=\"import-products__import__action\" ng-hide=\"product.integrationId && product.updating\" \nng-if=\"!product.selected && !product.failed\" ng-click=\"vm.importProduct(product)\">\n{{ \'CUSTOMERS.INTEGRATIONS.IMPORT\' | translate }}</md-button></div></div></div><div \nclass=\"import-products__table-navigation\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"import-products__table-navigation__info\" id=\"table-list_info\" aria-live=\"polite\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((vm.currentPage - 1) * vm.limitPerPage) + 1 }} <span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.TO\">to\n</span> {{ vm.currentPage * vm.limitPerPage > vm.totalCount ? vm.totalCount : vm.currentPage * vm.limitPerPage }} <span\n translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.OF\">of</span> {{ vm.totalCount }} <span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.RECORDS\">records</span></div><button \nclass=\"import-products__table-navigation__button-previous\" ng-click=\"vm.navigateToPage(false)\" \nng-disabled=\"vm.currentPage === 1 || ($root.loadingProgress || vm.isLoadingProducts)\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.PREVIOUS\">Previous</span></button> <button \nclass=\"import-products__table-navigation__button-next\" ng-click=\"vm.navigateToPage(true)\" \nng-disabled=\"vm.currentPage * vm.limitPerPage >= vm.totalCount || ($root.loadingProgress || vm.isLoadingProducts)\">\n<span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.NEXT\">Next</span></button></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/products/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"PRODUCTS.FILTERS.TITLE\">Filter Product</span><md-button ng-if=\"vm.productsFilters.isOn()\" \nng-click=\"vm.productsFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"PRODUCTS.FILTERS.CLEAR\">\nClear</span></md-tooltip></md-button></div></md-toolbar><md-content class=\"animate-slide-right filter-equipments\" \nms-scroll><div class=\"fc-input margin-0-auto mt-10 divider-margin\" flex=\"90\"><input data-cy=\"locations-filters.name\" \ntype=\"text\" placeholder=\" \" class=\"fc-input__input\" autocomplete=\"off\" ng-model=\"vm.productsFilters.name\" \nng-change=\"vm.broadcastFilterUpdated();\"><label class=\"fc-input__label\">{{(\'PRODUCTS.FILTERS.NAME\' | translate)}}\n</label></div><div class=\"fc-input margin-0-auto mt-10 divider-margin\" flex=\"90\"><input \ndata-cy=\"locations-filters.name\" type=\"text\" placeholder=\" \" class=\"fc-input__input\" autocomplete=\"off\" \nng-model=\"vm.productsFilters.description\" ng-change=\"vm.broadcastFilterUpdated();\"><label class=\"fc-input__label\">\n{{(\'PRODUCTS.FILTERS.DESCRIPTION\' | translate)}}</label></div><div class=\"fc-input margin-0-auto mt-10 divider-margin\" \nflex=\"90\"><input data-cy=\"locations-filters.name\" type=\"text\" placeholder=\" \" class=\"fc-input__input\" \nautocomplete=\"off\" ng-model=\"vm.productsFilters.code\" ng-change=\"vm.broadcastFilterUpdated();\"><label \nclass=\"fc-input__label\">{{(\'PRODUCTS.FILTERS.CODE\' | translate)}}</label></div><div \nclass=\"margin-0-auto divider-margin\" flex=\"90\" style=\"margin-bottom: 10px\"><fc-select \nlabel=\"{{(\'PRODUCTS.FILTERS.PRODUCT_TYPE\' | translate)}}\" options=\"vm.productTypeOptions\" \nng-model=\"vm.productTypeFilterValue\" track-by=\"label\" ng-change=\"vm.broadcastFilterUpdated(\'productType\');\" \nis-required=\"true\"></fc-select></div><div class=\"margin-0-auto divider-margin\" flex=\"90\" style=\"margin-bottom: 10px\">\n<fc-select label=\"{{(\'PRODUCTS.FILTERS.MEASURE\' | translate)}}\" options=\"vm.measureOptions\" \nng-model=\"vm.measureFilterValue\" track-by=\"label\" ng-change=\"vm.broadcastFilterUpdated(\'measure\');\" is-required=\"true\">\n</fc-select></div><div class=\"margin-0-auto divider-margin\" flex=\"90\" style=\"margin-top: 10px\"><fc-select \nlabel=\"{{(\'PRODUCTS.FILTERS.SITUATIONS.TITLE\' | translate)}}\" options=\"vm.statusOptions\" \nng-model=\"vm.statusFilterValue\" track-by=\"label\" ng-change=\"vm.broadcastFilterUpdated(\'archived\');\" is-required=\"true\">\n</fc-select></div></md-content>");
$templateCache.put("app/main/products/sidenavs/import-modal/import-products-services-modal.html","<div><p class=\"fc-modal__content\">{{vm.variables.title}}</p><div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{ vm.variables.progressPercentage }}\"></md-progress-linear><div layout=\"column\" layout-align=\"flex-end\"><p \nclass=\"fs-16 flex-end\">{{ vm.variables.totalProductsImported || \'0\' }} <span \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_FROM\">from</span> {{ vm.variables.totalProductsToImport }}\n</p></div></div></div>");
$templateCache.put("app/main/products-services/dialogs/omie-manual-import/omie-manual-import-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large task-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\" \ntranslate=\"PRODUCTS_SERVICES.IMPORT.TITLE\" translate-value-app=\"Omie\">Import products from Omie</span></div><div \nclass=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"import-products\" ms-scroll><div layout=\"column\" \nclass=\"import-products__search-bar\"><div class=\"search-bar\" layout=\"row\" flex=\"100\"><div class=\"fc-input\" flex=\"100\">\n<input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" \nng-model=\"vm.nameContains\" ng-change=\"vm.onSearchChange()\" ng-model-options=\"{ debounce: 500 }\" ng-disabled=\"false\">\n<label class=\"fc-input__label\" translate=\"TASKS.DIALOG.TABS.PRODUCTS.SEARCH_PRODUCT\">Search for an product</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></div></div><small class=\"search-bar__hint mt-5\" \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.SEARCH_BY_NAME\">Search by name</small></div><div layout=\"column\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"space-between center\" class=\"import-products__header\"><div><span \nclass=\"import-products__header__title\" flex=\"20\">\n{{ \'PRODUCTS_SERVICES.IMPORT.FOUND_PRODUCTS\' | translate }} ({{vm.totalCount}})</span></div></div><div \nng-if=\"$root.loadingProgress && vm.isLoadingProducts\" class=\"loading-gantt-tasks\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div><div ng-repeat=\"product in vm.allProducts\" layout-xs=\"column\" layout=\"row\" flex=\"100\" \nng-if=\"vm.totalCount && !vm.isLoadingProducts\" class=\"b brad-4 mb-10 import-products__item\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h-70 w-70 brad-4 ml-20\" \nng-if=\"product.imageUrl\"><img ng-src=\"{{ product.imageUrl | mumakil }}\" alt=\"{{ product.name }}\" \nclass=\"import-products__image\"></div><div layout=\"row\" class=\"border h-70 w-70 brad-4 ml-20\" \nlayout-align=\"center center\" ng-if=\"!product.imageUrl\"><img src=\"assets/icons/no-image_gray.svg\"></div><div flex=\"80\" \nclass=\"ph-24 import-products__product\"><span class=\"import-products__product__title\">{{ product.name }}</span> <span \nng-if=\"product.measure\">{{ \'TASKS.DIALOG.TABS.PRODUCTS.MEASURE.\' + product.measure | translate }} </span><span>\nR${{ vm.parseValueToPrice(product.value) }}</span></div></div><div class=\"import-products__import ph-10\"><md-icon \nng-if=\"product.selected\" md-svg-src=\"assets/icons/icon-imported-success.svg\"></md-icon><md-button \nclass=\"import-products__import__action\" \nng-if=\"!product.selected && product.integrationId && vm.isValidUUID(product.integrationId)\" \nng-click=\"vm.updateProduct(product)\">{{ \'CORE.SUBSCRIPTION_DIALOG.UPDATE\' | translate }}</md-button><md-button \nclass=\"import-products__import__action\" ng-if=\"!product.selected && !vm.isValidUUID(product.integrationId)\" \nng-click=\"vm.importProduct(product)\">{{ \'MODULES.REQUEST_ACTIVATION.DIALOG.IMPORT\' | translate }}</md-button></div>\n</div></div><div class=\"import-products__table-navigation\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"import-products__table-navigation__info\" id=\"table-list_info\" aria-live=\"polite\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((vm.currentPage - 1) * vm.limitPerPage) + 1 }} <span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.TO\">to\n</span> {{ vm.currentPage * vm.limitPerPage > vm.totalCount ? vm.totalCount : vm.currentPage * vm.limitPerPage }} <span\n translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.OF\">of</span> {{ vm.totalCount }} <span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.RECORDS\">records</span></div><button \nclass=\"import-products__table-navigation__button-previous\" ng-click=\"vm.navigateToPage(false)\" \nng-disabled=\"vm.currentPage === 1 || ($root.loadingProgress || vm.isLoadingProducts)\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.PREVIOUS\">Previous</span></button> <button \nclass=\"import-products__table-navigation__button-next\" ng-click=\"vm.navigateToPage(true)\" \nng-disabled=\"vm.currentPage * vm.limitPerPage >= vm.totalCount || ($root.loadingProgress || vm.isLoadingProducts)\">\n<span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.NEXT\">Next</span></button></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/products-services/dialogs/products-services/products-services-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large products-services-dialog\" id=\"products-services-dialog\" \naria-label=\"Products services dialog\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__title ml-10i\" layout=\"row\" layout-align=\"space-between\"><span \nng-show=\"!vm.productService.id\" class=\"title\" translate=\"PRODUCTS_SERVICES.DIALOG.NEW.TITLE\">New product or service\n</span> <span ng-show=\"vm.productService.id\" class=\"title\" translate=\"PRODUCTS_SERVICES.DIALOG.EDIT.TITLE\">\nEdit product or service</span></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\" aria-label=\"Close\" translate translate-attr-aria-label=\"PRODUCTS_SERVICES.DIALOG.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"productServiceForm\" \nclass=\"md-inline-form\" novalidate><div ng-hide=\"vm.productService.locked\" class=\"fc-warning-container\"><md-icon \nclass=\"warning-icon\" md-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span \ntranslate=\"PRODUCTS_SERVICES.DIALOG.QUOTATION_ALERT\"></span></div><corporate-customer-disclaimer \nng-if=\"vm.productService.metadata && vm.productService.metadata.sammathnaur\" \ncustomer-name=\"vm.productService.metadata.sammathnaur.account.name\"></corporate-customer-disclaimer><md-dialog-content \nms-scroll class=\"pt-20\"><div layout-xs=\"column\" layout=\"row\" class=\"mt-0 products-services-input-container\"><div \nlayout=\"row\"><fc-image-input class=\"fc-image-input__image-container--change-border-color\" \nng-disabled=\"vm.productService.locked\" name=\"imageUrl\" input-control=\"productServiceForm.imageUrl\" \nng-model=\"vm.productService.imageUrl\" image-file=\"vm.productResultImageFile\" \nimg-custom-class=\"products-services-image\" \nng-class=\"{\n              \'img-product-service-disabled\': vm.productService.locked\n            }\" height=\"120px\" \nwidth=\"120px\"></fc-image-input><div class=\"image-input__description\"><p>\n{{(\'PRODUCTS_SERVICES.DIALOG.IMAGE_INFORMATION\' | translate)}}</p></div></div></div><div class=\"inputs-container\"><div \nflex=\"50\"><div class=\"fc-input\"><input data-cy=\"field.name\" type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"name\" ng-model=\"vm.productService.name\" ng-disabled=\"vm.productService.locked\" \nng-maxlength=\"50\" \nng-class=\"{\n                invalid: productServiceForm.name.$touched && productServiceForm.name.$invalid,\n                \'input-product-service-locked\': vm.productService.locked\n              }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'PRODUCTS_SERVICES.MODEL.NAME\' | translate)}}</label><fc-error \nng-show=\"productServiceForm.name.$touched\" input-errors=\"productServiceForm.name.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'PRODUCTS_SERVICES.MODEL.ERRORS.NAME_REQUIRED\'\n                },\n                {\n                  name: \'maxlength\',\n                  translate: \'PRODUCTS_SERVICES.MODEL.ERRORS.MAX_LENGTH\',\n                  translateValues: { expectedLength: 50, receivedLength: productServiceForm.name.$viewValue.length }\n                },\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"20\"><fc-select \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{(\'PRODUCTS_SERVICES.MODEL.TYPE.LABEL\' | translate)}}\" ng-model=\"vm.productService.type\" \noptions=\"vm.productsServicesSelectOptions\" ng-change=\"vm.changeProductsServicesOption(value)\" is-required=\"true\" \ninput-name=\"type\" input-control=\"productServiceForm.type\" is-disabled=\"vm.productService.locked\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'PRODUCTS_SERVICES.MODEL.ERRORS.VALUE_REQUIRED\'\n                }\n              ]\">\n</fc-select></div><div flex=\"20\"><div class=\"fc-input\"><input data-cy=\"field.value\" type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input\" name=\"value\" ng-model=\"vm.productService.value\" \nng-disabled=\"vm.productService.locked\" min=\"0.00\" ui-money-mask \nng-class=\"{\n                invalid: productServiceForm.value.$touched && productServiceForm.value.$invalid,\n                \'input-product-service-locked\': vm.productService.locked\n              }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'PRODUCTS_SERVICES.MODEL.VALUE\' | translate)}}</label><fc-error \nng-show=\"productServiceForm.value.$touched\" input-errors=\"productServiceForm.value.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'PRODUCTS_SERVICES.MODEL.ERRORS.VALUE_REQUIRED\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"20\"><fc-select \nng-class=\"{\'img-product-service--disabled\': vm.productService.locked}\" \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{ \'PRODUCTS_SERVICES.DIALOG.MEASURE\' | translate }}\" ng-model=\"vm.productService.measure\" \noptions=\"vm.measuresSelectOptions\" is-required=\"vm.productService.type === \'product\'\" input-name=\"measure\" \ninput-control=\"productServiceForm.measure\" is-disabled=\"vm.productService.type === \'service\'\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'PRODUCTS_SERVICES.MODEL.ERRORS.MEASURE_REQUIRED\'\n              }\n            ]\">\n</fc-select></div></div><div layout-xs=\"column\" layout=\"row\" class=\"mt-30\"><div flex=\"100\"><fc-textarea \nclass=\"fc-textarea__textarea--change-border-color\" is-disabled=\"vm.productService.locked\" \nlabel=\"{{(\'PRODUCTS_SERVICES.MODEL.DESCRIPTION\' | translate)}}\" ng-model=\"vm.productService.description\" \ninput-name=\"description\" input-control=\"productServiceForm.description\" \nng-class=\"{\n            \'input-product-service-locked\': vm.productService.locked\n          }\" max-length=\"2000\" \nerrors-to-watch=\"[\n            {\n              name: \'maxlength\',\n              translate: \'PRODUCTS_SERVICES.MODEL.ERRORS.MAX_LENGTH\',\n              translateValues: { expectedLength: 2000, receivedLength: productServiceForm.description.$viewValue.length }\n            },\n          ]\">\n</fc-textarea></div></div></md-dialog-content><md-dialog-actions layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><button class=\"fc-button fc-button--actions\" type=\"submit\" ng-if=\"!vm.newProductService\" \nng-class=\"{disabled: productServiceForm.$invalid || productServiceForm.$pristine || $root.loadingProgress === true}\" \nng-click=\"vm.saveProductService()\" \nng-disabled=\"productServiceForm.$invalid || productServiceForm.$pristine || $root.loadingProgress === true || vm.productService.locked\" \naria-label=\"Save\" translate=\"PRODUCTS_SERVICES.DIALOG.ACTIONS.SAVE\" \ntranslate-attr-aria-label=\"PRODUCTS_SERVICES.DIALOG.ACTIONS.SAVE\">Save</button> <button data-cy=\"add-plan-type\" \nclass=\"fc-button fc-button--actions\" type=\"submit\" ng-if=\"vm.newProductService\" \nng-class=\"{disabled: productServiceForm.$invalid || productServiceForm.$pristine || $root.loadingProgress === true}\" \nng-click=\"vm.saveProductService()\" \nng-disabled=\"productServiceForm.$invalid || productServiceForm.$pristine || $root.loadingProgress === true || vm.productService.locked\" \naria-label=\"Add Plan Type\" translate=\"PRODUCTS_SERVICES.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"PRODUCTS_SERVICES.DIALOG.ACTIONS.CREATE\">Create</button></div><div layout=\"row\" \nng-if=\"vm.productService.id && vm.from !== \'quotations\'\"><md-button ng-show=\"!vm.productService.archived\" \nclass=\"md-icon-button\" ng-click=\"vm.archiveProductService($event)\" aria-label=\"Archive\" translate \nng-disabled=\"vm.productService.locked\" translate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-download\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button \nng-show=\"vm.productService.archived\" class=\"md-icon-button\" ng-click=\"vm.unarchiveProductService($event)\" \naria-label=\"Unarchive\" translate ng-disabled=\"vm.productService.locked\" \ntranslate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/products-services/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"PRODUCTS_SERVICES.FILTERS.TITLE\">Filter Product and services</span><md-button \nng-if=\"vm.productsServicesFilters.isOn()\" ng-click=\"vm.productsServicesFilters.clear()\" class=\"md-icon-button\" \naria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"PRODUCTS_SERVICES.FILTERS.CLEAR\">Clear</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-equipments\" ms-scroll><md-list-item><input flex class=\"search-input\" type=\"text\" \nng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by name\" translate \ntranslate-attr-placeholder=\"PRODUCTS_SERVICES.FILTERS.NAME\" ng-model=\"vm.productsServicesFilters.name\" \nng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"PRODUCTS_SERVICES.FILTERS.TYPE.TITLE\">Filter by type</span></div><md-list-item><md-select \nclass=\"w-100-percent mt-0 mb-0\" name=\"type\" ng-change=\"vm.broadcastFilterUpdated()\" \nng-model=\"vm.productsServicesFilters.type\"><md-option translate=\"PRODUCTS_SERVICES.FILTERS.TYPE.ALL\" value=\"-1\">All\n</md-option><md-option translate=\"PRODUCTS_SERVICES.FILTERS.TYPE.PRODUCT\" value=\"product\">Product</md-option><md-option\n translate=\"PRODUCTS_SERVICES.FILTERS.TYPE.SERVICE\" value=\"service\">Service</md-option></md-select></md-list-item>\n<md-divider></md-divider><div class=\"filter-subtitle\"><span translate=\"PRODUCTS_SERVICES.FILTERS.SITUATIONS.TITLE\">\nFilter by situation</span></div><md-list-item><md-select class=\"w-100-percent mt-0 mb-0\" name=\"archived\" \nng-change=\"vm.broadcastFilterUpdated()\" ng-model=\"vm.productsServicesFilters.archived\"><md-option \ntranslate=\"PRODUCTS_SERVICES.FILTERS.SITUATIONS.ALL\" value=\"-1\">All</md-option><md-option \ntranslate=\"PRODUCTS_SERVICES.FILTERS.SITUATIONS.ACTIVE\" value=\"1\">Active</md-option><md-option \ntranslate=\"PRODUCTS_SERVICES.FILTERS.SITUATIONS.ARCHIVED\" value=\"0\">Archived</md-option></md-select></md-list-item>\n</md-content>");
$templateCache.put("app/main/products-services/sidenavs/import-modal/import-products-services-modal.html","<div><p class=\"fc-modal__content\">{{vm.variables.title}}</p><div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{ vm.variables.progressPercentage }}\"></md-progress-linear><div layout=\"column\" layout-align=\"flex-end\"><p \nclass=\"fs-16 flex-end\">{{ vm.variables.totalProductsImported || \'0\' }} <span \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_FROM\">from</span> {{ vm.variables.totalProductsToImport }}\n</p></div></div></div>");
$templateCache.put("app/main/quotations/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span class=\"menu-title text-left\" flex \ntranslate=\"QUOTATIONS.FILTERS.TITLE\">Filter Quotations</span><md-button class=\"md-icon-button\" \nng-if=\"vm.quotationsFilters.isOn()\" ng-click=\"vm.quotationsFilters.clear()\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"QUOTATIONS.FILTERS.CLEAR\">\nClear</span></md-tooltip></md-button></div></md-toolbar><md-content class=\"animate-slide-right filter-quotations\" \nms-scroll><md-list-item><div flex=\"100\" class=\"fc-input\"><input flex class=\"fc-input__input\" type=\"text\" \nng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by name\" translate \ntranslate-attr-placeholder=\"QUOTATIONS.FILTERS.NAME\" ng-model=\"vm.quotationsFilters.name\" \nng-change=\"vm.broadcastFilterUpdated();\"></div></md-list-item><md-list-item><div flex=\"100\" class=\"fc-input\"><input \nflex class=\"fc-input__input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by identifier\" \ntranslate translate-attr-placeholder=\"QUOTATIONS.FILTERS.IDENTIFIER\" ng-model=\"vm.quotationsFilters.identifier\" \nng-change=\"vm.broadcastFilterUpdated();\"></div></md-list-item><md-list-item><div flex=\"100\" class=\"fc-input\"><input \nflex class=\"fc-input__input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"Filter customer\" translate \ntranslate-attr-placeholder=\"QUOTATIONS.FILTERS.CUSTOMER.PLACEHOLDER\" ng-model=\"vm.quotationsFilters.customer\" \nng-change=\"vm.broadcastFilterUpdated();\"></div></md-list-item><md-list-item><div flex=\"100\" class=\"fc-input\"><input \nflex class=\"fc-input__input\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by author\" translate \ntranslate-attr-placeholder=\"QUOTATIONS.FILTERS.CREATED_BY.PLACEHOLDER\" ng-model=\"vm.quotationsFilters.createdBy\" \nng-change=\"vm.broadcastFilterUpdated();\"></div></md-list-item><md-list-item><div flex=\"100\"><fc-select \nng-model=\"vm.quotationsFilters.archived\" options=\"vm.archived\" input-name=\"archived\" \nng-change=\"vm.broadcastFilterUpdated()\" name=\"archived\"></fc-select></div></md-list-item><md-list-item><div flex=\"100\">\n<fc-select ng-model=\"vm.quotationsFilters.dateType\" options=\"vm.dateType\" input-name=\"dateType\" \nng-change=\"vm.broadcastFilterUpdated()\" name=\"dateType\"></fc-select></div></md-list-item><div \nclass=\"border date-component\"><md-list-item><label>{{ \'QUOTATIONS.FILTERS.DATE.FROM\' | translate }}</label><div \nclass=\"fc-datepicker\" flex=\"100\"><div class=\"date-container\"><md-datepicker ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.quotationsFilters.dateFrom\" md-placeholder=\"{{ \'QUOTATIONS.FILTERS.DATE.SELECT_DATE\' | translate }}\">\n</md-datepicker></div></div></md-list-item><md-list-item><label class=\"\">{{ \'QUOTATIONS.FILTERS.DATE.TO\' | translate }}\n</label><div class=\"fc-datepicker\" flex=\"100\"><md-datepicker ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.quotationsFilters.dateTo\" md-placeholder=\"{{ \'QUOTATIONS.FILTERS.DATE.SELECT_DATE\' | translate }}\">\n</md-datepicker></div></md-list-item></div><div class=\"fc-card border\"><div class=\"filter-subtitle\"><span \ntranslate=\"QUOTATIONS.FILTERS.SITUATION\">Filter by status</span></div><md-list-item class=\"label\" \nng-repeat=\"quotationStatus in vm.quotationsStatus\" \nng-click=\"vm.toggleInArray(quotationStatus.name, vm.quotationsFilters.status)\"><p \nng-class=\"\'quotation-status-\' + quotationStatus.name + \'-fg\'\">{{ quotationStatus.description }}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(quotationStatus.name, vm.quotationsFilters.status)\"></i></md-list-item></div>\n<div class=\"fc-card border mb-30\" ng-if=\"vm.labels && vm.labels.length > 0\"><div class=\"filter-subtitle\" \ntranslate=\"QUOTATIONS.FILTERS.FILTER_BY_LABEL.LABEL\">Filter by tags</div><md-list-item class=\"label\" \ndata-cy=\"quotations-filters.labels-no-label\" ng-click=\"vm.toggleInArray(null, vm.quotationsFilters.labels)\"><md-icon \nmd-font-icon=\"icon-label-outline\" class=\"label-icon\"></md-icon><p \ntranslate=\"QUOTATIONS.FILTERS.FILTER_BY_LABEL.NO_LABEL\">No tag</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(null, vm.quotationsFilters.labels)\"></i></md-list-item><md-list-item class=\"label\" \ndata-cy=\"quotations-filters.labels-{{ $index }}\" ng-repeat=\"label in vm.labels\" \nng-click=\"vm.toggleInArray(label.id, vm.quotationsFilters.labels)\"><md-icon md-font-icon=\"icon-label\" \nng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(label.id, vm.quotationsFilters.labels)\"></i></md-list-item></div></md-content>");
$templateCache.put("app/main/recurrences/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"RECURRENCES.FILTERS.TITLE\">Filter Recurrences</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"RECURRENCES.FILTERS.CLEAR\">Clear filters</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-recurrences\" ms-scroll><md-list><div class=\"filter-subtitle\"><span \ntranslate=\"RECURRENCES.FILTERS.DATE.TITLE\">Filter by date</span></div><md-list-item><label \ntranslate=\"RECURRENCES.FILTERS.DATE.FROM\">From:</label><md-datepicker ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.recurrencesFilters.startDate\" md-placeholder=\"{{ \'RECURRENCES.FILTERS.DATE.SELECT\' | translate }}\">\n</md-datepicker></md-list-item><md-list-item><label translate=\"RECURRENCES.FILTERS.DATE.TO\">To:</label><md-datepicker \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.recurrencesFilters.endDate\" \nmd-placeholder=\"{{ \'RECURRENCES.FILTERS.DATE.SELECT\' | translate }}\"></md-datepicker></md-list-item><md-divider>\n</md-divider><md-list><div class=\"filter-subtitle\"><span translate=\"RECURRENCES.FILTERS.DATE.BY_DEADLINE.TITLE\">\nFilter by deadline</span></div><md-list-item><label translate=\"RECURRENCES.FILTERS.DATE.FROM\">From:</label>\n<md-datepicker ng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.recurrencesFilters.recurrenceDateDeadlineFrom\" \nmd-placeholder=\"{{ \'RECURRENCES.FILTERS.DATE.SELECT\' | translate }}\"></md-datepicker></md-list-item><md-list-item>\n<label translate=\"RECURRENCES.FILTERS.DATE.TO\">To:</label><md-datepicker ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.recurrencesFilters.recurrenceDateDeadlineTo\" \nmd-placeholder=\"{{ \'RECURRENCES.FILTERS.DATE.SELECT\' | translate }}\"></md-datepicker></md-list-item><md-list-item>\n<input flex class=\"search-input\" placeholder=\"Search by customer\" translate \ntranslate-attr-placeholder=\"RECURRENCES.FILTERS.CUSTOMER\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.recurrencesFilters.customer\"></md-list-item><md-list-item><input \nflex class=\"search-input\" placeholder=\"Search by observation\" translate \ntranslate-attr-placeholder=\"RECURRENCES.FILTERS.OBSERVATION\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.recurrencesFilters.notes\"></md-list-item><md-list-item><input \nflex class=\"search-input\" placeholder=\"Search by location\" translate \ntranslate-attr-placeholder=\"RECURRENCES.FILTERS.LOCATION\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.recurrencesFilters.location\"></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\"><span translate=\"RECURRENCES.FILTERS.SERVICE.TITLE\">Filter by OS type</span>\n</div><md-list-item><md-input-container><label ng-show=\"vm.recurrencesFilters.length == 0\">\n{{ \'RECURRENCES.FILTERS.SERVICE.TITLE\' | translate }}</label><md-select ng-model=\"vm.recurrencesFilters.services\" \nng-model-options=\"{trackBy: \'$value.id\', debounce: 100}\" md-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" \nng-change=\"vm.broadcastFilterUpdated();\" multiple=\"multiple\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'RECURRENCES.FILTERS.SERVICE.TITLE\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"service\" \nng-repeat=\"service in vm.services | filter:vm.searchTerm | orderBy: \'name\'\">\n{{(service.name && service.name.length) > 40 ? service.name.substring(0, 40) + \'...\' : service.name}}</md-option>\n</md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\">\n<span translate=\"RECURRENCES.FILTERS.EMPLOYEE\">Search by employee</span></div><md-list-item><input flex \nplaceholder=\"Search by employee\" translate translate-attr-placeholder=\"RECURRENCES.FILTERS.EMPLOYEE\" type=\"text\" \nclass=\"pl-10 h-35 search-input\" ng-model-options=\"{ debounce: 100 }\" ng-model=\"vm.employeeFilter\"></md-list-item>\n<md-list-item class=\"member\" ng-click=\"vm.toggleInArray(\'null\', vm.recurrencesFilters.employees)\" \naria-label=\"Toggle Member\"><div class=\"avatar bg-grey\"><i class=\"icon icon-account-remove s25 color-white\"></i></div><p\n class=\"member-name\"><span translate=\"RECURRENCES.MODEL.NO_EMPLOYEE\">No employee</span></p><i class=\"icon-check s16\" \nng-if=\"vm.exists(\'null\', vm.recurrencesFilters.employees)\"></i></md-list-item><md-list-item class=\"member\" \nng-repeat=\"employee in vm.employees | filter: { name: vm.employeeFilter }\" \nng-click=\"vm.toggleInArray(employee.id, vm.recurrencesFilters.employees)\" aria-label=\"Toggle Member\"><div \nclass=\"avatar bg-grey\"><img alt=\"{{ employee.name }}\" class=\"avatar\" \nng-src=\"{{ employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\' }}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ employee.name }}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(employee.id, vm.recurrencesFilters.employees)\"></i></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\"><span translate=\"RECURRENCES.FILTERS.SITUATIONS.TITLE\">Filter by situation\n</span></div><md-list-item><md-select class=\"mt-0 w-100-percent\" name=\"archived\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.recurrencesFilters.archived\"><md-option value=\"-1\"><span \ntranslate=\"RECURRENCES.FILTERS.SITUATIONS.ALL\">All</span></md-option><md-option value=\"1\"><span \ntranslate=\"RECURRENCES.FILTERS.SITUATIONS.ACTIVE\">Active</span></md-option><md-option value=\"0\"><span \ntranslate=\"RECURRENCES.FILTERS.SITUATIONS.ARCHIVED\">Archived</span></md-option></md-select></md-list-item></md-list>\n</md-list></md-content>");
$templateCache.put("app/main/routes/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"ROUTES.FILTER\">Filter activities</span><md-button ng-if=\"vm.filteringIsOn()\" ng-click=\"vm.clearFilters()\" \nclass=\"md-icon-button\" aria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip \nmd-direction=\"left\"><span translate=\"ROUTES.FILTERS.CLEAR\">Clear filters</span></md-tooltip></md-button></div>\n</md-toolbar><md-content ms-scroll><md-list><md-list-item><label translate=\"ROUTES.FILTERS.DATE.LABEL\">Date:</label>\n<md-datepicker class=\"ml-1\" ng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.routesFilters.date\" \nmd-min-date=\"vm.minDate\" md-placeholder=\"{{\'ROUTES.FILTERS.DATE.PLACEHOLDER\' | translate}}\"></md-datepicker>\n</md-list-item><div class=\"ml-15\" ng-if=\"vm.invalidDate\"><span class=\"red-text\" \ntranslate=\"ROUTES.FILTERS.DATE.PLACEHOLDER\" translate-values=\"{ validDateFormat: vm.validDateFormat }\">\nThe minimum date to be filtered is: {{vm.validDateFormat}}.</span></div><div class=\"item-title\" \ntranslate=\"ROUTES.FILTERS.COLLABORATOR.LABEL\">Filter by employee</div><md-list-item ng-if=\"vm.employees.length >= 10\">\n<input flex placeholder=\"Search by collaborator\" type=\"text\" class=\"employee-search-input\" \nng-model-options=\"{ debounce: 100 }\" ng-model=\"vm.employeeFilter\" translate \ntranslate-attr-placeholder=\"ROUTES.FILTERS.COLLABORATOR.PLACEHOLDER\"></md-list-item><md-list-item class=\"member\" \nng-repeat=\"employee in vm.employees | filter: { name: vm.employeeFilter }\" ng-click=\"vm.selectEmployee(employee);\" \naria-label=\"{{\'ROUTES.FILTERS.COLLABORATOR.SELECT\' | translate }}\"><div class=\"avatar\"><img class=\"avatar\" \nng-src=\"{{employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ employee.name }}</p><i \nclass=\"icon-check s16\" ng-if=\"employee.id === vm.routesFilters.employeeId\"></i></md-list-item></md-list></md-content>");
$templateCache.put("app/main/services/dialogs/alert/archive-service-alert.html","<md-dialog id=\"archive-service-alert-dialog\" aria-label=\"archive-service-alert-dialog\"><md-dialog-content><h3 \nclass=\"md-title\" translate=\"SERVICES.DIALOG.ARCHIVE_ALERT.TITLE\">Archive OS type</h3><p \ntranslate=\"SERVICES.DIALOG.ARCHIVE_ALERT.DESCRIPTION\">In some equipment types there are forms linked to this OS type:\n</p><div class=\"task-types\"><table><thead><tr><th translate=\"SERVICES.DIALOG.ARCHIVE_ALERT.FORM\">Form</th><th \ntranslate=\"SERVICES.DIALOG.ARCHIVE_ALERT.EQUIPMENT_TYPE\">Equipment type</th></tr></thead><tbody ms-scroll><tr \nng-repeat=\"item in vm.items\"><td>{{ item.form }}</td><td>{{ item.equipmentType }}</td></tr></tbody></table></div><p \ntranslate=\"SERVICES.DIALOG.ARCHIVE_ALERT.WHEN_ARCHIVED\">\nWhen a OS type is archived, the forms linked to it are removed from the equipment types.</p></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button class=\"cancel-button\" ng-click=\"vm.cancel()\" \ntranslate=\"SERVICES.DIALOG.ARCHIVE_ALERT.CANCEL\">Cancel</md-button><md-button data-cy=\"confirm-archive-button\" \nclass=\"confirm-button\" ng-click=\"vm.confirm()\" translate=\"SERVICES.DIALOG.ARCHIVE_ALERT.CONFIRM\">Continue and archive\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/services/dialogs/tabs/employees-tab.html","<div class=\"tab-service-dialog\"><div class=\"section-header mb-10\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"section-title\" translate=\"SERVICES.DIALOG.EMPLOYEES.IN_CHARGE\">Trained employees</span> &nbsp;&nbsp;&nbsp;&nbsp;\n<md-checkbox class=\"md-primary\" ng-checked=\"vm.selectAll\" ng-click=\"vm.toggleAllEmployees();\"><small \ntranslate=\"SERVICES.DIALOG.EMPLOYEES.SELECT_ALL\">Select all</small></md-checkbox></div><div flex=\"100\" \nflex-gt-sm=\"100\" layout=\"column\" class=\"mt-10n\"><div class=\"checkbox-list\"><div layout=\"row\" layout-wrap flex><div \nflex=\"50\" ng-repeat=\"employee in vm.employees\"><md-checkbox class=\"md-primary\" \nng-checked=\"exists(employee.id, employeeSkills)\" ng-click=\"toggle(employee.id, employeeSkills)\">\n{{ employee.name | limitTo: 25 }}</md-checkbox></div></div></div></div><div class=\"h-7\"></div></div>");
$templateCache.put("app/main/services/dialogs/tabs/forms-tab.html","<div class=\"tab-forms tab-service-dialog\"><div \nng-if=\"!(vm.service && vm.service.metadata && vm.service.metadata.sammathnaur)\" layout-xs=\"column\" layout=\"row\" \nclass=\"fs-14 mt-10n\"><md-input-container class=\"md-block\"><span class=\"text-gray small\" \ntranslate=\"SERVICES.DIALOG.FORMS.ADD\">Add form</span><label translate=\"SERVICES.DIALOG.FORMS.SEARCH\">Search form ...\n</label><md-select data-cy=\"form-search\" ng-disabled=\"vm.forms.length === 0\" ng-model=\"vm.selectedFormId\" \nclass=\"text-gray\" ng-change=\"vm.addForm(vm.selectedFormId);\"><md-select-header class=\"header-services\"><input \ndata-cy=\"form-input\" size=\"50\" type=\"text\" autocomplete=\"off\" translate \ntranslate-attr-placeholder=\"SERVICES.DIALOG.FORMS.SEARCH\" onkeydown=\"event.stopPropagation()\" \nng-model=\"vm.formSearchTerm\" ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.searchForm()\"></md-select-header>\n<md-option ng-repeat=\"form in vm.forms\" value=\"{{form.id}}\">{{form.name}}</md-option><md-option \nng-if=\"vm.forms.length === 0\" value=\"-1\"><span translate=\"SERVICES.DIALOG.FORMS.ALL_FORMS_ADDED\">\nAll forms are already added</span></md-option></md-select></md-input-container></div><div \nng-if=\"!(vm.service && vm.service.metadata && vm.service.metadata.sammathnaur)\" class=\"allow-all-forms fs-12\"><div \nlayout=\"column\"><span class=\"h4\" translate=\"SERVICES.DIALOG.FORMS.ALLOW_OTHER_FORMS\">\nAllow the technician to respond to other forms </span><span class=\"text-gray small\" \ntranslate=\"SERVICES.DIALOG.FORMS.ALLOW_OTHER_DESCRIPTION\">\nThis options allows an employee to add other forms that are not linked to the OS type</span></div><md-switch \nng-model=\"vm.service.allowAllForms\" ng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\">\n</md-switch></div><md-divider class=\"mb-10\" ng-if=\"vm.service.forms.length > 0\"></md-divider><p \nclass=\"fs-14 color-grey\" ng-if=\"!vm.service.forms.length\"><span translate=\"SERVICES.DIALOG.FORMS.EMPTY\">\nNo forms added for this OS type</span></p><div ng-if=\"vm.service.forms.length\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-list flex=\"100\" class=\"form-list\"><md-list-item class=\"form-list__row\" layout=\"row\"><p flex=\"70\" class=\"text-gray\" \ntranslate=\"SERVICES.DIALOG.FORMS.LINKED_FORMS\">Linked forms</p><div flex=\"30\" class=\"icons-header\"><md-icon \nmd-svg-src=\"assets/icons/icon-lock-clock.svg\" class=\"color-yellow\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICES.DIALOG.FORMS.REQUIRED_TO_START\">Required to start visit</span></md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"s22 color-green\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICES.DIALOG.FORMS.REQUIRED_TO_COMPLETE\">Required to complete visit</span></md-tooltip></md-icon><md-icon\n md-font-icon=\"icon-alert\" class=\"s22 color-red\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"SERVICES.DIALOG.FORMS.REQUIRED_TO_IMPEDIMENT\">Required to record impediment</span></md-tooltip></md-icon>\n</div></md-list-item><md-list-item ng-repeat=\"form in vm.service.forms track by $index\" class=\"form-list__row\" \nlayout=\"row\"><div flex=\"70\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteForm(form.id);\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s22\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"SERVICES.DIALOG.FORMS.REMOVE\">Remove form\n</span></md-tooltip></md-button>{{ form.name }} <small class=\"questions-count fs-12\"><span \nng-if=\"form.questions.length === 1\" translate=\"SERVICES.DIALOG.FORMS.QUESTION_QTY\" \ntranslate-values=\"{ questionsQty: form.questions.length }\">({{ form.questions.length }} question) </span><span \nng-if=\"form.questions.length > 1\" translate=\"SERVICES.DIALOG.FORMS.QUESTIONS_QTY\" \ntranslate-values=\"{ questionsQty: form.questions.length }\">({{ form.questions.length }} questions)</span></small></div>\n<div flex=\"30\" class=\"switches\"><md-switch ng-model=\"form.required.start\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\"></md-switch><md-switch \nng-model=\"form.required.complete\" ng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\">\n</md-switch><md-switch ng-model=\"form.required.report\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\"></md-switch></div></md-list-item>\n</md-list></div></div></div>");
$templateCache.put("app/main/services/dialogs/tabs/general-tab.html","<div class=\"tab-general tab-service-dialog\"><div layout-xs=\"column\" layout=\"row\" class=\"mb-40n\"><div flex=\"55\">\n<md-input-container class=\"md-block\" flex><label translate=\"SERVICES.MODEL.DESCRIPTION\">Description</label><input \ndata-cy=\"description-input\" name=\"description\" ng-model=\"vm.service.description\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.validateDescription()\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" title=\"{{vm.service.description}}\" \nrequired><div ng-messages=\"serviceForm.description.$error\" ng-show=\"serviceForm.description.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"SERVICES.MODEL.ERRORS.DESCRIPTION_REQUIRED\">Description is required</span>\n</div><div ng-message=\"duplicated\"><span translate=\"SERVICES.MODEL.ERRORS.DESCRIPTION_DUPLICATED\">\nDescription is duplicated</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"SERVICES.MODEL.ERRORS.DESCRIPTION_MAXLENGTH\">Maximum length of 150 characters</span></div></div>\n</md-input-container></div><div flex=\"25\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"SERVICES.MODEL.DURATION\">Duration</label><input data-cy=\"duration-input\" name=\"duration\" \nng-model=\"vm.service.duration\" type=\"number\" min=\"1\" max=\"999\" required><div ng-messages=\"serviceForm.duration.$error\" \nng-if=\"serviceForm.duration.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"SERVICES.MODEL.ERRORS.DURATION_REQUIRED\">Duration is required</span></div><div ng-message=\"max\"><span \ntranslate=\"SERVICES.MODEL.ERRORS.DURATION_MAX\">Maximum duration of 999 minutes</span></div><div ng-message=\"min\"><span \ntranslate=\"SERVICES.MODEL.ERRORS.DURATION_MIN\">Minimum duration of 1 minute</span></div></div></md-input-container>\n</div><div flex=\"20\"><md-input-container class=\"md-block\" flex><label translate=\"SERVICES.MODEL.DEADLINE\">\nDeadline (days)</label><input data-cy=\"slaTimeLimit-input\" name=\"slaTimeLimit\" type=\"number\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" ng-model=\"vm.service.slaTimeLimit\" \nmin=\"1\" max=\"999\"><div ng-messages=\"serviceForm.slaTimeLimit.$error\" ng-if=\"serviceForm.slaTimeLimit.$touched\" \nrole=\"alert\"><div ng-message=\"max\"><span translate=\"SERVICES.MODEL.ERRORS.DEADLINE_MAX\">Maximum deadline of 999 minutes\n</span></div><div ng-message=\"min\"><span translate=\"SERVICES.MODEL.ERRORS.DEADLINE_MIN\">Minimum deadline of 1 minute\n</span></div></div></md-input-container></div></div><div layout-xs=\"column\" layout=\"column\" \nclass=\"fs-12 mt-25n tab-general__configurations\"><div><md-switch data-cy=\"quotation-required-switch\" \nng-model=\"vm.service.quotationRequired\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\"><span \nng-if=\"vm.service.quotationRequired\" translate=\"SERVICES.MODEL.QUOTATION_REQUIRED\">\nQuotation is required to complete this service</span> <span ng-if=\"!vm.service.quotationRequired\" \ntranslate=\"SERVICES.MODEL.QUOTATION_NOT_REQUIRED\">Quotation <strong>isn\'t</strong> required to complete this service\n</span></md-switch></div><div><md-switch data-cy=\"signature-required-switch\" ng-model=\"vm.service.signatureRequired\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\"><span \nng-if=\"vm.service.signatureRequired\" translate=\"SERVICES.MODEL.SIGNATURE_REQUIRED\">\nSignature is required to complete this service</span> <span ng-if=\"!vm.service.signatureRequired\" \ntranslate=\"SERVICES.MODEL.SIGNATURE_NOT_REQUIRED\">Signature <strong>isn\'t</strong> required to complete this service\n</span></md-switch></div><div><md-switch data-cy=\"work-order-upon-switch\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" \nng-model=\"vm.service.configurations.notifications.sendEmailEmployeeOrderReportWhenCompleted\"><span \nng-if=\"vm.service.configurations.notifications.sendEmailEmployeeOrderReportWhenCompleted\" \ntranslate=\"SERVICES.MODEL.LINK_AUTO_SUBMIT_EMPLOYEE_ENABLED\"><strong>Send</strong>\n email with the work order upon completion of the activity. </span><span \nng-if=\"!vm.service.configurations.notifications.sendEmailEmployeeOrderReportWhenCompleted\" \ntranslate=\"SERVICES.MODEL.LINK_AUTO_SUBMIT_EMPLOYEE_DISABLED\"><strong>Do not send</strong>\n email with the work order upon completion of the activity.</span></md-switch></div><div><md-switch \ndata-cy=\"work-order-link-switch\" ng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" \nng-model=\"vm.service.configurations.notifications.sendEmailOrderReportLinkWhenCompleted\"><span \nng-if=\"vm.service.configurations.notifications.sendEmailOrderReportLinkWhenCompleted\" \ntranslate=\"SERVICES.MODEL.LINK_AUTO_SUBMIT_ENABLED\"><strong>Send</strong>\n email with the work order link automatically upon completion of the activity. </span><span \nng-if=\"!vm.service.configurations.notifications.sendEmailOrderReportLinkWhenCompleted\" \ntranslate=\"SERVICES.MODEL.LINK_AUTO_SUBMIT_DISABLED\"><strong>Do not send</strong>\n email with the work order link automatically upon completion of the activity.</span></md-switch></div><div><md-switch \ndata-cy=\"link-automatically-upon-switch\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" \nng-model=\"vm.service.configurations.notifications.sendEmailTaskRatingLinkWhenCompleted\"><span \nng-if=\"vm.service.configurations.notifications.sendEmailTaskRatingLinkWhenCompleted\" \ntranslate=\"SERVICES.MODEL.RATING_LINK_AUTO_SUBMIT_ENABLED\"><strong>Send</strong>\n email with the assessment link automatically upon completion of the activity. </span><span \nng-if=\"!vm.service.configurations.notifications.sendEmailTaskRatingLinkWhenCompleted\" \ntranslate=\"SERVICES.MODEL.RATING_LINK_AUTO_SUBMIT_DISABLED\"><strong>Do not send</strong>\n email with the assessment link automatically upon completion of the activity.</span></md-switch></div><div><md-switch \ndata-cy=\"link-to-the-collaborator-switch\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" \nng-model=\"vm.service.configurations.notifications.sendEmailEmployeeRouteTrackingLinkWhenOnRoute\"><span \nng-if=\"vm.service.configurations.notifications.sendEmailEmployeeRouteTrackingLinkWhenOnRoute\" \ntranslate=\"SERVICES.MODEL.ON_ROUTE_LINK_AUTO_SUBMIT_ENABLED\"><strong>Send</strong>\n an email with the link to the collaborator\'s location automatically after the shift starts. </span><span \nng-if=\"!vm.service.configurations.notifications.sendEmailEmployeeRouteTrackingLinkWhenOnRoute\" \ntranslate=\"SERVICES.MODEL.ON_ROUTE_LINK_AUTO_SUBMIT_DISABLED\"><strong>Do not send</strong>\n an email with the link to the collaborator\'s location automatically after the shift starts.</span></md-switch></div>\n<div><md-switch data-cy=\"order-evaluation-link-switch\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" \nng-model=\"vm.service.showRatingForm\" ng-change=\"vm.changeShowRatingForm()\"><span ng-if=\"vm.service.showRatingForm\" \ntranslate=\"SERVICES.MODEL.RATING_FORM_ENABLED\"><strong>View</strong>\n the service form on the work order evaluation link. </span><span ng-if=\"!vm.service.showRatingForm\" \ntranslate=\"SERVICES.MODEL.RATING_FORM_DISABLED\"><strong>Do not</strong>\n display the service form on the work order evaluation link.</span></md-switch></div><div \nclass=\"tab-general__configurations__rating-form\" ng-if=\"vm.service.showRatingForm\" flex=\"100\"><fc-select \ndata-cy=\"rating-form-select\" label=\"{{(\'SERVICES.DIALOG.FORMS.RATING_FORM\' | translate)}}\" ng-model=\"vm.ratingForm\" \nng-change=\"vm.changeRatingForm(value)\" options=\"vm.formSelectOptions\" input-name=\"ratingForm\" \ninput-control=\"serviceForm.ratingForm\" track-by=\"name\" \nis-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" with-search=\"true\" \nsearch-phrase=\"{{(\'SERVICES.DIALOG.FORMS.SEARCH\' | translate)}}\" is-required=\"true\"></fc-select></div><div \nng-if=\"vm.hasAutoSmartRewriteFeatureFlag\"><md-switch \nng-model=\"vm.service.configurations.mobile.autoSmartRewriteEnabled\"><div style=\"position: relative\" \nng-if=\"vm.service.configurations.mobile.autoSmartRewriteEnabled\"><span \ntranslate=\"SERVICES.MODEL.AUTO_SMART_REWRITE_ENABLED\"><strong>Automatically rewrite</strong>\n the task fields when employee completes the task</span></div><span \nng-if=\"!vm.service.configurations.mobile.autoSmartRewriteEnabled\" \ntranslate=\"SERVICES.MODEL.AUTO_SMART_REWRITE_DISABLED\"><strong>Do not automatically rewrite</strong>\n the task fields when employee completes the task</span></md-switch></div><input style=\"display: none\" \nname=\"autoSmartRewriteFields\" ng-model=\"vm.service.configurations.mobile.autoSmartRewriteFields\" \nng-required=\"vm.service.configurations.mobile.autoSmartRewriteEnabled\"><div \nclass=\"tab-general__configurations__auto-smart-rewrite-fields\" \nng-if=\"vm.service.configurations.mobile.autoSmartRewriteEnabled && vm.hasAutoSmartRewriteFeatureFlag\" layout \nlayout-gt-sm=\"column\"><md-checkbox class=\"md-primary m-0\" \nng-checked=\"vm.service.configurations.mobile.autoSmartRewriteFields.includes(\'statusDescription\')\" \nng-click=\"vm.toggleAutoSmartRewriteFields(\'statusDescription\')\"><span \ntranslate=\"SERVICES.MODEL.AUTO_SMART_REWRITE_FIELDS.STATUS_DESCRIPTION\">Status description</span></md-checkbox>\n<md-checkbox class=\"md-primary m-0\" \nng-checked=\"vm.service.configurations.mobile.autoSmartRewriteFields.includes(\'forms\')\" \nng-click=\"vm.toggleAutoSmartRewriteFields(\'forms\')\"><span translate=\"SERVICES.MODEL.AUTO_SMART_REWRITE_FIELDS.FORMS\">\nForms</span></md-checkbox><span ng-if=\"serviceForm.autoSmartRewriteFields.$error.required\" \nclass=\"tab-general__configurations__auto-smart-rewrite-fields__error\" \ntranslate=\"SERVICES.MODEL.ERRORS.AUTO_SMART_REWRITE_FIELDS_REQUIRED\">\nAt least one field must be selected for auto smart rewrite.</span></div><div \nng-if=\"vm.hasSmartOrderSummaryFeatureFlag\"><md-switch \nng-model=\"vm.service.configurations.smartSummary.postWork.enabled\"><div style=\"position: relative\" \nng-if=\"vm.service.configurations.smartSummary.postWork.enabled\"><span translate=\"SERVICES.MODEL.SMART_SUMMARY_ENABLED\">\n<strong>Generate</strong> a smart summary of the work order after the task is completed.</span></div><span \nng-if=\"!vm.service.configurations.smartSummary.postWork.enabled\" translate=\"SERVICES.MODEL.SMART_SUMMARY_DISABLED\">\n<strong>Do not generate</strong> a smart summary of the work order after the task is completed.</span></md-switch>\n</div><input style=\"display: none\" name=\"smartSummaryPostWorkDisplayOn\" \nng-model=\"vm.service.configurations.smartSummary.postWork.displayOn\" \nng-required=\"vm.service.configurations.smartSummary.postWork.enabled\"><div \nclass=\"tab-general__configurations__auto-smart-rewrite-fields\" \nng-if=\"vm.service.configurations.smartSummary.postWork.enabled && vm.hasSmartOrderSummaryFeatureFlag\" layout \nlayout-gt-sm=\"column\"><md-checkbox class=\"md-primary m-0\" \nng-checked=\"vm.service.configurations.smartSummary.postWork.displayOn.includes(\'web\')\" \nng-click=\"vm.toggleSmartSummaryPostWorkFields(\'web\')\"><span translate=\"SERVICES.MODEL.SMART_SUMMARY_DISPLAY_ON_WEB\">\nDisplay on web</span></md-checkbox><md-checkbox class=\"md-primary m-0\" \nng-checked=\"vm.service.configurations.smartSummary.postWork.displayOn.includes(\'mobile\')\" \nng-click=\"vm.toggleSmartSummaryPostWorkFields(\'mobile\')\"><span \ntranslate=\"SERVICES.MODEL.SMART_SUMMARY_DISPLAY_ON_MOBILE\">Display on mobile</span></md-checkbox><md-checkbox \nclass=\"md-primary m-0\" ng-checked=\"vm.service.configurations.smartSummary.postWork.displayOn.includes(\'report\')\" \nng-click=\"vm.toggleSmartSummaryPostWorkFields(\'report\')\"><span \ntranslate=\"SERVICES.MODEL.SMART_SUMMARY_DISPLAY_ON_REPORT\">Display on report</span></md-checkbox><span \nng-if=\"serviceForm.smartSummaryPostWorkDisplayOn.$error.required\" \nclass=\"tab-general__configurations__auto-smart-rewrite-fields__error\" \ntranslate=\"SERVICES.MODEL.ERRORS.SMART_SUMMARY_FIELDS_REQUIRED\">At least one field must be selected for smart summary.\n</span></div><div><md-switch data-cy=\"start-complete-validation-switch\" \nng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" \nng-model=\"vm.service.configurations.mobile.startNCompleteTaskValidationRadiusOn\"><div style=\"position: relative\" \nng-if=\"vm.service.configurations.mobile.startNCompleteTaskValidationRadiusOn\"><span \ntranslate=\"SERVICES.MODEL.VALIDATE_DISTANCE_ENABLED\"><strong>Validate</strong>\n the distance between customer and employee to change the status of the activity.</span><p class=\"version-hint\" \ntranslate=\"SERVICES.MODEL.VALIDATE_DISTANCE_HINT\">Will only take effect from the 12.9.0 app version onwards</p></div>\n<span ng-if=\"!vm.service.configurations.mobile.startNCompleteTaskValidationRadiusOn\" \ntranslate=\"SERVICES.MODEL.VALIDATE_DISTANCE_DISABLED\"><strong>Do not validate</strong>\n the distance between customer and employee to change the status of the activity.</span></md-switch></div><div \nclass=\"service-general-tab__configurations__distance-container distance-margin-top\" \nng-if=\"vm.service.configurations.mobile.startNCompleteTaskValidationRadiusOn\" layout layout-gt-sm=\"row\"><div flex=\"40\">\n<md-slider data-cy=\"task-distance-validation-slider\" class=\"mr-20\" style=\"cursor: pointer\" min=\"300\" max=\"20000\" \nng-model=\"vm.service.configurations.mobile.startNCompleteTaskValidationRadiusMeters\" \nid=\"mobileStartNCompleteTaskValidationRadiusMeters-slider\"></md-slider></div><div \nclass=\"service-general-tab__configurations__distance-container__input-container\" flex=\"30\"><div \nclass=\"fc-input fc-input--with-border\"><input data-cy=\"task-distance-validation-input\" \nclass=\"fc-input__input fc-input__input--without-border\" type=\"number\" placeholder=\" \" min=\"300\" max=\"20000\" \nng-required=\"vm.service.configurations.mobile.startNCompleteTaskValidationRadiusOn\" name=\"taskDistanceValidation\" \nautocomplete=\"off\" ng-disabled=\"vm.service && vm.service.metadata && vm.service.metadata.sammathnaur\" \nng-model=\"vm.service.configurations.mobile.startNCompleteTaskValidationRadiusMeters\" \nng-class=\"{\n              disabled: vm.service && vm.service.metadata && vm.service.metadata.sammathnaur,\n              invalid: serviceForm.taskDistanceValidation.$touched && serviceForm.taskDistanceValidation.$invalid\n            }\">\n<label class=\"fc-input__label\" translate=\"SERVICES.MODEL.DISTANCE\">Distance</label><div class=\"fc-input__half\" \ntranslate=\"SERVICES.MODEL.METERS\">meters</div><fc-error ng-show=\"serviceForm.taskDistanceValidation.$touched\" \ninput-errors=\"serviceForm.taskDistanceValidation.$error\" custom-class=\"fc-input__input-error custom-span-error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'SERVICES.MODEL.ERRORS.DISTANCE_REQUIRED\'\n              },\n              {\n                name: \'max\',\n                translate: \'SERVICES.MODEL.ERRORS.DISTANCE_MAX\'\n              },\n              {\n                name: \'min\',\n                translate: \'SERVICES.MODEL.ERRORS.DISTANCE_MIN\'\n              }\n            ]\">\n</div></div></div></div></div>");
$templateCache.put("app/main/services/dialogs/tabs/order-report-template-tab.html","<div class=\"tab-service-dialog tab-template\"><info-component-provider \ntext=\"{{ \'SERVICES.DIALOG.TEMPLATE.INFO\' | translate }}\"></info-component-provider><div \nclass=\"tab-template__empty-state\" ng-if=\"!vm.service.orderReportTemplate\"><span>\n{{ \'SERVICES.DIALOG.TEMPLATE.EMPTY_STATE\' | translate }}</span><md-button data-cy=\"link-order-report-template-button\" \nclass=\"tab-template__button\" ng-click=\"vm.linkOrderReportTemplate()\" translate=\"SERVICES.DIALOG.TEMPLATE.LINK\">Link\n</md-button></div><div class=\"tab-template__item\" ng-if=\"vm.service.orderReportTemplate\"><div \nclass=\"tab-template__icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" \nfill=\"none\"><path \nd=\"M7.425 9.4748L11.15 3.3998C11.25 3.23314 11.375 3.1123 11.525 3.0373C11.675 2.9623 11.8333 2.9248 12 2.9248C12.1667 2.9248 12.325 2.9623 12.475 3.0373C12.625 3.1123 12.75 3.23314 12.85 3.3998L16.575 9.4748C16.675 9.64147 16.725 9.81647 16.725 9.9998C16.725 10.1831 16.6833 10.3498 16.6 10.4998C16.5167 10.6498 16.4 10.7706 16.25 10.8623C16.1 10.954 15.925 10.9998 15.725 10.9998H8.275C8.075 10.9998 7.9 10.954 7.75 10.8623C7.6 10.7706 7.48333 10.6498 7.4 10.4998C7.31667 10.3498 7.275 10.1831 7.275 9.9998C7.275 9.81647 7.325 9.64147 7.425 9.4748ZM17.5 21.9998C16.25 21.9998 15.1875 21.5623 14.3125 20.6873C13.4375 19.8123 13 18.7498 13 17.4998C13 16.2498 13.4375 15.1873 14.3125 14.3123C15.1875 13.4373 16.25 12.9998 17.5 12.9998C18.75 12.9998 19.8125 13.4373 20.6875 14.3123C21.5625 15.1873 22 16.2498 22 17.4998C22 18.7498 21.5625 19.8123 20.6875 20.6873C19.8125 21.5623 18.75 21.9998 17.5 21.9998ZM3 20.4998V14.4998C3 14.2165 3.09583 13.979 3.2875 13.7873C3.47917 13.5956 3.71667 13.4998 4 13.4998H10C10.2833 13.4998 10.5208 13.5956 10.7125 13.7873C10.9042 13.979 11 14.2165 11 14.4998V20.4998C11 20.7831 10.9042 21.0206 10.7125 21.2123C10.5208 21.404 10.2833 21.4998 10 21.4998H4C3.71667 21.4998 3.47917 21.404 3.2875 21.2123C3.09583 21.0206 3 20.7831 3 20.4998ZM17.5 19.9998C18.2 19.9998 18.7917 19.7581 19.275 19.2748C19.7583 18.7915 20 18.1998 20 17.4998C20 16.7998 19.7583 16.2081 19.275 15.7248C18.7917 15.2415 18.2 14.9998 17.5 14.9998C16.8 14.9998 16.2083 15.2415 15.725 15.7248C15.2417 16.2081 15 16.7998 15 17.4998C15 18.1998 15.2417 18.7915 15.725 19.2748C16.2083 19.7581 16.8 19.9998 17.5 19.9998ZM5 19.4998H9V15.4998H5V19.4998ZM10.05 8.9998H13.95L12 5.8498L10.05 8.9998Z\" \nfill=\"#135AC0\"/></svg></div><div class=\"tab-template__content\"><strong>{{ vm.service.orderReportTemplate.name }}<div \nclass=\"tab-template__label\" \nng-class=\"{\n            \'tab-template__label--active\': vm.service.orderReportTemplate.archived ? false : vm.service.orderReportTemplate.active,\n            \'tab-template__label--inactive\': vm.service.orderReportTemplate.archived ? false : !vm.service.orderReportTemplate.active,\n            \'tab-template__label--archived\': vm.service.orderReportTemplate.archived\n          }\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\"><circle cx=\"6\" cy=\"6\" \nr=\"2.25\" fill=\"currentColor\"/></svg> <span \nng-if=\"vm.service.orderReportTemplate.archived ? false : vm.service.orderReportTemplate.active\">\n{{ \'SERVICES.DIALOG.TEMPLATE.ACTIVE\' | translate }} </span><span \nng-if=\"vm.service.orderReportTemplate.archived ? false : !vm.service.orderReportTemplate.active\">\n{{ \'SERVICES.DIALOG.TEMPLATE.INACTIVE\' | translate }} </span><span ng-if=\"vm.service.orderReportTemplate.archived\">\n{{ \'SERVICES.DIALOG.TEMPLATE.ARCHIVED\' | translate }}</span></div></strong><span>\n{{ \'SERVICES.DIALOG.TEMPLATE.TYPE.ORDER\' | translate }}</span></div><div class=\"tab-template__buttons\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.linkOrderReportTemplate()\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"tab-template__edit\"></md-icon><md-tooltip><span translate=\"SERVICES.DIALOG.TEMPLATE.EDIT\">Edit</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.unlinkOrderReportTemplate()\"><md-icon \nmd-font-icon=\"icon-trash\" class=\"tab-template__unlink\"></md-icon><md-tooltip><span \ntranslate=\"SERVICES.DIALOG.TEMPLATE.REMOVE\">Remove</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/services/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"SERVICES.FILTERS.TITLE\">Filter Services types</span><md-button ng-if=\"vm.servicesFilters.isOn()\" \nng-click=\"vm.servicesFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"SERVICES.FILTERS.CLEAR\">\nClear</span></md-tooltip></md-button></div></md-toolbar><md-content class=\"animate-slide-right filter-equipments\" \nms-scroll><md-list-item><input flex class=\"search-input\" type=\"text\" data-cy=\"filter-service-by-description\" \nng-model-options=\"{ debounce: 500 }\" placeholder=\"Search by description\" translate \ntranslate-attr-placeholder=\"SERVICES.FILTERS.DESCRIPTION\" ng-model=\"vm.servicesFilters.description\" \nng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"SERVICES.FILTERS.SITUATIONS.TITLE\">Filter by situation</span></div><md-list-item><md-select \ndata-cy=\"situation\" class=\"w-100-percent mt-0 mb-0\" name=\"archived\" id=\"select-situation-equipments\" \nng-change=\"vm.broadcastFilterUpdated()\" ng-model=\"vm.servicesFilters.archived\"><md-option \ntranslate=\"SERVICES.FILTERS.SITUATIONS.ALL\" value=\"-1\">All</md-option><md-option \ntranslate=\"SERVICES.FILTERS.SITUATIONS.ACTIVE\" value=\"1\">Active</md-option><md-option \ntranslate=\"SERVICES.FILTERS.SITUATIONS.ARCHIVED\" value=\"0\">Archived</md-option></md-select></md-list-item></md-content>");
$templateCache.put("app/main/settings/contents/account-info/account-info.html","<form name=\"companyForm\" class=\"md-inline-form\" novalidate id=\"account-info\"><div class=\"mb-15\" flex=\"100\" \nlayout=\"row\"><div flex class=\"w-210\" layout=\"row\" layout-align=\"start center\"><div class=\"avatar-image\" \nng-click=\"vm.useLocalPicture();\"><img \nng-src=\"{{ vm.avatarResultImage || vm.account.logoUrl + \'?updateAt=\'+ vm.currentUnixTime }}\" translate \ntranslate-attr-alt=\"CONFIGURATIONS.ACCOUNT.LOGO_ALT\" alt=\"Company logo\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip md-direction=\"top\"><span translate=\"CONFIGURATIONS.ACCOUNT.IMAGE_SIZE\" \ntranslate-values=\"{ minImageResolution: vm.minImageResolution }\">Ideal resolution is 512x512</span></md-tooltip></div>\n<input type=\"file\" id=\"file-avatar-company-input\" accept=\".jpg,.png,.jpeg\" class=\"hidden\"></div><div flex \nlayout=\"column\" class=\"pl-15\"><div flex=\"100\" layout=\"row\" class=\"h-70\"><md-input-container flex=\"50\" md-no-float>\n<label translate=\"CONFIGURATIONS.ACCOUNT.COMPANY_NAME.LABEL\">Company name</label><input data-cy=\"company-name-input\" \nname=\"companyName\" ng-model=\"vm.account.name\" placeholder=\"Company name\" translate \ntranslate-attr-placeholder=\"CONFIGURATIONS.ACCOUNT.COMPANY_NAME.PLACEHOLDER\" required><div \nng-messages=\"companyForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CONFIGURATIONS.ACCOUNT.COMPANY_NAME.REQUIRED\">Company name is required</span></div></div>\n</md-input-container><md-input-container flex=\"50\" md-no-float><label translate=\"CONFIGURATIONS.ACCOUNT.NAME.LABEL\">\nOwner\'s name</label><input data-cy=\"owner-name-input\" name=\"username\" ng-model=\"vm.account.contact.name\" \nplaceholder=\"Name\" translate translate-attr-placeholder=\"CONFIGURATIONS.ACCOUNT.NAME.PLACEHOLDER\" required><div \nng-messages=\"companyForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CONFIGURATIONS.ACCOUNT.NAME.REQUIRED\">Name is required</span></div></div></md-input-container></div><div \nflex=\"100\" layout=\"row\" class=\"h-70\"><md-input-container flex=\"50\"><label \ntranslate=\"CONFIGURATIONS.ACCOUNT.EMAIL.LABEL\">E-mail</label><input data-cy=\"email-input\" name=\"email\" \nng-model=\"vm.account.contact.email\" placeholder=\"E-mail\" translate \ntranslate-attr-placeholder=\"CONFIGURATIONS.ACCOUNT.EMAIL.PLACEHOLDER\" email-validation required><div \nng-messages=\"companyForm.email.$error\" ng-show=\"companyForm.email.$touched\" role=\"alert\" multitple><div \nng-message=\"required\"><span translate=\"CONFIGURATIONS.ACCOUNT.EMAIL.REQUIRED\">E-mail field is required</span></div><div\n ng-message=\"pattern\"><span translate=\"CONFIGURATIONS.ACCOUNT.EMAIL.PATTERN\">Must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container flex=\"10\"><label \ntranslate=\"CONFIGURATIONS.ACCOUNT.COUNTRY_CODE.LABEL\">Country Code</label><md-select \nng-model=\"vm.account.contact.phoneCountryCode\" placeholder=\"Select a country\" translate \ntranslate-attr-placeholder=\"CONFIGURATIONS.ACCOUNT.COUNTRY_CODE.PLACEHOLDER\"><md-option \nng-value=\"countryCode.countryCode\" ng-repeat=\"countryCode in vm.countryCodes\">+{{ ::countryCode.countryCode }}\n</md-option></md-select><div ng-messages=\"companyForm.phoneNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"CONFIGURATIONS.ACCOUNT.COUNTRY_CODE.REQUIRED\">Country code number is required</span></div></div>\n</md-input-container><md-input-container flex=\"40\"><label translate=\"CONFIGURATIONS.ACCOUNT.PHONE_NUMBER.LABEL\">\nPhone number</label><input data-cy=\"phone-number-input\" name=\"phoneNumber\" ng-model=\"vm.account.contact.phone\" \nplaceholder=\"Phone Number\" translate translate-attr-placeholder=\"CONFIGURATIONS.ACCOUNT.PHONE_NUMBER.PLACEHOLDER\" \nui-br-phone-number required><div ng-messages=\"companyForm.phoneNumber.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"CONFIGURATIONS.ACCOUNT.PHONE_NUMBER.REQUIRED\">Phone number is required</span></div></div>\n</md-input-container></div><div flex=\"100\" layout=\"row\" class=\"h-70\"><md-input-container flex><label \ntranslate=\"CONFIGURATIONS.ACCOUNT.WEB_SITE.LABEL\">Web site</label><input data-cy=\"web-site-input\" name=\"webSite\" \nng-model=\"vm.account.contact.webSite\" type=\"url\" placeholder=\"http://www.website.com\" translate \ntranslate-attr-placeholder=\"CONFIGURATIONS.ACCOUNT.WEB_SITE.PLACEHOLDER\"><div ng-messages=\"companyForm.webSite.$error\" \nrole=\"alert\"><div ng-message=\"url\"><span translate=\"CONFIGURATIONS.ACCOUNT.WEB_SITE.INVALID\">\nWeb site must be a valid url<br>(valid example: http://www.fieldcontrol.com.br)</span></div></div></md-input-container>\n<md-input-container flex=\"20\"><label translate=\"CONFIGURATIONS.ACCOUNT.COUNTRY.LABEL\">Country</label><md-select \nname=\"country\" ng-model=\"vm.account.address.countryCode\" placeholder=\"Select a country\" translate \ntranslate-attr-placeholder=\"CONFIGURATIONS.ACCOUNT.COUNTRY.PLACEHOLDER\" \nng-change=\"vm.handleTimezoneCountryFlagsAndAddress()\" required><md-option ng-value=\"country.code\" \nng-repeat=\"country in vm.countries\">{{ ::country.name }}</md-option></md-select></md-input-container>\n<md-input-container flex=\"30\"><label translate=\"CONFIGURATIONS.ACCOUNT.TIMEZONE.LABEL\">Time zone</label><md-select \ndata-cy=\"timezone-select\" name=\"timezone\" ng-model=\"vm.account.timezone\" placeholder=\"Select a time zone\" translate \ntranslate-attr-placeholder=\"CONFIGURATIONS.ACCOUNT.TIMEZONE.PLACEHOLDER\"><md-option ng-value=\"timezone.id\" \nng-repeat=\"timezone in vm.timezones\">{{ timezone.name }}</md-option></md-select></md-input-container>\n<md-input-container flex=\"10\"><label ng-show=\"vm.activitiesFilters.services.length == 0\">\n{{ \'CONFIGURATIONS.ACCOUNT.CURRENCY.LABEL\' | translate }}</label><md-select ng-model=\"vm.currencyCode\" \nng-model-options=\"{debounce: 100}\" md-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\"><md-select-header \nclass=\"select-header\"><input ng-model=\"vm.searchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'CONFIGURATIONS.ACCOUNT.CURRENCY.PLACEHOLDER\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"currency.code\" \nng-repeat=\"currency in vm.currencies | filter:vm.searchTerm | orderBy: \'name\'\" ng-click=\"vm.openAlertModal($event)\">\n{{ currency.symbol }}</md-option></md-optgroup></md-select></md-input-container></div></div></div><div \nng-if=\"!vm.isSelectedCountryBrasil\" class=\"autocomplete-address\" flex layout=\"row\"><div ng-if=\"!vm.hasAccountAddress\" \nflex><md-autocomplete flex ng-required=\"!vm.isSelectedCountryBrasil\" \nng-blur=\"vm.addressService.validateAddress(vm.formErr);\" md-input-id=\"auto-complete-address\" \nmd-input-name=\"auto-complete-address\" md-input-minlength=\"2\" md-input-maxlength=\"150\" md-no-cache=\"false\" \nmd-selected-item-change=\"vm.addressChanged()\" md-selected-item=\"vm.selectedAccountAddress\" \nmd-search-text=\"vm.selectedAccountAddressText\" \nmd-items=\"item in vm.addressService.searchAddress(vm.selectedAccountAddressText, { global: true })\" \nmd-autoselect=\"true\" md-delay=\"1500\" md-item-text=\"item.formattedAddress\" \nmd-floating-label=\"{{\'CONFIGURATIONS.ACCOUNT.ADDRESS.LABEL\' | translate}}\" \nmd-menu-class=\"autocomplete-custom-template\"><md-item-template><span class=\"item-title\"><md-icon class=\"s18\" \nmd-font-icon=\"icon-map-marker\"></md-icon><span>{{ item.formattedAddress }}</span></span></md-item-template>\n<md-not-found><span class=\"item-title\"><md-icon class=\"s18\" md-font-icon=\"icon-map-marker-off\"></md-icon><span \ntranslate=\"CONFIGURATIONS.ACCOUNT.ADDRESS.NOT_FOUND\">Address can\'t be found, change your search and try again.</span>\n</span></md-not-found><div \nng-if=\"!vm.formErr[\'accountAddressIsRequired\'] && !accountForm[\'auto-complete-address\'].$error\" class=\"hint\"><span \ntranslate=\"CONFIGURATIONS.ACCOUNT.ADDRESS.SEARCH_EXAMPLE\">Search an address, e.g.: 3501 S La Cienega Blvd, Los Angeles\n</span></div><div ng-if=\"vm.formErr[\'accountAddressIsRequired\'] && vm.selectedAccountAddressText.length\" class=\"hint\">\n<span ng-bind-html=\"vm.formErr[\'accountAddressIsRequired\']\"></span></div><div \nng-if=\"accountForm[\'auto-complete-address\'].$touched\" ng-messages=\"accountForm[\'auto-complete-address\'].$error\"><div \nng-message=\"required\"><span translate=\"CONFIGURATIONS.ACCOUNT.ADDRESS.REQUIRED\">Address field is required</span></div>\n</div></md-autocomplete></div><div ng-if=\"vm.hasAccountAddress\" flex><md-input-container class=\"md-block\"><label \ntranslate=\"CONFIGURATIONS.ACCOUNT.ADDRESS.LABEL\">Account Address</label><input name=\"formattedAddress\" \nng-model=\"vm.account.address.formattedAddress\" id=\"formattedAddress\" disabled=\"disabled\"><div \nng-if=\"!vm.form.account.address.number\" class=\"hint\"><md-icon md-font-icon=\"icon-alert\" class=\"red-fg fs-16\"></md-icon>\n<span class=\"ml-7n\" translate=\"CONFIGURATIONS.ACCOUNT.ADDRESS.NUMBER_NOT_SPECIFIED\">Number address not specified.\n</span></div></md-input-container></div><div ng-if=\"vm.hasAccountAddress\" flex=\"5\"><md-button \nid=\"clear-account-address\" class=\"md-icon-button md-accent md-block clear-address\" \naria-label=\"{{\'CONFIGURATIONS.ACCOUNT.ADDRESS.CLEAR\' | translate}}\" ng-click=\"vm.clearSelectedAccountAddress($event);\">\n<md-icon md-font-icon=\"icon icon-close-circle-outline\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CONFIGURATIONS.ACCOUNT.ADDRESS.CLEAR\">Clear address</span></md-tooltip></md-button></div></div><div \nng-if=\"vm.isSelectedCountryBrasil\" flex layout=\"row\"><md-input-container flex=\"15\"><label \ntranslate=\"CONFIGURATIONS.ACCOUNT.ZIPCODE.LABEL\">Zip Code</label><input data-cy=\"zip-code-input\" name=\"zipCode\" \nng-model=\"vm.account.address.zipCode\" id=\"zipCode\" ui-mask=\"99999-999\" ng-blur=\"vm.cepDb();\" ng-change=\"vm.cepDb();\" \nng-model-options=\"{debounce: 300}\" required><div ng-messages=\"companyForm.zipCode.$error\" \nng-show=\"companyForm.zipCode.$touched\" role=\"alert\"><div ng-message=\"required, mask\"><span \ntranslate=\"CONFIGURATIONS.ACCOUNT.ZIPCODE.REQUIRED\">Zip code field is required</span></div></div></md-input-container>\n<md-input-container flex=\"15\"><label translate=\"CONFIGURATIONS.ACCOUNT.CITY.LABEL\">City</label><input \ndata-cy=\"city-input\" name=\"city\" ng-model=\"vm.account.address.city\" required><div \nng-messages=\"companyForm.city.$error\" ng-show=\"companyForm.city.$touched\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"CONFIGURATIONS.ACCOUNT.CITY.REQUIRED\">City field is required</span></div></div></md-input-container>\n<md-input-container flex=\"15\"><label translate=\"CONFIGURATIONS.ACCOUNT.STATE.LABEL\">State</label><input \ndata-cy=\"state-input\" name=\"state\" ng-model=\"vm.account.address.state\" required><div \nng-messages=\"companyForm.state.$error\" ng-show=\"companyForm.state.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"CONFIGURATIONS.ACCOUNT.STATE.REQUIRED\">State field is required</span></div></div></md-input-container>\n<md-input-container flex=\"25\"><label translate=\"CONFIGURATIONS.ACCOUNT.STREET.LABEL\">Street</label><input \ndata-cy=\"street-input\" name=\"street\" ng-model=\"vm.account.address.street\" required><div \nng-messages=\"companyForm.street.$error\" ng-show=\"companyForm.street.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"CONFIGURATIONS.ACCOUNT.STREET.REQUIRED\">Street field is required</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"CONFIGURATIONS.ACCOUNT.NUMBER.LABEL\">Number</label>\n<input data-cy=\"number-input\" name=\"number\" ng-model=\"vm.account.address.number\" id=\"number\" \nng-blur=\"vm.geoCoderAddress();\" ng-keyup=\"vm.geoCoderAddress();\" ng-maxlength=\"20\" required><div \nng-messages=\"companyForm.number.$error\" ng-show=\"companyForm.number.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"CONFIGURATIONS.ACCOUNT.NUMBER.REQUIRED\">Number field is required</span></div></div>\n</md-input-container><div ng-if=\"vm.geocodingAddress === true\" class=\"geocoder-progress-container\" flex>\n<md-progress-circular id=\"geocoder-progress\" class=\"md-accent mt-10 mleft-10\" md-mode=\"indeterminate\" md-diameter=\"24\">\n</md-progress-circular></div><md-input-container flex><label translate=\"CONFIGURATIONS.ACCOUNT.COMPLEMENT.LABEL\">\nComplement</label><input data-cy=\"complement-input\" name=\"complement\" ng-model=\"vm.account.address.complement\" \nid=\"complement\" ng-maxlength=\"255\"></md-input-container><div layout=\"row\"><div \nng-if=\"vm.geocodingAddress == false || vm.account.address.coords.latitude && vm.account.address.coords.longitude\" flex>\n<a href=\"https://maps.google.com/?q={{vm.account.address.coords.latitude}},{{vm.account.address.coords.longitude}}\" \ntarget=\"_blank\" class=\"no-text-decoration\" aria-label=\"{{\'CONFIGURATIONS.ACCOUNT.PLACE.ARIA_LABEL\' | translate}}\">\n<md-tooltip md-direction=\"bottom\" md-delay=\"1\"><span translate=\"CONFIGURATIONS.ACCOUNT.PLACE.LATITUDE_LONGITUDE\" \ntranslate-values=\"{latitude:vm.account.address.coords.latitude,longitude:vm.account.address.coords.longitude}\">\nlatitude: {{vm.account.address.coords.latitude}}, longitude: {{vm.account.address.coords.longitude}}</span>\n</md-tooltip><i style=\"color: rgb(33,150,243)\" class=\"icon icon-map-marker s40\"></i></a></div></div></div><md-button \ndata-cy=\"save-account-button\" type=\"submit\" class=\"fc-button fc-button--actions save-fixed-button\" \naria-label=\"Save Configurations\" translate=\"CONFIGURATIONS.BUTTON_SAVE\" \ntranslate-attr-aria-label=\"CONFIGURATIONS.BUTTON_SAVE\" \nng-disabled=\"companyForm.$invalid || vm.isSearching || companyForm.$pristine || vm.disableSaveButton\" \nng-click=\"vm.saveAccount();\">Save Configurations</md-button></form>");
$templateCache.put("app/main/settings/contents/integrations/integrations.html","<div layout=\"row\" layout-wrap ms-scroll><fc-card icon=\"conta-azul\" title=\"{{ \'APPS.CONTA_AZUL.TITLE\' | translate }}\" \ndescription=\"{{ \'APPS.CONTA_AZUL.DESCRIPTION\' | translate }}\" configuration=\"vm.integrations[\'conta-azul\']\" \nopen-function=\"vm.manageContaAzul($event)\"></fc-card><fc-card icon=\"omie\" title=\"{{ \'APPS.OMIE.TITLE\' | translate }}\" \ndescription=\"{{ \'APPS.OMIE.DESCRIPTION\' | translate }}\" configuration=\"vm.integrations[\'omie\']\" \nopen-function=\"vm.manageOmie($event);\"></fc-card></div>");
$templateCache.put("app/main/settings/contents/labels-manager/labels-manager.html","<div id=\"default-list\" class=\"page-layout simple fullwidth header-default labels-manager\" layout=\"row\"><div \nclass=\"center\" layout=\"column\" flex><div class=\"content fullpage-datatable padding-0\" layout=\"column\" flex><table \nid=\"table-list\" datatable=\"\" class=\"dataTable row-border hover datatable-labels-manager\" \ndt-instance=\"vm.dtInstanceCallback\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><tbody></tbody></table></div>\n</div></div>");
$templateCache.put("app/main/settings/dialogs/labels/label-dialog.html","<md-dialog class=\"dev-dialog w-480\"><md-toolbar class=\"md-accent draggable-toolbar\"><div class=\"md-toolbar-tools\"><span\n flex class=\"title\"><span translate=\"CONFIGURATIONS.DIALOGS.LABELS.DELETE.TITLE\">Delete Label</span></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"CONFIGURATIONS.DIALOGS.LABELS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><form name=\"labelForm\" class=\"md-inline-form\" novalidate>\n<p><span translate=\"CONFIGURATIONS.DIALOGS.LABELS.DELETE.MESSAGE\">The label won\'t be available after delete.<br>\nTo proceed, type: </span><b>{{ vm.label.name }}</b></p><md-input-container class=\"md-block mt-30\"><label \ntranslate=\"CONFIGURATIONS.DIALOGS.LABELS.PLACEHOLDER\">Label</label><input data-cy=\"name-input\" name=\"name\" \nng-model=\"vm.confirmInput\" ng-maxlength=\"50\"></md-input-container></form></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><md-button data-cy=\"better-not-button\" md-no-ink class=\"md-primary\" \nng-click=\"vm.closeDialog()\" translate=\"CONFIGURATIONS.DIALOGS.LABELS.BETTER_NOT\">Better not</md-button><md-button \ndata-cy=\"confirm-button\" class=\"md-primary md-accent md-raised\" ng-disabled=\"vm.confirmInput !== vm.label.name\" \nng-click=\"vm.deleteLabel();\" translate=\"CONFIGURATIONS.DIALOGS.LABELS.CONFIRM\">Confirm</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/subscription/sidenavs/due-date/due-date.html","<md-sidenav ms-sidenav-helper id=\"due-date-sidenav\" md-component-id=\"due-date-sidenav\" \nclass=\"filters-sidenav md-sidenav-right module-sidenav plan-sidenav\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.TITLE\">\nManage emails</span></div></md-toolbar><md-content class=\"animate-slide-right p-0 overflow-hidden\" layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"plan-sidenav__description\" ms-scroll=\"{ suppressScrollX: true }\"><div \nclass=\"plan-sidenav__description__title\"><span translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.DESCRIPTION\">\nManage the emails that will receive alerts about your subscriptions</span></div><div class=\"chart mb-16 mt-32\"><div \nclass=\"bar-chart\"><div ng-style=\"{ width: vm.updateChart() + \'%\' }\" \nng-class=\"{ \'warning\': vm.updateChart() >= 60, \'danger\': vm.updateChart() >= 80 }\"></div></div><div class=\"text-right\">\n<span><strong>{{ vm.subscription.emails.length }}</strong> de <strong>{{ vm.max }}</strong> e-mails</span></div></div>\n<div class=\"plan-sidenav__description__content\"><form name=\"dueDateForm\" layout=\"column\" novalidate><div layout=\"row\">\n<div flex=\"90\"><md-input-container class=\"md-block\"><label translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.ADD_EMAIL\">\nAdd email</label><input name=\"email\" ng-model=\"vm.email\" ng-disabled=\"vm.renewal\" \nng-change=\"vm.validateForm(dueDateForm)\" ng-keydown=\"vm.handleKeyDown($event, dueDateForm)\" \nng-model-options=\"{ debounce: vm.formDebounceTime }\" email-validation><div ng-messages=\"dueDateForm.email.$error\" \nng-if=\"dueDateForm.email.$touched\" role=\"alert\"><div ng-message=\"pattern\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.INVALID_EMAIL\">Invalid email</span></div><div ng-message=\"duplicated\">\n<span translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.DUPLICATED\">Email already added</span></div><div \nng-message=\"item\"><span translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.ITEM_INVALID_EMAIL\">Editing item is invalid\n</span></div><div ng-message=\"maxItems\"><span translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.MAX_LIMIT\">\nMaximum limit reached</span></div></div></md-input-container></div><div layout=\"column\" layout-align=\"start end\" \nflex=\"10\"><md-button class=\"fc-icon-button t-24\" ng-click=\"vm.addEmail(dueDateForm);\" \nng-disabled=\"vm.renewal || !vm.email\"><md-icon class=\"md-accent\" md-font-icon=\"icon-plus-circle\"></md-icon><md-tooltip>\n<span translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.ADD_EMAIL\">Add email</span></md-tooltip></md-button></div></div>\n<div class=\"emails-container\"><div layout=\"row\" class=\"emails-container__item\" layout-align=\"space-between start\" \nng-if=\"vm.subscription.emails.length > 0\" ng-init=\"isEditing = false; confirmDelete = false\" \nng-repeat=\"email in vm.subscription.emails track by $index\"><div layout=\"row\"><div ng-if=\"!isEditing\" \nclass=\"emails-container__item__address\">{{ email.address }}</div><md-input-container ng-if=\"isEditing\" \nclass=\"emails-container__item__input-container\"><input name=\"email_item_list_{{ $index }}\" \nng-model=\"vm.subscription.emails[$index].address\" email-validation required><div \nng-messages=\"dueDateForm[\'email_item_list_\' + $index].$error\" \nng-if=\"dueDateForm[\'email_item_list_\' + $index].$touched\" role=\"alert\"><div ng-message=\"pattern\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.INVALID_EMAIL\">Invalid email</span></div><div ng-message=\"required\">\n<span translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.REQUIRED\">Email required</span></div></div></md-input-container>\n<div class=\"emails-container__item__type\" ng-class=\"{ \'pl-8 pt-8\': !isEditing }\"><span \nng-if=\"vm.subscription.emails[$index].primary\" translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.PRIMARY\">Primary</span>\n</div></div><div layout=\"row\" layout-align=\"end center\" ng-init=\"isExpanded = false\" \nclass=\"emails-container__item__options\" ng-mouseleave=\"isExpanded = (locked || isEditing)\" flex><div layout=\"row\" \nclass=\"emails-container__item__options--view\" ng-class=\"(isExpanded && !isEditing) ? \'expand\' : \'shrink\'\"><md-icon \nclass=\"fc-icon fc-pink mr-8\" md-svg-src=\"assets/icons/icon-email-remove.svg\" \nng-show=\"vm.subscription.emails.length > 1\" ng-click=\"confirmDelete = true; isExpanded = false;\"><md-tooltip><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.REMOVE_EMAIL\">Remove e-mail</span></md-tooltip></md-icon><md-icon \nclass=\"fc-icon fc-blue mr-8\" ng-click=\"isEditing = true\" md-font-icon=\"icon-pencil\"><md-tooltip><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.UPDATE_EMAIL\">Update</span></md-tooltip></md-icon><md-icon \nclass=\"fc-icon fc-yellow\" ng-if=\"email.primary\" md-font-icon=\"icon-star\"><md-tooltip><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.MAIN_EMAIL\">Main e-mail</span></md-tooltip></md-icon><md-icon \nclass=\"fc-icon fc-yellow\" ng-if=\"!email.primary\" ng-click=\"vm.setPrimaryEmail(dueDateForm, email)\" \nmd-font-icon=\"icon-star-outline\"><md-tooltip><span translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.SET_MAIN_EMAIL\">\nSet as main e-mail</span></md-tooltip></md-icon></div><div class=\"emails-container__item__options--edit\" \nng-class=\"(isExpanded && isEditing) ? \'expand\' : \'shrink\'\"><md-button md-no-ink ng-click=\"isEditing = false\" \nclass=\"fc-button black-500-fg\" ng-disabled=\"dueDateForm[\'email_item_list_\' + $index].$invalid\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.SAVE\">Save</span></md-button></div><md-icon class=\"fc-icon\" \nng-class=\"{ \'fc-blue\': !isExpanded }\" ng-click=\"locked = !vm.renewal ? !locked : locked\" \nng-mouseenter=\"isExpanded = !vm.renewal\" md-font-icon=\"icon-dots-horizontal\"></md-icon></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"emails-container__item__confirm-delete\" \nng-class=\"confirmDelete ? \'expand\' : \'shrink\'\"><span translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.CONFIRM_DELETE\">\nAre you sure you want to delete?</span><div layout=\"row\"><md-button md-no-ink class=\"fc-button fc-blue\" \nng-click=\"confirmDelete = false; vm.removeEmail(dueDateForm, $index)\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.YES\">Sim</span></md-button><md-button md-no-ink \nclass=\"fc-button fc-pink\" ng-click=\"confirmDelete = false\"><span translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.NO\">Não\n</span></md-button></div></div></div></div></form><div class=\"text-center\" ng-if=\"vm.subscription.emails.length < 1\">\n<span translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.EMPTY\">You do not have any registered email.</span></div><span \nclass=\"text-justify\" translate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.FOOTER_DESCRIPTION\">\nThe registered emails will receive updates on the expiration and renewal of the plan.</span></div></div><div \nclass=\"plan-sidenav__button-container\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-accent fc-button mr-8\" ng-click=\"vm.updateEmails()\" \nng-disabled=\"vm.renewal || dueDateForm.$pristine || dueDateForm.$invalid || $root.loadingProgress\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.MANAGE_EMAILS.SAVE\">Save</md-button></div></md-content></md-sidenav>");
$templateCache.put("app/main/subscription/sidenavs/employees-upgrade/employees-upgrade.html","<md-sidenav id=\"employees-upgrade\" md-component-id=\"employees-upgrade-sidenav\" ms-sidenav-helper \nclass=\"filters-sidenav md-sidenav-right module-sidenav plan-sidenav {{ vm.showModuleSettings && \'expand\' }}\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.EMPLOYEES.TITLE\">Renewal</span></div></md-toolbar><md-content \nclass=\"animate-slide-right p-0\" layout=\"column\" layout-align=\"space-between start\" ms-scroll><form \nname=\"employeesUpgradeForm\" class=\"plan-sidenav__description\"><div class=\"plan-sidenav__description__title mb-16\"><span\n translate=\"SUBSCRIPTION.SIDENAVS.EMPLOYEES.QUESTION\">Do you want to change your invoice\'s due date?</span></div><div \nclass=\"plan-sidenav__description__content\"><div class=\"mb-24\"><span class=\"mr-5\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.EMPLOYEES.CURRENT\">Hired licenses: </span><span class=\"current\" \ntranslate-value-number=\"{{ vm.currentLicensesQuantity }}\" translate=\"SUBSCRIPTION.SIDENAVS.EMPLOYEES.NUMBER\">\n{{ ::vm.currentLicensesQuantity }} licenses</span></div><div class=\"mb-16\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.EMPLOYEES.CHANGE_TO\">Change to:</span><md-input-container><input class=\"md-input\" \ntype=\"number\" name=\"increaseNumberInput\" ng-model=\"vm.increaseNumber\" \ntranslate-attr-aria-label=\"SUBSCRIPTION.SIDENAVS.EMPLOYEES.LICENSES_NUMBER\" aria-label=\"Licenses number\" max=\"100\" \nmin=\"1\"><div ng-messages=\"employeesUpgradeForm.increaseNumberInput.$error\" \nng-show=\"employeesUpgradeForm.increaseNumberInput.$touched\" role=\"alert\"><div ng-message=\"max\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.EMPLOYEES.MAX\">Maximum value exceeded</span></div><div ng-message=\"min\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.EMPLOYEES.INVALID\">Invalid value</span></div></div></md-input-container></div><span \nclass=\"text-justify\" translate=\"SUBSCRIPTION.SIDENAVS.EMPLOYEES.DESCRIPTION\">By clicking on <b>Request change</b>\n, our finance team will review the request and may contact you to make changing the maturity of your future invoices.\n</span></div></form><div class=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-accent plan-button\" ng-click=\"vm.requestUpgrade()\" \nng-disabled=\"employeesUpgradeForm.$invalid || $root.loadingProgress\" translate=\"SUBSCRIPTION.REQUEST_CHANGE\">\nRequest change</md-button></div></md-content></md-sidenav>");
$templateCache.put("app/main/subscription/sidenavs/renewal/renewal.html","<md-sidenav id=\"renewal\" md-component-id=\"renewal-sidenav\" ms-sidenav-helper \nclass=\"filters-sidenav md-sidenav-right plan-sidenav {{ vm.showModuleSettings && \'expand\' }}\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.TITLE\">Subscription renewal</span></div></md-toolbar><md-content \nclass=\"animate-slide-right p-0\" layout=\"column\" layout-align=\"space-between start\" ms-scroll><div \nclass=\"plan-sidenav__description\" ng-if=\"!vm.invoice\"><div class=\"plan-sidenav__description__title mb-24\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.QUESTION\">Do you want to renew your subscription?</span></div><div \nclass=\"plan-sidenav__description__content\"><div class=\"fw-500 mb-24\" layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.NEXT_DUE_DATE\">Next due date: </span><span class=\"blue\">\n{{ ::vm.subscription.renewAt }}</span></div><md-divider></md-divider><div layout=\"column\"><div class=\"fw-500 mb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><span translate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.TITLE\">Your plan:\n</span><div class=\"blue\"><span ng-if=\"vm.subscription.type === \'yearly\'\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.TYPE.YEARLY\">Yearly </span><span \nng-if=\"vm.subscription.type === \'biennial\'\" translate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.TYPE.BIENNIAL\">Biennial \n</span><span ng-if=\"vm.subscription.type === \'triennial\'\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.TYPE.TRIENNIAL\">Trienal </span><span \nng-if=\"vm.subscription.type === \'quadriennial\'\" translate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.TYPE.QUADRIENNIAL\">\nQuadrienal </span><span ng-if=\"vm.subscription.type === \'quinquennial\'\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.TYPE.QUINQUENNIAL\">Quinquenal</span></div></div><div class=\"mb-8\" \nng-if=\"vm.features.technicianApp.quantity\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.FEATURE.EMPLOYEE_APP\" \ntranslate-value-number=\"{{ vm.features.technicianApp.quantity }}\">\n{{ ::vm.features.technicianApp.quantity }} employees licenses </span><span class=\"fw-500\">\n{{ vm.numberToCurrency(vm.features.technicianApp.totalValue) }}</span></div><div class=\"mb-8\" \nng-if=\"vm.features.managerApp.quantity\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.FEATURE.MANAGER_APP\">Manager panel </span><span class=\"fw-500\">\n{{ vm.numberToCurrency(vm.features.managerApp.totalValue) }}</span></div><div class=\"mb-8\" \nng-if=\"vm.features.equipmentsModule.quantity\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.FEATURE.EQUIPMENTS_MODULE\">Equipments module </span><span class=\"fw-500\">\n{{ vm.numberToCurrency(vm.features.equipmentsModule.totalValue) }}</span></div><div class=\"mb-8\" \nng-if=\"vm.features.video.quantity\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.FEATURE.VIDEOS_MODULE\">Videos module </span><span class=\"fw-500\">\n{{ vm.numberToCurrency(vm.features.video.totalValue) }}</span></div><div class=\"fx mb-8\" \nng-if=\"vm.features.highResolutionImages.quantity\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.FEATURE.HIGH_RESOLUTION_IMAGES\">High resolution images </span><span \nclass=\"fw-500\">{{ vm.numberToCurrency(vm.features.highResolutionImages.totalValue) }}</span></div><div class=\"fx mb-8\" \nng-if=\"vm.features.routeOptimization.quantity\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.FEATURE.ROUTER\">Router </span><span class=\"fw-500\">\n{{ vm.numberToCurrency(vm.features.routeOptimization.totalValue) }}</span></div><div class=\"mb-8\" \nng-if=\"vm.features.storage.quantity\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.FEATURE.STORAGE\">Storage </span><span class=\"fw-500\">\n{{ vm.numberToCurrency(vm.features.storage.totalValue) }}</span></div><div class=\"mb-8\" \nng-if=\"vm.features.customerArea.quantity\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.FEATURE.CUSTOMER_AREA\">Customer Area </span><span class=\"fw-500\">\n{{ vm.numberToCurrency(vm.features.customerArea.totalValue) }}</span></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-align=\"space-between center\"><div><span class=\"fw-500\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.PAYMENT_METHODS\">Payment methods</span></div><div layout=\"column\"><div \nlayout=\"row\" layout-align=\"end start\"><div class=\"fs-10 mr-5 grey self-align-end\">12x</div><span \nclass=\"fw-500 green-teal\">{{ vm.numberToCurrency(vm.features.installmentValue) }}</span></div><span \nclass=\"fs-10 text-right grey\">no cartão de crédito<br>\nou {{ vm.numberToCurrency(vm.features.totalValue) }} à vista no boleto</span></div></div><md-divider></md-divider><div \nclass=\"fx mb-24\" layout=\"column\" layout-align=\"center start\"><div class=\"fx\"><md-checkbox md-no-ink class=\"md-primary\" \nng-model=\"vm.subscription.termsChecked\"></md-checkbox><span translate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.TERMS.TEXT\">\nI accept the </span><a \nhref=\"https://fieldcontrol.com.br/termos-condicoes.html?utm_source=painel-do-gestor&utm_medium=link&utm_campaign=renewal\" \ntarget=\"_blank\"><span translate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.PLAN.TERMS.LINK\">Terms and Use Conditions </span></a>.\n</div></div><span class=\"text-justify\" translate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.DESCRIPTION\">When you click <b>\nRenew subscription</b>\n, you will be redirected to a payment page to complete your renewal which will be analyzed until payment is confirmed.\n</span></div></div><div class=\"plan-sidenav__description plan-sidenav__description--expanded\" ng-if=\"vm.invoice\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"mb-24\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" \nheight=\"64\" viewBox=\"0 0 64 64\"><path fill=\"none\" d=\"M0 0h64v64H0z\"/><path fill=\"#0957c3\" \nd=\"M39.774 2H6v15.923h.028L6 17.949l11.258 10.589L6 39.153l.028.027H6v15.9h33.774v-15.9h-.028l.028-.027-11.258-10.615 11.258-10.589-.028-.027h.028zm-5.629 38.48v9.288H11.629V40.48l11.258-10.615zm0-23.884L22.887 27.211 11.629 16.6V7.308h22.516z\" \ntransform=\"translate(9.113 3.462)\"/></svg></div><div class=\"text-center\" layout=\"column\" layout-align=\"center center\">\n<div class=\"mb-16 f16 fw-500 w-50-percent\"><span translate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.SUCCESS\">\nYour renewal order has been successfully placed!</span></div><div class=\"mb-16\"><span \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.UNDER_REVIEW\">\nYour renewal is under review as soon as confirmed payment, your subscription will be renewed.</span></div><md-button \nclass=\"md-raised md-accent fc-button\" ng-click=\"vm.openInvoice()\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.VIEW_INVOICE\">View invoice</md-button></div></div><div \nclass=\"plan-sidenav__button-container\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-accent fc-button\" ng-if=\"!vm.invoice\" \nng-disabled=\"!vm.subscription.termsChecked || $root.loadingProgress\" ng-click=\"vm.renewSubscription()\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.RENEW_SUBSCRIPTION\">Renew subscription</md-button><md-button \nclass=\"md-raised md-accent fc-button\" ng-if=\"vm.invoice\" ng-click=\"vm.close()\" \ntranslate=\"SUBSCRIPTION.SIDENAVS.RENEWAL.OK\">Ok</md-button></div></md-content></md-sidenav>");
$templateCache.put("app/main/subscription/sidenavs/storage-upgrade/storage-upgrade.html","<md-sidenav md-component-id=\"storage-upgrade-sidenav\" ms-sidenav-helper \nclass=\"filters-sidenav md-sidenav-right module-sidenav plan-sidenav {{ vm.showModuleSettings && \'expand\' }}\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"SUBSCRIPTION.STORAGE_UPGRADE.TITLE\">Storage</span></div></md-toolbar><md-content \nclass=\"animate-slide-right p-0\" layout=\"column\" layout-align=\"space-between start\" ms-scroll><form name=\"dueDateForm\" \nclass=\"plan-sidenav__description\"><div class=\"plan-sidenav__description__title mb-16\"><span \ntranslate=\"SUBSCRIPTION.STORAGE_UPGRADE.QUESTION\">Do you want to change your invoice\'s due date?</span></div><div \nclass=\"plan-sidenav__description__content\"><div class=\"mb-24\"><span translate=\"SUBSCRIPTION.STORAGE_UPGRADE.CURRENT\">\nCurrent due date: </span><span class=\"current\">{{ ::vm.currentDueDate }}</span></div><div class=\"mb-16\"><span \ntranslate=\"SUBSCRIPTION.STORAGE_UPGRADE.CHANGE_TO\">Change to:</span></div><div class=\"mb-32\"><md-datepicker \nclass=\"icon-hide\" ng-model=\"vm.requestDate\" md-min-date=\"vm.minRequestDate\" \nmd-placeholder=\"{{ \'SUBSCRIPTION.STORAGE_UPGRADE.SELECT_DATE\' | translate }}\" required></md-datepicker></div><span \nclass=\"text-justify\" translate=\"SUBSCRIPTION.STORAGE_UPGRADE.DESCRIPTION\">By clicking on <b>Request change</b>\n, our finance team will review the request and may contact you to make changing the maturity of your future invoices.\n</span></div></form><div class=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-accent plan-button\" ng-click=\"vm.requestChange()\" \nng-disabled=\"dueDateForm.$invalid || $root.loadingProgress\" translate=\"SUBSCRIPTION.REQUEST_CHANGE\">Request change\n</md-button></div></md-content></md-sidenav>");
$templateCache.put("app/main/tasks/dialogs/add-equipments-dialog/add-equipments-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large task-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.LINK\">Attach equipments</span></div><div \nclass=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content id=\"add-equipments\" ms-scroll><div layout=\"column\"><div \nclass=\"search-bar\" layout=\"row\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--search\" ng-model=\"vm.selectedEquipmentText\" ng-change=\"vm.searchEquipments()\" \ndata-cy=\"add-equipments-input\" ng-disabled=\"false\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.SEARCH.LABEL\">Search for an equipment</label></div><button \nclass=\"fc-input__button border brad-4\" ng-click=\"vm.searchEquipments()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</button></div><small class=\"search-bar__hint mt-5\" translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.SEARCH.HINT\">\nSearch by the equipment\'s model name or serial number.</small></div><div layout=\"column\" class=\"orders-equipments\"><div\n layout=\"row\" flex=\"100\" layout-align=\"space-between center\"><div layout=\"row\" flex=\"90\" layout-align=\"start center\">\n<h4 class=\"fs-16 fw-550 mb-12\" flex=\"20\"><span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.EQUIPMENTS\">Equipments</span>\n ({{ vm.currentlySelectedEquipments.length + vm.selectedEquipments.length }}/{{ vm.totalCount }})</h4><span \nclass=\"equipment-link-hint\" \nng-if=\"vm.currentlySelectedEquipments.length < vm.maxEquipmentPerTask && vm.selectedEquipments.length < vm.maxEquipmentPerTask && (vm.maxEquipmentPerTask - (vm.currentlySelectedEquipments.length + vm.selectedEquipments.length)) > 0\">\n{{ \'TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.YOU_CAN_STILL_SELECT\' | translate }} {{ vm.maxEquipmentPerTask - (vm.currentlySelectedEquipments.length + vm.selectedEquipments.length) }} {{ \'TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.EQUIPMENTS_TO_ORDER\' | translate }} \n</span><span class=\"equipment-link-hint\" \nng-if=\"vm.currentlySelectedEquipments.length >= vm.maxEquipmentPerTask || vm.selectedEquipments.length >= vm.maxEquipmentPerTask || (vm.maxEquipmentPerTask - (vm.currentlySelectedEquipments.length + vm.selectedEquipments.length)) <= 0\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.MAXIMUM_LIMIT_REACHED\">\nMaximum linked equipments limit per activity reached.</span></div><md-checkbox class=\"orders-equipments__select-all\" \nng-model=\"vm.allEquipmentsSelected\" ng-change=\"vm.selectAllEquipments()\"></md-checkbox></div><div layout-xs=\"column\" \nlayout=\"row\" flex=\"100\" data-cy=\"add-equipment-item\" ng-if=\"vm.totalCount\" \nclass=\"b brad-4 mb-10 orders-equipments__item\" layout-align=\"space-between center\" \nng-repeat=\"equip in vm.equipmentOptions track by $index\" \nng-class=\"!equip.selected && vm.currentlySelectedEquipments.length >= vm.maxEquipmentPerTask || equip.linked ? \'content-disabled\' : \'\'\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"h-60 w-60 brad-4 ml-20\" ng-if=\"equip.thumbnail\"><img \nngf-src=\"equip.thumbnail\" alt=\"{{ equip.name }}\" class=\"orders-equipments__image\"></div><div layout=\"row\" \nclass=\"border h-60 w-60 brad-4 ml-20\" layout-align=\"center center\" ng-if=\"!equip.thumbnail\"><svg width=\"18\" \nheight=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path \nd=\"M0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0H2C0.9 0 0 0.9 0 2ZM16 16H2V2H16V16ZM11.14 8.86L8.14 12.72L6 10.14L3 14H15L11.14 8.86Z\" \nfill=\"#D4DEF1\"/></svg></div><div flex=\"80\" layout=\"column\" class=\"ph-24\"><strong class=\"fs-14 mb-5\">{{ equip.name }}\n</strong> <span class=\"fs-14 pt-12\">{{ equip.number }}</span></div></div><div class=\"add-equipment ph-10 mt-10\" \nng-if=\"!equip.linked\"><md-checkbox ng-model=\"equip.selected\" aria-label=\"Link Equipment\" translate \nng-change=\"equip.selected ? vm.selectEquipment(equip) : vm.deselectEquipment(equip)\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.LINK\" \nng-disabled=\"!equip.selected && (vm.currentlySelectedEquipments.length + vm.selectedEquipments.length) >= vm.maxEquipmentPerTask && (vm.maxEquipmentPerTask - (vm.currentlySelectedEquipments.length + vm.selectedEquipments.length)) <= 0\">\n</md-checkbox></div><span class=\"orders-equipments__item--selected pr-10\" ng-if=\"equip.linked\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.SELECTED\">Equipment already linked</span></div></div><div \nclass=\"table-navigation\" layout=\"row\" layout-align=\"end center\"><div class=\"table-navigation__info\" \nid=\"table-list_info\" aria-live=\"polite\"><span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.SHOWING_FROM\">\nShowing from</span>\n {{ vm.equipmentOptions.length === 0 ? 0 : ((vm.equipmentsPage - 1) * vm.equipmentsPaginateBy) + 1 }} <span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.TO\">to</span> {{ vm.equipmentOptions.length }} <span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.OF\">of</span> {{ vm.totalCount }} <span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.RECORDS\">records</span></div><button \nclass=\"table-navigation__button\" aria-label=\"Previous\" ng-click=\"vm.navigateToPage(vm.equipmentsPage - 1)\" \nng-disabled=\"vm.equipmentsPage === 1\"><span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.PREVIOUS\">Previous\n</span></button> <button class=\"table-navigation__button\" aria-label=\"Next\" \nng-click=\"vm.navigateToPage(vm.equipmentsPage + 1)\" \nng-disabled=\"vm.equipmentsPage * vm.equipmentsPaginateBy >= vm.totalCount\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.NEXT\">Next</span></button></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><button type=\"submit\" \nid=\"dialog-update-task-button\" ng-click=\"vm.saveEquipments()\" \nng-disabled=\"vm.currentlySelectedEquipments.length > vm.maxEquipmentPerTask || vm.currentlySelectedEquipments.length < 1 || vm.selectedEquipments.length >= vm.maxEquipmentPerTask || (vm.maxEquipmentPerTask - (vm.currentlySelectedEquipments.length + vm.selectedEquipments.length)) < 0 || vm.disableButton\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.SAVE_EQUIPMENTS\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.TABS.EQUIPMENTS.LINKED_EQUIPMENTS.SAVE_EQUIPMENTS\" \nclass=\"fc-button fc-button--actions\" aria-label=\"Save\">Save equipments</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tasks/dialogs/confirm-delete-product-service-dialog/confirm-delete-product-service-dialog.html","<div class=\"confirm-delete-productService-dialog\"><span class=\"confirm-delete-productService-dialog__title\" \ntranslate=\"TASKS.DIALOG.TABS.{{vm.translationTag}}.CONFIRM_DELETE_DIALOG.TITLE\">Remove service </span><span \nclass=\"confirm-delete-productService-dialog__message\" \ntranslate=\"TASKS.DIALOG.TABS.{{vm.translationTag}}.CONFIRM_DELETE_DIALOG.MESSAGE\" \ntranslate-values=\"{ name: vm.productServiceName }\"></span><div class=\"confirm-delete-productService-dialog__buttons\">\n<button ng-click=\"vm.closeDialog(true)\" class=\"confirm-delete-productService-dialog__buttons__yes\" \ntranslate=\"TASKS.DIALOG.TABS.{{vm.translationTag}}.CONFIRM_DELETE_DIALOG.YES\">Yes</button> <button \nng-click=\"vm.closeDialog(false)\" class=\"confirm-delete-productService-dialog__buttons__no\" \ntranslate=\"TASKS.DIALOG.TABS.{{vm.translationTag}}.CONFIRM_DELETE_DIALOG.NO\">No</button></div></div>");
$templateCache.put("app/main/tasks/dialogs/create-or-edit-pendency-dialog/create-or-edit-pendency-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large task-dialog\">\n<create-or-edit-pendency-dialog-body-provider ng-attr-order=\"{{ self.order }}\" id=\"create-or-edit-pendency\">\n</create-or-edit-pendency-dialog-body-provider></md-dialog>");
$templateCache.put("app/main/tasks/dialogs/link-products-dialog/link-products-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large task-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\" \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.LINK_PRODUCTS\">Attach products</span></div><div class=\"sidebar-dialog__actions\">\n<md-button class=\"md-icon-button\" ng-click=\"self.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"link-products\" ms-scroll><div layout=\"column\" class=\"link-products__search-bar\">\n<div class=\"search-bar\" layout=\"row\" flex=\"100\"><div class=\"fc-input\" flex=\"100\"><input type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" ng-model=\"self.nameContains\" \nng-change=\"self.searchProducts()\" ng-model-options=\"{ debounce: 500 }\" ng-disabled=\"false\"><label \nclass=\"fc-input__label\" translate=\"TASKS.DIALOG.TABS.PRODUCTS.SEARCH_PRODUCT\">Search for an product</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div></div></div><ng-container \nng-if=\"self.isLoading === false && self.allProducts.length\"><div layout=\"column\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\" class=\"link-products__header\"><div><span class=\"link-products__header__title\" \nflex=\"20\"><span translate=\"TASKS.DIALOG.TABS.PRODUCTS.TITLE\">Products</span>\n ({{ self.currentlySelectedProducts.length + self.linkedProducts.length }}/{{ self.maxLinkedProducts }}) </span><span \nclass=\"link-products__header__select-message\"><span \nng-if=\"self.currentlySelectedProducts.length + self.linkedProducts.length < self.maxLinkedProducts\"><span \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.YOU_CAN_STILL_SELECT\" \ntranslate-values=\"{ selectedProducts: self.maxLinkedProducts - (self.currentlySelectedProducts.length + self.linkedProducts.length) }\">\nYou can still select </span></span><span \nng-if=\"self.currentlySelectedProducts.length + self.linkedProducts.length >= self.maxLinkedProducts\" \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.MAXIMUM_LIMIT_REACHED\">Maximum linked products limit per activity reached.</span>\n</span></div><md-checkbox ng-model=\"self.allProductsSelected\" ng-change=\"self.selectOrDeselectAllProducts()\">\n</md-checkbox></div><div ng-repeat=\"product in self.allProducts\" ng-if=\"self.totalCount\" class=\"link-products__item\">\n<div class=\"link-products__flex-row\"><div class=\"link-products__flex-column\"><div class=\"link-products__item__info\">\n<div class=\"link-products__item__info__image\" ng-if=\"product.imageUrl\"><img ng-src=\"{{ product.imageUrl | mumakil }}\" \nalt=\"{{ product.name }}\" class=\"link-products__image\"></div><div class=\"link-products__item__info__image\" \nng-if=\"!product.imageUrl\"><img class=\"link-products__item__info__image--default\" src=\"assets/icons/no-image_gray.svg\">\n</div><div class=\"link-products__item__info__add-product\"><span class=\"link-products__item__info__add-product__line\">\n<span title=\"{{product.name}}\" class=\"link-products__item__info__add-product__line__name\">\n{{ product.name | maxLength: 50 }}</span> <span class=\"link-products__item__info__add-product__line__measure\">\n({{ \'TASKS.DIALOG.TABS.PRODUCTS.MEASURE.\' + product.measure | translate }}) </span></span><span \nclass=\"link-products__item__info__add-product__value\">{{ product.value | currencyFormat }}</span></div></div><div \nclass=\"link-products__add-product\"><span ng-if=\"product.linked\" class=\"link-products__add-product__already-linked\">\n{{\'TASKS.DIALOG.TABS.PRODUCTS.ALREADY_LINKED\' | translate}}</span> <span \nclass=\"link-products__add-productlink-products__add-product__tooltip\" \nng-if=\"self.currentlySelectedProducts.length + self.linkedProducts.length >= self.maxLinkedProducts && !product.selected && !product.linked\">\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.MAXIMUM_LIMIT_REACHED_TOOLTIP\' | translate }} </span><span ng-if=\"product.omieAccount\">\n<md-icon md-svg-src=\"assets/icons/icon-omie-active.svg\" class=\"omie-products-tiny-icon\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.OMIE_ACCOUNT\">Omie Account</span>: <b>{{ product.omieAccount }}</b></span><div \nng-if=\"vm.selectedCustomer && vm.selectedCustomer.metadata && !vm.selectedCustomer.metadata.featureDisableShowProductServiceValue\" \nclass=\"link-products__product__value\">{{ product.value | currencyFormat }}</div></div></div><md-checkbox \nng-model=\"product.selected\" translate ng-if=\"!product.linked\" \nng-change=\"product.selected ? self.selectProduct(product) : self.deselectProduct(product)\" \nng-disabled=\"self.currentlySelectedProducts.length + self.linkedProducts.length >= self.maxLinkedProducts && !product.selected\">\n</md-checkbox></div></div></div><div class=\"link-products__table-navigation\" layout=\"row\" layout-align=\"end center\">\n<div class=\"link-products__table-navigation__info\" id=\"table-list_info\" aria-live=\"polite\"><span \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((self.currentPage - 1) * self.limit) + 1 }} <span translate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.TO\">to</span> \n<span ng-if=\"self.getLastProductCount() <= self.limit\">{{ self.limit }}</span> <span \nng-if=\"self.getLastProductCount() > self.limit\">{{ self.getLastProductCount() }}</span> <span \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.OF\">of</span> {{ self.totalCount }} <span \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.ITEMS\">items.</span></div><button \nclass=\"link-products__table-navigation__button-previous\" ng-click=\"self.navigateToPage(false)\" \nng-disabled=\"self.currentPage === 1\"><span translate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.PREVIOUS\">Previous</span>\n</button> <button class=\"link-products__table-navigation__button-next\" ng-click=\"self.navigateToPage(true)\" \nng-disabled=\"self.currentShowedProducts >= self.totalCount\"><span \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.NEXT\">Next</span></button></div></ng-container><span \nng-if=\"!self.allProducts.length && self.isLoading === false\" class=\"services-tab__content__not-found\"><img \nsrc=\"assets/icons/not-found.svg\"> <span>{{ \'TASKS.DIALOG.TABS.PRODUCTS.NO_PRODUCTS_FOUND\' | translate }}</span></span>\n<div class=\"link-products__loading\" layout=\"column\" layout-align=\"center center\" ng-if=\"self.isLoading === true\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.LOADING\">Loading products ...</div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><button type=\"submit\" id=\"dialog-update-task-button\" \nng-click=\"self.saveSelectedProducts()\" \nng-disabled=\"self.isLoading || self.currentlySelectedProducts.length > self.maxLinkedProducts || self.currentlySelectedProducts.length < 1 || self.linkedProducts.length >= self.maxLinkedProducts || (self.maxLinkedProducts - (self.currentlySelectedProducts.length + self.linkedProducts.length)) < 0\" \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.SAVE_PRODUCTS\" class=\"fc-button fc-button--actions\" aria-label=\"Save\">\nSave products</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tasks/dialogs/link-services-dialog/link-services-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large task-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\" \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.LINK_SERVICES\">Attach services</span></div><div class=\"sidebar-dialog__actions\">\n<md-button class=\"md-icon-button\" ng-click=\"self.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"link-services\" ms-scroll><div layout=\"column\" class=\"link-services__search-bar\">\n<div class=\"search-bar\" layout=\"row\" flex=\"100\"><div class=\"fc-input\" flex=\"100\"><input type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" ng-model=\"self.nameContains\" \nng-change=\"self.searchServices()\" ng-model-options=\"{ debounce: 500 }\" ng-disabled=\"false\"><label \nclass=\"fc-input__label\" translate=\"TASKS.DIALOG.TABS.SERVICES.SEARCH_SERVICE\">Search for an service</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div></div></div><ng-container \nng-if=\"self.isLoading === false && self.allServices.length\"><div layout=\"column\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\" class=\"link-services__header\"><div><span class=\"link-services__header__title\" \nflex=\"20\"><span translate=\"TASKS.DIALOG.TABS.SERVICES.TITLE\">Services</span>\n ({{ self.currentlySelectedServices.length + self.linkedServices.length }}/{{ self.maxLinkedServices }}) </span><span \nclass=\"link-services__header__select-message\"><span \nng-if=\"self.currentlySelectedServices.length + self.linkedServices.length < self.maxLinkedServices\"><span \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.YOU_CAN_STILL_SELECT\" \ntranslate-values=\"{ selectedServices: self.maxLinkedServices - (self.currentlySelectedServices.length + self.linkedServices.length) }\">\nYou can still select </span></span><span \nng-if=\"self.currentlySelectedServices.length + self.linkedServices.length >= self.maxLinkedServices\" \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.MAXIMUM_LIMIT_REACHED\">Maximum linked services limit per activity reached.</span>\n</span></div><md-checkbox ng-model=\"self.allServicesSelected\" ng-change=\"self.selectOrDeselectAllServices()\">\n</md-checkbox></div><div ng-repeat=\"service in self.allServices\" ng-if=\"self.totalCount\" class=\"link-services__item\">\n<div class=\"link-services__item__info\"><div class=\"link-services__item__info__image\" ng-if=\"service.imageUrl\"><img \nng-src=\"{{ service.imageUrl | mumakil }}\" alt=\"{{ service.name }}\" class=\"link-services__image\"></div><div \nclass=\"link-services__item__info__image\" layout-align=\"center center\" ng-if=\"!service.imageUrl\"><img \nsrc=\"assets/icons/no-image_gray.svg\"></div><div class=\"link-services__item__info__service\"><span \nclass=\"link-services__item__info__service__line\"><span class=\"link-services__item__info__service__line__name\">\n{{ service.name }}</span></span><div class=\"link-services__item__info__service__value\">\n{{ service.value | currencyFormat }}</div><span ng-if=\"service.omieAccount\"><md-icon \nmd-svg-src=\"assets/icons/icon-omie-active.svg\" class=\"omie-products-tiny-icon\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.OMIE_ACCOUNT\">Omie Account</span>:<br><b>{{ service.omieAccount }}</b></span>\n</div></div><div class=\"link-services__add-service\"><md-checkbox ng-model=\"service.selected\" translate \nng-if=\"!service.linked\" ng-change=\"service.selected ? self.selectService(service) : self.deselectService(service)\" \nng-disabled=\"self.currentlySelectedServices.length + self.linkedServices.length >= self.maxLinkedServices && !service.selected\">\n</md-checkbox><span ng-if=\"service.linked\" class=\"link-services__add-service__already-linked\">\n{{\'TASKS.DIALOG.TABS.SERVICES.ALREADY_LINKED\' | translate}}</span> <span class=\"link-services__add-service__tooltip\" \nng-if=\"self.currentlySelectedServices.length + self.linkedServices.length >= self.maxLinkedServices && !service.selected && !service.linked\">\n{{ \'TASKS.DIALOG.TABS.SERVICES.MAXIMUM_LIMIT_REACHED_TOOLTIP\' | translate }}</span></div></div></div><div \nclass=\"link-services__table-navigation\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"link-services__table-navigation__info\" id=\"table-list_info\" aria-live=\"polite\"><span \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((self.currentPage - 1) * self.limit) + 1 }} <span translate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.TO\">to</span> \n<span ng-if=\"self.getLastServiceCount() <= self.limit\">{{ self.limit }}</span> <span \nng-if=\"self.getLastServiceCount() > self.limit\">{{ self.getLastServiceCount() }}</span> <span \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.OF\">of</span> {{ self.totalCount }} <span \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.ITEMS\">items.</span></div><button \nclass=\"link-services__table-navigation__button-previous\" ng-click=\"self.navigateToPage(false)\" \nng-disabled=\"self.currentPage === 1\"><span translate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.PREVIOUS\">Previous</span>\n</button> <button class=\"link-services__table-navigation__button-next\" ng-click=\"self.navigateToPage(true)\" \nng-disabled=\"self.currentShowedServices >= self.totalCount\"><span \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.NEXT\">Next</span></button></div></ng-container><span \nng-if=\"!self.allServices.length && self.isLoading === false\" class=\"services-tab__content__not-found\"><img \nsrc=\"assets/icons/not-found.svg\"> <span>{{ \'TASKS.DIALOG.TABS.SERVICES.NO_SERVICES_FOUND\' | translate }}</span></span>\n<div class=\"link-services__loading\" layout=\"column\" layout-align=\"center center\" ng-if=\"self.isLoading === true\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.LOADING\">Loading services ...</div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><button type=\"submit\" id=\"dialog-update-task-button\" \nng-click=\"self.saveSelectedServices()\" \nng-disabled=\"self.isLoading || self.currentlySelectedServices.length > self.maxLinkedServices || self.currentlySelectedServices.length < 1 || self.linkedServices.length >= self.maxLinkedServices || (self.maxLinkedServices - (self.currentlySelectedServices.length + self.linkedServices.length)) < 0\" \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.SAVE_SERVICES\" class=\"fc-button fc-button--actions\" aria-label=\"Save\">\nSave services</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tasks/dialogs/return-order-products-dialog/return-order-products-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large task-dialog\"><return-order-products-modal-provider \nng-attr-product-id=\"{{ self.productId }}\" ng-attr-order-id=\"{{ self.orderId }}\" id=\"return-order-products\">\n</return-order-products-modal-provider></md-dialog>");
$templateCache.put("app/main/tasks/dialogs/search-answered-equipments-forms/search-answered-equipments-forms.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large equipments-forms-dialogs task-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\">\n{{ \'TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.VIEW_COMPLETED_EQUIPMENT_FORMS\' | translate }} \"{{ vm.equipment ? vm.equipment.name : \'\' }}\"\n</span></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"list__equipments__forms\" ms-scroll><div \nlayout=\"row\" layout-align=\"space-between center\"><div flex=\"100\"><fc-search options=\"vm.filteredForms\" \nlabel=\"Buscar formulário\" hint=\"Busque por formulários respondidos.\" \nsearch-function=\"vm.searchAnsweredForms(searchTerm)\" select-function=\"vm.selectForm(option)\" track-by=\"text\" \nflex=\"100\"></fc-search></div></div><div class=\"mt-44 mb-24\"><h4 class=\"fs-15 fw-500\" flex=\"20\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.ALL_FORMS\">Todos os formulários</h4></div>\n<div class=\"list\"><div class=\"answered__form\" ng-repeat=\"(formName, forms) in vm.forms track by $index\"><div ms-scroll>\n<div class=\"answered__form__info\"><div class=\"icon\"><md-icon md-menu-origin md-font-icon=\"icon-clipboard-text\">\n</md-icon></div><div class=\"answered__form__name\"><p>{{formName}}</p><span ng-if=\"forms[0].required.complete\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.OPTIONAL\">Opcional</span> <span \nng-if=\"!forms[0].required.complete\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.REQUIRED\">Required</span> <span>\n{{ \'TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.FORM_LENGTH\' | translate:{ LENGTH: \' - \' + forms[0].questions.length } }}\n</span></div><div class=\"icon\"><md-button class=\"button-without-hover md-icon-button\" \nng-click=\"vm.toggleCollapse($index)\"><md-icon class=\"collapsed\" md-menu-origin md-font-icon=\"icon-chevron-down\" \nng-class=\"{\'collapsed\': !vm.answeredFormIsCollapsed[$index], \'unCollapsed\': vm.answeredFormIsCollapsed[$index]}\">\n</md-icon></md-button></div></div><div \nng-class=\"{\'answered__form--collapse\': !vm.answeredFormIsCollapsed[$index], \'answered__form--unCollapsed\': vm.answeredFormIsCollapsed[$index]}\">\n<h3 class=\"fs-13 fw-500\" translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.ANSWERS\" \ntranslate-values=\"{ quantity: forms.length }\">Answers ({{forms.length}})</h3><span ng-repeat=\"form in forms\" \nflex=\"100\" class=\"answered__form__answer\" ng-class=\"{ \'answered__form__answer--archived\': form.archived }\"><div \nclass=\"answered__form__answer__infos\"><p class=\"answered__form__answer__infos__title\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.STATUS\">Status</p><div \nclass=\"answered__form__answer__infos__subtitle form--{{form.status}}\"><span ng-if=\"form.status === \'in-progress\'\">\n{{\'TASKS.DIALOG.TABS.FORMS.IN_PROGRESS\' | translate}} </span><span ng-if=\"form.status === \'done\'\">\n{{\'TASKS.DIALOG.TABS.FORMS.DONE\' | translate}}</span><md-icon class=\"answered__form__answer__infos__subtitle__icon\" \nng-if=\"form.status === \'in-progress\'\" md-svg-src=\"assets/icons/icon-info.svg\" class=\"icon-info\"><md-tooltip \nmd-direction=\"bottom\"><span translate=\"TASKS.DIALOG.TABS.FORMS.IN_PROGRESS_ALERT\">Forms in progress cannot be edited.\n</span></md-tooltip></md-icon></div></div><div class=\"answered__form__answer__infos\"><p \nclass=\"answered__form__answer__infos__title\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.ANSWERED_BY\">Answered by</p><p \nclass=\"answered__form__answer__infos__subtitle\">{{ form.createdBy ? form.createdBy : \'--\'}}</p></div><div \nclass=\"answered__form__answer__infos\"><p class=\"answered__form__answer__infos__title\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.ANSWERED_AT\">Answered at</p><p \nclass=\"answered__form__answer__infos__subtitle\">\n{{ form.completedAt ? vm.moment(form.completedAt).format(vm.dateFormat) : \'--\' }}</p></div><md-button \nclass=\"button-without-hover md-icon-button\" ng-click=\"vm.goToForm(form)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-eye\"></md-icon></md-button></span></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"start center\"><button type=\"button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \nclass=\"fc-button fc-button--actions\" translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.BACK\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.BACK\">Voltar</button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tasks/dialogs/search-equipments-forms/search-equipments-forms.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large equipments-forms-dialogs task-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\">\n{{ \'TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.ANSWER_EQUIPMENTS_FORMS\' | translate }} \"{{ vm.equipment ? vm.equipment.name : \'\' }}\"\n</span></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"list__equipments__forms\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"100\"><fc-search options=\"vm.filteredForms\" \nlabel=\"{{ \'TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.SEARCH_FORM\' | translate }}\" \nhint=\"{{ \'TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.SEARCH_FORMS_LINKED_EQUIPMENT\' | translate }}\" \nsearch-function=\"vm.searchForms(searchTerm)\" select-function=\"vm.answerForm(option)\" track-by=\"name\" flex=\"100\">\n</fc-search></div></div><div class=\"mt-44 mb-24\"><h4 class=\"fs-15 fw-500\" flex=\"30\">\n{{ \'TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.FORMS_AVAILABLE\' | translate }} ({{vm.forms.length}})\n</h4></div><div class=\"list\" ms-scroll><div class=\"answered__form\" ng-repeat=\"form in vm.showingForms\"><div \nclass=\"answered__form__info\"><div class=\"icon\"><md-icon md-menu-origin md-font-icon=\"icon-clipboard-text\"></md-icon>\n</div><div class=\"answered__form__name\"><p class=\"fs-14 fw-400\">{{form.name}}</p><span class=\"fs-13 fw-400\">\n{{ form.required.complete ? \'Obrigatório\': \'Opcional\' }} - {{form.questionsCount ? form.questionsCount : 0}} perguntas\n</span></div><md-button class=\"answered__form__button\" ng-click=\"vm.answerForm(form)\">\n{{ \'TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.ANSWER\' | translate }}</md-button></div></div></div>\n<div ng-if=\"vm.showingForms.length\" class=\"table-navigation\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"table-navigation__info\" id=\"table-list_info\" aria-live=\"polite\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((vm.formsPage - 1) * vm.formsPaginateBy) + 1 }} <span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.TO\">to\n</span> {{ vm.getLastFormsCount() > vm.forms.length ? vm.forms.length : vm.getLastFormsCount() }} <span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.OF\">of</span> {{ vm.forms.length }} <span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.RECORDS\">records</span></div><button \nclass=\"table-navigation__button\" aria-label=\"Previous\" ng-click=\"vm.navigateToPage(vm.formsPage - 1)\" \nng-disabled=\"vm.formsPage === 1\"><span class=\"fw-500\" ng-style=\"{\'color\': vm.formsPage === 1 ? \'#757575\' : \'#135AC0\'}\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.PREVIOUS\">Previous</span></button> <button \nclass=\"table-navigation__button\" aria-label=\"Next\" ng-click=\"vm.navigateToPage(vm.formsPage + 1)\" \nng-disabled=\"vm.formsPage * vm.formsPaginateBy >= vm.forms.length\"><span class=\"fw-500\" \nng-style=\"{\'color\': vm.formsPage * vm.formsPaginateBy >= vm.forms.length ? \'#757575\' : \'#135AC0\'}\" \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.NEXT\">Next</span></button></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"start center\"><button type=\"button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\" class=\"fc-button fc-button--actions\">\n{{ \'TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.SEARCH_EQUIPMENTS.BACK\' | translate }}</button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/tasks/dialogs/storage-movements-dialog/storage-movements-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large task-dialog\"><storage-movements-modal-provider \nng-attr-movement=\"{{ self.storageMovement }}\" ng-attr-order=\"{{ self.order.id }}\" id=\"storage-movement\">\n</storage-movements-modal-provider></md-dialog>");
$templateCache.put("app/main/tasks/dialogs/update-pendency-assignee-modal/update-pendency-assignee-modal.html","<update-assignee-modal-provider ng-attr-assignee=\"{{ self.assignee }}\" ng-attr-pendency=\"{{ self.pendency.id }}\" \nid=\"update-assignee-modal\"></update-assignee-modal-provider>");
$templateCache.put("app/main/tasks/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button ng-hide=\"vm.selectedMenu === \'Filters\'\" \nclass=\"md-icon-button\" ng-click=\"vm.backToFilterPage();\" aria-label=\"back\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><div ng-if=\"vm.selectedMenu === \'Filters\'\" flex class=\"menu-title text-left\"><span \ntranslate=\"TASKS.SIDENAV.HEADER.FILTERS\">Filter tasks</span></div><div ng-if=\"vm.selectedMenu === \'CustomFilter\'\" flex \nclass=\"menu-title text-left\"><span translate=\"TASKS.SIDENAV.HEADER.CUSTOM_FILTER\">Custom filters</span></div><div \nng-if=\"vm.selectedMenu === \'SavedFilters\'\" flex class=\"menu-title text-left\"><span \ntranslate=\"TASKS.SIDENAV.HEADER.SAVED_FILTERS\">Filters</span></div><md-button \nng-if=\"vm.filteringIsOn() && vm.selectedMenu === \'Filters\'\" ng-click=\"vm.clearFilters()\" class=\"md-icon-button mr-n10\" \naria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"bottom\"><span\n translate=\"TASKS.SIDENAV.HEADER.ACTIONS.CLEAR\">Clear filters</span></md-tooltip></md-button><md-button \nng-if=\"!vm.filteringIsOn() && vm.selectedMenu === \'Filters\'\" ng-click=\"vm.selectedMenu = \'SavedFilters\';\" \nclass=\"md-icon-button\" aria-label=\"saved filters\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"TASKS.SIDENAV.HEADER.ACTIONS.SHOW_SAVED_FILTERS\">Filters</span></md-tooltip>\n</md-button><md-button ng-if=\"vm.filteringIsOn() && vm.selectedMenu === \'Filters\'\" \nng-click=\"vm.selectedMenu = \'CustomFilter\';\" class=\"md-icon-button\" aria-label=\"save filter\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"TASKS.SIDENAV.HEADER.ACTIONS.SAVE\">Save filter</span></md-tooltip></md-button></div></md-toolbar><md-content\n ng-show=\"vm.selectedMenu === \'Filters\'\" class=\"animate-slide-right filter-sidenav\" ms-scroll><md-list><p \nclass=\"filter-text\" ng-if=\"vm.account && vm.account.configuration.taskEnablePendingStatus\">\nPor padrão, atividades pendentes são exibidas no painel independentemente da data de agendamento. Caso não deseje visualizá-las, utilize os filtros por situação.\n</p><md-divider ng-if=\"vm.account && vm.account.configuration.taskEnablePendingStatus\"></md-divider><div \nclass=\"filter-property-name\"><span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_APPOINTMENT\">Filter by appointment</span>\n</div><md-list-item><label translate=\"TASKS.SIDENAV.FILTERS.FIELDS.FROM\">From:</label><md-datepicker \ndata-cy=\"tasks-filters.activitiesDateFromView\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.activitiesFilters.activitiesDateFromView\" \nmd-placeholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item>\n<md-list-item><label translate=\"TASKS.SIDENAV.FILTERS.FIELDS.TO\">To:</label><md-datepicker \ndata-cy=\"tasks-filters.activitiesDateToView\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.activitiesFilters.activitiesDateToView\" \nmd-placeholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item>\n<md-divider></md-divider><div class=\"filter-property-name\"><span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_DEADLINE\">\nFilter by deadline</span></div><md-list-item><label translate=\"TASKS.SIDENAV.FILTERS.FIELDS.FROM\">From:</label>\n<md-datepicker data-cy=\"tasks-filters.activitiesDateDeadlineFrom\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.activitiesFilters.activitiesDateDeadlineFrom\" \nmd-placeholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item>\n<md-list-item><label translate=\"TASKS.SIDENAV.FILTERS.FIELDS.TO\">To:</label><md-datepicker \ndata-cy=\"tasks-filters.activitiesDateDeadlineTo\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.activitiesFilters.activitiesDateDeadlineTo\" \nmd-placeholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item>\n<md-divider></md-divider><div ng-if=\"vm.hasTerritoriesFlag\"><div class=\"filter-property-name\"><span \ntranslate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_TERRITORY.LABEL\">Filter by territory</span></div><md-list-item>\n<md-input-container><label ng-show=\"!vm.activitiesFilters.territoryId\">\n{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_TERRITORY.SEARCH_LABEL\' | translate }}</label><md-select \ndata-cy=\"tasks-filters.territoryId\" ng-model=\"vm.activitiesFilters.territoryId\" \nng-model-options=\"{trackBy: \'$value\', debounce: 100}\" md-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" \nng-change=\"vm.broadcastFilterUpdated(); vm.territorySelected()\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_TERRITORY.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"territory.id\" \nng-repeat=\"territory in vm.territoriesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">{{ territory.name }}\n</md-option></md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider><div \nng-if=\"vm.activitiesFilters.territoryId\"><div class=\"filter-property-name\"><span \ntranslate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_SUBTERRITORY.LABEL\">Filter by subTerritory</span></div><md-list-item>\n<md-input-container><label ng-show=\"vm.activitiesFilters.subTerritoryIds.length == 0\">\n{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_SUBTERRITORY.SEARCH_LABEL\' | translate }}</label><md-select \ndata-cy=\"tasks-filters.subTerritoryIds\" ng-model=\"vm.activitiesFilters.subTerritoryIds\" \nng-model-options=\"{trackBy: \'$value\', debounce: 100}\" md-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" \nng-change=\"vm.broadcastFilterUpdated();\" multiple=\"multiple\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_SUBTERRITORY.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"territory.id\" \nng-repeat=\"territory in vm.subTerritoriesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">{{ territory.name }}\n</md-option></md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider></div></div><div \nclass=\"filter-subtitle\"><span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_STATUS.LABEL\">Filter by state</span></div>\n<md-list-item><md-select data-cy=\"tasks-filters.archived\" class=\"w-100-percent mt-0 mb-0\" name=\"archived\" \nng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.activitiesFilters.archived\"><md-option data-cy=\"all\" value=\"-1\">\n<span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_STATUS.OPTIONS.ALL\">All</span></md-option><md-option data-cy=\"active\" \nvalue=\"1\"><span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_STATUS.OPTIONS.ACTIVE\">Active</span></md-option><md-option \ndata-cy=\"archived\" value=\"0\"><span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_STATUS.OPTIONS.ARCHIVED\">Archived</span>\n</md-option></md-select></md-list-item><md-divider></md-divider><div class=\"filter-property-name\" \ntranslate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_CUSTOMER.LABEL\">Filter by customer</div><md-list-item class=\"fx-wrap\"><input\n data-cy=\"tasks-filters.customersName\" flex placeholder=\"Search by customer\" translate \ntranslate-attr-placeholder=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_CUSTOMER.SEARCH\" type=\"text\" \nclass=\"pl-10 h-35 input-border\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated(); vm.customerNameFilterHasChange();\" \nng-model=\"vm.activitiesFilters.customersName\" ng-show=\"!vm.hasCustomerSelectedInFilter\"><md-icon \nng-click=\"vm.removeSelectedCustomerInFilter();\" ng-show=\"vm.hasCustomerSelectedInFilter\" md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s18 remove-selected-option\"></md-icon><md-select \nplaceholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_CUSTOMER.SELECT\' | translate }}\" \nng-model=\"vm.selectedCustomerInFilter\" class=\"minimal-md-select md-no-underline ml-22 wd-100-22\" \nng-show=\"vm.customersFilterable.length > 0\" ng-change=\"vm.selectCustomerInFilter();\"><md-option ng-value=\"customer\" \nng-repeat=\"customer in vm.customersFilterable\">{{customer.name}}</md-option></md-select></md-list-item><md-divider>\n</md-divider><div class=\"filter-property-name\" translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_LOCATION.LABEL\">\nFilter by location name</div><md-list-item class=\"fx-wrap\"><input data-cy=\"tasks-filters.locationName\" flex \nplaceholder=\"Search by Location\" translate \ntranslate-attr-placeholder=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_LOCATION.SEARCH\" type=\"text\" \nclass=\"pl-10 h-35 input-border\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.activitiesFilters.locationName\"></md-list-item><div class=\"filter-property-name\" \ntranslate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_LOCATION_NOTES.LABEL\">Filter by location description</div><md-list-item \nclass=\"fx-wrap\"><input data-cy=\"tasks-filters.locationNotes\" flex placeholder=\"Search by Location\" translate \ntranslate-attr-placeholder=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_LOCATION_NOTES.SEARCH\" type=\"text\" \nclass=\"pl-10 h-35 input-border\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.activitiesFilters.locationNotes\"></md-list-item><div class=\"filter-property-name mt-10\" \nng-show=\"vm.hasSelectedCustomerEquipments\" translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_EQUIPMENT.LABEL\">\nFilter by equipment</div><md-list-item ng-show=\"vm.hasSelectedCustomerEquipments\"><ui-select multiple=\"multiple\" \nng-model=\"vm.activitiesFilters.equipments\" close-on-select=\"false\" on-select=\"vm.broadcastFilterUpdated($select);\" \non-remove=\"vm.broadcastFilterUpdated($select);\" class=\"pl-10\"><ui-select-match \nplaceholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_EQUIPMENT.SELECT\' | translate }}\"><span class=\"equipment-name\" \ntitle=\"{{$item.displayName}}\">{{ $item.displayName }}</span></ui-select-match><ui-select-choices \nrepeat=\"equipment in vm.equipmentsFilterList | propsFilter: { displayName: $select.search }\"><div \nclass=\"equipment-name\" title=\"{{equipment.displayName}}\" \nng-bind-html=\"equipment.displayName | highlight: $select.search\"></div></ui-select-choices></ui-select></md-list-item>\n<md-divider></md-divider><md-list-item data-cy=\"tasks-filters.customersLabels\"><tags-input \nng-model=\"vm.activitiesFilters.customersLabels\" display-property=\"name\" \nplaceholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_CUSTOMER_LABELS\' | translate }}\" add-from-autocomplete-only=\"true\" \non-tag-removed=\"vm.broadcastFilterUpdated();\" on-tag-added=\"vm.broadcastFilterUpdated();\" min-length=\"2\" \nclass=\"with-border w-100-percent\" add-on-paste=\"true\"><auto-complete min-length=\"1\" \nsource=\"vm.loadCustomerLabels($query)\" highlight-matched-text=\"true\"></auto-complete></tags-input></md-list-item>\n<md-list-item><input data-cy=\"tasks-filters.activitiesIdentifier\" flex type=\"text\" class=\"pl-10 h-35 input-border\" \ntranslate translate-attr-placeholder=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_ID\" placeholder=\"Search by identifier\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.activitiesFilters.activitiesIdentifier\"></md-list-item><md-list-item><input \ndata-cy=\"tasks-filters.zipCode\" flex placeholder=\"Search by ZipCode\" translate \ntranslate-attr-placeholder=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_ZIPCODE\" type=\"text\" class=\"pl-10 h-35 input-border\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.activitiesFilters.zipCode\">\n</md-list-item><md-list-item><input data-cy=\"tasks-filters.city\" flex placeholder=\"Search by city\" translate \ntranslate-attr-placeholder=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_CITY\" type=\"text\" class=\"pl-10 h-35 input-border\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" ng-model=\"vm.activitiesFilters.city\">\n</md-list-item><md-list-item><input data-cy=\"tasks-filters.neighborhood\" flex placeholder=\"Search by neighborhood\" \ntranslate translate-attr-placeholder=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_NEIGHBORHOOD\" type=\"text\" \nclass=\"pl-10 h-35 input-border\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.activitiesFilters.neighborhood\"></md-list-item><md-list-item><input data-cy=\"tasks-filters.description\" \nflex placeholder=\"Search by description\" translate \ntranslate-attr-placeholder=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_DESCRIPTION\" type=\"text\" class=\"pl-10 h-35 input-border\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.broadcastFilterUpdated();\" \nng-model=\"vm.activitiesFilters.description\"></md-list-item><md-divider></md-divider><div class=\"filter-property-name\">\n<span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_TYPE.LABEL\">Filter by OS type</span></div><md-list-item>\n<md-input-container><label ng-show=\"vm.activitiesFilters.services.length == 0\">\n{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_TYPE.SEARCH_LABEL\' | translate }}</label><md-select \ndata-cy=\"tasks-filters.services\" ng-model=\"vm.activitiesFilters.services\" \nng-model-options=\"{trackBy: \'$value.id\', debounce: 100}\" md-on-close=\"vm.clearSearchTerm()\" close-on-select=\"false\" \nng-change=\"vm.broadcastFilterUpdated();\" multiple=\"multiple\"><md-select-header class=\"select-header\"><input \nng-model=\"vm.searchTerm\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_TYPE.SEARCH\' | translate }}\" class=\"header-searchbox md-text\">\n</md-select-header><md-optgroup><md-option ng-value=\"service\" \nng-repeat=\"service in vm.servicesFilterList | filter:vm.searchTerm | orderBy: \'name\'\">\n{{(service.name && service.name.length) > 40 ? service.name.substring(0, 40) + \'...\' : service.name}}</md-option>\n</md-optgroup></md-select></md-input-container></md-list-item><md-divider></md-divider><div \nclass=\"filter-property-name\" translate=\"TASKS.SIDENAV.FILTERS.FIELDS.CREATED_BY.LABEL\">\nFilter by user who created the task</div><md-list-item class=\"fx-wrap\"><input data-cy=\"tasks-filters.createdBy\" flex \nplaceholder=\"Search by created by\" translate \ntranslate-attr-placeholder=\"TASKS.SIDENAV.FILTERS.FIELDS.CREATED_BY.SEARCH\" type=\"text\" \nclass=\"pl-10 h-35 input-border\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.broadcastFilterUpdated(); vm.createdByFilterHasChange();\" ng-model=\"vm.activitiesFilters.createdBy\" \nng-show=\"!vm.hasUserSelectedInFilter\"><md-icon ng-click=\"vm.removeSelectedUserInFilter();\" \nng-show=\"vm.hasUserSelectedInFilter\" md-menu-origin md-font-icon=\"icon-close\" class=\"icon s18 remove-selected-option\">\n</md-icon><md-select placeholder=\"{{ \'TASKS.SIDENAV.FILTERS.FIELDS.BY_USER.SELECT\' | translate }}\" \nng-model=\"vm.selectedUserInFilter\" class=\"minimal-md-select md-no-underline ml-22 wd-100-22\" \nng-show=\"vm.usersFilterable.length > 0\" ng-change=\"vm.selectUserInFilter();\"><md-option ng-value=\"user\" \nng-repeat=\"user in vm.usersFilterable\">{{user.name}}</md-option></md-select></md-list-item><md-divider \nng-if=\"vm.labels && vm.labels.length > 0\"></md-divider><div ng-if=\"vm.labels && vm.labels.length > 0\" \nclass=\"filter-property-name\"><span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_LABELS.LABEL\">Filter by tags</span></div>\n<md-list-item data-cy=\"tasks-filters.noLabel\" class=\"label\" \nng-click=\"vm.toggleInArray(null, vm.activitiesFilters.labels)\"><md-icon md-font-icon=\"icon-label-outline\" \nclass=\"label-icon\"></md-icon><p translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_LABELS.NO_LABEL\">No tag</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(null, vm.activitiesFilters.labels)\"></i></md-list-item><md-list-item \ndata-cy=\"tasks-filters.labels\" class=\"label\" ng-repeat=\"label in vm.labels\" \nng-click=\"vm.toggleInArray(label.id, vm.activitiesFilters.labels)\"><md-icon md-font-icon=\"icon-label\" \nng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(label.id, vm.activitiesFilters.labels)\"></i></md-list-item><md-divider></md-divider><div \nclass=\"filter-property-name\"><span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_SITUATION\">Filter by situation</span>\n</div><md-list-item data-cy=\"tasks-filters.activitiesStatus-{{ $index }}\" class=\"label\" \nng-repeat=\"activityStatus in vm.activitiesStatus\" \nng-click=\"vm.toggleInArray(activityStatus.name, vm.activitiesFilters.status)\"><md-icon \nmd-font-icon=\"{{activityStatus.icon}}\" ng-class=\"activityStatus.name + \'-fg\'\" class=\"label-icon\"></md-icon><p \nng-class=\"activityStatus.name + \'-fg\'\">{{activityStatus.description}}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(activityStatus.name, vm.activitiesFilters.status)\"></i></md-list-item><div \nng-if=\"vm.account && vm.account.configuration.moduleOrdersDeadlineEnabled\"><md-divider></md-divider><div \nclass=\"filter-property-name\"><span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_RESPONSE_DEADLINE_STATUS\">\nFilter by deadline</span></div><md-list-item class=\"label\" ng-repeat=\"deadlineStatus in vm.deadlineStatusFilterList\" \nng-click=\"vm.toggleInArray(deadlineStatus.name, vm.activitiesFilters.responseDeadlineStatus)\"><div \nclass=\"status-indicator\" ng-class=\"deadlineStatus.classBgColor\"></div><p>{{deadlineStatus.description}}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(deadlineStatus.name, vm.activitiesFilters.responseDeadlineStatus)\"></i>\n</md-list-item></div><div ng-if=\"vm.account && vm.account.configuration.moduleOrdersDeadlineEnabled\"><md-divider>\n</md-divider><div class=\"filter-property-name\"><span \ntranslate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_SOLUTION_DEADLINE_STATUS\">Filter by deadline</span></div><md-list-item \nclass=\"label\" ng-repeat=\"deadlineStatus in vm.deadlineStatusFilterList\" \nng-click=\"vm.toggleInArray(deadlineStatus.name, vm.activitiesFilters.solutionDeadlineStatus)\"><div \nclass=\"status-indicator\" ng-class=\"deadlineStatus.classBgColor\"></div><p>{{deadlineStatus.description}}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(deadlineStatus.name, vm.activitiesFilters.solutionDeadlineStatus)\"></i>\n</md-list-item></div><md-divider></md-divider><div class=\"filter-property-name\"><span \ntranslate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_EMPLOYEE.LABEL\">Filter by employee</span></div><md-list-item><input flex \nplaceholder=\"Search for employee\" translate \ntranslate-attr-placeholder=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_EMPLOYEE.SEARCH\" type=\"text\" \nclass=\"pl-10 h-35 input-border\" ng-model-options=\"{ debounce: 100 }\" ng-model=\"vm.employeeFilter\"></md-list-item>\n<md-list-item data-cy=\"tasks-filters.noEmployee\" class=\"member\" \nng-click=\"vm.toggleInArray(\'null\', vm.activitiesFilters.employees)\" aria-label=\"Toggle Member\"><div \nclass=\"avatar bg-grey\"><div class=\"mt-3\"><i class=\"icon icon-account-remove s25 color-white\"></i></div></div><p \nclass=\"member-name\" translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_EMPLOYEE.NO_EMPLOYEE\">No employee</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(\'null\', vm.activitiesFilters.employees)\"></i></md-list-item><md-list-item \ndata-cy=\"tasks-filters.employees-{{ $index }}\" class=\"member\" \nng-repeat=\"employee in vm.employees | filter: { name: vm.employeeFilter }\" \nng-click=\"vm.toggleInArray(employee.id, vm.activitiesFilters.employees)\" aria-label=\"Toggle Member\"><div \nclass=\"avatar bg-grey\"><img alt=\"{{employee.name}}\" class=\"avatar\" \nng-src=\"{{employee.avatarUrl ? employee.avatarUrl : \'./assets/images/avatars/profile.jpg\'}}\" \nsrc=\"./assets/images/avatars/profile.jpg\"></div><p class=\"member-name\">{{ employee.name }}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(employee.id, vm.activitiesFilters.employees)\"></i></md-list-item><md-divider>\n</md-divider><div class=\"filter-property-name\"><span translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_RATE.LABEL\">\nFilter by rating</span></div><md-list-item data-cy=\"tasks-filters.rating_{{ $index }}\" class=\"label\" \nng-repeat=\"rating in vm.ratings\" ng-click=\"vm.toggleInArray(rating.stars, vm.activitiesFilters.ratings)\"><p \nng-if=\"rating.stars === \'null\'\" translate=\"TASKS.SIDENAV.FILTERS.FIELDS.BY_RATE.NO_RATE\">No rating</p><p \nng-if=\"rating.stars > 0\" class=\"stars-row\"><i ng-class=\"rating.stars >= 1 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20 star-color\"></i> <i ng-class=\"rating.stars >= 2 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20 star-color\"></i> <i ng-class=\"rating.stars >= 3 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20 star-color\"></i> <i ng-class=\"rating.stars >= 4 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20 star-color\"></i> <i ng-class=\"rating.stars >= 5 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20 star-color\"></i></p><p class=\"rating-name\">{{ rating.name }}</p><p></p><i class=\"icon-check s16\" \nng-if=\"vm.exists(rating.stars, vm.activitiesFilters.ratings)\"></i></md-list-item></md-list></md-content><md-content \nng-show=\"vm.selectedMenu === \'SavedFilters\'\" ms-scroll class=\"animate-slide-left\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/tasks/sidenavs/filters/components/list/list-filter-sidenav.html\'\" \nng-controller=\"ListFilterSidenavController as vm\"></div></md-content><md-content \nng-show=\"vm.selectedMenu === \'CustomFilter\'\" ms-scroll class=\"animate-slide-left\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/tasks/sidenavs/filters/components/custom/custom-filter-sidenav.html\'\" \nng-controller=\"CustomFilterSidenavController as vm\"></div></md-content>");
$templateCache.put("app/main/vehicles/dialogs/modal/qrcode-generator.html","<div class=\"qrcode-modal-container\"><qrcode ng-if=\"!vm.variables.hasPublicQRCodeFeatureFlag\" \nid=\"vehicle-qrcode-download\" ng-model=\"vm.variables.vehicle.qrCode\" version=\"6\" error-correction-level=\"M\" size=\"250\" \ndata=\"{{ vm.variables.vehicle.qrCode }}\"></qrcode><qrcode ng-if=\"vm.variables.hasPublicQRCodeFeatureFlag\" \nid=\"vehicle-qrcode-download\" ng-model=\"vm.variables.vehicle.qrCode\" version=\"6\" error-correction-level=\"M\" size=\"250\" \ndata=\"{{ \'https://app.fieldcontrol.com.br/qrcode-publico/#/\' + vm.variables.vehicle.qrCode }}\"></qrcode><p \nng-model=\"vm.variables.vehicle.qrCode\">{{vm.variables.vehicle.qrCode}}</p></div>");
$templateCache.put("app/main/vehicles/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"VEHICLES.FILTERS.TITLE\">Filter Vehicles</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span translate=\"VEHICLES.FILTERS.CLEAR\">\nClear filters</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-vehicles\" ms-scroll><md-list><div class=\"filter-subtitle\"><span \ntranslate=\"VEHICLES.FILTERS.NAME\">Search by name</span></div><md-list-item><input flex placeholder=\"Search by name\" \ntranslate translate-attr-placeholder=\"VEHICLES.FILTERS.NAME\" type=\"text\" class=\"pl-10 h-35 search-input\" \nng-model=\"vm.vehiclesFilters.name\" ng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider>\n<div class=\"filter-subtitle\"><span translate=\"VEHICLES.FILTERS.LICENSE_PLATE\">Search by license plate</span></div>\n<md-list-item><input flex placeholder=\"Search by license plate\" translate \ntranslate-attr-placeholder=\"VEHICLES.FILTERS.LICENSE_PLATE\" type=\"text\" class=\"pl-10 h-35 search-input\" \nng-model=\"vm.vehiclesFilters.licensePlate\" ng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\"><span translate=\"VEHICLES.FILTERS.DISPONIBILITY\">Filter by disponibility\n</span></div><md-list-item><md-select class=\"w-100-percent mt-0 mb-0\" name=\"status\" \nng-change=\"vm.broadcastFilterUpdated(\'status\')\" ng-model=\"vm.vehiclesFilters.status\"><md-option value=\"null\"><span \ntranslate=\"VEHICLES.MODEL.ALL\">All</span></md-option><md-option value=\"available\"><span \ntranslate=\"VEHICLES.MODEL.STATUS_OPTIONS.AVAILABLE\">Available</span></md-option><md-option value=\"unavailable\"><span \ntranslate=\"VEHICLES.MODEL.STATUS_OPTIONS.UNAVAILABLE\">Unavailable</span></md-option></md-select></md-list-item>\n<md-divider></md-divider><div class=\"filter-subtitle\"><span translate=\"VEHICLES.FILTERS.TYPE\">Filter by type</span>\n</div><md-list-item><md-select class=\"w-100-percent mt-0 mb-0\" name=\"type\" \nng-change=\"vm.broadcastFilterUpdated(\'type\')\" ng-model=\"vm.vehiclesFilters.type\"><md-option value=\"null\"><span \ntranslate=\"VEHICLES.MODEL.ALL\">All</span></md-option><md-option value=\"car\"><span \ntranslate=\"VEHICLES.MODEL.TYPES_OPTIONS.CAR\">Car</span></md-option><md-option value=\"motorcycle\"><span \ntranslate=\"VEHICLES.MODEL.TYPES_OPTIONS.MOTORCYCLE\">Motorcycle</span></md-option><md-option value=\"nautical\"><span \ntranslate=\"VEHICLES.MODEL.TYPES_OPTIONS.NAUTICAL\">Nautical</span></md-option><md-option value=\"truck\"><span \ntranslate=\"VEHICLES.MODEL.TYPES_OPTIONS.TRUCK\">Truck</span></md-option><md-option value=\"semi_truck\"><span \ntranslate=\"VEHICLES.MODEL.TYPES_OPTIONS.SEMI_TRUCK\">Semi Truck</span></md-option></md-select></md-list-item>\n<md-divider></md-divider><div class=\"filter-subtitle\"><span translate=\"VEHICLES.FILTERS.ORIGIN\">Filter by origin</span>\n</div><md-list-item><md-select class=\"w-100-percent mt-0 mb-0\" name=\"origin\" \nng-change=\"vm.broadcastFilterUpdated(\'origin\')\" ng-model=\"vm.vehiclesFilters.origin\"><md-option value=\"null\"><span \ntranslate=\"VEHICLES.MODEL.ALL\">All</span></md-option><md-option value=\"rented\"><span \ntranslate=\"VEHICLES.MODEL.ORIGINS_OPTIONS.RENTED\">Rented</span></md-option><md-option value=\"company\"><span \ntranslate=\"VEHICLES.MODEL.ORIGINS_OPTIONS.COMPANY\">Company</span></md-option><md-option value=\"employee\"><span \ntranslate=\"VEHICLES.MODEL.ORIGINS_OPTIONS.EMPLOYEE\">Employee</span></md-option></md-select></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\"><span translate=\"VEHICLES.FILTERS.STATUS\">Filter by status</span></div>\n<md-list-item><md-select class=\"w-100-percent mt-0 mb-0\" name=\"archived\" \nng-change=\"vm.broadcastFilterUpdated(\'archived\')\" ng-model=\"vm.vehiclesFilters.archived\"><md-option value=\"null\"><span \ntranslate=\"VEHICLES.MODEL.ALL\">All</span></md-option><md-option value=\"true\"><span \ntranslate=\"VEHICLES.MODEL.ARCHIVED_OPTIONS.ARCHIVED\">Unactive</span></md-option><md-option value=\"false\"><span \ntranslate=\"VEHICLES.MODEL.ARCHIVED_OPTIONS.UNARCHIVED\">Active</span></md-option></md-select></md-list-item></md-list>\n</md-content>");
$templateCache.put("app/main/vehicles-usage/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"VEHICLES_USAGE.FILTERS.TITLE\">Filter Vehicles Usage</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"VEHICLES_USAGE.FILTERS.CLEAR\">Clear filters</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-vehicles\" ms-scroll><md-list><div class=\"filter-subtitle\"><span \ntranslate=\"VEHICLES_USAGE.FILTERS.NAME\">Search by name</span></div><md-list-item><input flex \nplaceholder=\"Search by name\" translate translate-attr-placeholder=\"VEHICLES_USAGE.FILTERS.NAME\" type=\"text\" \nclass=\"pl-10 h-35 search-input\" ng-model=\"vm.vehiclesUsageFilters.name\" ng-change=\"vm.broadcastFilterUpdated();\">\n</md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"VEHICLES_USAGE.FILTERS.LICENSE_PLATE\">Search by license plate</span></div><md-list-item><input flex \nplaceholder=\"Search by license plate\" translate translate-attr-placeholder=\"VEHICLES_USAGE.FILTERS.LICENSE_PLATE\" \ntype=\"text\" class=\"pl-10 h-35 search-input\" ng-model=\"vm.vehiclesUsageFilters.licensePlate\" \nng-change=\"vm.broadcastFilterUpdated();\"></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"VEHICLES_USAGE.FILTERS.PICK_UP_DATE\">Filter by pickup date</span></div><md-list-item \nclass=\"w-100-percent mt-0 mb-0\"><label translate=\"VEHICLES_USAGE.FILTERS.FROM\">From:</label><md-datepicker \nng-change=\"vm.broadcastFilterUpdated(\'pickupAtGte\');\" ng-model=\"vm.vehiclesUsageFilters.pickupAtGte\" \nmd-placeholder=\"{{ \'VEHICLES_USAGE.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item><md-list-item \nclass=\"w-100-percent mt-0 mb-0\"><label translate=\"VEHICLES_USAGE.FILTERS.TO\">To:</label><md-datepicker \nng-change=\"vm.broadcastFilterUpdated(\'pickupAtLte\');\" ng-model=\"vm.vehiclesUsageFilters.pickupAtLte\" \nmd-placeholder=\"{{ \'VEHICLES_USAGE.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\"><span translate=\"VEHICLES_USAGE.FILTERS.RETURN_DATE\">Filter by return date\n</span></div><md-list-item class=\"w-100-percent mt-0 mb-0\"><label translate=\"VEHICLES_USAGE.FILTERS.FROM\">From:</label>\n<md-datepicker ng-change=\"vm.broadcastFilterUpdated(\'returnedAtGte\');\" \nng-model=\"vm.vehiclesUsageFilters.returnedAtGte\" md-placeholder=\"{{ \'VEHICLES_USAGE.SELECT_DATE\' | translate }}\">\n</md-datepicker></md-list-item><md-list-item class=\"w-100-percent mt-0 mb-0\"><label \ntranslate=\"VEHICLES_USAGE.FILTERS.TO\">To:</label><md-datepicker \nng-change=\"vm.broadcastFilterUpdated(\'returnedAtLte\');\" ng-model=\"vm.vehiclesUsageFilters.returnedAtLte\" \nmd-placeholder=\"{{ \'VEHICLES_USAGE.SELECT_DATE\' | translate }}\"></md-datepicker></md-list-item><md-divider>\n</md-divider><div class=\"filter-subtitle\"><span translate=\"VEHICLES_USAGE.FILTERS.TYPE\">Filter by type</span></div>\n<md-list-item><md-select class=\"w-100-percent mt-0 mb-0\" name=\"type\" ng-change=\"vm.broadcastFilterUpdated(\'type\')\" \nng-model=\"vm.vehiclesUsageFilters.type\"><md-option value=\"null\"><span translate=\"VEHICLES_USAGE.MODEL.ALL\">All</span>\n</md-option><md-option value=\"car\"><span translate=\"VEHICLES_USAGE.MODEL.TYPES_OPTIONS.CAR\">Car</span></md-option>\n<md-option value=\"motorcycle\"><span translate=\"VEHICLES_USAGE.MODEL.TYPES_OPTIONS.MOTORCYCLE\">Motorcycle</span>\n</md-option><md-option value=\"nautical\"><span translate=\"VEHICLES_USAGE.MODEL.TYPES_OPTIONS.NAUTICAL\">Nautical</span>\n</md-option><md-option value=\"truck\"><span translate=\"VEHICLES_USAGE.MODEL.TYPES_OPTIONS.TRUCK\">Truck</span>\n</md-option><md-option value=\"semi_truck\"><span translate=\"VEHICLES_USAGE.MODEL.TYPES_OPTIONS.SEMI_TRUCK\">Semi Truck\n</span></md-option></md-select></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"VEHICLES_USAGE.FILTERS.ORIGIN\">Filter by origin</span></div><md-list-item><md-select \nclass=\"w-100-percent mt-0 mb-0\" name=\"origin\" ng-change=\"vm.broadcastFilterUpdated(\'origin\')\" \nng-model=\"vm.vehiclesUsageFilters.origin\"><md-option value=\"null\"><span translate=\"VEHICLES_USAGE.MODEL.ALL\">All</span>\n</md-option><md-option value=\"rented\"><span translate=\"VEHICLES_USAGE.MODEL.ORIGINS_OPTIONS.RENTED\">Rented</span>\n</md-option><md-option value=\"company\"><span translate=\"VEHICLES_USAGE.MODEL.ORIGINS_OPTIONS.COMPANY\">Company</span>\n</md-option><md-option value=\"employee\"><span translate=\"VEHICLES_USAGE.MODEL.ORIGINS_OPTIONS.EMPLOYEE\">Employee</span>\n</md-option></md-select></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"VEHICLES_USAGE.FILTERS.EMPLOYEE_OR_USER\">Filter by employee or user</span></div><md-list-item><md-select \nclass=\"w-100-percent mt-0 mb-0\" name=\"employeeId\" \nng-change=\"vm.broadcastFilterUpdated(vm.filterId.isEmployee ? \'employeeId\' : \'userId\')\" ng-model=\"vm.filterId\" \ndata-cy=\"vehicle-usage-filter-by-user-or-employee\"><md-option value=\"null\"><span translate=\"VEHICLES_USAGE.MODEL.ALL\">\nAll</span></md-option><md-option data-cy=\"vehicle-usage-select-item\" \nng-value=\"{ id: person.id, isEmployee: person.isEmployee }\" ng-repeat=\"person in vm.options\"><span>{{person.name}}\n</span> <span style=\"color: #757575\" ng-if=\"person.isEmployee\" translate=\"VEHICLES_USAGE.DIALOG.EMPLOYEE\">(Colaborador)\n</span> <span style=\"color: #757575\" ng-if=\"!person.isEmployee\" translate=\"VEHICLES_USAGE.DIALOG.USER\">(Usuário)</span>\n</md-option></md-select></md-list-item><md-divider></md-divider><div class=\"filter-subtitle\"><span \ntranslate=\"VEHICLES_USAGE.FILTERS.SITUATION\">Filter by situation</span></div><md-list-item><md-select \nclass=\"w-100-percent mt-0 mb-0\" name=\"archived\" ng-change=\"vm.broadcastFilterUpdated(\'archived\')\" \nng-model=\"vm.vehiclesUsageFilters.archived\"><md-option value=\"null\"><span translate=\"VEHICLES_USAGE.MODEL.ALL\">All\n</span></md-option><md-option value=\"false\"><span translate=\"VEHICLES_USAGE.MODEL.ARCHIVED_OPTIONS.UNARCHIVED\">Active\n</span></md-option><md-option value=\"true\"><span translate=\"VEHICLES_USAGE.MODEL.ARCHIVED_OPTIONS.ARCHIVED\">Inactive\n</span></md-option></md-select></md-list-item></md-list></md-content>");
$templateCache.put("app/main/work-services/dialogs/omie-manual-import/omie-manual-import-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--large task-dialog\"><md-toolbar \nclass=\"sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\"><span class=\"title\" \ntranslate=\"WORK_SERVICES.IMPORT.TITLE\" translate-value-app=\"Omie\">Import services from Omie</span></div><div \nclass=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"import-services\" ms-scroll><div layout=\"column\" \nclass=\"import-services__search-bar\"><div class=\"search-bar\" layout=\"row\" flex=\"100\"><div class=\"fc-input\" flex=\"100\">\n<input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" \nng-model=\"vm.nameContains\" ng-change=\"vm.onSearchChange()\" ng-model-options=\"{ debounce: 500 }\" ng-disabled=\"false\">\n<label class=\"fc-input__label\" translate=\"TASKS.DIALOG.TABS.SERVICES.SEARCH_SERVICE\">Search for an service</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></div></div><small class=\"search-bar__hint mt-5\" \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.SEARCH_BY_NAME\">Search by name</small></div><div layout=\"column\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"space-between center\" class=\"import-services__header\"><div><span \nclass=\"import-services__header__title\" flex=\"20\">\n{{ \'WORK_SERVICES.IMPORT.FOUND_SERVICES\' | translate }} ({{vm.totalCount}})</span></div></div><div \nng-if=\"$root.loadingProgress && vm.isLoadingServices\" class=\"loading-gantt-tasks\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div><div ng-repeat=\"service in vm.allServices\" layout-xs=\"column\" layout=\"row\" flex=\"100\" \nng-if=\"vm.totalCount && !vm.isLoadingServices\" class=\"b brad-4 mb-10 import-services__item\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h-70 w-70 brad-4 ml-20\" \nng-if=\"service.imageUrl\"><img ng-src=\"{{ service.imageUrl | mumakil }}\" alt=\"{{ service.name }}\" \nclass=\"import-services__image\"></div><div layout=\"row\" class=\"border h-70 w-70 brad-4 ml-20\" \nlayout-align=\"center center\" ng-if=\"!service.imageUrl\"><img src=\"assets/icons/no-image_gray.svg\"></div><div flex=\"80\" \nclass=\"ph-24 import-services__service\"><span class=\"import-services__service__title\">{{ service.name }}</span> <span>\nR${{ vm.parseValueToPrice(service.value) }}</span></div></div><div class=\"import-services__import ph-10\"><md-icon \nng-if=\"service.selected\" md-svg-src=\"/assets/icons/icon-imported-success.svg\"></md-icon><md-button \nclass=\"import-services__import__action\" ng-if=\"!service.selected && service.integrationId && service.updating\" \nng-click=\"vm.updateService(service)\">{{ \'CORE.SUBSCRIPTION_DIALOG.UPDATE\' | translate }}</md-button><md-button \nclass=\"import-services__import__action\" ng-hide=\"service.integrationId && service.updating\" ng-if=\"!service.selected\" \nng-click=\"vm.importService(service)\">{{ \'CUSTOMERS.INTEGRATIONS.IMPORT\' | translate }}</md-button></div></div></div>\n<div class=\"import-services__table-navigation\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"import-services__table-navigation__info\" id=\"table-list_info\" aria-live=\"polite\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((vm.currentPage - 1) * vm.limitPerPage) + 1 }} <span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.TO\">to\n</span> {{ vm.currentPage * vm.limitPerPage > vm.totalCount ? vm.totalCount : vm.currentPage * vm.limitPerPage }} <span\n translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.OF\">of</span> {{ vm.totalCount }} <span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.RECORDS\">records</span></div><button \nclass=\"import-services__table-navigation__button-previous\" ng-click=\"vm.navigateToPage(false)\" \nng-disabled=\"vm.currentPage === 1 || ($root.loadingProgress || vm.isLoadingServices)\"><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.PREVIOUS\">Previous</span></button> <button \nclass=\"import-services__table-navigation__button-next\" ng-click=\"vm.navigateToPage(true)\" \nng-disabled=\"vm.currentPage * vm.limitPerPage >= vm.totalCount || ($root.loadingProgress || vm.isLoadingServices)\">\n<span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.NAVIGATION.NEXT\">Next</span></button></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/work-services/dialogs/work-services/services-dialog.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large services-dialog\" id=\"services-dialog\" \naria-label=\"Services dialog\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__title ml-10i\" layout=\"row\" layout-align=\"space-between\"><span ng-show=\"!vm.service.id\" \nclass=\"title\" translate=\"WORK_SERVICES.DIALOG.NEW.TITLE\">New service</span> <span ng-show=\"vm.service.id\" \nclass=\"title\" translate=\"WORK_SERVICES.DIALOG.EDIT.TITLE\">Edit service</span></div><div \nclass=\"sidebar-dialog__actions\"><md-button data-cy=\"close-dialog-button\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\" aria-label=\"Close\" translate translate-attr-aria-label=\"WORK_SERVICES.DIALOG.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"workServiceForm\" \nclass=\"md-inline-form\" novalidate><div ng-hide=\"vm.service.locked\" class=\"fc-warning-container\"><md-icon \nclass=\"warning-icon\" md-svg-src=\"/assets/icons/icon-alert.svg\"></md-icon><span \ntranslate=\"WORK_SERVICES.DIALOG.SERVICE_ALERT\"></span></div><corporate-customer-disclaimer \nng-if=\"vm.service.metadata && vm.service.metadata.sammathnaur\" \ncustomer-name=\"vm.service.metadata.sammathnaur.account.name\"></corporate-customer-disclaimer><div \nclass=\"omie-declaration-product-container\" ng-if=\"vm.omieAccount\"><md-icon \nmd-svg-src=\"assets/icons/icon-omie-active.svg\" class=\"omie-declaration-product-icon\"><md-tooltip md-direction=\"top\">\n<span>Omie</span></md-tooltip></md-icon><p translate=\"WORK_SERVICES.IMPORT.FROM\" class=\"omie-declaration-product-text\" \ntranslate-values=\"{ account: vm.omieAccount }\">Service imported from</p></div><md-dialog-content ms-scroll \nclass=\"pt-20\"><div layout-xs=\"column\" layout=\"row\" class=\"mt-0 services-input-container\"><div layout=\"row\">\n<fc-image-input class=\"fc-image-input__image-container--change-border-color\" ng-disabled=\"vm.service.locked\" \nname=\"imageUrl\" input-control=\"workServiceForm.imageUrl\" ng-model=\"vm.service.imageUrl\" \nimage-file=\"vm.serviceResultImageFile\" img-custom-class=\"services-image\" \nng-class=\"{\n              \'img-service-disabled\': vm.service.locked\n            }\" height=\"120px\" width=\"120px\">\n</fc-image-input><div class=\"insert-picture\"><md-button data-cy=\"insert-picture-button\" class=\"insert-picture-button\" \nng-disabled=\"vm.serviceResultImageFile || vm.service.imageUrl || vm.service.locked\" ng-click=\"vm.selectImage()\" \ntranslate=\"WORK_SERVICES.DIALOG.SELECT_IMAGES\">Selecionar imagens</md-button><div \nclass=\"customer-dialog__general-tab__avatar-description ml-20\"><p>\n{{(\'WORK_SERVICES.DIALOG.IMAGE_INFORMATION\' | translate)}}</p></div></div></div></div><div class=\"inputs-container\">\n<div flex=\"65\"><div class=\"fc-input\"><input data-cy=\"field.name\" type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"name\" ng-model=\"vm.service.name\" ng-disabled=\"vm.service.locked\" ng-maxlength=\"150\" \nng-class=\"{\n                invalid: workServiceForm.name.$touched && workServiceForm.name.$invalid,\n                \'input-service-locked\': vm.service.locked\n              }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'WORK_SERVICES.MODEL.NAME\' | translate)}}</label><fc-error \nng-show=\"workServiceForm.name.$touched\" input-errors=\"workServiceForm.name.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'WORK_SERVICES.MODEL.ERRORS.FIELD_REQUIRED\'\n                },\n                {\n                  name: \'maxlength\',\n                  translate: \'WORK_SERVICES.MODEL.ERRORS.MAX_LENGTH\',\n                  translateValues: { expectedLength: 150, receivedLength: workServiceForm.name.$viewValue.length }\n                },\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"35\"><div class=\"fc-input\"><input \ndata-cy=\"field.value\" type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"value\" \nng-model=\"vm.service.value\" ng-disabled=\"vm.service.locked\" min=\"0.00\" ui-money-mask \nng-class=\"{\n                invalid: workServiceForm.value.$touched && workServiceForm.value.$invalid,\n                \'input-service-locked\': vm.service.locked\n              }\" \nng-required=\"true\"><label class=\"fc-input__label\" translate=\"WORK_SERVICES.MODEL.VALUE\" \ntranslate-values=\"{ currency: vm.currencySymbol }\"></label><fc-error ng-show=\"workServiceForm.value.$touched\" \ninput-errors=\"workServiceForm.value.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'WORK_SERVICES.MODEL.ERRORS.FIELD_REQUIRED\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div layout-xs=\"column\" layout=\"row\" class=\"mt-24\">\n<div flex=\"100\"><fc-smart-rewrite reference-id=\"vm.service.id || vm.sessionId\" \nreference-type=\"product-service-description\" disabled=\"vm.service.locked\"><fc-textarea data-cy=\"textarea-description\" \nclass=\"fc-textarea__textarea--change-border-color\" is-disabled=\"vm.service.locked\" \nlabel=\"{{(\'WORK_SERVICES.MODEL.DESCRIPTION\' | translate)}}\" ng-model=\"vm.service.description\" input-name=\"description\" \ninput-control=\"workServiceForm.description\" \nng-class=\"{\n                \'input-service-locked\': vm.service.locked\n              }\" max-length=\"2000\" \nerrors-to-watch=\"[\n                {\n                  name: \'maxlength\',\n                  translate: \'WORK_SERVICES.MODEL.ERRORS.MAX_LENGTH\',\n                  translateValues: { expectedLength: 2000, receivedLength: workServiceForm.description.$viewValue.length }\n                },\n              ]\">\n</fc-textarea></fc-smart-rewrite></div></div></md-dialog-content><md-dialog-actions \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><button data-cy=\"save-button\" \nclass=\"fc-button fc-button--actions\" type=\"submit\" ng-if=\"!vm.newService\" \nng-class=\"{disabled: workServiceForm.$invalid || workServiceForm.$pristine || $root.loadingProgress === true}\" \nng-click=\"vm.saveService()\" \nng-disabled=\"workServiceForm.$invalid || workServiceForm.$pristine || $root.loadingProgress === true || vm.service.locked\" \naria-label=\"Save\" translate=\"WORK_SERVICES.DIALOG.ACTIONS.SAVE\" \ntranslate-attr-aria-label=\"WORK_SERVICES.DIALOG.ACTIONS.SAVE\">Save</button> <button data-cy=\"create-button\" \nclass=\"fc-button fc-button--actions\" type=\"submit\" ng-if=\"vm.newService\" \nng-class=\"{disabled: workServiceForm.$invalid || workServiceForm.$pristine || $root.loadingProgress === true}\" \nng-click=\"vm.saveService()\" \nng-disabled=\"workServiceForm.$invalid || workServiceForm.$pristine || $root.loadingProgress === true || vm.service.locked\" \naria-label=\"Add Plan Type\" translate=\"WORK_SERVICES.DIALOG.ACTIONS.CREATE\" \ntranslate-attr-aria-label=\"WORK_SERVICES.DIALOG.ACTIONS.CREATE\">Create</button></div><div layout=\"row\" \nng-if=\"vm.service.id && vm.from !== \'quotations\'\"><md-button data-cy=\"archive-button\" ng-show=\"!vm.service.archived\" \nclass=\"md-icon-button\" ng-click=\"vm.archiveService($event)\" aria-label=\"Archive\" translate \nng-disabled=\"vm.service.locked\" translate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-download\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"PLANSTYPES.DIALOG.ACTIONS.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button \nng-show=\"vm.service.archived\" class=\"md-icon-button\" ng-click=\"vm.unarchiveService($event)\" aria-label=\"Unarchive\" \ntranslate ng-disabled=\"vm.service.locked\" translate-attr-aria-label=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\"><md-icon \nmd-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip md-direction=\"top\"><span \ntranslate=\"PLANSTYPES.DIALOG.ACTIONS.UNARCHIVE\">Unarchive</span></md-tooltip></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/work-services/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title text-left\" \ntranslate=\"WORK_SERVICES.FILTERS.TITLE\">Filter Services</span><md-button ng-if=\"vm.serviceFilters.isOn()\" \nng-click=\"vm.serviceFilters.clear()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"WORK_SERVICES.FILTERS.CLEAR\">Clear</span></md-tooltip></md-button></div></md-toolbar><md-content \nclass=\"animate-slide-right filter-equipments\" ms-scroll><div class=\"fc-input margin-0-auto mt-10 divider-margin\" \nflex=\"90\"><input data-cy=\"locations-filters.name\" type=\"text\" placeholder=\" \" class=\"fc-input__input\" \nautocomplete=\"off\" ng-model=\"vm.serviceFilters.name\" ng-change=\"vm.broadcastFilterUpdated();\"><label \nclass=\"fc-input__label\">{{(\'WORK_SERVICES.FILTERS.NAME\' | translate)}}</label></div><div \nclass=\"fc-input margin-0-auto mt-10 divider-margin\" flex=\"90\"><input data-cy=\"locations-filters.name\" type=\"text\" \nplaceholder=\" \" class=\"fc-input__input\" autocomplete=\"off\" ng-model=\"vm.serviceFilters.description\" \nng-change=\"vm.broadcastFilterUpdated();\"><label class=\"fc-input__label\">\n{{(\'WORK_SERVICES.FILTERS.DESCRIPTION\' | translate)}}</label></div><div class=\"margin-0-auto divider-margin\" flex=\"90\" \nstyle=\"margin-bottom: 60px\"><fc-select label=\"{{(\'WORK_SERVICES.FILTERS.SITUATIONS.TITLE\' | translate)}}\" \noptions=\"vm.statusOptions\" ng-model=\"vm.statusFilterValue\" track-by=\"label\" \nng-change=\"vm.broadcastFilterUpdated(\'archived\');\" is-required=\"true\"></fc-select></div></md-content>");
$templateCache.put("app/main/work-services/sidenavs/import-modal/import-products-services-modal.html","<div><p class=\"fc-modal__content\">{{vm.variables.title}}</p><div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{ vm.variables.progressPercentage }}\"></md-progress-linear><div layout=\"column\" layout-align=\"flex-end\"><p \nclass=\"fs-16 flex-end\">{{ vm.variables.totalServicesImported || \'0\' }} <span \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_FROM\">from</span> {{ vm.variables.totalServicesToImport }}\n</p></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div ng-if=\"card.media\" class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-11/template-11.html","<div class=\"template-11 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle\" ng-if=\"card.subtitle\" \nstyle=\"color: {{card.subtitleColor}}\">{{card.subtitle}}</div></div><div ng-if=\"card.media\" class=\"media ml-16\"><img \nclass=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"><md-tooltip \nmd-direction=\"bottom\">{{card.media.image.alt}}</md-tooltip></div></div><div class=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-12/template-12.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle\" ng-if=\"card.subtitle\" \nstyle=\"color: {{card.subtitleColor}}\">{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" \nng-if=\"card.text\" ng-bind-html=\"card.text\"></div><div class=\"media\" ng-if=\"card.map && card.map.id\"><leaflet \nid=\"{{card.map.id}}\" markers=\"card.map.markers\" bounds=\"card.map.bounds\" paths=\"card.map.paths\" \ndefaults=\"card.map.defaults\" height=\"200px\" width=\"100%\"></leaflet></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-13/template-13.html","<div class=\"template-13\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.emotion\" \nstyle=\"margin-right: 10px\"><i ng-class=\"card.emotion\" style=\"color: {{card.color}}\" class=\"icon s40\"></i></div><div \nclass=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle text-center\" \nng-if=\"card.stars\"><i style=\"color: {{card.color}}\" ng-class=\"card.stars >= 1 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20\"></i> <i style=\"color: {{card.color}}\" ng-class=\"card.stars >= 2 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20\"></i> <i style=\"color: {{card.color}}\" ng-class=\"card.stars >= 3 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20\"></i> <i style=\"color: {{card.color}}\" ng-class=\"card.stars >= 4 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20\"></i> <i style=\"color: {{card.color}}\" ng-class=\"card.stars >= 5 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20\"></i></div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\" ng-if=\"card.media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-14/template-14.html","<div class=\"template-14\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\">\n<img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nlayout=\"row\"><div flex=\"70\" class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div flex=\"30\" class=\"created-at\" \nng-if=\"card.createdAt\">{{card.createdAt}}</div></div><div layout=\"row\"><div class=\"subtitle\" ng-if=\"card.subtitle\" \nstyle=\"color: {{card.subtitleColor}}\">{{card.subtitle}}</div></div></div></div><div class=\"text ph-16 pb-16\" \nng-if=\"card.text\" ng-bind-html=\"card.text\"></div><div><md-button class=\"show-button\" ng-click=\"closeDialog();\" \nng-href=\"#/atividades?q=numero:{{ card.identifier }}\">Vizualizar visita</md-button></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\" ng-if=\"card.media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"><md-tooltip \nmd-direction=\"bottom\">{{card.media.image.alt}}</md-tooltip></div><div class=\"text p-16\" ng-if=\"card.text\" \nng-bind-html=\"card.text\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\" translate=\"CORE.MS_STEPPER.OPTIONAL\">Optional</div></div></md-button>\n</div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\"><span translate=\"CORE.MS_STEPPER.BACK\">Back</span></md-button><div \nclass=\"ms-stepper-dots\"><span ng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\"><span \ntranslate=\"CORE.MS_STEPPER.NEXT\">Next</span></md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\"><span \ntranslate=\"CORE.MS_STEPPER.SUBMIT\">Submit</span></md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/control-panel/dialogs/route-optimizer/templates/configuration.html","<div layout=\"column\" ng-cloak=\"\" class=\"toolbardemoScrollShrink height-100p\"><md-content class=\"height-100p\" flex \nlayout-padding layout=\"column\" layout-align=\"center center\" ng-show=\"vm.employeeScheduledTasks.length <= 2\"><span \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.INSULFICIENT_TASKS_ERROR\">\nEmployee must have more than 2 scheduled activities in order to proceed</span></md-content><md-content flex \nlayout-padding ng-show=\"vm.employeeScheduledTasks.length > 2 && !vm.taskGeolocationError\" class=\"height-100p\"><div \nlayout-padding class=\"height-100p\"><h3 class=\"configuration-block-title\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.ROUTE\">Route</h3><div layout=\"row\" \nlayout-align=\"space-between center\"><md-radio-group ng-model=\"vm.selectedRouteType\"><md-radio-button \nvalue=\"{{routeType.id}}\" ng-repeat=\"routeType in vm.routeTypes\" ng-click=\"vm.selectedRouteType = routeType\">\n{{routeType.name}} <span class=\"radio-button-description\">{{routeType.description}}</span></md-radio-button>\n</md-radio-group></div><md-divider></md-divider><h3 class=\"configuration-block-title\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.VEHICLE\">Vehicle</h3><div layout=\"row\" \nlayout-align=\"space-between center\"><md-radio-group ng-model=\"vm.selectedTravelMode\"><md-radio-button \nvalue=\"{{travelMode.id}}\" ng-repeat=\"travelMode in vm.TravelModes\" ng-click=\"vm.selectedTravelMode = travelMode\">\n{{travelMode.name}}</md-radio-button></md-radio-group></div><md-divider></md-divider><h3 \nclass=\"configuration-block-title\" translate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.INITIAL_DESTINATION\">\nInitial destination</h3><div layout=\"row\" layout-align=\"space-between center\" class=\"destination-block\"><md-radio-group\n ng-model=\"vm.selectedInitialDestination\"><md-radio-button value=\"{{initialDestination.id}}\" \nng-repeat=\"initialDestination in vm.initialDestinations\" ng-click=\"vm.selectedInitialDestination = initialDestination\">\n{{initialDestination.name}} <span class=\"address\" \nng-if=\"initialDestination.id == \'last_localization\' && vm.employeeLastLocalizationAddress\">\n({{vm.employeeLastLocalizationAddress}})</span> <span class=\"address\" ng-if=\"initialDestination.id == \'company\'\">\n({{vm.companyAddress}})</span> <span class=\"address\" \nng-if=\"initialDestination.id == \'home\' && vm.selectedEmployeeAddress\">({{vm.selectedEmployeeAddress}})</span> <span \nclass=\"radio-button-description\">{{initialDestination.description}}</span></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><h3 class=\"configuration-block-title\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.FINAL_DESTINATION\">Final destination</h3><div \nlayout=\"column\" layout-align=\"space-between start\" class=\"destination-block\"><md-radio-group \nng-model=\"vm.selectedFinalDestination\" ng-change=\"vm.selectedFinalDestinationChanged()\"><md-radio-button \nvalue=\"{{finalDestination.id}}\" ng-repeat=\"finalDestination in vm.finalDestinations\" \nng-click=\"vm.selectedFinalDestination = finalDestination\">{{finalDestination.name}} <span class=\"address\" \nng-if=\"finalDestination.id == \'company\'\">({{vm.companyAddress}})</span> <span class=\"address\" \nng-if=\"finalDestination.id == \'home\' && vm.selectedEmployeeAddress\">({{vm.selectedEmployeeAddress}})</span> <span \nclass=\"address\" ng-if=\"finalDestination.id == \'custom\' && vm.customEndLocationAddress\">\n({{vm.customEndLocationAddress}})</span> <span class=\"radio-button-description\">{{finalDestination.description}}</span>\n</md-radio-button></md-radio-group><div ng-if=\"vm.selectedFinalDestination === \'custom\'\" \nclass=\"search-custom-location\"><fc-autocomplete is-required=\"true\" \nlabel=\"{{ \'CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.ADDRESS\' | translate }}\" options=\"vm.locations\" \nng-model=\"vm.customEndLocation\" ng-change=\"vm.selectedCustomEndLocationChanged()\" \nsearch-term=\"vm.selectedEndLocationText\" track-by=\"formattedAddress\" debounce=\"800\" \nsearch-function=\"vm.searchCustomEndLocation()\"></fc-autocomplete></div></div><md-divider></md-divider><div \nlayout=\"row\" layout-align=\"space-between center\"><md-checkbox \ntranslate-attr-aria-label=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.CONSIDER_TRAFFIC\" \naria-label=\"Consider traffic\" ng-model=\"vm.considerTraffic\"><span \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.CONSIDER_TRAFFIC\">Consider traffic </span><span \nclass=\"checkbox-button-description\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.CONFIGURATION.CONSIDER_TRAFFIC_DESCRIPTION\">\nIf enabled, route routing will take traffic information into account</span></md-checkbox></div></div></md-content>\n</div>");
$templateCache.put("app/main/control-panel/dialogs/route-optimizer/templates/employees-selection.html","<div layout=\"column\" ng-cloak=\"\" class=\"toolbardemoScrollShrink height-100p\"><md-content flex class=\"height-100p\"><div \nclass=\"router-options\"><md-icon md-font-icon=\"icon-account-search\" class=\"custom-search-icon\"></md-icon>\n<md-input-container md-no-float class=\"md-block\"><input ng-model=\"vm.employeeSearch\" type=\"text\" \nclass=\"custom-search-input\" translate \ntranslate-attr-placeholder=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.SEARCH.EMPLOYEE_NAME_PLACEHOLDER\" placeholder=\"Name\">\n</md-input-container></div><div class=\"router-advanced\" \nng-if=\"(!vm.hideRouteOptimizationUpdate || vm.hideRouteOptimizationUpdate !== \'true\')\"><div \nclass=\"router-advanced-div\"><span><md-icon class=\"isights-icon\" md-svg-src=\"assets/icons/icon-insights.svg\"></md-icon>\n</span><p class=\"router-text\" translate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.MODULE_UPDATE.TEXT\">\nYou wish to hire the module for your business</p><div ng-click=\"vm.openModuleInfoElement()\" class=\"load-more-button\">\n<span class=\"hire-text\" translate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.MODULE_UPDATE.KNOW_MORE\"></span></div><div \nng-click=\"vm.openAdvancedRouteOptimizationHireDialog()\" class=\"upgrade-button\"><span class=\"hire-text\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.MODULE_UPDATE.UPGRADE\"></span></div><md-button \nclass=\"md-icon-button closing-icon\" aria-label=\"Dont show again\" ng-click=\"vm.dontShowAgain()\" translate \ntranslate-attr-aria-label=\"MODULES.DIALOGS.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></div>\n<md-list><md-radio-group ng-model=\"vm.selectedEmployee\"><md-list-item class=\"md-2-line\" \nng-repeat=\"employee in vm.employees | filter: {name: vm.employeeSearch}\" ng-click=\"vm.selectedEmployee = employee\">\n<md-radio-button ng-value=\"employee\" aria-label=\"{{employee.name}}\"></md-radio-button><img class=\"md-avatar\" \nalt=\"{{employee.name}}\" ng-src=\"{{employee.avatarUrl || \'./assets/images/avatars/profile.jpg\'}}\"><div \nclass=\"md-list-item-text\"><h3>{{employee.name}}</h3></div></md-list-item></md-radio-group></md-list></md-content></div>");
$templateCache.put("app/main/control-panel/dialogs/route-optimizer/templates/map.html","<div layout=\"column\" class=\"map height-100p\"><md-content flex layout-padding layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.routerizationApiError\" class=\"height-100p\">{{ vm.routerizationApiErrorMessage }}\n</md-content><md-content flex ng-if=\"!vm.routerizationApiError\" class=\"height-100p map__content\"><div layout=\"row\" \nclass=\"map-container\" ng-if=\"vm.loadingMap && !vm.routerizationApiError\"><md-progress-circular md-diameter=\"80\">\n</md-progress-circular></div><leaflet ng-if=\"vm.showMap && !vm.routerizationApiError\" id=\"routerOptizerMap\" \nmarkers=\"vm.map.markers\" paths=\"vm.map.paths\" decorations=\"vm.map.decorations\" controls=\"vm.map.controls\" \nlayers=\"vm.map.layers\" width=\"100%\" height=\"100%\"></leaflet></md-content><md-content><div class=\"map__description\" \nflex layout=\"row\" layout-align=\"space-between center\"><div><p><span \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.CLICK_ON_THE_BUTTON\">Clique no botão </span><img \nsrc=\"assets/icons/icon-map-zoom.svg\"> <span translate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.VIEW_THE_MAP_FULL_SCREEN\">\npara ver o mapa em tela cheia</span></p></div><div \nclass=\"map-kilometers map-kilometers--no-width map-kilometers--no-border-top\"><span class=\"map-kilometers__text\" \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.ROUTE_MILAGE.TEXT\">Total mileage of the route: </span><span \nclass=\"map-kilometers__km\">{{ vm.totalMilageRoute }} km</span></div></div></md-content></div>");
$templateCache.put("app/main/control-panel/views/gantt/override/tooltip.tmpl.html","<div ng-cloak class=\"gantt-task-info\" ng-show=\"displayed\" style=\"z-index: 999 !important\" \nng-class=\"isRightAligned ? \'gantt-task-infoArrowR\' : \'gantt-task-infoArrow\'\" \nng-style=\"{ \'top\' : (taskRect.top - elementHeight - 6) }\"><div class=\"gantt-task-info-content\"><div \nng-if=\"task.model.type == \'task\'\"><i class=\"icon icon-clipboard-text s12 md-accent-fg\"></i> {{task.model.identifier}}\n</div><div><i class=\"icon icon-account s12 md-accent-fg\"></i> {{task.model.name}}</div><div \nng-if=\"task.model.type == \'task\'\"><i class=\"icon icon-tag s12 md-accent-fg\"></i> {{task.model.serviceName}}</div><div>\n<i class=\"icon icon-clock s12 md-accent-fg\"></i>\n {{task.isMilestone() === true && getFromLabel() || getFromLabel() + \' - \' + getToLabel()}}</div><div \nng-if=\"task.model.type == \'task\'\"><i class=\"icon icon-map-marker s12 md-accent-fg\"></i> {{task.model.orderAddress}}\n</div></div></div>");
$templateCache.put("app/main/customers/dialogs/tabs/attachments/attachments-tab.html","<corporate-customer-disclaimer ng-if=\"vm.customer.locked && vm.customer.metadata.sammathnaur\" \ncustomer-name=\"vm.customer.metadata.sammathnaur.account.name\" \ncustom-class=\"customer-dialog__corporate-customer-disclaimer\"></corporate-customer-disclaimer><div \nng-if=\"!(vm.customer.locked && vm.customer.metadata.sammathnaur)\" layout=\"row\" layout-align=\"center center\" \nclass=\"warning\"><md-icon md-svg-src=\"assets/icons/icon-question-circle.svg\"></md-icon><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.ATTACHMENT_DESCRIPTION\">\nLimit of 20 attachments. Maximum size of 10MB per attachment.</span></div><main \nclass=\"customer-dialog__attachments-tab\"><div ng-if=\"!(vm.customer.locked && vm.customer.metadata.sammathnaur)\" \nclass=\"drop-box\" ng-class=\"{\'has-images\': vm.files.length > 0 }\" layout=\"row\" layout-align=\"center\" \nng-model=\"vm.files\" name=\"files\" ngf-allow-dir=\"true\" ngf-multiple=\"true\" ngf-drop \nngf-max-files=\"vm.maxAttachments - vm.attachments.length\" \nngf-accept=\"\'.jpg,.jpeg,.JPG,.JPEG,.kml,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nngf-pattern=\"\'.jpg,.jpeg,.JPG,.JPEG,.kml,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nngf-validate-fn=\"vm.validateImage($file)\"><div layout=\"column\" layout-align=\"center\" class=\"upload-warn\"><div \nlayout=\"column\" class=\"upload-warn__sentence-container\" layout-align=\"center center\"><div layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.maxAttachments - vm.attachments.length <= 0\"><md-icon \nmd-svg-src=\"assets/icons/icon-service-error.svg\"></md-icon><span style=\"margin-top: 14px\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.ATTACHMENTS_LIMIT_REACHED\">\nAttachments limit reached to add more attachments you need to remove some first.</span></div><div \nng-if=\"vm.files.length < 1 && vm.maxAttachments - vm.attachments.length > 0\"><md-icon \nmd-svg-src=\"assets/icons/icon-upload.svg\"></md-icon><span class=\"upload-warn__sentence-container__phrase\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.DROP_HERE\" layout-align=\"center center\" layout=\"column\">\nDrag your files to upload</span></div><div class=\"upload-warn__sentence-container__actions-buttons-container\" \nng-if=\"vm.attachments.length < vm.maxAttachments\"><div><span \nclass=\"upload-warn__sentence-container__actions-buttons-container__phrase\" ng-if=\"vm.files.length\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.INSERT_FILES_ALTERNATIVE\">Drag your files to upload or</span>\n<md-button class=\"insert-attachments\" ngf-select ng-model=\"vm.files\" ngf-multiple=\"true\" \nngf-pattern=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nngf-max-files=\"{{vm.maxAttachments - vm.attachments.length}}\" ngf-allow-dir=\"true\" \nngf-accept=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nng-disabled=\"vm.files.length > 0\" ngf-validate-fn=\"vm.validateImage($file)\"><md-icon \nmd-svg-src=\"assets/icons/insert-attachments.svg\"></md-icon><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.INSERT_FILES\">Insert files</span></md-button></div><md-button \nclass=\"send-attachments\" ng-click=\"vm.uploadImages()\" aria-label=\"menu\" \nng-disabled=\"vm.uploadProgress || !vm.files || !vm.files.length || vm.maxAttachments - vm.files.length < 0\" \nng-if=\"vm.files && vm.files.length && vm.attachments && vm.attachments.length < vm.maxAttachments && !vm.uploadProgress\">\n<span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.SEND_FILES\">Save files</span></md-button></div></div></div>\n<md-progress-circular id=\"upload-progress\" ng-if=\"vm.uploadProgress\" class=\"md-accent mleft-10\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"wrapper-images-upload\" \nstyle=\"display: flex\" layout-align=\"center\" ng-if=\"!vm.uploadProgress\"><div class=\"wrapper-images-upload__file\" \nng-repeat=\"file in vm.files\"><md-icon class=\"remove-attachment-icon\" md-svg-src=\"assets/icons/icon-remove.svg\" \nng-click=\"vm.removeUploadedAttachment($index)\"></md-icon><img ng-if=\"vm.isFileTypeImage(file)\" ngf-thumbnail=\"file\" \nngf-size=\"{width: 100, height: 100, quality: 0.9}\"><div ng-if=\"!vm.isFileTypeImage(file)\" layout=\"row\" \nlayout-align=\"center center\" class=\"attachment-icon\"><md-icon md-font-icon=\"{{vm.getIconByFileType(file.type)}}\" \nclass=\"file-image-thumbnail\" ng-class=\"vm.getIconByFileType(file.type)\"></md-icon></div><br><span \nclass=\"name-file-text\">{{file.$error}} {{file.$errorParam}}</span></div></div></div><div \nng-if=\"!(vm.customer.locked && vm.customer.metadata.sammathnaur)\" ngf-no-file-drop \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.NOT_SUPPORTED_FILE_DRAG\">\nFile Drag/Drop is not supported for this browser</div><md-divider \nng-if=\"!(vm.customer.locked && vm.customer.metadata.sammathnaur)\"></md-divider><span class=\"attachments-limit\" \nng-class=\"{ \'red-text\': vm.attachments.length >= vm.maxAttachments }\"><span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.TITLE\">Attachments</span>\n ({{ vm.attachments.length }} / {{ vm.maxAttachments }})</span><div *ngf-thumbnail=\"file\" \nngf-size=\"{width: 20, height: 20, quality: 0.9}\" ngf-as-background=\"boolean\"></div><div \nng-if=\"!vm.attachments || !vm.attachments.length\"><p class=\"text-center\"><i class=\"icon-attachment s40\"></i><br><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.NO_ATTACHMENTS_ADDED\">No attachments have been added for this client.\n</span></p></div><div ng-if=\"vm.attachments.length > 0\" class=\"sections\"><div class=\"section\"><div class=\"attachments\">\n<div class=\"section-content\"><div ng-class=\"\'attachment\' + (attachment.archived ? \' archived\' : \'\')\" \nng-repeat=\"attachment in vm.attachments track by $index\" ng-switch=\"item.type\"><div layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"vm.isFileTypeImage(attachment)\" class=\"attachment-preview md-whiteframe-2dp\" \nng-style=\"{ \'background-image\': \'url({{ attachment.path }})\' }\"></div><div \nclass=\"attachment-preview md-whiteframe-2dp attachment-icon\" ng-if=\"!vm.isFileTypeImage(attachment)\"><md-icon \nclass=\"file-image\" ng-class=\"vm.getIconByFileType(attachment.type)\" \nmd-font-icon=\"{{vm.getIconByFileType(attachment.type)}}\"></md-icon></div><div class=\"attachment-content\" \nlayout=\"column\" flex=\"100\"><div layout=\"row\"><div layout=\"column\" flex=\"100\"><div class=\"attachment-name\" \nng-if=\"attachment.editing\"><div class=\"attachment-content-edit\" layout-align=\"space-between\"><input \nid=\"attachment_{{ attachment.id }}\" name=\"attachment_{{ attachment.id }}\" ng-model=\"attachment.title\" maxlength=\"80\" \ntype=\"text\" ng-keydown=\"vm.saveAttachmentWhenEnterKey($event, attachment);\"><div><md-icon \nclass=\"s20 clickable attachment-content__icon-check\" md-font-icon=\"icon-check\" \nng-click=\"vm.saveAttachmentTitle(attachment);\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.SAVE_TITLE\">Save title</span></md-tooltip></md-icon><md-icon \nclass=\"s20 clickable attachment-content__icon-close\" md-font-icon=\"icon-close\" \nng-click=\"vm.cancelEditAttachment(attachment);\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.CANCEL\">Cancel</span></md-tooltip></md-icon></div></div></div><div \nclass=\"attachment-name\" ng-if=\"!attachment.editing\"><span>\n{{ attachment.title || (\'CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.UNTITLED\' | translate) }}</span></div></div></div><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"60\"><span ng-if=\"attachment.metadata.createdAt\" \nclass=\"attachment-time attachments-content-metadata\"><span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.ADDED_AT\">\nAdded at</span> {{ attachment.metadata.createdAt | amDateFormat: vm.dateFormat }} <span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.AT\">at</span>\n {{ attachment.metadata.createdAt | amDateFormat: vm.timeFormat }} </span><span class=\"attachment-rename\" \nng-if=\"!(vm.customer.locked && vm.customer.metadata.sammathnaur)\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.EDIT_NAME\" ng-click=\"vm.editAttachmentTitle(attachment);\">edit name\n</span></div><div layout=\"column\" layout-align=\"end end\" \nng-if=\"!(vm.customer.locked && vm.customer.metadata.sammathnaur)\"><div layout=\"row\" class=\"action-buttons mt-22\">\n<md-button class=\"action-buttons__button\" ng-click=\"vm.viewOriginalAttachment(attachment);\"><md-icon \nmd-svg-src=\"assets/icons/icon-eye-view.svg\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.VIEW_FILE\">View original</span></md-tooltip></md-button><md-button \nclass=\"action-buttons__button\" ng-if=\"vm.customerHaveCustomerArea\" \nng-click=\"vm.changeAttachmentShare(attachment.metadata.callbacks[0] === \'warg\', $index)\"><md-icon \nmd-svg-src=\"assets/icons/folder_{{ attachment.metadata.callbacks[0] === \'warg\' ? \'off\' : \'shared\' }}.svg\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.SHARE_ATTACHMENTS_WITH_CLIENT.TOOLTIP_{{ attachment.metadata.callbacks[0] === \'warg\' ? \'OFF\' : \'ON\'  }}\">\nShare with client</span></md-tooltip></md-button><md-button class=\"action-buttons__button\" \nng-click=\"attachment[\'open-delete-\' + $index] = \'visible\'\"><md-icon md-menu-origin class=\"delete-icon dark-red\" \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.REMOVE\">Remove attachment</span></md-tooltip></md-button></div></div>\n</div></div><div class=\"attachment-delete-dialog\" ng-class=\"attachment[\'open-delete-\' + $index]\" layout=\"column\" \nflex=\"100\"><div layout=\"column\" layout-align=\"space-between center\" layout-padding flex=\"100\"><div layout=\"row\"><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.REMOVE_CONFIRMATION\">Are you sure you want to delete the attachment?\n</span></div><div layout=\"row\"><md-button type=\"button\" ng-click=\"vm.confirmRemoveAttachment(attachment)\" \nclass=\"md-accent md-raised md-red-800-bg\" aria-label=\"Delete attachment yes\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.YES\" \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.YES\">Yes</md-button><md-button type=\"button\" \nng-click=\"attachment[\'open-delete-\' + $index] = \'\'\" class=\"md-grey-300-bg md-raised\" aria-label=\"Delete attachment no\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.NO\" \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.NO\">No</md-button></div></div></div></div><div \nng-switch-when=\"link\" layout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" layout=\"column\" \nlayout-align=\"center center\"><span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.ATTACHMENTS.LINK\">Link</span></div><div \nclass=\"attachment-content\" layout=\"column\"><span class=\"attachment-url\">{{ item.url }}</span> <span \nclass=\"attachment-time\">{{ item.time }}</span></div></div></div></div></div></div></div></main>");
$templateCache.put("app/main/customers/dialogs/tabs/contacts/contacts-tab.html","<corporate-customer-disclaimer ng-if=\"vm.customer.locked && vm.customer.metadata.sammathnaur\" \ncustomer-name=\"vm.customer.metadata.sammathnaur.account.name\" \ncustom-class=\"customer-dialog__corporate-customer-disclaimer\"></corporate-customer-disclaimer><main \nclass=\"customer-dialog__contacts-tab\"><div class=\"customer-dialog__contacts-tab__main-container\"><h2 \nclass=\"customer-dialog__contacts-tab__main-container__subtitle\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.SUBTITLE_PHONE\' | translate)}}</h2><section \nclass=\"customer-dialog__contacts-tab__main-container__contacts-container\" \nng-class=\"{\'pb-0\': vm.customer.contacts.phones.length === 3}\"><p \nclass=\"customer-dialog__contacts-tab__main-container__contacts-container__empty-phrase\" \nng-if=\"!vm.customer.contacts.phones || !vm.customer.contacts.phones.length\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.EMPTY_PHONES\' | translate)}}</p><div \nng-repeat=\"phone in vm.customer.contacts.phones track by $index\"><div flex layout=\"row\" \nclass=\"customer-dialog__contacts-tab__main-container__contacts-container__input-groups\"><div flex=\"25\"><fc-select \nlabel=\"{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.PHONE_TYPE.LABEL\' | translate)}}\" ng-model=\"phone.type\" \ndata-cy=\"customer-contacts-phone-type\" options=\"vm.phoneTypes\" \nis-disabled=\"$root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\" \nis-required=\"true\" input-name=\"type__{{$index}}\" input-control=\"customerForm[\'type__\' + $index]\"></fc-select></div><div\n flex=\"15\"><fc-select is-required=\"true\" \nis-disabled=\"$root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\" \nlabel=\"Código\" ng-model=\"phone.countryCode\" options=\"vm.countryCodes\" input-name=\"countryCode__{{$index}}\" \ninput-control=\"customerForm[\'countryCode__\' + $index]\" track-by=\"countryCode\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n                }\n              ]\">\n</fc-select></div><div ng-if=\"phone.countryCode.countryCode === \'55\'\" flex=\"40\"><div class=\"fc-input\"><input \ntype=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"phone__{{$index}}\" \nng-model=\"phone.number\" data-cy=\"customer-contacts-phone-number\" \nng-disabled=\"$root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\" \nng-class=\"{\n                  invalid: customerForm[\'phone__\' + $index].$touched && customerForm[\'phone__\' + $index].$invalid,\n                  disabled: $root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\n                }\" \nng-required=\"true\" ui-br-phone-number><label class=\"fc-input__label\">\n{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.PHONE.LABEL\' | translate)}}</label><fc-error \nng-show=\"customerForm[\'phone__\' + $index].$touched\" input-errors=\"customerForm[\'phone__\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div ng-if=\"phone.countryCode.countryCode !== \'55\'\" \nflex=\"40\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" \nname=\"phone__{{$index}}\" ng-model=\"phone.number\" data-cy=\"customer-contacts-phone-number\" \nng-disabled=\"$root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\" \nng-class=\"{\n                  invalid: customerForm[\'phone__\' + $index].$touched && customerForm[\'phone__\' + $index].$invalid,\n                  disabled: $root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\n                }\" \nng-required=\"true\" ng-pattern=\"/^[0-9]+$/\" maxlength=\"{{phone.countryCode.maxLength}}\"><label class=\"fc-input__label\">\n{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.PHONE.LABEL\' | translate)}}</label><fc-error \nng-show=\"customerForm[\'phone__\' + $index].$touched\" input-errors=\"customerForm[\'phone__\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n                  },\n                  {\n                    name: \'pattern\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.INVALID_PHONE\'\n                  },\n                  {\n                    name: \'maxlength\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.INVALID_PHONE\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"30\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"name__{{$index}}\" ng-model=\"phone.name\" \ndata-cy=\"customer-contacts-phone-name\" \nng-disabled=\"$root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\" \nng-class=\"{\n                  invalid: customerForm[\'name__\' + $index].$touched && customerForm[\'name__\' + $index].$invalid,\n                  disabled: $root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\n                }\">\n<label class=\"fc-input__label\">{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.FIELDS.NAME\' | translate)}}</label></div>\n</div><md-button ng-if=\"vm.newCustomer || !(vm.customer.locked && vm.customer.metadata.sammathnaur)\" flex=\"5\" \nclass=\"md-icon-button\" aria-label=\"Delete contact\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.REMOVE_PHONE\" \nng-click=\"vm.deleteContactField(phone, $index, vm.customer.contacts.phones, \'phone\')\"><md-tooltip md-direction=\"top\">\n<span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.REMOVE_PHONE\">Delete contact</span></md-tooltip><md-icon \nclass=\"mt-8 delete-icon\" md-font-icon=\"icon-delete\"></md-icon></md-button></div><div flex layout=\"row\" \nlayout-align=\"start center\" \nclass=\"customer-dialog__contacts-tab__main-container__contacts-container__select-main-contact\"><md-switch \nng-model=\"phone.primary\" ng-disabled=\"!vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\" \nng-change=\"vm.changePrimaryContact($index, vm.customer.contacts.phones, \'phone\')\"><span>\n{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.PHONE.MAIN\' | translate)}}</span></md-switch></div></div><div flex layout=\"row\" \nclass=\"customer-dialog__contacts-tab__main-container__contacts-container__input-groups\" \nng-click=\"vm.addContactFields(\'phone\', vm.customer.contacts.phones)\" \nng-if=\"vm.customer.contacts.phones.length < 3 && (vm.newCustomer || !(vm.customer.locked && vm.customer.metadata.sammathnaur))\" \ndata-cy=\"customer-contacts-add-phone\"><button class=\"fc-clone-button\">\n{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.ADD_PHONE\' | translate) }}</button></div></section><h2 \nclass=\"customer-dialog__contacts-tab__main-container__subtitle\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.SUBTITLE_EMAIL\' | translate)}}</h2><section \nclass=\"customer-dialog__contacts-tab__main-container__contacts-container\" \nng-class=\"{\'pb-0\': vm.customer.contacts.emails.length === 3}\"><p \nclass=\"customer-dialog__contacts-tab__main-container__contacts-container__empty-phrase\" \nng-if=\"!vm.customer.contacts.emails || !vm.customer.contacts.emails.length\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.EMPTY_EMAILS\' | translate)}}</p><div \nng-repeat=\"email in vm.customer.contacts.emails track by $index\"><div flex layout=\"row\" \nclass=\"customer-dialog__contacts-tab__main-container__contacts-container__input-groups\"><div flex=\"25\"><fc-select \nlabel=\"{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.EMAIL_TYPE.LABEL\' | translate)}}\" ng-model=\"email.type\" \ndata-cy=\"customer-contacts-email-type\" options=\"vm.emailTypes\" \nis-disabled=\"$root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\" \nis-required=\"true\" input-name=\"email-type__{{$index}}\" input-control=\"customerForm[\'email-type__\' + $index]\">\n</fc-select></div><div flex=\"50\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"email__{{$index}}\" ng-model=\"email.address\" data-cy=\"customer-contacts-email-address\" \nng-disabled=\"$root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\" \nng-class=\"{\n                  invalid: customerForm[\'email__\' + $index].$touched && customerForm[\'email__\' + $index].$invalid,\n                  disabled: $root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\n                }\" \nng-required=\"true\" email-validation><label class=\"fc-input__label\">\n{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.EMAIL.LABEL\' | translate)}}</label><fc-error \nng-show=\"customerForm[\'email__\' + $index].$touched\" input-errors=\"customerForm[\'email__\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n                  },\n                  {\n                    name: \'pattern\',\n                    translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.EMAIL.PATTERN\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"25\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"email-name__{{$index}}\" ng-model=\"email.name\" \ndata-cy=\"customer-contacts-email-name\" \nng-disabled=\"$root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\" \nng-class=\"{\n                  invalid: customerForm[\'email-name__\' + $index].$touched && customerForm[\'email-name__\' + $index].$invalid,\n                  disabled: $root.loadingProgress || !vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\n                }\">\n<label class=\"fc-input__label\">{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.FIELDS.NAME\' | translate)}}</label></div>\n</div><md-button ng-if=\"vm.newCustomer || !(vm.customer.locked && vm.customer.metadata.sammathnaur)\" flex=\"5\" \nclass=\"md-icon-button\" aria-label=\"Delete contact\" translate \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.REMOVE_EMAIL\" \nng-click=\"vm.deleteContactField(email, $index, vm.customer.contacts.emails, \'email\')\"><md-tooltip md-direction=\"top\">\n<span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.REMOVE_EMAIL\">Delete contact</span></md-tooltip><md-icon \nclass=\"delete-icon\" md-font-icon=\"icon-delete\"></md-icon></md-button></div><div flex layout=\"row\" \nlayout-align=\"start center\" \nclass=\"customer-dialog__contacts-tab__main-container__contacts-container__select-main-contact\"><md-switch \nng-model=\"email.primary\" ng-disabled=\"!vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur\" \nng-change=\"vm.changePrimaryContact($index, vm.customer.contacts.emails, \'email\')\"><span>\n{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.EMAIL.MAIN\' | translate)}}</span></md-switch></div></div><div flex layout=\"row\" \nclass=\"customer-dialog__contacts-tab__main-container__contacts-container__input-groups\" \nng-click=\"vm.addContactFields(\'email\', vm.customer.contacts.emails)\" \nng-if=\"vm.customer.contacts.emails.length < 3 && (vm.newCustomer || !(vm.customer.locked && vm.customer.metadata.sammathnaur))\" \ndata-cy=\"customer-contacts-add-email\"><button class=\"fc-clone-button\">\n{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.ADD_EMAIL\' | translate) }}</button></div></section></div></main>");
$templateCache.put("app/main/customers/dialogs/tabs/general/general-tab.html","<corporate-customer-disclaimer ng-if=\"vm.customer.locked && vm.customer.metadata.sammathnaur\" \ncustomer-name=\"vm.customer.metadata.sammathnaur.account.name\" \ncustom-class=\"customer-dialog__corporate-customer-disclaimer\"></corporate-customer-disclaimer><main \nclass=\"customer-dialog__general-tab\"><div class=\"omie-declaration-customer-container\" ng-if=\"vm.omieAccount\"><md-icon \nmd-svg-src=\"assets/icons/icon-omie-active.svg\" class=\"omie-declaration-customer-icon\"><md-tooltip md-direction=\"top\">\n<span>Omie</span></md-tooltip></md-icon><p translate=\"CUSTOMERS.INTEGRATIONS.IMPORTS.FROM\" \nclass=\"omie-declaration-customer-text\" translate-values=\"{ account: vm.omieAccount }\">Customer imported from</p></div>\n<h2 class=\"section-subtitle mb-25\">{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.CUSTOMER_INFOS\' | translate)}}</h2><div \nlayout=\"row\" layout-align=\"start center\" class=\"mb-30\"><fc-image-input height=\"120px\" width=\"120px\" name=\"image\" \ndata-cy=\"customer-image-input\" input-control=\"customerForm.image\" ngf-accept=\"\'.jpg,.png,.jpeg\'\" \nng-model=\"vm.customer.avatarUrl\" image-file=\"vm.brandImage\" \nis-disabled=\"!!(!vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur)\"></fc-image-input><p \nclass=\"customer-dialog__general-tab__avatar-description ml-20\">\n{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.AVATAR_RULES\' | translate)}}</p></div><div layout-xs=\"column\" layout=\"row\" \nclass=\"mt-20 customer-dialog__general-tab__customer-infos-row\"><div flex=\"70\" class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"name\" data-cy=\"customer-name-input\" \nng-model=\"vm.customer.name\" ng-change=\"vm.validateDuplicateWhiteSpacesInName()\" ng-model-options=\"{ debounce: 500 }\" \nng-disabled=\"$root.loadingProgress || (!vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur)\" \nng-maxlength=\"150\" \nng-class=\"{\n          disabled: $root.loadingProgress || (!vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur),\n          invalid: customerForm.name.$touched && customerForm.name.$invalid\n        }\" \nrequired><label class=\"fc-input__label\">{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.NAME.LABEL\' | translate)}}</label>\n<fc-error ng-show=\"customerForm.name.$touched\" input-errors=\"customerForm.name.$error\" \nerrors-to-watch=\"[\n          {\n            name: \'required\',\n            translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.NAME.REQUIRED\',\n          },\n          {\n            name: \'maxlength\',\n            translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.NAME.VALID\',\n          },\n          {\n            name: \'hasWhiteSpacesInName\',\n            translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.NAME.WHITE_SPACES\',\n          }\n        ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div flex=\"30\" ng-if=\"vm.countryCode === \'BRA\'\"><div \nclass=\"fc-input\"><input type=\"text\" placeholder=\" \" maxlength=\"18\" autocomplete=\"off\" class=\"fc-input__input\" \ndata-cy=\"customer-document-input\" name=\"documentNumber\" ng-model=\"vm.customer.documentNumber\" \nng-change=\"vm.duplicatedValidation(vm.customer, customerForm.documentNumber)\" \nng-disabled=\"$root.loadingProgress || (!vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur)\" \nng-class=\"{\n            invalid: customerForm.documentNumber.$touched && customerForm.documentNumber.$invalid,\n            disabled: $root.loadingProgress || (!vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur)\n          }\" \nui-br-cpfcnpj-mask><label class=\"fc-input__label\">{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.DOCUMENT.LABEL\' | translate)}}\n</label><fc-error ng-show=\"customerForm.documentNumber.$touched\" input-errors=\"customerForm.documentNumber.$error\" \nerrors-to-watch=\"[\n            {\n              name: \'cnpj\',\n              translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.DOCUMENT.INVALID_CNPJ\'\n            },\n            {\n              name: \'cpf\',\n              translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.DOCUMENT.INVALID_CPF\'\n            },\n            {\n              name: \'duplicated\',\n              translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.DOCUMENT.EXISTS\'\n            },\n          ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"30\" ng-if=\"vm.countryCode !== \'BRA\'\"><div \nclass=\"fc-input\"><input type=\"text\" maxlength=\"18\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" \ndata-cy=\"customer-document-input\" name=\"documentNumber\" ng-model=\"vm.customer.documentNumber\" \nng-change=\"vm.duplicatedValidation(vm.customer, customerForm.documentNumber)\" \nng-disabled=\"$root.loadingProgress || (!vm.newCustomer && vm.customer.metadata && vm.customer.metadata.sammathnaur)\" \nng-class=\"{\n            disabled: $root.loadingProgress || (!vm.newCustomer && vm.customer.metadata && vm.customer.metadata.sammathnaur)\n          }\">\n<label class=\"fc-input__label\">{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.DOCUMENT.LABEL\' | translate)}}</label><fc-error \nng-show=\"customerForm.documentNumber.$touched\" input-errors=\"customerForm.documentNumber.$error\" \nerrors-to-watch=\"[\n            {\n              name: \'duplicated\',\n              translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.DOCUMENT.EXISTS\'\n            },\n          ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div flex=\"100\" class=\"mt-18\"><fc-smart-rewrite \nreference-id=\"vm.customer.id || vm.sessionId\" reference-type=\"customer-notes\" \ndisabled=\"$root.loadingProgress || (!vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur)\" \nclass=\"flex-100\"><fc-textarea \nis-disabled=\"$root.loadingProgress || (!vm.newCustomer && vm.customer.locked && vm.customer.metadata.sammathnaur)\" \nlabel=\"{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.NOTES.LABEL\' | translate)}}\" ng-model=\"vm.customer.notes\" \ninput-name=\"notes\" data-cy=\"customer-notes-input\" input-control=\"customerForm.notes\" max-length=\"300\" \nerrors-to-watch=\"[\n          {\n            name: \'maxlength\',\n            translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.MAX_LENGTH\',\n            translateValues: { expectedLength: 300, receivedLength: customerForm.notes.$viewValue.length }\n          },\n        ]\">\n</fc-textarea></fc-smart-rewrite></div><div class=\"alert mt-20\"><span ng-repeat=\"idLabel in vm.customer.idLabels\"><span\n class=\"status-label customer-dialog__general-tab__label-span\" \nng-class=\"\'md-\'+vm.getItemById(vm.labels, idLabel).color+\'-bg\'\">{{ vm.getItemById(vm.labels, idLabel).name }}<md-icon \nclass=\"customer-dialog__general-tab__remove-label-icon\" ng-if=\"vm.hasLabelsPermission\" md-font-icon=\"icon-close\" \nng-click=\"!(vm.customer.locked && vm.customer.metadata.sammathnaur) || vm.newCustomer ? vm.toggleInArray(idLabel, vm.customer.idLabels) : null\">\n</md-icon></span></span></div></main>");
$templateCache.put("app/main/customers/dialogs/tabs/order-report-template/order-report-template-tab.html","<div class=\"customer-dialog-template-tab\"><info-component-provider \ntext=\"{{ \'CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.INFO\' | translate }}\"></info-component-provider><div \nclass=\"customer-dialog-template-tab__empty-state\" ng-if=\"!vm.customer.orderReportTemplate\"><span>\n{{ \'CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.EMPTY_STATE\' | translate }}</span><md-button \ndata-cy=\"link-order-report-template-button\" class=\"customer-dialog-template-tab__button\" \nng-click=\"vm.linkOrderReportTemplate()\" translate=\"CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.LINK\">Link</md-button></div><div\n class=\"customer-dialog-template-tab__item\" ng-if=\"vm.customer.orderReportTemplate\"><div \nclass=\"customer-dialog-template-tab__icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" \nviewBox=\"0 0 24 24\" fill=\"none\"><path \nd=\"M7.425 9.4748L11.15 3.3998C11.25 3.23314 11.375 3.1123 11.525 3.0373C11.675 2.9623 11.8333 2.9248 12 2.9248C12.1667 2.9248 12.325 2.9623 12.475 3.0373C12.625 3.1123 12.75 3.23314 12.85 3.3998L16.575 9.4748C16.675 9.64147 16.725 9.81647 16.725 9.9998C16.725 10.1831 16.6833 10.3498 16.6 10.4998C16.5167 10.6498 16.4 10.7706 16.25 10.8623C16.1 10.954 15.925 10.9998 15.725 10.9998H8.275C8.075 10.9998 7.9 10.954 7.75 10.8623C7.6 10.7706 7.48333 10.6498 7.4 10.4998C7.31667 10.3498 7.275 10.1831 7.275 9.9998C7.275 9.81647 7.325 9.64147 7.425 9.4748ZM17.5 21.9998C16.25 21.9998 15.1875 21.5623 14.3125 20.6873C13.4375 19.8123 13 18.7498 13 17.4998C13 16.2498 13.4375 15.1873 14.3125 14.3123C15.1875 13.4373 16.25 12.9998 17.5 12.9998C18.75 12.9998 19.8125 13.4373 20.6875 14.3123C21.5625 15.1873 22 16.2498 22 17.4998C22 18.7498 21.5625 19.8123 20.6875 20.6873C19.8125 21.5623 18.75 21.9998 17.5 21.9998ZM3 20.4998V14.4998C3 14.2165 3.09583 13.979 3.2875 13.7873C3.47917 13.5956 3.71667 13.4998 4 13.4998H10C10.2833 13.4998 10.5208 13.5956 10.7125 13.7873C10.9042 13.979 11 14.2165 11 14.4998V20.4998C11 20.7831 10.9042 21.0206 10.7125 21.2123C10.5208 21.404 10.2833 21.4998 10 21.4998H4C3.71667 21.4998 3.47917 21.404 3.2875 21.2123C3.09583 21.0206 3 20.7831 3 20.4998ZM17.5 19.9998C18.2 19.9998 18.7917 19.7581 19.275 19.2748C19.7583 18.7915 20 18.1998 20 17.4998C20 16.7998 19.7583 16.2081 19.275 15.7248C18.7917 15.2415 18.2 14.9998 17.5 14.9998C16.8 14.9998 16.2083 15.2415 15.725 15.7248C15.2417 16.2081 15 16.7998 15 17.4998C15 18.1998 15.2417 18.7915 15.725 19.2748C16.2083 19.7581 16.8 19.9998 17.5 19.9998ZM5 19.4998H9V15.4998H5V19.4998ZM10.05 8.9998H13.95L12 5.8498L10.05 8.9998Z\" \nfill=\"#135AC0\"/></svg></div><div class=\"customer-dialog-template-tab__content\"><strong>\n{{ vm.customer.orderReportTemplate.name }}<div class=\"customer-dialog-template-tab__label\" \nng-class=\"{\n            \'customer-dialog-template-tab__label--active\': vm.customer.orderReportTemplate.archived ? false : vm.customer.orderReportTemplate.active,\n            \'customer-dialog-template-tab__label--inactive\': vm.customer.orderReportTemplate.archived ? false : !vm.customer.orderReportTemplate.active,\n            \'customer-dialog-template-tab__label--archived\': vm.customer.orderReportTemplate.archived\n          }\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\"><circle cx=\"6\" cy=\"6\" \nr=\"2.25\" fill=\"currentColor\"/></svg> <span \nng-if=\"vm.customer.orderReportTemplate.archived ? false : vm.customer.orderReportTemplate.active\">\n{{ \'CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.ACTIVE\' | translate }} </span><span \nng-if=\"vm.customer.orderReportTemplate.archived ? false : !vm.customer.orderReportTemplate.active\">\n{{ \'CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.INACTIVE\' | translate }} </span><span \nng-if=\"vm.customer.orderReportTemplate.archived\">{{ \'CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.ARCHIVED\' | translate }}\n</span></div></strong><span>{{ \'CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.TYPE.ORDER\' | translate }}</span></div><div \nclass=\"customer-dialog-template-tab__buttons\"><md-button class=\"md-icon-button\" \nng-click=\"vm.linkOrderReportTemplate()\"><md-icon md-font-icon=\"icon-pencil\" class=\"customer-dialog-template-tab__edit\">\n</md-icon><md-tooltip><span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.EDIT\">Edit</span></md-tooltip></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.unlinkOrderReportTemplate()\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"customer-dialog-template-tab__unlink\"></md-icon><md-tooltip><span \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.TEMPLATE.REMOVE\">Remove</span></md-tooltip></md-button></div></div></div>");
$templateCache.put("app/main/equipments/dialogs/tabs/historic/historic-tab.html","<main class=\"equipment-dialog__historic-tab\"><div flex layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.loadingTimeline && !vm.equipmentLogs.length\"><i class=\"icon-history s40\"></i> <span \ntranslate=\"EQUIPMENTS.DIALOG.HISTORIC.NOT_FOUND\">This equipment has no historic yet.</span></div><div \nclass=\"equipment-dialog__historic-tab__log\" ng-repeat=\"log in vm.equipmentLogs track by $index\"><ng-container \nng-if=\"!vm.equipmentLogs[$index - 1] || vm.equipmentLogs[$index - 1].formattedCreatedAt !== log.formattedCreatedAt\"><p \nng-if=\"log.formattedCreatedAt === vm.today\" translate=\"EQUIPMENTS.DIALOG.HISTORIC.TODAY\" \nclass=\"equipment-dialog__historic-tab__log_date\">Today</p><p ng-if=\"log.formattedCreatedAt === vm.yesterday\" \ntranslate=\"EQUIPMENTS.DIALOG.HISTORIC.YESTERDAY\" class=\"equipment-dialog__historic-tab__log_date\">Yesterday</p><p \nclass=\"equipment-dialog__historic-tab__log_date\" \nng-if=\"log.formattedCreatedAt !== vm.yesterday && log.formattedCreatedAt !== vm.today\">{{ log.formattedCreatedAt }}</p>\n</ng-container><div data-cy=\"equipment-historic-container\" class=\"equipment-dialog__historic-tab__log__container\" flex \nlayout=\"row\" layout-align=\"stretch center\"><div class=\"equipment-dialog__historic-tab__log__container-status\"><div \nclass=\"equipment-dialog__historic-tab__log__container-status_icon equipment-dialog__historic-tab__log__container-status_icon--{{ log.colorClass }}\" \nflex layout=\"column\" layout-align=\"center center\"><md-icon md-svg-src=\"assets/icons/{{ log.icon }}.svg\"></md-icon>\n</div><div class=\"equipment-dialog__historic-tab__log__container-status_line\"></div></div><div \ndata-cy=\"equipment-historic-detail\" class=\"equipment-dialog__historic-tab__log__container__detail\"><div \nclass=\"equipment-dialog__historic-tab__log__container__detail_top\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><p \nclass=\"equipment-dialog__historic-tab__log__container__detail_top-title equipment-dialog__historic-tab__log__container__detail_top-title--{{ log.colorClass }}\" \nng-bind-html=\"log.title\"></p><p class=\"equipment-dialog__historic-tab__log__container__detail_top-date\">\n{{ log.createdAt }}</p></div><div class=\"equipment-dialog__historic-tab__log__container__detail-author\" flex=\"100\" \nlayout=\"row\" layout-align=\"start center\"><div><md-icon md-font-icon=\"{{ log.updatedBy.device }}\"></md-icon></div><p>\n{{ log.updatedBy.title }}</p></div><div class=\"equipment-dialog__historic-tab__log__container__detail_description\" \nng-if=\"log.eventDescription\" ng-bind-html=\"log.eventDescription\"></div></div></div></div><div flex layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.loadingTimeline\"><span translate=\"EQUIPMENTS.DIALOG.HISTORIC.LOADING\">\nProcessing...</span></div></main>");
$templateCache.put("app/main/equipments/dialogs/tabs/tasks/tasks-tab.html","<div ng-if=\"vm.timeline.length <= 0\"><p class=\"text-center\"><i class=\"icon-history s40\"></i><br><span \ntranslate=\"EQUIPMENTS.DIALOG.SERVICES.NO_HISTORY\">This Equipment has no service history.</span></p></div><a \nng-if=\"vm.timeline.length > 0\" class=\"equipment-to-task-list\" layout=\"row\" \nng-href=\"#/atividades?q=equipment_id:\'{{ vm.equipment.id }}\'+nome_cliente:\'{{ vm.equipment.customer.name }}\'+data_agendamento<=:{{ vm.lastTaskDate }}+data_agendamento>=:{{ vm.firstTaskDate }}\" \naria-label=\"ir para listagem de atividades\" ng-click=\"vm.closeDialog();\"><div flex=\"80\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"equipment-to-task-list__title\" \ntranslate=\"EQUIPMENTS.DIALOG.SERVICES.GO_TO_TASKS_LIST\">Go to tasks list</span></div><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button equipment-to-task-list__button\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"EQUIPMENTS.DIALOG.SERVICES.GO_TO_TASKS_LIST\">Go to tasks list</span></md-tooltip></md-button></div></a><div \nid=\"timeline-equipment\" class=\"timeline-equipment fs-13\" ng-if=\"vm.timeline.length > 0\" ms-timeline><div \nms-timeline-item layout=\"column\" layout-align=\"start start\" layout-gt-md=\"row\" layout-align-gt-md=\"start start\" \nng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-start\" layout=\"column\"><div \nng-style=\"{\'background-color\': timelineItem.color}\" class=\"timeline-point md-accent-bg\"><md-icon \nmd-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-line\"></div></div><div class=\"timeline-card\" \nlayout=\"row\" flex-md=\"100\" flex=\"90\"><div class=\"ms-card ms-card-equipment\" ng-model=\"timelineItem.card\"><div \nclass=\"card\"><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"timelineItem.avatar\"><img \nclass=\"avatar mr-16\" ng-src=\"{{timelineItem.avatar.src}}\" alt=\"{{timelineItem.avatar.alt}}\"></div><div class=\"info\">\n<div layout=\"row\"><div flex=\"70\" class=\"title\" ng-if=\"timelineItem.title\">{{timelineItem.title}}</div><div flex=\"30\" \nclass=\"created-at\" ng-if=\"timelineItem.createdAt\">{{timelineItem.createdAt}}</div></div><div layout=\"row\"><div \nclass=\"subtitle\" ng-if=\"timelineItem.subtitle\" ng-style=\"{color: timelineItem.subtitleColor};\">\n{{timelineItem.subtitle}}</div></div></div></div><div class=\"text ph-16\" ng-if=\"timelineItem.text\" \nng-bind-html=\"timelineItem.text\"></div><div><md-button class=\"show-button\" ng-click=\"vm.openTask(timelineItem.task);\">\nVisualizar visita</md-button></div></div></div></div></div></div><md-button \nclass=\"show-button offline-tab-load-more-button\" ng-if=\"vm.tasksTotalCount > vm.timeline.length\" \nng-click=\"vm.loadMoreTasks()\">Carregar mais</md-button>");
$templateCache.put("app/main/locations/dialogs/tabs/attachments/attachments-tab.html","<div layout=\"row\" layout-align=\"center center\" class=\"warning\"><md-icon \nmd-svg-src=\"assets/icons/icon-question-circle.svg\"></md-icon><span \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.ATTACHMENT_DESCRIPTION\">\nLimit 20 attachments per Manager Panel. There is no limit on attachments in the contributor app.</span></div><div \nclass=\"location-dialog__attachments-tab\"><div layout=\"row\" layout-align=\"center\" class=\"drop-box\" \nng-class=\"{\'has-images\': vm.files.length > 0 }\" ng-disabled=\"vm.location.locked\" ngf-drop ng-model=\"vm.files\" \nname=\"files\" ngf-multiple=\"true\" \nngf-pattern=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nngf-max-files=\"{{vm.maxAttachments - vm.attachments.length}}\" \nngf-accept=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nngf-allow-dir=\"true\" ngf-validate-fn=\"vm.validateImage($file)\"><div layout=\"column\" layout-align=\"center\" \nclass=\"upload-warn\"><div layout=\"column\" class=\"upload-warn__sentence-container\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.maxAttachments - vm.attachments.length <= 0\"><md-icon \nmd-svg-src=\"assets/icons/icon-service-error.svg\"></md-icon><span style=\"margin-top: 14px\" \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.ATTACHMENTS_LIMIT_REACHED\">\nAttachments limit reached to add more attachments you need to remove some first.</span></div><div \nng-if=\"vm.files.length < 1 && vm.maxAttachments - vm.attachments.length > 0\"><md-icon \nmd-svg-src=\"assets/icons/icon-upload.svg\"></md-icon><span class=\"upload-warn__sentence-container__phrase\" \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.DROP_HERE\" layout-align=\"center center\" layout=\"column\">\nDrag your files to upload</span></div><div class=\"upload-warn__sentence-container__actions-buttons-container\" \nng-if=\"vm.attachments.length < vm.maxAttachments\"><div><span \nclass=\"upload-warn__sentence-container__actions-buttons-container__phrase\" ng-if=\"vm.files.length\" \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.INSERT_FILES_ALTERNATIVE\">Drag your files to upload or</span><md-button \nclass=\"insert-attachments\" ng-disabled=\"vm.location.locked\" ngf-select ng-model=\"vm.files\" ngf-multiple=\"true\" \nngf-pattern=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nngf-max-files=\"{{vm.maxAttachments- vm.attachments.length}}\" \nngf-accept=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx\'\" \nngf-allow-dir=\"true\" ngf-validate-fn=\"vm.validateImage($file)\"><md-icon \nmd-svg-src=\"assets/icons/insert-attachments.svg\"></md-icon><span translate=\"LOCATIONS.DIALOG.ATTACHMENTS.INSERT_FILES\">\nInsert files</span></md-button></div><md-button class=\"send-attachments\" ng-click=\"vm.uploadImages()\" \nng-disabled=\"!vm.files.length || vm.uploadProgress || vm.maxAttachments- vm.files.length < 0\" aria-label=\"menu\" \nng-if=\"!vm.location.locked && vm.files.length && vm.attachments.length < vm.maxAttachments && !vm.uploadProgress\"><span\n translate=\"LOCATIONS.DIALOG.ATTACHMENTS.SEND_FILES\">Save files</span></md-button></div></div></div>\n<md-progress-circular id=\"upload-progress\" ng-if=\"vm.uploadProgress\" class=\"md-accent mleft-10\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"wrapper-images-upload\" \nstyle=\"display: flex\" layout-align=\"center\" ng-if=\"!vm.uploadProgress\"><div ng-repeat=\"f in vm.files\"><md-icon \nclass=\"remove-attachment-icon\" md-svg-src=\"assets/icons/icon-remove.svg\" \nng-click=\"vm.removeUploadedAttachment($index)\"></md-icon><img ng-if=\"vm.isFileTypeImage(f)\" ngf-thumbnail=\"f\" \nngf-size=\"{width: 100, height: 100, quality: 0.9}\"><div ng-if=\"!vm.isFileTypeImage(f)\" layout=\"row\" \nlayout-align=\"center center\" class=\"attachment-icon\"><md-icon md-font-icon=\"{{vm.getIconByFileType(f.type)}}\" \nclass=\"file-image-thumbnail\" ng-class=\"vm.getIconByFileType(f.type)\"></md-icon></div><br><span class=\"name-file-text\">\n{{f.$error}} {{f.$errorParam}}</span></div></div></div><div ngf-no-file-drop \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.NOT_SUPPORTED_FILE_DRAG\">File Drag/Drop is not supported for this browser</div>\n<md-divider></md-divider><span class=\"attachments-limit\" \nng-class=\"{ \'red-text\': vm.attachments.length >= vm.maxAttachments }\"><span \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.TITLE\">Attachments</span>\n ({{ vm.attachments.length }} / {{ vm.maxAttachments}})</span><div *ngf-thumbnail=\"file\" \nngf-size=\"{width: 20, height: 20, quality: 0.9}\" ngf-as-background=\"boolean\"></div><div \nng-if=\"(!vm.attachments.length || !vm.attachments) && !vm.loading\"><p class=\"text-center\"><i \nclass=\"icon-attachment s40\"></i><br><span></span> <span translate=\"LOCATIONS.DIALOG.ATTACHMENTS.NO_ATTACHMENTS_ADDED\">\nNo attachments have been added for this location.</span></p></div><div ng-if=\"vm.loading\"><p class=\"text-center\">\n<md-progress-circular ng-disabled=\"!vm.loading\" class=\"md-accent\" md-diameter=\"32\" md-mode=\"indeterminate\" \naria-valuemax=\"100\"></md-progress-circular><br><span></span> <span \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.SEARCHING_ATTACHMENTS\">searching for order attachments.</span></p></div><div \nng-if=\"vm.attachments.length && !vm.loading\" class=\"sections\"><div class=\"section\"><div class=\"attachments\"><div \nclass=\"section-content\"><div ng-class=\"\'attachment\' + (attachment.archived ? \' archived\' : \'\')\" \nng-repeat=\"attachment in vm.attachments track by $index\" ng-switch=\"item.type\"><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"5\"><div class=\"arrows-orders\" \nng-if=\"attachment.type !== \'signature\' && vm.order.id\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"icon s-20\" \nng-if=\"$index > 0\" ng-click=\"vm.reorderAttachments($index, \'up\');\"><md-tooltip md-direction=\"top\"><div \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.MOVE_UP\">Move up</div></md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"icon mt-15 s-20\" ng-if=\"$index !== vm.attachments.length - 1\" \nng-click=\"vm.reorderAttachments($index, \'down\');\"><md-tooltip md-direction=\"bottom\"><div \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.MOVE_DOWN\">Move down</div></md-tooltip></md-icon></div></div><div flex>\n<div layout=\"row\" flex=\"100\"><div class=\"attachment-preview md-whiteframe-2dp\" ng-if=\"vm.isFileTypeImage(attachment)\" \nng-style=\"{\'background-image\': \'url(\' + attachment.path + \')\'}\"></div><div \nclass=\"attachment-preview attachment-video md-whiteframe-2dp\" ng-if=\"vm.isFileTypeVideo(attachment)\" \nng-click=\"vm.viewOriginalAttachment(attachment.path);\" \nng-style=\"{\'background-image\': \'url(\' + attachment.path.replace(\'.mp4\', \'.jpg\') + \')\', \'background-size\': \'cover\'}\">\n</div><div class=\"attachment-preview md-whiteframe-2dp attachment-icon\" \nng-if=\"!vm.isFileTypeImage(attachment) && !vm.isFileTypeVideo(attachment)\"><md-icon class=\"file-image\" \nng-class=\"vm.getIconByFileType(attachment.type)\" md-font-icon=\"{{vm.getIconByFileType(attachment.type)}}\"></md-icon>\n</div><div class=\"attachment-content\" layout=\"column\" flex=\"100\"><div layout=\"row\"><div layout=\"column\" flex=\"100\"><div\n class=\"attachment-name\" ng-if=\"attachment.editing\"><div class=\"attachment-content-edit\" layout-align=\"space-between\">\n<input id=\"attachment_{{attachment.id}}\" name=\"attachment_{{attachment.id}}\" ng-model=\"attachment.title\" \nmaxlength=\"80\" ng-keydown=\"vm.saveAttachmentWhenEnterKey($event, attachment);\" type=\"text\"><div \nclass=\"attachment-content-edit-actions\"><md-icon class=\"s20 clickable attachment-content__icon-check\" \nng-click=\"vm.saveAttachmentTitle(attachment);\" md-font-icon=\"icon-check\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.SAVE_EDIT\">Save title</span></md-tooltip></md-icon><md-icon \nclass=\"s20 clickable attachment-content__icon-close\" ng-click=\"vm.cancelEditAttachment(attachment);\" \nmd-font-icon=\"icon-close\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.CANCEL_EDIT\">Cancel</span></md-tooltip></md-icon></div></div></div><div \nclass=\"attachment-content-name\" ng-if=\"!attachment.editing\"><span ng-if=\"attachment.type !== \'signature\'\">\n{{ attachment.title || ( \'LOCATIONS.DIALOG.ATTACHMENTS.FILES.NO_TITLE\' | translate ) }}</span> <span \nng-if=\"attachment.type === \'signature\'\"><span translate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.SIGNATURE\">Signature</span>\n <span ng-if=\"attachment.title\"><span translate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.OF\">of</span>\n {{ attachment.title }}</span></span></div></div></div><div layout=\"row\" class=\"attachment-content__metadata\"><div \nlayout=\"column\" flex=\"60\"><span ng-if=\"attachment.metadata.createdAt\" class=\"attachment-content-time\" \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ADDED_AT\" \ntranslate-value-date=\"{{ attachment.metadata.createdAt | amDateFormat: vm.dateFormat }}\" \ntranslate-value-hour=\"{{ attachment.metadata.createdAt | amDateFormat: vm.timeFormat }}\">\nAdded at {{ attachment.metadata.createdAt | amDateFormat: vm.dateFormat }} at {{ attachment.metadata.createdAt | amDateFormat: vm.timeFormat }} \n</span><span class=\"attachment-rename\" ng-if=\"!vm.location.locked && vm.location.id\" \nng-click=\"vm.editAttachmentTitle(attachment.id, ev);\">Renomear </span><span class=\"archived-text\" \nng-if=\"attachment.archived\"><md-icon md-font-icon=\"icon-archive\"></md-icon><span \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ARCHIVED\">Archived</span></span></div><div layout=\"column\" \nlayout-align=\"end\"><div layout=\"row\" class=\"remove-or-archive-attachment mt-22\"><md-button \nclass=\"remove-or-archive-attachment__action-button\" ng-click=\"vm.viewOriginalAttachment(attachment.path);\"><md-icon \nmd-svg-src=\"assets/icons/icon-eye-view.svg\"></md-icon><md-tooltip><span \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.VIEW_ORIGINAL\">See original attachment</span></md-tooltip></md-button>\n<md-button class=\"remove-or-archive-attachment__action-button\" ng-if=\"!vm.location.locked\" \nng-click=\"attachment[\'open-delete-\' + $index] = \'visible\'\"><md-icon class=\"dark-red\" md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span translate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ACTIONS.REMOVE\">Remove attachment</span>\n</md-tooltip></md-button><md-button class=\"remove-or-archive-attachment__action-button\" \nng-click=\"vm.archiveAttachment(attachment.id, !attachment.archived, $event)\"><md-icon class=\"light-blue\" \nmd-font-icon=\"icon-archive\"></md-icon><md-tooltip md-direction=\"bottom\">\n{{ attachment.archived ? \'LOCATIONS.DIALOG.ATTACHMENTS.FILES.ACTIONS.UNARCHIVE\' : \'LOCATIONS.DIALOG.ATTACHMENTS.FILES.ACTIONS.ARCHIVE\' | translate }}\n</md-tooltip></md-button></div></div></div></div><div class=\"attachment-delete-dialog\" \nng-class=\"attachment[\'open-delete-\' + $index]\" layout=\"column\" flex=\"100\"><div layout=\"column\" \nlayout-align=\"space-between center\" layout-padding flex=\"100\"><div layout=\"column\" class=\"pl-30\" \nng-if=\"attachment.type === \'signature\'\"><span translate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ALERTS.REMOVE_SIGNATURE\">\nAre you sure you want to delete this signature?</span></div><div layout=\"row\" ng-if=\"attachment.type !== \'signature\'\">\n<span translate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ALERTS.REMOVE_ATTACHMENT\">\nAre you sure you want to delete this attachment?</span></div><div layout=\"row\"><md-button type=\"button\" \nng-click=\"vm.confirmRemoveAttachment(attachment)\" style=\"color:white\" class=\"md-red-800-bg md-raised\" \naria-label=\"Delete attachment yes\" translate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ALERTS.YES\" \ntranslate-attr-aria-label=\"LOCATIONS.DIALOG.ATTACHMENTS.YES\">Yes</md-button><md-button type=\"button\" \nng-click=\"attachment[\'open-delete-\' + $index] = \'\'\" class=\"md-grey-300-bg md-raised\" aria-label=\"Delete attachment no\" \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ALERTS.NO\" translate-attr-aria-label=\"LOCATIONS.DIALOG.ATTACHMENTS.NO\">No\n</md-button></div></div></div><div class=\"attachment-archive-dialog\" ng-class=\"attachment[\'open-archive-\' + $index]\" \nlayout=\"column\" flex=\"100\"><div layout=\"column\" layout-align=\"space-between center\" layout-padding flex=\"100\"><div \nlayout=\"column\" ng-if=\"attachment.type === \'signature\'\"><span \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ALERTS.ARCHIVE_SIGNATURE\">\nAre you sure you want to archive this signature?</span></div><div layout=\"row\" ng-if=\"attachment.type !== \'signature\'\">\n<span translate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ALERTS.ARCHIVE_ATTACHMENT\">\nAre you sure you want to archive this attachment?</span></div><div layout=\"row\"><md-button type=\"button\" \nng-click=\"vm.confirmArchiveAttachment(attachment)\" class=\"md-accent md-raised\" aria-label=\"Archive attachment yes\" \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ALERTS.YES\" translate-attr-aria-label=\"LOCATIONS.DIALOG.ATTACHMENTS.YES\">\nYes</md-button><md-button type=\"button\" ng-click=\"attachment[\'open-archive-\' + $index] = \'\'\" \nclass=\"md-grey-300-bg md-raised\" aria-label=\"Archive attachment no\" \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.FILES.ALERTS.NO\" translate-attr-aria-label=\"LOCATIONS.DIALOG.ATTACHMENTS.NO\">No\n</md-button></div></div></div></div><div ng-switch-when=\"link\" layout=\"row\"><div \nclass=\"attachment-preview md-whiteframe-2dp\" layout=\"column\" layout-align=\"center center\"><span \ntranslate=\"LOCATIONS.DIALOG.ATTACHMENTS.LINK\">LINK</span></div><div class=\"attachment-content\" layout=\"column\"><span \nclass=\"attachment-url\">{{item.url}}</span> <span class=\"attachment-time\">{{item.time}}</span></div></div></div></div>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/locations/dialogs/tabs/contacts/contacts-tab.html","<corporate-customer-disclaimer \nng-if=\"vm.location.id && vm.location.customer.locked && vm.location.customer.metadata.sammathnaur\" \ncustomer-name=\"vm.customerAccountName(vm.location.customer.metadata)\" \ncustom-class=\"location-dialog__corporate-customer-disclaimer\"></corporate-customer-disclaimer><main \nclass=\"location-dialog__contacts-tab\"><div class=\"location-dialog__contacts-tab__main-container\"><h2 \nclass=\"location-dialog__contacts-tab__main-container__subtitle\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.SUBTITLE_PHONE\' | translate)}}</h2><section \nclass=\"location-dialog__contacts-tab__main-container__contacts-container\" \nng-class=\"{\'pb-0\': vm.location.contacts.phones.length === 3}\"><p \nclass=\"location-dialog__contacts-tab__main-container__contacts-container__empty-phrase\" \nng-if=\"!vm.location.contacts.phones || !vm.location.contacts.phones.length\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.EMPTY_PHONES\' | translate)}}</p><div \nng-repeat=\"phone in vm.location.contacts.phones track by $index\"><div flex layout=\"row\" \nclass=\"location-dialog__contacts-tab__main-container__contacts-container__input-groups\"><div flex=\"25\"><fc-select \nlabel=\"{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.FIELDS.PHONE_TYPE\' | translate)}}\" ng-model=\"phone.type\" \ndata-cy=\"phone-type\" options=\"vm.phonesTypes\" is-disabled=\"$root.loadingProgress || vm.location.locked\" \nis-required=\"true\" input-name=\"type__{{$index}}\" input-control=\"vm.locationsForm[\'type__\' + $index]\"></fc-select></div>\n<div flex=\"15\"><fc-select is-required=\"true\" is-disabled=\"$root.loadingProgress\" label=\"Código\" \nng-model=\"phone.countryCode\" options=\"vm.countryCodes\" input-name=\"countryCode__{{$index}}\" \ninput-control=\"vm.locationsForm[\'countryCode__\' + $index]\" track-by=\"countryCode\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n                }\n              ]\">\n</fc-select></div><div ng-if=\"phone.countryCode.countryCode === \'55\'\" flex=\"40\"><div class=\"fc-input\"><input \ntype=\"text\" placeholder=\" \" data-cy=\"phone-number\" autocomplete=\"off\" class=\"fc-input__input\" name=\"phone__{{$index}}\" \nng-model=\"phone.number\" ng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n                  invalid: vm.locationsForm[\'phone__\' + $index].$touched && vm.locationsForm[\'phone__\' + $index].$invalid\n                }\" \nng-required=\"true\" ui-br-phone-number><label class=\"fc-input__label\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.FIELDS.PHONE\' | translate)}}</label><fc-error \nng-show=\"vm.locationsForm[\'phone__\' + $index].$touched\" input-errors=\"vm.locationsForm[\'phone__\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div ng-if=\"phone.countryCode.countryCode !== \'55\'\" \nflex=\"40\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" \nname=\"phone__{{$index}}\" ng-model=\"phone.number\" ng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n                  invalid: vm.locationsForm[\'phone__\' + $index].$touched && vm.locationsForm[\'phone__\' + $index].$invalid\n                }\" \nng-required=\"true\" ng-pattern=\"/^[0-9]/\" ng-maxlength=\"phone.countryCode.maxLength\"><label class=\"fc-input__label\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.FIELDS.PHONE\' | translate)}}</label><fc-error \nng-show=\"vm.locationsForm[\'phone__\' + $index].$touched\" input-errors=\"vm.locationsForm[\'phone__\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n                  },\n                  {\n                    name: \'pattern\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.INVALID_PHONE\'\n                  },\n                  {\n                    name: \'maxlength\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.INVALID_PHONE\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"30\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" data-cy=\"phone-name\" autocomplete=\"off\" class=\"fc-input__input\" name=\"name__{{$index}}\" \nng-model=\"phone.name\" ng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n                  invalid: vm.locationsForm[\'name__\' + $index].$touched && vm.locationsForm[\'name__\' + $index].$invalid\n                }\">\n<label class=\"fc-input__label\">{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.FIELDS.NAME\' | translate)}}</label></div>\n</div><md-button ng-if=\"!vm.location.locked\" flex=\"5\" class=\"md-icon-button\" aria-label=\"Delete contact\" translate \ntranslate-attr-aria-label=\"LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.DELETE_CONTACT\" \nng-click=\"!vm.location.locked && vm.deleteContactField(phone, $index, vm.location.contacts.phones, \'phone\')\">\n<md-tooltip md-direction=\"top\"><span translate=\"LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.DELETE_CONTACT\">Delete contact\n</span></md-tooltip><md-icon class=\"delete-icon\" md-font-icon=\"icon-delete\"></md-icon></md-button></div><div flex \nlayout=\"row\" layout-align=\"start center\" \nclass=\"location-dialog__contacts-tab__main-container__contacts-container__select-main-contact\"><md-switch \nng-disabled=\"vm.location.locked\" ng-model=\"phone.primary\" data-cy=\"phone-primary-switch\" \nng-change=\"vm.changePrimaryContact($index, vm.location.contacts.phones, \'phone\')\"><span>\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.SELECT_AS_MAIN_PHONE\' | translate)}}</span></md-switch></div></div><div \nflex layout=\"row\" class=\"location-dialog__contacts-tab__main-container__contacts-container__input-groups\" \nng-click=\"vm.addContactFields(\'phone\', vm.location.contacts.phones)\" \nng-if=\"vm.location.contacts.phones.length < 3 && !vm.location.locked\"><button data-cy=\"contact-add-phone-button\" \nclass=\"fc-clone-button\">{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.ADD_PHONE\' | translate) }}</button></div></section>\n<h2 class=\"location-dialog__contacts-tab__main-container__subtitle\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.SUBTITLE_EMAIL\' | translate)}}</h2><section \nclass=\"location-dialog__contacts-tab__main-container__contacts-container\" \nng-class=\"{\'pb-0\': vm.location.contacts.emails.length === 3}\"><p \nclass=\"location-dialog__contacts-tab__main-container__contacts-container__empty-phrase\" \nng-if=\"!vm.location.contacts.emails || !vm.location.contacts.emails.length\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.EMPTY_EMAILS\' | translate)}}</p><div \nng-repeat=\"email in vm.location.contacts.emails track by $index\"><div flex layout=\"row\" \nclass=\"location-dialog__contacts-tab__main-container__contacts-container__input-groups\"><div flex=\"25\"><fc-select \nlabel=\"{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.FIELDS.EMAIL_TYPE\' | translate)}}\" ng-model=\"email.type\" \ndata-cy=\"email-type\" options=\"vm.emailsTypes\" is-disabled=\"$root.loadingProgress || vm.location.locked\" \nis-required=\"true\" input-name=\"email-type__{{$index}}\" input-control=\"vm.locationsForm[\'email-type__\' + $index]\">\n</fc-select></div><div flex=\"50\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" data-cy=\"email-address\" \nautocomplete=\"off\" class=\"fc-input__input\" name=\"email__{{$index}}\" ng-model=\"email.address\" \nng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n                  invalid: vm.locationsForm[\'email__\' + $index].$touched && vm.locationsForm[\'email__\' + $index].$invalid\n                }\" \nng-required=\"true\" email-validation><label class=\"fc-input__label\">\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.FIELDS.EMAIL\' | translate)}}</label><fc-error \nng-show=\"vm.locationsForm[\'email__\' + $index].$touched\" input-errors=\"vm.locationsForm[\'email__\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n                  },\n                  {\n                    name: \'pattern\',\n                    translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.EMAIL\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"25\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" data-cy=\"email-name\" autocomplete=\"off\" class=\"fc-input__input\" name=\"email-name__{{$index}}\" \nng-model=\"email.name\" ng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n                  invalid: vm.locationsForm[\'email-name__\' + $index].$touched && vm.locationsForm[\'email-name__\' + $index].$invalid\n                }\">\n<label class=\"fc-input__label\">{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.FIELDS.NAME\' | translate)}}</label></div>\n</div><md-button ng-if=\"!vm.location.locked\" flex=\"5\" class=\"md-icon-button\" aria-label=\"Delete contact\" translate \ntranslate-attr-aria-label=\"LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.DELETE_CONTACT\" \nng-click=\"!vm.location.locked && vm.deleteContactField(email, $index, vm.location.contacts.emails, \'email\')\">\n<md-tooltip md-direction=\"top\"><span translate=\"LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.DELETE_CONTACT\">Delete contact\n</span></md-tooltip><md-icon class=\"mt-8 delete-icon\" md-font-icon=\"icon-delete\"></md-icon></md-button></div><div flex \nlayout=\"row\" layout-align=\"start center\" \nclass=\"location-dialog__contacts-tab__main-container__contacts-container__select-main-contact\"><md-switch \nng-disabled=\"vm.location.locked\" ng-model=\"email.primary\" data-cy=\"email-primary-switch\" \nng-change=\"vm.changePrimaryContact($index, vm.location.contacts.emails, \'email\')\"><span>\n{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.SELECT_AS_MAIN_EMAIL\' | translate)}}</span></md-switch></div></div><div \nflex layout=\"row\" class=\"location-dialog__contacts-tab__main-container__contacts-container__input-groups\" \nng-click=\"vm.addContactFields(\'email\', vm.location.contacts.emails)\" \nng-if=\"vm.location.contacts.emails.length < 3 && !vm.location.locked\"><button data-cy=\"contact-add-email-button\" \nclass=\"fc-clone-button\">{{(\'LOCATIONS.DIALOG.CONTACT.CONTACT_INFOS.ADD_EMAIL\' | translate) }}</button></div></section>\n</div></main>");
$templateCache.put("app/main/locations/dialogs/tabs/equipments/equipments-tab.html","<ng-container class=\"location-dialog__equipments-tab\"><div class=\"fc-warning-container\" \nng-if=\"vm.location.id && vm.location.customer.locked && vm.location.customer.metadata.sammathnaur\"><div><md-icon \nclass=\"warning-icon\" md-svg-src=\"assets/icons/icon-padlock.svg\"></md-icon><span \ntranslate=\"CORE.CORPORATE_CUSTOMER_DISCLAIMER\" \ntranslate-values=\"{ customerName: vm.customerAccountName(vm.location.customer.metadata) }\">\nThe information about this page is defined by your customer <b>{{ customerName }}</b> and therefore can\'t be updated.\n</span></div></div><main class=\"location-dialog__equipments-tab__main-container\"><info-component-provider \ntext=\"{{ \'LOCATIONS.DIALOG.EQUIPMENTS.HINT\' | translate }}\"></info-component-provider><div layout=\"row\" \nng-if=\"!vm.location.locked\"><div layout=\"row\" flex=\"80\" \nclass=\"location-dialog__equipments-tab__main-container__search-bar\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" ng-model=\"vm.searchEquipmentText\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.searchEquipments()\" ng-disabled=\"false\"><label \nclass=\"fc-input__label\" translate=\"LOCATIONS.DIALOG.EQUIPMENTS.SEARCH_EQUIPMENTS\">Search for linked equipment</label>\n<small class=\"search-bar__hint\" translate=\"LOCATIONS.DIALOG.EQUIPMENTS.SEARCH_DESCRIPTION\">\nSearch by name or serial number.</small></div><button class=\"fc-input__button border brad-4\" \nng-click=\"vm.searchEquipments()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></button></div><button \nclass=\"new-equipment-button fc-button fc-blue full-height\" ng-click=\"vm.createEquipment($event)\" flex=\"20\" \ntranslate=\"LOCATIONS.DIALOG.EQUIPMENTS.REGISTER_NEW\">Register new</button></div><div layout=\"column\" \nclass=\"location-dialog__equipments-tab__main-container__equipments\"><h4 class=\"fs-16 fw-550\" \nng-class=\"{ \'location-dialog__equipments-tab__main-container__equipments__title\': vm.location.locked }\"><span \ntranslate=\"LOCATIONS.DIALOG.EQUIPMENTS.TITLE\">Equipments</span> ({{ vm.location.equipments.totalCount }})</h4><div \nlayout-xs=\"column\" layout=\"row\" flex=\"100\" ng-if=\"vm.location.equipments.items.length\" \nclass=\"b brad-4 mb-10 location-dialog__equipments-tab__main-container__equipments__item\" \nlayout-align=\"space-between center\" ng-repeat=\"equipment in vm.location.equipments.items track by $index\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"h-60 w-60 brad-4 ml-20\" ng-if=\"equipment.thumbnail\"><img \nngf-src=\"equipment.thumbnail\" alt=\"{{ equipment.name }}\" \nclass=\"location-dialog__equipments-tab__main-container__equipments__image\"></div><div layout=\"row\" \nclass=\"border h-60 w-60 brad-4 ml-20\" layout-align=\"center center\" ng-if=\"!equipment.thumbnail\"><svg width=\"18\" \nheight=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path \nd=\"M0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0H2C0.9 0 0 0.9 0 2ZM16 16H2V2H16V16ZM11.14 8.86L8.14 12.72L6 10.14L3 14H15L11.14 8.86Z\" \nfill=\"#D4DEF1\"/></svg></div><div flex=\"80\" layout=\"column\" class=\"ph-24\"><strong class=\"fs-14 mb-5\">\n{{ equipment.name }}</strong> <span class=\"fs-14 pt-6\">{{ equipment.number }}</span></div></div><div layout=\"column\" \nclass=\"remove-equipment ph-10\" ng-if=\"!vm.location.locked\"><md-button class=\"md-icon-button\" \nng-click=\"vm.editEquipment($event, equipment.id)\"><md-icon md-svg-src=\"assets/icons/icon-edit-product-service.svg\" \nclass=\"icon-edit clickable\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"LOCATIONS.DIALOG.EQUIPMENTS.EDIT_EQUIPMENT\">Edit equipment</span></md-tooltip></md-button></div></div><div \nng-if=\"vm.location.equipments.items.length\" \nclass=\"location-dialog__equipments-tab__main-container__equipments__navigation\" layout=\"row\" layout-align=\"end center\">\n<div class=\"location-dialog__equipments-tab__main-container__equipments__navigation__info\" aria-live=\"polite\"><span \ntranslate=\"LOCATIONS.DIALOG.EQUIPMENTS.PAGINATION.SHOWING_FROM\">Showing from</span>\n {{vm.skipEquipments === 0 ? \'1\' : vm.skipEquipments}} <span translate=\"LOCATIONS.DIALOG.EQUIPMENTS.PAGINATION.TO\">to\n</span>\n {{(vm.skipEquipments + vm.takeEquipments) >= vm.location.equipments.totalCount ? vm.location.equipments.totalCount : (vm.skipEquipments + vm.takeEquipments)}} \n<span translate=\"LOCATIONS.DIALOG.EQUIPMENTS.PAGINATION.OF\">of</span> {{vm.location.equipments.totalCount}} <span \ntranslate=\"LOCATIONS.DIALOG.EQUIPMENTS.PAGINATION.RECORDS\">records</span></div><button \nclass=\"fc-button location-dialog__equipments-tab__main-container__equipments__navigation__button\" \nng-class=\"{ disabled: vm.skipEquipments === 0 }\" aria-label=\"Previous\" \nng-click=\"vm.navigateToPage(vm.currentPage - 1, true)\" ng-disabled=\"vm.skipEquipments === 0\"><span \ntranslate=\"LOCATIONS.DIALOG.EQUIPMENTS.PAGINATION.PREVIOUS\">Previous</span></button> <button \nclass=\"fc-button location-dialog__equipments-tab__main-container__equipments__navigation__button\" \nng-class=\"{ disabled: (vm.skipEquipments + vm.takeEquipments) >= vm.location.equipments.totalCount }\" \naria-label=\"Next\" ng-click=\"vm.navigateToPage(vm.currentPage + 1, true)\" \nng-disabled=\"(vm.skipEquipments + vm.takeEquipments) >= vm.location.equipments.totalCount\"><span \ntranslate=\"LOCATIONS.DIALOG.EQUIPMENTS.PAGINATION.NEXT\">Next</span></button></div></div></main></ng-container>");
$templateCache.put("app/main/locations/dialogs/tabs/general/general-tab.html","<ng-container class=\"location-dialog__general-tab\"><div class=\"fc-warning-container\"><div \nng-if=\"!(vm.location.id && vm.location.customer.locked && vm.location.customer.metadata.sammathnaur)\"><md-switch \nng-if=\"(vm.location.id && vm.isTogglePrimaryLocationVisible) || !vm.location.id\" ng-model=\"vm.isPrimaryLocation\"><span \ntranslate=\"LOCATIONS.DIALOG.GENERAL.SELECT_AS_PRIMARY\"></span></md-switch><span \nng-if=\"vm.isPrimaryLocation && vm.location.id && !vm.isTogglePrimaryLocationVisible\" \ntranslate=\"LOCATIONS.DIALOG.GENERAL.PRIMARY_LOCATION\"></span></div><div data-cy=\"corporate-disclaimer\" \nng-if=\"vm.location.id && vm.location.customer.locked && vm.location.customer.metadata.sammathnaur\"><md-icon \nclass=\"warning-icon\" md-svg-src=\"assets/icons/icon-padlock.svg\"></md-icon><span \ntranslate=\"CORE.CORPORATE_CUSTOMER_DISCLAIMER\" \ntranslate-values=\"{ customerName: vm.customerAccountName(vm.location.customer.metadata) }\">\nThe information about this page is defined by your customer <b>{{ customerName }}</b> and therefore can\'t be updated.\n</span></div></div><main class=\"location-dialog__general-tab__main-container\"><h2 class=\"section-subtitle\">\n{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.TITLE\' | translate)}}</h2><div flex layout=\"row\" \nclass=\"location-dialog__general-tab__main-container__input-groups\"><div flex=\"80\"><div class=\"fc-input\"><input \ntype=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" data-cy=\"location-name-input\" \nname=\"locationName\" ng-change=\"vm.verifyDuplicatedNameLocation()\" ng-model=\"vm.location.name\" \nng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n              invalid: vm.locationsForm.locationName.$touched && vm.locationsForm.locationName.$invalid\n            }\" \nng-required=\"true\" ng-maxlength=\"240\"><label class=\"fc-input__label\">\n{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.LOCATION_NAME\' | translate)}}</label><fc-error \nng-show=\"vm.locationsForm.locationName.$touched\" input-errors=\"vm.locationsForm.locationName.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n              },\n              {\n                name: \'duplicatedName\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.DUPLICATED_LOCATION_NAME\'\n              },\n              {\n                name: \'maxlength\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.MAX_LENGTH\',\n                translateValues: { expectedLength: 240, receivedLength: vm.locationsForm.locationName.$viewValue.length }\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error><div style=\"text-align: right\"><span \nclass=\"fc-textarea__limit location-name ng-binding\">\n({{ vm.locationsForm.locationName.$viewValue.length ? vm.locationsForm.locationName.$viewValue.length : 0 }}/240)\n</span></div></div></div><div flex=\"30\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"documentNumber\" data-cy=\"document-number-input\" ng-model=\"vm.location.documentNumber\" \nng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n              invalid: vm.locationsForm.documentNumber.$touched && vm.locationsForm.documentNumber.$invalid\n            }\" \nui-br-cpfcnpj-mask><label class=\"fc-input__label\">\n{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.DOCUMENT_NUMBER\' | translate)}}</label><fc-error \nng-show=\"vm.locationsForm.documentNumber.$touched\" input-errors=\"vm.locationsForm.documentNumber.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'cpf\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.INVALID_DOCUMENT\',\n                translateValues: { documentName: \'CPF\' }\n              },\n              {\n                name: \'cnpj\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.INVALID_DOCUMENT\',\n                translateValues: { documentName: \'CNPJ\' }\n              },\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div \nclass=\"location-dialog__general-tab__main-container__toggle-location-search\" ng-if=\"!vm.location.locked\">\n<md-radio-group ng-model=\"vm.isGoogleAddress\"><md-radio-button data-cy=\"search-by-google-button\" ng-value=\"true\" \nclass=\"md-primary display-block\">{{(\'LOCATIONS.DIALOG.GENERAL.SEARCH_BY_GOOGLE\' | translate)}}</md-radio-button>\n<md-radio-button data-cy=\"search-by-cep-button\" ng-value=\"false\" class=\"md-primary display-block\">\n{{(\'LOCATIONS.DIALOG.GENERAL.SEARCH_BY_CEP\' | translate)}}</md-radio-button></md-radio-group><md-button \nclass=\"md-icon-button\" data-cy=\"customer-location-update-coordinates\" \nng-click=\"vm.openMapDialog($event, vm.location.address)\"><md-icon ng-class=\"{ \'enabled-icon\': vm.showMap }\" \nmd-font-icon=\"icon-map\"></md-icon><md-tooltip><span ng-if=\"vm.showMap\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.UPDATE_COORDINATES\"></span> <span ng-if=\"!vm.showMap\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.UPDATE_COORDINATES_DISABLED\"></span></md-tooltip></md-button></div><div\n flex layout=\"row\" class=\"location-dialog__general-tab__main-container__input-groups\" ng-if=\"vm.isGoogleAddress\"><div \nflex=\"100\"><fc-autocomplete focus-id=\"locations-google-address\" \nlabel=\"{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.LOCATION_ADDRESS\' | translate)}}\" \noptions=\"vm.googleLocations\" track-by=\"formattedAddress\" ng-model=\"vm.selectedGoogleLocation\" \nng-change=\"vm.selectedGoogleAddressChange()\" is-disabled=\"vm.location.locked\" is-required=\"true\" \ninput-name=\"googleLocation\" data-cy=\"google-location-input\" input-control=\"vm.locationsForm.googleLocation\" \nsearch-function=\"vm.searchLocationByGoogle()\" search-term=\"vm.locationByGoogleSearchTerm\" \nerrors-to-watch=\"[\n            {\n            name: \'required\',\n            translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n            }\n          ]\">\n</fc-autocomplete><div class=\"hint location-dialog__general-tab__main-container__input-groups__hint\"><div \nng-repeat=\"error in vm.googleLocationAddressErrors\"><md-icon md-font-icon=\"icon-alert\" class=\"red-fg fs-14\"></md-icon>\n<span>{{ \'CORE.ADDRESS_SERVICE.VALIDATION.\' + error | translate }}</span></div><div \nng-repeat=\"warning in vm.googleLocationAddressWarnings\"><md-icon md-font-icon=\"icon-alert\" class=\"orange-fg fs-14\">\n</md-icon><span>{{ \'CORE.ADDRESS_SERVICE.VALIDATION.\' + warning | translate }}</span></div></div></div></div><div flex \nlayout=\"row\" class=\"location-dialog__general-tab__main-container__input-groups\" ng-if=\"!vm.isGoogleAddress\"><div \nflex=\"30\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" \nname=\"cep\" data-cy=\"cep-input\" ng-model=\"vm.location.address.postalCode\" ng-blur=\"vm.cepDb()\" \nng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n              invalid: vm.locationsForm.cep.$touched && vm.locationsForm.cep.$invalid\n            }\" \nng-required=\"true\" ng-pattern=\"/(^[0-9]{1,8}$)|(^[0-9]{5}-[0-9]{3}$)/\"><label class=\"fc-input__label\">\n{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.CEP\' | translate)}}</label><fc-error \nng-show=\"vm.locationsForm.cep.$touched\" input-errors=\"vm.locationsForm.cep.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n              },\n              {\n                name: \'pattern\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.PATTERN_ZIP_CODE\'\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"40\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"street\" data-cy=\"street-input\" \nng-model=\"vm.location.address.street\" ng-blur=\"vm.geoCoderAddress()\" \nng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n              invalid: vm.locationsForm.street.$touched && vm.locationsForm.street.$invalid\n            }\">\n<label class=\"fc-input__label\">{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.STREET\' | translate)}}\n</label></div></div><div flex=\"30\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"number\" data-cy=\"number-input\" ng-model=\"vm.location.address.number\" \nng-blur=\"vm.geoCoderAddress()\" ng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n              invalid: vm.locationsForm.number.$touched && vm.locationsForm.number.$invalid\n            }\">\n<label class=\"fc-input__label\">{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.NUMBER\' | translate)}}\n</label></div></div></div><div flex layout=\"row\" class=\"location-dialog__general-tab__main-container__input-groups\" \nng-if=\"!vm.isGoogleAddress\"><div flex=\"30\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"neighborhood\" data-cy=\"neighborhood-input\" ng-model=\"vm.location.address.neighborhood\" \nng-blur=\"vm.geoCoderAddress()\" ng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n              invalid: vm.locationsForm.neighborhood.$touched && vm.locationsForm.neighborhood.$invalid\n            }\">\n<label class=\"fc-input__label\">{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.NEIGHBORHOOD\' | translate)}}\n</label></div></div><div flex=\"40\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"city\" data-cy=\"city-input\" ng-model=\"vm.location.address.city\" \nng-blur=\"vm.geoCoderAddress()\" ng-disabled=\"$root.loadingProgress|| vm.location.locked\" \nng-class=\"{\n              invalid: vm.locationsForm.city.$touched && vm.locationsForm.city.$invalid\n            }\" \nng-required=\"true\"><label class=\"fc-input__label\">\n{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.CITY\' | translate)}}</label><fc-error \nng-show=\"vm.locationsForm.city.$touched\" input-errors=\"vm.locationsForm.city.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"30\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"state\" data-cy=\"state-input\" \nng-model=\"vm.location.address.state\" ng-blur=\"vm.geoCoderAddress()\" \nng-disabled=\"$root.loadingProgress || vm.location.locked\" \nng-class=\"{\n              invalid: vm.locationsForm.state.$touched && vm.locationsForm.state.$invalid\n            }\" \nng-required=\"true\"><label class=\"fc-input__label\">\n{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.STATE\' | translate)}}</label><fc-error \nng-show=\"vm.locationsForm.state.$touched\" input-errors=\"vm.locationsForm.state.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div \nclass=\"location-dialog__general-tab__territories\" ng-if=\"vm.hasTerritoriesFlag\"><div \nclass=\"location-dialog__general-tab__territories__container\"><span \nclass=\"location-dialog__general-tab__territories__label\">{{ \'LOCATIONS.DIALOG.GENERAL.TERRITORIES\' | translate }}\n</span><div class=\"location-dialog__general-tab__territories__list\"><div \nng-repeat=\"territory in vm.location.territories\" class=\"location-dialog__general-tab__territories__item\"><span>\n{{ territory.name }}</span></div></div></div><div class=\"location-dialog__general-tab__territories__container\"><span \nclass=\"location-dialog__general-tab__territories__label\">{{ \'LOCATIONS.DIALOG.GENERAL.SUBTERRITORIES\' | translate }}\n</span><div class=\"location-dialog__general-tab__territories__list\"><div \nng-repeat=\"subTerritory in vm.location.subTerritories\" class=\"location-dialog__general-tab__territories__item\"><span>\n{{ subTerritory.name }}</span></div></div></div></div><div flex layout=\"row\" \nclass=\"location-dialog__general-tab__main-container__input-groups\"><div flex=\"100\"><fc-smart-rewrite \nreference-id=\"vm.location.id || vm.sessionId\" reference-type=\"location-complement\" \ndisabled=\"$root.loadingProgress || vm.location.locked\" class=\"flex-100\"><fc-textarea \nis-disabled=\"$root.loadingProgress || vm.location.locked\" \nlabel=\"{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.ADDRESS_COMPLEMENT\' | translate)}}\" \nng-model=\"vm.location.address.complement\" input-name=\"complement\" data-cy=\"complement-input\" \ninput-control=\"vm.locationsForm.complement\" max-length=\"100\" \nerrors-to-watch=\"[\n              {\n                name: \'maxlength\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.MAX_LENGTH\',\n                translateValues: { expectedLength: 100, receivedLength: vm.locationsForm.complement.$viewValue.length }\n              },\n            ]\">\n</fc-textarea></fc-smart-rewrite></div></div><div flex layout=\"row\" \nclass=\"location-dialog__general-tab__main-container__input-groups\"><div flex=\"100\"><fc-autocomplete data-cy=\"customer\" \nis-required=\"true\" is-disabled=\"$root.loadingProgress || vm.location.locked\" \nlabel=\"{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.CUSTOMER\' | translate)}}\" options=\"vm.customers\" \nng-class=\"{\n            invalid: inputControl.$invalid\n          }\" ng-model=\"vm.location.customer\" \ninput-control=\"vm.locationsForm.customer\" input-name=\"customer\" search-function=\"vm.searchCustomerByName()\" \nsearch-term=\"vm.customerSearchTerm\" ng-change=\"vm.verifyDuplicatedNameLocation()\" track-by=\"name\" debounce=\"600\" \nerrors-to-watch=\"[{\n            name: \'required\',\n            translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n          }, {\n            name: \'create-location-disabled-by-corporate\',\n            translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.DISABLED_CREATE_LOCATION\',\n            translateValues: { customerAccountName: vm.customerAccountName(vm.locationsForm.customer.$modelValue.metadata) }\n          }]\">\n</fc-autocomplete></div></div><div flex layout=\"row\" \nclass=\"location-dialog__general-tab__main-container__input-groups\"><div flex=\"100\"><fc-smart-rewrite \nreference-id=\"vm.location.id || vm.sessionId\" reference-type=\"location-notes\" \ndisabled=\"$root.loadingProgress || vm.location.locked\" class=\"flex-100\"><fc-textarea \nis-disabled=\"$root.loadingProgress || vm.location.locked\" \nlabel=\"{{(\'LOCATIONS.DIALOG.GENERAL.SECTIONS.LOCATION_DATA.FIELDS.NOTES\' | translate)}}\" ng-model=\"vm.location.notes\" \ninput-name=\"notes\" data-cy=\"notes-input\" input-control=\"vm.locationsForm.notes\" max-length=\"300\" \nerrors-to-watch=\"[\n              {\n                name: \'maxlength\',\n                translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.MAX_LENGTH\',\n                translateValues: { expectedLength: 300, receivedLength: vm.locationsForm.notes.$viewValue.length }\n              },\n            ]\">\n</fc-textarea></fc-smart-rewrite></div></div></main></ng-container>");
$templateCache.put("app/main/locations/dialogs/tabs/location-links/location-links-tab.html","<main><location-links-tab-provider id=\"location-links-tab\" ng-attr-location-id=\"{{ vm.location.id }}\">\n</location-links-tab-provider></main>");
$templateCache.put("app/main/locations/dialogs/tabs/tasks/tasks-tab.html","<div ng-if=\"vm.timeline.length <= 0\"><p class=\"text-center\"><i class=\"icon-history s40\"></i><br><span \ntranslate=\"LOCATIONS.DIALOG.VIEW.TABS.SERVICES.NO_HISTORY\">This location has no service history.</span></p></div><a \nng-if=\"vm.timeline.length > 0\" class=\"to-task-list\" layout=\"row\" \nng-href=\"#/atividades?q=nome_localizacao:\'{{ vm.location.name }}\'+data_agendamento<=:{{ vm.lastTaskDate }}+data_agendamento>=:{{ vm.firstTaskDate }}\" \naria-label=\"ir para listagem de atividades\" ng-click=\"vm.closeDialog();\"><div flex=\"80\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"to-task-list__title\" \ntranslate=\"LOCATIONS.DIALOG.VIEW.TABS.SERVICES.GO_TO_TASKS_LIST\">Go to tasks list</span></div><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button to-task-list__button\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip md-direction=\"left\"><span \ntranslate=\"LOCATIONS.DIALOG.VIEW.TABS.SERVICES.GO_TO_TASKS_LIST\">Go to tasks list</span></md-tooltip></md-button></div>\n</a><div id=\"timeline-location\" class=\"timeline-location fs-13\" ng-if=\"vm.timeline.length > 0\" ms-timeline><div \nms-timeline-item layout=\"column\" layout-align=\"start start\" layout-gt-md=\"row\" layout-align-gt-md=\"start start\" \nng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-start\" layout=\"column\"><div \nng-style=\"{\'background-color\': timelineItem.color}\" class=\"timeline-point md-accent-bg\"><md-icon \nmd-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-line\"></div></div><div class=\"timeline-card\" \nlayout=\"row\" flex-md=\"100\" flex=\"90\"><div class=\"ms-card ms-card-location\" ng-model=\"timelineItem.card\"><div \nclass=\"card\"><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"timelineItem.avatar\"><img \nclass=\"avatar mr-16\" ng-src=\"{{timelineItem.avatar.src}}\" alt=\"{{timelineItem.avatar.alt}}\"></div><div class=\"info\">\n<div layout=\"row\"><div flex=\"70\" class=\"title\" ng-if=\"timelineItem.title\">{{timelineItem.title}}</div><div flex=\"30\" \nclass=\"created-at\" ng-if=\"timelineItem.createdAt\">{{timelineItem.createdAt}}</div></div><div layout=\"row\"><div \nclass=\"subtitle\" ng-if=\"timelineItem.subtitle\" ng-style=\"{color: timelineItem.subtitleColor};\">\n{{timelineItem.subtitle}}</div></div></div></div><div class=\"text ph-16\" ng-if=\"timelineItem.text\" \nng-bind-html=\"timelineItem.text\"></div><div><md-button class=\"show-button\" ng-click=\"vm.openTask(timelineItem.task);\">\n{{ \'LOCATIONS.DIALOG.VIEW_VISIT\' | translate }}</md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/plans/dialogs/plans/plans-info/actual-plan.html","<div class=\"simple-table-container\" ng-if=\"vm.tasks.length\"><table class=\"simple plans-table\" ms-responsive-table>\n<thead class=\"fs-13\"><tr><th translate=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.CUSTOMER_NAME\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.CUSTOMER_NAME\">Customer</th><th \ntranslate=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.LOCATION_NAME\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.LOCATION_NAME\">Location</th><th \ntranslate=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.OS_TYPE\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.OS_TYPE\">Os Type</th><th \ntranslate=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.SCHEDULE_DATE\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.SCHEDULE_DATE\">Schedule Date</th><th \ntranslate=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.EMPLOYEE\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.EMPLOYEE\">Employee</th><th \ntranslate=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.STATUS\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.ACTUAL_PLAN.COLUMNS.STATUS\">Status</th></tr></thead><tbody class=\"fs-13\">\n<tr class=\"cursor-pointer\" ng-repeat=\"task in vm.currentTasks\" ng-click=\"vm.editOrder($event, task.order.id)\"><td>\n{{ task.customer.name }}</td><td><span ng-if=\"task.order.location && task.order.location.name\">\n{{ task.order.location.name }}</span></td><td>{{ task.service.description }}</td><td>\n{{ task.scheduling.formattedDate || \'\' }}</td><td>{{ task.employee.name }}</td><td class=\"{{task.status.name}}-fg\">\n{{ task.status.description }}</td></tr></tbody></table></div><div ng-if=\"!vm.tasks.length\" class=\"comment\"><div \nclass=\"reload-activity-plans\"><p><i class=\"icon-reload-activity-plans\"></i><br><span class=\"text-reload\" \ntranslate=\"PLANS.TABLE.INFO.ACTUAL_PLAN.WAITING_GENERATE\">\nActivities are being generated. In a few minutes, they will appear here!</span></p></div></div>");
$templateCache.put("app/main/plans/dialogs/plans/plans-info/new-plan.html","<div class=\"simple-table-container container\"><table class=\"simple plans-table\" ms-responsive-table><thead \nclass=\"fs-13\"><tr><th width=\"5%\"></th><th width=\"5%\" translate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.VALIDATION\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.VALIDATION\">Validation</th><th \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.OS_TYPE\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.OS_TYPE\">OS Type</th><th \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_NAME\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_NAME\">Customer</th><th \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.LOCATION_NAME\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.LOCATION_NAME\">Location name</th><th \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.EMPLOYEE_NAME\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.EMPLOYEE_NAME\">Employee</th><th \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.SCHEDULE_DATE\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.SCHEDULE_DATE\">Schedule Date</th></tr></thead><tbody \nclass=\"fs-13\"><tr class=\"cursor-pointer\" \nng-repeat-start=\"plan in vm.currentPlans | orderBy:\'statusValidator === invalid\'\" \nng-click=\"plan.expanded = !plan.expanded\"><td><md-icon class=\"grey-800-fg\" md-font-icon=\"icon-chevron-down\" \nng-if=\"!plan.expanded\"><md-tooltip md-direction=\"down\"><span translate=\"PLANS.TABLE.INFO.NEW_PLAN.MORE_DETAILS\">\nShow more details</span></md-tooltip></md-icon><md-icon class=\"grey-800-fg\" md-font-icon=\"icon-chevron-up\" \nng-if=\"plan.expanded\"><md-tooltip md-direction=\"down\"><span translate=\"PLANS.TABLE.INFO.NEW_PLAN.LESS_DETAILS\">\nShow less details</span></md-tooltip></md-icon></td><td><md-icon class=\"inconsistency-plans-label-color\" \nmd-font-icon=\"icon-close\" ng-if=\"plan.statusValidator === \'invalid\'\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.INVALID\">Invalid</span></md-tooltip></md-icon><md-icon class=\"green-800-fg\" \nmd-font-icon=\"icon-check\" ng-if=\"plan.statusValidator === \'valid\'\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.VALID\">Valid</span></md-tooltip></md-icon></td><td>{{ plan.service.description }}\n</td><td><span ng-if=\"plan.customer.name\">{{ plan.customer.name }}</span> <span ng-if=\"plan.customer.documentNumber\">\n- {{ plan.customer.documentNumber }} </span></td><td><span ng-if=\"plan.location.name\">{{ plan.location.name }}</span>\n</td><td>{{ plan.employee.name }}</td><td>{{ plan.scheduledDate }} {{ plan.scheduledHour }}</td></tr><tr \nng-if=\"plan.expanded\" ng-repeat-end=\"\"><td colspan=\"11\"><div class=\"ml-70\"><div \nng-if=\"plan.statusValidatorDescriptions && plan.statusValidatorDescriptions.length\"><h3 \nclass=\"text-bold inconsistency-plans-label-color pl-40\">Inconsistência(s):</h3><ul class=\"invalid-plan-list\"><li \nng-repeat=\"statusValidatorDescription in plan.statusValidatorDescriptions\"><b>{{statusValidatorDescription.property}}\n</b>: {{statusValidatorDescription.error}}</li></ul></div><div><h3 class=\"text-bold plans-label-color pl-40\" \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.ACTIVITY_PLAN\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.ACTIVITY_PLAN\">Activity Plan</h3><ul class=\"plan-list\"><li><b \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.OS_TYPE\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.OS_TYPE\">OS Type </b>: {{ plan.service.description }}</li>\n<li><b translate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_DOCUMENT_NUMBER\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_DOCUMENT_NUMBER\">Document Number </b><span \nng-if=\"plan.customer.documentNumber\">: {{ plan.customer.documentNumber }}</span></li><li><b \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_NAME\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.CUSTOMER_DOCUMENT_NUMBER\">Customer name </b><span \nng-if=\"plan.customer.name\">: {{ plan.customer.name }}</span></li><li><b \ntranslate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.LOCATION_NAME\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.LOCATION_NAME\">Location name </b>\n: {{ plan.location.name }}</li><li><b translate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.EQUIPMENT_NUMBER\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.EQUIPMENT_NUMBER\">Equipment Number </b>\n: {{ plan.equipment.number }}</li><li><b translate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.EMPLOYEE_NAME\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.EMPLOYEE_NAME\">Employee Name </b>\n: {{ plan.employee.name }}</li><li><b translate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.SCHEDULE_DATE\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.SCHEDULE_DATE\">Scheduled Date </b>\n: {{ plan.scheduledDate }}</li><li><b translate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.SCHEDULE_HOUR\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.SCHEDULE_HOUR\">Scheduled Hour </b>\n: {{ plan.scheduledHour }}</li><li><b translate=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.DESCRIPTION\" \ntranslate-attr-aria-label=\"PLANS.TABLE.INFO.NEW_PLAN.COLUMNS.DESCRIPTION\">Description </b>: {{ plan.description }}</li>\n</ul></div></div></td></tr></tbody></table></div>");
$templateCache.put("app/main/products/dialogs/tabs/general/general-tab.html","<ng-container><div ng-if=\"!vm.product.locked && (!productForm.type.$touched || productForm.type.$valid)\" \nclass=\"fc-warning-container\"><md-icon class=\"warning-icon\" md-svg-src=\"/assets/icons/icon-alert.svg\"></md-icon><span \ntranslate=\"PRODUCTS.DIALOG.PRODUCT_ALERT\"></span></div><div \nng-if=\"productForm.type.$error.required && productForm.type.$touched\" class=\"fc-warning-container\"><md-icon \nclass=\"warning-icon\" md-svg-src=\"/assets/icons/icon-alert.svg\"></md-icon><span \ntranslate=\"PRODUCTS.DIALOG.CREATE_TYPE_ALERT\"></span> <a href=\"#/tipos-de-produto\" ng-click=\"vm.closeDialog()\" \nclass=\"md-default-theme\">&nbsp;{{(\'PRODUCTS.DIALOG.PRODUCT_TYPE_ALERT\' | translate)}}</a></div><form \nname=\"vm.productForm\" class=\"md-inline-form\" novalidate><corporate-customer-disclaimer \nng-if=\"vm.product.metadata && vm.product.metadata.sammathnaur\" \ncustomer-name=\"vm.product.metadata.sammathnaur.account.name\"></corporate-customer-disclaimer><div ms-scroll \nclass=\"products-dialog__general-tab__content\"><div class=\"omie-declaration-product-container\" ng-if=\"vm.omieAccount\">\n<md-icon md-svg-src=\"assets/icons/icon-omie-active.svg\" class=\"omie-declaration-product-icon\"><md-tooltip \nmd-direction=\"top\"><span>Omie</span></md-tooltip></md-icon><p translate=\"PRODUCTS.IMPORT.FROM\" \nclass=\"omie-declaration-product-text\" translate-values=\"{ account: vm.omieAccount }\">Product imported from</p></div>\n<div layout-xs=\"column\" layout=\"row\" class=\"mt-0 products-input-container\"><div layout=\"row\"><fc-image-input \ndata-cy=\"field.image.url\" class=\"fc-image-input__image-container--change-border-color\" ng-disabled=\"vm.product.locked\" \nname=\"imageUrl\" input-control=\"productForm.imageUrl\" ng-model=\"vm.product.imageUrl\" \nimage-file=\"vm.productResultImageFile\" img-custom-class=\"products-image\" \nng-class=\"{\n              \'img-products-disabled\': vm.product.locked\n            }\" height=\"120px\" width=\"120px\">\n</fc-image-input><div class=\"insert-picture\"><md-button class=\"insert-picture-button\" data-cy=\"select-image-button\" \nng-disabled=\"vm.productResultImageFile || vm.product.imageUrl || vm.product.locked\" ng-click=\"vm.selectImage()\" \ntranslate=\"PRODUCTS.DIALOG.SELECT_IMAGES\">Selecionar imagens</md-button><div \nclass=\"customer-dialog__general-tab__avatar-description ml-20\"><p>{{(\'PRODUCTS.DIALOG.IMAGE_INFORMATION\' | translate)}}\n</p></div></div></div></div><div class=\"inputs-product-container\"><div flex=\"65\"><div class=\"fc-input\"><input \ndata-cy=\"field.name\" type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"name\" \nng-model=\"vm.product.name\" ng-disabled=\"vm.product.locked\" ng-maxlength=\"150\" \nng-class=\"{\n                invalid: productForm.name.$touched && productForm.name.$invalid,\n                \'input-products-locked\': vm.product.locked\n              }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'PRODUCTS.MODEL.NAME\' | translate)}}</label><fc-error \nng-show=\"productForm.name.$touched\" input-errors=\"productForm.name.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'PRODUCTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                },\n                {\n                  name: \'maxlength\',\n                  translate: \'PRODUCTS.MODEL.ERRORS.MAX_LENGTH\',\n                  translateValues: { expectedLength: 150, receivedLength: productForm.name.$viewValue.length }\n                },\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"35\"><div class=\"fc-input\"><input \ndata-cy=\"field.value\" type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"value\" \nng-model=\"vm.product.value\" ng-disabled=\"vm.product.locked\" min=\"0.00\" ui-money-mask \nng-class=\"{\n                invalid: productForm.value.$touched && productForm.value.$invalid,\n                \'input-products-locked\': vm.product.locked\n              }\" \nng-required=\"true\"><label class=\"fc-input__label\" translate=\"PRODUCTS.MODEL.VALUE\" \ntranslate-values=\"{ currency: vm.currencySymbol }\"></label><fc-error ng-show=\"productForm.value.$touched\" \ninput-errors=\"productForm.value.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'PRODUCTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div class=\"inputs-product-container\"><div \ndata-cy=\"field-meassure-select\" flex=\"50\"><fc-select ng-class=\"{\'img-products--disabled\': vm.product.locked}\" \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{ \'PRODUCTS.DIALOG.MEASURE\' | translate }}\" ng-model=\"vm.product.measure\" options=\"vm.measuresSelectOptions\" \nis-required=\"vm.product.type === \'product\'\" input-name=\"measure\" input-control=\"productForm.measure\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'PRODUCTS.MODEL.ERRORS.FIELD_REQUIRED\'\n              }\n            ]\">\n</fc-select></div><div flex=\"50\"><fc-select data-cy=\"field-type-select\" \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{(\'PRODUCTS.MODEL.TYPE.LABEL\' | translate)}}\" ng-model=\"vm.product.productType\" \noptions=\"vm.productTypesSelectOptions\" track-by=\"name\" is-required=\"true\" input-name=\"type\" \ninput-control=\"productForm.type\" is-disabled=\"vm.product.locked\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'PRODUCTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                }\n              ]\">\n</fc-select></div></div><div class=\"inputs-product-container\"><div flex=\"50\"><div class=\"fc-input\"><input \ndata-cy=\"field.code\" type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"code\" \nng-model=\"vm.product.code\" ng-disabled=\"vm.product.locked\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.verifyDuplicatedProductCode()\" \nng-class=\"{\n                invalid: productForm.code.$touched && productForm.code.$invalid,\n                \'input-products-locked\': vm.product.locked\n              }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'PRODUCTS.MODEL.CODE\' | translate)}}</label><fc-error \nng-show=\"productForm.code.$touched || productForm.code.length\" input-errors=\"productForm.code.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'PRODUCTS.MODEL.ERRORS.FIELD_REQUIRED\'\n                },\n                {\n                  name: \'duplicated\',\n                  translate: \'PRODUCTS.MODEL.ERRORS.DUPLICATED_CODE\'\n                },\n                {\n                  name: \'duplicatedArchived\',\n                  translate: \'PRODUCTS.MODEL.ERRORS.DUPLICATED_CODE_ARCHIVED\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"50\" class=\"fc-input\"><md-button \nclass=\"fc-input__input qrcode-container\" id=\"qrCode\" name=\"qrCode\" ng-model=\"vm.product.qrCode\" ng-maxlength=\"100\" \nng-click=\"!vm.product.qrCode ? vm.generateQRCode() : vm.viewQRCode()\"><div class=\"\"><md-button \nng-show=\"!vm.product.qrCode\" class=\"md-icon-button md-accent qrcode__button-center\" aria-label=\"Generate QR code\" \ntranslate-attr-aria-label=\"PRODUCTS.MODEL.QR_CODE.GENERATE\" data-cy=\"product-qr-code-button\"><md-icon \nmd-font-icon=\"icon-qrcode\" class=\"fs-18\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"PRODUCTS.MODEL.QR_CODE.GENERATE\">Generate QR code</span></md-tooltip></md-button><md-button \nng-show=\"vm.product.qrCode\" class=\"md-icon-button md-accent qrcode__button-center\" aria-label=\"Show QR code\" \ntranslate-attr-aria-label=\"PRODUCTS.MODEL.QR_CODE.DOWNLOAD_LINK_MESSAGE\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"fs-18\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"PRODUCTS.MODEL.QR_CODE.DOWNLOAD_LINK_MESSAGE\">Show QR code</span></md-tooltip></md-button></div><span \ntranslate=\"{{ !vm.product.qrCode ? \'PRODUCTS.MODEL.QR_CODE.GENERATE_QRCODE\' : \'PRODUCTS.MODEL.QR_CODE.VIEW_QRCODE\' }}\">\n</span> <a id=\"productDownloadLink\" class=\"download-link\" ng-click=\"vm.downloadQRCode();\" \ndownload=\"produto-{{ vm.product.qrCode }}.png\">Download</a><qrcode id=\"product-qrcode-download\" class=\"download-link\" \nversion=\"6\" error-correction-level=\"M\" size=\"250\" data=\"{{ vm.product.qrCode }}\"></qrcode></md-button></div></div><div \nlayout-xs=\"column\" layout=\"row\" class=\"mt-24\"><div flex=\"100\"><fc-smart-rewrite \nreference-id=\"vm.product.id || vm.sessionId\" reference-type=\"product-description\" disabled=\"vm.product.locked\">\n<fc-textarea data-cy=\"field.description\" class=\"fc-textarea__textarea--change-border-color\" \nis-disabled=\"vm.product.locked\" label=\"{{(\'PRODUCTS.MODEL.DESCRIPTION\' | translate)}}\" \nng-model=\"vm.product.description\" input-name=\"description\" input-control=\"productForm.description\" \nng-class=\"{\n                \'input-products-locked\': vm.product.locked\n              }\" max-length=\"2000\" \nerrors-to-watch=\"[\n                {\n                  name: \'maxlength\',\n                  translate: \'PRODUCTS.MODEL.ERRORS.MAX_LENGTH\',\n                  translateValues: { expectedLength: 2000, receivedLength: productForm.description.$viewValue.length }\n                },\n              ]\">\n</fc-textarea></fc-smart-rewrite></div></div></div></form></ng-container>");
$templateCache.put("app/main/products/dialogs/tabs/storage/storage-tab.html","<ng-container><div><div ng-hide=\"vm.product.locked\" class=\"fc-warning-container\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"/assets/icons/icon-alert.svg\"></md-icon><span translate=\"PRODUCTS.DIALOG.STORAGE_ALERT\"></span></div>\n<product-tab-storage-provider ng-attr-id=\"{{ vm.product.id }}\"></product-tab-storage-provider></div></ng-container>");
$templateCache.put("app/main/quotations/dialogs/components/quotation-expenses/quotation-expenses.component.html","<div class=\"expenses-tab__header\" layout=\"row\"><div flex=\"100\"><h4 class=\"subtitle\" \ntranslate=\"QUOTATIONS.DIALOG.EXPENSES.ITEMS\" translate-values=\"{ length: vm.items.length }\">Expense</h4></div><button \nng-class=\"{ disabled: vm.quotation.id && vm.quotation.status !== \'pending\' }\" ng-click=\"vm.selectExpense($event)\" \nflex=\"20\" type=\"submit\" aria-label=\"Create expense\" data-cy=\"register-new\" \nclass=\"expenses-tab__header__button fc-button\" translate=\"QUOTATIONS.DIALOG.EXPENSES.BUTTONS.ADD_EXPENSE\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.EXPENSES.BUTTONS.ADD_EXPENSE\">Add expense</button></div><div \nclass=\"empty__items\" layout-align=\"center center\" ng-if=\"!vm.items.length\"><md-icon md-font-icon=\"icon-alert-circle\">\n</md-icon><p translate=\"QUOTATIONS.DIALOG.EXPENSES.NO_EXPENSES_ADDED\">No expense added.</p></div><div \nng-repeat=\"item in vm.items | orderBy:\'-position\' track by $index\" class=\"expenses-tab__items-container\" \nlayout=\"column\"><div class=\"expenses-tab__items-container__item\" layout=\"column\" data-cy=\"quotation-item\"><div \nclass=\"mb-20\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"expenses-tab__items-container__item__without-image\"><md-icon md-svg-src=\"assets/icons/coin-outline.svg\">\n</md-icon></div><div class=\"expenses-tab__items-container__item__item-infos\" layout=\"column\"><main layout=\"row\" \nclass=\"expenses-tab__items-container__item__item-infos__content\"><div flex=\"70\"><div \nclass=\"expenses-tab__items-container__item__item-infos__content__info\"><p title=\"{{ item.expense.name }}\">\n{{ item.expense.name | maxLength: 60 }}</p></div></div><div class=\"fc-input\" \nng-if=\"!item.id && vm.quotation.id && vm.quotation.status === \'pending\'\"><button \nng-click=\"vm.createQuotationExpense(item)\" \nclass=\"expenses-tab__items-container__item__item-infos__content__create_button\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s20 clickable icon-create\"></md-icon><span translate=\"QUOTATIONS.DIALOG.EXPENSES.BUTTONS.SAVE\">Save</span>\n</button></div><div class=\"fc-input\"><button ng-click=\"vm.removeItem(item)\" \nclass=\"expenses-tab__items-container__item__item-infos__content__remove_button\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s20 clickable icon-delete\"></md-icon><span translate=\"QUOTATIONS.DIALOG.EXPENSES.BUTTONS.REMOVE\">Remove</span>\n</button></div></main></div></div><fc-smart-rewrite reference-id=\"item.sessionId || item.referenceId || item.id\" \nreference-type=\"quotation-product-service-description\" disabled=\"vm.hideButton\" class=\"flex-100\"><fc-textarea \nid=\"expenseDesc__{{item.position}}\" is-disabled=\"vm.hideButton\" class=\"fc-textarea__textarea--change-border-color\" \nlabel=\"{{(\'QUOTATIONS.DIALOG.EXPENSES.LABELS.DESCRIPTION\' | translate)}}\" ng-model=\"item.description\" \nng-change=\"vm.updateTotal(item)\" input-name=\"expenseDesc__{{item.position}}\" \ninput-control=\"vm.quotationForm[\'expenseDesc__\' + item.position]\" max-length=\"2000\" \nerrors-to-watch=\"[\n            {\n              name: \'maxlength\',\n              translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n              translateValues: { expectedLength: 2000, receivedLength: vm.quotationForm[\'expenseDesc__\' + item.position].$viewValue.length }\n            },\n          ]\">\n</fc-textarea></fc-smart-rewrite><div layout=\"row\" class=\"expenses-tab__items-container__item__item-infos__content\">\n<div flex=\"20\"><div class=\"fc-input\"><input type=\"text\" name=\"expenseTotal__{{item.position}}\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--change-border-color\" ng-model=\"item.total\" \nng-change=\"vm.updateTotal(item)\" ng-disabled=\"vm.quotation.status !== \'pending\'\" \ninput-control=\"vm.quotationForm[\'expenseTotal__\' + item.position]\" min=\"0.01\" ng-required=\"true\" ui-money-mask \nng-class=\"{\n              invalid: vm.quotationForm[\'expenseTotal__\' + item.position].$touched && vm.quotationForm[\'expenseTotal__\' + item.position].$invalid,\n              disabled: vm.quotation.id && vm.quotation.status !== \'pending\',\n              \'warning-border\': item.total > item.expense.maxValue\n            }\">\n<label class=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.EXPENSES.LABELS.VALUE\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div><div flex=\"80\"><div class=\"fc-input\" \nng-class=\"{ \'has-file\': item.path }\"><div \nclass=\"fc-input--attachment fc-input__input--change-border-color fc-input__input\" \nng-class=\"{\n            invalid: vm.quotationForm[\'fileInput_\' + item.position].$touched && vm.quotationForm[\'fileInput_\' + item.position].$invalid,\n            disabled: vm.quotation.id && vm.quotation.status !== \'pending\'\n          }\">\n<input id=\"fileInput_{{item.position}}\" type=\"file\" class=\"fc-input__file\" title=\"\" \nng-upload-change=\"vm.handleFileChange($event, item)\" ng-model=\"item.path\" ng-required=\"item.expense.receiptRequired\" \nname=\"fileInput_{{item.position}}\" input-control=\"vm.quotationForm[\'fileInput_\' + item.position]\" \nng-disabled=\"vm.quotation.status !== \'pending\'\" \nng-class=\"{\n                disabled: vm.quotation.id && vm.quotation.status !== \'pending\'\n              }\"><label \nng-if=\"item.path\" class=\"fc-input__label\" \nng-class=\"{\n              disabled: vm.quotation.id && vm.quotation.status !== \'pending\'\n            }\">\n{{ item.path.split(\'/\').pop() }}</label><label ng-if=\"!item.path\" class=\"fc-input__label\">Selecione aqui</label>\n<md-icon ng-if=\"!item.path && vm.quotation.status === \'pending\'\" class=\"fc-input__icon icon-attachment\" \nmd-font-icon=\"icon-attachment\"></md-icon><md-icon ng-if=\"item.path && vm.quotation.status === \'pending\'\" \nclass=\"fc-input__icon icon-remove clickable\" md-font-icon=\"icon-close\" ng-click=\"vm.removeFile(item)\"></md-icon></div>\n<label ng-class=\"{ \'required-label\': item.expense.receiptRequired }\" class=\"fc-input__label\" \ntranslate=\"QUOTATIONS.DIALOG.EXPENSES.LABELS.RECEIPT\"></label></div></div></div><div \nclass=\"expenses-tab__items-container__item__item-infos__content__warning\" ng-if=\"item.total > item.expense.maxValue\">\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"icon-warning\"></md-icon><span \ntranslate=\"QUOTATIONS.DIALOG.EXPENSES.WARNING\" \ntranslate-values=\"{ maxExpenseValue: (item.expense.maxValue | currencyFormat), currency: vm.currencySymbol }\"></span>\n</div></div></div>");
$templateCache.put("app/main/quotations/dialogs/components/quotation-items/quotation-items.component.html","<div class=\"products-services-tab__header\" \nng-if=\"(vm.quotation.id && vm.quotation.status === \'pending\') || !vm.quotation.id\" layout=\"row\"><div flex=\"100\">\n<fc-search options=\"vm.productsServices\" \nlabel=\"{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.MODEL.PRODUCTS_SERVICES.LABEL\' | translate }}\" \nhint=\"{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.MODEL.PRODUCTS_SERVICES.SEARCH_HINT\' | translate }}\" \nsearch-function=\"vm.searchProductService(searchTerm)\" select-function=\"vm.addQuotationItem(option, true)\" \ndata-cy=\"fc-search-productsServices\" track-by=\"name\"></fc-search></div><button \nng-if=\"!vm.selectedCustomer.metadata.featureQuotationAddNewProductsDisabled\" \nng-class=\"{ disabled: vm.quotation.id && vm.quotation.status !== \'pending\' }\" \nng-click=\"vm.createProductService($event)\" flex=\"20\" type=\"submit\" aria-label=\"Create product/service\" \ndata-cy=\"register-new\" class=\"products-services-tab__header__button fc-button\" \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.CREATE_PRODUCT_SERVICE\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.CREATE_PRODUCT_SERVICE\">Register new</button></div><h4 \nclass=\"mt-35 subtitle\">Produtos ({{ vm.products.length }})</h4><div class=\"empty__items\" layout-align=\"center center\" \nng-if=\"vm.products.length === 0\"><md-icon md-font-icon=\"icon-alert-circle\"></md-icon><p \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.NO_PRODUCTS_ADDED\">No products added.</p></div><div \nng-repeat=\"item in vm.products | orderBy:\'-position\' track by $index\" class=\"products-services-tab__items-container\" \nlayout=\"column\"><div class=\"products-services-tab__items-container__item\" layout=\"column\" data-cy=\"quotation-item\"><div\n class=\"mb-20\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"products-services-tab__items-container__item__image\" \nng-if=\"item && item.productService && item.productService.imageUrl\" \nng-src=\"{{ item.productService.imageUrl | mumakil }}\" alt=\"quotation item image\"><div \nng-if=\"!item || !item.productService || !item.productService.imageUrl\" \nclass=\"products-services-tab__items-container__item__without-image\"><md-icon \nmd-svg-src=\"assets/icons/icon-add-photo-alternate.svg\"></md-icon></div><div \nclass=\"products-services-tab__items-container__item__item-infos\" layout=\"column\"><main layout=\"row\" \nclass=\"products-services-tab__items-container__item__item-infos__content\"><div flex=\"50\"><div class=\"fc-input\" \nng-hide=\"true\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"itemName\" ng-disabled=\"true\" ng-required=\"true\" \nng-model=\"item.productService.name\" \nng-class=\"{\n                  invalid: vm.quotationForm.itemName.$touched && vm.quotationForm.itemName.$invalid,\n                  disabled: true\n                }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.NAME.LABEL\' | translate)}}</label>\n</div><div class=\"products-services-tab__items-container__item__item-infos__content__info\"><p \ntitle=\"{{ item.productService.name }}\">{{ item.productService.name | maxLength: 60 }}</p><span>\n{{ vm.findMeasureSelected(item.productService.measure).translate | translate}}</span></div></div><div flex=\"20\"><div \nclass=\"fc-input\"><input type=\"number\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"quantity\" \nng-disabled=\"!item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\" \nng-required=\"true\" min=\"0.0\" string-to-number ng-model=\"item.quantity\" ng-change=\"vm.updateTotal(item)\" \nng-class=\"{\n                  invalid: vm.quotationForm.quantity.$touched && vm.quotationForm.quantity.$invalid,\n                  disabled: !item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\n                }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.QTY.LABEL\' | translate)}}</label>\n</div></div><div flex=\"20\" \nng-hide=\"\n              (vm.selectedCustomer &&\n              vm.selectedCustomer.metadata &&\n              vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n              (item.productService &&\n              item.productService.metadata &&\n              item.productService.metadata.featureDisableShowValueOnQuotation)\n            \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"value\" ng-model=\"item.productService.value\" \nng-change=\"vm.updateTotal(item)\" ng-disabled=\"vm.setProductServiceInputDisabled(item.productService)\" min=\"0.01\" \nng-required=\"true\" ui-money-mask \nng-class=\"{\n                  invalid: vm.quotationForm.value.$touched && vm.quotationForm.value.$invalid,\n                  disabled: vm.setProductServiceInputDisabled(item.productService)\n                }\">\n<label class=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.VALUE.LABEL\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div><div flex=\"20\" \nng-hide=\"\n              (vm.selectedCustomer &&\n              vm.selectedCustomer.metadata &&\n              vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n              (item.productService &&\n              item.productService.metadata &&\n              item.productService.metadata.featureDisableShowValueOnQuotation)\n            \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"total\" ng-required=\"true\" ng-disabled=\"true\" \nng-model=\"item.total\" ui-money-mask ng-class=\"{\n                  disabled: true\n                }\"><label \nclass=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.TOTAL.LABEL\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div></main></div></div><fc-smart-rewrite \nreference-id=\"item.sessionId || item.referenceId || item.id\" reference-type=\"quotation-product-service-description\" \ndisabled=\"vm.hideButton\" class=\"flex-100\"><fc-textarea id=\"itemDesc__{{$index}}\" is-disabled=\"vm.hideButton\" \nclass=\"fc-textarea__textarea--change-border-color\" \nlabel=\"{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.DESCRIPTION.LABEL\' | translate)}}\" \nng-model=\"item.description\" input-name=\"itemDesc__{{$index}}\" input-control=\"vm.quotationForm[\'itemDesc__\' + $index]\" \nmax-length=\"2000\" , ng-change=\"vm.updateTotal(item)\" , \nerrors-to-watch=\"[\n            {\n              name: \'maxlength\',\n              translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n              translateValues: { expectedLength: 2000, receivedLength: vm.quotationForm[\'itemDesc__\' + $index].$viewValue.length }\n            },\n          ]\">\n</fc-textarea></fc-smart-rewrite><footer class=\"products-services-tab__items-container__item__item-infos__footer\"><div \nlayout=\"row\" ng-if=\"!vm.hideButton\"><p class=\"action\" \nng-hide=\"\n            (vm.selectedCustomer &&\n            vm.selectedCustomer.metadata &&\n            vm.selectedCustomer.metadata.featureDisableEditProductServiceOnQuotation) ||\n            (item.productService &&\n            item.productService.metadata &&\n            item.productService.metadata.featureDisableEditOnQuotation)\n          \" \nng-click=\"vm.editProductService($event, {id: item.productService.id, from: \'quotations\'})\"><md-icon \nmd-svg-src=\"assets/icons/icon-edit-product-service.svg\" class=\"icon-edit clickable\"></md-icon><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EDIT\">Edit</span></p><p class=\"action\" \nng-click=\"vm.removeItem(item.productService.id)\"><md-icon md-font-icon=\"icon-trash\" class=\"s24 clickable icon-delete\">\n</md-icon><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.REMOVE\">Remove</span></p></div></footer></div></div><h4 \nclass=\"mt-35 subtitle\">Serviços ({{ vm.services.length }})</h4><div class=\"empty__items\" layout-align=\"center center\" \nng-if=\"vm.services.length === 0\"><md-icon md-font-icon=\"icon-alert-circle\"></md-icon><p \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.NO_SERVICES_ADDED\">No services added.</p></div><div \nng-repeat=\"item in vm.services | orderBy:\'-position\' track by $index\" class=\"products-services-tab__items-container\" \nlayout=\"column\"><div class=\"products-services-tab__items-container__item\" layout=\"column\" data-cy=\"quotation-item\"><div\n class=\"mb-20\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"products-services-tab__items-container__item__image\" \nng-if=\"item && item.productService && item.productService.imageUrl\" \nng-src=\"{{ item.productService.imageUrl | mumakil }}\" alt=\"quotation item image\"><div \nng-if=\"!item || !item.productService || !item.productService.imageUrl\" \nclass=\"products-services-tab__items-container__item__without-image\"><md-icon \nmd-svg-src=\"assets/icons/icon-add-photo-alternate.svg\"></md-icon></div><div \nclass=\"products-services-tab__items-container__item__item-infos\" layout=\"column\"><main layout=\"row\" \nclass=\"products-services-tab__items-container__item__item-infos__content\"><div flex=\"50\"><div class=\"fc-input\" \nng-hide=\"true\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"itemName\" ng-disabled=\"true\" ng-required=\"true\" \nng-model=\"item.productService.name\" \nng-class=\"{\n                  invalid: vm.quotationForm.itemName.$touched && vm.quotationForm.itemName.$invalid,\n                  disabled: true\n                }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.NAME.LABEL\' | translate)}}</label>\n</div><div class=\"products-services-tab__items-container__item__item-infos__content__info\"><p \ntitle=\"{{ item.productService.name }}\">{{ item.productService.name | maxLength:60 }}</p><span \ntranslate=\"{{ vm.findMeasureSelected(item.productService.measure).translate || translate}}\"></span></div></div><div \nflex=\"15\"><div class=\"fc-input\"><input type=\"number\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"quantity\" \nng-disabled=\"!item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\" \nmin=\"1\" ng-required=\"true\" ng-model=\"item.quantity\" ng-change=\"vm.updateTotal(item)\" \nng-class=\"{\n                  invalid: vm.quotationForm.quantity.$touched && vm.quotationForm.quantity.$invalid,\n                  disabled: !item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\n                }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.QTY.LABEL\' | translate)}}</label>\n</div></div><div flex=\"20\" \nng-hide=\"\n              (vm.selectedCustomer &&\n              vm.selectedCustomer.metadata &&\n              vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n              (item.productService &&\n              item.productService.metadata &&\n              item.productService.metadata.featureDisableShowValueOnQuotation)\n            \">\n<div class=\"fc-input\"><input data-cy=\"value-input\" type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"value\" ng-model=\"item.productService.value\" \nng-change=\"vm.updateTotal(item)\" ng-disabled=\"vm.setProductServiceInputDisabled(item.productService)\" min=\"0.01\" \nng-required=\"true\" ui-money-mask \nng-class=\"{\n                  invalid: vm.quotationForm.value.$touched && vm.quotationForm.value.$invalid,\n                  disabled: vm.setProductServiceInputDisabled(item.productService)\n                }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.VALUE.LABEL\' | translate)}}</label>\n</div></div><div flex=\"20\" \nng-hide=\"\n              (vm.selectedCustomer &&\n              vm.selectedCustomer.metadata &&\n              vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n              (item.productService &&\n              item.productService.metadata &&\n              item.productService.metadata.featureDisableShowValueOnQuotation)\n            \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" class=\"fc-input__input\" name=\"total\" ng-required=\"true\" \nng-disabled=\"true\" ng-model=\"item.total\" ui-money-mask ng-class=\"{\n                  disabled: true\n                }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.TOTAL.LABEL\' | translate)}}</label>\n</div></div></main></div></div><fc-textarea id=\"itemDesc__{{$index}}\" is-disabled=\"vm.hideButton\" \nclass=\"fc-textarea__textarea--change-border-color\" \nlabel=\"{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.DESCRIPTION.LABEL\' | translate)}}\" \nng-model=\"item.description\" input-name=\"itemDesc__{{$index}}\" input-control=\"vm.quotationForm[\'itemDesc__\' + $index]\" \nmax-length=\"2000\" , ng-change=\"vm.updateTotal(item)\" , \nerrors-to-watch=\"[\n        {\n          name: \'maxlength\',\n          translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n          translateValues: { expectedLength: 2000, receivedLength: vm.quotationForm[\'itemDesc__\' + $index].$viewValue.length }\n        },\n      ]\">\n</fc-textarea><footer class=\"products-services-tab__items-container__item__item-infos__footer\"><div layout=\"row\" \nng-if=\"!vm.hideButton\"><p class=\"action\" \nng-hide=\"\n            (vm.selectedCustomer &&\n            vm.selectedCustomer.metadata &&\n            vm.selectedCustomer.metadata.featureDisableEditProductServiceOnQuotation) ||\n            (item.productService &&\n            item.productService.metadata &&\n            item.productService.metadata.featureDisableEditOnQuotation)\n          \" \nng-click=\"vm.editProductService($event, {id: item.productService.id, from: \'quotations\'})\"><md-icon \nmd-svg-src=\"assets/icons/icon-edit-product-service.svg\" class=\"icon-edit clickable\"></md-icon><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EDIT\">Edit</span></p><p class=\"action\" \nng-click=\"vm.removeItem(item.productService.id)\"><md-icon md-font-icon=\"icon-trash\" class=\"s24 clickable icon-delete\">\n</md-icon><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.REMOVE\">Remove</span></p></div></footer></div></div>");
$templateCache.put("app/main/quotations/dialogs/components/quotation-items-equipments/quotation-items-equipments.component.html","<div class=\"products-services-tab__items-equipments\"><div class=\"products-services-tab__items-equipments__banner\">\n<info-component-provider text=\"{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.BANNER\' | translate }}\">\n</info-component-provider></div><div class=\"products-services-tab__equipments-empty-state\" \nng-if=\"(!vm.equipments || !vm.equipments.length) && ((vm.quotation.id && vm.quotation.status === \'pending\') || !vm.quotation.id)\" \nclass=\"empty__items\" layout-align=\"center center\"><fc-search options=\"vm.equipmentsToPick\" \nclass=\"products-services-tab__equipments-empty-state__search\" \nlabel=\"{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.LABEL\' | translate }}\" \nsearch-function=\"vm.searchEquipments(searchTerm)\" select-function=\"vm.addQuotationEquipment(option, true)\" \ndata-cy=\"fc-search-equipments\" track-by=\"name\"></fc-search><div \nclass=\"products-services-tab__equipments-search w-100-percent pt-8\" \nng-if=\"(vm.quotation.id && vm.quotation.status === \'pending\') || !vm.quotation.id\" layout=\"row\"><fc-search \noptions=\"vm.productsServices\" class=\"products-services-tab__equipments-empty-state__search z-10\" \nlabel=\"{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.MODEL.PRODUCTS_SERVICES.LABELV2\' | translate }}\" \nsearch-function=\"vm.searchProductService(searchTerm)\" select-function=\"vm.addQuotationItem(option, true)\" \ndata-cy=\"fc-search-productsServices\" track-by=\"name\"></fc-search><button \nng-if=\"!vm.selectedCustomer.metadata.featureQuotationAddNewProductsDisabled\" \nng-class=\"{ disabled: vm.quotation.id && vm.quotation.status !== \'pending\' }\" \nng-click=\"vm.createProductServiceSetup($event)\" type=\"submit\" aria-label=\"Create product/service\" \ndata-cy=\"register-new\" class=\"products-services-tab__equipments-search__button\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.CREATE_PRODUCT_SERVICE\"><md-icon \nclass=\"products-services-tab__equipments-search__button__icon\" md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.CREATE_PRODUCT_SERVICE\">Add new</span>\n</md-tooltip></button></div></div><div class=\"products-services-tab__items-equipments__content\" \nng-if=\"vm.equipments && vm.equipments.length\"><div class=\"products-services-tab__items-equipments__content__add\">\n<fc-search ng-if=\"(vm.quotation.id && vm.quotation.status === \'pending\') || !vm.quotation.id\" \noptions=\"vm.equipmentsToPick\" class=\"products-services-tab__items-equipments__content__add__search\" \nlabel=\"{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.LABEL\' | translate }}\" \nsearch-function=\"vm.searchEquipments(searchTerm)\" select-function=\"vm.addQuotationEquipment(option, true)\" \ndata-cy=\"fc-search-equipments\" track-by=\"name\"></fc-search><div class=\"products-services-tab__equipments-search pt-0\" \nng-if=\"(vm.quotation.id && vm.quotation.status === \'pending\') || !vm.quotation.id\" layout=\"row\"><fc-search \noptions=\"vm.productsServices\" class=\"products-services-tab__equipments-empty-state__search z-10\" \nlabel=\"{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.MODEL.PRODUCTS_SERVICES.LABELV2\' | translate }}\" \nsearch-function=\"vm.searchProductService(searchTerm)\" select-function=\"vm.addQuotationItem(option, true)\" \ndata-cy=\"fc-search-productsServices\" track-by=\"name\"></fc-search><button \nng-if=\"!vm.selectedCustomer.metadata.featureQuotationAddNewProductsDisabled\" \nng-class=\"{ disabled: vm.quotation.id && vm.quotation.status !== \'pending\' }\" \nng-click=\"vm.createProductServiceSetup($event)\" type=\"submit\" aria-label=\"Create product/service\" \ndata-cy=\"register-new\" class=\"products-services-tab__equipments-search__button\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.CREATE_PRODUCT_SERVICE\"><md-icon \nclass=\"products-services-tab__equipments-search__button__icon\" md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.CREATE_PRODUCT_SERVICE\">Add new</span>\n</md-tooltip></button></div><span class=\"products-services-tab__items-equipments__content__span\">\n{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.LINKED\' | translate: { quantity: vm.equipments.length } }}</span>\n</div><div ng-repeat=\"equipment in vm.equipments track by $index\" \nng-class=\"{ \'expanded-equipments-padding\': equipment.expanded }\" class=\"products-services-tab__equipments-container\" \nlayout=\"column\"><div class=\"products-services-tab__equipments-container__item\" layout=\"column\" \ndata-cy=\"quotation-item\"><div ng-class=\"{ \'mb-20\': equipment.expanded }\" layout=\"row\" layout-align=\"center center\"><img\n class=\"products-services-tab__equipments-container__item__image\" ng-if=\"equipment && equipment.imageUrl\" \nng-src=\"{{ equipment.imageUrl | mumakil }}\" alt=\"img\"><div ng-if=\"!equipment || !equipment.imageUrl\" \nclass=\"products-services-tab__equipments-container__item__without-image\"><md-icon \nmd-svg-src=\"assets/icons/icon-add-photo-alternate.svg\"></md-icon></div><div \nclass=\"products-services-tab__equipments-container__item__item-infos\" layout=\"column\"><main layout=\"row\" \nclass=\"products-services-tab__equipments-container__item__item-infos__content\"><div flex=\"50\"><div \nclass=\"products-services-tab__equipments-container__item__item-infos__content__info\"><p title=\"{{ equipment.name }}\">\n{{ equipment.name | maxLength : 60 }} - <span>{{ equipment.type && equipment.type.name }}</span></p><span>\n{{ equipment.location && equipment.location.name }}</span></div></div><div flex=\"20\" \nclass=\"products-services-tab__equipments-container__item__item-infos__side\"><button \nclass=\"products-services-tab__equipments-container__item__item-infos__side__button\" ng-if=\"!vm.hideButton\" \nng-click=\"vm.removeEquipment(equipment.id)\"><md-icon \nclass=\"products-services-tab__equipments-container__item__item-infos__side__button__icon\" \nmd-font-icon=\"icon-minus-circle-outline\"></md-icon><span>\n{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.REMOVE\' | translate }}</span><md-tooltip md-direction=\"down\"><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.REMOVE\">Remove</span></md-tooltip></button><div \nclass=\"products-services-tab__equipments-container__item__item-infos__side__div\"><md-icon \nclass=\"products-services-tab__equipments-container__item__item-infos__side__arrow\" ng-if=\"equipment.expanded\" \nng-click=\"vm.toggleExpanded(vm.equipments, equipment)\" \nclass=\"products-services-tab__items-equipments__content__button__icon\" md-font-icon=\"icon-chevron-up\"><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.CLOSE\">Close</span></md-tooltip>\n</md-icon><md-icon class=\"products-services-tab__equipments-container__item__item-infos__side__arrow\" \nng-if=\"!equipment.expanded\" ng-click=\"vm.toggleExpanded(vm.equipments, equipment)\" \nclass=\"products-services-tab__items-equipments__content__button__icon\" md-font-icon=\"icon-chevron-down\"><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.OPEN\">Open</span></md-tooltip>\n</md-icon></div></div></main></div></div><div ng-if=\"equipment.expanded\" \nclass=\"products-services-tab__equipments-container__item__expanded-division\"></div><div ng-if=\"equipment.expanded\" \nclass=\"products-services-tab__equipments-container__item__expanded\"><div \nclass=\"products-services-tab__equipments-search\" \nng-if=\"(vm.quotation.id && vm.quotation.status === \'pending\') || !vm.quotation.id\" layout=\"row\"><div flex=\"100\">\n<fc-search options=\"vm.productsServices\" \nlabel=\"{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.MODEL.PRODUCTS_SERVICES.LABELV2\' | translate }}\" \nsearch-function=\"vm.searchProductService(searchTerm, equipment.id)\" \nselect-function=\"vm.addQuotationItem(option, true, equipment.id)\" data-cy=\"fc-search-productsServices\" track-by=\"name\">\n</fc-search></div><button ng-if=\"!vm.selectedCustomer.metadata.featureQuotationAddNewProductsDisabled\" \nng-class=\"{ disabled: vm.quotation.id && vm.quotation.status !== \'pending\' }\" \nng-click=\"vm.createProductServiceSetup($event, equipment)\" type=\"submit\" aria-label=\"Create product/service\" \ndata-cy=\"register-new\" class=\"products-services-tab__equipments-search__button\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.CREATE_PRODUCT_SERVICE\"><md-icon \nclass=\"products-services-tab__equipments-search__button__icon\" md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.CREATE_PRODUCT_SERVICE\">Add new</span>\n</md-tooltip></button></div><span ng-if=\"equipment.products && equipment.products.length\" \nclass=\"products-services-tab__items-equipments__content__span\">\n{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.PRODUCTS\' | translate: { quantity: equipment.products.length } }}\n</span><div ng-if=\"equipment.products && equipment.products.length\" \nng-repeat=\"item in equipment.products | orderBy:\'-position\' track by $index\" \nclass=\"products-services-tab__equipment-items-container\" layout=\"column\"><div \nclass=\"products-services-tab__equipment-items-container__item\" layout=\"column\" data-cy=\"quotation-item\"><div \nng-class=\"{ \'mb-20\': item.expanded }\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"products-services-tab__equipment-items-container__item__image\" \nng-if=\"item && item.productService && item.productService.imageUrl\" \nng-src=\"{{ item.productService.imageUrl | mumakil }}\" alt=\"img\"><div \nng-if=\"!item || !item.productService || !item.productService.imageUrl\" \nclass=\"products-services-tab__equipment-items-container__item__without-image\"><md-icon \nmd-svg-src=\"assets/icons/icon-add-photo-alternate.svg\"></md-icon></div><div \nclass=\"products-services-tab__equipment-items-container__item__item-infos\" layout=\"column\"><main layout=\"row\" \nclass=\"products-services-tab__equipment-items-container__item__item-infos__content\"><div flex=\"50\"><div \nclass=\"fc-input\" ng-hide=\"true\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"itemName\" ng-disabled=\"true\" ng-required=\"true\" \nng-model=\"item.productService.name\" \nng-class=\"{\n                            invalid: vm.quotationForm.itemName.$touched && vm.quotationForm.itemName.$invalid,\n                            disabled: true\n                          }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.NAME.LABEL\' | translate)}}</label>\n</div><div class=\"products-services-tab__equipment-items-container__item__item-infos__content__info\"><p \ntitle=\"{{ item.productService.name }}\">{{ item.productService.name | maxLength: 60 }}</p><span>\n{{ vm.findMeasureSelected(item.productService.measure).translate | translate}}</span></div></div><div flex=\"20\" \nclass=\"products-services-tab__equipments-container__item__item-infos__side\"><div layout=\"row\" \nclass=\"items-edit-buttons\" ng-if=\"!vm.hideButton\"><button \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button-edit\" \nng-hide=\"\n                            (vm.selectedCustomer &&\n                            vm.selectedCustomer.metadata &&\n                            vm.selectedCustomer.metadata.featureDisableEditProductServiceOnQuotation) ||\n                            (item.productService &&\n                            item.productService.metadata &&\n                            item.productService.metadata.featureDisableEditOnQuotation)\n                          \" \nng-click=\"vm.editProductService($event, {id: item.productService.id, from: \'quotations\', equipmentId: equipment.id})\">\n<md-icon class=\"products-services-tab__items-equipments__content__button__icon__svg\" \nmd-svg-src=\"assets/icons/icon-edit-product-service.svg\"></md-icon><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EDIT\">Edit</span><md-tooltip md-direction=\"down\"><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EDIT\">Edit</span></md-tooltip></button> <button \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button\" \nng-click=\"vm.removeItem(item.productService.id, equipment.id)\"><md-icon \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button__icon\" \nmd-font-icon=\"icon-minus-circle-outline\"></md-icon><md-tooltip md-direction=\"down\"><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.REMOVE\">Remove</span></md-tooltip></button></div><div \nng-class=\"{ \'products-services-tab__equipments-container__item__item-infos__side__div\': vm.hideButton }\"><md-icon \nclass=\"products-services-tab__equipments-container__item__item-infos__side__arrow\" ng-if=\"item.expanded\" \nng-click=\"vm.toggleExpanded(equipment.products, item)\" \nclass=\"products-services-tab__items-equipments__content__button__icon\" md-font-icon=\"icon-chevron-up\"><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.CLOSE\">Close</span></md-tooltip>\n</md-icon><md-icon class=\"products-services-tab__equipments-container__item__item-infos__side__arrow\" \nng-if=\"!item.expanded\" ng-click=\"vm.toggleExpanded(equipment.products, item)\" \nclass=\"products-services-tab__items-equipments__content__button__icon\" md-font-icon=\"icon-chevron-down\"><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.OPEN\">Open</span></md-tooltip>\n</md-icon></div></div></main></div></div><div ng-if=\"item.expanded\" \nclass=\"products-services-tab__equipment-items-container__item__expanded-division\"></div><div ng-if=\"item.expanded\" \nclass=\"products-services-tab__equipment-items-container__item__expanded\"><div class=\"mb-20 gap-12\" layout=\"row\" \nlayout-align=\"center center\"><div flex=\"33\"><div class=\"fc-input\"><input type=\"number\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--change-border-color\" name=\"quantity\" \nng-disabled=\"!item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\" \nng-required=\"true\" min=\"0.0\" string-to-number ng-model=\"item.quantity\" ng-change=\"vm.updateTotal(item)\" \nng-class=\"{\n                          invalid: vm.quotationForm.quantity.$touched && vm.quotationForm.quantity.$invalid,\n                          disabled: !item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\n                        }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.QTY.LABEL\' | translate)}}</label>\n</div></div><div flex=\"33\" \nng-hide=\"\n                      (vm.selectedCustomer &&\n                      vm.selectedCustomer.metadata &&\n                      vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n                      (item.productService &&\n                      item.productService.metadata &&\n                      item.productService.metadata.featureDisableShowValueOnQuotation)\n                    \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"value\" ng-model=\"item.productService.value\" \nng-change=\"vm.updateTotal(item)\" ng-disabled=\"vm.setProductServiceInputDisabled(item.productService)\" min=\"0.01\" \nng-required=\"true\" ui-money-mask \nng-class=\"{\n                          invalid: vm.quotationForm.value.$touched && vm.quotationForm.value.$invalid,\n                          disabled: vm.setProductServiceInputDisabled(item.productService)\n                        }\">\n<label class=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.VALUE.LABEL\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div><div flex=\"33\" \nng-hide=\"\n                      (vm.selectedCustomer &&\n                      vm.selectedCustomer.metadata &&\n                      vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n                      (item.productService &&\n                      item.productService.metadata &&\n                      item.productService.metadata.featureDisableShowValueOnQuotation)\n                    \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"total\" ng-required=\"true\" ng-disabled=\"true\" \nng-model=\"item.total\" ui-money-mask ng-class=\"{\n                          disabled: true\n                        }\">\n<label class=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.TOTAL.LABEL\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div></div><fc-smart-rewrite \nreference-id=\"item.sessionId || item.referenceId || item.id\" reference-type=\"quotation-product-service-description\" \ndisabled=\"vm.hideButton\" class=\"flex-100\"><fc-textarea id=\"itemDescProd__{{$index}}\" is-disabled=\"vm.hideButton\" \nclass=\"fc-textarea__textarea--change-border-color\" \nlabel=\"{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.DESCRIPTION.LABEL\' | translate)}}\" \nng-model=\"item.description\" input-name=\"itemDescProd__{{$index}}\" \ninput-control=\"vm.quotationForm[\'itemDescProd__\' + $index]\" max-length=\"2000\" , ng-change=\"vm.updateTotal(item)\" , \nerrors-to-watch=\"[\n                        {\n                          name: \'maxlength\',\n                          translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n                          translateValues: { expectedLength: 2000, receivedLength: vm.quotationForm[\'itemDescProd__\' + $index].$viewValue.length }\n                        },\n                      ]\">\n</fc-textarea></fc-smart-rewrite></div></div></div><span ng-if=\"equipment.services && equipment.services.length\" \nclass=\"products-services-tab__items-equipments__content__span\">\n{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.SERVICES\' | translate: { quantity: equipment.services.length } }}\n</span><div ng-if=\"equipment.services && equipment.services.length\" \nng-repeat=\"item in equipment.services | orderBy:\'-position\' track by $index\" \nclass=\"products-services-tab__equipment-items-container\" layout=\"column\"><div \nclass=\"products-services-tab__equipment-items-container__item\" layout=\"column\" data-cy=\"quotation-item\"><div \nng-class=\"{ \'mb-20\': item.expanded }\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"products-services-tab__equipment-items-container__item__image\" \nng-if=\"item && item.productService && item.productService.imageUrl\" \nng-src=\"{{ item.productService.imageUrl | mumakil }}\" alt=\"img\"><div \nng-if=\"!item || !item.productService || !item.productService.imageUrl\" \nclass=\"products-services-tab__equipment-items-container__item__without-image\"><md-icon \nmd-svg-src=\"assets/icons/icon-add-photo-alternate.svg\"></md-icon></div><div \nclass=\"products-services-tab__equipment-items-container__item__item-infos\" layout=\"column\"><main layout=\"row\" \nclass=\"products-services-tab__equipment-items-container__item__item-infos__content\"><div flex=\"50\"><div \nclass=\"fc-input\" ng-hide=\"true\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"itemName\" ng-disabled=\"true\" ng-required=\"true\" \nng-model=\"item.productService.name\" \nng-class=\"{\n                            invalid: vm.quotationForm.itemName.$touched && vm.quotationForm.itemName.$invalid,\n                            disabled: true\n                          }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.NAME.LABEL\' | translate)}}</label>\n</div><div class=\"products-services-tab__equipment-items-container__item__item-infos__content__info\"><p \ntitle=\"{{ item.productService.name }}\">{{ item.productService.name | maxLength: 60 }}</p><span>\n{{ vm.findMeasureSelected(item.productService.measure).translate | translate}}</span></div></div><div flex=\"20\" \nclass=\"products-services-tab__equipments-container__item__item-infos__side\"><div layout=\"row\" \nclass=\"items-edit-buttons\" ng-if=\"!vm.hideButton\"><button \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button-edit\" \nng-hide=\"\n                            (vm.selectedCustomer &&\n                            vm.selectedCustomer.metadata &&\n                            vm.selectedCustomer.metadata.featureDisableEditProductServiceOnQuotation) ||\n                            (item.productService &&\n                            item.productService.metadata &&\n                            item.productService.metadata.featureDisableEditOnQuotation)\n                          \" \nng-click=\"vm.editProductService($event, {id: item.productService.id, from: \'quotations\', equipmentId: equipment.id})\">\n<md-icon class=\"products-services-tab__items-equipments__content__button__icon__svg\" \nmd-svg-src=\"assets/icons/icon-edit-product-service.svg\"></md-icon><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EDIT\">Edit</span><md-tooltip md-direction=\"down\"><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EDIT\">Edit</span></md-tooltip></button> <button \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button\" \nng-click=\"vm.removeItem(item.productService.id, equipment.id)\"><md-icon \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button__icon\" \nmd-font-icon=\"icon-minus-circle-outline\"></md-icon><md-tooltip md-direction=\"down\"><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.REMOVE\">Remove</span></md-tooltip></button></div><div \nng-class=\"{ \'products-services-tab__equipments-container__item__item-infos__side__div\': vm.hideButton }\"><md-icon \nclass=\"products-services-tab__equipments-container__item__item-infos__side__arrow\" ng-if=\"item.expanded\" \nng-click=\"vm.toggleExpanded(equipment.services, item)\" \nclass=\"products-services-tab__items-equipments__content__button__icon\" md-font-icon=\"icon-chevron-up\"><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.CLOSE\">Close</span></md-tooltip>\n</md-icon><md-icon class=\"products-services-tab__equipments-container__item__item-infos__side__arrow\" \nng-if=\"!item.expanded\" ng-click=\"vm.toggleExpanded(equipment.services, item)\" \nclass=\"products-services-tab__items-equipments__content__button__icon\" md-font-icon=\"icon-chevron-down\"><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.OPEN\">Open</span></md-tooltip>\n</md-icon></div></div></main></div></div><div ng-if=\"item.expanded\" \nclass=\"products-services-tab__equipment-items-container__item__expanded-division\"></div><div ng-if=\"item.expanded\" \nclass=\"products-services-tab__equipment-items-container__item__expanded\"><div class=\"mb-20 gap-12\" layout=\"row\" \nlayout-align=\"center center\"><div flex=\"33\"><div class=\"fc-input\"><input type=\"number\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--change-border-color\" name=\"quantity\" \nng-disabled=\"!item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\" \nng-required=\"true\" min=\"0.0\" string-to-number ng-model=\"item.quantity\" ng-change=\"vm.updateTotal(item)\" \nng-class=\"{\n                          invalid: vm.quotationForm.quantity.$touched && vm.quotationForm.quantity.$invalid,\n                          disabled: !item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\n                        }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.QTY.LABEL\' | translate)}}</label>\n</div></div><div flex=\"33\" \nng-hide=\"\n                      (vm.selectedCustomer &&\n                      vm.selectedCustomer.metadata &&\n                      vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n                      (item.productService &&\n                      item.productService.metadata &&\n                      item.productService.metadata.featureDisableShowValueOnQuotation)\n                    \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"value\" ng-model=\"item.productService.value\" \nng-change=\"vm.updateTotal(item)\" ng-disabled=\"vm.setProductServiceInputDisabled(item.productService)\" min=\"0.01\" \nng-required=\"true\" ui-money-mask \nng-class=\"{\n                          invalid: vm.quotationForm.value.$touched && vm.quotationForm.value.$invalid,\n                          disabled: vm.setProductServiceInputDisabled(item.productService)\n                        }\">\n<label class=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.VALUE.LABEL\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div><div flex=\"33\" \nng-hide=\"\n                      (vm.selectedCustomer &&\n                      vm.selectedCustomer.metadata &&\n                      vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n                      (item.productService &&\n                      item.productService.metadata &&\n                      item.productService.metadata.featureDisableShowValueOnQuotation)\n                    \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"total\" ng-required=\"true\" ng-disabled=\"true\" \nng-model=\"item.total\" ui-money-mask ng-class=\"{\n                          disabled: true\n                        }\">\n<label class=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.TOTAL.LABEL\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div></div><fc-smart-rewrite \nreference-id=\"item.sessionId || item.referenceId || item.id\" reference-type=\"quotation-product-service-description\" \ndisabled=\"vm.hideButton\" class=\"flex-100\"><fc-textarea id=\"itemDescServ__{{$index}}\" is-disabled=\"vm.hideButton\" \nclass=\"fc-textarea__textarea--change-border-color\" \nlabel=\"{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.DESCRIPTION.LABEL\' | translate)}}\" \nng-model=\"item.description\" input-name=\"itemDescServ__{{$index}}\" \ninput-control=\"vm.quotationForm[\'itemDescServ__\' + $index]\" max-length=\"2000\" , ng-change=\"vm.updateTotal(item)\" , \nerrors-to-watch=\"[\n                        {\n                          name: \'maxlength\',\n                          translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n                          translateValues: { expectedLength: 2000, receivedLength: vm.quotationForm[\'itemDescServ__\' + $index].$viewValue.length }\n                        },\n                      ]\">\n</fc-textarea></fc-smart-rewrite></div></div></div><div class=\"products-services-tab__equipments-empty-state__item\" \nng-if=\"(!equipment.products || !equipment.products.length) && (!equipment.services || !equipment.services.length)\" \nclass=\"empty__items\" layout-align=\"center center\"><p \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.NO_ITEMS\">No items.</p></div></div></div></div></div><div \nclass=\"products-services-tab__equipments-empty-state\" class=\"empty__items\" layout-align=\"center center\"><span \nng-if=\"vm.productsWithoutEquipments.length\" class=\"products-services-tab__items-equipments__content__span\">\n{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.PRODUCTS_WITHOUT_EQUIPMENT\' | translate: { quantity: vm.productsWithoutEquipments.length } }}\n</span><div ng-if=\"vm.productsWithoutEquipments.length\" \nng-repeat=\"item in vm.productsWithoutEquipments | orderBy:\'-position\' track by $index\" \nclass=\"products-services-tab__equipment-items-container w-100-percent\" layout=\"column\"><div \nclass=\"products-services-tab__equipment-items-container__item\" layout=\"column\" data-cy=\"quotation-item\"><div \nng-class=\"{ \'mb-20\': item.expanded }\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"products-services-tab__equipment-items-container__item__image\" \nng-if=\"item && item.productService && item.productService.imageUrl\" \nng-src=\"{{ item.productService.imageUrl | mumakil }}\" alt=\"img\"><div \nng-if=\"!item || !item.productService || !item.productService.imageUrl\" \nclass=\"products-services-tab__equipment-items-container__item__without-image\"><md-icon \nmd-svg-src=\"assets/icons/icon-add-photo-alternate.svg\"></md-icon></div><div \nclass=\"products-services-tab__equipment-items-container__item__item-infos\" layout=\"column\"><main layout=\"row\" \nclass=\"products-services-tab__equipment-items-container__item__item-infos__content\"><div flex=\"50\"><div \nclass=\"fc-input\" ng-hide=\"true\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"itemName\" ng-disabled=\"true\" ng-required=\"true\" \nng-model=\"item.productService.name\" \nng-class=\"{\n                      invalid: vm.quotationForm.itemName.$touched && vm.quotationForm.itemName.$invalid,\n                      disabled: true\n                    }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.NAME.LABEL\' | translate)}}</label>\n</div><div class=\"products-services-tab__equipment-items-container__item__item-infos__content__info\"><p \ntitle=\"{{ item.productService.name }}\">{{ item.productService.name | maxLength: 60 }}</p><span>\n{{ vm.findMeasureSelected(item.productService.measure).translate | translate}}</span></div></div><div flex=\"20\" \nclass=\"products-services-tab__equipments-container__item__item-infos__side\"><div layout=\"row\" \nclass=\"items-edit-buttons\" ng-if=\"!vm.hideButton\"><button \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button-edit\" \nng-hide=\"\n                      (vm.selectedCustomer &&\n                      vm.selectedCustomer.metadata &&\n                      vm.selectedCustomer.metadata.featureDisableEditProductServiceOnQuotation) ||\n                      (item.productService &&\n                      item.productService.metadata &&\n                      item.productService.metadata.featureDisableEditOnQuotation)\n                    \" \nng-click=\"vm.editProductService($event, {id: item.productService.id, from: \'quotations\'})\"><md-icon \nclass=\"products-services-tab__items-equipments__content__button__icon__svg\" \nmd-svg-src=\"assets/icons/icon-edit-product-service.svg\"></md-icon><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EDIT\">Edit</span><md-tooltip md-direction=\"down\"><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EDIT\">Edit</span></md-tooltip></button> <button \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button\" \nng-click=\"vm.removeItem(item.productService.id)\"><md-icon \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button__icon\" \nmd-font-icon=\"icon-minus-circle-outline\"></md-icon><md-tooltip md-direction=\"down\"><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.REMOVE\">Remove</span></md-tooltip></button></div><div \nng-class=\"{ \'products-services-tab__equipments-container__item__item-infos__side__div\': vm.hideButton }\"><md-icon \nclass=\"products-services-tab__equipments-container__item__item-infos__side__arrow\" ng-if=\"item.expanded\" \nng-click=\"vm.toggleExpanded(vm.productsWithoutEquipments, item)\" \nclass=\"products-services-tab__items-equipments__content__button__icon\" md-font-icon=\"icon-chevron-up\"><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.CLOSE\">Close</span></md-tooltip>\n</md-icon><md-icon class=\"products-services-tab__equipments-container__item__item-infos__side__arrow\" \nng-if=\"!item.expanded\" ng-click=\"vm.toggleExpanded(vm.productsWithoutEquipments, item)\" \nclass=\"products-services-tab__items-equipments__content__button__icon\" md-font-icon=\"icon-chevron-down\"><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.OPEN\">Open</span></md-tooltip>\n</md-icon></div></div></main></div></div><div ng-if=\"item.expanded\" \nclass=\"products-services-tab__equipment-items-container__item__expanded-division\"></div><div ng-if=\"item.expanded\" \nclass=\"products-services-tab__equipment-items-container__item__expanded\"><div class=\"mb-20 gap-12\" layout=\"row\" \nlayout-align=\"center center\"><div flex=\"33\"><div class=\"fc-input\"><input type=\"number\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--change-border-color\" name=\"quantity\" \nng-disabled=\"!item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\" \nng-required=\"true\" min=\"0.0\" string-to-number ng-model=\"item.quantity\" ng-change=\"vm.updateTotal(item)\" \nng-class=\"{\n                    invalid: vm.quotationForm.quantity.$touched && vm.quotationForm.quantity.$invalid,\n                    disabled: !item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\n                  }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.QTY.LABEL\' | translate)}}</label>\n</div></div><div flex=\"33\" \nng-hide=\"\n                (vm.selectedCustomer &&\n                vm.selectedCustomer.metadata &&\n                vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n                (item.productService &&\n                item.productService.metadata &&\n                item.productService.metadata.featureDisableShowValueOnQuotation)\n              \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"value\" ng-model=\"item.productService.value\" \nng-change=\"vm.updateTotal(item)\" ng-disabled=\"vm.setProductServiceInputDisabled(item.productService)\" min=\"0.01\" \nng-required=\"true\" ui-money-mask \nng-class=\"{\n                    invalid: vm.quotationForm.value.$touched && vm.quotationForm.value.$invalid,\n                    disabled: vm.setProductServiceInputDisabled(item.productService)\n                  }\">\n<label class=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.VALUE.LABEL\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div><div flex=\"33\" \nng-hide=\"\n                (vm.selectedCustomer &&\n                vm.selectedCustomer.metadata &&\n                vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n                (item.productService &&\n                item.productService.metadata &&\n                item.productService.metadata.featureDisableShowValueOnQuotation)\n              \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"total\" ng-required=\"true\" ng-disabled=\"true\" \nng-model=\"item.total\" ui-money-mask ng-class=\"{\n                    disabled: true\n                  }\"><label \nclass=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.TOTAL.LABEL\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div></div><fc-smart-rewrite \nreference-id=\"item.sessionId || item.referenceId || item.id\" reference-type=\"quotation-product-service-description\" \ndisabled=\"vm.hideButton\" class=\"flex-100\"><fc-textarea id=\"itemDescServ__{{$index}}\" is-disabled=\"vm.hideButton\" \nclass=\"fc-textarea__textarea--change-border-color\" \nlabel=\"{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.DESCRIPTION.LABEL\' | translate)}}\" \nng-model=\"item.description\" input-name=\"itemDescServ__{{$index}}\" \ninput-control=\"vm.quotationForm[\'itemDescServ__\' + $index]\" max-length=\"2000\" , ng-change=\"vm.updateTotal(item)\" , \nerrors-to-watch=\"[\n                  {\n                    name: \'maxlength\',\n                    translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n                    translateValues: { expectedLength: 2000, receivedLength: vm.quotationForm[\'itemDescServ__\' + $index].$viewValue.length }\n                  },\n                ]\">\n</fc-textarea></fc-smart-rewrite></div></div></div><span ng-if=\"vm.servicesWithoutEquipments.length\" \nclass=\"mt-8 products-services-tab__items-equipments__content__span\">\n{{ \'QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.SERVICES_WITHOUT_EQUIPMENT\' | translate: { quantity: vm.servicesWithoutEquipments.length } }}\n</span><div ng-if=\"vm.servicesWithoutEquipments.length\" \nng-repeat=\"item in vm.servicesWithoutEquipments | orderBy:\'-position\' track by $index\" \nclass=\"products-services-tab__equipment-items-container w-100-percent\" layout=\"column\"><div \nclass=\"products-services-tab__equipment-items-container__item\" layout=\"column\" data-cy=\"quotation-item\"><div \nng-class=\"{ \'mb-20\': item.expanded }\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"products-services-tab__equipment-items-container__item__image\" \nng-if=\"item && item.productService && item.productService.imageUrl\" \nng-src=\"{{ item.productService.imageUrl | mumakil }}\" alt=\"img\"><div \nng-if=\"!item || !item.productService || !item.productService.imageUrl\" \nclass=\"products-services-tab__equipment-items-container__item__without-image\"><md-icon \nmd-svg-src=\"assets/icons/icon-add-photo-alternate.svg\"></md-icon></div><div \nclass=\"products-services-tab__equipment-items-container__item__item-infos\" layout=\"column\"><main layout=\"row\" \nclass=\"products-services-tab__equipment-items-container__item__item-infos__content\"><div flex=\"50\"><div \nclass=\"fc-input\" ng-hide=\"true\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"itemName\" ng-disabled=\"true\" ng-required=\"true\" \nng-model=\"item.productService.name\" \nng-class=\"{\n                      invalid: vm.quotationForm.itemName.$touched && vm.quotationForm.itemName.$invalid,\n                      disabled: true\n                    }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.NAME.LABEL\' | translate)}}</label>\n</div><div class=\"products-services-tab__equipment-items-container__item__item-infos__content__info\"><p \ntitle=\"{{ item.productService.name }}\">{{ item.productService.name | maxLength: 60 }}</p><span>\n{{ vm.findMeasureSelected(item.productService.measure).translate | translate}}</span></div></div><div flex=\"20\" \nclass=\"products-services-tab__equipments-container__item__item-infos__side\"><div layout=\"row\" \nclass=\"items-edit-buttons\" ng-if=\"!vm.hideButton\"><button \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button-edit\" \nng-hide=\"\n                      (vm.selectedCustomer &&\n                      vm.selectedCustomer.metadata &&\n                      vm.selectedCustomer.metadata.featureDisableEditProductServiceOnQuotation) ||\n                      (item.productService &&\n                      item.productService.metadata &&\n                      item.productService.metadata.featureDisableEditOnQuotation)\n                    \" \nng-click=\"vm.editProductService($event, {id: item.productService.id, from: \'quotations\'})\"><md-icon \nclass=\"products-services-tab__items-equipments__content__button__icon__svg\" \nmd-svg-src=\"assets/icons/icon-edit-product-service.svg\"></md-icon><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EDIT\">Edit</span><md-tooltip md-direction=\"down\"><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EDIT\">Edit</span></md-tooltip></button> <button \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button\" \nng-click=\"vm.removeItem(item.productService.id)\"><md-icon \nclass=\"products-services-tab__equipment-items-container__item__item-infos__side__button__icon\" \nmd-font-icon=\"icon-minus-circle-outline\"></md-icon><md-tooltip md-direction=\"down\"><span \ntranslate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.REMOVE\">Remove</span></md-tooltip></button></div><div \nng-class=\"{ \'products-services-tab__equipments-container__item__item-infos__side__div\': vm.hideButton }\"><md-icon \nclass=\"products-services-tab__equipments-container__item__item-infos__side__arrow\" ng-if=\"item.expanded\" \nng-click=\"vm.toggleExpanded(vm.servicesWithoutEquipments, item)\" \nclass=\"products-services-tab__items-equipments__content__button__icon\" md-font-icon=\"icon-chevron-up\"><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.CLOSE\">Close</span></md-tooltip>\n</md-icon><md-icon class=\"products-services-tab__equipments-container__item__item-infos__side__arrow\" \nng-if=\"!item.expanded\" ng-click=\"vm.toggleExpanded(vm.servicesWithoutEquipments, item)\" \nclass=\"products-services-tab__items-equipments__content__button__icon\" md-font-icon=\"icon-chevron-down\"><md-tooltip \nmd-direction=\"down\"><span translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.EQUIPMENTS.OPEN\">Open</span></md-tooltip>\n</md-icon></div></div></main></div></div><div ng-if=\"item.expanded\" \nclass=\"products-services-tab__equipment-items-container__item__expanded-division\"></div><div ng-if=\"item.expanded\" \nclass=\"products-services-tab__equipment-items-container__item__expanded\"><div class=\"mb-20 gap-12\" layout=\"row\" \nlayout-align=\"center center\"><div flex=\"33\"><div class=\"fc-input\"><input type=\"number\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--change-border-color\" name=\"quantity\" \nng-disabled=\"!item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\" \nng-required=\"true\" min=\"0.0\" string-to-number ng-model=\"item.quantity\" ng-change=\"vm.updateTotal(item)\" \nng-class=\"{\n                    invalid: vm.quotationForm.quantity.$touched && vm.quotationForm.quantity.$invalid,\n                    disabled: !item.productService.id || vm.hideButton || (vm.quotation.id && vm.quotation.status !== \'pending\')\n                  }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.QTY.LABEL\' | translate)}}</label>\n</div></div><div flex=\"33\" \nng-hide=\"\n                (vm.selectedCustomer &&\n                vm.selectedCustomer.metadata &&\n                vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n                (item.productService &&\n                item.productService.metadata &&\n                item.productService.metadata.featureDisableShowValueOnQuotation)\n              \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"value\" ng-model=\"item.productService.value\" \nng-change=\"vm.updateTotal(item)\" ng-disabled=\"vm.setProductServiceInputDisabled(item.productService)\" min=\"0.01\" \nng-required=\"true\" ui-money-mask \nng-class=\"{\n                    invalid: vm.quotationForm.value.$touched && vm.quotationForm.value.$invalid,\n                    disabled: vm.setProductServiceInputDisabled(item.productService)\n                  }\">\n<label class=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.VALUE.LABEL\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div><div flex=\"33\" \nng-hide=\"\n                (vm.selectedCustomer &&\n                vm.selectedCustomer.metadata &&\n                vm.selectedCustomer.metadata.featureDisableShowProductServiceValueOnQuotation) ||\n                (item.productService &&\n                item.productService.metadata &&\n                item.productService.metadata.featureDisableShowValueOnQuotation)\n              \">\n<div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input fc-input__input--change-border-color\" name=\"total\" ng-required=\"true\" ng-disabled=\"true\" \nng-model=\"item.total\" ui-money-mask ng-class=\"{\n                    disabled: true\n                  }\"><label \nclass=\"fc-input__label\" translate=\"QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.TOTAL.LABEL\" \ntranslate-values=\"{currency: vm.currencySymbol}\"></label></div></div></div><fc-smart-rewrite \nreference-id=\"item.sessionId || item.referenceId || item.id\" reference-type=\"quotation-product-service-description\" \ndisabled=\"vm.hideButton\" class=\"flex-100\"><fc-textarea id=\"itemDescServ__{{$index}}\" is-disabled=\"vm.hideButton\" \nclass=\"fc-textarea__textarea--change-border-color\" \nlabel=\"{{(\'QUOTATIONS.DIALOG.MODEL.PRODUCT_SERVICE.MODEL.DESCRIPTION.LABEL\' | translate)}}\" \nng-model=\"item.description\" input-name=\"itemDescServ__{{$index}}\" \ninput-control=\"vm.quotationForm[\'itemDescServ__\' + $index]\" max-length=\"2000\" , ng-change=\"vm.updateTotal(item)\" , \nerrors-to-watch=\"[\n                  {\n                    name: \'maxlength\',\n                    translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n                    translateValues: { expectedLength: 2000, receivedLength: vm.quotationForm[\'itemDescServ__\' + $index].$viewValue.length }\n                  },\n                ]\">\n</fc-textarea></fc-smart-rewrite></div></div></div></div></div>");
$templateCache.put("app/main/quotations/dialogs/tabs/attachments/attachments-tab.html","<div class=\"attachments-tab\"><div class=\"attachments-tab__upload-container\" \nng-class=\"{ \'has-images\': vm.files.length > 0 }\" ngf-drop ng-model=\"vm.files\" name=\"files\" layout=\"row\" \nlayout-align=\"center\" ngf-multiple=\"true\" \nngf-pattern=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx,.mp4\'\" \nngf-max-files=\"{{vm.attachmentsLimit - vm.files.length}}\" \nngf-accept=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx,.mp4\'\" \nngf-allow-dir=\"true\" ngf-validate-fn=\"vm.validateImageSize($file)\" ng-if=\"vm.attachments.length < vm.attachmentsLimit\">\n<div class=\"has-images__files-preview\" ng-if=\"vm.files.length\"><div ng-repeat=\"file in vm.files\" \nng-if=\"!vm.uploadProgress\"><md-icon class=\"has-images__files-preview__remove\" \nmd-svg-src=\"assets/icons/icon-remove.svg\" ng-click=\"vm.removeFile($index)\"></md-icon><div \nclass=\"has-images__files-preview__thumbnail\"><img ng-if=\"vm.isFileTypeImage(file)\" ngf-thumbnail=\"file\" \nngf-size=\"{width: 100, height: 100, quality: 0.9}\"><md-icon ng-if=\"!vm.isFileTypeImage(file)\" class=\"file-image\" \nng-class=\"vm.getIconByFileType(file.type)\" md-font-icon=\"{{vm.getIconByFileType(file.type)}}\"></md-icon></div></div>\n<div ng-if=\"vm.uploadProgress\" class=\"has-images__files-preview__loading\"><md-progress-circular id=\"upload-progress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div></div><img \nng-if=\"!vm.files.length\" src=\"assets/icons/icon-upload-blue.svg\"><div \nng-class=\"{ \'has-images__drag-message\': vm.files.length > 0 }\" class=\"attachments-tab__upload-container__drag-message\">\n{{ \'QUOTATIONS.DIALOG.ATTACHMENTS.DRAG_FILES\' | translate }} <span ng-if=\"vm.files.length\">\n{{ \'QUOTATIONS.DIALOG.ATTACHMENTS.OR\' | translate }}</span></div><div ng-if=\"!vm.files.length\" \nclass=\"attachments-tab__upload-container__drag-limit\">{{ \'QUOTATIONS.DIALOG.ATTACHMENTS.DRAG_LIMIT\' | translate }}\n</div><div class=\"attachments-tab__upload-container__action-buttons\"><button \nclass=\"attachments-tab__upload-container__action-buttons__upload-button\" ngf-select ng-model=\"vm.files\" \nngf-multiple=\"true\" \nngf-pattern=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx,.mp4\'\" \nngf-max-files=\"{{vm.attachmentsLimit - vm.files.length}}\" \nngf-accept=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx,.mp4\'\" \nngf-allow-dir=\"true\" ngf-validate-fn=\"vm.validateImageSize($file)\" \nng-disabled=\"vm.attachments.length >= vm.attachmentsLimit || vm.uploadProgress\"><img src=\"assets/icons/paper-clip.svg\">\n {{ \'QUOTATIONS.DIALOG.ATTACHMENTS.UPLOAD_BUTTON\' | translate }}</button> <button ng-if=\"vm.files.length\" \nng-disabled=\"$root.loadingProgress === true\" ng-class=\"{disabled: $root.loadingProgress === true}\" \nng-click=\"vm.uploadImages()\" class=\"attachments-tab__upload-container__action-buttons__send-button\">\n{{ \'QUOTATIONS.DIALOG.ATTACHMENTS.UPLOAD\' | translate }}</button></div></div><div \nng-if=\"vm.attachments.length >= vm.attachmentsLimit\" class=\"attachments-tab__limit-reached\"><img \nsrc=\"assets/icons/danger-icon.svg\"> {{ \'QUOTATIONS.DIALOG.ATTACHMENTS.LIMIT_REACHED\' | translate }}</div><span \nclass=\"attachments-tab__title\">\n{{ \'QUOTATIONS.DIALOG.ATTACHMENTS.TITLE\' | translate }} ({{vm.attachments.length}}/{{vm.attachmentsLimit}})</span><div \nng-if=\"!vm.attachments.length && !vm.loadingAttachments\" class=\"attachments-tab__no-attachments\"><img \nsrc=\"assets/icons/horizontal-paper-clip.svg\"> {{ \'QUOTATIONS.DIALOG.ATTACHMENTS.NO_ATTACHMENTS\' | translate }}</div>\n<div ng-if=\"vm.attachments.length && !vm.loadingAttachments\" class=\"attachments-tab__attachments-container\"><div \nclass=\"attachments-tab__attachments-container__single\" \nng-class=\"{ \'only-one-attachment\': vm.attachments.length == 1 }\" \nng-repeat=\"attachment in vm.attachments track by $index\"><div \nclass=\"attachments-tab__attachments-container__single__arrows\"><button \nng-click=\"vm.moveAttachmentUp(attachment.id, attachment.position)\" ng-if=\"$index !== 0\"><img \nsrc=\"assets/icons/full-arrow-up.svg\"></button> <button \nng-click=\"vm.moveAttachmentDown(attachment.id, attachment.position)\" ng-if=\"$index !== vm.attachments.length - 1\"><img \nsrc=\"assets/icons/full-arrow-down.svg\"></button></div><div ng-if=\"vm.isFileTypeImage(attachment)\" \nclass=\"attachments-tab__attachments-container__single__preview\" \nng-style=\"{\'background-image\': \'url(\' + attachment.path + \')\'}\"></div><div \nclass=\"attachments-tab__attachments-container__single__preview--file\" ng-if=\"!vm.isFileTypeImage(attachment)\"><md-icon \nclass=\"file-image\" ng-class=\"vm.getIconByFileType(attachment.type)\" \nmd-font-icon=\"{{vm.getIconByFileType(attachment.type)}}\"></md-icon></div><div \nclass=\"attachments-tab__attachments-container__single__information\"><span title=\"{{ attachment.title }}\" \nclass=\"attachments-tab__attachments-container__single__information__title\">{{ attachment.title }}</span> <span \nclass=\"attachments-tab__attachments-container__single__information__date\" \ntranslate=\"QUOTATIONS.DIALOG.ATTACHMENTS.CREATED_AT\" \ntranslate-value-date=\"{{ attachment.createdAt | amDateFormat: vm.dateFormat }}\" \ntranslate-value-hour=\"{{ attachment.createdAt | amDateFormat: vm.timeFormat  }}\"></span> <button \nng-click=\"vm.renameAttachment(attachment.id, attachment.title, ev)\" \nclass=\"attachments-tab__attachments-container__single__information__rename-button\">\n{{ \'QUOTATIONS.DIALOG.ATTACHMENTS.RENAME\' | translate }}</button><div ng-if=\"attachment.archived\" \nclass=\"attachments-tab__attachments-container__single__information__archived-message\"><img \nsrc=\"assets/icons/icon-archive.svg\"> <span>{{ \'QUOTATIONS.DIALOG.ATTACHMENTS.ARCHIVED\' | translate }}</span></div>\n</div><div class=\"attachments-tab__attachments-container__single__action-buttons\"><md-button \nng-click=\"vm.openOriginal(attachment.path)\"><md-icon md-svg-src=\"assets/icons/icon-eye-view_light-gray.svg\"></md-icon>\n<md-tooltip md-direction=\"bottom\">{{ \'QUOTATIONS.DIALOG.ATTACHMENTS.VIEW\' | translate }}</md-tooltip></md-button>\n<md-button ng-click=\"vm.deleteAttachment(attachment.id, attachment.position, $event)\"><md-icon \nmd-svg-src=\"assets/icons/icon-trash-can-gray.svg\"></md-icon><md-tooltip md-direction=\"bottom\">\n{{ \'QUOTATIONS.DIALOG.ATTACHMENTS.REMOVE\' | translate }}</md-tooltip></md-button><md-button \nng-click=\"vm.archiveAttachment(attachment.id, !attachment.archived, $event)\"><md-icon \nmd-svg-src=\"assets/icons/icon-archive.svg\"></md-icon><md-tooltip md-direction=\"bottom\">\n{{ attachment.archived ? \'QUOTATIONS.DIALOG.ATTACHMENTS.UNARCHIVE\' : \'QUOTATIONS.DIALOG.ATTACHMENTS.ARCHIVE\' | translate }}\n</md-tooltip></md-button></div></div></div><div ng-if=\"vm.loadingAttachments\" \nclass=\"attachments-tab__loading-attachments\"><md-progress-circular id=\"loading-attachments\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"52\"></md-progress-circular></div></div>");
$templateCache.put("app/main/quotations/dialogs/tabs/expenses/expenses-tab.html","<div class=\"expenses-tab\"><div class=\"expenses-tab__quotation-items-container\"><quotation-expenses \nng-if=\"vm.hasPaymentsBetaFlag\" is-copy=\"vm.quotation.copy\" quotation=\"vm.quotation\" quotation-form=\"quotationForm\">\n</quotation-expenses></div><div \nng-hide=\"vm.selectedCustomer && vm.selectedCustomer.metadata && vm.selectedCustomer.metadata.featureQuotationAddDiscountDisabled && vm.selectedCustomer.metadata.featureDisableShowQuotationTotalValue\" \nclass=\"expenses-tab__footer\"><div class=\"expenses-tab__footer__item\" \nng-if=\"!vm.selectedCustomer.metadata.featureQuotationAddDiscountDisabled\"><span \nclass=\"expenses-tab__footer__item__span-title\" translate=\"QUOTATIONS.DIALOG.MODEL.DISCOUNT.LABEL\">Discount</span><div \nclass=\"fc-input\" flex=\"75\"><input type=\"text\" class=\"fc-input__input fc-input__input__discount\" \nng-if=\"vm.quotation.discount.type === \'value\'\" ui-money-mask ng-model=\"vm.quotation.discount.value\" \nng-change=\"vm.validateDiscountValue()\" ng-disabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" \nng-class=\"{\n            disabled: vm.quotation.id && vm.quotation.status !== \'pending\',\n            invalid: vm.formErr[\'errorValueDiscount\'],\n          }\">\n <input type=\"number\" class=\"fc-input__input fc-input__input__discount\" \nng-if=\"vm.quotation.discount.type === \'percentage\'\" ng-change=\"vm.validateDiscountValue()\" \nng-model=\"vm.quotation.discount.value\" ng-disabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" \nng-class=\"{\n            disabled: vm.quotation.id && vm.quotation.status !== \'pending\',\n            invalid: vm.formErr[\'errorValueDiscount\']\n          }\">\n</div><div class=\"discount-select\"><fc-select options=\"vm.discountOptions\" ng-model=\"vm.currentDiscountOption\" \nng-change=\"vm.changeDiscountType(value)\" track-by=\"symbol\" \nis-disabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" without-divider=\"true\"></fc-select></div></div><div \nclass=\"expenses-tab__footer__item\" \nng-if=\"vm.selectedCustomer && !vm.selectedCustomer.metadata || vm.selectedCustomer.metadata && !vm.selectedCustomer.metadata.featureDisableShowQuotationTotalValue\">\n<span class=\"expenses-tab__footer__item__span-title\" \ntranslate=\"QUOTATIONS.DIALOG.EXPENSES.FOOTER.PRODUCTS_SERVICES_TOTAL\">Products and Services</span><div flex=\"100\" \nclass=\"fc-input\"><input class=\"fc-input__input disabled\" placeholder=\" \" autocomplete=\"off\" name=\"number\" \nui-money-mask ng-disabled=\"true\" ng-model=\"vm.quotation.subtotal\"></div></div><div class=\"expenses-tab__footer__item\" \nng-if=\"vm.selectedCustomer && !vm.selectedCustomer.metadata || vm.selectedCustomer.metadata && !vm.selectedCustomer.metadata.featureDisableShowQuotationTotalValue\">\n<span class=\"expenses-tab__footer__item__expense-title\" translate=\"QUOTATIONS.DIALOG.EXPENSES.FOOTER.EXPENSES_TOTAL\">\nExpenses</span><div flex=\"100\" class=\"fc-input\"><input class=\"fc-input__input disabled\" placeholder=\" \" \nautocomplete=\"off\" name=\"number\" ui-money-mask ng-disabled=\"true\" ng-model=\"vm.expensesTotalValue\"></div></div><div \nclass=\"expenses-tab__footer__item\" \nng-if=\"vm.selectedCustomer && !vm.selectedCustomer.metadata || vm.selectedCustomer.metadata && !vm.selectedCustomer.metadata.featureDisableShowQuotationTotalValue\">\n<span class=\"expenses-tab__footer__item__span-title\" translate=\"QUOTATIONS.DIALOG.EXPENSES.FOOTER.TOTAL\">Total</span>\n<div flex=\"100\" class=\"fc-input\"><div class=\"fc-input__input fc-input__input__total disabled\" \nng-class=\"{ invalid: vm.formErr[\'errorValueDiscount\'] }\">{{ vm.quotation.total | currencyFormat }}</div></div></div>\n</div></div>");
$templateCache.put("app/main/quotations/dialogs/tabs/general/general-tab.html","<div class=\"quotation-general-tab\"><div class=\"fc-warning-container\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.quotation && vm.quotation.id && vm.quotationCreatedAt\"><div layout-align=\"center center\"><md-icon \nclass=\"warning-icon\" md-svg-src=\"assets/icons/icon-warning-alert.svg\"></md-icon><span \ntranslate=\"QUOTATIONS.DIALOG.GENERAL.WARNING_SENTENCE\" \ntranslate-values=\"{createdAt: vm.quotationCreatedAt, createdBy: vm.quotation.createdBy}\"></span></div><div \nlayout=\"row\" layout-align=\"center center\"><div \nclass=\"quotation-general-tab__circle quotation-status-{{vm.quotation.status}}-bg mr-10\"></div><span \nclass=\"quotation-status-{{vm.quotation.status}}-fg\" \ntranslate=\"QUOTATIONS.STATUS.{{vm.quotation.status.toUpperCase()}}\">{{vm.quotation.status}}</span></div></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"quotation-general-tab__only-status\" \nng-if=\"!vm.quotation.id && !vm.quotationCreatedAt\"><div \nclass=\"quotation-general-tab__circle quotation-status-{{vm.quotation.status}}-bg mr-10\"></div><span \nclass=\"quotation-status-{{vm.quotation.status}}-fg general\" \ntranslate=\"QUOTATIONS.STATUS.{{vm.quotation.status.toUpperCase()}}\">{{vm.quotation.status}}</span></div><fieldset><h3 \nclass=\"subtitle\" translate=\"QUOTATIONS.DIALOG.GENERAL.QUOTATION_INFOS\">Quotation infos</h3><div \nng-if=\"vm.quotation.labels && vm.quotation.labels.length\" class=\"layout-wrap\" layout-xs=\"column\" layout=\"row\"><span \nng-repeat=\"label in vm.quotation.labels\"><span class=\"status-label md-{{ label.color }}-bg\">{{ label.name }}</span>\n</span></div><div class=\"quotation-general-tab__input-container\" layout-xs=\"column\" layout=\"row\"><div flex=\"100\">\n<fc-autocomplete is-required=\"true\" \nis-disabled=\"vm.quotation.id || (vm.order && vm.order.metadata && vm.order.metadata.featureDisableEditCustomer) || (vm.ticket && vm.ticket.metadata && vm.ticket.metadata.featureDisableEditCustomer)\" \nlabel=\"{{ \'QUOTATIONS.DIALOG.MODEL.CUSTOMER.LABEL\' | translate }}\" options=\"vm.customers\" \nng-model=\"vm.selectedCustomer\" input-name=\"customer\" input-control=\"quotationForm.customer\" \nsearch-term=\"vm.searchCustomerText\" ng-change=\"vm.changedCustomer(vm.selectedCustomer)\" \nsearch-function=\"vm.searchCustomerByName(vm.searchCustomerText)\" data-cy=\"quotation-customer-field\" track-by=\"name\" \nerrors-to-watch=\"[{\n            name: \'required\',\n            translate: \'QUOTATIONS.DIALOG.MODEL.CUSTOMER.ERRORS.REQUIRED\'\n          }]\">\n</fc-autocomplete></div></div><div class=\"quotation-general-tab__input-container quotation-create-order\" layout=\"row\">\n<div flex=\"100\"><fc-autocomplete is-required=\"!vm.quotation.id && vm.isServiceOrderRequired\" \nis-disabled=\"(\n            vm.quotation.status === \'refused\' ||\n            vm.quotation.status === \'canceled\' ||\n            vm.quotation.status === \'expired\' ||\n            !vm.selectedCustomer ||\n            vm.order.metadata.featureDisableEditTaskOnQuotation\n            )\" \nlabel=\"{{\'QUOTATIONS.DIALOG.MODEL.SERVICE_ORDER.LABEL\' | translate }}\" options=\"vm.serviceOrders\" \nng-model=\"vm.selectedServiceOrder\" ng-change=\"vm.changedServiceOrder(vm.selectedServiceOrder)\" \ninput-name=\"serviceOrder\" input-control=\"quotationForm.serviceOrder\" search-term=\"vm.searchServiceOrderIdentifierText\" \nsearch-function=\"vm.searchServiceOrderByIdentifier()\" track-by=\"identifier\" \nerrors-to-watch=\"[{\n            name: \'required\',\n            translate: \'QUOTATIONS.DIALOG.MODEL.SERVICE_ORDER.ERRORS.REQUIRED\'\n          }]\">\n</fc-autocomplete></div><div flex=\"20\" \nng-if=\"(!vm.quotation.id || (vm.quotation.id && !vm.quotation.order)) && vm.selectedCustomer && !vm.selectedCustomer.metadata || (vm.selectedCustomer && vm.selectedCustomer.metadata && !vm.selectedCustomer.metadata.featureDisableCreateTaskOnQuotation)\">\n<md-button class=\"fc-button flex-20 quotation-create-order__button\" data-cy=\"create-task-button\" type=\"submit\" \nng-disabled=\"(\n            vm.quotation.status === \'refused\' ||\n            vm.quotation.status === \'canceled\' ||\n            vm.quotation.status === \'expired\' ||\n            vm.selectedServiceOrder ||\n            !vm.selectedCustomer ||\n            vm.accountConfiguration.featureDisableAddTask\n          )\" \nng-click=\"vm.createTaskWithSelectedQuotation()\" aria-label=\"Create task with selected quotation\" \ntranslate=\"QUOTATIONS.DIALOG.ACTIONS.CREATE_SERVICE\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.CREATE_SERVICE\"></md-button><md-tooltip md-direction=\"down\" \nng-if=\"(\n          vm.quotation.status === \'refused\' ||\n          vm.quotation.status === \'canceled\' ||\n          vm.quotation.status === \'expired\' ||\n          vm.selectedServiceOrder ||\n          !vm.selectedCustomer\n        )\">\n{{ \'QUOTATIONS.DIALOG.ACTIONS.TOOLTIP\' | translate }}</md-tooltip></div></div><div \nclass=\"quotation-general-tab__input-container\" layout-xs=\"column\" layout=\"row\"><div flex=\"30\"><div class=\"fc-input\">\n<input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" data-cypress=\"inputQuotationIdentifier\" \nname=\"identifier\" ng-disabled=\"vm.identifierType !== \'none\'\" ng-change=\"vm.validateQuotationFormGeneralTab()\" \nng-maxlength=\"50\" ng-model-options=\"{ debounce: 500 }\" ng-required=\"vm.identifierType === \'none\'\" \nng-model=\"vm.quotation.identifier\" \nng-class=\"{\n              invalid: quotationForm.identifier.$touched && quotationForm.identifier.$invalid,\n            }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.IDENTIFIER.LABEL\' | translate)}}</label><fc-error \nng-show=\"quotationForm.identifier.$touched\" input-errors=\"quotationForm.identifier.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'QUOTATIONS.DIALOG.MODEL.IDENTIFIER.ERRORS.REQUIRED\'\n              },\n              {\n                name: \'identifierExists\',\n                translate: \'QUOTATIONS.DIALOG.MODEL.IDENTIFIER.ERRORS.IDENTIFIER_EXISTS\'\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"20\" class=\"fc-datepicker\" \nng-class=\"{\n        invalid: quotationForm.expiredAt.$error && quotationForm.expiredAt.$invalid && !vm.quotation.id,\n        disabled: vm.quotation.id && vm.quotation.status !== \'pending\'\n      }\">\n<label class=\"fc-datepicker__label\" translate=\"QUOTATIONS.DIALOG.MODEL.EXPIRE_DATE.LABEL\">Expire date*</label><div \nclass=\"date-container\"><md-datepicker flex required name=\"expiredAt\" ng-model=\"vm.quotation.expiredAt\" class=\"p-0\" \nng-change=\"vm.validateQuotationFormGeneralTab()\" ng-disabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" \nmd-hide-icons=\"calendar\" md-min-date=\"vm.today\" \nmd-placeholder=\"{{ \'QUOTATIONS.DIALOG.MODEL.EXPIRE_DATE.PLACEHOLDER\' | translate }}\"></md-datepicker><div \nng-messages=\"quotationForm.expiredAt.$error\" ng-show=\"quotationForm.expiredAt.$invalid\" role=\"alert\" \nclass=\"fc-input__input-error\"><div class=\"red-text\"><small><span class=\"fc-datepicker__error\" \nng-if=\"quotationForm.expiredAt.$error && quotationForm.expiredAt.$invalid && !quotationForm.expiredAt.$error.required && !vm.quotation.id\" \ntranslate=\"QUOTATIONS.DIALOG.MODEL.EXPIRE_DATE.ERRORS.INVALID\">Date is invalid </span><span \nclass=\"fc-datepicker__error\" ng-if=\"quotationForm.expiredAt.$error.required && !quotationForm.expiredAt.$error.valid\" \ntranslate=\"QUOTATIONS.DIALOG.MODEL.EXPIRE_DATE.ERRORS.REQUIRED\">Expire date is required</span></small></div></div>\n</div></div><div flex=\"50\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"quotationName\" data-cy=\"quotation-name-input\" \nng-disabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" ng-maxlength=\"150\" ng-required=\"true\" \nng-change=\"vm.validateQuotationFormGeneralTab()\" ng-model=\"vm.quotation.name\" \nng-class=\"{\n              invalid: quotationForm.quotationName.$touched && quotationForm.quotationName.$invalid,\n              disabled: vm.quotation.id && vm.quotation.status !== \'pending\'\n            }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.NAME.LABEL\' | translate)}}</label><fc-error \nng-show=\"quotationForm.quotationName.$touched\" input-errors=\"quotationForm.quotationName.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'QUOTATIONS.DIALOG.MODEL.NAME.ERRORS.REQUIRED\'\n              },\n              {\n                name: \'maxlength\',\n                translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n                translateValues: { expectedLength: 150, receivedLength: quotationForm.quotationName.$viewValue.length }\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div flex=\"100\"><fc-smart-rewrite \nreference-id=\"vm.quotation.id || vm.sessionId\" reference-type=\"quotation-description\" \ndisabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" class=\"flex-100\"><fc-textarea \nid=\"textarea-description\" is-disabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" \nlabel=\"{{(\'QUOTATIONS.DIALOG.MODEL.DESCRIPTION.LABEL\' | translate)}}\" ng-model=\"vm.quotation.description\" \ninput-name=\"description\" input-control=\"quotationForm[\'description\']\" data-cy=\"description\" max-length=\"2000\" \nerrors-to-watch=\"[\n            {\n              name: \'maxlength\',\n              translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n              translateValues: { expectedLength: 2000, receivedLength: quotationForm[\'description\'].$viewValue.length }\n            }\n          ]\">\n</fc-textarea></fc-smart-rewrite></div><div flex=\"100\"><fc-smart-rewrite \nreference-id=\"vm.quotation.id || vm.sessionId\" reference-type=\"quotation-additional-information\" \ndisabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" class=\"flex-100\"><fc-textarea \nid=\"textarea-additionalInformation\" is-disabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" \nlabel=\"{{(\'QUOTATIONS.DIALOG.MODEL.ADDITIONAL_INFORMATION.LABEL\' | translate)}}\" \nng-model=\"vm.quotation.additionalInformation\" input-name=\"additionalInformation\" \ninput-control=\"quotationForm[\'additionalInformation\']\" data-cy=\"additionalInformation\" max-length=\"2000\" \nerrors-to-watch=\"[\n            {\n              name: \'maxlength\',\n              translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n              translateValues: { expectedLength: 2000, receivedLength: quotationForm[\'additionalInformation\'].$viewValue.length }\n            }\n          ]\">\n</fc-textarea></fc-smart-rewrite></div><div flex=\"100\"><fc-textarea id=\"textarea-approvedMessage\" \nlabel=\"{{(\'QUOTATIONS.DIALOG.MODEL.APPROVAL.MESSAGE.LABEL\' | translate)}}\" is-disabled=\"true\" \nng-if=\"vm.quotation.status === \'approved\' || vm.quotation.status === \'refused\'\" \nng-model=\"vm.quotation.approvedMessage\" input-name=\"approvedMessage\" input-control=\"quotationForm[\'approvedMessage\']\" \nmax-length=\"2000\" \nerrors-to-watch=\"[\n          {\n            name: \'maxlength\',\n            translate: \'QUOTATIONS.DIALOG.MODEL.GENERAL_ERRORS.MAX_LENGTH\',\n            translateValues: { expectedLength: 2000, receivedLength: quotationForm[\'approvedMessage\'].$viewValue.length }\n          }\n        ]\">\n></fc-textarea></div></fieldset><div class=\"quotation-general-tab__send-quotation-container\" \nng-if=\"vm.selectedCustomer && !vm.isSendQuotationEmailDisabled(vm.selectedCustomer)\"><h3 class=\"subtitle\" \ntranslate=\"QUOTATIONS.DIALOG.SUBTITLES.SEND_QUOTATION_EMAIL_TO\">Send quotation to:</h3><div \nclass=\"quotation-general-tab__send-quotation-container__item\" \nng-repeat=\"email in vm.quotation.emailsToSendQuotation track by $index\" flex layout=\"row\" layout-align=\"start center\">\n<div class=\"quotation-general-tab__send-quotation-container__item__email-number\" flex=\"10\">E-mail {{$index +1}}</div>\n<div class=\"fc-input\" flex=\"75\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" \nname=\"email__{{$index}}\" ng-model=\"email.address\" ng-disabled=\"vm.quotation.id\" email-validation \nng-class=\"{\n            disabled: vm.quotation.id,\n            invalid: quotationForm[\'email__\' + $index].$touched && quotationForm[\'email__\' + $index].$invalid\n          }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.EMAIL.LABEL\' | translate)}}</label><fc-error \nng-show=\"quotationForm[\'email__\' + $index].$touched\" input-errors=\"quotationForm[\'email__\' + $index].$error\" \nerrors-to-watch=\"[\n            {\n              name: \'pattern\',\n              translate: \'QUOTATIONS.DIALOG.MODEL.EMAIL.ERRORS.INVALID\'\n            }\n          ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><button ng-if=\"!vm.quotation.id\" flex=\"20\" type=\"submit\" \nclass=\"fc-button quotation-general-tab__send-quotation-container__item__remove-button\" \nng-click=\"vm.deleteEmailToSendQuotation($index)\" aria-label=\"Remove e-mail\" \ntranslate=\"QUOTATIONS.DIALOG.ACTIONS.REMOVE_RECIPIENT_EMAIL\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.REMOVE_RECIPIENT_EMAIL\">Remove</button> <button \nng-if=\"vm.quotation.id\" flex=\"20\" type=\"submit\" \nclass=\"fc-button quotation-general-tab__send-quotation-container__item__resend-button\" \nng-click=\"vm.sendSpecificEmail(vm.quotation, quotationForm[\'email__\' + $index])\" aria-label=\"Resend\" \nng-disabled=\"quotationForm[\'email__\' + $index].$invalid || !quotationForm[\'email__\' + $index].$viewValue || quotationForm[\'email__\' + $index].$error.sended || (vm.quotation && vm.quotation.status !== \'pending\')\" \nng-class=\"{disabled: quotationForm[\'email__\' + $index].$invalid || !quotationForm[\'email__\' + $index].$viewValue || quotationForm[\'email__\' + $index].$error.sended}\">\n<span \ntranslate=\"{{ (!quotationForm[\'email__\' + $index].$error.sended ? \'QUOTATIONS.DIALOG.ACTIONS.SEND_RECIPIENT_EMAIL\' : \'QUOTATIONS.DIALOG.ACTIONS.SENT\') | translate }}\">\nResend</span><md-icon ng-if=\"quotationForm[\'email__\' + $index].$error.sended\" \nmd-svg-src=\"assets/icons/icon-checked.svg\" class=\"fc-button__icon\"></md-icon></button></div><button type=\"submit\" \nng-if=\"!vm.quotation.id && vm.quotation.emailsToSendQuotation.length <= 2\" \nclass=\"fc-clone-button quotation-general-tab__send-quotation-container__add-button\" \nng-class=\"{disabled: vm.quotation.emailsToSendQuotation.length >= 3 }\" ng-click=\"vm.addEmailToSendQuotation()\" \nng-disabled=\"vm.quotation.emailsToSendQuotation.length >= 3\" aria-label=\"Add recipient email\" \ntranslate=\"QUOTATIONS.DIALOG.ACTIONS.ADD_RECIPIENT_EMAIL\" \ntranslate-attr-aria-label=\"QUOTATIONS.DIALOG.ACTIONS.ADD_RECIPIENT_EMAIL\">Add recipient email</button><p \nng-if=\"vm.quotation.id && vm.quotation.emailsToSendQuotation.length\" class=\"mt-24 text-center\" \ntranslate=\"QUOTATIONS.DIALOG.GENERAL.OR\">or</p><div ng-if=\"vm.quotation.id\" \nclass=\"quotation-general-tab__send-quotation-container__item\" flex layout=\"row\" layout-align=\"start center\"><div \nclass=\"quotation-general-tab__send-quotation-container__item__email-phrase\" flex=\"15\" \ntranslate=\"QUOTATIONS.DIALOG.GENERAL.ALERT_WILL_NOT_BE_SAVED\">This email will not be saved in the quotation.</div><div \nclass=\"fc-input\" flex=\"70\"><input type=\"text\" placeholder=\" \" email-validation autocomplete=\"off\" \nclass=\"fc-input__input\" ng-model=\"email.address\" name=\"otherEmail\" \nng-disabled=\"quotationForm.otherEmail.$error.sended || (vm.quotation && vm.quotation.status !== \'pending\')\" \nng-class=\"{\n            disabled: quotationForm.otherEmail.$error.sended || (vm.quotation && vm.quotation.status !== \'pending\'),\n            invalid: quotationForm.otherEmail.$touched && quotationForm.otherEmail.$invalid && !quotationForm.otherEmail.$error.sended\n          }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.EMAIL.LABEL\' | translate)}}</label><fc-error \nng-show=\"quotationForm.otherEmail.$touched\" input-errors=\"quotationForm.otherEmail.$error\" \nerrors-to-watch=\"[\n            {\n              name: \'pattern\',\n              translate: \'QUOTATIONS.DIALOG.MODEL.EMAIL.ERRORS.INVALID\'\n            }\n          ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><button flex=\"20\" type=\"submit\" \nclass=\"fc-button quotation-general-tab__send-quotation-container__item__resend-button\" \nng-class=\"{\n          disabled: quotationForm.otherEmail.$invalid || quotationForm.otherEmail.$pristine || !quotationForm.otherEmail.$viewValue || quotationForm.otherEmail.sended\n        }\" \nng-disabled=\"quotationForm.otherEmail.$invalid || quotationForm.otherEmail.$pristine || !quotationForm.otherEmail.$viewValue || quotationForm.otherEmail.$error.sended\" \nng-click=\"vm.sendSpecificEmail(vm.quotation, quotationForm.otherEmail)\" aria-label=\"Send\"><span \ntranslate=\"{{ (!quotationForm.otherEmail.$error.sended ? \'QUOTATIONS.DIALOG.ACTIONS.SEND_RECIPIENT_EMAIL\' : \'QUOTATIONS.DIALOG.ACTIONS.SENT\') | translate }}\">\nSend</span><md-icon ng-if=\"quotationForm.otherEmail.$error.sended\" md-svg-src=\"assets/icons/icon-checked.svg\" \nclass=\"fc-button__icon\"></md-icon></button></div></div><div data-cy=\"customer-approve-by-link-disabled\" \nclass=\"quotation-general-tab__send-quotation-container\" \nng-if=\"vm.selectedCustomer && vm.isSendQuotationEmailDisabled(vm.selectedCustomer) &&\n      (vm.selectedCustomer.metadata && vm.selectedCustomer.metadata.sammathnaur)\">\n<h3 class=\"subtitle\" translate=\"QUOTATIONS.DIALOG.SUBTITLES.SEND_QUOTATION_EMAIL\">Send quotation</h3><div \nclass=\"quotation-general-tab__send-quotation-container__disabled-quotation-approve-by-corporate\"><span \ntranslate=\"QUOTATIONS.DIALOG.MODEL.CUSTOMER.APPROVE_BY_CUSTOMER_CORPORATE\" \ntranslate-values=\"{ customerName: vm.customerAccountName(vm.selectedCustomer) }\"></span></div></div></div>");
$templateCache.put("app/main/quotations/dialogs/tabs/products-services/products-services-tab.html","<div class=\"products-services-tab\"><div class=\"products-services-tab__quotation-items-container\"><quotation-items \nng-if=\"!vm.shouldShowNewQuotationItemsDesign\" is-copy=\"vm.quotation.copy\" quotation=\"vm.quotation\" \nquotation-form=\"quotationForm\"></quotation-items><quotation-items-equipments \nng-if=\"vm.shouldShowNewQuotationItemsDesign\" is-copy=\"vm.quotation.copy\" quotation=\"vm.quotation\" \nquotation-form=\"quotationForm\"></quotation-items-equipments></div><div \nng-hide=\"vm.selectedCustomer && vm.selectedCustomer.metadata && vm.selectedCustomer.metadata.featureQuotationAddDiscountDisabled && vm.selectedCustomer.metadata.featureDisableShowQuotationTotalValue\" \nclass=\"products-services-tab__footer\"><div class=\"products-services-tab__footer__item\" \nng-if=\"!vm.selectedCustomer.metadata.featureQuotationAddDiscountDisabled\"><span \nclass=\"products-services-tab__footer__item__span-title\" translate=\"QUOTATIONS.DIALOG.MODEL.DISCOUNT.LABEL\">Discount\n</span><div class=\"fc-input\" flex=\"75\"><input type=\"text\" class=\"fc-input__input fc-input__input__discount\" \nng-if=\"vm.quotation.discount.type === \'value\'\" ui-money-mask ng-model=\"vm.quotation.discount.value\" \nng-change=\"vm.validateDiscountValue()\" ng-disabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" \nng-class=\"{\n            disabled: vm.quotation.id && vm.quotation.status !== \'pending\',\n            invalid: vm.formErr[\'errorValueDiscount\'],\n          }\">\n <input type=\"number\" class=\"fc-input__input fc-input__input__discount\" \nng-if=\"vm.quotation.discount.type === \'percentage\'\" ng-change=\"vm.validateDiscountValue()\" \nng-model=\"vm.quotation.discount.value\" ng-disabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" \nng-class=\"{\n            disabled: vm.quotation.id && vm.quotation.status !== \'pending\',\n            invalid: vm.formErr[\'errorValueDiscount\']\n          }\">\n</div><div class=\"discount-select\"><fc-select options=\"vm.discountOptions\" ng-model=\"vm.currentDiscountOption\" \nng-change=\"vm.changeDiscountType(value)\" track-by=\"symbol\" \nis-disabled=\"vm.quotation.id && vm.quotation.status !== \'pending\'\" without-divider=\"true\"></fc-select></div></div><div \nclass=\"products-services-tab__footer__item\" \nng-if=\"vm.selectedCustomer && !vm.selectedCustomer.metadata || vm.selectedCustomer.metadata && !vm.selectedCustomer.metadata.featureDisableShowQuotationTotalValue\">\n<span class=\"products-services-tab__footer__item__span-title\" translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.SUBTOTAL\">\nSubtotal</span><div flex=\"100\" class=\"fc-input\"><input class=\"fc-input__input disabled\" placeholder=\" \" \nautocomplete=\"off\" name=\"number\" ui-money-mask ng-disabled=\"true\" ng-model=\"vm.quotation.subtotal\"></div></div><div \nclass=\"products-services-tab__footer__item\" \nng-if=\"vm.selectedCustomer && !vm.selectedCustomer.metadata || vm.selectedCustomer.metadata && !vm.selectedCustomer.metadata.featureDisableShowQuotationTotalValue\">\n<span class=\"products-services-tab__footer__item__span-title\" translate=\"QUOTATIONS.DIALOG.PRODUCTS_SERVICES.TOTAL\">\nTotal</span><div flex=\"100\" class=\"fc-input\"><div class=\"fc-input__input fc-input__input__total disabled\" \nng-class=\"{ invalid: vm.formErr[\'errorValueDiscount\'] }\">{{ vm.quotation.total | currencyFormat }}</div></div></div>\n</div></div>");
$templateCache.put("app/main/recurrences/dialog/tabs/links/links-tab.html","<div class=\"recurrence-links-tab\"><recurrence-links-tab-provider id=\"recurrence-links-tab-dialog\" \nng-attr-recurrence=\"{{ self.recurrence }}\"></recurrence-links-tab-provider></div>");
$templateCache.put("app/main/settings/contents/account-info/dialogs/resize-logo-dialog.html","<md-dialog class=\"resize-logo-dialog\"><md-dialog-content ms-scroll layout=\"row\" layout-align=\"center center\"><div \nclass=\"crop-area-square\"><img-crop image=\"vm.avatarImage\" result-image=\"vm.avatarResultImage\" \nresult-image-size=\"vm.minImageResolution\" area-type=\"square\"></img-crop></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-warn md-raised\" aria-label=\"Cancel\" \ntranslate=\"CONFIGURATIONS.ACCOUNT.RESIZE_CANCEL\" translate-attr-aria-label=\"CONFIGURATIONS.ACCOUNT.RESIZE_CANCEL\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Save\" \ntranslate=\"CONFIGURATIONS.ACCOUNT.RESIZE_CONTINUE\" translate-attr-aria-label=\"CONFIGURATIONS.ACCOUNT.RESIZE_CONTINUE\" \nng-click=\"vm.resize()\">Resize</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/dialogs/apikeys/create/create-apikey-dialog.html","<md-dialog class=\"form-dialog fixed-position\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span flex class=\"title\"><span ng-if=\"vm.createdApiKey === null\" \ntranslate=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.NEW_KEY\">New key </span><span ng-if=\"vm.createdApiKey\" \ntranslate=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.CREATED_KEY\">Api Key</span></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"{{ \'CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.CLOSE_DIALOG\' | translate }}\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form \nng-show=\"!vm.createdApiKey\" id=\"apiKeyForm\" name=\"apiKeyForm\" class=\"md-inline-form\" autocomplete=\"off\" novalidate><div\n layout-xs=\"column\" class=\"identifier-content mg-field-form\" layout=\"row\"><div flex=\"100\"><md-input-container \nclass=\"md-block\"><label translate=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.NAME.LABEL\">Name</label><input name=\"name\" \nng-model=\"vm.newName\" ng-maxlength=\"50\" required><div ng-messages=\"apiKeyForm.name.$error\" \nng-show=\"apiKeyForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.NAME.REQUIRED\">Field is required</span></div><div \nng-message=\"maxlength\"><span translate=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.NAME.MAX_LENGTH\">\nField value must be less than 50 characters</span></div></div></md-input-container></div></div></form><div \nng-if=\"vm.createdApiKey\"><form class=\"md-inline-form\" novalidate><p class=\"green-900-fg fs-14\" \ntranslate=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.INTEGRATION_KEY_CREATED\">\nThe integration key for your account has been successfully created!</p><p><pre class=\"text-center font-size-16\"><b>\n{{ vm.createdApiKey.apiKey }}</b></pre></p><p class=\"fs-14\" \ntranslate=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.FINISH_MESSAGE\"><span><b>Attention: </b></span>\nSave your key in a safe place as it will not be can be recovered later.</p></form></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"!vm.createdApiKey\" ng-click=\"vm.createApiKey()\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"apiKeyForm.$invalid || apiKeyForm.$pristine || $root.loadingProgress\" aria-label=\"Create Key\" \ntranslate=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.CREATE\" \ntranslate-attr-aria-label=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.CREATE\">Create</md-button><md-button type=\"submit\" \nng-if=\"vm.createdApiKey\" ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" \ntranslate=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.CLOSE\" \ntranslate-attr-aria-label=\"CONFIGURATIONS.DIALOGS.API_KEYS.CREATE.CLOSE\">Close</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/settings/dialogs/apikeys/delete/delete-dialog.html","<md-dialog class=\"form-dialog fixed-position\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span flex class=\"title\"><span translate=\"CONFIGURATIONS.DIALOGS.API_KEYS.DELETE.TITLE\">\nDelete API Key </span>: {{vm.key.name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"CONFIGURATIONS.DIALOGS.API_KEYS.DELETE.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form name=\"labelForm\" \nclass=\"md-inline-form\" autocomplete=\"off\" novalidate><p><span \ntranslate=\"CONFIGURATIONS.DIALOGS.API_KEYS.DELETE.MESSAGE\">The API Key won\'t be available after delete.<br>\nTo proceed, type: </span><b>{{ vm.key.name }}</b></p><md-input-container class=\"md-block mt-30\"><label \ntranslate=\"CONFIGURATIONS.DIALOGS.API_KEYS.DELETE.NAME_PLACEHOLDER\">Key name</label><input name=\"name\" \nng-model=\"vm.confirmInput\" ng-maxlength=\"50\"></md-input-container></form></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-primary md-accent md-raised\" ng-disabled=\"(vm.confirmInput !== vm.key.name) || $root.loadingProgress\" \nng-click=\"vm.deleteApiKey();\" translate=\"CONFIGURATIONS.DIALOGS.API_KEYS.DELETE.CONFIRM\">Confirm</md-button><md-button \nmd-no-ink class=\"md-primary\" ng-click=\"vm.closeDialog();\" \ntranslate=\"CONFIGURATIONS.DIALOGS.API_KEYS.DELETE.BETTER_NOT\">Better not</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/settings/dialogs/webhooks/create/create-webhook-dialog.html","<md-dialog class=\"form-dialog fixed-position\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span flex class=\"title\"><span \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.NEW_WEBHOOK\">New webhook</span></span><md-button \nclass=\"md-icon-button close-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form id=\"webhookForm\" name=\"webhookForm\" \nautocomplete=\"off\" novalidate class=\"webhook-form\"><div class=\"webhook-form__general\">\n{{ \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.GENERAL\' | translate }}</div><div class=\"fc-input webhook-form__input\">\n<input type=\"url\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"url\" ng-model=\"vm.url\" \nng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n                invalid: webhookForm.url.$touched && webhookForm.url.$invalid\n              }\" \nng-required=\"true\" ng-maxlength=\"300\"><label class=\"fc-input__label\" \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.URL.LABEL\">URL</label><fc-error ng-show=\"webhookForm.url.$touched\" \ninput-errors=\"webhookForm.url.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.URL.REQUIRED\'\n                },\n                {\n                  name: \'maxlength\',\n                  translate: \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.URL.MAX_LENGTH\',\n                  translateValues: { expectedLength: 300, receivedLength: webhookForm.url.$viewValue.length }\n                },\n                {\n                  name: \'url\',\n                  translate: \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.URL.INVALID\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error><div style=\"text-align: right\"><span \nclass=\"webhook-form__input__limit ng-binding\">\n({{ webhookForm.url.$viewValue.length ? webhookForm.url.$viewValue.length : 0 }}/240)</span></div></div><div \nclass=\"fc-input webhook-form__input\"><fc-select \nlabel=\"{{(\'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.AUTH.LABEL\' | translate)}}\" ng-model=\"vm.auth.type\" \noptions=\"vm.authenticationTypes\" is-required=\"true\" has-arrow=\"true\" is-disabled=\"$root.loadingProgress\"></fc-select>\n</div><div ng-if=\"vm.isBasicHttpAuth()\" class=\"fc-input webhook-form__input\"><input type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input\" name=\"username\" ng-model=\"vm.auth.username\" \nng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n                invalid: webhookForm.username.$touched && webhookForm.username.$invalid\n              }\" \nng-required=\"vm.isBasicHttpAuth()\" ng-maxlength=\"30\"><label class=\"fc-input__label\" \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.USERNAME.LABEL\">Username</label><fc-error \nng-show=\"webhookForm.username.$touched\" input-errors=\"webhookForm.username.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.USERNAME.REQUIRED\'\n                },\n                {\n                  name: \'maxlength\',\n                  translate: \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.USERNAME.MAX_LENGTH\',\n                  translateValues: { expectedLength: 30, receivedLength: webhookForm.username.$viewValue.length }\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error><span class=\"webhook-form__input__limit ng-binding\">\n({{ webhookForm.username.$viewValue.length ? webhookForm.username.$viewValue.length : 0 }}/30)</span></div><div \nng-if=\"vm.isBasicHttpAuth()\" class=\"fc-input webhook-form__input\"><input \ntype=\"{{ vm.showCurrentPassword ? \'text\' : \'password\' }}\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input password\" name=\"password\" ng-model=\"vm.auth.password\" ng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n                invalid: webhookForm.password.$touched && webhookForm.password.$invalid\n              }\" \nng-required=\"vm.isBasicHttpAuth()\" ng-maxlength=\"50\"><label class=\"fc-input__label\" \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.PASSWORD.LABEL\">Password</label><md-button \nclass=\"md-icon-button fc-input__toggle-password\" ng-click=\"vm.toggleCurrentPassword()\"><md-icon \nmd-font-icon=\"{{ vm.showCurrentPassword ? \'icon-eye\' : \'icon-eye-off\' }}\"></md-icon></md-button><fc-error \nng-show=\"webhookForm.password.$touched\" input-errors=\"webhookForm.password.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.PASSWORD.REQUIRED\'\n                },\n                {\n                  name: \'maxlength\',\n                  translate: \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.PASSWORD.MAX_LENGTH\',\n                  translateValues: { expectedLength: 50, receivedLength: webhookForm.password.$viewValue.length }\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div class=\"webhook-form__general\">\n{{ \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.EVENTS\' | translate }}</div><md-radio-group \nclass=\"webhook-form__radio-group\" ng-model=\"vm.toggleAllWebhooks\"><div class=\"webhook-form__radio-group__toggle-all\">\n<md-radio-button ng-value=\"true\" ng-click=\"vm.changeToggleAllWebhooks(true)\">\n{{ \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.SELECT_ALL\' | translate }}</md-radio-button></div><div \nclass=\"webhook-form__radio-group__options\"><md-radio-button ng-value=\"false\" \nng-click=\"vm.changeToggleAllWebhooks(false)\">{{ \'CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.SELECT_ONE\' | translate }}\n</md-radio-button><div class=\"webhook-form__radio-group__options__list\"><div \nclass=\"webhook-form__radio-group__options__list__option\" ng-repeat=\"webhook in vm.webhooks\"><div><md-checkbox \nclass=\"webhook-form__radio-group__options__list__option__checkbox\" ng-click=\"vm.toggleWebhook(webhook);\" \nng-checked=\"vm.isSelectedWebhook(webhook)\"></md-checkbox></div><div \nclass=\"webhook-form__radio-group__options__list__option__content\"><div \nclass=\"webhook-form__radio-group__options__list__option__content__name\" translate=\"{{ webhook.translate }}\"></div><div \nclass=\"webhook-form__radio-group__options__list__option__content__description\" translate=\"{{ webhook.description }}\">\n</div></div></div></div></div></md-radio-group></form></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.createWebhook()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"webhookForm.$invalid || $root.loadingProgress || (vm.selectedWebhooks.length === 0 && !vm.toggleAllWebhooks)\" \naria-label=\"Create\" translate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.CREATE_BUTTON\" \ntranslate-attr-aria-label=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.CREATE.CREATE_BUTTON\">Create</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/dialogs/webhooks/delete/delete-dialog.html","<md-dialog class=\"form-dialog fixed-position\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span flex class=\"title\"><span translate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.DELETE.TITLE\">\nDelete webhook </span>: {{ vm.webhook.url }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close Dialog\" translate translate-attr-aria-label=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.DELETE.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form \nname=\"labelForm\" class=\"md-inline-form\" autocomplete=\"off\" novalidate><p><span \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.DELETE.MESSAGE\">The webhook won\'t be available after delete.<br>\nTo proceed, type: </span><b>{{ vm.webhook.url }}</b></p><md-input-container class=\"md-block mt-30\"><input name=\"url\" \nng-model=\"vm.confirmInput\" ng-maxlength=\"400\" placeholder=\"URL\" translate \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.DELETE.URL_PLACEHOLDER\"></md-input-container></form></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-primary md-accent md-raised\" \nng-disabled=\"(vm.confirmInput !== vm.webhook.url) || $root.loadingProgress\" ng-click=\"vm.deleteWebhook();\" \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.DELETE.CONFIRM\">Confirm</md-button><md-button md-no-ink class=\"md-primary\" \nng-click=\"vm.closeDialog();\" translate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.DELETE.BETTER_NOT\">Better not</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/dialogs/webhooks/response-details/webhook-response-details-dialog.html","<md-dialog id=\"webhook\" class=\"sidebar-dialog sidebar-dialog--medium\"><md-toolbar \nclass=\"md-accent sidebar-dialog__header\"><div class=\"sidebar-dialog__header__title\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title\"><span \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.RESPONSE_DETAILS.REQUEST\">Request </span>: <span>{{vm.webhookResponse.id}}\n</span></span></div><div class=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close Dialog\" translate \ntranslate-attr-aria-label=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.RESPONSE_DETAILS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"pt-0\" ms-scroll><md-tabs \nmd-selected=\"vm.selectedTabIndex\" class=\"ml-24n\" md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.RESPONSE_DETAILS.REQUEST\">Request</span></md-tab-label><md-tab-body><div \nclass=\"top-left-margin-fix\"><div class=\"h3 font-weight-500\" \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.RESPONSE_DETAILS.REQUEST_HEADERS\">Request Headers:</div><div \nclass=\"relative\"><pre ms-scroll class=\"h3 font-weight-400 background-response mt-20 mb-20 scrollable\">\n{{\n                            vm.webhookResponse.request.headers | json\n                          }}</pre><md-button \nngclipboard data-clipboard-text=\"{{ vm.webhookResponse.request.headers | json }}\" ngclipboard \nngclipboard-success=\"vm.onCopyClipboard(true);\" ngclipboard-error=\"vm.onCopyClipboard(false);\" \nclass=\"md-icon-button absolute\"><md-icon class=\"color-icon\" md-font-icon=\"icon-content-copy\"></md-icon></md-button>\n</div><div class=\"h3 font-weight-500\" translate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.RESPONSE_DETAILS.REQUEST_BODY\">\nRequest Body:</div><div class=\"relative\"><pre ms-scroll \nclass=\"h3 font-weight-400 background-response mt-20 scrollable\">\n{{\n                            vm.tryGetPayloadAsObject(vm.webhookResponse.request.body) | json\n                          }}\n</pre><md-button ngclipboard \ndata-clipboard-text=\"{{ vm.tryGetPayloadAsObject(vm.webhookResponse.request.body) | json }}\" ngclipboard \nngclipboard-success=\"vm.onCopyClipboard(true);\" ngclipboard-error=\"vm.onCopyClipboard(false);\" \nclass=\"md-icon-button absolute\"><md-icon class=\"color-icon\" md-font-icon=\"icon-content-copy\"></md-icon></md-button>\n</div></div></md-tab-body></md-tab><md-tab><md-tab-label><span class=\"flex flex-align-center\"><span \ntranslate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.RESPONSE_DETAILS.RESPONSE\">Response </span><span \nclass=\"badge md-red-A700-bg ml-5 status-code\" \nng-if=\"!(vm.webhookResponse.response.statusCode >= 200 && vm.webhookResponse.response.statusCode < 300)\">\n{{ vm.webhookResponse.response.statusCode }} </span><span class=\"badge md-green-900-bg ml-5 status-code\" \nng-if=\"(vm.webhookResponse.response.statusCode >= 200 && vm.webhookResponse.response.statusCode < 300)\">\n{{ vm.webhookResponse.response.statusCode }}</span></span></md-tab-label><md-tab-body><div class=\"top-left-margin-fix\">\n<div class=\"h3 font-weight-500\" translate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.RESPONSE_DETAILS.RESPONSE_HEADERS\">\nResponse Headers:</div><div class=\"mt-20 mb-20\"><div class=\"relative\"><pre ng-if=\"vm.webhookResponse.response.headers\" \nms-scroll class=\"h3 font-weight-400 background-response relative scrollable\" id=\"copy-payload\">\n{{\n                                vm.webhookResponse.response.headers | json\n                              }}</pre>\n<pre ng-if=\"!vm.webhookResponse.response.headers\" ms-scroll \nclass=\"h3 font-weight-400 background-response relative scrollable\" id=\"copy-payload\">\n{{\n                                \"Without answer\" | json\n                              }}</pre><md-button \nngclipboard data-clipboard-text=\"{{ vm.webhookResponse.response.headers | json }}\" ngclipboard \nngclipboard-success=\"vm.onCopyClipboard(true);\" ngclipboard-error=\"vm.onCopyClipboard(false);\" \nclass=\"md-icon-button absolute\"><md-icon class=\"color-icon\" md-font-icon=\"icon-content-copy\"></md-icon></md-button>\n</div></div><div class=\"h3 font-weight-500\" translate=\"CONFIGURATIONS.DIALOGS.WEBHOOKS.RESPONSE_DETAILS.RESPONSE_BODY\">\nResponse Body:</div><div class=\"relative\"><pre ms-scroll \nclass=\"h3 font-weight-400 background-response mt-20 scrollable\">\n{{\n                            vm.tryGetPayloadAsObject(vm.webhookResponse.response.body) | json\n                          }}\n</pre><md-button ngclipboard data-clipboard-text=\"{{ vm.webhookResponse.response.body | json }}\" ngclipboard \nngclipboard-success=\"vm.onCopyClipboard(true);\" ngclipboard-error=\"vm.onCopyClipboard(false);\" \nclass=\"md-icon-button absolute\"><md-icon class=\"color-icon\" md-font-icon=\"icon-content-copy\"></md-icon></md-button>\n</div></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/tasks/dialogs/tabs/attachments/attachments-tab.html","<div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 25px\" class=\"warning\"><md-icon \nmd-svg-src=\"assets/icons/icon-question-circle.svg\"></md-icon><span style=\"margin-left: 10px\" \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.ATTACHMENT_DESCRIPTION\">\nLimit 20 attachments per Manager Panel. There is no limit on attachments in the contributor app.</span></div><div \nclass=\"container-attachments\"><div layout=\"row\" layout-align=\"center\" class=\"drop-box\" \nng-class=\"{\'has-images\': self.files.length > 0 }\" ng-disabled=\"self.order.locked\" ngf-drop ng-model=\"self.files\" \nname=\"files\" ngf-multiple=\"true\" \nngf-pattern=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx,.mp4,.xml,.zip\'\" \nngf-max-files=\"{{self.accountConfiguration.ordersUploadFilesLimit - self.attachments.length}}\" \nngf-accept=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx,.mp4,.xml,.zip\'\" \nngf-allow-dir=\"true\" ngf-validate-fn=\"self.validateImage($file)\"><div layout=\"column\" layout-align=\"center\" \nclass=\"upload-warn\"><div layout=\"column\" class=\"upload-warn__sentence-container\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\" \nng-if=\"self.accountConfiguration.ordersUploadFilesLimit - self.attachments.length <= 0\"><md-icon \nmd-svg-src=\"assets/icons/icon-service-error.svg\"></md-icon><span style=\"margin-top: 14px\" \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.ATTACHMENTS_LIMIT_REACHED\">\nAttachments limit reached to add more attachments you need to remove some first.</span></div><div \nng-if=\"self.files.length < 1 && self.accountConfiguration.ordersUploadFilesLimit - self.attachments.length > 0\">\n<md-icon md-svg-src=\"assets/icons/icon-upload.svg\"></md-icon><span class=\"upload-warn__sentence-container__phrase\" \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.DROP_HERE\" layout-align=\"center center\" layout=\"column\">\nDrag your files to upload</span></div><div class=\"upload-warn__sentence-container__actions-buttons-container\" \nng-if=\"self.attachments.length < self.accountConfiguration.ordersUploadFilesLimit\"><div><span \nclass=\"upload-warn__sentence-container__actions-buttons-container__phrase\" ng-if=\"self.files.length\" \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.INSERT_FILES_ALTERNATIVE\">Drag your files to upload or</span><md-button \nclass=\"insert-attachments\" ngf-select ng-model=\"self.files\" ngf-multiple=\"true\" \nngf-pattern=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx,.mp4,.xml,.zip\'\" \nngf-max-files=\"{{self.accountConfiguration.ordersUploadFilesLimit - self.attachments.length}}\" ngf-allow-dir=\"true\" \nngf-validate-fn=\"self.validateImage($file)\" \nngf-accept=\"\'.jpg,.jpeg,.kml,.JPG,.JPEG,.png,.PNG,.pdf,.docx,.doc,.txt,.xls,.xlsx,.csv,.ppt,.pptx,.mp4,.xml,.zip\'\" \nng-disabled=\"self.files.length > 0\"><md-icon md-svg-src=\"assets/icons/insert-attachments.svg\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.INSERT_FILES\">Insert files</span></md-button></div><md-button \nclass=\"send-attachments\" ng-click=\"self.uploadImages()\" \nng-disabled=\"!self.files.length || self.uploadProgress || self.accountConfiguration.ordersUploadFilesLimit - self.files.length < 0\" \naria-label=\"menu\" \nng-if=\"!self.order.locked && self.files.length && self.attachments.length < self.accountConfiguration.ordersUploadFilesLimit && !self.uploadProgress\">\n<span data-cy=\"save-image-button\" translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.SEND_FILES\">Save files</span></md-button>\n</div></div></div><md-progress-circular id=\"upload-progress\" ng-if=\"self.uploadProgress\" class=\"md-accent mleft-10\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"wrapper-images-upload\" \nstyle=\"display: flex\" layout-align=\"center\" ng-if=\"!self.uploadProgress\"><div ng-repeat=\"f in self.files\"><md-icon \nmd-svg-src=\"assets/icons/icon-remove.svg\" ng-click=\"self.removeUploadedAttachment($index)\"></md-icon><img \nng-if=\"self.isFileTypeImage(f)\" ngf-thumbnail=\"f\" ngf-size=\"{width: 100, height: 100, quality: 0.9}\"><div \nng-if=\"!self.isFileTypeImage(f)\" layout=\"row\" layout-align=\"center center\" class=\"attachment-icon\"><md-icon \nmd-font-icon=\"{{self.getIconByFileType(f.type)}}\" class=\"file-image-thumbnail\" \nng-class=\"self.getIconByFileType(f.type)\"></md-icon></div><br><span class=\"name-file-text\">\n{{f.$error}} {{f.$errorParam}}</span></div></div></div><div ngf-no-file-drop \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.NOT_SUPPORTED_FILE_DRAG\">File Drag/Drop is not supported for this browser\n</div><md-divider></md-divider><span class=\"attachments-limit\" \nng-class=\"{ \'red-text\': self.attachments.length >= self.accountConfiguration.ordersUploadFilesLimit }\"><span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.TITLE\">Attachments</span>\n ({{ self.attachments.length }} / {{ self.accountConfiguration.ordersUploadFilesLimit }})</span><div \n*ngf-thumbnail=\"file\" ngf-size=\"{width: 20, height: 20, quality: 0.9}\" ngf-as-background=\"boolean\"></div><div \nng-if=\"(!self.attachments.length || !self.attachments) && !self.loading\"><p class=\"text-center\"><i \nclass=\"icon-attachment s40\"></i><br><span></span> <span translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.NO_ATTACHMENTS_ADDED\">\nNo attachments have been added for this service order.</span></p></div><div ng-if=\"self.loading\"><p \nclass=\"text-center\"><md-progress-circular ng-disabled=\"!self.loading\" class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\" aria-valuemax=\"100\"></md-progress-circular><br><span></span> <span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.SEARCHING_ATTACHMENTS\">searching for order attachments.</span></p></div><div \nng-if=\"self.attachments.length && !self.loading\" class=\"sections\"><div class=\"section\"><div class=\"attachments\"><div \nclass=\"section-content\"><div ng-class=\"\'attachment\' + (attachment.archived ? \' archived\' : \'\')\" \nng-repeat=\"attachment in self.attachments track by $index\" ng-switch=\"item.type\"><div data-cy=\"attachment\" \nlayout=\"row\" layout-align=\"center center\"><div flex=\"5\"><div class=\"arrows-orders\" \nng-if=\"attachment.type !== \'signature\' && self.order.id\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"icon s-20\" \nng-if=\"$index > 0\" ng-click=\"self.reorderAttachments($index, \'up\');\"><md-tooltip md-direction=\"top\"><div \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.MOVE_UP\">Move up</div></md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"icon mt-15 s-20\" \nng-if=\"(self.order.signature && self.order.signature.path && $index <= self.attachments.length - 3) || (self.order.signature && !self.order.signature.path && $index <= self.attachments.length - 2)\" \nng-click=\"self.reorderAttachments($index, \'down\');\"><md-tooltip md-direction=\"bottom\"><div \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.MOVE_DOWN\">Move down</div></md-tooltip></md-icon></div></div><div flex>\n<div layout=\"row\" flex=\"100\"><div class=\"attachment-preview md-whiteframe-2dp\" \nng-if=\"self.isFileTypeImage(attachment)\" ng-style=\"{\'background-image\': \'url(\' + attachment.fullPath + \')\'}\"></div><div\n class=\"attachment-preview attachment-video md-whiteframe-2dp\" ng-if=\"self.isFileTypeVideo(attachment)\" \nng-click=\"self.viewOriginalAttachment(attachment.fullPath);\" \nng-style=\"{\'background-image\': \'url(\' + (attachment.status !== \'processing\' && attachment.fullPath.replace(\'.mp4\', \'.jpg\')) + \')\', \'background-size\': \'cover\'}\">\n<md-icon ng-if=\"(attachment.status && attachment.status !== \'processing\')\" class=\"icon s48 md-accent-fg\" \nmd-font-icon=\"icon-play\"></md-icon><md-progress-circular class=\"loader\" \nng-if=\"(attachment.status && attachment.status === \'processing\')\" class=\"md-accent\" md-diameter=\"42\" \nmd-mode=\"indeterminate\" aria-valuemax=\"100\"></md-progress-circular></div><div \nclass=\"attachment-preview md-whiteframe-2dp attachment-icon\" \nng-if=\"!self.isFileTypeImage(attachment) && !self.isFileTypeVideo(attachment)\"><md-icon class=\"file-image\" \nng-class=\"self.getIconByFileType(attachment.type)\" md-font-icon=\"{{self.getIconByFileType(attachment.type)}}\">\n</md-icon></div><div class=\"attachment-content\" layout=\"column\" flex=\"100\"><div layout=\"row\"><div layout=\"column\" \nflex=\"100\"><div class=\"attachment-name\" ng-if=\"attachment.editing\"><div class=\"attachment-content-edit\" \nlayout-align=\"space-between\"><input id=\"attachment_{{attachment.id}}\" name=\"attachment_{{attachment.id}}\" \nng-model=\"attachment.title\" maxlength=\"250\" ng-keydown=\"self.saveAttachmentWhenEnterKey($event, attachment);\" \ntype=\"text\"><div class=\"attachment-content-edit-actions\"><md-icon class=\"s20 clickable attachment-content__icon-check\" \nng-if=\"!self.order.id\" ng-click=\"self.fakeEditAttachmentTitle(attachment, $index);\" md-font-icon=\"icon-check\">\n<md-tooltip md-direction=\"top\"><span translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.SAVE_EDIT\">Save title</span>\n</md-tooltip></md-icon><md-icon class=\"s20 clickable attachment-content__icon-check\" ng-if=\"self.order.id\" \nng-click=\"self.saveAttachmentTitle(attachment);\" md-font-icon=\"icon-check\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.SAVE_EDIT\">Save title</span></md-tooltip></md-icon><md-icon \nclass=\"s20 clickable attachment-content__icon-close\" ng-click=\"self.cancelEditAttachment(attachment);\" \nmd-font-icon=\"icon-close\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.CANCEL_EDIT\">Cancel</span></md-tooltip></md-icon></div></div></div><div \nclass=\"attachment-content-name\" ng-if=\"!attachment.editing\"><span ng-if=\"attachment.type !== \'signature\'\">\n{{ attachment.title || ( \'TASKS.DIALOG.TABS.ATTACHMENTS.FILES.NO_TITLE\' | translate ) }}</span> <span \nng-if=\"attachment.type === \'signature\'\"><span translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.SIGNATURE\">Signature\n</span> <span ng-if=\"attachment.title\"><span translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.OF\">of</span>\n {{ attachment.title }}</span></span></div></div></div><div layout=\"row\" class=\"attachment-content__metadata\"><div \nlayout=\"column\" flex=\"60\"><span ng-if=\"attachment.metadata.createdAt\" class=\"attachment-content-time\" \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ADDED_AT\" \ntranslate-value-date=\"{{ attachment.metadata.createdAt | amDateFormat: self.dateFormat }}\" \ntranslate-value-hour=\"{{ attachment.metadata.createdAt | amDateFormat: self.timeFormat }}\">\nAdded at {{ attachment.metadata.createdAt | amDateFormat: self.dateFormat }} at {{ attachment.metadata.createdAt | amDateFormat: self.timeFormat }} \n</span><span class=\"attachment-rename\" translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.RENAME\" \nng-if=\"!self.order.locked\" ng-click=\"self.editAttachmentTitle(attachment);\">Rename </span><span class=\"archived-text\" \nng-if=\"attachment.archived\"><md-icon md-font-icon=\"icon-archive\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ARCHIVED\">Archived</span></span></div><div layout=\"column\" \nlayout-align=\"end\"><div layout=\"row\" class=\"remove-or-archive-attachment mt-22\"><md-button \nclass=\"remove-or-archive-attachment__action-button\" ng-click=\"self.viewOriginalAttachment(attachment.fullPath);\">\n<md-icon md-svg-src=\"assets/icons/icon-eye-view.svg\"></md-icon><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.VIEW_ORIGINAL\">See original attachment</span></md-tooltip></md-button>\n<md-button class=\"remove-or-archive-attachment__action-button\" ng-if=\"!self.order.locked\" \nng-click=\"attachment[\'open-delete-\' + $index] = \'visible\'\"><md-icon class=\"dark-red\" md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ACTIONS.REMOVE\">Remove attachment</span>\n</md-tooltip></md-button><md-button class=\"remove-or-archive-attachment__action-button\" \nng-if=\"!self.order.locked && self.order.id && attachment.archived === false\" \nng-click=\"attachment[\'open-archive-\' + $index] = \'visible\'\" ng-disabled=\"attachment.type === \'signature\'\"><md-icon \nclass=\"light-blue\" md-font-icon=\"icon-archive\"></md-icon><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ACTIONS.ARCHIVE\">Archive attachment</span></md-tooltip></md-button>\n<md-button class=\"remove-or-archive-attachment__action-button\" \nng-if=\"!self.order.locked && attachment.archived === true\" ng-click=\"self.unarchiveAttachment(attachment)\" \nng-disabled=\"attachment.type === \'signature\'\"><md-icon class=\"light-grey\" md-font-icon=\"icon-archive\"></md-icon>\n<md-tooltip><span translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ACTIONS.UNARCHIVE\">Unarchive attachment</span>\n</md-tooltip></md-button></div></div></div></div><div class=\"attachment-delete-dialog\" \nng-class=\"attachment[\'open-delete-\' + $index]\" layout=\"column\" flex=\"100\"><div layout=\"column\" \nlayout-align=\"space-between center\" layout-padding flex=\"100\"><div layout=\"column\" class=\"pl-30\" \nng-if=\"attachment.type === \'signature\'\"><span translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ALERTS.REMOVE_SIGNATURE\">\nAre you sure you want to delete this signature?</span></div><div layout=\"row\" ng-if=\"attachment.type !== \'signature\'\">\n<span translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ALERTS.REMOVE_ATTACHMENT\">\nAre you sure you want to delete this attachment?</span></div><div layout=\"row\"><md-button type=\"button\" \nng-click=\"self.confirmRemoveAttachment(attachment)\" style=\"color:white\" class=\"md-red-800-bg md-raised\" \naria-label=\"Delete attachment yes\" translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ALERTS.YES\" \ntranslate-attr-aria-label=\"TASKS.DIALOG.ATTACHMENTS.YES\">Yes</md-button><md-button type=\"button\" \nng-click=\"attachment[\'open-delete-\' + $index] = \'\'\" class=\"md-grey-300-bg md-raised\" aria-label=\"Delete attachment no\" \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ALERTS.NO\" translate-attr-aria-label=\"TASKS.DIALOG.ATTACHMENTS.NO\">No\n</md-button></div></div></div><div class=\"attachment-archive-dialog\" ng-class=\"attachment[\'open-archive-\' + $index]\" \nlayout=\"column\" flex=\"100\"><div layout=\"column\" layout-align=\"space-between center\" layout-padding flex=\"100\"><div \nlayout=\"column\" ng-if=\"attachment.type === \'signature\'\"><span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ALERTS.ARCHIVE_SIGNATURE\">\nAre you sure you want to archive this signature?</span></div><div layout=\"row\" ng-if=\"attachment.type !== \'signature\'\">\n<span translate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ALERTS.ARCHIVE_ATTACHMENT\">\nAre you sure you want to archive this attachment?</span></div><div layout=\"row\"><md-button type=\"button\" \nng-click=\"self.confirmArchiveAttachment(attachment)\" class=\"md-accent md-raised\" aria-label=\"Archive attachment yes\" \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ALERTS.YES\" translate-attr-aria-label=\"TASKS.DIALOG.ATTACHMENTS.YES\">Yes\n</md-button><md-button type=\"button\" ng-click=\"attachment[\'open-archive-\' + $index] = \'\'\" \nclass=\"md-grey-300-bg md-raised\" aria-label=\"Archive attachment no\" \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.FILES.ALERTS.NO\" translate-attr-aria-label=\"TASKS.DIALOG.ATTACHMENTS.NO\">No\n</md-button></div></div></div></div><div ng-switch-when=\"link\" layout=\"row\"><div \nclass=\"attachment-preview md-whiteframe-2dp\" layout=\"column\" layout-align=\"center center\"><span \ntranslate=\"TASKS.DIALOG.TABS.ATTACHMENTS.LINK\">LINK</span></div><div class=\"attachment-content\" layout=\"column\"><span \nclass=\"attachment-url\">{{item.url}}</span> <span class=\"attachment-time\">{{item.time}}</span></div></div></div></div>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/tasks/dialogs/tabs/comments/comments-tab.html","<div class=\"comments\"><div class=\"comments__body\" ms-scroll><div class=\"comments__body__wrapper\" \nng-if=\"self.comments.length && !self.firstLoading\"><div class=\"comments__started\"><label \nclass=\"comments__started__label\">\n{{\'TASKS.DIALOG.TABS.COMMENTS.COMMENTS_STARTED\' | translate}} {{self.comments[self.comments.length - 1].metadata.createdAt | formatDateTimeComments}}\n<md-tooltip>{{self.comments[self.comments.length - 1].metadata.createdAt | date: self.dateFormat}}</md-tooltip></label>\n</div><div layout=\"row\" layout-align=\"center\" ng-if=\"self.loading\"><md-progress-circular class=\"md-accent mb-5 mt-15\" \nmd-diameter=\"25\"></md-progress-circular></div><md-button class=\"comments__load-more md-accent\" \nng-if=\"!self.loading && !self.loadedAllComments\" ng-click=\"self.loadMoreComments();\">\n{{ \'TASKS.DIALOG.TABS.COMMENTS.LOAD_MORE\' | translate }}</md-button><div class=\"comment\" layout=\"row\" \nng-repeat=\"comment in self.comments | orderBy: \'-metadata.createdAt\':true\" \nng-class=\"{\'comment--self\': self.isMyOwnComment(comment)}\"><div class=\"comment__wrapper\"><img class=\"comment__avatar\" \nsrc=\"assets/images/null-avatar.jpg\" ng-src=\"{{comment.postedBy.avatarUrl}}\"></div><div class=\"comment__wrapper\"><div \nclass=\"comment__header\"><span class=\"comment__header__user-name\">\n{{comment.postedBy.name}} {{comment.type === \'corporate\' ? \'- \' + self.companyNameMetadata(self.order) : \'\'}} <span \nclass=\"comment__header__user-name__comment-type\">{{ self.validateCommentType(comment) }}</span></span></div><div \nclass=\"comment__body\"><p data-cy=\"comment\" ng-if=\"!comment.archived\" class=\"comment__body__text\" \nng-bind-html=\"comment.message\"></p><p ng-if=\"comment.archived\" \nclass=\"comment__body__text comment__body__text--archived\">{{\'TASKS.DIALOG.TABS.COMMENTS.DELETED_MESSAGE\'|translate}}\n</p><md-menu ng-if=\"!comment.archived && self.isMyOwnComment(comment)\" md-position-mode=\"target-right target\">\n<md-button class=\"md-icon-button\" ng-disabled=\"self.order.locked\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"self.deleteComment(comment)\" aria-label=\"{{ \'TASKS.DIALOG.TABS.COMMENTS.DELETE\' | translate }}\"><span \ntranslate=\"TASKS.DIALOG.TABS.COMMENTS.DELETE\">Delete comment</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div><div class=\"comment__footer\"><label class=\"comment__footer__date\">\n{{comment.metadata.createdAt | formatDateTimeComments}}<md-tooltip>\n{{comment.metadata.createdAt | date: self.dateFormat }}</md-tooltip></label></div></div></div></div><div \nclass=\"comments__no-comments\" ng-if=\"!self.comments.length && !self.firstLoading\"><i \nclass=\"icon-message-text-outline icon-color s40\"></i> <span class=\"comments__no-comments__text\" \ntranslate=\"TASKS.DIALOG.TABS.COMMENTS.NO_COMMENTS\">This work order has no comments.</span></div><div \nclass=\"comments__first-loading\" ng-if=\"self.firstLoading\"><md-progress-circular class=\"md-accent\" md-diameter=\"100\">\n</md-progress-circular></div></div><div class=\"comments__footer\"><fc-smart-rewrite><textarea id=\"text-area-comment\" \nclass=\"comments__input\" placeholder=\"{{ \'TASKS.DIALOG.TABS.COMMENTS.WRITE_A_COMMENT\' | translate }}\" \nng-disabled=\"self.sendingComment\" ng-model=\"self.comment.message\" ng-keydown=\"self.keyDownEvent($event)\">\n      \n</textarea></fc-smart-rewrite><div class=\"comments__actions\"><div class=\"comments__actions__wrapper\"><label \nclass=\"comments__actions__label\" translate=\"TASKS.DIALOG.TABS.COMMENTS.VISUALIZATION\">Visualization</label><md-select \nclass=\"comments__actions__select\" name=\"typeMessage\" ng-model=\"self.comment.type\"><md-option value=\"public\"><svg \nstyle=\"margin-bottom: -3px; margin-right: 3px\" xmlns=\"http://www.w3.org/2000/svg\" \nxmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path \nd=\"M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13C15,12.45 14.55,12 14,12H8V10H10C10.55,10 11,9.55 11,9V7H13C14.1,7 15,6.1 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16C9,17.1 9.9,18 11,18M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z\" \nfill=\"#000000\"/></svg> {{ \'TASKS.DIALOG.TABS.COMMENTS.TYPE.PUBLIC_MESSAGE\' | translate }}</md-option><md-option \nvalue=\"team\"><svg style=\"margin-bottom: -3px; margin-right: 3px\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" \nheight=\"20\" viewBox=\"0 0 24 24\"><path d=\"M9,15c-2.67,0-8,1.34-8,4v2h16v-2C17,16.34,11.67,15,9,15z\"/><path \nd=\"M22.1,6.84c0.01-0.11,0.02-0.22,0.02-0.34c0-0.12-0.01-0.23-0.03-0.34l0.74-0.58c0.07-0.05,0.08-0.15,0.04-0.22l-0.7-1.21 c-0.04-0.08-0.14-0.1-0.21-0.08L21.1,4.42c-0.18-0.14-0.38-0.25-0.59-0.34l-0.13-0.93C20.36,3.06,20.29,3,20.2,3h-1.4 c-0.09,0-0.16,0.06-0.17,0.15L18.5,4.08c-0.21,0.09-0.41,0.21-0.59,0.34l-0.87-0.35c-0.08-0.03-0.17,0-0.21,0.08l-0.7,1.21 c-0.04,0.08-0.03,0.17,0.04,0.22l0.74,0.58c-0.02,0.11-0.03,0.23-0.03,0.34c0,0.11,0.01,0.23,0.03,0.34l-0.74,0.58 c-0.07,0.05-0.08,0.15-0.04,0.22l0.7,1.21c0.04,0.08,0.14,0.1,0.21,0.08l0.87-0.35c0.18,0.14,0.38,0.25,0.59,0.34l0.13,0.93 C18.64,9.94,18.71,10,18.8,10h1.4c0.09,0,0.16-0.06,0.17-0.15l0.13-0.93c0.21-0.09,0.41-0.21,0.59-0.34l0.87,0.35 c0.08,0.03,0.17,0,0.21-0.08l0.7-1.21c0.04-0.08,0.03-0.17-0.04-0.22L22.1,6.84z M19.5,7.75c-0.69,0-1.25-0.56-1.25-1.25 s0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25S20.19,7.75,19.5,7.75z\"/>\n<path \nd=\"M19.92,11.68l-0.5-0.87c-0.03-0.06-0.1-0.08-0.15-0.06l-0.62,0.25c-0.13-0.1-0.27-0.18-0.42-0.24l-0.09-0.66 C18.12,10.04,18.06,10,18,10h-1c-0.06,0-0.11,0.04-0.12,0.11l-0.09,0.66c-0.15,0.06-0.29,0.15-0.42,0.24l-0.62-0.25 c-0.06-0.02-0.12,0-0.15,0.06l-0.5,0.87c-0.03,0.06-0.02,0.12,0.03,0.16l0.53,0.41c-0.01,0.08-0.02,0.16-0.02,0.24 c0,0.08,0.01,0.17,0.02,0.24l-0.53,0.41c-0.05,0.04-0.06,0.11-0.03,0.16l0.5,0.87c0.03,0.06,0.1,0.08,0.15,0.06l0.62-0.25 c0.13,0.1,0.27,0.18,0.42,0.24l0.09,0.66C16.89,14.96,16.94,15,17,15h1c0.06,0,0.12-0.04,0.12-0.11l0.09-0.66 c0.15-0.06,0.29-0.15,0.42-0.24l0.62,0.25c0.06,0.02,0.12,0,0.15-0.06l0.5-0.87c0.03-0.06,0.02-0.12-0.03-0.16l-0.52-0.41 c0.01-0.08,0.02-0.16,0.02-0.24c0-0.08-0.01-0.17-0.02-0.24l0.53-0.41C19.93,11.81,19.94,11.74,19.92,11.68z M17.5,13.33 c-0.46,0-0.83-0.38-0.83-0.83c0-0.46,0.38-0.83,0.83-0.83s0.83,0.38,0.83,0.83C18.33,12.96,17.96,13.33,17.5,13.33z\"/>\n<path \nd=\"M4.74,9h8.53c0.27,0,0.49-0.22,0.49-0.49V8.49c0-0.27-0.22-0.49-0.49-0.49H13c0-1.48-0.81-2.75-2-3.45V5.5 C11,5.78,10.78,6,10.5,6S10,5.78,10,5.5V4.14C9.68,4.06,9.35,4,9,4S8.32,4.06,8,4.14V5.5C8,5.78,7.78,6,7.5,6S7,5.78,7,5.5V4.55 C5.81,5.25,5,6.52,5,8H4.74C4.47,8,4.25,8.22,4.25,8.49v0.03C4.25,8.78,4.47,9,4.74,9z\"/>\n<path d=\"M9,13c1.86,0,3.41-1.28,3.86-3H5.14C5.59,11.72,7.14,13,9,13z\"/></svg>\n {{ \'TASKS.DIALOG.TABS.COMMENTS.TYPE.TEAM_MESSAGE\' | translate }}</md-option><md-option value=\"manager\"><svg \nstyle=\"margin-bottom: -3px; margin-right: 3px\" xmlns=\"http://www.w3.org/2000/svg\" \nxmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path \nd=\"M12,17C13.1,17 14,16.1 14,15C14,13.89 13.1,13 12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V10C4,8.89 4.9,8 6,8H7V6C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,3C10.34,3 9,4.34 9,6V8H15V6C15,4.34 13.66,3 12,3Z\" \nfill=\"#000000\"/></svg> {{ \'TASKS.DIALOG.TABS.COMMENTS.TYPE.MANAGER_MESSAGE\' | translate }}</md-option><md-option \nvalue=\"corporate\" ng-if=\"self.order.metadata.featureEnableCommentToCorporate\"><svg \nstyle=\"margin-bottom: -3px; margin-right: 3px\" class=\"comments__actions__icon\" width=\"20\" height=\"20\" \nviewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path \nd=\"M21 7H15C14.7348 7 14.4804 7.10536 14.2929 7.29289C14.1054 7.48043 14 7.73478 14 8V11H12V4C12 3.73478 11.8946 3.48043 11.7071 3.29289C11.5196 3.10536 11.2652 3 11 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V8C22 7.73478 21.8946 7.48043 21.7071 7.29289C21.5196 7.10536 21.2652 7 21 7ZM8 6H10V8H8V6ZM6 16H4V14H6V16ZM6 12H4V10H6V12ZM6 8H4V6H6V8ZM10 16H8V14H10V16ZM10 12H8V10H10V12ZM19 16H17V14H19V16ZM19 12H17V10H19V12Z\" \nfill=\"#000000\"/></svg> <span translate=\"TASKS.DIALOG.TABS.COMMENTS.TYPE.CORPORATE_MESSAGE\" \ntranslate-values=\"{ name: self.companyNameMetadata(self.order) }\"></span></md-option></md-select></div><div \nclass=\"comments__actions__wrapper\"><md-button class=\"md-icon-button md-accent\" \nng-disabled=\"self.comment.message.length === 0 || self.comment.message.length > 400\" ng-click=\"self.addComment();\" \naria-label=\"Add\" type=\"submit\"><md-tooltip md-direction=\"left\">\n{{\'TASKS.DIALOG.TABS.COMMENTS.PRESS_TO_SEND\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon icon-send\">\n</md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/tasks/dialogs/tabs/deadlines/deadlines-tab.html","<div class=\"deadlines-tab\"><div class=\"fc-warning-container fc-warning-container--inside-tab\"><span \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.INFO\">\nDeadline calculations are agreed with the chosen service contract and for complete activities only.</span></div><div \nng-if=\"!self.deadline.contract.id\" layout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"mt-20\"><span \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.NO_DEADLINE\">This activity has no defined deadline</span></div><div \nng-if=\"self.deadline.contract.id\"><h3 class=\"subtitle\" translate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.TITLE\">\nResponse deadline</h3><div class=\"input-group\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div flex=\"33\" \nclass=\"fc-input\"><input class=\"fc-input__input\" ng-value=\"self.deadline.responseAt\" disabled=\"disabled\"><label \nclass=\"fc-input__label\" translate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.DEADLINE_AT.LABEL\">Deadline at</label>\n</div><div flex=\"33\" class=\"fc-input\"><input class=\"fc-input__input\" ng-if=\"self.deadline.firstTaskStartedAt\" \nng-value=\"self.deadline.firstTaskStartedAt\" disabled=\"disabled\"> <input class=\"fc-input__input deadline-in-progress\" \nng-if=\"!self.deadline.firstTaskStartedAt\" \nplaceholder=\"{{ \'TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.COMPLETED_AT.IN_PROGRESS\' | translate }}\" \ndisabled=\"disabled\"><label class=\"fc-input__label--no-animation\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.COMPLETED_AT.LABEL\">Completed at</label></div><div flex=\"33\" \nclass=\"fc-input\"><input class=\"fc-input__input\" ng-class=\"self.deadline.responseStatus.classFgColor\" \nng-value=\"self.deadline.responseStatus.description\" disabled=\"disabled\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.SITUATION_DEADLINE.LABEL\">Situation deadline</label></div></div>\n<div class=\"input-group\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div flex=\"100\" class=\"mt-20\"><div \nclass=\"fc-input\" \nng-if=\"self.isEnterpriseOrder && !self.disabledReasonViolationResponse && self.isResponseViolationReasonLinkedByEnterprise\">\n<div class=\"fc-input__input fc-input__input__linked-by-enterprise\">\n{{ self.order.deadline.responseViolationReason.name }} - <span class=\"fc-input__input__linked-by-enterprise--italic\">\n{{ \'TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.LINKED_BY_ENTERPRISE\' | translate: { enterpriseAccountName: self.enterpriseAccountName } }}\n</span></div><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.LABEL\">Deadline Violation Reason</label></div>\n<div class=\"fc-input fc-input--with-suffix\" \nng-if=\"self.isEnterpriseOrder && !self.disabledReasonViolationResponse && !self.isResponseViolationReasonLinkedByEnterprise && self.featureDisableAddDeadlineViolationReason\">\n<div class=\"fc-input__input fc-input__input__linked-by-enterprise fc-input__input__linked-by-enterprise--disabled\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.LABEL\">Deadline Violation Reason</div><div \nclass=\"fc-input__suffix fc-input__suffix__disabled-by-enterprise\"><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.DISABLED_BY_ENTERPRISE_TOOLTIP\">\nCannot make changes because the customer has assigned this preference.</span></md-tooltip><md-icon \nmd-font-icon=\"icon-information\" class=\"fc-input__suffix__disabled-by-enterprise_icon\"></md-icon></div></div><fc-select \nng-if=\"self.showResponseViolationReasonInput\" is-disabled=\"self.disabledReasonViolationResponse\" \nclass=\"reason-violantion-select\" \nlabel=\"{{ self.disabledReasonViolationResponse ?\n                (\'TASKS.DIALOG.TABS.DEADLINES.MODEL.SOLUTION.REASON_VIOLATION.LABEL_NOT_VIOLED\' | translate) :\n                (\'TASKS.DIALOG.TABS.DEADLINES.MODEL.SOLUTION.REASON_VIOLATION.LABEL\' | translate) }}\" \nng-model=\"self.order.deadline.responseViolationReason\" options=\"self.violationsReasons\" has-arrow=\"true\" \ninput-name=\"responseViolationReason\" input-control=\"orderForm.responseViolationReason\" track-by=\"name\" \nsearch-phrase=\"{{(\'TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.LABEL\' | translate)}}\" \nwith-search=\"true\" ng-class=\"{\'disabled\': self.disabledReasonViolationResponse}\"></fc-select></div></div><h3 \nclass=\"subtitle\" translate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.SOLUTION.TITLE\">Solution deadline</h3><div \nclass=\"input-group\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div flex=\"33\" class=\"fc-input\"><input \nclass=\"fc-input__input\" ng-value=\"self.deadline.solutionAt\" disabled=\"disabled\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.SOLUTION.DEADLINE_AT.LABEL\">Deadline at</label></div><div flex=\"33\" \nclass=\"fc-input\"><input class=\"fc-input__input\" ng-if=\"self.deadline.firstTaskStartedAt\" \nng-value=\"self.deadline.lastTaskCompletedAt\" disabled=\"disabled\"> <input class=\"fc-input__input deadline-in-progress\" \nng-if=\"!self.deadline.firstTaskStartedAt\" \nplaceholder=\"{{ \'TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.COMPLETED_AT.IN_PROGRESS\' | translate }}\" \ndisabled=\"disabled\"><label class=\"fc-input__label--no-animation\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.SOLUTION.COMPLETED_AT.LABEL\">Completed At</label></div><div flex=\"33\" \nclass=\"fc-input\"><input class=\"fc-input__input\" ng-class=\"self.deadline.solutionStatus.classFgColor\" \nng-value=\"self.deadline.solutionStatus.description\" disabled=\"disabled\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.SOLUTION.SITUATION_DEADLINE.LABEL\">Situation deadline</label></div></div>\n<div class=\"input-group\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div flex=\"100\" class=\"mt-20\"><div \nclass=\"fc-input\" \nng-if=\"self.isEnterpriseOrder && !self.disabledReasonViolationSolution && self.isSolutionViolationReasonLinkedByEnterprise\">\n<div class=\"fc-input__input fc-input__input__linked-by-enterprise\">\n{{ self.order.deadline.solutionViolationReason.name }} - <span class=\"fc-input__input__linked-by-enterprise--italic\">\n{{ \'TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.LINKED_BY_ENTERPRISE\' | translate: { enterpriseAccountName: self.enterpriseAccountName } }}\n</span></div><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.LABEL\">Deadline Violation Reason</label></div>\n<div class=\"fc-input fc-input--with-suffix\" \nng-if=\"self.isEnterpriseOrder && !self.disabledReasonViolationSolution && !self.isSolutionViolationReasonLinkedByEnterprise && self.featureDisableAddDeadlineViolationReason\">\n<div class=\"fc-input__input fc-input__input__linked-by-enterprise fc-input__input__linked-by-enterprise--disabled\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.LABEL\">Deadline Violation Reason</div><div \nclass=\"fc-input__suffix fc-input__suffix__disabled-by-enterprise\"><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.DISABLED_BY_ENTERPRISE_TOOLTIP\">\nCannot make changes because the customer has assigned this preference.</span></md-tooltip><md-icon \nmd-font-icon=\"icon-information\" class=\"fc-input__suffix__disabled-by-enterprise_icon\"></md-icon></div></div><fc-select \nng-if=\"self.showSolutionViolationReasonInput\" is-disabled=\"self.disabledReasonViolationSolution\" \nclass=\"h100 reason-violantion-select\" \nlabel=\"{{ self.disabledReasonViolationSolution ?\n            (\'TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.LABEL_NOT_VIOLED\' | translate) :\n            (\'TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.LABEL\' | translate) }}\" \nng-model=\"self.order.deadline.solutionViolationReason\" options=\"self.violationsReasons\" \ninput-name=\"solutionViolationReason\" has-arrow=\"true\" input-control=\"orderForm.solutionViolationReason\" \ntrack-by=\"name\" with-search=\"true\" ng-class=\"{\'disabled\': self.disabledReasonViolationSolution}\" \nsearch-phrase=\"{{ (\'TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE.REASON_VIOLATION.LABEL\' | translate) }}\"></fc-select>\n</div></div><h3 class=\"subtitle\" translate=\"TASKS.DIALOG.TABS.DEADLINES.INFO_CONTRACT\">Contract Information</h3><div \nclass=\"input-group\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div flex=\"50\" class=\"fc-input\"><input \nclass=\"fc-input__input\" ng-value=\"self.deadline.contract.name\" disabled=\"disabled\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.CONTRACT_SLA.LABEL\">Contract SLA</label></div><div flex=\"25\" \nclass=\"fc-input\"><input class=\"fc-input__input\" ng-value=\"self.deadline.contract.officeHoursType\" disabled=\"disabled\">\n<label class=\"fc-input__label\" translate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.OFFICE_HOURS.LABEL\">Office Hours</label>\n</div><div flex=\"25\" class=\"fc-input\"><input class=\"fc-input__input\" ng-value=\"self.deadline.contract.considerHoliday\" \ndisabled=\"disabled\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.CONSIDER_HOLIDAYS.LABEL\">Consider holidays?</label></div></div><div \nclass=\"input-group\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div class=\"input-group\" flex=\"50\" layout=\"row\" \nlayout-xs=\"column\"><div flex=\"50\" class=\"mt-20\"><div flex=\"100\" class=\"fc-input\"><input class=\"fc-input__input\" \nng-value=\"self.deadline.contract.responseDeadlineRisk\" disabled=\"disabled\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE_DEADLINE_RISK.LABEL\">Response Deadline Risk</label></div>\n<md-tooltip><span>{{ self.deadline.contract.responseDeadlineRisk }}</span></md-tooltip></div><div flex=\"50\" \nclass=\"mt-20\"><div flex=\"100\" class=\"fc-input\"><input class=\"fc-input__input\" \nng-value=\"self.deadline.contract.responseDeadline\" disabled=\"disabled\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.RESPONSE_DEADLINE.LABEL\">Response Deadline</label></div><md-tooltip><span>\n{{ self.deadline.contract.responseDeadline }}</span></md-tooltip></div></div><div flex=\"25\" class=\"mt-20\"><div \nflex=\"100\" class=\"fc-input\"><input class=\"fc-input__input\" ng-value=\"self.deadline.contract.solutionDeadlineRisk\" \ndisabled=\"disabled\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.SOLUTION_DEADLINE_RISK.LABEL\">Solution Deadline Risk</label></div>\n<md-tooltip><span>{{ self.deadline.contract.solutionDeadlineRisk }}</span></md-tooltip></div><div flex=\"25\" \nclass=\"mt-20\"><div flex=\"100\" class=\"fc-input\"><input class=\"fc-input__input\" \nng-value=\"self.deadline.contract.solutionDeadline\" disabled=\"disabled\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.SOLUTION_DEADLINE.LABEL\">Solution Deadline</label></div><md-tooltip><span>\n{{ self.deadline.contract.solutionDeadline }}</span></md-tooltip></div></div><h3 \nng-if=\"self.deadline.contract.hasOfficeHours\" class=\"subtitle\" \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.CONSIDERED_DAYS.LABEL\">Considered Days</h3><div \nng-if=\"self.deadline.contract.hasOfficeHours\" class=\"office-hours\" layout=\"column\" layout-xs=\"column\" flex=\"100\"><div \nclass=\"office-hours-frame\"><div ng-repeat=\"officeHour in self.officeHoursDisplay\"><p class=\"office-hours-text\" \nng-if=\"self.notConsideredOfficeDays.includes(officeHour.key)\"><b><span \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.CONSIDERED_DAYS.DAYS.{{officeHour.key.toUpperCase()}}\">{{officeHour.key}}\n</span></b> &nbsp;<span \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.CONSIDERED_DAYS.DAYS.{{officeHour.value.toUpperCase()}}\">\n{{officeHour.value}}</span></p><p class=\"office-hours-text\" \nng-if=\"!self.notConsideredOfficeDays.includes(officeHour.key)\"><b><span \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.CONSIDERED_DAYS.DAYS.{{officeHour.key.toUpperCase()}}\">{{officeHour.key}}\n</span></b> &nbsp;{{officeHour.value.from.slice(0, 5)}}&nbsp;<span \ntranslate=\"TASKS.DIALOG.TABS.DEADLINES.MODEL.CONSIDERED_DAYS.TO\">&nbsp;ás&nbsp;</span>\n&nbsp;{{officeHour.value.to.slice(0, 5)}}</p></div></div></div></div></div>");
$templateCache.put("app/main/tasks/dialogs/tabs/forms/forms-tab.html","<order-forms-tab-provider ng-attr-order=\"{{ self.order }}\"></order-forms-tab-provider>");
$templateCache.put("app/main/tasks/dialogs/tabs/historic/historic-tab.html","<div class=\"select-history\"><div ng-if=\"self.timeline.length <= 0 || !self.timeline\"><p class=\"text-center\"><i \nclass=\"icon-history s40\"></i><br><span translate=\"TASKS.DIALOG.TABS.HISTORY.NO_HISTORY\">This work order has no history.\n</span></p></div><div class=\"select-history__container\" ng-if=\"self.timeline.length > 0 && self.tasks.length > 1\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"select-history__container__content\" layout=\"column\" \nlayout-align=\"baseline\"><label translate=\"TASKS.DIALOG.TABS.HISTORY.TIMELINE.SELECT\">Select</label><md-select \nng-model=\"self.selectedTask\"><md-option ng-if=\"task.id\" ng-repeat=\"task in self.tasks track by $index\" \nng-value=\"$index\" ng-class=\"{ \'archived-task-no-line-thru\': task.archived }\" class=\"fs-13\" \nng-click=\"self.loadTimeline(task);\" aria-label=\"{{ \'TASKS.DIALOG.TABS.HISTORY.SHOW_TIMELINE\' | translate }}\"><md-icon \nmd-font-icon=\"icon-clipboard-text\"></md-icon><span ng-bind-html=\"self.getTimelineLabel(task);\"></span></md-option>\n</md-select></div></div><div id=\"timeline\" ng-if=\"self.timeline.length > 0\" class=\"timeline-left fs-13\" ms-timeline>\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in self.timeline\"><div class=\"timeline-card break-card\" \nlayout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div><div\n ng-style=\"{\'background-color\': timelineItem.color}\" class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon \nmd-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div \nng-if=\"!timelineItem.offlineClock\" class=\"time\">{{timelineItem.time}}</div><div ng-if=\"timelineItem.offlineClock\" \nclass=\"time\">{{timelineItem.offlineClock}}</div><div class=\"event\"><md-icon class=\"timeline-icons\" \nng-if=\"timelineItem.eventIcon\" md-font-icon=\"icon icon-{{timelineItem.eventIcon}}\"><md-tooltip \nng-if=\"timelineItem.eventIcon\" md-direction=\"bottom\">{{timelineItem.eventIconTooltip}}</md-tooltip></md-icon><md-icon \nng-if=\"timelineItem.coords\" class=\"timeline-icons\" md-font-icon=\"icon icon-earth\"><md-tooltip md-direction=\"bottom\">\n<span translate=\"TASKS.DIALOG.TABS.HISTORY.GEOGRAPHIC_POSITION\">Geographic position:</span>\n {{ timelineItem.coords.latitude }}, {{ timelineItem.coords.longitude }}</md-tooltip></md-icon><md-icon \nng-if=\"timelineItem.mobileOffline\" class=\"timeline-icons\" md-font-icon=\"icon icon-cloud-outline-off\"><md-tooltip \nmd-direction=\"bottom\"><span translate=\"TASKS.DIALOG.TABS.HISTORY.OFFLINE_CHANGE\">Offline change - submitted on</span>\n {{ timelineItem.time }}</md-tooltip></md-icon>&nbsp;{{timelineItem.event}} <span ng-if=\"timelineItem.coords\" \nng-bind-html=\"timelineItem.coords.distanceDescription\"></span></div></div></div></div></div>");
$templateCache.put("app/main/tasks/dialogs/tabs/links/links-tab.html","<div class=\"order-links-tab\"><order-links-tab-provider id=\"order-links-tab-dialog\" ng-attr-order=\"{{ self.order }}\">\n</order-links-tab-provider></div>");
$templateCache.put("app/main/tasks/dialogs/tabs/materials/materials-tab.html","<div class=\"materials\"><div class=\"mb-24\" layout-xs=\"column\" layout=\"row\"><div flex=\"100\"><div \nclass=\"materials__migration\" ng-if=\"self.showMaterialMigration\"><img src=\"assets/icons/icon-alert-danger.svg\"> <span>\n{{\'TASKS.EXPORT_MODAL.TEMPLATE.MATERIALS_MUST_BE_MIGRATED\' | translate}} <a ng-click=\"self.closeDialog()\" \nhref=\"#/materiais\">{{ \'TASKS.EXPORT_MODAL.TEMPLATE.CLICK_HERE\' | translate }}</a>\n {{\'TASKS.EXPORT_MODAL.TEMPLATE.TO_KNOW_MORE\' | translate}}</span></div><md-autocomplete flex \nmd-input-id=\"auto-complete-materials\" md-input-name=\"materials\" md-input-minlength=\"2\" md-input-maxlength=\"150\" \nmd-no-cache=\"false\" md-selected-item-change=\"self.selectedMaterialItemChange(self.selectedMaterial)\" \nmd-selected-item=\"self.selectedMaterial\" md-search-text=\"self.selectedMaterialText\" \nmd-items=\"material in self.searchMaterials(self.selectedMaterialText)\" md-autoselect=\"true\" md-delay=\"1500\" \nmd-item-text=\"material.name\" md-floating-label=\"{{ \'TASKS.DIALOG.TABS.MATERIALS.SEARCH.LABEL\' | translate }}\">\n<md-item-template><span md-highlight-text=\"self.selectedMaterialText\">{{ material.name }}</span></md-item-template>\n<md-not-found><span translate=\"TASKS.DIALOG.TABS.MATERIALS.SEARCH.NOT_FOUND\">Material not found</span></md-not-found>\n<div class=\"hint\"><span translate=\"TASKS.DIALOG.TABS.MATERIALS.SEARCH.HINT\">Search by material name</span></div>\n</md-autocomplete></div></div><div class=\"mb-24\" ng-if=\"self.orderMaterials.length\"><h3 \ntranslate=\"TASKS.DIALOG.TABS.MATERIALS.LINKED_MATERIALS\" class=\"mb-24 mt-0\">Linked materials in this order</h3><div \nlayout-xs=\"column\" layout=\"row\" ng-repeat=\"orderMaterial in self.orderMaterials track by $index\" \nclass=\"bb mb-20 pb-20 mt-20 pt-20 order-material\"><div flex=\"50\" class=\"order-material-name\">\n{{ orderMaterial.material.name }}</div><div flex=\"25\" class=\"pr-30 order-material-quantity\"><md-input-container \nclass=\"md-block mb-0 mt-0\"><label translate=\"TASKS.DIALOG.TABS.MATERIALS.QUANTITY\">Quantity</label><input \ntype=\"number\" name=\"quantity\" ng-model=\"orderMaterial.material.quantity\" required ng-pattern=\"/^[0-9]+$/\">\n</md-input-container><fc-error ng-show=\"orderForm.quantity.$touched\" input-errors=\"orderForm.quantity.$error\" \nerrors-to-watch=\"[\n            {\n              name: \'required\',\n              translate: \'TASKS.DIALOG.TABS.MATERIALS.REQUIRED\',\n            },\n            {\n              name: \'pattern\',\n              translate: \'TASKS.DIALOG.TABS.MATERIALS.PATTERN\',\n            }\n          ]\" \ncustom-class=\"fc-input__input-error bottom-0\"></fc-error></div><div flex=\"20\" \ntranslate=\"{{ self.measuresOptions.selected(orderMaterial.material.measure) }}\">{{ orderMaterial.material.measure }}\n</div><md-fab-toolbar md-open=\"false\" md-direction=\"left\" class=\"remove-material\"><md-fab-trigger \nclass=\"align-with-text\"><md-button aria-label=\"menu\" class=\"md-fab md-primary md-mini w-35 h-35\"><md-icon \nmd-font-icon=\"icon-trash\" class=\"s20 clickable\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"TASKS.DIALOG.TABS.MATERIALS.UNLINK_MATERIAL\">Unlink material</span></md-tooltip></md-button>\n</md-fab-trigger><md-toolbar><md-fab-actions class=\"md-toolbar-tools\" layout-align=\"center center\"><div class=\"row\">\n<div layout=\"row\"><span class=\"fw-550 h3 mb-10\" translate=\"TASKS.DIALOG.TABS.MATERIALS.UNLINK_ALERT.MESSAGE\">\nAre you sure you want to unlink this equipment?</span></div><div layout=\"row\" layout-align=\"space-around center\">\n<md-button type=\"button\" class=\"md-accent md-raised\" ng-click=\"self.removeMaterial(orderMaterial.material)\"><span \ntranslate=\"TASKS.DIALOG.TABS.MATERIALS.UNLINK_ALERT.YES\">Yes</span></md-button><md-button type=\"button\" \nclass=\"md-accent md-raised\"><span translate=\"TASKS.DIALOG.TABS.MATERIALS.UNLINK_ALERT.NO\">No</span></md-button></div>\n</div></md-fab-actions></md-toolbar></md-fab-toolbar></div></div></div>");
$templateCache.put("app/main/tasks/dialogs/tabs/pendencies/pendencies-tab.html","<md-dialog-content class=\"pendencies-tab__content\" id=\"pendencies-tab-content\"><div \nng-if=\"!self.pendencies.length && self.permissions.canCreate\" ng-click=\"self.openCreatePendencyDialog()\" \nclass=\"pendencies-tab__content__empty-state\"><md-icon class=\"pendencies-tab__content__empty-state__icon\" \nmd-font-icon=\"icon-plus\"></md-icon><span class=\"pendencies-tab__content__empty-state__text\">\n{{ \'TASKS.DIALOG.TABS.PENDENCIES.EMPTY_STATE\' | translate }}</span></div><div \nng-if=\"!self.pendencies.length && !self.permissions.canCreate\" class=\"pendencies-tab__content__no-permissions\"><md-icon\n class=\"pendencies-tab__content__empty-state__icon\" md-font-icon=\"icon-lock\"></md-icon><span \nclass=\"pendencies-tab__content__empty-state__text\">\n{{ \'TASKS.DIALOG.TABS.PENDENCIES.EMPTY_STATE_NO_PERMISSIONS\' | translate }}</span></div><ng-container \nng-if=\"self.pendencies.length\"><p class=\"pendencies-tab__content_title\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.HEADLINE\" translate-values=\"{ totalCount: self.totalCount }\">\nPendencies ({{ self.totalCount }})</p><md-button ng-if=\"self.permissions.canCreate\" \nng-click=\"self.openCreatePendencyDialog()\" type=\"button\" class=\"pendencies-tab__content_add-button\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ADD\">Add new pendency</md-button><div class=\"pendencies-tab__content__scroll\" \nng-class=\"{ \'increase-height\': !self.permissions.canEdit }\"><div ng-repeat=\"pendency in self.pendencies\" \nclass=\"pendencies-tab__content__scroll__item\"><div class=\"pendencies-tab__content__scroll__item__picture\"><img \nng-if=\"pendency.contractor.logoUrl\" ng-src=\"{{ pendency.contractor.logoUrl }}\" alt=\"contractor logo\" \nclass=\"pendencies-tab__content__scroll__item__picture_logo\"><md-icon ng-if=\"!pendency.contractor.logoUrl\" \nmd-svg-src=\"assets/icons/company.svg\" class=\"pendencies-tab__content__scroll__item__picture_icon\"></md-icon></div><div \nclass=\"pendencies-tab__content__scroll__item__details\"><div \nclass=\"pendencies-tab__content__scroll__item__details__data\"><p \nclass=\"pendencies-tab__content__scroll__item__details__data_title\"><span \nclass=\"pendencies-tab__content__scroll__item__details__data_title--bold\">{{ pendency.contractor.name }} </span>\n- {{ pendency.title }}.</p><p class=\"pendencies-tab__content__scroll__item__details__data_description\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ITEM.DESCRIPTION\" \ntranslate-values=\"{ identifier: pendency.identifier, pendencyType: pendency.pendencyType.name }\">\nID {{ pendency.identifier }} | Pendency Type: {{ pendency.pendencyType.name }}</p></div><div \nclass=\"pendencies-tab__content__scroll__item__details__status-and-actions\"><div ng-if=\"pendency.status === \'opened\'\" \nclass=\"pendencies-tab__content__scroll__item__details__status-and-actions_info pendencies-tab__content__scroll__item__details__status-and-actions_info--opened\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ITEM.STATUS.OPENED\">Opened</div><div ng-if=\"pendency.status === \'done\'\" \nclass=\"pendencies-tab__content__scroll__item__details__status-and-actions_info pendencies-tab__content__scroll__item__details__status-and-actions_info--done\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ITEM.STATUS.DONE\">Finished</div><ng-container \nng-if=\"pendency.status !== \'done\'\"><div ng-if=\"pendency.treatmentStatus === \'company\'\" \nclass=\"pendencies-tab__content__scroll__item__details__status-and-actions_info pendencies-tab__content__scroll__item__details__status-and-actions_info--awaiting-management\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ITEM.TREATMENT_STATUS.AWAITING_MANAGEMENT\">Awaiting management</div><div \nng-if=\"pendency.treatmentStatus === \'enterprise\'\" \nclass=\"pendencies-tab__content__scroll__item__details__status-and-actions_info pendencies-tab__content__scroll__item__details__status-and-actions_info--awaiting-company\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ITEM.TREATMENT_STATUS.AWAITING_COMPANY\">Awaiting company</div></ng-container>\n<div ng-class=\"{ \'locked\': pendency.status === \'done\' || !self.permissions.canEdit }\" \nclass=\"pendencies-tab__content__scroll__item__details__status-and-actions__assignee\"><div \nclass=\"pendencies-tab__content__scroll__item__details__status-and-actions__assignee__button\" \nng-click=\"pendency.status !== \'done\' && self.permissions.canEdit ? self.openUpdateAssigneeModal(pendency) : null\"><img \nng-if=\"pendency.assignee && pendency.assignee.avatarUrl\" ng-src=\"{{ pendency.assignee.avatarUrl }}\" \nalt=\"assignee user\" \nclass=\"pendencies-tab__content__scroll__item__details__status-and-actions__assignee__button_picture\"><md-icon \nng-if=\"(!pendency.assignee || !pendency.assignee.avatarUrl) && (pendency.status !== \'done\' && self.permissions.canEdit)\" \nmd-svg-src=\"assets/icons/account_circle.svg\" \nclass=\"pendencies-tab__content__scroll__item__details__status-and-actions__assignee__button_icon\"></md-icon><md-icon \nng-if=\"(!pendency.assignee || !pendency.assignee.avatarUrl) && (pendency.status === \'done\' || !self.permissions.canEdit)\" \nmd-svg-src=\"assets/icons/lock_outline.svg\" \nclass=\"pendencies-tab__content__scroll__item__details__status-and-actions__assignee__button_icon\"></md-icon></div>\n<md-tooltip md-direction=\"above\"><span \nng-if=\"pendency.assignee && pendency.status !== \'done\' && self.permissions.canEdit\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ITEM.TOOLTIPS.ASSIGNEE\" \ntranslate-values=\"{ assignee: pendency.assignee.name }\">Assignee: {{ pendency.assignee.name }} </span><span \nng-if=\"!pendency.assignee && pendency.status !== \'done\' && self.permissions.canEdit\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ITEM.TOOLTIPS.NO_ASSIGNEE\">No assignee </span><span \nng-if=\"pendency.status === \'done\' && self.permissions.canEdit\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ITEM.TOOLTIPS.BLOCK_ASSIGNEE\">\nIt is not possible to change the responsible of a finalized pendency. </span><span ng-if=\"!self.permissions.canEdit\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ITEM.TOOLTIPS.NO_PERMISSION\">\nYou do not have permission to change the responsible of a finished pendency.</span></md-tooltip></div><md-button \nng-click=\"self.navigateToPendency(pendency)\" type=\"button\" \nclass=\"md-icon-button pendencies-tab__content__scroll__item__details__status-and-actions_open\"><md-icon \nmd-svg-src=\"assets/icons/open_in_new.svg\"></md-icon><md-tooltip md-direction=\"above\"><span \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.ITEM.TOOLTIPS.VIEW_PENDENCY\">View pendency</span></md-tooltip></md-button>\n</div></div></div></div><md-button \nng-class=\"{\'disabled\': (self.totalCount <= self.pendencies.length) || $root.loadingProgress}\" \nng-click=\"self.loadMorePendencies()\" type=\"button\" class=\"pendencies-tab__content__load-more-button\" \ntranslate=\"TASKS.DIALOG.TABS.PENDENCIES.LOAD_MORE\">Load more</md-button></ng-container></md-dialog-content>");
$templateCache.put("app/main/tasks/dialogs/tabs/products/products-tab.html","<div class=\"fc-warning-container fc-warning-container--inside-tab\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span translate=\"TASKS.DIALOG.TABS.PRODUCTS.INFO\" \nng-if=\"!self.hasStockModule\">Add the products that will be used in carrying out this activity. </span><span \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.INFO-STOCK\" ng-if=\"self.hasStockModule\">\nVisualize the products used in this activity.</span></div><md-dialog-content md-no-scroll \nclass=\"products-tab__content\" id=\"products-tab-content\"><div class=\"products-tab__content__search-container\"><div \nclass=\"fc-input search-bar products-tab__content__search-bar\" flex=\"100\"><input type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" ng-model=\"self.nameContains\" \nng-change=\"self.searchProducts()\" ng-model-options=\"{ debounce: 500 }\" flex=\"100\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.SEARCH_PRODUCT\">Search for an product</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div><md-button ng-if=\"self.hasStockModule\" \nclass=\"md-raised products-tab__content__link-button\" ng-click=\"self.openLinkStorageMovementDialog($event)\" \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.REGISTER_PRODUCT\">Register new product</md-button><md-button \ndata-cy=\"link-product-button\" ng-if=\"!self.hasStockModule\" class=\"md-raised products-tab__content__link-button\" \nng-click=\"self.openLinkProductDialog($event)\" translate=\"TASKS.DIALOG.TABS.PRODUCTS.LINK\" \nng-disabled=\"self.products.length >= self.maxProductsPerOrder\" \nng-class=\"self.products.length >= self.maxProductsPerOrder ? \'products-tab__content__link-button--disabled\' : \'\'\">\nLink product</md-button></div><span><h4 class=\"products-tab__content__title\" ng-if=\"!self.hasStockModule\">\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.LINKED_PRODUCTS\' | translate }} ({{self.totalCount}}/{{self.maxProductsPerOrder}})</h4>\n<h4 class=\"products-tab__content__title\" ng-if=\"self.hasStockModule\">\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.PRODUCTS_USED\' | translate }}</h4></span><span class=\"products-tab__content__value\" \nng-if=\"self.products.length && self.loadingList === false\"><h4 class=\"products-tab__content__value__not-highlighted\">\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.PRODUCTS_VALUE\' | translate }}</h4><h4 \nclass=\"products-tab__content__value__highlighted\">{{ self.order.productsTotalValue | currencyFormat }}</h4><h4 \nclass=\"products-tab__content__value__highlighted--sign\">+</h4><h4 \nclass=\"products-tab__content__value__not-highlighted\">{{ \'TASKS.DIALOG.TABS.PRODUCTS.SERVICES_VALUE\' | translate }}\n</h4><h4 class=\"products-tab__content__value__highlighted\">{{ self.order.servicesTotalValue | currencyFormat }}</h4><h4\n class=\"products-tab__content__value__highlighted--sign\">=</h4><h4 \nclass=\"products-tab__content__value__not-highlighted\">{{ \'TASKS.DIALOG.TABS.PRODUCTS.TOTAL_VALUE\' | translate }}</h4>\n<h4 class=\"products-tab__content__value__highlighted\">{{ self.order.totalValue | currencyFormat }}</h4></span><span \nng-if=\"self.products.length && self.loadingList === false\"><div class=\"products-tab__content__table\"><table \nclass=\"products-tab__content__table__content\"><thead class=\"products-tab__content__table__content__header\"><tr \nclass=\"products-tab__content__table__content__header__row\"><th ng-click=\"self.orderByName()\"><span>\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.TABLE.NAME\' | translate }}</span><md-icon \nng-class=\"self.orderBy === \'name_asc\' ? \'name-asc\' : \'name-desc\'\" md-font-icon=\"icon-arrow-down\"></md-icon></th><th>\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.TABLE.QUANTITY\' | translate }}</th><th \nclass=\"products-tab__content__table__content__header__row__value\">\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.TABLE.UNIT_VALUE\' | translate }}</th><th \nclass=\"products-tab__content__table__content__header__row__value\">\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.TABLE.TOTAL_VALUE\' | translate }}</th><th ng-if=\"!self.hasStockModule\">\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.TABLE.ACTIONS\' | translate }}</th><th ng-if=\"self.hasStockModule\"></th></tr></thead>\n<tbody class=\"products-tab__content__table__content__items\"><tr \nclass=\"products-tab__content__table__content__items__row\" ng-repeat=\"product in self.products\"><td data-cy=\"product\" \nclass=\"products-tab__content__table__content__items__row__cell--image-name\"><div ng-if=\"!product.item.imageUrl\" \nclass=\"products-tab__content__table__content__items__row__cell--image-name__default-image\"><img \nsrc=\"assets/icons/no-image_gray.svg\"></div><div ng-if=\"product.item.imageUrl\" \nclass=\"products-tab__content__table__content__items__row__cell--image-name__image\"><img \nng-src=\"{{ (product.item.imageUrl || product.imageUrl) | mumakil }}\" alt=\"{{ product.item.name || product.name }}\">\n</div><div class=\"products-tab__content__table__content__items__row__cell--image-name__title\"><span \ntitle=\"{{ product.item.name || product.name }}\" \nclass=\"products-tab__content__table__content__items__row__cell--image-name__title__name\">\n{{ product.item.name || product.name }} </span><span \nclass=\"products-tab__content__table__content__items__row__cell--image-name__title__measure\">\n({{ \'TASKS.DIALOG.TABS.PRODUCTS.MEASURE.\' + product.item.measure | translate }}) </span><span style=\"margin-top: 5px\" \nng-if=\"product.item.omieAccount\"><md-icon md-svg-src=\"assets/icons/icon-omie-active.svg\" \nclass=\"omie-products-tiny-icon\"></md-icon><span translate=\"TASKS.DIALOG.TABS.PRODUCTS.OMIE_ACCOUNT\">Omie Account</span>\n:<br><b>{{ product.item.omieAccount }}</b></span></div></td><td \nclass=\"products-tab__content__table__content__items__row__quantity\"><div \nclass=\"products-tab__content__table__content__items__row__quantity__content\" ng-if=\"!self.hasStockModule\"><input \ntype=\"number\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"quantity__{{ $index }}\" \nid=\"quantity__{{ $index }}\" ng-change=\"self.setTotalValue(product)\" ng-model=\"product.quantity\" ng-required=\"true\" \nng-maxlength=\"4\" onkeydown=\"return event.keyCode !== 69\" min=\"0.01\" \nng-class=\"{\n                      invalid: orderForm[\'quantity__\' + $index].$invalid && orderForm[\'quantity__\' + $index].$touched\n                    }\">\n<label class=\"fc-input__label\">{{ \'TASKS.DIALOG.TABS.PRODUCTS.QUANTITY\' | translate }}</label><fc-error \nng-show=\"orderForm[\'quantity__\' + $index].$touched\" input-errors=\"orderForm[\'quantity__\' + $index].$error\" \nerrors-to-watch=\"[\n                      {\n                        name: \'required\',\n                        translate: \'TASKS.DIALOG.TABS.PRODUCTS.REQUIRED\'\n                      },\n                      {\n                        name: \'maxlength\',\n                        translate: \'TASKS.DIALOG.TABS.PRODUCTS.MAX_LENGTH\',\n                        translateValues: { expectedLength: 4, receivedLength: orderForm[\'quantity__\' + $index].$viewValue.length }\n                      },\n                      {\n                        name: \'pattern\',\n                        translate: \'TASKS.DIALOG.TABS.PRODUCTS.INVALID_CHARACTER\'\n                      },\n                      {\n                        name: \'min\',\n                        translate: \'TASKS.DIALOG.TABS.PRODUCTS.MIN_NUMBER_ERROR\'\n                      }\n                    ]\" \ncustom-class=\"fc-input__input-error products-tab__content__table__content__items__row__quantity__content__word-break\">\n</fc-error></div><div ng-if=\"self.hasStockModule\"><span>{{ product.quantity }}</span></div></td><td \nclass=\"products-tab__content__table__content__items__row__value\" ng-if=\"!self.hasStockModule\"><div \nclass=\"products-tab__content__table__content__items__row__value__content\"><input type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input no-padding-right\" name=\"value__{{ $index }}\" id=\"value__{{ $index }}\" \nng-change=\"self.setTotalValue(product)\" ng-model=\"product.value\" ng-required=\"true\" \nonkeydown=\"return event.keyCode !== 69\" min=\"0.00\" ui-money-mask \nng-class=\"{\n                    invalid: orderForm[\'value__\' + $index].$invalid && orderForm[\'value__\' + $index].$touched\n                  }\">\n<label class=\"fc-input__label\">{{ \'TASKS.DIALOG.TABS.PRODUCTS.VALUE\' | translate }}</label><fc-error \nng-show=\"orderForm[\'value__\' + $index].$touched\" input-errors=\"orderForm[\'value__\' + $index].$error\" \nerrors-to-watch=\"[\n                    {\n                      name: \'required\',\n                      translate: \'TASKS.DIALOG.TABS.PRODUCTS.VALUE_REQUIRED\'\n                    },\n                    {\n                      name: \'pattern\',\n                      translate: \'TASKS.DIALOG.TABS.PRODUCTS.INVALID_CHARACTER\'\n                    },\n                    {\n                      name: \'min\',\n                      translate: \'TASKS.DIALOG.TABS.PRODUCTS.VALUE_MIN_NUMBER_ERROR\'\n                    }\n                  ]\" \ncustom-class=\"fc-input__input-error products-tab__content__table__content__items__row__value__content__word-break\">\n</fc-error></div></td><td ng-if=\"self.hasStockModule\">{{ product.value | currencyFormat }}</td><td>\n{{ product.totalValue | currencyFormat }}</td><td class=\"products-tab__content__table__content__items__row__remove\" \nng-if=\"!self.hasStockModule\"><button ng-click=\"self.openConfirmDeleteProductDialog(product)\"><img \nsrc=\"assets/icons/icon-trash-can.svg\"></button></td><td ng-if=\"self.hasStockModule\"><md-menu><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon style=\"color: #135AC0\" \nmd-menu-origin md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"6\"><md-menu-item>\n<md-button ng-click=\"self.openProductDialog($event, product.item.id)\"><md-icon md-menu-origin md-font-icon=\"icon-eye\">\n</md-icon>{{ \'TASKS.DIALOG.TABS.PRODUCTS.VIEW_PRODUCT_DETAILS\' | translate }}</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"self.openReturnStorageMovementDialog(product.item.id)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-undo\"></md-icon>{{ \'TASKS.DIALOG.TABS.PRODUCTS.RETURN_PRODUCT\' | translate }}</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"self.goToMovementsTab(product.item.id)\"><md-icon class=\"delete-icon\" \nmd-menu-origin md-svg-src=\"assets/icons/update.svg\"></md-icon>\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.SEE_PRODUCT_MOVEMENTS\' | translate }}</md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table><div class=\"products-tab__content__table__navigation\"><div \nclass=\"products-tab__content__table__navigation__text\" aria-live=\"polite\"><span \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((self.currentPage - 1) * self.limit) + 1 }} <span translate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.TO\">to</span> \n<span ng-if=\"self.totalCount < self.limit\">{{ self.totalCount }}</span> <span ng-if=\"self.totalCount >= self.limit\">\n{{ self.getLastProductCount() }}</span> <span translate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.OF\">of</span>\n {{ self.totalCount }} <span translate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.ITEMS\">items.</span></div><button \nclass=\"products-tab__content__table__navigation__button-previous\" ng-click=\"self.navigateToPage(false)\" \nng-disabled=\"self.currentPage === 1\"><span translate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.PREVIOUS\">Previous</span>\n</button> <button class=\"products-tab__content__table__navigation__button-next\" ng-click=\"self.navigateToPage(true)\" \nng-disabled=\"self.currentShowedProducts >= self.totalCount\"><span \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.NAVIGATION.NEXT\">Next</span></button></div></div></span><div \nclass=\"products-tab__content__loading\" layout=\"column\" layout-align=\"center center\" ng-if=\"self.loadingList === true\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \ntranslate=\"TASKS.DIALOG.TABS.PRODUCTS.LOADING\">Loading products ...</div></div><span \nclass=\"products-tab__content__not-found\" \nng-if=\"!self.products.length && self.loadingList === false && self.nameContains\"><img src=\"assets/icons/not-found.svg\">\n <span>{{ \'TASKS.DIALOG.TABS.PRODUCTS.NO_LINKED_PRODUCTS_FOUND\' | translate }} </span></span><span \nclass=\"products-tab__content__not-found\" \nng-if=\"!self.products.length && self.loadingList === false && !self.nameContains\"><span>\n{{ \'TASKS.DIALOG.TABS.PRODUCTS.NO_UTILIZED_PRODUCTS_FOUND\' | translate }}</span></span></md-dialog-content>");
$templateCache.put("app/main/tasks/dialogs/tabs/quotations/quotations-tab.html","<div class=\"quotations-tab\"><div class=\"fc-warning-container fc-warning-container--inside-tab\"><md-icon \nclass=\"warning-icon\" md-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.INFO\">Add quotes to this work order.</span></div><div \nclass=\"quotations-tab__header\"><fc-search data-cy=\"search-quotation\" options=\"self.searchedQuotations\" \nlabel=\"{{ \'TASKS.DIALOG.TABS.QUOTATIONS.SEARCH\' | translate }}\" \nhint=\"{{ \'TASKS.DIALOG.TABS.QUOTATIONS.SEARCH_HINT\' | translate }}\" \nsearch-function=\"self.searchQuotations(searchTerm)\" select-function=\"self.addQuotation(option)\" track-by=\"text\" \nis-disabled=\"self.quotations.length >= self.maxQuotationsAllowed\"></fc-search><md-button \nclass=\"md-raised quotations-tab__header__create-quotation\" ng-click=\"self.createQuotation($event)\" \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.CREATE\" ng-disabled=\"self.quotations.length >= self.maxQuotationsAllowed\">\nCreate quotation</md-button></div><p ng-if=\"!self.isLoading && self.quotations.length\" class=\"quotations-tab__title\">\n{{ \'TASKS.DIALOG.TABS.QUOTATIONS.LINKED\' | translate:{ quotations: self.quotations.length, maxAllowed: self.maxQuotationsAllowed } }} \n<span ng-if=\"self.quotations.length >= self.maxQuotationsAllowed\" class=\"quotations-tab__title__max-allowed\" \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.MAX_ALLOWED\">Maximum budget limit per work order reached</span></p><div \nng-repeat=\"quotation in self.quotations\" class=\"quotations-tab-quotation\" \nng-class=\"{ \'quotations-tab-quotation--archived\': quotation.archived }\"><div class=\"quotations-tab-quotation__header\">\n<span class=\"quotations-tab-quotation__header__title\"><md-icon class=\"quotations-tab-quotation__header__icon\" \nmd-svg-src=\"assets/icons/quotation.svg\"></md-icon><span>{{ quotation.name }}</span> <span ng-if=\"quotation.archived\">\n&nbsp;- {{ \'TASKS.DIALOG.TABS.QUOTATIONS.ARCHIVED\' | translate }}</span></span><md-menu \nmd-position-mode=\"target-right target\" class=\"options\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"options\"><md-icon md-menu-origin md-font-icon=\"icon-dots-horizontal\">\n</md-icon></md-button><md-menu-content class=\"options-menu-content\"><md-menu-item><md-button class=\"fs-13\" \nng-click=\"self.seeQuotation($event, quotation);\"><md-icon md-font-icon=\"icon-open-in-new\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.SEE\">See quotation</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"fs-13\" ng-click=\"self.removeQuotation(quotation);\"><md-icon md-font-icon=\"icon-trash\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.REMOVE\">Remove quotation</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div><div data-cy=\"quotation\" class=\"quotations-tab-quotation__info\"><div \nclass=\"quotations-tab-quotation__info__section quotations-tab-quotation__info__section--main\"><span \nclass=\"quotations-tab-quotation__info__title\">{{ quotation.identifier }}</span> <span \nclass=\"quotations-tab-quotation__info__text\"><span translate=\"TASKS.DIALOG.TABS.QUOTATIONS.STATUS.TITLE\">Status</span> \n<span class=\"quotation-status-{{ quotation.status }}-fg\">{{ quotation.statusName }}</span> </span><span \nng-if=\"quotation.approvedAt\" class=\"quotations-tab-quotation__info__text\" \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.APPROVED_AT\" translate-values=\"{ approvedAt: quotation.approvedAt }\">\nApproved at {{ quotation.approvedAt }} </span><span ng-if=\"quotation.refusedAt\" \nclass=\"quotations-tab-quotation__info__text\" translate=\"TASKS.DIALOG.TABS.QUOTATIONS.REFUSED_AT\" \ntranslate-values=\"{ refusedAt: quotation.refusedAt }\">Refused at {{ quotation.refusedAt }}</span></div><div \nclass=\"quotations-tab-quotation__info__section\"><span class=\"quotations-tab-quotation__info__title\" \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.PRODUCTS\" translate-values=\"{ quantity: quotation.products.quantity }\">\n{{ quotation.products.quantity }} products </span><span \nng-if=\"vm.selectedCustomer && (!vm.selectedCustomer.metadata || !vm.selectedCustomer.metadata.featureDisableShowQuotationTotalValue)\" \nclass=\"quotations-tab-quotation__info__text\" translate=\"TASKS.DIALOG.TABS.QUOTATIONS.VALUE\" \ntranslate-values=\"{ value: quotation.products.total }\">Value: {{ quotation.products.total }}</span></div><div \nclass=\"quotations-tab-quotation__info__section\"><span class=\"quotations-tab-quotation__info__title\" \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.SERVICES\" translate-values=\"{ quantity: quotation.services.quantity }\">\n{{ quotation.services.quantity }} products </span><span \nng-if=\"vm.selectedCustomer && (!vm.selectedCustomer.metadata || !vm.selectedCustomer.metadata.featureDisableShowQuotationTotalValue)\" \nclass=\"quotations-tab-quotation__info__text\" translate=\"TASKS.DIALOG.TABS.QUOTATIONS.VALUE\" \ntranslate-values=\"{ value: quotation.services.total }\">Value: {{ quotation.services.total }}</span></div><div \nng-if=\"vm.selectedCustomer && (!vm.selectedCustomer.metadata || !vm.selectedCustomer.metadata.featureDisableShowQuotationTotalValue)\" \nclass=\"quotations-tab-quotation__info__section quotations-tab-quotation__info__section--total\"><table><tr><td \nalign=\"right\"><span class=\"quotations-tab-quotation__info__text\" translate=\"TASKS.DIALOG.TABS.QUOTATIONS.SUBTOTAL\">\nSubtotal:</span></td><td class=\"quotations-tab-quotation__info__text\">{{ quotation.subtotal }}</td></tr><tr><td \nalign=\"right\"><span class=\"quotations-tab-quotation__info__text\" translate=\"TASKS.DIALOG.TABS.QUOTATIONS.DISCOUNT\">\nDiscount:</span></td><td class=\"quotations-tab-quotation__info__text\">{{ quotation.discount.total }}</td></tr><tr><td \nalign=\"right\"><span class=\"quotations-tab-quotation__info__text quotations-tab-quotation__info__text--blue\" \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.TOTAL\">Total value:</span></td><td \nclass=\"quotations-tab-quotation__info__text\">{{ quotation.total }}</td></tr></table></div></div></div><div \nng-if=\"!self.isLoading && !self.quotations.length\" class=\"quotations-tab__no-items\" \ntranslate=\"TASKS.DIALOG.TABS.QUOTATIONS.NO_ITEMS\">No linked quotation, link a new one using the search bar above.</div>\n<div class=\"quotations-tab__loading\" ng-if=\"self.isLoading\"><md-progress-circular md-diameter=\"80\">\n</md-progress-circular></div></div>");
$templateCache.put("app/main/tasks/dialogs/tabs/routes/routes-tab.html","<div class=\"routes\"><div layout=\"row\" layout-align=\"space-between center\" class=\"routes__header\"><span>\n{{ \'TASKS.DIALOG.TABS.ROUTES.ESTIMATED_ROUTE\' | translate }}</span> <span>\n{{ \'TASKS.DIALOG.TABS.ROUTES.TOTAL_KILOMETERS\' | translate: { kmTotal: self.route.kmTotal } }}</span></div><div \nclass=\"routes__body\"><div class=\"routes__body__addresses\"><div class=\"routes__body__addresses__item\" \nng-repeat=\"route in self.route.addresses| orderBy: \'position\'\" ng-init=\"isFirstRoute = $first; isLastRoute = $last\"><p \nng-if=\"isFirstRoute\">{{ \'TASKS.DIALOG.TABS.ROUTES.START_ROUTE\' | translate }}</p><p \nng-if=\"!isFirstRoute && !isLastRoute\">{{ \'TASKS.DIALOG.TABS.ROUTES.INTERMEDIATE_ROUTE\' | translate }}</p><p \nng-if=\"isLastRoute\">{{ \'TASKS.DIALOG.TABS.ROUTES.END_ROUTE\' | translate }}</p><div \nclass=\"routes__body__addresses__item__body\"><img \nsrc=\"{{ self.order.customer.avatarUrl ? \'https://ui-avatars.com/api/?name=\' : \'https://ui-avatars.com/api/?name=\' + self.order.customer.avatarUrl }}\">\n<div class=\"routes__body__addresses__item__body__address\"><p ng-if=\"isFirstRoute\">\n{{ \'TASKS.DIALOG.TABS.ROUTES.COMPANY_ADDRESS\' | translate }}</p><p ng-if=\"isLastRoute\">\n{{ \'TASKS.DIALOG.TABS.ROUTES.CUSTOMER_ADDRESS\' | translate }}</p><p>{{ route.formattedAddress }}</p></div></div><div \nclass=\"routes__body__addresses__separator\"></div></div></div><div ng-if=\"self.map\" class=\"routes__body__map\"><leaflet \nid=\"routeMap\" lf-center=\"self.map.center\" markers=\"self.map.markers\" controls=\"self.map.controls\" \nlayers=\"self.map.layers\" height=\"100%\" paths=\"self.paths\" width=\"100%\"></leaflet></div></div></div>");
$templateCache.put("app/main/tasks/dialogs/tabs/services/services-tab.html","<div class=\"fc-warning-container fc-warning-container--inside-tab\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span translate=\"TASKS.DIALOG.TABS.SERVICES.INFO\">\nAdd the services that will be used in carrying out this activity.</span></div><md-dialog-content md-no-scroll \nclass=\"services-tab__content\" id=\"services-tab-content\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"fc-input search-bar services-tab__content__search-bar\" flex=\"100\"><input type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" ng-model=\"self.nameContains\" \nng-change=\"self.searchServices()\" ng-model-options=\"{ debounce: 500 }\" flex=\"100\"><label class=\"fc-input__label\" \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.SEARCH_SERVICE\">Search for an service</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div><md-button data-cy=\"link-service-button\" \nclass=\"md-raised services-tab__content__link-button\" ng-click=\"self.openLinkServiceDialog($event)\" \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.LINK\" ng-disabled=\"self.services.length >= self.maxServicesPerOrder\" \nng-class=\"self.services.length >= self.maxServicesPerOrder ? \'services-tab__content__link-button--disabled\' : \'\'\">\nLink service</md-button></div><span><h4 class=\"services-tab__content__title\">\n{{ \'TASKS.DIALOG.TABS.SERVICES.LINKED_SERVICES\' | translate }} ({{self.totalCount}}/{{self.maxServicesPerOrder}})</h4>\n</span><span class=\"services-tab__content__value\"><h4 class=\"services-tab__content__value__not-highlighted\">\n{{ \'TASKS.DIALOG.TABS.SERVICES.PRODUCTS_VALUE\' | translate }}</h4><h4 \nclass=\"services-tab__content__value__highlighted\">{{ self.order.productsTotalValue | currencyFormat }}</h4><h4 \nclass=\"services-tab__content__value__highlighted--sign\">+</h4><h4 \nclass=\"services-tab__content__value__not-highlighted\">{{ \'TASKS.DIALOG.TABS.SERVICES.SERVICES_VALUE\' | translate }}\n</h4><h4 class=\"services-tab__content__value__highlighted\">{{ self.order.servicesTotalValue | currencyFormat }}</h4><h4\n class=\"services-tab__content__value__highlighted--sign\">=</h4><h4 \nclass=\"services-tab__content__value__not-highlighted\">{{ \'TASKS.DIALOG.TABS.SERVICES.TOTAL_VALUE\' | translate }}</h4>\n<h4 class=\"services-tab__content__value__highlighted\">{{ self.order.totalValue | currencyFormat }}</h4></span><span \nng-if=\"self.services.length && self.loadingList === false\"><div class=\"services-tab__content__table\"><table \nclass=\"services-tab__content__table__content\"><thead class=\"services-tab__content__table__content__header\"><tr \nclass=\"services-tab__content__table__content__header__row\"><th ng-click=\"self.orderByName()\"><span>\n{{ \'TASKS.DIALOG.TABS.SERVICES.TABLE.NAME\' | translate }}</span><md-icon \nng-class=\"self.orderBy === \'name_asc\' ? \'name-asc\' : \'name-desc\'\" md-font-icon=\"icon-arrow-down\"></md-icon></th><th>\n{{ \'TASKS.DIALOG.TABS.SERVICES.TABLE.QUANTITY\' | translate }}</th><th \nclass=\"services-tab__content__table__content__header__row__value\">\n{{ \'TASKS.DIALOG.TABS.SERVICES.TABLE.UNIT_VALUE\' | translate }}</th><th \nclass=\"services-tab__content__table__content__header__row__value\">\n{{ \'TASKS.DIALOG.TABS.SERVICES.TABLE.TOTAL_VALUE\' | translate }}</th><th>\n{{ \'TASKS.DIALOG.TABS.SERVICES.TABLE.ACTIONS\' | translate }}</th></tr></thead><tbody \nclass=\"services-tab__content__table__content__items\"><tr class=\"services-tab__content__table__content__items__row\" \nng-repeat=\"service in self.services\"><td data-cy=\"service\" \nclass=\"services-tab__content__table__content__items__row__cell--image-name\"><div ng-if=\"!service.item.imageUrl\" \nclass=\"services-tab__content__table__content__items__row__cell--image-name__default-image\"><img \nsrc=\"assets/icons/no-image_gray.svg\"></div><div ng-if=\"service.item.imageUrl\" \nclass=\"services-tab__content__table__content__items__row__cell--image-name__image\"><img \nng-src=\"{{ (service.item.imageUrl || service.imageUrl) | mumakil }}\" alt=\"{{ service.item.name || service.name }}\">\n</div><span>{{ service.item.name || service.name }}<br><br><span ng-if=\"service.item.omieAccount\"><md-icon \nmd-svg-src=\"assets/icons/icon-omie-active.svg\" class=\"omie-products-tiny-icon\"></md-icon><span \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.OMIE_ACCOUNT\">Omie Account</span>:<br><b>{{ service.item.omieAccount }}</b>\n</span></span></td><td class=\"services-tab__content__table__content__items__row__quantity\"><div \nclass=\"services-tab__content__table__content__items__row__quantity__content\"><input type=\"number\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input\" name=\"quantity__{{ $index }}\" id=\"quantity__{{ $index }}\" \nng-change=\"self.setService(service)\" ng-model=\"service.quantity\" ng-required=\"true\" ng-maxlength=\"4\" \nonkeydown=\"return event.keyCode !== 69\" min=\"1\" \nng-class=\"{\n                      invalid: orderForm[\'quantity__\' + $index].$invalid && orderForm[\'quantity__\' + $index].$touched\n                    }\">\n<label class=\"fc-input__label\">{{ \'TASKS.DIALOG.TABS.SERVICES.QUANTITY\' | translate }}</label><fc-error \nng-show=\"orderForm[\'quantity__\' + $index].$touched\" input-errors=\"orderForm[\'quantity__\' + $index].$error\" \nerrors-to-watch=\"[\n                      {\n                        name: \'required\',\n                        translate: \'TASKS.DIALOG.TABS.SERVICES.REQUIRED\'\n                      },\n                      {\n                        name: \'maxlength\',\n                        translate: \'TASKS.DIALOG.TABS.SERVICES.MAX_LENGTH\',\n                        translateValues: { expectedLength: 4, receivedLength: orderForm[\'quantity__\' + $index].$viewValue.length }\n                      },\n                      {\n                        name: \'pattern\',\n                        translate: \'TASKS.DIALOG.TABS.SERVICES.INVALID_CHARACTER\'\n                      },\n                      {\n                        name: \'min\',\n                        translate: \'TASKS.DIALOG.TABS.SERVICES.MIN_NUMBER_ERROR\'\n                      }\n                    ]\" \ncustom-class=\"fc-input__input-error services-tab__content__table__content__items__row__quantity__content__word-break\">\n</fc-error></div></td><td class=\"services-tab__content__table__content__items__row__value\"><div \nclass=\"services-tab__content__table__content__items__row__value__content\"><input type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input no-padding-right\" name=\"value__{{ $index }}\" id=\"value__{{ $index }}\" \nng-change=\"self.setService(service)\" ng-model=\"service.value\" ng-required=\"true\" \nonkeydown=\"return event.keyCode !== 69\" min=\"0.00\" ui-money-mask \nng-class=\"{\n                      invalid: orderForm[\'value__\' + $index].$invalid && orderForm[\'value__\' + $index].$touched\n                    }\">\n<label class=\"fc-input__label\">{{ \'TASKS.DIALOG.TABS.SERVICES.VALUE\' | translate }}</label><fc-error \nng-show=\"orderForm[\'value__\' + $index].$touched\" input-errors=\"orderForm[\'value__\' + $index].$error\" \nerrors-to-watch=\"[\n                      {\n                        name: \'required\',\n                        translate: \'TASKS.DIALOG.TABS.SERVICES.VALUE_REQUIRED\'\n                      },\n                      {\n                        name: \'pattern\',\n                        translate: \'TASKS.DIALOG.TABS.SERVICES.INVALID_CHARACTER\'\n                      },\n                      {\n                        name: \'min\',\n                        translate: \'TASKS.DIALOG.TABS.SERVICES.VALUE_MIN_NUMBER_ERROR\'\n                      }\n                    ]\" \ncustom-class=\"fc-input__input-error services-tab__content__table__content__items__row__value__content__word-break\">\n</fc-error></div></td><td>{{ service.totalValue | currencyFormat }}</td><td \nclass=\"services-tab__content__table__content__items__row__remove\"><button \nng-click=\"self.openConfirmDeleteServiceDialog(service)\"><img src=\"assets/icons/icon-trash-can.svg\"></button></td></tr>\n</tbody></table><div class=\"services-tab__content__table__navigation\"><div \nclass=\"services-tab__content__table__navigation__text\" aria-live=\"polite\"><span \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((self.currentPage - 1) * self.limit) + 1 }} <span translate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.TO\">to</span> \n<span ng-if=\"self.totalCount < self.limit\">{{ self.totalCount }}</span> <span ng-if=\"self.totalCount >= self.limit\">\n{{ self.getLastServiceCount() }}</span> <span translate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.OF\">of</span>\n {{ self.totalCount }} <span translate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.ITEMS\">items.</span></div><button \nclass=\"services-tab__content__table__navigation__button-previous\" ng-click=\"self.navigateToPage(false)\" \nng-disabled=\"self.currentPage === 1\"><span translate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.PREVIOUS\">Previous</span>\n</button> <button class=\"services-tab__content__table__navigation__button-next\" ng-click=\"self.navigateToPage(true)\" \nng-disabled=\"self.currentShowedServices >= self.totalCount\"><span \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.NAVIGATION.NEXT\">Next</span></button></div></div></span><div \nclass=\"services-tab__content__loading\" layout=\"column\" layout-align=\"center center\" ng-if=\"self.loadingList === true\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \ntranslate=\"TASKS.DIALOG.TABS.SERVICES.LOADING\">Loading services ...</div></div><span \nclass=\"services-tab__content__not-found\" ng-if=\"!self.services.length && self.loadingList === false\"><img \nsrc=\"assets/icons/not-found.svg\"> <span>{{ \'TASKS.DIALOG.TABS.SERVICES.NO_LINKED_SERVICES_FOUND\' | translate }}</span>\n</span></md-dialog-content>");
$templateCache.put("app/main/tasks/dialogs/tabs/storages-movements/storages-movements-tab.html","<div class=\"storages-movements-tab\" \nng-class=\"{ \'tab-min-height\': self.storagesMovements.length < 4, \'tab-medium-height\': self.storagesMovements.length === 4 }\">\n<div class=\"fc-warning-container fc-warning-container--inside-tab\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span>{{ \'TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.INFO\' | translate }}\n</span></div><md-dialog-content ms-scroll class=\"storages-movements-tab__content\" id=\"storages-movements-tab-content\">\n<div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"fc-input search-bar storages-movements-tab__content__search-bar\" flex=\"100\"><input type=\"text\" placeholder=\" \" \nautocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" ng-model=\"self.productOrStorageNameContains\" \nng-change=\"self.searchStoragesMovements()\" ng-model-options=\"{ debounce: 500 }\" flex=\"100\"><label \nclass=\"fc-input__label\">{{ \'TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.SEARCH_PRODUCT_OR_STORAGE\' | translate }}</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></div></div><span><h4 class=\"storages-movements-tab__content__title\">\n{{ \'TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.REMOVAL_MOVEMENT\' | translate: { quantity: self.totalCount } }}</h4></span>\n<span ng-if=\"self.storagesMovements.length && self.loadingList === false\"><div \nclass=\"storages-movements-tab__content__table\"><table class=\"storages-movements-tab__content__table__content\"><thead \nclass=\"storages-movements-tab__content__table__content__header\"><tr \nclass=\"storages-movements-tab__content__table__content__header__row\"><th>\n{{ \'TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.TABLE.DATE_TIME\' | translate }}</th><th>\n{{ \'TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.TABLE.TYPE\' | translate }}</th><th>\n{{ \'TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.TABLE.PRODUCT\' | translate }}</th><th>\n{{ \'TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.TABLE.QUANTITY\' | translate }}</th><th>\n{{ \'TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.TABLE.STORAGE\' | translate }}</th><th></th></tr></thead><tbody \nclass=\"storages-movements-tab__content__table__content__items\"><tr \nclass=\"storages-movements-tab__content__table__content__items__row\" \nng-repeat=\"storagesMovement in self.storagesMovements\"><td><span>\n{{ storagesMovement.createdAt | amDateFormat: self.dateFormat }}</span></td><td>\n{{ \'TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.TABLE.\' + storagesMovement.type | uppercase | translate }}</td><td>\n{{ storagesMovement.product.name }}</td><td>{{ storagesMovement.quantity }}</td><td>{{ storagesMovement.storage.name }}\n</td><td><md-icon md-menu-origin md-font-icon=\"icon-eye\" \nng-click=\"self.openEditStorageMovementDialog(storagesMovement)\"><md-tooltip md-direction=\"bottom  \"><span \ntranslate=\"TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.TABLE.SEE_MOVEMENTS\">Unarchive form</span></md-tooltip></md-icon></td>\n</tr></tbody></table><div class=\"storages-movements-tab__content__table__navigation\"><div \nclass=\"storages-movements-tab__content__table__navigation__text\" aria-live=\"polite\"><span \ntranslate=\"TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.NAVIGATION.SHOWING_FROM\">Showing from</span>\n {{ ((self.currentPage - 1) * self.take) + 1 }} <span translate=\"TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.NAVIGATION.TO\">to\n</span> <span ng-if=\"self.totalCount < self.take\">{{ self.totalCount }}</span> <span \nng-if=\"self.totalCount >= self.take\">{{ self.getLastStoragesMovementsCount() }}</span> <span \ntranslate=\"TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.NAVIGATION.OF\">of</span> {{ self.totalCount }} <span \ntranslate=\"TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.NAVIGATION.ITEMS\">items.</span></div><button \nclass=\"storages-movements-tab__content__table__navigation__button-previous\" ng-click=\"self.navigateToPage(false)\" \nng-disabled=\"self.currentPage === 1\"><span translate=\"TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.NAVIGATION.PREVIOUS\">\nPrevious</span></button> <button class=\"storages-movements-tab__content__table__navigation__button-next\" \nng-click=\"self.navigateToPage(true)\" ng-disabled=\"self.currentShowedStoragesMovements >= self.totalCount\"><span \ntranslate=\"TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.NAVIGATION.NEXT\">Next</span></button></div></div></span><div \nclass=\"storages-movements-tab__content__loading\" layout=\"column\" layout-align=\"center center\" \nng-if=\"self.loadingList === true\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular><div translate=\"TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.LOADING\">Loading movements ...</div></div>\n<span class=\"storages-movements-tab__content__not-found\" \nng-if=\"!self.storagesMovements.length && self.loadingList === false\"><img src=\"assets/icons/not-found.svg\"> <span>\n{{ \'TASKS.DIALOG.TABS.STORAGES_MOVEMENTS.NO_LINKED_MOVEMENTS_FOUND\' | translate }}</span></span></md-dialog-content>\n</div>");
$templateCache.put("app/main/vehicles/dialogs/tabs/forms/vehicle-forms-tab.html","<ng-container><div class=\"vehicle-form-tab\"><div class=\"fc-warning-container\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span>{{(\'VEHICLES.FORMS.WARNING\' | translate)}}</span></div><span \nclass=\"vehicle-form-tab__pickup-title\">{{(\'VEHICLES.FORMS.PICKUP-TITLE\' | translate)}}</span><div \nclass=\"vehicle-form-tab__pickup-container\"><fc-select label=\"{{(\'VEHICLES.FORMS.CHOOSE_FORM\' | translate)}}\" \noptions=\"vm.formsOptions\" ng-model=\"vm.currentSelectedPickupForm\" track-by=\"name\" input-name=\"vehiclePickupForm\" \ninput-control=\"vm.vehiclesForm.vehiclePickupForm\" class=\"search-form-bar\" with-search=\"true\" \nng-model-options=\"{ debounce: 500 }\" search-function=\"vm.getAllAvailableForms(searchTerm)\" \nsearch-phrase=\"{{ \'VEHICLES.FORMS.SEARCH_PHRASE\' | translate}}\" ng-change=\"vm.changePickupVehicleForm(value)\" \nflex=\"100\"></fc-select><div><md-button class=\"vehicle-form-tab__pickup-container__clear-button\" \nng-click=\"vm.clearSelectedPickupForm()\" ng-if=\"vm.currentSelectedPickupForm.id\"></md-button></div><md-switch \nng-if=\"vm.pickupSwitch\" ng-model=\"vm.pickupSwitch\" ng-change=\"vm.changePickupVehicleForm(false)\"><span>\n{{(\'VEHICLES.FORMS.REQUIRED_FORM\' | translate)}}</span></md-switch><md-switch ng-if=\"!vm.pickupSwitch\" \nng-model=\"vm.pickupSwitch\" ng-change=\"vm.changePickupVehicleForm(true)\"><span>\n{{(\'VEHICLES.FORMS.OPTIONAL_FORM\' | translate)}}</span></md-switch></div><span class=\"vehicle-form-tab__return-title\">\n{{(\'VEHICLES.FORMS.RETURN-TITLE\' | translate)}}</span><div class=\"vehicle-form-tab__return-container\"><fc-select \nlabel=\"{{(\'VEHICLES.FORMS.CHOOSE_FORM\' | translate)}}\" options=\"vm.formsOptions\" \nng-model=\"vm.currentSelectedReturnForm\" track-by=\"name\" input-name=\"vehicleReturnForm\" \ninput-control=\"vm.vehiclesForm.vehicleReturnForm\" class=\"search-form-bar\" with-search=\"true\" \nng-model-options=\"{ debounce: 500 }\" search-function=\"vm.getAllAvailableForms(searchTerm)\" \nsearch-phrase=\"{{ \'VEHICLES.FORMS.SEARCH_PHRASE\' | translate}}\" ng-change=\"vm.changeReturnVehicleForm(value)\" \nflex=\"100\"></fc-select><div><md-button class=\"vehicle-form-tab__pickup-container__clear-button\" \nng-click=\"vm.clearSelectedReturnForm()\" ng-if=\"vm.currentSelectedReturnForm.id\"></md-button></div><md-switch \nng-if=\"vm.returnSwitch\" ng-model=\"vm.returnSwitch\" ng-change=\"vm.changeReturnVehicleForm(false)\"><span>\n{{(\'VEHICLES.FORMS.REQUIRED_FORM\' | translate)}}</span></md-switch><md-switch ng-if=\"!vm.returnSwitch\" \nng-model=\"vm.returnSwitch\" ng-change=\"vm.changeReturnVehicleForm(true)\"><span>\n{{(\'VEHICLES.FORMS.OPTIONAL_FORM\' | translate)}}</span></md-switch></div></div></ng-container>");
$templateCache.put("app/main/vehicles/dialogs/tabs/general/general-tab.html","<ng-container class=\"vehicle-dialog__general-tab\"><div class=\"fc-warning-container\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span>{{(\'VEHICLES.DIALOG.WARNING\' | translate)}}</span></div><form \nname=\"vm.vehiclesForm\" novalidate><main class=\"vehicle-dialog__general-tab__main-container\"><div \nng-show=\"vm.vehicle.id && vm.vehicle.status\" layout=\"row\" layout-align=\"start center\" \nclass=\"vehicle-dialog__general-tab__main-container__vehicle-status\"><span \nclass=\"vehicle-dialog__general-tab__main-container__vehicle-status__bullet\" ng-class=\"vm.vehicle.status\"></span> <span>\n{{(\'VEHICLES.MODEL.STATUS_OPTIONS.\' + vm.vehicle.status.toUpperCase()) | translate}}</span></div><h2 \nclass=\"section-subtitle {{(!vm.vehicle.id || !vm.vehicle.status) ? \'mt-25\' : \'\'}}\">\n{{(\'VEHICLES.DIALOG.VEHICLE_CHARACTERISTICS\' | translate)}}</h2><div class=\"image-container\"><div \nclass=\"vehicle-dialog__general-tab__main-container__attachment-container__image\"><fc-image-input data-cy=\"image-input\" \nheight=\"120px\" width=\"120px\" id=\"image-input\" name=\"image\" input-control=\"vm.vehiclesForm.image\" \nng-model=\"vm.vehicle.imageUrl\" image-file=\"vm.vehicleImage\"></fc-image-input></div><div class=\"insert-picture\">\n<md-button data-cy=\"insert-picture-button\" class=\"insert-picture-button\" \nng-disabled=\"vm.vehicleImage || vm.vehicle.imageUrl\" ng-click=\"vm.selectImage()\" \ntranslate=\"VEHICLES.DIALOG.SELECT_IMAGES\">Selecionar imagens</md-button><p \nclass=\"customer-dialog__general-tab__avatar-description ml-20\">{{(\'VEHICLES.DIALOG.PHOTO_RULES\' | translate)}}</p>\n</div></div><div class=\"sidebar-dialog__input-group\" layout=\"row\" layout-xs=\"column\" flex=\"100\"><div flex=\"100\" \nclass=\"fc-input\"><input data-cy=\"vehicle-name-input\" type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"name\" ng-model=\"vm.vehicle.name\" ng-disabled=\"$root.loadingProgress\" ng-maxlength=\"80\" \nng-class=\"{\n                disabled: $root.loadingProgress,\n                invalid: vm.vehiclesForm.name.$touched && vm.vehiclesForm.name.$invalid\n              }\" \nng-required=\"true\" ng-change=\"vm.validateVehicleName()\"><label class=\"fc-input__label\">\n{{(\'VEHICLES.MODEL.NAME\' | translate)}}</label><fc-error ng-show=\"vm.vehiclesForm.name.$touched\" \ninput-errors=\"vm.vehiclesForm.name.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n                },\n                {\n                  name: \'duplicate\',\n                  translate: \'VEHICLES.MODEL.ERRORS.DUPLICATE_NAME\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div flex=\"100\" class=\"fc-input\"><md-button \ndata-cy=\"qrcode-button\" class=\"fc-input__input qrcode-container\" id=\"qrCode\" name=\"qrCode\" \nng-model=\"vm.vehicle.qrCode\" ng-maxlength=\"100\" ng-click=\"!vm.vehicle.qrCode ? vm.generateQRCode() : vm.viewQRCode()\">\n<div class=\"\"><md-button data-cy=\"generate-qrcode-button\" ng-show=\"!vm.vehicle.qrCode\" \nclass=\"md-icon-button md-accent qrcode__button-center\" aria-label=\"Generate QR code\" \ntranslate-attr-aria-label=\"VEHICLES.MODEL.QR_CODE.GENERATE\" data-cy=\"vehicle-qr-code-button\"><md-icon \nmd-font-icon=\"icon-qrcode\" class=\"fs-18\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"VEHICLES.MODEL.QR_CODE.GENERATE\">Generate QR code</span></md-tooltip></md-button><md-button \ndata-cy=\"show-qrcode-button\" ng-show=\"vm.vehicle.qrCode\" class=\"md-icon-button md-accent qrcode__button-center\" \naria-label=\"Show QR code\" translate-attr-aria-label=\"VEHICLES.MODEL.QR_CODE.DOWNLOAD_LINK_MESSAGE\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"fs-18\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"VEHICLES.MODEL.QR_CODE.DOWNLOAD_LINK_MESSAGE\">Show QR code</span></md-tooltip></md-button></div><span \ntranslate=\"{{ !vm.vehicle.qrCode ? (vm.isQRCodeRequired || vm.account.configuration.vehiclesQRCodeRequired ? \'VEHICLES.MODEL.QR_CODE.GENERATE_QRCODE_MANDATORY\' : \'VEHICLES.MODEL.QR_CODE.GENERATE_QRCODE\') : \'VEHICLES.MODEL.QR_CODE.VIEW_QRCODE\' }}\">\n</span> <a data-cy=\"download-qrcode-button\" id=\"vehicleDownloadLink\" class=\"download-link\" \nng-click=\"vm.downloadQRCode();\" download=\"veiculo-{{ vm.vehicle.qrCode }}.png\">Download</a><qrcode \nng-if=\"!vm.hasPublicQRCodeFeatureFlag\" id=\"vehicle-qrcode-download\" class=\"download-link\" version=\"6\" \nerror-correction-level=\"M\" size=\"250\" data=\"{{ vm.vehicle.qrCode }}\"></qrcode><qrcode \nng-if=\"vm.hasPublicQRCodeFeatureFlag\" id=\"vehicle-qrcode-download\" class=\"download-link\" version=\"6\" \nerror-correction-level=\"M\" size=\"250\" \ndata=\"{{ \'https://app.fieldcontrol.com.br/qrcode-publico/#/\' + vm.vehicle.qrCode }}\"></qrcode></md-button></div></div>\n<div class=\"vehicle-dialog__general-tab__input-groups\"><div flex=\"40\" class=\"fc-input\"><input \ndata-cy=\"vehicle-register-input\" type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" \nname=\"register\" ng-model=\"vm.vehicle.register\" ng-disabled=\"$root.loadingProgress\" ng-maxlength=\"140\" \nng-class=\"{\n              disabled: $root.loadingProgress,\n              invalid: vm.vehiclesForm.register.$touched && vm.vehiclesForm.register.$invalid\n            }\">\n<label class=\"fc-input__label\">{{(\'VEHICLES.MODEL.REGISTER\' | translate)}}</label></div><div flex=\"40\" \nclass=\"fc-input\"><input data-cy=\"vehicle-license-plate-input\" type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"licensePlate\" license-plate-mask ng-model=\"vm.vehicle.licensePlate\" \nng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n              disabled: $root.loadingProgress,\n              invalid: vm.vehiclesForm.licensePlate.$touched && vm.vehiclesForm.licensePlate.$invalid\n            }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'VEHICLES.MODEL.LICENSE_PLATE\' | translate)}}</label><fc-error \nng-show=\"vm.vehiclesForm.licensePlate.$touched\" input-errors=\"vm.vehiclesForm.licensePlate.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n              },\n              {\n                name: \'isValidLicensePlate\',\n                translate: \'VEHICLES.MODEL.ERRORS.INVALID_LICENSE_PLATE\'\n              },\n              {\n                name: \'isValidLength\',\n                translate: \'VEHICLES.MODEL.ERRORS.INVALID_LICENSE_PLATE\'\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div flex=\"40\" class=\"fc-input\"><fc-select \nlabel=\"{{(\'VEHICLES.MODEL.BRAND\' | translate)}}\" ng-model=\"vm.vehicle.brand\" ng-change=\"vm.loadVehicleModels(value)\" \nsearch-function=\"vm.searchBrandByName(searchTerm)\" options=\"vm.vehiclesBrandsOptions\" track-by=\"name\" \nwith-search=\"true\" is-required=\"true\" has-arrow=\"true\" data-cy=\"vehicle-brand-select\" input-name=\"brand\" \ninput-control=\"vm.vehiclesForm.brand\" is-disabled=\"$root.loadingProgress\" \nsearch-phrase=\"{{(\'VEHICLES.MODEL.BRAND\' | translate)}}\"></fc-select><fc-error class=\"brand-error\" \ninput-errors=\"vm.vehiclesForm.brand.$error\" ng-show=\"vm.vehiclesForm.brand.$touched || vm.vehiclesForm.brand.length\" \nerrors-to-watch=\"[\n            {\n              name: \'required\',\n              translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n            }\n          ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div class=\"vehicle-dialog__general-tab__input-groups\"><div\n flex=\"40\" class=\"fc-input\"><fc-select data-cy=\"vehicle-model-select\" label=\"{{(\'VEHICLES.MODEL.MODEL\' | translate)}}\" \nng-model=\"vm.vehicle.model\" search-function=\"vm.searchModelByName(searchTerm)\" options=\"vm.vehiclesModelsOptions\" \ntrack-by=\"name\" with-search=\"true\" is-required=\"true\" has-arrow=\"true\" input-name=\"model\" \ninput-control=\"vm.vehiclesForm.model\" class=\"select-disabled\" \nis-disabled=\"$root.loadingProgress || !vm.vehiclesModelsOptions.length\" \nsearch-phrase=\"{{(\'VEHICLES.MODEL.MODEL\' | translate)}}\"></fc-select><fc-error class=\"model-error\" \ninput-errors=\"vm.vehiclesForm.model.$error\" ng-show=\"vm.vehiclesForm.model.$touched || vm.vehiclesForm.model.length\" \nerrors-to-watch=\"[\n            {\n              name: \'required\',\n              translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n            }\n          ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div flex=\"40\" class=\"fc-input\"><fc-select \ndata-cy=\"vehicle-year-select\" label=\"{{ \'VEHICLES.MODEL.YEAR\' | translate }}\" ng-model=\"vm.vehicle.year\" \noptions=\"vm.vehiclesYearsOptions\" with-search=\"true\" is-required=\"true\" has-arrow=\"true\" input-name=\"year\" \ninput-control=\"vm.vehiclesForm.year\" is-disabled=\"$root.loadingProgress\" \nsearch-phrase=\"{{(\'VEHICLES.MODEL.YEAR\' | translate)}}\"></fc-select><fc-error class=\"year-error\" \ninput-errors=\"vm.vehiclesForm.year.$error\" ng-show=\"vm.vehiclesForm.year.$touched || vm.vehiclesForm.year.length\" \nerrors-to-watch=\"[\n            {\n              name: \'required\',\n              translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n            }\n          ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div flex=\"40\" class=\"fc-input\"><fc-select \ndata-cy=\"vehicle-color-select\" label=\"{{ \'VEHICLES.MODEL.COLOR\' | translate }}\" ng-model=\"vm.vehicle.color\" \noptions=\"vm.vehiclesColorsOptions\" with-search=\"true\" is-required=\"true\" has-arrow=\"true\" input-name=\"color\" \ninput-control=\"vm.vehiclesForm.color\" is-disabled=\"$root.loadingProgress\" \nsearch-phrase=\"{{(\'VEHICLES.MODEL.COLOR\' | translate)}}\"></fc-select><fc-error class=\"color-error\" \ninput-errors=\"vm.vehiclesForm.color.$error\" ng-show=\"vm.vehiclesForm.color.$touched || vm.vehiclesForm.color.length\" \nerrors-to-watch=\"[\n            {\n              name: \'required\',\n              translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n            }\n          ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div class=\"vehicle-dialog__general-tab__input-groups\"><div\n flex=\"40\"><fc-select data-cy=\"vehicle-type-select\" label=\"{{ \'VEHICLES.MODEL.TYPE\' | translate }}\" \nng-model=\"vm.vehicle.type\" options=\"vm.vehiclesTypeOptions\" is-required=\"true\" has-arrow=\"true\" input-name=\"type\" \nis-disabled=\"$root.loadingProgress\" input-control=\"vm.vehiclesForm.type\" with-search=\"true\" \nsearch-phrase=\"{{(\'VEHICLES.MODEL.TYPE\' | translate)}}\">\nerrors-to-watch=\"[ { name: \'required\', translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\' } ]\"></fc-select></div><div \nflex=\"40\"><fc-select data-cy=\"vehicle-origin-select\" label=\"{{ \'VEHICLES.MODEL.ORIGIN\' | translate }}\" \nng-model=\"vm.vehicle.origin\" options=\"vm.vehiclesOriginsOptions\" is-required=\"true\" has-arrow=\"true\" \ninput-name=\"origin\" with-search=\"true\" is-disabled=\"$root.loadingProgress\" input-control=\"vm.vehiclesForm.origin\" \nsearch-phrase=\"{{(\'VEHICLES.MODEL.ORIGIN\' | translate)}}\">\nerrors-to-watch=\"[ { name: \'required\', translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\' } ]\"></fc-select></div><div \nflex=\"40\" class=\"fc-input\"><input data-cy=\"vehicle-km-input\" type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"originalTravelingDistance\" ui-number-mask=\"0\" \nng-model=\"vm.vehicle.originalTravelingDistance\" ng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n              disabled: $root.loadingProgress,\n              invalid: vm.vehiclesForm.originalTravelingDistance.$touched && vm.vehiclesForm.originalTravelingDistance.$invalid\n            }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'VEHICLES.MODEL.INITIAL_KILOMETERS\' | translate)}}</label>\n<fc-error ng-show=\"vm.vehiclesForm.originalTravelingDistance.$touched\" \ninput-errors=\"vm.vehiclesForm.originalTravelingDistance.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"100\"><fc-smart-rewrite \nreference-id=\"vm.vehicle.id || vm.sessionId\" reference-type=\"vehicle-description\" disabled=\"$root.loadingProgress\">\n<fc-textarea data-cy=\"vehicle-description-textarea\" label=\"{{ \'VEHICLES.MODEL.OBSERVATIONS\' | translate }}\" \nng-model=\"vm.vehicle.description\" input-name=\"description\" input-control=\"vm.vehiclesForm.description\" \nmax-length=\"100\" is-disabled=\"$root.loadingProgress\" \nerrors-to-watch=\"[\n              {\n                name: \'maxlength\',\n                translate: \'VEHICLES.MODEL.ERRORS.DESCRIPTION_MAXLENGTH\',\n                translateValues: { expectedLength: 100, receivedLength: vm.vehiclesForm.description.$viewValue.length }\n              },\n            ]\">\n</fc-smart-rewrite></div></main></form></ng-container>");
$templateCache.put("app/main/vehicles-usage/dialogs/tabs/forms/forms-tab.html","<ng-container class=\"vehicles-usage-dialog__forms-tab\"><div class=\"fc-warning-container\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span>{{(\'VEHICLES_USAGE.DIALOG.FORMS.WARNING\' | translate)}}</span>\n</div><main class=\"vehicles-usage-dialog__forms-tab__main-container\"><section \nclass=\"vehicles-usage-dialog__forms-tab__main-container__form\"><h2 class=\"section-subtitle\">\n{{(\'VEHICLES_USAGE.DIALOG.VEHICLE_PICKUP\' | translate)}}</h2><div class=\"answered__form\"><p \nclass=\"answered__form__no-answers\" ng-if=\"!vm.vehicleUsage.pickupAnsweredForm\">\n{{(\'VEHICLES_USAGE.DIALOG.FORMS.WITHOUT_FORM\' | translate)}}</p><div ng-if=\"vm.vehicleUsage.pickupAnsweredForm\" \nclass=\"answered__form__info\"><div class=\"icon\"><md-icon md-menu-origin md-font-icon=\"icon-clipboard-text\"></md-icon>\n</div><div class=\"answered__form__name\"><p class=\"fs-14 fw-400\">{{vm.vehicleUsage.pickupAnsweredForm.name}}</p><div \nclass=\"answered__form__name__description\"><span class=\"fs-13 fw-400\" \ntranslate=\"VEHICLES_USAGE.DIALOG.FORMS.QUESTIONS_COUNT\" \ntranslate-values=\"{ COUNT: vm.vehicleUsage.pickupAnsweredForm.questionsCount }\"></span> <span class=\"fs-13 fw-400\" \ntranslate=\"VEHICLES_USAGE.DIALOG.FORMS.ANSWERED_BY_AT\" \ntranslate-values=\"{\n                  NAME: vm.vehicleUsage.pickupAnsweredForm.createdBy,\n                  DATE: vm.vehicleUsage.pickupAnsweredForm.createdAt\n                }\">\n</span></div></div><md-button class=\"answered__form__button\"><md-icon md-menu-origin md-font-icon=\"icon-eye\" \nng-click=\"vm.editVehicleUsageFormAnswers(vm.vehicleUsage.pickupAnsweredForm, \'pickupForm\');\"></md-icon></md-button>\n</div></div></section><section class=\"vehicles-usage-dialog__forms-tab__main-container__form\"><h2 \nclass=\"section-subtitle\">{{(\'VEHICLES_USAGE.DIALOG.VEHICLE_RETURN\' | translate)}}</h2><div class=\"answered__form\"><p \nclass=\"answered__form__no-answers\" ng-if=\"!vm.vehicleUsage.returnAnsweredForm\">\n{{(\'VEHICLES_USAGE.DIALOG.FORMS.WITHOUT_FORM\' | translate)}}</p><div ng-if=\"vm.vehicleUsage.returnAnsweredForm\" \nclass=\"answered__form__info\"><div class=\"icon\"><md-icon md-menu-origin md-font-icon=\"icon-clipboard-text\"></md-icon>\n</div><div class=\"answered__form__name\"><p class=\"fs-14 fw-400\">{{vm.vehicleUsage.returnAnsweredForm.name}}</p><div \nclass=\"answered__form__name__description\"><span class=\"fs-13 fw-400\" \ntranslate=\"VEHICLES_USAGE.DIALOG.FORMS.QUESTIONS_COUNT\" \ntranslate-values=\"{ COUNT: vm.vehicleUsage.returnAnsweredForm.questionsCount }\"></span> <span class=\"fs-13 fw-400\" \ntranslate=\"VEHICLES_USAGE.DIALOG.FORMS.ANSWERED_BY_AT\" \ntranslate-values=\"{\n                  NAME: vm.vehicleUsage.returnAnsweredForm.createdBy,\n                  DATE: vm.vehicleUsage.returnAnsweredForm.createdAt\n                }\">\n</span></div></div><md-button class=\"answered__form__button\" ng-if=\"vm.vehicleUsage.returnedAt\"><md-icon \nmd-menu-origin md-font-icon=\"icon-eye\" \nng-click=\"vm.editVehicleUsageFormAnswers(vm.vehicleUsage.returnAnsweredForm, \'returnForm\');\"></md-icon></md-button>\n</div></div></section></main></ng-container>");
$templateCache.put("app/main/vehicles-usage/dialogs/tabs/general/general-tab.html","<ng-container class=\"vehicles-usage-dialog__general-tab\"><div class=\"fc-warning-container\"><md-icon \nclass=\"warning-icon\" md-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span>\n{{(\'VEHICLES_USAGE.DIALOG.WARNING\' | translate)}}</span></div><form name=\"vm.vehiclesUsageForm\" novalidate><main \nclass=\"vehicles-usage-dialog__general-tab__main-container\"><h2 class=\"section-subtitle\">\n{{(\'VEHICLES_USAGE.DIALOG.VEHICLE_PICKUP\' | translate)}}</h2><section \nclass=\"vehicles-usage-dialog__general-tab__input-groups\"><div style=\"width: 44%\"><fc-select \nlabel=\"{{ \'VEHICLES_USAGE.MODEL.PICKED_UP_BY\' | translate }}\" ng-model=\"vm.pickedBy\" options=\"vm.employeesUsers\" \nis-required=\"true\" track-by=\"name\" input-name=\"pickedUpBy\" ng-change=\"vm.onChangePickedBy(value)\" \nis-disabled=\"$root.loadingProgress\" prefix-src=\"{{ vm.avatarUrl }}\" input-control=\"vm.vehiclesUsageForm.pickedUpBy\">\n</fc-select></div><div style=\"width: 20%\" class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"pickupTime\" ng-model=\"vm.pickupTime\" ng-change=\"vm.checkTimes()\" ui-time-mask=\"short\" \nng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n              disabled: $root.loadingProgress,\n              invalid: vm.vehiclesUsageForm.pickupTime.$touched && vm.vehiclesUsageForm.pickupTime.$invalid\n            }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'VEHICLES_USAGE.MODEL.PICK_UP_TIME\' | translate)}}</label>\n<fc-error ng-show=\"vm.vehiclesUsageForm.pickupTime.$touched\" input-errors=\"vm.vehiclesUsageForm.pickupTime.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'VEHICLES_USAGE.MODEL.ERRORS.REQUIRED_FIELD\',\n                translateValues: { fieldName: (\'VEHICLES_USAGE.MODEL.PICK_UP_TIME\' | translate) }\n              },\n              {\n                name: \'invalidPickupTime\',\n                translate: \'VEHICLES_USAGE.MODEL.ERRORS.INVALID_PICK_UP_TIME\',\n              },\n              {\n                name: \'pickupGreaterThan12\',\n                translate: \'VEHICLES_USAGE.MODEL.ERRORS.GREATER_THAN_12\',\n              },\n              {\n                name: \'pickupMinorThan00\',\n                translate: \'VEHICLES_USAGE.MODEL.ERRORS.MINOR_THAN_00\',\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div style=\"width: 20%\" \nclass=\"vehicles-usage-dialog__general-tab__input-groups\" ng-if=\"vm.timeFormatIsActive\"><fc-select label=\"Time Format\" \nng-model=\"vm.pickupTimeFormat\" options=\"vm.timeFormats\" is-required=\"true\" input-name=\"pickupTimeFormat\" \nng-change=\"vm.updatePickupTimeFormat(value, vm.vehiclesUsageForm.pickupTimeFormat); vm.checkTimes()\" \nis-disabled=\"$root.loadingProgress\"></fc-select></div><div style=\"width: 20%\" class=\"fc-datepicker\"><label \nclass=\"fc-datepicker__label\">{{(\'VEHICLES_USAGE.MODEL.PICK_UP_DATE\' | translate)}}</label><div class=\"date-container\">\n<md-datepicker class=\"p-0\" flex required name=\"pickupDate\" ng-model=\"vm.pickupDate\" md-max-date=\"vm.today\" \nng-change=\"vm.checkDates()\" ng-disabled=\"$root.loadingProgress\" md-hide-icons=\"calendar\" \nmd-placeholder=\"{{ \'VEHICLES_USAGE.MODEL.PICK_UP_DATE\' | translate }}\"></md-datepicker></div><fc-error \nng-show=\"vm.vehiclesUsageForm.pickupDate.$touched\" input-errors=\"vm.vehiclesUsageForm.pickupDate.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'VEHICLES_USAGE.MODEL.ERRORS.REQUIRED_FIELD\',\n                translateValues: { fieldName: (\'VEHICLES_USAGE.MODEL.PICK_UP_DATE\' | translate) }\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div style=\"width: 20%\" class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"pickupTravelingDistance\" \nng-change=\"vm.checkTravelingDistance()\" ng-model=\"vm.vehicleUsage.pickupTravelingDistance\" ui-number-mask=\"0\" \nng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n              disabled: $root.loadingProgress,\n              invalid: vm.vehiclesUsageForm.pickupTravelingDistance.$touched && vm.vehiclesUsageForm.pickupTravelingDistance.$invalid\n            }\" \nng-required=\"true\"><label style=\"font-size: 10px !important\" class=\"fc-input__label\">\n{{(\'VEHICLES_USAGE.MODEL.INITIAL_KILOMETERS\' | translate)}}</label><fc-error \nng-show=\"vm.vehiclesUsageForm.pickupTravelingDistance.$touched\" \ninput-errors=\"vm.vehiclesUsageForm.pickupTravelingDistance.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'VEHICLES_USAGE.MODEL.ERRORS.REQUIRED_FIELD\',\n                translateValues: { fieldName: (\'VEHICLES_USAGE.FIELD\' | translate) }\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></section><section flex=\"100\"><fc-textarea \nlabel=\"{{ \'VEHICLES_USAGE.MODEL.PICK_UP_DESCRIPTION\' | translate }}\" ng-model=\"vm.vehicleUsage.pickupDescription\" \ninput-name=\"pickupDescription\" input-control=\"vm.vehiclesUsageForm.pickupDescription\" max-length=\"100\" \nis-disabled=\"$root.loadingProgress\" \nerrors-to-watch=\"[\n          {\n            name: \'maxlength\',\n            translate: \'VEHICLES_USAGE.MODEL.ERRORS.DESCRIPTION_MAXLENGTH\',\n            translateValues: { expectedLength: 100, receivedLength: vm.vehiclesUsageForm.pickupDescription.$viewValue.length }\n          },\n        ]\">\n</section><h2 class=\"section-subtitle\">{{(\'VEHICLES_USAGE.DIALOG.VEHICLE_RETURN\' | translate)}}</h2><section \nclass=\"vehicles-usage-dialog__general-tab__input-groups\"><div flex=\"20\" class=\"fc-datepicker\"><label \nclass=\"fc-datepicker__label\">{{(\'VEHICLES_USAGE.MODEL.RETURN_DATE\' | translate)}}</label><div class=\"date-container\">\n<md-datepicker class=\"p-0\" flex required name=\"returnDate\" ng-model=\"vm.returnDate\" md-max-date=\"vm.today\" \nng-disabled=\"$root.loadingProgress\" md-hide-icons=\"calendar\" \nmd-placeholder=\"{{ \'VEHICLES_USAGE.MODEL.RETURN_DATE\' | translate }}\" md-min-date=\"vm.pickupDate\" \nng-change=\"vm.checkReturnTime()\"></md-datepicker></div></div><div flex=\"20\" class=\"fc-input\"><input \ndata-cy=\"return-time-input\" type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"returnTime\" \nui-time-mask=\"short\" ng-model=\"vm.returnTime\" ng-change=\"vm.checkTimes()\" \nng-disabled=\"$root.loadingProgress || !vm.returnDate\" \nng-class=\"{\n              disabled: $root.loadingProgress || !vm.returnDate,\n              invalid: vm.vehiclesUsageForm.returnTime.$touched && vm.vehiclesUsageForm.returnTime.$invalid\n            }\">\n<label class=\"fc-input__label\">{{(\'VEHICLES_USAGE.MODEL.RETURN_TIME\' | translate)}}</label><fc-error \nng-show=\"vm.vehiclesUsageForm.returnTime.$invalid\" input-errors=\"vm.vehiclesUsageForm.returnTime.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'invalidReturnTime\',\n                translate: \'VEHICLES_USAGE.MODEL.ERRORS.INVALID_RETURN_TIME\',\n              },\n              {\n                name: \'returnGreaterThan12\',\n                translate: \'VEHICLES_USAGE.MODEL.ERRORS.GREATER_THAN_12\',\n              },\n              {\n                name: \'returnMinorThan00\',\n                translate: \'VEHICLES_USAGE.MODEL.ERRORS.MINOR_THAN_00\',\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div flex=\"20\" \nclass=\"vehicles-usage-dialog__general-tab__input-groups\" ng-if=\"vm.timeFormatIsActive\"><fc-select label=\"Time Format\" \nng-model=\"vm.returnTimeFormat\" options=\"vm.timeFormats\" is-required=\"true\" input-name=\"returnTimeFormat\" \nng-change=\"vm.updateReturnTimeFormat(value, vm.vehiclesUsageForm.returnTimeFormat); vm.checkTimes()\" \nis-disabled=\"$root.loadingProgress\"></fc-select></div><div flex=\"20\" class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"returnedTravelingDistance\" \nng-change=\"vm.checkTravelingDistance()\" ng-model=\"vm.vehicleUsage.returnedTravelingDistance\" ui-number-mask=\"0\" \nng-disabled=\"$root.loadingProgress || !vm.returnTime\" \nng-class=\"{\n              disabled: $root.loadingProgress || !vm.returnTime,\n              invalid: vm.vehiclesUsageForm.returnedTravelingDistance.$invalid\n            }\">\n<label class=\"fc-input__label\">{{(\'VEHICLES_USAGE.MODEL.FINAL_KILOMETERS\' | translate)}}</label><fc-error \nng-show=\"vm.vehiclesUsageForm.returnedTravelingDistance.$invalid\" \ninput-errors=\"vm.vehiclesUsageForm.returnedTravelingDistance.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'invalidTravelingDistance\',\n                translate: \'VEHICLES_USAGE.MODEL.ERRORS.INVALID_RETURNED_DISTANCE\',\n              }]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div flex=\"20\" class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"travelingDistance\" ui-number-mask=\"0\" \nng-model=\"vm.vehicleUsage.travelingDistance\" ng-disabled=\"true\" \nng-class=\"{\n              disabled: true,\n              invalid: vm.vehiclesUsageForm.travelingDistance.$touched && vm.vehiclesUsageForm.travelingDistance.$invalid\n            }\">\n<label class=\"fc-input__label\">{{(\'VEHICLES_USAGE.MODEL.TRAVELED_KILOMETERS\' | translate)}}</label></div><div \nflex=\"20\" class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" \nname=\"duration\" ng-model=\"vm.vehicleUsage.duration\" ng-disabled=\"true\" \nng-class=\"{\n              disabled: true\n            }\"><label class=\"fc-input__label\">\n{{(\'VEHICLES_USAGE.MODEL.USAGE_TIME\' | translate)}}</label></div></section><section flex=\"100\"><fc-textarea \nlabel=\"{{ \'VEHICLES_USAGE.MODEL.RETURN_DESCRIPTION\' | translate }}\" ng-model=\"vm.vehicleUsage.returnedDescription\" \ninput-name=\"returnedDescription\" input-control=\"vm.vehiclesUsageForm.returnedDescription\" max-length=\"100\" \nis-disabled=\"$root.loadingProgress\" \nerrors-to-watch=\"[\n          {\n            name: \'maxlength\',\n            translate: \'VEHICLES_USAGE.MODEL.ERRORS.DESCRIPTION_MAXLENGTH\',\n            translateValues: { expectedLength: 100, receivedLength: vm.vehiclesUsageForm.returnedDescription.$viewValue.length }\n          },\n        ]\">\n</section><h2 class=\"section-subtitle\">{{(\'VEHICLES_USAGE.DIALOG.ODOMETER_RECORD\' | translate)}}</h2><section \nclass=\"vehicles-usage-dialog__general-tab__input-groups\"><div layout=\"column\" flex=\"50\"><h4 \nclass=\"vehicles-usage-dialog__general-tab__input-groups__title\">\n{{(\'VEHICLES_USAGE.DIALOG.INITIAL_KILOMETERS_PHOTO\' | translate)}}*</h4><fc-image-input height=\"150px\" \nwithout-remove=\"true\" name=\"pickupImageUrl\" ng-model=\"vm.vehicleUsage.pickupImageUrl\" image-file=\"vm.pickupImage\">\n</div><div layout=\"column\" flex=\"50\"><h4 class=\"vehicles-usage-dialog__general-tab__input-groups__title\">\n{{(\'VEHICLES_USAGE.DIALOG.FINAL_KILOMETERS_PHOTO\' | translate)}}*</h4><fc-image-input height=\"150px\" \nwithout-remove=\"true\" name=\"returnedImageUrl\" ng-model=\"vm.vehicleUsage.returnedImageUrl\" image-file=\"vm.returnImage\">\n</div></section></main></form></ng-container>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\" translate=\"CORE.MS_STEPPER.OPTIONAL\">Optional</div></div>\n</md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\"><span \ntranslate=\"CORE.MS_STEPPER.BACK\">Back</span></md-button><md-button class=\"md-accent md-raised\" \nng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" \nng-click=\"MsStepper.gotoNextStep()\"><span translate=\"CORE.MS_STEPPER.NEXT\">Next</span></md-button><md-button \ntype=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\"><span translate=\"CORE.MS_STEPPER.SUBMIT\">Submit</span></md-button></div>");
$templateCache.put("app/core/integrations/core/customers/dialogs/export/customers-export-dialog.html","<md-dialog class=\"integration-dialog\" aria-label=\"Integration\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools align-vertical align-vertical-middle\"><span class=\"fs-17\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.SENDING_CUSTOMER\" translate-value-app=\"{{ vm.appName }}\">\nSending customer to {{ vm.appName }} </span><span flex></span> <span flex></span><md-button \nclass=\"md-icon-button margin-top-0\" ng-click=\"vm.closeDialog();\" aria-label=\"Close Dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"fs-16\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.FIND_CUSTOMERS_DESCRIPTION\" translate-value-app=\"{{ vm.appName }}\">\nFrom the name, or document we identify the possible customers already registered in the {{ vm.appName }}</p><md-list \nflex><md-subheader class=\"md-no-sticky\" translate=\"CUSTOMERS.INTEGRATIONS.UPDATE_OR_CREATE_NEW_CUSTOMER\">\nChange an existing customer or create a new one:</md-subheader><br><md-list-item class=\"md-3-line\" \nng-click=\"vm.selectCustomer(null);\"><div class=\"md-list-item-text\" layout=\"column\"><h3 \ntranslate=\"CUSTOMERS.INTEGRATIONS.NEW_CUSTOMER\">New customer</h3><p \ntranslate=\"CUSTOMERS.INTEGRATIONS.CREATE_NEW_CUSTOMER\" translate-value-app=\"{{ vm.appName }}\">\nCreate a new customer on {{ vm.appName }}</p></div><md-icon ng-if=\"vm.selectedCustomer === null\" \nmd-font-icon=\"icon-check\"></md-icon></md-list-item><md-divider></md-divider><md-list-item class=\"md-3-line\" \nng-repeat=\"apiPossibleCustomer in vm.apiPossibleCustomers.customers\" \nng-click=\"vm.selectCustomer(apiPossibleCustomer);\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ apiPossibleCustomer.name }}</h3><p>{{ apiPossibleCustomer.documentNumber | cpfCnpjFilter }}</p><p>\n{{ apiPossibleCustomer.address.formattedAddress }}</p></div><md-icon \nng-if=\"vm.selectedCustomer === apiPossibleCustomer\" md-font-icon=\"icon-check\"></md-icon></md-list-item></md-list>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.goToConfirmPrompt($event);\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.selectedCustomerId === null\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.CONTINUE\" translate-attr-aria-label=\"CUSTOMERS.INTEGRATIONS.CONTINUE\">Continue\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/control-panel/dialogs/route-optimizer/templates/fc-modal-invalid-geo/fc-modal-invalid-geo.html","<div class=\"modal-invalid-geo\"><div class=\"modal-invalid-title\"><strong \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.MODAL.MODAL_TITLE\">Aviso</strong><md-button style=\"margin-right: -10px\" \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"TASKS.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"modal-invalid-content\"><p translate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.MODAL.MODAL_CONTENT\">\nOs identificadores listados abaixo correspondem a ordens de serviço com coordenadas inseridas de forma incorreta no cadastro de localização. Corrija-as manualmente antes de prosseguir com a roteirização.\n</p></div><div><div class=\"modal-invalid-identifiers\"><p ng-repeat=\"order in invalidGeolocationOrders\">{{ order }}</p>\n</div><div class=\"modal-invalid-identifiers-copy\" ng-click=\"copyInvalidOrders()\"><div \nclass=\"modal-invalid-identifiers-copy-text\"><span \ntranslate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.MODAL.MODAL_COPY_IDENTIFIERS\">Copiar códigos</span><md-icon \nmd-svg-src=\"assets/icons/content_copy.svg\"></md-icon></div></div></div><div class=\"modal-invalid-exit\"><button \nng-click=\"closeDialog()\" translate=\"CONTROL_PANEL.DIALOGS.ROUTERIZATION.MODAL.MODAL_CLOSE\">SAIR</button></div></div>");
$templateCache.put("app/main/control-panel/views/list/views/classic/classic-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" ng-disabled=\"!vm.tasks.length\" \naria-label=\"{{ vm.selectedTaskIds.length ? (\'CONTROL_PANEL.VIEWS.LIST.ACTIONS.DESELECT_ALL\' | translate) : (\'CONTROL_PANEL.VIEWS.LIST.ACTIONS.SELECT_ALL\' | translate) }}\" \nng-checked=\"vm.selectedTaskIds.length\" ng-click=\"vm.toggleSelectTasks()\"></md-checkbox><md-menu class=\"select-menu\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.FILTERS\' | translate }}\" ng-disabled=\"!vm.tasks.length\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectAllTasks()\" aria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.SELECT_ALL\' | translate }}\"><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.SELECT_ALL\">Select all</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectAllTasks()\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.DESELECT_ALL\' | translate }}\"><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.DESELECT_ALL\">Deselect all</span></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"action-buttons\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedTaskIds.length\" hide show-gt-xs><div class=\"divider-vertical\"></div><md-button \nclass=\"md-icon-button\" aria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.ARCHIVE\' | translate }}\" \nng-if=\"vm.showArchiveButton() && vm.editPermission\" ng-click=\"vm.archiveSelectedTasks();\"><md-icon \nmd-font-icon=\"icon-folder-download\"></md-icon><md-tooltip><span translate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.ARCHIVE\">\nArchive</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.ARCHIVE\' | translate }}\" \nng-if=\"vm.showArchiveButton() && !vm.editPermission\"><md-icon class=\"no-action-permission\" \nmd-font-icon=\"icon-folder-download\"></md-icon><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.NO_PERMISSION_WARN\">Archive</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.UNARCHIVE\' | translate }}\" \nng-if=\"vm.showUnarchiveButton() && vm.editPermission\" ng-click=\"vm.unarchiveSelectedTasks();\"><md-icon \nmd-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip><span translate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.UNARCHIVE\">\nUnarchive</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.UNARCHIVE\' | translate }}\" \nng-if=\"vm.showUnarchiveButton() && !vm.editPermission\"><md-icon class=\"no-action-permission\" \nmd-font-icon=\"icon-folder-upload\"></md-icon><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.NO_PERMISSION_WARN\">Unarchive</span>\n</md-tooltip></md-button><div class=\"divider-vertical\"></div><md-menu md-offset=\"0 30\" class=\"members\"><md-button \nclass=\"md-icon-button {{ !vm.editPermission && \'no-action-permission\'}}\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.CHANGE_EMPLOYEE\' | translate }}\" \nng-click=\"vm.openMenuWithEditPermission($mdOpenMenu, $event)\"><md-icon md-menu-origin md-font-icon=\"icon-worker\">\n</md-icon><md-tooltip><span translate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.CHANGE_EMPLOYEE\">Change employee</span>\n</md-tooltip></md-button><md-menu-content class=\"members-menu-content\" width=\"4\" ms-scroll><md-menu-item \nng-if=\"vm.employees.length\"><md-input-container class=\"no-errors-spacer\" md-no-float><input \nplaceholder=\"Search employees...\" type=\"text\" ng-model=\"vm.employeeSearchText\" autocomplete=\"off\" translate \ntranslate-attr-placeholder=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.SEARCH_EMPLOYEE\"></md-input-container></md-menu-item>\n<md-menu-item class=\"member\"><md-button \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.TOOGLE_EMPLOYEE\' | translate }}\" \nng-click=\"vm.setTaskEmployee({ id: null });\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"avatar\" style=\"background: #ccc\"><div style=\"margin-left: -3px\"><i\n style=\"color:white\" class=\"icon icon-account-remove s25\"></i></div></div><p class=\"member-name\" \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.NO_EMPLOYEE\">No employee</p></div><i class=\"icon-check s16\" \nng-if=\"vm.allSelectedTasksWithEmployee({ id: null });\"></i> <i class=\"icon-minus s16\" \nng-if=\"vm.someSelectedTasksWithEmployee({ id: null }) && !vm.allSelectedTasksWithEmployee({ id: null })\"></i></div>\n</md-button></md-menu-item><md-menu-item class=\"member\" \nng-repeat=\"employee in vm.employees | filter: vm.filterEmployee\"><md-button \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.TOOGLE_EMPLOYEE\' | translate }}\" \nng-click=\"vm.setTaskEmployee(employee);\"><div layout=\"row\" layout-align=\"space-between center\" flex><div layout=\"row\" \nlayout-align=\"start center\"><img class=\"avatar\" alt=\"{{ employee.name }}\" \nng-src=\"{{ vm.getEmployeeAvatarUrl(employee) }}\"><p class=\"member-name\">{{ employee.name }}</p></div><i \nclass=\"icon-check s16\" ng-if=\"vm.allSelectedTasksWithEmployee(employee);\"></i> <i class=\"icon-minus s16\" \nng-if=\"vm.someSelectedTasksWithEmployee(employee) && !vm.allSelectedTasksWithEmployee(employee)\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 30\" class=\"labels\"><md-button \nclass=\"md-icon-button {{ !vm.editPermission && \'no-action-permission\'}}\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.LABELS.TITLE\' | translate }}\" \nng-click=\"vm.openMenuWithEditPermission($mdOpenMenu, $event)\"><md-icon md-menu-origin md-font-icon=\"icon-label\">\n</md-icon><md-tooltip ng-if=\"(!vm.labels.length && vm.hasLabelsPermission) || vm.labels.length\"><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.LABELS.TITLE\">Labels</span></md-tooltip><md-tooltip \nng-if=\"!vm.labels.length && !vm.hasLabelsPermission\"><span translate=\"CONTROL_PANEL.VIEWS.LIST.LABELS.NO_LABEL\">\nNo labels registered, only administrators can register labels.</span></md-tooltip></md-button><md-menu-content \nclass=\"labels-menu-content\" width=\"4\" ms-scroll><md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height><md-tab>\n<md-tab-body><md-menu-item ng-if=\"vm.labels.length\"><md-input-container class=\"no-errors-spacer\" md-no-float><input \nplaceholder=\"Search labels...\" type=\"text\" ng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate \ntranslate-attr-placeholder=\"CONTROL_PANEL.VIEWS.LIST.LABELS.SEARCH_LABELS\"></md-input-container></md-menu-item>\n<md-menu-item ng-if=\"vm.labels.length\" class=\"label\" ng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button\n class=\"label-toggle-button\" ng-class=\"\'md-\'+label.color+\'-bg\'\" ng-click=\"vm.toggleTaskLabel(label);\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.LABELS.TOGGLE_LABEL\' | translate }}\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{ label.name }}</span> <i class=\"icon-check s16\" \nng-if=\"vm.allSelectedTasksWithLabel(label);\"></i> <i class=\"icon-minus s16\" \nng-if=\"vm.someSelectedTasksWithLabel(label) && !vm.allSelectedTasksWithLabel(label)\"></i></div></md-button><md-button \nng-if=\"vm.hasLabelsPermission\" class=\"md-icon-button label-edit-button\" md-prevent-menu-close \nng-click=\"vm.editLabel(label);\" aria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.LABELS.EDIT_BUTTON\' | translate }}\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></md-menu-item><small class=\"counter-labels\" \ntranslate=\"TASKS.DIALOG.LABELS.LIMIT_COUNT\" translate-values=\"{ length: vm.labels.length, limit: vm.labelsLimit }\">\n{{ vm.labels.length }} of {{ vm.labelsLimit }} labels</small><md-menu-divider \nng-if=\"vm.labels.length && vm.hasLabelsPermission\"></md-menu-divider><md-menu-item ng-if=\"vm.hasLabelsPermission\">\n<md-button data-cy=\"add-label-button\" class=\"add-label-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 1\" \nng-disabled=\"vm.labels.length >= vm.labelsLimit\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span \ntranslate=\"TASKS.DIALOG.LABELS.NEW\" style=\"pointer-events: auto\"><md-tooltip md-direction=\"right\" \nng-show=\"vm.labels.length >= vm.labelsLimit\"><span translate=\"TASKS.DIALOG.LABELS.LIMIT_EXCEEDED\" \ntranslate-values=\"{ length: vm.labels.length, limit: vm.labelsLimit }\">\nMaximum tag limit has been exceeded ({{ vm.labels.length }} of {{ vm.labelsLimit }}).</span></md-tooltip></span>\n</md-button></md-menu-item></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"add-label-tab-content\"><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button data-cy=\"add-label-button\" \nclass=\"md-icon-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 0\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.LABELS.BACK_BUTTTON\' | translate }}\"><i class=\"icon-arrow-left s20\"></i>\n</md-button><span flex translate=\"CONTROL_PANEL.VIEWS.LIST.LABELS.ADD_NEW_BUTTON\">Add new label</span></div><div \nclass=\"content\" layout=\"column\" layout-align=\"start stretch\"><form name=\"addLabelForm\" novalidate layout=\"column\">\n<md-input-container class=\"no-errors-spacer\" md-no-float><input placeholder=\"Name\" data-cy=\"label-name-input\" \ntype=\"text\" ng-model=\"vm.newLabelName\" maxlength=\"10\" required translate \ntranslate-attr-placeholder=\"CONTROL_PANEL.VIEWS.LIST.LABELS.NAME\"></md-input-container><div class=\"label-color-picker\" \nlayout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input data-cy=\"label-color-picker\" class=\"ng-hide\" type=\"radio\" \nng-model=\"vm.newLabelColor\" ng-value=\"palette\" aria-label=\"{{ palette }}\"> <i class=\"icon-check s18\" \nng-if=\"vm.newLabelColor === palette\"></i></label></div><md-button md-prevent-menu-close data-cy=\"create-label-button\" \nng-click=\"vm.addNewLabel({color:vm.newLabelColor, name: vm.newLabelName});\" class=\"create-button md-accent md-raised\" \nng-disabled=\"!vm.newLabelColor || !vm.newLabelName\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.LABELS.ADD_NEW_BUTTON\' | translate }}\"><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.LABELS.ADD_NEW_BUTTON\">Add new label</span></md-button></form></div></div>\n</md-tab-body></md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button data-cy=\"\" class=\"md-icon-button\" md-prevent-menu-close \nng-click=\"vm.labelTabIndex = 0\" aria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.LABELS.BACK_BUTTTON\' | translate }}\"><i \nclass=\"icon-arrow-left s20\"></i></md-button><span flex translate=\"CONTROL_PANEL.VIEWS.LIST.LABELS.EDIT_BUTTON\">Update\n</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\"><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input data-cy=\"label-name-input\" placeholder=\"Name\" type=\"text\" \nng-model=\"vm.editingLabel.name\" translate translate-attr-placeholder=\"CONTROL_PANEL.VIEWS.LIST.LABELS.NAME\">\n</md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap><label class=\"color\" \nng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input data-cy=\"label-color-picker\" class=\"ng-hide\" type=\"radio\" \nng-model=\"vm.editingLabel.color\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i \nng-if=\"vm.editingLabel.color === palette\" class=\"icon-check s18\"></i></label></div><md-button md-prevent-menu-close \ndata-cy=\"update-label-button\" class=\"create-button md-accent md-raised\" \naria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.LABELS.EDIT_BUTTON\' | translate }}\" \nng-click=\"vm.updateLabel(vm.editingLabel);\" ng-disabled=\"!vm.editingLabel.name || !vm.editingLabel.color\"><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.LABELS.EDIT_BUTTON\">Update</span></md-button><div layout=\"row\" \nlayout-align=\"end center\" flex></div></div></div></md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><div>\n<md-datepicker id=\"change-date\" class=\"md-date-picker-only-icon {{ !vm.editPermission && \'no-action-permission\'}}\" \nng-change=\"vm.changeTaskDate()\" ng-model=\"vm.newTaskDate\"></md-datepicker><md-tooltip><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.CHANGE_DATE\">Change date</span></md-tooltip></div><md-button \nclass=\"md-icon-button\" aria-label=\"{{ \'CONTROL_PANEL.VIEWS.LIST.ACTIONS.SEND_RATING\' | translate }}\" \nng-click=\"vm.sendRatingEmail();\"><md-icon md-font-icon=\"icon-thumbs-up-down\"></md-icon><md-tooltip><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.SEND_RATING\">Send rating email</span></md-tooltip></md-button></div></div>\n</div><div class=\"content-wrapper\"><div class=\"content thread-list\" ng-if=\"!vm.currentThread\" \nng-include=\"\'app/main/control-panel/views/list/views/classic/list/list.html\'\" ms-scroll flex></div></div><div \nclass=\"content-tasks-of-day__pagination\" layout=\"row\" layout-align=\"start center\"><div><select \nng-model=\"vm.pagination.perPageCount\" ng-change=\"vm.loadPaginatedTasks(1)\" ng-init=\"vm.pagination.perPageCount=\'25\'\">\n<option value=\"25\">25</option><option value=\"50\">50</option><option value=\"100\">100</option><option value=\"200\">200\n</option><option value=\"250\">250</option></select><span class=\"pagination-text\" \ntranslate=\"CORE.DATA_TABLE.RESULTS_PER_PAGE\">Results per page</span></div><div><span class=\"page-info\" hide-sm><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.PAGINATION.SELF\" \ntranslate-values=\"{ firstPageIndex: vm.pagination.firstPageIndex, lastPageIndex: vm.pagination.lastPageIndex, length: vm.tasks.length }\">\n</span> <span ng-if=\"vm.filteringIsOn()\" translate=\"CONTROL_PANEL.VIEWS.LIST.PAGINATION.FILTERED\" \ntranslate-values=\"{ length: vm.data.tasks.length }\">(Filtered from {{ vm.data.tasks.length }} records)</span></span>\n<md-button class=\"content-tasks-of-day__pagination-button\" aria-label=\"Previous\" translate \nng-disabled=\"vm.pagination.currentPage === 1\" ng-click=\"vm.loadPaginatedTasks(vm.pagination.currentPage - 1)\"><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.TICKETS.PREVIOUS\">Previous</span></md-button><md-button \nclass=\"content-tasks-of-day__pagination-button\" aria-label=\"Next\" translate \nng-disabled=\"vm.pagination.lastPageIndex >= vm.tasks.length\" \nng-click=\"vm.loadPaginatedTasks(vm.pagination.currentPage + 1)\"><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.TICKETS.NEXT\">Next</span></md-button></div></div>");
$templateCache.put("app/main/customers/dialogs/tabs/locations/edit/locations-tab.html","<main class=\"customers-dialog__locations-tab-edit\"><corporate-customer-disclaimer \nng-if=\"vm.customer.locked && vm.customer.metadata.sammathnaur\" \ncustomer-name=\"vm.customer.metadata.sammathnaur.account.name\" \ncustom-class=\"customer-dialog__corporate-customer-disclaimer\"></corporate-customer-disclaimer><section \nclass=\"customers-dialog__locations-tab-edit__main-container\"><div layout=\"row\"><div layout=\"row\" \nflex=\"{{(vm.customer.locked && vm.customer.metadata.sammathnaur) ? \'100\' : \'80\'}}\" \nclass=\"customers-dialog__locations-tab-edit__main-container__search-bar\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input fc-input__input--search\" ng-model=\"vm.locationsFilters.name\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.loadLocations()\" ng-disabled=\"false\"><label class=\"fc-input__label\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.FILTERS.NAME\">Filter by name</label><small class=\"search-bar__hint\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.FILTERS.NAME_HINT\"><b>Filter</b> locations by name</small></div><button\n class=\"fc-input__button border brad-4\" ng-click=\"vm.loadLocations()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</button></div><button class=\"new-equipment-button fc-button fc-blue full-height height-48\" \nstyle=\"white-space: nowrap\" ng-click=\"vm.newLocation($event)\" flex=\"20\" \nng-if=\"!(vm.customer.locked && vm.customer.metadata.sammathnaur) && !vm.customer.archived\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.CREATE_LOCATION\">New Location</button></div><div \nclass=\"customer-locations\"><header class=\"customer-locations__header\"><span>\n{{\'CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.LINKED_LOCATIONS\' | translate }} ({{ vm.locationsTotalItems }}) </span><span>\n{{\'CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.ACTIONS\' | translate }}<span></span></span></header><main \nclass=\"customer-locations__wrapper\" ms-scroll \nng-if=\"vm.locations.length && !vm.locationsIsLoading && !vm.locationsNotFound\"><div \nclass=\"customer-locations__location\" ng-repeat=\"location in vm.locations track by $index\" \nng-class=\"{\n            \'customer-locations__location--primary\': location.primary,\n            \'without-border\': vm.locations.length - 1 === $index\n          }\">\n<div class=\"customer-locations__location__info\"><md-icon ng-class=\"{\'primary-icon\': location.primary}\" \nmd-font-icon=\"icon-map-marker\"></md-icon><span class=\"customer-locations__location__info__name\"><span \ntitle=\"{{location.name}}\"><span ng-class=\"{ \'customer-locations__location__info__name--archived\': location.archived }\">\n{{ location.name | maxLength:240 }} </span><span class=\"customer-locations__location__info__name__primary\" \nng-if=\"location.primary\">- {{ \'CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.PRIMARY_LOCATION\' | translate }} </span><span \nng-if=\"location.archived\">{{ \'CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.ARCHIVED\' | translate }} </span></span><span \nclass=\"customer-locations__location__info__name__address\">{{ location.address.formattedAddress }}</span></span></div>\n<md-button class=\"md-icon-button\" data-cy=\"customer-edit-location\" ng-click=\"vm.editLocation($event, location.id)\">\n<md-icon md-svg-src=\"assets/icons/icon-edit-product-service.svg\" class=\"icon-edit clickable\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.EDIT_LOCATION\">Edit location</span>\n</md-tooltip></md-button></div></main><div class=\"customer-locations__loading\" ms-scroll \nng-if=\"(!vm.locations.length || vm.locationsIsLoading) && !vm.locationsNotFound\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"customer-locations__not-found\" ms-scroll \nng-if=\"vm.locationsNotFound && !vm.locationsIsLoading\"><md-icon class=\"s24\" md-font-icon=\"icon-map-marker\"></md-icon>\n<span translate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.FILTERS.NOT_FOUND\">Not found</span></div><div \nclass=\"customer-locations__pagination\"><span class=\"customer-locations__pagination__indicator\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.NAVIGATION_PHRASE\" \ntranslate-values=\"{ quantityStart: vm.locationPaginationQuantityStart,\n                              quantityEnd: vm.locationPaginationQuantityEnd,\n                              maxQuantity: vm.locationsTotalItems}\">\n</span> <button class=\"customer-locations__pagination__button\" type=\"button\" \nng-class=\"{\'disabled\': vm.disableLocationsPrevious || vm.locationsIsLoading}\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.PREVIOUS\" aria-label=\"Previous\" \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.PREVIOUS\" \nng-disabled=\"vm.disableLocationsPrevious || vm.locationsIsLoading\" ng-click=\"vm.changeLocationsPagination(-1);\">\nPrevious</button> <button class=\"customer-locations__pagination__button\" type=\"button\" \nng-class=\"{\'disabled\': vm.disableLocationsNext || vm.locationsIsLoading}\" \ntranslate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.NEXT\" aria-label=\"Next\" \ntranslate-attr-aria-label=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.NEXT\" \nng-disabled=\"vm.disableLocationsNext || vm.locationsIsLoading\" ng-click=\"vm.changeLocationsPagination(1);\">Next\n</button></div></div></section></main>");
$templateCache.put("app/main/customers/dialogs/tabs/locations/new/locations-tab.html","<main class=\"customers-dialog__locations-tab-new\"><div class=\"fc-warning-container\"><span>\n{{ \'CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.NEW_CUSTOMER_ALERT\' | translate }}</span></div><section \nclass=\"customers-dialog__locations-tab-new__main-container\"><div flex=\"100\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" data-cy=\"customer-location-name\" name=\"locationName\" \nng-model=\"vm.location.name\" ng-maxlength=\"240\" ng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n            invalid: customerForm.locationName.$touched && customerForm.locationName.$invalid\n          }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.NAME\' | translate)}}</label>\n<div style=\"text-align: right\"><span class=\"fc-textarea__limit location-name ng-binding\">\n({{ customerForm.locationName.$viewValue.length ? customerForm.locationName.$viewValue.length : 0 }}/240)</span></div>\n<fc-error ng-show=\"customerForm.locationName.$touched\" input-errors=\"customerForm.locationName.$error\" \nerrors-to-watch=\"[\n            {\n              name: \'required\',\n              translate: \'CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.ADDRESS.NAME_REQUIRED\'\n            },\n            {\n              name: \'maxlength\',\n              translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.MAX_LENGTH\',\n              translateValues: { expectedLength: 240, receivedLength: customerForm.locationName.$viewValue.length }\n            }\n          ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div \nclass=\"customers-dialog__locations-tab-new__main-container__toggle-location-search\"><md-radio-group \nng-model=\"vm.isGoogleAddress\"><md-radio-button data-cy=\"customer-location-google\" ng-value=\"true\" \nclass=\"md-primary display-block\">{{(\'LOCATIONS.DIALOG.GENERAL.SEARCH_BY_GOOGLE\' | translate)}}</md-radio-button>\n<md-radio-button data-cy=\"customer-location-cep\" ng-value=\"false\" class=\"md-primary display-block\">\n{{(\'LOCATIONS.DIALOG.GENERAL.SEARCH_BY_CEP\' | translate)}}</md-radio-button></md-radio-group><div><md-button \nclass=\"md-icon-button\" data-cy=\"customer-location-map\" ng-click=\"vm.openMapDialog($event, vm.location.address)\">\n<md-icon ng-class=\"{ \'enabled-icon\': vm.showMap }\" md-font-icon=\"icon-map\"></md-icon><md-tooltip><span \nng-if=\"vm.showMap\" translate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.UPDATE_COORDINATES\"></span> <span \nng-if=\"!vm.showMap\" translate=\"CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.UPDATE_COORDINATES_DISABLED\"></span></md-tooltip>\n</md-button></div></div><div flex layout=\"row\" \nclass=\"customers-dialog__locations-tab-new__main-container__input-groups\" ng-if=\"vm.isGoogleAddress\"><div flex=\"100\">\n<fc-autocomplete focus-id=\"customers-google-address\" \nlabel=\"{{(\'CUSTOMERS.DIALOGS.CUSTOMER.LOCATIONS.CUSTOMER_LOCATION\' | translate)}}\" options=\"vm.googleLocations\" \ntrack-by=\"formattedAddress\" ng-model=\"vm.selectedGoogleLocation\" ng-change=\"vm.selectedGoogleAddressChange()\" \nis-required=\"true\" data-cy=\"customer-location-autocomplete\" input-name=\"googleLocation\" \ninput-control=\"customerForm.googleLocation\" search-function=\"vm.searchLocationByGoogle()\" \nsearch-term=\"vm.locationByGoogleSearchTerm\" \nerrors-to-watch=\"[\n            {\n            name: \'required\',\n            translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.REQUIRED\'\n            }\n          ]\">\n</fc-autocomplete><div class=\"hint customers-dialog__locations-tab-new__main-container__input-groups__hint\"><div \nng-repeat=\"error in vm.googleLocationAddressErrors\"><md-icon md-font-icon=\"icon-alert\" class=\"red-fg fs-14\"></md-icon>\n<span>{{ \'CORE.ADDRESS_SERVICE.VALIDATION.\' + error | translate }}</span></div><div \nng-repeat=\"warning in vm.googleLocationAddressWarnings\"><md-icon md-font-icon=\"icon-alert\" class=\"orange-fg fs-14\">\n</md-icon><span>{{ \'CORE.ADDRESS_SERVICE.VALIDATION.\' + warning | translate }}</span></div></div></div></div><div flex \nlayout=\"row\" class=\"customers-dialog__locations-tab-new__main-container__input-groups\" ng-if=\"!vm.isGoogleAddress\"><div\n flex=\"25\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" \nname=\"cep\" ng-model=\"vm.location.address.postalCode\" ng-blur=\"vm.cepDb();\" data-cy=\"customer-zip-code\" \nng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n              invalid: customerForm.cep.$touched && customerForm.cep.$invalid\n            }\" \nng-required=\"true\" ng-pattern=\"/(^[0-9]{1,8}$)|(^[0-9]{5}-[0-9]{3}$)/\"><label class=\"fc-input__label\">\n{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.ZIPCODE.LABEL\' | translate)}}</label><fc-error \nng-show=\"customerForm.cep.$touched\" input-errors=\"customerForm.cep.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.ZIPCODE.REQUIRED\'\n              },\n              {\n                name: \'pattern\',\n                translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.ZIPCODE.PATTERN\'\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"50\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"city\" data-cy=\"customer-location-city\" \nng-model=\"vm.location.address.city\" ng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n              invalid: customerForm.city.$touched && customerForm.city.$invalid\n            }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.CITY.LABEL\' | translate)}}\n</label><fc-error ng-show=\"customerForm.city.$touched\" input-errors=\"customerForm.city.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.CITY.REQUIRED\'\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div flex=\"25\"><div class=\"fc-input\"><input type=\"text\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" name=\"number\" ng-model=\"vm.location.address.number\" \ndata-cy=\"customer-location-number\" ng-blur=\"vm.geoCoderAddress()\" ng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n              invalid: customerForm.number.$touched && customerForm.number.$invalid\n            }\"><label \nclass=\"fc-input__label\">{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.NUMBER.LABEL\' | translate)}}</label></div></div></div>\n<div flex layout=\"row\" class=\"customers-dialog__locations-tab-new__main-container__input-groups\" \nng-if=\"!vm.isGoogleAddress\"><div flex=\"25\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"neighborhood\" data-cy=\"customer-location-neighborhood\" \nng-model=\"vm.location.address.neighborhood\" ng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n              invalid: customerForm.neighborhood.$touched && customerForm.neighborhood.$invalid\n            }\">\n<label class=\"fc-input__label\">{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.NEIGHBORHOOD.LABEL\' | translate)}}</label></div>\n</div><div flex=\"50\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" name=\"street\" data-cy=\"customer-location-street\" ng-model=\"vm.location.address.street\" \nng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n              invalid: customerForm.street.$touched && customerForm.street.$invalid\n            }\"><label \nclass=\"fc-input__label\">{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.STREET.LABEL\' | translate)}}</label></div></div><div \nflex=\"25\"><div class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" \nname=\"state\" data-cy=\"customer-location-state\" ng-model=\"vm.location.address.state\" \nng-disabled=\"$root.loadingProgress\" \nng-class=\"{\n              invalid: customerForm.state.$touched && customerForm.state.$invalid\n            }\" \nng-required=\"true\"><label class=\"fc-input__label\">{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.STATE.LABEL\' | translate)}}\n</label><fc-error ng-show=\"customerForm.state.$touched\" input-errors=\"customerForm.state.$error\" \nerrors-to-watch=\"[\n              {\n                name: \'required\',\n                translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.STATE.REQUIRED\'\n              }\n            ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div flex layout=\"row\" \nclass=\"customers-dialog__locations-tab-new__main-container__input-groups\"><div flex=\"100\"><fc-smart-rewrite \nreference-id=\"vm.sessionId\" reference-type=\"location-complement\" disabled=\"$root.loadingProgress\" class=\"flex-100\">\n<fc-textarea is-disabled=\"$root.loadingProgress\" \nlabel=\"{{(\'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.ADDRESS.COMPLEMENT.LABEL\' | translate)}}\" \nng-model=\"vm.location.address.complement\" input-name=\"complement\" input-control=\"customerForm.complement\" \nmax-length=\"100\" \nerrors-to-watch=\"[\n              {\n                name: \'maxlength\',\n                translate: \'CUSTOMERS.DIALOGS.CUSTOMER.GENERAL.ADDRESS.COMPLEMENT.VALID\'\n              },\n            ]\">\n</fc-textarea></fc-smart-rewrite></div></div></section></main>");
$templateCache.put("app/main/locations/dialogs/tabs/attachments/template/rename-attachment-template.html","<div class=\"fc-input\" style=\"margin-bottom: 42px; display: flex; flex-direction: column;height: 60px\"><input \nng-change=\"vm.variables.handleTitleChange(vm.variables.editAttachmentTitle)\" style=\"height: 42px\" type=\"text\" \nclass=\"fc-input__input\" ng-model=\"vm.variables.editAttachmentTitle\" maxlength=\"100\"> <span \nstyle=\"align-self: flex-end;font-size: 12px;font-weight: 400;color: #757575\">\n({{vm.variables.editAttachmentTitle.length}}/100)</span></div>");
$templateCache.put("app/main/modules/sidenavs/customers-area/tabs/active-customers/active-customers.html","<div class=\"customers\"><md-list-item class=\"customers__title\" translate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.TITLE\">\nCustomers</md-list-item><div class=\"customers__toolbar\"><div class=\"customers__toolbar__search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input name=\"searchActiveCustomer\" type=\"search\" \nng-model=\"vm.searchActiveCustomer\" onkeydown=\"event.stopPropagation()\" translate \ntranslate-attr-placeholder=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.SEARCH\" placeholder=\"Search customer...\"></div><div \nclass=\"customers__toolbar__wrapper\"><md-button class=\"customers__toolbar__button md-raised md-accent\" \nng-click=\"vm.changeTab({ tabIndex: 1 })\"><span translate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.NEW\">New customer</span>\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div class=\"customers__list\" \nng-if=\"!vm.activeCustomersLoading\"><div class=\"customers__person\" \nng-repeat=\"customer in vm.activeCustomers | filter:vm.searchActiveCustomer\"><div class=\"customers__person__info\"><img \nng-if=\"customer.logoUrl\" class=\"customers__person__info__logo\" ng-src=\"{{ customer.logoUrl | mumakil }}\" \nsrc=\"./assets/images/avatars/profile.jpg\" alt=\"{{ customer.name }}\"><div ng-if=\"!customer.logoUrl\" \nclass=\"customers__person__info__letter-logo\">{{ customer.name.charAt(0) }}</div><div class=\"w-100-percent\"><p \nclass=\"customers__person__info__name\" title=\"{{customer.name}}\">{{ customer.name }}</p><p \nclass=\"customers__person__info__description\">{{ customer.description }}</p></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.syncCustomer({ customer: customer })\"><md-icon\n md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.SYNC\">Sync</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.editCustomer({ customer: customer })\" data-cy=\"customers-edit-button\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.EDIT\">Edit</span>\n</md-tooltip></md-button></div></div><div class=\"customers__list__not-found\" ng-if=\"vm.noActiveCustomers\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.NO_ACTIVE_CUSTOMER\">No active customer</span></div><div \nclass=\"customers__list__not-found\" \nng-if=\"!(vm.activeCustomers | filter:vm.searchActiveCustomer).length && !vm.noActiveCustomers\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.NO_ACTIVE_CUSTOMER_FOUND\">No active customer found</span></div></div><div \nclass=\"customers__loading\" ng-if=\"vm.activeCustomersLoading\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div></div>");
$templateCache.put("app/main/modules/sidenavs/customers-area/tabs/customer/customer.html","<div class=\"customers\"><div class=\"customers__wrapper\"><div class=\"customers__person no-border\"><div \nclass=\"customers__person__info\"><img ng-if=\"vm.customer.logoUrl\" class=\"customers__person__info__logo\" \nng-src=\"{{ vm.customer.logoUrl }}\" src=\"./assets/images/avatars/profile.jpg\" alt=\"{{ vm.customer.name }}\"><div \nng-if=\"!vm.customer.logoUrl\" class=\"customers__person__info__letter-logo\">{{ vm.customer.name.charAt(0) }}</div><div \nclass=\"customers__person__info__container\"><p class=\"customers__person__info__name\">{{ vm.customer.name }}</p><p \nclass=\"customers__person__info__description\">{{ vm.customer.description }}</p></div></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deactivateCustomer()\"><md-icon md-font-icon=\"icon-account-minus\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.REMOVE\">Remove</span></md-tooltip>\n</md-button></div></div><form name=\"customerForm\" novalidate><md-list-item><md-input-container><label \ntranslate=\"CUSTOMERS_AREA_MODULE.TASKS.TITLE\">OS types available:</label><md-select \ndata-md-container-class=\"module-sidenav__content__select\" multiple=\"true\" name=\"services\" required \nng-model=\"vm.customer.services\" ng-model-options=\"{trackBy: \'$value.id\'}\" md-on-close=\"vm.searchTaskTypeTerm = \'\'\">\n<md-select-header><input type=\"search\" ng-model=\"vm.searchTaskTypeTerm\" onkeydown=\"event.stopPropagation()\" translate \ntranslate-attr-placeholder=\"CUSTOMERS_AREA_MODULE.TASKS.SEARCH\" placeholder=\"Search for a type service...\">\n</md-select-header><md-optgroup><md-option ng-value=\"service\" \nng-repeat=\"service in vm.services | filter:vm.searchTaskTypeTerm\" ng-if=\"!service.archived\">\n{{(service.name && service.name.length) > 70 ? service.name.substring(0,70) + \'...\' : service.name }}</md-option>\n</md-optgroup><md-select-footer ng-if=\"!(vm.services | filter:vm.searchTaskTypeTerm).length\"><span \ntranslate=\"MODULES.NO_OPTION_FOUND\">No options found</span></md-select-footer></md-select><md-icon class=\"grey-400-fg\" \nmd-font-icon=\"icon-question-mark-circle\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.TASKS.HINT\">Only the OS types selected will be displayed when requesting a service.\n</span></md-tooltip></md-icon><div ng-messages=\"customerForm.services.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"CUSTOMERS_AREA_MODULE.TASKS.REQUIRED\">Required at least 1 OS types for call opening</span></div></div>\n</md-input-container></md-list-item></form><md-tabs class=\"main-tabs\" md-dynamic-height md-selected=\"vm.activeTab\">\n<md-tab label=\"0\"><div class=\"customers\"><md-list-item class=\"customers__title\" \ntranslate=\"CUSTOMERS_AREA_MODULE.USERS.TITLE\">Users</md-list-item><div class=\"customers__toolbar\"><div \nclass=\"customers__toolbar__search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input name=\"searchUsers\" \ntype=\"search\" ng-model=\"vm.searchUsers\" onkeydown=\"event.stopPropagation()\" translate \ntranslate-attr-placeholder=\"CUSTOMERS_AREA_MODULE.USERS.SEARCH\" placeholder=\"Search user...\"></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.reloadUsers()\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.USERS.RELOAD\">Reload</span></md-tooltip></md-button><div><md-button \nng-disabled=\"!vm.customer.services.length\" class=\"md-raised md-accent customers__toolbar__button\" \nng-click=\"vm.activeTab = 1;\"><span translate=\"CUSTOMERS_AREA_MODULE.USERS.NEW\">New user</span><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-tooltip ng-if=\"!vm.customer.services.length\" md-direction=\"bottom\">\n<span translate=\"CUSTOMERS_AREA_MODULE.USERS.NO_SERVICES_SELECTED\">No services selected</span></md-tooltip></div></div>\n</div><div class=\"customers__list\" ng-if=\"!vm.usersLoading\"><div class=\"customers__person\" \nng-repeat=\"user in vm.users | filter:vm.searchUsers\"><div class=\"customers__person__info\"><img ng-if=\"user.avatarUrl\" \nclass=\"customers__person__info__logo\" ng-src=\"{{ user.avatarUrl }}\" src=\"./assets/images/avatars/profile.jpg\" \nalt=\"{{ user.name }}\"><div ng-if=\"!user.avatarUrl\" class=\"customers__person__info__letter-logo\">\n{{ user.name.charAt(0) }}</div><div class=\"customers__person__info__container\"><p \nclass=\"customers__person__info__name\">{{ user.name }}</p><p class=\"customers__person__info__description\">\n{{ user.email }}</p><p class=\"customers__person__info__warn\" ng-if=\"!vm.isActivated(user)\">\n({{ \'CUSTOMERS_AREA_MODULE.USERS.PENDING\' | translate }})</p></div></div><div class=\"customers__person__buttons\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.resendUserInvitation(user)\" ng-if=\"!user.active\"><md-icon \nmd-font-icon=\"icon-share\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.USERS.RESEND_INVITATION\">Resend invitation</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deactivateUser(user)\"><md-icon md-font-icon=\"icon-account-minus\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"CUSTOMERS_AREA_MODULE.USERS.REMOVE\">Remove</span></md-tooltip>\n</md-button></div></div><div class=\"customers__list__not-found\" ng-if=\"vm.noUserActive && !vm.usersLoading\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.USERS.NO_ACTIVE_USER_FOUND\">No active user found</span></div><div \nclass=\"customers__list__not-found\" \nng-if=\"!(vm.users | filter:vm.searchUsers).length && !vm.usersLoading && !vm.noUserActive\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.USERS.NO_USER_FOUND\">No user found</span></div></div></div><div class=\"customers\" \nng-if=\"!vm.usersLoading && vm.archivedUsers.length\"><md-list-item class=\"customers__title\" \ntranslate=\"CUSTOMERS_AREA_MODULE.USERS.ARCHIVE_USERS_TITLE\">Archived users</md-list-item><div \nclass=\"customers__toolbar\"><div class=\"customers__toolbar__search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<input name=\"searchUsers\" type=\"search\" ng-model=\"vm.searchArchivedUsers\" onkeydown=\"event.stopPropagation()\" \ntranslate translate-attr-placeholder=\"CUSTOMERS_AREA_MODULE.USERS.SEARCH\" placeholder=\"Search user...\"></div></div><div\n class=\"customers__list\"><div class=\"customers__person customers__person--inactive\" \nng-repeat=\"user in vm.archivedUsers | filter:vm.searchArchivedUsers\"><div class=\"customers__person__info\"><img \nng-if=\"user.avatarUrl\" class=\"customers__person__info__logo\" ng-src=\"{{ user.avatarUrl }}\" \nsrc=\"./assets/images/avatars/profile.jpg\" alt=\"{{ user.name }}\"><div ng-if=\"!user.avatarUrl\" \nclass=\"customers__person__info__letter-logo\">{{ user.name.charAt(0) }}</div><div \nclass=\"customers__person__info__container\"><p class=\"customers__person__info__name\">{{ user.name }}</p><p \nclass=\"customers__person__info__description\">{{ user.email }}</p></div></div><md-button class=\"md-icon-button\" \nng-click=\"vm.activateUser(user)\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><md-tooltip md-direction=\"bottom\">\n<span translate=\"CUSTOMERS_AREA_MODULE.USERS.REACTIVATE\">Reactivate</span></md-tooltip></md-button></div><div \nclass=\"customers__list__not-found\" ng-if=\"!(vm.archivedUsers | filter:vm.searchArchivedUsers).length\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.USERS.NO_USER_FOUND\">No user found</span></div></div></div><div \nclass=\"customers__loading\" ng-if=\"vm.usersLoading\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div></md-tab><md-tab label=\"1\"><form name=\"newUserForm\" class=\"customers__new-user\"><span \nclass=\"customers__new-user__title\" translate=\"CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.TITLE\">Invite user </span><span \nclass=\"customers__new-user__subtitle\" translate=\"CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.SUBTITLE\" \ntranslate-values=\"{ name: vm.customer.name }\">Send an invitation to a new user of client</span><md-input-container>\n<label translate=\"CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.EMAIL\">Email</label><input type=\"email\" required \nng-model=\"vm.newUser.email\"><div ng-messages=\"newUserForm.userEmail.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.ERRORS.REQUIRED\">This field is required</span></div><div \nng-message=\"email\"><span translate=\"CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.ERRORS.EMAIL\">Insert a valid email</span>\n</div></div></md-input-container><div class=\"customers__new-user__buttons\"><md-button class=\"md-raised cancel-button\" \nng-disabled=\"vm.disableUserButton\" ng-click=\"vm.goBack()\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.CANCEL\">Cancel</span></md-button><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"newUserForm.$invalid || newUserForm.$pristine || vm.disableUserButton\" \nng-click=\"vm.sendUserInvitation();\"><span translate=\"CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.INVITE\">Convidar</span>\n</md-button></div></form></md-tab><md-tab label=\"2\"><div class=\"customers__new-user\"><span \nclass=\"customers__new-user__title\" translate=\"CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.SUCCESS.TITLE\">\nInvitation email sent </span><span class=\"customers__new-user__subtitle\" \ntranslate=\"CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.SUCCESS.SUBTITLE\" translate-values=\"{ name: vm.customer.name }\">\nThe user for this client will receive a invitation email</span><div class=\"customers__new-user__buttons mt-10\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.goBack()\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.USERS.NEW_SCREEN.OK\">Ok</span></md-button></div></div></md-tab></md-tabs></div>");
$templateCache.put("app/main/modules/sidenavs/customers-area/tabs/customers/customers.html","<div class=\"customers\"><md-list-item class=\"customers__title\" translate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.NEW\">\nNew customers</md-list-item><div class=\"customers__toolbar\"><div class=\"customers__toolbar__search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input name=\"searchCustomers\" type=\"search\" onkeydown=\"event.stopPropagation()\" \nng-model=\"vm.searchCustomersInput\" ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.searchCustomers()\" translate \ntranslate-attr-placeholder=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.SEARCH\" placeholder=\"Search customer...\" \nfocus-on=\"customersAreaSearchCustomersFocus\"></div></div><div class=\"customers__list\" ng-if=\"!vm.customersLoading\"><div\n class=\"customers__person\" ng-repeat=\"customer in vm.customers\"><div class=\"customers__person__info\"><img \nng-if=\"customer.logoUrl\" class=\"customers__person__info__logo\" ng-src=\"{{ customer.logoUrl }}\" \nsrc=\"./assets/images/avatars/profile.jpg\" alt=\"{{ customer.name }}\"><div ng-if=\"!customer.logoUrl\" \nclass=\"customers__person__info__letter-logo\">{{ customer.name.charAt(0) }}</div><div \nclass=\"customers__person__info__container\"><p class=\"customers__person__info__name\">{{ customer.name }}</p><p \nclass=\"customers__person__info__description\">{{ customer.notes }}</p></div></div><md-button class=\"md-icon-button\" \nng-disabled=\"customer.isAreaActivated\" ng-click=\"vm.activateCustomer(customer)\" \ntitle=\"{{customer.isAreaActivated ? (\'CUSTOMERS_AREA_MODULE.CUSTOMERS.ALREADY_ACTIVATED\' | translate) : \'\'}}\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><md-tooltip md-direction=\"bottom\"><span ng-if=\"!customer.isAreaActivated\" \ntranslate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.ACTIVATE\">Activate </span><span ng-if=\"customer.isAreaActivated\" \ntranslate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.ALREADY_ACTIVATED\">Customer is already activated</span></md-tooltip>\n</md-button></div><div class=\"customers__list__not-found\" ng-if=\"!vm.customers.length && !vm.customersLoading\"><span \ntranslate=\"CUSTOMERS_AREA_MODULE.CUSTOMERS.NO_CUSTOMER_FOUND\">No customer found</span></div></div><div \nclass=\"customers__loading\" ng-if=\"vm.customersLoading\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div></div>");
$templateCache.put("app/main/quotations/dialogs/components/quotation-expenses/select-expense/select-expense.component.html","<div data-cy=\"export-fc-modal\" class=\"fc-modal fc-modal__padding-small fc-modal__small\"><section \nclass=\"fc-modal__items\"><div class=\"fc-modal__header\"><div layout=\"row\"><h3 class=\"fc-modal__title\" \ntranslate=\"QUOTATIONS.DIALOG.EXPENSES.MODAL.TITLE\">Select expense</h3></div><md-icon \nmd-svg-src=\"assets/icons/icon-close.svg\" ng-click=\"vm.closeDialog()\"></md-icon></div></section><div \nclass=\"fc-modal__content\"><p translate=\"QUOTATIONS.DIALOG.EXPENSES.MODAL.LABEL\">Select expense type</p><fc-select \nng-model=\"vm.selectedExpense\" options=\"vm.expenses\" track-by=\"name\" with-search=\"true\" \nsearch-phrase=\"{{ \'QUOTATIONS.DIALOG.EXPENSES.MODAL.SEARCH_EXPENSE\' | translate }}\" \nlabel=\"{{ \'QUOTATIONS.DIALOG.EXPENSES.MODAL.PLACEHOLDER\' | translate }}\" \nsearch-function=\"vm.searchExpenses(searchTerm)\"></fc-select></div><section class=\"fc-modal__buttons-container\"><button \ntype=\"button\" data-cy=\"fc-modal-left-button\" class=\"fc-button fc-modal__button fc-modal__button--left-button\" \nstyle=\"margin-right: 12px; width: 120px\" ng-click=\"vm.closeDialog()\" \ntranslate=\"QUOTATIONS.DIALOG.EXPENSES.MODAL.BUTTONS.CANCEL\">Cancel</button> <button type=\"button\" \ndata-cy=\"fc-modal-right-button\" class=\"fc-button fc-modal__button fc-modal__button--right-button\" style=\"width: 120px\" \nng-click=\"vm.selectExpense()\" translate=\"QUOTATIONS.DIALOG.EXPENSES.MODAL.BUTTONS.SELECT\">Select</button></section>\n</div>");
$templateCache.put("app/main/quotations/dialogs/tabs/attachments/template/rename-attachment-template.html","<div class=\"fc-input\" style=\"margin-bottom: 24px; display: flex; flex-direction: column;height: 60px\"><input \nng-change=\"vm.variables.handleTitleChange(vm.variables.renameTitle)\" style=\"height: 42px\" type=\"text\" \nclass=\"fc-input__input\" ng-model=\"vm.variables.renameTitle\" maxlength=\"100\"> <span \nstyle=\"align-self: flex-end;font-size: 12px;font-weight: 400;color: #757575\">({{vm.variables.renameTitle.length}}/100)\n</span></div>");
$templateCache.put("app/main/settings/contents/integrations/apps/conta-azul/conta-azul.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><div class=\"sidebar-dialog__header__title\"><span flex \nclass=\"menu-title text-left\" translate=\"APPS.CONTA_AZUL.TITLE\">Omie</span></div></div><div \nclass=\"sidebar-dialog__actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-list class=\"module-sidenav__content\" ms-scroll>\n<p class=\"no-config\">{{ \'APPS.NO_CONFIG\' | translate }}</p></md-list><div class=\"module-sidenav__button-container\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised disable-button\" ng-click=\"vm.disableApp($event)\" \nng-disabled=\"vm.disableButton\" translate=\"APPS.DISABLE\">Disable</md-button></div></md-dialog>");
$templateCache.put("app/main/settings/contents/integrations/apps/omie/omie.html","<md-dialog class=\"sidebar-dialog sidebar-dialog--large\"><md-toolbar class=\"sidebar-dialog__header\"><div \nclass=\"sidebar-dialog__header__info\"><div class=\"sidebar-dialog__header__title\"><span flex \nclass=\"menu-title text-left\" translate=\"APPS.OMIE.TITLE\">Omie</span></div></div><div class=\"sidebar-dialog__actions\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-list class=\"module-sidenav__content\" ms-scroll><form name=\"omieForm\" novalidate><div \nclass=\"settings-content\" ng-if=\"!vm.isNewIntegration\"><div class=\"module-sidenav__content__switch setting-container\">\n<md-switch class=\"md-secondary switch-button\" flex \nng-model=\"vm.account.configuration.integrationsServiceQuantityAsDuration\"></md-switch><h3 class=\"title-text\">\n{{ \'APPS.OMIE.SERVICE_QUANTITY_AS_DURATION.TITLE\' | translate }}</h3></div><p class=\"description-text\">\n{{ \'APPS.OMIE.SERVICE_QUANTITY_AS_DURATION.DESCRIPTION\' | translate }}</p></div><div class=\"settings-content\" \nng-if=\"!vm.isNewIntegration\"><div class=\"module-sidenav__content__switch setting-container\"><md-switch \nclass=\"md-secondary\" flex ng-model=\"vm.account.configuration.integrationOmieCustomerCommercialName\"></md-switch><h3 \nclass=\"title-text\">{{ \'APPS.OMIE.COMMERCIAL_NAME.TITLE\' | translate }}</h3></div><p class=\"description-text\">\n{{ \'APPS.OMIE.COMMERCIAL_NAME.DESCRIPTION\' | translate }}</p></div><div class=\"settings-content\" \nng-if=\"!vm.isNewIntegration\"><div class=\"module-sidenav__content__switch setting-container\"><md-switch \nclass=\"md-secondary\" flex ng-model=\"vm.account.configuration.integrationOmieServicesOSValue\"></md-switch><h3 \nclass=\"title-text\">{{ \'APPS.OMIE.SERVICES_OS_VALUE.TITLE\' | translate }}</h3></div><p class=\"description-text\">\n{{ \'APPS.OMIE.SERVICES_OS_VALUE.DESCRIPTION\' | translate }}</p></div><div ng-if=\"vm.isNewIntegration\" \nclass=\"new-integration-container\"><h2 translate=\"CUSTOMERS.INTEGRATIONS.ENABLE_INTEGRATION\" class=\"main-info-text\">\nEnable Integration</h2><p class=\"fs-16\"><span translate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL\" \ntranslate-values=\"{ appKey: \'App Key\', appSecret: \'App Secret\' }\"></span></p><ul class=\"ul-steps tips-container\"><li>\n<span translate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_1\">Click</span> <a \nhref=\"https://developer.omie.com.br/my-apps/\" target=\"_blank\"><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_2\">here</span></a> <span \ntranslate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_3\">e faça login com sua conta Omie</span></li><li>\n<span translate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_4\">\nClick on the option with the name of your company/application</span></li><li><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_5\">\nCopy the information from App Key and App Secret and paste in the fields below</span></li><li><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_8\">Give it a name to your integration</span></li>\n<li><span translate=\"CUSTOMERS.INTEGRATIONS.OMIE.CONFIGURATION_TUTORIAL_TIPS_6\">\nClick Enable Integration and you\'re done :)</span></li></ul></div><div class=\"main-title-container\"><p \nclass=\"main-info-text\" translate=\"APPS.OMIE.ACCOUNTS.TITLE\" translate-values=\"{ value: vm.accounts.length }\"></p></div>\n<div class=\"multiple-accounts\"><div layout=\"row\" layout-align=\"center\"><div layout=\"column\" \nclass=\"accounts-items-table-container\"><div layout=\"column\" class=\"accounts-items-table-body\" \nng-repeat=\"item in vm.accounts track by $index\"><div layout=\"row\" layout-padding layout-align=\"start\" flex=\"100\"><div \nclass=\"omie-width item-width\"><div flex=\"100\" class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" ng-disabled=\"false\" id=\"name{{$index}}\" name=\"name{{$index}}\" aria-label=\"Name\" \nng-change=\"vm.changedAppName($index);\" ng-model=\"item.name\" \nng-class=\"{\n                    invalid: omieForm[\'name\' + $index].$touched && omieForm[\'name\' + $index].$error && (omieForm[\'name\' + $index].$error.duplicate || omieForm[\'name\' + $index].$error.required)\n                  }\" \nng-required=\"true\"><label class=\"fc-input__label\" translate=\"APPS.OMIE.ACCOUNTS.NAME\"></label><fc-error \nng-show=\"omieForm[\'name\' + $index].$touched\" input-errors=\"omieForm[\'name\' + $index].$error\" \nerrors-to-watch=\"[\n                        {\n                          name: \'duplicate\',\n                          translate: \'APPS.OMIE.ACCOUNTS.ERRORS.DUPLICATED_NAME\'\n                        },\n                        {\n                          name: \'required\',\n                          translate: \'APPS.OMIE.ACCOUNTS.ERRORS.REQUIRED\'\n                        }\n                    ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div class=\"omie-width item-width\"><div flex=\"100\" \nclass=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" ng-disabled=\"!item.new\" \nid=\"key{{$index}}\" name=\"key{{$index}}\" aria-label=\"Key\" ng-change=\"vm.changedAppKey($index);\" ng-model=\"item.key\" \nng-class=\"{\n                    invalid: omieForm[\'key\' + $index].$touched && omieForm[\'key\' + $index].$error && (omieForm[\'key\' + $index].$error.duplicate || omieForm[\'key\' + $index].$error.required || omieForm[\'key\' + $index].$error.minlength)\n                  }\" \nng-required=\"true\" ng-minlength=\"10\"><label class=\"fc-input__label\" translate=\"APPS.OMIE.ACCOUNTS.KEY\"></label>\n<fc-error ng-show=\"omieForm[\'key\' + $index].$touched\" input-errors=\"omieForm[\'key\' + $index].$error\" \nerrors-to-watch=\"[\n                        {\n                          name: \'minlength\',\n                          translate: \'APPS.OMIE.ACCOUNTS.ERRORS.MINLENGTH_KEY\'\n                        },\n                        {\n                          name: \'duplicate\',\n                          translate: \'APPS.OMIE.ACCOUNTS.ERRORS.DUPLICATED_KEY\'\n                        },\n                        {\n                          name: \'required\',\n                          translate: \'APPS.OMIE.ACCOUNTS.ERRORS.REQUIRED\'\n                        }\n                    ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div class=\"action-width item-width\"><md-input-container \nclass=\"trash-icon\"><button aria-label=\"Close\" ng-if=\"vm.accounts.length !== 1\" \nng-click=\"vm.removeAccount(vm.accounts[$index], $index)\"><img src=\"assets/icons/trash.svg\"></button><md-tooltip \nng-if=\"vm.accounts.length !== 1\" md-direction=\"left\"><span>{{ \"APPS.OMIE.ACCOUNTS.DELETE.TITLE\" | translate}}</span>\n</md-tooltip><button disabled=\"true\" ng-if=\"vm.accounts.length === 1\"><img src=\"assets/icons/trash-disabled.svg\">\n</button><md-tooltip ng-if=\"vm.accounts.length === 1\" md-direction=\"left\"><span>\n{{ \"APPS.OMIE.ACCOUNTS.DELETE.ONE_ITEM\" | translate}}</span></md-tooltip></md-input-container></div></div><div \nclass=\"secret-width item-width\"><div flex=\"100\" class=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" ng-disabled=\"!item.new\" id=\"secret{{$index}}\" name=\"secret{{$index}}\" \nng-change=\"vm.validatedAppKeys();\" aria-label=\"Secret\" ng-model=\"item.secret\" \nng-class=\"{\n              invalid: omieForm[\'secret\' + $index].$touched && omieForm[\'secret\' + $index].$error && (omieForm[\'secret\' + $index].$error.minlength || omieForm[\'secret\' + $index].$error.required)\n            }\" \nng-minlength=\"32\" ng-required=\"true\"><label class=\"fc-input__label\" translate=\"APPS.OMIE.ACCOUNTS.SECRET\"></label>\n<fc-error ng-show=\"omieForm[\'secret\' + $index].$touched\" input-errors=\"omieForm[\'secret\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'minlength\',\n                    translate: \'APPS.OMIE.ACCOUNTS.ERRORS.MINLENGTH_SECRET\'\n                  },\n                  {\n                    name: \'required\',\n                    translate: \'APPS.OMIE.ACCOUNTS.ERRORS.REQUIRED\'\n                  }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div></div></div><div flex=\"100\" class=\"item-add-row\" \nng-if=\"vm.accounts.length < 5\"><md-button class=\"add-button\" ng-click=\"vm.addAccount();\" \ntranslate=\"APPS.OMIE.ACCOUNTS.ADD\"></md-button></div></div></form></md-list><div \nclass=\"module-sidenav__button-container\" layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"vm.enableIntegration();\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.disableButton || omieForm.$pristine || !vm.hasValidAppKeys || omieForm.$invalid\" \nng-if=\"vm.isNewIntegration\" translate=\"CUSTOMERS.INTEGRATIONS.ACTIVATE_INTEGRATION\">Activate integration</md-button>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.save($event)\" ng-if=\"!vm.isNewIntegration\" \nng-disabled=\"vm.disableButton || omieForm.$pristine || !vm.hasValidAppKeys || omieForm.$invalid\" translate=\"APPS.SAVE\">\nSave</md-button><md-button class=\"md-raised disable-button\" ng-if=\"!vm.isNewIntegration\" \nng-click=\"vm.disableApp($event)\" ng-disabled=\"vm.disableButton\" translate=\"APPS.DISABLE\">Disable</md-button></div>\n</md-dialog>");
$templateCache.put("app/main/tasks/sidenavs/filters/components/custom/custom-filter-sidenav.html","<div flex class=\"content filter-sidenav\" ms-scroll ms-sidenav-helper><md-list><md-radio-group ng-model=\"vm.action\" \nng-change=\"vm.setFilterNames();\"><md-radio-button value=\"new\" class=\"md-primary ml-10\" \nng-class=\"!selectedCustomFilter.id ? \'hide-radio-button\' : \'\'\"><div class=\"h-10 pl-10 pb-25 ml-15n mt-6\"><span \ntranslate=\"TASKS.SIDENAV.CUSTOM_FILTERS.NEW_FILTER\">New filter</span></div></md-radio-button><md-list-item \nclass=\"mt-25n\"><input flex placeholder=\"Filter name\" translate \ntranslate-attr-placeholder=\"TASKS.SIDENAV.CUSTOM_FILTERS.FILTER_NAME\" type=\"text\" class=\"custom-filter-input-name\" \nng-model=\"vm.filter.newName\" maxlength=\"20\" ng-disabled=\"vm.action !== \'new\'\" required><md-button \nng-click=\"vm.saveFilter();\" class=\"md-accent md-raised\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"TASKS.SIDENAV.CUSTOM_FILTERS.SAVE\" ng-disabled=\"vm.action !== \'new\'\"><span \ntranslate=\"TASKS.SIDENAV.CUSTOM_FILTERS.SAVE\">Save</span></md-button></md-list-item><md-radio-button value=\"edit\" \nclass=\"md-primary ml-10\" ng-if=\"selectedCustomFilter.id\"><div class=\"pl-10 pb-25 mt-25 ml-15n\"><span \ntranslate=\"TASKS.SIDENAV.CUSTOM_FILTERS.EDIT_FILTER\">Edit filter</span></div></md-radio-button><md-list-item \nng-if=\"selectedCustomFilter.id\" class=\"mt-40n\"><input flex placeholder=\"Filter name\" translate \ntranslate-attr-placeholder=\"TASKS.SIDENAV.CUSTOM_FILTERS.FILTER_NAME\" type=\"text\" class=\"custom-filter-input-name\" \nng-model=\"vm.filter.editName\" maxlength=\"20\" ng-disabled=\"vm.action !== \'edit\'\" required><md-button \nng-click=\"vm.saveFilter(\'edit\');\" class=\"md-accent md-raised\" aria-label=\"edit filters\" translate \ntranslate-attr-aria-label=\"TASKS.SIDENAV.CUSTOM_FILTERS.EDIT\" ng-disabled=\"vm.action !== \'edit\'\"><span \ntranslate=\"TASKS.SIDENAV.CUSTOM_FILTERS.EDIT\">Edit</span></md-button></md-list-item></md-radio-group></md-list></div>");
$templateCache.put("app/main/tasks/sidenavs/filters/components/list/list-filter-sidenav.html","<div flex class=\"content filter-sidenav\" ms-sidenav-helper><md-list><div class=\"filter-property-name\"><span \ntranslate=\"TASKS.SIDENAV.CUSTOM_FILTERS.LIST.DEFAULT.LABEL\">Default filters</span></div><md-list-item class=\"label\" \nng-repeat=\"savedFilter in vm.defaultFilters\" ng-click=\"vm.selectFilter(savedFilter);\"><md-icon \nmd-font-icon=\"{{ savedFilter.icon }}\" class=\"label-icon\"></md-icon><p>{{ savedFilter.name }}</p></md-list-item><div \nclass=\"filter-property-name mt-15\" ng-if=\"vm.customFilters.length > 0\"><span \ntranslate=\"TASKS.SIDENAV.CUSTOM_FILTERS.LIST.CUSTOM\">Custom filters</span></div><md-list-item class=\"label\" \nng-if=\"vm.customFilters.length > 0\" ng-repeat=\"customFilter in vm.customFilters\" \nng-click=\"vm.selectFilter(customFilter);\"><md-icon md-font-icon=\"icon-filter-outline\" class=\"label-icon\"></md-icon><p>\n{{ customFilter.name }}</p><md-button ng-click=\"vm.updateToArchived($event, customFilter);\" \nclass=\"remove-button md-icon-button\" aria-label=\"{{ \'TASKS.SIDENAV.CUSTOM_FILTERS.LIST.REMOVE\' | translate }}\"><md-icon\n md-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item></md-list></div>");
$templateCache.put("app/core/integrations/core/customers/dialogs/import/automatic/customers-import-automatic-dialog.html","<div class=\"fc-modal fc-modal__small customers-import-automatic-progress\"><section class=\"fc-modal__items\"><h3 \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_DIALOG_TITLE\" translate-value-app=\"{{ vm.appName }}\" \nclass=\"fc-modal__title\"></h3><div><div><p class=\"fc-modal__content\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.WAIT_WE_RE_IMPORTING\"></p><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{ vm.progressPercentage }}\"></md-progress-linear><div layout=\"column\" layout-align=\"flex-end\"><p \nclass=\"fs-16 flex-end\">{{ vm.totalCustomersImported || \'0\' }} <span \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_FROM\">from</span> {{ vm.totalCustomersToImport }}</p>\n</div></div></div></section><section class=\"fc-modal__buttons-container\"><button ng-click=\"vm.closeDialog()\" \ndata-cy=\"fc-modal-left-button\" type=\"button\" translate=\"MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL\" \nclass=\"fc-button fc-modal__button fc-modal__button--left-button\"></button></section></div>");
$templateCache.put("app/core/integrations/core/customers/dialogs/import/manual/customers-import-manual-dialog.html","<md-dialog class=\"customers-import-manual-dialog\" aria-label=\"Integration\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools align-vertical align-vertical-middle\"><span class=\"fs-17\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.IMPORT_CUSTOMERS_FROM\" translate-value-app=\"{{ vm.appName }}\">\nImport customers from {{ vm.appName }}</span> <span flex></span> <span flex></span><md-button \nclass=\"md-icon-button margin-top-0\" ng-click=\"vm.closeDialog();\" aria-label=\"Close Dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\">\n<md-input-container class=\"search-customers-container mb-0\"><input flex placeholder=\"Pesquise pelo nome ou documento\" \nclass=\"fs-16\" type=\"text\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.searchCustomers();\" \nng-model=\"vm.searchText\"><md-progress-circular ng-if=\"vm.loadingCustomers\" md-diameter=\"24\"></md-progress-circular><p \nng-if=\"vm.customersFound.length\" translate=\"CUSTOMERS.INTEGRATIONS.CONTA_AZUL.TOTAL_CUSTOMERS\" \ntranslate-values=\"{ totalCustomers: vm.customersFound.length}\">Customer found</p></md-input-container></div><p \nclass=\"fs-14 text-center\" ng-if=\"!vm.didMakeTheFirstSearch && !vm.searchText\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.FIND_CUSTOMER_TO_IMPORT\">\nUse the field above to find the customers you want to import into Field Control</p><p class=\"fs-14 text-center\" \nng-if=\"vm.didMakeTheFirstSearch &&\n             vm.searchText &&\n             !vm.customersFound.length &&\n             !vm.displayErrMessage &&\n             !vm.displayKeyErrMessage &&\n             !vm.loadingCustomers\">\n<span translate=\"CUSTOMERS.INTEGRATIONS.CANT_FIND_ANY_CUSTOMER_WITH\">Could not find any customer with:</span> <strong>\n{{vm.searchText}}</strong></p><p class=\"fs-14 text-center red-text\" ng-if=\"vm.displayErrMessage\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.CANT_CONNECT\" translate-value-app=\"{{ vm.appName }}\">\nUnable to connect with {{ vm.appName }}, check your integration settings and try again.</p><p \nclass=\"fs-14 text-center red-text\" ng-if=\"vm.displayKeyErrMessage\" \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.ERROR_KEY\">Your key is not valid or the application has been suspended.</p>\n<md-list flex ng-show=\"vm.didMakeTheFirstSearch && vm.customersFound.length > 0\"><md-list-item \nclass=\"md-3-line extended\" ng-repeat=\"customer in vm.customersFound\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\"><h3 class=\"text-wrap\">{{ customer.apiCustomer.name }} <span \nclass=\"customer-archived-tag\" ng-if=\"customer.archived\"><span translate=\"CUSTOMERS.INTEGRATIONS.ARCHIVED\">archived\n</span><md-tooltip md-direction=\"right\"><span translate=\"CUSTOMERS.INTEGRATIONS.CUSTOMER_IS_ARCHIVED\">\nThis customer is archived on Field</span></md-tooltip></span></h3><div class=\"customer-infos\"><div \nng-if=\"customer.apiCustomer.documentNumber\"><i class=\"md-accent-fg icon icon-document s15\"></i> <span><b>\n{{ customer.apiCustomer.documentNumber | cpfCnpjFilter }}</b></span></div></div><div class=\"customer-infos\"><div \nng-if=\"customer.apiCustomer.address && customer.apiCustomer.address.formattedAddress\"><i \nclass=\"md-accent-fg icon icon-map-marker s15\"></i> <span>{{ customer.apiCustomer.address.formattedAddress }}</span>\n</div></div><div class=\"customer-infos\"><div ng-if=\"customer.apiCustomer.phone\"><i \nclass=\"md-accent-fg icon icon-phone s15\"></i> <span>{{ customer.apiCustomer.phone | brPhoneNumber }}</span></div><div \nng-if=\"customer.apiCustomer.email\"><i class=\"md-accent-fg icon icon-email s15\"></i> <span>\n{{ customer.apiCustomer.email }}</span></div></div></div><div class=\"action-centralize\" \nng-if=\"customer.isLoading || customer.actionCompleted\"><md-progress-circular ng-if=\"customer.isLoading\" \nmd-diameter=\"20\"></md-progress-circular><i ng-if=\"customer.actionCompleted\" class=\"s24 icon-check\"></i></div><div \nng-if=\"!customer.isLoading && !customer.actionCompleted\"><md-button type=\"button\" \nclass=\"{{ customer.actionButtonClass }}\" ng-click=\"customer.syncCustomer(customer);\" \nng-disabled=\"!customer.apiCustomer.address || !customer.apiCustomer.address.formattedAddress\">{{ customer.actionName }}\n</md-button><md-tooltip ng-if=\"!customer.apiCustomer.address || !customer.apiCustomer.address.formattedAddress\"><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.CANT_PROCEED_WITH_NO_ADDRESS\" \ntranslate-value-action=\"{{ customer.actionName | lowercase}}\">\nCan\'t {{ customer.actionName | lowercase}} a customer without address</span></md-tooltip></div></div><md-divider>\n</md-divider></md-list-item></md-list></md-dialog-content></md-dialog>");
$templateCache.put("app/core/integrations/core/customers/dialogs/prompt/create/customers-prompt.html","<md-dialog class=\"integration-prompt\"><md-content class=\"task-dialog-data-export\"><div \nclass=\"fc-modal fc-modal__small customers-import-prompt\"><h3 class=\"top-margin-title\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.EXPORT_TITLE\" class=\"fc-modal__title\"></h3><p class=\"fc-modal__content\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.EXPORT_INSTRUCTIONS\" translate-values=\"{ \'app\': vm.appName }\"></p><span><ul \nclass=\"no-list-padding\"><li class=\"gray-coloring\"><b translate=\"CUSTOMERS.INTEGRATIONS.NAME\">Name</b>\n: {{ vm.viewModel.customerName }}</li><li class=\"gray-coloring\" ng-if=\"vm.viewModel.customerDocumentNumber\"><b \ntranslate=\"CUSTOMERS.INTEGRATIONS.DOCUMENT\">Document</b>: {{ vm.viewModel.customerDocumentNumber | cpfCnpjFilter }}\n</li><li class=\"gray-coloring\" ng-if=\"vm.viewModel.formattedAddress\"><b translate=\"CUSTOMERS.INTEGRATIONS.ADDRESS\">\nAddress</b>: {{ vm.viewModel.formattedAddress }}</li><li class=\"gray-coloring\" \nng-if=\"vm.viewModel.customerEmailAddress\"><b translate=\"CUSTOMERS.INTEGRATIONS.EMAIL\">E-mail:</b>\n {{ vm.viewModel.customerEmailAddress }}</li><li class=\"gray-coloring\" ng-if=\"vm.viewModel.customerContactPhone\"><b \ntranslate=\"CUSTOMERS.INTEGRATIONS.PHONE\">Phone</b>:{{ vm.viewModel.customerContactPhone | brPhoneNumber }}</li><li \nclass=\"gray-coloring\" ng-if=\"vm.viewModel.customerNotes\"><b translate=\"CUSTOMERS.INTEGRATIONS.NOTES\">Notes</b>\n: {{ vm.viewModel.customerNotes }}</li></ul><p class=\"fc-modal__content\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.IMPORTS.ARE_YOU_SURE\"></p></span><br><section class=\"fc-modal__buttons-container\">\n<button ng-click=\"vm.closeDialog()\" data-cy=\"fc-modal-left-button\" type=\"button\" \ntranslate=\"MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL\" \nclass=\"fc-button button-right-margin fc-modal__button fc-modal__button--left-button\"></button> <button \nng-click=\"vm.createCustomer()\" data-cy=\"fc-modal-left-button\" type=\"button\" translate=\"CUSTOMERS.INTEGRATIONS.EXPORT\" \nclass=\"fc-button fc-modal__button fc-modal__button--right-button\"></button></section></div></md-content></md-dialog>");
$templateCache.put("app/core/integrations/core/customers/dialogs/prompt/update/customers-prompt.html","<md-dialog class=\"integration-prompt\"><md-content class=\"task-dialog-data-export\"><div \nclass=\"fc-modal fc-modal__small customers-import-prompt\"><h3 class=\"top-margin-title\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.CONFIRM_UPDATE\" class=\"fc-modal__title\">Customer creation confirmation</h3><p \nclass=\"fc-modal__content\" translate=\"CUSTOMERS.INTEGRATIONS.WILL_BE_UPDATED_WITH_DATA\" \ntranslate-value-app=\"{{ vm.appName }}\">The customer will be created in {{ vm.appName }} with the following data</p>\n<span><ul class=\"no-list-padding\"><li class=\"gray-coloring\"><b translate=\"CUSTOMERS.INTEGRATIONS.NAME\">Name</b>\n: {{ vm.viewModel.customerName }}</li><li class=\"gray-coloring\" ng-if=\"vm.viewModel.customerDocumentNumber\"><b \ntranslate=\"CUSTOMERS.INTEGRATIONS.DOCUMENT\">Document</b>: {{ vm.viewModel.customerDocumentNumber | cpfCnpjFilter }}\n</li><li class=\"gray-coloring\" ng-if=\"vm.viewModel.formattedAddress\"><b translate=\"CUSTOMERS.INTEGRATIONS.ADDRESS\">\nAddress</b>: {{ vm.viewModel.formattedAddress }}</li><li class=\"gray-coloring\" \nng-if=\"vm.viewModel.customerEmailAddress\"><b translate=\"CUSTOMERS.INTEGRATIONS.EMAIL\">E-mail:</b>\n {{ vm.viewModel.customerEmailAddress }}</li><li class=\"gray-coloring\" ng-if=\"vm.viewModel.customerContactPhone\"><b \ntranslate=\"CUSTOMERS.INTEGRATIONS.PHONE\">Phone</b>:{{ vm.viewModel.customerContactPhone | brPhoneNumber }}</li><li \nclass=\"gray-coloring\" ng-if=\"vm.viewModel.customerNotes\"><b translate=\"CUSTOMERS.INTEGRATIONS.NOTES\">Notes</b>\n: {{ vm.viewModel.customerNotes }}</li></ul><p class=\"fc-modal__content\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.IMPORTS.ARE_YOU_SURE\"></p></span><br><section class=\"fc-modal__buttons-container\">\n<button ng-click=\"vm.closeDialog()\" data-cy=\"fc-modal-left-button\" type=\"button\" \ntranslate=\"MODULES.REQUEST_ACTIVATION.DIALOG.CANCEL\" \nclass=\"fc-button button-right-margin fc-modal__button fc-modal__button--left-button\"></button> <button \nng-click=\"vm.updateCustomer()\" data-cy=\"fc-modal-left-button\" type=\"button\" translate=\"CUSTOMERS.INTEGRATIONS.EXPORT\" \nclass=\"fc-button fc-modal__button fc-modal__button--right-button\"></button></section></div></md-content></md-dialog>");
$templateCache.put("app/core/integrations/core/tasks/dialogs/export/conta-azul/conta-azul-tasks-export-dialog.html","<md-dialog class=\"integration-tasks-export-dialog form-dialog conta-azul\" aria-label=\"Integration\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title__conta-azul-tasks-export\">Enviar atividade para Conta Azul</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog();\" aria-label=\"Close Dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\"></md-icon>\n</md-button></div></md-toolbar><form name=\"salesForm\" class=\"md-inline-form\"><md-dialog-content ms-scroll><div \nclass=\"form-wrapper no-padding conta-azul-container\" flex=\"100\"><div class=\"sidebar-dialog__hint\"><div \nclass=\"conta-azul-hint\"><md-icon class=\"alert-icon\" md-font-icon=\"icon-alert-circle\"></md-icon><span>\nAo enviar a atividade novamente para o Conta Azul, uma nova Venda será criada. Selecione ao menos um produto ou serviço para enviar.\n</span></div></div><div class=\"general-information\"><div class=\"general-title-row\" \nng-click=\"vm.colapseSection(\'general\')\" layout=\"row\" layout-align=\"space-between center\"><p class=\"general-info-text\">\nInformações gerais</p><i class=\"18 arrow icon-arrow\" \nng-class=\"{\'icon-chevron-down\': vm.generalIsOpen, \'icon-chevron-up\': !vm.generalIsOpen}\"></i></div><div \nng-if=\"vm.generalIsOpen\" layout=\"row\" layout-align=\"space-between\" class=\"customer-data\"><div \nclass=\"customer-autocomplete-container\" flex=\"60\"><div class=\"customer-autocomplete-field\"><fc-autocomplete \nname=\"customerName\" md-autofocus flex required input-name=\"customerName\" label=\"Cliente\" is-required=\"true\" \ndebounce=\"500\" md-no-cache=\"true\" class=\"md-autocomplete-input-item customer-autocomplete-input-text\" \ninput-control=\"salesForm.customerName\" ng-model=\"vm.viewModel.form.customer\" track-by=\"name\" \noptions=\"vm.viewModel.availableCustomers\" search-term=\"vm.viewModel.searchCustomerText\" click-to-remove=\"true\" \nng-change=\"vm.viewModel.customerHasChanged();\" \nsearch-function=\"vm.viewModel.searchCustomer(vm.viewModel.searchCustomerText)\" \nerrors-to-watch=\"[\n                                {\n                                  name: \'required\',\n                                  translate: \'Campo obrigatório\'\n                                },\n                              ]\">\n</fc-autocomplete><md-button ng-if=\"vm.viewModel.form.customer\" ng-click=\"vm.viewModel.clearSelectedCustomer();\" \nclass=\"md-icon-button md-accent clear-selected-customer\" aria-label=\"Limpar cliente\"><md-icon \nmd-font-icon=\"icon icon-close-circle-outline\"></md-icon><md-tooltip md-direction=\"right\">Limpar cliente</md-tooltip>\n</md-button></div><div class=\"customer-infos\"><div class=\"row\"><div class=\"info\" \nng-if=\"vm.viewModel.customerData.documentNumber\"><i class=\"md-accent-fg icon icon-document s15\"></i> <span>\n{{ vm.viewModel.customerData.documentNumber | cpfCnpjFilter }}</span></div><div class=\"info\" \nng-if=\"vm.viewModel.customerData.contact && vm.viewModel.customerData.contact.email\"><i \nclass=\"md-accent-fg icon icon-email s15\"></i> <span>{{ vm.viewModel.customerData.contact.email }}</span></div><div \nclass=\"info\" ng-if=\"vm.viewModel.customerData.contact && vm.viewModel.customerData.contact.phone\"><i \nclass=\"md-accent-fg icon icon-phone s15\"></i> <span>{{ vm.viewModel.customerData.contact.phone | brPhoneNumber }}\n</span></div></div><div class=\"row\" \nng-if=\"vm.viewModel.customerData.address && vm.viewModel.customerData.address.formattedAddress\"><div class=\"info\"><i \nclass=\"md-accent-fg icon icon-map-marker s15\"></i> <span>{{ vm.viewModel.customerData.address.formattedAddress }}\n</span></div></div><br></div></div><div flex=\"20\" class=\"fc-datepicker date-selector\"><label \nclass=\"fc-datepicker__label\">Data da venda</label><div layout=\"row\" class=\"date-container\"><md-datepicker flex \nrequired class=\"p-0\" md-hide-icons=\"calendar\" md-min-date=\"task.minDate\" ng-model=\"vm.viewModel.form.date\" \nmd-placeholder=\"dd/mm/yyyy\"></md-datepicker></div></div><div flex=\"20\" class=\"fc-input status-container\"><fc-select \nlabel=\"Status\" ng-model=\"vm.viewModel.form.status\" options=\"vm.statusOptions\" is-required=\"true\" \ndata-cy=\"sales-status\" input-name=\"status\" input-control=\"vm.salesForm.status\" is-disabled=\"$root.loadingProgress\">\n</fc-select><fc-error class=\"status-error\" input-errors=\"vm.salesForm.status.$error\" \nng-show=\"vm.salesForm.status.$touched || vm.salesForm.status.length\" \nerrors-to-watch=\"[\n                          {\n                            name: \'required\',\n                            translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n                          }\n                        ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div ng-if=\"vm.generalIsOpen\" flex=\"100\" \nclass=\"mt-18 notes-row\"><fc-textarea is-disabled=\"$root.loadingProgress\" label=\"Informações complementares\" \nng-model=\"vm.viewModel.form.notes\" input-name=\"notes\" \nclass=\"ng-pristine ng-valid md-input ng-empty ng-valid-md-maxlength ng-touched textarea\" \ninput-control=\"salesForm.notes\" max-length=\"300\" \nerrors-to-watch=\"[\n                        {\n                          name: \'maxlength\',\n                          translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.MAX_LENGTH\',\n                          translateValues: { expectedLength: 300, receivedLength: salesForm.notes.length }\n                        },\n                      ]\">\n</fc-textarea></div></div><div class=\"products-services\"><div class=\"general-title-row\" \nng-click=\"vm.colapseSection(\'services\')\"><p class=\"general-info-text\">\nServiços realizados ({{vm.viewModel.services.length }})</p><i class=\"18 arrow icon-arrow\" \nng-class=\"{\'icon-chevron-down\': vm.servicesIsOpen, \'icon-chevron-up\': !vm.servicesIsOpen}\"></i></div><div \nng-if=\"vm.servicesIsOpen\" layout=\"row\" layout-align=\"center\"><div layout=\"column\" class=\"sale-items-table-container\">\n<div layout=\"column\" class=\"sale-items-table-body\" ng-repeat=\"item in vm.viewModel.services track by $index\"><div \nlayout=\"row\" layout-padding layout-align=\"space-between\" flex=\"100\"><div class=\"product-width item-width item-name\">\n<div flex=\"100\" class=\"status-container\"><fc-autocomplete name=\"itemServiceAutoComplete{{$index}}\" md-autofocus flex \nrequired input-name=\"itemServiceAutoComplete{{$index}}\" label=\"Item\" is-required=\"true\" debounce=\"500\" \nmd-no-cache=\"true\" class=\"md-autocomplete-input-item\" input-control=\"salesForm[\'itemServiceAutoComplete\' + $index]\" \nng-model=\"item.obj\" track-by=\"name\" options=\"vm.viewModel.probableServices\" search-term=\"vm.searchServicetext[$index]\" \nclick-to-remove=\"true\" ng-change=\"vm.viewModel.itemHasSelected(item)\" \nsearch-function=\"vm.viewModel.searchItem(vm.searchServicetext[$index], \'service\');\" \nerrors-to-watch=\"[\n                                      {\n                                        name: \'required\',\n                                        translate: \'Campo obrigatório\'\n                                      },\n                                    ]\">\n</fc-autocomplete></div></div><div class=\"qtd-width item-width\"><div flex=\"100\" class=\"fc-input\"><input type=\"number\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" min=\"0.01\" ng-disabled=\"false\" \nid=\"itemServiceQtd{{$index}}\" name=\"itemServiceQtd{{$index}}\" aria-label=\"Qtd\" \nng-change=\"vm.viewModel.itemHasChanged();\" ng-model=\"item.qtd\" \nng-class=\"{\n                                  invalid: (salesForm[\'itemServiceQtd\' + $index].$touched || vm.verifyItemInclude(item)) && salesForm[\'itemServiceQtd\' + $index].$error && (salesForm[\'itemServiceQtd\' + $index].$error.min || salesForm[\'itemServiceQtd\' + $index].$error.required)\n                                }\" \nng-required=\"true\"><label class=\"fc-input__label\">Quantidade</label><fc-error \nng-show=\"salesForm[\'itemServiceQtd\' + $index].$touched || vm.verifyItemInclude(item)\" \ninput-errors=\"salesForm[\'itemServiceQtd\' + $index].$error\" \nerrors-to-watch=\"[\n                                      {\n                                        name: \'min\',\n                                        translate: \'Valor deve ser maior que 0\'\n                                      },\n                                      {\n                                        name: \'required\',\n                                        translate: \'Campo obrigatório\'\n                                      }\n                                  ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div class=\"value-width item-width\"><div flex=\"100\" \nclass=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" min=\"0.01\" \nng-disabled=\"false\" id=\"itemServiceValue{{$index}}\" name=\"itemServiceValue{{$index}}\" aria-label=\"Discount value\" \nng-model=\"item.value\" ng-change=\"vm.viewModel.itemHasChanged();\" \nng-class=\"{\n                                  invalid: (salesForm[\'itemServiceValue\' + $index].$touched || vm.verifyItemInclude(item)) && salesForm[\'itemServiceValue\' + $index].$error && (salesForm[\'itemServiceValue\' + $index].$error.min || salesForm[\'itemServiceValue\' + $index].$error.required)\n                                }\" \nng-required=\"true\" ui-money-mask><label class=\"fc-input__label\">Valor</label><fc-error \nng-show=\"salesForm[\'itemServiceValue\' + $index].$touched || vm.verifyItemInclude(item)\" \ninput-errors=\"salesForm[\'itemServiceValue\' + $index].$error\" \nerrors-to-watch=\"[\n                                      {\n                                        name: \'min\',\n                                        translate: \'Valor deve ser maior que 0\'\n                                      },\n                                      {\n                                        name: \'required\',\n                                        translate: \'Campo obrigatório\'\n                                      },\n                                  ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div class=\"subtotal-width item-width\"><div flex=\"100\" \nclass=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" ng-disabled=\"false\" \nid=\"itemServiceTotal{{$index}}\" name=\"itemServiceTotal{{$index}}\" aria-label=\"Total value\" \nng-value=\"item.total = item.qtd * item.value || \'0,00\'\" ng-model=\"item.total\" \nng-change=\"vm.viewModel.itemHasChanged();\" ng-readonly=\"true\" \nng-class=\"{\n                                  invalid: (salesForm[\'itemServiceTotal\' + $index].$touched || vm.verifyItemInclude(item)) && salesForm[\'itemServiceTotal\' + $index].$error && salesForm[\'itemServiceTotal\' + $index].$error.required\n                                }\" \nng-required=\"true\" ui-money-mask><label class=\"fc-input__label\">Total</label><fc-error \nng-show=\"salesForm[\'itemServiceTotal\' + $index].$touched || vm.verifyItemInclude(item)\" \ninput-errors=\"salesForm[\'itemServiceTotal\' + $index].$error\" \nerrors-to-watch=\"[\n                                      {\n                                        name: \'required\',\n                                        translate: \'Campo obrigatório\'\n                                      },\n                                  ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div class=\"ca-action-width item-width\"><md-input-container\n class=\"trash-icon\"><button aria-label=\"Close\" ng-if=\"vm.viewModel.form.items.length !== 1\" \nng-click=\"vm.viewModel.removeItem($index, \'services\')\"><img src=\"assets/icons/trash.svg\"></button> <button \ndisabled=\"true\" ng-if=\"vm.viewModel.form.items.length === 1\"><img src=\"assets/icons/trash-disabled.svg\"></button>\n<md-tooltip ng-if=\"vm.viewModel.form.items.length === 1\" md-direction=\"left\"><span>Precisa ter pelo menos um item\n</span></md-tooltip></md-input-container></div></div><div class=\"description-width item-width\"><fc-textarea \nis-disabled=\"$root.loadingProgress\" label=\"Descrição\" ng-model=\"vm.viewModel.services[$index].description\" \ninput-name=\"itemServiceDescription{{$index}}\" \nclass=\"ng-pristine ng-valid md-input ng-empty ng-valid-md-maxlength ng-touched textarea\" \ninput-control=\"salesForm[\'itemServiceDescription\' + $index]\" max-length=\"500\" \nerrors-to-watch=\"[\n                          {\n                            name: \'maxlength\',\n                            translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.MAX_LENGTH\',\n                            translateValues: { expectedLength: 500, receivedLength: vm.viewModel.services[$index].description.length }\n                          },\n                        ]\">\n</fc-textarea></div></div></div></div><div flex=\"100\" class=\"ca-item-add-row\" ng-if=\"vm.servicesIsOpen\"><md-button \nclass=\"add-button\" ng-click=\"vm.addItem(\'service\');\">adicionar serviço</md-button></div></div><div \nclass=\"products-services\"><div class=\"general-title-row\" ng-click=\"vm.colapseSection(\'products\')\"><p \nclass=\"general-info-text\">Produtos utilizados ({{vm.viewModel.products.length }})</p><i class=\"18 arrow icon-arrow\" \nng-class=\"{\'icon-chevron-down\': vm.productsIsOpen, \'icon-chevron-up\': !vm.productsIsOpen}\"></i></div><div \nng-if=\"vm.productsIsOpen\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nclass=\"sale-items-table-container\"><div layout=\"column\" class=\"sale-items-table-body\" \nng-repeat=\"item in vm.viewModel.products track by $index\"><div layout=\"row\" layout-padding \nlayout-align=\"space-between\" flex=\"100\"><div class=\"product-width item-width item-name\"><div flex=\"100\" \nclass=\"status-container\"><fc-autocomplete name=\"itemProductAutoComplete{{$index}}\" md-autofocus flex required \ninput-name=\"itemProductAutoComplete{{$index}}\" label=\"Item\" is-required=\"true\" debounce=\"500\" md-no-cache=\"true\" \nclass=\"md-autocomplete-input-item\" input-control=\"salesForm[\'itemProductAutoComplete\' + $index]\" ng-model=\"item.obj\" \ntrack-by=\"name\" options=\"vm.viewModel.probableProducts\" search-term=\"vm.searchProducttext[$index]\" \nclick-to-remove=\"true\" ng-change=\"vm.viewModel.itemHasSelected(item)\" \nsearch-function=\"vm.viewModel.searchItem(vm.searchProducttext[$index], \'product\');\" \nerrors-to-watch=\"[\n                                    {\n                                      name: \'required\',\n                                      translate: \'Campo obrigatório\'\n                                    },\n                                  ]\">\n</fc-autocomplete></div></div><div class=\"qtd-width item-width\"><div flex=\"100\" class=\"fc-input\"><input type=\"number\" \nplaceholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" min=\"0.01\" ng-disabled=\"false\" \nid=\"itemProductQtd{{$index}}\" name=\"itemProductQtd{{$index}}\" aria-label=\"Qtd\" \nng-change=\"vm.viewModel.itemHasChanged();\" ng-model=\"item.qtd\" \nng-class=\"{\n                                  invalid: (salesForm[\'itemProductQtd\' + $index].$touched || vm.verifyItemInclude(item)) && salesForm[\'itemProductQtd\' + $index].$error && (salesForm[\'itemProductQtd\' + $index].$error.min || salesForm[\'itemProductQtd\' + $index].$error.required)\n                                }\" \nng-required=\"true\"><label class=\"fc-input__label\">Quantidade</label><fc-error \nng-show=\"salesForm[\'itemProductQtd\' + $index].$touched || vm.verifyItemInclude(item)\" \ninput-errors=\"salesForm[\'itemProductQtd\' + $index].$error\" \nerrors-to-watch=\"[\n                                      {\n                                        name: \'min\',\n                                        translate: \'Valor deve ser maior que 0\'\n                                      },\n                                      {\n                                        name: \'required\',\n                                        translate: \'Campo obrigatório\'\n                                      }\n                                  ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div class=\"value-width item-width\"><div flex=\"100\" \nclass=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" min=\"0.01\" \nng-disabled=\"false\" id=\"itemProductValue{{$index}}\" name=\"itemProductValue{{$index}}\" aria-label=\"Discount value\" \nng-model=\"item.value\" ng-change=\"vm.viewModel.itemHasChanged();\" \nng-class=\"{\n                                  invalid: (salesForm[\'itemProductValue\' + $index].$touched || vm.verifyItemInclude(item)) && salesForm[\'itemProductValue\' + $index].$error && (salesForm[\'itemProductValue\' + $index].$error.min || salesForm[\'itemProductValue\' + $index].$error.required)\n                                }\" \nng-required=\"true\" ui-money-mask><label class=\"fc-input__label\">Valor</label><fc-error \nng-show=\"salesForm[\'itemProductValue\' + $index].$touched || vm.verifyItemInclude(item)\" \ninput-errors=\"salesForm[\'itemProductValue\' + $index].$error\" \nerrors-to-watch=\"[\n                                      {\n                                        name: \'min\',\n                                        translate: \'Valor deve ser maior que 0\'\n                                      },\n                                      {\n                                        name: \'required\',\n                                        translate: \'Campo obrigatório\'\n                                      },\n                                  ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div class=\"subtotal-width item-width\"><div flex=\"100\" \nclass=\"fc-input\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" class=\"fc-input__input\" ng-disabled=\"false\" \nid=\"itemProductTotal{{$index}}\" name=\"itemProductTotal{{$index}}\" aria-label=\"Total value\" \nng-value=\"item.total = item.qtd * item.value || \'0,00\'\" ng-model=\"item.total\" \nng-change=\"vm.viewModel.itemHasChanged();\" ng-readonly=\"true\" \nng-class=\"{\n                                    invalid: (salesForm[\'itemProductTotal\' + $index].$touched || vm.verifyItemInclude(item)) && salesForm[\'itemProductTotal\' + $index].$error && salesForm[\'itemProductTotal\' + $index].$error.required\n                                  }\" \nng-required=\"true\" ui-money-mask><label class=\"fc-input__label\">Total</label><fc-error \nng-show=\"salesForm[\'itemProductTotal\' + $index].$touched || vm.verifyItemInclude(item)\" \ninput-errors=\"salesForm[\'itemProductTotal\' + $index].$error\" \nerrors-to-watch=\"[\n                                        {\n                                          name: \'required\',\n                                          translate: \'Campo obrigatório\'\n                                        },\n                                    ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div class=\"ca-action-width item-width\"><md-input-container\n class=\"trash-icon\"><button aria-label=\"Close\" ng-if=\"vm.viewModel.form.items.length !== 1\" \nng-click=\"vm.viewModel.removeItem($index, \'products\')\"><img src=\"assets/icons/trash.svg\"></button> <button \ndisabled=\"true\" ng-if=\"vm.viewModel.form.items.length === 1\"><img src=\"assets/icons/trash-disabled.svg\"></button>\n<md-tooltip ng-if=\"vm.viewModel.form.items.length === 1\" md-direction=\"left\"><span>Precisa ter pelo menos um item\n</span></md-tooltip></md-input-container></div></div><div class=\"description-width item-width\"><fc-textarea \nis-disabled=\"$root.loadingProgress\" label=\"Descrição\" \nclass=\"ng-pristine ng-valid md-input ng-empty ng-valid-md-maxlength ng-touched textarea\" \ninput-name=\"itemServiceDescription{{$index}}\" ng-model=\"vm.viewModel.products[$index].description\" \ninput-control=\"salesForm[\'itemServiceDescription\' + $index]\" max-length=\"500\" \nerrors-to-watch=\"[\n                          {\n                            name: \'maxlength\',\n                            translate: \'LOCATIONS.DIALOG.NEW.VALIDATION_ERRORS.MAX_LENGTH\',\n                            translateValues: { expectedLength: 500, receivedLength: vm.viewModel.products[$index].description.length }\n                          },\n                        ]\">\n</fc-textarea></div></div></div></div><div flex=\"100\" class=\"ca-item-add-row\" ng-if=\"vm.productsIsOpen\"><md-button \nclass=\"add-button\" ng-click=\"vm.addItem(\'product\');\">adicionar produto</md-button></div></div><div \nclass=\"general-information discount-full\"><div class=\"discount-title-row\"><p class=\"general-info-text\">Descontos</p>\n</div><div layout=\"row\" class=\"subtotal-row\"><div layout=\"row\" class=\"discount-container\"><div flex=\"45\" \nclass=\"fc-input discount-type\"><fc-select label=\"Tipo\" ng-model=\"vm.viewModel.form.discount.type\" \noptions=\"vm.typeOptions\" is-required=\"true\" data-cy=\"sales-types\" input-name=\"types\" \nng-change=\"vm.viewModel.itemHasChanged();\" input-control=\"vm.salesForm.types\" is-disabled=\"$root.loadingProgress\" \nclass=\"type-selector\"></fc-select></div><div class=\"fc-input discount-type disc-field\" \nng-if=\"vm.viewModel.form.discount.type == \'0\'\"><input type=\"text\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" min=\"0\" max=\"10000000000000000000000000000000000000\" ng-disabled=\"false\" id=\"valueDiscount\" \nname=\"valueDiscount\" aria-label=\"Discount value\" ng-model=\"vm.viewModel.form.discount.value\" \nng-change=\"vm.viewModel.itemHasChanged();\" \nng-class=\"{\n                                    invalid: salesForm.valueDiscount.$touched && salesForm.valueDiscount.$error && (salesForm.valueDiscount.$error.min || salesForm.valueDiscount.$error.required || salesForm.valueDiscount.$error.max)\n                                  }\" \nng-required=\"false\" ui-money-mask><label class=\"fc-input__label\">Desconto</label><fc-error \nng-show=\"salesForm.valueDiscount.$touched\" input-errors=\"salesForm.valueDiscount.$error\" \nerrors-to-watch=\"[\n                                        {\n                                          name: \'min\',\n                                          translate: \'Valor deve ser maior que 0\'\n                                        },\n                                        {\n                                          name: \'required\',\n                                          translate: \'Campo obrigatório\'\n                                        },\n                                        {\n                                          name: \'max\',\n                                          translate: \'Valor acima do limite\'\n                                        },\n                                    ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div class=\"fc-input discount-type disc-field\" \nng-if=\"vm.viewModel.form.discount.type == \'1\'\"><input type=\"number\" placeholder=\" \" autocomplete=\"off\" \nclass=\"fc-input__input\" max=\"100\" min=\"0.01\" ng-disabled=\"false\" id=\"percentDiscount\" name=\"percentDiscount\" \nng-model=\"vm.viewModel.form.discount.value\" ng-change=\"vm.viewModel.itemHasChanged();\" \nng-class=\"{\n                                    invalid: salesForm.percentDiscount.$touched && salesForm.percentDiscount.$error && (salesForm.percentDiscount.$error.min || salesForm.percentDiscount.$error.required || salesForm.percentDiscount.$error.max)\n                                  }\" \nng-required=\"true\"><label class=\"fc-input__label\">Desconto</label><fc-error \nng-show=\"salesForm.percentDiscount.$touched\" input-errors=\"salesForm.percentDiscount.$error\" \nerrors-to-watch=\"[\n                                      {\n                                        name: \'min\',\n                                        translate: \'Valor deve ser maior que 0%\'\n                                      },\n                                      {\n                                        name: \'required\',\n                                        translate: \'Campo obrigatório\'\n                                      },\n                                      {\n                                        name: \'max\',\n                                        translate: \'Valor não pode ser acima de 100%\'\n                                      },\n                                  ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"discount-container-values\"><div flex=\"2\" class=\"fc-input discount-type discounter-field\"><p \nclass=\"top-label-text\">Subtotal(R$)</p><p class=\"value-label-text\" \nng-class=\"{\'triple-values\': vm.viewModel.form.discount.value}\">{{ vm.viewModel.form.subTotal | currencyFormat }}</p>\n</div><div flex=\"2\" class=\"fc-input discount-type discounter-field\" ng-if=\"vm.viewModel.form.discount.value\"><p \nclass=\"top-label-text\">Desconto</p><p class=\"value-label-text red-color\" \nng-class=\"{\'triple-values\': vm.viewModel.form.discount.value}\">{{ vm.viewModel.discount | currencyFormat }}</p></div>\n<div flex=\"2\" class=\"fc-input discount-type discounter-field\"><p class=\"top-label-text\">Total(R$)</p><p \nclass=\"value-label-text blue-color\" ng-class=\"{\'triple-values\': vm.viewModel.form.discount.value}\">\n{{ vm.viewModel.form.total | currencyFormat }}</p></div></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-accent md-raised\" \nng-disabled=\"!vm.viewModel.form.customer || vm.sendingTask || !vm.viewModel.form.items.length || salesForm.$invalid\" \nng-click=\"vm.sendTask()\">Enviar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/control-panel/views/list/views/classic/list/list.html","<div class=\"no-threads\" ng-if=\"vm.data.tasks.length === 0 && vm.currentTasks.length === 0 && vm.loadingList === false\">\n<span translate=\"CONTROL_PANEL.VIEWS.LIST.NO_TASK_REGISTERED_DAY\" \ntranslate-values=\"{ selectedDate: (vm.selectedDate|date: vm.dateFormat) }\">\nNo task registered for {{(vm.selectedDate|date: vm.dateFormat)}}.</span></div><div class=\"no-threads\" \nng-if=\"vm.data.tasks.length > 0 && vm.currentTasks.length === 0 && vm.loadingList === false\"><span \ndata-cy=\"no-task-registred\" translate=\"CONTROL_PANEL.VIEWS.LIST.NO_TASK_REGISTERED_FILTERS\">\nNo task registered with selected filters, clear the filters by clicking the button</span><md-button \nclass=\"md-icon-button md-accent md-mini button-white-bg\" ng-click=\"vm.clearFilters()\" \naria-label=\"{{\'CONTROL_PANEL.VIEWS.LIST.CLEAR_FILTERS\' | translate}}\"><md-icon md-font-icon=\"icon-filter-remove\">\n</md-icon><md-tooltip><span translate=\"CONTROL_PANEL.VIEWS.LIST.CLEAR_FILTERS\">Clear filters</span></md-tooltip>\n</md-button><span translate=\"CONTROL_PANEL.VIEWS.LIST.DAYS_TASKS\" \ntranslate-values=\"{ selectedDate: (vm.selectedDate|date: vm.dateFormat) }\">\nto view the {{(vm.selectedDate|date: vm.dateFormat)}} task for the day.</span></div><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingList === true\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.LOADING_TASKS\">Loading tasks ...</div></div><div data-cy=\"task\" class=\"thread\" \nmd-ink-ripple ng-repeat=\"task in vm.currentTasks\" ng-click=\"vm.openTask(task, $event)\" \nng-class=\"{\'selected\': vm.isSelected(task)}\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isSelected(task)\" ng-click=\"vm.toggleSelectThread(task, $event)\" \naria-label=\"{{vm.isSelected(task) ? (\'CONTROL_PANEL.VIEWS.LIST.ACTIONS.DESELECT\' | translate) : (\'CONTROL_PANEL.VIEWS.LIST.ACTIONS.SELECT\' | translate)}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"avatar\" style=\"background: {{vm.getStatusTask(task).color}}\"><md-icon class=\"s20\" \nmd-font-icon=\"{{vm.getStatusTask(task).icon}}\" style=\"color: white; margin-top: -1px\"><md-tooltip md-direction=\"top\">\n{{vm.getStatusTask(task).description}}</md-tooltip></md-icon></div><span class=\"text-truncate\" \nng-class=\"{ \'archived-task\': task.archived }\"><span style=\"color:grey\">{{task.order.identifier}}</span>\n {{task.order.customer.name}}</span><div style=\"font-size: 13px;font-weight:400;margin-left: 7px\"><div \nng-if=\"task.rating.stars\"><md-tooltip md-direction=\"right\">{{task.rating.comments}}</md-tooltip><i \nstyle=\"color: {{card.color}}\" ng-class=\"task.rating.stars >= 1 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20\">\n</i> <i style=\"color: {{card.color}}\" ng-class=\"task.rating.stars >= 2 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20\"></i> <i style=\"color: {{card.color}}\" \nng-class=\"task.rating.stars >= 3 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20\"></i> <i \nstyle=\"color: {{card.color}}\" ng-class=\"task.rating.stars >= 4 ? \'icon-star\' : \'icon-star-outline\'\" class=\"icon s20\">\n</i> <i style=\"color: {{card.color}}\" ng-class=\"task.rating.stars >= 5 ? \'icon-star\' : \'icon-star-outline\'\" \nclass=\"icon s20\"></i></div><span ng-if=\"task.archived\" class=\"status-label md-red-900-bg\" \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.TASK.ARCHIVED\">Archived</span></div></div><div \nng-class=\"{ \'archived-task\': task.archived }\"><i class=\"icon icon-tag s15\"></i>\n {{task.order.service.description | maxLength:55}} • <img ng-if=\"task.employee.id\" class=\"avatar\" \nstyle=\"width: 15px;min-width: 15px;height: 15px;min-height: 15px;margin-right: 0px\" alt=\"{{task.employee.name}}\" \nng-src=\"{{vm.getEmployeeAvatarUrl(task.employee)}}\"> <i ng-if=\"!task.employee.id\" class=\"icon icon-account-remove s15\">\n</i> <span ng-if=\"task.employee.id\">{{task.employee.name}}</span> <span ng-if=\"!task.employee.id\" \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.NO_EMPLOYEE\">No employee </span>• <i class=\"icon icon-map-marker s15\"></i> <span \nstyle=\"color:rgba(0,0,0,0.54)\" ng-if=\"task.order.location && (task.order.location.name !== task.order.customer.name)\">\n<strong>{{task.order.location.name}} -</strong> </span>\n{{task.order.address.street}}, {{task.order.address.number}} - {{task.order.address.zipCode}}</div><div \nclass=\"message text-truncate\" ng-class=\"{ \'archived-task\': task.archived }\">{{task.order.description}}&nbsp;<div \nclass=\"labels\"><div class=\"label\" ng-repeat=\"label in task.order.labels | orderBy:\'name\'\" \nng-class=\"\'md-\'+label.color+\'-bg\'\">{{label.name}}</div></div></div><div class=\"message text-truncate\" \nng-if=\"task.statusDescription && task.status !== \'scheduled\'\"><span style=\"color: {{vm.getStatusTask(task).color}}\">\n{{ task.statusDescription | htmlToPlaintext | limitTo:180}}{{task.statusDescription.length > 180 ? \'...\' : \'\'}}</span>\n</div></div><div layout=\"column\" layout-align=\"space-between end\"><div ng-if=\"task.scheduling.estimation\" class=\"time\">\n{{task.scheduling.estimation.startTask | date: vm.timeFormat}} - {{task.scheduling.estimation.completeTask | date: vm.timeFormat}}\n</div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-menu md-position-mode=\"target-right target\">\n<md-button class=\"md-icon-button\" aria-label=\"Mais\" translate><md-icon md-font-icon=\"icon-dots-horizontal\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.printTask(task);\" aria-label=\"{{\'CONTROL_PANEL.VIEWS.LIST.ACTIONS.PRINT\' | translate}}\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><span translate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.PRINT\">Print</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"task.archived === false;\"><md-button ng-if=\"vm.editPermission\" \nng-click=\"vm.archiveTask(task);\" aria-label=\"{{\'CONTROL_PANEL.VIEWS.LIST.ACTIONS.ARCHIVE\' | translate}}\"><md-icon \nmd-font-icon=\"icon-folder-download\"></md-icon><span translate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.ARCHIVE\">Archive</span>\n</md-button><md-button ng-if=\"!vm.editPermission\" \naria-label=\"{{\'CONTROL_PANEL.VIEWS.LIST.ACTIONS.ARCHIVE\' | translate}}\" class=\"no-action-permission\"><md-icon \nmd-font-icon=\"icon-folder-download\"></md-icon><span translate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.ARCHIVE\">Archive</span>\n<md-tooltip><span translate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.NO_PERMISSION_WARN\"></span>\n</md-tooltip></md-button></md-menu-item><md-menu-item ng-if=\"task.archived === true;\"><md-button \nng-if=\"vm.editPermission\" ng-click=\"vm.unarchiveTask(task);\" \naria-label=\"{{\'CONTROL_PANEL.VIEWS.LIST.ACTIONS.UNARCHIVE\' | translate}}\"><md-icon md-font-icon=\"icon-folder-upload\">\n</md-icon><span translate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.UNARCHIVE\">Unarchive</span></md-button><md-button \nng-if=\"!vm.editPermission\" aria-label=\"{{\'CONTROL_PANEL.VIEWS.LIST.ACTIONS.UNARCHIVE\' | translate}}\" \nclass=\"no-action-permission\"><md-icon md-font-icon=\"icon-folder-upload\"></md-icon><span \ntranslate=\"CONTROL_PANEL.VIEWS.LIST.ACTIONS.UNARCHIVE\">Unarchive</span><md-tooltip><span \ntranslate=\"TASKS.DIALOG.TABS.EQUIPMENTS.FORMS_EQUIPMENT.BUTTON_OPTIONS.NO_PERMISSION_WARN\"></span>Unarchive\n</md-tooltip></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>");
$templateCache.put("app/core/integrations/core/customers/dialogs/import/automatic/confirm/customers-import-automatic-confirm-dialog.html","<md-dialog><md-content class=\"customers-import-automatic-confirm-dialog\"><h2><b \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT\">Customer automatic importation</b></h2><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_1\" \ntranslate-values=\"{ appName: vm.appName, totalCustomerToImport: vm.totalCustomerToImport }\">\nThis process will import all <b>{{ vm.totalCustomerToImport }} customers </b>who are registered with <b>\n{{ vm.appName }}</b></span><br><br><span translate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_2\">\n- Customers that do <b>not exist</b> in Field Control <b>will be created</b></span><br><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_3\">- Customers <b>existing</b>\n in Field Control <b>will be updated</b></span><br><br><span \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_4\">\nThe process may take a few minutes according to the number of customers you have, do not close the window until the process is finished\n</span><br><br><div layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.closeDialog();\" \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_CANCEL\">Cancel</md-button><md-button \nng-click=\"vm.startImport();\" translate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_START\">Start import\n</md-button></div></md-content></md-dialog>");
$templateCache.put("app/core/integrations/core/customers/dialogs/import/automatic/import-modal/import-customers-modal.html","<div><p class=\"fc-modal__content\">{{vm.variables.title}}</p><div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{ vm.variables.progressPercentage }}\"></md-progress-linear><div layout=\"column\" layout-align=\"flex-end\"><p \nclass=\"fs-16 flex-end\">{{ vm.variables.totalProductsImported || \'0\' }} <span \ntranslate=\"CUSTOMERS.INTEGRATIONS.CUSTOMERS_AUTOMATIC_IMPORT_FROM\">from</span> {{ vm.variables.totalProductsToImport }}\n</p></div></div></div>");
$templateCache.put("app/core/integrations/core/quotations/dialogs/export/omie/errors/omie-errors-dialog.html","<md-dialog draggable class=\"form-dialog omie-errors-dialog\" aria-label=\"Integration\"><md-toolbar class=\"md-accent\"><div\n class=\"md-toolbar-tools align-vertical align-vertical-middle\"><span class=\"fs-17 bold\" \ntranslate=\"INTEGRATIONS.QUOTATIONS.ERROR_LOADING_DATA\">Error loading data </span><span flex></span> <span flex></span>\n<md-button class=\"md-icon-button margin-top-0\" ng-click=\"vm.closeDialog();\" aria-label=\"Close Dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div ng-if=\"vm.data\">\n<div ng-if=\"!vm.data.customers\"><span translate=\"INTEGRATIONS.QUOTATIONS.ERROR_INEXISTENT_RESOURCE\">\nIt was not possible to identify all your customer data, either on Field Control, or Omie. Confirm that your customer has street address , number., City, company registry number, and try again.\n</span></div><div \nng-if=\"vm.data.customers && !vm.data.servicesLinkedToQuotation.length && !vm.data.productsLinkedToQuotation.length\">\n<span translate=\"INTEGRATIONS.QUOTATIONS.ERROR_NO_PRODUCTS_OR_SERVICES\">\nNo products or services linked to the quotation were found in Omie.</span></div></div><div ng-if=\"vm.error\"><div \nng-if=\"vm.isKeyError()\"><span translate=\"INTEGRATIONS.QUOTATIONS.ERROR_KEY\">\nYour key is invalid or the application has been suspended.</span></div><div ng-if=\"!vm.isKeyError()\"><span \ntranslate=\"INTEGRATIONS.QUOTATIONS.ERROR_UNKNOWN\">\nAn unknown error has occurred, please try again later or contact support.</span></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-click=\"vm.closeDialog()\" class=\"md-accent md-raised\">Ok</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/integrations/core/quotations/dialogs/export/omie/export/omie-quotations-export-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--small omie-quotation-export-dialog\" \naria-label=\"Integration\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools align-vertical align-vertical-middle\"><span class=\"dialog-title\" \ntranslate=\"INTEGRATIONS.QUOTATIONS.DIALOG.TITLE\">Send quotation to Omie </span><span flex></span> <span flex></span>\n<md-button class=\"md-icon-button margin-top-0\" ng-click=\"vm.closeDialog();\" aria-label=\"Close Dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"omieExportQuotationForm\" \nclass=\"md-inline-form\" novalidate><md-dialog-content class=\"omie-export-content\" ms-scroll><div \nclass=\"omie-export-content__title\" translate=\"INTEGRATIONS.QUOTATIONS.DIALOG.QUOTATION_DATA\">Quotation data</div><div \nclass=\"omie-export-content__first-line-container\"><div class=\"omie-export-content__second-line-container__city\">\n<fc-select class=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{(\'INTEGRATIONS.QUOTATIONS.SELECT_CUSTOMER\' | translate)}}\" options=\"vm.viewModel.customers\" \nng-model=\"vm.viewModel.selectedCustomer\" input-name=\"customer\" input-control=\"omieExportQuotationForm.customer\" \nis-required=\"true\"></fc-select><div ng-if=\"vm.viewModel.customers && vm.viewModel.customers.length > 1\" \nclass=\"omie-export-content__mutiple-customers-warn fc-warning-container\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span \ntranslate=\"INTEGRATIONS.QUOTATIONS.MULTIPLE_MATCHING_CUSTOMERS\"></span></div></div><div \nclass=\"omie-export-content__first-line-container__category\"><fc-select \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{ \'INTEGRATIONS.QUOTATIONS.CATEGORY\' | translate }}\" options=\"vm.viewModel.categories\" \nng-model=\"vm.viewModel.form.category.descricao\" input-name=\"category\" input-control=\"omieExportQuotationForm.category\" \nis-required=\"true\"></fc-select></div><div \nclass=\"omie-export-content__first-line-container__sales-forecast fc-datepicker\"><label class=\"fc-datepicker__label\" \ntranslate=\"INTEGRATIONS.QUOTATIONS.SALES_FORECAST\">Sales forecast *</label><div class=\"date-container\"><md-datepicker \nflex required class=\"p-0\" md-hide-icons=\"calendar\" md-min-date=\"vm.viewModel.oneYearAgo\" \nng-model=\"vm.viewModel.form.forecastDate\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker></div></div></div><div \nclass=\"omie-export-content__second-line-container\"><div class=\"omie-export-content__second-line-container__city\">\n<fc-autocomplete name=\"cityAutoComplete\" input-name=\"cityAutoComplete\" \nlabel=\"{{(\'INTEGRATIONS.QUOTATIONS.CITY_SERVICE\' | translate)}}\" is-required=\"true\" debounce=\"500\" \ninput-control=\"omieExportQuotationForm.cityAutoComplete\" ng-model=\"vm.viewModel.form.city\" \noptions=\"vm.viewModel.cities\" track-by=\"cCod\" click-to-remove=\"true\" search-term=\"vm.viewModel.searchCityText\" \nsearch-function=\"vm.search(vm.viewModel.searchCityText, \'City\')\" \nerrors-to-watch=\"[\n            {\n              name: \'required\',\n              translate: \'INTEGRATIONS.QUOTATIONS.REQUIRED\'\n            },\n          ]\">\n</fc-autocomplete></div><div class=\"omie-export-content__second-line-container__bank-account\"><fc-select \nclass=\"fc-select__select--without-border\" label=\"{{ \'INTEGRATIONS.QUOTATIONS.BANK_ACCOUNT\' | translate }}\" \noptions=\"vm.viewModel.bankAccounts\" ng-model=\"vm.viewModel.form.bankAccount\" input-name=\"bankAccount\" \ninput-control=\"omieExportQuotationForm.bankAccount\" is-required=\"true\"></fc-select></div><div \nclass=\"omie-export-content__second-line-container__installment\"><fc-select \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{ \'INTEGRATIONS.QUOTATIONS.INSTALLMENTS\' | translate }}\" options=\"vm.viewModel.installments\" \nng-model=\"vm.viewModel.form.installment\" input-name=\"installment\" input-control=\"omieExportQuotationForm.installment\" \nis-required=\"true\" limit=\"100\" search-function=\"vm.searchInstallmentText()\" \nsearch-phrase=\"{{(\'INTEGRATIONS.QUOTATIONS.INSTALLMENTS\' | translate)}}\" with-search=\"true\"></fc-select></div><div \nclass=\"omie-export-content__second-line-container__seller\"><fc-select \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{ \'INTEGRATIONS.QUOTATIONS.SELLER\' | translate }}\" options=\"vm.viewModel.sellers\" \nng-model=\"vm.viewModel.form.seller\" is-disabled=\"vm.duplicateOsMethod === \'update\'\" input-name=\"seller\" \ninput-control=\"omieExportQuotationForm.seller\" is-required=\"true\" limit=\"100\" search-function=\"vm.searchSellerText()\" \nsearch-phrase=\"{{ \'INTEGRATIONS.QUOTATIONS.SELLER\' | translate }}\" with-search=\"true\"></fc-select><md-tooltip \nng-if=\"vm.duplicateOsMethod === \'update\'\" md-direction=\"bottom\"><span \ntranslate=\"INTEGRATIONS.QUOTATIONS.SELLER_NOT_EDITABLE\">Seller cannot be changed for an existing quotation.</span>\n</md-tooltip></div></div><details class=\"collapsible\" ng-if=\"vm.viewModel.form.services.length\"><summary>\n{{ \"INTEGRATIONS.QUOTATIONS.SERVICES_PERFORMED\" | translate }} ({{vm.viewModel.form.services.length}})</summary>\n<banner-component-provider class=\"omie-export-content__banner\" icon=\"info\" \ntext=\"Ao exportar esse orçamento para o Omie, será criada uma Ordem de Serviço como o mesmo identificador da OS (caso exista) vinculada ao orçamento e com os serviços selecionados.\">\n</banner-component-provider><div class=\"omie-export-content__services-container\" \nng-repeat=\"service in vm.viewModel.form.services track by $index\"><div \nclass=\"omie-export-content__services-container__service\"><fc-autocomplete name=\"serviceAutoComplete__{{$index}}\" \ninput-name=\"serviceAutoComplete__{{$index}}\" label=\"{{(\'INTEGRATIONS.QUOTATIONS.SERVICE\' | translate)}}\" \nis-required=\"true\" debounce=\"500\" min=\"0.01\" input-control=\"omieExportQuotationForm[\'serviceAutoComplete__\' + $index]\" \nng-model=\"service.obj\" track-by=\"displayName\" ng-change=\"vm.viewModel.serviceHasSelected(service)\" \noptions=\"vm.viewModel.services\" search-term=\"vm.viewModel.searchServiceTextArray[$index]\" click-to-remove=\"true\" \nsearch-function=\"vm.search(vm.viewModel.searchServiceTextArray[$index], \'Service\')\" \nerrors-to-watch=\"[{\n                name: \'required\',\n                translate: \'INTEGRATIONS.QUOTATIONS.REQUIRED\'\n              }]\">\n</fc-autocomplete></div><div class=\"fc-input omie-export-content__services-container__quantity\"><input type=\"number\" \nclass=\"fc-input__input\" placeholder=\" \" name=\"servicesQuantity__{{$index}}\" input-name=\"servicesQuantity__{{$index}}\" \ninput-control=\"omieExportQuotationForm[\'servicesQuantity__\' + $index]\" autocomplete=\"off\" ng-model=\"service.qtd\" \nng-change=\"vm.validateServiceDiscountValue($index)\" string-to-number min=\"0.1\" ng-required=\"true\" \nng-class=\"{\n                invalid: omieExportQuotationForm[\'servicesQuantity__\' + $index].$touched && omieExportQuotationForm[\'servicesQuantity__\' + $index].$invalid,\n              }\">\n<label class=\"fc-input__label\">{{(\"INTEGRATIONS.QUOTATIONS.QTY\" | translate)}}</label><fc-error \nng-show=\"omieExportQuotationForm[\'servicesQuantity__\' + $index].$touched\" \ninput-errors=\"omieExportQuotationForm[\'servicesQuantity__\' + $index].$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'min\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.ERRORS.MIN_UNIT_VALUE\'\n                },\n                {\n                  name: \'required\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.REQUIRED\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"fc-input omie-export-content__services-container__unit-value\"><input type=\"text\" class=\"fc-input__input\" \nplaceholder=\" \" name=\"unitValue__{{$index}}\" autocomplete=\"off\" ng-model=\"service.value\" ui-money-mask \nng-required=\"true\" min=\"0.01\" \nng-class=\"{\n                invalid: omieExportQuotationForm[\'unitValue__\' + $index].$touched && omieExportQuotationForm[\'unitValue__\' + $index].$invalid,\n              }\">\n<label class=\"fc-input__label\">{{(\'INTEGRATIONS.QUOTATIONS.UNIT_VALUE\' | translate)}}</label><fc-error \nng-show=\"omieExportQuotationForm[\'unitValue__\' + $index].$touched\" \ninput-errors=\"omieExportQuotationForm[\'unitValue__\' + $index].$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.REQUIRED\'\n                },\n                {\n                  name: \'min\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.ERRORS.MIN_UNIT_VALUE\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"fc-input omie-export-content__services-container__discount\"><div class=\"fc-input\"><input type=\"text\" \nclass=\"fc-input__input fc-input__input__discount\" ng-if=\"service.discount.type === \'value\'\" ui-money-mask \nplaceholder=\" \" name=\"serviceDiscountValue__{{$index}}\" input-name=\"serviceDiscountValue__{{$index}}\" \ninput-control=\"omieExportQuotationForm[\'serviceDiscountValue__\' + $index]\" ng-model=\"service.discount.value\" \nng-change=\"vm.validateServiceDiscountValue($index)\" \nng-class=\"{ invalid: omieExportQuotationForm[\'serviceDiscountValue__\' + $index].$touched && omieExportQuotationForm[\'serviceDiscountValue__\' + $index].$invalid }\">\n <input type=\"number\" class=\"fc-input__input fc-input__input__discount\" ng-if=\"service.discount.type === \'percentage\'\" \nng-change=\"vm.validateServiceDiscountValue($index)\" ng-model=\"service.discount.value\" placeholder=\" \" \nname=\"serviceDiscountValue__{{$index}}\" input-name=\"serviceDiscountValue__{{$index}}\" \ninput-control=\"omieExportQuotationForm[\'serviceDiscountValue__\' + $index]\" \nng-class=\"{ invalid: omieExportQuotationForm[\'serviceDiscountValue__\' + $index].$touched && omieExportQuotationForm[\'serviceDiscountValue__\' + $index].$invalid }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.DISCOUNT.LABEL\' | translate)}}</label><fc-error \nng-show=\"omieExportQuotationForm[\'serviceDiscountValue__\' + $index].$touched\" \ninput-errors=\"omieExportQuotationForm[\'serviceDiscountValue__\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'min\', translate: \'INTEGRATIONS.QUOTATIONS.ERRORS.MIN_UNIT_VALUE\'\n                  },\n                  {\n                    name: \'errorPercentageDiscount\', translate: \'INTEGRATIONS.QUOTATIONS.ERRORS.PERCENTAGE_DISCOUNT\'\n                  },\n                  {\n                    name: \'errorValueDiscount\', translate: \'INTEGRATIONS.QUOTATIONS.ERRORS.VALUE_DISCOUNT\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"omie-export-content__discount-container__discount-type\"><fc-select options=\"vm.discountTypes\" \nng-model=\"service.discount.type\" ng-change=\"vm.validateServiceDiscountValue($index)\" without-divider=\"true\">\n</fc-select></div></div><div class=\"fc-input omie-export-content__services-container__trash\"><button \nng-if=\"vm.viewModel.form.services.length !== 1\" ng-click=\"vm.viewModel.removeService($index)\"><img \nsrc=\"assets/icons/trash.svg\"></button> <button disabled=\"true\" ng-if=\"vm.viewModel.form.services.length === 1\"><img \nsrc=\"assets/icons/trash-disabled.svg\"></button><md-tooltip ng-if=\"vm.viewModel.form.services.length === 1\" \nmd-direction=\"left\"><span translate=\"INTEGRATIONS.QUOTATIONS.AT_LEAST_ONE_SERVICE\">At least 1 product to remove</span>\n</md-tooltip></div></div></details><details class=\"collapsible\" ng-if=\"vm.viewModel.form.products.length\"><summary>\n{{ \"INTEGRATIONS.QUOTATIONS.PRODUCTS.USED_PRODUCTS\" | translate }} ({{vm.viewModel.form.products.length}})</summary>\n<banner-component-provider class=\"omie-export-content__banner\" icon=\"info\" \ntext=\"Ao exportar esse orçamento para o Omie, você poderá enviar os produtos selecionados como orçamento ou pedido de venda\">\n</banner-component-provider><div class=\"omie-export-content__products-container\" \nng-repeat=\"product in vm.viewModel.form.products track by $index\"><div \nclass=\"omie-export-content__products-container__product\"><fc-autocomplete name=\"productsAutoComplete__{{$index}}\" \ninput-name=\"productsAutoComplete__{{$index}}\" label=\"{{(\'INTEGRATIONS.QUOTATIONS.PRODUCTS.PRODUCT\' | translate)}}\" \nis-required=\"true\" debounce=\"500\" ng-change=\"vm.viewModel.productHasSelected(product); vm.verifyProductsName()\" \ninput-control=\"omieExportQuotationForm[\'productsAutoComplete__\' + $index]\" ng-model=\"product.obj\" track-by=\"name\" \noptions=\"vm.viewModel.products\" search-term=\"vm.viewModel.searchProductTextArray[$index]\" \nsearch-function=\"vm.search(vm.viewModel.searchProductTextArray[$index], \'Product\')\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.REQUIRED\'\n                },\n                {\n                  name: \'uniqueProduct\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.UNIQUE_PRODUCT\'\n                }\n              ]\">\n</fc-autocomplete></div><div class=\"fc-input omie-export-content__products-container__measure\"><input type=\"text\" \nng-disabled=\"true\" class=\"fc-input__input\" placeholder=\" \" name=\"productMeasure\" input-name=\"productMeasure\" \ninput-control=\"omieExportQuotationForm.productMeasure\" autocomplete=\"off\" ng-model=\"product.measure\"><label \nclass=\"fc-input__label\">{{(\"INTEGRATIONS.QUOTATIONS.PRODUCTS.MEASURE\" | translate)}}</label><fc-error \nng-show=\"omieExportQuotationForm.productMeasure.$touched\" input-errors=\"omieExportQuotationForm.productMeasure.$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.REQUIRED\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"fc-input omie-export-content__products-container__quantity\"><input type=\"number\" class=\"fc-input__input\" \nplaceholder=\" \" name=\"productQuantity__{{$index}}\" input-name=\"productQuantity__{{$index}}\" \ninput-control=\"omieExportQuotationForm[\'productQuantity__\' + $index]\" autocomplete=\"off\" ng-model=\"product.quantity\" \nng-change=\"vm.validateProductDiscountValue($index)\" min=\"1\" ng-required=\"true\" \nng-class=\"{\n                invalid: omieExportQuotationForm[\'productQuantity__\' + $index].$touched && omieExportQuotationForm[\'productQuantity__\' + $index].$invalid,\n              }\">\n<label class=\"fc-input__label\">{{(\"INTEGRATIONS.QUOTATIONS.QTY\" | translate)}}</label><fc-error \nng-show=\"omieExportQuotationForm[\'productQuantity__\' + $index].$touched\" \ninput-errors=\"omieExportQuotationForm[\'productQuantity__\' + $index].$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'min\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.ERRORS.MIN_UNIT_VALUE\'\n                },\n                {\n                  name: \'required\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.REQUIRED\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"fc-input omie-export-content__products-container__unit-value\"><input type=\"text\" class=\"fc-input__input\" \nplaceholder=\" \" ng-disabled=\"true\" name=\"productUnitValue__{{$index}}\" autocomplete=\"off\" \nng-change=\"vm.viewModel.verifyProductsName()\" ng-model=\"product.value\" min=\"0.01\" ui-money-mask ng-required=\"true\" \nng-class=\"{\n                invalid: omieExportQuotationForm[\'productUnitValue__\' + $index].$touched && omieExportQuotationForm[\'productUnitValue__\' + $index].$invalid,\n              }\">\n<label class=\"fc-input__label\">{{(\'INTEGRATIONS.QUOTATIONS.UNIT_VALUE\' | translate)}}</label><fc-error \nng-show=\"omieExportQuotationForm[\'productUnitValue__\' + $index].$touched\" \ninput-errors=\"omieExportQuotationForm[\'productUnitValue__\' + $index].$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'min\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.ERRORS.MIN_UNIT_VALUE\'\n                },\n                {\n                  name: \'required\',\n                  translate: \'INTEGRATIONS.QUOTATIONS.REQUIRED\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"fc-input omie-export-content__products-container__discount\"><div class=\"fc-input\"><input type=\"text\" \nclass=\"fc-input__input fc-input__input__discount\" ng-if=\"product.discount.type === \'value\'\" ui-money-mask \nplaceholder=\" \" name=\"productDiscountValue__{{$index}}\" input-name=\"productDiscountValue__{{$index}}\" \ninput-control=\"omieExportQuotationForm[\'productDiscountValue__\' + $index]\" ng-model=\"product.discount.value\" \nng-change=\"vm.validateProductDiscountValue($index)\" \nng-class=\"{ invalid: omieExportQuotationForm[\'productDiscountValue__\' + $index].$touched && omieExportQuotationForm[\'productDiscountValue__\' + $index].$invalid }\">\n <input type=\"number\" class=\"fc-input__input fc-input__input__discount\" ng-if=\"product.discount.type === \'percentage\'\" \nng-change=\"vm.validateProductDiscountValue($index)\" ng-model=\"product.discount.value\" placeholder=\" \" \nname=\"productDiscountValue__{{$index}}\" input-name=\"productDiscountValue__{{$index}}\" \ninput-control=\"omieExportQuotationForm[\'productDiscountValue__\' + $index]\" \nng-class=\"{ invalid: omieExportQuotationForm[\'productDiscountValue__\' + $index].$touched && omieExportQuotationForm[\'productDiscountValue__\' + $index].$invalid }\">\n<label class=\"fc-input__label\">{{(\'QUOTATIONS.DIALOG.MODEL.DISCOUNT.LABEL\' | translate)}}</label><fc-error \nng-show=\"omieExportQuotationForm[\'productDiscountValue__\' + $index].$touched\" \ninput-errors=\"omieExportQuotationForm[\'productDiscountValue__\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'min\', translate: \'INTEGRATIONS.QUOTATIONS.ERRORS.MIN_UNIT_VALUE\'\n                  },\n                  {\n                    name: \'errorPercentageDiscount\', translate: \'INTEGRATIONS.QUOTATIONS.ERRORS.PERCENTAGE_DISCOUNT\'\n                  },\n                  {\n                    name: \'errorValueDiscount\', translate: \'INTEGRATIONS.QUOTATIONS.ERRORS.VALUE_DISCOUNT\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"omie-export-content__discount-container__discount-type\"><fc-select options=\"vm.discountTypes\" \nng-model=\"product.discount.type\" ng-change=\"vm.validateProductDiscountValue($index)\" without-divider=\"true\">\n</fc-select></div></div><div class=\"fc-input omie-export-content__products-container__trash\" \nng-if=\"omieExportQuotationForm[\'productsAutoComplete__\' + $index].$error.uniqueProduct\"><button \nng-click=\"vm.viewModel.removeProduct($index)\"><img src=\"assets/icons/trash.svg\"></button></div></div></details>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"vm.sendingQuotation || omieExportQuotationForm.$invalid\" ng-click=\"vm.sendQuotation()\" \nclass=\"md-accent md-raised\" translate=\"INTEGRATIONS.QUOTATIONS.SEND\">Send</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/core/integrations/core/quotations/dialogs/export/omie/load-data/omie-load-data.html","<md-dialog class=\"w-400\"><md-dialog-content><div class=\"mb-10\"><span translate=\"INTEGRATIONS.QUOTATIONS.CHECKING_DATA\">\nChecking data...</span></div><md-progress-linear md-mode=\"indeterminated\"></md-progress-linear></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/core/integrations/core/quotations/dialogs/export/omie/sending-to-omie/sending-to-omie.html","<md-dialog class=\"w-400\"><md-dialog-content><div class=\"mb-10\"><span \ntranslate=\"INTEGRATIONS.QUOTATIONS.SENDING_TO_OMIE\">Sending quotation to Omie...</span></div><md-progress-linear \nmd-mode=\"indeterminated\"></md-progress-linear></md-dialog-content></md-dialog>");
$templateCache.put("app/core/integrations/core/tasks/dialogs/export/omie/errors/omie-errors-dialog.html","<md-dialog draggable class=\"form-dialog omie-errors-dialog\" aria-label=\"Integration\"><md-toolbar class=\"md-accent\"><div\n class=\"md-toolbar-tools align-vertical align-vertical-middle\"><span class=\"fs-17 bold\" \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.ERROR_LOADING_DATA\" translate-value-app=\"Omie\">Error loading data </span>\n<span flex></span> <span flex></span><md-button class=\"md-icon-button margin-top-0\" ng-click=\"vm.closeDialog();\" \naria-label=\"Close Dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div ng-if=\"vm.data\"><div ng-if=\"vm.data.services.length\"><span \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.ERROR_INEXISTENT_RESOURCE\">\nIt was not possible to identify all your customer data, either on Field Control, or Omie. Confirm that your customer has street address , number., City, company registry number, and try again.\n</span></div><div ng-if=\"!vm.data.services.length\"><span \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.ERROR_LOADING_SERVICES\" translate-value-app=\"Omie\">\nError: Omie\'s services could not be loaded</span></div></div><div ng-if=\"vm.error\"><div ng-if=\"vm.isKeyError()\"><span \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.ERROR_KEY\">Your key is invalid or the application has been suspended.</span>\n</div><div ng-if=\"!vm.isKeyError()\"><span translate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.ERROR_UNKNOWN\">\nAn unknown error has occurred, please try again later or contact support.</span></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-click=\"vm.closeDialog()\" class=\"md-accent md-raised\">Ok</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/integrations/core/tasks/dialogs/export/omie/export/omie-tasks-export-dialog.html","<md-dialog draggable class=\"sidebar-dialog sidebar-dialog--small omie-task-export-dialog\" aria-label=\"Integration\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools align-vertical align-vertical-middle\"><span \nclass=\"dialog-title\" translate=\"INTEGRATIONS.TASKS.EXPORT.DIALOG.TOOLBAR.TITLE\" translate-value-app=\"Omie\">\nSend task to Omie </span><span flex></span> <span flex></span><md-button class=\"md-icon-button margin-top-0\" \nng-click=\"vm.closeDialog();\" aria-label=\"Close Dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"omieExportTaskForm\" class=\"md-inline-form\" novalidate><md-dialog-content \nclass=\"omie-export-content\" ms-scroll><div layout=\"row\" layout-align=\"center\"><div class=\"account-items-table-body\"><h1\n class=\"omie-export-content__title\" translate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.ACCOUNT.TITLE\"></h1><div \nclass=\"omie-account-main fc-input omie-account-select\"><fc-select \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.ACCOUNT.TITLE\' | translate)}}\" options=\"vm.viewModel.accounts\" \nng-model=\"vm.viewModel.activatedAccount\" track-by=\"name\" input-name=\"account\" \ninput-control=\"omieExportTaskForm.account\" is-disabled=\"true\"></fc-select><fc-error \ninput-errors=\"omieExportTaskForm.account.$error\" ng-show=\"omieExportTaskForm.account.$touched\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'VEHICLES.MODEL.ERRORS.FIELD_REQUIRED\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div></div></div><div class=\"omie-export-content__title\" \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.DIALOG.TASK_DATA\" translate-value-app=\"Omie\">Task data</div><div \nclass=\"omie-export-content__first-line-container\"><div class=\"omie-export-content__second-line-container__city\">\n<fc-select class=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.SELECT_CUSTOMER\' | translate)}}\" options=\"vm.viewModel.customers\" \nng-model=\"vm.viewModel.selectedCustomer\" input-name=\"customer\" input-control=\"omieExportTaskForm.customer\" \nis-required=\"true\"></fc-select><div ng-if=\"vm.viewModel.customers && vm.viewModel.customers.length > 1\" \nclass=\"omie-export-content__mutiple-customers-warn fc-warning-container\"><md-icon class=\"warning-icon\" \nmd-svg-src=\"assets/icons/icon-alert.svg\"></md-icon><span \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.MULTIPLE_MATCHING_CUSTOMERS\"></span></div></div><div \nclass=\"omie-export-content__first-line-container__category\"><fc-select \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{ \'INTEGRATIONS.TASKS.EXPORT.OMIE.CATEGORY\' | translate }}\" options=\"vm.viewModel.categories\" \nng-model=\"vm.viewModel.form.category.descricao\" input-name=\"category\" input-control=\"omieExportTaskForm.category\" \nis-required=\"true\"></fc-select></div><div \nclass=\"omie-export-content__first-line-container__sales-forecast fc-datepicker\"><label class=\"fc-datepicker__label\" \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.SALES_FORECAST\">Sales forecast *</label><div class=\"date-container\">\n<md-datepicker flex required class=\"p-0\" md-hide-icons=\"calendar\" md-min-date=\"vm.viewModel.oneYearAgo\" \nng-model=\"vm.viewModel.form.forecastDate\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker></div></div></div><div \nclass=\"omie-export-content__second-line-container\"><div class=\"omie-export-content__second-line-container__city\">\n<fc-autocomplete name=\"cityAutoComplete\" input-name=\"cityAutoComplete\" \nlabel=\"{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.CITY_SERVICE\' | translate)}}\" is-required=\"true\" debounce=\"500\" \ninput-control=\"omieExportTaskForm.cityAutoComplete\" ng-model=\"vm.viewModel.form.city\" options=\"vm.viewModel.cities\" \ntrack-by=\"cCod\" click-to-remove=\"true\" search-term=\"vm.viewModel.searchCityText\" \nsearch-function=\"vm.search(vm.viewModel.searchCityText, \'City\')\" \nerrors-to-watch=\"[\n            {\n              name: \'required\',\n              translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.REQUIRED\'\n            },\n          ]\">\n</fc-autocomplete></div><div class=\"omie-export-content__second-line-container__bank-account\"><fc-select \nclass=\"fc-select__select--without-border\" label=\"{{ \'INTEGRATIONS.TASKS.EXPORT.OMIE.BANK_ACCOUNT\' | translate }}\" \noptions=\"vm.viewModel.bankAccounts\" ng-model=\"vm.viewModel.form.bankAccount\" input-name=\"bankAccount\" \ninput-control=\"omieExportTaskForm.bankAccount\" is-required=\"true\"></fc-select></div><div \nclass=\"omie-export-content__second-line-container__installment\"><fc-select \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{ \'INTEGRATIONS.TASKS.EXPORT.OMIE.INSTALLMENTS\' | translate }}\" options=\"vm.viewModel.installments\" \nng-model=\"vm.viewModel.form.installment\" input-name=\"installment\" input-control=\"omieExportTaskForm.installment\" \nis-required=\"true\" limit=\"100\" search-function=\"vm.searchInstallmentText()\" \nsearch-phrase=\"{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.INSTALLMENTS\' | translate)}}\" with-search=\"true\"></fc-select></div>\n<div class=\"omie-export-content__second-line-container__seller\"><fc-select \nclass=\"fc-select__select--without-border fc-select__select--change-border-color\" \nlabel=\"{{ \'INTEGRATIONS.TASKS.EXPORT.OMIE.SELLER\' | translate }}\" options=\"vm.viewModel.sellers\" \nng-model=\"vm.viewModel.form.seller\" is-disabled=\"vm.duplicateOsMethod === \'update\'\" input-name=\"seller\" \ninput-control=\"omieExportTaskForm.seller\" is-required=\"true\" limit=\"100\" search-function=\"vm.searchSellerText()\" \nsearch-phrase=\"{{ \'INTEGRATIONS.TASKS.EXPORT.OMIE.SELLER\' | translate }}\" with-search=\"true\"></fc-select><md-tooltip \nng-if=\"vm.duplicateOsMethod === \'update\'\" md-direction=\"bottom\"><span \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.SELLER_NOT_EDITABLE\">Seller cannot be changed for an existing task.</span>\n</md-tooltip></div></div><details class=\"collapsible\"><summary>\n{{ \"INTEGRATIONS.TASKS.EXPORT.OMIE.SERVICES_PERFORMED\" | translate }} ({{vm.viewModel.form.services.length}})</summary>\n<div class=\"omie-export-content__services-container\" ng-repeat=\"service in vm.viewModel.form.services track by $index\">\n<div class=\"omie-export-content__services-container__service\"><fc-autocomplete name=\"serviceAutoComplete__{{$index}}\" \ninput-name=\"serviceAutoComplete__{{$index}}\" label=\"{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.SERVICE\' | translate)}}\" \nis-required=\"true\" debounce=\"500\" min=\"0.01\" input-control=\"omieExportTaskForm[\'serviceAutoComplete__\' + $index]\" \nng-model=\"service.obj\" track-by=\"displayName\" ng-change=\"vm.viewModel.serviceHasSelected(service)\" \noptions=\"vm.viewModel.services\" search-term=\"vm.viewModel.searchServiceTextArray[$index]\" click-to-remove=\"true\" \nsearch-function=\"vm.search(vm.viewModel.searchServiceTextArray[$index], \'Service\')\" \nerrors-to-watch=\"[{\n                name: \'required\',\n                translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.REQUIRED\'\n              }]\">\n</fc-autocomplete></div><div class=\"fc-input omie-export-content__services-container__quantity\"><input type=\"number\" \nclass=\"fc-input__input\" placeholder=\" \" name=\"servicesQuantity__{{$index}}\" input-name=\"servicesQuantity__{{$index}}\" \ninput-control=\"omieExportTaskForm[\'servicesQuantity__\' + $index]\" autocomplete=\"off\" ng-model=\"service.qtd\" \nstring-to-number min=\"0.1\" ng-required=\"true\" \nng-class=\"{\n                invalid: omieExportTaskForm[\'servicesQuantity__\' + $index].$touched && omieExportTaskForm[\'servicesQuantity__\' + $index].$invalid,\n              }\">\n<label class=\"fc-input__label\">{{(\"INTEGRATIONS.TASKS.EXPORT.OMIE.QTY\" | translate)}}</label><fc-error \nng-show=\"omieExportTaskForm[\'servicesQuantity__\' + $index].$touched\" \ninput-errors=\"omieExportTaskForm[\'servicesQuantity__\' + $index].$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'min\',\n                  translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.ERRORS.MIN_UNIT_VALUE\'\n                },\n                {\n                  name: \'required\',\n                  translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.REQUIRED\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"fc-input omie-export-content__services-container__unit-value\"><input type=\"text\" class=\"fc-input__input\" \nplaceholder=\" \" name=\"unitValue__{{$index}}\" autocomplete=\"off\" ng-model=\"service.value\" ui-money-mask \nng-required=\"true\" min=\"0.01\" \nng-class=\"{\n                invalid: omieExportTaskForm[\'unitValue__\' + $index].$touched && omieExportTaskForm[\'unitValue__\' + $index].$invalid,\n              }\">\n<label class=\"fc-input__label\">{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.UNIT_VALUE\' | translate)}}</label><fc-error \nng-show=\"omieExportTaskForm[\'unitValue__\' + $index].$touched\" \ninput-errors=\"omieExportTaskForm[\'unitValue__\' + $index].$error\" \nerrors-to-watch=\"[\n                {\n                  name: \'required\',\n                  translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.REQUIRED\'\n                },\n                {\n                  name: \'min\',\n                  translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.ERRORS.MIN_UNIT_VALUE\'\n                }\n              ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"fc-input omie-export-content__services-container__trash\"><button \nng-if=\"vm.viewModel.form.services.length !== 1\" ng-click=\"vm.viewModel.removeService($index)\"><img \nsrc=\"assets/icons/trash.svg\"></button> <button disabled=\"true\" ng-if=\"vm.viewModel.form.services.length === 1\"><img \nsrc=\"assets/icons/trash-disabled.svg\"></button><md-tooltip ng-if=\"vm.viewModel.form.services.length === 1\" \nmd-direction=\"left\"><span translate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.AT_LEAST_ONE_SERVICE\">At least 1 product to remove\n</span></md-tooltip></div></div><div class=\"add-new-line\"><button ng-click=\"vm.viewModel.addService();\" \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.ADD_MORE_LINE\">add +1 line</button></div></details><details \nclass=\"collapsible\"><summary>\n{{ \"INTEGRATIONS.TASKS.EXPORT.OMIE.PRODUCTS.USED_PRODUCTS\" | translate }} ({{vm.viewModel.form.products.length}})\n</summary><form name=\"omieExportTaskForm\"><div class=\"omie-export-content__products-container\" \nng-repeat=\"product in vm.viewModel.form.products track by $index\"><div \nclass=\"omie-export-content__products-container__product\"><fc-autocomplete name=\"productsAutoComplete__{{$index}}\" \ninput-name=\"productsAutoComplete__{{$index}}\" \nlabel=\"{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.PRODUCTS.PRODUCT\' | translate)}}\" is-required=\"true\" debounce=\"500\" \nng-change=\"vm.viewModel.productHasSelected(product); vm.verifyProductsName()\" \ninput-control=\"omieExportTaskForm[\'productsAutoComplete__\' + $index]\" ng-model=\"product.obj\" track-by=\"name\" \noptions=\"vm.viewModel.products\" search-term=\"vm.viewModel.searchProductTextArray[$index]\" \nsearch-function=\"vm.search(vm.viewModel.searchProductTextArray[$index], \'Product\')\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.REQUIRED\'\n                  },\n                  {\n                    name: \'uniqueProduct\',\n                    translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.UNIQUE_PRODUCT\'\n                  }\n                ]\">\n</fc-autocomplete></div><div class=\"fc-input omie-export-content__products-container__measure\"><input type=\"text\" \nng-disabled=\"true\" class=\"fc-input__input\" placeholder=\" \" name=\"productMeasure\" input-name=\"productMeasure\" \ninput-control=\"omieExportTaskForm.productMeasure\" autocomplete=\"off\" ng-model=\"product.measure\"><label \nclass=\"fc-input__label\">{{(\"INTEGRATIONS.TASKS.EXPORT.OMIE.PRODUCTS.MEASURE\" | translate)}}</label><fc-error \nng-show=\"omieExportTaskForm.productMeasure.$touched\" input-errors=\"omieExportTaskForm.productMeasure.$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'required\',\n                    translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.REQUIRED\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"fc-input omie-export-content__products-container__quantity\"><input type=\"number\" \nng-disabled=\"vm.hasStockModule\" class=\"fc-input__input\" placeholder=\" \" name=\"productQuantity__{{$index}}\" \ninput-name=\"productQuantity__{{$index}}\" input-control=\"omieExportTaskForm[\'productQuantity__\' + $index]\" \nautocomplete=\"off\" ng-model=\"product.quantity\" min=\"1\" ng-required=\"true\" \nng-class=\"{\n                  invalid: omieExportTaskForm[\'productQuantity__\' + $index].$touched && omieExportTaskForm[\'productQuantity__\' + $index].$invalid,\n                }\">\n<label class=\"fc-input__label\">{{(\"INTEGRATIONS.TASKS.EXPORT.OMIE.QTY\" | translate)}}</label><fc-error \nng-show=\"omieExportTaskForm[\'productQuantity__\' + $index].$touched\" \ninput-errors=\"omieExportTaskForm[\'productQuantity__\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'min\',\n                    translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.ERRORS.MIN_UNIT_VALUE\'\n                  },\n                  {\n                    name: \'required\',\n                    translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.REQUIRED\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"fc-input omie-export-content__products-container__unit-value\"><input type=\"text\" class=\"fc-input__input\" \nplaceholder=\" \" ng-disabled=\"true\" name=\"productUnitValue__{{$index}}\" autocomplete=\"off\" \nng-change=\"vm.viewModel.verifyProductsName()\" ng-model=\"product.value\" min=\"0.01\" ui-money-mask ng-required=\"true\" \nng-class=\"{\n                  invalid: omieExportTaskForm[\'productUnitValue__\' + $index].$touched && omieExportTaskForm[\'productUnitValue__\' + $index].$invalid,\n                }\">\n<label class=\"fc-input__label\">{{(\'INTEGRATIONS.TASKS.EXPORT.OMIE.UNIT_VALUE\' | translate)}}</label><fc-error \nng-show=\"omieExportTaskForm[\'productUnitValue__\' + $index].$touched\" \ninput-errors=\"omieExportTaskForm[\'productUnitValue__\' + $index].$error\" \nerrors-to-watch=\"[\n                  {\n                    name: \'min\',\n                    translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.ERRORS.MIN_UNIT_VALUE\'\n                  },\n                  {\n                    name: \'required\',\n                    translate: \'INTEGRATIONS.TASKS.EXPORT.OMIE.REQUIRED\'\n                  }\n                ]\" \ncustom-class=\"fc-input__input-error\"></fc-error></div><div \nclass=\"fc-input omie-export-content__products-container__trash\" ng-if=\"!vm.hasStockModule\"><button \nng-click=\"vm.viewModel.removeProduct($index)\"><img src=\"assets/icons/trash.svg\"></button></div></div></form><div \nclass=\"add-new-line\"><button ng-if=\"!vm.hasStockModule\" ng-click=\"vm.viewModel.addProduct();\" \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.PRODUCTS.ADD_PRODUCT\">add +1 line</button><div ng-if=\"vm.hasStockModule\" \nclass=\"add-new-line--paragraph\"><img src=\"assets/icons/storage-control.svg\" width=\"20px\" height=\"20px\"> <span \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.PRODUCTS.ADD_PRODUCT_MOVEMENT\">\nEfetue uma movimentação para adicionar um produto a OS</span></div></div></details></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-if=\"!vm.loading\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"vm.sendingTask || omieExportTaskForm.$invalid\" \nng-click=\"vm.sendTask()\" class=\"md-accent md-raised\" translate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.SEND\">Send</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/integrations/core/tasks/dialogs/export/omie/load-data/omie-load-data.html","<md-dialog class=\"w-400\"><md-dialog-content><div class=\"mb-10\"><span \ntranslate=\"INTEGRATIONS.TASKS.EXPORT.OMIE.CHECKING_DATA\">Checking data...</span></div><md-progress-linear \nmd-mode=\"indeterminated\"></md-progress-linear></md-dialog-content></md-dialog>");}]);
(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/core/i18n/en.json',
    '{"CORE":{"INDEX":{"NON_PAYMENT_WARNING":"We haven\'t identified your payment yet, and your account will be blocked. Please contact financeiro@fieldcontrol.com.br","LIMIT_EXCEEDED_WARNING":"Your account has more active licenses than the acquired ammount. Contact live support via chat and ask for your account manager.","EMAIL_NOT_VALID_WARNING":"To continue using Field Control, you need to confirm your email address  {{email}}.","ACCOUNT_SUBSCRIPTION_WARNING_ADMIN":"Your subscription must be renewed.","ACCOUNT_SUBSCRIPTION_WARNING_USER":"Your subscription must be renewed. Ask your account management to access Field Control.","CLICK_TO_RENEW":"Click here to renew","CLICKING_HERE":"Send confirmation.","SENDING":"Sending...","CONFIRMATION_EMAIL_SUCCESS":"Confirmation email sent!","CONFIRMATION_EMAIL_ERROR":"An error occurred while sending the confirmation email","CONTRACT_NOT_SIGNED":"We could not identify the signature of the platform usage contract. Please contact your account manager to regularize your situation.","CLICK_TO_SIGN":"Sign contract"},"AUTH":{"NOT_ALLOWED":"User not allowed to access this page.","WITHOUT_PERMISSIONS":"You don\'t have system permissions."},"BLATOUT":{"TITLE":"Fieldnews - The Field Control newsletter"},"FC_SPREADSHEET_READER":{"LOADING":"Loading...","FILE":{"UPLOAD_MESSAGE":"Click or drag the template sheet to upload","MAX_SIZE":"The maximum file size is {{ maxSize }}"},"TOASTS":{"FILE":{"OPEN_ERROR":"There was a reading of the file, the file may be corrupted and cannot be opened."}}},"FC_SPREADSHEET_RESULT":{"TABLE":{"REVIEW":{"STATUS":{"VALID":"Valid","INVALID":"Invalid"},"INVALID_ROWS_PERCENTAGE":"{{ invalidPercentage }}% of lines are inconsistent","WITHOUT_INCONSISTENCY":"There are no inconsistent rows in this spreadsheet"},"COLUMNS":{"VALIDATION":"Validation","ROW":"Spreadsheet row","ERRORS_COUNT":"Inconsistencies"},"ROWS":{"SPREADSHEET_STATUS":{"VALID":"Valid","INVALID":"Invalid"},"DETAILS":{"MORE":"Show details","LESS":"Hide details","FIELDS":"Fields:","INCONSISTENCIES":"Inconsistencies:","ROW":"Row {{ rowNumber }}","ERRORS":{"TYPE":{"MESSAGE":"This field must be {{ expectedType }}, but it is {{ receivedType }}.","KINDS":{"STRING":"text","NUMBER":"numeric","UNKOWN":"unknown"}},"EXACT_LENGTH":{"MESSAGE":"This field must have exactly {{ expectedLength }} characters, but it has {{ receivedLength }}."},"MAX_LENGTH":{"MESSAGE":"This field must not exceed {{ expectedLength }} characters, but it has {{ receivedLength }} characters."},"MIN_LENGTH":{"MESSAGE":"This field must have at least {{ expectedLength }} characters, but it has {{ receivedLength }}."},"OPTIONAL":{"MESSAGE":"This field is mandatory, but has not been entered."},"PATTERN":{"MESSAGE":"The field must meet the ({{ pattern }}) standard but is \\"{{ value }}\\"."},"UNIQUENESS":{"MESSAGE":"The field values ​​must be unique, but there are duplicates."},"INVALID_CPF":{"MESSAGE":"The field contains an invalid CPF."},"INVALID_CNPJ":{"MESSAGE":"The field contains an invalid CNPJ."},"MAX_ITEMS":{"MESSAGE":"Only a maximum of {{ maxItems }} values are allowed for this field."},"INVALID_SPLITTER":{"MESSAGE":"This field must be separated by a comma ({{ expectedSplit }}), but it is separated by semicolons ( ; ) or vertical slash ( | )"}}}}}},"FC_EXPORT_CSV_BUTTON":{"TEXT":"Export to CSV"},"FC_EXPORT_EXCEL_BUTTON":{"TEXT":"Export to Excel"},"FC_EXPORT_ALERT":{"TITLE":"Export request","TEXT_SEND":"Export has been sent to email:  ","TEXT_VIEW":"You can also view it by clicking the button below.","BUTTON_VIEW":"View exports","BUTTON_DONT_SEE":"I don\'t want to see this message anymore","GENERATING":"Your export is being generated, wait for the download."},"FC_EXPORT_PRINT_BUTTON":{"TEXT":"Print"},"FC_DATE_INPUT":{"PLACEHOLDER":"Date","ERRORS":{"RETROACTIVE":"Retroactive date","INVALID":"Invalid date","EMPTY":"Empty date"}},"FC_TIME_INPUT":{"PLACEHOLDER":"Time","ERRORS":{"RETROACTIVE":"Retroactive time","INVALID":"Invalid time","EMPTY":"Empty time"}},"FC_IMPORT_TEMPLATE_BUTTON":{"TEXT":"Import template"},"FC_COLOR_PICKER":{"COLOR_INPUT":{"PLACEHOLDER":"Color"}},"FC_SELECT":{"WITH_SEARCH":{"NO_RESULTS_FOUND":"No items found"}},"FC_SMART_REWRITE":{"REWRITE_TEXT":"Rewrite text"},"FC_IMAGE_INPUT":"This file exceeds the 2MB limit","SHORTCUTS":{"MAX_SHORTCUTS":"Maximum of {{shortcutsLimit}} shortcuts","ADD_OR_REMOVE":"Add or remove shortcut","NOT_FOUND":"No shortcuts found","SEARCH":"Search shortcut","TASKS":"Task list","DAY_TASKS":"Tasks of the day","TASKS_TYPES":"OS Types","TIMELINE":"Timeline","MAP":"Map","CALENDAR":"Calendar","RECURRENCES":"Recurrences","CUSTOMERS":"Customers","EMPLOYEES":"Employee list","ABSENCES":"Absences","ROUTE_HISTORY":"Route history","DASHBOARD":"Dashboard","RATING":"Rates","EMPLOYEE_REPORT":"Employee report","FORMS_REPORT":"Forms report","TASKS_REPORT":"Service report","HEAT_MAP":"Heat map","TICKETS":"Tickets","EQUIPMENT":"Equipment list","EQUIPMENT_TYPES":"Equipment types","EXPORTS":"Exports","MATERIALS":"Materials"},"MS_INFO_BAR":{"CLOSE":"Close"},"MS_MATERIAL_COLOR_PICKER":{"PALETTE":"Palette","SELECT_COLOR":"Select color","REMOVE_COLOR":"Remove color"},"MS_NAVIGATION":{"TOGGLE_MOBILE_NAVIGATION":"Toggle mobile browsing"},"MS_SEARCH_BAR":{"SEARCH":"Search"},"MS_STEPPER":{"BACK":"Back","NEXT":"Next","SUBMIT":"Submit","OPTIONAL":"Optional"},"DATA_TABLE":{"DAY":"day","HOUR":"hour","MINUTE":"minute","DAYS":"days","HOURS":"hours","MINUTES":"minutes","AND":"and","LOADING":"Loading ...","EMPTY_TABLE":"No records found","INFO":"Showing from _START_ to _END_ of _TOTAL_ records","INFO_EMPTY":"Showing 0 to 0 of 0 entries","INFO_FILTERED":"(Filtered from _MAX_ records)","LENGTH_MENU":"_MENU_ results per page","RESULTS_PER_PAGE":"results per page","PROCESSING":"Processing ...","SEARCH":"Search by name:","PAGINATE":{"NEXT":"Next","PREVIOUS":"Previous","FIRST":"First","LAST":"Last"},"ARIA":{"SORT_ASCENDING":"Sort columns ascending","SORT_DESCENDING":"Sort columns descending"},"CHANGE_COLUMNS":"Change columns"},"TASKS_STATUS":{"PENDING":"Pending","SCHEDULED":"Scheduled","ON_ROUTE":"On route","IN_PROGRESS":"In progress","COMPLETED":"Completed","CANCELED":"Canceled","PREVENTED":"Prevented"},"TASKS_DEADLINE_STATUS":{"ON_SCHEDULE":"On schedule","AT_RISK":"At risk","OUT_OF_SCHEDULE":"Out of schedule","COMPLETED_OUT_OF_SCHEDULE":"Completed out of schedule","COMPLETED_ON_SCHEDULE":"Completed on schedule","NO_APPLICABLE":"No applicable"},"ADDRESS_SERVICE":{"COUNTRIES":{"NO_RESTRICTIONS":"No restrictions"},"VALIDATION":{"REQUIRED":"The address was not specified","POSTAL_CODE":"Zip code was not specified","STATE":"The state was not specified","CITY":"The city was not specified","STREET":"The street was not specified","NEIGHBORHOOD":"The neighborhood was not specified","NUMBER":"The number was not specified"}},"EQUIPAMENT_PERMISSION":{"TITLE":"Invalid access","MESSAGE":"You still have no access to the equipment inventory; for more information, contact our support."},"PUSH_NOTIFICATIONS":{"TITLE":"Notifications","MESSAGE":"Do you want to receive notifications about your operation in the browser?","OK":"Yes, I do","CANCEL":"Later"},"ERRORS":{"CONNECTION_ERROR":{"TITLE":"Oops, it looks like you are not connected.","CONTENT":"Please make sure you are connected to an internet network and try again."}},"FC_AUTOCOMPLETE":{"NO_RESULTS":"No results found"},"CORPORATE_CUSTOMER_DISCLAIMER":"The information about this page is defined by your customer <b>{{ customerName }}</b> and therefore can\'t be updated.","SUBSCRIPTION_DIALOG":{"CLOSE":"Close","CONTRACT_MODULE":"Hire modules","USAGE_CONDITIONS":"Module conditions","TIME_TO_EXPIRE":"There are still full <span>{{ timeToExpire }}</span> left for your annual plan to expire. Therefore, the value of this module will be calculated on top of this remaining time.","TABLE":{"DESCRIPTION":"Description","QUANTITY":"Quantity","MONTHLY_PRICE":"Monthly price","TIME_TO_EXPIRE":"Time left","DAYS":"Days","TOTAL_PRICE":"Total price"},"MODULES":{"VEHICLES":"Vehicle Control"},"ACTIONS":{"FINALIZE_CONTRACTING":"FINALIZE CONTRACTING"},"ONE_INSTALLMENT":"1 installment of R${{ price }}","MORE_INSTALLMENTS":"{{installments}} installments of R${{ price }}","PAYMENT":"Payment (credit card)","MODULE":"Module","CARDHOLDER_NAME":"Cardholder name","CARDHOLDER_NAME_ALERT":"The name must be the same as the name on the card.","CARD_NUMBER":"Card number","VALIDITY":"Validity","SECURITY_CODE":"Security code","HAS_CUPOM":"Have a discount coupon? enter it here","NEXT_PAYMENTS_ALERT":"Allow using the credit card for future invoices","INSTALLMENTS":"Installments","OBLIGATORY_FIELD":"Required field","CONTRACT_ALERT_TITLE":"Do you want to proceed with the hiring?","CONTRACT_ALERT_DESCRIPTION":"Upon confirmation, this amount will be deducted from the inserted credit card.","YES":"YES","NO":"NO","MONTHS":"month(s)","DAYS":"day(s)","AND":"and","CONGRATULATIONS_ALERT_TITLE":"Congratulations! You have hired the vehicle module.","CONGRATULATIONS_ALERT_DESCRIPTION":"An email confirming the hiring of the module will be sent shortly. Please refresh the page to access the new features.","UPDATE":"UPDATE","CONFIRMING_PAYMENT":"We are confirming payment...","EXPIRED_VALIDITY":"Expired validity","OPERATION_ERROR":"The operation could not be completed. Please check the data on the inserted card and try again.","INVALID_CARD_NUMBER":"Invalid card number","INVALID_VERIFICATION_VALUE":"Invalid CVV","RENEW_EXPIRED":"You are in the renewal period. If you want to purchase this module, include it in your subscription.","NOT_ALLOWED_MONTHLY":"Contact your account manager to hire this module."},"WELCOME":"Welcome to Field Control","WELCOME_DESCRIPTION":"Here\'s a short video to help you get started on the platform. Let\'s go?","WELCOME_CLOSE_DIALOG":"Close","FC_LINK_EQUIPMENT_WITH_ORDER":{"TITLE":"Linking equipment {{current}} / {{total}}"},"ATTENTION":"Attention","CLICK_HERE":"Click here"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/core/i18n/es.json',
    '{"CORE":{"INDEX":{"NON_PAYMENT_WARNING":"Todavía no hemos identificado su pago y su cuenta será bloqueada. Por favor, póngase en contacto con financeiro@fieldcontrol.com.br","LIMIT_EXCEEDED_WARNING":"Tu cuenta tiene más licencias activas que el plan contratado. Póngase en contacto con el chat en línea y solicite un contacto de la administración de su cuenta.","EMAIL_NOT_VALID_WARNING":"Para continuar usando Field Control, necesita confirmar su correo electrónico {{email}}.","ACCOUNT_SUBSCRIPTION_WARNING_ADMIN":"Su suscripción debe renovarse.","ACCOUNT_SUBSCRIPTION_WARNING_USER":"Su suscripción debe renovarse. Solicite a la administración de su cuenta que acceda a Field Control.","CLICK_TO_RENEW":"Haga clic aquí para renovar","CLICKING_HERE":"Enviar confirmación.","SENDING":"Enviando...","CONFIRMATION_EMAIL_SUCCESS":"¡Correo de Confirmación Mandado!","CONFIRMATION_EMAIL_ERROR":"Se produjo un error al enviar el correo electrónico de confirmación","CONTRACT_NOT_SIGNED":"No pudimos identificar la firma del contrato de uso de la plataforma. Por favor contacte a su administrador de cuenta para regularizar su situación.","CLICK_TO_SIGN":"Firmar contrato"},"AUTH":{"NOT_ALLOWED":"El usuario no tiene permiso para acceder a esta página.","WITHOUT_PERMISSIONS":"No tiene permisos del sistema."},"BLATOUT":{"TITLE":"Fieldnews - El boletín de Field Control"},"FC_SPREADSHEET_READER":{"LOADING":"Cargando...","FILE":{"UPLOAD_MESSAGE":"Haga clic o arrastre la hoja de plantilla para cargar","MAX_SIZE":"El tamaño máximo de archivo es {{ maxSize }}"},"TOASTS":{"FILE":{"OPEN_ERROR":"Hubo una lectura del archivo, el archivo puede estar dañado y no se puede abrir."}}},"FC_SPREADSHEET_RESULT":{"TABLE":{"REVIEW":{"STATUS":{"VALID":"Válido","INVALID":"No válido"},"INVALID_ROWS_PERCENTAGE":"{{ invalidPercentage }}% de líneas son inconsistentes","WITHOUT_INCONSISTENCY":"No hay filas incoherentes en esta hoja de cálculo"},"COLUMNS":{"VALIDATION":"Validación","ROW":"Fila de la hoja de cálculo","ERRORS_COUNT":"Inconsistencias"},"ROWS":{"SPREADSHEET_STATUS":{"VALID":"Válido","INVALID":"No válido"},"DETAILS":{"MORE":"Mostrar detalles","LESS":"Ocultar detalles","FIELDS":"Campos:","INCONSISTENCIES":"Inconsistencias:","ROW":"Línea {{ rowNumber }}","ERRORS":{"TYPE":{"MESSAGE":"Este campo debe ser {{ expectedType }}, pero es {{ receivedType }}.","KINDS":{"STRING":"texto","NUMBER":"numérico","UNKOWN":"desconocido"}},"EXACT_LENGTH":{"MESSAGE":"Este campo debe tener exactamente {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}."},"MAX_LENGTH":{"MESSAGE":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }} caracteres."},"MIN_LENGTH":{"MESSAGE":"Este campo debe tener al menos {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}."},"OPTIONAL":{"MESSAGE":"Este campo es obligatorio, pero no se ha introducido."},"PATTERN":{"MESSAGE":"El campo debe cumplir con el estándar ({{ pattern }}) pero es \\"{{ value }}\\"."},"UNIQUENESS":{"MESSAGE":"Los valores de campo deben ser únicos, pero hay duplicados."},"INVALID_CPF":{"MESSAGE":"El campo contiene un CPF no válido."},"INVALID_CNPJ":{"MESSAGE":"El campo contiene un CNPJ no válido."},"MAX_ITEMS":{"MESSAGE":"Solo se permite un máximo de {{ maxItems }} valores para este campo."},"INVALID_SPLITTER":{"MESSAGE":"Este campo debe estar separado por una coma ({{ expectedSplit }}), pero está separado por punto y coma ( ; ) o barra vertical ( | )"}}}}}},"FC_EXPORT_CSV_BUTTON":{"TEXT":"Exportar a CSV"},"FC_EXPORT_EXCEL_BUTTON":{"TEXT":"Exportar a Excel"},"FC_EXPORT_ALERT":{"TITLE":"Solicitud de exportación","TEXT_SEND":"La exportación ha sido enviada al correo electrónico:  ","TEXT_VIEW":"También puede verlo haciendo clic en el botón de abajo.","BUTTON_VIEW":"Ver exportaciones","BUTTON_DONT_SEE":"No quiero ver más este mensaje.","GENERATING":"Se está generando su exportación, espere la descarga."},"FC_EXPORT_PRINT_BUTTON":{"TEXT":"Imprimir"},"FC_DATE_INPUT":{"PLACEHOLDER":"Fecha","ERRORS":{"RETROACTIVE":"Fecha retroactivo","INVALID":"Fecha invalida","EMPTY":"Fecha vacía"}},"FC_TIME_INPUT":{"PLACEHOLDER":"Tiempo","ERRORS":{"RETROACTIVE":"Tiempo retroactivo","INVALID":"Tiempo invalido","EMPTY":"Tiempo vacío"}},"FC_IMPORT_TEMPLATE_BUTTON":{"TEXT":"Importar modelo"},"FC_COLOR_PICKER":{"COLOR_INPUT":{"PLACEHOLDER":"Color"}},"FC_SELECT":{"WITH_SEARCH":{"NO_RESULTS_FOUND":"No se encontraron resultados. "}},"FC_SMART_REWRITE":{"REWRITE_TEXT":"Reescribir texto"},"FC_IMAGE_INPUT":"Este archivo excede el límite de 2MB","MS_INFO_BAR":{"CLOSE":"Cerrar"},"SHORTCUTS":{"MAX_SHORTCUTS":"Máximo de {{shortcutsLimit}} atajos","ADD_OR_REMOVE":"Agregar o quitar atajos","NOT_FOUND":"No se han encontrado atajos","SEARCH":"Buscar atajo","TASKS":"Listado de actividades","DAY_TASKS":"Actividades del dia","TASKS_TYPES":"Tipos de OS","TIMELINE":"Linea de tiempo","MAP":"Mapa","CALENDAR":"Calendario de eventos","RECURRENCES":"Recurrencias","CUSTOMERS":"Clientes","EMPLOYEES":"Lista de empleados","ABSENCES":"Ausencias","ROUTE_HISTORY":"Registro de rutas","DASHBOARD":"Dashboard","RATING":"Calificaciones","EMPLOYEE_REPORT":"Informe del empleado","FORMS_REPORT":"Informe de formularios","TASKS_REPORT":"Informe de servicio","HEAT_MAP":"Mapa de calor","TICKETS":"Solicitudes","EQUIPMENT":"Equipamientos","EQUIPMENT_TYPES":"Tipos de equipamiento","EXPORTS":"Exportaciones","MATERIALS":"Materiales"},"MS_MATERIAL_COLOR_PICKER":{"PALETTE":"Paleta","SELECT_COLOR":"Seleccionar color","REMOVE_COLOR":"Eliminar color"},"MS_NAVIGATION":{"TOGGLE_MOBILE_NAVIGATION":"Alternar navegación móvil"},"MS_SEARCH_BAR":{"SEARCH":"Buscar"},"MS_STEPPER":{"BACK":"Volver","NEXT":"Siguiente","SUBMIT":"ENVIAR","OPTIONAL":"Opcional"},"DATA_TABLE":{"DAY":"día","HOUR":"hora","MINUTE":"minuto","DAYS":"días","HOURS":"horas","MINUTES":"minutos","AND":"y","LOADING":"Cargando ...","EMPTY_TABLE":"No se han encontrado registros","INFO":"Mostrando de _START_ a _END_ de _TOTAL_ registros","INFO_EMPTY":"Mostrando de 0 a 0 de 0 entradas","INFO_FILTERED":"(Filtrado de _MAX_ registros)","LENGTH_MENU":"_MENU_ resultados por página","RESULTS_PER_PAGE":"resultados por página","PROCESSING":"Procesando ...","SEARCH":"Buscar por nombre:","PAGINATE":{"NEXT":"Siguiente","PREVIOUS":"Anterior","FIRST":"Primero","LAST":"Último"},"ARIA":{"SORT_ASCENDING":"Ordenar columnas ascendentes","SORT_DESCENDING":"Ordenar columnas descendentes"},"CHANGE_COLUMNS":"Cambiar columnas"},"TASKS_STATUS":{"PENDING":"Pendiente","SCHEDULED":"Programado","ON_ROUTE":"En ruta","IN_PROGRESS":"En progreso","COMPLETED":"Concluida","CANCELED":"Cancelada","PREVENTED":"Impedida"},"TASKS_DEADLINE_STATUS":{"ON_SCHEDULE":"Dentro del plazo","AT_RISK":"En riesgo","OUT_OF_SCHEDULE":"Violado","COMPLETED_OUT_OF_SCHEDULE":"Completado con violación","COMPLETED_ON_SCHEDULE":"Completado a tiempo","NO_APPLICABLE":"No hay appletl"},"ADDRESS_SERVICE":{"COUNTRIES":{"NO_RESTRICTIONS":"Sin restricciones"},"VALIDATION":{"REQUIRED":"No se especificó la dirección","POSTAL_CODE":"No se especificó el código postal","STATE":"El estado no fue especificado","CITY":"La ciudad no fue especificada","STREET":"La calle no fue especificada","NEIGHBORHOOD":"No se especificó el barrio","NUMBER":"No se especificó el número"}},"EQUIPAMENT_PERMISSION":{"TITLE":"Acceso inválido","MESSAGE":"Aún no tiene acceso al inventario de equipamientos; para obtener más información, comuníquese con nuestro soporte."},"PUSH_NOTIFICATIONS":{"TITLE":"Notificaciones","MESSAGE":"¿Desea recibir notificaciones sobre su operación en el navegador?","OK":"Sí, quiero","CANCEL":"Después"},"ERRORS":{"CONNECTION_ERROR":{"TITLE":"Oops, parece que no estás conectado.","CONTENT":"Asegúrate que estás conectado a una red de internet y vuelva a intentarlo."}},"FC_AUTOCOMPLETE":{"NO_RESULTS":"No se han encontrado resultados"},"CORPORATE_CUSTOMER_DISCLAIMER":"La información de esta página está definida por su cliente <b>{{ customerName }}</b> y, por lo tanto, no se puede editar.","SUBSCRIPTION_DIALOG":{"CLOSE":"Cerrar","CONTRACT_MODULE":"Contratar modulos","USAGE_CONDITIONS":"Condiciones del módulo","TIME_TO_EXPIRE":"Aún quedan <span>{{ timeToExpire }}</span> completos para que caduque su plan anual. Por lo tanto, el valor de este módulo se calculará sobre este tiempo restante.","TABLE":{"DESCRIPTION":"Descripción","QUANTITY":"La cantidad","MONTHLY_PRICE":"Valor mensual","TIME_TO_EXPIRE":"Tiempo restante","DAYS":"Dias","TOTAL_PRICE":"Valor total"},"MODULES":{"VEHICLES":"Control de vehículos"},"ACTIONS":{"FINALIZE_CONTRACTING":"FINALIZAR CONTRATACIÓN"},"ONE_INSTALLMENT":"1 porcion de R${{ price }}","MORE_INSTALLMENTS":"{{installments}} porcion de R${{ price }}","PAYMENT":"Pago (tarjeta de crédito)","MODULE":"Módulo","CARDHOLDER_NAME":"Nombre del titular","CARDHOLDER_NAME_ALERT":"El nombre debe ser el mismo que el nombre en la tarjeta.","CARD_NUMBER":"Numero de tarjeta","VALIDITY":"Fecha de validez","SECURITY_CODE":"Código de seguridad","HAS_CUPOM":"¿Tienes un cupón de descuento? insértelo aquí","NEXT_PAYMENTS_ALERT":"Permitir el uso de la tarjeta de crédito para futuras facturas","INSTALLMENTS":"Cuotas","OBLIGATORY_FIELD":"Campo requerido","CONTRACT_ALERT_TITLE":"¿Desea continuar con la contratación?","CONTRACT_ALERT_DESCRIPTION":"Tras la confirmación, este importe se deducirá de la tarjeta de crédito insertada.","YES":"SÍ","NO":"NO","MONTHS":"mes(es)","DAYS":"día(s)","AND":"y","CONGRATULATIONS_ALERT_TITLE":"¡Felicidades! Has contratado el módulo del vehículo.","CONGRATULATIONS_ALERT_DESCRIPTION":"En breve se enviará un correo electrónico confirmando la contratación del módulo. Actualice la página para acceder a las nuevas funciones.","UPDATE":"ACTUALIZAR","CONFIRMING_PAYMENT":"Estamos confirmando el pago...","EXPIRED_VALIDITY":"Validez caducada","OPERATION_ERROR":"La operacion no pudo ser completada. Verifique los datos en la tarjeta insertada y vuelva a intentarlo.","INVALID_CARD_NUMBER":"Numero de tarjeta invalido","INVALID_VERIFICATION_VALUE":"CVV no válido","RENEW_EXPIRED":"Estás en el período de renovación. Si desea adquirir este módulo, inclúyalo en su suscripción.","NOT_ALLOWED_MONTHLY":"Contacta con tu gestor de cuenta para contratar este módulo."},"WELCOME":"Bienvenido a Field Control","WELCOME_DESCRIPTION":"Aquí hay un breve video para ayudarlo a comenzar a usar la plataforma. ¿Vamos?","WELCOME_CLOSE_DIALOG":"Cerrar","FC_LINK_EQUIPMENT_WITH_ORDER":{"TITLE":"Equipos relacionados {{current}} / {{total}}"},"ATTENTION":"Atención","CLICK_HERE":"Haga clic aquí"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/core/i18n/pt.json',
    '{"CORE":{"INDEX":{"NON_PAYMENT_WARNING":"Ainda não identificamos o pagamento do seu boleto, e a sua conta será bloqueada. Por favor, entre em contato com financeiro@fieldcontrol.com.br","LIMIT_EXCEEDED_WARNING":"Sua conta tem mais licenças ativas do que o plano contratado. Entre em contato com o chat online e peça um contato da gerência da sua conta.","EMAIL_NOT_VALID_WARNING":"Para continuar usando o Field Control é necessário confirmar seu e-mail {{email}}: ","ACCOUNT_SUBSCRIPTION_WARNING_ADMIN":"Sua assinatura deve ser renovada.","ACCOUNT_SUBSCRIPTION_WARNING_USER":"Sua assinatura deve ser renovada. Peça à gestão da sua conta acessar o Field Control.","CLICK_TO_RENEW":"Clique aqui para renová-la.","CLICKING_HERE":"Clique aqui para enviar a confirmação","SENDING":"Enviando...","CONFIRMATION_EMAIL_SUCCESS":"Email de confirmação enviado!","CONFIRMATION_EMAIL_ERROR":"Um erro aconteceu ao enviar o e-mail de confirmação","CONTRACT_NOT_SIGNED":"Não identificamos a assinatura do contrato de utilização da plataforma. Entre em contato com o seu gerente de contas para regularizar a sua situação.","CLICK_TO_SIGN":"Assinar contrato"},"AUTH":{"NOT_ALLOWED":"Usuário não tem permissão para acessar essa página.","WITHOUT_PERMISSIONS":"Você não tem permissões para o sistema."},"BLATOUT":{"TITLE":"Fieldnews - O boletim de novidades do Field Control"},"FC_SPREADSHEET_READER":{"LOADING":"Carregando...","FILE":{"UPLOAD_MESSAGE":"Clique ou arraste a planilha para fazer upload","MAX_SIZE":"O tamanho máximo do arquivo é {{ maxSize }}"},"TOASTS":{"FILE":{"OPEN_ERROR":"Ocorreu um na leitura do arquivo, o arquivo pode estar corrompido e não pode ser aberto."}}},"FC_SPREADSHEET_RESULT":{"TABLE":{"REVIEW":{"STATUS":{"VALID":"Válida","INVALID":"Inválida"},"INVALID_ROWS_PERCENTAGE":"{{ invalidPercentage }}% das linhas estão inconsistentes","WITHOUT_INCONSISTENCY":"Não há linhas inconsistentes nessa planilha"},"COLUMNS":{"VALIDATION":"Validação","ROW":"Linha da planilha","ERRORS_COUNT":"Inconsistências"},"ROWS":{"SPREADSHEET_STATUS":{"VALID":"Válido","INVALID":"Inválido"},"DETAILS":{"MORE":"Mostrar detalhes","LESS":"Ocultar detalhes","FIELDS":"Campos:","INCONSISTENCIES":"Inconsistências:","ROW":"Linha {{ rowNumber }}","ERRORS":{"TYPE":{"MESSAGE":"Esse campo deve ser {{ expectedType }}, mas é {{ receivedType }}.","KINDS":{"STRING":"texto","NUMBER":"numérico","UNKOWN":"desconhecido"}},"EXACT_LENGTH":{"MESSAGE":"Esse campo deve possuir exatamente {{ expectedLength }} caractéres, mas possui {{ receivedLength }}."},"MAX_LENGTH":{"MESSAGE":"Este campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }} caracteres."},"MIN_LENGTH":{"MESSAGE":"Esse campo deve possuir no mínimo {{ expectedLength }} caractéres, mas possui {{ receivedLength }}."},"OPTIONAL":{"MESSAGE":"Esse campo é obrigatório, mas não foi informado."},"PATTERN":{"MESSAGE":"O campo deve atender o padrão ({{ pattern }}) mas é \\"{{ value }}\\"."},"UNIQUENESS":{"MESSAGE":"Os valores do campo devem ser únicos, mas há repetidos."},"INVALID_CPF":{"MESSAGE":"O campo contém um CPF inválido."},"INVALID_CNPJ":{"MESSAGE":"O campo contém um CNPJ inválido."},"MAX_ITEMS":{"MESSAGE":"Só é permitido no máximo {{ maxItems }} valores para esse campo."},"INVALID_SPLITTER":{"MESSAGE":"Esse campo deve ser separado por vírgula ({{ expectedSplit }}), mas está separado por ponto e vírgula ( ; ) ou barra vertical ( | )"}}}}}},"FC_EXPORT_CSV_BUTTON":{"TEXT":"Exportar em CSV"},"FC_EXPORT_EXCEL_BUTTON":{"TEXT":"Exportar em Excel"},"FC_EXPORT_ALERT":{"TITLE":"Solicitação de exportação","TEXT_SEND":"A exportação foi enviada para o e-mail:  ","TEXT_VIEW":"Você também poderá visualizá-la clicando no botão logo abaixo","BUTTON_VIEW":"Visualizar exportações","BUTTON_DONT_SEE":"Não quero mais ver essa mensagem","GENERATING":" Sua exportação está sendo gerada, aguarde o download."},"FC_EXPORT_PRINT_BUTTON":{"TEXT":"Imprimir"},"FC_DATE_INPUT":{"PLACEHOLDER":"Data","ERRORS":{"RETROACTIVE":"Data retroativa","INVALID":"Data inválida","EMPTY":"Data vazia"}},"FC_TIME_INPUT":{"PLACEHOLDER":"Horário","ERRORS":{"RETROACTIVE":"Horário retroativo","INVALID":"Horário inválido","EMPTY":"Horário vazio"}},"FC_IMPORT_TEMPLATE_BUTTON":{"TEXT":"Importar template"},"FC_COLOR_PICKER":{"COLOR_INPUT":{"PLACEHOLDER":"Cor"}},"FC_SELECT":{"WITH_SEARCH":{"NO_RESULTS_FOUND":"Nenhum resultado encontrado"}},"FC_SMART_REWRITE":{"REWRITE_TEXT":"Reescrever texto"},"FC_IMAGE_INPUT":"Este arquivo excede o limite de 2MB","SHORTCUTS":{"MAX_SHORTCUTS":"Máximo de {{shortcutsLimit}} atalhos","ADD_OR_REMOVE":"Adicionar ou remover atalho","NOT_FOUND":"Nenhum atalho encontrado","SEARCH":"Buscar atalho","TASKS":"Atividades","DAY_TASKS":"Atividades do dia","TASKS_TYPES":"Tipos de OS","TIMELINE":"Linha do tempo","MAP":"Mapa","CALENDAR":"Calendário","RECURRENCES":"Recorrências","CUSTOMERS":"Clientes","EMPLOYEES":"Colaboradores","ABSENCES":"Ausências","ROUTE_HISTORY":"Histórico de rotas","DASHBOARD":"Dashboard","RATING":"Avaliações","EMPLOYEE_REPORT":"Relatório de colaboradores","FORMS_REPORT":"Relatório de formulários","TASKS_REPORT":"Relatório de serviços","HEAT_MAP":"Mapa de calor","TICKETS":"Solicitações","EQUIPMENT":"Equipamentos","EQUIPMENT_TYPES":"Tipos de Equipamentos","EXPORTS":"Exportações","MATERIALS":"Materiais"},"MS_INFO_BAR":{"CLOSE":"Fechar"},"MS_MATERIAL_COLOR_PICKER":{"SELECT_COLOR":"Selecione a cor","PALETTE":"Paleta","REMOVE_COLOR":"Remover cor"},"MS_NAVIGATION":{"TOGGLE_MOBILE_NAVIGATION":"Alternar navegação móvel"},"MS_SEARCH_BAR":{"SEARCH":"Procurar"},"MS_STEPPER":{"OPTIONAL":"Opcional","BACK":"Voltar","NEXT":"Próximo","SUBMIT":"Enviar"},"DATA_TABLE":{"DAY":"dia","HOUR":"hora","MINUTE":"minuto","DAYS":"dias","HOURS":"horas","MINUTES":"minutos","AND":"e","LOADING":"Carregando ...","EMPTY_TABLE":"Nenhum registro encontrado","INFO":"Mostrando de _START_ até _END_ de _TOTAL_ registros","INFO_EMPTY":"Mostrando 0 até 0 de 0 registros","INFO_FILTERED":"(Filtrados de _MAX_ registros)","LENGTH_MENU":"_MENU_ resultados por página","RESULTS_PER_PAGE":"resultados por página","PROCESSING":"Processando...","SEARCH":"Pesquisar por nome:","PAGINATE":{"NEXT":"Próximo","PREVIOUS":"Anterior","FIRST":"Primeiro","LAST":"Último"},"ARIA":{"SORT_ASCENDING":"Ordenar colunas de forma ascendente","SORT_DESCENDING":"Ordenar colunas de forma descendente"},"CHANGE_COLUMNS":"Alterar colunas"},"TASKS_STATUS":{"PENDING":"Pendente","SCHEDULED":"Agendada","ON_ROUTE":"Em deslocamento","IN_PROGRESS":"Em andamento","COMPLETED":"Concluída","CANCELED":"Cancelada","PREVENTED":"Impedida"},"TASKS_DEADLINE_STATUS":{"ON_SCHEDULE":"Dentro do prazo","AT_RISK":"Em risco","OUT_OF_SCHEDULE":"Violado","COMPLETED_OUT_OF_SCHEDULE":"Concluído com violação","COMPLETED_ON_SCHEDULE":"Concluído no prazo","NO_APPLICABLE":"Não aplicado"},"ADDRESS_SERVICE":{"COUNTRIES":{"NO_RESTRICTIONS":"Sem restrições"},"VALIDATION":{"REQUIRED":"O endereço não foi especificado","POSTAL_CODE":"O CEP não foi especificado","STATE":"O estado não foi especificado","CITY":"A cidade não foi especificada","STREET":"A rua não foi especificada","NEIGHBORHOOD":"O bairro não foi especificado","NUMBER":"O número não foi especificado"}},"EQUIPAMENT_PERMISSION":{"TITLE":"Acesso inválido","MESSAGE":"Você ainda não possui acesso ao inventário de equipamentos, para maiores informações contate nosso suporte."},"PUSH_NOTIFICATIONS":{"TITLE":"Notificações","MESSAGE":"Deseja receber notificações sobre sua operação no navegador?","OK":"Sim, eu quero","CANCEL":"Mais tarde"},"ERRORS":{"CONNECTION_ERROR":{"TITLE":"Ops, parece que você está sem conexão.","CONTENT":"Verifique se você está conectado em uma rede de internet e tente novamente."}},"FC_AUTOCOMPLETE":{"NO_RESULTS":"Sem resultados"},"CORPORATE_CUSTOMER_DISCLAIMER":"As informações desta página são definidas pelo seu cliente <b>{{ customerName }}</b> e por isso não podem ser editadas.","SUBSCRIPTION_DIALOG":{"CLOSE":"Fechar","CONTRACT_MODULE":"Contratar módulos","USAGE_CONDITIONS":"Condições do módulo","TIME_TO_EXPIRE":"Ainda faltam <span>{{ timeToExpire }}</span> para o seu plano anual terminar. Por isso, o valor deste módulo será calculado em cima desse tempo remanescente.","TABLE":{"DESCRIPTION":"Descrição","QUANTITY":"Quantidade","MONTHLY_PRICE":"Valor mensal","TIME_TO_EXPIRE":"Tempo restante","DAYS":"Dias","TOTAL_PRICE":"Valor total"},"MODULES":{"VEHICLES":"Controle de veículos"},"ACTIONS":{"FINALIZE_CONTRACTING":"FINALIZAR CONTRATAÇÃO"},"ONE_INSTALLMENT":"1 parcela de R${{ price }}","MORE_INSTALLMENTS":"{{installments}} parcelas de R${{ price }}","PAYMENT":"Pagamento (cartão de crédito)","MODULE":"Módulo","CARDHOLDER_NAME":"Nome do titular","CARDHOLDER_NAME_ALERT":"O nome precisa ser o mesmo que consta no cartão.","CARD_NUMBER":"Número do cartão","VALIDITY":"Validade","SECURITY_CODE":"Código de segurança","HAS_CUPOM":"Tem cupom de desconto? Insira-o aqui","NEXT_PAYMENTS_ALERT":"Permitir usar o cartão de crédito para próximas faturas","INSTALLMENTS":"Parcelas","OBLIGATORY_FIELD":"Campo requerido","CONTRACT_ALERT_TITLE":"Deseja prosseguir com a contratação?","CONTRACT_ALERT_DESCRIPTION":"Ao confirmar, este valor será descontado no cartão de crédito inserido.","YES":"SIM","NO":"NÃO","MONTHS":"mes(es)","DAYS":"dia(s)","AND":"e","CONGRATULATIONS_ALERT_TITLE":"Parabéns! Você contratou o módulo de veículos.","CONGRATULATIONS_ALERT_DESCRIPTION":"Um e-mail confirmando a contratação do módulo será enviado em instantes. Atualize a página para ter acesso às novas funcionalidades.","UPDATE":"ATUALIZAR","CONFIRMING_PAYMENT":"Estamos confirmando o pagamento...","EXPIRED_VALIDITY":"Validade expirada","OPERATION_ERROR":"Não foi possível completar a operação. Verifique os dados do cartão inserido e tente novamente.","INVALID_CARD_NUMBER":"Número do cartão inválido","INVALID_VERIFICATION_VALUE":"CVV Inválido","RENEW_EXPIRED":"Você está em período de renovação. Caso queira contratar este módulo, inclua-o na sua assinatura.","NOT_ALLOWED_MONTHLY":"Entre em contato com o seu gerente de contas para fazer a contratação deste módulo."},"WELCOME":"Boas-vindas ao Field Control","WELCOME_DESCRIPTION":"Aqui vai um vídeo curtinho pra te ajudar a dar os primeiros passos na plataforma. Bora?","WELCOME_CLOSE_DIALOG":"Fechar","FC_LINK_EQUIPMENT_WITH_ORDER":{"TITLE":"Vinculando equipamentos {{current}} / {{total}}"},"ATTENTION":"Atenção","CLICK_HERE":"Clique aqui"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/toolbar/i18n/en.json',
    '{"TOOLBAR":{"HELP_MENU":{"TITLE":"Help menu","NEWS_AND_UPDATES":"News and updates","INTRO_VIDEO":"Watch introduction video","HELP_CENTER":"Open help center","SEND_IDEAS":"Product evolutions","FIELD_STATUS":"View Field Control status"},"HELP_TOOLTIP":"You can watch the introduction video here.","NOTIFICATIONS":"Notifications","USER_SETTINGS":{"TITLE":"User settings","PROFILE":"Profile","LOGOUT":"Logout"},"SCHEDULE_DEMO":{"CLICK_TO_SCHEDULE":"Click here to schedule a demo.","CLICK_TO_BUTTON":"Request demo","SUCCESS":"Thank you for scheduling a demo! We will contact you shortly.","ERROR":"Error scheduling a demo, please check your connection and try again later."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/toolbar/i18n/es.json',
    '{"TOOLBAR":{"HELP_MENU":{"TITLE":"Menú de ayuda","NEWS_AND_UPDATES":"Noticias y actualizaciones","INTRO_VIDEO":"Ver video de introducción","HELP_CENTER":"Abrir centro de ayuda","SEND_IDEAS":"Evoluciones del producto","FIELD_STATUS":"Ver estado del Field Control"},"HELP_TOOLTIP":"Puede ver el video de introducción aquí.","NOTIFICATIONS":"Notificaciones","USER_SETTINGS":{"TITLE":"Configuraciones del usuario","PROFILE":"Perfil","LOGOUT":"Salir"},"SCHEDULE_DEMO":{"CLICK_TO_SCHEDULE":"Haga clic aquí para programar una demostración.","CLICK_TO_BUTTON":"Solicitar demostración","SUCCESS":"¡Gracias por programar una demostración! Nos pondremos en contacto contigo en breve.","ERROR":"Error al programar una demostración, por favor revise su conexión e inténtelo de nuevo más tarde."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/toolbar/i18n/pt.json',
    '{"TOOLBAR":{"HELP_MENU":{"TITLE":"Menu de ajuda","NEWS_AND_UPDATES":"Novidades e atualizações","INTRO_VIDEO":"Assistir vídeo de introdução","HELP_CENTER":"Abrir central de ajuda","SEND_IDEAS":"Evoluções do produto","FIELD_STATUS":"Ver status do Field Control"},"HELP_TOOLTIP":"Você poderá assistir a introdução aqui.","NOTIFICATIONS":"Notificações","USER_SETTINGS":{"TITLE":"Configurações do usuário","PROFILE":"Perfil","LOGOUT":"Sair"},"SCHEDULE_DEMO":{"CLICK_TO_SCHEDULE":"Clique aqui para agendar uma demonstração.","CLICK_TO_BUTTON":"Solicitar demonstração","SUCCESS":"Obrigado por agendar uma demonstração! Em breve entraremos em contato.","ERROR":"Erro ao agendar uma demonstração, verifique sua conexão e tente novamente mais tarde."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/core/integrations/i18n/en.json',
    '{"INTEGRATIONS":{"TASKS":{"EXPORT":{"OMIE":{"ACCOUNT":{"TITLE":"Omie Account","DESCRIPTION":"Select the Omie account to which you want to send this service order","SELECT":"Select a Omie account"},"CUSTOMERS":{"TITLE":"Omie Customers","DESCRIPTION":"Select the Omie customer you want to send this service order","SELECT":"Select a Omie customer","SEARCH":"Search customer by name"},"PRODUCTS":{"USED_PRODUCTS":"Products used","NAME":"Name","MEASURE":"Measure","QUANTITY":"Quantity","UNIT_VALUE":"Unit value","PRODUCT_NOT_FOUND":"Product not found","PRODUCT":"Product","AT_LEAST_ONE_PRODUCT":"Must have at least one product","ADD_PRODUCT":"ADD PRODUCT","ADD_PRODUCT_MOVEMENT":"The inventory control module is active, and therefore, for you to send products from the Field to Omie, it is necessary to perform the transaction through the service order."},"REQUIRED":"This field is required","UNIQUE_PRODUCT":"Repeated product","ADD_MORE_LINE":"add 1 line","SALES_FORECAST":"Revenue forecast *","CITY_SERVICE":"City of service","CITY_NOT_FOUND":"No cities found","SELECT_CITY":"Select city","CLEAR_CITY":"Clear city","CATEGORY":"Category","CUSTOMER":"Customer","CUSTOMER_NOT_FOUND":"No customers found","SELECT_CUSTOMER":"Select customer","CLEAR_CUSTOMER":"Clear customer","BANK_ACCOUNT":"Bank account","INSTALLMENTS":"Installments","INSTALLMENT_NOT_FOUND":"No installments found","ON_CASH":"Cash","X_INSTALLMENTS":"{{ total }} installments","SELLER":"Seller","SELLER_NOT_EDITABLE":"It is not possible to change the seller of a service order that has already been sent","DEFAULT_SELLER":"No seller","SERVICES_PERFORMED":"Tasks performed","SERVICE":"Task","SERVICE_NOT_FOUND":"No services found","SERVICE_LC116":"Task code LC 116","RETAIN_ISS":"Retain taxes *","YES":"Yes","NO":"No","QTY":"Amount","UNIT_VALUE":"Unit value","AT_LEAST_ONE_SERVICE":"One service at least necessary","ADD_ONE_LINE":"add 1 line","SEND":"Send","BANKACCOUNTS":"Checking accounts","SERVICES":"Services","CITIES":"Cities","CATEGORIES":"Categories","CHECKING_DATA":"Checking data...","ERRORS":{"MIN_UNIT_VALUE":"Must be greater than zero"},"MULTIPLE_MATCHING_CUSTOMERS":"More than one matching customer","ERROR_LOADING_LC116":"Error: Omie\'s LC 116 service codes could not be loaded","ERROR_LOADING_CATEGORIES":"Error: Omie\'s categories could not be loaded","ERROR_LOADING_BANK_ACCOUNTS":"Error: Omie\'s bank accounts could not be loaded","ERROR_LOADING_SERVICES":"You do not have any services registered in the system, therefore it was not possible to proceed with the action. Make sure to register them and try again.","ERROR_LOADING_PAYMENTS":"Error: Omie\'s payment methods could not be loaded","ERROR_INEXISTENT_RESOURCE":"It was not possible to identify all your customer data, either on Field Control, or Omie. Confirm that your customer has street address , number., City, company registry number, and try again.","ERROR_KEY":"Your key is invalid or the application has been suspended.","ERROR_UNKNOWN":"An unknown error has occurred, please try again later or contact support.","ERROR_LOADING_DATA":"Error loading data from {{ app}}","ERROR_INEXISTENT_INFO":"Without these resources it is not possible to proceed, be sure to register them and try again.","QUANTITY_WILL_NOT_BE_CHANGED_DIALOG":{"TITLE":"Warning","CONTENT":"It was not possible to calculate the quantity of services performed based on the activity duration, as there are no visits with start and end dates in the work order. Therefore, the \'quantity\' field will be filled with the default value of \'1\'.","CONTINUE":"Continue"}},"DIALOG":{"TOOLBAR":{"TITLE":"Send task to {{ app }}"},"TASK_DATA":"Task data"},"ERROR":"Error","SUCCESS_MESSAGE":"Task sent to {{ app }}"}},"QUOTATIONS":{"ERROR":"Error sending quotation to Omie","WARNING":"Warning","CANCEL":"Cancel","CONFIRM":"Confirm","UNIQUE_PRODUCT":"Repeated product","SUCCESS_MESSAGE":"Quotation successfully sent to Omie","ERROR_MESSAGE":"An error occurred while sending the quotation to Omie","ERROR_UNKNOWN":"An unknown error has occurred, please try again later or contact support.","ERRORS":{"MIN_UNIT_VALUE":"Must be greater than zero","PERCENTAGE_DISCOUNT":"Invalid value","VALUE_DISCOUNT":"Invalid value"},"ERROR_LOADING_DATA":"Error loading Omie data","ERROR_NO_PRODUCTS_OR_SERVICES":"No product or service linked to the quotation was found in Omie","ERROR_ONLY_SERVICE_AND_NO_ORDER_LINKED":"Only services were found linked to this quotation, but there is no service order linked. To send the quotation to Omie, it is necessary to have a linked service order.","ERROR_INEXISTENT_RESOURCE":"It was not possible to identify all your customer data, either on Field Control, or Omie. Confirm that your customer has street address, number., City, company registry number, and try again.","DIALOG":{"TITLE":"Send quotation to Omie","QUOTATION_DATA":"Quotation data"},"ACCOUNT":{"TITLE":"Omie Account","DESCRIPTION":"Select the Omie account you want to send this quotation to","SELECT":"Select an Omie account"},"CUSTOMERS":{"TITLE":"Omie Customers","DESCRIPTION":"Select the Omie customer you want to send this quotation to","SELECT":"Select an Omie customer"},"PRODUCTS":{"USED_PRODUCTS":"Used products","NAME":"Name","MEASURE":"Unit","QUANTITY":"Quantity","UNIT_VALUE":"Unit value","PRODUCT_NOT_FOUND":"Product not found","PRODUCT":"Product","AT_LEAST_ONE_PRODUCT":"At least one product is required","ADD_PRODUCT":"ADD PRODUCT","ADD_PRODUCT_MOVEMENT":"The inventory control module is active, so to send products from Field to Omie, you must move them through the service order."},"SELECT_CUSTOMER":"Customer","MULTIPLE_MATCHING_CUSTOMERS":"More than one customer found","CATEGORY":"Category","SALES_FORECAST":"Sales forecast *","CITY_SERVICE":"City where the service is performed","REQUIRED":"Required field","BANK_ACCOUNT":"Bank account","INSTALLMENTS":"Number of installments","INSTALLMENT_NOT_FOUND":"No installment found","ON_CASH":"Cash","X_INSTALLMENTS":"{{ total }} installments","SELLER":"Seller","SELLER_NOT_EDITABLE":"You cannot change the seller of an already sent quotation","DEFAULT_SELLER":"No seller","SERVICES_PERFORMED":"Services performed","SERVICE":"Service","SERVICE_NOT_FOUND":"No service found","SERVICE_LC116":"LC 116 Service Code","RETAIN_ISS":"Withhold ISS *","YES":"Yes","NO":"No","QTY":"Quantity","UNIT_VALUE":"Unit value","AT_LEAST_ONE_SERVICE":"At least one service is required","ADD_ONE_LINE":"ADD SERVICE","SEND":"Send","BANKACCOUNTS":"Bank accounts","SERVICES":"Services","CITIES":"Cities","CATEGORIES":"Categories","CHECKING_DATA":"Checking data...","SENDING_TO_OMIE":"Sending quotation to Omie...","DISCOUNT":"Discount","DISCOUNT_TYPE":"Discount type","DISCOUNT_TYPE_OPTIONS":{"PERCENTAGE":"Percentage","VALUE":"Value"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/core/integrations/i18n/es.json',
    '{"INTEGRATIONS":{"TASKS":{"EXPORT":{"OMIE":{"ACCOUNT":{"TITLE":"Cuenta Omie","DESCRIPTION":"Seleccione la cuenta Omie a la que desea enviar esta orden de servicio","SELECT":"Seleccione una cuenta Omie"},"CUSTOMERS":{"TITLE":"Clientes Omie","DESCRIPTION":"Seleccione el cliente de Omie al que desea enviar esta orden de servicio.","SELECT":"Selecciona un cliente Omie","SEARCH":"Buscar cliente por nombre"},"PRODUCTS":{"USED_PRODUCTS":"Productos utilizados","NAME":"Nombre","MEASURE":"Medida","QUANTITY":"Cantidad","UNIT_VALUE":"Valor unitario","PRODUCT_NOT_FOUND":"Producto no encontrado","PRODUCT":"Producto","AT_LEAST_ONE_PRODUCT":"Deve conter ao menos um producto","ADD_PRODUCT":"ADICIONAR PRODUCTO","ADD_PRODUCT_MOVEMENT":"El módulo de control de inventario está activo y, por lo tanto, para que puedas enviar productos desde el Campo a Omie, es necesario realizar la transacción a través de la orden de servicio."},"REQUIRED":"Este campo es obligatorio","UNIQUE_PRODUCT":"Producto repetido","ADD_MORE_LINE":"agregar 1 nueva línea","SALES_FORECAST":"Previsión de facturación *","CITY_SERVICE":"Ciudad de provisión de servicio","CITY_NOT_FOUND":"No se encontró ninguna ciudad","SELECT_CITY":"Seleccione ciudad","CLEAR_CITY":"Limpar ciudad","CATEGORY":"Categoría","CUSTOMER":"Cliente","CUSTOMER_NOT_FOUND":"No se encontraron clientes","SELECT_CUSTOMER":"Seleccionar cliente","CLEAR_CUSTOMER":"Limpiar cliente","BANK_ACCOUNT":"Cuenta bancaria","INSTALLMENTS":"Número de cuotas","INSTALLMENT_NOT_FOUND":"No se encontró ninguna parcela","ON_CASH":"Al contado","X_INSTALLMENTS":"{{ total }} cuotas","SELLER":"Vendedor","SELLER_NOT_EDITABLE":"No es posible cambiar el vendedor de una orden de servicio ya enviada","DEFAULT_SELLER":"Sin vendedor","SERVICES_PERFORMED":"Servicios realizados","SERVICE":"Servicio","SERVICE_NOT_FOUND":"No se encontraron servicios","SERVICE_LC116":"Código de servicio LC 116","RETAIN_ISS":"Retiene impuestos *","YES":"Si","NO":"No","QTY":"Ctd","UNIT_VALUE":"Valor unitário","AT_LEAST_ONE_SERVICE":"Debe tener al menos un servicio","ADD_ONE_LINE":"agregar 1 línea","SEND":"Enviar","BANKACCOUNTS":"Cuentas bancaria","SERVICES":"Servicios","CITIES":"Ciudades","CATEGORIES":"Categorias","CHECKING_DATA":"Comprobando los datos...","ERRORS":{"MIN_UNIT_VALUE":"Debe ser mayor que cero"},"MULTIPLE_MATCHING_CUSTOMERS":"Más de un cliente coincidente","ERROR_LOADING_LC116":"Error: No se pudieron cargar todos los códigos LC 116 de Omie","ERROR_LOADING_CATEGORIES":"Error: No se pudieron cargar todas las categorías de Omie","ERROR_LOADING_BANK_ACCOUNTS":"Error: No se pudieron cargar las cuentas corrientes de Omie","ERROR_LOADING_SERVICES":"No tiene ningún servicio registrado en el sistema, por lo tanto no fue posible continuar con la acción. Asegúrese de registrarlos e intentarlo de nuevo.","ERROR_LOADING_PAYMENTS":"Error: No se pueden cargar las formas de pago de Omie","ERROR_INEXISTENT_RESOURCE":"No fue posible identificar todos los datos de sus clientes, ni en Field Control ni en Omie. Confirme que su cliente tenga Calle, No., Ciudad, código de identificación fiscal e intente nuevamente.","ERROR_KEY":"Tu clave no es válida o la aplicación ha sido suspendida.","ERROR_UNKNOWN":"Se ha producido un error desconocido. Vuelva a intentarlo más tarde o póngase en contacto con el servicio de asistencia.","ERROR_LOADING_DATA":"Error al cargar datos de {{ app }}","ERROR_INEXISTENT_INFO":"Sin estos recursos no es posible continuar, asegúrese de registrarlos e intente nuevamente.","QUANTITY_WILL_NOT_BE_CHANGED_DIALOG":{"TITLE":"Advertencia","CONTENT":"No se pudo calcular la cantidad de servicios realizados en función de la duración de la actividad, ya que no hay visitas con fecha de inicio y finalización en la orden de servicio. Por lo tanto, el campo de \'cantidad\' se completará con el valor predeterminado de \'1\'.","CONTINUE":"Continuar"}},"DIALOG":{"TOOLBAR":{"TITLE":"Enviar actividad a {{ app }}"},"TASK_DATA":"Dados da actividad"},"ERROR":"Error","SUCCESS_MESSAGE":"Actividad enviada con éxito a {{ app }}"}},"QUOTATIONS":{"ERROR":"Error al enviar el presupuesto a Omie","WARNING":"Advertencia","CANCEL":"Cancelar","CONFIRM":"Confirmar","UNIQUE_PRODUCT":"Producto repetido","SUCCESS_MESSAGE":"Presupuesto enviado con éxito a Omie","ERROR_MESSAGE":"Ocurrió un error al enviar el presupuesto a Omie","ERROR_UNKNOWN":"Ocurrió un error desconocido, intente nuevamente más tarde o comuníquese con el soporte.","ERRORS":{"MIN_UNIT_VALUE":"Debe ser mayor que cero","PERCENTAGE_DISCOUNT":"Valor inválido","VALUE_DISCOUNT":"Valor inválido"},"ERROR_LOADING_DATA":"Error al cargar los datos de Omie","ERROR_NO_PRODUCTS_OR_SERVICES":"No se encontró ningún producto o servicio vinculado al presupuesto en Omie","ERROR_ONLY_SERVICE_AND_NO_ORDER_LINKED":"Solo se encontraron servicios vinculados a este presupuesto, pero no hay una orden de servicio vinculada. Para enviar el presupuesto a Omie, es necesario que haya una orden de servicio vinculada.","ERROR_INEXISTENT_RESOURCE":"No fue posible identificar todos los datos de su cliente, ya sea en Field Control o en Omie. Confirme que su cliente tenga Calle, No., Ciudad, código de identificación fiscal e intente nuevamente.","DIALOG":{"TITLE":"Enviar presupuesto a Omie","QUOTATION_DATA":"Datos del presupuesto"},"ACCOUNT":{"TITLE":"Cuenta de Omie","DESCRIPTION":"Seleccione la cuenta de Omie a la que desea enviar este presupuesto","SELECT":"Seleccione una cuenta de Omie"},"CUSTOMERS":{"TITLE":"Clientes de Omie","DESCRIPTION":"Seleccione el cliente de Omie al que desea enviar este presupuesto","SELECT":"Seleccione un cliente de Omie"},"PRODUCTS":{"USED_PRODUCTS":"Productos utilizados","NAME":"Nombre","MEASURE":"Unidad","QUANTITY":"Cantidad","UNIT_VALUE":"Valor unitario","PRODUCT_NOT_FOUND":"Producto no encontrado","PRODUCT":"Producto","AT_LEAST_ONE_PRODUCT":"Debe contener al menos un producto","ADD_PRODUCT":"AGREGAR PRODUCTO","ADD_PRODUCT_MOVEMENT":"El módulo de control de inventario está activo, por lo tanto, para enviar productos desde Field a Omie, debe realizar el movimiento a través de la orden de servicio."},"SELECT_CUSTOMER":"Cliente","MULTIPLE_MATCHING_CUSTOMERS":"Se encontraron varios clientes","CATEGORY":"Categoría","SALES_FORECAST":"Previsión de facturación *","CITY_SERVICE":"Ciudad donde se presta el servicio","REQUIRED":"Campo obligatorio","BANK_ACCOUNT":"Cuenta corriente","INSTALLMENTS":"Número de cuotas","INSTALLMENT_NOT_FOUND":"No se encontraron cuotas","ON_CASH":"Al contado","X_INSTALLMENTS":"{{ total }} cuotas","SELLER":"Vendedor","SELLER_NOT_EDITABLE":"No se puede cambiar el vendedor de un presupuesto ya enviado","DEFAULT_SELLER":"Sin vendedor","SERVICES_PERFORMED":"Servicios realizados","SERVICE":"Servicio","SERVICE_NOT_FOUND":"No se encontró ningún servicio","SERVICE_LC116":"Código del servicio LC 116","RETAIN_ISS":"¿Retiene ISS? *","YES":"Sí","NO":"No","QTY":"Cantidad","UNIT_VALUE":"Valor unitario","AT_LEAST_ONE_SERVICE":"Debe tener al menos un servicio","ADD_ONE_LINE":"AGREGAR SERVICIO","SEND":"Enviar","BANKACCOUNTS":"Cuentas corrientes","SERVICES":"Servicios","CITIES":"Ciudades","CATEGORIES":"Categorías","CHECKING_DATA":"Verificando datos...","SENDING_TO_OMIE":"Enviando presupuesto a Omie...","DISCOUNT":"Descuento","DISCOUNT_TYPE":"Tipo de descuento","DISCOUNT_TYPE_OPTIONS":{"PERCENTAGE":"Porcentaje","VALUE":"Valor"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/core/integrations/i18n/pt.json',
    '{"INTEGRATIONS":{"TASKS":{"EXPORT":{"OMIE":{"ACCOUNT":{"TITLE":"Conta Omie","DESCRIPTION":"Selecione a conta Omie que deseja enviar esta ordem de serviço","SELECT":"Selecione uma conta Omie"},"CUSTOMERS":{"TITLE":"Clientes Omie","DESCRIPTION":"Selecione o cliente Omie que deseja enviar esta ordem de serviço","SELECT":"Selecione um cliente Omie","SEARCH":"Pesquisar cliente por nome"},"PRODUCTS":{"USED_PRODUCTS":"Produtos utilizados","NAME":"Nome","MEASURE":"Medida","QUANTITY":"Quantidade","UNIT_VALUE":"Valor unitário","PRODUCT_NOT_FOUND":"Produto não encontrado","PRODUCT":"Produto","AT_LEAST_ONE_PRODUCT":"Deve conter ao menos um produto","ADD_PRODUCT":"ADICIONAR PRODUTO","ADD_PRODUCT_MOVEMENT":"O módulo de controle de estoque está ativo e, portanto, para que você possa enviar produtos do Field para o Omie, é necessário realizar a movimentação através da ordem de serviço."},"REQUIRED":"Campo obrigatório","UNIQUE_PRODUCT":"Produto repetido","ADD_MORE_LINE":"ADICIONAR SERVIÇO","SALES_FORECAST":"Previsão de faturamento *","CITY_SERVICE":"Cidade da prestação do serviço","CITY_NOT_FOUND":"Nenhuma cidade foi encontrada","SELECT_CITY":"Selecione a cidade","CLEAR_CITY":"Limpar cidade","CATEGORY":"Categoria","CUSTOMER":"Cliente","CUSTOMER_NOT_FOUND":"Nenhum cliente foi encontrado","SELECT_CUSTOMER":"Cliente","CLEAR_CUSTOMER":"Limpar cliente","BANK_ACCOUNT":"Conta corrente","INSTALLMENTS":"Número de parcelas","INSTALLMENT_NOT_FOUND":"Nenhuma parcela foi encontrada","ON_CASH":"À vista","X_INSTALLMENTS":"{{ total }} parcelas","SELLER":"Vendedor","SELLER_NOT_EDITABLE":"Não é possível alterar o vendedor de uma OS já enviada","DEFAULT_SELLER":"Sem vendedor","SERVICES_PERFORMED":"Serviços realizados","SERVICE":"Serviço","SERVICE_NOT_FOUND":"Nenhum serviço foi encontrado","SERVICE_LC116":"Código do serviço LC 116","RETAIN_ISS":"Retem ISS *","YES":"Sim","NO":"Não","QTY":"Quantidade","UNIT_VALUE":"Valor unitário","AT_LEAST_ONE_SERVICE":"Precisa ter pelo menos um serviço","ADD_ONE_LINE":"ADICIONAR SERVIÇO","SEND":"Enviar","BANKACCOUNTS":"Conta correntes","SERVICES":"Serviços","CITIES":"Cidades","CATEGORIES":"Categorias","CHECKING_DATA":"Verificando os dados...","ERRORS":{"MIN_UNIT_VALUE":"Deve ser maior que zero"},"MULTIPLE_MATCHING_CUSTOMERS":"Mais de um cliente encontrado","ERROR_LOADING_LC116":"Erro: Não foi possível carregar todos os códigos de serviço LC 116 da Omie","ERROR_LOADING_CATEGORIES":"Erro: Não foi possível carregar as categorias da Omie","ERROR_LOADING_BANK_ACCOUNTS":"Erro: Não foi possível carregar as contas correntes da Omie","ERROR_LOADING_SERVICES":"Você não possui serviços cadastrados no sistema, portanto não foi possível prosseguir com a ação. Certifique-se de cadastrá-los e tente novamente.","ERROR_LOADING_PAYMENTS":"Error: Não foi possível carregar as formas de pagamento da Omie","ERROR_INEXISTENT_RESOURCE":"Não foi possível identificar todos os dados do seu cliente, seja no Field Control, ou no Omie. Confirme se o seu cliente tem Rua, nº, Cidade, CPF/CNPJ, e tente novamente.","ERROR_KEY":"Sua chave não é válida ou o aplicativo foi suspenso.","ERROR_UNKNOWN":"Ocorreu um erro desconhecido, tente novamente mais tarde ou entre em contato com o suporte.","ERROR_LOADING_DATA":"Erro ao carregar os dados do {{ app }}","ERROR_INEXISTENT_INFO":"Sem esses recursos não é possível prosseguir, certifique-se de cadastrá-los e tente novamente.","QUANTITY_WILL_NOT_BE_CHANGED_DIALOG":{"TITLE":"Aviso","CONTENT":"Não foi possível calcular a quantidade de serviços realizados com base na duração da atividade, pois não há visitas com data de início e término na ordem de serviço. Portanto, o campo de ”quantidade” será preenchido com o valor padrão de ”1”.","CONTINUE":"Continuar"}},"DIALOG":{"TOOLBAR":{"TITLE":"Enviar atividade para {{ app }}"},"TASK_DATA":"Dados da atividade"},"ERROR":"Erro","SUCCESS_MESSAGE":"Atividade enviada com sucesso para o {{ app }}"}},"QUOTATIONS":{"ERROR":"Erro ao enviar orçamento para o Omie","WARNING":"Aviso","CANCEL":"Cancelar","CONFIRM":"Confirmar","UNIQUE_PRODUCT":"Produto repetido","SUCCESS_MESSAGE":"Orçamento enviado com sucesso para o Omie","ERROR_MESSAGE":"Ocorreu um erro ao enviar o orçamento para o Omie","ERROR_UNKNOWN":"Ocorreu um erro desconhecido, tente novamente mais tarde ou entre em contato com o suporte.","ERRORS":{"MIN_UNIT_VALUE":"Deve ser maior que zero","PERCENTAGE_DISCOUNT":"Valor invalido","VALUE_DISCOUNT":"Valor inválido"},"ERROR_LOADING_DATA":"Erro ao carregar os dados do Omie","ERROR_NO_PRODUCTS_OR_SERVICES":"Nenhum produto ou serviço vinculado ao orçamento foi encontrado na Omie","ERROR_ONLY_SERVICE_AND_NO_ORDER_LINKED":"Apenas serviços foram encontrados vinculados a este orçamento, mas não há ordem de serviço vinculada. Para enviar o orçamento para o Omie, é necessário que haja uma ordem de serviço vinculada.","ERROR_INEXISTENT_RESOURCE":"Não foi possível identificar todos os dados do seu cliente, seja no Field Control, ou no Omie. Confirme se o seu cliente tem Rua, nº, Cidade, CPF/CNPJ, e tente novamente.","DIALOG":{"TITLE":"Enviar orçamento para o Omie","QUOTATION_DATA":"Dados do orçamento"},"ACCOUNT":{"TITLE":"Conta Omie","DESCRIPTION":"Selecione a conta Omie que deseja enviar esta ordem de serviço","SELECT":"Selecione uma conta Omie"},"CUSTOMERS":{"TITLE":"Clientes Omie","DESCRIPTION":"Selecione o cliente Omie que deseja enviar este orçamento","SELECT":"Selecione um cliente Omie"},"PRODUCTS":{"USED_PRODUCTS":"Produtos utilizados","NAME":"Nome","MEASURE":"Medida","QUANTITY":"Quantidade","UNIT_VALUE":"Valor unitário","PRODUCT_NOT_FOUND":"Produto não encontrado","PRODUCT":"Produto","AT_LEAST_ONE_PRODUCT":"Deve conter ao menos um produto","ADD_PRODUCT":"ADICIONAR PRODUTO","ADD_PRODUCT_MOVEMENT":"O módulo de controle de estoque está ativo e, portanto, para que você possa enviar produtos do Field para o Omie, é necessário realizar a movimentação através da ordem de serviço."},"SELECT_CUSTOMER":"Cliente","MULTIPLE_MATCHING_CUSTOMERS":"Mais de um cliente encontrado","CATEGORY":"Categoria","SALES_FORECAST":"Previsão de faturamento *","CITY_SERVICE":"Cidade da prestação do serviço","REQUIRED":"Campo obrigatório","BANK_ACCOUNT":"Conta corrente","INSTALLMENTS":"Número de parcelas","INSTALLMENT_NOT_FOUND":"Nenhuma parcela foi encontrada","ON_CASH":"À vista","X_INSTALLMENTS":"{{ total }} parcelas","SELLER":"Vendedor","SELLER_NOT_EDITABLE":"Não é possível alterar o vendedor de uma OS já enviada","DEFAULT_SELLER":"Sem vendedor","SERVICES_PERFORMED":"Serviços realizados","SERVICE":"Serviço","SERVICE_NOT_FOUND":"Nenhum serviço foi encontrado","SERVICE_LC116":"Código do serviço LC 116","RETAIN_ISS":"Retem ISS *","YES":"Sim","NO":"Não","QTY":"Quantidade","UNIT_VALUE":"Valor unitário","AT_LEAST_ONE_SERVICE":"Precisa ter pelo menos um serviço","ADD_ONE_LINE":"ADICIONAR SERVIÇO","SEND":"Enviar","BANKACCOUNTS":"Conta correntes","SERVICES":"Serviços","CITIES":"Cidades","CATEGORIES":"Categorias","CHECKING_DATA":"Verificando os dados...","SENDING_TO_OMIE":"Enviando orçamento para o Omie...","DISCOUNT":"Desconto","DISCOUNT_TYPE":"Tipo de desconto","DISCOUNT_TYPE_OPTIONS":{"PERCENTAGE":"Porcentagem","VALUE":"Valor"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/absences/i18n/en.json',
    '{"ABSENCES":{"PAGE_TITLE":"Absences","TITLE":"Absences","DESCRIPTION":"An absence is a temporary leave of absence for an employee. Example: medical, training, vacation, etc...","SEARCH":"Search","NEW":"Add absence","RELOAD":"Reload","FILTER":"Filter absences","MODEL":{"FROM":"From","TO":"To","REASON":"Reason","EMPLOYEE":"Employee","ERRORS":{"DATE_REQUIRED":"Date is required","DATE_VALID":"Date is invalid","REASON_REQUIRED":"Reason is required","REASON_MAX":"Maximum of 50 characters","EMPLOYEE_REQUIRED":"Employee is required"}},"FILTERS":{"TITLE":"Filter absences","CLEAR":"Clear filters","REASON":"Search by reason","CUSTOMER":"Search by customer","DATE":{"START":"Filter by start date","END":"Filter by end date","SELECT":"Select date","FROM":"From:","TO":"To:"},"OBSERVATION":"Search by observation","EMPLOYEE":"Search by employee"},"DIALOG":{"TITLE_NEW":"New absence","TITLE_EDIT":"Edit absence","SELECT_EMPLOYEE":"Select an employee","SELECT_DATE":"Select date","SAVE":"Save","CREATE":"Create","DELETE":"Delete","DELETE_ALERT":{"TITLE":"Delete absence?","TEXT_CONTENT":"Once deleted, it cannot be recovered. Do you want to continue?","OK":"Yes, I want to","CANCEL":"Better not"}},"TABLE":{"EMPLOYEE":"Employee","REASON":"Reason","START_DATE":"Start date","END_DATE":"End date","CREATED_AT":"Created at","ACTIONS":"Actions","EDIT":"Edit","CREATE_NEW_CTA":"You can create a new absence","CREATE_NEW_LINK":"by clicking here"},"TOAST":{"SUCCESSFULLY_REMOVED":"Absence of \'{{ employeeName }}\' removed.","REMOVE_FAILED":"Unable to exclude the absence of \'{{ employeeName }}\', try again.","SAVE_SUCCESSFULLY":"Absence of \'{{ employeeName }}\' saved."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/absences/i18n/es.json',
    '{"ABSENCES":{"PAGE_TITLE":"Ausencias","TITLE":"Ausencias","DESCRIPTION":"Una ausencia es una ausencia temporal de un empleado. Ejemplo: médica, capacitación, vacaciones, etc...","SEARCH":"Buscar","NEW":"Agregar ausencia","RELOAD":"Recargar","FILTER":"Filtrar ausencias","MODEL":{"FROM":"Desde","TO":"Hasta","REASON":"Motivo","EMPLOYEE":"Empleado","ERRORS":{"DATE_REQUIRED":"Fecha requerida","DATE_VALID":"Fecha no válida","REASON_REQUIRED":"Motivo requerido","REASON_MAX":"Máximo de 50 caracteres","EMPLOYEE_REQUIRED":"Empleado requerido"}},"FILTERS":{"TITLE":"Filtrar ausencias","CLEAR":"Limpiar filtros","REASON":"Buscar por motivo","CUSTOMER":"Buscar por cliente","DATE":{"START":"Filtrar por fecha de inicio","END":"Filtrar por fecha de fin","SELECT":"Seleccionar fecha","FROM":"Desde:","TO":"Hasta:"},"OBSERVATION":"Buscar por observación","EMPLOYEE":"Buscar por empleado"},"DIALOG":{"TITLE_NEW":"Nueva ausencia","TITLE_EDIT":"Editar ausencia","SELECT_EMPLOYEE":"Seleccionar un empleado","SELECT_DATE":"Seleccionar fecha","SAVE":"Guardar","CREATE":"Crear","DELETE":"Eliminar","DELETE_ALERT":{"TITLE":"¿Eliminar ausencia?","TEXT_CONTENT":"Una vez eliminada, no se podrá recuperar. ¿Quieres continuar?","OK":"Sí, quiero","CANCEL":"Mejor no"}},"TABLE":{"EMPLOYEE":"Empleado","REASON":"Motivo","START_DATE":"Fecha de Inicio","END_DATE":"Fecha de Fin","CREATED_AT":"Creado en","ACTIONS":"Acciones","EDIT":"Editar","CREATE_NEW_CTA":"Puedes crear una nueva ausencia","CREATE_NEW_LINK":"haciendo clic aquí"},"TOAST":{"SUCCESSFULLY_REMOVED":"Ausencia de \'{{ employeeName }}\' eliminada correctamente.","REMOVE_FAILED":"No se pudo eliminar la ausencia de \'{{ employeeName }}\', por favor inténtalo de nuevo.","SAVE_SUCCESSFULLY":"Indisponibilidad de \'{{ employeeName }}\' guardada correctamente."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/absences/i18n/pt.json',
    '{"ABSENCES":{"PAGE_TITLE":"Ausências","TITLE":"Ausências","DESCRIPTION":"Uma ausência é um afastamento temporário de um colaborador. Exemplo: médico, treinamento, férias, etc...","SEARCH":"Pesquisar","NEW":"Adicionar ausência","RELOAD":"Atualizar","FILTER":"Filtrar ausências","MODEL":{"FROM":"A partir de","TO":"Até","REASON":"Motivo","EMPLOYEE":"Colaborador","ERRORS":{"DATE_REQUIRED":"Data é obrigatória","DATE_VALID":"Data é inválida","REASON_REQUIRED":"Motivo é obrigatório","REASON_MAX":"Máximo de 50 caracteres","EMPLOYEE_REQUIRED":"Colaborador é obrigatório"}},"FILTERS":{"TITLE":"Filtrar ausências","CLEAR":"Limpar filtros","REASON":"Buscar por motivo","CUSTOMER":"Buscar por cliente","DATE":{"START":"Filtrar por data de início","END":"Filtrar por data de término","SELECT":"Selecionar data","FROM":"De:","TO":"Até:"},"OBSERVATION":"Buscar por observação","EMPLOYEE":"Buscar por colaborador"},"DIALOG":{"TITLE_NEW":"Nova ausência","TITLE_EDIT":"Editar ausência","SELECT_EMPLOYEE":"Selecione um funcionário","SELECT_DATE":"Selecionar data","SAVE":"Salvar","CREATE":"Criar","DELETE":"Excluir","DELETE_ALERT":{"TITLE":"Excluir ausência?","TEXT_CONTENT":"Depois de excluída, não será possível recuperar. Quer continuar?","OK":"Sim, eu quero","CANCEL":"Melhor não"}},"TABLE":{"EMPLOYEE":"Colaborador","REASON":"Motivo","START_DATE":"Data de início","END_DATE":"Data término","CREATED_AT":"Criado em","ACTIONS":"Ações","EDIT":"Editar","CREATE_NEW_CTA":"Você pode criar uma nova ausência","CREATE_NEW_LINK":"clicando aqui"},"TOAST":{"SUCCESSFULLY_REMOVED":"Ausência de \'{{ employeeName }}\' excluída com sucesso.","REMOVE_FAILED":"Não foi possível excluir a ausência de \'{{ employeeName }}\', tente novamente.","SAVE_SUCCESSFULLY":"Indisponibilidade de \'{{ employeeName }}\' salva com sucesso."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/audit-logs/i18n/en.json',
    '{"AUDIT_LOGS":{"PAGE_TITLE":"Audit Logs","TITLE":"Audit Logs","ACTIONS":{"FILTER":"Filter Events","RELOAD":"Reload"},"SIDENAVS":{"FILTERS":{"TITLE":"Filter Events","CLEAR":"Clear Filters","FIELDS":{"FROM":"From:","TO":"To:","SELECT_DATE":"Select Date","CREATED_AT":"Filter by creation date","ACTION":{"LABEL":"Filter by action","OPTIONS":{"CREATED":"Created","UPDATED":"Updated","ARCHIVED":"Archived","UNARCHIVED":"Unarchived","PASSWORD_CHANGED":"Password Changed","AUTHORIZATION_CHANGED":"Authorization Changed","AUTHENTICATED":"Authenticated"}},"RESOURCE_NAME":{"LABEL":"Filter by entity","SEARCH":"Search by entity","OPTIONS":{"ALL":"All","USERS":"Users","EMPLOYEES":"Employees","IMPORTS":"Imports","EXPORTS":"Exports"}},"USERNAME":{"LABEL":"Filter by username","SEARCH":"Search by username"},"USER_IP":{"LABEL":"Filter by user IP","SEARCH":"Search by user IP"}}}},"TABLE":{"COLUMNS":{"RESOURCE_NAME":"Entity","ACTION":"Action","USERNAME":"Username","USER_IP":"User IP","CREATED_AT":"Created at","ACTIONS":"Actions"},"ROWS":{"ACTIONS":{"CREATED":"Created","UPDATED":"Updated","ARCHIVED":"Archived","DELETED":"Deleted","UNARCHIVED":"Unarchived","PASSWORD_CHANGED":"Password Changed","AUTHORIZATION_CHANGED":"Authorization Changed","AUTHENTICATED":"Authenticated"},"RESOURCE_NAME":{"USERS":"Users","EMPLOYEES":"Employees","IMPORTS":"Imports","EXPORTS":"Exports"}},"ACTIONS":{"VIEW":"View"}},"DIALOGS":{"CLOSE":"Close","EVENT_DETAILS":{"TITLE":"Event Details","DESCRIPTION":"Description","HUMANIZE":{"THE_USER":"The user ","THE_ENTITY":" a ","AT":" at ","AT_TIME":" at ","WHOSE_ID":" whose ID is ","ACTION":{"CREATED":"created","UPDATED":"updated","ARCHIVED":"archived","UNARCHIVED":"unarchived","PASSWORD_CHANGED":"password changed","AUTHORIZATION_CHANGED":"authorization changed","AUTHENTICATED":"authenticated"},"RESOURCE_NAME":{"USERS":"user","EMPLOYEES":"employee","IMPORTS":"import","EXPORTS":"export"}},"FIELDS":{"RESOURCE_NAME":{"LABEL":"Entity","OPTIONS":{"USERS":"Users","EMPLOYEES":"Employees","IMPORTS":"Imports","EXPORTS":"Exports"}},"ACTION":{"LABEL":"Action","OPTIONS":{"CREATED":"Created","UPDATED":"Updated","ARCHIVED":"Archived","UNARCHIVED":"Unarchived","PASSWORD_CHANGED":"Password Changed","AUTHORIZATION_CHANGED":"Authorization Changed","AUTHENTICATED":"Authenticated"}},"RESOURCE_ID":{"LABEL":"Entity ID"},"USER_IP":{"LABEL":"User IP"},"USER_ID":{"LABEL":"User ID"},"USERNAME":{"LABEL":"Triggered by"},"CREATED_AT":{"LABEL":"Triggered at"},"DATA":{"LABEL":"Details"}}}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/audit-logs/i18n/es.json',
    '{"AUDIT_LOGS":{"PAGE_TITLE":"Registros de auditoría","TITLE":"Registros de auditoría","ACTIONS":{"FILTER":"Filtrar eventos","RELOAD":"Recargar"},"SIDENAVS":{"FILTERS":{"TITLE":"Filtrar eventos","CLEAR":"Borrar filtros","FIELDS":{"FROM":"Desde:","TO":"Hasta:","SELECT_DATE":"Seleccionar fecha","CREATED_AT":"Filtrar por fecha de creación","ACTION":{"LABEL":"Filtrar por acción","OPTIONS":{"CREATED":"Creado","UPDATED":"Modificado","ARCHIVED":"Archivado","UNARCHIVED":"Desarchivado","PASSWORD_CHANGED":"Contraseña modificada","AUTHORIZATION_CHANGED":"Autorización modificada","AUTHENTICATED":"Autenticado"}},"RESOURCE_NAME":{"LABEL":"Filtrar por entidad","SEARCH":"Buscar por entidad","OPTIONS":{"ALL":"Todos","USERS":"Usuarios","EMPLOYEES":"Empleados","IMPORTS":"Importaciones","EXPORTS":"Exportaciones"}},"USERNAME":{"LABEL":"Filtrar por nombre de usuario","SEARCH":"Buscar por nombre de usuario"},"USER_IP":{"LABEL":"Filtrar por IP de usuario","SEARCH":"Buscar por IP de usuario"}}}},"TABLE":{"COLUMNS":{"RESOURCE_NAME":"Entidad","ACTION":"Acción","USERNAME":"Nombre de usuario","USER_IP":"IP de usuario","CREATED_AT":"Creado en","ACTIONS":"Acciones"},"ROWS":{"ACTIONS":{"CREATED":"Creado","UPDATED":"Actualizado","ARCHIVED":"Archivado","DELETED":"Eliminado","UNARCHIVED":"Desarchivado","PASSWORD_CHANGED":"Contraseña cambiada","AUTHORIZATION_CHANGED":"Autorización cambiada","AUTHENTICATED":"Autentificado"},"RESOURCE_NAME":{"USERS":"Usuarios","EMPLOYEES":"Empleados","IMPORTS":"Importaciones","EXPORTS":"Exportaciones"}},"ACTIONS":{"VIEW":"Ver"}},"DIALOGS":{"CLOSE":"Cerrar","EVENT_DETAILS":{"TITLE":"Detalles del evento","DESCRIPTION":"Descripción","HUMANIZE":{"THE_USER":"El usuario ","THE_ENTITY":" un(a) ","AT":" en ","AT_TIME":" a las ","WHOSE_ID":" de identificación ","ACTION":{"CREATED":"creado","UPDATED":"cambiado","ARCHIVED":"archivado","UNARCHIVED":"desarchivado","PASSWORD_CHANGED":"contraseña cambiada","AUTHORIZATION_CHANGED":"autorización modificada","AUTHENTICATED":"autenticado"},"RESOURCE_NAME":{"USERS":"usuario","EMPLOYEES":"empleado","IMPORTS":"importar","EXPORTS":"exportar"}},"FIELDS":{"RESOURCE_NAME":{"LABEL":"Entidad","OPTIONS":{"USERS":"Usuarios","EMPLOYEES":"Empleados","IMPORTS":"Importaciones","EXPORTS":"Exportaciones"}},"ACTION":{"LABEL":"Acción","OPTIONS":{"CREATED":"Creado","UPDATED":"Actualizado","ARCHIVED":"Archivado","UNARCHIVED":"Desarchivado","PASSWORD_CHANGED":"Contraseña cambiada","AUTHORIZATION_CHANGED":"Autorización cambiada","AUTHENTICATED":"Autentificado"}},"RESOURCE_ID":{"LABEL":"ID de la entidad"},"USER_IP":{"LABEL":"IP del usuario"},"USER_ID":{"LABEL":"ID del usuario"},"USERNAME":{"LABEL":"Disparado por"},"CREATED_AT":{"LABEL":"Disparado en"},"DATA":{"LABEL":"Detalles"}}}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/audit-logs/i18n/pt.json',
    '{"AUDIT_LOGS":{"PAGE_TITLE":"Registros de auditoria","TITLE":"Registros de auditoria","ACTIONS":{"FILTER":"Filtrar eventos","RELOAD":"Atualizar"},"SIDENAVS":{"FILTERS":{"TITLE":"Filtrar Eventos","CLEAR":"Limpar filtros","FIELDS":{"FROM":"De:","TO":"Até:","SELECT_DATE":"Selecionar data","CREATED_AT":"Filtrar por data de criação","ACTION":{"LABEL":"Filtrar por ação","OPTIONS":{"CREATED":"Criado","UPDATED":"Alterado","ARCHIVED":"Arquivado","UNARCHIVED":"Desarquivado","PASSWORD_CHANGED":"Senha alterada","AUTHORIZATION_CHANGED":"Autorização alterada","AUTHENTICATED":"Autentificado"}},"RESOURCE_NAME":{"LABEL":"Filtrar por entidade","SEARCH":"Buscar por entidade","OPTIONS":{"ALL":"Todas","USERS":"Usuários","EMPLOYEES":"Colaboradores","IMPORTS":"Importações","EXPORTS":"Exportações"}},"USERNAME":{"LABEL":"Filtrar por nome do usuário","SEARCH":"Buscar por nome do usuário"},"USER_IP":{"LABEL":"Filtrar por IP do usuário","SEARCH":"Buscar por IP do usuário"}}}},"TABLE":{"COLUMNS":{"RESOURCE_NAME":"Entidade","ACTION":"Operação","USERNAME":"Nome do usuário","USER_IP":"IP do usuário","CREATED_AT":"Criado em","ACTIONS":"Ações"},"ROWS":{"ACTIONS":{"CREATED":"Criado","UPDATED":"Alterado","ARCHIVED":"Arquivado","DELETED":"Deletado","UNARCHIVED":"Desarquivado","PASSWORD_CHANGED":"Senha alterada","AUTHORIZATION_CHANGED":"Autorização alterada","AUTHENTICATED":"Autentificado"},"RESOURCE_NAME":{"USERS":"Usuários","EMPLOYEES":"Colaboradores","IMPORTS":"Importações","EXPORTS":"Exportações"}},"ACTIONS":{"VIEW":"Visualizar"}},"DIALOGS":{"CLOSE":"Fechar","EVENT_DETAILS":{"TITLE":"Detalhes do evento","DESCRIPTION":"Descrição","HUMANIZE":{"THE_USER":"O usuário ","THE_ENTITY":" um(a) ","AT":" em ","AT_TIME":" às ","WHOSE_ID":" de identificação ","ACTION":{"CREATED":"criou","UPDATED":"alterou","ARCHIVED":"arquivou","UNARCHIVED":"desarquivou","PASSWORD_CHANGED":"alterou a senha","AUTHORIZATION_CHANGED":"alterou a autorização","AUTHENTICATED":"autentificou-se"},"RESOURCE_NAME":{"USERS":"usuário","EMPLOYEES":"colaborador","IMPORTS":"importação","EXPORTS":"exportação"}},"FIELDS":{"RESOURCE_NAME":{"LABEL":"Entidade","OPTIONS":{"USERS":"Usuários","EMPLOYEES":"Colaboradores","IMPORTS":"Importações","EXPORTS":"Exportações"}},"ACTION":{"LABEL":"Operação","OPTIONS":{"CREATED":"Criado","UPDATED":"Alterado","ARCHIVED":"Arquivado","UNARCHIVED":"Desarquivado","PASSWORD_CHANGED":"Senha alterada","AUTHORIZATION_CHANGED":"Autorização alterada","AUTHENTICATED":"Autentificado"}},"RESOURCE_ID":{"LABEL":"ID da entidade"},"USER_IP":{"LABEL":"IP do usuário"},"USER_ID":{"LABEL":"ID do usuário"},"USERNAME":{"LABEL":"Disparado por"},"CREATED_AT":{"LABEL":"Disparado em"},"DATA":{"LABEL":"Detalhes"}}}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/bootstrap/i18n/en.json',
    '{"BOOTSTRAP":{"PAGE_TITLE":"Initial settings","TITLE":"Initial settings","WELCOME":"Welcome to <b>Field Control</b>! We\'re glad to have you here with us.","CONFIG":"Before getting superpowers with your field team, let\'s set up a few things first. It\'s quick, let\'s go!","FINISH":"Finish","NEXT":"Next","ERROR":"The operation could not be completed. Please try again later. If the error persists, contact support.","PREVIOUS":"Previous","FORM":{"NAME":"Company","INFO":"Information about your company","LOCATION":"We need to understand where your company is located.","COMPANY":{"LABEL":"Company name","REQUIRED":"Company name is required"},"MANAGER":{"LABEL":"Manager\'s name","REQUIRED":"Manager\'s name is required"},"EMAIL":{"LABEL":"Company Email","REQUIRED":"Email is a required field","VALID":"Invalid email format"},"PHONE":{"LABEL":"Contact Phone","REQUIRED":"Phone number is required","VALID":"Invalid phone number"},"COUNTRY":{"LABEL":"Country","PLACEHOLDER":"Select a country"},"TIMEZONE":{"LABEL":"Timezone","PLACEHOLDER":"Select a timezone"},"ADDRESS":{"LABEL":"Address","LABEL_ACCOUNT":"Account address","REQUIRED":"Address is required","NOT_FOUND":"The address was not found, change your search and try again.","SEARCH_EXAMPLE":"Search for an address, for example: 3501 S La Cienega Blvd, Los Angeles","NUMBER_NOT_SPECIFIED":"Address number not specified","CLEAR":"Clear address","LATITUDE":"latitude","LONGITUDE":"longitude","ENTER_ADDRESS":"Enter the address in the field above"},"ZIPCODE":{"LABEL":"ZIP code","REQUIRED":"ZIP code is required","INVALID":"Invalid ZIP code"},"CITY":{"LABEL":"City","REQUIRED":"City is required"},"STATE":{"LABEL":"State","REQUIRED":"State is required"},"STREET":{"LABEL":"Street","REQUIRED":"Street is required"},"NUMBER":{"LABEL":"Number","REQUIRED":"Number is required","NOT_SPECIFIED":"Numeric address not specified."}},"APP":{"NAME":"App","DOWNLOAD":"Download the app corresponding to your smartphone\'s operating system","APP_STORE":"download on app store","GOOGLE_PLAY":"download on google play","VIDEO":"watch this explanatory video."},"DIALOG":{"HOW_INSTALL":{"TITLE":"Register employees"}},"WARNING":{"TEXT":"Unable to find your location. Please check if the fields are filled correctly."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/bootstrap/i18n/es.json',
    '{"BOOTSTRAP":{"PAGE_TITLE":"Configuraciones iniciales","TITLE":"Configuraciones iniciales","WELCOME":"¡Bienvenido a <b>Field Control</b>! Nos alegra tenerte aquí con nosotros.","CONFIG":"Antes de obtener superpoderes con tu equipo de campo, configuremos algunas cosas primero. Es rápido, ¡vamos!","FINISH":"Terminar","NEXT":"Siguiente","ERROR":"No se pudo completar la operación. Por favor, inténtalo de nuevo más tarde. Si el error persiste, contacta al soporte.","PREVIOUS":"Anterior","FORM":{"NAME":"Empresa","INFO":"Información sobre tu empresa","LOCATION":"Necesitamos entender dónde está ubicada tu empresa.","COMPANY":{"LABEL":"Nombre de la empresa","REQUIRED":"El nombre de la empresa es obligatorio"},"MANAGER":{"LABEL":"Nombre del gerente","REQUIRED":"El nombre del gerente es obligatorio"},"EMAIL":{"LABEL":"Correo Electrónico de la empresa","REQUIRED":"El correo electrónico es un campo obligatorio","VALID":"Formato de correo electrónico inválido"},"PHONE":{"LABEL":"Teléfono de contacto","REQUIRED":"El número de teléfono es obligatorio","VALID":"Número de teléfono inválido"},"COUNTRY":{"LABEL":"País","PLACEHOLDER":"Selecciona un país"},"TIMEZONE":{"LABEL":"Zona horaria","PLACEHOLDER":"Selecciona una zona horaria"},"ADDRESS":{"LABEL":"Dirección","LABEL_ACCOUNT":"Dirección de la cuenta","REQUIRED":"La dirección es obligatoria","NOT_FOUND":"La dirección no se encontró, cambia tu búsqueda e inténtalo de nuevo.","SEARCH_EXAMPLE":"Busca una dirección, por ejemplo: 3501 S La Cienega Blvd, Los Angeles","NUMBER_NOT_SPECIFIED":"Número de la dirección no especificado","CLEAR":"Limpiar dirección","LATITUDE":"latitud","LONGITUDE":"longitud","ENTER_ADDRESS":"Ingresa la dirección en el campo de arriba"},"ZIPCODE":{"LABEL":"Código postal","REQUIRED":"El código postal es obligatorio","INVALID":"Código postal inválido"},"CITY":{"LABEL":"Ciudad","REQUIRED":"La ciudad es obligatoria"},"STATE":{"LABEL":"Estado","REQUIRED":"El estado es obligatorio"},"STREET":{"LABEL":"Calle","REQUIRED":"La calle es obligatoria"},"NUMBER":{"LABEL":"Número","REQUIRED":"El número es obligatorio","NOT_SPECIFIED":"Dirección numérica no especificada."}},"APP":{"NAME":"Aplicación","DOWNLOAD":"Descarga la aplicación correspondiente al sistema operativo de tu smartphone","APP_STORE":"descargar en app store","GOOGLE_PLAY":"descargar en google play","VIDEO":"mira este video explicativo."},"DIALOG":{"HOW_INSTALL":{"TITLE":"Registrar colaboradores"}},"WARNING":{"TEXT":"No se pudo encontrar tu ubicación. Por favor, verifica si los campos están llenos correctamente."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/bootstrap/i18n/pt.json',
    '{"BOOTSTRAP":{"PAGE_TITLE":"Configurações iniciais","TITLE":"Configurações iniciais","WELCOME":"Bem-vindo ao <b>Field Control</b>! Estamos felizes de ter você aqui com a gente.","CONFIG":"Antes de ter super poderes com sua equipe externa, iremos configurar algumas coisas antes. É bem rápido, vamos lá!","FINISH":"Concluir","NEXT":"Próximo","ERROR":"Não foi possível realizar a operação. Por favor, tente novamente mais tarde. Se o erro persistir entre em contato com o suporte.","PREVIOUS":"Anterior","FORM":{"NAME":"Empresa","INFO":"Dados sobre sua empresa","LOCATION":"Precisamos entender onde sua empresa está localizada.","COMPANY":{"LABEL":"Nome da empresa","REQUIRED":"Nome da empresa obrigatório"},"MANAGER":{"LABEL":"Nome do gestor","REQUIRED":"Nome do gestor obrigatório"},"EMAIL":{"LABEL":"E-mail da empresa","REQUIRED":"E-mail é um campo obrigatório","VALID":"E-mail em formato inválido"},"PHONE":{"LABEL":"Telefone de contato","REQUIRED":"Telefone obrigatório","VALID":"Telefone inválido"},"COUNTRY":{"LABEL":"País","PLACEHOLDER":"Selecione um país"},"TIMEZONE":{"LABEL":"Fuso horário","PLACEHOLDER":"Selecione um fuso horário"},"ADDRESS":{"LABEL":"Endereço","LABEL_ACCOUNT":"Endereço da conta","REQUIRED":"Endereço é obrigatório","NOT_FOUND":"O endereço não foi encontrado, mude sua busca e tente novamente.","SEARCH_EXAMPLE":"Procure por um endereço, por exemplo: 3501 S La Cienega Blvd, Los Angeles","NUMBER_NOT_SPECIFIED":"Número do endereço não especificado","CLEAR":"Limpar endereço","LATITUDE":"latitude","LONGITUDE":"longitude","ENTER_ADDRESS":"Informe o endereço no campo acima"},"ZIPCODE":{"LABEL":"CEP","REQUIRED":"CEP é obrigatório","INVALID":"CEP inválido"},"CITY":{"LABEL":"Cidade","REQUIRED":"Cidade é obrigatório"},"STATE":{"LABEL":"Estado","REQUIRED":"Estado é obrigatório"},"STREET":{"LABEL":"Logradouro","REQUIRED":"Logradouro é obrigatório"},"NUMBER":{"LABEL":"Número","REQUIRED":"Número é obrigatório","NOT_SPECIFIED":"Endereço numérico não especificado."}},"APP":{"NAME":"Aplicativo","DOWNLOAD":"Baixe o aplicativo correspondente ao sistema operacional do smartphone","APP_STORE":"baixar na app store","GOOGLE_PLAY":"baixar na google play","VIDEO":"veja este vídeo explicativo."},"DIALOG":{"HOW_INSTALL":{"TITLE":"Cadastrar colaboradores"}},"WARNING":{"TEXT":"Não foi possível encontrar sua localização. Por favor, verifique se os campos estão preenchidos corretamente."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/calendar/i18n/en.json',
    '{"CALENDAR":{"PAGE_TITLE":"Task Calendar","FEEDBACK_FORM":"We are creating a new version of the calendar. <a href=\\"https://forms.gle/ZzXSmFAwWmHSb1WZ7\\" target=\\"_blank\\">Click here</a> to provide your feedback and help us improve this feature.","TITLE":"Task Calendar","FILTER":"Filter tasks","RELOAD":"Reload","TASKS":{"ADD":"Add task","NO_PERMISSION":"Cannot create tasks","CANT_EDIT":"You don\'t have permission to edit tasks."},"PREVIOUS":"Previous","NEXT":"Next","TODAY":"Today","DAY":"Day","WEEK":"Week","MONTH":"Month","ALL_DAY":"All day","FILTERS":{"TITLE":"Filter Tasks","CLEAR":"Clear filters","CUSTOMER":"Search by customer","NUMBER":"Search by number","OS_TYPE":{"TITLE":"Filter OS type","SELECT":"Select OS type"},"LABELS":"Filter by label","SITUATIONS":"Filter by situation","EMPLOYEE":{"TITLE":"Filter by employee","SEARCH":"Search by employee","EMPTY":"No employee"}},"CONTENT":{"LOADING":"Loading tasks..."},"TOAST":{"TASK_DATE_CHANGED":"Task date \'{{ eventTitle }}\' successfully changed."},"ALERTS":{"TASK_CHANGE_TIME_FAILED":{"TITLE":"Unable to modify the task","CONTENT":"Unable to change task time.","OK":"Ok"},"ONLY_SCHEDULED_TASKS":{"TITLE":"Unable to modify the task","CONTENT":"Only tasks with <span class=\'activity-scheduled-color\'><b>Scheduled</b></span> status can have their visit date changed.","OK":"Ok"}},"MONTHS":{"JANUARY":"January","FEBRUARY":"February","MARCH":"March","APRIL":"April","MAY":"May","JUNE":"June","JULY":"July","AUGUST":"August","SEPTEMBER":"September","OCTOBER":"October","NOVEMBER":"November","DECEMBER":"December"},"SHORT_MONTHS":{"JANUARY":"Jan","FEBRUARY":"Feb","MARCH":"Mar","APRIL":"Apr","MAY":"May","JUNE":"Jun","JULY":"Jul","AUGUST":"Aug","SEPTEMBER":"Sep","OCTOBER":"Oct","NOVEMBER":"Nov","DECEMBER":"Dec"},"WEEK_DAY":{"MONDAY":"Monday","TUESDAY":"Tuesday","WEDNESDAY":"Wednesday","THURSDAY":"Thursday","FRIDAY":"Friday","SATURDAY":"Saturday","SUNDAY":"Sunday"},"SHORT_WEEK_DAY":{"MONDAY":"Mon","TUESDAY":"Tue","WEDNESDAY":"Wed","THURSDAY":"Thu","FRIDAY":"Fri","SATURDAY":"Sat","SUNDAY":"Sun"},"NEW_LAYOUT":"View new layout","LAUNCH_DIALOG":{"TITLE":"New feature launched!","DESCRIPTION":"<div class=\\"tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4\\"><div class=\\"tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3\\"><h2 class=\\"tw-text-[20px] tw-font-medium tw-text-black\\">New calendar available</h2><span class=\\"tw-text-color-secondary tw-text-center\\">We just released a new version of this page and we are super excited for you to see how it looks! This version is packed with improvements and a more modern look, designed to provide an even smoother experience. Do you want to be one of the first to see how it turned out?</span></div></div>","VIDEO_TEXT":"📺 Watch the video below to learn more!","LEFT_BUTTON":"Leave for later :(","RIGHT_BUTTON":"Test now!","BANNER_TEXT":"New calendar available, now with improvements and a more modern look! Do you want to be one of the first to check it out?"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/calendar/i18n/es.json',
    '{"CALENDAR":{"PAGE_TITLE":"Calendario de Actividades","FEEDBACK_FORM":"Estamos creando una nueva versión del calendario. <a href=\\"https://forms.gle/ZzXSmFAwWmHSb1WZ7\\" target=\\"_blank\\">Haz clic aquí</a> para dejar tus comentarios y ayudanos a mejorar esta funcionalidad.","TITLE":"Calendario de Actividades","FILTER":"Filtrar actividades","RELOAD":"Actualizar","TASKS":{"ADD":"Agregar actividad","NO_PERMISSION":"No se puede crear actividades","CANT_EDIT":"No tienes permiso para editar actividades."},"PREVIOUS":"Anterior","NEXT":"Siguiente","TODAY":"Hoy","DAY":"Día","WEEK":"Semana","MONTH":"Mes","ALL_DAY":"Todo el día","FILTERS":{"TITLE":"Filtrar Actividades","CLEAR":"Limpiar filtros","CUSTOMER":"Buscar por cliente","NUMBER":"Buscar por número","OS_TYPE":{"TITLE":"Filtrar tipo de OS","SELECT":"Seleccionar tipos de OS"},"LABELS":"Filtrar por etiquetas","SITUATIONS":"Filtrar por situación","EMPLOYEE":{"TITLE":"Filtrar por empleado","SEARCH":"Buscar empleado","EMPTY":"Sin empleados"}},"CONTENT":{"LOADING":"Cargando actividades..."},"TOAST":{"TASK_DATE_CHANGED":"Fecha de la actividad \'{{ eventTitle }}\' cambiada con éxito."},"ALERTS":{"TASK_CHANGE_TIME_FAILED":{"TITLE":"No se puede modificar la actividad","CONTENT":"No se puede cambiar la hora de la actividad.","OK":"Ok"},"ONLY_SCHEDULED_TASKS":{"TITLE":"No se puede modificar la actividad","CONTENT":"Solo las actividades con estado <span class=\'activity-scheduled-color\'><b>Agendada</b></span> pueden cambiar la fecha de visita.","OK":"Ok"}},"MONTHS":{"JANUARY":"Enero","FEBRUARY":"Febrero","MARCH":"Marzo","APRIL":"Abril","MAY":"Mayo","JUNE":"Junio","JULY":"Julio","AUGUST":"Agosto","SEPTEMBER":"Septiembre","OCTOBER":"Octubre","NOVEMBER":"Noviembre","DECEMBER":"Diciembre"},"SHORT_MONTHS":{"JANUARY":"Ene","FEBRUARY":"Feb","MARCH":"Mar","APRIL":"Abr","MAY":"May","JUNE":"Jun","JULY":"Jul","AUGUST":"Ago","SEPTEMBER":"Sep","OCTOBER":"Oct","NOVEMBER":"Nov","DECEMBER":"Dic"},"WEEK_DAY":{"MONDAY":"Lunes","TUESDAY":"Martes","WEDNESDAY":"Miércoles","THURSDAY":"Jueves","FRIDAY":"Viernes","SATURDAY":"Sábado","SUNDAY":"Domingo"},"SHORT_WEEK_DAY":{"MONDAY":"Lun","TUESDAY":"Mar","WEDNESDAY":"Mié","THURSDAY":"Jue","FRIDAY":"Vie","SATURDAY":"Sáb","SUNDAY":"Dom"},"NEW_LAYOUT":"Ver nuevo diseño","LAUNCH_DIALOG":{"TITLE":"¡Novedad en el aire!","DESCRIPTION":"<div class=\\"tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4\\"><div class=\\"tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3\\"><h2 class=\\"tw-text-[20px] tw-font-medium tw-text-black\\">Nuevo calendario disponible</h2><span class=\\"tw-text-color-secondary tw-text-center\\">Acabamos de liberar una nueva versión de esta página y estamos muy emocionados de que veas cómo se ve. ¡Esta versión está llena de mejoras y un diseño más moderno, pensado para proporcionar una experiencia aún más fluida! ¿Quieres ser uno de los primeros en ver cómo quedó?</span></div></div>","VIDEO_TEXT":"📺 ¡Mira el video a continuación para saber más!","LEFT_BUTTON":"Dejar para después :(","RIGHT_BUTTON":"¡Probar ahora!","BANNER_TEXT":"Nuevo calendario disponible, ¡ahora con mejoras y un diseño más moderno! ¿Quieres ser uno de los primeros en verlo?"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/calendar/i18n/pt.json',
    '{"CALENDAR":{"PAGE_TITLE":"Calendário de Atividades","FEEDBACK_FORM":"Estamos criando uma nova versão do calendário. <a href=\\"https://forms.gle/ZzXSmFAwWmHSb1WZ7\\" target=\\"_blank\\">Clique aqui</a> para deixar a sua contribuição e nos ajude a melhorar esta funcionalidade.","TITLE":"Calendário de Atividades","FILTER":"Filtrar atividades","RELOAD":"Atualizar","TASKS":{"ADD":"Adicionar atividade","NO_PERMISSION":"Não é possível criar atividades","CANT_EDIT":"Você não tem permissão para editar atividades."},"PREVIOUS":"Anterior","NEXT":"Próximo","TODAY":"Hoje","DAY":"Dia","WEEK":"Semana","MONTH":"Mês","ALL_DAY":"Dia inteiro","FILTERS":{"TITLE":"Filtrar Atividades","CLEAR":"Limpar filtros","CUSTOMER":"Pesquisar por cliente","NUMBER":"Pesquisar por número","OS_TYPE":{"TITLE":"Filtrar tipo de OS","SELECT":"Selecionar tipos de atividade"},"LABELS":"Filtrar por etiquetas","SITUATIONS":"Filtrar por situação","EMPLOYEE":{"TITLE":"Filtrar por colaborador","SEARCH":"Pesquisar por colaborador","EMPTY":"Sem colaborador"}},"CONTENT":{"LOADING":"Carregando atividades..."},"TOAST":{"TASK_DATE_CHANGED":"Data da atividade \'{{ eventTitle }}\' alterada com sucesso."},"ALERTS":{"TASK_CHANGE_TIME_FAILED":{"TITLE":"Não é possível modificar a atividade","CONTENT":"Não é possível alterar a hora da atividade.","OK":"Ok"},"ONLY_SCHEDULED_TASKS":{"TITLE":"Não é possível modificar a atividade","CONTENT":"Apenas atividades com situação <span class=\'activity-scheduled-color\'><b>Agendada</b></span> podem ter a data da visita alterada.","OK":"Ok"}},"MONTHS":{"JANUARY":"Janeiro","FEBRUARY":"Fevereiro","MARCH":"Março","APRIL":"Abril","MAY":"Maio","JUNE":"Junho","JULY":"Julho","AUGUST":"Agosto","SEPTEMBER":"Setembro","OCTOBER":"Outubro","NOVEMBER":"Novembro","DECEMBER":"Dezembro"},"SHORT_MONTHS":{"JANUARY":"Jan","FEBRUARY":"Fev","MARCH":"Mar","APRIL":"Abr","MAY":"Mai","JUNE":"Jun","JULY":"Jul","AUGUST":"Ago","SEPTEMBER":"Set","OCTOBER":"Out","NOVEMBER":"Nov","DECEMBER":"Dez"},"WEEK_DAY":{"MONDAY":"Segunda","TUESDAY":"Terça","WEDNESDAY":"Quarta","THURSDAY":"Quinta","FRIDAY":"Sexta","SATURDAY":"Sábado","SUNDAY":"Domingo"},"SHORT_WEEK_DAY":{"MONDAY":"Seg","TUESDAY":"Ter","WEDNESDAY":"Qua","THURSDAY":"Qui","FRIDAY":"Sex","SATURDAY":"Sab","SUNDAY":"Dom"},"NEW_LAYOUT":"Visualizar novo layout","LAUNCH_DIALOG":{"TITLE":"Novidade no ar!","DESCRIPTION":"<div class=\\"tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4\\"><div class=\\"tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3\\"><h2 class=\\"tw-text-[ 20px] tw-font-medium tw-text-black\\">Novo calendário disponível</h2><span class=\\"tw-text-color-secondary tw-text-center\\">Acabamos de liberar uma nova versão dessa página e estamos super empolgados para que você veja como ela ficou! Esta versão está cheia de melhorias e um visual mais moderno, pensada para proporcionar uma experiência ainda mais fluida. Quer ser um dos primeiros a ver como ficou?</span></div></div>","VIDEO_TEXT":"📺 Assista ao vídeo abaixo para saber mais!","LEFT_BUTTON":"Deixar para depois :(","RIGHT_BUTTON":"Testar agora!","BANNER_TEXT":"Novo calendário disponível, agora com melhorias e um visual mais moderno! Quer ser um dos primeiros a conferir?"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/control-panel/i18n/en.json',
    '{"CONTROL_PANEL":{"PAGE_TITLE":"Control panel","TASKS_OF_DAY":"Tasks of the day","MAP":"Map","TIMELINE":"Timeline","TUTORIAL_VIDEO":{"TITLE":"Instructions","TOOLTIP":"Watch explanatory video"},"TOOLBAR":{"DATE":{"PLACEHOLDER":"Select date"},"CREATE_TASK":{"TOOLTIP":"Create new task","NO_PERMISSION":"You are not allowed to create tasks"},"OPTIMIZE_ROUTES":{"TOOLTIP":"Optimize routes"},"FILTERS":{"CLEAR":"Clear filters","TOOLTIP":"Filter tasks"},"RELOAD":{"TOOLTIP":"Reload data"}},"ERROR":{"DATE_REQUIRED":"Date is required"},"FILTERS":{"TITLE":"Filter tasks","CLEAR":"Clear","NAME":{"LABEL":"Filter by customer","PLACEHOLDER":"Search by customer"},"CUSTOMER_LABEL":{"LABEL":"Filter by customer label","SEARCH":"Search for customer label"},"LOCATION":{"LABEL":"Filter by location name","SEARCH":"Search by location name"},"ARCHIVED":{"LABEL":"Filter by status"},"TASK":{"LABEL":"Filter by OS type","PLACEHOLDER":"Filter OS type"},"DESCRIPTION":{"LABEL":"Filter by description","PLACEHOLDER":"Search by description"},"SITUATION":{"LABEL":"Filter by situation"},"EMPLOYEE":{"LABEL":"Filter by employee","NO_EMPLOYEE":"No employee","TOGGLE":"Toggle member"},"LABELS":{"LABEL":"Filter by labels","NO_LABELS":"No labels"},"RATING":{"LABEL":"Filter by rating","NO_RATING":"No rating","TERRIBLE":"Terrible","BAD":"Bad","REGULAR":"Regular","GOOD":"Good","GREAT":"Great"}},"DIALOGS":{"ROUTERIZATION":{"TITLE":"Task routing","CLOSE_BUTTON":"Close","PREVIOUS_BUTTON":"Previous","NEXT_BUTTON":"Next","CONFIRM_BUTTON":"Confirm","TASK_DISTRIBUTION":"Task distribution","INITIAL_DATE":"Start date","CLICK_ON_THE_BUTTON":"Click the button","VIEW_THE_MAP_FULL_SCREEN":"to view the map in full screen","AMOUNT_OF_ACTIVITIES_PER_DAY":"Number of activities per day","DAYS_OF_THE_WEEK":{"TITLE":"Days of the week","DAYS":{"SUNDAY":"Sun","MONDAY":"Mon","TUESDAY":"Tue","WEDNESDAY":"Wed","THURSDAY":"Thu","FRIDAY":"Fri","SATURDAY":"Sat"}},"STEPS":{"EMPLOYEE":"Employee","SETTINGS":"Settings","ROUTING":"Routing"},"INSULFICIENT_TASKS_ERROR":"The employee needs more than 2 scheduled tasks to proceed","SUCCESS_MESSAGE":"Tasks saved successfully","INVALID_INITIAL_LOCATION":"Invalid initial destination","INVALID_END_LOCATION":"Invalid end destination","CONFIGURATION":{"CONSIDER_TRAFFIC":"Consider traffic","CONSIDER_TRAFFIC_DESCRIPTION":"If enabled, the route optimization will consider traffic information","ROUTE":"Route","VEHICLE":"Vehicle","INITIAL_DESTINATION":"Initial destination","FINAL_DESTINATION":"Final destination","BALANCED":"Balanced","BALANCED_ROUTE_DESCRIPTION":"Balanced route in economy and speed","FASTEST":"Fast","FASTEST_ROUTE_DESCRIPTION":"The fastest possible route","SHORTEST":"Short","SHORTEST_ROUTE_DESCRIPTION":"The shortest possible route","CAR":"Car","MOTORCYCLE":"Motorcycle","TRUCK":"Truck","VAN":"Van","BICYCLE":"Bicycle","PEDESTRIAN":"Pedestrian (no vehicle)","COMPANY":"Company","COMPANY_DESCRIPTION":"Uses business address to calculate route","EMPLOYEE_HOME":"Employee\'s House","EMPLOYEE_HOME_DESCRIPTION":"Uses the employee\'s home address to calculate route","LAST_LOCALIZATION":"Last location","LAST_LOCALIZATION_DESCRIPTION":"Uses the employee\'s last active location to calculate route","CUSTOM_FINAL_DESTINATION":"Custom final destination","CUSTOM_FINAL_DESTINATION_DESCRIPTION":"Choose a custom address to calculate the route","ADDRESS":"Address"},"ERROR":{"EMPLOYEE_LAST_LOCALIZATION_NOT_FOUND":"Last employee\'s location not found","INVALID_INITIAL_DESTINATION":"Invalid initial location","USER_NOT_AUTHORIZED":"This module is not enabled for your account, request a demonstration with your consultant from account Manager.","MAXIMUM_LIMIT":"Maximum routing limit reached, contact support to increase your limit","SERVER_ERROR":"Server error to consult routing","NO_POSSIBLE_ROUTE_FOUND":"It was not possible to find a route between the selected activities.","UNKNOWN_SERVER_ERROR":"Unknown server error","INITIAL_DATE_REQUIRED":"Start date is required","AMOUNT_OF_ACTIVITIES_PER_DAY_REQUIRED":"Number of activities per day is required","AMOUNT_OF_ACTIVITIES_PER_DAY_PATTERN":"The value must be integer","AMOUNT_OF_ACTIVITIES_PER_DAY_MIN":"The minimum value must be 1"},"SEARCH":{"EMPLOYEE_NAME_PLACEHOLDER":"Employee\'s name"},"MODULE_UPDATE":{"TEXT":"Do you want the route for multiple collaborators at once? Upgrade to the new Advanced Router!","KNOW_MORE":"Know more","UPGRADE":"Upgrade"},"LAYERS":{"DEFAULT":"Default","SATELLITE":"Satellite","ROADS":"Roads","GROUND":"Ground"},"TASK_MARKER":{"OS_TYPE":"OS type","SITUATION":"Situation","LATITUDE_LONGITUDE":"Latitude, Longitude"},"ROUTE_MILAGE":{"TEXT":"Total route mileage: "},"MODAL":{"MODAL_TITLE":"Warning","MODAL_CONTENT":"The identifiers listed below correspond to service orders with incorrectly entered coordinates in the location registration. Correct them manually before proceeding with routing.","MODAL_COPY_IDENTIFIERS":"Copy codes","MODAL_CLOSE":"EXIT","COPY_IDENTIFIERS_GEOLOCATION_INVALID":"Successfully copied to clipboard"}}},"VIEWS":{"GANTT":{"ZOOM_CONTROL":{"TOOLTIP":"Zoom Control","ZOOM_IN":"Zoom in","ZOOM_OUT":"Zoom out"},"DRAW":"Draw","CREATE_TASK_TIMELINE":"Create task by timeline","DRAG_AND_DROP":"(drag and drop)","ALLOW_DRAGGING_TASKS":"Allow dragging tasks","TOTAL_TIME_TASKS":{"LABEL":"Total time in tasks:","TOOLTIP":"Total time in tasks is the sum of minutes spent on tasks."},"TOTAL_TIME_TRAVEL":{"LABEL":"Total travel time:","TOOLTIP":"Total travel time is the sum of minutes spent in travel."},"AVAILABLE_TIME":{"LABEL":"Available time:","TOOLTIP":"Available time is the result of subtracting total time minus time in tasks minus time in travel."},"TOTAL_TIME_SUM":{"LABEL":"Total time:","TOOLTIP":"Total time is the sum of available time per day for each employee."},"CONTENT":{"LOADING":"Loading tasks...","NO_EMPLOYEE_ADDED":"No employee from your external team has been added yet or there are none active on this date.","ADD_FIRST_EMPLOYEE":{"TEXT":"Add the first employee in the top right menu <b>Employees</b> or click","HERE":"here"}},"TASK":{"SUCCESS":"Task {{ name }} # {{ identifier }} saved successfully.","ERROR":"Could not modify task","NO_PERMISSION":"Employee cannot perform this OS type.","NEW":"New task","DRAG_AND_DROP":"Click on the timeline, drag and drop to create a task for the employee.","ERROR_ALREADY_ALOCATED":{"TITLE":"⚠️ Allocation Conflict","MESSAGE":"This employee is already assigned to the same work order during the selected period.<br/> <b>💡 Suggestion:</b> Choose another employee or adjust the activities."}},"TASKS_SUCCESS":"Tasks saved successfully.","CONFIG_EMPLOYEE":"Employee","ROUTE_TASK_NAME":"Travel","ABSENCE_TASK_NAME":"Absence: {{ reason }}","EMPLOYEE_LABEL_ONLINE":{"NO_LOCATION":"No location","LAST_RECEIVED_LOCATION":"Last received location","ON":" on {{ timestamp }}","OUTDATED_LOCATION":"Outdated location","LAST_UPDATE_ON":" - last update on {{ timestamp }}","TASK_LOCATION":"task location"}},"LIST":{"TASK":{"EMPLOYEE_SELECTED":"Employee {{ name }} has been assigned to the selected tasks.","SUCCESSFULLY_CHANGED":"The selected tasks have been successfully changed.","SUCCESSFULLY_ARCHIVED":"The selected tasks have been archived successfully.","SUCCESSFULLY_UNARCHIVED":"The selected tasks have been unarchived successfully.","SUCCESSFULLY_ARCHIVED_UNIQUE":"Task {{ customer_name }} #{{ order_identifier }} archived successfully.","SUCCESSFULLY_UNARCHIVED_UNIQUE":"Task {{ customer_name }} #{{ order_identifier }} unarchived successfully.","CHANGE_TASKS":{"TITLE":"{{ quantity }} selected tasks","MESSAGE":"{{ quantity }} tasks will be changed. Are you sure you want to proceed?","OK":"Yes, proceed","CANCEL":"Better not","CANNOT_MODIFY":{"TITLE":"Cannot modify one or more tasks","OK":"OK","MESSAGE":"Only tasks with status <span class=\\"activity-scheduled-color\\"><b>Scheduled</b></span> can have their visit date changed."}},"ARCHIVED":"Archived"},"RATING_EMAIL":{"RATING_LINK":"An email will be sent to the customers of each of the selected tasks with the link for evaluation.","TITLE":"{{ quantity }} selected tasks","MESSAGE":"Evaluation emails will be sent to customers of {{ quantity }} tasks. Are you sure you want to proceed?","OK":"Yes, proceed","CANCEL":"Better not"},"ACTIONS":{"FILTERS":"Filters","SELECT":"Select","DESELECT":"Deselect","SELECT_ALL":"Select all","DESELECT_ALL":"Deselect all","CHANGE_DATE":"Change date","SEARCH_EMPLOYEE":"Search employees...","CHANGE_EMPLOYEE":"Change employee","ARCHIVE":"Archive","SEND_RATING":"Send rating email","UNARCHIVE":"Unarchive","PRINT":"Print","TOOGLE_EMPLOYEE":"Toggle employee"},"NO_EMPLOYEE":"No employee","LABELS":{"TITLE":"Labels","NO_LABEL":"No labels registered, only administrators can register labels.","SEARCH_LABELS":"Search labels...","TOGGLE_LABEL":"Toggle","EDIT_BUTTON":"Update","ADD_NEW_BUTTON":"Create new label","BACK_BUTTTON":"Back","NAME":"Name"},"PAGINATION":{"SELF":"Showing from {{ firstPageIndex }} to {{ lastPageIndex }} of {{ length }} records","FILTERED":"(Filtered from {{ length }} records)"},"TICKETS":{"PREVIOUS":"Previous","NEXT":"Next"},"NO_TASK_REGISTERED_DAY":"No tasks registered for {{ selectedDate }}.","NO_TASK_REGISTERED_FILTERS":"No tasks registered with selected filters, clear filters by clicking the button","CLEAR_FILTERS":"Clear filters","DAYS_TASKS":"to view the tasks of the day {{ selectedDate }}.","LOADING_TASKS":"Loading tasks...","LAUNCH_DIALOG":{"TITLE":"🎉 News in the air!","DESCRIPTION":"The Tasks of the Day page has a new look! We redesigned the visuals and navigation to make it more modern, fluid and easier to use. Now it\'s even simpler to track everything that matters in your day.","RIGHT_BUTTON":"Try new version 🚀","LEFT_BUTTON":"Maybe later :(","BANNER_TEXT":"<b>New today tasks page available,</b> now with improvements and a more modern look! Want to be one of the first to check it out?"}},"MAIN":{"TITLE":"Control panel","TIMELINE":"Timeline","MAP":"Map","LIST":"Listing"},"MAP":{"TASK":{"SCHEDULED":"Scheduled task","ON_ROUTE":"On route","PROGRESS":"Task in progress","COMPLETED":"Task completed","CANCELED":"Task canceled","DISABLED":"Task impeded","CONNECTION_PATH":"Connection path"},"LAYERS":{"DEFAULT":"Default","SATELLITE":"Satellite","ROADS":"Roads","GROUND":"Ground"},"CENTRALIZE":"Center","GROUP_VISITS":"Group Visits"}},"AUTOUPDATE":"Auto-update","AUTOUPDATE_TOOLTIP":"Update the timeline every 2 minutes","AUTOUPDATE_ENABLE":"Automatic update enabled, the timeline will be updated every 2 minutes","AUTOUPDATE_DISABLE":"Automatic update disabled.","DRAG_ALTER_TIME":"Change scheduling time for unscheduled activities when dragging","DRAG_ALTER_TIME_TOOLTIP":"Change the scheduling time of unscheduled activities when dragging, instead of just moving their position","DRAG_ALTER_TIME_ENABLE":"Enabled: when dragging an unscheduled activity, its scheduling time will be set to the time of the drag","DRAG_ALTER_TIME_DISABLE":"Disabled: when dragging an unscheduled activity, only its position will be changed and its scheduling time will remain undefined","MAP_AUTOUPDATE_TOOLTIP":"Update the map every 2 minutes","NEW_LAYOUT":"Visualizar novo layout"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/control-panel/i18n/es.json',
    '{"CONTROL_PANEL":{"PAGE_TITLE":"Panel de control","TASKS_OF_DAY":"Actividades del día","MAP":"Mapa","TIMELINE":"Línea de tiempo","TUTORIAL_VIDEO":{"TITLE":"Instrucciones","TOOLTIP":"Ver video explicativo"},"TOOLBAR":{"DATE":{"PLACEHOLDER":"Seleccionar fecha"},"CREATE_TASK":{"TOOLTIP":"Crear nueva tarea","NO_PERMISSION":"No tienes permiso para crear actividades"},"OPTIMIZE_ROUTES":{"TOOLTIP":"Optimizar rutas"},"FILTERS":{"CLEAR":"Limpiar filtros","TOOLTIP":"Filtrar actividades"},"RELOAD":{"TOOLTIP":"Recargar datos"}},"ERROR":{"DATE_REQUIRED":"La fecha es obligatoria"},"FILTERS":{"TITLE":"Filtrar actividades","CLEAR":"Limpiar","NAME":{"LABEL":"Filtrar por cliente","PLACEHOLDER":"Buscar por cliente"},"CUSTOMER_LABEL":{"LABEL":"Filtrar por etiqueta de cliente","SEARCH":"Buscar etiqueta de cliente"},"LOCATION":{"LABEL":"Filtrar por nombre de ubicación","SEARCH":"Buscar nombre de la ubicación"},"ARCHIVED":{"LABEL":"Filtrar por estado"},"TASK":{"LABEL":"Filtrar por tipo de OS","PLACEHOLDER":"Filtrar tipo de OS"},"DESCRIPTION":{"LABEL":"Filtrar por descripción","PLACEHOLDER":"Buscar por descripción"},"SITUATION":{"LABEL":"Filtrar por situación"},"EMPLOYEE":{"LABEL":"Filtrar por empleado","NO_EMPLOYEE":"Sin empleado","TOGGLE":"Alternar miembro"},"LABELS":{"LABEL":"Filtrar por etiquetas","NO_LABELS":"Sin etiquetas"},"RATING":{"LABEL":"Filtrar por calificación","NO_RATING":"Sin calificación","TERRIBLE":"Terrible","BAD":"Malo","REGULAR":"Regular","GOOD":"Bueno","GREAT":"Genial"}},"DIALOGS":{"ROUTERIZATION":{"TITLE":"Enrutamiento de actividades","CLOSE_BUTTON":"Cerrar","PREVIOUS_BUTTON":"Anterior","NEXT_BUTTON":"Siguiente","CONFIRM_BUTTON":"Confirmar","TASK_DISTRIBUTION":"Distribución de actividades","INITIAL_DATE":"Fecha de inicio","CLICK_ON_THE_BUTTON":"Haz clic en el botón","VIEW_THE_MAP_FULL_SCREEN":"para ver el mapa a pantalla completa","AMOUNT_OF_ACTIVITIES_PER_DAY":"Cantidad de actividades por día","DAYS_OF_THE_WEEK":{"TITLE":"Días de la semana","DAYS":{"SUNDAY":"Dom","MONDAY":"Lun","TUESDAY":"Mar","WEDNESDAY":"Mié","THURSDAY":"Jue","FRIDAY":"Vie","SATURDAY":"Sáb"}},"STEPS":{"EMPLOYEE":"Empleado","SETTINGS":"Configuraciones","ROUTING":"Enrutamiento"},"INSULFICIENT_TASKS_ERROR":"El empleado necesita más de 2 actividades programadas para continuar","SUCCESS_MESSAGE":"Actividades guardadas correctamente","INVALID_INITIAL_LOCATION":"Destino inicial inválido","INVALID_END_LOCATION":"Destino final inválido","CONFIGURATION":{"CONSIDER_TRAFFIC":"Considerar tráfico","CONSIDER_TRAFFIC_DESCRIPTION":"Si está habilitado, la optimización de la ruta considerará la información del tráfico","ROUTE":"Ruta","VEHICLE":"Vehículo","INITIAL_DESTINATION":"Destino inicial","FINAL_DESTINATION":"Destino final","BALANCED":"Equilibrado","BALANCED_ROUTE_DESCRIPTION":"Ruta equilibrada en economía y velocidad","FASTEST":"Rápido","FASTEST_ROUTE_DESCRIPTION":"La ruta más rápida posible","SHORTEST":"Corto","SHORTEST_ROUTE_DESCRIPTION":"La ruta más corta posible","CAR":"Coche","MOTORCYCLE":"Motocicleta","TRUCK":"Camión","VAN":"Furgoneta","BICYCLE":"Bicicleta","PEDESTRIAN":"Peatón (sin vehículo)","COMPANY":"Empresa","COMPANY_DESCRIPTION":"Utiliza la dirección de la empresa para calcular la ruta","EMPLOYEE_HOME":"Casa del empleado","EMPLOYEE_HOME_DESCRIPTION":"Utiliza la dirección de casa del empleado para calcular la ruta","LAST_LOCALIZATION":"Última localización","LAST_LOCALIZATION_DESCRIPTION":"Utiliza la última localización activa del empleado para calcular la ruta","CUSTOM_FINAL_DESTINATION":"Destino final personalizado","CUSTOM_FINAL_DESTINATION_DESCRIPTION":"Elige una dirección personalizada para calcular la ruta","ADDRESS":"Dirección"},"ERROR":{"EMPLOYEE_LAST_LOCALIZATION_NOT_FOUND":"Última localización del empleado no encontrada","INVALID_INITIAL_DESTINATION":"Destino inicial inválido","USER_NOT_AUTHORIZED":"Este módulo no está habilitado para tu cuenta, solicita una demostración con tu gerente de cuenta.","MAXIMUM_LIMIT":"Se alcanzó el límite máximo de enrutamientos, contacta al soporte para aumentar tu límite","SERVER_ERROR":"Error de servidor al consultar el enrutamiento","NO_POSSIBLE_ROUTE_FOUND":"No fue posible encontrar una ruta entre las actividades seleccionadas.","UNKNOWN_SERVER_ERROR":"Error de servidor desconocido al consultar el enrutamiento","INITIAL_DATE_REQUIRED":"La fecha de inicio es obligatoria","AMOUNT_OF_ACTIVITIES_PER_DAY_REQUIRED":"La cantidad de actividades por día es obligatoria","AMOUNT_OF_ACTIVITIES_PER_DAY_PATTERN":"El valor debe ser un número entero","AMOUNT_OF_ACTIVITIES_PER_DAY_MIN":"El valor mínimo debe ser 1"},"SEARCH":{"EMPLOYEE_NAME_PLACEHOLDER":"Nombre del empleado"},"MODULE_UPDATE":{"TEXT":"¿Quieres escribir guiones para varios colaboradores a la vez? ¡Actualice al nuevo Avanzado Ruteador!","KNOW_MORE":"Saber más","UPGRADE":"Actualizar"},"LAYERS":{"DEFAULT":"Predeterminado","SATELLITE":"Satélite","ROADS":"Carreteras","GROUND":"Suelo"},"TASK_MARKER":{"OS_TYPE":"Tipo de tarea","SITUATION":"Situación","LATITUDE_LONGITUDE":"Latitud, Longitud"},"ROUTE_MILAGE":{"TEXT":"Total de millas de ruta: "},"MODAL":{"MODAL_TITLE":"Advertencia","MODAL_CONTENT":"Los identificadores enumerados a continuación corresponden a órdenes de servicio con coordenadas incorrectamente ingresadas en el registro de ubicación. Corrígelos manualmente antes de continuar con el enrutamiento.","MODAL_COPY_IDENTIFIERS":"Copiar códigos","MODAL_CLOSE":"SALIR","COPY_IDENTIFIERS_GEOLOCATION_INVALID":"Copiado correctamente al portapapeles"}}},"VIEWS":{"GANTT":{"ZOOM_CONTROL":{"TOOLTIP":"Control de zoom","ZOOM_IN":"Más zoom","ZOOM_OUT":"Menos zoom"},"DRAW":"Dibujar","CREATE_TASK_TIMELINE":"Crear actividad a través de la línea de tiempo","DRAG_AND_DROP":"(arrastrar y soltar)","ALLOW_DRAGGING_TASKS":"Permitir arrastrar actividades","TOTAL_TIME_TASKS":{"LABEL":"Tiempo total en actividades:","TOOLTIP":"El tiempo total en actividades es la suma de los minutos dedicados a las actividades."},"TOTAL_TIME_TRAVEL":{"LABEL":"Tiempo total de viaje:","TOOLTIP":"El tiempo total de viaje es la suma de los minutos dedicados al viaje."},"AVAILABLE_TIME":{"LABEL":"Tiempo disponible:","TOOLTIP":"El tiempo disponible es el resultado de restar el tiempo total menos el tiempo en actividades menos el tiempo de viaje."},"TOTAL_TIME_SUM":{"LABEL":"Tiempo total:","TOOLTIP":"El tiempo total es la suma del tiempo disponible por día para cada empleado."},"CONTENT":{"LOADING":"Cargando actividades...","NO_EMPLOYEE_ADDED":"Aún no se ha agregado ningún empleado de tu equipo externo o no hay ninguno activo en esta fecha.","ADD_FIRST_EMPLOYEE":{"TEXT":"Agrega el primer empleado en el menú superior derecho <b>Empleados</b> o haz clic","HERE":"aquí"}},"TASK":{"SUCCESS":"La actividad {{name}} # {{identifier}} se ha guardado correctamente.","ERROR":"No se pudo modificar la actividad.","NO_PERMISSION":"El empleado no puede realizar este tipo de OS.","NEW":"Nueva actividad","DRAG_AND_DROP":"Haga clic en la línea de tiempo, arrastre y suelte para crear una actividad para el empleado.","ERROR_ALREADY_ALOCATED":{"TITLE":"⚠️ Conflicto de Asignación","MESSAGE":"Este colaborador ya está asignado a la misma orden de trabajo durante el período seleccionado.<br/> <b>💡 Sugerencia:</b> Elija otro colaborador o ajuste las actividades."}},"TASKS_SUCCESS":"Actividades guardadas correctamente.","CONFIG_EMPLOYEE":"Empleado","ROUTE_TASK_NAME":"Desplazamiento","ABSENCE_TASK_NAME":"Ausencia: {{ reason }}","EMPLOYEE_LABEL_ONLINE":{"NO_LOCATION":"Sin ubicación","LAST_RECEIVED_LOCATION":"Última ubicación recibida","ON":" en {{ timestamp }}","OUTDATED_LOCATION":"Ubicación obsoleta","LAST_UPDATE_ON":" - última actualización en {{ timestamp }}","TASK_LOCATION":"ubicación  de la actividad"}},"LIST":{"TASK":{"EMPLOYEE_SELECTED":"El empleado {{ name }} ha sido asignado a las actividades seleccionadas.","SUCCESSFULLY_CHANGED":"Las actividades seleccionadas se han cambiado con éxito.","SUCCESSFULLY_ARCHIVED":"Las actividades seleccionadas se han archivado correctamente.","SUCCESSFULLY_UNARCHIVED":"Las actividades seleccionadas se han desarchivado correctamente.","SUCCESSFULLY_ARCHIVED_UNIQUE":"La actividad {{customer_name}} #{{order_identifier}} se ha archivado correctamente.","SUCCESSFULLY_UNARCHIVED_UNIQUE":"La actividad {{customer_name}} #{{order_identifier}} se desarchivó correctamente.","CHANGE_TASKS":{"TITLE":"{{ quantity }} actividades seleccionadas","MESSAGE":"{{ quantity }} actividades se cambiarán. ¿Estás seguro de que quieres continuar?","OK":"Sí, continuar","CANCEL":"Mejor no","CANNOT_MODIFY":{"TITLE":"No se puede modificar una o más actividades","OK":"OK","MESSAGE":"Solo las actividades con el estado <span class=\\"activity-scheduled-color\\"><b>Programado</b></span> pueden tener su fecha de visita cambiada."}},"ARCHIVED":"Archivado"},"RATING_EMAIL":{"RATING_LINK":"Se enviará un correo electrónico a los clientes de cada una de las actividades seleccionadas con el enlace para la evaluación.","TITLE":"{{ quantity }} actividades seleccionadas","MESSAGE":"Se enviarán correos electrónicos de evaluación a los clientes de {{ quantity }} actividades. ¿Estás seguro de que quieres continuar?","OK":"Sí, continuar","CANCEL":"Mejor no"},"ACTIONS":{"FILTERS":"Filtros","SELECT":"Seleccionar","DESELECT":"Deseleccionar","SELECT_ALL":"Seleccionar todo","DESELECT_ALL":"Deseleccionar todo","CHANGE_DATE":"Cambiar fecha","SEARCH_EMPLOYEE":"Buscar empleados...","CHANGE_EMPLOYEE":"Cambiar empleado","ARCHIVE":"Archivar","SEND_RATING":"Enviar correo de calificación","UNARCHIVE":"Desarchivar","PRINT":"Imprimir","TOOGLE_EMPLOYEE":"Alternar empleado"},"NO_EMPLOYEE":"Sin empleado","LABELS":{"TITLE":"Etiquetas","NO_LABEL":"No hay etiquetas registradas, solo los administradores pueden registrar etiquetas.","SEARCH_LABELS":"Buscar etiquetas...","TOGGLE_LABEL":"Alternar","EDIT_BUTTON":"Actualizar","ADD_NEW_BUTTON":"Crear nueva etiqueta","BACK_BUTTTON":"Atrás","NAME":"Nombre"},"PAGINATION":{"SELF":"Mostrando de {{ firstPageIndex }} a {{ lastPageIndex }} de {{ length }} registros","FILTERED":"(Filtrados de {{ length }} registros)"},"TICKETS":{"PREVIOUS":"Anterior","NEXT":"Siguiente"},"NO_TASK_REGISTERED_DAY":"No hay actividades registradas para {{ selectedDate }}.","NO_TASK_REGISTERED_FILTERS":"No hay actividades registradas con los filtros seleccionados, borra los filtros haciendo clic en el botón","CLEAR_FILTERS":"Borrar filtros","DAYS_TASKS":"para ver las actividades del día {{ selectedDate }}.","LOADING_TASKS":"Cargando actividades...","LAUNCH_DIALOG":{"TITLE":"🎉 ¡Novedad en el aire!","DESCRIPTION":"¡La página Actividades del Día tiene una nueva cara! Hemos rediseñado el aspecto y la navegación para hacerla más moderna, fluida y fácil de usar. Ahora es aún más sencillo seguir todo lo que importa en tu día.","RIGHT_BUTTON":"Probar nueva versión 🚀","LEFT_BUTTON":"Dejar para después :(","BANNER_TEXT":"<b>Nueva página de actividades del dia disponible,</b> ¡ahora con mejoras y un aspecto más moderno! ¿Quieres ser uno de los primeros en verla?"}},"MAIN":{"TITLE":"Panel de control","TIMELINE":"Línea de tiempo","MAP":"Mapa","LIST":"Listado"},"MAP":{"TASK":{"SCHEDULED":"Actividad programada","ON_ROUTE":"En ruta","PROGRESS":"Actividad en progreso","COMPLETED":"Actividad concluida","CANCELED":"Actividad cancelada","DISABLED":"Actividad impedida","CONNECTION_PATH":"Ruta de conexión"},"LAYERS":{"DEFAULT":"Predeterminado","SATELLITE":"Satélite","ROADS":"Carreteras","GROUND":"Suelo"},"CENTRALIZE":"Centrar","GROUP_VISITS":"Visitas en grupo"}},"AUTOUPDATE":"Auto-actualizar","AUTOUPDATE_TOOLTIP":"Actualizar la línea de tiempo cada 2 minutos","AUTOUPDATE_ENABLE":"Actualización automática habilitada, la línea de tiempo se actualizará cada 2 minutos","AUTOUPDATE_DISABLE":"Actualización automática deshabilitada.","DRAG_ALTER_TIME":"Cambiar la hora de programación de actividades sin horario al arrastrar","DRAG_ALTER_TIME_TOOLTIP":"Cambiar la hora de programación de actividades sin horario al arrastrar en lugar de solo modificar su posición","DRAG_ALTER_TIME_ENABLE":"Habilitado: al arrastrar una actividad sin horario, su hora de programación se establecerá en la hora del arrastre","DRAG_ALTER_TIME_DISABLE":"Deshabilitado: al arrastrar una actividad sin horario, solo se cambiará su posición y su hora de programación permanecerá sin definir","MAP_AUTOUPDATE_TOOLTIP":"Actualizar el mapa cada 2 minutos","NEW_LAYOUT":"Visualizar novo layout"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/control-panel/i18n/pt.json',
    '{"CONTROL_PANEL":{"PAGE_TITLE":"Painel de controle","TASKS_OF_DAY":"Atividades do dia","MAP":"Mapa","TIMELINE":"Linha do tempo","TUTORIAL_VIDEO":{"TITLE":"Instruções","TOOLTIP":"Assistir vídeo explicativo"},"TOOLBAR":{"DATE":{"PLACEHOLDER":"Selecionar data"},"CREATE_TASK":{"TOOLTIP":"Criar nova atividade","NO_PERMISSION":"Você não tem permissão para criar atividades"},"OPTIMIZE_ROUTES":{"TOOLTIP":"Otimizar rotas"},"FILTERS":{"CLEAR":"Limpar filtros","TOOLTIP":"Filtrar atividades"},"RELOAD":{"TOOLTIP":"Atualizar dados"}},"ERROR":{"DATE_REQUIRED":"A data é obrigatória"},"FILTERS":{"TITLE":"Filtrar atividades","CLEAR":"Limpar","NAME":{"LABEL":"Filtrar por cliente","PLACEHOLDER":"Pesquisar por cliente"},"CUSTOMER_LABEL":{"LABEL":"Filtrar por etiqueta de cliente","SEARCH":"Pesquisar etiqueta de cliente"},"LOCATION":{"LABEL":"Filtrar por nome da localização","SEARCH":"Pesquisar nome da localização"},"ARCHIVED":{"LABEL":"Filtrar por estado"},"TASK":{"LABEL":"Filtrar por tipo de OS","PLACEHOLDER":"Filtrar tipo de OS"},"DESCRIPTION":{"LABEL":"Filtrar por descrição","PLACEHOLDER":"Pesquisar por descrição"},"SITUATION":{"LABEL":"Filtrar por situação"},"EMPLOYEE":{"LABEL":"Filtrar por colaborador","NO_EMPLOYEE":"Sem colaborador","TOGGLE":"Alternar membro"},"LABELS":{"LABEL":"Filtrar por etiquetas","NO_LABELS":"Sem etiqueta"},"RATING":{"LABEL":"Filtrar por avaliação","NO_RATING":"Sem avaliação","TERRIBLE":"Péssimo","BAD":"Ruim","REGULAR":"Regular","GOOD":"Bom","GREAT":"Ótimo"}},"DIALOGS":{"ROUTERIZATION":{"TITLE":"Roteirização de atividades","CLOSE_BUTTON":"Fechar","PREVIOUS_BUTTON":"Voltar","NEXT_BUTTON":"Próximo","CONFIRM_BUTTON":"Confirmar","TASK_DISTRIBUTION":"Distribuição de atividades","INITIAL_DATE":"Data de início","CLICK_ON_THE_BUTTON":"Clique no botão","VIEW_THE_MAP_FULL_SCREEN":"para ver o mapa em tela cheia","AMOUNT_OF_ACTIVITIES_PER_DAY":"Quantidade de atividades por dia","DAYS_OF_THE_WEEK":{"TITLE":"Dias da semana","DAYS":{"SUNDAY":"Dom","MONDAY":"Seg","TUESDAY":"Ter","WEDNESDAY":"Qua","THURSDAY":"Qui","FRIDAY":"Sex","SATURDAY":"Sáb"}},"STEPS":{"EMPLOYEE":"Colaborador","SETTINGS":"Configurações","ROUTING":"Roteirização"},"INSULFICIENT_TASKS_ERROR":"O colaborador precisa ter mais que 2 atividades agendadas para poder prosseguir","SUCCESS_MESSAGE":"As atividades foram salvas com sucesso","INVALID_INITIAL_LOCATION":"Destino inicial inválido","INVALID_END_LOCATION":"Destino final inválido","CONFIGURATION":{"CONSIDER_TRAFFIC":"Considerar trânsito","CONSIDER_TRAFFIC_DESCRIPTION":"Se habilitado, a roteirização do percurso levará em consideração informações sobre o trânsito","ROUTE":"Percurso","VEHICLE":"Veículo","INITIAL_DESTINATION":"Destino inicial","FINAL_DESTINATION":"Destino final","BALANCED":"Equilibrado","BALANCED_ROUTE_DESCRIPTION":"Percurso equilibrado em economia e velocidade","FASTEST":"Rápido","FASTEST_ROUTE_DESCRIPTION":"O percurso mais rápido possível","SHORTEST":"Curto","SHORTEST_ROUTE_DESCRIPTION":"O percurso mais curto possível","CAR":"Carro","MOTORCYCLE":"Moto","TRUCK":"Caminhão","VAN":"Van","BICYCLE":"Bicicleta","PEDESTRIAN":"Pedestre (sem veículo)","COMPANY":"Empresa","COMPANY_DESCRIPTION":"Usa o endereço da empresa para calcular a rota","EMPLOYEE_HOME":"Casa do Colaborador","EMPLOYEE_HOME_DESCRIPTION":"Usa o endereço da casa do colaborador para calcular a rota","LAST_LOCALIZATION":"Última localização","LAST_LOCALIZATION_DESCRIPTION":"Usa a ultima localização ativa do colaborador para calcular a rota","CUSTOM_FINAL_DESTINATION":"Destino final personalizado","CUSTOM_FINAL_DESTINATION_DESCRIPTION":"Escolha um endereço personalizado para calcular a rota","ADDRESS":"Endereço"},"ERROR":{"EMPLOYEE_LAST_LOCALIZATION_NOT_FOUND":"Última localização do colaborador não encontrada","INVALID_INITIAL_DESTINATION":"Destino inicial inválido","USER_NOT_AUTHORIZED":"Esse módulo não está habilitado para sua conta, solicite uma demonstração com seu gerente de contas.","MAXIMUM_LIMIT":"Limite máximo de roteirizações atingido, entre em contato com o suporte para aumentar seu limite","SERVER_ERROR":"Erro no servidor ao consultar a roteirização","NO_POSSIBLE_ROUTE_FOUND":"Não foi possível encontrar uma rota entre as atividades selecionadas.","UNKNOWN_SERVER_ERROR":"Erro desconhecido no servidor ao consultar a roteirização","INITIAL_DATE_REQUIRED":"A data de início é obrigatória","AMOUNT_OF_ACTIVITIES_PER_DAY_REQUIRED":"Quantidade de atividades por dia é obrigatório","AMOUNT_OF_ACTIVITIES_PER_DAY_PATTERN":"O valor deve ser inteiro","AMOUNT_OF_ACTIVITIES_PER_DAY_MIN":"O valor mínimo deve ser 1"},"SEARCH":{"EMPLOYEE_NAME_PLACEHOLDER":"Nome do colaborador"},"MODULE_UPDATE":{"TEXT":"Deseja roteirizar para múltiplos colaboradores de uma única vez? Faça o upgrade para o novo Roteirizador Avançado!","KNOW_MORE":"Saiba mais","UPGRADE":"Fazer upgrade"},"LAYERS":{"DEFAULT":"Padrão","SATELLITE":"Satélite","ROADS":"Estradas","GROUND":"Terreno"},"TASK_MARKER":{"OS_TYPE":"Tipo de OS","SITUATION":"Situação","LATITUDE_LONGITUDE":"Latitude, Longitude"},"ROUTE_MILAGE":{"TEXT":"Quilometragem total do percurso: "},"MODAL":{"MODAL_TITLE":"Aviso","MODAL_CONTENT":"Os identificadores listados abaixo correspondem a ordens de serviço com coordenadas inseridas de forma incorreta no cadastro de localização. Corrija-as manualmente antes de prosseguir com a roteirização.","MODAL_COPY_IDENTIFIERS":"Copiar códigos","MODAL_CLOSE":"SAIR","COPY_IDENTIFIERS_GEOLOCATION_INVALID":"Copiado para a área de transferência com sucesso"}}},"VIEWS":{"GANTT":{"ZOOM_CONTROL":{"TOOLTIP":"Controle de Zoom","ZOOM_IN":"Mais Zoom","ZOOM_OUT":"Menos Zoom"},"DRAW":"Desenhar","CREATE_TASK_TIMELINE":"Criar atividade pela linha do tempo","DRAG_AND_DROP":"(arrastar e soltar)","ALLOW_DRAGGING_TASKS":"Permitir arrastar atividades","TOTAL_TIME_TASKS":{"LABEL":"Tempo total em atividades:","TOOLTIP":"Tempo total em atividades é a soma dos minutos gastos em atividades."},"TOTAL_TIME_TRAVEL":{"LABEL":"Tempo total em deslocamento:","TOOLTIP":"Tempo total em deslocamento é a soma dos minutos gastos em deslocamento."},"AVAILABLE_TIME":{"LABEL":"Tempo disponível:","TOOLTIP":"Tempo disponível é resultado a subtração do tempo total menos tempo em atividades menos tempo em deslocamento."},"TOTAL_TIME_SUM":{"LABEL":"Tempo total:","TOOLTIP":"Tempo total é a soma do tempo disponível por dia cada um dos colaboradores."},"CONTENT":{"LOADING":"Carregando atividades...","NO_EMPLOYEE_ADDED":"Ainda não foi adicionado nenhum colaborador da sua equipe externa ou não há nenhum ativo nessa data.","ADD_FIRST_EMPLOYEE":{"TEXT":"Adicione o primeiro colaborador no menu superior direito <b>Colaboradores</b> ou clique","HERE":"aqui"}},"TASK":{"SUCCESS":"Atividade {{ name }} # {{ identifier }} salva com sucesso.","ERROR":"Não foi possível modificar a atividade","ERROR_ALREADY_ALOCATED":{"TITLE":"⚠️ Conflito de Alocação","MESSAGE":"Este colaborador já está vinculado à mesma OS no período selecionado.<br/> <b>💡 Sugestão:</b> Escolha outro colaborador ou ajuste as atividade"},"NO_PERMISSION":"Colaborador não pode executar esse tipo de OS.","NEW":"Nova atividade","DRAG_AND_DROP":"Clique na linha do tempo, arraste e solte para criar uma atividade para o colaborador."},"TASKS_SUCCESS":"As atividades foram salvas com sucesso.","CONFIG_EMPLOYEE":"Colaborador","ROUTE_TASK_NAME":"Deslocamento","ABSENCE_TASK_NAME":"Ausência: {{ reason }}","EMPLOYEE_LABEL_ONLINE":{"NO_LOCATION":"Sem localização","LAST_RECEIVED_LOCATION":"Última localização recebida","ON":" em {{ timestamp }}","OUTDATED_LOCATION":"Localização desatualizada","LAST_UPDATE_ON":" - última atualização em {{ timestamp }}","TASK_LOCATION":"local da atividade"}},"LIST":{"TASK":{"EMPLOYEE_SELECTED":"Colaborador {{ name }} foi atribuído para as atividades selecionadas.","SUCCESSFULLY_CHANGED":"As atividades selecionadas foram alteradas com sucesso.","SUCCESSFULLY_ARCHIVED":"As atividades selecionadas foram arquivadas com sucesso.","SUCCESSFULLY_UNARCHIVED":"As atividades selecionadas foram desarquivadas com sucesso.","SUCCESSFULLY_ARCHIVED_UNIQUE":"Atividade {{ customer_name }} #{{ order_identifier }} arquivada com sucesso.","SUCCESSFULLY_UNARCHIVED_UNIQUE":"Atividade {{ customer_name }} #{{ order_identifier }} desarquivada com sucesso.","CHANGE_TASKS":{"TITLE":"{{ quantity }} atividades selecionadas","MESSAGE":"Serão alteradas {{ quantity }} atividades. Tem certeza que deseja prosseguir?","OK":"Sim, prosseguir","CANCEL":"Melhor não","CANNOT_MODIFY":{"TITLE":"Não é possível modificar uma ou mais atividades","OK":"OK","MESSAGE":"Apenas atividades com situação <span class=\\"activity-scheduled-color\\"><b>Agendada</b></span> podem ter a data da visita alterada."}},"ARCHIVED":"Arquivada"},"RATING_EMAIL":{"RATING_LINK":"Um e-mail será enviado para os clientes de cada uma das atividades selecionadas com o link para avaliação.","TITLE":"{{ quantity }} atividades selecionadas","MESSAGE":"Serão enviados e-mails de avaliação para clientes de {{ quantity }} atividades. Tem certeza que deseja prosseguir?","OK":"Sim, prosseguir","CANCEL":"Melhor não"},"ACTIONS":{"FILTERS":"Filtros","SELECT":"Selecionar","DESELECT":"Deselecionar","SELECT_ALL":"Selecionar todas","DESELECT_ALL":"Deselecionar todas","CHANGE_DATE":"Alterar data","SEARCH_EMPLOYEE":"Pesquisar colaboradores...","CHANGE_EMPLOYEE":"Alterar colaborador","ARCHIVE":"Arquivar","SEND_RATING":"Enviar e-mail de avaliação","UNARCHIVE":"Desarquivar","PRINT":"Imprimir","TOOGLE_EMPLOYEE":"Alternar colaborador"},"NO_EMPLOYEE":"Sem colaborador","LABELS":{"TITLE":"Etiquetas","NO_LABEL":"Nenhuma etiqueta cadastrada, apenas administradores podem cadastrar etiquetas.","SEARCH_LABELS":"Pesquisar etiquetas...","TOGGLE_LABEL":"Alternar","EDIT_BUTTON":"Atualizar","ADD_NEW_BUTTON":"Criar nova etiqueta","BACK_BUTTTON":"Voltar","NAME":"Nome"},"PAGINATION":{"SELF":"Mostrando de {{ firstPageIndex }} até {{ lastPageIndex }} de {{ length }} registros","FILTERED":"(Filtrados de {{ length }} registros)"},"TICKETS":{"PREVIOUS":"Anterior","NEXT":"Próximo"},"NO_TASK_REGISTERED_DAY":"Nenhuma atividade cadastrada para o dia {{ selectedDate }}.","NO_TASK_REGISTERED_FILTERS":"Nenhuma atividade cadastrada com filtros selecionados, limpe os filtros clicando no botão","CLEAR_FILTERS":"Limpar filtros","DAYS_TASKS":"para visualizar as atividades do dia {{ selectedDate }}.","LOADING_TASKS":"Carregando atividades...","LAUNCH_DIALOG":{"TITLE":"🎉 Novidade no ar!","DESCRIPTION":"A página Atividades do Dia está de cara nova! Reformulamos o visual e a navegação para deixá-la mais moderna, fluida e fácil de usar. Agora ficou ainda mais simples acompanhar tudo o que importa no seu dia.","RIGHT_BUTTON":"Testar nova versão 🚀","LEFT_BUTTON":"Deixar para depois :(","BANNER_TEXT":"<b>Nova página de atividades do dia disponível,</b> agora com melhorias e um visual mais moderno! Quer ser um dos primeiros a conferir?"}},"MAIN":{"TITLE":"Painel de controle","TIMELINE":"Linha do tempo","MAP":"Mapa","LIST":"Listagem"},"MAP":{"TASK":{"SCHEDULED":"Atividade agendada","ON_ROUTE":"Em deslocamento","PROGRESS":"Atividade em andamento","COMPLETED":"Atividade concluída","CANCELED":"Atividade cancelada","DISABLED":"Atividade impedida","CONNECTION_PATH":"Ligação de trajetos"},"LAYERS":{"DEFAULT":"Padrão","SATELLITE":"Satélite","ROADS":"Estradas","GROUND":"Terreno"},"CENTRALIZE":"Centralizar","GROUP_VISITS":"Agrupar visitas"}},"AUTOUPDATE":"Atualizar periodicamente","AUTOUPDATE_TOOLTIP":"Atualizar a linha do tempo a cada 2 minutos","AUTOUPDATE_ENABLE":"Atualização automática ativada, a linha do tempo será atualizado a cada 2 minutos","AUTOUPDATE_DISABLE":"Atualização automática desativada.","DRAG_ALTER_TIME":"Aplicar horário ao arrastar atividades sem hora marcada","DRAG_ALTER_TIME_TOOLTIP":"Ative esta opção para que, ao arrastar uma atividade sem horário marcado, ela receba o novo horário conforme a posição em que for solta.","DRAG_ALTER_TIME_ENABLE":"Quando ativado, ao arrastar uma atividade sem horário definido, o horário do agendamento será atualizado conforme o ponto em que ela for solta.","DRAG_ALTER_TIME_DISABLE":"Quando desativado, arrastar uma atividade sem horário apenas muda sua posição visual, sem definir um horário de agendamento.","MAP_AUTOUPDATE_TOOLTIP":"Atualizar o mapa a cada 2 minutos","NEW_LAYOUT":"Visualizar novo layout"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/customers/i18n/en.json',
    '{"CUSTOMERS":{"PAGE_TITLE":"Customers","TITLE":"Customers","TUTORIAL_VIDEO":{"TITLE":"Instructions","TOOLTIP":"Watch tutorial video"},"TOOLBAR":{"IMPORT_FROM":"Import customers from {{app}}","MANUAL_IMPORT":"Manual Import","AUTOMATIC_IMPORT":"Automatic Import","TABLE_VIEW":"View table","MAP_VIEW":"View map","PRINT":"Print","EXPORT_TO_EXCEL":"Export to Excel","RESTORE_COLUMNS":"Restore columns","SWITCH_COLUMNS":"Switch columns","ADD":"Add customer","NO_PERMISSION":"You are not allowed to create customers","CLEAR_FILTERS":"Clear filters","FILTER_CUSTOMERS":"Filter customers","RELOAD":"Refresh"},"TABLE":{"LABELS":"Tags","NAME":"Name","STATUS":{"ACTIVE":"Active","ARCHIVED":"Archived"},"DOCUMENT_NUMBER":"Customer Identification","EMAIL":"Primary email","PHONE":"telephone number","ADDRESS":"Full address","OBSERVATIONS":"Comments","FIRST_VISIT_IN":"First service on","LAST_VISIT_IN":"Last service on","TOTAL_VISITS":"Total services","AVERAGE_RATING":"Average rating","NOT_RATED":"Not rated","LAST_REVIEW":"Last review","LAST_COMMENT":"Last comment","CREATED_ON":"Created on","ACTIONS":"Actions","CUSTOMER_EDIT_NOT_ALLOWED":"You are not allowed to edit this customer","EDIT":"Edit","VIEW":"View","SPREADSHEET_SENT":"The spreadsheet will be sent to {{email}} in a few minutes","SPREADSHEET_ERROR":"Ooops, something went wrong. Unable to export customers :("},"MAP":{"LOADER":"Loading customer map ...","NEW_TASK_BUTTON":"Create new task","MAX_CUSTOMER_WARNING_TITLE":"Area search mode enabled","MAX_CUSTOMER_WARNING_MESSAGE":"The total number of customers registered in your account exceeds the capacity supported by the map. <br/><br/> Therefore, the search mode by area has been activated. <br/> To find customers that are not visible on your map, zoom in on the desired area and use the search button. <br/>","MAX_CUSTOMER_WARNING_IMG_ALT":"search button image by area","ERROR_WARNING_TITLE":"There has been an error","OK":"OK","ERROR_WARNING_MESSAGE":"There has been an error trying to fetch the information for the map, please try again later","IN_BOUNDS_SEARCH_BUTTON":"Search this area","CREATE_CUSTOMER":"You can create a new customer","CLICKING_HERE":"by clicking here","LAYERS":{"DEFAULT":"Default","SATELLITE":"Satellite","ROADS":"Roads","GROUND":"Ground"},"LATITUDE_LONGITUDE":"Coordinates: {{ latitude }}, {{ longitude }}"},"EXPORT_MODAL":{"TITLE":"Export customers","WARNING_BODY":"You will receive the export at: <b>{{email}}</b> .","SLOW_PROCESS":"At peak times, this procedure takes a while, ok?","EXPORT_TO_EMAIL":"Send by email","CANCEL":"Cancel"},"FILTERS":{"TITLE":"Filter customers","CLEAR":"clear","FIRST_VISIT_FILTERS":"First service filters","OF":"From:","UNTIL":"To:","DATE":{"PLACEHOLDER":"Select date"},"FILTERS_BY_LAST_VISIT":"Filters by last service","NAME":{"PLACEHOLDER":"Search name .."},"PHONE":{"PLACEHOLDER":"Search phone .."},"DOCUMENT_NUMBER":{"PLACEHOLDER":"Search ID / EIN .."},"STREET":{"PLACEHOLDER":"Search street .."},"EMAIL":{"PLACEHOLDER":"Search email .."},"CITY":{"PLACEHOLDER":"Search city .."},"STATE":{"PLACEHOLDER":"Search state .."},"FILTER_BY_OMIE":"Filter by Omie account","FILTER_BY_SITUATION":"Filter by situation","STATUS":{"ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"},"FILTER_BY_RATING_AVERAGE":"Filter by rating average","NOT_RATED":"Not rated","FILTER_BY_LAST_REVIEW":"Filter by last review","FILTER_BY_LABEL":{"LABEL":"Filter by tags","NO_LABEL":"Without tag"},"RATINGS":{"TERRIBLE":"Terrible","BAD":"Bad","REGULAR":"Regular","GOOD":"Good","GREAT":"Great"},"BY_TERRITORY":{"LABEL":"Filter by territory","SEARCH":"Search territory","SEARCH_LABEL":"Select territory"},"BY_SUBTERRITORY":{"LABEL":"Filter by subterritory","SEARCH":"Search subterritory","SEARCH_LABEL":"Select subterritory"}},"DIALOGS":{"CONTACTS":{"TITLE":"Select customer contacts","CLOSE":"Close","EMAIL_LINK_REPORT":"Which email should the activity report be sent to?","TOGGLE_ALL":"Select all","UNCHECK_ALL":"Unselect all","CHECK_ALL":"Check all","NOT_HAVE_EMAIL":"This client <strong>has no</strong> registered email.","SEND":"Submit"},"CUSTOMER":{"LABEL":{"TITLE":"Tag","MANAGE":"Manage Tags","NO_REGISTERED":"No tags, only managers can create tags.","UPDATED":"The labels were successfully updated.","LIMIT_EXCEEDED":"Maximum tag limit was exceeded.","PLACEHOLDER":"Search tags ...","TOGGLE":"Toggle","EDIT":"Update","ADD":"Create new tag","BACK":"Back","NAME":"Name","CREATE_BUTTON":"Create","EDIT_LABEL":"Edit"},"TITLE_NEW":"New customer","TITLE_EDIT":"Edit customer","CLOSE_DIALOG":"Close","ERROR":{"TITLE":"Customer without a primary location","MESSAGE":"The customer does not have a primary location. We will select one by default. Please go to the customer and set a location as primary.","CONTINUE":"Continue"},"GENERAL":{"TITLE":"General","CUSTOMER_INFOS":"Customer\'s infos","AVATAR_RULES":"Ideal logo dimensions are 512px x 512px, with a maximum size of 2MB.","NAME":{"LABEL":"Name","REQUIRED":"Name required","VALID":"Name can\'t be longer than 150 characters","WHITE_SPACES":"The name must not be separated by more than one space"},"DOCUMENT":{"LABEL":"Customer Identification","INVALID_CPF":"Invalid Social security number","INVALID_CNPJ":"Invalid EIN","EXISTS":"Document already exists"},"ADDRESS":{"LABEL":"Customer address","KM_DISTANCE":"km away","NOT_FOUND":"Unable to find address, please try again.","SEARCH_HINT":"Look for an address, for example: Rua dos Pinheiros, 383 - São Paulo","REQUIRED":"Customer address required","NUMBER_NOT_SPECIFIED":"Address number not specified.","CLEAR":"Clear customer address","ENTER_THE_CUSTOMERS_ADDRESS":"Enter the customer\'s address in the field above","COMPLEMENT":{"LABEL":"Additional information","VALID":"Additional information can\'t be longer than 100 characters"}},"ZIPCODE":{"LABEL":"Zip code","REQUIRED":"Zip code required","PATTERN":"Zip code invalid."},"CITY":{"LABEL":"City","REQUIRED":"City required"},"STATE":{"LABEL":"state","REQUIRED":"State required"},"NEIGHBORHOOD":{"LABEL":"Neighborhood","REQUIRED":"Neighborhood required"},"STREET":{"LABEL":"Street","REQUIRED":"Street required"},"NUMBER":{"LABEL":"Number","REQUIRED":"Number required"},"COMPLEMENT":{"LABEL":"additional information"},"LATITUDE_LONGITUDE":"latitude: {{latitude}}, longitude {{longitude}}","EMAIL":{"LABEL":"Email","PATTERN":"Invalid email format","MAIN":"Primary email"},"EMAIL_TYPE":{"LABEL":"Type","PERSONAL":"Personal","WORK":"Work"},"REMOVE_EMAIL":"Remove email","ADD_EMAIL":"Add one more email","PHONE":{"LABEL":"Number","INVALID":"Invalid phone number","MAIN":"Primary phone"},"PHONE_TYPE":{"LABEL":"Type","CELL":"Cell phone","HOME":"Home","WORK":"Work"},"REMOVE_PHONE":"Remove phone number","ADD_PHONE":"Add one more phone number","NOTES":{"LABEL":"Notes"},"GEOLOCATION_NOT_VERIFIED":"Geolocation (latitude / longitude) not verified"},"CONTACTS":{"TITLE":"Contacts"},"LOCATIONS":{"LABEL":"Locations","LABEL_CREATE":"Location","NEW_CUSTOMER_ALERT":"This will be the main location of this client.","LATITUDE_LONGITUDE":"Latitude: {{latitude}} - Longitude: {{longitude}}","CUSTOMER_LOCATION":"Customer location","COMPLEMENT":"Complement of address","NAME":"Location name","SAVE_LOCATION":"Save location","BACK":"Back","PRIMARY_LOCATION":"Primary location","LINKED_LOCATIONS":"Linked locations","ACTIONS":"Actions","DUPLICATED_LOCATION_NAME":"Location with duplicated name","CREATE_LOCATION":"Register location","EDIT_LOCATION":"Edit location","ARCHIVE_LOCATION":"Archive location","LOCATION_LOCKED":"Cannot edit a blocked location","SELECT_PRIMARY_LOCATION":"Selelct primary location","NEXT":"Next","PREVIOUS":"Previous","UPDATE_COORDINATES":"Update coordinates","UPDATE_COORDINATES_DISABLED":"To update the coordinates add an address.","NAVIGATION_PHRASE":"Showing from {{quantityStart}} to {{quantityEnd}} of {{maxQuantity}} locations","ARCHIVED":"Archived","ALERTS":{"REMOVE_LOCATION":"Are you sure you want to <b> delete </b> this location <br> <b> {{locationName}} </b>?"},"FILTERS":{"CLEAR":"Clear filter by address","FORMATTED_ADDRESS":"Filter by address","FORMATTED_ADDRESS_HINT":"To <b> filter </b> a location, enter the address.","NAME":"Search by name","NAME_HINT":"<b>Search</b> locations by name.","NOT_FOUND":"No address was found.","CREATE_LOCATION":"Register the address to your locations."},"TOASTS":{"LOCATION_SAVED":"Location \'{{locationName}}\' registered successfully!","LOCATION_ARCHIVED":"Location \'{{locationName}}\' archived successfully!","SAVE_ERROR":"An error occurred while saving the location. Please contact support!"},"ADDRESS":{"ADD":"Add location","LOCATION_ADDRESS":"Location address","SEARCH":"Search by address","SEARCH_HINT":"To add a new location, search for an address and click Add Location","NOT_FOUND":"The address was not found, please change your search and try again","NUMBER_NOT_SPECIFIED":"The address number is not specified","PRIMARY_ADDRESS":"Primary address","NAME_REQUIRED":"Name is required","DUPLICATED_NAME":"Another address already has this name","ADDRESS_REQUIRED":"Address is required"},"LAYERS":{"DEFAULT":"Standard","SATELLITE":"Satellite","ROADS":"Roads","GROUND":"Terrain"}},"ATTACHMENTS":{"LABEL":"Attachments","HINT_MESSAGE":"Click or drag your files to upload","MAX_SIZE":"Maximum file size of 10MB","NOT_SUPPORTED_FILE_DRAG":"File not supported by your browser","OF":"of","IMG":"attached images allowed","SEND":"Submit","ATTACHMENT_WARNING":"Limit of 20 attachments on the Manager Panel. The maximum size of each file is 10MB","DROP_HERE":"Drag your files to upload","INSERT_FILES_ALTERNATIVE":"Drag your files to upload or","ATTACHMENTS_LIMIT_REACHED":"Attachment limit was reached, to add more attachments you need to remove some of the files first.","INSERT_FILES":"Insert files","SEND_FILES":"Send files","ATTACHMENT_DESCRIPTION":"Limit of 20 attachments. Maximum size of 10MB per attachment.","NO_ATTACHMENTS_ADDED":"No attachments added for this customer.","SAVE_TITLE":"Save title","CANCEL":"Cancel","EDIT_NAME":"Rename","UNTITLED":"Untitled","ADDED_BY":"Added by","ADDED_AT":"Added at","IN":"in","AT":"at","VIEW_FILE":"View file","REMOVE":"Remove attachment","REMOVE_CONFIRMATION":"Are you sure you want to <strong>delete</strong> the attachment?","YES":"Yes","NO":"No","LINK":"Link","SEND_SUCCESS":"Files uploaded.","SEND_FAIL":"Unable to attach file: {{file_name}}","SAVE_TITLE_SUCCESS":"Attachment title changed.","SHARE_ATTACHMENTS_WITH_CLIENT":{"TOOLTIP_ON":"Share with client","TOOLTIP_OFF":"Stop sharing with client","CONFIRMATION_DIALOG":{"TITLE":"Share attachment with client","DESCRIPTION":"This attachment will be available in the {{ customerName }} client\'s area. Are you sure?","NOT_SHOW_AGAIN":"Do not show this message again.","YES":"Yes","NO":"No"},"TOASTS":{"IS_SHARING":"Attachment successfully shared.","IS_NOT_SHARING":"Attachment is no longer shared.","ERROR":"An error occurred while sharing the attachment."}}},"SERVICES":{"TITLE":"History","NO_HISTORY":"This customer has no service history.","GO_TO_TASKS_LIST":"Go to task list"},"TEMPLATE":{"TITLE":"Templates","INFO":"Templates are custom styles for work order reports. If necessary, link a specific template to this type of activity, and it will be automatically applied whenever it is related.","LINK":"Link template","EMPTY_STATE":"No template linked to this client","REMOVE":"Remove template","EDIT":"Change template","ACTIVE":"Active","INACTIVE":"Inactive","ARCHIVED":"Archived","TYPE":{"ORDER":"Work order report template"},"SELECT":{"TITLE":"Link Template","SEARCH":"Search by template name...","CANCEL":"Cancel","SUCCESS":"Link","EMPTY":"No templates found"}},"SAVE":"Save","CREATE":"Create","CONTINUE":"Continue","SEND_TO":"Send to","CANT_SEND_WITHOUT_DOCUMENT":"Cannot send customers without Social security number / EIN","ARCHIVE":"Archive","UNARCHIVE":"Unarchive","SAVED_CUSTOMER":"Customer \'{{name}}\' saved."},"BRAND":{"TITLE":"Logo","SELECT_OR_DRAG_IMAGE":"Click or drag your image to upload","CROP_IMAGE":"To crop this image, select below and click the button:"},"ALERTS":{"CUSTOMER_DESCRIPTION":{"TITLE":"Ops! It seems that something did not work.","MESSAGE":"It is not possible to complete this action because the Blue Account platform does not accept clients that have more than 255 characters registered in the customer\'s observations."}}},"SERVICES":{"SCHEDULED_ACTIVITY":"Scheduled task, waiting to be done.","ACTIVITY_IN_PROGRESS":"Task in progress, started at:","ACTIVITY_CANCELED":"Task canceled","OPENING_HOURS":"Opening hours:","UNTIL":"to","TOTAL_DURATION_OF":"with total duration of","MINUTES":"minutes."},"INTEGRATIONS":{"ENABLE_INTEGRATION":"Enable integration","ARCHIVED":"Archived","EXPORT_TITLE":"Export customer","EXPORT_INSTRUCTIONS":"The customer will be exported to {{ app }} with the following information:","EXPORT":"Export","CUSTOMER_IS_ARCHIVED":"This customer is archived on Field","IMPORTS":{"ACCOUNT":"Omie Account","FROM":"Customer imported from the Omie account <b>{{account}}</b>","SELECT_THE_ACCOUNT":"Select the Omie account to export the customer <b>{{customerName}}</b>","SELECT_THE_ACCOUNT_MANUAL":"Select the Omie account you wish to export the customers manually.","ARE_YOU_SURE":"Are you sure you want to continue with the export?","TITLE":"Import customers from {{app}}","FOUND_CUSTOMERS":"Found customers","MANUAL":"Manual Import","AUTOMATIC":"Automatic Import","CONTENT":"This process will import all {{quantity}} customers that are registered in the selected Omie account.<br><br>&#8226; customers that do not exist in Field Control will be created;<br>&#8226; customers already existing in Field Control will be updated<br><br >The process may take a few moments depending on the quantity of customers. Do not close the window until the process has finished.","IMPORT_LOADING_TITLE":"Importing customers from Omie","WAIT_LOADING":"Please wait, we are importing the customers...","CLOSE":"Close","IMPORT_BUTTON":"Import","UPDATE_SUCCESS":"Updated successfully","UPDATE_ERROR":"There was an error with this importation.","UPDATE_ERROR_CREATE":"Customer not found in field, so it was created.","CREATE_ERROR":"Error importing customer.","SUCCESS_AUTOMATIC":"customers imported successfully!","SUCCESS_MANUAL":"Imported successfully!","SEARCH_BY_NAME":"Enter at least 3 characters to search for customers you want to import into Field Control.","LOADING_ERROR":"There was an error loading omie customers."},"UPDATE":"Update","IMPORT":"import","CONTINUE":"Continue","CANCEL":"Cancel","CONFIRM":"Confirm","CONFIRM_CREATE":"Confirmation of customer creation","CONFIRM_UPDATE":"Customer update confirmation","UPDATE_OR_CREATE_NEW_CUSTOMER":"Change an existing customer or create a new one:","NEW_CUSTOMER":"New customer","CREATED_SUCCESSFULLY":"Customer {{customer}} created on {{appName}}","UPDATED_SUCCESSFULLY":"Customer {{customer}} updated on {{appName}}","CANT_CREATE_DOCUMENT_ALREADY_EXISTS":"Unable to create customer in Conta Azul, apparently there is already a customer with the same document: {{document}}","CANT_UPDATE_DOCUMENT_ALREADY_EXISTS":"Unable to update the customer in Conta Azul, apparently there is already a customer with the same document: {{document}}","ERROR_SENDING_CUSTOMER":"Error sending client","INVALID_ZIPCODE_CONFIRM_TITLE":"Invalid zip code","INVALID_ZIPCODE_CONFIRM_MESSAGE":"The zip code is invalid. If you continue, it will be sent blank to Omie and you will need to fill it in manually.","NAME":"Name","DOCUMENT":"Document","ADDRESS":"Address","PHONE":"telephone number","NOTES":"Notes","EMAIL":"Email","FIND_CUSTOMER_TO_IMPORT":"Use the field above to find the customers you want to import into Field Control","CANT_FIND_ANY_CUSTOMER_WITH":"Could not find any customer with:","WILL_BE_CREATED_WITH_DATA":"The customer will be created in {{app}} with the following data:","WILL_BE_UPDATED_WITH_DATA":"The customer will be updated in {{app}} with the following data:","SENDING_CUSTOMER":"Sending client to {{app}}","FIND_CUSTOMERS_DESCRIPTION":"From <b>name</b>\'s data, or <b>document, we</b> identify the possible customers already registered in the {{app}}","CREATE_NEW_CUSTOMER":"Create a new customer in {{app}}","IMPORT_CUSTOMERS_FROM":"Import {{app}} customers","CANT_CONNECT":"Unable to connect with {{app}}, check your integration settings and try again.","CANT_PROCEED_WITH_NO_ADDRESS":"You cannot {{action}} a customer without an address","ERROR_WHEN_ACTIVATING":"Error enabling integration with {{app}}","SUCCESS_WHEN_ACTIVATING":"{{app}} Integration enabled!","CONFIGURATION_TITLE":"{{App}} integration","ACTIVATE_INTEGRATION":"Enable integration","SUCCESS_WHEN_DISABLING":"Integration with {{app}} disabled!","ERROR_WHEN_DISABLING":"Error disabling integration with {{app}}","CUSTOMERS_AUTOMATIC_IMPORT":"Customer automatic importation","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_1":"This process will import all <b> {{totalCustomerToImport}} customers </b> who are registered with <b> {{appName}} </b>","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_2":"- Customers that do <b>not exist</b> in Field Control <b>will be created</b>","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_3":"- Customers <b>existing</b> in Field Control <b>will be updated</b>","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_4":"This may take a few minutes according to the number of customers you have, do not close the window until the process is finished","CUSTOMERS_AUTOMATIC_IMPORT_CANCEL":"Cancel","CUSTOMERS_AUTOMATIC_IMPORT_START":"Start import","AUTOMATIC_IMPORT_ERROR_IN_FINISH":"ERROR: Unable to finish the import process","AUTOMATIC_IMPORT_ERROR_LIMIT":"ERROR: Total records greater than 5000","AUTOMATIC_IMPORT_SUCCESS_TOAST":" Customers imported!","CUSTOMERS_AUTOMATIC_IMPORT_DIALOG_TITLE":"Automatic import of customers from {{ app }}","WAIT_WE_RE_IMPORTING":"Wait, importing customers..","CUSTOMERS_AUTOMATIC_IMPORT_FROM":"from","AUTOMATIC_IMPORT_ERROR_CANT_FIND_CUSTOMERS":"Unable to find registered customers","OMIE":{"CONFIGURATION_TUTORIAL":"To enable integration with <a href=\\"https://www.omie.com.br/\\" target=\\"_blank\\">Omie</a>, we need the information <strong>{{ appKey }}</strong> and <strong>{{ appSecret }}</strong>, to get this information, follow the instructions below:","CONFIGURATION_TUTORIAL_TIPS_1":"Click","CONFIGURATION_TUTORIAL_TIPS_2":"here","CONFIGURATION_TUTORIAL_TIPS_3":"and log in with your Omie account;","CONFIGURATION_TUTORIAL_TIPS_4":"Click the option with the name of your company / application;","CONFIGURATION_TUTORIAL_TIPS_5":"Copy the information from <b>App Key</b> and <b>App Secret</b> and paste it in the fields below;","CONFIGURATION_TUTORIAL_TIPS_6":"Click <b>Enable Integration</b> and you\'re done :)","CONFIGURATION_TUTORIAL_TIPS_7":"It is possible to integrate up to 5 Omie accounts with your Field control account.","CONFIGURATION_TUTORIAL_TIPS_8":"Give it a name to your integration;","FILTERS":{"INFO":"It is now possible to filter clients by <b>\'Corporate Name\'</b> or <b>\'Trade Name\'</b>, but remember that only the first 5 clients found will appear, so be specific.","FILTER_BY":"Filter by","CORPORATE_NAME":"Corporate Name","TRADE_NAME":"Trade Name","SEARCH_BY":"To apply the filter, at least 3 characters are required."}},"CONTA_AZUL":{"ERROR":{"INVALID_FIELD":"The client was not sent because it may have a invalid, null or unknown field","UNAUTHORIZED":"Unauthorized","CUSTOMER_NOT_PROVIDED":"The client was not supplied or provided incorrectly"},"TOTAL_CUSTOMERS":"Customers found: {{totalCustomers}}"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/customers/i18n/es.json',
    '{"CUSTOMERS":{"PAGE_TITLE":"Clientes","TITLE":"Clientes","TUTORIAL_VIDEO":{"TITLE":"Instrucciones","TOOLTIP":"Ver vídeo tutorial"},"TOOLBAR":{"IMPORT_FROM":"Importar clientes de {{app}}","MANUAL_IMPORT":"Importación Manual","AUTOMATIC_IMPORT":"Importación Automática","TABLE_VIEW":"Ver tabla","MAP_VIEW":"Mostrar mapa","PRINT":"Imprimir","EXPORT_TO_EXCEL":"Exportar a Excel","RESTORE_COLUMNS":"Restaurar columnas","SWITCH_COLUMNS":"Cambiar columnas","ADD":"Agregar cliente","NO_PERMISSION":"No tiene permiso para crear clientes","CLEAR_FILTERS":"Limpiar filtros","FILTER_CUSTOMERS":"Filtrar clientes","RELOAD":"Actualizar"},"TABLE":{"LABELS":"Etiquetas","NAME":"Nombre","STATUS":{"ACTIVE":"Activo","ARCHIVED":"Archivado"},"DOCUMENT_NUMBER":"Documento","EMAIL":"Correo electrónico principal","PHONE":"Número de teléfono","ADDRESS":"Direccion completa","OBSERVATIONS":"Observaciones","FIRST_VISIT_IN":"Primera visita el","LAST_VISIT_IN":"Última visita el","TOTAL_VISITS":"Visitas totales","AVERAGE_RATING":"Calificación promedio","NOT_RATED":"No calificado","LAST_REVIEW":"Última calificación","LAST_COMMENT":"Último comentario","CREATED_ON":"Creado el","ACTIONS":"Acciones","CUSTOMER_EDIT_NOT_ALLOWED":"No tiene permiso para editar este cliente","EDIT":"Editar","VIEW":"Ver","SPREADSHEET_SENT":"La hoja de cálculo se enviará a {{email}} en unos minutos.","SPREADSHEET_ERROR":"¡Uy! Algo ha ido mal y no ha sido posible exportar a sus clientes :("},"MAP":{"LOADER":"Cargando mapa del cliente ...","NEW_TASK_BUTTON":"Crear nueva visita","MAX_CUSTOMER_WARNING_TITLE":"Modo de búsqueda de área habilitado","MAX_CUSTOMER_WARNING_MESSAGE":"El número total de clientes registrados en su cuenta excede la capacidad admitida por el mapa de clientes. <br/><br/> Por lo tanto, se ha activado el modo de búsqueda por área. <br/> Para encontrar clientes que no están visibles en su mapa, amplíe el área deseada y use el botón de búsqueda para cargarlos. <br/>","MAX_CUSTOMER_WARNING_IMG_ALT":"imagen del botón de búsqueda por área","ERROR_WARNING_TITLE":"Se ha producido un error","OK":"Ok","ERROR_WARNING_MESSAGE":"Se ha producido un error al intentar obtener la información del mapa. Vuelva a intentarlo más tarde.","IN_BOUNDS_SEARCH_BUTTON":"Buscar en esta área","CREATE_CUSTOMER":"Puede crear un nuevo cliente","CLICKING_HERE":"haciendo clic aquí","LAYERS":{"DEFAULT":"Estándar","SATELLITE":"Satélite","ROADS":"Carreteras","GROUND":"Tierra"},"LATITUDE_LONGITUDE":"Coordenadas: {{ latitude }}, {{ longitude }}"},"EXPORT_MODAL":{"TITLE":"Exportación de clientes","WARNING_BODY":"Recibirá la exportación de clientes en el correo electrónico: <b>{{email}}</b> .","SLOW_PROCESS":"En las horas punta, este procedimiento llevar un tiempo, ¿ok?","EXPORT_TO_EMAIL":"Enviar exportación por correo electrónico","CANCEL":"Cancelar"},"FILTERS":{"TITLE":"Filtrar clientes","CLEAR":"Limpiar","FIRST_VISIT_FILTERS":"Filtros por primera visita","OF":"Desde:","UNTIL":"Hasta:","DATE":{"PLACEHOLDER":"Seleccionar fecha"},"FILTERS_BY_LAST_VISIT":"Filtros por última visita","NAME":{"PLACEHOLDER":"Busque el nombre .."},"PHONE":{"PLACEHOLDER":"Busque el teléfono ..."},"DOCUMENT_NUMBER":{"PLACEHOLDER":"Busque el documento .."},"STREET":{"PLACEHOLDER":"Busque el calle .."},"EMAIL":{"PLACEHOLDER":"Busque el correo electrónico .."},"CITY":{"PLACEHOLDER":"Busque la ciudad .."},"STATE":{"PLACEHOLDER":"Busque el estado .."},"FILTER_BY_OMIE":"Filtrar por cuenta Omie","FILTER_BY_SITUATION":"Filtrar por situación","STATUS":{"ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivado"},"FILTER_BY_RATING_AVERAGE":"Filtrar por promedio de calificación","NOT_RATED":"No calificado","FILTER_BY_LAST_REVIEW":"Filtrar por última calificación","FILTER_BY_LABEL":{"LABEL":"Filtrar por etiquetas","NO_LABEL":"Sin etiqueta"},"RATINGS":{"TERRIBLE":"Terrible","BAD":"Mal","REGULAR":"Regular","GOOD":"Bueno","GREAT":"Genial"},"BY_TERRITORY":{"LABEL":"Filtrar por territorio","SEARCH":"Buscar territorio","SEARCH_LABEL":"Seleccione el territorio"},"BY_SUBTERRITORY":{"LABEL":"Filtrar por subterritorio","SEARCH":"Buscar subterritorio","SEARCH_LABEL":"Seleccione el subterritorio"}},"DIALOGS":{"CONTACTS":{"TITLE":"Seleccionar contactos de clientes","CLOSE":"Cerrar","EMAIL_LINK_REPORT":"¿A qué correo electrónico se enviará el enlace de informe de actividad?","TOGGLE_ALL":"Alternar todo","UNCHECK_ALL":"Deseleccionar todo","CHECK_ALL":"Seleccionar todo","NOT_HAVE_EMAIL":"Este cliente <strong>no tiene</strong> correo electrónico registrado.","SEND":"ENVIAR"},"CUSTOMER":{"LABEL":{"TITLE":"Etiqueta","MANAGE":"Administrar etiquetas","NO_REGISTERED":"No hay etiquetas registradas, solo los administradores pueden registrar etiquetas.","LIMIT_EXCEEDED":"Se ha superado el límite máximo de etiquetas.","UPDATED":"Las etiquetas se actualizaron con éxito.","PLACEHOLDER":"Buscar etiquetas ...","TOGGLE":"Alternar","EDIT":"Actualizar","ADD":"Crear nueva etiqueta","BACK":"Volver","NAME":"Nombre","CREATE_BUTTON":"Crear","EDIT_LABEL":"Editar"},"TITLE_NEW":"Nuevo cliente","TITLE_EDIT":"Editar cliente","CLOSE_DIALOG":"Cerrar","ERROR":{"TITLE":"Cliente sin ubicación principal","MESSAGE":"El cliente no tiene una ubicación principal. Seleccionaremos una por defecto. Por favor, ingrese al cliente y establezca una ubicación como principal.","CONTINUE":"Continuar"},"CONTACTS":{"TITLE":"Contactos"},"GENERAL":{"TITLE":"General","CUSTOMER_INFOS":"Información del cliente","AVATAR_RULES":"Las dimensiones ideales del logotipo son 512 px x 512 px, con un tamaño máximo de 2MB.","NAME":{"LABEL":"Nombre","REQUIRED":"Se requiere el nombre","VALID":"El nombre no debe contener más de 150 caracteres.","WHITE_SPACES":"El nombre no debe estar separado por más de un espacio"},"DOCUMENT":{"LABEL":"Documento","INVALID_CPF":"Número no válido","INVALID_CNPJ":"No válido","EXISTS":"Documento ya existe"},"ADDRESS":{"LABEL":"Dirección del cliente","KM_DISTANCE":"km de distancia","NOT_FOUND":"No pudimos encontrar la dirección, cambie su búsqueda e intente nuevamente.","SEARCH_HINT":"Busque una dirección, ejemplo: Avenida de las Flores, 1 - Ciudad de México","REQUIRED":"Se requiere la dirección del cliente","NUMBER_NOT_SPECIFIED":"El número de la dirección no ha sido especificado.","CLEAR":"Limpiar dirección del cliente","ENTER_THE_CUSTOMERS_ADDRESS":"Ingrese la dirección del cliente en el campo de arriba","COMPLEMENT":{"LABEL":"Dirección complementaria","VALID":"El complementaria no debe contener más de 100 caracteres."}},"ZIPCODE":{"LABEL":"Código postal","REQUIRED":"Se requiere el código postal","PATTERN":"Código postal inválido"},"CITY":{"LABEL":"Ciudad","REQUIRED":"Se requiere la ciudad"},"STATE":{"LABEL":"Estado","REQUIRED":"Se requiere el estado"},"NEIGHBORHOOD":{"LABEL":"Barrio","REQUIRED":"Se requiere el barrio"},"STREET":{"LABEL":"Calle","REQUIRED":"Se requiere la calle"},"NUMBER":{"LABEL":"Número","REQUIRED":"Se requiere el número"},"COMPLEMENT":{"LABEL":"Dirección complementaria"},"LATITUDE_LONGITUDE":"latitud: {{latitude}}, longitud {{longitude}}","EMAIL":{"LABEL":"Correo electrónico","PATTERN":"Formato de correo electrónico no válido","MAIN":"Correo electrónico principal"},"EMAIL_TYPE":{"LABEL":"Tipo","PERSONAL":"Personal","WORK":"Profesional"},"REMOVE_EMAIL":"Eliminar correo electrónico","ADD_EMAIL":"Agregar un correo electrónico más","PHONE":{"LABEL":"Número","INVALID":"Teléfono inválido","MAIN":"Teléfono principal"},"PHONE_TYPE":{"LABEL":"Tipo","CELL":"Celular","HOME":"Casa","WORK":"Trabajo"},"REMOVE_PHONE":"Remover teléfono","ADD_PHONE":"Agregar un teléfono más","NOTES":{"LABEL":"Notas del cliente"},"GEOLOCATION_NOT_VERIFIED":"Geolocalización (latitud / longitud) no verificada"},"LOCATIONS":{"LABEL":"Ubicaciones","LABEL_CREATE":"Ubicación","NEW_CUSTOMER_ALERT":"Esta será la ubicación principal de este cliente.","LATITUDE_LONGITUDE":"Latitud: {{latitud}} - Longitud: {{longitud}}","CUSTOMER_LOCATION":"Ubicación del cliente","COMPLEMENT":"Complemento de dirección","NAME":"Nombre de la ubicación","SAVE_LOCATION":"Guardar ubicación","BACK":"Volver","PRIMARY_LOCATION":"Ubicación primaria","LINKED_LOCATIONS":"Ubicaciones vinculadas","ACTIONS":"Aciones","DUPLICATED_LOCATION_NAME":"Ubicación con nombre duplicado","CREATE_LOCATION":"Ubicación de registro","EDIT_LOCATION":"Editar ubicación","ARCHIVE_LOCATION":"Archivar ubicación","LOCATION_LOCKED":"No se puede editar una ubicación bloqueada","SELECT_PRIMARY_LOCATION":"Select ubicación primaria","NEXT":"Siguiente","PREVIOUS":"Anterior","UPDATE_COORDINATES":"Actualizar coordenadas","UPDATE_COORDINATES_DISABLED":"Para actualizar las coordenadas, agregue una dirección.","NAVIGATION_PHRASE":"Mostrando de {{quantityStart}} a {{quantityEnd}} de {{maxQuantity}} ubicaciones","ARCHIVED":"Archivada","ALERTS":{"REMOVE_LOCATION":"¿Está seguro de que desea <b> eliminar </b> esta ubicación <br> <b> {{locationName}} </b>?"},"FILTERS":{"CLEAR":"Borrar filtro por dirección","FORMATTED_ADDRESS":"Filtrar por dirección","FORMATTED_ADDRESS_HINT":"Para <b> filtrar </b> una ubicación, ingrese la dirección.","NAME":"Busca por nombre","NAME_HINT":"<b>Busca</b> ubicaciones por nombre.","NOT_FOUND":"No se encontró ninguna dirección.","CREATE_LOCATION":"Registra la dirección en tus ubicaciones."},"TOASTS":{"LOCATION_SAVED":"¡La ubicación \'{{locationName}}\' se registró correctamente!","LOCATION_ARCHIVED":"¡La ubicación \'{{locationName}}\' se archivó correctamente!","SAVE_ERROR":"Se produjo un error al guardar la ubicación. ¡Comuníquese con el servicio de asistencia!"},"ADDRESS":{"ADD":"Agregar ubicación","LOCATION_ADDRESS":"Dirección de la ubicación","SEARCH":"Buscar por dirección","SEARCH_HINT":"Para agregar una nueva ubicación, busque una dirección y haga clic en Agregar ubicación","NOT_FOUND":"No se encontró la dirección, cambie su búsqueda y vuelva a intentarlo","NUMBER_NOT_SPECIFIED":"El número de dirección no está especificado","PRIMARY_ADDRESS":"Dirección principal","NAME_REQUIRED":"El nombre es obligatorio","DUPLICATED_NAME":"Otra dirección ya tiene este nombre.","ADDRESS_REQUIRED":"La dirección es obligatoria"},"LAYERS":{"DEFAULT":"Estándar","SATELLITE":"Satélite","ROADS":"Carreteras","GROUND":"Terreno"}},"ATTACHMENTS":{"LABEL":"Archivos adjuntos","HINT_MESSAGE":"Haga clic o arrastre sus archivos para cargar","MAX_SIZE":"El tamaño máximo de cada archivo es de 10MB.","NOT_SUPPORTED_FILE_DRAG":"El archivo no es compatible con su navegador","OF":"de","IMG":"imágenes adjuntas permitidas","SEND":"ENVIAR","ATTACHMENT_WARNING":"Límite de 20 archivos adjuntos por Panel de Administrador. 10MB de tamaño máximo por archivo","DROP_HERE":"Arrastre sus archivos para cargar","INSERT_FILES_ALTERNATIVE":"Arrastre sus archivos para cargarlos o","ATTACHMENTS_LIMIT_REACHED":"Se alcanzó el límite de archivos adjuntos, para agregar más archivos adjuntos primero debe eliminar algunos.","INSERT_FILES":"Arrastra tus archivos para subirlos o","SEND_FILES":"Enviar archivos","ATTACHMENT_DESCRIPTION":"Límite de 20 archivos adjuntos. Tamaño máximo de 10MB por archivo adjunto.","NO_ATTACHMENTS_ADDED":"No se han agregado archivos adjuntos para ese cliente.","SAVE_TITLE":"Guardar nombre","CANCEL":"Cancelar","EDIT_NAME":"Renomear","UNTITLED":"Sin nombre","ADDED_BY":"Agregado por","ADDED_AT":"añadido en","IN":"en","AT":"a las","VIEW_FILE":"Ver archivo","REMOVE":"Eliminar archivo adjunto","REMOVE_CONFIRMATION":"¿Está seguro que desea <strong>eliminar</strong> el archivo adjunto?","YES":"Sí","NO":"No","LINK":"Enlace","SEND_SUCCESS":"Archivos cargados con éxito.","SEND_FAIL":"No se ha podido añadir el archivo: {{file_name}}","SAVE_TITLE_SUCCESS":"El nombre del archivo adjunto se ha cambiado con éxito.","SHARE_ATTACHMENTS_WITH_CLIENT":{"TOOLTIP_ON":"Compartir con el cliente","TOOLTIP_OFF":"Dejar de compartir con el cliente","CONFIRMATION_DIALOG":{"TITLE":"Compartir archivo adjunto con el cliente","DESCRIPTION":"Este archivo adjunto estará disponible en el área del cliente {{ customerName }}. ¿Estás seguro?","NOT_SHOW_AGAIN":"No mostrar este mensaje nuevamente.","YES":"Sí","NO":"No"},"TOASTS":{"IS_SHARING":"Archivo compartido exitosamente.","IS_NOT_SHARING":"El archivo ya no está compartido.","ERROR":"No se pudo compartir el archivo."}}},"SERVICES":{"TITLE":"Servicio al cliente","NO_HISTORY":"Este cliente no tiene registro de servicio.","GO_TO_TASKS_LIST":"Ir a la lista de actividades"},"TEMPLATE":{"TITLE":"Modelos","INFO":"Los modelos son estilos personalizados para informes de órdenes de servicio. Si es necesario, vincule un modelo específico a este tipo de OS, y se aplicará automáticamente siempre que esté relacionado.","LINK":"Vincular modelo","EMPTY_STATE":"Ningún modelo vinculado a este cliente","REMOVE":"Eliminar modelo","EDIT":"Cambiar modelo","ACTIVE":"Activo","INACTIVE":"Inactivo","ARCHIVED":"Archivado","TYPE":{"ORDER":"Modelo de informe de orden de servicio"},"SELECT":{"TITLE":"Vincular Modelo","SEARCH":"Buscar por nombre del modelo...","CANCEL":"Cancelar","SUCCESS":"Vincular","EMPTY":"No se encontraron modelos"}},"SAVE":"Guardar","CREATE":"Crear","CONTINUE":"Continuar","SEND_TO":"Enviar para","CANT_SEND_WITHOUT_DOCUMENT":"No se pueden enviar clientes sin documento","ARCHIVE":"Archivo","UNARCHIVE":"Desarchivar","SAVED_CUSTOMER":"El cliente \'{{name}}\' se ha guardado correctamente."},"BRAND":{"TITLE":"Logo","SELECT_OR_DRAG_IMAGE":"Haga clic o arrastre su imagen para subir","CROP_IMAGE":"Para recortar esta imagen, arrastre la región a continuación y haga clic en el botón:"},"ALERTS":{"CUSTOMER_DESCRIPTION":{"TITLE":"¡OPS! parece que algo no ha funcionado.","MESSAGE":"No es posible concluir esta acción ya que la plataforma de Cuenta Azul no acepta clientes que tiene más de 255 caracteres registrados en las observaciones del cliente."}}},"SERVICES":{"SCHEDULED_ACTIVITY":"Actividad programada, en espera de ejecución.","ACTIVITY_IN_PROGRESS":"Actividad en progreso, comenzada en:","ACTIVITY_CANCELED":"Actividad cancelada","OPENING_HOURS":"Horario de atención:","UNTIL":"hasta","TOTAL_DURATION_OF":"con una duración total de","MINUTES":"minutos"},"INTEGRATIONS":{"ENABLE_INTEGRATION":"Habilitar integración","ARCHIVED":"archivado","EXPORT_TITLE":"Exportación de cliente","EXPORT_INSTRUCTIONS":"El cliente será exportado a {{ app }} con la siguiente información:","EXPORT":"Exportar","CUSTOMER_IS_ARCHIVED":"Este cliente está archivado en Field","IMPORTS":{"ACCOUNT":"Cuenta Omie","FROM":"Cliente importado de la conta Omie <b>{{account}}</b>","SELECT_THE_ACCOUNT":"Seleccione la cuenta Omie a la que desea exportar el cliente <b>{{customerName}}</b>","SELECT_THE_ACCOUNT_MANUAL":"Seleccione la cuenta Omie a la que desea importar los clientes manualmente.","ARE_YOU_SURE":"¿Está seguro de que desea continuar con la exportación?","TITLE":"Importar clientes de {{app}}","FOUND_CUSTOMERS":"Clientes encontrados","MANUAL":"Importación Manual","AUTOMATIC":"Importación Automática","CONTENT":"Este proceso importará todos los clientes que están registrados en la cuenta de la Omie seleccionada.<br><br>&#8226; Se crearán los clientes que no existen en Field Control;<br>&#8226; Se actualizarán los clientes que ya existen en Field Control.<br><br >El proceso puede tardar unos instantes dependiendo de la cantidad de clientes. No cierre la ventana hasta que el proceso haya terminado.","IMPORT_LOADING_TITLE":"Importación de clientes de Omie","WAIT_LOADING":"Por favor espere, estamos importando los clientes...","CLOSE":"Fechar","IMPORT_BUTTON":"Importar","UPDATE_SUCCESS":"Actualizado con éxito","UPDATE_ERROR":"Hubo un error con esta importación.","UPDATE_ERROR_CREATE":"Cliente no encontrado en Field, entonces fue creado.","CREATE_ERROR":"Error al importar cliente.","SUCCESS_AUTOMATIC":"¡clientes importados con éxito!","SUCCESS_MANUAL":"Importado con éxito!","SEARCH_BY_NAME":"Ingrese al menos 3 caracteres para buscar los clientes que desea importar a Field Control.","LOADING_ERROR":"Hubo un error al cargar los clientes de Omie."},"UPDATE":"Actualizar","IMPORT":"Importar","CONTINUE":"Continuar","CANCEL":"Cancelar","CONFIRM":"Confirmar","CONFIRM_CREATE":"Confirmación de la creación del cliente.","CONFIRM_UPDATE":"Confirmación de actualización del cliente","UPDATE_OR_CREATE_NEW_CUSTOMER":"Cambiar un cliente existente o crear uno nuevo:","NEW_CUSTOMER":"Nuevo cliente","CREATED_SUCCESSFULLY":"Cliente {{customer}} creado con éxito en {{appName}}","UPDATED_SUCCESSFULLY":"El cliente {{customer}} se ha actualizado correctamente en {{appName}}","CANT_CREATE_DOCUMENT_ALREADY_EXISTS":"No fue posible crear el cliente en Conta Azul, aparentemente ya hay un cliente con el mismo documento: {{document}}","CANT_UPDATE_DOCUMENT_ALREADY_EXISTS":"No fue posible actualizar al cliente en Conta Azul, aparentemente ya hay un cliente con el mismo documento: {{document}}","ERROR_SENDING_CUSTOMER":"Error al enviar cliente","INVALID_ZIPCODE_CONFIRM_TITLE":"Código postal inválido","INVALID_ZIPCODE_CONFIRM_MESSAGE":"El código postal es inválido. Si continúa, se enviará en blanco a Omie y deberá completarlo manualmente.","NAME":"Nombre","DOCUMENT":"Documento","ADDRESS":"Dirección","PHONE":"Número de teléfono","NOTES":"Notas","EMAIL":"Correo electrónico","FIND_CUSTOMER_TO_IMPORT":"Use el campo de arriba para encontrar los clientes que desea importar a Field Control","CANT_FIND_ANY_CUSTOMER_WITH":"No se pudo encontrar ningún cliente con:","WILL_BE_CREATED_WITH_DATA":"El cliente se creará en {{app}} con los siguientes datos:","WILL_BE_UPDATED_WITH_DATA":"El cliente se actualizará en {{app}} con los siguientes datos:","SENDING_CUSTOMER":"Enviando cliente a {{app}}","FIND_CUSTOMERS_DESCRIPTION":"A partir de los datos de <b>nombre</b> o <b>documento,</b> identificamos los posibles clientes que ya están registrados en {{app}}","CREATE_NEW_CUSTOMER":"Crear un nuevo cliente en {{app}}","IMPORT_CUSTOMERS_FROM":"Importar {{app}} clientes","CANT_CONNECT":"No pudimos conectarnos con {{app}}, verifique su configuración de integración e intente nuevamente.","CANT_PROCEED_WITH_NO_ADDRESS":"No se puede {{action}} un cliente sin dirección","ERROR_WHEN_ACTIVATING":"Error al habilitar la integración con {{app}}","SUCCESS_WHEN_ACTIVATING":"¡Integración de {{app}} habilitada con éxito!","CONFIGURATION_TITLE":"Integración de {{App}}","ACTIVATE_INTEGRATION":"Habilitar integración","SUCCESS_WHEN_DISABLING":"¡La integración con {{app}} se ha deshabilitado correctamente!","ERROR_WHEN_DISABLING":"Error al deshabilitar la integración con {{app}}","CUSTOMERS_AUTOMATIC_IMPORT":"Importación automática de clientes","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_1":"Este proceso importará a todos los <b> {{totalCustomerToImport}} clientes </b> que están registrados con <b> {{appName}} </b>","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_2":"- <b>Se crearán</b> clientes que <b>no existen</b> en Field Control","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_3":"- Los <b>clientes existentes</b> de Field Control <b>serán actualizados</b>","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_4":"El proceso puede demorar unos minutos de acuerdo con la cantidad de clientes que tenga. No cierre la ventana hasta que el proceso haya finalizado.","CUSTOMERS_AUTOMATIC_IMPORT_CANCEL":"Cancelar","CUSTOMERS_AUTOMATIC_IMPORT_START":"Iniciar importación","AUTOMATIC_IMPORT_ERROR_IN_FINISH":"ERROR: no ha sido posible finalizar el proceso de importación del cliente","AUTOMATIC_IMPORT_ERROR_LIMIT":"ERROR: Registros totales superiores a 5000","AUTOMATIC_IMPORT_SUCCESS_TOAST":" clientes importados con éxito!","CUSTOMERS_AUTOMATIC_IMPORT_DIALOG_TITLE":"Importación automática de clientes de {{ app }}","WAIT_WE_RE_IMPORTING":"Espere, estamos importando los clientes..","CUSTOMERS_AUTOMATIC_IMPORT_FROM":"de","AUTOMATIC_IMPORT_ERROR_CANT_FIND_CUSTOMERS":"No se han encontrado clientes registrados","OMIE":{"CONFIGURATION_TUTORIAL":"Para permitir la integración con <a href=\\"https://www.omie.com.br/\\" target=\\"_blank\\">Omie</a>, necesitamos las informaciones <strong>{{ appKey }}</strong> y <strong>{{ appSecret }}</strong>, para obtener esta información siga las instrucciones a continuación:","CONFIGURATION_TUTORIAL_TIPS_1":"Haga clic","CONFIGURATION_TUTORIAL_TIPS_2":"aquí","CONFIGURATION_TUTORIAL_TIPS_3":"e inicie sesión con su cuenta Omie;","CONFIGURATION_TUTORIAL_TIPS_4":"Haga clic en la opción con el nombre de su empresa / aplicación;","CONFIGURATION_TUTORIAL_TIPS_5":"Copie la información de <b>App Key</b> y <b>App Secret</b> y péguela en los campos a continuación;","CONFIGURATION_TUTORIAL_TIPS_6":"Haga clic en <b>Habilitar integración</b> y listo :)","CONFIGURATION_TUTORIAL_TIPS_7":"Es posible integrar hasta 5 cuentas de Omie con tu cuenta de Field Control.","CONFIGURATION_TUTORIAL_TIPS_8":"De um nombre a tua integración;","FILTERS":{"INFO":"Ahora es posible filtrar los clientes por <b>\'Razón Social\'</b> o <b>\'Nombre Comercial\'</b>, pero recuerda que al filtrar solo aparecerán los primeros 5 clientes encontrados, así que sé específico.","FILTER_BY":"Filtrar por","CORPORATE_NAME":"Razón Social","TRADE_NAME":"Nombre Comercial","SEARCH_BY":"Para aplicar el filtro se requieren al menos 3 caracteres."}},"CONTA_AZUL":{"ERROR":{"INVALID_FIELD":"El cliente no se envió, ya que puede tener un campo inválido, nulo o desconocido","UNAUTHORIZED":"No autorizado","CUSTOMER_NOT_PROVIDED":"El cliente no fue suministrado o proporcionado incorrectamente"},"TOTAL_CUSTOMERS":"Clientes encontrados: {{ totalCustomers }}"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/customers/i18n/pt.json',
    '{"CUSTOMERS":{"PAGE_TITLE":"Clientes","TITLE":"Clientes","TUTORIAL_VIDEO":{"TITLE":"Instruções","TOOLTIP":"Assistir vídeo explicativo"},"TOOLBAR":{"IMPORT_FROM":"Importar clientes do {{ app }}","MANUAL_IMPORT":"Importação Manual","AUTOMATIC_IMPORT":"Importação em Massa","TABLE_VIEW":"Visualizar tabela","MAP_VIEW":"Visualizar mapa","PRINT":"Imprimir","EXPORT_TO_EXCEL":"Exportar em Excel","RESTORE_COLUMNS":"Restaurar colunas","SWITCH_COLUMNS":"Alternar colunas","ADD":"Adicionar cliente","NO_PERMISSION":"Você não tem permissão para criar clientes","CLEAR_FILTERS":"Limpar filtros","FILTER_CUSTOMERS":"Filtrar clientes","RELOAD":"Atualizar"},"TABLE":{"LABELS":"Etiquetas","NAME":"Nome","STATUS":{"ACTIVE":"Ativo","ARCHIVED":"Arquivado"},"DOCUMENT_NUMBER":"CPF/CNPJ","EMAIL":"E-mail principal","PHONE":"Telefone","ADDRESS":"Endereço completo","OBSERVATIONS":"Observações","FIRST_VISIT_IN":"Primeira visita em","LAST_VISIT_IN":"Última visita em","TOTAL_VISITS":"Total de visitas","AVERAGE_RATING":"Média de avaliação","NOT_RATED":"Não avaliado","LAST_REVIEW":"Última avaliação","LAST_COMMENT":"Último comentário","CREATED_ON":"Criado em","ACTIONS":"Ações","CUSTOMER_EDIT_NOT_ALLOWED":"Você não tem permissão para editar esse cliente","EDIT":"Editar","VIEW":"Visualizar","SPREADSHEET_SENT":"A planilha será enviada para o e-mail {{email}} em alguns minutos","SPREADSHEET_ERROR":"Ooooooooooops, algo errado aconteceu e não foi possível exportar seus clientes :("},"MAP":{"LOADER":"Carregando mapa de clientes...","NEW_TASK_BUTTON":"Criar nova visita","MAX_CUSTOMER_WARNING_TITLE":"Modo de pesquisa por área ativado","MAX_CUSTOMER_WARNING_MESSAGE":"O número total de clientes cadastrados na sua conta excede a capacidade suportada pelo mapa de clientes.<br/><br/>Por isso, o modo de pesquisa por área foi ativado.<br/>Para encontrar clientes que não estão visíveis no seu mapa, dê zoom na área desejada e use o botão de pesquisa para carregá-los.<br/>","MAX_CUSTOMER_WARNING_IMG_ALT":"imagem do botão de pesquisa por área","ERROR_WARNING_TITLE":"Houve um erro","OK":"OK","ERROR_WARNING_MESSAGE":"Houve um erro ao tentar buscar as informações para o mapa, tente novamente mais tarde","IN_BOUNDS_SEARCH_BUTTON":"Pesquisar nesta área","CREATE_CUSTOMER":"Você pode criar um novo cliente ","CLICKING_HERE":"clicando aqui","LAYERS":{"DEFAULT":"Padrão","SATELLITE":"Satélite","ROADS":"Estradas","GROUND":"Terreno"},"LATITUDE_LONGITUDE":"Coordenadas: {{ latitude }}, {{ longitude }}"},"EXPORT_MODAL":{"TITLE":"Exportação de clientes","WARNING_BODY":"Você receberá a exportação de clientes no e-mail: <b> {{ email }}</b>.","SLOW_PROCESS":"Em horários de pico esse procedimento pode demorar um pouquinho, combinado?","EXPORT_TO_EMAIL":"Enviar exportação por e-mail","CANCEL":"Cancelar"},"FILTERS":{"TITLE":"Filtrar clientes","CLEAR":"Limpar","FIRST_VISIT_FILTERS":"Filtros por primeira visita","OF":"De:","UNTIL":"Até:","DATE":{"PLACEHOLDER":"Selecionar data"},"FILTERS_BY_LAST_VISIT":"Filtros por última visita","NAME":{"PLACEHOLDER":"Pesquise o nome.."},"PHONE":{"PLACEHOLDER":"Pesquise o telefone.."},"DOCUMENT_NUMBER":{"PLACEHOLDER":"Pesquise pelo CPF/CNPJ.."},"STREET":{"PLACEHOLDER":"Pesquise a rua.."},"EMAIL":{"PLACEHOLDER":"Pesquise o e-mail.."},"CITY":{"PLACEHOLDER":"Pesquise a cidade.."},"STATE":{"PLACEHOLDER":"Pesquise o estado.."},"FILTER_BY_OMIE":"Filtrar por conta Omie","FILTER_BY_SITUATION":"Filtrar por situação","STATUS":{"ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"},"FILTER_BY_RATING_AVERAGE":"Filtrar por média de avaliação","NOT_RATED":"Não avaliado","FILTER_BY_LAST_REVIEW":"Filtrar por última avaliação","FILTER_BY_LABEL":{"LABEL":"Filtrar por etiquetas","NO_LABEL":"Sem etiqueta"},"RATINGS":{"TERRIBLE":"Péssimo","BAD":"Ruim","REGULAR":"Regular","GOOD":"Bom","GREAT":"Ótimo"},"BY_TERRITORY":{"LABEL":"Filtrar por território","SEARCH":"Pesquisar território","SEARCH_LABEL":"Selecione o território"},"BY_SUBTERRITORY":{"LABEL":"Filtrar por subterritório","SEARCH":"Pesquisar subterritório","SEARCH_LABEL":"Selecione o subterritório"}},"DIALOGS":{"CONTACTS":{"TITLE":"Selecione os contatos do cliente","CLOSE":"Fechar","EMAIL_LINK_REPORT":"Para qual e-mail enviar o link do relatório da atividade?","TOGGLE_ALL":"Alternar todos","UNCHECK_ALL":"Deselecionar todos","CHECK_ALL":"Selecionar todos","NOT_HAVE_EMAIL":"Este cliente <strong>não possui</strong> e-mail cadastrado.","SEND":"Enviar"},"CUSTOMER":{"LABEL":{"TITLE":"Etiqueta","MANAGE":"Gerenciar etiquetas","NO_REGISTERED":"Nenhuma etiqueta cadastrada, apenas administradores podem cadastrar etiquetas.","UPDATED":"Etiquetas atualizadas com sucesso.","LIMIT_EXCEEDED":"Limite máximo de etiquetas foi excedido.","PLACEHOLDER":"Pesquisar etiquetas...","TOGGLE":"Alternar","EDIT":"Atualizar","ADD":"Criar nova etiqueta","BACK":"Voltar","NAME":"Nome","CREATE_BUTTON":"Criar","EDIT_LABEL":"Editar"},"TITLE_NEW":"Novo cliente","TITLE_EDIT":"Editar cliente","CLOSE_DIALOG":"Fechar","ERROR":{"TITLE":"Cliente sem localização principal","MESSAGE":"O cliente não possui uma localização principal, vamos selecionar uma por padrão, por favor entre no cliente e selecione uma localização como principal.","CONTINUE":"Continuar"},"CONTACTS":{"TITLE":"Contatos"},"GENERAL":{"TITLE":"Geral","CUSTOMER_INFOS":"Dados do cliente","AVATAR_RULES":"As dimensões ideais do logotipo são 512px x 512px, com tamanho máximo de 2MB.","NAME":{"LABEL":"Nome","REQUIRED":"Nome é obrigatório","VALID":"Nome não deve conter mais de 150 caracteres","WHITE_SPACES":"O nome não deve ser separado por mais de um espaço"},"DOCUMENT":{"LABEL":"CPF/CNPJ","INVALID_CPF":"CPF inválido","INVALID_CNPJ":"CNPJ inválido","EXISTS":"Documento já existe"},"ADDRESS":{"LABEL":"Endereço principal do cliente","KM_DISTANCE":"km de distância","NOT_FOUND":"Não foi possível encontrar o endereço, altere sua busca e tente novamente.","SEARCH_HINT":"Procure por um endereço, exemplo: Rua dos Pinheiros, 383 - São Paulo","REQUIRED":"Endereço principal do cliente é obrigatório","NUMBER_NOT_SPECIFIED":"O número do endereço não foi especificado.","CLEAR":"Limpar Endereço principal do cliente","ENTER_THE_CUSTOMERS_ADDRESS":"Informe o endereço principal do cliente no campo acima","COMPLEMENT":{"LABEL":"Complemento do endereço","VALID":"Complemento não deve conter mais de 100 caracteres"}},"ZIPCODE":{"LABEL":"CEP","REQUIRED":"CEP é obrigatório","PATTERN":"CEP inválido"},"CITY":{"LABEL":"Cidade","REQUIRED":"Cidade é obrigatório"},"STATE":{"LABEL":"Estado","REQUIRED":"Estado é obrigatório"},"NEIGHBORHOOD":{"LABEL":"Bairro","REQUIRED":"Bairro é obrigatório"},"STREET":{"LABEL":"Logradouro","REQUIRED":"Logradouro é obrigatório"},"NUMBER":{"LABEL":"Número","REQUIRED":"Número é obrigatório"},"COMPLEMENT":{"LABEL":"Complemento"},"LATITUDE_LONGITUDE":"latitude: {{latitude}} , longitude {{longitude}}","EMAIL":{"LABEL":"E-mail","PATTERN":"E-mail em formato inválido","MAIN":"E-mail principal"},"EMAIL_TYPE":{"LABEL":"Tipo","PERSONAL":"Pessoal","WORK":"Trabalho"},"REMOVE_EMAIL":"Remover e-mail","ADD_EMAIL":"Adicionar mais um e-mail","PHONE":{"LABEL":"Número","INVALID":"Telefone inválido","MAIN":"Telefone principal"},"PHONE_TYPE":{"LABEL":"Tipo","CELL":"Celular","HOME":"Casa","WORK":"Trabalho"},"REMOVE_PHONE":"Remover telefone","ADD_PHONE":"Adicionar mais um telefone","NOTES":{"LABEL":"Observações do cliente"},"GEOLOCATION_NOT_VERIFIED":"Geolocalização (latitude/longitude) não verificada"},"LOCATIONS":{"LABEL":"Localizações","LABEL_CREATE":"Localização","NEW_CUSTOMER_ALERT":"Esta será a localização principal deste cliente.","LATITUDE_LONGITUDE":"Latitude: {{latitude}} - Longitude: {{longitude}}","CUSTOMER_LOCATION":"Localização do cliente","COMPLEMENT":"Complemento do endereço","NAME":"Nome da localização","SAVE_LOCATION":"Salvar localização","CREATE_LOCATION":"Nova localização","LOCATION_LOCKED":"Não é possível editar uma localização bloqueada","PRIMARY_LOCATION":"Localização principal","LINKED_LOCATIONS":"Localizações vinculadas","ACTIONS":"Ações","DUPLICATED_LOCATION_NAME":"Localização com nome duplicado","SELECT_PRIMARY_LOCATION":"Selecionar essa localização para a ser a principal.","EDIT_LOCATION":"Editar localização","ARCHIVE_LOCATION":"Arquivar localização","NEXT":"Próximo","PREVIOUS":"Anterior","UPDATE_COORDINATES":"Atualizar coordenadas","UPDATE_COORDINATES_DISABLED":"Para atualizar as coordenadas adicione um endereço.","NAVIGATION_PHRASE":"Mostrando de {{quantityStart}} até {{quantityEnd}} de {{maxQuantity}} localizações","BACK":"Voltar","ARCHIVED":"Arquivada","ALERTS":{"REMOVE_LOCATION":"Tem certeza de que deseja <b>excluir</b> esta localização <br><b>{{ locationName }}</b>?"},"FILTERS":{"CLEAR":"Limpar filtros","FORMATTED_ADDRESS":"Filtrar por endereço","FORMATTED_ADDRESS_HINT":"Para <b>filtrar</b> uma localização, digite o endereço.","NAME":"Buscar por nome","NAME_HINT":"<b>Buscar</b> as localizações pelo nome.","NOT_FOUND":"Não foi encontrado nenhum endereço.","CREATE_LOCATION":"Cadastre o endereço a suas localizações."},"TOASTS":{"LOCATION_SAVED":"Localização \'{{ locationName }}\' cadastrada com sucesso!","LOCATION_ARCHIVED":"Localização \'{{ locationName }}\' arquivada com sucesso!","SAVE_ERROR":"Ocorreu um erro ao salvar a localização. Entre em contato com o suporte!"},"ADDRESS":{"ADD":"Adicionar localização","LOCATION_ADDRESS":"Endereço da localização","SEARCH":"Procurar por endereço","SEARCH_HINT":"Para adicionar uma nova localização, procure por um endereço e clique em Adicionar Localização","NOT_FOUND":"O endereço não foi encontrado, mude sua pesquisa e tente novamente","NUMBER_NOT_SPECIFIED":"O número do endereço não foi especificado","PRIMARY_ADDRESS":"Endereço principal","NAME_REQUIRED":"Nome é obrigatório","DUPLICATED_NAME":"Outro endereço já possui esse nome","ADDRESS_REQUIRED":"Endereço é obrigatório"},"LAYERS":{"DEFAULT":"Padrão","SATELLITE":"Satélite","ROADS":"Estradas","GROUND":"Terreno"}},"ATTACHMENTS":{"LABEL":"Anexos","HINT_MESSAGE":"Clique ou arraste seus arquivos para fazer upload","MAX_SIZE":"Tamanho máximo de cada arquivo é de 10MB","NOT_SUPPORTED_FILE_DRAG":"O arquivo não é suportado pelo seu navegador","OF":"de","IMG":"imagens anexas permitidas","SEND":"Enviar","ATTACHMENT_WARNING":"Limite de 20 anexos pelo Painel do gestor. Tamanho máximo de 10MB por arquivo","DROP_HERE":"Arraste seus arquivos para fazer upload","INSERT_FILES_ALTERNATIVE":"Arraste seus arquivos para fazer upload ou","ATTACHMENTS_LIMIT_REACHED":"Limite de anexos foi atingido, para adicionar mais anexos você precisa remover alguns primeiro.","INSERT_FILES":"Inserir arquivos","SEND_FILES":"Enviar arquivos","ATTACHMENT_DESCRIPTION":"Limite de 20 anexos. Tamanho máximo de 10MB por anexo.","NO_ATTACHMENTS_ADDED":"Nenhum anexo foi adicionado para esse cliente.","SAVE_TITLE":"Salvar título","CANCEL":"Cancelar","EDIT_NAME":"Renomear","UNTITLED":"Sem título","ADDED_AT":"Adicionado em","ADDED_BY":"Adicionado por","IN":"em","AT":"às","VIEW_FILE":"Visualizar arquivo","REMOVE":"Remover anexo","REMOVE_CONFIRMATION":"Tem certeza que deseja <strong>excluir</strong> o anexo?","YES":"Sim","NO":"Não","LINK":"Link","SEND_SUCCESS":"Arquivos enviados com sucesso.","SEND_FAIL":"Não foi possível anexar o arquivo: {{file_name}}","SAVE_TITLE_SUCCESS":"Título do anexo alterado com sucesso.","SHARE_ATTACHMENTS_WITH_CLIENT":{"TOOLTIP_ON":"Compartilhar com o cliente","TOOLTIP_OFF":"Parar de compartilhar com o cliente","CONFIRMATION_DIALOG":{"TITLE":"Compartilhar anexo com cliente","DESCRIPTION":"Este anexo ficará disponível na área do cliente {{ customerName }}. Tem certeza?","NOT_SHOW_AGAIN":"Não mostrar essa mensagem novamente.","YES":"Sim","NO":"Não"},"TOASTS":{"IS_SHARING":"Anexo compartilhado com sucesso.","IS_NOT_SHARING":"O anexo deixou de ser compartilhado.","ERROR":"Algo deu errado ao compartilhar o anexo. Tente novamente mais tarde."}}},"SERVICES":{"TITLE":"Atendimento","NO_HISTORY":"Esse cliente não possui histórico de atendimento.","GO_TO_TASKS_LIST":"Ir para listagem de atividades"},"TEMPLATE":{"TITLE":"Modelos","INFO":"Modelos são estilos personalizados para relatórios de OS. Caso necessário, vincule um modelo específico a este tipo de OS, que será automaticamente aplicado sempre que ele estiver relacionado.","LINK":"Vincular modelo","EMPTY_STATE":"Nenhum modelo vinculado a este cliente","REMOVE":"Remover modelo","EDIT":"Trocar modelo","ACTIVE":"Ativo","INACTIVE":"Inativo","ARCHIVED":"Arquivado","TYPE":{"ORDER":"Modelo de relatório de OS"},"SELECT":{"TITLE":"Vincular Modelo","SEARCH":"Busque pelo nome do modelo...","CANCEL":"Cancelar","SUCCESS":"Vincular","EMPTY":"Nenhum modelo encontrado"}},"SAVE":"Salvar","CREATE":"Criar","CONTINUE":"Continuar","SEND_TO":"Enviar para","CANT_SEND_WITHOUT_DOCUMENT":"Não pode enviar clientes sem CPF/CNPJ","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar","SAVED_CUSTOMER":"Cliente \'{{name}}\' salvo com sucesso."},"BRAND":{"TITLE":"Logo","SELECT_OR_DRAG_IMAGE":"Clique ou arraste sua imagem para fazer upload","CROP_IMAGE":"Para cortar essa imagem, arraste a região abaixo e clique no botão:"},"ALERTS":{"CUSTOMER_DESCRIPTION":{"TITLE":"Ops! parece que algo não deu certo.","MESSAGE":"Não é possível concluir esta ação, pois a plataforma Conta Azul não aceita clientes que possuam mais de 255 caracteres cadastrados nas observações do cliente."}}},"SERVICES":{"SCHEDULED_ACTIVITY":"Atividade agendada, aguardando execução.","ACTIVITY_IN_PROGRESS":"Atividade em andamento, iniciada em:","ACTIVITY_CANCELED":"Atividade cancelada","OPENING_HOURS":"Horário de atendimento:","UNTIL":"até","TOTAL_DURATION_OF":"com duração total de","MINUTES":"minutos."},"INTEGRATIONS":{"ENABLE_INTEGRATION":"Habilitar integração","ARCHIVED":"arquivado","EXPORT_TITLE":"Exportação de cliente","EXPORT_INSTRUCTIONS":"O cliente será exportado para o {{ app }} com as seguintes informações:","EXPORT":"Exportar","CUSTOMER_IS_ARCHIVED":"Esse cliente está arquivado no Field","IMPORTS":{"ACCOUNT":"Conta Omie","FROM":"Cliente importado da conta Omie <b>{{account}}</b>","SELECT_THE_ACCOUNT":"Selecione a conta Omie que deseja exportar o cliente <b>{{customerName}}</b>","SELECT_THE_ACCOUNT_MANUAL":"Selecione a conta Omie que deseja importar os clientes manualmente.","ARE_YOU_SURE":"Tem certeza que deseja continuar com a exportação?","TITLE":"Importar clientes do {{app}}","FOUND_CUSTOMERS":"Clientes encontrados","MANUAL":"Importação manual","AUTOMATIC":"Importação em massa","CONTENT":"Esse processo irá importar todos os clientes que estão cadastrados na conta Omie selecionada.<br><br>&#8226; Os clientes que não existem no Field Control serão criados;<br>&#8226; Os clientes já existentes no Field Control serão atualizados.<br><br>O processo poderá demorar alguns instantes de acordo com a quantidade de clientes. Não feche a janela até que o processo tenha terminado.","IMPORT_LOADING_TITLE":"Importando clientes do Omie","WAIT_LOADING":"Aguarde, estamos importando os clientes...","CLOSE":"Fechar","IMPORT_BUTTON":"Importar","UPDATE_SUCCESS":"Atualizado com sucesso","UPDATE_ERROR":"Houve um erro com a importação.","UPDATE_ERROR_CREATE":"Cliente não encontrado no field, então foi criado.","CREATE_ERROR":"Erro ao importar cliente.","SUCCESS_AUTOMATIC":"clientes importados com sucesso!","SUCCESS_MANUAL":"Importado com sucesso!","SEARCH_BY_NAME":"Digite pelo menos 3 caracteres para buscar clientes que você deseja importar para o Field Control.","LOADING_ERROR":"Ocorreu um erro ao carregar os clientes da Omie."},"UPDATE":"Atualizar","IMPORT":"Importar","CONTINUE":"Continuar","CANCEL":"Cancelar","CONFIRM":"Confirmar","CONFIRM_CREATE":"Confirmação de criação de cliente","CONFIRM_UPDATE":"Confirmação de atualização de cliente","UPDATE_OR_CREATE_NEW_CUSTOMER":"Altere um cliente existente ou crie um novo:","NEW_CUSTOMER":"Novo Cliente","CREATED_SUCCESSFULLY":"Cliente {{ customer }} criado com sucesso no {{ appName }}","UPDATED_SUCCESSFULLY":"Cliente {{ customer }} atualizado com sucesso no {{ appName }}","CANT_CREATE_DOCUMENT_ALREADY_EXISTS":"Não foi possível criar o cliente no Conta Azul, aparentemente já existe um cliente com o mesmo documento: {{ document }}","CANT_UPDATE_DOCUMENT_ALREADY_EXISTS":"Não foi possível atualizar o cliente no Conta Azul, aparentemente já existe um cliente com o mesmo documento: {{ document }}","ERROR_SENDING_CUSTOMER":"Erro ao enviar o cliente","INVALID_ZIPCODE_CONFIRM_TITLE":"CEP inválido","INVALID_ZIPCODE_CONFIRM_MESSAGE":"O CEP informado é inválido. Se continuar, o CEP será enviado em branco para a Omie e você deverá preenchê-lo manualmente.","NAME":"Nome","DOCUMENT":"Documento","ADDRESS":"Endereço","PHONE":"Telefone","NOTES":"Notas","EMAIL":"Email","FIND_CUSTOMER_TO_IMPORT":"Use o campo acima para encontrar os clientes que você deseja importar para o Field Control","CANT_FIND_ANY_CUSTOMER_WITH":"Não foi possível encontrar nenhum cliente com:","WILL_BE_CREATED_WITH_DATA":"O cliente será criado no {{ app }} com os seguintes dados:","WILL_BE_UPDATED_WITH_DATA":"O cliente será atualizado no {{ app }} com os seguintes dados:","SENDING_CUSTOMER":"Enviando cliente para o {{ app }}","FIND_CUSTOMERS_DESCRIPTION":"A partir dos dados de <b>nome</b>, ou <b>documento</b> identificamos os possíveis clientes já cadastrados no {{ app }}","CREATE_NEW_CUSTOMER":"Criar um novo cliente no {{ app }}","IMPORT_CUSTOMERS_FROM":"Importar clientes do {{ app }}","CANT_CONNECT":"Não foi possível se conectar com o {{ app }}, verifique suas configurações de integração e tente novamente.","CANT_PROCEED_WITH_NO_ADDRESS":"Não pode {{ action }} um cliente sem endereço","ERROR_WHEN_ACTIVATING":"Erro ao ativar integração com o {{ app }}","SUCCESS_WHEN_ACTIVATING":"Integração com {{ app }} habilitada com sucesso!","CONFIGURATION_TITLE":"Integração {{ app }}","ACTIVATE_INTEGRATION":"Ativar integração","SUCCESS_WHEN_DISABLING":"Integração com {{ app }} desabilitada com sucesso!","ERROR_WHEN_DISABLING":"Erro ao desativar integração com {{ app }}","CUSTOMERS_AUTOMATIC_IMPORT":"Importação de Clientes em Massa","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_1":"Esse processo irá importar todos os <b>{{ totalCustomerToImport }} clientes </b> que estão cadastrados no <b>{{ appName }}</b>","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_2":"- Os clientes que <b>não existirem</b> no Field Control <b>serão criados</b>","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_3":"- Os clientes <b>já existentes</b> no Field Control <b>serão atualizados</b>","CUSTOMERS_AUTOMATIC_IMPORT_DESCRIPTION_4":"O processo poderá demorar alguns minutos de acordo com a quantidade de clientes que você tiver, não feche a janela até que o processo tenha terminado","CUSTOMERS_AUTOMATIC_IMPORT_CANCEL":"Cancelar","CUSTOMERS_AUTOMATIC_IMPORT_START":"Iniciar importação","AUTOMATIC_IMPORT_ERROR_IN_FINISH":"ERRO: Não foi possível terminar o processo de importação de clientes","AUTOMATIC_IMPORT_ERROR_LIMIT":"ERROR: Total de registros maior que 5000","AUTOMATIC_IMPORT_SUCCESS_TOAST":" clientes importados com sucesso!","CUSTOMERS_AUTOMATIC_IMPORT_DIALOG_TITLE":"Importação de clientes em massa do {{ app }}","WAIT_WE_RE_IMPORTING":"Aguarde, estamos importando os clientes.","CUSTOMERS_AUTOMATIC_IMPORT_FROM":"de","AUTOMATIC_IMPORT_ERROR_CANT_FIND_CUSTOMERS":"Não foi possível encontrar os clientes cadastrados","OMIE":{"CONFIGURATION_TUTORIAL":"Para ativar a integração com a <a href=\\"https://www.omie.com.br/\\" target=\\"_blank\\">Omie</a>, precisamos das informações <strong>{{ appKey }}</strong> e <strong>{{ appSecret }}</strong>. Siga o passo a passo abaixo:","CONFIGURATION_TUTORIAL_TIPS_1":"Clique","CONFIGURATION_TUTORIAL_TIPS_2":"aqui","CONFIGURATION_TUTORIAL_TIPS_3":"e faça login com sua conta Omie;","CONFIGURATION_TUTORIAL_TIPS_4":"Clique na opção com o nome da sua empresa/aplicação;","CONFIGURATION_TUTORIAL_TIPS_5":"Copie as informações do <b>App Key</b> e <b>App Secret</b> e cole nos campos logo abaixo;","CONFIGURATION_TUTORIAL_TIPS_6":"Clique em <b>Ativar Integração</b> e pronto :)","CONFIGURATION_TUTORIAL_TIPS_7":"É possível integrar até 5 contas Omie com a sua conta Field Control.","CONFIGURATION_TUTORIAL_TIPS_8":"Dê um nome para sua integração;","FILTERS":{"INFO":"Agora é possível filtrar os clientes pela <b>\'Razão Social\'</b> ou pelo <b>\'Nome Fantasia\'</b>, mas lembre que ao filtrar os clientes apareceram somente os 5 primeiros que forem encontrados, então seja específico.","FILTER_BY":"Filtrar por","CORPORATE_NAME":"Razão social","TRADE_NAME":"Nome fantasia","SEARCH_BY":"Para aplicar o filtro é necessário pelo menos 3 caracteres."}},"CONTA_AZUL":{"ERROR":{"INVALID_FIELD":"O cliente não foi enviado, pois pode possuir um campo inválido, nulo ou desconhecido","UNAUTHORIZED":"Não autorizado","CUSTOMER_NOT_PROVIDED":"O cliente não foi fornecido ou foi fornecido incorretamente"},"TOTAL_CUSTOMERS":"Clientes encontrados: {{totalCustomers}}"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/deadline-contracts/i18n/en.json',
    '{"DEADLINE-CONTRACTS":{"PAGE_TITLE":"Deadline contracts","TITLE":"Deadline contracts","NEW":"Add contract","RELOAD":"Reload","STATUS":{"PENDING":"Pending","APPROVED":"Approved","REFUSED":"Refused","EXPIRED":"Expired","CANCELED":"Canceled"},"DIALOG":{"GENERAL":{"TITLE":"General","WARNING_SENTENCE":"Changes made to this <b>contract</b> do not reflect on the activities it has already been linked to.","LEARN_MORE":"Learn more","CONTRACT_INFORMATION":"Contract information","OFFICE_HOURS":"Office hours"},"SCHEDULES":{"TITLE":"Schedules"},"UNIT":{"DAYS":"Days","HOURS":"Hours","MINUTES":"Minutes"},"NEW":{"TITLE":"New Deadline Contract"},"VIEW":{"TITLE":"Edit Deadline Contract","READONLY_TITLE":"View Deadline Contract"},"ACTIONS":{"SAVE":"Save","CLOSE":"Close","CREATE":"Create","ARCHIVE":"Archive","UNARCHIVE":"Unarchive"},"TOAST":{"SAVED":"Contract \'{{ contract }}\' saved successfully."},"ALERT":{"TITLE":"Could Not Save Contract","OK":"OK"},"MODEL":{"NAME":{"LABEL":"Name","ERRORS":{"REQUIRED":"Required field"}},"DESCRIPTION":{"LABEL":"Description","ERRORS":{"REQUIRED":"Required field","MAX_LENGTH":"This field must have at most {{ expectedLength }} characters, but it has {{ receivedLength }} characters."}},"RESPONSE_DEADLINE":{"LABEL":"Response Deadline","ERRORS":{"REQUIRED":"Response deadline is required","SIZE_null":"Value must be less than 1 year","SIZE_days":"Value must be less than 365 days (1 year)","SIZE_hours":"Value must be less than 8766 hours (1 year)","SIZE_minutes":"Value must be less than 525960 minutes (1 year)","PATTERN":"Value must be an integer"}},"RESPONSE_DEADLINE_RISK":{"LABEL":"Response deadline risk","ERRORS":{"REQUIRED":"Response deadline risk is required","MAX":"Risk must be less than the deadline","SIZE_null":"Value must be less than 1 year","SIZE_days":"Value must be less than 365 days (1 year)","SIZE_hours":"Value must be less than 8766 hours (1 year)","SIZE_minutes":"Value must be less than 525960 minutes (1 year)","PATTERN":"Value must be an integer"}},"SOLUTION_DEADLINE":{"LABEL":"Solution deadline","ERRORS":{"REQUIRED":"Solution deadline is required","SIZE_null":"Value must be less than 1 year","SIZE_days":"Value must be less than 365 days (1 year)","SIZE_hours":"Value must be less than 8766 hours (1 year)","SIZE_minutes":"Value must be less than 525960 minutes (1 year)","PATTERN":"Value must be an integer"}},"SOLUTION_DEADLINE_RISK":{"LABEL":"Solution deadline risk","ERRORS":{"REQUIRED":"Solution deadline risk is required","MAX":"Solution deadline risk must be less than the solution deadline","SIZE_null":"Value must be less than 1 year","SIZE_days":"Value must be less than 365 days (1 year)","SIZE_hours":"Value must be less than 8766 hours (1 year)","SIZE_minutes":"Value must be less than 525960 minutes (1 year)","PATTERN":"Value must be an integer"}},"CONSIDER_HOLIDAY":{"LABEL_NOT_REQUIRED":"Do not consider <b>national holidays</b> in deadline calculation.","LABEL_REQUIRED":"Consider <b>national holidays</b> in deadline calculation."},"HAS_OFFICE_HOURS":{"LABEL_NOT_REQUIRED":"Consider elapsed time based on <b>24 hours, 7 days a week</b>","LABEL_REQUIRED":"Consider elapsed time based on custom hours.","NOT_ALLOWED":"It is not possible to change elapsed time if any deadline type is set to \\"days\\"."},"OFFICE_HOURS":{"SUNDAY":{"LABEL":"Sunday"},"MONDAY":{"LABEL":"Monday"},"TUESDAY":{"LABEL":"Tuesday"},"WEDNESDAY":{"LABEL":"Wednesday"},"THURSDAY":{"LABEL":"Thursday"},"FRIDAY":{"LABEL":"Friday"},"SATURDAY":{"LABEL":"Saturday"}}}},"TABLE":{"NAME":"Name","DESCRIPTION":"Description","COLOR":"Color","ARCHIVED":"Archived","CREATED_AT":"Created at","ACTIONS":"Actions","VIEW":"View","RESPONSE_DEADLINE":"Response deadline","RESPONSE_DEADLINE_RISK":"Response deadline risk","SOLUTION_DEADLINE":"Solution deadline","SOLUTION_DEADLINE_RISK":"Solution deadline risk","MINUTES":"minute(s)"},"FILTERS":{"TITLE":"Filter contracts","CLEAR":"Clear","NAME":"Filter by name","DESCRIPTION":"Filter by description","SITUATION":"Situation","STATE":{"TITLE":"Search by state","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/deadline-contracts/i18n/es.json',
    '{"DEADLINE-CONTRACTS":{"PAGE_TITLE":"Contratos de plazos","TITLE":"Contratos de plazos","NEW":"Agregar Contrato","RELOAD":"Recargar","STATUS":{"PENDING":"Pendiente","APPROVED":"Aprobado","REFUSED":"Rechazado","EXPIRED":"Caducado","CANCELED":"Cancelado"},"DIALOG":{"GENERAL":{"TITLE":"General","WARNING_SENTENCE":"Los cambios realizados en este <b>contrato</b> no se reflejan en las actividades a las que ya se ha vinculado.","LEARN_MORE":"Saber más","CONTRACT_INFORMATION":"Información del contrato","OFFICE_HOURS":"Horarios de oficina"},"SCHEDULES":{"TITLE":"Horarios"},"UNIT":{"DAYS":"Días","HOURS":"Horas","MINUTES":"Minutos"},"NEW":{"TITLE":"Nuevo contrato de plazos"},"VIEW":{"TITLE":"Editar contrato de plazos","READONLY_TITLE":"Ver contrato de plazos"},"ACTIONS":{"SAVE":"Guardar","CLOSE":"Cerrar","CREATE":"Crear","ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar"},"TOAST":{"SAVED":"Contrato \'{{ contract }}\' guardado correctamente."},"ALERT":{"TITLE":"No se pudo guardar el contrato","OK":"OK"},"MODEL":{"NAME":{"LABEL":"Nombre","ERRORS":{"REQUIRED":"Campo obligatorio"}},"DESCRIPTION":{"LABEL":"Descripción","ERRORS":{"REQUIRED":"Campo obligatorio","MAX_LENGTH":"Este campo debe tener como máximo {{ expectedLength }} caracteres, pero tiene {{ receivedLength }} caracteres."}},"RESPONSE_DEADLINE":{"LABEL":"Plazo de respuesta","ERRORS":{"REQUIRED":"El plazo de respuesta es obligatorio","SIZE_null":"El valor debe ser menor que 1 año","SIZE_days":"El valor debe ser menor que 365 días (1 año)","SIZE_hours":"El valor debe ser menor que 8766 horas (1 año)","SIZE_minutes":"El valor debe ser menor que 525960 minutos (1 año)","PATTERN":"El valor debe ser un número entero"}},"RESPONSE_DEADLINE_RISK":{"LABEL":"Riesgo de plazo de respuesta","ERRORS":{"REQUIRED":"El riesgo de plazo de respuesta es obligatorio","MAX":"El riesgo debe ser menor que el plazo","SIZE_null":"El valor debe ser menor que 1 año","SIZE_days":"El valor debe ser menor que 365 días (1 año)","SIZE_hours":"El valor debe ser menor que 8766 horas (1 año)","SIZE_minutes":"El valor debe ser menor que 525960 minutos (1 año)","PATTERN":"El valor debe ser un número entero"}},"SOLUTION_DEADLINE":{"LABEL":"Plazo de solución","ERRORS":{"REQUIRED":"El plazo de solución es obligatorio","SIZE_null":"El valor debe ser menor que 1 año","SIZE_days":"El valor debe ser menor que 365 días (1 año)","SIZE_hours":"El valor debe ser menor que 8766 horas (1 año)","SIZE_minutes":"El valor debe ser menor que 525960 minutos (1 año)","PATTERN":"El valor debe ser un número entero"}},"SOLUTION_DEADLINE_RISK":{"LABEL":"Riesgo de plazo de solución","ERRORS":{"REQUIRED":"El riesgo de plazo de solución es obligatorio","MAX":"El riesgo de plazo de solución debe ser menor que el plazo de solución","SIZE_null":"El valor debe ser menor que 1 año","SIZE_days":"El valor debe ser menor que 365 días (1 año)","SIZE_hours":"El valor debe ser menor que 8766 horas (1 año)","SIZE_minutes":"El valor debe ser menor que 525960 minutos (1 año)","PATTERN":"El valor debe ser un número entero"}},"CONSIDER_HOLIDAY":{"LABEL_NOT_REQUIRED":"No considerar <b>feriados nacionales</b> en el cálculo del plazo.","LABEL_REQUIRED":"Considerar <b>feriados nacionales</b> en el cálculo del plazo."},"HAS_OFFICE_HOURS":{"LABEL_NOT_REQUIRED":"Considerar el tiempo transcurrido basado en <b>24 horas, 7 días a la semana</b>","LABEL_REQUIRED":"Considerar el tiempo transcurrido basado en horarios personalizados.","NOT_ALLOWED":"No es posible cambiar el tiempo transcurrido si algún tipo de plazo está establecido en \\"días\\"."},"OFFICE_HOURS":{"SUNDAY":{"LABEL":"Domingo"},"MONDAY":{"LABEL":"Lunes"},"TUESDAY":{"LABEL":"Martes"},"WEDNESDAY":{"LABEL":"Miércoles"},"THURSDAY":{"LABEL":"Jueves"},"FRIDAY":{"LABEL":"Viernes"},"SATURDAY":{"LABEL":"Sábado"}}}},"TABLE":{"NAME":"Nombre","DESCRIPTION":"Descripción","COLOR":"Color","ARCHIVED":"Archivado","CREATED_AT":"Creado en","ACTIONS":"Acciones","VIEW":"Ver","RESPONSE_DEADLINE":"Plazo de respuesta","RESPONSE_DEADLINE_RISK":"Riesgo de plazo de respuesta","SOLUTION_DEADLINE":"Plazo de solución","SOLUTION_DEADLINE_RISK":"Riesgo de plazo de solución","MINUTES":"minuto(s)"},"FILTERS":{"TITLE":"Filtrar Contratos","CLEAR":"Limpiar","NAME":"Filtrar por nombre","DESCRIPTION":"Filtrar por descripción","SITUATION":"Situación","STATE":{"TITLE":"Buscar por estado","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/deadline-contracts/i18n/pt.json',
    '{"DEADLINE-CONTRACTS":{"PAGE_TITLE":"Contratos de prazos","TITLE":"Contratos de prazos","NEW":"Adicionar contrato","RELOAD":"Recarregar","STATUS":{"PENDING":"Pendente","APPROVED":"Aprovado","REFUSED":"Recusado","EXPIRED":"Expirado","CANCELED":"Cancelado"},"DIALOG":{"GENERAL":{"TITLE":"Geral","WARNING_SENTENCE":"As alterações realizadas neste <b>contrato</b> não refletem nas atividades em que ele já foi vinculado.","LEARN_MORE":"Saiba mais","CONTRACT_INFORMATION":"Informações do contrato","OFFICE_HOURS":"Horários de atendimento"},"SCHEDULES":{"TITLE":"Horários"},"UNIT":{"DAYS":"Dias","HOURS":"Horas","MINUTES":"Minutos"},"NEW":{"TITLE":"Novo contrato de prazos"},"VIEW":{"TITLE":"Editar contrato de prazos","READONLY_TITLE":"Visualizar contrato de prazos"},"ACTIONS":{"SAVE":"Salvar","CLOSE":"Fechar","CREATE":"Criar","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"},"TOAST":{"SAVED":"Contrato \'{{ contract }}\' salvo com sucesso."},"ALERT":{"TITLE":"Não foi possível salvar o contrato","OK":"OK"},"MODEL":{"NAME":{"LABEL":"Nome","ERRORS":{"REQUIRED":"Campo obrigatório"}},"DESCRIPTION":{"LABEL":"Descrição","ERRORS":{"REQUIRED":"Campo obrigatório","MAX_LENGTH":"Este campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }} caracteres."}},"RESPONSE_DEADLINE":{"LABEL":"Prazo para resposta","ERRORS":{"REQUIRED":"Prazo para resposta é obrigatório","SIZE_null":"O valor deve ser menor que 1 ano","SIZE_days":"O valor deve ser menor que 365 dias (1 ano)","SIZE_hours":"O valor deve ser menor que 8766 horas (1 ano)","SIZE_minutes":"O valor deve ser menor que 525960 minutos (1 ano)","PATTERN":"O valor deve ser inteiro"}},"RESPONSE_DEADLINE_RISK":{"LABEL":"Risco para resposta","ERRORS":{"REQUIRED":"Risco para resposta é obrigatório","MAX":"O risco deve ser menor que o prazo","SIZE_null":"O valor deve ser menor que 1 ano","SIZE_days":"O valor deve ser menor que 365 dias (1 ano)","SIZE_hours":"O valor deve ser menor que 8766 horas (1 ano)","SIZE_minutes":"O valor deve ser menor que 525960 minutos (1 ano)","PATTERN":"O valor deve ser inteiro"}},"SOLUTION_DEADLINE":{"LABEL":"Prazo para solução","ERRORS":{"REQUIRED":"Prazo para solução é obrigatório","SIZE_null":"O valor deve ser menor que 1 ano","SIZE_days":"O valor deve ser menor que 365 dias (1 ano)","SIZE_hours":"O valor deve ser menor que 8766 horas (1 ano)","SIZE_minutes":"O valor deve ser menor que 525960 minutos (1 ano)","PATTERN":"O valor deve ser inteiro"}},"SOLUTION_DEADLINE_RISK":{"LABEL":"Risco para solução","ERRORS":{"REQUIRED":"Risco para solução é obrigatório","MAX":"Risco para solução deve ser menor que o prazo para solução","SIZE_null":"O valor deve ser menor que 1 ano","SIZE_days":"O valor deve ser menor que 365 dias (1 ano)","SIZE_hours":"O valor deve ser menor que 8766 horas (1 ano)","SIZE_minutes":"O valor deve ser menor que 525960 minutos (1 ano)","PATTERN":"O valor deve ser inteiro"}},"CONSIDER_HOLIDAY":{"LABEL_NOT_REQUIRED":"Não considerar <b>feriados nacionais</b> no cálculo do prazo.","LABEL_REQUIRED":"Considerar <b>feriados nacionais</b> no cálculo do prazo."},"HAS_OFFICE_HOURS":{"LABEL_NOT_REQUIRED":"Considerar o tempo decorrido baseado em <b>24 horas, 7 dias por semana</b>","LABEL_REQUIRED":"Considerar o tempo decorrido baseado em horários customizados.","NOT_ALLOWED":"Não é possível alterar o tempo decorrido caso o tipo de algum prazo estiver em \\"dias\\"."},"OFFICE_HOURS":{"SUNDAY":{"LABEL":"Domingo"},"MONDAY":{"LABEL":"Segunda"},"TUESDAY":{"LABEL":"Terça"},"WEDNESDAY":{"LABEL":"Quarta"},"THURSDAY":{"LABEL":"Quinta"},"FRIDAY":{"LABEL":"Sexta"},"SATURDAY":{"LABEL":"Sábado"}}}},"TABLE":{"NAME":"Nome","DESCRIPTION":"Descrição","COLOR":"Cor","ARCHIVED":"Arquivado","CREATED_AT":"Criado em","ACTIONS":"Ações","VIEW":"Visualizar","RESPONSE_DEADLINE":"Prazo para resposta","RESPONSE_DEADLINE_RISK":"Risco para resposta","SOLUTION_DEADLINE":"Prazo para solução","SOLUTION_DEADLINE_RISK":"Risco para solução","MINUTES":"minuto(s)"},"FILTERS":{"TITLE":"Filtrar contratos","CLEAR":"Limpar","NAME":"Filtrar por nome","DESCRIPTION":"Filtrar por descrição","SITUATION":"Situação","STATE":{"TITLE":"Pesquisar por estado","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/deadline-violations-reasons/i18n/en.json',
    '{"DEADLINE-VIOLATIONS-REASONS":{"PAGE_TITLE":"Violation reasons","TITLE":"Violation reasons","NEW":"New Violation reason","RELOAD":"Reload","STATUS":{"PENDING":"Pending","APPROVED":"Approved","REFUSED":"Refused","EXPIRED":"Expired","CANCELED":"Canceled"},"DIALOG":{"NEW":{"TITLE":"New Violation reason"},"VIEW":{"TITLE":"Edit Violation reason","READONLY_TITLE":"View Violation reason"},"ACTIONS":{"CREATE":"Save","CLOSE":"Close","ARCHIVE":"Archive Violation reason","UNARCHIVE":"Unarchive Violation reason"},"TOAST":{"SAVED":"Violation reason \'{{ violationReason }}\' saved successfully."},"ALERT":{"TITLE":"Unable to save the reason","OK":"OK"},"MODEL":{"NAME":{"LABEL":"Reason","ERRORS":{"REQUIRED":"Name is required"}},"COLOR":{"LABEL":"Color*","ERRORS":{"REQUIRED":"Color is required"}},"DESCRIPTION":{"LABEL":"Description","ERRORS":{"REQUIRED":"Description is required","MAX_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but has {{ receivedLength }}"}}},"ARCHIVED_LIST":{"ARCHIVED":"Archived","ACTIVATED":"Activated"},"WARNING":"A <b>violation reason</b> is used to indicate when a service has violated its deadline."},"TABLE":{"NAME":"Violation reason name","DESCRIPTION":"Description","COLOR":"Color","ARCHIVED":"Archived","CREATED_AT":"Created at","ACTIONS":"Actions","VIEW":"View"},"FILTERS":{"TITLE":"Filter violation reasons","CLEAR":"Clear","NAME":"Filter by name","DESCRIPTION":"Filter by description","SITUATION":"Situation","STATE":{"TITLE":"Search by state","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/deadline-violations-reasons/i18n/es.json',
    '{"DEADLINE-VIOLATIONS-REASONS":{"PAGE_TITLE":"Motivos de Violación","TITLE":"Motivos de Violación","NEW":"Nuevo Motivo de Violación","RELOAD":"Recargar","STATUS":{"PENDING":"Pendiente","APPROVED":"Aprobado","REFUSED":"Rechazado","EXPIRED":"Expirado","CANCELED":"Cancelado"},"DIALOG":{"NEW":{"TITLE":"Nuevo Motivo de Violación"},"VIEW":{"TITLE":"Editar Motivo de Violación","READONLY_TITLE":"Ver Motivo de Violación"},"ACTIONS":{"CREATE":"Guardar","CLOSE":"Cerrar","ARCHIVE":"Archivar Motivo de Violación","UNARCHIVE":"Desarchivar Motivo de Violación"},"TOAST":{"SAVED":"Motivo de violación \'{{ violationReason }}\' guardado exitosamente."},"ALERT":{"TITLE":"No se pudo guardar el motivo","OK":"OK"},"MODEL":{"NAME":{"LABEL":"Motivo","ERRORS":{"REQUIRED":"El nombre es obligatorio"}},"COLOR":{"LABEL":"Color*","ERRORS":{"REQUIRED":"El color es obligatorio"}},"DESCRIPTION":{"LABEL":"Descripción","ERRORS":{"REQUIRED":"La descripción es obligatoria","MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}"}}},"ARCHIVED_LIST":{"ARCHIVED":"Archivado","ACTIVATED":"Activado"},"WARNING":"Un <b>motivo de violación</b> se utiliza para indicar cuándo un servicio ha violado su plazo."},"TABLE":{"NAME":"Nombre del Motivo de Violación","DESCRIPTION":"Descripción","COLOR":"Color","ARCHIVED":"Archivado","CREATED_AT":"Creado en","ACTIONS":"Acciones","VIEW":"Ver"},"FILTERS":{"TITLE":"Filtrar Motivos de Violación","CLEAR":"Limpiar","NAME":"Filtrar por Nombre","DESCRIPTION":"Filtrar por Descripción","SITUATION":"Situación","STATE":{"TITLE":"Buscar por Estado","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/deadline-violations-reasons/i18n/pt.json',
    '{"DEADLINE-VIOLATIONS-REASONS":{"PAGE_TITLE":"Motivos de violação","TITLE":"Motivos de violação","NEW":"Novo motivo de violação","RELOAD":"Recarregar","STATUS":{"PENDING":"Pendente","APPROVED":"Aprovado","REFUSED":"Recusado","EXPIRED":"Expirado","CANCELED":"Cancelado"},"DIALOG":{"NEW":{"TITLE":"Novo motivo de violação"},"VIEW":{"TITLE":"Editar motivo de violação","READONLY_TITLE":"Visualizar motivo de violação"},"ACTIONS":{"CREATE":"Salvar","CLOSE":"Fechar","ARCHIVE":"Arquivar motivo de violação","UNARCHIVE":"Desarquivar motivo de violação"},"TOAST":{"SAVED":"Motivo de violação \'{{ violationReason }}\' salvo com sucesso."},"ALERT":{"TITLE":"Não foi possível salvar o motivo","OK":"OK"},"MODEL":{"NAME":{"LABEL":"Motivo","ERRORS":{"REQUIRED":"Nome é obrigatório"}},"COLOR":{"LABEL":"Cor*","ERRORS":{"REQUIRED":"Cor é obrigatório"}},"DESCRIPTION":{"LABEL":"Descrição","ERRORS":{"REQUIRED":"Descrição é obrigatório","MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}"}}},"ARCHIVED_LIST":{"ARCHIVED":"Desativado","ACTIVATED":"Ativado"},"WARNING":"Um <b>motivo de violação</b> é utilizado para indicar quando um serviço teve seu prazo violado."},"TABLE":{"NAME":"Nome do motivo","DESCRIPTION":"Descrição","COLOR":"Cor","ARCHIVED":"Arquivado","CREATED_AT":"Criado em","ACTIONS":"Ações","VIEW":"Visualizar"},"FILTERS":{"TITLE":"Filtrar motivos de violação","CLEAR":"Limpar","NAME":"Filtrar por nome","DESCRIPTION":"Filtrar por descrição","SITUATION":"Situação","STATE":{"TITLE":"Pesquisar por estado","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/devices/i18n/en.json',
    '{"DEVICES":{"PAGE_TITLE":"Devices","TITLE":"Devices","DESCRIPTION":"Here you control the devices released by your company","FILTER":"Filter devices","RELOAD":"Reload","TABLE":{"NO_RESULTS":"No devices added yet.","REMOVE":"Remove","ACTIONS":"Actions"},"DELETE_ALERT":{"TITLE":"Devices","BODY":"Do you really want to remove this device?","OK":"Yes, I want to","CANCEL":"Later"},"DELETE_ALL_ALERT":{"TITLE":"Devices","BODY":"Do you really want to remove ALL devices?","OK":"Yes, I want to","CANCEL":"Later","SUCCESS":"Devices removed successfully","ERROR":"An error occurred while trying to remove the devices","BUTTON":"Remove all devices"},"MODEL":{"IDENTIFIER":"Identifier","MANUFACTURER":"Manufacturer","MODEL":"Model","PLATFORM":"Platform","VERSION":"Version","LAST_ACCESS":"Last access","LAST_USER_TO_USE_IT":"Last user to use it","DEVICE_APP_VERSION":"App version"},"FILTERS":{"CLEAR":"Clear filters","IDENTIFIER":"Filter by identifier","MANUFACTURER":"Filter by manufacturer","PLATFORM":{"LABEL":"Filter by platform","ALL_OPTION":"All"},"EMPLOYEE":{"LABEL":"Filter by employee","TYPES":"Filtering type","ALL_OPTION":"All","ACTIVE_OPTION":"Hired","UNACTIVE_OPTION":"Fired"}},"TOAST":{"DELETE_SUCCESS":"Device removed","DELETE_ERROR":"An error occurred while trying to delete the device"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/devices/i18n/es.json',
    '{"DEVICES":{"PAGE_TITLE":"Dispositivos","TITLE":"Dispositivos","DESCRIPTION":"Aquí usted puede controlar los dispositivos liberados de su empresa","FILTER":"Filtrar dispositivos","RELOAD":"Recargar","TABLE":{"NO_RESULTS":"Ningún dispositivo añadido todavía.","REMOVE":"Eliminar","ACTIONS":"Acciones"},"DELETE_ALERT":{"TITLE":"Dispositivos","BODY":"¿Realmente quieres eliminar este dispositivo?","OK":"Sí, quiero","CANCEL":"Después"},"DELETE_ALL_ALERT":{"TITLE":"Dispositivos","BODY":"¿Desea realmente eliminar TODOS los dispositivos?","OK":"Sí, quiero","CANCEL":"Más tarde","SUCCESS":"Dispositivos eliminados con éxito","ERROR":"Ocurrió un error al intentar eliminar los dispositivos","BUTTON":"Eliminar todos los dispositivos"},"MODEL":{"IDENTIFIER":"Identificador","MANUFACTURER":"Fabricante","MODEL":"Modelo","PLATFORM":"Plataforma","VERSION":"Versión","LAST_ACCESS":"Último acceso","LAST_USER_TO_USE_IT":"Último usuario en usarlo","DEVICE_APP_VERSION":"Versión de la aplicación"},"FILTERS":{"CLEAR":"Limpiar filtros","IDENTIFIER":"Filtrar por identificador","MANUFACTURER":"Filtrar por fabricante","PLATFORM":{"LABEL":"Filtrar por plataforma","ALL_OPTION":"Todos"},"EMPLOYEE":{"LABEL":"Filtrar por empleado","TYPES":"Tipo de filtrado","ALL_OPTION":"Todos","ACTIVE_OPTION":"Contratados","UNACTIVE_OPTION":"Despedidos"}},"TOAST":{"DELETE_SUCCESS":"Dispositivo eliminado","DELETE_ERROR":"Se produjo un error al intentar eliminar el dispositivo"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/devices/i18n/pt.json',
    '{"DEVICES":{"PAGE_TITLE":"Dispositivos","TITLE":"Dispositivos","DESCRIPTION":"Aqui você controla os dispositivos liberados da sua empresa","FILTER":"Filtrar dispositivos","RELOAD":"Recarregar","TABLE":{"NO_RESULTS":"Nenhum dispositivo adicionado até o momento.","REMOVE":"Remover","ACTIONS":"Ações"},"DELETE_ALERT":{"TITLE":"Dispositivos","BODY":"Deseja realmente remover este dispositivo?","OK":"Sim, eu quero","CANCEL":"Mais tarde"},"DELETE_ALL_ALERT":{"TITLE":"Dispositivos","BODY":"Deseja realmente remover TODOS os dispositivo?","OK":"Sim, eu quero","CANCEL":"Mais tarde","SUCCESS":"Dispositivos removidos com sucesso","ERROR":"Ocorreu um erro ao tentar remover os dispositivos","BUTTON":"Remover todos os dispositivos"},"MODEL":{"IDENTIFIER":"Identificador","MANUFACTURER":"Fabricante","MODEL":"Modelo","PLATFORM":"Plataforma","VERSION":"Versão","LAST_ACCESS":"Último acesso","LAST_USER_TO_USE_IT":"Último usuário a usá-lo","DEVICE_APP_VERSION":"Versão do aplicativo"},"FILTERS":{"CLEAR":"Limpar filtros","IDENTIFIER":"Filtrar por identificador","MANUFACTURER":"Filtrar por fabricante","PLATFORM":{"LABEL":"Filtrar por plataforma","ALL_OPTION":"Todos"},"EMPLOYEE":{"LABEL":"Filtrar por colaborador","TYPES":"Tipo de filtragem","ALL_OPTION":"Todos","ACTIVE_OPTION":"Contratados","UNACTIVE_OPTION":"Demitidos"}},"TOAST":{"DELETE_SUCCESS":"Dispositivo removido","DELETE_ERROR":"Ocorreu um erro ao tentar deletar o dispositivo"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/employees/i18n/en.json',
    '{"EMPLOYEES":{"PAGE_TITLE":"Employees","TITLE":"Employees","SEARCH":"Search","DESCRIPTION":"Employees are professionals who work externally.","NEW":"Add employee","RELOAD":"Reload","CLEAR_FILTERS":"Clear filters","FILTER":"Filter Employees","FILTERS":{"TITLE":"Filter Employees","CLEAR":"Clear filters","NAME":"Search by name","SITUATIONS":{"TITLE":"Filter by situation","ALL":"All","ACTIVE":"Active","INACTIVE":"Inactive","FIRED":"Fired","HIRED":"Hired"}},"PRO":{"ACTIVE_COUNT":"{{ countActiveEmployees }} of {{ planLicenses }} active employees","ACTIVE_PERCENTAGE":"You are using <strong>{{ activeEmployeesPercentage }}%</strong> of your license limit."},"TOOLTIP":{"EXPORT_TO_EXCEL":"Export to Excel"},"MODEL":{"NAME":"Name","DOCUMENT":{"LABEL":"Customer Identification","INVALID_CPF":"Invalid CPF","INVALID_CNPJ":"Invalid CNPJ","EXISTS":"Document already exists"},"NOTES":"Observations","PHONE_NUMBER":"Mobile identifier","START_DATE":"Admission date","END_DATE":"Dismissal date","EMAIL":"Email","NO_EMAIL":"No email","GEOLOCATION":"Geolocation","GEOLOCATION_ENABLED":"Enabled","GEOLOCATION_DISABLED":"Disabled","PHONE":"Telephone","ZIPCODE":"Zipcode","STREET":"Street","NUMBER":"Number","CITY":"City","STATE":"State","START_TIME":"Arrival time","END_TIME":"Departure time","START_BREAK_TIME":"Start breaktime","END_BREAK_TIME":"End breaktime","EMPLOYEE_ADDRESS":"Employee address","DISTANCE_AWAY":"km away","PASSWORD":"Password","CONFIRM_PASSWORD":"Password Confirmation","GROUPS":"Groups","ERRORS":{"ALREADY_USED_PASSWORD":"This password was already used by you not so long ago, input a diferent one.","ADDRESS_NOT_FOUND":"Unable to find the address, please try again.","ADDRESS_NUMBER_NOT_SPECIFIED":"Number not specified.","CITY_REQUIRED":"City required","DEVICE_ALREADY_TAKEN":"This mobile device is already assigned to another employee.","EMAIL_ALREADY_TAKEN":"This email adress is alredy in use with another employee.","EMAIL_PATTERN":"Invalid email format","EMAIL_PATTERN_AFTER_CREATED":"Email with invalid format, please contact your account manager","EMAIL_REQUIRED":"Email required","EMPLOYEE_ADDRESS_REQUIRED":"Employee address required","END_BREAK_TIME_REQUIRED":"End of breaktime required","END_TIME_REQUIRED":"Departure time is required","END_TIME_INVALID":"Departure time is invalid","NAME_REQUIRED":"Name required","NAME_VALID_LENGTH":"Name size is invalid because it is greater {{ length }}","DOCUMENT_NUMBER_VALID_LENGTH":"Document size is invalid because it is greater {{ length }}","NOTE_VALID_LENGTH":"This field should contain no more than {{ expectedLength }} characters, but it has {{ receivedLength }}.","NUMBER_REQUIRED":"Number required","PASSWORD_REQUIRED":"Password required","PASSWORD_MAX_LENGTH":"Password must be up to 40 characters","PASSWORDS_DIDNT_MATCH":"Passwords don\'t match, type again.","PHONE_REQUIRED":"Phone required","RELOAD":"Could not update employee list","START_BREAK_TIME_REQUIRED":"Breaktime start required","START_DATE_REQUIRED":"Admission date required","START_TIME_REQUIRED":"Arrival time is required","START_TIME_INVALID":"Arrival time is invalid","STATE_REQUIRED":"State required","STREET_REQUIRED":"Street required","ZIPCODE_REQUIRED":"Zipcode required","TIME_FORMAT_REQUIRED":"Time format is required","DEPARTURE_TIME_IS_LESS_THAN_ARRIVAL_TIME":"Departure time must be greater than arrival time","START_TIME_IS_GREATER_THAN_12_HOURS":"Arrival time must be less or equal than 12 hours","START_TIME_IS_MINOR_THAN_1_HOUR":"Arrival time must be greater than 1 hour","END_TIME_IS_GREATER_THAN_12_HOURS":"Departure time must be less or equal than 12 hours","END_TIME_IS_MINOR_THAN_1_HOUR":"Departure time must be greater than 1 hour","GROUP_REQUIRED":"Group required"}},"TABLE":{"NAME":"Name","DOCUMENT_NUMBER":"Document","ACTIVATED":"Within the hiring period","DEACTIVATED":"Outside of the hiring period","HIRED_AT":"Admission date","FIRED_AT":"Dismissal date","WORKSCHEDULE_START":"Arrival time","WORKSCHEDULE_END":"Exit time","ACTIONS":"Actions","CHANGE_PASSWORD":"Edit employee password","ADD_CREDENTIALS":"Employee has no username and password!","EDIT":"Edit","CREATE_EMPLOYEE_CTA":"You can create a new employee","CREATE_EMPLOYEE_LINK":"by clicking here","ROWS":{"EMAIL":{"VERIFIED":"Verified at: {{ validatedAt }}","UNVERIFIED":"Unverified"}}},"DIALOG":{"CLOSE":"Close","HINT":"You need to use a strong enough password. It must contain at least 8 characters including letters, numbers and symbols.","FOR_EXAMPLE":"For example:","NEW":{"TITLE":"New employee"},"EDIT":{"TITLE":"Edit employee"},"GENERAL":{"TITLE":"General","EMPLOYEE_DATA":"Employee data","AND":"and","ACTIVE":"Active","INACTIVE":"Inactive","CLEAR_ADDRESS":"Clear employee address","ENTER_ADDRESS":"Enter the employee\'s address in the field above","ADDRESS_EXAMPLE":"Search an address, example: Rua dos Pinheiros, 383 - São Paulo","SELECT_DATE":"Select date","ACCESS_DATA":"Access data"},"ERRORS":{"TEMP_PASSWORD":"Temporary password not used. Please renew the password so the collaborator can use it."},"SKILLS":{"TITLE":"Skills","RESPONSIBILITIES":"Tasks performed","SELECT_ALL":"Select all"},"IMAGE":{"TITLE":"Photo","SEND_PICTURE":"Send picture","SELECT_OR_DRAG_PHOTO":"Select or drag your image to upload","CROP_IMAGE":"To crop this image, select below and click the button:"},"ACTIONS":{"CREATE":"Create","SAVE":"Save","FIRE_EMPLOYEE":"Fire employee","REHIRE_EMPLOYEE":"Rehire employee","UPLOAD_AVATAR":"Upload photo","CHANGE_TEMP_PASSWORD":"Renew password","CREATE_CREDENTIALS":"Create Credential"},"CREDENTIALS":{"TITLE":"Add email and password for employee <strong>{{ name }}</strong>","AGREE_TERMS":"I agree that after registering these data, they will be necessary <strong>{{ name }}</strong> to login app."},"PASSWORD":{"TITLE":"Change password"},"INACTIVATE":{"TITLE":"Deactivate Employee","WARNING":"Are you sure you want to deactivate this employee?","INSTRUCTION":"To proceed, type: <b>{{ firstName }}</b>","TYPE_IT":"Type {{ firstName }}","CANCEL":"No","SUBMIT":"Yes","ALERT":{"TITLE":"Deactivate Employee?","TEXT_CONTENT":"After deactivation, the employee \'{{ username }}\' will not have access to the system until reactivated. Do you want to continue?","OK":"Yes, I want to","CANCEL":"Better not"},"TOOLTIP":"Deactivate"},"ACTIVATE":{"TITLE":"Activate Employee","WARNING":"Are you sure you want to activate this employee?","INSTRUCTION":"To proceed, type: <b>{{ firstName }}</b>","TYPE_IT":"Type {{ firstName }}","CANCEL":"No","SUBMIT":"Yes","ALERT":{"TITLE":"Activate Employee?","TEXT_CONTENT":"After activation, the employee \'{{ username }}\' will have access to the system until deactivated again. Do you want to continue?","OK":"Yes, I want to","CANCEL":"Better not"},"TOOLTIP":"Activate"},"EMPLOYEE_CREATED_DIALOG":{"TITLE":"employee created successfully!","MESSAGE":"A new employee has been successfully created. They will receive a temporary password by email, which should be used to log in for the first time in the application. Upon first access, the employee will be prompted to create a new permanent password.","OK":"Continue"},"DELETE_DEVICES":{"TITLE":"Delete Devices","WARNING":"Are you sure you want to delete all devices linked to this employee?","CANCEL":"No","SUBMIT":"Yes","TOOLTIP":"Delete Devices"}},"TOAST":{"SAVED":"Employee \'{{ name }}\' saved successfully.","PASSWORD_CHANGED":"Password for employee \'{{ name }}\' updated successfully.","EMPLOYEE_SUCCESSFULLY_INACTIVATED":"Employee successfully deactivated.","INACTIVATE_EMPLOYEE_FAILED":"Could not deactivate employee \'{{ username }}\', please try again.","EMPLOYEE_SUCCESSFULLY_ACTIVATED":"Employee successfully activated.","ACTIVATE_EMPLOYEE_FAILED_EMAIL":"Could not activate employee \'{{ username }}\' because this email is already in use.","ACTIVATE_EMPLOYEE_FAILED":"Could not activate employee \'{{ username }}\', please try again.","ALREADY_USED_PASSWORD":"This password was recently used by you, please enter a different password.","UNEXPECTED_ERROR":"An unexpected error occurred, please try again later.","CREDENTIALS_ADDED":"Email and password for \'{{ name }}\' added successfully.","GENERATE_PASSWORD_ERROR":"Error generating temporary password","GENERATE_CREDENTIAL_ERROR":"Error generating credential","DEVICES_DELETED":"All employee devices were successfully deleted.","DELETE_DEVICES_FAILED":"Could not delete employee devices."},"EXPORT":{"TITLE":"Employees successfully exported!","ERROR":"Unable to export employees, please try again later."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/employees/i18n/es.json',
    '{"EMPLOYEES":{"PAGE_TITLE":"Colaboradores","TITLE":"Colaboradores","SEARCH":"Buscar","DESCRIPTION":"Los colaboradores son profesionales que trabajan externamente.","NEW":"Agregar empleado","RELOAD":"Recargar","CLEAR_FILTERS":"Limpiar filtros","FILTER":"Filtrar colaboradores","FILTERS":{"TITLE":"Filtrar colaboradores","CLEAR":"Limpiar filtros","NAME":"Buscar por nombre","SITUATIONS":{"TITLE":"Filtrar por situación","ALL":"Todos","ACTIVE":"Activos","INACTIVE":"Inactivos","FIRED":"Despedidos","HIRED":"Contratados"}},"PRO":{"ACTIVE_COUNT":"{{ countActiveEmployees }} de {{ planLicenses }} empleados habilitados","ACTIVE_PERCENTAGE":"Está utilizando <strong>{{ activeEmployeesPercentage }}%</strong> del límite de licencia contratado."},"TOOLTIP":{"EXPORT_TO_EXCEL":"Exportar a Excel"},"MODEL":{"NAME":"Nombre","DOCUMENT":{"LABEL":"Documento","INVALID_CPF":"CPF inválido","INVALID_CNPJ":"CNPJ inválido","EXISTS":"El documento ya existe"},"NOTES":"Observaciones","PHONE_NUMBER":"Identificador móvil","START_DATE":"Fecha de admisión","END_DATE":"Fecha de despido","EMAIL":"Correo","NO_EMAIL":"Sin correo","GEOLOCATION":"Geolocalización","GEOLOCATION_ENABLED":"Habilitada","GEOLOCATION_DISABLED":"Deshabilitada","PHONE":"Número de teléfono","ZIPCODE":"Código postal","STREET":"Calle","NUMBER":"Número","CITY":"Ciudad","STATE":"Estado","START_TIME":"Hora de entrada","END_TIME":"Hora de salida","START_BREAK_TIME":"Comienzo del horaio de almuerzo","END_BREAK_TIME":"Fin del horario de almuerzo","EMPLOYEE_ADDRESS":"Dirección del empleado","DISTANCE_AWAY":"km de distancia","PASSWORD":"Contraseña","CONFIRM_PASSWORD":"Confirmación de contraseña","GROUPS":"Grupos","ERRORS":{"ALREADY_USED_PASSWORD":"Esta contraseña ya fue utilizada por usted no hace mucho, ingrese una diferente","ADDRESS_NOT_FOUND":"No pudimos encontrar la dirección, cambie su búsqueda e intente nuevamente.","ADDRESS_NUMBER_NOT_SPECIFIED":"El número de dirección no fue especificado.","CITY_REQUIRED":"Se requiere la ciudad","DEVICE_ALREADY_TAKEN":"Este teléfono celular ya está registrado para otro empleado.","EMAIL_ALREADY_TAKEN":"Este correo electrónico ya está en uso para otro empleado.","EMAIL_PATTERN":"Formato de correo electrónico no válido","EMAIL_PATTERN_AFTER_CREATED":"Correo electrónico con formato no válido, póngase en contacto con su gestor de cuentas","EMAIL_REQUIRED":"Se requiere el correo electrónico","EMPLOYEE_ADDRESS_REQUIRED":"Se requiere la dirección del empleado","END_BREAK_TIME_REQUIRED":"Se requiere el término del horario de almuerzo","END_TIME_REQUIRED":"Se requiere la hora de salida","END_TIME_INVALID":"La hora de salida no es válida","NAME_REQUIRED":"Se requiere el nombre","NAME_VALID_LENGTH":"El tamaño del nombre no es válido porque es mayor que {{ length }}","DOCUMENT_NUMBER_VALID_LENGTH":"El tamaño del documento no es válido porque es mayor que {{ length }}","NOTE_VALID_LENGTH":"Este campo debe tener como máximo {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}.","NUMBER_REQUIRED":"Se requiere el número","PASSWORD_REQUIRED":"Se requiere la contraseña","PASSWORD_MAX_LENGTH":"La contraseña debe tener hasta 40 caracteres","PASSWORDS_DIDNT_MATCH":"Las contraseñas no coinciden, escriba de nuevo.","PHONE_REQUIRED":"Se requiere el teléfono","RELOAD":"No se ha podido actualizar la lista de empleados","START_BREAK_TIME_REQUIRED":"Se requiere el inicio del horario de almuerzo","START_DATE_REQUIRED":"Se requiere la contratación","START_TIME_REQUIRED":"Se requiere la hora de entrada","START_TIME_INVALID":"La hora de entrada no es válida","STATE_REQUIRED":"Se requiere el estado","STREET_REQUIRED":"Se requiere la dirección de la calle","ZIPCODE_REQUIRED":"Se requiere el código postal","TIME_FORMAT_REQUIRED":"Se requiere el formato de tiempo","DEPARTURE_TIME_IS_LESS_THAN_ARRIVAL_TIME":"El tiempo de salida debe ser mayor que el tiempo de llegada","START_TIME_IS_GREATER_THAN_12_HOURS":"El tiempo de llegada debe ser menor o igual a 12 horas","START_TIME_IS_MINOR_THAN_1_HOUR":"El tiempo de llegada debe ser mayor a 1 hora","END_TIME_IS_GREATER_THAN_12_HOURS":"El tiempo de salida debe ser menor o igual a 12 horas","END_TIME_IS_MINOR_THAN_1_HOUR":"El tiempo de salida debe ser mayor a 1 hora","GROUP_REQUIRED":"Se requiere el grupo"}},"TABLE":{"NAME":"Nombre","DOCUMENT_NUMBER":"Documento","ACTIVATED":"Dentro del período de contratación","DEACTIVATED":"Fuera del período de contratación","HIRED_AT":"Fecha de ingreso","FIRED_AT":"Fecha de despido","WORKSCHEDULE_START":"Hora de entrada","WORKSCHEDULE_END":"Hora de salida","ACTIONS":"Acciones","CHANGE_PASSWORD":"Edite la contraseña del empleado","ADD_CREDENTIALS":"¡Empleado sin nombre de usuario y contraseña!","EDIT":"Editar","CREATE_EMPLOYEE_CTA":"Puede crear un nuevo empleado","CREATE_EMPLOYEE_LINK":"haciendo clic aquí","ROWS":{"EMAIL":{"VERIFIED":"Verificado el: {{ validatedAt }}","UNVERIFIED":"Inconfirmado"}}},"DIALOG":{"CLOSE":"Cerrar","HINT":"Necesita usar una contraseña lo suficientemente segura. La contraseña debe contener al menos 8 caracteres e incluir letras, números y símbolos.","FOR_EXAMPLE":"Por ejemplo:","NEW":{"TITLE":"Nuevo empleado"},"EDIT":{"TITLE":"Editar empleado"},"GENERAL":{"TITLE":"General","EMPLOYEE_DATA":"Datos del empleado","AND":"y","ACTIVE":"Activo","INACTIVE":"Inactivo","CLEAR_ADDRESS":"Limpiar la dirección del empleado","ENTER_ADDRESS":"Ingrese la dirección del empleado en el campo de arriba","ADDRESS_EXAMPLE":"Busque una dirección, ejemplo: Rua dos Pinheiros, 383 - São Paulo","SELECT_DATE":"Seleccionar fecha","ACCESS_DATA":"Datos de acceso"},"ERRORS":{"TEMP_PASSWORD":"Contraseña temporal no utilizada. Por favor, renueve la contraseña para que el colaborador pueda utilizarla."},"SKILLS":{"TITLE":"Habilidades","RESPONSIBILITIES":"Tipos de OS realizadas","SELECT_ALL":"Seleccionar todo"},"IMAGE":{"TITLE":"Foto","SEND_PICTURE":"Subir imagen","SELECT_OR_DRAG_PHOTO":"Haga clic o arrastra su imagen para subir","CROP_IMAGE":"Para recortar esta imagen, arrastre la región a continuación y haga clic en el botón:"},"ACTIONS":{"CREATE":"Crear","SAVE":"Guardar","FIRE_EMPLOYEE":"Demitir empleado","REHIRE_EMPLOYEE":"Recontratar empleado","UPLOAD_AVATAR":"Cambiar foto","CHANGE_TEMP_PASSWORD":"Renovar contraseña","CREATE_CREDENTIALS":"Gerar Credencial"},"CREDENTIALS":{"TITLE":"Agregue correo electrónico y contraseña para el empleado <strong>{{ name }}</strong>","AGREE_TERMS":"Acepto que después de registrar estos datos, serán obligatorios para que <strong>{{ name }}</strong> acceda a la aplicación."},"PASSWORD":{"TITLE":"Cambia la contraseña"},"INACTIVATE":{"TITLE":"Desactivar Colaborador","WARNING":"¿Está seguro de que desea desactivar a este colaborador?","INSTRUCTION":"Para continuar, escriba: <b>{{ firstName }}</b>","TYPE_IT":"Escriba {{ firstName }}","CANCEL":"No","SUBMIT":"Sí","ALERT":{"TITLE":"¿Desactivar Colaborador?","TEXT_CONTENT":"Después de desactivación, el colaborador \'{{ username }}\' no tendrá acceso al sistema hasta que se reactive. ¿Desea continuar?","OK":"Sí, quiero","CANCEL":"Mejor no"},"TOOLTIP":"Desactivar"},"ACTIVATE":{"TITLE":"Activar Colaborador","WARNING":"¿Está seguro de que desea activar a este colaborador?","INSTRUCTION":"Para continuar, escriba: <b>{{ firstName }}</b>","TYPE_IT":"Escriba {{ firstName }}","CANCEL":"No","SUBMIT":"Sí","ALERT":{"TITLE":"¿Activar Colaborador?","TEXT_CONTENT":"Después de activación, el colaborador \'{{ username }}\' tendrá acceso al sistema hasta que se desactive nuevamente. ¿Desea continuar?","OK":"Sí, quiero","CANCEL":"Mejor no"},"TOOLTIP":"Activar"},"EMPLOYEE_CREATED_DIALOG":{"TITLE":"¡Empleado creado con éxito!","MESSAGE":"Se ha creado un nuevo empleado con éxito. Recibirá una contraseña temporal por correo electrónico, que deberá utilizar para iniciar sesión por primera vez en la aplicación. Al acceder por primera vez, se le pedirá al empleado que cree una nueva contraseña permanente.","OK":"Continuar"},"DELETE_DEVICES":{"TITLE":"Eliminar dispositivos","WARNING":"¿Está seguro de que desea eliminar todos los dispositivos vinculados a este colaborador?","CANCEL":"No","SUBMIT":"Sí","TOOLTIP":"Eliminar dispositivos"}},"TOAST":{"SAVED":"Colaborador \'{{ name }}\' guardado con éxito.","PASSWORD_CHANGED":"Contraseña del colaborador \'{{ name }}\' actualizada con éxito.","EMPLOYEE_SUCCESSFULLY_INACTIVATED":"Colaborador desactivado con éxito.","INACTIVATE_EMPLOYEE_FAILED":"No se pudo desactivar al colaborador \'{{ username }}\', inténtelo nuevamente.","EMPLOYEE_SUCCESSFULLY_ACTIVATED":"Colaborador activado con éxito.","ACTIVATE_EMPLOYEE_FAILED_EMAIL":"No se pudo activar al colaborador \'{{ username }}\', porque este correo electrónico ya está en uso.","ACTIVATE_EMPLOYEE_FAILED":"No se pudo activar al colaborador \'{{ username }}\', inténtelo nuevamente.","ALREADY_USED_PASSWORD":"Esta contraseña ya fue utilizada recientemente, ingrese una contraseña diferente.","UNEXPECTED_ERROR":"Ocurrió un error inesperado, inténtelo nuevamente más tarde.","CREDENTIALS_ADDED":"Email y contraseña para \'{{ name }}\' agregados con éxito.","GENERATE_PASSWORD_ERROR":"Erro ao gerar senha temporária","GENERATE_CREDENTIAL_ERROR":"Error al generar credencial","DEVICES_DELETED":"Todos los dispositivos del colaborador fueron eliminados con éxito.","DELETE_DEVICES_FAILED":"No se pudieron eliminar los dispositivos del colaborador."},"EXPORT":{"TITLE":"¡Empleados exportados con éxito!","ERROR":"No se pudo exportar a los empleados, intente nuevamente más tarde."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/employees/i18n/pt.json',
    '{"EMPLOYEES":{"PAGE_TITLE":"Colaboradores","TITLE":"Colaboradores","SEARCH":"Pesquisar","DESCRIPTION":"Colaboradores são os profissionais que trabalham externamente.","NEW":"Adicionar colaborador","RELOAD":"Atualizar","CLEAR_FILTERS":"Limpar filtros","FILTER":"Filtrar Colaboradores","FILTERS":{"TITLE":"Filtrar Colaboradores","CLEAR":"Limpar filtros","NAME":"Pesquisar por nome","SITUATIONS":{"TITLE":"Filtrar por situação","ALL":"Todos","ACTIVE":"Ativos","INACTIVE":"Inativos","FIRED":"Demitidos","HIRED":"Contratados"}},"TOOLTIP":{"EXPORT_TO_EXCEL":"Exportar para Excel"},"PRO":{"ACTIVE_COUNT":"{{ countActiveEmployees }} de {{ planLicenses }} colaboradores habilitados","ACTIVE_PERCENTAGE":"Você está usando <strong>{{ activeEmployeesPercentage }}%</strong> do limite de licenças contratadas."},"MODEL":{"NAME":"Nome","DOCUMENT":{"LABEL":"CPF/CNPJ","INVALID_CPF":"CPF inválido","INVALID_CNPJ":"CNPJ inválido","EXISTS":"Documento já existe"},"NOTES":"Observações","PHONE_NUMBER":"Identificador do celular","START_DATE":"Data de admissão","END_DATE":"Data de demissão","EMAIL":"E-mail","NO_EMAIL":"Sem e-mail","GEOLOCATION":"Geolocalização","GEOLOCATION_ENABLED":"Ativa","GEOLOCATION_DISABLED":"Desativada","PHONE":"Telefone","ZIPCODE":"CEP","STREET":"Logradouro","NUMBER":"Número","CITY":"Cidade","STATE":"Estado","START_TIME":"Horário entrada","END_TIME":"Horário saída","START_BREAK_TIME":"Início almoço","END_BREAK_TIME":"Termino almoço","EMPLOYEE_ADDRESS":"Endereço do colaborador","DISTANCE_AWAY":"km de distância","PASSWORD":"Senha","CONFIRM_PASSWORD":"Confirmação de senha","GROUPS":"Grupos","ERRORS":{"ALREADY_USED_PASSWORD":"Essa senha já foi utilizada por você a pouco tempo, insira uma senha diferente.","ADDRESS_NOT_FOUND":"Não foi possível encontrar o endereço, altere sua busca e tente novamente.","ADDRESS_NUMBER_NOT_SPECIFIED":"O número do endereço não foi especificado.","CITY_REQUIRED":"Cidade é obrigatório","DEVICE_ALREADY_TAKEN":"Este celular já está registrado para outro colaborador.","EMAIL_ALREADY_TAKEN":"Este e-mail já está em uso para outro colaborador.","EMAIL_PATTERN":"E-mail em formato inválido","EMAIL_PATTERN_AFTER_CREATED":"Email com formato inválido, por favor entre em contato com seu gerente de contas","EMAIL_REQUIRED":"E-mail é obrigatório","EMPLOYEE_ADDRESS_REQUIRED":"Endereço do colaborador é obrigatório","END_BREAK_TIME_REQUIRED":"Termino almoço é obrigatório","END_TIME_REQUIRED":"Horário de saída é obrigatório","END_TIME_INVALID":"Horário de saída é inválido","NAME_REQUIRED":"Nome é obrigatório","NAME_VALID_LENGTH":"Tamanho do nome é invalido por ser maior que {{ length }}","DOCUMENT_NUMBER_VALID_LENGTH":"Tamanho do documento é invalido por ser maior que {{ length }}","NOTE_VALID_LENGTH":"Este campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }} caracteres.","NUMBER_REQUIRED":"Número é obrigatório","PASSWORD_REQUIRED":"Senha é obrigatória","PASSWORD_MAX_LENGTH":"A senha deve ter até 40 caracteres","PASSWORDS_DIDNT_MATCH":"Senhas não coincidem, digite novamente.","PHONE_REQUIRED":"Telefone é obrigatório","RELOAD":"Não foi possível atualizar a lista de colaboradores","START_BREAK_TIME_REQUIRED":"Início almoço é obrigatório","START_DATE_REQUIRED":"Início de contratação é obrigatório","START_TIME_REQUIRED":"Horário de entrada é obrigatório","START_TIME_INVALID":"Horário de entrada é inválido","STATE_REQUIRED":"Estado é obrigatório","STREET_REQUIRED":"Logradouro é obrigatório","ZIPCODE_REQUIRED":"CEP é obrigatório","TIME_FORMAT_REQUIRED":"Formato de hora é obrigatório","DEPARTURE_TIME_IS_LESS_THAN_ARRIVAL_TIME":"O horário de partida deve ser maior que o horário de chegada","START_TIME_IS_GREATER_THAN_12_HOURS":"O horário de chegada deve ser menor ou igual a 12 horas","START_TIME_IS_MINOR_THAN_1_HOUR":"O horário de chegada deve ser maior que 1 hora","END_TIME_IS_GREATER_THAN_12_HOURS":"O horário de partida deve ser menor ou igual a 12 horas","END_TIME_IS_MINOR_THAN_1_HOUR":"O horário de partida deve ser maior que 1 hora","GROUP_REQUIRED":"Grupo é obrigatório"}},"TABLE":{"NAME":"Nome","DOCUMENT_NUMBER":"CPF/CNPJ","ACTIVATED":"Dentro do período de contratação","DEACTIVATED":"Fora do período de contratação","HIRED_AT":"Data admissão","FIRED_AT":"Data demissão","WORKSCHEDULE_START":"Horário de entrada","WORKSCHEDULE_END":"Horário de saída","ACTIONS":"Ações","CHANGE_PASSWORD":"Editar a senha do colaborador","ADD_CREDENTIALS":"Colaborador sem usuário e senha!","EDIT":"Editar","CREATE_EMPLOYEE_CTA":"Você pode criar um novo colaborador","CREATE_EMPLOYEE_LINK":"clicando aqui","ROWS":{"EMAIL":{"VERIFIED":"Verificado em: {{ validatedAt }}","UNVERIFIED":"Não verificado"}}},"DIALOG":{"CLOSE":"Fechar","HINT":"Você precisa usar uma senha suficientemente forte. A senha deve conter no mínimo 8 caracteres e que inclua letras, números e símbolos.","FOR_EXAMPLE":"Por exemplo:","NEW":{"TITLE":"Novo colaborador"},"EDIT":{"TITLE":"Editar colaborador"},"GENERAL":{"TITLE":"Geral","EMPLOYEE_DATA":"Dados do colaborador","AND":"e","ACTIVE":"Ativo","INACTIVE":"Inativo","CLEAR_ADDRESS":"Limpar endereço do colaborador","ENTER_ADDRESS":"Informe o endereço do colaborador no campo acima","ADDRESS_EXAMPLE":"Procure por um endereço, exemplo: Rua dos Pinheiros, 383 - São Paulo","SELECT_DATE":"Selecionar data","ACCESS_DATA":"Dados de acesso"},"ERRORS":{"TEMP_PASSWORD":"Senha temporária não utilizada. Por favor, renove a senha para que o colaborador possa utilizá-la."},"SKILLS":{"TITLE":"Habilidades","RESPONSIBILITIES":"Tipos de OS realizadas","SELECT_ALL":"Selecionar todos"},"IMAGE":{"TITLE":"Foto","SEND_PICTURE":"Enviar imagem","SELECT_OR_DRAG_PHOTO":"Clique ou arraste sua imagem para fazer upload","CROP_IMAGE":"Para cortar essa imagem, arraste a região abaixo e clique no botão:"},"ACTIONS":{"CREATE":"Criar","SAVE":"Salvar","FIRE_EMPLOYEE":"Demitir colaborador","REHIRE_EMPLOYEE":"Recontratar colaborador","UPLOAD_AVATAR":"Alterar foto","CHANGE_TEMP_PASSWORD":"Renovar senha","CREATE_CREDENTIALS":"Criar Credencial"},"CREDENTIALS":{"TITLE":"Adicionar e-mail e senha para o colaborador <strong>{{ name }}</strong>","AGREE_TERMS":"Estou de acordo que após o cadastro destes dados, eles serão obrigatórios para o acesso do <strong>{{ name }}</strong> no aplicativo."},"PASSWORD":{"TITLE":"Mudar senha"},"INACTIVATE":{"TITLE":"Inativar colaborador","WARNING":"Tem certeza que deseja inativar este colaborador?","INSTRUCTION":"Para continuar, digite: <b>{{ firstName }}</b>","TYPE_IT":"Digite {{ firstName }}","CANCEL":"Não","SUBMIT":"Sim","ALERT":{"TITLE":"Inativar colaborador?","TEXT_CONTENT":"Depois de inativado, o colaborador \'{{ username }}\' não terá acesso ao sistema até ser ativado novamente. Quer continuar?","OK":"Sim, eu quero","CANCEL":"Melhor não"},"TOOLTIP":"Inativar"},"ACTIVATE":{"TITLE":"Ativar colaborador","WARNING":"Tem certeza que deseja ativar este colaborador?","INSTRUCTION":"Para continuar, digite: <b>{{ firstName }}</b>","TYPE_IT":"Digite {{ firstName }}","CANCEL":"Não","SUBMIT":"Sim","ALERT":{"TITLE":"Ativar colaborador?","TEXT_CONTENT":"Depois de ativado, o colaborador \'{{ username }}\' terá acesso ao sistema até ser inativado novamente. Quer continuar?","OK":"Sim, eu quero","CANCEL":"Melhor não"},"TOOLTIP":"Ativar"},"EMPLOYEE_CREATED_DIALOG":{"TITLE":"Colaborador criado com sucesso!","MESSAGE":"Um novo colaborador foi criado com sucesso. Ele receberá uma senha temporária por e-mail, que deverá ser utilizada para fazer o primeiro login no aplicativo. Ao acessar pela primeira vez, o colaborador será solicitado a criar uma nova senha permanente.","OK":"Continuar"},"DELETE_DEVICES":{"TITLE":"Excluir dispositivos","WARNING":"Tem certeza que deseja excluir todos os dispositivos vinculados a este colaborador?","CANCEL":"Não","SUBMIT":"Sim","TOOLTIP":"Excluir dispositivos"}},"TOAST":{"SAVED":"Colaborador \'{{ name }}\' salvo com sucesso.","PASSWORD_CHANGED":"Senha do colaborador \'{{ name }}\' atualizada com sucesso.","EMPLOYEE_SUCCESSFULLY_INACTIVATED":"Colaborador inativado com sucesso.","INACTIVATE_EMPLOYEE_FAILED":"Não foi possível inativar o colaborador \'{{ username }}\', tente novamente.","EMPLOYEE_SUCCESSFULLY_ACTIVATED":"Colaborador ativado com sucesso.","ACTIVATE_EMPLOYEE_FAILED_EMAIL":"Não foi possível ativar o colaborador \'{{ username }}\', pois este e-mail está em uso.","ACTIVATE_EMPLOYEE_FAILED":"Não foi possível ativar o colaborador \'{{ username }}\', tente novamente.","ALREADY_USED_PASSWORD":"Essa senha já foi utilizada por você a pouco tempo, insira uma senha diferente.","UNEXPECTED_ERROR":"Ocorreu um erro inesperado, tente novamente mais tarde.","CREDENTIALS_ADDED":"Email e senha do \'{{ name }}\' adicionados com sucesso.","GENERATE_PASSWORD_ERROR":"Erro ao gerar senha temporária","GENERATE_CREDENTIAL_ERROR":"Erro ao gerar credencial","DEVICES_DELETED":"Todos os dispositivos do colaborador foram removidos com sucesso.","DELETE_DEVICES_FAILED":"Não foi possível excluir os dispositivos do colaborador."},"EXPORT":{"TITLE":"Colaboradores exportados com sucesso!","ERROR":"Não foi possível exportar os colaboradores, tente novamente mais tarde."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/equipment-types/i18n/en.json',
    '{"EQUIPMENT_TYPES":{"PAGE_TITLE":"Equipment Types","TITLE":"Equipment Types","TUTORIAL_VIDEO":{"TITLE":"Instructions","TOOLTIP":"Watch explanatory video"},"DESCRIPTION":"Equipment types define a model with specific properties.","SEARCH":"Search","NEW":"Add equipment type","RELOAD":"Reload","FILTER":"Filter equipment types","FILTERS":{"TITLE":"Filter equipment types","CLEAR":"Clear filters","NAME":"Search by name","SITUATIONS":{"TITLE":"Filter by situation","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"}},"MODEL":{"ACTIVED":"Active","ARCHIVED":"Archived","NAME":"Name *","CREATED_AT":"Created at","QR_CODE":"QR code","CHARACTERS_REMAINING":"Characters remaining: {{ remains }}","CONFIGURATIONS":"Configurations","SHOW_KNOWLEDGE_BASE":"If enabled, the knowledge base related to this equipment type will be displayed.","KNOWLEDGE_BASE":"Knowledge Base","SEARCH":"Search knowledge base...","ERRORS":{"NAME_REQUIRED":"Name is required","FIELD_REQUIRED":"Field is required","NAME_VALID_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but has {{ receivedLength }} characters.","FIELD_VALID_LENGTH":"Field length is invalid"}},"TABLE":{"ACTIONS":"Actions","EDIT":"Edit","VIEW":"View","EDIT_LOCKED":"You do not have permission to edit this equipment type"},"DIALOG":{"NEW":{"TITLE":"New Equipment type"},"EDIT":{"TITLE":"Edit {{ equipmentType }}"},"GENERAL":{"TITLE":"General"},"CUSTOM_FIELDS":{"TITLE":"Custom Fields","FIELD":"Field","REQUIRED_ANSWER":"Required answer","OPTIONAL_ANSWER":"Optional answer","FIELD_TYPES":{"TITLE":"Field type","ADD":"Add another field","REMOVE":"Remove field","LONG_ANSWER":"Long answer","DATE":"Date","MULTIPLE_CHOICE":"Multiple choice","NUMBER":"Numeric"},"ALTERNATIVE_NEEDED":"At least one answer alternative is required","CHANGE_ORDER":"Drag to change the order of the alternative","ALTERNATIVE_TEXT":"Alternative answer text...","REMOVE_ALTERNATIVE":"Remove alternative answer","ADD_QUESTION":"Add new answer option","ARROW":{"UP":"Move up","DOWN":"Move down"},"INFO":"By changing the question or type of response, we will unlink the assigned response from this custom field and all related locations."},"FORMS":{"TITLE":"Forms","SEARCH":"Search form...","ALL_FORMS_ADDED":"All forms already added","ADD":"Add form","REMOVE":"Remove form","EMPTY":"No form added for this equipment type","QUESTIONS_QTY":"({{ questionsQty }} questions)","REQUIRED_TO_COMPLETE":"Required to answer to complete visit","REQUIRED_TO_IMPEDIMENT":"Required to answer to register impediment","OPTION":"Option","QUESTION":"Question","SERVICE":{"LABEL":"OS type","PLACEHOLDER":"Select a OS type","SEARCH":"Search OS type...","ALL":"All","ERROR":{"ALL_SERVICES":"It is not possible to select all OS types for the same form.","SAME_SERVICE":"You cannot select the same type of activity for two identical forms."}}},"ACTIONS":{"SAVE":"Save","CLOSE":"Close","CREATE":"Create","ARCHIVE":"Archive equipment type","UNARCHIVE":"Unarchive equipment type"}},"TOAST":{"SAVED":"Equipment type saved.","SAVE_FAILED":"Something went wrong, please check the custom fields.","ARCHIVED":"Equipment type successfully archived.","UNARCHIVED":"Equipment type successfully unarchived."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/equipment-types/i18n/es.json',
    '{"EQUIPMENT_TYPES":{"PAGE_TITLE":"Tipos de Equipos","TITLE":"Tipos de Equipos","TUTORIAL_VIDEO":{"TITLE":"Instrucciones","TOOLTIP":"Ver video explicativo"},"DESCRIPTION":"Los tipos de equipos definen un modelo de equipo con propiedades personalizadas.","SEARCH":"Buscar","NEW":"Agregar tipo de equipo","RELOAD":"Recargar","FILTER":"Filtrar tipos de equipos","FILTERS":{"TITLE":"Filtrar tipos de equipos","CLEAR":"Limpiar filtros","NAME":"Buscar por nombre","SITUATIONS":{"TITLE":"Filtrar por situación","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"}},"MODEL":{"ACTIVED":"Activos","ARCHIVED":"Archivados","NAME":"Nombre *","CREATED_AT":"Creado en","QR_CODE":"Código QR","CHARACTERS_REMAINING":"Caracteres restantes: {{ remains }}","CONFIGURATIONS":"Configuraciones","SHOW_KNOWLEDGE_BASE":"Si está activado, la base de conocimientos relacionada con este tipo de equipo se mostrará.","KNOWLEDGE_BASE":"Base de conocimientos","SEARCH":"Buscar base de conocimientos...","ERRORS":{"NAME_REQUIRED":"El nombre es obligatorio","FIELD_REQUIRED":"El campo es obligatorio","NAME_VALID_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }} caracteres.","FIELD_VALID_LENGTH":"La longitud del campo es inválida"}},"TABLE":{"ACTIONS":"Acciones","EDIT":"Editar","VIEW":"Ver","EDIT_LOCKED":"No tiene permiso para editar este tipo de equipo"},"DIALOG":{"NEW":{"TITLE":"Nuevo tipo de equipo"},"EDIT":{"TITLE":"Editar {{ equipmentType }}"},"GENERAL":{"TITLE":"General"},"CUSTOM_FIELDS":{"TITLE":"Campos Personalizados","FIELD":"Campo","REQUIRED_ANSWER":"Respuesta obligatoria","OPTIONAL_ANSWER":"Respuesta opcional","FIELD_TYPES":{"TITLE":"Tipo de campo","ADD":"Agregar otro campo","REMOVE":"Eliminar campo","LONG_ANSWER":"Respuesta larga","DATE":"Fecha","MULTIPLE_CHOICE":"Selección múltiple","NUMBER":"Numérico"},"ALTERNATIVE_NEEDED":"Se requiere al menos una alternativa de respuesta","CHANGE_ORDER":"Arrastre para cambiar el orden de la alternativa","ALTERNATIVE_TEXT":"Texto de la alternativa de respuesta...","REMOVE_ALTERNATIVE":"Eliminar alternativa de respuesta","ADD_QUESTION":"Agregar nueva opción de respuesta","ARROW":{"UP":"Mover hacia arriba","DOWN":"Mover hacia abajo"},"INFO":"Al cambiar la pregunta o el tipo de respuesta, desvincularemos la respuesta asignada de este campo personalizado y de todos los lugares relacionados."},"FORMS":{"TITLE":"Formularios","SEARCH":"Buscar formulario...","ALL_FORMS_ADDED":"Todos los formularios ya están agregados","ADD":"Agregar formulario","REMOVE":"Eliminar formulario","EMPTY":"Ningún formulario agregado para este tipo de equipo","QUESTIONS_QTY":"({{ questionsQty }} preguntas)","REQUIRED_TO_COMPLETE":"Requerido para responder y completar visita","REQUIRED_TO_IMPEDIMENT":"Requerido para responder y registrar impedimento","OPTION":"Opción","QUESTION":"Pregunta","SERVICE":{"LABEL":"Tipo de OS","PLACEHOLDER":"Seleccione un tipo de OS","SEARCH":"Buscar tipo de OS...","ALL":"Todos","ERROR":{"ALL_SERVICES":"No es posible seleccionar todos los tipos de OS para el mismo formulario.","SAME_SERVICE":"No es posible repetir un tipo de OS para el mismo formulario."}}},"ACTIONS":{"SAVE":"Guardar","CLOSE":"Cerrar","CREATE":"Crear","ARCHIVE":"Archivar tipo de equipo","UNARCHIVE":"Desarchivar tipo de equipo"}},"TOAST":{"SAVED":"Tipo de equipo guardado exitosamente.","SAVE_FAILED":"Algo salió mal, por favor revise los campos personalizados.","ARCHIVED":"Tipo de equipo archivado exitosamente.","UNARCHIVED":"Tipo de equipo desarchivado exitosamente."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/equipment-types/i18n/pt.json',
    '{"EQUIPMENT_TYPES":{"PAGE_TITLE":"Tipos de Equipamentos","TITLE":"Tipos de Equipamentos","TUTORIAL_VIDEO":{"TITLE":"Instruções","TOOLTIP":"Assistir vídeo explicativo"},"DESCRIPTION":"Tipos de equipamentos definem um modelo de equipamento com propriedades personalizadas.","SEARCH":"Pesquisar","NEW":"Adicionar tipo de equipamento","RELOAD":"Atualizar","FILTER":"Filtrar tipos de equipamentos","FILTERS":{"TITLE":"Filtrar Tipos de Equipamentos","CLEAR":"Limpar filtros","NAME":"Pesquisar por nome","SITUATIONS":{"TITLE":"Filtrar por situação","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"}},"MODEL":{"ACTIVED":"Ativos","ARCHIVED":"Arquivados","NAME":"Nome *","CREATED_AT":"Criado em","QR_CODE":"QR code","CHARACTERS_REMAINING":"Caracteres restantes: {{ remains }}","CONFIGURATIONS":"Configurações","SHOW_KNOWLEDGE_BASE":"Se ativado, a base de conhecimento relacionada a este tipo de equipamento será exibida.","KNOWLEDGE_BASE":"Base de conhecimento","SEARCH":"Pesquisar base de conhecimento...","ERRORS":{"NAME_REQUIRED":"Nome é obrigatório","FIELD_REQUIRED":"Campo é obrigatório","NAME_VALID_LENGTH":"Este campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }} caracteres.","FIELD_VALID_LENGTH":"Tamanho do campo é inválido"}},"TABLE":{"ACTIONS":"Ações","EDIT":"Editar","VIEW":"Visualizar","EDIT_LOCKED":"Você não tem permissão para editar esse tipo de equipamento"},"DIALOG":{"NEW":{"TITLE":"Novo Tipo de Equipamento"},"EDIT":{"TITLE":"Editar {{ equipmentType }}"},"GENERAL":{"TITLE":"Geral"},"CUSTOM_FIELDS":{"TITLE":"Campos Personalizados","FIELD":"Campo","REQUIRED_ANSWER":"Resposta obrigatória","OPTIONAL_ANSWER":"Resposta não obrigatória","FIELD_TYPES":{"TITLE":"Tipo de campo","ADD":"Adicionar mais um campo","REMOVE":"Remover campo","LONG_ANSWER":"Resposta longa","DATE":"Data","MULTIPLE_CHOICE":"Múltipla escolha","NUMBER":"Numérico"},"ALTERNATIVE_NEEDED":"É necessário ao menos uma alternativa de resposta","CHANGE_ORDER":"Arraste para trocar a ordem da alternativa","ALTERNATIVE_TEXT":"Texto da alternativa de resposta...","REMOVE_ALTERNATIVE":"Remover alternativa de resposta","ADD_QUESTION":"Adicionar nova opção de resposta","ARROW":{"UP":"Mover para cima","DOWN":"Mover para baixo"},"INFO":"Ao alterar a pergunta ou tipo de resposta, desvincularemos a resposta atribuída deste campo personalizado e de todos os locais relacionados."},"FORMS":{"TITLE":"Formulários","SEARCH":"Pesquisar formulário...","ALL_FORMS_ADDED":"Todos formulários já estão adicionados","ADD":"Adicionar formulário","REMOVE":"Remover formulário","EMPTY":"Nenhum formulário adicionado para o tipo de equipamento","QUESTIONS_QTY":"({{ questionsQty }} perguntas)","REQUIRED_TO_COMPLETE":"Obrigatório responder para concluir visita","REQUIRED_TO_IMPEDIMENT":"Obrigatório responder para registrar impedimento","OPTION":"Opção","QUESTION":"Pergunta","SERVICE":{"LABEL":"Tipo de OS","PLACEHOLDER":"Selecione um tipo de OS","SEARCH":"Pesquisar tipo de OS...","ALL":"Todos","ERROR":{"ALL_SERVICES":"Não é possível selecionar todos os tipos de OS para o mesmo formulário.","SAME_SERVICE":"Não é possível repetir um tipo de OS para o mesmo formulário."}}},"ACTIONS":{"SAVE":"Salvar","CLOSE":"Fechar","CREATE":"Criar","ARCHIVE":"Arquivar tipo de equipamento","UNARCHIVE":"Desarquivar tipo de equipamento"}},"TOAST":{"SAVED":"Tipo de equipamento salvo com sucesso.","SAVE_FAILED":"Aconteceu algo de errado, favor verificar os campos personalizados.","ARCHIVED":"Tipo de equipamento arquivado com sucesso.","UNARCHIVED":"Tipo de equipamento desarquivado com sucesso."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/equipments/i18n/en.json',
    '{"EQUIPMENTS":{"PAGE_TITLE":"Equipments","TITLE":"Equipments","NEW":"New equipment","GENERATE_QR_CODE":"Generate QR Code","SEARCH":"Search","EXPORT_EXCEL":"Export to Excel","RELOAD":"Reload","FILTER":"Filter equipment","FEEDBACK_FORM":"Your perspective is crucial for evaluating the development of a new equipment rental feature! Share your experience with us:","FILTERS":{"TITLE":"Filter Equipment","CLEAR":"Clear filters","NAME":"Search by name","MODEL_NAME":"Search by model name","CUSTOMER":{"TITLE":"Filter by customer","SEARCH":"Search by customer","SELECT":"Select a customer","INACTIVE":"INACTIVE"},"LOCATION":{"TITLE":"Filter by location","SEARCH":"Search by location","SELECT":"Select a location"},"NUMBER":"Search by serial number","SITUATIONS":{"TITLE":"Filter by situation","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"},"TYPE":{"TITLE":"Filter by equipment type","ALL":"All"},"FILTER_BY_LABEL":{"LABEL":"Filter by tags","NO_LABEL":"Without tag"},"BY_TERRITORY":{"LABEL":"Filter by territory","SEARCH":"Search territory","SEARCH_LABEL":"Select territory"},"BY_SUBTERRITORY":{"LABEL":"Filter by subterritory","SEARCH":"Search subterritory","SEARCH_LABEL":"Select subterritory"},"WARRANTY":{"LABEL":"Filter by warranty","WARRANTY_FROM":"Warranty from","WARRANTY_UNTIL":"Warranty until","SELECT_DATE":"Select date","STATUS":"Status","ALL":"All","ACTIVE":"Active","EXPIRED":"Expired","EXTENDED":"Extended","FUTURE":"Future","NO_WARRANTY":"No warranties"}},"MODEL":{"NAME":"Model name","NUMBER":"Serial number","CREATED_AT":"Created on","EQUIPMENT_TYPE":"Equipment type","SECTOR":"Sector","SEARCH_BY_SECTOR":"Search by sector","ENVIRONMENT":"Environment","SEARCH_BY_ENVIRONMENT":"Search by environment","CUSTOMER":"Customer","LOCATION":"Location","ACTIVE":"Active","ARCHIVED":"Archived","EMPTY":"None","WARRANTY_START_DATE":"Warranty start date","WARRANTY_END_DATE":"Warranty end date","WARRANTY_STATUS":{"TITLE":"Status","ACTIVE":"Active","EXPIRED":"Expired","EXTENDED":"Extended","FUTURE":"Future","NO_WARRANTY":"No status"},"QR_CODE":{"DOWNLOAD_LINK_MESSAGE":"view QR code","GENERATE":"Generate QR code"},"ERRORS":{"NAME_REQUIRED":"Name required","NOTES_MAX_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but it has {{ receivedLength }}.","FIELD_REQUIRED":"Required field.","NUMBER_REQUIRED":"Serial number required","NAME_INVALID_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but it has {{ receivedLength }}.","MAX_LENGTH_NUMBER":"Serial number must have a maximum of 100 characters","DUPLICATED_NUMBER":"Serial number already registered to another equipment","DUPLICATED_NUMBER_ARCHIVED":"Serial number already registered to another equipment (Archived)","EQUIPMENT_TYPE_REQUIRED":"Equipment type required","CUSTOM_FIELD_REQUIRED":"Mandatory custom field, you need to fill it","CUSTOMER_REQUIRED":"Customer required","CUSTOMER_NOT_FOUND":"Customer not found","LOCATION_ENTER_VALUE":"Location should be selected","LOCATION_REQUIRED":"Location is mandatory","LOCATION_NOT_FOUND":"No location found","NO_LOCATIONS":{"TEXT":"This customer has no location yet.","LINK":"Click here to create a location in:"},"DISABLED_CREATE_EQUIPMENT":"It is not possible to register equipment for this customer\'s location.","DISABLED_CREATE_EQUIPMENT_CORPORATE":"It is not possible to register equipment for <b>{{ customerAccountName }}\'s</b> location."}},"TABLE":{"ACTIONS":"Actions","EDIT":"Edit","EDIT_LOCKED":"You are not allowed to edit this equipment"},"DIALOG":{"NEW":{"TITLE":"New Equipment"},"EDIT":{"TITLE":"Edit Equipment"},"GENERAL":{"TITLE":"General","HINT":"New fields added! You can now link equipment to a department and/or an environment. <span class=\'tw-font-medium tw-text-color-primary tw-cursor-pointer open-launch-video-dialog\'>Click here</span> to learn more!","INFO":"Add a main image and set the information for this equipment.","SELECT_EQUIPMENT_TYPE":"Select an equipment type","SELECT_IMAGES":"Select image","PHOTO_RULES":"The ideal image dimensions are 512px x 512px, with a maximum size of 2MB.","CLEAR_CUSTOMER":"Clear customer","CLEAR_LOCATION":"Clear location","NOTES":"Notes","ARCHIVED":" (Archived)"},"CUSTOM_FIELDS":{"TITLE":"Custom Fields","HINT":"The customized fields are configured in the type of equipment and are intended to standardize the registration of information.","SELECT":"Select","SELECT_DATE":"Select date","LABEL_SELECT":"Select you answer","LABEL_TEXT_AREA":"Type your answer","LABEL_NUMBER":"Type your numeric answer","LABEL_DATE_PICKER":"Put the date","EMPTY":"Select an equipment type to have custom fields displayed here.","INVALID":"This type of equipment has no custom fields.","ERRORS":{"DATE_INVALID":"scheduled date is invalid"}},"ATTACHMENTS":{"TITLE":"Attachments","ATTACHMENT_WARNING":"Limit of 20 attachments on the Manager Panel. The maximum size of each file is 10MB","DROP_HERE":"Drag your files to upload","INSERT_FILES_ALTERNATIVE":"Drag your files to upload or","ATTACHMENTS_LIMIT_REACHED":"Attachment limit was reached, to add more attachments you need to remove some of the files first.","INSERT_FILES":"Insert files","MAX_SIZE_FILES":"This file exceeds the 10MB limit","SEND_FILES":"Send files","UPLOAD":"Click or drag your images to upload","SEND":"Upload images","SAVE":"Save title","CANCEL":"Cancel","EDIT":"Edit name","CREATED_AT":"Added on {{ date }} at {{ time }}","VIEW_ORIGINAL":"View original","REMOVE":"Remove","ALERT":{"CONTENT":"Are you sure you want to <strong>delete</strong> the image?","YES":"Yes","NO":"No"},"NOT_SUPPORTED_FILE_DRAG":"Dragging files is not supported by your browser","EMPTY_STATE":"No attachments have been added for this equipment."},"QRCODE":{"TITLE":"QR Code","DOWNLOAD":"Download","PLACEHOLDER":"Click the button to generate QRCode","GENERATE_QRCODE":"Click here to generate the QR Code","VIEW_QRCODE":"View equipment\'s QR Code","GENERATE_QRCODE_MANDATORY":"Click here to generate the QR Code*","MODAL":{"GENERATE":"Generate QR Code","GENERATE_ANOTHER_CODE":"Generate another code","SAVE":"Save","DOWNLOAD":"Download","SAVED_SUCCESSFULLY":"QR Code altered, save the equipment to conclude the change."}},"SERVICES":{"TITLE":"Service","NO_HISTORY":"This location has no service history.","GO_TO_TASKS_LIST":"Go to activity list"},"HISTORIC":{"TITLE":"Historic","LOADING":"Processing...","TODAY":"Today","YESTERDAY":"Yesterday","NOT_FOUND":"This equipment has no historic yet.","LOGS":{"ARCHIVED":"Equipment <b>archived</b>.","CREATED":"Equipment <b>created</b>.","CHANGED":"Equipment <b>updated</b>.","UNARCHIVED":"Equipment <b>unarchived</b>.","CREATED_DESCRIPTION":"The equipment <b>{{ equipmentNumber }}</b> - <b>{{ equipmentName }}</b> has been created.","CREATED_BY":"Created by {{ userName }} {{ clientName }}","UPDATED_BY":"Updated by {{ userName }} {{ clientName }}","CLIENT":{"MORDOR":"via control panel.","ORC-2":"by employee app.","GOTHMOG-2":"by manager app.","CARCHOST":"via API.","SYSTEM":"via system."},"EVENT":{"REQUIRED_CHANGES_TITLE":"Required changed data.","PICTURE_CHANGED_TITLE":"Picture of equipment changed.","PICTURE_REMOVED_TITLE":"Picture of equipment removed.","NOTES_CHANGED_TITLE":"Changed notes:","EMPTY_NOTES":"<em>No notes.</em>","EMPTY_CUSTOM_FIELD":"<em>No answer.</em>","CUSTOM_FIELDS_ADDED_TITLE":"Custom fields with added answers:","CUSTOM_FIELDS_CHANGED_TITLE":"Custom fields with changed answers:","CUSTOM_FIELDS_DELETED_TITLE":"Custom fields with deleted answers:","ATTACHMENTS_ADDED_TITLE":"Attachments added:","ATTACHMENTS_DELETED_TITLE":"Attachments deleted:","CHANGED_NAME":"The equipment name has been changed from <b>{{ previous }}</b> to <b>{{ current }}</b>.","CHANGED_NUMBER":"The equipment number has been changed from <b>{{ previous }}</b> to <b>{{ current }}</b>.","CHANGED_TYPE":"The type of equipment has been changed from <b>{{ previous }}</b> to <b>{{ current }}</b>.","CHANGED_CUSTOMER":"The customer has been changed from <b>{{ previous }}</b> to <b>{{ current }}</b>.","CHANGED_LOCATION":"The location has been changed from <b>{{ previous }}</b> to <b>{{ current }}</b>.","CHANGED_LOCATION_SECTOR":"The sector has been changed from <b>{{ previous }}</b> to <b>{{ current }}</b>.","CHANGED_LOCATION_ENVIRONMENT":"The environment has been changed from <b>{{ previous }}</b> to <b>{{ current }}</b>.","CHANGED_QR_CODE":"The QR Code has been changed."}}},"WARRANTIES":{"TITLE":"Waranties"},"ACTIONS":{"SAVE":"Save","CREATE":"Create","ARCHIVE":"Archive","UNARCHIVE":"Unarchive"},"EQUIPMENT":{"LABEL":{"TITLE":"Tag","MANAGE":"Manage Tags","NO_REGISTERED":"No tags, only managers can create tags.","UPDATED":"The labels were successfully updated.","LIMIT_EXCEEDED":"Maximum tag limit was exceeded.","PLACEHOLDER":"Search tags ...","TOGGLE":"Toggle","EDIT":"Update","ADD":"Create new tag","BACK":"Back","NAME":"Name","CREATE_BUTTON":"Create","EDIT_LABEL":"Edit"}}},"ALERT":{"TITLE":"Equipment export","SUBTITLE":"Choose the way you want to export.","FIRST_CONTENT":"When you click export, you will receive a link to download the export in the email","SECOND_CONTENT":"Depending on the amount of equipment, the export may take a few minutes to complete","WITH_CUSTOM_FIELD":"With custom fields","WITHOUT_CUSTOM_FIELD":"Without custom fields","EXPORT_CONFIRMATION":"Do you want to continue with the export?","OK":"Yes","CANCEL":"No"},"TOAST":{"EXPORTED":"The spreadsheet will be sent to \'{{ email }}\' in a few minutes.","WAIT_PLANNING":"Please wait, automatic activity planning will start soon.","IMAGE_TITLE_CHANGED":"Attachment title changed.","IMAGE_DELETED":"The image has been removed!","EQUIPMENT_SAVED":"Equipment saved for \'{{ name }}\'.","IMAGES_SENDED":"images sent.","ERRORS":{"EQUIPMENT_IMAGE_UPLOAD":"Failed to save device image."}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/equipments/i18n/es.json',
    '{"EQUIPMENTS":{"PAGE_TITLE":"Equipamientos","TITLE":"Equipos","SEARCH":"Buscar","NEW":"Nuevo equipo","GENERATE_QR_CODE":"Generar código QR","EXPORT_EXCEL":"Exportar a Excel","RELOAD":"Actualizar","FILTER":"Filtrar equipamientos","FEEDBACK_FORM":"¡Tu perspectiva es fundamental para evaluar el desarrollo de una nueva funcionalidad de alquiler de equipos! Cuéntanos tu experiencia:","FILTERS":{"TITLE":"Filtrar equipamientos","CLEAR":"Limpiar filtros","NAME":"Buscar por nombre","MODEL_NAME":"Buscar por nombre de modelo","CUSTOMER":{"TITLE":"Filtrar por cliente","SEARCH":"Buscar por cliente","SELECT":"Seleccionar un cliente","INACTIVE":"INACTIVO"},"LOCATION":{"TITLE":"Filtrar por localidad","SEARCH":"Buscar por localizacion","SELECT":"Selecciona una localizacion"},"NUMBER":"Buscar por numero de serie","SITUATIONS":{"TITLE":"Filtrar por situación","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivado"},"TYPE":{"TITLE":"Filtrar por tipo de equipamiento","ALL":"Todos"},"FILTER_BY_LABEL":{"LABEL":"Filtrar por etiquetas","NO_LABEL":"Sin etiqueta"},"BY_TERRITORY":{"LABEL":"Filtrar por territorio","SEARCH":"Buscar territorio","SEARCH_LABEL":"Seleccione el territorio"},"BY_SUBTERRITORY":{"LABEL":"Filtrar por subterritorio","SEARCH":"Buscar subterritorio","SEARCH_LABEL":"Seleccione el subterritorio"},"WARRANTY":{"LABEL":"Filtrar por garantía","WARRANTY_FROM":"Garantía desde","WARRANTY_UNTIL":"Garantía hasta","SELECT_DATE":"Seleccionar fecha","STATUS":"Estado","ALL":"Todas","ACTIVE":"Activas","EXPIRED":"Expiradas","EXTENDED":"Extendidas","FUTURE":"Futuras","NO_WARRANTY":"Sin garantías"}},"MODEL":{"NAME":"Nombre del modelo","NUMBER":"Numero de serie","CREATED_AT":"Creado el","EQUIPMENT_TYPE":"Tipo de equipamiento","SECTOR":"Sector","SEARCH_BY_SECTOR":"Buscar sector","ENVIRONMENT":"Ambiente","SEARCH_BY_ENVIRONMENT":"Buscar ambiente","CUSTOMER":"Cliente","LOCATION":"Localización","ACTIVE":"Activo","ARCHIVED":"Archivado","EMPTY":"Ninguno","WARRANTY_START_DATE":"Inicio de la garantía","WARRANTY_END_DATE":"Fin de la garantía","WARRANTY_STATUS":{"TITLE":"Estado","ACTIVE":"Activa","EXPIRED":"Expirada","EXTENDED":"Extendida","FUTURE":"Futura","NO_WARRANTY":"Sin estado"},"QR_CODE":{"DOWNLOAD_LINK_MESSAGE":"Ver código QR","GENERATE":"Generar código QR"},"ERRORS":{"NAME_REQUIRED":"Se requiere el nombre","NOTES_MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}.","FIELD_REQUIRED":"Campo requerido.","NUMBER_REQUIRED":"Se requiere el número serial","NAME_INVALID_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}.","MAX_LENGTH_NUMBER":"El número serial debe tener um máximo de 100 caracteres","DUPLICATED_NUMBER":"El número serial ya está registrado en otro equipamiento","DUPLICATED_NUMBER_ARCHIVED":"El número serial ya está registrado en otro equipamiento (Archivado)","EQUIPMENT_TYPE_REQUIRED":"Se requiere el tipo de equipamiento","CUSTOM_FIELD_REQUIRED":"Campo personalizado obligatorio, debe completarlo","CUSTOMER_REQUIRED":"Se requiere el cliente","CUSTOMER_NOT_FOUND":"Cliente no encontrado","LOCATION_ENTER_VALUE":"Ubicación debe ser seleccionada","LOCATION_REQUIRED":"La ubicación es obligatoria","LOCATION_NOT_FOUND":"No se encuentra ninguna ubicación","NO_LOCATIONS":{"TEXT":"Este cliente todavía no tiene ubicación.","LINK":"Haga clic aquí para crear una ubicación en:"},"DISABLED_CREATE_EQUIPMENT":"No se puede registrar el equipo para la ubicación de este cliente.","DISABLED_CREATE_EQUIPMENT_CORPORATE":"No se puede registrar el equipo para la ubicación de <b>{{ customerAccountName }}</b>."}},"TABLE":{"ACTIONS":"Acciones","EDIT":"Editar","EDIT_LOCKED":"No tiene permiso para editar este equipamiento"},"DIALOG":{"NEW":{"TITLE":"Nuevo equipamiento"},"EDIT":{"TITLE":"Editar equipamiento"},"GENERAL":{"TITLE":"General","HINT":"¡Nuevos campos añadidos! Ahora puedes vincular el equipo a un sector y/o un ambiente. <span class=\'tw-font-medium tw-text-color-primary tw-cursor-pointer open-launch-video-dialog\'>Haz clic aquí</span> para saber más.","INFO":"Agregue una imagen principal y configure la información para este equipo.","SELECT_EQUIPMENT_TYPE":"Seleccione un tipo de equipamiento","SELECT_IMAGES":"Seleccionar imagen","PHOTO_RULES":"Las dimensiones ideales de la imagen son 512 px x 512 px, con un tamaño máximo de 2MB.","CLEAR_CUSTOMER":"Limpiar cliente","CLEAR_LOCATION":"Limpiar ubicación","NOTES":"Observaciones","ARCHIVED":" (Archivado)"},"CUSTOM_FIELDS":{"TITLE":"Campos personalizados","HINT":"Los campos personalizados se configuran en el tipo de equipo y sirven para estandarizar el registro de la información.","SELECT":"Seleccione el/la","SELECT_DATE":"Seleccione la fecha","LABEL_SELECT":"Selecciona tu respuesta","LABEL_TEXT_AREA":"Escriba tu respuesta","LABEL_NUMBER":"Escriba tu respuesta numérica","LABEL_DATE_PICKER":"Pon la fecha","EMPTY":"Seleccione un tipo de equipo para que se muestren aquí los campos personalizados.","INVALID":"Este tipo de equipamiento no tiene campos personalizados.","ERRORS":{"DATE_INVALID":"La fecha programada no es válida"}},"SERVICES":{"TITLE":"Servicio","NO_HISTORY":"Esta ubicación no tiene historial de servicio.","GO_TO_TASKS_LIST":"Ir a la lista de actividades"},"HISTORIC":{"TITLE":"Histórico","TODAY":"Hoy","YESTERDAY":"Ayer","LOADING":"Procesando...","NOT_FOUND":"Este equipo aún no tiene histórico.","LOGS":{"ARCHIVED":"Equipo <b>archivado</b>.","CREATED":"Equipo <b>creado</b>.","CHANGED":"Equipo <b>actualizado</b>.","UNARCHIVED":"Equipo <b>sin archivar</b>.","CREATED_DESCRIPTION":"El equipo <b>{{ equipmentNumber }}</b> - <b>{{ equipmentName }}</b> ha sido creado.","CREATED_BY":"Creado por {{ userName }} {{ clientName }}","UPDATED_BY":"Actualizado por {{ userName }} {{ clientName }}","CLIENT":{"MORDOR":"a través del panel de control.","ORC-2":"por la aplicación del empleado.","GOTHMOG-2":"por aplicación de administrador.","CARCHOST":"vía API.","SYSTEM":"a través del sistema."},"EVENT":{"REQUIRED_CHANGES_TITLE":"Datos modificados obligatorios.","PICTURE_CHANGED_TITLE":"Imagen del equipo cambiada.","PICTURE_REMOVED_TITLE":"Imagen del equipo eliminada.","NOTES_CHANGED_TITLE":"Notas modificadas:","EMPTY_NOTES":"<em>Sin notas.</em>","EMPTY_CUSTOM_FIELD":"<em>Sin respuesta.</em>","CUSTOM_FIELDS_ADDED_TITLE":"Campos personalizados con respuestas añadidas:","CUSTOM_FIELDS_CHANGED_TITLE":"Campos personalizados con respuestas modificadas:","CUSTOM_FIELDS_DELETED_TITLE":"Campos personalizados con respuestas eliminadas:","ATTACHMENTS_ADDED_TITLE":"Adjuntos agregados:","ATTACHMENTS_DELETED_TITLE":"Adjuntos eliminados:","CHANGED_NAME":"El nombre del equipo ha sido cambiado de <b>{{ previous }}</b> a <b>{{ current }}</b>.","CHANGED_NUMBER":"El número de equipo ha sido cambiado de <b>{{ previous }}</b> a <b>{{ current }}</b>.","CHANGED_TYPE":"El tipo de equipo ha cambiado de <b>{{ previous }}</b> a <b>{{ current }}</b>.","CHANGED_LOCATION":"La ubicación se ha cambiado de <b>{{ previous }}</b> a <b>{{ current }}</b>.","CHANGED_CUSTOMER":"EL cliente se ha cambiado de <b>{{ previous }}</b> a <b>{{ current }}</b>.","CHANGED_LOCATION_SECTOR":"El sector se ha cambiado de <b>{{ previous }}</b> a <b>{{ current }}</b>.","CHANGED_LOCATION_ENVIRONMENT":"El ambiente se ha cambiado de <b>{{ previous }}</b> a <b>{{ current }}</b>.","CHANGED_QR_CODE":"El Código QR ha sido cambiado."}}},"ATTACHMENTS":{"TITLE":"Archivos adjuntos","ATTACHMENT_WARNING":"Límite de 20 archivos adjuntos por Panel de Administrador. 10MB de tamaño máximo por archivo","DROP_HERE":"Arrastre sus archivos para cargar","INSERT_FILES_ALTERNATIVE":"Arrastre sus archivos para cargarlos o","ATTACHMENTS_LIMIT_REACHED":"Se alcanzó el límite de archivos adjuntos, para agregar más archivos adjuntos primero debe eliminar algunos.","INSERT_FILES":"Arrastra tus archivos para subirlos o","SEND_FILES":"Enviar archivos","MAX_SIZE_FILES":"Este archivo excede el límite de 10MB.","UPLOAD":"Haga clic o arrastre sus imágenes para cargar","SEND":"Subir imágenes","SAVE":"Guardar título","CANCEL":"Cancelar","EDIT":"Editar nombre de imagen","CREATED_AT":"Agregado en {{ date }} a las {{ time }}","VIEW_ORIGINAL":"Ver original","REMOVE":"Eliminar imagen","ALERT":{"CONTENT":"¿Está seguro de que desea <strong>eliminar</strong> la imagen?","YES":"Sí","NO":"No"},"NOT_SUPPORTED_FILE_DRAG":"Arrastrar/soltar archivos no es compatible con su navegador","EMPTY_STATE":"Ningún archivo adjunto ha sido agregado para este equipo."},"QRCODE":{"TITLE":"Código QR","DOWNLOAD":"Descargar","PLACEHOLDER":"Clic en el botón para generar el QRCode","GENERATE_QRCODE":"Haga click aquí para generar el QRCode","VIEW_QRCODE":"Ver el QR code del equipo","GENERATE_QRCODE_MANDATORY":"Haga click aquí para generar el QRCode*","MODAL":{"GENERATE":"Generar QRCode","GENERATE_ANOTHER_CODE":"Generar otro código","SAVE":"Guardar","DOWNLOAD":"Descargar","SAVED_SUCCESSFULLY":"QR Code modificado, guarde el equipo para realizar la actualización."}},"WARRANTIES":{"TITLE":"Garantías"},"ACTIONS":{"SAVE":"Guardar","CREATE":"Crear","ARCHIVE":"Archivo","UNARCHIVE":"Desarchivar"},"EQUIPMENT":{"LABEL":{"TITLE":"Etiqueta","MANAGE":"Administrar etiquetas","NO_REGISTERED":"No hay etiquetas registradas, solo los administradores pueden registrar etiquetas.","LIMIT_EXCEEDED":"Se ha superado el límite máximo de etiquetas.","UPDATED":"Las etiquetas se actualizaron con éxito.","PLACEHOLDER":"Buscar etiquetas ...","TOGGLE":"Alternar","EDIT":"Actualizar","ADD":"Crear nueva etiqueta","BACK":"Volver","NAME":"Nombre","CREATE_BUTTON":"Crear","EDIT_LABEL":"Editar"}}},"ALERT":{"TITLE":"Exportación de equipamientos","SUBTITLE":"Elija la forma en que desea exportar.","FIRST_CONTENT":"Cuando haga clic en exportar, recibirá un enlace para descargar la exportación en el correo electrónico","SECOND_CONTENT":"Dependiendo de la cantidad de equipo, la exportación puede tardar unos minutos en completarse","WITH_CUSTOM_FIELD":"Con campos personalizados","WITHOUT_CUSTOM_FIELD":"Sin campos personalizados","EXPORT_CONFIRMATION":"¿Quieres continuar con la exportación?","OK":"Sí","CANCEL":"No"},"TOAST":{"EXPORTED":"La tabla se enviará al correo electrónico \'{{ email }}\' en unos minutos.","WAIT_PLANNING":"Espere, en unos momentos comenzará la planificación automática de actividades.","IMAGE_TITLE_CHANGED":"El título del archivo adjunto ha sido cambiado.","IMAGE_DELETED":"¡La imagen se ha eliminado con éxito!","EQUIPMENT_SAVED":"El equipamiento para el cliente \'{{ name }}\' se ha guardado correctamente.","IMAGES_SENDED":"Las imágenes han sido enviadas con éxito.","ERRORS":{"EQUIPMENT_IMAGE_UPLOAD":"No se pudo guardar la imagen del dispositivo."}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/equipments/i18n/pt.json',
    '{"EQUIPMENTS":{"PAGE_TITLE":"Equipamentos","TITLE":"Equipamentos","NEW":"Novo equipamento","GENERATE_QR_CODE":"Gerar código QR","SEARCH":"Pesquisar","EXPORT_EXCEL":"Exportar em Excel","RELOAD":"Atualizar","FILTER":"Filtrar equipamentos","FEEDBACK_FORM":"Sua perspectiva é fundamental para avaliar o desenvolvimento de uma nova funcionalidade de locação de equipamentos! Conta pra gente sua experiência:","FILTERS":{"TITLE":"Filtrar Equipamentos","CLEAR":"Limpar filtros","NAME":"Buscar por nome","MODEL_NAME":"Buscar por nome do modelo","CUSTOMER":{"TITLE":"Filtrar por cliente","SEARCH":"Buscar por cliente","SELECT":"Selecionar um cliente","INACTIVE":"INATIVO"},"LOCATION":{"TITLE":"Filtrar por localização","SEARCH":"Buscar por localização","SELECT":"Selecionar uma localização"},"NUMBER":"Buscar por número","SITUATIONS":{"TITLE":"Filtrar por situação","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"},"TYPE":{"TITLE":"Filtrar por tipo de equipamento","ALL":"Todos"},"FILTER_BY_LABEL":{"LABEL":"Filtrar por etiquetas","NO_LABEL":"Sem etiqueta"},"BY_TERRITORY":{"LABEL":"Filtrar por território","SEARCH":"Pesquisar território","SEARCH_LABEL":"Selecione o território"},"BY_SUBTERRITORY":{"LABEL":"Filtrar por subterritório","SEARCH":"Pesquisar subterritório","SEARCH_LABEL":"Selecione o subterritório"},"WARRANTY":{"LABEL":"Filtrar por garantia","WARRANTY_FROM":"Garantia de","WARRANTY_UNTIL":"Garantia até","SELECT_DATE":"Selecione a data","STATUS":"Status","ALL":"Todas","ACTIVE":"Ativas","EXPIRED":"Expiradas","EXTENDED":"Estendidas","FUTURE":"Futuras","NO_WARRANTY":"Sem garantias"}},"MODEL":{"NAME":"Nome do modelo","NUMBER":"Número de série","CREATED_AT":"Criado em","EQUIPMENT_TYPE":"Tipo de equipamento","SECTOR":"Setor","SEARCH_BY_SECTOR":"Procurar setor","ENVIRONMENT":"Ambiente","SEARCH_BY_ENVIRONMENT":"Procurar ambiente","CUSTOMER":"Cliente","LOCATION":"Localização","ACTIVE":"Ativo","ARCHIVED":"Arquivado","EMPTY":"Nenhum","WARRANTY_START_DATE":"Início da garantia","WARRANTY_END_DATE":"Fim da garantia","WARRANTY_STATUS":{"TITLE":"Status","ACTIVE":"Ativa","EXPIRED":"Expirada","EXTENDED":"Estendida","FUTURE":"Futura","NO_WARRANTY":"Sem status"},"QR_CODE":{"DOWNLOAD_LINK_MESSAGE":"Visualizar QR code","GENERATE":"Gerar QR code"},"ERRORS":{"NAME_REQUIRED":"Nome é obrigatório","NOTES_MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}.","FIELD_REQUIRED":"Campo obrigatório.","NUMBER_REQUIRED":"Número de série é obrigatório","NAME_INVALID_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}.","DUPLICATED_NUMBER":"Número já consta para outro equipamento","DUPLICATED_NUMBER_ARCHIVED":"Número já consta para outro equipamento (Arquivado)","MAX_LENGTH_NUMBER":"Número de série deve possuir no máximo 100 caracteres","EQUIPMENT_TYPE_REQUIRED":"O tipo de equipamento é obrigatório","CUSTOM_FIELD_REQUIRED":"Campo personalizado obrigatório, você precisa preenchê-lo","CUSTOMER_REQUIRED":"Cliente é obrigatório","CUSTOMER_NOT_FOUND":"Cliente não encontrado","LOCATION_ENTER_VALUE":"Localização deve ser selecionada","LOCATION_REQUIRED":"Localização é obrigatório","LOCATION_NOT_FOUND":"Nenhuma localização encontrada","NO_LOCATIONS":{"TEXT":"Esse cliente ainda não possui localizações.","LINK":"Clique aqui para criar uma localização em:"},"DISABLED_CREATE_EQUIPMENT":"Não é possível cadastrar equipamentos para uma localização desse cliente","DISABLED_CREATE_EQUIPMENT_CORPORATE":"Não é possível cadastrar equipamentos para uma localização de <b>{{ customerAccountName }}</b>."}},"TABLE":{"ACTIONS":"Ações","EDIT":"Editar","EDIT_LOCKED":"Você não tem permissão para editar esse equipamento"},"DIALOG":{"NEW":{"TITLE":"Novo equipamento"},"EDIT":{"TITLE":"Editar equipamento"},"GENERAL":{"TITLE":"Geral","HINT":"Novos campos adicionados! Agora você pode vincular o equipamento a um setor e/ou um ambiente. <span class=\'tw-font-medium tw-text-color-primary tw-cursor-pointer open-launch-video-dialog\'>Clique aqui</span> para saber mais!","INFO":"Adicione uma imagem principal e defina as informações deste equipamento.","PHOTO_RULES":"As dimensões ideais da imagem são 512px x 512px, com tamanho máximo de 2MB.","SELECT_IMAGES":"Selecionar imagem","SELECT_EQUIPMENT_TYPE":"Selecione um tipo de equipamento","CLEAR_CUSTOMER":"Limpar cliente","CLEAR_LOCATION":"Limpar localização","NOTES":"Observações","ARCHIVED":" (Arquivado)"},"CUSTOM_FIELDS":{"TITLE":"Campos Personalizados","HINT":"Os campos customizados são configurados no tipo de equipamento e servem para padronizar o cadastro de informações","SELECT":"Selecione o(a)","SELECT_DATE":"Selecione a data","LABEL_SELECT":"Selecione sua resposta","LABEL_TEXT_AREA":"Digite sua resposta","LABEL_DATE_PICKER":"Coloque a data","LABEL_NUMBER":"Digite sua resposta numérica","EMPTY":"Selecione um tipo de equipamento para que os campos personalizados sejam exibidos aqui.","INVALID":"Esse tipo de equipamento não possui campos customizados.","ERRORS":{"DATE_INVALID":"A data agendada é inválida"}},"ATTACHMENTS":{"TITLE":"Anexos","ATTACHMENT_WARNING":"Limite de 20 anexos pelo Painel do gestor. Tamanho máximo de 10MB por arquivo","DROP_HERE":"Arraste seus arquivos para fazer upload","INSERT_FILES_ALTERNATIVE":"Arraste seus arquivos para fazer upload ou","ATTACHMENTS_LIMIT_REACHED":"Limite de anexos foi atingido, para adicionar mais anexos você precisa remover alguns primeiro.","INSERT_FILES":"Inserir arquivos","MAX_SIZE_FILES":"Este arquivo excede o limite de 10MB","SEND_FILES":"Enviar arquivos","UPLOAD":"Clique ou arraste suas imagens para fazer upload","SEND":"Enviar imagens","SAVE":"Salvar título","CANCEL":"Cancelar","EDIT":"Editar nome da imagem","CREATED_AT":"Adicionada em {{ date }} às {{ time }}","VIEW_ORIGINAL":"Ver original","REMOVE":"Remover imagem","ALERT":{"CONTENT":"Tem certeza que deseja <strong>excluir</strong> a imagem?","YES":"Sim","NO":"Não"},"NOT_SUPPORTED_FILE_DRAG":"O arrastar/soltar arquivos não é suportado pelo seu navegador","EMPTY_STATE":"Nenhum anexo foi adicionado para esse equipamento."},"QRCODE":{"TITLE":"QR Code","DOWNLOAD":"Baixar","PLACEHOLDER":"Clique no botão para gerar o QRCode","GENERATE_QRCODE":"Clique aqui para gerar o QR Code","VIEW_QRCODE":"Visualizar QR code do equipamento","GENERATE_QRCODE_MANDATORY":"Clique aqui para gerar o QR Code*","MODAL":{"GENERATE":"Gerar QR Code","GENERATE_ANOTHER_CODE":"Gerar outro código","SAVE":"Salvar","DOWNLOAD":"Baixar","SAVED_SUCCESSFULLY":"QR Code alterado, salve o equipamento para efetuar a atualização."}},"SERVICES":{"TITLE":"Atendimento","NO_HISTORY":"Esse equipamento não possui histórico de atendimento.","GO_TO_TASKS_LIST":"Ir para a lista de atividades"},"HISTORIC":{"TITLE":"Histórico","TODAY":"Hoje","YESTERDAY":"Ontem","LOADING":"Processando...","NOT_FOUND":"Este equipamento ainda não possui histórico.","LOGS":{"ARCHIVED":"Equipamento <b>arquivado</b>.","CREATED":"Equipamento <b>criado</b>.","CHANGED":"Equipamento <b>alterado</b>.","UNARCHIVED":"Equipamento <b>desarquivado</b>.","CREATED_DESCRIPTION":"O equipamento <b>{{ equipmentNumber }}</b> - <b>{{ equipmentName }}</b> foi criado.","CREATED_BY":"Criado por {{ userName }} {{ clientName }}","UPDATED_BY":"Alterado por {{ userName }} {{ clientName }}","CLIENT":{"MORDOR":"via painel de controle.","ORC-2":"pelo app do colaborador.","GOTHMOG-2":"pelo app do gestor.","CARCHOST":"via API.","SYSTEM":"via sistema."},"EVENT":{"REQUIRED_CHANGES_TITLE":"Informações obrigatórias alteradas.","PICTURE_CHANGED_TITLE":"Imagem do equipamento alterada.","PICTURE_REMOVED_TITLE":"Imagem do equipamento removida.","NOTES_CHANGED_TITLE":"Observações alteradas:","EMPTY_NOTES":"<em>Sem observações.</em>","EMPTY_CUSTOM_FIELD":"<em>Sem resposta.</em>","CUSTOM_FIELDS_ADDED_TITLE":"Campos customizados com respostas adicionadas:","CUSTOM_FIELDS_CHANGED_TITLE":"Campos customizados com respostas alteradas:","CUSTOM_FIELDS_DELETED_TITLE":"Campos customizados com respostas removidas:","ATTACHMENTS_ADDED_TITLE":"Anexo adicionado:","ATTACHMENTS_DELETED_TITLE":"Anexo removido:","CHANGED_NAME":"O nome do modelo foi alterado de <b>{{ previous }}</b> para <b>{{ current }}</b>.","CHANGED_NUMBER":"O número de série foi alterado de <b>{{ previous }}</b> para <b>{{ current }}</b>.","CHANGED_TYPE":"O tipo de equipamento foi alterado de <b>{{ previous }}</b> para <b>{{ current }}</b>.","CHANGED_CUSTOMER":"O cliente foi alterado de <b>{{ previous }}</b> para <b>{{ current }}</b>.","CHANGED_LOCATION":"A localização foi alterada de <b>{{ previous }}</b> para <b>{{ current }}</b>.","CHANGED_LOCATION_SECTOR":"O setor foi alterado de <b>{{ previous }}</b> para <b>{{ current }}</b>.","CHANGED_LOCATION_ENVIRONMENT":"O ambiente foi alterado de <b>{{ previous }}</b> para <b>{{ current }}</b>.","CHANGED_QR_CODE":"O QR Code foi alterado."}}},"WARRANTIES":{"TITLE":"Garantias"},"ACTIONS":{"SAVE":"Salvar","CREATE":"Criar","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"},"EQUIPMENT":{"LABEL":{"TITLE":"Etiqueta","MANAGE":"Gerenciar etiquetas","NO_REGISTERED":"Nenhuma etiqueta cadastrada, apenas administradores podem cadastrar etiquetas.","UPDATED":"Etiquetas atualizadas com sucesso.","LIMIT_EXCEEDED":"Limite máximo de etiquetas foi excedido.","PLACEHOLDER":"Pesquisar etiquetas...","TOGGLE":"Alternar","EDIT":"Atualizar","ADD":"Criar nova etiqueta","BACK":"Voltar","NAME":"Nome","CREATE_BUTTON":"Criar","EDIT_LABEL":"Editar"}}},"ALERT":{"TITLE":"Exportação de equipamentos","SUBTITLE":"Escolha a forma que deseja exportar.","FIRST_CONTENT":"Ao clicar em exportar, você receberá um link para download da exportação no e-mail","SECOND_CONTENT":"Dependendo da quantidade de equipamentos, a exportação poderá demorar alguns minutos para ser finalizada","WITH_CUSTOM_FIELD":"Com campos customizados","WITHOUT_CUSTOM_FIELD":"Sem campos customizados","EXPORT_CONFIRMATION":"Deseja continuar com a exportação?","OK":"Sim","CANCEL":"Não"},"TOAST":{"EXPORTED":"A planilha será enviada para o email \'{{ email }}\' em alguns minutos.","WAIT_PLANNING":"Aguarde, em alguns instantes será iniciado o planejamento automático das atividades.","IMAGE_TITLE_CHANGED":"Título do anexo alterado com sucesso.","IMAGE_DELETED":"A imagem foi removida com sucesso!","EQUIPMENT_SAVED":"Equipamento para o cliente \'{{ name }}\' salvo com sucesso.","IMAGES_SENDED":"As imagens foram enviadas com sucesso.","ERRORS":{"EQUIPMENT_IMAGE_UPLOAD":"Falha ao salvar imagem do equipamento."}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/errors/i18n/en.json',
    '{"DESKTOP_REQUIRED_ERROR":{"CODE":"We noticed you\'re on mobile.","MESSAGE":"Account creation is done through the <b>management panel</b> accessed via desktop. Use your <b>laptop</b> or <b>computer</b> to perform this action. It\'s quick and simple.<br/><br/>If you have any questions, use the chat to talk to us.<br/><br/>"},"ERROR404":{"PAGE_TITLE":"Oops! Page not found","CODE":"404 - Page not found","MESSAGE":"Sorry, we couldn\'t find the page you were looking for... :(","GO_BACK_LOGGED":"Back to control panel"},"APP_DOWNLOAD_REQUIRED_ERROR":{"CODE":"We noticed you\'re on mobile.","DOWNLOAD":"Download the corresponding app for your smartphone\'s operating system","APP_STORE":"download on the app store","GOOGLE_PLAY":"download on google play"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/errors/i18n/es.json',
    '{"DESKTOP_REQUIRED_ERROR":{"CODE":"Hemos notado que estás en un dispositivo móvil.","MESSAGE":"La creación de cuentas se realiza a través del <b>panel de gestión</b> accesible desde el escritorio. Utiliza tu <b>portátil</b> o <b>computadora</b> para realizar esta acción. Es rápido y sencillo.<br/><br/>Si tienes alguna duda, utiliza el chat para hablar con nosotros.<br/><br/>"},"ERROR404":{"PAGE_TITLE":"¡Ops! Página no encontrada","CODE":"404 - Página no encontrada","MESSAGE":"Lo sentimos, no pudimos encontrar la página que estabas buscando... :(","GO_BACK_LOGGED":"Volver al panel de control"},"APP_DOWNLOAD_REQUIRED_ERROR":{"CODE":"Hemos notado que estás en un dispositivo móvil.","DOWNLOAD":"Descarga la aplicación correspondiente para el sistema operativo de tu smartphone","APP_STORE":"descargar en la app store","GOOGLE_PLAY":"descargar en google play"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/errors/i18n/pt.json',
    '{"DESKTOP_REQUIRED_ERROR":{"CODE":"Percebemos que você está no celular.","MESSAGE":"A criação de conta é realizada pelo <b>painel de gerenciamento</b> acessado via desktop. Utilize seu <b>notebook</b> ou <b>computador</b> para realizar essa ação. É rápido e simples.<br/><br/>Em caso de dúvidas, use o chat para falar com a gente.<br/><br/>"},"ERROR404":{"PAGE_TITLE":"Ops! Página não encontrada","CODE":"404 - Página não encontrada","MESSAGE":"Desculpe, não encontramos a página que você estava procurando... :(","GO_BACK_LOGGED":"Voltar para o painel de controle"},"APP_DOWNLOAD_REQUIRED_ERROR":{"CODE":"Percebemos que você está no celular.","DOWNLOAD":"Baixe o aplicativo correspondente ao sistema operacional do smartphone","APP_STORE":"baixar na app store","GOOGLE_PLAY":"baixar na google play"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/exports/i18n/en.json',
    '{"EXPORTS":{"PAGE_TITLE":"Exports","TITLE":"Exports","SEARCH":"Search","NEW":"Add export","RELOAD":"Reload","FILTER":"Filter exports","EXPIRED":"expired link","FILTERS":{"TITLE":"Filter Exports","CLEAR":"Clear filters","CREATION_DATE":"Search by creation date","COMPLETION_DATE":"Search by completion date","STATUS":"Search by status","EMPLOYEE":"Search by employee","NO_EMPLOYEE":"No employee","FROM":"From:","TO":"To:","SELECT_DATE":"Select date"},"MODEL":{"NAME":"Model name","TYPE":"Type","EMPLOYEE":"Created by","CREATED_AT":"Created at","COMPLETED_AT":"Completed at","EXPORT_LINK":"File link","ACCESS_FILE":"View file","STATUS":{"TITLE":"Status","PENDING":"Pending","COMPLETED":"Completed","ERROR":"Error","IN_PROGRESS":"In progress"},"TYPES":{"TASKS":"Tasks","CUSTOMERS":"Customers","FORMS_ANSWERS":"Form answers","ORDER_PDF":"Service order PDF","EQUIPMENTS":"Equipments","QUOTATIONS":"Quotations","VEHICLES_USAGE":"Vehicle usage history","ORDER_PDF_MULTIPLE":"Multiple service order PDFs","PRODUCTS_SERVICES":"Products and services","LOCATIONS":"Locations"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/exports/i18n/es.json',
    '{"EXPORTS":{"PAGE_TITLE":"Exportaciones","TITLE":"Exportaciones","SEARCH":"Buscar","NEW":"Agregar exportación","RELOAD":"Recargar","FILTER":"Filtrar exportaciones","EXPIRED":"enlace caducado","FILTERS":{"TITLE":"Filtrar Exportaciones","CLEAR":"Limpiar filtros","CREATION_DATE":"Buscar por fecha de creación","COMPLETION_DATE":"Buscar por fecha de finalización","STATUS":"Buscar por estado","EMPLOYEE":"Buscar por colaborador","NO_EMPLOYEE":"Sin colaborador","FROM":"De:","TO":"Hasta:","SELECT_DATE":"Seleccionar fecha"},"MODEL":{"NAME":"Nombre del modelo","TYPE":"Tipo","EMPLOYEE":"Creado por","CREATED_AT":"Creado en","COMPLETED_AT":"Completado en","EXPORT_LINK":"Enlace del archivo","ACCESS_FILE":"Ver archivo","STATUS":{"TITLE":"Estado","PENDING":"Pendiente","COMPLETED":"Completado","ERROR":"Error","IN_PROGRESS":"En progreso"},"TYPES":{"TASKS":"Actividades","CUSTOMERS":"Clientes","FORMS_ANSWERS":"Respuestas de formularios","ORDER_PDF":"Orden de servicio PDF","EQUIPMENTS":"Equipos","QUOTATIONS":"Presupuestos","VEHICLES_USAGE":"Historial de uso de vehículos","ORDER_PDF_MULTIPLE":"Múltiples órdenes de servicio PDF","PRODUCTS_SERVICES":"Productos y servicios","LOCATIONS":"Ubicaciones"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/exports/i18n/pt.json',
    '{"EXPORTS":{"PAGE_TITLE":"Exportações","TITLE":"Exportações","SEARCH":"Pesquisar","NEW":"Adicionar exportação","RELOAD":"Atualizar","FILTER":"Filtrar exportações","EXPIRED":"link expirado","FILTERS":{"TITLE":"Filtrar Exportações","CLEAR":"Limpar filtros","CREATION_DATE":"Buscar por data de criação","COMPLETION_DATE":"Buscar por data de conclusão","STATUS":"Buscar por status","EMPLOYEE":"Buscar por colaborador","NO_EMPLOYEE":"Não há colaborador","FROM":"De:","TO":"Até:","SELECT_DATE":"Selecionar data"},"MODEL":{"NAME":"Nome do modelo","TYPE":"Tipo","EMPLOYEE":"Criado por","CREATED_AT":"Criado em","COMPLETED_AT":"Concluído em","EXPORT_LINK":"Link do arquivo","ACCESS_FILE":"Ver arquivo","STATUS":{"TITLE":"Status","PENDING":"Pendente","COMPLETED":"Concluído","ERROR":"Falha","IN_PROGRESS":"Processando"},"TYPES":{"TASKS":"Atividades","CUSTOMERS":"Clientes","FORMS_ANSWERS":"Respostas de formulários","ORDER_PDF":"Ordem de serviço pdf","EQUIPMENTS":"Equipamentos","QUOTATIONS":"Orçamentos","VEHICLES_USAGE":"Histórico de uso","ORDER_PDF_MULTIPLE":"Múltiplas ordens de serviço pdf","PRODUCTS_SERVICES":"Produtos e serviços","LOCATIONS":"Localizações"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/locations/i18n/en.json',
    '{"LOCATIONS":{"PAGE_TITLE":"Locations","TITLE":"Locations","VIEW":"View","GENERATE_QR_CODE":"Generate QR Code","PRODUCT_SERVICE_EDIT_NOT_ALLOWED":"Unable to edit a blocked product/service","EDIT":"Edit","MAP":{"TITLE":"Update coordinates","ALERT":"Drag the building icon to the desired location to update the location coordinates.","UPDATE":"UPDATE"},"TOOLBAR":{"ADD":"Add location","FILTER":"Filter locations","RELOAD":"Reload locations"},"FILTERS":{"CLEAR":"Clear filters","LABELS":{"LOCATION_NAME":"Search by location name","LOCATION_DESCRIPTION":"Search by location description","CUSTOMER_NAME":"Search by customer name","DOCUMENT_NUMBER":"Search by document number","STREET":"Search by street","CITY":"Search by city","STATE":"Search by state","STATUS":"Filter by status"},"STATUS":{"ALL":"All","ARCHIVED":"Archived","UNARCHIVED":"Active"},"BY_TERRITORY":{"LABEL":"Filter by territory","SEARCH":"Search territory","SEARCH_LABEL":"Select territory"},"BY_SUBTERRITORY":{"LABEL":"Filter by subterritory","SEARCH":"Search subterritory","SEARCH_LABEL":"Select subterritory"}},"TABLE":{"COLUMNS":{"NAME":"Location name","CUSTOMER":"Customer","ADDRESS":"Location address","DOCUMENT_NUMBER":"Document","ACTIONS":"Actions"}},"DIALOG":{"VIEW_VISIT":"View visit","SAVED":"Location \'{{ name }}\' saved.","ERROR_SAVING":"There was an error saving the location","ERROR_SAVING_CONTACTS":"There was an error saving the contacts from the location","ERROR_SAVING_PRIMARY_LOCATION":"There was an error saving the customer\'s primary location","ERROR_DUPLICATED":"There is already a location with the same name for this customer","ARCHIVE":"Archive","UNARCHIVE":"Unarchive","GENERAL":{"SELECT_AS_PRIMARY":"<strong>Select</strong> this location as<strong>primary</strong> location for this customer","PRIMARY_LOCATION":"This is the customer\'s <strong>primary</strong> location and therefore cannot be archived.","SEARCH_BY_CEP":"Search by ZIP code","SEARCH_BY_GOOGLE":"Search by Google","TERRITORIES":"Territories","SUBTERRITORIES":"Subterritories","SECTIONS":{"LOCATION_DATA":{"TITLE":"Location data","FIELDS":{"LOCATION_NAME":"Location name","LOCATION_ADDRESS":"Location address","DOCUMENT_NUMBER":"Document","CEP":"ZIP Code","STREET":"Street","NUMBER":"Number","NEIGHBORHOOD":"Neighborhood","CITY":"City","STATE":"State","ADDRESS_COMPLEMENT":"Address complement","NOTES":"Notes","CUSTOMER":"Customer"}}}},"CONTACT":{"CONTACT_TYPES":{"WORK":"Work","PERSONAL":"Personal","HOME":"Home","PHONE":"Cellphone"},"CONTACT_INFOS":{"SUBTITLE_PHONE":"Phones","SUBTITLE_EMAIL":"Emails","DELETE_CONTACT":"Delete contact","ADD_PHONE":"Add phone","ADD_EMAIL":"Add email","SELECT_AS_MAIN_PHONE":"Consider as primary phone number","SELECT_AS_MAIN_EMAIL":"Consider as primary email","EMPTY_PHONES":"No phones registered.","EMPTY_EMAILS":"No emails registered.","FIELDS":{"NAME":"Contact name","EMAIL":"Email","PHONE":"Number","PHONE_TYPE":"Type","EMAIL_TYPE":"Type"}}},"EQUIPMENTS":{"HINT":"To ensure a better experience, we are migrating the <span class=\'tw-font-medium\'>\'Equipments\'</span> tab to <span class=\'tw-font-medium\'>\'Links\'</span>. Soon, the <span class=\'tw-font-medium\'>\'Equipments\'</span> tab will be deactivated. <span class=\'tw-text-color-primary tw-font-medium tw-cursor-pointer go-to-links\'>Click here</span> to learn more!","TITLE":"Equipments","SEARCH_EQUIPMENTS":"Search for linked equipments","SEARCH_DESCRIPTION":"Search by name or serial number.","REGISTER_NEW":"Register new","EDIT_EQUIPMENT":"Edit equipment","PAGINATION":{"PREVIOUS":"Previous","NEXT":"Next","SHOWING_FROM":"Showing from","TO":"to","OF":"of","RECORDS":"records"}},"ATTACHMENTS":{"TITLE":"Attachments","NO_TITLE":"No title","DROP_HERE":"Drag your files to upload","NOT_SUPPORTED_FILE_DRAG":"The file is not supported by your browser","ATTACHMENT_DESCRIPTION":"Limit of 10 attachments. Maximum size of 10MB per file","INSERT_FILES":"Insert files","INSERT_FILES_ALTERNATIVE":"Drag your files to upload or","SEND_FILES":"Send files","NO_ATTACHMENTS_ADDED":"No attachments have been added for this location.","SEARCHING_ATTACHMENTS":"Searching location attachments","ATTACHMENTS_LIMIT_REACHED":"Attachments limit reached, to add more attachments you need to remove some first.","MAX_SIZE_FILES":"This file exceeds the limit of 20MB","SAVE_TITLE_SUCESS":"Attachment title successfully changed.","FILES":{"MOVE_UP":"Move up","MOVE_DOWN":"Move down","SAVE_EDIT":"Save title","CANCEL_EDIT":"Cancel","NO_TITLE":"No title","SIGNATURE":"Signature","EDIT_TITLE":"Edit attachment title","EDIT_CUSTOMER_NAME":"Edit customer name","OF":"of","ADDED_AT":"Created on {{ date }} at {{ hour }}","EDIT":"Edit","VIEW_ORIGINAL":"View original","ARCHIVED":"Archived","ACTIONS":{"REMOVE":"Remove attachment","ARCHIVE":"Archive attachment","UNARCHIVE":"Unarchive attachment"},"ALERTS":{"REMOVE_SIGNATURE":"Are you sure you want to <strong>remove</strong> this signature?","REMOVE_ATTACHMENT":"Are you sure you want to <strong>remove</strong> this attachment?","ARCHIVE_SIGNATURE":"Are you sure you want to <strong>archive</strong> this signature?","ARCHIVE_ATTACHMENT":"Are you sure you want to <strong>archive</strong> this attachment?","YES":"Yes","NO":"No"}},"RENAME_MODAL":{"TITLE":"Rename attachment","SUCCESS_MESSAGE":"Attachment renamed successfully"},"ARCHIVE_MODAL":{"ARCHIVE_TITLE":"Archive attachment","UNARCHIVE_TITLE":"Unarchive attachment","ARCHIVE_CONTENT":"Are you sure you want to archive it?","UNARCHIVE_CONTENT":"Are you sure you want to unarchive it?","SUCCESS_MESSAGE":"Attachment archived successfully","SUCCESS_UNARCHIVE_MESSAGE":"Attachment unarchived successfully"},"ERROR_MESSAGE":"There was an error, please try again.","ERROR_MESSAGE_FILE_SIZE":"This file exceeds the 10MB limit.","ERROR_MESSAGE_MAX_FILES":"You have reached the limit of 10 attachments.","LINK":"LINK"},"NEW":{"TITLE":"New location","VALIDATION_ERRORS":{"REQUIRED":"This field is required.","PATTERN_ZIP_CODE":"Invalid ZIP code.","MAX_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but it has {{ receivedLength }}.","MIN_LENGTH":"This field must have at least {{ expectedLength }} characters, but it has {{ receivedLength }}.","EMAIL":"Invalid email.","INVALID_DOCUMENT":"Invalid {{ documentName }}.","INVALID_PHONE":"Invalid phone number.","DUPLICATED_LOCATION_NAME":"Duplicated location name","DISABLED_CREATE_LOCATION":"It is not possible to register locations for a customer of <b>{{ customerAccountName }}</b>."},"CREATE_NEW_LOCATION":"Create"},"VIEW":{"TITLE":"View location","TABS":{"GENERAL":"GENERAL","CONTACTS":"CONTACTS","LOCATION_LINKS":"Links","EQUIPMENTS":"EQUIPMENTS","ATTACHMENTS":"ATTACHMENTS","SERVICES":{"TITLE":"Service","NO_HISTORY":"This location has no service history.","GO_TO_TASKS_LIST":"Go to tasks list","CREATED_AT":"Created at ","RESPONSIBLE_EMPLOYEE":"Responsible employee: ","VISIT_DURATION":"Visit duration: ","MINUTES":" minutes","SCHEDULING_DATE_AND_TIME":"Date/hour of scheduling: ","START_DATE_AND_TIME":"Date/hour of start: ","DATE_AND_TIME_OF_CONCLUSION":"Date/hour of conclusion: ","NO_EMPLOYEE":"No employee"}},"SAVE":"Save"},"LAUNCH_VIDEO":{"TITLE":"Welcome to the new links tab","MESSAGE":"View sectors, environments and/or equipment linked to this location. Watch the video below or close this window to test the functionality!"}},"EXPORT":{"TITLE":"Export of Locations","CONTENT":"By clicking export, you will receive a download link of the export to your email <b>{{ email }}</b>. Depending on the amount of information, the export may take a few minutes to complete.","YES":"YES","NO":"NO","CONFIRM_ACTION_CONTENT":"Do you want to proceed with the exportation?","SPREADSHEET_SENT":"The spreadsheet will be sent to {{email}} in a few minutes","SPREADSHEET_ERROR":"Ooops, something went wrong. Unable to export locations :("}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/locations/i18n/es.json',
    '{"LOCATIONS":{"PAGE_TITLE":"Ubicaciones","TITLE":"Ubicaciones","VIEW":"Ver","GENERATE_QR_CODE":"Generar código QR","PRODUCT_SERVICE_EDIT_NOT_ALLOWED":"No se puede editar un producto/servicio bloqueado","EDIT":"Editar","MAP":{"TITLE":"Actualizar coordenadas","ALERT":"Arrastra el ícono del edificio a la ubicación deseada para actualizar las coordenadas de la ubicación.","UPDATE":"ACTUALIZAR"},"TOOLBAR":{"ADD":"Añadir ubicación","FILTER":"Filtrar las ubicaciones","RELOAD":"Actualizar ubicaciones"},"FILTERS":{"CLEAR":"Limpiar los filtros","LABELS":{"LOCATION_NAME":"Buscar por nombre de ubicación","LOCATION_DESCRIPTION":"Buscar por descripción de la ubicación","CUSTOMER_NAME":"Buscar por nombre de cliente","DOCUMENT_NUMBER":"Buscar por número del documento","STREET":"Buscar por calle","CITY":"Buscar por ciudad","STATE":"Buscar por estado","STATUS":"Filtrar por situación"},"STATUS":{"ALL":"Todos","ARCHIVED":"Archivados","UNARCHIVED":"Ativos"},"BY_TERRITORY":{"LABEL":"Filtrar por territorio","SEARCH":"Buscar territorio","SEARCH_LABEL":"Seleccione el territorio"},"BY_SUBTERRITORY":{"LABEL":"Filtrar por subterritorio","SEARCH":"Buscar subterritorio","SEARCH_LABEL":"Seleccione el subterritorio"}},"TABLE":{"COLUMNS":{"NAME":"Nombre de la ubicacion","CUSTOMER":"Cliente","ADDRESS":"Dirección de la ubicacion","DOCUMENT_NUMBER":"Documento","ACTIONS":"Acciones"}},"DIALOG":{"VIEW_VISIT":"Ver visita","SAVED":"Se ha guardado la ubicacion \'{{name}}\'.","ERROR_SAVING":"Hubo un error al guardar la ubicación","ERROR_SAVING_CONTACTS":"Hubo un error al guardar los contactos de la ubicación","ERROR_SAVING_PRIMARY_LOCATION":"Hubo un error al guardar la ubicación principal del cliente","ERROR_DUPLICATED":"Ya existe una ubicación con el mismo nombre para este cliente","ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar","GENERAL":{"SELECT_AS_PRIMARY":"<strong>Seleccione</strong> esta ubicación como la<strong>principal</strong> para este cliente","PRIMARY_LOCATION":"Esta es la ubicación <strong>principal</strong> de este cliente, de manera que no se puede archivar.","SEARCH_BY_CEP":"Búsqueda por Código Postal","SEARCH_BY_GOOGLE":"Búsqueda por Google","TERRITORIES":"Territorios","SUBTERRITORIES":"Subterritorios","SECTIONS":{"LOCATION_DATA":{"TITLE":"Datos de ubicacion","FIELDS":{"LOCATION_NAME":"Nombre de la ubicacion","LOCATION_ADDRESS":"Dirección de ubicacion","DOCUMENT_NUMBER":"Documento","CEP":"Codigo Postal","STREET":"Calle","NUMBER":"Número","NEIGHBORHOOD":"Barrio","CITY":"Ciudad","STATE":"Estado","ADDRESS_COMPLEMENT":"Complemento de la dirección","NOTES":"Notas","CUSTOMER":"Cliente"}}}},"CONTACT":{"CONTACT_TYPES":{"WORK":"Trabajo","PERSONAL":"Personal","HOME":"Casa","PHONE":"Teléfono"},"CONTACT_INFOS":{"SUBTITLE_PHONE":"Teléfonos","SUBTITLE_EMAIL":"Correos electrónicos","DELETE_CONTACT":"Eliminar contacto","ADD_PHONE":"Agregar teléfono","ADD_EMAIL":"Agregar correo electrónico","SELECT_AS_MAIN_PHONE":"Considerar como teléfono principal","SELECT_AS_MAIN_EMAIL":"Considerar como correo electrónico principal","EMPTY_PHONES":"No hay teléfonos registrados.","EMPTY_EMAILS":"No hay correos electrónicos registrados.","FIELDS":{"NAME":"Nombre del contacto","EMAIL":"Correo electrónico","PHONE":"Número","PHONE_TYPE":"Tipo","EMAIL_TYPE":"Tipo"}}},"EQUIPMENTS":{"HINT":"Para garantizar una mejor experiencia, estamos migrando la pestaña <span class=\'tw-font-medium\'>\'Equipos\'</span> a <span class=\'tw-font-medium\'>\'Vínculos\'</span>. Pronto, la pestaña <span class=\'tw-font-medium\'>\'Equipos\'</span> será desactivada. <span class=\'tw-text-color-primary tw-font-medium tw-cursor-pointer go-to-links\'>Haga clic aquí</span> para saber más!","TITLE":"Equipos","SEARCH_EQUIPMENTS":"Buscar equipos vinculados","SEARCH_DESCRIPTION":"Buscar por nombre o número de serie","REGISTER_NEW":"Registrar nuevo","EDIT_EQUIPMENT":"Editar equipo","PAGINATION":{"PREVIOUS":"Anterior","NEXT":"Siguiente","SHOWING_FROM":"Mostrando de","TO":"hasta","OF":"desde","RECORDS":"registros"}},"ATTACHMENTS":{"TITLE":"Adjuntos","NO_TITLE":"Sin título","DROP_HERE":"Arrastre sus archivos para cargar","NOT_SUPPORTED_FILE_DRAG":"El archivo no es compatible con su navegador","ATTACHMENT_DESCRIPTION":"Límite de 10 adjuntos. Tamaño máximo 10MB por archivo","INSERT_FILES":"Insertar archivos","INSERT_FILES_ALTERNATIVE":"Arrastre sus archivos para cargar o","SEND_FILES":"Enviar archivos","NO_ATTACHMENTS_ADDED":"No se han agregado archivos adjuntos para esta ubicación.","SEARCHING_ATTACHMENTS":"Buscando adjuntos de la ubicación","ATTACHMENTS_LIMIT_REACHED":"Se ha alcanzado el límite de adjuntos. Para agregar más adjuntos, primero debes eliminar algunos.","MAX_SIZE_FILES":"Este archivo excede el límite de 20MB","SAVE_TITLE_SUCESS":"Título del adjunto cambiado exitosamente.","FILES":{"MOVE_UP":"Mover arriba","MOVE_DOWN":"Mover abajo","SAVE_EDIT":"Guardar título","CANCEL_EDIT":"Cancelar","NO_TITLE":"Sin título","SIGNATURE":"Firma","EDIT_TITLE":"Editar título del adjunto","EDIT_CUSTOMER_NAME":"Editar nombre del cliente","OF":"de","ADDED_AT":"Creado el {{ date }} a las {{ hour }}","EDIT":"Editar","VIEW_ORIGINAL":"Ver original","ARCHIVED":"Archivado","ACTIONS":{"REMOVE":"Eliminar adjunto","ARCHIVE":"Archivar adjunto","UNARCHIVE":"Desarchivar adjunto"},"ALERTS":{"REMOVE_SIGNATURE":"¿Está seguro de que desea <strong>eliminar</strong> esta firma?","REMOVE_ATTACHMENT":"¿Está seguro de que desea <strong>eliminar</strong> este adjunto?","ARCHIVE_SIGNATURE":"¿Está seguro de que desea <strong>archivar</strong> esta firma?","ARCHIVE_ATTACHMENT":"¿Está seguro de que desea <strong>archivar</strong> este adjunto?","YES":"Sí","NO":"No"}},"RENAME_MODAL":{"TITLE":"Cambiar nombre del adjunto","SUCCESS_MESSAGE":"Adjunto renombrado exitosamente"},"ARCHIVE_MODAL":{"ARCHIVE_TITLE":"Archivar adjunto","UNARCHIVE_TITLE":"Desarchivar adjunto","ARCHIVE_CONTENT":"¿Está seguro de que desea archivarlo?","UNARCHIVE_CONTENT":"¿Está seguro de que desea desarhivarlo?","SUCCESS_MESSAGE":"Adjunto archivado exitosamente","SUCCESS_UNARCHIVE_MESSAGE":"Adjunto desarhivado exitosamente"},"ERROR_MESSAGE":"Hubo un error, por favor intente nuevamente","ERROR_MESSAGE_FILE_SIZE":"Este archivo excede el límite de 10MB.","ERROR_MESSAGE_MAX_FILES":"Se ha alcanzado el límite de 10 archivos adjuntos.","LINK":"ENLACE"},"NEW":{"TITLE":"Nueva ubicacion","VALIDATION_ERRORS":{"REQUIRED":"Este campo es obligatorio.","PATTERN_ZIP_CODE":"Código postal inválido","MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}.","MIN_LENGTH":"Este campo debe tener al menos {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}.","EMAIL":"Correo electrónico inválido","INVALID_DOCUMENT":"{{ documentName }} inválido.","INVALID_PHONE":"Número de teléfono inválido.","DUPLICATED_LOCATION_NAME":"Nombre de ubicación duplicado","DISABLED_CREATE_LOCATION":"No es posible registrar ubicaciones para un cliente de <b>{{ customerAccountName }}</b>."},"CREATE_NEW_LOCATION":"Crear"},"VIEW":{"TITLE":"Ver ubicación","TABS":{"GENERAL":"GENERAL","CONTACTS":"CONTACTOS","LOCATION_LINKS":"VÍNCULOS","EQUIPMENTS":"EQUIPOS","ATTACHMENTS":"ADJUNTOS","SERVICES":{"TITLE":"Servicio","NO_HISTORY":"Esta ubicación no tiene historial de servicio.","GO_TO_TASKS_LIST":"Ir a la lista de actividades","CREATED_AT":"Creado en ","RESPONSIBLE_EMPLOYEE":"Empleado responsable: ","VISIT_DURATION":"Duración de la visita: ","MINUTES":" minutos","SCHEDULING_DATE_AND_TIME":"Fecha/hora de programación: ","START_DATE_AND_TIME":"Fecha/hora de inicio: ","DATE_AND_TIME_OF_CONCLUSION":"Fecha/hora de conclusión: ","NO_EMPLOYEE":"Sin colaborador"}},"SAVE":"Guardar"},"LAUNCH_VIDEO":{"TITLE":"Bienvenido a la nueva pestaña de vínculos","MESSAGE":"Visualiza sectores, ambientes y/o equipos vinculados a esta ubicación. ¡Mira el video a continuación o cierra esta ventana para probar la funcionalidad!"}},"EXPORT":{"TITLE":"Exportación de Ubicaciones","CONTENT":"Al hacer clic en exportar, recibirá un enlace de descarga de la exportación en su correo electrónico <b>{{ email }}</b>. Dependiendo de la cantidad de información, la exportación puede tardar algunos minutos en completarse.","YES":"SÍ","NO":"NO","CONFIRM_ACTION_CONTENT":"¿Desea continuar con la exportación?","SPREADSHEET_SENT":"La hoja de cálculo se enviará a {{email}} en unos minutos","SPREADSHEET_ERROR":"Oops, algo salió mal y no se pudo exportar sus ubicaciones :("}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/locations/i18n/pt.json',
    '{"LOCATIONS":{"PAGE_TITLE":"Localizações","TITLE":"Localizações","VIEW":"Visualizar","GENERATE_QR_CODE":"Gerar código QR","PRODUCT_SERVICE_EDIT_NOT_ALLOWED":"Não é possível editar um produto/serviço bloqueado","EDIT":"Editar","MAP":{"TITLE":"Atualizar coordenadas","ALERT":"Arraste o ícone de prédio no local desejado para atualizar as coordenadas da localização.","UPDATE":"ATUALIZAR"},"TOOLBAR":{"ADD":"Adicionar localização","FILTER":"Filtrar localizações","RELOAD":"Recarregar localizações"},"FILTERS":{"CLEAR":"Limpar filtros","LABELS":{"LOCATION_NAME":"Buscar por nome da localização","LOCATION_DESCRIPTION":"Buscar por descrição da localização","CUSTOMER_NAME":"Pesquise pelo nome do cliente","DOCUMENT_NUMBER":"Buscar por CPF/CNPJ","STREET":"Buscar por rua","CITY":"Buscar por cidade","STATE":"Buscar por estado","STATUS":"Filtrar por situação"},"STATUS":{"ALL":"Todos","ARCHIVED":"Arquivados","UNARCHIVED":"Ativos"},"BY_TERRITORY":{"LABEL":"Filtrar por território","SEARCH":"Pesquisar território","SEARCH_LABEL":"Selecione o território"},"BY_SUBTERRITORY":{"LABEL":"Filtrar por subterritório","SEARCH":"Pesquisar subterritório","SEARCH_LABEL":"Selecione o subterritório"}},"TABLE":{"COLUMNS":{"NAME":"Nome da localização","CUSTOMER":"Cliente","ADDRESS":"Endereço da localização","DOCUMENT_NUMBER":"CPF/CNPJ","ACTIONS":"Ações"}},"DIALOG":{"VIEW_VISIT":"Visualizar visita","SAVED":"Localização \'{{name}}\' salva.","ERROR_SAVING":"Houve um erro ao salvar a localização","ERROR_SAVING_CONTACTS":"Houve um erro ao salvar os contatos da localização","ERROR_SAVING_PRIMARY_LOCATION":"Houve um erro ao salvar a localização primária do cliente","ERROR_DUPLICATED":"Já existe uma localização com o mesmo nome para este cliente","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar","GENERAL":{"SELECT_AS_PRIMARY":"<strong>Selecionar</strong> a localização como a <strong>principal</strong> deste cliente","PRIMARY_LOCATION":"Esta é a localização <strong>principal</strong> deste cliente, portanto não pode ser arquivada.","SEARCH_BY_CEP":"Buscar por CEP","SEARCH_BY_GOOGLE":"Buscar por Google","TERRITORIES":"Territórios","SUBTERRITORIES":"Subterritórios","SECTIONS":{"LOCATION_DATA":{"TITLE":"Dados da localização","FIELDS":{"LOCATION_NAME":"Nome da localização","LOCATION_ADDRESS":"Endereço da localização","DOCUMENT_NUMBER":"CPF/CNPJ","CEP":"CEP","STREET":"Logradouro","NUMBER":"Número","NEIGHBORHOOD":"Bairro","CITY":"Cidade","STATE":"Estado","ADDRESS_COMPLEMENT":"Complemento do endereço","NOTES":"Observações","CUSTOMER":"Cliente"}}}},"CONTACT":{"CONTACT_TYPES":{"WORK":"Trabalho","PERSONAL":"Pessoal","HOME":"Casa","PHONE":"Celular"},"CONTACT_INFOS":{"SUBTITLE_PHONE":"Telefones","SUBTITLE_EMAIL":"E-mails","DELETE_CONTACT":"Deletar contato","ADD_PHONE":"Adicionar telefone","ADD_EMAIL":"Adicionar e-mail","SELECT_AS_MAIN_PHONE":"Considerar como telefone principal","SELECT_AS_MAIN_EMAIL":"Considerar como e-mail principal","EMPTY_PHONES":"Nenhum telefone cadastrado.","EMPTY_EMAILS":"Nenhum e-mail cadastrado.","FIELDS":{"NAME":"Nome do contato","EMAIL":"E-mail","PHONE":"Número","PHONE_TYPE":"Tipo","EMAIL_TYPE":"Tipo"}}},"EQUIPMENTS":{"HINT":"Para garantir uma melhor experiência, estamos migrando a aba <span class=\'tw-font-medium\'>\'Equipamentos\'</span> para <span class=\'tw-font-medium\'>\'Vínculos\'</span>. Em breve, a aba <span class=\'tw-font-medium\'>\'Equipamentos\'</span> será desativada. <span class=\'tw-text-color-primary tw-font-medium tw-cursor-pointer go-to-links\'>Clique aqui</span> para saber mais!","TITLE":"Equipamentos","SEARCH_EQUIPMENTS":"Buscar por equipamentos vinculados","SEARCH_DESCRIPTION":"Busque pelo nome ou número de série.","REGISTER_NEW":"Cadastrar novo","EDIT_EQUIPMENT":"Editar equipmento","PAGINATION":{"PREVIOUS":"Anterior","NEXT":"Próximo","SHOWING_FROM":"Mostrando de","TO":"até","OF":"de","RECORDS":"registros"}},"ATTACHMENTS":{"TITLE":"Anexos","NO_TITLE":"Sem título","DROP_HERE":"Arraste seus arquivos para fazer upload","NOT_SUPPORTED_FILE_DRAG":"O arquivo não é suportado pelo seu navegador","ATTACHMENT_DESCRIPTION":"Limite de 10 anexos. Tamanho máximo 10MB por arquivo","INSERT_FILES":"Inserir arquivos","INSERT_FILES_ALTERNATIVE":"Arraste seus arquivos para fazer upload ou","SEND_FILES":"Enviar arquivos","NO_ATTACHMENTS_ADDED":"Nenhum anexo foi adicionado para essa localização.","SEARCHING_ATTACHMENTS":"Buscando anexos da localização","ATTACHMENTS_LIMIT_REACHED":"Limite de anexos atingido, para adicionar mais anexos você precisa remover alguns primeiro.","MAX_SIZE_FILES":"Este arquivo excede o limite de 20MB","SAVE_TITLE_SUCESS":"Título do anexo alterado com sucesso.","FILES":{"MOVE_UP":"Mover para cima","MOVE_DOWN":"Mover para baixo","SAVE_EDIT":"Salvar título","CANCEL_EDIT":"Cancelar","NO_TITLE":"Sem título","SIGNATURE":"Assinatura","EDIT_TITLE":"Editar título do anexo","EDIT_CUSTOMER_NAME":"Editar nome do cliente","OF":"de","ADDED_AT":"Criado em {{ date }} às {{ hour }}","EDIT":"Editar","VIEW_ORIGINAL":"Ver original","ARCHIVED":"Arquivado","ACTIONS":{"REMOVE":"Remover anexo","ARCHIVE":"Arquivar anexo","UNARCHIVE":"Desarquivar anexo"},"ALERTS":{"REMOVE_SIGNATURE":"Tem certeza que deseja <strong>remover</strong> esta assinatura?","REMOVE_ATTACHMENT":"Tem certeza que deseja <strong>remover</strong> este anexo?","ARCHIVE_SIGNATURE":"Tem certeza que deseja <strong>arquivar</strong> esta assinatura?","ARCHIVE_ATTACHMENT":"Tem certeza que deseja <strong>arquivar</strong> este anexo?","YES":"Sim","NO":"Não"}},"RENAME_MODAL":{"TITLE":"Renomear anexo","SUCCESS_MESSAGE":"Anexo renomeado com sucesso"},"ARCHIVE_MODAL":{"ARCHIVE_TITLE":"Arquivar anexo","UNARCHIVE_TITLE":"Desarquivar anexo","ARCHIVE_CONTENT":"Tem certeza que deseja arquivá-lo?","UNARCHIVE_CONTENT":"Tem certeza que deseja desarquivá-lo?","SUCCESS_MESSAGE":"Anexo arquivado com sucesso","SUCCESS_UNARCHIVE_MESSAGE":"Anexo desarquivado com sucesso"},"ERROR_MESSAGE":"Houve um erro, por favor tente novamente","ERROR_MESSAGE_FILE_SIZE":"Este arquivo excede o limite de 10MB.","ERROR_MESSAGE_MAX_FILES":"Você atingiu o limite de 10 anexos.","LINK":"LINK"},"NEW":{"TITLE":"Nova localização","VALIDATION_ERRORS":{"REQUIRED":"Este campo é obrigatório.","PATTERN_ZIP_CODE":"CEP inválido.","MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}.","MIN_LENGTH":"Esse campo deve possuir no mínimo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}.","EMAIL":"E-mail inválido.","INVALID_DOCUMENT":"{{ documentName }} inválido.","INVALID_PHONE":"Número de telefone inválido.","DUPLICATED_LOCATION_NAME":"Nome de localização duplicado","DISABLED_CREATE_LOCATION":"Não é possível cadastrar localizações para um cliente da <b>{{ customerAccountName }}</b>."},"CREATE_NEW_LOCATION":"Criar"},"VIEW":{"TITLE":"Ver localização","TABS":{"GENERAL":"GERAL","CONTACTS":"CONTATOS","LOCATION_LINKS":"VÍNCULOS","EQUIPMENTS":"EQUIPAMENTOS","ATTACHMENTS":"ANEXOS","SERVICES":{"TITLE":"Atendimento","NO_HISTORY":"Essa localização não possui histórico de atendimento.","GO_TO_TASKS_LIST":"Ir para a lista de atividades","CREATED_AT":"Criado em ","RESPONSIBLE_EMPLOYEE":"Colaborador responsável: ","VISIT_DURATION":"Duração da visita: ","MINUTES":" minutos","SCHEDULING_DATE_AND_TIME":"Data/hora de agendamento: ","START_DATE_AND_TIME":"Data/hora de início: ","DATE_AND_TIME_OF_CONCLUSION":"Data/hora de conclusão: ","NO_EMPLOYEE":"Sem colaborador"}},"SAVE":"Salvar"},"LAUNCH_VIDEO":{"TITLE":"Bem-vindo(a) à nova aba de vínculos","MESSAGE":"Visualize setores, ambientes e/ou equipamentos vinculados à esta localização. Assista ao vídeo abaixo ou feche esta janela para testar a funcionalidade!"}},"EXPORT":{"TITLE":"Exportação de Localizações","CONTENT":"Ao clicar em exportar, você receberá um link de download da exportação no seu e-mail <b>{{ email }}</b>. Dependendo da quantidade de informações, a exportação poderá demorar alguns minutos para ser finalizada.","YES":"SIM","NO":"NÃO","CONFIRM_ACTION_CONTENT":"Deseja continuar com a exportação?","SPREADSHEET_SENT":"A planilha será enviada para o e-mail {{email}} em alguns minutos","SPREADSHEET_ERROR":"Ooops, algo errado aconteceu e não foi possível exportar suas localizações :("}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/materials/i18n/en.json',
    '{"MATERIALS":{"PAGE_TITLE":"Materials","TITLE":"Materials","SEARCH_PLACEHOLDER":"Search","DESCRIPTION":"Control and manage your Materials","RELOAD":"Reload","ADD":"Add new material","SUCCESSFULLY_SAVED":"Material saved successfully!","SUCCESSFULLY_ARCHIVED":"Material archived successfully!","SUCCESSFULLY_UNARCHIVED":"Material unarchived successfully!","ERROR_ON_SAVING":"An unexpected error occurred while saving the material.","ERROR_ON_SEARCH":"An unexpected error occurred while searching for materials.","ARCHIVED":"Archived","UNARCHIVED":"Unarchived","FILTERS":{"TITLE":"Filter materials","CLEAR":"Clear filters","NAME":"Filter by name","STATUS":"Filter by situation","ACTIVE":"Active","INACTIVE":"Archived","ALL":"All"},"DIALOG":{"QUOTATION_ALERT":"Register the materials that will be used in the execution of the activity. For example: equipament components.","QUOTATION_INFO":"Material information","TITLE_EDIT":"Edit material","TITLE_NEW":"New material","SAVE":"SAVE","CREATE":"CREATE","ARCHIVE_MATERIAL":"Archive material","UNARCHIVE_MATERIAL":"Unarchive material"},"MODEL":{"NAME":"Material name","MEASURE":"Material measure","ERRORS":{"NAME_REQUIRED":"Name is required","MEASURE_REQUIRED":"Material measure is required","MAX_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but it has {{ receivedLength }}."}},"MEASURES":{"UNITY":"Units (UN)","METER":"Meters (M)","CENTIMETER":"Centimeters (CM)","LITER":"Liters (LT)","MILLILITER":"Milliliters (ML)","KILOGRAM":"Kilograms (KG)","GRAM":"Grams (G)","SQUARE_METERS":"Square meters","CUBIC_METERS":"Cubic meters","TONS_REFRIGERATION":"Tons of refrigeration","DISLOCATION":"Displacement","CJT":"CJT","OTHERS":"Others"},"DATATABLE":{"NAME":"Material name","MEASURE":"Material measures","CREATED_AT":"Created at","ACTIONS":"Actions","EDIT":"Edit","EDIT_LOCKED":"You do not have permission to edit this material"},"MIGRATION":{"NEWS_FOR_YOU":"We have a new feature for you!","MIGRATION_DONE":"Migration of materials to products performed!","NOW_IS_POSSIBLE":"Did you see that now it\'s possible to link products in service orders, either through the dashboard or the employee app? Oh, and the linked products appear both in the service order report and in the activity export. Pretty cool, right?","WE_WILL_UNIFY":"But you may be wondering: what does this have to do with materials? Well, we understand that the same information registered as materials can also be registered as products. That\'s why we will unify this registration into one: products.","FIRST_STEP":"We\'ve already taken the first step towards this change, which was to create the possibility of linking products in activities, something that was also possible with materials. The next step is to migrate all your materials to products, so you can continue to control all the inputs used in an activity, but now through products.","ITS_YOU":"You will perform this migration! To do this, just click the button below and the migration will begin. But hey, what happens when I click the button? Well, there are 3 things:","MATERIALS_WILL_BECOME_PRODUCTS":"1. All your active materials will become products, that is, they will be available for consultation on the Products screen;","MATERIALS_OS":"2. All materials linked in activities will still be linked to them, but now as products (that is, their history will remain intact);","BUTTON_CREATE_MATERIALS":"3. The buttons to create new materials and filter them will be blocked, as you can now do all the control of inputs through products.","IMPORTANT":"It is important to note that this action is irreversible. Therefore, we recommend that you review your materials before performing the migration.","DEFINED_VALUE":"Materials converted into products will be without a defined value ($), which will not prevent them from being linked in activities. We suggest that values be gradually inserted into the registration of these new products, as they are being used.","CONTACT_SUPPORT":"In case of doubts, contact our support or your account manager, okay? 😉","MINIMIZE":"Minimize","EXPAND":"Expand","MIGRATE":"Migrate materials to products","YES":"Yes","NO":"No","DESCRIPTION":"All active materials will be converted into products and moved to the corresponding listing. Are you sure you want to perform the migration?","IN_PROGRESS":"Migration in progress","ALERT_DESCRIPTION":"Okay, we\'re already migrating materials to products. We\'ll let you know when everything is ready. 😉","DONE_EXPLANATION":{"MIGRATION_DONE":"The migration of materials to the products dashboard has been completed. The reason for this action is to unify both registrations into one, facilitating their linkage in service orders. But don\'t worry, you can continue to control all your inputs (previously called materials) on the Products and Services screen, but now as products.","MATERIALS":"The \'materials\' will continue to be linked in previous service orders, but as products, maintaining their history intact.","BUTTONS":"The buttons to create new materials and filter are blocked for use, as this screen has been discontinued, since the materials had the same specifications as products, thus, we enable migration to unify and provide our customers with more ease in using the platform. The materials converted into products will be without a defined value ($), which does not prevent them from being linked in activities. We suggest that values be gradually inserted into the registration of these new products, as they are being used.","DOUBTS":"In case of doubts, contact our support or your account manager, okay? 😉"},"GO_TO_PRODUCTS":"Go to products","APP_OUTDATED":"Outdated employee app","APP_OUTDATED_IN_DEVICES":"Outdated employee app on {{devicesNumber}} devices","DESCRIPTION_DEVICES":"The migration of materials to products cannot be performed because there are <b style=\'color: blue\'> {{devicesNumber}} employees </b> with the outdated app. If the migration is carried out without this update, the employee will not be able to view the products in the activity or link new ones. Instruct your employees to perform the update and return to complete the migration.","CANCEL":"Cancel","TRY_AGAIN":"Try again","OUTDATED":"Discontinued"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/materials/i18n/es.json',
    '{"MATERIALS":{"PAGE_TITLE":"Materiales","TITLE":"Materiales","SEARCH_PLACEHOLDER":"Buscar","DESCRIPTION":"Los materiales te permiten controlar y gestionar el inventario de materiales","RELOAD":"Recargar","ADD":"Agregar nuevo material","SUCCESSFULLY_SAVED":"¡Material guardado correctamente!","SUCCESSFULLY_ARCHIVED":"¡Material archivado correctamente!","SUCCESSFULLY_UNARCHIVED":"¡Material desarquivado correctamente!","ERROR_ON_SAVING":"Se produjo un error inesperado al guardar el material.","ERROR_ON_SEARCH":"Se produjo un error inesperado al buscar los materiales.","ARCHIVED":"Archivado","UNARCHIVED":"Desarchivado","FILTERS":{"TITLE":"Filtrar materiales","CLEAR":"Limpiar filtros","NAME":"Filtrar por nombre","STATUS":"Filtrar por estado","ACTIVE":"Activos","INACTIVE":"Archivados","ALL":"Todos"},"DIALOG":{"QUOTATION_ALERT":"Registre los materiales que se utilizarán en la realización de un servicio. Ejemplo: componentes de un equipo.","QUOTATION_INFO":"Información del material","TITLE_EDIT":"Editar material","TITLE_NEW":"Nuevo material","SAVE":"GUARDAR","CREATE":"CREAR","ARCHIVE_MATERIAL":"Archivar material","UNARCHIVE_MATERIAL":"Desarchivar material"},"MODEL":{"NAME":"Nombre del material","MEASURE":"Medida del material","ERRORS":{"NAME_REQUIRED":"El nombre es obligatorio","MEASURE_REQUIRED":"La medida del material es obligatoria","MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}."}},"MEASURES":{"UNITY":"Unidades (UN)","METER":"Metros (M)","CENTIMETER":"Centímetros (CM)","LITER":"Litros (LT)","MILLILITER":"Mililitros (ML)","KILOGRAM":"Kilogramos (KG)","GRAM":"Gramos (G)","SQUARE_METERS":"Metros cuadrados","CUBIC_METERS":"Metros cúbicos","TONS_REFRIGERATION":"Toneladas de refrigeración","DISLOCATION":"Desplazamiento","CJT":"CJT","OTHERS":"Otros"},"DATATABLE":{"NAME":"Nombre del material","MEASURE":"Medida del material","CREATED_AT":"Creado en","ACTIONS":"Acciones","EDIT":"Editar","EDIT_LOCKED":"No tienes permiso para editar este material"},"MIGRATION":{"NEWS_FOR_YOU":"¡Tenemos noticias para ti!","MIGRATION_DONE":"¡Migración de materiales a productos realizada!","NOW_IS_POSSIBLE":"¿Viste que ahora es posible vincular productos en órdenes de servicio, ya sea a través del panel o de la aplicación del empleado? Oh, y los productos vinculados aparecen tanto en el informe de la orden de servicio como en la exportación de actividades. Bastante genial, ¿verdad?","WE_WILL_UNIFY":"Pero quizás te estés preguntando: ¿qué tiene que ver esto con los materiales? Bueno, entendemos que la misma información registrada como materiales también puede registrarse como productos. Por eso, vamos a unificar este registro en uno solo: productos.","FIRST_STEP":"Ya hemos dado el primer paso hacia este cambio, que fue crear la posibilidad de vincular productos en actividades, algo que también era posible con los materiales. El siguiente paso es migrar todos tus materiales a productos, para que puedas seguir controlando todas las entradas utilizadas en una actividad, pero ahora a través de productos.","ITS_YOU":"¡Tú realizarás esta migración! Para hacerlo, simplemente haz clic en el botón a continuación y comenzará la migración. Pero hey, ¿qué sucede cuando hago clic en el botón? Bueno, hay 3 cosas:","MATERIALS_WILL_BECOME_PRODUCTS":"1. Todos tus materiales activos se convertirán en productos, es decir, estarán disponibles para su consulta en la pantalla de Productos;","MATERIALS_OS":"2. Todos los materiales vinculados en actividades seguirán vinculados a ellas, pero ahora como productos (es decir, su historial permanecerá intacto);","BUTTON_CREATE_MATERIALS":"3. Los botones para crear nuevos materiales y filtrarlos se bloquearán, ya que ahora puedes hacer todo el control de las entradas a través de productos.","IMPORTANT":"Es importante tener en cuenta que esta acción es irreversible. Por lo tanto, recomendamos que revises tus materiales antes de realizar la migración.","DEFINED_VALUE":"Los materiales convertidos en productos no tendrán un valor definido ($), lo que no les impedirá vincularse en actividades. Sugerimos que los valores se inserten gradualmente en el registro de estos nuevos productos, a medida que se vayan utilizando.","CONTACT_SUPPORT":"En caso de dudas, ponte en contacto con nuestro soporte o con tu gerente de cuenta, ¿vale? 😉","MINIMIZE":"Minimizar","EXPAND":"Expandir","MIGRATE":"Migrar materiales a productos","YES":"Sí","NO":"No","DESCRIPTION":"Todos los materiales activos se convertirán en productos y se moverán a la lista correspondiente. ¿Estás seguro de que deseas realizar la migración?","IN_PROGRESS":"Migración en progreso","ALERT_DESCRIPTION":"De acuerdo, ya estamos migrando materiales a productos. Te avisaremos cuando todo esté listo. 😉","DONE_EXPLANATION":{"MIGRATION_DONE":"Se ha completado la migración de materiales al panel de productos. El motivo de esta acción es unificar ambos registros en uno solo, facilitando su vinculación en órdenes de servicio. Pero no te preocupes, puedes seguir controlando todas tus entradas (anteriormente llamadas materiales) en la pantalla de Productos y Servicios, pero ahora como productos.","MATERIALS":"Los \'materiales\' seguirán vinculados en órdenes de servicio anteriores, pero como productos, manteniendo su historial intacto.","BUTTONS":"Los botones para crear nuevos materiales y filtrar están bloqueados para su uso, ya que esta pantalla ha sido descontinuada, ya que los materiales tenían las mismas especificaciones que los productos, así que permitimos la migración para unificar y proporcionar a nuestros clientes más facilidad en el uso de la plataforma. Los materiales convertidos en productos no tendrán un valor definido ($), lo que no les impide vincularse en actividades. Sugerimos que los valores se inserten gradualmente en el registro de estos nuevos productos, a medida que se vayan utilizando.","DOUBTS":"En caso de dudas, ponte en contacto con nuestro soporte o con tu gerente de cuenta, ¿vale? 😉"},"GO_TO_PRODUCTS":"Ir a productos","APP_OUTDATED":"Aplicación de empleado desactualizada","APP_OUTDATED_IN_DEVICES":"Aplicación de empleado desactualizada en {{devicesNumber}} dispositivos","DESCRIPTION_DEVICES":"La migración de materiales a productos no se puede realizar porque hay <b style=\'color: blue\'> {{devicesNumber}} empleados </b> con la aplicación desactualizada. Si se realiza la migración sin esta actualización, el empleado no podrá ver los productos en la actividad ni vincular nuevos. Instruye a tus empleados a realizar la actualización y vuelve para completar la migración.","CANCEL":"Cancelar","TRY_AGAIN":"Intentar de nuevo","OUTDATED":"Descontinuado"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/materials/i18n/pt.json',
    '{"MATERIALS":{"PAGE_TITLE":"Materiais","TITLE":"Materiais","SEARCH_PLACEHOLDER":"Pesquisar","DESCRIPTION":"Materiais permite controlar e gerir o inventário de materiais","RELOAD":"Recarregar","ADD":"Adicionar novo material","SUCCESSFULLY_SAVED":"Material salvo com sucesso!","SUCCESSFULLY_ARCHIVED":"Material arquivado com sucesso!","SUCCESSFULLY_UNARCHIVED":"Material desarquivado com sucesso!","ERROR_ON_SAVING":"Ocorreu um erro inesperado ao salvar o material.","ERROR_ON_SEARCH":"Ocorreu um erro inesperado ao buscar os materiais.","ARCHIVED":"Arquivado","UNARCHIVED":"Desarquivado","FILTERS":{"TITLE":"Filtrar materiais","CLEAR":"Limpar filtros","NAME":"Filtrar por nome","STATUS":"Filtrar por situação","ACTIVE":"Ativos","INACTIVE":"Arquivados","ALL":"Todos"},"DIALOG":{"QUOTATION_ALERT":"Cadastre os materiais a serem utilizados na realização de um atendimento. Exemplo: componentes de um equipamento.","QUOTATION_INFO":"Informações do material","TITLE_EDIT":"Editar material","TITLE_NEW":"Novo material","SAVE":"SALVAR","CREATE":"CRIAR","ARCHIVE_MATERIAL":"Arquivar material","UNARCHIVE_MATERIAL":"Desarquivar material"},"MODEL":{"NAME":"Nome do material","MEASURE":"Medida do material","ERRORS":{"NAME_REQUIRED":"Nome é obrigatório","MEASURE_REQUIRED":"Medida do material é obrigatória","MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}."}},"MEASURES":{"UNITY":"Unidades (UN)","METER":"Metros (M)","CENTIMETER":"Centímetros (CM)","LITER":"Litros (LT)","MILLILITER":"Mililitros (ML)","KILOGRAM":"Quilograma (KG)","GRAM":"Gramas (G)","SQUARE_METERS":"Metros quadrados","CUBIC_METERS":"Metros cúbicos","TONS_REFRIGERATION":"Toneladas de refrigeração","DISLOCATION":"Deslocamento","CJT":"CJT","OTHERS":"Outros"},"DATATABLE":{"NAME":"Nome do material","MEASURE":"Medida do material","CREATED_AT":"Criado em","ACTIONS":"Ações","EDIT":"Editar","EDIT_LOCKED":"Você não tem permissão para editar esse material"},"MIGRATION":{"NEWS_FOR_YOU":"Temos uma novidade para você!","MIGRATION_DONE":"Migração de materiais para produtos realizada!","NOW_IS_POSSIBLE":"Viu que agora é possível vincular produtos nas ordens de serviço, seja pelo painel ou pelo app do colaborador? Ah, e os produtos vinculados aparecem tanto no relatório da OS quanto na exportação de atividades. Bem legal, né?","WE_WILL_UNIFY":"Mas você deve estar se perguntando: o que isso tem a ver com os materiais? Bem, entendemos que as mesmas informações cadastradas como materiais também podem ser cadastradas como produto. Por isso, iremos unificar esse cadastro em um só: produtos.","FIRST_STEP":"Já demos o primeiro passo para essa mudança, que foi criar a possibilidade de vincular produtos nas atividades, algo que também é possível fazer com materiais. O próximo passo consiste em migrar todos os seus materiais para produtos, para que você continue fazendo o controle de todos os insumos utilizados em uma atividade, porém, agora, através dos produtos.","ITS_YOU":"Quem fará essa migração é você! Para isso, basta clicar no botão abaixo que a migração será iniciada. Mas beleza, o que acontece quando eu clicar no botão? Bom, são 3 coisas:","MATERIALS_WILL_BECOME_PRODUCTS":"1. Todos os seus materiais ativos se tornarão produtos, isto é, eles estarão disponíveis para consulta na tela de Produtos;","MATERIALS_OS":"2. Todos os materiais vinculados em atividades ainda continuarão vinculados a elas, porém, agora como produtos (ou seja, o seu histórico continuará intacto);","BUTTON_CREATE_MATERIALS":"3. O botão de criar novos materiais e filtrá-los ficarão bloqueados, já que agora você poderá fazer todo o controle dos insumos através dos produtos.","IMPORTANT":"Importante ressaltar que esta ação é irreversível. Por isso, recomendamos que seja feita uma conferência dos seus materiais antes de realizar a migração.","DEFINED_VALUE":"Os materiais convertidos em produtos ficarão sem valor ($) definido, o que não os impedirá de serem vinculados nas atividades. Sugerimos que os valores sejam inseridos pouco a pouco no cadastro destes novos produtos, conforme eles vão sendo utilizados.","CONTACT_SUPPORT":"No caso de dúvidas, entre em contato com o nosso suporte ou com o seu gerente de contas, combinado? 😉","MINIMIZE":"Minimizar","EXPAND":"Expandir","MIGRATE":"Migrar materiais para produtos","YES":"Sim","NO":"Não","DESCRIPTION":"Todos os materiais ativos serão convertidos em produtos e movidos para a listagem correspondente. Tem certeza que deseja realizar a migração?","IN_PROGRESS":"Migração em andamento","ALERT_DESCRIPTION":"Beleza, já estamos migrando os materiais para produtos. Vamos te avisar quando estiver tudo pronto. 😉","DONE_EXPLANATION":{"MIGRATION_DONE":"Foi realizada a migração dos materiais para o painel de produtos. O motivo desta ação é unificar ambos os cadastros em um só, facilitando o vínculo deles nas ordens de serviço. Mas fique tranquilo, você pode continuar fazendo o controle de todos os seus insumos (anteriormente chamados de materiais) na tela de Produtos e Serviços, porém, agora como produtos.","MATERIALS":"Os “materiais” continuarão vinculados em ordens de serviço anteriores, porém como produtos, mantendo o histórico delas intacto.","BUTTONS":"O botão de criar novos materiais e filtrar estão bloqueados para uso, pois esta tela foi descontinuada, uma vez que os materiais tinham as mesmas especificações de produtos, dessa forma, possibilitamos a migração para unificar e proporcionar ao nosso cliente mais facilidade no uso da plataforma. Os materiais convertidos em produtos ficaram sem valor ($) definido, o que não os impede de serem vinculados nas atividades. Sugerimos que os valores sejam inseridos pouco a pouco no cadastro destes novos produtos, conforme eles vão sendo utilizados.","DOUBTS":"No caso de dúvidas, entre em contato com o nosso suporte ou com o seu gerente de contas, combinado? 😉"},"GO_TO_PRODUCTS":"Ir para produtos","APP_OUTDATED":"Aplicativo do colaborador desatualizado","APP_OUTDATED_IN_DEVICES":"Aplicativo do colaborador desatualizado em {{devicesNumber}} dispositivos","DESCRIPTION_DEVICES":"A migração de materiais para produtos não pode ser realizada porque há <b style=\'color: blue\'> {{devicesNumber}} colaboradores </b> com o app desatualizado. Se a migração for efetuada sem essa atualização, o colaborador não conseguirá visualizar os produtos na atividade nem vincular novos. Oriente seus colaboradores a realizarem a atualização e retorne para concluir a migração. ","CANCEL":"Cancelar","TRY_AGAIN":"Tentar novamente","OUTDATED":"Descontinuado"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/i18n/en.json',
    '{"MODULES":{"PAGE_TITLE":"Modules","TITLE":"Modules","ENABLE":"ENABLE","DISABLE":"DISABLE","SAVE_SETTINGS":"SAVE","END_ACTIVATION":"END ACTIVATION","CANCEL":"CANCEL","HIRING":"HIRING","REQUEST_ACTIVATION":{"BUTTON":"Hiring","SUCCESS":"Request sent successfully! We will contact you soon.","ERROR":"Error on sending request, please check your connection and try again later.","DIALOG":{"TITLE":"Request activation of this module?","DESCRIPTION":"This is a <strong>paid</strong> module and there is an additional cost for its acquisition. <br> By confirming, we will contact you to finalize the hiring process.","OK":"REQUEST","CANCEL":"CANCEL","IMPORT":"IMPORT"},"TRIAL_DIALOG":{"TITLE":"Regularize your account!","DESCRIPTION":"This module is only available for Field Control customers. <br> Request a demonstration from your consultant in our commercial team.","OK":"CLOSE"}},"PAID_MODULE":"Paid module","FREE_MODULE":"Free module","SEE_DESCRIPTION":"See description","SEE_SETTINGS":"See Settings","NO_CONFIG":"The module is active, but there are no additional settings available","NO_OPTION_FOUND":"No option found","MODULES_SAVED":"Module settings saved successfully.","MODULES_ERROR":"Unable to make the modification. Check your connection.","DISABLE_MODULE":{"TITLE":"Disable module","CONTENT":"Are you sure you want to disable this module?"},"MODULE_CARD":{"ENABLED":"enabled","DISABLED":"disabled","MANAGE":"MANAGE","SEE":"SEE","NEW":"new!"},"MODULE_VIDEO":{"PLAY_BUTTON":"Play video"},"DIALOGS":{"CLOSE":"Close"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/i18n/es.json',
    '{"MODULES":{"PAGE_TITLE":"Módulos","TITLE":"Módulos","ENABLE":"ACTIVAR","DISABLE":"DESACTIVAR","SAVE_SETTINGS":"GUARDAR","END_ACTIVATION":"FINALIZAR ACTIVACIÓN","CANCEL":"CANCELAR","HIRING":"CONTRATAR","REQUEST_ACTIVATION":{"BUTTON":"Contrato","SUCCESS":"¡Solicitud enviada con éxito! Nos pondremos en contacto con usted pronto.","ERROR":"Error al enviar la solicitud, verifique su conexión y vuelva a intentarlo más tarde.","DIALOG":{"TITLE":"¿Solicitar activación de este módulo?","DESCRIPTION":"Este es un módulo <strong>pago</strong> y hay un costo adicional para su adquisición. <br> Al confirmar, nos pondremos en contacto contigo para finalizar el proceso de contratación.","OK":"SOLICITAR","CANCEL":"CANCELAR","IMPORT":"IMPORTAR"},"TRIAL_DIALOG":{"TITLE":"¡Regulariza tu cuenta!","DESCRIPTION":"Este módulo solo está disponible para clientes de Field Control. <br> Solicita una demostración a tu consultor en nuestro equipo comercial.","OK":"CERRAR"}},"PAID_MODULE":"Módulo de pago","FREE_MODULE":"Módulo gratuito","SEE_DESCRIPTION":"Ver Descripción","SEE_SETTINGS":"Ver Configuraciones","NO_CONFIG":"El módulo está activo, pero no hay configuraciones adicionales disponibles","NO_OPTION_FOUND":"No se encontró ninguna opción","MODULES_SAVED":"Configuraciones del módulo guardadas correctamente.","MODULES_ERROR":"No se pudo realizar la modificación. Verifica tu conexión.","DISABLE_MODULE":{"TITLE":"Desactivar Módulo","CONTENT":"¿Estás seguro de que quieres desactivar este módulo?"},"MODULE_CARD":{"ENABLED":"activado","DISABLED":"desactivado","MANAGE":"ADMINISTRAR","SEE":"VER","NEW":"¡nuevo!"},"MODULE_VIDEO":{"PLAY_BUTTON":"Iniciar video"},"DIALOGS":{"CLOSE":"Cerrar"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/i18n/pt.json',
    '{"MODULES":{"PAGE_TITLE":"Módulos","TITLE":"Módulos","ENABLE":"ATIVAR","DISABLE":"DESATIVAR","SAVE_SETTINGS":"SALVAR","END_ACTIVATION":"FINALIZAR ATIVAÇÃO","CANCEL":"CANCELAR","HIRING":"CONTRATAR","REQUEST_ACTIVATION":{"BUTTON":"Contratar","SUCCESS":"Solicitação enviada com sucesso! Entraremos em contato com você em breve.","ERROR":"Erro ao enviar solicitação, verifique sua conexão e tente novamente mais tarde.","DIALOG":{"TITLE":"Solicitar ativação desse módulo?","DESCRIPTION":"Esse é um módulo <strong>pago</strong> e há um custo adicional para sua aquisição. <br> Ao confirmar, <strong>entraremos em contato</strong> para definirmos a contratação","OK":"SOLICITAR","CANCEL":"CANCELAR","IMPORT":"IMPORTAR"},"TRIAL_DIALOG":{"TITLE":"Regularize sua conta!","DESCRIPTION":"Esse módulo é disponível apenas para clientes Field Control. <br> Solicite uma demonstração para seu consultor do nosso time comercial.","OK":"FECHAR"}},"PAID_MODULE":"Módulo pago","FREE_MODULE":"Módulo gratuito","SEE_DESCRIPTION":"Ver descrição","SEE_SETTINGS":"Ver configurações","NO_CONFIG":"O módulo está ativo, mas não há nenhuma configuração adicional disponível.","NO_OPTION_FOUND":"Nenhuma opção encontrada","MODULES_SAVED":"Configurações dos módulos salvas com sucesso.","MODULES_ERROR":"Não foi possível realizar a modificação. Verifique sua conexão.","DISABLE_MODULE":{"TITLE":"Desativar módulo","CONTENT":"Tem certeza que deseja desativar esse módulo?"},"MODULE_CARD":{"ENABLED":"ativado","DISABLED":"desativado","MANAGE":"GERENCIAR","SEE":"VER","NEW":"novo!"},"MODULE_VIDEO":{"PLAY_BUTTON":"Iniciar vídeo"},"DIALOGS":{"CLOSE":"Fechar"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/notifications/i18n/en.json',
    '{"NOTIFICATIONS":{"PAGE_TITLE":"Notifications","TITLE":"Notification center","DESCRIPTION":"The notification center has an overview of all Field Control\'s notifications","NO_RESULTS":"No notifications found yet","LOAD_MORE":"Load more","READ":"Mark as read","READ_ALL":"Mark all as read","GO_TO_NOTIFICATION_CENTER":"Go to Notification Center","FILTERS":{"TITLE":"Filters","ALL":"All","TICKETS":"Tickets","COMMENTS":"Comments","RATINGS":"Ratings","IMPEDIMENTS":"Impediments"},"ALL_NOTIFICATIONS":"All notifications"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/notifications/i18n/es.json',
    '{"NOTIFICATIONS":{"PAGE_TITLE":"Notificaciones","TITLE":"Centro de notificaciones","DESCRIPTION":"El centro de notificaciones proporciona una visión general de las alertas de Field Control","NO_RESULTS":"No se encontraron notificaciones","LOAD_MORE":"Cargar más","READ":"Marcar como leído","READ_ALL":"Marcar todo como leído","GO_TO_NOTIFICATION_CENTER":"Ir al centro de notificaciones","FILTERS":{"TITLE":"Filtros","ALL":"Todos","TICKETS":"Tickets","COMMENTS":"Comentarios","RATINGS":"Calificaciones","IMPEDIMENTS":"Impedimentos"},"ALL_NOTIFICATIONS":"Todas las notificaciones"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/notifications/i18n/pt.json',
    '{"NOTIFICATIONS":{"PAGE_TITLE":"Notificações","TITLE":"Central de notificações","DESCRIPTION":"A central de notificações permite uma visão geral de alertas do Field Control","NO_RESULTS":"Nenhuma notificação encontrada","LOAD_MORE":"Carregar mais","READ":"Marcar como lida","READ_ALL":"Marcar todos como lida","GO_TO_NOTIFICATION_CENTER":"Ir para a Central de Notificações","FILTERS":{"TITLE":"Filtros","ALL":"Todos","TICKETS":"Chamados","COMMENTS":"Conversas","RATINGS":"Avaliações","IMPEDIMENTS":"Impedimentos"},"ALL_NOTIFICATIONS":"Todas as notificações"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/plans/i18n/en.json',
    '{"PLANS":{"PAGE_TITLE":"Task plans","TITLE":"Task plans","DESCRIPTION":"Task plans are a routine where you can import tasks into Field Control based on a model spreadsheet.","SEARCH":"Search","DOWNLOAD_SPREADSHEET_MODEL":"Download template spreadsheet","NEW":"Create task plan","FILTER":"Filter task plan","RELOAD":"Update","MODEL":{"NAME":"Plan name","DESCRIPTION":"Description","NO_DESCRIPTION":"No description","PLANTYPE":"Plan type","CREATED_AT":"Created at","ERRORS":{"NAME_REQUIRED":"Name is required","PLANTYPE_REQUIRED":"Task plan type is required","DESCRIPTION_MAXLENGTH":"Description must have a maximum of 100 characters"}},"FILTERS":{"TITLE":"Filter task plans","CLEAR":"Clear filter","NAME":"Search by name","DESCRIPTION":"Search by description","PLANTYPE":"Search by plan type","SITUATIONS":{"TITLE":"Search by situation","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"}},"DIALOG":{"CLOSE":"Close","NEW":{"TITLE":"New task plan"},"EDIT":{"TITLE":"Edit task plan"},"IMPORT":{"TITLE":"Import task plan","MESSAGE":"Download our template spreadsheet below and fill it out with the necessary data to create your new task plan","UPLOAD_MESSAGE":"Click or drag the template spreadsheet to upload","DOWNLOAD_SPREADSHEET_MODEL":"Download template spreadsheet","SELECTED_SPREADSHEET":"Selected spreadsheet","MAX_SIZE":"Maximum file size is 10MB","ERROR":{"SIZE_NOT_ALLOWED":"The selected file is larger than allowed (maximum size: up to 10MB)","TYPE_NOT_ALLOWED":"The selected file is not a spreadsheet (.xlsx)"}},"GENERAL":{"TITLE":"General"},"ACTIVITIES":{"TITLE":"Tasks"},"ACTIONS":{"LOAD":"Import","LOADING":"Please wait, loading file...","DOWNLOAD":"DOWNLOAD TEMPLATE SPREADSHEET","SAVE":"Save","EDIT":"Edit","CREATE":"Create","ARCHIVE":"Archive","UNARCHIVE":"Unarchive","EXCEED_LIMIT":"Unable to import a spreadsheet with more than {{ activitiesLimit }} tasks. Review the spreadsheet."},"NAVIGATION":{"PREVIOUS":"Previous","NEXT":"Next","SHOWING_FROM":"Showing from","TO":"to","OF":"of","RECORDS":"records"},"ALERT":{"TITLE":"Could not save the task plan","ERROR":"Unable to archive the tasks linked to this task plan","ERROR_ARCHIVE":"An error occurred while archiving the task plan. Please contact support","ERROR_UNARCHIVE":"An error occurred while unarchiving the task plan. Please contact support","OK":"OK"},"CONFIRM_DIALOG":{"TITLE":"Upcoming tasks scheduled","CONTENT":"The task plan that you have archived has tasks scheduled for the next few days. What do you want to do with those tasks?","ERROR":"Unable to archive the tasks linked to this task plan","OK":"Archive","CANCEL":"Cancel"},"UNPROCESSABLE":{"TITLE":"Oops, unable to process the spreadsheet...","BUTTON":"OK, got it"}},"TABLE":{"ACTIVE":"Active","INACTIVE":"Inactive","DEADLINE":"Deadline (days)","SITUATION":"Situation","ACTIONS":"Actions","EDIT":"Edit","CREATE_PLANS_TYPE_CTA":"You can create a new task plan","CREATE_PLANS_TYPE_LINK":"by clicking here","INFO":{"NEW_PLAN":{"ACTIVITY_PLAN":"Task plan","MORE_DETAILS":"Show more details","LESS_DETAILS":" Show less details","VALID":"Valid","INVALID":"Invalid","COLUMNS":{"VALIDATION":"Validation","OS_TYPE":"OS type","CUSTOMER_NAME":"Customer","CUSTOMER_DOCUMENT_NUMBER":"Customer Document","LOCATION_NAME":"Location name","EQUIPMENT_NUMBER":"Equipment","EMPLOYEE_NAME":"Employee","SCHEDULE_DATE":"Scheduling date","SCHEDULE_HOUR":"Scheduling time","DESCRIPTION":"Description"},"IMPORT_ERRORS":{"COULD_NOT_READ":"Oops! An error occurred while trying to open the file, the file may be corrupted and cannot be opened!","CORPORATE_SERVICE":"You do not have permission to launch tasks of this type for customer {{ customerName }}","EMPTY":"CUSTOMER DOCUMENT or CUSTOMER NAME is mandatory","DATE_EMPTY":"SCHEDULE DATE is mandatory","INACTIVE":"Inactive/Archived","INACTIVE_FIRED":"Inactive/Outside of the hiring period","NOT_FOUND":"Not found with the specified name","DOCUMENT_NOT_FOUND":"Not found with the specified document","DESCRIPTION_NOT_FOUND":"Not found with the specified description","SERIAL_NUMBER_NOT_FOUND":"Not found with the specified serial number","DOCUMENT_NONSTANDARD":"Non-standard (CPF/CNPJ)","CUSTOMER_NOT_FOUND":"Customer not found","DUPLICATE_CUSTOMER":"Duplicate customers","DUPLICATE_LOCATION":"Duplicate locations","CUSTOMER_ARCHIVED":"This customer is archived","DATE_NONSTANDARD":"Non-standard (DD/MM/YY)","HOUR_NONSTANDARD":"Non-standard (HH:MM)","DATE_BEFORE_TODAY":"Date before today","INVALID_DATE":"Invalid date"},"UNPROCESSABLE":{"COLUMNS_NOT_FOUND":"Columns not found:","SPREADSHEET_TOO_BIG":"Unable to import a spreadsheet with more than {{ activitiesLimit }} tasks. Review the spreadsheet.","EMPTY_SPREADSHEET":"No data was found in the inserted spreadsheet. Review the spreadsheet."}},"ACTUAL_PLAN":{"SEE_ACTIVITIES":"See Tasks","WAITING_GENERATE":"Tasks are being generated. In a few minutes, they will appear here!","COLUMNS":{"STATUS":"Status","IDENTIFIER":"Identifier","OS_TYPE":"OS type","CUSTOMER_NAME":"Customer","LOCATION_NAME":"Location","SCHEDULE_DATE":"Scheduling date","EMPLOYEE":"Employee"}}}},"TOAST":{"SAVED":"Task plan \'{{ plan }}\' saved successfully.","EDITED":"Task plan \'{{ plan }}\' edited successfully.","ARCHIVED":"Task plan \'{{ plan }}\' archived successfully.","UNARCHIVED":"Task plan \'{{ plan }}\' unarchived successfully.","ERROR_SAVED":"An error occurred while saving the task plan. Please contact support.","SCHEDULED_TASKS_ARCHIVED":"Scheduled tasks archived successfully."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/plans/i18n/es.json',
    '{"PLANS":{"PAGE_TITLE":"Planes de actividades","TITLE":"Planes de actividades","DESCRIPTION":"Los planes de actividades son una rutina en la que puedes importar actividades a Field Control basadas en una hoja de cálculo modelo.","SEARCH":"Buscar","DOWNLOAD_SPREADSHEET_MODEL":"Descargar Modelo de Hoja de Cálculo","NEW":"Crear plan de actividad","FILTER":"Filtrar planes de actividades","RELOAD":"Recargar","MODEL":{"NAME":"Nombre del plan","DESCRIPTION":"Descripción","NO_DESCRIPTION":"Sin descripción","PLANTYPE":"Tipo de plan","CREATED_AT":"Creado en","ERRORS":{"NAME_REQUIRED":"El nombre es obligatorio","PLANTYPE_REQUIRED":"El tipo de plan de actividades es obligatorio","DESCRIPTION_MAXLENGTH":"La descripción debe tener un máximo de 100 caracteres"}},"FILTERS":{"TITLE":"Filtrar planes de actividades","CLEAR":"Limpiar filtro","NAME":"Buscar por nombre","DESCRIPTION":"Buscar por descripción","PLANTYPE":"Buscar por tipo de plan","SITUATIONS":{"TITLE":"Buscar por Situación","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"}},"DIALOG":{"CLOSE":"Cerrar","NEW":{"TITLE":"Nuevo plan de actividad"},"EDIT":{"TITLE":"Editar plan de actividad"},"IMPORT":{"TITLE":"Importar plan de actividad","MESSAGE":"Descarga nuestra hoja de cálculo modelo a continuación y rellénala con los datos necesarios para crear tu nuevo plan de actividades","UPLOAD_MESSAGE":"Haz clic o arrastra la hoja de cálculo modelo para subirla","DOWNLOAD_SPREADSHEET_MODEL":"Descargar Modelo de Hoja de Cálculo","SELECTED_SPREADSHEET":"Hoja de Cálculo Seleccionada","MAX_SIZE":"El tamaño máximo del archivo es de 10MB","ERROR":{"SIZE_NOT_ALLOWED":"El archivo seleccionado es más grande de lo permitido (tamaño máximo: hasta 10MB)","TYPE_NOT_ALLOWED":"El archivo seleccionado no es una hoja de cálculo (.xlsx)"}},"GENERAL":{"TITLE":"General"},"ACTIVITIES":{"TITLE":"Actividades"},"ACTIONS":{"LOAD":"Importar","LOADING":"Por favor espera, cargando archivo...","DOWNLOAD":"DESCARGAR HOJA DE CÁLCULO MODELO","SAVE":"Guardar","EDIT":"Editar","CREATE":"Crear","ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar","EXCEED_LIMIT":"No se puede importar una hoja de cálculo con más de {{ activitiesLimit }} actividades. Revisa la hoja de cálculo."},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Siguiente","SHOWING_FROM":"Mostrando de","TO":"a","OF":"de","RECORDS":"registros"},"ALERT":{"TITLE":"No se pudo guardar el plan de actividad","ERROR":"No se pudo archivar las actividades vinculadas a este plan de actividad","ERROR_ARCHIVE":"Se produjo un error al archivar el plan de actividades. Por favor contacta al soporte","ERROR_UNARCHIVE":"Se produjo un error al desarchivar el plan de actividades. Por favor contacta al soporte","OK":"OK"},"CONFIRM_DIALOG":{"TITLE":"Próximas actividades programadas","CONTENT":"El plan de actividades archivado tiene actividades programadas para los próximos días. ¿Qué deseas hacer con estas actividades?","ERROR":"No se pudo archivar las actividades vinculadas a este plan de actividad","OK":"Archivar","CANCEL":"Cancelar"},"UNPROCESSABLE":{"TITLE":"Vaya, no se pudo procesar la hoja de cálculo...","BUTTON":"OK, entendido"}},"TABLE":{"ACTIVE":"Activo","INACTIVE":"Inactivo","DEADLINE":"Plazo (días)","SITUATION":"Situación","ACTIONS":"Acciones","EDIT":"Editar","CREATE_PLANS_TYPE_CTA":"Puedes crear un nuevo plan de actividad","CREATE_PLANS_TYPE_LINK":"haciendo clic aquí","INFO":{"NEW_PLAN":{"ACTIVITY_PLAN":"Plan de actividad","MORE_DETAILS":"Mostrar más detalles","LESS_DETAILS":"Mostrar menos detalles","VALID":"Válido","INVALID":"Inválido","COLUMNS":{"VALIDATION":"Validación","OS_TYPE":"Tipo de OS","CUSTOMER_NAME":"Cliente","CUSTOMER_DOCUMENT_NUMBER":"Documento del cliente","LOCATION_NAME":"Nombre de la localización","EQUIPMENT_NUMBER":"Equipo","EMPLOYEE_NAME":"Empleado","SCHEDULE_DATE":"Fecha de programación","SCHEDULE_HOUR":"Hora de programación","DESCRIPTION":"Descripción"},"IMPORT_ERRORS":{"COULD_NOT_READ":"¡Vaya! Se produjo un error al intentar abrir el archivo, ¡puede que esté corrupto y no se pueda abrir!","CORPORATE_SERVICE":"No tienes permiso para lanzar actividades de este tipo para el cliente {{ customerName }}","EMPTY":"El DOCUMENTO DEL CLIENTE o el NOMBRE DEL CLIENTE son obligatorios","DATE_EMPTY":"La FECHA DE PROGRAMACIÓN es obligatoria","INACTIVE":"Inactivo/Archivado","INACTIVE_FIRED":"Inactivo/Fuera del período de contratación","NOT_FOUND":"No encontrado con el nombre especificado","DOCUMENT_NOT_FOUND":"No encontrado con el documento especificado","DESCRIPTION_NOT_FOUND":"No encontrado con la descripción especificada","SERIAL_NUMBER_NOT_FOUND":"No encontrado con el número de serie especificado","DOCUMENT_NONSTANDARD":"Fuera del estándar (CPF/CNPJ)","CUSTOMER_NOT_FOUND":"Cliente no encontrado","DUPLICATE_CUSTOMER":"Clientes duplicados","DUPLICATE_LOCATION":"Localizaciones duplicadas","CUSTOMER_ARCHIVED":"Este cliente está archivado","DATE_NONSTANDARD":"Fuera del estándar (DD/MM/AA)","HOUR_NONSTANDARD":"Fuera del estándar (HH:MM)","DATE_BEFORE_TODAY":"Fecha anterior a hoy","INVALID_DATE":"Fecha inválida"},"UNPROCESSABLE":{"COLUMNS_NOT_FOUND":"Columnas no encontradas:","SPREADSHEET_TOO_BIG":"No se puede importar una hoja de cálculo con más de {{ activitiesLimit }} actividades. Revisa la hoja de cálculo.","EMPTY_SPREADSHEET":"No se encontraron datos en la hoja de cálculo insertada. Revisa la hoja de cálculo."}},"ACTUAL_PLAN":{"SEE_ACTIVITIES":"Ver actividades","WAITING_GENERATE":"Las actividades se están generando. ¡En unos minutos aparecerán aquí!","COLUMNS":{"STATUS":"Estado","IDENTIFIER":"Identificador","OS_TYPE":"Tipo de OS","CUSTOMER_NAME":"Cliente","LOCATION_NAME":"Ubicación","SCHEDULE_DATE":"Fecha de programación","EMPLOYEE":"Empleado"}}}},"TOAST":{"SAVED":"Plan de actividad \'{{ plan }}\' guardado exitosamente.","EDITED":"Plan de actividad \'{{ plan }}\' editado exitosamente.","ARCHIVED":"Plan de actividad \'{{ plan }}\' archivado exitosamente.","UNARCHIVED":"Plan de actividad \'{{ plan }}\' desarquivado exitosamente.","ERROR_SAVED":"Se produjo un error al guardar el plan de actividades. Por favor contacta al soporte.","SCHEDULED_TASKS_ARCHIVED":"Actividades programadas archivadas exitosamente."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/plans/i18n/pt.json',
    '{"PLANS":{"PAGE_TITLE":"Planos de atividades","TITLE":"Planos de atividades","DESCRIPTION":"Planos de atividades é uma rotina onde é possível importar atividades dentro do Field Control baseado em uma planilha modelo.","SEARCH":"Pesquisar","DOWNLOAD_SPREADSHEET_MODEL":"Download da planilha modelo","NEW":"Criar plano de atividade","FILTER":"Filtrar plano de atividades","RELOAD":"Atualizar","MODEL":{"NAME":"Nome do plano","DESCRIPTION":"Descrição","NO_DESCRIPTION":"Sem descrição","PLANTYPE":"Tipo do plano","CREATED_AT":"Criado em","ERRORS":{"NAME_REQUIRED":"Nome é obrigatório","PLANTYPE_REQUIRED":"Tipo de plano de atividades é obrigatório","DESCRIPTION_MAXLENGTH":"Descrição deve ter no máximo 100 caracteres"}},"FILTERS":{"TITLE":"Filtrar planos de atividades","CLEAR":"Limpar filtro","NAME":"Pesquisar por nome","DESCRIPTION":"Pesquisar por descrição","PLANTYPE":"Pesquisar por tipo de plano","SITUATIONS":{"TITLE":"Pesquisar por situação","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"}},"DIALOG":{"CLOSE":"Fechar","NEW":{"TITLE":"Novo plano de atividades"},"EDIT":{"TITLE":"Editar plano de atividades"},"IMPORT":{"TITLE":"Importar plano de atividades","MESSAGE":"Faça o download abaixo da nossa planilha modelo e preencha com os dados necessários para criar seu novo plano de atividades","UPLOAD_MESSAGE":"Clique ou arraste a planilha modelo para fazer upload","DOWNLOAD_SPREADSHEET_MODEL":"Download da planilha modelo","SELECTED_SPREADSHEET":"Planilha selecionada","MAX_SIZE":"Tamanho máximo do arquivo é de 10MB","ERROR":{"SIZE_NOT_ALLOWED":"O arquivo selecionado é maior do que o permitido (tamanho permitido: até 10MB)","TYPE_NOT_ALLOWED":"O arquivo selecionado não é uma planilha (.xlsx)"}},"GENERAL":{"TITLE":"Geral"},"ACTIVITIES":{"TITLE":"Atividades"},"ACTIONS":{"LOAD":"Importar","LOADING":"Aguarde, carregando arquivo...","DOWNLOAD":"DOWNLOAD DA PLANILHA MODELO","SAVE":"Salvar","EDIT":"Editar","CREATE":"Criar","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar","EXCEED_LIMIT":"Não é possível importar uma planilha com mais de {{ activitiesLimit }} atividades. Revise a planilha."},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Próximo","SHOWING_FROM":"Mostrando de","TO":"até","OF":"de","RECORDS":"registros"},"ALERT":{"TITLE":"Não foi possível salvar o plano de atividade","ERROR":"Não foi possível arquivar as atividades vinculadas a esse plano de atividade","ERROR_ARCHIVE":"Ocorreu um erro ao arquivar o plano de atividades. Entre em contato com o suporte","ERROR_UNARCHIVE":"Ocorreu um erro ao desarquivar o plano de atividades. Entre em contato com o suporte","OK":"OK"},"CONFIRM_DIALOG":{"TITLE":"Próximas atividades agendadas","CONTENT":"O plano de atividades arquivado possui atividades agendadas para os próximos dias. O que deseja fazer com essas atividades?","ERROR":"Não foi possível arquivar as atividades vinculadas a esse plano de atividade","OK":"Arquivar","CANCEL":"Cancelar"},"UNPROCESSABLE":{"TITLE":"Ops, não foi possível processar a planilha...","BUTTON":"OK, entendi"}},"TABLE":{"ACTIVE":"Ativo","INACTIVE":"Inativo","DEADLINE":"Prazo (dias)","SITUATION":"Situação","ACTIONS":"Ações","EDIT":"Editar","CREATE_PLANS_TYPE_CTA":"Você pode criar um novo plano de atividade","CREATE_PLANS_TYPE_LINK":"clicando aqui","INFO":{"NEW_PLAN":{"ACTIVITY_PLAN":"Plano de atividade","MORE_DETAILS":"Mostrar mais detalhes","LESS_DETAILS":"Mostrar menos detalhes","VALID":"Válido","INVALID":"Inválido","COLUMNS":{"VALIDATION":"Validação","OS_TYPE":"Tipo de OS","CUSTOMER_NAME":"Cliente","CUSTOMER_DOCUMENT_NUMBER":"Documento do cliente","LOCATION_NAME":"Nome da localização","EQUIPMENT_NUMBER":"Equipamento","EMPLOYEE_NAME":"Colaborador","SCHEDULE_DATE":"Data agendamento","SCHEDULE_HOUR":"Hora agendamento","DESCRIPTION":"Descrição"},"IMPORT_ERRORS":{"COULD_NOT_READ":"Ops! Ocorreu um erro ao tentar abrir o arquivo, o arquivo pode estar corrompido e não pode ser aberto!","CORPORATE_SERVICE":"Você não tem permissão para lançar atividades deste tipo para o cliente {{ customerName }}","EMPTY":"DOCUMENTO DO CLIENTE ou NOME DO CLIENTE é obrigatório","DATE_EMPTY":"DATA DE AGENDAMENTO é obrigatória","INACTIVE":"Inativo/Arquivado","INACTIVE_FIRED":"Inativo/Fora do período de contratação","NOT_FOUND":"Não encontrado com o nome especificado","DOCUMENT_NOT_FOUND":"Não encontrado com o documento especificado","DESCRIPTION_NOT_FOUND":"Não encontrado com a descrição especificada","SERIAL_NUMBER_NOT_FOUND":"Não encontrado com o número de série especificado","DOCUMENT_NONSTANDARD":"Fora do padrão (CPF/CNPJ)","CUSTOMER_NOT_FOUND":"Cliente não encontrado","DUPLICATE_CUSTOMER":"Clientes duplicados","DUPLICATE_LOCATION":"Localizações duplicadas","CUSTOMER_ARCHIVED":"Esse cliente está arquivado","DATE_NONSTANDARD":"Fora do padrão (DD/MM/YY)","HOUR_NONSTANDARD":"Fora do padrão (HH:MM)","DATE_BEFORE_TODAY":"Data anterior ao dia de hoje","INVALID_DATE":"Data inválida"},"UNPROCESSABLE":{"COLUMNS_NOT_FOUND":"As colunas não foram encontradas:","SPREADSHEET_TOO_BIG":"Não é possível importar uma planilha com mais de {{ activitiesLimit }} atividades. Revise a planilha.","EMPTY_SPREADSHEET":"Não foi encontrado nenhuma dado na planilha inserida. Revise a planilha."}},"ACTUAL_PLAN":{"SEE_ACTIVITIES":"Ver Atividades","WAITING_GENERATE":"As atividades estão sendo geradas. Em alguns minutos, elas aparecerão aqui!","COLUMNS":{"STATUS":"Situação","IDENTIFIER":"Identificador","OS_TYPE":"Tipo de OS","CUSTOMER_NAME":"Cliente","LOCATION_NAME":"Localização","SCHEDULE_DATE":"Data agendamento","EMPLOYEE":"Colaborador"}}}},"TOAST":{"SAVED":"Plano de atividade \'{{ plan }}\' salvo com sucesso.","EDITED":"Plano de atividade \'{{ plan }}\' editado com sucesso.","ARCHIVED":"Plano de atividade \'{{ plan }}\' arquivado com sucesso.","UNARCHIVED":"Plano de atividade \'{{ plan }}\' desarquivado com sucesso.","ERROR_SAVED":"Ocorreu um erro ao salvar o plano de atividades. Entre em contato com o suporte.","SCHEDULED_TASKS_ARCHIVED":"Atividades agendadas arquivadas com sucesso."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/plans-types/i18n/en.json',
    '{"PLANSTYPES":{"PAGE_TITLE":"OS types plans","TITLE":"OS types plans","DESCRIPTION":"OS types plans are segments of an task plan generated periodically by the company.","SEARCH":"Search","NEW":"Create task plan type","FILTER":"Filter task plan types","RELOAD":"Reload","MODEL":{"NAME":"Name","DESCRIPTION":"Description","CREATED_AT":"Created at","ERRORS":{"NAME_REQUIRED":"Name is required"}},"FILTERS":{"TITLE":"Filter OS types plans","CLEAR":"Clear filter","NAME":"Search by name","DESCRIPTION":"Search by description","SITUATIONS":{"TITLE":"Search by situation","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"}},"DIALOG":{"CLOSE":"Close","NEW":{"TITLE":"New OS type plan"},"EDIT":{"TITLE":"Edit task plan type"},"GENERAL":{"TITLE":"General"},"ACTIONS":{"SAVE":"Save","CREATE":"Create","ARCHIVE":"Archive","UNARCHIVE":"Unarchive"},"ALERT":{"TITLE":"Could not save the task plan type","OK":"OK"}},"TABLE":{"ACTIVE":"Active","INACTIVE":"Inactive","DEADLINE":"Deadline (days)","SITUATION":"Situation","ACTIONS":"Actions","EDIT":"Edit","CREATE_PLANS_TYPE_CTA":"You can create a new task plan type","CREATE_PLANS_TYPE_LINK":"by clicking here"},"TOAST":{"SAVED":"Task plan type \'{{ planType }}\' saved successfully."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/plans-types/i18n/es.json',
    '{"PLANSTYPES":{"PAGE_TITLE":"Tipos de planes de actividades","TITLE":"Tipos de planes de actividades","DESCRIPTION":"Los tipos de planes de actividades son segmentos de un plan de actividades generado periódicamente por la empresa","SEARCH":"Pesquisar","NEW":"Crear tipo de plan de actividad","FILTER":"Filtrar tipos de planes de actividades","RELOAD":"Recargar","MODEL":{"NAME":"Nombre","DESCRIPTION":"Descripción","CREATED_AT":"Creado en","ERRORS":{"NAME_REQUIRED":"El nombre es obligatorio"}},"FILTERS":{"TITLE":"Filtrar tipos de planes de actividades","CLEAR":"Limpiar filtro","NAME":"Buscar por nombre","DESCRIPTION":"Buscar por descripción","SITUATIONS":{"TITLE":"Buscar por situación","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"}},"DIALOG":{"CLOSE":"Cerrar","NEW":{"TITLE":"Nuevo tipo de plan de actividades"},"EDIT":{"TITLE":"Editar tipo de plan de actividades"},"GENERAL":{"TITLE":"General"},"ACTIONS":{"SAVE":"Guardar","CREATE":"Crear","ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar"},"ALERT":{"TITLE":"No se pudo guardar el tipo de plan de actividades","OK":"OK"}},"TABLE":{"ACTIVE":"Activo","INACTIVE":"Inactivo","DEADLINE":"Plazo (días)","SITUATION":"Situación","ACTIONS":"Acciones","EDIT":"Editar","CREATE_PLANS_TYPE_CTA":"Puede crear un nuevo tipo de plan de actividades","CREATE_PLANS_TYPE_LINK":"haciendo clic aquí"},"TOAST":{"SAVED":"Tipo de plan de actividades \'{{ planType }}\' guardado correctamente."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/plans-types/i18n/pt.json',
    '{"PLANSTYPES":{"PAGE_TITLE":"Tipos de planos de atividades","TITLE":"Tipos de planos de atividades","DESCRIPTION":"Tipos de planos de atividades são segmentos de um plano de atividades gerado periódicamente pela empresa.","SEARCH":"Pesquisar","NEW":"Criar tipo de plano de atividade","FILTER":"Filtrar tipos de plano de atividades","RELOAD":"Atualizar","MODEL":{"NAME":"Nome","DESCRIPTION":"Descrição","CREATED_AT":"Criado em","ERRORS":{"NAME_REQUIRED":"Nome é obrigatório"}},"FILTERS":{"TITLE":"Filtrar tipos de planos de atividades","CLEAR":"Limpar filtro","NAME":"Pesquisar por nome","DESCRIPTION":"Pesquisar por descrição","SITUATIONS":{"TITLE":"Pesquisar por situação","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"}},"DIALOG":{"CLOSE":"Fechar","NEW":{"TITLE":"Novo tipo de plano de atividades"},"EDIT":{"TITLE":"Editar tipo do plano de atividades"},"GENERAL":{"TITLE":"Geral"},"ACTIONS":{"SAVE":"Salvar","CREATE":"Criar","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"},"ALERT":{"TITLE":"Não foi possível salvar o tipo de plano de atividade","OK":"OK"}},"TABLE":{"ACTIVE":"Ativo","INACTIVE":"Inativo","DEADLINE":"Prazo (dias)","SITUATION":"Situação","ACTIONS":"Ações","EDIT":"Editar","CREATE_PLANS_TYPE_CTA":"Você pode criar um novo tipo de plano de atividade","CREATE_PLANS_TYPE_LINK":"clicando aqui"},"TOAST":{"SAVED":"Tipo de plano de atividade \'{{ planType }}\' salvo com sucesso."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/product-types/i18n/en.json',
    '{"PRODUCT_TYPES":{"PAGE_TITLE":"Product types","TITLE":"Product types","NEW":"Add product type","RELOAD":"Reload","FILTER":"Filter","FILTERS":{"TITLE":"Filter product types","CLEAR":"Clear filter","NAME":"Search by name","DESCRIPTION":"Search by description","SITUATIONS":{"TITLE":"Search by situation","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"}},"TABLE":{"NAME":"Name","CREATED_AT":"Created at","VALUE":"Value","DESCRIPTION":"Description","TYPE":"Type","ACTIVE":"Active","INACTIVE":"Inactive","SITUATION":"Situation","ACTIONS":"Actions","EDIT":"Edit","VIEW":"View","CREATE_PRODUCT_TYPES_CTA":"You can create a new product type","CREATE_PRODUCT_TYPES_LINK":"by clicking here","PRODUCT_TYPE_EDIT_NOT_ALLOWED":"Unable to edit a blocked product type."},"MODEL":{"NAME":"Name","VALUE":"Value","DESCRIPTION":"Description","ERRORS":{"NAME_REQUIRED":"Name is required","MAX_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but it has {{ receivedLength }}.","VALUE_REQUIRED":"Value is required","FIELD_REQUIRED":"This field is required"}},"DIALOG":{"CLOSE":"Close","PRODUCT_TYPE_ALERT":"Product type is a specific category for goods with similar characteristics.","IMAGE_INFORMATION":"The ideal logo dimensions are 512px x 512px, with a maximum size of 2MB.","SELECT_IMAGES":"Select image","NEW":{"TITLE":"New product type","INFO":"Product type information"},"EDIT":{"TITLE":"Edit product type"},"ACTIONS":{"SAVE":"SAVE","CREATE":"CREATE","ARCHIVE":"Archive","UNARCHIVE":"Unarchive"},"ALERT":{"TITLE":"Could not save the product type","OK":"OK"}},"TOAST":{"SAVED":"Product type \'{{ productType }}\' saved successfully."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/product-types/i18n/es.json',
    '{"PRODUCT_TYPES":{"PAGE_TITLE":"Tipos de producto","TITLE":"Tipos de producto","NEW":"Agregar tipo de producto","RELOAD":"Recargar","FILTER":"Filtrar","FILTERS":{"TITLE":"Filtrar tipos de producto","CLEAR":"Limpiar filtro","NAME":"Buscar por nombre","DESCRIPTION":"Buscar por descripción","SITUATIONS":{"TITLE":"Buscar por situación","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"}},"TABLE":{"NAME":"Nombre","CREATED_AT":"Creado en","VALUE":"Valor","DESCRIPTION":"Descripción","TYPE":"Tipo","ACTIVE":"Activo","INACTIVE":"Inactivo","SITUATION":"Situación","ACTIONS":"Acciones","EDIT":"Editar","VIEW":"Ver","CREATE_PRODUCT_TYPES_CTA":"Puede crear un nuevo tipo de producto","CREATE_PRODUCT_TYPES_LINK":"haciendo clic aquí","PRODUCT_TYPE_EDIT_NOT_ALLOWED":"No se puede editar un tipo de producto bloqueado"},"MODEL":{"NAME":"Nombre","VALUE":"Valor","DESCRIPTION":"Descripción","ERRORS":{"NAME_REQUIRED":"El nombre es obligatorio","MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}.","VALUE_REQUIRED":"El valor es obligatorio","FIELD_REQUIRED":"Este campo es obligatorio"}},"DIALOG":{"CLOSE":"Cerrar","PRODUCT_TYPE_ALERT":"El tipo de producto es una categoría específica de bienes con características similares.","IMAGE_INFORMATION":"Las dimensiones ideales del logo son 512px x 512px, con un tamaño máximo de 2 MB.","SELECT_IMAGES":"Seleccionar imagen","NEW":{"TITLE":"Nuevo tipo de producto","INFO":"Información del tipo de producto"},"EDIT":{"TITLE":"Editar tipo de producto"},"ACTIONS":{"SAVE":"GUARDAR","CREATE":"CREAR","ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar"},"ALERT":{"TITLE":"No se pudo guardar el tipo de producto","OK":"OK"}},"TOAST":{"SAVED":"Tipo de producto \'{{ productType }}\' guardado correctamente."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/product-types/i18n/pt.json',
    '{"PRODUCT_TYPES":{"PAGE_TITLE":"Tipos de produto","TITLE":"Tipos de produto","NEW":"Novo Tipo de produto","RELOAD":"Atualizar","FILTER":"Filtrar","FILTERS":{"TITLE":"Filtrar tipos de produtos","CLEAR":"Limpar filtro","NAME":"Pesquisar por nome","DESCRIPTION":"Pesquisar por descrição","SITUATIONS":{"TITLE":"Pesquisar por situação","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"}},"TABLE":{"NAME":"Nome","CREATED_AT":"Criado em","VALUE":"Valor (R$)","DESCRIPTION":"Descrição","TYPE":"Tipo","ACTIVE":"Ativo","INACTIVE":"Inativo","SITUATION":"Situação","ACTIONS":"Ações","EDIT":"Editar","VIEW":"Visualizar","CREATE_PRODUCT_TYPES_CTA":"Você pode criar um novo tipo de produto","CREATE_PRODUCT_TYPES_LINK":"clicando aqui","PRODUCT_TYPE_EDIT_NOT_ALLOWED":"Não é possível editar um tipo de produto bloqueado"},"MODEL":{"NAME":"Nome","VALUE":"Valor (R$)","DESCRIPTION":"Descrição","ERRORS":{"NAME_REQUIRED":"Nome é obrigatório","MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}.","VALUE_REQUIRED":"Valor é obrigatório","FIELD_REQUIRED":"Este campo é obrigatório"}},"DIALOG":{"CLOSE":"Fechar","PRODUCT_TYPE_ALERT":"Tipo de produto é uma categoria específica de bens com características semelhantes.","IMAGE_INFORMATION":"As dimensões ideais do logo são 512px x 512px, com tamanho máximo de 2 MB.","SELECT_IMAGES":"Selecionar imagem","NEW":{"TITLE":"Novo tipo de produto","INFO":"Informações do tipo de produto"},"EDIT":{"TITLE":"Editar tipo de produto"},"ACTIONS":{"SAVE":"SALVAR","CREATE":"CRIAR","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"},"ALERT":{"TITLE":"Não foi possível salvar o tipo de produto","OK":"OK"}},"TOAST":{"SAVED":"Tipo de produto \'{{ productType }}\' salvo com sucesso."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/products/i18n/en.json',
    '{"PRODUCTS":{"PAGE_TITLE":"Products","TITLE":"Products","NEW":"Add product","RELOAD":"Reload","FILTER":"Filter","EXPORT":{"TITLE":"Export of Products","CONTENT":"By clicking export, you will receive a download link of the export to your email <b>{{ email }}</b>. Depending on the amount of information, the export may take a few minutes to complete.","YES":"YES","NO":"NO","CONFIRM_ACTION_CONTENT":"Do you want to proceed with the exportation?","SPREADSHEET_SENT":"The spreadsheet will be sent to {{email}} in a few minutes","SPREADSHEET_ERROR":"Ooops, something went wrong. Unable to export products :("},"FILTERS":{"TITLE":"Filter products","CLEAR":"Clear filter","NAME":"Search by name","DESCRIPTION":"Search by description","CODE":"Search by code","PRODUCT_TYPE":"Search by product type","MEASURE":"Search by measure","SITUATIONS":{"TITLE":"Search by situation","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"},"TYPE":{"TITLE":"Search by type","ALL":"All","PRODUCT":"Products"}},"IMPORT":{"TITLE":"Import products from {{app}}","FROM":"Product imported from the Omie account <b>{{account}}</b>","SELECT_THE_ACCOUNT_MANUAL":"Select the Omie account you wish to export the products manually.","FOUND_PRODUCTS":"Found products","MANUAL":"Manual Import","AUTOMATIC":"Automatic Import","CONTENT":"This process will import all {{quantity}} products that are registered in the selected Omie account.<br><br>&#8226; Products that do not exist in Field Control will be created;<br>&#8226; Products already existing in Field Control will be updated<br><br >The process may take a few moments depending on the quantity of products. Do not close the window until the process has finished.","IMPORT_LOADING_TITLE":"Importing products from Omie","WAIT_LOADING":"Please wait, we are importing the products...","CLOSE":"Close","IMPORT_BUTTON":"Import","UPDATE_SUCCESS":"Updated successfully","UPDATE_ERROR":"There was an error with this importation.","CREATE_ERROR":"Error importing product.","SUCCESS_AUTOMATIC":"Products imported successfully!","SUCCESS_MANUAL":"Imported successfully!","SEARCH_BY_NAME":"Enter at least 3 characters to search for products you want to import into Field Control.","LOADING_ERROR":"There was an error loading omie products."},"TABLE":{"NAME":"Name","CREATED_AT":"Created at","VALUE":"Value ({{ currency }})","DESCRIPTION":"Description","TYPE":"Type","MEASURE":"Measure","CODE":"Code","QRCODE":"Qr Code","PRODUCT_TYPE":"Product type","ACTIVE":"Active","INACTIVE":"Inactive","SITUATION":"Situation","ACTIONS":"Actions","EDIT":"Edit","VIEW":"View","CREATE_PRODUCTS_CTA":"You can create a new product","CREATE_PRODUCTS_LINK":"clicking here","PRODUCT_EDIT_NOT_ALLOWED":"Unable to edit a blocked product."},"MODEL":{"NAME":"Name","VALUE":"Value ({{ currency }})","DESCRIPTION":"Description","CODE":"Code","TYPE":{"LABEL":"Product type","PRODUCT":"Product","ALL":"All"},"QR_CODE":{"GENERATE":"Generate QR code","DOWNLOAD_LINK_MESSAGE":"Show QR code","GENERATE_QRCODE":"Click here to generate the QR Code","VIEW_QRCODE":"View product\'s QR Code","GENERATE_QRCODE_MANDATORY":"Click here to generate the QR Code*","MODAL":{"GENERATE":"Generate QR Code","GENERATE_ANOTHER_CODE":"Generate another code","SAVE":"Save","DOWNLOAD":"Download","SAVED_SUCCESSFULLY":"QR Code altered, save the product to conclude the change."}},"MEASURES":{"ALL":"All","UNITY":"Units","CENTIMETER":"Centimeters","METER":"Meters","LITER":"Liters","MILLILITER":"Milliliters","KILOGRAM":"Kilograms","GRAM":"Grams","SQUARE_METERS":"Square Meters (m²)","CUBIC_METERS":"Cubic Meters (m³)","TONS_REFRIGERATION":"Tons of Refrigeration (TR)","DISLOCATION":"Dislocation (D)","CJT":"CJT","OTHERS":"Others"},"ERRORS":{"NAME_REQUIRED":"Name is required","MAX_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but it has {{ receivedLength }}.","VALUE_REQUIRED":"Value is required","CODE_REQUIRED":"Code is required","FIELD_REQUIRED":"This field is required","MEASURE_REQUIRED":"Product measurement is required","DUPLICATED_CODE":"Code is already associated with another product","DUPLICATED_CODE_ARCHIVED":"Code is already associated with another product (Archived)"}},"DIALOG":{"CLOSE":"Close","MEASURE":"Measure","PRODUCT_ALERT":"Add a product that will be stored or sold by your company.","PRODUCT_TYPE_ALERT":"Types of Products","STORAGE_ALERT":"Manage your product in each of the deposits.","CREATE_TYPE_ALERT":"To create a product, you must create a product type in:","IMAGE_INFORMATION":"The ideal logo dimensions are 512px x 512px, with a maximum size of 2MB.","SELECT_IMAGES":"Select image","NEW":{"TITLE":"New product","INFO":"Product information"},"EDIT":{"TITLE":"Edit product"},"ACTIONS":{"SAVE":"SAVE","CREATE":"CREATE","ARCHIVE":"Archive","UNARCHIVE":"Unarchive"},"ALERT":{"TITLE":"Could not save the product","OK":"OK"},"TABS":{"GENERAL":"GENERAL","STORAGE":"STORAGE"}},"TOAST":{"SAVED":"Product \'{{ product }}\' saved successfully."},"OMIE_DIALOG":{"TITLE":"Error importing product \'{{ productToUpdate }}\'","CONTENT":"The product was not imported because the code \'{{ code }}\' is already being used by product \'{{existingProduct}}\'. Do you want to update the existing product?","TITLE_ALL":"Error importing products","CONTENT_ALL":"The following products were not imported: <br> <b>{{ names }}</b>, because their codes \'{{ codes }}\' are already being used by the products \'{{existingProduct}}\'. Do you want to update these existing products?","CONTENT_ALL1":"The following products were not imported: ","CONTENT_ALL2":"<br><br> Because their codes: ","CONTENT_ALL3":"<br><br> Are already being used by the products: ","CONTENT_ALL4":"<br><br> Do you want to update these existing products?","UPDATE":"Update","CANCEL":"Cancel"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/products/i18n/es.json',
    '{"PRODUCTS":{"PAGE_TITLE":"Productos","TITLE":"Productos","NEW":"Agregar producto","RELOAD":"Recargar","FILTER":"Filtrar","EXPORT":{"TITLE":"Exportación de Productos","CONTENT":"Al hacer clic en exportar, recibirá un enlace de descarga de la exportación en su correo electrónico <b>{{ email }}</b>. Dependiendo de la cantidad de información, la exportación puede tardar algunos minutos en completarse.","YES":"SÍ","NO":"NO","CONFIRM_ACTION_CONTENT":"¿Desea continuar con la exportación?","SPREADSHEET_SENT":"La hoja de cálculo se enviará a {{email}} en unos minutos","SPREADSHEET_ERROR":"Oops, algo salió mal. No se pueden exportar los clientes :("},"FILTERS":{"TITLE":"Filtrar productos","CLEAR":"Limpiar filtro","NAME":"Buscar por nombre","DESCRIPTION":"Buscar por descripción","CODE":"Buscar por código","PRODUCT_TYPE":"Buscar por tipo de producto","MEASURE":"Buscar por medida","SITUATIONS":{"TITLE":"Buscar por situación","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"},"TYPE":{"TITLE":"Buscar por tipo","ALL":"Todos","PRODUCT":"Productos"}},"IMPORT":{"TITLE":"Importar productos de {{app}}","FROM":"Producto importado de la cuenta de Omie <b>{{account}}</b>","SELECT_THE_ACCOUNT_MANUAL":"Seleccione la cuenta de Omie de la que desea exportar los productos manualmente.","FOUND_PRODUCTS":"Productos encontrados","MANUAL":"Importación manual","AUTOMATIC":"Importación automática","CONTENT":"Este proceso importará todos los {{quantity}} productos que estén registrados en la cuenta de Omie seleccionada.<br><br>&#8226; Los productos que no existan en Field Control se crearán;<br>&#8226; Los productos ya existentes en Field Control se actualizarán<br><br>El proceso puede tardar unos momentos dependiendo de la cantidad de productos. No cierre la ventana hasta que el proceso haya finalizado.","IMPORT_LOADING_TITLE":"Importando productos de Omie","WAIT_LOADING":"Por favor espere, estamos importando los productos...","CLOSE":"Cerrar","IMPORT_BUTTON":"Importar","UPDATE_SUCCESS":"Actualizado con éxito","UPDATE_ERROR":"Hubo un error con esta importación.","CREATE_ERROR":"Error al importar el producto.","SUCCESS_AUTOMATIC":"¡Productos importados exitosamente!","SUCCESS_MANUAL":"¡Importado exitosamente!","SEARCH_BY_NAME":"Ingrese al menos 3 caracteres para buscar los productos que desea importar a Field Control.","LOADING_ERROR":"Hubo un error al cargar los productos de Omie."},"TABLE":{"NAME":"Nombre","CREATED_AT":"Creado en","VALUE":"Valor ({{ currency }})","DESCRIPTION":"Descripción","TYPE":"Tipo","MEASURE":"Medida","CODE":"Código","QRCODE":"Qr Code","PRODUCT_TYPE":"Tipo do producto","ACTIVE":"Activo","INACTIVE":"Inactivo","SITUATION":"Situación","ACTIONS":"Acciones","EDIT":"Editar","VIEW":"Ver","CREATE_PRODUCTS_CTA":"Puede crear un nuevo producto","CREATE_PRODUCTS_LINK":"haciendo clic aquí","PRODUCT_EDIT_NOT_ALLOWED":"No se puede editar un producto bloqueado"},"MODEL":{"NAME":"Nombre","VALUE":"Valor ({{ currency }})","DESCRIPTION":"Descripción","CODE":"Código","TYPE":{"LABEL":"Tipo de producto","PRODUCT":"Producto","ALL":"Todos"},"QR_CODE":{"GENERATE":"Generar QR code","DOWNLOAD_LINK_MESSAGE":"Visualizar QR code","GENERATE_QRCODE":"Haga click aquí para generar el QRCode","VIEW_QRCODE":"Ver el QR code del producto","GENERATE_QRCODE_MANDATORY":"Haga click aquí para generar el QRCode*","MODAL":{"GENERATE":"Generar QRCode","GENERATE_ANOTHER_CODE":"Generar otro código","SAVE":"Guardar","DOWNLOAD":"Descargar","SAVED_SUCCESSFULLY":"QR Code modificado, guarde el producto para realizar la actualización."}},"MEASURES":{"ALL":"Todos","UNITY":"Unidades","CENTIMETER":"Centímetros","METER":"Metros","LITER":"Litros","MILLILITER":"Mililitros","KILOGRAM":"Kilogramos","GRAM":"Gramos","SQUARE_METERS":"Metros cuadrados (m²)","CUBIC_METERS":"Metros cúbicos (m³)","TONS_REFRIGERATION":"Toneladas de refrigeración (TR)","DISLOCATION":"Desplazamiento (D)","CJT":"CJT","OTHERS":"Otros"},"ERRORS":{"NAME_REQUIRED":"El nombre es obligatorio","MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}.","VALUE_REQUIRED":"El valor es obligatorio","CODE_REQUIRED":"El código es obligatorio","FIELD_REQUIRED":"Este campo es obligatorio","MEASURE_REQUIRED":"La medida del producto es obligatoria","DUPLICATED_CODE":"El código ya está asociado con otro producto","DUPLICATED_CODE_ARCHIVED":"El código ya está asociado con otro producto (Archivado)"}},"DIALOG":{"CLOSE":"Cerrar","MEASURE":"Medida","PRODUCT_ALERT":"Agregue un producto que será almacenado o vendido por su empresa.","PRODUCT_TYPE_ALERT":"Tipos de productos","STORAGE_ALERT":"Administre su producto en cada uno de los depósitos.","CREATE_TYPE_ALERT":"Para crear un producto, debe crear un tipo de producto en la pestaña:","IMAGE_INFORMATION":"Las dimensiones ideales del logo son 512px x 512px, con un tamaño máximo de 2 MB.","SELECT_IMAGES":"Seleccionar imagen","NEW":{"TITLE":"Nuevo producto","INFO":"Información del producto"},"EDIT":{"TITLE":"Editar producto"},"ACTIONS":{"SAVE":"GUARDAR","CREATE":"CREAR","ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar"},"ALERT":{"TITLE":"No se pudo guardar el producto","OK":"OK"},"TABS":{"GENERAL":"GENERAL","STORAGE":"ALMACENAMIENTO"}},"TOAST":{"SAVED":"El producto \'{{product}}\' se guardó correctamente."},"OMIE_DIALOG":{"TITLE":"Error al importar el producto \'{{ productToUpdate }}\'","CONTENT":"El producto no se importó porque el código \'{{ code }}\' ya está siendo utilizado por el producto \'{{existingProduct}}\'. ¿Desea actualizar el producto existente?","TITLE_ALL":"Error en la importación de los productos","CONTENT_ALL":"Los siguientes productos no se importaron <br> <b>{{ names }}</b>, porque sus códigos \'{{ codes }}\' ya están siendo utilizados por los productos \'{{existingProduct}}\'. ¿Desea actualizar estos productos existentes?","CONTENT_ALL1":"Los siguientes productos no se importaron: ","CONTENT_ALL2":"<br><br> Porque sus códigos: ","CONTENT_ALL3":"<br><br> Ya están siendo utilizados por los productos: ","CONTENT_ALL4":"<br><br> ¿Desea actualizar estos productos existentes?","UPDATE":"Actualizar","CANCEL":"Cancelar"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/products/i18n/pt.json',
    '{"PRODUCTS":{"PAGE_TITLE":"Produtos","TITLE":"Produtos","NEW":"Novo produto","RELOAD":"Atualizar","FILTER":"Filtrar","EXPORT":{"TITLE":"Exportação de Produtos","CONTENT":"Ao clicar em exportar, você receberá um link de download da exportação no seu e-mail <b>{{ email }}</b>. Dependendo da quantidade de informações, a exportação poderá demorar alguns minutos para ser finalizada.","YES":"SIM","NO":"NÃO","CONFIRM_ACTION_CONTENT":"Deseja continuar com a exportação?","SPREADSHEET_SENT":"A planilha será enviada para o e-mail {{email}} em alguns minutos","SPREADSHEET_ERROR":"Ooooooooooops, algo errado aconteceu e não foi possível exportar seus clientes :("},"FILTERS":{"TITLE":"Filtrar produtos","CLEAR":"Limpar filtro","NAME":"Pesquisar por nome","DESCRIPTION":"Pesquisar por descrição","CODE":"Pesquisar por código","PRODUCT_TYPE":"Pesquisar por tipo do produto","MEASURE":"Pesquisar por medida","SITUATIONS":{"TITLE":"Pesquisar por situação","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"},"TYPE":{"TITLE":"Pesquisar por tipo","ALL":"Todos","PRODUCT":"Produtos"}},"IMPORT":{"TITLE":"Importar produtos do {{app}}","FROM":"Produto importado da conta Omie <b>{{account}}</b>","SELECT_THE_ACCOUNT_MANUAL":"Selecione a conta Omie que deseja importar os produtos manualmente.","FOUND_PRODUCTS":"Produtos encontrados","MANUAL":"Importação manual","AUTOMATIC":"Importação em massa","CONTENT":"Esse processo irá importar todos os produtos que estão cadastrados na conta Omie selecionada.<br><br>&#8226; Os produtos que não existem no Field Control serão criados;<br>&#8226; Os produtos já existentes no Field Control serão atualizados.<br><br>O processo poderá demorar alguns instantes de acordo com a quantidade de produtos. Não feche a janela até que o processo tenha terminado.","IMPORT_LOADING_TITLE":"Importando produtos do Omie","WAIT_LOADING":"Aguarde, estamos importando os produtos...","CLOSE":"Fechar","IMPORT_BUTTON":"Importar","UPDATE_SUCCESS":"Atualizado com sucesso","UPDATE_ERROR":"Houve um erro com a importação.","CREATE_ERROR":"Erro ao importar produto.","SUCCESS_AUTOMATIC":"Produtos importados com sucesso!","SUCCESS_MANUAL":"Importado com sucesso!","SEARCH_BY_NAME":"Digite pelo menos 3 caracteres para buscar produtos que você deseja importar para o Field Control.","LOADING_ERROR":"Ocorreu um erro ao carregar os produtos da Omie."},"TABLE":{"NAME":"Nome","CREATED_AT":"Criado em","VALUE":"Valor ({{ currency }})","DESCRIPTION":"Descrição","TYPE":"Tipo","MEASURE":"Medida","CODE":"Código","QRCODE":"Qr Code","PRODUCT_TYPE":"Tipo do produto","ACTIVE":"Ativo","INACTIVE":"Inativo","SITUATION":"Situação","ACTIONS":"Ações","EDIT":"Editar","VIEW":"Visualizar","CREATE_PRODUCTS_CTA":"Você pode criar um novo produto","CREATE_PRODUCTS_LINK":"clicando aqui","PRODUCT_EDIT_NOT_ALLOWED":"Não é possível editar um produto bloqueado"},"MODEL":{"NAME":"Nome","VALUE":"Valor ({{ currency }})","DESCRIPTION":"Descrição","CODE":"Código","TYPE":{"LABEL":"Tipo do produto","PRODUCT":"Produto","ALL":"Todos"},"QR_CODE":{"GENERATE":"Gerar código QR","DOWNLOAD_LINK_MESSAGE":"Ver código QR","GENERATE_QRCODE":"Clique aqui para gerar o QR Code","VIEW_QRCODE":"Visualizar QR code do produto","GENERATE_QRCODE_MANDATORY":"Clique aqui para gerar o QR Code*","MODAL":{"GENERATE":"Gerar QR Code","GENERATE_ANOTHER_CODE":"Gerar outro código","SAVE":"Salvar","DOWNLOAD":"Baixar","SAVED_SUCCESSFULLY":"QR Code alterado, salve o produto para efetuar a atualização."}},"MEASURES":{"ALL":"Todas","UNITY":"Unidades","CENTIMETER":"Centímetros","METER":"Metros","LITER":"Litros","MILLILITER":"Mililitros","KILOGRAM":"Quilograma","GRAM":"Gramas","SQUARE_METERS":"Metros Quadrados (m²)","CUBIC_METERS":"Metros Cúbicos (m³)","TONS_REFRIGERATION":"Toneladas de Refrigeração (TR)","DISLOCATION":"Deslocamento (D)","CJT":"CJT","OTHERS":"Outros"},"ERRORS":{"NAME_REQUIRED":"Nome é obrigatório","MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}.","VALUE_REQUIRED":"Valor é obrigatório","CODE_REQUIRED":"Código é obrigatório","FIELD_REQUIRED":"Este campo é obrigatório","MEASURE_REQUIRED":"Medida do produto é obrigatória","DUPLICATED_CODE":"Código já consta para outro produto","DUPLICATED_CODE_ARCHIVED":"Código já consta para outro produto (Arquivado)"}},"DIALOG":{"CLOSE":"Fechar","MEASURE":"Medida","PRODUCT_ALERT":"Adicione um produto que será armazenado ou vendido pela sua empresa.","PRODUCT_TYPE_ALERT":"Tipos de Produtos","STORAGE_ALERT":"Gerencie seu produto em cada um dos depósitos.","CREATE_TYPE_ALERT":"Para criar um produto é necessário criar um tipo de produto na aba:","IMAGE_INFORMATION":"As dimensões ideais do logo são 512px x 512px, com tamanho máximo de 2 MB.","SELECT_IMAGES":"Selecionar imagem","NEW":{"TITLE":"Novo produto","INFO":"Informações do produto"},"EDIT":{"TITLE":"Editar produto"},"ACTIONS":{"SAVE":"SALVAR","CREATE":"CRIAR","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"},"ALERT":{"TITLE":"Não foi possível salvar o produto","OK":"OK"},"TABS":{"GENERAL":"GERAL","STORAGE":"ESTOQUE"}},"TOAST":{"SAVED":"Produto \'{{ product }}\' salvo com sucesso."},"OMIE_DIALOG":{"TITLE":"Erro na importação do produto \'{{ productToUpdate }}\'","CONTENT":"O produto não foi importado pois o código \'{{ code }}\' já está sendo utilizado pelo produto \'{{existingProduct}}\'. Deseja atualizar o produto existente?","TITLE_ALL":"Erro na importação dos produtos","CONTENT_ALL":"Os seguintes produtos não foram importados <br> <b>{{ names }}</b>, pois seus códigos \'{{ codes }}\' já está sendo utilizado pelos produtos \'{{existingProduct}}\'. Deseja atualizar estes produtos existentes?","CONTENT_ALL1":"Os seguintes produtos não foram importados: ","CONTENT_ALL2":"<br><br> Pois seus códigos: ","CONTENT_ALL3":"<br><br> Já está sendo utilizado pelos produtos: ","CONTENT_ALL4":"<br><br> Deseja atualizar estes produtos existentes?","UPDATE":"Atualizar","CANCEL":"Cancelar"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/products-services/i18n/en.json',
    '{"PRODUCTS_SERVICES":{"PAGE_TITLE":"Products and services","TITLE":"Products and services","NEW":"Add product or service","RELOAD":"Reload","FILTER":"Filter","EXPORT":{"TITLE":"Export Products/Services","CONTENT":"By clicking export, you will receive a download link of the export in your email <b>{{ email }}</b>. Depending on the amount of information, the export may take a few minutes to complete.","YES":"YES","NO":"NO","CONFIRM_ACTION_CONTENT":"Do you want to proceed with the export?","SPREADSHEET_SENT":"The spreadsheet will be sent to the email {{email}} in a few minutes","SPREADSHEET_ERROR":"Ooooooooooops, something went wrong and we couldn\'t export your products :("},"FILTERS":{"TITLE":"Filter products and services","CLEAR":"Clear filter","NAME":"Search by name","SITUATIONS":{"TITLE":"Search by situation","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"},"TYPE":{"TITLE":"Search by type","ALL":"All","PRODUCT":"Products","SERVICE":"Services"}},"IMPORT":{"TITLE":"Import products from {{app}}","FOUND_PRODUCTS":"Products found","MANUAL":"Manual Import","AUTOMATIC":"Mass Import","CONTENT":"This process will import all {{quantity}} products that are registered in Omie.<br><br>- Products that do not exist in Field Control will be created;<br>- Products already existing in Field Control will be updated<br><br>The process may take a few moments depending on the quantity of products. Do not close the window until the process is finished.","IMPORT_LOADING_TITLE":"Importing products from Omie","WAIT_LOADING":"Please wait, we are importing the products...","CLOSE":"Close","IMPORT_BUTTON":"Import","UPDATE_SUCCESS":"Successfully updated","UPDATE_ERROR":"There was an error with the import.","CREATE_ERROR":"Error importing product.","SUCCESS_AUTOMATIC":"Products imported successfully!","SUCCESS_MANUAL":"Imported successfully!","SEARCH_BY_NAME":"Type at least 3 characters to search for products you want to import into Field Control.","LOADING_ERROR":"An error occurred while loading the products from Omie."},"TABLE":{"NAME":"Name","CREATED_AT":"Created at","VALUE":"Value","DESCRIPTION":"Description","TYPE":"Type","MEASURE":"Measure","ACTIVE":"Active","INACTIVE":"Inactive","SITUATION":"Situation","ACTIONS":"Actions","EDIT":"Edit","VIEW":"View","CREATE_PRODUCTS_SERVICES_CTA":"You can create a new product or service","CREATE_PRODUCTS_SERVICES_LINK":"by clicking here","PRODUCT_SERVICE_EDIT_NOT_ALLOWED":"Cannot edit a locked product/service"},"MODEL":{"NAME":"Name","VALUE":"Value","DESCRIPTION":"Description","TYPE":{"LABEL":"Type","PRODUCT":"Product","SERVICE":"Service"},"MEASURES":{"UNITY":"Units","CENTIMETER":"Centimeters","METER":"Meters","LITER":"Liters","MILLILITER":"Milliliters","KILOGRAM":"Kilogram","GRAM":"Grams","SQUARE_METERS":"Square Meters (m²)","CUBIC_METERS":"Cubic Meters (m³)","TONS_REFRIGERATION":"Tons of Refrigeration (TR)","DISLOCATION":"Dislocation (D)","CJT":"CJT","OTHERS":"Others"},"ERRORS":{"NAME_REQUIRED":"Name is required","MAX_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but has {{ receivedLength }}.","VALUE_REQUIRED":"Value is required","MEASURE_REQUIRED":"Product measure is required"}},"DIALOG":{"CLOSE":"Close","MEASURE":"Measure","QUOTATION_ALERT":"This product/service will be used in creating a quotation.","IMAGE_INFORMATION":"The ideal dimensions for the logo are 512px x 512px, with a maximum size of 2 MB.","NEW":{"TITLE":"New product or service","INFO":"Product/service information"},"EDIT":{"TITLE":"Edit product or service"},"ACTIONS":{"SAVE":"SAVE","CREATE":"CREATE","ARCHIVE":"Archive","UNARCHIVE":"Unarchive"},"ALERT":{"TITLE":"Could not save the product/service","OK":"OK"}},"TOAST":{"SAVED":"Product/Service \'{{ productService }}\' saved successfully."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/products-services/i18n/es.json',
    '{"PRODUCTS_SERVICES":{"PAGE_TITLE":"Productos y servicios","TITLE":"Productos y servicios","NEW":"Adicionar produto ou serviço","RELOAD":"Recargar","FILTER":"Filtrar","EXPORT":{"TITLE":"Exportar Productos/Servicios","CONTENT":"Al hacer clic en exportar, recibirá un enlace de descarga de la exportación en su correo electrónico <b>{{ email }}</b>. Dependiendo de la cantidad de información, la exportación puede tardar unos minutos en completarse.","YES":"SÍ","NO":"NO","CONFIRM_ACTION_CONTENT":"¿Desea continuar con la exportación?","SPREADSHEET_SENT":"La hoja de cálculo se enviará al correo electrónico {{email}} en unos minutos","SPREADSHEET_ERROR":"Ooooooooooops, algo salió mal y no pudimos exportar sus productos :("},"FILTERS":{"TITLE":"Filtrar productos y servicios","CLEAR":"Limpiar filtro","NAME":"Buscar por nombre","SITUATIONS":{"TITLE":"Buscar por situación","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"},"TYPE":{"TITLE":"Buscar por tipo","ALL":"Todos","PRODUCT":"Productos","SERVICE":"Servicios"}},"IMPORT":{"TITLE":"Importar productos de {{app}}","FOUND_PRODUCTS":"Productos encontrados","MANUAL":"Importación manual","AUTOMATIC":"Importación masiva","CONTENT":"Este proceso importará todos los {{quantity}} productos que estén registrados en Omie.<br><br>- Los productos que no existen en Field Control se crearán;<br>- Los productos ya existentes en Field Control se actualizarán<br><br>El proceso puede tardar unos momentos dependiendo de la cantidad de productos. No cierre la ventana hasta que el proceso haya finalizado.","IMPORT_LOADING_TITLE":"Importando productos de Omie","WAIT_LOADING":"Espere, estamos importando los productos...","CLOSE":"Cerrar","IMPORT_BUTTON":"Importar","UPDATE_SUCCESS":"Actualizado con éxito","UPDATE_ERROR":"Hubo un error con la importación.","CREATE_ERROR":"Error al importar el producto.","SUCCESS_AUTOMATIC":"¡Productos importados con éxito!","SUCCESS_MANUAL":"¡Importado con éxito!","SEARCH_BY_NAME":"Escriba al menos 3 caracteres para buscar productos que desea importar a Field Control.","LOADING_ERROR":"Se produjo un error al cargar los productos de Omie."},"TABLE":{"NAME":"Nombre","CREATED_AT":"Creado en","VALUE":"Valor","DESCRIPTION":"Descripción","TYPE":"Tipo","MEASURE":"Medida","ACTIVE":"Activo","INACTIVE":"Inactivo","SITUATION":"Situación","ACTIONS":"Acciones","EDIT":"Editar","VIEW":"Ver","CREATE_PRODUCTS_SERVICES_CTA":"Puede crear un nuevo producto o servicio","CREATE_PRODUCTS_SERVICES_LINK":"haciendo clic aquí","PRODUCT_SERVICE_EDIT_NOT_ALLOWED":"No se puede editar un producto / servicio bloqueado"},"MODEL":{"NAME":"Nombre","VALUE":"Valor","DESCRIPTION":"Descripción","TYPE":{"LABEL":"Tipo","PRODUCT":"Producto","SERVICE":"Servicio"},"MEASURES":{"UNITY":"Unidades","CENTIMETER":"Centímetros","METER":"Metros","LITER":"Litros","MILLILITER":"Mililitros","KILOGRAM":"Kilogramos","GRAM":"Gramos","SQUARE_METERS":"Metros Cuadrados (m²)","CUBIC_METERS":"Metros Cúbicos (m³)","TONS_REFRIGERATION":"Toneladas de Refrigeración (TR)","DISLOCATION":"Desplazamiento (D)","CJT":"CJT","OTHERS":"Otros"},"ERRORS":{"NAME_REQUIRED":"El nombre es obligatorio","MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}.","VALUE_REQUIRED":"El valor es obligatorio","MEASURE_REQUIRED":"La medida del producto es obligatoria"}},"DIALOG":{"CLOSE":"Cerrar","MEASURE":"Medida","QUOTATION_ALERT":"Este producto/servicio se utilizará en la creación de una cotización.","IMAGE_INFORMATION":"Las dimensiones ideales para el logo son 512px x 512px, con un tamaño máximo de 2 MB.","NEW":{"TITLE":"Nuevo producto o servicio","INFO":"Información del producto/servicio"},"EDIT":{"TITLE":"Editar producto o servicio"},"ACTIONS":{"SAVE":"GUARDAR","CREATE":"CREAR","ARCHIVE":"Desarchivar","UNARCHIVE":"Desarchivar"},"ALERT":{"TITLE":"No se pudo guardar el producto / servicio","OK":"OK"}},"TOAST":{"SAVED":"Producto/Servicio \'{{ productService }}\' guardado exitosamente."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/products-services/i18n/pt.json',
    '{"PRODUCTS_SERVICES":{"PAGE_TITLE":"Produtos e Serviços","TITLE":"Produtos e Serviços","NEW":"Novo produto ou serviço","RELOAD":"Atualizar","FILTER":"Filtrar","EXPORT":{"TITLE":"Exportação de Produtos/Serviços","CONTENT":"Ao clicar em exportar, você receberá um link de download da exportação no seu e-mail <b>{{ email }}</b>. Dependendo da quantidade de informações, a exportação poderá demorar alguns minutos para ser finalizada.","YES":"SIM","NO":"NÃO","CONFIRM_ACTION_CONTENT":"Deseja continuar com a exportação?","SPREADSHEET_SENT":"A planilha será enviada para o e-mail {{email}} em alguns minutos","SPREADSHEET_ERROR":"Ooooooooooops, algo errado aconteceu e não foi possível exportar seus clientes :("},"FILTERS":{"TITLE":"Filtrar produtos e serviços","CLEAR":"Limpar filtro","NAME":"Pesquisar por nome","SITUATIONS":{"TITLE":"Pesquisar por situação","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"},"TYPE":{"TITLE":"Pesquisar por tipo","ALL":"Todos","PRODUCT":"Produtos","SERVICE":"Serviços"}},"IMPORT":{"TITLE":"Importar produtos do {{app}}","FOUND_PRODUCTS":"Produtos encontrados","MANUAL":"Importação manual","AUTOMATIC":"Importação em massa","CONTENT":"Esse processo irá importar todos os {{quantity}} produtos que estão cadastrados no Omie.<br><br>- Os produtos que não existem no Field Control serão criados;<br>- Os produtos já existentes no Field Control serão atualizados<br><br>O processo poderá demorar alguns instantes de acordo com a quantidade de produtos. Não feche a janela até que o processo tenha terminado.","IMPORT_LOADING_TITLE":"Importando produtos do Omie","WAIT_LOADING":"Aguarde, estamos importando os produtos...","CLOSE":"Fechar","IMPORT_BUTTON":"Importar","UPDATE_SUCCESS":"Atualizado com sucesso","UPDATE_ERROR":"Houve um erro com a importação.","CREATE_ERROR":"Erro ao importar produto.","SUCCESS_AUTOMATIC":"Produtos importados com sucesso!","SUCCESS_MANUAL":"Importado com sucesso!","SEARCH_BY_NAME":"Digite pelo menos 3 caracteres para buscar produtos que você deseja importar para o Field Control.","LOADING_ERROR":"Ocorreu um erro ao carregar os produtos da Omie."},"TABLE":{"NAME":"Nome","CREATED_AT":"Criado em","VALUE":"Valor (R$)","DESCRIPTION":"Descrição","TYPE":"Tipo","MEASURE":"Medida","ACTIVE":"Ativo","INACTIVE":"Inativo","SITUATION":"Situação","ACTIONS":"Ações","EDIT":"Editar","VIEW":"Visualizar","CREATE_PRODUCTS_SERVICES_CTA":"Você pode criar um novo produto ou serviço","CREATE_PRODUCTS_SERVICES_LINK":"clicando aqui","PRODUCT_SERVICE_EDIT_NOT_ALLOWED":"Não é possível editar um produto/serviço bloqueado"},"MODEL":{"NAME":"Nome","VALUE":"Valor (R$)","DESCRIPTION":"Descrição","TYPE":{"LABEL":"Tipo","PRODUCT":"Produto","SERVICE":"Serviço"},"MEASURES":{"UNITY":"Unidades","CENTIMETER":"Centímetros","METER":"Metros","LITER":"Litros","MILLILITER":"Mililitros","KILOGRAM":"Quilograma","GRAM":"Gramas","SQUARE_METERS":"Metros Quadrados (m²)","CUBIC_METERS":"Metros Cúbicos (m³)","TONS_REFRIGERATION":"Toneladas de Refrigeração (TR)","DISLOCATION":"Deslocamento (D)","CJT":"CJT","OTHERS":"Outros"},"ERRORS":{"NAME_REQUIRED":"Nome é obrigatório","MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}.","VALUE_REQUIRED":"Valor é obrigatório","MEASURE_REQUIRED":"Medida do produto é obrigatória"}},"DIALOG":{"CLOSE":"Fechar","MEASURE":"Medida","QUOTATION_ALERT":"Este produto / serviço será utilizado na criação de um orçamento.","IMAGE_INFORMATION":"As dimensões ideais do logo são 512px x 512px, com tamanho máximo de 2 MB.","NEW":{"TITLE":"Novo produto ou serviço","INFO":"Informações do produto/serviço"},"EDIT":{"TITLE":"Editar produto ou serviço"},"ACTIONS":{"SAVE":"SALVAR","CREATE":"CRIAR","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"},"ALERT":{"TITLE":"Não foi possível salvar o produto/serviço","OK":"OK"}},"TOAST":{"SAVED":"Produto/Serviço \'{{ productService }}\' salvo com sucesso."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/quotations/i18n/en.json',
    '{"QUOTATIONS":{"PAGE_TITLE":"Quotations","TITLE":"Quotations","NEW":"Add quotation","RELOAD":"Reload","EXPORT_EXCEL":"Export to Excel","STATUS":{"PENDING":"Pending","APPROVED":"Approved","REFUSED":"Refused","EXPIRED":"Expired","CANCELED":"Canceled"},"DIALOG":{"GENERAL":{"TITLE":"General","WARNING_SENTENCE":"Created at {{createdAt}} by <strong>{{createdBy}}</strong>","QUOTATION_INFOS":"Quotation information","ALERT_WILL_NOT_BE_SAVED":"This email will not be saved in the quotation.","OR":"or","LABEL":{"TITLE":"Label","MANAGE":"Manage labels","NO_REGISTERED":"No labels registered, only administrators can register labels.","PLACEHOLDER":"Search labels...","TOGGLE":"Toggle","EDIT":"Update","ADD":"Create new label","BACK":"Back","NAME":"Name","CREATE_BUTTON":"Create","EDIT_LABEL":"Edit","LIMIT_EXCEEDED":"Maximum limit of labels exceeded.","LIMIT_COUNT":"{{ length }} of {{ limit }} labels"},"THIS_QUOTATION_WAS_EDITED":"This quotation was edited by another user/employee. Click the button to update it with the new information.","IMPORTANT":"Important"},"PRODUCTS_SERVICES":{"EDIT":"Edit","REMOVE":"Remove","TITLE":"Products and services","ITEMS":"Products and services ({{quotationItems}})","NO_PRODUCTS_ADDED":"No products added.","NO_SERVICES_ADDED":"No services added.","NOT_ITEMS":"No products or services added","TOTAL":"Total","SUBTOTAL":"Subtotal","CREATE_PRODUCT_SERVICE":"Create new","MODEL":{"PRODUCTS_SERVICES":{"LABEL":"Search for a product or service","LABELV2":"Search for a product or service...","SEARCH_HINT":"Search by the name of a product or service"}},"EQUIPMENTS":{"LABEL":"Search for an equipment...","BANNER":"Enter the equipment first, then add the products or services that will be used with it or add the products or services without a equipment.","LINKED":"Linked equipment ({{quantity}})","PRODUCTS":"Products ({{quantity}})","SERVICES":"Services ({{quantity}})","PRODUCTS_WITHOUT_EQUIPMENT":"Products without equipment ({{quantity}})","SERVICES_WITHOUT_EQUIPMENT":"Services without equipment ({{quantity}})","LINK":"Link equipment","NO_EQUIPS":"No equipment linked","NO_ITEMS":"No product or service linked","REMOVE":"Remove","CLOSE":"Close","OPEN":"Open"}},"EXPENSES":{"TITLE":"Expenses","ITEMS":"Expenses ({{ length }})","NO_EXPENSES_ADDED":"No expenses added.","NOT_ITEMS":"No expenses added","WARNING":"The maximum value for this expense is {{ currency }} {{ maxExpenseValue }}.","MODAL":{"TITLE":"Add Expense","LABEL":"Select expense type","SEARCH_EXPENSE":"Search expense type...","PLACEHOLDER":"Type here...","BUTTONS":{"CANCEL":"Cancel","SELECT":"Select"}},"LABELS":{"DESCRIPTION":"Expense description","VALUE":"Value ({{currency}})","RECEIPT":"Receipt"},"BUTTONS":{"ADD_EXPENSE":"Add expense","SAVE":"Save","REMOVE":"Remove"},"FOOTER":{"PRODUCTS_SERVICES_TOTAL":"Products and services","EXPENSES_TOTAL":"Expenses","TOTAL":"Total"},"TOAST":{"UPDATED_SUCCESSFULLY":"Expense receipt successfully updated.","UPDATED_FAILED":"Failed to update the expense receipt, please try again."}},"ATTACHMENTS":{"TITLE":"Attachments","DRAG_FILES":"Drag files here or click to upload","DRAG_LIMIT":"Maximum limit of 20 attachments with a maximum size of 10MB per file.","UPLOAD_BUTTON":"Upload attachments","NO_ATTACHMENTS":"No attachments","LIMIT_REACHED":"Limit of attachments reached, to add more attachments you must first delete some.","VIEW":"Check the attachment","REMOVE":"Remove","ARCHIVE":"Archive","ARCHIVED":"Archived","UNARCHIVE":"Unarchive","OR":"or","UPLOAD":"Upload attachments","NO_TITLE":"No title","CREATED_AT":"Created on {{ date }} at {{ hour }}","RENAME":"Rename","YES":"Yes","NO":"No","CANCEL":"Cancel","SAVE":"Save","DELETE_MODAL":{"TITLE":"Delete attachment","CONTENT":"Are you sure you want to delete?","SUCCESS_MESSAGE":"Attachment deleted successfully"},"ARCHIVE_MODAL":{"ARCHIVE_TITLE":"Archive attachment","UNARCHIVE_TITLE":"Unarchive attachment","ARCHIVE_CONTENT":"Are you sure you want to archive it?","UNARCHIVE_CONTENT":"Are you sure you want to unarchive it?","SUCCESS_MESSAGE":"Attachment archived successfully","SUCCESS_UNARCHIVE_MESSAGE":"Attachment unarchived successfully"},"RENAME_MODAL":{"TITLE":"Rename attachment","SUCCESS_MESSAGE":"Attachment renamed successfully","ERROR_MESSAGE":"Attachment name too large, please try again"},"ERROR_MESSAGE":" There was an error, please try again","ERROR_MESSAGE_FILE_SIZE":"This file exceeds the 10MB limit.","ERROR_MESSAGE_MAX_FILES":"You can only upload 20 files at a time.","ERROR_MESSAGE_MAX_FILES_REMOVE":" The limit of 20 attachments has been reached, delete some files to continue."},"SUBTITLES":{"SEND_QUOTATION_EMAIL_TO":"Send quotation to:","SEND_QUOTATION_EMAIL":"Send quotation"},"ARROW":{"UP":"Up","DOWN":"Down"},"NEW":{"TITLE":"Add quotation"},"VIEW":{"TITLE":"View quotation"},"ACTIONS":{"CREATE":"Create","SAVE":"Save","CONTINUE":"Continue","CREATE_SERVICE":"Create new activity","ADD_RECIPIENT_EMAIL":"Add recipient email","REMOVE_RECIPIENT_EMAIL":"Remove","SEND_RECIPIENT_EMAIL":"Send","SENT":"Sent","PRINT":"Print","SEND_TO_OMIE":"Send to Omie","ARCHIVE":"Archive quotation","UNARCHIVE":"Unarchive quotation","COPY":"Copy quotation","CANCEL":"Cancel quotation","SEND_LINK":"Send quotation","COPY_LINK":"Copy quotation link","OPEN_LINK":"Open quotation link","WARNINGS":{"UPDATE_BUDGET_TITLE":"Update quotation","UPDATE_BUDGET_CONTENT":"We detected that you changed the value or description","UPDATE_BUDGET_TYPE_PRODUCT":" of a product, ","UPDATE_BUDGET_TYPE_SERVICE":" of a service, ","UPDATE_BUDGET_TYPE_CONFIRM":"do you want to update in the quotation?","CUSTOMER_NOT_HAVE_EMAIL":"The customer does not have a registered email.","QUESTION_DATA_LOSS_TITLE":"Discard quotation","QUESTION_DATA_LOSS_CONTENT":"Are you sure you want to discard this quotation? You will not be able to resume editing later.","QUESTION_DATA_LOSS_CONTENT_WITH_EXPENSES":"Changes related to Expenses are saved automatically, other changes may be lost.","QUESTION_DATA_LOSS_YES":"Yes","QUESTION_DATA_LOSS_NO":"No"},"TOOLTIP":"It is only possible to create activity from pending and/or approved quotations"},"ADD_ITEM":"Add item","ALERT":{"TITLE":"Could not save the quotation","OK":"OK","WITHOUT_CONTENT":"It is necessary to register a product or service.","QUOTATION_ALREADY_APPROVED":"This quotation has already been approved and cannot be edited.","QUOTATION_DUPLICATED_IDENTIFIER":"This identifier is already in use, please choose another.","VALIDATION_ERROR":"There are validation errors in the quotation, please check the fields."},"CONFIRM":{"OK":"Yes","CANCEL":"No","TITLE":"Send email","MESSAGE":"Do you want to send an email with the quotation to your customer\'s emails?"},"CANCEL":{"YES":"Yes","NO":"No","TITLE":"Cancel quotation","MESSAGE":"Are you sure you want to cancel this quotation? This action is irreversible."},"TOAST":{"SAVED":"Quotation \'{{ quotation }}\' saved successfully.","LINK_SENDED":"Quotation link sent to selected emails of customer {{ customerName }}.","SPECIFIC_LINK_SENDED":"Quotation link sent to email {{ customerEmail }}.","LINK_COPIED_MESSAGE":"Quotation #{{ id }} link copied to clipboard.","COPIED_QUOTATION":"The quotation was successfully copied.","LABELS_UPDATED":"Labels updated successfully."},"MODEL":{"CUSTOMER":{"LABEL":"Customer","NOT_FOUND":"Customer not found","ENTER_VALUE":"Select the customer you want to add this quotation to.","ERRORS":{"REQUIRED":"Customer is required"},"APPROVE_BY_CUSTOMER_CORPORATE":"Approval or refusal of this quotation is done by your customer <b>{{ customerName }}.</b>"},"SERVICE_ORDER":{"LABEL":"Service order","NOT_FOUND":"Service order not found","ENTER_VALUE":"Select the service order you want to link to this quotation.","ERRORS":{"REQUIRED":"Service order is required"}},"APPROVAL":{"MESSAGE":{"LABEL":"Customer message"}},"IDENTIFIER":{"LABEL":"Identifier","ERRORS":{"REQUIRED":"Identifier is required","IDENTIFIER_EXISTS":"Identifier already registered, choose another."}},"NAME":{"LABEL":"Quotation name","ERRORS":{"REQUIRED":"Name is required"}},"EXPIRE_DATE":{"LABEL":"Expiration date*","PLACEHOLDER":"Select","ERRORS":{"REQUIRED":"Expiration date is required","INVALID":"The date is invalid"}},"DESCRIPTION":{"LABEL":"Quotation description","MAX_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but has {{ receivedLength }}."},"ADDITIONAL_INFORMATION":{"LABEL":"Observation","MAX_LENGTH":"This field should have a maximum of {{ expectedLength }} characters, but it has {{ receivedLength }}."},"DISCOUNT":{"LABEL":"Discount"},"SUBTOTAL":{"LABEL":"Subtotal"},"PRODUCT_SERVICE":{"REMOVE":"Remove","ADD":"Add","CANCEL":"Cancel","MODEL":{"NAME":{"LABEL":"Product/Service","ERRORS":{"REQUIRED":"Product/Service is required"},"NOT_FOUND":"Item not found"},"QTY":{"LABEL":"Quantity","ERRORS":{"REQUIRED":"Quantity is required"}},"VALUE":{"LABEL":"Value ({{currency}})","ERRORS":{"REQUIRED":"Value is required"}},"TOTAL":{"LABEL":"Total ({{currency}})","ERRORS":{"REQUIRED":"Total is required"}},"DESCRIPTION":{"LABEL":"Description"},"NEW_NAME":{"LABEL":"Name of the product or service"},"TYPE":{"LABEL":"Type","PRODUCT":"Product","SERVICE":"Service"}}},"EMAIL":{"LABEL":"Email","ERRORS":{"REQUIRED":"Email is required","INVALID":"Invalid email"}},"GENERAL_ERRORS":{"MAX_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but has {{ receivedLength }}."}}},"TABLE":{"IDENTIFIER":"Identifier","NAME":"Name","DESCRIPTION":"Description","CUSTOMER":"Customer","OS_IDENTIFIER":"Service order","CREATED_AT":"Created at","CREATED_BY":"Created by","EXPIRED_AT":"Expires at","TOTAL":"Total amount ({{currency}})","STATUS":"Status","ACTIONS":"Actions","VIEW":"View","CREATE_QUOTATIONS_CTA":"You can create a new quotation","CREATE_QUOTATIONS_LINK":"by clicking here"},"FILTERS":{"TITLE":"Filter quotations","CLEAR":"Clear","NAME":"Filter by name","IDENTIFIER":"Filter by identifier","CUSTOMER":{"LABEL":"Filter by customer","PLACEHOLDER":"Filter by customer"},"SITUATION":"Filter by status","STATE":{"TITLE":"Search by state","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"},"CREATED_BY":{"LABEL":"Filter by author","PLACEHOLDER":"Created by"},"FILTER_BY_LABEL":{"LABEL":"Filter by labels","NO_LABEL":"No label"},"DATE":{"TITLE":"Filter by date","NO_FILTER":"No filter","CREATION":"Creation date","NEGOTIATION":"Negotiation date","FROM":"From:","TO":"To:","SELECT_DATE":"Select date"}},"EXPORT":{"TITLE":"Export quotations","CONTENT":"Exporting quotations may take a while...<br/><br/>We will send the complete spreadsheet to your email <b>{{ email }}</b>, okay?","OK":"Confirm and receive by email","CANCEL":"Cancel"},"TOAST":{"EXPORTED":"The spreadsheet will be sent to the email \'{{ email }}\' in a few minutes."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/quotations/i18n/es.json',
    '{"QUOTATIONS":{"PAGE_TITLE":"Presupuestos","TITLE":"Presupuestos","NEW":"Agregar presupuesto","RELOAD":"Recargar","EXPORT_EXCEL":"Exportar a Excel","STATUS":{"PENDING":"Pendiente","APPROVED":"Aprobado","REFUSED":"Rechazado","EXPIRED":"Caducado","CANCELED":"Cancelado"},"DIALOG":{"GENERAL":{"TITLE":"General","WARNING_SENTENCE":"Creado en {{createdAt}} por <strong>{{createdBy}}</strong>","QUOTATION_INFOS":"Información del presupuesto","ALERT_WILL_NOT_BE_SAVED":"Este correo electrónico no se guardará en el presupuesto.","OR":"o","LABEL":{"TITLE":"Etiqueta","MANAGE":"Administrar etiquetas","NO_REGISTERED":"No hay etiquetas registradas, solo los administradores pueden registrar etiquetas.","PLACEHOLDER":"Buscar etiquetas...","TOGGLE":"Alternar","EDIT":"Actualizar","ADD":"Crear nueva etiqueta","BACK":"Volver","NAME":"Nombre","CREATE_BUTTON":"Crear","EDIT_LABEL":"Editar","LIMIT_EXCEEDED":"Se ha excedido el límite máximo de etiquetas.","LIMIT_COUNT":"{{ length }} de {{ limit }} etiquetas"},"THIS_QUOTATION_WAS_EDITED":"Este presupuesto fue editado por otro usuario/colaborador. Haga clic en el botón para actualizarlo con la nueva información.","IMPORTANT":"Importante"},"PRODUCTS_SERVICES":{"EDIT":"Editar","REMOVE":"Eliminar","TITLE":"Productos y servicios","ITEMS":"Productos y servicios ({{quotationItems}})","NO_PRODUCTS_ADDED":"No se han agregado productos.","NO_SERVICES_ADDED":"No se han agregado servicios.","NOT_ITEMS":"No se han agregado productos ni servicios","TOTAL":"Total","SUBTOTAL":"Subtotal","CREATE_PRODUCT_SERVICE":"Crear nuevo","MODEL":{"PRODUCTS_SERVICES":{"LABEL":"Buscar un producto o servicio","LABELV2":"Buscar un producto o servicio...","SEARCH_HINT":"Buscar por el nombre de un producto o servicio"}},"EQUIPMENTS":{"LABEL":"Busca un equipo...","BANNER":"Ingresa el equipo primero y luego añade los productos o servicios que se utilizarán con él o añade los productos o servicios sin un equipo vinculado.","LINKED":"Equipos vinculados ({{quantity}})","PRODUCTS":"Productos ({{quantity}})","SERVICES":"Servicios ({{quantity}})","PRODUCTS_WITHOUT_EQUIPMENT":"Productos sin equipo vinculado ({{quantity}})","SERVICES_WITHOUT_EQUIPMENT":"Servicios sin equipo vinculado ({{quantity}})","LINK":"Vincular equipos","NO_EQUIPS":"Ningún equipo vinculado","NO_ITEMS":"Ningún producto o servicio vinculado","REMOVE":"Eliminar","CLOSE":"Cerrar","OPEN":"Abrir"}},"EXPENSES":{"TITLE":"Gastos","ITEMS":"Gastos ({{ length }})","NO_EXPENSES_ADDED":"No se agregaron gastos.","NOT_ITEMS":"No se agregaron gastos","WARNING":"El valor máximo para este gasto es {{ currency }} {{ maxExpenseValue }}.","MODAL":{"TITLE":"Agregar Gasto","LABEL":"Seleccionar tipo de gasto","SEARCH_EXPENSE":"Buscar tipo de gasto...","PLACEHOLDER":"Escribe aquí...","BUTTONS":{"CANCEL":"Cancelar","SELECT":"Seleccionar"}},"LABELS":{"DESCRIPTION":"Descripción del gasto","VALUE":"Valor ({{currency}})","RECEIPT":"Recibo"},"BUTTONS":{"ADD_EXPENSE":"Agregar gasto","SAVE":"Guardar","REMOVE":"Eliminar"},"FOOTER":{"PRODUCTS_SERVICES_TOTAL":"Productos y servicios","EXPENSES_TOTAL":"Gastos","TOTAL":"Total"},"TOAST":{"UPDATED_SUCCESSFULLY":"Expense receipt successfully updated.","UPDATED_FAILED":"Failed to update the expense receipt, please try again."}},"ATTACHMENTS":{"TITLE":"Archivos adjuntos","DRAG_FILES":"Arrastre y suelte los archivos aquí","DRAG_LIMIT":"Límite máximo de 20 anexos con tamaño máximo de 10MB por archivo.","UPLOAD_BUTTON":"Subir anexos","NO_ATTACHMENTS":"No hay archivos adjuntos","LIMIT_REACHED":"Límite de anexos alcanzado, para agregar más archivos adjuntos debe eliminar algunos primero.","VIEW":"Ver archivo","REMOVE":"Eliminar archivo","ARCHIVE":"Archivar","ARCHIVED":"Archivado","UNARCHIVE":"Desarchivar","OR":"o","UPLOAD":"Cargar adjuntos","NO_TITLE":"Sin título","CREATED_AT":"Creado el {{ date }} a las {{ hour }}","RENAME":"Renombrar","YES":"Sí","NO":"No","CANCEL":"Cancelar","SAVE":"Guardar","DELETE_MODAL":{"TITLE":"Eliminar adjunto","CONTENT":"¿Estás seguro de que quieres eliminarlo?","SUCCESS_MESSAGE":"Adjunto eliminado correctamente"},"ARCHIVE_MODAL":{"ARCHIVE_TITLE":"Archivar adjunto","UNARCHIVE_TITLE":"Desarchivar adjunto","ARCHIVE_CONTENT":"¿Estás seguro de que quieres archivarlo?","UNARCHIVE_CONTENT":"¿Estás seguro de que quieres desarchivarlo?","SUCCESS_MESSAGE":"Adjunto archivado correctamente","SUCCESS_UNARCHIVE_MESSAGE":"Adjunto desarchivado correctamente"},"RENAME_MODAL":{"TITLE":"Renombrar adjunto","SUCCESS_MESSAGE":"Adjunto renombrado correctamente","ERROR_MESSAGE":"Nombre del adjunto demasiado largo, por favor inténtelo de nuevo"},"ERROR_MESSAGE":"Ocurrió un error, por favor intente nuevamente","ERROR_MESSAGE_FILE_SIZE":"Este archivo excede el límite de 10MB.","ERROR_MESSAGE_MAX_FILES":"Se ha alcanzado el límite de 20 archivos adjuntos.","ERROR_MESSAGE_MAX_FILES_REMOVE":"Se ha alcanzado el límite de 20 archivos adjuntos, elimine algunos archivos para continuar."},"SUBTITLES":{"SEND_QUOTATION_EMAIL_TO":"Enviar presupuesto a:","SEND_QUOTATION_EMAIL":"Enviar presupuesto"},"ARROW":{"UP":"Arriba","DOWN":"Abajo"},"NEW":{"TITLE":"Agregar presupuesto"},"VIEW":{"TITLE":"Ver presupuesto"},"ACTIONS":{"CREATE":"Crear","SAVE":"Guardar","CONTINUE":"Continuar","CREATE_SERVICE":"Crear nueva actividad","ADD_RECIPIENT_EMAIL":"Agregar correo electrónico del destinatario","REMOVE_RECIPIENT_EMAIL":"Eliminar","SEND_RECIPIENT_EMAIL":"Enviar","SENT":"Enviado","PRINT":"Imprimir","SEND_TO_OMIE":"Enviar a Omie","ARCHIVE":"Archivar presupuesto","UNARCHIVE":"Desarchivar presupuesto","COPY":"Copiar presupuesto","CANCEL":"Cancelar presupuesto","SEND_LINK":"Enviar presupuesto","COPY_LINK":"Copiar enlace del presupuesto","OPEN_LINK":"Abrir enlace del presupuesto","WARNINGS":{"UPDATE_BUDGET_TITLE":"Actualizar presupuesto","UPDATE_BUDGET_CONTENT":"Detectamos que has cambiado el valor o la descripción","UPDATE_BUDGET_TYPE_PRODUCT":" de un producto, ","UPDATE_BUDGET_TYPE_SERVICE":" de un servicio, ","UPDATE_BUDGET_TYPE_CONFIRM":"¿quieres actualizarlo en el presupuesto?","CUSTOMER_NOT_HAVE_EMAIL":"El cliente no tiene un correo electrónico registrado.","QUESTION_DATA_LOSS_TITLE":"Descartar presupuesto","QUESTION_DATA_LOSS_CONTENT":"¿Estás seguro de que quieres descartar este presupuesto? No podrás reanudar la edición más tarde.","QUESTION_DATA_LOSS_CONTENT_WITH_EXPENSES":"Los cambios relacionados con los gastos se guardan automáticamente, los demás cambios pueden perderse.","QUESTION_DATA_LOSS_YES":"Sí","QUESTION_DATA_LOSS_NO":"No"},"TOOLTIP":"Solo es posible crear actividad a partir de presupuestos pendientes y/o aprobados"},"ADD_ITEM":"Agregar elemento","ALERT":{"TITLE":"No se pudo guardar el presupuesto","OK":"OK","WITHOUT_CONTENT":"Es necesario registrar un producto o servicio.","QUOTATION_ALREADY_APPROVED":"No se puede editar un presupuesto aprobado.","QUOTATION_DUPLICATED_IDENTIFIER":"El identificador del presupuesto ya existe.","VALIDATION_ERROR":"Se encontraron errores de validación en el presupueto."},"CONFIRM":{"OK":"Sí","CANCEL":"No","TITLE":"Enviar correo electrónico","MESSAGE":"¿Quieres enviar un correo electrónico con el presupuesto a los correos electrónicos de tu cliente?"},"CANCEL":{"YES":"Sí","NO":"No","TITLE":"Cancelar presupuesto","MESSAGE":"¿Estás seguro de que quieres cancelar este presupuesto? Esta acción es irreversible."},"TOAST":{"SAVED":"Presupuesto \'{{ quotation }}\' guardado correctamente.","LINK_SENDED":"Enlace del presupuesto enviado a los correos electrónicos seleccionados del cliente {{ customerName }}.","SPECIFIC_LINK_SENDED":"Enlace del presupuesto enviado al correo electrónico {{ customerEmail }}.","LINK_COPIED_MESSAGE":"Enlace del presupuesto #{{ id }} copiado al portapapeles.","COPIED_QUOTATION":"El presupuesto se copió correctamente.","LABELS_UPDATED":"Etiquetas actualizadas correctamente."},"MODEL":{"CUSTOMER":{"LABEL":"Cliente","NOT_FOUND":"Cliente no encontrado","ENTER_VALUE":"Seleccione el cliente al que desea agregar este presupuesto.","ERRORS":{"REQUIRED":"Cliente es requerido"},"APPROVE_BY_CUSTOMER_CORPORATE":"La aprobación o el rechazo de este presupuesto lo realiza tu cliente <b>{{ customerName }}.</b>"},"SERVICE_ORDER":{"LABEL":"Orden de servicio","NOT_FOUND":"Orden de servicio no encontrada","ENTER_VALUE":"Seleccione la orden de servicio que desea vincular a este presupuesto.","ERRORS":{"REQUIRED":"La orden de servicio es requerida"}},"APPROVAL":{"MESSAGE":{"LABEL":"Mensaje del cliente"}},"IDENTIFIER":{"LABEL":"Identificador","ERRORS":{"REQUIRED":"Identificador es requerido","IDENTIFIER_EXISTS":"Identificador ya registrado, elige otro."}},"NAME":{"LABEL":"Nombre del presupuesto","ERRORS":{"REQUIRED":"El nombre es requerido"}},"EXPIRE_DATE":{"LABEL":"Fecha de vencimiento*","PLACEHOLDER":"Seleccionar","ERRORS":{"REQUIRED":"La fecha de vencimiento es requerida","INVALID":"La fecha es inválida"}},"DESCRIPTION":{"LABEL":"Descripción del presupuesto","MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}."},"ADDITIONAL_INFORMATION":{"LABEL":"Observaciones","MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}."},"DISCOUNT":{"LABEL":"Descuento"},"SUBTOTAL":{"LABEL":"Subtotal"},"PRODUCT_SERVICE":{"REMOVE":"Eliminar","ADD":"Agregar","CANCEL":"Cancelar","MODEL":{"NAME":{"LABEL":"Producto/Servicio","ERRORS":{"REQUIRED":"Producto/Servicio es requerido"},"NOT_FOUND":"Elemento no encontrado"},"QTY":{"LABEL":"Cantidad","ERRORS":{"REQUIRED":"Cantidad es requerida"}},"VALUE":{"LABEL":"Valor ({{currency}})","ERRORS":{"REQUIRED":"Valor es requerido"}},"TOTAL":{"LABEL":"Total ({{currency}})","ERRORS":{"REQUIRED":"Total es requerido"}},"DESCRIPTION":{"LABEL":"Descripción"},"NEW_NAME":{"LABEL":"Nombre del producto o servicio"},"TYPE":{"LABEL":"Tipo","PRODUCT":"Producto","SERVICE":"Servicio"}}},"EMAIL":{"LABEL":"Correo electrónico","ERRORS":{"REQUIRED":"Correo electrónico es requerido","INVALID":"Correo electrónico inválido"}},"GENERAL_ERRORS":{"MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}."}}},"TABLE":{"IDENTIFIER":"Identificador","NAME":"Nombre","DESCRIPTION":"Descripción","CUSTOMER":"Cliente","OS_IDENTIFIER":"Orden de servicio","CREATED_AT":"Creado en","CREATED_BY":"Creado por","EXPIRED_AT":"Caduca el","TOTAL":"Total ({{currency}})","STATUS":"Estado","ACTIONS":"Acciones","VIEW":"Ver","CREATE_QUOTATIONS_CTA":"Puede crear un nuevo presupuesto","CREATE_QUOTATIONS_LINK":"haciendo clic aquí"},"FILTERS":{"TITLE":"Filtrar presupuestos","CLEAR":"Limpiar","NAME":"Filtrar por nombre","IDENTIFIER":"Filtrar por identificador","CUSTOMER":{"LABEL":"Filtrar por cliente","PLACEHOLDER":"Filtrar por cliente"},"SITUATION":"Filtrar por estado","STATE":{"TITLE":"Buscar por estado","ALL":"Todo","ACTIVE":"Activo","ARCHIVED":"Archivado"},"CREATED_BY":{"LABEL":"Filtrar por autor","PLACEHOLDER":"Creado por"},"FILTER_BY_LABEL":{"LABEL":"Filtrar por etiquetas","NO_LABEL":"Sin etiqueta"},"DATE":{"TITLE":"Filtrar por fecha","NO_FILTER":"Sin filtro","CREATION":"Fecha de creación","NEGOTIATION":"Fecha de negociación","FROM":"Desde:","TO":"Hasta:","SELECT_DATE":"Seleccionar fecha"}},"EXPORT":{"TITLE":"Exportar Presupuestos","CONTENT":"La exportación de presupuestos puede tardar un tiempo...<br/><br/>Enviaremos la hoja de cálculo completa a tu correo electrónico <b>{{ email }}</b>, ¿de acuerdo?","OK":"Confirmar y recibir por correo electrónico","CANCEL":"Cancelar"},"TOAST":{"EXPORTED":"La hoja de cálculo se enviará al correo electrónico \'{{ email }}\' en unos minutos."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/quotations/i18n/pt.json',
    '{"QUOTATIONS":{"PAGE_TITLE":"Orçamentos","TITLE":"Orçamentos","NEW":"Adicionar Orçamento","RELOAD":"Recarregar","EXPORT_EXCEL":"Exportar em Excel","STATUS":{"PENDING":"Pendente","APPROVED":"Aprovado","REFUSED":"Recusado","EXPIRED":"Expirado","CANCELED":"Cancelado"},"DIALOG":{"GENERAL":{"TITLE":"Geral","WARNING_SENTENCE":"Criado em {{createdAt}} por <strong>{{createdBy}}</strong>","QUOTATION_INFOS":"Dados do orçamento","ALERT_WILL_NOT_BE_SAVED":"Este e-mail não será salvo no orçamento.","OR":"ou","LABEL":{"TITLE":"Etiqueta","MANAGE":"Gerenciar etiquetas","NO_REGISTERED":"Nenhuma etiqueta cadastrada, apenas administradores podem cadastrar etiquetas.","PLACEHOLDER":"Pesquisar etiquetas...","TOGGLE":"Alternar","EDIT":"Atualizar","ADD":"Criar nova etiqueta","BACK":"Voltar","NAME":"Nome","CREATE_BUTTON":"Criar","EDIT_LABEL":"Editar","LIMIT_EXCEEDED":"Limite máximo de etiquetas foi excedido.","LIMIT_COUNT":"{{ length }} de {{ limit }} etiquetas"},"THIS_QUOTATION_WAS_EDITED":"Este orçamento foi editado por outro usuário/colaborador. Clique no botão para atualizá-lo com as novas informações.","IMPORTANT":"Importante"},"PRODUCTS_SERVICES":{"EDIT":"Editar","REMOVE":"Remover","TITLE":"Produtos e serviços","ITEMS":"Produtos e serviços ({{quotationItems}})","NO_PRODUCTS_ADDED":"Nenhum produto adicionado.","NO_SERVICES_ADDED":"Nenhum serviço adicionado.","NOT_ITEMS":"Nenhum produto ou serviço adicionado","TOTAL":"Total","SUBTOTAL":"Subtotal","CREATE_PRODUCT_SERVICE":"Cadastrar novo","MODEL":{"PRODUCTS_SERVICES":{"LABEL":"Busque por um produto ou serviço","LABELV2":"Busque por um produto ou serviço...","SEARCH_HINT":"Buscar pelo nome de um produto ou serviço"}},"EQUIPMENTS":{"LABEL":"Busque por um equipamento...","BANNER":"Insira o equipamento inicialmente e, em seguida, adicione os produtos ou serviços que serão usados nele ou adicione produtos ou serviços sem um equipamento.","LINKED":"Equipamentos vinculados ({{quantity}})","PRODUCTS":"Produtos ({{quantity}})","SERVICES":"Serviços ({{quantity}})","PRODUCTS_WITHOUT_EQUIPMENT":"Produtos sem equipamento ({{quantity}})","SERVICES_WITHOUT_EQUIPMENT":"Serviços sem equipamento ({{quantity}})","LINK":"Vincular equipamentos","NO_EQUIPS":"Nenhum equipamento vinculado","NO_ITEMS":"Nenhum produto ou serviço vinculado","REMOVE":"Remover","CLOSE":"Fechar","OPEN":"Abrir"}},"EXPENSES":{"TITLE":"Despesas","ITEMS":"Despesas ({{ length }})","NO_EXPENSES_ADDED":"Nenhuma despesa adicionada.","NOT_ITEMS":"Nenhuma despesa adicionada","WARNING":"O valor máximo para essa despesa é de {{ currency }} {{ maxExpenseValue }}.","MODAL":{"TITLE":"Adicionar Despesa","LABEL":"Selecionar tipo de despesa","SEARCH_EXPENSE":"Pesquisar tipo de despesa...","PLACEHOLDER":"Digite aqui...","BUTTONS":{"CANCEL":"Cancelar","SELECT":"Selecionar"}},"LABELS":{"DESCRIPTION":"Descrição da despesa","VALUE":"Valor ({{currency}})","RECEIPT":"Nota Fiscal"},"BUTTONS":{"ADD_EXPENSE":"Adicionar despesa","SAVE":"Salvar","REMOVE":"Remover"},"FOOTER":{"PRODUCTS_SERVICES_TOTAL":"Produtos e serviços","EXPENSES_TOTAL":"Despesas","TOTAL":"Total"},"TOAST":{"UPDATED_SUCCESSFULLY":"Nota Fiscal da despesa atualizada com sucesso.","UPDATED_FAILED":"Erro ao atualizar a Nota Fiscal da despesa, por favor tente novamente."}},"ATTACHMENTS":{"TITLE":"Anexos","DRAG_FILES":"Arraste seus arquivos para fazer upload","DRAG_LIMIT":"Limite máximo de 20 anexos com tamanho máximo de 10MB por arquivo.","UPLOAD_BUTTON":"Inserir arquivos","NO_ATTACHMENTS":"Nenhum anexo adicionado.","LIMIT_REACHED":"Limite de anexos atingido, para adicionar mais anexos você precisa remover alguns primeiro.","VIEW":"Ver original","REMOVE":"Excluir","ARCHIVE":"Arquivar","ARCHIVED":"Arquivado","UNARCHIVE":"Desarquivar","OR":"ou","UPLOAD":"Enviar anexos","NO_TITLE":"Sem título","CREATED_AT":"Criado em {{ date }} às {{ hour }}","RENAME":"Renomear","YES":"Sim","NO":"Não","CANCEL":"Cancelar","SAVE":"Salvar","DELETE_MODAL":{"TITLE":"Excluir anexo","CONTENT":"Tem certeza que deseja excluir?","SUCCESS_MESSAGE":"Anexo excluído com sucesso"},"ARCHIVE_MODAL":{"ARCHIVE_TITLE":"Arquivar anexo","UNARCHIVE_TITLE":"Desarquivar anexo","ARCHIVE_CONTENT":"Tem certeza que deseja arquivá-lo?","UNARCHIVE_CONTENT":"Tem certeza que deseja desarquivá-lo?","SUCCESS_MESSAGE":"Anexo arquivado com sucesso","SUCCESS_UNARCHIVE_MESSAGE":"Anexo desarquivado com sucesso"},"RENAME_MODAL":{"TITLE":"Renomear anexo","SUCCESS_MESSAGE":"Anexo renomeado com sucesso","ERROR_MESSAGE":"Nome do anexo muito grande, por favor tente novamente"},"ERROR_MESSAGE":"Houve um erro, por favor tente novamente","ERROR_MESSAGE_FILE_SIZE":"Este arquivo excede o limite de 10MB.","ERROR_MESSAGE_MAX_FILES":"Você atingiu o limite de 20 anexos.","ERROR_MESSAGE_MAX_FILES_REMOVE":"O limite de é de 20 anexos, remova algum arquivo para continuar."},"SUBTITLES":{"SEND_QUOTATION_EMAIL_TO":"Enviar orçamento para:","SEND_QUOTATION_EMAIL":"Enviar orçamento"},"ARROW":{"UP":"Subir","DOWN":"Descer"},"NEW":{"TITLE":"Adicionar orçamento"},"VIEW":{"TITLE":"Visualizar orçamento"},"ACTIONS":{"CREATE":"Criar","SAVE":"Salvar","CONTINUE":"Continuar","CREATE_SERVICE":"Criar nova atividade","ADD_RECIPIENT_EMAIL":"Adicionar e-mail destinatário","REMOVE_RECIPIENT_EMAIL":"Remover","SEND_RECIPIENT_EMAIL":"Enviar","SENT":"Enviado","PRINT":"Imprimir","SEND_TO_OMIE":"Enviar para Omie","ARCHIVE":"Arquivar orçamento","UNARCHIVE":"Desarquivar orçamento","COPY":"Copiar orçamento","CANCEL":"Cancelar orçamento","SEND_LINK":"Enviar orçamento","COPY_LINK":"Copiar link do orçamento","OPEN_LINK":"Abrir link do orçamento","WARNINGS":{"UPDATE_BUDGET_TITLE":"Atualizar orçamento","UPDATE_BUDGET_CONTENT":"Detectamos que você alterou o valor ou descrição","UPDATE_BUDGET_TYPE_PRODUCT":" de um produto, ","UPDATE_BUDGET_TYPE_SERVICE":" de um serviço, ","UPDATE_BUDGET_TYPE_CONFIRM":"deseja atualizar no orçamento?","CUSTOMER_NOT_HAVE_EMAIL":"O cliente não possui e-mail cadastrado.","QUESTION_DATA_LOSS_TITLE":"Descartar orçamento","QUESTION_DATA_LOSS_CONTENT":"Tem certeza que deseja descartar este orçamento? Você não poderá retomar a edição posteriormente.","QUESTION_DATA_LOSS_CONTENT_WITH_EXPENSES":"Alterações relacionadas a Despesas são salvas automaticamente, as demais alterações podem ser perdidas.","QUESTION_DATA_LOSS_YES":"Sim","QUESTION_DATA_LOSS_NO":"Não"},"TOOLTIP":"Só é possível criar atividade a partir de orçamentos pendentes e/ou aprovados"},"ADD_ITEM":"Adicionar item","ALERT":{"TITLE":"Não foi possível salvar o orçamento","OK":"OK","WITHOUT_CONTENT":"É necessário cadastrar um produto ou serviço.","QUOTATION_ALREADY_APPROVED":"Este orçamento já foi aprovado, não é possível editá-lo.","QUOTATION_DUPLICATED_IDENTIFIER":"Identificador duplicado, por favor escolha outro.","VALIDATION_ERROR":"Existem dados inválidos no orçamento, por favor corrija-os e tente novamente."},"CONFIRM":{"OK":"Sim","CANCEL":"Não","TITLE":"Enviar e-mail","MESSAGE":"Deseja enviar e-mail com o orçamento para os e-mails do seu cliente ?"},"CANCEL":{"YES":"Sim","NO":"Não","TITLE":"Cancelar orçamento","MESSAGE":"Tem certeza que deseja cancelar este orçamento? Essa ação é irreversível."},"TOAST":{"SAVED":"Orçamento \'{{ quotation }}\' salvo com sucesso.","LINK_SENDED":"Link do orçamento enviado para os e-mails selecionados do cliente {{ customerName }}.","SPECIFIC_LINK_SENDED":"Link do orçamento enviado para o e-mail {{ customerEmail }}.","LINK_COPIED_MESSAGE":"O link do orçamento #{{ id }} foi copiado para área de transferência.","COPIED_QUOTATION":"O orçamento foi copiado com sucesso.","LABELS_UPDATED":"Etiquetas atualizadas com sucesso."},"MODEL":{"CUSTOMER":{"LABEL":"Cliente","NOT_FOUND":"Cliente não encontrado","ENTER_VALUE":"Selecione o cliente que deseja adicionar este orçamento.","ERRORS":{"REQUIRED":"Cliente é obrigatório"},"APPROVE_BY_CUSTOMER_CORPORATE":"A aprovação ou recusa deste orçamento é feita pelo seu cliente <b>{{ customerName }}.</b>"},"SERVICE_ORDER":{"LABEL":"Ordem de serviço","NOT_FOUND":"Ordem de serviço não encontrada","ENTER_VALUE":"Selecione a ordem de serviço que deseja vincular a este orçamento.","ERRORS":{"REQUIRED":"Ordem de serviço é obrigatório"}},"APPROVAL":{"MESSAGE":{"LABEL":"Mensagem do cliente"}},"IDENTIFIER":{"LABEL":"Identificador","ERRORS":{"REQUIRED":"Identificador é obrigatório","IDENTIFIER_EXISTS":"Identificador já cadastrado, escolha outro."}},"NAME":{"LABEL":"Nome do orçamento","ERRORS":{"REQUIRED":"Nome é obrigatório"}},"EXPIRE_DATE":{"LABEL":"Data de expiração*","PLACEHOLDER":"Selecione","ERRORS":{"REQUIRED":"Data de expiração é obrigatória","INVALID":"A data é inválida"}},"DESCRIPTION":{"LABEL":"Descrição do orçamento","MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}."},"ADDITIONAL_INFORMATION":{"LABEL":"Observações","MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}."},"DISCOUNT":{"LABEL":"Desconto"},"SUBTOTAL":{"LABEL":"Subtotal"},"PRODUCT_SERVICE":{"REMOVE":"Remover","ADD":"Adicionar","CANCEL":"Cancelar","MODEL":{"NAME":{"LABEL":"Produto/Serviço","ERRORS":{"REQUIRED":"Produto/Serviço é obrigatória"},"NOT_FOUND":"Item não encontrado"},"QTY":{"LABEL":"Quantidade","ERRORS":{"REQUIRED":"Quantidade é obrigatória"}},"VALUE":{"LABEL":"Valor ({{currency}})","ERRORS":{"REQUIRED":"Valor é obrigatória"}},"TOTAL":{"LABEL":"Total ({{currency}})","ERRORS":{"REQUIRED":"Total é obrigatória"}},"DESCRIPTION":{"LABEL":"Descrição"},"NEW_NAME":{"LABEL":"Nome do produto ou serviço"},"TYPE":{"LABEL":"Tipo","PRODUCT":"Produto","SERVICE":"Serviço"}}},"EMAIL":{"LABEL":"E-mail","ERRORS":{"REQUIRED":"E-mail é obrigatório","INVALID":"E-mail inválido"}},"GENERAL_ERRORS":{"MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}."}}},"TABLE":{"IDENTIFIER":"Identificador","NAME":"Nome","DESCRIPTION":"Descrição","CUSTOMER":"Cliente","OS_IDENTIFIER":"Ordem de serviço","CREATED_AT":"Criado em","CREATED_BY":"Criado por","EXPIRED_AT":"Expira em","TOTAL":"Valor total ({{currency}})","STATUS":"Situação","ACTIONS":"Ações","VIEW":"Visualizar","CREATE_QUOTATIONS_CTA":"Você pode criar um novo orçamento","CREATE_QUOTATIONS_LINK":"clicando aqui"},"FILTERS":{"TITLE":"Filtrar orçamentos","CLEAR":"Limpar","NAME":"Filtrar por nome","IDENTIFIER":"Filtrar por identificador","CUSTOMER":{"LABEL":"Filtrar por cliente","PLACEHOLDER":"Filtrar por cliente"},"SITUATION":"Filtrar por status","STATE":{"TITLE":"Pesquisar por estado","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"},"CREATED_BY":{"LABEL":"Filtrar por autor","PLACEHOLDER":"Criado por"},"FILTER_BY_LABEL":{"LABEL":"Filtrar por etiquetas","NO_LABEL":"Sem etiqueta"},"DATE":{"TITLE":"Filtrar por data","NO_FILTER":"Sem filtro","CREATION":"Data da criação","NEGOTIATION":"Data da tratativa","FROM":"De:","TO":"Até:","SELECT_DATE":"Selecionar data"}},"EXPORT":{"TITLE":"Exportação de orçamentos","CONTENT":"A exportação dos orçamentos pode demorar um pouco...<br/><br/>Enviaremos a planilha completa para o seu email <b>{{ email }}</b>, combinado?","OK":"Confirmar e receber por e-mail","CANCEL":"Cancelar"},"TOAST":{"EXPORTED":"A planilha será enviada para o email \'{{ email }}\' em alguns minutos."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/recurrences/i18n/en.json',
    '{"RECURRENCES":{"PAGE_TITLE":"Recurrent tasks","TITLE":"Recurrent tasks","ALTER_COLUMN":"Change columns","PRINT":"Print","EXPORT_CSV":"Export to CSV","EXPORT_EXCEL":"Export to Excel","NEW":"New recurrent task","FILTER":"Filter Recurrent tasks","RELOAD":"Reload","REACHED_THE_MAXIMUM":"You have reached the recurrent tasks limit for your account. Contact support to learn more.","CONTACT_SUPPORT":"Contact support to learn more.","MODEL":{"SERVICE":"OS type","EMPLOYEE":"Employee","CUSTOMER":"Customer","LOCATION":"Location","ZIPCODE":"Zip code","CITY":"City","STATE":"State","NEIGHBORHOOD":"Neighborhood","STREET":"Street","NUMBER":"Number","COMPLEMENT":"Additionl address information","EMAIL":"Email","PHONE":"Telephone number","NOTES":"Work order information","ARCHIVE":"Archive recurrent task","UNARCHIVE":"Unarchive","ARCHIVED":"Archived","INTERVAL":"Repeat","INTERVALS":{"DAILY":"Daily","WEEKLY":"Weekly","MONTHLY":"Monthly"},"EVERY":"Every","START_AT":"Starts on","END_AT":"Ends on","TIME_UNITS":{"DAY":"day","DAYS":"days","WEEK":"week","WEEKS":"weeks","MONTH":"month","MONTHS":"months"},"DAY_OF_MONTH":"Day of the month","DAY_OF_WEEK":"Day of the week","WEEK_DAYS":{"MONDAY":"Monday","TUESDAY":"Tuesday","WEDNESDAY":"Wednesday","THURSDAY":"Thursday","FRIDAY":"Friday","SATURDAY":"Saturday","SUNDAY":"Sunday"},"SCHEDULE":"Time","NO_EMPLOYEE":"No employee","INACTIVE_EMPLOYEE":"Inactive","ARCHIVED_SERVICE":"Archived","ABSENT_EMPLOYEE":"Absent","EXPLANATION":{"ON_O":"on","ON_A":"on","STARTS_ON":"The recurrent task will start on <b>{{ date }}</b>","ENDS_ON":"and end on <b>{{ date }}</b>","NO_END_DATE":"no end date","SCHEDULED_EVERY":"Work orders will be scheduled every <b>{{ everyInterval }}</b>","EXCEPT_WEEKENDS":"except on weekends","ON_DAY":"on day","AT":"at","AUTOMATICALLY_CREATED":"and created in Field Control <b>automatically</b> 1 month before the scheduled date.","MANUALLY_CREATED":"and must be created <b>manually</b>."},"ERRORS":{"SERVICE_REQUIRED":"Service is mandatory","EMPLOYEE_REQUIRED":"Employee is mandatory","CUSTOMER_REQUIRED":"Customer is mandatory","CORPORATE_CUSTOMER":"Cannot post recurrences to a customer <b>{{ customerName }}</b>.","CUSTOMER_NOT_FOUND":"Customer not found","LOCATION_ENTER_VALUE":"Location should be selected","LOCATION_REQUIRED":"Location is mandatory","LOCATION_NOT_FOUND":"No location found","SCHEDULING_DATE_REQUIRED":"Date is mandatory","START_AT_REQUIRED":"Date \'starts in\' is mandatory","INVALID_DATE":"The value entered is not a date","EVERY_REQUIRED":"\'Each\' is mandatory","EVERY_MAX_DAYS":"45 day maximum ","EVERY_MAX_WEEKENDS":"Maximum value of 45 weeks","EVERY_MAX_MOUTHS":"Maximum value of 45 months","EVERY_MIN_DAYS":"Minimum value of 1 day","EVERY_MIN_WEEKENDS":"Minimum value of 1 week","EVERY_MIN_MOUTHS":"Minimum value of 1 month","DAY_OF_MONTH_REQUIRED":"Month of the month is mandatory","INVALID_TIME":"Invalid time","DOES_NOT_PERFORM":"Employee does not perform <b>{{ serviceDescription }} tasks</b>","NO_LOCATIONS":{"TEXT":"This customer has no location yet.","LINK":"Click here to create a location in:"}}},"FILTERS":{"TITLE":"Filter Recurrent tasks","CLEAR":"Clear filters","CUSTOMER":"Search by customer","LOCATION":"Search by location","DATE":{"TITLE":"Filter by date","SELECT":"Select date","FROM":"From:","TO":"To:","BY_DEADLINE":{"TITLE":"Filter by end date","BY_RESPONSE_DEADLINE_STATUS":"Filter by response deadline","BY_SOLUTION_DEADLINE_STATUS":"Filter by solution deadline"}},"OBSERVATION":"Search by observation","EMPLOYEE":"Search by employee","SERVICE":{"TITLE":"Filter by OS type","SELECT":"Select tasks"},"SITUATIONS":{"TITLE":"Filter by situation","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"}},"DIALOG":{"NEW":{"TITLE":"New recurrent task"},"EDIT":{"TITLE":"Edit recurrent task"},"COPYING":{"TITLE":"Copying recurrent task"},"GENERAL":{"TITLE":"General","CLEAR_CUSTOMER":"Clear customer","CLEAR_LOCATION":"Clear location","SELECT_SERVICE":"Select a OS type","SELECT_EMPLOYEE":"Select an employee","SERVICE_DURATION":" - {{ duration }} minutes","DONT_CALCULATE_DEADLINE":"<b>Do not calculate</b> deadline for a work order","CALCULATE_DEADLINE":"<b>Calculate</b> the deadline of <b>{{ deadline }} days</b> when creating a new work order.","PRECONFIG_DEADLINE":"Deadline preconfigured by the OS type selected","SEARCH_EMPLOYEE":"Search for an employee...","INACTIVE_EMPLOYEE":"Inactive","ORDER_DESCRIPTION":{"LABEL":"Work order description","ERRORS":{"MAX_LENGTH":"This field should contain no more than {{ expectedLength }} characters, but it has {{ receivedLength }}."}},"SELECT_DATE":"Select date","SKIP_WEEKEND":"<b>Do not consider</b> scheduling on weekends","NO_SKIP_WEEKEND":"<b>Consider</b> scheduling on weekends","EMPLOYEE":{"ADD_TASK":{"MESSAGE":"Add {{ description }} as performed task?","CONFIRM":"Yes"}},"WARNING_MESSAGE":"The employee will be changed only for tasks that have not yet been created."},"EQUIPMENTS":{"TITLE":"Equipments","SEARCH":{"LABEL":"Search for equipment","NOT_FOUND":"No equipment found.","HINT":"Search by model name or equipment serial number."},"LINKED_EQUIPMENTS":{"TITLE":"Linked Equipments","OBSERVATIONS":"Observations:","REMOVE":"Remove equipment","UNLINK_ALERT":{"MESSAGE":"Are you sure you want to unlink this equipment?","YES":"Yes","NO":"No"}},"NO_EQUIPMENTS":"No equipment linked","FORMS_EQUIPMENT":{"BUTTON_OPTIONS":{"UNLINK_EQUIPMENT":"Unlink equipment"}},"NAVIGATION":{"PREVIOUS":"Previous","NEXT":"Next","SHOWING_FROM":"Showing from","TO":"to","OF":"of","RECORDS":"records"}},"OCCURRENCES":{"TITLE":"Occurrences","SIMULATION_LINK":"click here","SIMULATION_CTA":"to simulate the occurrences (dates) of the recurrence.","DATE":"Date","HOUR":"Hour","EMPLOYEE":"Employee","SITUATION":"Situation","TYPE":"Type","ACTIONS":"Actions","SCHEDULED":{"MANUAL":"Manual","AUTOMATIC":"Automatic"},"CHANGE_DESCRIPTION":{"TITLE":"Changed description","CONTENT":"The recurrence description has been changed, would you like to change it in the created service orders as well? <br> <b>Caution</b>: This will replace the existing description in the created service orders!","ACCEPT":"Change","CANCEL":"Do not change","SUCESS":"Successfully changed service order descriptions!","ERROR":"An error occurred while changing service order descriptions!"},"EDIT":"Edit","ADD":"Create task","REMOVE":"Remove","ARCHIVE_TASK":"Archive task","UNARCHIVE_TASK":"Unarchive task","CONFIRM":"Confirm","CANCEL":"Cancel","ARCHIVED_RECURRENCE":"recurrence is archived, you cannot add tasks","WAITING":"Waiting...","LOADING":"Loading occurrences...","NEXT":"Next","PREVIOUS":"Previous","HINT":"Occurrences are simulated for the <b><u>next 90 days</u></b>.<br/>tasks will be created automatically by Field Control <b><u>30 days before the scheduling date</u></b> of the occurrence."},"LINKS":{"TITLE":"Links"},"ACTIONS":{"SAVE":"Save","CREATE":"Create","CREATE_COPY":"Create a copy","ARCHIVE":"Archive","UNARCHIVE":"Unarchive"},"ALERT":{"TITLE":"Upcoming scheduled tasks","CONTENT":"The archived recurrence has scheduled tasks for the next few days, what would you like to do with these tasks?","OK":"Archive all future tasks","CANCEL":"Keep scheduled tasks"},"NAVIGATION":{"PREVIOUS":"Previous","NEXT":"Next","SHOWING_FROM":"Showing from","TO":"to","OF":"of","RECORDS":"records"},"WARNINGS":{"REMOVE_CUSTOMER_TITLE":"Confirm Removal","REMOVE_CUSTOMER_CONTENT":"Are you sure you want to remove? This will also remove the links.","CANCEL_BUTTON":"Cancel","REMOVE_BUTTON":"Remove"}},"TABLE":{"ACTIVE":"Active recurrence","INACTIVE":"Inactive recurrence","CREATED_AT":"Created at","START_AT":"Starts at","END_AT":"Ends at","RECURRENCE":"Recurrence","OBSERVATIONS":"Description","EDIT":"Edit","ACTIONS":"Actions","CREATE_RECURRENCE_CTA":"You can create a new recurrence","CREATE_RECURRENCE_LINK":"by clicking here"},"TOAST":{"CONNECTION_ERROR":"Unable to perform the action. Check your connection!","RECURRENCE_ARCHIVED":"Upcoming scheduled tasks for the recurrence have been successfully archived.","RECURRENCE_COPIED":"Recurrence copied successfully.","RECURRENCE_SAVED":"Recurrence for customer \'{{ customerName }}\' saved successfully.","TASK_ARCHIVED":"Task #{{ occurrenceIteration }} for {{ date }} has been archived.","TASK_CREATED":"Task #{{ occurrenceIteration }} for {{ date }} has been created successfully.","TASK_UNARCHIVED":"Task #{{ occurrenceIteration }} for {{ date }} has been unarchived.","TASK_UPDATED":"Occurrence #{{ occurrenceIteration }} has been successfully updated."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/recurrences/i18n/es.json',
    '{"RECURRENCES":{"PAGE_TITLE":"Recurrencias","TITLE":"Recurrencias","ALTER_COLUMN":"Cambiar columnas","PRINT":"Imprimir","EXPORT_CSV":"Exportar a CSV","EXPORT_EXCEL":"Exportar a Excel","NEW":"Nueva recurrencia","FILTER":"Filtrar recurrencias","RELOAD":"Actualizar","REACHED_THE_MAXIMUM":"Ha alcanzado el límite de las recurrencias de su cuenta.","CONTACT_SUPPORT":"Comuníquese con el soporte para obtener más información.","MODEL":{"SERVICE":"Tipo de OS","EMPLOYEE":"Empleado","CUSTOMER":"Cliente","LOCATION":"Localización","ZIPCODE":"Código postal","CITY":"Ciudad","STATE":"Estado","NEIGHBORHOOD":"Barrio","STREET":"Dirección","NUMBER":"Numero","COMPLEMENT":"Dirección complementaria","EMAIL":"Correo","PHONE":"Número de teléfono","NOTES":"Información para órdenes de servicio","ARCHIVE":"Archivar actividad recurrente","UNARCHIVE":"Desarchivar","ARCHIVED":"Archivado","INTERVAL":"Repetir","INTERVALS":{"DAILY":"Diariamente","WEEKLY":"Semanalmente","MONTHLY":"Mensualmente"},"EVERY":"Cada","START_AT":"Comienza en","END_AT":"Termina en","TIME_UNITS":{"DAY":"día","DAYS":"días","WEEK":"semana","WEEKS":"semanas","MONTH":"mes","MONTHS":"meses"},"DAY_OF_MONTH":"Día del mes","DAY_OF_WEEK":"Día de la semana","WEEK_DAYS":{"MONDAY":"Lunes","TUESDAY":"Martes","WEDNESDAY":"Miércoles","THURSDAY":"Jueves","FRIDAY":"Viernes","SATURDAY":"Sábado","SUNDAY":"Domingo"},"SCHEDULE":"Hora","NO_EMPLOYEE":"Sin empleado","INACTIVE_EMPLOYEE":"Inactivo","ARCHIVED_SERVICE":"Archivado","ABSENT_EMPLOYEE":"Ausente","EXPLANATION":{"ON_O":"el","ON_A":"el","STARTS_ON":"La recurrencia comenza el <b>{{ date }}</b>","ENDS_ON":"y termina el <b>{{ date }}</b>","NO_END_DATE":"sin fecha de término","SCHEDULED_EVERY":"Las órdenes de servicio se programarán cada <b>{{ everyInterval }}</b>","EXCEPT_WEEKENDS":"excepto los fines de semana","ON_DAY":"El día","AT":"a las","AUTOMATICALLY_CREATED":"y creadas en Control de campo <b>automáticamente</b> 1 mes antes de la fecha programada.","MANUALLY_CREATED":"y deben crearse <b>manualmente</b>."},"ERRORS":{"SERVICE_REQUIRED":"El servicio es obligatorio","EMPLOYEE_REQUIRED":"El empleado es obligatorio","CUSTOMER_REQUIRED":"El cliente es obligatorio","CUSTOMER_NOT_FOUND":"Cliente no encontrado","CORPORATE_CUSTOMER":"No se pueden publicar recurrencias para el cliente <b>{{ customerName }}</b>.","LOCATION_ENTER_VALUE":"Ubicación debe ser seleccionada","LOCATION_REQUIRED":"La ubicación es obligatoria","LOCATION_NOT_FOUND":"No se encuentra ninguna ubicación","SCHEDULING_DATE_REQUIRED":"La fecha es obligatoria","START_AT_REQUIRED":"La fecha \'comienza en\' es obligatorio","INVALID_DATE":"El valor introducido no es una fecha.","EVERY_REQUIRED":"\'Cada uno\' es obligatorio","EVERY_MAX_DAYS":"Máximo de 45 días","EVERY_MAX_WEEKENDS":"Valor máximo de 45 semanas","EVERY_MAX_MOUTHS":"Valor máximo de 45 meses","EVERY_MIN_DAYS":"Valor mínimo de 1 día","EVERY_MIN_WEEKENDS":"Valor mínimo de 1 semana","EVERY_MIN_MOUTHS":"Valor mínimo de 1 mes","DAY_OF_MONTH_REQUIRED":"El mes del mes es obligatorio.","INVALID_TIME":"Tiempo inválido","DOES_NOT_PERFORM":"El empleado no realiza actividades de <b>{{ serviceDescription }}</b>","NO_LOCATIONS":{"TEXT":"Este cliente todavía no tiene ubicación.","LINK":"Haga clic aquí para crear una ubicación en:"}}},"FILTERS":{"TITLE":"Filtrar recurrencias","CLEAR":"Limpiar filtros","CUSTOMER":"Búsqueda por cliente","LOCATION":"Búsqueda por ubicación","DATE":{"TITLE":"Filtrar por fecha","SELECT":"Seleccionar fecha","FROM":"Desde:","TO":"Hasta:","BY_DEADLINE":{"TITLE":"Filtrar por fecha de finalización","BY_RESPONSE_DEADLINE_STATUS":"Filtrar por plazo de respuesta","BY_SOLUTION_DEADLINE_STATUS":"Filtrar por plazo de solución"}},"OBSERVATION":"Buscar por observación","EMPLOYEE":"Buscar por empleado","SERVICE":{"TITLE":"Filtrar por tipo de OS","SELECT":"Seleccione las actividades"},"SITUATIONS":{"TITLE":"Filtrar por situación","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivado"}},"DIALOG":{"NEW":{"TITLE":"Nueva recurrencia"},"EDIT":{"TITLE":"Editar recurrencia"},"COPYING":{"TITLE":"Copia de recurrencia"},"GENERAL":{"TITLE":"General","CLEAR_CUSTOMER":"Limpiar cliente","CLEAR_LOCATION":"Limpiar ubicación","SELECT_SERVICE":"Seleccione un tipo de OS","SELECT_EMPLOYEE":"Seleccione un empleado","SERVICE_DURATION":" - {{ duration }} minutos","DONT_CALCULATE_DEADLINE":"<b>No calcule la</b> fecha límite para la orden de servicio.","CALCULATE_DEADLINE":"<b>Calcule</b> la fecha límite de <b>{{ deadline }} días</b> al crear la orden de servicio.","PRECONFIG_DEADLINE":"Fecha límite preconfigurada por el tipo de OS seleccionada","SEARCH_EMPLOYEE":"Buscar empleado...","INACTIVE_EMPLOYEE":"Inactivo","ORDER_DESCRIPTION":{"LABEL":"Descripción de la orden de servicio","ERRORS":{"MAX_LENGTH":"Este campo debe tener como máximo {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}."}},"SELECT_DATE":"Seleccionar fecha","SKIP_WEEKEND":"<b>No considere</b> programar los fines de semana","NO_SKIP_WEEKEND":"<b>Considere</b> programar los fines de semana","EMPLOYEE":{"ADD_TASK":{"MESSAGE":"¿Agregar {{ description }} como actividad realizada?","CONFIRM":"Sí"}},"WARNING_MESSAGE":"El empleado solo se cambiará para las actividades que aún no se hayan creado."},"EQUIPMENTS":{"TITLE":"Equipos","SEARCH":{"LABEL":"Buscar equipo","NOT_FOUND":"No se encontraron equipos.","HINT":"Buscar por nombre del modelo o número de serie del equipo."},"LINKED_EQUIPMENTS":{"TITLE":"Equipos Vinculados","OBSERVATIONS":"Observaciones:","REMOVE":"Remover equipo","UNLINK_ALERT":{"MESSAGE":"¿Estás seguro de que deseas desvincular este equipo?","YES":"Sí","NO":"No"}},"NO_EQUIPMENTS":"Ningún equipo vinculado","FORMS_EQUIPMENT":{"BUTTON_OPTIONS":{"UNLINK_EQUIPMENT":"Desvincular equipo"}},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Siguiente","SHOWING_FROM":"Mostrando de","TO":"a","OF":"de","RECORDS":"registros"}},"OCCURRENCES":{"TITLE":"Ocurrencias","SIMULATION_LINK":"haz clic aquí","SIMULATION_CTA":"para simular las ocurrencias (fechas) de la actividad recurrente.","DATE":"Fecha","HOUR":"Hora","EMPLOYEE":"Empleado","SITUATION":"Situación","TYPE":"Tipo","ACTIONS":"Acciones","SCHEDULED":{"MANUAL":"Manual","AUTOMATIC":"Automático"},"CHANGE_DESCRIPTION":{"TITLE":"Descripción cambiada","CONTENT":"La descripción de la recurrencia ha cambiado, ¿deseas cambiarla también en las órdenes de servicio creadas? <br> <b>¡Precaución!</b>: ¡Esto reemplazará la descripción existente en las órdenes de servicio creadas!","ACCEPT":"Cambiar","CANCEL":"No cambiar","SUCESS":"¡Se cambiaron con éxito las descripciones de las órdenes de servicio!","ERROR":"¡Se produjo un error al cambiar las descripciones de las órdenes de servicio!"},"EDIT":"Editar","ADD":"Crear actividad","REMOVE":"Remover","ARCHIVE_TASK":"Archivar actividad","UNARCHIVE_TASK":"Desarchivar actividad","CONFIRM":"Confirmar","CANCEL":"Cancelar","ARCHIVED_RECURRENCE":"la recurrencia está archivada, no se pueden agregar actividades","WAITING":"Esperando...","LOADING":"Cargando ocurrencias...","NEXT":"Siguiente","PREVIOUS":"Anterior","HINT":"Las ocurrencias se simulan para los <b><u>próximos 90 días</u></b>.<br/>Las actividades se crearán automáticamente por Field Control <b><u>30 días antes de la fecha de programación</u></b> de la ocurrencia."},"LINKS":{"TITLE":"Enlaces"},"ACTIONS":{"SAVE":"Guardar","CREATE":"Crear","CREATE_COPY":"Crear una copia","ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar"},"ALERT":{"TITLE":"Próximas actividades programadas","CONTENT":"La recurrencia archivada tiene actividades programadas para los próximos días, ¿qué te gustaría hacer con estas actividades?","OK":"Archivar todas las actividades futuras","CANCEL":"Mantener las actividades programadas"},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Siguiente","SHOWING_FROM":"Mostrando de","TO":"a","OF":"de","RECORDS":"registros"},"WARNINGS":{"REMOVE_CUSTOMER_TITLE":"Confirmar eliminación","REMOVE_CUSTOMER_CONTENT":"¿Estás seguro de que deseas eliminar? Esto también eliminará los enlaces.","CANCEL_BUTTON":"Cancelar","REMOVE_BUTTON":"Eliminar"}},"TABLE":{"ACTIVE":"Actividad recurrente activa","INACTIVE":"Actividad recurrente inactiva","CREATED_AT":"Creado en","START_AT":"Comienza en","END_AT":"Termina en","RECURRENCE":"Recurrencia","OBSERVATIONS":"Descripción","EDIT":"Editar","ACTIONS":"Acciones","CREATE_RECURRENCE_CTA":"Puedes crear una nueva recurrencia","CREATE_RECURRENCE_LINK":"haciendo clic aquí"},"TOAST":{"CONNECTION_ERROR":"¡No se puede realizar la acción. ¡Verifica tu conexión!","RECURRENCE_ARCHIVED":"Se han archivado con éxito las próximas actividades programadas de la recurrencia.","RECURRENCE_COPIED":"Recurrencia copiada con éxito.","RECURRENCE_SAVED":"Actividad recurrente para el cliente \'{{ customerName }}\' guardada con éxito.","TASK_ARCHIVED":"La actividad #{{ occurrenceIteration }} para {{ date }} ha sido archivada.","TASK_CREATED":"La actividad #{{ occurrenceIteration }} para {{ date }} ha sido creada con éxito.","TASK_UNARCHIVED":"La actividad #{{ occurrenceIteration }} para {{ date }} ha sido desarchivada.","TASK_UPDATED":"La ocurrencia #{{ occurrenceIteration }} ha sido actualizada con éxito."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/recurrences/i18n/pt.json',
    '{"RECURRENCES":{"PAGE_TITLE":"Recorrências","TITLE":"Recorrências","ALTER_COLUMN":"Alterar colunas","PRINT":"Imprimir","EXPORT_CSV":"Exportar em CSV","EXPORT_EXCEL":"Exportar em Excel","NEW":"Nova recorrência","FILTER":"Filtrar Recorrências","RELOAD":"Atualizar","REACHED_THE_MAXIMUM":"Você chegou ao limite de recorrencias para a sua conta.","CONTACT_SUPPORT":"Contate o suporte para saber mais.","MODEL":{"SERVICE":"Tipo de OS","EMPLOYEE":"Colaborador","CUSTOMER":"Cliente","LOCATION":"Localização","ZIPCODE":"Cep","CITY":"Cidade","STATE":"Estado","NEIGHBORHOOD":"Bairro","STREET":"Logradouro","NUMBER":"Número","COMPLEMENT":"Complemento","EMAIL":"E-mail","PHONE":"Telefone","NOTES":"Informações para ordem de serviço","ARCHIVE":"Arquivar atividade recorrente","UNARCHIVE":"Desarquivar","ARCHIVED":"Arquivado","INTERVAL":"Repete","INTERVALS":{"DAILY":"Diariamente","WEEKLY":"Semanalmente","MONTHLY":"Mensalmente"},"EVERY":"A cada","START_AT":"Inicia em","END_AT":"Termina em","TIME_UNITS":{"DAY":"dia","DAYS":"dias","WEEK":"semana","WEEKS":"semanas","MONTH":"mês","MONTHS":"meses"},"DAY_OF_MONTH":"Dia do mês","DAY_OF_WEEK":"Dia da semana","WEEK_DAYS":{"MONDAY":"Segunda-feira","TUESDAY":"Terça-feira","WEDNESDAY":"Quarta-feira","THURSDAY":"Quinta-feira","FRIDAY":"Sexta-feira","SATURDAY":"Sábado","SUNDAY":"Domingo"},"SCHEDULE":"Horário","NO_EMPLOYEE":"Sem colaborador","INACTIVE_EMPLOYEE":"Inativo","ARCHIVED_SERVICE":"Arquivado","ABSENT_EMPLOYEE":"Ausente","EXPLANATION":{"ON_O":"no","ON_A":"na","STARTS_ON":"A recorrência terá início no dia <b>{{ date }}</b>","ENDS_ON":"e término no dia <b>{{ date }}</b>","NO_END_DATE":"sem data para término","SCHEDULED_EVERY":"As ordens de serviços serão agendadas a cada <b>{{ everyInterval }}</b>","EXCEPT_WEEKENDS":"exceto em finais de semana","ON_DAY":"no dia","AT":"às","AUTOMATICALLY_CREATED":"e criadas no Field Control <b>automaticamente</b> 1 mês antes da sua data de agendamento.","MANUALLY_CREATED":"e devem ser criadas <b>manualmente</b>."},"ERRORS":{"SERVICE_REQUIRED":"Serviço é obrigatório","EMPLOYEE_REQUIRED":"Colaborador é obrigatório","CUSTOMER_REQUIRED":"Cliente é obrigatório","CORPORATE_CUSTOMER":"Não é possível lançar recorrências para uma localização do cliente <b>{{ customerName }}</b>.","CUSTOMER_NOT_FOUND":"Cliente não encontrado","LOCATION_ENTER_VALUE":"Localização deve ser selecionada","LOCATION_REQUIRED":"Localização é obrigatório","LOCATION_NOT_FOUND":"Nenhuma localização encontrada","SCHEDULING_DATE_REQUIRED":"Data é obrigatório","START_AT_REQUIRED":"Data \'inicia em\' é obrigatório","INVALID_DATE":"O valor inserido não é uma data","EVERY_REQUIRED":"\'A cada\' é obrigatório","EVERY_MAX_DAYS":"Valor máximo de 45 dias","EVERY_MAX_WEEKENDS":"Valor máximo de 45 semanas","EVERY_MAX_MOUTHS":"Valor máximo de 45 meses","EVERY_MIN_DAYS":"Valor mínimo de 1 dia","EVERY_MIN_WEEKENDS":"Valor mínimo de 1 semana","EVERY_MIN_MOUTHS":"Valor mínimo de 1 mês","DAY_OF_MONTH_REQUIRED":"Dia do mês é obrigatório","INVALID_TIME":"Horário inválido","DOES_NOT_PERFORM":"Colaborador não realiza atividades do tipo <b>{{ serviceDescription }}</b>","NO_LOCATIONS":{"TEXT":"Esse cliente ainda não possui localizações.","LINK":"Clique aqui para criar uma localização em:"}}},"FILTERS":{"TITLE":"Filtrar Recorrências","CLEAR":"Limpar filtros","CUSTOMER":"Buscar por cliente","LOCATION":"Buscar por localização","DATE":{"TITLE":"Filtrar por data de início","SELECT":"Selecionar data","FROM":"De:","TO":"Até:","BY_DEADLINE":{"TITLE":"Filtrar por data de término","BY_RESPONSE_DEADLINE_STATUS":"Filtrar por prazo de resposta","BY_SOLUTION_DEADLINE_STATUS":"Filtrar por prazo de solução"}},"OBSERVATION":"Buscar por observação","EMPLOYEE":"Buscar por colaborador","SERVICE":{"TITLE":"Filtrar por tipo de OS","SELECT":"Selecione as atividades"},"SITUATIONS":{"TITLE":"Filtrar por situação","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"}},"DIALOG":{"NEW":{"TITLE":"Nova recorrência"},"EDIT":{"TITLE":"Editar recorrência"},"COPYING":{"TITLE":"Cópia de recorrência"},"GENERAL":{"TITLE":"Geral","CLEAR_CUSTOMER":"Limpar cliente","CLEAR_LOCATION":"Limpar localização","SELECT_SERVICE":"Selecione um tipo de OS","SELECT_EMPLOYEE":"Selecione um colaborador","SERVICE_DURATION":" - {{ duration }} minutos","DONT_CALCULATE_DEADLINE":"<b>Não calcular</b> prazo para ordem de serviço.","CALCULATE_DEADLINE":"<b>Calcular</b> o prazo de <b>{{ deadline }} dias</b> ao criar ordem de serviço.","PRECONFIG_DEADLINE":"Prazo pré-configurado pelo tipo de OS selecionado","SEARCH_EMPLOYEE":"Pesquisar colaborador...","INACTIVE_EMPLOYEE":"Inativo","ORDER_DESCRIPTION":{"LABEL":"Descrição da ordem de serviço","ERRORS":{"MAX_LENGTH":"Este campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }} caracteres."}},"SELECT_DATE":"Selecionar data","SKIP_WEEKEND":"<b>Não considerar</b> agendamentos em finais de semana","NO_SKIP_WEEKEND":"<b>Considerar</b> agendamentos em finais de semana","EMPLOYEE":{"ADD_TASK":{"MESSAGE":"Adicionar {{ description }} como tipo de OS realizada?","CONFIRM":"Sim"}},"WARNING_MESSAGE":"O colaborador será alterado apenas para atividades que ainda não foram criadas."},"EQUIPMENTS":{"TITLE":"Equipamentos","SEARCH":{"LABEL":"Procurar por equipamento","NOT_FOUND":"Nenhum equipamento encontrado.","HINT":"Busque pelo nome do modelo ou número de série do equipamento."},"LINKED_EQUIPMENTS":{"TITLE":"Equipamentos vinculados","OBSERVATIONS":"Observações:","REMOVE":"Remover equipamento","UNLINK_ALERT":{"MESSAGE":"Tem certeza que deseja desvincular este equipamento?","YES":"Sim","NO":"Não"}},"NO_EQUIPMENTS":"Nenhum equipamento vinculado","FORMS_EQUIPMENT":{"BUTTON_OPTIONS":{"UNLINK_EQUIPMENT":"Desvincular equipamento"}},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Próximo","SHOWING_FROM":"Mostrando de","TO":"até","OF":"de","RECORDS":"registros"}},"OCCURRENCES":{"TITLE":"Ocorrências","SIMULATION_LINK":"clique aqui","SIMULATION_CTA":"para simular as ocorrências (datas) da atividade recorrente.","DATE":"Data","HOUR":"Hora","EMPLOYEE":"Colaborador","SITUATION":"Situação","TYPE":"Tipo","ACTIONS":"Ações","SCHEDULED":{"MANUAL":"Manual","AUTOMATIC":"Automático"},"CHANGE_DESCRIPTION":{"TITLE":"Descrição alterada","CONTENT":"A descrição da recorrencia foi alterada, gostaria de alterar nas ordem de serviços criadas também? <br> <b>Cuidado</b>: Isso irá substituir a descrição existente nas ordem de serviços criadas!","ACCEPT":"Alterar","CANCEL":"Não alterar","SUCESS":"Sucesso ao alterar as descrições das ordens de serviço!","ERROR":"Ocorreu um erro ao alterar a descrição das ordens de serviço!"},"EDIT":"Editar","ADD":"Criar atividade","REMOVE":"Remover","ARCHIVE_TASK":"Arquivar atividade","UNARCHIVE_TASK":"Desarquivar atividade","CONFIRM":"Confirmar","CANCEL":"Cancelar","ARCHIVED_RECURRENCE":"recorrência está arquivada, você não pode adicionar atividades","WAITING":"Aguardando...","LOADING":"Carregando ocorrências...","NEXT":"Próximo","PREVIOUS":"Anterior","HINT":"As ocorrências são simuladas para os <b><u>próximos 90 dias</u></b>.<br/>As atividades serão criadas automaticamente pelo Field Control <b><u>30 dias antes da data do agendamento</u></b> da ocorrência."},"LINKS":{"TITLE":"Vínculos"},"ACTIONS":{"SAVE":"Salvar","CREATE":"Criar","CREATE_COPY":"Criar uma cópia","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"},"ALERT":{"TITLE":"Próximas atividades agendadas","CONTENT":"A recorrência arquivada possui atividades agendadas para os próximos dias, o que prefere fazer com essas atividades?","OK":"Arquivar todas atividades futuras","CANCEL":"Manter atividades agendadas"},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Próximo","SHOWING_FROM":"Mostrando de","TO":"até","OF":"de","RECORDS":"registros"},"WARNINGS":{"REMOVE_CUSTOMER_TITLE":"Confirmar Remoção","REMOVE_CUSTOMER_CONTENT":"Você tem certeza de que deseja remover? Isso também removerá os vínculos.","CANCEL_BUTTON":"Cancelar","REMOVE_BUTTON":"Remover"}},"TABLE":{"ACTIVE":"Atividade recorrente ativa","INACTIVE":"Atividade recorrente inativa","CREATED_AT":"Criado em","START_AT":"Inicia em","END_AT":"Termina em","RECURRENCE":"Recorrência","OBSERVATIONS":"Descrição","EDIT":"Editar","ACTIONS":"Ações","CREATE_RECURRENCE_CTA":"Você pode criar uma nova recorrência","CREATE_RECURRENCE_LINK":"clicando aqui"},"TOAST":{"CONNECTION_ERROR":"Não foi possível realizar a ação. Verifique sua conexão!","RECURRENCE_ARCHIVED":"Próximas atividades agendadas da recorrência foram arquivadas com sucesso.","RECURRENCE_COPIED":"Recorrência copiada com sucesso.","RECURRENCE_SAVED":"Atividade recorrente para o cliente \'{{ customerName }}\' salvo com sucesso.","TASK_ARCHIVED":"Atividade #{{ occurrenceIteration }} para dia {{ date }} foi arquivada.","TASK_CREATED":"Atividade #{{ occurrenceIteration }} para dia {{ date }} foi criada com sucesso.","TASK_UNARCHIVED":"Atividade #{{ occurrenceIteration }} para dia {{ date }} foi desarquivada.","TASK_UPDATED":"Ocorrência #{{ occurrenceIteration }} foi alterada com sucesso."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/routes/i18n/en.json',
    '{"ROUTES":{"PAGE_TITLE":"Route history","TITLE":"Route history","DESCRIPTION":"The route history allows you to view the paths taken by employees on operational days.","FILTER":"Filter tasks","TOOLBAR":{"CENTRALIZE":"Center","SHOW_CONNECTION_PATHS":"Show connection paths","CLEAR_ACTIVITY_SELECTION":"Clear task selection"},"INACCURATE_ERROR":"We detected that the employee\'s route has low accuracy. It is essential that location settings be enabled on the employee\'s phone.","MAP":{"TASKS":{"SCHEDULED":"Scheduled task","PROGRESS":"Task in progress","COMPLETED":"Completed task","CANCELED":"Canceled task","DISABLED":"Disabled task"},"LAYERS":{"DEFAULT":"Default","SATELLITE":"Satellite","ROADS":"Roads","LAND":"Land"}},"FILTERS":{"CLEAR":"Clear filters","DATE":{"LABEL":"Date: ","PLACEHOLDER":"Select date","INVALID":"The minimum date to filter is: {{ validDateFormat }}"},"COLLABORATOR":{"LABEL":"Filter by employee","PLACEHOLDER":"Search for employee","SELECT":"Select employee"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/routes/i18n/es.json',
    '{"ROUTES":{"PAGE_TITLE":"Registro de rutas","TITLE":"Registro de rutas","DESCRIPTION":"El registro de rutas te permite ver los caminos tomados por los colaboradores en días operativos.","FILTER":"Filtrar actividades","TOOLBAR":{"CENTRALIZE":"Centrar","SHOW_CONNECTION_PATHS":"Mostrar rutas de conexión","CLEAR_ACTIVITY_SELECTION":"Borrar la selección de actividades"},"INACCURATE_ERROR":"Detectamos que la ruta del técnico tiene baja precisión. Es fundamental que la configuración de ubicación esté activada en el teléfono del colaborador.","MAP":{"TASKS":{"SCHEDULED":"Actividad programada","PROGRESS":"Actividad en progreso","COMPLETED":"Actividad completada","CANCELED":"Actividad cancelada","DISABLED":"Actividad impedida"},"LAYERS":{"DEFAULT":"Estándar","SATELLITE":"Satélite","ROADS":"Carreteras","LAND":"Terreno"}},"FILTERS":{"CLEAR":"Limpiar filtros","DATE":{"LABEL":"Fecha: ","PLACEHOLDER":"Seleccionar fecha","INVALID":"La fecha mínima para filtrar es: {{ validDateFormat }}"},"COLLABORATOR":{"LABEL":"Filtrar por colaborador","PLACEHOLDER":"Buscar colaborador","SELECT":"Seleccionar colaborador"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/routes/i18n/pt.json',
    '{"ROUTES":{"PAGE_TITLE":"Histórico de rotas","TITLE":"Histórico de rotas","DESCRIPTION":"O histórico de rotas permite visualizar os trajetos realizadas pelos colaboradores nos dias de operação.","FILTER":"Filtrar atividades","TOOLBAR":{"CENTRALIZE":"Centralizar","SHOW_CONNECTION_PATHS":"Mostrar ligações de trajetos","CLEAR_ACTIVITY_SELECTION":"Limpar seleção de atividade"},"INACCURATE_ERROR":"Detectamos que o trajeto do técnico está com baixa precisão. É fundamental que as configurações de localização estejam ativadas no celular do colaborador.","MAP":{"TASKS":{"SCHEDULED":"Atividade agendada","PROGRESS":"Atividade em andamento","COMPLETED":"Atividade concluída","CANCELED":"Atividade cancelada","DISABLED":"Atividade impedida"},"LAYERS":{"DEFAULT":"Padrão","SATELLITE":"Satélite","ROADS":"Estradas","LAND":"Terreno"}},"FILTERS":{"CLEAR":"Limpar filtros","DATE":{"LABEL":"Data: ","PLACEHOLDER":"Selecionar data","INVALID":"A data mínima a ser filtrada é: {{ validDateFormat }}"},"COLLABORATOR":{"LABEL":"Filtrar por colaborador","PLACEHOLDER":"Pesquisar por colaborador","SELECT":"Selecionar colaborador"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/services/i18n/en.json',
    '{"SERVICES":{"PAGE_TITLE":"OS Types","TITLE":"OS Types","DESCRIPTION":"OS Types are services provided by the company. Examples: installation, maintenance, repair, etc...","SEARCH":"Search","NEW":"Create OS type","FILTER":"Filter OS Types","RELOAD":"Reload","MODEL":{"DESCRIPTION":"Description","DURATION":"Duration (minutes)","CREATEDAT":"Created at","UPDATEDAT":"Updated at","DEADLINE":"Deadline (days)","DISTANCE":"Distance","METERS":"meters","SIGNATURE_REQUIRED":"Signature is required to complete this OS type","SIGNATURE_NOT_REQUIRED":"Signature <strong>not</strong> required to complete this OS type","QUOTATION_REQUIRED":"Quotation is required to complete this OS type","QUOTATION_NOT_REQUIRED":"Quotation <strong>not</strong> required to complete this OS type","LINK_AUTO_SUBMIT_EMPLOYEE_ENABLED":"<strong>Send</strong> service order to employee\'s email after task completion.","LINK_AUTO_SUBMIT_EMPLOYEE_DISABLED":"<strong>Do not send</strong> service order to employee\'s email after task completion.","FORM":"Choose a form","VALIDATE_DISTANCE_ENABLED":"<strong>Validate</strong> distance between client and employee to change task status.","VALIDATE_DISTANCE_DISABLED":"<strong>Do not validate</strong> distance between client and employee to change task status.","VALIDATE_DISTANCE_HINT":"Will only take effect from version 12.9.0 of the app","LINK_AUTO_SUBMIT_ENABLED":"<strong>Send</strong> email with service order link automatically after task completion.","LINK_AUTO_SUBMIT_DISABLED":"<strong>Do not send</strong> email with service order link automatically after task completion.","RATING_LINK_AUTO_SUBMIT_ENABLED":"<strong>Send</strong> email with rating link automatically after task completion.","RATING_LINK_AUTO_SUBMIT_DISABLED":"<strong>Do not send</strong> email with rating link automatically after task completion.","ON_ROUTE_LINK_AUTO_SUBMIT_ENABLED":"<strong>Send</strong> email with employee\'s location link automatically after start of travel.","ON_ROUTE_LINK_AUTO_SUBMIT_DISABLED":"<strong>Do not send</strong> email with employee\'s location link automatically after start of travel.","RATING_FORM_ENABLED":"<strong>Show</strong> rating form on service order evaluation link.","RATING_FORM_DISABLED":"<strong>Do not show</strong> rating form on service order evaluation link.","RATING_FORM":"Rating form","AUTO_SMART_REWRITE_ENABLED":"<strong>Automatically rewrite</strong> task fields when the employee completes the task.","AUTO_SMART_REWRITE_DISABLED":"<strong>Do not automatically rewrite</strong> task fields when the employee completes the task.","AUTO_SMART_REWRITE_FIELDS":{"STATUS_DESCRIPTION":"Completion description","FORMS":"Forms"},"SMART_SUMMARY_ENABLED":"<strong>Generate</strong> a smart summary of the work order after task completion with the employee\'s app.","SMART_SUMMARY_DISABLED":"<strong>Do not generate</strong> a smart summary of the work order after task completion with the employee\'s app.","SMART_SUMMARY_DISPLAY_ON_WEB":"Display the summary on the manager\'s dashboard.","SMART_SUMMARY_DISPLAY_ON_MOBILE":"Display the summary in the employee\'s app.","SMART_SUMMARY_DISPLAY_ON_REPORT":"Display the summary in the work order report.","ERRORS":{"DESCRIPTION_REQUIRED":"Description is required","DESCRIPTION_DUPLICATED":"Description already exists","DESCRIPTION_MAXLENGTH":"This field must have a maximum of 50 characters","DEADLINE_PATTERN":"Deadline must be a number","DURATION_REQUIRED":"Duration is required","DURATION_MAX":"Maximum duration of 999 minutes","DURATION_MIN":"Minimum duration of 1 minute","DEADLINE_MAX":"Maximum deadline of 999 minutes","DEADLINE_MIN":"Minimum deadline of 1 minute","DISTANCE_REQUIRED":"Distance is required","DISTANCE_MAX":"Maximum distance of 20000 meters","DISTANCE_MIN":"Minimum distance of 300 meters","AUTO_SMART_REWRITE_FIELDS_REQUIRED":"At least one field must be selected for automatic rewriting","SMART_SUMMARY_FIELDS_REQUIRED":"At least one place must be selected to display the smart summary"}},"FILTERS":{"TITLE":"Filter OS Types","CLEAR":"Clear filter","DESCRIPTION":"Search by description","DURATION":"Search by duration (minutes)","DEADLINE":"Search by deadline (days)","SITUATIONS":{"TITLE":"Search by situation","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"}},"DIALOG":{"CLOSE":"Close","NEW":{"TITLE":"New OS type"},"EDIT":{"TITLE":"Edit OS type"},"GENERAL":{"TITLE":"General"},"FORMS":{"TITLE":"Forms","ADD":"Add form","RATING_FORM":"Rating form","SEARCH":"Search form...","REMOVE":"Remove form","ALL_FORMS_ADDED":"All forms are already added","ALLOW_OTHER_FORMS":"Allow technician to answer other forms","ALLOW_OTHER_DESCRIPTION":"This option allows the employee to select other forms not linked to the OS type","EMPTY":"No forms added for the OS type","LINKED_FORMS":"Linked forms","QUESTION_QTY":"({{ questionsQty }} question)","QUESTIONS_QTY":"({{ questionsQty }} questions)","REQUIRED_TO_COMPLETE":"Required to answer to complete visit","REQUIRED_TO_IMPEDIMENT":"Required to answer to register impediment","REQUIRED_TO_START":"Required to answer to start task"},"EMPLOYEES":{"TITLE":"Employees","IN_CHARGE":"Assigned employees","SELECT_ALL":"Select all"},"TEMPLATE":{"TITLE":"Templates","INFO":"Templates are custom styles for work order reports. If necessary, link a specific template to this type of activity, and it will be automatically applied whenever it is related.","LINK":"Link template","EMPTY_STATE":"No template linked to this client","REMOVE":"Remove template","EDIT":"Change template","ACTIVE":"Active","INACTIVE":"Inactive","ARCHIVED":"Archived","TYPE":{"ORDER":"Work order report template"},"SELECT":{"TITLE":"Link Template","SEARCH":"Search by template name...","CANCEL":"Cancel","SUCCESS":"Link","EMPTY":"No templates found"}},"ACTIONS":{"SAVE":"Save","CREATE":"Create","ARCHIVE":"Archive","UNARCHIVE":"Unarchive"},"ALERT":{"TITLE":"Unable to save OS type","OK":"OK"},"ARCHIVE_ALERT":{"TITLE":"Archive OS type","DESCRIPTION":"In equipment types, there are forms linked to this OS type:","FORM":"Form","EQUIPMENT_TYPE":"Equipment type","WHEN_ARCHIVED":"When an OS type is archived, the forms linked to it are removed from the equipment types.","CANCEL":"Cancel","CONFIRM":"Continue and archive"}},"TABLE":{"ACTIVE":"Active","INACTIVE":"Inactive","DEADLINE":"Deadline (days)","SITUATION":"Situation","ACTIONS":"Actions","EDIT":"Edit","VIEW":"View","EDIT_LOCKED":"You do not have permission to edit this OS type","CREATE_OS_TYPE_CTA":"You can create a new OS type","CREATE_OS_TYPE_LINK":"by clicking here"},"TOAST":{"SAVED":"OS type \'{{ service }}\' saved successfully."},"LAUNCH_DIALOG":{"TITLE":"New feature live!","DESCRIPTION":"<div class=\\"tw-text-center tw-flex tw-flex-col tw-gap-3\\"><strong>New OS types page is now available</strong> <span>We\'ve just released a new version of this page and we\'re super excited for you to see it! This version comes packed with improvements and a more modern look, designed to offer an even smoother experience. Want to be one of the first to check it out?</span></div>","LEFT_BUTTON":"Maybe later :(","RIGHT_BUTTON":"Try it now!","BANNER_TEXT":"<b>New OS types page available,</b> now with improvements and a more modern design! Want to be one of the first to check it out?"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/services/i18n/es.json',
    '{"SERVICES":{"PAGE_TITLE":"Tipos de OS","TITLE":"Tipos de OS","DESCRIPTION":"Los tipos de OS son servicios proporcionados por la empresa. Ejemplos: instalación, mantenimiento, reparación, etc...","SEARCH":"Buscar","NEW":"Crear tipo de OS","FILTER":"Filtrar tipos de OS","RELOAD":"Recargar","MODEL":{"DESCRIPTION":"Descripción","DURATION":"Duración (minutos)","CREATEDAT":"Creado en","UPDATEDAT":"Editado en","DEADLINE":"Fecha límite (días)","DISTANCE":"Distancia","METERS":"metros","SIGNATURE_REQUIRED":"Se requiere firma para completar este tipo de OS","SIGNATURE_NOT_REQUIRED":"La firma <strong>no</strong> es requerida para completar este tipo de OS","QUOTATION_REQUIRED":"Se requiere presupuesto para completar este tipo de OS","QUOTATION_NOT_REQUIRED":"El presupuesto <strong>no</strong> es requerido para completar este tipo de OS","LINK_AUTO_SUBMIT_EMPLOYEE_ENABLED":"<strong>Enviar</strong> orden de servicio al correo electrónico del colaborador después de completar la actividad.","LINK_AUTO_SUBMIT_EMPLOYEE_DISABLED":"<strong>No enviar</strong> orden de servicio al correo electrónico del colaborador después de completar la actividad.","FORM":"Elegir un formulario","VALIDATE_DISTANCE_ENABLED":"<strong>Validar</strong> la distancia entre cliente y colaborador para cambiar el estado de la actividad.","VALIDATE_DISTANCE_DISABLED":"<strong>No validar</strong> la distancia entre cliente y colaborador para cambiar el estado de la actividad.","VALIDATE_DISTANCE_HINT":"Solo tendrá efecto a partir de la versión 12.9.0 de la aplicación","LINK_AUTO_SUBMIT_ENABLED":"<strong>Enviar</strong> correo electrónico con el enlace de la orden de servicio automáticamente después de completar la actividad.","LINK_AUTO_SUBMIT_DISABLED":"<strong>No enviar</strong> correo electrónico con el enlace de la orden de servicio automáticamente después de completar la actividad.","RATING_LINK_AUTO_SUBMIT_ENABLED":"<strong>Enviar</strong> correo electrónico con el enlace de calificación automáticamente después de completar la actividad.","RATING_LINK_AUTO_SUBMIT_DISABLED":"<strong>No enviar</strong> correo electrónico con el enlace de calificación automáticamente después de completar la actividad.","ON_ROUTE_LINK_AUTO_SUBMIT_ENABLED":"<strong>Enviar</strong> correo electrónico con el enlace de ubicación del colaborador automáticamente después de iniciar el desplazamiento.","ON_ROUTE_LINK_AUTO_SUBMIT_DISABLED":"<strong>No enviar</strong> correo electrónico con el enlace de ubicación del colaborador automáticamente después de iniciar el desplazamiento.","RATING_FORM_ENABLED":"<strong>Mostrar</strong> formulario de calificación en el enlace de evaluación de órdenes de servicio.","RATING_FORM_DISABLED":"<strong>No mostrar</strong> formulario de calificación en el enlace de evaluación de órdenes de servicio.","RATING_FORM":"Formulario de calificación","AUTO_SMART_REWRITE_ENABLED":"<strong>Reescribir automáticamente</strong> los campos de la actividad cuando el colaborador complete la actividad.","AUTO_SMART_REWRITE_DISABLED":"<strong>No reescribir automáticamente</strong> los campos de la actividad cuando el colaborador complete la actividad.","AUTO_SMART_REWRITE_FIELDS":{"STATUS_DESCRIPTION":"Descripción de finalización","FORMS":"Formularios"},"SMART_SUMMARY_ENABLED":"<strong>Generar</strong> un resumen inteligente de la orden de servicio después de completar la actividad con la aplicación del colaborador.","SMART_SUMMARY_DISABLED":"<strong>No generar</strong> un resumen inteligente de la orden de servicio después de completar la actividad con la aplicación del colaborador.","SMART_SUMMARY_DISPLAY_ON_WEB":"Mostrar el resumen en el panel del gestor.","SMART_SUMMARY_DISPLAY_ON_MOBILE":"Mostrar el resumen en la aplicación del colaborador.","SMART_SUMMARY_DISPLAY_ON_REPORT":"Mostrar el resumen en el informe de la orden de servicio.","ERRORS":{"DESCRIPTION_REQUIRED":"La descripción es obligatoria","DESCRIPTION_DUPLICATED":"La descripción ya existe","DESCRIPTION_MAXLENGTH":"Este campo debe tener un máximo de 50 caracteres","DEADLINE_PATTERN":"El plazo en días debe ser un número","DURATION_REQUIRED":"La duración es obligatoria","DURATION_MAX":"Duración máxima de 999 minutos","DURATION_MIN":"Duración mínima de 1 minuto","DEADLINE_MAX":"Fecha límite máxima de 999 minutos","DEADLINE_MIN":"Fecha límite mínima de 1 minuto","DISTANCE_REQUIRED":"La distancia es obligatoria","DISTANCE_MAX":"Distancia máxima de 20000 metros","DISTANCE_MIN":"Distancia mínima de 300 metros","AUTO_SMART_REWRITE_FIELDS_REQUIRED":"Es necesario seleccionar al menos un campo para reescribir automáticamente","SMART_SUMMARY_FIELDS_REQUIRED":"Es necesario seleccionar al menos un lugar para mostrar el resumen inteligente"}},"FILTERS":{"TITLE":"Filtrar tipos de OS","CLEAR":"Limpiar filtro","DESCRIPTION":"Buscar por descripción","DURATION":"Buscar por duración (minutos)","DEADLINE":"Buscar por fecha límite (días)","SITUATIONS":{"TITLE":"Buscar por situación","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"}},"DIALOG":{"CLOSE":"Cerrar","NEW":{"TITLE":"Nuevo tipo de OS"},"EDIT":{"TITLE":"Editar tipo de OS"},"GENERAL":{"TITLE":"General"},"FORMS":{"TITLE":"Formularios","ADD":"Agregar formulario","RATING_FORM":"Formulario de calificación","SEARCH":"Buscar formulario...","REMOVE":"Eliminar formulario","ALL_FORMS_ADDED":"Todos los formularios ya están agregados","ALLOW_OTHER_FORMS":"Permitir que el técnico responda otros formularios","ALLOW_OTHER_DESCRIPTION":"Esta opción permite que el colaborador seleccione otros formularios no vinculados al tipo de OS","EMPTY":"Ningún formulario agregado para el tipo de OS","LINKED_FORMS":"Formularios vinculados","QUESTION_QTY":"({{ questionsQty }} pregunta)","QUESTIONS_QTY":"({{ questionsQty }} preguntas)","REQUIRED_TO_COMPLETE":"Requerido para responder para completar visita","REQUIRED_TO_IMPEDIMENT":"Requerido para responder para registrar impedimento","REQUIRED_TO_START":"Requerido para responder para iniciar la actividad"},"EMPLOYEES":{"TITLE":"Colaboradores","IN_CHARGE":"Colaboradores asignados","SELECT_ALL":"Seleccionar todos"},"TEMPLATE":{"TITLE":"Modelos","INFO":"Los modelos son estilos personalizados para informes de órdenes de servicio. Si es necesario, vincule un modelo específico a este tipo de OS, y se aplicará automáticamente siempre que esté relacionado.","LINK":"Vincular modelo","EMPTY_STATE":"Ningún modelo vinculado a este cliente","REMOVE":"Eliminar modelo","EDIT":"Cambiar modelo","ACTIVE":"Activo","INACTIVE":"Inactivo","ARCHIVED":"Archivado","TYPE":{"ORDER":"Modelo de informe de orden de servicio"},"SELECT":{"TITLE":"Vincular Modelo","SEARCH":"Buscar por nombre del modelo...","CANCEL":"Cancelar","SUCCESS":"Vincular","EMPTY":"No se encontraron modelos"}},"ACTIONS":{"SAVE":"Guardar","CREATE":"Crear","ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar"},"ALERT":{"TITLE":"No se pudo guardar el tipo de OS","OK":"OK"},"ARCHIVE_ALERT":{"TITLE":"Archivar tipo de OS","DESCRIPTION":"En tipos de equipos, hay formularios vinculados a este tipo de OS:","FORM":"Formulario","EQUIPMENT_TYPE":"Tipo de equipo","WHEN_ARCHIVED":"Cuando se archiva un tipo de OS, los formularios vinculados a él se eliminan de los tipos de equipos.","CANCEL":"Cancelar","CONFIRM":"Continuar y archivar"}},"TABLE":{"ACTIVE":"Activo","INACTIVE":"Inactivo","DEADLINE":"Duración (minutos)","SITUATION":"Situación","ACTIONS":"Acciones","EDIT":"Editar","VIEW":"Ver","EDIT_LOCKED":"No tiene permiso para editar este tipo de OS","CREATE_OS_TYPE_CTA":"Puede crear un nuevo tipo de OS","CREATE_OS_TYPE_LINK":"haciendo clic aquí"},"TOAST":{"SAVED":"Tipo de OS \'{{ service }}\' guardado exitosamente."},"LAUNCH_DIALOG":{"TITLE":"¡Novedad en el aire!","DESCRIPTION":"<div class=\\"tw-text-center tw-flex tw-flex-col tw-gap-3\\"><strong>Nueva página de tipos de OS disponible</strong> <span>¡Acabamos de lanzar una nueva versión de esta página y estamos muy emocionados de que veas cómo quedó! Esta versión está llena de mejoras y un diseño más moderno, pensada para ofrecer una experiencia aún más fluida. ¿Quieres ser de los primeros en verla?</span></div>","LEFT_BUTTON":"Ver más tarde :(","RIGHT_BUTTON":"¡Probar ahora!","BANNER_TEXT":"<b>Nueva página de tipos de OS disponible,</b> ¡ahora con mejoras y un diseño más moderno! ¿Quieres ser de los primeros en verla?"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/services/i18n/pt.json',
    '{"SERVICES":{"PAGE_TITLE":"Tipos de OS","TITLE":"Tipos de OS","DESCRIPTION":"Tipos de OS são serviços prestados pela empresa. Exemplos: instalação, manutenção, reparo, etc...","SEARCH":"Pesquisar","NEW":"Criar tipo de OS","FILTER":"Filtrar tipos de OS","RELOAD":"Atualizar","MODEL":{"DESCRIPTION":"Descrição","DURATION":"Duração (minutos)","CREATEDAT":"Criado em","UPDATEDAT":"Editado em","DEADLINE":"Prazo em dias","DISTANCE":"Distância","METERS":"metros","SIGNATURE_REQUIRED":"Assinatura é obrigatória para concluir este tipo de OS","SIGNATURE_NOT_REQUIRED":"Assinatura <strong>não</strong> é obrigatória para concluir este tipo de OS","QUOTATION_REQUIRED":"Orçamento é obrigatório para concluir este tipo de OS","QUOTATION_NOT_REQUIRED":"Orçamento <strong>não</strong> é obrigatório para concluir este tipo de OS","LINK_AUTO_SUBMIT_EMPLOYEE_ENABLED":"<strong>Enviar</strong> ordem de serviço para o e-mail do colaborador após a conclusão da atividade.","LINK_AUTO_SUBMIT_EMPLOYEE_DISABLED":"<strong>Não enviar</strong> ordem de serviço para o e-mail do colaborador após a conclusão da atividade.","FORM":"Escolha um formulários","VALIDATE_DISTANCE_ENABLED":"<strong>Validar</strong> a distância entre cliente e colaborador para alterar o status da atividade.","VALIDATE_DISTANCE_DISABLED":"<strong>Não validar</strong> a distância entre cliente e colaborador para alterar o status da atividade.","VALIDATE_DISTANCE_HINT":"Apenas surtirá efeito a partir da versão 12.9.0 do aplicativo","LINK_AUTO_SUBMIT_ENABLED":"<strong>Enviar</strong> e-mail com o link da ordem de serviço automaticamente após a conclusão da atividade.","LINK_AUTO_SUBMIT_DISABLED":"<strong>Não enviar</strong> e-mail com o link da ordem de serviço automaticamente após a conclusão da atividade.","RATING_LINK_AUTO_SUBMIT_ENABLED":"<strong>Enviar</strong> e-mail com o link da avaliação automaticamente após a conclusão da atividade.","RATING_LINK_AUTO_SUBMIT_DISABLED":"<strong>Não enviar</strong> e-mail com o link da avaliação automaticamente após a conclusão da atividade.","ON_ROUTE_LINK_AUTO_SUBMIT_ENABLED":"<strong>Enviar</strong> e-mail com o link da localização do colaborador automaticamente após o inicio do deslocamento.","ON_ROUTE_LINK_AUTO_SUBMIT_DISABLED":"<strong>Não enviar</strong> e-mail com o link da localização do colaborador automaticamente após o inicio do deslocamento.","RATING_FORM_ENABLED":"<strong>Exibe</strong> o formulário de classificação no link de avaliação das ordens de serviço.","RATING_FORM_DISABLED":"<strong>Não exibe</strong> o formulário de classificação no link de avaliação das ordens de serviço.","RATING_FORM":"Formulário de avaliação","AUTO_SMART_REWRITE_ENABLED":"<strong>Reescrever automaticamente</strong> os campos da atividade quando o colaborador concluir a atividade.","AUTO_SMART_REWRITE_DISABLED":"<strong>Não reescrever automaticamente</strong> os campos da atividade quando o colaborador concluir a atividade.","AUTO_SMART_REWRITE_FIELDS":{"STATUS_DESCRIPTION":"Descrição de conclusão","FORMS":"Formulários"},"SMART_SUMMARY_ENABLED":"<strong>Gerar</strong> um resumo inteligente da ordem de serviço após a conclusão da atividade pelo aplicativo do colaborador.","SMART_SUMMARY_DISABLED":"<strong>Não gerar</strong> um resumo inteligente da ordem de serviço após a conclusão da atividade pelo aplicativo do colaborador.","SMART_SUMMARY_DISPLAY_ON_WEB":"Exibir o resumo no painel do gestor.","SMART_SUMMARY_DISPLAY_ON_MOBILE":"Exibir o resumo no aplicativo do colaborador.","SMART_SUMMARY_DISPLAY_ON_REPORT":"Exibir o resumo no relatório da ordem de serviço.","ERRORS":{"DESCRIPTION_REQUIRED":"Descrição é obrigatório","DESCRIPTION_DUPLICATED":"Descrição já existe","DESCRIPTION_MAXLENGTH":"Este campo deve possuir no máximo 150 caracteres","DEADLINE_PATTERN":"Prazo em dias deve ser um número","DURATION_REQUIRED":"Duração é obrigatório","DURATION_MAX":"Duração máxima de 999 minutos","DURATION_MIN":"Duração mínima de 1 minuto","DEADLINE_MAX":"Prazo máximo de 999 minutos","DEADLINE_MIN":"Prazo mínimo de 1 minuto","DISTANCE_REQUIRED":"Distância é obrigatória","DISTANCE_MAX":"Distância máxima de 20000 metros","DISTANCE_MIN":"Distância mínima de 300 metros","AUTO_SMART_REWRITE_FIELDS_REQUIRED":"É necessário selecionar pelo menos um campo para reescrever automaticamente","SMART_SUMMARY_FIELDS_REQUIRED":"É necessário selecionar pelo menos um lugar para exibir o resumo inteligente"}},"FILTERS":{"TITLE":"Filtrar Tipos de OS","CLEAR":"Limpar filtro","DESCRIPTION":"Pesquisar por descrição","DURATION":"Pesquisar por duração (minutos)","DEADLINE":"Pesquisar por prazo (dias)","SITUATIONS":{"TITLE":"Pesquisar por situação","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"}},"DIALOG":{"CLOSE":"Fechar","NEW":{"TITLE":"Novo tipo de OS"},"EDIT":{"TITLE":"Editar tipo de OS"},"GENERAL":{"TITLE":"Geral"},"FORMS":{"TITLE":"Formulários","ADD":"Adicionar formulário","RATING_FORM":"Formulário de avaliação","SEARCH":"Pesquisar formulário...","REMOVE":"Remover formulário","ALL_FORMS_ADDED":"Todos formulários já estão adicionados","ALLOW_OTHER_FORMS":"Permitir que o técnico responda outros formulários","ALLOW_OTHER_DESCRIPTION":"Essa opção permite que o colaborador selecione outros formulários não vinculados ao tipo de OS","EMPTY":"Nenhum formulário adicionado para o tipo de OS","LINKED_FORMS":"Formulários vinculados","QUESTION_QTY":"({{ questionsQty }} pergunta)","QUESTIONS_QTY":"({{ questionsQty }} perguntas)","REQUIRED_TO_COMPLETE":"Obrigatório responder para concluir visita","REQUIRED_TO_IMPEDIMENT":"Obrigatório responder para registrar impedimento","REQUIRED_TO_START":"Obrigatório responder para iniciar a atividade"},"EMPLOYEES":{"TITLE":"Colaboradores","IN_CHARGE":"Colaboradores capacitados","SELECT_ALL":"Selecionar todos"},"TEMPLATE":{"TITLE":"Modelos","INFO":"Modelos são estilos personalizados para relatórios de OS. Caso necessário, vincule um modelo específico a este tipo de OS, que será automaticamente aplicado sempre que ele estiver relacionado.","LINK":"Vincular modelo","EMPTY_STATE":"Nenhum modelo vinculado a este cliente","REMOVE":"Remover modelo","EDIT":"Trocar modelo","ACTIVE":"Ativo","INACTIVE":"Inativo","ARCHIVED":"Arquivado","TYPE":{"ORDER":"Modelo de relatório de OS"},"SELECT":{"TITLE":"Vincular Modelo","SEARCH":"Busque pelo nome do modelo...","CANCEL":"Cancelar","SUCCESS":"Vincular","EMPTY":"Nenhum modelo encontrado"}},"ACTIONS":{"SAVE":"Salvar","CREATE":"Criar","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"},"ALERT":{"TITLE":"Não foi possível salvar o tipo de OS","OK":"OK"},"ARCHIVE_ALERT":{"TITLE":"Arquivar tipo de OS","DESCRIPTION":"Nos tipos de equipamentos existem formulários vinculados a este tipo de OS:","FORM":"Formulário","EQUIPMENT_TYPE":"Tipo de equipamento","WHEN_ARCHIVED":"Quando um tipo de OS é arquivado, os formulários vinculados a ele são removidos dos tipos de equipamento.","CANCEL":"Cancelar","CONFIRM":"Continuar e arquivar"}},"TABLE":{"ACTIVE":"Ativo","INACTIVE":"Inativo","DEADLINE":"Prazo (dias)","SITUATION":"Situação","ACTIONS":"Ações","EDIT":"Editar","VIEW":"Visualizar","EDIT_LOCKED":"Você não tem permissão para editar esse tipo de OS","CREATE_OS_TYPE_CTA":"Você pode criar um novo tipo de OS","CREATE_OS_TYPE_LINK":"clicando aqui"},"TOAST":{"SAVED":"Tipo de OS \'{{ service }}\' salvo com sucesso."},"LAUNCH_DIALOG":{"TITLE":"Novidade no ar!","DESCRIPTION":"<div class=\\"tw-text-center tw-flex tw-flex-col tw-gap-3\\"><strong>Nova página de tipos de OS disponível</strong> <span>Acabamos de liberar uma nova versão dessa página e estamos super empolgados para que você veja como ela ficou! Esta versão está cheia de melhorias e um visual mais moderno, pensada para proporcionar uma experiência ainda mais fluida. Quer ser um dos primeiros a ver como ficou?</span></div>","LEFT_BUTTON":"Deixar para depois :(","RIGHT_BUTTON":"Testar agora!","BANNER_TEXT":"<b>Nova página de tipos de OS disponível,</b> agora com melhorias e um visual mais moderno! Quer ser um dos primeiros a conferir?"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/settings/i18n/en.json',
    '{"CONFIGURATIONS":{"PAGE_TITLE":"Configurations","COMPANY_DATA":"Company data","DISCARD_CHANGES":{"TITLE":"Discard changes?","CONTENT":"You have changes to this page that have not been saved. If you continue, they will all be discarded. Are you sure about that?","OK":"Yes","DISCARD":"No"},"CLIENT_AREA_UPDATED":"Customer area updated successfully.","ACCOUNT_SETTINGS_SAVED":"Account settings saved successfully.","SIDENAV":{"ACCOUNT":"Account","COMPANY_DATA":"Company data","MANAGE_LABELS":"Manage tags","INTEGRATIONS":"Integrations","SERVICE_REQUEST":"Ticket","SYSTEM":"System","SERVICE_ORDERS":"Work orders","TIMELINE":"Timeline","MOBILE_APP":"Employee app","EQUIPMENTS":"Equipments","OTHER_SETTINGS":"Other settings","DEVELOPER":"Developer","INTEGRATION_API":"Integration API","INTEGRATION_EVENT_HISTORY":"Event history"},"SERVICES":{"ENTER_ADDRESS":"Enter address in the field above"},"DIALOGS":{"API_KEYS":{"CREATE":{"NEW_KEY":"New key","CREATED_KEY":"Integration key","CLOSE_DIALOG":"Close","NAME":{"LABEL":"Name","REQUIRED":"Required field","MAX_LENGTH":"The field value must have a maximum of 50 characters"},"INTEGRATION_KEY_CREATED":"The integration key for your account has been created!","FINISH_MESSAGE":"<span><b>Attention:</b></span> Store your key in a safe place, as it will not be possible to recover it later.","CREATE":"Create","CLOSE":"Close"},"DELETE":{"TITLE":"Delete key","CLOSE_DIALOG":"Close","MESSAGE":"Once deleted, the key will no longer be available. <br/> To continue, type:","NAME_PLACEHOLDER":"Key name","CONFIRM":"Confirm","BETTER_NOT":"Better not"}},"LABELS":{"SUCCESSFULLY_DELETED":"Tag \'{{name}}\' deleted.","COULD_NOT_DELETE":"Unable to delete tag \'{{name}}\', please try again.","DELETE":{"TITLE":"Delete tag","MESSAGE":"Once deleted, the tag will no longer be available. <br /> To continue, type:"},"CLOSE_DIALOG":"Close","PLACEHOLDER":"Tag","BETTER_NOT":"Better not","CONFIRM":"Confirm"},"WEBHOOKS":{"CREATE":{"NEW_WEBHOOK":"New webhook","CLOSE_DIALOG":"Close","URL":{"LABEL":"URL","INVALID":"The URL is invalid","REQUIRED":"Required field","MAX_LENGTH":"The field value must have a maximum of 300 characters"},"AUTH":{"LABEL":"Authentication","NONE":"None"},"USERNAME":{"LABEL":"User name","REQUIRED":"Required field","MAX_LENGTH":"The field value must have a maximum of 30 characters"},"PASSWORD":{"LABEL":"Password","REQUIRED":"Required field","MAX_LENGTH":"The field value must have a maximum of 50 characters"},"CREATE_BUTTON":"Create","GENERAL":"General","EVENTS":"Webhook Events","SELECT_ALL":"Add all webhook events","SELECT_ONE":"Select webhook events individually","TYPES":{"ORDER_FORM_CREATED":"Order Form Creation","ORDER_FORM_CREATED_DESCRIPTION":"An order form has been created","ORDER_FORM_UPDATED":"Order Form Update","ORDER_FORM_UPDATED_DESCRIPTION":"An order form has been updated","ORDER_ATTACHMENT_CREATED":"Order Attachment Creation","ORDER_ATTACHMENT_CREATED_DESCRIPTION":"An order attachment has been created","ORDER_ATTACHMENT_UPDATED":"Order Attachment Update","ORDER_ATTACHMENT_UPDATED_DESCRIPTION":"An order attachment has been updated","ORDER_CREATED":"Order Creation","ORDER_CREATED_DESCRIPTION":"An order has been created","ORDER_UPDATED":"Order Update","ORDER_UPDATED_DESCRIPTION":"An order has been updated","TASK_CREATED":"Task Creation","TASK_CREATED_DESCRIPTION":"A task has been created","TASK_UPDATED":"Task Update","TASK_UPDATED_DESCRIPTION":"A task has been updated","TASK_STARTED":"Task Started by Employee","TASK_STARTED_DESCRIPTION":"A task status has been changed to \'In Progress\'","TASK_REPORTED":"Task Reported Impediment","TASK_REPORTED_DESCRIPTION":"A task status has been changed to \'Reported\'","TASK_COMPLETED":"Task Successfully Completed","TASK_COMPLETED_DESCRIPTION":"A task status has been changed to \'Completed\'","TASK_RATED":"Task Rating","TASK_RATED_DESCRIPTION":"A task rating has been changed","TASK_START_ROUTE":"Task Start Route","TASK_START_ROUTE_DESCRIPTION":"A task status has been changed to \'On Route\'","TASK_ROUTE_STARTED":"Task Route Started","TASK_ROUTE_STARTED_DESCRIPTION":"A task status has been changed to \'On Route\'","COMMENT_CREATED":"Comment Creation","COMMENT_CREATED_DESCRIPTION":"A comment has been created","EMPLOYEE_CREATED":"Employee Creation","EMPLOYEE_CREATED_DESCRIPTION":"A new employee has been created","TICKET_ACCEPTED":"Service Request Accepted","TICKET_ACCEPTED_DESCRIPTION":"A service request has been accepted","TICKET_CANCELED":"Service Request Canceled","TICKET_CANCELED_DESCRIPTION":"A service request has been canceled","TICKET_CREATED":"Service Request Creation","TICKET_CREATED_DESCRIPTION":"A service request has been created","QUOTATION_CREATED":"Quotation Creation","QUOTATION_CREATED_DESCRIPTION":"A quotation has been created","QUOTATION_CANCELED":"Quotation Canceled","QUOTATION_CANCELED_DESCRIPTION":"A quotation has been canceled","QUOTATION_UPDATED":"Quotation Update","QUOTATION_UPDATED_DESCRIPTION":"A quotation has been updated","QUOTATION_APPROVED":"Quotation Approved","QUOTATION_APPROVED_DESCRIPTION":"A quotation has been approved","QUOTATION_REFUSED":"Quotation Refused","QUOTATION_REFUSED_DESCRIPTION":"A quotation has been refused","VEHICLE_CREATED":"Vehicle Creation","VEHICLE_CREATED_DESCRIPTION":"A vehicle has been created","VEHICLE_UPDATED":"Vehicle Update","VEHICLE_UPDATED_DESCRIPTION":"A vehicle has been updated"}},"DELETE":{"TITLE":"Delete webhook","CLOSE_DIALOG":"Close","MESSAGE":"Once deleted, the webhook will no longer be available. <br /> To continue, type:","URL_PLACEHOLDER":"URL","CONFIRM":"Confirm","BETTER_NOT":"Better not"},"TYPES":{"TITLE":"Webhook events","SELECT_ALL":"Select all"},"RESPONSE_DETAILS":{"REQUEST":"Request","CLOSE_DIALOG":"Close","REQUEST_HEADERS":"Requisition header:","REQUEST_BODY":"Requisition body:","RESPONSE":"Response","RESPONSE_HEADERS":"Response header:","RESPONSE_BODY":"Response body:"},"COPY":{"SUCCESS":"Successfully copied","FAILURE":"Error copying"}}},"ACCOUNT":{"PAGE_TITLE":"Company data","COMPANY_NAME":{"LABEL":"Company Name","PLACEHOLDER":"Company Name","REQUIRED":"Company name required"},"NAME":{"LABEL":"Manager name","PLACEHOLDER":"Manager name","REQUIRED":"Manager name required"},"PHONE_NUMBER":{"LABEL":"Company phone","PLACEHOLDER":"Company phone","REQUIRED":"Telephone required"},"COUNTRY_CODE":{"LABEL":"Phone code","PLACEHOLDER":"+1","REQUIRED":"Phone code required"},"EMAIL":{"LABEL":"Company email","PLACEHOLDER":"Company email","REQUIRED":"E-mail required","PATTERN":"Invalid email format"},"WEB_SITE":{"LABEL":"Company website","PLACEHOLDER":"http://www.website.com","INVALID":"Website in invalid format <br/> (valid example: http://www.fieldcontrol.com.br)"},"COUNTRY":{"LABEL":"Country","PLACEHOLDER":"Select a country"},"TIMEZONE":{"LABEL":"Time zone","PLACEHOLDER":"Select a time zone"},"CURRENCY":{"LABEL":"Currency","PLACEHOLDER":"Select a currency","TITLE":"Currency","DESCRIPTION":"When changing the currency, the values of products, services, quotations, or any items that use the currency for display will not be converted to the new currency."},"ADDRESS":{"LABEL":"Account address","NOT_FOUND":"Address not found, change your search and try again.","SEARCH_EXAMPLE":"Search for an address, for example: 3501 S La Cienega Blvd, Los Angeles","REQUIRED":"Address required","NUMBER_NOT_SPECIFIED":"Unspecified address number","CLEAR":"Clear Address"},"ZIPCODE":{"LABEL":"Zip code","REQUIRED":"Zip code required"},"CITY":{"LABEL":"City","REQUIRED":"City required"},"STATE":{"LABEL":"State","REQUIRED":"State required"},"STREET":{"LABEL":"Street","REQUIRED":"Street required"},"NUMBER":{"LABEL":"Number","REQUIRED":"Number required"},"COMPLEMENT":{"LABEL":"Complement"},"PLACE":{"ARIA_LABEL":"Place","LATITUDE_LONGITUDE":"latitude: {{latitude}}, longitude: {{longitude}}"},"LOGO_ALT":"Company logo","IMAGE_SIZE":"Ideal size of the company logo is {{ minImageResolution }}x{{ minImageResolution }}","MIN_IMAGE_SIZE_REQUIRED":"The minimum size allowed for the logo image is {{ minImageResolution }}x{{ minImageResolution }}","RESIZE_CANCEL":"Cancel","RESIZE_CONTINUE":"Resize"},"DEV_SETTINGS":{"PAGE_TITLE":"Integration API","INTEGRATION_KEY":{"TITLE":"Integration key","DESCRIPTION":"Integration keys are used to programmatically access Field Control data","NAME":"Key name integration","PREFIX":"Prefix","CREATED_ON":"Created on","CREATED_BY":"Created by","ACTIONS":"Actions","NOT_HAVE_INTEGRATION_KEY":"Your account doesn\'t have an integration key, create one","CLICKING_HERE":"by clicking here","DELETE_INTEGRATION_KEY":"Delete integration key"},"INTEGRATION_WEBHOOKS":{"TITLE":"Integration webhooks","DESCRIPTION":"Webhooks are notifications that will be sent to your system when changes are made in Field Control","INTEGRATION_URL":"Integration URL","AUTHENTICATION":"Authentication","CREATED_ON":"Created on","CREATED_BY":"Created by","ACTIONS":"Actions","NOT_HAVE_INTEGRATION_WEBHOOK":"Your account doesn\'t have an integration webhook, create one","CLICKING_HERE":"by clicking here","NONE":"None","BASIC_AUTH":"Basic Authentication","DELETE_INTEGRATION_WEBHOOK":"Delete integration webhook"},"DOCUMENTATION":{"TITLE":"Documentation","DESCRIPTION":"Click on the link below to access the documentation and learn more about how to integrate","BUTTON":"Access documentation"}},"WEBHOOKS_CALLBACKS":{"PAGE_TITLE":"Event history","TITLE":"Webhook requisitions","DESCRIPTION":"In this section, all requisitions for the integration webhook will be displayed","REQUEST_IDENTIFIER":"Request identifier","EVENT":"Event","SENT_IN":"Sent on","SEE_DETAILS":"See details","NO_INTEGRATION_EVENTS":"There are no integration events.","LOAD_MORE":"Load more","DETAILS":"Details"},"LABELS_MANAGER":{"PAGE_TITLE":"Tags","NAME":"Name","TYPE":"Type","ACTIONS":"Actions","CUSTOMERS":"Customers","ORDERS":"Tasks","QUOTATIONS":"Quotations","EQUIPMENTS":"Equipments","LIST_OF":"Go to list of","DELETE_LABEL":"Delete tag","CREATED_AT":"Created in"},"MOBILE":{"PAGE_TITLE":"Employee app","WARNING":"The settings referring to the employee\'s application will only be reflected after the logout is performed.","CUSTOM_TASK_CARD":{"TITLE":"Customize the information displayed on the activity card","HINT":"This option allows you to choose which information will be displayed on the activity card","SELECT":"Select the desired information","MAX_SELECTED":"(Maximum of 2 information)","ORDER_SERVICE":"Type of activity","EQUIPMENT_NUMBER":"Equipment serial number","ORDER_IDENTIFIER":"Work order identifier","LOCATION_NAME":"Location name","ERROR":"You can only select two options, if you want to select another, uncheck the ones that are already marked"},"CUSTOM_EDIT_TASK_COMPLETE":{"TITLE":"Customize Completed Task Editing","HINT":"This option allows you to define which completion statuses can be edited after the tasks are finished.","SELECT":"Select the desired completion statuses","CANCELED":"Cancel","COMPLETED":"Complete","REPORTED":"Report"},"ENABLE_TRACKING":{"TITLE":"Enable tracking","HINT":"This option enables employee location and route history."},"ENABLE_TICKETS":{"TITLE":"Enable tickets","HINT":"This option enables the employee to view tickets.","SEARCH_EMPLOYEES":"Search employee"},"GPS_ACCURACY":{"TITLE":"GPS accuracy","HIGH":"High","AVERAGE":"Average","LOW":"Low","HINT":"Higher GPS accuracy means higher battery consumption."},"ALLOW_CREATE_NEW_TASKS":{"TITLE":"Allow creating new activities from impeded services","HINT":"For companies where the external employee has the autonomy to add new activities in impeded services"},"UPLOAD_GALLERY_ON":{"TITLE":"Enable upload of images from the gallery","HINT":"This option allows employees to upload images from the photo gallery."},"ALLOW_REORDER_TASKS":{"TITLE":"Allow reorder tasks","HINT":"For companies where the external employee has the autonomy to organize tasks."},"LIST_TASKS":{"TITLE":"List tasks for the next few days","HINT":"In addition to being able to see the visits of the day, the employee can see and carry out visits from the previous days or that are scheduled for the next days."},"LIST_TASKS_ALLOWED_DAYS":{"TITLE":"Days available to list past and future tasks","HINT":"Defines which days the employee can view the tasks.","YESTERDAY":"Yesterday","TOMORROW":"Tomorrow","NEXT_WEEK":"Next week"},"START_TASKS_OUT_OF_ORDER":{"TITLE":"Start tasks out of order","HINT":"Allows the employee to start tasks out of order."},"START_PENDING_TASKS":{"TITLE":"Allow access to pending activities","HINT":"The employee will be able to choose which activities to perform from the list of pending activities, and will also have automatic access to the configuration of reordering the activities.","SEARCH_EMPLOYEES":"Search employee"},"START_TASKS_SIMULTANEOUSLY":{"TITLE":"Start tasks simultaneously","HINT":"Allows the employee to start more than one activity at the same time during the day."},"SEND_TASK_REPORT_LINK":{"TITLE":"Allow to send task report link","HINT":"After completing the task, the employee will be able to send the report to the customer\'s and/or location\'s email."},"SEND_TASK_RATING_LINK":{"TITLE":"Allow to send task rating link","HINT":"After completing the task, the employee will be able to send the service rating to the customer\'s and/or location\'s email."},"SEND_TASK_SIGNATURE_LINK":{"TITLE":"Allow to send task signature link","HINT":"During the task, the employee will be able to send the signature link to the customer\'s and/or location\'s email."},"ALLOW_EDIT_TASK_LABELS":{"TITLE":"Allow to edit the labels from the activity","HINT":"The employee can add or remove labels from the activity"},"CREATE_EDIT_QUOTATIONS":{"TITLE":"Allows the creation and editing of quotations","HINT":"If enabled, the employee will be able to view, create, edit and share quotations through the app"},"SEND_LOCATION_OF_IMPEDIMENT":{"TITLE":"Send location when starting, completing and registering impediment in the task","HINT":"When starting, completing or registering a task as impeded, the geolocation information will be stored."},"HIDE_PRODUCT_VALUE":{"TITLE":"Hide the product value (beta)","DESCRIPTION":"If enabled, the value of the products used in the activities will be hidden from the employee."},"EDIT_PRODUCT_SERVICE_VALUE":{"TITLE":"Allow to edit the value of products and services","DESCRIPTION":"If enabled, the employee will be able to edit the value of the products and services added to the work orders"},"VALIDATE_DISTANCE":{"TITLE":"Validate distance with customer","HINT":"The employee will only be able to initiate, complete and register a task as impeded when they are within the established perimeter.","ALLOWED_METERS":"Allowed distance in meters","METERS":"meters"},"UPDATE_CUSTOMERS_COORDINATES":{"TITLE":"Allow the employee to use their location to update the customer\'s coordinates","HINT":"The employee can use their current location to update the customer\'s coordinates, if they are out of date."},"VIEW_CUSTOMER_CONTACT_INFO":{"TITLE":"View customer\'s contact information","HINT":"Allows the employee access the customer\'s contact information only."},"UPDATE_CUSTOMER_CONTACT_INFO":{"TITLE":"Update customer\'s contact information","HINT":"Allows the employee to update the customer\'s contact information."},"LIST_CUSTOMERS":{"TITLE":"List customers","HINT":"Allows employees to list and have access to customer\'s information."},"ENABLE_CHANGES_VISIT":{"TITLE":"Allow visit changes after completion, blocking, or cancellation.","HINT":"Allows the employee to edit information, forms, and photos of a visit after it has been completed, cancelled, or blocked. *This setting only affects the employee app."},"TASK_DESCRIPTION_REQUIRED":{"TITLE":"Required Service Order Completion","HINT":"To complete the task, the employee must fill in the service order completion field."},"TASK_REPORT_DESCRIPTION_REQUIRED":{"TITLE":"Required task report description","HINT":"To complete the task, the employee must fill in the task report description."},"FORMS_STEP_BY_STEP":{"TITLE":"Step-by-step forms","HINT":"Allows the employee to answer forms in stages, one question at a time"},"HIDE_EMPLOYEE_WORK_HOURS":{"TITLE":"Hide information of hours worked on the employee\'s profile","HINT":"This setting hides hours worked reported within the employee\'s profile in the technician\'s application."},"SAVE_IMAGE_TO_GALLERY":{"TITLE":"Enable for images to be saved in the gallery","HINT":"This option allows employees to save images taken by Field Control to the mobile gallery."},"SOUND_NOTIFICATION":{"TITLE":"Select the app notification sound","HINT":"Select the sound that will play in the application","SELECT":"Select the type of sound","DEFAULT":"Standard","SMOOTH":"Subtle","MODERATE":"Moderate","HIGH":"Loud","HIGH_EXTENDED":"Extended loud"},"SHOW_TASK_ON_ROUTE_ALERT":{"TITLE":"View next tasks alerts","HINT":"The employee will receive alerts about activities that are close to the scheduled time, making it easier to start their journey"},"TASK_ON_ROUTE_ALERT_INTERVAL":{"TITLE":"The interval for displaying alerts is ","MINUTES":"minutes","HINT":"Defines the time in minutes before the scheduled time for the employee to receive this alert."},"ALLOW_CREATE_ORDERS":{"TITLE":"Allow creation of activities","HINT":"The employee will be able to create and assign activities.","SEARCH_EMPLOYEES":"Search employee"},"CREATE_ORDERS_TO_OTHER_EMPLOYEES":{"TITLE":"Allow creating tasks for other employees","HINT":"Employees enabled to create activities will be able to assign them to other employees when selected.","SEARCH_EMPLOYEES":"Search employee"},"NOTIFY_GEOLOCATION_DISABLED":{"TITLE":"Notify when the employee disables geolocation","HINT":"The selected users will be notified via the panel when an employee disables geolocation.","SEARCH_USER":"Search user"}},"OTHERS":{"PAGE_TITLE":"Other settings","LANGUAGE":{"TITLE":"Account language","HINT":"Language settings for emails and more features.","PLACEHOLDER":"Select language","PORTUGUESE":"Português","ENGLISH":"English","SPANISH":"Español"},"EMAIL":{"INIT_ROUTE_LINK":{"TITLE":"Send email with the link of the employee\'s location automatically once the route has begun","HINT":"Upon starting the route on employee\'s App, the link of the employee\'s location will be sent automatically to the customer\'s registered email."},"SERVICE_ORDER_LINK":{"TITLE":"Send email with the work order link automatically after task completion","HINT":"Upon completion of the task on employee\'s App, the link of the task report will be automatically sent to the customer\'s registered email."},"RATING_LINK":{"TITLE":"Send email with rating link automatically after task completion","HINT":"Upon completion of the task on employee\'s App, the task rating link will be sent automatically to the customer\'s registered email."},"NOTICE_TASK_RATING":{"TITLE":"Send notification by email when receiving a task rating","HINT":"Upon receiving a task rating, the selected managers will receive a notification email."}},"FORMS":{"SCORED_OPTIONS":{"TITLE":"Use scoring scheme in question options on forms","HINT":"Enables you to enter a score for a list or multiple choice option on forms."}},"NOTIFICATIONS":{"PENDING_NOTIFICATIONS":{"TITLE":"Enable notification for pending activities","HINT":"When enabled, new activities with pending status are gonna send notifications to all contributors via application"}},"QUOTATIONS":{"IDENTIFIER_TYPE":{"TITLE":"Identifier Type","TYPES":{"SEQUENCE":"Sequence","RANDOM":"Random","DO_NOT_GENERATE":"Do not generate"},"DESCRIPTIONS":{"SEQUENCE":"<strong>Do not generate:</strong> The quotation identifier will not be generated and must be provided by the manager at the time of creating a quotation.","RANDOM":"<strong>Sequence:</strong> The quotation identifier will be generated in ascending order.","DO_NOT_GENERATE":"<strong>Random:</strong> The quotation identifier will be generated randomly."}},"SEQUENCE":{"TITLE":"The next quotation will have the identifier number: ","CUSTOMIZE":"Customize","CONFIRM":"Confirm","CANCEL":"Cancel","ERRORS":{"MIN_ERROR":"Must be greater than {{ lastNextIdentifier }}","SEARCH_FAILED":"Could not retrieve current identifier. Check your connection and try again."}},"EQUIPMENTS_ON":{"TITLE":"Equipments on quotations","HINT":"When enabled, it makes selecting equipment available before selecting products and services"},"LINK_ITEMS":{"TITLE":"Linking quotation items to the service order","HINT":"When enabled, after creating a quotation from the service order, it will be possible to link products and services in the activity"}},"SEARCH_USER":"Search user","SWITCH_USER":"Switch user","PUBLIC_QRCODE":{"ENABLE":{"TITLE":"Public QR Code Scanning","DESCRIPTION":"Allow anyone to scan the QR Code of equipment, environments, and vehicles, and when doing so outside the app, a web page will be opened."},"CUSTOMIZATION":{"TITLE":"Customize information displayed on the QR Code page","DESCRIPTION":"Choose what will be displayed on the page that opens after scanning the QR Code","CHOOSE_TITLE":"Select the desired information:","DETAIL":"Details","OPEN_TICKET":"Open ticket","TASKS":"Activity history"}}},"ORDERS":{"PAGE_TITLE":"Work orders","TASK_IDENTIFIER_TYPE":{"TITLE":"Identifier type","HINT":"<span><strong>Do not generate:</strong> the work order identifier will not be generated and must be informed by the manager when creating the work order.</span> <br/> <span><strong>Sequential:</strong> the work order identifier will be generated in ascending order.</span> <br/> <span><strong>Random:</strong> the work order identifier will be generated at random.</span>","DO_NOT_GENERATE":"Do not generate","SEQUENTIAL":"Sequential","RANDOM":"Random","NEXT_IDENTIFIER":"The next work order will have the following identification number","CUSTOMIZE":"Customize","CANCEL":"Cancel","CONFIRM":"Confirm","SUCCESS":"Identification number of the next work order has been changed!","FAIL":"Unable to perform change. Check your connection.","GET_FAIL":"Unable to fetch current indentifier. Check your connection and retry.","RETRY":"Retry","MIN_ERROR":"Must be greater than {{ lastNextIdentifier }}"},"EMPLOYEE_IS_MORE_THAN_ONE_TASK_SAME_TIME":{"TITLE":"Do not allow one collaborator to be in more than one visit at the same time","HINT":"If enabled, it will not be allowed to put, trough the panel, two or more visits of the same activity at the same time for the same collaborator."},"ALLOW_PENDING_TASKS":{"TITLE":"Allow pendent activities","HINT":"Allows the manager to create, edit, and view activities without a scheduled date."},"CREATED_AT_IS_AFTER_STARTED_AT":{"TITLE":"Allows to close maintenance before the order creation date","HINT":"It allows the manager to close maintenance before the order creation date."},"ALLOW_MULTIPLE_TASKS":{"TITLE":"Allow multiple tasks","HINT":"Allows the manager to create more than one task for the same work order."},"ALLOW_NEW_TASK_IF_PREVIOUS_COMPLETED":{"TITLE":"Block addition of additional visits while previous visits are open","HINT":"It will only be possible to add a new visit if previous one is finalized, that is, with a status of Completed, Impeded, or Canceled."},"ADDRESS_SEARCH_MODE":{"TITLE":"Address search mode","GOOGLE":"Google","ZIP_CODE":"Zip code","HINT":"<span><strong>Google:</strong> Address search for customers with Google data. <br> <strong>Zip code:</strong> Search for customer address by zip code</span>"},"SEARCHES_RESTRICTED_COUNTRY":{"TITLE":"Address searches must be restricted to country:","SEARCH":"Search by continent...","HINT":"It will be possible to search for addresses only in the selected country."}},"GANTT":{"PAGE_TITLE":"Timeline","VIEW_DISPLACEMENT":{"TITLE":"Show route","HINT":"A \\"gray bar\\" will appear on the timeline, which is an estimate of route calculated by the air distance between tasks"},"SORT_EMPLOYEES":{"TITLE":"Ordering employees in the timeline","ALPHABETICALLY":"Alphabetically","CUSTOM":"Custom","HINT":"<span><strong>Alphabetical:</strong> Employees sorted alphabetically. <br> <strong>Custom:</strong> Employees sorted according to settings.</span>"},"GANTT_REAL_TIME_MONITORING_ON":"Monitor tasks in real time","GANTT_REAL_TIME_MONITORING_ON_HINT":"Monitor tasks in real time"},"BUTTON_SAVE":"Save","ERRORS":{"SAVE_IMAGE":"There has been an error saving the image.","ERROR_FETCHING_ADDRESS":"There has been an error fetching the address!","SAVE_ERROR":"There was an error saving the settings. Please try again."},"WARNINGS":{"TIMELINE_NOT_WORK_PROPERLY":"Enabling this setting may affect the way tasks are shown in the timeline.","AFFECTS_TASK_OUT_OF_ORDER":"Enabling the setting may affect the setting of \\"start activities out of order\\"","APP_VERSION":"This configuration is only valid in versions prior to: 1.1.1. After this version, the configuration informed in the OS types will be considered."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/settings/i18n/es.json',
    '{"CONFIGURATIONS":{"PAGE_TITLE":"Configuración","COMPANY_DATA":"Datos de la empresa","DISCARD_CHANGES":{"TITLE":"¿descartar los cambios?","CONTENT":"Tiene cambios en esta página que no se han guardado. Si continúa, todos serán descartados. ¿Está usted seguro de eso?","OK":"Si","DISCARD":"No"},"CLIENT_AREA_UPDATED":"Área del cliente actualizada con éxito.","ACCOUNT_SETTINGS_SAVED":"La configuración de la cuenta se ha guardado correctamente.","SIDENAV":{"ACCOUNT":"Cuenta","COMPANY_DATA":"Datos de la empresa","MANAGE_LABELS":"Administrar etiquetas","INTEGRATIONS":"Integraciones","SERVICE_REQUEST":"Solicitud de servicios","SYSTEM":"Sistema","SERVICE_ORDERS":"Órdenes de servicio","TIMELINE":"Linea de tiempo","MOBILE_APP":"Aplicación de empleados","EQUIPMENTS":"Equipamientos","OTHER_SETTINGS":"Otras configuraciones","DEVELOPER":"Desarrollador","INTEGRATION_API":"API de integración","INTEGRATION_EVENT_HISTORY":"Registro de eventos"},"SERVICES":{"ENTER_ADDRESS":"Ingrese la dirección en el campo de arriba"},"DIALOGS":{"API_KEYS":{"CREATE":{"NEW_KEY":"Nueva clave","CREATED_KEY":"Clave de integración","CLOSE_DIALOG":"Cerrar","NAME":{"LABEL":"Nombre","REQUIRED":"El campo es obligatorio","MAX_LENGTH":"El valor del campo debe tener un máximo de 50 caracteres."},"INTEGRATION_KEY_CREATED":"¡La clave de integración para su cuenta ha sido creada con éxito!","FINISH_MESSAGE":"<span><b>Atención:</b></span> guarde su clave en un lugar seguro, ya que no será posible recuperarla más tarde.","CREATE":"Crear","CLOSE":"Cerrar"},"DELETE":{"TITLE":"Eliminar clave","CLOSE_DIALOG":"Cerrar","MESSAGE":"Una vez eliminada, la clave ya no estará disponible. <br/> Para continuar, escriba:","NAME_PLACEHOLDER":"Nombre de la clave","CONFIRM":"Confirmar","BETTER_NOT":"Mejor no"}},"LABELS":{"SUCCESSFULLY_DELETED":"La etiqueta \'{{name}}\' se ha eliminado correctamente.","COULD_NOT_DELETE":"No se pudo eliminar la etiqueta \'{{name}}\', intente nuevamente.","DELETE":{"TITLE":"Eliminar etiqueta","MESSAGE":"Una vez eliminada, la etiqueta ya no estará disponible. <br /> Para continuar, escriba:"},"CLOSE_DIALOG":"Cerrar","PLACEHOLDER":"Etiqueta","BETTER_NOT":"Mejor no","CONFIRM":"Confirmar"},"WEBHOOKS":{"CREATE":{"NEW_WEBHOOK":"Nuevo webhook","CLOSE_DIALOG":"Cerrar","URL":{"LABEL":"URL","INVALID":"La URL no es válida.","REQUIRED":"El campo es obligatorio","MAX_LENGTH":"El valor del campo debe tener un máximo de 300 caracteres."},"AUTH":{"LABEL":"Autenticación","NONE":"Ninguno"},"USERNAME":{"LABEL":"Nombre de usuario","REQUIRED":"El campo es obligatorio","MAX_LENGTH":"El valor del campo debe tener un máximo de 30 caracteres."},"PASSWORD":{"LABEL":"Contraseña","REQUIRED":"El campo es obligatorio","MAX_LENGTH":"El valor del campo debe tener un máximo de 50 caracteres."},"CREATE_BUTTON":"Crear","GENERAL":"General","EVENTS":"Eventos de Webhook","SELECT_ALL":"Agregar todos los eventos de Webhook","SELECT_ONE":"Seleccionar eventos de Webhook individualmente","TYPES":{"ORDER_FORM_CREATED":"Creación de formulario de pedido","ORDER_FORM_CREATED_DESCRIPTION":"Se ha creado un formulario de pedido","ORDER_FORM_UPDATED":"Actualización de formulario de pedido","ORDER_FORM_UPDATED_DESCRIPTION":"Se ha actualizado un formulario de pedido","ORDER_ATTACHMENT_CREATED":"Creación de adjunto de pedido","ORDER_ATTACHMENT_CREATED_DESCRIPTION":"Se ha creado un adjunto de pedido","ORDER_ATTACHMENT_UPDATED":"Actualización de adjunto de pedido","ORDER_ATTACHMENT_UPDATED_DESCRIPTION":"Se ha actualizado un adjunto de pedido","ORDER_CREATED":"Creación de pedido","ORDER_CREATED_DESCRIPTION":"Se ha creado un pedido","ORDER_UPDATED":"Actualización de pedido","ORDER_UPDATED_DESCRIPTION":"Se ha actualizado un pedido","TASK_CREATED":"Creación de tarea","TASK_CREATED_DESCRIPTION":"Se ha creado una tarea","TASK_UPDATED":"Actualización de tarea","TASK_UPDATED_DESCRIPTION":"Se ha actualizado una tarea","TASK_STARTED":"Tarea iniciada por el colaborador","TASK_STARTED_DESCRIPTION":"El estado de una tarea se ha cambiado a \'En progreso\'","TASK_REPORTED":"Impedimento reportado de una tarea","TASK_REPORTED_DESCRIPTION":"El estado de una tarea se ha cambiado a \'Reportado\'","TASK_COMPLETED":"Tarea completada con éxito","TASK_COMPLETED_DESCRIPTION":"El estado de una tarea se ha cambiado a \'Completada\'","TASK_RATED":"Calificación de tarea","TASK_RATED_DESCRIPTION":"La calificación de una tarea se ha cambiado","TASK_START_ROUTE":"Inicio de ruta de tarea","TASK_START_ROUTE_DESCRIPTION":"El estado de una tarea se ha cambiado a \'En ruta\'","TASK_ROUTE_STARTED":"Ruta de tarea iniciada","TASK_ROUTE_STARTED_DESCRIPTION":"El estado de una tarea se ha cambiado a \'En ruta\'","COMMENT_CREATED":"Creación de comentario","COMMENT_CREATED_DESCRIPTION":"Se ha creado un comentario","EMPLOYEE_CREATED":"Creación de empleado","EMPLOYEE_CREATED_DESCRIPTION":"Se ha creado un nuevo empleado","TICKET_ACCEPTED":"Solicitud de servicio aceptada","TICKET_ACCEPTED_DESCRIPTION":"Se ha aceptado una solicitud de servicio","TICKET_CANCELED":"Solicitud de servicio cancelada","TICKET_CANCELED_DESCRIPTION":"Se ha cancelado una solicitud de servicio","TICKET_CREATED":"Solicitud de servicio creada","TICKET_CREATED_DESCRIPTION":"Se ha creado una solicitud de servicio","QUOTATION_CREATED":"Creación de presupuesto","QUOTATION_CREATED_DESCRIPTION":"Se ha creado un presupuesto","QUOTATION_CANCELED":"Presupuesto cancelado","QUOTATION_CANCELED_DESCRIPTION":"Se ha cancelado un presupuesto","QUOTATION_UPDATED":"Actualización de presupuesto","QUOTATION_UPDATED_DESCRIPTION":"Se ha actualizado un presupuesto","QUOTATION_APPROVED":"Presupuesto aprobado","QUOTATION_APPROVED_DESCRIPTION":"Se ha aprobado un presupuesto","QUOTATION_REFUSED":"Presupuesto rechazado","QUOTATION_REFUSED_DESCRIPTION":"Se ha rechazado un presupuesto","VEHICLE_CREATED":"Creación de vehículo","VEHICLE_CREATED_DESCRIPTION":"Se ha creado un vehículo","VEHICLE_UPDATED":"Actualización de vehículo","VEHICLE_UPDATED_DESCRIPTION":"Se ha actualizado un vehículo"}},"DELETE":{"TITLE":"Eliminar webhook","CLOSE_DIALOG":"Cerrar","MESSAGE":"Una vez eliminado, el webhook ya no estará disponible. <br /> Para continuar, escriba:","URL_PLACEHOLDER":"URL","CONFIRM":"Confirmar","BETTER_NOT":"Mejor no"},"TYPES":{"TITLE":"Eventos de webhook","SELECT_ALL":"Seleccionar todo"},"RESPONSE_DETAILS":{"REQUEST":"Solicitud","CLOSE_DIALOG":"Cerrar","REQUEST_HEADERS":"Headers de la solicitud:","REQUEST_BODY":"Body de la solicitud:","RESPONSE":"Respuesta","RESPONSE_HEADERS":"Headers de la respuesta:","RESPONSE_BODY":"Body de la respuesta:"},"COPY":{"SUCCESS":"Copiado con éxito","FAILURE":"Error al copiar"}}},"ACCOUNT":{"PAGE_TITLE":"Datos de la empresa","COMPANY_NAME":{"LABEL":"Nombre de la empresa","PLACEHOLDER":"Nombre de la empresa","REQUIRED":"Se requiere el nombre de la empresa"},"NAME":{"LABEL":"Nombre del gerente","PLACEHOLDER":"Nombre del gerente","REQUIRED":"Se requiere el nombre del gerente"},"PHONE_NUMBER":{"LABEL":"Teléfono de la empresa","PLACEHOLDER":"Teléfono de la empresa","REQUIRED":"Se requiere el teléfono"},"COUNTRY_CODE":{"LABEL":"Código","PLACEHOLDER":"+34","REQUIRED":"Código obligatorio"},"EMAIL":{"LABEL":"Correo electrónico de la empresa","PLACEHOLDER":"Correo electrónico de la empresa","REQUIRED":"Se requiere el correo electrónico","PATTERN":"Formato de correo electrónico no válido"},"WEB_SITE":{"LABEL":"Sitio web de la empresa","PLACEHOLDER":"http://www.website.com","INVALID":"Sitio web en formato no válido <br/> (ejemplo válido: http://www.fieldcontrol.com.br)"},"COUNTRY":{"LABEL":"País","PLACEHOLDER":"Seleccione un país"},"TIMEZONE":{"LABEL":"Zona horaria","PLACEHOLDER":"Seleccione una zona horaria"},"CURRENCY":{"LABEL":"Moneda","PLACEHOLDER":"Seleccione una moneda","TITLE":"Moneda","DESCRIPTION":"Al cambiar la moneda, los valores de productos, servicios, presupuestos o cualquier elemento que utilice la moneda para su visualización no se convertirán a la nueva moneda."},"ADDRESS":{"LABEL":"Dirección de cuenta","NOT_FOUND":"No se ha encontrado la dirección, cambie su búsqueda e intente nuevamente.","SEARCH_EXAMPLE":"Busque una dirección, por ejemplo: 3501 S La Cienega Blvd, Los Angeles","REQUIRED":"Se requiere la dirección","NUMBER_NOT_SPECIFIED":"Número de dirección no especificado","CLEAR":"Limpiar dirección"},"ZIPCODE":{"LABEL":"Código postal","REQUIRED":"Se requiere el código postal"},"CITY":{"LABEL":"Pueblo","REQUIRED":"Se requiere la ciudad"},"STATE":{"LABEL":"Estado","REQUIRED":"Se requiere el estado"},"STREET":{"LABEL":"Dirección","REQUIRED":"Se requiere la calle"},"NUMBER":{"LABEL":"Némero","REQUIRED":"Se requiere el número"},"COMPLEMENT":{"LABEL":"Complemento"},"PLACE":{"ARIA_LABEL":"Ubicación","LATITUDE_LONGITUDE":"latitud: {{latitude}}, longitud: {{longitude}}"},"LOGO_ALT":"Logotipo de la empresa","IMAGE_SIZE":"El tamaño ideal del logotipo de la empresa es {{ minImageResolution }}x{{ minImageResolution }}","MIN_IMAGE_SIZE_REQUIRED":"El tamaño mínimo permitido para la imagen del logotipo es {{ minImageResolution }}x{{ minImageResolution }}","RESIZE_CANCEL":"Cancelar","RESIZE_CONTINUE":"Cambiar tamaño"},"DEV_SETTINGS":{"PAGE_TITLE":"API de integración","INTEGRATION_KEY":{"TITLE":"Clave de integración","DESCRIPTION":"Las claves de integración se utilizan para acceder mediante programación a los datos de Field Control","NAME":"Integración de nombre clave","PREFIX":"Prefijo","CREATED_ON":"Creado en","CREATED_BY":"Criado por","ACTIONS":"Acciones","NOT_HAVE_INTEGRATION_KEY":"Su cuenta no tiene una clave de integración, cree una","CLICKING_HERE":"haciendo clic aquí","DELETE_INTEGRATION_KEY":"Eliminar clave de integración"},"INTEGRATION_WEBHOOKS":{"TITLE":"Webhooks de integración","DESCRIPTION":"Los webhooks son notificaciones que se enviarán a su sistema cuando se produzcan modificaciones en Field Control","INTEGRATION_URL":"URL de integración","AUTHENTICATION":"Autenticación","CREATED_ON":"Creado en","CREATED_BY":"Criado por","ACTIONS":"Acciones","NOT_HAVE_INTEGRATION_WEBHOOK":"Su cuenta no tiene un webhook de integración, cree uno","CLICKING_HERE":"haciendo clic aquí","NONE":"Ninguno","BASIC_AUTH":"Autenticación Básica","DELETE_INTEGRATION_WEBHOOK":"Eliminar webhook de integración"},"DOCUMENTATION":{"TITLE":"Documentación","DESCRIPTION":"Haga clic en el enlace a continuación para acceder a la documentación y obtener más detalles sobre cómo integrar","BUTTON":"Acceder a la documentación"}},"WEBHOOKS_CALLBACKS":{"PAGE_TITLE":"Registro de eventos","TITLE":"Solicitudes de webhook","DESCRIPTION":"En esta sección, se mostrarán todas las solicitudes para el webhook de integración","REQUEST_IDENTIFIER":"Identificador de solicitud","EVENT":"El evento","SENT_IN":"Enviado en","SEE_DETAILS":"Ver detalles","NO_INTEGRATION_EVENTS":"No hay eventos de integración.","LOAD_MORE":"Cargar más","DETAILS":"Ver detalles"},"LABELS_MANAGER":{"PAGE_TITLE":"Etiquetas","NAME":"Nombre","TYPE":"Tipo","ACTIONS":"Acciones","CUSTOMERS":"Clientes","ORDERS":"Actividades","QUOTATIONS":"Presupuestos","EQUIPMENTS":"Equipos","LIST_OF":"Ir a la lista de","DELETE_LABEL":"Eliminar etiqueta","CREATED_AT":"Creado en"},"MOBILE":{"PAGE_TITLE":"Aplicación de empleados","WARNING":"La configuración que hace referencia a la aplicación del empleado solo se reflejará después de que se haya realizado el cierre de sesión.","CUSTOM_TASK_CARD":{"TITLE":"Personalizar información mostrada en la tarjeta de actividades","HINT":"Esta opción permite elegir qué información se mostrará en la tarjeta de actividades","SELECT":"Seleccione la información deseada","MAX_SELECTED":"(Máximo de 2 informaciones)","ORDER_SERVICE":"Tipo de OS","EQUIPMENT_NUMBER":"Nº de serie del equipo","ORDER_IDENTIFIER":"Identificador de la OS","LOCATION_NAME":"Nombre de la ubicación","ERROR":"Solo se pueden seleccionar dos opciones, si desea seleccionar otra, desmarque primero las que ya están marcadas"},"CUSTOM_EDIT_TASK_COMPLETE":{"TITLE":"Personalizar edición de actividades completadas","HINT":"Esta opción permite definir qué estados de finalización podrán ser editados después de que las actividades sean completadas.","SELECT":"Seleccione los estados de finalización deseados","CANCELED":"Cancelada","COMPLETED":"Concluida","REPORTED":"Impedida"},"ENABLE_TRACKING":{"TITLE":"Habilitar seguimiento","HINT":"Esta opción habilita la ubicación del empleado y el registro de rutas."},"ENABLE_TICKETS":{"TITLE":"Habilitar solicitudes","HINT":"Esta opción habilita la visualización de solicitudes en la aplicación del empleado.","SEARCH_EMPLOYEES":"Buscar empleado"},"GPS_ACCURACY":{"TITLE":"Precisión del GPS","HIGH":"Alta","AVERAGE":"Media","LOW":"Bajo","HINT":"Mayor precisión del GPS significa mayor consumo de batería."},"ALLOW_CREATE_NEW_TASKS":{"TITLE":"Permitir crear nuevas actividades a partir de servicios impedidos","HINT":"Para empresas donde el empleado externo tiene autonomía para agregar nuevas actividades en servicios impedidos"},"UPLOAD_GALLERY_ON":{"TITLE":"Habilitar la carga de imágenes desde la galería","HINT":"Esta opción permite a los empleados cargar imágenes a través de la galería de fotos."},"ALLOW_REORDER_TASKS":{"TITLE":"Permitir reordenar actividades","HINT":"Para empresas donde el empleado externo tiene la autonomía para organizar actividades."},"LIST_TASKS":{"TITLE":"Enumere las actividades para los próximos días.","HINT":"Además de poder ver las visitas del día, el empleado puede ver y realizar visitas de los días anteriores o que estén programadas para los próximos días."},"LIST_TASKS_ALLOWED_DAYS":{"TITLE":"Días disponibles para listar actividades pasadas y futuras","HINT":"Define los días en los que el colaborador podrá ver las actividades.","YESTERDAY":"Ayer","TOMORROW":"Mañana","NEXT_WEEK":"Próxima semana"},"START_TASKS_OUT_OF_ORDER":{"TITLE":"Comenzar actividades fuera de servicio","HINT":"Permite al empleado comenzar actividades fuera de servicio."},"START_PENDING_TASKS":{"TITLE":"Permitir el acceso a las actividades pendientes","HINT":"El empleado podrá elegir qué actividades realizar de la lista de actividades pendientes, así como tener acceso automático a la configuración de la reordenación de las actividades.","SEARCH_EMPLOYEES":"Buscar empleado"},"START_TASKS_SIMULTANEOUSLY":{"TITLE":"Comience actividades simultáneamente","HINT":"Permite al empleado iniciar más de una actividad al mismo tiempo durante el día."},"SEND_TASK_REPORT_LINK":{"TITLE":"Permitir enviar enlace de informe de actividad","HINT":"Después de finalizar la visita, el empleado puede enviar el informe al correo electrónico del cliente y/o de la ubicación."},"SEND_TASK_RATING_LINK":{"TITLE":"Permitir enviar enlace de calificación de actividad","HINT":"Después de finalizar la visita, el empleado puede enviar la calificación del servicio al correo electrónico del cliente y/o de la ubicación."},"SEND_TASK_SIGNATURE_LINK":{"TITLE":"Permitir enviar enlace de firma de actividad","HINT":"Durante la visita, el empleado podrá enviar el enlace de firma al correo electrónico del cliente y/o de la ubicación"},"ALLOW_EDIT_TASK_LABELS":{"TITLE":"Permitir editar las etiquetas de la actividad","HINT":"El empleado puede añadir o eliminar etiquetas de actividad"},"CREATE_EDIT_QUOTATIONS":{"TITLE":"Permite crear y editar presupuestos","HINT":"Si está habilitado, el colaborador podrá ver, crear, editar y compartir presupuestos a través de la aplicación"},"SEND_LOCATION_OF_IMPEDIMENT":{"TITLE":"Enviar ubicación al comenzar, completar y registrar impedimento para visitar","HINT":"Al comenzar, completar o registrar una actividad como impedidida, se almacenará la información de geolocalización."},"HIDE_PRODUCT_VALUE":{"TITLE":"Ocultar el valor del producto (beta)","DESCRIPTION":"Si está habilitado, el valor de los productos utilizados en las actividades se ocultará al contribuyente"},"EDIT_PRODUCT_SERVICE_VALUE":{"TITLE":"Permitir editar el valor de los productos y servicios","DESCRIPTION":"Si está habilitado, el colaborador podrá editar el valor de los productos y servicios agregados a las órdenes de servicio."},"VALIDATE_DISTANCE":{"TITLE":"Validar distancia con el cliente","HINT":"El empleado solo podrá iniciar, concluir y registrar un impedimento en la visita cuando se encuentre dentro del perímetro establecido.","ALLOWED_METERS":"Distancia permitida en metros","METERS":"metros"},"UPDATE_CUSTOMERS_COORDINATES":{"TITLE":"Permitir al empleado, con su ubicación, actualizar las coordenadas del cliente.","HINT":"El empleado puede usar su ubicación actual para actualizar las coordenadas del cliente, si están desactualizadas."},"VIEW_CUSTOMER_CONTACT_INFO":{"TITLE":"Ver informaciones de contacto del cliente","HINT":"Permite a los empleados acceder únicamente a la información de contacto del cliente."},"UPDATE_CUSTOMER_CONTACT_INFO":{"TITLE":"Actualizar la información de contacto del cliente","HINT":"Permite al empleado actualizar la información de contacto del cliente."},"LIST_CUSTOMERS":{"TITLE":"Lista de clientes","HINT":"Permite a los empleados enumerar y tener acceso a la información del cliente."},"ENABLE_CHANGES_VISIT":{"TITLE":"Permitir cambios en la visita después de ser completada, bloqueada o cancelada.","HINT":"Permite que el colaborador modifique información, formularios y fotos de una visita después de su finalización, cancelación o bloqueo. *Esta configuración solo afecta a la aplicación del colaborador."},"TASK_DESCRIPTION_REQUIRED":{"TITLE":"Completar Orden de Servicio Obligatorio","HINT":"Para completar la tarea, el empleado debe llenar el campo de completación de la orden de servicio."},"TASK_REPORT_DESCRIPTION_REQUIRED":{"TITLE":"Relleno obligatorio de la descripción del impedimento de la orden de servicio","HINT":"Para impedir la actividad, el colaborador deberá rellenar el campo de descripción del impedimento."},"FORMS_STEP_BY_STEP":{"TITLE":"Formularios paso a paso","HINT":"Permite al empleado responder el formulario en etapas, una pregunta a la vez"},"HIDE_EMPLOYEE_WORK_HOURS":{"TITLE":"Ocultar información de horas trabajadas en el perfil del empleado","HINT":"Esta configuración oculta el informe de horas trabajadas dentro del perfil del empleado en  la aplicación del técnico."},"SAVE_IMAGE_TO_GALLERY":{"TITLE":"Habilitar para que las imágenes se guarden en la galería","HINT":"Esta opción permite a los empleados guardar imágenes tomadas por Field Control en la galería móvil."},"SOUND_NOTIFICATION":{"TITLE":"Seleccione el sonido de notificación de la aplicación","HINT":"Seleccione el sonido que se reproducirá en la aplicación","SELECT":"Seleccionar el tipo de sonido","DEFAULT":"Estándar","SMOOTH":"Sutil","MODERATE":"Moderado","HIGH":"Fuerte","HIGH_EXTENDED":"Fuerte extendido"},"SHOW_TASK_ON_ROUTE_ALERT":{"TITLE":"Ver alertas de próxima actividad","HINT":"El empleado recibirá alertas sobre actividades cercanas al horario programado, lo que facilitará el inicio de su viaje."},"TASK_ON_ROUTE_ALERT_INTERVAL":{"TITLE":"El intervalo para mostrar alertas es ","MINUTES":"minutos","HINT":"Define el tiempo en minutos antes de la hora programada para que el empleado reciba esta alerta."},"ALLOW_CREATE_ORDERS":{"TITLE":"Permitir la creación de actividades","HINT":"El empleado podrá crear y asignar actividades","SEARCH_EMPLOYEES":"Buscar empleado"},"CREATE_ORDERS_TO_OTHER_EMPLOYEES":{"TITLE":"Permitir la creación de actividades para otros colaboradores","HINT":"Los empleados habilitados para crear actividades podrán asignarlas a otros empleados cuando sean seleccionados.","SEARCH_EMPLOYEES":"Buscar colaborador"},"NOTIFY_GEOLOCATION_DISABLED":{"TITLE":"Notificar cuando el colaborador desactive la geolocalización","HINT":"Los usuarios seleccionados serán notificados a través del panel cuando un colaborador desactive la geolocalización.","SEARCH_USER":"Buscar usuario"}},"OTHERS":{"PAGE_TITLE":"Otras configuraciones","LANGUAGE":{"TITLE":"Idioma de la cuenta","HINT":"Configuración de idioma para correos electrónicos","PLACEHOLDER":"Seleccione el idioma","PORTUGUESE":"Português","ENGLISH":"English","SPANISH":"Español"},"EMAIL":{"INIT_ROUTE_LINK":{"TITLE":"Envíe un correo electrónico con el enlace de la ubicación del empleado automáticamente después del comienzo del viaje","HINT":"Al iniciar la transferencia a través de la aplicación del empleado, el enlace de la ubicación del empleado se enviará automáticamente al correo electrónico registrado del cliente."},"SERVICE_ORDER_LINK":{"TITLE":"Enviar un correo electrónico con el enlace de la orden de servicio automáticamente después de que se concluya la actividad","HINT":"Al concluir la actividad a través de la aplicación del empleado, el enlace del informe de la visita se enviará automáticamente al correo electrónico registrado del cliente."},"RATING_LINK":{"TITLE":"Enviar correo electrónico con enlace de calificación automáticamente después de completar la actividad","HINT":"Al finalizar la actividad a través de la aplicación del empleado, el enlace para calificar la visita se enviará automáticamente al correo electrónico registrado del cliente."},"NOTICE_TASK_RATING":{"TITLE":"Enviar un aviso por correo electrónico cuando reciba una calificación de actividad","HINT":"Al recibir una calificación de una actividad, los gerentes seleccionados recibirán un correo electrónico de notificación."}},"FORMS":{"SCORED_OPTIONS":{"TITLE":"Utilice el esquema de puntuación en las opciones de preguntas de los formularios","HINT":"Permite ingresar una puntuación para una lista o una opción de opción múltiple en los formularios."}},"NOTIFICATIONS":{"PENDING_NOTIFICATIONS":{"TITLE":"Habilitar notificación de actividades pendientes","HINT":"Cuando está habilitado, las nuevas actividades con estado pendiente enviarán notificaciones a todos los colaboradores a través de la aplicación."}},"QUOTATIONS":{"IDENTIFIER_TYPE":{"TITLE":"Tipo de identificador","TYPES":{"SEQUENCE":"Secuencial","RANDOM":"Aleatorio","DO_NOT_GENERATE":"No generar"},"DESCRIPTIONS":{"SEQUENCE":"<strong> No generar: </strong> El identificador del presupuesto no será generado y debe ser informado por el gestor en el momento de la creación de un presupuesto.","RANDOM":"<strong> Secuencial: </strong> El identificador del presupuesto se generará en orden creciente.","DO_NOT_GENERATE":"<strong>  Aleatorio: </strong> El identificador del presupuesto se generará de forma aleatoria."}},"SEQUENCE":{"TITLE":"El próximo presupuesto tendrá como identificador el número: ","CUSTOMIZE":"Personalizar","CONFIRM":"Confirmar","CANCEL":"Cancelar","ERRORS":{"MIN_ERROR":"Debe ser mayor que {{ lastNextIdentifier }}","SEARCH_FAILED":"No se pudo buscar el identificador actual. Verifique su conexión e intente nuevamente."}},"EQUIPMENTS_ON":{"TITLE":"Equipos en presupuestos","HINT":"Cuando está habilitado, la selección de equipos es adicionada en la creación de un presupuesto."},"LINK_ITEMS":{"TITLE":"Vincular automáticamente los elementos del presupuesto en la creación de la orden de servicio","HINT":"Cuando está habilitado, después de crear un presupuesto a partir de la orden de servicio, será posible vincular productos y servicios en la actividad"}},"SEARCH_USER":"Buscar usuario","SWITCH_USER":"Cambiar usuario","PUBLIC_QRCODE":{"ENABLE":{"TITLE":"Lectura pública del código QR","DESCRIPTION":"Permitir que cualquier persona escanee el código QR de equipos, ambientes y vehículos y, al hacerlo fuera de la app, se abrirá una página web."},"CUSTOMIZATION":{"TITLE":"Personalizar la información mostrada en la página del código QR","DESCRIPTION":"Elija qué se mostrará en la página que se abrirá después de escanear el código QR","CHOOSE_TITLE":"Seleccione la información deseada:","DETAIL":"Detalles","OPEN_TICKET":"Abrir ticket","TASKS":"Historial de actividades"}}},"ORDERS":{"PAGE_TITLE":"Órdenes de servicio","TASK_IDENTIFIER_TYPE":{"TITLE":"Tipo de identificador","HINT":"<span><strong>No generar:</strong> el identificador de la orden de servicio no se generará y el gerente debe informarlo al crear la orden de servicio.</span> <br/> <span><strong>Secuencial:</strong> el identificador de orden de servicio se generará en orden ascendente.</span> <br/> <span><strong>Aleatorio:</strong> el identificador de orden de servicio se generará al azar.</span>","DO_NOT_GENERATE":"No generar","SEQUENTIAL":"Secuencial","RANDOM":"Al azar","NEXT_IDENTIFIER":"El próximo pedido de servicio tendrá como identificador el número","CUSTOMIZE":"Personalizar","CANCEL":"Cancelar","CONFIRM":"Confirmar","SUCCESS":"¡El número de identificador de la siguiente orden de servicio se ha cambiado con éxito!","FAIL":"No se ha podido realizar la modificación. ¡Compruebe su conexión!","GET_FAIL":"No se ha podido recuperar el identificador actual. Verifique su conexión e intente otra vez.","RETRY":"Intentar otra vez","MIN_ERROR":"Debe ser mayor que {{ lastNextIdentifier }}"},"EMPLOYEE_IS_MORE_THAN_ONE_TASK_SAME_TIME":{"TITLE":"No permita que un colaborador realice más de una visita al mismo tiempo","HINT":"Si está activado, no será posible colocar, a través del panel, dos o más visitas de la misma actividad en curso para el mismo colaborador."},"CREATED_AT_IS_AFTER_STARTED_AT":{"TITLE":"Permite cerrar el mantenimiento antes de la fecha de creación del sistema operativo","HINT":"Permite al administrador cerrar el mantenimiento antes de la fecha de creación del sistema operativo."},"ALLOW_MULTIPLE_TASKS":{"TITLE":"Permitir múltiples actividades","HINT":"Permite al administrador crear más de una visita para la misma orden de servicio."},"ALLOW_PENDING_TASKS":{"TITLE":"Habilitar las actividades pendientes","HINT":"Permite al gestor crear, editar y ver las actividades sin fecha de programación."},"ALLOW_NEW_TASK_IF_PREVIOUS_COMPLETED":{"TITLE":"Bloquear la adición de visitas adicionales mientras las visitas anteriores estén abiertas","HINT":"Solo será posible agregar una nueva visita si la anterior está finalizada, es decir, con estado de Completada, Impedida o Cancelada."},"ADDRESS_SEARCH_MODE":{"TITLE":"Modo de búsqueda de dirección","GOOGLE":"Google","ZIP_CODE":"Código postal","HINT":"<span><strong>Google:</strong> búsqueda de direcciones para clientes con datos de Google. <br> <strong>Código postal:</strong> búsqueda de dirección del cliente por código postal</span>"},"SEARCHES_RESTRICTED_COUNTRY":{"TITLE":"Las búsquedas de direcciones deben restringirse solo al país:","SEARCH":"Buscar por continente...","HINT":"Será posible buscar direcciones solo para el país seleccionado."}},"GANTT":{"PAGE_TITLE":"Linea de tiempo","VIEW_DISPLACEMENT":{"TITLE":"Mostrar desplazamiento","HINT":"Aparecerá una \\"barra gris\\" en la línea de tiempo, que es una estimación del desplazamiento calculada por la distancia aérea entre actividades."},"SORT_EMPLOYEES":{"TITLE":"Ordenar empleados en la línea de tiempo en orden","ALPHABETICALLY":"Alfabético","CUSTOM":"Personalizado","HINT":"<span><strong>Alfabético:</strong> empleados ordenados alfabéticamente. <br> <strong>Personalizado:</strong> empleados ordenados según la configuración.</span>"},"GANTT_REAL_TIME_MONITORING_ON":"Monitorear visitas en tiempo real","GANTT_REAL_TIME_MONITORING_ON_HINT":"Monitorear visitas en tiempo real"},"BUTTON_SAVE":"Guardar","ERRORS":{"SAVE_IMAGE":"Se ha producido un error al guardar la imagen.","ERROR_FETCHING_ADDRESS":"¡Hubo un error al buscar la dirección!","SAVE_ERROR":"¡Hubo un error al guardar la configuración!"},"WARNINGS":{"TIMELINE_NOT_WORK_PROPERLY":"Habilitar esta configuración hace que la línea de tiempo no funcione correctamente.","AFFECTS_TASK_OUT_OF_ORDER":"Habilitar la configuración puede afectar la configuración de \\"iniciar actividades fuera de orden\\"","APP_VERSION":"Esta configuración solo es válida en versiones anteriores a: 1.1.1. Posterior a esta versión, se considerará la configuración informada en el tipo de OS."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/settings/i18n/pt.json',
    '{"CONFIGURATIONS":{"PAGE_TITLE":"Configurações","COMPANY_DATA":"Dados da empresa","DISCARD_CHANGES":{"TITLE":"Descartar alterações","CONTENT":"Você tem alterações nesta página que não foram salvas. Se você continuar, todos eles serão descartados. Você tem certeza sobre isso?","OK":"Sim","DISCARD":"Não"},"CLIENT_AREA_UPDATED":"Área do cliente atualizada com sucesso.","ACCOUNT_SETTINGS_SAVED":"Configurações da conta salvas com sucesso.","SIDENAV":{"ACCOUNT":"Conta","COMPANY_DATA":"Dados da empresa","MANAGE_LABELS":"Gerenciar etiquetas","INTEGRATIONS":"Integrações","SERVICE_REQUEST":"Solicitação de serviços","SYSTEM":"Sistema","SERVICE_ORDERS":"Ordens de serviço","TIMELINE":"Linha do tempo","MOBILE_APP":"Aplicativo do colaborador","EQUIPMENTS":"Equipamentos","OTHER_SETTINGS":"Outras configurações","DEVELOPER":"Desenvolvedor","INTEGRATION_API":"API de integração","INTEGRATION_EVENT_HISTORY":"Histórico de eventos"},"SERVICES":{"ENTER_ADDRESS":"Informe o endereço no campo acima"},"DIALOGS":{"API_KEYS":{"CREATE":{"NEW_KEY":"Nova chave","CREATED_KEY":"Chave de integração","CLOSE_DIALOG":"Fechar","NAME":{"LABEL":"Nome","REQUIRED":"O campo é obrigatório","MAX_LENGTH":"O valor do campo deve ter no máximo 50 caracteres de tamanho"},"INTEGRATION_KEY_CREATED":"A chave de integração para sua conta foi criada com sucesso!","FINISH_MESSAGE":"<span><b>Atenção: </b></span>Armazene sua chave em um local seguro, pois não será possível recuperá-la posteriomente.","CREATE":"Criar","CLOSE":"Fechar"},"DELETE":{"TITLE":"Excluir chave","CLOSE_DIALOG":"Fechar","MESSAGE":"Depois de excluída, a chave não estará mais disponível.<br/>Para continuar, digite: ","NAME_PLACEHOLDER":"Nome da chave","CONFIRM":"Confirmar","BETTER_NOT":"Melhor não"}},"LABELS":{"SUCCESSFULLY_DELETED":"Etiqueta \'{{ name }}\' excluída com sucesso.","COULD_NOT_DELETE":"Não foi possível excluir a etiqueta \'{{ name }}\', tente novamente.","DELETE":{"TITLE":"Excluir etiqueta","MESSAGE":"Depois de excluída, a etiqueta não estará mais disponível.<br />Para continuar, digite: "},"CLOSE_DIALOG":"Fechar","PLACEHOLDER":"Etiqueta","BETTER_NOT":"Melhor não","CONFIRM":"Confirmar"},"WEBHOOKS":{"CREATE":{"NEW_WEBHOOK":"Novo webhook","CLOSE_DIALOG":"Fechar","URL":{"LABEL":"URL","INVALID":"A URL é inválida","REQUIRED":"O campo é obrigatório","MAX_LENGTH":"O valor do campo deve ter no máximo 300 caracteres de tamanho"},"AUTH":{"LABEL":"Autenticação","NONE":"Nenhuma"},"USERNAME":{"LABEL":"Nome de usuário","REQUIRED":"O campo é obrigatório","MAX_LENGTH":"O valor do campo deve ter no máximo 30 caracteres de tamanho"},"PASSWORD":{"LABEL":"Senha","REQUIRED":"O campo é obrigatório","MAX_LENGTH":"O valor do campo deve ter no máximo 50 caracteres de tamanho"},"CREATE_BUTTON":"Criar","GENERAL":"Geral","EVENTS":"Eventos de webhook","SELECT_ALL":"Adicionar todos os eventos de webhook","SELECT_ONE":"Selecionar eventos de webhook individialmente","TYPES":{"ORDER_FORM_CREATED":"Criação de um formulário","ORDER_FORM_CREATED_DESCRIPTION":"Um formulário foi criado","ORDER_FORM_UPDATED":"Atualização de um formulário","ORDER_FORM_UPDATED_DESCRIPTION":"Um formulário teve seu conteúdo atualizado","ORDER_ATTACHMENT_CREATED":"Criação de um anexo","ORDER_ATTACHMENT_CREATED_DESCRIPTION":"Um anexo foi criado","ORDER_ATTACHMENT_UPDATED":"Atualização de um anexo","ORDER_ATTACHMENT_UPDATED_DESCRIPTION":"Um anexo teve seu conteúdo atualizado","ORDER_CREATED":"Criação de uma ordem de serviço","ORDER_CREATED_DESCRIPTION":"Uma ordem de serviço foi criada","ORDER_UPDATED":"Atualização de uma ordem de serviço","ORDER_UPDATED_DESCRIPTION":"Uma ordem de serviço teve seu conteúdo atualizado","TASK_CREATED":"Criação de uma atividade","TASK_CREATED_DESCRIPTION":"Uma atividade foi criada","TASK_UPDATED":"Atualização de uma atividade","TASK_UPDATED_DESCRIPTION":"Uma atividade teve seu conteúdo atualizado","TASK_STARTED":"Atividade iniciada pelo colaborador","TASK_STARTED_DESCRIPTION":"Uma atividade teve seu status alterado para \'Em andamento\'","TASK_REPORTED":"Impedimento da realização de alguma atividade","TASK_REPORTED_DESCRIPTION":"Uma atividade teve seu status alterado para \'Impedida\'","TASK_COMPLETED":"Atividade concluída com sucesso","TASK_COMPLETED_DESCRIPTION":"Uma atividade teve seu status alterado para \'Concluída\'","TASK_RATED":"Avaliação de uma atividade","TASK_RATED_DESCRIPTION":"Uma atividade teve sua avaliação alterada","TASK_START_ROUTE":"Inicio da rota de uma atividade","TASK_START_ROUTE_DESCRIPTION":"Uma atividade teve seu status alterado para \'Em rota\'","TASK_ROUTE_STARTED":"Rota de uma atividade iniciada","TASK_ROUTE_STARTED_DESCRIPTION":"Uma atividade teve seu status alterado para \'Em rota\'","COMMENT_CREATED":"Criação de um comentário","COMMENT_CREATED_DESCRIPTION":"Um comentário foi criado","EMPLOYEE_CREATED":"Criação de um novo colaborador","EMPLOYEE_CREATED_DESCRIPTION":"Um novo colaborador foi criado","TICKET_ACCEPTED":"Solicitação de serviço aceita","TICKET_ACCEPTED_DESCRIPTION":"Uma solicitação de serviço foi aceita","TICKET_CANCELED":"Solicitação de serviço cancelada","TICKET_CANCELED_DESCRIPTION":"Uma solicitação de serviço foi cancelada","TICKET_CREATED":"Criação de uma solicitação de serviço","TICKET_CREATED_DESCRIPTION":"Uma solicitação de serviço foi criada","QUOTATION_CREATED":"Criação de um orçamento","QUOTATION_CREATED_DESCRIPTION":"Um orçamento foi criado","QUOTATION_CANCELED":"Orçamento cancelado","QUOTATION_CANCELED_DESCRIPTION":"Um orçamento foi cancelado","QUOTATION_UPDATED":"Orçamento atualizado","QUOTATION_UPDATED_DESCRIPTION":"Um orçamento foi atualizado","QUOTATION_APPROVED":"Orçamento aprovado","QUOTATION_APPROVED_DESCRIPTION":"Um orçamento foi aprovado","QUOTATION_REFUSED":"Orçamento recusado","QUOTATION_REFUSED_DESCRIPTION":"Um orçamento foi recusado","VEHICLE_CREATED":"Veículo criado","VEHICLE_CREATED_DESCRIPTION":"Um veículo foi criado","VEHICLE_UPDATED":"Veículo atualizado","VEHICLE_UPDATED_DESCRIPTION":"Um veículo foi atualizado"}},"DELETE":{"TITLE":"Excluir webhook","CLOSE_DIALOG":"Fechar","MESSAGE":"Depois de excluída, a webhook não estará mais disponível.<br />Para continuar, digite: ","URL_PLACEHOLDER":"URL","CONFIRM":"Confirmar","BETTER_NOT":"Melhor não"},"TYPES":{"TITLE":"Eventos de webhook","SELECT_ALL":"Selecionar todos"},"RESPONSE_DETAILS":{"REQUEST":"Requisição","CLOSE_DIALOG":"Fechar","REQUEST_HEADERS":"Headers da requisição:","REQUEST_BODY":"Body da requisição:","RESPONSE":"Resposta","RESPONSE_HEADERS":"Headers da resposta:","RESPONSE_BODY":"Body da resposta:"},"COPY":{"SUCCESS":"Copiado com sucesso","FAILURE":"Erro ao copiar"}}},"ACCOUNT":{"PAGE_TITLE":"Dados da empresa","COMPANY_NAME":{"LABEL":"Nome da empresa","PLACEHOLDER":"Nome da empresa","REQUIRED":"Nome da empresa obrigatório"},"NAME":{"LABEL":"Nome do gestor","PLACEHOLDER":"Nome do gestor","REQUIRED":"Nome do gestor obrigatório"},"PHONE_NUMBER":{"LABEL":"Telefone da empresa","PLACEHOLDER":"Telefone da empresa","REQUIRED":"Telefone obrigatório"},"COUNTRY_CODE":{"LABEL":"Código","PLACEHOLDER":"+55","REQUIRED":"Código obrigatório"},"EMAIL":{"LABEL":"E-mail da empresa","PLACEHOLDER":"E-mail da empresa","REQUIRED":"E-mail é obrigatório","PATTERN":"E-mail em formato inválido"},"WEB_SITE":{"LABEL":"Web site da empresa","PLACEHOLDER":"http://www.website.com","INVALID":"Web site em formato inválido <br/> (exemplo válido: http://www.fieldcontrol.com.br)"},"COUNTRY":{"LABEL":"País","PLACEHOLDER":"Selecione um país"},"TIMEZONE":{"LABEL":"Fuso horário","PLACEHOLDER":"Selecione um fuso horário"},"CURRENCY":{"LABEL":"Moeda","PLACEHOLDER":"Selecione uma moeda","TITLE":"Alterar moeda","DESCRIPTION":"Ao alterar a moeda, os valores de produtos, serviços, orçamentos ou quaisquer itens que utilizam da moeda para exibição não serão convertidos para a nova moeda."},"ADDRESS":{"LABEL":"Endereço da conta","NOT_FOUND":"O endereço não foi encontrado, mude sua busca e tente novamente.","SEARCH_EXAMPLE":"Procure por um endereço, por exemplo: 3501 S La Cienega Blvd, Los Angeles","REQUIRED":"Endereço é obrigatório","NUMBER_NOT_SPECIFIED":"Número do endereço não especificado","CLEAR":"Limpar endereço"},"ZIPCODE":{"LABEL":"CEP","REQUIRED":"CEP é obrigatório"},"CITY":{"LABEL":"Cidade","REQUIRED":"Cidade é obrigatório"},"STATE":{"LABEL":"Estado","REQUIRED":"Estado é obrigatório"},"STREET":{"LABEL":"Logradouro","REQUIRED":"Logradouro é obrigatório"},"NUMBER":{"LABEL":"Número","REQUIRED":"Número é obrigatório"},"COMPLEMENT":{"LABEL":"Complemento"},"PLACE":{"ARIA_LABEL":"Local","LATITUDE_LONGITUDE":"latitude: {{latitude}}, longitude: {{longitude}}"},"LOGO_ALT":"Logo da empresa","IMAGE_SIZE":"Tamanho ideal do logo da empresa é {{ minImageResolution }}x{{ minImageResolution }}","MIN_IMAGE_SIZE_REQUIRED":"O tamanho mínimo permitido para a imagem do logo é {{ minImageResolution }}x{{ minImageResolution }}","RESIZE_CANCEL":"Cancelar","RESIZE_CONTINUE":"Redimensionar"},"DEV_SETTINGS":{"PAGE_TITLE":"API de integração","INTEGRATION_KEY":{"TITLE":"Chave de integração","DESCRIPTION":"Chaves de integração são usadas para acessar programaticamente os dados do Field Control","NAME":"Nome chave integração","PREFIX":"Prefixo","CREATED_ON":"Criado em","CREATED_BY":"Criado por","ACTIONS":"Ações","NOT_HAVE_INTEGRATION_KEY":"Sua conta ainda não possui chave de integração, crie uma","CLICKING_HERE":"clicando aqui","DELETE_INTEGRATION_KEY":"Excluir chave de integração"},"INTEGRATION_WEBHOOKS":{"TITLE":"Webhooks integração","DESCRIPTION":"Webhooks são notificações que serão enviadas para o seu sistema quando modificações ocorrem no Field Control","INTEGRATION_URL":"URL de integração","AUTHENTICATION":"Autenticação","CREATED_ON":"Criado em","CREATED_BY":"Criado por","ACTIONS":"Ações","NOT_HAVE_INTEGRATION_WEBHOOK":"Sua conta ainda não possui webhook de integração, crie um","CLICKING_HERE":"clicando aqui","NONE":"Nenhuma","BASIC_AUTH":"Autenticação Básica","DELETE_INTEGRATION_WEBHOOK":"Excluir webhook de integração"},"DOCUMENTATION":{"TITLE":"Documentação","DESCRIPTION":"Clique no link abaixo para acessar a documentação e ter mais detalhes de como fazer a integração","BUTTON":"Acessar documentação"}},"WEBHOOKS_CALLBACKS":{"PAGE_TITLE":"Histórico de eventos","TITLE":"Requisições para webhook","DESCRIPTION":"Nessa seção serão exibidas todas as requisições para a webhook da integração","REQUEST_IDENTIFIER":"Identificador da requisição","EVENT":"Evento","SENT_IN":"Enviado em","SEE_DETAILS":"Ver detalhes","NO_INTEGRATION_EVENTS":"Não constam eventos de integração.","LOAD_MORE":"Carregar mais","DETAILS":"Detalhes"},"LABELS_MANAGER":{"PAGE_TITLE":"Etiquetas","NAME":"Nome","TYPE":"Tipo","ACTIONS":"Ações","CUSTOMERS":"Clientes","ORDERS":"Atividades","QUOTATIONS":"Orçamentos","EQUIPMENTS":"Equipamentos","LIST_OF":"Ir para listagem de","DELETE_LABEL":"Excluir etiqueta","CREATED_AT":"Criado em"},"MOBILE":{"PAGE_TITLE":"Aplicativo do colaborador","WARNING":"As configurações referentes ao aplicativo do colaborador só serão refletidas após a realização do logout.","CUSTOM_TASK_CARD":{"TITLE":"Personalizar informações exibidas no card de atividades","HINT":"Essa opção possibilita escolher quais informações serão exibidas no card de atividades","SELECT":"Selecione as informações desejadas","MAX_SELECTED":"(Máximo de 2 informações)","ORDER_SERVICE":"Tipo de OS","EQUIPMENT_NUMBER":"Nº série do equipamento","ORDER_IDENTIFIER":"Identificador da OS","LOCATION_NAME":"Nome da localização","ERROR":"Só é possível selecionar duas opções, caso deseje selecionar outra, desmarque primeiro as que já estão marcadas"},"CUSTOM_EDIT_TASK_COMPLETE":{"TITLE":"Personalizar edição de atividades concluidas","HINT":"Esta opção permite definir quais status de conclusão poderão ser editadas após a finalização das atividades.","SELECT":"Selecione os status de conclusão desejados","CANCELED":"Cancelada","COMPLETED":"Concluida","REPORTED":"Impedida"},"ENABLE_TRACKING":{"TITLE":"Habilitar rastreamento","HINT":"Essa opção habilita localização e histórico de rotas dos colaboradores."},"ENABLE_TICKETS":{"TITLE":"Habilitar solicitações","HINT":"Essa opção habilita a visualização de solicitações no aplicativo do colaborador.","SEARCH_EMPLOYEES":"Procurar colaborador"},"GPS_ACCURACY":{"TITLE":"Precisão do GPS","HIGH":"Alta","AVERAGE":"Média","LOW":"Baixa","HINT":"Maior precisão do GPS significa maior consumo de bateria."},"ALLOW_CREATE_NEW_TASKS":{"TITLE":"Permitir a criação de novas atividades a partir de serviços impedidos","HINT":"Para empresas onde o colaborador externo tem autonomia para adicionar novas atividades em serviços impedidos"},"UPLOAD_GALLERY_ON":{"TITLE":"Habilitar envio de imagem pela galeria","HINT":"Essa opção permite que os colaboradores possam fazer envio de imagem pela galeria de fotos."},"ALLOW_REORDER_TASKS":{"TITLE":"Permitir reordenar atividades","HINT":"Para empresas onde o colaborador externo tem autonomia para ordenar as atividades."},"LIST_TASKS":{"TITLE":"Listar atividades dos próximos dias","HINT":"Além de conseguir ver as visitas do dia, o colaborador consegue ver e realizar visitas dos dias anteriores ou que estão agendadas para os próximos dias."},"LIST_TASKS_ALLOWED_DAYS":{"TITLE":"Dias possíveis para listar atividades anteriores e futuras","HINT":"Define quais dias o colaborador poderá visualizar as atividades.","YESTERDAY":"Ontem","TOMORROW":"Amanhã","NEXT_WEEK":"Próxima semana"},"START_TASKS_OUT_OF_ORDER":{"TITLE":"Iniciar as atividades fora de ordem","HINT":"Permite que o colaborador inicie as atividades fora de ordem."},"START_PENDING_TASKS":{"TITLE":"Permitir o acesso às atividades pendentes","HINT":"O colaborador poderá escolher quais atividades irá realizar a partir da lista de atividades pendentes, além de ter acesso automático à configuração de reordenar as atividades.","SEARCH_EMPLOYEES":"Procurar colaborador"},"START_TASKS_SIMULTANEOUSLY":{"TITLE":"Iniciar as atividades simultaneamente","HINT":"Permite que o colaborador inicie mais de uma atividade ao mesmo tempo no decorrer do dia."},"SEND_TASK_REPORT_LINK":{"TITLE":"Permitir enviar link do relatório da atividade","HINT":"Após encerrar a visita, o colaborador poderá enviar o relatório para o e-mail do cliente e/ou da localização."},"SEND_TASK_RATING_LINK":{"TITLE":"Permitir enviar link de avaliação da atividade","HINT":"Após encerrar a visita, o colaborador poderá enviar a avaliação do serviço para o e-mail do cliente e/ou da localização."},"SEND_TASK_SIGNATURE_LINK":{"TITLE":"Permitir enviar link de assinatura da atividade","HINT":"Durante a visita, o colaborador poderá enviar um link de assinatura para o e-mail do cliente e/ou da localização."},"ALLOW_EDIT_TASK_LABELS":{"TITLE":"Permitir editar as etiquetas da atividade","HINT":"O colaborador poderá adicionar ou remover etiquetas das atividades"},"CREATE_EDIT_QUOTATIONS":{"TITLE":"Permite criar e editar orçamentos","HINT":"Se ativado, o colaborador poderá ver, criar, editar e compartilhar orçamentos pelo app"},"SEND_LOCATION_OF_IMPEDIMENT":{"TITLE":"Enviar localização ao iniciar, completar e registrar impedimento na visita","HINT":"Ao iniciar, concluir ou registrar como impedimento uma atividade, serão armazenadas as informações de geolocalização."},"HIDE_PRODUCT_VALUE":{"TITLE":"Esconder valor do produto (beta)","DESCRIPTION":"Se ativado, o valor dos produtos utilizados ​nas atividades será ocultado para o colaborador"},"EDIT_PRODUCT_SERVICE_VALUE":{"TITLE":"Permitir alterar valor dos produtos e serviços","DESCRIPTION":"Se ativado, o colaborador poderá editar o valor dos produtos e serviços adicionados nas ordens de serviço."},"VALIDATE_DISTANCE":{"TITLE":"Validar distância com cliente","HINT":"O colaborador só poderá iniciar, concluir e registrar impedimento na visita quando estiver dentro do perímetro estabelecido.","ALLOWED_METERS":"Distância permitida em metros","METERS":"metros"},"UPDATE_CUSTOMERS_COORDINATES":{"TITLE":"Permitir o colaborador, com sua localização, atualizar as coordenadas do cliente","HINT":"O colaborador poderá utilizar sua localização atual para atualizar as coordenadas do cliente, caso estejam desatualizadas."},"VIEW_CUSTOMER_CONTACT_INFO":{"TITLE":"Exibir informações de contato do cliente","HINT":"Permite que o colaborador acesse as informações de contato do cliente."},"UPDATE_CUSTOMER_CONTACT_INFO":{"TITLE":"Atualizar informações de contato do cliente","HINT":"Permite ao colaborador atualizar as informações de contato do cliente."},"LIST_CUSTOMERS":{"TITLE":"Listar os clientes","HINT":"Permite ao colaborador listar e ter acesso às informações dos clientes."},"ENABLE_CHANGES_VISIT":{"TITLE":"Possibilitar alterações da visita depois de concluída, impedida ou cancelada.","HINT":"Permite que o colaborador altere informações, formulários e fotos de uma visita após conclusão, cancelamento ou impedimento. *Essa configuração reflete somente no app do colaborador."},"TASK_DESCRIPTION_REQUIRED":{"TITLE":"Preenchimento obrigatório da conclusão da ordem de serviço","HINT":"Para concluir a atividade, o colaborador deverá preencher o campo de conclusão da ordem de serviço."},"TASK_REPORT_DESCRIPTION_REQUIRED":{"TITLE":"Preenchimento obrigatório da descrição de impedimento da ordem de serviço","HINT":"Para impedir a atividade, o colaborador deverá preencher o campo de descrição do impedimento."},"FORMS_STEP_BY_STEP":{"TITLE":"Formulários por etapas","HINT":"Permite ao colaborador responder o formulário em etapas, uma pergunta por vez"},"HIDE_EMPLOYEE_WORK_HOURS":{"TITLE":"Ocultar informações das horas trabalhadas no perfil do colaborador","HINT":"Essa configuração oculta o relatório de horas trabalhadas dentro do perfil do colaborador no aplicativo."},"SAVE_IMAGE_TO_GALLERY":{"TITLE":"Habilite para que as imagens sejam salvas na galeria","HINT":"Essa opção permite que os colaboradores salvem na galeria do celular as imagens tiradas pelo Field Control."},"SOUND_NOTIFICATION":{"TITLE":"Selecione o som de notificação do aplicativo (Android):","HINT":"Permite alterar o som das notificações do aplicativo do Colaborador<br/><br/><b>Atenção: A versão do aplicativo do colaborador deve ser superior a 6.16.0</b>","SELECT":"Selecione o tipo do som","DEFAULT":"Padrão","SMOOTH":"Sútil","MODERATE":"Moderado","HIGH":"Chamativo","HIGH_EXTENDED":"Chamativo (Estendido)"},"SHOW_TASK_ON_ROUTE_ALERT":{"TITLE":"Exibir alertas de próxima atividade","HINT":"O colaborador receberá alertas de atividades que estão próximas do horário agendado, facilitando o início do deslocamento"},"TASK_ON_ROUTE_ALERT_INTERVAL":{"TITLE":"O intervalo para exibição dos alertas é de ","MINUTES":"minutos","HINT":"Define o tempo em minutos antes do horário agendado para que o colaborador receba esse alerta."},"ALLOW_CREATE_ORDERS":{"TITLE":"Permitir criação de atividades","HINT":"O colaborador poderá criar e editar atividades.","SEARCH_EMPLOYEES":"Procurar colaborador"},"CREATE_ORDERS_TO_OTHER_EMPLOYEES":{"TITLE":"Permitir criação de atividades para outros colaboradores","HINT":"Os colaboradores habilitados para criar atividades poderão designá-las a outros colaboradores ao serem selecionados.","SEARCH_EMPLOYEES":"Procurar colaborador"},"NOTIFY_GEOLOCATION_DISABLED":{"TITLE":"Notificar quando o colaborador desativar a geolocalização","HINT":"Os usuários selecionados serão notificados via painel quando um colaborador desativar a geolocalização.","SEARCH_USER":"Pesquisar usuário"}},"OTHERS":{"PAGE_TITLE":"Outras configurações","LANGUAGE":{"TITLE":"Idioma da conta","HINT":"Configuração de linguagem para e-mails enviados pelo Field","PLACEHOLDER":"Selecione o idioma","PORTUGUESE":"Português","ENGLISH":"Inglês","SPANISH":"Espanhol"},"EMAIL":{"INIT_ROUTE_LINK":{"TITLE":"Enviar e-mail com o link da localização do colaborador automaticamente após o inicio do deslocamento","HINT":"Ao iniciar o deslocamento pelo app do colaborador, será enviado automaticamente o link da localização do colaborador para o e-mail cadastrado do cliente."},"SERVICE_ORDER_LINK":{"TITLE":"Enviar e-mail com o link da ordem de serviço automaticamente após a conclusão da atividade","HINT":"Ao concluir a atividade pelo app do colaborador, será enviado automaticamente o link do relatório da visita para o e-mail cadastrado do cliente."},"RATING_LINK":{"TITLE":"Enviar e-mail com link de avaliação automaticamente após a conclusão da atividade","HINT":"Ao concluir a atividade pelo app do colaborador, será enviado automaticamente o link da avaliação da visita para o e-mail cadastrado do cliente."},"NOTICE_TASK_RATING":{"TITLE":"Enviar aviso por e-mail ao receber uma avaliação de atividade","HINT":"Ao receber uma avaliação de uma atividade, os gestores selecionados receberão um e-mail de notificação."}},"FORMS":{"SCORED_OPTIONS":{"TITLE":"Usar esquema de pontuações nas opções das questões dos formulários","HINT":"Habilita inserir uma pontuação para uma opção do tipo lista ou múltipla escolha nos formulários."}},"NOTIFICATIONS":{"PENDING_NOTIFICATIONS":{"TITLE":"Habilitar notificação para atividades pendentes","HINT":"Quando habilitado, novas atividades com situação pendente notificarão todos os colaboradores pelo aplicativo"}},"QUOTATIONS":{"IDENTIFIER_TYPE":{"TITLE":"Tipo de identificador dos <strong> orçamentos </strong>","TYPES":{"SEQUENCE":"Sequencial","RANDOM":"Randômico","DO_NOT_GENERATE":"Não gerar"},"DESCRIPTIONS":{"SEQUENCE":"<strong> Sequencial: </strong> o identificador do orçamento será gerado em ordem crescente.","RANDOM":"<strong> Randômico: </strong> o identificador do orçamento será gerado de forma aleatória.","DO_NOT_GENERATE":"<strong> Não gerar: </strong> o identificador do orçamento não será gerado e deve ser informado pelo gestor no momento de criação de um orçamento."}},"SEQUENCE":{"TITLE":"Próximo orçamento terá como identificador o número: ","CUSTOMIZE":"Personalizar","CONFIRM":"Confirmar","CANCEL":"Cancelar","ERRORS":{"MIN_ERROR":"Precisa ser maior que {{ lastNextIdentifier }}","SEARCH_FAILED":"Não foi possível buscar o identificador atual. Verifique sua conexão e tente novamente."}},"EQUIPMENTS_ON":{"TITLE":"Equipamentos em orçamentos","HINT":"Quando habilitado, permite a seleção de equipamentos antes da seleção de produtos e serviços"},"LINK_ITEMS":{"TITLE":"Vínculo de itens do orçamento na O.S.","HINT":"Quando habilitado, após criar um orçamento pela ordem de serviço, será possível vincular produtos e serviços na atividade"}},"SEARCH_USER":"Pequisar usuário","SWITCH_USER":"Alternar usuário","PUBLIC_QRCODE":{"ENABLE":{"TITLE":"Leitura pública do QR Code","DESCRIPTION":"Permitir que qualquer pessoa escaneie o QR Code de equipamentos, ambientes e veículos e, ao fazer isso fora do app, uma página web será aberta."},"CUSTOMIZATION":{"TITLE":"Personalizar informações exibidas na página do QR Code","DESCRIPTION":"Escolha o que será exibido na página que será aberta após a leitura do QR Code","CHOOSE_TITLE":"Selecione as informações desejadas:","DETAIL":"Detalhes","OPEN_TICKET":"Abertura de chamado","TASKS":"Histórico de atividades"}}},"ORDERS":{"PAGE_TITLE":"Ordens de serviço","TASK_IDENTIFIER_TYPE":{"TITLE":"Tipo de identificador","HINT":"<span><strong>Não gerar: </strong> o identificador da ordem de serviço não será gerado e deve ser informado pelo gestor no momento de criação da ordem de serviço.</span><br/><span><strong>Sequencial: </strong> o identificador da ordem de serviço será gerado em ordem crescente.</span><br/><span><strong>Randômico: </strong> o identificador da ordem de serviço será gerado de forma aleatória.</span>","DO_NOT_GENERATE":"Não gerar","SEQUENTIAL":"Sequencial","RANDOM":"Randômico","NEXT_IDENTIFIER":"Próxima ordem de serviço terá como identificador o número","CUSTOMIZE":"Personalizar","CANCEL":"Cancelar","CONFIRM":"Confirmar","SUCCESS":"Número do identificador da próxima order de serviço alterado com sucesso!","FAIL":"Não foi possível realizar a modificação. Verifique sua conexão.","GET_FAIL":"Não foi possível buscar o identificador atual. Verifique sua conexão e tente novamente.","RETRY":"Tentar novamente","MIN_ERROR":"Precisa ser maior que {{ lastNextIdentifier }}"},"EMPLOYEE_IS_MORE_THAN_ONE_TASK_SAME_TIME":{"TITLE":"Não permitir que um colaborador realize mais de uma visita ao mesmo tempo","HINT":"Se ativado, não será possível colocar, pelo painel, duas ou mais visitas de uma mesma atividade em andamento para o mesmo colaborador."},"CREATED_AT_IS_AFTER_STARTED_AT":{"TITLE":"Permite fechar manutenções antes da data de criação da OS","HINT":"Permite que o gestor feche a manutenção antes da data de criação da OS."},"ALLOW_MULTIPLE_TASKS":{"TITLE":"Permitir múltiplas atividades","HINT":"Permite que o gestor crie mais de uma visita para mesma ordem de serviço."},"ALLOW_PENDING_TASKS":{"TITLE":"Habilitar atividades pendentes","HINT":"Permite que o gestor crie, edite e visualize atividades sem data de agendamento."},"ALLOW_NEW_TASK_IF_PREVIOUS_COMPLETED":{"TITLE":"Bloquear adição de visitas adicionais enquanto visitas anteriores estiverem em aberto","HINT":"Só será possível adicionar uma nova visita caso a anterior estiver finalizada, ou seja, com situação de Concluída, Impedida ou Cancelada."},"ADDRESS_SEARCH_MODE":{"TITLE":"Modo de pesquisa endereço","GOOGLE":"Google","ZIP_CODE":"CEP","HINT":"<span><strong>Google:</strong> Busca de endereço para clientes com dados do Google.<br><strong>CEP: </strong> Busca de endereço para clientes por CEP</span>"},"SEARCHES_RESTRICTED_COUNTRY":{"TITLE":"Buscas de endereço devem se restringir apenas ao país:","SEARCH":"Procurar por continente...","HINT":"Será possível buscar endereços apenas para o país selecionado."}},"GANTT":{"PAGE_TITLE":"Linha do tempo","VIEW_DISPLACEMENT":{"TITLE":"Exibir deslocamento","HINT":"Na linha do tempo será exibido uma \\"barra cinza\\" que é uma estimativa de deslocamento  calculado pela distância aérea entre as atividades"},"SORT_EMPLOYEES":{"TITLE":"Ordenação de colaboradores na linha do tempo por ordem","ALPHABETICALLY":"Alfabética","CUSTOM":"Customizada","HINT":"<span><strong>Alfabética:</strong> Colaboradores ordenados por ordem alfabética. <br> <strong>Customizada:</strong> Colaboradores ordenados de acordo com configuração.</span>"},"GANTT_REAL_TIME_MONITORING_ON":"Monitorar visitas em tempo real","GANTT_REAL_TIME_MONITORING_ON_HINT":"Monitorar visitas em tempo real"},"BUTTON_SAVE":"Salvar","ERRORS":{"SAVE_IMAGE":"Houve um erro ao salvar a imagem.","ERROR_FETCHING_ADDRESS":"Houve um erro ao buscar o endereço!","SAVE_ERROR":"Não foi possível realizar a modificação. Verifique sua conexão."},"WARNINGS":{"TIMELINE_NOT_WORK_PROPERLY":"Habilitar essa configuração pode afetar a exibição das atividades na Linha do tempo","AFFECTS_TASK_OUT_OF_ORDER":"Habilitar a configuração pode afetar a configuração de \\"iniciar atividades fora de ordem\\"","APP_VERSION":"Essa configuração só está válida nas versões anteriores à: 1.1.1. Após esta versão será considerada a configuração informada no tipo de OS."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/subscription/i18n/en.json',
    '{"SUBSCRIPTION":{"OF":"of","EMAIL":"Email","METHOD":"Method","VIDEOS":"Videos","IMAGES":"Images","USING":"license(s) used.","PAYMENT":"Payment","LICENSE":"Licenses - employee app","PAGE_TITLE":"Subscription","STORAGE":"Storage","UPGRADE_BUTTON":"Upgrade","EMPLOYEES":"Employees","CURRENT_PLAN":"Current plan","BENEFITS":"Plan benefits","LAST_PAYMENT":"Last payment","MANAGE_EMAILS":"Manage emails","MANAGE_LICENSES":"Add more licenses","NEXT_DUE_DATE":"Next due date","REQUEST_CHANGE":"Request change","ACTIVE_MODULES_BUTTON":"Activate modules","REQUEST_STORAGE_UPGRADE":"Need more space?<br>Request an upgrade","REQUEST_LICENSES_UPGRADE":"Need more licenses?<br>Request an upgrade","RENEW_ALERT_TOOLTIP":"Your subscription will expire, renew it to avoid account lockout.","PLAN_WARNING":{"DOES_NOT_HAVE":"You do not have a Field Control subscription yet.","SUBTITLE":"Talk to one of our experts to get it.","BUTTON":"Request a demo"},"SECTIONS":{"OVERVIEW":{"TITLE":"Overview"},"MODULES":{"TITLE":"Boost your subscription with modules","DESCRIPTION":"Choose from the available modules the one that best suits your company\'s scenario.","ROUTES":{"TITLE":"Routing","DESCRIPTION":"Automate your team\'s routes with artificial intelligence."},"EQUIPMENTS":{"TITLE":"Equipment","DESCRIPTION":"Control your clients\' equipment with QR Code."},"VEHICLES":{"TITLE":"Vehicles","DESCRIPTION":"Control vehicles and their respective mileage."},"CUSTOMERS_AREA":{"TITLE":"Customer Area","DESCRIPTION":"Dashboard for your customers to open, view, and track tickets."},"IMAGE_RENDER":{"TITLE":"Image Resolution","DESCRIPTION":"Increase the image quality of your services."},"VIDEO":{"TITLE":"Video","DESCRIPTION":"Capture more details of your services with videos."},"DEADLINE":{"TITLE":"Deadlines","DESCRIPTION":"Set response and solution deadlines for your services and track their execution."}},"CANCEL_ACCOUNT":{"TITLE":"Want to cancel your account?","DESCRIPTION":"Contact <a class=\'header-description--link\' href=\'mailto: suporte@fieldcontrol.com.br\'> suporte@fieldcontrol.com.br </a> or talk to your account manager to cancel your subscription."}},"SIDENAVS":{"MANAGE_EMAILS":{"NO":"No","YES":"Yes","SAVE":"Save","PRIMARY":"Main","TITLE":"Manage emails","ADD_EMAIL":"Add email","INVALID_EMAIL":"Invalid email","REMOVE_EMAIL":"Remove email","UPDATE_EMAIL":"Update","MAIN_EMAIL":"Main email","SET_MAIN_EMAIL":"Set as main email","REQUIRED":"Email is required","DUPLICATED":"Email already added","MAX_LIMIT":"Maximum limit reached","CONFIRM_DELETE":"Are you sure you want to delete?","EMPTY":"You don\'t have any emails registered.","ITEM_INVALID_EMAIL":"Item being edited is invalid","DESCRIPTION":"Manage the emails that will receive alerts about your subscription.","FOOTER_DESCRIPTION":"Registered emails will receive updates on plan expiration and renewal.","TOAST":{"SUCCESS":"Your changes have been saved successfully!","FAIL":"There was an error trying to save your changes!"}},"EMPLOYEES":{"INVALID":"Invalid value","MAX":"Maximum number exceeded","NUMBER":"{{ number }} licenses","CHANGE_TO":"Add licenses:","CURRENT":"Contracted licenses:","TITLE":"Employee licenses","LICENSES_NUMBER":"Number of licenses","QUESTION":"Do you want to increase the number of employee licenses?","DESCRIPTION":"By clicking on <b>Request Change</b>, our team will analyze the request and contact you to confirm the license increase.","DIALOG":{"CANCEL":"Cancel","CONFIRM":"Confirm","TITLE":"Confirm upgrade?","DESCRIPTION":"This feature is <strong>paid</strong> and there is an additional cost for its acquisition.<br>Your account manager will contact you to process your request."},"TOAST":{"FAIL":"There was an error sending your request.","SUCCESS":"Your request has been successfully submitted!"}},"RENEWAL":{"OK":"Ok","CHANGE_TO":"Change to:","SELECT_DATE":"Select date","TITLE":"Subscription renewal","VIEW_INVOICE":"View invoice","NEXT_DUE_DATE":"Next due date","RENEW_SUBSCRIPTION":"Renew subscription","QUESTION":"Do you want to renew your subscription?","FAIL":"There was an error sending your request.","SUCCESS":"Your renewal request has been successfully made!","UNDER_REVIEW":"Your renewal is under review, once payment is confirmed, your subscription will be renewed.","DESCRIPTION":"When you click <b> Renew subscription </b>, you will be redirected to a payment page to complete your renewal, which will be analyzed until payment is confirmed.","PLAN":{"TOTAL":"Total","TITLE":"Your plan","PAYMENT_METHODS":"Payment methods","TERMS":{"TEXT":"I accept the&nbsp;","LINK":"Terms and Conditions of Use"},"CONTRACT":{"TEXT":"I agree with the&nbsp;","LINK":"Subscription Contract"},"TYPE":{"YEARLY":"Yearly","BIENNIAL":"Biennial","TRIENNIAL":"Triennial","QUADRIENNIAL":"Quadrennial","QUINQUENNIAL":"Quinquennial"},"FEATURE":{"ROUTER":"Routing","STORAGE":"Storage","MANAGER_APP":"Management panel","VIDEOS_MODULE":"Videos module","EQUIPMENTS_MODULE":"Equipment module","HIGH_RESOLUTION_IMAGES":"High resolution images","EMPLOYEE_APP":"{{ number }} employee license(s)","CUSTOMER_AREA":"Customer area"}}}},"TOAST":{"FAIL":"There was an error sending your request.","SUCCESS":"Your request has been successfully sent."},"STORAGE_UPGRADE":{"CHANGE_TO":"Increase space:","TITLE":"Storage space","CURRENT":"Current storage space:","QUESTION":"Do you want to increase storage space?","DESCRIPTION":"By clicking on <b>request change</b>, our team will analyze the request and contact you to confirm the increase in storage space."}},"FC_SUBSCRIPTION_MODULE":{"ACTIONS":{"CONTRACT_MODULE":"Contract module","MANAGER_MODULE":{"TITLE":"Module already contracted","BUTTON_TITLE":"Manage module"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/subscription/i18n/es.json',
    '{"SUBSCRIPTION":{"OF":"de","EMAIL":"Correo electrónico","METHOD":"Método","VIDEOS":"Videos","IMAGES":"Imágenes","USING":"licencia(s) utilizada(s).","PAYMENT":"Pago","LICENSE":"Licencias - App del colaborador","PAGE_TITLE":"Suscripción","STORAGE":"Almacenamiento","UPGRADE_BUTTON":"Actualizar","EMPLOYEES":"Colaboradores","CURRENT_PLAN":"Plan actual","BENEFITS":"Beneficios del plan","LAST_PAYMENT":"Último pago","MANAGE_EMAILS":"Administrar correos electrónicos","MANAGE_LICENSES":"Agregar más licencias","NEXT_DUE_DATE":"Fecha de próxima renovación","REQUEST_CHANGE":"Solicitar cambio","ACTIVE_MODULES_BUTTON":"Activar módulos","REQUEST_STORAGE_UPGRADE":"¿Necesitas más espacio?<br>Solicita una actualización","REQUEST_LICENSES_UPGRADE":"¿Necesitas más licencias?<br>Solicita una actualización","RENEW_ALERT_TOOLTIP":"Tu suscripción expirará, renuévala para evitar el bloqueo de la cuenta.","PLAN_WARNING":{"DOES_NOT_HAVE":"Todavía no tienes una suscripción a Field Control.","SUBTITLE":"Habla con uno de nuestros expertos para obtenerla.","BUTTON":"Solicitar una demostración"},"SECTIONS":{"OVERVIEW":{"TITLE":"Visión general"},"MODULES":{"TITLE":"Mejora tu suscripción con módulos","DESCRIPTION":"Elige entre los módulos disponibles el que mejor se adapte al escenario de tu empresa.","ROUTES":{"TITLE":"Enrutamiento","DESCRIPTION":"Automatiza las rutas de tu equipo con inteligencia artificial."},"EQUIPMENTS":{"TITLE":"Equipos","DESCRIPTION":"Controla los equipos de tus clientes con código QR."},"VEHICLES":{"TITLE":"Vehículos","DESCRIPTION":"Controla los vehículos y sus respectivos kilometrajes."},"CUSTOMERS_AREA":{"TITLE":"Área del cliente","DESCRIPTION":"Panel para que tus clientes puedan abrir, ver y hacer seguimiento de los tickets."},"IMAGE_RENDER":{"TITLE":"Resolución de imagen","DESCRIPTION":"Aumenta la calidad de imagen de tus servicios."},"VIDEO":{"TITLE":"Video","DESCRIPTION":"Captura más detalles de tus servicios con videos."},"DEADLINE":{"TITLE":"Plazos","DESCRIPTION":"Establece plazos de respuesta y solución para tus servicios y sigue su ejecución."}},"CANCEL_ACCOUNT":{"TITLE":"¿Quiere cancelar su cuenta?","DESCRIPTION":"Ponte en contacto con <a class=\'header-description--link\' href=\'mailto: suporte@fieldcontrol.com.br\'> suporte@fieldcontrol.com.br </a> o habla con tu gestor de cuentas para cancelar tu suscripción."}},"SIDENAVS":{"MANAGE_EMAILS":{"NO":"No","YES":"Sí","SAVE":"Guardar","PRIMARY":"Principal","TITLE":"Administrar correos electrónicos","ADD_EMAIL":"Agregar correo electrónico","INVALID_EMAIL":"Correo electrónico inválido","REMOVE_EMAIL":"Eliminar correo electrónico","UPDATE_EMAIL":"Actualizar","MAIN_EMAIL":"Correo electrónico principal","SET_MAIN_EMAIL":"Establecer como correo electrónico principal","REQUIRED":"El correo electrónico es obligatorio","DUPLICATED":"Correo electrónico ya agregado","MAX_LIMIT":"Límite máximo alcanzado","CONFIRM_DELETE":"¿Estás seguro de que quieres eliminar?","EMPTY":"No tienes ningún correo electrónico registrado.","ITEM_INVALID_EMAIL":"El elemento en edición es inválido","DESCRIPTION":"Administra los correos electrónicos que recibirán alertas sobre tu suscripción.","FOOTER_DESCRIPTION":"Los correos electrónicos registrados recibirán actualizaciones sobre la expiración y renovación del plan.","TOAST":{"SUCCESS":"¡Tus cambios se han guardado correctamente!","FAIL":"Hubo un error al intentar guardar tus cambios."}},"EMPLOYEES":{"INVALID":"Valor inválido","MAX":"Se excedió el número máximo","NUMBER":"{{ number }} licencias","CHANGE_TO":"Agregar licencias:","CURRENT":"Licencias contratadas:","TITLE":"Licencias de empleados","LICENSES_NUMBER":"Número de licencias","QUESTION":"¿Quieres aumentar el número de licencias de empleados?","DESCRIPTION":"Al hacer clic en <b>Solicitar cambio</b>, nuestro equipo analizará la solicitud y se pondrá en contacto contigo para confirmar el aumento de licencias.","DIALOG":{"CANCEL":"Cancelar","CONFIRM":"Confirmar","TITLE":"¿Confirmar actualización?","DESCRIPTION":"Esta función es <strong>de pago</strong> y hay un costo adicional por su adquisición.<br>Tu gestor de cuenta se pondrá en contacto contigo para procesar tu solicitud."},"TOAST":{"FAIL":"Hubo un error al enviar tu solicitud.","SUCCESS":"¡Tu solicitud se ha enviado correctamente!"}},"RENEWAL":{"OK":"Ok","CHANGE_TO":"Cambiar a:","SELECT_DATE":"Seleccionar fecha","TITLE":"Renovación de suscripción","VIEW_INVOICE":"Ver factura","NEXT_DUE_DATE":"Siguiente vencimiento","RENEW_SUBSCRIPTION":"Renovar suscripción","QUESTION":"¿Quieres renovar tu suscripción?","FAIL":"Hubo un error al enviar tu solicitud.","SUCCESS":"¡Tu solicitud de renovación se ha realizado con éxito!","UNDER_REVIEW":"Tu renovación está bajo revisión, una vez confirmado el pago, se renovará tu suscripción.","DESCRIPTION":"Al hacer clic en <b>Renovar suscripción</b>, serás redirigido a una página de pago para finalizar tu renovación, que estará bajo revisión hasta la confirmación del pago.","PLAN":{"TOTAL":"Total","TITLE":"Tu plan","PAYMENT_METHODS":"Métodos de pago","TERMS":{"TEXT":"Acepto los&nbsp;","LINK":"Términos y Condiciones de Uso"},"CONTRACT":{"TEXT":"Estoy de acuerdo con el&nbsp;","LINK":"Contrato de Suscripción"},"TYPE":{"YEARLY":"Anual","BIENNIAL":"Bienal","TRIENNIAL":"Trienal","QUADRIENNIAL":"Cuadrienal","QUINQUENNIAL":"Quinquenal"},"FEATURE":{"ROUTER":"Ruteador","STORAGE":"Almacenamiento","MANAGER_APP":"Panel de gestión","VIDEOS_MODULE":"Módulo de videos","EQUIPMENTS_MODULE":"Módulo de equipos","HIGH_RESOLUTION_IMAGES":"Imágenes de alta resolución","EMPLOYEE_APP":"{{ number }} licencia(s) de empleado","CUSTOMER_AREA":"Área del cliente"}}}},"TOAST":{"FAIL":"Hubo un error al enviar tu solicitud.","SUCCESS":"Tu solicitud se ha enviado correctamente."},"STORAGE_UPGRADE":{"CHANGE_TO":"Aumentar espacio:","TITLE":"Espacio de almacenamiento","CURRENT":"Espacio de almacenamiento actual:","QUESTION":"¿Quieres aumentar el espacio de almacenamiento?","DESCRIPTION":"Al hacer clic en <b>Solicitar cambio</b>, nuestro equipo analizará la solicitud y se pondrá en contacto contigo para confirmar el aumento del espacio de almacenamiento."}},"FC_SUBSCRIPTION_MODULE":{"ACTIONS":{"CONTRACT_MODULE":"Contratar módulo","MANAGER_MODULE":{"TITLE":"Módulo ya contratado","BUTTON_TITLE":"Gestionar módulo"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/subscription/i18n/pt.json',
    '{"SUBSCRIPTION":{"OF":"de","EMAIL":"E-mail","METHOD":"Método","VIDEOS":"Vídeos","IMAGES":"Imagens","USING":"licença(s) utilizada(s).","PAYMENT":"Pagamento","LICENSE":"Licenças - App do colaborador","PAGE_TITLE":"Assinatura","STORAGE":"Armazenamento","UPGRADE_BUTTON":"Upgrade","EMPLOYEES":"Colaboradores","CURRENT_PLAN":"Plano atual","BENEFITS":"Benefícios do plano","LAST_PAYMENT":"Último pagamento","MANAGE_EMAILS":"Gerenciar e-mails","MANAGE_LICENSES":"Adicionar mais licenças","NEXT_DUE_DATE":"Data da próxima renovação","REQUEST_CHANGE":"Solicitar alteração","ACTIVE_MODULES_BUTTON":"Ativar módulos","REQUEST_STORAGE_UPGRADE":"Precisa de mais espaço?<br>Solicite um upgrade","REQUEST_LICENSES_UPGRADE":"Precisa de mais licenças?<br>Solicite um upgrade","RENEW_ALERT_TOOLTIP":"Sua assinatura vai expirar, faça a renovação e evite o bloqueio da conta.","PLAN_WARNING":{"DOES_NOT_HAVE":"Você ainda não possui uma assinatura Field Control.","SUBTITLE":"Converse com um dos nossos especialistas para obtê-la.","BUTTON":"Solicitar demonstração"},"SECTIONS":{"OVERVIEW":{"TITLE":"Visão geral"},"MODULES":{"TITLE":"Turbine sua assinatura com módulos","DESCRIPTION":"Escolha entre os módulos disponíveis o que melhor se adequa ao cenário da sua empresa.","ROUTES":{"TITLE":"Roteirização","DESCRIPTION":"Automatize as rotas de sua equipe com inteligência artificial."},"EQUIPMENTS":{"TITLE":"Equipamentos","DESCRIPTION":"Controle os equipamentos de seus clientes com QR Code."},"VEHICLES":{"TITLE":"Veículos","DESCRIPTION":"Faça o controle de veículos e suas respectivas quilometragens"},"CUSTOMERS_AREA":{"TITLE":"Área do cliente","DESCRIPTION":"Painel para que seus clientes possam abrir, ver e acompanhar chamados."},"IMAGE_RENDER":{"TITLE":"Resolução de imagem","DESCRIPTION":"Aumente a qualidade de imagem de seus atendimentos."},"VIDEO":{"TITLE":"Vídeo","DESCRIPTION":"Capture mais detalhes de seus atendimentos com vídeos."},"DEADLINE":{"TITLE":"Prazos","DESCRIPTION":"Defina prazos de resposta e solução para os seus serviços e acompanhe sua execução."}},"CANCEL_ACCOUNT":{"TITLE":" Deseja cancelar sua conta?","DESCRIPTION":"Entre em contato com <a class=\'header-description--link\' href=\'mailto: suporte@fieldcontrol.com.br\'> suporte@fieldcontrol.com.br </a> ou fale com seu gerente de conta para cancelar sua assinatura."}},"SIDENAVS":{"MANAGE_EMAILS":{"NO":"Não","YES":"Sim","SAVE":"Salvar","PRIMARY":"Principal","TITLE":"Gerenciar e-mails","ADD_EMAIL":"Adicionar e-mail","INVALID_EMAIL":"E-mail inválido","REMOVE_EMAIL":"Remover e-mail","UPDATE_EMAIL":"Atualizar","MAIN_EMAIL":"E-mail principal","SET_MAIN_EMAIL":"Definir como e-mail principal","REQUIRED":"E-mail é obrigatório","DUPLICATED":"E-mail já adicionado","MAX_LIMIT":"Limite máximo atingido","CONFIRM_DELETE":"Tem certeza que deseja excluir?","EMPTY":"Você não possui nenhum e-mail cadastrado.","ITEM_INVALID_EMAIL":"Item em edição está inválido","DESCRIPTION":"Administre os e-mails que receberão os alertas sobre sua assinatura","FOOTER_DESCRIPTION":"Os e-mails cadastrados receberão atualizações sobre o vencimento e renovação do plano.","TOAST":{"SUCCESS":"Suas alterações foram salvas com sucesso!","FAIL":"Houve um erro ao tentar salvar suas alterações!"}},"EMPLOYEES":{"INVALID":"Valor inválido","MAX":"Número máximo excedido","NUMBER":"{{ number }} licenças","CHANGE_TO":"Adicionar licenças:","CURRENT":"Licenças contratadas:","TITLE":"Licenças de colaboradores","LICENSES_NUMBER":"Número de licenças","QUESTION":"Deseja aumentar o número de licenças de colaboradores?","DESCRIPTION":"Ao clicar em <b>Solicitar alteração</b>, nosso time irá analisar a solicitação e entrará em contato para confirmar o aumento de licenças.","DIALOG":{"CANCEL":"Cancelar","CONFIRM":"Confirmar","TITLE":"Confirmar upgrade?","DESCRIPTION":"Este recurso é <strong>pago</strong> e há um custo adicional para sua aquisição.<br>O seu gerente de contas entrará em contato para processar sua solicitação."},"TOAST":{"FAIL":"Houve um erro ao enviar sua solicitação.","SUCCESS":"Sua solicitação foi feita com sucesso!"}},"RENEWAL":{"OK":"Ok","CHANGE_TO":"Alterar para:","SELECT_DATE":"Selecione a data","TITLE":"Renovação de assinatura","VIEW_INVOICE":"Visualizar fatura","NEXT_DUE_DATE":"Próximo vencimento","RENEW_SUBSCRIPTION":"Renovar assinatura","QUESTION":"Deseja renovar a sua assinatura?","FAIL":"Houve um erro ao enviar sua solicitação.","SUCCESS":"Seu pedido de renovação foi feito com sucesso!","UNDER_REVIEW":"Sua renovação está em análise, assim que confirmado o pagamento, sua assinatura será renovada.","DESCRIPTION":"Ao clicar em <b>Renovar assinatura</b>, você será redirecionado a uma página de pagamento para finalizar sua renovação que entrará em análise até a confirmação do pagamento.","PLAN":{"TOTAL":"Total","TITLE":"Seu plano","PAYMENT_METHODS":"Formas de pagamento","TERMS":{"TEXT":"Aceito os&nbsp;","LINK":"Termos e Condições de Uso"},"CONTRACT":{"TEXT":"Concordo com o&nbsp;","LINK":"Contrato de Assinatura"},"TYPE":{"YEARLY":"Anual","BIENNIAL":"Bienal","TRIENNIAL":"Trienal","QUADRIENNIAL":"Quadrienal","QUINQUENNIAL":"Quinquenal"},"FEATURE":{"ROUTER":"Roteirizador","STORAGE":"Armazenamento","MANAGER_APP":"Painel de gestão","VIDEOS_MODULE":"Módulo de vídeos","EQUIPMENTS_MODULE":"Módulo de equipamentos","HIGH_RESOLUTION_IMAGES":"Imagens em alta resolução","EMPLOYEE_APP":"{{ number }} licença(s) de colaborador","CUSTOMER_AREA":"Área do cliente"}}}},"TOAST":{"FAIL":"Houve um erro ao enviar sua solicitação.","SUCCESS":"Sua solicitação foi enviada com sucesso."},"STORAGE_UPGRADE":{"CHANGE_TO":"Aumentar espaço:","TITLE":"Espaço de armazenamento","CURRENT":"Espaço de armazenamento atual:","QUESTION":"Deseja aumentar o espaço de armazenamento?","DESCRIPTION":"Ao clicar em <b>Solicitar alteração</b>, nosso time irá analisar a solicitação e entrará em contato para confirmar o aumento do espaço de armazenamento."}},"FC_SUBSCRIPTION_MODULE":{"ACTIONS":{"CONTRACT_MODULE":"Contratar módulo","MANAGER_MODULE":{"TITLE":"Módulo já contratado","BUTTON_TITLE":"Gerenciar módulo"}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/tasks/i18n/en.json',
    '{"TASKS":{"PAGE_TITLE":"Tasks","TITLE":"Tasks","TUTORIAL_VIDEO":{"TITLE":"Instructions","TOOLTIP":"Watch tutorial video"},"FEEDBACK_FORM":"Try the stock module and optimize your business management!!!","ACTION_BUTTONS":{"PRINT":"Print","EXPORT_PDF":"Export to Pdf","EXPORT_EXCEL":"Export to Excel","RESTORE_COLUMNS":"Restore columns","TOGGLE_COLUMNS":"Toggle columns","CLEAR_FILTERS":"Clear filters","FILTER":"Filter tasks","NEW":"New task","CANT_CREATE":"You don\'t have permission to add tasks","RELOAD":"Reload"},"EXPORT_MODAL":{"TITLE":"Visit export","TITLE_PDF":"Mass PDF export","TITLE_LIMIT_EXCEEDED":"Attention","TEMPLATE":{"YES":"Yes","NO":"No","OK":"Ok, got it","MATERIALS":"Materials","PRODUCTS":"Products","EQUIPMENTS":"Equipments","FORMS":"Forms","LINKS":"Links","SERVICES":"Services","TITLE":"Choose which information will be exported along with the visits.","ALERT_FIRST_CONTENT":"By clicking export, you will receive a download link for the export in your email","ALERT_SECOND_CONTENT":"Depending on the amount of information, the export may take a few minutes to complete.","ALERT_LIMIT_EXCEEDED_FIRST_CONTENT":"You can only export up to","ALERT_LIMIT_EXCEEDED_SECOND_CONTENT":"mass PDFs. Use the filters available in the listing to reduce the number of results and try again.","CONFIRM_ACTION_CONTENT":"Do you want to continue with the export?","MATERIALS_MUST_BE_MIGRATED":"Materials must be migrated to products.","TO_KNOW_MORE":"to learn more and perform the migration.","CLICK_HERE":"Click here"}},"CHANGE_TASK_STATUS":{"ALERT_FIRST_CONTENT":"Are you sure you want to modify the status of this task? It\'s likely that","ALERT_SECOND_CONTENT":"is still performing this task."},"TABLE":{"MARKINGS":{"NO_RATE":"Not rated","ARCHIVED":"Archived","DAY":{"SINGULAR":"day","PLURAL":"days"}},"COLUMNS":{"ID":"Identifier","LABELS":"Labels","DATE":"Scheduling date","HOUR":"Scheduling hour","DEADLINE":"Deadline","CUSTOMER":"Customer","CUSTOMER_LOCATION":"Location","ADDRESS":"Address","DESCRIPTION":"Description","VISIT_OBSERVATION":"Task observation","SITUATION":"Status","START_DATE":"Start date","START_HOUR":"Start time","ROUTE_DATE":"Travel date","ROUTE_HOUR":"Travel time","END_DATE":"End date","END_HOUR":"End time","VISIT_DURATION":"Task duration","ROUTE_DURATION":"Route duration","DESCRIPTION_CLOSURE":"Completion - Description","RATE":"Rating","COMMENT":"Comments","TYPE":"Type","EMPLOYEE":"Employee","CREATED_AT":"Created on","RESPONSE_DEADLINE_STATUS":"Response deadline","SOLUTION_DEADLINE_STATUS":"Solution deadline","ORDER_CREATED_BY":"Created by","ACTIONS":"Actions"},"ROWS":{"EMPTY":{"CTA":"You can create a new task","LINK":"by clicking here"},"ACTION":{"VIEW":"View","EDIT":"Edit"}}},"SIDENAV":{"HEADER":{"FILTERS":"Filter tasks","CUSTOM_FILTER":"Custom filter","SAVED_FILTERS":"Filters","ACTIONS":{"CLEAR":"Clear filters","SHOW_SAVED_FILTERS":"Filters","SAVE":"Save filter"}},"FILTERS":{"FIELDS":{"FROM":"From:","TO":"To:","SELECT_DATE":"Select date","BY_APPOINTMENT":"Filters by scheduling","BY_DEADLINE":"Filters by deadline","BY_RESPONSE_DEADLINE_STATUS":"Filter by response deadline status","BY_SOLUTION_DEADLINE_STATUS":"Filter by solution deadline status","BY_STATUS":{"LABEL":"Filter by status","OPTIONS":{"ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"}},"BY_USER":{"SELECT":"Select a user"},"BY_CUSTOMER":{"LABEL":"Filter by customer","SEARCH":"Search customer","SELECT":"Select a customer"},"BY_EQUIPMENT":{"LABEL":"Filter by equipment","SELECT":"Select equipment"},"BY_LOCATION":{"LABEL":"Filter by location name","SEARCH":"Search location"},"BY_LOCATION_NOTES":{"LABEL":"Filter by location description","SEARCH":"Search description"},"BY_CUSTOMER_LABELS":"Filter by label (customer)","BY_ID":"Filter by identifier","BY_ZIPCODE":"Filter by zip code","BY_CITY":"Filter by city","BY_NEIGHBORHOOD":"Filter by neighborhood","BY_DESCRIPTION":"Filter by description","BY_TYPE":{"LABEL":"Filter by OS type","SEARCH_LABEL":"Select OS type","SEARCH":"Search OS type"},"CREATED_BY":{"LABEL":"Search by user who created the task","SEARCH":"Search by task creator"},"BY_LABELS":{"LABEL":"Filter by labels","NO_LABEL":"No label"},"BY_SITUATION":"Filter by situation","BY_EMPLOYEE":{"LABEL":"Filter by employee","SEARCH":"Search by employee","NO_EMPLOYEE":"No employee","INACTIVE":" (Inactive)"},"BY_RATE":{"LABEL":"Filter by rating","NO_RATE":"No rating","RATINGS":{"ONE_STAR":"Poor","TWO_STARS":"Bad","THREE_STARS":"Fair","FOUR_STARS":"Good","FIVE_STARS":"Excellent"}},"BY_TERRITORY":{"LABEL":"Filter by territory","SEARCH":"Search territory","SEARCH_LABEL":"Select territory"},"BY_SUBTERRITORY":{"LABEL":"Filter by subterritory","SEARCH":"Search subterritory","SEARCH_LABEL":"Select subterritory"}}},"CUSTOM_FILTERS":{"NEW_FILTER":"New filter","EDIT_FILTER":"Edit filter","FILTER_NAME":"Filter name","SAVE":"Save","EDIT":"Edit","LIST":{"DEFAULT":{"LABEL":"Default filters","FILTERS":{"OUT_OF_TIME":"Tasks out of time","WITHOUT_EMPLOYEE":"Tasks without employee","UNFINISHED_FROM_PAST":"Unfinished tasks from the past"}},"CUSTOM":"Custom filters","REMOVE":"Remove","REMOVE_DIALOG":{"TITLE":"Delete filter","CONTENT":"Are you sure you want to delete this filter: {{ filterName  }}?","OK":"Delete","CANCEL":"Cancel"}}}},"MODAL":{"ERROR":{"TITLE":"Error","CONTENT":"It was not possible to attach the file. Please do not use special characters (/[<>!{}=\';]|?:.) in the file name.","OK":"OK"}},"DIALOG":{"TITLES":{"NEW":"New task","EDIT":"Edit task","VIEW":"View task"},"OS_ID":"Work order identifier","CLOSE":"Close","TEST_NEW_LAYOUT":"Test new layout","FEEDBACK_FORM":"We are revamping the work order. <a href=\\"https://forms.gle/ujDQt6FqvmmoqHpP8\\" target=\\"_blank\\">Click here</a> to leave your contribution.","FEATURE_FLAGS_WARNING":{"TEST_NOW":"Test now","FORM":"Discover the new experience in filling out forms - easier, faster and more intuitive than ever! <strong>Official launch on 30/05/2024.</strong>"},"FORM":"Form","LABELS":{"TITLE":"Labels","MANAGE":"Manage labels","EMPTY":"No labels created, only admins can create labels.","SEARCH":"Search labels ...","LIMIT_COUNT":"{{ length }} of {{ limit }} tags","LIMIT_EXCEEDED":"Maximum tag limit was exceeded ({{ length }} of {{ limit }}).","NEW":"Create new label","CREATE":"Create","EDIT":"Edit","UPDATE":"Refresh","BACK":"Go back","NAME":"Name","LABELS_UPDATED":"The labels were successfully updated.","TASK_LOCKED":"This task is blocked and cannot be changed."},"ACTIONS":{"SAVE":"Save","CREATE":"Create","ACTIVITY_REPORT_LINK":"Task report link","VISIT_REPORT_LINK":"Visit report link","VISIT_REVIEW_LINK":"Visit Review Link","SEND_TO_CONTA_AZUL":"Send to Conta Azul","SEND_TO_OMIE":"Send to Omie","SELECT_THE_ACCOUNT":"Select the Omie account you want to export the task","SEND_REPORT_LINK":"Send report link","COPY_LINK":"Copy link","SEND_RATING_LINK":"Send task rating link","COPY_VISIT_REPORT_LINK":"Copy report link","OPEN_REPORT":"Open report","OPEN_EVALUATION_LINK":"Open evaluation link","SHARE_REPORT_LINK":"Share report link","SHARE_BY_EMAIL":"Share by e-mail","LOCATION_EMAILS":"Location emails","LOCATION_NO_HAVE_EMAILS":"This location does not have emails.","CUSTOMER_NO_HAVE_EMAILS":"This customer does not have emails.","LOCATION_NO_HAVE_CONTACTS":"This location does not have contacts.","CUSTOMER_NO_HAVE_CONTACTS":"This customer does not have contacts.","CUSTOMER_EMAILS":"Customer Emails","SHARE_BY_WHATSAPP":"Share by WhatsApp","CONTACTS_BY_LOCATION":"Contacts by location","CUSTOMER_CONTACTS":"Customer contacts","PRIMARY":"- Primary","SEND_TO_ANOTHER_CONTACT":"Send to another contact","ARCHIVE_TASK":"Archive task","CANT_ARCHIVE_LOCKED":"It\'s not possible to archive/unarchive tasks in a locked service order.","ARCHIVE_FORM":"Archive form","UNBUNDLING_FORM":"Unarchive form","ATTACHMENTS_VIEW_ORIGINAL":"See original attachment","COPY_EVALUATION_LINK":"Copy task rating link","COPY_TRACKING_LINK":"Copy tracking link","COPY":"Copy task","DELETE_TASK":"Delete","OPTIONS":"options","PRINT":"Print","EXPORT_PDF":"Export order to Pdf","SEND_EMPLOYEE_LOCATION_LINK":"Send employee location link","SEND_ESTIMATED_SCHEDULE":"Send service hours","SEND_REPORTS_LINK":"Send task report link","SEND_NEW_REPORTS_LINK":"Send new task report link","OPEN_REPORTS":"Open report","SHARE_LOCATION":"Share location with customer","UNARCHIVE_TASK":"Unarchive task","UNWATCH_TASK":"Block notifications","WATCH_TASK":"Allow notifications","WHATSAPP_MESSAGE":"Hi {{ customer }}!\\n\\nHere is the report of work order number {{ identifier }} - {{ service }} performed by {{ company }} company.\\n\\n{{ link }}","WHATSAPP_EVALUATION_MESSAGE":"Hi {{ customer }}!\\n\\nHere is the evaluation link of work order number {{ identifier }} - {{ service }} performed by {{ company }} company.\\n\\n{{ link }}","WHATSAPP_SEND_CONTACT":"Send to a contact","SEND_VIA_WHATSAPP":"Send via WhatsApp","ALERTS":{"EXPORT_DATA":{"TITLE":"Export tasks","CONTENT":"You will reveive the task export at: <b>{{ email }}</b>.<br/><br/> It may take a while during peak hours, ok?","CONFIRM":"Send data export to an e-mail","CANCEL":"Cancel","CANT_EXPORT":"Unable to perform the exportation"},"CANT_CREATE":"You don\'t have permission to create tasks.","CANT_EDIT":"You don\'t have permission to edit tasks."},"WARNINGS":{"CUSTOMER_NOT_HAVE_EMAIL":"Customer doesn\'t have an email","RATE_TASK_WITHOUT_EMPLOYEE":"You cannot avaliate activities without a collaborator"}},"TABS":{"GENERAL":{"TITLE":"General","ORDER_ADDRESS":"Work order address","CUSTOMER":{"TOTAL_VIEWS":"Total of tasks","AVERAGE_RATING":"Average rating","OMIE_ACCOUNT":"Customer imported from Omie account","LAST_REVIEW":"Last rating","PHONES":"Phones","EMAILS":"Emails","SCHEDULED_TASKS":"There are <b>{{ count }} tasks scheduled</b> for the customer in the coming days","SCHEDULED_TASK":"There is <b>{{ count }} task scheduled</b> for the customer on {{ date }}","SHOW_MORE":"View more","SHOW_LESS":"View less","CLEAR":"Clear customer"},"FIELDS":{"IDENTIFIER":{"LABEL":"Identifier","ERRORS":{"REQUIRED":"Identifier required","IN_USE":"Identifier already in use","CHARACTER_INVALID":"The \'#\' character cannot be inserted"}},"SERVICE":{"LABEL":"OS type","SELECT":"Select a type","SEARCH":"Search OS type ...","DURATION":"- {{ duration }} minutes","ERRORS":{"REQUIRED":"OS type required"}},"DEADLINE":{"LABEL":"Deadline","ERRORS":{"INVALID":"Invalid date"}},"CUSTOMER":{"LABEL":"Customer","NOT_FOUND":"No customers found","ADD":"No customers found, add new customer?","REGISTER":"Create customer","ENTER_VALUE":"Customer must be selected or created by clicking the button <i class=\'md-accent-fg icon icon-account-plus s14\'></i>","OMIE_TOAST_SUCCESS":"Customer {{name}} successfully imported from Omie!","OMIE_UPDATE_SUCCESS":"Customer data {{ogName}} updated with Omie customer {{newName}} successfully!","OMIE_TOAST_FAIL":"Unable to import this customer, check its Omie credentials and try again later.","ERRORS":{"REQUIRED":"Customer required","ADD_TASK_DISABLED_FOR_CORPORATE_CUSTOMER":"Cannot post task to a customer location <b>{{ customerName }}</b>."}},"CUSTOMER_LOCATION":{"LABEL":"Location","NOT_FOUND":"No location found","ADD":"No location found for the customer, do you want to add a new location?","REGISTER":"Register location","ENTER_VALUE":"Location must be selected","CLEAR":"Clear location","ERRORS":{"REQUIRED":"Location is required"},"NO_LOCATIONS":{"TEXT":"This client does not yet include locations.","LINK":"Click here to create a location at:"}},"CUSTOMER_ADDRESS":{"LABEL":"Customer address","DISTANCE":"{{ distance }} km away","HINT":"Search an address, example: Rua dos Pinheiros, 383 - São Paulo","ENTER_VALUE":"Enter the customer\'s address in the field above <i class=\'md-accent-fg icon icon-arrow-up-bold s14\'></i>","CLEAR":"Clear customer address","ERRORS":{"ADDRESS_NOT_FOUND":"Unable to find the address, try again.","REQUIRED":"Customer address required","NUMBER_NOT_SPECIFIED":"Address number not specified."}},"COMPLEMENT":{"LABEL":"Additional info","ERRORS":{"VALID":"Complement must not contain more than 50 characters"}},"DOCUMENT":{"LABEL":"Social Security Number / EIN","ERRORS":{"INVALID_CPF":"Invalid Social Security Number","INVALID_CNPJ":"Invalid EIN","NUMBER_DUPLICATED":"Duplicated Social Security / EIN number"}},"ZIPCODE":{"LABEL":"Zip code","ERRORS":{"REQUIRED":"Zip code required"}},"CITY":{"LABEL":"City","ERRORS":{"REQUIRED":"City required"}},"STATE":{"LABEL":"state","ERRORS":{"REQUIRED":"State required"}},"NEIGHBORHOOD":{"LABEL":"Neighborhood"},"STREET":{"LABEL":"Street","ERRORS":{"REQUIRED":"Street required"}},"NUMBER":{"LABEL":"Number","ERRORS":{"REQUIRED":"Number required"}},"LOCAL":{"LABEL":"Local","LAT_LONG":"latitude: {{ lat }}, longitude {{ long }}"},"EMAIL":{"LABEL":"Email","HINT":"Primary email","SELECT_TYPE":"Email type","REMOVE":"Remove email","ADD":"Add one more email","ERRORS":{"PATTERN":"Invalid Email format"}},"PHONE":{"CODE":"Code","LABEL":"Telephone","HINT":"Primary phone","SELECT_TYPE":"Phone type","REMOVE":"Remove phone","ADD":"Add one more phone","ERRORS":{"NUMBER_INVALID":"Invalid phone format"}},"CUSTOMER_NOTES":{"LABEL":"Customer notes"},"DEADLINE_CONTRACT":{"LABEL":"Term contract","SELECT":"Term contract","SEARCH":"Search for a contract...","NO_SLA_CONTRACT":"Can\'t find term contract"},"DESCRIPTION":{"LABEL":"Work order description","ERRORS":{"MAX_LENGTH":"This field should contain no more than {{ expectedLength }} characters, but it has {{ receivedLength }}."},"DEFAULT_FROM_OS":{"NAME":"Name: ","SUBJECT":"Task: ","EMAIL":"Email: ","PHONE":"Phone: ","NUMBER":"Number: ","DATE":"Date: "}},"EMPLOYEE":{"LABEL":"Employee","SELECT":"Select an employee","SEARCH":"Search employee...","NO_EMPLOYEE":"No employee","INACTIVE":"Inactive","ABSENT":"Absent","GREATER_THAN_EQUAL_1KM":" - {{ distance }} km away","LESS_THAN_1KM":" - {{ distance }} m away","ADD_TASK":{"MESSAGE":"Add {{ description }} as the OS type performed?","CONFIRM":"Yes"},"ERRORS":{"DOES_NOT_PERFORM":"Employee does not perform <b>{{ serviceDescription }} tasks</b>","SECONDARY_EMPLOYEES_DOES_NOT_PERFORM":"Os Colaboradores <b>{{ notSkilledEmployees }}</br> não realiza atividades do tipo <b>{{ serviceDescription }}</b>","ALREADY_IN_ACTIVITY":"This employee is in more than one task at the same time","REQUIRED":"Employee is required"}},"SECONDARY_EMPLOYEES":{"LABEL":"Other employees","SELECT":"Select other employees","SEARCH":"Search employees...","NO_EMPLOYEE":"No employee","ERRORS":{"SECONDARY_EMPLOYEES_LIMIT":"An activity can have a maximum of 10 secondary employees"}},"DURATION":{"LABEL":"Task duration","ERRORS":{"REQUIRED":"Duration required","PATTERN":"Duration must be a number","MIM":"Minimum duration of 1 minute","MAX":"Maximum duration 999 minutes"}},"SCHEDULED_DATE":{"LABEL":"Scheduled date","ERRORS":{"MIN":"Invalid retroactive date","INVALID":"Invalid date","REQUIRED":"Date required","CREATED_AT_IS_AFTER_SCHEDULING_DATE":"The date of the visit cannot be before the date of creation of the task","MUST_BE_NULL":"There cannot be an appointment date"}},"SCHEDULED_TIME_FORMAT":{"LABEL":"Scheduled time","ERRORS":{"REQUIRED":"Time format is required"}},"START_TIME_FORMAT":{"LABEL":"Start time","ERRORS":{"REQUIRED":"Time format is required"}},"COMPLETED_TIME_FORMAT":{"LABEL":"End time","ERRORS":{"REQUIRED":"Time format is required"}},"TIMEABLE_VISIT":{"LABEL":"Scheduled time","ERRORS":{"INVALID":"Invalid time","GREATER_12_HOURS":"The time must be less than 12 hours","MINOR_1_HOUR":"The time to be greater than 1 hour"}},"TASK_DESCRIPTION":{"LABEL":"Task observation","ERRORS":{"MAX_LENGTH":"This field should contain no more than {{ expectedLength }} characters, but it has {{ receivedLength }}."}},"SITUATION":{"LABEL":"Status"},"STARTED_AT":{"LABEL_DATE":"Start Date","LABEL_TIME":"Start Time","ERRORS":{"REQUIRED_DATE":"Date is mandatory","REQUIRED_TIME":"Time is mandatory","INVALID_DATE":"Invalid date","INVALID_TIME":"Invalid time","LESS_THAN":"Date smaller than creation","TIME_IN_FUTURE":"Start cannot be greater than current date/time","CREATED_AT_IS_AFTER_STARTED_AT":"The date/time cannot be less than the OS creation date/time","TIME_MUST_HAVE_DATE":"The date cannot be without a time","DATE_MUST_HAVE_TIME":"The time cannot be without a date","GREATER_12_HOURS":"The time must be less than 12 hours","MINOR_1_HOUR":"The time to be greater than 1 hour"}},"COMPLETED_AT":{"LABEL_DATE":"End Date","LABEL_TIME":"End Time","ERRORS":{"REQUIRED_DATE":"Date is mandatory","REQUIRED_TIME":"Time is mandatory","INVALID_DATE":"Invalid date","INVALID_TIME":"Invalid time","MUST_BE_GREATER":"The time of completion must be greater than the time of beginning","TIME_IN_FUTURE":"Completion cannot be greater than the current date/time","TIME_MUST_HAVE_DATE":"The date cannot be without a time","DATE_MUST_HAVE_TIME":"The time cannot be without a date","GREATER_12_HOURS":"The time must be less than 12 hours","MINOR_1_HOUR":"The time to be greater than 1 hour"}},"REPORTED_REASON":{"LABEL":"Reason for Impediment","PLACEHOLDER":"Select the reason for the impediment","ERRORS":{"REQUIRED":"Impediment reason required"}},"DONE_DESCRIPTION":{"LABEL":"Completion description","PLACEHOLDER":"Describe conclusion here ..."},"CANCELED_DESCRIPTION":{"LABEL":"Cancellation description","PLACEHOLDER":"Describe the reason for cancelling here ..."},"IMPEDIMENT_DESCRIPTION":{"LABEL":"Description of impediment","PLACEHOLDER":"Describe the reason for the impediment here ..."}},"MODEL":{"CONTACT_TYPE":{"WORK":"Work","HOME":"House","PERSONAL":"Personal","MOBILE":"Cell phone","PRIMARY":"Main"}},"VISIT":{"TITLE":"Visit {{ index }}","RECEIVED_AT":"Received on {{ date }}","VIEWED_AT":"Viewed on {{ date }}","ARCHIVED":"Archived","CTA":"add another task","ERRORS":{"MUST_BE_FINISHED":"To add a <b>new visit</b>, the previous ones must be completed, canceled or impeded"}}},"DEADLINES":{"TITLE":"Deadlines","INFO":"Deadlines are calculated according to the <b>deadline contract</b> chosen for this task.","INFO_CONTRACT":"Contract Information","NO_DEADLINE":"This task has no defined deadline","MODEL":{"CONTRACT_SLA":{"LABEL":"Name"},"OFFICE_HOURS":{"LABEL":"Office Hours","CUSTOMIZED":"Customized","NO_CUSTOMIZE":"Continuous"},"CONSIDER_HOLIDAYS":{"LABEL":"Consider holidays?","CONSIDER":"Yes","NO_CONSIDER":"No"},"RESPONSE_DEADLINE":{"LABEL":"Response time"},"RESPONSE_DEADLINE_RISK":{"LABEL":"Response risk after"},"SOLUTION_DEADLINE":{"LABEL":"Solution time"},"SOLUTION_DEADLINE_RISK":{"LABEL":"Solution risk after"},"CONSIDERED_DAYS":{"LABEL":"Days Considered in the contract","TO":"to","DAYS":{"MONDAY":"Monday -","TUESDAY":"Tuesday -","WEDNESDAY":"Wed -","THURSDAY":"Thursday -","FRIDAY":"Friday -","SATURDAY":"Saturday -","SUNDAY":"Sunday -","NOT CONSIDERED":"N/A"}},"RESPONSE":{"TITLE":"Response deadline","COMPLETED_AT":{"IN_PROGRESS":"Awaiting completion","LABEL":"Completed at"},"DEADLINE_AT":{"LABEL":"Response deadline Reply Limit"},"SITUATION_DEADLINE":{"LABEL":"Deadline situation"},"REASON_VIOLATION":{"LABEL":"Violation reason","LABEL_NOT_VIOLED":"Deadline not Violated","LINKED_BY_ENTERPRISE":"Attributed by {{ enterpriseAccountName }}","DISABLED_BY_ENTERPRISE_TOOLTIP":"Changes cannot be made as the client has attributed this preference.","ERRORS":{"REQUIRED":"Violation reason is required"}}},"SOLUTION":{"TITLE":"Solution deadline","COMPLETED_AT":{"IN_PROGRESS":"Awaiting completion","LABEL":"Completed at"},"DEADLINE_AT":{"LABEL":"Solution deadline Reply Limit"},"SITUATION_DEADLINE":{"LABEL":"Deadline"},"REASON_VIOLATION":{"LABEL":"Violation reason","LABEL_NOT_VIOLED":"Deadline not violated"}}}},"LOCATION":{"TITLE":"Location","SEARCH_ADDRESS":{"LABEL":"Search by address","NO_ADDRESS_FOUND":"No address found.","ADDRESS_EXAMPLE":"To update location, look for an address, example: Rua dos Pinheiros, 383 - São Paulo"},"SET_TO_EMPLOYEE":"Consider employee location","SET_TO_CUSTOMER":"Consider customer location","CHANGE_CUSTOMER_ADDRESS":{"MESSAGE":"The geolocation (latitude and longitude) for this work order has been changed. Do you want to permanently change location for <b>{{ customerName }}</b> ?","OK":"Yes"},"MAP":{"TASK_LOCATION":"Task location","LAYERS":{"STANDARD":"Pattern","SATELLITE":"Satellite","ROADMAP":"Roads","TERRAIN":"Ground"}}},"FORMS":{"TITLE":"Forms","FORM":"Form","ARCHIVED":"Archived","ARCHIVE":"Archive","UNARCHIVE":"Unarchive","ADDED_AT":"Added on {{ createdAt }}","REPLY":"Answer form","EMPTY":"This OS type <b>has no linked forms</b> .","SEARCH":"Search form ...","UNANSWERED":"Work order has no completed forms.","RELOAD":"Reload form","RELOAD_DISABLED":"Only forms in progress can be reloaded.","RATING":"(Rating - Visit {{ index }})","EQUIPMENT":"Equipment","CLICK_OR_DROP_IMAGES":"Drop files here or click to upload","HINT_MESSAGE":"Maximum image size 10MB or 50MB For videos","NOT_SUPPORTED_FILE_DRAG":"File not supported by your browser","LOADING_PICTURE":"Loading image","VIEW_ORIGINAL":"View original","REMOVE_ANSWER":"Remove answer","UN_ARCHIVE_FORM":"{{ action }} form","EQUIPMENT_TAB":"equipments tab.","NO_ITEMS":"Equipment forms are now displayed in the ","CLICK_ON_OPTION":"To do so, click on the option See answered forms located in the 3 dots (...) to the right of the equipment.","MULTIPLE_PICTURES":{"WARNING":"Add up to 5 images with up to 10MB each."},"SCORE":{"TITLE":"Score","TOTAL":"Total","NO_VALUE":"no value"},"SIGNATURE":{"LOADING":"Loading signature","CONFIRM":"Confirm signature","REMOVE":"Remove signature","NO":"No signature","CANCEL":"Cancel","EDIT":"Edit signature","CLEAR":"Clear signature","ADD":"Add signature"},"ALERTS":{"DELETE_FORM":{"MESSAGE":"Are you sure you want to delete the form <b>{{ formName }}</b>?","CONFIRM":"Yes","CANCEL":"Better not"},"REMOVE_ANSWER":{"MESSAGE":"Are you sure you want to remove this answer?","CONFIRM":"Yes","CANCEL":"No"},"UN_ARCHIVE_FORM":{"MESSAGE":"Are you sure you want to <b>{{ action }}</b> the form \'<b>{{ formName }}</b>\'?","CONFIRM":"Yes","CANCEL":"Better not"}},"VALIDATOR":{"REQUIRED_ANSWERS":"Form {{ formName }} (required questions are unanswered)","FORM_REQUIRED":"Form {{ formName }} required"},"ERRORS":{"MAXIMUM_CHARACTERS":"Maximum of {{ limit }} characters"},"IN_PROGRESS":"In progress","DONE":"Done","IN_PROGRESS_ALERT":"Forms in progress cannot be edited.","LOCK_DATE_AND_TIME_CHANGE":"It is not allowed to change the date/time of an accepted appointment suggestion."},"COMMENTS":{"TITLE":"Comments","WRITE_A_COMMENT":"Write a comment","NO_COMMENTS":"No comments have been created.","COMMENT_TO_COLLABORATORS":"Comment for collaborators","COMMENT_TO_MANAGER":"Comment for managers","COMMENT_TO_INTERNAL":"Internal comment","COMMENT_TO_CORPORATE":"Comment for ","COMMENT_TO_CORPORATE_BY_COLLABORATOR":"Contributor comment","COMMENT_TO_CORPORATE_BY_MANAGER":"Manager comment","COMMENT_TO_PUBLIC":"Comment for everyone","WRITE_YOUR_MESSAGE_HERE":"Write your message here","WRITE_A_MESSAGE":{"LABEL":"Write a comment for the work order ...","MAX_LENGTH":"Message can have a maximum of 400 characters."},"VISUALIZATION":"Visualization:","PRESS_TO_SEND":"Press Enter to send and Shift + Enter to skip line","DELETE":"Delete","CLIENT":"Customer","TYPE":{"PUBLIC_MESSAGE":"Public comment","TEAM_MESSAGE":"Comment for collaborators","MANAGER_MESSAGE":"Comment to managers","CORPORATE_MESSAGE":"Comment for {{ name }}","COLLABORATOR_MESSAGE":"Comment for collaborators"},"TOOLTIP_TYPE":{"PUBLIC_VISIBILITY":"Visible to everyone","TEAM_VISIBILITY":"Visible only to the team","MANAGER_VISIBILITY":"Visible to managers only","CORPORATE_VISIBILITY":"Visible only to managers and {{ name }}","COLLABORATOR_VISIBILITY":"Visible only to collaborators"},"DELETED_MESSAGE":"This message has been deleted.","COMMENTS_STARTED":"Conversation started at ","LOAD_MORE":"Load more comments","TOASTS":{"COMMENT_DELETED":"Comment deleted successfully."}},"HISTORY":{"TITLE":"History","NO_HISTORY":"This work order has no history.","OPTIONS":"options","SHOW_TIMELINE":"Display timeline","GEOGRAPHIC_POSITION":"Geographic location:","OFFLINE_CHANGE":"Offline change - submitted on","TIMELINE":{"SELECT":"Select task history","TASK_CREATED":{"EVENT":"{{ name }} created the task"},"TASK_ARCHIVED":{"TITLE":"Archived task","TEXT":"{{ name }} <b>archived</b> the task <b>it will not appear</b> on the employee’s calendar.","EVENT":"{{ name }} archived the task"},"TASK_UNARCHIVED":{"TITLE":"Unarchived task","TEXT":"{{ name }} has <b>unarchived</b> the task and it <b>will appear</b> on the employee’s calendar again.","EVENT":"{{ name }} unarchived the task"},"SCHEDULE_CHANGED":{"TITLE":"Date of service changed","TEXT":"{{ name }} changed the service date from <b>{{ fromDate }}</b> to <b>{{ toDate }}</b> .","EVENT":"{{ name }} changed the service date"},"EMPLOYEE_CHANGED":{"TITLE":"Employee changed","TEXT":"{{ name }} changed the employee from <b>{{ previousEmployee }}</b> to <b>{{ currentEmployee }}</b> .","EVENT":"{{ name }} changed the employee"},"EMPLOYEE_ASSIGNED":{"TITLE":"Assigned employee","TEXT":"{{ name }} assigned employee <b>{{ employeeName }}</b> to the task.","EVENT":"{{ name }} assigned an employee"},"EMPLOYEE_UNASSIGNED":{"TITLE":"Employee removed","TEXT":"{{ name }} removed employee <b>{{ employeeName }}</b> from the task.","EVENT":"{{ name }} removed the Employee"},"STATUS_CHANGED":{"TITLE":"Status changed","TEXT":"Task status has been changed.","EVENT":"{{ name }} changed status","DISTANCE_DESCRIPTION":"<b>{{ displayDistance }} {{ displayDistanceName }}</b> away from the task location"},"STATUS_DECRIPTION_CHANGED":{"TITLE":"Description of the amended conclusion","TEXT":"The description of the conclusion has been changed.","EVENT":"{{ name }} changed the description of the conclusion"},"TASK_RATING":{"TITLE":"Task rating","EVENT":"The customer {{ customerName }} has rated the service provided."},"SENT_BY":{"BROWSER":"Sent from  the browser","CELLPHONE":"Sent by mobile","ROUTE_PLANNER":"Updated by automatic route planner","FIELD_CONTROL":"Updated by the system","CONTROL_PANEL":"(Control panel)","ENTERPRISE":"Updated by the client {{ corporateAccount }}","GANDALF":"Updated by the automatic rewrite"}}},"MATERIALS":{"TITLE":"Materials","HINT":"To ensure a better experience, we have migrated <span class=\'tw-font-medium\'>\'Materials\'</span> to <span class=\'tw-font-medium\'>\'Products\'</span>. Soon, the <span class=\'tw-font-medium\'>\'Materials\'</span> tab and its respective module will be deactivated. <a href=\'https://app.fieldcontrol.com.br/#/materiais\' class=\'hover-link\'><span class=\'tw-text-color-primary tw-font-medium tw-cursor-pointer go-to-links\'>Click here</span></a> to learn more!","SEARCH":{"LABEL":"Search materials","NOT_FOUND":"Material not found","HINT":"Search by material name"},"LINKED_MATERIALS":"Materials linked to this service order:","QUANTITY":"Quantity of material","UNLINK_MATERIAL":"Unlink material","UNLINK_ALERT":{"MESSAGE":"Are you sure you want to unlink this material?","YES":"Yes","NO":"No"},"REQUIRED":"This field is required","PATTERN":"This field must be a integer number"},"PRODUCTS":{"TITLE":"Products","SEARCH_CUSTOMER":"Search customer","INFO":"The products used are counted in the total value of this task.","INFO-STOCK":"Visualize the products used in this task.","SEARCH_PRODUCT":"Search by product name","SEARCH_BY_NAME":"Search by name","SEARCH_BY_PRODUCT_OR_STORAGE":"Search for a product or storage","LINKED_PRODUCTS":"Linked products","PRODUCTS_USED":"Used products","PRODUCTS_VALUE":"Total value in products:","SERVICES_VALUE":"Total value in services:","TOTAL_VALUE":"Total value of the service order:","NO_LINKED_PRODUCTS_FOUND":"No linked products found.","NO_UTILIZED_PRODUCTS_FOUND":"No used product found.","NO_PRODUCTS_FOUND":"No products found.","LINK":"Link","LINK_PRODUCTS":"Link products","REGISTER_PRODUCT":"Register product","VIEW_PRODUCT_DETAILS":"View Product Details","RETURN_PRODUCT":"Return Products","SEE_PRODUCT_MOVEMENTS":"View Movements","OMIE_ACCOUNT":"Product imported from Omie account","MEASURE":{"milliliter":"Milliliter","centimeter":"Centimeter","kilogram":"Kilogram","gram":"Gram","liter":"Liter","unity":"Unity","meter":"Meter","square-meters":"Square meters","cubic-meters":"Cubic meters","tons-refrigeration":"Tons of refrigeration","dislocation":"Displacement","cjt":"CJT","others":"Others","null":"Unity"},"SAVE_PRODUCTS":"Save","LINKED_SUCESS":"Product linked successfully.","YOU_CAN_STILL_SELECT":"You can still select {{ selectedProducts }} products to link to this task.","MAXIMUM_LIMIT_REACHED":"Maximum limit of products per task reached.","MAXIMUM_LIMIT_REACHED_TOOLTIP":"Limit of selected products reaching.","VALUE":"Value","QUANTITY":"Quantity","REQUIRED":"Field is required","VALUE_REQUIRED":"Value is required","INVALID_CHARACTER":"Invalid character","MIN_NUMBER_ERROR":"Quantity must be greater than 1","VALUE_MIN_NUMBER_ERROR":"Value must be greater or equal to 0","MAX_LENGTH":"Max length exceeded","ALREADY_LINKED":"Product already linked","LOADING":"Loading products...","TABLE":{"NAME":"Name","QUANTITY":"Quantity","STORAGE":"Storage","UNIT_VALUE":"Unit value","TOTAL_VALUE":"Total value","ACTIONS":"Actions"},"NAVIGATION":{"PREVIOUS":"Previous","NEXT":"Next","SHOWING_FROM":"Showing from","TO":"to","OF":"of","ITEMS":"items."},"CONFIRM_DELETE_DIALOG":{"TITLE":"Remove product","MESSAGE":"Are you sure you want to remove the product <b>{{ name }}</b>?","YES":"Yes","NO":"No","SUCESS":"Product removed successfully."},"PRODUCTS_TO_ORDER":"products to link to this service order."},"SERVICES":{"TITLE":"Services","INFO":"Performed services are accounted for in the total value of this task.","SEARCH_SERVICE":"Search by service name","LINKED_SERVICES":"Performed services","PRODUCTS_VALUE":"Total value in products:","SERVICES_VALUE":"Total value in services:","TOTAL_VALUE":"Total order value:","NO_LINKED_SERVICES_FOUND":"No linked services found.","NO_SERVICES_FOUND":"No services found.","LINK":"Link","LINK_SERVICES":"Link services","SAVE_SERVICES":"Save","LINKED_SUCESS":"Service linked successfully.","YOU_CAN_STILL_SELECT":"You can still select {{ selectedServices }} services to link to this service order.","MAXIMUM_LIMIT_REACHED":"Maximum limit of services per service order reached.","MAXIMUM_LIMIT_REACHED_TOOLTIP":"Maximum number of selected services reached.","QUANTITY":"Quantity","VALUE":"Value","REQUIRED":"Quantity is required","VALUE_REQUIRED":"Value is required","INVALID_CHARACTER":"Invalid character","MIN_NUMBER_ERROR":"Quantity must be greater than 0","VALUE_MIN_NUMBER_ERROR":"Value must be greater than or equal to 0","MAX_LENGTH":"Maximum length exceeded","ALREADY_LINKED":"Service is already linked.","LOADING":"Loading services...","OMIE_ACCOUNT":"Service successfully imported from Omie account","TABLE":{"NAME":"Name","QUANTITY":"Quantity","UNIT_VALUE":"Unit value","TOTAL_VALUE":"Total value","ACTIONS":"Actions"},"NAVIGATION":{"PREVIOUS":"Previous","NEXT":"Next","SHOWING_FROM":"Showing from","TO":"to","OF":"of","ITEMS":"items."},"CONFIRM_DELETE_DIALOG":{"TITLE":"Remove service","MESSAGE":"Are you sure you want to remove the service <b>{{ name }}</b>?","YES":"Yes","NO":"No","SUCESS":"Service removed successfully."},"SERVICES_TO_ORDER":"services to link to this service order."},"STORAGES_MOVEMENTS":{"TITLE":"Movements","INFO":"Follow and perform product movements.","SEARCH_PRODUCT_OR_STORAGE":"Search for a product or storage","NEW_MOVEMENT":"New movement","REMOVAL_MOVEMENT":"Removal movements ({{ quantity }})","LOADING":"Loading services...","NO_LINKED_MOVEMENTS_FOUND":"No movements found","TABLE":{"DATE_TIME":"Date/Time","PRODUCT":"Product","QUANTITY":"Quantity","STORAGE":"Storage","TYPE":"Type","ENTRY":"Entry","REMOVAL":"Removal","SEE_MOVEMENTS":"View Movements"},"NAVIGATION":{"PREVIOUS":"Previous","NEXT":"Next","SHOWING_FROM":"Showing from","TO":"to","OF":"of","ITEMS":"items."},"SUCCESSFULLY_CREATED":"Movement created successfully.","SUCCESSFULLY_EDITED":"Movement edited successfully."},"PENDENCIES":{"TITLE":"Pendencies","HEADLINE":"Pendencies ({{ totalCount }})","ADD":"Add new pendency","LOAD_MORE":"Load more","EMPTY_STATE":"No linked pendency. Click here to create.","EMPTY_STATE_NO_PERMISSIONS":"You do not have permission to create pendencies.","ITEM":{"DESCRIPTION":"ID {{ identifier }} | Pendency Type: {{ pendencyType }}","TREATMENT_STATUS":{"AWAITING_COMPANY":"Awaiting company","AWAITING_MANAGEMENT":"Awaiting management"},"STATUS":{"OPENED":"Open","DONE":"Completed"},"TOOLTIPS":{"ASSIGNEE":"Responsible user: {{ assignee }}","NO_ASSIGNEE":"No responsible user","VIEW_PENDENCY":"Access pendency","BLOCK_ASSIGNEE":"It is not possible to change the responsible of a finished pendency.","NO_PERMISSION":"You do not have permission to change the assignee of a pendency."}},"UPDATE_PENDENCY_ASSIGNEE":{"SUCCESS":"Responsible successfully linked.","SUCCESS_UPDATE":"Responsible successfully changed.","ERROR":"An error occurred while linking the responsible. Try again later."},"SUCCESSFULLY_SAVED":"Pendency successfully created."},"EQUIPMENTS":{"TITLE":"Equipments","EQUIPMENTS":"Equipments","SEARCH":{"LABEL":"Search for equipments","NOT_FOUND":"No equipment found.","HINT":"Search by name or serial number."},"LINKED_EQUIPMENTS":{"TITLE":"Linked equipments","REMOVE":"Remove equipment","LABEL":"Search for linked equipment","LINK":"Link equipments","LINK_NEW":"Link","SELECTED":"Equipment already linked","SAVE_EQUIPMENTS":"Save","UNLINK_ALERT":{"MESSAGE":"Are you sure you want to unlink this equipment?","YES":"Yes","NO":"No"},"YOU_CAN_STILL_SELECT":"You can still select","EQUIPMENTS_TO_ORDER":"equipments to link to this work order.","MAXIMUM_LIMIT_REACHED":"Maximum limit of equipments per work order reached."},"NAVIGATION":{"PREVIOUS":"Previous","NEXT":"Next","SHOWING_FROM":"Showing from","TO":"to","OF":"of","RECORDS":"records"},"CUSTOMER_WITHOUT_EQUIPMENTS":"This location has no registered equipments.","FORMS_EQUIPMENT":{"BUTTON_OPTIONS":{"VIEW_COMPLETED_FORMS":"View completed forms","ANSWER_FORMS":"Answer forms","UNLINK_EQUIPMENT":"Unlink equipment","NO_PERMISSION_WARN":"No permission","NO_PERMISSION_WARN_CREATE_TASK":"You do not have permission to create tasks","NO_PERMISSION_WARN_EDIT_TASK":"You do not have permission to edit tasks","NO_PERMISSION_WARN_CREATE_RECURRENCE":"You do not have permission to create recurrences","NO_PERMISSION_WARN_EDIT_RECURRENCE":"You do not have permission to edit recurrences","NO_PERMISSION_WARN_CREATE_PLAN":"You do not have permission to create task plans","NO_PERMISSION_WARN_EDIT_PLAN":"You do not have permission to edit task plans"},"SEARCH_EQUIPMENTS":{"ANSWER_EQUIPMENTS_FORMS":"Answer equipment forms","REPLY":"Reply form","SEARCH_FORM":"Search form","SEARCH_FORMS_LINKED_EQUIPMENT":"Search for forms linked to this equipment.","VIEW_COMPLETED_EQUIPMENT_FORMS":"View completed forms for this equipment","FORMS_AVAILABLE":"Available forms","REQUIRED":"Required","OPTIONAL":"Optional","ANSWER":"Answer","BACK":"Back","ANSWERED_BY":"Answered by","ANSWERED_AT":"Answered at","ANSWERS":"Answers ({{ quantity }})","ALL_FORMS":"All forms","INSERT_ATTACHMENTS":"Insert attachments","STATUS":"Status","FORM_LENGTH":"{{ LENGTH }} questions"},"ARCHIVED":{"FORMS_IS_ARCHIVED":"This form is archived","TITLE":"Archive equipment form","ARE_YOU_SURE":"Are you sure you want to archive the {{ formName }} form?","NO":"No","YES":"Yes"}}},"QUOTATIONS":{"TITLE":"Quotations","INFO":"Add quotations to this work order.","LINKED":"Linked quotations ({{ quotations }}/{{ maxAllowed }})","SEE":"See quotation","REMOVE":"Remove quotation","APPROVED_AT":"Approved in {{ approvedAt }}","REFUSED_AT":"Refused on {{ refusedAt }}","NO_ITEMS":"No linked quotation, it\'s possible to link a new quotation using the search bar above.","PRODUCTS":"{{ quantity }} product(s)","SERVICES":"{{ quantity }} service(s)","VALUE":"Value: {{ value }}","SUBTOTAL":"Subtotal:","DISCOUNT":"Discount:","TOTAL":"Amount:","SEARCH":"Search for quotation","SEARCH_HINT":"Search by the name of a quotation or its identifier.","CREATE":"Register new","MAX_ALLOWED":"Maximum quotation limit per work order reached.","ARCHIVED":"Archived","LINK_CONFIRM_DIALOG":{"TITLE":"Link quotation items to the work order","DESCRIPTION":"Do you want to link the unlinked services and products from the quotation to the work order?","YES":"Yes","NO":"No"},"STATUS":{"TITLE":"Situation","PENDING":"Pending","APPROVED":"Approved","REFUSED":"Refused","EXPIRED":"Expired","CANCELED":"Cancelled"}},"ATTACHMENTS":{"TITLE":"Attachments","DROP_HERE":"Drag your files to upload","NOT_SUPPORTED_FILE_DRAG":"File not supported by your browser","ATTACHMENT_DESCRIPTION":"Limit 20 attachments per Manager Panel. There is no limit on attachments in the contributor app. </br> Maximum size of each file is 10MB or 50MB for videos and images","INSERT_FILES":"Insert files","INSERT_FILES_ALTERNATIVE":"Drag your files to upload or","SEND_FILES":"Send files","NO_ATTACHMENTS_ADDED":"No attachments have been added for this work order.","SEARCHING_ATTACHMENTS":"Fetching work order attachments.","ATTACHMENTS_LIMIT_REACHED":"Attachments limit reached to add more attachments you need to remove some first.","MAX_SIZE_FILES":"This file exceeds the 10MB limit","MAX_SIZE_BIG_FILES":"This file exceeds the 50MB limit","MIN_SIZE_FILES":"This file does not meet the minimum size of 1KB","FILES":{"MOVE_UP":"Move up","MOVE_DOWN":"Move down","SAVE_EDIT":"Save title","CANCEL_EDIT":"Cancel","NO_TITLE":"Untitled","RENAME":"Rename","SIGNATURE":"signature","EDIT_TITLE":"Edit attachment title","EDIT_CUSTOMER_NAME":"Edit customer name","OF":"in","ADDED_AT":"Created {{ date }} at {{ hour }}","EDIT":"Edit","VIEW_ORIGINAL":"View original","ARCHIVED":"Archived","ACTIONS":{"REMOVE":"Remove attachment","ARCHIVE":"Archive attachment","UNARCHIVE":"Unarchive attachment"},"ALERTS":{"REMOVE_SIGNATURE":"Are you sure you want to <strong>remove</strong> this subscription?","REMOVE_ATTACHMENT":"Are you sure you want to <strong>remove</strong> this attachment?","ARCHIVE_SIGNATURE":"Are you sure you want to <strong>archive</strong> this signature?","ARCHIVE_ATTACHMENT":"Are you sure you want to <strong>archive</strong> this attachment?","YES":"Yes","NO":"No"}},"LINK":"LINK"},"OFFLINE":{"TITLE":"Sync (beta)","NO_SYNC":"There are no syncs for this service order","INFO":"As soon as the technician gets internet, their offline synchronizations for this service order will appear here.","STATUS":{"PENDING":"Not synchronized yet","IN_PROGRESS":"Synchronizing","DONE":"Synchronized","ERROR":"Error while synchronizing"}},"ROUTES":{"TITLE":"Routes","ESTIMATED_ROUTE":"Estimated route","TOTAL_KILOMETERS":"Total kilometers: {{ kmTotal }} km","START_ROUTE":"Starting point of the route","INTERMEDIATE_ROUTE":"Intermediate point of the route","END_ROUTE":"End point of the route","COMPANY_ADDRESS":"Your company address","CUSTOMER_ADDRESS":"Customer address","MAP":{"LAYERS":{"DEFAULT":"Default","SATELLITE":"Satellite","ROADS":"Roads","GROUND":"Ground"},"CENTRALIZE":"Centralize","GROUP_VISITS":"Group services"}},"LINKS":{"TITLE":"Links"}},"WARNINGS":{"TITLE":"Warning","CANT_EDIT":"You don\'t have permission to edit tasks.","CONTENT":"Remove equipment from the client/current location to proceed with this change","BUTTON":"Close"},"EMPLOYEE_WARNING":{"TITLE":"Employees outside service region","CONTENT":"Some employees are not within the service region and will therefore be unlinked from the activity.","BUTTON":"Close"},"ROUTERIZATION":{"SUCCESS_MESSAGE":"The tasks have been successfully saved"},"LAUNCH_DIALOG":{"TITLE":"🚀 Launch of the New Service Order","DESCRIPTION":"We have great news for you! The service order creation and editing screen has been completely updated! It now features a more modern and organized design, providing a more intuitive experience and making it easier to learn. All features remain available, and to help you understand the changes, we’ve included an explanatory video below.","VIDEO_TEXT":"📺 Watch the video below to learn more!","LEFT_BUTTON":"Cancel","RIGHT_BUTTON":"Try new version"}},"TOASTS":{"FILTERS":{"CUSTOM_FILTER_SAVED":"The custom filter \'{{ filterName }}\' has been saved.","CUSTOM_FILTER_DELETED":"The custom filter \'{{ filterName }}\' has been deleted."},"GENERAL":{"CUSTOMER_REGISTERED":"Customer {{ customerName }} created."},"LOCATION":{"CUSTOMER_GEOLOCATION_UPDATED":"Done! Geolocation (latitude and longitude) has been updated for {{ customerName }}."},"SERVICES_TYPE":{"CUSTOMER_SERVICE_ADDED":"Done! The {{ serviceDescription }} OS type can now be added for {{ employeeName }}.","CUSTOMER_SERVICE_ADDED_TO_SECONDARY_EMPLOYEES":"Done! The {{ serviceDescription }} OS type can now be added for secondary employees."},"EQUIPMENTS":{"EQUIPMENT_UNLINKED":"Equipment unlinked"},"ATTACHMENTS":{"TITLE_UPDATED":"Attachment title changed.","IMAGES_UPLOADED":"The images have been sent.","SIGNATURE_REMOVED":"The signature has been removed!","SUCCESSFULLY_ARCHIVED":"The attachment has been archived!","SUCCESSFULLY_UNARCHIVED":"The attachment has been unarchived!","SUCCESSFULLY_REMOVED":"The attachment was removed!"},"FORMS":{"FORM_UPDATED":{"SUCCESS":"Form {{ formName }} {{ action }}!","FAILED":"Unable to {{ action }} the form {{ formName }}, please try again.","ARCHIVE":"Archive","ARCHIVED":"Equipment form successfully filed!","SAVE":"saved","UNARCHIVE":"Unarchive","UNARCHIVED":"Equipment form successfully unfiled!"},"FORM_CREATED":{"CREATED":"Form {{ formName }} created successfully!"},"INCOMPATIBLE_FILE":"Please select a compatible file","UPLOAD_FAILED":"Unable to send image, please try again."},"DIALOG_ACTIONS":{"LINK_COPIED":{"MESSAGE":"The {{ type }} # {{ id }} link has been copied to the clipboard.","FROM_REPORT":"of the report","TO_EVALUATION":"for task rating"},"EVALUATION_LINK_SENDED":"The rating link will be sent to {{ customerName }}\'s selected emails.","REPORT_LINK_SENDED":"The link with the task report will be sent to the customer {{ customerName }}\'s selected emails.","EMPLOYEE_LOCATION_SENDED":"The link with the employee\'s location will be sent to the customer {{ customerName }}\'s selected emails.","TASK_ARCHIVED":"Task {{ customerName }} #{{ id }} archived.","TASK_UNARCHIVED":"Task {{ customerName }} #{{ id }} unarchived.","TASK_SAVED":"Task {{ customerName }} #{{ id }} saved.","EXPORT_ERROR":"Unable to request export, please try again...","SEND_TO_EMAIL":"You will receive the export in the email: {{ email }}.","TASK_WITHOUT_EMPLOYEE":"You cannot avaliate activities without a collaborator"},"TICKETS":{"EXPIRED":"This request is either expired or has already been resolved!","ACCEPT_FAILED":"There was an error accepting the service request, please try again.","ACCEPT_FAILED_DUPLICATED":"This service request has already been accepted by another employee."},"EXPORT":{"TITLE":"PDF export requested","EXCEL_TITLE":"Excel export requested"}},"INTEGRATIONS":{"CONTA_AZUL":{"ERROR":{"NOT_PROVIDED":"Error in the product/service, make sure it was informed or has inventory in the Conta Azul.","UNAUTHORIZED":"Not authorized","INVALID_FIELD":"The sale was not created, as it may have a field: (invalid, null or unknown)"}}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/tasks/i18n/es.json',
    '{"TASKS":{"PAGE_TITLE":"Actividades","TITLE":"Actividades","TUTORIAL_VIDEO":{"TITLE":"Instrucciones","TOOLTIP":"Ver vídeo tutorial"},"FEEDBACK_FORM":"¡Prueba el módulo de inventario y optimiza la gestión de tu negocio!","ACTION_BUTTONS":{"PRINT":"Imprimir","EXPORT_PDF":"Exportar Pdf","EXPORT_EXCEL":"Exportar a Excel","RESTORE_COLUMNS":"Restaurar columnas","TOGGLE_COLUMNS":"Alternar columnas","CLEAR_FILTERS":"Limpiar filtros","FILTER":"Filtrar actividades","NEW":"Nueva actividad","CANT_CREATE":"No tienes permiso para agregar actividades","RELOAD":"Recargar"},"EXPORT_MODAL":{"TITLE":"Exportación de visitas","TITLE_PDF":"Exportación masiva de PDF","TITLE_LIMIT_EXCEEDED":"Atención","TEMPLATE":{"YES":"Sí","NO":"No","OK":"Ok, entendido","MATERIALS":"Materiales","PRODUCTS":"Productos","EQUIPMENTS":"Equipos","FORMS":"Forms","LINKS":"Links","SERVICES":"Services","TITLE":"Elija qué información se exportará junto con las visitas.","ALERT_FIRST_CONTENT":"Cuando haga clic en exportar, recibirá un enlace de descarga para la exportación en su correo electrónico","ALERT_SECOND_CONTENT":"Según la cantidad de información, la exportación puede tardar unos minutos en completarse.","ALERT_LIMIT_EXCEEDED_FIRST_CONTENT":"Solo puedes exportar hasta","ALERT_LIMIT_EXCEEDED_SECOND_CONTENT":"PDFs en masa. Utiliza los filtros disponibles en la lista para reducir la cantidad de resultados e intenta nuevamente.","CONFIRM_ACTION_CONTENT":"¿Quieres continuar con la exportación?","MATERIALS_MUST_BE_MIGRATED":"Los materiales deben migrarse a productos.","TO_KNOW_MORE":"para obtener más información y realizar la migración.","CLICK_HERE":"Haz clic aquí"}},"CHANGE_TASK_STATUS":{"ALERT_FIRST_CONTENT":"¿Estás seguro de que quieres modificar el estado de esta actividad? Es probable que","ALERT_SECOND_CONTENT":"todavía esté realizando esta actividad."},"TABLE":{"MARKINGS":{"NO_RATE":"Sin evaluar","ARCHIVED":"Archivado","DAY":{"SINGULAR":"día","PLURAL":"días"}},"COLUMNS":{"ID":"Identificador","LABELS":"Etiquetas","DATE":"Día de la cita","HOUR":"Hora de la cita","DEADLINE":"Fecha límite","CUSTOMER":"Cliente","CUSTOMER_LOCATION":"Localización","ADDRESS":"Dirección","DESCRIPTION":"Descripción","VISIT_OBSERVATION":"Observación de la visita","SITUATION":"Situación","START_DATE":"Fecha de inicio","START_HOUR":"Hora de inicio","ROUTE_DATE":"Fecha del desplazamiento","ROUTE_HOUR":"Tiempo de desplazamiento","END_DATE":"Fecha de finalizacion","END_HOUR":"Tiempo de finalización","VISIT_DURATION":"Duración de la visita","ROUTE_DURATION":"Duración del desplazamiento","DESCRIPTION_CLOSURE":"Descripción del cierre","RATE":"Calificación","COMMENT":"Comentario","TYPE":"Tipo","EMPLOYEE":"Empleado","CREATED_AT":"Creado en","RESPONSE_DEADLINE_STATUS":"Plazo de respuesta","SOLUTION_DEADLINE_STATUS":"Plazo de solución","ORDER_CREATED_BY":"Creado por","ACTIONS":"Acciones"},"ROWS":{"EMPTY":{"CTA":"Puede crear una nueva actividad","LINK":"haciendo clic aquí"},"ACTION":{"VIEW":"Ver","EDIT":"Editar"}}},"SIDENAV":{"HEADER":{"FILTERS":"Filtrar actividades","CUSTOM_FILTER":"Filtro personalizado","SAVED_FILTERS":"Filtros","ACTIONS":{"CLEAR":"Limpiar filtros","SHOW_SAVED_FILTERS":"Filtros","SAVE":"Guardar filtro"}},"FILTERS":{"FIELDS":{"FROM":"Desde:","TO":"Hasta:","SELECT_DATE":"Seleccionar fecha","BY_APPOINTMENT":"Filtros por cita","BY_DEADLINE":"Filtros por fechas límite","BY_RESPONSE_DEADLINE_STATUS":"Filtrar por plazo de respuesta","BY_SOLUTION_DEADLINE_STATUS":"Filtrar por plazo de solución","BY_STATUS":{"LABEL":"Filtrar por estado","OPTIONS":{"ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"}},"BY_USER":{"SELECT":"Seleccionar un usuario"},"BY_CUSTOMER":{"LABEL":"Filtrar por cliente","SEARCH":"Buscar cliente","SELECT":"Seleccionar un cliente"},"BY_EQUIPMENT":{"LABEL":"Filtrar por equipo","SELECT":"Seleccionar equipo"},"BY_LOCATION":{"LABEL":"Filtrar por nombre de ubicación","SEARCH":"Ubicación de búsqueda"},"BY_LOCATION_NOTES":{"LABEL":"Filtrar por descripción de la ubicación","SEARCH":"Buscar descripción"},"BY_CUSTOMER_LABELS":"Filtrar por etiquetas (cliente)","BY_ID":"Filtrar por identificador","BY_ZIPCODE":"Filtrar por código postal","BY_CITY":"Filtrar por ciudad","BY_NEIGHBORHOOD":"Filtrar por barrio","BY_DESCRIPTION":"Filtrar por descripción","BY_TYPE":{"LABEL":"Filtrar por tipo de OS","SEARCH_LABEL":"Seleccione el tipo de OS","SEARCH":"Buscar por tipo de OS"},"CREATED_BY":{"LABEL":"Filtrar por usuario que creó la tarea","SEARCH":"Búsqueda por creador del tarea"},"BY_LABELS":{"LABEL":"Filtrar por etiquetas","NO_LABEL":"Sin etiqueta"},"BY_SITUATION":"Filtrar por situación","BY_EMPLOYEE":{"LABEL":"Filtrar por empleado","SEARCH":"Buscar por empleado","NO_EMPLOYEE":"Sin empleado","INACTIVE":" (Inactivo)"},"BY_RATE":{"LABEL":"Filtrar por calificación","NO_RATE":"Sin calificación","RATINGS":{"ONE_STAR":"Terrible","TWO_STARS":"Malo","THREE_STARS":"Regular","FOUR_STARS":"Bueno","FIVE_STARS":"Excelente"}},"BY_TERRITORY":{"LABEL":"Filtrar por territorio","SEARCH":"Buscar territorio","SEARCH_LABEL":"Seleccione el territorio"},"BY_SUBTERRITORY":{"LABEL":"Filtrar por subterritorio","SEARCH":"Buscar subterritorio","SEARCH_LABEL":"Seleccione el subterritorio"}}},"CUSTOM_FILTERS":{"NEW_FILTER":"Nuevo filtro","EDIT_FILTER":"Editar filtro","FILTER_NAME":"Nombre del filtro","SAVE":"Guardar","EDIT":"Editar","LIST":{"DEFAULT":{"LABEL":"Filtros estándar","FILTERS":{"OUT_OF_TIME":"Actividades fuera del plazo","WITHOUT_EMPLOYEE":"Actividades sin empleado","UNFINISHED_FROM_PAST":"Actividades no concluidas en el pasado"}},"CUSTOM":"Filtros personalizados","REMOVE":"Eliminar","REMOVE_DIALOG":{"TITLE":"Eliminar filtro","CONTENT":"¿Estás seguro de que deseas eliminar el filtro {{ filterName }}?","OK":"Eliminar","CANCEL":"Cancelar"}}}},"MODAL":{"ERROR":{"TITLE":"Error","CONTENT":"No se pudo adjuntar el archivo. Por favor, no utilice caracteres especiales (/[<>!{}=\';]|?:.) en el nombre del archivo.","OK":"Ok"}},"DIALOG":{"TITLES":{"NEW":"Nueva actividad","EDIT":"Editar actividad","VIEW":"Ver actividad"},"OS_ID":"Identificador de orden de servicio","CLOSE":"Cerrar","TEST_NEW_LAYOUT":"Probar nuevo diseño","FEEDBACK_FORM":"Estamos renovando la orden de servicio. <a href=\\"https://forms.gle/ujDQt6FqvmmoqHpP8\\" target=\\"_blank\\">Haz clic aquí</a> para dejar tu contribución.","FEATURE_FLAGS_WARNING":{"TEST_NOW":"Probar ahora","FORM":"¡Descubre la nueva experiencia de llenado de formularios, más fácil, más rápida y más intuitiva que nunca! <strong>Lanzamiento oficial el 30/05/2024.</strong>"},"FORM":"Formulario","LABELS":{"TITLE":"Etiquetas","MANAGE":"Administrar etiquetas","EMPTY":"No hay etiquetas registradas, solo los administradores pueden registrar etiquetas.","SEARCH":"Buscar etiquetas ...","LIMIT_COUNT":"{{ length }} de {{ limit }} etiquetas","LIMIT_EXCEEDED":"Se ha excedido el límite máximo de etiquetas ({{ length }} de {{ limit }}).","NEW":"Crear nueva etiqueta","CREATE":"Crear","EDIT":"Editar","UPDATE":"Actualizar","BACK":"Volver","NAME":"Nombre","LABELS_UPDATED":"Las etiquetas se actualizaron con éxito.","TASK_LOCKED":"Esta orden de servicio está bloqueada y no se puede cambiar"},"ACTIONS":{"SAVE":"Guardar","CREATE":"Crear","ACTIVITY_REPORT_LINK":"Enlace del informe de actividad","VISIT_REPORT_LINK":"Visite el enlace del informe","VISIT_REVIEW_LINK":"Enlace de evaluación de la visita","SEND_TO_CONTA_AZUL":"Enviar a Conta Azul","SEND_TO_OMIE":"Enviar a Omie","SELECT_THE_ACCOUNT":"Seleccione la cuenta de Omie a la que desea exportar la actividad","SEND_REPORT_LINK":"Enviar enlace del informe","COPY_LINK":"Copiar enlace","SEND_RATING_LINK":"Enviar enlace de la calificación de actividad","COPY_VISIT_REPORT_LINK":"Copiar enlace del informe","OPEN_REPORT":"Abrir enlace del informe","OPEN_EVALUATION_LINK":"Abrir enlace de evaluación","SHARE_REPORT_LINK":"Compartir enlace de informe","SHARE_BY_EMAIL":"Compartir por correo electrónico","LOCATION_EMAILS":"correos electrónicos de ubicación","LOCATION_NO_HAVE_EMAILS":"Esta ubicación no tiene correos electrónicos.","CUSTOMER_NO_HAVE_EMAILS":"Este cliente no tiene correos electrónicos.","LOCATION_NO_HAVE_CONTACTS":"Esta ubicación no tiene contactos.","CUSTOMER_NO_HAVE_CONTACTS":"Esta cliente no tiene contactos.","CUSTOMER_EMAILS":"Correos electrónicos de los clientes","SHARE_BY_WHATSAPP":"Compartir por WhatsApp","CONTACTS_BY_LOCATION":"contactos por ubicación","CUSTOMER_CONTACTS":"contactos de clientes","PRIMARY":"- Primario","SEND_TO_ANOTHER_CONTACT":"Enviar a otro contacto","ARCHIVE_TASK":"Archivar atividad","CANT_ARCHIVE_LOCKED":"No es posible archivar/desarchivar actividades en una o.s. bloqueada.","ARCHIVE_FORM":"Archivar formulario","UNBUNDLING_FORM":"Desarchivar formulario","ATTACHMENTS_VIEW_ORIGINAL":"Ver archivo adjunto original","COPY_EVALUATION_LINK":"Copiar enlace de calificación de actividad","COPY_TRACKING_LINK":"Copiar enlace de rastreo","COPY":"Copiar actividad","DELETE_TASK":"Eliminar","OPTIONS":"opciones","PRINT":"Imprimir","EXPORT_PDF":"Exportar PDF del orden de servicio","SEND_EMPLOYEE_LOCATION_LINK":"Enviar enlace de ubicación del empleado","SEND_ESTIMATED_SCHEDULE":"Enviar horario de servicio","SEND_REPORTS_LINK":"Enviar enlace del informe de actividad","SEND_NEW_REPORTS_LINK":"Enviar enlace del nuevo informe de actividad","OPEN_REPORTS":"Abrir informe","SHARE_LOCATION":"Compartir ubicación con el cliente","UNARCHIVE_TASK":"Desarchivar atividad","UNWATCH_TASK":"No recibir notificaciones","WATCH_TASK":"Recibir notificaciones","WHATSAPP_MESSAGE":"¡Hola, {{ customer }}!\\n\\nA continuación se muestra el informe de la visita relacionada con la orden de servicio {{ identifier }} - {{service }} realizada por la empresa {{company }}.\\n\\n{{ link }}","WHATSAPP_EVALUATION_MESSAGE":"¡Hola, {{ customer }}!\\n\\nA continuación se muestra el enlace para calificar la actividad relacionada con la orden de servicio {{ identifier }} - {{service }} realizada por la empresa {{company }}.\\n\\n{{ link }}","WHATSAPP_SEND_CONTACT":"Enviar a un contacto","SEND_VIA_WHATSAPP":"Enviar por WhatsApp","ALERTS":{"EXPORT_DATA":{"TITLE":"Exportación de visitas","CONTENT":"Usted recibirá la exportación de visitas en el correo: <b>{{ email }}</b>.<br/><br/> A las horas puntas, eso puede tardar un poco, ¿vale?","CONFIRM":"Enviar exportación por correo","CANCEL":"Cancelar","CANT_EXPORT":"No se puede realizar la exportación"},"CANT_CREATE":"No tienes permiso para crear actividades.","CANT_EDIT":"No tienes permiso para editar actividades."},"WARNINGS":{"CUSTOMER_NOT_HAVE_EMAIL":"El cliente no tiene un correo electrónico.","RATE_TASK_WITHOUT_EMPLOYEE":"No se pueden evaluar las actividades sin un empleado"}},"TABS":{"GENERAL":{"TITLE":"General","ORDER_ADDRESS":"Dirección de la orden de trabajo","CUSTOMER":{"TOTAL_VIEWS":"Visitas totales","AVERAGE_RATING":"Puntuación promedio","OMIE_ACCOUNT":"Cliente importado de la cuenta Omie","LAST_REVIEW":"Última calificación","PHONES":"Teléfonos","EMAILS":"Correos electrónicos","SCHEDULED_TASKS":"Hay <b>{{ count }} actividades programadas</b> para el cliente los próximos días","SCHEDULED_TASK":"Hay <b>{{ count }} actividad programada</b> para el cliente el {{ date }}","SHOW_MORE":"Ver más","SHOW_LESS":"Ver menos","CLEAR":"Limpiar cliente"},"FIELDS":{"IDENTIFIER":{"LABEL":"Identificador","ERRORS":{"REQUIRED":"Se requiere un identificador","IN_USE":"Identificador en uso","CHARACTER_INVALID":"El carácter \'#\' no puede ser insertado"}},"SERVICE":{"LABEL":"Tipo de OS","SELECT":"Seleccione un tipo de OS","SEARCH":"Buscar tipo de OS ...","DURATION":"- {{ duration }} minutos","ERRORS":{"REQUIRED":"Se requiere el tipo de OS"}},"DEADLINE":{"LABEL":"Fecha límite","ERRORS":{"INVALID":"La fecha no es válida"}},"CUSTOMER":{"LABEL":"Cliente","NOT_FOUND":"No se han encontrado clientes","ADD":"No se han encontrado clientes, ¿agregar un nuevo cliente?","REGISTER":"Registrar cliente","ENTER_VALUE":"El cliente debe ser seleccionado o puede crearse haciendo clic en el botón <i class=\'md-accent-fg icon icon-account-plus s14\'></i>","OMIE_TOAST_SUCCESS":"Client {{name}} importado con éxito de Omie!","OMIE_UPDATE_SUCCESS":"Dados del cliente {{ogName}} actualizados con éxito con los del cliente de Omie {{newName}}!","OMIE_TOAST_FAIL":"No se puede importar este cliente, verifique sus credenciales de Omie e intente nuevamente más tarde.","ERRORS":{"REQUIRED":"Se requiere el cliente","ADD_TASK_DISABLED_FOR_CORPORATE_CUSTOMER":"No se pueden publicar atividade en una ubicación de cliente <b>{{ customerName }}</b>."}},"CUSTOMER_LOCATION":{"LABEL":"Ubicación","NOT_FOUND":"No se encontró ninguna ubicación","ADD":"Nenhum localização encontrada para o cliente, deseja adicionar uma nova localização?","REGISTER":"Registrar ubicación","ENTER_VALUE":"Se debe seleccionar la ubicación","CLEAR":"Borrar ubicación","ERRORS":{"REQUIRED":"Se requiere la ubicación"},"NO_LOCATIONS":{"TEXT":"Este cliente aún no incluye localización.","LINK":"Haga clic aquí para crear una localización en:"}},"CUSTOMER_ADDRESS":{"LABEL":"Dirección del cliente","DISTANCE":"{{ distance }} km de distancia","HINT":"Busque una dirección, ejemplo: Calle de las Flores, 383 - Ciudad de México","ENTER_VALUE":"Ingrese la dirección del cliente en el campo de arriba <i class=\'md-accent-fg icon icon-arrow-up-bold s14\'></i>","CLEAR":"Limpiar dirección del cliente","ERRORS":{"ADDRESS_NOT_FOUND":"No se ha podido encontrar la dirección, cambie su búsqueda e intente nuevamente.","REQUIRED":"Se requiere la dirección del cliente","NUMBER_NOT_SPECIFIED":"El número de dirección no ha sido especificado."}},"COMPLEMENT":{"LABEL":"Dirección complementaria","ERRORS":{"VALID":"El complementaria no debe contener más de 50 caracteres."}},"DOCUMENT":{"LABEL":"Documento","ERRORS":{"INVALID_CPF":"Número de documento no válido","INVALID_CNPJ":"Documento no válido","NUMBER_DUPLICATED":"Número de documento duplicado"}},"ZIPCODE":{"LABEL":"Código postal","ERRORS":{"REQUIRED":"Se requiere el código postal"}},"CITY":{"LABEL":"Ciudad","ERRORS":{"REQUIRED":"Se requiere la ciudad"}},"STATE":{"LABEL":"estado","ERRORS":{"REQUIRED":"Se requiere el estado"}},"NEIGHBORHOOD":{"LABEL":"Barrio"},"STREET":{"LABEL":"Calle","ERRORS":{"REQUIRED":"Se requiere la calle"}},"NUMBER":{"LABEL":"Número","ERRORS":{"REQUIRED":"Se requiere el número"}},"LOCAL":{"LABEL":"Local","LAT_LONG":"latitud: {{ lat }}, longitud {{ long }}"},"EMAIL":{"LABEL":"Correo","HINT":"Correo electrónico principal","SELECT_TYPE":"Tipo de correo electrónico","REMOVE":"Eliminar correo electrónico","ADD":"Agregar un correo electrónico más","ERRORS":{"PATTERN":"Formato de correo inválido"}},"PHONE":{"CODE":"Código","LABEL":"teléfono","HINT":"Teléfono Principal","SELECT_TYPE":"Tipo de telefono","REMOVE":"Eliminar teléfono","ADD":"Agregar un teléfono más","ERRORS":{"NUMBER_INVALID":"Formato de teléfono no válido"}},"CUSTOMER_NOTES":{"LABEL":"Observaciones del cliente"},"DEADLINE_CONTRACT":{"LABEL":"Contrato temporal","SELECT":"Contrato temporal","SEARCH":"Buscar un contrato...","NO_SLA_CONTRACT":"Ningún contrato temporal encontrado"},"DESCRIPTION":{"LABEL":"Descripción de la orden de servicio","ERRORS":{"MAX_LENGTH":"Este campo debe tener como máximo {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}."},"DEFAULT_FROM_OS":{"NAME":"Nombre: ","SUBJECT":"Servicio: ","EMAIL":"Correo: ","PHONE":"Teléfono: ","NUMBER":"Número: ","DATE":"Fecha: "}},"EMPLOYEE":{"LABEL":"Empleado","SELECT":"Seleccione un empleado","SEARCH":"Buscar empleado ...","NO_EMPLOYEE":"Sin empleado","INACTIVE":"Inactivo","ABSENT":"Ausente","GREATER_THAN_EQUAL_1KM":" - {{ distance }} km de distancia","LESS_THAN_1KM":" - {{ distance }} m de distancia","ADD_TASK":{"MESSAGE":"¿Agregar {{ description }} como el tipo de OS realizada?","CONFIRM":"sí"},"ERRORS":{"DOES_NOT_PERFORM":"El empleado no realiza actividades de <b>{{ serviceDescription }}</b>","SECONDARY_EMPLOYEES_DOES_NOT_PERFORM":"Los Colaboradores <b>{{ notSkilledEmployees }}</br> no realizan actividades del tipo <b>{{ serviceDescription }}</b>","ALREADY_IN_ACTIVITY":"Este empleado está en más de una actividad al mismo tiempo","REQUIRED":"Se requiere el empleado"}},"SECONDARY_EMPLOYEES":{"LABEL":"Otros colaboradores","SELECT":"Seleccione otros colaboradores","SEARCH":"Buscar colaboradores...","NO_EMPLOYEE":"Sin colaborador","ERRORS":{"SECONDARY_EMPLOYEES_LIMIT":"Una actividad puede tener un máximo de 10 colaboradores secundarios"}},"DURATION":{"LABEL":"Duración de la actividad","ERRORS":{"REQUIRED":"Se requiere la duración","PATTERN":"La duración debe ser un número.","MIM":"Duración mínima de 1 minuto","MAX":"Duración máxima 999 minutos"}},"SCHEDULED_DATE":{"LABEL":"Día de la cita","ERRORS":{"MIN":"Fecha anterior inválida","INVALID":"Fecha no válida","REQUIRED":"Se requiere la fecha","CREATED_AT_IS_AFTER_SCHEDULING_DATE":"La fecha de la visita no puede ser inferior a la fecha de creación de la actividad","MUST_BE_NULL":"No puede haber una fecha de cita"}},"SCHEDULED_TIME_FORMAT":{"LABEL":"Hora de la cita","ERRORS":{"REQUIRED":"Se requiere la formato de hora"}},"START_TIME_FORMAT":{"LABEL":"Hora de inicio","ERRORS":{"REQUIRED":"Se requiere la formato de hora"}},"COMPLETED_TIME_FORMAT":{"LABEL":"Hora de finalización","ERRORS":{"REQUIRED":"Se requiere la formato de hora"}},"TIMEABLE_VISIT":{"LABEL":"Hora de la cita","ERRORS":{"INVALID":"Horario no válido","GREATER_12_HOURS":"La hora de la cita no puede ser mayor que 12 horas","MINOR_1_HOUR":"La hora de finalización debe ser mayor que 1 hora"}},"TASK_DESCRIPTION":{"LABEL":"Observación de la visita","ERRORS":{"MAX_LENGTH":"Este campo debe tener como máximo {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}."}},"SITUATION":{"LABEL":"Situación"},"STARTED_AT":{"LABEL_DATE":"Fecha de inicio","LABEL_TIME":"Hora de inicio","ERRORS":{"REQUIRED_DATE":"La fecha es obligatoria","REQUIRED_TIME":"El tiempo es obligatorio","INVALID_DATE":"Fecha invalida","INVALID_TIME":"Hora no válida","LESS_THAN":"Fecha menor que la creación","TIME_IN_FUTURE":"El inicio no puede ser posterior a la fecha/hora actual","CREATED_AT_IS_AFTER_STARTED_AT":"La fecha/hora no puede ser inferior a la fecha/hora de creación del sistema operativo.","TIME_MUST_HAVE_DATE":"La fecha no puede ser sin un tiempo.","DATE_MUST_HAVE_TIME":"El tiempo no puede estar sin fecha.","GREATER_12_HOURS":"La hora de inicio no puede ser mayor que 12 horas","MINOR_1_HOUR":"La hora de finalización debe ser mayor que 1 hora"}},"COMPLETED_AT":{"LABEL_DATE":"Fecha de finalización","LABEL_TIME":"Hora de finalización","ERRORS":{"REQUIRED_DATE":"La fecha es obligatoria","REQUIRED_TIME":"El tiempo es obligatorio","INVALID_DATE":"Fecha invalida","INVALID_TIME":"Hora no válida","MUST_BE_GREATER":"El tiempo de finalización debe ser mayor que el tiempo de inicio.","TIME_IN_FUTURE":"La finalización no puede ser mayor que la fecha/hora actual","TIME_MUST_HAVE_DATE":"La fecha no puede ser sin un tiempo.","DATE_MUST_HAVE_TIME":"El tiempo no puede estar sin fecha.","GREATER_12_HOURS":"La hora de finalización no puede ser mayor que 12 horas","MINOR_1_HOUR":"La hora de finalización debe ser mayor que 1 hora"}},"REPORTED_REASON":{"LABEL":"Razón del impedimento","PLACEHOLDER":"Seleccione la razón del impedimento","ERRORS":{"REQUIRED":"Se requiere la razón del informe"}},"DONE_DESCRIPTION":{"LABEL":"Descripción de la conclusión","PLACEHOLDER":"Describa la conclusión aquí ..."},"CANCELED_DESCRIPTION":{"LABEL":"Descripción de la cancelación","PLACEHOLDER":"Describa la razón de la cancelación aquí ..."},"IMPEDIMENT_DESCRIPTION":{"LABEL":"Descripción del impedimento","PLACEHOLDER":"Describa la razón del impedimento aquí ..."}},"MODEL":{"CONTACT_TYPE":{"WORK":"Trabajo","HOME":"Casa","PERSONAL":"Personal","MOBILE":"Teléfono móvil","PRIMARY":"Principal"}},"VISIT":{"TITLE":"Visita {{ index }}","RECEIVED_AT":"Recibido el {{ date }}","VIEWED_AT":"Visto el {{ date }}","ARCHIVED":"Archivada","CTA":"agregar otra visita","ERRORS":{"MUST_BE_FINISHED":"Para agregar una <b>nueva visita</b>, las anteriores deben completarse, cancelarse o impedirse"}}},"DEADLINES":{"TITLE":"Plazos ","INFO":"Los plazos se calculan de acuerdo con el  <b>contrato de plazos de </b> elegido para esta actividad.","INFO_CONTRACT":"Información del contrato","NO_DEADLINE":"Esta actividad no tiene una fecha límite definida","MODEL":{"CONTRACT_SLA":{"LABEL":"Nombre"},"OFFICE_HOURS":{"LABEL":"Horarios de asistencia","CUSTOMIZED":"Personalizado","NO_CUSTOMIZE":"corrido"},"CONSIDER_HOLIDAYS":{"LABEL":"Considerar vacaciones?","CONSIDER":"Sí","NO_CONSIDER":"No"},"RESPONSE_DEADLINE":{"LABEL":"Tiempo para responder"},"RESPONSE_DEADLINE_RISK":{"LABEL":"Riesgo después de"},"SOLUTION_DEADLINE":{"LABEL":"Tiempo para la solución"},"SOLUTION_DEADLINE_RISK":{"LABEL":"Riesgo después de"},"CONSIDERED_DAYS":{"LABEL":"Días considerados en el contrato","TO":"a","DAYS":{"MONDAY":"Lunes -","TUESDAY":"Martes -","WEDNESDAY":"Miérc -","THURSDAY":"Jueves -","FRIDAY":"Viernes -","SATURDAY":"Sábado -","SUNDAY":"Domingo -","NOT CONSIDERED":"N/A"}},"RESPONSE":{"TITLE":"Respuesta","COMPLETED_AT":{"IN_PROGRESS":"En espera de la conclusión","LABEL":"Completado en"},"DEADLINE_AT":{"LABEL":"Límite de respuesta de fecha/hora"},"SITUATION_DEADLINE":{"LABEL":"Fecha límite"},"REASON_VIOLATION":{"LABEL":"Razón de violación","LABEL_NOT_VIOLED":"Violación no violada","LINKED_BY_ENTERPRISE":"Atribuido por {{ enterpriseAccountName }}","DISABLED_BY_ENTERPRISE_TOOLTIP":"La razón de violación no puede ser modificada por el usuario, ya que está vinculada a la cuenta de la empresa.","ERRORS":{"REQUIRED":"La razón de violación es obligatoria"}}},"SOLUTION":{"TITLE":"Término de solución","COMPLETED_AT":{"IN_PROGRESS":"En espera de la conclusión","LABEL":"Completado en"},"DEADLINE_AT":{"LABEL":"Límite de respuesta de fecha/hora"},"SITUATION_DEADLINE":{"LABEL":"Fecha límite"},"REASON_VIOLATION":{"LABEL":"Violación","LABEL_NOT_VIOLED":"Violación no violada"}}}},"LOCATION":{"TITLE":"Ubicación","SEARCH_ADDRESS":{"LABEL":"Buscar por direccion","NO_ADDRESS_FOUND":"No se ha encontrado la dirección.","ADDRESS_EXAMPLE":"Para actualizarla, busque una dirección, por ejemplo: Calle de las Flores, 383 - Ciudad de México"},"SET_TO_EMPLOYEE":"Considerar la ubicación del empleado","SET_TO_CUSTOMER":"Considerar la ubicación del cliente","CHANGE_CUSTOMER_ADDRESS":{"MESSAGE":"La información de geolocalización (latitud y longitud) para esta orden de servicio ha sido modificada. ¿Desea cambiar permanentemente esta información para el cliente <b>{{customerName }}</b> ?","OK":"sí"},"MAP":{"TASK_LOCATION":"Lugar de la actividad","LAYERS":{"STANDARD":"Estándar","SATELLITE":"Satélite","ROADMAP":"Carreteras","TERRAIN":"Tierra"}}},"FORMS":{"TITLE":"Formularios","FORM":"Formulario","ARCHIVED":"Archivado","ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar","ADDED_AT":"Agregado el {{ createdAt }}","REPLY":"Formulario de respuesta","EMPTY":"Este tipo de OS <b>no tiene formularios vinculados</b> .","SEARCH":"Buscar formulario ...","UNANSWERED":"La orden de servicio no tiene formularios completos.","RELOAD":"Actualizar formulario","RELOAD_DISABLED":"Solo se pueden actualizar los formularios en curso.","RATING":"(Clasificación - Visita {{ index }})","EQUIPMENT":"Equipo","CLICK_OR_DROP_IMAGES":"Haga clic o arrastre una imagen","HINT_MESSAGE":"El tamaño máximo de la imagen es 10MB","NOT_SUPPORTED_FILE_DRAG":"El archivo no es compatible con su navegador","LOADING_PICTURE":"Cargando imagen","VIEW_ORIGINAL":"Ver original","REMOVE_ANSWER":"Eliminar respuesta","EQUIPMENT_TAB":"pestaña Equipo.","NO_ITEMS":"Los formularios de equipo ahora se muestran en la ","CLICK_ON_OPTION":"Para ello, haga clic en la opción Ver formularios contestados que se encuentra en los 3 puntos (...) a la derecha del equipo.","UN_ARCHIVE_FORM":"Formulario de {{ action }}","MULTIPLE_PICTURES":{"WARNING":"Agregue hasta 5 imágenes de hasta 10MB cada una."},"SCORE":{"TITLE":"Puntuación","TOTAL":"Total","NO_VALUE":"sin valor"},"SIGNATURE":{"LOADING":"Enviando firma","CONFIRM":"Confirmar suscripción","REMOVE":"Quitar suscripción","NO":"Sin firma","CANCEL":"Cancelar","EDIT":"Suscríbete de nuevo","CLEAR":"Eliminar firma","ADD":"Agregar firma"},"ALERTS":{"DELETE_FORM":{"MESSAGE":"¿Está seguro de que desea eliminar el <b>formulario {{ formName }}</b> ?","CONFIRM":"Sí","CANCEL":"Mejor no"},"REMOVE_ANSWER":{"MESSAGE":"¿Está seguro de que desea eliminar esta respuesta?","CONFIRM":"Sí","CANCEL":"No"},"UN_ARCHIVE_FORM":{"MESSAGE":"¿Está seguro de que desea <b>{{ action }}</b> el formulario &#39; <b>{{ formName }}</b> &#39;?","CONFIRM":"Sí","CANCEL":"Mejor no"}},"VALIDATOR":{"REQUIRED_ANSWERS":"Formulario {{ formName }} (las preguntas obligatorias no tienen respuesta)","FORM_REQUIRED":"El formulario {{ formName }} es obligatorio"},"ERRORS":{"MAXIMUM_CHARACTERS":"Máximo {{ limit }} caracteres"},"IN_PROGRESS":"En proceso","DONE":"Concluido","IN_PROGRESS_ALERT":"Los formularios en curso no se pueden editar.","LOCK_DATE_AND_TIME_CHANGE":"No está permitido cambiar la fecha/hora de una sugerencia de cita aceptada."},"COMMENTS":{"TITLE":"Commentarios","WRITE_A_COMMENT":"Escribe un comentario","NO_COMMENTS":"No se han creado comentarios.","COMMENT_TO_COLLABORATORS":"Comentario para contribuyentes","COMMENT_TO_MANAGER":"Comentario para gerentes","COMMENT_TO_INTERNAL":"Comentario interno","COMMENT_TO_CORPORATE":"Comentario para ","COMMENT_TO_CORPORATE_BY_COLLABORATOR":"Comentario del colaborador","COMMENT_TO_CORPORATE_BY_MANAGER":"Comentario del gerentes","COMMENT_TO_PUBLIC":"Comenta para todos","WRITE_YOUR_MESSAGE_HERE":"Escriba aquí su mensaje","WRITE_A_MESSAGE":{"LABEL":"Escribe un comentario para la orden de trabajo ...","MAX_LENGTH":"El comentario puede tener un máximo de 400 caracteres"},"VISUALIZATION":"Visualización:","PRESS_TO_SEND":"Presione Enter para enviar y Shift + Enter para saltar línea","DELETE":"Eliminar","CLIENT":"Cliente","TYPE":{"PUBLIC_MESSAGE":"Comentario público","TEAM_MESSAGE":"Comentario para contribuyentes","MANAGER_MESSAGE":"Comentario para los administradores","CORPORATE_MESSAGE":"Comentario para los administradores y {{ name }}","COLLABORATOR_MESSAGE":"Comentario para los colaboradores"},"TOOLTIP_TYPE":{"PUBLIC_VISIBILITY":"Visible para todos","TEAM_VISIBILITY":"Visible solo para el equipo","MANAGER_VISIBILITY":"Visible solo para los administradores","CORPORATE_VISIBILITY":"Visible solo para {{ name }}","COLLABORATOR_VISIBILITY":"Visible solo para los colaboradores"},"DELETED_MESSAGE":"Este comentario ha sido eliminado.","COMMENTS_STARTED":"La conversación comenzó a las","LOAD_MORE":"Cargar más comentarios","TOASTS":{"COMMENT_DELETED":"Comentario eliminado correctamente."}},"HISTORY":{"TITLE":"Registro","NO_HISTORY":"Esta orden de servicio no tiene registro.","OPTIONS":"opciones","SHOW_TIMELINE":"Mostrar línea de tiempo","GEOGRAPHIC_POSITION":"Posición geográfica:","OFFLINE_CHANGE":"Cambio sin conexión: enviado el","TIMELINE":{"SELECT":"Seleccionar historial de actividad","TASK_CREATED":{"EVENT":"{{ name }} creó la actividad"},"TASK_ARCHIVED":{"TITLE":"Actividad archivada","TEXT":"{{ name }} <b>archivó</b> la actividad y <b>no aparecerá</b> en el calendario del empleado.","EVENT":"{{ name }} archivó la actividad"},"TASK_UNARCHIVED":{"TITLE":"Actividad no archivada","TEXT":"{{ name }} ha <b>desarchivado</b> la actividad y <b>aparecerá nuevamente</b> en el calendario del empleado.","EVENT":"{{ name }} desarchivó la actividad"},"SCHEDULE_CHANGED":{"TITLE":"Cambio de fecha de servicio","TEXT":"{{ name }} cambió la fecha del servicio de <b>{{ fromDate }}</b> a <b>{{ toDate }}</b> .","EVENT":"{{ name }} cambió la fecha del servicio"},"EMPLOYEE_CHANGED":{"TITLE":"Empleado cambiado","TEXT":"{{ name }} cambió el empleado de la actividad de <b>{{ previousEmployee }}</b> a <b>{{ currentEmployee }}</b> .","EVENT":"{{ name }} cambió al empleado"},"EMPLOYEE_ASSIGNED":{"TITLE":"Empleado asignado","TEXT":"{{ name }} asignó al empleado <b>{{ employeeName }}</b> a la actividad.","EVENT":"{{ name }} asignó un empleado"},"EMPLOYEE_UNASSIGNED":{"TITLE":"Empleado eliminado","TEXT":"{{ name }} eliminó al empleado <b>{{ employeeName }}</b> de la actividad.","EVENT":"{{ name }} eliminó al empleado"},"STATUS_CHANGED":{"TITLE":"Cambio de situación","TEXT":"La situación de la actividad ha cambiado.","EVENT":"{{ name }} cambió la situación","DISTANCE_DESCRIPTION":"a <b>{{ displayDistance }} {{ displayDistanceName }}</b> de la ubicación de la actividad"},"STATUS_DECRIPTION_CHANGED":{"TITLE":"Descripción de la conclusión modificada","TEXT":"Se ha modificado la descripción de la conclusión.","EVENT":"{{ name }} cambió la descripción de la conclusión"},"TASK_RATING":{"TITLE":"Calificación de la actividad","EVENT":"El cliente {{ customerName }} ha calificado el servicio prestado."},"SENT_BY":{"BROWSER":"Enviado por el navegador","CELLPHONE":"Enviado por el móvil","ROUTE_PLANNER":"Actualizado por planificador de ruta automático","FIELD_CONTROL":"Actualizado por el sistema","CONTROL_PANEL":"(Panel de control)","ENTERPRISE":"Atualizado por el cliente {{ corporateAccount }}","GANDALF":"Actualizado por el sistema"}}},"MATERIALS":{"TITLE":"Materiales","HINT":"Para garantizar una mejor experiencia, hemos migrado <span class=\'tw-font-medium\'>\'Materiales\'</span> a <span class=\'tw-font-medium\'>\'Productos\'</span>. Pronto, la pestaña <span class=\'tw-font-medium\'>\'Materiales\'</span> y su respectivo módulo serán desactivados. <a href=\'https://app.fieldcontrol.com.br/#/materiais\' class=\'hover-link\'><span class=\'tw-text-color-primary tw-font-medium tw-cursor-pointer go-to-links\'>Haga clic aquí</span></a> para saber más!","SEARCH":{"LABEL":"Buscar materiales","NOT_FOUND":"Material no encontrado","HINT":"Buscar por nombre de material"},"LINKED_MATERIALS":"Materiales vinculados a esta orden de servicio:","QUANTITY":"Cantidad de material","UNLINK_MATERIAL":"Desvincular material","UNLINK_ALERT":{"MESSAGE":"¿Está seguro de que desea desvincular este material?","YES":"Sí","NO":"No"},"REQUIRED":"Este campo es obligatorio","PATTERN":"El valor debe ser un número entero"},"PRODUCTS":{"TITLE":"Productos","SEARCH_CUSTOMER":"Búsqueda por clientes","INFO":"Los productos utilizados se contabilizan en el valor total de esta actividad.","INFO-STOCK":"Visualice los productos utilizados en esta actividad.","SEARCH_PRODUCT":"Buscar por nombre de producto","SEARCH_BY_NAME":"Buscar por nombre","SEARCH_BY_PRODUCT_OR_STORAGE":"Buscar por producto ou depósito","LINKED_PRODUCTS":"Productos vinculados","PRODUCTS_USED":"Productos utilizados","PRODUCTS_VALUE":"Valor total en productos:","SERVICES_VALUE":"Valor total en servicios:","TOTAL_VALUE":"Valor total del pedido de servicios:","NO_LINKED_PRODUCTS_FOUND":"No se encontraron productos vinculados.","NO_UTILIZED_PRODUCTS_FOUND":"No se encontraron productos utilizados.","NO_PRODUCTS_FOUND":"No se encontraron productos.","LINK":"Vincular","LINK_PRODUCTS":"Vincular productos","REGISTER_PRODUCT":"Registrar producto","VIEW_PRODUCT_DETAILS":"Ver Detalles del Producto","RETURN_PRODUCT":"Devolver Productos","SEE_PRODUCT_MOVEMENTS":"Ver Movimientos del Producto","OMIE_ACCOUNT":"Producto importado de la cuenta Omie","MEASURE":{"milliliter":"Milimétrica","centimeter":"Centimetro","kilogram":"Quilograma","gram":"Grama","liter":"Litro","unity":"Unidade","meter":"Metro","null":"Unidade","square-meters":"Metros cuadrados","cubic-meters":"Metros cúbicos","tons-refrigeration":"Toneladas de refrigeración","dislocation":"Desplazamiento","cjt":"CJT","others":"Otros"},"SAVE_PRODUCTS":"Guardar","LINKED_SUCESS":"Producto vinculado con éxito.","YOU_CAN_STILL_SELECT":"Aún puede seleccionar {{ selectedProducts }} productos para vincular a esta actividad.","MAXIMUM_LIMIT_REACHED":"Se ha alcanzado el límite máximo de productos por orden de trabajo.","MAXIMUM_LIMIT_REACHED_TOOLTIP":"Límite de productos seleccionados alcanzables.","QUANTITY":"Quantidade","VALUE":"Valor","VALUE_REQUIRED":"El valor es obligatorio","REQUIRED":"Campo e requirido","INVALID_CHARACTER":"Caractere invalido","MIN_NUMBER_ERROR":"El valor no puede ser menor que 1","MAX_LENGTH":"Máximo excedido","VALUE_MIN_NUMBER_ERROR":"El valor no puede ser menor que 0","ALREADY_LINKED":"Producto já esta vinculado","LOADING":"Cargando productos...","TABLE":{"NAME":"Nombre","QUANTITY":"Cantidad","STORAGE":"Almacén","UNIT_VALUE":"Valor unitario","TOTAL_VALUE":"Valor total","ACTIONS":"Acciones"},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Siguiente","SHOWING_FROM":"Mostrando de","TO":"a","OF":"de","ITEMS":"ítems."},"CONFIRM_DELETE_DIALOG":{"TITLE":"Eliminar producto","MESSAGE":"¿Está seguro de que desea eliminar el producto <b>{{ name }}</b>?","YES":"Sí","NO":"No","SUCESS":"Producto eliminado con éxito."},"PRODUCTS_TO_ORDER":"productos para vincular a esta orden de servicio."},"SERVICES":{"TITLE":"Servicios","INFO":"Los servicios realizados se contabilizan en el valor total de esta actividad.","SEARCH_SERVICE":"Buscar por nombre de servicio","LINKED_SERVICES":"Servicios realizados","PRODUCTS_VALUE":"Valor total en productos:","SERVICES_VALUE":"Valor total en servicios:","TOTAL_VALUE":"Valor total de la orden de servicio:","NO_LINKED_SERVICES_FOUND":"No se encontraron servicios vinculados.","NO_SERVICES_FOUND":"No se encontraron servicios.","LINK":"Vincular","LINK_SERVICES":"Vincular servicios","SAVE_SERVICES":"Guardar","LINKED_SUCESS":"Servicio vinculado con éxito.","YOU_CAN_STILL_SELECT":"Todavía puede seleccionar {{ selectedServices }} servicios para vincular a esta orden de servicio.","MAXIMUM_LIMIT_REACHED":"Se ha alcanzado el límite máximo de servicios por orden de servicio.","MAXIMUM_LIMIT_REACHED_TOOLTIP":"Se ha alcanzado el límite de servicios seleccionados.","QUANTITY":"Cantidad","VALUE":"Valor","REQUIRED":"La cantidad es obligatoria","VALUE_REQUIRED":"El valor es obligatorio","INVALID_CHARACTER":"Carácter inválido","MIN_NUMBER_ERROR":"La cantidad debe ser mayor que 0","VALUE_MIN_NUMBER_ERROR":"El valor debe ser mayor o igual a 0","MAX_LENGTH":"Excedido el máximo de caracteres","ALREADY_LINKED":"El servicio ya está enlazado.","LOADING":"Cargando servicios...","OMIE_ACCOUNT":"Servicio importado de la cuenta de Omie","TABLE":{"NAME":"Nombre","QUANTITY":"Cantidad","UNIT_VALUE":"Valor unitario","TOTAL_VALUE":"Valor total","ACTIONS":"Acciones"},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Siguiente","SHOWING_FROM":"Mostrando de","TO":"a","OF":"de","ITEMS":"ítems."},"CONFIRM_DELETE_DIALOG":{"TITLE":"Eliminar servicio","MESSAGE":"¿Estás seguro de que deseas eliminar el servicio <b>{{ name }}</b>?","YES":"Sí","NO":"No","SUCESS":"Servicio eliminado exitosamente."},"SERVICES_TO_ORDER":"servicios para vincular a esta orden de servicio."},"STORAGES_MOVEMENTS":{"TITLE":"Movimientos","INFO":"Realice un seguimiento y realice movimientos de productos.","SEARCH_PRODUCT_OR_STORAGE":"Buscar un producto o almacenamiento","NEW_MOVEMENT":"Nuevo movimiento","REMOVAL_MOVEMENT":"Movimientos de salida ({{ quantity }})","LOADING":"Cargando servicios...","NO_LINKED_MOVEMENTS_FOUND":"No se encontraron movimientos","TABLE":{"DATE_TIME":"Fecha/Hora","PRODUCT":"Producto","QUANTITY":"Cantidad","STORAGE":"Almacenamiento","TYPE":"Tipo","ENTRY":"Entrada","REMOVAL":"Salida","SEE_MOVEMENTS":"Ver movimientos"},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Siguiente","SHOWING_FROM":"Mostrando de","TO":"a","OF":"de","ITEMS":"ítems."},"SUCCESSFULLY_CREATED":"Movimiento creado con éxito.","SUCCESSFULLY_EDITED":"Movimiento editado con éxito."},"PENDENCIES":{"TITLE":"Pendientes","HEADLINE":"Pendientes ({{ totalCount }})","ADD":"Agregar nueva pendiente","LOAD_MORE":"Cargar más","EMPTY_STATE":"No hay ninguna pendencia vinculada. Haz clic aquí para crear.","EMPTY_STATE_NO_PERMISSIONS":"No tienes permiso para crear pendencias.","ITEM":{"DESCRIPTION":"ID {{ identifier }} | Tipo de pendiente: {{ pendencyType }}","TREATMENT_STATUS":{"AWAITING_COMPANY":"Esperando respuesta de la empresa","AWAITING_MANAGEMENT":"Esperando respuesta de la gestión"},"STATUS":{"OPENED":"Abierta","DONE":"Finalizada"},"TOOLTIPS":{"ASSIGNEE":"Usuario responsable: {{ assignee }}","NO_ASSIGNEE":"Sin usuario responsable","VIEW_PENDENCY":"Acceder a la pendencia","BLOCK_ASSIGNEE":"No es posible cambiar el responsable de una pendencia finalizada.","NO_PERMISSION":"No tienes permiso para cambiar el responsable de una pendencia."}},"UPDATE_PENDENCY_ASSIGNEE":{"SUCCESS":"Responsable vinculado con éxito.","SUCCESS_UPDATE":"Responsable cambiado con éxito.","ERROR":"Ocurrió un error al vincular el responsable. Inténtalo de nuevo más tarde."},"SUCCESSFULLY_SAVED":"Pendencia creada con éxito."},"EQUIPMENTS":{"TITLE":"Equipos","EQUIPMENTS":"Equipos","SEARCH":{"LABEL":"Buscar equipos","NOT_FOUND":"No se encontraron equipos.","HINT":"Buscar por nombre o número de serie."},"LINKED_EQUIPMENTS":{"TITLE":"Equipos vinculados","REMOVE":"Eliminar equipo","LABEL":"Buscar equipo vinculado","LINK":"Vincular equipos","LINK_NEW":"Vincular","SELECTED":"Equipo ya vinculado","SAVE_EQUIPMENTS":"Guardar","UNLINK_ALERT":{"MESSAGE":"¿Estás seguro de que deseas desvincular este equipo?","YES":"Sí","NO":"No"},"YOU_CAN_STILL_SELECT":"Todavía puedes seleccionar","EQUIPMENTS_TO_ORDER":"equipos para vincular a esta orden de trabajo.","MAXIMUM_LIMIT_REACHED":"Se alcanzó el límite máximo de equipos por orden de trabajo."},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Siguiente","SHOWING_FROM":"Mostrando de","TO":"a","OF":"de","RECORDS":"registros"},"CUSTOMER_WITHOUT_EQUIPMENTS":"Esta ubicación no tiene equipos registrados.","FORMS_EQUIPMENT":{"BUTTON_OPTIONS":{"VIEW_COMPLETED_FORMS":"Ver formularios completados","ANSWER_FORMS":"Responder formularios","UNLINK_EQUIPMENT":"Desvincular equipo","NO_PERMISSION_WARN":"Sin permiso","NO_PERMISSION_WARN_CREATE_TASK":"No tienes permiso para crear tareas","NO_PERMISSION_WARN_EDIT_TASK":"No tienes permiso para editar tareas","NO_PERMISSION_WARN_CREATE_RECURRENCE":"No tienes permiso para crear recurrencias","NO_PERMISSION_WARN_EDIT_RECURRENCE":"No tienes permiso para editar recurrencias","NO_PERMISSION_WARN_CREATE_PLAN":"No tienes permiso para crear planes de actividad","NO_PERMISSION_WARN_EDIT_PLAN":"No tienes permiso para editar planes de actividad"},"SEARCH_EQUIPMENTS":{"ANSWER_EQUIPMENTS_FORMS":"Responder formularios de equipos","REPLY":"Responder formulario","SEARCH_FORM":"Buscar formulario","SEARCH_FORMS_LINKED_EQUIPMENT":"Buscar formularios vinculados a este equipo.","VIEW_COMPLETED_EQUIPMENT_FORMS":"Ver formularios completados para este equipo","FORMS_AVAILABLE":"Formularios disponibles","REQUIRED":"Requerido","OPTIONAL":"Opcional","ANSWER":"Responder","BACK":"Volver","ANSWERED_BY":"Respondido por","ANSWERED_AT":"Respondido en","ANSWERS":"Respuestas ({{ quantity }})","ALL_FORMS":"Todos los formularios","INSERT_ATTACHMENTS":"Insertar archivos adjuntos","STATUS":"Situación","FORM_LENGTH":"{{ LENGTH }} preguntas"},"ARCHIVED":{"FORMS_IS_ARCHIVED":"Este formulario está archivado","TITLE":"Archivar formulario de equipo","ARE_YOU_SURE":"¿Estás seguro de que deseas archivar el formulario {{ formName }}?","NO":"No","YES":"Sí"}}},"QUOTATIONS":{"TITLE":"Presupuestos","INFO":"Agregue cotizaciones a esta orden de trabajo.","LINKED":"Cotizaciones vinculadas ({{ quotations }} / {{ maxAllowed }})","SEE":"Ver cotización","REMOVE":"Remover cotización","APPROVED_AT":"Aprobado en {{ approvedAt }}","REFUSED_AT":"Rechazado el {{ refusedAt }}","NO_ITEMS":"Sin presupuesto vinculada, es posible vincular una nueva presupuesto usando la barra de búsqueda de arriba.","PRODUCTS":"{{ quantity }} producto (s)","SERVICES":"{{ quantity }} servicio (s)","VALUE":"Valor: {{ value }}","SUBTOTAL":"Subtotal:","DISCOUNT":"Descuento:","TOTAL":"Valor total:","SEARCH":"Buscar presupuestos","SEARCH_HINT":"Busque por el nombre de una presupuesto o su identificador.","CREATE":"Registrar nuevo","MAX_ALLOWED":"Límite máximo de presupuesto por orden de trabajo alcanzado.","ARCHIVED":"Archivado","LINK_CONFIRM_DIALOG":{"TITLE":"Vincular ítems del presupuesto a la orden de servicio","DESCRIPTION":"¿Deseas vincular los servicios y productos no vinculados del presupuesto a la orden de servicio?","YES":"Sí","NO":"No"},"STATUS":{"TITLE":"Situación","PENDING":"Pendiente","APPROVED":"Aprobado","REFUSED":"Rechazado","EXPIRED":"Expirado","CANCELED":"Cancelado"}},"ATTACHMENTS":{"TITLE":"Archivos adjuntos","DROP_HERE":"Arrastre sus archivos para cargar","NOT_SUPPORTED_FILE_DRAG":"El archivo no es compatible con su navegador","ATTACHMENT_DESCRIPTION":"Límite de 20 archivos adjuntos por panel de administrador. No hay límite para los archivos adjuntos en la aplicación de colaborador. </br> 10MB de tamaño máximo por archivo o 50MB por video o imagen.","INSERT_FILES":"Arrastra tus archivos para subirlos o","INSERT_FILES_ALTERNATIVE":"Arraste seus arquivos para fazer upload ou","SEND_FILES":"Enviar archivos","NO_ATTACHMENTS_ADDED":"No se han agregado archivos adjuntos para esta orden de servicio.","SEARCHING_ATTACHMENTS":"Obtener archivos adjuntos de órdenes de trabajo.","ATTACHMENTS_LIMIT_REACHED":"Se alcanzó el límite de archivos adjuntos para agregar más archivos adjuntos, primero debe eliminar algunos.","MAX_SIZE_FILES":"Este archivo excede el límite de 10MB.","MAX_SIZE_BIG_FILES":"Este archivo excede el límite de 50MB.","MIN_SIZE_FILES":"Este archivo no cumple el tamaño mínimo de 1KB","FILES":{"MOVE_UP":"Subir","MOVE_DOWN":"Bajar","SAVE_EDIT":"Guardar título","CANCEL_EDIT":"Cancelar","NO_TITLE":"Sin título","RENAME":"Cambiar nombre","SIGNATURE":"firma","EDIT_TITLE":"Editar el título del adjunto","EDIT_CUSTOMER_NAME":"Editar el nombre del cliente","OF":"en","ADDED_AT":"Creado el {{ date }} a las {{ hour }}","EDIT":"Editar","VIEW_ORIGINAL":"Ver original","ARCHIVED":"Archivado","ACTIONS":{"REMOVE":"Remover adjunto","ARCHIVE":"Archivo adjunto","UNARCHIVE":"Desarchivar archivo adjunto"},"ALERTS":{"REMOVE_SIGNATURE":"¿Está seguro de que desea <strong>eliminar</strong> esta firma?","REMOVE_ATTACHMENT":"¿Está seguro de que desea <strong>eliminar</strong> este archivo adjunto?","ARCHIVE_SIGNATURE":"¿Está seguro de que desea <strong>archivar</strong> esta firma?","ARCHIVE_ATTACHMENT":"¿Está seguro de que desea <strong>archivar</strong> este <strong>archivo</strong> adjunto?","YES":"Sí","NO":"No"}},"LINK":"ENLACE"},"OFFLINE":{"TITLE":"Sincronizaciones (beta)","NO_SYNC":"No hay sincronizaciones para esta orden de servicio","INFO":"Tan pronto como el técnico tenga internet, sus sincronizaciones sin conexión para esta orden de servicio aparecerán aquí.","STATUS":{"PENDING":"Aún no sincronizado","IN_PROGRESS":"Sincronizando","DONE":"Sincronizado","ERROR":"Error al sincronizar"}},"ROUTES":{"TITLE":"Rutas","ESTIMATED_ROUTE":"Ruta estimada","TOTAL_KILOMETERS":"Kilometraje total: {{ kmTotal }} km","START_ROUTE":"Punto de inicio de la ruta","INTERMEDIATE_ROUTE":"Punto intermedio de la ruta","END_ROUTE":"Punto final de la ruta","COMPANY_ADDRESS":"La dirección de tu empresa","CUSTOMER_ADDRESS":"La dirección de tu cliente","MAP":{"LAYERS":{"DEFAULT":"Estándar","SATELLITE":"Satélite","ROADS":"Carreteras","GROUND":"Tierra"},"CENTRALIZE":"Centralizar","GROUP_VISITS":"Agrupar visitas"}},"LINKS":{"TITLE":"Enlaces"}},"WARNINGS":{"TITLE":"Aviso","CANT_EDIT":"No tienes permiso para editar actividades.","CONTENT":"Retire el equipo del cliente/ubicación actual para continuar con este cambio","BUTTON":"Cerca"},"EMPLOYEE_WARNING":{"TITLE":"Empleados fuera de la región de servicio","CONTENT":"Algunos empleados no están en la región de servicio y, por lo tanto, serán desvinculados de la actividad.","BUTTON":"Cerrar"},"ROUTERIZATION":{"SUCCESS_MESSAGE":"Las actividades se han guardado con éxito"},"LAUNCH_DIALOG":{"TITLE":"🚀 Lanzamiento de la Nueva Orden de Servicio","DESCRIPTION":"¡Tenemos una gran novedad para ti! La pantalla de creación y edición de órdenes de servicio ha sido completamente renovada. Ahora cuenta con un diseño más moderno y organizado, ofreciendo una experiencia más intuitiva y facilitando tu aprendizaje. Todas las funciones siguen disponibles y, para ayudarte a entender los cambios, incluimos un video explicativo a continuación.","VIDEO_TEXT":"📺 ¡Mira el video a continuación para saber más!","LEFT_BUTTON":"Cancelar","RIGHT_BUTTON":"Probar nueva versión"}},"TOASTS":{"FILTERS":{"CUSTOM_FILTER_SAVED":"El filtro personalizado \'{{ filterName }}\' ha sido guardado.","CUSTOM_FILTER_DELETED":"El filtro personalizado \'{{ filterName }}\' ha sido eliminado."},"GENERAL":{"CUSTOMER_REGISTERED":"El cliente {{ customerName }} se ha registrado correctamente."},"LOCATION":{"CUSTOMER_GEOLOCATION_UPDATED":"¡Listo! Se han actualizado las informaciones de ubicación geográfica (latitud y longitud) para el cliente {{ customerName }}."},"SERVICES_TYPE":{"CUSTOMER_SERVICE_ADDED_TO_SECONDARY_EMPLOYEES":"¡Hecho! El tipo de tarea {{ serviceDescription }} ahora se puede agregar para empleados secundarios.","CUSTOMER_SERVICE_ADDED":"¡Listo! El tipo de OS {{ serviceDescription }} ahora se puede agregar para {{ employeeName }}."},"EQUIPMENTS":{"EQUIPMENT_UNLINKED":"Equipo desvinculado correctamente"},"ATTACHMENTS":{"TITLE_UPDATED":"El título del archivo adjunto ha sido cambiado.","IMAGES_UPLOADED":"Los archivos adjuntos se enviaron correctamente.","SIGNATURE_REMOVED":"¡La firma se ha eliminado!","SUCCESSFULLY_ARCHIVED":"¡El archivo adjunto se ha archivado!","SUCCESSFULLY_UNARCHIVED":"¡El archivo adjunto se ha desarchivado!","SUCCESSFULLY_REMOVED":"¡El archivo adjunto se ha eliminado!"},"FORMS":{"FORM_UPDATED":{"SUCCESS":"¡Formulario {{ formName }} {{ action }} correctamente!","FAILED":"No pudimos {{ action }} el formulario {{ formName }}. Vuelva a intentarlo.","ARCHIVE":"archivar","ARCHIVED":"¡Formulario de equipo archivado con éxito!","SAVE":"guardado","UNARCHIVE":"desarchivar","UNARCHIVED":"¡Formulario de equipo desarchivado con éxito!"},"FORM_CREATED":{"CREATED":"Formulario {{ formName }} creado con exito!"},"INCOMPATIBLE_FILE":"Seleccione un archivo compatible","UPLOAD_FAILED":"No se pudo enviar la imagen. Vuelva a intentarlo."},"DIALOG_ACTIONS":{"LINK_COPIED":{"MESSAGE":"El enlace {{ type }} # {{ id }} se ha copiado al portapapeles.","FROM_REPORT":"del informe","TO_EVALUATION":"para la calificación de la actividad"},"EVALUATION_LINK_SENDED":"El enlace de calificación se enviará al cliente {{ customerName }} en los correos electrónicos seleccionados.","REPORT_LINK_SENDED":"El enlace con el informe de la actividad se enviará al cliente {{ customerName }} en los correos electrónicos seleccionados.","EMPLOYEE_LOCATION_SENDED":"El enlace con la ubicación del empleado se enviará al cliente {{ customerName }} en los correos electrónicos seleccionados.","TASK_ARCHIVED":"Actividad {{ customerName }} # {{ id }} archivada.","TASK_UNARCHIVED":"Actividad {{ customerName }} # {{ id }} desarchivada.","TASK_SAVED":"Actividad {{ customerName }} # {{ id }} guardada.","EXPORT_ERROR":"No pudimos solicitar su exportación. Vuelva a intentarlo ...","SEND_TO_EMAIL":"Recibirá actividades de exportación en el correo electrónico: {{ email }}.","TASK_WITHOUT_EMPLOYEE":"No se pueden evaluar las actividades sin un empleado"},"TICKETS":{"EXPIRED":"¡Esta solicitud ha caducado o ya ha sido resuelta!","ACCEPT_FAILED":"Hubo un error al aceptar la solicitud de servicio, intente nuevamente.","ACCEPT_FAILED_DUPLICATED":"Esta solicitud ya ha sido aceptada por otro empleado."},"EXPORT":{"TITLE":"Exportación de PDF solicitada","EXCEL_TITLE":"Exportación de Excel solicitada"}},"INTEGRATIONS":{"CONTA_AZUL":{"ERROR":{"NOT_PROVIDED":"Error en el producto/servicio, asegúrese de que estuvo informado o que haya inventario en la Conta Azul.","UNAUTHORIZED":"No autorizado","INVALID_FIELD":"La venta no fue creada, ya que puede tener un campo: (inválido, nulo o desconocido)"}}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/tasks/i18n/pt.json',
    '{"TASKS":{"PAGE_TITLE":"Atividades","TITLE":"Atividades","TUTORIAL_VIDEO":{"TITLE":"Instruções","TOOLTIP":"Assistir vídeo explicativo"},"FEEDBACK_FORM":"Experimente o módulo de estoque e otimize a gestão do seu negócio!!","ACTION_BUTTONS":{"PRINT":"Imprimir","EXPORT_PDF":"Exportar em Pdf","EXPORT_EXCEL":"Exportar em Excel","RESTORE_COLUMNS":"Restaurar colunas","TOGGLE_COLUMNS":"Alterar colunas","CLEAR_FILTERS":"Limpar filtros","FILTER":"Filtrar atividades","NEW":"Nova atividade","CANT_CREATE":"Você não tem permissão para adicionar atividades","RELOAD":"Atualizar"},"EXPORT_MODAL":{"TITLE":"Exportação de visitas","TITLE_PDF":"Exportar PDFs em massa","TITLE_LIMIT_EXCEEDED":"Atenção","TEMPLATE":{"YES":"Sim","NO":"Não","OK":"Ok, entendi","MATERIALS":"Materiais","PRODUCTS":"Produtos","EQUIPMENTS":"Equipamentos","FORMS":"Formulários","LINKS":"Vínculos","SERVICES":"Serviços","TITLE":"Escolha quais informações serão exportadas junto com as visitas.","ALERT_FIRST_CONTENT":"Ao clicar em exportar, você receberá um link de download da exportação no seu e-mail","ALERT_SECOND_CONTENT":"Dependendo da quantidade de informações, a exportação poderá demorar alguns minutos para ser finalizada.","ALERT_LIMIT_EXCEEDED_FIRST_CONTENT":"Você só pode exportar até","ALERT_LIMIT_EXCEEDED_SECOND_CONTENT":"PDFs em massa. Utilize os filtros disponíveis na listagem para reduzir a quantidade de resultados e tente novamente.","CONFIRM_ACTION_CONTENT":"Deseja continuar com a exportação?","MATERIALS_MUST_BE_MIGRATED":"Materiais devem ser migrados para produtos.","TO_KNOW_MORE":"para saber mais e realizar a migração.","CLICK_HERE":"Clique aqui"}},"CHANGE_TASK_STATUS":{"ALERT_FIRST_CONTENT":"Tem certeza que deseja modificar o status dessa atividade? É provável que","ALERT_SECOND_CONTENT":"ainda esteja realizando essa atividade."},"TABLE":{"MARKINGS":{"NO_RATE":"Não avaliado","ARCHIVED":"Arquivado","DAY":{"SINGULAR":"dia","PLURAL":"dias"}},"COLUMNS":{"ID":"Identificador","LABELS":"Etiquetas","DATE":"Data do agendamento","HOUR":"Hora do agendamento","DEADLINE":"Prazo","CUSTOMER":"Cliente","CUSTOMER_LOCATION":"Localização","ADDRESS":"Endereço","DESCRIPTION":"Descrição","VISIT_OBSERVATION":"Observação da visita","SITUATION":"Situação","START_DATE":"Data de início","START_HOUR":"Hora de início","ROUTE_DATE":"Data de deslocamento","ROUTE_HOUR":"Hora de deslocamento","END_DATE":"Data de término","END_HOUR":"Hora de término","VISIT_DURATION":"Duração da visita","ROUTE_DURATION":"Duração do deslocamento","DESCRIPTION_CLOSURE":"Descrição fechamento","RATE":"Avaliação","COMMENT":"Comentário","TYPE":"Tipo","EMPLOYEE":"Colaborador","CREATED_AT":"Criado em","RESPONSE_DEADLINE_STATUS":"Prazo de resposta","SOLUTION_DEADLINE_STATUS":"Prazo de solução","ORDER_CREATED_BY":"Criado por","ACTIONS":"Ações"},"ROWS":{"EMPTY":{"CTA":"Você pode criar uma nova atividade","LINK":"clicando aqui"},"ACTION":{"VIEW":"Visualizar","EDIT":"Editar"}}},"SIDENAV":{"HEADER":{"FILTERS":"Filtrar atividades","CUSTOM_FILTER":"Filtro customizado","SAVED_FILTERS":"Filtros","ACTIONS":{"CLEAR":"Limpar filtros","SHOW_SAVED_FILTERS":"Filtros","SAVE":"Salvar filtro"}},"FILTERS":{"FIELDS":{"FROM":"De:","TO":"Até:","SELECT_DATE":"Selecionar data","BY_APPOINTMENT":"Filtros por agendamento","BY_DEADLINE":"Filtros por prazos","BY_RESPONSE_DEADLINE_STATUS":"Filtrar por prazo de resposta","BY_SOLUTION_DEADLINE_STATUS":"Filtrar por prazo de solução","BY_STATUS":{"LABEL":"Filtrar por estado","OPTIONS":{"ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"}},"BY_USER":{"SELECT":"Selecionar um usuário"},"BY_CUSTOMER":{"LABEL":"Filtrar por cliente","SEARCH":"Pesquisar cliente","SELECT":"Selecionar um cliente"},"BY_EQUIPMENT":{"LABEL":"Filtrar por equipamento","SELECT":"Selecionar equipamento"},"BY_LOCATION":{"LABEL":"Filtrar por nome da localização","SEARCH":"Pesquisar localização"},"BY_LOCATION_NOTES":{"LABEL":"Filtrar por descrição da localização","SEARCH":"Pesquisar descrição"},"BY_CUSTOMER_LABELS":"Filtrar por etiquetas (cliente)","BY_ID":"Filtrar por identificador","BY_ZIPCODE":"Filtrar por CEP","BY_CITY":"Filtrar por cidade","BY_NEIGHBORHOOD":"Filtrar por bairro","BY_DESCRIPTION":"Filtrar por descrição","BY_TYPE":{"LABEL":"Filtrar por tipo de OS","SEARCH_LABEL":"Selecione o tipo de OS","SEARCH":"Pesquisar tipo de OS"},"CREATED_BY":{"LABEL":"Buscar por usuário que criou a atividade","SEARCH":"Buscar por criador da atividade"},"BY_LABELS":{"LABEL":"Filtrar por etiquetas","NO_LABEL":"Sem etiqueta"},"BY_SITUATION":"Filtrar por situação","BY_EMPLOYEE":{"LABEL":"Filtrar por colaborador","SEARCH":"Pesquisar por colaborador","NO_EMPLOYEE":"Sem colaborador","INACTIVE":" (Inativo)"},"BY_RATE":{"LABEL":"Filtrar por avaliação","NO_RATE":"Sem avaliação","RATINGS":{"ONE_STAR":"Péssimo","TWO_STARS":"Ruim","THREE_STARS":"Regular","FOUR_STARS":"Bom","FIVE_STARS":"Ótimo"}},"BY_TERRITORY":{"LABEL":"Filtrar por território","SEARCH":"Pesquisar território","SEARCH_LABEL":"Selecione o território"},"BY_SUBTERRITORY":{"LABEL":"Filtrar por subterritório","SEARCH":"Pesquisar subterritório","SEARCH_LABEL":"Selecione o subterritório"}}},"CUSTOM_FILTERS":{"NEW_FILTER":"Novo filtro","EDIT_FILTER":"Editar filtro","FILTER_NAME":"Nome do filtro","SAVE":"Salvar","EDIT":"Alterar","LIST":{"DEFAULT":{"LABEL":"Filtros padrões","FILTERS":{"OUT_OF_TIME":"Atividades fora do prazo","WITHOUT_EMPLOYEE":"Atividades sem colaborador","UNFINISHED_FROM_PAST":"Atividades não finalizadas do passado"}},"CUSTOM":"Filtros customizados","REMOVE":"Remover","REMOVE_DIALOG":{"TITLE":"Excluir filtro","CONTENT":"Tem certeza que deseja excluir o filtro {{ filterName }}?","OK":"Excluir","CANCEL":"Cancelar"}}}},"MODAL":{"ERROR":{"TITLE":"Erro","CONTENT":"Não foi possível anexar o arquivo. Por gentileza, não utilize caracteres especiais (/[<>!{}=\';]|?:.) no nome do arquivo","OK":"Ok"}},"DIALOG":{"TITLES":{"NEW":"Nova atividade","EDIT":"Editar atividade","VIEW":"Visualizar atividade"},"OS_ID":"Identificador de ordem de serviço","CLOSE":"Fechar","TEST_NEW_LAYOUT":"Testar novo layout","FEEDBACK_FORM":"Estamos repaginando a ordem de serviço. <a href=\\"https://forms.gle/ujDQt6FqvmmoqHpP8\\" target=\\"_blank\\">Clique aqui</a> para deixar sua contribuição.","FEATURE_FLAGS_WARNING":{"TEST_NOW":"Testar agora","FORM":"Descubra a nova experiência no preenchimento de formulários - mais fácil, mais rápida e mais intuitiva do que nunca! <strong>Lançamento oficial em 30/05/2024.</strong>"},"FORM":"Formulário","LABELS":{"TITLE":"Etiquetas","MANAGE":"Gerenciar etiquetas","EMPTY":"Nenhuma etiqueta cadastrada, apenas administradores podem cadastrar etiquetas.","SEARCH":"Pesquisar etiquetas...","LIMIT_COUNT":"{{ length }} de {{ limit }} etiquetas","LIMIT_EXCEEDED":"Limite máximo de etiquetas foi excedido ({{ length }} de {{ limit }}).","NEW":"Criar nova etiqueta","CREATE":"Criar","EDIT":"Editar","UPDATE":"Atualizar","BACK":"Voltar","NAME":"Nome","LABELS_UPDATED":"Etiquetas atualizadas com sucesso.","TASK_LOCKED":"Essa ordem de serviço está bloqueada e não pode ser alterada."},"ACTIONS":{"SAVE":"Salvar","CREATE":"Criar","ACTIVITY_REPORT_LINK":"Link do relatório da atividade","VISIT_REPORT_LINK":"Link do relatório da visita","VISIT_REVIEW_LINK":"Link de avaliação da visita","SEND_TO_CONTA_AZUL":"Enviar para o Conta Azul","SEND_TO_OMIE":"Enviar para o Omie","SELECT_THE_ACCOUNT":"Selecione a conta Omie que deseja exportar a atividade","SEND_REPORT_LINK":"Enviar link do relatório","COPY_LINK":"Copiar link","SEND_RATING_LINK":"Enviar link de avaliação da atividade","COPY_VISIT_REPORT_LINK":"Copiar link do relatório","OPEN_REPORT":"Abrir relatório","OPEN_EVALUATION_LINK":"Abrir link de avaliação","SHARE_REPORT_LINK":"Compartilhar link do relatório","SHARE_BY_EMAIL":"Compartilhar por e-mail","LOCATION_EMAILS":"E-mails da localização","LOCATION_NO_HAVE_EMAILS":"Esta localização não possui e-mails.","CUSTOMER_NO_HAVE_EMAILS":"Este cliente não possui e-mails.","LOCATION_NO_HAVE_CONTACTS":"Esta localização não possui contatos.","CUSTOMER_NO_HAVE_CONTACTS":"Este cliente não possui contatos.","CUSTOMER_EMAILS":"E-mails do cliente","SHARE_BY_WHATSAPP":"Compartilhar via WhatsApp","CONTACTS_BY_LOCATION":"Contatos por localização","CUSTOMER_CONTACTS":"Contatos do cliente","PRIMARY":"- Principal","SEND_TO_ANOTHER_CONTACT":"Enviar para outro número","ARCHIVE_TASK":"Arquivar visita","CANT_ARCHIVE_LOCKED":"Não é possível arquivar/desarquivar atividades em uma o.s. bloqueada.","ARCHIVE_FORM":"Arquivar formulário","UNBUNDLING_FORM":"Desarquivar formulário","ATTACHMENTS_VIEW_ORIGINAL":"Ver anexo original","COPY_EVALUATION_LINK":"Copiar link de avaliação de atividade","COPY_TRACKING_LINK":"Copiar link de rastreamento","COPY":"Copiar atividade","DELETE_TASK":"Excluir","OPTIONS":"Opções","PRINT":"Imprimir","EXPORT_PDF":"Exportar PDF da ordem de serviço","SEND_EMPLOYEE_LOCATION_LINK":"Enviar link de localização do colaborador","SEND_ESTIMATED_SCHEDULE":"Enviar horários de atendimento","SEND_REPORTS_LINK":"Enviar link do relatório das atividades","SEND_NEW_REPORTS_LINK":"Enviar link do relatório das atividades","OPEN_REPORTS":"Abrir relatório","SHARE_LOCATION":"Compartilhar localização com o cliente","UNARCHIVE_TASK":"Desarquivar visita","UNWATCH_TASK":"Não receber notificações","WATCH_TASK":"Receber notificações","WHATSAPP_MESSAGE":"Olá, {{ customer }}!\\n\\nSegue o relatório da visita referente a ordem de serviço {{identifier}} - {{service}} realizada pela empresa {{company}}.\\n\\n{{link}}","WHATSAPP_EVALUATION_MESSAGE":"Olá, {{ customer }}!\\n\\nSegue o link para avaliar a atividade referente a ordem de serviço {{identifier}} - {{service}} realizada pela empresa {{company}}.\\n\\n{{link}}","WHATSAPP_SEND_CONTACT":"Enviar para um contato","SEND_VIA_WHATSAPP":"Enviar via WhatsApp","ALERTS":{"EXPORT_DATA":{"TITLE":"Exportação de visitas","CONTENT":"Você receberá a exportação de visitas no e-mail: <b>{{ email }}</b>.<br/><br/>Em horários de pico, esse procedimento pode demorar um pouquinho, combinado?","CONFIRM":"Enviar exportação por e-mail","CANCEL":"Cancelar","CANT_EXPORT":"Não foi possível realizar a exportação"},"CANT_CREATE":"Você não tem permissão para criar atividades.","CANT_EDIT":"Você não tem permissão para editar atividades."},"WARNINGS":{"CUSTOMER_NOT_HAVE_EMAIL":"O cliente não possui um e-mail","RATE_TASK_WITHOUT_EMPLOYEE":"Não é possível avaliar atividades sem colaborador"}},"TABS":{"GENERAL":{"TITLE":"Geral","ORDER_ADDRESS":"Endereço da ordem de serviço","CUSTOMER":{"TOTAL_VIEWS":"Total de visitas","AVERAGE_RATING":"Média de avaliação","OMIE_ACCOUNT":"Cliente importado da conta Omie","LAST_REVIEW":"Última avaliação","PHONES":"Telefones","EMAILS":"E-mails","SCHEDULED_TASKS":"Existem <b>{{ count }} atividades agendadas</b> para o cliente nos próximos dias","SCHEDULED_TASK":"Existe <b>{{ count }} atividade agendada</b> para o cliente em {{ date }}","SHOW_MORE":"Ver mais","SHOW_LESS":"Ver menos","CLEAR":"Limpar cliente"},"FIELDS":{"IDENTIFIER":{"LABEL":"Identificador","ERRORS":{"REQUIRED":"Identificador é obrigatório","IN_USE":"Identificador em uso","CHARACTER_INVALID":"O caractere \'#\' não pode ser inserido"}},"SERVICE":{"LABEL":"Tipo de OS","SELECT":"Selecione um tipo de OS","SEARCH":"Pesquisar tipo de OS...","DURATION":"- {{ duration }} minutos","ERRORS":{"REQUIRED":"Tipo de OS é obrigatório"}},"DEADLINE":{"LABEL":"Prazo","ERRORS":{"INVALID":"Data é inválida"}},"CUSTOMER":{"LABEL":"Cliente","NOT_FOUND":"Nenhum cliente encontrado","ADD":"Nenhum cliente encontrado, adicionar um novo cliente?","REGISTER":"Cadastrar cliente","ENTER_VALUE":"Cliente deve ser selecionado ou pode ser criado clicando no botão <i class=\'md-accent-fg icon icon-account-plus s14\'></i>","OMIE_TOAST_SUCCESS":"Cliente {{name}} importado da Omie com sucesso!","OMIE_UPDATE_SUCCESS":"Dados do cliente {{ogName}} atualizados com os do cliente da Omie {{newName}} com sucesso!","OMIE_TOAST_FAIL":"Não foi possível importar este cliente, cheque suas credenciais na Omie e tente novamente mais tarde.","ERRORS":{"REQUIRED":"Cliente é obrigatório","ADD_TASK_DISABLED_FOR_CORPORATE_CUSTOMER":"Não é possível lançar atividades para uma localização do cliente <b>{{ customerName }}</b>."}},"CUSTOMER_LOCATION":{"LABEL":"Localização","NOT_FOUND":"Nenhuma localização encontrada","ADD":"Nenhum localização encontrada para o cliente, deseja adicionar uma nova localização?","REGISTER":"Cadastrar localização","ENTER_VALUE":"Localização deve ser selecionada","CLEAR":"Limpar localização","ERRORS":{"REQUIRED":"Localização é obrigatório"},"NO_LOCATIONS":{"TEXT":"Esse cliente ainda não possui localizações.","LINK":"Clique aqui para criar uma localização em:"}},"CUSTOMER_ADDRESS":{"LABEL":"Endereço do cliente","DISTANCE":"{{ distance }} km de distância","HINT":"Procure por um endereço, exemplo: Rua dos Pinheiros, 383 - São Paulo","ENTER_VALUE":"Informe o endereço do cliente no campo acima <i class=\'md-accent-fg icon icon-arrow-up-bold s14\'></i>","CLEAR":"Limpar endereço do cliente","ERRORS":{"ADDRESS_NOT_FOUND":"Não foi possível encontrar o endereço, altere sua busca e tente novamente.","REQUIRED":"Endereço do cliente é obrigatório","NUMBER_NOT_SPECIFIED":"O número do endereço não foi especificado."}},"COMPLEMENT":{"LABEL":"Complemento do endereço","ERRORS":{"VALID":"Complemento não deve conter mais de 50 caracteres"}},"DOCUMENT":{"LABEL":"CPF/CNPJ","ERRORS":{"INVALID_CPF":"CPF inválido","INVALID_CNPJ":"CNPJ inválido","NUMBER_DUPLICATED":"Número de CPF/CNPJ duplicado"}},"ZIPCODE":{"LABEL":"CEP","ERRORS":{"REQUIRED":"CEP é obrigatório"}},"CITY":{"LABEL":"Cidade","ERRORS":{"REQUIRED":"Cidade é obrigatório"}},"STATE":{"LABEL":"Estado","ERRORS":{"REQUIRED":"Estado é obrigatório"}},"NEIGHBORHOOD":{"LABEL":"Bairro"},"STREET":{"LABEL":"Logradouro","ERRORS":{"REQUIRED":"Logradouro é obrigatório"}},"NUMBER":{"LABEL":"Número","ERRORS":{"REQUIRED":"Número é obrigatório"}},"LOCAL":{"LABEL":"Local","LAT_LONG":"latitude: {{ lat }}, longitude {{ long }}"},"EMAIL":{"LABEL":"E-mail","HINT":"E-mail principal","SELECT_TYPE":"Tipo do e-mail","REMOVE":"Remover e-mail","ADD":"Adicionar mais um e-mail","ERRORS":{"PATTERN":"E-mail em formato inválido"}},"PHONE":{"CODE":"Código","LABEL":"Telefone","HINT":"Telefone principal","SELECT_TYPE":"Tipo do telefone","REMOVE":"Remover telefone","ADD":"Adicionar mais um telefone","ERRORS":{"NUMBER_INVALID":"Formato de telefone inválido"}},"CUSTOMER_NOTES":{"LABEL":"Observações do cliente"},"DEADLINE_CONTRACT":{"LABEL":"Contrato de prazo","SELECT":"Contrato de prazo","SEARCH":"Pesquisar um contrato...","NO_SLA_CONTRACT":"Nenhum contrato de prazo encontrado"},"DESCRIPTION":{"LABEL":"Descrição da ordem de serviço","ERRORS":{"MAX_LENGTH":"Este campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }} caracteres."},"DEFAULT_FROM_OS":{"NAME":"Nome: ","SUBJECT":"Serviço: ","EMAIL":"E-mail: ","PHONE":"Telefone: ","NUMBER":"Número: ","DATE":"Data: "}},"EMPLOYEE":{"LABEL":"Colaborador","SELECT":"Selecione um colaborador","SEARCH":"Pesquisar colaborador...","NO_EMPLOYEE":"Sem colaborador","INACTIVE":"Inativo","ABSENT":"Ausente","GREATER_THAN_EQUAL_1KM":" - {{ distance }}km de distância","LESS_THAN_1KM":" - {{ distance }}m de distância","ADD_TASK":{"MESSAGE":"Adicionar {{ description }} como tipo de OS realizada?","CONFIRM":"Sim"},"ERRORS":{"DOES_NOT_PERFORM":"Colaborador não realiza atividades do tipo <b>{{ serviceDescription }}</b>","SECONDARY_EMPLOYEES_DOES_NOT_PERFORM":"Os Colaboradores <b>{{ notSkilledEmployees }}</br> não realiza atividades do tipo <b>{{ serviceDescription }}</b>","ALREADY_IN_ACTIVITY":"Esse colaborador está em mais de uma tarefa ao mesmo tempo","REQUIRED":"Colaborador é obrigatório"}},"SECONDARY_EMPLOYEES":{"LABEL":"Outros colaboradores","SELECT":"Selecione outros colaboradores","SEARCH":"Pesquisar colaboradores...","NO_EMPLOYEE":"Sem colaborador","ERRORS":{"SECONDARY_EMPLOYEES_LIMIT":"Uma atividade por ter no máximo 10 colaboradores secundários"}},"DURATION":{"LABEL":"Duração estimada (min)","ERRORS":{"REQUIRED":"Duração é obrigatória","PATTERN":"Duração deve ser um número","MIM":"Duração mínima de 1 minuto","MAX":"Duração maxima de 999 minuto"}},"SCHEDULED_DATE":{"LABEL":"Data do agendamento","ERRORS":{"MIN":"Data retroativa inválida","INVALID":"Data inválida","REQUIRED":"Data é obrigatória","CREATED_AT_IS_AFTER_SCHEDULING_DATE":"A data da visita não pode ser menor que a da data de criação da OS","MUST_BE_NULL":"Não pode haver uma data de agendamento"}},"SCHEDULED_TIME_FORMAT":{"LABEL":"Formato de hora","ERRORS":{"REQUIRED":"Formato de hora é obrigatório"}},"START_TIME_FORMAT":{"LABEL":"Formato de hora de início","ERRORS":{"REQUIRED":"Formato de hora de início é obrigatório"}},"COMPLETED_TIME_FORMAT":{"LABEL":"Formato de hora de conclusão","ERRORS":{"REQUIRED":"Formato de hora de conclusão é obrigatório"}},"TIMEABLE_VISIT":{"LABEL":"Hora do agendamento","ERRORS":{"INVALID":"Horário inválido","GREATER_12_HOURS":"O horário não pode ser maior que 12 horas","MINOR_1_HOUR":"O horário não pode ser menor que 1 hora"}},"TASK_DESCRIPTION":{"LABEL":"Observação da visita","ERRORS":{"MAX_LENGTH":"Este campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }} caracteres."}},"SITUATION":{"LABEL":"Situação"},"STARTED_AT":{"LABEL_DATE":"Data de início","LABEL_TIME":"Hora de início","ERRORS":{"REQUIRED_DATE":"Data é obrigatória","REQUIRED_TIME":"Hora é obrigatório","INVALID_DATE":"Data inválida","INVALID_TIME":"Horário inválido","LESS_THAN":"Data menor que a de criação","TIME_IN_FUTURE":"O início não pode ser maior que a data/hora atual","CREATED_AT_IS_AFTER_STARTED_AT":"A data/hora não pode ser menor que data/hora de criação da OS","TIME_MUST_HAVE_DATE":"A data não pode ficar sem uma hora","DATE_MUST_HAVE_TIME":"A hora não pode ficar sem uma data","GREATER_12_HOURS":"O horário não pode ser maior que 12 horas","MINOR_1_HOUR":"O horário não pode ser menor que 1 hora"}},"COMPLETED_AT":{"LABEL_DATE":"Data de conclusão","LABEL_TIME":"Hora de conclusão","ERRORS":{"REQUIRED_DATE":"Data é obrigatória","REQUIRED_TIME":"Hora é obrigatório","INVALID_DATE":"Data inválida","INVALID_TIME":"Horário inválido","MUST_BE_GREATER":"O momento da conclusão deve ser maior que o de início","TIME_IN_FUTURE":"A conclusão não pode ser maior que a data/hora atual","TIME_MUST_HAVE_DATE":"A data não pode ficar sem uma hora","DATE_MUST_HAVE_TIME":"A hora não pode ficar sem uma data","GREATER_12_HOURS":"O horário não pode ser maior que 12 horas","MINOR_1_HOUR":"O horário não pode ser menor que 1 hora"}},"REPORTED_REASON":{"LABEL":"Motivo do Impedimento","PLACEHOLDER":"Selecione o motivo do impedimento","ERRORS":{"REQUIRED":"Motivo do relato é obrigatório"}},"DONE_DESCRIPTION":{"LABEL":"Descrição da conclusão","PLACEHOLDER":"Descreva a conclusão aqui..."},"CANCELED_DESCRIPTION":{"LABEL":"Descrição do cancelamento","PLACEHOLDER":"Descreva o motivo do cancelamento aqui..."},"IMPEDIMENT_DESCRIPTION":{"LABEL":"Descrição do impedimento","PLACEHOLDER":"Descreva o motivo do impedimento aqui..."}},"MODEL":{"CONTACT_TYPE":{"WORK":"Trabalho","HOME":"Casa","PERSONAL":"Pessoal","MOBILE":"Celular","PRIMARY":"Principal"}},"VISIT":{"TITLE":"Visita {{ index }}","RECEIVED_AT":"Recebido em {{ date }}","VIEWED_AT":"Visualizado em {{ date }}","ARCHIVED":"Arquivada","CTA":"adicionar mais uma visita","ERRORS":{"MUST_BE_FINISHED":"Para adicionar uma <b>nova visita</b>, as anteriores precisam estar concluídas, canceladas ou impedidas"}}},"DEADLINES":{"TITLE":"Prazos","INFO":"Os prazos são calculados de acordo com o <b>contrato de prazos</b> escolhido para esta atividade.","INFO_CONTRACT":"Informações do contrato","NO_DEADLINE":"Essa atividade não tem prazo definido","MODEL":{"CONTRACT_SLA":{"LABEL":"Nome"},"OFFICE_HOURS":{"LABEL":"Horários de atendimento","CUSTOMIZED":"Customizado","NO_CUSTOMIZE":"Corrido"},"CONSIDER_HOLIDAYS":{"LABEL":"Considerar feriados?","CONSIDER":"Sim","NO_CONSIDER":"Não"},"RESPONSE_DEADLINE":{"LABEL":"Tempo para resposta"},"RESPONSE_DEADLINE_RISK":{"LABEL":"Risco de resposta após"},"SOLUTION_DEADLINE":{"LABEL":"Tempo para solução"},"SOLUTION_DEADLINE_RISK":{"LABEL":"Risco de solução após"},"CONSIDERED_DAYS":{"LABEL":"Dias considerados no Contrato","TO":"às","DAYS":{"MONDAY":"Segunda -","TUESDAY":"Terça -","WEDNESDAY":"Quarta -","THURSDAY":"Quinta -","FRIDAY":"Sexta -","SATURDAY":"Sábado -","SUNDAY":"Domingo -","NOT CONSIDERED":"N/A"}},"RESPONSE":{"TITLE":"Prazo de resposta","COMPLETED_AT":{"IN_PROGRESS":"Aguardando conclusão","LABEL":"Concluído em"},"DEADLINE_AT":{"LABEL":"Data/hora limite da resposta"},"SITUATION_DEADLINE":{"LABEL":"Situação do prazo"},"REASON_VIOLATION":{"LABEL":"Motivo da violação","LABEL_NOT_VIOLED":"Prazo não violado","LINKED_BY_ENTERPRISE":"Atribuído por {{ enterpriseAccountName }}","DISABLED_BY_ENTERPRISE_TOOLTIP":"Não é possível fazer alterações, pois o cliente atribuiu essa preferência.","ERRORS":{"REQUIRED":"Motivo de violação é obrigatório"}}},"SOLUTION":{"TITLE":"Prazo de solução","COMPLETED_AT":{"IN_PROGRESS":"Aguardando conclusão","LABEL":"Concluído em"},"DEADLINE_AT":{"LABEL":"Data/hora limite da solução"},"SITUATION_DEADLINE":{"LABEL":"Situação do prazo"},"REASON_VIOLATION":{"LABEL":"Motivo da violação","LABEL_NOT_VIOLED":"Prazo não violado"}}}},"LOCATION":{"TITLE":"Localização","SEARCH_ADDRESS":{"LABEL":"Procurar por endereço","NO_ADDRESS_FOUND":"Nenhum endereço encontrado.","ADDRESS_EXAMPLE":"Para atualizar a localização, procure por um endereço, exemplo: Rua dos Pinheiros, 383 - São Paulo"},"SET_TO_EMPLOYEE":"Considerar localização do colaborador","SET_TO_CUSTOMER":"Considerar localização do cliente","CHANGE_CUSTOMER_ADDRESS":{"MESSAGE":"As informações de geolocalização (latitude e longitude) para essa ordem de serviço foram alteradas. Quer alterar essas informações permanentemente para o cliente <b>{{ customerName }}</b>?","OK":"Sim"},"MAP":{"TASK_LOCATION":"Localização da atividade","LAYERS":{"STANDARD":"Padrão","SATELLITE":"Satélite","ROADMAP":"Estradas","TERRAIN":"Terreno"}}},"FORMS":{"TITLE":"Formulários","FORM":"Formulário","ARCHIVED":"Arquivado","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar","ADDED_AT":"Adicionado em {{ createdAt }}","REPLY":"Responder formulário","EMPTY":"Esse tipo de OS <b>não possui formulários vinculados</b>.","SEARCH":"Pesquisar formulário...","UNANSWERED":"Ordem de serviço não possui formulários respondidos.","RELOAD":"Atualizar formulário","RELOAD_DISABLED":"Apenas formulários em andamento podem ser atualizados.","RATING":"(Avaliação - Visita {{ index }})","EQUIPMENT":"Equipamento","CLICK_OR_DROP_IMAGES":"Clique ou arraste uma imagem","HINT_MESSAGE":"Tamanho máximo da imagem é de 10MB","NOT_SUPPORTED_FILE_DRAG":"O arquivo não é suportado pelo seu navegador","LOADING_PICTURE":"Carregando imagem","VIEW_ORIGINAL":"Ver original","REMOVE_ANSWER":"Remover resposta","UN_ARCHIVE_FORM":"{{ action }} formulário","EQUIPMENT_TAB":"aba de equipamentos.","NO_ITEMS":"Agora, formulários de equipamentos são exibidos na","CLICK_ON_OPTION":"Para tanto, clique na opção \\"Ver formulários respondidos\\" localizada nos 3 pontinhos (...) à direita do equipamento.","MULTIPLE_PICTURES":{"WARNING":"Adicione até 5 imagens com até 10MB cada uma."},"SCORE":{"TITLE":"Pontuação","TOTAL":"Total","NO_VALUE":"sem valor"},"SIGNATURE":{"LOADING":"Enviando assinatura","CONFIRM":"Confirmar assinatura","REMOVE":"Remover assinatura","NO":"Sem assinatura","CANCEL":"Cancelar","EDIT":"Assinar novamente","CLEAR":"Limpar assinatura","ADD":"Adicionar assinatura"},"ALERTS":{"DELETE_FORM":{"MESSAGE":"Tem certeza que deseja excluir o formulário <b>{{ formName }}</b>?","CONFIRM":"Sim","CANCEL":"Melhor não"},"REMOVE_ANSWER":{"MESSAGE":"Tem certeza de que deseja remover esta resposta?","CONFIRM":"Sim","CANCEL":"Não"},"UN_ARCHIVE_FORM":{"MESSAGE":"Tem certeza que quer <b>{{ action }}</b> o formulário \'<b>{{ formName }}</b>\'?","CONFIRM":"Sim","CANCEL":"Melhor não"}},"VALIDATOR":{"REQUIRED_ANSWERS":"Formulário {{ formName }} (perguntas obrigatórias estão sem resposta)","FORM_REQUIRED":"Formulário {{ formName }} é obrigatório"},"ERRORS":{"MAXIMUM_CHARACTERS":"Máximo de {{ limit }} caracteres"},"IN_PROGRESS":"Em andamento","DONE":"Concluído","IN_PROGRESS_ALERT":"Formulários em andamento não podem ser editados.","LOCK_DATE_AND_TIME_CHANGE":"Não é permitido alterar a data/horário de uma sugestão de agendamento aceita."},"COMMENTS":{"TITLE":"Comentários","WRITE_A_COMMENT":"Escreva um comentário","NO_COMMENTS":"Nenhum comentário foi feito","COMMENT_TO_COLLABORATORS":"Comentário para colaboradores","COMMENT_TO_MANAGER":"Comentário para gestores","COMMENT_TO_INTERNAL":"Comentário interno","COMMENT_TO_CORPORATE":"Comentário para ","COMMENT_TO_CORPORATE_BY_COLLABORATOR":"Comentário de colaborador","COMMENT_TO_CORPORATE_BY_MANAGER":"Comentário de gestor","COMMENT_TO_PUBLIC":"Comentário para todos","WRITE_YOUR_MESSAGE_HERE":"Escreva aqui a sua mensagem","WRITE_A_MESSAGE":{"LABEL":"Escreva um comentário para a ordem de serviço...","MAX_LENGTH":"Comentário pode ter no máximo 400 caracteres."},"VISUALIZATION":"Visualização:","PRESS_TO_SEND":"Pressione Enter para enviar e Shift + Enter para pular linha","DELETE":"Excluir","CLIENT":"Cliente","TYPE":{"PUBLIC_MESSAGE":"Comentar para todos","TEAM_MESSAGE":"Comentar para colaboradores","MANAGER_MESSAGE":"Comentar para os gestores","CORPORATE_MESSAGE":"Comentar para {{ name }}","COLLABORATOR_MESSAGE":"Comentar para os colaboradores"},"TOOLTIP_TYPE":{"PUBLIC_VISIBILITY":"Visível para todos","TEAM_VISIBILITY":"Visível somente para a equipe","MANAGER_VISIBILITY":"Visível somente para os gestores","CORPORATE_VISIBILITY":"Visível somente para gestores e {{ name }}","COLLABORATOR_VISIBILITY":"VisíveL para os colaboradores"},"DELETED_MESSAGE":"Este comentário foi excluído.","COMMENTS_STARTED":"Conversa iniciada à ","LOAD_MORE":"Carregar mais comentários","TOASTS":{"COMMENT_DELETED":"Comentário excluído com sucesso."}},"HISTORY":{"TITLE":"Histórico","NO_HISTORY":"Essa ordem de serviço não possui histórico.","OPTIONS":"Opções","SHOW_TIMELINE":"Exibir linha do tempo","GEOGRAPHIC_POSITION":"Posição geográfica:","OFFLINE_CHANGE":"Alteração offline - enviado em","TIMELINE":{"SELECT":"Selecionar histórico de atividade","TASK_CREATED":{"EVENT":"{{ name }} criou a atividade"},"TASK_ARCHIVED":{"TITLE":"Atividade arquivada","TEXT":"{{ name }} <b>arquivou</b> a atividade e a mesma <b>não será exibida</b> na agenda do colaborador.","EVENT":"{{ name }} arquivou a atividade"},"TASK_UNARCHIVED":{"TITLE":"Atividade desarquivada","TEXT":"{{ name }} <b>desarquivou</b> a atividade e a mesma <b>será exibida novamente</b> na agenda do colaborador.","EVENT":"{{ name }} desarquivou a atividade"},"SCHEDULE_CHANGED":{"TITLE":"Data de atendimento alterada","TEXT":"{{ name }} alterou a data de atendimento de <b>{{ fromDate }}</b> para <b>{{ toDate }}</b>.","EVENT":"{{ name }} alterou a data de atendimento"},"EMPLOYEE_CHANGED":{"TITLE":"Colaborador alterado","TEXT":"{{ name }} alterou o colaborador da atividade de <b>{{ previousEmployee }}</b> para <b>{{ currentEmployee }}</b>.","EVENT":"{{ name }} alterou o colaborador"},"EMPLOYEE_ASSIGNED":{"TITLE":"Colaborador atribuído","TEXT":"{{ name }} atribuiu o colaborador <b>{{ employeeName }}</b> para a atividade.","EVENT":"{{ name }} atribuiu um colaborador"},"EMPLOYEE_UNASSIGNED":{"TITLE":"Colaborador removido","TEXT":"{{ name }} removeu o colaborador <b>{{ employeeName }}</b> da a atividade.","EVENT":"{{ name }} removeu o colaborador"},"STATUS_CHANGED":{"TITLE":"Situação alterada","TEXT":"A situação da atividade foi alterada.","EVENT":"{{ name }} alterou a situação","DISTANCE_DESCRIPTION":"à <b>{{ displayDistance }} {{ displayDistanceName }}</b> de distância do local da atividade"},"STATUS_DECRIPTION_CHANGED":{"TITLE":"Descrição da conclusão alterada","TEXT":"A descrição da conclusão foi alterada.","EVENT":"{{ name }} alterou a descrição da conclusão"},"TASK_RATING":{"TITLE":"Avaliação da atividade","EVENT":"O cliente {{ customerName }} avaliou o serviço prestado."},"SENT_BY":{"BROWSER":"Enviado pelo navegador","CELLPHONE":"Enviado pelo celular","ROUTE_PLANNER":"Atualizado pelo planejador automático de rotas","FIELD_CONTROL":"Atualizado pelo sistema","CONTROL_PANEL":"(Painel de controle)","ENTERPRISE":"Atualizado pelo cliente {{ corporateAccount }}","GANDALF":"Atualizado pela Reescrita automática"}}},"MATERIALS":{"TITLE":"Materiais","HINT":"Para garantir uma melhor experiência, realizamos a migração de <span class=\'tw-font-medium\'>\'Materiais\'</span> para <span class=\'tw-font-medium\'>\'Produtos\'</span>. Em breve, a aba <span class=\'tw-font-medium\'>\'Materiais\'</span> e o respectivo módulo serão desativados. <a href=\'https://app.fieldcontrol.com.br/#/materiais\' class=\'hover-link\'><span class=\'tw-text-color-primary tw-font-medium tw-cursor-pointer go-to-links\'>Clique aqui</span></a> para saber mais!","SEARCH":{"LABEL":"Buscar materiais","NOT_FOUND":"Material não encontrado","HINT":"Busque pelo nome do material"},"LINKED_MATERIALS":"Materiais vinculados a esta ordem de serviço:","QUANTITY":"Quantidade de material","UNLINK_MATERIAL":"Desvincular material","UNLINK_ALERT":{"MESSAGE":"Tem certeza que deseja desvincular este material?","YES":"Sim","NO":"Não"},"REQUIRED":"Esse campo é obrigatório","PATTERN":"A quantidade deve ser um número inteiro"},"PRODUCTS":{"TITLE":"Produtos","SEARCH_CUSTOMER":"Buscar por clientes","INFO":"Os produtos utilizados são contabilizados no valor total desta atividade.","INFO-STOCK":"Visualize os produtos utilizados nesta atividade.","SEARCH_PRODUCT":"Busque por um produto","SEARCH_BY_NAME":"Buscar por nome","SEARCH_BY_PRODUCT_OR_STORAGE":"Busque pro um produto ou depósito","LINKED_PRODUCTS":"Produtos vinculados","PRODUCTS_USED":"Produtos utilizados","PRODUCTS_VALUE":"Valor total em produtos:","SERVICES_VALUE":"Valor total em serviços:","TOTAL_VALUE":"Valor total da ordem de serviço:","NO_LINKED_PRODUCTS_FOUND":"Nenhum produto encontrado.","NO_UTILIZED_PRODUCTS_FOUND":"Nenhum produto utilizado.","NO_PRODUCTS_FOUND":"Nenhum produto encontrado.","LINK":"Vincular","LINK_PRODUCTS":"Vincular produtos","REGISTER_PRODUCT":"Registrar uso do produto","VIEW_PRODUCT_DETAILS":"Ver detalhes do produto","RETURN_PRODUCT":"Devolver produtos","SEE_PRODUCT_MOVEMENTS":"Ver movimentações","OMIE_ACCOUNT":"Produto importado da conta Omie","MEASURE":{"milliliter":"Milímetro","centimeter":"Centimetro","kilogram":"Quilograma","gram":"Grama","liter":"Litro","unity":"Unidade","meter":"Metro","null":"Unidade","square-meters":"Metros quadrados","cubic-meters":"Metros cúbicos","tons-refrigeration":"Toneladas de refrigeração","dislocation":"Deslocamento","cjt":"CJT","others":"Outros"},"SAVE_PRODUCTS":"Salvar","LINKED_SUCESS":"Produto vinculado com sucesso.","YOU_CAN_STILL_SELECT":"Você ainda pode selecionar {{ selectedProducts }} produtos para vincular a esta ordem de serviço.","MAXIMUM_LIMIT_REACHED":"Limite máximo de produtos por ordem de serviço atingido.","MAXIMUM_LIMIT_REACHED_TOOLTIP":"Limite de produtos selecionados atingido.","QUANTITY":"Quantidade","VALUE":"Valor","REQUIRED":"Quantidade é obrigatória","VALUE_REQUIRED":"Valor é obrigatório","INVALID_CHARACTER":"Caracter inválido","MIN_NUMBER_ERROR":"Quantidade tem que ser maior que 0","VALUE_MIN_NUMBER_ERROR":"Valor tem que ser maior ou igual a 0","MAX_LENGTH":"Tamanho máximo excedido","ALREADY_LINKED":"Produto já está vinculado.","LOADING":"Carregando produtos...","TABLE":{"NAME":"Nome","QUANTITY":"Quantidade","STORAGE":"Depósito","UNIT_VALUE":"Valor unitário","TOTAL_VALUE":"Valor total","ACTIONS":"Ações"},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Próxima","SHOWING_FROM":"Mostrando de","TO":"até","OF":"de","ITEMS":"itens."},"CONFIRM_DELETE_DIALOG":{"TITLE":"Remover produto","MESSAGE":"Tem certeza que deseja remover o produto <b>{{ name }}</b>?","YES":"Sim","NO":"Não","SUCESS":"Produto removido com sucesso."},"PRODUCTS_TO_ORDER":"produtos para vincular a esta ordem de serviço."},"SERVICES":{"TITLE":"Serviços","INFO":"Os serviços realizados são contabilizados no valor total desta atividade.","SEARCH_SERVICE":"Busque pelo nome do serviço","LINKED_SERVICES":"Serviços realizados","PRODUCTS_VALUE":"Valor total em produtos:","SERVICES_VALUE":"Valor total em serviços:","TOTAL_VALUE":"Valor total da ordem de serviço:","NO_LINKED_SERVICES_FOUND":"Nenhum serviço vinculado.","NO_SERVICES_FOUND":"Nenhum serviço encontrado.","LINK":"Vincular","LINK_SERVICES":"Vincular serviços","SAVE_SERVICES":"Salvar","LINKED_SUCESS":"Serviço vinculado com sucesso.","YOU_CAN_STILL_SELECT":"Você ainda pode selecionar {{ selectedServices }} serviços para vincular a esta ordem de serviço.","MAXIMUM_LIMIT_REACHED":"Limite máximo de serviços por ordem de serviço atingido.","MAXIMUM_LIMIT_REACHED_TOOLTIP":"Limite de serviços selecionados atingido.","QUANTITY":"Quantidade","VALUE":"Valor","REQUIRED":"Quantidade é obrigatória","VALUE_REQUIRED":"Valor é obrigatório","INVALID_CHARACTER":"Caracter inválido","MIN_NUMBER_ERROR":"Quantidade tem que ser maior que 0","VALUE_MIN_NUMBER_ERROR":"Valor tem que ser maior ou igual a 0","MAX_LENGTH":"Tamanho máximo excedido","ALREADY_LINKED":"Serviço já está vinculado.","LOADING":"Carregando serviços...","OMIE_ACCOUNT":"Serviço importado da conta Omie","TABLE":{"NAME":"Nome","QUANTITY":"Quantidade","UNIT_VALUE":"Valor unitário","TOTAL_VALUE":"Valor total","ACTIONS":"Ações"},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Próxima","SHOWING_FROM":"Mostrando de","TO":"até","OF":"de","ITEMS":"itens."},"CONFIRM_DELETE_DIALOG":{"TITLE":"Remover serviço","MESSAGE":"Tem certeza que deseja remover o serviço <b>{{ name }}</b>?","YES":"Sim","NO":"Não","SUCESS":"Serviço removido com sucesso."},"SERVICES_TO_ORDER":"serviços para vincular a esta ordem de serviço."},"STORAGES_MOVEMENTS":{"TITLE":"Movimentações","INFO":"Acompanhe e realize movimentações de produtos.","SEARCH_PRODUCT_OR_STORAGE":"Busque por um produto ou depósito","NEW_MOVEMENT":"Nova movimentação","REMOVAL_MOVEMENT":"Movimentações de saída ({{ quantity }})","LOADING":"Carregando serviços...","NO_LINKED_MOVEMENTS_FOUND":"Nenhuma movimentação encontrada","TABLE":{"DATE_TIME":"Data/Hora","PRODUCT":"Produto","QUANTITY":"Quantidade","STORAGE":"Depósito","TYPE":"Tipo","ENTRY":"Entrada","REMOVAL":"Saída","SEE_MOVEMENTS":"Ver movimentação"},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Próxima","SHOWING_FROM":"Mostrando de","TO":"até","OF":"de","ITEMS":"itens."},"SUCCESSFULLY_CREATED":"Movimentação criada com sucesso.","SUCCESSFULLY_EDITED":"Movimentação editada com sucesso."},"PENDENCIES":{"TITLE":"Pendências","HEADLINE":"Pendências ({{ totalCount }})","ADD":"Adicionar nova pendência","LOAD_MORE":"Carregar mais","EMPTY_STATE":"Nenhuma pendência vinculada. Clique aqui para criar.","EMPTY_STATE_NO_PERMISSIONS":"Você não possui permissão para criar pendências.","ITEM":{"DESCRIPTION":"ID {{ identifier }} | Tipo da pendência: {{ pendencyType }}","TREATMENT_STATUS":{"AWAITING_COMPANY":"Aguardando empresa","AWAITING_MANAGEMENT":"Aguardando gestão"},"STATUS":{"OPENED":"Em aberto","DONE":"Finalizada"},"TOOLTIPS":{"ASSIGNEE":"Usuário responsável: {{ assignee }}","NO_ASSIGNEE":"Sem usuário responsável","VIEW_PENDENCY":"Acessar pendência","BLOCK_ASSIGNEE":"Não é possível alterar o responsável de uma pendência finalizada.","NO_PERMISSION":"Você não tem permissão para alterar o responsável de uma pendência."}},"UPDATE_PENDENCY_ASSIGNEE":{"SUCCESS":"Responsável vinculado com sucesso.","SUCCESS_UPDATE":"Responsável alterado com sucesso.","ERROR":"Ocorreu um erro ao vincular o responsável. Tente novamente mais tarde."},"SUCCESSFULLY_SAVED":"Pendência criada com sucesso."},"EQUIPMENTS":{"TITLE":"Equipamentos","EQUIPMENTS":"Equipamentos","SEARCH":{"LABEL":"Procurar por equipamentos","NOT_FOUND":"Nenhum equipamento encontrado.","HINT":"Busque pelo nome ou número de série."},"LINKED_EQUIPMENTS":{"TITLE":"Equipamentos vinculados","REMOVE":"Remover equipamento","LABEL":"Procurar por equipamento vinculado","LINK":"Vincular equipamentos","LINK_NEW":"Vincular","SELECTED":"Equipamento já vinculado","SAVE_EQUIPMENTS":"Salvar","UNLINK_ALERT":{"MESSAGE":"Tem certeza que deseja desvincular este equipamento?","YES":"Sim","NO":"Não"},"YOU_CAN_STILL_SELECT":"Você ainda pode selecionar","EQUIPMENTS_TO_ORDER":"equipamentos para vincular a esta ordem de serviço.","MAXIMUM_LIMIT_REACHED":"Limite máximo de equipamentos por ordem de serviço atingido."},"NAVIGATION":{"PREVIOUS":"Anterior","NEXT":"Próximo","SHOWING_FROM":"Mostrando de","TO":"até","OF":"de","RECORDS":"registros"},"CUSTOMER_WITHOUT_EQUIPMENTS":"Essa localização não possui equipamentos cadastrados.","FORMS_EQUIPMENT":{"BUTTON_OPTIONS":{"VIEW_COMPLETED_FORMS":"Ver formulários respondidos","ANSWER_FORMS":"Responder formulários","UNLINK_EQUIPMENT":"Desvincular equipamento","NO_PERMISSION_WARN":"Sem permissão","NO_PERMISSION_WARN_CREATE_TASK":"Você não possui permissão para criar atividades","NO_PERMISSION_WARN_EDIT_TASK":"Você não possui permissão para editar atividades","NO_PERMISSION_WARN_CREATE_RECURRENCE":"Você não possui permissão para criar recorrências","NO_PERMISSION_WARN_EDIT_RECURRENCE":"Você não possui permissão para editar recorrências","NO_PERMISSION_WARN_CREATE_PLAN":"Você não possui permissão para criar plano de atividade","NO_PERMISSION_WARN_EDIT_PLAN":"Você não possui permissão para editar plano de atividade"},"SEARCH_EQUIPMENTS":{"ANSWER_EQUIPMENTS_FORMS":"Responder formulários do equipamento","REPLY":"Responder formulário","SEARCH_FORM":"Buscar formulário","SEARCH_FORMS_LINKED_EQUIPMENT":"Busque por formulários vinculados a este equipamento.","VIEW_COMPLETED_EQUIPMENT_FORMS":"Ver formulários respondidos do equipamento","FORMS_AVAILABLE":"Formulários disponíveis","REQUIRED":"Obrigatório","OPTIONAL":"Opcional","ANSWER":"Responder","BACK":"Voltar","ANSWERED_BY":"Respondido por","ANSWERED_AT":"Respondido em","ANSWERS":"Respostas ({{ quantity }})","ALL_FORMS":"Todos os formulários","INSERT_ATTACHMENTS":"Inserir anexos","STATUS":"Situação","FORM_LENGTH":"{{ LENGTH }} perguntas"},"ARCHIVED":{"FORMS_IS_ARCHIVED":"Esse formulário está arquivado","TITLE":"Arquivar formulário de equipamento","ARE_YOU_SURE":"Tem certeza que deseja arquivar o formulário {{ formName }}?","NO":"Não","YES":"Sim"}}},"QUOTATIONS":{"TITLE":"Orçamentos","INFO":"Adicione orçamentos a esta ordem de serviço.","LINKED":"Orçamentos vinculados ({{ quotations }}/{{ maxAllowed }})","SEE":"Ver orçamento","REMOVE":"Remover orçamento","APPROVED_AT":"Aprovado em {{ approvedAt }}","REFUSED_AT":"Recusado em {{ refusedAt }}","NO_ITEMS":"Nenhum orçamento vinculado, é possível vincular um orçamento usando a barra de pesquisa acima.","PRODUCTS":"{{ quantity }} produto(s)","SERVICES":"{{ quantity }} serviço(s)","VALUE":"Valor: {{ value }}","SUBTOTAL":"Subtotal:","DISCOUNT":"Desconto:","TOTAL":"Valor total:","SEARCH":"Buscar por orçamentos","SEARCH_HINT":"Busque pelo nome de um orçamento ou pelo seu identificador.","CREATE":"Cadastrar novo","MAX_ALLOWED":"Limite máximo de orçamentos por ordem de serviço atingido.","ARCHIVED":"Arquivado","LINK_CONFIRM_DIALOG":{"TITLE":"Vincular itens do orçamento na ordem de serviço","DESCRIPTION":"Deseja vincular os serviços e produtos não vinculados do orçamento na ordem de serviço?","YES":"Sim","NO":"Não"},"STATUS":{"TITLE":"Situação","PENDING":"Pendente","APPROVED":"Aprovado","REFUSED":"Recusado","EXPIRED":"Expirado","CANCELED":"Cancelado"}},"ATTACHMENTS":{"TITLE":"Anexos","DROP_HERE":"Arraste seus arquivos para fazer upload","NOT_SUPPORTED_FILE_DRAG":"O arquivo não é suportado pelo seu navegador","ATTACHMENT_DESCRIPTION":"Limite de 20 anexos pelo Painel do gestor. Não há limite de anexos no aplicativo do colaborador. Tamanho máximo 10MB por arquivo ou 50MB para vídeos ou imagens","INSERT_FILES":"Inserir arquivos","INSERT_FILES_ALTERNATIVE":"Arraste seus arquivos para fazer upload ou","SEND_FILES":"Enviar arquivos","NO_ATTACHMENTS_ADDED":"Nenhum anexo foi adicionado para essa ordem de serviço.","SEARCHING_ATTACHMENTS":"Buscando anexos da ordem de serviço","ATTACHMENTS_LIMIT_REACHED":"Limite de anexos atingido, para adicionar mais anexos você precisa remover alguns primeiro.","MAX_SIZE_FILES":"Este arquivo excede o limite de 10MB","MAX_SIZE_BIG_FILES":"Este arquivo excede o limite de 50MB","MIN_SIZE_FILES":"Este arquivo não atende o tamanho mínimo de 1KB","FILES":{"MOVE_UP":"Mover para cima","MOVE_DOWN":"Mover para baixo","SAVE_EDIT":"Salvar título","CANCEL_EDIT":"Cancelar","NO_TITLE":"Sem título","RENAME":"Renomear","SIGNATURE":"Assinatura","EDIT_TITLE":"Editar título do anexo","EDIT_CUSTOMER_NAME":"Editar nome do cliente","OF":"de","ADDED_AT":"Criado em {{ date }} às {{ hour }}","EDIT":"Editar","VIEW_ORIGINAL":"Ver original","ARCHIVED":"Arquivado","ACTIONS":{"REMOVE":"Remover anexo","ARCHIVE":"Arquivar anexo","UNARCHIVE":"Desarquivar anexo"},"ALERTS":{"REMOVE_SIGNATURE":"Tem certeza que deseja <strong>remover</strong> esta assinatura?","REMOVE_ATTACHMENT":"Tem certeza que deseja <strong>remover</strong> este anexo?","ARCHIVE_SIGNATURE":"Tem certeza que deseja <strong>arquivar</strong> esta assinatura?","ARCHIVE_ATTACHMENT":"Tem certeza que deseja <strong>arquivar</strong> este anexo?","YES":"Sim","NO":"Não"}},"LINK":"LINK"},"OFFLINE":{"TITLE":"Sincronizações (beta)","NO_SYNC":"Não há sincronizações para essa ordem de serviço","INFO":"Assim que o técnico ficar com internet, suas sincronizações offline dessa O.S aparecerão aqui.","STATUS":{"PENDING":"Ainda não sincronizado","IN_PROGRESS":"Sincronizando","DONE":"Sincronizado","ERROR":"Erro ao sincronzar"}},"ROUTES":{"TITLE":"Trajetos","ESTIMATED_ROUTE":"Trajeto estipulado","TOTAL_KILOMETERS":"Quilometragem total: {{ kmTotal }} km","START_ROUTE":"Ponto inicial do trajeto","INTERMEDIATE_ROUTE":"Ponto intermediário do trajeto","END_ROUTE":"Ponto final do trajeto","COMPANY_ADDRESS":"Endereço da sua empresa","CUSTOMER_ADDRESS":"Endereço do cliente","MAP":{"LAYERS":{"DEFAULT":"Padrão","SATELLITE":"Satélite","ROADS":"Estradas","GROUND":"Terreno"},"CENTRALIZE":"Centralizar","GROUP_VISITS":"Agrupar visitas"}},"LINKS":{"TITLE":"Vínculos"}},"WARNINGS":{"TITLE":"Atenção","CANT_EDIT":"Você não tem permissão para editar atividades","CONTENT":"Remova os equipamentos do cliente/localização atual para prosseguir com essa alteração","BUTTON":"Fechar"},"EMPLOYEE_WARNING":{"TITLE":"Colaboradores fora da região de atendimento","CONTENT":"Alguns colaboradores não estão na região de atendimento, portanto, serão desvinculados da atividade.","BUTTON":"Fechar"},"ROUTERIZATION":{"SUCCESS_MESSAGE":"As atividades foram salvas com sucesso"},"LAUNCH_DIALOG":{"TITLE":"🚀 Lançamento da Nova ordem de serviço","DESCRIPTION":"Temos uma grande novidade para você! A tela de criação e edição de ordens de serviço foi completamente atualizada! Agora, ela conta com um design mais moderno e organizado, proporcionando uma experiência de uso mais intuitiva e facilitando seu aprendizado. Todos os recursos permanecem disponíveis e, para ajudar a entender as mudanças, incluímos um vídeo explicativo abaixo.","VIDEO_TEXT":"📺 Assista ao vídeo abaixo para saber mais!","LEFT_BUTTON":"Cancelar","RIGHT_BUTTON":"Testar nova versão"}},"TOASTS":{"FILTERS":{"CUSTOM_FILTER_SAVED":"Filtro customizado \'{{ filterName }}\' foi salvo com sucesso.","CUSTOM_FILTER_DELETED":"Filtro customizado \'{{ filterName }}\' foi excluído com sucesso."},"GENERAL":{"CUSTOMER_REGISTERED":"Cliente {{ customerName }} cadastrado com sucesso."},"LOCATION":{"CUSTOMER_GEOLOCATION_UPDATED":"Pronto! As informações de geolocalização (latitude e longitude) foram atualizadas para o cliente {{ customerName }}."},"SERVICES_TYPE":{"CUSTOMER_SERVICE_ADDED_TO_SECONDARY_EMPLOYEES":"Feito! O tipo de tarefa {{ serviceDescription }} agora pode ser adicionado para colaboradores secundários.","CUSTOMER_SERVICE_ADDED":"Pronto! O tipo de OS {{ serviceDescription }} agora pode ser adicionado para {{ employeeName }}."},"EQUIPMENTS":{"EQUIPMENT_UNLINKED":"Equipamento desvinculado com sucesso"},"ATTACHMENTS":{"TITLE_UPDATED":"Título do anexo alterado com sucesso.","IMAGES_UPLOADED":"Os anexos foram enviados com sucesso.","SIGNATURE_REMOVED":"A assinatura foi removida com sucesso!","SUCCESSFULLY_ARCHIVED":"O anexo foi arquivado com sucesso!","SUCCESSFULLY_UNARCHIVED":"O anexo foi desarquivado com sucesso!","SUCCESSFULLY_REMOVED":"O anexo foi removido com sucesso!"},"FORMS":{"FORM_UPDATED":{"SUCCESS":"Formulário {{ formName }} {{ action }} com sucesso!","FAILED":"Não foi possível {{ action }} o formulário {{ formName }}, tente novamente.","ARCHIVE":"arquivar","ARCHIVED":"Formulário de equipamento arquivado com sucesso!","SAVE":"salvo","UNARCHIVE":"desarquivar","UNARCHIVED":"Formulário de equipamento desarquivado com sucesso!"},"FORM_CREATED":{"CREATED":"Formulário {{ formName }} criado com sucesso!"},"INCOMPATIBLE_FILE":"Por favor, selecione um arquivo compatível","UPLOAD_FAILED":"Não foi possível enviar a imagem, tente novamente."},"DIALOG_ACTIONS":{"LINK_COPIED":{"MESSAGE":"O link {{ type }} #{{ id }} foi copiado para área de transferência.","FROM_REPORT":"do relatório","TO_EVALUATION":"para a avaliação da atividade"},"EVALUATION_LINK_SENDED":"O link de avaliação será enviado para o cliente {{ customerName }} nos e-mails selecionados.","REPORT_LINK_SENDED":"O link com o relatório da atividade será enviado para o cliente {{ customerName }} nos e-mails selecionados.","EMPLOYEE_LOCATION_SENDED":"O link com a localização do colaborador será enviado para o cliente {{ customerName }} nos e-mails selecionados.","TASK_ARCHIVED":"Atividade {{ customerName }} #{{ id }} arquivada com sucesso.","TASK_UNARCHIVED":"Atividade {{ customerName }} #{{ id }} desarquivada com sucesso.","TASK_SAVED":"Atividade {{ customerName }} #{{ id }} salva com sucesso.","EXPORT_ERROR":"Não foi possível solicitar sua exportação, tente novamente...","SEND_TO_EMAIL":"Você receberá a exportação de atividades no e-mail: {{ email }}.","TASK_WITHOUT_EMPLOYEE":"Não é possível avaliar atividades sem colaborador"},"TICKETS":{"EXPIRED":"Essa solicitação está expirada ou já foi resolvida!","ACCEPT_FAILED":"Ocorreu um erro ao aceitar a solicitação de serviço, por favor tente novamente.","ACCEPT_FAILED_DUPLICATED":"Ocorreu um erro ao aceitar a solicitação de serviço! Esse ticket já foi utilizado."},"EXPORT":{"TITLE":"Exportação em PDF solicitada","EXCEL_TITLE":"Exportação em Excel solicitada"}},"INTEGRATIONS":{"CONTA_AZUL":{"ERROR":{"NOT_PROVIDED":"Erro no produto/serviço, verifique se foi informado ou possui estoque no Conta Azul.","UNAUTHORIZED":"Não autorizado","INVALID_FIELD":"A venda não foi criada, pois pode possuir um campo: (inválido, nulo ou desconhecido)"}}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/tickets/i18n/en.json',
    '{"TICKETS":{"PAGE_TITLE":"Tickets"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/tickets/i18n/es.json',
    '{"TICKETS":{"PAGE_TITLE":"Solicitudes"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/tickets/i18n/pt.json',
    '{"TICKETS":{"PAGE_TITLE":"Solicitações"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/vehicles/i18n/en.json',
    '{"VEHICLES":{"TITLE":"Vehicles","EDIT":"Edit","TUTORIAL_VIDEO":{"TITLE":"Instructions","TOOLTIP":"Watch tutorial video"},"FILTERS":{"TITLE":"Filter vehicles","NAME":"Search by name","LICENSE_PLATE":"Search by license plate","STATUS":"Filter by status","DISPONIBILITY":"Filter by availability","TYPE":"Filter by type","ORIGIN":"Filter by origin","CLEAR":"Clear filters"},"TABLE":{"CREATE_VEHICLE_CTA":"You can create a new vehicle","CREATE_VEHICLE_LINK":"by clicking here","COLUMNS":{"NAME":"Vehicle name","LICENSE_PLATE_NUMBER":"License Plate","REGISTER":"Register","MODEL":"Model","BRAND":"Brand","YEAR":"Year","CATEGORY":"Category","ORIGIN":"Origin","STATUS":"Status","DISPONIBILITY":"Availability","ACTIONS":"Actions"}},"TOOLBAR":{"FILTER":"Filter","CLEAR_FILTERS":"Clear filters","RELOAD":"Reload","ADD":"Add vehicle","GENERATE_QR_CODE":"Generate QR Code"},"DIALOG":{"WARNING":"Add a main image and define the vehicle\'s information.","VEHICLE_CHARACTERISTICS":"Vehicle characteristics","DOWNLOAD_QR_CODE":"Download","PHOTO_RULES":"The ideal image dimensions are 512px x 512px, with a maximum size of 2 MB.","SELECT_IMAGES":"Select image","EDIT":{"TITLE":"Edit vehicle","SAVE":"Save"},"NEW":{"TITLE":"New vehicle","CREATE":"Create"},"TABS":{"GENERAL":"GENERAL","QR_CODE":"QR CODE","FORMS":"FORMS"},"ACTIONS":{"ARCHIVE":"Archive","UNARCHIVE":"Unarchive"}},"TOAST":{"ERRORS":{"IMAGE_UPLOAD":"Failed to save vehicle image.","ERROR_TO_SAVE":"There was an error while saving.","UNARCHIVE_DUPLICATE_NAME":"There is already an active vehicle with this name. Rename it before unarchiving."},"SUCCESS":{"VEHICLE_SAVED":"Vehicle \'{{name}}\' saved."}},"MODEL":{"NAME":"Vehicle name","REGISTER":"Register","LICENSE_PLATE":"License plate (AAA-9999)","BRAND":"Brand","MODEL":"Model","YEAR":"Year","COLOR":"Color","STATUS":"Status","DISPONIBILITY":"Availability","TYPE":"Type","ORIGIN":"Origin","INITIAL_KILOMETERS":"Initial kilometers (Km)","OBSERVATIONS":"Observations","ALL":"All","QR_CODE":{"GENERATE":"Generate QR code","DOWNLOAD_LINK_MESSAGE":"View QR code","GENERATE_QRCODE":"Click here to generate the QR Code","VIEW_QRCODE":"View vehicle\'s QR code","GENERATE_QRCODE_MANDATORY":"Click here to generate the QR Code*","MODAL":{"GENERATE":"Generate QR Code","GENERATE_ANOTHER_CODE":"Generate another code","SAVE":"Save","DOWNLOAD":"Download","SAVED_SUCCESSFULLY":"QR Code changed, save the vehicle to update."}},"ERRORS":{"FIELD_REQUIRED":"Field required.","NAME_REQUIRED":"Name is required","DUPLICATE_NAME":"A vehicle with this name already exists.","LICENSE_PLATE_REQUIRED":"License plate is required","TYPE_REQUIRED":"Type is required","ORIGIN_REQUIRED":"Origin is required","FIELD_IS_REQUIRED":"Field is required","INVALID_LICENSE_PLATE":"Invalid license plate for Mercosur","DESCRIPTION_MAXLENGTH":"This field must have a maximum of {{ expectedLength }} characters, but it has {{ receivedLength }}."},"TYPES_OPTIONS":{"CAR":"Car","MOTORCYCLE":"Motorcycle","NAUTICAL":"Nautical","TRUCK":"Truck","SEMI_TRUCK":"Semi Truck"},"STATUS_OPTIONS":{"AVAILABLE":"Available","UNAVAILABLE":"Unavailable"},"ORIGINS_OPTIONS":{"RENTED":"Rented","COMPANY":"Company","EMPLOYEE":"Employee"},"COLORS_OPTIONS":{"YELLOW":"Yellow","BLUE":"Blue","BEIGE":"Beige","WHITE":"White","BRONZE":"Bronze","GRAY":"Gray","GOLDEN":"Golden","UNDEFINED":"Other","ORANGE":"Orange","BROWN":"Brown","SILVER":"Silver","BLACK":"Black","PINK":"Pink","PURPLE":"Purple","GREEN":"Green","RED":"Red","WINE":"Wine"},"ARCHIVED_OPTIONS":{"ARCHIVED":"Archived","UNARCHIVED":"Active"}},"FORMS":{"WARNING":"Add forms and set the obligation of each one during the pickup and return of a vehicle.","PICKUP-TITLE":"Vehicle pickup","RETURN-TITLE":"Vehicle return","REQUIRED_FORM":"Required form","OPTIONAL_FORM":"Optional form","SEARCH_PHRASE":"Search forms to link","CHOOSE_FORM":"Choose form"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/vehicles/i18n/es.json',
    '{"VEHICLES":{"TITLE":"Vehículos","EDIT":"Editar","TUTORIAL_VIDEO":{"TITLE":"Instrucciones","TOOLTIP":"Ver video tutorial"},"FILTERS":{"TITLE":"Filtrar vehículos","NAME":"Buscar por nombre","LICENSE_PLATE":"Buscar por placa","STATUS":"Filtrar por estado","DISPONIBILITY":"Filtrar por disponibilidad","TYPE":"Filtrar por tipo","ORIGIN":"Filtrar por origen","CLEAR":"Limpiar filtros"},"TABLE":{"CREATE_VEHICLE_CTA":"Puede crear un nuevo vehículo","CREATE_VEHICLE_LINK":"haciendo clic aquí","COLUMNS":{"NAME":"Nombre del vehículo","LICENSE_PLATE_NUMBER":"Placa","REGISTER":"Registro","MODEL":"Modelo","BRAND":"Marca","YEAR":"Año","CATEGORY":"Categoría","ORIGIN":"Origen","STATUS":"Estado","DISPONIBILITY":"Disponibilidad","ACTIONS":"Acciones"}},"TOOLBAR":{"FILTER":"Filtrar","CLEAR_FILTERS":"Limpiar filtros","RELOAD":"Recargar","ADD":"Agregar vehículo","GENERATE_QR_CODE":"Generar código QR"},"DIALOG":{"WARNING":"Agregue una imagen principal y defina la información del vehículo.","VEHICLE_CHARACTERISTICS":"Características del vehículo","DOWNLOAD_QR_CODE":"Descargar","SELECT_IMAGES":"Seleccionar imagen","PHOTO_RULES":"Las dimensiones ideales de la imagen son 512 px x 512 px, con un tamaño máximo de 2MB.","EDIT":{"TITLE":"Editar vehículo","SAVE":"Guardar"},"NEW":{"TITLE":"Nuevo vehículo","CREATE":"Crear"},"TABS":{"GENERAL":"GENERAL","QR_CODE":"QR CODE","FORMS":"FORMULARIOS"},"ACTIONS":{"ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar"}},"TOAST":{"ERRORS":{"IMAGE_UPLOAD":"Error al guardar la imagen del vehículo.","ERROR_TO_SAVE":"Hubo un error al guardar.","UNARCHIVE_DUPLICATE_NAME":"Ya existe un vehículo activo con ese nombre. Cámbialo antes de desarchivarlo."},"SUCCESS":{"VEHICLE_SAVED":"Vehículo \'{{name}}\' guardado."}},"MODEL":{"NAME":"Nombre del vehículo","REGISTER":"Registro","LICENSE_PLATE":"Placa (AAA-9999)","BRAND":"Marca","MODEL":"Modelo","YEAR":"Año","COLOR":"Color","STATUS":"Estado","DISPONIBILITY":"Disponibilidad","TYPE":"Tipo","ORIGIN":"Origen","INITIAL_KILOMETERS":"Kilometraje inicial (Km)","OBSERVATIONS":"Observaciones","ALL":"Todos","QR_CODE":{"GENERATE":"Generar código QR","DOWNLOAD_LINK_MESSAGE":"Ver código QR","GENERATE_QRCODE":"Haga clic aquí para generar el código QR","VIEW_QRCODE":"Ver código QR del vehículo","GENERATE_QRCODE_MANDATORY":"Haga clic aquí para generar el código QR*","MODAL":{"GENERATE":"Generar código QR","GENERATE_ANOTHER_CODE":"Generar otro código","SAVE":"Guardar","DOWNLOAD":"Descargar","SAVED_SUCCESSFULLY":"Código QR cambiado, guarde el vehículo para actualizar."}},"ERRORS":{"FIELD_REQUIRED":"Campo obligatorio.","DUPLICATE_NAME":"Ya existe un vehículo con este nombre","NAME_REQUIRED":"El nombre es obligatorio","LICENSE_PLATE_REQUIRED":"La placa es obligatoria","TYPE_REQUIRED":"El tipo es obligatorio","ORIGIN_REQUIRED":"El origen es obligatorio","FIELD_IS_REQUIRED":"El campo es obligatorio","INVALID_LICENSE_PLATE":"Placa inválida para Mercosur","DESCRIPTION_MAXLENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}."},"TYPES_OPTIONS":{"CAR":"Automóvil","MOTORCYCLE":"Motocicleta","NAUTICAL":"Náutico","TRUCK":"Camión","SEMI_TRUCK":"Carreta"},"STATUS_OPTIONS":{"AVAILABLE":"Disponible","UNAVAILABLE":"Indisponible"},"ORIGINS_OPTIONS":{"RENTED":"Alquilado","COMPANY":"Empresa","EMPLOYEE":"Empleado"},"COLORS_OPTIONS":{"YELLOW":"Amarillo","BLUE":"Azul","BEIGE":"Beige","WHITE":"Blanco","BRONZE":"Bronce","GRAY":"Gris","GOLDEN":"Dorado","UNDEFINED":"Otro","ORANGE":"Naranja","BROWN":"Marrón","SILVER":"Plateado","BLACK":"Negro","PINK":"Rosa","PURPLE":"Morado","GREEN":"Verde","RED":"Rojo","WINE":"Vino"},"ARCHIVED_OPTIONS":{"ARCHIVED":"Archivado","UNARCHIVED":"Activo"}},"FORMS":{"WARNING":"Agregue formularios y establezca la obligación de cada uno durante la recogida y devolución de un vehículo.","PICKUP-TITLE":"Recogida del vehículo","RETURN-TITLE":"Devolución del vehículo","REQUIRED_FORM":"Formulario obligatorio","OPTIONAL_FORM":"Formulario opcional","SEARCH_PHRASE":"Buscar formularios para vincular","CHOOSE_FORM":"Elegir formulario"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/vehicles/i18n/pt.json',
    '{"VEHICLES":{"TITLE":"Veículos","EDIT":"Editar","TUTORIAL_VIDEO":{"TITLE":"Instruções","TOOLTIP":"Assistir vídeo explicativo"},"FILTERS":{"TITLE":"Filtrar veículos","NAME":"Pesquisar nome","LICENSE_PLATE":"Pesquisar placa","STATUS":"Filtrar por situação","DISPONIBILITY":"Filtrar por disponibilidade","TYPE":"Filtrar por tipo","ORIGIN":"Filtrar por origem","CLEAR":"Limpar filtros"},"TABLE":{"CREATE_VEHICLE_CTA":"Você pode criar um novo veículo","CREATE_VEHICLE_LINK":"Clicando aqui","COLUMNS":{"NAME":"Nome do veículo","LICENSE_PLATE_NUMBER":"Placa","REGISTER":"Registro","MODEL":"Modelo","BRAND":"Marca","YEAR":"Ano","CATEGORY":"Categoria","ORIGIN":"Origem","STATUS":"Situação","DISPONIBILITY":"Disponibilidade","ACTIONS":"Ações"}},"TOOLBAR":{"FILTER":"Filtrar","CLEAR_FILTERS":"Limpar filtros","RELOAD":"Recarregar","ADD":"Adicionar veículo","GENERATE_QR_CODE":"Gerar código QR"},"DIALOG":{"WARNING":"Adicione uma imagem principal e defina as informações do veículo.","VEHICLE_CHARACTERISTICS":"Caracteristícas do veículo","DOWNLOAD_QR_CODE":"Baixar","PHOTO_RULES":"As dimensões ideais da imagem são 512px x 512px, com tamanho máximo de 2MB.","SELECT_IMAGES":"Selecionar imagem","EDIT":{"TITLE":"Editar veículo","SAVE":"Salvar"},"NEW":{"TITLE":"Novo veículo","CREATE":"Criar"},"TABS":{"GENERAL":"GERAL","QR_CODE":"QR CODE","FORMS":"FORMULÁRIOS"},"ACTIONS":{"ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"}},"TOAST":{"ERRORS":{"IMAGE_UPLOAD":"Falha ao salvar a imagem do veículo.","ERROR_TO_SAVE":"Houve um erro ao salvar.","UNARCHIVE_DUPLICATE_NAME":"Já existe um veículo ativo com esse nome. Renomeie antes de desarquivar."},"SUCCESS":{"VEHICLE_SAVED":"Veículo \'{{name}}\' salvo."}},"MODEL":{"NAME":"Nome do veículo","REGISTER":"Registro","LICENSE_PLATE":"Placa (AAA-9999)","BRAND":"Marca","MODEL":"Modelo","YEAR":"Ano","COLOR":"Cor","STATUS":"Situação","DISPONIBILITY":"Disponibilidade","TYPE":"Tipo","ORIGIN":"Origem","INITIAL_KILOMETERS":"Quilometragem inicial (Km)","OBSERVATIONS":"Observações","ALL":"Todos","QR_CODE":{"GENERATE":"Gerar código QR","DOWNLOAD_LINK_MESSAGE":"Ver código QR","GENERATE_QRCODE":"Clique aqui para gerar o QR Code","VIEW_QRCODE":"Visualizar QR code do veículo","GENERATE_QRCODE_MANDATORY":"Clique aqui para gerar o QR Code*","MODAL":{"GENERATE":"Gerar QR Code","GENERATE_ANOTHER_CODE":"Gerar outro código","SAVE":"Salvar","DOWNLOAD":"Baixar","SAVED_SUCCESSFULLY":"QR Code alterado, salve o veículo para efetuar a atualização."}},"ERRORS":{"FIELD_REQUIRED":"Campo obrigatório.","DUPLICATE_NAME":"Já existe um veículo com este nome","NAME_REQUIRED":"Nome é obrigatório","LICENSE_PLATE_REQUIRED":"Placa é obrigatória","TYPE_REQUIRED":"Tipo é obrigatório","ORIGIN_REQUIRED":"Origem é obrigatória","FIELD_IS_REQUIRED":"Campo é obrigatório","INVALID_LICENSE_PLATE":"Placa inválida para o Mercosul","DESCRIPTION_MAXLENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}."},"TYPES_OPTIONS":{"CAR":"Carro","MOTORCYCLE":"Moto","NAUTICAL":"Marítimo","TRUCK":"Caminhão","SEMI_TRUCK":"Carreta"},"STATUS_OPTIONS":{"AVAILABLE":"Disponível","UNAVAILABLE":"Indisponível"},"ORIGINS_OPTIONS":{"RENTED":"Alugado","COMPANY":"Empresa","EMPLOYEE":"Colaborador"},"COLORS_OPTIONS":{"YELLOW":"Amarelo","BLUE":"Azul","BEIGE":"Bege","WHITE":"Branco","BRONZE":"Bronze","GRAY":"Cinza","GOLDEN":"Dourado","UNDEFINED":"Outra","ORANGE":"Laranja","BROWN":"Marrom","SILVER":"Prata","BLACK":"Preto","PINK":"Rosa","PURPLE":"Roxo","GREEN":"Verde","RED":"Vermelho","WINE":"Vinho"},"ARCHIVED_OPTIONS":{"ARCHIVED":"Arquivado","UNARCHIVED":"Ativo"}},"FORMS":{"WARNING":"Adicione formulários e defina a obrigatoriedade de cada um deles durante a retirada e devolução de um veículo.","PICKUP-TITLE":"Retirada do veículo","RETURN-TITLE":"Devolução do veículo","REQUIRED_FORM":"Formulário obrigatório","OPTIONAL_FORM":"Formulário opcional","SEARCH_PHRASE":"Pesquise os formulários para vincular","CHOOSE_FORM":"Escolher formulário"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/vehicles-usage/i18n/en.json',
    '{"VEHICLES_USAGE":{"TITLE":"Usage history","TUTORIAL_VIDEO":{"TITLE":"Instructions","TOOLTIP":"Watch tutorial video"},"EDIT":"Edit","FIELD":"Field","SELECT_DATE":"Select date","TABLE":{"COLUMNS":{"NAME":"Vehicle name","LICENSE_PLATE":"License plate","PICKED_UP_BY":"Picked up by","PICKED_UP_AT":"Picked up at","INITIAL_KM":"Initial km","TRAVELED_KM":"Traveled km","RETURNED_AT":"Returned at","USAGE_TIME":"Usage time","ACTIONS":"Actions"}},"TOOLBAR":{"FILTER":"Filter","CLEAR_FILTERS":"Clear filters","RELOAD":"Reload","EXPORT_EXCEL":"Export to excel"},"DIALOG":{"TITLE":"Usage report - {{ vehicleName }}","SAVE":"Save","ACTIONS":{"ARCHIVE":"Archive","UNARCHIVE":"Unarchive"},"TABS":{"GENERAL":"GENERAL","FORMS":"FORMS"},"FORMS":{"WARNING":"See which forms were linked to the report during the pickup and return of this vehicle.","WITHOUT_FORM":"No forms answered.","QUESTIONS_COUNT":"{{COUNT}} questions.","ANSWERED_BY_AT":"Answered by {{NAME}} on {{DATE}}"},"WARNING":"See the last movements performed by the employee in this vehicle.","VEHICLE_PICKUP":"Vehicle pickup","VEHICLE_RETURN":"Vehicle return","ODOMETER_RECORD":"Odometer record","INITIAL_KILOMETERS_PHOTO":"Initial kilometers photo","FINAL_KILOMETERS_PHOTO":"Final kilometers photo","USER":" (User)","EMPLOYEE":" (Employee)"},"MODEL":{"PICKED_UP_BY":"Picked up by","PICK_UP_TIME":"Pickup time","PICK_UP_DATE":"Pickup date","INITIAL_KILOMETERS":"Initial kilometrage","PICK_UP_DESCRIPTION":"Pickup comment","RETURN_TIME":"Return time","RETURN_DATE":"Return date","FINAL_KILOMETERS":"Final kilometrage","TRAVELED_KILOMETERS":"Traveled kilometrage","USAGE_TIME":"Usage Time","RETURN_DESCRIPTION":"Return comment","ERRORS":{"REQUIRED_FIELD":"{{fieldName}} is required.","DESCRIPTION_MAXLENGTH":"This field must have a maximum of {{ expectedLength }} characters, but it has {{ receivedLength }}.","INVALID_RETURNED_DISTANCE":"Invalid final kilometers","INVALID_RETURN_TIME":"Invalid return time","INVALID_PICK_UP_TIME":"Invalid pickup time","GREATER_THAN_12":"Must be less or equal to 12 hours","MINOR_THAN_00":"Must be greater than 00 hours"},"TYPES_OPTIONS":{"CAR":"Car","MOTORCYCLE":"Motorcycle","NAUTICAL":"Nautical","TRUCK":"Truck","SEMI_TRUCK":"Semi Truck"},"ORIGINS_OPTIONS":{"RENTED":"Rented","COMPANY":"Company","EMPLOYEE":"Employee"},"ARCHIVED_OPTIONS":{"ARCHIVED":"Archived","UNARCHIVED":"Active"},"ALL":"All"},"TOAST":{"VEHICLE_USAGE_SAVED":"Vehicle usage history \'{{name}}\' saved successfully.","EXPORTED":"The spreadsheet will be sent to the email \'{{ email }}\' in a few minutes.","WAIT":"Please wait","ERRORS":{"IMAGE_UPLOAD":"Failed to save vehicle image.","SAVING":"Error saving vehicle usage history."}},"FILTERS":{"TITLE":"Filter usage history","NAME":"Search name","LICENSE_PLATE":"Search license plate","TYPE":"Filter by type","ORIGIN":"Filter by origin","EMPLOYEE":"Filter by employee","EMPLOYEE_OR_USER":"Filter by employee or user","SITUATION":"Filter by situation","PICK_UP_DATE":"Filter by pickup date","RETURN_DATE":"Filter by return date","FROM":"From","TO":"To","CLEAR":"Clear filters"},"ALERT":{"TITLE":"Usage history export","CONTENT":"Usage history export may take a while...<br/><br/>We will send the complete spreadsheet to your email <b>{{ email }}</b>, okay?","OK":"Confirm and receive by email","CANCEL":"Cancel"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/vehicles-usage/i18n/es.json',
    '{"VEHICLES_USAGE":{"TITLE":"Historial de uso","TUTORIAL_VIDEO":{"TITLE":"Instrucciones","TOOLTIP":"Ver video tutorial"},"EDIT":"Editar","FIELD":"Campo","SELECT_DATE":"Seleccionar fecha","TABLE":{"COLUMNS":{"NAME":"Nombre del vehículo","LICENSE_PLATE":"Placa","PICKED_UP_BY":"Recogido por","PICKED_UP_AT":"Recogido en","INITIAL_KM":"Kilometraje inicial","TRAVELED_KM":"Kilometraje recorrido","RETURNED_AT":"Devuelto en","USAGE_TIME":"Tiempo de uso","ACTIONS":"Acciones"}},"TOOLBAR":{"FILTER":"Filtrar","CLEAR_FILTERS":"Limpiar filtros","RELOAD":"Recargar","EXPORT_EXCEL":"Exportar a Excel"},"DIALOG":{"TITLE":"Reporte de Uso - {{ vehicleName }}","SAVE":"Guardar","ACTIONS":{"ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar"},"TABS":{"GENERAL":"GENERAL","FORMS":"FORMULARIOS"},"FORMS":{"WARNING":"Vea qué formularios estaban vinculados al informe durante la recogida y devolución de este vehículo.","WITHOUT_FORM":"No se respondió ningún formulario.","QUESTIONS_COUNT":"{{COUNT}} preguntas.","ANSWERED_BY_AT":"Respondido por {{NAME}} en {{DATE}}"},"WARNING":"Vea los últimos movimientos realizados por el empleado en este vehículo.","VEHICLE_PICKUP":"Recogida del vehículo","VEHICLE_RETURN":"Devolución del vehículo","ODOMETER_RECORD":"Registro del odómetro","INITIAL_KILOMETERS_PHOTO":"Foto de los kilómetros iniciales","FINAL_KILOMETERS_PHOTO":"Foto de los kilómetros finales","USER":" (Usuario)","EMPLOYEE":" (Colaborador)"},"MODEL":{"PICKED_UP_BY":"Recogido por","PICK_UP_TIME":"Hora de recogida","PICK_UP_DATE":"Fecha de recogida","INITIAL_KILOMETERS":"Kilómetros iniciales","PICK_UP_DESCRIPTION":"Comentario de recogida","RETURN_TIME":"Hora de devolución","RETURN_DATE":"Fecha de devolución","FINAL_KILOMETERS":"Kilómetros finales","TRAVELED_KILOMETERS":"Kilómetros recorridos","USAGE_TIME":"Tiempo de uso","RETURN_DESCRIPTION":"Comentario de devolución","ERRORS":{"REQUIRED_FIELD":"{{fieldName}} es obligatorio.","DESCRIPTION_MAXLENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}.","INVALID_RETURNED_DISTANCE":"Kilometraje final inválida","INVALID_RETURN_TIME":"Hora de devolución inválida","INVALID_PICK_UP_TIME":"Hora de recogida inválida","GREATER_THAN_12":"Debe ser menor o igual a 12 horas","MINOR_THAN_00":"Debe ser mayor a 00 horas"},"TYPES_OPTIONS":{"CAR":"Coche","MOTORCYCLE":"Motocicleta","NAUTICAL":"Náutico","TRUCK":"Camión","SEMI_TRUCK":"Carreta"},"ORIGINS_OPTIONS":{"RENTED":"Alquilado","COMPANY":"Empresa","EMPLOYEE":"Empleado"},"ARCHIVED_OPTIONS":{"ARCHIVED":"Archivados","UNARCHIVED":"Activos"},"ALL":"Todos"},"TOAST":{"VEHICLE_USAGE_SAVED":"Historial de uso del vehículo \'{{name}}\' guardado exitosamente.","EXPORTED":"La hoja de cálculo se enviará al correo electrónico \'{{ email }}\' en unos minutos.","WAIT":"Por favor espera","ERRORS":{"IMAGE_UPLOAD":"Error al guardar la imagen del vehículo.","SAVING":"Error al guardar el historial de uso del vehículo."}},"FILTERS":{"TITLE":"Filtrar historial de uso","NAME":"Buscar por nombre","LICENSE_PLATE":"Buscar por placa","TYPE":"Filtrar por tipo","ORIGIN":"Filtrar por origen","EMPLOYEE":"Filtrar por empleado","EMPLOYEE_OR_USER":"Filtrar por empleado o usuario","SITUATION":"Filtrar por situación","PICK_UP_DATE":"Filtrar por fecha de recogida","RETURN_DATE":"Filtrar por fecha de devolución","FROM":"Desde","TO":"Hasta","CLEAR":"Limpiar filtros"},"ALERT":{"TITLE":"Exportación de historial de uso","CONTENT":"La exportación del historial de uso puede tardar un momento...<br/><br/>Enviaremos la hoja de cálculo completa a su correo electrónico <b>{{ email }}</b>, ¿de acuerdo?","OK":"Confirmar y recibir por correo electrónico","CANCEL":"Cancelar"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/vehicles-usage/i18n/pt.json',
    '{"VEHICLES_USAGE":{"TITLE":"Histórico de uso","TUTORIAL_VIDEO":{"TITLE":"Instruções","TOOLTIP":"Assistir vídeo explicativo"},"EDIT":"Editar","FIELD":"Campo","SELECT_DATE":"Selecionar data","TABLE":{"COLUMNS":{"NAME":"Nome do veículo","LICENSE_PLATE":"Placa","PICKED_UP_BY":"Retirado por","PICKED_UP_AT":"Retirado em","INITIAL_KM":"Km inicial","TRAVELED_KM":"Km rodado","RETURNED_AT":"Devolvido em","USAGE_TIME":"Tempo de uso","ACTIONS":"Ações"}},"TOOLBAR":{"FILTER":"Filtrar","CLEAR_FILTERS":"Limpar filtros","RELOAD":"Recarregar","EXPORT_EXCEL":"Exportar em Excel"},"DIALOG":{"TITLE":"Relatório de uso - {{ vehicleName }}","SAVE":"Salvar","ACTIONS":{"ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"},"TABS":{"GENERAL":"GERAL","FORMS":"FORMULÁRIOS"},"FORMS":{"WARNING":"Veja quais formulários foram vinculados ao relatório durante a retirada e devolução deste veículo.","WITHOUT_FORM":"Nenhum formulário respondido.","QUESTIONS_COUNT":"{{COUNT}} perguntas.","ANSWERED_BY_AT":"Respondido por {{NAME}} em {{DATE}}"},"WARNING":"Veja quais foram as últimas movimentações realizadas pelo colaborador neste veículo.","VEHICLE_PICKUP":"Retirada do veículo","VEHICLE_RETURN":"Devolução de veículo","ODOMETER_RECORD":"Registro do hodômetro","INITIAL_KILOMETERS_PHOTO":"Foto da quilometragem inicial","FINAL_KILOMETERS_PHOTO":"Foto da quilometragem final","USER":" (Usuário)","EMPLOYEE":" (Colaborador)"},"MODEL":{"PICKED_UP_BY":"Retirado por","PICK_UP_TIME":"Hora da retirada","PICK_UP_DATE":"Data da retirada","INITIAL_KILOMETERS":"Quilometragem inicial","PICK_UP_DESCRIPTION":"Comentário da retirada","RETURN_TIME":"Hora da devolução","RETURN_DATE":"Data da devolução","FINAL_KILOMETERS":"Quilometragem final","TRAVELED_KILOMETERS":"Quilômetros rodados","USAGE_TIME":"Tempo de uso","RETURN_DESCRIPTION":"Comentário de devolução","ERRORS":{"REQUIRED_FIELD":"{{fieldName}} é obrigatório.","DESCRIPTION_MAXLENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}.","INVALID_RETURNED_DISTANCE":"Quilometragem final inválida","INVALID_RETURN_TIME":"Hora de devolução inválida","INVALID_PICK_UP_TIME":"Hora de retirada inválida","GREATER_THAN_12":"Deve ser menor ou igual que 12 horas","MINOR_THAN_00":"Deve ser maior que 00 horas"},"TYPES_OPTIONS":{"CAR":"Carro","MOTORCYCLE":"Moto","NAUTICAL":"Marítimo","TRUCK":"Caminhão","SEMI_TRUCK":"Carreta"},"ORIGINS_OPTIONS":{"RENTED":"Alugado","COMPANY":"Empresa","EMPLOYEE":"Colaborador"},"ARCHIVED_OPTIONS":{"ARCHIVED":"Arquivados","UNARCHIVED":"Ativos"},"ALL":"Todos"},"TOAST":{"VEHICLE_USAGE_SAVED":"Histórico de uso do veículo {{name}} salvo com sucesso.","EXPORTED":"A planilha será enviada para o email \'{{ email }}\' em alguns minutos.","WAIT":"Por favor aguarde","ERRORS":{"IMAGE_UPLOAD":"Falha ao salvar a imagem do veículo.","SAVING":"Erro ao salvar histórico de uso do veículo."}},"FILTERS":{"TITLE":"Filtrar histórico de uso","NAME":"Pesquisar nome","LICENSE_PLATE":"Pesquisar placa","TYPE":"Filtrar por tipo","ORIGIN":"Filtrar por origem","EMPLOYEE":"Filtrar por colaborador","EMPLOYEE_OR_USER":"Filtrar por colaborador ou usuário","SITUATION":"Filtrar por situação","PICK_UP_DATE":"Filtrar por data de retirada","RETURN_DATE":"Filtrar por data de devolução","FROM":"De","TO":"Até","CLEAR":"Limpar filtros"},"ALERT":{"TITLE":"Exportação de histórico de uso","CONTENT":"A exportação de histórico de uso pode demorar um pouco...<br/><br/>Enviaremos a planilha completa para o seu email <b>{{ email }}</b>, combinado?","OK":"Confirmar e receber por e-mail","CANCEL":"Cancelar"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/work-services/i18n/en.json',
    '{"WORK_SERVICES":{"PAGE_TITLE":"Services","TITLE":"Services","NEW":"New service","RELOAD":"Reload","FILTER":"Filter","EXPORT":{"TITLE":"Service export","CONTENT":"By clicking export, you will receive a download link for the export in your email <b>{{ email }}</b>. Depending on the amount of information, the export may take a few minutes to complete.","YES":"YES","NO":"NO","CONFIRM_ACTION_CONTENT":"Do you want to continue with the export?","SPREADSHEET_SENT":"The spreadsheet will be sent to the email {{email}} in a few minutes","SPREADSHEET_ERROR":"Ooooooooooops, something went wrong and we couldn\'t export your services :("},"FILTERS":{"TITLE":"Filter services","CLEAR":"Clear filter","NAME":"Search by name","DESCRIPTION":"Search by description","SITUATIONS":{"TITLE":"Search by situation","ALL":"All","ACTIVE":"Active","ARCHIVED":"Archived"},"TYPE":{"TITLE":"Search by type","ALL":"All","SERVICE":"Services"}},"IMPORT":{"TITLE":"Import {{app}} services","FROM":"Service imported from Omie account <b>{{account}}</b>","SELECT_THE_ACCOUNT_MANUAL":"Select the Omie account from which you want to manually import services.","FOUND_SERVICES":"services found","MANUAL":"Manual Import","AUTOMATIC":"Mass Import","CONTENT":"This process will import all services that are registered in the selected Omie account.<br><br>&#8226; Services that do not exist in Field Control will be created;<br>&#8226; Existing services in Field Control will be updated.<br><br>The process may take a few moments depending on the number of services. Do not close the window until the process is complete.","IMPORT_LOADING_TITLE":"Importing Services from Omie","WAIT_LOADING":"Please wait, we are importing the services...","CLOSE":"Close","IMPORT_BUTTON":"Import","UPDATE_SUCCESS":"Updated successfully","UPDATE_ERROR":"There was an error with the import.","CREATE_ERROR":"Error importing service.","SUCCESS_AUTOMATIC":"Services imported successfully.","SUCCESS_MANUAL":"Imported successfully.","SEARCH_BY_NAME":"Enter at least 3 characters to search for services you want to import into Field Control.","LOADING_ERROR":"An error occurred while loading services from Omie."},"TABLE":{"NAME":"Name","CREATED_AT":"Created at","VALUE":"Value ({{currency}})","DESCRIPTION":"Description","TYPE":"Type","ACTIVE":"Active","INACTIVE":"Inactive","SITUATION":"Situation","ACTIONS":"Actions","EDIT":"Edit","VIEW":"View","CREATE_SERVICES_CTA":"You can create a new service","CREATE_SERVICES_LINK":"by clicking here","SERVICE_EDIT_NOT_ALLOWED":"Cannot edit a locked service"},"MODEL":{"NAME":"Name","VALUE":"Value ({{currency}})","DESCRIPTION":"Description","TYPE":{"LABEL":"Type","SERVICE":"Service"},"ERRORS":{"NAME_REQUIRED":"Name is required","MAX_LENGTH":"This field must have a maximum of {{ expectedLength }} characters, but it has {{ receivedLength }}.","VALUE_REQUIRED":"Value is required","FIELD_REQUIRED":"This field is required"}},"DIALOG":{"CLOSE":"Close","SERVICE_ALERT":"A service is a task with defined value to fulfill specific necessities.","IMAGE_INFORMATION":"The ideal logo dimensions are 512px x 512px, with a maximum size of 2MB.","SELECT_IMAGES":"Select image","NEW":{"TITLE":"New service","INFO":"service information"},"EDIT":{"TITLE":"Edit service"},"ACTIONS":{"SAVE":"SAVE","CREATE":"CREATE","ARCHIVE":"Archive","UNARCHIVE":"Unarchive"},"ALERT":{"TITLE":"Could not save the service","OK":"OK"}},"TOAST":{"SAVED":"Service \'{{ service }}\' saved successfully."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/work-services/i18n/es.json',
    '{"WORK_SERVICES":{"PAGE_TITLE":"Servicios","TITLE":"Servicios","NEW":"Nuevo servicio","RELOAD":"Recargar","FILTER":"Filtrar","EXPORT":{"TITLE":"Exportación de servicios","CONTENT":"Al hacer clic en exportar, recibirá un enlace de descarga de la exportación en su correo electrónico <b>{{ email }}</b>. Dependiendo de la cantidad de información, la exportación puede tardar algunos minutos en completarse.","YES":"SÍ","NO":"NO","CONFIRM_ACTION_CONTENT":"¿Desea continuar con la exportación?","SPREADSHEET_SENT":"La hoja de cálculo se enviará al correo electrónico {{email}} en unos minutos","SPREADSHEET_ERROR":"Ooooooooooops, algo salió mal y no pudimos exportar sus servicios :("},"FILTERS":{"TITLE":"Filtrar servicios","CLEAR":"Limpiar filtro","NAME":"Buscar por nombre","DESCRIPTION":"Buscar por descripción","SITUATIONS":{"TITLE":"Buscar por situación","ALL":"Todos","ACTIVE":"Activos","ARCHIVED":"Archivados"},"TYPE":{"TITLE":"Buscar por tipo","ALL":"Todos","SERVICE":"Servicios"}},"IMPORT":{"TITLE":"Importar Servicios de {{app}}","FROM":"Servicio importado de la cuenta Omie <b>{{account}}</b>","SELECT_THE_ACCOUNT_MANUAL":"Seleccione la cuenta Omie de la que desea importar los servicios manualmente.","FOUND_SERVICES":"servicios encontrados","MANUAL":"Importación Manual","AUTOMATIC":"Importación Masiva","CONTENT":"Este proceso importará todos los servicios que están registrados en la cuenta Omie seleccionada.<br><br>&#8226; Los servicios que no existen en Field Control serán creados;<br>&#8226; Los servicios existentes en Field Control se actualizarán.<br><br>El proceso puede tardar unos momentos dependiendo de la cantidad de servicios. No cierre la ventana hasta que el proceso haya terminado.","IMPORT_LOADING_TITLE":"Importando Servicios de Omie","WAIT_LOADING":"Espere, estamos importando los servicios...","CLOSE":"Cerrar","IMPORT_BUTTON":"Importar","UPDATE_SUCCESS":"Actualizado con éxito","UPDATE_ERROR":"Hubo un error con la importación.","CREATE_ERROR":"Error al importar el servicio.","SUCCESS_AUTOMATIC":"Servicios importados correctamente.","SUCCESS_MANUAL":"Importado correctamente.","SEARCH_BY_NAME":"Ingrese al menos 3 caracteres para buscar servicios que desea importar a Field Control.","LOADING_ERROR":"Se produjo un error al cargar los servicios de Omie."},"TABLE":{"NAME":"Nombre","CREATED_AT":"Creado en","VALUE":"Valor ({{currency}})","DESCRIPTION":"Descripción","TYPE":"Tipo","ACTIVE":"Activo","INACTIVE":"Inactivo","SITUATION":"Situación","ACTIONS":"Acciones","EDIT":"Editar","VIEW":"Ver","CREATE_SERVICES_CTA":"Puede crear un nuevo servicio","CREATE_SERVICES_LINK":"haciendo clic aquí","SERVICE_EDIT_NOT_ALLOWED":"No se puede editar un servicio bloqueado"},"MODEL":{"NAME":"Nombre","VALUE":"Valor ({{currency}})","DESCRIPTION":"Descripción","TYPE":{"LABEL":"Tipo","SERVICE":"Servicio"},"ERRORS":{"NAME_REQUIRED":"El nombre es obligatorio","MAX_LENGTH":"Este campo debe tener un máximo de {{ expectedLength }} caracteres, pero tiene {{ receivedLength }}.","VALUE_REQUIRED":"El valor es obligatorio","FIELD_REQUIRED":"Este campo es obligatorio"}},"DIALOG":{"CLOSE":"Cerrar","SERVICE_ALERT":"Un servicio es una actividad con un valor definido para satisfacer necesidades específicas.","IMAGE_INFORMATION":"Las dimensiones ideales para el logo son 512px x 512px, con un tamaño máximo de 2 MB.","SELECT_IMAGES":"Seleccionar imagen","NEW":{"TITLE":"Nuevo servicio","INFO":"Información del servicio"},"EDIT":{"TITLE":"Editar servicio"},"ACTIONS":{"SAVE":"GUARDAR","CREATE":"CREAR","ARCHIVE":"Archivar","UNARCHIVE":"Desarchivar"},"ALERT":{"TITLE":"No se pudo guardar el servicio","OK":"OK"}},"TOAST":{"SAVED":"Servicio \'{{ service }}\' guardado exitosamente."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/work-services/i18n/pt.json',
    '{"WORK_SERVICES":{"PAGE_TITLE":"Serviços","TITLE":"Serviços","NEW":"Novo Serviço","RELOAD":"Atualizar","FILTER":"Filtrar","EXPORT":{"TITLE":"Exportação de Serviços","CONTENT":"Ao clicar em exportar, você receberá um link de download da exportação no seu e-mail <b>{{ email }}</b>. Dependendo da quantidade de informações, a exportação poderá demorar alguns minutos para ser finalizada.","YES":"SIM","NO":"NÃO","CONFIRM_ACTION_CONTENT":"Deseja continuar com a exportação?","SPREADSHEET_SENT":"A planilha será enviada para o e-mail {{email}} em alguns minutos","SPREADSHEET_ERROR":"Ooooooooooops, algo errado aconteceu e não foi possível exportar seus serviços :("},"FILTERS":{"TITLE":"Filtrar serviços","CLEAR":"Limpar filtro","NAME":"Pesquisar por nome","DESCRIPTION":"Pesquisar por descrição","SITUATIONS":{"TITLE":"Pesquisar por situação","ALL":"Todos","ACTIVE":"Ativos","ARCHIVED":"Arquivados"},"TYPE":{"TITLE":"Pesquisar por tipo","ALL":"Todos","SERVICE":"Serviços"}},"IMPORT":{"TITLE":"Importar serviços do {{app}}","FROM":"Serviço importado da conta Omie <b>{{account}}</b>","SELECT_THE_ACCOUNT_MANUAL":"Selecione a conta Omie que deseja importar os serviços manualmente.","FOUND_SERVICES":"serviços encontrados","MANUAL":"Importação manual","AUTOMATIC":"Importação em massa","CONTENT":"Esse processo irá importar todos os serviços que estão cadastrados na conta Omie selecionada.<br><br>&#8226; Os serviços que não existem no Field Control serão criados;<br>&#8226; Os serviços já existentes no Field Control serão atualizados.<br><br>O processo poderá demorar alguns instantes de acordo com a quantidade de serviços. Não feche a janela até que o processo tenha terminado.","IMPORT_LOADING_TITLE":"Importando serviços do Omie","WAIT_LOADING":"Aguarde, estamos importando os serviços...","CLOSE":"Fechar","IMPORT_BUTTON":"Importar","UPDATE_SUCCESS":"Atualizado com sucesso","UPDATE_ERROR":"Houve um erro com a importação.","CREATE_ERROR":"Erro ao importar serviço.","SUCCESS_AUTOMATIC":"Serviços importados com sucesso.","SUCCESS_MANUAL":"Importado com sucesso.","SEARCH_BY_NAME":"Digite pelo menos 3 caracteres para buscar serviços que você deseja importar para o Field Control.","LOADING_ERROR":"Ocorreu um erro ao carregar os serviços da Omie."},"TABLE":{"NAME":"Nome","CREATED_AT":"Criado em","VALUE":"Valor ({{currency}})","DESCRIPTION":"Descrição","TYPE":"Tipo","ACTIVE":"Ativo","INACTIVE":"Inativo","SITUATION":"Situação","ACTIONS":"Ações","EDIT":"Editar","VIEW":"Visualizar","CREATE_SERVICES_CTA":"Você pode criar um novo serviço","CREATE_SERVICES_LINK":"clicando aqui","SERVICE_EDIT_NOT_ALLOWED":"Não é possível editar um serviço bloqueado"},"MODEL":{"NAME":"Nome","VALUE":"Valor ({{currency}})","DESCRIPTION":"Descrição","TYPE":{"LABEL":"Tipo","SERVICE":"Serviço"},"ERRORS":{"NAME_REQUIRED":"Nome é obrigatório","MAX_LENGTH":"Esse campo deve possuir no máximo {{ expectedLength }} caracteres, mas possui {{ receivedLength }}.","VALUE_REQUIRED":"Valor é obrigatório","FIELD_REQUIRED":"Este campo é obrigatório"}},"DIALOG":{"CLOSE":"Fechar","SERVICE_ALERT":"Um serviço é uma atividade com valor definido para atender necessidades específicas.","IMAGE_INFORMATION":"As dimensões ideais do logo são 512px x 512px, com tamanho máximo de 2 MB.","SELECT_IMAGES":"Selecionar imagem","NEW":{"TITLE":"Novo serviço","INFO":"Informações do serviço"},"EDIT":{"TITLE":"Editar serviço"},"ACTIONS":{"SAVE":"SALVAR","CREATE":"CRIAR","ARCHIVE":"Arquivar","UNARCHIVE":"Desarquivar"},"ALERT":{"TITLE":"Não foi possível salvar o serviço","OK":"OK"}},"TOAST":{"SAVED":"Serviço \'{{ service }}\' salvo com sucesso."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/auth/confirm-email/i18n/en.json',
    '{"CONFIRM_EMAIL":{"PAGE_TITLE":"Email Confirmation","TITLE":"Confirm your email!","SEND_BUTTON":"Send email","DESCRIPTION":{"PART_1":"You need to confirm your email to continue, click the button below to send an email to <strong>{{ email }}</strong>","PART_2":"Email sent successfully! Continue the confirmation process there."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/auth/confirm-email/i18n/es.json',
    '{"CONFIRM_EMAIL":{"PAGE_TITLE":"Confirmación de correo electrónico","TITLE":"¡Confirma tu correo electrónico!","SEND_BUTTON":"Enviar correo electrónico","DESCRIPTION":{"PART_1":"Necesitas confirmar tu correo electrónico para continuar, haz clic en el botón a continuación para enviar un correo electrónico a <strong>{{ email }}</strong>","PART_2":"Correo electrónico enviado con éxito. Continúa el proceso de confirmación allí."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/auth/confirm-email/i18n/pt.json',
    '{"CONFIRM_EMAIL":{"PAGE_TITLE":"Confirmação de e-mail","TITLE":"Confirme seu e-mail!","SEND_BUTTON":"Enviar email","DESCRIPTION":{"PART_1":"Você precisa confirmar seu e-mail para continuar, clique no botão abaixo para enviar um email para <strong>{{ email }}</strong>","PART_2":"Email enviado com sucesso! Continue o processo de confirmação por lá."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/auth/forgot-password/i18n/en.json',
    '{"FORGOT_PASSWORD":{"PAGE_TITLE":"Forgot Password?","TITLE":"Forgot Password?","DESCRIPTION":"To recover your password, enter the registered email address to receive the password reset link.","EMAIL_ADDRESS":"Enter your email here","SEND_RESET_LINK":"Send reset link","GO_BACK":"Back to login","EMAIL_SENT":"Done! Within minutes, you will receive an email with instructions to reset your password.","OR":"Or","ERRORS":{"EMAIL_REQUIRED":"Email is a required field","EMAIL_MUST_VALID":"Invalid email format"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/auth/forgot-password/i18n/es.json',
    '{"FORGOT_PASSWORD":{"PAGE_TITLE":"¿Olvidó su contraseña?","TITLE":"¿Olvidó su contraseña?","DESCRIPTION":"Para recuperar su contraseña, ingrese el correo registrado para recibir el enlace de cambio de contraseña.","EMAIL_ADDRESS":"Ingrese su correo aquí","SEND_RESET_LINK":"Enviar enlace de recuperación","GO_BACK":"Volver al inicio de sesión","EMAIL_SENT":"¡Listo! En unos minutos recibirá un correo electrónico con instrucciones para restablecer su contraseña.","OR":"O","ERRORS":{"EMAIL_REQUIRED":"El correo electrónico es un campo obligatorio","EMAIL_MUST_VALID":"Formato de correo electrónico inválido"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/auth/forgot-password/i18n/pt.json',
    '{"FORGOT_PASSWORD":{"PAGE_TITLE":"Esqueceu a senha?","TITLE":"Esqueceu a senha?","DESCRIPTION":"Para recuperar sua senha, informe o e-mail cadastrado para receber o link de alteração de senha.","EMAIL_ADDRESS":"Digite seu e-mail aqui","SEND_RESET_LINK":"Enviar link de recuperação","GO_BACK":"Voltar para o login","EMAIL_SENT":"Pronto! Dentro de minutos você receberá um e-mail com as instruções de redefinição de sua senha.","OR":"Ou","ERRORS":{"EMAIL_REQUIRED":"E-mail é um campo obrigatório","EMAIL_MUST_VALID":"E-mail em formato inválido"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/auth/reset-password/i18n/en.json',
    '{"RESET_PASSWORD":{"PAGE_TITLE":"Reset password","TITLE":"Reset password","DESCRIPTION":"Enter your new password next to it, it must have at least 8 characters and include letters, numbers, and symbols.","NEW_PASSWORD":"New password","SUBMIT_LABEL":"Reset password","OR":"Or","GO_BACK":"Back to login","PASSWORD_EXAMPLE":"You need to use a strong password. The password must have at least 8 characters and include letters, numbers, and symbols. For example:","SUCCESSFULLY_RESETED":"Done! Your password has been successfully changed. Shortly you will be redirected to login.","ERRORS":{"NEW_PASSWORD_REQUIRED":"New password required","INVALID_LINK":"The link you tried to access can no longer be used, request a new password reset","RESET_FAILED":"Unable to save your new password. If the problem persists, please contact suporte@fieldcontrol.com.br"},"TOAST":{"SUCCESSFULLY_RESETED":"Done! Your password has been successfully changed! Welcome back :)"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/auth/reset-password/i18n/es.json',
    '{"RESET_PASSWORD":{"PAGE_TITLE":"Restablecer contraseña","TITLE":"Restablecer contraseña","DESCRIPTION":"Ingrese su nueva contraseña al lado, debe tener al menos 8 caracteres e incluir letras, números y símbolos.","NEW_PASSWORD":"Nueva contraseña","SUBMIT_LABEL":"Restablecer contraseña","OR":"O","GO_BACK":"Volver al inicio de sesión","PASSWORD_EXAMPLE":"Debe utilizar una contraseña segura. La contraseña debe tener al menos 8 caracteres e incluir letras, números y símbolos. Por ejemplo:","SUCCESSFULLY_RESETED":"¡Listo! Su contraseña ha sido cambiada exitosamente. En breve será redirigido al inicio de sesión.","ERRORS":{"NEW_PASSWORD_REQUIRED":"Se requiere una nueva contraseña","INVALID_LINK":"El enlace que intentó acceder ya no se puede utilizar, solicite un nuevo restablecimiento de contraseña","RESET_FAILED":"No fue posible guardar su nueva contraseña; si el problema persiste, comuníquese con suporte@fieldcontrol.com.br"},"TOAST":{"SUCCESSFULLY_RESETED":"¡Listo! ¡Su contraseña ha sido cambiada exitosamente! Bienvenido de vuelta :)"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/auth/reset-password/i18n/pt.json',
    '{"RESET_PASSWORD":{"PAGE_TITLE":"Redefinir senha","TITLE":"Redefinir senha","DESCRIPTION":"Digite ao lado a sua nova senha, ela deve possuir no mínimo 8 caracteres e que inclua letras, números e símbolos.","NEW_PASSWORD":"Nova senha","SUBMIT_LABEL":"Redefinir senha","OR":"Ou","GO_BACK":"Voltar para o login","PASSWORD_EXAMPLE":"Você precisa usar uma senha suficientemente forte. A senha deve conter no mínimo 8 caracteres e que inclua letras, números e símbolos. Por Exemplo:","SUCCESSFULLY_RESETED":"Pronto! Sua senha foi alterada com sucesso. Em instantes você será redirecionado para o login.","ERRORS":{"NEW_PASSWORD_REQUIRED":"Nova senha é um campo obrigatório","INVALID_LINK":"O link que você tentou acessar não pode mais ser utilizado, solicite uma nova redefinição de senha","RESET_FAILED":"Não foi possível salvar sua nova senha, caso o problema persista entre em contato com suporte@fieldcontrol.com.br"},"TOAST":{"SUCCESSFULLY_RESETED":"Pronto! Sua senha foi alterada com sucesso! Bem-vindo de volta :)"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/customers-area/i18n/en.json',
    '{"CUSTOMERS_AREA_MODULE":{"TITLE":"Customer\'s area","DESCRIPTION":"Have a dedicated area for your customers to open, view and track service calls.","TEXT":"Receive requests from your customers through a single panel, from which they can request and track their own requests; and shorten the waiting time for customer service.","LIST":"Speed in service; Personalized for your company; Service form; Reduction of waiting time","GO_BACK":"Come back","RELOAD":"Reload","ENABLE_SUCCESS":"Client area successfully activated","DISABLE_SUCCESS":"Client area successfully deactivated","SYNC_SUCCESS":"Company synchronized successfully!","SYNC_ERROR":"Error synchronizing your company, please try again in a few moments","GENERAL":"General","DISABLE_DIALOG":{"TITLE":"Deactivate the client area?","MESSAGE":"Are you sure you want to disable the client area? <br /> This will make it impossible for all users from the client to access and send service requests.","OK":"Disable","CANCEL":"Cancel"},"TASKS":{"TITLE":"OS types available:","HINT":"Only the selected OS types will be displayed when requesting a service.","SEARCH":"Search by OS types ...","REQUIRED":"At least 1 type of OS is required for opening tickets"},"SLUG":{"TITLE":"Complete your online address (link): *","HINT":"This will be the link your clientes will request new services","REQUIRED":"The URL complement is required","IN_USE":"The URL complement is already in use","INVALID":"The URL complement is invalid. Example: field-control","MIN":"The URL complement must be at least 2 characters long","MAX":"The URL complement must have a maximum of 50 characters","COPY_LINK":"Copy link"},"CUSTOMERS":{"TITLE":"Activated clients","SEARCH":"Search for clients ...","NEW":"New client area","MENU":"Menu","REMOVE":"Remove","EDIT":"Edit","SYNC":"Sync","ACTIVATE":"Activate","ALREADY_ACTIVATED":"Customer is already activated","NO_CUSTOMER_FOUND":"Your search did not find any clients.","NO_ACTIVE_CUSTOMER":"Your account has no active clients area, click on the button above to add and configure a new client area.","NO_ACTIVE_CUSTOMER_FOUND":"Your search did not find any active client areas.","SAVE_SUCCESS":"Customer area saved successfully!","SAVE_ERROR":"Error saving customer area, please try again in a few moments","SYNC_SUCCESS":"Customer {{name}} successfully synced!","SYNC_ERROR":"Error syncing customer {{name}}, please try again in a few moments","ACTIVATE_CUSTOMER":{"TITLE":"Activate client","MESSAGE":"Are you sure you want to activate the <strong>{{name}}</strong> client?<br /> Upon acceptance, a link will be created between that customer and the customer area.<br /><br /> You will be asked to invite users to access it on the following screen.","OK":"Activate","CANCEL":"Cancel","SUCCESS":"Client activated successfully","ERROR":"Error activating the client, please try again later"},"DEACTIVATE_CUSTOMER":{"TITLE":"Disable client","MESSAGE":"Are you sure you want to <strong>disable</strong> the <strong>{{name}}</strong> client?<br /> Upon acceptance, this customer and their users will no longer be able to access the customer area until you reactivate it.","OK":"Disable","CANCEL":"Cancel","SUCCESS":"Client deactivated successfully","ERROR":"Error deactivating the client, please try again later"},"DEACTIVATE_USER":{"TITLE":"Disable user","MESSAGE":"Are you sure you want to <strong>disable</strong> the user <strong>{{name}}</strong> ?<br /> Upon acceptance, this user will no longer be able to access the customer area until you reactivate it.","OK":"Disable","CANCEL":"Cancel","SUCCESS":"User successfully activated","ERROR":"Error deactivating the user, please try again later"}},"USERS":{"TITLE":"Users","NEW":"Invite new user","SEARCH":"Search user by name...","REMOVE":"Remove","ARCHIVE_USERS_TITLE":"Disabled users","NO_ACTIVE_USER_FOUND":"This customer area has no user, click the button above to invite a new user.","REACTIVATE":"Reactivate","RELOAD":"Reload users","NO_USER_FOUND":"Your search did not find any users.","PENDING":"Pending activation","NO_SERVICES_SELECTED":"No OS types selected","RESEND_INVITATION":"Resend invitation","NEW_SCREEN":{"TITLE":"Invite User","SUBTITLE":"Send an invite to a new user from customer <strong>{{name}}</strong>","NAME":"Name","EMAIL":"Email","INVITE":"Invite","CANCEL":"Cancel","OK":"OK","SUCCESS":{"TITLE":"Invite sent successfully!","SUBTITLE":"The invitee will receive the invitation to create a profile on the client <strong>{{name}}</strong>"},"ERRORS":{"REQUIRED":"This field is required","EMAIL":"Enter a valid email","INVITE":"There was an error sending the invitation email, please try again later"}},"ACTIVATE":{"TITLE":"Enable user","MESSAGE":"Do you want to activate this user for the {{name}} client?","OK":"Enable","CANCEL":"Cancel","SUCCESS":"User activated successfully","ERROR":"Error activating the user, please try again later"},"ACTIVATE_EXISTENT_SAME_ORGANIZATION":{"TITLE":"Activate user","MESSAGE":"This user already exists, do you want to activate it for the customer {{name}}?","OK":"Activate","CANCEL":"Cancel","SUCCESS":"User successfully activated","ERROR":"Error activating user, please try again in a few moments"},"ACTIVATE_ALREADY_EXISTS":{"TITLE":"We were unable to activate this user","MESSAGE":"This user already exists for another client","OK":"OK"},"ACTIVATE_ALREADY_ACTIVE":{"TITLE":"We were unable to activate this user","MESSAGE":"This user is already activated","OK":"OK"},"ACTIVATE_WAITING_INVITE":{"TITLE":"This user has already received an invitation!","MESSAGE":"This user has already received an invitation email! Do you want to send it again?","OK":"Submit","CANCEL":"Cancel"},"RESEND_USER_INVITATION":{"TITLE":"Resend invitation","MESSAGE":"Are you sure you want to resend an invitation to that user? <br /> A new invitation will be sent to <strong> {{email}} </strong>","OK":"Submit","CANCEL":"Cancel","SUCCESS":"Invitation successfully resent!"}},"CONFIGURATIONS":{"TITLE":"Configurations","CLIENT_LIMIT":{"LIMIT_REACHED":"The number of active customers has reached its limit! Contact us so we can help you."},"CUSTOMERS_AREA_CHOOSE_EMPLOYEE_ON_TICKET_ACCEPT":{"TITLE":"Choose employee on ticket accept from customer area","HINT":"Makes the employee selection mandatory when accepting a ticket from the customer area."}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/customers-area/i18n/es.json',
    '{"CUSTOMERS_AREA_MODULE":{"TITLE":"Área del cliente","DESCRIPTION":"Tenga un portal para que sus clientes abran, vean y rastreen llamadas.","TEXT":"Reciba solicitudes de sus clientes a través de un único panel, desde el cual pueden solicitar y rastrear sus solicitudes; y acortar el tiempo de espera del servicio al cliente.","LIST":"Rapidez en el servicio; Panel personalizado de su empresa; Formulario de servicio; Reducción de tiempos de espera","GO_BACK":"Vuelve","RELOAD":"Recargar","ENABLE_SUCCESS":"Área de clientes activada con éxito","DISABLE_SUCCESS":"Área de clientes desactivada con éxito","SYNC_SUCCESS":"¡La empresa se sincronizó correctamente!","SYNC_ERROR":"Error al sincronizar su empresa. Vuelva a intentarlo en unos momentos","GENERAL":"General","DISABLE_DIALOG":{"TITLE":"¿Desactivar el área de clientes?","MESSAGE":"¿Está seguro de que desea deshabilitar el área del cliente? <br /> Esto hará imposible que todos los usuarios del client accedan y envíen solicitudes de servicio.","OK":"Desactivar","CANCEL":"Cancelar"},"TASKS":{"TITLE":"Tipos de OS disponibles:","HINT":"Solo se mostrarán los tipos de OS seleccionados al solicitar un servicio.","SEARCH":"Buscar por tipo de OS ...","REQUIRED":"Se requiere al menos 1 tipo de OS para abrir boletos"},"SLUG":{"TITLE":"Complete su dirección en línea (enlace): *","HINT":"Esta será su dirección en línea (enlace) para solicitar servicios a sus clientes","REQUIRED":"Se requiere el complemento de URL","IN_USE":"El complemento de URL ya está en uso","INVALID":"El complemento de URL tiene un formato no válido. Ejemplo: control de campo","MIN":"El complemento de URL debe tener al menos 2 caracteres","MAX":"El complemento de URL debe tener un máximo de 50 caracteres.","COPY_LINK":"Copiar link"},"CUSTOMERS":{"TITLE":"Clientes activados","SEARCH":"Buscar cliente ...","NEW":"Nueva área de clientes","MENU":"Menú","REMOVE":"Eliminar","EDIT":"Editar","SYNC":"Sincronizar","ACTIVATE":"Ativar","ALREADY_ACTIVATED":"Cliente ya está activado","NO_CUSTOMER_FOUND":"Su búsqueda no encontró ningún cliente","NO_ACTIVE_CUSTOMER":"Su cuenta no tiene un área de cliente activa, haga clic en el botón de arriba para agregar y configurar una nueva área de cliente","NO_ACTIVE_CUSTOMER_FOUND":"Su búsqueda no encontró áreas de clientes activas.","SAVE_SUCCESS":"¡Área de cliente guardada correctamente!","SAVE_ERROR":"Error al guardar el área del cliente. Vuelve a intentarlo en unos momentos.","SYNC_SUCCESS":"¡Cliente {{name}} sincronizado correctamente!","SYNC_ERROR":"Error al sincronizar el cliente {{name}}. Vuelve a intentarlo en unos momentos","ACTIVATE_CUSTOMER":{"TITLE":"Activar cliente","MESSAGE":"¿Está seguro de que desea activar el cliente <strong>{{name}}</strong> ?<br /> Tras la aceptación, se creará un enlace entre ese cliente y el área de clientes.<br /><br /> Se le pedirá que invite a los usuarios a acceder a él en la siguiente pantalla.","OK":"Activar","CANCEL":"Cancelar","SUCCESS":"Cliente activado con éxito","ERROR":"Error al activar el cliente. Vuelve a intentarlo más tarde."},"DEACTIVATE_CUSTOMER":{"TITLE":"Deshabilitar cliente","MESSAGE":"¿Está seguro de que desea <strong>inhabilitar</strong> el cliente <strong>{{name}}</strong> ?<br /> Tras la aceptación, este cliente y sus usuarios ya no podrán acceder al área de clientes hasta que la reactive.","OK":"Inhabilitar","CANCEL":"Cancelar","SUCCESS":"Cliente desactivado con éxito","ERROR":"Error al desactivar el cliente, inténtelo de nuevo más tarde"},"DEACTIVATE_USER":{"TITLE":"Inhabilitar usuario","MESSAGE":"¿Está seguro de que desea <strong>inhabilitar</strong> al usuario <strong>{{name}}</strong> ?<br /> Tras la aceptación, este usuario ya no podrá acceder al área de clientes hasta que la reactive.","OK":"Inhabilitar","CANCEL":"Cancelar","SUCCESS":"Usuario activado con éxito","ERROR":"Error al desactivar el usuario. Vuelve a intentarlo más tarde."}},"USERS":{"TITLE":"Usuarios","NEW":"Invitar a un nuevo usuario","SEARCH":"Buscar usuario por nombre...","REMOVE":"Eliminar","ARCHIVE_USERS_TITLE":"Usuarios discapacitados","NO_ACTIVE_USER_FOUND":"Esta área de clientes no tiene usuario, haga clic en el botón de arriba para invitar a un nuevo usuario","REACTIVATE":"Reactivar","RELOAD":"Recargar usuarios","NO_USER_FOUND":"Su búsqueda no encontró ningún usuario.","PENDING":"Activación pendiente","NO_SERVICES_SELECTED":"No se seleccionó ningún tipo de OS","RESEND_INVITATION":"Reenviar invitación","NEW_SCREEN":{"TITLE":"Invitar usuario","SUBTITLE":"Envíe una invitación a un nuevo usuario del cliente <strong>{{name}}</strong>","NAME":"Nombre","EMAIL":"Correo electrónico","INVITE":"Invitar","CANCEL":"Cancelar","OK":"Okay","SUCCESS":{"TITLE":"¡Invitación enviada con éxito!","SUBTITLE":"El invitado recibirá la invitación para crear un perfil en el cliente <strong>{{name}}</strong>"},"ERRORS":{"REQUIRED":"este campo es requerido","EMAIL":"Introduzca un correo electrónico válido","INVITE":"Se produjo un error al enviar el correo electrónico de invitación. Vuelve a intentarlo más tarde."}},"ACTIVATE":{"TITLE":"Habilitar usuario","MESSAGE":"¿Desea activar este usuario para el cliente {{name}}?","OK":"Activar","CANCEL":"Cancelar","SUCCESS":"Usuario activado correctamente","ERROR":"Error al activar el usuario, inténtelo de nuevo más tarde"},"ACTIVATE_EXISTENT_SAME_ORGANIZATION":{"TITLE":"Activar usuario","MESSAGE":"Este usuario ya existe, desea activarlo para el cliente {{name}}","OK":"Activar","CANCEL":"Cancelar","SUCCESS":"Usuario activado con éxito","ERROR":"Error al activar el usuario. Vuelve a intentarlo en unos momentos."},"ACTIVATE_ALREADY_EXISTS":{"TITLE":"No pudimos activar este usuario","MESSAGE":"Este usuario ya existe para otro cliente","OK":"OK"},"ACTIVATE_ALREADY_ACTIVE":{"TITLE":"No pudimos activar este usuario","MESSAGE":"Este usuario ya está activado","OK":"OK"},"ACTIVATE_WAITING_INVITE":{"TITLE":"¡Este usuario ya ha recibido una invitación!","MESSAGE":"¡Este usuario ya ha recibido un correo electrónico de invitación! ¿Enviar de nuevo?","OK":"Enviar","CANCEL":"Cancelar"},"RESEND_USER_INVITATION":{"TITLE":"Reenviar invitación","MESSAGE":"¿Está seguro de que desea reenviar una invitación a ese usuario? <br /> Se enviará una nueva invitación a <strong> {{email}} </strong>","OK":"Enviar","CANCEL":"Cancelar","SUCCESS":"¡Invitación reenviada con éxito!"}},"CONFIGURATIONS":{"TITLE":"Configuración","CLIENT_LIMIT":{"LIMIT_REACHED":"¡El número de clientes activos ha llegado a su límite! Póngase en contacto con Field Control"},"CUSTOMERS_AREA_CHOOSE_EMPLOYEE_ON_TICKET_ACCEPT":{"TITLE":"Empleado obligatorio al aceptar tickets de la área de clientes","HINT":"Hace que la selección del empleado sea obligatoria al aceptar un ticket de la área de clientes."}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/customers-area/i18n/pt.json',
    '{"CUSTOMERS_AREA_MODULE":{"TITLE":"Área do cliente","DESCRIPTION":"Tenha um portal para que seus clientes possam abrir, ver e acompanhar chamados.","TEXT":"Receba as solicitações de seus clientes através de um painel único, no qual ele poderá solicitar e acompanhar suas solicitações; e diminua o tempo de espera do atendimento de seus clientes.","LIST":"Velocidade no atendimento;Painel personalizado da sua empresa;Formulário de atendimento;Redução do tempo de espera","GO_BACK":"Voltar","RELOAD":"Recarregar","ENABLE_SUCCESS":"Área do cliente ativada com sucesso","DISABLE_SUCCESS":"Área do cliente desativada com sucesso","SYNC_SUCCESS":"Empresa sincronizada com sucesso!","SYNC_ERROR":"Erro ao sincronizar sua empresa, tente novamente em alguns instantes","GENERAL":"Geral","DISABLE_DIALOG":{"TITLE":"Desativar a área do cliente?","MESSAGE":"Tem certeza que deseja desativar a área do cliente? <br /> Isso vai impossibilitar que todos os usuários desse cliente acessem e enviem solicitações de serviço.","OK":"Desativar","CANCEL":"Cancelar"},"TASKS":{"TITLE":"Tipos de OS disponíveis:","HINT":"Apenas os tipos de OS selecionados serão exibidas na solicitação de um serviço.","SEARCH":"Procurar por tipo de OS...","REQUIRED":"Necessário pelo menos 1 tipo de OS para a abertura de chamados"},"SLUG":{"TITLE":"Complete o seu endereço online (link):*","HINT":"Esse será seu endereço online (link) para a solicitação de serviços do seus clientes","REQUIRED":"O complemento da URL é necessário","IN_USE":"O complemento da URL já está em uso","INVALID":"O complemento da URL está em um formato invalido. Exemplo: field-control","MIN":"O complemento da URL deve ter pelo menos 2 caracteres","MAX":"O complemento da URL deve ter no máximo 50 caracteres","COPY_LINK":"Copiar link"},"CUSTOMERS":{"TITLE":"Clientes ativados","SEARCH":"Buscar por cliente...","NEW":"Nova área do cliente","MENU":"Menu","REMOVE":"Remover","EDIT":"Editar","SYNC":"Sincronizar","ACTIVATE":"Ativar","ALREADY_ACTIVATED":"Cliente já está ativado","NO_CUSTOMER_FOUND":"Sua busca não encontrou nenhum cliente.","NO_ACTIVE_CUSTOMER":"Sua conta não possui nenhuma área do cliente ativa, clique no botão acima para adicionar e configurar uma nova área do cliente.","NO_ACTIVE_CUSTOMER_FOUND":"Sua busca não encontrou nenhuma área do cliente ativa.","SAVE_SUCCESS":"Área do cliente salva com sucesso!","SAVE_ERROR":"Erro ao salvar área do cliente, tente novamente em alguns instantes","SYNC_SUCCESS":"Cliente {{ name }} sincronizado com sucesso!","SYNC_ERROR":"Erro ao sincronizar cliente {{ name }}, tente novamente em alguns instantes","ACTIVATE_CUSTOMER":{"TITLE":"Ativar cliente","MESSAGE":"Tem certeza que deseja ativar o cliente <strong>{{ name }}</strong>? <br /> Ao aceitar, será criado um vínculo desse cliente com a área do cliente. <br /> <br /> Você deverá convidar os usuários para acessá-la na tela a seguir.","OK":"Ativar","CANCEL":"Cancelar","SUCCESS":"Cliente ativado com sucesso","ERROR":"Erro ao ativar o cliente, tente novamente mais tarde"},"DEACTIVATE_CUSTOMER":{"TITLE":"Desativar cliente","MESSAGE":"Tem certeza que deseja <strong>desativar</strong> o cliente <strong>{{ name }}</strong>? <br /> Ao aceitar, esse cliente e seus usuários não conseguirão mais acessar a área de clientes, até você o reativar.","OK":"Desativar","CANCEL":"Cancelar","SUCCESS":"Cliente desativado com sucesso","ERROR":"Erro ao desativar o cliente, tente novamente mais tarde"},"DEACTIVATE_USER":{"TITLE":"Desativar usuário","MESSAGE":"Tem certeza que deseja <strong>desativar</strong> o usuário <strong>{{ name }}</strong>? <br /> Ao aceitar, esse usuário não conseguirá mais acessar a área de clientes, até você o reativar.","OK":"Desativar","CANCEL":"Cancelar","SUCCESS":"Usuário desativado com sucesso","ERROR":"Erro ao desativar o usuário, tente novamente mais tarde"}},"USERS":{"TITLE":"Usuários","NEW":"Convidar novo usuário","SEARCH":"Buscar usuário por nome...","REMOVE":"Remover","ARCHIVE_USERS_TITLE":"Usuários desativados","NO_ACTIVE_USER_FOUND":"Esta área do cliente não possui nenhum usuário, clique no botão acima para convidar um novo usuário.","REACTIVATE":"Reativar","RELOAD":"Recarregar usuários","NO_USER_FOUND":"Sua busca não encontrou nenhum usuário.","PENDING":"Pendente de ativação","RESEND_INVITATION":"Reenviar convite","NO_SERVICES_SELECTED":"Escolha um tipo de OS antes de convidar um usuário.","NEW_SCREEN":{"TITLE":"Convidar usuário","SUBTITLE":"Envie um convite para um novo usuário do cliente <strong>{{ name }}</strong>","NAME":"Nome","EMAIL":"E-mail","INVITE":"Convidar","CANCEL":"Cancelar","OK":"OK","SUCCESS":{"TITLE":"Convite enviado com sucesso!","SUBTITLE":"O convidado irá receber o convite para criar um perfil no cliente <strong>{{ name }}</strong>"},"ERRORS":{"REQUIRED":"Esse campo é obrigatório","EMAIL":"Insira um email válido","INVITE":"Houve um erro ao enviar o email de convite, tente novamente mais tarde"}},"ACTIVATE":{"TITLE":"Ativar usuário","MESSAGE":"Deseja ativar esse usuário para o cliente {{ name }}?","OK":"Ativar","CANCEL":"Cancelar","SUCCESS":"Usuário ativado com sucesso","ERROR":"Erro ao ativar o usuário, tente novamente mais tarde"},"ACTIVATE_EXISTENT_SAME_ORGANIZATION":{"TITLE":"Ativar usuário","MESSAGE":"Esse usuário já existe, deseja ativá-lo para o cliente {{ name }}?","OK":"Ativar","CANCEL":"Cancelar","SUCCESS":"Usuário ativado com sucesso","ERROR":"Erro ao ativar o usuário, tente novamente em alguns instantes"},"ACTIVATE_ALREADY_EXISTS":{"TITLE":"Não foi possível ativar esse usuário","MESSAGE":"Esse usuário já existe para outro cliente","OK":"OK"},"ACTIVATE_ALREADY_ACTIVE":{"TITLE":"Não foi possível ativar esse usuário","MESSAGE":"Esse usuário já está ativado","OK":"OK"},"ACTIVATE_WAITING_INVITE":{"TITLE":"Esse usuário já recebeu um convite!","MESSAGE":"Esse usuário já recebeu um email de convite! Enviar novamente?","OK":"Enviar","CANCEL":"Cancelar"},"RESEND_USER_INVITATION":{"TITLE":"Re-enviar convite","MESSAGE":"Tem certeza que deseja reenviar um convite para esse usuário? <br /> Será enviado um novo convite para o email <strong> {{ email }} </strong>","OK":"Enviar","CANCEL":"Cancelar","SUCCESS":"Convite reenviado com sucesso!"}},"CONFIGURATIONS":{"TITLE":"Configurações","CLIENT_LIMIT":{"LIMIT_REACHED":"A quantidade de clientes ativos chegou ao limite! Entre em contato com a Field Control."},"CUSTOMERS_AREA_CHOOSE_EMPLOYEE_ON_TICKET_ACCEPT":{"TITLE":"Colaborador obrigatório no aceite de chamados vindos da área do cliente","HINT":"Torna a seleção do colaborador obrigatória ao aceitar um chamado da área do cliente."}}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/deadlines/i18n/en.json',
    '{"DEADLINES_MODULES":{"TITLE":"Deadlines","DESCRIPTION":"Control the deadlines of O.S.","TEXT":"Control times for the solution and response of O.S, what orders are within the deadline and those that are without answers. ","LIST":"Greater control of O.S;Time control;Solution control;Agility in care "}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/deadlines/i18n/es.json',
    '{"DEADLINES_MODULES":{"TITLE":"Plazos","DESCRIPTION":"Controlar los plazos de las O.S. ","TEXT":"Tiempos de control para la solución y respuesta de O.S, qué pedidos están dentro de la fecha límite y aquellos que están sin respuestas ","LIST":"Mayor control de O.S;Control de tiempo;Control de la solución;Agilidad en cuidado"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/deadlines/i18n/pt.json',
    '{"DEADLINES_MODULES":{"TITLE":"Prazos","DESCRIPTION":"Defina prazos de resposta e solução para os seus serviços.","TEXT":"Defina prazos de resposta e solução para os seus serviços e acompanhe a execução destes mesmos, isto é, se os colaboradores realizarão os atendimentos dentro do prazo estipulado.","LIST":"Garanta aos seus clientes que as atividades serão realizadas no prazo determinado;Seja avisado quando um prazo estiver em risco de ser violado;Localize por meio de filtros todos os serviços que tiveram prazos violados"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/equipments/i18n/en.json',
    '{"EQUIPMENTS_MODULE":{"TITLE":"Equipments","DESCRIPTION":"Control your customers\' equipment with QR Code.","TEXT":"Register the equipment of your customers and have total control with forms dedicated to each type of equipment and facilitate the identification of registration via QR Code.","LIST":"Greater control of equipment;History of equipment maintenance;Custom forms by type of equipment;Clarity in the service provided","LINK_EQUIPMENT_SERVICE_ORDER":{"TITLE":"Link equipment to the work order to the employee application","HINT":"Allows the employee to add or remove equipment from the work order."},"EQUIPMENTS_SERVICE_HISTORY":{"TITLE":"Access to the equipment service history","HINT":"Allows the employee to have access to the service history of the equipment through the application."},"REQUIRED_QRCODE":{"TITLE":"QR Code required","HINT":"Equipments can only be registered via the application with a valid QR Code."},"CREATE_ORDER_EQUIPMENTS":{"TITLE":"Create and edit equipment through the employee\'s application","HINT":"Allows the collaborator to create and edit equipments through the employee\'s application."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/equipments/i18n/es.json',
    '{"EQUIPMENTS_MODULE":{"TITLE":"Equipos","DESCRIPTION":"Controle los equipos de sus clientes con QR Code.","TEXT":"Registre los equipos de sus clientes y tenga un control total con formularios dedicados a cada tipo de equipo y facilite la identificación del registro mediante Código QR.","LIST":"Mayor control de los equipos;Historial de mantenimiento de los equipos;Formularios personalizados por tipo de equipo;Claridad en el servicio prestado","LINK_EQUIPMENT_SERVICE_ORDER":{"TITLE":"Enlace de equipamientos a la orden de servicio a la aplicación del empleado","HINT":"Permite al empleado agregar o quitar equipamientos de la orden de servicio."},"EQUIPMENTS_SERVICE_HISTORY":{"TITLE":"Acceso al histórico de servicios del equipo","HINT":"Permite que el empleado tenga acceso al histórico de servicio del equipo a través de la aplicación."},"REQUIRED_QRCODE":{"TITLE":"Se requiere el código QR","HINT":"El equipamiento solo se puede registrar a través de la aplicación con un código QR válido."},"CREATE_ORDER_EQUIPMENTS":{"TITLE":"Crear y editar equipos a través de la aplicación del colaborador","HINT":"Permite al colaborador crear y editar dispositivos a través de la aplicación del colaborador."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/equipments/i18n/pt.json',
    '{"EQUIPMENTS_MODULE":{"TITLE":"Equipamentos","DESCRIPTION":"Controle os equipamentos de seus clientes com QR Code.","TEXT":"Cadastre os Equipamentos de seus clientes e tenha total controle com formulários dedicados a cada tipo de equipamento e facilite a identificação de cadastro via QR Code.","LIST":"Maior controle de equipamentos;Histórico de manutenção de equipamentos;Formulários personalizados por tipo de equipamento;Clareza no atendimento realizado","LINK_EQUIPMENT_SERVICE_ORDER":{"TITLE":"Vincular equipamentos à ordem de serviço pelo aplicativo do colaborador","HINT":"Permite que o colaborador adicione ou remova equipamentos da ordem de serviço."},"EQUIPMENTS_SERVICE_HISTORY":{"TITLE":"Acesso ao histórico de atendimentos dos equipamentos","HINT":"Permite que o colaborador tenha acesso ao histórico de atendimentos dos equipamentos pelo aplicativo."},"REQUIRED_QRCODE":{"TITLE":"QR Code obrigatório","HINT":"Equipamentos só poderão ser cadastrados com um QR Code válido, tanto pelo painel quanto pelo aplicativo do colaborador."},"CREATE_ORDER_EQUIPMENTS":{"TITLE":"Criar e editar equipamentos pelo aplicativo do colaborador","HINT":"Permite que o colaborador crie e edite equipamentos pelo aplicativo do colaborador."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/image-resolution/i18n/en.json',
    '{"IMAGE_RESOLUTION_MODULE":{"TITLE":"Image resolution","DESCRIPTION":"Increase the image quality of your services.","TEXT":"Have more quality in the images of your calls to give even more clarity in your calls with more detailed images about the service that was performed on your customers.","LIST":"Higher image resolution;Clarity of service;Details of each maintenance"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/image-resolution/i18n/es.json',
    '{"IMAGE_RESOLUTION_MODULE":{"TITLE":"Resolución de imagen","DESCRIPTION":"Aumente la calidad de imagen de sus servicios.","TEXT":"Tener más calidad en las imágenes de tus llamadas para dar aún más claridad en tus llamadas con imágenes más detalladas sobre el servicio que se prestó a tus clientes.","LIST":"Mayor resolución de imagen;Claridad del servicio;Detalles de cada mantenimiento"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/image-resolution/i18n/pt.json',
    '{"IMAGE_RESOLUTION_MODULE":{"TITLE":"Resolução de imagem","DESCRIPTION":"Aumente a qualidade de imagem de seus atendimentos.","TEXT":"Tenha maior qualidade nas imagens de seus atendimentos para dar ainda mais clareza em seus atendimentos com imagens mais detalhadas sobre o serviço que foi realizado em seus clientes.","LIST":"Maior resolução de imagem;Clareza no atendimento;Detalhes de cada manutenção"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/materials/i18n/en.json',
    '{"MATERIALS_MODULE":{"TITLE":"Materials","DESCRIPTION":"Record all the materials used in care by your team.","TEXT":"Register all the materials used by your employees in daily visits to have greater control of your company\'s stock.","LIST":"Greater control of equipment;Control of materials used;Control of measures;Clarity in attendance"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/materials/i18n/es.json',
    '{"MATERIALS_MODULE":{"TITLE":"Materiales","DESCRIPTION":"Registre todos los materiales utilizados en el cuidado por su equipo.","TEXT":"Registra todos los materiales que utilizan tus empleados en las visitas diarias para tener un mayor control del stock de tu empresa.","LIST":"Mayor control de equipos;Control de materiales utilizados;Control de medidas;Claridad en la asistencia"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/materials/i18n/pt.json',
    '{"MATERIALS_MODULE":{"TITLE":"Materiais","DESCRIPTION":"Registre todos os materiais usados em atendimento pela sua equipe.","TEXT":"Registre todos os materiais utilizados pelos seus colaboradores em atendimentos diários para ter maior controle do estoque de sua empresa.","LIST":"Maior controle de equipamentos;Controle de materiais utilizados;Controle de medidas;Clareza no atendimento"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/print-configuration/i18n/en.json',
    '{"PRINT_CONFIGURATION_MODULE":{"TITLE":"Printing the work order","DESCRIPTION":"Customize the OS according to the settings.","SUBTITLES":{"GENERAL":"General","FORMS":"Forms","EQUIPMENTS":"Equipments","ATTACHMENTS":"Attachments","PRODUCTS":"Products"},"CONFIGURATIONS":{"COMPLEMENTARY_INFO":"Complementary information","COMPLEMENTARY_INFO_DESCRIPTION":"The information written here will be displayed on all Service Orders.","CUSTOM_FIELDS_EQUIPMENTS":"Equipments custom fields","CUSTOM_FIELDS_EQUIPMENTS_DESCRIPTION":"Show custom fields for linked equipment in work orders.","EQUIPMENTS_ORDINATION":"Forms ordination","EQUIPMENTS_ORDINATION_DESCRIPTION":"Show the order of forms according to the chosen option.","EQUIPMENTS_ORDINATION_OPTIONS":{"LINKAGE":"Linkage","NAME":"Name"},"FORMS_ORDINATION":"Forms ordination","FORMS_ORDINATION_DESCRIPTION":"Show the order of forms according to the chosen option.","FORMS_ORDINATION_OPTIONS":{"DATE":"Date","NAME":"Name"},"ORDER_CREATED_AT":"Service order creation date","ORDER_CREATED_AT_DESCRIPTION":"Display the work order creation date.","CUSTOMER_NOTES":"Customer notes","CUSTOMER_NOTES_DESCRIPTION":"Display the customer comment field.","TASK_DURATION":"Task duration","TASK_DURATION_DESCRIPTION":"Display the duration of the executed activities","EMPLOYEE_IMAGE":"Employee image","EMPLOYEE_IMAGE_DESCRIPTION":"Show an image of the employee responsible for the activity.","AUTO_PAGE_BREAK":"Page Break","AUTO_PAGE_BREAK_DESCRIPTION":"Start sections (attachments, forms, equipment, etc.) of the report on new pages.","EMPLOYEE_COORDINATES":"Employee coordinates","EMPLOYEE_COORDINATES_DESCRIPTION":"Show employee\'s coordinates, at the start and end of the activity.","FORM_SELECTED_RESPONSES":"Display only selected responses","FORM_SELECTED_RESPONSES_DESCRIPTION":"For multiple choice or checklist questions, only the selected alternatives will be displayed.","FORM_TOTAL_SCORE":"Display form total score","FORM_TOTAL_SCORE_DESCRIPTION":"Displays the total score next to the form title.","FORM_HIDE_QUESTIONS_WITHOUT_ANSWERS":"Show only questions with answers.","FORM_HIDE_QUESTIONS_WITHOUT_ANSWERS_DESCRIPTION":"Questions of any kind will not be displayed if unanswered.","FORM_QUESTIONS_DESCRIPTION":"Enable guidance messages","FORM_QUESTIONS_DESCRIPTION_DESCRIPTION":"If enabled, guidance messages defined in multiple choice and list questions will be displayed in the report.","FORM_FILLING_DATA":"View form filling data","FORM_FILLING_DATA_DESCRIPTION":"Displays the date of completion with the form.","FORM_DISPLAY_RESPONSES_IN_A_SINGLE_COLUMN":"Display form responses in a single column","FORM_DISPLAY_RESPONSES_IN_A_SINGLE_COLUMN_DESCRIPTION":"Displays the responses in a single column, increasing the size of the photos inserted in multiple photo questions. If disabled, the responses will be displayed in two columns.","EQUIPMENTS_QR_CODE":"Display QR code of equipment","EQUIPMENTS_QR_CODE_DESCRIPTION":"Displays the QR code of the equipment next to the equipment information.","ATTACHMENTS_PER_ROW":"Number of attachments per row:","ATTACHMENTS_PER_ROW_DESCRIPTION":"The quantity selected here will be the number of attachments per line in the service order.","ATTACHMENTS_PER_ROW_PLACEHOLDER":"Attachments per row quantity","HIDE_PRODUCT_VALUE":"Hide the product value (beta)","HIDE_PRODUCT_VALUE_DESCRIPTION":"If activated, the values of the products used in the activities will be hidden from the report.","SHOW_START_AND_COMPLETE_TIME":"Show Time","SHOW_START_AND_COMPLETE_TIME_DESCRIPTION":"Show the start and completion time of tasks in the report."},"SAVE_CONFIGURATION":"Save"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/print-configuration/i18n/es.json',
    '{"PRINT_CONFIGURATION_MODULE":{"TITLE":"Imprimir la orden de trabajo","DESCRIPTION":"Personalice la pantalla del sistema operativo de acuerdo con la configuración.","SUBTITLES":{"GENERAL":"General","FORMS":"Formularios","EQUIPMENTS":"Equipos","ATTACHMENTS":"Archivos adjuntos","PRODUCTS":"Productos"},"CONFIGURATIONS":{"COMPLEMENTARY_INFO":"Información complementaria","COMPLEMENTARY_INFO_DESCRIPTION":"La información escrita aquí se mostrará en todas las órdenes de servicio.","CUSTOM_FIELDS_EQUIPMENTS":"Campos personalizados de equipos","CUSTOM_FIELDS_EQUIPMENTS_DESCRIPTION":"Muestra campos personalizados para equipos vinculados en órdenes de trabajo.","EQUIPMENTS_ORDINATION":"Orden de equipos","EQUIPMENTS_ORDINATION_DESCRIPTION":"Mostrar el orden de los equipos según la opción elegida.","EQUIPMENTS_ORDINATION_OPTIONS":{"LINKAGE":"Vínculo","NAME":"Nombre"},"FORMS_ORDINATION":"Orden de formularios","FORMS_ORDINATION_DESCRIPTION":"Mostrar el orden de los formularios según la opción elegida.","FORMS_ORDINATION_OPTIONS":{"DATE":"Fecha","NAME":"Nombre"},"ORDER_CREATED_AT":"Fecha de creación de la orden de servicio","ORDER_CREATED_AT_DESCRIPTION":"Muestra la fecha de creación de la orden de trabajo.","CUSTOMER_NOTES":"Notas de los clientes","CUSTOMER_NOTES_DESCRIPTION":"Mostrar el campo de comentarios del cliente.","TASK_DURATION":"Duración de la actividad","TASK_DURATION_DESCRIPTION":"Mostrar la duración de las actividades realizadas","EMPLOYEE_IMAGE":"Imagen de colaborador","EMPLOYEE_IMAGE_DESCRIPTION":"Mostre a imagem do funcionário responsável pela atividade.","AUTO_PAGE_BREAK":"Salto de Página","AUTO_PAGE_BREAK_DESCRIPTION":"Comenzar secciones (adjuntos, formularios, equipos, etc.) del informe en nuevas páginas.","EMPLOYEE_COORDINATES":"Coordenadas del colaborador","EMPLOYEE_COORDINATES_DESCRIPTION":"Mostrar coordenadas del local del colaborador, ao iniciar y finalizar a atividade.","FORM_SELECTED_RESPONSES":"Muestra solo las respuestas seleccionadas","FORM_SELECTED_RESPONSES_DESCRIPTION":"En las preguntas de opción múltiple o lista de verificación, solo se mostrarán las alternativas seleccionadas.","FORM_TOTAL_SCORE":"Muestra la puntuación total del formulario","FORM_TOTAL_SCORE_DESCRIPTION":"Muestra la puntuación total junto al título del formulario.","FORM_HIDE_QUESTIONS_WITHOUT_ANSWERS":"Muestra solo preguntas con respuestas.","FORM_HIDE_QUESTIONS_WITHOUT_ANSWERS_DESCRIPTION":"Las preguntas de cualquier tipo no se mostrarán si no se responden.","FORM_QUESTIONS_DESCRIPTION":"Habilitar mensajes de guía","FORM_QUESTIONS_DESCRIPTION_DESCRIPTION":"Si está habilitado, los mensajes de guía definidos en preguntas de lista y opción múltiple se mostrarán en el informe.","FORM_FILLING_DATA":"Ver datos de llenado de formularios","FORM_FILLING_DATA_DESCRIPTION":"Muestra la fecha de finalización con el formulario","FORM_DISPLAY_RESPONSES_IN_A_SINGLE_COLUMN":"Mostrar respuestas de formulario en una sola columna","FORM_DISPLAY_RESPONSES_IN_A_SINGLE_COLUMN_DESCRIPTION":"Muestra las respuestas en una sola columna, ampliando el tamaño de las fotos insertadas en preguntas de múltiples fotos. Si está deshabilitado, las respuestas se mostrarán en dos columnas.","EQUIPMENTS_QR_CODE":"Muestra el código QR del equipo","EQUIPMENTS_QR_CODE_DESCRIPTION":"Muestra el código QR del equipo junto a la información del equipo.","ATTACHMENTS_PER_ROW":"Número de archivos adjuntos por línea:","ATTACHMENTS_PER_ROW_DESCRIPTION":"La cantidad seleccionada aquí será la cantidad de archivos adjuntos por línea en la orden de servicio.","ATTACHMENTS_PER_ROW_PLACEHOLDER":"Cantidad de archivos adjuntos por fila","HIDE_PRODUCT_VALUE":"Ocultar el valor del producto (beta)","HIDE_PRODUCT_VALUE_DESCRIPTION":"Si está activada, los valores de los productos utilizados en las actividades se ocultarán en el informe.","SHOW_START_AND_COMPLETE_TIME":"Muestra Hora","SHOW_START_AND_COMPLETE_TIME_DESCRIPTION":"Muestra la hora de inicio y finalización de las tareas en el informe."},"SAVE_CONFIGURATION":"Guardar"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/print-configuration/i18n/pt.json',
    '{"PRINT_CONFIGURATION_MODULE":{"TITLE":"Impressão da ordem de serviço","DESCRIPTION":"Personalize a exibição da OS de acordo com as configurações.","SUBTITLES":{"GENERAL":"Geral","FORMS":"Formulários","EQUIPMENTS":"Equipamentos","ATTACHMENTS":"Anexos","PRODUCTS":"Produtos"},"CONFIGURATIONS":{"COMPLEMENTARY_INFO":"Informação complementar","COMPLEMENTARY_INFO_DESCRIPTION":"As informações escritas aqui serão exibidas em todas as ordens de serviço.","CUSTOM_FIELDS_EQUIPMENTS":"Campos customizados dos equipamentos","CUSTOM_FIELDS_EQUIPMENTS_DESCRIPTION":"Exibir campos customizados dos equipamentos vinculados às ordens de serviço.","EQUIPMENTS_ORDINATION":"Ordenação dos equipamentos","EQUIPMENTS_ORDINATION_DESCRIPTION":"Exibir a ordem dos equipamentos de acordo com a opção escolhida.","EQUIPMENTS_ORDINATION_OPTIONS":{"LINKAGE":"Vínculo","NAME":"Nome"},"FORMS_ORDINATION":"Ordenação dos formulários","FORMS_ORDINATION_DESCRIPTION":"Exibir a ordem dos formulários de acordo com a opção escolhida.","FORMS_ORDINATION_OPTIONS":{"DATE":"Data","NAME":"Nome"},"ORDER_CREATED_AT":"Data de criação da ordem de serviço","ORDER_CREATED_AT_DESCRIPTION":"Exibir a data de criação da ordem de serviço.","CUSTOMER_NOTES":"Observações do cliente","CUSTOMER_NOTES_DESCRIPTION":"Exibir o campo de observações do cliente.","TASK_DURATION":"Duração da atividade","TASK_DURATION_DESCRIPTION":"Exibir a duração das atividades realizadas","EMPLOYEE_IMAGE":"Imagem do colaborador","EMPLOYEE_IMAGE_DESCRIPTION":"Mostrar imagem do colaborador responsável pela atividade.","AUTO_PAGE_BREAK":"Quebra de página","AUTO_PAGE_BREAK_DESCRIPTION":"Começar seções (anexos, formulários, equipamentos, etc) do relatório em novas páginas.","EMPLOYEE_COORDINATES":"Coordenadas do colaborador","EMPLOYEE_COORDINATES_DESCRIPTION":"Mostrar coordenadas do local do colaborador, ao iniciar e finalizar a atividade.","FORM_SELECTED_RESPONSES":"Exibir apenas as respostas selecionadas","FORM_SELECTED_RESPONSES_DESCRIPTION":"Em perguntas de Múltipla escolha ou Checklist só serão exibidas as alternativas selecionadas.","FORM_TOTAL_SCORE":"Exibir pontuação total dos formulários","FORM_TOTAL_SCORE_DESCRIPTION":"Exibe a pontuação total ao lado do título do formulário.","FORM_HIDE_QUESTIONS_WITHOUT_ANSWERS":"Exibir apenas as perguntas com resposta","FORM_HIDE_QUESTIONS_WITHOUT_ANSWERS_DESCRIPTION":"Perguntas de qualquer tipo não serão exibidas caso estejam sem resposta.","FORM_QUESTIONS_DESCRIPTION":"Habilitar mensagens de orientação","FORM_QUESTIONS_DESCRIPTION_DESCRIPTION":"Se ativada, as mensagens de orientação definidas em perguntas de múltipla escolha e lista serão exibidas do relatório.","FORM_FILLING_DATA":"Exibir dados de preenchimento do formulário","FORM_FILLING_DATA_DESCRIPTION":"Exibe junto ao formulário a data de preenchimento.","FORM_DISPLAY_RESPONSES_IN_A_SINGLE_COLUMN":"Exibir respostas de formulário em apenas uma coluna","FORM_DISPLAY_RESPONSES_IN_A_SINGLE_COLUMN_DESCRIPTION":"Exibe as respostas em apenas uma coluna, ampliando o tamanho das fotos inseridas em perguntas de múltiplas fotos. Caso esteja desabilitada, as respostas serão exibidas em duas colunas.","EQUIPMENTS_QR_CODE":"Exibir o QR code do equipamento","EQUIPMENTS_QR_CODE_DESCRIPTION":"Exibe o QR code do equipamento ao lado das informações do mesmo.","ATTACHMENTS_PER_ROW":"Número de anexos por linha:","ATTACHMENTS_PER_ROW_DESCRIPTION":"A quantidade selecionada aqui será o número de anexos por linha na ordem de serviços.","ATTACHMENTS_PER_ROW_PLACEHOLDER":"Quantidade de anexos por linha","HIDE_PRODUCT_VALUE":"Esconder valor do produto (beta)","HIDE_PRODUCT_VALUE_DESCRIPTION":"Se ativada, os valores dos produtos utilizados nas atividades serão ocultados do relatório","SHOW_START_AND_COMPLETE_TIME":"Exibir Hora","SHOW_START_AND_COMPLETE_TIME_DESCRIPTION":"Exibir a hora de início e conclusão das tarefas no relatório."},"SAVE_CONFIGURATION":"Salvar"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/route-optimizer/i18n/en.json',
    '{"ROUTE_OPTIMIZER_MODULE":{"ROUTE_CREDITS":"credits for routings","AVULSE_CREDITS":"Single credits","HIRE_MORE":"Hire more","TITLE":"Route optimizer","DESCRIPTION":"Automate your team\'s routes with artificial intelligence.","TEXT":"Automate the routes of all employees through artificial intelligence that identifies the best possible routes to save time and gasoline.","LIST":"More efficient management;Time savings;Gasoline savings","INFO":"The route optimization module is a key component to optimize and simplify the management of teams performing field services. In addition to improving operational efficiency and minimizing travel times, it helps maximize overall team productivity in the field."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/route-optimizer/i18n/es.json',
    '{"ROUTE_OPTIMIZER_MODULE":{"ROUTE_CREDITS":"créditos para rutas","AVULSE_CREDITS":"Créditos sueltos","HIRE_MORE":"Contratar más","TITLE":"Optimización de Rutas","DESCRIPTION":"Automatice las rutas de su equipo con inteligencia artificial.","TEXT":"Automatice las rutas de todos los colaboradores a través de inteligencia artificial que identifica las mejores rutas posibles para ahorrar tiempo y gasolina.","LIST":"Gestión más eficiente;Ahorro de tiempo;Ahorro de gasolina","INFO":"El módulo de optimización de rutas es una pieza fundamental para optimizar y simplificar la gestión de equipos que realizan servicios en campo. Además de mejorar la eficiencia operativa y minimizar los tiempos de desplazamiento, ayuda a maximizar la productividad general de los equipos en el campo."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/route-optimizer/i18n/pt.json',
    '{"ROUTE_OPTIMIZER_MODULE":{"ROUTE_CREDITS":"créditos para roteirizações","AVULSE_CREDITS":"Créditos avulsos","HIRE_MORE":"Contratar mais","TITLE":"Roteirização","DESCRIPTION":"Automatize as rotas de sua equipe com inteligência artificial.","TEXT":"Automatize as rotas de todos os colaboradores através de uma inteligência artificial que identifica as melhores rotas possíveis para economizar tempo e gasolina.","LIST":"Gestão mais eficiente;Economia de tempo;Economia de gasolina","INFO":"O módulo de roteirização é uma peça fundamental para otimizar e simplificar a gestão de equipes que realizam serviços externos. Além de aprimorar a eficiência operacional e minimizar os tempos de deslocamento, ele ajuda a maximizar a produtividade geral das equipes em campo."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/smart-rewrite/i18n/en.json',
    '{"SMART_REWRITE_MODULES":{"TITLE":"Smart Rewrite","GENERAL":"General","HISTORY":"History","INFO":"The smart rewrite module is an essential tool to maintain clear communication with your customers, preventing them from losing trust in your company due to your team\'s typing errors.","CLICK_HERE":"Click here","INFO_END":"to watch a video about the module.","USED_CREDITS":"used credits","REWRITE_CREDITS":"rewrite credits","MONTHLY_PLAN":"Monthly Plan","AVULSE_CREDITS":"One-time credits","HIRE_MORE":"Hire More","MANAGE_SUBSCRIPTION":"Would you like to manage your subscription?","CONTACT":"Contact ","CONTACT_END":"or speak with your account manager.","LOAD_MORE":"Load More","TODAY":"Today","YESTERDAY":"Yesterday","ANTERIOR":"Previous","TOTAL_VALUE":"Total Balance:","CREDITS":"{{ value }} credits","NO_CREDIT":"No credits used yet.","OPTIONS":{"SPELLING":"Correct Errors","SHORTENED":"Shorter","DESCRIPTIVE":"More Descriptive","FORMAL":"More Formal"},"HISTORY_TYPES":{"SPELLING":"Spelling Correction","SHORTENED":"Shorter Writing","DESCRIPTIVE":"More Descriptive Writing","FORMAL":"More Formal Writing"},"PLATFORMS":{"MORDOR":"Manager Panel","":"Manager Panel","GOTHMOG":"Manager App","ORC":"Employee App","ORC-PWA":"Employee App (PWA)"},"ALTERED_BY":"Used by {{ name }} via {{ platform }}","DESCRIPTION":"Maintain clear communication with your customers, preventing them from losing trust due to writing errors.","TEXT":"The smart rewrite module is an essential tool to maintain clear communication with your customers, preventing them from losing trust in your company due to your team\'s typing errors. Click here to watch a video about the module.","LIST":"Advanced algorithm with the ability to analyze content to understand context and meaning;Identification and correction of grammatical and spelling errors;Option to shorten text while maintaining clarity and relevance;Option to extend text length in a cohesive and meaningful way;Option to make the text more formal as needed;Recording of changes made to enable review and reversal;Smart rewriting capability in different languages"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/smart-rewrite/i18n/es.json',
    '{"SMART_REWRITE_MODULES":{"TITLE":"Reescritura Inteligente","GENERAL":"General","HISTORY":"Historial","INFO":"El módulo de reescritura inteligente es una herramienta esencial para mantener una comunicación clara con sus clientes, evitando que pierdan la confianza en su empresa debido a los errores de escritura de su equipo.","CLICK_HERE":"Haga clic aquí","INFO_END":"para ver un video sobre el módulo.","USED_CREDITS":"créditos utilizados","REWRITE_CREDITS":"créditos de reescritura","MONTHLY_PLAN":"Plan Mensual","AVULSE_CREDITS":"Créditos únicos","HIRE_MORE":"Contratar Más","MANAGE_SUBSCRIPTION":"¿Le gustaría gestionar su suscripción?","CONTACT":"Póngase en contacto con ","CONTACT_END":"o hable con su gerente de cuenta.","LOAD_MORE":"Cargar Más","TODAY":"Hoy","YESTERDAY":"Ayer","ANTERIOR":"Anterior","TOTAL_VALUE":"Saldo Total:","CREDITS":"{{ value }} créditos","NO_CREDIT":"No se han utilizado créditos todavía.","OPTIONS":{"SPELLING":"Corregir Errores","SHORTENED":"Más Corto","DESCRIPTIVE":"Más Descriptivo","FORMAL":"Más Formal"},"HISTORY_TYPES":{"SPELLING":"Corrección de Errores","SHORTENED":"Escritura Más Corta","DESCRIPTIVE":"Escritura Más Descriptiva","FORMAL":"Escritura Más Formal"},"PLATFORMS":{"MORDOR":"Panel del Gestor","":"Panel del Gestor","GOTHMOG":"Aplicación del Gestor","ORC":"Aplicación del Colaborador","ORC-PWA":"Aplicación del Colaborador (PWA)"},"ALTERED_BY":"Utilizado por {{ name }} vía {{ platform }}","DESCRIPTION":"Mantenga una comunicación clara con sus clientes, evitando que pierdan la confianza debido a errores de escritura.","TEXT":"El módulo de reescritura inteligente es una herramienta esencial para mantener una comunicación clara con sus clientes, evitando que pierdan la confianza en su empresa debido a los errores de escritura de su equipo. Haga clic aquí para ver un video sobre el módulo.","LIST":"Algoritmo avanzado con capacidad de analizar contenido para comprender contexto y significado;Identificación y corrección de errores gramaticales y ortográficos;Opción para acortar texto manteniendo claridad y relevancia;Opción para extender longitud del texto de manera cohesiva y significativa;Opción para hacer el texto más formal según sea necesario;Registro de cambios realizados para permitir revisión y reversión;Capacidad de reescritura inteligente en diferentes idiomas"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/smart-rewrite/i18n/pt.json',
    '{"SMART_REWRITE_MODULES":{"TITLE":"Reescrita inteligente","GENERAL":"Geral","HISTORY":"Histórico","INFO":"O módulo de reescrita inteligente é uma ferramenta essencial para manter uma comunicação sem ruídos com seus clientes, evitando que eles percam a confiança em sua empresa devido à erros de digitação da sua equipe. ","CLICK_HERE":"Clique aqui","INFO_END":"para assistir um vídeo sobre o módulo.","USED_CREDITS":"créditos utilizados","REWRITE_CREDITS":"créditos de reescrita","MONTHLY_PLAN":"Plano mensal","AVULSE_CREDITS":"Créditos avulsos","HIRE_MORE":"Contratar mais","MANAGE_SUBSCRIPTION":"Gostaria de gerenciar sua assinatura?","CONTACT":"Entre em contato com ","CONTACT_END":"ou fale com seu gerente de conta.","LOAD_MORE":"Carregar mais","TODAY":"Hoje","YESTERDAY":"Ontem","ANTERIOR":"Anterior","TOTAL_VALUE":"Saldo total:","CREDITS":"{{ value }} créditos","NO_CREDIT":"Nenhum crédito utilizado até o momento.","OPTIONS":{"SPELLING":"Corrigir erros","SHORTENED":"Mais curto","DESCRIPTIVE":"Mais descritivo","FORMAL":"Mais formal"},"HISTORY_TYPES":{"SPELLING":"Correção de erros","SHORTENED":"Escrita mais curta","DESCRIPTIVE":"Escrita mais descritiva","FORMAL":"Escrita mais formal"},"PLATFORMS":{"MORDOR":"Painel do gestor","":"Painel do gestor","GOTHMOG":"Aplicativo do gestor","ORC":"Aplicativo do colaborador","ORC-PWA":"Aplicativo do colaborador (PWA)"},"ALTERED_BY":"Utilizado por {{ name }} via {{ platform }}","DESCRIPTION":"Mantenha a comunicação com seus clientes sem ruídos, evitando a perca de confiança devido à erros de escrita.","TEXT":"O módulo de reescrita inteligente é uma ferramenta essencial para manter uma comunicação sem ruídos com seus clientes, evitando que eles percam a confiança em sua empresa devido à erros de digitação da sua equipe. Clique aqui para assistir um vídeo sobre o módulo.","LIST":"Algoritmo avançado com capacidade de analisar o conteúdo para compreender contexto e significado;Identificação e correção de erros gramaticais e ortográficos;Opção que permite reduzir a extensão do texto mantendo a clareza e relevância;Opção que permite estender o comprimento do texto de maneira coesa e significativa;Opção que permite tornar o texto mais formal, conforme necessário;Registro das alterações realizadas para possibilitar revisão e reversão;Capacidade de reescrita inteligente em diferentes idiomas"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/storage-control/i18n/en.json',
    '{"STORAGE_CONTROL_MODULES":{"TITLE":"Storage","DESCRIPTION":"Keep your storage under control and know which products are with your collaborators.","TEXT":"Ensure complete control of your storage products, from tracking to managing movements. Make more informed and strategic decisions to boost your business growth.","LIST":"Manage the storage of your products; Know which products are in possession of the collaborators; Explore each entry and exit movement in detail."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/storage-control/i18n/es.json',
    '{"STORAGE_CONTROL_MODULES":{"TITLE":"Inventario","DESCRIPTION":"Mantén tu inventario bajo control y sabe qué productos están en manos de tus colaboradores.","TEXT":"Asegura el control completo de los productos de tu inventario, desde el seguimiento hasta la gestión de movimientos. Toma decisiones más informadas y estratégicas para impulsar el crecimiento de tu negocio.","LIST":"Gestiona el inventario de tus productos; Sabe qué productos están en posesión de los colaboradores; Explora cada movimiento de entrada y salida en detalle."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/storage-control/i18n/pt.json',
    '{"STORAGE_CONTROL_MODULES":{"TITLE":"Estoque","DESCRIPTION":"Mantenha o estoque sob controle e saiba quais produtos estão com seus colaboradores.","TEXT":"Garanta o controle total dos seus produtos em estoque, desde acompanhar até gerenciar movimentações. Tome decisões mais informadas e estratégicas para impulsionar o crescimento do seu negócio.","LIST":"Gerencie o estoque dos seus produtos;Saiba quais produtos estão em posse dos colaboradores;Explore cada movimentação de entrada e saída em detalhes."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/tasks-plans/i18n/en.json',
    '{"TASKS_PLANS_MODULE":{"TITLE":"Activities Plans","DESCRIPTION":"Import maintenance plan services.","TEXT":"Register as many work orders as you need through spreadsheets.","LIST":"Reduction in the registration time of activities; Greater assertiveness of the information entered; Guarantee that the maintenance plans will be carried out on the correct dates."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/tasks-plans/i18n/es.json',
    '{"TASKS_PLANS_MODULE":{"TITLE":"Planes de actividades","DESCRIPTION":"Importe servicios del plan de mantenimiento.","TEXT":"Registre tantas órdenes de trabajo como necesite mediante hojas de cálculo.","LIST":"Reducción del tiempo de registro de actividades; Mayor asertividad de la información introducida; Garantía de que los planes de mantenimiento se llevarán a cabo en las fechas correctas"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/tasks-plans/i18n/pt.json',
    '{"TASKS_PLANS_MODULE":{"TITLE":"Planos de atividades","DESCRIPTION":"Importe serviços de planos de manutenções.","TEXT":"Cadastre quantas ordens de serviço precisar através de planilhas.","LIST":"Redução no tempo de cadastro de atividades; Maior assertividade das informações inseridas; Garantia de que os planos de manutenções serão realizados nas datas corretas."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/templates/i18n/en.json',
    '{"TEMPLATES_MODULE":{"TITLE":"Templates","DESCRIPTION":"Create and customize templates for work order reports.","TEXT":"Develop custom templates to standardize and optimize your work order reports. Adjust them according to your needs to ensure efficiency and professionalism.","LIST":"Create custom templates for reports;Define layouts and information as needed;Enhance the organization and presentation of work orders."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/templates/i18n/es.json',
    '{"TEMPLATES_MODULE":{"TITLE":"Modelos","DESCRIPTION":"Cree y personalice modelos para informes de órdenes de servicio.","TEXT":"Desarrolle modelos personalizados para estandarizar y optimizar sus informes de órdenes de servicio. Ajústelos según sus necesidades para garantizar eficiencia y profesionalismo.","LIST":"Cree modelos personalizados para informes;Defina diseños e información según sus necesidades;Mejore la organización y presentación de las órdenes de servicio."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/templates/i18n/pt.json',
    '{"TEMPLATES_MODULE":{"TITLE":"Templates","DESCRIPTION":"Crie e personalize modelos para relatórios de ordem de serviço.","TEXT":"Desenvolva templates personalizados para padronizar e otimizar seus relatórios de ordem de serviço. Ajuste conforme suas necessidades para garantir eficiência e profissionalismo.","LIST":"Crie modelos personalizados para relatórios;Defina layouts e informações conforme sua necessidade;Aprimore a organização e apresentação das ordens de serviço."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/territories/i18n/en.json',
    '{"TERRITORIES_MODULE":{"TITLE":"Territories","DESCRIPTION":"Territorial permissions to link users to specific regions.","TEXT":"Link user groups to regions and restrict the execution of work orders to clients within these areas.","LIST":"Link users to specific regions;Restrict work orders based on location;Control access in a territorial manner."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/territories/i18n/es.json',
    '{"TERRITORIES_MODULE":{"TITLE":"Territorios","DESCRIPTION":"Permisos territoriales para vincular usuarios a regiones específicas.","TEXT":"Vincule grupos de usuarios a regiones y restrinja la ejecución de órdenes de servicio solo a clientes de esas áreas.","LIST":"Vincule usuarios a regiones específicas;Restrinja órdenes de servicio según la ubicación;Controle el acceso de manera territorial."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/territories/i18n/pt.json',
    '{"TERRITORIES_MODULE":{"TITLE":"Territórios","DESCRIPTION":"Permissionamento territorial para vincular usuários a regiões específicas.","TEXT":"Vincule grupos de usuários a regiões e restrinja a realização de ordens de serviço apenas para clientes dessas áreas.","LIST":"Vincule usuários a regiões específicas;Restringa ordens de serviço conforme a localização;Controle o acesso de forma territorializada."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/tickets/i18n/en.json',
    '{"TICKETS_MODULE":{"TITLE":"Tickets","DESCRIPTION":"Have a portal for your customers to open tickets.","TEXT":"Receive requests from your customers through a single panel and reduce the waiting time for customer service.","LIST":"Speed in attendance;Customized panel of your company;Attendance form;Reduction of waiting time","TASKS":{"TITLE":"OS types available:","HINT":"Only the OS types selected will be displayed when open a ticket.","SEARCH":"Search by OS type ...","REQUIRED":"At least 1 OS type is required for opening tickets"},"SLUG":{"TITLE":"Complete your online address (link): *","HINT":"This will be your online address (link) for opening tickets from your customers","REQUIRED":"The URL complement is required","IN_USE":"The URL complement is already in use","INVALID":"The URL complement is in an invalid format. Example: field-control","MIN":"The URL complement must be at least 2 characters long","MAX":"The URL complement must be a maximum of 50 characters","COPY_LINK":"Copy link"},"CONFIGURATIONS":{"SHOW_ADDRESS_FIELDS":"Show address fields on the link","SHOW_ADDRESS_FIELDS_DESCRIPTION":"By enabling this setting, address fields will be displayed for filling.","MANDATORY_ADDRESS_FIELDS":"Turn the address fields mandatory","MANDATORY_ADDRESS_FIELDS_DESCRIPTION":"By enabling this setting, the filling of the address fields will be mandatory to fulfill the ticket."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/tickets/i18n/es.json',
    '{"TICKETS_MODULE":{"TITLE":"Petición de servicio","DESCRIPTION":"Tenga un portal para que sus clientes abran tickets.","TEXT":"Reciba solicitudes de sus clientes a través de un solo panel y reduzca el tiempo de espera para el servicio al cliente","LIST":"Rapidez en la asistencia;Panel personalizado de su empresa;Formulario de asistencia;Reducción del tiempo de espera","TASKS":{"TITLE":"Tipos de OS disponibles:","HINT":"Solo se mostrarán los tipos de OS seleccionados al solicitar un servicio.","SEARCH":"Buscar por tipo de OS ...","REQUIRED":"Se requiere al menos 1 tipo de OS para abrir boletos"},"SLUG":{"TITLE":"Complete su dirección en línea (enlace): *","HINT":"Esta será su dirección en línea (enlace) para solicitar servicios a sus clientes","REQUIRED":"Se requiere el complemento de URL","IN_USE":"El complemento de URL ya está en uso","INVALID":"El complemento de URL tiene un formato no válido. Ejemplo: field-control","MIN":"El complemento de URL debe tener al menos 2 caracteres","MAX":"El complemento de URL debe tener un máximo de 50 caracteres.","COPY_LINK":"Copiar enlace"},"CONFIGURATIONS":{"SHOW_ADDRESS_FIELDS":"Mostrar campos de dirección en el enlace","SHOW_ADDRESS_FIELDS_DESCRIPTION":"Al habilitar esta configuración, los campos de dirección se mostrarán para rellenar.","MANDATORY_ADDRESS_FIELDS":"Hacer obligatorios los campos de dirección","MANDATORY_ADDRESS_FIELDS_DESCRIPTION":"Al habilitar esta configuración, el llenado de los campos de dirección será obligatorio para realizar la solicitud."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/tickets/i18n/pt.json',
    '{"TICKETS_MODULE":{"TITLE":"Solicitação de serviços","DESCRIPTION":"Tenha um portal para que seus clientes possam abrir chamados.","TEXT":"Receba as solicitações de seus clientes através de um painel único e diminua o tempo de espera do atendimento de seus clientes.","LIST":"Velocidade no atendimento;Painel personalizado da sua empresa;Formulário de atendimento;Redução do tempo de espera","TASKS":{"TITLE":"Tipos de OS disponíveis:","HINT":"Apenas os tipos de OS selecionados serão exibidas na solicitação de um serviço.","SEARCH":"Procurar por tipo de OS...","REQUIRED":"Necessário pelo menos 1 tipo de OS para a abertura de chamados"},"SLUG":{"TITLE":"Complete o seu endereço online (link):*","HINT":"Esse será seu endereço online (link) para a solicitação de serviços do seus clientes","REQUIRED":"O complemento da URL é necessario","IN_USE":"O complemento da URL já está em uso","INVALID":"O complemento da URL está em um formato invalido. Exemplo: field-control","MIN":"O complemento da URL deve ter pelo menos 2 caracteres","MAX":"O complemento da URL deve ter no maximo 50 caracteres","COPY_LINK":"Copiar link"},"CONFIGURATIONS":{"SHOW_ADDRESS_FIELDS":"Mostrar campos de endereço no link","SHOW_ADDRESS_FIELDS_DESCRIPTION":"Ao habilitar essa configuração, os campos de endereço serão exibidos para preenchimento.","MANDATORY_ADDRESS_FIELDS":"Tornar campos de endereço obrigatórios","MANDATORY_ADDRESS_FIELDS_DESCRIPTION":"Ao habilitar essa configuração, o preenchimento dos campos de endereço será obrigatório para efetuar a solicitação."}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/vehicles/i18n/en.json',
    '{"VEHICLES":{"TITLE":"Vehicles","DESCRIPTION":"Control vehicles and their mileage.","TEXT":"Register and control your vehicles, as well as their mileage through usage reports.","LIST":"Zero paper, just like work orders. All digitized; Greater security of collected data; Accurate data collection and easy reporting."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/vehicles/i18n/es.json',
    '{"VEHICLES":{"TITLE":"Vehículos","DESCRIPTION":"Controla los vehículos y su kilometraje.","TEXT":"Registra y controla tus vehículos, así como su kilometraje a través de informes de uso.","LIST":"Cero papel, al igual que las órdenes de trabajo. Todo digitalizado; Mayor seguridad de los datos recopilados; Recopilación precisa de datos y fácil generación de informes."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/vehicles/i18n/pt.json',
    '{"VEHICLES":{"TITLE":"Veículos","DESCRIPTION":"Faça o controle de veículos e suas respectivas quilometragens","TEXT":"Cadastre e controle seus veículos, assim como suas quilometragens rodadas através de relatórios de uso.","LIST":"Zero papel, assim como as ordens de serviço. Tudo digitalizado;Maior segurança dos dados coletados;Levantamento de dados precisos e fácil emissão de relatórios."}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/videos/i18n/en.json',
    '{"VIDEOS_MODULE":{"TITLE":"Video","DESCRIPTION":"Capture more details of your field service by uploading  videos.","TEXT":"Have more field service details with video uploads bringing greater clarity and are easy to identify issues with quality image and sound.","LIST":"Clarity of service; Detail of maintenance; Audiovisual capture of problems and resolutions"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/videos/i18n/es.json',
    '{"VIDEOS_MODULE":{"TITLE":"Video","DESCRIPTION":"Agrega videos en las ordens de trabajo.","TEXT":"Tener más detalles de la asistencia con videos que faciliten el trabajo y den mayor claridad en el servicio realizado con calidad de imagen y sonido.","LIST":"Claridad de servicio; Detalle de mantenimiento; Captura audiovisual de problemas y resoluciones"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/modules/sidenavs/videos/i18n/pt.json',
    '{"VIDEOS_MODULE":{"TITLE":"Vídeo","DESCRIPTION":"Capture mais detalhes de seus atendimentos com vídeos.","TEXT":"Tenha mais detalhes dos atendimentos com vídeos que facilitam o trabalho e dão mais clareza no serviço realizado com imagem e som de qualidade.","LIST":"Clareza no atendimento;Detalhe da manutenção;Captação audiovisual dos problemas e resoluções"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/settings/contents/integrations/i18n/en.json',
    '{"APPS":{"OMIE":{"TITLE":"Omie Integration","DESCRIPTION":"Issue charges for each service with a dedicated system.","SERVICE_QUANTITY_AS_DURATION":{"TITLE":"Consider service quantity when sending it to Omie","DESCRIPTION":"Consider the service quantity based on the total duration of the work order when sending it to Omie."},"COMMERCIAL_NAME":{"TITLE":"Import customers using the company name","DESCRIPTION":"If this setting is disabled, the customers will be imported using the company name."},"SERVICES_OS_VALUE":{"TITLE":"Use Field service values by default when exporting OS to Omie","DESCRIPTION":"If this setting is enabled, when exporting the O.S. to Omie, the service values will be obtained from Field Control and not from Omie."},"ACCOUNTS":{"TITLE":"Integrations {{value}}/5","NAME":"Name","KEY":"App Key","SECRET":"App Secret","ADD":"Add Integration","DELETE":{"TITLE":"Delete Account","ONE_ITEM":"Must have at least one item","DESCRIPTION":"Are you sure you want to remove the integration with the account <b>{{account}}</b>?","TOAST":"Integration with account {{account}} successfully removed.","YES":"YES","NO":"NO"},"ERRORS":{"REQUIRED":"This field is required.","DUPLICATED_NAME":"Duplicate name, please enter a unique name.","DUPLICATED_KEY":"Duplicate key, please enter a unique key.","MINLENGTH_KEY":"The key must have 10 or more characters.","MINLENGTH_SECRET":"The secret must have 32 or more characters."}}},"CONTA_AZUL":{"TITLE":"Conta Azul","CONFIRM_DIALOG":{"TITLE":"Attention","CONTENT":"You are about to be redirected to an external website<br><br>Do you want to continue and leave the page?","NO":"NO","CONTINUE":"Continue"},"DESCRIPTION":"Connect your financial system with your management system."},"PAGE_TITLE":"Integrations","SUCCESS_WHEN_DISABLING":"Integration with {{ app }} successfully disabled!","ERROR_WHEN_SAVING":"Error saving integration with {{ app }}","ERROR_WHEN_DISABLING":"Error disabling integration with {{ app }}","NO_CONFIG":"This integration is active, but there is no additional configuration available.","SAVE":"Save","DISABLE":"Disable","TOAST_SUCCESS":"Changes saved successfully.","DISABLE_DIALOG":{"TITLE":"Disable Integration","TEXT":"Are you sure you want to disable this integration?","YES":"Yes","NO":"No"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/settings/contents/integrations/i18n/es.json',
    '{"APPS":{"OMIE":{"TITLE":"Integracion Omie","DESCRIPTION":"Emitir cobros por cada servicio con un sistema dedicado.","SERVICE_QUANTITY_AS_DURATION":{"TITLE":"Considerar cantidad de servicio al enviar a Omie","DESCRIPTION":"Considerar la cantidad de servicio en función de la duración total de la orden de trabajo al enviarla a Omie."},"COMMERCIAL_NAME":{"TITLE":"Importar clientes utilizando el nombre de la empresa","DESCRIPTION":"Si esta configuración está deshabilitada, los clientes se importarán utilizando el nombre de la empresa."},"SERVICES_OS_VALUE":{"TITLE":"Usar por defecto los valores de los servicios de Field al exportar OS a Omie","DESCRIPTION":"Si esta configuración está habilitada, al exportar la O.S. a Omie, los valores de los servicios se obtendrán de Field Control y no de Omie."},"ACCOUNTS":{"TITLE":"integraciones {{value}}/5","NAME":"Nombre","KEY":"Clave de la App","SECRET":"Secreto de la App","ADD":"Agregar Integración","DELETE":{"TITLE":"Eliminar Cuenta","ONE_ITEM":"Debe tener al menos un elemento","DESCRIPTION":"¿Estás seguro de que deseas eliminar la integración con la cuenta <b>{{account}}</b>?","TOAST":"Integración con la cuenta {{account}} eliminada con éxito.","YES":"SÍ","NO":"NO"},"ERRORS":{"REQUIRED":"Este campo es obligatorio.","DUPLICATED_NAME":"Nombre duplicado, por favor ingresa un nombre único.","DUPLICATED_KEY":"Clave duplicada, por favor ingresa una clave única.","MINLENGTH_KEY":"La clave debe tener más de 10 caracteres.","MINLENGTH_SECRET":"El secreto debe tener más de 32 caracteres."}}},"CONTA_AZUL":{"TITLE":"Conta Azul","CONFIRM_DIALOG":{"TITLE":"Atención","CONTENT":"Estás a punto de ser redirigido a un sitio web externo<br><br>¿Quieres continuar y salir de la página?","NO":"NO","CONTINUE":"Continuar"},"DESCRIPTION":"Conecta tu sistema financiero con tu sistema de gestión."},"PAGE_TITLE":"Integraciones","SUCCESS_WHEN_DISABLING":"¡Integración con {{ app }} deshabilitada correctamente!","ERROR_WHEN_SAVING":"Error al guardar la integración con {{ app }}","ERROR_WHEN_DISABLING":"Error al deshabilitar la integración con {{ app }}","NO_CONFIG":"Esta integración está activa, pero no hay ninguna configuración adicional disponible.","SAVE":"Guardar","DISABLE":"Deshabilitar","TOAST_SUCCESS":"Las alteraciónes fueron guardaron exitosamente.","DISABLE_DIALOG":{"TITLE":"Deshabilitar Integración","TEXT":"¿Está seguro de que desea deshabilitar esta integración?","YES":"Sí","NO":"No"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/settings/contents/integrations/i18n/pt.json',
    '{"APPS":{"OMIE":{"TITLE":"Integração Omie","DESCRIPTION":"Emita cobranças de cada atendimento com um sistema dedicado.","SERVICE_QUANTITY_AS_DURATION":{"TITLE":"Considerar quantidade de serviços no envio ao Omie","DESCRIPTION":"Considerar a quantidade de serviços baseada na duração total da ordem de serviço ao enviá-la para o Omie."},"COMMERCIAL_NAME":{"TITLE":"Importar clientes com o nome fantasia","DESCRIPTION":"Se esta configuração estiver desabilitada, os clientes serão importados com a razão social."},"SERVICES_OS_VALUE":{"TITLE":"Usar por padrão valores de serviços do Field ao exportar OS para Omie","DESCRIPTION":"Se esta configuração estiver habilitada, ao exportar a O.S. para o Omie, os valores dos serviços serão obtidos do Field Control, e não do Omie."},"ACCOUNTS":{"TITLE":"Integrações {{value}}/5","NAME":"Nome","KEY":"App Key","SECRET":"App Secret","ADD":"Adicionar Integração","DELETE":{"TITLE":"Deletar conta","ONE_ITEM":"Precisa ter pelo menos um item","DESCRIPTION":"Tem certeza que deseja remover a integração com a conta <b>{{account}}</b>?","TOAST":"Integração com a conta {{account}} removida com sucesso.","YES":"SIM","NO":"NÃO"},"ERRORS":{"REQUIRED":"Campo obrigatório.","DUPLICATED_NAME":"Nome duplicado, insira um nome único.","DUPLICATED_KEY":"Chave duplicada, insira uma chave única","MINLENGTH_KEY":"A Chave deve ter mais de 10 caracteres.","MINLENGTH_SECRET":"O Secret deve ter mais de 32 caracteres."}}},"CONTA_AZUL":{"TITLE":"Conta Azul","CONFIRM_DIALOG":{"TITLE":"Atenção","CONTENT":"Você está prestes a ser redirecionado para um site externo<br><br>Deseja continuar e sair da página?","NO":"NÃO","CONTINUE":"Continuar"},"DESCRIPTION":"Conecte seu sistema financeiro com seu sistema de gestão."},"PAGE_TITLE":"Integrações","SUCCESS_WHEN_DISABLING":"Integração com {{ app }} desabilitada com sucesso!","ERROR_WHEN_SAVING":"Erro ao salvar integração com {{ app }}","ERROR_WHEN_DISABLING":"Erro ao desativar integração com {{ app }}","NO_CONFIG":"Essa integração está ativa, mas não há nenhuma configuração adicional disponível.","SAVE":"Salvar","DISABLE":"Desabilitar","TOAST_SUCCESS":"Alterações salvas com sucesso.","DISABLE_DIALOG":{"TITLE":"Desativar integração","TEXT":"Tem certeza que deseja desativar esta integração?","YES":"Sim","NO":"Não"}}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/control-panel/views/map/services/mapHtmlTemplate/i18n/en.json',
    '{"MAP_HTML_TEMPLATE":{"TYPE":"OS Types","IDENTIFIER":"Identifier","LABELS":"Tags","SITUATION":"Status","ESTIMATED_START":"Estimated starting time","STARTED_IN":"Started at","ESTIMATED_COMPLETION":"Estimated completion time","FINISHED_IN":"Completed at","RATING":"Rating","EMPLOYEE":"Employee","LATITUDE_LONGITUDE":"Latitude, Longitude","EDIT":"Edit","BATTERY":"Battery","LAST_UPDATE":"Last update"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/control-panel/views/map/services/mapHtmlTemplate/i18n/es.json',
    '{"MAP_HTML_TEMPLATE":{"TYPE":"Tipo de Actividad","IDENTIFIER":"Identificador","LABELS":"Etiquetas","SITUATION":"Situación","ESTIMATED_START":"Inicio estimado","STARTED_IN":"Iniciado el","ESTIMATED_COMPLETION":"Conclusión estimada","FINISHED_IN":"Concluido el","RATING":"Calificación","EMPLOYEE":"Empleado","LATITUDE_LONGITUDE":"Latitud, Longitud","EDIT":"Editar","BATTERY":"Batería","LAST_UPDATE":"Última actualización"}}');
}]);
})();

(function(module) {
try {
  module = angular.module('app.core');
} catch (e) {
  module = angular.module('app.core', []);
}
module.run(['$translationCache', function($translationCache) {
  $translationCache.put('app/main/control-panel/views/map/services/mapHtmlTemplate/i18n/pt.json',
    '{"MAP_HTML_TEMPLATE":{"TYPE":"Tipo de OS","IDENTIFIER":"Identificador","LABELS":"Etiquetas","SITUATION":"Situação","ESTIMATED_START":"Estimativa de início","STARTED_IN":"Iniciado em","ESTIMATED_COMPLETION":"Estimativa de término","FINISHED_IN":"Concluído em","RATING":"Avaliação","EMPLOYEE":"Colaborador","LATITUDE_LONGITUDE":"Latitude, Longitude","EDIT":"Editar","BATTERY":"Bateria","LAST_UPDATE":"Última atualização"}}');
}]);
})();
